/*!
 * @splidejs/splide-extension-intersection
 * Version  : 0.1.3
 * License  : MIT
 * Copyright: 2021 Naotoshi Fujita
 */(function(b){typeof define=="function"&&define.amd?define(b):b()})(function(){"use strict";function b(e){return Array.isArray(e)}function y(e){return b(e)?e:[e]}function I(e,o){y(e).forEach(o)}var _="destroy";function T(e){var o=e.event,t={},n=[];function c(r,s,a){o.on(r,s,t,a)}function u(r){o.off(r,t)}function p(r,s,a,d){E(r,s,function(f,i){n.push([f,i,a,d]),f.addEventListener(i,a,d)})}function l(r,s,a){E(r,s,function(d,f){n=n.filter(function(i){return i[0]===d&&i[1]===f&&(!a||i[2]===a)?(d.removeEventListener(f,i[2],i[3]),!1):!0})})}function E(r,s,a){I(r,function(d){d&&s.split(" ").forEach(a.bind(null,d))})}function v(){n=n.filter(function(r){return l(r[0],r[1])}),o.offBy(t)}return o.on(_,v,t),{on:c,off:u,emit:o.emit,bind:p,unbind:l,destroy:v}}function h(e){return typeof e=="undefined"}function m(e,o,t){if(e){var n=Object.keys(e);n=t?n.reverse():n;for(var c=0;c<n.length;c++){var u=n[c];if(u!=="__proto__"&&o(e[u],u)===!1)break}}return e}var N="intersection",O="intersection:in",V="intersection:out";function A(e){var o=e.Components;return{keyboard:{enable:function(){o.Keyboard.disable(!1)},disable:function(){o.Keyboard.disable(!0)}},autoplay:{enable:function(){e.options.autoplay&&o.Autoplay.play()},disable:function(){o.Autoplay.pause()}},autoScroll:{enable:function(){var n;(n=o.AutoScroll)==null||n.play()},disable:function(){var n;(n=o.AutoScroll)==null||n.pause()}},video:{enable:function(){var n;(n=o.Video)==null||n.play()},disable:function(){var n;(n=o.Video)==null||n.pause()}}}}function C(e,o,t){var n=T(e),c=n.emit,u=t.intersection||{},p=A(e),l;function E(){window.IntersectionObserver&&(l=new IntersectionObserver(r,{root:u.root,rootMargin:u.rootMargin,threshold:u.threshold}),l.observe(e.root))}function v(){l&&(l.disconnect(),l=null)}function r(f){var i=f[0];i&&(i.isIntersecting?a(i):d(i),c(N,i))}function s(f){m(f,function(i,R){if(!h(i)){var w=p[R];i?w.enable():w.disable()}})}function a(f){s(u.inView||{}),c(O,f),u.once&&v()}function d(f){s(u.outView||{}),c(V,f)}return{mount:E,destroy:v}}typeof window!="undefined"&&(window.splide=window.splide||{},window.splide.Extensions=window.splide.Extensions||{},window.splide.Extensions.Intersection=C);/*!
 * Splide.js
 * Version  : 3.6.9
 * License  : MIT
 * Copyright: 2021 Naotoshi Fujita
 */});

function At(n,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}
/*!
 * Splide.js
 * Version  : 3.6.9
 * License  : MIT
 * Copyright: 2021 Naotoshi Fujita
 */
var n,t;n=this,t=function(){"use strict";var m="splide",a="data-"+m,n={CREATED:1,MOUNTED:2,IDLE:3,MOVING:4,DESTROYED:5},R=10;function _(n){n.length=0}function I(n){return!u(n)&&"object"==typeof n}function r(n){return Array.isArray(n)}function D(n){return"string"==typeof n}function M(n){return void 0===n}function u(n){return null===n}function y(n){return n instanceof HTMLElement}function w(n){return r(n)?n:[n]}function b(n,t){w(n).forEach(t)}function x(n,t){return-1<n.indexOf(t)}function k(n,t){return n.push.apply(n,w(t)),n}var o=Array.prototype;function s(n,t,i){return o.slice.call(n,t,i)}function E(t,n,i){t&&b(n,function(n){n&&t.classList[i?"add":"remove"](n)})}function A(n,t){E(n,D(t)?t.split(" "):t,!0)}function L(n,t){b(t,n.appendChild.bind(n))}function S(n,i){b(n,function(n){var t=i.parentNode;t&&t.insertBefore(n,i)})}function W(n,t){return y(n)&&(n.msMatchesSelector||n.matches).call(n,t)}function z(n,t){return n?s(n.children).filter(function(n){return W(n,t)}):[]}function P(n,t){return t?z(n,t)[0]:n.firstElementChild}function e(n,t,i){if(n)for(var r=Object.keys(n),r=i?r.reverse():r,u=0;u<r.length;u++){var o=r[u];if("__proto__"!==o&&!1===t(n[o],o))break}return n}function O(r){return s(arguments,1).forEach(function(i){e(i,function(n,t){r[t]=i[t]})}),r}function l(i,n){return e(n,function(n,t){r(n)?i[t]=n.slice():I(n)?i[t]=l(I(i[t])?i[t]:{},n):i[t]=n}),i}function T(t,n){t&&b(n,function(n){t.removeAttribute(n)})}function j(i,n,t){I(n)?e(n,function(n,t){j(i,t,n)}):u(t)?T(i,n):i.setAttribute(n,String(t))}function F(n,t,i){n=document.createElement(n);return t&&(D(t)?A:j)(n,t),i&&L(i,n),n}function C(n,t,i){if(M(i))return getComputedStyle(n)[t];u(i)||(n=n.style)[t]!==(i=""+i)&&(n[t]=i)}function N(n,t){C(n,"display",t)}function X(n,t){return n.getAttribute(t)}function B(n,t){return n&&n.classList.contains(t)}function G(n){return n.getBoundingClientRect()}function H(n){b(n,function(n){n&&n.parentNode&&n.parentNode.removeChild(n)})}function Y(n){return P((new DOMParser).parseFromString(n,"text/html").body)}function U(n,t){n.preventDefault(),t&&(n.stopPropagation(),n.stopImmediatePropagation())}function q(n,t){return n&&n.querySelector(t)}function J(n,t){return s(n.querySelectorAll(t))}function K(n,t){E(n,t,!1)}function V(n){return D(n)?n:n?n+"px":""}function Q(n,t){if(void 0===t&&(t=""),!n)throw new Error("["+m+"] "+t)}function g(n){setTimeout(n)}function Z(){}function v(n){return requestAnimationFrame(n)}var $=Math.min,nn=Math.max,tn=Math.floor,rn=Math.ceil,un=Math.abs;function on(n,t,i,r){var u=$(t,i),i=nn(t,i);return r?u<n&&n<i:u<=n&&n<=i}function en(n,t,i){var r=$(t,i),i=nn(t,i);return $(nn(r,n),i)}function cn(n){return(0<n)-(n<0)}function fn(t,n){return b(n,function(n){t=t.replace("%s",""+n)}),t}function an(n){return n<10?"0"+n:""+n}var sn={};function c(){var o={};function r(n,r){t(n,function(n,t){var i=o[n];o[n]=i&&i.filter(function(n){return n.n?n.n!==r:r||n.t!==t})})}function t(n,t){w(n).join(" ").split(" ").forEach(function(n){n=n.split(".");t(n[0],n[1])})}return{on:function(n,i,r,u){void 0===u&&(u=R),t(n,function(n,t){o[n]=o[n]||[],k(o[n],{i:n,r:i,t:t,u:u,n:r}).sort(function(n,t){return n.u-t.u})})},off:r,offBy:function(i){e(o,function(n,t){r(t,i)})},emit:function(n){var t=arguments;(o[n]||[]).forEach(function(n){n.r.apply(n,s(t,1))})},destroy:function(){o={}}}}var ln="mounted",dn="move",vn="moved",hn="shifted",pn="click",gn="active",mn="inactive",yn="visible",wn="hidden",_n="slide:keydown",bn="refresh",xn="updated",kn="resize",An="resized",Ln="repositioned",En="scrolled",f="destroy",Sn="navigation:mounted",zn="lazyload:loaded";function Pn(n){var r=n.event,u={},o=[];function t(n,t,r){e(n,t,function(t,i){o=o.filter(function(n){return!!(n[0]!==t||n[1]!==i||r&&n[2]!==r)||(t.removeEventListener(i,n[2],n[3]),!1)})})}function e(n,t,i){b(n,function(n){n&&t.split(" ").forEach(i.bind(null,n))})}function i(){o=o.filter(function(n){return t(n[0],n[1])}),r.offBy(u)}return r.on(f,i,u),{on:function(n,t,i){r.on(n,t,u,i)},off:function(n){r.off(n,u)},emit:r.emit,bind:function(n,t,i,r){e(n,t,function(n,t){o.push([n,t,i,r]),n.addEventListener(t,i,r)})},unbind:t,destroy:i}}function Rn(t,i,r,u){var o,n,e=Date.now,c=0,f=!0,a=0;function s(){if(!f){var n=e()-o;if(t<=n?(c=1,o=e()):c=n/t,r&&r(c),1===c&&(i(),u&&++a>=u))return l();v(s)}}function l(){f=!0}function d(){cancelAnimationFrame(n),f=!(n=c=0)}return{start:function(n){n||d(),o=e()-(n?c*t:0),f=!1,v(s)},rewind:function(){o=e(),c=0,r&&r(c)},pause:l,cancel:d,set:function(n){t=n},isPaused:function(){return f}}}function d(n){var t=n;return{set:function(n){t=n},is:function(n){return x(w(n),t)}}}function Dn(i,r){var u;return function(){var n=arguments,t=this;u||(u=Rn(r||0,function(){i.apply(t,n),u=null},null,1)).start()}}var h={marginRight:["marginBottom","marginLeft"],autoWidth:["autoHeight"],fixedWidth:["fixedHeight"],paddingLeft:["paddingTop","paddingRight"],paddingRight:["paddingBottom","paddingLeft"],width:["height"],left:["top","right"],right:["bottom","left"],x:["y"],X:["Y"],Y:["X"],ArrowLeft:["ArrowUp","ArrowRight"],ArrowRight:["ArrowDown","ArrowLeft"]};var Mn=m,On=m+"__slider",Tn=m+"__track",jn=m+"__list",Fn=m+"__slide",In=Fn+"--clone",Wn=Fn+"__container",Cn=m+"__arrows",t=m+"__arrow",Nn=t+"--prev",Xn=t+"--next",i=m+"__pagination",Bn=m+"__progress",Gn=Bn+"__bar",Hn=m+"__autoplay",Yn=m+"__play",Un=m+"__pause",qn="is-active",Jn="is-prev",Kn="is-next",Vn="is-visible",Qn="is-loading",Zn=[qn,Vn,Jn,Kn,Qn];var $n="role",nt="aria-controls",tt="aria-current",it="aria-label",rt="aria-hidden",ut="tabindex",p="aria-orientation",ot=[$n,nt,tt,it,rt,p,ut,"disabled"],et="slide",ct="loop",ft="fade";function at(u,i,r,o){var t,n=Pn(u),e=n.on,c=n.emit,f=n.bind,a=n.destroy,s=u.Components,l=u.root,d=u.options,v=d.isNavigation,h=d.updateOnMove,p=s.Direction.resolve,g=X(o,"style"),m=-1<r,y=P(o,"."+Wn),w=d.focusableNodes&&J(o,d.focusableNodes);function _(){var n=m?r:i,t=fn(d.i18n.slideX,n+1),n=u.splides.map(function(n){return n.splide.root.id}).join(" ");j(o,it,t),j(o,nt,n),j(o,$n,"menuitem"),k(A())}function b(){t||x()}function x(){var n;t||(n=u.index,k(A()),function(n){var t=!n&&(!A()||m);j(o,rt,t||null),j(o,ut,!t&&d.slideFocus?0:null),w&&w.forEach(function(n){j(n,ut,t?-1:null)});n!==B(o,Vn)&&(E(o,Vn,n),c(n?yn:wn,L))}(function(){if(u.is(ft))return A();var n=G(s.Elements.track),t=G(o),i=p("left"),r=p("right");return tn(n[i])<=rn(t[i])&&tn(t[r])<=rn(n[r])}()),E(o,Jn,i===n-1),E(o,Kn,i===n+1))}function k(n){n!==B(o,qn)&&(E(o,qn,n),v&&j(o,tt,n||null),c(n?gn:mn,L))}function A(){var n=u.index;return n===i||d.cloneStatus&&n===r}var L={index:i,slideIndex:r,slide:o,container:y,isClone:m,mount:function(){m||(o.id=l.id+"-slide"+an(i+1)),f(o,"click keydown",function(n){c("click"===n.type?pn:_n,L,n)}),e([bn,Ln,hn,vn,En],x),e(Sn,_),h&&e(dn,b)},destroy:function(){t=!0,a(),K(o,Zn),T(o,ot),j(o,"style",g)},update:x,style:function(n,t,i){C(i&&y||o,n,t)},isWithin:function(n,t){return n=un(n-i),(n=!m&&(d.rewind||u.is(ct))?$(n,u.length-n):n)<=t}};return L}var st=a+"-interval";var lt={passive:!1,capture:!0},dt="touchmove mousemove",vt="touchend touchcancel mouseup";var ht=["Left","Right","Up","Down"],pt="keydown";var gt=a+"-lazy",mt=gt+"-srcset",yt="["+gt+"], ["+mt+"]";var wt=[" ","Enter","Spacebar"];var _t=Object.freeze({__proto__:null,Options:function(t,n,r){var u,o,i,e=Dn(f);function c(n){n&&removeEventListener("resize",e)}function f(){var n,n=(n=function(n){return n[1].matches},s(o).filter(n)[0]||[]);n[0]!==i&&function(n){n=r.breakpoints[n]||u;n.destroy?(t.options=u,t.destroy("completely"===n.destroy)):(t.state.is(5)&&(c(!0),t.mount()),t.options=n)}(i=n[0])}return{setup:function(){try{l(r,JSON.parse(X(t.root,a)))}catch(n){Q(!1,n.message)}u=l({},r);var i,n=r.breakpoints;n&&(i="min"===r.mediaQuery,o=Object.keys(n).sort(function(n,t){return i?+t-+n:+n-+t}).map(function(n){return[n,matchMedia("("+(i?"min":"max")+"-width:"+n+"px)")]}),f())},mount:function(){o&&addEventListener("resize",e)},destroy:c}},Direction:function(n,t,r){return{resolve:function(n,t){var i=r.direction;return h[n]["rtl"!==i||t?"ttb"===i?0:-1:1]||n},orient:function(n){return n*("rtl"===r.direction?1:-1)}}},Elements:function(n,t,i){var r,u,o,e,c=Pn(n).on,f=n.root,a={},s=[];function l(){var n;!function(){u=P(f,"."+On),o=q(f,"."+Tn),e=P(o,"."+jn),Q(o&&e,"A track/list element is missing."),k(s,z(e,"."+Fn+":not(."+In+")"));var n=p("."+Hn),t=p("."+Cn);O(a,{root:f,slider:u,track:o,list:e,slides:s,arrows:t,autoplay:n,prev:q(t,"."+Nn),next:q(t,"."+Xn),bar:q(p("."+Bn),"."+Gn),play:q(n,"."+Yn),pause:q(n,"."+Un)})}(),n=f.id||function(n){return""+n+an(sn[n]=(sn[n]||0)+1)}(m),f.id=n,o.id=o.id||n+"-track",e.id=e.id||n+"-list",A(f,r=g())}function d(){[f,o,e].forEach(function(n){T(n,"style")}),_(s),K(f,r)}function v(){d(),l()}function h(){K(f,r),A(f,r=g())}function p(n){return P(f,n)||P(u,n)}function g(){return[Mn+"--"+i.type,Mn+"--"+i.direction,i.drag&&Mn+"--draggable",i.isNavigation&&Mn+"--nav",qn]}return O(a,{setup:l,mount:function(){c(bn,v,R-2),c(xn,h)},destroy:d})},Slides:function(r,u,o){var n=Pn(r),t=n.on,e=n.emit,c=n.bind,f=(n=u.Elements).slides,a=n.list,s=[];function i(){f.forEach(function(n,t){v(n,t,-1)})}function l(){p(function(n){n.destroy()}),_(s)}function d(){l(),i()}function v(n,t,i){n=at(r,t,i,n);n.mount(),s.push(n)}function h(n){return n?g(function(n){return!n.isClone}):s}function p(n,t){h(t).forEach(n)}function g(t){return s.filter("function"==typeof t?t:function(n){return D(t)?W(n.slide,t):x(w(t),n.index)})}return{mount:function(){i(),t(bn,d),t([ln,bn],function(){s.sort(function(n,t){return n.index-t.index})})},destroy:l,update:function(){p(function(n){n.update()})},register:v,get:h,getIn:function(n){var t=u.Controller,i=t.toIndex(n),r=t.hasFocus()?1:o.perPage;return g(function(n){return on(n.index,i,i+r-1)})},getAt:function(n){return g(n)[0]},add:function(n,u){b(n,function(n){var t,i,r;y(n=D(n)?Y(n):n)&&((t=f[u])?S(n,t):L(a,n),A(n,o.classes.slide),n=n,i=e.bind(null,kn),n=J(n,"img"),(r=n.length)?n.forEach(function(n){c(n,"load error",function(){--r||i()})}):i())}),e(bn)},remove:function(n){H(g(n).map(function(n){return n.slide})),e(bn)},forEach:p,filter:g,style:function(t,i,r){p(function(n){n.style(t,i,r)})},getLength:function(n){return(n?f:s).length},isEnough:function(){return s.length>o.perPage}}},Layout:function(n,t,i){var r,u,o=Pn(n),e=o.on,c=o.bind,f=o.emit,a=t.Slides,s=t.Direction.resolve,l=(t=t.Elements).root,d=t.track,v=t.list,h=a.getAt;function p(){u=null,r="ttb"===i.direction,C(l,"maxWidth",V(i.width)),C(d,s("paddingLeft"),m(!1)),C(d,s("paddingRight"),m(!0)),g()}function g(){var n=G(l);u&&u.width===n.width&&u.height===n.height||(C(d,"height",function(){var n="";r&&(Q(n=y(),"height or heightRatio is missing."),n="calc("+n+" - "+m(!1)+" - "+m(!0)+")");return n}()),a.style(s("marginRight"),V(i.gap)),a.style("width",(i.autoWidth?"":V(i.fixedWidth)||(r?"":w()))||null),a.style("height",V(i.fixedHeight)||(r?i.autoHeight?"":w():y())||null,!0),u=n,f(An))}function m(n){var t=i.padding,n=s(n?"right":"left");return t&&V(t[n]||(I(t)?0:t))||"0px"}function y(){return V(i.height||G(v).width*i.heightRatio)}function w(){var n=V(i.gap);return"calc((100%"+(n&&" + "+n)+")/"+(i.perPage||1)+(n&&" - "+n)+")"}function _(n,t){var i=h(n);if(i){n=G(i.slide)[s("right")],i=G(v)[s("left")];return un(n-i)+(t?0:b())}return 0}function b(){var n=h(0);return n&&parseFloat(C(n.slide,s("marginRight")))||0}return{mount:function(){p(),c(window,"resize load",Dn(f.bind(this,kn))),e([xn,bn],p),e(kn,g)},listSize:function(){return G(v)[s("width")]},slideSize:function(n,t){return(n=h(n||0))?G(n.slide)[s("width")]+(t?0:b()):0},sliderSize:function(){return _(n.length-1,!0)-_(-1,!0)},totalSize:_,getPadding:function(n){return parseFloat(C(d,s("padding"+(n?"Right":"Left"))))||0}}},Clones:function(c,n,f){var t,i=Pn(c),r=i.on,u=i.emit,a=n.Elements,s=n.Slides,o=n.Direction.resolve,l=[];function e(){(t=p())&&(function(u){var o=s.get().slice(),e=o.length;if(e){for(;o.length<u;)k(o,o);k(o.slice(-u),o.slice(0,u)).forEach(function(n,t){var i=t<u,r=function(n,t){n=n.cloneNode(!0);return A(n,f.classes.clone),n.id=c.root.id+"-clone"+an(t+1),n}(n.slide,t);i?S(r,o[0].slide):L(a.list,r),k(l,r),s.register(r,t-u+(i?0:e),n.index)})}}(t),u(kn))}function d(){H(l),_(l)}function v(){d(),e()}function h(){t<p()&&u(bn)}function p(){var n,t,i=f.clones;return c.is(ct)?i||(n=a.list,D(t=f[o("fixedWidth")])&&(t=G(n=F("div",{style:"width: "+t+"; position: absolute;"},n)).width,H(n)),i=((t=t)&&rn(G(a.track)[o("width")]/t)||f[o("autoWidth")]&&c.length||f.perPage)*(f.drag?(f.flickMaxPages||1)+1:2)):i=0,i}return{mount:function(){e(),r(bn,v),r([xn,kn],h)},destroy:d}},Move:function(e,c,f){var a,n=Pn(e),t=n.on,s=n.emit,r=(n=c.Layout).slideSize,i=n.getPadding,u=n.totalSize,o=n.listSize,l=n.sliderSize,d=(n=c.Direction).resolve,v=n.orient,h=(n=c.Elements).list,p=n.track;function g(){k()||(c.Scroll.cancel(),m(e.index),s(Ln))}function m(n){y(_(n,!0))}function y(n,t){e.is(ft)||(t=t?n:function(n){{var t,i;e.is(ct)&&(i=v(n-b()),t=A(!1,n)&&i<0,i=A(!0,n)&&0<i,(t||i)&&(n=w(n,i)))}return n}(n),h.style.transform="translate"+d("X")+"("+t+"px)",n!==t&&s(hn))}function w(n,t){var i=n-x(t),r=l();return n-=v(r*(rn(un(i)/r)||1))*(t?1:-1)}function _(n,t){var i,i=v(u(n-1)-(i=n,"center"===(n=f.focus)?(o()-r(i,!0))/2:+n*r(i)||0));return t?function(n){f.trimSpace&&e.is(et)&&(n=en(n,0,v(l()-o())));return n}(i):i}function b(){var n=d("left");return G(h)[n]-G(p)[n]+v(i(!1))}function x(n){return _(n?c.Controller.getEnd():0,!!f.trimSpace)}function k(){return e.state.is(4)&&f.waitForTransition}function A(n,t){t=M(t)?b():t;var i=!0!==n&&v(t)<v(x(!1)),t=!1!==n&&v(t)>v(x(!0));return i||t}return{mount:function(){a=c.Transition,t([ln,An,xn,bn],g)},destroy:function(){T(h,"style")},move:function(n,t,i,r){var u,o;k()||(u=e.state.set,o=b(),n!==t&&(a.cancel(),y(w(o,t<n),!0)),u(4),s(dn,t,i,n),a.start(t,function(){u(3),s(vn,t,i,n),"move"===f.trimSpace&&n!==i&&o===b()?c.Controller.go(i<n?">":"<",!1,r):r&&r()}))},jump:m,translate:y,shift:w,cancel:function(){y(b()),a.cancel()},toIndex:function(n){for(var t=c.Slides.get(),i=0,r=1/0,u=0;u<t.length;u++){var o=t[u].index,e=un(_(o,!0)-n);if(!(e<=r))break;r=e,i=o}return i},toPosition:_,getPosition:b,getLimit:x,isBusy:k,exceededLimit:A}},Controller:function(n,e,u){var o,c,f,t=Pn(n).on,a=e.Move,s=a.getPosition,l=a.getLimit,i=e.Slides,d=i.isEnough,r=i.getLength,v=n.is(ct),h=n.is(et),p=u.start||0,g=p;function m(){o=r(!0),c=u.perMove,f=u.perPage,p=en(p,0,o-1)}function y(n,t,i,r,u){var o=t?n:S(n);e.Scroll.scroll(t||i?a.toPosition(o,!0):n,r,function(){z(a.toIndex(a.getPosition())),u&&u()})}function w(n){return b(!1,n)}function _(n){return b(!0,n)}function b(n,t){var i,r,u=c||(P()?1:f),o=x(p+u*(n?-1:1),p);return-1!==o||!h||(i=s(),r=l(!n),u=1,un(i-r)<u)?t?o:A(o):n?0:k()}function x(n,t,i){var r;return d()?(r=k(),n<0||r<n?n=on(0,n,t,!0)||on(r,t,n,!0)?L(E(n)):v?c||P()?n:n<0?-(o%f||f):o:u.rewind?n<0?r:0:-1:i||n===t||(n=c?n:L(E(t)+(n<t?-1:1)))):n=-1,n}function k(){var n=o-f;return(P()||v&&c)&&(n=o-1),nn(n,0)}function A(n){return v?d()?n%o+(n<0?o:0):-1:n}function L(n){return en(P()?n:f*n,0,k())}function E(n){return P()||(n=on(n,o-f,o-1)?o-1:n,n=tn(n/f)),n}function S(n){n=a.toIndex(n);return h?en(n,0,k()):n}function z(n){n!==p&&(g=p,p=n)}function P(){return!M(u.focus)||u.isNavigation}return{mount:function(){m(),t([xn,bn],m,R-1)},go:function(n,t,i){var r=function(n){var t=p;{var i,r;D(n)?(r=n.match(/([+\-<>])(\d+)?/)||[],i=r[1],r=r[2],"+"===i||"-"===i?t=x(p+ +(""+i+(+r||1)),p,!0):">"===i?t=r?L(+r):w(!0):"<"===i&&(t=_(!0))):t=v?n:en(n,0,k())}return t}(n);u.useScroll?y(r,!0,!0,u.speed,i):-1<(n=A(r))&&!a.isBusy()&&(t||n!==p)&&(z(n),a.move(r,n,g,i))},scroll:y,getNext:w,getPrev:_,getAdjacent:b,getEnd:k,setIndex:z,getIndex:function(n){return n?g:p},toIndex:L,toPage:E,toDest:S,hasFocus:P}},Arrows:function(u,n,i){var r,t=Pn(u),o=t.on,e=t.bind,c=t.emit,f=i.classes,a=i.i18n,s=n.Elements,l=n.Controller,d=s.arrows,v=s.prev,h=s.next,p={};function g(){var n,t;i.arrows&&(v&&h||(d=F("div",f.arrows),v=m(!0),h=m(!1),r=!0,L(d,[v,h]),S(d,P("slider"===i.arrows&&s.slider||u.root)))),v&&h&&(p.prev?N(d,!1===i.arrows?"none":""):(n=s.track.id,j(v,nt,n),j(h,nt,n),p.prev=v,p.next=h,t=l.go,o([ln,vn,xn,bn,En],y),e(h,"click",function(){t(">",!0)}),e(v,"click",function(){t("<",!0)}),c("arrows:mounted",v,h)))}function m(n){return Y('<button class="'+f.arrow+" "+(n?f.prev:f.next)+'" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="'+(i.arrowPath||"m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z")+'" />')}function y(){var n=u.index,t=l.getPrev(),i=l.getNext(),r=-1<t&&n<t?a.last:a.prev,n=-1<i&&i<n?a.first:a.next;v.disabled=t<0,h.disabled=i<0,j(v,it,r),j(h,it,n),c("arrows:updated",v,h,t,i)}return{arrows:p,mount:function(){g(),o(xn,g)},destroy:function(){r?H(d):(T(v,ot),T(h,ot))}}},Autoplay:function(t,i,r){var u,o,e,n=Pn(t),c=n.on,f=n.bind,a=n.emit,s=Rn(r.interval,t.go.bind(t,">"),function(n){var t=d.bar;t&&C(t,"width",100*n+"%"),a("autoplay:playing",n)}),l=s.isPaused,d=i.Elements;function v(n){var t=n?"pause":"play",i=d[t];i&&(j(i,nt,d.track.id),j(i,it,r.i18n[t]),f(i,"click",n?p:h))}function h(){l()&&i.Slides.isEnough()&&(s.start(!r.resetProgress),o=u=e=!1,a("autoplay:play"))}function p(n){void 0===n&&(n=!0),l()||(s.pause(),a("autoplay:pause")),e=n}function g(){e||(u||o?p(!1):h())}function m(){var n=i.Slides.getAt(t.index);s.set(n&&+X(n.slide,st)||r.interval)}return{mount:function(){var n=r.autoplay;n&&(v(!0),v(!1),function(){var n=d.root;r.pauseOnHover&&f(n,"mouseenter mouseleave",function(n){u="mouseenter"===n.type,g()});r.pauseOnFocus&&f(n,"focusin focusout",function(n){o="focusin"===n.type,g()});c([dn,"scroll",bn],s.rewind),c(dn,m)}(),"pause"!==n&&h())},destroy:s.cancel,play:h,pause:p,isPaused:l}},Cover:function(n,t,i){var r=Pn(n).on;function u(i){t.Slides.forEach(function(n){var t=P(n.container||n.slide,"img");t&&t.src&&o(i,t,n)})}function o(n,t,i){i.style("background",n?'center/cover no-repeat url("'+t.src+'")':"",!0),N(t,n?"none":"")}return{mount:function(){i.cover&&(r(zn,function(n,t){o(!0,n,t)}),r([ln,xn,bn],u.bind(null,!0)))},destroy:function(){u(!1)}}},Scroll:function(c,n,f){var a,s,t=Pn(c),i=t.on,l=t.emit,d=n.Move,v=d.getPosition,h=d.getLimit,p=d.exceededLimit;function g(r,n,t,u){var i,o=v(),e=1;n=n||(i=un(r-o),nn(i/1.5,800)),s=t,y(),a=Rn(n,m,function(n){var t=v(),i=(o+(r-o)*(i=n,(n=f.easingFunc)?n(i):1-Math.pow(1-i,4))-v())*e;d.translate(t+i),c.is(et)&&!u&&p()&&(e*=.6,un(i)<10&&(i=p(!1),g(h(!i),600,null,!0)))},1),l("scroll"),a.start()}function m(){var n=v(),t=d.toIndex(n);on(t,0,c.length-1)||d.translate(d.shift(n,0<t),!0),s&&s(),l(En)}function y(){a&&a.cancel()}function r(){a&&!a.isPaused()&&(y(),m())}return{mount:function(){i(dn,y),i([xn,bn],r)},destroy:y,scroll:g,cancel:r}},Drag:function(u,o,e){var c,f,a,s,l,d,v,r,h,n=Pn(u),t=n.on,p=n.emit,g=n.bind,m=n.unbind,y=o.Move,w=o.Scroll,_=o.Controller,b=o.Elements.track,i=(n=o.Direction).resolve,x=n.orient,k=y.getPosition,A=y.exceededLimit,L=!1;function E(){var n=e.drag;F(!n),l="free"===n}function S(n){var t,i;r||(i=e.noDrag,t=j(n),i=!i||!W(n.target,i),v=!1,!i||!t&&n.button||(y.isBusy()?U(n,!0):(h=t?b:window,s=a=null,g(h,dt,z,lt),g(h,vt,P,lt),y.cancel(),w.cancel(),R(n))))}function z(n){var t,i,r;s||p("drag"),(s=n).cancelable&&(t=O(n)-O(f),d?(y.translate(c+t/(L&&u.is(et)?5:1)),i=200<T(n)-T(f),r=L!==(L=A()),(i||r)&&R(n),p("dragging"),v=!0,U(n)):(r=I(r=e.dragMinThreshold)?r:{mouse:0,touch:+r||10},d=un(t)>(j(n)?r.touch:r.mouse),M()&&U(n)))}function P(n){m(h,dt,z),m(h,vt,P);var t,i,r=u.index;s?((d||n.cancelable&&M())&&(t=function(n){if(u.is(ct)||!L){var t=f===s&&a||f,i=O(s)-O(t),t=T(n)-T(t),n=T(n)-T(s)<200;if(t&&n)return i/t}return 0}(n),i=t,i=k()+cn(i)*$(un(i)*(e.flickPower||600),l?1/0:o.Layout.listSize()*(e.flickMaxPages||1)),l?_.scroll(i):u.is(ft)?_.go(r+x(cn(t))):_.go(_.toDest(i),!0),U(n)),p("dragged")):l||k()===y.toPosition(r)||_.go(r,!0),d=!1}function R(n){a=f,f=n,c=k()}function D(n){!r&&v&&U(n,!0)}function M(){var n=un(O(s)-O(f));return un(O(s,!0)-O(f,!0))<n}function O(n,t){return(j(n)?n.touches[0]:n)["page"+i(t?"Y":"X")]}function T(n){return n.timeStamp}function j(n){return"undefined"!=typeof TouchEvent&&n instanceof TouchEvent}function F(n){r=n}return{mount:function(){g(b,dt,Z,lt),g(b,vt,Z,lt),g(b,"touchstart mousedown",S,lt),g(b,"click",D,{capture:!0}),g(b,"dragstart",U),t([ln,xn],E)},disable:F,isDragging:function(){return d}}},Keyboard:function(t,n,i){var r,u,o=Pn(t),e=o.on,c=o.bind,f=o.unbind,a=t.root,s=n.Direction.resolve;function l(){var n=i.keyboard;n&&("focused"===n?j(r=a,ut,0):r=window,c(r,pt,p))}function d(){f(r,pt),y(r)&&T(r,ut)}function v(){var n=u;u=!0,g(function(){u=n})}function h(){d(),l()}function p(n){u||(n=n.key,(n=x(ht,n)?"Arrow"+n:n)===s("ArrowLeft")?t.go("<"):n===s("ArrowRight")&&t.go(">"))}return{mount:function(){l(),e(xn,h),e(dn,v)},destroy:d,disable:function(n){u=n}}},LazyLoad:function(i,n,e){var t=Pn(i),r=t.on,u=t.off,o=t.bind,c=t.emit,f="sequential"===e.lazyLoad,a=[],s=0;function l(){v(),d()}function d(){n.Slides.forEach(function(o){J(o.slide,yt).forEach(function(n){var t,i,r=X(n,gt),u=X(n,mt);r===n.src&&u===n.srcset||(t=e.classes.spinner,j(i=P(i=n.parentElement,"."+t)||F("span",t,i),$n,"presentation"),a.push({o:n,e:o,src:r,srcset:u,c:i}),n.src||N(n,"none"))})}),f&&g()}function v(){s=0,a=[]}function h(){(a=a.filter(function(n){var t=e.perPage*((e.preloadPages||1)+1)-1;return!n.e.isWithin(i.index,t)||p(n)})).length||u(vn)}function p(t){var i=t.o;A(t.e.slide,Qn),o(i,"load error",function(n){!function(n,t){var i=n.e;K(i.slide,Qn),t||(H(n.c),N(n.o,""),c(zn,n.o,i),c(kn));f&&g()}(t,"error"===n.type)}),["src","srcset"].forEach(function(n){t[n]&&(j(i,n,t[n]),T(i,"src"===n?gt:mt))})}function g(){s<a.length&&p(a[s++])}return{mount:function(){e.lazyLoad&&(d(),r(bn,l),f||r([ln,bn,vn,En],h))},destroy:v}},Pagination:function(l,n,d){var v,t=Pn(l),i=t.on,r=t.emit,h=t.bind,u=t.unbind,p=n.Slides,g=n.Elements,o=n.Controller,m=o.hasFocus,e=o.getIndex,y=[];function c(){f(),d.pagination&&p.isEnough()&&(function(){var n=l.length,t=d.classes,i=d.i18n,r=d.perPage,u="slider"===d.pagination&&g.slider||g.root,o=m()?n:rn(n/r);v=F("ul",t.pagination,u);for(var e=0;e<o;e++){var c=F("li",null,v),f=F("button",{class:t.page,type:"button"},c),a=p.getIn(e).map(function(n){return n.slide.id}),s=!m()&&1<r?i.pageX:i.slideX;h(f,"click",w.bind(null,e)),j(f,nt,a.join(" ")),j(f,it,fn(s,e+1)),y.push({li:c,button:f,page:e})}}(),r("pagination:mounted",{list:v,items:y},a(l.index)),s())}function f(){v&&(H(v),y.forEach(function(n){u(n.button,"click")}),_(y),v=null)}function w(t){o.go(">"+t,!0,function(){var n=p.getAt(o.toIndex(t));n&&((n=n.slide).setActive&&n.setActive()||n.focus({preventScroll:!0}))})}function a(n){return y[o.toPage(n)]}function s(){var n=a(e(!0)),t=a(e());n&&(K(n.button,qn),T(n.button,tt)),t&&(A(t.button,qn),j(t.button,tt,!0)),r("pagination:updated",{list:v,items:y},n,t)}return{items:y,mount:function(){c(),i([xn,bn],c),i([dn,En],s)},destroy:f,getAt:a,update:s}},Sync:function(u,n,i){var r=n.Elements.list,o=[];function t(){var n,t;u.splides.forEach(function(n){var i;n.isParent||(i=n.splide,[u,i].forEach(function(n){var t=Pn(n),r=n===u?i:u;t.on(dn,function(n,t,i){r.go(r.is(ct)?i:n)}),o.push(t)}))}),i.isNavigation&&(n=Pn(u),(t=n.on)(pn,f),t(_n,a),t([ln,xn],c),j(r,$n,"menu"),o.push(n),n.emit(Sn,u.splides))}function e(){T(r,ot),o.forEach(function(n){n.destroy()}),_(o)}function c(){j(r,p,"ttb"!==i.direction?"horizontal":null)}function f(n){u.go(n.index)}function a(n,t){x(wt,t.key)&&(f(n),U(t))}return{mount:t,destroy:e,remount:function(){e(),t()}}},Wheel:function(i,r,u){var n=Pn(i).bind;function t(n){var t;!n.cancelable||(t=n.deltaY)&&(i.go((t=t<0)?"<":">"),t=t,u.releaseWheel&&!i.state.is(4)&&-1===r.Controller.getAdjacent(t)||U(n))}return{mount:function(){u.wheel&&n(r.Elements.track,"wheel",t,lt)}}}}),bt={type:"slide",speed:400,waitForTransition:!0,perPage:1,cloneStatus:!0,arrows:!0,pagination:!0,interval:5e3,pauseOnHover:!0,pauseOnFocus:!0,resetProgress:!0,keyboard:!0,easing:"cubic-bezier(0.25, 1, 0.5, 1)",drag:!0,direction:"ltr",slideFocus:!0,trimSpace:!0,focusableNodes:"a, button, textarea, input, select, iframe",classes:{slide:Fn,clone:In,arrows:Cn,arrow:t,prev:Nn,next:Xn,pagination:i,page:i+"__page",spinner:m+"__spinner"},i18n:{prev:"Previous slide",next:"Next slide",first:"Go to first slide",last:"Go to last slide",slideX:"Go to slide %s",pageX:"Go to page %s",play:"Start autoplay",pause:"Pause autoplay"}};function xt(n,r,t){var i=Pn(n).on;return{mount:function(){i([ln,bn],function(){g(function(){r.Slides.style("transition","opacity "+t.speed+"ms "+t.easing)})})},start:function(n,t){var i=r.Elements.track;C(i,"height",V(G(i).height)),g(function(){t(),C(i,"height","")})},cancel:Z}}function kt(o,n,e){var c,t=Pn(o).bind,f=n.Move,a=n.Controller,i=n.Elements.list;function r(){s("")}function s(n){C(i,"transition",n)}return{mount:function(){t(i,"transitionend",function(n){n.target===i&&c&&(r(),c())})},start:function(n,t){var i=f.toPosition(n,!0),r=f.getPosition(),u=function(n){var t=e.rewindSpeed;if(o.is(et)&&t){var i=a.getIndex(!0),r=a.getEnd();if(0===i&&r<=n||r<=i&&0===n)return t}return e.speed}(n);1<=un(i-r)&&1<=u?(s("transform "+u+"ms "+e.easing),f.translate(i,!0),c=t):(f.jump(n),t())},cancel:r}}i=function(){function i(n,t){this.event=c(),this.Components={},this.state=d(1),this.splides=[],this.f={},this.a={};n=D(n)?q(document,n):n;Q(n,n+" is invalid."),this.root=n,l(bt,i.defaults),l(l(this.f,bt),t||{})}var n,t,r=i.prototype;return r.mount=function(n,t){var i=this,r=this.state,u=this.Components;return Q(r.is([1,5]),"Already mounted!"),r.set(1),this.s=u,this.l=t||this.l||(this.is(ft)?xt:kt),this.a=n||this.a,e(O({},_t,this.a,{Transition:this.l}),function(n,t){n=n(i,u,i.f);(u[t]=n).setup&&n.setup()}),e(u,function(n){n.mount&&n.mount()}),this.emit(ln),A(this.root,"is-initialized"),r.set(3),this.emit("ready"),this},r.sync=function(n){return this.splides.push({splide:n}),n.splides.push({splide:this,isParent:!0}),this.state.is(3)&&(this.s.Sync.remount(),n.Components.Sync.remount()),this},r.go=function(n){return this.s.Controller.go(n),this},r.on=function(n,t){return this.event.on(n,t,null,20),this},r.off=function(n){return this.event.off(n),this},r.emit=function(n){var t;return(t=this.event).emit.apply(t,[n].concat(s(arguments,1))),this},r.add=function(n,t){return this.s.Slides.add(n,t),this},r.remove=function(n){return this.s.Slides.remove(n),this},r.is=function(n){return this.f.type===n},r.refresh=function(){return this.emit(bn),this},r.destroy=function(t){void 0===t&&(t=!0);var n=this.event,i=this.state;return i.is(1)?n.on("ready",this.destroy.bind(this,t),this):(e(this.s,function(n){n.destroy&&n.destroy(t)},!0),n.emit(f),n.destroy(),t&&_(this.splides),i.set(5)),this},n=i,(r=[{key:"options",get:function(){return this.f},set:function(n){var t=this.f;l(t,n),this.state.is(1)||this.emit(xn,t)}},{key:"length",get:function(){return this.s.Slides.getLength(!0)}},{key:"index",get:function(){return this.s.Controller.getIndex()}}])&&At(n.prototype,r),t&&At(n,t),i}();return i.defaults={},i.STATES=n,i},"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).Splide=t();

/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.19.7 - 2017-04-15T14:28:36.649Z
 * License: MIT
 */


(function () { 
    "use strict";
    var KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        COMMAND: 91,
    
        MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
        },
    
        isControl: function (e) {
            var k = e.which;
            switch (k) {
            case KEY.COMMAND:
            case KEY.SHIFT:
            case KEY.CTRL:
            case KEY.ALT:
                return true;
            }
    
            if (e.metaKey || e.ctrlKey || e.altKey) return true;
    
            return false;
        },
        isFunctionKey: function (k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        },
        isVerticalMovement: function (k){
          return ~[KEY.UP, KEY.DOWN].indexOf(k);
        },
        isHorizontalMovement: function (k){
          return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
        },
        toSeparator: function (k) {
          var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
          if (sep) return sep;
          // return undefined for special keys other than enter, tab or space.
          // no way to use them to cut strings.
          return KEY[k] ? undefined : k;
        }
      };
    
    function isNil(value) {
      return angular.isUndefined(value) || value === null;
    }
    
    /**
     * Add querySelectorAll() to jqLite.
     *
     * jqLite find() is limited to lookups by tag name.
     * TODO This will change with future versions of AngularJS, to be removed when this happens
     *
     * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
     * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
     */
    if (angular.element.prototype.querySelectorAll === undefined) {
      angular.element.prototype.querySelectorAll = function(selector) {
        return angular.element(this[0].querySelectorAll(selector));
      };
    }
    
    /**
     * Add closest() to jqLite.
     */
    if (angular.element.prototype.closest === undefined) {
      angular.element.prototype.closest = function( selector) {
        var elem = this[0];
        var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
    
        while (elem) {
          if (matchesSelector.bind(elem)(selector)) {
            return elem;
          } else {
            elem = elem.parentElement;
          }
        }
        return false;
      };
    }
    
    var latestId = 0;
    
    var uis = angular.module('ui.select', [])
    
    .constant('uiSelectConfig', {
      theme: 'bootstrap',
      searchEnabled: true,
      sortable: false,
      placeholder: '', // Empty by default, like HTML tag <select>
      refreshDelay: 1000, // In milliseconds
      closeOnSelect: true,
      skipFocusser: false,
      dropdownPosition: 'auto',
      removeSelected: true,
      resetSearchInput: true,
      generateId: function() {
        return latestId++;
      },
      appendToBody: false,
      spinnerEnabled: false,
      spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
      backspaceReset: true
    })
    
    // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
    .service('uiSelectMinErr', function() {
      var minErr = angular.$$minErr('ui.select');
      return function() {
        var error = minErr.apply(this, arguments);
        var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
        return new Error(message);
      };
    })
    
    // Recreates old behavior of ng-transclude. Used internally.
    .directive('uisTranscludeAppend', function () {
      return {
        link: function (scope, element, attrs, ctrl, transclude) {
            transclude(scope, function (clone) {
              element.append(clone);
            });
          }
        };
    })
    
    /**
     * Highlights text that matches $select.search.
     *
     * Taken from AngularUI Bootstrap Typeahead
     * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
     */
    .filter('highlight', function() {
      function escapeRegexp(queryToEscape) {
        return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
      }
    
      return function(matchItem, query) {
        return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
      };
    })
    
    /**
     * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
     *
     * Taken from AngularUI Bootstrap Position:
     * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
     */
    .factory('uisOffset',
      ['$document', '$window',
      function ($document, $window) {
    
      return function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      };
    }]);
    
    /**
     * Debounces functions
     *
     * Taken from UI Bootstrap $$debounce source code
     * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
     *
     */
    uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
      return function(callback, debounceTime) {
        var timeoutPromise;
    
        return function() {
          var self = this;
          var args = Array.prototype.slice.call(arguments);
          if (timeoutPromise) {
            $timeout.cancel(timeoutPromise);
          }
    
          timeoutPromise = $timeout(function() {
            callback.apply(self, args);
          }, debounceTime);
        };
      };
    }]);
    
    uis.directive('uiSelectChoices',
      ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
      function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
    
      return {
        restrict: 'EA',
        require: '^uiSelect',
        replace: true,
        transclude: true,
        templateUrl: function(tElement) {
          // Needed so the uiSelect can detect the transcluded content
          tElement.addClass('ui-select-choices');
    
          // Gets theme attribute from parent (ui-select)
          var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
          return theme + '/choices.tpl.html';
        },
    
        compile: function(tElement, tAttrs) {
    
          if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
    
          // var repeat = RepeatParser.parse(attrs.repeat);
          var groupByExp = tAttrs.groupBy;
          var groupFilterExp = tAttrs.groupFilter;
    
          if (groupByExp) {
            var groups = tElement.querySelectorAll('.ui-select-choices-group');
            if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
            groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
          }
    
          var parserResult = RepeatParser.parse(tAttrs.repeat);
    
          var choices = tElement.querySelectorAll('.ui-select-choices-row');
          if (choices.length !== 1) {
            throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
          }
    
          choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
                 .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
    
    
          var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
          if (rowsInner.length !== 1) {
            throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
          }
          rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
    
          // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
          var clickTarget = $window.document.addEventListener ? choices : rowsInner;
          clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
    
          return function link(scope, element, attrs, $select) {
    
    
            $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
            $select.disableChoiceExpression = attrs.uiDisableChoice;
            $select.onHighlightCallback = attrs.onHighlight;
            $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
            $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
    
            scope.$watch('$select.search', function(newValue) {
              if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
              $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
              if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
                $select.refresh(attrs.refresh);
              } else {
                $select.items = [];
              }
            });
    
            attrs.$observe('refreshDelay', function() {
              // $eval() is needed otherwise we get a string instead of a number
              var refreshDelay = scope.$eval(attrs.refreshDelay);
              $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
            });
    
            scope.$watch('$select.open', function(open) {
              if (open) {
                tElement.attr('role', 'listbox');
                $select.refresh(attrs.refresh);
              } else {
                element.removeAttr('role');
              }
            });
          };
        }
      };
    }]);
    
    /**
     * Contains ui-select "intelligence".
     *
     * The goal is to limit dependency on the DOM whenever possible and
     * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
     */
    uis.controller('uiSelectCtrl',
      ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
      function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
    
      var ctrl = this;
    
      var EMPTY_SEARCH = '';
    
      ctrl.placeholder = uiSelectConfig.placeholder;
      ctrl.searchEnabled = uiSelectConfig.searchEnabled;
      ctrl.sortable = uiSelectConfig.sortable;
      ctrl.refreshDelay = uiSelectConfig.refreshDelay;
      ctrl.paste = uiSelectConfig.paste;
      ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
      ctrl.refreshing = false;
      ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
      ctrl.spinnerClass = uiSelectConfig.spinnerClass;
      ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
      ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
      ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
      ctrl.search = EMPTY_SEARCH;
    
      ctrl.activeIndex = 0; //Dropdown of choices
      ctrl.items = []; //All available choices
    
      ctrl.open = false;
      ctrl.focus = false;
      ctrl.disabled = false;
      ctrl.selected = undefined;
    
      ctrl.dropdownPosition = 'auto';
    
      ctrl.focusser = undefined; //Reference to input element used to handle focus events
      ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
      ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
      ctrl.tagging = {isActivated: false, fct: undefined};
      ctrl.taggingTokens = {isActivated: false, tokens: undefined};
      ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
      ctrl.clickTriggeredSelect = false;
      ctrl.$filter = $filter;
      ctrl.$element = $element;
    
      // Use $injector to check for $animate and store a reference to it
      ctrl.$animate = (function () {
        try {
          return $injector.get('$animate');
        } catch (err) {
          // $animate does not exist
          return null;
        }
      })();
    
      ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
      if (ctrl.searchInput.length !== 1) {
        throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
      }
    
      ctrl.isEmpty = function() {
        return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
      };
    
      function _findIndex(collection, predicate, thisArg){
        if (collection.findIndex){
          return collection.findIndex(predicate, thisArg);
        } else {
          var list = Object(collection);
          var length = list.length >>> 0;
          var value;
    
          for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
              return i;
            }
          }
          return -1;
        }
      }
    
      // Most of the time the user does not want to empty the search input when in typeahead mode
      function _resetSearchInput() {
        if (ctrl.resetSearchInput) {
          ctrl.search = EMPTY_SEARCH;
          //reset activeIndex
          if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
            ctrl.activeIndex = _findIndex(ctrl.items, function(item){
              return angular.equals(this, item);
            }, ctrl.selected);
          }
        }
      }
    
        function _groupsFilter(groups, groupNames) {
          var i, j, result = [];
          for(i = 0; i < groupNames.length ;i++){
            for(j = 0; j < groups.length ;j++){
              if(groups[j].name == [groupNames[i]]){
                result.push(groups[j]);
              }
            }
          }
          return result;
        }
    
      // When the user clicks on ui-select, displays the dropdown list
      ctrl.activate = function(initSearchValue, avoidReset) {
        if (!ctrl.disabled  && !ctrl.open) {
          if(!avoidReset) _resetSearchInput();
    
          $scope.$broadcast('uis:activate');
          ctrl.open = true;
          ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
          // ensure that the index is set to zero for tagging variants
          // that where first option is auto-selected
          if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
            ctrl.activeIndex = 0;
          }
    
          var container = $element.querySelectorAll('.ui-select-choices-content');
          var searchInput = $element.querySelectorAll('.ui-select-search');
          if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
            var animateHandler = function(elem, phase) {
              if (phase === 'start' && ctrl.items.length === 0) {
                // Only focus input after the animation has finished
                ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
                $timeout(function () {
                  ctrl.focusSearchInput(initSearchValue);
                });
              } else if (phase === 'close') {
                // Only focus input after the animation has finished
                ctrl.$animate.off('enter', container[0], animateHandler);
                $timeout(function () {
                  ctrl.focusSearchInput(initSearchValue);
                });
              }
            };
    
            if (ctrl.items.length > 0) {
              ctrl.$animate.on('enter', container[0], animateHandler);
            } else {
              ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
            }
          } else {
            $timeout(function () {
              ctrl.focusSearchInput(initSearchValue);
              if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
                _ensureHighlightVisible();
              }
            });
          }
        }
        else if (ctrl.open && !ctrl.searchEnabled) {
          // Close the selection if we don't have search enabled, and we click on the select again
          ctrl.close();
        }
      };
    
      ctrl.focusSearchInput = function (initSearchValue) {
        ctrl.search = initSearchValue || ctrl.search;
        ctrl.searchInput[0].focus();
      };
    
      ctrl.findGroupByName = function(name) {
        return ctrl.groups && ctrl.groups.filter(function(group) {
          return group.name === name;
        })[0];
      };
    
      ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
        function updateGroups(items) {
          var groupFn = $scope.$eval(groupByExp);
          ctrl.groups = [];
          angular.forEach(items, function(item) {
            var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
            var group = ctrl.findGroupByName(groupName);
            if(group) {
              group.items.push(item);
            }
            else {
              ctrl.groups.push({name: groupName, items: [item]});
            }
          });
          if(groupFilterExp){
            var groupFilterFn = $scope.$eval(groupFilterExp);
            if( angular.isFunction(groupFilterFn)){
              ctrl.groups = groupFilterFn(ctrl.groups);
            } else if(angular.isArray(groupFilterFn)){
              ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
            }
          }
          ctrl.items = [];
          ctrl.groups.forEach(function(group) {
            ctrl.items = ctrl.items.concat(group.items);
          });
        }
    
        function setPlainItems(items) {
          ctrl.items = items || [];
        }
    
        ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
    
        ctrl.parserResult = RepeatParser.parse(repeatAttr);
    
        ctrl.isGrouped = !!groupByExp;
        ctrl.itemProperty = ctrl.parserResult.itemName;
    
        //If collection is an Object, convert it to Array
    
        var originalSource = ctrl.parserResult.source;
    
        //When an object is used as source, we better create an array and use it as 'source'
        var createArrayFromObject = function(){
          var origSrc = originalSource($scope);
          $scope.$uisSource = Object.keys(origSrc).map(function(v){
            var result = {};
            result[ctrl.parserResult.keyName] = v;
            result.value = origSrc[v];
            return result;
          });
        };
    
        if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
          createArrayFromObject();
          ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
          $scope.$watch(originalSource, function(newVal, oldVal){
            if (newVal !== oldVal) createArrayFromObject();
          }, true);
        }
    
        ctrl.refreshItems = function (data){
          data = data || ctrl.parserResult.source($scope);
          var selectedItems = ctrl.selected;
          //TODO should implement for single mode removeSelected
          if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
            ctrl.setItemsFn(data);
          }else{
            if ( data !== undefined && data !== null ) {
              var filteredItems = data.filter(function(i) {
                return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
                  return !angular.equals(i, selectedItem);
                }) : !angular.equals(i, selectedItems);
              });
              ctrl.setItemsFn(filteredItems);
            }
          }
          if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
            $scope.calculateDropdownPos();
          }
          $scope.$broadcast('uis:refresh');
        };
    
        // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
        $scope.$watchCollection(ctrl.parserResult.source, function(items) {
          if (items === undefined || items === null) {
            // If the user specifies undefined or null => reset the collection
            // Special case: items can be undefined if the user did not initialized the collection on the scope
            // i.e $scope.addresses = [] is missing
            ctrl.items = [];
          } else {
            if (!angular.isArray(items)) {
              throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
            } else {
              //Remove already selected items (ex: while searching)
              //TODO Should add a test
              ctrl.refreshItems(items);
    
              //update the view value with fresh data from items, if there is a valid model value
              if(angular.isDefined(ctrl.ngModel.$modelValue)) {
                ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
              }
            }
          }
        });
    
      };
    
      var _refreshDelayPromise;
    
      /**
       * Typeahead mode: lets the user refresh the collection using his own function.
       *
       * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
       */
      ctrl.refresh = function(refreshAttr) {
        if (refreshAttr !== undefined) {
          // Debounce
          // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
          // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
          if (_refreshDelayPromise) {
            $timeout.cancel(_refreshDelayPromise);
          }
          _refreshDelayPromise = $timeout(function() {
            if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
              var refreshPromise = $scope.$eval(refreshAttr);
              if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
                ctrl.refreshing = true;
                refreshPromise.finally(function() {
                  ctrl.refreshing = false;
                });
              }
            }
          }, ctrl.refreshDelay);
        }
      };
    
      ctrl.isActive = function(itemScope) {
        if ( !ctrl.open ) {
          return false;
        }
        var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
        var isActive =  itemIndex == ctrl.activeIndex;
    
        if ( !isActive || itemIndex < 0 ) {
          return false;
        }
    
        if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
          itemScope.$eval(ctrl.onHighlightCallback);
        }
    
        return isActive;
      };
    
      var _isItemSelected = function (item) {
        return (ctrl.selected && angular.isArray(ctrl.selected) &&
            ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
      };
    
      var disabledItems = [];
    
      function _updateItemDisabled(item, isDisabled) {
        var disabledItemIndex = disabledItems.indexOf(item);
        if (isDisabled && disabledItemIndex === -1) {
          disabledItems.push(item);
        }
    
        if (!isDisabled && disabledItemIndex > -1) {
          disabledItems.splice(disabledItemIndex, 1);
        }
      }
    
      function _isItemDisabled(item) {
        return disabledItems.indexOf(item) > -1;
      }
    
      ctrl.isDisabled = function(itemScope) {
    
        if (!ctrl.open) return;
    
        var item = itemScope[ctrl.itemProperty];
        var itemIndex = ctrl.items.indexOf(item);
        var isDisabled = false;
    
        if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
    
          if (item.isTag) return false;
    
          if (ctrl.multiple) {
            isDisabled = _isItemSelected(item);
          }
    
          if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
            isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
          }
    
          _updateItemDisabled(item, isDisabled);
        }
    
        return isDisabled;
      };
    
    
      // When the user selects an item with ENTER or clicks the dropdown
      ctrl.select = function(item, skipFocusser, $event) {
        if (isNil(item) || !_isItemDisabled(item)) {
    
          if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
    
          if (!item || !_isItemDisabled(item)) {
            // if click is made on existing item, prevent from tagging, ctrl.search does not matter
            ctrl.clickTriggeredSelect = false;
            if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
              ctrl.clickTriggeredSelect = true;
    
            if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
              // if taggingLabel is disabled and item is undefined we pull from ctrl.search
              if ( ctrl.taggingLabel === false ) {
                if ( ctrl.activeIndex < 0 ) {
                  if (item === undefined) {
                    item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
                  }
                  if (!item || angular.equals( ctrl.items[0], item ) ) {
                    return;
                  }
                } else {
                  // keyboard nav happened first, user selected from dropdown
                  item = ctrl.items[ctrl.activeIndex];
                }
              } else {
                // tagging always operates at index zero, taggingLabel === false pushes
                // the ctrl.search value without having it injected
                if ( ctrl.activeIndex === 0 ) {
                  // ctrl.tagging pushes items to ctrl.items, so we only have empty val
                  // for `item` if it is a detected duplicate
                  if ( item === undefined ) return;
    
                  // create new item on the fly if we don't already have one;
                  // use tagging function if we have one
                  if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
                    item = ctrl.tagging.fct(item);
                    if (!item) return;
                  // if item type is 'string', apply the tagging label
                  } else if ( typeof item === 'string' ) {
                    // trim the trailing space
                    item = item.replace(ctrl.taggingLabel,'').trim();
                  }
                }
              }
              // search ctrl.selected for dupes potentially caused by tagging and return early if found
              if (_isItemSelected(item)) {
                ctrl.close(skipFocusser);
                return;
              }
            }
            _resetSearchInput();
            $scope.$broadcast('uis:select', item);
    
            if (ctrl.closeOnSelect) {
              ctrl.close(skipFocusser);
            }
          }
        }
      };
    
      // Closes the dropdown
      ctrl.close = function(skipFocusser) {
        if (!ctrl.open) return;
        if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
        ctrl.open = false;
        _resetSearchInput();
        $scope.$broadcast('uis:close', skipFocusser);
    
      };
    
      ctrl.setFocus = function(){
        if (!ctrl.focus) ctrl.focusInput[0].focus();
      };
    
      ctrl.clear = function($event) {
        ctrl.select(null);
        $event.stopPropagation();
        $timeout(function() {
          ctrl.focusser[0].focus();
        }, 0, false);
      };
    
      // Toggle dropdown
      ctrl.toggle = function(e) {
        if (ctrl.open) {
          ctrl.close();
          e.preventDefault();
          e.stopPropagation();
        } else {
          ctrl.activate();
        }
      };
    
      // Set default function for locked choices - avoids unnecessary
      // logic if functionality is not being used
      ctrl.isLocked = function () {
        return false;
      };
    
      $scope.$watch(function () {
        return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
      }, _initaliseLockedChoices);
    
      function _initaliseLockedChoices(doInitalise) {
        if(!doInitalise) return;
    
        var lockedItems = [];
    
        function _updateItemLocked(item, isLocked) {
          var lockedItemIndex = lockedItems.indexOf(item);
          if (isLocked && lockedItemIndex === -1) {
            lockedItems.push(item);
            }
    
          if (!isLocked && lockedItemIndex > -1) {
            lockedItems.splice(lockedItemIndex, 1);
          }
        }
    
        function _isItemlocked(item) {
          return lockedItems.indexOf(item) > -1;
        }
    
        ctrl.isLocked = function (itemScope, itemIndex) {
          var isLocked = false,
              item = ctrl.selected[itemIndex];
    
          if(item) {
            if (itemScope) {
              isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
              _updateItemLocked(item, isLocked);
            } else {
              isLocked = _isItemlocked(item);
            }
          }
    
          return isLocked;
        };
      }
    
    
      var sizeWatch = null;
      var updaterScheduled = false;
      ctrl.sizeSearchInput = function() {
    
        var input = ctrl.searchInput[0],
            container = ctrl.$element[0],
            calculateContainerWidth = function() {
              // Return the container width only if the search input is visible
              return container.clientWidth * !!input.offsetParent;
            },
            updateIfVisible = function(containerWidth) {
              if (containerWidth === 0) {
                return false;
              }
              var inputWidth = containerWidth - input.offsetLeft;
              if (inputWidth < 50) inputWidth = containerWidth;
              ctrl.searchInput.css('width', inputWidth+'px');
              return true;
            };
    
        ctrl.searchInput.css('width', '10px');
        $timeout(function() { //Give tags time to render correctly
          if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
            sizeWatch = $scope.$watch(function() {
              if (!updaterScheduled) {
                updaterScheduled = true;
                $scope.$$postDigest(function() {
                  updaterScheduled = false;
                  if (updateIfVisible(calculateContainerWidth())) {
                    sizeWatch();
                    sizeWatch = null;
                  }
                });
              }
            }, angular.noop);
          }
        });
      };
    
      function _handleDropDownSelection(key) {
        var processed = true;
        switch (key) {
          case KEY.DOWN:
            if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
            else if (ctrl.activeIndex < ctrl.items.length - 1) {
              var idx = ++ctrl.activeIndex;
              while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
                ctrl.activeIndex = ++idx;
              }
            }
            break;
          case KEY.UP:
            var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
            if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
            else if (ctrl.activeIndex > minActiveIndex) {
              var idxmin = --ctrl.activeIndex;
              while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
                ctrl.activeIndex = --idxmin;
              }
            }
            break;
          case KEY.TAB:
            if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
            break;
          case KEY.ENTER:
            if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
              ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
            } else {
              ctrl.activate(false, true); //In case its the search input in 'multiple' mode
            }
            break;
          case KEY.ESC:
            ctrl.close();
            break;
          default:
            processed = false;
        }
        return processed;
      }
    
      // Bind to keyboard shortcuts
      ctrl.searchInput.on('keydown', function(e) {
    
        var key = e.which;
    
        if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
          e.preventDefault();
          e.stopPropagation();
        }
    
        $scope.$apply(function() {
    
          var tagged = false;
    
          if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
            if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
              e.preventDefault();
              e.stopPropagation();
            }
            if ( ctrl.taggingTokens.isActivated ) {
              for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
                if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
                  // make sure there is a new value to push via tagging
                  if ( ctrl.search.length > 0 ) {
                    tagged = true;
                  }
                }
              }
              if ( tagged ) {
                $timeout(function() {
                  ctrl.searchInput.triggerHandler('tagged');
                  var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
                  if ( ctrl.tagging.fct ) {
                    newItem = ctrl.tagging.fct( newItem );
                  }
                  if (newItem) ctrl.select(newItem, true);
                });
              }
            }
          }
    
        });
    
        if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
          _ensureHighlightVisible();
        }
    
        if (key === KEY.ENTER || key === KEY.ESC) {
          e.preventDefault();
          e.stopPropagation();
        }
    
      });
    
      ctrl.searchInput.on('paste', function (e) {
        var data;
    
        if (window.clipboardData && window.clipboardData.getData) { // IE
          data = window.clipboardData.getData('Text');
        } else {
          data = (e.originalEvent || e).clipboardData.getData('text/plain');
        }
    
        // Prepend the current input field text to the paste buffer.
        data = ctrl.search + data;
    
        if (data && data.length > 0) {
          // If tagging try to split by tokens and add items
          if (ctrl.taggingTokens.isActivated) {
            var items = [];
            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
              var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
              if (data.indexOf(separator) > -1) {
                items = data.split(separator);
                break;  // only split by one token
              }
            }
            if (items.length === 0) {
              items = [data];
            }
            var oldsearch = ctrl.search;
            angular.forEach(items, function (item) {
              var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
              if (newItem) {
                ctrl.select(newItem, true);
              }
            });
            ctrl.search = oldsearch || EMPTY_SEARCH;
            e.preventDefault();
            e.stopPropagation();
          } else if (ctrl.paste) {
            ctrl.paste(data);
            ctrl.search = EMPTY_SEARCH;
            e.preventDefault();
            e.stopPropagation();
          }
        }
      });
    
      ctrl.searchInput.on('tagged', function() {
        $timeout(function() {
          _resetSearchInput();
        });
      });
    
      // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
      function _ensureHighlightVisible() {
        var container = $element.querySelectorAll('.ui-select-choices-content');
        var choices = container.querySelectorAll('.ui-select-choices-row');
        if (choices.length < 1) {
          throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
        }
    
        if (ctrl.activeIndex < 0) {
          return;
        }
    
        var highlighted = choices[ctrl.activeIndex];
        var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
        var height = container[0].offsetHeight;
    
        if (posY > height) {
          container[0].scrollTop += posY - height;
        } else if (posY < highlighted.clientHeight) {
          if (ctrl.isGrouped && ctrl.activeIndex === 0)
            container[0].scrollTop = 0; //To make group header visible when going all the way up
          else
            container[0].scrollTop -= highlighted.clientHeight - posY;
        }
      }
    
      var onResize = $$uisDebounce(function() {
        ctrl.sizeSearchInput();
      }, 50);
    
      angular.element($window).bind('resize', onResize);
    
      $scope.$on('$destroy', function() {
        ctrl.searchInput.off('keyup keydown tagged blur paste');
        angular.element($window).off('resize', onResize);
      });
    
      $scope.$watch('$select.activeIndex', function(activeIndex) {
        if (activeIndex)
          $element.find('input').attr(
            'aria-activedescendant',
            'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
      });
    
      $scope.$watch('$select.open', function(open) {
        if (!open)
          $element.find('input').removeAttr('aria-activedescendant');
      });
    }]);
    
    uis.directive('uiSelect',
      ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
      function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
    
      return {
        restrict: 'EA',
        templateUrl: function(tElement, tAttrs) {
          var theme = tAttrs.theme || uiSelectConfig.theme;
          return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
        },
        replace: true,
        transclude: true,
        require: ['uiSelect', '^ngModel'],
        scope: true,
    
        controller: 'uiSelectCtrl',
        controllerAs: '$select',
        compile: function(tElement, tAttrs) {
    
          // Allow setting ngClass on uiSelect
          var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
          if(match) {
            var combined = '{'+ match[1] +', '+ match[2] +'}';
            tAttrs.ngClass = combined;
            tElement.attr('ng-class', combined);
          }
    
          //Multiple or Single depending if multiple attribute presence
          if (angular.isDefined(tAttrs.multiple))
            tElement.append('<ui-select-multiple/>').removeAttr('multiple');
          else
            tElement.append('<ui-select-single/>');
    
          if (tAttrs.inputId)
            tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
    
          return function(scope, element, attrs, ctrls, transcludeFn) {
    
            var $select = ctrls[0];
            var ngModel = ctrls[1];
    
            $select.generatedId = uiSelectConfig.generateId();
            $select.baseTitle = attrs.title || 'Select box';
            $select.focusserTitle = $select.baseTitle + ' focus';
            $select.focusserId = 'focusser-' + $select.generatedId;
    
            $select.closeOnSelect = function() {
              if (angular.isDefined(attrs.closeOnSelect)) {
                return $parse(attrs.closeOnSelect)();
              } else {
                return uiSelectConfig.closeOnSelect;
              }
            }();
    
            scope.$watch('skipFocusser', function() {
                var skipFocusser = scope.$eval(attrs.skipFocusser);
                $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
            });
    
            $select.onSelectCallback = $parse(attrs.onSelect);
            $select.onRemoveCallback = $parse(attrs.onRemove);
    
            //Set reference to ngModel from uiSelectCtrl
            $select.ngModel = ngModel;
    
            $select.choiceGrouped = function(group){
              return $select.isGrouped && group && group.name;
            };
    
            if(attrs.tabindex){
              attrs.$observe('tabindex', function(value) {
                $select.focusInput.attr('tabindex', value);
                element.removeAttr('tabindex');
              });
            }
    
            scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
              $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
            });
    
            scope.$watch('sortable', function() {
                var sortable = scope.$eval(attrs.sortable);
                $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
            });
    
            attrs.$observe('backspaceReset', function() {
              // $eval() is needed otherwise we get a string instead of a boolean
              var backspaceReset = scope.$eval(attrs.backspaceReset);
              $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
            });
    
            attrs.$observe('limit', function() {
              //Limit the number of selections allowed
              $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
            });
    
            scope.$watch('removeSelected', function() {
                var removeSelected = scope.$eval(attrs.removeSelected);
                $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
            });
    
            attrs.$observe('disabled', function() {
              // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
              $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
            });
    
            attrs.$observe('resetSearchInput', function() {
              // $eval() is needed otherwise we get a string instead of a boolean
              var resetSearchInput = scope.$eval(attrs.resetSearchInput);
              $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
            });
    
            attrs.$observe('paste', function() {
              $select.paste = scope.$eval(attrs.paste);
            });
    
            attrs.$observe('tagging', function() {
              if(attrs.tagging !== undefined)
              {
                // $eval() is needed otherwise we get a string instead of a boolean
                var taggingEval = scope.$eval(attrs.tagging);
                $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
              }
              else
              {
                $select.tagging = {isActivated: false, fct: undefined};
              }
            });
    
            attrs.$observe('taggingLabel', function() {
              if(attrs.tagging !== undefined )
              {
                // check eval for FALSE, in this case, we disable the labels
                // associated with tagging
                if ( attrs.taggingLabel === 'false' ) {
                  $select.taggingLabel = false;
                }
                else
                {
                  $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
                }
              }
            });
    
            attrs.$observe('taggingTokens', function() {
              if (attrs.tagging !== undefined) {
                var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
                $select.taggingTokens = {isActivated: true, tokens: tokens };
              }
            });
    
            attrs.$observe('spinnerEnabled', function() {
              // $eval() is needed otherwise we get a string instead of a boolean
              var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
              $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
            });
    
            attrs.$observe('spinnerClass', function() {
              var spinnerClass = attrs.spinnerClass;
              $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
            });
    
            //Automatically gets focus when loaded
            if (angular.isDefined(attrs.autofocus)){
              $timeout(function(){
                $select.setFocus();
              });
            }
    
            //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
            if (angular.isDefined(attrs.focusOn)){
              scope.$on(attrs.focusOn, function() {
                  $timeout(function(){
                    $select.setFocus();
                  });
              });
            }
    
            function onDocumentClick(e) {
              if (!$select.open) return; //Skip it if dropdown is close
    
              var contains = false;
    
              if (window.jQuery) {
                // Firefox 3.6 does not support element.contains()
                // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
                contains = window.jQuery.contains(element[0], e.target);
              } else {
                contains = element[0].contains(e.target);
              }
    
              if (!contains && !$select.clickTriggeredSelect) {
                var skipFocusser;
                if (!$select.skipFocusser) {
                  //Will lose focus only with certain targets
                  var focusableControls = ['input','button','textarea','select'];
                  var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
                  skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
                  if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
                } else {
                  skipFocusser = true;
                }
                $select.close(skipFocusser);
                scope.$digest();
              }
              $select.clickTriggeredSelect = false;
            }
    
            // See Click everywhere but here event http://stackoverflow.com/questions/12931369
            $document.on('click', onDocumentClick);
    
            scope.$on('$destroy', function() {
              $document.off('click', onDocumentClick);
            });
    
            // Move transcluded elements to their correct position in main template
            transcludeFn(scope, function(clone) {
              // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
    
              // One day jqLite will be replaced by jQuery and we will be able to write:
              // var transcludedElement = clone.filter('.my-class')
              // instead of creating a hackish DOM element:
              var transcluded = angular.element('<div>').append(clone);
    
              var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
              transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
              transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
              if (transcludedMatch.length !== 1) {
                throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
              }
              element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
    
              var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
              transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
              transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
              if (transcludedChoices.length !== 1) {
                throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
              }
              element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
    
              var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
              transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
              transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
              if (transcludedNoChoice.length == 1) {
                element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
              }
            });
    
            // Support for appending the select field to the body when its open
            var appendToBody = scope.$eval(attrs.appendToBody);
            if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
              scope.$watch('$select.open', function(isOpen) {
                if (isOpen) {
                  positionDropdown();
                } else {
                  resetDropdown();
                }
              });
    
              // Move the dropdown back to its original location when the scope is destroyed. Otherwise
              // it might stick around when the user routes away or the select field is otherwise removed
              scope.$on('$destroy', function() {
                resetDropdown();
              });
            }
    
            // Hold on to a reference to the .ui-select-container element for appendToBody support
            var placeholder = null,
                originalWidth = '';
    
            function positionDropdown() {
              // Remember the absolute position of the element
              var offset = uisOffset(element);
    
              // Clone the element into a placeholder element to take its original place in the DOM
              placeholder = angular.element('<div class="ui-select-placeholder"></div>');
              placeholder[0].style.width = offset.width + 'px';
              placeholder[0].style.height = offset.height + 'px';
              element.after(placeholder);
    
              // Remember the original value of the element width inline style, so it can be restored
              // when the dropdown is closed
              originalWidth = element[0].style.width;
    
              // Now move the actual dropdown element to the end of the body
              $document.find('body').append(element);
    
              element[0].style.position = 'absolute';
              element[0].style.left = offset.left + 'px';
              element[0].style.top = offset.top + 'px';
              element[0].style.width = offset.width + 'px';
            }
    
            function resetDropdown() {
              if (placeholder === null) {
                // The dropdown has not actually been display yet, so there's nothing to reset
                return;
              }
    
              // Move the dropdown element back to its original location in the DOM
              placeholder.replaceWith(element);
              placeholder = null;
    
              element[0].style.position = '';
              element[0].style.left = '';
              element[0].style.top = '';
              element[0].style.width = originalWidth;
    
              // Set focus back on to the moved element
              $select.setFocus();
            }
    
            // Hold on to a reference to the .ui-select-dropdown element for direction support.
            var dropdown = null,
                directionUpClassName = 'direction-up';
    
            // Support changing the direction of the dropdown if there isn't enough space to render it.
            scope.$watch('$select.open', function() {
    
              if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
                scope.calculateDropdownPos();
              }
    
            });
    
            var setDropdownPosUp = function(offset, offsetDropdown){
    
              offset = offset || uisOffset(element);
              offsetDropdown = offsetDropdown || uisOffset(dropdown);
    
              dropdown[0].style.position = 'absolute';
              dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
              element.addClass(directionUpClassName);
    
            };
    
            var setDropdownPosDown = function(offset, offsetDropdown){
    
              element.removeClass(directionUpClassName);
    
              offset = offset || uisOffset(element);
              offsetDropdown = offsetDropdown || uisOffset(dropdown);
    
              dropdown[0].style.position = '';
              dropdown[0].style.top = '';
    
            };
    
            var calculateDropdownPosAfterAnimation = function() {
              // Delay positioning the dropdown until all choices have been added so its height is correct.
              $timeout(function() {
                if ($select.dropdownPosition === 'up') {
                  //Go UP
                  setDropdownPosUp();
                } else {
                  //AUTO
                  element.removeClass(directionUpClassName);
    
                  var offset = uisOffset(element);
                  var offsetDropdown = uisOffset(dropdown);
    
                  //https://code.google.com/p/chromium/issues/detail?id=342307#c4
                  var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
    
                  // Determine if the direction of the dropdown needs to be changed.
                  if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
                    //Go UP
                    setDropdownPosUp(offset, offsetDropdown);
                  }else{
                    //Go DOWN
                    setDropdownPosDown(offset, offsetDropdown);
                  }
                }
    
                // Display the dropdown once it has been positioned.
                dropdown[0].style.opacity = 1;
              });
            };
    
            var opened = false;
            
            scope.calculateDropdownPos = function() {
              if ($select.open) {
                dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
    
                if (dropdown.length === 0) {
                  return;
                }
    
               // Hide the dropdown so there is no flicker until $timeout is done executing.
               if ($select.search === '' && !opened) {
                  dropdown[0].style.opacity = 0;
                  opened = true;
               }
    
                if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
                  var needsCalculated = true;
    
                  $select.$animate.on('enter', dropdown, function (elem, phase) {
                    if (phase === 'close' && needsCalculated) {
                      calculateDropdownPosAfterAnimation();
                      needsCalculated = false;
                    }
                  });
                } else {
                  calculateDropdownPosAfterAnimation();
                }
              } else {
                if (dropdown === null || dropdown.length === 0) {
                  return;
                }
    
                // Reset the position of the dropdown.
                dropdown[0].style.opacity = 0;
                dropdown[0].style.position = '';
                dropdown[0].style.top = '';
                element.removeClass(directionUpClassName);
              }
            };
          };
        }
      };
    }]);
    
    uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
      return {
        restrict: 'EA',
        require: '^uiSelect',
        replace: true,
        transclude: true,
        templateUrl: function(tElement) {
          // Needed so the uiSelect can detect the transcluded content
          tElement.addClass('ui-select-match');
    
          var parent = tElement.parent();
          // Gets theme attribute from parent (ui-select)
          var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
          var multi = angular.isDefined(getAttribute(parent, 'multiple'));
    
          return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
        },
        link: function(scope, element, attrs, $select) {
          $select.lockChoiceExpression = attrs.uiLockChoice;
          attrs.$observe('placeholder', function(placeholder) {
            $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
          });
    
          function setAllowClear(allow) {
            $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
          }
    
          attrs.$observe('allowClear', setAllowClear);
          setAllowClear(attrs.allowClear);
    
          if($select.multiple){
            $select.sizeSearchInput();
          }
    
        }
      };
    
      function getAttribute(elem, attribute) {
        if (elem[0].hasAttribute(attribute))
          return elem.attr(attribute);
    
        if (elem[0].hasAttribute('data-' + attribute))
          return elem.attr('data-' + attribute);
    
        if (elem[0].hasAttribute('x-' + attribute))
          return elem.attr('x-' + attribute);
      }
    }]);
    
    uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
      return {
        restrict: 'EA',
        require: ['^uiSelect', '^ngModel'],
    
        controller: ['$scope','$timeout', function($scope, $timeout){
    
          var ctrl = this,
              $select = $scope.$select,
              ngModel;
    
          if (angular.isUndefined($select.selected))
            $select.selected = [];
    
          //Wait for link fn to inject it
          $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
    
          ctrl.activeMatchIndex = -1;
    
          ctrl.updateModel = function(){
            ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
            ctrl.refreshComponent();
          };
    
          ctrl.refreshComponent = function(){
            //Remove already selected items
            //e.g. When user clicks on a selection, the selected array changes and
            //the dropdown should remove that item
            if($select.refreshItems){
              $select.refreshItems();
            }
            if($select.sizeSearchInput){
              $select.sizeSearchInput();
            }
          };
    
          // Remove item from multiple select
          ctrl.removeChoice = function(index){
    
            // if the choice is locked, don't remove it
            if($select.isLocked(null, index)) return false;
    
            var removedChoice = $select.selected[index];
    
            var locals = {};
            locals[$select.parserResult.itemName] = removedChoice;
    
            $select.selected.splice(index, 1);
            ctrl.activeMatchIndex = -1;
            $select.sizeSearchInput();
    
            // Give some time for scope propagation.
            $timeout(function(){
              $select.onRemoveCallback($scope, {
                $item: removedChoice,
                $model: $select.parserResult.modelMapper($scope, locals)
              });
            });
    
            ctrl.updateModel();
    
            return true;
          };
    
          ctrl.getPlaceholder = function(){
            //Refactor single?
            if($select.selected && $select.selected.length) return;
            return $select.placeholder;
          };
    
    
        }],
        controllerAs: '$selectMultiple',
    
        link: function(scope, element, attrs, ctrls) {
    
          var $select = ctrls[0];
          var ngModel = scope.ngModel = ctrls[1];
          var $selectMultiple = scope.$selectMultiple;
    
          //$select.selected = raw selected objects (ignoring any property binding)
    
          $select.multiple = true;
    
          //Input that will handle focus
          $select.focusInput = $select.searchInput;
    
          //Properly check for empty if set to multiple
          ngModel.$isEmpty = function(value) {
            return !value || value.length === 0;
          };
    
          //From view --> model
          ngModel.$parsers.unshift(function () {
            var locals = {},
                result,
                resultMultiple = [];
            for (var j = $select.selected.length - 1; j >= 0; j--) {
              locals = {};
              locals[$select.parserResult.itemName] = $select.selected[j];
              result = $select.parserResult.modelMapper(scope, locals);
              resultMultiple.unshift(result);
            }
            return resultMultiple;
          });
    
          // From model --> view
          ngModel.$formatters.unshift(function (inputValue) {
            var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
                locals = {},
                result;
            if (!data) return inputValue;
            var resultMultiple = [];
            var checkFnMultiple = function(list, value){
              if (!list || !list.length) return;
              for (var p = list.length - 1; p >= 0; p--) {
                locals[$select.parserResult.itemName] = list[p];
                result = $select.parserResult.modelMapper(scope, locals);
                if($select.parserResult.trackByExp){
                    var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
                    var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
                    if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
                      if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
                          resultMultiple.unshift(list[p]);
                          return true;
                      }
                    }
                }
                if (angular.equals(result,value)){
                  resultMultiple.unshift(list[p]);
                  return true;
                }
              }
              return false;
            };
            if (!inputValue) return resultMultiple; //If ngModel was undefined
            for (var k = inputValue.length - 1; k >= 0; k--) {
              //Check model array of currently selected items
              if (!checkFnMultiple($select.selected, inputValue[k])){
                //Check model array of all items available
                if (!checkFnMultiple(data, inputValue[k])){
                  //If not found on previous lists, just add it directly to resultMultiple
                  resultMultiple.unshift(inputValue[k]);
                }
              }
            }
            return resultMultiple;
          });
    
          //Watch for external model changes
          scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
            if (oldValue != newValue){
              //update the view value with fresh data from items, if there is a valid model value
              if(angular.isDefined(ngModel.$modelValue)) {
                ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
              }
              $selectMultiple.refreshComponent();
            }
          });
    
          ngModel.$render = function() {
            // Make sure that model value is array
            if(!angular.isArray(ngModel.$viewValue)){
              // Have tolerance for null or undefined values
              if (isNil(ngModel.$viewValue)){
                ngModel.$viewValue = [];
              } else {
                throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
              }
            }
            $select.selected = ngModel.$viewValue;
            $selectMultiple.refreshComponent();
            scope.$evalAsync(); //To force $digest
          };
    
          scope.$on('uis:select', function (event, item) {
            if($select.selected.length >= $select.limit) {
              return;
            }
            $select.selected.push(item);
            var locals = {};
            locals[$select.parserResult.itemName] = item;
    
            $timeout(function(){
              $select.onSelectCallback(scope, {
                $item: item,
                $model: $select.parserResult.modelMapper(scope, locals)
              });
            });
            $selectMultiple.updateModel();
          });
    
          scope.$on('uis:activate', function () {
            $selectMultiple.activeMatchIndex = -1;
          });
    
          scope.$watch('$select.disabled', function(newValue, oldValue) {
            // As the search input field may now become visible, it may be necessary to recompute its size
            if (oldValue && !newValue) $select.sizeSearchInput();
          });
    
          $select.searchInput.on('keydown', function(e) {
            var key = e.which;
            scope.$apply(function() {
              var processed = false;
              // var tagged = false; //Checkme
              if(KEY.isHorizontalMovement(key)){
                processed = _handleMatchSelection(key);
              }
              if (processed  && key != KEY.TAB) {
                //TODO Check si el tab selecciona aun correctamente
                //Crear test
                e.preventDefault();
                e.stopPropagation();
              }
            });
          });
          function _getCaretPosition(el) {
            if(angular.isNumber(el.selectionStart)) return el.selectionStart;
            // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
            else return el.value.length;
          }
          // Handles selected options in "multiple" mode
          function _handleMatchSelection(key){
            var caretPosition = _getCaretPosition($select.searchInput[0]),
                length = $select.selected.length,
                // none  = -1,
                first = 0,
                last  = length-1,
                curr  = $selectMultiple.activeMatchIndex,
                next  = $selectMultiple.activeMatchIndex+1,
                prev  = $selectMultiple.activeMatchIndex-1,
                newIndex = curr;
    
            if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
    
            $select.close();
    
            function getNewActiveMatchIndex(){
              switch(key){
                case KEY.LEFT:
                  // Select previous/first item
                  if(~$selectMultiple.activeMatchIndex) return prev;
                  // Select last item
                  else return last;
                  break;
                case KEY.RIGHT:
                  // Open drop-down
                  if(!~$selectMultiple.activeMatchIndex || curr === last){
                    $select.activate();
                    return false;
                  }
                  // Select next/last item
                  else return next;
                  break;
                case KEY.BACKSPACE:
                  // Remove selected item and select previous/first
                  if(~$selectMultiple.activeMatchIndex){
                    if($selectMultiple.removeChoice(curr)) {
                      return prev;
                    } else {
                      return curr;
                    }
    
                  } else {
                    // If nothing yet selected, select last item
                    return last;
                  }
                  break;
                case KEY.DELETE:
                  // Remove selected item and select next item
                  if(~$selectMultiple.activeMatchIndex){
                    $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
                    return curr;
                  }
                  else return false;
              }
            }
    
            newIndex = getNewActiveMatchIndex();
    
            if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
            else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
    
            return true;
          }
    
          $select.searchInput.on('keyup', function(e) {
    
            if ( ! KEY.isVerticalMovement(e.which) ) {
              scope.$evalAsync( function () {
                $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
              });
            }
            // Push a "create new" item into array if there is a search string
            if ( $select.tagging.isActivated && $select.search.length > 0 ) {
    
              // return early with these keys
              if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
                return;
              }
              // always reset the activeIndex to the first item when tagging
              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
              // taggingLabel === false bypasses all of this
              if ($select.taggingLabel === false) return;
    
              var items = angular.copy( $select.items );
              var stashArr = angular.copy( $select.items );
              var newItem;
              var item;
              var hasTag = false;
              var dupeIndex = -1;
              var tagItems;
              var tagItem;
    
              // case for object tagging via transform `$select.tagging.fct` function
              if ( $select.tagging.fct !== undefined) {
                tagItems = $select.$filter('filter')(items,{'isTag': true});
                if ( tagItems.length > 0 ) {
                  tagItem = tagItems[0];
                }
                // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
                if ( items.length > 0 && tagItem ) {
                  hasTag = true;
                  items = items.slice(1,items.length);
                  stashArr = stashArr.slice(1,stashArr.length);
                }
                newItem = $select.tagging.fct($select.search);
                // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
                if (
                  stashArr.some(function (origItem) {
                     return angular.equals(origItem, newItem);
                  }) ||
                  $select.selected.some(function (origItem) {
                    return angular.equals(origItem, newItem);
                  })
                ) {
                  scope.$evalAsync(function () {
                    $select.activeIndex = 0;
                    $select.items = items;
                  });
                  return;
                }
                if (newItem) newItem.isTag = true;
              // handle newItem string and stripping dupes in tagging string context
              } else {
                // find any tagging items already in the $select.items array and store them
                tagItems = $select.$filter('filter')(items,function (item) {
                  return item.match($select.taggingLabel);
                });
                if ( tagItems.length > 0 ) {
                  tagItem = tagItems[0];
                }
                item = items[0];
                // remove existing tag item if found (should only ever be one tag item)
                if ( item !== undefined && items.length > 0 && tagItem ) {
                  hasTag = true;
                  items = items.slice(1,items.length);
                  stashArr = stashArr.slice(1,stashArr.length);
                }
                newItem = $select.search+' '+$select.taggingLabel;
                if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
                  return;
                }
                // verify the the tag doesn't match the value of an existing item from
                // the searched data set or the items already selected
                if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
                  // if there is a tag from prev iteration, strip it / queue the change
                  // and return early
                  if ( hasTag ) {
                    items = stashArr;
                    scope.$evalAsync( function () {
                      $select.activeIndex = 0;
                      $select.items = items;
                    });
                  }
                  return;
                }
                if ( _findCaseInsensitiveDupe(stashArr) ) {
                  // if there is a tag from prev iteration, strip it
                  if ( hasTag ) {
                    $select.items = stashArr.slice(1,stashArr.length);
                  }
                  return;
                }
              }
              if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
              // dupe found, shave the first item
              if ( dupeIndex > -1 ) {
                items = items.slice(dupeIndex+1,items.length-1);
              } else {
                items = [];
                if (newItem) items.push(newItem);
                items = items.concat(stashArr);
              }
              scope.$evalAsync( function () {
                $select.activeIndex = 0;
                $select.items = items;
    
                if ($select.isGrouped) {
                  // update item references in groups, so that indexOf will work after angular.copy
                  var itemsWithoutTag = newItem ? items.slice(1) : items;
                  $select.setItemsFn(itemsWithoutTag);
                  if (newItem) {
                    // add tag item as a new group
                    $select.items.unshift(newItem);
                    $select.groups.unshift({name: '', items: [newItem], tagging: true});
                  }
                }
              });
            }
          });
          function _findCaseInsensitiveDupe(arr) {
            if ( arr === undefined || $select.search === undefined ) {
              return false;
            }
            var hasDupe = arr.filter( function (origItem) {
              if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
                return false;
              }
              return origItem.toUpperCase() === $select.search.toUpperCase();
            }).length > 0;
    
            return hasDupe;
          }
          function _findApproxDupe(haystack, needle) {
            var dupeIndex = -1;
            if(angular.isArray(haystack)) {
              var tempArr = angular.copy(haystack);
              for (var i = 0; i <tempArr.length; i++) {
                // handle the simple string version of tagging
                if ( $select.tagging.fct === undefined ) {
                  // search the array for the match
                  if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
                  dupeIndex = i;
                  }
                // handle the object tagging implementation
                } else {
                  var mockObj = tempArr[i];
                  if (angular.isObject(mockObj)) {
                    mockObj.isTag = true;
                  }
                  if ( angular.equals(mockObj, needle) ) {
                    dupeIndex = i;
                  }
                }
              }
            }
            return dupeIndex;
          }
    
          $select.searchInput.on('blur', function() {
            $timeout(function() {
              $selectMultiple.activeMatchIndex = -1;
            });
          });
    
        }
      };
    }]);
    
    uis.directive('uiSelectNoChoice',
        ['uiSelectConfig', function (uiSelectConfig) {
            return {
                restrict: 'EA',
                require: '^uiSelect',
                replace: true,
                transclude: true,
                templateUrl: function (tElement) {
                    // Needed so the uiSelect can detect the transcluded content
                    tElement.addClass('ui-select-no-choice');
          
                    // Gets theme attribute from parent (ui-select)
                    var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
                    return theme + '/no-choice.tpl.html';
                }
            };
        }]);
    
    uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
      return {
        restrict: 'EA',
        require: ['^uiSelect', '^ngModel'],
        link: function(scope, element, attrs, ctrls) {
    
          var $select = ctrls[0];
          var ngModel = ctrls[1];
    
          //From view --> model
          ngModel.$parsers.unshift(function (inputValue) {
            // Keep original value for undefined and null
            if (isNil(inputValue)) {
              return inputValue;
            }
    
            var locals = {},
                result;
            locals[$select.parserResult.itemName] = inputValue;
            result = $select.parserResult.modelMapper(scope, locals);
            return result;
          });
    
          //From model --> view
          ngModel.$formatters.unshift(function (inputValue) {
            // Keep original value for undefined and null
            if (isNil(inputValue)) {
              return inputValue;
            }
    
            var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
                locals = {},
                result;
            if (data){
              var checkFnSingle = function(d){
                locals[$select.parserResult.itemName] = d;
                result = $select.parserResult.modelMapper(scope, locals);
                return result === inputValue;
              };
              //If possible pass same object stored in $select.selected
              if ($select.selected && checkFnSingle($select.selected)) {
                return $select.selected;
              }
              for (var i = data.length - 1; i >= 0; i--) {
                if (checkFnSingle(data[i])) return data[i];
              }
            }
            return inputValue;
          });
    
          //Update viewValue if model change
          scope.$watch('$select.selected', function(newValue) {
            if (ngModel.$viewValue !== newValue) {
              ngModel.$setViewValue(newValue);
            }
          });
    
          ngModel.$render = function() {
            $select.selected = ngModel.$viewValue;
          };
    
          scope.$on('uis:select', function (event, item) {
            $select.selected = item;
            var locals = {};
            locals[$select.parserResult.itemName] = item;
    
            $timeout(function() {
              $select.onSelectCallback(scope, {
                $item: item,
                $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
              });
            });
          });
    
          scope.$on('uis:close', function (event, skipFocusser) {
            $timeout(function(){
              $select.focusser.prop('disabled', false);
              if (!skipFocusser) $select.focusser[0].focus();
            },0,false);
          });
    
          scope.$on('uis:activate', function () {
            focusser.prop('disabled', true); //Will reactivate it on .close()
          });
    
          //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
          var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
          $compile(focusser)(scope);
          $select.focusser = focusser;
    
          //Input that will handle focus
          $select.focusInput = focusser;
    
          element.parent().append(focusser);
          focusser.bind("focus", function(){
            scope.$evalAsync(function(){
              $select.focus = true;
            });
          });
          focusser.bind("blur", function(){
            scope.$evalAsync(function(){
              $select.focus = false;
            });
          });
          focusser.bind("keydown", function(e){
    
            if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
              e.preventDefault();
              e.stopPropagation();
              $select.select(undefined);
              scope.$apply();
              return;
            }
    
            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
              return;
            }
    
            if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
              e.preventDefault();
              e.stopPropagation();
              $select.activate();
            }
    
            scope.$digest();
          });
    
          focusser.bind("keyup input", function(e){
    
            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
              return;
            }
    
            $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
            focusser.val('');
            scope.$digest();
    
          });
    
    
        }
      };
    }]);
    
    // Make multiple matches sortable
    uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
      return {
        require: ['^^uiSelect', '^ngModel'],
        link: function(scope, element, attrs, ctrls) {
          if (scope[attrs.uiSelectSort] === null) {
            throw uiSelectMinErr('sort', 'Expected a list to sort');
          }
    
          var $select = ctrls[0];
          var $ngModel = ctrls[1];
    
          var options = angular.extend({
              axis: 'horizontal'
            },
            scope.$eval(attrs.uiSelectSortOptions));
    
          var axis = options.axis;
          var draggingClassName = 'dragging';
          var droppingClassName = 'dropping';
          var droppingBeforeClassName = 'dropping-before';
          var droppingAfterClassName = 'dropping-after';
    
          scope.$watch(function(){
            return $select.sortable;
          }, function(newValue){
            if (newValue) {
              element.attr('draggable', true);
            } else {
              element.removeAttr('draggable');
            }
          });
    
          element.on('dragstart', function(event) {
            element.addClass(draggingClassName);
    
            (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
          });
    
          element.on('dragend', function() {
            removeClass(draggingClassName);
          });
    
          var move = function(from, to) {
            /*jshint validthis: true */
            this.splice(to, 0, this.splice(from, 1)[0]);
          };
    
          var removeClass = function(className) {
            angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
              angular.element(el).removeClass(className);
            });
          };
    
          var dragOverHandler = function(event) {
            event.preventDefault();
    
            var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
    
            if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
              removeClass(droppingAfterClassName);
              element.addClass(droppingBeforeClassName);
    
            } else {
              removeClass(droppingBeforeClassName);
              element.addClass(droppingAfterClassName);
            }
          };
    
          var dropTimeout;
    
          var dropHandler = function(event) {
            event.preventDefault();
    
            var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
    
            // prevent event firing multiple times in firefox
            $timeout.cancel(dropTimeout);
            dropTimeout = $timeout(function() {
              _dropHandler(droppedItemIndex);
            }, 20);
          };
    
          var _dropHandler = function(droppedItemIndex) {
            var theList = scope.$eval(attrs.uiSelectSort);
            var itemToMove = theList[droppedItemIndex];
            var newIndex = null;
    
            if (element.hasClass(droppingBeforeClassName)) {
              if (droppedItemIndex < scope.$index) {
                newIndex = scope.$index - 1;
              } else {
                newIndex = scope.$index;
              }
            } else {
              if (droppedItemIndex < scope.$index) {
                newIndex = scope.$index;
              } else {
                newIndex = scope.$index + 1;
              }
            }
    
            move.apply(theList, [droppedItemIndex, newIndex]);
    
            $ngModel.$setViewValue(Date.now());
    
            scope.$apply(function() {
              scope.$emit('uiSelectSort:change', {
                array: theList,
                item: itemToMove,
                from: droppedItemIndex,
                to: newIndex
              });
            });
    
            removeClass(droppingClassName);
            removeClass(droppingBeforeClassName);
            removeClass(droppingAfterClassName);
    
            element.off('drop', dropHandler);
          };
    
          element.on('dragenter', function() {
            if (element.hasClass(draggingClassName)) {
              return;
            }
    
            element.addClass(droppingClassName);
    
            element.on('dragover', dragOverHandler);
            element.on('drop', dropHandler);
          });
    
          element.on('dragleave', function(event) {
            if (event.target != element) {
              return;
            }
    
            removeClass(droppingClassName);
            removeClass(droppingBeforeClassName);
            removeClass(droppingAfterClassName);
    
            element.off('dragover', dragOverHandler);
            element.off('drop', dropHandler);
          });
        }
      };
    }]);
    
    uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
      return {
        restrict: 'A',
        require: 'uiSelect',
        link: function (scope, element, attrs, $select) {
          $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
    
          scope.$watch('$select.open', function (isOpen, previousState) {
            if (isOpen !== previousState) {
              $timeout(function () {
                $select.onOpenCloseCallback(scope, {
                  isOpen: isOpen
                });
              });
            }
          });
        }
      };
    }]);
    
    /**
     * Parses "repeat" attribute.
     *
     * Taken from AngularJS ngRepeat source code
     * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
     *
     * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
     * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
     */
    
    uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
      var self = this;
    
      /**
       * Example:
       * expression = "address in addresses | filter: {street: $select.search} track by $index"
       * itemName = "address",
       * source = "addresses | filter: {street: $select.search}",
       * trackByExp = "$index",
       */
      self.parse = function(expression) {
    
    
        var match;
        //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
        // If an array is used as collection
    
        // if (isObjectCollection){
        // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
        match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
    
        // 1 Alias
        // 2 Item
        // 3 Key on (key,value)
        // 4 Value on (key,value)
        // 5 Source expression (including filters)
        // 6 Track by
    
        if (!match) {
          throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
                  expression);
        }
        
        var source = match[5], 
            filters = '';
    
        // When using (key,value) ui-select requires filters to be extracted, since the object
        // is converted to an array for $select.items 
        // (in which case the filters need to be reapplied)
        if (match[3]) {
          // Remove any enclosing parenthesis
          source = match[5].replace(/(^\()|(\)$)/g, '');
          // match all after | but not after ||
          var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
          if(filterMatch && filterMatch[1].trim()) {
            filters = filterMatch[1];
            source = source.replace(filters, '');
          }      
        }
    
        return {
          itemName: match[4] || match[2], // (lhs) Left-hand side,
          keyName: match[3], //for (key, value) syntax
          source: $parse(source),
          filters: filters,
          trackByExp: match[6],
          modelMapper: $parse(match[1] || match[4] || match[2]),
          repeatExpression: function (grouped) {
            var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
            if (this.trackByExp) {
              expression += ' track by ' + this.trackByExp;
            }
            return expression;
          } 
        };
    
      };
    
      self.getGroupNgRepeatExpression = function() {
        return '$group in $select.groups track by $group.name';
      };
    
    }]);
    
    }());
    angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
    $templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
    $templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
    $templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
    $templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
    $templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
    $templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
    $templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
    $templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
    $templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
    $templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
    $templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
    $templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
    $templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
    $templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
    $templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
    $templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
    $templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);
(function() {
    var MutationObserver, Util, WeakMap, getComputedStyle, getComputedStyleRX,
      bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
      indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  
    Util = (function() {
      function Util() {}
  
      Util.prototype.extend = function(custom, defaults) {
        var key, value;
        for (key in defaults) {
          value = defaults[key];
          if (custom[key] == null) {
            custom[key] = value;
          }
        }
        return custom;
      };
  
      Util.prototype.isMobile = function(agent) {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent);
      };
  
      Util.prototype.createEvent = function(event, bubble, cancel, detail) {
        var customEvent;
        if (bubble == null) {
          bubble = false;
        }
        if (cancel == null) {
          cancel = false;
        }
        if (detail == null) {
          detail = null;
        }
        if (document.createEvent != null) {
          customEvent = document.createEvent('CustomEvent');
          customEvent.initCustomEvent(event, bubble, cancel, detail);
        } else if (document.createEventObject != null) {
          customEvent = document.createEventObject();
          customEvent.eventType = event;
        } else {
          customEvent.eventName = event;
        }
        return customEvent;
      };
  
      Util.prototype.emitEvent = function(elem, event) {
        if (elem.dispatchEvent != null) {
          return elem.dispatchEvent(event);
        } else if (event in (elem != null)) {
          return elem[event]();
        } else if (("on" + event) in (elem != null)) {
          return elem["on" + event]();
        }
      };
  
      Util.prototype.addEvent = function(elem, event, fn) {
        if (elem.addEventListener != null) {
          return elem.addEventListener(event, fn, false);
        } else if (elem.attachEvent != null) {
          return elem.attachEvent("on" + event, fn);
        } else {
          return elem[event] = fn;
        }
      };
  
      Util.prototype.removeEvent = function(elem, event, fn) {
        if (elem.removeEventListener != null) {
          return elem.removeEventListener(event, fn, false);
        } else if (elem.detachEvent != null) {
          return elem.detachEvent("on" + event, fn);
        } else {
          return delete elem[event];
        }
      };
  
      Util.prototype.innerHeight = function() {
        if ('innerHeight' in window) {
          return window.innerHeight;
        } else {
          return document.documentElement.clientHeight;
        }
      };
  
      return Util;
  
    })();
  
    WeakMap = this.WeakMap || this.MozWeakMap || (WeakMap = (function() {
      function WeakMap() {
        this.keys = [];
        this.values = [];
      }
  
      WeakMap.prototype.get = function(key) {
        var i, item, j, len, ref;
        ref = this.keys;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          item = ref[i];
          if (item === key) {
            return this.values[i];
          }
        }
      };
  
      WeakMap.prototype.set = function(key, value) {
        var i, item, j, len, ref;
        ref = this.keys;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          item = ref[i];
          if (item === key) {
            this.values[i] = value;
            return;
          }
        }
        this.keys.push(key);
        return this.values.push(value);
      };
  
      return WeakMap;
  
    })());
  
    MutationObserver = this.MutationObserver || this.WebkitMutationObserver || this.MozMutationObserver || (MutationObserver = (function() {
      function MutationObserver() {
        if (typeof console !== "undefined" && console !== null) {
          console.warn('MutationObserver is not supported by your browser.');
        }
        if (typeof console !== "undefined" && console !== null) {
          console.warn('WOW.js cannot detect dom mutations, please call .sync() after loading new content.');
        }
      }
  
      MutationObserver.notSupported = true;
  
      MutationObserver.prototype.observe = function() {};
  
      return MutationObserver;
  
    })());
  
    getComputedStyle = this.getComputedStyle || function(el, pseudo) {
      this.getPropertyValue = function(prop) {
        var ref;
        if (prop === 'float') {
          prop = 'styleFloat';
        }
        if (getComputedStyleRX.test(prop)) {
          prop.replace(getComputedStyleRX, function(_, _char) {
            return _char.toUpperCase();
          });
        }
        return ((ref = el.currentStyle) != null ? ref[prop] : void 0) || null;
      };
      return this;
    };
  
    getComputedStyleRX = /(\-([a-z]){1})/g;
  
    this.WOW = (function() {
      WOW.prototype.defaults = {
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
        callback: null,
        scrollContainer: null
      };
  
      function WOW(options) {
        if (options == null) {
          options = {};
        }
        this.scrollCallback = bind(this.scrollCallback, this);
        this.scrollHandler = bind(this.scrollHandler, this);
        this.resetAnimation = bind(this.resetAnimation, this);
        this.start = bind(this.start, this);
        this.scrolled = true;
        this.config = this.util().extend(options, this.defaults);
        if (options.scrollContainer != null) {
          this.config.scrollContainer = document.querySelector(options.scrollContainer);
        }
        this.animationNameCache = new WeakMap();
        this.wowEvent = this.util().createEvent(this.config.boxClass);
      }
  
      WOW.prototype.init = function() {
        var ref;
        this.element = window.document.documentElement;
        if ((ref = document.readyState) === "interactive" || ref === "complete") {
          this.start();
        } else {
          this.util().addEvent(document, 'DOMContentLoaded', this.start);
        }
        return this.finished = [];
      };
  
      WOW.prototype.start = function() {
        var box, j, len, ref;
        this.stopped = false;
        this.boxes = (function() {
          var j, len, ref, results;
          ref = this.element.querySelectorAll("." + this.config.boxClass);
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            box = ref[j];
            results.push(box);
          }
          return results;
        }).call(this);
        this.all = (function() {
          var j, len, ref, results;
          ref = this.boxes;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            box = ref[j];
            results.push(box);
          }
          return results;
        }).call(this);
        if (this.boxes.length) {
          if (this.disabled()) {
            this.resetStyle();
          } else {
            ref = this.boxes;
            for (j = 0, len = ref.length; j < len; j++) {
              box = ref[j];
              this.applyStyle(box, true);
            }
          }
        }
        if (!this.disabled()) {
          this.util().addEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
          this.util().addEvent(window, 'resize', this.scrollHandler);
          this.interval = setInterval(this.scrollCallback, 50);
        }
        if (this.config.live) {
          return new MutationObserver((function(_this) {
            return function(records) {
              var k, len1, node, record, results;
              results = [];
              for (k = 0, len1 = records.length; k < len1; k++) {
                record = records[k];
                results.push((function() {
                  var l, len2, ref1, results1;
                  ref1 = record.addedNodes || [];
                  results1 = [];
                  for (l = 0, len2 = ref1.length; l < len2; l++) {
                    node = ref1[l];
                    results1.push(this.doSync(node));
                  }
                  return results1;
                }).call(_this));
              }
              return results;
            };
          })(this)).observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      };
  
      WOW.prototype.stop = function() {
        this.stopped = true;
        this.util().removeEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
        this.util().removeEvent(window, 'resize', this.scrollHandler);
        if (this.interval != null) {
          return clearInterval(this.interval);
        }
      };
  
      WOW.prototype.sync = function(element) {
        if (MutationObserver.notSupported) {
          return this.doSync(this.element);
        }
      };
  
      WOW.prototype.doSync = function(element) {
        var box, j, len, ref, results;
        if (element == null) {
          element = this.element;
        }
        if (element.nodeType !== 1) {
          return;
        }
        element = element.parentNode || element;
        ref = element.querySelectorAll("." + this.config.boxClass);
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          box = ref[j];
          if (indexOf.call(this.all, box) < 0) {
            this.boxes.push(box);
            this.all.push(box);
            if (this.stopped || this.disabled()) {
              this.resetStyle();
            } else {
              this.applyStyle(box, true);
            }
            results.push(this.scrolled = true);
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
  
      WOW.prototype.show = function(box) {
        this.applyStyle(box);
        box.className = box.className + " " + this.config.animateClass;
        if (this.config.callback != null) {
          this.config.callback(box);
        }
        this.util().emitEvent(box, this.wowEvent);
        this.util().addEvent(box, 'animationend', this.resetAnimation);
        this.util().addEvent(box, 'oanimationend', this.resetAnimation);
        this.util().addEvent(box, 'webkitAnimationEnd', this.resetAnimation);
        this.util().addEvent(box, 'MSAnimationEnd', this.resetAnimation);
        return box;
      };
  
      WOW.prototype.applyStyle = function(box, hidden) {
        var delay, duration, iteration;
        duration = box.getAttribute('data-wow-duration');
        delay = box.getAttribute('data-wow-delay');
        iteration = box.getAttribute('data-wow-iteration');
        return this.animate((function(_this) {
          return function() {
            return _this.customStyle(box, hidden, duration, delay, iteration);
          };
        })(this));
      };
  
      WOW.prototype.animate = (function() {
        if ('requestAnimationFrame' in window) {
          return function(callback) {
            return window.requestAnimationFrame(callback);
          };
        } else {
          return function(callback) {
            return callback();
          };
        }
      })();
  
      WOW.prototype.resetStyle = function() {
        var box, j, len, ref, results;
        ref = this.boxes;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          box = ref[j];
          results.push(box.style.visibility = 'visible');
        }
        return results;
      };
  
      WOW.prototype.resetAnimation = function(event) {
        var target;
        if (event.type.toLowerCase().indexOf('animationend') >= 0) {
          target = event.target || event.srcElement;
          return target.className = target.className.replace(this.config.animateClass, '').trim();
        }
      };
  
      WOW.prototype.customStyle = function(box, hidden, duration, delay, iteration) {
        if (hidden) {
          this.cacheAnimationName(box);
        }
        box.style.visibility = hidden ? 'hidden' : 'visible';
        if (duration) {
          this.vendorSet(box.style, {
            animationDuration: duration
          });
        }
        if (delay) {
          this.vendorSet(box.style, {
            animationDelay: delay
          });
        }
        if (iteration) {
          this.vendorSet(box.style, {
            animationIterationCount: iteration
          });
        }
        this.vendorSet(box.style, {
          animationName: hidden ? 'none' : this.cachedAnimationName(box)
        });
        return box;
      };
  
      WOW.prototype.vendors = ["moz", "webkit"];
  
      WOW.prototype.vendorSet = function(elem, properties) {
        var name, results, value, vendor;
        results = [];
        for (name in properties) {
          value = properties[name];
          elem["" + name] = value;
          results.push((function() {
            var j, len, ref, results1;
            ref = this.vendors;
            results1 = [];
            for (j = 0, len = ref.length; j < len; j++) {
              vendor = ref[j];
              results1.push(elem["" + vendor + (name.charAt(0).toUpperCase()) + (name.substr(1))] = value);
            }
            return results1;
          }).call(this));
        }
        return results;
      };
  
      WOW.prototype.vendorCSS = function(elem, property) {
        var j, len, ref, result, style, vendor;
        style = getComputedStyle(elem);
        result = style.getPropertyCSSValue(property);
        ref = this.vendors;
        for (j = 0, len = ref.length; j < len; j++) {
          vendor = ref[j];
          result = result || style.getPropertyCSSValue("-" + vendor + "-" + property);
        }
        return result;
      };
  
      WOW.prototype.animationName = function(box) {
        var animationName, error;
        try {
          animationName = this.vendorCSS(box, 'animation-name').cssText;
        } catch (error) {
          animationName = getComputedStyle(box).getPropertyValue('animation-name');
        }
        if (animationName === 'none') {
          return '';
        } else {
          return animationName;
        }
      };
  
      WOW.prototype.cacheAnimationName = function(box) {
        return this.animationNameCache.set(box, this.animationName(box));
      };
  
      WOW.prototype.cachedAnimationName = function(box) {
        return this.animationNameCache.get(box);
      };
  
      WOW.prototype.scrollHandler = function() {
        return this.scrolled = true;
      };
  
      WOW.prototype.scrollCallback = function() {
        var box;
        if (this.scrolled) {
          this.scrolled = false;
          this.boxes = (function() {
            var j, len, ref, results;
            ref = this.boxes;
            results = [];
            for (j = 0, len = ref.length; j < len; j++) {
              box = ref[j];
              if (!(box)) {
                continue;
              }
              if (this.isVisible(box)) {
                this.show(box);
                continue;
              }
              results.push(box);
            }
            return results;
          }).call(this);
          if (!(this.boxes.length || this.config.live)) {
            return this.stop();
          }
        }
      };
  
      WOW.prototype.offsetTop = function(element) {
        var top;
        while (element.offsetTop === void 0) {
          element = element.parentNode;
        }
        top = element.offsetTop;
        while (element = element.offsetParent) {
          top += element.offsetTop;
        }
        return top;
      };
  
      WOW.prototype.isVisible = function(box) {
        var bottom, offset, top, viewBottom, viewTop;
        offset = box.getAttribute('data-wow-offset') || this.config.offset;
        viewTop = (this.config.scrollContainer && this.config.scrollContainer.scrollTop) || window.pageYOffset;
        viewBottom = viewTop + Math.min(this.element.clientHeight, this.util().innerHeight()) - offset;
        top = this.offsetTop(box);
        bottom = top + box.clientHeight;
        return top <= viewBottom && bottom >= viewTop;
      };
  
      WOW.prototype.util = function() {
        return this._util != null ? this._util : this._util = new Util();
      };
  
      WOW.prototype.disabled = function() {
        return !this.config.mobile && this.util().isMobile(navigator.userAgent);
      };
  
      return WOW;
  
    })();
  
  }).call(this);
  
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.AOS=t()}(this,function(){"use strict";var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},t="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,r=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof e&&e&&e.Object===Object&&e,d="object"==typeof self&&self&&self.Object===Object&&self,l=u||d||Function("return this")(),f=Object.prototype.toString,m=Math.max,p=Math.min,b=function(){return l.Date.now()};function v(e,n,o){var i,a,r,c,s,u,d=0,l=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError(t);function y(t){var n=i,o=a;return i=a=void 0,d=t,c=e.apply(o,n)}function h(e){var t=e-u;return void 0===u||t>=n||t<0||f&&e-d>=r}function k(){var e=b();if(h(e))return x(e);s=setTimeout(k,function(e){var t=n-(e-u);return f?p(t,r-(e-d)):t}(e))}function x(e){return s=void 0,v&&i?y(e):(i=a=void 0,c)}function O(){var e=b(),t=h(e);if(i=arguments,a=this,u=e,t){if(void 0===s)return function(e){return d=e,s=setTimeout(k,n),l?y(e):c}(u);if(f)return s=setTimeout(k,n),y(u)}return void 0===s&&(s=setTimeout(k,n)),c}return n=w(n)||0,g(o)&&(l=!!o.leading,r=(f="maxWait"in o)?m(w(o.maxWait)||0,n):r,v="trailing"in o?!!o.trailing:v),O.cancel=function(){void 0!==s&&clearTimeout(s),d=0,i=u=a=s=void 0},O.flush=function(){return void 0===s?c:x(b())},O}function g(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&f.call(e)==o}(e))return n;if(g(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=g(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var u=r.test(e);return u||c.test(e)?s(e.slice(2),u?2:8):a.test(e)?n:+e}var y=function(e,n,o){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(t);return g(o)&&(i="leading"in o?!!o.leading:i,a="trailing"in o?!!o.trailing:a),v(e,n,{leading:i,maxWait:n,trailing:a})},h="Expected a function",k=NaN,x="[object Symbol]",O=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,E=/^0b[01]+$/i,N=/^0o[0-7]+$/i,z=parseInt,C="object"==typeof e&&e&&e.Object===Object&&e,A="object"==typeof self&&self&&self.Object===Object&&self,q=C||A||Function("return this")(),L=Object.prototype.toString,T=Math.max,M=Math.min,S=function(){return q.Date.now()};function D(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function H(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&L.call(e)==x}(e))return k;if(D(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=D(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(O,"");var n=E.test(e);return n||N.test(e)?z(e.slice(2),n?2:8):j.test(e)?k:+e}var $=function(e,t,n){var o,i,a,r,c,s,u=0,d=!1,l=!1,f=!0;if("function"!=typeof e)throw new TypeError(h);function m(t){var n=o,a=i;return o=i=void 0,u=t,r=e.apply(a,n)}function p(e){var n=e-s;return void 0===s||n>=t||n<0||l&&e-u>=a}function b(){var e=S();if(p(e))return v(e);c=setTimeout(b,function(e){var n=t-(e-s);return l?M(n,a-(e-u)):n}(e))}function v(e){return c=void 0,f&&o?m(e):(o=i=void 0,r)}function g(){var e=S(),n=p(e);if(o=arguments,i=this,s=e,n){if(void 0===c)return function(e){return u=e,c=setTimeout(b,t),d?m(e):r}(s);if(l)return c=setTimeout(b,t),m(s)}return void 0===c&&(c=setTimeout(b,t)),r}return t=H(t)||0,D(n)&&(d=!!n.leading,a=(l="maxWait"in n)?T(H(n.maxWait)||0,t):a,f="trailing"in n?!!n.trailing:f),g.cancel=function(){void 0!==c&&clearTimeout(c),u=0,o=s=i=c=void 0},g.flush=function(){return void 0===c?r:v(S())},g},W=function(){};function P(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes);if(function e(t){var n=void 0,o=void 0;for(n=0;n<t.length;n+=1){if((o=t[n]).dataset&&o.dataset.aos)return!0;if(o.children&&e(o.children))return!0}return!1}(t.concat(n)))return W()})}function Y(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var _={isSupported:function(){return!!Y()},ready:function(e,t){var n=window.document,o=new(Y())(P);W=t,o.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},B=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},F=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},K=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,G=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,J=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,Q=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function R(){return navigator.userAgent||navigator.vendor||window.opera||""}var U=new(function(){function e(){B(this,e)}return F(e,[{key:"phone",value:function(){var e=R();return!(!K.test(e)&&!G.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=R();return!(!J.test(e)&&!Q.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),e}()),V=function(e,t){var n=void 0;return U.ie11()?(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):n=new CustomEvent(e,{detail:t}),document.dispatchEvent(n)},X=function(e){return e.forEach(function(e,t){return function(e,t){var n=e.options,o=e.position,i=e.node,a=(e.data,function(){e.animated&&(function(e,t){t&&t.forEach(function(t){return e.classList.remove(t)})}(i,n.animatedClassNames),V("aos:out",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!1)});n.mirror&&t>=o.out&&!n.once?a():t>=o.in?e.animated||(function(e,t){t&&t.forEach(function(t){return e.classList.add(t)})}(i,n.animatedClassNames),V("aos:in",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!0):e.animated&&!n.once&&a()}(e,window.pageYOffset)})},Z=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}},ee=function(e,t,n){var o=e.getAttribute("data-aos-"+t);if(void 0!==o){if("true"===o)return!0;if("false"===o)return!1}return o||n},te=function(e,t){return e.forEach(function(e,n){var o=ee(e.node,"mirror",t.mirror),i=ee(e.node,"once",t.once),a=ee(e.node,"id"),r=t.useClassNames&&e.node.getAttribute("data-aos"),c=[t.animatedClassName].concat(r?r.split(" "):[]).filter(function(e){return"string"==typeof e});t.initClassName&&e.node.classList.add(t.initClassName),e.position={in:function(e,t,n){var o=window.innerHeight,i=ee(e,"anchor"),a=ee(e,"anchor-placement"),r=Number(ee(e,"offset",a?0:t)),c=a||n,s=e;i&&document.querySelectorAll(i)&&(s=document.querySelectorAll(i)[0]);var u=Z(s).top-o;switch(c){case"top-bottom":break;case"center-bottom":u+=s.offsetHeight/2;break;case"bottom-bottom":u+=s.offsetHeight;break;case"top-center":u+=o/2;break;case"center-center":u+=o/2+s.offsetHeight/2;break;case"bottom-center":u+=o/2+s.offsetHeight;break;case"top-top":u+=o;break;case"bottom-top":u+=o+s.offsetHeight;break;case"center-top":u+=o+s.offsetHeight/2}return u+r}(e.node,t.offset,t.anchorPlacement),out:o&&function(e,t){window.innerHeight;var n=ee(e,"anchor"),o=ee(e,"offset",t),i=e;return n&&document.querySelectorAll(n)&&(i=document.querySelectorAll(n)[0]),Z(i).top+i.offsetHeight-o}(e.node,t.offset)},e.options={once:i,mirror:o,animatedClassNames:c,id:a}}),e},ne=function(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})},oe=[],ie=!1,ae={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){return document.all&&!window.atob},ce=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(ie=!0),ie&&(oe=te(oe,ae),X(oe),window.addEventListener("scroll",y(function(){X(oe,ae.once)},ae.throttleDelay)))},se=function(){if(oe=ne(),de(ae.disable)||re())return ue();ce()},ue=function(){oe.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),ae.initClassName&&e.node.classList.remove(ae.initClassName),ae.animatedClassName&&e.node.classList.remove(ae.animatedClassName)})},de=function(e){return!0===e||"mobile"===e&&U.mobile()||"phone"===e&&U.phone()||"tablet"===e&&U.tablet()||"function"==typeof e&&!0===e()};return{init:function(e){return ae=I(ae,e),oe=ne(),ae.disableMutationObserver||_.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),ae.disableMutationObserver=!0),ae.disableMutationObserver||_.ready("[data-aos]",se),de(ae.disable)||re()?ue():(document.querySelector("body").setAttribute("data-aos-easing",ae.easing),document.querySelector("body").setAttribute("data-aos-duration",ae.duration),document.querySelector("body").setAttribute("data-aos-delay",ae.delay),-1===["DOMContentLoaded","load"].indexOf(ae.startEvent)?document.addEventListener(ae.startEvent,function(){ce(!0)}):window.addEventListener("load",function(){ce(!0)}),"DOMContentLoaded"===ae.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1&&ce(!0),window.addEventListener("resize",$(ce,ae.debounceDelay,!0)),window.addEventListener("orientationchange",$(ce,ae.debounceDelay,!0)),oe)},refresh:ce,refreshHard:se}});

// Generated by CoffeeScript 1.7.1
(function() {
  var MODULE_NAME, SLIDER_TAG, angularize, contain, events, gap, halfWidth, hide, module, offset, offsetLeft, pixelize, qualifiedDirectiveDefinition, roundStep, show, sliderDirective, width;

  MODULE_NAME = 'ui.slider';

  SLIDER_TAG = 'slider';

  angularize = function(element) {
    return angular.element(element);
  };

  pixelize = function(position) {
    return "" + position + "px";
  };

  hide = function(element) {
    return element.css({
      opacity: 0
    });
  };

  show = function(element) {
    return element.css({
      opacity: 1
    });
  };

  offset = function(element, position) {
    return element.css({
      left: position
    });
  };

  halfWidth = function(element) {
    return element[0].offsetWidth / 2;
  };

  offsetLeft = function(element) {
    return element[0].offsetLeft;
  };

  width = function(element) {
    return element[0].offsetWidth;
  };

  gap = function(element1, element2) {
    return offsetLeft(element2) - offsetLeft(element1) - width(element1);
  };

  contain = function(value) {
    if (isNaN(value)) {
      return value;
    }
    return Math.min(Math.max(0, value), 100);
  };

  roundStep = function(value, precision, step, floor) {
    var decimals, remainder, roundedValue, steppedValue;
    if (floor == null) {
      floor = 0;
    }
    if (step == null) {
      step = 1 / Math.pow(10, precision);
    }
    remainder = (value - floor) % step;
    steppedValue = remainder > (step / 2) ? value + step - remainder : value - remainder;
    decimals = Math.pow(10, precision);
    roundedValue = steppedValue * decimals / decimals;
    return parseFloat(roundedValue.toFixed(precision));
  };

  events = {
    mouse: {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    touch: {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend'
    }
  };

  sliderDirective = function($timeout) {
    return {
      restrict: 'E',
      scope: {
        floor: '@',
        ceiling: '@',
        values: '=?',
        step: '@',
        highlight: '@',
        precision: '@',
        buffer: '@',
        dragstop: '@',
        ngModel: '=?',
        ngModelLow: '=?',
        ngModelHigh: '=?',
        change: '&'
      },
      template: '<div class="bar"><div class="selection"></div></div>\n<div class="handle low"></div><div class="handle high"></div>\n<div class="bubble limit low">{{ values.length ? values[floor || 0] : floor }}</div>\n<div class="bubble limit high">{{ values.length ? values[ceiling || values.length - 1] : ceiling }}</div>\n<div class="bubble value low">{{ values.length ? values[local.ngModelLow || local.ngModel || 0] : local.ngModelLow || local.ngModel || 0 }}</div>\n<div class="bubble value high">{{ values.length ? values[local.ngModelHigh] : local.ngModelHigh }}</div>',
      compile: function(element, attributes) {
        var high, low, range, watchables;
        range = (attributes.ngModel == null) && (attributes.ngModelLow != null) && (attributes.ngModelHigh != null);
        low = range ? 'ngModelLow' : 'ngModel';
        high = 'ngModelHigh';
        watchables = ['floor', 'ceiling', 'values', low];
        if (range) {
          watchables.push(high);
        }
        return {
          post: function(scope, element, attributes) {
            var bar, barWidth, bound, ceilBub, dimensions, e, flrBub, handleHalfWidth, highBub, lowBub, maxOffset, maxPtr, maxValue, minOffset, minPtr, minValue, ngDocument, offsetRange, selection, updateDOM, upper, valueRange, w, _i, _j, _len, _len1, _ref, _ref1;
            _ref = (function() {
              var _i, _len, _ref, _results;
              _ref = element.children();
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                e = _ref[_i];
                _results.push(angularize(e));
              }
              return _results;
            })(), bar = _ref[0], minPtr = _ref[1], maxPtr = _ref[2], flrBub = _ref[3], ceilBub = _ref[4], lowBub = _ref[5], highBub = _ref[6];
            selection = angularize(bar.children()[0]);
            if (!range) {
              _ref1 = [maxPtr, highBub];
              for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                upper = _ref1[_i];
                upper.remove();
              }
              if (!attributes.highlight) {
                selection.remove();
              }
            }
            scope.local = {};
            scope.local[low] = scope[low];
            scope.local[high] = scope[high];
            bound = false;
            ngDocument = angularize(document);
            handleHalfWidth = barWidth = minOffset = maxOffset = minValue = maxValue = valueRange = offsetRange = void 0;
            dimensions = function() {
              var value, _j, _len1, _ref2;
              if (scope.step == null) {
                scope.step = 1;
              }
              if (scope.floor == null) {
                scope.floor = 0;
              }
              if (scope.precision == null) {
                scope.precision = 0;
              }
              if (!range) {
                scope.ngModelLow = scope.ngModel;
              }
              if ((_ref2 = scope.values) != null ? _ref2.length : void 0) {
                if (scope.ceiling == null) {
                  scope.ceiling = scope.values.length - 1;
                }
              }
              scope.local[low] = scope[low];
              scope.local[high] = scope[high];
              for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
                value = watchables[_j];
                if (typeof value === 'number') {
                  scope[value] = roundStep(parseFloat(scope[value]), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                }
              }
              handleHalfWidth = halfWidth(minPtr);
              barWidth = width(bar);
              minOffset = 0;
              maxOffset = barWidth - width(minPtr);
              minValue = parseFloat(scope.floor);
              maxValue = parseFloat(scope.ceiling);
              valueRange = maxValue - minValue;
              return offsetRange = maxOffset - minOffset;
            };
            updateDOM = function() {
              var bind, percentOffset, percentValue, pixelsToOffset, setBindings, setPointers;
              dimensions();
              percentOffset = function(offset) {
                return contain(((offset - minOffset) / offsetRange) * 100);
              };
              percentValue = function(value) {
                return contain(((value - minValue) / valueRange) * 100);
              };
              pixelsToOffset = function(percent) {
                return pixelize(percent * offsetRange / 100);
              };
              setPointers = function() {
                var newHighValue, newLowValue;
                offset(ceilBub, pixelize(barWidth - width(ceilBub)));
                newLowValue = percentValue(scope.local[low]);
                offset(minPtr, pixelsToOffset(newLowValue));
                offset(lowBub, pixelize(offsetLeft(minPtr) - (halfWidth(lowBub)) + handleHalfWidth));
                offset(selection, pixelize(offsetLeft(minPtr) + handleHalfWidth));
                switch (true) {
                  case range:
                    newHighValue = percentValue(scope.local[high]);
                    offset(maxPtr, pixelsToOffset(newHighValue));
                    offset(highBub, pixelize(offsetLeft(maxPtr) - (halfWidth(highBub)) + handleHalfWidth));
                    return selection.css({
                      width: pixelsToOffset(newHighValue - newLowValue)
                    });
                  case attributes.highlight === 'right':
                    return selection.css({
                      width: pixelsToOffset(110 - newLowValue)
                    });
                  case attributes.highlight === 'left':
                    selection.css({
                      width: pixelsToOffset(newLowValue)
                    });
                    return offset(selection, 0);
                }
              };
              bind = function(handle, bubble, ref, events) {
                var changed, currentRef, onEnd, onMove, onStart;
                currentRef = ref;
                changed = false;
                onEnd = function() {
                  bubble.removeClass('active');
                  handle.removeClass('active');
                  ngDocument.unbind(events.move);
                  ngDocument.unbind(events.end);
                  if (scope.dragstop) {
                    scope[high] = scope.local[high];
                    scope[low] = scope.local[low];
                  }
                  currentRef = ref;
                  scope.$apply();
                  if (changed) {
                    return scope.$eval(scope.change);
                  }
                };
                onMove = function(event) {
                  var eventX, newOffset, newPercent, newValue, _ref2, _ref3, _ref4;
                  eventX = event.clientX || ((_ref2 = event.touches) != null ? _ref2[0].clientX : void 0) || ((_ref3 = event.originalEvent) != null ? (_ref4 = _ref3.changedTouches) != null ? _ref4[0].clientX : void 0 : void 0) || 0;
                  newOffset = eventX - element[0].getBoundingClientRect().left - handleHalfWidth;
                  newOffset = Math.max(Math.min(newOffset, maxOffset), minOffset);
                  newPercent = percentOffset(newOffset);
                  newValue = minValue + (valueRange * newPercent / 100.0);
                  if (range) {
                    switch (currentRef) {
                      case low:
                        if (newValue > scope.local[high]) {
                          currentRef = high;
                          minPtr.removeClass('active');
                          lowBub.removeClass('active');
                          maxPtr.addClass('active');
                          highBub.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.min(newValue, scope.local[high] - scope.buffer);
                        }
                        break;
                      case high:
                        if (newValue < scope.local[low]) {
                          currentRef = low;
                          maxPtr.removeClass('active');
                          highBub.removeClass('active');
                          minPtr.addClass('active');
                          lowBub.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.max(newValue, parseInt(scope.local[low]) + parseInt(scope.buffer));
                        }
                    }
                  }
                  newValue = roundStep(newValue, parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                  changed = scope.dragstop && changed || scope.local[currentRef] !== newValue;
                  scope.local[currentRef] = newValue;
                  scope.$apply();
                  setPointers();
                  if (!scope.dragstop) {
                    scope[currentRef] = newValue;
                    if (changed) {
                      return scope.$eval(scope.change);
                    }
                  }
                };
                onStart = function(event) {
                  dimensions();
                  bubble.addClass('active');
                  handle.addClass('active');
                  setPointers();
                  event.stopPropagation();
                  event.preventDefault();
                  ngDocument.bind(events.move, onMove);
                  return ngDocument.bind(events.end, onEnd);
                };
                return handle.bind(events.start, onStart);
              };
              setBindings = function() {
                var method, _j, _len1, _ref2;
                _ref2 = ['touch', 'mouse'];
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                  method = _ref2[_j];
                  bind(minPtr, lowBub, low, events[method]);
                  bind(maxPtr, highBub, high, events[method]);
                }
                return bound = true;
              };
              if (!bound) {
                setBindings();
              }
              return setPointers();
            };
            $timeout(updateDOM);
            for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
              w = watchables[_j];
              scope.$watch(w, updateDOM, true);
            }
            return window.addEventListener('resize', updateDOM);
          }
        };
      }
    };
  };

  qualifiedDirectiveDefinition = ['$timeout', sliderDirective];

  module = function(window, angular) {
    return angular.module(MODULE_NAME, []).directive(SLIDER_TAG, qualifiedDirectiveDefinition);
  };

  module(window, window.angular);

}).call(this);

$(window).on('load', function() {
$('.carousel[data-type="multi"] .item').each(function(){
    var next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));
    
    for (var i=0;i<1;i++) {
      next=next.next();
      if (!next.length) {
          next = $(this).siblings(':first');
        }
      
      next.children(':first-child').clone().appendTo($(this));
    }
  });
});

var countTo = angular.module('countTo', [])
.directive('countTo', ['$timeout', function ($timeout) {
  return {
    replace: false,
    scope: true,
    link: function (scope, element ,attrs) {

      var e = element[0];
      var num, refreshInterval, duration, steps, step, countTo, value, increment;

      var calculate = function () {
        refreshInterval = 30;
        step = 0;
        scope.timoutId = null;
        countTo = parseInt(attrs.countTo) || 0;
        scope.value = parseInt(attrs.value, 10) || 0;
        duration = (parseFloat(attrs.duration) * 1000) || 0;

        steps = Math.ceil(duration / refreshInterval);
        increment = ((countTo - scope.value) / steps);
        num = scope.value;
      }

      var tick = function () {
        scope.timoutId = $timeout(function () {
          num += increment;
          step++;
          if (step >= steps) {
            $timeout.cancel(scope.timoutId);
            num = countTo;
            e.textContent = countTo;
            angular.element(element).addClass('font-resized')
            e.textContent = countTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          } else if(step >= steps/2) {
            angular.element(element).addClass('font-mid-resized')
            e.textContent = Math.round(num);
            tick();

          } else {
            e.textContent = Math.round(num);
            tick();
          }
        }, refreshInterval);

      }

      var start = function () {
        if (scope.timoutId) {
          $timeout.cancel(scope.timoutId);
        }
        calculate();
        tick();
      }

      // attrs.$observe('endTo', function (val) {
      //
      // )};

      attrs.$observe('countTo', function (val) {
        if (val) {
          start();
        }
      });

      attrs.$observe('value', function (val) {
        start();
      });

      return true;
    }
  }

}]);

/*
CryptoJS v3.0.2
code.google.com/p/crypto-js
(c) 2009-2012 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(h,i){var e={},f=e.lib={},l=f.Base=function(){function a(){}return{extend:function(j){a.prototype=this;var d=new a;j&&d.mixIn(j);d.$super=this;return d},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var d in a)a.hasOwnProperty(d)&&(this[d]=a[d]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.$super.extend(this)}}}(),k=f.WordArray=l.extend({init:function(a,j){a=
this.words=a||[];this.sigBytes=j!=i?j:4*a.length},toString:function(a){return(a||m).stringify(this)},concat:function(a){var j=this.words,d=a.words,c=this.sigBytes,a=a.sigBytes;this.clamp();if(c%4)for(var b=0;b<a;b++)j[c+b>>>2]|=(d[b>>>2]>>>24-8*(b%4)&255)<<24-8*((c+b)%4);else if(65535<d.length)for(b=0;b<a;b+=4)j[c+b>>>2]=d[b>>>2];else j.push.apply(j,d);this.sigBytes+=a;return this},clamp:function(){var a=this.words,b=this.sigBytes;a[b>>>2]&=4294967295<<32-8*(b%4);a.length=h.ceil(b/4)},clone:function(){var a=
l.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var b=[],d=0;d<a;d+=4)b.push(4294967296*h.random()|0);return k.create(b,a)}}),o=e.enc={},m=o.Hex={stringify:function(a){for(var b=a.words,a=a.sigBytes,d=[],c=0;c<a;c++){var e=b[c>>>2]>>>24-8*(c%4)&255;d.push((e>>>4).toString(16));d.push((e&15).toString(16))}return d.join("")},parse:function(a){for(var b=a.length,d=[],c=0;c<b;c+=2)d[c>>>3]|=parseInt(a.substr(c,2),16)<<24-4*(c%8);return k.create(d,b/2)}},q=o.Latin1={stringify:function(a){for(var b=
a.words,a=a.sigBytes,d=[],c=0;c<a;c++)d.push(String.fromCharCode(b[c>>>2]>>>24-8*(c%4)&255));return d.join("")},parse:function(a){for(var b=a.length,d=[],c=0;c<b;c++)d[c>>>2]|=(a.charCodeAt(c)&255)<<24-8*(c%4);return k.create(d,b)}},r=o.Utf8={stringify:function(a){try{return decodeURIComponent(escape(q.stringify(a)))}catch(b){throw Error("Malformed UTF-8 data");}},parse:function(a){return q.parse(unescape(encodeURIComponent(a)))}},b=f.BufferedBlockAlgorithm=l.extend({reset:function(){this._data=k.create();
this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=r.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var b=this._data,d=b.words,c=b.sigBytes,e=this.blockSize,g=c/(4*e),g=a?h.ceil(g):h.max((g|0)-this._minBufferSize,0),a=g*e,c=h.min(4*a,c);if(a){for(var f=0;f<a;f+=e)this._doProcessBlock(d,f);f=d.splice(0,a);b.sigBytes-=c}return k.create(f,c)},clone:function(){var a=l.clone.call(this);a._data=this._data.clone();return a},_minBufferSize:0});f.Hasher=b.extend({init:function(){this.reset()},
reset:function(){b.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);this._doFinalize();return this._hash},clone:function(){var a=b.clone.call(this);a._hash=this._hash.clone();return a},blockSize:16,_createHelper:function(a){return function(b,d){return a.create(d).finalize(b)}},_createHmacHelper:function(a){return function(b,d){return g.HMAC.create(a,d).finalize(b)}}});var g=e.algo={};return e}(Math);
(function(h){var i=CryptoJS,e=i.lib,f=e.WordArray,e=e.Hasher,l=i.algo,k=[],o=[];(function(){function e(a){for(var b=h.sqrt(a),d=2;d<=b;d++)if(!(a%d))return!1;return!0}function f(a){return 4294967296*(a-(a|0))|0}for(var b=2,g=0;64>g;)e(b)&&(8>g&&(k[g]=f(h.pow(b,0.5))),o[g]=f(h.pow(b,1/3)),g++),b++})();var m=[],l=l.SHA256=e.extend({_doReset:function(){this._hash=f.create(k.slice(0))},_doProcessBlock:function(e,f){for(var b=this._hash.words,g=b[0],a=b[1],j=b[2],d=b[3],c=b[4],h=b[5],l=b[6],k=b[7],n=0;64>
n;n++){if(16>n)m[n]=e[f+n]|0;else{var i=m[n-15],p=m[n-2];m[n]=((i<<25|i>>>7)^(i<<14|i>>>18)^i>>>3)+m[n-7]+((p<<15|p>>>17)^(p<<13|p>>>19)^p>>>10)+m[n-16]}i=k+((c<<26|c>>>6)^(c<<21|c>>>11)^(c<<7|c>>>25))+(c&h^~c&l)+o[n]+m[n];p=((g<<30|g>>>2)^(g<<19|g>>>13)^(g<<10|g>>>22))+(g&a^g&j^a&j);k=l;l=h;h=c;c=d+i|0;d=j;j=a;a=g;g=i+p|0}b[0]=b[0]+g|0;b[1]=b[1]+a|0;b[2]=b[2]+j|0;b[3]=b[3]+d|0;b[4]=b[4]+c|0;b[5]=b[5]+h|0;b[6]=b[6]+l|0;b[7]=b[7]+k|0},_doFinalize:function(){var e=this._data,f=e.words,b=8*this._nDataBytes,
g=8*e.sigBytes;f[g>>>5]|=128<<24-g%32;f[(g+64>>>9<<4)+15]=b;e.sigBytes=4*f.length;this._process()}});i.SHA256=e._createHelper(l);i.HmacSHA256=e._createHmacHelper(l)})(Math);
(function(){var h=CryptoJS,i=h.enc.Utf8;h.algo.HMAC=h.lib.Base.extend({init:function(e,f){e=this._hasher=e.create();"string"==typeof f&&(f=i.parse(f));var h=e.blockSize,k=4*h;f.sigBytes>k&&(f=e.finalize(f));for(var o=this._oKey=f.clone(),m=this._iKey=f.clone(),q=o.words,r=m.words,b=0;b<h;b++)q[b]^=1549556828,r[b]^=909522486;o.sigBytes=m.sigBytes=k;this.reset()},reset:function(){var e=this._hasher;e.reset();e.update(this._iKey)},update:function(e){this._hasher.update(e);return this},finalize:function(e){var f=
this._hasher,e=f.finalize(e);f.reset();return f.finalize(this._oKey.clone().concat(e))}})})();

/*
CryptoJS v3.0.2
code.google.com/p/crypto-js
(c) 2009-2012 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
(function(){var h=CryptoJS,i=h.lib.WordArray;h.enc.Base64={stringify:function(b){var e=b.words,f=b.sigBytes,c=this._map;b.clamp();for(var b=[],a=0;a<f;a+=3)for(var d=(e[a>>>2]>>>24-8*(a%4)&255)<<16|(e[a+1>>>2]>>>24-8*((a+1)%4)&255)<<8|e[a+2>>>2]>>>24-8*((a+2)%4)&255,g=0;4>g&&a+0.75*g<f;g++)b.push(c.charAt(d>>>6*(3-g)&63));if(e=c.charAt(64))for(;b.length%4;)b.push(e);return b.join("")},parse:function(b){var b=b.replace(/\s/g,""),e=b.length,f=this._map,c=f.charAt(64);c&&(c=b.indexOf(c),-1!=c&&(e=c));
for(var c=[],a=0,d=0;d<e;d++)if(d%4){var g=f.indexOf(b.charAt(d-1))<<2*(d%4),h=f.indexOf(b.charAt(d))>>>6-2*(d%4);c[a>>>2]|=(g|h)<<24-8*(a%4);a++}return i.create(c,a)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();

/**
 * MathQuill v0.10.1               http://mathquill.com
 * by Han, Jeanine, and Mary  maintainers@mathquill.com
 *
 * This Source Code Form is subject to the terms of the
 * Mozilla Public License, v. 2.0. If a copy of the MPL
 * was not distributed with this file, You can obtain
 * one at http://mozilla.org/MPL/2.0/.
 */
!function(){function t(){}function e(t){var e=t.length-1;return function(){var n=kt.call(arguments,0,e),i=kt.call(arguments,e);return t.apply(this,n.concat([i]))}}function n(t){return e(function(e,n){"function"!=typeof e&&(e=jt(e));var i=function(t){return e.apply(t,[t].concat(n))};return t.call(this,i)})}function i(t){var e=kt.call(arguments,1);return function(){return t.apply(this,e)}}function s(t,e){if(!e)throw new Error("prayer failed: "+t)}function r(t){s("a direction was passed",t===Tt||t===Ct)}function o(t,e,n){s("a parent is always present",t),s("leftward is properly set up",function(){return e?e[Ct]===n&&e.parent===t:t.ends[Tt]===n}()),s("rightward is properly set up",function(){return n?n[Tt]===e&&n.parent===t:t.ends[Ct]===e}())}function a(){window.console&&console.warn('You are using the MathQuill API without specifying an interface version, which will fail in v1.0.0. Easiest fix is to do the following before doing anything else:\n\n    MathQuill = MathQuill.getInterface(1);\n    // now MathQuill.MathField() works like it used to\n\nSee also the "`dev` branch (2014–2015) → v0.10.0 Migration Guide" at\n  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide')}function l(t){return a(),bt(t)}function c(e){function n(t){var e,n;return t&&t.nodeType?(e=_t(t).children(".mq-root-block").attr(xt),n=e&&St.byId[e].controller,n?s[n.KIND_OF_MQ](n):null):null}function i(t,e){var n,i,r;e&&e.handlers&&(e.handlers={fns:e.handlers,APIClasses:s});for(n in e)e.hasOwnProperty(n)&&(i=e[n],r=Ft[n],t[n]=r?r(i):i)}var s,r,o;if(!(e>=g&&b>=e))throw"Only interface versions between "+g+" and "+b+" supported. You specified: "+e;s={},n.L=Tt,n.R=Ct,n.config=function(t){return i(Bt.p,t),this},n.registerEmbed=function(t,e){if(!/^[a-z][a-z0-9]*$/i.test(t))throw"Embed name must start with letter and be only letters and digits";Nt[t]=e},r=s.AbstractMathQuill=Qt($t,function(t){t.init=function(t){this.__controller=t,this.__options=t.options,this.id=t.id,this.data=t.data},t.__mathquillify=function(t){var e,n=this.__controller,i=n.root,s=n.container;n.createTextarea(),e=s.addClass(t).contents().detach(),i.jQ=_t('<span class="mq-root-block"/>').attr(xt,i.id).appendTo(s),this.latex(e.text()),this.revert=function(){return s.empty().unbind(".mathquill").removeClass("mq-editable-field mq-math-mode mq-text-mode").append(e)}},t.config=function(t){return i(this.__options,t),this},t.el=function(){return this.__controller.container[0]},t.text=function(){return this.__controller.exportText()},t.latex=function(t){return arguments.length>0?(this.__controller.renderLatexMath(t),this.__controller.blurred&&this.__controller.cursor.hide().parent.blur(),this):this.__controller.exportLatex()},t.html=function(){return this.__controller.root.jQ.html().replace(/ mathquill-(?:command|block)-id="?\d+"?/g,"").replace(/<span class="?mq-cursor( mq-blink)?"?>.?<\/span>/i,"").replace(/ mq-hasCursor|mq-hasCursor ?/,"").replace(/ class=(""|(?= |>))/g,"")},t.reflow=function(){return this.__controller.root.postOrder("reflow"),this}}),n.prototype=r.prototype,s.EditableField=Qt(r,function(e,n){e.__mathquillify=function(){return n.__mathquillify.apply(this,arguments),this.__controller.editable=!0,this.__controller.delegateMouseEvents(),this.__controller.editablesTextareaEvents(),this},e.focus=function(){return this.__controller.textarea.focus(),this},e.blur=function(){return this.__controller.textarea.blur(),this},e.write=function(t){return this.__controller.writeLatex(t),this.__controller.scrollHoriz(),this.__controller.blurred&&this.__controller.cursor.hide().parent.blur(),this},e.cmd=function(t){var e,n=this.__controller.notify(),i=n.cursor;return/^\\[a-z]+$/i.test(t)?(t=t.slice(1),e=Et[t],e&&(t=e(t),i.selection&&t.replaces(i.replaceSelection()),t.createLeftOf(i.show()),this.__controller.scrollHoriz())):i.parent.write(i,t),n.blurred&&i.hide().parent.blur(),this},e.select=function(){var t=this.__controller;for(t.notify("move").cursor.insAtRightEnd(t.root);t.cursor[Tt];)t.selectLeft();return this},e.clearSelection=function(){return this.__controller.cursor.clearSelection(),this},e.moveToDirEnd=function(t){return this.__controller.notify("move").cursor.insAtDirEnd(t,this.__controller.root),this},e.moveToLeftEnd=function(){return this.moveToDirEnd(Tt)},e.moveToRightEnd=function(){return this.moveToDirEnd(Ct)},e.keystroke=function(e){var n;for(e=e.replace(/^\s+|\s+$/g,"").split(/\s+/),n=0;n<e.length;n+=1)this.__controller.keystroke(e[n],{preventDefault:t});return this},e.typedText=function(t){for(var e=0;e<t.length;e+=1)this.__controller.typedText(t.charAt(e));return this},e.dropEmbedded=function(t,e,n){var i,s=t-_t(window).scrollLeft(),r=e-_t(window).scrollTop(),o=document.elementFromPoint(s,r);this.__controller.seek(_t(o),t,e),i=mt().setOptions(n),i.createLeftOf(this.__controller.cursor)},e.clickAt=function(t,e,n){n=n||document.elementFromPoint(t,e);var i=this.__controller,s=i.root;return wt.contains(s.jQ[0],n)||(n=s.jQ[0]),i.seek(_t(n),t+pageXOffset,e+pageYOffset),i.blurred&&this.focus(),this},e.ignoreNextMousedown=function(t){return this.__controller.cursor.options.ignoreNextMousedown=t,this}}),n.EditableField=function(){throw"wtf don't call me, I'm 'abstract'"},n.EditableField.prototype=s.EditableField.prototype;for(o in Mt)(function(t,i){var r=s[t]=i(s);n[t]=function(i,s){var o,a=n(i);return a instanceof r||!i||!i.nodeType?a:(o=zt(r.RootBlock(),_t(i),Bt()),o.KIND_OF_MQ=t,r(o).__mathquillify(s,e))},n[t].prototype=r.prototype})(o,Mt[o]);return n}function u(t){var e,n="moveOutOf deleteOutOf selectOutOf upOutOf downOutOf".split(" ");for(e=0;e<n.length;e+=1)(function(e){t[e]=function(t){this.controller.handle(e,t)}})(n[e]);t.reflow=function(){this.controller.handle("reflow"),this.controller.handle("edited"),this.controller.handle("edit")}}function h(t,e,n){return Qt(_,{ctrlSeq:t,htmlTemplate:"<"+e+" "+n+">&0</"+e+">"})}function f(t){var e=this.parent,n=t;do{if(n[Ct])return t.insLeftOf(e);n=n.parent.parent}while(n!==e);t.insRightOf(e)}function p(t,e){t.jQadd=function(){e.jQadd.apply(this,arguments),this.delimjQs=this.jQ.children(":first").add(this.jQ.children(":last")),this.contentjQ=this.jQ.children(":eq(1)")},t.reflow=function(){var t=this.contentjQ.outerHeight()/parseFloat(this.contentjQ.css("fontSize"));K(this.delimjQs,yt(1+.2*(t-1),1.2),1.2*t)}}function d(t,e){var e=e||t,n=ft[t],s=ft[e];At[t]=i(ht,Tt,t,n,e,s),At[n]=i(ht,Ct,t,n,e,s)}var m,g,b,v,w,q,x,y,O,k,j,Q,T,C,_,D,S,L,E,A,R,I,z,M,B,F,$,N,P,U,W,H,G,K,Y,X,Z,V,J,tt,et,nt,it,st,rt,ot,at,lt,ct,ut,ht,ft,pt,dt,mt,gt,bt,vt,wt=window.jQuery,qt="mathquill-command-id",xt="mathquill-block-id",yt=Math.min,Ot=Math.max,kt=[].slice,jt=e(function(t,n){return e(function(e,i){return t in e?e[t].apply(e,n.concat(i)):void 0})}),Qt=function(t,e,n){function i(t){return"object"==typeof t}function s(t){return"function"==typeof t}function r(){}return function o(a,l){function c(){var t=new u;return s(t.init)&&t.init.apply(t,arguments),t}function u(){}var h,f,p;return l===n&&(l=a,a=Object),c.Bare=u,h=r[t]=a[t],f=u[t]=c[t]=c.p=new r,f.constructor=c,c.extend=function(t){return o(c,t)},(c.open=function(t){if(p={},s(t)?p=t.call(c,f,h,c,a):i(t)&&(p=t),i(p))for(var n in p)e.call(p,n)&&(f[n]=p[n]);return s(f.init)||(f.init=a),c})(l)}}("prototype",{}.hasOwnProperty),Tt=-1,Ct=1,_t=Qt(wt,function(t){t.insDirOf=function(t,e){return t===Tt?this.insertBefore(e.first()):this.insertAfter(e.last())},t.insAtDirEnd=function(t,e){return t===Tt?this.prependTo(e):this.appendTo(e)}}),Dt=Qt(function(t){t.parent=0,t[Tt]=0,t[Ct]=0,t.init=function(t,e,n){this.parent=t,this[Tt]=e,this[Ct]=n},this.copy=function(t){return Dt(t.parent,t[Tt],t[Ct])}}),St=Qt(function(t){function e(){return i+=1}t[Tt]=0,t[Ct]=0,t.parent=0;var i=0;this.byId={},t.init=function(){this.id=e(),St.byId[this.id]=this,this.ends={},this.ends[Tt]=0,this.ends[Ct]=0},t.dispose=function(){delete St.byId[this.id]},t.toString=function(){return"{{ MathQuill Node #"+this.id+" }}"},t.jQ=_t(),t.jQadd=function(t){return this.jQ=this.jQ.add(t)},t.jQize=function(t){function e(t){var n,i;for(t.getAttribute&&(n=t.getAttribute("mathquill-command-id"),i=t.getAttribute("mathquill-block-id"),n&&St.byId[n].jQadd(t),i&&St.byId[i].jQadd(t)),t=t.firstChild;t;t=t.nextSibling)e(t)}var n;for(t=_t(t||this.html()),n=0;n<t.length;n+=1)e(t[n]);return t},t.createDir=function(t,e){r(t);var n=this;return n.jQize(),n.jQ.insDirOf(t,e.jQ),e[t]=n.adopt(e.parent,e[Tt],e[Ct]),n},t.createLeftOf=function(t){return this.createDir(Tt,t)},t.selectChildren=function(t,e){return It(t,e)},t.bubble=n(function(t){var e,n;for(e=this;e&&(n=t(e),n!==!1);e=e.parent);return this}),t.postOrder=n(function(t){return function e(n){n.eachChild(e),t(n)}(this),this}),t.isEmpty=function(){return 0===this.ends[Tt]&&0===this.ends[Ct]},t.children=function(){return Lt(this.ends[Tt],this.ends[Ct])},t.eachChild=function(){var t=this.children();return t.each.apply(t,arguments),this},t.foldChildren=function(t,e){return this.children().fold(t,e)},t.withDirAdopt=function(t,e,n,i){return Lt(this,this).withDirAdopt(t,e,n,i),this},t.adopt=function(t,e,n){return Lt(this,this).adopt(t,e,n),this},t.disown=function(){return Lt(this,this).disown(),this},t.remove=function(){return this.jQ.remove(),this.postOrder("dispose"),this.disown()}}),Lt=Qt(function(t){t.init=function(t,e,n){if(n===m&&(n=Tt),r(n),s("no half-empty fragments",!t==!e),this.ends={},t){s("withDir is passed to Fragment",t instanceof St),s("oppDir is passed to Fragment",e instanceof St),s("withDir and oppDir have the same parent",t.parent===e.parent),this.ends[n]=t,this.ends[-n]=e;var i=this.fold([],function(t,e){return t.push.apply(t,e.jQ.get()),t});this.jQ=this.jQ.add(i)}},t.jQ=_t(),t.withDirAdopt=function(t,e,n,i){return t===Tt?this.adopt(e,n,i):this.adopt(e,i,n)},t.adopt=function(t,e,n){var i,s,r;return o(t,e,n),i=this,i.disowned=!1,(s=i.ends[Tt])?(r=i.ends[Ct],e||(t.ends[Tt]=s),n?n[Tt]=r:t.ends[Ct]=r,i.ends[Ct][Ct]=n,i.each(function(n){n[Tt]=e,n.parent=t,e&&(e[Ct]=n),e=n}),i):this},t.disown=function(){var t,e,n=this,i=n.ends[Tt];return!i||n.disowned?n:(n.disowned=!0,t=n.ends[Ct],e=i.parent,o(e,i[Tt],i),o(e,t,t[Ct]),i[Tt]?i[Tt][Ct]=t[Ct]:e.ends[Tt]=t[Ct],t[Ct]?t[Ct][Tt]=i[Tt]:e.ends[Ct]=i[Tt],n)},t.remove=function(){return this.jQ.remove(),this.each("postOrder","dispose"),this.disown()},t.each=n(function(t){var e,n=this,i=n.ends[Tt];if(!i)return n;for(;i!==n.ends[Ct][Ct]&&(e=t(i),e!==!1);i=i[Ct]);return n}),t.fold=function(t,e){return this.each(function(n){t=e.call(this,t,n)}),t}}),Et={},At={},Rt=Qt(Dt,function(t){t.init=function(t,e){this.parent=t,this.options=e;var n=this.jQ=this._jQ=_t('<span class="mq-cursor">&#8203;</span>');this.blink=function(){n.toggleClass("mq-blink")},this.upDownCache={}},t.show=function(){return this.jQ=this._jQ.removeClass("mq-blink"),"intervalId"in this?clearInterval(this.intervalId):(this[Ct]?this.selection&&this.selection.ends[Tt][Tt]===this[Tt]?this.jQ.insertBefore(this.selection.jQ):this.jQ.insertBefore(this[Ct].jQ.first()):this.jQ.appendTo(this.parent.jQ),this.parent.focus()),this.intervalId=setInterval(this.blink,500),this},t.hide=function(){return"intervalId"in this&&clearInterval(this.intervalId),delete this.intervalId,this.jQ.detach(),this.jQ=_t(),this},t.withDirInsertAt=function(t,e,n,i){var s=this.parent;this.parent=e,this[t]=n,this[-t]=i,s!==e&&s.blur&&s.blur(this)},t.insDirOf=function(t,e){return r(t),this.jQ.insDirOf(t,e.jQ),this.withDirInsertAt(t,e.parent,e[t],e),this.parent.jQ.addClass("mq-hasCursor"),this},t.insLeftOf=function(t){return this.insDirOf(Tt,t)},t.insRightOf=function(t){return this.insDirOf(Ct,t)},t.insAtDirEnd=function(t,e){return r(t),this.jQ.insAtDirEnd(t,e.jQ),this.withDirInsertAt(t,e,0,e.ends[t]),e.focus(),this},t.insAtLeftEnd=function(t){return this.insAtDirEnd(Tt,t)},t.insAtRightEnd=function(t){return this.insAtDirEnd(Ct,t)},t.jumpUpDown=function(t,e){var n,i,s=this;s.upDownCache[t.id]=Dt.copy(s),n=s.upDownCache[e.id],n?n[Ct]?s.insLeftOf(n[Ct]):s.insAtRightEnd(n.parent):(i=s.offset().left,e.seek(i,s))},t.offset=function(){var t=this,e=t.jQ.removeClass("mq-cursor").offset();return t.jQ.addClass("mq-cursor"),e},t.unwrapGramp=function(){var t=this.parent.parent,e=t.parent,n=t[Ct],i=this,s=t[Tt];if(t.disown().eachChild(function(i){i.isEmpty()||(i.children().adopt(e,s,n).each(function(e){e.jQ.insertBefore(t.jQ.first())}),s=i.ends[Ct])}),!this[Ct])if(this[Tt])this[Ct]=this[Tt][Ct];else for(;!this[Ct];){if(this.parent=this.parent[Ct],!this.parent){this[Ct]=t[Ct],this.parent=e;break}this[Ct]=this.parent.ends[Tt]}this[Ct]?this.insLeftOf(this[Ct]):this.insAtRightEnd(e),t.jQ.remove(),t[Tt].siblingDeleted&&t[Tt].siblingDeleted(i.options,Ct),t[Ct].siblingDeleted&&t[Ct].siblingDeleted(i.options,Tt)},t.startSelection=function(){var t,e=this.anticursor=Dt.copy(this),n=e.ancestors={};for(t=e;t.parent;t=t.parent)n[t.parent.id]=t},t.endSelection=function(){delete this.anticursor},t.select=function(){var t,e,n,i,r,o,a,l=this.anticursor;if(this[Tt]===l[Tt]&&this.parent===l.parent)return!1;for(t=this;t.parent;t=t.parent)if(t.parent.id in l.ancestors){e=t.parent;break}if(s("cursor and anticursor in the same tree",e),n=l.ancestors[e.id],o=Ct,t[Tt]!==n)for(a=t;a;a=a[Ct])if(a[Ct]===n[Ct]){o=Tt,i=t,r=n;break}return o===Ct&&(i=n,r=t),i instanceof Dt&&(i=i[Ct]),r instanceof Dt&&(r=r[Tt]),this.hide().selection=e.selectChildren(i,r),this.insDirOf(o,this.selection.ends[o]),this.selectionChanged(),!0},t.clearSelection=function(){return this.selection&&(this.selection.clear(),delete this.selection,this.selectionChanged()),this},t.deleteSelection=function(){this.selection&&(this[Tt]=this.selection.ends[Tt][Tt],this[Ct]=this.selection.ends[Ct][Ct],this.selection.remove(),this.selectionChanged(),delete this.selection)},t.replaceSelection=function(){var t=this.selection;return t&&(this[Tt]=t.ends[Tt][Tt],this[Ct]=t.ends[Ct][Ct],delete this.selection),t}}),It=Qt(Lt,function(t,e){t.init=function(){e.init.apply(this,arguments),this.jQ=this.jQ.wrapAll('<span class="mq-selection"></span>').parent()},t.adopt=function(){return this.jQ.replaceWith(this.jQ=this.jQ.children()),e.adopt.apply(this,arguments)},t.clear=function(){return this.jQ.replaceWith(this.jQ[0].childNodes),this},t.join=function(t){return this.fold("",function(e,n){return e+n[t]()})}}),zt=Qt(function(t){t.init=function(t,e,n){this.id=t.id,this.data={},this.root=t,this.container=e,this.options=n,t.controller=this,this.cursor=t.cursor=Rt(t,n)},t.handle=function(t,e){var n,i=this.options.handlers;i&&i.fns[t]&&(n=i.APIClasses[this.KIND_OF_MQ](this),e===Tt||e===Ct?i.fns[t](e,n):i.fns[t](n))};var e=[];this.onNotify=function(t){e.push(t)},t.notify=function(){for(var t=0;t<e.length;t+=1)e[t].apply(this.cursor,arguments);return this}}),Mt={},Bt=Qt(),Ft={},$t=Qt(),Nt={};l.prototype=$t.p,l.interfaceVersion=function(t){if(1!==t)throw"Only interface version 1 supported. You specified: "+t;return a=function(){window.console&&console.warn('You called MathQuill.interfaceVersion(1); to specify the interface version, which will fail in v1.0.0. You can fix this easily by doing this before doing anything else:\n\n    MathQuill = MathQuill.getInterface(1);\n    // now MathQuill.MathField() works like it used to\n\nSee also the "`dev` branch (2014–2015) → v0.10.0 Migration Guide" at\n  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide')},a(),l},l.getInterface=c,g=c.MIN=1,b=c.MAX=2,l.noConflict=function(){return window.MathQuill=v,l},v=window.MathQuill,window.MathQuill=l,w=Qt(function(t,e,n){function i(t,e){throw t=t?"'"+t+"'":"EOF","Parse Error: "+e+" at "+t}var r,o,a,l,c,u,h,f,p,d,m,g,b;t.init=function(t){this._=t},t.parse=function(t){function e(t,e){return e}return this.skip(b)._(""+t,e,i)},t.or=function(t){s("or is passed a parser",t instanceof n);var e=this;return n(function(n,i,s){function r(e){return t._(n,i,s)}return e._(n,i,r)})},t.then=function(t){var e=this;return n(function(i,r,o){function a(e,i){var a=t instanceof n?t:t(i);return s("a parser is returned",a instanceof n),a._(e,r,o)}return e._(i,a,o)})},t.many=function(){var t=this;return n(function(e,n,i){function s(t,n){return e=t,o.push(n),!0}function r(){return!1}for(var o=[];t._(e,s,r););return n(e,o)})},t.times=function(t,e){arguments.length<2&&(e=t);var i=this;return n(function(n,s,r){function o(t,e){return h.push(e),n=t,!0}function a(t,e){return c=e,n=t,!1}function l(t,e){return!1}var c,u,h=[],f=!0;for(u=0;t>u;u+=1)if(f=i._(n,o,a),!f)return r(n,c);for(;e>u&&f;u+=1)f=i._(n,o,l);return s(n,h)})},t.result=function(t){return this.then(a(t))},t.atMost=function(t){return this.times(0,t)},t.atLeast=function(t){var e=this;return e.times(t).then(function(t){return e.many().map(function(e){return t.concat(e)})})},t.map=function(t){return this.then(function(e){return a(t(e))})},t.skip=function(t){return this.then(function(e){return t.result(e)})},r=this.string=function(t){var e=t.length,i="expected '"+t+"'";return n(function(n,s,r){var o=n.slice(0,e);return o===t?s(n.slice(e),o):r(n,i)})},o=this.regex=function(t){s("regexp parser is anchored","^"===t.toString().charAt(1));var e="expected "+t;return n(function(n,i,s){var r,o=t.exec(n);return o?(r=o[0],i(n.slice(r.length),r)):s(n,e)})},a=n.succeed=function(t){return n(function(e,n){return n(e,t)})},l=n.fail=function(t){return n(function(e,n,i){return i(e,t)})},c=n.letter=o(/^[a-z]/i),u=n.letters=o(/^[a-z]*/i),h=n.digit=o(/^[0-9]/),f=n.digits=o(/^[0-9]*/),p=n.whitespace=o(/^\s+/),d=n.optWhitespace=o(/^\s*/),m=n.any=n(function(t,e,n){return t?e(t.slice(1),t.charAt(0)):n(t,"expected any character")}),g=n.all=n(function(t,e,n){return e("",t)}),b=n.eof=n(function(t,e,n){return t?n(t,"expected EOF"):e(t,t)})}),q=function(){function e(t){var e,i=t.which||t.keyCode,s=n[i],r=[];return t.ctrlKey&&r.push("Ctrl"),t.originalEvent&&t.originalEvent.metaKey&&r.push("Meta"),t.altKey&&r.push("Alt"),t.shiftKey&&r.push("Shift"),e=s||String.fromCharCode(i),r.length||s?(r.push(e),r.join("-")):e}var n={8:"Backspace",9:"Tab",10:"Enter",13:"Enter",16:"Shift",17:"Control",18:"Alt",20:"CapsLock",27:"Esc",32:"Spacebar",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",45:"Insert",46:"Del",144:"NumLock"};return function(n,i){function s(t){q=t,clearTimeout(d),d=setTimeout(t)}function r(e){q(),q=t,clearTimeout(d),v.val(e),e&&v[0].select&&v[0].select(),m=!!e}function o(){var t=v[0];return"selectionStart"in t?t.selectionStart!==t.selectionEnd:!1}function a(){i.keystroke(e(g),g)}function l(e){g=e,b=null,m&&s(function(e){e&&"focusout"===e.type||!v[0].select||v[0].select(),q=t,clearTimeout(d)}),a()}function c(t){g&&b&&a(),b=t,s(u)}function u(){if(!o()){var t=v.val();1===t.length?(v.val(""),i.typedText(t)):t&&v[0].select&&v[0].select()}}function h(){g=b=null}function f(t){v.focus(),s(p)}function p(){var t=v.val();v.val(""),t&&i.paste(t)}var d,m,g=null,b=null,v=wt(n),w=wt(i.container||v),q=t;return w.bind("keydown keypress input keyup focusout paste",function(t){q(t)}),m=!1,w.bind({keydown:l,keypress:c,focusout:h,paste:f}),{select:r}}}(),zt.open(function(t,e){t.exportText=function(){return this.root.foldChildren("",function(t,e){return t+e.text()})}}),zt.open(function(t){t.focusBlurEvents=function(){function t(){clearTimeout(n),r.selection&&r.selection.jQ.addClass("mq-blur"),e()}function e(){r.hide().parent.blur(),i.container.removeClass("mq-focused"),_t(window).off("blur",t)}var n,i=this,s=i.root,r=i.cursor;i.textarea.focus(function(){i.blurred=!1,clearTimeout(n),i.container.addClass("mq-focused"),r.parent||r.insAtRightEnd(s),r.selection?(r.selection.jQ.removeClass("mq-blur"),i.selectionChanged()):r.show()}).blur(function(){i.blurred=!0,n=setTimeout(function(){s.postOrder("intentionalBlur"),r.clearSelection().endSelection(),e()}),_t(window).on("blur",t)}),i.blurred=!0,r.hide().parent.blur()}}),zt.open(function(t){t.keystroke=function(t,e){this.cursor.parent.keystroke(t,e,this)}}),St.open(function(t){t.keystroke=function(t,e,n){var i=n.cursor;switch(t){case"Ctrl-Shift-Backspace":case"Ctrl-Backspace":n.ctrlDeleteDir(Tt);break;case"Shift-Backspace":case"Backspace":n.backspace();break;case"Esc":case"Tab":return void n.escapeDir(Ct,t,e);case"Shift-Tab":case"Shift-Esc":return void n.escapeDir(Tt,t,e);case"End":n.notify("move").cursor.insAtRightEnd(i.parent);break;case"Ctrl-End":n.notify("move").cursor.insAtRightEnd(n.root);break;case"Shift-End":for(;i[Ct];)n.selectRight();break;case"Ctrl-Shift-End":for(;i[Ct]||i.parent!==n.root;)n.selectRight();break;case"Home":n.notify("move").cursor.insAtLeftEnd(i.parent);break;case"Ctrl-Home":n.notify("move").cursor.insAtLeftEnd(n.root);break;case"Shift-Home":for(;i[Tt];)n.selectLeft();break;case"Ctrl-Shift-Home":for(;i[Tt]||i.parent!==n.root;)n.selectLeft();break;case"Left":n.moveLeft();break;case"Shift-Left":n.selectLeft();break;case"Ctrl-Left":break;case"Right":n.moveRight();break;case"Shift-Right":n.selectRight();break;case"Ctrl-Right":break;case"Up":n.moveUp();break;case"Down":n.moveDown();break;case"Shift-Up":if(i[Tt])for(;i[Tt];)n.selectLeft();else n.selectLeft();case"Shift-Down":if(i[Ct])for(;i[Ct];)n.selectRight();else n.selectRight();case"Ctrl-Up":break;case"Ctrl-Down":break;case"Ctrl-Shift-Del":case"Ctrl-Del":n.ctrlDeleteDir(Ct);break;case"Shift-Del":case"Del":n.deleteForward();break;case"Meta-A":case"Ctrl-A":for(n.notify("move").cursor.insAtRightEnd(n.root);i[Tt];)n.selectLeft();break;default:return}e.preventDefault(),n.scrollHoriz()},t.moveOutOf=t.moveTowards=t.deleteOutOf=t.deleteTowards=t.unselectInto=t.selectOutOf=t.selectTowards=function(){s("overridden or never called on this node")}}),zt.open(function(t){function e(t,e){var n=t.notify("upDown").cursor,i=e+"Into",s=e+"OutOf";return n[Ct][i]?n.insAtLeftEnd(n[Ct][i]):n[Tt][i]?n.insAtRightEnd(n[Tt][i]):n.parent.bubble(function(t){var e=t[s];return e&&("function"==typeof e&&(e=t[s](n)),e instanceof St&&n.jumpUpDown(t,e),e!==!0)?!1:void 0}),t}this.onNotify(function(t){"move"!==t&&"upDown"!==t||this.show().clearSelection()}),t.escapeDir=function(t,e,n){r(t);var i=this.cursor;return i.parent!==this.root&&n.preventDefault(),i.parent!==this.root?(i.parent.moveOutOf(t,i),this.notify("move")):void 0},Ft.leftRightIntoCmdGoes=function(t){if(t&&"up"!==t&&"down"!==t)throw'"up" or "down" required for leftRightIntoCmdGoes option, got "'+t+'"';return t},t.moveDir=function(t){r(t);var e=this.cursor,n=e.options.leftRightIntoCmdGoes;return e.selection?e.insDirOf(t,e.selection.ends[t]):e[t]?e[t].moveTowards(t,e,n):e.parent.moveOutOf(t,e,n),this.notify("move")},t.moveLeft=function(){return this.moveDir(Tt)},t.moveRight=function(){return this.moveDir(Ct)},t.moveUp=function(){return e(this,"up")},t.moveDown=function(){return e(this,"down")},this.onNotify(function(t){"upDown"!==t&&(this.upDownCache={})}),this.onNotify(function(t){"edit"===t&&this.show().deleteSelection()}),t.deleteDir=function(t){var e,n;return r(t),e=this.cursor,n=e.selection,this.notify("edit"),n||(e[t]?e[t].deleteTowards(t,e):e.parent.deleteOutOf(t,e)),e[Tt].siblingDeleted&&e[Tt].siblingDeleted(e.options,Ct),e[Ct].siblingDeleted&&e[Ct].siblingDeleted(e.options,Tt),e.parent.bubble("reflow"),this},t.ctrlDeleteDir=function(t){r(t);var e=this.cursor;return!e[Tt]||e.selection?ctrlr.deleteDir():(this.notify("edit"),Lt(e.parent.ends[Tt],e[Tt]).remove(),e.insAtDirEnd(Tt,e.parent),e[Tt].siblingDeleted&&e[Tt].siblingDeleted(e.options,Ct),e[Ct].siblingDeleted&&e[Ct].siblingDeleted(e.options,Tt),e.parent.bubble("reflow"),this)},t.backspace=function(){return this.deleteDir(Tt)},t.deleteForward=function(){return this.deleteDir(Ct)},this.onNotify(function(t){"select"!==t&&this.endSelection()}),t.selectDir=function(t){var e,n=this.notify("select").cursor,i=n.selection;r(t),n.anticursor||n.startSelection(),e=n[t],e?i&&i.ends[t]===e&&n.anticursor[-t]!==e?e.unselectInto(t,n):e.selectTowards(t,n):n.parent.selectOutOf(t,n),n.clearSelection(),n.select()||n.show()},t.selectLeft=function(){return this.selectDir(Tt)},t.selectRight=function(){return this.selectDir(Ct)}}),x=function(){function t(t){var e=T();return t.adopt(e,0,0),e}function e(t){var e,n=t[0]||T();for(e=1;e<t.length;e+=1)t[e].children().adopt(n,n.ends[Ct],0);return n}var n=w.string,i=w.regex,s=w.letter,r=w.any,o=w.optWhitespace,a=w.succeed,l=w.fail,c=s.map(function(t){return R(t)}),u=i(/^[^${}\\_^]/).map(function(t){return j(t)}),h=i(/^[^\\a-eg-zA-Z]/).or(n("\\").then(i(/^[a-z]+/i).or(i(/^\s+/).result(" ")).or(r))).then(function(t){var e=Et[t];return e?e(t).parser():l("unknown command: \\"+t)}),f=h.or(c).or(u),p=n("{").then(function(){return m}).skip(n("}")),d=o.then(p.or(f.map(t))),m=d.many().map(e).skip(o),g=n("[").then(d.then(function(t){return"]"!==t.join("latex")?a(t):l()}).many().map(e).skip(o)).skip(n("]")),b=m;return b.block=d,b.optBlock=g,b}(),zt.open(function(t,e){t.exportLatex=function(){return this.root.latex().replace(/(\\[a-z]+) (?![a-z])/gi,"$1")},t.writeLatex=function(t){var e,n=this.notify("edit").cursor,i=w.all,s=w.eof,r=x.skip(s).or(i.result(!1)).parse(t);return r&&!r.isEmpty()&&(r.children().adopt(n.parent,n[Tt],n[Ct]),e=r.jQize(),e.insertBefore(n.jQ),n[Tt]=r.ends[Ct],r.finalizeInsert(n.options,n),r.ends[Ct][Ct].siblingCreated&&r.ends[Ct][Ct].siblingCreated(n.options,Tt),r.ends[Tt][Tt].siblingCreated&&r.ends[Tt][Tt].siblingCreated(n.options,Ct),n.parent.bubble("reflow")),this},t.renderLatexMath=function(t){var e,n,i=this.root,s=this.cursor,r=w.all,o=w.eof,a=x.skip(o).or(r.result(!1)).parse(t);i.eachChild("postOrder","dispose"),i.ends[Tt]=i.ends[Ct]=0,a&&a.children().adopt(i,0,0),e=i.jQ,a?(n=a.join("html"),e.html(n),i.jQize(e.children()),i.finalizeInsert(s.options)):e.empty(),delete s.selection,s.insAtRightEnd(i)},t.renderLatexText=function(t){var e,n,i,s,r,o,a,l,c,u,h=this.root,f=this.cursor;if(h.jQ.children().slice(1).remove(),h.eachChild("postOrder","dispose"),h.ends[Tt]=h.ends[Ct]=0,delete f.selection,f.show().insAtRightEnd(h),e=w.regex,n=w.string,i=w.eof,s=w.all,r=n("$").then(x).skip(n("$").or(i)).map(function(t){var e,n=S(f);return n.createBlocks(),e=n.ends[Tt],t.children().adopt(e,0,0),n}),o=n("\\$").result("$"),a=o.or(e(/^[^$]/)).map(j),l=r.or(a).many(),c=l.skip(i).or(s.result(!1)).parse(t)){for(u=0;u<c.length;u+=1)c[u].adopt(h,h.ends[Ct],0);h.jQize().appendTo(h.jQ),h.finalizeInsert(f.options)}}}),zt.open(function(e){Bt.p.ignoreNextMousedown=t,e.delegateMouseEvents=function(){var e=this.root.jQ;this.container.bind("mousedown.mathquill",function(n){function i(t){o=_t(t.target)}function s(t){u.anticursor||u.startSelection(),c.seek(o,t.pageX,t.pageY).cursor.select(),o=m}function r(t){u.blink=h,u.selection||(c.editable?u.show():f.detach()),a.unbind("mousemove",i),_t(t.target.ownerDocument).unbind("mousemove",s).unbind("mouseup",r)}var o,a=_t(n.target).closest(".mq-root-block"),l=St.byId[a.attr(xt)||e.attr(xt)],c=l.controller,u=c.cursor,h=u.blink,f=c.textareaSpan,p=c.textarea;n.preventDefault(),n.target.unselectable=!0,u.options.ignoreNextMousedown(n)||(u.options.ignoreNextMousedown=t,c.blurred&&(c.editable||a.prepend(f),p.focus()),u.blink=t,c.seek(_t(n.target),n.pageX,n.pageY).cursor.startSelection(),a.mousemove(i),_t(n.target.ownerDocument).mousemove(s).mouseup(r))})}}),zt.open(function(t){t.seek=function(t,e,n){var i,r,o,a=this.notify("select").cursor;return t&&(i=t.attr(xt)||t.attr(qt),i||(r=t.parent(),i=r.attr(xt)||r.attr(qt))),o=i?St.byId[i]:this.root,s("nodeId is the id of some Node that exists",o),a.clearSelection().show(),o.seek(e,a),this.scrollHoriz(),this}}),zt.open(function(t){t.scrollHoriz=function(){var t,e,n,i,s,r=this.cursor,o=r.selection,a=this.root.jQ[0].getBoundingClientRect();if(o)if(n=o.jQ[0].getBoundingClientRect(),i=n.left-(a.left+20),s=n.right-(a.right-20),o.ends[Tt]===r[Ct])if(0>i)e=i;else{if(!(s>0))return;e=n.left-s<a.left+20?i:s}else if(s>0)e=s;else{if(!(0>i))return;e=n.right-i>a.right-20?s:i}else if(t=r.jQ[0].getBoundingClientRect().left,t>a.right-20)e=t-(a.right-20);else{if(!(t<a.left+20))return;e=t-(a.left+20)}this.root.jQ.stop().animate({scrollLeft:"+="+e},100)}}),zt.open(function(t){Bt.p.substituteTextarea=function(){return _t("<textarea autocapitalize=off autocomplete=off autocorrect=off spellcheck=false x-palm-disable-ste-all=true />")[0]},t.createTextarea=function(){var t,e=this.textareaSpan=_t('<span class="mq-textarea"></span>'),n=this.options.substituteTextarea();if(!n.nodeType)throw"substituteTextarea() must return a DOM element, got "+n;n=this.textarea=_t(n).appendTo(e),t=this,t.cursor.selectionChanged=function(){t.selectionChanged()},t.container.bind("copy",function(){t.setTextareaSelection()})},t.selectionChanged=function(){var t=this;Y(t.container[0]),t.textareaSelectionTimeout===m&&(t.textareaSelectionTimeout=setTimeout(function(){t.setTextareaSelection()}))},t.setTextareaSelection=function(){this.textareaSelectionTimeout=m;var t="";this.cursor.selection&&(t=this.cursor.selection.join("latex"),this.options.statelessClipboard&&(t="$"+t+"$")),this.selectFn(t)},t.staticMathTextareaEvents=function(){function t(){s.detach(),e.blurred=!0}var e=this,n=(e.root,e.cursor),i=e.textarea,s=e.textareaSpan;this.container.prepend('<span class="mq-selectable">$'+e.exportLatex()+"$</span>"),e.blurred=!0,i.bind("cut paste",!1).focus(function(){e.blurred=!1}).blur(function(){n.selection&&n.selection.clear(),setTimeout(t)}),e.selectFn=function(t){i.val(t),t&&i.select()}},t.editablesTextareaEvents=function(){var t=this,e=(t.root,t.cursor),n=t.textarea,i=t.textareaSpan,s=q(n,this);this.selectFn=function(t){s.select(t)},this.container.prepend(i).on("cut",function(n){e.selection&&setTimeout(function(){t.notify("edit"),e.parent.bubble("reflow")})}),this.focusBlurEvents()},t.typedText=function(t){if("\n"===t)return this.handle("enter");var e=this.notify().cursor;e.parent.write(e,t),this.scrollHoriz()},t.paste=function(t){this.options.statelessClipboard&&(t="$"===t.slice(0,1)&&"$"===t.slice(-1)?t.slice(1,-1):"\\text{"+t+"}"),this.writeLatex(t).cursor.show()}}),y=Qt(St,function(t,e){t.finalizeInsert=function(t,e){var n=this;n.postOrder("finalizeTree",t),n.postOrder("contactWeld",e),n.postOrder("blur"),n.postOrder("reflow"),n[Ct].siblingCreated&&n[Ct].siblingCreated(t,Tt),n[Tt].siblingCreated&&n[Tt].siblingCreated(t,Ct),n.bubble("reflow")}}),O=Qt(y,function(t,e){t.init=function(t,n,i){var s=this;e.init.call(s),s.ctrlSeq||(s.ctrlSeq=t),n&&(s.htmlTemplate=n),i&&(s.textTemplate=i)},t.replaces=function(t){t.disown(),this.replacedFragment=t},t.isEmpty=function(){return this.foldChildren(!0,function(t,e){return t&&e.isEmpty()})},t.parser=function(){var t=x.block,e=this;return t.times(e.numBlocks()).map(function(t){e.blocks=t;for(var n=0;n<t.length;n+=1)t[n].adopt(e,e.ends[Ct],0);return e})},t.createLeftOf=function(t){var n=this,i=n.replacedFragment;n.createBlocks(),e.createLeftOf.call(n,t),i&&(i.adopt(n.ends[Tt],0,0),i.jQ.appendTo(n.ends[Tt].jQ)),n.finalizeInsert(t.options),n.placeCursor(t)},t.createBlocks=function(){var t,e,n=this,i=n.numBlocks(),s=n.blocks=Array(i);for(t=0;i>t;t+=1)e=s[t]=T(),e.adopt(n,n.ends[Ct],0)},t.placeCursor=function(t){t.insAtRightEnd(this.foldChildren(this.ends[Tt],function(t,e){return t.isEmpty()?t:e}))},t.moveTowards=function(t,e,n){var i=n&&this[n+"Into"];e.insAtDirEnd(-t,i||this.ends[-t])},t.deleteTowards=function(t,e){this.isEmpty()?e[t]=this.remove()[t]:this.moveTowards(t,e,null)},t.selectTowards=function(t,e){e[-t]=this,e[t]=this[t]},t.selectChildren=function(){return It(this,this)},t.unselectInto=function(t,e){e.insAtDirEnd(-t,e.anticursor.ancestors[this.id])},t.seek=function(t,e){function n(t){var e={};return e[Tt]=t.jQ.offset().left,e[Ct]=e[Tt]+t.jQ.outerWidth(),e}var i,s=this,r=n(s);return t<r[Tt]?e.insLeftOf(s):t>r[Ct]?e.insRightOf(s):(i=r[Tt],void s.eachChild(function(o){var a=n(o);return t<a[Tt]?(t-i<a[Tt]-t?o[Tt]?e.insAtRightEnd(o[Tt]):e.insLeftOf(s):e.insAtLeftEnd(o),!1):t>a[Ct]?void(o[Ct]?i=a[Ct]:r[Ct]-t<t-a[Ct]?e.insRightOf(s):e.insAtRightEnd(o)):(o.seek(t,e),!1)}))},t.numBlocks=function(){var t=this.htmlTemplate.match(/&\d+/g);return t?t.length:0;
},t.html=function(){var t,e,n,i=this,r=i.blocks,o=" mathquill-command-id="+i.id,a=i.htmlTemplate.match(/<[^<>]+>|[^<>]+/g);for(s("no unmatched angle brackets",a.join("")===this.htmlTemplate),t=0,e=a[0];e;t+=1,e=a[t])if("/>"===e.slice(-2))a[t]=e.slice(0,-2)+o+"/>";else if("<"===e.charAt(0)){s("not an unmatched top-level close tag","/"!==e.charAt(1)),a[t]=e.slice(0,-1)+o+">",n=1;do t+=1,e=a[t],s("no missing close tags",e),"</"===e.slice(0,2)?n-=1:"<"===e.charAt(0)&&"/>"!==e.slice(-2)&&(n+=1);while(n>0)}return a.join("").replace(/>&(\d+)/g,function(t,e){return" mathquill-block-id="+r[e].id+">"+r[e].join("html")})},t.latex=function(){return this.foldChildren(this.ctrlSeq,function(t,e){return t+"{"+(e.latex()||" ")+"}"})},t.textTemplate=[""],t.text=function(){var t=this,e=0;return t.foldChildren(t.textTemplate[e],function(n,i){e+=1;var s=i.text();return n&&"("===t.textTemplate[e]&&"("===s[0]&&")"===s.slice(-1)?n+s.slice(1,-1)+t.textTemplate[e]:n+i.text()+(t.textTemplate[e]||"")})}}),k=Qt(O,function(e,n){e.init=function(t,e,i){i||(i=t&&t.length>1?t.slice(1):t),n.init.call(this,t,e,[i])},e.parser=function(){return w.succeed(this)},e.numBlocks=function(){return 0},e.replaces=function(t){t.remove()},e.createBlocks=t,e.moveTowards=function(t,e){e.jQ.insDirOf(t,this.jQ),e[-t]=this,e[t]=this[t]},e.deleteTowards=function(t,e){e[t]=this.remove()[t]},e.seek=function(t,e){t-this.jQ.offset().left<this.jQ.outerWidth()/2?e.insLeftOf(this):e.insRightOf(this)},e.latex=function(){return this.ctrlSeq},e.text=function(){return this.textTemplate},e.placeCursor=t,e.isEmpty=function(){return!0}}),j=Qt(k,function(t,e){t.init=function(t,n){e.init.call(this,t,"<span>"+(n||t)+"</span>")}}),Q=Qt(k,function(t,e){t.init=function(t,n,i){e.init.call(this,t,'<span class="mq-binary-operator">'+n+"</span>",i)}}),T=Qt(y,function(t,e){t.join=function(t){return this.foldChildren("",function(e,n){return e+n[t]()})},t.html=function(){return this.join("html")},t.latex=function(){return this.join("latex")},t.text=function(){return this.ends[Tt]===this.ends[Ct]&&0!==this.ends[Tt]?this.ends[Tt].text():this.join("text")},t.keystroke=function(t,n,i){return!i.options.spaceBehavesLikeTab||"Spacebar"!==t&&"Shift-Spacebar"!==t?e.keystroke.apply(this,arguments):(n.preventDefault(),void i.escapeDir("Shift-Spacebar"===t?Tt:Ct,t,n))},t.moveOutOf=function(t,e,n){var i=n&&this.parent[n+"Into"];!i&&this[t]?e.insAtDirEnd(-t,this[t]):e.insDirOf(t,this.parent)},t.selectOutOf=function(t,e){e.insDirOf(t,this.parent)},t.deleteOutOf=function(t,e){e.unwrapGramp()},t.seek=function(t,e){var n=this.ends[Ct];if(!n||n.jQ.offset().left+n.jQ.outerWidth()<t)return e.insAtRightEnd(this);if(t<this.ends[Tt].jQ.offset().left)return e.insAtLeftEnd(this);for(;t<n.jQ.offset().left;)n=n[Tt];return n.seek(t,e)},t.chToCmd=function(t){var e;return t.match(/^[a-eg-zA-Z]$/)?R(t):/^\d$/.test(t)?E(t):(e=At[t]||Et[t])?e(t):j(t)},t.write=function(t,e){var n=this.chToCmd(e);t.selection&&n.replaces(t.replaceSelection()),n.createLeftOf(t.show())},t.focus=function(){return this.jQ.addClass("mq-hasCursor"),this.jQ.removeClass("mq-empty"),this},t.blur=function(){return this.jQ.removeClass("mq-hasCursor"),this.isEmpty()&&this.jQ.addClass("mq-empty"),this}}),Mt.StaticMath=function(t){return Qt(t.AbstractMathQuill,function(e,n){this.RootBlock=T,e.__mathquillify=function(){return n.__mathquillify.call(this,"mq-math-mode"),this.__controller.delegateMouseEvents(),this.__controller.staticMathTextareaEvents(),this},e.init=function(){n.init.apply(this,arguments),this.__controller.root.postOrder("registerInnerField",this.innerFields=[],t.MathField)},e.latex=function(){var e=n.latex.apply(this,arguments);return arguments.length>0&&this.__controller.root.postOrder("registerInnerField",this.innerFields=[],t.MathField),e}})},C=Qt(T,u),Mt.MathField=function(e){return Qt(e.EditableField,function(e,n){this.RootBlock=C,e.__mathquillify=function(e,i){return this.config(e),i>1&&(this.__controller.root.reflow=t),n.__mathquillify.call(this,"mq-editable-field mq-math-mode"),delete this.__controller.root.reflow,this}})},_=Qt(St,function(t,e){function n(t){var e,n;return t.jQ[0].normalize(),(e=t.jQ[0].firstChild)?(s("only node in TextBlock span is Text node",3===e.nodeType),n=D(e.data),n.jQadd(e),t.children().disown(),n.adopt(t,0,0)):void 0}t.ctrlSeq="\\text",t.replaces=function(t){t instanceof Lt?this.replacedText=t.remove().jQ.text():"string"==typeof t&&(this.replacedText=t)},t.jQadd=function(t){e.jQadd.call(this,t),this.ends[Tt]&&this.ends[Tt].jQadd(this.jQ[0].firstChild)},t.createLeftOf=function(t){var n,i=this;if(e.createLeftOf.call(this,t),i[Ct].siblingCreated&&i[Ct].siblingCreated(t.options,Tt),i[Tt].siblingCreated&&i[Tt].siblingCreated(t.options,Ct),i.bubble("reflow"),t.insAtRightEnd(i),i.replacedText)for(n=0;n<i.replacedText.length;n+=1)i.write(t,i.replacedText.charAt(n))},t.parser=function(){var t=this,e=w.string,n=w.regex,i=w.optWhitespace;return i.then(e("{")).then(n(/^[^}]*/)).skip(e("}")).map(function(e){return 0===e.length?Lt():(D(e).adopt(t,0,0),t)})},t.textContents=function(){return this.foldChildren("",function(t,e){return t+e.text})},t.text=function(){return'"'+this.textContents()+'"'},t.latex=function(){var t=this.textContents();return 0===t.length?"":"\\text{"+t+"}"},t.html=function(){return'<span class="mq-text-mode" mathquill-command-id='+this.id+">"+this.textContents()+"</span>"},t.moveTowards=function(t,e){e.insAtDirEnd(-t,this)},t.moveOutOf=function(t,e){e.insDirOf(t,this)},t.unselectInto=t.moveTowards,t.selectTowards=O.prototype.selectTowards,t.deleteTowards=O.prototype.deleteTowards,t.selectOutOf=function(t,e){e.insDirOf(t,this)},t.deleteOutOf=function(t,e){this.isEmpty()&&e.insRightOf(this)},t.write=function(t,n){var i,s;t.show().deleteSelection(),"$"!==n?t[Tt]?t[Tt].appendText(n):D(n).createLeftOf(t):this.isEmpty()?(t.insRightOf(this),j("\\$","$").createLeftOf(t)):t[Ct]?t[Tt]?(i=_(),s=this.ends[Tt],s.disown().jQ.detach(),s.adopt(i,0,0),t.insLeftOf(this),e.createLeftOf.call(i,t)):t.insLeftOf(this):t.insRightOf(this)},t.seek=function(t,e){var i,s,r,o,a,l,c,u;for(e.hide(),i=n(this),s=this.jQ.width()/this.text.length,r=Math.round((t-this.jQ.offset().left)/s),0>=r?e.insAtLeftEnd(this):r>=i.text.length?e.insAtRightEnd(this):e.insLeftOf(i.splitRight(r)),o=t-e.show().offset().left,a=o&&0>o?Tt:Ct,l=a;e[a]&&o*l>0;)e[a].moveTowards(a,e),l=o,o=t-e.offset().left;-a*l>a*o&&e[-a].moveTowards(-a,e),e.anticursor?e.anticursor.parent===this&&(c=e[Tt]&&e[Tt].text.length,this.anticursorPosition===c?e.anticursor=Dt.copy(e):(this.anticursorPosition<c?(u=e[Tt].splitRight(this.anticursorPosition),e[Tt]=u):u=e[Ct].splitRight(this.anticursorPosition-c),e.anticursor=Dt(this,u[Tt],u))):this.anticursorPosition=e[Tt]&&e[Tt].text.length},t.blur=function(t){T.prototype.blur.call(this),t&&(""===this.textContents()?(this.remove(),t[Tt]===this?t[Tt]=this[Tt]:t[Ct]===this&&(t[Ct]=this[Ct])):n(this))},t.focus=T.prototype.focus}),D=Qt(St,function(t,e){function n(t,e){return e.charAt(t===Tt?0:-1+e.length)}t.init=function(t){e.init.call(this),this.text=t},t.jQadd=function(t){this.dom=t,this.jQ=_t(t)},t.jQize=function(){return this.jQadd(document.createTextNode(this.text))},t.appendText=function(t){this.text+=t,this.dom.appendData(t)},t.prependText=function(t){this.text=t+this.text,this.dom.insertData(0,t)},t.insTextAtDirEnd=function(t,e){r(e),e===Ct?this.appendText(t):this.prependText(t)},t.splitRight=function(t){var e=D(this.text.slice(t)).adopt(this.parent,this,this[Ct]);return e.jQadd(this.dom.splitText(t)),this.text=this.text.slice(0,t),e},t.moveTowards=function(t,e){var i,s;return r(t),i=n(-t,this.text),s=this[-t],s?s.insTextAtDirEnd(i,t):D(i).createDir(-t,e),this.deleteTowards(t,e)},t.latex=function(){return this.text},t.deleteTowards=function(t,e){this.text.length>1?t===Ct?(this.dom.deleteData(0,1),this.text=this.text.slice(1)):(this.dom.deleteData(-1+this.text.length,1),this.text=this.text.slice(0,-1)):(this.remove(),this.jQ.remove(),e[t]=this[t])},t.selectTowards=function(t,e){var i,s,o,a;return r(t),i=e.anticursor,s=n(-t,this.text),i[t]===this?(o=D(s).createDir(t,e),i[t]=o,e.insDirOf(t,o)):(a=this[-t],a?a.insTextAtDirEnd(s,t):(o=D(s).createDir(-t,e),o.jQ.insDirOf(-t,e.selection.jQ)),1===this.text.length&&i[-t]===this&&(i[-t]=this[-t])),this.deleteTowards(t,e)}}),At.$=Et.text=Et.textnormal=Et.textrm=Et.textup=Et.textmd=_,Et.em=Et.italic=Et.italics=Et.emph=Et.textit=Et.textsl=h("\\textit","i",'class="mq-text-mode"'),Et.strong=Et.bold=Et.textbf=h("\\textbf","b",'class="mq-text-mode"'),Et.sf=Et.textsf=h("\\textsf","span",'class="mq-sans-serif mq-text-mode"'),Et.tt=Et.texttt=h("\\texttt","span",'class="mq-monospace mq-text-mode"'),Et.textsc=h("\\textsc","span",'style="font-variant:small-caps" class="mq-text-mode"'),Et.uppercase=h("\\uppercase","span",'style="text-transform:uppercase" class="mq-text-mode"'),Et.lowercase=h("\\lowercase","span",'style="text-transform:lowercase" class="mq-text-mode"'),S=Qt(O,function(t,e){t.init=function(t){e.init.call(this,"$"),this.cursor=t},t.htmlTemplate='<span class="mq-math-mode">&0</span>',t.createBlocks=function(){e.createBlocks.call(this),this.ends[Tt].cursor=this.cursor,this.ends[Tt].write=function(t,e){"$"!==e?T.prototype.write.call(this,t,e):this.isEmpty()?(t.insRightOf(this.parent),this.parent.deleteTowards(dir,t),j("\\$","$").createLeftOf(t.show())):t[Ct]?t[Tt]?T.prototype.write.call(this,t,e):t.insLeftOf(this.parent):t.insRightOf(this.parent)}},t.latex=function(){return"$"+this.ends[Tt].latex()+"$"}}),L=Qt(C,function(t,e){t.keystroke=function(t){return"Spacebar"!==t&&"Shift-Spacebar"!==t?e.keystroke.apply(this,arguments):void 0},t.write=function(t,e){if(t.show().deleteSelection(),"$"===e)S(t).createLeftOf(t);else{var n;"<"===e?n="&lt;":">"===e&&(n="&gt;"),j(e,n).createLeftOf(t)}}}),Mt.TextField=function(t){return Qt(t.EditableField,function(t,e){this.RootBlock=L,t.__mathquillify=function(){return e.__mathquillify.call(this,"mq-editable-field mq-text-mode")},t.latex=function(t){return arguments.length>0?(this.__controller.renderLatexText(t),this.__controller.blurred&&this.__controller.cursor.hide().parent.blur(),this):this.__controller.exportLatex()}})},Et.notin=Et.cong=Et.equiv=Et.oplus=Et.otimes=Qt(Q,function(t,e){t.init=function(t){e.init.call(this,"\\"+t+" ","&"+t+";")}}),Et["≠"]=Et.ne=Et.neq=i(Q,"\\ne ","&ne;"),Et.ast=Et.star=Et.loast=Et.lowast=i(Q,"\\ast ","&lowast;"),Et.therefor=Et.therefore=i(Q,"\\therefore ","&there4;"),Et.cuz=Et.because=i(Q,"\\because ","&#8757;"),Et.prop=Et.propto=i(Q,"\\propto ","&prop;"),Et["≈"]=Et.asymp=Et.approx=i(Q,"\\approx ","&asymp;"),Et.isin=Et["in"]=i(Q,"\\in ","&isin;"),Et.ni=Et.contains=i(Q,"\\ni ","&ni;"),Et.notni=Et.niton=Et.notcontains=Et.doesnotcontain=i(Q,"\\not\\ni ","&#8716;"),Et.sub=Et.subset=i(Q,"\\subset ","&sub;"),Et.sup=Et.supset=Et.superset=i(Q,"\\supset ","&sup;"),Et.nsub=Et.notsub=Et.nsubset=Et.notsubset=i(Q,"\\not\\subset ","&#8836;"),Et.nsup=Et.notsup=Et.nsupset=Et.notsupset=Et.nsuperset=Et.notsuperset=i(Q,"\\not\\supset ","&#8837;"),Et.sube=Et.subeq=Et.subsete=Et.subseteq=i(Q,"\\subseteq ","&sube;"),Et.supe=Et.supeq=Et.supsete=Et.supseteq=Et.supersete=Et.superseteq=i(Q,"\\supseteq ","&supe;"),Et.nsube=Et.nsubeq=Et.notsube=Et.notsubeq=Et.nsubsete=Et.nsubseteq=Et.notsubsete=Et.notsubseteq=i(Q,"\\not\\subseteq ","&#8840;"),Et.nsupe=Et.nsupeq=Et.notsupe=Et.notsupeq=Et.nsupsete=Et.nsupseteq=Et.notsupsete=Et.notsupseteq=Et.nsupersete=Et.nsuperseteq=Et.notsupersete=Et.notsuperseteq=i(Q,"\\not\\supseteq ","&#8841;"),Et.N=Et.naturals=Et.Naturals=i(j,"\\mathbb{N}","&#8469;"),Et.P=Et.primes=Et.Primes=Et.projective=Et.Projective=Et.probability=Et.Probability=i(j,"\\mathbb{P}","&#8473;"),Et.Z=Et.integers=Et.Integers=i(j,"\\mathbb{Z}","&#8484;"),Et.Q=Et.rationals=Et.Rationals=i(j,"\\mathbb{Q}","&#8474;"),Et.R=Et.reals=Et.Reals=i(j,"\\mathbb{R}","&#8477;"),Et.C=Et.complex=Et.Complex=Et.complexes=Et.Complexes=Et.complexplane=Et.Complexplane=Et.ComplexPlane=i(j,"\\mathbb{C}","&#8450;"),Et.H=Et.Hamiltonian=Et.quaternions=Et.Quaternions=i(j,"\\mathbb{H}","&#8461;"),Et.quad=Et.emsp=i(j,"\\quad ","    "),Et.qquad=i(j,"\\qquad ","        "),Et.diamond=i(j,"\\diamond ","&#9671;"),Et.bigtriangleup=i(j,"\\bigtriangleup ","&#9651;"),Et.ominus=i(j,"\\ominus ","&#8854;"),Et.uplus=i(j,"\\uplus ","&#8846;"),Et.bigtriangledown=i(j,"\\bigtriangledown ","&#9661;"),Et.sqcap=i(j,"\\sqcap ","&#8851;"),Et.triangleleft=i(j,"\\triangleleft ","&#8882;"),Et.sqcup=i(j,"\\sqcup ","&#8852;"),Et.triangleright=i(j,"\\triangleright ","&#8883;"),Et.odot=Et.circledot=i(j,"\\odot ","&#8857;"),Et.bigcirc=i(j,"\\bigcirc ","&#9711;"),Et.dagger=i(j,"\\dagger ","&#0134;"),Et.ddagger=i(j,"\\ddagger ","&#135;"),Et.wr=i(j,"\\wr ","&#8768;"),Et.amalg=i(j,"\\amalg ","&#8720;"),Et.models=i(j,"\\models ","&#8872;"),Et.prec=i(j,"\\prec ","&#8826;"),Et.succ=i(j,"\\succ ","&#8827;"),Et.preceq=i(j,"\\preceq ","&#8828;"),Et.succeq=i(j,"\\succeq ","&#8829;"),Et.simeq=i(j,"\\simeq ","&#8771;"),Et.mid=i(j,"\\mid ","&#8739;"),Et.ll=i(j,"\\ll ","&#8810;"),Et.gg=i(j,"\\gg ","&#8811;"),Et.parallel=i(j,"\\parallel ","&#8741;"),Et.nparallel=i(j,"\\nparallel ","&#8742;"),Et.bowtie=i(j,"\\bowtie ","&#8904;"),Et.sqsubset=i(j,"\\sqsubset ","&#8847;"),Et.sqsupset=i(j,"\\sqsupset ","&#8848;"),Et.smile=i(j,"\\smile ","&#8995;"),Et.sqsubseteq=i(j,"\\sqsubseteq ","&#8849;"),Et.sqsupseteq=i(j,"\\sqsupseteq ","&#8850;"),Et.doteq=i(j,"\\doteq ","&#8784;"),Et.frown=i(j,"\\frown ","&#8994;"),Et.vdash=i(j,"\\vdash ","&#8870;"),Et.dashv=i(j,"\\dashv ","&#8867;"),Et.nless=i(j,"\\nless ","&#8814;"),Et.ngtr=i(j,"\\ngtr ","&#8815;"),Et.longleftarrow=i(j,"\\longleftarrow ","&#8592;"),Et.longrightarrow=i(j,"\\longrightarrow ","&#8594;"),Et.Longleftarrow=i(j,"\\Longleftarrow ","&#8656;"),Et.Longrightarrow=i(j,"\\Longrightarrow ","&#8658;"),Et.longleftrightarrow=i(j,"\\longleftrightarrow ","&#8596;"),Et.updownarrow=i(j,"\\updownarrow ","&#8597;"),Et.Longleftrightarrow=i(j,"\\Longleftrightarrow ","&#8660;"),Et.Updownarrow=i(j,"\\Updownarrow ","&#8661;"),Et.mapsto=i(j,"\\mapsto ","&#8614;"),Et.nearrow=i(j,"\\nearrow ","&#8599;"),Et.hookleftarrow=i(j,"\\hookleftarrow ","&#8617;"),Et.hookrightarrow=i(j,"\\hookrightarrow ","&#8618;"),Et.searrow=i(j,"\\searrow ","&#8600;"),Et.leftharpoonup=i(j,"\\leftharpoonup ","&#8636;"),Et.rightharpoonup=i(j,"\\rightharpoonup ","&#8640;"),Et.swarrow=i(j,"\\swarrow ","&#8601;"),Et.leftharpoondown=i(j,"\\leftharpoondown ","&#8637;"),Et.rightharpoondown=i(j,"\\rightharpoondown ","&#8641;"),Et.nwarrow=i(j,"\\nwarrow ","&#8598;"),Et.ldots=i(j,"\\ldots ","&#8230;"),Et.cdots=i(j,"\\cdots ","&#8943;"),Et.vdots=i(j,"\\vdots ","&#8942;"),Et.ddots=i(j,"\\ddots ","&#8945;"),Et.surd=i(j,"\\surd ","&#8730;"),Et.triangle=i(j,"\\triangle ","&#9651;"),Et.ell=i(j,"\\ell ","&#8467;"),Et.top=i(j,"\\top ","&#8868;"),Et.flat=i(j,"\\flat ","&#9837;"),Et.natural=i(j,"\\natural ","&#9838;"),Et.sharp=i(j,"\\sharp ","&#9839;"),Et.wp=i(j,"\\wp ","&#8472;"),Et.bot=i(j,"\\bot ","&#8869;"),Et.clubsuit=i(j,"\\clubsuit ","&#9827;"),Et.diamondsuit=i(j,"\\diamondsuit ","&#9826;"),Et.heartsuit=i(j,"\\heartsuit ","&#9825;"),Et.spadesuit=i(j,"\\spadesuit ","&#9824;"),Et.parallelogram=i(j,"\\parallelogram ","&#9649;"),Et.square=i(j,"\\square ","&#11036;"),Et.oint=i(j,"\\oint ","&#8750;"),Et.bigcap=i(j,"\\bigcap ","&#8745;"),Et.bigcup=i(j,"\\bigcup ","&#8746;"),Et.bigsqcup=i(j,"\\bigsqcup ","&#8852;"),Et.bigvee=i(j,"\\bigvee ","&#8744;"),Et.bigwedge=i(j,"\\bigwedge ","&#8743;"),Et.bigodot=i(j,"\\bigodot ","&#8857;"),Et.bigotimes=i(j,"\\bigotimes ","&#8855;"),Et.bigoplus=i(j,"\\bigoplus ","&#8853;"),Et.biguplus=i(j,"\\biguplus ","&#8846;"),Et.lfloor=i(j,"\\lfloor ","&#8970;"),Et.rfloor=i(j,"\\rfloor ","&#8971;"),Et.lceil=i(j,"\\lceil ","&#8968;"),Et.rceil=i(j,"\\rceil ","&#8969;"),Et.opencurlybrace=Et.lbrace=i(j,"\\lbrace ","{"),Et.closecurlybrace=Et.rbrace=i(j,"\\rbrace ","}"),Et.lbrack=i(j,"["),Et.rbrack=i(j,"]"),Et.slash=i(j,"/"),Et.vert=i(j,"|"),Et.perp=Et.perpendicular=i(j,"\\perp ","&perp;"),Et.nabla=Et.del=i(j,"\\nabla ","&nabla;"),Et.hbar=i(j,"\\hbar ","&#8463;"),Et.AA=Et.Angstrom=Et.angstrom=i(j,"\\text\\AA ","&#8491;"),Et.ring=Et.circ=Et.circle=i(j,"\\circ ","&#8728;"),Et.bull=Et.bullet=i(j,"\\bullet ","&bull;"),Et.setminus=Et.smallsetminus=i(j,"\\setminus ","&#8726;"),Et.not=Et["¬"]=Et.neg=i(j,"\\neg ","&not;"),Et["…"]=Et.dots=Et.ellip=Et.hellip=Et.ellipsis=Et.hellipsis=i(j,"\\dots ","&hellip;"),Et.converges=Et.darr=Et.dnarr=Et.dnarrow=Et.downarrow=i(j,"\\downarrow ","&darr;"),Et.dArr=Et.dnArr=Et.dnArrow=Et.Downarrow=i(j,"\\Downarrow ","&dArr;"),Et.diverges=Et.uarr=Et.uparrow=i(j,"\\uparrow ","&uarr;"),Et.uArr=Et.Uparrow=i(j,"\\Uparrow ","&uArr;"),Et.to=i(Q,"\\to ","&rarr;"),Et.rarr=Et.rightarrow=i(j,"\\rightarrow ","&rarr;"),Et.implies=i(Q,"\\Rightarrow ","&rArr;"),Et.rArr=Et.Rightarrow=i(j,"\\Rightarrow ","&rArr;"),Et.gets=i(Q,"\\gets ","&larr;"),Et.larr=Et.leftarrow=i(j,"\\leftarrow ","&larr;"),Et.impliedby=i(Q,"\\Leftarrow ","&lArr;"),Et.lArr=Et.Leftarrow=i(j,"\\Leftarrow ","&lArr;"),Et.harr=Et.lrarr=Et.leftrightarrow=i(j,"\\leftrightarrow ","&harr;"),Et.iff=i(Q,"\\Leftrightarrow ","&hArr;"),Et.hArr=Et.lrArr=Et.Leftrightarrow=i(j,"\\Leftrightarrow ","&hArr;"),Et.Re=Et.Real=Et.real=i(j,"\\Re ","&real;"),Et.Im=Et.imag=Et.image=Et.imagin=Et.imaginary=Et.Imaginary=i(j,"\\Im ","&image;"),Et.part=Et.partial=i(j,"\\partial ","&part;"),Et.infty=Et.infin=Et.infinity=i(j,"\\infty ","&infin;"),Et.alef=Et.alefsym=Et.aleph=Et.alephsym=i(j,"\\aleph ","&alefsym;"),Et.xist=Et.xists=Et.exist=Et.exists=i(j,"\\exists ","&exist;"),Et.nexists=Et.nexist=i(j,"\\nexists ","&#8708;"),Et.and=Et.land=Et.wedge=i(j,"\\wedge ","&and;"),Et.or=Et.lor=Et.vee=i(j,"\\vee ","&or;"),Et.o=Et.O=Et.empty=Et.emptyset=Et.oslash=Et.Oslash=Et.nothing=Et.varnothing=i(Q,"\\varnothing ","&empty;"),Et.cup=Et.union=i(Q,"\\cup ","&cup;"),Et.cap=Et.intersect=Et.intersection=i(Q,"\\cap ","&cap;"),Et.deg=Et.degree=i(j,"\\degree ","&deg;"),Et.ang=Et.angle=i(j,"\\angle ","&ang;"),Et.measuredangle=i(j,"\\measuredangle ","&#8737;"),E=Qt(j,function(t,e){t.createLeftOf=function(t){t.options.autoSubscriptNumerals&&t.parent!==t.parent.parent.sub&&(t[Tt]instanceof A&&t[Tt].isItalic!==!1||t[Tt]instanceof st&&t[Tt][Tt]instanceof A&&t[Tt][Tt].isItalic!==!1)?(Et._().createLeftOf(t),e.createLeftOf.call(this,t),t.insRightOf(t.parent.parent)):e.createLeftOf.call(this,t)}}),A=Qt(k,function(t,e){t.init=function(t,n){e.init.call(this,t,"<var>"+(n||t)+"</var>")},t.text=function(){var t=this.ctrlSeq;return!this[Tt]||this[Tt]instanceof A||this[Tt]instanceof Q||"\\ "===this[Tt].ctrlSeq||(t="*"+t),!this[Ct]||this[Ct]instanceof Q||this[Ct]instanceof st||(t+="*"),t}}),Bt.p.autoCommands={_maxLength:0},Ft.autoCommands=function(t){var e,n,i,s,r;if(!/^[a-z]+(?: [a-z]+)*$/i.test(t))throw'"'+t+'" not a space-delimited list of only letters';for(e=t.split(" "),n={},i=0,s=0;s<e.length;s+=1){if(r=e[s],r.length<2)throw'autocommand "'+r+'" not minimum length of 2';if(Et[r]===B)throw'"'+r+'" is a built-in operator name';n[r]=1,i=Ot(i,r.length)}return n._maxLength=i,n},R=Qt(A,function(t,e){function n(t){return!t||t instanceof Q||t instanceof rt}t.init=function(t){return e.init.call(this,this.letter=t)},t.createLeftOf=function(t){var n,i,s,r,o;if(e.createLeftOf.apply(this,arguments),n=t.options.autoCommands,i=n._maxLength,i>0){for(s="",r=this,o=0;r instanceof R&&r.ctrlSeq===r.letter&&i>o;)s=r.letter+s,r=r[Tt],o+=1;for(;s.length;){if(n.hasOwnProperty(s)){for(o=1,r=this;o<s.length;o+=1,r=r[Tt]);return Lt(r,this).remove(),t[Tt]=r[Tt],Et[s](s).createLeftOf(t)}s=s.slice(1)}}},t.italicize=function(t){return this.isItalic=t,this.jQ.toggleClass("mq-operator-name",!t),this},t.finalizeTree=t.siblingDeleted=t.siblingCreated=function(t,e){e!==Tt&&this[Ct]instanceof R||this.autoUnItalicize(t)},t.autoUnItalicize=function(t){var e,i,s,r,o,a,l,c,u,h,f,p,d,m=t.autoOperatorNames;if(0!==m._maxLength){for(e=this.letter,i=this[Tt];i instanceof R;i=i[Tt])e=i.letter+e;for(s=this[Ct];s instanceof R;s=s[Ct])e+=s.letter;Lt(i[Ct]||this.parent.ends[Tt],s[Tt]||this.parent.ends[Ct]).each(function(t){t.italicize(!0).jQ.removeClass("mq-first mq-last mq-followed-by-supsub"),t.ctrlSeq=t.letter});t:for(r=0,o=i[Ct]||this.parent.ends[Tt];r<e.length;r+=1,o=o[Ct])for(a=yt(m._maxLength,e.length-r);a>0;a-=1)if(l=e.slice(r,r+a),m.hasOwnProperty(l)){for(c=0,u=o;a>c;c+=1,u=u[Ct])u.italicize(!1),h=u;f=I.hasOwnProperty(l),o.ctrlSeq=(f?"\\":"\\operatorname{")+o.ctrlSeq,h.ctrlSeq+=f?" ":"}",M.hasOwnProperty(l)&&h[Tt][Tt][Tt].jQ.addClass("mq-last"),n(o[Tt])||o.jQ.addClass("mq-first"),n(h[Ct])||(h[Ct]instanceof st?(p=h[Ct],(d=p.siblingCreated=p.siblingDeleted=function(){p.jQ.toggleClass("mq-after-operator-name",!(p[Ct]instanceof ht))})()):h.jQ.toggleClass("mq-last",!(h[Ct]instanceof ht))),r+=a-1,o=h;continue t}}}}),I={},z=Bt.p.autoOperatorNames={_maxLength:9},M={limsup:1,liminf:1,projlim:1,injlim:1},function(){var t,e,n,i,s="arg deg det dim exp gcd hom inf ker lg lim ln log max min sup limsup liminf injlim projlim Pr".split(" ");for(t=0;t<s.length;t+=1)I[s[t]]=z[s[t]]=1;for(e="sin cos tan arcsin arccos arctan sinh cosh tanh sec csc cot coth".split(" "),t=0;t<e.length;t+=1)I[e[t]]=1;for(n="sin cos tan sec cosec csc cotan cot ctg".split(" "),t=0;t<n.length;t+=1)z[n[t]]=z["arc"+n[t]]=z[n[t]+"h"]=z["ar"+n[t]+"h"]=z["arc"+n[t]+"h"]=1;for(i="gcf hcf lcm proj span".split(" "),t=0;t<i.length;t+=1)z[i[t]]=1}(),Ft.autoOperatorNames=function(t){var e,n,i,s,r;if(!/^[a-z]+(?: [a-z]+)*$/i.test(t))throw'"'+t+'" not a space-delimited list of only letters';for(e=t.split(" "),n={},i=0,s=0;s<e.length;s+=1){if(r=e[s],r.length<2)throw'"'+r+'" not minimum length of 2';n[r]=1,i=Ot(i,r.length)}return n._maxLength=i,n},B=Qt(k,function(t,e){t.init=function(t){this.ctrlSeq=t},t.createLeftOf=function(t){var e,n=this.ctrlSeq;for(e=0;e<n.length;e+=1)R(n.charAt(e)).createLeftOf(t)},t.parser=function(){var t,e=this.ctrlSeq,n=T();for(t=0;t<e.length;t+=1)R(e.charAt(t)).adopt(n,n.ends[Ct],0);return w.succeed(n.children())}});for(F in z)z.hasOwnProperty(F)&&(Et[F]=B);Et.operatorname=Qt(O,function(e){e.createLeftOf=t,e.numBlocks=function(){return 1},e.parser=function(){return x.block.map(function(t){return t.children()})}}),Et.f=Qt(R,function(t,e){t.init=function(){k.p.init.call(this,this.letter="f",'<var class="mq-f">f</var>')},t.italicize=function(t){return this.jQ.html("f").toggleClass("mq-f",t),e.italicize.apply(this,arguments)}}),Et[" "]=Et.space=i(j,"\\ ","&nbsp;"),Et["'"]=Et.prime=i(j,"'","&prime;"),Et.backslash=i(j,"\\backslash ","\\"),At["\\"]||(At["\\"]=Et.backslash),Et.$=i(j,"\\$","$"),$=Qt(k,function(t,e){t.init=function(t,n){e.init.call(this,t,'<span class="mq-nonSymbola">'+(n||t)+"</span>")}}),Et["@"]=$,Et["&"]=i($,"\\&","&amp;"),Et["%"]=i($,"\\%","%"),Et.alpha=Et.beta=Et.gamma=Et.delta=Et.zeta=Et.eta=Et.theta=Et.iota=Et.kappa=Et.mu=Et.nu=Et.xi=Et.rho=Et.sigma=Et.tau=Et.chi=Et.psi=Et.omega=Qt(A,function(t,e){t.init=function(t){e.init.call(this,"\\"+t+" ","&"+t+";")}}),Et.phi=i(A,"\\phi ","&#981;"),Et.phiv=Et.varphi=i(A,"\\varphi ","&phi;"),Et.epsilon=i(A,"\\epsilon ","&#1013;"),Et.epsiv=Et.varepsilon=i(A,"\\varepsilon ","&epsilon;"),Et.piv=Et.varpi=i(A,"\\varpi ","&piv;"),Et.sigmaf=Et.sigmav=Et.varsigma=i(A,"\\varsigma ","&sigmaf;"),Et.thetav=Et.vartheta=Et.thetasym=i(A,"\\vartheta ","&thetasym;"),Et.upsilon=Et.upsi=i(A,"\\upsilon ","&upsilon;"),Et.gammad=Et.Gammad=Et.digamma=i(A,"\\digamma ","&#989;"),Et.kappav=Et.varkappa=i(A,"\\varkappa ","&#1008;"),Et.rhov=Et.varrho=i(A,"\\varrho ","&#1009;"),Et.pi=Et["π"]=i($,"\\pi ","&pi;"),Et.lambda=i($,"\\lambda ","&lambda;"),Et.Upsilon=Et.Upsi=Et.upsih=Et.Upsih=i(k,"\\Upsilon ",'<var style="font-family: serif">&upsih;</var>'),Et.Gamma=Et.Delta=Et.Theta=Et.Lambda=Et.Xi=Et.Pi=Et.Sigma=Et.Phi=Et.Psi=Et.Omega=Et.forall=Qt(j,function(t,e){t.init=function(t){e.init.call(this,"\\"+t+" ","&"+t+";")}}),N=Qt(O,function(t){t.init=function(t){this.latex=t},t.createLeftOf=function(t){var e=x.parse(this.latex);e.children().adopt(t.parent,t[Tt],t[Ct]),t[Tt]=e.ends[Ct],e.jQize().insertBefore(t.jQ),e.finalizeInsert(t.options,t),e.ends[Ct][Ct].siblingCreated&&e.ends[Ct][Ct].siblingCreated(t.options,Tt),e.ends[Tt][Tt].siblingCreated&&e.ends[Tt][Tt].siblingCreated(t.options,Ct),t.parent.bubble("reflow")},t.parser=function(){var t=x.parse(this.latex).children();return w.succeed(t)}}),Et["¹"]=i(N,"^1"),Et["²"]=i(N,"^2"),Et["³"]=i(N,"^3"),Et["¼"]=i(N,"\\frac14"),Et["½"]=i(N,"\\frac12"),Et["¾"]=i(N,"\\frac34"),P=Qt(Q,function(t){t.init=j.prototype.init,t.contactWeld=t.siblingCreated=t.siblingDeleted=function(t,e){return e!==Ct?(this.jQ[0].className=!this[Tt]||this[Tt]instanceof Q||/^[,;:\(\[]$/.test(this[Tt].ctrlSeq)?"":"mq-binary-operator",this):void 0}}),Et["+"]=i(P,"+","+"),Et["–"]=Et["-"]=i(P,"-","&minus;"),Et["±"]=Et.pm=Et.plusmn=Et.plusminus=i(P,"\\pm ","&plusmn;"),Et.mp=Et.mnplus=Et.minusplus=i(P,"\\mp ","&#8723;"),At["*"]=Et.sdot=Et.cdot=i(Q,"\\cdot ","&middot;","*"),U=Qt(Q,function(t,e){t.init=function(t,n){this.data=t,this.strict=n;var i=n?"Strict":"";e.init.call(this,t["ctrlSeq"+i],t["html"+i],t["text"+i])},t.swap=function(t){this.strict=t;var e=t?"Strict":"";this.ctrlSeq=this.data["ctrlSeq"+e],this.jQ.html(this.data["html"+e]),this.textTemplate=[this.data["text"+e]]},t.deleteTowards=function(t,n){return t!==Tt||this.strict?void e.deleteTowards.apply(this,arguments):(this.swap(!0),void this.bubble("reflow"))}}),W={ctrlSeq:"\\le ",html:"&le;",text:"≤",ctrlSeqStrict:"<",htmlStrict:"&lt;",textStrict:"<"},H={ctrlSeq:"\\ge ",html:"&ge;",text:"≥",ctrlSeqStrict:">",htmlStrict:"&gt;",textStrict:">"},Et["<"]=Et.lt=i(U,W,!0),Et[">"]=Et.gt=i(U,H,!0),Et["≤"]=Et.le=Et.leq=i(U,W,!1),Et["≥"]=Et.ge=Et.geq=i(U,H,!1),G=Qt(Q,function(t,e){t.init=function(){e.init.call(this,"=","=")},t.createLeftOf=function(t){return t[Tt]instanceof U&&t[Tt].strict?(t[Tt].swap(!1),void t[Tt].bubble("reflow")):void e.createLeftOf.apply(this,arguments)}}),Et["="]=G,Et["×"]=Et.times=i(Q,"\\times ","&times;","[x]"),Et["÷"]=Et.div=Et.divide=Et.divides=i(Q,"\\div ","&divide;","[/]"),At["~"]=Et.sim=i(Q,"\\sim ","~","~"),Y=t,X=document.createElement("div"),Z=X.style,V={transform:1,WebkitTransform:1,MozTransform:1,OTransform:1,msTransform:1};for(tt in V)if(tt in Z){J=tt;break}J?K=function(t,e,n){t.css(J,"scale("+e+","+n+")")}:"filter"in Z?(Y=function(t){t.className=t.className},K=function(t,e,n){function i(){t.css("marginRight",(s.width()-1)*(e-1)/e+"px")}var s,r;e/=1+(n-1)/2,t.css("fontSize",n+"em"),t.hasClass("mq-matrixed-container")||t.addClass("mq-matrixed-container").wrapInner('<span class="mq-matrixed"></span>'),s=t.children().css("filter","progid:DXImageTransform.Microsoft.Matrix(M11="+e+",SizingMethod='auto expand')"),i(),r=setInterval(i),_t(window).load(function(){clearTimeout(r),i()})}):K=function(t,e,n){t.css("fontSize",n+"em")},et=Qt(O,function(t,e){t.init=function(t,n,i){e.init.call(this,t,"<"+n+" "+i+">&0</"+n+">")}}),Et.mathrm=i(et,"\\mathrm","span",'class="mq-roman mq-font"'),Et.mathit=i(et,"\\mathit","i",'class="mq-font"'),Et.mathbf=i(et,"\\mathbf","b",'class="mq-font"'),Et.mathsf=i(et,"\\mathsf","span",'class="mq-sans-serif mq-font"'),Et.mathtt=i(et,"\\mathtt","span",'class="mq-monospace mq-font"'),Et.underline=i(et,"\\underline","span",'class="mq-non-leaf mq-underline"'),Et.overline=Et.bar=i(et,"\\overline","span",'class="mq-non-leaf mq-overline"'),Et.overrightarrow=i(et,"\\overrightarrow","span",'class="mq-non-leaf mq-overarrow mq-arrow-right"'),Et.overleftarrow=i(et,"\\overleftarrow","span",'class="mq-non-leaf mq-overarrow mq-arrow-left"'),nt=Et.textcolor=Qt(O,function(t,e){t.setColor=function(t){this.color=t,this.htmlTemplate='<span class="mq-textcolor" style="color:'+t+'">&0</span>'},t.latex=function(){return"\\textcolor{"+this.color+"}{"+this.blocks[0].latex()+"}"},t.parser=function(){var t=this,n=w.optWhitespace,i=w.string,s=w.regex;return n.then(i("{")).then(s(/^[#\w\s.,()%-]*/)).skip(i("}")).then(function(n){return t.setColor(n),e.parser.call(t)})}}),it=Et["class"]=Qt(O,function(t,e){t.parser=function(){var t=this,n=w.string,i=w.regex;return w.optWhitespace.then(n("{")).then(i(/^[-\w\s\\\xA0-\xFF]*/)).skip(n("}")).then(function(n){return t.htmlTemplate='<span class="mq-class '+n+'">&0</span>',e.parser.call(t)})}}),st=Qt(O,function(t,e){t.ctrlSeq="_{...}^{...}",t.createLeftOf=function(t){return t[Tt]||!t.options.supSubsRequireOperand?e.createLeftOf.apply(this,arguments):void 0},t.contactWeld=function(t){var e,n,i,s,r,o;for(e=Tt;e;e=e===Tt?Ct:!1)if(this[e]instanceof st){for(n="sub";n;n="sub"===n?"sup":!1)i=this[n],s=this[e][n],i&&(s?i.isEmpty()?o=Dt(s,0,s.ends[Tt]):(i.jQ.children().insAtDirEnd(-e,s.jQ),r=i.children().disown(),o=Dt(s,r.ends[Ct],s.ends[Tt]),e===Tt?r.adopt(s,s.ends[Ct],0):r.adopt(s,0,s.ends[Tt])):this[e].addBlock(i.disown()),this.placeCursor=function(t,n){return function(i){i.insAtDirEnd(-e,t||n)}}(s,i));this.remove(),t&&t[Tt]===this&&(e===Ct&&o?o[Tt]?t.insRightOf(o[Tt]):t.insAtLeftEnd(o.parent):t.insRightOf(this[e]));break}},Bt.p.charsThatBreakOutOfSupSub="",t.finalizeTree=function(){this.ends[Tt].write=function(t,e){if(t.options.autoSubscriptNumerals&&this===this.parent.sub){if("_"===e)return;var n=this.chToCmd(e);return n instanceof k?t.deleteSelection():t.clearSelection().insRightOf(this.parent),n.createLeftOf(t.show())}t[Tt]&&!t[Ct]&&!t.selection&&t.options.charsThatBreakOutOfSupSub.indexOf(e)>-1&&t.insRightOf(this.parent),T.p.write.apply(this,arguments)}},t.moveTowards=function(t,n,i){n.options.autoSubscriptNumerals&&!this.sup?n.insDirOf(t,this):e.moveTowards.apply(this,arguments)},t.deleteTowards=function(t,n){if(n.options.autoSubscriptNumerals&&this.sub){var i=this.sub.ends[-t];i instanceof k?i.remove():i&&i.deleteTowards(t,n.insAtDirEnd(-t,this.sub)),this.sub.isEmpty()&&(this.sub.deleteOutOf(Tt,n.insAtLeftEnd(this.sub)),this.sup&&n.insDirOf(-t,this))}else e.deleteTowards.apply(this,arguments)},t.latex=function(){function t(t,e){var n=e&&e.latex();return e?t+(1===n.length?n:"{"+(n||" ")+"}"):""}return t("_",this.sub)+t("^",this.sup)},t.addBlock=function(t){"sub"===this.supsub?(this.sup=this.upInto=this.sub.upOutOf=t,t.adopt(this,this.sub,0).downOutOf=this.sub,t.jQ=_t('<span class="mq-sup"/>').append(t.jQ.children()).attr(xt,t.id).prependTo(this.jQ)):(this.sub=this.downInto=this.sup.downOutOf=t,t.adopt(this,0,this.sup).upOutOf=this.sup,t.jQ=_t('<span class="mq-sub"></span>').append(t.jQ.children()).attr(xt,t.id).appendTo(this.jQ.removeClass("mq-sup-only")),this.jQ.append('<span style="display:inline-block;width:0">&#8203;</span>'));for(var e=0;2>e;e+=1)(function(t,e,n,i){t[e].deleteOutOf=function(s,r){if(r.insDirOf(this[s]?-s:s,this.parent),!this.isEmpty()){var o=this.ends[s];this.children().disown().withDirAdopt(s,r.parent,r[s],r[-s]).jQ.insDirOf(-s,r.jQ),r[-s]=o}t.supsub=n,delete t[e],delete t[i+"Into"],t[n][i+"OutOf"]=f,delete t[n].deleteOutOf,"sub"===e&&_t(t.jQ.addClass("mq-sup-only")[0].lastChild).remove(),this.remove()}})(this,"sub sup".split(" ")[e],"sup sub".split(" ")[e],"down up".split(" ")[e])}}),Et.subscript=Et._=Qt(st,function(t,e){t.supsub="sub",t.htmlTemplate='<span class="mq-supsub mq-non-leaf"><span class="mq-sub">&0</span><span style="display:inline-block;width:0">&#8203;</span></span>',t.textTemplate=["_"],t.finalizeTree=function(){this.downInto=this.sub=this.ends[Tt],this.sub.upOutOf=f,e.finalizeTree.call(this)}}),Et.superscript=Et.supscript=Et["^"]=Qt(st,function(t,e){t.supsub="sup",t.htmlTemplate='<span class="mq-supsub mq-non-leaf mq-sup-only"><span class="mq-sup">&0</span></span>',t.textTemplate=["^"],t.finalizeTree=function(){this.upInto=this.sup=this.ends[Ct],this.sup.downOutOf=f,e.finalizeTree.call(this)}}),rt=Qt(O,function(t,e){t.init=function(t,e){var n='<span class="mq-large-operator mq-non-leaf"><span class="mq-to"><span>&1</span></span><big>'+e+'</big><span class="mq-from"><span>&0</span></span></span>';k.prototype.init.call(this,t,n)},t.createLeftOf=function(t){e.createLeftOf.apply(this,arguments),t.options.sumStartsWithNEquals&&(R("n").createLeftOf(t),G().createLeftOf(t))},t.latex=function(){function t(t){
return 1===t.length?t:"{"+(t||" ")+"}"}return this.ctrlSeq+"_"+t(this.ends[Tt].latex())+"^"+t(this.ends[Ct].latex())},t.parser=function(){var t,e=w.string,n=w.optWhitespace,i=w.succeed,s=x.block,r=this,o=r.blocks=[T(),T()];for(t=0;t<o.length;t+=1)o[t].adopt(r,r.ends[Ct],0);return n.then(e("_").or(e("^"))).then(function(t){var e=o["_"===t?0:1];return s.then(function(t){return t.children().adopt(e,e.ends[Ct],0),i(r)})}).many().result(r)},t.finalizeTree=function(){this.downInto=this.ends[Tt],this.upInto=this.ends[Ct],this.ends[Tt].upOutOf=this.ends[Ct],this.ends[Ct].downOutOf=this.ends[Tt]}}),Et["∑"]=Et.sum=Et.summation=i(rt,"\\sum ","&sum;"),Et["∏"]=Et.prod=Et.product=i(rt,"\\prod ","&prod;"),Et.coprod=Et.coproduct=i(rt,"\\coprod ","&#8720;"),Et["∫"]=Et["int"]=Et.integral=Qt(rt,function(t,e){t.init=function(){var t='<span class="mq-int mq-non-leaf"><big>&int;</big><span class="mq-supsub mq-non-leaf"><span class="mq-sup"><span class="mq-sup-inner">&1</span></span><span class="mq-sub">&0</span><span style="display:inline-block;width:0">&#8203</span></span></span>';k.prototype.init.call(this,"\\int ",t)},t.createLeftOf=O.p.createLeftOf}),ot=Et.frac=Et.dfrac=Et.cfrac=Et.fraction=Qt(O,function(t,e){t.ctrlSeq="\\frac",t.htmlTemplate='<span class="mq-fraction mq-non-leaf"><span class="mq-numerator">&0</span><span class="mq-denominator">&1</span></span>',t.textTemplate=["(",")/(",")"],t.finalizeTree=function(){this.upInto=this.ends[Ct].upOutOf=this.ends[Tt],this.downInto=this.ends[Tt].downOutOf=this.ends[Ct]}}),at=Et.over=At["/"]=Qt(ot,function(e,n){e.createLeftOf=function(e){if(!this.replacedFragment){for(var i=e[Tt];i&&!(i instanceof Q||i instanceof(Et.text||t)||i instanceof rt||"\\ "===i.ctrlSeq||/^[,;:]$/.test(i.ctrlSeq));)i=i[Tt];i instanceof rt&&i[Ct]instanceof st&&(i=i[Ct],i[Ct]instanceof st&&i[Ct].ctrlSeq!=i.ctrlSeq&&(i=i[Ct])),i!==e[Tt]&&(this.replaces(Lt(i[Ct]||e.parent.ends[Tt],e[Tt])),e[Tt]=i)}n.createLeftOf.call(this,e)}}),lt=Et.sqrt=Et["√"]=Qt(O,function(t,e){t.ctrlSeq="\\sqrt",t.htmlTemplate='<span class="mq-non-leaf"><span class="mq-scaled mq-sqrt-prefix">&radic;</span><span class="mq-non-leaf mq-sqrt-stem">&0</span></span>',t.textTemplate=["sqrt(",")"],t.parser=function(){return x.optBlock.then(function(t){return x.block.map(function(e){var n=ut();return n.blocks=[t,e],t.adopt(n,0,0),e.adopt(n,t,0),n})}).or(e.parser.call(this))},t.reflow=function(){var t=this.ends[Ct].jQ;K(t.prev(),1,t.innerHeight()/+t.css("fontSize").slice(0,-2)-.1)}}),ct=Et.vec=Qt(O,function(t,e){t.ctrlSeq="\\vec",t.htmlTemplate='<span class="mq-non-leaf"><span class="mq-vector-prefix">&rarr;</span><span class="mq-vector-stem">&0</span></span>',t.textTemplate=["vec(",")"]}),ut=Et.nthroot=Qt(lt,function(t,e){t.htmlTemplate='<sup class="mq-nthroot mq-non-leaf">&0</sup><span class="mq-scaled"><span class="mq-sqrt-prefix mq-scaled">&radic;</span><span class="mq-sqrt-stem mq-non-leaf">&1</span></span>',t.textTemplate=["sqrt[","](",")"],t.latex=function(){return"\\sqrt["+this.ends[Tt].latex()+"]{"+this.ends[Ct].latex()+"}"}}),ht=Qt(Qt(O,p),function(e,n){e.init=function(t,e,i,s,r){n.init.call(this,"\\left"+s,m,[e,i]),this.side=t,this.sides={},this.sides[Tt]={ch:e,ctrlSeq:s},this.sides[Ct]={ch:i,ctrlSeq:r}},e.numBlocks=function(){return 1},e.html=function(){return this.htmlTemplate='<span class="mq-non-leaf"><span class="mq-scaled mq-paren'+(this.side===Ct?" mq-ghost":"")+'">'+this.sides[Tt].ch+'</span><span class="mq-non-leaf">&0</span><span class="mq-scaled mq-paren'+(this.side===Tt?" mq-ghost":"")+'">'+this.sides[Ct].ch+"</span></span>",n.html.call(this)},e.latex=function(){return"\\left"+this.sides[Tt].ctrlSeq+this.ends[Tt].latex()+"\\right"+this.sides[Ct].ctrlSeq},e.oppBrack=function(t,e,n){return e instanceof ht&&e.side&&e.side!==-n&&("|"===this.sides[this.side].ch||e.side===-this.side)&&(!t.restrictMismatchedBrackets||ft[this.sides[this.side].ch]===e.sides[e.side].ch||{"(":"]","[":")"}[this.sides[Tt].ch]===e.sides[Ct].ch)&&e},e.closeOpposing=function(t){t.side=0,t.sides[this.side]=this.sides[this.side],t.delimjQs.eq(this.side===Tt?0:1).removeClass("mq-ghost").html(this.sides[this.side].ch)},e.createLeftOf=function(t){var e,i,s;this.replacedFragment||(e=t.options,i=this.oppBrack(e,t[Tt],Tt)||this.oppBrack(e,t[Ct],Ct)||this.oppBrack(e,t.parent.parent)),i?(s=this.side=-i.side,this.closeOpposing(i),i===t.parent.parent&&t[s]&&(Lt(t[s],t.parent.ends[s],-s).disown().withDirAdopt(-s,i.parent,i,i[s]).jQ.insDirOf(s,i.jQ),i.bubble("reflow"))):(i=this,s=i.side,i.replacedFragment?i.side=0:t[-s]&&(i.replaces(Lt(t[-s],t.parent.ends[-s],s)),t[-s]=0),n.createLeftOf.call(i,t)),s===Tt?t.insAtLeftEnd(i.ends[Tt]):t.insRightOf(i)},e.placeCursor=t,e.unwrap=function(){this.ends[Tt].children().disown().adopt(this.parent,this,this[Ct]).jQ.insertAfter(this.jQ),this.remove()},e.deleteSide=function(t,e,n){var i,s,r,o=this.parent,a=this[t],l=o.ends[t];if(t===this.side)return this.unwrap(),void(a?n.insDirOf(-t,a):n.insAtDirEnd(t,o));if(i=n.options,s=!this.side,this.side=-t,this.oppBrack(i,this.ends[Tt].ends[this.side],t))this.closeOpposing(this.ends[Tt].ends[this.side]),r=this.ends[Tt].ends[t],this.unwrap(),r.siblingCreated&&r.siblingCreated(n.options,t),a?n.insDirOf(-t,a):n.insAtDirEnd(t,o);else{if(this.oppBrack(i,this.parent.parent,t))this.parent.parent.closeOpposing(this),this.parent.parent.unwrap();else{if(e&&s)return this.unwrap(),void(a?n.insDirOf(-t,a):n.insAtDirEnd(t,o));this.sides[t]={ch:ft[this.sides[this.side].ch],ctrlSeq:ft[this.sides[this.side].ctrlSeq]},this.delimjQs.removeClass("mq-ghost").eq(t===Tt?0:1).addClass("mq-ghost").html(this.sides[t].ch)}a?(r=this.ends[Tt].ends[t],Lt(a,l,-t).disown().withDirAdopt(-t,this.ends[Tt],r,0).jQ.insAtDirEnd(t,this.ends[Tt].jQ.removeClass("mq-empty")),r.siblingCreated&&r.siblingCreated(n.options,t),n.insDirOf(-t,a)):e?n.insDirOf(t,this):n.insAtDirEnd(t,this.ends[Tt])}},e.deleteTowards=function(t,e){this.deleteSide(-t,!1,e)},e.finalizeTree=function(){this.ends[Tt].deleteOutOf=function(t,e){this.parent.deleteSide(t,!0,e)},this.finalizeTree=this.intentionalBlur=function(){this.delimjQs.eq(this.side===Tt?1:0).removeClass("mq-ghost"),this.side=0}},e.siblingCreated=function(t,e){e===-this.side&&this.finalizeTree()}}),ft={"(":")",")":"(","[":"]","]":"[","{":"}","}":"{","\\{":"\\}","\\}":"\\{","&lang;":"&rang;","&rang;":"&lang;","\\langle ":"\\rangle ","\\rangle ":"\\langle ","|":"|"},d("("),d("["),d("{","\\{"),Et.langle=i(ht,Tt,"&lang;","&rang;","\\langle ","\\rangle "),Et.rangle=i(ht,Ct,"&lang;","&rang;","\\langle ","\\rangle "),At["|"]=i(ht,Tt,"|","|","|","|"),Et.left=Qt(O,function(t){t.parser=function(){var t=w.regex,e=w.string,n=(w.succeed,w.optWhitespace);return n.then(t(/^(?:[([|]|\\\{)/)).then(function(i){var s="\\"===i.charAt(0)?i.slice(1):i;return x.then(function(r){return e("\\right").skip(n).then(t(/^(?:[\])|]|\\\})/)).map(function(t){var e="\\"===t.charAt(0)?t.slice(1):t,n=ht(0,s,e,i,t);return n.blocks=[r],r.adopt(n,0,0),n})})})}}),Et.right=Qt(O,function(t){t.parser=function(){return w.fail("unmatched \\right")}}),pt=Et.binom=Et.binomial=Qt(Qt(O,p),function(t,e){t.ctrlSeq="\\binom",t.htmlTemplate='<span class="mq-non-leaf"><span class="mq-paren mq-scaled">(</span><span class="mq-non-leaf"><span class="mq-array mq-non-leaf"><span>&0</span><span>&1</span></span></span><span class="mq-paren mq-scaled">)</span></span>',t.textTemplate=["choose(",",",")"]}),dt=Et.choose=Qt(pt,function(t){t.createLeftOf=at.prototype.createLeftOf}),Et.editable=Et.MathQuillMathField=Qt(O,function(t,e){t.ctrlSeq="\\MathQuillMathField",t.htmlTemplate='<span class="mq-editable-field"><span class="mq-root-block">&0</span></span>',t.parser=function(){var t=this,n=w.string,i=w.regex,s=w.succeed;return n("[").then(i(/^[a-z][a-z0-9]*/i)).skip(n("]")).map(function(e){t.name=e}).or(s()).then(e.parser.call(t))},t.finalizeTree=function(){var t=zt(this.ends[Tt],this.jQ,Bt());t.KIND_OF_MQ="MathField",t.editable=!0,t.createTextarea(),t.editablesTextareaEvents(),t.cursor.insAtRightEnd(t.root),u(t.root)},t.registerInnerField=function(t,e){t.push(t[this.name]=e(this.ends[Tt].controller))},t.latex=function(){return this.ends[Tt].latex()},t.text=function(){return this.ends[Tt].text()}}),mt=Et.embed=Qt(k,function(t,e){t.setOptions=function(t){function e(){return""}return this.text=t.text||e,this.htmlTemplate=t.htmlString||"",this.latex=t.latex||e,this},t.parser=function(){var t=this;return string=w.string,regex=w.regex,succeed=w.succeed,string("{").then(regex(/^[a-z][a-z0-9]*/i)).skip(string("}")).then(function(e){return string("[").then(regex(/^[-\w\s]*/)).skip(string("]")).or(succeed()).map(function(n){return t.setOptions(Nt[e](n))})})}}),gt=At["\\"]=Qt(O,function(t,e){t.ctrlSeq="\\",t.replaces=function(t){this._replacedFragment=t.disown(),this.isEmpty=function(){return!1}},t.htmlTemplate='<span class="mq-latex-command-input mq-non-leaf">\\<span>&0</span></span>',t.textTemplate=["\\"],t.createBlocks=function(){e.createBlocks.call(this),this.ends[Tt].focus=function(){return this.parent.jQ.addClass("mq-hasCursor"),this.isEmpty()&&this.parent.jQ.removeClass("mq-empty"),this},this.ends[Tt].blur=function(){return this.parent.jQ.removeClass("mq-hasCursor"),this.isEmpty()&&this.parent.jQ.addClass("mq-empty"),this},this.ends[Tt].write=function(t,e){t.show().deleteSelection(),e.match(/[a-z]/i)?j(e).createLeftOf(t):(this.parent.renderCommand(t),"\\"===e&&this.isEmpty()||this.parent.parent.write(t,e))},this.ends[Tt].keystroke=function(t,n,i){return"Tab"===t||"Enter"===t||"Spacebar"===t?(this.parent.renderCommand(i.cursor),void n.preventDefault()):e.keystroke.apply(this,arguments)}},t.createLeftOf=function(t){if(e.createLeftOf.call(this,t),this._replacedFragment){var n=this.jQ[0];this.jQ=this._replacedFragment.jQ.addClass("mq-blur").bind("mousedown mousemove",function(t){return _t(t.target=n).trigger(t),!1}).insertBefore(this.jQ).add(this.jQ)}},t.latex=function(){return"\\"+this.ends[Tt].latex()+" "},t.renderCommand=function(t){var e,n;this.jQ=this.jQ.last(),this.remove(),this[Ct]?t.insLeftOf(this[Ct]):t.insAtRightEnd(this.parent),e=this.ends[Tt].latex(),e||(e=" "),n=Et[e],n?(n=n(e),this._replacedFragment&&n.replaces(this._replacedFragment),n.createLeftOf(t)):(n=_(),n.replaces(e),n.createLeftOf(t),t.insRightOf(n),this._replacedFragment&&this._replacedFragment.remove())}}),bt=c(1);for(vt in bt)(function(t,e){"function"==typeof e?(l[t]=function(){return a(),e.apply(this,arguments)},l[t].prototype=e.prototype):l[t]=e})(vt,bt[vt])}();
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.io=f()}})(function(){var define,module,exports;return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){module.exports=_dereq_("./lib/")},{"./lib/":2}],2:[function(_dereq_,module,exports){module.exports=_dereq_("./socket");module.exports.parser=_dereq_("engine.io-parser")},{"./socket":3,"engine.io-parser":19}],3:[function(_dereq_,module,exports){(function(global){var transports=_dereq_("./transports");var Emitter=_dereq_("component-emitter");var debug=_dereq_("debug")("engine.io-client:socket");var index=_dereq_("indexof");var parser=_dereq_("engine.io-parser");var parseuri=_dereq_("parseuri");var parsejson=_dereq_("parsejson");var parseqs=_dereq_("parseqs");module.exports=Socket;function noop(){}function Socket(uri,opts){if(!(this instanceof Socket))return new Socket(uri,opts);opts=opts||{};if(uri&&"object"==typeof uri){opts=uri;uri=null}if(uri){uri=parseuri(uri);opts.hostname=uri.host;opts.secure=uri.protocol=="https"||uri.protocol=="wss";opts.port=uri.port;if(uri.query)opts.query=uri.query}else if(opts.host){opts.hostname=parseuri(opts.host).host}this.secure=null!=opts.secure?opts.secure:global.location&&"https:"==location.protocol;if(opts.hostname&&!opts.port){opts.port=this.secure?"443":"80"}this.agent=opts.agent||false;this.hostname=opts.hostname||(global.location?location.hostname:"localhost");this.port=opts.port||(global.location&&location.port?location.port:this.secure?443:80);this.query=opts.query||{};if("string"==typeof this.query)this.query=parseqs.decode(this.query);this.upgrade=false!==opts.upgrade;this.path=(opts.path||"/engine.io").replace(/\/$/,"")+"/";this.forceJSONP=!!opts.forceJSONP;this.jsonp=false!==opts.jsonp;this.forceBase64=!!opts.forceBase64;this.enablesXDR=!!opts.enablesXDR;this.timestampParam=opts.timestampParam||"t";this.timestampRequests=opts.timestampRequests;this.transports=opts.transports||["polling","websocket"];this.readyState="";this.writeBuffer=[];this.policyPort=opts.policyPort||843;this.rememberUpgrade=opts.rememberUpgrade||false;this.binaryType=null;this.onlyBinaryUpgrades=opts.onlyBinaryUpgrades;this.perMessageDeflate=false!==opts.perMessageDeflate?opts.perMessageDeflate||{}:false;if(true===this.perMessageDeflate)this.perMessageDeflate={};if(this.perMessageDeflate&&null==this.perMessageDeflate.threshold){this.perMessageDeflate.threshold=1024}this.pfx=opts.pfx||null;this.key=opts.key||null;this.passphrase=opts.passphrase||null;this.cert=opts.cert||null;this.ca=opts.ca||null;this.ciphers=opts.ciphers||null;this.rejectUnauthorized=opts.rejectUnauthorized===undefined?null:opts.rejectUnauthorized;var freeGlobal=typeof global=="object"&&global;if(freeGlobal.global===freeGlobal){if(opts.extraHeaders&&Object.keys(opts.extraHeaders).length>0){this.extraHeaders=opts.extraHeaders}}this.open()}Socket.priorWebsocketSuccess=false;Emitter(Socket.prototype);Socket.protocol=parser.protocol;Socket.Socket=Socket;Socket.Transport=_dereq_("./transport");Socket.transports=_dereq_("./transports");Socket.parser=_dereq_("engine.io-parser");Socket.prototype.createTransport=function(name){debug('creating transport "%s"',name);var query=clone(this.query);query.EIO=parser.protocol;query.transport=name;if(this.id)query.sid=this.id;var transport=new transports[name]({agent:this.agent,hostname:this.hostname,port:this.port,secure:this.secure,path:this.path,query:query,forceJSONP:this.forceJSONP,jsonp:this.jsonp,forceBase64:this.forceBase64,enablesXDR:this.enablesXDR,timestampRequests:this.timestampRequests,timestampParam:this.timestampParam,policyPort:this.policyPort,socket:this,pfx:this.pfx,key:this.key,passphrase:this.passphrase,cert:this.cert,ca:this.ca,ciphers:this.ciphers,rejectUnauthorized:this.rejectUnauthorized,perMessageDeflate:this.perMessageDeflate,extraHeaders:this.extraHeaders});return transport};function clone(obj){var o={};for(var i in obj){if(obj.hasOwnProperty(i)){o[i]=obj[i]}}return o}Socket.prototype.open=function(){var transport;if(this.rememberUpgrade&&Socket.priorWebsocketSuccess&&this.transports.indexOf("websocket")!=-1){transport="websocket"}else if(0===this.transports.length){var self=this;setTimeout(function(){self.emit("error","No transports available")},0);return}else{transport=this.transports[0]}this.readyState="opening";try{transport=this.createTransport(transport)}catch(e){this.transports.shift();this.open();return}transport.open();this.setTransport(transport)};Socket.prototype.setTransport=function(transport){debug("setting transport %s",transport.name);var self=this;if(this.transport){debug("clearing existing transport %s",this.transport.name);this.transport.removeAllListeners()}this.transport=transport;transport.on("drain",function(){self.onDrain()}).on("packet",function(packet){self.onPacket(packet)}).on("error",function(e){self.onError(e)}).on("close",function(){self.onClose("transport close")})};Socket.prototype.probe=function(name){debug('probing transport "%s"',name);var transport=this.createTransport(name,{probe:1}),failed=false,self=this;Socket.priorWebsocketSuccess=false;function onTransportOpen(){if(self.onlyBinaryUpgrades){var upgradeLosesBinary=!this.supportsBinary&&self.transport.supportsBinary;failed=failed||upgradeLosesBinary}if(failed)return;debug('probe transport "%s" opened',name);transport.send([{type:"ping",data:"probe"}]);transport.once("packet",function(msg){if(failed)return;if("pong"==msg.type&&"probe"==msg.data){debug('probe transport "%s" pong',name);self.upgrading=true;self.emit("upgrading",transport);if(!transport)return;Socket.priorWebsocketSuccess="websocket"==transport.name;debug('pausing current transport "%s"',self.transport.name);self.transport.pause(function(){if(failed)return;if("closed"==self.readyState)return;debug("changing transport and sending upgrade packet");cleanup();self.setTransport(transport);transport.send([{type:"upgrade"}]);self.emit("upgrade",transport);transport=null;self.upgrading=false;self.flush()})}else{debug('probe transport "%s" failed',name);var err=new Error("probe error");err.transport=transport.name;self.emit("upgradeError",err)}})}function freezeTransport(){if(failed)return;failed=true;cleanup();transport.close();transport=null}function onerror(err){var error=new Error("probe error: "+err);error.transport=transport.name;freezeTransport();debug('probe transport "%s" failed because of error: %s',name,err);self.emit("upgradeError",error)}function onTransportClose(){onerror("transport closed")}function onclose(){onerror("socket closed")}function onupgrade(to){if(transport&&to.name!=transport.name){debug('"%s" works - aborting "%s"',to.name,transport.name);freezeTransport()}}function cleanup(){transport.removeListener("open",onTransportOpen);transport.removeListener("error",onerror);transport.removeListener("close",onTransportClose);self.removeListener("close",onclose);self.removeListener("upgrading",onupgrade)}transport.once("open",onTransportOpen);transport.once("error",onerror);transport.once("close",onTransportClose);this.once("close",onclose);this.once("upgrading",onupgrade);transport.open()};Socket.prototype.onOpen=function(){debug("socket open");this.readyState="open";Socket.priorWebsocketSuccess="websocket"==this.transport.name;this.emit("open");this.flush();if("open"==this.readyState&&this.upgrade&&this.transport.pause){debug("starting upgrade probes");for(var i=0,l=this.upgrades.length;i<l;i++){this.probe(this.upgrades[i])}}};Socket.prototype.onPacket=function(packet){if("opening"==this.readyState||"open"==this.readyState){debug('socket receive: type "%s", data "%s"',packet.type,packet.data);this.emit("packet",packet);this.emit("heartbeat");switch(packet.type){case"open":this.onHandshake(parsejson(packet.data));break;case"pong":this.setPing();this.emit("pong");break;case"error":var err=new Error("server error");err.code=packet.data;this.onError(err);break;case"message":this.emit("data",packet.data);this.emit("message",packet.data);break}}else{debug('packet received with socket readyState "%s"',this.readyState)}};Socket.prototype.onHandshake=function(data){this.emit("handshake",data);this.id=data.sid;this.transport.query.sid=data.sid;this.upgrades=this.filterUpgrades(data.upgrades);this.pingInterval=data.pingInterval;this.pingTimeout=data.pingTimeout;this.onOpen();if("closed"==this.readyState)return;this.setPing();this.removeListener("heartbeat",this.onHeartbeat);this.on("heartbeat",this.onHeartbeat)};Socket.prototype.onHeartbeat=function(timeout){clearTimeout(this.pingTimeoutTimer);var self=this;self.pingTimeoutTimer=setTimeout(function(){if("closed"==self.readyState)return;self.onClose("ping timeout")},timeout||self.pingInterval+self.pingTimeout)};Socket.prototype.setPing=function(){var self=this;clearTimeout(self.pingIntervalTimer);self.pingIntervalTimer=setTimeout(function(){debug("writing ping packet - expecting pong within %sms",self.pingTimeout);self.ping();self.onHeartbeat(self.pingTimeout)},self.pingInterval)};Socket.prototype.ping=function(){var self=this;this.sendPacket("ping",function(){self.emit("ping")})};Socket.prototype.onDrain=function(){this.writeBuffer.splice(0,this.prevBufferLen);this.prevBufferLen=0;if(0===this.writeBuffer.length){this.emit("drain")}else{this.flush()}};Socket.prototype.flush=function(){if("closed"!=this.readyState&&this.transport.writable&&!this.upgrading&&this.writeBuffer.length){debug("flushing %d packets in socket",this.writeBuffer.length);this.transport.send(this.writeBuffer);this.prevBufferLen=this.writeBuffer.length;this.emit("flush")}};Socket.prototype.write=Socket.prototype.send=function(msg,options,fn){this.sendPacket("message",msg,options,fn);return this};Socket.prototype.sendPacket=function(type,data,options,fn){if("function"==typeof data){fn=data;data=undefined}if("function"==typeof options){fn=options;options=null}if("closing"==this.readyState||"closed"==this.readyState){return}options=options||{};options.compress=false!==options.compress;var packet={type:type,data:data,options:options};this.emit("packetCreate",packet);this.writeBuffer.push(packet);if(fn)this.once("flush",fn);this.flush()};Socket.prototype.close=function(){if("opening"==this.readyState||"open"==this.readyState){this.readyState="closing";var self=this;if(this.writeBuffer.length){this.once("drain",function(){if(this.upgrading){waitForUpgrade()}else{close()}})}else if(this.upgrading){waitForUpgrade()}else{close()}}function close(){self.onClose("forced close");debug("socket closing - telling transport to close");self.transport.close()}function cleanupAndClose(){self.removeListener("upgrade",cleanupAndClose);self.removeListener("upgradeError",cleanupAndClose);close()}function waitForUpgrade(){self.once("upgrade",cleanupAndClose);self.once("upgradeError",cleanupAndClose)}return this};Socket.prototype.onError=function(err){debug("socket error %j",err);Socket.priorWebsocketSuccess=false;this.emit("error",err);this.onClose("transport error",err)};Socket.prototype.onClose=function(reason,desc){if("opening"==this.readyState||"open"==this.readyState||"closing"==this.readyState){debug('socket close with reason: "%s"',reason);var self=this;clearTimeout(this.pingIntervalTimer);clearTimeout(this.pingTimeoutTimer);this.transport.removeAllListeners("close");this.transport.close();this.transport.removeAllListeners();this.readyState="closed";this.id=null;this.emit("close",reason,desc);self.writeBuffer=[];self.prevBufferLen=0}};Socket.prototype.filterUpgrades=function(upgrades){var filteredUpgrades=[];for(var i=0,j=upgrades.length;i<j;i++){if(~index(this.transports,upgrades[i]))filteredUpgrades.push(upgrades[i])}return filteredUpgrades}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./transport":4,"./transports":5,"component-emitter":15,debug:17,"engine.io-parser":19,indexof:23,parsejson:26,parseqs:27,parseuri:28}],4:[function(_dereq_,module,exports){var parser=_dereq_("engine.io-parser");var Emitter=_dereq_("component-emitter");module.exports=Transport;function Transport(opts){this.path=opts.path;this.hostname=opts.hostname;this.port=opts.port;this.secure=opts.secure;this.query=opts.query;this.timestampParam=opts.timestampParam;this.timestampRequests=opts.timestampRequests;this.readyState="";this.agent=opts.agent||false;this.socket=opts.socket;this.enablesXDR=opts.enablesXDR;this.pfx=opts.pfx;this.key=opts.key;this.passphrase=opts.passphrase;this.cert=opts.cert;this.ca=opts.ca;this.ciphers=opts.ciphers;this.rejectUnauthorized=opts.rejectUnauthorized;this.extraHeaders=opts.extraHeaders}Emitter(Transport.prototype);Transport.prototype.onError=function(msg,desc){var err=new Error(msg);err.type="TransportError";err.description=desc;this.emit("error",err);return this};Transport.prototype.open=function(){if("closed"==this.readyState||""==this.readyState){this.readyState="opening";this.doOpen()}return this};Transport.prototype.close=function(){if("opening"==this.readyState||"open"==this.readyState){this.doClose();this.onClose()}return this};Transport.prototype.send=function(packets){if("open"==this.readyState){this.write(packets)}else{throw new Error("Transport not open")}};Transport.prototype.onOpen=function(){this.readyState="open";this.writable=true;this.emit("open")};Transport.prototype.onData=function(data){var packet=parser.decodePacket(data,this.socket.binaryType);this.onPacket(packet)};Transport.prototype.onPacket=function(packet){this.emit("packet",packet)};Transport.prototype.onClose=function(){this.readyState="closed";this.emit("close")}},{"component-emitter":15,"engine.io-parser":19}],5:[function(_dereq_,module,exports){(function(global){var XMLHttpRequest=_dereq_("xmlhttprequest-ssl");var XHR=_dereq_("./polling-xhr");var JSONP=_dereq_("./polling-jsonp");var websocket=_dereq_("./websocket");exports.polling=polling;exports.websocket=websocket;function polling(opts){var xhr;var xd=false;var xs=false;var jsonp=false!==opts.jsonp;if(global.location){var isSSL="https:"==location.protocol;var port=location.port;if(!port){port=isSSL?443:80}xd=opts.hostname!=location.hostname||port!=opts.port;xs=opts.secure!=isSSL}opts.xdomain=xd;opts.xscheme=xs;xhr=new XMLHttpRequest(opts);if("open"in xhr&&!opts.forceJSONP){return new XHR(opts)}else{if(!jsonp)throw new Error("JSONP disabled");return new JSONP(opts)}}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./polling-jsonp":6,"./polling-xhr":7,"./websocket":9,"xmlhttprequest-ssl":10}],6:[function(_dereq_,module,exports){(function(global){var Polling=_dereq_("./polling");var inherit=_dereq_("component-inherit");module.exports=JSONPPolling;var rNewline=/\n/g;var rEscapedNewline=/\\n/g;var callbacks;var index=0;function empty(){}function JSONPPolling(opts){Polling.call(this,opts);this.query=this.query||{};if(!callbacks){if(!global.___eio)global.___eio=[];callbacks=global.___eio}this.index=callbacks.length;var self=this;callbacks.push(function(msg){self.onData(msg)});this.query.j=this.index;if(global.document&&global.addEventListener){global.addEventListener("beforeunload",function(){if(self.script)self.script.onerror=empty},false)}}inherit(JSONPPolling,Polling);JSONPPolling.prototype.supportsBinary=false;JSONPPolling.prototype.doClose=function(){if(this.script){this.script.parentNode.removeChild(this.script);this.script=null}if(this.form){this.form.parentNode.removeChild(this.form);this.form=null;this.iframe=null}Polling.prototype.doClose.call(this)};JSONPPolling.prototype.doPoll=function(){var self=this;var script=document.createElement("script");if(this.script){this.script.parentNode.removeChild(this.script);this.script=null}script.async=true;script.src=this.uri();script.onerror=function(e){self.onError("jsonp poll error",e)};var insertAt=document.getElementsByTagName("script")[0];if(insertAt){insertAt.parentNode.insertBefore(script,insertAt)}else{(document.head||document.body).appendChild(script)}this.script=script;var isUAgecko="undefined"!=typeof navigator&&/gecko/i.test(navigator.userAgent);if(isUAgecko){setTimeout(function(){var iframe=document.createElement("iframe");document.body.appendChild(iframe);document.body.removeChild(iframe)},100)}};JSONPPolling.prototype.doWrite=function(data,fn){var self=this;if(!this.form){var form=document.createElement("form");var area=document.createElement("textarea");var id=this.iframeId="eio_iframe_"+this.index;var iframe;form.className="socketio";form.style.position="absolute";form.style.top="-1000px";form.style.left="-1000px";form.target=id;form.method="POST";form.setAttribute("accept-charset","utf-8");area.name="d";form.appendChild(area);document.body.appendChild(form);this.form=form;this.area=area}this.form.action=this.uri();function complete(){initIframe();fn()}function initIframe(){if(self.iframe){try{self.form.removeChild(self.iframe)}catch(e){self.onError("jsonp polling iframe removal error",e)}}try{var html='<iframe src="javascript:0" name="'+self.iframeId+'">';iframe=document.createElement(html)}catch(e){iframe=document.createElement("iframe");iframe.name=self.iframeId;iframe.src="javascript:0"}iframe.id=self.iframeId;self.form.appendChild(iframe);self.iframe=iframe}initIframe();data=data.replace(rEscapedNewline,"\\\n");this.area.value=data.replace(rNewline,"\\n");try{this.form.submit()}catch(e){}if(this.iframe.attachEvent){this.iframe.onreadystatechange=function(){if(self.iframe.readyState=="complete"){complete()}}}else{this.iframe.onload=complete}}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./polling":8,"component-inherit":16}],7:[function(_dereq_,module,exports){(function(global){var XMLHttpRequest=_dereq_("xmlhttprequest-ssl");var Polling=_dereq_("./polling");var Emitter=_dereq_("component-emitter");var inherit=_dereq_("component-inherit");var debug=_dereq_("debug")("engine.io-client:polling-xhr");module.exports=XHR;module.exports.Request=Request;function empty(){}function XHR(opts){Polling.call(this,opts);if(global.location){var isSSL="https:"==location.protocol;var port=location.port;if(!port){port=isSSL?443:80}this.xd=opts.hostname!=global.location.hostname||port!=opts.port;this.xs=opts.secure!=isSSL}else{this.extraHeaders=opts.extraHeaders}}inherit(XHR,Polling);XHR.prototype.supportsBinary=true;XHR.prototype.request=function(opts){opts=opts||{};opts.uri=this.uri();opts.xd=this.xd;opts.xs=this.xs;opts.agent=this.agent||false;opts.supportsBinary=this.supportsBinary;opts.enablesXDR=this.enablesXDR;opts.pfx=this.pfx;opts.key=this.key;opts.passphrase=this.passphrase;opts.cert=this.cert;opts.ca=this.ca;opts.ciphers=this.ciphers;opts.rejectUnauthorized=this.rejectUnauthorized;opts.extraHeaders=this.extraHeaders;return new Request(opts)};XHR.prototype.doWrite=function(data,fn){var isBinary=typeof data!=="string"&&data!==undefined;var req=this.request({method:"POST",data:data,isBinary:isBinary});var self=this;req.on("success",fn);req.on("error",function(err){self.onError("xhr post error",err)});this.sendXhr=req};XHR.prototype.doPoll=function(){debug("xhr poll");var req=this.request();var self=this;req.on("data",function(data){self.onData(data)});req.on("error",function(err){self.onError("xhr poll error",err)});this.pollXhr=req};function Request(opts){this.method=opts.method||"GET";this.uri=opts.uri;this.xd=!!opts.xd;this.xs=!!opts.xs;this.async=false!==opts.async;this.data=undefined!=opts.data?opts.data:null;this.agent=opts.agent;this.isBinary=opts.isBinary;this.supportsBinary=opts.supportsBinary;this.enablesXDR=opts.enablesXDR;this.pfx=opts.pfx;this.key=opts.key;this.passphrase=opts.passphrase;this.cert=opts.cert;this.ca=opts.ca;this.ciphers=opts.ciphers;this.rejectUnauthorized=opts.rejectUnauthorized;this.extraHeaders=opts.extraHeaders;this.create()}Emitter(Request.prototype);Request.prototype.create=function(){var opts={agent:this.agent,xdomain:this.xd,xscheme:this.xs,enablesXDR:this.enablesXDR};opts.pfx=this.pfx;opts.key=this.key;opts.passphrase=this.passphrase;opts.cert=this.cert;opts.ca=this.ca;opts.ciphers=this.ciphers;opts.rejectUnauthorized=this.rejectUnauthorized;var xhr=this.xhr=new XMLHttpRequest(opts);var self=this;try{debug("xhr open %s: %s",this.method,this.uri);xhr.open(this.method,this.uri,this.async);try{if(this.extraHeaders){xhr.setDisableHeaderCheck(true);for(var i in this.extraHeaders){if(this.extraHeaders.hasOwnProperty(i)){xhr.setRequestHeader(i,this.extraHeaders[i])}}}}catch(e){}if(this.supportsBinary){xhr.responseType="arraybuffer"}if("POST"==this.method){try{if(this.isBinary){xhr.setRequestHeader("Content-type","application/octet-stream")}else{xhr.setRequestHeader("Content-type","text/plain;charset=UTF-8")}}catch(e){}}if("withCredentials"in xhr){xhr.withCredentials=true}if(this.hasXDR()){xhr.onload=function(){self.onLoad()};xhr.onerror=function(){self.onError(xhr.responseText)}}else{xhr.onreadystatechange=function(){if(4!=xhr.readyState)return;if(200==xhr.status||1223==xhr.status){self.onLoad()}else{setTimeout(function(){self.onError(xhr.status)},0)}}}debug("xhr data %s",this.data);xhr.send(this.data)}catch(e){setTimeout(function(){self.onError(e)},0);return}if(global.document){this.index=Request.requestsCount++;Request.requests[this.index]=this}};Request.prototype.onSuccess=function(){this.emit("success");this.cleanup()};Request.prototype.onData=function(data){this.emit("data",data);this.onSuccess()};Request.prototype.onError=function(err){this.emit("error",err);this.cleanup(true)};Request.prototype.cleanup=function(fromError){if("undefined"==typeof this.xhr||null===this.xhr){return}if(this.hasXDR()){this.xhr.onload=this.xhr.onerror=empty}else{this.xhr.onreadystatechange=empty}if(fromError){try{this.xhr.abort()}catch(e){}}if(global.document){delete Request.requests[this.index]}this.xhr=null};Request.prototype.onLoad=function(){var data;try{var contentType;try{contentType=this.xhr.getResponseHeader("Content-Type").split(";")[0]}catch(e){}if(contentType==="application/octet-stream"){data=this.xhr.response}else{if(!this.supportsBinary){data=this.xhr.responseText}else{try{data=String.fromCharCode.apply(null,new Uint8Array(this.xhr.response))}catch(e){var ui8Arr=new Uint8Array(this.xhr.response);var dataArray=[];for(var idx=0,length=ui8Arr.length;idx<length;idx++){dataArray.push(ui8Arr[idx])}data=String.fromCharCode.apply(null,dataArray)}}}}catch(e){this.onError(e)}if(null!=data){this.onData(data)}};Request.prototype.hasXDR=function(){return"undefined"!==typeof global.XDomainRequest&&!this.xs&&this.enablesXDR};Request.prototype.abort=function(){this.cleanup()};if(global.document){Request.requestsCount=0;Request.requests={};if(global.attachEvent){global.attachEvent("onunload",unloadHandler)}else if(global.addEventListener){global.addEventListener("beforeunload",unloadHandler,false)}}function unloadHandler(){for(var i in Request.requests){if(Request.requests.hasOwnProperty(i)){Request.requests[i].abort()}}}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./polling":8,"component-emitter":15,"component-inherit":16,debug:17,"xmlhttprequest-ssl":10}],8:[function(_dereq_,module,exports){var Transport=_dereq_("../transport");var parseqs=_dereq_("parseqs");var parser=_dereq_("engine.io-parser");var inherit=_dereq_("component-inherit");var yeast=_dereq_("yeast");var debug=_dereq_("debug")("engine.io-client:polling");module.exports=Polling;var hasXHR2=function(){var XMLHttpRequest=_dereq_("xmlhttprequest-ssl");var xhr=new XMLHttpRequest({xdomain:false});return null!=xhr.responseType}();function Polling(opts){var forceBase64=opts&&opts.forceBase64;if(!hasXHR2||forceBase64){this.supportsBinary=false}Transport.call(this,opts)}inherit(Polling,Transport);Polling.prototype.name="polling";Polling.prototype.doOpen=function(){this.poll()};Polling.prototype.pause=function(onPause){var pending=0;var self=this;this.readyState="pausing";function pause(){debug("paused");self.readyState="paused";onPause()}if(this.polling||!this.writable){var total=0;if(this.polling){debug("we are currently polling - waiting to pause");total++;this.once("pollComplete",function(){debug("pre-pause polling complete");--total||pause()})}if(!this.writable){debug("we are currently writing - waiting to pause");total++;this.once("drain",function(){debug("pre-pause writing complete");--total||pause()})}}else{pause()}};Polling.prototype.poll=function(){debug("polling");this.polling=true;this.doPoll();this.emit("poll")};Polling.prototype.onData=function(data){var self=this;debug("polling got data %s",data);var callback=function(packet,index,total){if("opening"==self.readyState){self.onOpen()}if("close"==packet.type){self.onClose();return false}self.onPacket(packet)};parser.decodePayload(data,this.socket.binaryType,callback);if("closed"!=this.readyState){this.polling=false;this.emit("pollComplete");if("open"==this.readyState){this.poll()}else{debug('ignoring poll - transport state "%s"',this.readyState)}}};Polling.prototype.doClose=function(){var self=this;function close(){debug("writing close packet");self.write([{type:"close"}])}if("open"==this.readyState){debug("transport open - closing");close()}else{debug("transport not open - deferring close");this.once("open",close)}};Polling.prototype.write=function(packets){var self=this;this.writable=false;var callbackfn=function(){self.writable=true;self.emit("drain")};var self=this;parser.encodePayload(packets,this.supportsBinary,function(data){self.doWrite(data,callbackfn)})};Polling.prototype.uri=function(){var query=this.query||{};var schema=this.secure?"https":"http";var port="";if(false!==this.timestampRequests){query[this.timestampParam]=yeast()}if(!this.supportsBinary&&!query.sid){query.b64=1}query=parseqs.encode(query);if(this.port&&("https"==schema&&this.port!=443||"http"==schema&&this.port!=80)){port=":"+this.port}if(query.length){query="?"+query}var ipv6=this.hostname.indexOf(":")!==-1;return schema+"://"+(ipv6?"["+this.hostname+"]":this.hostname)+port+this.path+query}},{"../transport":4,"component-inherit":16,debug:17,"engine.io-parser":19,parseqs:27,"xmlhttprequest-ssl":10,yeast:30}],9:[function(_dereq_,module,exports){(function(global){var Transport=_dereq_("../transport");var parser=_dereq_("engine.io-parser");var parseqs=_dereq_("parseqs");var inherit=_dereq_("component-inherit");var yeast=_dereq_("yeast");var debug=_dereq_("debug")("engine.io-client:websocket");var BrowserWebSocket=global.WebSocket||global.MozWebSocket;var WebSocket=BrowserWebSocket;if(!WebSocket&&typeof window==="undefined"){try{WebSocket=_dereq_("ws")}catch(e){}}module.exports=WS;function WS(opts){var forceBase64=opts&&opts.forceBase64;if(forceBase64){this.supportsBinary=false}this.perMessageDeflate=opts.perMessageDeflate;Transport.call(this,opts)}inherit(WS,Transport);WS.prototype.name="websocket";WS.prototype.supportsBinary=true;WS.prototype.doOpen=function(){if(!this.check()){return}var self=this;var uri=this.uri();var protocols=void 0;var opts={agent:this.agent,perMessageDeflate:this.perMessageDeflate};opts.pfx=this.pfx;opts.key=this.key;opts.passphrase=this.passphrase;opts.cert=this.cert;opts.ca=this.ca;opts.ciphers=this.ciphers;opts.rejectUnauthorized=this.rejectUnauthorized;if(this.extraHeaders){opts.headers=this.extraHeaders}this.ws=BrowserWebSocket?new WebSocket(uri):new WebSocket(uri,protocols,opts);if(this.ws.binaryType===undefined){this.supportsBinary=false}if(this.ws.supports&&this.ws.supports.binary){this.supportsBinary=true;this.ws.binaryType="buffer"}else{this.ws.binaryType="arraybuffer"}this.addEventListeners()};WS.prototype.addEventListeners=function(){var self=this;this.ws.onopen=function(){self.onOpen()};this.ws.onclose=function(){self.onClose()};this.ws.onmessage=function(ev){self.onData(ev.data)};this.ws.onerror=function(e){self.onError("websocket error",e)}};if("undefined"!=typeof navigator&&/iPad|iPhone|iPod/i.test(navigator.userAgent)){WS.prototype.onData=function(data){var self=this;setTimeout(function(){Transport.prototype.onData.call(self,data)},0)}}WS.prototype.write=function(packets){var self=this;this.writable=false;var total=packets.length;for(var i=0,l=total;i<l;i++){(function(packet){parser.encodePacket(packet,self.supportsBinary,function(data){if(!BrowserWebSocket){var opts={};if(packet.options){opts.compress=packet.options.compress}if(self.perMessageDeflate){var len="string"==typeof data?global.Buffer.byteLength(data):data.length;if(len<self.perMessageDeflate.threshold){opts.compress=false}}}try{if(BrowserWebSocket){self.ws.send(data)}else{self.ws.send(data,opts)}}catch(e){debug("websocket closed before onclose event")}--total||done()})})(packets[i])}function done(){self.emit("flush");setTimeout(function(){self.writable=true;self.emit("drain")},0)}};WS.prototype.onClose=function(){Transport.prototype.onClose.call(this)};WS.prototype.doClose=function(){if(typeof this.ws!=="undefined"){this.ws.close()}};WS.prototype.uri=function(){var query=this.query||{};var schema=this.secure?"wss":"ws";var port="";if(this.port&&("wss"==schema&&this.port!=443||"ws"==schema&&this.port!=80)){port=":"+this.port}if(this.timestampRequests){query[this.timestampParam]=yeast()}if(!this.supportsBinary){query.b64=1}query=parseqs.encode(query);if(query.length){query="?"+query}var ipv6=this.hostname.indexOf(":")!==-1;return schema+"://"+(ipv6?"["+this.hostname+"]":this.hostname)+port+this.path+query};WS.prototype.check=function(){return!!WebSocket&&!("__initialize"in WebSocket&&this.name===WS.prototype.name)}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"../transport":4,"component-inherit":16,debug:17,"engine.io-parser":19,parseqs:27,ws:undefined,yeast:30}],10:[function(_dereq_,module,exports){var hasCORS=_dereq_("has-cors");module.exports=function(opts){var xdomain=opts.xdomain;var xscheme=opts.xscheme;var enablesXDR=opts.enablesXDR;try{if("undefined"!=typeof XMLHttpRequest&&(!xdomain||hasCORS)){return new XMLHttpRequest}}catch(e){}try{if("undefined"!=typeof XDomainRequest&&!xscheme&&enablesXDR){return new XDomainRequest}}catch(e){}if(!xdomain){try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(e){}}}},{"has-cors":22}],11:[function(_dereq_,module,exports){module.exports=after;function after(count,callback,err_cb){var bail=false;err_cb=err_cb||noop;proxy.count=count;return count===0?callback():proxy;function proxy(err,result){if(proxy.count<=0){throw new Error("after called too many times")}--proxy.count;if(err){bail=true;callback(err);callback=err_cb}else if(proxy.count===0&&!bail){callback(null,result)}}}function noop(){}},{}],12:[function(_dereq_,module,exports){module.exports=function(arraybuffer,start,end){var bytes=arraybuffer.byteLength;start=start||0;end=end||bytes;if(arraybuffer.slice){return arraybuffer.slice(start,end)}if(start<0){start+=bytes}if(end<0){end+=bytes}if(end>bytes){end=bytes}if(start>=bytes||start>=end||bytes===0){return new ArrayBuffer(0)}var abv=new Uint8Array(arraybuffer);var result=new Uint8Array(end-start);for(var i=start,ii=0;i<end;i++,ii++){result[ii]=abv[i]}return result.buffer}},{}],13:[function(_dereq_,module,exports){(function(chars){"use strict";exports.encode=function(arraybuffer){var bytes=new Uint8Array(arraybuffer),i,len=bytes.length,base64="";for(i=0;i<len;i+=3){base64+=chars[bytes[i]>>2];
base64+=chars[(bytes[i]&3)<<4|bytes[i+1]>>4];base64+=chars[(bytes[i+1]&15)<<2|bytes[i+2]>>6];base64+=chars[bytes[i+2]&63]}if(len%3===2){base64=base64.substring(0,base64.length-1)+"="}else if(len%3===1){base64=base64.substring(0,base64.length-2)+"=="}return base64};exports.decode=function(base64){var bufferLength=base64.length*.75,len=base64.length,i,p=0,encoded1,encoded2,encoded3,encoded4;if(base64[base64.length-1]==="="){bufferLength--;if(base64[base64.length-2]==="="){bufferLength--}}var arraybuffer=new ArrayBuffer(bufferLength),bytes=new Uint8Array(arraybuffer);for(i=0;i<len;i+=4){encoded1=chars.indexOf(base64[i]);encoded2=chars.indexOf(base64[i+1]);encoded3=chars.indexOf(base64[i+2]);encoded4=chars.indexOf(base64[i+3]);bytes[p++]=encoded1<<2|encoded2>>4;bytes[p++]=(encoded2&15)<<4|encoded3>>2;bytes[p++]=(encoded3&3)<<6|encoded4&63}return arraybuffer}})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")},{}],14:[function(_dereq_,module,exports){(function(global){var BlobBuilder=global.BlobBuilder||global.WebKitBlobBuilder||global.MSBlobBuilder||global.MozBlobBuilder;var blobSupported=function(){try{var a=new Blob(["hi"]);return a.size===2}catch(e){return false}}();var blobSupportsArrayBufferView=blobSupported&&function(){try{var b=new Blob([new Uint8Array([1,2])]);return b.size===2}catch(e){return false}}();var blobBuilderSupported=BlobBuilder&&BlobBuilder.prototype.append&&BlobBuilder.prototype.getBlob;function mapArrayBufferViews(ary){for(var i=0;i<ary.length;i++){var chunk=ary[i];if(chunk.buffer instanceof ArrayBuffer){var buf=chunk.buffer;if(chunk.byteLength!==buf.byteLength){var copy=new Uint8Array(chunk.byteLength);copy.set(new Uint8Array(buf,chunk.byteOffset,chunk.byteLength));buf=copy.buffer}ary[i]=buf}}}function BlobBuilderConstructor(ary,options){options=options||{};var bb=new BlobBuilder;mapArrayBufferViews(ary);for(var i=0;i<ary.length;i++){bb.append(ary[i])}return options.type?bb.getBlob(options.type):bb.getBlob()}function BlobConstructor(ary,options){mapArrayBufferViews(ary);return new Blob(ary,options||{})}module.exports=function(){if(blobSupported){return blobSupportsArrayBufferView?global.Blob:BlobConstructor}else if(blobBuilderSupported){return BlobBuilderConstructor}else{return undefined}}()}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{}],15:[function(_dereq_,module,exports){module.exports=Emitter;function Emitter(obj){if(obj)return mixin(obj)}function mixin(obj){for(var key in Emitter.prototype){obj[key]=Emitter.prototype[key]}return obj}Emitter.prototype.on=Emitter.prototype.addEventListener=function(event,fn){this._callbacks=this._callbacks||{};(this._callbacks[event]=this._callbacks[event]||[]).push(fn);return this};Emitter.prototype.once=function(event,fn){var self=this;this._callbacks=this._callbacks||{};function on(){self.off(event,on);fn.apply(this,arguments)}on.fn=fn;this.on(event,on);return this};Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(event,fn){this._callbacks=this._callbacks||{};if(0==arguments.length){this._callbacks={};return this}var callbacks=this._callbacks[event];if(!callbacks)return this;if(1==arguments.length){delete this._callbacks[event];return this}var cb;for(var i=0;i<callbacks.length;i++){cb=callbacks[i];if(cb===fn||cb.fn===fn){callbacks.splice(i,1);break}}return this};Emitter.prototype.emit=function(event){this._callbacks=this._callbacks||{};var args=[].slice.call(arguments,1),callbacks=this._callbacks[event];if(callbacks){callbacks=callbacks.slice(0);for(var i=0,len=callbacks.length;i<len;++i){callbacks[i].apply(this,args)}}return this};Emitter.prototype.listeners=function(event){this._callbacks=this._callbacks||{};return this._callbacks[event]||[]};Emitter.prototype.hasListeners=function(event){return!!this.listeners(event).length}},{}],16:[function(_dereq_,module,exports){module.exports=function(a,b){var fn=function(){};fn.prototype=b.prototype;a.prototype=new fn;a.prototype.constructor=a}},{}],17:[function(_dereq_,module,exports){exports=module.exports=_dereq_("./debug");exports.log=log;exports.formatArgs=formatArgs;exports.save=save;exports.load=load;exports.useColors=useColors;exports.storage="undefined"!=typeof chrome&&"undefined"!=typeof chrome.storage?chrome.storage.local:localstorage();exports.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"];function useColors(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}exports.formatters.j=function(v){return JSON.stringify(v)};function formatArgs(){var args=arguments;var useColors=this.useColors;args[0]=(useColors?"%c":"")+this.namespace+(useColors?" %c":" ")+args[0]+(useColors?"%c ":" ")+"+"+exports.humanize(this.diff);if(!useColors)return args;var c="color: "+this.color;args=[args[0],c,"color: inherit"].concat(Array.prototype.slice.call(args,1));var index=0;var lastC=0;args[0].replace(/%[a-z%]/g,function(match){if("%%"===match)return;index++;if("%c"===match){lastC=index}});args.splice(lastC,0,c);return args}function log(){return"object"===typeof console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function save(namespaces){try{if(null==namespaces){exports.storage.removeItem("debug")}else{exports.storage.debug=namespaces}}catch(e){}}function load(){var r;try{r=exports.storage.debug}catch(e){}return r}exports.enable(load());function localstorage(){try{return window.localStorage}catch(e){}}},{"./debug":18}],18:[function(_dereq_,module,exports){exports=module.exports=debug;exports.coerce=coerce;exports.disable=disable;exports.enable=enable;exports.enabled=enabled;exports.humanize=_dereq_("ms");exports.names=[];exports.skips=[];exports.formatters={};var prevColor=0;var prevTime;function selectColor(){return exports.colors[prevColor++%exports.colors.length]}function debug(namespace){function disabled(){}disabled.enabled=false;function enabled(){var self=enabled;var curr=+new Date;var ms=curr-(prevTime||curr);self.diff=ms;self.prev=prevTime;self.curr=curr;prevTime=curr;if(null==self.useColors)self.useColors=exports.useColors();if(null==self.color&&self.useColors)self.color=selectColor();var args=Array.prototype.slice.call(arguments);args[0]=exports.coerce(args[0]);if("string"!==typeof args[0]){args=["%o"].concat(args)}var index=0;args[0]=args[0].replace(/%([a-z%])/g,function(match,format){if(match==="%%")return match;index++;var formatter=exports.formatters[format];if("function"===typeof formatter){var val=args[index];match=formatter.call(self,val);args.splice(index,1);index--}return match});if("function"===typeof exports.formatArgs){args=exports.formatArgs.apply(self,args)}var logFn=enabled.log||exports.log||console.log.bind(console);logFn.apply(self,args)}enabled.enabled=true;var fn=exports.enabled(namespace)?enabled:disabled;fn.namespace=namespace;return fn}function enable(namespaces){exports.save(namespaces);var split=(namespaces||"").split(/[\s,]+/);var len=split.length;for(var i=0;i<len;i++){if(!split[i])continue;namespaces=split[i].replace(/\*/g,".*?");if(namespaces[0]==="-"){exports.skips.push(new RegExp("^"+namespaces.substr(1)+"$"))}else{exports.names.push(new RegExp("^"+namespaces+"$"))}}}function disable(){exports.enable("")}function enabled(name){var i,len;for(i=0,len=exports.skips.length;i<len;i++){if(exports.skips[i].test(name)){return false}}for(i=0,len=exports.names.length;i<len;i++){if(exports.names[i].test(name)){return true}}return false}function coerce(val){if(val instanceof Error)return val.stack||val.message;return val}},{ms:25}],19:[function(_dereq_,module,exports){(function(global){var keys=_dereq_("./keys");var hasBinary=_dereq_("has-binary");var sliceBuffer=_dereq_("arraybuffer.slice");var base64encoder=_dereq_("base64-arraybuffer");var after=_dereq_("after");var utf8=_dereq_("utf8");var isAndroid=navigator.userAgent.match(/Android/i);var isPhantomJS=/PhantomJS/i.test(navigator.userAgent);var dontSendBlobs=isAndroid||isPhantomJS;exports.protocol=3;var packets=exports.packets={open:0,close:1,ping:2,pong:3,message:4,upgrade:5,noop:6};var packetslist=keys(packets);var err={type:"error",data:"parser error"};var Blob=_dereq_("blob");exports.encodePacket=function(packet,supportsBinary,utf8encode,callback){if("function"==typeof supportsBinary){callback=supportsBinary;supportsBinary=false}if("function"==typeof utf8encode){callback=utf8encode;utf8encode=null}var data=packet.data===undefined?undefined:packet.data.buffer||packet.data;if(global.ArrayBuffer&&data instanceof ArrayBuffer){return encodeArrayBuffer(packet,supportsBinary,callback)}else if(Blob&&data instanceof global.Blob){return encodeBlob(packet,supportsBinary,callback)}if(data&&data.base64){return encodeBase64Object(packet,callback)}var encoded=packets[packet.type];if(undefined!==packet.data){encoded+=utf8encode?utf8.encode(String(packet.data)):String(packet.data)}return callback(""+encoded)};function encodeBase64Object(packet,callback){var message="b"+exports.packets[packet.type]+packet.data.data;return callback(message)}function encodeArrayBuffer(packet,supportsBinary,callback){if(!supportsBinary){return exports.encodeBase64Packet(packet,callback)}var data=packet.data;var contentArray=new Uint8Array(data);var resultBuffer=new Uint8Array(1+data.byteLength);resultBuffer[0]=packets[packet.type];for(var i=0;i<contentArray.length;i++){resultBuffer[i+1]=contentArray[i]}return callback(resultBuffer.buffer)}function encodeBlobAsArrayBuffer(packet,supportsBinary,callback){if(!supportsBinary){return exports.encodeBase64Packet(packet,callback)}var fr=new FileReader;fr.onload=function(){packet.data=fr.result;exports.encodePacket(packet,supportsBinary,true,callback)};return fr.readAsArrayBuffer(packet.data)}function encodeBlob(packet,supportsBinary,callback){if(!supportsBinary){return exports.encodeBase64Packet(packet,callback)}if(dontSendBlobs){return encodeBlobAsArrayBuffer(packet,supportsBinary,callback)}var length=new Uint8Array(1);length[0]=packets[packet.type];var blob=new Blob([length.buffer,packet.data]);return callback(blob)}exports.encodeBase64Packet=function(packet,callback){var message="b"+exports.packets[packet.type];if(Blob&&packet.data instanceof global.Blob){var fr=new FileReader;fr.onload=function(){var b64=fr.result.split(",")[1];callback(message+b64)};return fr.readAsDataURL(packet.data)}var b64data;try{b64data=String.fromCharCode.apply(null,new Uint8Array(packet.data))}catch(e){var typed=new Uint8Array(packet.data);var basic=new Array(typed.length);for(var i=0;i<typed.length;i++){basic[i]=typed[i]}b64data=String.fromCharCode.apply(null,basic)}message+=global.btoa(b64data);return callback(message)};exports.decodePacket=function(data,binaryType,utf8decode){if(typeof data=="string"||data===undefined){if(data.charAt(0)=="b"){return exports.decodeBase64Packet(data.substr(1),binaryType)}if(utf8decode){try{data=utf8.decode(data)}catch(e){return err}}var type=data.charAt(0);if(Number(type)!=type||!packetslist[type]){return err}if(data.length>1){return{type:packetslist[type],data:data.substring(1)}}else{return{type:packetslist[type]}}}var asArray=new Uint8Array(data);var type=asArray[0];var rest=sliceBuffer(data,1);if(Blob&&binaryType==="blob"){rest=new Blob([rest])}return{type:packetslist[type],data:rest}};exports.decodeBase64Packet=function(msg,binaryType){var type=packetslist[msg.charAt(0)];if(!global.ArrayBuffer){return{type:type,data:{base64:true,data:msg.substr(1)}}}var data=base64encoder.decode(msg.substr(1));if(binaryType==="blob"&&Blob){data=new Blob([data])}return{type:type,data:data}};exports.encodePayload=function(packets,supportsBinary,callback){if(typeof supportsBinary=="function"){callback=supportsBinary;supportsBinary=null}var isBinary=hasBinary(packets);if(supportsBinary&&isBinary){if(Blob&&!dontSendBlobs){return exports.encodePayloadAsBlob(packets,callback)}return exports.encodePayloadAsArrayBuffer(packets,callback)}if(!packets.length){return callback("0:")}function setLengthHeader(message){return message.length+":"+message}function encodeOne(packet,doneCallback){exports.encodePacket(packet,!isBinary?false:supportsBinary,true,function(message){doneCallback(null,setLengthHeader(message))})}map(packets,encodeOne,function(err,results){return callback(results.join(""))})};function map(ary,each,done){var result=new Array(ary.length);var next=after(ary.length,done);var eachWithIndex=function(i,el,cb){each(el,function(error,msg){result[i]=msg;cb(error,result)})};for(var i=0;i<ary.length;i++){eachWithIndex(i,ary[i],next)}}exports.decodePayload=function(data,binaryType,callback){if(typeof data!="string"){return exports.decodePayloadAsBinary(data,binaryType,callback)}if(typeof binaryType==="function"){callback=binaryType;binaryType=null}var packet;if(data==""){return callback(err,0,1)}var length="",n,msg;for(var i=0,l=data.length;i<l;i++){var chr=data.charAt(i);if(":"!=chr){length+=chr}else{if(""==length||length!=(n=Number(length))){return callback(err,0,1)}msg=data.substr(i+1,n);if(length!=msg.length){return callback(err,0,1)}if(msg.length){packet=exports.decodePacket(msg,binaryType,true);if(err.type==packet.type&&err.data==packet.data){return callback(err,0,1)}var ret=callback(packet,i+n,l);if(false===ret)return}i+=n;length=""}}if(length!=""){return callback(err,0,1)}};exports.encodePayloadAsArrayBuffer=function(packets,callback){if(!packets.length){return callback(new ArrayBuffer(0))}function encodeOne(packet,doneCallback){exports.encodePacket(packet,true,true,function(data){return doneCallback(null,data)})}map(packets,encodeOne,function(err,encodedPackets){var totalLength=encodedPackets.reduce(function(acc,p){var len;if(typeof p==="string"){len=p.length}else{len=p.byteLength}return acc+len.toString().length+len+2},0);var resultArray=new Uint8Array(totalLength);var bufferIndex=0;encodedPackets.forEach(function(p){var isString=typeof p==="string";var ab=p;if(isString){var view=new Uint8Array(p.length);for(var i=0;i<p.length;i++){view[i]=p.charCodeAt(i)}ab=view.buffer}if(isString){resultArray[bufferIndex++]=0}else{resultArray[bufferIndex++]=1}var lenStr=ab.byteLength.toString();for(var i=0;i<lenStr.length;i++){resultArray[bufferIndex++]=parseInt(lenStr[i])}resultArray[bufferIndex++]=255;var view=new Uint8Array(ab);for(var i=0;i<view.length;i++){resultArray[bufferIndex++]=view[i]}});return callback(resultArray.buffer)})};exports.encodePayloadAsBlob=function(packets,callback){function encodeOne(packet,doneCallback){exports.encodePacket(packet,true,true,function(encoded){var binaryIdentifier=new Uint8Array(1);binaryIdentifier[0]=1;if(typeof encoded==="string"){var view=new Uint8Array(encoded.length);for(var i=0;i<encoded.length;i++){view[i]=encoded.charCodeAt(i)}encoded=view.buffer;binaryIdentifier[0]=0}var len=encoded instanceof ArrayBuffer?encoded.byteLength:encoded.size;var lenStr=len.toString();var lengthAry=new Uint8Array(lenStr.length+1);for(var i=0;i<lenStr.length;i++){lengthAry[i]=parseInt(lenStr[i])}lengthAry[lenStr.length]=255;if(Blob){var blob=new Blob([binaryIdentifier.buffer,lengthAry.buffer,encoded]);doneCallback(null,blob)}})}map(packets,encodeOne,function(err,results){return callback(new Blob(results))})};exports.decodePayloadAsBinary=function(data,binaryType,callback){if(typeof binaryType==="function"){callback=binaryType;binaryType=null}var bufferTail=data;var buffers=[];var numberTooLong=false;while(bufferTail.byteLength>0){var tailArray=new Uint8Array(bufferTail);var isString=tailArray[0]===0;var msgLength="";for(var i=1;;i++){if(tailArray[i]==255)break;if(msgLength.length>310){numberTooLong=true;break}msgLength+=tailArray[i]}if(numberTooLong)return callback(err,0,1);bufferTail=sliceBuffer(bufferTail,2+msgLength.length);msgLength=parseInt(msgLength);var msg=sliceBuffer(bufferTail,0,msgLength);if(isString){try{msg=String.fromCharCode.apply(null,new Uint8Array(msg))}catch(e){var typed=new Uint8Array(msg);msg="";for(var i=0;i<typed.length;i++){msg+=String.fromCharCode(typed[i])}}}buffers.push(msg);bufferTail=sliceBuffer(bufferTail,msgLength)}var total=buffers.length;buffers.forEach(function(buffer,i){callback(exports.decodePacket(buffer,binaryType,true),i,total)})}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./keys":20,after:11,"arraybuffer.slice":12,"base64-arraybuffer":13,blob:14,"has-binary":21,utf8:29}],20:[function(_dereq_,module,exports){module.exports=Object.keys||function keys(obj){var arr=[];var has=Object.prototype.hasOwnProperty;for(var i in obj){if(has.call(obj,i)){arr.push(i)}}return arr}},{}],21:[function(_dereq_,module,exports){(function(global){var isArray=_dereq_("isarray");module.exports=hasBinary;function hasBinary(data){function _hasBinary(obj){if(!obj)return false;if(global.Buffer&&global.Buffer.isBuffer(obj)||global.ArrayBuffer&&obj instanceof ArrayBuffer||global.Blob&&obj instanceof Blob||global.File&&obj instanceof File){return true}if(isArray(obj)){for(var i=0;i<obj.length;i++){if(_hasBinary(obj[i])){return true}}}else if(obj&&"object"==typeof obj){if(obj.toJSON){obj=obj.toJSON()}for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)&&_hasBinary(obj[key])){return true}}}return false}return _hasBinary(data)}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{isarray:24}],22:[function(_dereq_,module,exports){try{module.exports=typeof XMLHttpRequest!=="undefined"&&"withCredentials"in new XMLHttpRequest}catch(err){module.exports=false}},{}],23:[function(_dereq_,module,exports){var indexOf=[].indexOf;module.exports=function(arr,obj){if(indexOf)return arr.indexOf(obj);for(var i=0;i<arr.length;++i){if(arr[i]===obj)return i}return-1}},{}],24:[function(_dereq_,module,exports){module.exports=Array.isArray||function(arr){return Object.prototype.toString.call(arr)=="[object Array]"}},{}],25:[function(_dereq_,module,exports){var s=1e3;var m=s*60;var h=m*60;var d=h*24;var y=d*365.25;module.exports=function(val,options){options=options||{};if("string"==typeof val)return parse(val);return options.long?long(val):short(val)};function parse(str){str=""+str;if(str.length>1e4)return;var match=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);if(!match)return;var n=parseFloat(match[1]);var type=(match[2]||"ms").toLowerCase();switch(type){case"years":case"year":case"yrs":case"yr":case"y":return n*y;case"days":case"day":case"d":return n*d;case"hours":case"hour":case"hrs":case"hr":case"h":return n*h;case"minutes":case"minute":case"mins":case"min":case"m":return n*m;case"seconds":case"second":case"secs":case"sec":case"s":return n*s;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n}}function short(ms){if(ms>=d)return Math.round(ms/d)+"d";if(ms>=h)return Math.round(ms/h)+"h";if(ms>=m)return Math.round(ms/m)+"m";if(ms>=s)return Math.round(ms/s)+"s";return ms+"ms"}function long(ms){return plural(ms,d,"day")||plural(ms,h,"hour")||plural(ms,m,"minute")||plural(ms,s,"second")||ms+" ms"}function plural(ms,n,name){if(ms<n)return;if(ms<n*1.5)return Math.floor(ms/n)+" "+name;return Math.ceil(ms/n)+" "+name+"s"}},{}],26:[function(_dereq_,module,exports){(function(global){var rvalidchars=/^[\],:{}\s]*$/;var rvalidescape=/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;var rvalidtokens=/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;var rvalidbraces=/(?:^|:|,)(?:\s*\[)+/g;var rtrimLeft=/^\s+/;var rtrimRight=/\s+$/;module.exports=function parsejson(data){if("string"!=typeof data||!data){return null}data=data.replace(rtrimLeft,"").replace(rtrimRight,"");if(global.JSON&&JSON.parse){return JSON.parse(data)}if(rvalidchars.test(data.replace(rvalidescape,"@").replace(rvalidtokens,"]").replace(rvalidbraces,""))){return new Function("return "+data)()}}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{}],27:[function(_dereq_,module,exports){exports.encode=function(obj){var str="";for(var i in obj){if(obj.hasOwnProperty(i)){if(str.length)str+="&";str+=encodeURIComponent(i)+"="+encodeURIComponent(obj[i])}}return str};exports.decode=function(qs){var qry={};var pairs=qs.split("&");for(var i=0,l=pairs.length;i<l;i++){var pair=pairs[i].split("=");qry[decodeURIComponent(pair[0])]=decodeURIComponent(pair[1])}return qry}},{}],28:[function(_dereq_,module,exports){var re=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;var parts=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];module.exports=function parseuri(str){var src=str,b=str.indexOf("["),e=str.indexOf("]");if(b!=-1&&e!=-1){str=str.substring(0,b)+str.substring(b,e).replace(/:/g,";")+str.substring(e,str.length)}var m=re.exec(str||""),uri={},i=14;while(i--){uri[parts[i]]=m[i]||""}if(b!=-1&&e!=-1){uri.source=src;uri.host=uri.host.substring(1,uri.host.length-1).replace(/;/g,":");uri.authority=uri.authority.replace("[","").replace("]","").replace(/;/g,":");uri.ipv6uri=true}return uri}},{}],29:[function(_dereq_,module,exports){(function(global){(function(root){var freeExports=typeof exports=="object"&&exports;var freeModule=typeof module=="object"&&module&&module.exports==freeExports&&module;var freeGlobal=typeof global=="object"&&global;if(freeGlobal.global===freeGlobal||freeGlobal.window===freeGlobal){root=freeGlobal}var stringFromCharCode=String.fromCharCode;function ucs2decode(string){var output=[];var counter=0;var length=string.length;var value;var extra;while(counter<length){value=string.charCodeAt(counter++);if(value>=55296&&value<=56319&&counter<length){extra=string.charCodeAt(counter++);if((extra&64512)==56320){output.push(((value&1023)<<10)+(extra&1023)+65536)}else{output.push(value);counter--}}else{output.push(value)}}return output}function ucs2encode(array){var length=array.length;var index=-1;var value;var output="";while(++index<length){value=array[index];if(value>65535){value-=65536;output+=stringFromCharCode(value>>>10&1023|55296);value=56320|value&1023}output+=stringFromCharCode(value)}return output}function checkScalarValue(codePoint){if(codePoint>=55296&&codePoint<=57343){throw Error("Lone surrogate U+"+codePoint.toString(16).toUpperCase()+" is not a scalar value")}}function createByte(codePoint,shift){return stringFromCharCode(codePoint>>shift&63|128)}function encodeCodePoint(codePoint){if((codePoint&4294967168)==0){return stringFromCharCode(codePoint)}var symbol="";if((codePoint&4294965248)==0){symbol=stringFromCharCode(codePoint>>6&31|192)}else if((codePoint&4294901760)==0){checkScalarValue(codePoint);symbol=stringFromCharCode(codePoint>>12&15|224);symbol+=createByte(codePoint,6)}else if((codePoint&4292870144)==0){symbol=stringFromCharCode(codePoint>>18&7|240);symbol+=createByte(codePoint,12);symbol+=createByte(codePoint,6)}symbol+=stringFromCharCode(codePoint&63|128);return symbol}function utf8encode(string){var codePoints=ucs2decode(string);var length=codePoints.length;var index=-1;var codePoint;var byteString="";while(++index<length){codePoint=codePoints[index];byteString+=encodeCodePoint(codePoint)}return byteString}function readContinuationByte(){if(byteIndex>=byteCount){throw Error("Invalid byte index")}var continuationByte=byteArray[byteIndex]&255;byteIndex++;if((continuationByte&192)==128){return continuationByte&63}throw Error("Invalid continuation byte")}function decodeSymbol(){var byte1;var byte2;var byte3;var byte4;var codePoint;if(byteIndex>byteCount){throw Error("Invalid byte index")}if(byteIndex==byteCount){return false}byte1=byteArray[byteIndex]&255;byteIndex++;if((byte1&128)==0){return byte1}if((byte1&224)==192){var byte2=readContinuationByte();codePoint=(byte1&31)<<6|byte2;if(codePoint>=128){return codePoint}else{throw Error("Invalid continuation byte")}}if((byte1&240)==224){byte2=readContinuationByte();byte3=readContinuationByte();codePoint=(byte1&15)<<12|byte2<<6|byte3;if(codePoint>=2048){checkScalarValue(codePoint);return codePoint}else{throw Error("Invalid continuation byte")}}if((byte1&248)==240){byte2=readContinuationByte();byte3=readContinuationByte();byte4=readContinuationByte();codePoint=(byte1&15)<<18|byte2<<12|byte3<<6|byte4;if(codePoint>=65536&&codePoint<=1114111){return codePoint}}throw Error("Invalid UTF-8 detected")}var byteArray;var byteCount;var byteIndex;function utf8decode(byteString){byteArray=ucs2decode(byteString);byteCount=byteArray.length;byteIndex=0;var codePoints=[];var tmp;while((tmp=decodeSymbol())!==false){codePoints.push(tmp)}return ucs2encode(codePoints)}var utf8={version:"2.0.0",encode:utf8encode,decode:utf8decode};if(typeof define=="function"&&typeof define.amd=="object"&&define.amd){define(function(){return utf8})}else if(freeExports&&!freeExports.nodeType){if(freeModule){freeModule.exports=utf8}else{var object={};var hasOwnProperty=object.hasOwnProperty;for(var key in utf8){hasOwnProperty.call(utf8,key)&&(freeExports[key]=utf8[key])}}}else{root.utf8=utf8}})(this)}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{}],30:[function(_dereq_,module,exports){"use strict";var alphabet="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),length=64,map={},seed=0,i=0,prev;function encode(num){var encoded="";do{encoded=alphabet[num%length]+encoded;num=Math.floor(num/length)}while(num>0);return encoded}function decode(str){var decoded=0;for(i=0;i<str.length;i++){decoded=decoded*length+map[str.charAt(i)]}return decoded}function yeast(){var now=encode(+new Date);if(now!==prev)return seed=0,prev=now;return now+"."+encode(seed++)}for(;i<length;i++)map[alphabet[i]]=i;yeast.encode=encode;yeast.decode=decode;module.exports=yeast},{}],31:[function(_dereq_,module,exports){var url=_dereq_("./url");var parser=_dereq_("socket.io-parser");var Manager=_dereq_("./manager");var debug=_dereq_("debug")("socket.io-client");module.exports=exports=lookup;var cache=exports.managers={};function lookup(uri,opts){if(typeof uri=="object"){opts=uri;uri=undefined}opts=opts||{};var parsed=url(uri);var source=parsed.source;var id=parsed.id;var path=parsed.path;var sameNamespace=cache[id]&&path in cache[id].nsps;var newConnection=opts.forceNew||opts["force new connection"]||false===opts.multiplex||sameNamespace;var io;if(newConnection){debug("ignoring socket cache for %s",source);io=Manager(source,opts)}else{if(!cache[id]){debug("new io instance for %s",source);cache[id]=Manager(source,opts)}io=cache[id]}return io.socket(parsed.path)}exports.protocol=parser.protocol;exports.connect=lookup;exports.Manager=_dereq_("./manager");exports.Socket=_dereq_("./socket")},{"./manager":32,"./socket":34,"./url":35,debug:39,"socket.io-parser":47}],32:[function(_dereq_,module,exports){var eio=_dereq_("engine.io-client");var Socket=_dereq_("./socket");var Emitter=_dereq_("component-emitter");var parser=_dereq_("socket.io-parser");var on=_dereq_("./on");var bind=_dereq_("component-bind");var debug=_dereq_("debug")("socket.io-client:manager");var indexOf=_dereq_("indexof");var Backoff=_dereq_("backo2");var has=Object.prototype.hasOwnProperty;module.exports=Manager;function Manager(uri,opts){if(!(this instanceof Manager))return new Manager(uri,opts);if(uri&&"object"==typeof uri){opts=uri;uri=undefined}opts=opts||{};opts.path=opts.path||"/socket.io";this.nsps={};this.subs=[];this.opts=opts;this.reconnection(opts.reconnection!==false);this.reconnectionAttempts(opts.reconnectionAttempts||Infinity);this.reconnectionDelay(opts.reconnectionDelay||1e3);this.reconnectionDelayMax(opts.reconnectionDelayMax||5e3);this.randomizationFactor(opts.randomizationFactor||.5);this.backoff=new Backoff({min:this.reconnectionDelay(),max:this.reconnectionDelayMax(),jitter:this.randomizationFactor()});this.timeout(null==opts.timeout?2e4:opts.timeout);this.readyState="closed";this.uri=uri;this.connecting=[];this.lastPing=null;this.encoding=false;this.packetBuffer=[];this.encoder=new parser.Encoder;this.decoder=new parser.Decoder;this.autoConnect=opts.autoConnect!==false;if(this.autoConnect)this.open()}Manager.prototype.emitAll=function(){this.emit.apply(this,arguments);for(var nsp in this.nsps){if(has.call(this.nsps,nsp)){this.nsps[nsp].emit.apply(this.nsps[nsp],arguments)}}};Manager.prototype.updateSocketIds=function(){for(var nsp in this.nsps){if(has.call(this.nsps,nsp)){this.nsps[nsp].id=this.engine.id}}};Emitter(Manager.prototype);Manager.prototype.reconnection=function(v){if(!arguments.length)return this._reconnection;this._reconnection=!!v;return this};Manager.prototype.reconnectionAttempts=function(v){if(!arguments.length)return this._reconnectionAttempts;this._reconnectionAttempts=v;return this};Manager.prototype.reconnectionDelay=function(v){if(!arguments.length)return this._reconnectionDelay;this._reconnectionDelay=v;this.backoff&&this.backoff.setMin(v);return this};Manager.prototype.randomizationFactor=function(v){if(!arguments.length)return this._randomizationFactor;this._randomizationFactor=v;this.backoff&&this.backoff.setJitter(v);return this};Manager.prototype.reconnectionDelayMax=function(v){if(!arguments.length)return this._reconnectionDelayMax;this._reconnectionDelayMax=v;this.backoff&&this.backoff.setMax(v);return this};Manager.prototype.timeout=function(v){if(!arguments.length)return this._timeout;this._timeout=v;return this};Manager.prototype.maybeReconnectOnOpen=function(){if(!this.reconnecting&&this._reconnection&&this.backoff.attempts===0){this.reconnect()}};Manager.prototype.open=Manager.prototype.connect=function(fn){debug("readyState %s",this.readyState);if(~this.readyState.indexOf("open"))return this;debug("opening %s",this.uri);this.engine=eio(this.uri,this.opts);var socket=this.engine;var self=this;this.readyState="opening";this.skipReconnect=false;var openSub=on(socket,"open",function(){self.onopen();fn&&fn()});var errorSub=on(socket,"error",function(data){debug("connect_error");self.cleanup();self.readyState="closed";self.emitAll("connect_error",data);if(fn){var err=new Error("Connection error");err.data=data;fn(err)}else{self.maybeReconnectOnOpen()}});if(false!==this._timeout){var timeout=this._timeout;debug("connect attempt will timeout after %d",timeout);var timer=setTimeout(function(){debug("connect attempt timed out after %d",timeout);openSub.destroy();socket.close();socket.emit("error","timeout");self.emitAll("connect_timeout",timeout)},timeout);this.subs.push({destroy:function(){clearTimeout(timer)}})}this.subs.push(openSub);this.subs.push(errorSub);return this};Manager.prototype.onopen=function(){debug("open");this.cleanup();this.readyState="open";this.emit("open");var socket=this.engine;this.subs.push(on(socket,"data",bind(this,"ondata")));this.subs.push(on(socket,"ping",bind(this,"onping")));this.subs.push(on(socket,"pong",bind(this,"onpong")));this.subs.push(on(socket,"error",bind(this,"onerror")));this.subs.push(on(socket,"close",bind(this,"onclose")));this.subs.push(on(this.decoder,"decoded",bind(this,"ondecoded")))};Manager.prototype.onping=function(){this.lastPing=new Date;this.emitAll("ping")};Manager.prototype.onpong=function(){this.emitAll("pong",new Date-this.lastPing)};Manager.prototype.ondata=function(data){this.decoder.add(data)};Manager.prototype.ondecoded=function(packet){this.emit("packet",packet)};Manager.prototype.onerror=function(err){debug("error",err);this.emitAll("error",err)};Manager.prototype.socket=function(nsp){var socket=this.nsps[nsp];if(!socket){socket=new Socket(this,nsp);this.nsps[nsp]=socket;var self=this;socket.on("connecting",onConnecting);
socket.on("connect",function(){socket.id=self.engine.id});if(this.autoConnect){onConnecting()}}function onConnecting(){if(!~indexOf(self.connecting,socket)){self.connecting.push(socket)}}return socket};Manager.prototype.destroy=function(socket){var index=indexOf(this.connecting,socket);if(~index)this.connecting.splice(index,1);if(this.connecting.length)return;this.close()};Manager.prototype.packet=function(packet){debug("writing packet %j",packet);var self=this;if(!self.encoding){self.encoding=true;this.encoder.encode(packet,function(encodedPackets){for(var i=0;i<encodedPackets.length;i++){self.engine.write(encodedPackets[i],packet.options)}self.encoding=false;self.processPacketQueue()})}else{self.packetBuffer.push(packet)}};Manager.prototype.processPacketQueue=function(){if(this.packetBuffer.length>0&&!this.encoding){var pack=this.packetBuffer.shift();this.packet(pack)}};Manager.prototype.cleanup=function(){debug("cleanup");var sub;while(sub=this.subs.shift())sub.destroy();this.packetBuffer=[];this.encoding=false;this.lastPing=null;this.decoder.destroy()};Manager.prototype.close=Manager.prototype.disconnect=function(){debug("disconnect");this.skipReconnect=true;this.reconnecting=false;if("opening"==this.readyState){this.cleanup()}this.backoff.reset();this.readyState="closed";if(this.engine)this.engine.close()};Manager.prototype.onclose=function(reason){debug("onclose");this.cleanup();this.backoff.reset();this.readyState="closed";this.emit("close",reason);if(this._reconnection&&!this.skipReconnect){this.reconnect()}};Manager.prototype.reconnect=function(){if(this.reconnecting||this.skipReconnect)return this;var self=this;if(this.backoff.attempts>=this._reconnectionAttempts){debug("reconnect failed");this.backoff.reset();this.emitAll("reconnect_failed");this.reconnecting=false}else{var delay=this.backoff.duration();debug("will wait %dms before reconnect attempt",delay);this.reconnecting=true;var timer=setTimeout(function(){if(self.skipReconnect)return;debug("attempting reconnect");self.emitAll("reconnect_attempt",self.backoff.attempts);self.emitAll("reconnecting",self.backoff.attempts);if(self.skipReconnect)return;self.open(function(err){if(err){debug("reconnect attempt error");self.reconnecting=false;self.reconnect();self.emitAll("reconnect_error",err.data)}else{debug("reconnect success");self.onreconnect()}})},delay);this.subs.push({destroy:function(){clearTimeout(timer)}})}};Manager.prototype.onreconnect=function(){var attempt=this.backoff.attempts;this.reconnecting=false;this.backoff.reset();this.updateSocketIds();this.emitAll("reconnect",attempt)}},{"./on":33,"./socket":34,backo2:36,"component-bind":37,"component-emitter":38,debug:39,"engine.io-client":1,indexof:42,"socket.io-parser":47}],33:[function(_dereq_,module,exports){module.exports=on;function on(obj,ev,fn){obj.on(ev,fn);return{destroy:function(){obj.removeListener(ev,fn)}}}},{}],34:[function(_dereq_,module,exports){var parser=_dereq_("socket.io-parser");var Emitter=_dereq_("component-emitter");var toArray=_dereq_("to-array");var on=_dereq_("./on");var bind=_dereq_("component-bind");var debug=_dereq_("debug")("socket.io-client:socket");var hasBin=_dereq_("has-binary");module.exports=exports=Socket;var events={connect:1,connect_error:1,connect_timeout:1,connecting:1,disconnect:1,error:1,reconnect:1,reconnect_attempt:1,reconnect_failed:1,reconnect_error:1,reconnecting:1,ping:1,pong:1};var emit=Emitter.prototype.emit;function Socket(io,nsp){this.io=io;this.nsp=nsp;this.json=this;this.ids=0;this.acks={};this.receiveBuffer=[];this.sendBuffer=[];this.connected=false;this.disconnected=true;if(this.io.autoConnect)this.open()}Emitter(Socket.prototype);Socket.prototype.subEvents=function(){if(this.subs)return;var io=this.io;this.subs=[on(io,"open",bind(this,"onopen")),on(io,"packet",bind(this,"onpacket")),on(io,"close",bind(this,"onclose"))]};Socket.prototype.open=Socket.prototype.connect=function(){if(this.connected)return this;this.subEvents();this.io.open();if("open"==this.io.readyState)this.onopen();this.emit("connecting");return this};Socket.prototype.send=function(){var args=toArray(arguments);args.unshift("message");this.emit.apply(this,args);return this};Socket.prototype.emit=function(ev){if(events.hasOwnProperty(ev)){emit.apply(this,arguments);return this}var args=toArray(arguments);var parserType=parser.EVENT;if(hasBin(args)){parserType=parser.BINARY_EVENT}var packet={type:parserType,data:args};packet.options={};packet.options.compress=!this.flags||false!==this.flags.compress;if("function"==typeof args[args.length-1]){debug("emitting packet with ack id %d",this.ids);this.acks[this.ids]=args.pop();packet.id=this.ids++}if(this.connected){this.packet(packet)}else{this.sendBuffer.push(packet)}delete this.flags;return this};Socket.prototype.packet=function(packet){packet.nsp=this.nsp;this.io.packet(packet)};Socket.prototype.onopen=function(){debug("transport is open - connecting");if("/"!=this.nsp){this.packet({type:parser.CONNECT})}};Socket.prototype.onclose=function(reason){debug("close (%s)",reason);this.connected=false;this.disconnected=true;delete this.id;this.emit("disconnect",reason)};Socket.prototype.onpacket=function(packet){if(packet.nsp!=this.nsp)return;switch(packet.type){case parser.CONNECT:this.onconnect();break;case parser.EVENT:this.onevent(packet);break;case parser.BINARY_EVENT:this.onevent(packet);break;case parser.ACK:this.onack(packet);break;case parser.BINARY_ACK:this.onack(packet);break;case parser.DISCONNECT:this.ondisconnect();break;case parser.ERROR:this.emit("error",packet.data);break}};Socket.prototype.onevent=function(packet){var args=packet.data||[];debug("emitting event %j",args);if(null!=packet.id){debug("attaching ack callback to event");args.push(this.ack(packet.id))}if(this.connected){emit.apply(this,args)}else{this.receiveBuffer.push(args)}};Socket.prototype.ack=function(id){var self=this;var sent=false;return function(){if(sent)return;sent=true;var args=toArray(arguments);debug("sending ack %j",args);var type=hasBin(args)?parser.BINARY_ACK:parser.ACK;self.packet({type:type,id:id,data:args})}};Socket.prototype.onack=function(packet){var ack=this.acks[packet.id];if("function"==typeof ack){debug("calling ack %s with %j",packet.id,packet.data);ack.apply(this,packet.data);delete this.acks[packet.id]}else{debug("bad ack %s",packet.id)}};Socket.prototype.onconnect=function(){this.connected=true;this.disconnected=false;this.emit("connect");this.emitBuffered()};Socket.prototype.emitBuffered=function(){var i;for(i=0;i<this.receiveBuffer.length;i++){emit.apply(this,this.receiveBuffer[i])}this.receiveBuffer=[];for(i=0;i<this.sendBuffer.length;i++){this.packet(this.sendBuffer[i])}this.sendBuffer=[]};Socket.prototype.ondisconnect=function(){debug("server disconnect (%s)",this.nsp);this.destroy();this.onclose("io server disconnect")};Socket.prototype.destroy=function(){if(this.subs){for(var i=0;i<this.subs.length;i++){this.subs[i].destroy()}this.subs=null}this.io.destroy(this)};Socket.prototype.close=Socket.prototype.disconnect=function(){if(this.connected){debug("performing disconnect (%s)",this.nsp);this.packet({type:parser.DISCONNECT})}this.destroy();if(this.connected){this.onclose("io client disconnect")}return this};Socket.prototype.compress=function(compress){this.flags=this.flags||{};this.flags.compress=compress;return this}},{"./on":33,"component-bind":37,"component-emitter":38,debug:39,"has-binary":41,"socket.io-parser":47,"to-array":51}],35:[function(_dereq_,module,exports){(function(global){var parseuri=_dereq_("parseuri");var debug=_dereq_("debug")("socket.io-client:url");module.exports=url;function url(uri,loc){var obj=uri;var loc=loc||global.location;if(null==uri)uri=loc.protocol+"//"+loc.host;if("string"==typeof uri){if("/"==uri.charAt(0)){if("/"==uri.charAt(1)){uri=loc.protocol+uri}else{uri=loc.host+uri}}if(!/^(https?|wss?):\/\//.test(uri)){debug("protocol-less url %s",uri);if("undefined"!=typeof loc){uri=loc.protocol+"//"+uri}else{uri="https://"+uri}}debug("parse %s",uri);obj=parseuri(uri)}if(!obj.port){if(/^(http|ws)$/.test(obj.protocol)){obj.port="80"}else if(/^(http|ws)s$/.test(obj.protocol)){obj.port="443"}}obj.path=obj.path||"/";var ipv6=obj.host.indexOf(":")!==-1;var host=ipv6?"["+obj.host+"]":obj.host;obj.id=obj.protocol+"://"+host+":"+obj.port;obj.href=obj.protocol+"://"+host+(loc&&loc.port==obj.port?"":":"+obj.port);return obj}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{debug:39,parseuri:45}],36:[function(_dereq_,module,exports){module.exports=Backoff;function Backoff(opts){opts=opts||{};this.ms=opts.min||100;this.max=opts.max||1e4;this.factor=opts.factor||2;this.jitter=opts.jitter>0&&opts.jitter<=1?opts.jitter:0;this.attempts=0}Backoff.prototype.duration=function(){var ms=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var rand=Math.random();var deviation=Math.floor(rand*this.jitter*ms);ms=(Math.floor(rand*10)&1)==0?ms-deviation:ms+deviation}return Math.min(ms,this.max)|0};Backoff.prototype.reset=function(){this.attempts=0};Backoff.prototype.setMin=function(min){this.ms=min};Backoff.prototype.setMax=function(max){this.max=max};Backoff.prototype.setJitter=function(jitter){this.jitter=jitter}},{}],37:[function(_dereq_,module,exports){var slice=[].slice;module.exports=function(obj,fn){if("string"==typeof fn)fn=obj[fn];if("function"!=typeof fn)throw new Error("bind() requires a function");var args=slice.call(arguments,2);return function(){return fn.apply(obj,args.concat(slice.call(arguments)))}}},{}],38:[function(_dereq_,module,exports){module.exports=Emitter;function Emitter(obj){if(obj)return mixin(obj)}function mixin(obj){for(var key in Emitter.prototype){obj[key]=Emitter.prototype[key]}return obj}Emitter.prototype.on=Emitter.prototype.addEventListener=function(event,fn){this._callbacks=this._callbacks||{};(this._callbacks["$"+event]=this._callbacks["$"+event]||[]).push(fn);return this};Emitter.prototype.once=function(event,fn){function on(){this.off(event,on);fn.apply(this,arguments)}on.fn=fn;this.on(event,on);return this};Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(event,fn){this._callbacks=this._callbacks||{};if(0==arguments.length){this._callbacks={};return this}var callbacks=this._callbacks["$"+event];if(!callbacks)return this;if(1==arguments.length){delete this._callbacks["$"+event];return this}var cb;for(var i=0;i<callbacks.length;i++){cb=callbacks[i];if(cb===fn||cb.fn===fn){callbacks.splice(i,1);break}}return this};Emitter.prototype.emit=function(event){this._callbacks=this._callbacks||{};var args=[].slice.call(arguments,1),callbacks=this._callbacks["$"+event];if(callbacks){callbacks=callbacks.slice(0);for(var i=0,len=callbacks.length;i<len;++i){callbacks[i].apply(this,args)}}return this};Emitter.prototype.listeners=function(event){this._callbacks=this._callbacks||{};return this._callbacks["$"+event]||[]};Emitter.prototype.hasListeners=function(event){return!!this.listeners(event).length}},{}],39:[function(_dereq_,module,exports){arguments[4][17][0].apply(exports,arguments)},{"./debug":40,dup:17}],40:[function(_dereq_,module,exports){arguments[4][18][0].apply(exports,arguments)},{dup:18,ms:44}],41:[function(_dereq_,module,exports){(function(global){var isArray=_dereq_("isarray");module.exports=hasBinary;function hasBinary(data){function _hasBinary(obj){if(!obj)return false;if(global.Buffer&&global.Buffer.isBuffer&&global.Buffer.isBuffer(obj)||global.ArrayBuffer&&obj instanceof ArrayBuffer||global.Blob&&obj instanceof Blob||global.File&&obj instanceof File){return true}if(isArray(obj)){for(var i=0;i<obj.length;i++){if(_hasBinary(obj[i])){return true}}}else if(obj&&"object"==typeof obj){if(obj.toJSON&&"function"==typeof obj.toJSON){obj=obj.toJSON()}for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)&&_hasBinary(obj[key])){return true}}}return false}return _hasBinary(data)}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{isarray:43}],42:[function(_dereq_,module,exports){arguments[4][23][0].apply(exports,arguments)},{dup:23}],43:[function(_dereq_,module,exports){arguments[4][24][0].apply(exports,arguments)},{dup:24}],44:[function(_dereq_,module,exports){arguments[4][25][0].apply(exports,arguments)},{dup:25}],45:[function(_dereq_,module,exports){arguments[4][28][0].apply(exports,arguments)},{dup:28}],46:[function(_dereq_,module,exports){(function(global){var isArray=_dereq_("isarray");var isBuf=_dereq_("./is-buffer");exports.deconstructPacket=function(packet){var buffers=[];var packetData=packet.data;function _deconstructPacket(data){if(!data)return data;if(isBuf(data)){var placeholder={_placeholder:true,num:buffers.length};buffers.push(data);return placeholder}else if(isArray(data)){var newData=new Array(data.length);for(var i=0;i<data.length;i++){newData[i]=_deconstructPacket(data[i])}return newData}else if("object"==typeof data&&!(data instanceof Date)){var newData={};for(var key in data){newData[key]=_deconstructPacket(data[key])}return newData}return data}var pack=packet;pack.data=_deconstructPacket(packetData);pack.attachments=buffers.length;return{packet:pack,buffers:buffers}};exports.reconstructPacket=function(packet,buffers){var curPlaceHolder=0;function _reconstructPacket(data){if(data&&data._placeholder){var buf=buffers[data.num];return buf}else if(isArray(data)){for(var i=0;i<data.length;i++){data[i]=_reconstructPacket(data[i])}return data}else if(data&&"object"==typeof data){for(var key in data){data[key]=_reconstructPacket(data[key])}return data}return data}packet.data=_reconstructPacket(packet.data);packet.attachments=undefined;return packet};exports.removeBlobs=function(data,callback){function _removeBlobs(obj,curKey,containingObject){if(!obj)return obj;if(global.Blob&&obj instanceof Blob||global.File&&obj instanceof File){pendingBlobs++;var fileReader=new FileReader;fileReader.onload=function(){if(containingObject){containingObject[curKey]=this.result}else{bloblessData=this.result}if(!--pendingBlobs){callback(bloblessData)}};fileReader.readAsArrayBuffer(obj)}else if(isArray(obj)){for(var i=0;i<obj.length;i++){_removeBlobs(obj[i],i,obj)}}else if(obj&&"object"==typeof obj&&!isBuf(obj)){for(var key in obj){_removeBlobs(obj[key],key,obj)}}}var pendingBlobs=0;var bloblessData=data;_removeBlobs(bloblessData);if(!pendingBlobs){callback(bloblessData)}}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{"./is-buffer":48,isarray:43}],47:[function(_dereq_,module,exports){var debug=_dereq_("debug")("socket.io-parser");var json=_dereq_("json3");var isArray=_dereq_("isarray");var Emitter=_dereq_("component-emitter");var binary=_dereq_("./binary");var isBuf=_dereq_("./is-buffer");exports.protocol=4;exports.types=["CONNECT","DISCONNECT","EVENT","BINARY_EVENT","ACK","BINARY_ACK","ERROR"];exports.CONNECT=0;exports.DISCONNECT=1;exports.EVENT=2;exports.ACK=3;exports.ERROR=4;exports.BINARY_EVENT=5;exports.BINARY_ACK=6;exports.Encoder=Encoder;exports.Decoder=Decoder;function Encoder(){}Encoder.prototype.encode=function(obj,callback){debug("encoding packet %j",obj);if(exports.BINARY_EVENT==obj.type||exports.BINARY_ACK==obj.type){encodeAsBinary(obj,callback)}else{var encoding=encodeAsString(obj);callback([encoding])}};function encodeAsString(obj){var str="";var nsp=false;str+=obj.type;if(exports.BINARY_EVENT==obj.type||exports.BINARY_ACK==obj.type){str+=obj.attachments;str+="-"}if(obj.nsp&&"/"!=obj.nsp){nsp=true;str+=obj.nsp}if(null!=obj.id){if(nsp){str+=",";nsp=false}str+=obj.id}if(null!=obj.data){if(nsp)str+=",";str+=json.stringify(obj.data)}debug("encoded %j as %s",obj,str);return str}function encodeAsBinary(obj,callback){function writeEncoding(bloblessData){var deconstruction=binary.deconstructPacket(bloblessData);var pack=encodeAsString(deconstruction.packet);var buffers=deconstruction.buffers;buffers.unshift(pack);callback(buffers)}binary.removeBlobs(obj,writeEncoding)}function Decoder(){this.reconstructor=null}Emitter(Decoder.prototype);Decoder.prototype.add=function(obj){var packet;if("string"==typeof obj){packet=decodeString(obj);if(exports.BINARY_EVENT==packet.type||exports.BINARY_ACK==packet.type){this.reconstructor=new BinaryReconstructor(packet);if(this.reconstructor.reconPack.attachments===0){this.emit("decoded",packet)}}else{this.emit("decoded",packet)}}else if(isBuf(obj)||obj.base64){if(!this.reconstructor){throw new Error("got binary data when not reconstructing a packet")}else{packet=this.reconstructor.takeBinaryData(obj);if(packet){this.reconstructor=null;this.emit("decoded",packet)}}}else{throw new Error("Unknown type: "+obj)}};function decodeString(str){var p={};var i=0;p.type=Number(str.charAt(0));if(null==exports.types[p.type])return error();if(exports.BINARY_EVENT==p.type||exports.BINARY_ACK==p.type){var buf="";while(str.charAt(++i)!="-"){buf+=str.charAt(i);if(i==str.length)break}if(buf!=Number(buf)||str.charAt(i)!="-"){throw new Error("Illegal attachments")}p.attachments=Number(buf)}if("/"==str.charAt(i+1)){p.nsp="";while(++i){var c=str.charAt(i);if(","==c)break;p.nsp+=c;if(i==str.length)break}}else{p.nsp="/"}var next=str.charAt(i+1);if(""!==next&&Number(next)==next){p.id="";while(++i){var c=str.charAt(i);if(null==c||Number(c)!=c){--i;break}p.id+=str.charAt(i);if(i==str.length)break}p.id=Number(p.id)}if(str.charAt(++i)){try{p.data=json.parse(str.substr(i))}catch(e){return error()}}debug("decoded %s as %j",str,p);return p}Decoder.prototype.destroy=function(){if(this.reconstructor){this.reconstructor.finishedReconstruction()}};function BinaryReconstructor(packet){this.reconPack=packet;this.buffers=[]}BinaryReconstructor.prototype.takeBinaryData=function(binData){this.buffers.push(binData);if(this.buffers.length==this.reconPack.attachments){var packet=binary.reconstructPacket(this.reconPack,this.buffers);this.finishedReconstruction();return packet}return null};BinaryReconstructor.prototype.finishedReconstruction=function(){this.reconPack=null;this.buffers=[]};function error(data){return{type:exports.ERROR,data:"parser error"}}},{"./binary":46,"./is-buffer":48,"component-emitter":49,debug:39,isarray:43,json3:50}],48:[function(_dereq_,module,exports){(function(global){module.exports=isBuf;function isBuf(obj){return global.Buffer&&global.Buffer.isBuffer(obj)||global.ArrayBuffer&&obj instanceof ArrayBuffer}}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{}],49:[function(_dereq_,module,exports){arguments[4][15][0].apply(exports,arguments)},{dup:15}],50:[function(_dereq_,module,exports){(function(global){(function(){var isLoader=typeof define==="function"&&define.amd;var objectTypes={"function":true,object:true};var freeExports=objectTypes[typeof exports]&&exports&&!exports.nodeType&&exports;var root=objectTypes[typeof window]&&window||this,freeGlobal=freeExports&&objectTypes[typeof module]&&module&&!module.nodeType&&typeof global=="object"&&global;if(freeGlobal&&(freeGlobal["global"]===freeGlobal||freeGlobal["window"]===freeGlobal||freeGlobal["self"]===freeGlobal)){root=freeGlobal}function runInContext(context,exports){context||(context=root["Object"]());exports||(exports=root["Object"]());var Number=context["Number"]||root["Number"],String=context["String"]||root["String"],Object=context["Object"]||root["Object"],Date=context["Date"]||root["Date"],SyntaxError=context["SyntaxError"]||root["SyntaxError"],TypeError=context["TypeError"]||root["TypeError"],Math=context["Math"]||root["Math"],nativeJSON=context["JSON"]||root["JSON"];if(typeof nativeJSON=="object"&&nativeJSON){exports.stringify=nativeJSON.stringify;exports.parse=nativeJSON.parse}var objectProto=Object.prototype,getClass=objectProto.toString,isProperty,forEach,undef;var isExtended=new Date(-0xc782b5b800cec);try{isExtended=isExtended.getUTCFullYear()==-109252&&isExtended.getUTCMonth()===0&&isExtended.getUTCDate()===1&&isExtended.getUTCHours()==10&&isExtended.getUTCMinutes()==37&&isExtended.getUTCSeconds()==6&&isExtended.getUTCMilliseconds()==708}catch(exception){}function has(name){if(has[name]!==undef){return has[name]}var isSupported;if(name=="bug-string-char-index"){isSupported="a"[0]!="a"}else if(name=="json"){isSupported=has("json-stringify")&&has("json-parse")}else{var value,serialized='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if(name=="json-stringify"){var stringify=exports.stringify,stringifySupported=typeof stringify=="function"&&isExtended;if(stringifySupported){(value=function(){return 1}).toJSON=value;try{stringifySupported=stringify(0)==="0"&&stringify(new Number)==="0"&&stringify(new String)=='""'&&stringify(getClass)===undef&&stringify(undef)===undef&&stringify()===undef&&stringify(value)==="1"&&stringify([value])=="[1]"&&stringify([undef])=="[null]"&&stringify(null)=="null"&&stringify([undef,getClass,null])=="[null,null,null]"&&stringify({a:[value,true,false,null,"\x00\b\n\f\r	"]})==serialized&&stringify(null,value)==="1"&&stringify([1,2],null,1)=="[\n 1,\n 2\n]"&&stringify(new Date(-864e13))=='"-271821-04-20T00:00:00.000Z"'&&stringify(new Date(864e13))=='"+275760-09-13T00:00:00.000Z"'&&stringify(new Date(-621987552e5))=='"-000001-01-01T00:00:00.000Z"'&&stringify(new Date(-1))=='"1969-12-31T23:59:59.999Z"'}catch(exception){stringifySupported=false}}isSupported=stringifySupported}if(name=="json-parse"){var parse=exports.parse;if(typeof parse=="function"){try{if(parse("0")===0&&!parse(false)){value=parse(serialized);var parseSupported=value["a"].length==5&&value["a"][0]===1;if(parseSupported){try{parseSupported=!parse('"	"')}catch(exception){}if(parseSupported){try{parseSupported=parse("01")!==1}catch(exception){}}if(parseSupported){try{parseSupported=parse("1.")!==1}catch(exception){}}}}}catch(exception){parseSupported=false}}isSupported=parseSupported}}return has[name]=!!isSupported}if(!has("json")){var functionClass="[object Function]",dateClass="[object Date]",numberClass="[object Number]",stringClass="[object String]",arrayClass="[object Array]",booleanClass="[object Boolean]";var charIndexBuggy=has("bug-string-char-index");if(!isExtended){var floor=Math.floor;var Months=[0,31,59,90,120,151,181,212,243,273,304,334];var getDay=function(year,month){return Months[month]+365*(year-1970)+floor((year-1969+(month=+(month>1)))/4)-floor((year-1901+month)/100)+floor((year-1601+month)/400)}}if(!(isProperty=objectProto.hasOwnProperty)){isProperty=function(property){var members={},constructor;if((members.__proto__=null,members.__proto__={toString:1},members).toString!=getClass){isProperty=function(property){var original=this.__proto__,result=property in(this.__proto__=null,this);this.__proto__=original;return result}}else{constructor=members.constructor;isProperty=function(property){var parent=(this.constructor||constructor).prototype;return property in this&&!(property in parent&&this[property]===parent[property])}}members=null;return isProperty.call(this,property)}}forEach=function(object,callback){var size=0,Properties,members,property;(Properties=function(){this.valueOf=0}).prototype.valueOf=0;members=new Properties;for(property in members){if(isProperty.call(members,property)){size++}}Properties=members=null;if(!size){members=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"];forEach=function(object,callback){var isFunction=getClass.call(object)==functionClass,property,length;var hasProperty=!isFunction&&typeof object.constructor!="function"&&objectTypes[typeof object.hasOwnProperty]&&object.hasOwnProperty||isProperty;for(property in object){if(!(isFunction&&property=="prototype")&&hasProperty.call(object,property)){callback(property)}}for(length=members.length;property=members[--length];hasProperty.call(object,property)&&callback(property));}}else if(size==2){forEach=function(object,callback){var members={},isFunction=getClass.call(object)==functionClass,property;for(property in object){if(!(isFunction&&property=="prototype")&&!isProperty.call(members,property)&&(members[property]=1)&&isProperty.call(object,property)){callback(property)}}}}else{forEach=function(object,callback){var isFunction=getClass.call(object)==functionClass,property,isConstructor;for(property in object){if(!(isFunction&&property=="prototype")&&isProperty.call(object,property)&&!(isConstructor=property==="constructor")){callback(property)}}if(isConstructor||isProperty.call(object,property="constructor")){callback(property)}}}return forEach(object,callback)};if(!has("json-stringify")){var Escapes={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"};var leadingZeroes="000000";var toPaddedString=function(width,value){return(leadingZeroes+(value||0)).slice(-width)};var unicodePrefix="\\u00";var quote=function(value){var result='"',index=0,length=value.length,useCharIndex=!charIndexBuggy||length>10;var symbols=useCharIndex&&(charIndexBuggy?value.split(""):value);for(;index<length;index++){var charCode=value.charCodeAt(index);switch(charCode){case 8:case 9:case 10:case 12:case 13:case 34:case 92:result+=Escapes[charCode];break;default:if(charCode<32){result+=unicodePrefix+toPaddedString(2,charCode.toString(16));break}result+=useCharIndex?symbols[index]:value.charAt(index)}}return result+'"'};var serialize=function(property,object,callback,properties,whitespace,indentation,stack){var value,className,year,month,date,time,hours,minutes,seconds,milliseconds,results,element,index,length,prefix,result;try{value=object[property]}catch(exception){}if(typeof value=="object"&&value){className=getClass.call(value);if(className==dateClass&&!isProperty.call(value,"toJSON")){if(value>-1/0&&value<1/0){if(getDay){date=floor(value/864e5);for(year=floor(date/365.2425)+1970-1;getDay(year+1,0)<=date;year++);for(month=floor((date-getDay(year,0))/30.42);getDay(year,month+1)<=date;month++);date=1+date-getDay(year,month);time=(value%864e5+864e5)%864e5;hours=floor(time/36e5)%24;minutes=floor(time/6e4)%60;seconds=floor(time/1e3)%60;milliseconds=time%1e3}else{year=value.getUTCFullYear();month=value.getUTCMonth();date=value.getUTCDate();hours=value.getUTCHours();minutes=value.getUTCMinutes();seconds=value.getUTCSeconds();milliseconds=value.getUTCMilliseconds()}value=(year<=0||year>=1e4?(year<0?"-":"+")+toPaddedString(6,year<0?-year:year):toPaddedString(4,year))+"-"+toPaddedString(2,month+1)+"-"+toPaddedString(2,date)+"T"+toPaddedString(2,hours)+":"+toPaddedString(2,minutes)+":"+toPaddedString(2,seconds)+"."+toPaddedString(3,milliseconds)+"Z"}else{value=null}}else if(typeof value.toJSON=="function"&&(className!=numberClass&&className!=stringClass&&className!=arrayClass||isProperty.call(value,"toJSON"))){value=value.toJSON(property)}}if(callback){value=callback.call(object,property,value)}if(value===null){return"null"}className=getClass.call(value);if(className==booleanClass){return""+value}else if(className==numberClass){return value>-1/0&&value<1/0?""+value:"null"}else if(className==stringClass){return quote(""+value)}if(typeof value=="object"){for(length=stack.length;length--;){if(stack[length]===value){throw TypeError()}}stack.push(value);results=[];prefix=indentation;indentation+=whitespace;if(className==arrayClass){for(index=0,length=value.length;index<length;index++){element=serialize(index,value,callback,properties,whitespace,indentation,stack);results.push(element===undef?"null":element)}result=results.length?whitespace?"[\n"+indentation+results.join(",\n"+indentation)+"\n"+prefix+"]":"["+results.join(",")+"]":"[]"}else{forEach(properties||value,function(property){var element=serialize(property,value,callback,properties,whitespace,indentation,stack);if(element!==undef){results.push(quote(property)+":"+(whitespace?" ":"")+element)}});result=results.length?whitespace?"{\n"+indentation+results.join(",\n"+indentation)+"\n"+prefix+"}":"{"+results.join(",")+"}":"{}"}stack.pop();return result}};exports.stringify=function(source,filter,width){var whitespace,callback,properties,className;if(objectTypes[typeof filter]&&filter){if((className=getClass.call(filter))==functionClass){callback=filter}else if(className==arrayClass){properties={};for(var index=0,length=filter.length,value;index<length;value=filter[index++],(className=getClass.call(value),className==stringClass||className==numberClass)&&(properties[value]=1));}}if(width){if((className=getClass.call(width))==numberClass){if((width-=width%1)>0){for(whitespace="",width>10&&(width=10);whitespace.length<width;whitespace+=" ");}}else if(className==stringClass){whitespace=width.length<=10?width:width.slice(0,10)}}return serialize("",(value={},value[""]=source,value),callback,properties,whitespace,"",[])}}if(!has("json-parse")){var fromCharCode=String.fromCharCode;var Unescapes={92:"\\",34:'"',47:"/",98:"\b",116:"	",110:"\n",102:"\f",114:"\r"};var Index,Source;var abort=function(){Index=Source=null;throw SyntaxError()};var lex=function(){var source=Source,length=source.length,value,begin,position,isSigned,charCode;while(Index<length){charCode=source.charCodeAt(Index);switch(charCode){case 9:case 10:case 13:case 32:Index++;break;case 123:case 125:case 91:case 93:case 58:case 44:value=charIndexBuggy?source.charAt(Index):source[Index];Index++;return value;case 34:for(value="@",Index++;Index<length;){charCode=source.charCodeAt(Index);if(charCode<32){abort()}else if(charCode==92){charCode=source.charCodeAt(++Index);switch(charCode){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:value+=Unescapes[charCode];Index++;break;case 117:begin=++Index;for(position=Index+4;Index<position;Index++){charCode=source.charCodeAt(Index);if(!(charCode>=48&&charCode<=57||charCode>=97&&charCode<=102||charCode>=65&&charCode<=70)){abort()}}value+=fromCharCode("0x"+source.slice(begin,Index));break;default:abort()}}else{if(charCode==34){break}charCode=source.charCodeAt(Index);begin=Index;while(charCode>=32&&charCode!=92&&charCode!=34){charCode=source.charCodeAt(++Index)}value+=source.slice(begin,Index)}}if(source.charCodeAt(Index)==34){Index++;return value}abort();default:begin=Index;if(charCode==45){isSigned=true;charCode=source.charCodeAt(++Index)}if(charCode>=48&&charCode<=57){if(charCode==48&&(charCode=source.charCodeAt(Index+1),charCode>=48&&charCode<=57)){abort()}isSigned=false;for(;Index<length&&(charCode=source.charCodeAt(Index),charCode>=48&&charCode<=57);Index++);if(source.charCodeAt(Index)==46){position=++Index;for(;position<length&&(charCode=source.charCodeAt(position),charCode>=48&&charCode<=57);position++);if(position==Index){abort()}Index=position}charCode=source.charCodeAt(Index);if(charCode==101||charCode==69){charCode=source.charCodeAt(++Index);if(charCode==43||charCode==45){Index++}for(position=Index;position<length&&(charCode=source.charCodeAt(position),charCode>=48&&charCode<=57);position++);if(position==Index){abort()}Index=position}return+source.slice(begin,Index)}if(isSigned){abort()}if(source.slice(Index,Index+4)=="true"){Index+=4;return true}else if(source.slice(Index,Index+5)=="false"){Index+=5;return false}else if(source.slice(Index,Index+4)=="null"){Index+=4;return null}abort()}}return"$"};var get=function(value){var results,hasMembers;if(value=="$"){abort()}if(typeof value=="string"){if((charIndexBuggy?value.charAt(0):value[0])=="@"){return value.slice(1)}if(value=="["){results=[];for(;;hasMembers||(hasMembers=true)){value=lex();if(value=="]"){break}if(hasMembers){if(value==","){value=lex();if(value=="]"){abort()}}else{abort()}}if(value==","){abort()}results.push(get(value))}return results}else if(value=="{"){results={};for(;;hasMembers||(hasMembers=true)){value=lex();if(value=="}"){break}if(hasMembers){if(value==","){value=lex();if(value=="}"){abort()}}else{abort()}}if(value==","||typeof value!="string"||(charIndexBuggy?value.charAt(0):value[0])!="@"||lex()!=":"){abort()}results[value.slice(1)]=get(lex())
}return results}abort()}return value};var update=function(source,property,callback){var element=walk(source,property,callback);if(element===undef){delete source[property]}else{source[property]=element}};var walk=function(source,property,callback){var value=source[property],length;if(typeof value=="object"&&value){if(getClass.call(value)==arrayClass){for(length=value.length;length--;){update(value,length,callback)}}else{forEach(value,function(property){update(value,property,callback)})}}return callback.call(source,property,value)};exports.parse=function(source,callback){var result,value;Index=0;Source=""+source;result=get(lex());if(lex()!="$"){abort()}Index=Source=null;return callback&&getClass.call(callback)==functionClass?walk((value={},value[""]=result,value),"",callback):result}}}exports["runInContext"]=runInContext;return exports}if(freeExports&&!isLoader){runInContext(root,freeExports)}else{var nativeJSON=root.JSON,previousJSON=root["JSON3"],isRestored=false;var JSON3=runInContext(root,root["JSON3"]={noConflict:function(){if(!isRestored){isRestored=true;root.JSON=nativeJSON;root["JSON3"]=previousJSON;nativeJSON=previousJSON=null}return JSON3}});root.JSON={parse:JSON3.parse,stringify:JSON3.stringify}}if(isLoader){define(function(){return JSON3})}}).call(this)}).call(this,typeof self!=="undefined"?self:typeof window!=="undefined"?window:typeof global!=="undefined"?global:{})},{}],51:[function(_dereq_,module,exports){module.exports=toArray;function toArray(list,index){var array=[];index=index||0;for(var i=index||0;i<list.length;i++){array[i-index]=list[i]}return array}},{}]},{},[31])(31)});
/*! jQuery v1.11.3 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l="1.11.3",m=function(a,b){return new m.fn.init(a,b)},n=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,o=/^-ms-/,p=/-([\da-z])/gi,q=function(a,b){return b.toUpperCase()};m.fn=m.prototype={jquery:l,constructor:m,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=m.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return m.each(this,a,b)},map:function(a){return this.pushStack(m.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},m.extend=m.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||m.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(m.isPlainObject(c)||(b=m.isArray(c)))?(b?(b=!1,f=a&&m.isArray(a)?a:[]):f=a&&m.isPlainObject(a)?a:{},g[d]=m.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},m.extend({expando:"jQuery"+(l+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===m.type(a)},isArray:Array.isArray||function(a){return"array"===m.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){return!m.isArray(a)&&a-parseFloat(a)+1>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||"object"!==m.type(a)||a.nodeType||m.isWindow(a))return!1;try{if(a.constructor&&!j.call(a,"constructor")&&!j.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}if(k.ownLast)for(b in a)return j.call(a,b);for(b in a);return void 0===b||j.call(a,b)},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(b){b&&m.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(o,"ms-").replace(p,q)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=r(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(n,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(r(Object(a))?m.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(g)return g.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=r(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(f=a[b],b=a,a=f),m.isFunction(a)?(c=d.call(arguments,2),e=function(){return a.apply(b||this,c.concat(d.call(arguments)))},e.guid=a.guid=a.guid||m.guid++,e):void 0},now:function(){return+new Date},support:k}),m.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function r(a){var b="length"in a&&a.length,c=m.type(a);return"function"===c||m.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var s=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N=M.replace("w","w#"),O="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+N+"))|)"+L+"*\\]",P=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+O+")*)|.*)\\)|)",Q=new RegExp(L+"+","g"),R=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),S=new RegExp("^"+L+"*,"+L+"*"),T=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),U=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),V=new RegExp(P),W=new RegExp("^"+N+"$"),X={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M.replace("w","w*")+")"),ATTR:new RegExp("^"+O),PSEUDO:new RegExp("^"+P),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,aa=/[+~]/,ba=/'|\\/g,ca=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),da=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,"string"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(ba,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(",")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener("unload",ea,!1):e.attachEvent&&e.attachEvent("onunload",ea)),p=!f(g),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\f]' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){var b=g.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",P)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||"").replace(ca,da),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(Q," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);m.find=s,m.expr=s.selectors,m.expr[":"]=m.expr.pseudos,m.unique=s.uniqueSort,m.text=s.getText,m.isXMLDoc=s.isXML,m.contains=s.contains;var t=m.expr.match.needsContext,u=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,v=/^.[^:#\[\.,]*$/;function w(a,b,c){if(m.isFunction(b))return m.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return m.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(v.test(b))return m.filter(b,a,c);b=m.filter(b,a)}return m.grep(a,function(a){return m.inArray(a,b)>=0!==c})}m.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?m.find.matchesSelector(d,a)?[d]:[]:m.find.matches(a,m.grep(b,function(a){return 1===a.nodeType}))},m.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(m(a).filter(function(){for(b=0;e>b;b++)if(m.contains(d[b],this))return!0}));for(b=0;e>b;b++)m.find(a,d[b],c);return c=this.pushStack(e>1?m.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},filter:function(a){return this.pushStack(w(this,a||[],!1))},not:function(a){return this.pushStack(w(this,a||[],!0))},is:function(a){return!!w(this,"string"==typeof a&&t.test(a)?m(a):a||[],!1).length}});var x,y=a.document,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=m.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||x).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof m?b[0]:b,m.merge(this,m.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:y,!0)),u.test(c[1])&&m.isPlainObject(b))for(c in b)m.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}if(d=y.getElementById(c[2]),d&&d.parentNode){if(d.id!==c[2])return x.find(a);this.length=1,this[0]=d}return this.context=y,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):m.isFunction(a)?"undefined"!=typeof x.ready?x.ready(a):a(m):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),m.makeArray(a,this))};A.prototype=m.fn,x=m(y);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};m.extend({dir:function(a,b,c){var d=[],e=a[b];while(e&&9!==e.nodeType&&(void 0===c||1!==e.nodeType||!m(e).is(c)))1===e.nodeType&&d.push(e),e=e[b];return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),m.fn.extend({has:function(a){var b,c=m(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(m.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=t.test(a)||"string"!=typeof a?m(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&m.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?m.unique(f):f)},index:function(a){return a?"string"==typeof a?m.inArray(this[0],m(a)):m.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(m.unique(m.merge(this.get(),m(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}m.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return m.dir(a,"parentNode")},parentsUntil:function(a,b,c){return m.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return m.dir(a,"nextSibling")},prevAll:function(a){return m.dir(a,"previousSibling")},nextUntil:function(a,b,c){return m.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return m.dir(a,"previousSibling",c)},siblings:function(a){return m.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return m.sibling(a.firstChild)},contents:function(a){return m.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:m.merge([],a.childNodes)}},function(a,b){m.fn[a]=function(c,d){var e=m.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=m.filter(d,e)),this.length>1&&(C[a]||(e=m.unique(e)),B.test(a)&&(e=e.reverse())),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return m.each(a.match(E)||[],function(a,c){b[c]=!0}),b}m.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):m.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(c=a.memory&&l,d=!0,f=g||0,g=0,e=h.length,b=!0;h&&e>f;f++)if(h[f].apply(l[0],l[1])===!1&&a.stopOnFalse){c=!1;break}b=!1,h&&(i?i.length&&j(i.shift()):c?h=[]:k.disable())},k={add:function(){if(h){var d=h.length;!function f(b){m.each(b,function(b,c){var d=m.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&f(c)})}(arguments),b?e=h.length:c&&(g=d,j(c))}return this},remove:function(){return h&&m.each(arguments,function(a,c){var d;while((d=m.inArray(c,h,d))>-1)h.splice(d,1),b&&(e>=d&&e--,f>=d&&f--)}),this},has:function(a){return a?m.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],e=0,this},disable:function(){return h=i=c=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,c||k.disable(),this},locked:function(){return!i},fireWith:function(a,c){return!h||d&&!i||(c=c||[],c=[a,c.slice?c.slice():c],b?i.push(c):j(c)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!d}};return k},m.extend({Deferred:function(a){var b=[["resolve","done",m.Callbacks("once memory"),"resolved"],["reject","fail",m.Callbacks("once memory"),"rejected"],["notify","progress",m.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return m.Deferred(function(c){m.each(b,function(b,f){var g=m.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&m.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?m.extend(a,d):d}},e={};return d.pipe=d.then,m.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&m.isFunction(a.promise)?e:0,g=1===f?a:m.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&m.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;m.fn.ready=function(a){return m.ready.promise().done(a),this},m.extend({isReady:!1,readyWait:1,holdReady:function(a){a?m.readyWait++:m.ready(!0)},ready:function(a){if(a===!0?!--m.readyWait:!m.isReady){if(!y.body)return setTimeout(m.ready);m.isReady=!0,a!==!0&&--m.readyWait>0||(H.resolveWith(y,[m]),m.fn.triggerHandler&&(m(y).triggerHandler("ready"),m(y).off("ready")))}}});function I(){y.addEventListener?(y.removeEventListener("DOMContentLoaded",J,!1),a.removeEventListener("load",J,!1)):(y.detachEvent("onreadystatechange",J),a.detachEvent("onload",J))}function J(){(y.addEventListener||"load"===event.type||"complete"===y.readyState)&&(I(),m.ready())}m.ready.promise=function(b){if(!H)if(H=m.Deferred(),"complete"===y.readyState)setTimeout(m.ready);else if(y.addEventListener)y.addEventListener("DOMContentLoaded",J,!1),a.addEventListener("load",J,!1);else{y.attachEvent("onreadystatechange",J),a.attachEvent("onload",J);var c=!1;try{c=null==a.frameElement&&y.documentElement}catch(d){}c&&c.doScroll&&!function e(){if(!m.isReady){try{c.doScroll("left")}catch(a){return setTimeout(e,50)}I(),m.ready()}}()}return H.promise(b)};var K="undefined",L;for(L in m(k))break;k.ownLast="0"!==L,k.inlineBlockNeedsLayout=!1,m(function(){var a,b,c,d;c=y.getElementsByTagName("body")[0],c&&c.style&&(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText="display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1",k.inlineBlockNeedsLayout=a=3===b.offsetWidth,a&&(c.style.zoom=1)),c.removeChild(d))}),function(){var a=y.createElement("div");if(null==k.deleteExpando){k.deleteExpando=!0;try{delete a.test}catch(b){k.deleteExpando=!1}}a=null}(),m.acceptData=function(a){var b=m.noData[(a.nodeName+" ").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute("classid")===b};var M=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,N=/([A-Z])/g;function O(a,b,c){if(void 0===c&&1===a.nodeType){var d="data-"+b.replace(N,"-$1").toLowerCase();if(c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:M.test(c)?m.parseJSON(c):c}catch(e){}m.data(a,b,c)}else c=void 0}return c}function P(a){var b;for(b in a)if(("data"!==b||!m.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;

return!0}function Q(a,b,d,e){if(m.acceptData(a)){var f,g,h=m.expando,i=a.nodeType,j=i?m.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||"string"!=typeof b)return k||(k=i?a[h]=c.pop()||m.guid++:h),j[k]||(j[k]=i?{}:{toJSON:m.noop}),("object"==typeof b||"function"==typeof b)&&(e?j[k]=m.extend(j[k],b):j[k].data=m.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[m.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[m.camelCase(b)])):f=g,f}}function R(a,b,c){if(m.acceptData(a)){var d,e,f=a.nodeType,g=f?m.cache:a,h=f?a[m.expando]:m.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){m.isArray(b)?b=b.concat(m.map(b,m.camelCase)):b in d?b=[b]:(b=m.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;while(e--)delete d[b[e]];if(c?!P(d):!m.isEmptyObject(d))return}(c||(delete g[h].data,P(g[h])))&&(f?m.cleanData([a],!0):k.deleteExpando||g!=g.window?delete g[h]:g[h]=null)}}}m.extend({cache:{},noData:{"applet ":!0,"embed ":!0,"object ":"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?m.cache[a[m.expando]]:a[m.expando],!!a&&!P(a)},data:function(a,b,c){return Q(a,b,c)},removeData:function(a,b){return R(a,b)},_data:function(a,b,c){return Q(a,b,c,!0)},_removeData:function(a,b){return R(a,b,!0)}}),m.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=m.data(f),1===f.nodeType&&!m._data(f,"parsedAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=m.camelCase(d.slice(5)),O(f,d,e[d])));m._data(f,"parsedAttrs",!0)}return e}return"object"==typeof a?this.each(function(){m.data(this,a)}):arguments.length>1?this.each(function(){m.data(this,a,b)}):f?O(f,a,m.data(f,a)):void 0},removeData:function(a){return this.each(function(){m.removeData(this,a)})}}),m.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=m._data(a,b),c&&(!d||m.isArray(c)?d=m._data(a,b,m.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=m.queue(a,b),d=c.length,e=c.shift(),f=m._queueHooks(a,b),g=function(){m.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return m._data(a,c)||m._data(a,c,{empty:m.Callbacks("once memory").add(function(){m._removeData(a,b+"queue"),m._removeData(a,c)})})}}),m.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?m.queue(this[0],a):void 0===b?this:this.each(function(){var c=m.queue(this,a,b);m._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&m.dequeue(this,a)})},dequeue:function(a){return this.each(function(){m.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=m.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=m._data(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=["Top","Right","Bottom","Left"],U=function(a,b){return a=b||a,"none"===m.css(a,"display")||!m.contains(a.ownerDocument,a)},V=m.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===m.type(c)){e=!0;for(h in c)m.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,m.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(m(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},W=/^(?:checkbox|radio)$/i;!function(){var a=y.createElement("input"),b=y.createElement("div"),c=y.createDocumentFragment();if(b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",k.leadingWhitespace=3===b.firstChild.nodeType,k.tbody=!b.getElementsByTagName("tbody").length,k.htmlSerialize=!!b.getElementsByTagName("link").length,k.html5Clone="<:nav></:nav>"!==y.createElement("nav").cloneNode(!0).outerHTML,a.type="checkbox",a.checked=!0,c.appendChild(a),k.appendChecked=a.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue,c.appendChild(b),b.innerHTML="<input type='radio' checked='checked' name='t'/>",k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,k.noCloneEvent=!0,b.attachEvent&&(b.attachEvent("onclick",function(){k.noCloneEvent=!1}),b.cloneNode(!0).click()),null==k.deleteExpando){k.deleteExpando=!0;try{delete b.test}catch(d){k.deleteExpando=!1}}}(),function(){var b,c,d=y.createElement("div");for(b in{submit:!0,change:!0,focusin:!0})c="on"+b,(k[b+"Bubbles"]=c in a)||(d.setAttribute(c,"t"),k[b+"Bubbles"]=d.attributes[c].expando===!1);d=null}();var X=/^(?:input|select|textarea)$/i,Y=/^key/,Z=/^(?:mouse|pointer|contextmenu)|click/,$=/^(?:focusinfocus|focusoutblur)$/,_=/^([^.]*)(?:\.(.+)|)$/;function aa(){return!0}function ba(){return!1}function ca(){try{return y.activeElement}catch(a){}}m.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=m.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return typeof m===K||a&&m.event.triggered===a.type?void 0:m.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||"").match(E)||[""],h=b.length;while(h--)f=_.exec(b[h])||[],o=q=f[1],p=(f[2]||"").split(".").sort(),o&&(j=m.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=m.event.special[o]||{},l=m.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&m.expr.match.needsContext.test(e),namespace:p.join(".")},i),(n=g[o])||(n=g[o]=[],n.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent("on"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?n.splice(n.delegateCount++,0,l):n.push(l),m.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m.hasData(a)&&m._data(a);if(r&&(k=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=_.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=m.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,n=k[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=n.length;while(f--)g=n[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(n.splice(f,1),g.selector&&n.delegateCount--,l.remove&&l.remove.call(a,g));i&&!n.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||m.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)m.event.remove(a,o+b[j],c,d,!0);m.isEmptyObject(k)&&(delete r.handle,m._removeData(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,l,n,o=[d||y],p=j.call(b,"type")?b.type:b,q=j.call(b,"namespace")?b.namespace.split("."):[];if(h=l=d=d||y,3!==d.nodeType&&8!==d.nodeType&&!$.test(p+m.event.triggered)&&(p.indexOf(".")>=0&&(q=p.split("."),p=q.shift(),q.sort()),g=p.indexOf(":")<0&&"on"+p,b=b[m.expando]?b:new m.Event(p,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=q.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:m.makeArray(c,[b]),k=m.event.special[p]||{},e||!k.trigger||k.trigger.apply(d,c)!==!1)){if(!e&&!k.noBubble&&!m.isWindow(d)){for(i=k.delegateType||p,$.test(i+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),l=h;l===(d.ownerDocument||y)&&o.push(l.defaultView||l.parentWindow||a)}n=0;while((h=o[n++])&&!b.isPropagationStopped())b.type=n>1?i:k.bindType||p,f=(m._data(h,"events")||{})[b.type]&&m._data(h,"handle"),f&&f.apply(h,c),f=g&&h[g],f&&f.apply&&m.acceptData(h)&&(b.result=f.apply(h,c),b.result===!1&&b.preventDefault());if(b.type=p,!e&&!b.isDefaultPrevented()&&(!k._default||k._default.apply(o.pop(),c)===!1)&&m.acceptData(d)&&g&&d[p]&&!m.isWindow(d)){l=d[g],l&&(d[g]=null),m.event.triggered=p;try{d[p]()}catch(r){}m.event.triggered=void 0,l&&(d[g]=l)}return b.result}},dispatch:function(a){a=m.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(m._data(this,"events")||{})[a.type]||[],k=m.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=m.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,g=0;while((e=f.handlers[g++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(e.namespace))&&(a.handleObj=e,a.data=e.data,c=((m.event.special[e.origType]||{}).handle||e.handler).apply(f.elem,i),void 0!==c&&(a.result=c)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(e=[],f=0;h>f;f++)d=b[f],c=d.selector+" ",void 0===e[c]&&(e[c]=d.needsContext?m(c,this).index(i)>=0:m.find(c,this,null,[i]).length),e[c]&&e.push(d);e.length&&g.push({elem:i,handlers:e})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[m.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=Z.test(e)?this.mouseHooks:Y.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new m.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=f.srcElement||y),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,g.filter?g.filter(a,f):a},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button,g=b.fromElement;return null==a.pageX&&null!=b.clientX&&(d=a.target.ownerDocument||y,e=d.documentElement,c=d.body,a.pageX=b.clientX+(e&&e.scrollLeft||c&&c.scrollLeft||0)-(e&&e.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||c&&c.scrollTop||0)-(e&&e.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&g&&(a.relatedTarget=g===a.target?b.toElement:g),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==ca()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===ca()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return m.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return m.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=m.extend(new m.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?m.event.trigger(e,null,b):m.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},m.removeEvent=y.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){var d="on"+b;a.detachEvent&&(typeof a[d]===K&&(a[d]=null),a.detachEvent(d,c))},m.Event=function(a,b){return this instanceof m.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?aa:ba):this.type=a,b&&m.extend(this,b),this.timeStamp=a&&a.timeStamp||m.now(),void(this[m.expando]=!0)):new m.Event(a,b)},m.Event.prototype={isDefaultPrevented:ba,isPropagationStopped:ba,isImmediatePropagationStopped:ba,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=aa,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=aa,a&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=aa,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},m.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){m.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!m.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.submitBubbles||(m.event.special.submit={setup:function(){return m.nodeName(this,"form")?!1:void m.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,c=m.nodeName(b,"input")||m.nodeName(b,"button")?b.form:void 0;c&&!m._data(c,"submitBubbles")&&(m.event.add(c,"submit._submit",function(a){a._submit_bubble=!0}),m._data(c,"submitBubbles",!0))})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&m.event.simulate("submit",this.parentNode,a,!0))},teardown:function(){return m.nodeName(this,"form")?!1:void m.event.remove(this,"._submit")}}),k.changeBubbles||(m.event.special.change={setup:function(){return X.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(m.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._just_changed=!0)}),m.event.add(this,"click._change",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1),m.event.simulate("change",this,a,!0)})),!1):void m.event.add(this,"beforeactivate._change",function(a){var b=a.target;X.test(b.nodeName)&&!m._data(b,"changeBubbles")&&(m.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||m.event.simulate("change",this.parentNode,a,!0)}),m._data(b,"changeBubbles",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return m.event.remove(this,"._change"),!X.test(this.nodeName)}}),k.focusinBubbles||m.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){m.event.simulate(b,a.target,m.event.fix(a),!0)};m.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=m._data(d,b);e||d.addEventListener(a,c,!0),m._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=m._data(d,b)-1;e?m._data(d,b,e):(d.removeEventListener(a,c,!0),m._removeData(d,b))}}}),m.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(f in a)this.on(f,b,c,a[f],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=ba;else if(!d)return this;return 1===e&&(g=d,d=function(a){return m().off(a),g.apply(this,arguments)},d.guid=g.guid||(g.guid=m.guid++)),this.each(function(){m.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,m(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=ba),this.each(function(){m.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){m.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?m.event.trigger(a,b,c,!0):void 0}});function da(a){var b=ea.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}var ea="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",fa=/ jQuery\d+="(?:null|\d+)"/g,ga=new RegExp("<(?:"+ea+")[\\s/>]","i"),ha=/^\s+/,ia=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ja=/<([\w:]+)/,ka=/<tbody/i,la=/<|&#?\w+;/,ma=/<(?:script|style|link)/i,na=/checked\s*(?:[^=]|=\s*.checked.)/i,oa=/^$|\/(?:java|ecma)script/i,pa=/^true\/(.*)/,qa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ra={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:k.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},sa=da(y),ta=sa.appendChild(y.createElement("div"));ra.optgroup=ra.option,ra.tbody=ra.tfoot=ra.colgroup=ra.caption=ra.thead,ra.th=ra.td;function ua(a,b){var c,d,e=0,f=typeof a.getElementsByTagName!==K?a.getElementsByTagName(b||"*"):typeof a.querySelectorAll!==K?a.querySelectorAll(b||"*"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||m.nodeName(d,b)?f.push(d):m.merge(f,ua(d,b));return void 0===b||b&&m.nodeName(a,b)?m.merge([a],f):f}function va(a){W.test(a.type)&&(a.defaultChecked=a.checked)}function wa(a,b){return m.nodeName(a,"table")&&m.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function xa(a){return a.type=(null!==m.find.attr(a,"type"))+"/"+a.type,a}function ya(a){var b=pa.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function za(a,b){for(var c,d=0;null!=(c=a[d]);d++)m._data(c,"globalEval",!b||m._data(b[d],"globalEval"))}function Aa(a,b){if(1===b.nodeType&&m.hasData(a)){var c,d,e,f=m._data(a),g=m._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)m.event.add(b,c,h[c][d])}g.data&&(g.data=m.extend({},g.data))}}function Ba(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!k.noCloneEvent&&b[m.expando]){e=m._data(b);for(d in e.events)m.removeEvent(b,d,e.handle);b.removeAttribute(m.expando)}"script"===c&&b.text!==a.text?(xa(b).text=a.text,ya(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),k.html5Clone&&a.innerHTML&&!m.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&W.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}}m.extend({clone:function(a,b,c){var d,e,f,g,h,i=m.contains(a.ownerDocument,a);if(k.html5Clone||m.isXMLDoc(a)||!ga.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(ta.innerHTML=a.outerHTML,ta.removeChild(f=ta.firstChild)),!(k.noCloneEvent&&k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||m.isXMLDoc(a)))for(d=ua(f),h=ua(a),g=0;null!=(e=h[g]);++g)d[g]&&Ba(e,d[g]);if(b)if(c)for(h=h||ua(a),d=d||ua(f),g=0;null!=(e=h[g]);g++)Aa(e,d[g]);else Aa(a,f);return d=ua(f,"script"),d.length>0&&za(d,!i&&ua(a,"script")),d=h=e=null,f},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,l,n=a.length,o=da(b),p=[],q=0;n>q;q++)if(f=a[q],f||0===f)if("object"===m.type(f))m.merge(p,f.nodeType?[f]:f);else if(la.test(f)){h=h||o.appendChild(b.createElement("div")),i=(ja.exec(f)||["",""])[1].toLowerCase(),l=ra[i]||ra._default,h.innerHTML=l[1]+f.replace(ia,"<$1></$2>")+l[2],e=l[0];while(e--)h=h.lastChild;if(!k.leadingWhitespace&&ha.test(f)&&p.push(b.createTextNode(ha.exec(f)[0])),!k.tbody){f="table"!==i||ka.test(f)?"<table>"!==l[1]||ka.test(f)?0:h:h.firstChild,e=f&&f.childNodes.length;while(e--)m.nodeName(j=f.childNodes[e],"tbody")&&!j.childNodes.length&&f.removeChild(j)}m.merge(p,h.childNodes),h.textContent="";while(h.firstChild)h.removeChild(h.firstChild);h=o.lastChild}else p.push(b.createTextNode(f));h&&o.removeChild(h),k.appendChecked||m.grep(ua(p,"input"),va),q=0;while(f=p[q++])if((!d||-1===m.inArray(f,d))&&(g=m.contains(f.ownerDocument,f),h=ua(o.appendChild(f),"script"),g&&za(h),c)){e=0;while(f=h[e++])oa.test(f.type||"")&&c.push(f)}return h=null,o},cleanData:function(a,b){for(var d,e,f,g,h=0,i=m.expando,j=m.cache,l=k.deleteExpando,n=m.event.special;null!=(d=a[h]);h++)if((b||m.acceptData(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)n[e]?m.event.remove(d,e):m.removeEvent(d,e,g.handle);j[f]&&(delete j[f],l?delete d[i]:typeof d.removeAttribute!==K?d.removeAttribute(i):d[i]=null,c.push(f))}}}),m.fn.extend({text:function(a){return V(this,function(a){return void 0===a?m.text(this):this.empty().append((this[0]&&this[0].ownerDocument||y).createTextNode(a))},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?m.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||m.cleanData(ua(c)),c.parentNode&&(b&&m.contains(c.ownerDocument,c)&&za(ua(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&m.cleanData(ua(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&m.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return m.clone(this,a,b)})},html:function(a){return V(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(fa,""):void 0;if(!("string"!=typeof a||ma.test(a)||!k.htmlSerialize&&ga.test(a)||!k.leadingWhitespace&&ha.test(a)||ra[(ja.exec(a)||["",""])[1].toLowerCase()])){a=a.replace(ia,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(m.cleanData(ua(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,m.cleanData(ua(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,n=this,o=l-1,p=a[0],q=m.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&na.test(p))return this.each(function(c){var d=n.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(i=m.buildFragment(a,this[0].ownerDocument,!1,this),c=i.firstChild,1===i.childNodes.length&&(i=c),c)){for(g=m.map(ua(i,"script"),xa),f=g.length;l>j;j++)d=i,j!==o&&(d=m.clone(d,!0,!0),f&&m.merge(g,ua(d,"script"))),b.call(this[j],d,j);if(f)for(h=g[g.length-1].ownerDocument,m.map(g,ya),j=0;f>j;j++)d=g[j],oa.test(d.type||"")&&!m._data(d,"globalEval")&&m.contains(h,d)&&(d.src?m._evalUrl&&m._evalUrl(d.src):m.globalEval((d.text||d.textContent||d.innerHTML||"").replace(qa,"")));i=c=null}return this}}),m.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){m.fn[a]=function(a){for(var c,d=0,e=[],g=m(a),h=g.length-1;h>=d;d++)c=d===h?this:this.clone(!0),m(g[d])[b](c),f.apply(e,c.get());return this.pushStack(e)}});var Ca,Da={};function Ea(b,c){var d,e=m(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:m.css(e[0],"display");return e.detach(),f}function Fa(a){var b=y,c=Da[a];return c||(c=Ea(a,b),"none"!==c&&c||(Ca=(Ca||m("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=(Ca[0].contentWindow||Ca[0].contentDocument).document,b.write(),b.close(),c=Ea(a,b),Ca.detach()),Da[a]=c),c}!function(){var a;k.shrinkWrapBlocks=function(){if(null!=a)return a;a=!1;var b,c,d;return c=y.getElementsByTagName("body")[0],c&&c.style?(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1",b.appendChild(y.createElement("div")).style.width="5px",a=3!==b.offsetWidth),c.removeChild(d),a):void 0}}();var Ga=/^margin/,Ha=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ia,Ja,Ka=/^(top|right|bottom|left)$/;a.getComputedStyle?(Ia=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c.getPropertyValue(b)||c[b]:void 0,c&&(""!==g||m.contains(a.ownerDocument,a)||(g=m.style(a,b)),Ha.test(g)&&Ga.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0===g?g:g+""}):y.documentElement.currentStyle&&(Ia=function(a){return a.currentStyle},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Ha.test(g)&&!Ka.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left="fontSize"===b?"1em":g,g=h.pixelLeft+"px",h.left=d,f&&(e.left=f)),void 0===g?g:g+""||"auto"});function La(a,b){return{get:function(){var c=a();if(null!=c)return c?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d,e,f,g,h;if(b=y.createElement("div"),b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",d=b.getElementsByTagName("a")[0],c=d&&d.style){c.cssText="float:left;opacity:.5",k.opacity="0.5"===c.opacity,k.cssFloat=!!c.cssFloat,b.style.backgroundClip="content-box",b.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===b.style.backgroundClip,k.boxSizing=""===c.boxSizing||""===c.MozBoxSizing||""===c.WebkitBoxSizing,m.extend(k,{reliableHiddenOffsets:function(){return null==g&&i(),g},boxSizingReliable:function(){return null==f&&i(),f},pixelPosition:function(){return null==e&&i(),e},reliableMarginRight:function(){return null==h&&i(),h}});function i(){var b,c,d,i;c=y.getElementsByTagName("body")[0],c&&c.style&&(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),b.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",e=f=!1,h=!0,a.getComputedStyle&&(e="1%"!==(a.getComputedStyle(b,null)||{}).top,f="4px"===(a.getComputedStyle(b,null)||{width:"4px"}).width,i=b.appendChild(y.createElement("div")),i.style.cssText=b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",i.style.marginRight=i.style.width="0",b.style.width="1px",h=!parseFloat((a.getComputedStyle(i,null)||{}).marginRight),b.removeChild(i)),b.innerHTML="<table><tr><td></td><td>t</td></tr></table>",i=b.getElementsByTagName("td"),i[0].style.cssText="margin:0;border:0;padding:0;display:none",g=0===i[0].offsetHeight,g&&(i[0].style.display="",i[1].style.display="none",g=0===i[0].offsetHeight),c.removeChild(d))}}}(),m.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var Ma=/alpha\([^)]*\)/i,Na=/opacity\s*=\s*([^)]*)/,Oa=/^(none|table(?!-c[ea]).+)/,Pa=new RegExp("^("+S+")(.*)$","i"),Qa=new RegExp("^([+-])=("+S+")","i"),Ra={position:"absolute",visibility:"hidden",display:"block"},Sa={letterSpacing:"0",fontWeight:"400"},Ta=["Webkit","O","Moz","ms"];function Ua(a,b){if(b in a)return b;var c=b.charAt(0).toUpperCase()+b.slice(1),d=b,e=Ta.length;while(e--)if(b=Ta[e]+c,b in a)return b;return d}function Va(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=m._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&U(d)&&(f[g]=m._data(d,"olddisplay",Fa(d.nodeName)))):(e=U(d),(c&&"none"!==c||!e)&&m._data(d,"olddisplay",e?c:m.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function Wa(a,b,c){var d=Pa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Xa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=m.css(a,c+T[f],!0,e)),d?("content"===c&&(g-=m.css(a,"padding"+T[f],!0,e)),"margin"!==c&&(g-=m.css(a,"border"+T[f]+"Width",!0,e))):(g+=m.css(a,"padding"+T[f],!0,e),"padding"!==c&&(g+=m.css(a,"border"+T[f]+"Width",!0,e)));return g}function Ya(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ia(a),g=k.boxSizing&&"border-box"===m.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Ja(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ha.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Xa(a,b,c||(g?"border":"content"),d,f)+"px"}m.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ja(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":k.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=m.camelCase(b),i=a.style;if(b=m.cssProps[h]||(m.cssProps[h]=Ua(i,h)),g=m.cssHooks[b]||m.cssHooks[h],void 0===c)return g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,"string"===f&&(e=Qa.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(m.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||m.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),!(g&&"set"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=m.camelCase(b);return b=m.cssProps[h]||(m.cssProps[h]=Ua(a.style,h)),g=m.cssHooks[b]||m.cssHooks[h],g&&"get"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Ja(a,b,d)),"normal"===f&&b in Sa&&(f=Sa[b]),""===c||c?(e=parseFloat(f),c===!0||m.isNumeric(e)?e||0:f):f}}),m.each(["height","width"],function(a,b){m.cssHooks[b]={get:function(a,c,d){return c?Oa.test(m.css(a,"display"))&&0===a.offsetWidth?m.swap(a,Ra,function(){return Ya(a,b,d)}):Ya(a,b,d):void 0},set:function(a,c,d){var e=d&&Ia(a);return Wa(a,c,d?Xa(a,b,d,k.boxSizing&&"border-box"===m.css(a,"boxSizing",!1,e),e):0)}}}),k.opacity||(m.cssHooks.opacity={get:function(a,b){return Na.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=m.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===m.trim(f.replace(Ma,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=Ma.test(f)?f.replace(Ma,e):f+" "+e)}}),m.cssHooks.marginRight=La(k.reliableMarginRight,function(a,b){return b?m.swap(a,{display:"inline-block"},Ja,[a,"marginRight"]):void 0}),m.each({margin:"",padding:"",border:"Width"},function(a,b){m.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+T[d]+b]=f[d]||f[d-2]||f[0];return e}},Ga.test(a)||(m.cssHooks[a+b].set=Wa)}),m.fn.extend({css:function(a,b){return V(this,function(a,b,c){var d,e,f={},g=0;if(m.isArray(b)){for(d=Ia(a),e=b.length;e>g;g++)f[b[g]]=m.css(a,b[g],!1,d);return f}return void 0!==c?m.style(a,b,c):m.css(a,b)},a,b,arguments.length>1)},show:function(){return Va(this,!0)},hide:function(){return Va(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){U(this)?m(this).show():m(this).hide()})}});function Za(a,b,c,d,e){
return new Za.prototype.init(a,b,c,d,e)}m.Tween=Za,Za.prototype={constructor:Za,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(m.cssNumber[c]?"":"px")},cur:function(){var a=Za.propHooks[this.prop];return a&&a.get?a.get(this):Za.propHooks._default.get(this)},run:function(a){var b,c=Za.propHooks[this.prop];return this.options.duration?this.pos=b=m.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Za.propHooks._default.set(this),this}},Za.prototype.init.prototype=Za.prototype,Za.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=m.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){m.fx.step[a.prop]?m.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[m.cssProps[a.prop]]||m.cssHooks[a.prop])?m.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Za.propHooks.scrollTop=Za.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},m.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},m.fx=Za.prototype.init,m.fx.step={};var $a,_a,ab=/^(?:toggle|show|hide)$/,bb=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),cb=/queueHooks$/,db=[ib],eb={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=bb.exec(b),f=e&&e[3]||(m.cssNumber[a]?"":"px"),g=(m.cssNumber[a]||"px"!==f&&+d)&&bb.exec(m.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,m.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function fb(){return setTimeout(function(){$a=void 0}),$a=m.now()}function gb(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=T[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function hb(a,b,c){for(var d,e=(eb[b]||[]).concat(eb["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,l,n=this,o={},p=a.style,q=a.nodeType&&U(a),r=m._data(a,"fxshow");c.queue||(h=m._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,n.always(function(){n.always(function(){h.unqueued--,m.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=m.css(a,"display"),l="none"===j?m._data(a,"olddisplay")||Fa(a.nodeName):j,"inline"===l&&"none"===m.css(a,"float")&&(k.inlineBlockNeedsLayout&&"inline"!==Fa(a.nodeName)?p.zoom=1:p.display="inline-block")),c.overflow&&(p.overflow="hidden",k.shrinkWrapBlocks()||n.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],ab.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(q?"hide":"show")){if("show"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||m.style(a,d)}else j=void 0;if(m.isEmptyObject(o))"inline"===("none"===j?Fa(a.nodeName):j)&&(p.display=j);else{r?"hidden"in r&&(q=r.hidden):r=m._data(a,"fxshow",{}),f&&(r.hidden=!q),q?m(a).show():n.done(function(){m(a).hide()}),n.done(function(){var b;m._removeData(a,"fxshow");for(b in o)m.style(a,b,o[b])});for(d in o)g=hb(q?r[d]:0,d,n),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=m.camelCase(c),e=b[d],f=a[c],m.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=m.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=db.length,h=m.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=$a||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:m.extend({},b),opts:m.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:$a||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=m.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);g>f;f++)if(d=db[f].call(j,a,k,j.opts))return d;return m.map(k,hb,j),m.isFunction(j.opts.start)&&j.opts.start.call(a,j),m.fx.timer(m.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}m.Animation=m.extend(kb,{tweener:function(a,b){m.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],eb[c]=eb[c]||[],eb[c].unshift(b)},prefilter:function(a,b){b?db.unshift(a):db.push(a)}}),m.speed=function(a,b,c){var d=a&&"object"==typeof a?m.extend({},a):{complete:c||!c&&b||m.isFunction(a)&&a,duration:a,easing:c&&b||b&&!m.isFunction(b)&&b};return d.duration=m.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in m.fx.speeds?m.fx.speeds[d.duration]:m.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){m.isFunction(d.old)&&d.old.call(this),d.queue&&m.dequeue(this,d.queue)},d},m.fn.extend({fadeTo:function(a,b,c,d){return this.filter(U).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=m.isEmptyObject(a),f=m.speed(b,c,d),g=function(){var b=kb(this,m.extend({},a),f);(e||m._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=m.timers,g=m._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&cb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&m.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=m._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=m.timers,g=d?d.length:0;for(c.finish=!0,m.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),m.each(["toggle","show","hide"],function(a,b){var c=m.fn[b];m.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),m.each({slideDown:gb("show"),slideUp:gb("hide"),slideToggle:gb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){m.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),m.timers=[],m.fx.tick=function(){var a,b=m.timers,c=0;for($a=m.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||m.fx.stop(),$a=void 0},m.fx.timer=function(a){m.timers.push(a),a()?m.fx.start():m.timers.pop()},m.fx.interval=13,m.fx.start=function(){_a||(_a=setInterval(m.fx.tick,m.fx.interval))},m.fx.stop=function(){clearInterval(_a),_a=null},m.fx.speeds={slow:600,fast:200,_default:400},m.fn.delay=function(a,b){return a=m.fx?m.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a,b,c,d,e;b=y.createElement("div"),b.setAttribute("className","t"),b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",d=b.getElementsByTagName("a")[0],c=y.createElement("select"),e=c.appendChild(y.createElement("option")),a=b.getElementsByTagName("input")[0],d.style.cssText="top:1px",k.getSetAttribute="t"!==b.className,k.style=/top/.test(d.getAttribute("style")),k.hrefNormalized="/a"===d.getAttribute("href"),k.checkOn=!!a.value,k.optSelected=e.selected,k.enctype=!!y.createElement("form").enctype,c.disabled=!0,k.optDisabled=!e.disabled,a=y.createElement("input"),a.setAttribute("value",""),k.input=""===a.getAttribute("value"),a.value="t",a.setAttribute("type","radio"),k.radioValue="t"===a.value}();var lb=/\r/g;m.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=m.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,m(this).val()):a,null==e?e="":"number"==typeof e?e+="":m.isArray(e)&&(e=m.map(e,function(a){return null==a?"":a+""})),b=m.valHooks[this.type]||m.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=m.valHooks[e.type]||m.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(lb,""):null==c?"":c)}}}),m.extend({valHooks:{option:{get:function(a){var b=m.find.attr(a,"value");return null!=b?b:m.trim(m.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&m.nodeName(c.parentNode,"optgroup"))){if(b=m(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=m.makeArray(b),g=e.length;while(g--)if(d=e[g],m.inArray(m.valHooks.option.get(d),f)>=0)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),m.each(["radio","checkbox"],function(){m.valHooks[this]={set:function(a,b){return m.isArray(b)?a.checked=m.inArray(m(a).val(),b)>=0:void 0}},k.checkOn||(m.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var mb,nb,ob=m.expr.attrHandle,pb=/^(?:checked|selected)$/i,qb=k.getSetAttribute,rb=k.input;m.fn.extend({attr:function(a,b){return V(this,m.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){m.removeAttr(this,a)})}}),m.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===K?m.prop(a,b,c):(1===f&&m.isXMLDoc(a)||(b=b.toLowerCase(),d=m.attrHooks[b]||(m.expr.match.bool.test(b)?nb:mb)),void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=m.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void m.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=m.propFix[c]||c,m.expr.match.bool.test(c)?rb&&qb||!pb.test(c)?a[d]=!1:a[m.camelCase("default-"+c)]=a[d]=!1:m.attr(a,c,""),a.removeAttribute(qb?c:d)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&m.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),nb={set:function(a,b,c){return b===!1?m.removeAttr(a,c):rb&&qb||!pb.test(c)?a.setAttribute(!qb&&m.propFix[c]||c,c):a[m.camelCase("default-"+c)]=a[c]=!0,c}},m.each(m.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ob[b]||m.find.attr;ob[b]=rb&&qb||!pb.test(b)?function(a,b,d){var e,f;return d||(f=ob[b],ob[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,ob[b]=f),e}:function(a,b,c){return c?void 0:a[m.camelCase("default-"+b)]?b.toLowerCase():null}}),rb&&qb||(m.attrHooks.value={set:function(a,b,c){return m.nodeName(a,"input")?void(a.defaultValue=b):mb&&mb.set(a,b,c)}}),qb||(mb={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+="","value"===c||b===a.getAttribute(c)?b:void 0}},ob.id=ob.name=ob.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&""!==d.value?d.value:null},m.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:mb.set},m.attrHooks.contenteditable={set:function(a,b,c){mb.set(a,""===b?!1:b,c)}},m.each(["width","height"],function(a,b){m.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),k.style||(m.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+""}});var sb=/^(?:input|select|textarea|button|object)$/i,tb=/^(?:a|area)$/i;m.fn.extend({prop:function(a,b){return V(this,m.prop,a,b,arguments.length>1)},removeProp:function(a){return a=m.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),m.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!m.isXMLDoc(a),f&&(b=m.propFix[b]||b,e=m.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=m.find.attr(a,"tabindex");return b?parseInt(b,10):sb.test(a.nodeName)||tb.test(a.nodeName)&&a.href?0:-1}}}}),k.hrefNormalized||m.each(["href","src"],function(a,b){m.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),k.optSelected||(m.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),m.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){m.propFix[this.toLowerCase()]=this}),k.enctype||(m.propFix.enctype="encoding");var ub=/[\t\r\n\f]/g;m.fn.extend({addClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j="string"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).addClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ub," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=m.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j=0===arguments.length||"string"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).removeClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ub," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?m.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(m.isFunction(a)?function(c){m(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=m(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===K||"boolean"===c)&&(this.className&&m._data(this,"__className__",this.className),this.className=this.className||a===!1?"":m._data(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ub," ").indexOf(b)>=0)return!0;return!1}}),m.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){m.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),m.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var vb=m.now(),wb=/\?/,xb=/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;m.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+"");var c,d=null,e=m.trim(b+"");return e&&!m.trim(e.replace(xb,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,"")}))?Function("return "+e)():m.error("Invalid JSON: "+b)},m.parseXML=function(b){var c,d;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(d=new DOMParser,c=d.parseFromString(b,"text/xml")):(c=new ActiveXObject("Microsoft.XMLDOM"),c.async="false",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName("parsererror").length||m.error("Invalid XML: "+b),c};var yb,zb,Ab=/#.*$/,Bb=/([?&])_=[^&]*/,Cb=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Db=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Eb=/^(?:GET|HEAD)$/,Fb=/^\/\//,Gb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,Hb={},Ib={},Jb="*/".concat("*");try{zb=location.href}catch(Kb){zb=y.createElement("a"),zb.href="",zb=zb.href}yb=Gb.exec(zb.toLowerCase())||[];function Lb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(m.isFunction(c))while(d=f[e++])"+"===d.charAt(0)?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Mb(a,b,c,d){var e={},f=a===Ib;function g(h){var i;return e[h]=!0,m.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Nb(a,b){var c,d,e=m.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&m.extend(!0,a,c),a}function Ob(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader("Content-Type"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+" "+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Pb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}m.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:zb,type:"GET",isLocal:Db.test(yb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Jb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":m.parseJSON,"text xml":m.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Nb(Nb(a,m.ajaxSettings),b):Nb(m.ajaxSettings,a)},ajaxPrefilter:Lb(Hb),ajaxTransport:Lb(Ib),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=m.ajaxSetup({},b),l=k.context||k,n=k.context&&(l.nodeType||l.jquery)?m(l):m.event,o=m.Deferred(),p=m.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!j){j={};while(b=Cb.exec(f))j[b[1].toLowerCase()]=b[2]}b=j[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?f:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return i&&i.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||zb)+"").replace(Ab,"").replace(Fb,yb[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=m.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(c=Gb.exec(k.url.toLowerCase()),k.crossDomain=!(!c||c[1]===yb[1]&&c[2]===yb[2]&&(c[3]||("http:"===c[1]?"80":"443"))===(yb[3]||("http:"===yb[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=m.param(k.data,k.traditional)),Mb(Hb,k,b,v),2===t)return v;h=m.event&&k.global,h&&0===m.active++&&m.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!Eb.test(k.type),e=k.url,k.hasContent||(k.data&&(e=k.url+=(wb.test(e)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=Bb.test(e)?e.replace(Bb,"$1_="+vb++):e+(wb.test(e)?"&":"?")+"_="+vb++)),k.ifModified&&(m.lastModified[e]&&v.setRequestHeader("If-Modified-Since",m.lastModified[e]),m.etag[e]&&v.setRequestHeader("If-None-Match",m.etag[e])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+Jb+"; q=0.01":""):k.accepts["*"]);for(d in k.headers)v.setRequestHeader(d,k.headers[d]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(d in{success:1,error:1,complete:1})v[d](k[d]);if(i=Mb(Ib,k,b,v)){v.readyState=1,h&&n.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,i.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,c,d){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),i=void 0,f=d||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,c&&(u=Ob(k,v,c)),u=Pb(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(m.lastModified[e]=w),w=v.getResponseHeader("etag"),w&&(m.etag[e]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,h&&n.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),h&&(n.trigger("ajaxComplete",[v,k]),--m.active||m.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return m.get(a,b,c,"json")},getScript:function(a,b){return m.get(a,void 0,b,"script")}}),m.each(["get","post"],function(a,b){m[b]=function(a,c,d,e){return m.isFunction(c)&&(e=e||d,d=c,c=void 0),m.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),m._evalUrl=function(a){return m.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},m.fn.extend({wrapAll:function(a){if(m.isFunction(a))return this.each(function(b){m(this).wrapAll(a.call(this,b))});if(this[0]){var b=m(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return this.each(m.isFunction(a)?function(b){m(this).wrapInner(a.call(this,b))}:function(){var b=m(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=m.isFunction(a);return this.each(function(c){m(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){m.nodeName(this,"body")||m(this).replaceWith(this.childNodes)}).end()}}),m.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0||!k.reliableHiddenOffsets()&&"none"===(a.style&&a.style.display||m.css(a,"display"))},m.expr.filters.visible=function(a){return!m.expr.filters.hidden(a)};var Qb=/%20/g,Rb=/\[\]$/,Sb=/\r?\n/g,Tb=/^(?:submit|button|image|reset|file)$/i,Ub=/^(?:input|select|textarea|keygen)/i;function Vb(a,b,c,d){var e;if(m.isArray(b))m.each(b,function(b,e){c||Rb.test(a)?d(a,e):Vb(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==m.type(b))d(a,b);else for(e in b)Vb(a+"["+e+"]",b[e],c,d)}m.param=function(a,b){var c,d=[],e=function(a,b){b=m.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=m.ajaxSettings&&m.ajaxSettings.traditional),m.isArray(a)||a.jquery&&!m.isPlainObject(a))m.each(a,function(){e(this.name,this.value)});else for(c in a)Vb(c,a[c],b,e);return d.join("&").replace(Qb,"+")},m.fn.extend({serialize:function(){return m.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=m.prop(this,"elements");return a?m.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!m(this).is(":disabled")&&Ub.test(this.nodeName)&&!Tb.test(a)&&(this.checked||!W.test(a))}).map(function(a,b){var c=m(this).val();return null==c?null:m.isArray(c)?m.map(c,function(a){return{name:b.name,value:a.replace(Sb,"\r\n")}}):{name:b.name,value:c.replace(Sb,"\r\n")}}).get()}}),m.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return!this.isLocal&&/^(get|post|head|put|delete|options)$/i.test(this.type)&&Zb()||$b()}:Zb;var Wb=0,Xb={},Yb=m.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in Xb)Xb[a](void 0,!0)}),k.cors=!!Yb&&"withCredentials"in Yb,Yb=k.ajax=!!Yb,Yb&&m.ajaxTransport(function(a){if(!a.crossDomain||k.cors){var b;return{send:function(c,d){var e,f=a.xhr(),g=++Wb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)void 0!==c[e]&&f.setRequestHeader(e,c[e]+"");f.send(a.hasContent&&a.data||null),b=function(c,e){var h,i,j;if(b&&(e||4===f.readyState))if(delete Xb[g],b=void 0,f.onreadystatechange=m.noop,e)4!==f.readyState&&f.abort();else{j={},h=f.status,"string"==typeof f.responseText&&(j.text=f.responseText);try{i=f.statusText}catch(k){i=""}h||!a.isLocal||a.crossDomain?1223===h&&(h=204):h=j.text?200:404}j&&d(h,i,j,f.getAllResponseHeaders())},a.async?4===f.readyState?setTimeout(b):f.onreadystatechange=Xb[g]=b:b()},abort:function(){b&&b(void 0,!0)}}}});function Zb(){try{return new a.XMLHttpRequest}catch(b){}}function $b(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}m.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return m.globalEval(a),a}}}),m.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),m.ajaxTransport("script",function(a){if(a.crossDomain){var b,c=y.head||m("head")[0]||y.documentElement;return{send:function(d,e){b=y.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||e(200,"success"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var _b=[],ac=/(=)\?(?=&|$)|\?\?/;m.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=_b.pop()||m.expando+"_"+vb++;return this[a]=!0,a}}),m.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(ac.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&ac.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=m.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(ac,"$1"+e):b.jsonp!==!1&&(b.url+=(wb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||m.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,_b.push(e)),g&&m.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),m.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||y;var d=u.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=m.buildFragment([a],b,e),e&&e.length&&m(e).remove(),m.merge([],d.childNodes))};var bc=m.fn.load;m.fn.load=function(a,b,c){if("string"!=typeof a&&bc)return bc.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=m.trim(a.slice(h,a.length)),a=a.slice(0,h)),m.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(f="POST"),g.length>0&&m.ajax({url:a,type:f,dataType:"html",data:b}).done(function(a){e=arguments,g.html(d?m("<div>").append(m.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,e||[a.responseText,b,a])}),this},m.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){m.fn[b]=function(a){return this.on(b,a)}}),m.expr.filters.animated=function(a){return m.grep(m.timers,function(b){return a===b.elem}).length};var cc=a.document.documentElement;function dc(a){return m.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}m.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=m.css(a,"position"),l=m(a),n={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=m.css(a,"top"),i=m.css(a,"left"),j=("absolute"===k||"fixed"===k)&&m.inArray("auto",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),m.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(n.top=b.top-h.top+g),null!=b.left&&(n.left=b.left-h.left+e),"using"in b?b.using.call(a,n):l.css(n)}},m.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){m.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,m.contains(b,e)?(typeof e.getBoundingClientRect!==K&&(d=e.getBoundingClientRect()),c=dc(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===m.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),m.nodeName(a[0],"html")||(c=a.offset()),c.top+=m.css(a[0],"borderTopWidth",!0),c.left+=m.css(a[0],"borderLeftWidth",!0)),{top:b.top-c.top-m.css(d,"marginTop",!0),left:b.left-c.left-m.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||cc;while(a&&!m.nodeName(a,"html")&&"static"===m.css(a,"position"))a=a.offsetParent;return a||cc})}}),m.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c=/Y/.test(b);m.fn[a]=function(d){return V(this,function(a,d,e){var f=dc(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?m(f).scrollLeft():e,c?e:m(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),m.each(["top","left"],function(a,b){m.cssHooks[b]=La(k.pixelPosition,function(a,c){return c?(c=Ja(a,b),Ha.test(c)?m(a).position()[b]+"px":c):void 0})}),m.each({Height:"height",Width:"width"},function(a,b){m.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){m.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return V(this,function(b,c,d){var e;return m.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?m.css(b,c,g):m.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),m.fn.size=function(){return this.length},m.fn.andSelf=m.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return m});var ec=a.jQuery,fc=a.$;return m.noConflict=function(b){return a.$===m&&(a.$=fc),b&&a.jQuery===m&&(a.jQuery=ec),m},typeof b===K&&(a.jQuery=a.$=m),m});
//# sourceMappingURL=jquery.min.map
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/* Last build : 2016-8-18_10:31:35 / git revision : 5695140 */

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return root['MediaPlayer'] = factory();
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
   root['MediaPlayer'] = factory();
  }
}(this, function () {

   var hasplayer = {},
        Mss = {},
        Hls = {},
        Dash ={},
        MediaPlayer = {},
        Q,
        goog,
        dijon;
/* $Date: 2007-06-12 18:02:31 $ */

// from: http://bannister.us/weblog/2007/06/09/simple-base64-encodedecode-javascript/
// Handles encode/decode of ASCII and Unicode strings.

var UTF8 = {};
UTF8.encode = function(s) {
    var u = [];
    for (var i = 0; i < s.length; ++i) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            u.push(c);
        } else if (c < 0x800) {
            u.push(0xC0 | (c >> 6));
            u.push(0x80 | (63 & c));
        } else if (c < 0x10000) {
            u.push(0xE0 | (c >> 12));
            u.push(0x80 | (63 & (c >> 6)));
            u.push(0x80 | (63 & c));
        } else {
            u.push(0xF0 | (c >> 18));
            u.push(0x80 | (63 & (c >> 12)));
            u.push(0x80 | (63 & (c >> 6)));
            u.push(0x80 | (63 & c));
        }
    }
    return u;
};
UTF8.decode = function(u) {
    var a = [];
    var i = 0;
    while (i < u.length) {
        var v = u[i++];
        if (v < 0x80) {
            // no need to mask byte
        } else if (v < 0xE0) {
            v = (31 & v) << 6;
            v |= (63 & u[i++]);
        } else if (v < 0xF0) {
            v = (15 & v) << 12;
            v |= (63 & u[i++]) << 6;
            v |= (63 & u[i++]);
        } else {
            v = (7 & v) << 18;
            v |= (63 & u[i++]) << 12;
            v |= (63 & u[i++]) << 6;
            v |= (63 & u[i++]);
        }
        a.push(String.fromCharCode(v));
    }
    return a.join('');
};

var BASE64 = {};
(function(T){
    var encodeArray = function(u) {
        var i = 0;
        var a = [];
        var n = 0 | (u.length / 3);
        while (0 < n--) {
            var v = (u[i] << 16) + (u[i+1] << 8) + u[i+2];
            i += 3;
            a.push(T.charAt(63 & (v >> 18)));
            a.push(T.charAt(63 & (v >> 12)));
            a.push(T.charAt(63 & (v >> 6)));
            a.push(T.charAt(63 & v));
        }
        if (2 == (u.length - i)) {
            var v = (u[i] << 16) + (u[i+1] << 8);
            a.push(T.charAt(63 & (v >> 18)));
            a.push(T.charAt(63 & (v >> 12)));
            a.push(T.charAt(63 & (v >> 6)));
            a.push('=');
        } else if (1 == (u.length - i)) {
            var v = (u[i] << 16);
            a.push(T.charAt(63 & (v >> 18)));
            a.push(T.charAt(63 & (v >> 12)));
            a.push('==');
        }
        return a.join('');
    }
    var R = (function(){
        var a = [];
        for (var i=0; i<T.length; ++i) {
            a[T.charCodeAt(i)] = i;
        }
        a['='.charCodeAt(0)] = 0;
        return a;
    })();
    var decodeArray = function(s) {
        var i = 0;
        var u = [];
        var n = 0 | (s.length / 4);
        while (0 < n--) {
            var v = (R[s.charCodeAt(i)] << 18) + (R[s.charCodeAt(i+1)] << 12) + (R[s.charCodeAt(i+2)] << 6) + R[s.charCodeAt(i+3)];
            u.push(255 & (v >> 16));
            u.push(255 & (v >> 8));
            u.push(255 & v);
            i += 4;
        }
        if (u) {
            if ('=' == s.charAt(i-2)) {
                u.pop();
                u.pop();
            } else if ('=' == s.charAt(i-1)) {
                u.pop();
            }
        }
        return u;
    }
    var ASCII = {};
    ASCII.encode = function(s) {
        var u = [];
        for (var i = 0; i<s.length; ++i) {
            u.push(s.charCodeAt(i));
        }
        return u;
    };
    ASCII.decode = function(u) {
        for (var i = 0; i<s.length; ++i) {
            a[i] = String.fromCharCode(a[i]);
        }
        return a.join('');
    };
    BASE64.decodeArray = function(s) {
        var u = decodeArray(s);
        return new Uint8Array(u);
    };
    BASE64.encodeASCII = function(s) {
        var u = ASCII.encode(s);
        return encodeArray(u);
    };
    BASE64.decodeASCII = function(s) {
        var a = decodeArray(s);
        return ASCII.decode(a);
    };
    BASE64.encode = function(s) {
        var u = UTF8.encode(s);
        return encodeArray(u);
    };
    BASE64.decode = function(s) {
        var u = decodeArray(s);
        return UTF8.decode(u);
    };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");

if (undefined === btoa) {
    var btoa = BASE64.encode;
}
if (undefined === atob) {
    var atob = BASE64.decode;
}

/**
 * @author <a href="http://www.creynders.be">Camille Reynders</a>
 */
( function ( scope ) {

    "use strict";

    /**
     * @namespace
     */
    var dijon = {
        /**
         * framework version number
         * @constant
         * @type String
         */
        VERSION:'0.5.3'
    };//dijon


    //======================================//
    // dijon.System
    //======================================//

    /**
     * @class dijon.System
     * @constructor
     */
    dijon.System = function () {
        /** @private */
        this._mappings = {};

        /** @private */
        this._outlets = {};

        /** @private */
        this._handlers = {};

        /**
         * When <code>true</code> injections are made only if an object has a property with the mapped outlet name.<br/>
         * <strong>Set to <code>false</code> at own risk</strong>, may have quite undesired side effects.
         * @example
         * system.strictInjections = true
         * var o = {};
         * system.mapSingleton( 'userModel', UserModel );
         * system.mapOutlet( 'userModel' );
         * system.injectInto( o );
         *
         * //o is unchanged
         *
         * system.strictInjections = false;
         * system.injectInto( o );
         *
         * //o now has a member 'userModel' which holds a reference to the singleton instance
         * //of UserModel
         * @type Boolean
         * @default true
         */
        this.strictInjections = true;

        /**
         * Enables the automatic mapping of outlets for mapped values, singletons and classes
         * When this is true any value, singleton or class that is mapped will automatically be mapped as a global outlet
         * using the value of <code>key</code> as outlet name
         *
         * @example
         * var o = {
         *     userModel : undefined; //inject
         * }
         * system.mapSingleton( 'userModel', UserModel );
         * system.injectInto( o ):
         * //o.userModel now holds a reference to the singleton instance of UserModel
         * @type Boolean
         * @default false
         */
        this.autoMapOutlets = false;

        /**
         * The name of the method that will be called for all instances, right after injection has occured.
         * @type String
         * @default 'setup'
         */
        this.postInjectionHook = 'setup';

    };//dijon.System

    dijon.System.prototype = {

        /**
         * @private
         * @param {Class} clazz
         */
        _createAndSetupInstance:function ( key, Clazz ) {
            var instance = new Clazz();
            this.injectInto( instance, key );
            return instance;
        },

        /**
         * @private
         * @param {String} key
         * @param {Boolean} overrideRules
         * @return {Object}
         */
        _retrieveFromCacheOrCreate:function ( key, overrideRules ) {
            if ( typeof overrideRules === 'undefined' ) {
                overrideRules = false;
            }
            var output;
            if ( this._mappings.hasOwnProperty( key ) ) {
                var config = this._mappings[ key ];
                if ( !overrideRules && config.isSingleton ) {
                    if ( config.object == null ) {
                        config.object = this._createAndSetupInstance( key, config.clazz );
                    }
                    output = config.object;
                } else {
                    if ( config.clazz ) {
                        output = this._createAndSetupInstance( key, config.clazz );
                    } else {
                        //TODO shouldn't this be null
                        output = config.object;
                    }
                }
            } else {
                throw new Error( 1000 );
            }
            return output;
        },


        /**
         * defines <code>outletName</code> as an injection point in <code>targetKey</code>for the object mapped to <code>sourceKey</code>
         * @example
         system.mapSingleton( 'userModel', TestClassA );
         var o = {
         user : undefined //inject
         }
         system.mapOutlet( 'userModel', 'o', 'user' );
         system.mapValue( 'o', o );

         var obj = system.getObject( 'o' );
         * //obj.user holds a reference to the singleton instance of UserModel
         *
         * @example
         system.mapSingleton( 'userModel', TestClassA );
         var o = {
         userModel : undefined //inject
         }
         system.mapOutlet( 'userModel', 'o' );
         system.mapValue( 'o', o );

         var obj = system.getObject( 'o' );
         * //obj.userModel holds a reference to the singleton instance of UserModel
         *
         * @example
         system.mapSingleton( 'userModel', TestClassA );
         system.mapOutlet( 'userModel' );
         var o = {
         userModel : undefined //inject
         }
         system.mapValue( 'o', o );

         var obj = system.getObject( 'o' );
         * //o.userModel holds a reference to the singleton instance of userModel
         *
         * @param {String} sourceKey the key mapped to the object that will be injected
         * @param {String} [targetKey='global'] the key the outlet is assigned to.
         * @param {String} [outletName=sourceKey] the name of the property used as an outlet.<br/>
         * @return {dijon.System}
         * @see dijon.System#unmapOutlet
         */
        mapOutlet:function ( sourceKey, targetKey, outletName ) {
            if ( typeof sourceKey === 'undefined' ) {
                throw new Error( 1010 );
            }
            targetKey = targetKey || "global";
            outletName = outletName || sourceKey;

            if ( !this._outlets.hasOwnProperty( targetKey ) ) {
                this._outlets[ targetKey ] = {};
            }
            this._outlets[ targetKey ][ outletName ] = sourceKey;

            return this;
        },

        /**
         * Retrieve (or create) the object mapped to <code>key</code>
         * @example
         * system.mapValue( 'foo', 'bar' );
         * var b = system.getObject( 'foo' ); //now contains 'bar'
         * @param {Object} key
         * @return {Object}
         */
        getObject:function ( key ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1020 );
            }
            return this._retrieveFromCacheOrCreate( key );
        },

        /**
         * Maps <code>useValue</code> to <code>key</code>
         * @example
         * system.mapValue( 'foo', 'bar' );
         * var b = system.getObject( 'foo' ); //now contains 'bar'
         * @param {String} key
         * @param {Object} useValue
         * @return {dijon.System}
         */
        mapValue:function ( key, useValue ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1030 );
            }
            this._mappings[ key ] = {
                clazz:null,
                object:useValue,
                isSingleton:true
            };
            if ( this.autoMapOutlets ) {
                this.mapOutlet( key );
            }
            if ( this.hasMapping( key )) {
                this.injectInto( useValue, key );
            }
            return this;
        },

        /**
         * Returns whether the key is mapped to an object
         * @example
         * system.mapValue( 'foo', 'bar' );
         * var isMapped = system.hasMapping( 'foo' );
         * @param {String} key
         * @return {Boolean}
         */
        hasMapping:function ( key ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1040 );
            }
            return this._mappings.hasOwnProperty( key );
        },

        /**
         * Maps <code>clazz</code> as a factory to <code>key</code>
         * @example
         * var SomeClass = function(){
         * }
         * system.mapClass( 'o', SomeClass );
         *
         * var s1 = system.getObject( 'o' );
         * var s2 = system.getObject( 'o' );
         *
         * //s1 and s2 reference two different instances of SomeClass
         *
         * @param {String} key
         * @param {Function} clazz
         * @return {dijon.System}
         */
        mapClass:function ( key, clazz ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1050 );
            }
            if ( typeof clazz === 'undefined' ) {
                throw new Error( 1051 );
            }
            this._mappings[ key ] = {
                clazz:clazz,
                object:null,
                isSingleton:false
            };
            if ( this.autoMapOutlets ) {
                this.mapOutlet( key );
            }
            return this;
        },

        /**
         * Maps <code>clazz</code> as a singleton factory to <code>key</code>
         * @example
         * var SomeClass = function(){
         * }
         * system.mapSingleton( 'o', SomeClass );
         *
         * var s1 = system.getObject( 'o' );
         * var s2 = system.getObject( 'o' );
         *
         * //s1 and s2 reference the same instance of SomeClass
         *
         * @param {String} key
         * @param {Function} clazz
         * @return {dijon.System}
         */
        mapSingleton:function ( key, clazz ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1060 );
            }
            if ( typeof clazz === 'undefined' ) {
                throw new Error( 1061 );
            }
            this._mappings[ key ] = {
                clazz:clazz,
                object:null,
                isSingleton:true
            };
            if ( this.autoMapOutlets ) {
                this.mapOutlet( key );
            }
            return this;
        },

        /**
         * Force instantiation of the class mapped to <code>key</code>, whether it was mapped as a singleton or not.
         * When a value was mapped, the value will be returned.
         * TODO: should this last rule be changed?
         * @example
         var SomeClass = function(){
         }
         system.mapClass( 'o', SomeClass );

         var s1 = system.getObject( 'o' );
         var s2 = system.getObject( 'o' );
         * //s1 and s2 reference different instances of SomeClass
         *
         * @param {String} key
         * @return {Object}
         */
        instantiate:function ( key ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1070 );
            }
            return this._retrieveFromCacheOrCreate( key, true );
        },

        /**
         * Perform an injection into an object's mapped outlets, satisfying all it's dependencies
         * @example
         * var UserModel = function(){
         * }
         * system.mapSingleton( 'userModel', UserModel );
         * var SomeClass = function(){
         *      user = undefined; //inject
         * }
         * system.mapSingleton( 'o', SomeClass );
         * system.mapOutlet( 'userModel', 'o', 'user' );
         *
         * var foo = {
         *      user : undefined //inject
         * }
         *
         * system.injectInto( foo, 'o' );
         *
         * //foo.user now holds a reference to the singleton instance of UserModel
         * @param {Object} instance
         * @param {String} [key] use the outlet mappings as defined for <code>key</code>, otherwise only the globally
         * mapped outlets will be used.
         * @return {dijon.System}
         */
        injectInto:function ( instance, key ) {
            if ( typeof instance === 'undefined' ) {
                throw new Error( 1080 );
            }
			if( ( typeof instance === 'object' ) ){
				var o = [];
				if ( this._outlets.hasOwnProperty( 'global' ) ) {
					o.push( this._outlets[ 'global' ] );
				}
				if ( typeof key !== 'undefined' && this._outlets.hasOwnProperty( key ) ) {
					o.push( this._outlets[ key ] );
				}
				for ( var i in o ) {
					var l = o [ i ];
					for ( var outlet in l ) {
						var source = l[ outlet ];
						//must be "in" [!]
						if ( !this.strictInjections || outlet in instance ) {
							instance[ outlet ] = this.getObject( source );
						}
					}
				}
				if ( "setup" in instance ) {
					instance.setup.call( instance );
				}
			}
            return this;
        },

        /**
         * Remove the mapping of <code>key</code> from the system
         * @param {String} key
         * @return {dijon.System}
         */
        unmap:function ( key ) {
            if ( typeof key === 'undefined' ) {
                throw new Error( 1090 );
            }
            delete this._mappings[ key ];

            return this;
        },

        /**
         * removes an injection point mapping for a given object mapped to <code>key</code>
         * @param {String} target
         * @param {String} outlet
         * @return {dijon.System}
         * @see dijon.System#addOutlet
         */
        unmapOutlet:function ( target, outlet ) {
            if ( typeof target === 'undefined' ) {
                throw new Error( 1100 );
            }
            if ( typeof outlet === 'undefined' ) {
                throw new Error( 1101 );
            }
            delete this._outlets[ target ][ outlet ];

            return this;
        },

        /**
         * maps a handler for an event/route.<br/>
         * @example
         var hasExecuted = false;
         var userView = {
         showUserProfile : function(){
         hasExecuted = true;
         }
         }
         system.mapValue( 'userView', userView );
         system.mapHandler( 'user/profile', 'userView', 'showUserProfile' );
         system.notify( 'user/profile' );
         //hasExecuted is true
         * @example
         * var userView = {
         *      showUserProfile : function(){
         *          //do stuff
         *      }
         * }
         * system.mapValue( 'userView', userView );
         * <strong>system.mapHandler( 'showUserProfile', 'userView' );</strong>
         * system.notify( 'showUserProfile' );
         *
         * //userView.showUserProfile is called
         * @example
         * var showUserProfile = function(){
         *          //do stuff
         * }
         * <strong>system.mapHandler( 'user/profile', undefined, showUserProfile );</strong>
         * system.notify( 'user/profile' );
         *
         * //showUserProfile is called
         * @example
         * var userView = {};
         * var showUserProfile = function(){
         *          //do stuff
         * }
         * system.mapValue( 'userView', userView );
         * <strong>system.mapHandler( 'user/profile', 'userView', showUserProfile );</strong>
         * system.notify( 'user/profile' );
         *
         * //showUserProfile is called within the scope of the userView object
         * @example
         * var userView = {
         *      showUserProfile : function(){
         *          //do stuff
         *      }
         * }
         * system.mapValue( 'userView', userView );
         * <strong>system.mapHandler( 'user/profile', 'userView', 'showUserProfile', true );</strong>
         * system.notify( 'user/profile' );
         * system.notify( 'user/profile' );
         * system.notify( 'user/profile' );
         *
         * //userView.showUserProfile is called exactly once [!]
         * @example
         * var userView = {
         *      showUserProfile : function( route ){
         *          //do stuff
         *      }
         * }
         * system.mapValue( 'userView', userView );
         * <strong>system.mapHandler( 'user/profile', 'userView', 'showUserProfile', false, true );</strong>
         * system.notify( 'user/profile' );
         *
         * //userView.showUserProfile is called and the route/eventName is passed to the handler
         * @param {String} eventName/route
         * @param {String} [key=undefined] If <code>key</code> is <code>undefined</code> the handler will be called without
         * scope.
         * @param {String|Function} [handler=eventName] If <code>handler</code> is <code>undefined</code> the value of
         * <code>eventName</code> will be used as the name of the member holding the reference to the to-be-called function.
         * <code>handler</code> accepts either a string, which will be used as the name of the member holding the reference
         * to the to-be-called function, or a direct function reference.
         * @param {Boolean} [oneShot=false] Defines whether the handler should be called exactly once and then automatically
         * unmapped
         * @param {Boolean} [passEvent=false] Defines whether the event object should be passed to the handler or not.
         * @return {dijon.System}
         * @see dijon.System#notify
         * @see dijon.System#unmapHandler
         */
        mapHandler:function ( eventName, key, handler, oneShot, passEvent ) {
            if ( typeof eventName === 'undefined' ) {
                throw new Error( 1110 );
            }
            key = key || 'global';
            handler = handler || eventName;

            if ( typeof oneShot === 'undefined' ) {
                oneShot = false;
            }
            if ( typeof passEvent === 'undefined' ) {
                passEvent = false;
            }
            if ( !this._handlers.hasOwnProperty( eventName ) ) {
                this._handlers[ eventName ] = {};
            }
            if ( !this._handlers[eventName].hasOwnProperty( key ) ) {
                this._handlers[eventName][key] = [];
            }
            this._handlers[ eventName ][ key ].push( {
                handler:handler,
                oneShot:oneShot,
                passEvent:passEvent
            } );

            return this;
        },

        /**
         * Unmaps the handler for a specific event/route.
         * @param {String} eventName Name of the event/route
         * @param {String} [key=undefined] If <code>key</code> is <code>undefined</code> the handler is removed from the
         * global mapping space. (If the same event is mapped globally and specifically for an object, then
         * only the globally mapped one will be removed)
         * @param {String | Function} [handler=eventName]
         * @return {dijon.System}
         * @see dijon.System#mapHandler
         */
        unmapHandler:function ( eventName, key, handler ) {
            if ( typeof eventName === 'undefined' ) {
                throw new Error( 1120 );
            }
            key = key || 'global';
            //handler = handler || eventName;

            if ( this._handlers.hasOwnProperty( eventName ) && this._handlers[ eventName ].hasOwnProperty( key ) ) {
                var handlers = this._handlers[ eventName ][ key ];
                for ( var i in handlers ) {
                    var config = handlers[ i ];
                    if ( (!handler) || (config.handler === handler) ) {
                        handlers.splice( i, 1 );
                        break;
                    }
                }
            }
            return this;
        },

        /**
         * calls all handlers mapped to <code>eventName/route</code>
         * @param {String} eventName/route
         * @return {dijon.System}
         * @see dijon.System#mapHandler
         */
        notify:function ( eventName ) {
            if ( typeof eventName === 'undefined' ) {
                throw new Error( 1130 );
            }
            var argsWithEvent = Array.prototype.slice.call( arguments );
            var argsClean = argsWithEvent.slice( 1 );
            if ( this._handlers.hasOwnProperty( eventName ) ) {
                var handlers = this._handlers[ eventName ];
                for ( var key in handlers ) {
                    var configs = handlers[ key ];
                    var instance;
                    if ( key !== 'global' ) {
                        instance = this.getObject( key );
                    }
                    var toBeDeleted = [];
                    var i, n;
                    for ( i = 0, n = configs.length ; i < n ; i++ ) {
                        var handler;
                        var config = configs[ i ];
                        if ( instance && typeof config.handler === "string" ) {
                            handler = instance[ config.handler ];
                        } else {
                            handler = config.handler;
                        }

                        //see deletion below
                        if ( config.oneShot ) {
                            toBeDeleted.unshift( i );
                        }

                        if ( config.passEvent ) {
                            handler.apply( instance, argsWithEvent );
                        } else {
                            handler.apply( instance, argsClean );
                        }
                    }

                    //items should be deleted in reverse order
                    //either use push above and decrement here
                    //or use unshift above and increment here
                    for ( i = 0, n = toBeDeleted.length ; i < n ; i++ ) {
                        configs.splice( toBeDeleted[ i ], 1 );
                    }
                }
            }

            return this;
        }

    };//dijon.System.prototype

    scope.dijon = dijon;
}( this ));



// Copyright 2009 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

goog = {};
goog.math = {};

/**
 * @fileoverview Defines a Long class for representing a 64-bit two's-complement
 * integer value, which faithfully simulates the behavior of a Java "long". This
 * implementation is derived from LongLib in GWT.
 *
 */

//goog.provide('goog.math.Long');



/**
 * Constructs a 64-bit two's-complement integer, given its low and high 32-bit
 * values as *signed* integers.  See the from* functions below for more
 * convenient ways of constructing Longs.
 *
 * The internal representation of a long is the two given signed, 32-bit values.
 * We use 32-bit pieces because these are the size of integers on which
 * Javascript performs bit-operations.  For operations like addition and
 * multiplication, we split each number into 16-bit pieces, which can easily be
 * multiplied within Javascript's floating-point representation without overflow
 * or change in sign.
 *
 * In the algorithms below, we frequently reduce the negative case to the
 * positive case by negating the input(s) and then post-processing the result.
 * Note that we must ALWAYS check specially whether those values are MIN_VALUE
 * (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
 * a positive number, it overflows back into a negative).  Not handling this
 * case would often result in infinite recursion.
 *
 * @param {number} low  The low (signed) 32 bits of the long.
 * @param {number} high  The high (signed) 32 bits of the long.
 * @constructor
 */
goog.math.Long = function(low, high) {
  /**
   * @type {number}
   * @private
   */
  this.low_ = low | 0;  // force into 32 signed bits.

  /**
   * @type {number}
   * @private
   */
  this.high_ = high | 0;  // force into 32 signed bits.
};


// NOTE: Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the
// from* methods on which they depend.


/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @private
 */
goog.math.Long.IntCache_ = {};


/**
 * Returns a Long representing the given (32-bit) integer value.
 * @param {number} value The 32-bit integer in question.
 * @return {!goog.math.Long} The corresponding Long value.
 */
goog.math.Long.fromInt = function(value) {
  if (-128 <= value && value < 128) {
    var cachedObj = goog.math.Long.IntCache_[value];
    if (cachedObj) {
      return cachedObj;
    }
  }

  var obj = new goog.math.Long(value | 0, value < 0 ? -1 : 0);
  if (-128 <= value && value < 128) {
    goog.math.Long.IntCache_[value] = obj;
  }
  return obj;
};


/**
 * Returns a Long representing the given value, provided that it is a finite
 * number.  Otherwise, zero is returned.
 * @param {number} value The number in question.
 * @return {!goog.math.Long} The corresponding Long value.
 */
goog.math.Long.fromNumber = function(value) {
  if (isNaN(value) || !isFinite(value)) {
    return goog.math.Long.ZERO;
  } else if (value <= -goog.math.Long.TWO_PWR_63_DBL_) {
    return goog.math.Long.MIN_VALUE;
  } else if (value + 1 >= goog.math.Long.TWO_PWR_63_DBL_) {
    return goog.math.Long.MAX_VALUE;
  } else if (value < 0) {
    return goog.math.Long.fromNumber(-value).negate();
  } else {
    return new goog.math.Long(
        (value % goog.math.Long.TWO_PWR_32_DBL_) | 0,
        (value / goog.math.Long.TWO_PWR_32_DBL_) | 0);
  }
};


/**
 * Returns a Long representing the 64-bit integer that comes by concatenating
 * the given high and low bits.  Each is assumed to use 32 bits.
 * @param {number} lowBits The low 32-bits.
 * @param {number} highBits The high 32-bits.
 * @return {!goog.math.Long} The corresponding Long value.
 */
goog.math.Long.fromBits = function(lowBits, highBits) {
  return new goog.math.Long(lowBits, highBits);
};


/**
 * Returns a Long representation of the given string, written using the given
 * radix.
 * @param {string} str The textual representation of the Long.
 * @param {number=} opt_radix The radix in which the text is written.
 * @return {!goog.math.Long} The corresponding Long value.
 */
goog.math.Long.fromString = function(str, opt_radix) {
  if (str.length == 0) {
    throw Error('number format error: empty string');
  }

  var radix = opt_radix || 10;
  if (radix < 2 || 36 < radix) {
    throw Error('radix out of range: ' + radix);
  }

  if (str.charAt(0) == '-') {
    return goog.math.Long.fromString(str.substring(1), radix).negate();
  } else if (str.indexOf('-') >= 0) {
    throw Error('number format error: interior "-" character: ' + str);
  }

  // Do several (8) digits each time through the loop, so as to
  // minimize the calls to the very expensive emulated div.
  var radixToPower = goog.math.Long.fromNumber(Math.pow(radix, 8));

  var result = goog.math.Long.ZERO;
  for (var i = 0; i < str.length; i += 8) {
    var size = Math.min(8, str.length - i);
    var value = parseInt(str.substring(i, i + size), radix);
    if (size < 8) {
      var power = goog.math.Long.fromNumber(Math.pow(radix, size));
      result = result.multiply(power).add(goog.math.Long.fromNumber(value));
    } else {
      result = result.multiply(radixToPower);
      result = result.add(goog.math.Long.fromNumber(value));
    }
  }
  return result;
};


// NOTE: the compiler should inline these constant values below and then remove
// these variables, so there should be no runtime penalty for these.


/**
 * Number used repeated below in calculations.  This must appear before the
 * first call to any from* function below.
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_16_DBL_ = 1 << 16;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_24_DBL_ = 1 << 24;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_32_DBL_ =
    goog.math.Long.TWO_PWR_16_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_31_DBL_ =
    goog.math.Long.TWO_PWR_32_DBL_ / 2;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_48_DBL_ =
    goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_64_DBL_ =
    goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_32_DBL_;


/**
 * @type {number}
 * @private
 */
goog.math.Long.TWO_PWR_63_DBL_ =
    goog.math.Long.TWO_PWR_64_DBL_ / 2;


/** @type {!goog.math.Long} */
goog.math.Long.ZERO = goog.math.Long.fromInt(0);


/** @type {!goog.math.Long} */
goog.math.Long.ONE = goog.math.Long.fromInt(1);


/** @type {!goog.math.Long} */
goog.math.Long.NEG_ONE = goog.math.Long.fromInt(-1);


/** @type {!goog.math.Long} */
goog.math.Long.MAX_VALUE =
    goog.math.Long.fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0);


/** @type {!goog.math.Long} */
goog.math.Long.MIN_VALUE = goog.math.Long.fromBits(0, 0x80000000 | 0);


/**
 * @type {!goog.math.Long}
 * @private
 */
goog.math.Long.TWO_PWR_24_ = goog.math.Long.fromInt(1 << 24);


/** @return {number} The value, assuming it is a 32-bit integer. */
goog.math.Long.prototype.toInt = function() {
  return this.low_;
};


/** @return {number} The closest floating-point representation to this value. */
goog.math.Long.prototype.toNumber = function() {
  return this.high_ * goog.math.Long.TWO_PWR_32_DBL_ +
         this.getLowBitsUnsigned();
};


/**
 * @param {number=} opt_radix The radix in which the text should be written.
 * @return {string} The textual representation of this value.
 * @override
 */
goog.math.Long.prototype.toString = function(opt_radix) {
  var radix = opt_radix || 10;
  if (radix < 2 || 36 < radix) {
    throw Error('radix out of range: ' + radix);
  }

  if (this.isZero()) {
    return '0';
  }

  if (this.isNegative()) {
    if (this.equals(goog.math.Long.MIN_VALUE)) {
      // We need to change the Long value before it can be negated, so we remove
      // the bottom-most digit in this base and then recurse to do the rest.
      var radixLong = goog.math.Long.fromNumber(radix);
      var div = this.div(radixLong);
      var rem = div.multiply(radixLong).subtract(this);
      return div.toString(radix) + rem.toInt().toString(radix);
    } else {
      return '-' + this.negate().toString(radix);
    }
  }

  // Do several (6) digits each time through the loop, so as to
  // minimize the calls to the very expensive emulated div.
  var radixToPower = goog.math.Long.fromNumber(Math.pow(radix, 6));

  var rem = this;
  var result = '';
  while (true) {
    var remDiv = rem.div(radixToPower);
    var intval = rem.subtract(remDiv.multiply(radixToPower)).toInt();
    var digits = intval.toString(radix);

    rem = remDiv;
    if (rem.isZero()) {
      return digits + result;
    } else {
      while (digits.length < 6) {
        digits = '0' + digits;
      }
      result = '' + digits + result;
    }
  }
};


/** @return {number} The high 32-bits as a signed value. */
goog.math.Long.prototype.getHighBits = function() {
  return this.high_;
};


/** @return {number} The low 32-bits as a signed value. */
goog.math.Long.prototype.getLowBits = function() {
  return this.low_;
};


/** @return {number} The low 32-bits as an unsigned value. */
goog.math.Long.prototype.getLowBitsUnsigned = function() {
  return (this.low_ >= 0) ?
      this.low_ : goog.math.Long.TWO_PWR_32_DBL_ + this.low_;
};


/**
 * @return {number} Returns the number of bits needed to represent the absolute
 *     value of this Long.
 */
goog.math.Long.prototype.getNumBitsAbs = function() {
  if (this.isNegative()) {
    if (this.equals(goog.math.Long.MIN_VALUE)) {
      return 64;
    } else {
      return this.negate().getNumBitsAbs();
    }
  } else {
    var val = this.high_ != 0 ? this.high_ : this.low_;
    for (var bit = 31; bit > 0; bit--) {
      if ((val & (1 << bit)) != 0) {
        break;
      }
    }
    return this.high_ != 0 ? bit + 33 : bit + 1;
  }
};


/** @return {boolean} Whether this value is zero. */
goog.math.Long.prototype.isZero = function() {
  return this.high_ == 0 && this.low_ == 0;
};


/** @return {boolean} Whether this value is negative. */
goog.math.Long.prototype.isNegative = function() {
  return this.high_ < 0;
};


/** @return {boolean} Whether this value is odd. */
goog.math.Long.prototype.isOdd = function() {
  return (this.low_ & 1) == 1;
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long equals the other.
 */
goog.math.Long.prototype.equals = function(other) {
  return (this.high_ == other.high_) && (this.low_ == other.low_);
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long does not equal the other.
 */
goog.math.Long.prototype.notEquals = function(other) {
  return (this.high_ != other.high_) || (this.low_ != other.low_);
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long is less than the other.
 */
goog.math.Long.prototype.lessThan = function(other) {
  return this.compare(other) < 0;
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long is less than or equal to the other.
 */
goog.math.Long.prototype.lessThanOrEqual = function(other) {
  return this.compare(other) <= 0;
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long is greater than the other.
 */
goog.math.Long.prototype.greaterThan = function(other) {
  return this.compare(other) > 0;
};


/**
 * @param {goog.math.Long} other Long to compare against.
 * @return {boolean} Whether this Long is greater than or equal to the other.
 */
goog.math.Long.prototype.greaterThanOrEqual = function(other) {
  return this.compare(other) >= 0;
};


/**
 * Compares this Long with the given one.
 * @param {goog.math.Long} other Long to compare against.
 * @return {number} 0 if they are the same, 1 if the this is greater, and -1
 *     if the given one is greater.
 */
goog.math.Long.prototype.compare = function(other) {
  if (this.equals(other)) {
    return 0;
  }

  var thisNeg = this.isNegative();
  var otherNeg = other.isNegative();
  if (thisNeg && !otherNeg) {
    return -1;
  }
  if (!thisNeg && otherNeg) {
    return 1;
  }

  // at this point, the signs are the same, so subtraction will not overflow
  if (this.subtract(other).isNegative()) {
    return -1;
  } else {
    return 1;
  }
};


/** @return {!goog.math.Long} The negation of this value. */
goog.math.Long.prototype.negate = function() {
  if (this.equals(goog.math.Long.MIN_VALUE)) {
    return goog.math.Long.MIN_VALUE;
  } else {
    return this.not().add(goog.math.Long.ONE);
  }
};


/**
 * Returns the sum of this and the given Long.
 * @param {goog.math.Long} other Long to add to this one.
 * @return {!goog.math.Long} The sum of this and the given Long.
 */
goog.math.Long.prototype.add = function(other) {
  // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

  var a48 = this.high_ >>> 16;
  var a32 = this.high_ & 0xFFFF;
  var a16 = this.low_ >>> 16;
  var a00 = this.low_ & 0xFFFF;

  var b48 = other.high_ >>> 16;
  var b32 = other.high_ & 0xFFFF;
  var b16 = other.low_ >>> 16;
  var b00 = other.low_ & 0xFFFF;

  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 + b00;
  c16 += c00 >>> 16;
  c00 &= 0xFFFF;
  c16 += a16 + b16;
  c32 += c16 >>> 16;
  c16 &= 0xFFFF;
  c32 += a32 + b32;
  c48 += c32 >>> 16;
  c32 &= 0xFFFF;
  c48 += a48 + b48;
  c48 &= 0xFFFF;
  return goog.math.Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32);
};


/**
 * Returns the difference of this and the given Long.
 * @param {goog.math.Long} other Long to subtract from this.
 * @return {!goog.math.Long} The difference of this and the given Long.
 */
goog.math.Long.prototype.subtract = function(other) {
  return this.add(other.negate());
};


/**
 * Returns the product of this and the given long.
 * @param {goog.math.Long} other Long to multiply with this.
 * @return {!goog.math.Long} The product of this and the other.
 */
goog.math.Long.prototype.multiply = function(other) {
  if (this.isZero()) {
    return goog.math.Long.ZERO;
  } else if (other.isZero()) {
    return goog.math.Long.ZERO;
  }

  if (this.equals(goog.math.Long.MIN_VALUE)) {
    return other.isOdd() ? goog.math.Long.MIN_VALUE : goog.math.Long.ZERO;
  } else if (other.equals(goog.math.Long.MIN_VALUE)) {
    return this.isOdd() ? goog.math.Long.MIN_VALUE : goog.math.Long.ZERO;
  }

  if (this.isNegative()) {
    if (other.isNegative()) {
      return this.negate().multiply(other.negate());
    } else {
      return this.negate().multiply(other).negate();
    }
  } else if (other.isNegative()) {
    return this.multiply(other.negate()).negate();
  }

  // If both longs are small, use float multiplication
  if (this.lessThan(goog.math.Long.TWO_PWR_24_) &&
      other.lessThan(goog.math.Long.TWO_PWR_24_)) {
    return goog.math.Long.fromNumber(this.toNumber() * other.toNumber());
  }

  // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
  // We can skip products that would overflow.

  var a48 = this.high_ >>> 16;
  var a32 = this.high_ & 0xFFFF;
  var a16 = this.low_ >>> 16;
  var a00 = this.low_ & 0xFFFF;

  var b48 = other.high_ >>> 16;
  var b32 = other.high_ & 0xFFFF;
  var b16 = other.low_ >>> 16;
  var b00 = other.low_ & 0xFFFF;

  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 * b00;
  c16 += c00 >>> 16;
  c00 &= 0xFFFF;
  c16 += a16 * b00;
  c32 += c16 >>> 16;
  c16 &= 0xFFFF;
  c16 += a00 * b16;
  c32 += c16 >>> 16;
  c16 &= 0xFFFF;
  c32 += a32 * b00;
  c48 += c32 >>> 16;
  c32 &= 0xFFFF;
  c32 += a16 * b16;
  c48 += c32 >>> 16;
  c32 &= 0xFFFF;
  c32 += a00 * b32;
  c48 += c32 >>> 16;
  c32 &= 0xFFFF;
  c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
  c48 &= 0xFFFF;
  return goog.math.Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32);
};


/**
 * Returns this Long divided by the given one.
 * @param {goog.math.Long} other Long by which to divide.
 * @return {!goog.math.Long} This Long divided by the given one.
 */
goog.math.Long.prototype.div = function(other) {
  if (other.isZero()) {
    throw Error('division by zero');
  } else if (this.isZero()) {
    return goog.math.Long.ZERO;
  }

  if (this.equals(goog.math.Long.MIN_VALUE)) {
    if (other.equals(goog.math.Long.ONE) ||
        other.equals(goog.math.Long.NEG_ONE)) {
      return goog.math.Long.MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
    } else if (other.equals(goog.math.Long.MIN_VALUE)) {
      return goog.math.Long.ONE;
    } else {
      // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
      var halfThis = this.shiftRight(1);
      var approx = halfThis.div(other).shiftLeft(1);
      if (approx.equals(goog.math.Long.ZERO)) {
        return other.isNegative() ? goog.math.Long.ONE : goog.math.Long.NEG_ONE;
      } else {
        var rem = this.subtract(other.multiply(approx));
        var result = approx.add(rem.div(other));
        return result;
      }
    }
  } else if (other.equals(goog.math.Long.MIN_VALUE)) {
    return goog.math.Long.ZERO;
  }

  if (this.isNegative()) {
    if (other.isNegative()) {
      return this.negate().div(other.negate());
    } else {
      return this.negate().div(other).negate();
    }
  } else if (other.isNegative()) {
    return this.div(other.negate()).negate();
  }

  // Repeat the following until the remainder is less than other:  find a
  // floating-point that approximates remainder / other *from below*, add this
  // into the result, and subtract it from the remainder.  It is critical that
  // the approximate value is less than or equal to the real value so that the
  // remainder never becomes negative.
  var res = goog.math.Long.ZERO;
  var rem = this;
  while (rem.greaterThanOrEqual(other)) {
    // Approximate the result of division. This may be a little greater or
    // smaller than the actual value.
    var approx = Math.max(1, Math.floor(rem.toNumber() / other.toNumber()));

    // We will tweak the approximate result by changing it in the 48-th digit or
    // the smallest non-fractional digit, whichever is larger.
    var log2 = Math.ceil(Math.log(approx) / Math.LN2);
    var delta = (log2 <= 48) ? 1 : Math.pow(2, log2 - 48);

    // Decrease the approximation until it is smaller than the remainder.  Note
    // that if it is too large, the product overflows and is negative.
    var approxRes = goog.math.Long.fromNumber(approx);
    var approxRem = approxRes.multiply(other);
    while (approxRem.isNegative() || approxRem.greaterThan(rem)) {
      approx -= delta;
      approxRes = goog.math.Long.fromNumber(approx);
      approxRem = approxRes.multiply(other);
    }

    // We know the answer can't be zero... and actually, zero would cause
    // infinite recursion since we would make no progress.
    if (approxRes.isZero()) {
      approxRes = goog.math.Long.ONE;
    }

    res = res.add(approxRes);
    rem = rem.subtract(approxRem);
  }
  return res;
};


/**
 * Returns this Long modulo the given one.
 * @param {goog.math.Long} other Long by which to mod.
 * @return {!goog.math.Long} This Long modulo the given one.
 */
goog.math.Long.prototype.modulo = function(other) {
  return this.subtract(this.div(other).multiply(other));
};


/** @return {!goog.math.Long} The bitwise-NOT of this value. */
goog.math.Long.prototype.not = function() {
  return goog.math.Long.fromBits(~this.low_, ~this.high_);
};


/**
 * Returns the bitwise-AND of this Long and the given one.
 * @param {goog.math.Long} other The Long with which to AND.
 * @return {!goog.math.Long} The bitwise-AND of this and the other.
 */
goog.math.Long.prototype.and = function(other) {
  return goog.math.Long.fromBits(this.low_ & other.low_,
                                 this.high_ & other.high_);
};


/**
 * Returns the bitwise-OR of this Long and the given one.
 * @param {goog.math.Long} other The Long with which to OR.
 * @return {!goog.math.Long} The bitwise-OR of this and the other.
 */
goog.math.Long.prototype.or = function(other) {
  return goog.math.Long.fromBits(this.low_ | other.low_,
                                 this.high_ | other.high_);
};


/**
 * Returns the bitwise-XOR of this Long and the given one.
 * @param {goog.math.Long} other The Long with which to XOR.
 * @return {!goog.math.Long} The bitwise-XOR of this and the other.
 */
goog.math.Long.prototype.xor = function(other) {
  return goog.math.Long.fromBits(this.low_ ^ other.low_,
                                 this.high_ ^ other.high_);
};


/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number} numBits The number of bits by which to shift.
 * @return {!goog.math.Long} This shifted to the left by the given amount.
 */
goog.math.Long.prototype.shiftLeft = function(numBits) {
  numBits &= 63;
  if (numBits == 0) {
    return this;
  } else {
    var low = this.low_;
    if (numBits < 32) {
      var high = this.high_;
      return goog.math.Long.fromBits(
          low << numBits,
          (high << numBits) | (low >>> (32 - numBits)));
    } else {
      return goog.math.Long.fromBits(0, low << (numBits - 32));
    }
  }
};


/**
 * Returns this Long with bits shifted to the right by the given amount.
 * @param {number} numBits The number of bits by which to shift.
 * @return {!goog.math.Long} This shifted to the right by the given amount.
 */
goog.math.Long.prototype.shiftRight = function(numBits) {
  numBits &= 63;
  if (numBits == 0) {
    return this;
  } else {
    var high = this.high_;
    if (numBits < 32) {
      var low = this.low_;
      return goog.math.Long.fromBits(
          (low >>> numBits) | (high << (32 - numBits)),
          high >> numBits);
    } else {
      return goog.math.Long.fromBits(
          high >> (numBits - 32),
          high >= 0 ? 0 : -1);
    }
  }
};


/**
 * Returns this Long with bits shifted to the right by the given amount, with
 * the new top bits matching the current sign bit.
 * @param {number} numBits The number of bits by which to shift.
 * @return {!goog.math.Long} This shifted to the right by the given amount, with
 *     zeros placed into the new leading bits.
 */
goog.math.Long.prototype.shiftRightUnsigned = function(numBits) {
  numBits &= 63;
  if (numBits == 0) {
    return this;
  } else {
    var high = this.high_;
    if (numBits < 32) {
      var low = this.low_;
      return goog.math.Long.fromBits(
          (low >>> numBits) | (high << (32 - numBits)),
          high >>> numBits);
    } else if (numBits == 32) {
      return goog.math.Long.fromBits(high, 0);
    } else {
      return goog.math.Long.fromBits(high >>> (numBits - 32), 0);
    }
  }
};
/*
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * author Digital Primates
 * copyright dash-if 2012
 */
 if(typeof(utils) == "undefined"){
 	var utils = {};
 }

 if(typeof(utils.Math) == "undefined"){
 	utils.Math = {};
 }

 utils.Math.to64BitNumber = function(low, high) {
	var highNum, lowNum, expected;

	highNum = new goog.math.Long(0, high);
	lowNum = new goog.math.Long(low, 0);
	expected = highNum.add(lowNum);

	return expected.toNumber();
}
/*
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * author Digital Primates
 * copyright dash-if 2012
 */

/*
 * var parent,
 *     child,
 *     properties = [
                    {
                        name: 'profiles',
                        merge: false
                    }
                ];
 *
 * parent = {};
 * parent.name = "ParentNode";
 * parent.isRoor = false;
 * parent.isArray = false;
 * parent.parent = null;
 * parent.children = [];
 * parent.properties = properties;
 *
 * child = {};
 * child.name = "ChildNode";
 * child.isRoor = false;
 * child.isArray = true;
 * child.parent = parent;
 * child.children = null;
 * child.properties = properties;
 * parent.children.push(child);
 *
 */

function ObjectIron(map) {

    var lookup;

    // create a list of top level items to search for
    lookup = [];
    for (i = 0, len = map.length; i < len; i += 1) {
        if (map[i].isRoot) {
            lookup.push("root");
        } else {
            lookup.push(map[i].name);
        }
    }

    var mergeValues = function (parentItem, childItem) {
            var name,
                parentValue,
                childValue;

            if (parentItem === null || childItem === null) {
                return;
            }

            for (name in parentItem) {
                if (parentItem.hasOwnProperty(name)) {
                    if (!childItem.hasOwnProperty(name)) {
                        childItem[name] = parentItem[name];
                    }
                }
            }
        },

        mapProperties = function (properties, parent, child) {
            var i,
                len,
                property,
                parentValue,
                childValue;

            if (properties === null || properties.length === 0) {
                return;
            }

            for (i = 0, len = properties.length; i < len; i += 1) {
                property = properties[i];

                if (parent.hasOwnProperty(property.name)) {
                    if (child.hasOwnProperty(property.name)) {
                        // check to see if we should merge
                        if (property.merge) {
                           parentValue = parent[property.name];
                           childValue = child[property.name];

                            // complex objects; merge properties
                            if (typeof parentValue === 'object' && typeof childValue === 'object') {
                                mergeValues(parentValue, childValue);
                            }
                            // simple objects; merge them together
                            else {
                                if (property.mergeFunction != null) {
                                    child[property.name] = property.mergeFunction(parentValue, childValue);
                                } else {
                                    child[property.name] = parentValue + childValue;
                                }
                            }
                        }
                    } else {
                        // just add the property
                        child[property.name] = parent[property.name];
                    }
                }
            }
        },

        mapItem = function (obj, node) {
            var item = obj,
                i,
                len,
                v,
                len2,
                array,
                childItem,
                childNode,
                property;

            if (item.children === null || item.children.length === 0) {
                return;
            }

            for (i = 0, len = item.children.length; i < len; i += 1) {
                childItem = item.children[i];

                if (node.hasOwnProperty(childItem.name)) {
                    if (childItem.isArray) {
                        array = node[childItem.name + "_asArray"];
                        for (v = 0, len2 = array.length; v < len2; v += 1) {
                            childNode = array[v];
                            mapProperties(item.properties, node, childNode);
                            mapItem(childItem, childNode);
                        }
                    } else {
                        childNode = node[childItem.name];
                        mapProperties(item.properties, node, childNode);
                        mapItem(childItem, childNode);
                    }
                }
            }
        },

        performMapping = function (source) {
            var i,
                len,
                pi,
                pp,
                item,
                node,
                array;

            if (source === null) {
                return source;
            }

            if (typeof source !== 'object') {
                return source;
            }

            // first look to see if anything cares about the root node
            for (i = 0, len = lookup.length; i < len; i += 1) {
                if (lookup[i] === "root") {
                    item = map[i];
                    node = source;
                    mapItem(item, node);
                }
            }

            // iterate over the objects and look for any of the items we care about
            for (pp in source) {
                if (source.hasOwnProperty(pp)) {
                    pi = lookup.indexOf(pp);
                    if (pi !== -1) {
                        item = map[pi];

                        if (item.isArray) {
                            array = source[pp + "_asArray"];
                            for (i = 0, len = array.length; i < len; i += 1) {
                                node = array[i];
                                mapItem(item, node);
                            }
                        } else {
                            node = source[pp];
                            mapItem(item, node);
                        }
                    }
                    // now check this to see if he has any of the properties we care about
                    performMapping(source[pp]);
                }
            }

            return source;
        };

    return {
        run: performMapping
    };
}
// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    // Turn off strict mode for this function so we can assign to global.Q
    /*jshint strict: false*/
    Q = definition();
})(function () {
"use strict";

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick;
if (typeof process !== "undefined") {
    // node
    nextTick = process.nextTick;
} else if (typeof setImmediate === "function") {
    // In IE10, or use https://github.com/NobleJS/setImmediate
    if (typeof window !== "undefined") {
        nextTick = setImmediate.bind(window);
    } else {
        nextTick = setImmediate;
    }
} else {
    (function () {
        // linked list of tasks (single, with head node)
        var head = {task: void 0, next: null}, tail = head,
            maxPendingTicks = 2, pendingTicks = 0, queuedTasks = 0, usedTicks = 0,
            requestTick;

        function onTick() {
            // In case of multiple tasks ensure at least one subsequent tick
            // to handle remaining tasks in case one throws.
            --pendingTicks;

            if (++usedTicks >= maxPendingTicks) {
                // Amortize latency after thrown exceptions.
                usedTicks = 0;
                maxPendingTicks *= 4; // fast grow!
                var expectedTicks = queuedTasks && Math.min(queuedTasks - 1, maxPendingTicks);
                while (pendingTicks < expectedTicks) {
                    ++pendingTicks;
                    requestTick();
                }
            }

            while (queuedTasks) {
                --queuedTasks; // decrement here to ensure it's never negative
                head = head.next;
                var task = head.task;
                head.task = void 0;
                task();
            }

            usedTicks = 0;
        }

        nextTick = function (task) {
            tail = tail.next = {task: task, next: null};
            if (pendingTicks < ++queuedTasks && pendingTicks < maxPendingTicks) {
                ++pendingTicks;
                requestTick();
            }
        };

        if (typeof MessageChannel !== "undefined") {
            // modern browsers
            // http://www.nonblocking.io/2011/06/windownexttick.html
            var channel = new MessageChannel();
            channel.port1.onmessage = onTick;
            requestTick = function () {
                channel.port2.postMessage(0);
            };

        } else {
            // old browsers
            requestTick = function () {
                setTimeout(onTick, 0);
            };
        }
    })();
}

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this does have the nice side-effect of reducing the size
// of the code by reducing x.call() to merely x(), eliminating many
// hard-to-minify characters.
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
function uncurryThis(f) {
    var call = Function.call;
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

// generator related shims

function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

Q.longStackJumpLimit = 1;

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible (that is, if in V8), transform the error stack
    // trace by removing Node and Q cruft, then concatenating with
    // the stack trace of the promise we are ``done``ing. See #57.
    if (promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
        error.stack = filterStackString(error.stack) +
            "\n" + STACK_JUMP_SEPARATOR + "\n" +
            filterStackString(promise.stack);
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line)) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function isInternalFrame(stackLine) {
    var pieces = /at .+ \((.*):(\d+):\d+\)/.exec(stackLine);

    if (!pieces) {
        return false;
    }

    var fileName = pieces[1];
    var lineNumber = pieces[2];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (Error.captureStackTrace) {
        var fileName, lineNumber;

        var oldPrepareStackTrace = Error.prepareStackTrace;

        Error.prepareStackTrace = function (error, frames) {
            fileName = frames[1].getFileName();
            lineNumber = frames[1].getLineNumber();
        };

        // teases call of temporary prepareStackTrace
        // JSHint and Closure Compiler generate known warnings here
        /*jshint expr: true */
        new Error().stack;

        Error.prepareStackTrace = oldPrepareStackTrace;
        qFileName = fileName;
        return lineNumber;
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" && typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative + " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Creates fulfilled promises from non-promises,
 * Passes Q promises through,
 * Coerces CommonJS/Promises/A+ promises to Q promises.
 */
function Q(value) {
    return resolve(value);
}

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Constructs a {promise, resolve} object.
 *
 * The resolver is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke the resolver with any value that is
 * not a function. To reject the promise, invoke the resolver with a rejection
 * object. To put the promise in the same state as another promise, invoke the
 * resolver with that other promise.
 */
Q.defer = defer;
function defer() {
    // if "pending" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the pending array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the ref promise because it handles both fully
    // resolved values and other promises gracefully.
    var pending = [], progressListeners = [], value;

    var deferred = object_create(defer.prototype);
    var promise = object_create(makePromise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (pending) {
            pending.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            nextTick(function () {
                value.promiseDispatch.apply(value, args);
            });
        }
    };

    promise.valueOf = function () {
        if (pending) {
            return promise;
        }
        value = valueOf(value); // shorten chain
        return value;
    };

    if (Error.captureStackTrace && Q.longStackJumpLimit > 0) {
        Error.captureStackTrace(promise, defer);

        // Reify the stack into a string by using the accessor; this prevents
        // memory leaks as per GH-111. At the same time, cut off the first line;
        // it's always just "[object Promise]\n", as per the `toString`.
        promise.stack = promise.stack.substring(promise.stack.indexOf("\n") + 1);
    }

    function become(resolvedValue) {
        if (!pending) {
            return;
        }
        value = resolve(resolvedValue);
        array_reduce(pending, function (undefined, pending) {
            nextTick(function () {
                value.promiseDispatch.apply(value, pending);
            });
        }, void 0);
        pending = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = become;
    deferred.fulfill = function (value) {
        become(fulfill(value));
    };
    deferred.reject = function (exception) {
        become(reject(exception));
    };
    deferred.notify = function (progress) {
        if (pending) {
            array_reduce(progressListeners, function (undefined, progressListener) {
                nextTick(function () {
                    progressListener(progress);
                });
            }, void 0);
        }
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param makePromise {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in makePromise
 */
Q.promise = promise;
function promise(makePromise) {
    var deferred = defer();
    fcall(
        makePromise,
        deferred.resolve,
        deferred.reject,
        deferred.notify
    ).fail(deferred.reject);
    return deferred.promise;
}

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * put(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = makePromise;
function makePromise(descriptor, fallback, valueOf, exception, isException) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error("Promise does not support operation: " + op));
        };
    }

    var promise = object_create(makePromise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    if (valueOf) {
        promise.valueOf = valueOf;
    }

    if (isException) {
        promise.exception = exception;
    }

    return promise;
}

// provide thenables, CommonJS/Promises/A
makePromise.prototype.then = function (fulfilled, rejected, progressed) {
    return when(this, fulfilled, rejected, progressed);
};

makePromise.prototype.thenResolve = function (value) {
    return when(this, function () { return value; });
};

// Chainable methods
array_reduce(
    [
        "isFulfilled", "isRejected", "isPending",
        "dispatch",
        "when", "spread",
        "get", "put", "set", "del", "delete",
        "post", "send", "invoke",
        "keys",
        "fapply", "fcall", "fbind",
        "all", "allResolved",
        "timeout", "delay",
        "catch", "finally", "fail", "fin", "progress", "done",
        "nfcall", "nfapply", "nfbind", "denodeify", "nbind",
        "ncall", "napply", "nbind",
        "npost", "nsend", "ninvoke",
        "nodeify"
    ],
    function (undefined, name) {
        makePromise.prototype[name] = function () {
            return Q[name].apply(
                Q,
                [this].concat(array_slice(arguments))
            );
        };
    },
    void 0
);

makePromise.prototype.toSource = function () {
    return this.toString();
};

makePromise.prototype.toString = function () {
    return "[object Promise]";
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */
Q.nearer = valueOf;
function valueOf(value) {
    if (isPromise(value)) {
        return value.valueOf();
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object && typeof object.promiseDispatch === "function";
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return object && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return !isFulfilled(object) && !isRejected(object);
}

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromiseAlike(valueOf(object));
}

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    object = valueOf(object);
    return isPromise(object) && 'exception' in object;
}

var rejections = [];
var errors = [];
var errorsDisplayed;
function displayErrors() {

    /*
      HACK MGA :  remove !window.Touch in the condition
      because window.Touch is defined in Chrome, so errors are never displayed...
    */

    if (
        !errorsDisplayed &&
        typeof window !== "undefined" &&
        window.console
    ) {
        // This promise library consumes exceptions thrown in handlers so
        // they can be handled by a subsequent promise.  The rejected
        // promises get added to this array when they are created, and
        // removed when they are handled.

        //HACK MGA : change log level (log to error)
        console.error("Should be empty:", errors);
    }
    // HACK MGA : remove this affectation to display ALL errors
    // errorsDisplayed = true;
}

// Show unhandled rejection if Node exits without handling an outstanding
// rejection.  (Note that Browserify presently produces a process global
// without the Emitter on interface)
if (typeof process !== "undefined" && process.on) {
    process.on("exit", function () {
        for (var i = 0; i < errors.length; i++) {
            var error = errors[i];
            if (error && typeof error.stack !== "undefined") {
                console.warn("Unhandled rejected promise:", error.stack);
            } else {
                console.warn("Unhandled rejected promise (no stack):", error);
            }
        }
    });
}

/**
 * Constructs a rejected promise.
 * @param exception value describing the failure
 */
Q.reject = reject;
function reject(exception) {
    var rejection = makePromise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                var at = array_indexOf(rejections, this);
                if (at !== -1) {
                    errors.splice(at, 1);
                    rejections.splice(at, 1);
                }
            }
            return rejected ? rejected(exception) : this;
        }
    }, function fallback() {
        return reject(exception);
    }, function valueOf() {
        return this;
    }, exception, true);
    rejections.push(rejection);
    errors.push(exception);
    // note that the error has not been handled
    // HACK MGA : change call order because in disaplyErrors, we use errors...
    //displayErrors();
    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(object) {
    return makePromise({
        "when": function () {
            return object;
        },
        "get": function (name) {
            return object[name];
        },
        "set": function (name, value) {
            object[name] = value;
        },
        "delete": function (name) {
            delete object[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name == null) { // iff name is null or undefined
                return object.apply(void 0, args);
            } else {
                return object[name].apply(object, args);
            }
        },
        "apply": function (thisP, args) {
            return object.apply(thisP, args);
        },
        "keys": function () {
            return object_keys(object);
        }
    }, void 0, function valueOf() {
        return object;
    });
}

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
Q.resolve = resolve;
function resolve(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (isPromise(value)) {
        return value;
    }
    // In order to break infinite recursion or loops between `then` and
    // `resolve`, it is necessary to attempt to extract fulfilled values
    // out of foreign promise implementations before attempting to wrap
    // them as unresolved promises.  It is my hope that other
    // implementations will implement `valueOf` to synchronously extract
    // the fulfillment value from their fulfilled promises.  If the
    // other promise library does not implement `valueOf`, the
    // implementations on primordial prototypes are harmless.
    value = valueOf(value);
    // assimilate thenables, CommonJS/Promises/A+
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return makePromise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return valueOf(object);
    });
}

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, resolvedValue);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    var resolvedValue = resolve(value);
    nextTick(function () {
        resolvedValue.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    resolvedValue.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(promise, fulfilled, rejected) {
    return when(promise, function (valuesOrPromises) {
        return all(valuesOrPromises).then(function (values) {
            return fulfilled.apply(void 0, values);
        }, rejected);
    }, rejected);
}

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  This presently only works in
 * Firefox/Spidermonkey, however, this code does not cause syntax
 * errors in older engines.  This code should continue to work and
 * will in fact improve over time as the language improves.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 *  - in present implementations of generators, when a generator
 *    function is complete, it throws ``StopIteration``, ``return`` is
 *    a syntax error in the presence of ``yield``, so there is no
 *    observable return value. There is a proposal[1] to add support
 *    for ``return``, which would permit the value to be carried by a
 *    ``StopIteration`` instance, in which case it would fulfill the
 *    promise returned by the asynchronous generator.  This can be
 *    emulated today by throwing StopIteration explicitly with a value
 *    property.
 *
 *  [1]: http://wiki.ecmascript.org/doku.php?id=strawman:async_functions#reference_implementation
 *
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;
            try {
                result = generator[verb](arg);
            } catch (exception) {
                if (isStopIteration(exception)) {
                    return exception.value;
                } else {
                    return reject(exception);
                }
            }
            return when(result, callback, errback);
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "send");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 * Only useful presently in Firefox/SpiderMonkey since generators are
 * implemented.
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q['return'] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are resolved and passed as values (`this` is also resolved and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q.resolve(a), Q.resolve(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    var deferred = defer();
    nextTick(function () {
        resolve(object).promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
}

/**
 * Constructs a promise method that can be used to safely observe resolution of
 * a promise for an arbitrarily named method like "propfind" in a future turn.
 *
 * "dispatcher" constructs methods like "get(promise, name)" and "put(promise)".
 */
Q.dispatcher = dispatcher;
function dispatcher(op) {
    return function (object) {
        var args = array_slice(arguments, 1);
        return dispatch(object, op, args);
    };
}

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = dispatcher("get");

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = dispatcher("set");

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q["delete"] = // XXX experimental
Q.del = dispatcher("delete");

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
var post = Q.post = dispatcher("post");

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = send;
Q.invoke = send; // synonyms
function send(value, name) {
    var args = array_slice(arguments, 2);
    return post(value, name, args);
}

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = fapply;
function fapply(value, args) {
    return dispatch(value, "apply", [void 0, args]);
}

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] = fcall; // XXX experimental
Q.fcall = fcall;
function fcall(value) {
    var args = array_slice(arguments, 1);
    return fapply(value, args);
}

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = fbind;
function fbind(value) {
    var args = array_slice(arguments, 1);
    return function fbound() {
        var allArgs = args.concat(array_slice(arguments));
        return dispatch(value, "apply", [this, allArgs]);
    };
}

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually resolved object
 */
Q.keys = dispatcher("keys");

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var countDown = promises.length;
        if (countDown === 0) {
            return resolve(promises);
        }
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            if (isFulfilled(promise)) {
                promises[index] = valueOf(promise);
                if (--countDown === 0) {
                    deferred.resolve(promises);
                }
            } else {
                when(promise, function (value) {
                    promises[index] = value;
                    if (--countDown === 0) {
                        deferred.resolve(promises);
                    }
                })
                .fail(deferred.reject);
            }
        }, void 0);
        return deferred.promise;
    });
}

/**
 * Waits for all promises to be resolved, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = allResolved;
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, resolve);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q["catch"] = // XXX experimental
Q.fail = fail;
function fail(promise, rejected) {
    return when(promise, void 0, rejected);
}

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(promise, progressed) {
    return when(promise, void 0, void 0, progressed);
}

/**
 * Provides an opportunity to observe the rejection of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q["finally"] = // XXX experimental
Q.fin = fin;
function fin(promise, callback) {
    return when(promise, function (value) {
        return when(callback(), function () {
            return value;
        });
    }, function (exception) {
        return when(callback(), function () {
            return reject(exception);
        });
    });
}

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = done;
function done(promise, fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        nextTick(function () {
            makeStackTraceLong(error, promise);

            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promiseToHandle = fulfilled || rejected || progress ?
        when(promise, fulfilled, rejected, progress) :
        promise;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }
    fail(promiseToHandle, onUnhandledError);
}

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = timeout;
function timeout(promise, ms) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        deferred.reject(new Error("Timed out after " + ms + " ms"));
    }, ms);

    when(promise, function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    });

    return deferred.promise;
}

/**
 * Returns a promise for the given value (or promised value) after some
 * milliseconds.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after some
 * time has elapsed.
 */
Q.delay = delay;
function delay(promise, timeout) {
    if (timeout === void 0) {
        timeout = promise;
        promise = void 0;
    }
    var deferred = defer();
    setTimeout(function () {
        deferred.resolve(promise);
    }, timeout);
    return deferred.promise;
}

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = nfapply;
function nfapply(callback, args) {
    var nodeArgs = array_slice(args);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());

    fapply(callback, nodeArgs).fail(deferred.reject);
    return deferred.promise;
}

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 *
 *      Q.nfcall(FS.readFile, __filename)
 *      .then(function (content) {
 *      })
 *
 */
Q.nfcall = nfcall;
function nfcall(callback/*, ...args */) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());

    fapply(callback, nodeArgs).fail(deferred.reject);
    return deferred.promise;
}

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 *
 *      Q.nfbind(FS.readFile, __filename)("utf-8")
 *      .then(//console.log)
 *      .done()
 *
 */
Q.nfbind = nfbind;
Q.denodeify = Q.nfbind; // synonyms
function nfbind(callback/*, ...args */) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());

        fapply(callback, nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
}

Q.nbind = nbind;
function nbind(callback/*, ... args*/) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());

        var thisArg = this;
        function bound() {
            return callback.apply(thisArg, arguments);
        }

        fapply(bound, nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
}

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.npost = npost;
function npost(object, name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());

    post(object, name, nodeArgs).fail(deferred.reject);
    return deferred.promise;
}

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = nsend;
Q.ninvoke = Q.nsend; // synonyms
function nsend(object, name /*, ...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    post(object, name, nodeArgs).fail(deferred.reject);
    return deferred.promise;
}

Q.nodeify = nodeify;
function nodeify(promise, nodeback) {
    if (nodeback) {
        promise.then(function (value) {
            nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return promise;
    }
}

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});

/*
 Copyright 2011 Abdulla Abdurakhmanov
 Original sources are available at https://code.google.com/p/x2js/

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

function X2JS(matchers, attrPrefix, ignoreRoot) {
    if (attrPrefix === null || attrPrefix === undefined) {
        attrPrefix = "_";
    }

    if (ignoreRoot === null || ignoreRoot === undefined) {
        ignoreRoot = false;
    }

	var VERSION = "1.0.11";
	var escapeMode = false;

	var DOMNodeTypes = {
		ELEMENT_NODE 	   : 1,
		TEXT_NODE    	   : 3,
		CDATA_SECTION_NODE : 4,
		COMMENT_NODE       : 8,
		DOCUMENT_NODE 	   : 9
	};

	function getNodeLocalName( node ) {
		var nodeLocalName = node.localName;
		if(nodeLocalName == null) // Yeah, this is IE!!
			nodeLocalName = node.baseName;
		if(nodeLocalName == null || nodeLocalName=="") // =="" is IE too
			nodeLocalName = node.nodeName;
		return nodeLocalName;
	}

	function getNodePrefix(node) {
		return node.prefix;
	}

	function escapeXmlChars(str) {
		if(typeof(str) == "string")
			return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2F;');
		else
			return str;
	}

	function unescapeXmlChars(str) {
		return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&#x2F;/g, '\/')
	}

	function parseDOMChildren( node ) {
		if(node.nodeType == DOMNodeTypes.DOCUMENT_NODE) {
			var result,
			    child = node.firstChild,
			    i,
			    len;

			// get the first node that isn't a comment
			for(i = 0, len = node.childNodes.length; i < len; i += 1) {
			   if (node.childNodes[i].nodeType !== DOMNodeTypes.COMMENT_NODE) {
			       child = node.childNodes[i];
			       break;
			   }
			}

			if ( ignoreRoot ) {
			    result = parseDOMChildren(child);
			} else {
			    result = {};
			    var childName = getNodeLocalName(child);
                result[childName] = parseDOMChildren(child);
			}

			return result;
		}
		else
		if(node.nodeType == DOMNodeTypes.ELEMENT_NODE) {
			var result = new Object;
			result.__cnt=0;

			var nodeChildren = node.childNodes;

			// Children nodes
			for(var cidx=0; cidx <nodeChildren.length; cidx++) {
				var child = nodeChildren.item(cidx); // nodeChildren[cidx];
				var childName = getNodeLocalName(child);

				result.__cnt++;
				if(result[childName] == null) {
					result[childName] = parseDOMChildren(child);
					result[childName+"_asArray"] = new Array(1);
					result[childName+"_asArray"][0] = result[childName];
				}
				else {
					if(result[childName] != null) {
						if( !(result[childName] instanceof Array)) {
							var tmpObj = result[childName];
							result[childName] = new Array();
							result[childName][0] = tmpObj;

							result[childName+"_asArray"] = result[childName];
						}
					}
					var aridx = 0;
					while(result[childName][aridx]!=null) aridx++;
					(result[childName])[aridx] = parseDOMChildren(child);
				}
			}

			// Attributes
			for(var aidx=0; aidx <node.attributes.length; aidx++) {
				var attr = node.attributes.item(aidx); // [aidx];
				result.__cnt++;

				var value2 = attr.value;
				for(var m=0, ml=matchers.length; m < ml; m++) {
				    var matchobj = matchers[m];
				    if (matchobj.test.call(this, attr.value))
				        value2 = matchobj.converter.call(this, attr.value);
				}

				result[attrPrefix+attr.name]=value2;
			}

			// Node namespace prefix
			var nodePrefix = getNodePrefix(node);
			if(nodePrefix!=null && nodePrefix!="") {
				result.__cnt++;
				result.__prefix=nodePrefix;
			}

			if( result.__cnt == 1 && result["#text"]!=null  ) {
				result = result["#text"];
			}

			if(result["#text"]!=null) {
				result.__text = result["#text"];
				if(escapeMode)
					result.__text = unescapeXmlChars(result.__text)
				delete result["#text"];
				delete result["#text_asArray"];
			}
			if(result["#cdata-section"]!=null) {
				result.__cdata = result["#cdata-section"];
				delete result["#cdata-section"];
				delete result["#cdata-section_asArray"];
			}

			if(result.__text!=null || result.__cdata!=null) {
				result.toString = function() {
					return (this.__text!=null? this.__text:'')+( this.__cdata!=null ? this.__cdata:'');
				}
			}
			return result;
		}
		else
		if(node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE) {
			return node.nodeValue;
		}
		else
		if(node.nodeType == DOMNodeTypes.COMMENT_NODE) {
		    return null;
		}
	}

	function startTag(jsonObj, element, attrList, closed) {
		var resultStr = "<"+ ( (jsonObj!=null && jsonObj.__prefix!=null)? (jsonObj.__prefix+":"):"") + element;
		if(attrList!=null) {
			for(var aidx = 0; aidx < attrList.length; aidx++) {
				var attrName = attrList[aidx];
				var attrVal = jsonObj[attrName];
				resultStr+=" "+attrName.substr(1)+"='"+attrVal+"'";
			}
		}
		if(!closed)
			resultStr+=">";
		else
			resultStr+="/>";
		return resultStr;
	}

	function endTag(jsonObj,elementName) {
		return "</"+ (jsonObj.__prefix!=null? (jsonObj.__prefix+":"):"")+elementName+">";
	}

	function endsWith(str, suffix) {
	    return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}

	function jsonXmlSpecialElem ( jsonObj, jsonObjField ) {
		if(endsWith(jsonObjField.toString(),("_asArray"))
				|| jsonObjField.toString().indexOf("_")==0
				|| (jsonObj[jsonObjField] instanceof Function) )
			return true;
		else
			return false;
	}

	function jsonXmlElemCount ( jsonObj ) {
		var elementsCnt = 0;
		if(jsonObj instanceof Object ) {
			for( var it in jsonObj  ) {
				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;
				elementsCnt++;
			}
		}
		return elementsCnt;
	}

	function parseJSONAttributes ( jsonObj ) {
		var attrList = [];
		if(jsonObj instanceof Object ) {
			for( var ait in jsonObj  ) {
				if(ait.toString().indexOf("__")== -1 && ait.toString().indexOf("_")==0) {
					attrList.push(ait);
				}
			}
		}
		return attrList;
	}

	function parseJSONTextAttrs ( jsonTxtObj ) {
		var result ="";

		if(jsonTxtObj.__cdata!=null) {
			result+="<![CDATA["+jsonTxtObj.__cdata+"]]>";
		}

		if(jsonTxtObj.__text!=null) {
			if(escapeMode)
				result+=escapeXmlChars(jsonTxtObj.__text);
			else
				result+=jsonTxtObj.__text;
		}
		return result
	}

	function parseJSONTextObject ( jsonTxtObj ) {
		var result ="";

		if( jsonTxtObj instanceof Object ) {
			result+=parseJSONTextAttrs ( jsonTxtObj )
		}
		else
			if(jsonTxtObj!=null) {
				if(escapeMode)
					result+=escapeXmlChars(jsonTxtObj);
				else
					result+=jsonTxtObj;
			}

		return result;
	}

	function parseJSONArray ( jsonArrRoot, jsonArrObj, attrList ) {
		var result = "";
		if(jsonArrRoot.length == 0) {
			result+=startTag(jsonArrRoot, jsonArrObj, attrList, true);
		}
		else {
			for(var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
				result+=startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
				result+=parseJSONObject(jsonArrRoot[arIdx]);
				result+=endTag(jsonArrRoot[arIdx],jsonArrObj);
			}
		}
		return result;
	}

	function parseJSONObject ( jsonObj ) {
		var result = "";

		var elementsCnt = jsonXmlElemCount ( jsonObj );

		if(elementsCnt > 0) {
			for( var it in jsonObj ) {

				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;

				var subObj = jsonObj[it];

				var attrList = parseJSONAttributes( subObj )

				if(subObj == null || subObj == undefined) {
					result+=startTag(subObj, it, attrList, true)
				}
				else
				if(subObj instanceof Object) {

					if(subObj instanceof Array) {
						result+=parseJSONArray( subObj, it, attrList )
					}
					else {
						var subObjElementsCnt = jsonXmlElemCount ( subObj );
						if(subObjElementsCnt > 0 || subObj.__text!=null || subObj.__cdata!=null) {
							result+=startTag(subObj, it, attrList, false);
							result+=parseJSONObject(subObj);
							result+=endTag(subObj,it);
						}
						else {
							result+=startTag(subObj, it, attrList, true);
						}
					}
				}
				else {
					result+=startTag(subObj, it, attrList, false);
					result+=parseJSONTextObject(subObj);
					result+=endTag(subObj,it);
				}
			}
		}
		result+=parseJSONTextObject(jsonObj);

		return result;
	}

	this.parseXmlString = function(xmlDocStr) {
		var xmlDoc;
		if (window.DOMParser) {
			// ORANGE: XML parsing management
			try
			{
				var parser=new window.DOMParser();
				xmlDoc = parser.parseFromString( xmlDocStr, "text/xml" );
				if(xmlDoc.getElementsByTagName('parsererror').length > 0) {
					  throw new Error('Error parsing XML');
				}
				//var parsererrorNS = parser.parseFromString('INVALID', 'text/xml').childNodes[0].namespaceURI;
			    //if(xmlDoc.getElementsByTagNameNS(parsererrorNS, 'parsererror').length > 0) {
			    //    throw new Error('Error parsing XML');
			    //}
			}
			catch (e)
			{
				return null;
			}
		}
		return xmlDoc;
	}

	this.xml2json = function (xmlDoc) {
		return parseDOMChildren ( xmlDoc );
	}

	this.xml_str2json = function (xmlDocStr) {
		var xmlDoc = this.parseXmlString(xmlDocStr);
		return xmlDoc === null ? xmlDoc : this.xml2json(xmlDoc);
	}

	this.json2xml_str = function (jsonObj) {
		return parseJSONObject ( jsonObj );
	}

	this.json2xml = function (jsonObj) {
		var xmlDocStr = this.json2xml_str (jsonObj);
		return this.parseXmlString(xmlDocStr);
	}

	this.getVersion = function () {
		return VERSION;
	}

	this.escapeMode = function(enabled) {
		escapeMode = enabled;
	}
}
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var mp4lib = (function() {
    var mp4lib = {
        boxes:{},
        fields:{},

        // In debug mode, source data buffer is kept for each of deserialized box so any
        // structural deserialization problems can be traced by serializing each box
        // and comparing the resulting buffer with the source buffer.
        // This greatly increases memory consumption, so it is turned off by default.
        debug:false,

        // A handler function may be hooked up to display warnings.
        // A warning is typically non-critical issue, like unknown box in data buffer.
        warningHandler:function(message){
            ////console.log(message);
        }
    };

    var boxTypeArray = {};

    mp4lib.registerTypeBoxes = function() {
        boxTypeArray["moov"] = mp4lib.boxes.MovieBox;
        boxTypeArray["moof"] = mp4lib.boxes.MovieFragmentBox;
        boxTypeArray["ftyp"] = mp4lib.boxes.FileTypeBox;
        boxTypeArray["mfhd"] = mp4lib.boxes.MovieFragmentHeaderBox;
        boxTypeArray["mfra"] = mp4lib.boxes.MovieFragmentRandomAccessBox;
        boxTypeArray["udta"] = mp4lib.boxes.UserDataBox;
        boxTypeArray["trak"] = mp4lib.boxes.TrackBox;
        boxTypeArray["edts"] = mp4lib.boxes.EditBox;
        boxTypeArray["mdia"] = mp4lib.boxes.MediaBox;
        boxTypeArray["minf"] = mp4lib.boxes.MediaInformationBox;
        boxTypeArray["dinf"] = mp4lib.boxes.DataInformationBox;
        boxTypeArray["stbl"] = mp4lib.boxes.SampleTableBox;
        boxTypeArray["mvex"] = mp4lib.boxes.MovieExtendsBox;
        boxTypeArray["traf"] = mp4lib.boxes.TrackFragmentBox;
        boxTypeArray["meta"] = mp4lib.boxes.MetaBox;
        boxTypeArray["mvhd"] = mp4lib.boxes.MovieHeaderBox;
        boxTypeArray["mdat"] = mp4lib.boxes.MediaDataBox;
        boxTypeArray["free"] = mp4lib.boxes.FreeSpaceBox;
        boxTypeArray["sidx"] = mp4lib.boxes.SegmentIndexBox;
        boxTypeArray["tkhd"] = mp4lib.boxes.TrackHeaderBox;
        boxTypeArray["mdhd"] = mp4lib.boxes.MediaHeaderBox;
        boxTypeArray["mehd"] = mp4lib.boxes.MovieExtendsHeaderBox;
        boxTypeArray["hdlr"] = mp4lib.boxes.HandlerBox;
        boxTypeArray["stts"] = mp4lib.boxes.TimeToSampleBox;
        boxTypeArray["stsc"] = mp4lib.boxes.SampleToChunkBox;
        boxTypeArray["stco"] = mp4lib.boxes.ChunkOffsetBox;
        boxTypeArray["trex"] = mp4lib.boxes.TrackExtendsBox;
        boxTypeArray["vmhd"] = mp4lib.boxes.VideoMediaHeaderBox;
        boxTypeArray["smhd"] = mp4lib.boxes.SoundMediaHeaderBox;
        boxTypeArray["dref"] = mp4lib.boxes.DataReferenceBox;
        boxTypeArray["url "] = mp4lib.boxes.DataEntryUrlBox;
        boxTypeArray["urn "] = mp4lib.boxes.DataEntryUrnBox;
        boxTypeArray["tfhd"] = mp4lib.boxes.TrackFragmentHeaderBox;
        boxTypeArray["tfdt"] = mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox;
        boxTypeArray["trun"] = mp4lib.boxes.TrackFragmentRunBox;
        boxTypeArray["stsd"] = mp4lib.boxes.SampleDescriptionBox;
        boxTypeArray["sdtp"] = mp4lib.boxes.SampleDependencyTableBox;
        boxTypeArray["avc1"] = mp4lib.boxes.AVC1VisualSampleEntryBox;
        boxTypeArray["encv"] = mp4lib.boxes.EncryptedVideoBox;
        boxTypeArray["avcC"] = mp4lib.boxes.AVCConfigurationBox;
        boxTypeArray["pasp"] = mp4lib.boxes.PixelAspectRatioBox;
        boxTypeArray["mp4a"] = mp4lib.boxes.MP4AudioSampleEntryBox;
        boxTypeArray["enca"] = mp4lib.boxes.EncryptedAudioBox;
        boxTypeArray["esds"] = mp4lib.boxes.ESDBox;
        boxTypeArray["stsz"] = mp4lib.boxes.SampleSizeBox;
        boxTypeArray["pssh"] = mp4lib.boxes.ProtectionSystemSpecificHeaderBox;
        boxTypeArray["saiz"] = mp4lib.boxes.SampleAuxiliaryInformationSizesBox;
        boxTypeArray["saio"] = mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox;
        boxTypeArray["sinf"] = mp4lib.boxes.ProtectionSchemeInformationBox;
        boxTypeArray["schi"] = mp4lib.boxes.SchemeInformationBox;
        boxTypeArray["tenc"] = mp4lib.boxes.TrackEncryptionBox;
        boxTypeArray["schm"] = mp4lib.boxes.SchemeTypeBox;
        boxTypeArray["elst"] = mp4lib.boxes.EditListBox;
        boxTypeArray["hmhd"] = mp4lib.boxes.HintMediaHeaderBox;
        boxTypeArray["nmhd"] = mp4lib.boxes.NullMediaHeaderBox;
        boxTypeArray["ctts"] = mp4lib.boxes.CompositionOffsetBox;
        boxTypeArray["cslg"] = mp4lib.boxes.CompositionToDecodeBox;
        boxTypeArray["stss"] = mp4lib.boxes.SyncSampleBox;
        boxTypeArray["tref"] = mp4lib.boxes.TrackReferenceBox;
        boxTypeArray["frma"] = mp4lib.boxes.OriginalFormatBox;
        //extended types
        boxTypeArray[JSON.stringify([0x6D, 0x1D, 0x9B, 0x05, 0x42, 0xD5, 0x44, 0xE6, 0x80, 0xE2, 0x14, 0x1D, 0xAF, 0xF7, 0x57, 0xB2])] = mp4lib.boxes.TfxdBox;
        boxTypeArray[JSON.stringify([0xD4, 0x80, 0x7E, 0xF2, 0xCA, 0x39, 0x46, 0x95, 0x8E, 0x54, 0x26, 0xCB, 0x9E, 0x46, 0xA7, 0x9F])] = mp4lib.boxes.TfrfBox;
        boxTypeArray[JSON.stringify([0xD0, 0x8A, 0x4F, 0x18, 0x10, 0xF3, 0x4A, 0x82, 0xB6, 0xC8, 0x32, 0xD8, 0xAB, 0xA1, 0x83, 0xD3])] = mp4lib.boxes.PiffProtectionSystemSpecificHeaderBox;
        boxTypeArray[JSON.stringify([0x89, 0x74, 0xDB, 0xCE, 0x7B, 0xE7, 0x4C, 0x51, 0x84, 0xF9, 0x71, 0x48, 0xF9, 0x88, 0x25, 0x54])] = mp4lib.boxes.PiffTrackEncryptionBox;
        boxTypeArray[JSON.stringify([0xA2, 0x39, 0x4F, 0x52, 0x5A, 0x9B, 0x4F, 0x14, 0xA2, 0x44, 0x6C, 0x42, 0x7C, 0x64, 0x8D, 0xF4])] = mp4lib.boxes.PiffSampleEncryptionBox;
    };


    mp4lib.constructorTypeBox = function (type) {
        var obj, args;
        obj = Object.create(type.prototype);
        args = Array.prototype.slice.call(arguments, 1);
        type.apply(obj, args);
        return obj;
    };

    mp4lib.searchBox = function ( boxtype, uuid ){
        var boxType;

        if (uuid) {
            boxType = boxTypeArray[uuid];
        }
        else {
            boxType = boxTypeArray[boxtype];
        }

        if (!boxType){
            boxType = mp4lib.boxes.UnknownBox;
        }

        return boxType;
    };

    mp4lib.createBox = function( boxtype,size, uuid) {
        return mp4lib.constructorTypeBox.apply(null, [mp4lib.searchBox(boxtype, uuid),size]);
    };

    /**
    deserialize binary data (uint8array) into mp4lib.File object
    */
    mp4lib.deserialize = function(uint8array) {
        var f = new mp4lib.boxes.File();
        try{
            f.read(uint8array);
        }catch(e){
            mp4lib.warningHandler(e.message);
            return null;
        }
        return f;
    };

    /**
    serialize box (or mp4lib.File) into binary data (uint8array)
    */
    mp4lib.serialize = function(f) {
        var file_size = f.getLength(),
            uint8array = new Uint8Array(file_size);
        f.write(uint8array);
        return uint8array;
    };

    /**
    exception thrown when binary data is malformed
    it is thrown typically during deserialization
    */
    mp4lib.ParseException = function(message) {
        this.message = message;
        this.name = "ParseException";
    };

    /**
    exception thrown when box objects contains invalid data,
    ex. flag field is are not coherent with fields etc.
    it is thrown typically during object manipulation or serialization
    */
    mp4lib.DataIntegrityException = function(message) {
        this.message = message;
        this.name = "DataIntegrityException";
    };

    return mp4lib;
})();

// This module is intended to work both on node.js and inside browser.
// Since these environments differ in a way modules are stored/accessed,
// we need to export the module in the environment-dependant way

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
    module.exports = mp4lib; // node.js
else
    window.mp4lib = mp4lib;  // browser


/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

mp4lib.fields.readBytes = function(buf, pos, nbBytes) {
    var value = 0,
        i = 0;
    for (i = 0; i < nbBytes; i++) {
        value = value << 8;
        value = value + buf[pos];
        pos++;
    }
    return value;
};

mp4lib.fields.writeBytes = function(buf, pos, nbBytes, value) {
    var i = 0;
    for (i = 0; i < nbBytes; i++) {
        buf[pos + nbBytes - i - 1] = value & 0xFF;
        value = value >> 8;
    }
};

mp4lib.fields.readString = function(buf, pos, count) {
    var res = "",
        i;
    for (i = pos; i < pos + count; i++) {
        res += String.fromCharCode(buf[i]);
    }
    return res;
};

//------------------------------- NumberField -------------------------------

mp4lib.fields.NumberField = function(bits, signed) {
    this.bits = bits;
    this.signed = signed;
};

mp4lib.fields.NumberField.prototype.read = function(buf, pos) {
    return mp4lib.fields.readBytes(buf, pos, this.bits / 8);
};

mp4lib.fields.NumberField.prototype.write = function(buf, pos, val) {
    mp4lib.fields.writeBytes(buf, pos, this.bits / 8, val);
};

mp4lib.fields.NumberField.prototype.getLength = function() {
    return this.bits / 8;
};

//------------------------------- 64BitsNumberField -------------------------------

mp4lib.fields.LongNumberField = function() {};

mp4lib.fields.LongNumberField.prototype.read = function(buf, pos) {
    var high = mp4lib.fields.readBytes(buf, pos, 4),
        low = mp4lib.fields.readBytes(buf, pos + 4, 4);
    return goog.math.Long.fromBits(low, high).toNumber();
};

mp4lib.fields.LongNumberField.prototype.write = function(buf, pos, val) {
    var longNumber = goog.math.Long.fromNumber(val),
        low = longNumber.getLowBits(),
        high = longNumber.getHighBits();
    mp4lib.fields.writeBytes(buf, pos, 4, high);
    mp4lib.fields.writeBytes(buf, pos + 4, 4, low);
};

mp4lib.fields.LongNumberField.prototype.getLength = function() {
    return 8;
};

//------------------------------- FixedLenStringField -------------------------------

mp4lib.fields.FixedLenStringField = function(size) {
    this.size = size;
};

mp4lib.fields.FixedLenStringField.prototype.read = function(buf, pos) {
    var res = "",
        i = 0;
    for (i = 0; i < this.size; i++) {
        res = res + String.fromCharCode(buf[pos + i]);
    }
    return res;
};

mp4lib.fields.FixedLenStringField.prototype.write = function(buf, pos, val) {
    var i = 0;
    for (i = 0; i < this.size; i++) {
        buf[pos + i] = val.charCodeAt(i);
    }
};

mp4lib.fields.FixedLenStringField.prototype.getLength = function() {
    return this.size;
};

//------------------------------- BoxTypeField -------------------------------

mp4lib.fields.BoxTypeField = function() {};

mp4lib.fields.BoxTypeField.prototype.read = function(buf, pos) {
    var res = "",
        i = 0;
    for (i = 0; i < 4; i++) {
        res = res + String.fromCharCode(buf[pos + i]);
    }
    return res;
};

mp4lib.fields.BoxTypeField.prototype.write = function(buf, pos, val) {
    var i = 0;
    for (i = 0; i < 4; i++) {
        buf[pos + i] = val.charCodeAt(i);
    }
};

mp4lib.fields.BoxTypeField.prototype.getLength = function() {
    return 4;
};


//------------------------------- StringField -------------------------------

mp4lib.fields.StringField = function() {};


mp4lib.fields.StringField.prototype.read = function(buf, pos, end) {
    var res = "",
        i = 0;

    for (i = pos; i < end; i++) {
        res = res + String.fromCharCode(buf[i]);
        if (buf[i] === 0) {
            return res;
        }
    }

    if ((end - pos < 255) && (buf[0] == String.fromCharCode(end - pos))) {
        res = res.substr(1, end - pos);
        mp4lib.warningHandler('null-terminated string expected, ' +
            'but found a string "' + res + '", which seems to be ' +
            'length-prefixed instead. Conversion done.');
        return res;
    }

    throw new mp4lib.ParseException('expected null-terminated string, ' +
        'but end of field reached without termination. ' +
        'Read so far:"' + res + '"');
};

mp4lib.fields.StringField.prototype.write = function(buf, pos, val) {
    var i = 0;

    for (i = 0; i < val.length; i++) {
        buf[pos + i] = val.charCodeAt(i);
    }
    buf[pos + val.length] = 0;
};

mp4lib.fields.StringField.prototype.getLength = function(val) {
    return val.length;
};

//------------------------------- ArrayField -------------------------------

mp4lib.fields.ArrayField = function(innerField, size) {
    this.innerField = innerField;
    this.size = size;
};

mp4lib.fields.ArrayField.prototype.read = function(buf, pos) {
    var innerFieldLength = -1,
        res = [],
        i = 0;
    for (i = 0; i < this.size; i++) {

        res.push(this.innerField.read(buf, pos));

        if (innerFieldLength == -1) {
            innerFieldLength = this.innerField.getLength(res[i]);
        }
        // it may happen that the size of field depends on the box flags,
        // we need to count is having box and first structure constructed

        pos += innerFieldLength;
    }
    return res;
};

// pre-defined shortcuts for common fields
// ( it is recommended to use these shortcuts to avoid constructors
//   being called for every field processing action )
mp4lib.fields.FIELD_INT8 = new mp4lib.fields.NumberField(8, true);
mp4lib.fields.FIELD_INT16 = new mp4lib.fields.NumberField(16, true);
mp4lib.fields.FIELD_INT32 = new mp4lib.fields.NumberField(32, true);
mp4lib.fields.FIELD_INT64 = new mp4lib.fields.LongNumberField();
mp4lib.fields.FIELD_UINT8 = new mp4lib.fields.NumberField(8, false);
mp4lib.fields.FIELD_UINT16 = new mp4lib.fields.NumberField(16, false);
mp4lib.fields.FIELD_UINT32 = new mp4lib.fields.NumberField(32, false);
mp4lib.fields.FIELD_UINT64 = new mp4lib.fields.LongNumberField();
mp4lib.fields.FIELD_BIT8 = new mp4lib.fields.NumberField(8, false);
mp4lib.fields.FIELD_BIT16 = new mp4lib.fields.NumberField(16, false);
mp4lib.fields.FIELD_BIT24 = new mp4lib.fields.NumberField(24, false);
mp4lib.fields.FIELD_BIT32 = new mp4lib.fields.NumberField(32, false);
mp4lib.fields.FIELD_ID = new mp4lib.fields.BoxTypeField(4);
mp4lib.fields.FIELD_STRING = new mp4lib.fields.StringField();
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

// ---------- File (treated similarly to box in terms of processing) ----------
mp4lib.boxes.File = function() {
    this.boxes = [];
};

mp4lib.boxes.File.prototype.getBoxByType = function(boxType) {
    var i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].boxtype === boxType) {
            return this.boxes[i];
        }
    }
    return null;
};

mp4lib.boxes.File.prototype.getLength = function() {
    var length = 0,
        i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        this.boxes[i].computeLength();
        length += this.boxes[i].size;
    }

    return length;
};

mp4lib.boxes.File.prototype.write = function(data) {
    var pos = 0,
        i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        pos = this.boxes[i].write(data, pos);
    }
};

mp4lib.boxes.File.prototype.read = function(data) {
    var size = 0,
        boxtype = null,
        uuidFieldPos = 0,
        uuid = null,
        pos = 0,
        end = data.length,
        box;

    while (pos < end) {
        // Read box size
        size = mp4lib.fields.FIELD_UINT32.read(data, pos);

        // Read boxtype
        boxtype = mp4lib.fields.readString(data, pos + 4, 4);

        // Extented type?
        if (boxtype == "uuid") {
            uuidFieldPos = (size == 1) ? 16 : 8;
            uuid = new mp4lib.fields.ArrayField(mp4lib.fields.FIELD_INT8, 16).read(data, pos + uuidFieldPos, pos + uuidFieldPos + 16);
            uuid = JSON.stringify(uuid);
        }

        box = mp4lib.createBox(boxtype, size, uuid);
        if (boxtype === "uuid") {
            pos = box.read(data, pos + mp4lib.fields.FIELD_INT8.getLength() * 16 + 8, pos + size);
            uuid = null;
        } else {
            pos = box.read(data, pos + 8, pos + size);
        }

        // in debug mode, sourcebuffer is copied to each box,
        // so any invalid deserializations may be found by comparing
        // source buffer with serialized box
        if (mp4lib.debug) {
            box.__sourceBuffer = data.subarray(pos - box.size, pos);
        }

        //if boxtype is unknown, don't add it to the list box
        if (box.boxtype) {
            this.boxes.push(box);
        }

        if (box.size <= 0 || box.size === null) {
            throw new mp4lib.ParseException('Problem on size of box ' + box.boxtype +
                ', parsing stopped to avoid infinite loop');
        }
    }
};

/**
find child position
*/
mp4lib.boxes.File.prototype.getBoxOffsetByType = function(boxType) {
    var offset = 0,
        i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].boxtype === boxType) {
            return offset;
        }
        offset += this.boxes[i].size;
    }
    return -1;
};

mp4lib.boxes.File.prototype.getBoxIndexByType = function(boxType) {
    var index = 0,
        i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].boxtype === boxType) {
            return index;
        }
        index++;
    }
    return -1;
};


// ---------- Generic Box -------------------------------
mp4lib.boxes.Box = function(boxType, size, uuid, largesize) {
    this.size = size || null;
    this.boxtype = boxType;
    //large size management to do...
    if (this.size === 1 && largesize) {
        this.largesize = largesize;
    }

    if (uuid) {
        this.extended_type = uuid;
    }

    this.localPos = 0;
    this.localEnd = 0;
};

mp4lib.boxes.Box.prototype.write = function(data, pos) {
    this.localPos = pos;
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.size);
    //if extended_type is not defined, boxtype must have this.boxtype value
    if (!this.extended_type) {
        this._writeData(data, mp4lib.fields.FIELD_ID, this.boxtype);
    } else { //if extended_type is defined, boxtype must have 'uuid' value
        this._writeData(data, mp4lib.fields.FIELD_ID, 'uuid');
    }

    if (this.size === 1) {
        this._writeData(data, mp4lib.fields.FIELD_INT64, this.largesize);
    }

    if (this.extended_type) {
        for (i = 0; i < 16; i++) {
            this._writeData(data, mp4lib.fields.FIELD_INT8, this.extended_type[i]);
        }
    }
};

mp4lib.boxes.Box.prototype.getBoxByType = function(boxType) {
    var i = 0;
    if (this.hasOwnProperty('boxes')) {
        for (i = 0; i < this.boxes.length; i++) {
            if (this.boxes[i].boxtype === boxType) {
                return this.boxes[i];
            }
        }
    }
    return null;
};


mp4lib.boxes.Box.prototype.getBoxesByType = function(boxType) {
    var resu = [],
        i = 0;
    if (this.hasOwnProperty('boxes')) {
        for (i = 0; i < this.boxes.length; i++) {
            if (this.boxes[i].boxtype === boxType) {
                resu.push(this.boxes[i]);
            }
        }
    }
    return resu;
};

/**
remove child from a box
*/
mp4lib.boxes.Box.prototype.removeBoxByType = function(boxType) {
    var i = 0;

    if (this.hasOwnProperty('boxes')) {
        for (i = 0; i < this.boxes.length; i++) {
            if (this.boxes[i].boxtype === boxType) {
                this.boxes.splice(i, 1);
            }
        }
    } else {
        mp4lib.warningHandler('' + this.boxtype + 'does not have ' + boxType + ' box, impossible to remove it');
    }
};

/**
find child position
*/
mp4lib.boxes.Box.prototype.getBoxOffsetByType = function(boxType) {
    var offset = 8,
        i = 0;

    if (this.hasOwnProperty('boxes')) {
        for (i = 0; i < this.boxes.length; i++) {
            if (this.boxes[i].boxtype === boxType) {
                return offset;
            }
            offset += this.boxes[i].size;
        }
    }
    return null;
};

mp4lib.boxes.Box.prototype.getBoxIndexByType = function(boxType) {
    var index = 0,
        i = 0;

    if (this.hasOwnProperty('boxes')) {
        for (i = 0; i < this.boxes.length; i++) {
            if (this.boxes[i].boxtype === boxType) {
                return index;
            }
            index++;
        }
    }
    return null;
};

mp4lib.boxes.Box.prototype.computeLength = function() {
    this.size = mp4lib.fields.FIELD_UINT32.getLength() + mp4lib.fields.FIELD_ID.getLength(); //size and boxtype length

    /*if (this.size === 1) {
        this.size += mp4lib.fields.FIELD_INT64.getLength(); //add large_size length
    }*/
    if (this.extended_type) {
        this.size += mp4lib.fields.FIELD_INT8.getLength() * 16; //add extended_type length.
    }
};

mp4lib.boxes.Box.prototype._readData = function(data, dataType) {
    var resu = dataType.read(data, this.localPos, this.localEnd);
    this.localPos += dataType.getLength(resu);
    return resu;
};

mp4lib.boxes.Box.prototype._writeData = function(data, dataType, dataField) {
    if (dataField === undefined || dataField === null) {
        throw new mp4lib.ParseException('a field to write is null or undefined for box : ' + this.boxtype);
    } else {
        dataType.write(data, this.localPos, dataField);
        this.localPos += dataType.getLength(dataField);
    }
};

mp4lib.boxes.Box.prototype._writeBuffer = function(data, dataField, size) {
    data.set(dataField, this.localPos);
    this.localPos += size;
};

mp4lib.boxes.Box.prototype._writeArrayData = function(data, dataArrayType, array) {
    var i = 0;

    if (array === undefined || array === null || array.length === 0) {
        throw new mp4lib.ParseException('an array to write is null, undefined or length = 0 for box : ' + this.boxtype);
    }

    for (i = 0; i < array.length; i++) {
        this._writeData(data, dataArrayType, array[i]);
    }
};

mp4lib.boxes.Box.prototype._readArrayData = function(data, dataArrayType) {
    var array = [],
        dataArrayTypeLength = dataArrayType.getLength(),
        size = (this.localEnd - this.localPos) / dataArrayTypeLength,
        i = 0;

    for (i = 0; i < size; i++) {
        array.push(dataArrayType.read(data, this.localPos));
        this.localPos += dataArrayTypeLength;
    }
    return array;
};

mp4lib.boxes.Box.prototype._readArrayFieldData = function(data, dataArrayType, arraySize) {
    var innerFieldLength = -1,
        array = [],
        i = 0;

    for (i = 0; i < arraySize; i++) {

        array.push(dataArrayType.read(data, this.localPos));

        if (innerFieldLength === -1) {
            innerFieldLength = dataArrayType.getLength(array[i]);
        }
        // it may happen that the size of field depends on the box flags,
        // we need to count is having box and first structure constructed

        this.localPos += innerFieldLength;
    }
    return array;
};

// ---------- Abstract Container Box -------------------------------
mp4lib.boxes.ContainerBox = function(boxType, size) {
    mp4lib.boxes.Box.call(this, boxType, size);
    this.boxes = [];
};

mp4lib.boxes.ContainerBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.ContainerBox.prototype.constructor = mp4lib.boxes.ContainerBox;

mp4lib.boxes.ContainerBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    var i = 0;
    for (i = 0; i < this.boxes.length; i++) {
        this.boxes[i].computeLength();
        this.size += this.boxes[i].size;
    }
};

mp4lib.boxes.ContainerBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);
    var i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        this.localPos = this.boxes[i].write(data, this.localPos);
    }

    return this.localPos;
};

mp4lib.boxes.ContainerBox.prototype.read = function(data, pos, end) {
    var size = 0,
        uuidFieldPos = 0,
        uuid = null,
        boxtype,
        box;

    while (pos < end) {
        // Read box size
        size = mp4lib.fields.FIELD_UINT32.read(data, pos);

        // Read boxtype
        boxtype = mp4lib.fields.readString(data, pos + 4, 4);

        // Extented type?
        if (boxtype === "uuid") {
            uuidFieldPos = (size == 1) ? 16 : 8;
            uuid = new mp4lib.fields.ArrayField(mp4lib.fields.FIELD_INT8, 16).read(data, pos + uuidFieldPos, pos + uuidFieldPos + 16);
            uuid = JSON.stringify(uuid);
        }

        box = mp4lib.createBox(boxtype, size, uuid);
        if (boxtype === "uuid") {
            pos = box.read(data, pos + mp4lib.fields.FIELD_INT8.getLength() * 16 + 8, pos + size);
            uuid = null;
        } else {
            pos = box.read(data, pos + 8, pos + size);
        }

        // in debug mode, sourcebuffer is copied to each box,
        // so any invalid deserializations may be found by comparing
        // source buffer with serialized box
        if (mp4lib.debug) {
            box.__sourceBuffer = data.subarray(pos - box.size, pos);
        }

        //if boxtype is unknown, don't add it to the list box
        if (box.boxtype) {
            this.boxes.push(box);
        }

        if (box.size <= 0 || box.size === null) {
            throw new mp4lib.ParseException('Problem on size of box ' + box.boxtype +
                ', parsing stopped to avoid infinite loop');
        }
    }

    return pos;
};

// ---------- Full Box -------------------------------
mp4lib.boxes.FullBox = function(boxType, size, uuid) {
    mp4lib.boxes.Box.call(this, boxType, size, uuid);
    this.version = null;
    this.flags = null;
};

mp4lib.boxes.FullBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.FullBox.prototype.constructor = mp4lib.boxes.FullBox;

mp4lib.boxes.FullBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;
    this.version = this._readData(data, mp4lib.fields.FIELD_INT8);
    this.flags = this._readData(data, mp4lib.fields.FIELD_BIT24);
};

mp4lib.boxes.FullBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT8, this.version);
    this._writeData(data, mp4lib.fields.FIELD_BIT24, this.flags);
};

mp4lib.boxes.FullBox.prototype.getFullBoxAttributesLength = function() {
    this.size += mp4lib.fields.FIELD_INT8.getLength() + mp4lib.fields.FIELD_BIT24.getLength(); //version and flags size
};

mp4lib.boxes.FullBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    mp4lib.boxes.FullBox.prototype.getFullBoxAttributesLength.call(this);
};

// ---------- Abstract Container FullBox -------------------------------
mp4lib.boxes.ContainerFullBox = function(boxType, size) {
    mp4lib.boxes.FullBox.call(this, boxType, size);
    this.boxes = [];
};

mp4lib.boxes.ContainerFullBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.ContainerFullBox.prototype.constructor = mp4lib.boxes.ContainerFullBox;

mp4lib.boxes.ContainerFullBox.prototype.computeLength = function(isEntryCount) {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    var i = 0;

    if (isEntryCount) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }

    for (i = 0; i < this.boxes.length; i++) {
        this.boxes[i].computeLength();
        this.size += this.boxes[i].size;
    }
};

mp4lib.boxes.ContainerFullBox.prototype.read = function(data, pos, end, isEntryCount) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var size = 0,
        uuidFieldPos = 0,
        uuid = null,
        boxtype, box;

    if (isEntryCount) {
        this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    while (this.localPos < this.localEnd) {
        // Read box size
        size = mp4lib.fields.FIELD_UINT32.read(data, this.localPos);

        // Read boxtype
        boxtype = mp4lib.fields.readString(data, this.localPos + 4, 4);

        // Extented type?
        if (boxtype == "uuid") {
            uuidFieldPos = (size == 1) ? 16 : 8;
            uuid = new mp4lib.fields.ArrayField(mp4lib.fields.FIELD_INT8, 16).read(data, this.localPos + uuidFieldPos, this.localPos + uuidFieldPos + 16);
            uuid = JSON.stringify(uuid);
        }

        box = mp4lib.createBox(boxtype, size, uuid);
        if (boxtype === "uuid") {
            this.localPos = box.read(data, this.localPos + mp4lib.fields.FIELD_INT8.getLength() * 16 + 8, this.localPos + size);
            uuid = null;
        } else {
            this.localPos = box.read(data, this.localPos + 8, this.localPos + size);
        }

        // in debug mode, sourcebuffer is copied to each box,
        // so any invalid deserializations may be found by comparing
        // source buffer with serialized box
        if (mp4lib.debug) {
            box.__sourceBuffer = data.subarray(this.localPos - box.size, this.localPos);
        }

        if (box.boxtype) {
            this.boxes.push(box);
        }

        if (box.size <= 0 || box.size === null) {
            throw new mp4lib.ParseException('Problem on size of box ' + box.boxtype +
                ', parsing stopped to avoid infinite loop');
        }
    }

    return this.localPos;
};

mp4lib.boxes.ContainerFullBox.prototype.write = function(data, pos, isEntryCount) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    if (isEntryCount === true) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    }

    for (i = 0; i < this.boxes.length; i++) {
        this.localPos = this.boxes[i].write(data, this.localPos);
    }

    return this.localPos;
};

// ----------- Unknown Box -----------------------------

mp4lib.boxes.UnknownBox = function(size) {
    mp4lib.boxes.Box.call(this, null, size);
};

mp4lib.boxes.UnknownBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.UnknownBox.prototype.constructor = mp4lib.boxes.UnknownBox;

mp4lib.boxes.UnknownBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;

    this.unrecognized_data = data.subarray(this.localPos, this.localEnd);

    return this.localEnd;
};

mp4lib.boxes.UnknownBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeBuffer(data, this.unrecognized_data, this.unrecognized_data.length);

    return this.localPos;
};

mp4lib.boxes.UnknownBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += this.unrecognized_data.length;
};

// --------------------------- ftyp ----------------------------------

mp4lib.boxes.FileTypeBox = function(size) {
    mp4lib.boxes.Box.call(this, 'ftyp', size);
};

mp4lib.boxes.FileTypeBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.FileTypeBox.prototype.constructor = mp4lib.boxes.FileTypeBox;

mp4lib.boxes.FileTypeBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT32.getLength() * 2 + mp4lib.fields.FIELD_INT32.getLength() * this.compatible_brands.length;
};

mp4lib.boxes.FileTypeBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;

    this.major_brand = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.minor_brand = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.compatible_brands = this._readArrayData(data, mp4lib.fields.FIELD_INT32);

    return this.localPos;
};

mp4lib.boxes.FileTypeBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT32, this.major_brand);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.minor_brand);
    this._writeArrayData(data, mp4lib.fields.FIELD_INT32, this.compatible_brands);

    return this.localPos;
};
// --------------------------- moov ----------------------------------

mp4lib.boxes.MovieBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'moov', size);
};

mp4lib.boxes.MovieBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MovieBox.prototype.constructor = mp4lib.boxes.MovieBox;

// --------------------------- moof ----------------------------------
mp4lib.boxes.MovieFragmentBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'moof', size);
};

mp4lib.boxes.MovieFragmentBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MovieFragmentBox.prototype.constructor = mp4lib.boxes.MovieFragmentBox;

// --------------------------- mfra ----------------------------------
mp4lib.boxes.MovieFragmentRandomAccessBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'mfra', size);
};

mp4lib.boxes.MovieFragmentRandomAccessBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MovieFragmentRandomAccessBox.prototype.constructor = mp4lib.boxes.MovieFragmentRandomAccessBox;

// --------------------------- udta ----------------------------------
mp4lib.boxes.UserDataBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'udta', size);
};

mp4lib.boxes.UserDataBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.UserDataBox.prototype.constructor = mp4lib.boxes.UserDataBox;

// --------------------------- trak ----------------------------------
mp4lib.boxes.TrackBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'trak', size);
};

mp4lib.boxes.TrackBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.TrackBox.prototype.constructor = mp4lib.boxes.TrackBox;

// --------------------------- edts ----------------------------------
mp4lib.boxes.EditBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'edts', size);
};

mp4lib.boxes.EditBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.EditBox.prototype.constructor = mp4lib.boxes.EditBox;

// --------------------------- mdia ----------------------------------
mp4lib.boxes.MediaBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'mdia', size);
};

mp4lib.boxes.MediaBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MediaBox.prototype.constructor = mp4lib.boxes.MediaBox;

// --------------------------- minf ----------------------------------
mp4lib.boxes.MediaInformationBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'minf', size);
};

mp4lib.boxes.MediaInformationBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MediaInformationBox.prototype.constructor = mp4lib.boxes.MediaInformationBox;

// --------------------------- dinf ----------------------------------
mp4lib.boxes.DataInformationBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'dinf', size);
};

mp4lib.boxes.DataInformationBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.DataInformationBox.prototype.constructor = mp4lib.boxes.DataInformationBox;

// --------------------------- stbl ----------------------------------
mp4lib.boxes.SampleTableBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'stbl', size);
};

mp4lib.boxes.SampleTableBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.SampleTableBox.prototype.constructor = mp4lib.boxes.SampleTableBox;

// --------------------------- mvex ----------------------------------
mp4lib.boxes.MovieExtendsBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'mvex', size);
};

mp4lib.boxes.MovieExtendsBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.MovieExtendsBox.prototype.constructor = mp4lib.boxes.MovieExtendsBox;

// --------------------------- traf ----------------------------------
mp4lib.boxes.TrackFragmentBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'traf', size);
};

mp4lib.boxes.TrackFragmentBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.TrackFragmentBox.prototype.constructor = mp4lib.boxes.TrackFragmentBox;

// --------------------------- meta -----------------------------
mp4lib.boxes.MetaBox = function(size) {
    mp4lib.boxes.ContainerFullBox.call(this, 'meta', size);
};

mp4lib.boxes.MetaBox.prototype = Object.create(mp4lib.boxes.ContainerFullBox.prototype);
mp4lib.boxes.MetaBox.prototype.constructor = mp4lib.boxes.MetaBox;

mp4lib.boxes.MetaBox.prototype.computeLength = function() {
    mp4lib.boxes.ContainerFullBox.prototype.computeLength.call(this, false);
};

mp4lib.boxes.MetaBox.prototype.read = function(data, pos, end) {
    return mp4lib.boxes.ContainerFullBox.prototype.read.call(this, data, pos, end, false);
};

mp4lib.boxes.MetaBox.prototype.write = function(data, pos) {
    return mp4lib.boxes.ContainerFullBox.prototype.write.call(this, data, pos, false);
};

// --------------------------- mvhd ----------------------------------
mp4lib.boxes.MovieHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'mvhd', size);
};

mp4lib.boxes.MovieHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.MovieHeaderBox.prototype.constructor = mp4lib.boxes.MovieHeaderBox;

mp4lib.boxes.MovieHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_INT32.getLength() /*rate size*/ + mp4lib.fields.FIELD_INT16.getLength() * 2 /*volume size and reserved size*/ ;
    this.size += mp4lib.fields.FIELD_INT32.getLength() * 2 /*reserved_2 size*/ + mp4lib.fields.FIELD_INT32.getLength() * 9 /*matrix size*/ ;
    this.size += mp4lib.fields.FIELD_BIT32.getLength() * 6 /*pre_defined size*/ + mp4lib.fields.FIELD_UINT32.getLength() /*next_track_ID size*/ ;
    if (this.version === 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * 3 + mp4lib.fields.FIELD_UINT32.getLength();
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 4;
    }
};

mp4lib.boxes.MovieHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.timescale);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.duration);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.timescale);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.duration);
    }

    this._writeData(data, mp4lib.fields.FIELD_INT32, this.rate);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.volume);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.reserved);
    this._writeArrayData(data, mp4lib.fields.FIELD_INT32, this.reserved_2);
    this._writeArrayData(data, mp4lib.fields.FIELD_INT32, this.matrix);
    this._writeArrayData(data, mp4lib.fields.FIELD_BIT32, this.pre_defined);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.next_track_ID);

    return this.localPos;
};

mp4lib.boxes.MovieHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version == 1) {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.timescale = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.timescale = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    this.rate = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.volume = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.reserved = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.reserved_2 = this._readArrayFieldData(data, mp4lib.fields.FIELD_INT32, 2);
    this.matrix = this._readArrayFieldData(data, mp4lib.fields.FIELD_INT32, 9);
    this.pre_defined = this._readArrayFieldData(data, mp4lib.fields.FIELD_BIT32, 6);
    this.next_track_ID = this._readData(data, mp4lib.fields.FIELD_UINT32);

    return this.localPos;
};

// --------------------------- mdat ----------------------------------
mp4lib.boxes.MediaDataBox = function(size) {
    mp4lib.boxes.Box.call(this, 'mdat', size);
};

mp4lib.boxes.MediaDataBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.MediaDataBox.prototype.constructor = mp4lib.boxes.MediaDataBox;

mp4lib.boxes.MediaDataBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += this.data.length;
};

mp4lib.boxes.MediaDataBox.prototype.read = function(data, pos, end) {
    this.data = data.subarray(pos, end);

    return end;
};

mp4lib.boxes.MediaDataBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeBuffer(data, this.data, this.data.length);

    return this.localPos;
};

// --------------------------- free ----------------------------------
mp4lib.boxes.FreeSpaceBox = function(size) {
    mp4lib.boxes.Box.call(this, 'free', size);
};

mp4lib.boxes.FreeSpaceBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.FreeSpaceBox.prototype.constructor = mp4lib.boxes.FreeSpaceBox;

mp4lib.boxes.FreeSpaceBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += this.data.length;
};

mp4lib.boxes.FreeSpaceBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;
    this.data = data.subarray(this.localPos, this.localEnd);
    return this.localEnd;
};

mp4lib.boxes.FreeSpaceBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeBuffer(data, this.data, this.data.length);

    return this.localPos;
};

// --------------------------- sidx ----------------------------------
mp4lib.boxes.SegmentIndexBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'sidx', size);
};

mp4lib.boxes.SegmentIndexBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SegmentIndexBox.prototype.constructor = mp4lib.boxes.SegmentIndexBox;

mp4lib.boxes.SegmentIndexBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2; /* reference_ID and timescale size*/
    if (this.version === 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * 2; /* earliest_presentation_time and first_offset size*/
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2; /* earliest_presentation_time and first_offset size*/
    }
    this.size += mp4lib.fields.FIELD_UINT16.getLength(); /* reserved size*/
    this.size += mp4lib.fields.FIELD_UINT16.getLength(); /* reference_count size*/
    this.size += (mp4lib.fields.FIELD_UINT64.getLength() /* reference_info size*/ + mp4lib.fields.FIELD_UINT32.getLength() /* SAP size*/ ) * this.reference_count;
};


mp4lib.boxes.SegmentIndexBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    var i = 0,
        struct = {};

    this.reference_ID = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.timescale = this._readData(data, mp4lib.fields.FIELD_UINT32);

    if (this.version === 1) {
        this.earliest_presentation_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.first_offset = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.earliest_presentation_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.first_offset = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    this.reserved = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.reference_count = this._readData(data, mp4lib.fields.FIELD_UINT16);

    this.references = [];

    for (i = 0; i < this.reference_count; i++) {
        struct = {};

        struct.reference_info = this._readData(data, mp4lib.fields.FIELD_UINT64);
        struct.SAP = this._readData(data, mp4lib.fields.FIELD_UINT32);

        this.references.push(struct);
    }

    return this.localPos;
};

mp4lib.boxes.SegmentIndexBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.reference_ID);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.timescale);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.earliest_presentation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.first_offset);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.earliest_presentation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.first_offset);
    }

    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.reserved);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.reference_count);

    for (i = 0; i < this.reference_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.references[i].reference_info);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.references[i].SAP);
    }
    return this.localPos;
};

// --------------------------- tkhd ----------------------------------
mp4lib.boxes.TrackHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tkhd', size);
};

mp4lib.boxes.TrackHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackHeaderBox.prototype.constructor = mp4lib.boxes.TrackHeaderBox;

mp4lib.boxes.TrackHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT16.getLength() * 4 + mp4lib.fields.FIELD_INT32.getLength() * 2 + mp4lib.fields.FIELD_UINT32.getLength() * 2 + mp4lib.fields.FIELD_INT32.getLength() * 9;
    if (this.version == 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * 3 + mp4lib.fields.FIELD_UINT32.getLength() * 2;
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 5;
    }
};

mp4lib.boxes.TrackHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version === 1) {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.track_id = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.reserved = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.track_id = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.reserved = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    this.reserved_2 = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, 2);
    this.layer = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.alternate_group = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.volume = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.reserved_3 = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.matrix = this._readArrayFieldData(data, mp4lib.fields.FIELD_INT32, 9);
    this.width = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.height = this._readData(data, mp4lib.fields.FIELD_INT32);
    return this.localPos;
};

mp4lib.boxes.TrackHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.track_id);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.reserved);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.duration);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.track_id);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.reserved);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.duration);
    }

    this._writeArrayData(data, mp4lib.fields.FIELD_UINT32, this.reserved_2);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.layer);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.alternate_group);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.volume);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.reserved_3);
    this._writeArrayData(data, mp4lib.fields.FIELD_INT32, this.matrix);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.width);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.height);
    return this.localPos;
};

// --------------------------- mdhd ----------------------------------
mp4lib.boxes.MediaHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'mdhd', size);
};

mp4lib.boxes.MediaHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.MediaHeaderBox.prototype.constructor = mp4lib.boxes.MediaHeaderBox;

mp4lib.boxes.MediaHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT16.getLength() * 2;
    if (this.version == 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * 3 + mp4lib.fields.FIELD_UINT32.getLength();
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 4;
    }
};

mp4lib.boxes.MediaHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version === 1) {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.timescale = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.creation_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.modification_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.timescale = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    this.language = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.pre_defined = this._readData(data, mp4lib.fields.FIELD_UINT16);
    return this.localPos;
};

mp4lib.boxes.MediaHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.timescale);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.duration);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.creation_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.modification_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.timescale);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.duration);
    }

    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.language);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.pre_defined);
    return this.localPos;
};

// --------------------------- mehd ----------------------------------
mp4lib.boxes.MovieExtendsHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'mehd', size);
};

mp4lib.boxes.MovieExtendsHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.MovieExtendsHeaderBox.prototype.constructor = mp4lib.boxes.MovieExtendsHeaderBox;

mp4lib.boxes.MovieExtendsHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    if (this.version == 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength();
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
};

mp4lib.boxes.MovieExtendsHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version === 1) {
        this.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    return this.localPos;
};

mp4lib.boxes.MovieExtendsHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.fragment_duration);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.fragment_duration);
    }
    return this.localPos;
};

// --------------------------- hdlr --------------------------------
mp4lib.boxes.HandlerBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'hdlr', size);
};

mp4lib.boxes.HandlerBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.HandlerBox.prototype.constructor = mp4lib.boxes.HandlerBox;

//add NAN
mp4lib.boxes.HandlerBox.prototype.HANDLERTYPEVIDEO = "vide";
mp4lib.boxes.HandlerBox.prototype.HANDLERTYPEAUDIO = "soun";
mp4lib.boxes.HandlerBox.prototype.HANDLERTYPETEXT = "meta";
mp4lib.boxes.HandlerBox.prototype.HANDLERVIDEONAME = "Video Track";
mp4lib.boxes.HandlerBox.prototype.HANDLERAUDIONAME = "Audio Track";
mp4lib.boxes.HandlerBox.prototype.HANDLERTEXTNAME = "Text Track";

mp4lib.boxes.HandlerBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2 + mp4lib.fields.FIELD_UINT32.getLength() * 3 +
        mp4lib.fields.FIELD_STRING.getLength(this.name);
};

mp4lib.boxes.HandlerBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.pre_defined = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.handler_type = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.reserved = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, 3);
    this.name = this._readData(data, mp4lib.fields.FIELD_STRING);
    return this.localPos;
};

mp4lib.boxes.HandlerBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.pre_defined);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.handler_type);
    this._writeArrayData(data, mp4lib.fields.FIELD_UINT32, this.reserved);
    this._writeData(data, mp4lib.fields.FIELD_STRING, this.name);
    return this.localPos;
};

// --------------------------- stts ----------------------------------
mp4lib.boxes.TimeToSampleBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'stts', size);
};

mp4lib.boxes.TimeToSampleBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TimeToSampleBox.prototype.constructor = mp4lib.boxes.TimeToSampleBox;

mp4lib.boxes.TimeToSampleBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
    this.size += this.entry_count * (mp4lib.fields.FIELD_UINT32.getLength() * 2);
};

mp4lib.boxes.TimeToSampleBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};

    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    this.entry = [];

    for (i = 0; i < this.entry_count; i++) {
        struct = {};

        struct.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
        struct.sample_delta = this._readData(data, mp4lib.fields.FIELD_UINT32);

        this.entry.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.TimeToSampleBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);

    for (i = 0; i < this.entry_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].sample_count);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].sample_delta);
    }
    return this.localPos;
};

// --------------------------- stsc ----------------------------------
mp4lib.boxes.SampleToChunkBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'stsc', size);
};

mp4lib.boxes.SampleToChunkBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SampleToChunkBox.prototype.constructor = mp4lib.boxes.SampleToChunkBox;

mp4lib.boxes.SampleToChunkBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
    this.size += this.entry_count * (mp4lib.fields.FIELD_UINT32.getLength() * 3);
};

mp4lib.boxes.SampleToChunkBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};

    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    this.entry = [];

    for (i = 0; i < this.entry_count; i++) {
        struct = {};

        struct.first_chunk = this._readData(data, mp4lib.fields.FIELD_UINT32);
        struct.samples_per_chunk = this._readData(data, mp4lib.fields.FIELD_UINT32);
        struct.samples_description_index = this._readData(data, mp4lib.fields.FIELD_UINT32);

        this.entry.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.SampleToChunkBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    for (i = 0; i < this.entry_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].first_chunk);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].samples_per_chunk);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].samples_description_index);
    }
    return this.localPos;
};

// --------------------------- stco ----------------------------------
mp4lib.boxes.ChunkOffsetBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'stco', size);
};

mp4lib.boxes.ChunkOffsetBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.ChunkOffsetBox.prototype.constructor = mp4lib.boxes.ChunkOffsetBox;

mp4lib.boxes.ChunkOffsetBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength() + this.entry_count * mp4lib.fields.FIELD_UINT32.getLength();
};

mp4lib.boxes.ChunkOffsetBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.chunk_offset = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    return this.localPos;
};

mp4lib.boxes.ChunkOffsetBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);

    for (i = 0; i < this.entry_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.chunk_offset[i]);
    }
    return this.localPos;
};

// --------------------------- trex ----------------------------------
mp4lib.boxes.TrackExtendsBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'trex', size);
};

mp4lib.boxes.TrackExtendsBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackExtendsBox.prototype.constructor = mp4lib.boxes.TrackExtendsBox;

mp4lib.boxes.TrackExtendsBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 5;
};

mp4lib.boxes.TrackExtendsBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.track_ID = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.default_sample_description_index = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.default_sample_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.default_sample_size = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.default_sample_flags = this._readData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.TrackExtendsBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.track_ID);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_description_index);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_duration);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_size);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_flags);
    return this.localPos;
};

// --------------------------- vmhd ----------------------------------
mp4lib.boxes.VideoMediaHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'vmhd', size);
};

mp4lib.boxes.VideoMediaHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.VideoMediaHeaderBox.prototype.constructor = mp4lib.boxes.VideoMediaHeaderBox;

mp4lib.boxes.VideoMediaHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT16.getLength() + mp4lib.fields.FIELD_UINT16.getLength() * 3;
};

mp4lib.boxes.VideoMediaHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.graphicsmode = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.opcolor = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT16, 3);
    return this.localPos;
};

mp4lib.boxes.VideoMediaHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT16, this.graphicsmode);
    this._writeArrayData(data, mp4lib.fields.FIELD_UINT16, this.opcolor);
    return this.localPos;
};

// --------------------------- smhd ----------------------------------
mp4lib.boxes.SoundMediaHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'smhd', size);
};

mp4lib.boxes.SoundMediaHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SoundMediaHeaderBox.prototype.constructor = mp4lib.boxes.SoundMediaHeaderBox;

mp4lib.boxes.SoundMediaHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT16.getLength() + mp4lib.fields.FIELD_UINT16.getLength();
};

mp4lib.boxes.SoundMediaHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.balance = this._readData(data, mp4lib.fields.FIELD_INT16);
    this.reserved = this._readData(data, mp4lib.fields.FIELD_UINT16);
    return this.localPos;
};

mp4lib.boxes.SoundMediaHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT16, this.balance);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.reserved);
    return this.localPos;
};

// --------------------------- dref ----------------------------------
mp4lib.boxes.DataReferenceBox = function(size) {
    mp4lib.boxes.ContainerFullBox.call(this, 'dref', size);
};

mp4lib.boxes.DataReferenceBox.prototype = Object.create(mp4lib.boxes.ContainerFullBox.prototype);
mp4lib.boxes.DataReferenceBox.prototype.constructor = mp4lib.boxes.DataReferenceBox;

mp4lib.boxes.DataReferenceBox.prototype.computeLength = function() {
    mp4lib.boxes.ContainerFullBox.prototype.computeLength.call(this, true);
};

mp4lib.boxes.DataReferenceBox.prototype.read = function(data, pos, end) {
    return mp4lib.boxes.ContainerFullBox.prototype.read.call(this, data, pos, end, true);
};

mp4lib.boxes.DataReferenceBox.prototype.write = function(data, pos) {
    if (!this.entry_count) {
        //if entry_count has not been set, set it to boxes array length
        this.entry_count = this.boxes.length;
    }
    return mp4lib.boxes.ContainerFullBox.prototype.write.call(this, data, pos, true);
};

// --------------------------- url  ----------------------------------
mp4lib.boxes.DataEntryUrlBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'url ', size);
};

mp4lib.boxes.DataEntryUrlBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.DataEntryUrlBox.prototype.constructor = mp4lib.boxes.DataEntryUrlBox;

mp4lib.boxes.DataEntryUrlBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    //NAN : test on location value, not definition, probleme in IE
    if (this.location !== undefined /*&& this.location !==""*/ ) {
        //this.flags = this.flags | 1;
        this.size += mp4lib.fields.FIELD_STRING.getLength(this.location);
    }
};

mp4lib.boxes.DataEntryUrlBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.flags & '0x000001' === 0) {
        this.location = this._readData(data, mp4lib.fields.FIELD_STRING);
    }

    return this.localPos;
};

mp4lib.boxes.DataEntryUrlBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.location !== undefined /* && this.location !== ""*/ ) {
        this._writeData(data, mp4lib.fields.FIELD_STRING, this.location);
    }
    return this.localPos;
};

// --------------------------- urn  ----------------------------------
mp4lib.boxes.DataEntryUrnBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'urn ', size);
};

mp4lib.boxes.DataEntryUrnBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.DataEntryUrnBox.prototype.constructor = mp4lib.boxes.DataEntryUrnBox;

mp4lib.boxes.DataEntryUrnBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    if (this.flags & '0x000001' === 0) {
        this.size += mp4lib.fields.FIELD_STRING.getLength(this.name) + mp4lib.fields.FIELD_STRING.getLength(this.location);
    }
};

mp4lib.boxes.DataEntryUrnBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.flags & '0x000001' === 0) {
        this.name = this._readData(data, mp4lib.fields.FIELD_STRING);
        this.location = this._readData(data, mp4lib.fields.FIELD_STRING);
    }
    return this.localPos;
};

mp4lib.boxes.DataEntryUrnBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.flags & '0x000001' === 0) {
        this._writeData(data, mp4lib.fields.FIELD_STRING, this.name);
        this._writeData(data, mp4lib.fields.FIELD_STRING, this.location);
    }
    return this.localPos;
};

// --------------------------- mfhd ----------------------------------
mp4lib.boxes.MovieFragmentHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'mfhd', size);
};

mp4lib.boxes.MovieFragmentHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.MovieFragmentHeaderBox.prototype.constructor = mp4lib.boxes.MovieFragmentHeaderBox;

mp4lib.boxes.MovieFragmentHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
};

mp4lib.boxes.MovieFragmentHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    this.sequence_number = this._readData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.MovieFragmentHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sequence_number);
    return this.localPos;
};

// --------------------------- tfhd ----------------------------------
mp4lib.boxes.TrackFragmentHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tfhd', size);
};

mp4lib.boxes.TrackFragmentHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackFragmentHeaderBox.prototype.constructor = mp4lib.boxes.TrackFragmentHeaderBox;

mp4lib.boxes.TrackFragmentHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
    //even if, for example base_data_offset is defined, test the flags value
    //to know if base_data_offset size should be added to global size.
    if ((this.flags & 0x000001) !== 0 && this.base_data_offset !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength();
    }
    if ((this.flags & 0x000002) !== 0 && this.sample_description_index !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
    if ((this.flags & 0x000008) !== 0 && this.default_sample_duration !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
    if ((this.flags & 0x000010) !== 0 && this.default_sample_size !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
    if ((this.flags & 0x000020) !== 0 && this.default_sample_flags !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
};

mp4lib.boxes.TrackFragmentHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.track_ID = this._readData(data, mp4lib.fields.FIELD_UINT32);
    if ((this.flags & 0x000001) !== 0) {
        this.base_data_offset = this._readData(data, mp4lib.fields.FIELD_UINT64);
    }
    if ((this.flags & 0x000002) !== 0) {
        this.sample_description_index = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    if ((this.flags & 0x000008) !== 0) {
        this.default_sample_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    if ((this.flags & 0x000010) !== 0) {
        this.default_sample_size = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    if ((this.flags & 0x000020) !== 0) {
        this.default_sample_flags = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    return this.localPos;
};

mp4lib.boxes.TrackFragmentHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.track_ID);

    if ((this.flags & 0x000001) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.base_data_offset);
    }
    if ((this.flags & 0x000002) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_description_index);
    }
    if ((this.flags & 0x000008) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_duration);
    }
    if ((this.flags & 0x000010) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_size);
    }
    if ((this.flags & 0x000020) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.default_sample_flags);
    }
    return this.localPos;
};

// --------------------------- tfdt ----------------------------------
mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tfdt', size);
};

mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox.prototype.constructor = mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox;

mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    if (this.version === 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength();
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }
};

mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version === 1) {
        this.baseMediaDecodeTime = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.baseMediaDecodeTime = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    return this.localPos;
};

mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.baseMediaDecodeTime);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.baseMediaDecodeTime);
    }
    return this.localPos;
};

// --------------------------- trun ----------------------------------
mp4lib.boxes.TrackFragmentRunBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'trun', size);
};

mp4lib.boxes.TrackFragmentRunBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackFragmentRunBox.prototype.constructor = mp4lib.boxes.TrackFragmentRunBox;

mp4lib.boxes.TrackFragmentRunBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    var i = 0;
    this.size += mp4lib.fields.FIELD_UINT32.getLength(); //sample_count size
    if ((this.flags & 0x000001) !== 0 && this.data_offset !== undefined) {
        this.size += mp4lib.fields.FIELD_INT32.getLength();
    }
    if ((this.flags & 0x000004) !== 0 && this.first_sample_flags !== undefined) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength();
    }

    for (i = 0; i < this.sample_count; i++) {
        if ((this.flags & 0x000100) !== 0 && this.samples_table[i].sample_duration !== undefined) {
            this.size += mp4lib.fields.FIELD_UINT32.getLength();
        }
        if ((this.flags & 0x000200) !== 0 && this.samples_table[i].sample_size !== undefined) {
            this.size += mp4lib.fields.FIELD_UINT32.getLength();
        }
        if ((this.flags & 0x000400) !== 0 && this.samples_table[i].sample_flags !== undefined) {
            this.size += mp4lib.fields.FIELD_UINT32.getLength();
        }

        if (this.version === 1) {
            if ((this.flags & 0x000800) !== 0 && this.samples_table[i].sample_composition_time_offset !== undefined) {
                this.size += mp4lib.fields.FIELD_INT32.getLength();
            }
        } else {
            if ((this.flags & 0x000800) !== 0 && this.samples_table[i].sample_composition_time_offset !== undefined) {
                this.size += mp4lib.fields.FIELD_UINT32.getLength();
            }
        }
    }
};

mp4lib.boxes.TrackFragmentRunBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};

    this.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    if ((this.flags & 0x000001) !== 0) {
        this.data_offset = this._readData(data, mp4lib.fields.FIELD_INT32);
    }
    if ((this.flags & 0x000004) !== 0) {
        this.first_sample_flags = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    this.samples_table = [];

    for (i = 0; i < this.sample_count; i++) {
        struct = {};
        if ((this.flags & 0x000100) !== 0) {
            struct.sample_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
        }
        if ((this.flags & 0x000200) !== 0) {
            struct.sample_size = this._readData(data, mp4lib.fields.FIELD_UINT32);
        }
        if ((this.flags & 0x000400) !== 0) {
            struct.sample_flags = this._readData(data, mp4lib.fields.FIELD_UINT32);
        }

        if (this.version === 1) {
            if ((this.flags & 0x000800) !== 0) {
                struct.sample_composition_time_offset = this._readData(data, mp4lib.fields.FIELD_INT32);
            }
        } else {
            if ((this.flags & 0x000800) !== 0) {
                struct.sample_composition_time_offset = this._readData(data, mp4lib.fields.FIELD_UINT32);
            }
        }
        this.samples_table.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.TrackFragmentRunBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_count);

    if ((this.flags & 0x000001) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_INT32, this.data_offset);
    }
    if ((this.flags & 0x000004) !== 0) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.first_sample_flags);
    }

    for (i = 0; i < this.sample_count; i++) {

        if ((this.flags & 0x000100) !== 0) {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.samples_table[i].sample_duration);
        }
        if ((this.flags & 0x000200) !== 0) {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.samples_table[i].sample_size);
        }
        if ((this.flags & 0x000400) !== 0) {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.samples_table[i].sample_flags);
        }

        if (this.version === 1) {
            if ((this.flags & 0x000800) !== 0) {
                this._writeData(data, mp4lib.fields.FIELD_INT32, this.samples_table[i].sample_composition_time_offset);
            }
        } else {
            if ((this.flags & 0x000800) !== 0) {
                this._writeData(data, mp4lib.fields.FIELD_UINT32, this.samples_table[i].sample_composition_time_offset);
            }
        }
    }
    return this.localPos;
};

// --------------------------- stsd ----------------------------------
mp4lib.boxes.SampleDescriptionBox = function(size) {
    mp4lib.boxes.ContainerFullBox.call(this, 'stsd', size);
};

mp4lib.boxes.SampleDescriptionBox.prototype = Object.create(mp4lib.boxes.ContainerFullBox.prototype);
mp4lib.boxes.SampleDescriptionBox.prototype.constructor = mp4lib.boxes.SampleDescriptionBox;

mp4lib.boxes.SampleDescriptionBox.prototype.computeLength = function() {
    mp4lib.boxes.ContainerFullBox.prototype.computeLength.call(this, true);
};

mp4lib.boxes.SampleDescriptionBox.prototype.read = function(data, pos, end) {
    return mp4lib.boxes.ContainerFullBox.prototype.read.call(this, data, pos, end, true);
};

mp4lib.boxes.SampleDescriptionBox.prototype.write = function(data, pos) {
    this.entry_count = this.boxes.length;
    return mp4lib.boxes.ContainerFullBox.prototype.write.call(this, data, pos, true);
};

// --------------------------- sdtp ----------------------------------
mp4lib.boxes.SampleDependencyTableBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'sdtp', size);
};

mp4lib.boxes.SampleDependencyTableBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SampleDependencyTableBox.prototype.constructor = mp4lib.boxes.SampleDependencyTableBox;

mp4lib.boxes.SampleDependencyTableBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT8.getLength() * this.sample_dependency_table.length;
};

mp4lib.boxes.SampleDependencyTableBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    this.sample_dependency_table = this._readArrayData(data, mp4lib.fields.FIELD_UINT8);
    return this.localPos;
};

mp4lib.boxes.SampleDependencyTableBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeArrayData(data, mp4lib.fields.FIELD_UINT8, this.sample_dependency_table);
    return this.localPos;
};

// --------------------------- abstract SampleEntry ----------------------------------
mp4lib.boxes.SampleEntryBox = function(boxType, size) {
    mp4lib.boxes.Box.call(this, boxType, size);
};

mp4lib.boxes.SampleEntryBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.SampleEntryBox.prototype.constructor = mp4lib.boxes.SampleEntryBox;

mp4lib.boxes.SampleEntryBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT16.getLength() + mp4lib.fields.FIELD_UINT8.getLength() * 6;
};

mp4lib.boxes.SampleEntryBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;

    this.reserved = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT8, 6);
    this.data_reference_index = this._readData(data, mp4lib.fields.FIELD_UINT16);
    return this.localPos;
};

mp4lib.boxes.SampleEntryBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeArrayData(data, mp4lib.fields.FIELD_UINT8, this.reserved);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.data_reference_index);
    return this.localPos;
};

// --------------------------- abstract VisualSampleEntry ----------------------------------
mp4lib.boxes.VisualSampleEntryBox = function(boxType, size) {
    mp4lib.boxes.SampleEntryBox.call(this, boxType, size);
};

mp4lib.boxes.VisualSampleEntryBox.prototype = Object.create(mp4lib.boxes.SampleEntryBox.prototype);
mp4lib.boxes.VisualSampleEntryBox.prototype.constructor = mp4lib.boxes.VisualSampleEntryBox;

mp4lib.boxes.VisualSampleEntryBox.prototype.computeLength = function() {
    mp4lib.boxes.SampleEntryBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT16.getLength() * 7 + mp4lib.fields.FIELD_UINT32.getLength() * 3;
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 3;
    this.size += 32; //compressorname size
};

mp4lib.boxes.VisualSampleEntryBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.SampleEntryBox.prototype.read.call(this, data, pos, end);
    this.pre_defined = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.reserved_2 = this._readData(data, mp4lib.fields.FIELD_UINT16);
    // there is already field called reserved from SampleEntry, so we need to call it reserved_2
    this.pre_defined_2 = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, 3);
    this.width = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.height = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.horizresolution = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.vertresolution = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.reserved_3 = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.frame_count = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.compressorname = new mp4lib.fields.FixedLenStringField(32);
    this.compressorname = this.compressorname.read(data, this.localPos);
    this.localPos += 32;
    this.depth = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.pre_defined_3 = this._readData(data, mp4lib.fields.FIELD_INT16);
    return this.localPos;
};

mp4lib.boxes.VisualSampleEntryBox.prototype.write = function(data, pos) {
    mp4lib.boxes.SampleEntryBox.prototype.write.call(this, data, pos);
    var i = 0;

    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.pre_defined);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.reserved_2);
    // there is already field called reserved from SampleEntry, so we need to call it reserved_2
    this._writeArrayData(data, mp4lib.fields.FIELD_UINT32, this.pre_defined_2);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.width);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.height);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.horizresolution);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.vertresolution);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.reserved_3);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.frame_count);
    for (i = 0; i < 32; i++) {
        data[this.localPos + i] = this.compressorname.charCodeAt(i);
    }
    this.localPos += 32;
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.depth);
    this._writeData(data, mp4lib.fields.FIELD_INT16, this.pre_defined_3);
    return this.localPos;
};

// --------------------------- abstract VisualSampleEntryContainer ----------------------------------
mp4lib.boxes.VisualSampleEntryContainerBox = function(boxType, size) {
    mp4lib.boxes.VisualSampleEntryBox.call(this, boxType, size);
    this.boxes = [];
};

mp4lib.boxes.VisualSampleEntryContainerBox.prototype = Object.create(mp4lib.boxes.VisualSampleEntryBox.prototype);
mp4lib.boxes.VisualSampleEntryContainerBox.prototype.constructor = mp4lib.boxes.VisualSampleEntryContainerBox;

mp4lib.boxes.VisualSampleEntryContainerBox.prototype.computeLength = function() {
    mp4lib.boxes.VisualSampleEntryBox.prototype.computeLength.call(this);
    var i = 0;
    for (i = 0; i < this.boxes.length; i++) {
        this.boxes[i].computeLength();
        this.size += this.boxes[i].size;
    }
};

mp4lib.boxes.VisualSampleEntryContainerBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.VisualSampleEntryBox.prototype.read.call(this, data, pos, end);

    var size = 0,
        uuidFieldPos = 0,
        uuid = null,
        boxtype,
        box;

    while (this.localPos < this.localEnd) {
        // Read box size
        size = mp4lib.fields.FIELD_UINT32.read(data, this.localPos);

        // Read boxtype
        boxtype = mp4lib.fields.readString(data, this.localPos + 4, 4);

        // Extented type?
        if (boxtype == "uuid") {
            uuidFieldPos = (size == 1) ? 16 : 8;
            uuid = new mp4lib.fields.ArrayField(mp4lib.fields.FIELD_INT8, 16).read(data, this.localPos + uuidFieldPos, this.localPos + uuidFieldPos + 16);
            uuid = JSON.stringify(uuid);
        }

        box = mp4lib.createBox(boxtype, size, uuid);
        if (boxtype === "uuid") {
            this.localPos = box.read(data, this.localPos + mp4lib.fields.FIELD_INT8.getLength() * 16 + 8, this.localPos + size);
        } else {
            this.localPos = box.read(data, this.localPos + 8, this.localPos + size);
        }

        // in debug mode, sourcebuffer is copied to each box,
        // so any invalid deserializations may be found by comparing
        // source buffer with serialized box
        if (mp4lib.debug) {
            box.__sourceBuffer = data.subarray(this.localPos - box.size, this.localPos);
        }

        this.boxes.push(box);

        if (box.size <= 0 || box.size === null) {
            throw new mp4lib.ParseException('Problem on size of box ' + box.boxtype +
                ', parsing stopped to avoid infinite loop');
        }

        if (!box.boxtype) {
            throw new mp4lib.ParseException('Problem on unknown box, parsing stopped to avoid infinite loop');
        }
    }
    return this.localPos;
};

mp4lib.boxes.VisualSampleEntryContainerBox.prototype.write = function(data, pos) {
    mp4lib.boxes.VisualSampleEntryBox.prototype.write.call(this, data, pos);
    var i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        this.localPos = this.boxes[i].write(data, this.localPos);
    }
    return this.localPos;
};

// --------------------------- avc1 ----------------------------------
mp4lib.boxes.AVC1VisualSampleEntryBox = function(size) {
    mp4lib.boxes.VisualSampleEntryContainerBox.call(this, 'avc1', size);
};

mp4lib.boxes.AVC1VisualSampleEntryBox.prototype = Object.create(mp4lib.boxes.VisualSampleEntryContainerBox.prototype);
mp4lib.boxes.AVC1VisualSampleEntryBox.prototype.constructor = mp4lib.boxes.AVC1VisualSampleEntryBox;

//-------------------------- encv ------------------------------------
mp4lib.boxes.EncryptedVideoBox = function(size) {
    mp4lib.boxes.VisualSampleEntryContainerBox.call(this, 'encv', size);
};

mp4lib.boxes.EncryptedVideoBox.prototype = Object.create(mp4lib.boxes.VisualSampleEntryContainerBox.prototype);
mp4lib.boxes.EncryptedVideoBox.prototype.constructor = mp4lib.boxes.EncryptedVideoBox;

// --------------------------- avcc ----------------------------------
mp4lib.boxes.AVCConfigurationBox = function(size) {
    mp4lib.boxes.Box.call(this, 'avcC', size);
};

mp4lib.boxes.AVCConfigurationBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.AVCConfigurationBox.prototype.constructor = mp4lib.boxes.AVCConfigurationBox;

mp4lib.boxes.AVCConfigurationBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT8.getLength() * 4 + mp4lib.fields.FIELD_UINT8.getLength() * 3;
    this.size += this._getNALLength(this.numOfSequenceParameterSets, this.SPS_NAL);
    this.size += this._getNALLength(this.numOfPictureParameterSets, this.PPS_NAL);
};

mp4lib.boxes.AVCConfigurationBox.prototype._getNALLength = function(nbElements, nalArray) {
    var size_NAL = 0,
        i = 0;

    for (i = 0; i < nbElements; i++) {
        size_NAL += mp4lib.fields.FIELD_UINT16.getLength() + nalArray[i].NAL_length;
    }

    return size_NAL;
};

mp4lib.boxes.AVCConfigurationBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;
    this.configurationVersion = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.AVCProfileIndication = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.profile_compatibility = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.AVCLevelIndication = this._readData(data, mp4lib.fields.FIELD_UINT8);

    this.temp = this._readData(data, mp4lib.fields.FIELD_UINT8);
    // 6 bits for reserved =63 and two bits for NAL length = 2-bit length byte size type
    this.lengthSizeMinusOne = this.temp & 3;
    this.numOfSequenceParameterSets_tmp = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.numOfSequenceParameterSets = this.numOfSequenceParameterSets_tmp & 31;

    this.SPS_NAL = this._readNAL(data, this.numOfSequenceParameterSets);

    this.numOfPictureParameterSets = this._readData(data, mp4lib.fields.FIELD_UINT8);

    this.PPS_NAL = this._readNAL(data, this.numOfPictureParameterSets);
    return this.localPos;
};

mp4lib.boxes.AVCConfigurationBox.prototype._readNAL = function(data, nbElements) {
    var nalArray = [],
        i = 0,
        struct = {};

    for (i = 0; i < nbElements; i++) {
        struct = {};

        struct.NAL_length = this._readData(data, mp4lib.fields.FIELD_UINT16);
        struct.NAL = data.subarray(this.localPos, this.localPos + struct.NAL_length);
        this.localPos += struct.NAL_length;
        nalArray.push(struct);
    }
    return nalArray;
};

mp4lib.boxes.AVCConfigurationBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.configurationVersion);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.AVCProfileIndication);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.profile_compatibility);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.AVCLevelIndication);

    this.temp = this.lengthSizeMinusOne | 252;
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.temp);
    this.numOfSequenceParameterSets = this.SPS_NAL.length;
    this.numOfSequenceParameterSets_tmp = this.numOfSequenceParameterSets | 224;
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.numOfSequenceParameterSets_tmp);
    this._writeNAL(data, this.numOfSequenceParameterSets, this.SPS_NAL);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.numOfPictureParameterSets);
    this._writeNAL(data, this.numOfPictureParameterSets, this.PPS_NAL);
    return this.localPos;
};

mp4lib.boxes.AVCConfigurationBox.prototype._writeNAL = function(data, nbElements, nalArray) {
    var i = 0;

    for (i = 0; i < nbElements; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT16, nalArray[i].NAL_length);
        this._writeBuffer(data, nalArray[i].NAL, nalArray[i].NAL_length);
    }
};

// --------------------------- pasp ----------------------------------
mp4lib.boxes.PixelAspectRatioBox = function(size) {
    mp4lib.boxes.Box.call(this, 'pasp', size);
};

mp4lib.boxes.PixelAspectRatioBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.PixelAspectRatioBox.prototype.constructor = mp4lib.boxes.PixelAspectRatioBox;

mp4lib.boxes.PixelAspectRatioBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT32.getLength() * 2;
};

mp4lib.boxes.PixelAspectRatioBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;

    this.hSpacing = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.vSpacing = this._readData(data, mp4lib.fields.FIELD_INT32);
    return this.localPos;
};

mp4lib.boxes.PixelAspectRatioBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT32, this.hSpacing);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.vSpacing);
    return this.localPos;
};

// --------------------------- abstract VisualSampleEntry ----------------------------------
mp4lib.boxes.AudioSampleEntryBox = function(boxType, size) {
    mp4lib.boxes.SampleEntryBox.call(this, boxType, size);
};

mp4lib.boxes.AudioSampleEntryBox.prototype = Object.create(mp4lib.boxes.SampleEntryBox.prototype);
mp4lib.boxes.AudioSampleEntryBox.prototype.constructor = mp4lib.boxes.AudioSampleEntryBox;

mp4lib.boxes.AudioSampleEntryBox.prototype.computeLength = function() {
    mp4lib.boxes.SampleEntryBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT16.getLength() * 4 + mp4lib.fields.FIELD_UINT32.getLength() * 3;
};

mp4lib.boxes.AudioSampleEntryBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.SampleEntryBox.prototype.read.call(this, data, pos, end);

    this.reserved_2 = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, 2);
    this.channelcount = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.samplesize = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.pre_defined = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.reserved_3 = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.samplerate = this._readData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.AudioSampleEntryBox.prototype.write = function(data, pos) {
    mp4lib.boxes.SampleEntryBox.prototype.write.call(this, data, pos);

    this._writeArrayData(data, mp4lib.fields.FIELD_UINT32, this.reserved_2);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.channelcount);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.samplesize);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.pre_defined);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.reserved_3);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.samplerate);
    return this.localPos;
};

// --------------------------- abstract AudioSampleEntryContainer ----------------------------------
mp4lib.boxes.AudioSampleEntryContainerBox = function(boxType, size) {
    mp4lib.boxes.AudioSampleEntryBox.call(this, boxType, size);
    this.boxes = [];
};

mp4lib.boxes.AudioSampleEntryContainerBox.prototype = Object.create(mp4lib.boxes.AudioSampleEntryBox.prototype);
mp4lib.boxes.AudioSampleEntryContainerBox.prototype.constructor = mp4lib.boxes.AudioSampleEntryContainerBox;

mp4lib.boxes.AudioSampleEntryContainerBox.prototype.computeLength = function() {
    mp4lib.boxes.AudioSampleEntryBox.prototype.computeLength.call(this);
    var i = 0;
    for (i = 0; i < this.boxes.length; i++) {
        this.boxes[i].computeLength();
        this.size += this.boxes[i].size;
    }
};

mp4lib.boxes.AudioSampleEntryContainerBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.AudioSampleEntryBox.prototype.read.call(this, data, pos, end);

    var size = 0,
        uuidFieldPos = 0,
        uuid = null,
        boxtype,
        box;

    while (this.localPos < this.localEnd) {
        // Read box size
        size = mp4lib.fields.FIELD_UINT32.read(data, this.localPos);

        // Read boxtype
        boxtype = mp4lib.fields.readString(data, this.localPos + 4, 4);

        // Extented type?
        if (boxtype == "uuid") {
            uuidFieldPos = (size == 1) ? 16 : 8;
            uuid = new mp4lib.fields.ArrayField(mp4lib.fields.FIELD_INT8, 16).read(data, this.localPos + uuidFieldPos, this.localPos + uuidFieldPos + 16);
            uuid = JSON.stringify(uuid);
        }

        box = mp4lib.createBox(boxtype, size, uuid);
        if (boxtype === "uuid") {
            this.localPos = box.read(data, this.localPos + mp4lib.fields.FIELD_INT8.getLength() * 16 + 8, this.localPos + size);
        } else {
            this.localPos = box.read(data, this.localPos + 8, this.localPos + size);
        }

        // in debug mode, sourcebuffer is copied to each box,
        // so any invalid deserializations may be found by comparing
        // source buffer with serialized box
        if (mp4lib.debug) {
            box.__sourceBuffer = data.subarray(this.localPos - box.size, this.localPos);
        }

        this.boxes.push(box);

        if (box.size <= 0 || box.size === null) {
            throw new mp4lib.ParseException('Problem on size of box ' + box.boxtype +
                ', parsing stopped to avoid infinite loop');
        }

        if (!box.boxtype) {
            throw new mp4lib.ParseException('Problem on unknown box, parsing stopped to avoid infinite loop');
        }
    }
    return this.localPos;
};

mp4lib.boxes.AudioSampleEntryContainerBox.prototype.write = function(data, pos) {
    mp4lib.boxes.AudioSampleEntryBox.prototype.write.call(this, data, pos);
    var i = 0;

    for (i = 0; i < this.boxes.length; i++) {
        this.localPos = this.boxes[i].write(data, this.localPos);
    }
    return this.localPos;
};

// --------------------------- mp4a ----------------------------------
mp4lib.boxes.MP4AudioSampleEntryBox = function(size) {
    mp4lib.boxes.AudioSampleEntryContainerBox.call(this, 'mp4a', size);
};

mp4lib.boxes.MP4AudioSampleEntryBox.prototype = Object.create(mp4lib.boxes.AudioSampleEntryContainerBox.prototype);
mp4lib.boxes.MP4AudioSampleEntryBox.prototype.constructor = mp4lib.boxes.MP4AudioSampleEntryBox;

//-------------------------- enca ------------------------------------
mp4lib.boxes.EncryptedAudioBox = function(size) {
    mp4lib.boxes.AudioSampleEntryContainerBox.call(this, 'enca', size);
};

mp4lib.boxes.EncryptedAudioBox.prototype = Object.create(mp4lib.boxes.AudioSampleEntryContainerBox.prototype);
mp4lib.boxes.EncryptedAudioBox.prototype.constructor = mp4lib.boxes.EncryptedAudioBox;

// --------------------------- esds ----------------------------
mp4lib.boxes.ESDBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'esds', size);
};

mp4lib.boxes.ESDBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.ESDBox.prototype.constructor = mp4lib.boxes.ESDBox;

mp4lib.boxes.ESDBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT8.getLength() * 2 + this.ES_length;
};

mp4lib.boxes.ESDBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.ES_tag = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.ES_length = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.ES_data = data.subarray(this.localPos, this.localPos + this.ES_length);
    this.localPos += this.ES_length;
    return this.localPos;
};

mp4lib.boxes.ESDBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.ES_tag);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.ES_length);
    this._writeBuffer(data, this.ES_data, this.ES_length);
    return this.localPos;
};

// --------------------------- stsz ----------------------------------
mp4lib.boxes.SampleSizeBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'stsz', size);
};

mp4lib.boxes.SampleSizeBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SampleSizeBox.prototype.constructor = mp4lib.boxes.SampleSizeBox;

mp4lib.boxes.SampleSizeBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2 + mp4lib.fields.FIELD_UINT32.getLength() * this.sample_count;
};

mp4lib.boxes.SampleSizeBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.sample_size = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.entries = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, this.sample_count);
    return this.localPos;
};

mp4lib.boxes.SampleSizeBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_size);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_count);
    for (i = 0; i < this.sample_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i]);
    }
    return this.localPos;
};

// ------------------------- pssh ------------------------------------
mp4lib.boxes.ProtectionSystemSpecificHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'pssh', size);
};

mp4lib.boxes.ProtectionSystemSpecificHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.ProtectionSystemSpecificHeaderBox.prototype.constructor = mp4lib.boxes.ProtectionSystemSpecificHeaderBox;

mp4lib.boxes.ProtectionSystemSpecificHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT8.getLength() * 16;
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
    this.size += mp4lib.fields.FIELD_UINT8.getLength() * this.DataSize;
};

mp4lib.boxes.ProtectionSystemSpecificHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.SystemID = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT8, 16);
    this.DataSize = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.Data = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT8, this.DataSize);
    return this.localPos;
};

mp4lib.boxes.ProtectionSystemSpecificHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;

    for (i = 0; i < 16; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT8, this.SystemID[i]);
    }
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.DataSize);
    for (i = 0; i < this.DataSize; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT8, this.Data[i]);
    }
    return this.localPos;
};

// ------------------------- saiz ------------------------------------
mp4lib.boxes.SampleAuxiliaryInformationSizesBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'saiz', size);
};

mp4lib.boxes.SampleAuxiliaryInformationSizesBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SampleAuxiliaryInformationSizesBox.prototype.constructor = mp4lib.boxes.SampleAuxiliaryInformationSizesBox;

mp4lib.boxes.SampleAuxiliaryInformationSizesBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    if (this.flags & 1) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2;
    }

    this.size += mp4lib.fields.FIELD_UINT8.getLength() + mp4lib.fields.FIELD_UINT32.getLength();

    if (this.default_sample_info_size === 0) {
        this.size += mp4lib.fields.FIELD_UINT8.getLength() * this.sample_count;
    }
};

mp4lib.boxes.SampleAuxiliaryInformationSizesBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.flags & 1) {
        this.aux_info_type = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.aux_info_type_parameter = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    this.default_sample_info_size = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    if (this.default_sample_info_size === 0) {
        this.sample_info_size = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT8, this.sample_count);
    }
    return this.localPos;
};

mp4lib.boxes.SampleAuxiliaryInformationSizesBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    if (this.flags & 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.aux_info_type);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.aux_info_type_parameter);
    }
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.default_sample_info_size);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_count);
    if (this.default_sample_info_size === 0) {
        for (i = 0; i < this.sample_count; i++) {
            this._writeData(data, mp4lib.fields.FIELD_UINT8, this.sample_info_size[i]);
        }
    }
    return this.localPos;
};

//------------------------- saio ------------------------------------
mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'saio', size);
};

mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox.prototype.constructor = mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox;

mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    if (this.flags & 1) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2;
    }
    this.size += mp4lib.fields.FIELD_UINT32.getLength(); /*entry_count size */
    if (this.version === 0) {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * this.entry_count;
    } else {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * this.entry_count;
    }
};

mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.flags & 1) {
        this.aux_info_type = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.aux_info_type_parameter = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }

    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    if (this.version === 0) {
        this.offset = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    } else {
        this.offset = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT64, this.entry_count);
    }
    return this.localPos;
};

mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    var i = 0;
    if (this.flags & 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.aux_info_type);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.aux_info_type_parameter);
    }
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    if (this.version === 0) {
        for (i = 0; i < this.entry_count; i++) {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.offset[i]);
        }
    } else {
        for (i = 0; i < this.entry_count; i++) {
            this._writeData(data, mp4lib.fields.FIELD_UINT64, this.offset[i]);
        }
    }
    return this.localPos;
};

//------------------------- sinf ------------------------------------
mp4lib.boxes.ProtectionSchemeInformationBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'sinf', size);
};

mp4lib.boxes.ProtectionSchemeInformationBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.ProtectionSchemeInformationBox.prototype.constructor = mp4lib.boxes.ProtectionSchemeInformationBox;

//------------------------ schi --------------------------------------
mp4lib.boxes.SchemeInformationBox = function(size) {
    mp4lib.boxes.ContainerBox.call(this, 'schi', size);
};

mp4lib.boxes.SchemeInformationBox.prototype = Object.create(mp4lib.boxes.ContainerBox.prototype);
mp4lib.boxes.SchemeInformationBox.prototype.constructor = mp4lib.boxes.SchemeInformationBox;

//------------------------ tenc --------------------------------------
mp4lib.boxes.TrackEncryptionBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tenc', size);
};

mp4lib.boxes.TrackEncryptionBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackEncryptionBox.prototype.constructor = mp4lib.boxes.TrackEncryptionBox;

mp4lib.boxes.TrackEncryptionBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_BIT24.getLength();
    this.size += mp4lib.fields.FIELD_UINT8.getLength();
    this.size += mp4lib.fields.FIELD_UINT8.getLength() * 16;
};

mp4lib.boxes.TrackEncryptionBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.default_IsEncrypted = this._readData(data, mp4lib.fields.FIELD_BIT24);
    this.default_IV_size = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.default_KID = this._readArrayFieldData(data, mp4lib.fields.FIELD_UINT8, 16);
    return this.localPos;
};

mp4lib.boxes.TrackEncryptionBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_BIT24, this.default_IsEncrypted);
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.default_IV_size);
    this._writeArrayData(data, mp4lib.fields.FIELD_UINT8, this.default_KID);
    return this.localPos;
};

//------------------------- schm -------------------------------------
mp4lib.boxes.SchemeTypeBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'schm', size);
};

mp4lib.boxes.SchemeTypeBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SchemeTypeBox.prototype.constructor = mp4lib.boxes.SchemeTypeBox;

mp4lib.boxes.SchemeTypeBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2;
    if (this.flags & 0x000001) {
        this.size += mp4lib.fields.FIELD_STRING.getLength(this.scheme_uri);
    }
};

mp4lib.boxes.SchemeTypeBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.scheme_type = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.scheme_version = this._readData(data, mp4lib.fields.FIELD_UINT32);
    if (this.flags & 0x000001) {
        this.scheme_uri = this._readData(data, mp4lib.fields.FIELD_STRING);
    }
    return this.localPos;
};

mp4lib.boxes.SchemeTypeBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.scheme_type);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.scheme_version);
    if (this.flags & 0x000001) {
        this._writeData(data, mp4lib.fields.FIELD_STRING, this.scheme_uri);
    }
    return this.localPos;
};

// --------------------------- elst ----------------------------------
mp4lib.boxes.EditListBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'elst', size);
    this.entries = [];
};

mp4lib.boxes.EditListBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.EditListBox.prototype.constructor = mp4lib.boxes.EditListBox;

mp4lib.boxes.EditListBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT32.getLength(); //entry_count size

    if (this.version === 1) {
        this.size += (mp4lib.fields.FIELD_UINT64.getLength() * 2 /*segment_duration and media_time size*/ +
            mp4lib.fields.FIELD_UINT16.getLength() * 2 /*media_rate_integer and media_rate_fraction size)*/ ) * this.entry_count;
    } else { // version==0
        this.size += (mp4lib.fields.FIELD_UINT32.getLength() * 2 /*segment_duration and media_time size*/ +
            mp4lib.fields.FIELD_UINT16.getLength() * 2 /*media_rate_integer and media_rate_fraction size)*/ ) * this.entry_count;
    }
};

mp4lib.boxes.EditListBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};
    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);

    for (i = 0; i < this.entry_count; i++) {
        struct = {};
        if (this.version === 1) {
            struct.segment_duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
            struct.media_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        } else { // version==0
            struct.segment_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
            struct.media_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        }
        struct.media_rate_integer = this._readData(data, mp4lib.fields.FIELD_UINT16);
        struct.media_rate_fraction = this._readData(data, mp4lib.fields.FIELD_UINT16);
        this.entries.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.EditListBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    for (i = 0; i < this.entry_count; i++) {

        if (this.version === 1) {
            this._writeData(data, mp4lib.fields.FIELD_UINT64, this.entries[i].segment_duration);
            this._writeData(data, mp4lib.fields.FIELD_UINT64, this.entries[i].media_time);
        } else { // version==0
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].segment_duration);
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].media_time);
        }
        this._writeData(data, mp4lib.fields.FIELD_UINT16, this.entries[i].media_rate_integer);
        this._writeData(data, mp4lib.fields.FIELD_UINT16, this.entries[i].media_rate_fraction);
    }
    return this.localPos;
};

// --------------------------- hmhd ----------------------------------
mp4lib.boxes.HintMediaHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'hmhd', size);
};

mp4lib.boxes.HintMediaHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.HintMediaHeaderBox.prototype.constructor = mp4lib.boxes.HintMediaHeaderBox;

mp4lib.boxes.HintMediaHeaderBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT16.getLength() * 2; //maxPDUsize and avgPDUsize size
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * 3; //maxbitrate, avgbitrate and reserved size
};

mp4lib.boxes.HintMediaHeaderBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.maxPDUsize = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.avgPDUsize = this._readData(data, mp4lib.fields.FIELD_UINT16);
    this.maxbitrate = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.avgbitrate = this._readData(data, mp4lib.fields.FIELD_UINT32);
    this.reserved = this._readData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.HintMediaHeaderBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.maxPDUsize);
    this._writeData(data, mp4lib.fields.FIELD_UINT16, this.avgPDUsize);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.maxbitrate);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.avgbitrate);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.reserved);
    return this.localPos;
};

// --------------------------- nmhd ----------------------------------
mp4lib.boxes.NullMediaHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'nmhd', size);
};

mp4lib.boxes.NullMediaHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.NullMediaHeaderBox.prototype.constructor = mp4lib.boxes.NullMediaHeaderBox;

// --------------------------- ctts ----------------------------------
mp4lib.boxes.CompositionOffsetBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'ctts', size);
    this.entries = [];
};

mp4lib.boxes.CompositionOffsetBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.CompositionOffsetBox.prototype.constructor = mp4lib.boxes.CompositionOffsetBox;

mp4lib.boxes.CompositionOffsetBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT32.getLength(); //entry_count size

    if (this.version === 0) {
        this.size += (mp4lib.fields.FIELD_UINT32.getLength() * 2 /*sample_count and sample_offset size*/ ) * this.entry_count;
    } else { // version===1
        this.size += (mp4lib.fields.FIELD_UINT32.getLength() /*sample_count size*/ + mp4lib.fields.FIELD_INT32.getLength()
            /*sample_offset size*/
        ) * this.entry_count;
    }
};

mp4lib.boxes.CompositionOffsetBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};
    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    for (i = 0; i < this.entry_count; i++) {
        struct = {};

        if (this.version === 0) {
            struct.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
            struct.sample_offset = this._readData(data, mp4lib.fields.FIELD_UINT32);
        } else { // version==1
            struct.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
            struct.sample_offset = this._readData(data, mp4lib.fields.FIELD_INT32);
        }
        this.entries.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.CompositionOffsetBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    for (i = 0; i < this.entry_count; i++) {
        if (this.version === 0) {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].sample_count);
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].sample_offset);
        } else { // version==1
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].sample_count);
            this._writeData(data, mp4lib.fields.FIELD_INT32, this.entries[i].sample_offset);
        }
    }
    return this.localPos;
};

// --------------------------- cslg ----------------------------------
mp4lib.boxes.CompositionToDecodeBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'cslg', size);
};

mp4lib.boxes.CompositionToDecodeBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.CompositionToDecodeBox.prototype.constructor = mp4lib.boxes.CompositionToDecodeBox;

mp4lib.boxes.CompositionToDecodeBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_INT32.getLength() * 5;
};

mp4lib.boxes.CompositionToDecodeBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    this.compositionToDTSShift = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.leastDecodeToDisplayDelta = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.greatestDecodeToDisplayDelta = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.compositionStartTime = this._readData(data, mp4lib.fields.FIELD_INT32);
    this.compositionEndTime = this._readData(data, mp4lib.fields.FIELD_INT32);
    return this.localPos;
};

mp4lib.boxes.CompositionToDecodeBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    this._writeData(data, mp4lib.fields.FIELD_INT32, this.compositionToDTSShift);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.leastDecodeToDisplayDelta);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.greatestDecodeToDisplayDelta);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.compositionStartTime);
    this._writeData(data, mp4lib.fields.FIELD_INT32, this.compositionEndTime);
    return this.localPos;
};

// --------------------------- stss ----------------------------------
mp4lib.boxes.SyncSampleBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'stss', size);
    this.entries = [];
};

mp4lib.boxes.SyncSampleBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.SyncSampleBox.prototype.constructor = mp4lib.boxes.SyncSampleBox;

mp4lib.boxes.SyncSampleBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength(); //entry_count size
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * this.entry_count; //entries size
};

mp4lib.boxes.SyncSampleBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};

    this.entry_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    for (i = 0; i < this.entry_count; i++) {
        struct = {};
        struct.sample_number = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.entries.push(struct);
    }
    return this.localPos;
};

mp4lib.boxes.SyncSampleBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry_count);
    for (i = 0; i < this.entry_count; i++) {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entries[i].sample_number);
    }
    return this.localPos;
};

// --------------------------- tref ----------------------------------
mp4lib.boxes.TrackReferenceBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tref', size);
};

mp4lib.boxes.TrackReferenceBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TrackReferenceBox.prototype.constructor = mp4lib.boxes.TrackReferenceBox;

mp4lib.boxes.TrackReferenceBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength() * this.track_IDs.length;
};

mp4lib.boxes.TrackReferenceBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    this.track_IDs = this._readArrayData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.TrackReferenceBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    this._writeArrayData(data, mp4lib.fields.FIELD_UINT32, this.track_IDs);
    return this.localPos;
};

//---------------------------- frma ----------------------------------
mp4lib.boxes.OriginalFormatBox = function(size) {
    mp4lib.boxes.Box.call(this, 'frma', size);
};

mp4lib.boxes.OriginalFormatBox.prototype = Object.create(mp4lib.boxes.Box.prototype);
mp4lib.boxes.OriginalFormatBox.prototype.constructor = mp4lib.boxes.OriginalFormatBox;

mp4lib.boxes.OriginalFormatBox.prototype.computeLength = function() {
    mp4lib.boxes.Box.prototype.computeLength.call(this);
    this.size += mp4lib.fields.FIELD_UINT32.getLength();
};

mp4lib.boxes.OriginalFormatBox.prototype.read = function(data, pos, end) {
    this.localPos = pos;
    this.localEnd = end;
    this.data_format = this._readData(data, mp4lib.fields.FIELD_UINT32);
    return this.localPos;
};

mp4lib.boxes.OriginalFormatBox.prototype.write = function(data, pos) {
    mp4lib.boxes.Box.prototype.write.call(this, data, pos);
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.data_format);
    return this.localPos;
};

// -------------------------------------------------------------------
// Microsoft Smooth Streaming specific boxes
// -------------------------------------------------------------------

// --------------------------- piff ----------------------------------
//PIFF Sample Encryption box
mp4lib.boxes.PiffSampleEncryptionBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'sepiff', size, [0xA2, 0x39, 0x4F, 0x52, 0x5A, 0x9B, 0x4F, 0x14, 0xA2, 0x44, 0x6C, 0x42, 0x7C, 0x64, 0x8D, 0xF4]);
};

mp4lib.boxes.PiffSampleEncryptionBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.PiffSampleEncryptionBox.prototype.constructor = mp4lib.boxes.PiffSampleEncryptionBox;

mp4lib.boxes.PiffSampleEncryptionBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    var i = 0,
        j = 0;

    this.size += mp4lib.fields.FIELD_UINT32.getLength(); //sample_count size
    if (this.flags & 1) {
        this.size += mp4lib.fields.FIELD_UINT8.getLength(); //IV_size size
    }
    for (i = 0; i < this.sample_count; i++) {
        this.size += 8; // InitializationVector size
        if (this.flags & 2) {
            this.size += mp4lib.fields.FIELD_UINT16.getLength(); // NumberOfEntries size
            for (j = 0; j < this.entry[i].NumberOfEntries; j++) {
                this.size += mp4lib.fields.FIELD_UINT16.getLength(); //BytesOfClearData size
                this.size += mp4lib.fields.FIELD_UINT32.getLength(); //BytesOfEncryptedData size
            }
        }
    }
};

mp4lib.boxes.PiffSampleEncryptionBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0,
        j = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT32, this.sample_count);
    if (this.flags & 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT8, this.IV_size);
    }
    for (i = 0; i < this.sample_count; i++) {
        this._writeBuffer(data, this.entry[i].InitializationVector, 8);

        if (this.flags & 2) {
            this._writeData(data, mp4lib.fields.FIELD_UINT16, this.entry[i].NumberOfEntries); // NumberOfEntries

            for (j = 0; j < this.entry[i].NumberOfEntries; j++) {
                this._writeData(data, mp4lib.fields.FIELD_UINT16, this.entry[i].clearAndCryptedData[j].BytesOfClearData); //BytesOfClearData
                this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].clearAndCryptedData[j].BytesOfEncryptedData); //BytesOfEncryptedData size
            }
        }
    }
    return this.localPos;
};

mp4lib.boxes.PiffSampleEncryptionBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        j = 0,
        clearAndCryptedStruct = {},
        struct = {};
    this.sample_count = this._readData(data, mp4lib.fields.FIELD_UINT32);
    if (this.flags & 1) {
        this.IV_size = this._readData(data, mp4lib.fields.FIELD_UINT8);
    }
    this.entry = [];
    for (i = 0; i < this.sample_count; i++) {
        struct = {};
        struct.InitializationVector = data.subarray(this.localPos, this.localPos + 8);
        this.localPos += 8; //InitializationVector size

        if (this.flags & 2) {
            struct.NumberOfEntries = this._readData(data, mp4lib.fields.FIELD_UINT16); // NumberOfEntries
            struct.clearAndCryptedData = [];
            for (j = 0; j < struct.NumberOfEntries; j++) {
                clearAndCryptedStruct = {};
                clearAndCryptedStruct.BytesOfClearData = this._readData(data, mp4lib.fields.FIELD_UINT16); //BytesOfClearData
                clearAndCryptedStruct.BytesOfEncryptedData = this._readData(data, mp4lib.fields.FIELD_UINT32); //BytesOfEncryptedData size
                struct.clearAndCryptedData.push(clearAndCryptedStruct);
            }
        }
        this.entry.push(struct);
    }
    return this.localPos;
};

//PIFF Track Encryption Box
mp4lib.boxes.PiffTrackEncryptionBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tepiff', size, [0x89, 0x74, 0xDB, 0xCE, 0x7B, 0xE7, 0x4C, 0x51, 0x84, 0xF9, 0x71, 0x48, 0xF9, 0x88, 0x25, 0x54]);
};

mp4lib.boxes.PiffTrackEncryptionBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.PiffTrackEncryptionBox.prototype.constructor = mp4lib.boxes.PiffTrackEncryptionBox;

//PIFF Protection System Specific Header Box
mp4lib.boxes.PiffProtectionSystemSpecificHeaderBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'psshpiff', size, [0xD0, 0x8A, 0x4F, 0x18, 0x10, 0xF3, 0x4A, 0x82, 0xB6, 0xC8, 0x32, 0xD8, 0xAB, 0xA1, 0x83, 0xD3]);
};

mp4lib.boxes.PiffProtectionSystemSpecificHeaderBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.PiffProtectionSystemSpecificHeaderBox.prototype.constructor = mp4lib.boxes.PiffProtectionSystemSpecificHeaderBox;

// --------------------------- tfdx -----------------------------
mp4lib.boxes.TfxdBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tfxd', size, [0x6D, 0x1D, 0x9B, 0x05, 0x42, 0xD5, 0x44, 0xE6, 0x80, 0xE2, 0x14, 0x1D, 0xAF, 0xF7, 0x57, 0xB2]);
};

mp4lib.boxes.TfxdBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TfxdBox.prototype.constructor = mp4lib.boxes.TfxdBox;

mp4lib.boxes.TfxdBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);
    if (this.version === 1) {
        this.size += mp4lib.fields.FIELD_UINT64.getLength() * 2;
    } else {
        this.size += mp4lib.fields.FIELD_UINT32.getLength() * 2;
    }
};

mp4lib.boxes.TfxdBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);

    if (this.version === 1) {
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.fragment_absolute_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT64, this.fragment_duration);
    } else {
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.fragment_absolute_time);
        this._writeData(data, mp4lib.fields.FIELD_UINT32, this.fragment_duration);
    }
    return this.localPos;
};

mp4lib.boxes.TfxdBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);

    if (this.version === 1) {
        this.fragment_absolute_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
        this.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
    } else {
        this.fragment_absolute_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
        this.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
    }
    return this.localPos;
};

// --------------------------- tfrf -----------------------------
mp4lib.boxes.TfrfBox = function(size) {
    mp4lib.boxes.FullBox.call(this, 'tfrf', size, [0xD4, 0x80, 0x7E, 0xF2, 0xCA, 0x39, 0x46, 0x95, 0x8E, 0x54, 0x26, 0xCB, 0x9E, 0x46, 0xA7, 0x9F]);
};

mp4lib.boxes.TfrfBox.prototype = Object.create(mp4lib.boxes.FullBox.prototype);
mp4lib.boxes.TfrfBox.prototype.constructor = mp4lib.boxes.TfrfBox;

mp4lib.boxes.TfrfBox.prototype.computeLength = function() {
    mp4lib.boxes.FullBox.prototype.computeLength.call(this);

    this.size += mp4lib.fields.FIELD_UINT8.getLength(); //fragment_count size
    if (this.version === 1) {
        this.size += (mp4lib.fields.FIELD_UINT64.getLength() * 2 /*fragment_absolute_time and fragment_duration size*/ ) * this.fragment_count;
    } else {
        this.size += (mp4lib.fields.FIELD_UINT32.getLength() * 2 /*fragment_absolute_time and fragment_duration size*/ ) * this.fragment_count;
    }
};

mp4lib.boxes.TfrfBox.prototype.write = function(data, pos) {
    mp4lib.boxes.FullBox.prototype.write.call(this, data, pos);
    var i = 0;
    this._writeData(data, mp4lib.fields.FIELD_UINT8, this.fragment_count);
    for (i = 0; i < this.fragment_count; i++) {
        if (this.version === 1) {
            this._writeData(data, mp4lib.fields.FIELD_UINT64, this.entry[i].fragment_absolute_time);
            this._writeData(data, mp4lib.fields.FIELD_UINT64, this.entry[i].fragment_duration);
        } else {
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].fragment_absolute_time);
            this._writeData(data, mp4lib.fields.FIELD_UINT32, this.entry[i].fragment_duration);
        }
    }
    return this.localPos;
};

mp4lib.boxes.TfrfBox.prototype.read = function(data, pos, end) {
    mp4lib.boxes.FullBox.prototype.read.call(this, data, pos, end);
    var i = 0,
        struct = {};
    this.fragment_count = this._readData(data, mp4lib.fields.FIELD_UINT8);
    this.entry = [];
    for (i = 0; i < this.fragment_count; i++) {
        struct = {};
        if (this.version === 1) {
            struct.fragment_absolute_time = this._readData(data, mp4lib.fields.FIELD_UINT64);
            struct.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT64);
        } else {
            struct.fragment_absolute_time = this._readData(data, mp4lib.fields.FIELD_UINT32);
            struct.fragment_duration = this._readData(data, mp4lib.fields.FIELD_UINT32);
        }
        this.entry.push(struct);
    }
    return this.localPos;
};

mp4lib.registerTypeBoxes();
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var mpegts = (function() {
    return {
        pes: {},
        si: {},
        binary: {},
        ts: {},
        Pts: {},
        aac: {},
        h264: {}
    };
}());

// This module is intended to work both on node.js and inside browser.
// Since these environments differ in a way modules are stored/accessed,
// we need to export the module in the environment-dependant way

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
    module.exports = mpegts; // node.js
else
    window.mpegts = mpegts; // browser
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.si.PSISection = function(table_id) {
    this.m_table_id = table_id;
    this.m_section_syntax_indicator = 1;
    this.m_section_length = mpegts.si.PSISection.prototype.SECTION_LENGTH;
    this.m_transport_stream_id = 0;
    this.m_version_number = 0;
    this.m_current_next_indicator = true;
    this.m_section_number = 0;
    this.m_last_section_number = 0;
    this.m_bValid = null;
};

mpegts.si.PSISection.prototype.parse = function(data) {
    this.m_bValid = false;

    var id = 0;

    var pointerField = data[id];

    //if pointerField = 0 payload data start immediately otherwise, shift pointerField value
    id = pointerField === 0 ? id + 1 : id + pointerField;

    this.m_table_id = data[id];
    id++;
    this.m_section_syntax_indicator = mpegts.binary.getBitFromByte(data[id], 0);
    this.m_section_length = mpegts.binary.getValueFrom2Bytes(data.subarray(id, id + 2), 4);
    id += 2;
    this.m_transport_stream_id = mpegts.binary.getValueFrom2Bytes(data.subarray(id, id + 2));
    id += 2;
    this.m_version_number = mpegts.binary.getValueFromByte(data[id], 2, 5);
    this.m_current_next_indicator = mpegts.binary.getBitFromByte(data[id], 7);
    id++;
    this.m_section_number = data[id];
    id++;
    this.m_last_section_number = data[id];

    /*if (nLength < (m_section_length + 3))
	{
		m_bComplete = false;
		SAFE_DELETE(m_pBytestream);
		m_pBytestream = new unsigned char[m_section_length + 3];
		memcpy(m_pBytestream, pBytestream, nLength);
		m_nSectionIndex = nLength;
		return;
	}

	m_nSectionIndex = 0;
	m_bComplete = true;*/
    this.m_bValid = true;

    return id;
};

mpegts.si.PSISection.prototype.getSectionLength = function() {
    return this.m_section_length;
};

mpegts.si.PSISection.prototype.SECTION_LENGTH = 9;
mpegts.si.PSISection.prototype.HEADER_LENGTH = 8;
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

// Sampling frequency dependent on sampling_frequency_index
mpegts.aac.SAMPLING_FREQUENCY = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];

mpegts.aac.getAudioSpecificConfig = function(data) { // data as Uint8Array

    // We need to parse the beginning of the adts_frame in order to get
    // object type, sampling frequency and channel configuration
    var profile = mpegts.binary.getValueFromByte(data[2], 0, 2);
    var sampling_frequency_index = mpegts.binary.getValueFromByte(data[2], 2, 4);
    var channel_configuration = mpegts.binary.getValueFrom2Bytes(data.subarray(2, 5), 7, 3);

    var audioSpecificConfig = new Uint8Array(2);

    // audioObjectType = profile = MPEG-4 Audio Object Type minus 1
    audioSpecificConfig[0] = (profile + 1) << 3;

    // samplingFrequencyIndex
    audioSpecificConfig[0] |= (sampling_frequency_index & 0x0E) >> 1;
    audioSpecificConfig[1] |= (sampling_frequency_index & 0x01) << 7;

    // channelConfiguration
    audioSpecificConfig[1] |= channel_configuration << 3;

    /*  code for HE AAC v2 to be tested

    var audioSpecificConfig = new Uint8Array(4);

    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    audioSpecificConfig[0] = 29 << 3;

    // samplingFrequencyIndex
    audioSpecificConfig[0] |= (sampling_frequency_index & 0x0E) >> 1;
    audioSpecificConfig[1] |= (sampling_frequency_index & 0x01) << 7;

    // channelConfiguration
    audioSpecificConfig[1] |= channel_configuration << 3;

    var extensionSamplingFrequencyIndex = 5;// in HE AAC Extension Sampling frequence

    audioSpecificConfig[1] |= extensionSamplingFrequencyIndex >> 1;

    audioSpecificConfig[2] = (extensionSamplingFrequencyIndex << 7) | ((profile+1) << 2);// origin object type equals to 2 => AAC Main Low Complexity
    audioSpecificConfig[3] = 0x0; //alignment bits

   */

    return audioSpecificConfig;
};

mpegts.aac.parseADTS = function(data, cts) { // data as Uint8Array, cts as an array of cts for each frame index

    var aacFrames = [],
        adtsHeader = {},
        aacFrame,
        adtsFrameIndex,
        i = 0;

    while (i < data.length) {
        // = adts_frame
        adtsFrameIndex = i;

        // == adts_fixed_header
        adtsHeader.syncword = (data[i] << 4) + ((data[i + 1] & 0xF0) >> 4);
        // adtsHeader.ID
        // adtsHeader.layer
        adtsHeader.protection_absent = data[i + 1] & 0x01;
        // adtsHeader.profile
        adtsHeader.sampling_frequency_index = (data[i + 2] & 0x3C) >> 2;
        // adtsHeader.private_bit
        adtsHeader.channel_configuration = ((data[i + 2] & 0x01) << 1) + ((data[i + 3] & 0xC0) >> 6);
        // adtsHeader.original_copy
        // adtsHeader.home

        // == adts_variable_header
        // adtsHeader.copyright_identification_bit
        // adtsHeader.copyright_identification_start
        adtsHeader.aac_frame_length = ((data[i + 3] & 0x03) << 11) + (data[i + 4] << 3) + ((data[i + 5] & 0xE0) >> 5);
        // adtsHeader.adts_buffer_fullness
        adtsHeader.number_of_raw_data_blocks_in_frame = (data[i + 6] & 0x03) >> 2;

        i += 7;

        if (adtsHeader.number_of_raw_data_blocks_in_frame === 0) {
            // == adts_error_check()
            if (adtsHeader.protection_absent === 0) {
                i += 2;
            }

            // == raw_data_block() => create AAC frame
            aacFrame = {};
            aacFrame.offset = i;
            aacFrame.length = adtsHeader.aac_frame_length - (i - adtsFrameIndex);

            if (cts && cts[adtsFrameIndex]) {
                aacFrame.cts = cts[adtsFrameIndex];
            }

            aacFrames.push(aacFrame);

            i += aacFrame.length;
        } else {
            // == adts_header_error_check
        }
    }

    return aacFrames;
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.ts.AdaptationField = function() {
    /** adaptation field fields */
    this.m_cAFLength = null;
    this.m_bDiscontinuityInd = null;
    this.m_bRAI = null;
    this.m_bESPriority = null;

    /** Optional fields flags */
    this.m_bPCRFlag = null;
    this.m_bOPCRFlag = null;
    this.m_bSplicingPointFlag = null;
    this.m_bPrivateDataFlag = null;
    this.m_bAdaptationFieldExtFlag = null;
};

mpegts.ts.AdaptationField.prototype.getLength = function() {
    return (this.m_cAFLength + 1);
};

mpegts.ts.AdaptationField.prototype.parse = function(data) {
    this.m_cAFLength = data[0];

    if (this.m_cAFLength === 0) {
        // = exactly 1 stuffing byte
        return;
    }

    var index = 1;

    this.m_bDiscontinuityInd = mpegts.binary.getBitFromByte(data[index], 0);
    this.m_bRAI = mpegts.binary.getBitFromByte(data[index], 1);
    this.m_bESPriority = mpegts.binary.getBitFromByte(data[index], 2);
    this.m_bPCRFlag = mpegts.binary.getBitFromByte(data[index], 3);
    this.m_bOPCRFlag = mpegts.binary.getBitFromByte(data[index], 4);
    this.m_bSplicingPointFlag = mpegts.binary.getBitFromByte(data[index], 5);
    this.m_bPrivateDataFlag = mpegts.binary.getBitFromByte(data[index], 6);
    this.m_bAdaptationFieldExtFlag = mpegts.binary.getBitFromByte(data[index], 7);

    //other flags are not useful for the conversion HLS => MP4
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.binary.readBytes = function(buf, pos, nbBytes) {
    var value = 0;
    for (var i = 0; i < nbBytes; i++) {
        value = value << 8;
        value = value + buf[pos];
        pos++;
    }
    return value;
};

/**
 * Returns a bit value from the given byte
 * @param data the input byte
 * @param bitIndex the bit index inside the byte (0=msb to 7=lsb)
 * @return the bit value as a boolean (0 => false, 1 => true)
 */
mpegts.binary.getBitFromByte = function(data, bitIndex) {
    var cMask = 0x00;
    cMask += (1 << (7 - bitIndex));

    return ((data & cMask) !== 0);
};

/**
 * Returns the value extracted from three consecutive bytes
 * @param pBytes the input bytes
 * @param msbIndex the index of the first bit to extract ( 0=msb to 15=lsb )
 * @param nbBits the number of bits to extract (if '-1' then extract up to the last bit)
 * @return the value of the extracted bits as an unsigned short, or 0xFFFFFFFF if a problem has occured
 */
mpegts.binary.getValueFrom3Bytes = function(pBytes, msbIndex /* = 0*/ , nbBits /* = -1*/ ) {
    if (typeof nbBits === "undefined") {
        nbBits = -1;
    }
    if (typeof msbIndex === "undefined") {
        msbIndex = 0;
    }
    var nbBits2 = nbBits == -1 ? -1 : (nbBits - (16 - msbIndex));
    var nbLsbShift = nbBits == -1 ? 0 : (8 - nbBits2);
    var cValue0 = mpegts.binary.getValueFromByte(pBytes[0], msbIndex);
    var cValue1 = mpegts.binary.getValueFromByte(pBytes[1]);
    var cValue2 = mpegts.binary.getValueFromByte(pBytes[2], 0, nbBits2, false);

    return ((((cValue0 << 16) & 0x00FF0000) | ((cValue1 << 8) & 0x0000FF00) | (cValue2 & 0x000000FF)) >> nbLsbShift);
};

/**
 * Returns the value extracted from two consecutive bytes
 * @param data the input bytes
 * @param msbIndex the index of the first bit to extract ( 0=msb to 15=lsb )
 * @param nbBits the number of bits to extract (if '-1' then extract up to the last bit)
 * @return the value of the extracted bits as an unsigned short, or 0xFFFF if a problem has occured
 */
mpegts.binary.getValueFrom2Bytes = function(data, msbIndex /* = 0*/ , nbBits /* = -1*/ ) {
    if (typeof nbBits === "undefined") {
        nbBits = -1;
    }
    if (typeof msbIndex === "undefined") {
        msbIndex = 0;
    }

    var nbBits1 = nbBits == -1 ? -1 : (nbBits - (8 - msbIndex));
    var nbLsbShift = nbBits == -1 ? 0 : (8 - nbBits1);
    var cValue0 = mpegts.binary.getValueFromByte(data[0], msbIndex);
    var cValue1 = mpegts.binary.getValueFromByte(data[1], 0, nbBits1, false);

    return ((((cValue0 << 8) & 0xFF00) | (cValue1 & 0x00FF)) >> nbLsbShift);
};

/**
 * Returns the value extracted from the given byte
 * @param data the input byte
 * @param msbIndex the index of the first bit to extract ( 0=msb to 7=lsb )
 * @param nbBits the number of bits to extract (if '-1' then extract up to the last bit)
 * @param bShift true if the bits have to be shifted to the right
 * @return the value of the extracted bits as an unsigned char, or 0xFF if a problem has occurred
 */
mpegts.binary.getValueFromByte = function(data, msbIndex /* = 0*/ , nbBits /* = -1*/ , bShift /* = true*/ ) {
    var cMask = 0x00;
    var i = 0;

    if (typeof nbBits === "undefined") {
        nbBits = -1;
    }
    if (typeof msbIndex === "undefined") {
        msbIndex = 0;
    }

    var lsbIndex = (nbBits == -1) ? 7 : (msbIndex + nbBits - 1);
    for (i = msbIndex; i <= lsbIndex; i++) {
        cMask += (1 << (7 - i));
    }

    var cValue = data & cMask;
    if (bShift || typeof bShift === "undefined") {
        cValue >>= (7 - lsbIndex);
    }
    return cValue;
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.h264.getSequenceHeader = function(data) { // data as Uint8Array

    var pos = -1,
        length = -1,
        i = 0,
        naluType,
        sequenceHeader = null,
        width = 0,
        height = 0;

    while (i < data.length) {
        if ((data[i] === 0x00) && (data[i + 1] === 0x00) && (data[i + 2] === 0x00) && (data[i + 3] === 0x01)) {

            naluType = data[i + 4] & 0x1F;

            // Start of SPS or PPS
            if ((naluType >= mpegts.h264.NALUTYPE_SPS) && (naluType <= mpegts.h264.NALUTYPE_PPS)) {
                // First NALU of this type => we start storing the sequence header
                if (pos === -1) {
                    pos = i;
                }

                // SPS => parse to get width and height
                if (naluType === mpegts.h264.NALUTYPE_SPS) {
                    var sps = mpegts.h264.parseSPS(data.subarray(i + 5)); // +5 => after nal_unit_type byte
                    width = (sps.pic_width_in_mbs_minus1 + 1) << 4;
                    height = (sps.pic_height_in_map_units_minus1 + 1) << 4;
                }
            } else if (pos > 0) {
                length = i - pos;
            }

            // Start of coded picture NALU
            if ((naluType === mpegts.h264.NALUTYPE_IDR) || (naluType === mpegts.h264.NALUTYPE_NONIDR)) {
                break;
            }

            i += 4;
        } else if ((data[i] === 0x00) && (data[i + 1] === 0x00) && (data[i + 2] === 0x01)) {
            if (pos > 0) {
                length = i - pos;
            }
            break;
        } else {
            i++;
        }
    }

    if ((pos === -1) || (length === -1)) {
        return null;
    }

    sequenceHeader = new Uint8Array(length);
    sequenceHeader.set(data.subarray(pos, pos + length));

    return {
        bytes: sequenceHeader,
        width: width,
        height: height
    };
};

mpegts.h264.read_ue = function(data, ctx) {

    var value = 1,
        temp = 0,
        numZeros = 0;

    ctx._bit = (ctx._byte >> ctx._bitPos) & 0x01;
    ctx._bitPos--;
    if (ctx._bitPos < 0) {
        ctx._byte = data[ctx._bytePos];
        ctx._bytePos++;
        ctx._bitPos = 7;
    }

    while (ctx._bit === 0) {
        numZeros++;
        value = value << 1;
        ctx._bit = (ctx._byte >> ctx._bitPos) & 0x01;
        ctx._bitPos--;
        if (ctx._bitPos < 0) {
            ctx._byte = data[ctx._bytePos];
            ctx._bytePos++;
            ctx._bitPos = 7;
        }
    }


    value -= 1;
    temp = 0;
    if (numZeros) {
        while (numZeros > 0) {
            ctx._bit = (ctx._byte >> ctx._bitPos) & 0x01;
            ctx._bitPos--;
            temp = (temp << 1) + ctx._bit;
            numZeros--;
            if (ctx._bitPos < 0) {
                ctx._byte = data[ctx._bytePos];
                ctx._bytePos++;
                ctx._bitPos = 7;
            }
        }
    }
    value = value + temp;

    return value;
};

mpegts.h264.read_flag = function(data, ctx) {

    var value = 0;

    ctx._bit = (ctx._byte >> ctx._bitPos) & 0x01;
    ctx._bitPos--;
    if (ctx._bitPos < 0) {
        ctx._byte = data[ctx._bytePos];
        ctx._bytePos++;
        ctx._bitPos = 7;
    }
    value = ctx._bit;

    return value;
};


mpegts.h264.parseSPS = function(data) {

    var sps = {
            profile_idc: 0,
            constraint_set0_flag: 0,
            constraint_set1_flag: 0,
            constraint_set2_flag: 0,
            constraint_set3_flag: 0,
            level_idc: 0,
            seq_parameter_set_id: 0,
            chroma_format_idc: 0,
            separate_colour_plane_flag: 0,
            bit_depth_luma_minus8: 0,
            bit_depth_chroma_minus8: 0,
            qpprime_y_zero_transform_bypass_flag: 0,
            seq_scaling_matrix_present_flag: 0,
            log2_max_frame_num_minus4: 0,
            pic_order_cnt_type: 0,
            log2_max_pic_order_cnt_lsb_minus4: 0,
            num_ref_frames: 0,
            gaps_in_frame_num_value_allowed_flag: 0,
            pic_width_in_mbs_minus1: 0,
            pic_height_in_map_units_minus1: 0
        },

        ctx = {
            _byte: 0,
            _bit: 0,
            _bytePos: 0,
            _bitPos: 0
        };


    ctx._bytePos = ctx._bitPos = 0;

    // profile_idc - u(8)
    ctx._byte = data[ctx._bytePos];
    ctx._bytePos++;
    sps.profile_idc = ctx._byte;

    // constraint_set_flag (0/1/2/3 + reserved bits) - u(8)
    ctx._byte = data[ctx._bytePos];
    ctx._bytePos++;
    sps.constraint_set0_flag = (ctx._byte & 0x80) >> 7;
    sps.constraint_set1_flag = (ctx._byte & 0x40) >> 6;
    sps.constraint_set2_flag = (ctx._byte & 0x20) >> 5;
    sps.constraint_set3_flag = (ctx._byte & 0x10) >> 4;

    // level_idc - u(8)
    ctx._byte = data[ctx._bytePos];
    ctx._bytePos++;
    sps.level_idc = ctx._byte;

    // sps_id - ue(v)
    ctx._bitPos = 7;
    sps.seq_parameter_set_id = mpegts.h264.read_ue(data, ctx);

    if ((sps.profileIdc == 100) ||
        (sps.profileIdc == 110) ||
        (sps.profileIdc == 122) ||
        (sps.profileIdc == 244) ||
        (sps.profileIdc == 44) ||
        (sps.profileIdc == 83) ||
        (sps.profileIdc == 86)) {

        // chroma_format_idc - ue(v)
        sps.chroma_format_idc = mpegts.h264.read_ue(data, ctx);

        if (sps.chroma_format_idc === 3) {
            // separate_colour_plane_flag - u(1)
            sps.separate_colour_plane_flag = mpegts.h264.read_flag(data, ctx);
        }

        // bit_depth_luma_minus8 - ue(v)
        sps.bit_depth_luma_minus8 = mpegts.h264.read_ue(data, ctx);

        // bit_depth_chroma_minus8 - ue(v)
        sps.bit_depth_chroma_minus8 = mpegts.h264.read_ue(data, ctx);

        // qpprime_y_zero_transform_bypass_flag - u(1)
        sps.qpprime_y_zero_transform_bypass_flag = mpegts.h264.read_flag(data, ctx);

        // seq_scaling_matrix - u(1)
        sps.seq_scaling_matrix_present_flag = mpegts.h264.read_flag(data, ctx);

        if (sps.seq_scaling_matrix_present_flag === 1) {
            // NOT IMPLEMENTED
            ////console.log("H.264 SPS parsing: (seq_scaling_matrix_present_flag = 1) not implemented");
        }
    }

    // log2_max_frame_num_minus4 - ue(v)
    sps.log2_max_frame_num_minus4 = mpegts.h264.read_ue(data, ctx);

    // pic_order_cnt_type - ue(v)
    sps.pic_order_cnt_type = mpegts.h264.read_ue(data, ctx);

    if (sps.pic_order_cnt_type === 0) {
        // log2_max_pic_order_cnt_lsb_minus4 - ue(v)
        sps.log2_max_pic_order_cnt_lsb_minus4 = mpegts.h264.read_ue(data, ctx);
    } else if (sps.pic_order_cnt_type === 1) {
        // NOT IMPLEMENTED
        ////console.log("H.264 SPS parsing: (log2_max_pic_order_cnt_lsb_minus4 = 1) not implemented");
    }

    // num_ref_frames - ue(v)
    sps.num_ref_frames = mpegts.h264.read_ue(data, ctx);

    // gaps_in_frame_num_value_allowed_flag - u(1)
    sps.gaps_in_frame_num_value_allowed_flag = mpegts.h264.read_flag(data, ctx);

    // pic_width_in_mbs_minus1 - ue(v)
    sps.pic_width_in_mbs_minus1 = mpegts.h264.read_ue(data, ctx);

    // pic_height_in_map_units_minus1 - ue(v)
    sps.pic_height_in_map_units_minus1 = mpegts.h264.read_ue(data, ctx);

    return sps;
};

mpegts.h264.bytestreamToMp4 = function(data) { // data as Uint8Array

    var i = 0,
        length = data.length,
        startCodeIndex = -1,
        naluSize = 0;

    while (i < length) {
        if ((data[i] === 0x00) && (data[i + 1] === 0x00) && (data[i + 2] === 0x00) && (data[i + 3] === 0x01)) {

            if (startCodeIndex >= 0) {
                naluSize = (i - startCodeIndex - 4); // 4 = start code length or NALU-size field length
                data[startCodeIndex] = (naluSize & 0xFF000000) >> 24;
                data[startCodeIndex + 1] = (naluSize & 0x00FF0000) >> 16;
                data[startCodeIndex + 2] = (naluSize & 0x0000FF00) >> 8;
                data[startCodeIndex + 3] = (naluSize & 0x000000FF);
            }

            startCodeIndex = i;
            i += 4;
        } else {
            i++;
        }
    }

    // Last NAL unit
    naluSize = (i - startCodeIndex - 4); // 4 = start code length or NALU-size field length
    data[startCodeIndex] = (naluSize & 0xFF000000) >> 24;
    data[startCodeIndex + 1] = (naluSize & 0x00FF0000) >> 16;
    data[startCodeIndex + 2] = (naluSize & 0x0000FF00) >> 8;
    data[startCodeIndex + 3] = (naluSize & 0x000000FF);

};

mpegts.h264.isIDR = function(data) { // data as Uint8Array
    var i = 0,
        naluType;

    while (i < data.length) {
        if ((data[i] === 0x00) && (data[i + 1] === 0x00) && (data[i + 2] === 0x00) && (data[i + 3] === 0x01)) {
            naluType = data[i + 4] & 0x1F;
            if (naluType === mpegts.h264.NALUTYPE_IDR) {
                return true;
            }
            i += 4;
        } else {
            i++;
        }
    }
    return false;
};

mpegts.h264.NALUTYPE_NONIDR = 1;
mpegts.h264.NALUTYPE_IDR = 5;
mpegts.h264.NALUTYPE_SEI = 6;
mpegts.h264.NALUTYPE_SPS = 7;
mpegts.h264.NALUTYPE_PPS = 8;
mpegts.h264.NALUTYPE_AU_DELIMITER = 9;
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.si.PAT = function() {
    mpegts.si.PSISection.call(this, mpegts.si.PAT.prototype.TABLE_ID);
    this.m_listOfProgramAssociation = [];
    this.m_network_pid = null;
};

mpegts.si.PAT.prototype = Object.create(mpegts.si.PSISection.prototype);
mpegts.si.PAT.prototype.constructor = mpegts.si.PAT;

mpegts.si.PAT.prototype.parse = function(data) {
    var id = mpegts.si.PSISection.prototype.parse.call(this, data);
    id++;

    if (!this.m_bValid) {
        ////console.log("PSI Parsing Problem during PAT parsing!");
        return;
    }
    this.m_bValid = false;

    if (this.m_table_id !== this.TABLE_ID) {
        return;
    }

    var remainingBytes = this.getSectionLength() - this.SECTION_LENGTH;

    while (remainingBytes >= 4) {
        var prog = new mpegts.si.ProgramAssociation(data.subarray(id, id + 4));

        if (prog.getProgramNumber() === 0) {
            // Network PID
            this.m_network_pid = prog.getProgramMapPid();
        } else {
            this.m_listOfProgramAssociation.push(prog);
        }
        remainingBytes -= 4;
        id += 4;
    }

    this.m_bValid = true;
};

/**
 * returns the PID of the PMT associated to the first program
 *
 * @return the PID of the PMT associated to the first program
 */
mpegts.si.PAT.prototype.getPmtPid = function() {
    var pid = mpegts.ts.TsPacket.prototype.UNDEFINED_PID;

    if (this.m_listOfProgramAssociation.length >= 1) {
        var prog = this.m_listOfProgramAssociation[0];
        pid = prog.getProgramMapPid();
    }

    return pid;
};

mpegts.si.PAT.prototype.TABLE_ID = 0x00;
mpegts.si.PAT.prototype.PID = 0x00;


mpegts.si.ProgramAssociation = function(data) {
    this.m_program_number = 0;
    this.m_program_map_pid = 0;
    this.parse(data);
};

mpegts.si.ProgramAssociation.prototype.getProgramNumber = function() {
    return this.m_program_number;
};

mpegts.si.ProgramAssociation.prototype.getProgramMapPid = function() {
    return this.m_program_map_pid;
};

mpegts.si.ProgramAssociation.prototype.getLength = function() {
    return 4;
};

/**
 * Parse the ProgramAssociation from given stream
 */
mpegts.si.ProgramAssociation.prototype.parse = function(data) {
    this.m_program_number = mpegts.binary.getValueFrom2Bytes(data.subarray(0, 2));
    this.m_program_map_pid = mpegts.binary.getValueFrom2Bytes(data.subarray(2, 4), 3, 13);
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.pes.PesPacket = function() {
    this.m_cStreamID = null;
    this.m_nPESPacketLength = null;
    this.m_cPESScramblingCtrl = null;
    this.m_bPESpriority = null;
    this.m_bDataAlignement = null;
    this.m_bCopyright = null;
    this.m_bOriginalOrCopy = null;
    this.m_cPES_header_data_length = null;
    this.m_cPTS_DTS_flags = null;
    this.m_bESCR_flag = null;
    this.m_bES_rate_flag = null;
    this.m_bDSM_trick_mode_flag = null;
    this.m_bAdditional_copy_info_flag = null;
    this.m_bPES_CRC_flag = null;
    this.m_bPES_extension_flag = null;
    this.m_pPTS = null;
    this.m_pDTS = null;
    this.m_pESCR = null;
    this.m_ES_rate = null;
    this.m_DSM_trick_mode = null;
    this.m_Additional_copy_info = null;
    this.m_PES_CRC = null;
    this.m_cNbStuffingBytes = null;
    this.m_pPESExtension = null;
    this.m_pPrivateData = null;
    this.m_payloadArray = null;
    this.m_nPayloadLength = null;
    this.m_bDirty = null;
    this.m_bValid = false;
};

mpegts.pes.PesPacket.prototype.parse = function(data) {
    var index = 0;
    this.m_nLength = data.length;
    // packet_start_code_prefix
    var nStartCode = mpegts.binary.getValueFrom3Bytes(data.subarray(index, index + 3));
    if (nStartCode !== this.START_CODE_PREFIX) {
        ////console.log("PES Packet start code not define!");
        return;
    }

    index = 3; // 3 = packet_start_code_prefix length

    // stream_id
    this.m_cStreamID = data[index];
    index++;

    // PES_packet_length
    this.m_nPESPacketLength = mpegts.binary.getValueFrom2Bytes(data.subarray(index, index + 2));
    index += 2;

    // Padding bytes
    if (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_PADDING_STREAM) {
        // Padding bytes => no more field, no payload
        this.m_bValid = true;
        return;
    }

    // PES_packet_data_byte (no optional header)
    if (!this.hasOptionalPESHeader()) {
        //NAN => to Validate!!!!
        // no more header field, only payload
        this.m_payloadArray = data.subarray(index + mpegts.pes.PesPacket.prototype.FIXED_HEADER_LENGTH);
        this.m_nPayloadLength = this.m_nLength - mpegts.pes.PesPacket.prototype.FIXED_HEADER_LENGTH;
        this.m_bValid = true;
        return;
    }

    // Optional PES header
    var reserved = mpegts.binary.getValueFromByte(data[index], 0, 2);
    if (reserved !== 0x02) {
        return;
    }
    this.m_cPESScramblingCtrl = mpegts.binary.getValueFromByte(data[index], 2, 2);
    this.m_bPESpriority = mpegts.binary.getBitFromByte(data[index], 4);
    this.m_bDataAlignement = mpegts.binary.getBitFromByte(data[index], 5);
    this.m_bCopyright = mpegts.binary.getBitFromByte(data[index], 6);
    this.m_bOriginalOrCopy = mpegts.binary.getBitFromByte(data[index], 7);
    index++;

    // 7 flags
    this.m_cPTS_DTS_flags = mpegts.binary.getValueFromByte(data[index], 0, 2);
    this.m_bESCR_flag = mpegts.binary.getBitFromByte(data[index], 2);
    this.m_bES_rate_flag = mpegts.binary.getBitFromByte(data[index], 3);
    this.m_bDSM_trick_mode_flag = mpegts.binary.getBitFromByte(data[index], 4);
    this.m_bAdditional_copy_info_flag = mpegts.binary.getBitFromByte(data[index], 5);
    this.m_bPES_CRC_flag = mpegts.binary.getBitFromByte(data[index], 6);
    this.m_bPES_extension_flag = mpegts.binary.getBitFromByte(data[index], 7);
    index++;

    // PES_header_data_length
    this.m_cPES_header_data_length = (data[index] & 0xFF);
    index++;

    // PTS
    if ((this.m_cPTS_DTS_flags & mpegts.pes.PesPacket.prototype.FLAG_PTS) == mpegts.pes.PesPacket.prototype.FLAG_PTS) {
        this.m_pPTS = new mpegts.Pts(data.subarray(index, index + 5));
        index += 5;
    }

    // DTS
    if ((this.m_cPTS_DTS_flags & mpegts.pes.PesPacket.prototype.FLAG_DTS) == mpegts.pes.PesPacket.prototype.FLAG_DTS) {
        this.m_pDTS = new mpegts.Pts(data.subarray(index, index + 5));
        index += 5;
    }

    // ESCR
    if (this.m_bESCR_flag) {
        //NAN => to Complete
        //this.m_pESCR = new PCR(m_pBytestream + index);
        index += 6;
    }

    // ES_rate
    if (this.m_bES_rate_flag) {
        this.m_ES_rate = mpegts.binary.getValueFrom3Bytes(data.subarray(index, index + 3), 1, 22);
        index += 3;
    }

    // DSM_trick_mode
    if (this.m_bDSM_trick_mode_flag) {
        this.m_DSM_trick_mode = data[index];
        index++;
    }

    // Additional_copy_info
    if (this.m_bAdditional_copy_info_flag) {
        this.m_Additional_copy_info = data[index];
        index++;
    }

    // PES_CRC
    if (this.m_bPES_CRC_flag) {
        this.m_PES_CRC = mpegts.binary.getValueFrom2Bytes(data.subarray(index, index + 2));
        index += 2;
    }

    // PES_extension
    if (this.m_bPES_extension_flag) {
        //NAN => to Complete
        //this.m_pPESExtension = new PESExtension(m_pBytestream + index, m_cPES_header_data_length);
        //index += m_pPESExtension->getLength();
    }

    // Stuffing bytes
    var uiHeaderLength = mpegts.pes.PesPacket.prototype.FIXED_HEADER_LENGTH + mpegts.pes.PesPacket.prototype.FIXED_OPTIONAL_HEADER_LENGTH + this.m_cPES_header_data_length;
    this.m_cNbStuffingBytes = uiHeaderLength - index;
    index += this.m_cNbStuffingBytes;

    // Payload
    this.m_nPayloadLength = this.m_nLength - uiHeaderLength;
    this.m_payloadArray = data.subarray(uiHeaderLength, uiHeaderLength + this.m_nPayloadLength);

    this.m_bValid = true;
};


/**
 * Returns true if header contains optional PES header.
 * @return true if header contains optional PES header
 */
mpegts.pes.PesPacket.prototype.hasOptionalPESHeader = function() {

    if ((this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_PROGRAM_STREAM_MAP) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_PADDING_STREAM) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_PRIVATE_STREAM_2) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_ECM_STREAM) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_EMM_STREAM) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_PROGRAM_STREAM_DIRECTORY) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_DSMCC_STREAM) ||
        (this.m_cStreamID === mpegts.ts.TsPacket.prototype.STREAM_ID_H2221_TYPE_E_STREAM)) {
        return false;
    }

    return true;
};

mpegts.pes.PesPacket.prototype.getHeaderLength = function() {
    return mpegts.pes.PesPacket.prototype.FIXED_HEADER_LENGTH +
        mpegts.pes.PesPacket.prototype.FIXED_OPTIONAL_HEADER_LENGTH +
        this.m_cPES_header_data_length;
};

mpegts.pes.PesPacket.prototype.getPayload = function() {
    return this.m_payloadArray;
};

mpegts.pes.PesPacket.prototype.getPts = function() {
    return this.m_pPTS;
};

mpegts.pes.PesPacket.prototype.getDts = function() {
    return this.m_pDTS;
};

/** The start code prefix */
mpegts.pes.PesPacket.prototype.START_CODE_PREFIX = 0x000001;
/** The first fixed header fields length (start_code + stream_id + PES_packet_length fields) **/
mpegts.pes.PesPacket.prototype.FIXED_HEADER_LENGTH = 6;
/** The first optional fixed header fields length **/
mpegts.pes.PesPacket.prototype.FIXED_OPTIONAL_HEADER_LENGTH = 3;
/** PTS_DTS_flags possible values */
mpegts.pes.PesPacket.prototype.FLAG_DTS = 0x01;
mpegts.pes.PesPacket.prototype.FLAG_PTS = 0x02;
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.si.PMT = function() {
    mpegts.si.PSISection.call(this, mpegts.si.PMT.prototype.TABLE_ID);
    this.m_listOfComponents = [];
    this.m_PCR_PID = null;
    this.m_program_info_length = null;
};

mpegts.si.PMT.prototype = Object.create(mpegts.si.PSISection.prototype);
mpegts.si.PMT.prototype.constructor = mpegts.si.PMT;

mpegts.si.PMT.prototype.parse = function(data) {
    var id = mpegts.si.PSISection.prototype.parse.call(this, data);
    id++;

    if (!this.m_bValid) {
        ////console.log("PSI Parsing Problem during PMT parsing!");
        return;
    }
    this.m_bValid = false;

    // Check table_id field value
    if (this.m_table_id !== this.TABLE_ID) {
        return;
    }

    var remainingBytes = this.getSectionLength() - this.SECTION_LENGTH;

    // check if we have almost PCR_PID and program_info_length fields
    if (remainingBytes < 4) {
        return;
    }

    this.m_PCR_PID = mpegts.binary.getValueFrom2Bytes(data.subarray(id, id + 2), 3);
    id += 2;
    this.m_program_info_length = mpegts.binary.getValueFrom2Bytes(data.subarray(id, id + 2), 4);
    id += 2;

    // Parse program descriptors
    id += this.m_program_info_length;

    // Parse ES descriptions
    remainingBytes = (this.m_section_length - this.SECTION_LENGTH - 4 - this.m_program_info_length);
    var pESDescription = null;
    while (remainingBytes > 0) {
        pESDescription = new mpegts.si.ESDescription(data.subarray(id, id + remainingBytes));
        this.m_listOfComponents.push(pESDescription);
        remainingBytes -= pESDescription.getLength();
        id += pESDescription.getLength();
    }

    this.m_bValid = true;
};

mpegts.si.PMT.prototype.TABLE_ID = 0x02;

mpegts.si.PMT.prototype.gStreamTypes = [
    /*  0 - 0x00 */
    {
        name: "Reserved",
        value: 0x00,
        desc: "ITU-T | ISO/IEC Reserved"
    },
    /*  1 - 0x01 */
    {
        name: "MPEG1-Video",
        value: 0xE0,
        desc: "ISO/IEC 11172-2 Video"
    },
    /*  2 - 0x02 */
    {
        name: "MPEG2-Video",
        value: 0xE0,
        desc: "ITU-T Rec. H.262 | ISO/IEC 13818-2 Video or ISO/IEC 11172-2 constrained parameter video stream"
    },
    /*  3 - 0x03 */
    {
        name: "MPEG1-Audio",
        value: 0xC0,
        desc: "ISO/IEC 11172-3 Audio"
    },
    /*  4 - 0x04 */
    {
        name: "MPEG2-Audio",
        value: 0xC0,
        desc: "ISO/IEC 13818-3 Audio"
    },
    /*  5 - 0x05 */
    {
        name: "PRIVATE_SECTIONS",
        value: 0xBD,
        desc: "ITU-T Rec. H.222.0 | ISO/IEC 13818-1 private_sections"
    },
    /*  6 - 0x06 */
    {
        name: "PRIVATE",
        value: 0xBD,
        desc: "ITU-T Rec. H.222.0 | ISO/IEC 13818-1 PES packets containing private data"
    },
    /*  7 - 0x07 */
    {
        name: "MHEG",
        value: 0xF3,
        desc: "ISO/IEC 13522 MHEG"
    },
    /*  8 - 0x08 */
    {
        name: "MPEG1-DSM-CC",
        value: 0xF2,
        desc: "ITU-T Rec. H.222.0 | ISO/IEC 13818-1 Annex A DSM-CC"
    },
    /*  9 - 0x09 */
    {
        name: "H.222.1",
        value: 0xF4,
        desc: "ITU-T Rec. H.222.1"
    },
    /* 10 - 0x0A */
    {
        name: "DSM-CC_A",
        value: 0xF4,
        desc: "ISO/IEC 13818-6 type A"
    },
    /* 11 - 0x0B */
    {
        name: "DSM-CC_B",
        value: 0xF5,
        desc: "ISO/IEC 13818-6 type B"
    },
    /* 12 - 0x0C */
    {
        name: "DSM-CC_C",
        value: 0xF6,
        desc: "ISO/IEC 13818-6 type C"
    },
    /* 13 - 0x0D */
    {
        name: "DSM-CC_D",
        value: 0xF7,
        desc: "ISO/IEC 13818-6 type D"
    },
    /* 14 - 0x0E */
    {
        name: "Auxiliary",
        value: 0x00,
        desc: "ITU-T Rec. H.222.0 | ISO/IEC 13818-1 auxiliary"
    },
    /* 15 - 0x0F */
    {
        name: "MPEG2-AAC-ADTS",
        value: 0xC0,
        desc: "ISO/IEC 13818-7 Audio with ADTS transport syntax"
    },
    /* 16 - 0x10 */
    {
        name: "MPEG4-Video",
        value: 0xE0,
        desc: "ISO/IEC 14496-2 Visual"
    },
    /* 17 - 0x11 */
    {
        name: "MPEG4-AAC-LATM",
        value: 0xC0,
        desc: "ISO/IEC 14496-3 Audio with the LATM transport syntax as defined in ISO/IEC 14496-3/AMD-1"
    },
    /* 18 - 0x12 */
    {
        name: "MPEG4-SL",
        value: 0xFA,
        desc: "ISO/IEC 14496-1 SL-packetized stream or FlexMux stream carried in PES packets"
    },
    /* 19 - 0x13 */
    {
        name: "MPEG4-SL",
        value: 0xFA,
        desc: "ISO/IEC 14496-1 SL-packetized stream or FlexMux stream carried in ISO/IEC14496_sections"
    },
    /* 20 - 0x14 */
    {
        name: "DSM-CC_SDP",
        value: 0x00,
        desc: "ISO/IEC 13818-6 Synchronized Download Protocol"
    },
    /* 21 - 0x15 */
    {
        name: "META_PES",
        value: 0xFC,
        desc: "Metadata carried in PES packets"
    },
    /* 22 - 0x16 */
    {
        name: "META_SECTIONS",
        value: 0xFC,
        desc: "Metadata carried in metadata_sections"
    },
    /* 23 - 0x17 */
    {
        name: "META_DSM-CC",
        value: 0xFC,
        desc: "Metadata carried in ISO/IEC 13818-6 Data Carousel"
    },
    /* 24 - 0x18 */
    {
        name: "META_DSM-CC",
        value: 0xFC,
        desc: "Metadata carried in ISO/IEC 13818-6 Object Carousel"
    },
    /* 25 - 0x19 */
    {
        name: "META_DSM-CC",
        value: 0xFC,
        desc: "Metadata carried in ISO/IEC 13818-6 Synchronized Download Protocol"
    },
    /* 26 - 0x1A */
    {
        name: "MPEG2-IPMP",
        value: 0x00,
        desc: "IPMP stream (defined in ISO/IEC 13818-11, MPEG-2 IPMP)"
    },
    /* 27 - 0x1B */
    {
        name: "H.264",
        value: 0xE0,
        desc: "AVC video stream as defined in ITU-T Rec. H.264 | ISO/IEC 14496-10 Video"
    },
    /* 28 - 0x1C */
    {
        name: "MPEG4AAC",
        value: 0xC0,
        desc: "ISO/IEC 14496-3 Audio, without using any additional transport syntax, such as DST, ALS and SLS"
    },
    /* 29 - 0x1D */
    {
        name: "MPEG4Text",
        value: 0x00,
        desc: "ISO/IEC 14496-17 Text"
    },
    /* 30 - 0x1E */
    {
        name: "Aux. Video (23002-3)",
        value: 0x1E,
        desc: "Auxiliary video stream as defined in ISO/IEC 23002-3"
    },
    /* 31 - 0x1F */
    {
        name: "H.264-SVC",
        value: 0xE0,
        desc: "SVC video sub-bitstream of a video stream as defined in the Annex G of ITU-T Rec. H.264 | ISO/IEC 14496-10 Video"
    },
    /* 32 - 0x20 */
    {
        name: "H.264-MVC",
        value: 0xE0,
        desc: "MVC video sub-bitstream of a video stream as defined in the Annex H of ITU-T Rec. H.264 | ISO/IEC 14496-10 Video"
    },
    /* 33 - 0x21 */
    {
        name: "Reserved1",
        value: 0x00,
        desc: "TBC Reserved"
    },
    /* 34 - 0x22 */
    {
        name: "Reserved2",
        value: 0x00,
        desc: "TBC Reserved"
    },
    /* 35 - 0x23 */
    {
        name: "Reserved3",
        value: 0x00,
        desc: "TBC Reserved"
    },
    /* 36 - 0x24 */
    {
        name: "HEVC",
        value: 0xE0,
        desc: "ITU.-T Rec H.26x | ISO/IEC 23008-2 video stream"
    }
];

mpegts.si.PMT.prototype.MPEG2_VIDEO_STREAM_TYPE = 0x02;
mpegts.si.PMT.prototype.AVC_VIDEO_STREAM_TYPE = 0x1B;
mpegts.si.PMT.prototype.MPEG1_AUDIO_STREAM_TYPE = 0x03;
mpegts.si.PMT.prototype.MPEG2_AUDIO_STREAM_TYPE = 0x04;
mpegts.si.PMT.prototype.AAC_AUDIO_STREAM_TYPE = 0x11;
mpegts.si.PMT.prototype.AC3_AUDIO_STREAM_TYPE = 0x06;
mpegts.si.PMT.prototype.SUB_STREAM_TYPE = 0x06;

mpegts.si.PMT.prototype.STREAM_TYPE_MP1V = 0x01;
mpegts.si.PMT.prototype.STREAM_TYPE_MP2V = 0x02;
mpegts.si.PMT.prototype.STREAM_TYPE_MP1A = 0x03;
mpegts.si.PMT.prototype.STREAM_TYPE_MP2A = 0x04;
mpegts.si.PMT.prototype.STREAM_TYPE_PRIVATE = 0x06;
mpegts.si.PMT.prototype.STREAM_TYPE_TELETEXT = 0x06;
mpegts.si.PMT.prototype.STREAM_TYPE_DVBSUBTITLE = 0x06;
mpegts.si.PMT.prototype.STREAM_TYPE_AC3 = 0x06;
mpegts.si.PMT.prototype.STREAM_TYPE_MP2AAC_ADTS = 0x0F;
mpegts.si.PMT.prototype.STREAM_TYPE_MP4AAC_LATM = 0x11;
mpegts.si.PMT.prototype.STREAM_TYPE_H264 = 0x1B;
mpegts.si.PMT.prototype.STREAM_TYPE_MP4AAC = 0x1C;
mpegts.si.PMT.prototype.STREAM_TYPE_AUX_23002_3 = 0x1E;
mpegts.si.PMT.prototype.STREAM_TYPE_SVC = 0x1F;
mpegts.si.PMT.prototype.STREAM_TYPE_MVC = 0x20;
mpegts.si.PMT.prototype.STREAM_TYPE_HEVC = 0x24;


mpegts.si.ESDescription = function(data) {
    /** ES description fields */
    this.m_stream_type = null;
    this.m_elementary_PID = null;
    this.m_ES_info_length = null;
    this.parse(data);
};

/**
 * Gets the stream type associated to this ES
 * @return the stream type associated to this ES
 */
mpegts.si.ESDescription.prototype.getStreamType = function() {
    return this.m_stream_type;
};

/**
 * Gets the pid on which this ES may be found
 * @return the pid on which this ES may be found
 */
mpegts.si.ESDescription.prototype.getPID = function() {
    return this.m_elementary_PID;
};

/**
 * Returns the elementary stream description length
 * @return the elementary stream description length
 */
mpegts.si.ESDescription.prototype.getLength = function() {
    return 5 + this.m_ES_info_length;
};

/**
 * Parse the ESDescription from given bytestream
 * @param the bytestream to parse
 * @return the bytestream length
 */
mpegts.si.ESDescription.prototype.parse = function(data) {
    this.m_stream_type = data[0];
    this.m_elementary_PID = mpegts.binary.getValueFrom2Bytes(data.subarray(1, 3), 3);
    this.m_ES_info_length = mpegts.binary.getValueFrom2Bytes(data.subarray(3, 5), 4);
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

mpegts.Pts = function(data) {

    var low,
        high;

    //initialize an unsigned 64 bits long number
    //this.m_lPTS = goog.math.Long.fromNumber(0);

    //=> PTS is defined on 33 bits
    //=> In the first byte, bit number 2 to 4 is useful
    var bits3230 = data[0] >> 1 & 0x7;

    //thirty-third bit in the high member
    high = bits3230 >> 2;
    //32 and 31 bits in th low member, shift by 30 bits
    low = ((bits3230 & 0x3) << 30) >>> 0; //=> http://www.codeonastick.com/2013/06/javascript-convert-signed-integer-to.html unsigned int!!!!!!

    //=> In the second byte, all the bits are useful
    var bits2922 = data[1];
    low = (low | (bits2922 << 22)) >>> 0; //=> http://www.codeonastick.com/2013/06/javascript-convert-signed-integer-to.html unsigned int!!!!!!

    //=> In the third byte, bit number 2 to 8 is useful
    var bits2115 = data[2] >> 1;
    low = (low | (bits2115 << 15)) >>> 0; //=> http://www.codeonastick.com/2013/06/javascript-convert-signed-integer-to.html unsigned int!!!!!!

    //=> In the fourth byte, all the bits are useful
    var bits1407 = data[3];
    low = (low | (bits1407 << 7)) >>> 0; //=> http://www.codeonastick.com/2013/06/javascript-convert-signed-integer-to.html unsigned int!!!!!!

    //=> In the fifth byte, bit number 2 to 8 is useful
    var bits0701 = data[4] >> 1;
    low = (low | bits0701) >>> 0; //=> http://www.codeonastick.com/2013/06/javascript-convert-signed-integer-to.html unsigned int!!!!!!

    this.m_lPTS = goog.math.Long.fromBits(low, high).toNumber();
    this.m_fPTS = this.m_lPTS / mpegts.Pts.prototype.SYSTEM_CLOCK_FREQUENCY;
};

/**
 * Returns the PTS value in units of system clock frequency.
 * @return the PTS value in units of system clock frequency
 */
mpegts.Pts.prototype.getValue = function() {
    return this.m_lPTS;
};

/**
 * Returns the PTS value in seconds.
 * @return the PTS value in seconds
 */
mpegts.Pts.prototype.getValueInSeconds = function() {
    return this.m_fPTS;
};

mpegts.Pts.prototype.SYSTEM_CLOCK_FREQUENCY = 90000;
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
mpegts.ts.TsPacket = function() {
    this.m_cSync = null;
    this.m_bTransportError = null;
    this.m_bPUSI = null;
    this.m_bTransportPriority = null;
    this.m_nPID = null;
    this.m_cTransportScramblingCtrl = null;
    this.m_cAdaptationFieldCtrl = null;
    this.m_cContinuityCounter = null;
    this.m_pAdaptationField = null;
    this.m_payloadArray = null;
    this.m_cPayloadLength = null;
    this.m_bDirty = null;
    this.m_time = null;
    this.m_arrivalTime = null;
    this.m_bIgnored = null;
};

mpegts.ts.TsPacket.prototype.parse = function(data) {
    var byteId = 0;
    this.m_cSync = data[byteId];
    if (this.m_cSync !== this.SYNC_WORD) {
        ////console.log("TS Packet Malformed!");
        return;
    }

    byteId++;

    this.m_bTransportError = mpegts.binary.getBitFromByte(data[byteId], 0);
    this.m_bPUSI = mpegts.binary.getBitFromByte(data[byteId], 1);
    this.m_bTransportPriority = mpegts.binary.getBitFromByte(data[byteId], 2);
    this.m_nPID = mpegts.binary.getValueFrom2Bytes(data.subarray(byteId, byteId + 2), 3, 13);

    byteId += 2;

    this.m_cTransportScramblingCtrl = mpegts.binary.getValueFromByte(data[byteId], 0, 2);
    this.m_cAdaptationFieldCtrl = mpegts.binary.getValueFromByte(data[byteId], 2, 2);
    this.m_cContinuityCounter = mpegts.binary.getValueFromByte(data[byteId], 4, 4);

    byteId++;

    // Adaptation field
    // NAN => to Validate
    if (this.m_cAdaptationFieldCtrl & 0x02) {
        // Check adaptation field length before parsing
        var cAFLength = data[byteId];
        if ((cAFLength + byteId) >= this.TS_PACKET_SIZE) {
            ////console.log("TS Packet Size Problem!");
            return;
        }
        this.m_pAdaptationField = new mpegts.ts.AdaptationField();
        this.m_pAdaptationField.parse(data.subarray(byteId));
        byteId += this.m_pAdaptationField.getLength();
    }

    // Check packet validity
    if (this.m_cAdaptationFieldCtrl === 0x00) {
        ////console.log("TS Packet is invalid!");
        return;
    }

    // Payload
    if (this.m_cAdaptationFieldCtrl & 0x01) {
        this.m_cPayloadLength = this.TS_PACKET_SIZE - byteId;
        this.m_payloadArray = data.subarray(byteId, byteId + this.m_cPayloadLength);
    }
};

mpegts.ts.TsPacket.prototype.getPid = function() {
    return this.m_nPID;
};

mpegts.ts.TsPacket.prototype.getPayload = function() {
    return this.m_payloadArray;
};

mpegts.ts.TsPacket.prototype.getPayloadLength = function() {
    return this.m_cPayloadLength;
};

mpegts.ts.TsPacket.prototype.getPusi = function() {
    return this.m_bPUSI;
};

mpegts.ts.TsPacket.prototype.hasAdaptationFieldOnly = function() {
    return (this.m_cAdaptationFieldCtrl === 0x02);
};

mpegts.ts.TsPacket.prototype.SYNC_WORD = 0x47;
mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE = 188;
mpegts.ts.TsPacket.prototype.UNDEFINED_PID = 0xFFFF;
mpegts.ts.TsPacket.prototype.PAT_PID = 0;
mpegts.ts.TsPacket.prototype.STREAM_ID_PROGRAM_STREAM_MAP = 0xBC;
mpegts.ts.TsPacket.prototype.STREAM_ID_PADDING_STREAM = 0xBE;
mpegts.ts.TsPacket.prototype.STREAM_ID_PADDING_STREAM = 0xBE;
mpegts.ts.TsPacket.prototype.STREAM_ID_PRIVATE_STREAM_2 = 0xBF;
mpegts.ts.TsPacket.prototype.STREAM_ID_ECM_STREAM = 0xF0;
mpegts.ts.TsPacket.prototype.STREAM_ID_EMM_STREAM = 0xF1;
mpegts.ts.TsPacket.prototype.STREAM_ID_DSMCC_STREAM = 0xF2;
mpegts.ts.TsPacket.prototype.STREAM_ID_H2221_TYPE_E_STREAM = 0xF8;
mpegts.ts.TsPacket.prototype.STREAM_ID_PROGRAM_STREAM_DIRECTORY = 0xFF;
/*   Copyright (C) 2011,2012,2013,2014 John Kula */

/*
    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.

    All trademarks and service marks contained within this document are
    property of their respective owners.

    Version 2014.07.23

    Updates may be found at: http:\\www.darkwavetech.com

*/

/*jslint browser:true */

/* This function returns the browser and version number by using the navigator.useragent object */

function fingerprint_browser() {
    "use strict";
    var userAgent,
        name,
        version;

    try {

        userAgent = navigator.userAgent.toLowerCase();

        if (/msie (\d+\.\d+);/.test(userAgent)) { //test for MSIE x.x;
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            if (userAgent.indexOf("trident/6") > -1) {
                version = 10;
            }
            if (userAgent.indexOf("trident/5") > -1) {
                version = 9;
            }
            if (userAgent.indexOf("trident/4") > -1) {
                version = 8;
            }
            name = "Internet Explorer";
        } else if (userAgent.indexOf("trident/7") > -1) { //IE 11+ gets rid of the legacy 'MSIE' in the user-agent string;
            version = 11;
            name = "Internet Explorer";
        }  else if (/edge[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Firefox/x.x or Firefox x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Edge";
        }  else if (/firefox[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Firefox/x.x or Firefox x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Firefox";
        } else if (/opera[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Opera/x.x or Opera x.x (ignoring remaining decimal places);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Opera";
        } else if (/chrome[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Chrome/x.x or Chrome x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Chrome";
        } else if (/version[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Version/x.x or Version x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Safari";
        } else if (/rv[\/\s](\d+\.\d+)/.test(userAgent)) { //test for rv/x.x or rv x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Mozilla";
        } else if (/mozilla[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Mozilla/x.x or Mozilla x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Mozilla";
        } else if (/binget[\/\s](\d+\.\d+)/.test(userAgent)) { //test for BinGet/x.x or BinGet x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (BinGet)";
        } else if (/curl[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Curl/x.x or Curl x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (cURL)";
        } else if (/java[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Java/x.x or Java x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (Java)";
        } else if (/libwww-perl[\/\s](\d+\.\d+)/.test(userAgent)) { //test for libwww-perl/x.x or libwww-perl x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (libwww-perl)";
        } else if (/microsoft url control -[\s](\d+\.\d+)/.test(userAgent)) { //test for Microsoft URL Control - x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (Microsoft URL Control)";
        } else if (/peach[\/\s](\d+\.\d+)/.test(userAgent)) { //test for Peach/x.x or Peach x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (Peach)";
        } else if (/php[\/\s](\d+\.\d+)/.test(userAgent)) { //test for PHP/x.x or PHP x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (PHP)";
        } else if (/pxyscand[\/\s](\d+\.\d+)/.test(userAgent)) { //test for pxyscand/x.x or pxyscand x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (pxyscand)";
        } else if (/pycurl[\/\s](\d+\.\d+)/.test(userAgent)) { //test for pycurl/x.x or pycurl x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (PycURL)";
        } else if (/python-urllib[\/\s](\d+\.\d+)/.test(userAgent)) { //test for python-urllib/x.x or python-urllib x.x (ignoring remaining digits);
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Library (Python URLlib)";
        } else if (/appengine-google/.test(userAgent)) { //test for AppEngine-Google;
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Cloud (Google AppEngine)";
        } else if (/trident/.test(userAgent)) { //test for Trident;
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Trident";
        } else if (/adventurer/.test(userAgent)) { //test for Orange Adventurer;
            version = Number(RegExp.$1); // capture x.x portion and store as a number
            name = "Adventurer";
        } else {
            version = "unknown";
            name = "unknown";
        }
    } catch (err) {
        name = "error";
        version = "error";
    }

    return {
        name: name.replace(/\s+/g, ''),
        version: version
    };
}
/*   Copyright (C) 2011,2012,2013,2014 John Kula */

/*
    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.

    All trademarks and service marks contained within this document are
    property of their respective owners.

    Version 2014.07.23

    Updates may be found at: http:\\www.darkwavetech.com

*/

/*jslint browser:true */

/* This function returns the operating system and number of bits by looking at the navigator.useragent and navigator.platform objects */

function fingerprint_os() {
    "use strict";

    var userAgent,
        platform,
        name,
        bits,
        os = {
            name: "",
            bits: ""
        };

    try {
        /* navigator.userAgent is supported by all major browsers */
        userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.indexOf("windows nt 10.0") !== -1) {
            name = "Windows 10";
        } else if (userAgent.indexOf("windows nt 6.3") !== -1) {
            name = "Windows 8.1";
        } else if (userAgent.indexOf("windows nt 6.2") !== -1) {
            name = "Windows 8";
        } else if (userAgent.indexOf("windows nt 6.1") !== -1) {
            name = "Windows 7";
        } else if (userAgent.indexOf("windows nt 6.0") !== -1) {
            name = "Windows Vista/Windows Server 2008";
        } else if (userAgent.indexOf("windows nt 5.2") !== -1) {
            name = "Windows XP x64/Windows Server 2003";
        } else if (userAgent.indexOf("windows nt 5.1") !== -1) {
            name = "Windows XP";
        } else if (userAgent.indexOf("windows nt 5.01") !== -1) {
            name = "Windows 2000, Service Pack 1 (SP1)";
        } else if (userAgent.indexOf("windows xp") !== -1) {
            name = "Windows XP";
        } else if (userAgent.indexOf("windows 2000") !== -1) {
            name = "Windows 2000";
        } else if (userAgent.indexOf("windows nt 5.0") !== -1) {
            name = "Windows 2000";
        } else if (userAgent.indexOf("windows nt 4.0") !== -1) {
            name = "Windows NT 4.0";
        } else if (userAgent.indexOf("windows nt") !== -1) {
            name = "Windows NT 4.0";
        } else if (userAgent.indexOf("winnt4.0") !== -1) {
            name = "Windows NT 4.0";
        } else if (userAgent.indexOf("winnt") !== -1) {
            name = "Windows NT 4.0";
        } else if (userAgent.indexOf("windows me") !== -1) {
            name = "Windows ME";
        } else if (userAgent.indexOf("win 9x 4.90") !== -1) {
            name = "Windows ME";
        } else if (userAgent.indexOf("windows 98") !== -1) {
            name = "Windows 98";
        } else if (userAgent.indexOf("win98") !== -1) {
            name = "Windows 98";
        } else if (userAgent.indexOf("windows 95") !== -1) {
            name = "Windows 95";
        } else if (userAgent.indexOf("windows_95") !== -1) {
            name = "Windows 95";
        } else if (userAgent.indexOf("win95") !== -1) {
            name = "Windows 95";
        } else if (userAgent.indexOf("ce") !== -1) {
            name = "Windows CE";
        } else if (userAgent.indexOf("win16") !== -1) {
            name = "Windows 3.11";
        } else if (userAgent.indexOf("iemobile") !== -1) {
            name = "Windows Mobile";
        } else if (userAgent.indexOf("wm5 pie") !== -1) {
            name = "Windows Mobile";
        } else if (userAgent.indexOf("windows phone 10.0") !== -1) {
            name = "Windows Phone 10";
        } else if (userAgent.indexOf("windows") !== -1) {
            name = "Windows (Unknown Version)";
        } else if (userAgent.indexOf("openbsd") !== -1) {
            name = "Open BSD";
        } else if (userAgent.indexOf("sunos") !== -1) {
            name = "Sun OS";
        } else if (userAgent.indexOf("ubuntu") !== -1) {
            name = "Ubuntu";
        } else if (userAgent.indexOf("ipad") !== -1) {
            name = "iOS (iPad)";
        } else if (userAgent.indexOf("ipod") !== -1) {
            name = "iOS (iTouch)";
        } else if (userAgent.indexOf("iphone") !== -1) {
            name = "iOS (iPhone)";
        } else if (userAgent.indexOf("mac os x beta") !== -1) {
            name = "Mac O SX Beta";
        } else if (userAgent.indexOf("mac os x 10") !== -1) {
            if (/mac os x 10_(\d+)\_(\d+)/.test(userAgent)) {
                name = "Mac OS X 10." + RegExp.$1;
            } else {
                name = "Mac OS X 10";
            }
        } else if (userAgent.indexOf("mac os x") !== -1) {
            name = "Mac OS X";
        } else if (userAgent.indexOf("mac_68000") !== -1) {
            name = "Mac OS Classic (68000)";
        } else if (userAgent.indexOf("68K") !== -1) {
            name = "Mac OS Classic (68000)";
        } else if (userAgent.indexOf("mac_powerpc") !== -1) {
            name = "Mac OS Classic (PowerPC)";
        } else if (userAgent.indexOf("ppc mac") !== -1) {
            name = "Mac OS Classic (PowerPC)";
        } else if (userAgent.indexOf("macintosh") !== -1) {
            name = "Mac OS Classic";
        } else if (userAgent.indexOf("googletv") !== -1) {
            name = "Android (GoogleTV)";
        } else if (userAgent.indexOf("xoom") !== -1) {
            name = "Android (Xoom)";
        } else if (userAgent.indexOf("htc_flyer") !== -1) {
            name = "Android (HTC Flyer)";
        } else if (userAgent.indexOf("android") !== -1) {
            name = "Android";
        } else if (userAgent.indexOf("symbian") !== -1) {
            name = "Symbian";
        } else if (userAgent.indexOf("series60") !== -1) {
            name = "Symbian (Series 60)";
        } else if (userAgent.indexOf("series70") !== -1) {
            name = "Symbian (Series 70)";
        } else if (userAgent.indexOf("series80") !== -1) {
            name = "Symbian (Series 80)";
        } else if (userAgent.indexOf("series90") !== -1) {
            name = "Symbian (Series 90)";
        } else if (userAgent.indexOf("x11") !== -1) {
            name = "UNIX";
        } else if (userAgent.indexOf("nix") !== -1) {
            name = "UNIX";
        } else if (userAgent.indexOf("linux") !== -1) {
            name = "Linux";
        } else if (userAgent.indexOf("qnx") !== -1) {
            name = "QNX";
        } else if (userAgent.indexOf("os/2") !== -1) {
            name = "IBM OS/2";
        } else if (userAgent.indexOf("beos") !== -1) {
            name = "BeOS";
        } else if (userAgent.indexOf("blackberry95") !== -1) {
            name = "Blackberry (Storm 1/2)";
        } else if (userAgent.indexOf("blackberry97") !== -1) {
            name = "Blackberry (Bold)";
        } else if (userAgent.indexOf("blackberry96") !== -1) {
            name = "Blackberry (Tour)";
        } else if (userAgent.indexOf("blackberry89") !== -1) {
            name = "Blackberry (Curve 2)";
        } else if (userAgent.indexOf("blackberry98") !== -1) {
            name = "Blackberry (Torch)";
        } else if (userAgent.indexOf("playbook") !== -1) {
            name = "Blackberry (Playbook)";
        } else if (userAgent.indexOf("wnd.rim") !== -1) {
            name = "Blackberry (IE/FF Emulator)";
        } else if (userAgent.indexOf("blackberry") !== -1) {
            name = "Blackberry";
        } else if (userAgent.indexOf("palm") !== -1) {
            name = "Palm OS";
        } else if (userAgent.indexOf("webos") !== -1) {
            name = "WebOS";
        } else if (userAgent.indexOf("hpwos") !== -1) {
            name = "WebOS (HP)";
        } else if (userAgent.indexOf("blazer") !== -1) {
            name = "Palm OS (Blazer)";
        } else if (userAgent.indexOf("xiino") !== -1) {
            name = "Palm OS (Xiino)";
        } else if (userAgent.indexOf("kindle") !== -1) {
            name = "Kindle";
        } else if (userAgent.indexOf("wii") !== -1) {
            name = "Nintendo (Wii)";
        } else if (userAgent.indexOf("nintendo ds") !== -1) {
            name = "Nintendo (DS)";
        } else if (userAgent.indexOf("playstation 3") !== -1) {
            name = "Sony (Playstation Console)";
        } else if (userAgent.indexOf("playstation portable") !== -1) {
            name = "Sony (Playstation Portable)";
        } else if (userAgent.indexOf("webtv") !== -1) {
            name = "MSN TV (WebTV)";
        } else if (userAgent.indexOf("inferno") !== -1) {
            name = "Inferno";
        } else {
            name = "Unknown";
        }

        /* navigator.platform is supported by all major browsers */
        platform = navigator.platform.toLowerCase();

        if (platform.indexOf("x64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("x86_64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("x86-64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("win64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("x64;") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("amd64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("wow64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("x64_64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("ia65") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("sparc64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("ppc64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("irix64") !== -1) {
            bits = "64";
        } else if (userAgent.indexOf("irix64") !== -1) {
            bits = "64";
        } else {
            bits = "32";
        }
    } catch (err) {
        name = "error";
        bits = "error";
    }

    return {
        name: name.replace(/\s+/g, ''),
        bits: "x" + bits
    };
}
/**
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * @constructs MediaPlayer
 *
 */
/*jshint -W020 */
MediaPlayer = function () {

//#region Private attributes/properties
    ///////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////// PRIVATE ////////////////////////////////////////////
    var VERSION_DASHJS = "1.2.0",
        VERSION = '1.4.0',
        GIT_TAG = '5695140',
        BUILD_DATE = '2016-8-18_10:31:35',
        context = new MediaPlayer.di.Context(), // default context
        system = new dijon.System(), // dijon system instance
        initialized = false,
        debugController = null, // use to handle key pressed and download debug file
        videoModel, // model to manipulate hte domVideoNode
        videoBitrates = null, //bitrates list of video
        audioBitrates = null,
        videoQualityChanged = [],
        audioQualityChanged = [],
        error = null,
        warning = null,
        defaultAudioLang = 'und',
        defaultSubtitleLang = 'und',
        subtitlesEnabled = false,
        initialQuality = {
            video: -1,
            audio: -1
        },
        streamController = null,
        resetting = false,
        playing = false,
        autoPlay = true,
        source = null, // current source played
        scheduleWhilePaused = true, // should we buffer while in pause
        plugins = {};
//#endregion

//#region Private methods
    var _isPlayerInitialized = function () {
        if (!initialized) {
            throw new Error('MediaPlayer not initialized !!!');
        }
    };

    var _isVideoModelInitialized = function () {
        if (!videoModel.getElement()) {
            throw new Error('MediaPlayer.play(): Video element not attached to MediaPlayer');
        }
    };

    var _isSourceInitialized = function () {
        if (!source) {
            throw new Error('MediaPlayer.play(): Source not attached to MediaPlayer');
        }
    };

    var _play = function () {
        _isPlayerInitialized();
        _isVideoModelInitialized();
        _isSourceInitialized();

        if (!MediaPlayer.hasMediaSourceExtension()) {
            this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.CAPABILITY_ERR_MEDIASOURCE, "MediaSource extension not supported by the browser");
            return;
        }

        playing = true;

        this.metricsModel.addSession(null, source.url, videoModel.getElement().loop, null, "MediaPlayer.js_" + this.getVersion());

        // streamController Initialization
        if (!streamController) {
            streamController = system.getObject('streamController');
            streamController.setVideoModel(videoModel);
            streamController.setAutoPlay(autoPlay);
        }

        streamController.setDefaultAudioLang(defaultAudioLang);
        streamController.setDefaultSubtitleLang(defaultSubtitleLang);
        streamController.enableSubtitles(subtitlesEnabled);
        // TODO restart here !!!
        streamController.load(source);
        system.mapValue("scheduleWhilePaused", scheduleWhilePaused);
        system.mapOutlet("scheduleWhilePaused", "stream");

    };

    // player state and intitialization
    var _isReady = function () {
        return initialized && videoModel.getElement() && source && !resetting;
    };

    var _doAutoPlay = function () {
        if (_isReady()) {
            _play.call(this);
        }
    };

    // event disptach
    var _dispatchBitrateEvent = function (type, value) {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent(type, false, false, {
            type: value.streamType,
            bitrate: value.switchedQuality,
            representationId: value.representationId,
            time: videoModel.getCurrentTime(),
            width: value.width,
            height: value.height
        });
        videoModel.getElement().dispatchEvent(event);
    };


    var _metricAdded = function (e) {
        var event;
        switch (e.data.metric) {
            case "ManifestReady":
                _isPlayerInitialized();
                this.debug.log("[MediaPlayer] ManifestReady");
                videoBitrates = this.metricsExt.getBitratesForType('video');
                this.debug.log("[MediaPlayer] video bitrates: " + JSON.stringify(videoBitrates));
                event = document.createEvent("CustomEvent");
                event.initCustomEvent('manifest_loaded', false, false, {});
                videoModel.getElement().dispatchEvent(event);
                break;
            case "RepresentationSwitch":
                _isPlayerInitialized();
                if (e.data.stream == "video") {
                    videoBitrates = this.metricsExt.getBitratesForType(e.data.stream);
                    if (videoBitrates) {
                        _dispatchBitrateEvent('download_bitrate', {
                            streamType: e.data.stream,
                            switchedQuality: videoBitrates[e.data.value.lto],
                            representationId: e.data.value.to,
                            width: this.metricsExt.getVideoWidthForRepresentation(e.data.value.to),
                            height: this.metricsExt.getVideoHeightForRepresentation(e.data.value.to)
                        });
                        this.debug.log("[MediaPlayer][" + e.data.stream + "] send download_bitrate - b=" + videoBitrates[e.data.value.lto]);
                    }
                } else if (e.data.stream == "audio") {
                    audioBitrates = this.metricsExt.getBitratesForType(e.data.stream);
                    if (audioBitrates) {
                        _dispatchBitrateEvent('download_bitrate', {
                            streamType: e.data.stream,
                            switchedQuality: audioBitrates[e.data.value.to],
                            representationId: e.data.value.to,
                            width: this.metricsExt.getVideoWidthForRepresentation(e.data.value.to),
                            height: this.metricsExt.getVideoHeightForRepresentation(e.data.value.to)
                        });
                        this.debug.log("[MediaPlayer][" + e.data.stream + "] send download_bitrate - b=" + videoBitrates[e.data.value.lto]);
                    }
                }
                break;
            case "BufferedSwitch":
                _isPlayerInitialized();
                if (e.data.stream == "video") {
                    videoQualityChanged.push({
                        streamType: e.data.stream,
                        mediaStartTime: e.data.value.mt,
                        switchedQuality: videoBitrates[e.data.value.lto],
                        representationId: e.data.value.to,
                        width: this.metricsExt.getVideoWidthForRepresentation(e.data.value.to),
                        height: this.metricsExt.getVideoHeightForRepresentation(e.data.value.to)
                    });
                } else if (e.data.stream == "audio") {
                    audioQualityChanged.push({
                        streamType: e.data.stream,
                        mediaStartTime: e.data.value.mt,
                        switchedQuality: audioBitrates[e.data.value.lto],
                        representationId: e.data.value.to,
                        width: this.metricsExt.getVideoWidthForRepresentation(e.data.value.to),
                        height: this.metricsExt.getVideoHeightForRepresentation(e.data.value.to)
                    });
                }
                break;
            case "BufferLevel":
                //this.debug.log("[MediaPlayer] BufferLevel = "+e.data.value.level+" for type = "+e.data.stream);
                event = document.createEvent("CustomEvent");
                event.initCustomEvent('bufferLevel_updated', false, false, {
                    type: e.data.stream,
                    level: e.data.value.level
                });
                videoModel.getElement().dispatchEvent(event);
                break;
            case "State":
                //this.debug.log("[MediaPlayer] State = "+e.data.value.current+" for type = "+e.data.stream);
                event = document.createEvent("CustomEvent");
                event.initCustomEvent('state_changed', false, false, {
                    type: e.data.stream,
                    state: e.data.value.current
                });
                videoModel.getElement().dispatchEvent(event);
                break;
        }
    };

    var _onError = function (e) {
        error = e.data;
    };

    var _onWarning = function (e) {
        warning = e.data;
    };

    var _cleanStreamTab = function (streamTab, idToRemove) {
        var i = 0;

        for (i = idToRemove.length - 1; i >= 0; i -= 1) {
            streamTab.splice(i, 1);
        }
    };

    var _detectPlayBitrateChange = function (streamTab) {
        var currentTime = videoModel.getCurrentTime(),
            currentSwitch = null,
            idToRemove = [],
            i = 0;

        for (i = 0; i < streamTab.length; i += 1) {
            currentSwitch = streamTab[i];
            if (currentTime >= currentSwitch.mediaStartTime) {
                _dispatchBitrateEvent('play_bitrate', currentSwitch);
                this.debug.log("[MediaPlayer][" + currentSwitch.streamType + "] send play_bitrate - b=" + currentSwitch.switchedQuality + ", t=" + currentSwitch.mediaStartTime + "(" + videoModel.getPlaybackRate() + ")");
                // And remove when it's played
                idToRemove.push(i);
            }
        }

        _cleanStreamTab(streamTab, idToRemove);
    };


    /**
     * Usefull to dispatch event of quality changed
     */
    var _onTimeupdate = function () {
        // If not in playing state, then do not send 'play_bitrate' events, wait for 'loadeddata' event first
        if (videoModel.getPlaybackRate() === 0) {
            return;
        }
        // Check for video playing quality change
        _detectPlayBitrateChange.call(this, videoQualityChanged);
        // Check for audio playing quality change
        _detectPlayBitrateChange.call(this, audioQualityChanged);
    };




    // event connection
    var _connectEvents = function () {
        this.addEventListener('metricAdded', _metricAdded.bind(this));
        this.addEventListener('error', _onError.bind(this));
        this.addEventListener('warning', _onWarning.bind(this));
        this.addEventListener('timeupdate', _onTimeupdate.bind(this));
    };




    /// Private playback functions ///
    var _resetAndPlay = function (reason) {
        if (playing && streamController) {
            if (!resetting) {
                resetting = true;

                var teardownComplete = {};
                teardownComplete[MediaPlayer.dependencies.StreamController.eventList.ENAME_TEARDOWN_COMPLETE] = (function () {

                    // Finish rest of shutdown process
                    streamController = null;
                    playing = false;

                    resetting = false;

                    this.debug.log("[MediaPlayer] Player is stopped");

                    if (_isReady.call(this)) {
                        _doAutoPlay.call(this);
                    }
                }).bind(this);
                streamController.subscribe(MediaPlayer.dependencies.StreamController.eventList.ENAME_TEARDOWN_COMPLETE, teardownComplete, undefined, true);
                streamController.reset(reason);
            }
        } else {
            if (_isReady.call(this)) {
                _doAutoPlay.call(this);
            }
        }
    };



    // TODO : remove this when migration of method getTracks will be done on all the process
    var _getTracksFromType = function (_type) {
        if (!streamController) {
            return null;
        }
        switch (_type) {
            case MediaPlayer.TRACKS_TYPE.AUDIO:
                return streamController.getAudioTracks();
            case MediaPlayer.TRACKS_TYPE.TEXT:
                return streamController.getSubtitleTracks();
        }
        return null;
    };

    var _getSelectedTrackFromType = function (_type) {
        if (!streamController) {
            return null;
        }
        switch (_type) {
            case MediaPlayer.TRACKS_TYPE.AUDIO:
                return streamController.getSelectedAudioTrack();
            case MediaPlayer.TRACKS_TYPE.TEXT:
                return streamController.getSelectedSubtitleTrack();
        }
        return null;
    };

    var _selectTrackFromType = function (_type, _track) {
        if (!streamController) {
            return null;
        }
        switch (_type) {
            case MediaPlayer.TRACKS_TYPE.AUDIO:
                streamController.setAudioTrack(_track);
                break;
            case MediaPlayer.TRACKS_TYPE.TEXT:
                streamController.setSubtitleTrack(_track);
                break;
        }
        return null;
    };


    // parse the arguments of load function to make an object
    var _parseLoadArguments = function () {
        if (arguments && arguments.length > 0) {
            var params = {};
            // restaure url
            if (typeof arguments[0] === 'string') {
                params.url = arguments[0];
            }
            //restaure protData
            if (arguments[1]) {
                params.protData = arguments[1];
            }
            return params;
        }

    };
    // END TODO


    var _getDVRInfoMetric = function () {
        var metrics = this.metricsModel.getReadOnlyMetricsFor('video'),
            dvrInfo = metrics ? this.metricsExt.getCurrentDVRInfo(metrics) : null;
        return dvrInfo;
    };

//#endregion

//#region DIJON initialization
    system.mapValue('system', system);
    system.mapOutlet('system');
    system.injectInto(context);
//#endregion

    return {
        ///////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////// PUBLIC /////////////////////////////////////////////
//#region dependencies
        notifier: undefined,
        debug: undefined,
        eventBus: undefined,
        metricsExt: undefined,
        abrController: undefined,
        metricsModel: undefined,
        errHandler: undefined,
        config: undefined,
//#endregion

//#region VERSION
        /**
         * Returns the version of the player.
         * @method getVersion
         * @access public
         * @memberof MediaPlayer#
         * @return {string} the version of the player
         */
        getVersion: function () {
            return VERSION;
        },

        /**
         * Returns the full version of the player (including git tag).
         * @method getVersionFull
         * @access public
         * @memberof MediaPlayer#
         * @return {string} the version of the player including git tag
         */
        getVersionFull: function () {
            if (GIT_TAG.indexOf("@@") === -1) {
                return VERSION + '_' + GIT_TAG;
            } else {
                return VERSION;
            }
        },

        /**
         * Returns the version of dash.js from which this player has been built.
         * @method getVersionDashJS
         * @access public
         * @memberof MediaPlayer#
         * @return {string} the dash.js version
         */
        getVersionDashJS: function () {
            return VERSION_DASHJS;
        },

        /**
         * Returns the date at which this player has been built.
         * @access public
         * @memberof MediaPlayer#
         * @return {string} the date at which this player has been built
         */
        getBuildDate: function () {
            if (BUILD_DATE.indexOf("@@") === -1) {
                return BUILD_DATE;
            } else {
                return 'Not a builded version';
            }
        },
//#endregion

//#region INIT
        /**
         * Initialize the player.
         * @method init
         * @access public
         * @memberof MediaPlayer#
         * @param {Object} video - the HTML5 video element used to decode and render the media data
         */
        init: function (video) {
            if (!video) {
                throw new Error('MediaPlayer.init(): Invalid Argument');
            }
            if (!initialized) {
                system.injectInto(this);
                initialized = true;
                this.debug.log("[MediaPlayer] Version: " + this.getVersionFull() + " - " + this.getBuildDate());
                this.debug.log("[MediaPlayer] user-agent: " + navigator.userAgent);
            }
            videoModel = system.getObject('videoModel');
            videoModel.setElement(video);

            // in case of init is called another time
            /*if (playing && streamController) {
                streamController.reset();
                playing = false;
            }*/

            // connect default events
            _connectEvents.call(this);
            //debugController.init();

            // create DebugController
            debugController = system.getObject('debugController');
        },
//#endregion

//#region LISTENERS
        /**
         * Registers a listener on the specified event.
         * The possible event types are:
         * <li>'error' (see [error]{@link MediaPlayer#event:error} event specification)
         * <li>'warning' (see [warning]{@link MediaPlayer#event:warning} event specification)
         * <li>'manifestUrlUpdate' (see [manifestUrlUpdate]{@link MediaPlayer#event:manifestUrlUpdate} event specification)
         * <li>'play_bitrate' (see [play_bitrate]{@link MediaPlayer#event:play_bitrate} event specification)
         * <li>'download_bitrate' (see [download_bitrate]{@link MediaPlayer#event:download_bitrate} event specification)
         * <li>'bufferLevel_updated' (see [bufferLevel_updated]{@link MediaPlayer#event:bufferLevel_updated} event specification)
         * <li>'state_changed' (see [state_changed]{@link MediaPlayer#event:state_changed} event specification)
         * @method addEventListener
         * @access public
         * @memberof MediaPlayer#
         * @param {string} type - the event type for listen to, either any HTML video element event or player event.
         * @param {callback} listener - the callback which is called when an event of the specified type occurs
         * @param {boolean} useCapture - see HTML DOM addEventListener() method specification
         */
        addEventListener: function (type, listener, useCapture) {
            _isPlayerInitialized();
            if (MediaPlayer.PUBLIC_EVENTS[type] === 'hasplayer') {
                this.eventBus.addEventListener(type, listener, useCapture);
            } else {
                videoModel.listen(type, listener, useCapture);
            }
        },

        /**
         * Unregisters the listener previously registered with the addEventListener() method.
         * @method removeEventListener
         * @access public
         * @memberof MediaPlayer#
         * @see [addEventListener]{@link MediaPlayer#addEventListener}
         * @param {string} type - the event type on which the listener was registered
         * @param {callback} listener - the callback which was registered to the event type
         */
        removeEventListener: function (type, listener) {
            _isPlayerInitialized();
            if (MediaPlayer.PUBLIC_EVENTS[type] === 'hasplayer') {
                this.eventBus.removeEventListener(type, listener);
            } else {
                videoModel.unlisten(type, listener);
            }
        },
//#endregion

//#region COMPONENTS GETTER
        /**
         * Returns the video model object.
         * @access public
         * @memberof MediaPlayer#
         * @return {object} the video model object
         */
        getVideoModel: function() {
            return videoModel;
        },

        /**
         * Returns the debug object.
         * @access public
         * @memberof MediaPlayer#
         * @return {object} the debug object
         */
        getDebug: function () {
            return this.debug;
        },

        /**
         * Returns the metrics extension object.
         * @access public
         * @memberof MediaPlayer#
         * @return {object} the metrics extension object
         */
        getMetricsExt: function () {
            return this.metricsExt;
        },
//#endregion

//#region CONFIG
        /**
         * Sets player configuration parameters.
         * @access public
         * @memberof MediaPlayer#
         * @param {PlayerParams} params - parameter(s) value(s) to set.
         */
        setConfig: function (params) {
            if (this.config && params) {
                this.debug.log("[MediaPlayer] set config: " + JSON.stringify(params, null, '\t'));
                this.config.setParams(params);
            }
        },
        setParams: function (params) {
            this.setConfig(params);
        },

        /**
         * Enables or disables debug information in the browser console.
         * @method setDebug
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - true to enable debug information, false to disable
         */
        setDebug: function (value) {
            _isPlayerInitialized();
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.setDebug(): Invalid Arguments');
            }
            if (value === true) {
                this.debug.setLevel(4);
            } else {
                this.debug.setLevel(0);
            }
        },

        /**
         * Returns the autoplay state.
         * @access public
         * @memberof MediaPlayer#
         * @return {boolean} the autoplay state
         */
        getAutoPlay: function () {
            return autoPlay;
        },

        /**
         * Sets the autoplay state.
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - true to activate autoplay, false to disable autoplay
         */
        setAutoPlay: function (value) {
            autoPlay = value;
        },

        /**
         * Sets the initial quality to be downloaded for the given track type.
         * This method has to be used before each call to load() method to set the initial quality.
         * Otherwise, the initial quality is set according to previous bandwidth condition.
         * @access public
         * @memberof MediaPlayer#
         * @see [setConfig]{@link MediaPlayer#setConfig} to set quality boundaries
         * @param {string} type - the track type ('video' or 'audio')
         * @param {number} value - the new initial quality index (starting from 0) to be downloaded
         */
        setInitialQualityFor: function (type, value) {
            initialQuality[type] = value;
        },

        /**
         * Returns the current quality for a stream type.
         * @access public
         * @memberof MediaPlayer#
         * @param {string} type - stream type, 'video' or 'audio'
         * @return {number} the current quality level as an index of the quality (in bitrate ascending order)
         */
        getQualityFor: function (type) {
            _isPlayerInitialized();
            return this.abrController.getQualityFor(type);
        },

        /**
         * Selects the quality for a stream type.
         * @access public
         * @memberof MediaPlayer#
         * @param {string} type - stream type, 'video' or 'audio'
         * @param {number} value - the selected quality level as an index of the quality (in bitrate ascending order)
         */
        setQualityFor: function (type, value) {
            _isPlayerInitialized();
            if (typeof value !== 'number') {
                throw new Error('MediaPlayer.setQualityFor(): Invalid Arguments');
            }
            this.abrController.setQualityFor(type, value);
        },

        /**
         * Returns the auto switch quality state.
         * @access public
         * @memberof MediaPlayer#
         * @return {boolean} the auto switch quality state
         */
        getAutoSwitchQuality: function() {
            _isPlayerInitialized();
            return this.abrController.getAutoSwitchBitrate();
        },

        /**
         * Sets the auto switch quality state.
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - the new auto switch quality state
         */
        setAutoSwitchQuality: function(value) {
            _isPlayerInitialized();
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.setAutoSwitchQuality(): Invalid Arguments');
            }
            this.abrController.setAutoSwitchBitrate(value);
        },

        /**
         * Returns the buffering behaviour while the player is in pause.
         * @access public
         * @memberof MediaPlayer#
         * @return {boolean} true if the player still buffers stream while in pause
         */
        getScheduleWhilePaused: function () {
            return scheduleWhilePaused;
        },

        /**
         * Sets the buffering behaviour while player is in pause.
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - true if the player has to buffer stream while in pause
         */
        setScheduleWhilePaused: function (value) {
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.setScheduleWhilePaused(): Invalid Arguments');
            }
            scheduleWhilePaused = value;
        },

        /**
         * Sets the default audio language. If the default language is available in the stream,
         * the corresponding audio track is selected. Otherwise, the first declared audio track in the manifest is selected.
         * @method setDefaultAudioLang
         * @access public
         * @memberof MediaPlayer#
         * @param {string} lang - the default audio language based on ISO 3166-2
         */
        setDefaultAudioLang: function (language) {
            if (typeof language !== 'string') {
                throw new Error('MediaPlayer.setDefaultAudioLang(): Invalid Arguments');
            }
            defaultAudioLang = language;
        },

        /**
         * Gets the default audio language.
         * @method getDefaultAudioLang
         * @access public
         * @memberof MediaPlayer#
         * @return {string} lang - the default audio language based on ISO 3166-2
         */
        getDefaultAudioLang: function(){
            return defaultAudioLang;
        },

        /**
         * Sets the default subtitle language. If the default language is available in the stream,
         * the corresponding subtitle track is selected. Otherwise, the first declared subtitle track in the manifest is selected.
         * @method setDefaultSubtitleLang
         * @access public
         * @memberof MediaPlayer#
         * @param {string} lang - the default subtitle language based on ISO 3166-2
         */
        setDefaultSubtitleLang: function (language) {
            if (typeof language !== 'string') {
                throw new Error('MediaPlayer.setDefaultSubtitleLang(): Invalid Arguments');
            }
            defaultSubtitleLang = language;
        },

        /**
         * Gets the default subtitle language.
         * @method getDefaultSubtitleLang
         * @access public
         * @memberof MediaPlayer#
         * @return {string} lang - the default subtitle language based on ISO 3166-2
         */
        getDefaultSubtitleLang: function () {
            return defaultSubtitleLang;
        },
//#endregion

//#region PLAYBACK
        /**
         * Load/open a video stream.
         * @method load
         * @access public
         * @memberof MediaPlayer#
         * @param {object} stream - video stream properties object such url, startTime, prodData ...
            <pre>
            {
                url : "[manifest url]",
                startTime : [start time in seconds (optionnal)]
                protData : {
                    // one entry for each key system ('com.microsoft.playready' or 'com.widevine.alpha')
                    "[key_system_name]": {
                        laURL: "[licenser url (optionnal)]",
                        pssh: "[base64 pssh box (optionnal)]"
                        cdmData: "[CDM data (optionnal)]"
                    },
                    ...
               }
               ...
            }
            </pre>
        */
        load: function (stream) {
            var plugin,
                pluginsInitDefer = [],
                pluginsLoadDefer = [],
                config = {
                    video: {
                        "ABR.keepBandwidthCondition": true
                    },
                    audio: {
                        "ABR.keepBandwidthCondition": true
                    }
                };

            // patch to be retro compatible with old syntax
            if (arguments && arguments.length > 0 && typeof arguments[0] !== 'object') {
                console.warn('You are using "deprecated" call of the method load, please refer to the documentation to change prameters call');
                stream = _parseLoadArguments.apply(null, arguments);
            }

            videoQualityChanged = [];
            audioQualityChanged = [];

            _isPlayerInitialized();

            // Reset the player
            this.reset(0);

            // Set initial quality if first stream
            if (initialQuality.video >= 0) {
                this.abrController.setQualityFor('video', initialQuality.video);
                config.video["ABR.keepBandwidthCondition"] = false;
                initialQuality.video = -1;
            }

            if (initialQuality.audio >= 0) {
                this.abrController.setQualityFor('audio', initialQuality.audio);
                config.audio["ABR.keepBandwidthCondition"] = false;
                initialQuality.audio = -1;
            }

            // Set config to set 'keepBandwidthCondition' parameter
            this.setConfig(config);

            // Reset last error and warning
            error = null;
            warning = null;

            // Wait for plugins completely intialized before starting a new session
            for(var name in  plugins) {
                pluginsInitDefer.push(plugins[name].deferInit.promise);
            }
            Q.all(pluginsInitDefer).then((function () {
                // Notify plugins a new stream is loaded
                for (var name in plugins) {
                    plugin = plugins[name];
                    plugin.deferLoad = Q.defer();
                    pluginsLoadDefer.push(plugin.deferLoad.promise);
                    plugin.load(stream, function () {
                        this.deferLoad.resolve();
                    }.bind(plugin));
                }

                Q.all(pluginsLoadDefer).then((function () {
                    // Once all plugins are ready, we load the stream
                    source = stream;
                    _resetAndPlay.call(this, 0);

                }).bind(this));
            }).bind(this));
        },

        /**
        * Plays/resumes playback of the media.
        * @method play
        * @access public
        * @memberof MediaPlayer#
        */
        play: function () {
            _isPlayerInitialized();
            videoModel.play();
        },

        /**
         * Seeks the media to the new time. For LIVE streams, this function can be used to perform seeks within the DVR window if available.
         * @method seek
         * @access public
         * @memberof MediaPlayer#
         * @param {number} time - the new time value in seconds
         */
        seek: function (time) {
            var range = null,
                minBufferTime = 0;

            _isPlayerInitialized();

            if (typeof time !== 'number') {
                throw new Error('MediaPlayer.seek(): Invalid Arguments');
            }

            if (!this.isLive()) {
                if (time < 0 || time > videoModel.getDuration()) {
                    throw new Error('MediaPlayer.seek(): seek value outside available time range');
                } else {
                    videoModel.setCurrentTime(time);
                }
            } else {
                range = this.getDVRWindowRange();
                minBufferTime = streamController.getMinBufferTime();
                if (range === null) {
                    throw new Error('MediaPlayer.seek(): impossible for live stream');
                } else if (time < range.start || time > range.end) {
                    throw new Error('MediaPlayer.seek(): seek value outside available time range');
                } else {
                    // Ensure we keep enough buffer
                    if (time > (range.end - minBufferTime)) {
                        time = range.end - minBufferTime;
                    }
                    streamController.seek(time, true);
                }
            }
        },

        /**
         * Pauses the media playback.
         * @method pause
         * @access public
         * @memberof MediaPlayer#
         */
        pause: function () {
            _isPlayerInitialized();
            videoModel.pause();
        },

        /**
         * Stops the media playback and seek back to start of stream and media. Subsequently call to play() method will restart streaming and playing from beginning.
         * @method stop
         * @access public
         * @memberof MediaPlayer#
         */
        stop: function () {
            _isPlayerInitialized();
            videoModel.pause();
            //test if player is in VOD mode
            if (!this.isLive()) {
                videoModel.setCurrentTime(0);
            }

            // Notify plugins that current stream is stopped
            for (var plugin in plugins) {
                plugins[plugin].stop();
            }
        },

        /**
         * Stops and resets the player.
         * @method reset
         * @access public
         * @memberof MediaPlayer#
         * @param {number} reason - the reason for stopping the player.
         * Possible values are:
         * <li>0 : stop during streaming at user request
         * <li>1 : stop when all streams are completed
         * <li>2 : stop after an error
         */
        reset: function (reason) {
            _isPlayerInitialized();

            // Reset ABR controller
            this.setQualityFor('video', 0);
            this.setQualityFor('audio', 0);

            source = null;

            _resetAndPlay.call(this, reason);

            // Notify plugins that player is reset
            for (var plugin in plugins) {
                plugins[plugin].stop();
            }
        },

        /**
        * Updates the manifest URL. This method is used to provide an update of the manifest URL when the original
        * URL provided in load() method is no more valid (for example if it has expired when signed)
        * (see [manifestUrlUpdate]{@link MediaPlayer#event:manifestUrlUpdate} event specification).
        * @method refeshManifest
        * @access public
        * @memberof MediaPlayer#
        * param {string} url - the updated video stream's manifest URL
        */
        refreshManifest: function (url) {
            _isPlayerInitialized();
            streamController.refreshManifest(url);
        },
//#endregion

//#region STREAM METADATA
        /**
         * Returns the media duration.
         * @method getDuration
         * @access public
         * @memberof MediaPlayer#
         * @return {number} the media duration in seconds, <i>Infinity</i> for live content
         */
        getDuration: function () {
            _isPlayerInitialized();
            return videoModel.getDuration();
        },

        /**
         * Returns true if the current stream is a live stream.
         * @method isLive
         * @access public
         * @memberof MediaPlayer#
         * @return {boolean} true if current stream is a live stream, false otherwise
         */
        isLive: function () {
            _isPlayerInitialized();
            return videoModel.getDuration() !== Number.POSITIVE_INFINITY ? false : true;
        },

        /**
         * Returns the current playback time/position.
         * @method getPosition
         * @access public
         * @memberof MediaPlayer#
         * @return {number} the current playback time/position in seconds
         */
        getPosition: function () {
            _isPlayerInitialized();
            if (!this.isLive()) {
                return videoModel.getCurrentTime();
            } else {
                return undefined;
            }
        },

        /**
         * Return the available DVR window range in case of live streams.
         * @method isLive
         * @access public
         * @memberOf MediaPlayer#
         * @return {object} range - the DVR window range
         * @return {number} range.start - the DVR window range start time
         * @return {number} range.end - the DVR window range end time
         */
        getDVRWindowRange: function () {
            _isPlayerInitialized();
            if (!this.isLive()) {
                return null;
            }
            var dvrInfo = _getDVRInfoMetric.call(this);
            return dvrInfo ? dvrInfo.range : null;
        },

        /**
         * Returns the DVR window size.
         * @method getDVRWindowSize
         * @access public
         * @memberof MediaPlayer#
         * @return {number} the DVR window size in seconds
         */
        getDVRWindowSize: function () {
            _isPlayerInitialized();
            if (!this.isLive()) {
                return null;
            }
            // TODO: get timeShiftBufferDepth
            return null;
            // var dvrInfo = _getDVRInfoMetric();
            // return dvrInfo ? dvrInfo.mpd.timeShiftBufferDepth : null;;
        },

        /**
         * TBD
         * @method getDVRSeekOffset
         * @access public
         * @memberof MediaPlayer#
         * @param  value
         * @return DVR seek offset
         */
        getDVRSeekOffset: function (value) {
            _isPlayerInitialized();
            if (!this.isLive()) {
                return null;
            }
            var dvrInfo = _getDVRInfoMetric.call(this),
                val = dvrInfo ? dvrInfo.range.start + value : null;

            if (val && val > dvrInfo.range.end) {
                val = dvrInfo.range.end;
            }

            return val;
        },

        /**
         * Returns the list of available bitrates (as specified in the stream manifest).
         * @method getVideoBitrates
         * @access public
         * @memberof MediaPlayer#
         * @return {Array<Number>} array of bitrate values
         */
        getVideoBitrates: function () {
            _isPlayerInitialized();
            return videoBitrates;
        },

        /**
         * Returns the metrics for stream type.
         * @access public
         * @memberof MediaPlayer#
         * @param {string} type - stream type, 'video' or 'audio'
         * @return {Array} the metrics array for the selected type
         */
        getMetricsFor: function(type) {
            var metrics = this.metricsModel.getReadOnlyMetricsFor(type);
            return metrics;
        },
//#endregion

//#region TRICK MODE
        /////////// TRICK MODE
        /**
         * Returns the current trick mode speed.
         * @method setTrickModeSpeed
         * @access public
         * @memberof MediaPlayer#
         * @return {number} the current trick mode speed
         */
        getTrickModeSpeed: function () {
            if (streamController) {
                return streamController.getTrickModeSpeed();
            }

            return 0;
        },

        /**
         * Sets the trick mode speed.
         * @method setTrickModeSpeed
         * @access public
         * @memberof MediaPlayer#
         * @param {number} speed - the new trick mode speed (0 corresponds to normal playback, i.e. playbackRate = 1)
         */
        setTrickModeSpeed: function (speed) {
            _isPlayerInitialized();
            if (streamController) {
                if (streamController.getTrickModeSpeed() !== speed && speed === 1) {
                    videoModel.play();
                } else {
                    streamController.setTrickModeSpeed(speed);
                }
            }
        },
//#endregion

//#region ERROR/WARNING
        /**
         * Returns the Error object for the most recent error.
         * @method getError
         * @access public
         * @memberof MediaPlayer#
         * @return {object} the Error object for the most recent error, or null if there has not been an error
        */
        getError: function () {
            return error;
        },

        /**
         * Returns the Warning object for the most recent warning.
         * @method getWarning
         * @access public
         * @memberof MediaPlayer#
         * @return {object} the Warning object for the most recent warning, or null if there has not been a warning
         */
        getWarning: function () {
            return warning;
        },
//#endregion

//#region TRACKS
        /**
         * Returns the list of available tracks for the stream type (as specified in the stream manifest).
         * The tracks list can be retrieved once the video 'loadeddata' event has been fired.
         * @method getTracks
         * @access public
         * @param {String} type - the stream type according to MediaPlayer.TRACKS_TYPE (see @link MediaPlayer#TRACKS_TYPE)
         * @memberof MediaPlayer#
         * @return {Array<Track>} the available tracks for the stream type
         */
        getTracks: function (type) {

            _isPlayerInitialized();

            if (!type || (type !== MediaPlayer.TRACKS_TYPE.AUDIO && type !== MediaPlayer.TRACKS_TYPE.TEXT)) {
                throw new Error('MediaPlayer Invalid Argument - "type" should be defined and shoud be kind of MediaPlayer.TRACKS_TYPE');
            }

            var _tracks = _getTracksFromType(type);

            if (!_tracks) {
                return [];
            }

            var tracks = [];
            for (var i = 0; i < _tracks.length; i += 1) {
                tracks.push({
                    id: _tracks[i].id,
                    lang: _tracks[i].lang
                });
            }

            return tracks;
        },

        /**
         * Selects the track to be playbacked for the stream type.
         * @method selectTrack
         * @access public
         * @memberof MediaPlayer#
         * @see [getTracks]{@link MediaPlayer#getTracks}
         * @param {String} type - the stream type according to MediaPlayer.TRACKS_TYPE (see @link MediaPlayer#TRACKS_TYPE)
         * @param {Track} track - the track to select
         *
         */
        selectTrack: function (type, track) {

            _isPlayerInitialized();

            if (!type || (type !== MediaPlayer.TRACKS_TYPE.AUDIO && type !== MediaPlayer.TRACKS_TYPE.TEXT)) {
                throw new Error('MediaPlayer Invalid Argument - "type" should be defined and shoud be kind of MediaPlayer.TRACKS_TYPE');
            }

            if (!track || !(track.id || track.lang)) {
                throw new Error('MediaPlayer.selectTrack(): track parameter is unknown');
            }

            var _tracks = _getTracksFromType(type);

            if (!_tracks) {
                this.debug.error("[MediaPlayer] No available track for type " + type);
                return;
            }

            var selectedTrack = _getSelectedTrackFromType(type);

            if (selectedTrack &&
                ((track.id && track.id === selectedTrack.id) ||
                 (track.lang && track.lang === selectedTrack.lang))) {
                this.debug.log("[MediaPlayer] " + type + " track [" + track.id + " - " + track.lang + "] is already selected");
                return;
            }

            for (var i = 0; i < _tracks.length; i += 1) {
                if ((track.id && track.id === _tracks[i].id) ||
                    (track.lang && track.lang === _tracks[i].lang)) {
                    _selectTrackFromType(type, _tracks[i]);
                    return;
                }
            }
        },

        /**
         * Returns the selected track for the stream type.
         * @method getSelectedTrack
         * @access public
         * @memberof MediaPlayer#
         * @param {String} type - the stream type according to MediaPlayer.TRACKS_TYPE (see @link MediaPlayer#TRACKS_TYPE)
         * @return {Track} the selected track
         */
        getSelectedTrack: function (type) {
            _isPlayerInitialized();

            if (!type || (type !== MediaPlayer.TRACKS_TYPE.AUDIO && type !== MediaPlayer.TRACKS_TYPE.TEXT)) {
                throw new Error('MediaPlayer Invalid Argument - "type" should be defined and shoud be kind of MediaPlayer.TRACKS_TYPE');
            }

            var _track = _getSelectedTrackFromType(type);

            if (!_track) {
                return null;
            }

            return {
                id: _track.id,
                lang: _track.lang
            };
        },
//#endregion

//#region SUBTITLES DISPLAY
        /**
         * Enable or disables subtitles processing.
         * @method enableSubtitles
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - true to enable subtitles, false to disables subtitles processing (by default subtitles are disabled)
         */
        enableSubtitles: function (value) {
            _isPlayerInitialized();
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.enableSubtitles(): Invalid Arguments');
            }
            subtitlesEnabled = value;
            if (streamController) {
                streamController.enableSubtitles(subtitlesEnabled);
            }
        },

        /**
        * Returns the subtitles processing state.
        * @method isSubtitlesEnabled
        * @access public
        * @memberof MediaPlayer#
        * @retrun {boolean} true if subtitles are enabled, false otherwise
       */
        isSubtitlesEnabled: function () {
            _isPlayerInitialized();
            return subtitlesEnabled;
        },

        /**
         * Enables or disables subtitles display in a div outside video player.
         * @method enableSubtitleExternDisplay
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} mode - true if subtitles are displayed in a div outside video player
         */
        enableSubtitleExternDisplay: function (value) {
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.enableSubtitleExternDisplay(): Invalid Arguments');
            }
            this.config.setParams({'TextTrackExtensions.displayModeExtern': value});
        },
//#endregion

//#region AUDIO VOLUME
        /**
         * Returns the audio mute state.
         * @method getMute
         * @access public
         * @memberof MediaPlayer#
         * @return {boolean} true if the audio is muted, false otherwise
         */
        getMute: function () {
            _isPlayerInitialized();
            return videoModel.getMute();
        },

        /**
         * Sets the audio mute state.
         * @method setMute
         * @access public
         * @memberof MediaPlayer#
         * @param {boolean} value - true to mute audio, false otherwise
         */
        setMute: function (value) {
            _isPlayerInitialized();
            if (typeof value !== 'boolean') {
                throw new Error('MediaPlayer.setMute(): Invalid Arguments');
            }
            videoModel.setMute(value);
        },

        /**
         * Returns the audio volume level.
         * @method getVolume
         * @access public
         * @memberof MediaPlayer#
         * @return {number} the current audio volume level, from 0.0 (silent) to 1.0 (loudest)
         */
        getVolume: function () {
            _isPlayerInitialized();
            return videoModel.getVolume();
        },

        /**
         * Sets the audio volume level.
         * @method setVolume
         * @access public
         * @memberof MediaPlayer#
         * @param {number} level - the audio volume level, from 0.0 (silent) to 1.0 (loudest)
         */
        setVolume: function (level) {
            _isPlayerInitialized();
            if ((typeof level !== 'number') || level < 0 || level > 1) {
                throw new Error('MediaPlayer.setVolume(): Invalid Arguments');
            }

            videoModel.setVolume(level);
        },
//#endregion

//#region TERMINAL ID
        /**
         * Returns the terminal ID.
         * @method getTerminalId
         * @access public
         * @memberof MediaPlayer#
         * @return {string} the terminal ID (<OS name>-<OS bits>-<browser name>)
         */
        getTerminalId: function () {
            var browser = fingerprint_browser(),
                os = fingerprint_os();

            return os.name + "-" + os.bits + "-" + browser.name;
        },
//#endregion

//#region PLUGINS
        /**
         * Adds a MediaPlayer plugin.
         * @method addPlugin
         * @access public
         * @memberof MediaPlayer#
         * @param {object} plugin - the plugin instance
         */
        addPlugin: function (plugin) {
            _isPlayerInitialized();

            if (plugin === undefined) {
                throw new Error('MediaPlayer.addPlugin(): plugin undefined');
            }

            // Check plugin API
            if (typeof(plugin.getName) !== 'function' ||
                typeof(plugin.getVersion) !== 'function' ||
                typeof(plugin.init) !== 'function' ||
                typeof(plugin.load) !== 'function' ||
                typeof(plugin.stop) !== 'function' ||
                typeof(plugin.reset) !== 'function') {
                throw new Error('MediaPlayer.addPlugin(): plugin API not compliant');
            }

            if (plugins[plugin.getName()]) {
                // Reset plugin already loaded
                plugins[plugin.getName()].reset();
            }

            this.debug.log("[MediaPlayer] Add plugin '" + plugin.getName() + "' (v" + plugin.getVersion() + ")");

            // Store plugin
            plugins[plugin.getName()] = plugin;

            // Initialize plugin (if player initialized)
            plugin.deferInit = Q.defer();
            if (initialized) {
                plugin.init(this, function () {
                    this.deferInit.resolve();
                }.bind(plugin));
            }
        },

        /**
         * Removes a MediaPlayer plugin.
         * @method removePlugin
         * @access public
         * @memberof MediaPlayer#
         * @param {object|string} plugin - the plugin instance (or name) to remove
         */
        removePlugin: function (plugin) {
            var name;

            if (plugin === undefined) {
                throw new Error('MediaPlayer.removePlugin(): plugin undefined');
            }

            if (typeof(plugin) === 'string') {
                name = plugin;
            } else {
                if (typeof(plugin.getName) !== 'function') {
                    throw new Error('MediaPlayer.removePlugin(): plugin API not compliant');
                }
                name = plugin.getName();
            }

            if (plugins[name]) {
                this.debug.log("[MediaPlayer] Remove plugin '" + name);
                // Reset plugin
                plugins[name].reset();
                // delete it
                plugins[name] = null;
                delete plugins[name];
            }
        }
//#endregion
    };
};

/**
 * @class
 * @classdesc MediaPlayer is the object used by the webapp to instanciante and control hasplayer.
 */
MediaPlayer.prototype = {
    constructor: MediaPlayer
};

//#region Packages
/**
 * Packages declaration
 */
MediaPlayer.dependencies = {};
MediaPlayer.dependencies.protection = {};
MediaPlayer.dependencies.protection.servers = {};
MediaPlayer.utils = {};
MediaPlayer.models = {};
MediaPlayer.modules = {};
MediaPlayer.vo = {};
MediaPlayer.vo.metrics = {};
MediaPlayer.vo.protection = {};
MediaPlayer.rules = {};
MediaPlayer.rules.o = {};
MediaPlayer.di = {};
//#endregion

//#region Enums
/**
 * ENUMS
 */
MediaPlayer.PUBLIC_EVENTS = {
    /**
     * The error event is fired when an error occurs.
     * When the error event is fired, the application shall stop the player.
     *
     * @event MediaPlayer#error
     * @param {object} event - the event
     * @param {object} event.type - the event type ('error')
     * @param {object} event.data - the event data
     * @param {string} event.data.code - error code
     * @param {string} event.data.message - error message
     * @param {object} event.data.data - error additionnal data
     */
    'error': 'hasplayer',
    /**
    * The warning event is fired when a warning occurs.
    *
    * @event MediaPlayer#warning
    * @param {object} event - the event
    * @param {object} event.type - the event type ('warning')
    * @param {object} event.data - the event data
    * @param {string} event.data.code - warning code
    * @param {string} event.data.message - warning message
    * @param {object} event.data.data - warning additionnal data
    */
    'warning': 'hasplayer',
    /**
     * The cueEnter event is fired when a subtitle cue needs to be displayed.
     *
     * @event MediaPlayer#cueEnter
     * @param {object} event - the event
     * @param {object} event.type - the event type ('cueEnter')
     * @param {object} event.data - the event data
     * @param {object} event.data.text - the subtitle text
     * @param {string} event.data.style.backgroundColor - the background color
     * @param {string} event.data.style.color - the font color
     * @param {string} event.data.style.fontFamily - the font family
     * @param {string} event.data.style.fontSize - the font size
     */
    'cueEnter': 'hasplayer',

    /**
     * The cueExit event is fired when a subtitle cue needs to be erased.
     *
     * @event MediaPlayer#cueExit
     * @param {object} event - the event
     * @param {object} event.type - the event type ('cueExit')
     * @param {object} event.data - the event data
     * @param {object} event.data.text - the subtitle text
     * @param {string} event.data.style.backgroundColor - the background color
     * @param {string} event.data.style.color - the font color
     * @param {string} event.data.style.fontFamily - the font family
     * @param {string} event.data.style.fontSize - the font size
     */
    'cueExit': 'hasplayer',

    /**
     * The manifestUrlUpdate event is fired when the URL of the manifest may have to be refreshed,
     * since the player failed to download the manifest file (URL expiration for example).
     * The application shall therefore provide an updated manifest URL by using the method [refreshManifest]{@link MediaPlayer#refreshManifest}
     *
     * @event MediaPlayer#manifestUrlUpdate
     * @param {object} event - the event
     * @param {object} event.type - the event type ('manifestUrlUpdate')
     * @param {object} event.data - the event data
     * @param {object} event.data.url - the current manifest url
     */
    'manifestUrlUpdate': 'hasplayer',

    /**
     * The metricAdded event is fired when a new metric has been added,
     * TBD
     */
    'metricAdded' : 'hasplayer',

    /**
     * The metricChanged event is fired when a metric has been updated,
     * TBD
     */
    'metricChanged' : 'hasplayer',

    /**
     * The 'play_bitrate' event is fired when the current played bitrate has changed.
     *
     * @event MediaPlayer#play_bitrate
     * @param {CustomEvent} event - the event
     * @param {object} event.detail - the event data
     * @param {string} event.detail.type - the stream type ('audio' or 'video')
     * @param {number} event.detail.bitrate - the new bitrate
     * @param {string} event.detail.representationId - the corresponding representation id (from manifest)
     * @param {number} event.detail.time - the current video time
     * @param {number} event.detail.width - in case of video stream, the video width of the representation
     * @param {number} event.detail.height - in case of video stream, the video height of the representation
     */
    'play_bitrate': 'video',

    /**
     * The download_bitrate event is fired when the current downloaded bitrate has changed.
     *
     * @event MediaPlayer#download_bitrate
     * @param {CustomEvent} event - the event
     * @param {object} event.detail - the event data
     * @param {string} event.detail.type - the stream type ('audio' or 'video')
     * @param {number} event.detail.bitrate - the new bitrate
     * @param {string} event.detail.representationId - the corresponding representation id (from manifest)
     * @param {number} event.detail.time - the current video time
     * @param {number} event.detail.width - in case of video stream, the video width of the representation
     * @param {number} event.detail.height - in case of video stream, the video height of the representation
     */
    'download_bitrate': 'video',


    /**
     * The bufferLevel_updated event is fired when the buffer level changed.
     *
     * @event MediaPlayer#bufferLevel_updated
     * @param {CustomEvent} event - the event
     * @param {object} event.detail - the event data
     * @param {string} event.detail.type - the stream type ('audio' or 'video')
     * @param {number} event.detail.level - the buffer level (in seconds)
     */
    'bufferLevel_updated': 'video',

    /**
     * The state_changed event is fired when the player state changed.
     *
     * @event MediaPlayer#state_changed
     * @param {CustomEvent} event - the event
     * @param {object} event.detail - the event data
     * @param {string} event.detail.type - the stream type ('audio' or 'video')
     * @param {string} event.detail.state - the current state ('stopped', 'buffering', 'seeking' or 'playing')
     */
    'state_changed': 'video'
};

/**
 * Exposes the available tracks types used to manage tracks (language) switching.
 * @see [getTracks]{@link MediaPlayer#getTracks}
 * @see [getSelectedTrack]{@link MediaPlayer#getSelectedTrack}
 * @see [selectTrack]{@link MediaPlayer#selectTrack}
 * @enum
 */
MediaPlayer.TRACKS_TYPE = {
    AUDIO: "audio",
    TEXT: "text"
};
//#endregion

//#region Player parameters
/**
 * Player parameters object.
 * All parameters values are applied for any stream type. Parameters can be overriden specifically for audio and video track by setting
 * parameters values in the params.audio and params.video objects.
 * @typedef PlayerParams
 * @type Object
 * @property {number}   BufferController.minBufferTimeForPlaying - Minimum buffer level before playing, in seconds (default value = 0)
 * @property {number}   BufferController.minBufferTime - Minimum buffer size, in seconds (default value = 16)
 * @property {number}   ABR.minBandwidth - Minimum bandwidth to be playbacked (default value = -1)
 * @property {number}   ABR.maxBandwidth - Maximum bandwidth to be playbacked (default value = -1)
 * @property {number}   ABR.minQuality - Minimum quality index (start from 0) to be playbacked (default value = -1)
 * @property {number}   ABR.maxQuality - Maximum quality index (start from 0) to be playbacked (default value = -1)
 * @property {boolean}  ABR.switchUpIncrementally - Switch up quality incrementally, or not (default value = false)
 * @property {number}   ABR.switchUpRatioSafetyFactor - Switch up bandwith ratio safety factor (default value = 1.5)
 * @property {boolean}  ABR.latencyInBandwidth - Include (or not) latency in bandwidth (default value = true)
 * @property {number}   ABR.switchLowerBufferTime - Buffer level (in seconds) under which switching down to lowest quality occurs (default value = -1)
 * @property {number}   ABR.switchLowerBufferRatio - Buffer level (as percentage of buffer size) under which switching down to lowest quality occurs (default value = 0.25)
 * @property {number}   ABR.switchDownBufferTime - Buffer level (in seconds) under which switching down quality occur, if unsufficient bandwidth (default value = -1)
 * @property {number}   ABR.switchDownBufferRatio - Buffer level (as percentage of buffer size) under which switching down quality occurs, if unsufficient bandwidth (default value = 0.5)
 * @property {number}   ABR.switchUpBufferTime - Buffer level (in seconds) upper which switching up quality occurs, if sufficient bandwidth (default value = -1)
 * @property {number}   ABR.switchUpBufferRatio - Buffer level (as percentage of buffer size) upper which switching up quality occurs, if sufficient bandwidth (default value = 0.75)
 * @property {number}   ManifestLoader.RetryAttempts - Number of retry attempts for downloading manifest file when it fails (default value = 2)
 * @property {number}   ManifestLoader.RetryInterval - Interval (in milliseconds) between each retry attempts for downloading manifest file (default value = 500)
 * @property {number}   FragmentLoader.RetryAttempts - Number of retry attempts for downloading segment files when it fails (default value = 2)
 * @property {number}   FragmentLoader.RetryInterval - Interval (in milliseconds) between each retry attempts for downloading segment files (default value = 500)
 * @property {Object}   video - Video parameters (parameters for video track)
 * @property {Object}   audio - audio parameters (parameters for audio track)
 */
//#endregion

//#region Static functions
/**
 * Static functions
 */
/**
* Returns the current browser status on MSE support.
* @method hasMediaSourceExtension
* @static
* @return true if MSE is supported, false otherwise
*/
MediaPlayer.hasMediaSourceExtension = function () {
    return new MediaPlayer.utils.Capabilities().supportsMediaSource();
};

/**
 * Returns the current browser status on EME support.
 * @method hasMediaKeysExtension
 * @static
 * @return true if EME is supported, false otherwise
 */
MediaPlayer.hasMediaKeysExtension = function () {
    return new MediaPlayer.utils.Capabilities().supportsMediaKeys();
};
//#endregion

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.AbrController = function() {
    "use strict";

    var autoSwitchBitrate = true,
        autoSwitchDic = {},
        qualityDict = {},
        qualityMaxDict = {},
        confidenceDict = {},
        playerState = "",

        getInternalAutoSwitch = function(type) {
            if (!autoSwitchDic.hasOwnProperty(type)) {
                autoSwitchDic[type] = true;
            }
            return autoSwitchDic[type];
        },

        setInternalAutoSwitch = function(type, value) {
            autoSwitchDic[type] = value;
        },

        getInternalQuality = function(type) {
            var quality;

            if (!qualityDict.hasOwnProperty(type)) {
                qualityDict[type] = 0;
            }

            quality = qualityDict[type];

            return quality;
        },

        setInternalQuality = function(type, value) {
            qualityDict[type] = value;
        },

        getInternalConfidence = function(type) {
            var confidence;

            if (!confidenceDict.hasOwnProperty(type)) {
                confidenceDict[type] = 0;
            }

            confidence = confidenceDict[type];

            return confidence;
        },

        setInternalConfidence = function(type, value) {
            confidenceDict[type] = value;
        },

        getRulesRequestQuality = function(type, data) {
            var self = this,
                autoSwitch = getInternalAutoSwitch(type),
                quality = getInternalQuality(type),
                confidence = getInternalConfidence(type),
                newQuality = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE,
                newConfidence = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE,
                qualityMax = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE,
                i,
                len,
                results = [],
                metrics,
                req,
                values = {},
                rules,
                max;

            if (!autoSwitchBitrate || !autoSwitch) {
                self.debug.log("[AbrController][" + type + "] ABR disabled");
                return {
                    quality: quality,
                    confidence: confidence
                };
            }

            self.debug.log("[AbrController][" + type + "] Check rules....");

            metrics = self.getMetricsFor(data);
            rules = self.abrRulesCollection.getRules(MediaPlayer.rules.BaseRulesCollection.prototype.QUALITY_SWITCH_RULES);
            for (i = 0, len = rules.length; i < len; i += 1) {
                results.push(rules[i].checkIndex(quality, metrics, data, playerState));
            }

            values[MediaPlayer.rules.SwitchRequest.prototype.STRONG] = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE;
            values[MediaPlayer.rules.SwitchRequest.prototype.WEAK] = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE;
            values[MediaPlayer.rules.SwitchRequest.prototype.DEFAULT] = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE;

            for (i = 0, len = results.length; i < len; i += 1) {
                req = results[i];
                if (req.quality !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE) {
                    self.debug.log("[AbrController][" + type + "] Request for quality " + req.quality + ", priority = " + req.priority + " (" + rules[i].name + ")");
                    values[req.priority] = Math.min(values[req.priority], req.quality);
                }

                if (req.max === true) {
                    qualityMax = Math.min(qualityMax, req.quality);
                }
            }

            if (values[MediaPlayer.rules.SwitchRequest.prototype.WEAK] !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE) {
                newConfidence = MediaPlayer.rules.SwitchRequest.prototype.WEAK;
                newQuality = values[MediaPlayer.rules.SwitchRequest.prototype.WEAK];
            }

            if (values[MediaPlayer.rules.SwitchRequest.prototype.DEFAULT] !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE) {
                newConfidence = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT;
                newQuality = values[MediaPlayer.rules.SwitchRequest.prototype.DEFAULT];
            }

            if (values[MediaPlayer.rules.SwitchRequest.prototype.STRONG] !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE) {
                newConfidence = MediaPlayer.rules.SwitchRequest.prototype.STRONG;
                newQuality = values[MediaPlayer.rules.SwitchRequest.prototype.STRONG];
            }

            if (newQuality !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE && newQuality !== undefined) {
                quality = newQuality;
            }

            if (newConfidence !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE && newConfidence !== undefined) {
                confidence = newConfidence;
            }

            if (qualityMax !== MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE) {
                qualityMaxDict[type] = qualityMax;
            }

            max = self.manifestExt.getRepresentationCount(data);
            // Ensure valid quality index
            if (quality < 0) {
                quality = 0;
            }
            if (quality >= max) {
                quality = max - 1;
            }

            if (confidence !== MediaPlayer.rules.SwitchRequest.prototype.STRONG &&
                confidence !== MediaPlayer.rules.SwitchRequest.prototype.WEAK) {
                confidence = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT;
            }

            self.debug.info("[AbrController][" + type + "] Request quality: " + quality);

            return {
                quality: quality,
                confidence: confidence
            };
        },

        getQualityBoundaries = function(type, data) {
            var bitrates = this.metricsExt.getBitratesForType(type, data),
                qualityMin = this.config.getParamFor(type, "ABR.minQuality", "number", -1),
                qualityMax = this.config.getParamFor(type, "ABR.maxQuality", "number", -1),
                bandwidthMin = this.config.getParamFor(type, "ABR.minBandwidth", "number", -1),
                bandwidthMax = this.config.getParamFor(type, "ABR.maxBandwidth", "number", -1),
                i,
                count = bitrates.length;

            if (bandwidthMin !== -1) {
                for (i = 0; i < bitrates.length; i++) {
                    if (bitrates[i] >= bandwidthMin) {
                        qualityMin = (qualityMin === -1) ? i : Math.max(i, qualityMin);
                        break;
                    }
                }
            }

            if (bandwidthMax !== -1) {
                for (i = bitrates.length - 1; i >= 0; i--) {
                    if (bitrates[i] <= bandwidthMax) {
                        qualityMax = (qualityMax === -1) ? i : Math.min(i, qualityMax);
                        break;
                    }
                }
            }

            qualityMin = (qualityMin >= count) ? (count - 1) : qualityMin;
            qualityMin = (qualityMin < 0) ? 0 : qualityMin;
            qualityMax = (qualityMax >= count || qualityMax < 0) ? (count - 1) : qualityMax;

            return {
                min: qualityMin,
                max: qualityMax
            };

        };

    return {
        debug: undefined,
        abrRulesCollection: undefined,
        manifestExt: undefined,
        metricsModel: undefined,
        metricsExt: undefined,
        config: undefined,

        getAutoSwitchBitrate: function() {
            return autoSwitchBitrate;
        },

        setAutoSwitchBitrate: function(value) {
            this.debug.log("[AbrController] Set auto switch: " + value);
            autoSwitchBitrate = value;
        },

        getMetricsFor: function(data) {
            var isVideo,
                isAudio;

            isVideo = this.manifestExt.getIsVideo(data);
            if (isVideo) {
                return this.metricsModel.getMetricsFor("video");
            } else {
                isAudio = this.manifestExt.getIsAudio(data);
                if (isAudio) {
                    return this.metricsModel.getMetricsFor("audio");
                } else {
                    return this.metricsModel.getMetricsFor("stream");
                }
            }
        },

        getPlaybackQuality: function(type, data) {
            var self = this,
                previousQuality = this.getQualityFor(type),
                qualityMin = -1,
                qualityMax = -1,
                quality,
                confidence,
                switchUpIncrementally = this.config.getParamFor(type, "ABR.switchUpIncrementally", "boolean", false),
                result;

            result = getRulesRequestQuality.call(this, type, data);
            quality = result.quality;
            confidence = result.confidence;

            if (self.getAutoSwitchBitrate()) {
                // Check incremental switch
                if (switchUpIncrementally && (quality > previousQuality)) {
                    self.debug.log("[AbrController][" + type + "] Incremental switch => quality: " + quality);
                    quality = previousQuality + 1;
                }

                // Check representation boundaries
                var qualityBoundaries = getQualityBoundaries.call(self, type, data);
                qualityMin = qualityBoundaries.min;
                qualityMax = qualityBoundaries.max;

                if (quality < qualityMin) {
                    quality = qualityMin;
                    self.debug.log("[AbrController][" + type + "] New quality < min => " + quality);
                }

                if (quality > qualityMax) {
                    quality = qualityMax;
                    self.debug.log("[AbrController][" + type + "] New quality > max => " + quality);
                }

                // Check max quality allowed by the rules (see DroppedFramesRule for example)
                if (quality > qualityMaxDict[type]) {
                    quality = qualityMaxDict[type];
                    self.debug.log("[AbrController][" + type + "] Max allowed quality = " + quality);
                }
            }

            setInternalQuality.call(self, type, quality);
            setInternalConfidence.call(self, type, confidence);

            self.debug.info("[AbrController][" + type + "] Set quality: " + quality);
            return {
                quality: quality,
                confidence: confidence
            };
        },

        getAutoSwitchFor: function(type) {
            return getInternalAutoSwitch(type);
        },

        setAutoSwitchFor: function(type, value) {
            var autoSwitch = getInternalAutoSwitch(type);
            if (value !== autoSwitch) {
                this.debug.log("[AbrController][" + type + "] Set auto switch: " + value);
                setInternalAutoSwitch(type, value);
            }
        },

        getQualityFor: function(type) {
            return getInternalQuality(type);
        },

        setQualityFor: function(type, value) {
            var quality = getInternalQuality(type);
            if (value !== quality) {
                this.debug.log("[AbrController][" + type + "] Set playback quality: " + value);
                setInternalQuality(type, value);
            }
        },

        isMinQuality: function(type, data, value) {
            var qualityBoundaries = getQualityBoundaries.call(this, type, data);
            return value <= qualityBoundaries.min;
        },

        setPlayerState: function(state) {
            playerState = state;
        }
    };
};

MediaPlayer.dependencies.AbrController.prototype = {
    constructor: MediaPlayer.dependencies.AbrController
};

MediaPlayer.dependencies.AbrController.BANDWIDTH_SAFETY = 0.9;
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.BufferController = function() {
    "use strict";
    var READY = "READY",
        state = READY,
        ready = false,
        started = false,
        waitingForBuffer = false,
        initialPlayback = true,
        initializationData = [],
        seeking = false,
        seekTarget = -1,
        dataChanged = true,
        languageChanged = false,
        availableRepresentations,
        _currentRepresentation,
        currentBufferedQuality = -1,
        currentDownloadQuality = -1,
        stalled = false,
        isDynamic = false,
        isBufferingCompleted = false,
        deferredRejectedDataAppend = null,
        deferredBuffersFlatten = null,
        periodInfo = null,
        fragmentsToLoad = 0,
        fragmentModel = null,
        bufferLevel = 0,
        isQuotaExceeded = false,
        rejectedBytes = null,
        appendingRejectedData = false,
        mediaSource,
        type,
        data = null,
        buffer = null,
        minBufferTime,
        minBufferTimeAtStartup,
        bufferTimeout,
        bufferStateTimeout,
        trickModeEnabled = false,
        trickModePreviousQuality = 0,
        trickModePreviousAutoSwitch = true,
        trickModeForward = false,

        playListMetrics = null,
        playListTraceMetrics = null,
        playListTraceMetricsClosed = true,

        inbandEventFound = false,

        // Buffering state
        INIT = -1,
        BUFFERING = 0,
        PLAYING = 1,
        htmlVideoState = INIT,
        htmlVideoTime = -1,

        deferredFragmentBuffered = null,
        isFirstMediaSegment = false,

        // Async. vs async. MSE's SourceBuffer appending/removing algorithm
        appendSync = false,

        // Segment download failure recovery
        SEGMENT_DOWNLOAD_ERROR_MAX = 3,
        segmentDownloadErrorCount = 0,
        segmentRequestOnError = null,
        reloadTimeout = null,

        // HLS chunk sequence number
        currentSequenceNumber = -1,

        segmentDuration = NaN,

        // Patch for Safari: do not remove past buffer in live use case
        // since it generates MEDIA_ERROR_DECODE while appending new segment
        isSafari = (fingerprint_browser().name === "Safari"),


        sendRequest = function() {

            // Check if running state
            if (!isRunning.call(this)) {
                return;
            }

            if (fragmentModel !== null) {
                this.fragmentController.onBufferControllerStateChange();
            }
        },

        clearPlayListTraceMetrics = function(endTime, stopreason) {
            var duration = 0,
                startTime = null;

            if (playListTraceMetricsClosed === false) {
                startTime = playListTraceMetrics.start;
                duration = endTime.getTime() - startTime.getTime();

                playListTraceMetrics.duration = duration;
                playListTraceMetrics.stopreason = stopreason;

                playListTraceMetricsClosed = true;
            }
        },

        setStalled = function(value) {
            var self = this;

            if (type === "text") {
                return;
            }

            self.debug.info("[BufferController][" + type + "] stalled = " + value);
            stalled = value;
            self.videoModel.stallStream(type, stalled);

            // Notify ABR controller we start buffering in order to adapt ABR rules (see InsufficientbufferRule)
            self.abrController.setPlayerState(stalled ? "buffering" : "playing");
        },

        startPlayback = function() {
            if (!ready || !started) {
                return;
            }

            this.debug.info("[BufferController][" + type + "] startPlayback");

            // Set media type to stalled state
            setStalled.call(this, true);

            // Start buffering process
            checkIfSufficientBuffer.call(this);
        },

        doStart = function() {
            var currentTime,
                self = this;

            if (started === true) {
                return;
            }

            if (seeking === false) {
                currentTime = new Date();
                clearPlayListTraceMetrics(currentTime, MediaPlayer.vo.metrics.PlayList.Trace.USER_REQUEST_STOP_REASON);
                playListMetrics = this.metricsModel.addPlayList(type, currentTime, 0, MediaPlayer.vo.metrics.PlayList.INITIAL_PLAY_START_REASON);
            }

            if (isBufferingCompleted) {
                if(data.mimeType === "application/ttml+xml"){
                    return;
                }
                isBufferingCompleted = false;
            }

            started = true;

            self.debug.info("[BufferController][" + type + "] START");

            waitingForBuffer = true;

            // Reset htmlVideoState in order to update it after a pause or seek command in UpdateBufferState function
            htmlVideoState = INIT;
            htmlVideoTime = -1;
            segmentRequestOnError = null;

            startPlayback.call(self);
        },

        doSeek = function(time) {
            var self = this,
                currentTime = new Date();

            // Avoid identical successive seeks
            if ((seeking === true) && (seekTarget === time)) {
                // We are already seeking at the given time
                return;
            }

            this.debug.info("[BufferController][" + type + "] SEEK: " + time);

            // Do stop since <video>'s stop command may not be called before seek one
            if (started === true) {
                doStop.call(self);
            }

            // Clear executed requests from fragment controller. In case the browser has cleared the buffer itslef silently,
            // then FragmentController will not state that the cleared segments have been already loaded.
            this.fragmentController.clearExecutedRequests(fragmentModel);

            // Restart
            playListMetrics = this.metricsModel.addPlayList(type, currentTime, seekTarget, MediaPlayer.vo.metrics.PlayList.SEEK_START_REASON);
            seeking = true;
            seekTarget = time;

            // Wait for current buffering process to be completed before restarting
            Q.when(deferredFragmentBuffered ? deferredFragmentBuffered.promise : true).then(
                function() {
                    //self.debug.log("[BufferController]["+type+"] SEEK: deferredFragmentBuffered = "+deferredFragmentBuffered+" Call start!");
                    doStart.call(self);
                }
            );
        },

        doSeeked = function() {
            this.debug.info("[BufferController][" + type + "] SEEKED");
            seeking = false;
            seekTarget = -1;
        },

        doStop = function() {
            if (!started) {
                return;
            }
            this.debug.info("[BufferController][" + type + "] STOP");

            // Stop buffering process
            clearTimeout(bufferTimeout);
            clearTimeout(bufferStateTimeout);
            started = false;
            waitingForBuffer = false;

            seeking = false;
            seekTarget = -1;

            // Stop reload timeout
            clearTimeout(reloadTimeout);
            reloadTimeout = null;

            // Stop buffering process and cancel loaded request
            clearPlayListTraceMetrics(new Date(), MediaPlayer.vo.metrics.PlayList.Trace.USER_REQUEST_STOP_REASON);

            this.fragmentController.abortRequestsForModel(fragmentModel);
        },


        getRepresentationForQuality = function(quality) {
            return availableRepresentations[quality];
        },

        onBytesLoadingStart = function(request) {
            this.debug.info("[BufferController][" + type + "] Load request ", (request.url !== null) ? request.url : request.quality);
        },

        onBytesLoaded = function(request, response) {

            // Store current segment sequence number for next segment request (HLS use case)
            if (request.sequenceNumber !== undefined) {
                currentSequenceNumber = request.sequenceNumber;
            }

            if (this.fragmentController.isInitializationRequest(request)) {
                onInitializationLoaded.call(this, request, response);
            } else {
                onMediaLoaded.call(this, request, response);
            }
        },

        onInitializationLoaded = function(request, response) {
            var self = this,
                initData = response.data,
                quality = request.quality,
                data;

            self.debug.log("[BufferController][" + type + "] Initialization loaded ", quality);

            data = self.fragmentController.process(initData);
            if (data) {
                if (data.error) {
                    signalSegmentBuffered.call(self);
                    self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.INTERNAL_ERROR, "Internal error while processing media segment", data.message);
                } else {
                    // cache the initialization data to use it next time the quality has changed
                    initializationData[quality] = data;

                    // if this is the initialization data for current quality we need to push it to the buffer
                    self.debug.info("[BufferController][" + type + "] Buffer initialization segment ", (request.url !== null) ? request.url : request.quality);
                    //    console.saveBinArray(data, type + "_init_" + request.quality + ".mp4");
                    // Clear the buffer if required (language track switching)
                    Q.when(languageChanged ? removeBuffer.call(self) : true).then(
                        function() {
                            languageChanged = false;
                            appendToBuffer.call(self, data, request.quality).then(
                                function() {
                                    self.debug.log("[BufferController][" + type + "] Initialization segment buffered");
                                    // Load next media segment
                                    if (isRunning()) {
                                        loadNextFragment.call(self);
                                    }
                                }
                            );
                        }
                    );
                }
            } else {
                self.debug.log("No " + type + " bytes to push.");
                // ORANGE : For HLS Stream, init segment are pushed with media (@see HlsFragmentController)
                loadNextFragment.call(self);
            }
        },

        onMediaLoaded = function(request, response) {
            var self = this,
                eventStreamAdaption = this.manifestExt.getEventStreamForAdaptationSet(self.getData()),
                eventStreamRepresentation = this.manifestExt.getEventStreamForRepresentation(self.getData(), _currentRepresentation),
                segmentStartTime = null,
                events,
                data;

            segmentDuration = request.duration;

            if (!isRunning()) {
                return;
            }

            // Reset segment download error status
            segmentDownloadErrorCount = 0;

            self.debug.log("[BufferController][" + type + "] Media loaded ", request.url);

            if (self.chunkAborted === true) {
                self.chunkAborted = false;
            }

            if (self.chunkMissingCount === 1) {
                self.chunkMissingCount = 0;
            }

            // ORANGE: add request and representations in function parameters, used by MssFragmentController
            data = self.fragmentController.process(response.data, request, availableRepresentations);
            if (data) {
                if (data.error) {
                    signalSegmentBuffered.call(self);
                    if (data.name) {
                        self.errHandler.sendError(data.name, data.message, data.data);
                    } else {
                        self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.INTERNAL_ERROR, "Internal error while processing media segment", data.message);
                    }
                } else {
                    if (eventStreamAdaption.length > 0 || eventStreamRepresentation.length > 0) {
                        events = handleInbandEvents.call(self, data, request, eventStreamAdaption, eventStreamRepresentation);
                        self.eventController.addInbandEvents(events);
                    }

                    self.debug.info("[BufferController][" + type + "] Buffer segment from url ", request.url);

                    /*if (trickModeEnabled) {
                            var filename = type + "_" + request.index + "_" + request.quality + ".mp4",
                                blob = new Blob([data], {
                                    type: 'data/mp4'
                                });

                            if (navigator.msSaveBlob) { // For IE10+ and edge
                                navigator.msSaveBlob(blob, filename);
                            }
                        }*/

                    //console.saveBinArray(data, type + "_" + request.index + "_" + request.quality + ".mp4");
                    data = deleteInbandEvents.call(self, data);

                    appendToBuffer.call(self, data, request.quality, request.index).then(
                        function() {
                            if (isFirstMediaSegment) {
                                isFirstMediaSegment = false;
                                if (self.fragmentController.hasOwnProperty('getStartTime')) {
                                    segmentStartTime = self.fragmentController.getStartTime();
                                }
                                if (segmentStartTime) {
                                    self.metricsModel.addBufferedSwitch(type, segmentStartTime, _currentRepresentation.id, request.quality);
                                } else {
                                    self.metricsModel.addBufferedSwitch(type, request.startTime, _currentRepresentation.id, request.quality);
                                }
                            }

                            self.debug.log("[BufferController][" + type + "] Media segment buffered");
                            // Signal end of buffering process
                            signalSegmentBuffered.call(self);
                            // Check buffer level
                            checkIfSufficientBuffer.call(self);
                        }
                    );
                }
            } else {
                self.debug.error("[BufferController][" + type + "] Error with segment data, no bytes to push");
                // Signal end of buffering process
                signalSegmentBuffered.call(self);
                // Check buffer level
                checkIfSufficientBuffer.call(self);
            }
        },

        appendToBuffer = function(data, quality, index) {
            var self = this,
                deferred = Q.defer(),
                currentVideoTime = self.videoModel.getCurrentTime(),
                currentTime = new Date();

            //self.debug.log("Push (" + type + ") bytes: " + data.byteLength);

            if (playListTraceMetricsClosed === true) {
                playListTraceMetricsClosed = false;
                playListTraceMetrics = self.metricsModel.appendPlayListTrace(playListMetrics, _currentRepresentation.id, null, currentTime, currentVideoTime, null, 1.0, null);
            }

            if (!hasData()) {
                return;
            }

            hasEnoughSpaceToAppend.call(self).then(
                function() {
                    Q.when(deferredBuffersFlatten ? deferredBuffersFlatten.promise : true).then(
                        function() {
                            if (!hasData()) {
                                return;
                            }
                            self.debug.log("[BufferController][" + type + "] Buffering segment");
                            self.sourceBufferExt.append(buffer, data, appendSync).then(
                                function( /*appended*/ ) {
                                    self.debug.log("[BufferController][" + type + "] Segment buffered");
                                    //self.debug.log("[BufferController]["+type+"] Data has been appended for quality = "+quality+" index = "+index);
                                    if (currentBufferedQuality !== quality) {
                                        isFirstMediaSegment = true;
                                        self.debug.log("[BufferController][" + type + "] set currentBufferedQuality to " + quality);
                                        currentBufferedQuality = quality;
                                    }

                                    isQuotaExceeded = false;

                                    // Patch for Safari: do not remove past buffer in live use case
                                    // since it generates MEDIA_ERROR_DECODE while appending new segment

                                    if (isDynamic && bufferLevel > 1 && !isSafari) {
                                        // In case of live streams, remove outdated buffer parts and requests
                                        // (checking bufferLevel ensure buffer is not empty or back to current time)
                                        removeBuffer.call(self, -1, getWorkingTime.call(self) - 30).then(
                                            function() {
                                                debugBufferRange.call(self);
                                                deferred.resolve();
                                            }
                                        );
                                    } else if (trickModeEnabled) {
                                        // In case of trick play, remove outdated buffer parts according to trick play direction
                                        var start = trickModeForward ? -1 : (getWorkingTime.call(self) + segmentDuration);
                                        var end = trickModeForward ? (getWorkingTime.call(self) - segmentDuration) : -1;
                                        removeBuffer.call(self, start, end).then(
                                            function() {
                                                debugBufferRange.call(self);
                                                deferred.resolve();
                                            }
                                        );
                                    } else {
                                        debugBufferRange.call(self);
                                        deferred.resolve();
                                    }

                                    self.system.notify("bufferUpdated");
                                },
                                function(result) {
                                    self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_APPEND_SOURCEBUFFER, "Failed to append data into " + type + " source buffer",
                                        new MediaPlayer.vo.Error(result.err.code, result.err.name, result.err.message));
                                    // if the append has failed because the buffer is full we should store the data
                                    // that has not been appended and stop request scheduling. We also need to store
                                    // the promise for this append because the next data can be appended only after
                                    // this promise is resolved.
                                    if (result.err.code === MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_QUOTA_EXCEEDED) {
                                        rejectedBytes = {
                                            data: data,
                                            quality: quality,
                                            index: index
                                        };
                                        deferredRejectedDataAppend = deferred;
                                        isQuotaExceeded = true;
                                        fragmentsToLoad = 0;
                                        // stop scheduling new requests
                                        doStop.call(self);
                                    }
                                }
                            );
                        }
                    );
                }
            );

            return deferred.promise;
        },

        debugBufferRange = function() {
            var ranges = null,
                i,
                len;

            if (this.debug.getLevel() >= this.debug.INFO) {
                if (buffer) {
                    ranges = this.sourceBufferExt.getAllRanges(buffer);
                    if ((ranges === null) || (ranges.length === 0)) {
                        return;
                    }
                    for (i = 0, len = ranges.length; i < len; i += 1) {
                        this.debug.info("[BufferController][" + type + "] Buffered range [" + i + "]: " + ranges.start(i) + " - " + ranges.end(i) + " (" + this.getVideoModel().getCurrentTime() + ")");
                    }
                }
            }
        },

        handleInbandEvents = function(data, request, adaptionSetInbandEvents, representationInbandEvents) {
            var events = [],
                i = 0,
                identifier,
                size,
                expTwo = Math.pow(256, 2),
                expThree = Math.pow(256, 3),
                segmentStarttime = Math.max(isNaN(request.startTime) ? 0 : request.startTime, 0),
                eventStreams = [],
                inbandEvents;

            inbandEventFound = false;
            /* Extract the possible schemeIdUri : If a DASH client detects an event message box with a scheme that is not defined in MPD, the client is expected to ignore it */
            inbandEvents = adaptionSetInbandEvents.concat(representationInbandEvents);
            for (var loop = 0; loop < inbandEvents.length; loop++) {
                eventStreams[inbandEvents[loop].schemeIdUri] = inbandEvents[loop];
            }
            while (i < data.length) {
                identifier = String.fromCharCode(data[i + 4], data[i + 5], data[i + 6], data[i + 7]); // box identifier
                size = data[i] * expThree + data[i + 1] * expTwo + data[i + 2] * 256 + data[i + 3] * 1; // size of the box
                if (identifier === "moov" || identifier === "moof") {
                    break;
                } else if (identifier === "emsg") {
                    inbandEventFound = true;
                    var eventBox = ["", "", 0, 0, 0, 0, ""],
                        arrIndex = 0,
                        j = i + 12; //fullbox header is 12 bytes, thats why we start at 12

                    while (j < size + i) {
                        /* == string terminates with 0, this indicates end of attribute == */
                        if (arrIndex === 0 || arrIndex === 1 || arrIndex === 6) {
                            if (data[j] !== 0) {
                                eventBox[arrIndex] += String.fromCharCode(data[j]);
                            } else {
                                arrIndex += 1;
                            }
                            j += 1;
                        } else {
                            eventBox[arrIndex] = data[j] * expThree + data[j + 1] * expTwo + data[j + 2] * 256 + data[j + 3] * 1;
                            j += 4;
                            arrIndex += 1;
                        }
                    }
                    var schemeIdUri = eventBox[0],
                        value = eventBox[1],
                        timescale = eventBox[2],
                        presentationTimeDelta = eventBox[3],
                        duration = eventBox[4],
                        id = eventBox[5],
                        messageData = eventBox[6],
                        presentationTime = segmentStarttime * timescale + presentationTimeDelta;

                    if (eventStreams[schemeIdUri]) {
                        var event = new Dash.vo.Event();
                        event.eventStream = eventStreams[schemeIdUri];
                        event.eventStream.value = value;
                        event.eventStream.timescale = timescale;
                        event.duration = duration;
                        event.id = id;
                        event.presentationTime = presentationTime;
                        event.messageData = messageData;
                        event.presentationTimeDelta = presentationTimeDelta;
                        events.push(event);
                    }
                }
                i += size;
            }
            return events;
        },

        deleteInbandEvents = function(data) {

            if (!inbandEventFound) {
                return data;
            }

            var length = data.length,
                i = 0,
                j = 0,
                l = 0,
                identifier,
                size,
                expTwo = Math.pow(256, 2),
                expThree = Math.pow(256, 3),
                modData = new Uint8Array(data.length);


            while (i < length) {

                identifier = String.fromCharCode(data[i + 4], data[i + 5], data[i + 6], data[i + 7]);
                size = data[i] * expThree + data[i + 1] * expTwo + data[i + 2] * 256 + data[i + 3] * 1;


                if (identifier !== "emsg") {
                    for (l = i; l < i + size; l++) {
                        modData[j] = data[l];
                        j += 1;
                    }
                }
                i += size;

            }

            return modData.subarray(0, j);

        },

        isRunning = function() {
            var self = this;
            if (started) {
                return true;
            }

            // If buffering process is running, then we interrupt it
            signalSegmentBuffered.call(self);

            return false;
        },

        signalSegmentBuffered = function() {
            if (deferredFragmentBuffered) {
                //self.debug.log("[BufferController]["+type+"] End of buffering process");
                deferredFragmentBuffered.resolve();
                deferredFragmentBuffered = null;
            }
        },

        hasEnoughSpaceToAppend = function() {
            var self = this,
                deferred = Q.defer(),
                removedTime = 0,
                fragmentDuration,
                startClearing;

            // do not remove any data until the quota is exceeded
            if (!isQuotaExceeded) {
                return Q.when(true);
            }

            startClearing = function() {
                var self = this,
                    currentTime = self.videoModel.getCurrentTime(),
                    removeStart = 0,
                    removeEnd,
                    req;

                // we need to remove data that is more than one segment before the video currentTime
                req = self.fragmentController.getExecutedRequestForTime(fragmentModel, currentTime);
                removeEnd = (req && !isNaN(req.startTime)) ? req.startTime : Math.floor(currentTime);
                fragmentDuration = (req && !isNaN(req.duration)) ? req.duration : 1;

                removeBuffer.call(self, removeStart, removeEnd).then(
                    function(removedTimeValue) {
                        removedTime += removedTimeValue;
                        if (removedTime >= fragmentDuration) {
                            deferred.resolve();
                        } else {
                            setTimeout(startClearing, fragmentDuration * 1000);
                        }
                    }
                );
            };

            startClearing.call(self);

            return deferred.promise;
        },

        removeBuffer = function(start, end) {
            var self = this,
                deferred = Q.defer(),
                removeStart,
                removeEnd;

            if (buffer.buffered.length === 0) {
                deferred.resolve(0);
                return deferred.promise;
            }

            removeStart = ((start !== undefined) && (start !== -1)) ? start : buffer.buffered.start(0);
            removeEnd = ((end !== undefined) && (end !== -1)) ? end : buffer.buffered.end(buffer.buffered.length - 1);

            if (removeEnd <= removeStart) {
                deferred.resolve(0);
                return deferred.promise;
            }

            self.debug.info("[BufferController][" + type + "] Remove from " + removeStart + " to " + removeEnd + " (" + self.getVideoModel().getCurrentTime() + ")");

            // Abort on buffer
            if (type !== "text") {
                // no need to abort for text buffer. remove call do the same thing
                self.sourceBufferExt.abort(mediaSource, buffer);
            }

            // Wait for buffer update completed
            self.sourceBufferExt.remove(buffer, removeStart, removeEnd, periodInfo.duration, mediaSource, appendSync).then(
                function() {
                    // Remove all requests from the list of the executed requests
                    self.fragmentController.removeExecutedRequestsBeforeTime(fragmentModel, removeEnd + 1); // +1 for rounding issues
                    self.fragmentController.cancelPendingRequestsForModel(fragmentModel);
                    deferred.resolve(removeEnd - removeStart);
                }, function(ex) {
                    self.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_REMOVE_SOURCEBUFFER, "Failed to remove data from " + type + " source buffer",
                        new MediaPlayer.vo.Error(ex.code, ex.name, ex.message));
                    deferred.resolve(0);
                }
            );

            return deferred.promise;
        },

        onBytesError = function(e) {

            if (!isRunning.call(this)) {
                return;
            }

            signalSegmentBuffered.call(this);

            // Abandonned request => load segment at lowest quality
            if (e.aborted) {
                // if (e.quality !== 0) {
                // this.debug.info("[BufferController][" + type + "] Segment download abandonned => Retry segment download at lowest quality");
                // this.abrController.setAutoSwitchFor(type, false);
                // this.abrController.setQualityFor(type, 0);
                bufferFragment.call(this);
                // }
                return;
            }

            // Ignore in case of text track, this will not stop playing
            if (type === "text") {

                this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT,
                    "Failed to download media segment", {
                        url: e.url,
                        status: e.status
                    });

                return;
            }

            // Segment download failed
            segmentDownloadErrorCount += 1;

            if (segmentDownloadErrorCount === SEGMENT_DOWNLOAD_ERROR_MAX) {
                // If failed consecutively SEGMENT_DOWNLOAD_ERROR_MAX times, then raise an error
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT,
                    "Failed to download media segment", {
                        url: e.url,
                        status: e.status
                    });
            } else {
                // Raise a warning
                this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT,
                    "Failed to download media segment", {
                        url: e.url,
                        status: e.status
                    });

                // Store segment request that failed to load
                segmentRequestOnError = e;
                if (htmlVideoState === BUFFERING) {
                    // If already in buffering state (i.e. empty buffer) then signal to stream that segment loading failed
                    // Else signal it when entering in buffering state (see updateBufferState())
                    signalSegmentLoadingFailed.call(this);
                }
            }
        },

        signalStreamComplete = function( /*request*/ ) {
            var self = this;

            self.debug.log("[BufferController][" + type + "] Stream is complete.");

            isBufferingCompleted = true;
            clearPlayListTraceMetrics(new Date(), MediaPlayer.vo.metrics.PlayList.Trace.END_OF_CONTENT_STOP_REASON);

            signalSegmentBuffered.call(self);

            doStop.call(self);

            self.system.notify("bufferingCompleted");
        },

        loadInitialization = function(quality) {
            var self = this;

            // Check if running state
            if (!isRunning.call(self)) {
                return Q.when(null);
            }

            // Check if initialization segment for current quality has already been loaded and stored
            if (initializationData[quality]) {
                self.debug.info("[BufferController][" + type + "] Buffer initialization segment, quality = ", quality);
                appendToBuffer.call(this, initializationData[quality], quality).then(
                    function() {
                        self.debug.log("[BufferController][" + type + "] Initialization segment buffered");
                        // Load next media segment
                        if (isRunning()) {
                            loadNextFragment.call(self);
                        }
                    }
                );
                return Q.when(null);
            } else {
                // Get init segment request for the current
                return this.indexHandler.getInitRequest(availableRepresentations[quality]);
            }
        },

        loadNextFragment = function() {
            var self = this,
                time = getWorkingTime.call(self),
                range,
                segmentTime;

            // Check if running state
            if (!isRunning.call(self)) {
                return;
            }

            // Get buffer range that includes working time
            range = self.sourceBufferExt.getBufferRange(buffer, time);

            // Get next segment time
            segmentTime = range ? range.end : time;

            // currentSequenceNumber used in HLS
            if ((currentSequenceNumber !== -1) && !seeking) {
                self.debug.log("[BufferController][" + type + "] loadNextFragment for sequence number: " + currentSequenceNumber);
                self.indexHandler.getNextSegmentRequestFromSN(_currentRepresentation, currentSequenceNumber).then(onFragmentRequest.bind(self));
            } else {
                self.debug.log("[BufferController][" + type + "] loadNextFragment for time: " + segmentTime);
                self.indexHandler.getSegmentRequestForTime(_currentRepresentation, segmentTime).then(onFragmentRequest.bind(self), function (){
                    currentDownloadQuality = -1;
                    signalStreamComplete.call(self);
                });
            }
        },

        onFragmentRequest = function(request) {
            var self = this,
                manifest = self.manifestModel.getValue();

            // Check if current request signals end of stream
            if ((request !== null) && (request.action === request.ACTION_COMPLETE)) {
                signalStreamComplete.call(self);
                return;
            }

            if (request !== null) {
                //if trick mode enbaled, get the request to get I Frame data.
                if (trickModeEnabled) {
                    request = self.indexHandler.getIFrameRequest(request);
                }

                // If we have already loaded the given fragment ask for the next one. Otherwise prepare it to get loaded
                if (self.fragmentController.isFragmentLoadedOrPending(self, request)) {
                    self.debug.log("[BufferController][" + type + "] new fragment request => already loaded or pending");
                    self.indexHandler.getNextSegmentRequest(_currentRepresentation).then(onFragmentRequest.bind(self));
                } else {
                    // Download the segment
                    self.fragmentController.prepareFragmentForLoading(self, request, onBytesLoadingStart, onBytesLoaded, onBytesError, null /*signalStreamComplete*/ );
                    sendRequest.call(self);
                }
            } else {
                // No more fragment in current list
                self.debug.log("[BufferController][" + type + "] loadNextFragment failed");
                signalSegmentBuffered.call(self);

                // If live HLS, then try to refresh playlist
                if (isDynamic) {
                    if (manifest.name === "M3U") {
                        updatePlayListForRepresentation.call(self, currentDownloadQuality).then(
                            function() {
                                _currentRepresentation = getRepresentationForQuality.call(self, currentDownloadQuality);
                                updateCheckBufferTimeout.call(self, 0);
                            }, function(err) {
                                if (err) {
                                    self.errHandler.sendError(err.name, err.message, err.data);
                                }
                            }
                        );
                    }
                }
                /*else {
                    // For VOD streams, signal end of stream
                    signalStreamComplete.call(self);
                }*/
            }
        },

        hasData = function() {
            return !!data && !!buffer;
        },

        getTimeToEnd = function() {
            var currentTime = this.videoModel.getCurrentTime();

            return ((periodInfo.start + periodInfo.duration) - currentTime);
        },

        getWorkingTime = function() {
            var time = -1,
                videoTime = this.videoModel.getCurrentTime();

            if (seeking) {
                time = seekTarget;
                //this.debug.log("[BufferController][" + type + "] Working time = " + time + " (seeking = " + seeking + ", video time = " + videoTime + ")");
            } else {
                time = videoTime;
                //this.debug.log("[BufferController][" + type + "] Working time = " + time);
            }

            return time;
        },

        getLiveEdgeTime = function() {
            var self = this,
                deferred = Q.defer(),
                startTime,
                // Get live edge time from manifest as the last segment time
                liveEdgeTime = _currentRepresentation.segmentAvailabilityRange.end;

            self.debug.log("[BufferController][" + type + "] Manifest live edge = " + liveEdgeTime);

            // Step back from a found live edge time to be able to buffer some data
            startTime = Math.max((liveEdgeTime - minBufferTime), _currentRepresentation.segmentAvailabilityRange.start);

            // Get the request corresponding to the start time
            this.indexHandler.getSegmentRequestForTime(_currentRepresentation, startTime).then(
                function(request) {
                    // Set live edge to be the start time of the founded segment
                    periodInfo.liveEdge = request.startTime;
                    self.debug.log("[BufferController][" + type + "] Live edge = " + periodInfo.liveEdge);

                    deferred.resolve(periodInfo.liveEdge);
                }
            );

            return deferred.promise;
        },

        updateBufferLevel = function(sendMetric) {
            if (!hasData()) {
                return;
            }

            var self = this,
                workingTime = getWorkingTime.call(self);

            bufferLevel = self.sourceBufferExt.getBufferLength(buffer, workingTime);
            self.debug.log("[BufferController][" + type + "] Working time = " + workingTime + ", Buffer level = " + bufferLevel.toFixed(3));
            if (sendMetric) {
                self.metricsModel.addBufferLevel(type, new Date(), bufferLevel);
            }
            self.updateBufferState();
        },

        checkIfSufficientBuffer = function() {
            var self = this,
                timeToEnd,
                delay;

            // Check if running state
            if (!isRunning.call(self)) {
                return;
            }

            self.debug.log("[BufferController][" + type + "] Check buffer...");

            updateBufferLevel.call(self, true);

            // Check stalled mode of video model
            if (stalled) {
                if (bufferLevel > minBufferTimeAtStartup) {
                    setStalled.call(self, false);
                }
            }

            timeToEnd = getTimeToEnd.call(self);
            self.debug.log("[BufferController][" + type + "] time to end = " + timeToEnd);

            //for trick mode, buffer needs to be filled faster
            if (trickModeEnabled) {
                if (bufferLevel < 1) {
                    bufferFragment.call(self);
                }
            } else {
                if (languageChanged ||
                    ((bufferLevel < minBufferTime) &&
                        ((minBufferTime < timeToEnd) || (minBufferTime >= timeToEnd && !isBufferingCompleted)))) {
                    // Buffer needs to be filled
                    bufferFragment.call(self);
                } else {
                    // Determine the timeout delay before checking again the buffer
                    delay = bufferLevel - minBufferTime + 0.5; // + 0.5 to ensure buffer level will be inferior to minBufferTime
                    updateCheckBufferTimeout.call(self, delay);
                }
            }
        },

        updateCheckBufferTimeout = function(delay) {
            var self = this;

            delay = Math.max(delay, (segmentDuration / 2));

            this.debug.log("[BufferController][" + type + "] Check buffer in = " + delay.toFixed(3) + " ms (bufferLevel = " + bufferLevel + ")");

            clearTimeout(bufferTimeout);
            bufferTimeout = setTimeout(function() {
                bufferTimeout = null;
                checkIfSufficientBuffer.call(self);
            }, (delay * 1000));
        },

        cancelCheckBufferTimeout = function() {
            if (bufferTimeout) {
                clearTimeout(bufferTimeout);
                bufferTimeout = null;
                checkIfSufficientBuffer.call(this);
            }
        },

        bufferFragment = function() {
            var self = this,
                now = new Date(),
                currentVideoTime = self.videoModel.getCurrentTime(),
                manifest = self.manifestModel.getValue(),
                quality,
                playlistUpdated = null,
                abrResult;

            if (deferredFragmentBuffered !== null) {
                self.debug.error("[BufferController][" + type + "] deferredFragmentBuffered has not been resolved, create a new one is not correct.");
            }

            deferredFragmentBuffered = Q.defer();

            self.debug.log("[BufferController][" + type + "] Start buffering process...");

            // Check if data has changed
            // If data has been changed, then load initialization segment
            var loadInit = doUpdateData.call(self);
            // Get current quality
            abrResult = self.abrController.getPlaybackQuality(type, data);

            quality = abrResult.quality;

            // Get corresponding representation
            _currentRepresentation = getRepresentationForQuality.call(self, quality);

            // Quality changed?
            if (quality !== currentDownloadQuality) {
                self.debug.log("[BufferController][" + type + "] currentDownloadQuality changed : " + quality);
                currentDownloadQuality = quality;
                // Load initialization segment
                loadInit = true;

                clearPlayListTraceMetrics(new Date(), MediaPlayer.vo.metrics.PlayList.Trace.REPRESENTATION_SWITCH_STOP_REASON);
                self.debug.log("[BufferController][" + type + "] Send RepresentationSwitch with quality = " + quality);
                self.metricsModel.addRepresentationSwitch(type, now, currentVideoTime, _currentRepresentation.id, quality);

                // HLS use case => download playlist for new representation
                if ((manifest.name === "M3U") && (isDynamic || availableRepresentations[quality].initialization === null)) {
                    playlistUpdated = Q.defer();
                    updatePlayListForRepresentation.call(self, quality).then(
                        function() {
                            _currentRepresentation = getRepresentationForQuality.call(self, quality);
                            playlistUpdated.resolve();
                        },
                        function(err) {
                            playlistUpdated.reject(err);
                        }
                    );
                }
            }

            Q.when(playlistUpdated ? playlistUpdated.promise : true).then(
                function() {
                    if (loadInit === true) {
                        // Load initialization segment request
                        loadInitialization.call(self, quality).then(
                            function(request) {
                                if (request !== null) {
                                    self.fragmentController.prepareFragmentForLoading(self, request, onBytesLoadingStart, onBytesLoaded, onBytesError, null /*signalStreamComplete*/ );
                                    sendRequest.call(self);
                                }
                            }, function(e) {
                                signalSegmentBuffered.call(self);
                                if (e.name === MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED) {
                                    self.errHandler.sendError(e.name, e.message, e.data);
                                } else {
                                    self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.INTERNAL_ERROR, "Internal error while processing initialization segment", e.message);
                                }
                            }
                        );
                    } else {
                        // Load next fragment
                        // Notes: 1 - Next fragment is download in // with initialization segment
                        //        2 - Buffer level is checked once next fragment data has been pushed into buffer (@see checkIfSufficientBuffer())
                        loadNextFragment.call(self);
                    }
                },
                function(err) {
                    signalSegmentBuffered();
                    if (err) {
                        self.errHandler.sendError(err.name, err.message, err.data);
                    }
                }
            );

        },

        updatePlayListForRepresentation = function(repIndex) {
            var self = this,
                deferred = Q.defer(),
                manifest = self.manifestModel.getValue(),
                representation,
                idx;


            // Check if running state
            if (!isRunning.call(self)) {
                deferred.reject();
                return deferred.promise;
            }

            idx = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);
            representation = manifest.Period_asArray[periodInfo.index].AdaptationSet_asArray[idx].Representation_asArray[repIndex];
            self.parser.hlsParser.updatePlaylist(representation).then(
                function() {
                    availableRepresentations = updateRepresentations.call(self, data, periodInfo);
                    deferred.resolve();
                },
                function(err) {
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        },

        updateRepresentations = function(data, periodInfo) {
            var manifest = this.manifestModel.getValue(),
                idx,
                adaptations;

            idx = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);
            adaptations = this.manifestExt.getAdaptationsForPeriod(manifest, periodInfo);

            return this.manifestExt.getRepresentationsForAdaptation(manifest, adaptations[idx]);
        },

        doUpdateData = function() {
            if (dataChanged === false) {
                return false;
            }

            this.debug.log("[BufferController][" + type + "] updateData");

            // Reset stored initialization segments
            initializationData = [];

            // Update representations
            availableRepresentations = updateRepresentations.call(this, data, periodInfo);
            this.bufferExt.updateData(data, type);

            dataChanged = false;

            _currentRepresentation = getRepresentationForQuality.call(this, this.abrController.getPlaybackQuality(type, data).quality);

            return true;
        },

        onFragmentLoadProgress = function(evt) {
            var self = this,
                currentQuality = this.abrController.getQualityFor(type),
                i,
                rules;

            // Check only if not at lowest quality
            if (this.abrController.isMinQuality(type, data, currentQuality)) {
                return;
            }

            rules = self.abrRulesCollection.getRules(MediaPlayer.rules.BaseRulesCollection.prototype.ABANDON_FRAGMENT_RULES);
            var callback = function(switchRequest) {
                if (switchRequest.quality < currentQuality) {
                    self.fragmentController.abortRequestsForModel(fragmentModel);
                    self.debug.info("[BufferController][" + type + "] Abandon current segment download");
                }
            };

            for (i = 0; i < rules.length; i++) {
                rules[i].execute(evt.data.request, callback);
            }
        },

        signalSegmentLoadingFailed = function() {
            if (segmentRequestOnError === null) {
                return;
            }
            this.debug.log("[BufferController][" + type + "] Signal segment loading failed");
            this.system.notify("segmentLoadingFailed", segmentRequestOnError);
            segmentRequestOnError = null;
        };

    return {
        videoModel: undefined,
        metricsModel: undefined,
        manifestExt: undefined,
        manifestModel: undefined,
        bufferExt: undefined,
        sourceBufferExt: undefined,
        abrController: undefined,
        parser: undefined,
        fragmentExt: undefined,
        indexHandler: undefined,
        debug: undefined,
        system: undefined,
        errHandler: undefined,
        config: undefined,
        abrRulesCollection: undefined,

        initialize: function(type, newPeriodInfo, newData, buffer, fragmentController, source, eventController) {
            var self = this,
                manifest = self.manifestModel.getValue();

            self.debug.log("[BufferController][" + type + "] Initialize");

            // PATCH for Espial browser which implements SourceBuffer appending/removing synchronoulsy
            if (navigator.userAgent.indexOf("Espial") !== -1) {
                self.debug.log("[BufferController][" + type + "] Espial browser = sync append");
                appendSync = true;
            }
            self[MediaPlayer.dependencies.FragmentLoader.eventList.ENAME_LOADING_PROGRESS] = onFragmentLoadProgress;

            isDynamic = self.manifestExt.getIsDynamic(manifest);
            self.setMediaSource(source);
            self.setType(type);
            self.setBuffer(buffer);
            self.setFragmentController(fragmentController);
            self.setEventController(eventController);
            minBufferTime = self.config.getParamFor(type, "BufferController.minBufferTime", "number", -1);
            minBufferTimeAtStartup = self.config.getParamFor(type, "BufferController.minBufferTimeForPlaying", "number", 0);

            data = newData;
            periodInfo = newPeriodInfo;
            dataChanged = true;

            self.load();

            ready = true;
        },

        load: function() {
            var self = this,
                manifest = self.manifestModel.getValue();

            doUpdateData.call(this);

            // Retreive the representation of initial quality to enable some parameters initialization
            // (@see getLiveEdgeTime() for example)
            _currentRepresentation = getRepresentationForQuality.call(self, self.abrController.getPlaybackQuality(type, data).quality);

            currentDownloadQuality = -1;

            if (_currentRepresentation) {
                self.indexHandler.setIsDynamic(isDynamic);
                if (minBufferTime === -1) {
                    minBufferTime = self.bufferExt.decideBufferLength(manifest.minBufferTime, periodInfo.duration, waitingForBuffer);
                }
                // Update manifest's minBufferTime value
                manifest.minBufferTime = minBufferTime;
                if (type === "video") {
                    if (isDynamic) {
                        self.indexHandler.updateSegmentList(_currentRepresentation).then(
                            function() {
                                getLiveEdgeTime.call(self).then(
                                    function(time) {
                                        self.system.notify("startTimeFound", time);
                                    }
                                );
                            }
                        );
                    } else {
                        self.indexHandler.getCurrentTime(_currentRepresentation).then(
                            function(time) {
                                if (time < _currentRepresentation.segmentAvailabilityRange.start) {
                                    time = _currentRepresentation.segmentAvailabilityRange.start;
                                }
                                self.system.notify("startTimeFound", time);
                            }
                        );
                    }
                }
            }
        },

        getIndexHandler: function() {
            return this.indexHandler;
        },

        getType: function() {
            return type;
        },

        setType: function(value) {
            type = value;

            if (this.indexHandler !== undefined) {
                this.indexHandler.setType(value);
            }
        },

        getPeriodInfo: function() {
            return periodInfo;
        },

        getVideoModel: function() {
            return this.videoModel;
        },

        setVideoModel: function(value) {
            this.videoModel = value;
        },

        getFragmentController: function() {
            return this.fragmentController;
        },

        setFragmentController: function(value) {
            if (value) {
                this.fragmentController = value;
                fragmentModel = this.fragmentController.attachBufferController(this);
                fragmentModel.fragmentLoader.subscribe(MediaPlayer.dependencies.FragmentLoader.eventList.ENAME_LOADING_PROGRESS, this);
                fragmentModel.setType(type);
            }
        },

        setEventController: function(value) {
            this.eventController = value;
        },

        getData: function() {
            return data;
        },

        updateData: function(newData, newPeriodInfo) {
            var self = this;

            self.debug.log("[BufferController][" + type + "] Update data");

            // Set the new data
            languageChanged = (data && ((data.lang !== null ? data.lang : data.id) !== ((newData.lang !== null ? newData.lang : newData.id)))) ? true : false;
            data = newData;
            periodInfo = newPeriodInfo;
            dataChanged = true;

            // If data language changed (audio or text) then seek to current time
            // in order to switch to new language as soon as possible (see appendToBuffer())
            if (languageChanged) {
                self.debug.log("[BufferController][" + type + "] Language changed");
                cancelCheckBufferTimeout.call(this);
                //for xml subtitles file, reset cues and restart buffering
                if (type === 'text' && (data.mimeType === 'application/ttml+xml')) {
                    buffer.abort();
                    isBufferingCompleted = false;
                    doStart.call(self);
                }
            }
        },

        getHtmlVideoState: function() {
            return htmlVideoState;
        },

        getAvailableRepresentations: function() {
            return availableRepresentations;
        },

        getCurrentRepresentation: function() {
            return _currentRepresentation;
        },

        getBuffer: function() {
            return buffer;
        },

        setBuffer: function(value) {
            buffer = value;
        },

        getMinBufferTime: function() {
            return minBufferTime;
        },

        setMinBufferTime: function(value) {
            minBufferTime = value;
        },

        setMediaSource: function(value) {
            mediaSource = value;
        },

        isReady: function() {
            return state === READY;
        },

        isBufferingCompleted: function() {
            return isBufferingCompleted;
        },

        clearMetrics: function() {
            if (type === null || type === "") {
                return;
            }

            this.metricsModel.clearCurrentMetricsForType(type);
        },

        updateManifest: function() {
            this.system.notify("manifestUpdate");
        },

        updateBufferState: function() {
            var self = this,
                currentTime = this.videoModel.getCurrentTime(),//getWorkingTime.call(this),
                previousTime = htmlVideoTime === -1 ? currentTime : htmlVideoTime,
                progress = (currentTime - previousTime),
                ranges;

            clearTimeout(bufferStateTimeout);
            bufferStateTimeout = null;

            if (started === false) {
                return;
            }

            if (type === "text") {
                return;
            }

            if (trickModeEnabled) {
                return;
            }

            //this.debug.log("#### [" + type + "] level = " + bufferLevel + ", currentTime = " + currentTime + ", progress = " + progress);

            switch (htmlVideoState) {
                case INIT:
                    htmlVideoState = BUFFERING;
                    this.debug.info("[BufferController][" + type + "] BUFFERING - " + currentTime + " - " + bufferLevel);
                    this.metricsModel.addState(type, "buffering", currentTime);
                    break;

                case BUFFERING:
                    if (!this.getVideoModel().isPaused() &&
                        ((progress > 0) && (bufferLevel >= 1))) {
                        htmlVideoState = PLAYING;
                        this.debug.info("[BufferController][" + type + "] PLAYING - " + currentTime);
                        this.metricsModel.addState(type, "playing", currentTime);
                        // Reset seeking state since on some browsers (Edge) seeked event may not be raised
                        seeking = false;
                        seekTarget = -1;

                        // Reset segment download error status
                        segmentDownloadErrorCount = 0;
                    } else if (!this.getVideoModel().isStalled()) {
                        ranges = this.sourceBufferExt.getAllRanges(buffer);
                        /*if (ranges.length > 0) {
                            var workingTime = getWorkingTime.call(this),
                                gap = workingTime - ranges.end(ranges.length - 1);
                            if (gap > 4) {
                                this.debug.log("[BufferController][" + type + "] BUFFERING - delay from current time = " + gap);
                                signalSegmentLoadingFailed.call(this);
                            }
                        }*/
                    }
                    break;

                case PLAYING:
                    if (!this.getVideoModel().isPaused() &&
                        ((progress <= 0 && bufferLevel <= 1) || (bufferLevel === 0))) {
                        htmlVideoState = BUFFERING;
                        this.debug.info("[BufferController][" + type + "] BUFFERING - " + currentTime + " - " + bufferLevel);
                        this.metricsModel.addState(type, "buffering", currentTime);

                        // Check if there is a hole in the buffer (segment download failed or input stream discontinuity), then skip it
                        ranges = this.sourceBufferExt.getAllRanges(buffer);
                        var i;
                        for (i = 0; i < ranges.length; i++) {
                            if (currentTime < ranges.start(i)) {
                                break;
                            }
                        }
                        if (i < ranges.length) {
                            // Seek to next available range
                            this.videoModel.setCurrentTime(ranges.start(i));
                        } else {
                            // Else buffering may be due to segment download failure (see onBytesError()), then signal it to Stream (see Stream.onBufferFailed())
                            signalSegmentLoadingFailed.call(this);
                        }
                    }

                    bufferStateTimeout = setTimeout(function() {
                        bufferStateTimeout = null;
                        updateBufferLevel.call(self, false);
                    }, 1000);

                    break;
            }

            if (currentTime > 0) {
                htmlVideoTime = currentTime;
            }
        },

        updateStalledState: function() {
            stalled = this.videoModel.isStalled();
        },

        reset: function(errored) {
            var self = this,
                cancel = function cancelDeferred(d) {
                    if (d) {
                        d.reject();
                        d = null;
                    }
                },
                deferred = Q.defer();

            doStop.call(self);
            // Wait for current buffering process to be completed before restarting
            self.sourceBufferExt.abort(mediaSource, buffer);

            Q.when(deferredFragmentBuffered ? deferredFragmentBuffered.promise : true).then(
                function() {
                    cancel(deferredRejectedDataAppend);
                    cancel(deferredBuffersFlatten);
                    cancel(deferredFragmentBuffered);

                    if (fragmentModel) {
                        fragmentModel.fragmentLoader.unsubscribe(MediaPlayer.dependencies.FragmentLoader.eventList.ENAME_LOADING_PROGRESS, self.abrController);
                        self.fragmentController.abortRequestsForModel(fragmentModel);
                        self.fragmentController.detachBufferController(fragmentModel);
                        fragmentModel = null;
                    }

                    self.clearMetrics();
                    initializationData = [];
                    initialPlayback = true;
                    isQuotaExceeded = false;
                    rejectedBytes = null;
                    appendingRejectedData = false;

                    if (!errored) {
                        self.sourceBufferExt.removeSourceBuffer(mediaSource, buffer);
                    }
                    data = null;
                    buffer = null;

                    deferred.resolve();
                }, function() {
                    deferred.reject();
                }
            );

            return deferred.promise;
        },

        getSegmentDuration: function() {
            return segmentDuration;
        },

        setTrickMode: function(enabled, forward) {
            var deferred = Q.defer();

            this.debug.log("[BufferController][" + type + "] setTrickMode - enabled = " + enabled);

            if (trickModeEnabled === enabled) {
                deferred.resolve();
                return deferred.promise;
            }
            trickModeEnabled = enabled;

            if (trickModeEnabled) {
                // Trick mode enabled
                // => store current quality and auto switch state
                // => disable auto switch and set lowest quality
                trickModeForward = forward;
                trickModePreviousQuality = this.abrController.getQualityFor(type);
                trickModePreviousAutoSwitch = this.abrController.getAutoSwitchFor(type);
                this.abrController.setAutoSwitchFor(type, false);
                this.abrController.setQualityFor(type, 0);
                deferred.resolve();
            } else {
                // Trick mode disabled
                // => restore ABR quality and auto switch state
                this.abrController.setAutoSwitchFor(type, trickModePreviousAutoSwitch);
                this.abrController.setQualityFor(type, trickModePreviousQuality);
                removeBuffer.call(this).then(function() {
                    deferred.resolve();
                });
            }

            return deferred.promise;
        },

        start: doStart,
        seek: doSeek,
        stop: doStop,
        seeked: doSeeked,
        updateBufferLevel: updateBufferLevel
    };
};

MediaPlayer.dependencies.BufferController.prototype = {
    constructor: MediaPlayer.dependencies.BufferController
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.BufferExtensions = function () {
    "use strict";

    var minBufferTarget,
        currentBufferTarget,
        topAudioQualityIndex = 0,
        topVideoQualityIndex = 0,
        audioData = null,
        videoData = null,

        getCurrentHttpRequestLatency = function(metrics) {
            var httpRequest = this.metricsExt.getCurrentHttpRequest(metrics);
            if (httpRequest !== null) {
                return (httpRequest.tresponse.getTime() - httpRequest.trequest.getTime()) / 1000;
            }
            return 0;
        },

        isPlayingAtTopQuality = function() {
            var self = this,
                audioQuality,
                videoQuality,
                isAtTop;

            audioQuality = audioData ? self.abrController.getQualityFor("audio") : topAudioQualityIndex;
            videoQuality = videoData ? self.abrController.getQualityFor("video") : topVideoQualityIndex;

            isAtTop = (audioQuality === topAudioQualityIndex) &&
                (videoQuality === topVideoQualityIndex);

            return isAtTop;
        };

    return {
        system:undefined,
        videoModel: undefined,
        metricsExt: undefined,
        metricsModel: undefined,
        abrController: undefined,
        bufferMax: undefined,

        updateData: function(data, type) {
            if (data) {
                var topIndex = data.Representation_asArray.length - 1;

                if (type === "audio") {
                    topAudioQualityIndex = topIndex;
                    audioData = data;
                } else if (type === "video") {
                    topVideoQualityIndex = topIndex;
                    videoData = data;
                }
            }
        },

        getTopQualityIndex: function(type) {
            var topQualityIndex = null;

            if (type === "audio") {
                topQualityIndex = topAudioQualityIndex;
            } else if (type === "video") {
                topQualityIndex = topVideoQualityIndex;
            }

            return topQualityIndex;
        },

        decideBufferLength: function (minBufferTime, duration/*, waitingForBuffer*/) {
            if (isNaN(duration) || MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME < duration && minBufferTime < duration) {
                minBufferTarget = Math.max(MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME, minBufferTime);
            } else if (minBufferTime >= duration) {
                minBufferTarget = Math.min(duration, MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME);
            } else {
                minBufferTarget = Math.min(duration, minBufferTime);
            }

            return minBufferTarget;
        },

        getLeastBufferLevel: function() {
            var videoMetrics = this.metricsModel.getReadOnlyMetricsFor("video"),
                videoBufferLevel = this.metricsExt.getCurrentBufferLevel(videoMetrics),
                audioMetrics = this.metricsModel.getReadOnlyMetricsFor("audio"),
                audioBufferLevel = this.metricsExt.getCurrentBufferLevel(audioMetrics),
                leastLevel = null;

            if (videoBufferLevel === null || audioBufferLevel === null) {
                leastLevel = (audioBufferLevel !== null) ? audioBufferLevel.level : ((videoBufferLevel !== null) ? videoBufferLevel.level : null);
            } else {
                leastLevel = Math.min(audioBufferLevel.level, videoBufferLevel.level);
            }

            return leastLevel;
        },

        getRequiredBufferLength: function (waitingForBuffer, delay, isDynamic, duration) {
            var self = this,
                vmetrics = self.metricsModel.getReadOnlyMetricsFor("video"),
                ametrics = self.metricsModel.getReadOnlyMetricsFor("audio"),
                isLongFormContent = (duration >= MediaPlayer.dependencies.BufferExtensions.LONG_FORM_CONTENT_DURATION_THRESHOLD),
                deferred = Q.defer(),
                isAtTop = false,
                requiredBufferLength;

            if (self.bufferMax === MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_MIN) {
                requiredBufferLength = minBufferTarget;
                deferred.resolve(requiredBufferLength);
            } else if (self.bufferMax === MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_INFINITY) {
                requiredBufferLength = duration;
                deferred.resolve(requiredBufferLength);
            } else if (self.bufferMax === MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_REQUIRED) {
                currentBufferTarget = minBufferTarget;

                if (!isDynamic) {
                    if (!waitingForBuffer) {
                        isAtTop = isPlayingAtTopQuality.call(self);
                    }
                }

                        if (isAtTop) {
                            currentBufferTarget = isLongFormContent ?
                                MediaPlayer.dependencies.BufferExtensions.BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM :
                                MediaPlayer.dependencies.BufferExtensions.BUFFER_TIME_AT_TOP_QUALITY;
                        }

                        requiredBufferLength = currentBufferTarget + delay + Math.max(getCurrentHttpRequestLatency.call(self, vmetrics),
                            getCurrentHttpRequestLatency.call(self, ametrics));

                        deferred.resolve(requiredBufferLength);
            } else {
                deferred.reject("invalid bufferMax value: " + self.bufferMax);
            }

            return deferred.promise;
        },

        //TODO: need to add this info to MediaPlayer.vo.metrics.BufferLevel or create new metric?
        getBufferTarget: function() {
            return currentBufferTarget === undefined ? minBufferTarget : currentBufferTarget;
        }
    };
};

MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_REQUIRED = "required";
MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_MIN = "min";
MediaPlayer.dependencies.BufferExtensions.BUFFER_SIZE_INFINITY = "infinity";
MediaPlayer.dependencies.BufferExtensions.BUFFER_TIME_AT_STARTUP = 1;
MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME = 16;
MediaPlayer.dependencies.BufferExtensions.BUFFER_TIME_AT_TOP_QUALITY = 30;
MediaPlayer.dependencies.BufferExtensions.BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM = 300;
MediaPlayer.dependencies.BufferExtensions.LONG_FORM_CONTENT_DURATION_THRESHOLD = 600;
MediaPlayer.dependencies.BufferExtensions.prototype.constructor = MediaPlayer.dependencies.BufferExtensions;

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.Capabilities = function () {
    "use strict";
};

MediaPlayer.utils.Capabilities.prototype = {
    constructor: MediaPlayer.utils.Capabilities,
    system: undefined,

    supportsMediaSource: function () {
        "use strict";

        var hasWebKit = ("WebKitMediaSource" in window),
            hasMediaSource = ("MediaSource" in window);

        return (hasWebKit || hasMediaSource);
    },

    supportsMediaKeys: function () {
        "use strict";

        var hasWebKit = ("WebKitMediaKeys" in window),
            hasMs = ("MSMediaKeys" in window),
            hasMediaSource = ("MediaKeys" in window);

        return (hasWebKit || hasMs || hasMediaSource);
    },

    /**
     * Returns whether Encrypted Media Extensions are supported on this
     * user agent
     *
     * @return {boolean} true if EME is supported, false otherwise
     */
    supportsEncryptedMedia: function () {
        return this.system.hasMapping('protectionModel');
    },

    supportsCodec: function (element, codec) {
        "use strict";

        if (!(element instanceof HTMLMediaElement)) {
            throw "element must be of type HTMLMediaElement.";
        }

        var canPlay = element.canPlayType(codec);
        return (canPlay === "probably" || canPlay === "maybe");
    }
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.Config = function () {
    "use strict";

    var paramsType = ["video", "audio"],

        // Default configuration, provides list of possible parameters
        params = {
            // BufferController parameters
            "BufferController.minBufferTimeForPlaying": 3,
            "BufferController.minBufferTime": 70,
            // ABR parameters
            "ABR.minBandwidth": -1,
            "ABR.maxBandwidth": -1,
            "ABR.minQuality": -1,
            "ABR.maxQuality": -1,
            "ABR.switchUpIncrementally": false,
            "ABR.switchUpRatioSafetyFactor": -1,
            "ABR.latencyInBandwidth": true,
            "ABR.switchDownBufferTime": -1,
            "ABR.switchDownBufferRatio": -1,
            "ABR.switchLowerBufferTime": -1,
            "ABR.switchLowerBufferRatio": -1,
            "ABR.switchUpBufferTime": -1,
            "ABR.switchUpBufferRatio": -1,
            "ABR.keepBandwidthCondition": true,
            "ABR.droppedFramesMinRatio": -1,
            "ABR.droppedFramesMaxRatio": -1,
            // Manifest loader parameters
            "ManifestLoader.RetryAttempts": -1,
            "ManifestLoader.RetryInterval": -1,
            // Fragment loader parameters
            "FragmentLoader.RetryAttempts": -1,
            "FragmentLoader.RetryInterval": -1,
            // Video parameters
            "video": {
            },
            // Audio parameters
            "audio": {
            }
        },

        doSetParams = function (newParams) {
            var item,
                typeParams,
                typeItem;

            for (item in newParams) {
                if (newParams.hasOwnProperty(item)) {
                    // Check if comment
                    if (item.indexOf('//') === -1) {
                        // Check if type parameters
                        if (paramsType.indexOf(item) > -1) {
                            typeParams = newParams[item];
                            for (typeItem in typeParams) {
                                if (typeParams.hasOwnProperty(typeItem)) {
                                    params[item][typeItem] = newParams[item][typeItem];
                                }
                            }
                        } else {
                            params[item] = newParams[item];
                        }
                    }
                }
            }
        },

        getParam = function (params, name, type, def) {
            var value = params[name];

            if ((value === undefined) || (value === -1)) {
                return def;
            }

            if ((type !== undefined) && (typeof value !== type)) {
                switch (type) {
                    case 'number':
                        value = Number(value);
                        break;
                    case 'boolean':
                        value = (value === 'true') ||
                                (value === '1') ||
                                (value === 1);
                        break;
                    default:
                        break;
                }
            }

            return value;
        },

        doGetParam = function (name, type, def) {
            return getParam(params, name, type, def);
        },

        doGetParamFor = function (key, name, type, def) {
            var typeParams = params[key];

            if ((typeParams !== undefined) && (typeParams[name] !== undefined)) {
                return getParam(typeParams, name, type, def);
            }

            return getParam(params, name, type, def);
        };

    return {
        debug: undefined,

        setup: function () {
        },

        setParams: function (newParams) {
            doSetParams(newParams);

            // Update debugger level if set in config
            var level = this.getParam("Debug.level", "number", -1);
            if (level !== -1) {
                this.debug.setLevel(level);
            }
        },

        getParam: function (name, type, def) {
            return doGetParam(name, type, def);
        },

        getParamFor: function (key, name, type, def) {
            return doGetParamFor(key, name, type, def);
        }
    };
};

MediaPlayer.utils.Config.prototype = {
    constructor: MediaPlayer.utils.Config
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.di.Context = function () {
    "use strict";

    var mapProtectionModel = function() {
        var videoElement = document.createElement("video"),
            debug = this.system.getObject("debug");

        // Detect EME APIs.  Look for newest API versions first
        if (MediaPlayer.models.ProtectionModel_21Jan2015.detect(videoElement)) {
            this.system.mapSingleton('protectionModel', MediaPlayer.models.ProtectionModel_21Jan2015);
        } else if (MediaPlayer.models.ProtectionModel_3Feb2014.detect(videoElement)) {
            this.system.mapClass('protectionModel', MediaPlayer.models.ProtectionModel_3Feb2014);
        } else if (MediaPlayer.models.ProtectionModel_01b.detect(videoElement)) {
            this.system.mapClass('protectionModel', MediaPlayer.models.ProtectionModel_01b);
        } else {
            debug.log("No supported version of EME detected on this user agent!");
            debug.log("Attempts to play encrypted content will fail!");
        }
    };

    return {
        system : undefined,
        setup : function () {
            this.system.autoMapOutlets = true;

            // MediaPlayer.utils.*
            this.system.mapSingleton('capabilities', MediaPlayer.utils.Capabilities);
            this.system.mapSingleton('config', MediaPlayer.utils.Config);
            this.system.mapSingleton('debug', MediaPlayer.utils.Debug);
            this.system.mapSingleton('debugController', MediaPlayer.utils.DebugController);
            this.system.mapClass('domParser', MediaPlayer.utils.DOMParser);
            this.system.mapSingleton('eventBus', MediaPlayer.utils.EventBus);
            this.system.mapSingleton('textTrackExtensions', MediaPlayer.utils.TextTrackExtensions);
            this.system.mapSingleton('tokenAuthentication', MediaPlayer.utils.TokenAuthentication);
            this.system.mapSingleton('vttParser', MediaPlayer.utils.VTTParser);
            this.system.mapSingleton('ttmlParser', MediaPlayer.utils.TTMLParser);

            // MediaPlayer.models.*
            this.system.mapSingleton('manifestModel', MediaPlayer.models.ManifestModel);
            this.system.mapClass('metrics', MediaPlayer.models.MetricsList);
            this.system.mapSingleton('metricsModel', MediaPlayer.models.MetricsModel);
            this.system.mapSingleton('uriQueryFragModel', MediaPlayer.models.URIQueryAndFragmentModel);
            this.system.mapSingleton('videoModel', MediaPlayer.models.VideoModel);

            // MediaPlayer.dependencies.*
            this.system.mapSingleton('abrController', MediaPlayer.dependencies.AbrController);
            this.system.mapClass('bufferController', MediaPlayer.dependencies.BufferController);
            this.system.mapSingleton('bufferExt', MediaPlayer.dependencies.BufferExtensions);
            this.system.mapSingleton('errHandler', MediaPlayer.dependencies.ErrorHandler);
            this.system.mapClass('eventController', MediaPlayer.dependencies.EventController);
            this.system.mapClass('fragmentController', MediaPlayer.dependencies.FragmentController);
            this.system.mapClass('fragmentInfoController', MediaPlayer.dependencies.FragmentInfoController);
            this.system.mapClass('fragmentLoader', MediaPlayer.dependencies.FragmentLoader);
            this.system.mapClass('fragmentModel', MediaPlayer.dependencies.FragmentModel);
            this.system.mapClass('manifestLoader', MediaPlayer.dependencies.ManifestLoader);
            this.system.mapSingleton('manifestUpdater', MediaPlayer.dependencies.ManifestUpdater);
            this.system.mapSingleton('mediaSourceExt', MediaPlayer.dependencies.MediaSourceExtensions);
            this.system.mapSingleton('notifier', MediaPlayer.dependencies.Notifier);
            this.system.mapSingleton('sourceBufferExt', MediaPlayer.dependencies.SourceBufferExtensions);
            this.system.mapClass('stream', MediaPlayer.dependencies.Stream);
            this.system.mapSingleton('streamController', MediaPlayer.dependencies.StreamController);
            this.system.mapClass('textController', MediaPlayer.dependencies.TextController);
            this.system.mapSingleton('textSourceBuffer', MediaPlayer.dependencies.TextSourceBuffer);
            this.system.mapSingleton('textTTMLXMLMP4SourceBuffer', MediaPlayer.dependencies.TextTTMLXMLMP4SourceBuffer);
            this.system.mapSingleton('videoExt', MediaPlayer.dependencies.VideoModelExtensions);

            // MediaPlayer.dependencies.protection.*
            this.system.mapClass('protectionController', MediaPlayer.dependencies.ProtectionController);
            this.system.mapSingleton('protectionExt', MediaPlayer.dependencies.ProtectionExtensions);
            this.system.mapSingleton('ksClearKey', MediaPlayer.dependencies.protection.KeySystem_ClearKey);
            this.system.mapSingleton('ksPlayReady', MediaPlayer.dependencies.protection.KeySystem_PlayReady);
            this.system.mapSingleton('ksWidevine', MediaPlayer.dependencies.protection.KeySystem_Widevine);
            this.system.mapSingleton('serverClearKey', MediaPlayer.dependencies.protection.servers.ClearKey);
            this.system.mapSingleton('serverDRMToday', MediaPlayer.dependencies.protection.servers.DRMToday);
            this.system.mapSingleton('serverPlayReady', MediaPlayer.dependencies.protection.servers.PlayReady);
            this.system.mapSingleton('serverWidevine', MediaPlayer.dependencies.protection.servers.Widevine);
            mapProtectionModel.call(this); // Determines EME API support and version

            // MediaPlayer.rules.*
            this.system.mapClass('abrRulesCollection', MediaPlayer.rules.BaseRulesCollection);
            this.system.mapClass('abandonRequestRule', MediaPlayer.rules.AbandonRequestsRule);
            this.system.mapClass('downloadRatioRule', MediaPlayer.rules.DownloadRatioRule);
            this.system.mapClass('droppedFramesRule', MediaPlayer.rules.DroppedFramesRule);
            this.system.mapClass('insufficientBufferRule', MediaPlayer.rules.InsufficientBufferRule);
            this.system.mapClass('limitSwitchesRule', MediaPlayer.rules.LimitSwitchesRule);

            // Dash.dependencies.*
            this.system.mapClass('baseURLExt', Dash.dependencies.BaseURLExtensions);
            this.system.mapClass('fragmentExt', Dash.dependencies.FragmentExtensions);
            this.system.mapClass('indexHandler', Dash.dependencies.DashHandler);
            this.system.mapSingleton('manifestExt', Dash.dependencies.DashManifestExtensions);
            //this.system.mapSingleton('metricsExt', Dash.dependencies.DashMetricsExtensions);
            this.system.mapSingleton('metricsExt', MediaPlayer.dependencies.MetricsExtensions);
            this.system.mapSingleton('timelineConverter', Dash.dependencies.TimelineConverter);

            this.system.mapSingleton('parser', MediaPlayer.dependencies.Parser);
            this.system.mapClass('dashParser', Dash.dependencies.DashParser);
            this.system.mapClass('mssParser', Mss.dependencies.MssParser);
            this.system.mapClass('hlsParser', Hls.dependencies.HlsParser);
            this.system.mapClass('hlsDemux', Hls.dependencies.HlsDemux);

            // Create the context manager to plug some specific parts of the code
            this.system.mapSingleton('contextManager', MediaPlayer.modules.ContextManager);

            // Plug message handler. When the message is notify, the contextManager is called
            this.system.mapHandler('setContext', 'contextManager', 'setContext');
        }
    };
};

/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.modules.ContextManager = function (){
    "use strict";

    return {
        system: undefined,
        debug: undefined,

        setContext: function(ctx) {
            this.system.autoMapOutlets = true;

            if (ctx === "MSS") {
                // here we map specific Class
                this.system.mapClass('mp4Processor', MediaPlayer.dependencies.Mp4Processor);
                this.system.mapClass('indexHandler', Mss.dependencies.MssHandler);
                this.system.mapClass('fragmentController', Mss.dependencies.MssFragmentController);
            } else if (ctx === "HLS") {
                this.system.mapClass('mp4Processor', MediaPlayer.dependencies.Mp4Processor);
                this.system.mapClass('fragmentController', Hls.dependencies.HlsFragmentController);
                this.system.mapClass('indexHandler', Hls.dependencies.HlsHandler);
            } else {
                this.system.mapClass('fragmentController', MediaPlayer.dependencies.FragmentController);
                this.system.mapClass('indexHandler', Dash.dependencies.DashHandler);
            }
        }
    };
};

MediaPlayer.modules.ContextManager.prototype =  {
    constructor: MediaPlayer.modules.ContextManager
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.Debug = function () {
    "use strict";

    Date.prototype.HHMMSSmmm = function() {

        var h = this.getHours().toString(),
            m = this.getMinutes().toString(),
            s = this.getSeconds().toString(),
            ms = this.getMilliseconds().toString(),
            HH = h[1] ? h : "0" + h[0],
            MM = m[1] ? m : "0" + m[0],
            SS = s[1] ? s : "0" + s[0],
            mmm = ms[2] ? ms : "0" + (ms[1] ? ms : "0" + ms[0]);

        return HH + ":" + MM + ":" + SS + "." + mmm;
    };

    Date.prototype.MMSSmmm = function() {

        var m = this.getMinutes().toString(),
            s = this.getSeconds().toString(),
            ms = this.getMilliseconds().toString(),
            MM = m[1] ? m : "0" + m[0],
            SS = s[1] ? s : "0" + s[0],
            mmm = ms[2] ? ms : "0" + (ms[1] ? ms : "0" + ms[0]);

        return MM + ":" + SS + "." + mmm;
    };

    // MemoryLogger definition

    var MemoryLogger = function(){
        // array to store logs
        this.logArray= [];
        // boolean to set leve in message
        this.showLevel = true;
    };


    MemoryLogger.prototype.error =
    MemoryLogger.prototype.warn =
    MemoryLogger.prototype.info =
    MemoryLogger.prototype.debug  = function(message){
        this.logArray.push(message);
    };

    MemoryLogger.prototype.getLogs = function(){
        return this.logArray;
    };

    // ORANGE: add level
    var NONE  = 0,
        ERROR = 1,
        WARN  = 2,
        INFO  = 3,
        DEBUG = 4,
        ALL   = 4,
        level = 0,
        showTimestamp = true,
        showElapsedTime = false,
        startTime = new Date(),
        // default logger set to console
        _logger = console,

        _log = function (logLevel, args) {
            if (logLevel <= getLevel()) {

                var message = _prepareLog(logLevel, args);

                switch (logLevel) {
                    case ERROR:
                        _logger.error(message);
                        break;
                    case WARN:
                        _logger.warn(message);
                        break;
                    case INFO:
                        _logger.info(message);
                        break;
                    case DEBUG:
                        _logger.debug(message);
                        break;
                }

            }

        },

        _prepareLog = function(logLevel, args){
            var message = "",
                logTime = null;

            if (showTimestamp) {
                logTime = new Date();
                message += "[" + logTime.HHMMSSmmm() + "]";
            }

            if(_logger && _logger.showLevel){
                 message += "["+_getStringLevel(logLevel)+"]";
            }

            if (showElapsedTime) {
                message += "[" + new Date(logTime - startTime).MMSSmmm() + "]";
            }

            Array.apply(null, args).forEach(function(item) {
                message += item + " ";
            });

            return message;
        },

        _getStringLevel = function(level){
            switch(level){
                case ERROR:
                return "ERROR";
                case WARN:
                return "WARN";
                case INFO:
                return "INFO";
                case DEBUG:
                return "DEBUG";
                default:
                return "";
            }
        },

        getLevel = function() {
            return level;
        },

        getLogger = function () {
            return _logger;
        };

    return {

        // ORANGE: add level
        NONE:   NONE,
        ERROR:  ERROR,
        WARN:   WARN,
        INFO:   INFO,
        DEBUG:  DEBUG,
        ALL:    ALL,

        getLevel: getLevel,
        getLogger: getLogger,

        setLevel: function(value) {
            level  = value;
        },

        setLogger: function(type){
           switch(type){
                case 'log4javascript' :
                    var appender = new log4javascript.PopUpAppender();
                    var layout = new log4javascript.PatternLayout("%d{HH:mm:ss.SSS} %-5p - %m%n");
                    appender.setLayout(layout);
                    _logger.addAppender(appender);
                    _logger.setLevel(log4javascript.Level.ALL);
                    _logger.initialized = true;
                break;

                case 'memory':
                    _logger = new MemoryLogger();
                break;

                case 'console':
                    _logger = console;
                break;

                default:
                    _logger = null;
           }
        },

        error: function () {
            _log.call(this, ERROR, arguments);
        },

        warn: function () {
            _log.call(this, WARN, arguments);
        },

        info: function () {
            _log.call(this, INFO, arguments);
        },

        // Keep this function for compatibility
        log: function () {
            _log.call(this, DEBUG, arguments);
        }
    };
};

/**
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2016, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * @constructs DebugController
 * @description A class which allow to download debug data on specific keybord shortcut
 */
MediaPlayer.utils.DebugController = function() {
    'use strict';

    // debug data configuration
    var debugData = {
        isInDebug:false,
        level:0,
        loggerType:'console'
    };

    var _handleKeyPressedEvent = function(e) {
        // if we press ctrl + alt + maj + z we activate debug mode
        if ((e.altKey === true) && (e.ctrlKey === true) && (e.shiftKey === true) &&
            ((e.keyCode === 68) || (e.keyCode === 90))) {
            if (debugData.isInDebug) {
                debugData.isInDebug = false;
                //console.log("debug mode desactivated");
                if (e.keyCode === 90) {
                    _downloadDebug(this.debug.getLogger().getLogs());
                }
                this.debug.setLevel(debugData.level);
                this.debug.setLogger(debugData.loggerType);
            } else {
                debugData.isInDebug = true;
                //console.log("debug mode activated");
                debugData.level = this.debug.getLevel();
                this.debug.setLevel((e.keyCode === 68) ? 4 : 3);
                this.debug.setLogger((e.keyCode === 68) ? 'console' : 'memory');
            }
        }
    };

    var _downloadDebug = function(array) {
        if (array && array.length > 0) {
            var filename = 'hasplayer_logs.txt',
                data = JSON.stringify(array, null, '\r\n'),
                blob = new Blob([data], {
                    type: 'text/json'
                });

            if (navigator.msSaveBlob) { // For IE10+ and edge
                navigator.msSaveBlob(blob, filename);
            } else {
                var e = document.createEvent('MouseEvents'),
                    a = document.createElement('a');
                a.download = filename;
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
            }
        }
    };


    return {
        debug: undefined,

        setup: function() {
            window.addEventListener('keydown', _handleKeyPressedEvent.bind(this));
        }
    };
};

MediaPlayer.utils.DebugController.prototype = {
    constructor: MediaPlayer.utils.DebugController
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

MediaPlayer.dependencies.ErrorHandler = function () {
    "use strict";

    return {
        eventBus: undefined,
        debug: undefined,

        sendWarning: function (code, message, data) {
            this.eventBus.dispatchEvent({
                type: "warning",
                data: {code : code, message: message, data: data}
            });
            this.debug.warn("[Warn] Code: " + code + ", Message: " + message + ", Data: " + JSON.stringify(data, null, '\t'));
        },

        sendError: function (code, message, data) {
            this.eventBus.dispatchEvent({
                type: "error",
                data: {code : code, message: message, data: data}
            });
            this.debug.error("[Error] Code: " + code + ", Message: " + message + ", Data: " + JSON.stringify(data, null, '\t'));
        }
    };
};

MediaPlayer.dependencies.ErrorHandler.prototype = {
    constructor: MediaPlayer.dependencies.ErrorHandler
};

// <video> element errors
MediaPlayer.dependencies.ErrorHandler.prototype.INTERNAL_ERROR = "INTERNAL_ERROR";

// <video> element errors
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ABORTED = "MEDIA_ERR_ABORTED";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_NETWORK = "MEDIA_ERR_NETWORK";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_DECODE = "MEDIA_ERR_DECODE";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = "MEDIA_ERR_SRC_NOT_SUPPORTED";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ENCRYPTED = "MEDIA_ERR_ENCRYPTED";

MediaPlayer.dependencies.ErrorHandler.prototype.CAPABILITY_ERR_MEDIASOURCE = "CAPABILITY_ERR_MEDIASOURCE";
MediaPlayer.dependencies.ErrorHandler.prototype.CAPABILITY_ERR_MEDIAKEYS = "CAPABILITY_ERR_MEDIAKEYS";

// MSE errors
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CREATE_MEDIASOURCE = "MEDIA_ERR_CREATE_MEDIASOURCE";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED = "MEDIA_ERR_CODEC_UNSUPPORTED";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CREATE_SOURCEBUFFER = "MEDIA_ERR_CREATE_SOURCEBUFFER";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_APPEND_SOURCEBUFFER = "MEDIA_ERR_APPEND_SOURCEBUFFER";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_REMOVE_SOURCEBUFFER = "MEDIA_ERR_REMOVE_SOURCEBUFFER";

// MediaPlayer errors
MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_PARSE = "MANIFEST_ERR_PARSE";
MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_STREAM = "MANIFEST_ERR_NO_STREAM";
MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_VIDEO = "MANIFEST_ERR_NO_VIDEO";
MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_AUDIO = "MANIFEST_ERR_NO_AUDIO";
MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_MANIFEST = "DOWNLOAD_ERR_MANIFEST";
MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_SIDX = "DOWNLOAD_ERR_SIDX";
MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_INIT = "DOWNLOAD_ERR_INIT";
MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT = "DOWNLOAD_ERR_CONTENT";
MediaPlayer.dependencies.ErrorHandler.prototype.CC_ERR_PARSE = "CC_ERR_PARSE";

// HLS errors
MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR = "HLS_DEMUX_ERROR";

// MediaKeyError from EME v0.1b (https://dvcs.w3.org/hg/html-media/raw-file/eme-v0.1b/encrypted-media/encrypted-media.html)
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR = "MEDIA_KEYERR";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_UNKNOWN = "MEDIA_KEYERR_UNKNOWN";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_CLIENT = "MEDIA_KEYERR_CLIENT";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_SERVICE = "MEDIA_KEYERR_SERVICE";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_OUTPUT = "MEDIA_KEYERR_OUTPUT";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_HARDWARECHANGE = "MEDIA_KEYERR_HARDWARECHANGE";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_DOMAIN = "MEDIA_KEYERR_DOMAIN";

// Key system errors
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYSYSERR_ACCESS_DENIED = "MEDIA_KEYSYSERR_ACCESS_DENIED";

// Key/license errors
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_URL_LICENSER_UNKNOWN = "MEDIA_KEYMESSERR_URL_LICENSER_UNKNOWN";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_NO_CHALLENGE = "MEDIA_KEYMESSERR_NO_CHALLENGE";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_LICENSER_ERROR = "MEDIA_KEYMESSERR_LICENSER_ERROR";
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_NO_SESSION = "MEDIA_KEYMESSERR_NO_SESSION";

// Other MediaKeyError
MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_SERVER_CERTIFICATE = "MEDIA_KEYERR_SERVER_CERTIFICATE";

// DOM exceptions (see http://www.w3.org/TR/WebIDL-1/#h-idl-domexception-error-names)
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INDEX_SIZE = 1;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_HIERARCHY_REQUEST = 3;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_WRONG_DOCUMENT = 4;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INVALID_CHARACTER = 5;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_NO_MODIFICATION_ALLOWED = 7;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_NOT_FOUND = 8;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_NOT_SUPPORTED = 9;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INVALID_STATE = 11;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_SYNTAX = 12;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INVALID_MODIFICATION = 13;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_NAMESPACE = 14;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INVALID_ACCESS = 15;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_SECURITY = 18;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_NETWORK = 19;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_ABORT = 20;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_URL_MISMATCH = 21;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_QUOTA_EXCEEDED = 22;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_TIMEOUT = 23;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_INVALID_NODE_TYPE = 24;
MediaPlayer.dependencies.ErrorHandler.prototype.DOM_ERR_DATA_CLONE = 25;
MediaPlayer.utils.EventBus = function() {
    "use strict";

    var registrations,

        getListeners = function(type, useCapture) {
            var captype = (useCapture ? '1' : '0') + type;

            if (!(captype in registrations)) {
                registrations[captype] = [];
            }

            return registrations[captype];
        },

        init = function() {
            registrations = {};
        };

    init();

    return {
        addEventListener: function(type, listener, useCapture) {
            var listeners = getListeners(type, useCapture),
                idx = listeners.indexOf(listener);

            if (idx === -1) {
                listeners.push(listener);
            }
        },

        removeEventListener: function(type, listener, useCapture) {
            var listeners = getListeners(type, useCapture),
                idx = listeners.indexOf(listener);

            if (idx !== -1) {
                listeners.splice(idx, 1);
            }
        },

        dispatchEvent: function(evt) {
            var listeners = getListeners(evt.type, false).slice(),
                i = 0;

            for (i = 0; i < listeners.length; i += 1) {
                listeners[i].call(this, evt);
            }
            return !evt.defaultPrevented;
        }
    };
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Fraunhofer Fokus
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.EventController = function() {
    "use strict";


    var inlineEvents = [], // Holds all Inline Events not triggered yet
        inbandEvents = [], // Holds all Inband Events not triggered yet
        activeEvents = [], // Holds all Events currently running
        eventInterval = null, // variable holding the setInterval
        refreshDelay = 100, // refreshTime for the setInterval
        presentationTimeThreshold = refreshDelay / 1000,
        MPD_RELOAD_SCHEME = "urn:mpeg:dash:event:2012",
        MPD_RELOAD_VALUE = 1,

        reset = function() {
            if (eventInterval !== null) {
                clearInterval(eventInterval);
                eventInterval = null;
            }
            inlineEvents = null;
            inbandEvents = null;
            activeEvents = null;
        },

        clear = function() {
            if (eventInterval !== null) {
                clearInterval(eventInterval);
                eventInterval = null;
            }
        },

        start = function() {
            var self = this;

            self.debug.log("[EventController] Start Event Controller");
            if (!isNaN(refreshDelay)) {
                eventInterval = setInterval(onEventTimer.bind(this), refreshDelay);
            }
        },

        /**
         * Add events to the eventList. Events that are not in the mpd anymore but not triggered yet will still be deleted
         * @param values
         */
        addInlineEvents = function(values) {
            var self = this;
            inlineEvents = [];

            if (values && values.length > 0) {
                inlineEvents = values;
            }
            self.debug.log("[EventController] Added " + values.length + " inline events");
        },

        /**
         * i.e. processing of any one event message box with the same id is sufficient
         * @param values
         */
        addInbandEvents = function(values) {
            var self = this,
                i = 0,
                event;

            for (i = 0; i < values.length; i++) {
                event = values[i];
                inbandEvents[event.id] = event;
                self.debug.log("[EventController] Add inband event with id " + event.id);
            }
        },

        /**
         * Itereate through the eventList and trigger/remove the events
         */
        onEventTimer = function() {
            triggerEvents.call(this, inbandEvents);
            triggerEvents.call(this, inlineEvents);
            removeEvents.call(this);
        },

        triggerEvents = function(events) {
            var self = this,
                currentVideoTime = this.videoModel.getCurrentTime(),
                presentationTime,
                j = 0,
                curr;

            /* == Trigger events that are ready == */
            if (events) {
                for (j = 0; j < events.length; j++) {
                    curr = events[j];

                    if (curr !== undefined) {
                        presentationTime = curr.presentationTime / curr.eventStream.timescale;
                        if (presentationTime === 0 || (presentationTime <= currentVideoTime && presentationTime + presentationTimeThreshold > currentVideoTime)) {
                            self.debug.log("[EventController] Start Event at " + currentVideoTime);
                            if (curr.duration > 0) {
                                activeEvents.push(curr);
                            }
                            if (curr.eventStream.schemeIdUri === MPD_RELOAD_SCHEME && curr.eventStream.value === MPD_RELOAD_VALUE) {
                                refreshManifest.call(this);
                            }
                            events.splice(j, 1);
                        }
                    }
                }
            }
        },

        /**
         * Remove events from the list that are over
         */
        removeEvents = function() {
            var self = this,
                currentVideoTime,
                i = 0,
                curr;

            if (activeEvents) {
                currentVideoTime = this.videoModel.getCurrentTime();

                for (i = 0; i < activeEvents.length; i++) {
                    curr = activeEvents[i];
                    if (curr !== null && (curr.duration + curr.presentationTime) / curr.eventStream.timescale < currentVideoTime) {
                        self.debug.log("[EventController] Remove Event at time " + currentVideoTime);
                        curr = null;
                        activeEvents.splice(i, 1);
                    }
                }
            }

        },

        refreshManifest = function() {
            var self = this,
                manifest = self.manifestModel.getValue(),
                url = manifest.mpdUrl;

            if (manifest.hasOwnProperty("Location")) {
                url = manifest.Location;
            }
            self.debug.log("[EventController] Refresh manifest @ " + url);
            self.manifestLoader.load(url).then(
                function(manifestResult) {
                    self.manifestModel.setValue(manifestResult);
                }
            );
        };

    return {
        manifestModel: undefined,
        manifestLoader: undefined,
        debug: undefined,
        system: undefined,
        videoModel: undefined,
        addInlineEvents: addInlineEvents,
        addInbandEvents: addInbandEvents,
        reset: reset,
        clear: clear,
        start: start
    };

};

MediaPlayer.dependencies.EventController.prototype = {
    constructor: MediaPlayer.dependencies.EventController
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.FragmentController = function() {
    "use strict";

    var fragmentModels = [],

        findModel = function(bufferController) {
            var ln = fragmentModels.length,
                i = 0;
            // We expect one-to-one relation between FragmentModel and BufferController,
            // so just compare the given BufferController object with the one that stored in the model to find the model for it
            for (i = 0; i < ln; i += 1) {
                if (fragmentModels[i].getContext() === bufferController) {
                    return fragmentModels[i];
                }
            }

            return null;
        },

        isReadyToLoadNextFragment = function() {
            var isReady = true,
                ln = fragmentModels.length,
                i = 0;
            // Loop through the models and check if all of them are in the ready state
            for (i = 0; i < ln; i += 1) {
                if (!fragmentModels[i].isReady()) {
                    isReady = false;
                    break;
                }
            }

            return isReady;
        },

        executeRequests = function() {
            var i = 0;

            for (i = 0; i < fragmentModels.length; i += 1) {
                fragmentModels[i].executeCurrentRequest();
            }
        };

    return {
        system: undefined,
        debug: undefined,

        process: function(bytes) {
            var result = null;

            if (bytes !== null && bytes !== undefined && bytes.byteLength > 0) {
                result = new Uint8Array(bytes);
            }

            return result;
        },

        attachBufferController: function(bufferController) {
            var model;

            if (!bufferController) {
                return null;
            }
            // Wrap the buffer controller into model and store it to track the loading state and execute the requests
            model = findModel(bufferController);

            if (!model) {
                model = this.system.getObject("fragmentModel");
                model.setContext(bufferController);
                fragmentModels.push(model);
            }

            return model;
        },

        detachBufferController: function(bufferController) {
            var idx = fragmentModels.indexOf(bufferController);
            // If we have the model for the given buffer just remove it from array
            if (idx > -1) {
                fragmentModels.splice(idx, 1);
            }
        },

        onBufferControllerStateChange: function() {
            // Check if we are ready to execute pending requests and do it
            if (isReadyToLoadNextFragment()) {
                executeRequests.call(this);
            }
        },

        isFragmentLoadedOrPending: function(bufferController, request) {
            var fragmentModel = findModel(bufferController),
                isLoaded;

            if (!fragmentModel) {
                return false;
            }

            isLoaded = fragmentModel.isFragmentLoadedOrPending(request);

            return isLoaded;
        },

        getPendingRequests: function(bufferController) {
            var fragmentModel = findModel(bufferController);

            if (!fragmentModel) {
                return null;
            }

            return fragmentModel.getPendingRequests();
        },

        getLoadingRequests: function(bufferController) {
            var fragmentModel = findModel(bufferController);

            if (!fragmentModel) {
                return null;
            }

            return fragmentModel.getLoadingRequests();
        },

        isInitializationRequest: function(request) {
            return (request && request.type && request.type.toLowerCase() === "initialization segment");
        },

        getLoadingTime: function(bufferController) {
            var fragmentModel = findModel(bufferController);

            if (!fragmentModel) {
                return null;
            }

            return fragmentModel.getLoadingTime();
        },

        getExecutedRequestForTime: function(model, time) {
            if (model) {
                return model.getExecutedRequestForTime(time);
            }

            return null;
        },

        removeExecutedRequest: function(model, request) {
            if (model) {
                model.removeExecutedRequest(request);
            }
        },

        removeExecutedRequestsBeforeTime: function(model, time) {
            if (model) {
                model.removeExecutedRequestsBeforeTime(time);
            }
        },

        clearExecutedRequests: function(model) {
            if (model) {
                model.clearExecutedRequests();
            }
        },

        cancelPendingRequestsForModel: function(model) {
            if (model) {
                model.cancelPendingRequests();
            }
        },

        abortRequestsForModel: function(model) {
            if (model) {
                model.abortRequests();
            }
        },

        prepareFragmentForLoading: function(bufferController, request, startLoadingCallback, successLoadingCallback, errorLoadingCallback, streamEndCallback) {
            var fragmentModel = findModel(bufferController);

            if (!fragmentModel || !request) {
                return null;
            }
            // Store the request and all the necessary callbacks in the model for deferred execution
            fragmentModel.addRequest(request);
            fragmentModel.setCallbacks(startLoadingCallback, successLoadingCallback, errorLoadingCallback, streamEndCallback);

            return true;
        }
    };
};

MediaPlayer.dependencies.FragmentController.prototype = {
    constructor: MediaPlayer.dependencies.FragmentController
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.FragmentLoader = function() {
    "use strict";

    var DEFAULT_RETRY_ATTEMPTS = 2,
        DEFAULT_RETRY_INTERVAL = 500,
        retryAttempts = DEFAULT_RETRY_ATTEMPTS,
        retryInterval = DEFAULT_RETRY_INTERVAL,
        retryCount = 0,
        xhrs = [],
        type,

        _checkForExistence = function(request) {
            var req = new XMLHttpRequest(),
                isSuccessful = false;

            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+request.url, false);
            // req_.send(null);
            // var url_ = req_.responseText;
            // req.open("HEAD", url_, true);
            var url = request.url;
            //console.log("MediaPlayer.dependencies.FragmentLoader");
            
            //console.log(req);
            

            req.open("HEAD", '/get_video_content?video_url='+url, true);
            var value ="XMLHttpPlayerRequest";
            //console.log(value);
            req.setRequestHeader("X-Requested-With", value);



            req.onload = function() {
                if (req.status < 200 || req.status > 399) {
                    return;
                }
                isSuccessful = true;
                request.deferred.resolve(request);
            };

            req.onloadend = req.onerror = function() {
                if (isSuccessful) {
                    return;
                }
                request.deferred.reject(req);
            };
            //console.log('Fragmenta loaders');
            req.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            req.send(null);
            // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // //console.log($.cookie('CloudFront-Signature'));

        },

        _loadRequest = function(request) {
            var deferred = Q.defer(),
                req = new XMLHttpRequest(),
                httpRequestMetrics = null,
                firstProgress = true,
                needFailureReport = true,
                lastTraceTime = null,
                self = this;

            xhrs.push(req);
            request.requestStartDate = new Date();

            httpRequestMetrics = self.metricsModel.addHttpRequest(
                request.streamType,
                null,
                request.type,
                request.url,
                null,
                request.range,
                request.requestStartDate,
                null,
                null,
                null,
                null,
                request.duration,
                request.startTime,
                request.quality);

            self.metricsModel.appendHttpTrace(
                httpRequestMetrics,
                request.requestStartDate,
                request.requestStartDate.getTime() - request.requestStartDate.getTime(), [0]);

            lastTraceTime = request.requestStartDate;
            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+self.tokenAuthentication.addTokenAsQueryArg(request.url), false);
            // req_.send(null);
            // var url_ = req_.responseText;
            // req.open("GET", url_, true);
            var url = self.tokenAuthentication.addTokenAsQueryArg(request.url);
            //console.log("_loadRequest");
            
            //console.log(req);
            var value ="XMLHttpPlayerRequest-"+"bytes=" + request.range;
            //console.log(value);
            req.open("GET", '/get_video_content?video_url='+url, true);
            req.setRequestHeader("X-Requested-With", value);


            req.responseType = "arraybuffer";
            req = self.tokenAuthentication.setTokenInRequestHeader(req);

            if (request.range) {
                req.setRequestHeader("Range", 'bytes='+request.range);
            }

            req.onprogress = function(event) {
                var currentTime = new Date();
                if (firstProgress) {
                    firstProgress = false;
                    if (!event.lengthComputable || (event.lengthComputable && event.total !== event.loaded)) {
                        request.firstByteDate = currentTime;
                        httpRequestMetrics.tresponse = currentTime;
                    }
                }

                if (event.lengthComputable) {
                    request.bytesLoaded = event.loaded;
                    request.bytesTotal = event.total;
                }

                self.metricsModel.appendHttpTrace(
                    httpRequestMetrics,
                    currentTime,
                    currentTime.getTime() - lastTraceTime.getTime(), [request.bytesLoaded ? request.bytesLoaded : 0]);

                lastTraceTime = currentTime;

                self.notify(MediaPlayer.dependencies.FragmentLoader.eventList.ENAME_LOADING_PROGRESS, {
                    request: request,
                    httpRequestMetrics: httpRequestMetrics,
                    lastTraceTime: lastTraceTime
                });

            };

            req.onload = function() {
                if (req.status < 200 || req.status > 399) {
                    return;
                }
                needFailureReport = false;

                var currentTime = new Date(),
                    bytes = req.response,
                    bytesLength = (bytes ? bytes.byteLength : 0),
                    latency,
                    download;

                if (!request.firstByteDate) {
                    request.firstByteDate = request.requestStartDate;
                }
                request.requestEndDate = currentTime;

                latency = (request.firstByteDate.getTime() - request.requestStartDate.getTime());
                download = (request.requestEndDate.getTime() - request.firstByteDate.getTime());

                self.debug.log("[FragmentLoader]["+type+"] Loaded: " + request.url + " (" + req.status + ", " + latency + "ms, " + download + "ms)");

                httpRequestMetrics.tresponse = request.firstByteDate;
                httpRequestMetrics.tfinish = request.requestEndDate;
                httpRequestMetrics.responsecode = req.status;

                httpRequestMetrics.bytesLength = bytesLength;

                self.metricsModel.appendHttpTrace(
                    httpRequestMetrics,
                    currentTime,
                    currentTime.getTime() - lastTraceTime.getTime(), [bytesLength]);

                lastTraceTime = currentTime;

                deferred.resolve({
                    data: bytes,
                    request: request
                });
                // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // //console.log($.cookie('CloudFront-Signature'));
            };

            req.onabort = function() {
                var currentTime = new Date(),
                    lastTrace,
                    bytes;

                req.aborted = true;

                if (httpRequestMetrics.trace.length === 0) {
                    return;
                }
                lastTrace = httpRequestMetrics.trace[httpRequestMetrics.trace.length - 1];
                bytes = lastTrace.b[0];

                request.requestEndDate = currentTime;
                httpRequestMetrics.tresponse = request.firstByteDate;
                httpRequestMetrics.tfinish = request.requestEndDate;
                httpRequestMetrics.responsecode = req.status;

                httpRequestMetrics.bytesLength = bytes;
            };

            req.onloadend = req.onerror = function() {
                if (xhrs.indexOf(req) === -1) {
                    return;
                }

                xhrs.splice(xhrs.indexOf(req), 1);

                if (!needFailureReport) {
                    return;
                }
                needFailureReport = false;

                httpRequestMetrics.responsecode = req.status;

                // When request failed do not complete http metrics so that
                // DownloadRatioRule does not take into account these request
                /*var currentTime = new Date(),
                    bytes = req.response,
                    latency,
                    download;

                if (!request.firstByteDate) {
                    request.firstByteDate = request.requestStartDate;
                }
                request.requestEndDate = currentTime;

                latency = (request.firstByteDate.getTime() - request.requestStartDate.getTime());
                download = (request.requestEndDate.getTime() - request.firstByteDate.getTime());

                httpRequestMetrics.tresponse = request.firstByteDate;
                httpRequestMetrics.tfinish = request.requestEndDate;
                httpRequestMetrics.responsecode = req.status;

                self.metricsModel.appendHttpTrace(httpRequestMetrics,
                    currentTime,
                    currentTime.getTime() - lastTraceTime.getTime(), [bytes ? bytes.byteLength : 0]);
                lastTraceTime = currentTime;*/

                deferred.reject(req);
            };

            self.debug.log("[FragmentLoader]["+type+"] Load: " + request.url);
            //console.log('above the fragment loader debug');
            // var xmlHttp = new XMLHttpRequest();
            // var url_ = '/signedCookies?src_=';
            // url_+= self.tokenAuthentication.addTokenAsQueryArg(request.url);
            // xmlHttp.open( "GET", url_, false ); // false for synchronous request
            // xmlHttp.send(null);
            req.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            req.send(null);
            return deferred.promise;
        },

        _load = function (request, deferred) {
            var self = this;

            _loadRequest.call(self, request).then(function(result) {
                    retryCount = 0;
                    deferred.resolve(result);
                }, function(reqerror) {
                     if (reqerror.aborted) {
                        // Request has been aborted => set status to 0
                        request.status = 0;
                        request.aborted = true;
                        deferred.reject(request);
                    } else if (retryCount >= retryAttempts) {
                        // No (more) retry => set status and reject
                        retryCount = 0;
                        request.status = reqerror.status;
                        deferred.reject(request);
                    } else {
                        // Retry
                        setTimeout(function() {
                            retryCount++;
                            _load.call(self, request, deferred);
                        }, retryInterval);
                    }
                });

        };

    return {
        metricsModel: undefined,
        debug: undefined,
        tokenAuthentication: undefined,
        config: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,

        setup: function() {
            retryAttempts = this.config.getParam("FragmentLoader.RetryAttempts", "number", DEFAULT_RETRY_ATTEMPTS);
            retryInterval = this.config.getParam("FragmentLoader.RetryInterval", "number", DEFAULT_RETRY_INTERVAL);
        },

        setType: function (value) {
            type = value;
        },

        load: function(request) {
            var deferred = Q.defer();

            // MSS use case: if initialization segment and data already ready (automatically generated),
            // then do not download segment
            if (request.type === "Initialization Segment" && request.data) {
                deferred.resolve(request, {data: request.data});
            } else {
                _load.call(this, request, deferred);
            }

            return deferred.promise;
        },

        abort: function() {
            var i = 0;

            for (i = 0; i < xhrs.length; i += 1) {
                this.debug.log("[FragmentLoader]["+type+"] Abort XHR " + (xhrs[i].responseURL ? xhrs[i].responseURL : ""));
                xhrs[i].abort();
            }
        },

        checkForExistence: function(req) {
            if (!req) {
                return Q.when(null);
            }

            req.deferred = Q.defer();
            _checkForExistence.call(this, req);

            return req.deferred.promise;
        }
    };
};

MediaPlayer.dependencies.FragmentLoader.prototype = {
    constructor: MediaPlayer.dependencies.FragmentLoader
};

MediaPlayer.dependencies.FragmentLoader.eventList = {
    ENAME_LOADING_PROGRESS: "loadingProgress"
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

MediaPlayer.dependencies.FragmentModel = function () {
    "use strict";

    var context,
        executedRequests = [],
        pendingRequests = [],
        loadingRequests = [],
        startLoadingCallback,
        successLoadingCallback,
        errorLoadingCallback,
        streamEndCallback,
        type,

        LOADING_REQUEST_THRESHOLD = 2,

        loadCurrentFragment = function(request) {
            var onSuccess,
                onError,
                self = this;

            // We are about to start loading the fragment, so execute the corresponding callback
            startLoadingCallback.call(context, request);

            onSuccess = function(request, response) {
                loadingRequests.splice(loadingRequests.indexOf(request), 1);
                executedRequests.push(request);
                successLoadingCallback.call(context, request, response);
                request.deferred = null;
            };

            onError = function(request) {
                loadingRequests.splice(loadingRequests.indexOf(request), 1);
                errorLoadingCallback.call(context, request);
                request.deferred = null;
            };

            self.fragmentLoader.load(request).then(onSuccess.bind(context, request),
                onError.bind(context, request));
        },

        sortRequestsByProperty = function(requestsArray, sortProp) {
            var compare = function (req1, req2){
                if (req1[sortProp] < req2[sortProp]) {
                    return -1;
                }
                if (req1[sortProp] > req2[sortProp]){
                    return 1;
                }
                return 0;
            };

            requestsArray.sort(compare);

        },

        removeExecutedRequest = function(request) {
            var idx = executedRequests.indexOf(request);

            if (idx !== -1) {
                executedRequests.splice(idx, 1);
            }
        };

    return {
        system: undefined,
        debug: undefined,
        fragmentLoader: undefined,

        setContext: function(value) {
            context = value;
        },

        getContext: function() {
            return context;
        },

        setType: function (value) {
            type = value;
            if (this.fragmentLoader) {
                this.fragmentLoader.setType(value);
            }
        },

        addRequest: function(value) {
            if (value) {
                if (this.isFragmentLoadedOrPending(value)) {
                    return;
                }

                pendingRequests.push(value);
                sortRequestsByProperty.call(this, pendingRequests, "index");
            }
        },

        setCallbacks: function(onLoadingStart, onLoadingSuccess, onLoadingError, onStreamEnd) {
            startLoadingCallback = onLoadingStart;
            streamEndCallback = onStreamEnd;
            errorLoadingCallback = onLoadingError;
            successLoadingCallback = onLoadingSuccess;
        },

        isFragmentLoadedOrPending: function(request) {
            var isLoaded = false,
                ln = executedRequests.length,
                i = 0,
                req;

            // First, check if the fragment has already been loaded
            for (i = 0; i < ln; i++) {
                req = executedRequests[i];
                if (request.startTime === req.startTime || ((req.action === "complete") && request.action === req.action)) {
                    //self.debug.log(request.streamType + " Fragment already loaded for time: " + request.startTime);
                    if (request.url === req.url) {
                        //self.debug.log(request.streamType + " Fragment url already loaded: " + request.url);
                        isLoaded = true;
                        break;
                    } else {
                        // remove overlapping segement of a different quality
                        removeExecutedRequest(request);
                    }
                }
            }

            // if it has not been loaded check if it is going to be loaded
            if (!isLoaded) {
                for (i = 0, ln = pendingRequests.length; i < ln; i += 1) {
                    req = pendingRequests[i];
                    if ((request.url === req.url) && (request.startTime === req.startTime)) {
                        isLoaded = true;
                    }
                }
            }

            if (!isLoaded) {
                for (i = 0, ln = loadingRequests.length; i < ln; i += 1) {
                    req = loadingRequests[i];
                    if ((request.url === req.url) && (request.startTime === req.startTime)) {
                        isLoaded = true;
                    }
                }
            }

            return isLoaded;
        },

        isReady: function() {
            return context.isReady();
        },

        getPendingRequests: function() {
            return pendingRequests;
        },

        getLoadingRequests: function() {
            return loadingRequests;
        },

        getLoadingTime: function() {
            var loadingTime = 0,
                req,
                i;

            // get the latest loaded request and calculate its loading time. In case requestEndDate/firstByteDate properties
            // have not been set (e.g. for a request with action='complete') we should get the previous request.
            for (i = executedRequests.length - 1; i >= 0; i -= 1) {
                req = executedRequests[i];

                if ((req.requestEndDate instanceof Date) && (req.firstByteDate instanceof Date)) {
                    loadingTime = req.requestEndDate.getTime() - req.firstByteDate.getTime();
                    break;
                }
            }

            return loadingTime;
        },

        getExecutedRequestForTime: function(time) {
            var lastIdx = executedRequests.length - 1,
                start = NaN,
                end = NaN,
                req = null,
                i;

            // loop through the executed requests and pick the one for which the playback interval matches the given time
            for (i = lastIdx; i >= 0; i -=1) {
                req = executedRequests[i];
                start = req.startTime;
                end = start + req.duration;
                if (!isNaN(start) && !isNaN(end) && (time > start) && (time < end)) {
                    return req;
                }
            }

            return null;
        },

        getExecutedRequestForQualityAndIndex: function(quality, index) {
            var lastIdx = executedRequests.length - 1,
                req = null,
                i;

            for (i = lastIdx; i >= 0; i -=1) {
                req = executedRequests[i];
                if (req.quality === quality && req.index === index) {
                    return req;
                }
            }

            return null;
        },

        removeExecutedRequest: function(request) {
            removeExecutedRequest.call(this, request);
        },

        removeExecutedRequestsBeforeTime: function(time) {
            var lastIdx = executedRequests.length - 1,
                start = NaN,
                req = null,
                i;

            // loop through the executed requests and remove the ones for which startTime is less than the given time
            for (i = lastIdx; i >= 0; i -=1) {
                req = executedRequests[i];
                start = req.startTime;
                if (!isNaN(start) && (start < time)) {
                    removeExecutedRequest.call(this, req);
                }
            }
        },

        clearExecutedRequests: function() {
            executedRequests = [];
        },

        cancelPendingRequests: function() {
            pendingRequests = [];
        },

        abortRequests: function() {
            this.fragmentLoader.abort();
            loadingRequests = [];
        },

        executeCurrentRequest: function() {
            var self = this,
                currentRequest;

            if (pendingRequests.length === 0) {
                return;
            }

            if (loadingRequests.length >= LOADING_REQUEST_THRESHOLD) {
                // too many requests have been loading, do nothing until some of them are loaded or aborted
                return;
            }

            // take the next request to execute and remove it from the list of pending requests
            currentRequest = pendingRequests.shift();

            switch (currentRequest.action) {
                case "complete":
                    // Stream has completed, execute the correspoinding callback
                    executedRequests.push(currentRequest);
                    streamEndCallback.call(context, currentRequest);
                    break;
                case "download":
                    loadingRequests.push(currentRequest);
                    loadCurrentFragment.call(self, currentRequest);
                    break;
                default:
                    this.debug.log("Unknown request action.");
                    if (currentRequest.deferred) {
                        currentRequest.deferred.reject();
                        currentRequest.deferred = null;
                    } else {
                        errorLoadingCallback.call(context, currentRequest);
                    }
            }
        }
    };
};

MediaPlayer.dependencies.FragmentModel.prototype = {
    constructor: MediaPlayer.dependencies.FragmentModel
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.FragmentInfoController = function() {
    "use strict";
    var READY = "READY",
        state = READY,
        ready = false,
        started = false,
        fragmentModel = null,
        type,
        bufferTimeout,
        _fragmentInfoTime,
        _bufferController,
        // ORANGE: segment downlaod failed recovery
        SEGMENT_DOWNLOAD_ERROR_MAX = 3,
        segmentDownloadFailed = false,
        segmentDownloadErrorCount = 0,
        reloadTimeout = null,
        startLoadingDate = null,
        deltaTime = 0,

        segmentDuration = NaN,

        sendRequest = function() {
            this.debug.info("[FragmentInfoController][" + type + "] sendRequest");
            // Check if running state
            if (!isRunning.call(this)) {
                return;
            }

            if (fragmentModel !== null) {
                this.fragmentController.onBufferControllerStateChange();
            }
        },

        startPlayback = function() {
            if (!ready || !started) {
                return;
            }

            this.debug.info("[FragmentInfoController][" + type + "] startPlayback");

            // Start buffering process
            bufferFragmentInfo.call(this);
        },

        doStart = function() {
            var self = this,
                segments;

            if (started === true) {
                return;
            }

            started = true;

            self.debug.info("[FragmentInfoController][" + type + "] START");

            segments = _bufferController.getCurrentRepresentation().segments;
            if (segments) {
                _fragmentInfoTime = segments[segments.length - 1].presentationStartTime - segments[segments.length - 1].duration;

                startPlayback.call(self);
            } else {
                self.indexHandler.updateSegmentList(_bufferController.getCurrentRepresentation()).then(function(segmentList) {
                    segments = segmentList;
                    _fragmentInfoTime = segments[segments.length - 1].presentationStartTime - segments[segments.length - 1].duration;

                    startPlayback.call(self);
                });
            }
        },

        doStop = function() {
            if (!started) {
                return;
            }
            this.debug.info("[FragmentInfoController][" + type + "] STOP");

            // Stop buffering process
            clearTimeout(bufferTimeout);
            started = false;

            // Stop reload timeout
            clearTimeout(reloadTimeout);
            reloadTimeout = null;

            this.fragmentController.abortRequestsForModel(fragmentModel);
        },

        onBytesLoadingStart = function(request) {
            this.debug.info("[FragmentInfoController][" + type + "] Load request ", (request.url !== null) ? request.url : request.quality);
        },

        onBytesLoaded = function(request, response) {
            var data;

            segmentDuration = request.duration;

            // Reset segment download error status
            segmentDownloadFailed = false;
            segmentDownloadErrorCount = 0;

            this.debug.log("[FragmentInfoController][" + type + "] Media loaded ", request.url);

            // ORANGE: add request and representations in function parameters, used by MssFragmentController
            data = this.fragmentController.process(response.data, request, _bufferController.getAvailableRepresentations());
            if (data && data.error) {
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.INTERNAL_ERROR, "Internal error while processing fragment info segment", data.message);
            } else {
                this.debug.info("[FragmentInfoController][" + type + "] Buffer segment from url ", request.url);

                deltaTime = new Date().getTime() - startLoadingDate;

                delayLoadNextFragmentInfo.call(this, (segmentDuration - (deltaTime / 1000)));
            }
        },

        isRunning = function() {
            return started;
        },

        onBytesError = function(e) {
            if (!isRunning.call(this)) {
                return;
            }

            // Abandonned request => load segment at lowest quality
            if (e.aborted) {
                bufferFragmentInfo.call(this);
                return;
            }

            // Segment download failed
            segmentDownloadErrorCount += 1;

            // => If failed SEGMENT_DOWNLOAD_ERROR_MAX times, then raise a warning
            // => Else raise a warning and try to reload session
            if (segmentDownloadErrorCount === SEGMENT_DOWNLOAD_ERROR_MAX) {
                this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT,
                    "Failed to download fragmentInfo segment", {
                        url: e.url,
                        status: e.status
                    });
            } else {
                this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_CONTENT,
                    "Failed to download fragmentInfo segment", {
                        url: e.url,
                        status: e.status
                    });
            }
        },

        onFragmentRequest = function(request) {
            var self = this;

            // Check if current request signals end of stream
            if ((request !== null) && (request.action === request.ACTION_COMPLETE)) {
                doStop.call(self);
                return;
            }

            if (request !== null) {
                _fragmentInfoTime = request.startTime + request.duration;
                request = self.indexHandler.getFragmentInfoRequest(request);

                if (self.fragmentController.isFragmentLoadedOrPending(self, request)) {
                    self.indexHandler.getNextSegmentRequest(_bufferController.getCurrentRepresentation()).then(onFragmentRequest.bind(self));
                    return;
                }

                self.debug.log("[FragmentInfoController][" + type + "] onFragmentRequest " + request.url);

                // Download the fragment info segment
                self.fragmentController.prepareFragmentForLoading(self, request, onBytesLoadingStart, onBytesLoaded, onBytesError, null);
                sendRequest.call(self);
            } else {
                // No more fragment in current list
                self.debug.log("[FragmentInfoController][" + type + "] bufferFragmentInfo failed");
            }
        },

        delayLoadNextFragmentInfo = function(delay) {
            var self = this,
                delayMs = Math.round(Math.min((delay * 1000), 2000));

            self.debug.log("[FragmentInfoController][" + type + "] Check buffer delta = " + delayMs + " ms");

            clearTimeout(bufferTimeout);
            bufferTimeout = setTimeout(function() {
                bufferTimeout = null;
                bufferFragmentInfo.call(self);
            }, delayMs);
        },

        bufferFragmentInfo = function() {
            var self = this,
                segmentTime;

            // Check if running state
            if (!isRunning.call(self)) {
                return;
            }

            self.debug.log("[FragmentInfoController][" + type + "] Start buffering process...");

            startLoadingDate = new Date().getTime();

            // Get next segment time
            segmentTime = _fragmentInfoTime;

            self.debug.log("[FragmentInfoController][" + type + "] loadNextFragment for time: " + segmentTime);

            this.indexHandler.getSegmentRequestForTime(_bufferController.getCurrentRepresentation(), segmentTime).then(onFragmentRequest.bind(this));
        };

    return {
        sourceBufferExt: undefined,
        abrController: undefined,
        debug: undefined,
        system: undefined,
        errHandler: undefined,
        abrRulesCollection: undefined,
        indexHandler: undefined,

        initialize: function(type, fragmentController, bufferController) {
            var self = this;

            self.debug.log("[FragmentInfoController][" + type + "] Initialize");

            _bufferController = bufferController;

            self.setType(type);
            self.setFragmentController(fragmentController);

            ready = true;
        },

        setType: function(value) {
            type = value;

            if (this.indexHandler !== undefined) {
                this.indexHandler.setType(value);
                this.indexHandler.setIsDynamic(true);
            }
        },

        isReady: function() {
            return state === READY;
        },

        setFragmentController: function(value) {
            if (value) {
                this.fragmentController = value;
                fragmentModel = this.fragmentController.attachBufferController(this);
                fragmentModel.setType(type);
            }
        },

        reset: function() {
            var self = this;

            doStop.call(self);

            if (fragmentModel) {
                self.fragmentController.abortRequestsForModel(fragmentModel);
                self.fragmentController.detachBufferController(fragmentModel);
                fragmentModel = null;
            }

            return Q.when(null);
        },

        start: doStart,
        stop: doStop
    };
};

MediaPlayer.dependencies.FragmentInfoController.prototype = {
    constructor: MediaPlayer.dependencies.FragmentInfoController
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.ManifestLoader = function() {
    "use strict";

    var DEFAULT_RETRY_ATTEMPTS = 2,
        DEFAULT_RETRY_INTERVAL = 500,
        retryAttempts = DEFAULT_RETRY_ATTEMPTS,
        retryInterval = DEFAULT_RETRY_INTERVAL,
        retryCount = 0,
        retryTimeout = null,
        deferred = null,
        request = null,

        _getDecodedResponseText = function(text) {
            var fixedCharCodes = '',
                i = 0,
                charCode;

            // Some content is not always successfully decoded by every browser.
            // Known problem case: UTF-16 BE manifests on Internet Explorer 11.
            // This function decodes any text that the browser failed to decode.
            if (text.length < 1) {
                return text;
            }

            // The troublesome bit here is that IE still strips off the BOM, despite incorrectly decoding the file.
            // So we will simply assume that the first character is < (0x3C) and detect its invalid decoding (0x3C00).
            if (text.charCodeAt(0) !== 0x3C00) {
                return text;
            }

            // We have a problem!
            for (i = 0; i < text.length; i += 1) {
                charCode = text.charCodeAt(i);

                // Swap around the two bytes that make up the character code.
                fixedCharCodes += String.fromCharCode(((charCode & 0xFF) << 8 | (charCode & 0xFF00) >> 8));
            }

            return fixedCharCodes;
    },

        _parseBaseUrl = function(url) {
            var base = null;

            if (url.indexOf("/") !== -1) {
                if (url.indexOf("?") !== -1) {
                    url = url.substring(0, url.indexOf("?"));
                }
                base = url.substring(0, url.lastIndexOf("/") + 1);
            }

            return base;
        },

        _abort = function() {

            if (request !== null && request.readyState > 0 && request.readyState < 4) {
                this.debug.log("[ManifestLoader] Manifest download abort.");
                request.abort();
            } else if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
                deferred.reject();
            }

            this.parser.abort();
        },

        _load = function(url) {
            var baseUrl = _parseBaseUrl(url),
                requestTime = new Date(),
                mpdLoadedTime = null,
                needFailureReport = true,
                onload = null,
                report = null,
                onabort = null,
                self = this;

            onabort = function() {
                request.aborted = true;
            };

            onload = function() {
                if (request.status < 200 || request.status > 299) {
                    return;
                }

                if (request.status === 200 && request.readyState === 4) {
                    self.debug.log("[ManifestLoader] Manifest downloaded");

                    // Get the redirection URL and use it as base URL
                    if (request.responseURL) {
                        self.debug.log("[ManifestLoader] Redirect URL: " + request.responseURL);
                        baseUrl = _parseBaseUrl(request.responseURL);
                    }

                    needFailureReport = false;
                    mpdLoadedTime = new Date();

                    self.tokenAuthentication.checkRequestHeaderForToken(request);
                    self.metricsModel.addHttpRequest("stream",
                        null,
                        "MPD",
                        url,
                        null,
                        null,
                        requestTime,
                        mpdLoadedTime,
                        request.status,
                        null,
                        null);

                    self.parser.parse(_getDecodedResponseText(request.responseText), baseUrl).then(
                        function(manifest) {
                            if (manifest) {
                                manifest.mpdUrl = url;
                                manifest.mpdLoadedTime = mpdLoadedTime;
                                self.metricsModel.addManifestUpdate("stream", manifest.type, requestTime, mpdLoadedTime, manifest.availabilityStartTime);
                                deferred.resolve(manifest);
                            } else {
                                deferred.reject();
                            }
                            // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
                            // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
                            // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
                            // //console.log($.cookie('CloudFront-Signature'));
                        },
                        function(error) {
                            // Check if reject is due to other issue than manifest parsing
                            // (for example HLS variant steam playlist download error)
                            if (error && error.name && error.message) {
                                deferred.reject(error);
                            } else {
                                self.debug.error("[ManifestLoader] Manifest parsing error");
                                deferred.reject({
                                    name: MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_PARSE,
                                    message: "Failed to parse manifest",
                                    data: {
                                        url: url
                                    }
                                });
                            }
                        }
                    );
                }
            };

            report = function() {
                if (!needFailureReport) {
                    return;
                }
                needFailureReport = false;

                self.metricsModel.addHttpRequest("stream",
                    null,
                    "MPD",
                    url,
                    null,
                    null,
                    requestTime,
                    new Date(),
                    request.status,
                    null,
                    null);

                if (request.aborted) {
                    deferred.reject();
                } else {
                    retryCount++;
                    if (retryAttempts > 0 && retryCount <= retryAttempts) {
                        retryTimeout = setTimeout(function() {
                            _load.call(self, url);
                        }, retryInterval);
                    } else {
                        deferred.reject({
                            name: MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_MANIFEST,
                            message: "Failed to download manifest",
                            data : {
                                url: url,
                                status: request.status
                            }
                        });
                    }
                }
            };

            try {
                request = new XMLHttpRequest();
                request.onload = onload;
                request.onloadend = report;
                request.onerror = report;
                request.onabort = onabort;
                // var req_ = new XMLHttpRequest();
                // req_.open("GET", '/signedUrl?src_='+url, false);
                // req_.send(null);
                // var url_ = req_.responseText;
                // request.open("GET", url_, true);

               // console.log("_load");
            
                //console.log(request);
                request.open("GET", '/get_video_content?video_url='+url, true);
                var value ="XMLHttpPlayerRequest";
                //console.log(value);
                request.setRequestHeader("X-Requested-With", value);


                request.withCredentials = true;
                //console.log('playlist request');
                // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
                request.send(null);

            } catch (e) {
                request.onerror();
                //console.log(e);
            }
        };

    return {
        debug: undefined,
        parser: undefined,
        config: undefined,
        metricsModel: undefined,
        tokenAuthentication: undefined,

        setup: function() {
            retryAttempts = this.config.getParam("ManifestLoader.RetryAttempts", "number", DEFAULT_RETRY_ATTEMPTS);
            retryInterval = this.config.getParam("ManifestLoader.RetryInterval", "number", DEFAULT_RETRY_INTERVAL);
        },

        load: function(url) {
            deferred = Q.defer();
            request = new XMLHttpRequest();
            retryCount = 0;
            _load.call(this, url);
            return deferred.promise;
        },

        abort: _abort
    };
};

MediaPlayer.dependencies.ManifestLoader.prototype = {
    constructor: MediaPlayer.dependencies.ManifestLoader
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.ManifestUpdater = function() {
    "use strict";

    var refreshDelay = NaN,
        refreshTimer = null,
        isStopped = false,
        deferredUpdate,

        clear = function() {
            if (refreshTimer !== null) {
                clearInterval(refreshTimer);
                refreshTimer = null;
            }
        },

        start = function() {
            clear.call(this);

            if (!isNaN(refreshDelay)) {
                this.debug.log("Refresh manifest in " + refreshDelay + " seconds.");
                refreshTimer = setTimeout(onRefreshTimer.bind(this), Math.min(refreshDelay * 1000, Math.pow(2, 31) - 1), this);
            }
        },

        update = function() {
            var self = this,
                manifest = self.manifestModel.getValue(),
                timeSinceLastUpdate,
                t;

            if (manifest !== undefined && manifest !== null) {
                t = self.manifestExt.getRefreshDelay(manifest);
                timeSinceLastUpdate = (new Date().getTime() - manifest.mpdLoadedTime.getTime()) / 1000;
                refreshDelay = Math.max(t - timeSinceLastUpdate, 0);
                start.call(self);
            }
        },

        onRefreshTimer = function() {
            var self = this,
                manifest,
                url;

            // The manifest should not update until the previous update has completed. A promise postpones the update
            // until is is resolved. For the first time the promise does not exist yet, so pass 'true' instead.
            Q.when(deferredUpdate ? deferredUpdate.promise : true).then(
                function() {
                    deferredUpdate = Q.defer();
                    manifest = self.manifestModel.getValue();
                    url = manifest.mpdUrl;

                    if (manifest.hasOwnProperty("Location")) {
                        url = manifest.Location;
                    }

                    //self.debug.log("Refresh manifest @ " + url);

                    self.manifestLoader.load(url).then(
                        function(manifestResult) {
                            self.manifestModel.setValue(manifestResult);
                            self.debug.log("Manifest has been refreshed.");
                            //self.debug.log(manifestResult);
                            if (isStopped) {
                                return;
                            }

                            update.call(self);
                        }
                    );
                }
            );
        },

        onStreamsComposed = function() {
            // When streams are ready we can consider manifest update completed. Resolve the update promise.
            if (deferredUpdate) {
                deferredUpdate.resolve();
            }
        };

    return {
        debug: undefined,
        system: undefined,
        manifestModel: undefined,
        manifestExt: undefined,
        manifestLoader: undefined,

        setup: function() {
            update.call(this);
            // Listen to streamsComposed event to be aware that the streams have been composed
            this.system.mapHandler("streamsComposed", undefined, onStreamsComposed.bind(this));
        },

        start: function() {
            isStopped = false;
            update.call(this);
        },

        stop: function() {
            isStopped = true;
            clear.call(this);
        }
    };
};

MediaPlayer.dependencies.ManifestUpdater.prototype = {
    constructor: MediaPlayer.dependencies.ManifestUpdater
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.models.ManifestModel = function () {
    "use strict";

    var manifest = null;

    return {
        system: undefined,
        eventBus: undefined,

        getValue:  function () {
            return manifest;
        },

        setValue: function (value) {
            manifest = value;
            if (manifest) {
            this.system.notify("manifestUpdated");
            }

            if (manifest !== null) {
                this.eventBus.dispatchEvent({
                    type: "manifestLoaded",
                    data: value
                });
            }
        }
    };
};

MediaPlayer.models.ManifestModel.prototype = {
    constructor: MediaPlayer.models.ManifestModel
};





/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.MediaSourceExtensions = function () {
    "use strict";
};

MediaPlayer.dependencies.MediaSourceExtensions.prototype = {
    constructor: MediaPlayer.dependencies.MediaSourceExtensions,

    createMediaSource: function () {
        "use strict";

        var hasWebKit = ("WebKitMediaSource" in window),
            hasMediaSource = ("MediaSource" in window);

        if (hasMediaSource) {
            return new MediaSource();
        } else if (hasWebKit) {
            return new WebKitMediaSource();
        }

        return null;
    },

    attachMediaSource: function (source, videoModel) {
        "use strict";

        videoModel.setSource(window.URL.createObjectURL(source));
        return true;
    },

    detachMediaSource: function (videoModel) {
        "use strict";
        // it seems that any value passed to the setSource is cast to a string when setting element.src,
        // so we cannot use null or undefined to reset the element. Use empty string instead.
        videoModel.setSource("");
        return true;
    },

    setDuration: function (source, value) {
        "use strict";
        var i,
            updating = false;

        if (source.readyState !== 'open') return source.duration;

        for (i = 0; i < source.sourceBuffers.length; i++) {
            if(source.sourceBuffers[i].updating){
                updating = true;
                break;
            }
        }

        if (!updating) {
            source.duration = value;
        }

        return source.duration;
    },

    signalEndOfStream: function(source) {
        "use strict";
        var buffers = source.sourceBuffers,
            ln = buffers.length,
            i = 0;

        if (source.readyState !== 'open') {
            return;
        }

        for (i; i < ln; i++) {
            if (buffers[i].updating) {
                return;
            }
            if (buffers[i].buffered.length === 0) {
                return;
            }
        }

        source.endOfStream();
        return true;
    }
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.MetricsExtensions = function() {
    "use strict";

    var h264ProfileMap = {
        "42": "Baseline",
        "4D": "Main",
        "58": "Extended",
        "64": "High"
    };

    var findRepresentionInPeriodArray = function(periodArray, representationId) {
        var period,
            adaptationSet,
            adaptationSetArray,
            representation,
            representationArray,
            periodArrayIndex,
            adaptationSetArrayIndex,
            representationArrayIndex;

        for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
            period = periodArray[periodArrayIndex];
            adaptationSetArray = period.AdaptationSet_asArray;
            for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                representationArray = adaptationSet.Representation_asArray;
                for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                    representation = representationArray[representationArrayIndex];
                    if (representationId === representation.id) {
                        return representation;
                    }
                }
            }
        }

        return null;
    };

    var adaptationIsType = function(adaptation, bufferType) {
        var found = false;
        // TODO : HACK ATTACK
        // Below we call getIsVideo and getIsAudio and then check the adaptation set for a 'type' property.
        // getIsVideo and getIsAudio are adding this 'type' property and SHOULD NOT BE.
        // This method expects getIsVideo and getIsAudio to be sync, but they are async (returns a promise).
        // This is a bad workaround!
        // The metrics extensions should have every method use promises.

        if (bufferType === "video") {
            this.manifestExt.getIsVideo(adaptation);
            if (adaptation.type === "video") {
                found = true;
            }
        } else if (bufferType === "audio") {
            this.manifestExt.getIsAudio(adaptation);
            if (adaptation.type === "audio") {
                found = true;
            }
        } else if (bufferType === "text") {
            this.manifestExt.getIsText(adaptation);
            if (adaptation.type === "text") {
                found = true;
            }
        } else {
            found = false;
        }

        return found;
    };

    var rslt = MediaPlayer.utils.copyMethods(Dash.dependencies.DashMetricsExtensions);

    rslt.config = undefined;

    rslt.getDuration = function() {
        var self = this,
            manifest = self.manifestModel.getValue(),
            duration = manifest ? manifest.Period.duration : null;

        if (duration !== Infinity) {
            return duration;
        }

        return -1;
    };

    rslt.getFormatForType = function(type) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            i = 0,
            adaptation;

        for (i = 0; i < manifest.Period.AdaptationSet.length; i++) {
            adaptation = manifest.Period.AdaptationSet[i];
            if (adaptation.type === type) {
                return adaptation.mimeType;
            }
        }

        return null;
    };

    rslt.getCodecForType = function(type) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            i = 0,
            adaptation;

        for (i = 0; i < manifest.Period.AdaptationSet.length; i++) {
            adaptation = manifest.Period.AdaptationSet[i];
            if (adaptation.type === type || adaptation.contentType === type) {
                //return codecs of the first Representation
                return adaptation.Representation[0].codecs;
            }
        }

        return null;
    };

    rslt.getVideoWidthForRepresentation = function(representationId) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            representation,
            periodArray;

        if (manifest) {
            periodArray = manifest.Period_asArray;

            representation = findRepresentionInPeriodArray.call(self, periodArray, representationId);

            if (representation === null) {
                return null;
            }

            return representation.width;
        } else {
            return null;
        }
    };

    rslt.getVideoHeightForRepresentation = function(representationId) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            representation,
            periodArray;

        if (manifest) {
            periodArray = manifest.Period_asArray;

            representation = findRepresentionInPeriodArray.call(self, periodArray, representationId);

            if (representation === null) {
                return null;
            }

            return representation.height;
        } else {
            return null;
        }
    };

    rslt.getCodecsForRepresentation = function(representationId) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            representation,
            periodArray = manifest.Period_asArray;

        representation = findRepresentionInPeriodArray.call(self, periodArray, representationId);

        if (representation === null) {
            return null;
        }

        return representation.codecs;
    };

    rslt.getH264ProfileLevel = function(codecs) {

        if (codecs.indexOf("avc1") < 0) {
            return "";
        }
        var profile = h264ProfileMap[codecs.substr(5, 2)],
            level = parseInt(codecs.substr(9, 2), 16) / 10.0;

        return profile + "@" + level.toString();
    };

    rslt.getBitratesForType = function(type, data) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            periodArray,
            period,
            periodArrayIndex,
            adaptationSetArray,
            adaptationSet = null,
            representation,
            representationArray,
            adaptationSetArrayIndex,
            representationArrayIndex,
            bitrateArray = [];

        if (((manifest === null) || (manifest === undefined)) && ((data === null) || (data === undefined))) {
            return null;
        }

        if (data) {
            adaptationSet = data;
        } else {
            periodArray = manifest.Period_asArray;

            for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
                period = periodArray[periodArrayIndex];
                adaptationSetArray = period.AdaptationSet_asArray;
                for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                    adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                    if (adaptationIsType.call(self, adaptationSetArray[adaptationSetArrayIndex], type)) {
                        adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                        break;
                    }
                }
            }
        }

        if (adaptationSet !== null) {
            // Order adaptationSet's representations in bitrate ascending value
            adaptationSet = self.manifestExt.processAdaptation(adaptationSet);
            representationArray = adaptationSet.Representation_asArray;
            for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                representation = representationArray[representationArrayIndex];
                bitrateArray.push(representation.bandwidth);
            }
        }

        return bitrateArray;
    };

    rslt.getBitratesWithResolutionForType = function(type) {
        var self = this,
            manifest = self.manifestModel.getValue(),
            periodArray,
            period,
            periodArrayIndex,
            adaptationSet,
            adaptationSetArray,
            representation,
            representationArray,
            adaptationSetArrayIndex,
            representationArrayIndex,
            bitrateArray = [];

        if ((manifest === null) || (manifest === undefined)) {
            return null;
        }

        periodArray = manifest.Period_asArray;

        for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
            period = periodArray[periodArrayIndex];
            adaptationSetArray = period.AdaptationSet_asArray;
            for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                if (adaptationIsType.call(self, adaptationSet, type)) {
                    //order adaptation in bitrate ascending value
                    adaptationSet = self.manifestExt.processAdaptation(adaptationSet);
                    representationArray = adaptationSet.Representation_asArray;
                    for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                        representation = representationArray[representationArrayIndex];
                        var reso = {
                            bitrate: representation.bandwidth,
                            width: representation.width,
                            height: representation.height
                        };
                        bitrateArray.push(reso);
                    }
                    return bitrateArray;
                }
            }
        }

        return bitrateArray;
    };

    return rslt;
};

MediaPlayer.dependencies.MetricsExtensions.prototype = {
    constructor: MediaPlayer.dependencies.MetricsExtensions
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
 MediaPlayer.models.MetricsModel = function () {
    "use strict";

    return {
        system : undefined,
        eventBus: undefined,
        config: undefined,
        streamMetrics: {},
        metricsChanged: function () {
            this.eventBus.dispatchEvent({
                type: "metricsChanged",
                data: {}
            });
        },

        metricChanged: function (streamType) {
            this.eventBus.dispatchEvent({
                type: "metricChanged",
                data: {stream: streamType}
            });
            this.metricsChanged();
        },

        metricUpdated: function (streamType, metricType, vo) {
            this.eventBus.dispatchEvent({
                type: "metricUpdated",
                data: {stream: streamType, metric: metricType, value: vo}
            });
            this.metricChanged(streamType);
        },

        metricAdded: function (streamType, metricType, vo) {
            this.eventBus.dispatchEvent({
                type: "metricAdded",
                data: {stream: streamType, metric: metricType, value: vo}
            });
            this.metricChanged(streamType);
        },

        clearCurrentMetricsForType: function (type) {
            var keepBW = this.config.getParamFor(type, "ABR.keepBandwidthCondition", "boolean", true);

            for (var prop in this.streamMetrics[type]) {
                // We keep HttpList in order to keep bandwidth conditions when switching the input stream
                if (this.streamMetrics[type].hasOwnProperty(prop) && ((prop !== "HttpList") || (keepBW === false))) {
                    this.streamMetrics[type][prop] = [];
                }
            }

            this.metricChanged(type);
        },

        clearAllCurrentMetrics: function () {
            var self = this;

            for (var prop in this.streamMetrics) {
                if (this.streamMetrics.hasOwnProperty(prop) && (prop === "stream")) {
                    delete this.streamMetrics[prop];
                }
            }

            //this.streamMetrics = {};
            this.metricsChanged.call(self);
        },

        getReadOnlyMetricsFor: function(type) {
            if (this.streamMetrics.hasOwnProperty(type)) {
                return this.streamMetrics[type];
            }

            return null;
        },

        getMetricsFor: function(type) {
            var metrics;

            if (this.streamMetrics.hasOwnProperty(type)) {
                metrics = this.streamMetrics[type];
            } else {
                metrics = this.system.getObject("metrics");
                this.streamMetrics[type] = metrics;
            }

            return metrics;
        },

        addTcpConnection: function (streamType, tcpid, dest, topen, tclose, tconnect) {
            var vo = new MediaPlayer.vo.metrics.TCPConnection();

            vo.tcpid = tcpid;
            vo.dest = dest;
            vo.topen = topen;
            vo.tclose = tclose;
            vo.tconnect = tconnect;

            this.getMetricsFor(streamType).TcpList.push(vo);
            this.metricAdded(streamType, "TcpConnection", vo);

            return vo;
        },

        // ORANGE: add request quality
        addHttpRequest: function (streamType, tcpid, type, url, actualurl, range, trequest, tresponse, tfinish, responsecode, interval, mediaduration, startTime, quality) {
            var vo = new MediaPlayer.vo.metrics.HTTPRequest(),
                metrics = this.getMetricsFor(streamType).HttpList;

            vo.stream = streamType;
            vo.tcpid = tcpid;
            vo.type = type;
            vo.url = url;
            vo.actualurl = actualurl;
            vo.range = range;
            vo.trequest = trequest;
            vo.tresponse = tresponse;
            vo.tfinish = tfinish;
            vo.responsecode = responsecode;
            vo.interval = interval;
            vo.mediaduration = mediaduration;
            vo.startTime = startTime;
            vo.quality = quality;

            metrics.push(vo);
            this.metricAdded(streamType, "HttpRequest", vo);

            // Keep only last 10 metrics to avoid memory leak
            if (metrics.length > 10) {
                metrics.shift();
            }

            return vo;
        },

        appendHttpTrace: function (httpRequest, s, d, b) {
            var vo = new MediaPlayer.vo.metrics.HTTPRequest.Trace();

            vo.s = s;
            vo.d = d;
            vo.b = b;

            httpRequest.trace.push(vo);
            this.metricUpdated(httpRequest.stream, "HttpRequestTrace", httpRequest);

            return vo;
        },

        addRepresentationSwitch: function (streamType, t, mt, to, lto) {
            var vo = new MediaPlayer.vo.metrics.RepresentationSwitch();

            vo.t = t;
            vo.mt = mt;
            vo.to = to;
            vo.lto = lto;

            this.getMetricsFor(streamType).RepSwitchList.push(vo);
            this.metricAdded(streamType, "RepresentationSwitch", vo);

            return vo;
        },

        addBufferedSwitch: function (streamType, mt, to, lto) {
            var vo = new MediaPlayer.vo.metrics.BufferedSwitch();

            vo.mt = mt;
            vo.to = to;
            vo.lto = lto;

            this.getMetricsFor(streamType).BufferedSwitchList.push(vo);
            this.metricAdded(streamType, "BufferedSwitch", vo);

            return vo;
        },

        addState: function (streamType, currentState, position, reason) {
            var vo = new MediaPlayer.vo.metrics.State();

            vo.current = currentState;
            vo.position = position;
            vo.reason = reason;

            this.metricAdded(streamType, "State", vo);

            return vo;
        },

        addSession: function (streamType, url, loop, endTime, playerType) {
            var vo = new MediaPlayer.vo.metrics.Session();

            vo.uri = url;
            if (loop) {
                vo.loopMode = 1;
            } else {
                vo.loopMode = 0;
            }
            vo.endTime = endTime;
            vo.playerType = playerType;

            this.metricAdded(streamType, "Session", vo);

            return vo;
        },

        addCondition: function (streamType, isFullScreen, videoWidth, videoHeight, droppedFrames, fps) {
            var vo = new MediaPlayer.vo.metrics.Condition();

            vo.isFullScreen = isFullScreen;
            vo.windowSize = videoWidth + "x" + videoHeight;
            vo.fps = fps;
            vo.droppedFrames = droppedFrames;

            this.metricAdded(streamType, "Condition", vo);

            return vo;
        },

        addMetaData: function () {
            this.metricAdded(null, "ManifestReady", null);
        },

        addBufferLevel: function (streamType, t, level) {
            var vo = new MediaPlayer.vo.metrics.BufferLevel(),
                metrics = this.getMetricsFor(streamType).BufferLevel;

            vo.t = t;
            vo.level = Number(level.toFixed(3));

            metrics.push(vo);
            this.metricAdded(streamType, "BufferLevel", vo);

            // Keep only last 10 metrics to avoid memory leak
            if (metrics.length > 10) {
                metrics.shift();
            }

            return vo;
        },


        addDVRInfo: function (streamType, t, range) {
            var vo = new MediaPlayer.vo.metrics.DVRInfo(),
                metrics = this.getMetricsFor(streamType).DVRInfo;

            vo.t = t;
            vo.range = range;

            metrics.push(vo);
            this.metricAdded(streamType, "DVRInfo", vo);

            // Keep only last 10 metrics to avoid memory leak
            if (metrics.length > 10) {
                metrics.shift();
            }

            return vo;
        },

        addDroppedFrames: function (streamType, quality) {
            var vo = new MediaPlayer.vo.metrics.DroppedFrames(),
                list = this.getMetricsFor(streamType).DroppedFrames;

            vo.time = quality.creationTime;
            vo.droppedFrames = quality.droppedVideoFrames;
            vo.decodedFrameCount = quality.totalVideoFrames;

            if (list.length > 0 && list[list.length - 1] === vo) {
                return list[list.length - 1];
            }

            list.push(vo);

            this.metricAdded(streamType, "DroppedFrames", vo);
            return vo;
        },


        addPlaybackQuality: function (streamType, t, quality, mediaTime) {
            var vo = new MediaPlayer.vo.metrics.PlaybackQuality(),
                metrics = this.getMetricsFor(streamType).PlaybackQuality;

            vo.t = t;//quality.creationTime;
            vo.mt = mediaTime;
            vo.droppedFrames = quality.droppedVideoFrames;
            vo.totalVideoFrames = quality.totalVideoFrames;

            // Add new metrics only if droppedVideoFrames or totalVideoFrames changed
            if (metrics.length > 0) {
                if ((vo.droppedFrames === metrics[metrics.length-1].droppedFrames) &&
                    (vo.totalVideoFrames === metrics[metrics.length-1].totalVideoFrames)) {
                    return metrics[metrics.length - 1];
                }
            }

            metrics.push(vo);
            this.metricAdded(streamType, "PlaybackQuality", vo);

            // Keep only last 10 metrics to avoid memory leak
            if (metrics.length > 10) {
                metrics.shift();
            }

            return vo;
        },

        addVideoResolution: function (streamType, t, width, height, mediaTime) {
            var vo = new MediaPlayer.vo.metrics.VideoResolution(),
                metrics = this.getMetricsFor(streamType).VideoResolution;

            vo.t = t;
            vo.mt = mediaTime;
            vo.width = width;
            vo.height = height;

            // Add new metrics only if width or height changed
            if (metrics.length > 0) {
                if ((vo.width === metrics[metrics.length-1].width) &&
                    (vo.height === metrics[metrics.length-1].height)) {
                    return metrics[metrics.length - 1];
                }
            }

            metrics.push(vo);
            this.metricAdded(streamType, "VideoResolution", vo);

            return vo;
        },

        addManifestUpdate: function(streamType, type, requestTime, fetchTime, availabilityStartTime, presentationStartTime, clientTimeOffset, currentTime, buffered, latency) {
            var vo = new MediaPlayer.vo.metrics.ManifestUpdate(),
                metrics = this.getMetricsFor("stream");

            vo.streamType = streamType;
            vo.type = type;
            vo.requestTime = requestTime; // when this manifest update was requested
            vo.fetchTime = fetchTime; // when this manifest update was received
            vo.availabilityStartTime = availabilityStartTime;
            vo.presentationStartTime = presentationStartTime; // the seek point (liveEdge for dynamic, Period[0].startTime for static)
            vo.clientTimeOffset = clientTimeOffset; // the calculated difference between the server and client wall clock time
            vo.currentTime = currentTime; // actual element.currentTime
            vo.buffered = buffered; // actual element.ranges
            vo.latency = latency; // (static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - currentTime)

            metrics.ManifestUpdate.push(vo);
            this.metricAdded(streamType, "ManifestUpdate", vo);

            return vo;
        },

        updateManifestUpdateInfo: function(manifestUpdate, updatedFields) {
            if (manifestUpdate && updatedFields) {
                for (var field in updatedFields) {
                    if (updatedFields.hasOwnProperty(field)) {
                        manifestUpdate[field] = updatedFields[field];
                    }
                }

                this.metricUpdated(manifestUpdate.streamType, "ManifestUpdate", manifestUpdate);
            }
        },

        addManifestUpdatePeriodInfo: function(manifestUpdate, id, index, start, duration) {
            var vo = new MediaPlayer.vo.metrics.ManifestUpdate.PeriodInfo();

            vo.id = id;
            vo.index = index;
            vo.start = start;
            vo.duration = duration;

            manifestUpdate.periodInfo.push(vo);
            this.metricUpdated(manifestUpdate.streamType, "ManifestUpdatePeriodInfo", manifestUpdate);

            return vo;
        },

        addManifestUpdateRepresentationInfo: function(manifestUpdate, id, index, periodIndex, streamType, presentationTimeOffset, startNumber, segmentInfoType) {
            var vo = new MediaPlayer.vo.metrics.ManifestUpdate.RepresentationInfo();

            vo.id = id;
            vo.index = index;
            vo.periodIndex = periodIndex;
            vo.streamType = streamType;
            vo.startNumber = startNumber;
            vo.segmentInfoType = segmentInfoType;
            vo.presentationTimeOffset = presentationTimeOffset;

            manifestUpdate.representationInfo.push(vo);
            this.metricUpdated(manifestUpdate.streamType, "ManifestUpdateRepresentationInfo", manifestUpdate);

            return vo;
        },

        addPlayList: function (streamType, start, mstart, starttype) {
            var vo = new MediaPlayer.vo.metrics.PlayList(),
                metrics = this.getMetricsFor(streamType).PlayList;

            vo.stream = streamType;
            vo.start = start;
            vo.mstart = mstart;
            vo.starttype = starttype;

            metrics.push(vo);
            this.metricAdded(streamType, "PlayList", vo);

            // Keep only last 10 metrics to avoid memory leak
            if (metrics.length > 10) {
                metrics.shift();
            }

            return vo;
        },

        appendPlayListTrace: function (playList, representationid, subreplevel, start, mstart, duration, playbackspeed, stopreason) {
            var vo = new MediaPlayer.vo.metrics.PlayList.Trace();

            vo.representationid = representationid;
            vo.subreplevel = subreplevel;
            vo.start = start;
            vo.mstart = mstart;
            vo.duration = duration;
            vo.playbackspeed = playbackspeed;
            vo.stopreason = stopreason;

            playList.trace.push(vo);
            this.metricUpdated(playList.stream, "PlayListTrace", playList);

            // Keep only last 10 metrics to avoid memory leak
            if (playList.trace.length > 10) {
                playList.trace.shift();
            }

            return vo;
        }
    };
};

MediaPlayer.models.MetricsModel.prototype = {
    constructor: MediaPlayer.models.MetricsModel
};

/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.Mp4Processor = function() {
    "use strict";

    ///////////////////////////////////////////////////////////////////////////////////////////
    // MOOV
    ///////////////////////////////////////////////////////////////////////////////////////////

    var createMovieHeaderBox = function(tracks) {

            // Movie Header Box
            // This box defines overall information which is media-independent, and relevant to the
            // entire presentation considered as a whole.

            // Create MovieHeader box (mvhd)
            var mvhd = new mp4lib.boxes.MovieHeaderBox(),
                track = tracks[tracks.length - 1]; // take last track to determine get track id

            mvhd.version = 1; // version = 1  in order to have 64bits duration value
            mvhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)
            mvhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)
            mvhd.timescale = track.timescale; // the time-scale for the entire presentation => take timescale of current adaptationSet
            mvhd.duration = Math.round(track.duration * track.timescale); // the length of the presentation (in the indicated timescale) =>  take duration of period
            mvhd.rate = 0x00010000; // 16.16 number, "1.0" = normal playback
            mvhd.volume = 0x0100; // 8.8 number, "1.0" = full volume
            mvhd.reserved = 0;
            mvhd.reserved_2 = [0x0, 0x0];
            mvhd.matrix = [0x00010000, 0x0, 0x0, 0x0, 0x00010000, 0x0, 0x0, 0x0, 0x40000000]; // provides a transformation matrix for the video; (u,v,w) are restricted here to (0,0,1),
            // hex values (0,0,0x40000000)
            mvhd.pre_defined = [0x0, 0x0, 0x0, 0x0, 0x0, 0x0];
            mvhd.next_track_ID = track.trackId + 1; // indicates a value to use for the track ID of the next track to be added to this presentation
            mvhd.flags = 0; //default value

            return mvhd;
        },

        createTrackBox = function(track) {

            // Track Box: This is a container box for a single track of a presentation
            // Track Header Box: This box specifies the characteristics of a single track
            var trak,
                tkhd,
                mdia;

            // Create Track box (trak)
            trak = new mp4lib.boxes.TrackBox();

            // Create and add TrackHeader box (trak)
            tkhd = new mp4lib.boxes.TrackHeaderBox();

            tkhd.version = 1; // version = 1  in order to have 64bits duration value
            tkhd.flags = 0x1 | 0x2 | 0x4; //Track_enabled: Indicates that the track is enabled. Flag value is 0x000001. A disabled track (the low
            //bit is zero) is treated as if it were not present.
            //Track_in_movie: Indicates that the track is used in the presentation. Flag value is 0x000002.
            //Track_in_preview: Indicates that the track is used when previewing the presentation. Flag value is 0x000004.
            tkhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)
            tkhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)
            tkhd.track_id = track.trackId; // uniquely identifies this track over the entire life-time of this presentation
            tkhd.reserved = 0;
            tkhd.duration = Math.round(track.duration * track.timescale); // the duration of this track (in the timescale indicated in the Movie Header Box) =>  take duration of period
            tkhd.reserved_2 = [0x0, 0x0];
            tkhd.layer = 0; // specifies the front-to-back ordering of video tracks; tracks with lower numbers are closer to the viewer => 0 since only one video track
            tkhd.alternate_group = 0; // specifies a group or collection of tracks => ignore
            tkhd.volume = 0x0100; // 8.8 number, "1.0" = full volume
            tkhd.reserved_3 = 0;
            tkhd.matrix = [0x00010000, 0x0, 0x0, 0x0, 0x00010000, 0x0, 0x0, 0x0, 0x40000000]; // provides a transformation matrix for the video; (u,v,w) are restricted here to (0,0,1),
            tkhd.width = track.width << 16; // visual presentation size as fixed-point 16.16 values
            tkhd.height = track.height << 16; // visual presentation size as fixed-point 16.16 values

            trak.boxes.push(tkhd);

            //Create container for the track information in a track (mdia)
            mdia = new mp4lib.boxes.MediaBox();

            //Create and add Media Header Box (mdhd)
            mdia.boxes.push(createMediaHeaderBox(track));

            //Create and add Handler Reference Box (hdlr)
            mdia.boxes.push(createHandlerReferenceBox(track));

            //Create and add Media Information Box (minf)
            mdia.boxes.push(createMediaInformationBox(track));

            trak.boxes.push(mdia);

            return trak;
        },

        getLanguageCode = function(language) {

            // Declares the language code for this track. See ISO 639-2/T for the set of three character
            // codes. Each character is packed as the difference between its ASCII value and 0x60. Since the code
            // is confined to being three lower-case letters, these values are strictly positive.
            var firstLetterCode,
                secondLetterCode,
                thirdLetterCode,
                result = 0;

            // If lang member is define, get it. if not language is 'und'
            // If current adaptation is video type, return 'und'.
            // var language = adaptation.lang ? adaptation.lang : 'und' ;

            // Return value is packed on 15 bits, each character is defined on 5 bits
            // there is a padding value to align on 16 bits
            firstLetterCode = (language.charCodeAt(0) - 96) << 10; //96 decimal base = 0x60
            secondLetterCode = (language.charCodeAt(1) - 96) << 5;
            thirdLetterCode = language.charCodeAt(2) - 96;

            result = firstLetterCode | secondLetterCode | thirdLetterCode;

            return result;
        },

        createMediaHeaderBox = function(track) {

            // mdhd : The media header declares overall information that is media-independent, and relevant to characteristics of
            // the media in a track.
            var mdhd = new mp4lib.boxes.MediaHeaderBox();

            mdhd.flags = 0;
            mdhd.version = 1; // version = 1  in order to have 64bits duration value
            mdhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)
            mdhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)
            mdhd.timescale = track.timescale; // the time-scale for the entire presentation => take timescale of current adaptationSet
            mdhd.duration = Math.round(track.duration * track.timescale); //integer that declares the duration of this media (in the scale of the timescale). If the
            //duration cannot be determined then duration is set to all 1s.
            mdhd.pad = 0; // padding for language value
            mdhd.language = getLanguageCode(track.language);

            mdhd.pre_defined = 0; // default value

            return mdhd;
        },

        stringToCharCode = function(str) {
            var code = 0,
                i;

            for (i = 0; i < str.length; i += 1) {
                code |= str.charCodeAt(i) << ((str.length - i - 1) * 8);
            }
            return code;
        },

        createHandlerReferenceBox = function(track) {

            // This box within a Media Box declares the process by which the media-data in the track is presented, and thus,
            // the nature of the media in a track. For example, a video track would be handled by a video handler.
            var hdlr = new mp4lib.boxes.HandlerBox();

            hdlr.version = 0; // default value version = 0
            hdlr.pre_defined = 0; //default value.
            switch (track.type) {
                case 'video':
                    hdlr.handler_type = stringToCharCode(hdlr.HANDLERTYPEVIDEO);
                    hdlr.name = hdlr.HANDLERVIDEONAME;
                    break;
                case 'audio':
                    hdlr.handler_type = stringToCharCode(hdlr.HANDLERTYPEAUDIO);
                    hdlr.name = hdlr.HANDLERAUDIONAME;
                    break;
                default:
                    hdlr.handler_type = stringToCharCode(hdlr.HANDLERTYPETEXT);
                    hdlr.name = hdlr.HANDLERTEXTNAME;
            }
            hdlr.name += '\0';
            hdlr.reserved = [0x0, 0x0, 0x0]; //default value
            hdlr.flags = 0; //default value

            return hdlr;
        },

        createMediaInformationBox = function(track) {

            // This box contains all the objects that declare characteristic information of the media in the track.
            var minf = new mp4lib.boxes.MediaInformationBox();

            //Create and add the adapted media header box (vmhd, smhd or nmhd) for audio, video or text.
            switch (track.type) {
                case 'video':
                    minf.boxes.push(createVideoMediaHeaderBox(track));
                    break;
                case 'audio':
                    minf.boxes.push(createSoundMediaHeaderBox(track));
                    break;
                default:
                    //minf.boxes.push(createNullMediaHeaderBox(track));
            }

            //Create and add Data Information Box (dinf)
            minf.boxes.push(createDataInformationBox(track));

            //Create and add Sample Table Box (stbl)
            minf.boxes.push(createSampleTableBox(track));

            return minf;

        },

        createDataInformationBox = function() {
            var dinf,
                dref,
                url;

            // The data information box contains objects that declare the location of the media information in a track.
            dinf = new mp4lib.boxes.DataInformationBox();

            // The data reference object contains a table of data references (normally URLs) that declare the location(s) of
            // the media data used within the presentation
            dref = new mp4lib.boxes.DataReferenceBox();

            dref.version = 0; // is an integer that specifies the version of this box default = 0
            dref.entry_count = 1; // is an integer that counts the actual entries
            dref.flags = 0; // default value

            // The DataEntryBox within the DataReferenceBox shall be either a DataEntryUrnBox or a DataEntryUrlBox.
            // (not used, but mandatory)
            url = new mp4lib.boxes.DataEntryUrlBox();
            url.location = "";
            url.version = 0;
            url.flags = 1;

            //add data Entry Url Box in data Reference box
            dref.boxes.push(url);

            //add data Reference Box in data information box
            dinf.boxes.push(dref);

            return dinf;
        },

        createDecodingTimeToSampleBox = function() {

            // This box contains a compact version of a table that allows indexing from decoding time to sample number.

            var stts = new mp4lib.boxes.TimeToSampleBox();

            stts.version = 0; // is an integer that specifies the version of this box. default value = 0
            stts.entry_count = 0; // is an integer that gives the number of entries in the following table. not used in fragmented content
            stts.flags = 0; // default value = 0

            stts.entry = [];

            return stts;
        },

        createSampleToChunkBox = function() {

            // Samples within the media data are grouped into chunks.
            var stsc = new mp4lib.boxes.SampleToChunkBox();

            stsc.flags = 0;
            stsc.version = 0; // is an integer that specifies the version of this box. default value = 0.
            stsc.entry_count = 0; // is an integer that gives the number of entries in the following table

            stsc.entry = [];

            return stsc;
        },

        createChunkOffsetBox = function() {

            // The chunk offset table gives the index of each chunk into the containing file
            var stco = new mp4lib.boxes.ChunkOffsetBox();

            stco.version = 0; // is an integer that specifies the version of this box. default value = 0
            stco.entry_count = 0; // is an integer that gives the number of entries in the following table
            stco.flags = 0; // default value

            stco.chunk_offset = [];

            return stco;
        },

        createSampleSizeBox = function() {

            // This box contains the sample count and a table giving the size in bytes of each sample. This allows the media
            // data itself to be unframed. The total number of samples in the media is always indicated in the sample count.
            var stsz = new mp4lib.boxes.SampleSizeBox();

            stsz.version = 0; // default value = 0
            stsz.flags = 0; //default value = 0
            stsz.sample_count = 0; //is an integer that gives the number of samples in the track; if sample-size is 0, then it is
            //also the number of entries in the following table
            stsz.sample_size = 0; //is integer specifying the default sample size.

            return stsz;
        },

        _hexstringtoBuffer = function(a) {
            var res = new Uint8Array(a.length / 2),
                i;

            for (i = 0; i < a.length / 2; i += 1) {
                res[i] = parseInt("" + a[i * 2] + a[i * 2 + 1], 16);
            }
            return res;
        },

        _mergeArrays = function(oldBuffer, newPart) {
            var res = new Uint8Array(oldBuffer.length + newPart.length);
            res.set(oldBuffer, 0);
            res.set(newPart, oldBuffer.length);
            return res;
        },

        createAVCConfigurationBox = function(track) {
            var avcC,
                NALDatabuffer,
                codecPrivateData,
                NALArray,
                SPS_index,
                PPS_index,
                i,
                NALBuffer,
                tempBuffer,
                regexpSPS = new RegExp("^[A-Z0-9]7", "gi"),
                regexpPPS = new RegExp("^[A-Z0-9]8", "gi");

            //Create an AVC Configuration Box
            avcC = new mp4lib.boxes.AVCConfigurationBox();

            avcC.configurationVersion = 1; //unsigned int(8) configurationVersion = 1;
            avcC.lengthSizeMinusOne = 3; //indicates the length in bytes of the NALUnitLength field in an AVC video
            //sample or AVC parameter set sample of the associated stream minus one

            avcC.reserved = 0x3F; //bit(6) reserved = ‘111111’b;

            avcC.SPS_NAL = []; //SPS NAL Array
            avcC.PPS_NAL = []; //PPS NAL Array

            NALDatabuffer = new Uint8Array(0);

            codecPrivateData = track.codecPrivateData;

            NALArray = codecPrivateData.split("00000001");

            NALArray.splice(0, 1);

            SPS_index = 0;
            PPS_index = 0;
            for (i = 0; i < NALArray.length; i += 1) {
                NALBuffer = _hexstringtoBuffer(NALArray[i]);

                if (NALArray[i].match(regexpSPS)) {
                    avcC.SPS_NAL[SPS_index++] = {
                        "NAL_length": NALBuffer.length,
                        "NAL": NALBuffer
                    };
                    avcC.AVCProfileIndication = parseInt(NALArray[i].substr(2, 2), 16); //contains the profile code as defined in ISO/IEC 14496-10.
                    avcC.profile_compatibility = parseInt(NALArray[i].substr(4, 2), 16); //is a byte defined exactly the same as the byte which occurs between the
                    //profile_IDC and level_IDC in a sequence parameter set (SPS), as defined in ISO/IEC 14496-10.
                    avcC.AVCLevelIndication = parseInt(NALArray[i].substr(6, 2), 16); //contains the level code as defined in ISO/IEC 14496-10.
                }
                if (NALArray[i].match(regexpPPS)) {
                    avcC.PPS_NAL[PPS_index++] = {
                        "NAL_length": NALBuffer.length,
                        "NAL": NALBuffer
                    };
                }

                tempBuffer = new Uint8Array(NALBuffer.length + 4);
                tempBuffer[3] = NALBuffer.length;
                tempBuffer.set(NALBuffer, 4);

                NALDatabuffer = _mergeArrays(NALDatabuffer, tempBuffer);
            }
            avcC.numOfSequenceParameterSets = SPS_index; // number of SPSs that are used as the initial set of SPSs for decoding the AVC elementary stream.
            avcC.numOfPictureParameterSets = PPS_index; // number of PPSs that are used as the initial set of PPSs for decoding the AVC elementary stream.

            return avcC;
        },

        createAVCVisualSampleEntry = function(track) {
            var avc1 = null;

            //An AVC visual sample entry shall contain an AVC Configuration Box
            if (track.contentProtection !== undefined) {
                avc1 = new mp4lib.boxes.EncryptedVideoBox();
            } else {
                avc1 = new mp4lib.boxes.AVC1VisualSampleEntryBox();
            }

            avc1.data_reference_index = 1; //To DO... ??
            avc1.compressorname = "AVC Coding"; //is a name, for informative purposes. It is formatted in a fixed 32-byte field, with the first
            //byte set to the number of bytes to be displayed, followed by that number of bytes of displayable data,
            //and then padding to complete 32 bytes total (including the size byte). The field may be set to 0.
            avc1.depth = 0x0018; //takes one of the following values 0x0018 – images are in colour with no alpha.
            avc1.reserved = [0x0, 0x0, 0x0, 0x0, 0x0, 0x0]; //default value = 0
            avc1.reserved_2 = 0; //default value = 0
            avc1.reserved_3 = 0; //default value = 0
            avc1.pre_defined = 0; //unsigned int(16) pre_defined = 0;
            avc1.pre_defined_2 = [0x0, 0x0, 0x0]; //unsigned int(32)[3] pre_defined = 0;
            avc1.pre_defined_3 = 65535; //int(16) pre_defined = -1;
            avc1.frame_count = 1; //template unsigned int(16) frame_count = 1;indicates how many frames of compressed video are stored in each sample. The default is
            //1, for one frame per sample; it may be more than 1 for multiple frames per sample
            avc1.horizresolution = 0x00480000; // 72 dpi
            avc1.vertresolution = 0x00480000; // 72 dpi

            avc1.height = track.height; //are the maximum visual width and height of the stream described by this sample
            avc1.width = track.width; //description, in pixels

            //create and add AVC Configuration Box (avcC)
            avc1.boxes.push(createAVCConfigurationBox(track));

            if (track.contentProtection !== undefined) {
                // create and add Protection Scheme Info Box
                avc1.boxes.push(createProtectionSchemeInfoBox(track));
            }

            return avc1;
        },

        createOriginalFormatBox = function(track) {
            var frma = new mp4lib.boxes.OriginalFormatBox();
            frma.data_format = stringToCharCode(track.codecs.substring(0, track.codecs.indexOf('.')));
            return frma;
        },

        createSchemeTypeBox = function() {
            var schm = new mp4lib.boxes.SchemeTypeBox();

            schm.flags = 0;
            schm.version = 0;
            schm.scheme_type = 0x63656E63; //'cenc' => common encryption
            schm.scheme_version = 0x00010000; // version set to 0x00010000 (Major version 1, Minor version 0)

            return schm;
        },

        createSchemeInformationBox = function(track) {
            var schi = new mp4lib.boxes.SchemeInformationBox();

            //create and add Track Encryption Box
            schi.boxes.push(createTrackEncryptionBox(track));

            return schi;
        },

        createTrackEncryptionBox = function(track) {
            var tenc = new mp4lib.boxes.TrackEncryptionBox();

            tenc.flags = 0; //default value
            tenc.version = 0; //default value

            tenc.default_IsEncrypted = 0x1; //default value
            tenc.default_IV_size = 8; //default value, NA => à préciser
            tenc.default_KID = (track.contentProtection && (track.contentProtection.length) > 0 && track.contentProtection[0]["cenc:default_KID"]) ?
                track.contentProtection[0]["cenc:default_KID"] :
                [0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0];

            return tenc;
        },

        createProtectionSchemeInfoBox = function(track) {
            //create Protection Scheme Info Box
            var sinf = new mp4lib.boxes.ProtectionSchemeInformationBox();

            //create and add Original Format Box => indicate codec type of the encrypted content
            sinf.boxes.push(createOriginalFormatBox(track));

            //create and add Scheme Type box
            sinf.boxes.push(createSchemeTypeBox());

            //create and add Scheme Information Box
            sinf.boxes.push(createSchemeInformationBox(track));

            return sinf;
        },

        createVisualSampleEntry = function(track) {
            var codec = track.codecs.substring(0, track.codecs.indexOf('.'));

            switch (codec) {
                case "avc1":
                    return createAVCVisualSampleEntry(track);
                default:
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED,
                        message: "Codec is not supported",
                        data: {
                            codec: codec
                        }
                    };
            }
        },

        parseHexString = function(str) {
            var bytes = [];
            while (str.length >= 2) {
                bytes.push(parseInt(str.substring(0, 2), 16));
                str = str.substring(2, str.length);
            }

            return bytes;
        },

        createMPEG4AACESDescriptor = function(track) {
            var audioSpecificConfig,
                dsiLength,
                decoderSpecificInfo,
                dcdLength,
                decoderConfigDescriptor,
                esdLength,
                esDescriptor;

            // AudioSpecificConfig
            // defined in ISO/IEC 14496-3, subpart 1
            // => AudioSpecificConfig corresponds to hex bytes contained in "codecPrivateData" field
            audioSpecificConfig = parseHexString(track.codecPrivateData);

            // DecoderSpecificInfo
            // defined in ISO/IEC 14496-1 (Systems), extends a BaseDescriptor
            dsiLength = audioSpecificConfig.length;
            decoderSpecificInfo = new Uint8Array(2 + dsiLength); // 2 = tag + size bytes
            decoderSpecificInfo[0] = 0x05; // bit(8), tag=0x05 (DecSpecificInfoTag)
            decoderSpecificInfo[1] = dsiLength; // bit(8), size
            decoderSpecificInfo.set(audioSpecificConfig, 2); // AudioSpecificConfig bytes

            // DecoderConfigDescriptor
            // defined in ISO/IEC 14496-1 (Systems), extends a BaseDescriptor
            dcdLength = 13 + decoderSpecificInfo.length; // 2 = tag + size bytes
            decoderConfigDescriptor = new Uint8Array(2 + dcdLength);
            decoderConfigDescriptor[0] = 0x04; // bit(8), tag=0x04 (DecoderConfigDescrTag)
            decoderConfigDescriptor[1] = dcdLength; // bit(8), size
            decoderConfigDescriptor[2] = 0x40; // bit(8), objectTypeIndication=0x40 (MPEG-4 AAC)
            decoderConfigDescriptor[3] = 0x05 << 2; // bit(6), streamType=0x05 (Audiostream)
            decoderConfigDescriptor[3] |= 0 << 1; // bit(1), upStream=0
            decoderConfigDescriptor[3] |= 1; // bit(1), reserved=1
            decoderConfigDescriptor[4] = 0xFF; // bit(24), buffersizeDB=undefined
            decoderConfigDescriptor[5] = 0xFF; // ''
            decoderConfigDescriptor[6] = 0xFF; // ''
            decoderConfigDescriptor[7] = (track.bandwidth & 0xFF000000) >> 24; // bit(32), maxBitrate=undefined
            decoderConfigDescriptor[8] = (track.bandwidth & 0x00FF0000) >> 16; // ''
            decoderConfigDescriptor[9] = (track.bandwidth & 0x0000FF00) >> 8; // ''
            decoderConfigDescriptor[10] = (track.bandwidth & 0x000000FF); // ''
            decoderConfigDescriptor[11] = (track.bandwidth & 0xFF000000) >> 24; // bit(32), avgbitrate
            decoderConfigDescriptor[12] |= (track.bandwidth & 0x00FF0000) >> 16; // ''
            decoderConfigDescriptor[13] |= (track.bandwidth & 0x0000FF00) >> 8; // ''
            decoderConfigDescriptor[14] |= (track.bandwidth & 0x000000FF); // ''
            decoderConfigDescriptor.set(decoderSpecificInfo, 15); // DecoderSpecificInfo bytes

            // ES_Descriptor
            // defined in ISO/IEC 14496-1 (Systems), extends a BaseDescriptor
            esdLength = 3 + decoderConfigDescriptor.length;
            esDescriptor = new Uint8Array(2 + esdLength); // 2 = tag + size bytes
            esDescriptor[0] = 0x03; // bit(8), tag=0x03 (ES_DescrTag)
            esDescriptor[1] = esdLength; // bit(8), size
            esDescriptor[2] = (track.trackId & 0xFF00) >> 8; // bit(16), ES_ID=track_id
            esDescriptor[3] = (track.trackId & 0x00FF); // ''
            esDescriptor[4] = 0; // bit(8), flags and streamPriority
            esDescriptor.set(decoderConfigDescriptor, 5); // decoderConfigDescriptor bytes

            return esDescriptor;
        },

        createMP4AudioSampleEntry = function(track) {
            var mp4a = null,
                esdBox,
                ES_Descriptor;

            if (track.contentProtection !== undefined) {
                mp4a = new mp4lib.boxes.EncryptedAudioBox();
            } else {
                mp4a = new mp4lib.boxes.MP4AudioSampleEntryBox();
            }

            // SampleEntry fields
            mp4a.reserved = [0x0, 0x0, 0x0, 0x0, 0x0, 0x0];
            mp4a.data_reference_index = 1; // ??

            // AudioSampleEntry fields
            mp4a.reserved_2 = [0x0, 0x0]; // default value = 0
            mp4a.channelcount = track.channels; // number of channels
            mp4a.samplesize = 16; // default value = 16
            mp4a.pre_defined = 0; // default value = 0
            mp4a.reserved_3 = 0; // default value = 0
            mp4a.samplerate = track.samplingRate << 16; // sampling rate, as fixed-point 16.16 values

            esdBox = new mp4lib.boxes.ESDBox();
            ES_Descriptor = createMPEG4AACESDescriptor(track);
            esdBox.ES_tag = ES_Descriptor[0];
            esdBox.ES_length = ES_Descriptor[1];
            esdBox.ES_data = ES_Descriptor.subarray(2, ES_Descriptor.length);
            esdBox.version = 0;
            esdBox.flags = 0;

            // MP4AudioSampleEntry fields
            mp4a.boxes.push(esdBox);

            if (track.contentProtection !== undefined) {
                // create and add Protection Scheme Info Box
                mp4a.boxes.push(createProtectionSchemeInfoBox(track));
            }

            return mp4a;
        },

        createAudioSampleEntry = function(track) {
            var codec = track.codecs.substring(0, track.codecs.indexOf('.'));

            switch (codec) {
                case "mp4a":
                    return createMP4AudioSampleEntry(track);
                default:
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED,
                        message: "Codec is not supported",
                        data: {
                            codec: codec
                        }
                    };
            }

            return null;
        },

        createSampleDescriptionBox = function(track) {

            //The sample description table gives detailed information about the coding type used, and any initialization
            //information needed for that coding.
            var stsd = new mp4lib.boxes.SampleDescriptionBox();
            stsd.version = 0;
            stsd.flags = 0;

            switch (track.type) {
                case "video":
                    stsd.boxes.push(createVisualSampleEntry(track));
                    break;
                case "audio":
                    stsd.boxes.push(createAudioSampleEntry(track));
                    break;
                default:
                    //NAN : To do add text entry
                    break;
            }

            return stsd;
        },

        createSampleTableBox = function(track) {

            //The sample table contains all the time and data indexing of the media samples in a track. Using the tables
            //here, it is possible to locate samples in time, determine their type (e.g. I-frame or not), and determine their
            //size, container, and offset into that container.
            var stbl = new mp4lib.boxes.SampleTableBox();

            //create and add Decoding Time to Sample Box (stts)
            stbl.boxes.push(createDecodingTimeToSampleBox(track));

            //create and add Sample to Chunk Box (stsc)
            stbl.boxes.push(createSampleToChunkBox(track));

            //create and add Chunk Offset Box (stco)
            stbl.boxes.push(createChunkOffsetBox(track));

            //create and add Sample Size Box (stsz)
            stbl.boxes.push(createSampleSizeBox(track));

            //create and add Sample Description Box (stsd)
            stbl.boxes.push(createSampleDescriptionBox(track));

            return stbl;
        },

        createVideoMediaHeaderBox = function() {
            //The video media header contains general presentation information, independent of the coding, for video
            //track. Note that the flags field has the value 1.
            var vmhd = new mp4lib.boxes.VideoMediaHeaderBox();

            vmhd.version = 0; //default value, is an integer that specifies the version of this box
            vmhd.flags = 1; //default value
            vmhd.graphicsmode = 0; //specifies a composition mode for this video track, from the following enumerated set,
            //which may be extended by derived specifications: copy = 0 copy over the existing image
            vmhd.opcolor = [0x0, 0x0, 0x0]; //is a set of 3 colour values (red, green, blue) available for use by graphics modes
            //default value opcolor = {0, 0, 0};

            return vmhd;
        },

        createSoundMediaHeaderBox = function() {

            //The sound media header contains general presentation information, independent of the coding, for audio
            //track. This header is used for all tracks containing audio
            var smhd = new mp4lib.boxes.SoundMediaHeaderBox();

            smhd.version = 0; //default value, is an integer that specifies the version of this box
            smhd.balance = 0; //is a fixed-point 8.8 number that places mono audio tracks in a stereo space; 0 is centre (the
            //normal value); full left is -1.0 and full right is 1.0.
            smhd.reserved = 0;
            smhd.flags = 1;

            return smhd;
        },

        /*createNullMediaHeaderBox = function () {
            //NAN non défini dans mp4lib, à définir
            //var nmhd = new NullMediaHeaderBox();
            //return nmhd;
        },*/

        createFileTypeBox = function() {

            //create a File Type Box
            var ftyp = new mp4lib.boxes.FileTypeBox();

            ftyp.major_brand = 1769172790; // is a brand identifier iso6 => decimal ASCII value for iso6
            ftyp.minor_brand = 1; // is an informative integer for the minor version of the major brand
            ftyp.compatible_brands = []; //is a list, to the end of the box, of brands isom, iso6 and msdh
            ftyp.compatible_brands[0] = 1769172845; // => decimal ASCII value for isom
            ftyp.compatible_brands[1] = 1769172790; // => decimal ASCII value for iso6
            ftyp.compatible_brands[2] = 1836278888; // => decimal ASCII value for msdh

            return ftyp;
        },

        createMovieExtendsBox = function(tracks) {
            var mvex,
                //mehd,
                trex,
                track = tracks[tracks.length - 1],
                i;

            // Create Movie Extends Box (mvex)
            // This box warns readers that there might be Movie Fragment Boxes in this file
            mvex = new mp4lib.boxes.MovieExtendsBox();

            // Create Movie Extends Header Box (mehd)
            // The Movie Extends Header is optional, and provides the overall duration, including fragments, of a fragmented
            // movie. If this box is not present, the overall duration must be computed by examining each fragment.
            // mehd is optional
            /*if (track.duration !== Number.POSITIVE_INFINITY) {
                mehd = new mp4lib.boxes.MovieExtendsHeaderBox();
                mehd.version = 1;
                mehd.flags = 0;
                mehd.fragment_duration = Math.round(track.duration * track.timescale); // declares length of the presentation of the whole movie including fragments

                //add mehd box in mvex box
                mvex.boxes.push(mehd);
            }*/

            for (i = 0; i < tracks.length; i += 1) {
                track = tracks[i];
                // Create Track Extend Box (trex), exactly one for each track in the movie box
                // This sets up default values used by the movie fragments. By setting defaults in this way, space and
                // complexity can be saved in each Track Fragment Box.
                trex = new mp4lib.boxes.TrackExtendsBox();
                trex.version = 0;
                trex.flags = 0;
                trex.track_ID = track.trackId; // identifies the track; this shall be the track ID of a track in the Movie Box
                trex.default_sample_description_index = 1; // Set default value
                trex.default_sample_duration = 0; // ''
                trex.default_sample_flags = 0; // ''
                trex.default_sample_size = 0; // ''

                // add trex box in mvex box
                mvex.boxes.push(trex);
            }

            return mvex;
        },

        createProtectionSystemSpecificHeaderBox = function(keySystems) {
            var psshs = [],
                pssh_bytes,
                pssh,
                i;

            for (i = 0; i < keySystems.length; i += 1) {
                pssh_bytes = new Uint8Array(keySystems[i].initData);
                pssh = new mp4lib.boxes.ProtectionSystemSpecificHeaderBox();
                pssh.read(pssh_bytes, 8, pssh_bytes.length); // 8: skip box length and type fields
                psshs.push(pssh);
            }

            return psshs;
        },

        doGenerateInitSegment = function(tracks) {
            var moov_file,
                moov,
                supportedKS,
                i;

            // Create file
            moov_file = new mp4lib.boxes.File();

            // Create Movie box (moov)
            moov = new mp4lib.boxes.MovieBox();

            // Create and add MovieHeader box (mvhd)
            moov.boxes.push(createMovieHeaderBox(tracks));

            for (i = 0; i < tracks.length; i += 1) {
                // Create and add Track box (trak)
                moov.boxes.push(createTrackBox(tracks[i]));
            }

            // Create and add MovieExtends box (mvex)
            moov.boxes.push(createMovieExtendsBox(tracks));

            // Create and add Protection System Specific Header box (pssh)
            for (i = 0; i < tracks.length; i++) {
                if (tracks[i].contentProtection !== undefined) {
                    supportedKS = this.protectionExt.getSupportedKeySystemsFromContentProtection(tracks[i].contentProtection);
                    moov.boxes.push.apply(moov.boxes, createProtectionSystemSpecificHeaderBox(supportedKS));
                }
            }

            moov_file.boxes.push(createFileTypeBox());

            moov_file.boxes.push(moov);

            return mp4lib.serialize(moov_file);
        },

        ///////////////////////////////////////////////////////////////////////////////////////////
        // MOOF
        ///////////////////////////////////////////////////////////////////////////////////////////

        createMovieFragmentHeaderBox = function(sequenceNumber) {

            // Movie Fragment Header Box
            // The movie fragment header contains a sequence number, as a safety check. The sequence number usually
            // starts at 1 and must increase for each movie fragment in the file, in the order in which they occur. This allows
            // readers to verify integrity of the sequence; it is an error to construct a file where the fragments are out of
            // sequence.
            var mfhd = new mp4lib.boxes.MovieFragmentHeaderBox();

            mfhd.version = 0;
            mfhd.flags = 0;
            mfhd.sequence_number = sequenceNumber;

            return mfhd;
        },

        createTrackFragmentBox = function(track) {

            // Track Fragment Box
            // Within the movie fragment there is a set of track fragments, zero or more per track. The track fragments in
            // turn contain zero or more track runs, each of which document a contiguous run of samples for that track.
            // Within these structures, many fields are optional and can be defaulted.
            var traf = new mp4lib.boxes.TrackFragmentBox();

            traf.version = 0;
            traf.flags = 0;

            // Add Track Fragment Header box (tfhd)
            traf.boxes.push(createTrackFragmentHeaderBox(track));

            // Add Track Fragment Decode Time box (tfdt)
            traf.boxes.push(createTrackFragmentBaseMediaDecodeTimeBox(track));

            // Add Track Fragment Run box (trun)
            traf.boxes.push(createTrackFragmentRunBox(track));

            // Add Sample Dependency Table box (sdtp)
            traf.boxes.push(createSampleDependencyTableBox(track));

            return traf;
        },

        createTrackFragmentHeaderBox = function(track) {

            // Track Fragment Header Box
            // Each movie fragment can add zero or more fragments to each track; and a track fragment can add zero or
            // more contiguous runs of samples. The track fragment header sets up information and defaults used for those
            // runs of samples.
            var tfhd = new mp4lib.boxes.TrackFragmentHeaderBox();

            tfhd.version = 0;
            tfhd.flags = //0x000008 | // default-sample-duration-present
            //0x000010 | // default-sample-size-present
            0x020000; // default-base-is-moof

            tfhd.track_ID = track.trackId;
            //tfhd.default_sample_duration = 0;
            //tfhd.default_sample_size = 0;

            return tfhd;
        },

        createTrackFragmentBaseMediaDecodeTimeBox = function(track) {

            // Track Fragment Base Media Decode Time Box
            // The Track Fragment Base Media Decode Time Box provides the absolute decode time, measured on the
            // media timeline, of the first sample in decode order in the track fragment. This can be useful, for example,
            // when performing random access in a file; it is not necessary to sum the sample durations of all preceding
            // samples in previous fragments to find this value (where the sample durations are the deltas in the Decoding
            // Time to Sample Box and the sample_durations in the preceding track runs).
            // The Track Fragment Base Media Decode Time Box, if present, shall be positioned after the Track Fragment
            // Header Box and before the first Track Fragment Run box.

            var tfdt = new mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox();

            tfdt.version = 1; // baseMediaDecodeTime on 64 bits
            tfdt.flags = 0;

            tfdt.baseMediaDecodeTime = (track.samples.length > 0) ? track.samples[0].dts : 0;

            return tfdt;
        },

        createTrackFragmentRunBox = function(track) {

            // Track Fragment Run Box
            // Within the Track Fragment Box, there are zero or more Track Run Boxes. If the duration-is-empty flag is set in
            // the tf_flags, there are no track runs. A track run documents a contiguous set of samples for a track.
            // The number of optional fields is determined from the number of bits set in the lower byte of the flags, and the
            // size of a record from the bits set in the second byte of the flags. This procedure shall be followed, to allow for
            // new fields to be defined.

            var trun = new mp4lib.boxes.TrackFragmentRunBox(),
                i,
                cts_base,
                sample_duration_present_flag,
                sample;

            cts_base = track.samples[0].cts;
            sample_duration_present_flag = (track.samples[0].duration > 0) ? 0x000100 : 0x000000;

            trun.version = 0;
            trun.flags = 0x000001 | // data-offset-present
                         sample_duration_present_flag | // sample-duration-present
                         0x000200 | // sample-size-present
                         0x000400 | // sample-flags-present
                         ((track.type === 'video') ? 0x000800 : 0x000000); // sample-composition-time-offsets-present

            trun.data_offset = 0; // Initialize to 0, will be updated once mdat is set
            trun.samples_table = [];
            trun.sample_count = track.samples.length;

            for (i = 0; i < track.samples.length; i++) {
                sample = {
                    sample_duration: track.samples[i].duration,
                    sample_size: track.samples[i].size,
                    sample_composition_time_offset: track.samples[i].cts - track.samples[i].dts,
                    sample_flags: track.samples[i].flags
                };

                if (sample.sample_composition_time_offset < 0) {
                    trun.version = 1;
                }

                trun.samples_table.push(sample);
            }

            return trun;
        },

        createSampleDependencyTableBox = function(track) {
            var sdtp = new mp4lib.boxes.SampleDependencyTableBox(),
                i;

            sdtp.version = 0;
            sdtp.flags = 0;
            sdtp.sample_dependency_table = [];
            for (i = 0; i < track.samples.length; i++) {
                sdtp.sample_dependency_table.push((track.samples[i].flags & 0x0FF00000) >> 20);
            }

            return sdtp;
        },


        createMediaDataBox = function(track) {

            // Media Data Box

            var mdat = new mp4lib.boxes.MediaDataBox();

            mdat.data = track.data;

            return mdat;
        },

        doGenerateMediaSegment = function(tracks, sequenceNumber) {

            var moof_file,
                moof,
                i,
                length,
                data,
                trafs,
                mdatLength = 0,
                trackglobal = {},
                mdatTracksTab = [],
                offset = 0;

            // Create file
            moof_file = new mp4lib.boxes.File();

            // Create Movie Fragment box (moof)
            moof = new mp4lib.boxes.MovieFragmentBox();

            // Create Movie Fragment Header box (moof)
            moof.boxes.push(createMovieFragmentHeaderBox(sequenceNumber));

            if (tracks) {
                for (i = 0; i < tracks.length; i += 1) {
                    // Create Track Fragment box (traf)
                    moof.boxes.push(createTrackFragmentBox(tracks[i]));
                }
            }

            moof_file.boxes.push(moof);

            // Determine total length of output fragment file
            length = moof_file.getLength();

            // Add tracks data
            trafs = moof.getBoxesByType("traf");

            length += 8; // 8 = 'size' + 'type' mdat fields length

            if (tracks && tracks.length) {
                // mdat array size = tracks.length
                mdatTracksTab = [tracks.length];
            }

            if (tracks) {
                for (i = 0; i < tracks.length; i += 1) {
                    // Update trun.data_offset for the track
                    trafs[i].getBoxByType("trun").data_offset = length;
                    // Update length of output fragment file
                    length += tracks[i].data.length;
                    // Add current data in mdatTracksTab array
                    mdatTracksTab[i] = tracks[i].data;
                    // Update length of global mdat
                    mdatLength += mdatTracksTab[i].length;
                }
            }

            trackglobal.data = new Uint8Array(mdatLength);

            // Concatenate all the tracks data in an array
            for (i = 0; i < mdatTracksTab.length; i++) {
                trackglobal.data.set(mdatTracksTab[i], offset);
                offset += mdatTracksTab[i].length;
            }

            // Create mdat
            moof_file.boxes.push(createMediaDataBox(trackglobal));

            data = mp4lib.serialize(moof_file);

            return data;
        };

    return {
        protectionExt: undefined,

        generateInitSegment: doGenerateInitSegment,
        generateMediaSegment: doGenerateMediaSegment
    };
};

MediaPlayer.dependencies.Mp4Processor.prototype = {
    constructor: MediaPlayer.dependencies.Mp4Processor
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.Notifier = function () {
    "use strict";

    var OBSERVABLE_ID_PROP = "observableId",
        system,
        id = 0,

        getId = function() {
            if (!this[OBSERVABLE_ID_PROP]) {
                id += 1;
                this[OBSERVABLE_ID_PROP] = "_id_" + id;
            }

            return this[OBSERVABLE_ID_PROP];
        };

    return {
        system : undefined,

        setup: function() {
            system = this.system;
            system.mapValue('notify', this.notify);
            system.mapValue('subscribe', this.subscribe);
            system.mapValue('unsubscribe', this.unsubscribe);
        },

        notify: function (/*eventName[, args]*/) {
            var eventId = arguments[0] + getId.call(this),
                event = new MediaPlayer.vo.Event();

            event.sender =  this;
            event.type = arguments[0];
            event.data = arguments[1];
            event.error = arguments[2];
            event.timestamp = new Date().getTime();

            system.notify.call(system, eventId, event);
        },

        subscribe: function(eventName, observer, handler, oneShot) {
            if (!handler && observer[eventName]) {
                handler = observer[eventName] = observer[eventName].bind(observer);
            }

            if(!observer) throw "observer object cannot be null or undefined";

            if(!handler) throw "event handler cannot be null or undefined";

            eventName += getId.call(this);

            system.mapHandler(eventName, undefined, handler, oneShot);
        },

        unsubscribe: function(eventName, observer, handler) {
            handler = handler || observer[eventName];
            eventName += getId.call(this);

            system.unmapHandler(eventName, undefined, handler);
        }
    };
};

MediaPlayer.dependencies.Notifier.prototype = {
    constructor: MediaPlayer.dependencies.Notifier
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.Parser = function() {
    "use strict";

    var _parser = null,

        parse = function(data, baseUrl) {

            if (_parser === null) {
                // we parse the response of the request to know the manifest type
                if (data.indexOf("SmoothStreamingMedia") > -1 && typeof(this.mssParser) !== 'undefined') {
                    this.system.notify('setContext', 'MSS');
                    //do some business to transform it into a Dash Manifest
                    _parser = this.mssParser;
                } else if (data.indexOf("#EXTM3U") > -1 && typeof(this.hlsParser) !== 'undefined') {
                    this.system.notify('setContext', 'HLS');
                    _parser = this.hlsParser;
                } else if (data.indexOf("MPD") > -1 && typeof(this.dashParser) !== 'undefined') {
                    this.system.notify('setContext', 'MPD');
                    _parser = this.dashParser;
                } else {
                    return Q.reject("manifest cannot be parsed, protocol is unsupported!");
                }
            }

            return _parser.parse(data, baseUrl);
        },

        abort = function() {
            if ((_parser !== null) && (_parser.abort !== undefined)) {
                _parser.abort();
            }
        },

        reset = function() {
            _parser = null;
        };

    return {
        debug: undefined,
        system: undefined,
        dashParser: undefined,
        mssParser: undefined,
        hlsParser: undefined,
        metricsModel: undefined,

        parse: parse,
        abort: abort,
        reset: reset
    };
};

MediaPlayer.dependencies.Parser.prototype = {
    constructor: MediaPlayer.dependencies.Parser
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.SourceBufferExtensions = function () {
    "use strict";
    this.system = undefined;
    this.manifestExt = undefined;
};

MediaPlayer.dependencies.SourceBufferExtensions.prototype = {

    constructor: MediaPlayer.dependencies.SourceBufferExtensions,

    createSourceBuffer: function (mediaSource, codec) {
        "use strict";

        var buffer = null;

        if (!mediaSource) {
            return null;
        }

        try {
            buffer = mediaSource.addSourceBuffer(codec);
        } catch(ex) {
            // For text track not supported by MSE, we try to create corresponding specific source buffer
            if (this.manifestExt.getIsTextTrack(codec)) {
                if ((codec === 'text/vtt') || (codec === 'text/ttml')) {
                    buffer = this.system.getObject("textSourceBuffer");
                } else if (codec === 'application/ttml+xml+mp4' || codec === 'application/mp4' || codec === 'application/ttml+xml') {
                    buffer = this.system.getObject("textTTMLXMLMP4SourceBuffer");
                } else {
                    throw ex;
                }
            } else {
                throw ex;
            }
        }
        return buffer;
    },

    removeSourceBuffer: function (mediaSource, buffer) {
        "use strict";
        try {
            mediaSource.removeSourceBuffer(buffer);
        } catch (ex) {
        }
    },

    getBufferRange: function (buffer, time, tolerance) {
        "use strict";
        var ranges = null,
            start = 0,
            end = 0,
            firstStart = null,
            lastEnd = null,
            gap = 0,
            toler = (tolerance || 0.01),
            len,
            i;

        try {
            ranges = buffer.buffered;
        } catch(ex) {
            return null;
        }

        if (ranges) {
            for (i = 0, len = ranges.length; i < len; i += 1) {
                start = ranges.start(i);
                end = ranges.end(i);
                if (firstStart === null) {
                    gap = Math.abs(start - time);
                    if (time >= start && time < end) {
                        // start the range
                        firstStart = start;
                        lastEnd = end;
                        continue;
                    } else if (gap <= toler) {
                        // start the range even though the buffer does not contain time 0
                        firstStart = start;
                        lastEnd = end;
                        continue;
                    }
                } else {
                    gap = start - lastEnd;
                    if (gap <= toler) {
                        // the discontinuity is smaller than the tolerance, combine the ranges
                        lastEnd = end;
                    } else {
                        break;
                    }
                }
            }

            if (firstStart !== null) {
                return {start: firstStart, end: lastEnd};
            }
        }

        return null;
    },

    getAllRanges: function(buffer) {
        var ranges = null;

        try{
            ranges = buffer.buffered;
            return ranges;
        } catch (ex) {
            return null;
        }
    },

    getBufferLength: function (buffer, time, tolerance) {
        "use strict";

        var self = this,
            range,
            length;

        range = self.getBufferRange(buffer, time, tolerance);

        if (range === null) {
            length = 0;
        } else {
            length = range.end - time;
        }

        return length;
    },

    waitForUpdateEnd: function(buffer) {
        "use strict";
        var defer = Q.defer(),
            intervalId,
            CHECK_INTERVAL = 50,
            checkIsUpdateEnded = function() {
                // if undating is still in progress do nothing and wait for the next check again.
                if (buffer.updating) {
                    return;
                }
                // updating is completed, now we can stop checking and resolve the promise
                clearInterval(intervalId);
                defer.resolve(true);
            },
            updateEndHandler = function() {
                if (buffer.updating) {
                    return;
                }

                buffer.removeEventListener("updateend", updateEndHandler, false);
                defer.resolve(true);
            };

            if (!buffer.updating) {
                defer.resolve(true);
                return defer.promise;
            }
        // use updateend event if possible
        if (typeof buffer.addEventListener === "function") {
            try {
                buffer.addEventListener("updateend", updateEndHandler, false);
            } catch (err) {
                // use setInterval to periodically check if updating has been completed
                intervalId = setInterval(checkIsUpdateEnded, CHECK_INTERVAL);
            }
        } else {
            // use setInterval to periodically check if updating has been completed
            intervalId = setInterval(checkIsUpdateEnded, CHECK_INTERVAL);
        }

        return defer.promise;
    },

    append: function (buffer, bytes, sync) {
        var deferred = Q.defer(),
            self = this;

        self.waitForUpdateEnd(buffer).then(function() {
            try {
                if ("append" in buffer) {
                    buffer.append(bytes);
                } else if ("appendBuffer" in buffer) {
                    buffer.appendBuffer(bytes);
                }

                if (sync) {
                    deferred.resolve();
                } else {
                    // updating is in progress, we should wait for it to complete before signaling that this operation is done
                    self.waitForUpdateEnd(buffer).then(
                        function() {
                            deferred.resolve();
                        }
                    );
                }
            } catch (err) {
                deferred.reject({err: err, data: bytes});
            }
        });

        return deferred.promise;
    },

    remove: function (buffer, start, end, duration, mediaSource, sync) {
        var deferred = Q.defer(),
            self = this;

        self.waitForUpdateEnd(buffer).then(function() {
            try {
                // make sure that the given time range is correct. Otherwise we will get InvalidAccessError
                if ((start >= 0) && (start < duration) && (end > start) && (mediaSource.readyState !== "ended")) {
                    buffer.remove(start, end);
                }

                if (sync) {
                    deferred.resolve();
                } else {
                    // updating is in progress, we should wait for it to complete before signaling that this operation is done
                    self.waitForUpdateEnd(buffer).then(
                        function() {
                            deferred.resolve();
                        }
                    );
                }
            } catch (err) {
                deferred.reject(err);
            }
        });

        return deferred.promise;
    },

    abort: function (mediaSource, buffer) {
        "use strict";
        try {
            if (mediaSource.readyState === "open") {
                buffer.abort();
            }
        } catch(ex){
        }
    }
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

// Define Math.sign method in case it is not defined (like in IE11)
if (!Math.sign) {
    Math.sign = function(value) {
        "use strict";
        return (value < 0) ? -1 : ((value === 0) ? 0 : 1);
    };
}

MediaPlayer.dependencies.Stream = function() {
    "use strict";

    var manifest,
        mediaSource,
        contentProtection = null,
        videoController = null,
        videoTrackIndex = -1,
        audioController = null,
        audioTrackIndex = -1,
        textController = null,
        subtitlesEnabled = false,
        dvrStarted = false,
        fragmentInfoVideoController = null,
        fragmentInfoAudioController = null,
        fragmentInfoTextController = null,

        textTrackIndex = -1,
        autoPlay = true,
        initialized = false,
        errored = false,

        // Events listeners
        endedListener,
        loadedListener,
        playListener,
        pauseListener,
        errorListener,
        seekingListener,
        seekedListener,
        timeupdateListener,
        durationchangeListener,
        progressListener,
        ratechangeListener,
        canplayListener,
        playingListener,
        loadstartListener,

        // Audio/text languages
        defaultAudioLang = 'und',
        defaultSubtitleLang = 'und',

        periodInfo = null,

        // Initial start time
        initialStartTime = -1,

        // Play start time (= live edge for live streams)
        playStartTime = -1,

        // Programmatical seek
        seekTime,
        checkStartTimeIntervalId,

        // trick mode variables
        tmState = "Stopped",
        tmSpeed = 1,
        tmPreviousSpeed,
        tmStartTime,
        tmVideoStartTime,
        tmMinSeekStep,
        tmSeekStep,
        tmSeekTime,
        tmSeekTimeout,
        tmSeekValue,
        tmEndDetected = false,
        muteState = false,

        eventController = null,
        protectionController,
        initializeMediaSourceFinished = true,

        reloadTimeout = null,
        isReloading = false,

        startClockTime = -1,
        startStreamTime = -1,
        visibilitychangeListener,

        // Protection errors
        onProtectionError = function(event) {
            this.errHandler.sendError(event.data.code, event.data.message, event.data.data);
        },

        play = function() {
            if (!initialized) {
                return;
            }

            this.debug.info("[Stream] Play.");
            this.videoModel.play();
        },

        pause = function() {
            this.debug.info("[Stream] Pause.");
            this.videoModel.pause();
        },

        seek = function(time, autoplay) {
            if (!initialized) {
                //this.debug.info("[Stream] (seek) not initialized");
                return;
            }

            this.debug.info("[Stream] Seek: " + time);

            // In case of live streams and then DVR seek, then we start the fragmentInfoControllers
            // (check if seek not due to stream loading or reloading)
            if (this.manifestExt.getIsDynamic(manifest) && !isReloading && (this.videoModel.getCurrentTime() !== 0)) {
                startFragmentInfoControllers.call(this);
            }

            // Stream is starting playing => fills the buffers before setting <video> current time
            if (autoplay === true) {
                // 1- seeks the buffer controllers at the desired time
                // 2- once data is present in the buffers, then we can set the current time to the <video> component (see onBufferUpdated())
                seekTime = time;
                this.system.unmapHandler("bufferUpdated");
                this.system.mapHandler("bufferUpdated", undefined, onBufferUpdated.bind(this));
                startBuffering.call(this, seekTime);
            } else {
                // Stream is already playing, simply seek the <video> component
                this.videoModel.setCurrentTime(time);
            }
        },

        // Media Source
        setUpMediaSource = function(mediaSourceArg) {
            var deferred = Q.defer(),
                self = this,

                onMediaSourceOpen = function( /*e*/ ) {
                    //self.debug.log("MediaSource is open!");

                    mediaSourceArg.removeEventListener("sourceopen", onMediaSourceOpen);
                    mediaSourceArg.removeEventListener("webkitsourceopen", onMediaSourceOpen);

                    deferred.resolve(mediaSourceArg);
                };

            //self.debug.log("MediaSource should be closed. The actual readyState is: " + mediaSourceArg.readyState);

            mediaSourceArg.addEventListener("sourceopen", onMediaSourceOpen, false);
            mediaSourceArg.addEventListener("webkitsourceopen", onMediaSourceOpen, false);

            self.mediaSourceExt.attachMediaSource(mediaSourceArg, self.videoModel);

            //self.debug.log("MediaSource attached to video.  Waiting on open...");

            return deferred.promise;
        },

        tearDownMediaSource = function() {
            var self = this,
                funcs = [],
                deferred = Q.defer(),

                executeReset = function() {
                    if (!!videoController) {
                        funcs.push(videoController.reset(errored));
                    }

                    if (!!fragmentInfoVideoController) {
                        funcs.push(fragmentInfoVideoController.reset(errored));
                    }

                    if (!!audioController) {
                        funcs.push(audioController.reset(errored));
                    }

                    if (!!fragmentInfoAudioController) {
                        funcs.push(fragmentInfoAudioController.reset(errored));
                    }

                    if (!!textController) {
                        funcs.push(textController.reset(errored));
                    }

                    if (!!fragmentInfoTextController) {
                        funcs.push(fragmentInfoTextController.reset(errored));
                    }

                    Q.all(funcs).then(
                        function() {
                            if (!!eventController) {
                                eventController.reset();
                                eventController = undefined;
                            }

                            if (!!mediaSource) {
                                self.mediaSourceExt.detachMediaSource(self.videoModel);
                            }

                            initialized = false;

                            contentProtection = null;

                            videoController = null;
                            audioController = null;
                            textController = null;

                            mediaSource = null;
                            manifest = null;

                            deferred.resolve();
                        });
                };


            Q.when(initializeMediaSourceFinished).then(
                function() {
                    executeReset();
                });
            return deferred.promise;
        },

        createBufferController = function(data, codec) {
            var bufferController = null,
                buffer = null;

            // Check if codec is supported (applies only for video and audio)
            if (data.type === 'video' || data.type === 'audio') {
                if (!this.capabilities.supportsCodec(this.videoModel.getElement(), codec)) {
                    this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED, data.type + ' codec is not supported', {
                        codec: codec
                    });
                    return null;
                }
            }

            // Create SourceBuffer
            try {
                buffer = this.sourceBufferExt.createSourceBuffer(mediaSource, codec);
            } catch (ex) {
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CREATE_SOURCEBUFFER, 'Failed to create ' + data.type + ' source buffer',
                    new MediaPlayer.vo.Error(ex.code, ex.name, ex.message));
                return null;
            }

            // Create and initialize BufferController
            bufferController = this.system.getObject("bufferController");
            bufferController.initialize(data.type, periodInfo, data, buffer, this.fragmentController, mediaSource, eventController);

            if (data.type === 'text' && buffer.hasOwnProperty('initialize')) {
                buffer.initialize(codec, bufferController, data);
            }

            return bufferController;
        },

        createFragmentInfoController = function(bufferController, data) {
            var fragmentInfoController = null;

            if (bufferController && data && data.type) {
                fragmentInfoController = this.system.getObject("fragmentInfoController");
                fragmentInfoController.initialize(data.type, this.fragmentController, bufferController);
            }

            return fragmentInfoController;
        },

        initializeMediaSource = function() {
            var data,
                videoCodec,
                audioCodec,
                textMimeType;

            initializeMediaSourceFinished = false;
            eventController = this.system.getObject("eventController");

            // Initialize video BufferController
            data = this.manifestExt.getVideoData(manifest, periodInfo.index);

            if (data === null) {
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_VIDEO, 'No Video data in manifest');
            } else {
                videoTrackIndex = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);
                videoCodec = this.manifestExt.getCodec(data);
                contentProtection = this.manifestExt.getContentProtectionData(data);

                if (videoCodec === null) {
                    this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_VIDEO, 'Video codec information not available');
                } else {
                    videoController = createBufferController.call(this, data, videoCodec);
                    if (this.manifestExt.getIsDynamic(manifest)) {
                        fragmentInfoVideoController = createFragmentInfoController.call(this, videoController, data);
                    }
                }
            }

            // Abort if no video controller
            if (videoController === null) {
                initializeMediaSourceFinished = true;
                return;
            }

            // Initialize audio BufferController
            data = this.manifestExt.getSpecificAudioData(manifest, periodInfo.index, defaultAudioLang);

            if (data === null) {
                this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_AUDIO, "No audio data in manifest");
            } else {
                audioTrackIndex = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);
                audioCodec = this.manifestExt.getCodec(data);

                if (audioCodec === null) {
                    this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_AUDIO, "Audio codec information not available");
                } else {
                    audioController = createBufferController.call(this, data, audioCodec);

                    // Abort if audio track defined but failed to create audio controller
                    if (audioController === null) {
                        initializeMediaSourceFinished = true;
                        return;
                    }

                    if (this.manifestExt.getIsDynamic(manifest)) {
                        fragmentInfoAudioController = createFragmentInfoController.call(this, audioController, data);
                    }
                }
            }

            // Initialize text BufferController
            data = this.manifestExt.getSpecificTextData(manifest, periodInfo.index, defaultSubtitleLang);

            if (data !== null) {
                textTrackIndex = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);
                textMimeType = this.manifestExt.getMimeType(data);

                if (textMimeType === null) {
                    this.errHandler.sendWarning(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_TEXT, "Text codec information not available");
                } else {
                    textController = createBufferController.call(this, data, textMimeType);
                    if (this.manifestExt.getIsDynamic(manifest)) {
                        fragmentInfoTextController = createFragmentInfoController.call(this, textController, data);
                    }
                }
            }

            // Initialize EventController
            if (eventController) {
                eventController.addInlineEvents(this.manifestExt.getEventsForPeriod(manifest, periodInfo));
            }

            // Initialize ProtectionController
            if (protectionController) {
                protectionController.init(contentProtection, audioCodec, videoCodec);
            } else if (contentProtection && !this.capabilities.supportsEncryptedMedia()) {
                // No protectionController (MediaKeys not supported/enabled) but content is protected => error
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.CAPABILITY_ERR_MEDIAKEYS, "EME is not supported/enabled", null);
            }

            initializeMediaSourceFinished = true;
            return;
        },

        initializePlayback = function() {
            this.debug.log("[Stream] Setting duration: " + periodInfo.duration);
            this.mediaSourceExt.setDuration(mediaSource, periodInfo.duration);
            initialized = true;
        },

        startFragmentInfoControllers = function() {
            if (fragmentInfoVideoController && dvrStarted === false) {
                dvrStarted = true;
                fragmentInfoVideoController.start();
            }

            if (fragmentInfoAudioController) {
                fragmentInfoAudioController.start();
            }

            if (fragmentInfoTextController && subtitlesEnabled) {
                fragmentInfoTextController.start();
            }
        },

        stopFragmentInfoControllers = function() {
            if (fragmentInfoVideoController) {
                dvrStarted = false;
                fragmentInfoVideoController.stop();
            }

            if (fragmentInfoAudioController) {
                fragmentInfoAudioController.stop();
            }

            if (fragmentInfoTextController) {
                fragmentInfoTextController.stop();
            }
        },

        onLoaded = function() {
            this.debug.info("[Stream] <video> loadedmetadata event");
        },

        onCanPlay = function() {
            this.debug.info("[Stream] <video> canplay event");
        },

        onPlaying = function() {
            this.debug.info("[Stream] <video> playing event");

            // Store start time (clock and stream time) for resynchronization purpose
            startClockTime = new Date().getTime() / 1000;
            startStreamTime = this.getVideoModel().getCurrentTime();
        },

        onLoadStart = function() {
            this.debug.info("[Stream] <video> loadstart event");
        },

        onPlay = function() {
            this.debug.info("[Stream] <video> play event");

            if (tmSpeed !== 1) {
                this.setTrickModeSpeed(1);
            } else {
                // Set the currentTime here to be sure that videoTag is ready to accept the seek (cause IE fail on set currentTime on BufferUpdate)
                if (playStartTime >= 0) {
                    setVideoModelCurrentTime.call(this, playStartTime);
                    playStartTime = -1;
                } else {
                    startBuffering.call(this);
                }
            }

            this.metricsModel.addPlayList("video", new Date().getTime(), this.videoModel.getCurrentTime(), "play");
        },

        // ORANGE : ended event
        onEnded = function() {
            this.debug.info("[Stream] <video> ended event");
            //add stopped state metric with reason = 1 : end of stream
            this.metricsModel.addState("video", "stopped", this.videoModel.getCurrentTime(), 1);
        },

        onPause = function() {
            this.debug.info("[Stream] <video> pause event");
            startClockTime = -1;
            startStreamTime = -1;
            this.metricsModel.addPlayList("video", new Date().getTime(), this.videoModel.getCurrentTime(), "pause");
            suspend.call(this);
            if (manifest.name === 'MSS' && this.manifestExt.getIsDynamic(manifest)) {
                startFragmentInfoControllers.call(this);
            }
        },

        onError = function(event) {
            var error = event.srcElement.error,
                code,
                message = "[Stream] <video> error: ";

            if (error.code === -1) {
                // not an error!
                return;
            }

            switch (error.code) {
                case 1:
                    code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ABORTED;
                    message += "fetching process aborted";
                    break;
                case 2:
                    code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_NETWORK;
                    message += "network error";
                    break;
                case 3:
                    code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_DECODE;
                    message += "media decoding error";
                    break;
                case 4:
                    code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED;
                    message += "media format not supported";
                    break;
                case 5:
                    code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ENCRYPTED;
                    message += "media is encrypted";
                    break;
            }

            errored = true;

            this.errHandler.sendError(code, message);
        },

        onSeeking = function() {
            var time = this.videoModel.getCurrentTime();

            this.debug.info("[Stream] <video> seeking event: " + time);

            // Check if seeking is different from trick mode seeking, then cancel trick mode
            if ((tmSpeed !== 1) && (time.toFixed(3) !== tmSeekValue.toFixed(3))) {
                this.setTrickModeSpeed(1);
                return;
            }

            // Check if seek time is less than range start, never seek before range start.
            time = (time < this.getStartTime()) ? this.getStartTime() : time;

            startBuffering.call(this, time);
        },

        onSeeked = function() {
            var self = this,
                currentTime,
                currentVideoTime,
                elapsedTime,
                elapsedSeekTime,
                elapsedVideoTime,
                speed,
                ratio = 0.9,
                seekValue,
                videoEndedEvent,
                delay,
                _seek = function(delay, seekValue) {
                    if (self.videoModel.getCurrentTime() === self.getStartTime() || tmEndDetected) {
                        self.debug.log("[Stream] Trick mode (x" + tmSpeed + "): stop");
                        if (tmEndDetected) {
                            videoEndedEvent = document.createEvent("Event");
                            videoEndedEvent.initEvent("ended", true, true);
                            self.videoModel.getElement().dispatchEvent(videoEndedEvent);
                        }
                        return;
                    }
                    if (seekValue < self.getStartTime()) {
                        seekValue = self.getStartTime();
                    } else if (seekValue >= self.videoModel.getDuration()) {
                        seekValue = self.videoModel.getDuration() - tmMinSeekStep;
                        tmEndDetected = true;
                    }
                    if (delay > 0) {
                        self.debug.log("[Stream] Trick mode (x" + tmSpeed + "): wait " + delay.toFixed(3) + " s");
                    }
                    tmSeekTimeout = setTimeout(function() {
                        tmSeekTime = new Date().getTime() / 1000;
                        self.debug.log("[Stream] Trick mode (x" + tmSpeed + "): seek time = " + seekValue.toFixed(3));
                        tmSeekValue = seekValue;
                        self.videoModel.setCurrentTime(seekValue);
                    }, delay > 0 ? (delay * 1000) : 0);
                };

            this.debug.info("[Stream] <video> seeked event");

            // Notify BufferControllers that video has seeked
            seekedBuffers.call(this);

            // Trick mode
            if (tmSpeed !== 1) {

                currentTime = (new Date().getTime()) / 1000;
                currentVideoTime = self.videoModel.getCurrentTime();
                elapsedTime = currentTime - tmStartTime;
                elapsedSeekTime = currentTime - tmSeekTime;
                elapsedVideoTime = Math.abs(currentVideoTime - tmVideoStartTime);
                speed = (elapsedVideoTime / elapsedTime);

                self.debug.log("[Stream] Trick mode (x" + tmSpeed + "): elapsed time = " + elapsedTime.toFixed(3) + ", elapsed video time = " + elapsedVideoTime.toFixed(3) + ", speed = " + speed.toFixed(3));

                if (tmState === "Changed") {
                    clearTimeout(tmSeekTimeout);
                    // Target speed changed => reset start times, and seek
                    tmState = "Running";
                    tmStartTime = (new Date().getTime()) / 1000;
                    tmVideoStartTime = currentVideoTime;
                    self.debug.info("[Stream] Trick mode (x" + tmSpeed + "): videoTime = " + tmVideoStartTime);
                    //if trick mode speed has decreased, we have to decrease tmSeekStep
                    tmSeekStep = Math.abs(tmPreviousSpeed / tmSpeed) > 1 ? tmSeekStep / Math.abs(tmPreviousSpeed / tmSpeed) : tmSeekStep;
                    seekValue = currentVideoTime + (tmSeekStep * Math.sign(tmSpeed));
                    delay = 0;
                } else if (speed < (Math.abs(tmSpeed) * ratio)) {
                    // Measured speed < target speed => increase seek step
                    var speedRatio = Math.abs(tmSpeed / speed);
                    tmSeekStep *= Math.round(speedRatio) + Math.round(speedRatio % tmMinSeekStep);
                    self.debug.info("[Stream] Trick mode (x" + tmSpeed + "): seek step = " + tmSeekStep);
                    seekValue = currentVideoTime + (tmSeekStep * Math.sign(tmSpeed));
                    delay = 0;
                } else {
                    // Measured speed > target speed => wait before next seek
                    seekValue = currentVideoTime + (tmSeekStep * Math.sign(tmSpeed));
                    delay = (Math.abs(seekValue - tmVideoStartTime) / Math.abs(tmSpeed)) - elapsedTime - elapsedSeekTime;
                }

                _seek.call(self, delay, seekValue);

            }

            // The current time has been changed on video model, then reactivate 'seeking' event listener
            // (see setVideoModelCurrentTime())
            this.videoModel.listen("seeking", seekingListener);

            isReloading = false;
            startClockTime = -1;
            startStreamTime = -1;
        },

        onProgress = function() {
            this.debug.info("[Stream] <video> progress event");
            updateBuffer.call(this);
        },

        onTimeupdate = function() {
            this.debug.info("[Stream] <video> timeupdate event: " + this.videoModel.getCurrentTime());
            updateBuffer.call(this);
        },

        onDurationchange = function() {
            var duration = this.videoModel.getDuration(),
                streamDuration = Number(periodInfo.duration.toFixed(3));

            this.debug.info("[Stream] <video> durationchange event: " + duration);

            // The duration may change if the effective MSE buffer duration is greater than the initial duration set from manifest
            // => then we update the MediaSource duration to ensure 'ended' event being sent by the video element
            // (round durationfrom manifest to milliseconds to avoid rounding issue within MSE buffer)
            if (!isNaN(duration) && duration !== Infinity && duration > streamDuration) {
                this.debug.log("[Stream] Setting duration: " + streamDuration);
                this.mediaSourceExt.setDuration(mediaSource, streamDuration);
            }
        },

        onRatechange = function() {
            this.debug.info("[Stream] <video> ratechange event: " + this.videoModel.getPlaybackRate());
            if (videoController) {
                videoController.updateStalledState();
            }
            if (audioController) {
                audioController.updateStalledState();
            }
            if (textController) {
                textController.updateStalledState();
            }
        },

        onReload = function() {

            // Ask for manifest refresh
            // Then, once manifest has been refresh and data updated, we reload session (see updateData())
            pause.call(this);
            isReloading = true;
            this.system.notify("manifestUpdate", true);
        },

        updateBuffer = function() {

            if (videoController) {
                videoController.updateBufferLevel(true);
            }

            if (audioController) {
                audioController.updateBufferLevel(true);
            }

            if (textController) {
                textController.updateBufferLevel(true);
            }
        },

        startBuffering = function(time) {
            this.debug.log("[Stream] startBuffering" + ((time === undefined) ? "" : (" at time " + time)));

            if (videoController) {
                if (time === undefined) {
                    videoController.start();
                } else {
                    videoController.seek(time);
                }
            }

            if (audioController) {
                if (time === undefined) {
                    audioController.start();
                } else {
                    audioController.seek(time);
                }
            }

            if (textController && subtitlesEnabled && tmSpeed === 1) {
                if (time === undefined) {
                    textController.start();
                } else {
                    textController.seek(time);
                }
            }
        },

        stopBuffering = function() {
/*            this.debug.log("[Stream] stopBuffering");

            if (videoController) {
                videoController.stop();
            }

            if (audioController) {
                audioController.stop();
            }

            if (textController) {
                textController.stop();
            }*/
        },

        seekedBuffers = function() {
            if (videoController) {
                videoController.seeked();
            }
            if (audioController) {
                audioController.seeked();
            }
            if (textController) {
                textController.seeked();
            }
        },

        suspend = function() {
            if (!this.scheduleWhilePaused || this.manifestExt.getIsDynamic(manifest)) {
                stopBuffering.call(this);
            }

            clearInterval(checkStartTimeIntervalId);
        },

        doLoad = function(manifestResult) {

            var self = this;

            //self.debug.log("Stream start loading.");

            manifest = manifestResult;
            self.debug.log("[Stream] Create MediaSource");

            try {
                mediaSource = self.mediaSourceExt.createMediaSource();
            } catch (error) {
                self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CREATE_MEDIASOURCE, "Failed to create MediaSource", {
                    name: error.name,
                    message: error.message
                });
            }

            if (mediaSource === null) {
                return;
            }

            self.debug.log("[Stream] Setup MediaSource");
            setUpMediaSource.call(self, mediaSource).then(
                function(mediaSourceResult) {
                    mediaSource = mediaSourceResult;
                    self.debug.log("[Stream] Initialize MediaSource");
                    initializeMediaSource.call(self);
                    self.debug.log("[Stream] Initialize playback");
                    initializePlayback.call(self);
                    self.debug.log("[Stream] Playback initialized");
                }
            );
        },

        setVideoModelCurrentTime = function(time) {
            this.debug.log("[Stream] Set video model current time: " + time);
            this.videoModel.unlisten("seeking", seekingListener);
            this.videoModel.setCurrentTime(time);
        },

        onBufferingCompleted = function() {

            // if there is at least one buffer controller that has not completed buffering yet do nothing
            if ((videoController && !videoController.isBufferingCompleted()) || (audioController && !audioController.isBufferingCompleted())) {
                return;
            }

            // buffering has been complted, now we can signal end of stream
            if (mediaSource) {
                this.debug.info("[Stream] Signal end of stream");
                this.mediaSourceExt.signalEndOfStream(mediaSource);
            }
        },

        // 'startTimeFound' event raised by video controller when start time has been found
        // startTime = video live edge for live streams
        // startTime = first video segment time for static streams
        // => then seek every BufferController at the found start time
        onStartTimeFound = function(startTime) {
            this.debug.info("[Stream] Start time = " + startTime);
            // Check if initial start time is set, then overload start time
            if (initialStartTime !== -1 &&
                !this.manifestExt.getIsDynamic(manifest) &&
                initialStartTime < periodInfo.duration) {
                this.debug.info("[Stream] Initial start time = " + initialStartTime);
                startTime = initialStartTime;
            }
            seek.call(this, startTime, (periodInfo.index === 0) && autoPlay);
        },

        // ORANGE: 'bufferUpdated' event raised when some data has been appended into media buffers
        // => if not started (live use case) then check for playback start time and do play
        onBufferUpdated = function() {
            var videoRange,
                audioRange,
                startTime;

            this.debug.info("[Stream] Check start time");

            // Check if video buffer is not empty
            videoRange = this.sourceBufferExt.getBufferRange(videoController.getBuffer(), seekTime, 2);
            if (videoRange === null) {
                return;
            }

            startTime = Math.max(seekTime, videoRange.start);

            if (audioController) {
                // Check if audio buffer is not empty
                audioRange = this.sourceBufferExt.getBufferRange(audioController.getBuffer(), seekTime, 2);
                if (audioRange === null) {
                    return;
                }
                this.debug.info("[Stream] Check start time: A[" + audioRange.start + "-" + audioRange.end + "], V[" + videoRange.start + "-" + videoRange.end + "]");
                // Check if audio and video can be synchronized (if some audio sample is available at returned start time)
                if (audioRange.end < startTime) {
                    return;
                }
                startTime = Math.max(startTime, audioRange.start);
            }

            this.debug.info("[Stream] Check start time: OK => " + startTime);

            // Unmap "bufferUpdated" handler
            this.system.unmapHandler("bufferUpdated");

            // Set current time on video if 'play' event has already been raised.
            // If 'play' event has not yet been raised, the the current time will be set afterwards
            if (!this.videoModel.isPaused()) {
                setVideoModelCurrentTime.call(this, startTime);
            } else {
                playStartTime = startTime;
            }

            play.call(this);
        },

        selectTrack = function(controller, track, currentIndex) {
            var index = -1;

            if (!controller) {
                return currentIndex;
            }

            if (currentIndex === -1) {
                return currentIndex;
            }

            // Get data index corresponding to the new selected track
            index = this.manifestExt.getDataIndex(track, manifest, periodInfo.index);

            // Check if different track selected
            if (index !== currentIndex) {
                if (this.manifestExt.getIsDynamic(manifest)) {
                    // If live, refresh the manifest to get new selected track segments info
                    this.system.notify("manifestUpdate");
                } else {
                    // Else update controller data directly
                    controller.updateData(track, periodInfo);
                }
            }

            return index;
        },

        updateData = function(updatedPeriodInfo) {
            var videoData,
                data;

            manifest = this.manifestModel.getValue();
            periodInfo = updatedPeriodInfo;
            this.debug.log("[Stream] Manifest updated ... set new data on buffers.");

            if (videoController) {
                videoData = videoController.getData();

                if (!!videoData && videoData.hasOwnProperty("id")) {
                    data = this.manifestExt.getDataForId(videoData.id, manifest, periodInfo.index);
                } else {
                    data = this.manifestExt.getDataForIndex(videoTrackIndex, manifest, periodInfo.index);
                }
                videoController.updateData(data, periodInfo);
            }

            if (audioController) {
                data = this.manifestExt.getDataForIndex(audioTrackIndex, manifest, periodInfo.index);
                audioController.updateData(data, periodInfo);
            }

            if (textController) {
                data = this.manifestExt.getDataForIndex(textTrackIndex, manifest, periodInfo.index);
                textController.updateData(data, periodInfo);
            }

            if (eventController) {
                var events = this.manifestExt.getEventsForPeriod(manifest, periodInfo);
                eventController.addInlineEvents(events);
            }

            if (isReloading && videoController) {
                this.system.unmapHandler("bufferUpdated");
                this.system.mapHandler("bufferUpdated", undefined, onBufferUpdated.bind(this));
                // Call load on video controller in order to get new stream start time (=live edge for live streams)
                videoController.load();
            }

            if (dvrStarted) {
                startFragmentInfoControllers.call(this);
            }
        },

        streamsComposed = function() {
            var time = this.videoModel.getCurrentTime();
            textController.seek(time);
            textController.seeked();
        },

        // Called when a BufferController failed to download or buffer a segment
        onSegmentLoadingFailed = function(segmentRequest) {
            var self = this;

            this.debug.log("[Stream] Segment loading failed: start time = " + segmentRequest.startTime + ", duration = " + segmentRequest.duration);

            if (this.manifestExt.getIsDynamic(manifest) && !isReloading) {
                // For Live streams, then we try to reload the session
                isReloading = true;
                var delay = segmentRequest.duration;
                this.debug.info("[Stream] Reload session in " + delay + " s.");
                reloadTimeout = setTimeout(function() {
                    reloadTimeout = null;
                    //pause.call(self);
                    self.system.notify("manifestUpdate", true);
                }, delay * 1000);
            } else {
                // For VOD streams, we seek at recovery time
                seek.call(this, (segmentRequest.startTime + segmentRequest.duration));
            }
        },

        onVisibilitychange = function() {

            if (document.hidden === true || startClockTime === -1) {
                return;
            }

            // If current document get focus back, then check if resynchronization is required
            var clockTime = new Date().getTime() / 1000,
                streamTime = this.getVideoModel().getCurrentTime(),
                elapsedClockTime = clockTime - startClockTime,
                elapsedStreamTime = streamTime - startStreamTime;

            this.debug.log("[Stream] VisibilityChange: elapsedClockTime = " + elapsedClockTime + ", elapsedStreamTime = " + elapsedStreamTime + " (" + (elapsedClockTime - elapsedStreamTime) + ")");

            if ((elapsedClockTime - elapsedStreamTime) > 1) {
                onReload.call(this);
            }

        };

    return {
        system: undefined,
        videoModel: undefined,
        manifestLoader: undefined,
        manifestModel: undefined,
        mediaSourceExt: undefined,
        sourceBufferExt: undefined,
        manifestExt: undefined,
        fragmentController: undefined,
        fragmentExt: undefined,
        protectionExt: undefined,
        capabilities: undefined,
        debug: undefined,
        metricsExt: undefined,
        errHandler: undefined,
        timelineConverter: undefined,
        scheduleWhilePaused: undefined,
        textTrackExtensions: undefined,
        // ORANGE : add metricsModel
        metricsModel: undefined,
        eventBus: undefined,
        notify: undefined,

        setup: function() {
            this.system.mapHandler("startTimeFound", undefined, onStartTimeFound.bind(this));
            this.system.mapHandler("segmentLoadingFailed", undefined, onSegmentLoadingFailed.bind(this));
            this.system.mapHandler("bufferingCompleted", undefined, onBufferingCompleted.bind(this));

            // Protection event handlers
            this[MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR] = onProtectionError.bind(this);

            playListener = onPlay.bind(this);
            pauseListener = onPause.bind(this);
            errorListener = onError.bind(this);
            seekingListener = onSeeking.bind(this);
            seekedListener = onSeeked.bind(this);
            progressListener = onProgress.bind(this);
            ratechangeListener = onRatechange.bind(this);
            timeupdateListener = onTimeupdate.bind(this);
            durationchangeListener = onDurationchange.bind(this);
            loadedListener = onLoaded.bind(this);
            canplayListener = onCanPlay.bind(this);
            playingListener = onPlaying.bind(this);
            loadstartListener = onLoadStart.bind(this);

            // ORANGE : add Ended Event listener
            endedListener = onEnded.bind(this);

            visibilitychangeListener = onVisibilitychange.bind(this);
        },

        load: function(manifest, periodInfoValue) {
            periodInfo = periodInfoValue;
            doLoad.call(this, manifest);
        },

        setVideoModel: function(value) {
            this.videoModel = value;
            this.videoModel.listen("play", playListener);
            this.videoModel.listen("pause", pauseListener);
            this.videoModel.listen("error", errorListener);
            this.videoModel.listen("seeking", seekingListener);
            this.videoModel.listen("seeked", seekedListener);
            this.videoModel.listen("timeupdate", timeupdateListener);
            this.videoModel.listen("durationchange", durationchangeListener);
            this.videoModel.listen("progress", progressListener);
            this.videoModel.listen("ratechange", ratechangeListener);
            this.videoModel.listen("loadedmetadata", loadedListener);
            this.videoModel.listen("ended", endedListener);
            this.videoModel.listen("canplay", canplayListener);
            this.videoModel.listen("playing", playingListener);
            this.videoModel.listen("loadstart", loadstartListener);

            //document.addEventListener("visibilitychange", visibilitychangeListener);
        },

        setInitialStartTime: function(startTime) {
            var time = parseFloat(startTime);
            if (!isNaN(time)) {
                initialStartTime = time;
            }
        },

        setAudioTrack: function(audioTrack) {
            if (fragmentInfoAudioController) {
                fragmentInfoAudioController.stop();
            }
            audioTrackIndex = selectTrack.call(this, audioController, audioTrack, audioTrackIndex);
        },

        getSelectedAudioTrack: function() {
            if (audioController) {
                return this.manifestExt.getDataForIndex(audioTrackIndex, manifest, periodInfo.index);
            }
            return undefined;
        },

        setSubtitleTrack: function(subtitleTrack) {
            if (fragmentInfoTextController) {
                fragmentInfoTextController.stop();
            }
            textTrackIndex = selectTrack.call(this, textController, subtitleTrack, textTrackIndex);
        },

        getSelectedSubtitleTrack: function() {
            if (textController && subtitlesEnabled) {
                return this.manifestExt.getDataForIndex(textTrackIndex, manifest, periodInfo.index);
            }
            return undefined;
        },

        initProtection: function(protectionCtrl) {
            protectionController = protectionCtrl;
            if (protectionController) {
                protectionController.subscribe(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR, this);
            }
        },

        getVideoModel: function() {
            return this.videoModel;
        },

        getManifestExt: function() {
            var self = this;
            return self.manifestExt;
        },

        setAutoPlay: function(value) {
            autoPlay = value;
        },

        setDefaultAudioLang: function(language) {
            defaultAudioLang = language;
        },

        setDefaultSubtitleLang: function(language) {
            defaultSubtitleLang = language;
        },

        getAutoPlay: function() {
            return autoPlay;
        },

        reset: function() {
            var deferred = Q.defer(),
                self = this;

            this.debug.info("[Stream] Reset");

            stopBuffering.call(this);

            stopFragmentInfoControllers.call(this);

            pause.call(this);

            // Trick mode seeking timeout
            clearTimeout(tmSeekTimeout);

            // Stop reload timeout
            clearTimeout(reloadTimeout);

            //if player is in trick mode, restore mute state.
            if (tmSpeed !== 1) {
                this.videoModel.setMute(muteState);
            }

            //document.removeEventListener("visibilityChange");

            this.videoModel.unlisten("play", playListener);
            this.videoModel.unlisten("pause", pauseListener);
            this.videoModel.unlisten("error", errorListener);
            this.videoModel.unlisten("seeking", seekingListener);
            this.videoModel.unlisten("seeked", seekedListener);
            this.videoModel.unlisten("timeupdate", timeupdateListener);
            this.videoModel.unlisten("durationchange", durationchangeListener);
            this.videoModel.unlisten("progress", progressListener);
            this.videoModel.unlisten("ratechange", ratechangeListener);
            this.videoModel.unlisten("loadedmetadata", loadedListener);
            this.videoModel.unlisten("ended", endedListener);
            this.videoModel.unlisten("canplay", canplayListener);
            this.videoModel.unlisten("playing", playingListener);
            this.videoModel.unlisten("loadstart", loadstartListener);

            this.system.unmapHandler("streamsComposed", undefined, streamsComposed);

            this.system.unmapHandler("bufferUpdated");
            this.system.unmapHandler("startTimeFound");
            this.system.unmapHandler("segmentLoadingFailed");
            this.system.unmapHandler("bufferingCompleted");

            tearDownMediaSource.call(this).then(
                function() {
                    if (protectionController) {
                        protectionController.unsubscribe(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR, self);
                    }

                    protectionController = undefined;
                    self.fragmentController = undefined;

                    deferred.resolve();
                });

            return deferred.promise;
        },

        getDuration: function() {
            return periodInfo.duration;
        },

        getStartTime: function() {
            return periodInfo.start;
        },

        getPeriodIndex: function() {
            return periodInfo.index;
        },

        getId: function() {
            return periodInfo.id;
        },

        getPeriodInfo: function() {
            return periodInfo;
        },

        startEventController: function() {
            eventController.start();
        },

        resetEventController: function() {
            eventController.reset();
        },

        enableSubtitles: function(enabled) {
            var track;

            if (enabled !== subtitlesEnabled) {
                subtitlesEnabled = enabled;
                track = this.textTrackExtensions.getCurrentTextTrack(this.videoModel.getElement());

                if (textController) {
                    if (enabled) {
                        if (this.manifestExt.getIsDynamic(manifest)) {
                            // In case of live streams, refresh manifest before activating subtitles
                            this.system.mapHandler("streamsComposed", undefined, streamsComposed.bind(this), true);
                            this.system.notify("manifestUpdate");
                        } else {
                            streamsComposed.call(this);
                        }
                        // show subtitle here => useful for full TTML file
                        if (track && track.mode !== 'showing') {
                            track.mode = "showing";
                        }
                    } else {
                        if (fragmentInfoTextController) {
                            fragmentInfoTextController.stop();
                        }
                        // hide subtitle here
                        if (track) {
                            track.mode = "hidden";
                        }
                        textController.stop();
                    }
                }
            }
        },

        setTrickModeSpeed: function(speed) {
            var funcs = [],
                self = this,
                enableTrickMode = (speed !== 1) ? true : false,
                currentVideoTime,
                seekValue,
                restoreMute = function() {
                    if (self.videoModel.getCurrentTime() > (currentVideoTime + 1)) {
                        self.videoModel.unlisten("timeupdate", restoreMute);
                        self.debug.info("[Stream] Set mute: " + muteState + ", the mute state before using trick mode.");
                        self.videoModel.setMute(muteState);
                    }
                };

            if (speed === tmSpeed) {
                return;
            }

            if (!videoController) {
                return;
            }

            self.debug.info("[Stream] Trick mode: speed = " + speed);

            if (enableTrickMode && tmState === "Stopped") {
                self.debug.info("[Stream] Set mute: true");
                muteState = self.videoModel.getMute();
                if (!muteState) {
                    self.videoModel.setMute(true);
                }
                self.videoModel.pause();
            } else if (!enableTrickMode) {
                tmSpeed = 1;
                clearTimeout(tmSeekTimeout);
                this.videoModel.pause();
                stopBuffering.call(self);
            }

            funcs.push(videoController.setTrickMode(enableTrickMode, speed > 1));
            if (audioController) {
                funcs.push(audioController.setTrickMode(enableTrickMode, speed > 1));
            }

            Q.all(funcs).then(function() {
                tmPreviousSpeed = tmSpeed;
                tmSpeed = speed;
                currentVideoTime = self.videoModel.getCurrentTime();

                if (!enableTrickMode) {
                    self.debug.info("[Stream] Trick mode: Stopped, current time = " + currentVideoTime);
                    tmState = "Stopped";
                    self.videoModel.listen("timeupdate", restoreMute);
                    currentVideoTime = tmEndDetected ? self.getStartTime() : currentVideoTime;
                    seek.call(self, currentVideoTime, true);
                } else {
                    if (tmState === "Running") {
                        tmState = "Changed";
                    } else if (tmState === "Stopped") {
                        tmEndDetected = false;
                        tmState = "Running";
                        tmSeekStep = tmMinSeekStep = videoController.getSegmentDuration();
                        tmStartTime = tmSeekTime = (new Date().getTime()) / 1000;
                        tmVideoStartTime = currentVideoTime;
                        self.debug.info("[Stream] Trick mode (x" + tmSpeed + "): videoTime = " + tmVideoStartTime);
                        seekValue = currentVideoTime + (tmSeekStep * Math.sign(tmSpeed));
                        seekValue = Math.round((seekValue - (seekValue % tmMinSeekStep)) * 1000) / 1000;
                        self.debug.info("[Stream] Trick mode (x" + tmSpeed + "): seek step = " + tmSeekStep);
                        tmSeekValue = seekValue;
                        seek.call(self, seekValue);
                    }
                }
            });
        },

        getTrickModeSpeed: function() {
            return tmSpeed;
        },

        updateData: updateData,
        play: play,
        seek: seek,
        pause: pause
    };
};

MediaPlayer.dependencies.Stream.prototype = {
    constructor: MediaPlayer.dependencies.Stream
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.StreamController = function() {
    "use strict";

    /*
     * StreamController aggregates all streams defined as Period sections in the manifest file
     * and implements corresponding logic to switch between them.
     */

    var source,
        running = false,
        streams = [],
        activeStream,
        protectionController,
        ownProtectionController = false,
        //TODO set correct value for threshold
        STREAM_BUFFER_END_THRESHOLD = 6,
        STREAM_END_THRESHOLD = 0.2,
        autoPlay = true,
        isPeriodSwitchingInProgress = false,
        timeupdateListener,
        seekingListener,
        progressListener,
        pauseListener,
        playListener,
        // ORANGE: audio language management
        audioTracks,
        subtitleTracks,
        protectionData,
        defaultAudioLang = 'und',
        defaultSubtitleLang = 'und',
        subtitlesEnabled = false,
        reloadStream = false,
        deferredLoading = null,

        /*
         * Replaces the currently displayed <video> with a new data and corresponding <video> element.
         *
         * @param fromVideoModel Currently used video data
         * @param toVideoModel New video data to be displayed
         *
         * TODO - move method to appropriate place - VideoModelExtensions??
         */
        switchVideoModel = function(fromVideoModel, toVideoModel) {
            var activeVideoElement = fromVideoModel.getElement(),
                newVideoElement = toVideoModel.getElement();

            if (!newVideoElement.parentNode) {
                activeVideoElement.parentNode.insertBefore(newVideoElement, activeVideoElement);
            }

            // We use width property to hide/show video element because when using display="none"/"block" playback
            // sometimes stops after switching.
            activeVideoElement.style.width = "0px";
            newVideoElement.style.width = "100%";

            copyVideoProperties(activeVideoElement, newVideoElement);
            detachVideoEvents.call(this, fromVideoModel);
            attachVideoEvents.call(this, toVideoModel);

            return true;
        },

        attachVideoEvents = function(videoModel) {
            videoModel.listen("seeking", seekingListener);
            videoModel.listen("progress", progressListener);
            videoModel.listen("timeupdate", timeupdateListener);
            videoModel.listen("pause", pauseListener);
            videoModel.listen("play", playListener);
        },

        detachVideoEvents = function(videoModel) {
            videoModel.unlisten("seeking", seekingListener);
            videoModel.unlisten("progress", progressListener);
            videoModel.unlisten("timeupdate", timeupdateListener);
            videoModel.unlisten("pause", pauseListener);
            videoModel.unlisten("play", playListener);
        },

        copyVideoProperties = function(fromVideoElement, toVideoElement) {
            ["controls", "loop", "muted", "playbackRate", "volume"].forEach(function(prop) {
                toVideoElement[prop] = fromVideoElement[prop];
            });
        },

        /*
         * Called when more data is buffered.
         * Used to determine the time current stream is almost buffered and we can start buffering of the next stream.
         * TODO move to ???Extensions class
         */
        onProgress = function() {

            var ranges = activeStream.getVideoModel().getElement().buffered;

            // nothing is buffered
            if (!ranges.length) {
                return;
            }

            var lastRange = ranges.length - 1,
                bufferEndTime = ranges.end(lastRange),
                remainingBufferDuration = activeStream.getStartTime() + activeStream.getDuration() - bufferEndTime;

            if (remainingBufferDuration < STREAM_BUFFER_END_THRESHOLD) {
                activeStream.getVideoModel().unlisten("progress", progressListener);
                onStreamBufferingEnd();
            }
        },

        switchStream = function(from, to, seekTo) {

            if (isPeriodSwitchingInProgress || !from || !to || from === to) {
                return;
            }

            isPeriodSwitchingInProgress = true;

            from.pause();
            activeStream = to;

            switchVideoModel.call(this, from.getVideoModel(), to.getVideoModel());

            if (seekTo) {
                this.seek(from.getVideoModel().getCurrentTime());
            } else {
                this.seek(to.getStartTime());
            }

            this.play();
            from.resetEventController();
            activeStream.startEventController();
            isPeriodSwitchingInProgress = false;
        },


        /*
         * Called when current playback positon is changed.
         * Used to determine the time current stream is finished and we should switch to the next stream.
         * TODO move to ???Extensions class
         */
        onTimeupdate = function() {
            var self = this,
                time = new Date(),
                streamEndTime = activeStream.getStartTime() + activeStream.getDuration(),
                videoElement = activeStream.getVideoModel().getElement(),
                currentTime = videoElement.currentTime,
                playBackQuality = self.videoExt.getPlaybackQuality(videoElement);

            self.metricsModel.addPlaybackQuality("video", time, playBackQuality, currentTime);
            self.metricsModel.addVideoResolution("video", time, videoElement.videoWidth, videoElement.videoHeight, currentTime);

            if (!getNextStream()) {
                return;
            }

            // Sometimes after seeking timeUpdateHandler is called before seekingHandler and a new period starts
            // from beginning instead of from a chosen position. So we do nothing if the player is in the seeking state
            if (activeStream.getVideoModel().getElement().seeking) {
                return;
            }

            // check if stream end is reached
            if (streamEndTime - currentTime < STREAM_END_THRESHOLD) {
                switchStream.call(this, activeStream, getNextStream());
            }
        },

        /*
         * Called when Seeking event is occured.
         * TODO move to ???Extensions class
         */
        onSeeking = function() {
            var seekingTime = activeStream.getVideoModel().getCurrentTime(),
                seekingStream = getStreamForTime(seekingTime);

            // ORANGE : add metric
            this.metricsModel.addState("video", "seeking", activeStream.getVideoModel().getCurrentTime());

            if (seekingStream && seekingStream !== activeStream) {
                switchStream.call(this, activeStream, seekingStream, seekingTime);
            }
        },

        onPause = function() {
            this.manifestUpdater.stop();
            // ORANGE : add metric
            this.metricsModel.addState("video", "paused", activeStream.getVideoModel().getCurrentTime());
        },

        onPlay = function() {
            this.manifestUpdater.start();
        },

        /*
         * Handles the current stream buffering end moment to start the next stream buffering
         */
        onStreamBufferingEnd = function() {
            var nextStream = getNextStream();
            if (nextStream) {
                nextStream.seek(nextStream.getStartTime());
            }
        },

        getNextStream = function() {
            var nextIndex = activeStream.getPeriodIndex() + 1;
            return (nextIndex < streams.length) ? streams[nextIndex] : null;
        },

        getStreamForTime = function(time) {
            var duration = 0,
                stream = null,
                ln = streams.length,
                i = 0;

            if (ln > 0) {
                duration += streams[0].getStartTime();
            }

            for (i = 0; i < ln; i += 1) {
                stream = streams[i];
                duration += stream.getDuration();

                if (time < duration) {
                    return stream;
                }
            }
        },

        //  TODO move to ???Extensions class
        createVideoModel = function() {
            var model = this.system.getObject("videoModel"),
                video = document.createElement("video");
            model.setElement(video);
            return model;
        },

        removeVideoElement = function(element) {
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
        },

        composeStreams = function() {
            var self = this,
                manifest = self.manifestModel.getValue(),
                metrics = self.metricsModel.getMetricsFor("stream"),
                manifestUpdateInfo = self.metricsExt.getCurrentManifestUpdate(metrics),
                periodInfo,
                periods,
                pLen,
                sLen,
                pIdx,
                sIdx,
                period,
                mpd,
                stream;

            if (!manifest) {
                return false;
            }

            this.debug.info("[StreamController] composeStreams");

            if (self.capabilities.supportsEncryptedMedia()) {
                if (!protectionController) {
                    protectionController = self.system.getObject("protectionController");
                    /*self.eventBus.dispatchEvent({
                        type: MediaPlayer.events.PROTECTION_CREATED,
                        data: {
                            controller: protectionController,
                            manifest: manifest
                        }
                    });*/
                    ownProtectionController = true;
                }
                protectionController.setMediaElement(self.videoModel.getElement());
                if (protectionData) {
                    protectionController.setProtectionData(protectionData);
                }
            }

            mpd = self.manifestExt.getMpd(manifest);
            if (activeStream) {
                periodInfo = activeStream.getPeriodInfo();
                mpd.isClientServerTimeSyncCompleted = periodInfo.mpd.isClientServerTimeSyncCompleted;
                mpd.clientServerTimeShift = periodInfo.mpd.clientServerTimeShift;
            }

            periods = self.manifestExt.getRegularPeriods(manifest, mpd);
            if (periods.length === 0) {
                return false;
            }

            for (pIdx = 0, pLen = periods.length; pIdx < pLen; pIdx += 1) {
                period = periods[pIdx];
                for (sIdx = 0, sLen = streams.length; sIdx < sLen; sIdx += 1) {
                    // If the stream already exists we just need to update the values we got from the updated manifest
                    if (streams[sIdx].getId() === period.id) {
                        stream = streams[sIdx];
                        this.debug.info("[StreamController] update stream data");
                        stream.updateData(period);
                    }
                }
                // If the Stream object does not exist we probably loaded the manifest the first time or it was
                // introduced in the updated manifest, so we need to create a new Stream and perform all the initialization operations
                if (!stream) {
                    this.debug.info("[StreamController] Create stream");
                    stream = self.system.getObject("stream");
                    stream.setVideoModel(pIdx === 0 ? self.videoModel : createVideoModel.call(self));
                    stream.initProtection(protectionController);
                    stream.setAutoPlay(autoPlay);
                    stream.setDefaultAudioLang(defaultAudioLang);
                    stream.setDefaultSubtitleLang(defaultSubtitleLang);
                    stream.enableSubtitles(subtitlesEnabled);
                    stream.setInitialStartTime(source.startTime);
                    stream.load(manifest, period);
                    streams.push(stream);
                }

                self.metricsModel.addManifestUpdatePeriodInfo(manifestUpdateInfo, period.id, period.index, period.start, period.duration);
                stream = null;
            }

            // If the active stream has not been set up yet, let it be the first Stream in the list
            if (!activeStream) {
                activeStream = streams[0];
                attachVideoEvents.call(self, activeStream.getVideoModel());
            }

            self.metricsModel.updateManifestUpdateInfo(manifestUpdateInfo, {
                currentTime: self.videoModel.getCurrentTime(),
                buffered: self.videoModel.getElement().buffered,
                presentationStartTime: periods[0].start,
                clientTimeOffset: mpd.clientServerTimeShift
            });

            if (deferredLoading) {
                deferredLoading.resolve();
                deferredLoading = null;
            }

            return true;
        },

        // ORANGE: create function to handle audiotracks
        updateAudioTracks = function() {
            if (activeStream) {
                audioTracks = this.manifestExt.getAudioDatas(this.manifestModel.getValue(), activeStream.getPeriodIndex());
                // fire event to notify that audiotracks have changed
                this.system.notify("audioTracksUpdated");
            }
        },

        updateSubtitleTracks = function() {
            if (activeStream) {
                subtitleTracks = this.manifestExt.getTextDatas(this.manifestModel.getValue(), activeStream.getPeriodIndex());
                // fire event to notify that subtitletracks have changed
                this.system.notify("subtitleTracksUpdated");
            }
        },

        manifestUpdate = function(reload) {
            if (reload === true) {
                reloadStream = true;
            }
            this.refreshManifest();
        },

        manifestHasUpdated = function() {

            // Check if stopping
            if (!running) {
                if (deferredLoading) {
                    deferredLoading.resolve();
                    deferredLoading = null;
                }
                return;
            }

            this.debug.info("[StreamController] Manifest updated");

            var result = composeStreams.call(this);

            if (result) {
                // ORANGE: Update Audio Tracks List
                updateAudioTracks.call(this);
                // ORANGE: Update Subtitle Tracks List
                updateSubtitleTracks.call(this);
                this.system.notify("streamsComposed");
            } else {
                this.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_NO_STREAM, "No stream/period is provided in the manifest");
            }

            if (deferredLoading) {
                deferredLoading.resolve();
                deferredLoading = null;
            }
        };

    return {
        system: undefined,
        videoModel: undefined,
        parser: undefined,
        manifestLoader: undefined,
        manifestUpdater: undefined,
        manifestModel: undefined,
        manifestExt: undefined,
        fragmentExt: undefined,
        capabilities: undefined,
        debug: undefined,
        metricsModel: undefined,
        metricsExt: undefined,
        videoExt: undefined,
        errHandler: undefined,
        eventBus: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,

        setup: function() {
            this.system.mapHandler("manifestUpdate", undefined, manifestUpdate.bind(this));
            this.system.mapHandler("manifestUpdated", undefined, manifestHasUpdated.bind(this));
            timeupdateListener = onTimeupdate.bind(this);
            progressListener = onProgress.bind(this);
            seekingListener = onSeeking.bind(this);
            pauseListener = onPause.bind(this);
            playListener = onPlay.bind(this);
        },

        getManifestExt: function() {
            return activeStream.getManifestExt();
        },

        setAutoPlay: function(value) {
            autoPlay = value;
        },

        getAutoPlay: function() {
            return autoPlay;
        },

        getVideoModel: function() {
            return this.videoModel;
        },

        setVideoModel: function(value) {
            this.videoModel = value;
        },

        getAudioTracks: function() {
            return audioTracks;
        },

        getSelectedAudioTrack: function() {

            if (activeStream) {
                return activeStream.getSelectedAudioTrack();
            }

            return undefined;
        },

        setAudioTrack: function(audioTrack) {
            if (activeStream) {
                activeStream.setAudioTrack(audioTrack);
            }
        },

        getSubtitleTracks: function() {
            return subtitleTracks;
        },

        setSubtitleTrack: function(subtitleTrack) {
            if (activeStream) {
                activeStream.setSubtitleTrack(subtitleTrack);
            }
        },

        getSelectedSubtitleTrack: function() {

            if (activeStream) {
                return activeStream.getSelectedSubtitleTrack();
            }

            return undefined;
        },

        getMinBufferTime: function () {
            if (!this.manifestModel || !this.manifestModel.getValue()) {
                return -1;
            }
            return this.manifestModel.getValue().minBufferTime;
        },

        load: function(newSource) {
            var self = this;

            running = true;

            source = newSource;

            if (source.protData) {
                protectionData = source.protData;
            }

            reloadStream = false;

            deferredLoading = Q.defer();
            self.debug.info("[StreamController] load url: " + source.url);
            self.manifestLoader.load(source.url).then(
                function(manifest) {
                    self.manifestModel.setValue(manifest);
                    //ORANGE : add Metadata metric
                    self.metricsModel.addMetaData();
                    self.debug.info("[StreamController] Manifest has loaded.");
                    //self.debug.log(self.manifestModel.getValue());
                    self.manifestUpdater.start();
                },
                function(err) {
                    deferredLoading.resolve();
                    deferredLoading = null;
                    // err is undefined in the case the request has been aborted
                    if (err) {
                        self.errHandler.sendError(err.name, err.message, err.data);
                    }
                }
            );
        },

        refreshManifest: function(url) {
            var manifest = this.manifestModel.getValue(),
                manifestUrl = url ? url : (manifest.hasOwnProperty("Location") ? manifest.Location : manifest.mpdUrl);

            this.debug.log("### Refresh manifest @ " + manifestUrl);

            var self = this;
            this.manifestLoader.abort();
            this.manifestLoader.load(manifestUrl, true).then(
                function(manifestResult) {
                    self.manifestModel.setValue(manifestResult);
                    self.debug.log("### Manifest has been refreshed.");
                    reloadStream = false;
                },
                function(err) {
                    // err is undefined in the case the request has been aborted
                    if (err === undefined) {
                        return;
                    }

                    // Url is refreshed
                    if (url) {
                        // Raise an error only in case we try to reload the session
                        // to recover some segment downloading error
                        if (reloadStream) {
                            self.errHandler.sendError(err.name, err.message, err.data);
                        }
                    } else {
                        // If internal manifest updating (for ex. track switching),
                        // then raise a warning and ask for refreshing the url (in case it is no more valid or expired)
                        self.errHandler.sendWarning(err.name, err.message, err.data);
                        self.eventBus.dispatchEvent({
                            type: "manifestUrlUpdate",
                            data: {
                                url: manifestUrl
                            }
                        });
                    }
                }
            );
        },

        reset: function(reason) {
            var teardownComplete = {},
                funcs = [],
                self = this;

            this.debug.info("[StreamController] Reset");

            if (!!activeStream) {
                detachVideoEvents.call(this, activeStream.getVideoModel());
            }

            running = false;

            self.manifestLoader.abort();
            self.manifestUpdater.stop();
            self.parser.reset();

            // Wait for current loading process (manifest download and updating) to be achieved
            Q.when(deferredLoading ? deferredLoading.promise : true).then(function () {

                // Pause the active stream, but reset only once protection controller and media key sessions have been resetted
                self.pause();

                self.metricsModel.clearAllCurrentMetrics();
                isPeriodSwitchingInProgress = false;

                teardownComplete[MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE] = function() {
                    var i = 0,
                        ln,
                        stream;

                    // Complete teardown process
                    ownProtectionController = false;
                    protectionController = null;
                    protectionData = null;

                    // Reset the streams
                    for (i = 0, ln = streams.length; i < ln; i += 1) {
                        stream = streams[i];
                        funcs.push(stream.reset());
                        if (stream !== activeStream) {
                            removeVideoElement(stream.getVideoModel().getElement());
                        }
                    }

                    // Reset the video model (and controllers stalled states)
                    self.videoModel.reset();

                    Q.all(funcs).then(
                        function() {
                            streams = [];
                            activeStream = null;
                            self.metricsModel.addState('video', 'stopped', self.videoModel.getCurrentTime(), reason);
                            self.notify(MediaPlayer.dependencies.StreamController.eventList.ENAME_TEARDOWN_COMPLETE);
                        });

                    self.manifestModel.setValue(null);
                };

                // Teardown the protection system, if necessary
                if (!protectionController) {
                    teardownComplete[MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE]();
                } else if (ownProtectionController) {
                    protectionController.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE, teardownComplete, undefined, true);
                    protectionController.teardown();
                } else {
                    protectionController.setMediaElement(null);
                    teardownComplete[MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE]();
                }
            });
        },

        setDefaultAudioLang: function(language) {
            defaultAudioLang = language;
        },

        setDefaultSubtitleLang: function(language) {
            defaultSubtitleLang = language;
        },

        enableSubtitles: function(enabled) {
            subtitlesEnabled = enabled;
            if (activeStream) {
                activeStream.enableSubtitles(enabled);
            }
        },

        setTrickModeSpeed: function(speed) {
            if (activeStream) {
                activeStream.setTrickModeSpeed(speed);
            }
        },

        getTrickModeSpeed: function() {
            if (activeStream) {
                return activeStream.getTrickModeSpeed();
            }
            return 0;
        },

        play: function() {
            activeStream.play();
        },

        pause: function() {
            if (activeStream) {
                activeStream.pause();
            }
        },

        seek: function(time, autoplay) {
            if (activeStream) {
                activeStream.seek(time, autoplay);
            }
        },
    };
};

MediaPlayer.dependencies.StreamController.prototype = {
    constructor: MediaPlayer.dependencies.StreamController
};

MediaPlayer.dependencies.StreamController.eventList = {
    ENAME_STREAMS_COMPOSED: "streamsComposed",
    ENAME_TEARDOWN_COMPLETE: "streamTeardownComplete"
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.TokenAuthentication = function () {
    "use strict";
    var tokenAuthentication = {type:MediaPlayer.utils.TokenAuthentication.TYPE_QUERY};
    return {
        debug:undefined,
        getTokenAuthentication:function () {

            return tokenAuthentication;

        },
        setTokenAuthentication:function (object) {

            tokenAuthentication = object;

        },
        checkRequestHeaderForToken:function(request) {

            if (tokenAuthentication.name !== undefined &&
                request.getResponseHeader(tokenAuthentication.name) !== null) {

                tokenAuthentication.token = request.getResponseHeader(tokenAuthentication.name);
                this.debug.log(tokenAuthentication.name+" received: " + tokenAuthentication.token);

           }
        },
        addTokenAsQueryArg:function(url) {

            if(tokenAuthentication.name !== undefined && tokenAuthentication.token !== undefined) {
                if (tokenAuthentication.type === MediaPlayer.utils.TokenAuthentication.TYPE_QUERY) {

                    var modifier = url.indexOf('?') === -1 ? '?' : '&';
                    url += modifier + tokenAuthentication.name +"=" + tokenAuthentication.token;
                    this.debug.log(tokenAuthentication.name+" is being appended on the request url with a value of : " + tokenAuthentication.token);

                }
            }

            return url;
        },
        setTokenInRequestHeader:function(request) {

            if (tokenAuthentication.type === MediaPlayer.utils.TokenAuthentication.TYPE_HEADER) {

                request.setRequestHeader(tokenAuthentication.name, tokenAuthentication.token);
                this.debug.log(tokenAuthentication.name+" is being set in the request header with a value of : " + tokenAuthentication.token);

            }

            return request;
        }
    };
};

MediaPlayer.utils.TokenAuthentication.TYPE_QUERY = "query";
MediaPlayer.utils.TokenAuthentication.TYPE_HEADER = "header";
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.models.URIQueryAndFragmentModel = function () {
    "use strict";

    var URIFragmentDataVO = new MediaPlayer.vo.URIFragmentData(),
        URIQueryData = [],

        reset = function () {
            URIFragmentDataVO = new MediaPlayer.vo.URIFragmentData();
            URIQueryData = [];
        },

        parseURI = function (uri) {

            var URIFragmentData = [],
                testQuery = new RegExp(/[?]/),
                testFragment = new RegExp(/[#]/),
                isQuery = testQuery.test(uri),
                isFragment = testFragment.test(uri),
                mappedArr;

            function reduceArray(previousValue, currentValue, index, array) {
                var arr =  array[0].split(/[=]/);
                array.push({key:arr[0], value:arr[1]});
                array.shift();
                return array;
            }

            function mapArray(currentValue, index, array) {
                if (index > 0)
                {
                    if (isQuery && URIQueryData.length === 0) {
                        URIQueryData = array[index].split(/[&]/);
                    } else if (isFragment) {
                        URIFragmentData = array[index].split(/[&]/);
                    }
                }

                return array;
            }

            mappedArr = uri.split(/[?#]/).map(mapArray);

            if (URIQueryData.length > 0) {
                URIQueryData = URIQueryData.reduce(reduceArray, null);
            }

            if (URIFragmentData.length > 0) {
                URIFragmentData = URIFragmentData.reduce(reduceArray, null);
                URIFragmentData.forEach(function (object) {
                    URIFragmentDataVO[object.key] = object.value;
                });
            }

            return uri;
        };

    return {
        parseURI:parseURI,
        reset:reset,
        //ORANGE: fix bug on not updating URIFragmentDataVO
        getURIFragmentData: function() {
            return URIFragmentDataVO;
        },
        getURIQueryData:URIQueryData
    };
};

MediaPlayer.models.URIQueryAndFragmentModel.prototype = {
    constructor: MediaPlayer.models.URIQueryAndFragmentModel
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.models.VideoModel = function () {
    "use strict";

    var element,
        stalledStreams = {},

        isStalled = function () {
            for (var type in stalledStreams){
                if(stalledStreams[type]===true) {
                    return true;
                }
            }
            return false;
        },

        stallStream = function (type, stalled) {
            stalledStreams[type] = stalled;

            if (!isStalled()) {
                this.debug.info("<video> setPlaybackRate(1)");
                element.playbackRate = 1;
            } else {
                this.debug.info("<video> setPlaybackRate(0)");
                element.playbackRate = 0;
            }
        };

    return {
        system : undefined,
        debug : undefined,

        setup : function () {
        },

        reset : function () {
            stalledStreams = [];
        },

        play: function () {
            this.debug.info("<video> play()");
            element.play();
        },

        pause: function () {
            this.debug.info("<video> pause()");
            element.pause();
        },

        isPaused: function () {
            return element.paused;
        },

        isSeeking: function() {
            return element.seeking;
        },

        getDuration:  function () {
            return element.duration;
        },

        getPlaybackRate:  function () {
            return element.playbackRate;
        },

        setPlaybackRate: function (value) {
            this.debug.info("<video> setPlaybackRate(" + value + ")");
            element.playbackRate = value;
        },

        getMute:  function () {
            return element.muted;
        },

        setMute: function (value) {
            element.muted = value;
        },

        getVolume: function () {
            return element.volume;
        },

        setVolume: function (value) {
            element.volume = value;
        },

        getCurrentTime: function () {
            return element.currentTime;
        },

        setCurrentTime: function (currentTime) {
            this.debug.info("<video> setCurrentTime (" + currentTime + ")");
            element.currentTime = currentTime;
        },

        listen: function (type, callback) {
            element.addEventListener(type, callback, false);
        },

        unlisten: function (type, callback) {
            element.removeEventListener(type, callback, false);
        },

        // ORANGE : register listener on video element parent
        listenOnParent: function (type, callback) {
            element.parentElement.addEventListener(type, callback, false);
        },

        unlistenOnParent: function (type, callback) {
            element.parentElement.removeEventListener(type, callback, false);
        },

        getElement: function () {
            return element;
        },

        setElement: function (value) {
            element = value;
        },

        setSource: function (source) {
            element.src = source;
        },

        isStalled: function () {
            return element.playbackRate === 0;
        },

        stallStream: stallStream
    };
};

MediaPlayer.models.VideoModel.prototype = {
    constructor: MediaPlayer.models.VideoModel
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.VideoModelExtensions = function () {
    "use strict";

    return {
        getPlaybackQuality: function (videoElement) {
            var hasWebKit = ("webkitDroppedFrameCount" in videoElement),
                hasQuality = ("getVideoPlaybackQuality" in videoElement),
                result = null;

            if (hasQuality) {
                result = videoElement.getVideoPlaybackQuality();
            }
            // ORANGE : add totalVideoFrames
            else if (hasWebKit) {
                result = {droppedVideoFrames: videoElement.webkitDroppedFrameCount, creationTime: new Date(), totalVideoFrames: videoElement.webkitDecodedFrameCount};
            }

            return result;
        }
    };
};

MediaPlayer.dependencies.VideoModelExtensions.prototype = {
    constructor: MediaPlayer.dependencies.VideoModelExtensions
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.TTMLParser = function() {
    "use strict";

    /*
     * This TTML parser follows "TTML Simple Delivery Profile for Closed Captions (US)" spec - http://www.w3.org/TR/ttml10-sdp-us/
     *
     * ORANGE: Some strict limitations of US profile removed to allow for non-US TTML2 implmentations used in Europe:
     *         - no requirement for US profile
     *         - offset-style format allowed for <timeExpression>
     * */

    var SECONDS_IN_HOUR = 60 * 60,
        SECONDS_IN_MIN = 60,
        TTAF_URI = "http://www.w3.org/2006/10/ttaf1",
        TTAF_PARAMETER_URI = "http://www.w3.org/2006/10/ttaf1#parameter",
        TTAF_STYLE_URI = "http://www.w3.org/2006/10/ttaf1#styling",
        TTML_URI = "http://www.w3.org/ns/ttml",
        TTML_PARAMETER_URI = "http://www.w3.org/ns/ttml#parameter",
        TTML_STYLE_URI = "http://www.w3.org/ns/ttml#styling",
        globalPrefTTNameSpace = "",
        globalPrefStyleNameSpace = "",
        globalPrefParameterNameSpace = "",
        //regionPrefTTNameSpace = "",
        //regionPrefStyleNameSpace = "",
        // R0028 - A document must not contain a <timeExpression> value that does not conform to the subset of clock-time that
        // matches either of the following patterns: hh:mm:ss.mss or hh:mm:ss:ff, where hh denotes hours (00-23),
        // mm denotes minutes (00-59), ss denotes seconds (00-59), mss denotes milliseconds (000-999), and ff denotes frames (00-frameRate - 1).
        // R0030 - For time expressions that use the hh:mm:ss.mss format, the following constraints apply:
        // - Exactly 2 digits must be used in each of the hours, minutes, and second components (include leading zeros).
        // - Exactly 3 decimal places must be used for the milliseconds component (include leading zeros).
        // R0031 -For time expressions that use the hh:mm:ss:ff format, the following constraints apply:
        // - Exactly 2 digits must be used in each of the hours, minutes, second, and frame components (include leading zeros).

        // Orange: the restrictions above are for US profile only.
        //         in general, TTML allows other syntax representations, see https://dvcs.w3.org/hg/ttml/raw-file/tip/ttml2/spec/ttml2.html#timing-value-timeExpression
        //         we have added support for offset-time, a pretty popular one.

        timingRegexClockTime = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])((\.[0-9][0-9][0-9])|(:[0-9][0-9]))$/,
        timingRegexOffsetTime = /^\d+(\.\d+|)(h|m|s|ms|f)$/,
        xmlDoc = null,
        nodeTt = null,
        nodeHead = null,
        nodeLayout = null,
        nodeStyling = null,
        nodeBody = null,
        frameRate = null,
        tabStyles = [],
        tabRegions = [],

        parseTimings = function(timingStr) {

            var timeParts,
                parsedTime,
                metric;

            if (timingRegexClockTime.test(timingStr)) {

                timeParts = timingStr.split(":");

                parsedTime = (parseFloat(timeParts[0]) * SECONDS_IN_HOUR +
                    parseFloat(timeParts[1]) * SECONDS_IN_MIN +
                    parseFloat(timeParts[2]));

                // R0031 -For time expressions that use the hh:mm:ss:ff format, the following constraints apply:
                //  - A ttp:frameRate attribute must be present on the tt element.
                //  - A ttp:frameRateMultiplier attribute may be present on the tt element.

                // ORANGE: removed the restrictions above.
                //         now if no frameRate is defined in tt, the :ff information is ignored.

                if (timeParts[3]) {
                    if (frameRate && !isNaN(frameRate)) {
                        parsedTime += parseFloat(timeParts[3]) / frameRate;
                    }
                }
                return parsedTime;
            }

            if (timingRegexOffsetTime.test(timingStr)) {

                if (timingStr.substr(timingStr.length - 2) == 'ms') {
                    parsedTime = parseFloat(timingStr.substr(0, timingStr.length - 3));
                    metric = timingStr.substr(timingStr.length - 2);
                } else {
                    parsedTime = parseFloat(timingStr.substr(0, timingStr.length - 2));
                    metric = timingStr.substr(timingStr.length - 1);
                }

                switch (metric) {
                    case 'h':
                        parsedTime = parsedTime * 60 * 60;
                        break;
                    case 'm':
                        parsedTime = parsedTime * 60;
                        break;
                    case 's':
                        break;
                    case 'ms':
                        parsedTime = parsedTime * 0.01;
                        break;
                    case 'f':
                        if (frameRate && !isNaN(frameRate)) {
                            parsedTime = parsedTime / frameRate;
                        } else {
                            return NaN;
                        }
                        break;
                }

                return parsedTime;
            }

            return NaN;
        },

        passStructuralConstraints = function() {
            var passed = false;

            nodeTt = xmlDoc ? this.domParser.getChildNode(xmlDoc, "tt") : null;
            nodeHead = nodeTt ? this.domParser.getChildNode(nodeTt, "head") : null;
            nodeLayout = nodeHead ? this.domParser.getChildNode(nodeHead, "layout") : null;
            nodeStyling = nodeHead ? this.domParser.getChildNode(nodeHead, "styling") : null;
            nodeBody = nodeTt ? this.domParser.getChildNode(nodeTt, "body") : null;

            // R001 - A document must contain a tt element.
            // R002 - A document must contain both a head and body element.
            // R003 - A document must contain both a styling and a layout element.
            if (nodeTt && nodeHead && /*nodeLayout && nodeStyling &&*/ nodeBody) {
                passed = true;
            }

            // R0008 - A document must contain a ttp:profile element where the use attribute of that element is specified as http://www.w3.org/ns/ttml/profile/sdp-us.
            // ORANGE: The R0008 requirement is removed in the parser implementation to make it work with non-US profiles
            return passed;
        },

        findStyleElement = function(nodeTab, styleElementName) {
            var styleName,
                regionName,
                resu = null,
                i = 0;


            for (i = 0; i < nodeTab.length; i += 1) {
                //search styleElementName in node Element
                resu = findParameterElement.call(this, [nodeTab[i]], globalPrefStyleNameSpace, styleElementName);

                if (resu) {
                    return resu;
                }

                //search style reference in node Element
                styleName = findParameterElement.call(this, [nodeTab[i]], globalPrefTTNameSpace, 'style');
                if (styleName) {
                    //search if styleElementName is defined in the specific style reference
                    resu = searchInTab(tabStyles, styleName, styleElementName);
                    if (resu) {
                        return resu;
                    }
                }

                //search region reference in node Element
                regionName = findParameterElement.call(this, [nodeTab[i]], globalPrefTTNameSpace, 'region');
                if (regionName) {
                    //region reference has been found in the node element, search styleElementName definition in this specified region
                    resu = searchInTab(tabRegions, regionName, styleElementName);

                    if (resu) {
                        return resu;
                    }

                    styleName = searchInTab(tabRegions, regionName, 'style');
                    //search style reference in this specified region Element

                    if (styleName) {
                        //specified style has been detected
                        //browse attributes of this style to detect styleElementName attribute
                        resu = searchInTab(tabStyles, styleName, styleElementName);
                        if (resu) {
                            return resu;
                        }

                        //search if others styles are referenced in the selected one
                        styleName = searchInTab(tabStyles, styleName, 'style');

                        while (styleName) {
                            //search in this other style
                            resu = searchInTab(tabStyles, styleName, styleElementName);
                            if (resu) {
                                return resu;
                            }
                            styleName = searchInTab(tabStyles, styleName, 'style');
                        }
                    }
                }
            }

            return null;
        },

        searchInTab = function(tab, elementNameReference, styleElementName) {
            var i = 0,
                j = 0;

            for (i = 0; i < tab[elementNameReference].length; i += 1) {
                //search with style nameSpaces
                for (j = 0; j < globalPrefStyleNameSpace.length; j += 1) {
                    if (tab[elementNameReference][i].name === globalPrefStyleNameSpace[j] + styleElementName) {
                        return tab[elementNameReference][i].nodeValue;
                    }
                }
                //search with main nameSpaces
                for (j = 0; j < globalPrefTTNameSpace.length; j += 1) {
                    if (tab[elementNameReference][i].name === globalPrefTTNameSpace[j] + styleElementName) {
                        return tab[elementNameReference][i].nodeValue;
                    }
                }
            }

            return null;
        },

        findParameterElement = function(nodeTab, nameSpaceTab, parameterElementName) {
            var parameterValue = null,
                i = 0,
                k = 0;
            //search for each node in the noteTab, if the parameterElementName is defined
            for (i = 0; i < nodeTab.length; i += 1) {
                for (k = 0; k < nameSpaceTab.length; k += 1) {
                    parameterValue = this.domParser.getAttributeValue(nodeTab[i], nameSpaceTab[k] + parameterElementName);
                    if (parameterValue) {
                        return parameterValue;
                    }
                }
            }

            return parameterValue;
        },

        arrayUnique = function(array) {
            var a = array.concat(),
                i = 0,
                j = 0;
            for (i = 0; i < a.length; ++i) {
                for (j = i + 1; j < a.length; ++j) {
                    if (a[i] === a[j]) {
                        a.splice(j--, 1);
                    }
                }
            }

            return a;
        },

        getNameSpace = function(node, type) {
            var nameSpace = null,
                TTAFUrl = null,
                TTMLUrl = null,
                i = 0,
                tabReturn = [],
                valTab;

            switch (type) {
                case "style":
                    TTAFUrl = TTAF_STYLE_URI;
                    TTMLUrl = TTML_STYLE_URI;
                    break;
                case "parameter":
                    TTAFUrl = TTAF_PARAMETER_URI;
                    TTMLUrl = TTML_PARAMETER_URI;
                    break;
                case "main":
                    TTAFUrl = TTAF_URI;
                    TTMLUrl = TTML_URI;
                    break;
            }

            if (TTAFUrl && TTMLUrl) {
                if (Array.isArray(node)) {
                    for (var key in node) {
                        for (i = node[key].length - 1; i >= 0; i -= 1) {
                            nameSpace = node[key][i].nodeValue === TTMLUrl ? node[key][i].nodeName : null;

                            if (nameSpace === null) {
                                nameSpace = node[key][i].nodeValue === TTAFUrl ? node[key][i].nodeName : null;
                            }

                            if (nameSpace) {
                                nameSpace = nameSpace.split(':').length > 1 ? nameSpace.split(':')[1] + ':' : "";
                                if (tabReturn.indexOf(nameSpace) < 0) {
                                    tabReturn.push(nameSpace);
                                    //nameSpace attribute has been detected, we can remove it.
                                    node[key].removeNamedItem(node[key][i].nodeName);
                                }
                            }
                        }
                    }
                } else {
                    nameSpace = this.domParser.getAttributeName(node, TTAFUrl);

                    if (nameSpace.length === 0) {
                        nameSpace = this.domParser.getAttributeName(node, TTMLUrl);
                    }

                    if (nameSpace.length > 0) {
                        for (i = 0; i < nameSpace.length; i += 1) {
                            valTab = nameSpace[i].split(':').length > 1 ? nameSpace[i].split(':')[1] + ':' : "";
                            if (tabReturn.indexOf(valTab) < 0) {
                                tabReturn.push(valTab);
                            }
                        }
                    }
                }
            }

            return tabReturn;
        },

        getTimeValue = function(node, parameter) {
            var returnTime = NaN,
                i = 0;

            for (i = 0; i < globalPrefTTNameSpace.length && isNaN(returnTime); i += 1) {
                returnTime = parseTimings(this.domParser.getAttributeValue(node, globalPrefTTNameSpace[i] + parameter));
            }

            return returnTime;
        },

        computeCellResolution = function(cellResolution) {
            if (!cellResolution) {
                //default cell resolution defined in TTML documentation
                cellResolution = '32 15';
            }

            var computedCellResolution = cellResolution,
                i = 0;


            computedCellResolution = computedCellResolution.split(' ');

            for (i = 0; i < computedCellResolution.length; i += 1) {
                computedCellResolution[i] = parseFloat(computedCellResolution[i]);
            }

            return computedCellResolution;
        },

        computeTextOutline = function(textOutline, cellResolution, defaultColor) {
            var computedTextOutline = {
                    color: null,
                    width: null
                },
                formatTextOutlineWidth,
                textOutlineWidthIndex = 0;

            if (textOutline) {
                textOutline = textOutline.split(' ');
                //detect if outline color has been defined, if not outline color should be set to color value
                if (textOutline[0] && isNaN(textOutline[0][0])) {
                    computedTextOutline.color = textOutline[0];
                    textOutlineWidthIndex = 1;
                } else {
                    computedTextOutline.color = defaultColor;
                }

                //detect text outline width, the first length value
                if (textOutline[textOutlineWidthIndex]) {
                    //get the last character for text Outline width definition
                    formatTextOutlineWidth = textOutline[textOutlineWidthIndex][textOutline[textOutlineWidthIndex].length - 1];
                    switch (formatTextOutlineWidth) {
                        //definition in cell.
                        case 'c':
                            textOutline[textOutlineWidthIndex] = textOutline[textOutlineWidthIndex].split('c');
                            if (textOutline[textOutlineWidthIndex][0]) {
                                computedTextOutline.width = (parseFloat(textOutline[textOutlineWidthIndex][0] / cellResolution[1], 10) * 100).toFixed(1) + '%';
                            }
                            break;
                        case 'x':
                            //definition in pixel
                            computedTextOutline.width = textOutline[textOutlineWidthIndex];
                            break;
                    }
                }
            }
            return computedTextOutline;
        },

        computeFontSize = function(fontSize, cellResolution) {
            var formatFontSize,
                cellsSize,
                i,
                computedFontSize = fontSize;

            if (fontSize) {
                //get the last character for font size definition
                formatFontSize = fontSize[fontSize.length - 1];
            }

            switch (formatFontSize) {
                case '%':
                    computedFontSize = (parseFloat(1 / cellResolution[1], 10) * 100);
                    computedFontSize = ((parseInt(fontSize.substr(0, fontSize.length - 1), 10) * computedFontSize) / 100).toFixed(1) + "%";
                    break;
                case 'c':
                    //define fontSize in %
                    cellsSize = fontSize.replace(/\s/g, '').split('c');

                    for (i = 0; i < cellsSize.length; i += 1) {
                        cellsSize[i] = parseFloat(cellsSize[i]);
                    }

                    if (isNaN(cellsSize[1])) {
                        computedFontSize = (cellsSize[0] / cellResolution[1] * 100).toFixed(1) + '%';
                    } else {
                        computedFontSize = (cellsSize[1] / cellResolution[1] * 100).toFixed(1) + '%';
                    }
                    break;
                case 'x':
                    //nothing to do, fontSize has been set with an absolute value.
                    break;
                default:
                    //no fontSize has been defined => '1 c'
                    computedFontSize = (parseFloat(1 / cellResolution[1], 10) * 100).toFixed(1) + '%';
            }

            return computedFontSize;
        },

        internalParse = function(data) {
            var captionArray = [],
                errorMsg,
                regions,
                region,
                previousStartTime = null,
                previousEndTime = null,
                startTime,
                endTime,
                cssStyle = {
                    backgroundColor: null,
                    color: null,
                    fontSize: null,
                    fontFamily: null,
                    textOutline: {
                        color: null,
                        with: null
                    }
                },
                caption,
                divBody,
                i,
                textDatas,
                j,
                k,
                cellResolution,
                extent,
                textNodes,
                textOutline,
                textValue = "";

            try {

                xmlDoc = this.domParser.createXmlTree(data);

                if (!passStructuralConstraints.call(this)) {
                    errorMsg = "TTML document has incorrect structure";
                    return Q.reject(errorMsg);
                }

                //define global namespace prefix for TTML
                globalPrefTTNameSpace = getNameSpace.call(this, nodeTt, 'main');
                //define global namespace prefix for parameter
                globalPrefParameterNameSpace = getNameSpace.call(this, nodeTt, 'parameter');
                //define global namespace prefix for style
                globalPrefStyleNameSpace = getNameSpace.call(this, nodeTt, 'style');
                for (i = 0; i < globalPrefParameterNameSpace.length; i += 1) {
                    frameRate = this.domParser.getAttributeValue(nodeTt, globalPrefParameterNameSpace[i] + "frameRate") ? parseInt(frameRate, 10) : null;
                }

                divBody = this.domParser.getChildNodes(nodeBody, 'div');

                if (!divBody || divBody.length === 0) {
                    errorMsg = "TTML body document does not contain any div";
                    return Q.reject(errorMsg);
                }

                //get all styles informations
                tabStyles = this.domParser.getAllSpecificNodes(nodeTt, 'style');
                //search prefTT nameSpace in tabStyles
                globalPrefTTNameSpace = arrayUnique(globalPrefTTNameSpace.concat(getNameSpace.call(this, tabStyles, 'main')));
                //search prefStyle nameSpace in tabStyles
                globalPrefStyleNameSpace = arrayUnique(globalPrefStyleNameSpace.concat(getNameSpace.call(this, tabStyles, 'style')));
                //get all regions informations
                tabRegions = this.domParser.getAllSpecificNodes(nodeTt, 'region');
                //search prefTT nameSpace in tabRegions
                globalPrefTTNameSpace = arrayUnique(globalPrefTTNameSpace.concat(getNameSpace.call(this, tabRegions, 'main')));
                //search prefStyle nameSpace in tabRegions
                globalPrefStyleNameSpace = arrayUnique(globalPrefStyleNameSpace.concat(getNameSpace.call(this, tabRegions, 'style')));

                for (k = 0; k < divBody.length; k += 1) {
                    regions = this.domParser.getChildNodes(divBody[k], 'p');

                    if (!regions || regions.length === 0) {
                        errorMsg = "TTML document does not contain any cues";
                    } else {
                        for (i = 0; i < regions.length; i += 1) {
                            caption = null;
                            cssStyle = {
                                backgroundColor: null,
                                color: null,
                                fontSize: null,
                                fontFamily: null,
                                textOutline: {
                                    color: null,
                                    with: null
                                }
                            };
                            region = regions[i];

                            globalPrefTTNameSpace = arrayUnique(globalPrefTTNameSpace.concat(getNameSpace.call(this, region, 'main')));

                            globalPrefStyleNameSpace = arrayUnique(globalPrefStyleNameSpace.concat(getNameSpace.call(this, region, 'style')));

                            startTime = getTimeValue.call(this, region, 'begin');

                            endTime = getTimeValue.call(this, region, 'end');

                            if (isNaN(startTime) || isNaN(endTime)) {
                                errorMsg = "TTML document has incorrect timing value";
                            } else {
                                textDatas = this.domParser.getChildNodes(region, 'span');
                                //subtitles are set in span
                                if (textDatas.length > 0) {
                                    for (j = 0; j < textDatas.length; j++) {
                                        /******************** Find style informations ***************************************
                                         *   1- in subtitle paragraph ToDo
                                         *   2- in style element referenced in the subtitle paragraph
                                         *   3- in region ToDo
                                         *   4- in style referenced in the region referenced in the subtitle paragraph
                                         *   5- in the main div ToDo
                                         *   6- in the style of the main div
                                         **************************************************************************************/
                                        //search style informations once.
                                        if (j === 0) {
                                            cssStyle.backgroundColor = findStyleElement.call(this, [textDatas[j], region, divBody], 'backgroundColor');
                                            if (cssStyle.backgroundColor === null) {
                                                //set default TTML value
                                                cssStyle.backgroundColor = 'transparent';
                                            }
                                            cssStyle.color = findStyleElement.call(this, [textDatas[j], region, divBody], 'color');
                                            cssStyle.fontSize = findStyleElement.call(this, [textDatas[j], region, divBody], 'fontSize');
                                            cssStyle.fontFamily = findStyleElement.call(this, [textDatas[j], region, divBody], 'fontFamily');
                                            textOutline = findStyleElement.call(this, [textDatas[j], region, divBody], 'textOutline');
                                            extent = findStyleElement.call(this, [textDatas[j], region, divBody], 'extent');

                                            cellResolution = findParameterElement.call(this, [textDatas[j], region, divBody, nodeTt], globalPrefParameterNameSpace, 'cellResolution');
                                            cellResolution = computeCellResolution(cellResolution);

                                            cssStyle.textOutline = computeTextOutline(textOutline, cellResolution, cssStyle.color);
                                            cssStyle.fontSize = computeFontSize(cssStyle.fontSize, cellResolution);
                                        }
                                        //try to detect multi lines subtitle
                                        textValue += textDatas[j].textContent + "\n";
                                    }
                                    //line and position element have no effect on IE
                                    //For Chrome line = 80 is a percentage workaround to reorder subtitles
                                    caption = {
                                        start: startTime,
                                        end: endTime,
                                        data: textValue,
                                        line: 80,
                                        style: cssStyle
                                    };
                                    textValue = "";
                                    captionArray.push(caption);
                                } else {
                                    cssStyle.backgroundColor = findStyleElement.call(this, [region, divBody], 'backgroundColor');
                                    if (cssStyle.backgroundColor === null) {
                                        //set default TTML value
                                        cssStyle.backgroundColor = 'transparent';
                                    }
                                    cssStyle.color = findStyleElement.call(this, [region, divBody], 'color');
                                    cssStyle.fontSize = findStyleElement.call(this, [region, divBody], 'fontSize');
                                    cssStyle.fontFamily = findStyleElement.call(this, [region, divBody], 'fontFamily');
                                    textOutline = findStyleElement.call(this, [region, divBody], 'textOutline');

                                    extent = findStyleElement.call(this, [region, divBody], 'extent');

                                    cellResolution = findParameterElement.call(this, [region, divBody], globalPrefParameterNameSpace, 'cellResolution');
                                    cellResolution = computeCellResolution(cellResolution);

                                    cssStyle.textOutline = computeTextOutline(textOutline, cellResolution, cssStyle.color);
                                    cssStyle.fontSize = computeFontSize(cssStyle.fontSize, cellResolution);

                                    //line and position element have no effect on IE
                                    //For Chrome line = 80 is a percentage workaround to reorder subtitles
                                    //try to detect multi lines subtitle
                                    if (i > 0) {
                                        previousStartTime = getTimeValue.call(this, regions[i - 1], 'begin');
                                        previousEndTime = getTimeValue.call(this, regions[i - 1], 'end');
                                    }

                                    if (startTime === previousStartTime && endTime === previousEndTime) {
                                        if (region.textContent !== "") {
                                            var lastCaption = captionArray.pop();
                                            caption = {
                                                start: startTime,
                                                end: endTime,
                                                data: lastCaption.data + '\n' + region.textContent,
                                                line: 80,
                                                style: cssStyle
                                            };
                                        }
                                    } else {
                                        textNodes = this.domParser.getChildNodes(region, '#text');

                                        for (j = 0; j < textNodes.length; j += 1) {
                                            textValue += textNodes[j].textContent + "\n";
                                        }
                                        caption = {
                                            start: startTime,
                                            end: endTime,
                                            data: textValue,
                                            line: 80,
                                            style: cssStyle
                                        };
                                        textValue = "";
                                    }
                                    if (caption !== null) {
                                        captionArray.push(caption);
                                    }
                                }
                            }
                        }
                    }
                }
                if (captionArray.length > 0) {
                    return Q.when(captionArray);
                } else {
                    return Q.reject(errorMsg);
                }

            } catch (err) {
                errorMsg = err.message;
                return Q.reject(errorMsg);
            }
        };

    return {
        domParser: undefined,
        parse: internalParse

    };
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.TextController = function () {

     var LOADING = "LOADING",
         //LOADED = "LOADED",
         READY = "READY",
         initialized = false,
         periodInfo = null,
         mediaSource,
         data,
         buffer,
         availableRepresentations,
         state = READY,
         setState = function (value) {
             this.debug.log("TextController setState to:" + value);
             state = value;
         },
         startPlayback = function () {

             if (!initialized || state !== READY) {
                 return;
             }

             var self = this;
            // TODO Multiple tracks can be handled here by passing in quality level.
            self.indexHandler.getInitRequest(availableRepresentations[0]).then(
                function(request) {
                    //self.debug.log("Loading text track initialization: " + request.url);
                    //self.debug.log(request);
                    self.fragmentLoader.load(request).then(onBytesLoaded.bind(self, request), onBytesError.bind(self, request));
                    setState.call(self, LOADING);
                }
            );
        },
        doStart = function() {
            startPlayback.call(this);
        },

        updateRepresentations = function(data, periodInfo) {
            var adaptations,
                manifest = this.manifestModel.getValue(),
                idx;

            idx = this.manifestExt.getDataIndex(data, manifest, periodInfo.index);

            adaptations = this.manifestExt.getAdaptationsForPeriod(manifest, periodInfo);
            return this.manifestExt.getRepresentationsForAdaptation(manifest, adaptations[idx]);
        },

        onBytesLoaded = function(request, response) {
            var self = this;
            //self.debug.log(" Text track Bytes finished loading: " + request.url);
            // ORANGE: add request parameter to retrieve startTime and timescale in fragmentController
             self.fragmentController.process(response.data, request).then(
                 function (data) {
                     if (data !== null) {
                         //self.debug.log("Push text track bytes: " + data.byteLength);
                         self.sourceBufferExt.append(buffer, data, self.videoModel);
                     }
                 }
             );
         },

        onBytesError = function( /*request*/ ) {};

    return {
        videoModel: undefined,
        fragmentLoader: undefined,
        fragmentController: undefined,
        indexHandler: undefined,
        sourceBufferExt: undefined,
        manifestModel: undefined,
        manifestExt: undefined,
        debug: undefined,
        initialize: function (periodInfo, data, buffer, videoModel, source) {
            var self = this;

            self.setVideoModel(videoModel);
            self.setBuffer(buffer);
            self.setMediaSource(source);

            self.updateData(data, periodInfo);

            initialized = true;

            startPlayback.call(self);
        },

        setPeriodInfo: function(value) {
            periodInfo = value;
        },

        getPeriodIndex: function () {
            return periodInfo.index;
        },

        getVideoModel: function () {
            return this.videoModel;
        },

        setVideoModel: function (value) {
            this.videoModel = value;
        },

        getData: function () {
            return data;
        },

        setData: function (value) {
            data = value;
        },

        getBuffer: function () {
            return buffer;
        },

        setBuffer: function (value) {
            buffer = value;
        },

        setMediaSource: function(value) {
            mediaSource = value;
        },

        updateData: function(dataValue, periodInfoValue) {
            data = dataValue;
            periodInfo = periodInfoValue;

            availableRepresentations = updateRepresentations.call(this, data, periodInfo);
            setState.call(this, READY);
            startPlayback.call(this);
        },

        reset: function (errored) {
            if (!errored) {
                this.sourceBufferExt.abort(mediaSource, buffer);
                this.sourceBufferExt.removeSourceBuffer(mediaSource, buffer);
            }
        },

        start: doStart
    };
};

MediaPlayer.dependencies.TextController.prototype = {
    constructor: MediaPlayer.dependencies.TextController
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.dependencies.TextSourceBuffer = function () {

    var video,
        data,
        mimeType;

    return {
        system:undefined,
        eventBus:undefined,
        errHandler: undefined,

        initialize: function (type, bufferController) {
            mimeType = type;
            video = bufferController.getVideoModel().getElement();
            data = bufferController.getData();
        },

        append: function (bytes) {
            var self = this,
                ccContent = String.fromCharCode.apply(null, new Uint16Array(bytes));

            self.getParser().parse(ccContent).then(
                function(result)
                {
                    var label = data.Representation_asArray[0].id,
                        lang = data.lang;

                    self.getTextTrackExtensions().addTextTrack(video, result, label, lang, true).then(
                        function(/*track*/)
                        {
                            self.eventBus.dispatchEvent({type:"updateend"});
                        }
                    );
                },
                function(errMsg) {
                    self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.CC_ERR_PARSE, errMsg, ccContent);
                }
            );
        },

        abort:function() {
            this.getTextTrackExtensions().deleteCues(video);
        },

        getParser:function() {
            var parser;

            if (mimeType === "text/vtt") {
                parser = this.system.getObject("vttParser");
            } else if (mimeType === "application/ttml+xml") {
                parser = this.system.getObject("ttmlParser");
            }

            return parser;
        },

        getTextTrackExtensions:function() {
            return this.system.getObject("textTrackExtensions");
        },

        addEventListener: function (type, listener, useCapture) {
            this.eventBus.addEventListener(type, listener, useCapture);
        },

        removeEventListener: function (type, listener, useCapture) {
            this.eventBus.removeEventListener(type, listener, useCapture);
        }
    };
};

MediaPlayer.dependencies.TextSourceBuffer.prototype = {
    constructor: MediaPlayer.dependencies.TextSourceBuffer
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

// Orange: This Source Buffer processes TTML+XML subtitles encapsulated in the mp4
//         This format is used by smoothstreaming headends

MediaPlayer.dependencies.TextTTMLXMLMP4SourceBuffer = function() {

    var video,
        mimeType,
        currentLang,
        currentId,

        // We need to simulate TimeRanges, as defined
        // by Media Streaming Extensions.
        // start() and end() functions must be provided,
        // as player checks the buffer level using these

        buffered = {
            length: 0,
            ranges: [],

            start: function(index) {
                return this.ranges[index].start;
            },

            end: function(index) {
                return this.ranges[index].end;
            },

            addRange: function(start, end) {
                var i = 0,
                    rangesUpdated = false,
                    tolerance = 0.01;

                //detect discontinuity in ranges.
                for (i = 0; i < this.ranges.length; i++) {
                    if (this.ranges[i].end <= (start + tolerance) && this.ranges[i].end >= (start - tolerance)) {
                        rangesUpdated = true;
                        this.ranges[i].end = end;
                    }

                    if (this.ranges[i].start <= (end + tolerance) && this.ranges[i].start >= (end - tolerance)) {
                        rangesUpdated = true;
                        this.ranges[i].start = start;
                    }
                }

                if (!rangesUpdated) {
                    this.ranges.push({
                        start: start,
                        end: end
                    });
                    this.length = this.length + 1;

                    // TimeRanges must be normalized
                    this.ranges.sort(function(a, b) {
                        return a.start - b.start;
                    });
                }
            },

            removeRange: function(start, end) {
                var i = 0;
                for (i = this.ranges.length - 1; i >= 0; i -= 1) {
                    if (((end === undefined || end === -1) || (this.ranges[i].end <= end)) &&
                        ((start === undefined || start === -1) || (this.ranges[i].start >= start))) {
                        this.ranges.splice(i, 1);
                    }
                }

                this.length = this.ranges.length;
            },

            reset: function() {
                this.length = 0;
                this.ranges = [];
            }
        };

    return {
        updating: false,
        system: undefined,
        eventBus: undefined,
        buffered: buffered,
        textTrackExtensions: undefined,
        ttmlParser: undefined,
        debug: undefined,

        initialize: function(type, bufferController, subtitleData) {
            mimeType = type;
            video = bufferController.getVideoModel().getElement();
            buffered.reset();
            currentLang = subtitleData.lang;
            currentId = subtitleData.id;
        },
        remove: function(start, end) {
            /*If start is negative or greater than duration, then throw an INVALID_ACCESS_ERR exception and abort these steps.
            If end is less than or equal to start, then throw an INVALID_ACCESS_ERR exception and abort these steps.
            If this object has been removed from the sourceBuffers attribute of the parent media source then throw an INVALID_STATE_ERR exception and abort these steps.
            If the updating attribute equals true, then throw an INVALID_STATE_ERR exception and abort these steps.
            If the readyState attribute of the parent media source is in the "ended" state then run the following steps:

            Set the readyState attribute of the parent media source to "open"
            Queue a task to fire a simple event named sourceopen at the parent media source .
            Set the updating attribute to true.
            Queue a task to fire a simple event named updatestart at this SourceBuffer object.
            Return control to the caller and run the rest of the steps asynchronously.
            Run the coded frame removal algorithm with start and end as the start and end of the removal range.
            Set the updating attribute to false.
            Queue a task to fire a simple event named update at this SourceBuffer object.
            Queue a task to fire a simple event named updateend at this SourceBuffer object.*/
            if (start < 0 || start >= end) {
                throw "INVALID_ACCESS_ERR";
            }

            this.getTextTrackExtensions().deleteCues(video, false, start, end);
            this.buffered.removeRange(start, end);
        },

        append: function(bytes) {
            var self = this,
                file = mp4lib.deserialize(bytes),
                moov = file.getBoxByType('moov'),
                mvhd,
                moof,
                mdat,
                traf,
                tfhd,
                tfdt,
                trun,
                fragmentStart,
                fragmentDuration = 0,
                encoding = 'utf-8';

            //no mp4, all the subtitles are in one xml file
            if (mimeType === 'application/ttml+xml') {
                this.track = this.textTrackExtensions.addTextTrack(video, [], currentId, currentLang, true);

                //detect utf-16 encoding
                if (self.isUTF16(bytes)) {
                    encoding = 'utf-16';
                }

                this.convertUTFToString(bytes, encoding)
                    .then(function(result) {
                        self.ttmlParser.parse(result).then(function(cues) {
                            if (cues) {

                                self.textTrackExtensions.addCues(self.track, cues);
                                self.buffered.addRange(0, video.duration);
                                self.eventBus.dispatchEvent({
                                    type: "updateend"
                                });
                            }
                        }, function( /*error*/ ) {
                            //self.debug.error("[TextTTMLXMLMP4SourceBuffer] error parsing TTML "+error);
                        });
                    });
                return;
            }

            if (moov) {
                // This must be an init segment, if it has a moov box.
                // We need it to read the timescale, as it will be
                // used to compute fragments time ranges.

                mvhd = moov.getBoxByType('mvhd');
                self.timescale = mvhd.timescale;

                // Also, it is a good moment to set up a text track on videoElement
                // TODO: set up name and language
                this.track = this.textTrackExtensions.addTextTrack(video, [], currentId, currentLang, true);
                this.eventBus.dispatchEvent({
                    type: "updateend"
                });
                return;
            }

            moof = file.getBoxByType('moof');
            if (moof) {

                // This is a subtitles track fragment
                // let's decode the data and add captions to video element
                mdat = file.getBoxByType('mdat');

                // We need to update TimeRanges.
                // assume that there is a single text sample in fragment
                traf = moof.getBoxByType('traf');
                tfhd = traf.getBoxByType('tfhd');
                tfdt = traf.getBoxByType('tfdt');
                trun = traf.getBoxByType('trun');

                fragmentStart = tfdt.baseMediaDecodeTime / self.timescale;
                fragmentDuration = 0;
                if (trun.flags & 0x000100) {
                    fragmentDuration = trun.samples_table[0].sample_duration / self.timescale;
                } else {
                    fragmentDuration = tfhd.default_sample_duration / self.timescale;
                }

                self.buffered.addRange(fragmentStart, fragmentStart + fragmentDuration);

                //detect utf-16 encoding
                if (self.isUTF16(mdat.data)) {
                    encoding = 'utf-16';
                }
                // parse data and add to cues
                self.convertUTFToString(mdat.data, encoding)
                    .then(function(result) {
                        self.ttmlParser.parse(result).then(function(cues) {
                            var i;
                            if (cues) {
                                for (i = 0; i < cues.length; i += 1) {
                                    cues[i].start = cues[i].start + fragmentStart;
                                    cues[i].end = cues[i].end + fragmentStart;
                                }

                                self.textTrackExtensions.addCues(self.track, cues);

                                self.eventBus.dispatchEvent({
                                    type: "updateend"
                                });
                            }
                        }, function( /*error*/ ) {
                            //self.debug.error("[TextTTMLXMLMP4SourceBuffer] error parsing TTML "+error);
                        });
                    });
            }
            return;
        },

        convertUTFToString: function(buf, encoding) {
            var deferred = Q.defer(),
                blob = new Blob([buf], {
                    type: "text/xml"
                }),
                f = new FileReader();

            f.onload = function(e) {
                deferred.resolve(e.target.result);
            };
            f.readAsText(blob, encoding);

            return deferred.promise;
        },

        /**
         * UTF-16 (LE or BE)
         *
         * RFC2781: UTF-16, an encoding of ISO 10646
         *
         * @link http://www.ietf.org/rfc/rfc2781.txt
         * @private
         * @ignore
         */
        isUTF16: function(data) {
            var i = 0;
            var len = data && data.length;
            var pos = null;
            var b1, b2, next, prev;

            if (len < 2) {
                if (data[0] > 0xFF) {
                    return false;
                }
            } else {
                b1 = data[0];
                b2 = data[1];
                if (b1 === 0xFF && // BOM (little-endian)
                    b2 === 0xFE) {
                    return true;
                }
                if (b1 === 0xFE && // BOM (big-endian)
                    b2 === 0xFF) {
                    return true;
                }

                for (; i < len; i++) {
                    if (data[i] === 0x00) {
                        pos = i;
                        break;
                    } else if (data[i] > 0xFF) {
                        return false;
                    }
                }

                if (pos === null) {
                    return false; // Non ASCII
                }

                next = data[pos + 1]; // BE
                if (next !== void 0 && next > 0x00 && next < 0x80) {
                    return true;
                }

                prev = data[pos - 1]; // LE
                if (prev !== void 0 && prev > 0x00 && prev < 0x80) {
                    return true;
                }
            }

            return false;
        },

        abort: function() {
            this.getTextTrackExtensions().deleteCues(video, true);
        },

        getTextTrackExtensions: function() {
            return this.textTrackExtensions;
        },

        addEventListener: function(type, listener, useCapture) {
            this.eventBus.addEventListener(type, listener, useCapture);
            if (!this.updating)
                this.eventBus.dispatchEvent({
                    type: "updateend"
                });
        },

        removeEventListener: function(type, listener, useCapture) {
            this.eventBus.removeEventListener(type, listener, useCapture);
        }
    };
};

MediaPlayer.dependencies.TextTTMLXMLMP4SourceBuffer.prototype = {
    constructor: MediaPlayer.dependencies.TextTTMLXMLMP4SourceBuffer
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.TextTrackExtensions = function() {
    "use strict";
    var Cue;

    return {
        eventBus: undefined,
        config: undefined,

        setup: function() {
            Cue = window.VTTCue || window.TextTrackCue;
        },

        cueEnter: function(subtitle_style, subtitle_text) {
            this.eventBus.dispatchEvent({
                type: "cueEnter",
                data: {
                    text: subtitle_text,
                    style: subtitle_style,
                }
            });
        },

        cueExit: function(subtitle_style, subtitle_text) {
            this.eventBus.dispatchEvent({
                type: "cueExit",
                data: {
                    text: subtitle_text,
                    style: subtitle_style,
                }
            });
        },

        getCurrentTextTrack: function(video){
            for(var i=0; i< video.textTracks.length; i++){
                if(video.textTracks[i].label === 'hascaption'){
                    return video.textTracks[i];
                }
            }
            return null;
        },

        addTextTrack: function(video, captionData, label, scrlang, isDefaultTrack) {
            var track = null,
                currentItem = null,
                subtitleDisplayMode = 'subtitles',
                i;

            //no function removeTextTrack is defined
            //add one, only if it's necessary
            //deleteCues will be very efficient in this case
            track = this.getCurrentTextTrack(video);
            if (!track) {
                subtitleDisplayMode = this.config.getParam("TextTrackExtensions.displayModeExtern", "boolean") === true ? 'metadata' : 'subtitles';
                //TODO: Ability to define the KIND in the MPD - ie subtitle vs caption....
                track = video.addTextTrack(subtitleDisplayMode, 'hascaption', scrlang);
                // track.default is an object property identifier that is a reserved word
                // The following jshint directive is used to suppressed the warning "Expected an identifier and instead saw 'default' (a reserved word)"
                /*jshint -W024 */
                track.default = isDefaultTrack;
                track.mode = "showing";
            }else{
                track.default = isDefaultTrack;
                if (track.mode !== 'showing') {
                    track.mode = "showing";
                }
            }

            for (i = 0; i < captionData.length; i += 1) {
                currentItem = captionData[i];
                track.addCue(new Cue(currentItem.start, currentItem.end, currentItem.data));
            }

            return track;
        },

        onCueEnter: function(e) {
            this.cueEnter(e.currentTarget.style, e.currentTarget.text);
        },

        onCueExit: function(e) {
            this.cueExit(e.currentTarget.style, e.currentTarget.text);
        },

        // Orange: addCues added so it is possible to add cues during playback,
        //         not only during track initialization

        addCues: function(track, captionData) {
            var i = 0,
                currentItem = null,
                newCue = null;

            for (i = 0; i < captionData.length; i += 1) {
                currentItem = captionData[i];
                if (currentItem.start < currentItem.end) {
                    newCue = new Cue(currentItem.start, currentItem.end, currentItem.data);

                    newCue.onenter = this.onCueEnter.bind(this);
                    newCue.onexit = this.onCueExit.bind(this);

                    newCue.snapToLines = false;

                    newCue.line = currentItem.line;

                    if (currentItem.style) {
                        newCue.style = currentItem.style;
                    }

                    track.addCue(newCue);
                }
            }
        },

        deleteCues: function(video, disabled, start, end) {
            var track = null,
                cues = null,
                lastIdx = null,
                i = 0;

            //when multiple tracks are supported - iterate through and delete all cues from all tracks.
            if (video) {
                track = video.textTracks[0];
                if (track) {
                    cues = track.cues;
                    if (cues) {
                        lastIdx = cues.length - 1;

                        for (i = lastIdx; i >= 0; i -= 1) {
                            if (((end === undefined || end === -1) || (cues[i].endTime < end)) &&
                                ((start === undefined || start === -1) || (cues[i].startTime > start))) {
                                track.removeCue(cues[i]);
                            }
                        }
                    }
                    //noway to delete track, just disable it
                    //useful when player switchs between a stream with subtitles and an other one without.
                    if (disabled) {
                        track.mode = "disabled";
                    }
                }
            }
        }
    };
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Akamai Technologies nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.VTTParser = function () {
    "use strict";

    var convertCuePointTimes = function(time) {
        var timeArray = time.split( ":"),
            len = timeArray.length - 1;

        time = parseInt( timeArray[len-1], 10 ) * 60 + parseFloat( timeArray[len], 10 );

        if ( len === 2 ) {
            time += parseInt( timeArray[0], 10 ) * 3600;
        }

        return time;
    };

    return {

        parse: function (data)
        {
            var regExNewLine = /(?:\r\n|\r|\n)/gm,
                regExToken = /-->/,
                regExWhiteSpace = /(^[\s]+|[\s]+$)/g,
                captionArray = [],
                len;

            data = data.split( regExNewLine );
            len = data.length;

            for (var i = 0 ; i < len; i++)
            {
                var item = data[i];

                if (item.length > 0 && item !== "WEBVTT")
                {
                    if (item.match(regExToken))
                    {
                        var cuePoints = item.split(regExToken);
                        //vtt has sublines so more will need to be done here
                        var sublines = data[i+1];

                        //TODO Make VO external so other parsers can use.
                        captionArray.push({
                            start:convertCuePointTimes(cuePoints[0].replace(regExWhiteSpace, '')),
                            end:convertCuePointTimes(cuePoints[1].replace(regExWhiteSpace, '')),
                            data:sublines
                        });
                    }
                }
            }

            return Q.when(captionArray);
        }
    };
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.AbandonRequestsRule = function() {
    "use strict";

    var GRACE_TIME_THRESHOLD = 0.5,
        ABANDON_MULTIPLIER = 2;

    return {
        debug: undefined,
        metricsExt:undefined,

        name: "AbandonRequestRule",

        execute: function(request, callback) {
            var now = new Date().getTime(),
                type = request.streamType,
                elapsedTime,
                measuredBandwidth,
                estimatedTimeOfDownload,
                switchRequest = new MediaPlayer.rules.SwitchRequest(MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE, MediaPlayer.rules.SwitchRequest.prototype.WEAK);

                if (request.firstByteDate === null || request.aborted) {
                    this.debug.log("[AbandonRequestsRule][" + type + "] Request has already been aborted.");
                    callback(switchRequest);
                    return;
                }

                elapsedTime = (now - request.firstByteDate.getTime()) / 1000;
                //this.debug.log("[AbandonRequestsRule][" + type + "] elapsedTime = " + elapsedTime + " s (" + request.bytesLoaded + "/" + request.bytesTotal + ")");

                if (request.bytesLoaded < request.bytesTotal && elapsedTime >= (request.duration * GRACE_TIME_THRESHOLD)) {

                    measuredBandwidth = request.bytesLoaded / elapsedTime;
                    estimatedTimeOfDownload = request.bytesTotal / measuredBandwidth;

                    //this.debug.log("[AbandonRequestsRule][" + type + "] bw = " + measuredBandwidth + " kb/s (" + estimatedTimeOfDownload + " s)");

                    if ((estimatedTimeOfDownload) > (request.duration * ABANDON_MULTIPLIER)) {
                        switchRequest = new MediaPlayer.rules.SwitchRequest(0, MediaPlayer.rules.SwitchRequest.prototype.STRONG);
                        this.debug.info("[AbandonRequestsRule][" + type + "] BW = " + measuredBandwidth.toFixed(3) + " kb/s => switch to lowest quality");
                    }
                }

            callback(switchRequest);
        },
    };
};

MediaPlayer.rules.AbandonRequestsRule.prototype = {
    constructor: MediaPlayer.rules.AbandonRequestsRule
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.BaseRulesCollection = function () {
    "use strict";

    var rules = [],
        adandonFragmentRules = [];

    return {
        downloadRatioRule: undefined,
        insufficientBufferRule: undefined,
        droppedFramesRule: undefined,
        abandonRequestRule:undefined,

        getRules: function (type) {
            switch (type) {
                case MediaPlayer.rules.BaseRulesCollection.prototype.QUALITY_SWITCH_RULES:
                    return rules;
                case MediaPlayer.rules.BaseRulesCollection.prototype.ABANDON_FRAGMENT_RULES:
                    return adandonFragmentRules;
                default:
                    return null;
            }
        },

        setup: function () {
            rules.push(this.downloadRatioRule);
            rules.push(this.insufficientBufferRule);
            rules.push(this.droppedFramesRule);
            adandonFragmentRules.push(this.abandonRequestRule);
        }
    };
};

MediaPlayer.rules.BaseRulesCollection.prototype = {
    constructor: MediaPlayer.rules.BaseRulesCollection,
    QUALITY_SWITCH_RULES: "qualitySwitchRules",
    ABANDON_FRAGMENT_RULES: "abandonFragmentRules"
};

/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.DownloadRatioRule = function() {
    "use strict";

    return {
        debug: undefined,
        manifestExt: undefined,
        metricsExt: undefined,
        manifestModel: undefined,
        config: undefined,

        name: "DownloadRatioRule",

        checkIndex: function(current, metrics, data) {
            var self = this,
                requests = self.metricsExt.getHttpRequests(metrics),
                lastRequest = null,
                downloadTime,
                totalTime,
                calculatedBandwidth,
                currentBandwidth,
                latencyInBandwidth,
                switchUpRatioSafetyFactor,
                currentRepresentation,
                count,
                bandwidths = [],
                i,
                q = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE,
                totalBytesLength = 0,
                p = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT;

            if (data && data.hasOwnProperty('type')) {
                latencyInBandwidth = self.config.getParamFor(data.type, "ABR.latencyInBandwidth", "boolean", true);
                switchUpRatioSafetyFactor = self.config.getParamFor(data.type, "ABR.switchUpRatioSafetyFactor", "number", 1.5);
                //self.debug.log("Checking download ratio rule...");
                self.debug.log("[DownloadRatioRule][" + data.type + "] Checking download ratio rule... (current = " + current + ")");

                if (!metrics) {
                    self.debug.log("[DownloadRatioRule][" + data.type + "] No metrics, bailing.");
                    return new MediaPlayer.rules.SwitchRequest();
                }

                // Get last valid request
                i = requests.length - 1;
                while (i >= 0 && lastRequest === null) {
                    if (requests[i].tfinish && requests[i].trequest && requests[i].tresponse && requests[i].bytesLength > 0) {
                        lastRequest = requests[i];
                    }
                    i--;
                }

                if (lastRequest === null) {
                    self.debug.log("[DownloadRatioRule][" + data.type + "] No valid requests made for this stream yet, bailing.");
                    return new MediaPlayer.rules.SwitchRequest();
                }

                totalTime = (lastRequest.tfinish.getTime() - lastRequest.trequest.getTime()) / 1000;
                downloadTime = (lastRequest.tfinish.getTime() - lastRequest.tresponse.getTime()) / 1000;

                if (totalTime <= 0) {
                    self.debug.log("[DownloadRatioRule][" + data.type + "] Don't know how long the download of the last fragment took, bailing.");
                    return new MediaPlayer.rules.SwitchRequest();
                }

                if (lastRequest.mediaduration === null ||
                    lastRequest.mediaduration === undefined ||
                    lastRequest.mediaduration <= 0 ||
                    isNaN(lastRequest.mediaduration)) {
                    self.debug.log("[DownloadRatioRule][" + data.type + "] Don't know the duration of the last media fragment, bailing.");
                    return new MediaPlayer.rules.SwitchRequest();
                }

                self.debug.log("[DownloadRatioRule][" + data.type + "] DL: " + Number(downloadTime.toFixed(3)) + "s, Total: " + Number(totalTime.toFixed(3)) + "s");

                totalBytesLength = lastRequest.bytesLength;

                // Take average bandwidth over 3 requests
                count = 1;
                i = requests.length - 2;
                while (i >= 0 && count < 3) {
                    if (requests[i].tfinish && requests[i].trequest && requests[i].tresponse && requests[i].bytesLength > 0) {
                        self.debug.log("[DownloadRatioRule][" + data.type + "] length: " + requests[i].bytesLength + ", time: " + ((requests[i].tfinish.getTime() - requests[i].trequest.getTime()) / 1000));
                        totalBytesLength += requests[i].bytesLength;
                        totalTime += (requests[i].tfinish.getTime() - requests[i].trequest.getTime()) / 1000;
                        downloadTime += (requests[i].tfinish.getTime() - requests[i].tresponse.getTime()) / 1000;
                        count += 1;
                    }
                    i--;
                }

                // Set length in bits
                totalBytesLength *= 8;

                calculatedBandwidth = latencyInBandwidth ? (totalBytesLength / totalTime) : (totalBytesLength / downloadTime);

                self.debug.log("[DownloadRatioRule][" + data.type + "] BW = " + Math.round(calculatedBandwidth / 1000) + " kb/s");

                if (isNaN(calculatedBandwidth)) {
                    return new MediaPlayer.rules.SwitchRequest();
                }

                count = self.manifestExt.getRepresentationCount(data);
                currentRepresentation = self.manifestExt.getRepresentationFor(current, data);
                currentBandwidth = self.manifestExt.getBandwidth(currentRepresentation);
                for (i = 0; i < count; i += 1) {
                    bandwidths.push(self.manifestExt.getRepresentationBandwidth(data, i));
                }
                if (calculatedBandwidth <= currentBandwidth) {
                    for (i = current - 1; i > 0; i -= 1) {
                        if (bandwidths[i] <= calculatedBandwidth) {
                            break;
                        }
                    }
                    q = i;
                    p = MediaPlayer.rules.SwitchRequest.prototype.WEAK;

                    self.debug.info("[DownloadRatioRule][" + data.type + "] SwitchRequest: q=" + q + "/" + (count - 1) + " (" + bandwidths[q] + "), p=" + p);
                    return new MediaPlayer.rules.SwitchRequest(q, p);
                } else {
                    for (i = count - 1; i > current; i -= 1) {
                        if (calculatedBandwidth > (bandwidths[i] * switchUpRatioSafetyFactor)) {
                            //self.debug.log("[DownloadRatioRule][" + data.type + "] bw = " + calculatedBandwidth + " results[i] * switchUpRatioSafetyFactor =" + (bandwidths[i] * switchUpRatioSafetyFactor) + " with i=" + i);
                            break;
                        }
                    }

                    q = i;
                    p = MediaPlayer.rules.SwitchRequest.prototype.STRONG;

                    self.debug.info("[DownloadRatioRule][" + data.type + "] SwitchRequest: q=" + q + "/" + (count - 1) + " (" + bandwidths[q] + "), p=" + p);
                    return new MediaPlayer.rules.SwitchRequest(q, p);
                }
            } else {
                return new MediaPlayer.rules.SwitchRequest();
            }
        }
    };
};

MediaPlayer.rules.DownloadRatioRule.prototype = {
    constructor: MediaPlayer.rules.DownloadRatioRule
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.DroppedFramesRule = function() {
    "use strict";

    var MIN_ELAPSED_TIME = 1,
        lastPlaybackQuality = null,
        currentDroppedFrames = -1,
        currentTotalVideoFrames = -1,

        getDroppedFrames = function(playbackQuality) {
            var elapsedTime;

            if (lastPlaybackQuality === null) {
                lastPlaybackQuality = playbackQuality;
                return;
            }

            // Check sufficient elapsed media time to determine frame rate
            elapsedTime = playbackQuality.mt - lastPlaybackQuality.mt;
            if (elapsedTime < MIN_ELAPSED_TIME) {
                return;
            }

            currentDroppedFrames = playbackQuality.droppedFrames - lastPlaybackQuality.droppedFrames;
            currentTotalVideoFrames = playbackQuality.totalVideoFrames - lastPlaybackQuality.totalVideoFrames;

            lastPlaybackQuality = playbackQuality;
        };

    return {
        debug: undefined,
        metricsExt: undefined,
        manifestModel: undefined,
        config: undefined,

        name: "DroppedFramesRule",

        checkIndex: function(current, metrics, data, playerState) {
            var droppedFramesMaxRatio = this.config.getParamFor(data.type, "ABR.droppedFramesMaxRatio", "number", 0.30),
                droppedFramesMinRatio = this.config.getParamFor(data.type, "ABR.droppedFramesMinRatio", "number", 0.10),
                playbackQuality = this.metricsExt.getCurrentPlaybackQuality(metrics),
                q = MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE,
                p = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT,
                ratio;

            if (data === null) {
                return new MediaPlayer.rules.SwitchRequest();
            }

            if (data.type !== "video") {
                return new MediaPlayer.rules.SwitchRequest();
            }

            if (playbackQuality === null) {
                // No PlaybackQuality metric => start of a new stream => reset lastPlaybackQuality
                lastPlaybackQuality = null;
                currentDroppedFrames = currentTotalVideoFrames = -1;
                return new MediaPlayer.rules.SwitchRequest();
            }

            // Check if we start buffering the stream. In this case we ignore the rule and reset lastPlaybackQuality
            if (playerState === 'buffering') {
                lastPlaybackQuality = null;
                currentDroppedFrames = currentTotalVideoFrames = -1;
                return new MediaPlayer.rules.SwitchRequest();
            }

            //this.debug.info("[DroppedFramesRule]["+data.type+"] PlaybackQuality = " + JSON.stringify(playbackQuality));

            // Determine number of dropped frames and fps
            getDroppedFrames(playbackQuality);

            if (currentDroppedFrames === -1) {
                return new MediaPlayer.rules.SwitchRequest();
            }

            ratio = currentDroppedFrames / currentTotalVideoFrames;

            this.debug.info("[DroppedFramesRule]["+data.type+"] DroppedFrames:" + currentDroppedFrames + ", totalVideoFrames:" + currentTotalVideoFrames + " => ratio = " + ratio);

            if (ratio > droppedFramesMaxRatio && current > 0) {
                // If too much dropped frames, then switch to lower representation
                q = current - 1;
                p = MediaPlayer.rules.SwitchRequest.prototype.STRONG;
            } else if (ratio > droppedFramesMinRatio) {
                // Still some dropped frames, then stay at current quality
                q = current;
                p = MediaPlayer.rules.SwitchRequest.prototype.STRONG;
            }

            this.debug.info("[DroppedFramesRule][" + data.type + "] SwitchRequest: q=" + q + ", p=" + p);

            return new MediaPlayer.rules.SwitchRequest(q, p);
        }
    };
};

MediaPlayer.rules.DroppedFramesRule.prototype = {
    constructor: MediaPlayer.rules.DroppedFramesRule
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.InsufficientBufferRule = function() {
    "use strict";

    return {
        debug: undefined,
        manifestExt: undefined,
        metricsExt: undefined,
        manifestModel: undefined,
        config: undefined,
        isStartBuffering: {},

        name: "InsufficientBufferRule",

        checkIndex: function(current, metrics, data, playerState) {
            var self = this,
                bufferLevel = self.metricsExt.getCurrentBufferLevel(metrics),
                minBufferTime,
                switchLowerBufferRatio,
                switchLowerBufferTime,
                switchDownBufferRatio,
                switchDownBufferTime,
                switchUpBufferRatio,
                switchUpBufferTime,
                mpd,
                q = current,
                p = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT;


            if (data === null) {
                return new MediaPlayer.rules.SwitchRequest();
            }

            // Check if we start buffering the stream. In this case we ignore the rule
            if (playerState === 'buffering') {
                self.isStartBuffering[data.type] = true;
            }

            if (bufferLevel === null) {
                return new MediaPlayer.rules.SwitchRequest();
            }

            self.debug.info("[InsufficientBufferRule][" + data.type + "] Checking buffer level ... (current = " + current +
                ", buffer level = " + (Math.round(bufferLevel.level * 100) / 100) +
                ", buffering = " + self.isStartBuffering[data.type] + ")");


            mpd = self.manifestExt.getMpd(self.manifestModel.getValue());
            if (mpd) {
                minBufferTime = self.config.getParamFor(data.type, "BufferController.minBufferTime", "number", mpd.manifest.minBufferTime);
                switchLowerBufferRatio = self.config.getParamFor(data.type, "ABR.switchLowerBufferRatio", "number", 0.25);
                switchLowerBufferTime = self.config.getParamFor(data.type, "ABR.switchLowerBufferTime", "number", switchLowerBufferRatio * minBufferTime);
                switchDownBufferRatio = self.config.getParamFor(data.type, "ABR.switchDownBufferRatio", "number", 0.5);
                switchDownBufferTime = self.config.getParamFor(data.type, "ABR.switchDownBufferTime", "number", switchDownBufferRatio * minBufferTime);
                switchUpBufferRatio = self.config.getParamFor(data.type, "ABR.switchUpBufferRatio", "number", 0.75);
                switchUpBufferTime = self.config.getParamFor(data.type, "ABR.switchUpBufferTime", "number", switchUpBufferRatio * minBufferTime);

                if ((bufferLevel.level < switchDownBufferTime) && (self.isStartBuffering[data.type])) {
                    return new MediaPlayer.rules.SwitchRequest();
                } else {
                    if (bufferLevel.level >= switchDownBufferTime) {
                        self.isStartBuffering[data.type] = false;
                    }

                    var max = self.manifestExt.getRepresentationCount(data);

                    max -= 1; // 0 based

                    if (bufferLevel.level <= switchLowerBufferTime) {
                        q = 0;
                        p = MediaPlayer.rules.SwitchRequest.prototype.STRONG;
                    } else if (bufferLevel.level <= switchDownBufferTime) {
                        q = (current > 0) ? (current - 1) : 0;
                        p = MediaPlayer.rules.SwitchRequest.prototype.DEFAULT;
                    }

                    self.debug.info("[InsufficientBufferRule][" + data.type + "] SwitchRequest: q=" + q + ", p=" + p);
                    return new MediaPlayer.rules.SwitchRequest(q, p);

                }
            } else {
                self.debug.log("[InsufficientBufferRule][" + data.type + "] Manifest not present yet");
                return new MediaPlayer.rules.SwitchRequest();
            }
        }
    };
};

MediaPlayer.rules.InsufficientBufferRule.prototype = {
    constructor: MediaPlayer.rules.OInsufficientBufferRule
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.LimitSwitchesRule = function () {
    "use strict";

    /*
     * This rule is intended to limit the number of switches that can happen.
     * We might get into a situation where there quality is bouncing around a ton.
     * This can create an unpleasant experience, so let the stream settle down.
     */

    var MAX_SWITCHES = 10,
        VALIDATION_TIME = 20000,
        WAIT_COUNT = 5,
        waiting = 0;

    return {
        debug: undefined,

        name: "LimitSwitchesRule",

        checkIndex: function (current, metrics /*, data*/) {
            if (waiting > 0) {
                waiting -= 1;
                return new MediaPlayer.rules.SwitchRequest(current, MediaPlayer.rules.SwitchRequest.prototype.STRONG);
            }

            var self = this,
                panic = false,
                rs,
                now = new Date().getTime(),
                delay,
                i,
                numSwitches = metrics.RepSwitchList.length;

            //self.debug.log("Checking limit switches rule...");

            for (i = numSwitches - 1; i >= 0; i -= 1) {
                rs = metrics.RepSwitchList[i];
                delay = now - rs.t.getTime();

                if (delay >= VALIDATION_TIME) {
                    self.debug.log("Reached time limit, bailing.");
                    break;
                }

                if (i >= MAX_SWITCHES) {
                    self.debug.log("Found too many switches within validation time, force the stream to not change.");
                    panic = true;
                    break;
                }
            }

            if (panic) {
                self.debug.log("Wait some time before allowing another switch.");
                waiting = WAIT_COUNT;
                return new MediaPlayer.rules.SwitchRequest(current, MediaPlayer.rules.SwitchRequest.prototype.STRONG);
            } else {
                return new MediaPlayer.rules.SwitchRequest(MediaPlayer.rules.SwitchRequest.prototype.NO_CHANGE, MediaPlayer.rules.SwitchRequest.prototype.STRONG);
            }
        }
    };
};

MediaPlayer.rules.LimitSwitchesRule.prototype = {
    constructor: MediaPlayer.rules.LimitSwitchesRule
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.rules.SwitchRequest = function (q, p) {
    "use strict";
    this.quality = q;
    this.priority = p;

    if (this.quality === undefined) {
        this.quality = 999;
    }

    if (this.priority === undefined) {
        this.priority = 0.5;
    }
};

MediaPlayer.rules.SwitchRequest.prototype = {
    constructor: MediaPlayer.rules.SwitchRequest,
    NO_CHANGE: 999,
    DEFAULT: 0.5,
    STRONG: 1,
    WEAK: 0
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.Error = function (code, message, data) {
    "use strict";
    this.code = code || null;
    this.message = message || null;
    this.data = data || null;
};

MediaPlayer.vo.Error.prototype = {
    constructor: MediaPlayer.vo.Error
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.Event = function () {
    "use strict";
    this.type = null; // event type/name. mandatory
    this.sender = null; // object that fires an event. mandatory
    this.data = null; // object that contains additional information about the event. optional
    this.error = null; // error object. optional
    this.timestamp = NaN; // timestamp. mandatory
};

MediaPlayer.vo.Event.prototype = {
    constructor: MediaPlayer.vo.Event
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.models.MetricsList = function () {
    "use strict";

    return {
        TcpList: [],
        HttpList: [],
        RepSwitchList: [],
        BufferedSwitchList:[],
        BufferLevel: [],
        PlayList: [],
        DroppedFrames: [],
        PlaybackQuality: [],
        VideoResolution: [],
        DVRInfo: [],
        ManifestUpdate: []
    };
};

MediaPlayer.models.MetricsList.prototype = {
    constructor: MediaPlayer.models.MetricsList
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.Mp4Track = function () {
    "use strict";

    this.type = 'und';
    this.trackId = 0;
    this.timescale = 0;
    this.duration = 0;
    this.codecs = "";
    this.codecPrivateData = "";
    this.bandwidth = "";

    // Video related fields
    this.width = 0;
    this.height = 0;

    // Audio related fields
    this.language = 'und';
    this.channels = 0;
    this.samplingRate = 0;

    // Content protection
    this.contentProtection = undefined;

    // Samples description and data
    this.samples = [];
    this.data = null;
};

MediaPlayer.vo.Mp4Track.prototype = {
    constructor: MediaPlayer.vo.Mp4Track
};


MediaPlayer.vo.Mp4Track.Sample = function () {
    "use strict";

    this.dts = 0;
    this.cts = 0;
    this.duration = 0;
    this.flags = 0;
    this.data = null;
    this.size = 0;
};

MediaPlayer.vo.Mp4Track.Sample.prototype = {
    constructor: MediaPlayer.vo.Mp4Track.Sample
};


/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.SegmentRequest = function () {
    "use strict";
    this.action = "download";
    this.startTime = NaN;
    this.streamType = null;
    this.type = null;
    this.duration = NaN;
    this.timescale = NaN;
    this.range = null;
    this.url = null;
    this.requestStartDate = null;
    this.firstByteDate = null;
    this.requestEndDate = null;
    this.deferred = null;
    this.quality = NaN;
    this.index = NaN;
    this.availabilityStartTime = null;
    this.availabilityEndTime = null;
    this.wallStartTime = null;
};

MediaPlayer.vo.SegmentRequest.prototype = {
    constructor: MediaPlayer.vo.SegmentRequest,
    ACTION_DOWNLOAD: "download",
    ACTION_COMPLETE: "complete"
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.URIFragmentData = function () {
    "use strict";
    this.t = null;
    this.xywh = null;
    this.track = null;
    this.id = null;
    this.s = null;
};

MediaPlayer.vo.URIFragmentData.prototype = {
    constructor: MediaPlayer.vo.URIFragmentData
};


/*
    From Spec http://www.w3.org/TR/media-frags/

    temporal (t)     - This dimension denotes a specific time range in the original media, such as "starting at second 10, continuing until second 20";
    spatial  (xywh)  - this dimension denotes a specific range of pixels in the original media, such as "a rectangle with size (100,100) with its top-left at coordinate (10,10)";
                       Media fragments support also addressing the media along two additional dimensions (in the advanced version defined in Media Fragments 1.0 URI (advanced)):
    track    (track) - this dimension denotes one or more tracks in the original media, such as "the english audio and the video track";
    id       (id)    - this dimension denotes a named temporal fragment within the original media, such as "chapter 2", and can be seen as a convenient way of specifying a temporal fragment.


    ## Note
    Akamai is purposing to add #s=X to the ISO standard.
        - (X) Value would be a start time to seek to at startup instead of starting at 0 or live edge
        - Allows for seeking back before the start time unlike a temporal clipping.
*/
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.BufferLevel = function () {
    "use strict";

    this.t = null;      // Real-Time | Time of the measurement of the buffer level.
    this.level = null;  // Level of the buffer in milliseconds. Indicates the playout duration for which media data of all active media components is available starting from the current playout time.
};

MediaPlayer.vo.metrics.BufferLevel.prototype = {
    constructor: MediaPlayer.vo.metrics.BufferLevel
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.BufferedSwitch = function () {
    "use strict";

    this.mt = null;     // Media-Time | The media presentation time of the earliest access unit (out of all media content components) played out from the Representation.
    this.to = null;     // value of Representation@id identifying the switch-to Representation.
    this.lto = null;    // If not present, this metrics concerns the Representation as a whole. If present, lto indicates the value of SubRepresentation@level within Representation identifying the switch-to level of the Representation.
};

MediaPlayer.vo.metrics.BufferedSwitch.prototype = {
    constructor: MediaPlayer.vo.metrics.BufferedSwitch
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.Condition = function () {
    "use strict";

    this.isFullScreen = null;
    this.windowSize = null;
    this.droppedFrames = null;
    this.fps = null;
    this.bandwidth = null;
};

MediaPlayer.vo.metrics.Condition.prototype = {
    constructor: MediaPlayer.vo.metrics.Condition
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Akamai Technologies
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.DVRInfo = function () {
    "use strict";

    this.time = null;   // Time of the measurement of the DVR info
    this.range = null;  // DVR range
};

MediaPlayer.vo.metrics.DVRInfo.prototype = {
    constructor: MediaPlayer.vo.metrics.DVRInfo
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.DroppedFrames = function () {
    "use strict";

    this.time = null;      // Real-Time | Time of the measurement of the dropped frames.
    this.droppedFrames = null;  // Number of dropped frames.
};

MediaPlayer.vo.metrics.DroppedFrames.prototype = {
    constructor: MediaPlayer.vo.metrics.DroppedFrames
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.HTTPRequest = function () {
    "use strict";

    this.stream = null;         // type of stream ("audio" | "video" etc..)
    this.tcpid = null;          // Identifier of the TCP connection on which the HTTP request was sent.
    this.type = null;           // This is an optional parameter and should not be included in HTTP request/response transactions for progressive download.
                                    // The type of the request:
                                    // - MPD
                                    // - XLink expansion
                                    // - Initialization Segment
                                    // - Index Segment
                                    // - Media Segment
                                    // - Bitstream Switching Segment
                                    // - other
    this.url = null;            // The original URL (before any redirects or failures)
    this.actualurl = null;      // The actual URL requested, if different from above
    this.range = null;          // The contents of the byte-range-spec part of the HTTP Range header.
    this.trequest = null;       // Real-Time | The real time at which the request was sent.
    this.tresponse = null;      // Real-Time | The real time at which the first byte of the response was received.
    this.tfinish = null;        // Real-Time | The real time at which the request finshed.
    this.responsecode = null;   // The HTTP response code.
    this.interval = null;       // The duration of the throughput trace intervals (ms), for successful requests only.
    this.mediaduration = null;  // The duration of the media requests, if available, in milliseconds.
    this.trace = [];            // Throughput traces, for successful requests only.
    this.startTime = null;      // the media start time of the segment
    this.quality = null;        // the quality index of the segment
    this.bytesLength = null;    // the segment bytes length
};

MediaPlayer.vo.metrics.HTTPRequest.prototype = {
    constructor: MediaPlayer.vo.metrics.HTTPRequest
};

MediaPlayer.vo.metrics.HTTPRequest.Trace = function () {
    "use strict";

    /*
     * s - Real-Time | Measurement period start.
     * d - Measurement period duration (ms).
     * b - List of integers counting the bytes received in each trace interval within the measurement period.
     */
    this.s = null;
    this.d = null;
    this.b = [];
};

MediaPlayer.vo.metrics.HTTPRequest.Trace.prototype = {
    constructor : MediaPlayer.vo.metrics.HTTPRequest.Trace
};

MediaPlayer.vo.metrics.ManifestUpdate = function () {
    "use strict";

    this.streamType = null;
    this.type = null;                       // static|dynamic
    this.requestTime = null;                // when this manifest update was requested
    this.fetchTime = null;                  // when this manifest update was received
    this.availabilityStartTime = null;
    this.presentationStartTime = 0;      // the seek point (liveEdge for dynamic, Period[0].startTime for static)
    this.clientTimeOffset = 0;           // the calculated difference between the server and client wall clock time
    this.currentTime = null;                // actual element.currentTime
    this.buffered = null;                   // actual element.ranges
    this.latency = 0;                       // (static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - elementCurrentTime)
    this.periodInfo = [];
    this.representationInfo = [];
};

MediaPlayer.vo.metrics.ManifestUpdate.PeriodInfo = function () {
    "use strict";

    this.id = null;         // Period@id
    this.index = null;
    this.start = null;      // Period@start
    this.duration = null;   // Period@duration
};

MediaPlayer.vo.metrics.ManifestUpdate.RepresentationInfo = function () {
    "use strict";

    this.id = null;                         // Representation@id
    this.index = null;
    this.streamType = null;
    this.periodIndex = null;
    this.presentationTimeOffset = null;     // @presentationTimeOffset
    this.startNumber = null;                // @startNumber
    this.segmentInfoType = null;            // list|template|timeline
};

MediaPlayer.vo.metrics.ManifestUpdate.prototype = {
    constructor: MediaPlayer.vo.metrics.ManifestUpdate
};

MediaPlayer.vo.metrics.ManifestUpdate.PeriodInfo.prototype = {
    constructor: MediaPlayer.vo.metrics.ManifestUpdate.PeriodInfo
};

MediaPlayer.vo.metrics.ManifestUpdate.RepresentationInfo.prototype = {
    constructor: MediaPlayer.vo.metrics.ManifestUpdate.RepresentationInfo
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.PlayList = function () {
    "use strict";

    this.stream = null;     // type of stream ("audio" | "video" etc..)
    this.start = null;      // Real-Time | Timestamp of the user action that starts the playback period...
    this.mstart = null;     // Media-Time | Presentation time at which playout was requested by the user...
    this.starttype = null;  // Type of user action which triggered playout
                            //      - New playout request (e.g. initial playout or seeking)
                            //      - Resume from pause
                            //        - Other user request (e.g. user-requested quality change)
                            //        - Start of a metrics collection period (hence earlier entries in the play list not collected)
    this.trace = [];        // List of periods of continuous rendering of decoded samples.
};

MediaPlayer.vo.metrics.PlayList.Trace = function () {
    "use strict";

    /*
     * representationid - The value of the Representation@id of the Representation from which the samples were taken.
     * subreplevel      - If not present, this metrics concerns the Representation as a whole. If present, subreplevel indicates the greatest value of any Subrepresentation@level being rendered.
     * start            - Real-Time | The time at which the first sample was rendered.
     * mstart           - Media-Time | The presentation time of the first sample rendered.
     * duration         - The duration of the continuously presented samples (which is the same in real time and media time). ―Continuously presented‖ means that the media clock continued to advance at the playout speed throughout the interval.
     * playbackspeed    - The playback speed relative to normal playback speed (i.e.normal forward playback speed is 1.0).
     * stopreason       - The reason why continuous presentation of this Representation was stopped.
     *                    Either:
     *                    representation switch
     *                    rebuffering
     *                    user request
     *                    end of Period
     *                    end of content
     *                    end of a metrics collection period
     */
    this.representationid = null;
    this.subreplevel = null;
    this.start = null;
    this.mstart = null;
    this.duration = null;
    this.playbackspeed = null;
    this.stopreason = null;
};

MediaPlayer.vo.metrics.PlayList.prototype = {
    constructor: MediaPlayer.vo.metrics.PlayList
};

/* Public Static Constants */
MediaPlayer.vo.metrics.PlayList.INITIAL_PLAY_START_REASON = "initial_start";
MediaPlayer.vo.metrics.PlayList.SEEK_START_REASON = "seek";

MediaPlayer.vo.metrics.PlayList.Trace.prototype = {
    constructor: MediaPlayer.vo.metrics.PlayList.Trace()
};

/* Public Static Constants */
MediaPlayer.vo.metrics.PlayList.Trace.USER_REQUEST_STOP_REASON = "user_request";
MediaPlayer.vo.metrics.PlayList.Trace.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch";
MediaPlayer.vo.metrics.PlayList.Trace.END_OF_CONTENT_STOP_REASON = "end_of_content";
MediaPlayer.vo.metrics.PlayList.Trace.REBUFFERING_REASON = "rebuffering";
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.PlaybackQuality = function () {
    "use strict";

    this.t = null;                  // Real-Time | Time of the measurement of the playback quality
    this.mt = null;                 // Media-Time | Media presentation time of the measurement of the playback quality
    this.droppedFrames = null;      // Number of dropped frames
    this.totalVideoFrames = null;   // Number of decoded video frames
};

MediaPlayer.vo.metrics.PlaybackQuality.prototype = {
    constructor: MediaPlayer.vo.metrics.PlaybackQuality
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.RepresentationSwitch = function () {
    "use strict";

    this.t = null;      // Real-Time | Time of the switch event.
    this.mt = null;     // Media-Time | The media presentation time of the earliest access unit (out of all media content components) played out from the Representation.
    this.to = null;     // value of Representation@id identifying the switch-to Representation.
    this.lto = null;    // If not present, this metrics concerns the Representation as a whole. If present, lto indicates the value of SubRepresentation@level within Representation identifying the switch-to level of the Representation.
};

MediaPlayer.vo.metrics.RepresentationSwitch.prototype = {
    constructor: MediaPlayer.vo.metrics.RepresentationSwitch
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.Session = function () {
    "use strict";

    this.uri = null;
    this.loopMode = null;
    this.endTime = null;
    this.playerType = null;
};

MediaPlayer.vo.metrics.Session.prototype = {
    constructor: MediaPlayer.vo.metrics.Session
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.State = function () {
    "use strict";

    this.t = null;      // Real-Time | Time of the event.
    this.current = null;    // current state
    this.position = null;    // position in the stream
    this.reason = null;
};

MediaPlayer.vo.metrics.State.prototype = {
    constructor: MediaPlayer.vo.metrics.State
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.TCPConnection = function () {
    "use strict";

    this.tcpid = null;      // Identifier of the TCP connection on which the HTTP request was sent.
    this.dest = null;       // IP Address of the interface over which the client is receiving the TCP data.
    this.topen = null;      // Real-Time | The time at which the connection was opened (sending time of the initial SYN or connect socket operation).
    this.tclose = null;     // Real-Time | The time at which the connection was closed (sending or reception time of FIN or RST or close socket operation).
    this.tconnect = null;   // Connect time in ms (time from sending the initial SYN to receiving the ACK or completion of the connect socket operation).
};

MediaPlayer.vo.metrics.TCPConnection.prototype = {
    constructor: MediaPlayer.vo.metrics.TCPConnection
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.vo.metrics.VideoResolution = function () {
    "use strict";

    this.t = null;      // Real-Time | Time of the event.
    this.mt = null;     // Media-Time | Media presentation time of the measurement of the video resolution
    this.width = null;  // video width
    this.height = null; // video height
};

MediaPlayer.vo.metrics.VideoResolution.prototype = {
    constructor: MediaPlayer.vo.metrics.VideoResolution
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/*jshint -W020 */
Dash = (function () {
    "use strict";

    return {
        modules: {},
        dependencies: {},
        vo: {},
        di: {}
    };
}());
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.BaseURLExtensions = function () {
    "use strict";

        // From YouTube player.  Reformatted for JSLint.
    var parseSIDX = function (ab, ab_first_byte_offset) {
            var d = new DataView(ab),
                sidx = {},
                pos = 0,
                offset,
                time,
                sidxEnd,
                i,
                ref_type,
                ref_size,
                ref_dur,
                type,
                size,
                charCode;

            while (type !== "sidx" && pos < d.byteLength) {
                size = d.getUint32(pos); // subtract 8 for including the size and type
                pos += 4;

                type = "";
                for (i = 0; i < 4; i += 1) {
                    charCode = d.getInt8(pos);
                    type += String.fromCharCode(charCode);
                    pos += 1;
                }

                if (type !== "moof" && type !== "traf" && type !== "sidx") {
                    pos += size - 8;
                } else if (type === "sidx") {
                    // reset the position to the beginning of the box...
                    // if we do not reset the position, the evaluation
                    // of sidxEnd to ab.byteLength will fail.
                    pos -= 8;
                }
            }

            sidxEnd = d.getUint32(pos, false) + pos;
            if (sidxEnd > ab.byteLength) {
                throw "sidx terminates after array buffer";
            }

            sidx.version = d.getUint8(pos + 8);
            pos += 12;

            // skipped reference_ID(32)
            sidx.timescale = d.getUint32(pos + 4, false);
            pos += 8;

            if (sidx.version === 0) {
                sidx.earliest_presentation_time = d.getUint32(pos, false);
                sidx.first_offset = d.getUint32(pos + 4, false);
                pos += 8;
            } else {
                // TODO(strobe): Overflow checks
                sidx.earliest_presentation_time = utils.Math.to64BitNumber(d.getUint32(pos + 4, false), d.getUint32(pos, false));
                //first_offset = utils.Math.to64BitNumber(d.getUint32(pos + 8, false), d.getUint32(pos + 12, false));
                sidx.first_offset = (d.getUint32(pos + 8, false) << 32) + d.getUint32(pos + 12, false);
                pos += 16;
            }

            sidx.first_offset += sidxEnd + (ab_first_byte_offset || 0);

            // skipped reserved(16)
            sidx.reference_count = d.getUint16(pos + 2, false);
            pos += 4;

            sidx.references = [];
            offset = sidx.first_offset;
            time = sidx.earliest_presentation_time;

            for (i = 0; i < sidx.reference_count; i += 1) {
                ref_size = d.getUint32(pos, false);
                ref_type = (ref_size >>> 31);
                ref_size = ref_size & 0x7fffffff;
                ref_dur = d.getUint32(pos + 4, false);
                pos += 12;
                sidx.references.push({
                    'size': ref_size,
                    'type': ref_type,
                    'offset': offset,
                    'duration': ref_dur,
                    'time': time,
                    'timescale': sidx.timescale
                });
                offset += ref_size;
                time += ref_dur;
            }

            if (pos !== sidxEnd) {
                throw "Error: final pos " + pos + " differs from SIDX end " + sidxEnd;
            }

            return sidx;
        },

        parseSegments = function (data, media, offset) {
            var parsed,
                ref,
                segments,
                segment,
                i,
                len,
                start,
                end;

            parsed = parseSIDX.call(this, data, offset);
            ref = parsed.references;
            segments = [];

            for (i = 0, len = ref.length; i < len; i += 1) {
                segment = new Dash.vo.Segment();
                segment.duration = ref[i].duration;
                segment.media = media;
                segment.startTime = ref[i].time;
                segment.timescale = ref[i].timescale;

                start = ref[i].offset;
                end = ref[i].offset + ref[i].size - 1;
                segment.mediaRange = start + "-" + end;

                segments.push(segment);
            }

            this.debug.log("Parsed SIDX box: " + segments.length + " segments.");
            return segments;
        },

        findInit = function (data, info) {
            var deferred = Q.defer(),
                ftyp,
                moov,
                start,
                end,
                d = new DataView(data),
                pos = 0,
                type = "",
                size = 0,
                bytesAvailable,
                i,
                c,
                request,
                loaded = false,
                irange,
                self = this;

            self.debug.log("Searching for initialization.");

            while (type !== "moov" && pos < d.byteLength) {
                size = d.getUint32(pos); // subtract 8 for including the size and type
                pos += 4;

                type = "";
                for (i = 0; i < 4; i += 1) {
                    c = d.getInt8(pos);
                    type += String.fromCharCode(c);
                    pos += 1;
                }

                if (type === "ftyp") {
                    ftyp = pos - 8;
                }
                if (type === "moov") {
                    moov = pos - 8;
                }
                if (type !== "moov") {
                    pos += size - 8;
                }
            }

            bytesAvailable = d.byteLength - pos;

            if (type !== "moov") {
                // Case 1
                // We didn't download enough bytes to find the moov.
                // TODO : Load more bytes.
                //        Be sure to detect EOF.
                //        Throw error is no moov is found in the entire file.
                //        Protection from loading the entire file?
                self.debug.log("Loading more bytes to find initialization.");
                info.range.start = 0;
                info.range.end = info.bytesLoaded + info.bytesToLoad;

                request = new XMLHttpRequest();

                request.onloadend = function () {
                    if (!loaded) {
                        deferred.reject("Error loading initialization.");
                    }
                };

                request.onload = function () {
                    loaded = true;
                    info.bytesLoaded = info.range.end;
                    findInit.call(self, request.response).then(
                        function (segments) {
                            deferred.resolve(segments);
                        }
                    );
                };

                request.onerror = function () {
                    deferred.reject("Error loading initialization.");
                };
                // var req_ = new XMLHttpRequest();
                // req_.open("GET", '/signedUrl?src_='+self.tokenAuthentication.addTokenAsQueryArg(info.url), false);
                // req_.send(null);
                // var url_ = req_.responseText;
                // request.open("GET", url_);
                var url = self.tokenAuthentication.addTokenAsQueryArg(info.url);
               // console.log("findInit");
            
                //console.log(request);
                var value ="XMLHttpPlayerRequest-"+"bytes=" + info.range.start + "-" + info.range.end;
                //console.log(value);
                request.open("GET", '/get_video_content?video_url='+url);
                request.setRequestHeader("X-Requested-With", value);


                request.responseType = "arraybuffer";
                request.setRequestHeader("Range", "bytes=" + info.range.start + "-" + info.range.end);
                request = self.tokenAuthentication.setTokenInRequestHeader(request);

                //console.log('This is for Range');
                request.withCredentials = true;
                // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
                request.send(null);
                // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // //console.log($.cookie('CloudFront-Signature'));
            } else {
                // Case 2
                // We have the entire range, so continue.
                start = ftyp === undefined ? moov : ftyp;
                end = moov + size - 1;
                irange = start + "-" + end;

                self.debug.log("Found the initialization.  Range: " + irange);
                deferred.resolve(irange);
            }

            return deferred.promise;
        },

        loadInit = function (media) {
            var deferred = Q.defer(),
                request = new XMLHttpRequest(),
                needFailureReport = true,
                self = this,
                info = {
                    url: media,
                    range: {},
                    searching: false,
                    bytesLoaded: 0,
                    bytesToLoad: 1500,
                    request: request
                };

            self.debug.log("Start searching for initialization.");
            info.range.start = 0;
            info.range.end = info.bytesToLoad;

            request.onload = function () {
                if (request.status < 200 || request.status > 299)
                {
                  return;
                }
                needFailureReport = false;

                info.bytesLoaded = info.range.end;
                findInit.call(self, request.response, info).then(
                    function (range) {
                        deferred.resolve(range);
                    },function(){
                        deferred.reject();
                    }
                );
            };

            request.onloadend = request.onerror = function () {
                if (!needFailureReport)
                {
                  return;
                }
                needFailureReport = false;

                var data = {};
                data.url = info.url;
                data.request = request;

                self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_INIT, null, data);
                deferred.reject(request);
            };
            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+self.tokenAuthentication.addTokenAsQueryArg(info.url), false);
           //console.log("loadInit");
            
            //console.log(request);

            var url = self.tokenAuthentication.addTokenAsQueryArg(info.url);
            request.open("GET", '/get_video_content?video_url='+url);
            // request.setRequestHeader("X-Requested-With", "XMLHttpPlayerRequest=");
            var value ="XMLHttpPlayerRequest-"+"bytes=" + info.range.start + "-" + info.range.end;
            //console.log(value);
            request.setRequestHeader("X-Requested-With",value);

            // req_.send(null);
            // var url_ = req_.responseText;
            // request.open("GET", url_);
            request.responseType = "arraybuffer";
            request.setRequestHeader("Range", "bytes=" + info.range.start + "-" + info.range.end);
            request = self.tokenAuthentication.setTokenInRequestHeader(request);
            //console.log('This is also for Range');
            request.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            request.send(null);
            // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // //console.log($.cookie('CloudFront-Signature'));
            self.debug.log("Perform init search: " + info.url);

            return deferred.promise;
        },

        findSIDX = function (data, info) {
            var deferred = Q.defer(),
                d = new DataView(data),
                request = new XMLHttpRequest(),
                pos = 0,
                type = "",
                size = 0,
                bytesAvailable,
                sidxBytes,
                sidxSlice,
                sidxOut,
                i,
                c,
                needFailureReport = true,
                parsed,
                ref,
                loadMultiSidx = false,
                self = this;

            self.debug.log("Searching for SIDX box.");
            self.debug.log(info.bytesLoaded + " bytes loaded.");

            while (type !== "sidx" && pos < d.byteLength) {
                size = d.getUint32(pos); // subtract 8 for including the size and type
                pos += 4;

                type = "";
                for (i = 0; i < 4; i += 1) {
                    c = d.getInt8(pos);
                    type += String.fromCharCode(c);
                    pos += 1;
                }

                if (type !== "sidx") {
                    pos += size - 8;
                }
            }

            bytesAvailable = d.byteLength - pos;

            if (type !== "sidx") {
                // Case 1
                // We didn't download enough bytes to find the sidx.
                // TODO : Load more bytes.
                //        Be sure to detect EOF.
                //        Throw error is no sidx is found in the entire file.
                //        Protection from loading the entire file?
                deferred.reject();
            } else if (bytesAvailable < (size - 8)) {
                // Case 2
                // We don't have the entire box.
                // Increase the number of bytes to read and load again.
                self.debug.log("Found SIDX but we don't have all of it.");

                info.range.start = 0;
                info.range.end = info.bytesLoaded + (size - bytesAvailable);

                request.onload = function () {
                    if (request.status < 200 || request.status > 299)
                    {
                      return;
                    }
                    needFailureReport = false;

                    info.bytesLoaded = info.range.end;
                    findSIDX.call(self, request.response, info).then(
                        function (segments) {
                            deferred.resolve(segments);
                        }
                    );
                };

                request.onloadend = request.onerror = function () {
                    if (!needFailureReport)
                    {
                      return;
                    }
                    needFailureReport = false;

                    var data = {};
                    data.url = info.url;
                    data.request = request;

                    self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_SIDX, null, data);
                    deferred.reject(request);
                };
                // var req_ = new XMLHttpRequest();
                // req_.open("GET", '/signedUrl?src_='+self.tokenAuthentication.addTokenAsQueryArg(info.url), false);
                // req_.send(null);

                //console.log("findSIDX");
            
                //console.log(request);
                var url = self.tokenAuthentication.addTokenAsQueryArg(info.url);
                request.open("GET", '/get_video_content?video_url='+url);
                var value ="XMLHttpPlayerRequest-"+"bytes=" + info.range.start + "-" + info.range.end;
            //console.log(value);
                request.setRequestHeader("X-Requested-With", value);

                // var url_ = req_.responseText;
                // request.open("GET", url_);

                request.responseType = "arraybuffer";
                request.setRequestHeader("Range", "bytes=" + info.range.start + "-" + info.range.end);
                request = self.tokenAuthentication.setTokenInRequestHeader(request);
                //console.log('Also for range');
                request.withCredentials = true;
                // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
                request.send(null);
                // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // //console.log($.cookie('CloudFront-Signature'));
            } else {
                // Case 3
                // We have the entire box, so parse it and continue.
                info.range.start = pos - 8;
                info.range.end = info.range.start + size;

                self.debug.log("Found the SIDX box.  Start: " + info.range.start + " | End: " + info.range.end);
//                sidxBytes = data.slice(info.range.start, info.range.end);
                sidxBytes = new ArrayBuffer(info.range.end - info.range.start);
                sidxOut = new Uint8Array(sidxBytes);
                sidxSlice = new Uint8Array(data, info.range.start, info.range.end - info.range.start);
                sidxOut.set(sidxSlice);

                parsed = this.parseSIDX.call(this, sidxBytes, info.range.start);

                // We need to check to see if we are loading multiple sidx.
                // For now just check the first reference and assume they are all the same.
                // TODO : Can the referenceTypes be mixed?
                // TODO : Load them all now, or do it as needed?

                ref = parsed.references;
                if (ref !== null && ref !== undefined && ref.length > 0) {
                    loadMultiSidx = (ref[0].type === 1);
                }

                if (loadMultiSidx) {
                    self.debug.log("Initiate multiple SIDX load.");

                    var j, len, ss, se, r, funcs = [], segs;

                    for (j = 0, len = ref.length; j < len; j += 1) {
                        ss = ref[j].offset;
                        se = ref[j].offset + ref[j].size - 1;
                        r = ss + "-" + se;

                        funcs.push(this.loadSegments.call(self, info.url, r));
                    }

                    Q.all(funcs).then(
                        function (results) {
                            segs = [];
                            for (j = 0, len = results.length; j < len; j += 1) {
                                segs = segs.concat(results[j]);
                            }
                            deferred.resolve(segs);
                        },
                        function (httprequest) {
                            deferred.reject(httprequest);
                        }
                    );

                } else {
                    self.debug.log("Parsing segments from SIDX.");
                    deferred.resolve(parseSegments.call(self, sidxBytes, info.url, info.range.start));
                }
            }

            return deferred.promise;
        },

        loadSegments = function (media, theRange) {
            var deferred = Q.defer(),
                request = new XMLHttpRequest(),
                parts,
                needFailureReport = true,
                self = this,
                info = {
                    url: media,
                    range: {},
                    searching: false,
                    bytesLoaded: 0,
                    bytesToLoad: 1500,
                    request: request
                };

            // We might not know exactly where the sidx box is.
            // Load the first n bytes (say 1500) and look for it.
            if (theRange === null) {
                self.debug.log("No known range for SIDX request.");
                info.searching = true;
                info.range.start = 0;
                info.range.end = info.bytesToLoad;
            } else {
                parts = theRange.split("-");
                info.range.start = parseFloat(parts[0]);
                info.range.end = parseFloat(parts[1]);
            }

            request.onload = function () {
                if (request.status < 200 || request.status > 299)
                {
                  return;
                }
                needFailureReport = false;
                // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
                // //console.log($.cookie('CloudFront-Signature'));

                // If we didn't know where the SIDX box was, we have to look for it.
                // Iterate over the data checking out the boxes to find it.
                if (info.searching) {
                    info.bytesLoaded = info.range.end;
                    findSIDX.call(self, request.response, info).then(
                        function (segments) {
                            deferred.resolve(segments);
                        }, function(){
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(parseSegments.call(self, request.response, info.url, info.range.start));
                }
            };

            request.onloadend = request.onerror = function () {
                if (!needFailureReport)
                {
                  return;
                }
                needFailureReport = false;

                var data = {};
                data.url = info.url;
                data.request = request;

                self.errHandler.sendError(MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_SIDX, null, data);
                deferred.reject(request);
            };
            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+self.tokenAuthentication.addTokenAsQueryArg(info.url), false);
            // req_.send(null);
            var url = self.tokenAuthentication.addTokenAsQueryArg(info.url);
            // var url_ = req_.responseText;

            // request.open("GET", url_);

            // console.log("loadSegments");
            // console.log("before header set");
            
            // console.log(request);
            // console.log(request.headers);
            // console.log(info.range.start + "-" + info.range.end);
            
            
            request.open("GET", '/get_video_content?video_url='+url);
            var value ="XMLHttpPlayerRequest-bytes=" + info.range.start + "-" + info.range.end;
            //console.log(value);
            
            request.setRequestHeader("X-Requested-With", value);

            request.responseType = "arraybuffer";
            request.setRequestHeader("Range", "bytes=" + info.range.start + "-" + info.range.end);
            request = self.tokenAuthentication.setTokenInRequestHeader(request);
            // console.log("after header set");
            // console.log("Load segments");
            // console.log(request);
            // console.log(request.headers);
            // console.log(info.range.start + "-" + info.range.end);
                        
            
            //console.log('Another Range Request');
            request.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            request.send(null);
            self.debug.log("Perform SIDX load: " + info.url);

            return deferred.promise;
        };

    return {
        debug: undefined,
        errHandler: undefined,
        tokenAuthentication:undefined,
        loadSegments: loadSegments,
        loadInitialization: loadInit,
        parseSegments: parseSegments,
        parseSIDX: parseSIDX,
        findSIDX: findSIDX
    };
};

Dash.dependencies.BaseURLExtensions.prototype = {
    constructor: Dash.dependencies.BaseURLExtensions
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.di.DashContext = function () {
    "use strict";

    return {
        system : undefined,
        setup : function () {
            Dash.di.DashContext.prototype.setup.call(this);

            this.system.mapClass('parser', Dash.dependencies.DashParser);
            this.system.mapClass('indexHandler', Dash.dependencies.DashHandler);
            this.system.mapClass('baseURLExt', Dash.dependencies.BaseURLExtensions);
            this.system.mapClass('fragmentExt', Dash.dependencies.FragmentExtensions);
            this.system.mapSingleton('manifestExt', Dash.dependencies.DashManifestExtensions);
            this.system.mapSingleton('metricsExt', Dash.dependencies.DashMetricsExtensions);
            this.system.mapSingleton('timelineConverter', Dash.dependencies.TimelineConverter);
        }
    };
};

Dash.di.DashContext.prototype = new MediaPlayer.di.Context();
Dash.di.DashContext.prototype.constructor = Dash.di.DashContext;

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.DashHandler = function() {
    "use strict";

    var index = -1,
        requestedTime = null,
        isDynamic,
        type,
        offset = null,

        zeroPadToLength = function(numStr, minStrLength) {
            while (numStr.length < minStrLength) {
                numStr = "0" + numStr;
            }

            return numStr;
        },

        replaceTokenForTemplate = function(url, token, value) {
            var startPos = 0,
                endPos = 0,
                tokenLen = token.length,
                formatTag = "%0",
                formatTagLen = formatTag.length,
                formatTagPos,
                specifier,
                width,
                paddedValue;

            // keep looping round until all instances of <token> have been
            // replaced. once that has happened, startPos below will be -1
            // and the completed url will be returned.
            while (true) {

                // check if there is a valid $<token>...$ identifier
                // if not, return the url as is.
                startPos = url.indexOf("$" + token);
                if (startPos < 0) {
                    return url;
                }

                // the next '$' must be the end of the identifer
                // if there isn't one, return the url as is.
                endPos = url.indexOf("$", startPos + tokenLen);
                if (endPos < 0) {
                    return url;
                }

                // now see if there is an additional format tag suffixed to
                // the identifier within the enclosing '$' characters
                formatTagPos = url.indexOf(formatTag, startPos + tokenLen);
                if (formatTagPos > startPos && formatTagPos < endPos) {

                    specifier = url.charAt(endPos - 1);
                    width = parseInt(url.substring(formatTagPos + formatTagLen, endPos - 1), 10);

                    // support the minimum specifiers required by IEEE 1003.1
                    // (d, i , o, u, x, and X) for completeness
                    switch (specifier) {
                        // treat all int types as uint,
                        // hence deliberate fallthrough
                        case 'd':
                        case 'i':
                        case 'u':
                            paddedValue = zeroPadToLength(value.toString(), width);
                            break;
                        case 'x':
                            paddedValue = zeroPadToLength(value.toString(16), width);
                            break;
                        case 'X':
                            paddedValue = zeroPadToLength(value.toString(16), width).toUpperCase();
                            break;
                        case 'o':
                            paddedValue = zeroPadToLength(value.toString(8), width);
                            break;
                        default:
                            this.debug.log("Unsupported/invalid IEEE 1003.1 format identifier string in URL");
                            return url;
                    }
                } else {
                    paddedValue = value;
                }

                url = url.substring(0, startPos) + paddedValue + url.substring(endPos + 1);
            }
        },

        unescapeDollarsInTemplate = function(url) {
            return url.split("$$").join("$");
        },

        replaceIDForTemplate = function(url, value) {
            if (value === null || url.indexOf("$RepresentationID$") === -1) {
                return url;
            }
            var v = value.toString();
            return url.split("$RepresentationID$").join(v);
        },

        getNumberForSegment = function(segment, segmentIndex) {
            return segment.representation.startNumber + segmentIndex;
        },

        getRequestUrl = function(destination, representation) {
            var baseURL = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].BaseURL,
            url;

            if (destination === baseURL) {
                url = destination;
            } else if ((destination.indexOf("http://") !== -1) || (destination.indexOf("https://") !== -1)) {
                url = destination;
            } else {
                url = baseURL + destination;
            }

            return url;
        },

        generateInitRequest = function(representation, streamType) {
            var self = this,
                period,
                request = new MediaPlayer.vo.SegmentRequest(),
                presentationStartTime;

            period = representation.adaptation.period;

            request.streamType = streamType;
            request.type = "Initialization Segment";
            request.url = getRequestUrl(representation.initialization, representation);
            request.range = representation.range;
            presentationStartTime = period.start;
            request.availabilityStartTime = self.timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime, representation.adaptation.period.mpd, isDynamic);
            request.availabilityEndTime = self.timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration, period.mpd, isDynamic);
            request.quality = representation.index;

            return request;
        },

        getInit = function(representation) {
            var deferred = Q.defer(),
                request = null,
                url = null,
                self = this;

            if (!representation) {
                return Q.reject("no represenation");
            }

            //self.debug.log("Getting the initialization request.");

            if (representation.initialization) {
                //self.debug.log("Got an initialization.");
                request = generateInitRequest.call(self, representation, type);
                deferred.resolve(request);
            } else {
                // Go out and find the initialization.
                url = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
                AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].BaseURL;
                self.baseURLExt.loadInitialization(url).then(
                    function(theRange) {
                        //self.debug.log("Got an initialization.");
                        representation.range = theRange;
                        representation.initialization = url;
                        request = generateInitRequest.call(self, representation, type);
                        deferred.resolve(request);
                    },
                    function(httprequest) {
                        deferred.reject(httprequest);
                    }
                );
            }

            return deferred.promise;
        },

        isMediaFinished = function(representation) { // TODO
            var sDuration,
                period = representation.adaptation.period,
                isFinished = false,
                seg,
                fTime;

            if (representation && representation.segments && representation.segments.length > 0 &&
                (offset === null || offset > representation.segments[0].availabilityIdx)) {
                offset = representation.segments[0].availabilityIdx;
            }

            //this.debug.log("Checking for stream end...");
            if (isDynamic) {
                //this.debug.log("Live never ends! (TODO)");
                // TODO : Check the contents of the last box to signal end.
                isFinished = false;
            } else {
                if (index < 0) {
                    isFinished = false;
                } else if (index < representation.availableSegmentsNumber + offset) {
                    seg = getSegmentByIndex(index, representation);

                    if (seg) {
                        fTime = seg.presentationStartTime - period.start;
                        sDuration = representation.adaptation.period.duration;
                        //this.debug.log(representation.segmentInfoType + ": " + fTime + " / " + sDuration);
                        isFinished = (fTime >= sDuration);
                    }
                } else {
                    isFinished = true;
                }
            }

            return isFinished;
        },

        getIndexBasedSegment = function(representation, index) {
            var self = this,
                seg,
                duration,
                presentationStartTime,
                presentationEndTime;

            duration = representation.segmentDuration;
            presentationStartTime = representation.adaptation.period.start + (index * duration);
            presentationEndTime = presentationStartTime + duration;

            seg = new Dash.vo.Segment();

            seg.representation = representation;
            seg.duration = duration;
            seg.presentationStartTime = presentationStartTime;

            seg.mediaStartTime = self.timelineConverter.calcMediaTimeFromPresentationTime(seg.presentationStartTime, representation);

            seg.availabilityStartTime = self.timelineConverter.calcAvailabilityStartTimeFromPresentationTime(seg.presentationStartTime, representation.adaptation.period.mpd, isDynamic);
            seg.availabilityEndTime = self.timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime, representation.adaptation.period.mpd, isDynamic);

            // at this wall clock time, the video element currentTime should be seg.presentationStartTime
            seg.wallStartTime = self.timelineConverter.calcWallTimeForSegment(seg, isDynamic);

            seg.replacementNumber = getNumberForSegment(seg, index);
            seg.availabilityIdx = index;

            //this.debug.log("[DashHandler]["+type+"] createSegment: time = " + seg.mediaStartTime + ", availabilityIdx = " + seg.availabilityIdx);

            return seg;
        },

        getSegmentsFromTimeline = function(representation) {
            var self = this,
                template = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate,
            timeline = template.SegmentTimeline,
            isAvailableSegmentNumberCalculated = representation.availableSegmentsNumber > 0,
            maxSegmentsAhead = 10,
            segments = [],
            fragments,
            frag,
            i,
            len,
            j,
            repeat,
            repeatEndTime,
            nextFrag,
            time = 0,
            availabilityIdx = -1,
            calculatedRange,
            hasEnoughSegments,
            requiredMediaTime,
            startIdx,
            endIdx,
            fTimescale,
            createSegment = function(s) {
                return getTimeBasedSegment.call(
                    self,
                    representation,
                    time,
                    s.d,
                    fTimescale,
                    template.media,
                    s.mediaRange,
                    availabilityIdx);
            };

            fTimescale = representation.timescale;

            fragments = timeline.S_asArray;

            calculatedRange = decideSegmentListRangeForTimeline.call(self, representation);

            // if calculatedRange exists we should generate segments that belong to this range.
            // Otherwise generate maxSegmentsAhead segments ahead of the requested time
            if (calculatedRange) {
                startIdx = calculatedRange.start;
                endIdx = calculatedRange.end;
            } else {
                requiredMediaTime = self.timelineConverter.calcMediaTimeFromPresentationTime(requestedTime || 0, representation);
            }

            for (i = 0, len = fragments.length; i < len; i += 1) {
                frag = fragments[i];
                repeat = 0;
                if (frag.hasOwnProperty("r")) {
                    repeat = frag.r;
                }

                //For a repeated S element, t belongs only to the first segment
                if (frag.hasOwnProperty("t")) {
                    time = frag.t;
                }

                //This is a special case: "A negative value of the @r attribute of the S element indicates that the duration indicated in @d attribute repeats until the start of the next S element, the end of the Period or until the
                // next MPD update."
                if (repeat < 0) {
                    nextFrag = fragments[i + 1];
                    repeatEndTime = (nextFrag && nextFrag.hasOwnProperty("t")) ? (nextFrag.t / fTimescale) : representation.adaptation.period.duration;
                    repeat = Math.ceil((repeatEndTime - time / fTimescale) / (frag.d / fTimescale)) - 1;
                }

                // if we have enough segments in the list, but we have not calculated the total number of the segments yet we
                // should continue the loop and calc the number. Once it is calculated, we can break the loop.
                if (hasEnoughSegments) {
                    if (isAvailableSegmentNumberCalculated) break;
                    availabilityIdx += repeat + 1;
                    continue;
                }

                for (j = 0; j <= repeat; j += 1) {
                    availabilityIdx += 1;

                    if (calculatedRange) {
                        if (availabilityIdx > endIdx) {
                            hasEnoughSegments = true;
                            if (isAvailableSegmentNumberCalculated) break;
                            continue;
                        }

                        if (availabilityIdx >= startIdx) {
                            segments.push(createSegment.call(self, frag));
                        }
                    } else {
                        if (segments.length > maxSegmentsAhead) {
                            hasEnoughSegments = true;
                            if (isAvailableSegmentNumberCalculated) break;
                            continue;
                        }

                        if (time / fTimescale >= (requiredMediaTime - (frag.d / fTimescale))) {
                            segments.push(createSegment.call(self, frag));
                        }
                    }

                    time += frag.d;
                }
            }

            if (!isAvailableSegmentNumberCalculated) {
                var availabilityStartTime,
                    availabilityEndTime,
                    f = fragments[0];

                availabilityStartTime = (f.t === undefined) ? 0 : self.timelineConverter.calcPresentationTimeFromMediaTime(f.t / fTimescale, representation);
                availabilityEndTime = self.timelineConverter.calcPresentationTimeFromMediaTime((time - frag.d) / fTimescale, representation);
                representation.segmentAvailabilityRange = {
                    start: availabilityStartTime,
                    end: availabilityEndTime
                };
                representation.availableSegmentsNumber = availabilityIdx + 1;
            }

            return Q.when(segments);
        },

        getSegmentsFromTemplate = function(representation) {
            var segments = [],
                self = this,
                deferred = Q.defer(),
                template = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate,
            duration = representation.segmentDuration,
            segmentRange = null,
            periodStartIdx = Math.floor(representation.adaptation.period.start / duration),
            i,
            startIdx,
            endIdx,
            seg = null,
            start,
            url = null;

            start = representation.startNumber;

            waitForAvailabilityWindow.call(self, representation).then(
                function(availabilityWindow) {
                    representation.segmentAvailabilityRange = availabilityWindow;
                    segmentRange = decideSegmentListRangeForTemplate.call(self, representation);

                    startIdx = segmentRange.start;
                    endIdx = segmentRange.end;

                    for (i = startIdx; i <= endIdx; i += 1) {

                        seg = getIndexBasedSegment.call(
                            self,
                            representation,
                            i - (isDynamic ? periodStartIdx : 0));

                        seg.replacementTime = (start + i - 1) * representation.segmentDuration;
                        url = template.media;
                        url = replaceTokenForTemplate(url, "Number", seg.replacementNumber);
                        url = replaceTokenForTemplate(url, "Time", seg.replacementTime);
                        seg.media = url;

                        segments.push(seg);
                        seg = null;
                    }

                    representation.availableSegmentsNumber = periodStartIdx + Math.ceil((availabilityWindow.end - availabilityWindow.start) / duration);

                    deferred.resolve(segments);
                }
            );

            return deferred.promise;
        },

        decideSegmentListRangeForTemplate = function(representation) {
            var self = this,
                periodStart = representation.adaptation.period.start,
                duration = representation.segmentDuration,
                minBufferTime = representation.adaptation.period.mpd.manifest.minBufferTime,
                availabilityWindow = representation.segmentAvailabilityRange,
                originAvailabilityTime = NaN,
                originSegment = null,
                currentSegmentList = representation.segments,
                availabilityLowerLimit = 2 * duration,
                availabilityUpperLimit = Math.max(2 * minBufferTime, 10 * duration),
                start,
                end,
                range;

            if (!availabilityWindow) {
                availabilityWindow = self.timelineConverter.calcSegmentAvailabilityRange(representation, isDynamic);
            }

            if (isDynamic && !representation.adaptation.period.mpd.isClientServerTimeSyncCompleted) {
                start = Math.floor(availabilityWindow.start / duration);
                end = Math.floor(availabilityWindow.end / duration);
                range = {
                    start: start,
                    end: end
                };
                return range;
            }

            // if segments exist we should try to find the latest buffered time, which is the presentation time of the
            // segment for the current index
            if (currentSegmentList) {
                originSegment = getSegmentByIndex(index, representation);
                originAvailabilityTime = originSegment ? (originSegment.presentationStartTime - periodStart) : (index > 0 ? (index * duration) : (requestedTime - periodStart) || (currentSegmentList[0].presentationStartTime - periodStart));
            } else {
                // If no segments exist, but index > 0, it means that we switch to the other representation, so
                // we should proceed from this time.
                // Otherwise we should start from the beginning for static mpds or from the end (live edge) for dynamic mpds
                originAvailabilityTime = (index > 0) ? (index * duration) : (isDynamic ? availabilityWindow.end : availabilityWindow.start);
            }

            // segment list should not be out of the availability window range
            start = Math.floor(Math.max(originAvailabilityTime - availabilityLowerLimit, availabilityWindow.start) / duration);
            end = Math.floor(Math.min(start + availabilityUpperLimit / duration, availabilityWindow.end / duration));

            range = {
                start: start,
                end: end
            };

            return range;
        },

        decideSegmentListRangeForTimeline = function(representation) {
            var originAvailabilityIdx = NaN,
                currentSegmentList = representation.segments,
                availabilityLowerLimit = 2,
                availabilityUpperLimit = 10,
                firstIdx = 0,
                lastIdx = Number.POSITIVE_INFINITY,
                start,
                end,
                range;

            if (isDynamic && !representation.adaptation.period.mpd.isClientServerTimeSyncCompleted) {
                range = {
                    start: firstIdx,
                    end: lastIdx
                };
                return range;
            }

            if (!isDynamic && requestedTime !== null) {
                return null;
            }

            // if segments exist use the current index as an origin index for a new range
            if (currentSegmentList) {
                // if the index is negative we can't calculate the range right now
                if (index < 0) {
                    return null;
                }
                originAvailabilityIdx = index;
            } else {
                // If no segments exist, but index > 0, it means that we switch to the other representation, so
                // we should proceed from this index.
                // Otherwise we should start from the beginning for static mpds or from the end (live edge) for dynamic mpds
                originAvailabilityIdx = (index > 0) ? index : (isDynamic ? lastIdx : firstIdx);
            }

            // segment list should not be out of the availability window range
            start = Math.max(originAvailabilityIdx - availabilityLowerLimit, firstIdx);
            end = Math.min(originAvailabilityIdx + availabilityUpperLimit, lastIdx);

            range = {
                start: start,
                end: end
            };

            return range;
        },

        waitForAvailabilityWindow = function(representation) {
            var self = this,
                deferred = Q.defer(),
                range,
                waitingTime,
                getRange = function() {
                    range = self.timelineConverter.calcSegmentAvailabilityRange(representation, isDynamic);

                    if (range.end > 0) {
                        deferred.resolve(range);
                    } else {
                        // range.end represents a time gap between the current wall-clock time and the availability time of the first segment.
                        // A negative value means that no segments are available yet, we should wait until segments become available
                        waitingTime = Math.abs(range.end) * 1000;
                        setTimeout(getRange, waitingTime);
                    }
                };

            getRange();

            return deferred.promise;
        },

        getTimeBasedSegment = function(representation, time, duration, fTimescale, url, range, index) {
            var self = this,
                scaledTime = time / fTimescale,
                scaledDuration = Math.min(duration / fTimescale, representation.adaptation.period.mpd.maxSegmentDuration),
                presentationStartTime,
                presentationEndTime,
                seg;

            presentationStartTime = self.timelineConverter.calcPresentationTimeFromMediaTime(scaledTime, representation);
            // ORANGE: presentationStartTime is the media time of the segment as provided in the SegmentTimeline
            presentationStartTime = scaledTime; //self.timelineConverter.calcPresentationTimeFromMediaTime(scaledTime, representation);
            presentationEndTime = presentationStartTime + scaledDuration;

            seg = new Dash.vo.Segment();

            seg.representation = representation;
            seg.duration = scaledDuration;
            seg.mediaStartTime = scaledTime;

            seg.presentationStartTime = presentationStartTime;

            // For SegmentTimeline every segment is available at mpdLoadedTime
            seg.availabilityStartTime = representation.adaptation.period.mpd.manifest.mpdLoadedTime;
            seg.availabilityEndTime = self.timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime, representation.adaptation.period.mpd, isDynamic);

            // at this wall clock time, the video element currentTime should be seg.presentationStartTime
            seg.wallStartTime = self.timelineConverter.calcWallTimeForSegment(seg, isDynamic);

            seg.replacementTime = time;

            seg.replacementNumber = getNumberForSegment(seg, index);

            url = replaceTokenForTemplate(url, "Number", seg.replacementNumber);
            url = replaceTokenForTemplate(url, "Time", seg.replacementTime);
            seg.media = url;
            seg.mediaRange = range;
            seg.availabilityIdx = index;

            //this.debug.log("[DashHandler]["+type+"] createSegment: time = " + seg.mediaStartTime + ", availabilityIdx = " + seg.availabilityIdx + ", url = " + seg.media);

            return seg;
        },

        getSegmentsFromList = function(representation) {
            var self = this,
                segments = [],
                deferred = Q.defer(),
                list = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList,
            len = list.SegmentURL_asArray.length,
            i,
            seg,
            s,
            range,
            startIdx = 0,
            endIdx = list.SegmentURL_asArray.length,
            start;

            start = representation.startNumber;

            waitForAvailabilityWindow.call(self, representation).then(
                function(availabilityWindow) {
                    if (!isDynamic) {
                        range = decideSegmentListRangeForTemplate.call(self, representation);
                        startIdx = range.start;
                        endIdx = range.end;
                    }

                    for (i = startIdx; i < endIdx; i += 1) {
                        s = list.SegmentURL_asArray[i];

                        seg = getIndexBasedSegment.call(
                            self,
                            representation,
                            i);

                        seg.replacementTime = (start + i - 1) * representation.segmentDuration;
                        seg.media = s.media;
                        seg.mediaRange = s.mediaRange;
                        seg.index = s.index;
                        seg.indexRange = s.indexRange;

                        // ORANGE: add sequence number (HLS use case)
                        if (s.sequenceNumber !== undefined) {
                            seg.sequenceNumber = s.sequenceNumber;
                        }

                        //self.debug.log("[DashHandler]["+type+"] createSegment: time = " + seg.mediaStartTime + ", availabilityIdx = " + seg.availabilityIdx + ", url = " + seg.media);

                        segments.push(seg);
                        seg = null;
                    }
                    representation.segmentAvailabilityRange = availabilityWindow;
                    representation.availableSegmentsNumber = len;
                    deferred.resolve(segments);
                });

            return deferred.promise;
        },

        getSegmentsFromSource = function(representation) {
            var self = this,
                baseURL = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].BaseURL,
            deferred = Q.defer(),
            segments = [],
            count = 0,
            range = null,
            s,
            i,
            len,
            seg;

            if (representation.indexRange) {
                range = representation.indexRange;
            }

            this.baseURLExt.loadSegments(baseURL, range).then(
                function(fragments) {
                    for (i = 0, len = fragments.length; i < len; i += 1) {
                        s = fragments[i];

                        seg = getTimeBasedSegment.call(
                            self,
                            representation,
                            s.startTime,
                            s.duration,
                            s.timescale,
                            s.media,
                            s.mediaRange,
                            count);

                        segments.push(seg);
                        seg = null;
                        count += 1;
                    }

                    representation.segmentAvailabilityRange = {
                        start: segments[0].presentationStartTime,
                        end: segments[len - 1].presentationStartTime
                    };
                    representation.availableSegmentsNumber = len;
                    deferred.resolve(segments);
                }, function(){
                    deferred.reject();
                }
            );

            return deferred.promise;
        },

        getSegments = function(representation) {
            var segmentPromise,
                deferred = Q.defer(),
                self = this,
                lastIdx;

            //self.debug.log("[DashHandler]["+type+"] getSegments for representation " + representation.id);
            // Already figure out the segments.
            if (!isSegmentListUpdateRequired.call(self, representation)) {
                return Q.when(representation.segments);
            } else {
                if (representation.segmentInfoType === "SegmentTimeline") {
                    segmentPromise = getSegmentsFromTimeline.call(self, representation);
                } else if (representation.segmentInfoType === "SegmentTemplate") {
                    segmentPromise = getSegmentsFromTemplate.call(self, representation);
                } else if (representation.segmentInfoType === "SegmentList") {
                    segmentPromise = getSegmentsFromList.call(self, representation);
                } else {
                    segmentPromise = getSegmentsFromSource.call(self, representation);
                }

                Q.when(segmentPromise).then(
                    function(segments) {
                        representation.segments = segments;
                        lastIdx = segments.length - 1;
                        if (isDynamic && isNaN(representation.adaptation.period.liveEdge)) {
                            var metrics = self.metricsModel.getMetricsFor("stream"),
                                liveEdge = segments[lastIdx].presentationStartTime;
                            // the last segment is supposed to be a live edge
                            representation.adaptation.period.liveEdge = liveEdge;
                            self.metricsModel.updateManifestUpdateInfo(self.metricsExt.getCurrentManifestUpdate(metrics), {
                                presentationStartTime: liveEdge
                            });
                        }

                        deferred.resolve(segments);
                    }, function(){
                        deferred.reject();
                    }
                );
            }

            return deferred.promise;
        },

        updateSegmentList = function(representation) {
            var self = this,
                deferred = Q.defer();

            representation.segments = null;

            self.debug.log("[DashHandler][" + type + "] updateSegmentList for representation ", representation.id);

            getSegments.call(self, representation).then(
                function(segments) {
                    representation.segments = segments;
                    deferred.resolve(segments);
                }
            );

            return deferred.promise;
        },

        getIndexForSegments = function(time, representation) {
            var segments = representation === null ? null : representation.segments,
                segmentLastIdx = segments === null ? 0 : segments.length - 1,
                idx = -1,
                frag,
                ft,
                fd,
                i,
                self = this;

            self.debug.log("[DashHandler][" + type + "] getIndexForSegments for time ", time);

            if (segments && segments.length > 0) {
                for (i = segmentLastIdx; i >= 0; i--) {
                    frag = segments[i];
                    ft = frag.presentationStartTime;
                    fd = frag.duration;
                    //self.debug.log("[DashHandler]["+type+"] ft = " + ft + ", fd = " + fd + ", idx = " + frag.availabilityIdx);
                    if ((time + Dash.dependencies.DashHandler.EPSILON) >= ft &&
                        (time - Dash.dependencies.DashHandler.EPSILON) <= (ft + fd)) {
                        idx = frag.availabilityIdx;
                        self.debug.log("[DashHandler][" + type + "] getIndexForSegments, idx =  ", idx);
                        break;
                    } else if (idx === -1 && (time - Dash.dependencies.DashHandler.EPSILON) > (ft + fd)) {
                        // time is past the end
                        self.debug.log("[DashHandler][" + type + "] getIndexForSegments, (past the end) idx =  ", idx);
                        idx = isNaN(representation.segmentDuration) ? (frag.availabilityIdx + 1) : Math.floor((time - representation.adaptation.period.start) / representation.segmentDuration);
                        //ORANGE : we have past the end, don't iterate for nothing
                        break;
                    }
                }
            }

            if (idx === -1) {
                if (!isNaN(representation.segmentDuration)) {
                    self.debug.log("[DashHandler][" + type + "] getIndexForSegments, (segment duration) idx =  ", idx);
                    idx = Math.floor((time - representation.adaptation.period.start) / representation.segmentDuration);
                } else {
                    self.debug.log("Couldn't figure out a time!");
                    self.debug.log("Time: " + time);
                }
            }

            // TODO : This is horrible.
            // Temp fix for SegmentTimeline refreshes.
            //if (idx === -1) {
            //    idx = 0;
            //}

            /*
            if (segments && segments.length > 0) {
                idx = 0;
                ft = segments[0].startTime / segments[0].timescale;
                frag = null;

                while (ft <= time && (idx + 1) < segments.length) {
                    frag = segments[idx];
                    ft += frag.duration / frag.timescale;
                    idx += 1;
                }
                idx -= 1;
            }
            */

            return Q.when(idx);
        },

        getSegmentByIndex = function(index, representation) {
            if (!representation || !representation.segments) {
                return null;
            }

            var ln = representation.segments.length,
                seg,
                i;

            for (i = 0; i < ln; i += 1) {
                seg = representation.segments[i];

                if (seg.availabilityIdx === index) {
                    return seg;
                }
            }

            return null;
        },

        // ORANGE: HLS use case, get next segment from sequence number
        getNextSegmentBySequenceNumber = function(sn, representation) {
            if (!representation || !representation.segments) {
                return null;
            }

            var ln = representation.segments.length,
                seg,
                i;

            for (i = 0; i < ln; i += 1) {
                seg = representation.segments[i];

                if ((seg.sequenceNumber !== undefined) && (seg.sequenceNumber === sn)) {
                    if (i < (ln - 1)) {
                        return representation.segments[i + 1];
                    }
                    return null;
                }
            }

            return null;
        },

        isSegmentListUpdateRequired = function(representation) {
            var updateRequired = false,
                segments = representation.segments,
                upperIdx,
                lowerIdx,
                upperTime,
                lowerTime;

            if (!segments || segments.length === 0) {
                updateRequired = true;
            } else {
                lowerIdx = segments[0].availabilityIdx;
                upperIdx = segments[segments.length - 1].availabilityIdx;
                // ORANGE: check also regarding requested time (@see getForTime()), required for live use case
                // to avoid already loaded fragments to be returned
                upperTime = segments[segments.length - 1].presentationStartTime;
                lowerTime = segments[0].presentationStartTime;
                updateRequired = (index < lowerIdx) || (index > upperIdx) || (requestedTime > upperTime) || (requestedTime < lowerTime);
            }

            return updateRequired;
        },

        getRequestForSegment = function(segment) {
            if (segment === null || segment === undefined) {
                return null;
            }

            var request = new MediaPlayer.vo.SegmentRequest(),
                representation = segment.representation,
                bandwidth = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].
            AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].bandwidth,
            url;

            url = getRequestUrl(segment.media, representation);
            url = replaceTokenForTemplate(url, "Number", segment.replacementNumber);
            url = replaceTokenForTemplate(url, "Time", segment.replacementTime);
            url = replaceTokenForTemplate(url, "Bandwidth", bandwidth);
            url = replaceIDForTemplate(url, representation.id);
            url = unescapeDollarsInTemplate(url);

            request.streamType = type;
            request.type = "Media Segment";
            request.url = url;
            request.range = segment.mediaRange;
            request.startTime = segment.presentationStartTime;
            request.duration = segment.duration;
            request.timescale = representation.timescale;
            request.availabilityStartTime = segment.availabilityStartTime;
            request.availabilityEndTime = segment.availabilityEndTime;
            request.wallStartTime = segment.wallStartTime;
            request.quality = representation.index;
            request.index = segment.availabilityIdx;
            // ORANGE: add sequence number (HLS use case)
            if (segment.sequenceNumber !== undefined) {
                request.sequenceNumber = segment.sequenceNumber;
            }

            return request;
        },

        getForTime = function(representation, time) {
            var deferred,
                request,
                segment,
                self = this;

            if (!representation) {
                return Q.reject("no representation");
            }

            requestedTime = time;

            self.debug.log("[DashHandler][" + type + "] Getting the request for time: " + time);

            deferred = Q.defer();

            getSegments.call(self, representation).then(
                function( /*segments*/ ) {
                    var segmentsPromise;

                    //self.debug.log("Got segments.");
                    //self.debug.log(segments);
                    //self.debug.log("Got a list of segments, so dig deeper.");
                    segmentsPromise = getIndexForSegments.call(self, time, representation);
                    return segmentsPromise;
                }, function(){deferred.reject();}
            ).then(
                function(newIndex) {
                    self.debug.log("[DashHandler][" + type + "] Index for time " + time + " is " + newIndex);
                    index = newIndex;

                    return Q.when(isMediaFinished.call(self, representation));
                }
            ).then(
                function(finished) {
                    var requestForSegment = null;

                    //self.debug.log("Stream finished? " + finished);
                    if (finished) {
                        request = new MediaPlayer.vo.SegmentRequest();
                        request.action = request.ACTION_COMPLETE;
                        request.index = index;
                        self.debug.log("[DashHandler][" + type + "] Signal complete.");
                        self.debug.log(request);
                        deferred.resolve(request);
                    } else {
                        segment = getSegmentByIndex(index, representation);
                        requestForSegment = getRequestForSegment.call(self, segment);
                    }

                    return Q.when(requestForSegment);
                }
            ).then(
                function(request) {
                    //self.debug.log("Got a request.");
                    //self.debug.log(request);
                    deferred.resolve(request);
                }
            );

            return deferred.promise;
        },

        getNext = function(representation) {
            var deferred,
                request,
                segment,
                finished,
                self = this;

            if (!representation) {
                return Q.reject("no represenation");
            }

            //self.debug.log("Getting the next request.");

            if (index === -1) {
                throw "You must call getSegmentRequestForTime first.";
            }

            requestedTime = null;
            index += 1;
            //self.debug.log("New index: " + index);

            deferred = Q.defer();

            self.debug.log("[DashHandler][" + type + "] Getting the next request => index = " + index);

            finished = isMediaFinished.call(self, representation);
            //self.debug.log("Stream finished? " + finished);
            if (finished) {
                request = new MediaPlayer.vo.SegmentRequest();
                request.action = request.ACTION_COMPLETE;
                request.index = index;
                self.debug.log("[DashHandler][" + type + "] Signal complete.");
                //self.debug.log(request);
                deferred.resolve(request);
            } else {
                getSegments.call(self, representation).then(
                    function( /*segments*/ ) {
                        var segmentsPromise;

                        //self.debug.log("Got segments.");
                        //self.debug.log(segments);
                        segment = getSegmentByIndex(index, representation);
                        segmentsPromise = getRequestForSegment.call(self, segment);
                        return Q.when(segmentsPromise);
                    }
                ).then(
                    function(request) {
                        //self.debug.log("Got a request.");
                        //self.debug.log(request);
                        deferred.resolve(request);
                    }
                );
            }

            return deferred.promise;
        },

        // ORANGE: HLS use case, get next request from sequence number
        getNextFromSN = function(representation, sn) {
            var deferred,
                request,
                segment,
                finished,
                self = this;

            if (!representation) {
                return Q.reject("no represenation");
            }

            //self.debug.log("Getting the next request.");

            if (index === -1) {
                throw "You must call getSegmentRequestForTime first.";
            }

            deferred = Q.defer();

            self.debug.log("[DashHandler][" + type + "] Getting the next request => sn = " + sn);

            getSegments.call(self, representation).then(
                function( /*segments*/ ) {
                    finished = isMediaFinished.call(self, representation);
                    //self.debug.log("Stream finished? " + finished);
                    if (finished) {
                        request = new MediaPlayer.vo.SegmentRequest();
                        request.action = request.ACTION_COMPLETE;
                        request.index = index;
                        self.debug.log("[DashHandler][" + type + "] Signal complete.");
                        //self.debug.log(request);
                        deferred.resolve(request);
                    } else {
                        segment = getNextSegmentBySequenceNumber(sn, representation);
                        if (segment === null) {
                            deferred.resolve(null);
                        } else {
                            index = segment.availabilityIdx;
                            var requestForSegment = getRequestForSegment.call(self, segment);
                            //self.debug.log("Got a request.");
                            //self.debug.log(request);
                            deferred.resolve(requestForSegment);
                        }
                    }
                }
            );

            return deferred.promise;
        },

        getSegmentCountForDuration = function(representation, requiredDuration, bufferedDuration) {
            var self = this,
                remainingDuration = Math.max(requiredDuration - bufferedDuration, 0),
                deferred = Q.defer(),
                segmentDuration,
                segmentCount = 0;

            if (!representation) {
                return Q.reject("no represenation");
            }

            self.debug.log("[DashHandler][" + type + "] getSegmentCountForDuration");

            getSegments.call(self, representation).then(
                function(segments) {
                    segmentDuration = segments[0].duration;
                    segmentCount = Math.ceil(remainingDuration / segmentDuration);
                    deferred.resolve(segmentCount);
                },
                function() {
                    deferred.resolve(0);
                }
            );

            return deferred.promise;
        },

        getCurrentTime = function(representation) {
            var self = this,
                time,
                bufferedIndex,
                deferred = Q.defer();

            if (!representation) {
                return Q.reject("no represenation");
            }

            bufferedIndex = index;

            getSegments.call(self, representation).then(
                function(segments) {
                    if (bufferedIndex < 0) {
                        time = self.timelineConverter.calcPresentationStartTime(representation.adaptation.period);
                    } else {
                        bufferedIndex = bufferedIndex < segments[0].availabilityIdx ? segments[0].availabilityIdx : Math.min(segments[segments.length - 1].availabilityIdx, bufferedIndex);
                        time = getSegmentByIndex(bufferedIndex, representation).presentationStartTime;
                        self.debug.log("[DashHandler][" + type + "] getSegmentByIndex, index = " + bufferedIndex + " => time = " + time);
                    }

                    self.debug.log("[DashHandler][" + type + "] getCurrentTime => ", time);
                    deferred.resolve(time);
                },
                function() {
                    deferred.reject();
                }
            );

            return deferred.promise;
        },

        getIFrameRequest = function( /*request*/ ) {
            //TBD
        },

        getFragmentInfoRequest = function( /*request*/ ) {
            //TBD
        };

    return {
        debug: undefined,
        baseURLExt: undefined,
        metricsModel: undefined,
        metricsExt: undefined,
        manifestModel: undefined,
        manifestExt: undefined,
        timelineConverter: undefined,
        capabilities: undefined,
        videoModel: undefined,

        getType: function() {
            return type;
        },

        setType: function(value) {
            type = value;
        },

        getIsDynamic: function() {
            return isDynamic;
        },
        setIsDynamic: function(value) {
            isDynamic = value;
        },

        getInitRequest: getInit,
        getSegmentRequestForTime: getForTime,
        getNextSegmentRequest: getNext,
        // ORANGE: HLS use case, get next request from sequence number
        getNextSegmentRequestFromSN: getNextFromSN,
        getCurrentTime: getCurrentTime,
        getSegmentCountForDuration: getSegmentCountForDuration,
        updateSegmentList: updateSegmentList,
        getIFrameRequest: getIFrameRequest,
        getFragmentInfoRequest: getFragmentInfoRequest
    };
};

Dash.dependencies.DashHandler.EPSILON = 0.003;

Dash.dependencies.DashHandler.prototype = {
    constructor: Dash.dependencies.DashHandler
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */


Dash.dependencies.DashManifestExtensions = function() {
    "use strict";
    this.timelineConverter = undefined;
};

Dash.dependencies.DashManifestExtensions.prototype = {
    constructor: Dash.dependencies.DashManifestExtensions,

    getIsType: function(adaptation, type, mimeTypes) {
        "use strict";
        var i, j,
            found = false,
            col,
            representation;

        if (!adaptation) {
            return false;
        }

        if (adaptation.type === undefined) {
            adaptation.type = null;
        }

        col = adaptation.ContentComponent_asArray;

        if (col) {
            // Check contentType attribute at adaptation level
            for (i = 0; i < adaptation.ContentComponent_asArray.length && !found; i++) {
                if (adaptation.ContentComponent_asArray[i].contentType === type) {
                    adaptation.type = type;
                    found = true;
                }
            }
        }

        // Check mimeType attribute at adaptation level
        if (!found) {
            if (adaptation.mimeType) {
                for (i = 0; i < mimeTypes.length && !found; i++) {
                    if (adaptation.mimeType.indexOf(mimeTypes[i]) !== -1) {
                        adaptation.type = type;
                        found = true;
                    }
                }
            }
        }

        // Check mimeType attribute at representation level
        if (!found) {
            for (i = 0; i < adaptation.Representation_asArray.length && !found; i++) {
                representation = adaptation.Representation_asArray[i];
                for (j = 0; j < mimeTypes.length && !found; j++) {
                    if (representation.mimeType.indexOf(mimeTypes[j]) !== -1) {
                        adaptation.type = type;
                        found = true;
                    }
                }
            }
        }

        return found;
    },

    getIsVideo: function(adaptation) {
        return this.getIsType(adaptation, "video", ["video"]);
    },

    getIsAudio: function(adaptation) {
        return this.getIsType(adaptation, "audio", ["audio"]);
    },

    getIsText: function(adaptation) {
        return this.getIsType(adaptation, "text", ["vtt", "ttml", "application/mp4"]);
    },

    // ORANGE: added application/ttml+xml+mp4 for Smoothstreaming subtitles (ttml+xml encapsulated in mp4 binary form)
    getIsTextTrack: function(type) {
        return (type === "text/vtt" || type === "application/ttml+xml" || type === "application/ttml+xml+mp4" || type === "application/mp4");
    },

    getIsMain: function( /*adaptation*/ ) {
        "use strict";
        // TODO : Check "Role" node.
        // TODO : Use this somewhere.
        return false;
    },

    processAdaptation: function(adaptation) {
        "use strict";
        if (adaptation.Representation_asArray !== undefined && adaptation.Representation_asArray !== null) {
            adaptation.Representation_asArray.sort(function(a, b) {
                return a.bandwidth - b.bandwidth;
            });
        }

        return adaptation;
    },

    getDataForId: function(id, manifest, periodIndex) {
        "use strict";
        var adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray,
            i,
            len;

        for (i = 0, len = adaptations.length; i < len; i += 1) {
            if (adaptations[i].hasOwnProperty("id") && adaptations[i].id === id) {
                return adaptations[i];
            }
        }

        return null;
    },

    getDataForIndex: function(index, manifest, periodIndex) {
        "use strict";
        var adaptations;

        if (manifest && periodIndex >= 0) {
            adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;

            if (adaptations && adaptations.length > 0 && !isNaN(index)) {
                return adaptations[index];
            }
        }

        return [];
    },

    getIndex: function(adaptation, manifest) {
        var periods = manifest.Period_asArray,
            adaptations,
            i,
            j;

        for (i = 0; i < periods.length; i += 1) {
            adaptations = periods[i].AdaptationSet_asArray;
            for (j = 0; j < adaptations.length; j += 1) {
                if (adaptations[j] === adaptation) {
                    return j;
                }
            }
        }

        return -1;
    },

    getDataIndex: function(data, manifest, periodIndex) {
        "use strict";

        var adaptations,
            i,
            len;

        if (manifest && periodIndex >= 0) {
            adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;

            // ORANGE : compare data with id or string representation to avoid reference error due to manifest refresh
            if (data.id) {
                for (i = 0, len = adaptations.length; i < len; i += 1) {
                    if (adaptations[i].id && adaptations[i].id === data.id) {
                        return i;
                    }
                }
            } else {
                var strData = JSON.stringify(data);
                var strAdapt;
                for (i = 0, len = adaptations.length; i < len; i += 1) {
                    strAdapt = JSON.stringify(adaptations[i]);
                    if (strAdapt === strData) {
                        return i;
                    }
                }
            }
        }

        return -1;
    },

    getVideoData: function(manifest, periodIndex) {
        "use strict";
        //return null;
        //------------------------------------
        var adaptations,
            i;

        if (!manifest || periodIndex < 0) {
            return null;
        }

        adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;

        if (adaptations.length === 0) {
            return null;
        }

        for (i = 0; i < adaptations.length; i += 1) {
            if (this.getIsVideo(adaptations[i])) {
                return adaptations[i];
            }
        }

        return null;
    },

    getTextDatas: function(manifest, periodIndex) {
        "use strict";
        //return null;
        //------------------------------------
        var adaptations,
            datas = [],
            i;

        if (!manifest || periodIndex < 0) {
            return datas;
        }

        adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;

        if (adaptations.length === 0) {
            return datas;
        }

        for (i = 0; i < adaptations.length; i += 1) {
            if (this.getIsText(adaptations[i])) {
                datas.push(adaptations[i]);
            }
        }

        return datas;
    },

    getAudioDatas: function(manifest, periodIndex) {
        "use strict";
        //------------------------------------
        var adaptations,
            datas = [],
            i;

        //return datas;

        if (!manifest || periodIndex < 0) {
            return datas;
        }

        adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;

        if (adaptations.length === 0) {
            return datas;
        }

        for (i = 0; i < adaptations.length; i += 1) {
            if (this.getIsAudio(adaptations[i])) {
                datas.push(adaptations[i]);
            }
        }

        return datas;
    },

    getSpecificAudioData: function(manifest, periodIndex, language) {
        "use strict";
        var i,
            datas;


        if (!manifest || periodIndex < 0) {
            return null;
        }

        datas = this.getAudioDatas(manifest, periodIndex);
        if (datas.length === 0) {
            return null;
        }

        for (i = 0; i < datas.length; i += 1) {
            if (datas[i].lang === language) {
                return this.processAdaptation(datas[i]);
            }
        }

        //if the specific language has not been found, return the first one.
        return this.processAdaptation(datas[0]);
    },

    getSpecificTextData: function(manifest, periodIndex, language) {
        "use strict";
        var i,
            datas;

        if (!manifest || periodIndex < 0) {
            return null;
        }

        datas = this.getTextDatas(manifest, periodIndex);
        if (datas.length === 0) {
            return null;
        }

        for (i = 0; i < datas.length; i += 1) {
            if (datas[i].lang === language) {
                return this.processAdaptation(datas[i]);
            }
        }

        return this.processAdaptation(datas[0]);
    },

    getCodec: function(adaptation) {
        "use strict";
        var i = 0,
            representation,
            codec = null;

        while ((codec === null) && (i < adaptation.Representation_asArray.length)) {
            representation = adaptation.Representation_asArray[i];
            if (representation.codecs !== null && representation.codecs !== "") {
                codec = (representation.mimeType + ';codecs="' + representation.codecs + '"');
            }
            i++;
        }

        return codec;
    },

    getMimeType: function(data) {
        "use strict";
        return data.Representation_asArray[0].mimeType;
    },

    getKID: function(data) {
        "use strict";

        if (!data || !data.hasOwnProperty("cenc:default_KID")) {
            return null;
        }
        return data["cenc:default_KID"];
    },

    getContentProtectionData: function(data) {
        "use strict";
        if (!data || !data.hasOwnProperty("ContentProtection_asArray") || data.ContentProtection_asArray.length === 0) {
            return null;
        }
        return data.ContentProtection_asArray;
    },

    getIsDynamic: function(manifest) {
        "use strict";
        var isDynamic = false,
            LIVE_TYPE = "dynamic";

        if (manifest && manifest.hasOwnProperty("type")) {
            isDynamic = (manifest.type === LIVE_TYPE);
        }

        return isDynamic;
    },

    getIsDVR: function(manifest) {
        "use strict";
        var isDynamic = this.getIsDynamic(manifest),
            containsDVR,
            isDVR;

        containsDVR = !isNaN(manifest.timeShiftBufferDepth);
        isDVR = (isDynamic && containsDVR);

        return isDVR;
    },

    getIsOnDemand: function(manifest) {
        "use strict";
        var isOnDemand = false;

        if (manifest.profiles && manifest.profiles.length > 0) {
            isOnDemand = (manifest.profiles.indexOf("urn:mpeg:dash:profile:isoff-on-demand:2011") !== -1);
        }

        return isOnDemand;
    },

    getDuration: function(manifest) {
        var mpdDuration;

        //@mediaPresentationDuration specifies the duration of the entire Media Presentation.
        //If the attribute is not present, the duration of the Media Presentation is unknown.
        if (manifest && manifest.hasOwnProperty("mediaPresentationDuration")) {
            mpdDuration = manifest.mediaPresentationDuration;
        } else {
            mpdDuration = Number.POSITIVE_INFINITY;
        }

        return mpdDuration;
    },

    getBandwidth: function(representation) {
        "use strict";
        return representation.bandwidth;
    },

    getRefreshDelay: function(manifest) {
        "use strict";
        var delay = NaN,
            minDelay = 2;

        if (manifest.hasOwnProperty("minimumUpdatePeriod")) {
            delay = Math.max(parseFloat(manifest.minimumUpdatePeriod), minDelay);
        }

        return delay;
    },

    getRepresentationCount: function(adaptation) {
        "use strict";
        if (adaptation) {
            return adaptation.Representation_asArray.length;
        }

        return null;
    },

    getRepresentationFor: function(index, data) {
        "use strict";
        return data.Representation_asArray[index];
    },

    getRepresentationsForAdaptation: function(manifest, adaptation) {
        var a,
            representations = [],
            representation,
            initialization,
            segmentInfo,
            r;

        if (manifest && adaptation) {
            a = this.processAdaptation(manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index]);

            for (var i = 0; i < a.Representation_asArray.length; i += 1) {
                r = a.Representation_asArray[i];
                representation = new Dash.vo.Representation();
                representation.index = i;
                representation.adaptation = adaptation;

                if (r.hasOwnProperty("id")) {
                    representation.id = r.id;
                }

                if (r.hasOwnProperty("SegmentBase")) {
                    segmentInfo = r.SegmentBase;
                    representation.segmentInfoType = "SegmentBase";
                } else if (r.hasOwnProperty("SegmentList")) {
                    segmentInfo = r.SegmentList;
                    representation.segmentInfoType = "SegmentList";
                    representation.useCalculatedLiveEdgeTime = true;
                } else if (r.hasOwnProperty("SegmentTemplate")) {
                    segmentInfo = r.SegmentTemplate;

                    if (segmentInfo.hasOwnProperty("SegmentTimeline")) {
                        representation.segmentInfoType = "SegmentTimeline";
                    } else {
                        representation.segmentInfoType = "SegmentTemplate";
                    }

                    if (segmentInfo.hasOwnProperty("initialization")) {
                        representation.initialization = segmentInfo.initialization.split("$Bandwidth$")
                            .join(r.bandwidth).split("$RepresentationID$").join(r.id);
                    }
                } else {
                    segmentInfo = r.BaseURL;
                    representation.segmentInfoType = "BaseURL";
                }

                if (segmentInfo.hasOwnProperty("Initialization")) {
                    initialization = segmentInfo.Initialization;
                    if (initialization.hasOwnProperty("sourceURL")) {
                        representation.initialization = initialization.sourceURL;
                    } else if (initialization.hasOwnProperty("range")) {
                        representation.initialization = r.BaseURL;
                        representation.range = initialization.range;
                    }
                } else if (r.hasOwnProperty("mimeType") && this.getIsTextTrack(r.mimeType)) {
                    representation.initialization = r.BaseURL;
                    representation.range = 0;
                }

                if (segmentInfo.hasOwnProperty("timescale")) {
                    representation.timescale = segmentInfo.timescale;
                }
                if (segmentInfo.hasOwnProperty("duration")) {
                    // TODO according to the spec @maxSegmentDuration specifies the maximum duration of any Segment in any Representation in the Media Presentation
                    // It is also said that for a SegmentTimeline any @d value shall not exceed the value of MPD@maxSegmentDuration, but nothing is said about
                    // SegmentTemplate @duration attribute. We need to find out if @maxSegmentDuration should be used instead of calculated duration if the the duration
                    // exceeds @maxSegmentDuration
                    //representation.segmentDuration = Math.min(segmentInfo.duration / representation.timescale, adaptation.period.mpd.maxSegmentDuration);
                    representation.segmentDuration = segmentInfo.duration / representation.timescale;
                }
                if (segmentInfo.hasOwnProperty("startNumber")) {
                    representation.startNumber = segmentInfo.startNumber;
                }
                if (segmentInfo.hasOwnProperty("indexRange")) {
                    representation.indexRange = segmentInfo.indexRange;
                }
                if (segmentInfo.hasOwnProperty("presentationTimeOffset")) {
                    representation.presentationTimeOffset = segmentInfo.presentationTimeOffset / representation.timescale;
                }

                representation.MSETimeOffset = this.timelineConverter.calcMSETimeOffset(representation);
                representations.push(representation);
            }
        }

        return representations;
    },

    getAdaptationsForPeriod: function(manifest, period) {
        var p = manifest === null ? null : manifest.Period_asArray[period.index],
            adaptations = [],
            adaptationSet;

        if (p) {
            for (var i = 0; i < p.AdaptationSet_asArray.length; i += 1) {
                adaptationSet = new Dash.vo.AdaptationSet();
                adaptationSet.index = i;
                adaptationSet.period = period;
                adaptations.push(adaptationSet);
            }
        }

        return adaptations;
    },

    getRegularPeriods: function(manifest, mpd) {
        var periods = [],
            isDynamic = this.getIsDynamic(manifest),
            i,
            len,
            p1 = null,
            p = null,
            vo1 = null,
            vo = null;

        for (i = 0, len = manifest.Period_asArray.length; i < len; i += 1) {
            p = manifest.Period_asArray[i];

            // If the attribute @start is present in the Period, then the
            // Period is a regular Period and the PeriodStart is equal
            // to the value of this attribute.
            if (p.hasOwnProperty("start")) {
                vo = new Dash.vo.Period();
                vo.start = p.start;
            }
            // If the @start attribute is absent, but the previous Period
            // element contains a @duration attribute then then this new
            // Period is also a regular Period. The start time of the new
            // Period PeriodStart is the sum of the start time of the previous
            // Period PeriodStart and the value of the attribute @duration
            // of the previous Period.
            else if (p1 !== null && p.hasOwnProperty("duration")) {
                vo = new Dash.vo.Period();
                vo.start = vo1.start + vo1.duration;
                vo.duration = p.duration;
            }
            // If (i) @start attribute is absent, and (ii) the Period element
            // is the first in the MPD, and (iii) the MPD@type is 'static',
            // then the PeriodStart time shall be set to zero.
            else if (i === 0 && !isDynamic) {
                vo = new Dash.vo.Period();
                vo.start = 0;
            }

            // The Period extends until the PeriodStart of the next Period.
            // The difference between the PeriodStart time of a Period and
            // the PeriodStart time of the following Period.
            if (vo1 !== null && isNaN(vo1.duration)) {
                vo1.duration = vo.start - vo1.start;
            }

            if (vo !== null && p.hasOwnProperty("id")) {
                vo.id = p.id;
            }

            if (vo !== null && p.hasOwnProperty("duration")) {
                vo.duration = p.duration;
            }

            if (vo !== null) {
                vo.index = i;
                vo.mpd = mpd;
                periods.push(vo);
            }

            p1 = p;
            p = null;
            vo1 = vo;
            vo = null;
        }

        if (periods.length === 0) {
            return periods;
        }

        mpd.checkTime = this.getCheckTime(manifest, periods[0]);

        // The last Period extends until the end of the Media Presentation.
        // The difference between the PeriodStart time of the last Period
        // and the mpd duration
        if (vo1 !== null && isNaN(vo1.duration)) {
            vo1.duration = this.getEndTimeForLastPeriod(mpd) - vo1.start;
        }

        return periods;
    },

    getMpd: function(manifest) {
        var mpd = new Dash.vo.Mpd();

        if (manifest) {
            mpd.manifest = manifest;

            if (manifest.hasOwnProperty("availabilityStartTime")) {
                mpd.availabilityStartTime = new Date(manifest.availabilityStartTime.getTime());
            } else {
                mpd.availabilityStartTime = new Date(manifest.mpdLoadedTime.getTime());
            }

            if (manifest.hasOwnProperty("availabilityEndTime")) {
                mpd.availabilityEndTime = new Date(manifest.availabilityEndTime.getTime());
            }

            if (manifest.hasOwnProperty("suggestedPresentationDelay")) {
                mpd.suggestedPresentationDelay = manifest.suggestedPresentationDelay;
            }

            if (manifest.hasOwnProperty("timeShiftBufferDepth")) {
                mpd.timeShiftBufferDepth = manifest.timeShiftBufferDepth;
            }

            if (manifest.hasOwnProperty("maxSegmentDuration")) {
                mpd.maxSegmentDuration = manifest.maxSegmentDuration;
            }

            return mpd;
        }

        return null;
    },

    getFetchTime: function(manifest, period) {
        // FetchTime is defined as the time at which the server processes the request for the MPD from the client.
        // TODO The client typically should not use the time at which it actually successfully received the MPD, but should
        // take into account delay due to MPD delivery and processing. The fetch is considered successful fetching
        // either if the client obtains an updated MPD or the client verifies that the MPD has not been updated since the previous fetching.
        var fetchTime = this.timelineConverter.calcPresentationTimeFromWallTime(manifest.mpdLoadedTime, period);

        return fetchTime;
    },

    getCheckTime: function(manifest, period) {
        var checkTime = NaN;

        // If the MPD@minimumUpdatePeriod attribute in the client is provided, then the check time is defined as the
        // sum of the fetch time of this operating MPD and the value of this attribute,
        // i.e. CheckTime = FetchTime + MPD@minimumUpdatePeriod.
        if (manifest.hasOwnProperty("minimumUpdatePeriod")) {
            checkTime = this.getFetchTime(manifest, period) + manifest.minimumUpdatePeriod;
        }

        return checkTime;
    },

    getEndTimeForLastPeriod: function(mpd) {
        var periodEnd;

        // if the MPD@mediaPresentationDuration attribute is present, then PeriodEndTime is defined as the end time of the Media Presentation.
        // if the MPD@mediaPresentationDuration attribute is not present, then PeriodEndTime is defined as FetchTime + MPD@minimumUpdatePeriod

        if (mpd.manifest.mediaPresentationDuration) {
            periodEnd = mpd.manifest.mediaPresentationDuration;
        } else if (!isNaN(mpd.checkTime)) {
            // in this case the Period End Time should match CheckTime
            periodEnd = mpd.checkTime;
        } else {
            return new Error("Must have @mediaPresentationDuration or @minimumUpdatePeriod on MPD or an explicit @duration on the last period.");
        }

        return periodEnd;
    },

    getEventsForPeriod: function(manifest, period) {
        var periodArray = manifest === null ? null : manifest.Period_asArray,
            eventStreams = periodArray === null ? null : periodArray[period.index].EventStream_asArray,
            events = [];

        if (eventStreams) {
            for (var i = 0; i < eventStreams.length; i += 1) {
                var eventStream = new Dash.vo.EventStream();
                eventStream.period = period;
                eventStream.timescale = 1;

                if (eventStreams[i].hasOwnProperty("schemeIdUri")) {
                    eventStream.schemeIdUri = eventStreams[i].schemeIdUri;
                } else {
                    throw "Invalid EventStream. SchemeIdUri has to be set";
                }
                if (eventStreams[i].hasOwnProperty("timescale")) {
                    eventStream.timescale = eventStreams[i].timescale;
                }
                if (eventStreams[i].hasOwnProperty("value")) {
                    eventStream.value = eventStreams[i].value;
                }
                for (var j = 0; j < eventStreams[i].Event_asArray.length; j += 1) {
                    var event = new Dash.vo.Event();
                    event.presentationTime = 0;
                    event.eventStream = eventStream;

                    if (eventStreams[i].Event_asArray[j].hasOwnProperty("presentationTime")) {
                        event.presentationTime = eventStreams[i].Event_asArray[j].presentationTime;
                    }
                    if (eventStreams[i].Event_asArray[j].hasOwnProperty("duration")) {
                        event.duration = eventStreams[i].Event_asArray[j].duration;
                    }
                    if (eventStreams[i].Event_asArray[j].hasOwnProperty("id")) {
                        event.id = eventStreams[i].Event_asArray[j].id;
                    }
                    events.push(event);
                }
            }
        }

        return events;
    },

    getEventStreamForAdaptationSet: function(data) {

        var eventStreams = [],
            inbandStreams;

        if (data) {
            inbandStreams = data.InbandEventStream_asArray;

            if (inbandStreams) {
                for (var i = 0; i < inbandStreams.length; i += 1) {
                    var eventStream = new Dash.vo.EventStream();
                    eventStream.timescale = 1;

                    if (inbandStreams[i].hasOwnProperty("schemeIdUri")) {
                        eventStream.schemeIdUri = inbandStreams[i].schemeIdUri;
                    } else {
                        throw "Invalid EventStream. SchemeIdUri has to be set";
                    }
                    if (inbandStreams[i].hasOwnProperty("timescale")) {
                        eventStream.timescale = inbandStreams[i].timescale;
                    }
                    if (inbandStreams[i].hasOwnProperty("value")) {
                        eventStream.value = inbandStreams[i].value;
                    }
                    eventStreams.push(eventStream);
                }
            }
        }

        return eventStreams;
    },

    getEventStreamForRepresentation: function(data, representation) {

        var eventStreams = [],
            inbandStreams;

        if (data && representation) {

            inbandStreams = data.Representation_asArray[representation.index].InbandEventStream_asArray;

            if (inbandStreams) {
                for (var i = 0; i < inbandStreams.length; i++) {
                    var eventStream = new Dash.vo.EventStream();
                    eventStream.timescale = 1;
                    eventStream.representation = representation;

                    if (inbandStreams[i].hasOwnProperty("schemeIdUri")) {
                        eventStream.schemeIdUri = inbandStreams[i].schemeIdUri;
                    } else {
                        throw "Invalid EventStream. SchemeIdUri has to be set";
                    }
                    if (inbandStreams[i].hasOwnProperty("timescale")) {
                        eventStream.timescale = inbandStreams[i].timescale;
                    }
                    if (inbandStreams[i].hasOwnProperty("value")) {
                        eventStream.value = inbandStreams[i].value;
                    }
                    eventStreams.push(eventStream);
                }
            }
        }

        return eventStreams;

    },

    getRepresentationBandwidth: function(adaptation, index) {
        return this.getBandwidth(this.getRepresentationFor(index, adaptation));
    }

};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.DashMetricsExtensions = function() {
    "use strict";
    var findRepresentationIndexInPeriodArray = function(periodArray, representationId) {
            var period,
                adaptationSet,
                adaptationSetArray,
                representation,
                representationArray,
                periodArrayIndex,
                adaptationSetArrayIndex,
                representationArrayIndex;

            for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
                period = periodArray[periodArrayIndex];
                adaptationSetArray = period.AdaptationSet_asArray;
                for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                    adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                    representationArray = adaptationSet.Representation_asArray;
                    for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                        representation = representationArray[representationArrayIndex];
                        if (representationId === representation.id) {
                            return representationArrayIndex;
                        }
                    }
                }
            }

            return -1;
        },

        findRepresentionInPeriodArray = function(periodArray, representationId) {
            var period,
                adaptationSet,
                adaptationSetArray,
                representation,
                representationArray,
                periodArrayIndex,
                adaptationSetArrayIndex,
                representationArrayIndex;

            for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
                period = periodArray[periodArrayIndex];
                adaptationSetArray = period.AdaptationSet_asArray;
                for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                    adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                    representationArray = adaptationSet.Representation_asArray;
                    for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                        representation = representationArray[representationArrayIndex];
                        if (representationId === representation.id) {
                            return representation;
                        }
                    }
                }
            }

            return null;
        },

        adaptationIsType = function(adaptation, bufferType) {
            var found = false;

            // TODO : HACK ATTACK
            // Below we call getIsVideo and getIsAudio and then check the adaptation set for a 'type' property.
            // getIsVideo and getIsAudio are adding this 'type' property and SHOULD NOT BE.
            // This method expects getIsVideo and getIsAudio to be sync, but they are async (returns a promise).
            // This is a bad workaround!
            // The metrics extensions should have every method use promises.

            if (bufferType === "video") {
                //found = this.manifestExt.getIsVideo(adaptation);
                this.manifestExt.getIsVideo(adaptation);
                if (adaptation.type === "video") {
                    found = true;
                }
            } else if (bufferType === "audio") {
                //found = this.manifestExt.getIsAudio(adaptation); // TODO : Have to be sure it's the *active* audio track.
                this.manifestExt.getIsAudio(adaptation);
                if (adaptation.type === "audio") {
                    found = true;
                }
            } else {
                found = false;
            }

            return found;
        },

        findMaxBufferIndex = function(periodArray, bufferType) {
            var period,
                adaptationSet,
                adaptationSetArray,
                representationArray,
                periodArrayIndex,
                adaptationSetArrayIndex;

            for (periodArrayIndex = 0; periodArrayIndex < periodArray.length; periodArrayIndex = periodArrayIndex + 1) {
                period = periodArray[periodArrayIndex];
                adaptationSetArray = period.AdaptationSet_asArray;
                for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                    adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                    representationArray = adaptationSet.Representation_asArray;
                    if (adaptationIsType.call(this, adaptationSet, bufferType)) {
                        return representationArray.length;
                    }
                }
            }

            return -1;
        },

        getBandwidthForRepresentation = function(representationId) {
            var self = this,
                manifest = self.manifestModel.getValue(),
                representation,
                periodArray = manifest === null ? null : manifest.Period_asArray;

            if (periodArray) {
                representation = findRepresentionInPeriodArray.call(self, periodArray, representationId);

                if (representation === null) {
                    return null;
                }

                return representation.bandwidth;
            }

            return null;
        },

        getIndexForRepresentation = function(representationId) {
            var self = this,
                manifest = self.manifestModel.getValue(),
                representationIndex,
                periodArray = manifest === null ? null : manifest.Period_asArray;

            if (periodArray) {
                representationIndex = findRepresentationIndexInPeriodArray.call(self, periodArray, representationId);
                return representationIndex;
            }

            return null;
        },

        getMaxIndexForBufferType = function(bufferType) {
            var self = this,
                manifest = self.manifestModel.getValue(),
                maxIndex,
                periodArray = manifest === null ? null : manifest.Period_asArray;

            if (periodArray) {
                maxIndex = findMaxBufferIndex.call(this, periodArray, bufferType);
                return maxIndex;
            }

            return null;
        },

        getCurrentRepresentationSwitch = function(metrics) {
            if (metrics === null) {
                return null;
            }

            var repSwitch = metrics.RepSwitchList,
                repSwitchLength,
                repSwitchLastIndex,
                currentRepSwitch;

            if (repSwitch === null || repSwitch.length <= 0) {
                return null;
            }

            repSwitchLength = repSwitch.length;
            repSwitchLastIndex = repSwitchLength - 1;

            currentRepSwitch = repSwitch[repSwitchLastIndex];
            return currentRepSwitch;
        },

        getCurrentBufferLevel = function(metrics) {
            if (metrics === null) {
                return null;
            }

            var bufferLevel = metrics.BufferLevel,
                bufferLevelLength,
                bufferLevelLastIndex,
                currentBufferLevel;

            if (bufferLevel === null || bufferLevel.length <= 0) {
                return null;
            }

            bufferLevelLength = bufferLevel.length;
            bufferLevelLastIndex = bufferLevelLength - 1;

            currentBufferLevel = bufferLevel[bufferLevelLastIndex];
            return currentBufferLevel;
        },

        getCurrentHttpRequest = function(metrics) {
            if (metrics === null) {
                return null;
            }

            var httpList = metrics.HttpList,
                httpListLength,
                httpListLastIndex,
                currentHttpList = null;

            if (httpList === null || httpList.length <= 0) {
                return null;
            }

            httpListLength = httpList.length;
            httpListLastIndex = httpListLength - 1;

            // ORANGE: if only 1 item, then was ignored
            //while (httpListLastIndex > 0) {
            while (httpListLastIndex >= 0) {
                if (httpList[httpListLastIndex].responsecode !== null) {
                    currentHttpList = httpList[httpListLastIndex];
                    break;
                }
                httpListLastIndex -= 1;
            }
            return currentHttpList;
        },

        getHttpRequests = function(metrics) {
            if (metrics === null) {
                return [];
            }

            return !!metrics.HttpList ? metrics.HttpList : [];
        },

        getCurrentDroppedFrames = function(metrics) {
            if (metrics === null) {
                return null;
            }

            var droppedFrames = metrics.DroppedFrames,
                droppedFramesLength,
                droppedFramesLastIndex,
                currentDroppedFrames;

            if (droppedFrames === null || droppedFrames.length <= 0) {
                return null;
            }

            droppedFramesLength = droppedFrames.length;
            droppedFramesLastIndex = droppedFramesLength - 1;
            currentDroppedFrames = droppedFrames[droppedFramesLastIndex];

            return currentDroppedFrames;
        },

        getCurrentPlaybackQuality = function(metrics) {

            if (metrics === null) {
                return null;
            }

            var playbackQuality = metrics.PlaybackQuality;

            if (playbackQuality === null || playbackQuality.length <= 0) {
                return null;
            }

            return playbackQuality[playbackQuality.length-1];
        },

        getCurrentDVRInfo = function(metrics) {

            if (metrics === null) {
                return null;
            }

            var dvrInfo = metrics.DVRInfo,
                dvrInfoLastIndex,
                curentDVRInfo = null;

            if (dvrInfo === null || dvrInfo.length <= 0) {
                return null;
            }

            dvrInfoLastIndex = dvrInfo.length - 1;
            curentDVRInfo = dvrInfo[dvrInfoLastIndex];

            return curentDVRInfo;
        },

        getCurrentManifestUpdate = function(metrics) {
            if (metrics === null) {
                return null;
            }

            var manifestUpdate = metrics.ManifestUpdate,
                ln,
                lastIdx,
                currentManifestUpdate;

            if (manifestUpdate === null || manifestUpdate.length <= 0) {
                return null;
            }

            ln = manifestUpdate.length;
            lastIdx = ln - 1;

            currentManifestUpdate = manifestUpdate[lastIdx];

            return currentManifestUpdate;
        };

    return {
        manifestModel: undefined,
        manifestExt: undefined,
        getBandwidthForRepresentation: getBandwidthForRepresentation,
        getIndexForRepresentation: getIndexForRepresentation,
        getMaxIndexForBufferType: getMaxIndexForBufferType,
        getCurrentRepresentationSwitch: getCurrentRepresentationSwitch,
        getCurrentBufferLevel: getCurrentBufferLevel,
        getCurrentHttpRequest: getCurrentHttpRequest,
        getHttpRequests: getHttpRequests,
        getCurrentDroppedFrames: getCurrentDroppedFrames,
        getCurrentPlaybackQuality: getCurrentPlaybackQuality,
        getCurrentDVRInfo: getCurrentDVRInfo,
        getCurrentManifestUpdate: getCurrentManifestUpdate
    };
};

Dash.dependencies.DashMetricsExtensions.prototype = {
    constructor: Dash.dependencies.DashMetricsExtensions
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.DashParser = function () {
    "use strict";

    var SECONDS_IN_YEAR = 365 * 24 * 60 * 60,
        SECONDS_IN_MONTH = 30 * 24 * 60 * 60, // not precise!
        SECONDS_IN_DAY = 24 * 60 * 60,
        SECONDS_IN_HOUR = 60 * 60,
        SECONDS_IN_MIN = 60,
        MINUTES_IN_HOUR = 60,
        MILLISECONDS_IN_SECONDS = 1000,
        durationRegex = /^P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/,
        datetimeRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})([0-9]{2}))?/,
        numericRegex = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/,
        matchers = [
            {
                type: "duration",
                test: function (str) {
                    return durationRegex.test(str);
                },
                converter: function (str) {
                    //str = "P10Y10M10DT10H10M10.1S";
                    var match = durationRegex.exec(str);
                    return (parseFloat(match[2] || 0) * SECONDS_IN_YEAR +
                            parseFloat(match[4] || 0) * SECONDS_IN_MONTH +
                            parseFloat(match[6] || 0) * SECONDS_IN_DAY +
                            parseFloat(match[8] || 0) * SECONDS_IN_HOUR +
                            parseFloat(match[10] || 0) * SECONDS_IN_MIN +
                            parseFloat(match[12] || 0));
                }
            },
            {
                type: "datetime",
                test: function (str) {
                    return datetimeRegex.test(str);
                },
                converter: function (str) {
                    var match = datetimeRegex.exec(str),
                        utcDate;
                    // If the string does not contain a timezone offset different browsers can interpret it either
                    // as UTC or as a local time so we have to parse the string manually to normalize the given date value for
                    // all browsers
                    utcDate = Date.UTC(
                        parseInt(match[1], 10),
                        parseInt(match[2], 10)-1, // months start from zero
                        parseInt(match[3], 10),
                        parseInt(match[4], 10),
                        parseInt(match[5], 10),
                        (match[6] && parseInt(match[6], 10) || 0),
                        (match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS) || 0);
                    // If the date has timezone offset take it into account as well
                    if (match[9] && match[10]) {
                        var timezoneOffset = parseInt(match[9], 10) * MINUTES_IN_HOUR + parseInt(match[10], 10);
                        utcDate += (match[8] === '+' ? -1 : +1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;
                    }

                    return new Date(utcDate);
                }
            },
            {
                type: "numeric",
                test: function (str) {
                    return numericRegex.test(str);
                },
                converter: function (str) {
                    return parseFloat(str);
                }
            }
        ],

        getCommonValuesMap = function () {
            var adaptationSet,
                representation,
                subRepresentation,
                common;

            common = [
                {
                    name: 'profiles',
                    merge: false
                },
                {
                    name: 'width',
                    merge: false
                },
                {
                    name: 'height',
                    merge: false
                },
                {
                    name: 'sar',
                    merge: false
                },
                {
                    name: 'frameRate',
                    merge: false
                },
                {
                    name: 'audioSamplingRate',
                    merge: false
                },
                {
                    name: 'mimeType',
                    merge: false
                },
                {
                    name: 'segmentProfiles',
                    merge: false
                },
                {
                    name: 'codecs',
                    merge: false
                },
                {
                    name: 'maximumSAPPeriod',
                    merge: false
                },
                {
                    name: 'startsWithSap',
                    merge: false
                },
                {
                    name: 'maxPlayoutRate',
                    merge: false
                },
                {
                    name: 'codingDependency',
                    merge: false
                },
                {
                    name: 'scanType',
                    merge: false
                },
                {
                    name: 'FramePacking',
                    merge: true
                },
                {
                    name: 'AudioChannelConfiguration',
                    merge: true
                },
                {
                    name: 'ContentProtection',
                    merge: true
                }
            ];

            adaptationSet = {};
            adaptationSet.name = "AdaptationSet";
            adaptationSet.isRoot = false;
            adaptationSet.isArray = true;
            adaptationSet.parent = null;
            adaptationSet.children = [];
            adaptationSet.properties = common;

            representation = {};
            representation.name = "Representation";
            representation.isRoot = false;
            representation.isArray = true;
            representation.parent = adaptationSet;
            representation.children = [];
            representation.properties = common;
            adaptationSet.children.push(representation);

            subRepresentation = {};
            subRepresentation.name = "SubRepresentation";
            subRepresentation.isRoot = false;
            subRepresentation.isArray = true;
            subRepresentation.parent = representation;
            subRepresentation.children = [];
            subRepresentation.properties = common;
            representation.children.push(subRepresentation);

            return adaptationSet;
        },

        getSegmentValuesMap = function () {
            var period,
                adaptationSet,
                representation,
                common;

            common = [
                {
                    name: 'SegmentBase',
                    merge: true
                },
                {
                    name: 'SegmentTemplate',
                    merge: true
                },
                {
                    name: 'SegmentList',
                    merge: true
                }
            ];

            period = {};
            period.name = "Period";
            period.isRoot = false;
            period.isArray = true;
            period.parent = null;
            period.children = [];
            period.properties = common;

            adaptationSet = {};
            adaptationSet.name = "AdaptationSet";
            adaptationSet.isRoot = false;
            adaptationSet.isArray = true;
            adaptationSet.parent = period;
            adaptationSet.children = [];
            adaptationSet.properties = common;
            period.children.push(adaptationSet);

            representation = {};
            representation.name = "Representation";
            representation.isRoot = false;
            representation.isArray = true;
            representation.parent = adaptationSet;
            representation.children = [];
            representation.properties = common;
            adaptationSet.children.push(representation);

            return period;
        },

        getBaseUrlValuesMap = function () {
            var mpd,
                period,
                adaptationSet,
                representation,
                common;

            common = [
                {
                    name: 'BaseURL',
                    merge: true,
                    mergeFunction: function (parentValue, childValue) {
                        var mergedValue;

                        // child is absolute, don't merge
                        if (childValue.indexOf("http://") === 0) {
                            mergedValue = childValue;
                        } else {
                            mergedValue = parentValue + childValue;
                        }

                        return mergedValue;
                    }
                }
            ];

            mpd = {};
            mpd.name = "mpd";
            mpd.isRoot = true;
            mpd.isArray = true;
            mpd.parent = null;
            mpd.children = [];
            mpd.properties = common;

            period = {};
            period.name = "Period";
            period.isRoot = false;
            period.isArray = true;
            period.parent = null;
            period.children = [];
            period.properties = common;
            mpd.children.push(period);

            adaptationSet = {};
            adaptationSet.name = "AdaptationSet";
            adaptationSet.isRoot = false;
            adaptationSet.isArray = true;
            adaptationSet.parent = period;
            adaptationSet.children = [];
            adaptationSet.properties = common;
            period.children.push(adaptationSet);

            representation = {};
            representation.name = "Representation";
            representation.isRoot = false;
            representation.isArray = true;
            representation.parent = adaptationSet;
            representation.children = [];
            representation.properties = common;
            adaptationSet.children.push(representation);

            return mpd;
        },

        getDashMap = function () {
            var result = [];

            result.push(getCommonValuesMap());
            result.push(getSegmentValuesMap());
            result.push(getBaseUrlValuesMap());

            return result;
        },

        internalParse = function (data, baseUrl) {
            //this.debug.log("Doing parse.");

            var manifest,
                converter = new X2JS(matchers, '', true),
                iron = new ObjectIron(getDashMap()),
                start = new Date(),
                json = null,
                ironed = null;

            try {
                //this.debug.log("Converting from XML.");
                manifest = converter.xml_str2json(data);
                json = new Date();

                if (!manifest.hasOwnProperty("BaseURL")) {
                    //this.debug.log("Setting baseURL: " + baseUrl);
                    manifest.BaseURL = baseUrl;
                } else {
                    // Setting manifest's BaseURL to the first BaseURL
                    manifest.BaseURL = manifest.BaseURL_asArray[0];

                    if (manifest.BaseURL.toString().indexOf("http") !== 0) {
                        manifest.BaseURL = baseUrl + manifest.BaseURL;
                    }
                }

                //this.debug.log("Flatten manifest properties.");
                iron.run(manifest);
                ironed = new Date();

                this.debug.log("Parsing complete: ( xml2json: " + (json.getTime() - start.getTime()) + "ms, objectiron: " + (ironed.getTime() - json.getTime()) + "ms, total: " + ((ironed.getTime() - start.getTime()) / 1000) + "s)");

            } catch (e) {
                return Q.reject(null);
            }

            return Q.when(manifest);
        };

    return {
        debug: undefined,
        parse: internalParse
    };
};

Dash.dependencies.DashParser.prototype = {
    constructor: Dash.dependencies.DashParser
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.FragmentExtensions = function () {
    "use strict";

    var parseTFDT = function (ab) {
            var d = new DataView(ab),
                pos = 0,
                base_media_decode_time,
                version,
                size,
                type,
                i,
                c;

            while (type !== "tfdt" && pos < d.byteLength) {
                size = d.getUint32(pos); // subtract 8 for including the size and type
                pos += 4;

                type = "";
                for (i = 0; i < 4; i += 1) {
                    c = d.getInt8(pos);
                    type += String.fromCharCode(c);
                    pos += 1;
                }

                if (type !== "moof" && type !== "traf" && type !== "tfdt") {
                    pos += size - 8;
                }
            }

            if (pos === d.byteLength) {
                throw "Error finding live offset.";
            }

            version = d.getUint8(pos);

            this.debug.log("position: " + pos);

            if (version === 0) {
                pos += 4;
                base_media_decode_time = d.getUint32(pos, false);
            } else {
                pos += size - 16;
                base_media_decode_time = utils.Math.to64BitNumber(d.getUint32(pos + 4, false), d.getUint32(pos, false));
            }

            return {
                'version' : version,
                'base_media_decode_time' : base_media_decode_time
            };
        },

        parseSIDX = function (ab) {
            var d = new DataView(ab),
                pos = 0,
                version,
                timescale,
                earliest_presentation_time,
                i,
                type,
                size,
                charCode;

            while (type !== "sidx" && pos < d.byteLength) {
                size = d.getUint32(pos); // subtract 8 for including the size and type
                pos += 4;

                type = "";
                for (i = 0; i < 4; i += 1) {
                    charCode = d.getInt8(pos);
                    type += String.fromCharCode(charCode);
                    pos += 1;
                }

                if (type !== "moof" && type !== "traf" && type !== "sidx") {
                    pos += size - 8;
                } else if (type === "sidx") {
                    // reset the position to the beginning of the box...
                    // if we do not reset the position, the evaluation
                    // of sidxEnd to ab.byteLength will fail.
                    pos -= 8;
                }
            }

            version = d.getUint8(pos + 8);
            pos += 12;

            // skipped reference_ID(32)
            timescale = d.getUint32(pos + 4, false);
            pos += 8;

            if (version === 0) {
                earliest_presentation_time = d.getUint32(pos, false);
            } else {
                earliest_presentation_time = utils.Math.to64BitNumber(d.getUint32(pos + 4, false), d.getUint32(pos, false));
            }

            return Q.when({
                'earliestPresentationTime' : earliest_presentation_time,
                'timescale' : timescale
            });
        },

        loadFragment = function (media) {
            var deferred = Q.defer(),
                request = new XMLHttpRequest(),
                url,
                loaded = false,
                errorStr,
                parsed;

            url = media;

            request.onloadend = function () {
                if (!loaded) {
                    errorStr = "Error loading fragment: " + url;
                    deferred.reject(errorStr);
                }
            };

            request.onload = function () {
                loaded = true;
                parsed = parseTFDT(request.response);
                deferred.resolve(parsed);
            };

            request.onerror = function () {
                errorStr = "Error loading fragment: " + url;
                deferred.reject(errorStr);
            };

            request.responseType = "arraybuffer";
            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+url, false);
            // req_.send(null);
            // var url_ = req_.responseText;

            // request.open("GET", url_);
            //console.log("loadFragment");
            
            //console.log(request);

            request.open("GET", '/get_video_content?video_url='+url);
            var value ="XMLHttpPlayerRequest";
            //console.log(value);
            request.setRequestHeader("X-Requested-With", value);
            // request.setRequestHeader("X-Requested-With", "XMLHttpPlayerRequest-"+"bytes=" + info.range.start + "-" + info.range.end);

            //console.log('loda fragmenta');
            request.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            request.send(null);
            // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // //console.log($.cookie('CloudFront-Signature'));
            return deferred.promise;
        };

    return {
        debug : undefined,
        loadFragment : loadFragment,
        parseTFDT : parseTFDT,
        parseSIDX : parseSIDX
    };
};

Dash.dependencies.FragmentExtensions.prototype = {
    constructor: Dash.dependencies.FragmentExtensions
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.dependencies.TimelineConverter = function() {
    "use strict";

    var clientServerTimeShift = 0,

        calcAvailabilityTimeFromPresentationTime = function(presentationTime, mpd, isDynamic, calculateEnd) {
            var availabilityTime = NaN;

            if (calculateEnd) {
                //@timeShiftBufferDepth specifies the duration of the time shifting buffer that is guaranteed
                // to be available for a Media Presentation with type 'dynamic'.
                // When not present, the value is infinite.
                if (isDynamic && (mpd.timeShiftBufferDepth !== Number.POSITIVE_INFINITY)) {
                    availabilityTime = new Date(mpd.availabilityStartTime.getTime() + ((presentationTime + mpd.timeShiftBufferDepth) * 1000));
                } else {
                    availabilityTime = mpd.availabilityEndTime;
                }
            } else {
                if (isDynamic) {
                    availabilityTime = new Date(mpd.availabilityStartTime.getTime() + (presentationTime * 1000));
                } else {
                    // in static mpd, all segments are available at the same time
                    availabilityTime = mpd.availabilityStartTime;
                }
            }

            return availabilityTime;
        },

        calcAvailabilityStartTimeFromPresentationTime = function(presentationTime, mpd, isDynamic) {
            return calcAvailabilityTimeFromPresentationTime.call(this, presentationTime, mpd, isDynamic);
        },

        calcAvailabilityEndTimeFromPresentationTime = function(presentationTime, mpd, isDynamic) {
            return calcAvailabilityTimeFromPresentationTime.call(this, presentationTime, mpd, isDynamic, true);
        },

        calcPresentationStartTime = function(period) {
            var presentationStartTime,
                isDynamic = period.mpd.manifest.type === "dynamic",
                //ORANGE: fix bug on not updating URIFragmentDataVO
                startTimeOffset = parseInt(this.uriQueryFragModel.getURIFragmentData().s, 10);

            if (isDynamic) {

                if (!isNaN(startTimeOffset) && startTimeOffset > 1262304000) {

                    presentationStartTime = startTimeOffset - (period.mpd.availabilityStartTime.getTime() / 1000);

                    if (presentationStartTime > period.liveEdge ||
                        presentationStartTime < (period.liveEdge - period.mpd.timeShiftBufferDepth)) {

                        presentationStartTime = null;
                    }
                }
                presentationStartTime = presentationStartTime || period.liveEdge;

            } else {
                if (!isNaN(startTimeOffset) && startTimeOffset < period.duration && startTimeOffset >= 0) {
                    presentationStartTime = startTimeOffset;
                } else {
                    presentationStartTime = period.start;
                }
            }

            return presentationStartTime;
        },

        calcPresentationTimeFromWallTime = function(wallTime, period) {
            return ((wallTime.getTime() - period.mpd.availabilityStartTime.getTime()) / 1000);
        },

        calcPresentationTimeFromMediaTime = function(mediaTime, representation) {
            var presentationOffset = representation.presentationTimeOffset;

            return mediaTime - presentationOffset;
        },

        calcMediaTimeFromPresentationTime = function(presentationTime, representation) {
            var presentationOffset = representation.presentationTimeOffset;

            return (presentationOffset + presentationTime);
        },

        calcWallTimeForSegment = function(segment, isDynamic) {
            var suggestedPresentationDelay,
                displayStartTime,
                wallTime;

            if (isDynamic) {
                suggestedPresentationDelay = segment.representation.adaptation.period.mpd.suggestedPresentationDelay;
                displayStartTime = segment.presentationStartTime + suggestedPresentationDelay;
                wallTime = new Date(segment.availabilityStartTime.getTime() + (displayStartTime * 1000));
            }

            return wallTime;
        },

        calcActualPresentationTime = function(representation, currentTime, isDynamic) {
            var self = this,
                //periodStart = representation.adaptation.period.start,
                availabilityWindow = self.calcSegmentAvailabilityRange(representation, isDynamic),
                actualTime;

            // ORANGE: confusion to resolve between availabilityWindow.start and periodStart.
            // (in MSS case, periodStart is set to availabilityWindow.start)
            //if ((currentTime >= (availabilityWindow.start + periodStart)) && (currentTime <= (availabilityWindow.end + periodStart))) {
            if ((currentTime >= (availabilityWindow.start)) && (currentTime <= (availabilityWindow.end))) {
                return currentTime;
            }

            actualTime = Math.max(availabilityWindow.end - representation.adaptation.period.mpd.manifest.minBufferTime * 2, availabilityWindow.start);

            return actualTime;
        },

        calcSegmentAvailabilityRange = function(representation, isDynamic) {
            var duration = representation.segmentDuration,
                start = 0,
                end = representation.adaptation.period.duration,
                range = {
                    start: start,
                    end: end
                },
                checkTime,
                now;

            if (!isDynamic) {
                return range;
            }

            if ((!representation.adaptation.period.mpd.isClientServerTimeSyncCompleted || isNaN(duration)) && representation.segmentAvailabilityRange) {
                return representation.segmentAvailabilityRange;
            }

            checkTime = representation.adaptation.period.mpd.checkTime;
            now = calcPresentationTimeFromWallTime(new Date((new Date().getTime()) + clientServerTimeShift), representation.adaptation.period);
            //the Media Segment list is further restricted by the CheckTime together with the MPD attribute
            // MPD@timeShiftBufferDepth such that only Media Segments for which the sum of the start time of the
            // Media Segment and the Period start time falls in the interval [NOW- MPD@timeShiftBufferDepth - @duration, min(CheckTime, NOW)] are included.
            start = Math.max((now - representation.adaptation.period.mpd.timeShiftBufferDepth), 0);
            checkTime += (clientServerTimeShift / 1000);
            end = isNaN(checkTime) ? now : Math.min(checkTime, now);
            range = {
                start: start,
                end: end
            };

            return range;
        },

        /*liveEdgeFound = function(expectedLiveEdge, actualLiveEdge, period) {
            if (period.mpd.isClientServerTimeSyncCompleted) return;

            // the difference between expected and actual live edge time is supposed to be a difference between client
            // and server time as well
            period.mpd.clientServerTimeShift = actualLiveEdge - expectedLiveEdge;
            period.mpd.isClientServerTimeSyncCompleted = true;
            clientServerTimeShift = period.mpd.clientServerTimeShift * 1000;
        },*/

        calcMSETimeOffset = function(representation) {
            var presentationOffset = representation.presentationTimeOffset;

            return (-presentationOffset);
        };

    return {
        system: undefined,
        debug: undefined,
        uriQueryFragModel: undefined,

        setup: function() {
            //this.system.mapHandler("liveEdgeFound", undefined, liveEdgeFound.bind(this));
        },

        calcAvailabilityStartTimeFromPresentationTime: calcAvailabilityStartTimeFromPresentationTime,
        calcAvailabilityEndTimeFromPresentationTime: calcAvailabilityEndTimeFromPresentationTime,
        calcPresentationTimeFromWallTime: calcPresentationTimeFromWallTime,
        calcPresentationTimeFromMediaTime: calcPresentationTimeFromMediaTime,
        calcPresentationStartTime: calcPresentationStartTime,
        calcActualPresentationTime: calcActualPresentationTime,
        calcMediaTimeFromPresentationTime: calcMediaTimeFromPresentationTime,
        calcSegmentAvailabilityRange: calcSegmentAvailabilityRange,
        calcWallTimeForSegment: calcWallTimeForSegment,
        calcMSETimeOffset: calcMSETimeOffset
    };
};

Dash.dependencies.TimelineConverter.prototype = {
    constructor: Dash.dependencies.TimelineConverter
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.AdaptationSet = function () {
    "use strict";
    this.period = null;
    this.index = -1;
};

Dash.vo.AdaptationSet.prototype = {
    constructor: Dash.vo.AdaptationSet
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Fraunhofer Fokus
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.Event = function () {
    "use strict";
    this.duration = NaN;
    this.presentationTime = NaN;
    this.id = NaN;
    this.messageData = "";
    this.eventStream = null;
    this.presentationTimeDelta = NaN; // Specific EMSG Box paramater

};

Dash.vo.Event.prototype = {
    constructor: Dash.vo.Event
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Fraunhofer Fokus
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.EventStream = function () {
    "use strict";
    this.adaptionSet = null;
    this.representation = null;
    this.period = null;
    this.timescale = 1;
    this.value = "";
    this.schemeIdUri = "";
};

Dash.vo.EventStream.prototype = {
    constructor: Dash.vo.EventStream
};

/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.Mpd = function () {
    "use strict";
    this.manifest = null;
    this.suggestedPresentationDelay = 0;
    this.availabilityStartTime = null;
    this.availabilityEndTime = Number.POSITIVE_INFINITY;
    this.timeShiftBufferDepth = Number.POSITIVE_INFINITY;
    this.maxSegmentDuration = Number.POSITIVE_INFINITY;
    this.checkTime = NaN;
    this.clientServerTimeShift = 0;
    this.isClientServerTimeSyncCompleted = false;
};

Dash.vo.Mpd.prototype = {
    constructor: Dash.vo.Mpd
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.Period = function () {
    "use strict";
    this.id = null;
    this.index = -1;
    this.duration = NaN;
    this.start = NaN;
    this.mpd = null;
    this.liveEdge = NaN;
};

Dash.vo.Period.prototype = {
    constructor: Dash.vo.Period
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.Representation = function () {
    "use strict";
    this.id = null;
    this.index = -1;
    this.adaptation = null;
    this.segmentInfoType = null;
    this.initialization = null;
    this.segmentDuration = NaN;
    this.timescale = 1;
    this.startNumber = 1;
    this.indexRange = null;
    this.range = null;
    this.presentationTimeOffset = 0;
    // Set the source buffer timeOffset to this
    this.MSETimeOffset = NaN;
    this.segmentAvailabilityRange = null;
    this.availableSegmentsNumber = 0;
};

Dash.vo.Representation.prototype = {
    constructor: Dash.vo.Representation
};
/*
 * The copyright in this software is being made available under the BSD License, included below. This software may be subject to other third party and contributor rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Digital Primates
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Digital Primates nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Dash.vo.Segment = function () {
    "use strict";
    this.indexRange = null;
    this.index = null;
    this.mediaRange = null;
    this.media = null;
    this.duration = NaN;
    // this is the time that should be inserted into the media url
    this.replacementTime = null;
    // this is the number that should be inserted into the media url
    this.replacementNumber = NaN;
    // This is supposed to match the time encoded in the media Segment
    this.mediaStartTime = NaN;
    // When the source buffer timeOffset is set to MSETimeOffset this is the
    // time that will match the seekTarget and video.currentTime
    this.presentationStartTime = NaN;
    // Do not schedule this segment until
    this.availabilityStartTime = NaN;
    // Ignore and  discard this segment after
    this.availabilityEndTime = NaN;
    // The index of the segment inside the availability window
    this.availabilityIdx = NaN;
    // For dynamic mpd's, this is the wall clock time that the video
    // element currentTime should be presentationStartTime
    this.wallStartTime = NaN;
    this.representation = null;
};

Dash.vo.Segment.prototype = {
    constructor: Dash.vo.Segment
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * Defines the public interface for all ProtectionModel implementations.
 *
 * ProtectionModel implementations provide access to particular versions
 * of the Encrypted Media Extensions (EME) APIs that have been implemented
 * in a user agent.  Developers wishing to add support for a new EME version
 * found in a target user-agent should add a new instance of this interface
 * to the
 *
 * Applications should not need direct access to this object.  All interactions with
 * the protection system should be performed with
 * {@link MediaPlayer.dependencies.ProtectionController}
 *
 * @interface MediaPlayer.models.ProtectionModel
 */

MediaPlayer.models.ProtectionModel = function() { };

/**
 * Returns an array of all initialization data currently used by
 * active sessions.
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#getAllInitData
 * @returns {ArrayBuffer[]} an array of initialization data buffers
 */

/**
 * Determine if the user-agent supports one of the given key systems and
 * content type configurations. Sends ENAME_KEY_SYSTEM_ACCESS_COMPLETE event
 * with a KeySystemAccess object as event data
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#requestKeySystemAccess
 * @param {Object[]} ksConfigurations array of desired key system
 * configurations in priority order (highest priority first)
 * @param {MediaPlayer.dependencies.protection.KeySystem} ksConfigurations.ks
 * the key system
 * @param {MediaPlayer.vo.protection.KeySystemConfiguration[]} ksConfigurations.configs
 * array of acceptable key system configurations
 * for this key system in priority order (highest priority first)
 */

/**
 * Selects the key system to use for all future operations on this
 * ProtectionModel.  Sends ENAME_KEY_SYSTEM_SELECTED with no data
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#selectKeySystem
 * @param keySystemAccess {MediaPlayer.vo.protection.KeySystemAccess} the key
 * system access token representing a supported key system
 */

/**
 * Associate this protection model with a HTMLMediaElement
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#setMediaElement
 * @param mediaElement {HTMLMediaElement} the media element to
 * which we should associate this protection model and all current
 * key sessions
 */

/**
 * Creates a new key session using the given initData and type. Sends
 * ENAME_KEY_SESSION_CREATED event with MediaPlayer.vo.protection.SessionToken
 * as data.
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#createKeySession
 * @param {ArrayBuffer} initData PSSH box for the currently selected
 * key system.
 * @param {string} sessionType the desired session type.  One of "temporary",
 * "persistent-license", "persistent-release-message".  CDM implementations
 * are not required to support anything except "temporary"
 */

/**
 * Update the given key session with a key (or any other message
 * intended for the CDM)
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#updateKeySession
 * @param {MediaPlayer.vo.protection.SessionToken} sessionToken the session
 * token
 * @param {ArrayBuffer} message the message that should be delivered to the CDM
 * for this session
 */

/**
 * Loads the persisted key session data associated with the given sessionID
 * into a new session.  Sends ENAME_KEY_SESSION_CREATED event with
 * {@MediaPlayer.vo.protection.SessionToken} as data.
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#loadKeySession
 * @param {string} sessionID the session ID corresponding to the persisted
 * session data to be loaded
 */

/**
 * Removes any persisted key session data associated with the given session.
 * Also closes the session.  Sends ENAME_KEY_SESSION_REMOVED and
 * ENAME_KEY_SESSION_CLOSED with sessionID as data
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#removeKeySession
 * @param {MediaPlayer.vo.protection.SessionToken} sessionToken the session
 * token
 */

/**
 * Close the given session and release all associated keys.  Following
 * this call, the sessionToken becomes invalid.  Sends ENAME_KEY_SESSION_CLOSED
 * with sessionID as data
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#closeKeySession
 * @param sessionToken the session token
 */

/**
 * Sets the certificate to be used by the CDM for encrypting messages
 *
 * @function
 * @name MediaPlayer.models.ProtectionModel#setServerCertificate
 * @param {ArrayBuffer} serverCertificate
 */

/**
 * Currently selected key system.  Will be null or undefined if no key
 * system has yet been selected
 *
 * @instance
 * @name keySystem
 * @memberof MediaPlayer.models.ProtectionModel
 * @readonly
 * @type MediaPlayer.dependencies.protection.KeySystem
 */


/**
 * Event IDs for events sent by ProtectionModel implementations. Use these
 * event names when subscribing or unsubscribing from ProtectionModel events.
 *
 * @enum {String}
 */
MediaPlayer.models.ProtectionModel.eventList = {
    /**
     * Event ID for needkey/encrypted events
     *
     * @constant
     */
    ENAME_NEED_KEY: "needkey",
    /**
     * Event ID for events delivered when a key system access procedure
     * has completed
     *
     * @constant
     */
    ENAME_KEY_SYSTEM_ACCESS_COMPLETE: "keySystemAccessComplete",
    /**
     * Event ID for events delivered when a key system selection procedure
     * completes
     *
     * @constant
     */
    ENAME_KEY_SYSTEM_SELECTED: "keySystemSelected",
    /**
     * Event ID for events delivered when a HTMLMediaElement has been
     * associated with the protection set
     *
     * @constant
     */
    ENAME_VIDEO_ELEMENT_SELECTED: "videoElementSelected",
    /**
     * Event ID for events delivered when a new server certificate has
     * been delivered to the CDM
     *
     * @constant
     */
    ENAME_SERVER_CERTIFICATE_UPDATED: "serverCertificateUpdated",
    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     *
     * @constant
     */
    ENAME_KEY_MESSAGE: "keyMessage",
    /**
     * Event ID for events delivered when a new key has been added
     *
     * @constant
     * @deprecated The latest versions of the EME specification no longer
     * use this event.  {@MediaPlayer.models.protectionModel.eventList.ENAME_KEY_STATUSES_CHANGED}
     * is preferred.
     */
    ENAME_KEY_ADDED: "keyAdded",
    /**
     * Event ID for events delivered when an error is encountered by the CDM
     * while processing a license server response message
     *
     * @constant
     */
    ENAME_KEY_ERROR: "keyError",
    /**
     * Event ID for events delivered when a new key sessions creation
     * process has completed
     *
     * @constant
     */
    ENAME_KEY_SESSION_CREATED: "keySessionCreated",
    /**
     * Event ID for events delivered when a key session removal
     * process has completed
     *
     * @constant
     */
    ENAME_KEY_SESSION_REMOVED: "keySessionRemoved",
    /**
     * Event ID for events delivered when a key session close
     * process has completed
     *
     * @constant
     */
    ENAME_KEY_SESSION_CLOSED: "keySessionClosed",
    /**
     * Event ID for events delivered when the status of one or more
     * decryption keys has changed
     *
     * @constant
     */
    ENAME_KEY_STATUSES_CHANGED: "keyStatusesChanged",
    /**
     * Event ID for events delivered when the process of shutting down
     * a protection set has completed
     *
     * @constant
     */
    ENAME_TEARDOWN_COMPLETE: "protectionTeardownComplete",
};

/**
 * needkey/encrypted event
 */

/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.copyMethods = function(clazz) {
    var rslt = new clazz();
    rslt.parent = {};
    for (var key in rslt) {
        rslt.parent[key] = rslt[key];
    }

    rslt.setup = function() {
        for (var att in this.parent) {
            if (this.parent[att] === undefined) {
                this.parent[att] = this[att];
            }
        }
    };

    return rslt;
};

 /*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.DOMParser = function() {
    "use strict";

    var _parser = null,
        _xmlDoc = null;

    return {
        getAllSpecificNodes: function(mainNode, nodeName) {
            var i = 0,
                id,
                querySelectorResult,
                returnTab = [];

            if (mainNode) {
                querySelectorResult = mainNode.querySelectorAll(nodeName);
                if (querySelectorResult) {
                    for (i = 0; i < querySelectorResult.length; i++) {
                        id = this.getAttributeValue(querySelectorResult[i], 'xml:id');
                        if (id) {
                            returnTab[id] = querySelectorResult[i].attributes;
                        }
                    }
                }
            }

            return returnTab;
        },

        getAttributeName: function(node, attrValue) {
            var returnValue = [],
                domAttribute = null,
                i = 0,
                attribList = null;

            if (node && node.attributes) {
                attribList = node.attributes;
                if (attribList) {
                    for (i = 0; i < attribList.length; i++) {
                        domAttribute = attribList[i];
                        if (domAttribute.value === attrValue) {
                            returnValue.push(domAttribute.name);
                        }
                    }
                }
            }

            return returnValue;
        },

        getAttributeValue: function(node, attrName) {
            var returnValue = null,
                domElem = null,
                attribList = null;

            if (node && node.attributes) {
                attribList = node.attributes;
                if (attribList) {
                    domElem = attribList.getNamedItem(attrName);
                    if (domElem) {
                        returnValue = domElem.value;
                        return returnValue;
                    }
                }
            }

            return returnValue;
        },

        getChildNode: function(nodeParent, childName) {
            var i = 0,
                element;

            if (nodeParent && nodeParent.childNodes) {
                for (i = 0; i < nodeParent.childNodes.length; i++) {
                    element = nodeParent.childNodes[i];
                    if (element.nodeName === childName) {
                        return element;
                    }
                    element = undefined;
                }
            }

            return element;
        },

        getChildNodes: function(nodeParent, childName) {
            var i = 0,
                element = [];

            if (nodeParent && nodeParent.childNodes) {
                for (i = 0; i < nodeParent.childNodes.length; i++) {
                    if (nodeParent.childNodes[i].nodeName === childName) {
                        element.push(nodeParent.childNodes[i]);
                    }
                }
            }

            return element;
        },

        createXmlTree: function(xmlDocStr) {
            if (window.DOMParser) {
                try {
                    if (!_parser) {
                        _parser = new window.DOMParser();
                    }

                    _xmlDoc = _parser.parseFromString(xmlDocStr, "text/xml");
                    if (_xmlDoc.getElementsByTagName('parsererror').length > 0) {
                        throw new Error('Error parsing XML');
                    }
                } catch (e) {
                    _xmlDoc = null;
                }
            }
            return _xmlDoc;
        }
    };
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
MediaPlayer.utils.ObjectIron = function (map) {

    var lookup;

    // create a list of top level items to search for
    lookup = [];
    for (var i = 0, len = map.length; i < len; i += 1) {
        if (map[i].isRoot) {
            lookup.push("root");
        } else {
            lookup.push(map[i].name);
        }
    }

    var mergeValues = function (parentItem, childItem) {
            var name;
            if (parentItem === null || childItem === null) {
                return;
            }

            for (name in parentItem) {
                if (parentItem.hasOwnProperty(name)) {
                    if (!childItem.hasOwnProperty(name)) {
                        childItem[name] = parentItem[name];
                    }
                }
            }
        },

        mapProperties = function (properties, parent, child) {
            var i,
                len,
                property,
                parentValue,
                childValue;

            if (properties === null || properties.length === 0) {
                return;
            }

            for (i = 0, len = properties.length; i < len; i += 1) {
                property = properties[i];

                if (parent.hasOwnProperty(property.name)) {
                    if (child.hasOwnProperty(property.name)) {
                        // check to see if we should merge
                        if (property.merge) {
                           parentValue = parent[property.name];
                           childValue = child[property.name];

                            // complex objects; merge properties
                            if (typeof parentValue === 'object' && typeof childValue === 'object') {
                                mergeValues(parentValue, childValue);
                            }
                            // simple objects; merge them together
                            else {
                                if (property.mergeFunction !== null) {
                                    child[property.name] = property.mergeFunction(parentValue, childValue);
                                } else {
                                    child[property.name] = parentValue + childValue;
                                }
                            }
                        }
                    } else {
                        // just add the property
                        child[property.name] = parent[property.name];
                    }
                }
            }
        },

        mapItem = function (obj, node) {
            var item = obj,
                i,
                len,
                v,
                len2,
                array,
                childItem,
                childNode;

            if (obj.transformFunc) {
                node = obj.transformFunc(node);
            }

            if (item.children === null || item.children.length === 0) {
                return node;
            }

            for (i = 0, len = item.children.length; i < len; i += 1) {
                childItem = item.children[i];
                var itemMapped = null;
                if (node.hasOwnProperty(childItem.name)) {
                    if (childItem.isArray) {
                        array = node[childItem.name + "_asArray"];
                        for (v = 0, len2 = array.length; v < len2; v += 1) {
                            childNode = array[v];
                            mapProperties(item.properties, node, childNode);
                            //copy result in source object
                            itemMapped = mapItem(childItem, childNode);
                            node[childItem.name + "_asArray"][v] = itemMapped;
                            node[childItem.name][v] =  itemMapped;
                        }
                    } else {
                        childNode = node[childItem.name];
                        mapProperties(item.properties, node, childNode);
                        //copy result in source object
                        itemMapped = mapItem(childItem, childNode);
                        node[childItem.name] = itemMapped;
                        node[childItem.name + "_asArray"] =  [itemMapped];
                    }
                }
            }
            return node;
        },

        performMapping = function (source) {
            var i,
                len,
                pi,
                pp,
                item,
                node,
                array;

            if (source === null) {
                return source;
            }

            if (typeof source !== 'object') {
                return source;
            }

            // first look to see if anything cares about the root node
            for (i = 0, len = lookup.length; i < len; i += 1) {
                if (lookup[i] === "root") {
                    item = map[i];
                    node = source;
                    source = mapItem(item, node);
                    // node == source;
                }
            }

            // iterate over the objects and look for any of the items we care about
            for (pp in source) {
                if (source.hasOwnProperty(pp)) {
                    pi = lookup.indexOf(pp);
                    if (pi !== -1) {
                        item = map[pi];

                        if (item.isArray) {
                            array = source[pp + "_asArray"];
                            for (i = 0, len = array.length; i < len; i += 1) {
                                node = array[i];
                                source[pp][i] = mapItem(item, node);
                                source[pp + "_asArray"][i] = mapItem(item, node);
                            }
                        } else {
                            node = source[pp];
                            source[pp] = mapItem(item, node);
                            source[pp + "_asArray"] = [mapItem(item, node)];
                        }
                    }
                    // now check this to see if he has any of the properties we care about
                    source[pp] = performMapping(source[pp]);
                }
            }

            return source;
        };

    return {
        run: performMapping
    };
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

MediaPlayer.dependencies.protection.CommonEncryption = {

    /**
     * Find and return the ContentProtection element in the given array
     * that indicates support for MPEG Common Encryption
     *
     * @param cpArray array of content protection elements
     * @returns the Common Encryption content protection element or
     * null if one was not found
     */
    findCencContentProtection: function(cpArray) {
        var retVal = null,
            i = 0,
            cp;
        for (i = 0; i < cpArray.length; ++i) {
            cp = cpArray[i];
            if (cp.schemeIdUri.toLowerCase() === "urn:mpeg:dash:mp4protection:2011" &&
                cp.value.toLowerCase() === "cenc")
                retVal = cp;
        }
        return retVal;
    },

    /**
     * Returns just the data portion of a single PSSH
     *
     * @param pssh {ArrayBuffer} the PSSH
     * @return {ArrayBuffer} data portion of the PSSH
     */
    getPSSHData: function(pssh) {
        var offset = 8, // Box size and type fields
            view = new DataView(pssh),
            // Read version
            version = view.getUint8(offset);

        offset += 20; // Version (1), flags (3), system ID (16)

        if (version > 0) {
            offset += 4 + (16 * view.getUint32(offset)); // Key ID count (4) and All key IDs (16*count)
        }

        offset += 4; // Data size
        return pssh.slice(offset);
    },

    /**
     * Returns the PSSH associated with the given key system from the concatenated
     * list of PSSH boxes in the given initData
     *
     * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the desired
     * key system
     * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
     * @returns {ArrayBuffer} The PSSH box data corresponding to the given key system
     * or null if a valid association could not be found.
     */
    getPSSHForKeySystem: function(keySystem, initData) {
        var psshList = MediaPlayer.dependencies.protection.CommonEncryption.parsePSSHList(initData);
        if (psshList.hasOwnProperty(keySystem.uuid.toLowerCase())) {
            return psshList[keySystem.uuid.toLowerCase()];
        }
        return null;
    },

    /**
     * Parse a standard common encryption PSSH which contains a sinmple
     * base64-encoding of the init data
     *
     * @param cpData the ContentProtection element
     * @returns {ArrayBuffer} the init data or null if not found
     */
    parseInitDataFromContentProtection: function(cpData) {
        if (cpData && ("pssh" in cpData)) {
            return BASE64.decodeArray(cpData.pssh.__text).buffer;
        }
        return null;
    },

    readBytes: function(buf, pos, nbBytes) {
        var value = 0,
            i = 0;

        for (i = 0; i < nbBytes; i++) {
            value = value << 8;
            value = value + buf[pos];
            pos++;
        }
        return value;
    },

    /**
     * Parses list of PSSH boxes into keysystem-specific PSSH data
     *
     * @param data {ArrayBuffer} the concatenated list of PSSH boxes as provided by
     * CDM as initialization data when CommonEncryption content is detected
     * @returns {object} an object that has a property named according to each of
     * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
     * and a ArrayBuffer (the entire PSSH box) as the property value
     */
    parsePSSHList: function(data) {

        if (data === null)
            return [];

        var buffer = data,
            done = false,
            pssh = {},
            // TODO: Need to check every data read for end of buffer
            byteCursor = 0,
            size,
            nextBox,
            version,
            systemID,
            psshDataSize,
            boxStart,
            i,
            val;

        if (!data.buffer) {
            buffer = new Uint8Array(data);
        }

        while (!done) {

            boxStart = byteCursor;

            if (byteCursor >= buffer.byteLength)
                break;

            /* Box size */
            size = this.readBytes(buffer, byteCursor, 4);
            nextBox = byteCursor + size;
            byteCursor += 4;

            /* Verify PSSH */
            if (this.readBytes(buffer, byteCursor, 4) !== 0x70737368) {
                byteCursor = nextBox;
                continue;
            }
            byteCursor += 4;

            /* Version must be 0 or 1 */
            version = this.readBytes(buffer, byteCursor, 1);
            if (version !== 0 && version !== 1) {
                byteCursor = nextBox;
                continue;
            }
            byteCursor += 1;

            byteCursor += 3; /* skip flags */

            // 16-byte UUID/SystemID
            systemID = "";

            for (i = 0; i < 4; i++) {
                val = this.readBytes(buffer, (byteCursor + i), 1).toString(16);
                systemID += (val.length === 1) ? "0" + val : val;
            }
            byteCursor += 4;
            systemID += "-";
            for (i = 0; i < 2; i++) {
                val = this.readBytes(buffer, (byteCursor + i), 1).toString(16);
                systemID += (val.length === 1) ? "0" + val : val;
            }
            byteCursor += 2;
            systemID += "-";
            for (i = 0; i < 2; i++) {
                val = this.readBytes(buffer, (byteCursor + i), 1).toString(16);
                systemID += (val.length === 1) ? "0" + val : val;
            }
            byteCursor += 2;
            systemID += "-";
            for (i = 0; i < 2; i++) {
                val = this.readBytes(buffer, (byteCursor + i), 1).toString(16);
                systemID += (val.length === 1) ? "0" + val : val;
            }
            byteCursor += 2;
            systemID += "-";
            for (i = 0; i < 6; i++) {
                val = this.readBytes(buffer, (byteCursor + i), 1).toString(16);
                systemID += (val.length === 1) ? "0" + val : val;
            }
            byteCursor += 6;

            systemID = systemID.toLowerCase();

            /* PSSH Data Size */
            psshDataSize = this.readBytes(buffer, byteCursor, 4);
            byteCursor += 4;

            /* PSSH Data */
            //pssh[systemID] = buffer.slice(boxStart, nextBox);
            pssh[systemID] = buffer.subarray(boxStart, nextBox).buffer;
            byteCursor = nextBox;
        }

        return pssh;
    },


    /**
     * Returns list of {MediaPlayer.vo.protection.KeySystemConfiguration}
     * (see: https://w3c.github.io/encrypted-media/#idl-def-MediaKeySystemConfiguration)
     *
     * @param {object} videoCodec contains relevant info about video codec
     * @param {object} audioCodec contains relevant info about audio codec
     * @param {String} sessionType the session type like "temporary" or "persistent-license"
     * @returns {Array} list of {MediaPlayer.vo.protection.KeySystemConfiguration}
     */
    getKeySystemConfigurations: function(videoCodec, audioCodec, sessionType) {
        var audioCapabilities = [],
            videoCapabilities = [];
        if (videoCodec) {
            videoCapabilities.push(new MediaPlayer.vo.protection.MediaCapability(videoCodec));
        }
        if (audioCodec) {
            audioCapabilities.push(new MediaPlayer.vo.protection.MediaCapability(audioCodec));
        }
        return [new MediaPlayer.vo.protection.KeySystemConfiguration(
            audioCapabilities, videoCapabilities, "optional", (sessionType === "temporary") ? "optional" : "required", [sessionType])];
    }
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Provides access to media protection information and functionality.  Each
 * ProtectionController manages a single {@link MediaPlayer.models.ProtectionModel}
 * which encapsulates a set of protection information (EME APIs, selected key system,
 * key sessions).  The APIs of ProtectionController mostly align with the latest EME
 * APIs.  Key system selection is mostly automated when combined with app-overrideable
 * functionality provided in {@link MediaPlayer.dependencies.ProtectionExtensions}.
 *
 * @class MediaPlayer.dependencies.ProtectionController
 * @todo ProtectionController does almost all of its tasks automatically after init() is
 * called.  Applications might want more control over this process and want to go through
 * each step manually (key system selection, session creation, session maintenance).
 */

// Define ArrayBuffer.isView method in case it is not defined (like in IE11 for example)
if (!ArrayBuffer.isView) {
    ArrayBuffer.isView = function(data) {
        return data instanceof ArrayBuffer;
    };
}

if (!ArrayBuffer.prototype.slice) {
    ArrayBuffer.prototype.slice = function(begin, end) {
        var len = this.byteLength,
            length,
            target,
            targetArray;
        begin = (begin | 0) || 0;
        end = end === (void 0) ? len : (end | 0);

        // Handle negative values.
        if (begin < 0) {
            begin = Math.max(begin + len, 0);
        }
        if (end < 0) {
            end = Math.max(end + len, 0);
        }

        if (len === 0 || begin >= len || begin >= end) {
            return new ArrayBuffer(0);
        }

        length = Math.min(len - begin, end - begin);
        target = new ArrayBuffer(length);
        targetArray = new Uint8Array(target);
        targetArray.set(new Uint8Array(this, begin, length));
        return target;
    };
}

MediaPlayer.dependencies.ProtectionController = function() {
    "use strict";

    var keySystems = null,
        pendingNeedKeyData = [],
        //audioInfo,
        //videoInfo,
        audioCodec,
        videoCodec,
        protDataSet,
        xhrLicense = null,
        initialized = false,

        getProtData = function(keySystem) {
            var protData = null,
                keySystemString = keySystem.systemString;
            if (protDataSet) {
                protData = (keySystemString in protDataSet) ? protDataSet[keySystemString] : null;
            }
            return protData;
        },

        selectKeySystem = function(supportedKS, fromManifest) {

            var self = this,
                sessionType,
                // Build our request object for requestKeySystemAccess
                requestedKeySystems = [],
                keySystemsInfo = [],
                ksIdx,
                ksAccess,
                i = 0,
                ksSelected,
                keySystemAccess;

            self.debug.log("[DRM] Select key system");

            if (this.keySystem) {
                // We have a key system
                for (ksIdx = 0; ksIdx < supportedKS.length; ksIdx++) {
                    if (this.keySystem === supportedKS[ksIdx].ks) {
                        sessionType = supportedKS[ksIdx].ks.sessionType;
                        requestedKeySystems.push({
                            ks: supportedKS[ksIdx].ks,
                            configs: supportedKS[ksIdx].ks.getKeySystemConfigurations(videoCodec, audioCodec, sessionType)
                        });
                        // Key system info in case of error
                        keySystemsInfo.push({
                            schemeIdURI: supportedKS[ksIdx].ks.schemeIdURI,
                            systemString: supportedKS[ksIdx].ks.systemString
                        });

                        // Ensure that we would be granted key system access using the key
                        // system and codec information
                        ksAccess = {};
                        ksAccess[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE] = function(event) {
                            if (event.error) {
                                //if (!fromManifest) {
                                self.eventBus.dispatchEvent({
                                    type: MediaPlayer.dependencies.ProtectionController.events.KEY_SYSTEM_SELECTED,
                                    error: "[DRM] KeySystem Access Denied! -- " + event.error
                                });
                                //}
                            } else {
                                self.debug.log("[DRM] KeySystem Access Granted");
                                self.eventBus.dispatchEvent({
                                    type: MediaPlayer.dependencies.ProtectionController.events.KEY_SYSTEM_SELECTED,
                                    data: event.data
                                });
                                self.createKeySession(supportedKS[ksIdx].initData, supportedKS[ksIdx].cdmData);
                            }
                        };
                        this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, ksAccess, undefined, true);
                        this.protectionModel.requestKeySystemAccess(requestedKeySystems);
                        break;
                    }
                }
            } else if (this.keySystem === undefined) {
                // First time through, so we need to select a key system
                this.keySystem = null;
                pendingNeedKeyData.push(supportedKS);

                // Add all key systems to our request list since we have yet to select a key system
                for (i = 0; i < supportedKS.length; i++) {
                    sessionType = supportedKS[i].ks.sessionType;
                    requestedKeySystems.push({
                        ks: supportedKS[i].ks,
                        configs: supportedKS[i].ks.getKeySystemConfigurations(videoCodec, audioCodec, sessionType)
                    });
                    // Key system info in case of error
                    keySystemsInfo.push({
                        schemeIdURI: supportedKS[i].ks.schemeIdURI,
                        systemString: supportedKS[i].ks.systemString
                    });
                }

                ksSelected = {};

                ksSelected[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE] = function(event) {
                    if (event.error) {
                        self.debug.log("[DRM] KeySystem Access Denied!");
                        self.keySystem = undefined;
                        self.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED, ksSelected);
                        if (!fromManifest) {
                            self.eventBus.dispatchEvent({
                                type: MediaPlayer.dependencies.ProtectionController.events.KEY_SYSTEM_SELECTED,
                                error: "[DRM] KeySystem Access Denied! -- " + event.error
                            });
                        }
                        self.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                            new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYSYSERR_ACCESS_DENIED, "No KeySystem/CDM available", {keySystems: keySystemsInfo}));
                    } else {
                        keySystemAccess = event.data;
                        self.debug.log("[DRM] KeySystem Access (" + keySystemAccess.keySystem.systemString + ") Granted!  Selecting key system...");
                        self.protectionModel.selectKeySystem(keySystemAccess);
                    }
                };
                ksSelected[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED] = function(event) {
                    if (!event.error) {
                        self.debug.log("[DRM] KeySystem selected => create key session");
                        self.keySystem = self.protectionModel.keySystem;
                        self.eventBus.dispatchEvent({
                            type: MediaPlayer.dependencies.ProtectionController.events.KEY_SYSTEM_SELECTED,
                            data: keySystemAccess
                        });
                        for (i = 0; i < pendingNeedKeyData.length; i++) {
                            for (ksIdx = 0; ksIdx < pendingNeedKeyData[i].length; ksIdx++) {
                                if (self.keySystem === pendingNeedKeyData[i][ksIdx].ks) {
                                    self.createKeySession(pendingNeedKeyData[i][ksIdx].initData, pendingNeedKeyData[i][ksIdx].cdmData);
                                    break;
                                }
                            }
                        }
                    } else {
                        self.keySystem = undefined;
                        if (!fromManifest) {
                            self.eventBus.dispatchEvent({
                                type: MediaPlayer.dependencies.ProtectionController.events.KEY_SYSTEM_SELECTED,
                                error: "[DRM] Error selecting key system! -- " + event.error
                            });
                        }
                        self.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                            new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYSYSERR_ACCESS_DENIED, "No KeySystem/CDM available", {keySystems: keySystemsInfo}));

                    }
                };
                this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED, ksSelected, undefined, true);
                this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, ksSelected, undefined, true);

                this.protectionModel.requestKeySystemAccess(requestedKeySystems);
            } else {
                // We are in the process of selecting a key system, so just save the data
                pendingNeedKeyData.push(supportedKS);
            }
        },

        /*sendLicenseRequestCompleteEvent = function(data) {
            this.eventBus.dispatchEvent({
                type: MediaPlayer.dependencies.ProtectionController.events.LICENSE_REQUEST_COMPLETE,
                data: data
            });
        },*/

        onKeyMessage = function(e) {
            var self = this,
                licenseMessage = null,
                keyMessage,
                messageType;

            keyMessage = e.data;
            messageType = (keyMessage.messageType) ? keyMessage.messageType : "license-request";
            this.debug.log("[DRM] Key message: type = " + messageType);

            // Dispatch event to applications indicating we received a key message
            this.eventBus.dispatchEvent({
                type: MediaPlayer.dependencies.ProtectionController.events.KEY_MESSAGE,
                data: keyMessage
            });

            var message = keyMessage.message,
                sessionToken = keyMessage.sessionToken,
                protData = getProtData(this.keySystem),
                keySystemString = this.keySystem.systemString,
                licenseServerData = this.protectionExt.getLicenseServer(this.keySystem, protData, messageType),
                needFailureReport = true/*,
                eventData = {
                    sessionToken: sessionToken,
                    messageType: messageType
                }*/;

            // Ensure message from CDM is not empty
            if (!message || message.byteLength === 0) {
                this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                    new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_NO_CHALLENGE, "Empty key message from CDM"));
                return;
            }

            // Message not destined for license server
            if (!licenseServerData) {
                this.debug.log("[DRM] License server request not required for this message (type = " + e.data.messageType + ").  Session ID = " + sessionToken.getSessionID());
                return;
            }

            // Perform any special handling for ClearKey
            if (this.protectionExt.isClearKey(this.keySystem)) {
                var clearkeys = this.protectionExt.processClearKeyLicenseRequest(protData, message);
                if (clearkeys) {
                    this.debug.log("[DRM] ClearKey license request handled by application!");
                    this.protectionModel.updateKeySession(sessionToken, clearkeys);
                    return;
                }
            }

            // All remaining key system scenarios require a request to a remote license server
            xhrLicense = new XMLHttpRequest();

            // Determine license server URL
            var url = null;
            if (protData) {
                if (protData.serverURL) {
                    var serverURL = protData.serverURL;
                    if (typeof serverURL === "string" && serverURL !== "") {
                        url = serverURL;
                    } else if (typeof serverURL === "object" && serverURL.hasOwnProperty(messageType)) {
                        url = serverURL[messageType];
                    }
                } else if (protData.laURL && protData.laURL !== "") { // TODO: Deprecated!
                    url = protData.laURL;
                }
            }

            if (url === null) {
                url = this.keySystem.getLicenseServerURLFromInitData(MediaPlayer.dependencies.protection.CommonEncryption.getPSSHData(sessionToken.initData));
                if (!url) {
                    url = e.data.defaultURL;
                }
            }
            // Possibly update or override the URL based on the message
            url = licenseServerData.getServerURLFromMessage(url, message, messageType);

            this.debug.log("[DRM] Licenser server url: " + url);

            // Ensure valid license server URL
            if (!url) {
                this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                    new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_URL_LICENSER_UNKNOWN, "No license server URL specified"));
                return;
            }

            xhrLicense.open(licenseServerData.getHTTPMethod(messageType), url, true);
            xhrLicense.responseType = licenseServerData.getResponseType(keySystemString, messageType);
            xhrLicense.onload = function() {

                if (this.status < 200 || this.status > 299) {
                    return;
                }

                if (this.status === 200 && this.readyState === 4) {
                    self.debug.log("[DRM] Received license response");
                    needFailureReport = false;
                    licenseMessage = licenseServerData.getLicenseMessage(this.response, keySystemString, messageType);
                    if (licenseMessage !== null) {
                        needFailureReport = false;
                        self.protectionModel.updateKeySession(sessionToken, licenseMessage);
                    } else {
                        needFailureReport = true;
                    }
                }
            };

            xhrLicense.onerror = xhrLicense.onloadend = function() {
                if (!needFailureReport) {
                    xhrLicense = null;
                    return;
                }
                needFailureReport = false;

                // send error only if request has  not been aborted by reset
                if (!this.aborted) {
                    self.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                        new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_LICENSER_ERROR, "License request failed", {
                            url: url,
                            status: this.status,
                            error: (this.response && this.response !== null) ? licenseServerData.getErrorResponse(this.response) : ""
                        }));
                }
                xhrLicense = null;
            };

            // Set optional XMLHttpRequest headers from protection data and message
            var updateHeaders = function(headers) {
                var key;
                if (headers) {
                    for (key in headers) {
                        if ('authorization' === key.toLowerCase()) {
                            xhrLicense.withCredentials = true;
                        }
                        xhrLicense.setRequestHeader(key, headers[key]);
                    }
                }
            };
            if (protData) {
                updateHeaders(protData.httpRequestHeaders);
            }
            updateHeaders(this.keySystem.getRequestHeadersFromMessage(message));

            // Set withCredentials property from protData
            if (protData && protData.withCredentials) {
                xhrLicense.withCredentials = true;
            }

            this.debug.log("[DRM] Send license request");
            var licenseRequest = this.keySystem.getLicenseRequestFromMessage(message);
            if (licenseRequest === null) {
                this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                    new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_NO_CHALLENGE, "No license challenge from CDM key message"));
            }
            xhrLicense.send(licenseRequest);
        },

        onNeedKey = function(event) {

            var self = this,
                abInitData,
                supportedKS;

            self.debug.log("[DRM] onNeedKey, initDataType = " + event.data.initDataType);

            // Ignore non-cenc initData
            if (event.data.initDataType !== "cenc") {
                self.debug.log("[DRM] Only 'cenc' initData is supported!  Ignoring initData of type: " + event.data.initDataType);
                return;
            }

            // Some browsers return initData as Uint8Array (IE), some as ArrayBuffer (Chrome).
            // Convert to ArrayBuffer
            abInitData = event.data.initData;
            if (ArrayBuffer.isView(abInitData)) {
                abInitData = abInitData.buffer;
            }

            supportedKS = this.protectionExt.getSupportedKeySystems(abInitData);
            if (supportedKS.length === 0) {
                self.debug.log("[DRM] Received needkey event with initData, but we don't support any of the key systems!");
                return;
            }

            selectKeySystem.call(this, supportedKS, false);
        },

        onServerCertificateUpdated = function(event) {
            if (!event.error) {
                this.debug.log("[DRM] License server certificate successfully updated");
            } else {
                this.debug.error("[DRM] Failed to set license server certificate");
                this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                    new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_SERVER_CERTIFICATE, "Failed to set server certificate", event.error));
            }
        },

        onKeySessionCreated = function(event) {
            if (!event.error) {
                this.debug.log("[DRM] Session created.  SessionID = " + event.data.getSessionID());
            } else {
                this.debug.error("[DRM] Failed to create key session");
                this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                    new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYMESSERR_NO_SESSION, "Failed to create key session", event.error));
            }
        },

        onKeyAdded = function( /*event*/ ) {
            this.debug.log("[DRM] Key added");
        },

        onKeyError = function(event) {
            this.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                new MediaPlayer.vo.Error(event.data.code, event.data.message, event.data.data));
        },

        onKeySessionClosed = function(event) {
            if (!event.error) {
                this.debug.log("[DRM] Session closed.  SessionID = " + event.data);
            } else {
                this.debug.warn("[DRM] Failed to close session");
            }
        },

        onKeySessionRemoved = function(event) {
            if (!event.error) {
                this.debug.log("[DRM] Session removed.  SessionID = " + event.data);
            } else {
                this.debug.warn("[DRM] Failed to remove session");
            }
        },

        onKeyStatusesChanged = function(event) {
            if (!event.error) {
                this.debug.log("[DRM] Key statuses changed. statuses = " + event.data);
            } /*else {
                // TODO: handle expired session
            }*/
        };

    return {
        system: undefined,
        debug: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,
        protectionExt: undefined,
        keySystem: undefined,

        setup: function() {
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE] = onKeyMessage.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY] = onNeedKey.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_SERVER_CERTIFICATE_UPDATED] = onServerCertificateUpdated.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ADDED] = onKeyAdded.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR] = onKeyError.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED] = onKeySessionCreated.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED] = onKeySessionClosed.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_REMOVED] = onKeySessionRemoved.bind(this);
            this[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED] = onKeyStatusesChanged.bind(this);

            keySystems = this.protectionExt.getKeySystems();
            this.protectionModel = this.system.getObject("protectionModel");
            this.protectionModel.init();

            this.eventBus = this.system.getObject("eventBus");

            // Subscribe to events
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_SERVER_CERTIFICATE_UPDATED, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ADDED, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_REMOVED, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE, this);
            this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED, this);
        },

        /**
         * Initialize this protection system with a given manifest and optional audio
         * and video stream information.
         *
         * @param {Object} manifest the json version of the manifest XML document for the
         * desired content.  Applications can download their manifest using
         * {@link MediaPlayer#retrieveManifest}
         * @param {MediaPlayer.vo.StreamInfo} [aInfo] audio stream information
         * @param {MediaPlayer.vo.StreamInfo} [vInfo] video stream information
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @todo This API will change when we have better support for allowing applications
         * to select different adaptation sets for playback.  Right now it is clunky for
         * applications to create {@link MediaPlayer.vo.StreamInfo} with the right information,
         */
        init: function(contentProtection, aCodec, vCodec) {
            var supportedKS;
            // TODO: We really need to do much more here... We need to be smarter about knowing
            // which adaptation sets for which we have initialized, including the default key ID
            // value from the ContentProtection elements so we know whether or not we still need to
            // select key systems and acquire keys.
            if (!initialized) {

                this.debug.log("[DRM] Initialize ProtectionController (" + vCodec + ", " + aCodec + ")");

                audioCodec = aCodec;
                videoCodec = vCodec;

                // ContentProtection elements are specified at the AdaptationSet level, so the CP for audio
                // and video will be the same.  Just use one valid MediaInfo object
                supportedKS = this.protectionExt.getSupportedKeySystemsFromContentProtection(contentProtection);
                if (supportedKS && supportedKS.length > 0) {
                    selectKeySystem.call(this, supportedKS, true);
                }

                initialized = true;
            }
        },

        /**
         * ProtectionController Event Listener
         *
         * @callback MediaPlayer.dependencies.ProtectionController~eventListener
         * @param {Object} event The event.  See the documentation for ProtectionController
         * APIs to see what events are fired by each API call
         */

        /**
         * Add a listener for ProtectionController events
         *
         * @param type the event ID
         * @param {MediaPlayer.dependencies.ProtectionController~eventListener} listener
         * the event listener to add
         * @see MediaPlayer.dependencies.ProtectionController.events
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        addEventListener: function(type, listener) {
            this.eventBus.addEventListener(type, listener);
        },

        /**
         * Remove a listener for ProtectionController events
         *
         * @param type the event ID associated with the listener to rmove
         * @param {MediaPlayer.dependencies.ProtectionController~eventListener} listener
         * the event listener to remove
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        removeEventListener: function(type, listener) {
            this.eventBus.removeEventListener(type, listener);
        },

        /**
         * Destroys all protection data associated with this protection set.  This includes
         * deleting all key sessions.  In the case of persistent key sessions, the sessions
         * will simply be unloaded and not deleted.  Additionally, if this protection set is
         * associated with a HTMLMediaElement, it will be detached from that element.
         *
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        teardown: function() {
            // abort request if xhrLicense is different from null
            if (xhrLicense) {
                xhrLicense.aborted = true;
                xhrLicense.abort();
            }
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_SERVER_CERTIFICATE_UPDATED, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ADDED, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_REMOVED, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE, this);
            this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED, this);
            this.keySystem = undefined;

            this.protectionModel.teardown();
            this.setMediaElement(null);
            this.protectionModel = undefined;
        },

        /**
         * Create a new key session associated with the given initialization data from
         * the MPD or from the PSSH box in the media
         *
         * @param {ArrayBuffer} initData the initialization data
         * @param {Uint8Array} cdmData the custom data to provide to licenser
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @fires MediaPlayer.dependencies.ProtectionController#KeySessionCreated
         * @todo In older versions of the EME spec, there was a one-to-one relationship between
         * initialization data and key sessions.  That is no longer true in the latest APIs.  This
         * API will need to modified (and a new "generateRequest(keySession, initData)" API created)
         * to come up to speed with the latest EME standard
         */
        createKeySession: function(initData, cdmData) {

            this.debug.log("[DRM] Create key session");

            var initDataForKS = MediaPlayer.dependencies.protection.CommonEncryption.getPSSHForKeySystem(this.keySystem, initData),
                i = 0,
                currentInitData;
            if (initDataForKS) {
                // Check for duplicate initData
                currentInitData = this.protectionModel.getAllInitData();
                for (i = 0; i < currentInitData.length; i++) {
                    if (this.protectionExt.initDataEquals(initDataForKS, currentInitData[i])) {
                        this.debug.log("[DRM] Ignoring initData because we have already seen it!");
                        // If Key session already exists for this content, we check if the session and stored license key
                        // correclty decrypt the content
                        //this.protectionModel.checkIfEncrypted();
                        return;
                    }
                }
                try {
                    this.protectionModel.createKeySession(initDataForKS, this.keySystem.sessionType, cdmData);
                } catch (ex) {
                    this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, null, {
                        reason: "Create key session raised en exception",
                        error: new MediaPlayer.vo.Error(ex.code, ex.name, ex.message)
                    });
                }
            } else {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, null, {
                    reason: "needkey/encrypted event contains no initData corresponding to that key system " + this.keySystem.systemString,
                    error: null
                });
            }
        },

        /**
         * Loads a key session with the given session ID from persistent storage.  This
         * essentially creates a new key session
         *
         * @param {string} sessionID
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @fires MediaPlayer.dependencies.ProtectionController#KeySessionCreated
         */
        loadKeySession: function(sessionID) {
            this.protectionModel.loadKeySession(sessionID);
        },

        /**
         * Removes the given key session from persistent storage and closes the session
         * as if {@link MediaPlayer.dependencies.ProtectionController#closeKeySession}
         * was called
         *
         * @param {MediaPlayer.vo.protection.SessionToken} sessionToken the session
         * token
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @fires MediaPlayer.dependencies.ProtectionController#KeySessionRemoved
         * @fires MediaPlayer.dependencies.ProtectionController#KeySessionClosed
         */
        removeKeySession: function(sessionToken) {
            this.protectionModel.removeKeySession(sessionToken);
        },

        /**
         * Closes the key session and releases all associated decryption keys.  These
         * keys will no longer be available for decrypting media
         *
         * @param {MediaPlayer.vo.protection.SessionToken} sessionToken the session
         * token
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @fires MediaPlayer.dependencies.ProtectionController#KeySessionClosed
         */
        closeKeySession: function(sessionToken) {
            this.protectionModel.closeKeySession(sessionToken);
        },

        /**
         * Sets a server certificate for use by the CDM when signing key messages
         * intended for a particular license server.  This will fire
         * an error event if a key system has not yet been selected.
         *
         * @param {ArrayBuffer} serverCertificate a CDM-specific license server
         * certificate
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         * @fires MediaPlayer.dependencies.ProtectionController#ServerCertificateUpdated
         */
        setServerCertificate: function(serverCertificate) {
            this.protectionModel.setServerCertificate(serverCertificate);
        },

        /**
         * Associate this protection system with the given HTMLMediaElement.  This
         * causes the system to register for needkey/encrypted events from the given
         * element and provides a destination for setting of MediaKeys
         *
         * @param {HTMLMediaElement} element the media element to which the protection
         * system should be associated
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        setMediaElement: function(element) {
            if (element) {
                this.protectionModel.setMediaElement(element);
                this.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY, this);
            } else if (element === null) {
                this.protectionModel.setMediaElement(element);
                this.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY, this);
            }
        },

        /**
         * Sets the session type to use when creating key sessions.  Either "temporary" or
         * "persistent-license".  Default is "temporary".
         *
         * @param {String} sessionType the session type
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        setSessionType: function(sessionType) {
            if (this.keysystem) {
                this.keySystem.sessionType = sessionType;
            }
        },

        /**
         * Attach KeySystem-specific data to use for license acquisition with EME
         *
         * @param {Object} data an object containing property names corresponding to
         * key system name strings (e.g. "org.w3.clearkey") and associated values
         * being instances of {@link MediaPlayer.vo.protection.ProtectionData}
         * @memberof MediaPlayer.dependencies.ProtectionController
         * @instance
         */
        setProtectionData: function(data) {
            protDataSet = data;
            this.protectionExt.init(data);
        }
    };
};

/**
 * Key system selection event
 *
 * @event MediaPlayer.dependencies.ProtectionController#KeySystemSelected
 * @type {Object}
 * @property {MediaPlayer.vo.protection.KeySystemAccess} data key system
 * access object that describes the selected key system and associated
 * audio/video codecs and CDM capabilities.  May be null if an error occurred
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * Key session creation event
 *
 * @event MediaPlayer.dependencies.ProtectionController#KeySessionCreated
 * @type {Object}
 * @property {MediaPlayer.vo.protection.SessionToken} data the session token
 * that can be used to access certain properties of the session.  Also
 * required for other ProtectionController APIs that act on key sessions.
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * Key session removed event
 *
 * @event MediaPlayer.dependencies.ProtectionController#KeySessionRemoved
 * @type {Object}
 * @property {string} data the session ID of the session that was removed
 * from persistent storage
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * Key session closed event
 *
 * @event MediaPlayer.dependencies.ProtectionController#KeySessionClosed
 * @type {Object}
 * @property {string} data the session ID of the session that was closed
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * Server certificate updated event
 *
 * @event MediaPlayer.dependencies.ProtectionController#ServerCertificateUpdated
 * @type {Object}
 * @property {Object} data unused for this event.  The server certificate update
 * was is successful if the "error" property of this event is null or undefined
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * License request completed event
 *
 * @event MediaPlayer.dependencies.ProtectionController#LicenseRequestComplete
 * @type {Object}
 * @property {Object} data The event data.  This data will be provided regardless
 * of the success/failure status of the event
 * @property {MediaPlayer.vo.protection.SessionToken} data.sessionToken session token
 * associated with this license response.  Will never be null, even in error cases.
 * @property {String} data.messageType the message type associated with this request.
 * Supported message types can be found
 * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @property {string} error if not null, an error occurred and this object
 * will contain an informative error string describing the failure
 */

/**
 * Events names for events sent by ProtectionController.  Use these event
 * names when subscribing or unsubscribing from ProtectionController events
 *
 * @enum {String}
 * @see MediaPlayer.dependencies.ProtectionController#addEventListener
 */
MediaPlayer.dependencies.ProtectionController.events = {
    /**
     * Event ID for events delivered when a key system selection procedure
     * has completed
     *
     * @constant
     */
    KEY_SYSTEM_SELECTED: "keySystemSelected",
    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     *
     * @constant
     */
    SERVER_CERTIFICATE_UPDATED: "serverCertificateUpdated",
    /**
     * Event ID for events delivered when a new key has been added
     *
     * @constant
     * @deprecated The latest versions of the EME specification no longer
     * use this event. {@MediaPlayer.dependencies.ProtectionController.events.KEY_STATUSES_CHANGED}
     * is preferred.
     */
    KEY_ADDED: "keyAdded",
    /**
     * Event ID for events delivered when a new key sessions creation
     * process has completed
     *
     * @constant
     */
    KEY_SESSION_CREATED: "keySessionCreated",
    /**
     * Event ID for events delivered when a key session removal
     * process has completed
     *
     * @constant
     */
    KEY_SESSION_REMOVED: "keySessionRemoved",
    /**
     * Event ID for events delivered when a key session close
     * process has completed
     *
     * @constant
     */
    KEY_SESSION_CLOSED: "keySessionClosed",
    /**
     * Event ID for events delivered when the status of one or more
     * decryption keys has changed
     *
     * @constant
     */
    KEY_STATUSES_CHANGED: "keyStatusesChanged",
    /**
     * Event ID for events delivered when the protection system receives
     * a key message from the CDM
     *
     * @constant
     */
    KEY_MESSAGE: "keyMessage",
    /**
     * Event ID for events delivered when a license request procedure
     * has completed
     *
     * @constant
     */
    LICENSE_REQUEST_COMPLETE: "licenseRequestComplete"
};

MediaPlayer.dependencies.ProtectionController.eventList = {
    ENAME_PROTECTION_ERROR: "protectionError"
};

MediaPlayer.dependencies.ProtectionController.prototype = {
    constructor: MediaPlayer.dependencies.ProtectionController
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Media protection functionality that can be modified/overridden by applications
 *
 * @class MediaPlayer.dependencies.ProtectionExtensions
 */
MediaPlayer.dependencies.ProtectionExtensions = function () {
    "use strict";

    this.system = undefined;
    this.debug = undefined;
    this.keySystems = [];

    this.clearkeyKeySystem = undefined;
};

MediaPlayer.dependencies.ProtectionExtensions.prototype = {
    constructor: MediaPlayer.dependencies.ProtectionExtensions,

    /**
     * Setup the key systems available in the player
     */
    setup: function() {
        var keySystem;

        // PlayReady
        keySystem = this.system.getObject("ksPlayReady");
        this.keySystems.push(keySystem);

        // Widevine
        keySystem = this.system.getObject("ksWidevine");
        this.keySystems.push(keySystem);

        // ClearKey
        keySystem = this.system.getObject("ksClearKey");
        this.keySystems.push(keySystem);
        this.clearkeyKeySystem = keySystem;
    },

    /**
     * Initialize the available key systems
     *
     * @param protectionDataSet object that contains 0 or more ProtectionData
     * objects.  Each one is identified by an attribute name equal to
     * to the unique key system string for the DRM to which it is intended
     */
    init: function(protectionDataSet) {
        var getProtectionData = function(keySystemString) {
            var protData = null;
            if (protectionDataSet) {
                protData = (keySystemString in protectionDataSet) ? protectionDataSet[keySystemString] : null;
            }
            return protData;
        };

        for (var i = 0; i < this.keySystems.length; i++) {
            var keySystem = this.keySystems[i];
            keySystem.init(getProtectionData(keySystem.systemString));
        }
    },

    /**
     * Returns a prioritized list of key systems supported
     * by this player (not necessarily those supported by the
     * user agent)
     *
     * @returns {MediaPlayer.dependencies.protection.KeySystem[]} a prioritized
     * list of key systems
     */
    getKeySystems: function() {
        return this.keySystems;
    },

    /**
     * Returns the key system associated with the given key system string
     * name (i.e. 'org.w3.clearkey')
     *
     * @param {string} systemString the system string
     * @returns {MediaPlayer.dependencies.protection.KeySystem} the key system
     * or null if no supported key system is associated with the given key
     * system string
     */
    getKeySystemBySystemString: function(systemString) {
        for (var i = 0; i < this.keySystems.length; i++) {
            if (this.keySystems[i].systemString === systemString) {
                return this.keySystems[i];
            }
        }
        return null;
    },

    /**
     * Determines whether the given key system is ClearKey.  This is
     * necessary because the EME spec defines ClearKey and its method
     * for providing keys to the key session; and this method has changed
     * between the various API versions.  Our EME-specific ProtectionModels
     * must know if the system is ClearKey so that it can format the keys
     * according to the particular spec version.
     *
     * @param keySystem the key
     * @returns {boolean} true if this is the ClearKey key system, false
     * otherwise
     */
    isClearKey: function(keySystem) {
        return (keySystem === this.clearkeyKeySystem);
    },

    /**
     * Check equality of initData array buffers.
     *
     * @param initData1 {ArrayBuffer} first initData
     * @param initData2 {ArrayBuffer} second initData
     * @returns {boolean} true if the initData arrays are equal in size and
     * contents, false otherwise
     */
    initDataEquals: function(initData1, initData2) {
        if (initData1.byteLength === initData2.byteLength) {
            var data1 = new Uint8Array(initData1),
                data2 = new Uint8Array(initData2);
            for (var j = 0; j < data1.length; j++) {
                if (data1[j] !== data2[j]) {
                    return false;
                }
            }
            return true;
        }
        return false;
    },

    /**
     * Returns a set of supported key systems and CENC intialization data
     * from the given array of ContentProtection elements.  Only
     * key systems that are supported by this player will be returned.
     * Key systems are returned in priority order (highest first).
     *
     * @param {Object[]} cps array of content protection elements parsed
     * from the manifest
     * @returns {Object[]} array of objects indicating which supported key
     * systems were found.  Empty array is returned if no
     * supported key systems were found
     * @returns {MediaPlayer.dependencies.protection.KeySystem} Object.ks the key
     * system identified by the ContentProtection element
     * @returns {ArrayBuffer} Object.initData the initialization data parsed
     * from the ContentProtection element
     */
    getSupportedKeySystemsFromContentProtection: function(cps) {
        var cp, ks, ksIdx, cpIdx, supportedKS = [];

        this.debug.log("[DRM] Get supported key systems from content protection");

        if (cps) {
            for(ksIdx = 0; ksIdx < this.keySystems.length; ++ksIdx) {
                ks = this.keySystems[ksIdx];
                for(cpIdx = 0; cpIdx < cps.length; ++cpIdx) {
                    cp = cps[cpIdx];
                    if (cp.schemeIdUri.toLowerCase() === ks.schemeIdURI) {

                        //this.debug.log("[DRM] Supported key systems: " + ks.systemString + " (" + ks.schemeIdURI + ")");

                        // Look for DRM-specific ContentProtection
                        var initData = ks.getInitData(cp);
                        if (!!initData) {
                            supportedKS.push({
                                ks: this.keySystems[ksIdx],
                                initData: initData,
                                cdmData: ks.getCDMData()
                            });
                        }
                    }
                }
            }
        }
        return supportedKS;
    },

    /**
     * Returns key systems supported by this player for the given PSSH
     * initializationData. Only key systems supported by this player
     * will be returned.  Key systems are returned in priority order
     * (highest priority first)
     *
     * @param {ArrayBuffer} initData Concatenated PSSH data for all DRMs
     * supported by the content
     * @returns {Object[]} array of objects indicating which supported key
     * systems were found.  Empty array is returned if no
     * supported key systems were found
     * @returns {MediaPlayer.dependencies.protection.KeySystem} Object.ks the key
     * system
     * @returns {ArrayBuffer} Object.initData the initialization data
     * associated with the key system
     */
    getSupportedKeySystems: function(initData) {
        var ksIdx, supportedKS = [],
                pssh = MediaPlayer.dependencies.protection.CommonEncryption.parsePSSHList(initData);

        this.debug.log("[DRM] Get supported key systems from init data");

        for (ksIdx = 0; ksIdx < this.keySystems.length; ++ksIdx) {
            if (this.keySystems[ksIdx].uuid in pssh) {
                //this.debug.log("[DRM] Add supported key system: " + this.keySystems[ksIdx].systemString);
                supportedKS.push({
                    ks: this.keySystems[ksIdx],
                    initData: pssh[this.keySystems[ksIdx].uuid],
                    cdmData: this.keySystems[ksIdx].getCDMData()
                });
            }
        }
        return supportedKS;
    },

    /**
     * Returns the license server implementation data that should be used for this request.
     *
     * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
     * associated with this license request
     * @param {MediaPlayer.vo.protection.ProtectionData} protData protection data to use for the
     * request
     * @param {String} [messageType="license-request"] the message type associated with this
     * request.  Supported message types can be found
     * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
     * @return {MediaPlayer.dependencies.protection.servers.LicenseServer} the license server
     * implementation that should be used for this request or null if the player should not
     * pass messages of the given type to a license server
     *
     */
    getLicenseServer: function(keySystem, protData, messageType) {

        // Our default server implementations do not do anything with "license-release" or
        // "individualization-request" messages, so we just send a success event
        if (messageType === "license-release" || messageType == "individualization-request") {
            return null;
        }

        var licenseServerData = null;
        if (protData && protData.hasOwnProperty("drmtoday")) {
            licenseServerData = this.system.getObject("serverDRMToday");
        } else if (keySystem.systemString === "com.widevine.alpha") {
            licenseServerData = this.system.getObject("serverWidevine");
        } else if (keySystem.systemString === "com.microsoft.playready") {
            licenseServerData = this.system.getObject("serverPlayReady");
        } else if (keySystem.systemString === "org.w3.clearkey") {
            licenseServerData = this.system.getObject("serverClearKey");
        }

        return licenseServerData;
    },

    /**
     * Allows application-specific retrieval of ClearKey keys.
     *
     * @param {MediaPlayer.vo.protection.ProtectionData} protData protection data to use for the
     * request
     * @param {ArrayBuffer} message the key message from the CDM
     * @return {MediaPlayer.vo.protection.ClearKeyKeySet} the clear keys associated with
     * the request or null if no keys can be returned by this function
     */
    processClearKeyLicenseRequest: function(protData, message) {
        try {
            return MediaPlayer.dependencies.protection.KeySystem_ClearKey.getClearKeysFromProtectionData(protData, message);
        } catch (error) {
            this.log("Failed to retrieve clearkeys from ProtectionData");
            return null;
        }
    },

    /**
     * Select a key system by using the priority-ordered key systems supported
     * by the player and the key systems supported by the content
     *
     * @param {Object[]} supportedKS supported key systems
     * @param {MediaPlayer.dependencies.ProtectionController} protectionController
     * @param {MediaPlayer.vo.MediaInfo} videoInfo video media information
     * @param {MediaPlayer.vo.MediaInfo} audioInfo audio media information
     */
    //autoSelectKeySystem: function(supportedKS, protectionController, videoInfo, audioInfo) {
    autoSelectKeySystem: function(supportedKS, protectionController, videoCodec, audioCodec) {

        this.debug.log("[DRM] Auto select key system: ");
        this.debug.log("[DRM] ---- video codec = " + videoCodec);
        this.debug.log("[DRM] ---- audio codec = " + audioCodec);

        // Does the initData contain a key system supported by the player?
        if (supportedKS.length === 0) {
            throw new Error("DRM system for this content not supported by the player!");
        }

        var audioCapabilities = [], videoCapabilities = [];
        if (videoCodec) {
            videoCapabilities.push(new MediaPlayer.vo.protection.MediaCapability(videoCodec));
        }
        if (audioCodec) {
            audioCapabilities.push(new MediaPlayer.vo.protection.MediaCapability(audioCodec));
        }
        var ksConfig = new MediaPlayer.vo.protection.KeySystemConfiguration(audioCapabilities, videoCapabilities);
        var requestedKeySystems = [];
        for (var i = 0; i < supportedKS.length; i++) {
            requestedKeySystems.push({ ks: supportedKS[i].ks, configs: [ksConfig] });
        }

        // Since ProtectionExtensions is a singleton, we need to create an IIFE to wrap the
        // event callback and save the values of protectionModel and protectionController.
        var self = this;
        (function(protCtrl) {

            // Callback object for KEY_SYSTEM_ACCESS_COMPLETE event
            var cbObj = {};

            // Subscribe for event and then perform request
            cbObj[MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE] = function(event) {
                protCtrl.protectionModel.unsubscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, this);
                if (!event.error) {
                    var keySystemAccess = event.data;
                    self.debug.log("[DRM] KeySystem Access Granted (" + keySystemAccess.keySystem.systemString + ")!");
                    protCtrl.selectKeySystem(keySystemAccess);
                } else {
                    self.debug.log(event.error);
                    protCtrl.notify(MediaPlayer.dependencies.ProtectionController.eventList.ENAME_PROTECTION_ERROR,
                        new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYSYSERR_ACCESS_DENIED, "[DRM] KeySystem Access Denied! -- " + event.error, null));
                }
            };

            protCtrl.protectionModel.subscribe(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, cbObj);
            protCtrl.requestKeySystemAccess(requestedKeySystems);

        })(protectionController);
    }
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Initial implementation of EME
 *
 * Implemented by Google Chrome prior to v36
 *
 * @implements MediaPlayer.models.ProtectionModel
 * @class
 */
MediaPlayer.models.ProtectionModel_01b = function () {

    var videoElement = null,

        // API names object selected for this user agent
        api = null,

        // With this version of the EME APIs, sessionIDs are not assigned to
        // sessions until the first key message is received.  We are assuming
        // that in the case of multiple sessions, key messages will be received
        // in the order that generateKeyRequest() is called.

        // Holding spot for newly-created sessions until we determine whether or
        // not the CDM supports sessionIDs
        pendingSessions = [],

        // List of sessions that have been initialized.  Only the first position will
        // be used in the case that the CDM does not support sessionIDs
        sessions = [],

        // Not all CDMs support the notion of sessionIDs.  Without sessionIDs
        // there is no way for us to differentiate between sessions, therefore
        // we must only allow a single session.  Once we receive the first key
        // message we can set this flag to determine if more sessions are allowed
        moreSessionsAllowed,

        // This is our main event handler for all desired HTMLMediaElement events
        // related to EME.  These events are translated into our API-independent
        // versions of the same events
        createEventHandler = function() {
            var self = this;
            return {
                handleEvent: function(event) {
                    var sessionToken = null;
                    switch (event.type) {

                        case api.needkey:
                            var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY,
                                new MediaPlayer.vo.protection.NeedKey(initData, "cenc"));
                            break;

                        case api.keyerror:
                            sessionToken = findSessionByID(sessions, event.sessionId);
                            if (!sessionToken) {
                                sessionToken = findSessionByID(pendingSessions, event.sessionId);
                            }

                            if (sessionToken) {
                                var code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR,
                                    msg = "MediakeyError";
                                switch (event.errorCode.code) {
                                    case 1:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_UNKNOWN;
                                        msg += "An unspecified error occurred. This value is used for errors that don't match any of the other codes.";
                                        break;
                                    case 2:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_CLIENT;
                                        msg += "The Key System could not be installed or updated.";
                                        break;
                                    case 3:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_SERVICE;
                                        msg += "The message passed into update indicated an error from the license service.";
                                        break;
                                    case 4:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_OUTPUT;
                                        msg += "There is no available output device with the required characteristics for the content protection system.";
                                        break;
                                    case 5:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_HARDWARECHANGE;
                                        msg += "A hardware configuration change caused a content protection error.";
                                        break;
                                    case 6:
                                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_DOMAIN;
                                        msg += "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.";
                                        break;
                                }
                                if (event.systemCode) {
                                    msg += "  (System Code = " + event.systemCode + ")";
                                }
                                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR, new MediaPlayer.vo.protection.KeyError(code, msg));
                            } else {
                                self.log("No session token found for key error");
                            }
                            break;

                        case api.keyadded:
                            sessionToken = findSessionByID(sessions, event.sessionId);
                            if (!sessionToken) {
                                sessionToken = findSessionByID(pendingSessions, event.sessionId);
                            }

                            if (sessionToken) {
                                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ADDED, sessionToken);
                            } else {
                                self.log("No session token found for key added");
                            }
                            break;

                        case api.keymessage:

                            // If this CDM does not support session IDs, we will be limited
                            // to a single session
                            moreSessionsAllowed = (event.sessionId !== null) && (event.sessionId !== undefined);

                            // SessionIDs supported
                            if (moreSessionsAllowed) {

                                // Attempt to find an uninitialized token with this sessionID
                                sessionToken = findSessionByID(sessions, event.sessionId);
                                if (!sessionToken && pendingSessions.length > 0) {

                                    // This is the first message for our latest session, so set the
                                    // sessionID and add it to our list
                                    sessionToken = pendingSessions.shift();
                                    sessions.push(sessionToken);
                                    sessionToken.sessionID = event.sessionId;
                                }
                            } else if (pendingSessions.length > 0) { // SessionIDs not supported

                                sessionToken = pendingSessions.shift();
                                sessions.push(sessionToken);

                                if (pendingSessions.length !== 0) {
                                    self.errHandler.mediaKeyMessageError("Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!");
                                }
                            }

                            if (sessionToken) {
                                var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;

                                // For ClearKey, the spec mandates that you pass this message to the
                                // addKey method, so we always save it to the token since there is no
                                // way to tell which key system is in use
                                sessionToken.keyMessage = message;

                                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE,
                                    new MediaPlayer.vo.protection.KeyMessage(sessionToken, message, event.defaultURL));
                            } else {
                                self.log("No session token found for key message");
                            }
                            break;
                    }
                }
            };
        },
        eventHandler = null,

        /**
         * Helper function to retrieve the stored session token based on a given
         * sessionID value
         *
         * @param sessionArray {Array} the array of sessions to search
         * @param sessionID the sessionID to search for
         * @returns {*} the session token with the given sessionID
         */
        findSessionByID = function(sessionArray, sessionID) {

            if (!sessionID || !sessionArray) {
                return null;
            } else {
                var len = sessionArray.length;
                for (var i = 0; i < len; i++) {
                    if (sessionArray[i].sessionID === sessionID) {
                        return sessionArray[i];
                    }
                }
                return null;
            }
        },

        removeEventListeners = function() {
            videoElement.removeEventListener(api.keyerror, eventHandler);
            videoElement.removeEventListener(api.needkey, eventHandler);
            videoElement.removeEventListener(api.keymessage, eventHandler);
            videoElement.removeEventListener(api.keyadded, eventHandler);
        };

    return {
        system: undefined,
        log: undefined,
        errHandler: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,
        protectionExt: undefined,
        keySystem: null,

        setup: function() {
            eventHandler = createEventHandler.call(this);
        },

        /**
         * Initialize this protection model
         */
        init: function() {
            var tmpVideoElement = document.createElement("video");
            api = MediaPlayer.models.ProtectionModel_01b.detect(tmpVideoElement);
        },

        teardown: function() {
            if (videoElement) {
                removeEventListeners();
            }
            for (var i = 0; i < sessions.length; i++) {
                this.closeKeySession(sessions[i]);
            }
            this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
        },

        getAllInitData: function() {
            var i, retVal = [];
            for (i = 0; i < pendingSessions.length; i++) {
                retVal.push(pendingSessions[i].initData);
            }
            for (i = 0; i < sessions.length; i++) {
                retVal.push(sessions[i].initData);
            }
            return retVal;
        },

        requestKeySystemAccess: function(ksConfigurations) {
            var ve = videoElement;
            if (!ve) { // Must have a video element to do this capability tests
                ve = document.createElement("video");
            }

            // Try key systems in order, first one with supported key system configuration
            // is used
            var found = false;
            for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
                var systemString = ksConfigurations[ksIdx].ks.systemString;
                var configs = ksConfigurations[ksIdx].configs;
                var supportedAudio = null;
                var supportedVideo = null;

                // Try key system configs in order, first one with supported audio/video
                // is used
                for (var configIdx = 0; configIdx < configs.length; configIdx++) {
                    //var audios = configs[configIdx].audioCapabilities;
                    var videos = configs[configIdx].videoCapabilities;

                    // Look for supported audio container/codecs
                    /*
                    if (audios && audios.length !== 0) {
                        supportedAudio = []; // Indicates that we have a requested audio config
                        for (var audioIdx = 0; audioIdx < audios.length; audioIdx++) {
                            if (ve.canPlayType(audios[audioIdx].contentType, systemString) !== "") {
                                supportedAudio.push(audios[audioIdx]);
                            }
                        }
                    }
                    */

                    // Look for supported video container/codecs
                    if (videos && videos.length !== 0) {
                        supportedVideo = []; // Indicates that we have a requested video config
                        for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
                            if (ve.canPlayType(videos[videoIdx].contentType, systemString) !== "") {
                                supportedVideo.push(videos[videoIdx]);
                            }
                        }
                    }

                    // No supported audio or video in this configuration OR we have
                    // requested audio or video configuration that is not supported
                    if ((!supportedAudio && !supportedVideo) ||
                            (supportedAudio && supportedAudio.length === 0) ||
                            (supportedVideo && supportedVideo.length === 0)) {
                        continue;
                    }

                    // This configuration is supported
                    found = true;
                    var ksConfig = new MediaPlayer.vo.protection.KeySystemConfiguration(supportedAudio, supportedVideo);
                    var ks = this.protectionExt.getKeySystemBySystemString(systemString);
                    var ksAccess = new MediaPlayer.vo.protection.KeySystemAccess(ks, ksConfig);
                    this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE,
                            ksAccess);
                    break;
                }
            }
            if (!found) {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE,
                        null, "Key system access denied! -- No valid audio/video content configurations detected!");
            }
        },

        selectKeySystem: function(keySystemAccess) {
            this.keySystem = keySystemAccess.keySystem;
            this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED);
        },

        setMediaElement: function(mediaElement) {
            if (videoElement === mediaElement) {
                return;
            }

            // Replacing the previous element
            if (videoElement) {
                removeEventListeners();
            }

            videoElement = mediaElement;

            // Only if we are not detaching from the existing element
            if (videoElement) {
                videoElement.addEventListener(api.keyerror, eventHandler);
                videoElement.addEventListener(api.needkey, eventHandler);
                videoElement.addEventListener(api.keymessage, eventHandler);
                videoElement.addEventListener(api.keyadded, eventHandler);
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_VIDEO_ELEMENT_SELECTED);
            }
        },

        createKeySession: function(initData /*, keySystemType */) {

            if (!this.keySystem) {
                throw new Error("Can not create sessions until you have selected a key system");
            }

            // Determine if creating a new session is allowed
            if (moreSessionsAllowed || sessions.length === 0) {

                var newSession = { // Implements MediaPlayer.vo.protection.SessionToken
                    sessionID: null,
                    initData: initData,

                    getSessionID: function() {
                        return this.sessionID;
                    },

                    getExpirationTime: function() {
                        return NaN;
                    },

                    getSessionType: function() {
                        return "temporary";
                    }
                };
                pendingSessions.push(newSession);

                // Send our request to the CDM
                videoElement[api.generateKeyRequest](this.keySystem.systemString, new Uint8Array(initData));

                return newSession;

            } else {
                throw new Error("Multiple sessions not allowed!");
            }

        },

        updateKeySession: function(sessionToken, message) {
            var sessionID = sessionToken.sessionID;
            if (!this.protectionExt.isClearKey(this.keySystem)) {
                // Send our request to the CDM
                videoElement[api.addKey](this.keySystem.systemString,
                        new Uint8Array(message), sessionToken.initData, sessionID);
            } else {
                // For clearkey, message is a MediaPlayer.vo.protection.ClearKeyKeySet
                for (var i = 0; i < message.keyPairs.length; i++) {
                    videoElement[api.addKey](this.keySystem.systemString,
                            message.keyPairs[i].key, message.keyPairs[i].keyID, sessionID);
                }
            }
        },

        closeKeySession: function(sessionToken) {
            // Send our request to the CDM
            videoElement[api.cancelKeyRequest](this.keySystem.systemString, sessionToken.sessionID);
        },

        setServerCertificate: function(/*serverCertificate*/) { /* Not supported */ },

        loadKeySession: function(/*sessionID*/) { /* Not supported */ },

        removeKeySession: function(/*sessionToken*/) { /* Not supported */ },

        checkIfEncrypted: function() { /* Not supported */ }
    };
};

MediaPlayer.models.ProtectionModel_01b.prototype = {
    constructor: MediaPlayer.models.ProtectionModel_01b
};

// Defines the supported 0.1b API variations
MediaPlayer.models.ProtectionModel_01b.APIs = [
    // Un-prefixed as per spec
    {
        // Video Element
        generateKeyRequest: "generateKeyRequest",
        addKey: "addKey",
        cancelKeyRequest: "cancelKeyRequest",

        // Events
        needkey: "needkey",
        keyerror: "keyerror",
        keyadded: "keyadded",
        keymessage: "keymessage"
    },
    // Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
    {
        // Video Element
        generateKeyRequest: "webkitGenerateKeyRequest",
        addKey: "webkitAddKey",
        cancelKeyRequest: "webkitCancelKeyRequest",

        // Events
        needkey: "webkitneedkey",
        keyerror: "webkitkeyerror",
        keyadded: "webkitkeyadded",
        keymessage: "webkitkeymessage"
    }
];

/**
 * Detects presence of EME v0.1b APIs
 *
 * @param videoElement {HTMLMediaElement} the media element that will be
 * used for detecting APIs
 * @returns an API object that is used when initializing the ProtectionModel
 * instance, or null if this EME version is not supported
 */
MediaPlayer.models.ProtectionModel_01b.detect = function(videoElement) {
    var apis = MediaPlayer.models.ProtectionModel_01b.APIs;
    for (var i = 0; i < apis.length; i++) {
        var api = apis[i];
        if (typeof videoElement[api.generateKeyRequest] !== 'function') {
            continue;
        }
        if (typeof videoElement[api.addKey] !== 'function') {
            continue;
        }
        if (typeof videoElement[api.cancelKeyRequest] !== 'function') {
            continue;
        }
        return api;
    }

    return null;
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Implementation of the EME APIs as of the 3 Feb 2014 state of the specification.
 *
 * Implemented by Internet Explorer 11 (Windows 8.1)
 *
 * @implements MediaPlayer.models.ProtectionModel
 * @class
 */
MediaPlayer.models.ProtectionModel_3Feb2014 = function () {

    var videoElement = null,
        mediaKeys = null,
        keySystemAccess = null,
        boundDoSetKeys = null,

        // API names object selected for this user agent
        api = null,

        // Session list
        sessions = [],

        // This is our main event handler for all desired HTMLMediaElement events
        // related to EME.  These events are translated into our API-independent
        // versions of the same events
        createEventHandler = function() {
            var self = this;
            return {
                handleEvent: function(event) {
                    switch (event.type) {

                        case api.needkey:
                            if (event.initData) {
                                var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY,
                                        new MediaPlayer.vo.protection.NeedKey(initData, "cenc"));
                            }
                            break;
                    }
                }
            };
        },
        eventHandler = null,

        // IE11 does not let you set MediaKeys until it has entered a certain
        // readyState, so we need this logic to ensure we don't set the keys
        // too early
        setMediaKeys = function() {
            var doSetKeys = function() {
                videoElement.removeEventListener("loadedmetadata", boundDoSetKeys);
                videoElement[api.setMediaKeys](mediaKeys);
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_VIDEO_ELEMENT_SELECTED);
            };
            if (videoElement.readyState >= 1) {
                doSetKeys.call(this);
            } else {
                boundDoSetKeys = doSetKeys.bind(this);
                videoElement.addEventListener("loadedmetadata", boundDoSetKeys);
            }

        },

        getKeyError = function(event) {
            var code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR,
                msg = "MediakeyError";

            if (event.errorCode) {
                switch (event.errorCode.code) {
                    case 1:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_UNKNOWN;
                        msg = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.";
                        break;
                    case 2:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_CLIENT;
                        msg = "The Key System could not be installed or updated.";
                        break;
                    case 3:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_SERVICE;
                        msg = "The message passed into update indicated an error from the license service.";
                        break;
                    case 4:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_OUTPUT;
                        msg = "There is no available output device with the required characteristics for the content protection system.";
                        break;
                    case 5:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_HARDWARECHANGE;
                        msg += "A hardware configuration change caused a content protection error.";
                        break;
                    case 6:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_DOMAIN;
                        msg = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.";
                        break;
                    default:
                        code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_UNKNOWN;
                        msg = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.";
                        break;
                }
            } else {
                code = MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR_UNKNOWN;
                msg = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.";
            }
            if (event.systemCode) {
                msg += "  (System Code = " + event.systemCode + ")";
            }
            return new MediaPlayer.vo.protection.KeyError(code, msg);
        },

        // Function to create our session token objects which manage the EME
        // MediaKeySession and session-specific event handler
        createSessionToken = function(keySession, initData) {
            var self = this;
            return { // Implements MediaPlayer.vo.protection.SessionToken
                session: keySession,
                initData: initData,

                // This is our main event handler for all desired MediaKeySession events
                // These events are translated into our API-independent versions of the
                // same events
                handleEvent: function(event) {
                    switch (event.type) {

                        case api.error:
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR, getKeyError(event));
                            break;

                        case api.message:
                            var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE,
                                    new MediaPlayer.vo.protection.KeyMessage(this, message, event.destinationURL));
                            break;

                        case api.ready:
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ADDED, this);
                            break;

                        case api.close:
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED, this.getSessionID());
                            break;
                    }
                },

                getSessionID: function() {
                    return this.session.sessionId;
                },

                getExpirationTime: function() {
                    return NaN;
                },

                getSessionType: function() {
                    return "temporary";
                }
            };
        };

    return {
        system: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,
        protectionExt: undefined,
        debug: undefined,
        keySystem: null,

        setup: function() {
            eventHandler = createEventHandler.call(this);
        },

        /**
         * Initialize this protection model
         */
        init: function() {
            var tmpVideoElement = document.createElement("video");
            api = MediaPlayer.models.ProtectionModel_3Feb2014.detect(tmpVideoElement);
        },

        teardown: function() {
            try {
                for (var i = 0; i < sessions.length; i++) {
                    this.closeKeySession(sessions[i]);
                }
                if (videoElement) {
                    videoElement.removeEventListener(api.needkey, eventHandler);
                }
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
            } catch (error) {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE,
                        null, "Error tearing down key sessions and MediaKeys! -- " + error.message);
            }
        },

        getAllInitData: function() {
            var retVal = [];
            for (var i = 0; i < sessions.length; i++) {
                retVal.push(sessions[i].initData);
            }
            return retVal;
        },

        requestKeySystemAccess: function(ksConfigurations) {

            // Try key systems in order, first one with supported key system configuration
            // is used
            var found = false;
            for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
                var systemString = ksConfigurations[ksIdx].ks.systemString;
                var configs = ksConfigurations[ksIdx].configs;
                var supportedAudio = null;
                var supportedVideo = null;

                this.debug.log("[DRM][3Feb2014] Request access for key system " + systemString);

                // Try key system configs in order, first one with supported audio/video
                // is used
                for (var configIdx = 0; configIdx < configs.length; configIdx++) {
                    var audios = configs[configIdx].audioCapabilities;
                    var videos = configs[configIdx].videoCapabilities;

                    // Look for supported audio container/codecs
                    if (audios && audios.length !== 0) {
                        supportedAudio = []; // Indicates that we have a requested audio config
                        for (var audioIdx = 0; audioIdx < audios.length; audioIdx++) {
                            if (window[api.MediaKeys].isTypeSupported(systemString, audios[audioIdx].contentType)) {
                                //this.debug.log("[DRM][3Feb2014] audio codec supported: " + audios[audioIdx].contentType);
                                supportedAudio.push(audios[audioIdx]);
                            }
                        }
                    }

                    // Look for supported video container/codecs
                    if (videos && videos.length !== 0) {
                        supportedVideo = []; // Indicates that we have a requested video config
                        for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
                            if (window[api.MediaKeys].isTypeSupported(systemString, videos[videoIdx].contentType)) {
                                //this.debug.log("[DRM][3Feb2014] video codec supported: " + videos[audioIdx].contentType);
                                supportedVideo.push(videos[videoIdx]);
                            }
                        }
                    }

                    // No supported audio or video in this configuration OR we have
                    // requested audio or video configuration that is not supported
                    if ((!supportedAudio && !supportedVideo) ||
                            (supportedAudio && supportedAudio.length === 0) ||
                            (supportedVideo && supportedVideo.length === 0)) {
                        continue;
                    }

                    // This configuration is supported
                    found = true;
                    var ksConfig = new MediaPlayer.vo.protection.KeySystemConfiguration(supportedAudio, supportedVideo);
                    var ks = this.protectionExt.getKeySystemBySystemString(systemString);
                    var ksAccess = new MediaPlayer.vo.protection.KeySystemAccess(ks, ksConfig);
                    this.debug.log("[DRM][3Feb2014] configuration supported = audio:" + JSON.stringify(supportedAudio) + ", video:" + JSON.stringify(supportedVideo));
                    this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE,
                            ksAccess);
                    break;
                }
            }
            if (!found) {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE,
                        null, "[DRM][3Feb2014] Key system access denied! -- No valid audio/video content configurations detected!");
            }
        },

        selectKeySystem: function(ksAccess) {
            this.debug.log("[DRM][3Feb2014] Select key system " + ksAccess.keySystem.systemString);
            try {
                mediaKeys = ksAccess.mediaKeys = new window[api.MediaKeys](ksAccess.keySystem.systemString);
                this.keySystem = ksAccess.keySystem;
                keySystemAccess = ksAccess;
                if (videoElement) {
                    setMediaKeys.call(this);
                }
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED);

            } catch (error) {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED,
                        null, "Error selecting keys system (" + this.keySystem.systemString + ")! Could not create MediaKeys -- TODO");
            }
        },

        setMediaElement: function(mediaElement) {
            if (videoElement === mediaElement)
                return;

            // Replacing the previous element
            if (videoElement) {
                videoElement.removeEventListener(api.needkey, eventHandler);
                videoElement.removeEventListener("loadedmetadata", boundDoSetKeys);
            }

            videoElement = mediaElement;

            // Only if we are not detaching from the existing element
            if (videoElement) {
                //videoElement.addEventListener(api.needkey, eventHandler);
                if (mediaKeys) {
                    setMediaKeys.call(this);
                }
            }
        },

        createKeySession: function(initData, sessionType, cdmData) {

            if (!this.keySystem || !mediaKeys || !keySystemAccess) {
                throw new Error("Can not create sessions until you have selected a key system");
            }

            this.debug.log("[DRM][3Feb2014] Create key session");

            // Use the first video capability for the contentType.
            // TODO:  Not sure if there is a way to concatenate all capability data into a RFC6386-compatible format
            var contentType = keySystemAccess.ksConfiguration.videoCapabilities[0].contentType;
            var session = mediaKeys.createSession(contentType, new Uint8Array(initData), cdmData ? new Uint8Array(cdmData) : null);
            var sessionToken = createSessionToken.call(this, session, initData);

            // Add all event listeners
            session.addEventListener(api.error, sessionToken);
            session.addEventListener(api.message, sessionToken);
            session.addEventListener(api.ready, sessionToken);
            session.addEventListener(api.close, sessionToken);

            // Add to our session list
            sessions.push(sessionToken);

            this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, sessionToken);
        },

        updateKeySession: function(sessionToken, message) {

            var session = sessionToken.session;

            this.debug.log("[DRM][3Feb2014] Update key session");

            if (!this.protectionExt.isClearKey(this.keySystem)) {
                // Send our request to the key session
                session.update(new Uint8Array(message));
            } else {
                // For clearkey, message is a MediaPlayer.vo.protection.ClearKeyKeySet
                session.update(new Uint8Array(message.toJWK()));
            }
        },

        /**
         * Close the given session and release all associated keys.  Following
         * this call, the sessionToken becomes invalid
         *
         * @param sessionToken the session token
         */
        closeKeySession: function(sessionToken) {

            this.debug.log("[DRM][3Feb2014] Close key session, token = " + sessionToken.session.sessionId);

            var session = sessionToken.session;

            // Remove event listeners
            session.removeEventListener(api.error, sessionToken);
            session.removeEventListener(api.message, sessionToken);
            session.removeEventListener(api.ready, sessionToken);
            session.removeEventListener(api.close, sessionToken);

            // Remove from our session list
            for (var i = 0; i < sessions.length; i++) {
                if (sessions[i] === sessionToken) {
                    sessions.splice(i,1);
                    break;
                }
            }

            // Send our request to the key session
            session[api.release]();
        },

        setServerCertificate: function(/*serverCertificate*/) { /* Not supported */ },

        loadKeySession: function(/*sessionID*/) { /* Not supported */ },

        removeKeySession: function(/*sessionToken*/) { /* Not supported */ },

        checkIfEncrypted: function() { /* Not supported */ }

    };
};

// Defines the supported 3Feb2014 API variations
MediaPlayer.models.ProtectionModel_3Feb2014.APIs = [
    // MS-prefixed (IE11, Windows 8.1)
    {
        // Video Element
        setMediaKeys: "msSetMediaKeys",

        // MediaKeys
        MediaKeys: "MSMediaKeys",

        // MediaKeySession
        release: "close",

        // Events
        needkey: "msneedkey",
        error: "mskeyerror",
        message: "mskeymessage",
        ready: "mskeyadded",
        close: "mskeyclose"
    },

    // Un-prefixed as per spec
    // Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
    {
        // Video Element
        setMediaKeys: "setMediaKeys",

        // MediaKeys
        MediaKeys: "MediaKeys",

        // MediaKeySession
        release: "close",

        // Events
        needkey: "needkey",
        error: "keyerror",
        message: "keymessage",
        ready: "keyadded",
        close: "keyclose"
    }
];

/**
 * Detects presence of EME v3Feb2014 APIs
 *
 * @param videoElement {HTMLMediaElement} the media element that will be
 * used for detecting APIs
 * @returns {Object} an API object that is used when initializing the
 * ProtectionModel instance or null if this EME version is not supported
 */
MediaPlayer.models.ProtectionModel_3Feb2014.detect = function(videoElement) {
    var apis = MediaPlayer.models.ProtectionModel_3Feb2014.APIs;
    for (var i = 0; i < apis.length; i++) {
        var api = apis[i];
        if (typeof videoElement[api.setMediaKeys] !== 'function') {
            continue;
        }
        if (typeof window[api.MediaKeys] !== 'function')  {
            continue;
        }
        return api;
    }

    return null;
};

MediaPlayer.models.ProtectionModel_3Feb2014.prototype = {
    constructor: MediaPlayer.models.ProtectionModel_3Feb2014
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Most recent EME implementation
 *
 * Implemented by Google Chrome v36+ (Windows, OSX, Linux)
 *
 * @implements MediaPlayer.models.ProtectionModel
 * @class
 */
MediaPlayer.models.ProtectionModel_21Jan2015 = function () {

    var videoElement = null,
        mediaKeys = null,
        eventHandler = null,

        // Session list
        sessions = [],

        arrayToHexString = function (array) {

            var str = "[",
                i;

            for (i = 0; i < array.length; i++) {
                str += "0x" + array[i].toString(16);
                if (i < (array.length - 1)) {
                    str += ",";
                }
            }

            str += "]";

            return str;
        },

        requestKeySystemAccessInternal = function(ksConfigurations, idx) {
            var self = this;
            (function(i) {
                var keySystem = ksConfigurations[i].ks;
                var configs = ksConfigurations[i].configs;
                self.debug.log("[DRM][PM_21Jan2015] requestMediaKeySystemAccess: " + keySystem.systemString);
                navigator.requestMediaKeySystemAccess(keySystem.systemString, configs).then(function(mediaKeySystemAccess) {

                    // Chrome 40 does not currently implement MediaKeySystemAccess.getConfiguration()
                    var configuration = (typeof mediaKeySystemAccess.getConfiguration === 'function') ?
                            mediaKeySystemAccess.getConfiguration() : null;
                    var keySystemAccess = new MediaPlayer.vo.protection.KeySystemAccess(keySystem, configuration);
                    keySystemAccess.mksa = mediaKeySystemAccess;
                    self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, keySystemAccess);
                }).catch(function() {
                    if (++i < ksConfigurations.length) {
                        requestKeySystemAccessInternal.call(self, ksConfigurations, i);
                    } else {
                        self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_ACCESS_COMPLETE, null, "Key system access denied!");
                    }
                });
            })(idx);
        },

        closeKeySessionInternal = function(sessionToken) {
            var session = sessionToken.session;
            // Remove event listeners
            session.removeEventListener("keystatuseschange", sessionToken);
            session.removeEventListener("message", sessionToken);

            // Send our request to the key session
            return session.close();
        },

        // This is our main event handler for all desired HTMLMediaElement events
        // related to EME.  These events are translated into our API-independent
        // versions of the same events
        createEventHandler = function() {
            var self = this;
            return {
                session : null,

                handleEvent: function(event) {
                    switch (event.type) {

                        case "encrypted":
                            self.debug.log("[DRM][PM_21Jan2015] 'encrypted' event");
                            // this code is commented as the license retrieval is done on the key initialisation
                            // if (event.initData) {
                            //     var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                            //     self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_NEED_KEY,
                            //             new MediaPlayer.vo.protection.NeedKey(initData, event.initDataType));
                            // }
                        break;

                        case "waitingforkey":
                            // Chrome doesn't raised error if keys don't match
                            // so the unique wy is to track this event and raise an error
                            self.debug.log("[DRM][PM_21Jan2015] 'waitingforkey' event");
                            // Set licenseStored to false to remove the session
                            if (this.session !== null) {
                                this.session.licenseStored = false;
                                this.session = null;
                            }
                            videoElement.removeEventListener("waitingforkey", eventHandler);
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR,
                                new MediaPlayer.vo.protection.KeyError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ENCRYPTED, "Media is encrypted and no key is available"));

                        break;
                    }
                }
            };
        },

        removeSession = function(token) {
            // Remove from our session list
            for (var i = 0; i < sessions.length; i++) {
                if (sessions[i] === token) {
                    sessions.splice(i,1);
                    break;
                }
            }
        },

        // Function to create our session token objects which manage the EME
        // MediaKeySession and session-specific event handler
        createSessionToken = function(session, initData, sessionType) {

            var self = this;
            var token = { // Implements MediaPlayer.vo.protection.SessionToken
                session: session,
                initData: initData,
                licenseStored: false,

                // This is our main event handler for all desired MediaKeySession events
                // These events are translated into our API-independent versions of the
                // same events
                handleEvent: function(event) {
                    switch (event.type) {

                        case "keystatuseschange":
                            self.debug.log("[DRM][PM_21Jan2015] 'keystatuseschange' event: ", event);
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED, this);

                             event.target.keyStatuses.forEach(function() {
                                // has Edge and Chrome implement different version of keystatues, param are not on same order
                                var status, keyId;
                                if(arguments && arguments.length > 0){
                                    if(arguments[0]){
                                        if(typeof arguments[0] === 'string'){
                                            status = arguments[0];
                                        }else{
                                            keyId = arguments[0];
                                        }
                                    }

                                    if(arguments[1]){
                                        if(typeof arguments[1] === 'string'){
                                            status = arguments[1];
                                        }else{
                                            keyId = arguments[1];
                                        }
                                    }
                                }
                                self.debug.log("[DRM][PM_21Jan2015] status = " + status + " for KID " + arrayToHexString(new Uint8Array(keyId)));
                                switch (status) {
                                    case "expired":
                                      // Report an expired key.
                                      self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED, null,
                                            new MediaPlayer.vo.Error(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_ENCRYPTED, "License has expired!!!", null));
                                      break;
                                    //case "usable":
                                    //case "status-pending":
                                    default:
                                        self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_STATUSES_CHANGED,
                                            {status:status, keyId: keyId});
                                    }
                                  });

                            break;

                        case "message":
                            self.debug.log("[DRM][PM_21Jan2015] 'message' event: ", event);
                            var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_MESSAGE,
                                    new MediaPlayer.vo.protection.KeyMessage(this, message, undefined, event.messageType));
                            break;
                    }
                },

                getSessionID: function() {
                    return this.session.sessionId;
                },

                getExpirationTime: function() {
                    return this.session.expiration;
                },

                getKeyStatuses: function() {
                    return this.session.keyStatuses;
                },

                getSessionType: function() {
                    return sessionType;
                }
            };

            // Add all event listeners
            session.addEventListener("keystatuseschange", token);
            session.addEventListener("message", token);

            // Register callback for session closed Promise
            session.closed.then(function () {
                removeSession(token);
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED,
                        token.getSessionID());
            });

            // Add to our session list
            sessions.push(token);

            return token;
        };

    return {
        system: undefined,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,
        protectionExt: undefined,
        keySystem: null,
        debug: null,

        setup: function() {
            eventHandler = createEventHandler.call(this);
        },

        /**
         * Initialize this protection model
         */
        init: function() {
        },

        teardown: function() {
            var session,
                i;

            this.debug.log("[DRM][PM_21Jan2015] Teardown");

            // remove session without license
            for (i = 0; i < sessions.length; i++) {
                session = sessions[i];
                if (!session.licenseStored) {
                   sessions.splice(i, 1);
                   i--;
                }
            }

            videoElement.removeEventListener("waitingforkey", eventHandler);

            // Do not close and remove sessions to keep licences persistence
            this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
            return;

            /*if (numSessions !== 0) {
                // Called when we are done closing a session.  Success or fail
                var done = function(session) {
                    removeSession(session);
                    if (sessions.length === 0) {
                        if (videoElement) {
                            videoElement.removeEventListener("encrypted", eventHandler);
                            videoElement.setMediaKeys(null).then(function () {
                                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
                            });
                        } else {
                            self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
                        }
                    }
                };
                for (var i = 0; i < numSessions; i++) {
                    session = sessions[i];
                    (function (s) {
                        // Override closed promise resolver
                        session.session.closed.then(function () {
                            done(s);
                        });
                        // Close the session and handle errors, otherwise promise
                        // resolver above will be called
                        closeKeySessionInternal(session).catch(function () {
                            done(s);
                        });

                    })(session);
                }
            } else {
                this.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_TEARDOWN_COMPLETE);
            }*/
        },

        getAllInitData: function() {
            var retVal = [];
            for (var i = 0; i < sessions.length; i++) {
                retVal.push(sessions[i].initData);
            }
            return retVal;
        },

        requestKeySystemAccess: function(ksConfigurations) {
            requestKeySystemAccessInternal.call(this, ksConfigurations, 0);
        },

        selectKeySystem: function(keySystemAccess) {

            var self = this;

            self.debug.log("[DRM][PM_21Jan2015] Select key system, create new MediaKeys");

            if (mediaKeys !== null) {
                self.debug.log("[DRM][PM_21Jan2015] MediaKeys already created");
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED);
                return;
            }

            keySystemAccess.mksa.createMediaKeys().then(function(mkeys) {
                self.keySystem = keySystemAccess.keySystem;
                mediaKeys = mkeys;
                if (videoElement) {
                    videoElement.setMediaKeys(mediaKeys);
                }
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED);

            }).catch(function() {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SYSTEM_SELECTED,
                        null, "Error selecting keys system (" + keySystemAccess.keySystem.systemString + ")! Could not create MediaKeys -- TODO");

            });
        },

        setMediaElement: function(mediaElement) {
            if (videoElement === mediaElement)
                return;

            // Since this model is a singleton for media key sessions persistance,
            // we ignore reseting video element.
            if (mediaElement === null) {
                return;
            }

            // Replacing the previous element
            if (videoElement) {
                videoElement.removeEventListener("encrypted", eventHandler);
                videoElement.removeEventListener("waitingforkey", eventHandler);
                videoElement.setMediaKeys(null);
            }

            videoElement = mediaElement;

            // Only if we are not detaching from the existing element
            if (videoElement) {
                videoElement.addEventListener("encrypted", eventHandler);
                if (mediaKeys) {
                    videoElement.setMediaKeys(mediaKeys);
                }
            }
        },

        setServerCertificate: function(serverCertificate) {
            if (!this.keySystem || !mediaKeys) {
                throw new Error("Can not set server certificate until you have selected a key system");
            }

            var self = this;
            mediaKeys.setServerCertificate(serverCertificate).then(function() {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_SERVER_CERTIFICATE_UPDATED);
            }).catch(function(error) {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_SERVER_CERTIFICATE_UPDATED,
                        null, "Error updating server certificate -- " + error.name);
            });
        },

        createKeySession: function(initData, sessionType) {

            if (!this.keySystem || !mediaKeys) {
                throw new Error("Can not create sessions until you have selected a key system");
            }

            this.debug.log("[DRM][PM_21Jan2015] Create key session, type = " + sessionType);

            var session = mediaKeys.createSession(sessionType);
            var sessionToken = createSessionToken.call(this, session, initData, sessionType);

            // Generate initial key request
            var self = this;
            session.generateRequest("cenc", initData).then(function() {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, sessionToken);
            }).catch(function(ex) {
                removeSession(sessionToken);
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, null, {
                    reason: "Failed to generate key request",
                    error: new MediaPlayer.vo.Error(ex.code, ex.name, ex.message)
                });
            });
        },

        updateKeySession: function(sessionToken, message) {

            var session = sessionToken.session;

            // Send our request to the key session
            var self = this;

            self.debug.log("[DRM][PM_21Jan2015] Update key session");

            if (this.protectionExt.isClearKey(this.keySystem)) {
                message = message.toJWK();
            }
            session.update(message)
            .then(function(){
                // track license has been stored in order to not retry request
                sessionToken.licenseStored = true;
                // used to monitor wrong key added to the CDM
                eventHandler.session = sessionToken;
                videoElement.addEventListener("waitingforkey", eventHandler);
            })
            .catch(function (ex) {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_ERROR,
                    new MediaPlayer.vo.protection.KeyError(MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_KEYERR, "Error while providing license to the CDM", ex));
            });
        },

        loadKeySession: function(sessionID) {
            if (!this.keySystem || !mediaKeys) {
                throw new Error("Can not load sessions until you have selected a key system");
            }

            this.debug.log("[DRM][PM_21Jan2015] Load key session, id = " + sessionID);

            var session = mediaKeys.createSession();

            // Load persisted session data into our newly created session object
            var self = this;
            session.load(sessionID).then(function (success) {
                if (success) {
                    var sessionToken = createSessionToken.call(this, session);
                    self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, sessionToken);
                } else {
                    self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, null, {
                        reason: "Failed to load session " + sessionID,
                        error: null
                    });
                }
            }).catch(function (ex) {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CREATED, {
                    reason: "Failed to load session " + sessionID,
                    error: new MediaPlayer.vo.Error(ex.code, ex.name, ex.message)
                });
            });
        },

        removeKeySession: function(sessionToken) {

            var session = sessionToken.session;

            this.debug.log("[DRM][PM_21Jan2015] Remove key session");

            var self = this;
            session.remove().then(function () {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_REMOVED,
                        sessionToken.getSessionID());
            }, function (error) {
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_REMOVED,
                        null, "Error removing session (" + sessionToken.getSessionID() + "). " + error.name);
            });
        },

        closeKeySession: function(sessionToken) {

            this.debug.log("[DRM][PM_21Jan2015] Close key session");

            // Send our request to the key session
            var self = this;
            closeKeySessionInternal(sessionToken).catch(function(error) {
                removeSession(sessionToken);
                self.notify(MediaPlayer.models.ProtectionModel.eventList.ENAME_KEY_SESSION_CLOSED,
                        null, "Error closing session (" + sessionToken.getSessionID() + ") " + error.name);
            });
        },

        checkIfEncrypted: function() {
            videoElement.addEventListener("waitingforkey", eventHandler);
        }
    };
};

/**
 * Detects presence of EME v21Jan2015 APIs
 *
 * @param videoElement {HTMLMediaElement} the media element that will be
 * used for detecting API support
 * @returns {Boolean} true if support was detected, false otherwise
 */
MediaPlayer.models.ProtectionModel_21Jan2015.detect = function(videoElement) {
    if (videoElement.onencrypted === undefined ||
            videoElement.mediaKeys === undefined) {
        return false;
    }
    if (navigator.requestMediaKeySystemAccess === undefined ||
            typeof navigator.requestMediaKeySystemAccess !== 'function') {
        return false;
    }

    if(window.MSMediaKeys){
        return false;
    }

    return true;
};

MediaPlayer.models.ProtectionModel_21Jan2015.prototype = {
    constructor: MediaPlayer.models.ProtectionModel_21Jan2015
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Defines the public interface for all Key Systems (DRMs) supported
 * by the player.
 *
 * @interface
 */

MediaPlayer.dependencies.protection.KeySystem = function() {};

/**
 * Key system name string (e.g. 'org.w3.clearkey')
 *
 * @instance
 * @name systemString
 * @memberof MediaPlayer.dependencies.protection.KeySystem
 * @readonly
 * @type String
 */

/**
 * Key system UUID in the form '01234567-89ab-cdef-0123-456789abcdef'
 *
 * @instance
 * @name uuid
 * @memberof MediaPlayer.dependencies.protection.KeySystem
 * @readonly
 * @type String
 */

/**
 * The scheme ID URI for this key system in the form
 * 'urn:uuid:01234567-89ab-cdef-0123-456789abcdef' as used
 * in DASH ContentProtection elements
 *
 * @instance
 * @name schemeIdURI
 * @memberof MediaPlayer.dependencies.protection.KeySystem
 * @readonly
 * @type String
 */


/**
 * The sessionType used for the CDM
 *
 * @instance
 * @name sessionType
 * @memberof MediaPlayer.dependencies.protection.KeySystem
 * @readonly
 * @type String
 */

/**
 * Parse DRM-specific init data from the ContentProtection
 * element.
 *
 * @function
 * @name MediaPlayer.dependencies.protection.KeySystem#getInitData
 * @param {Object} contentProtection the json-style contentProtection
 * object representing the ContentProtection element parsed from the
 * MPD XML document.
 * @returns {ArrayBuffer} EME initialization data
 */

/**
 * For some key systems, the CDM message contains HTTP headers that
 * can be parsed by the application and attached to the license request.
 * Returns a header object with key/value pairs as object properties/values
 *
 * @function
 * @name MediaPlayer.dependencies.protection.KeySystem#getRequestHeadersFromMessage
 * @param {ArrayBuffer} message the CDM message
 * @returns {?Object} headers object with header names as the object property
 * names and header values as the corresponding object property values.  Return
 * null if no such headers were found or if the mechanism is not supported by
 * this key system
 */

/**
 * For some key systems, the CDM message contains more than just the
 * license request data.  This method will pull the license request from
 * the CDM message, if necessary.
 *
 * @function
 * @name MediaPlayer.dependencies.protection.KeySystem#getKeySystemConfigurations
 * @param {object} videoInfo contains relevant info about video (mimeType, codec)
 * @param {object} audioInfo contains relevant info about audio (mimeType, codec)
 * @param {String} sessionType the session type like "temporary" or "persistent-license"
 * @returns {Array} list of {MediaPlayer.vo.protection.KeySystemConfiguration}
 *

 * @function
 * @name MediaPlayer.dependencies.protection.KeySystem#getLicenseRequestFromMessage
 * @param message {ArrayBuffer} the CDM message
 * @returns {Uint8Array} the license request message as will be passed to
 * XMLHttpRequest.send()
 */

/**
 * Returns a license server URL as parsed from key system initialization data (PSSH).
 *
 * @function
 * @name MediaPlayer.dependencies.protection.KeySystem#getLicenseServerURLFromInitData
 * @param initData {ArrayBuffer} the initialization data.  This is just the "Data" field
 * from the PSSH box definition
 * @returns {?string} The license server URL or null if URL is not available in initData
 */

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Adobe Access DRM
 *
 * @class
 * @implements MediaPlayer.dependencies.protection.KeySystem
 */
MediaPlayer.dependencies.protection.KeySystem_Access = function() {
    "use strict";
};

MediaPlayer.dependencies.protection.KeySystem_Access.prototype = {
    constructor: MediaPlayer.dependencies.protection.KeySystem_Access
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

MediaPlayer.dependencies.protection.KeySystem_ClearKey = function() {
    "use strict";

    var keySystemStr = "org.w3.clearkey",
        keySystemUUID = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b",
        protData;

    return {

        system: undefined,
        schemeIdURI: "urn:uuid:" + keySystemUUID,
        systemString: keySystemStr,
        uuid: keySystemUUID,
        sessionType:"temporary",

        init: function(protectionData){
            protData = protectionData;
        },

        getInitData: MediaPlayer.dependencies.protection.CommonEncryption.parseInitDataFromContentProtection,

        getKeySystemConfigurations: MediaPlayer.dependencies.protection.CommonEncryption.getKeySystemConfigurations,

        getRequestHeadersFromMessage: function(/*message*/) { return null; },

        getLicenseRequestFromMessage: function(message) { return new Uint8Array(message); },

        getLicenseServerURLFromInitData: function(/*initData*/) { return null; },

        getCDMData: function () {return null;}
    };
};

MediaPlayer.dependencies.protection.KeySystem_ClearKey.prototype = {
    constructor: MediaPlayer.dependencies.protection.KeySystem_ClearKey
};

/**
 * Returns desired clearkeys (as specified in the CDM message) from protection data
 *
 * @param {MediaPlayer.vo.protection.ProtectionData} protData the protection data
 * @param {ArrayBuffer} message the ClearKey CDM message
 * @returns {MediaPlayer.vo.protection.ClearKeyKeySet} the key set or null if none found
 * @throws {Error} if a keyID specified in the CDM message was not found in the
 * protection data
 * @memberof MediaPlayer.dependencies.protection.KeySystem_ClearKey
 */
MediaPlayer.dependencies.protection.KeySystem_ClearKey.getClearKeysFromProtectionData = function(protData, message) {
    var clearkeySet = null;
    if (protData) {
        // ClearKey is the only system that does not require a license server URL, so we
        // handle it here when keys are specified in protection data
        var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message)));
        var keyPairs = [];
        for (var i = 0; i < jsonMsg.kids.length; i++) {
            var clearkeyID = jsonMsg.kids[i],
                    clearkey = (protData.clearkeys.hasOwnProperty(clearkeyID)) ? protData.clearkeys[clearkeyID] : null;
            if (!clearkey) {
                throw new Error("[DRM] ClearKey keyID (" + clearkeyID + ") is not known!");
            }
            // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded
            keyPairs.push(new MediaPlayer.vo.protection.KeyPair(clearkeyID, clearkey));
        }
        clearkeySet = new MediaPlayer.vo.protection.ClearKeyKeySet(keyPairs);
    }
    return clearkeySet;
};



/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Microsoft PlayReady DRM
 *
 * @class
 * @implements MediaPlayer.dependencies.protection.KeySystem
 */
MediaPlayer.dependencies.protection.KeySystem_PlayReady = function() {
    "use strict";

    var keySystemStr = "com.microsoft.playready",
        keySystemUUID = "9a04f079-9840-4286-ab92-e65be0885f95",
        messageFormat = "utf16",
        PRCDMData = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>',
        protData,

        getRequestHeaders = function(message) {
            var msg,
                xmlDoc,
                headers = {},
                data = (message instanceof ArrayBuffer) ? message : message.buffer,
                dataview = (messageFormat === "utf16") ? new Uint16Array(data) : new Uint8Array(data),
                headerNameList,
                headerValueList,
                i = 0;

            msg = String.fromCharCode.apply(null, dataview);
            xmlDoc = this.domParser.createXmlTree(msg);

            headerNameList = xmlDoc.getElementsByTagName("name");
            headerValueList = xmlDoc.getElementsByTagName("value");
            for (i = 0; i < headerNameList.length; i += 1) {
                headers[headerNameList[i].childNodes[0].nodeValue] = headerValueList[i].childNodes[0].nodeValue;
            }
            // Some versions of the PlayReady CDM return 'Content' instead of 'Content-Type'.
            // this is NOT w3c conform and license servers may reject the request!
            // -> rename it to proper w3c definition!
            if (headers.hasOwnProperty('Content')) {
                headers['Content-Type'] = headers.Content;
                delete headers.Content;
            }

            // Some versions of the PlayReady CDM do not return headers at all, which means the Content-Type
            // does not get set and most license servers will just refuse the license request.
            // -> set it manually if is missing.
            if (!headers.hasOwnProperty('Content-Type')) {
                headers['Content-Type'] = 'text/xml; charset=utf-8';
            }

            return headers;
        },

        getLicenseRequest = function(message) {
            var msg,
                xmlDoc,
                licenseRequest = null,
                data = (message instanceof ArrayBuffer) ? message : message.buffer,
                dataview = (messageFormat === "utf16") ? new Uint16Array(data) : new Uint8Array(data),
                Challenge;

            msg = String.fromCharCode.apply(null, dataview);
            xmlDoc = this.domParser.createXmlTree(msg);

            if (xmlDoc.getElementsByTagName("Challenge")[0]) {
                Challenge = xmlDoc.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
                if (Challenge) {
                    licenseRequest = BASE64.decode(Challenge);
                }
            } else {
                // Some versions of the PlayReady CDM do not return the Microsoft-specified XML structure
                // but just return the raw license request. If we can't extract the license request, let's
                // assume it is the latter and just return the whole message.
                licenseRequest = msg;
            }
            return licenseRequest;
        },

        getLicenseServerURL = function(initData) {
            if (initData) {
                var data = new DataView(initData),
                        numRecords = data.getUint16(4, true),
                        offset = 6,
                        i = 0,
                        recordType,
                        recordLength,
                        recordData,
                        record,
                        xmlDoc,
                        laurl,
                        luiurl;

                for (i = 0; i < numRecords; i++) {
                    // Parse the PlayReady Record header
                    recordType = data.getUint16(offset, true);
                    offset += 2;
                    recordLength = data.getUint16(offset, true);
                    offset += 2;
                    if (recordType !== 0x0001) {
                        offset += recordLength;
                        continue;
                    }

                    recordData = initData.slice(offset, offset+recordLength);
                    record = String.fromCharCode.apply(null, new Uint16Array(recordData));
                    xmlDoc = this.domParser.createXmlTree(record);

                    // First try <LA_URL>
                    if (xmlDoc.getElementsByTagName("LA_URL")[0]) {
                        laurl = xmlDoc.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                        if (laurl) {
                            return laurl;
                        }
                    }

                    // Optionally, try <LUI_URL>
                    if (xmlDoc.getElementsByTagName("LUI_URL")[0]) {
                        luiurl = xmlDoc.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                        if (luiurl) {
                            return luiurl;
                        }
                    }
                }
            }

            return null;

        },

        parseInitDataFromContentProtection = function(cpData) {
            // * desc@ getInitData
            // *   generate PSSH data from PROHeader defined in MPD file
            // *   PSSH format:
            // *   size (4)
            // *   box type(PSSH) (8)
            // *   Protection SystemID (16)
            // *   protection system data size (4) - length of decoded PROHeader
            // *   decoded PROHeader data from MPD file
            var byteCursor = 0,
                PROSize,
                PSSHSize,
                PSSHBoxType = new Uint8Array([0x70, 0x73, 0x73, 0x68, 0x00, 0x00, 0x00, 0x00 ]), //'PSSH' 8 bytes
                playreadySystemID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]),
                uint8arraydecodedPROHeader = null,
                PSSHBoxBuffer,
                PSSHBox,
                PSSHData;

            // Handle common encryption PSSH
            if ("pssh" in cpData) {
                return MediaPlayer.dependencies.protection.CommonEncryption.parseInitDataFromContentProtection(cpData);
            }
            // Handle native MS PlayReady ContentProtection elements
            if ("pro" in cpData) {
                uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.pro.__text);
            }
            else if ("prheader" in cpData) {
                uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.prheader.__text);
            }
            else {
                return null;
            }

            PROSize = uint8arraydecodedPROHeader.length;
            PSSHSize = 0x4 + PSSHBoxType.length + playreadySystemID.length + 0x4 + PROSize;

            PSSHBoxBuffer = new ArrayBuffer(PSSHSize);

            PSSHBox = new Uint8Array(PSSHBoxBuffer);
            PSSHData = new DataView(PSSHBoxBuffer);

            PSSHData.setUint32(byteCursor, PSSHSize);
            byteCursor += 0x4;

            PSSHBox.set(PSSHBoxType, byteCursor);
            byteCursor += PSSHBoxType.length;

            PSSHBox.set(playreadySystemID, byteCursor);
            byteCursor += playreadySystemID.length;

            PSSHData.setUint32(byteCursor, PROSize);
            byteCursor += 0x4;

            PSSHBox.set(uint8arraydecodedPROHeader, byteCursor);
            byteCursor += PROSize;

            return PSSHBox.buffer;
        },

        doGetCDMData = function () {
            var customData,
                cdmData,
                cdmDataBytes,
                i;

            if (protData && protData.cdmData) {

                // Convert custom data into multibyte string
                customData = [];
                for (i = 0; i < protData.cdmData.length; ++i) {
                    customData.push(protData.cdmData.charCodeAt(i));
                    customData.push(0);
                }
                customData = String.fromCharCode.apply(null, customData);

                // Encode in Base 64 the custom data string
                customData = BASE64.encode(customData);

                // Initialize CDM data with Base 64 encoded custom data
                // (see https://msdn.microsoft.com/en-us/library/dn457361.aspx)
                cdmData = PRCDMData.replace('%CUSTOMDATA%', customData);

                // Convert CDM data into multibyte characters
                cdmDataBytes = [];
                for (i = 0; i < cdmData.length; ++i) {
                    cdmDataBytes.push(cdmData.charCodeAt(i));
                    cdmDataBytes.push(0);
                }

                return new Uint8Array(cdmDataBytes).buffer;
            }

            return null;
        };

    return {

        schemeIdURI: "urn:uuid:" + keySystemUUID,
        systemString: keySystemStr,
        uuid: keySystemUUID,
        notify: undefined,
        subscribe: undefined,
        unsubscribe: undefined,
        domParser: undefined,
        /*sessionType:"persistent-license",*/
        sessionType:"temporary",

        init: function(protectionData){
            if(protectionData){
                protData = protectionData;
                if(protData.sessionType){
                    this.sessionType = protData.sessionType;
                }
            }
        },

        getInitData: parseInitDataFromContentProtection,

        getKeySystemConfigurations: MediaPlayer.dependencies.protection.CommonEncryption.getKeySystemConfigurations,

        getRequestHeadersFromMessage: getRequestHeaders,

        getLicenseRequestFromMessage: getLicenseRequest,

        getLicenseServerURLFromInitData: getLicenseServerURL,

        getCDMData: doGetCDMData,

        /**
         * It seems that some PlayReady implementations return their XML-based CDM
         * messages using UTF16, while others return them as UTF8.  Use this function
         * to modify the message format to expect when parsing CDM messages.
         *
         * @param {string} format the expected message format.  Either "utf8" or "utf16".
         * @throws {Error} Specified message format is not one of "utf8" or "utf16"
         */
        setPlayReadyMessageFormat: function(format) {
            if (format !== "utf8" && format !== "utf16") {
                throw new Error("Illegal PlayReady message format! -- " + format);
            }
            messageFormat = format;
        }
    };
};

MediaPlayer.dependencies.protection.KeySystem_PlayReady.prototype = {
    constructor: MediaPlayer.dependencies.protection.KeySystem_PlayReady
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Google Widevine DRM
 *
 * @class
 * @implements MediaPlayer.dependencies.protection.KeySystem
 */
MediaPlayer.dependencies.protection.KeySystem_Widevine = function() {
    "use strict";

    var keySystemStr = "com.widevine.alpha",
        keySystemUUID = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
        protData = null,

        doGetInitData = function(cpData){
            if(protData && protData.pssh){
                return BASE64.decodeArray(protData.pssh).buffer;
            }

            return MediaPlayer.dependencies.protection.CommonEncryption.parseInitDataFromContentProtection(cpData);

        };

    return {

        schemeIdURI: "urn:uuid:" + keySystemUUID,
        systemString: keySystemStr,
        uuid: keySystemUUID,
        sessionType:"temporary",

        init:function(protectionData){
            if(protectionData){
                protData = protectionData;
                if(protData.sessionType){
                    this.sessionType = protData.sessionType;
                }
            }
        },

        getInitData: doGetInitData,

        getKeySystemConfigurations: MediaPlayer.dependencies.protection.CommonEncryption.getKeySystemConfigurations,

        getRequestHeadersFromMessage: function(/*message*/) { return null; },

        getLicenseRequestFromMessage: function(message) { return new Uint8Array(message); },

        getLicenseServerURLFromInitData: function(/*initData*/) { return null; },

        getCDMData: function () {return null;}

    };
};

MediaPlayer.dependencies.protection.KeySystem_Widevine.prototype = {
    constructor: MediaPlayer.dependencies.protection.KeySystem_Widevine
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CableLabs ClearKey license server implementation
 *
 * For testing purposes and evaluating potential uses for ClearKey, we have developed
 * a dirt-simple API for requesting ClearKey licenses from a remote server.
 *
 * @implements MediaPlayer.dependencies.protection.servers.LicenseServer
 * @class
 */
MediaPlayer.dependencies.protection.servers.ClearKey = function() {
    "use strict";

    return {

        getServerURLFromMessage: function(url, message /*, messageType*/ ) {
            // Build ClearKey server query string
            var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message))),
                i = 0;
            url += "/?";
            for (i = 0; i < jsonMsg.kids.length; i++) {
                url += jsonMsg.kids[i] + "&";
            }
            url = url.substring(0, url.length - 1);
            return url;
        },

        getHTTPMethod: function( /*messageType*/ ) {
            return 'GET';
        },

        getResponseType: function( /*keySystemStr*/ ) {
            return 'json';
        },

        getLicenseMessage: function(serverResponse /*, keySystemStr, messageType*/ ) {
            var i, keyPairs = [],
                keypair,
                keyid,
                key;
            if (!serverResponse.hasOwnProperty("keys")) {
                return null;
            }

            for (i = 0; i < serverResponse.keys.length; i++) {
                keypair = serverResponse.keys[i];
                keyid = keypair.kid.replace(/=/g, "");
                key = keypair.k.replace(/=/g, "");
                keyPairs.push(new MediaPlayer.vo.protection.KeyPair(keyid, key));
            }
            return new MediaPlayer.vo.protection.ClearKeyKeySet(keyPairs);
        },

        getErrorResponse: function(serverResponse/*, keySystemStr, messageType*/) {
            return {
                code: 0,
                name: "UnknownError",
                message: String.fromCharCode.apply(null, new Uint8Array(serverResponse))
            };
        }
    };
};

MediaPlayer.dependencies.protection.servers.ClearKey.prototype = {
    constructor: MediaPlayer.dependencies.protection.servers.ClearKey
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CastLabs DRMToday License Server implementation
 *
 * @implements MediaPlayer.dependencies.protection.servers.LicenseServer
 * @class
 */
MediaPlayer.dependencies.protection.servers.DRMToday = function() {
    "use strict";

    var keySystems = {
        "com.widevine.alpha": {
            responseType: "json",
            getLicenseMessage: function(response) {
                return BASE64.decodeArray(response.license);
            },
            getErrorResponse: function(response) {
                return response;
            }
        },
        "com.microsoft.playready": {
            responseType: "arraybuffer",
            getLicenseMessage: function(response) {
                return response;
            },
            getErrorResponse: function(response) {
                return String.fromCharCode.apply(null, new Uint8Array(response));
            }
        }
    };

    return {

        getServerURLFromMessage: function(url /*, message, messageType*/) { return url; },

        getHTTPMethod: function(/*messageType*/) { return 'POST'; },

        getResponseType: function(keySystemStr/*, messageType*/) {
            return keySystems[keySystemStr].responseType;
        },

        getLicenseMessage: function(serverResponse, keySystemStr/*, messageType*/) {
            return keySystems[keySystemStr].getLicenseMessage(serverResponse);
        },

        getErrorResponse: function(serverResponse, keySystemStr/*, messageType*/) {
            return {
                code: 0,
                name: "UnknownError",
                message: keySystems[keySystemStr].getErrorResponse(serverResponse)
            };
        }
    };
};

MediaPlayer.dependencies.protection.servers.DRMToday.prototype = {
    constructor: MediaPlayer.dependencies.protection.servers.DRMToday
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Defines the public interface for license server implementations supported
 * by the player.
 *
 * Different license servers have different requirements regarding the methods
 * used to request DRM licenses.  Things like request headers, license response
 * formats (for both error and success cases) need to be customized for a
 * specific server implementation
 *
 * License servers handle requests for more than just initial license retrieval.
 * Each API takes a parameter which describes the message type as supported by
 * the Encrypted Media Extensions.
 *
 * @interface
 */

MediaPlayer.dependencies.protection.servers.LicenseServer = function() {};

/**
 * Returns a new or updated license server URL based on the requirements of the
 * license server and possibly from information passed in the CDM license message
 *
 * @function
 * @name MediaPlayer.dependencies.protection.servers.LicenseServer#getServerURLFromMessage
 * @param {?string} url the initially established URL (from ProtectionData or initData)
 * @param {ArrayBuffer} message the CDM message which may be needed to generate the license
 * requests URL
 * @param {String} messageType the message type associated with this request.  Supported
 * message types can be found {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @returns {string} the URL to use in license requests
 */

/**
 * Returns the HTTP method to be used (i.e. "GET", "POST", etc.) in
 * XMLHttpRequest.open().
 *
 * @function
 * @name MediaPlayer.dependencies.protection.servers.LicenseServer#getHTTPMethod
 * @param {String} messageType the message type associated with this request.  Supported
 * message types can be found {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @returns {string} the HTTP method
 */

/**
 * Returns the response type to set for XMLHttpRequest.responseType
 *
 * @function
 * @name MediaPlayer.dependencies.protection.servers.LicenseServer#getResponseType
 * @param {string} keySystemStr the key system string representing the key system
 * associated with a license request.  Multi-DRM license servers may have different
 * response types depending on the key system.
 * @param {String} messageType the message type associated with this request.  Supported
 * message types can be found {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @returns {string} the response type
 */

/**
 * Parses the license server response for any message intended for
 * the CDM.
 *
 * @function
 * @name MediaPlayer.dependencies.protection.servers.LicenseServer#getLicenseMessage
 * @param {Object} serverResponse the response as returned in XMLHttpRequest.response
 * @param {string} keySystemStr the key system string representing the key system
 * associated with a license request.
 * @param {String} messageType the message type associated with this request.  Supported
 * message types can be found {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @returns {ArrayBuffer} message that will be sent to the CDM or null if no CDM message
 * was present in the response.
 */

/**
 * Parses the license server response during error conditions and returns a
 * string to display for debugging purposes
 *
 * @function
 * @name MediaPlayer.dependencies.protection.servers.LicenseServer#getErrorResponse
 * @param {Object} serverResponse the server response
 * @param {String} messageType the message type associated with this request.  Supported
 * message types can be found {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @returns {string} an error message that indicates the reason for the failure
 */

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Microsoft PlayReady Test License Server
 *
 * For testing content that uses the PlayReady test server at
 *
 * @implements MediaPlayer.dependencies.protection.servers.LicenseServer
 * @class
 */
MediaPlayer.dependencies.protection.servers.PlayReady = function() {
    "use strict";

    var decodeUtf8 = function(arrayBuffer) {
            var result = "",
                i = 0,
                c = 0,
                c2 = 0,
                c3 = 0,
                data = new Uint8Array(arrayBuffer);

            // If we have a BOM skip it
            if (data.length >= 3 && data[0] === 0xef && data[1] === 0xbb && data[2] === 0xbf) {
                i = 3;
            }

            while (i < data.length) {
                c = data[i];

                if (c < 128) {
                    result += String.fromCharCode(c);
                    i++;
                } else if (c > 191 && c < 224) {
                    if (i + 1 >= data.length) {
                        throw "UTF-8 Decode failed. Two byte character was truncated.";
                    }
                    c2 = data[i + 1];
                    result += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    if (i + 2 >= data.length) {
                        throw "UTF-8 Decode failed. Multi byte character was truncated.";
                    }
                    c2 = data[i + 1];
                    c3 = data[i + 2];
                    result += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }
            }
            return result;
        },

        parseServerResponse = function(serverResponse) {
            var stringResponse = decodeUtf8(serverResponse),
                xmlDoc = this.domParser.createXmlTree(stringResponse),
                enveloppe = xmlDoc ? this.domParser.getChildNode(xmlDoc, "soap:Envelope") : null,
                body = enveloppe ? this.domParser.getChildNode(enveloppe, "soap:Body") : null,
                fault = body ? this.domParser.getChildNode(body, "soap:Fault") : null;

            if (fault) {
                return null;
            }

            return serverResponse;
        },

        parseErrorResponse = function(serverResponse) {
            var stringResponse = decodeUtf8(serverResponse),
                xmlDoc = this.domParser.createXmlTree(stringResponse),
                enveloppe = xmlDoc ? this.domParser.getChildNode(xmlDoc, "soap:Envelope") : null,
                body = enveloppe ? this.domParser.getChildNode(enveloppe, "soap:Body") : null,
                fault = body ? this.domParser.getChildNode(body, "soap:Fault") : null,
                detail = fault ? this.domParser.getChildNode(fault, "detail") : null,
                exception = detail ? this.domParser.getChildNode(detail, "Exception") : null,
                node = null,
                faultstring = "",
                statusCode = "",
                message = "",
                idStart = -1,
                idEnd = -1;

            if (fault === null) {
                return {
                    code: 0,
                    name: "UnknownError",
                    message: String.fromCharCode.apply(null, new Uint8Array(serverResponse))
                };
            }

            node = this.domParser.getChildNode(fault, "faultstring").firstChild;
            faultstring = node ? node.nodeValue : null;

            if (exception !== null) {
                node = this.domParser.getChildNode(exception, "StatusCode");
                statusCode = node ? node.firstChild.nodeValue : null;

                node = this.domParser.getChildNode(exception, "Message");
                message = node ? node.firstChild.nodeValue : null;
                idStart = message ? message.lastIndexOf('[') + 1 : -1;
                idEnd = message ? message.indexOf(']') : -1;
            }

            return {
                code: statusCode,
                name: faultstring,
                message: message ? message.substring(idStart, idEnd) : ""
            };
        };

    return {
        domParser: undefined,

        getServerURLFromMessage: function(url /*, message, messageType*/) { return url; },

        getHTTPMethod: function(/*messageType*/) { return 'POST'; },

        getResponseType: function(/*keySystemStr, messageType*/) { return 'arraybuffer'; },

        getLicenseMessage: function(serverResponse/*, keySystemStr, messageType*/) {
            return parseServerResponse.call(this, serverResponse);
        },

        getErrorResponse: function(serverResponse/*, keySystemStr, messageType*/) {
            return parseErrorResponse.call(this, serverResponse);
        }
    };
};

MediaPlayer.dependencies.protection.servers.PlayReady.prototype = {
    constructor: MediaPlayer.dependencies.protection.servers.PlayReady
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

MediaPlayer.dependencies.protection.servers.Widevine = function() {
    "use strict";

    return {

        getServerURLFromMessage: function(url /*, message, messageType*/) { return url; },

        getHTTPMethod: function(/*messageType*/) { return 'POST'; },

        getResponseType: function(/*keySystemStr, messageType*/) { return 'arraybuffer'; },

        getLicenseMessage: function(serverResponse/*, keySystemStr, messageType*/) {
            return serverResponse;
        },

        getErrorResponse: function(serverResponse/*, keySystemStr, messageType*/) {
            return {
                code: 0,
                name: "UnknownError",
                message: String.fromCharCode.apply(null, new Uint8Array(serverResponse))
            };
        }
    };
};

MediaPlayer.dependencies.protection.servers.Widevine.prototype = {
    constructor: MediaPlayer.dependencies.protection.servers.Widevine
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * A collection of ClearKey encryption keys with an (optional) associated
 * type
 *
 * @param keyPairs {MediaPlayer.vo.protection.KeyPair[]} array of key pairs
 * @param type the type of keys in this set.  One of either 'persistent'
 * or 'temporary'.  Can also be null or undefined.
 * @constructor
 */
MediaPlayer.vo.protection.ClearKeyKeySet = function(keyPairs, type) {
    if (type && type !== "persistent" && type !== "temporary")
        throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
    this.keyPairs = keyPairs;
    this.type = type;

    /**
     * Convert this key set to its JSON Web Key (JWK) representation
     *
     * @return {ArrayBuffer} JWK object UTF-8 encoded as ArrayBuffer
     */
    this.toJWK = function() {
        var i, numKeys = this.keyPairs.length,
            jwk = {};
        jwk.keys = [];
        for (i = 0; i < numKeys; i++) {
            var key = {
                kty: "oct",
                alg: "A128KW",
                kid: this.keyPairs[i].keyID,
                k: this.keyPairs[i].key
            };
            jwk.keys.push(key);
        }
        if (this.type) {
            jwk.type = this.type;
        }
        var jwkString = JSON.stringify(jwk);
        var len = jwkString.length;

        // Convert JSON string to ArrayBuffer
        var buf = new ArrayBuffer(len);
        var bView = new Uint8Array(buf);
        for (i = 0; i < len; i++)
            bView[i] = jwkString.charCodeAt(i);
        return buf;
    };
};

MediaPlayer.vo.protection.ClearKeyKeySet.prototype = {
    constructor: MediaPlayer.vo.protection.ClearKeyKeySet
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * EME-independent KeyError
 *
 * @param sessionToken the key session to which this error is associated
 * @param errorString an informational error message
 * @class
 * @deprecated Newest versions of EME APIs will not use this error object
 */
MediaPlayer.vo.protection.KeyError = function(code, message, data) {
    "use strict";
    this.code = code;
    this.message = message;
    this.data = data;
};

MediaPlayer.vo.protection.KeyError.prototype = {
    constructor: MediaPlayer.vo.protection.KeyError
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * EME-independent KeyMessage
 *
 * @param {MediaPlayer.vo.protection.SessionToken} sessionToken the session
 * to which the key message is associated
 * @param {ArrayBuffer} message the key message
 * @param [defaultURL] license acquisition URL provided by the CDM
 * @param [messageType] the message type.  One of "license-request",
 * "license-renewal", "license-release", "individualization-request"
 * @constructor
 */
MediaPlayer.vo.protection.KeyMessage = function(sessionToken, message, defaultURL, messageType) {
    "use strict";
    this.sessionToken = sessionToken;
    this.message = message;
    this.defaultURL = defaultURL;
    this.messageType = messageType;
};

MediaPlayer.vo.protection.KeyMessage.prototype = {
    constructor: MediaPlayer.vo.protection.KeyMessage
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Represents a 128-bit keyID and 128-bit encryption key
 *
 * @param keyID {String} 128-bit key ID, base64 encoded, with no padding
 * @param key {String} 128-bit encryption key, base64 encoded, with no padding
 * @constructor
 */
MediaPlayer.vo.protection.KeyPair = function(keyID, key) {
    "use strict";
    this.keyID = keyID;
    this.key = key;
};

MediaPlayer.vo.protection.KeyPair.prototype = {
    constructor: MediaPlayer.vo.protection.KeyPair
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Creates a new key system access token.  Represents a valid key system for
 * given piece of content and key system requirements.  Used to initialize license
 * acquisition operations.
 *
 * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
 * @param {MediaPlayer.vo.protection.KeySystemConfiguration} ksConfiguration the
 * subset of configurations passed to the key system access request that are supported
 * by this user agent
 * @constructor
 */
MediaPlayer.vo.protection.KeySystemAccess = function(keySystem, ksConfiguration) {
    this.keySystem = keySystem;
    this.ksConfiguration = ksConfiguration;
};

MediaPlayer.vo.protection.KeySystemAccess.prototype = {
    constructor: MediaPlayer.vo.protection.KeySystemAccess
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 *
 * @param {MediaPlayer.vo.protection.MediaCapability[]} audioCapabilities
 * @param {MediaPlayer.vo.protection.MediaCapability[]} videoCapabilities
 * @param {string} [distinctiveIdentifier]
 * @param {string} [persistentState]
 * @constructor
 */
MediaPlayer.vo.protection.KeySystemConfiguration = function(audioCapabilities, videoCapabilities, distinctiveIdentifier, persistentState, sessionTypes) {
    this.initDataTypes = [ "cenc" ];
    this.audioCapabilities = audioCapabilities;
    this.videoCapabilities = videoCapabilities;
    this.distinctiveIdentifier = distinctiveIdentifier;
    this.persistentState = persistentState;
    this.sessionTypes = sessionTypes;
};

MediaPlayer.vo.protection.KeySystemConfiguration.prototype = {
    constructor: MediaPlayer.vo.protection.KeySystemConfiguration
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Event indicating the receipt of a response from a license server
 *
 * @param message {Uint8Array} license response message
 * @param requestData a request-specific data object
 * @constructor
 */
MediaPlayer.vo.protection.LicenseRequestComplete = function(message, requestData) {
    "use strict";
    this.message = message;
    this.requestData = requestData;
};

MediaPlayer.vo.protection.LicenseRequestComplete.prototype = {
    constructor: MediaPlayer.vo.protection.LicenseRequestComplete
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A media capability
 *
 * @param {string} contentType MIME type and codecs (RFC6386)
 * @param {string} [robustness]
 * @constructor
 */
MediaPlayer.vo.protection.MediaCapability = function(contentType, robustness) {
    this.contentType = contentType;
    this.robustness = robustness;
};

MediaPlayer.vo.protection.MediaCapability.prototype = {
    constructor: MediaPlayer.vo.protection.MediaCapability
};

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * EME-independent NeedKey
 *
 * @param initData the initialization data
 * @param [initDataType] initialization data type
 * @constructor
 */
MediaPlayer.vo.protection.NeedKey = function(initData, initDataType) {
    this.initData = initData;
    this.initDataType = initDataType;
};

MediaPlayer.vo.protection.NeedKey.prototype = {
    constructor: MediaPlayer.vo.protection.NeedKey
};


/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Data used to customize KeySystems and override default or CDM-provided
 * values
 *
 * @param {string} laURL a license acquisition URL to use with this key system
 * @param {Object} httpRequestHeaders headers to add to the http request
 * @param {Object} bearerToken
 * @param {Object} clearkeys defines a set of clear keys that are available to
 * the key system.  Object properties are base64-encoded keyIDs (with no padding).
 * Corresponding property values are keys, base64-encoded (no padding).
 * @constructor
 */
MediaPlayer.vo.protection.ProtectionData = function(laURL, httpRequestHeaders, bearerToken, clearkeys) {
    this.laURL = laURL;
    this.httpRequestHeaders = httpRequestHeaders;
    this.bearerToken = bearerToken;
    this.clearkeys = clearkeys;
};

MediaPlayer.vo.protection.ProtectionData.prototype = {
    constructor: MediaPlayer.vo.protection.ProtectionData
};
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * All session tokens returns by ProtectionModel implementations
 * are guaranteed to contain initialization data and optionally
 * session IDs
 *
 * @constructor
 */
MediaPlayer.models.SessionToken = function () {
    "use strict";
};

MediaPlayer.models.SessionToken.prototype = {

    /**
     * The initialization data used to create this session
     *
     * {Uint8Array} initialization data
     */
    initData: null,

    /**
     * The unique session ID designated to this session
     *
     * @return {string} the session ID or the empty string if the implementation
     * does not support session IDs or the sessionID has not yet been established
     */
    getSessionID: function() { return ""; },

    /**
     * The time, in milliseconds since 01 January, 1970 UTC, after which
     * the key(s) in the session will no longer be usable to decrypt
     * media data, or NaN if no such time exists
     *
     * @returns {Number} the expiration time
     */
    getExpirationTime: function() { return NaN; },

    /**
     * Returns a read-only map of key IDs known to the session to the
     * current status of the associated key.
     *
     * @returns {maplike<BufferSource,MediaKeyStatus>}
     */
    getKeyStatuses: function() { return null; }
};




/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*jshint -W020 */
Hls = (function () {
    "use strict";

    return {
        dependencies: {}
    };
}());
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Hls.dependencies.HlsDemux = function() {
    "use strict";

    var _appendArray = function(array1, array2) {
        var tmp = new Uint8Array(array1.byteLength + array2.byteLength);
        tmp.set(array1, 0);
        tmp.set(array2, array1.byteLength);
        return tmp;
    };

    var pat = null,
        pmt = null,
        pidToTrackId = [],
        tracks = [],
        baseDts = -1,
        dtsOffset = -1,

        getTsPacket = function(data, offset, pid, pusi) {
            var i = offset,
                tsPacket;

            while (i < data.length) {
                tsPacket = new mpegts.ts.TsPacket();
                tsPacket.parse(data.subarray(i, i + mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE));

                //this.debug.log("[HlsDemux] TS packet: pid=" + tsPacket.getPid() + ", pusi = " + tsPacket.getPusi());

                if ((tsPacket.getPid() === pid) && ((pusi === undefined) || (tsPacket.getPusi() === pusi))) {
                    return {
                        offset: i,
                        packet: tsPacket
                    };
                }

                i += mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE;
            }

            return null;
        },

        getPAT = function(data) {
            var tsPacket = getTsPacket.call(this, data, 0, mpegts.ts.TsPacket.prototype.PAT_PID);

            if (tsPacket === null) {
                return null;
            }

            pat = new mpegts.si.PAT();
            pat.parse(tsPacket.packet.getPayload());

            //this.debug.log("[HlsDemux] PAT: PMT_PID=" + pat.getPmtPid());

            return pat;
        },

        getPMT = function(data, pid) {
            var tsPacket = getTsPacket.call(this, data, 0, pid),
                i = 0,
                elementStream,
                track,
                streamTypeDesc;

            if (tsPacket === null) {
                return null;
            }

            pmt = new mpegts.si.PMT();
            pmt.parse(tsPacket.packet.getPayload());

            //this.debug.log("[HlsDemux] PMT");

            for (i = 0; i < pmt.m_listOfComponents.length; i++) {
                elementStream = pmt.m_listOfComponents[i];
                track = new MediaPlayer.vo.Mp4Track();
                streamTypeDesc = pmt.gStreamTypes[elementStream.m_stream_type];
                if (streamTypeDesc !== null) {
                    track.streamType = streamTypeDesc.name;
                    switch (streamTypeDesc.value) {
                        case 0xE0:
                            track.type = "video";
                            break;
                        case 0xC0:
                            track.type = "audio";
                            break;
                        case 0xFC:
                            track.type = "data";
                            break;
                        default:
                            track.type = "und";
                    }
                } else {
                    this.debug.log("[HlsDemux] Stream Type " + elementStream.m_stream_type + " unknown!");
                }

                // PATCH to remove audio track
                // if (track.type === "video") {
                track.timescale = mpegts.Pts.prototype.SYSTEM_CLOCK_FREQUENCY;
                track.pid = elementStream.m_elementary_PID;
                tracks.push(track);
                // }
            }

            return pmt;
        },

        demuxTsPacket = function(data) {
            var tsPacket,
                pid,
                trackId,
                track,
                sample = null,
                sampleData = null,
                pesPacket;

            tsPacket = new mpegts.ts.TsPacket();
            tsPacket.parse(data);

            // If packet has only adaptation field, then ignore
            if (tsPacket.hasAdaptationFieldOnly()) {
                return;
            }

            // Get PID and corresponding track
            pid = tsPacket.getPid();
            trackId = pidToTrackId[pid];
            if (trackId === undefined) {
                return;
            }

            // Get track from tracks array (trackId start from 1)
            track = tracks[trackId - 1];

            // PUSI => start storing new AU
            if (tsPacket.getPusi()) {

                // Parse PES header
                pesPacket = new mpegts.pes.PesPacket();
                pesPacket.parse(tsPacket.getPayload());

                // Store new access unit
                sample = new MediaPlayer.vo.Mp4Track.Sample();
                sample.cts = pesPacket.getPts().getValue();
                sample.dts = (pesPacket.getDts() !== null) ? pesPacket.getDts().getValue() : sample.cts;
                sample.size = 0;
                sample.duration = 0;
                sample.subSamples = [];

                if (baseDts === -1) {
                    baseDts = sample.dts;
                }

                sample.dts -= baseDts;
                sample.cts -= baseDts;

                sample.dts += dtsOffset;
                sample.cts += dtsOffset;

                // Store payload of PES packet as a subsample
                sampleData = pesPacket.getPayload();

                // Set sample flags
                if (track.type === "audio") {
                    sample.flags = 0x01000000; // sample_depends_on = 1, other flags = 0
                }
                if (track.type === "video" && (track.streamType.search('H.264') !== -1)) {
                    // In case of H.264 stream, check if the sample is an IDR sample
                    // If IDR: sample_depends_on = 2, sample_is_non_sync_sample = false
                    // If non-IDR: sample_depends_on = 1, sample_is_non_sync_sample = true
                    sample.flags = mpegts.h264.isIDR(sampleData) ? 0x02000000 : 0x01010000;
                }

                sample.subSamples.push(sampleData);
                track.samples.push(sample);
            } else {
                // Get currently buffered access unit
                if (track.samples.length > 0) {
                    sample = track.samples[track.samples.length - 1];
                }

                // Store payload of TS packet as a subsample
                sample.subSamples.push(tsPacket.getPayload());
            }
        },

        postProcess = function(track) {
            var sample,
                length = 0,
                offset = 0,
                subSamplesLength,
                i, s;

            // Determine total length of track samples data
            // Set samples duration and size
            for (i = 0; i < track.samples.length; i++) {
                subSamplesLength = 0;
                sample = track.samples[i];

                for (s = 0; s < sample.subSamples.length; s++) {
                    subSamplesLength += sample.subSamples[s].length;
                }

                if (i > 0) {
                    track.samples[i - 1].duration = track.samples[i].dts - track.samples[i - 1].dts;
                }

                sample.size = subSamplesLength;
                length += subSamplesLength;
            }
            track.samples[track.samples.length - 1].duration = track.samples[track.samples.length - 2].duration;

            // Allocate track data
            track.data = new Uint8Array(length);

            track.dataCTS = [];

            for (i = 0; i < track.samples.length; i++) {
                sample = track.samples[i];

                // In case of ADTS, for each input sample (i.e. PES packet), we store the CTS (=PTS)
                // in order to set the correct timestamp to each AAC frames after ADTS demultiplexing (see demuxADTS()),
                // and then get around missing frames in input stream
                if (track.streamType.search('ADTS') !== -1) {
                    track.dataCTS[offset] = sample.cts;
                }

                // Copy all sub-sample parts into track data
                for (s = 0; s < sample.subSamples.length; s++) {
                    track.data.set(sample.subSamples[s], offset);
                    offset += sample.subSamples[s].length;
                }
            }

            // In case of H.264 stream, convert bytestream to MP4 format (NALU size field instead of start codes)
            if (track.streamType.search('H.264') !== -1) {
                mpegts.h264.bytestreamToMp4(track.data);
            }

            // In case of AAC-ADTS stream, demultiplex ADTS frames into AAC frames
            // (Demultiplexing is performed on the whole segment data in case ADTS packets are not aligned
            // on PES packets)
            if (track.streamType.search('ADTS') !== -1) {
                demuxADTS.call(this, track);
            }

            // Patch first frame timestamp and duration in case of missing frames at the end
            // of the previous segment
            if (track.previousCts && track.previousDuration) {
                sample = track.samples[0];
                var gap = sample.cts - (track.previousCts + track.previousDuration);
                if (gap > 0) {
                    sample.cts -= gap;
                    sample.dts -= gap;
                    sample.duration += gap;
                    this.debug.log("[HlsDemux][" + track.type + "] Patch sample duration, cts = " + (sample.cts / 90000).toFixed(3) + ", duration = " + (sample.duration / 90000).toFixed(3));
                }
            }

        },

        demuxADTS = function(track) {
            var aacFrames,
                aacSamples = [],
                length,
                offset,
                data,
                sample,
                cts,
                duration,
                i;

            // Parse AAC-ADTS access units and get AAC frames description
            aacFrames = mpegts.aac.parseADTS(track.data, track.dataCTS);

            // And determine total length of AAC frames
            length = 0;
            for (i = 0; i < aacFrames.length; i++) {
                length += aacFrames[i].length;
            }

            // Allocate new data section that will contains all AAC frames
            data = new Uint8Array(length);

            // Store first sample info
            cts = track.samples[0].cts;

            // Determine sample duration
            duration = track.timescale * 1024.0 / track.samplingRate;

            // Copy AAC frames data and create AAC samples
            offset = 0;
            for (i = 0; i < aacFrames.length; i++) {
                // Create sample
                sample = new MediaPlayer.vo.Mp4Track.Sample();

                // Set CTS according to ADTS frame CTS (=PES CTS) or according to sample duration
                sample.cts = sample.dts = (aacFrames[i].cts ? aacFrames[i].cts : cts);
                sample.size = aacFrames[i].length;
                sample.duration = duration;
                sample.flags = 0x01000000; // sample_depends_on = 1, other flags = 0
                aacSamples.push(sample);

                // Update cts for next frame
                cts = sample.cts + duration;

                // Update previous sample duration in case of missing frames
                if (i > 0) {
                    aacSamples[i - 1].duration = aacSamples[i].cts - aacSamples[i - 1].cts;
                    if (aacSamples[i - 1].duration > duration) {
                        this.debug.log("[HlsDemux][" + track.type + "] Patch sample duration, cts = " + (aacSamples[i - 1].cts / 90000).toFixed(3) + ", duration = " + (aacSamples[i - 1].duration / 90000).toFixed(3));
                    }
                }

                // Copy AAC frame data
                data.set(track.data.subarray(aacFrames[i].offset, aacFrames[i].offset + aacFrames[i].length), offset);
                offset += aacFrames[i].length;
            }

            // Replace track data
            track.data = data;

            // Replace track's AAC-ADTS samples by demultiplexed AAC samples
            track.samples = aacSamples;
        },

        arrayToHexString = function(array) {
            var str = "",
                i = 0,
                h = 0;

            for (i = 0; i < array.length; i++) {
                h = array[i].toString(16);
                if (h.length < 2) {
                    h = "0" + h;
                }
                str += h;
            }
            return str;
        },

        doInit = function(startTime) {
            //pat = null;
            //pmt = null;

            // Reset codecs info to force setting new codecs (quality switch)
            for (var i = 0; i < tracks.length; i++) {
                tracks[i].codecs = "";
            }

            if (dtsOffset === -1) {
                dtsOffset = startTime;
            }
        },

        getTrackCodecInfo = function(data, track) {
            var tsPacket,
                pesPacket,
                esBytes,
                sequenceHeader,
                nalHeader,
                codecPrivateData,
                objectType,
                samplingFrequencyIndex;

            if (track.codecs !== "") {
                return track;
            }

            // Get first TS packet containing start of a PES/sample
            tsPacket = getTsPacket.call(this, data, 0, track.pid, true);

            // We have no packet of track's PID , need some more packets to get track info
            if (tsPacket === null) {
                // We throw an error since the <video> element will raise a MEDIA_ERR_SRC_NOT_SUPPORTED error
                // when pushing the initialization segment
                throw {
                    name: MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR,
                    message: "No packets for track " + track.type
                };
            }

            // Get PES packet
            pesPacket = new mpegts.pes.PesPacket();
            pesPacket.parse(tsPacket.packet.getPayload());
            esBytes = pesPacket.getPayload();

            // H264
            if (track.streamType.search('H.264') !== -1) {
                sequenceHeader = mpegts.h264.getSequenceHeader(esBytes);

                while (sequenceHeader === null) {
                    tsPacket = getTsPacket.call(this, data, (tsPacket.offset + mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE), track.pid, false);
                    esBytes = _appendArray(esBytes, tsPacket.packet.getPayload());
                    sequenceHeader = mpegts.h264.getSequenceHeader(esBytes);
                }

                track.codecPrivateData = arrayToHexString(sequenceHeader.bytes);
                track.codecs = "avc1.";

                // Extract from the CodecPrivateData field the hexadecimal representation of the following
                // three bytes in the sequence parameter set NAL unit.
                // => Find the SPS nal header
                nalHeader = /00000001[0-9]7/.exec(track.codecPrivateData);
                if (nalHeader && nalHeader[0]) {
                    // => Take the 6 characters after the SPS nalHeader (if it exists)
                    track.codecs += track.codecPrivateData.substr(track.codecPrivateData.indexOf(nalHeader[0]) + 10, 6);
                }

                // Extract width and height from SPS
                track.width = sequenceHeader.width;
                track.height = sequenceHeader.height;
            }

            // AAC
            if (track.streamType.search('AAC') !== -1) {
                codecPrivateData = mpegts.aac.getAudioSpecificConfig(esBytes);
                objectType = (codecPrivateData[0] & 0xF8) >> 3;
                track.codecPrivateData = arrayToHexString(codecPrivateData);
                track.codecs = "mp4a.40." + objectType;

                samplingFrequencyIndex = (codecPrivateData[0] & 0x07) << 1 | (codecPrivateData[1] & 0x80) >> 7;
                track.samplingRate = mpegts.aac.SAMPLING_FREQUENCY[samplingFrequencyIndex];
                track.channels = (codecPrivateData[1] & 0x78) >> 3;
                track.bandwidth = 0;
                /* code for HE AAC v2 to be tested
                var arr16 = new Uint16Array(2);
                arr16[0] = (codecPrivateData[0] << 8) + codecPrivateData[1];
                arr16[1] = (codecPrivateData[2] << 8) + codecPrivateData[3];
                //convert decimal to hex value
                var codecPrivateDataHex = arr16[0].toString(16)+arr16[1].toString(16);
                track.codecPrivateData = codecPrivateDataHex.toUpperCase();*/
            }

            this.debug.log("[HlsDemux][" + track.type + "] track codecPrivateData = " + track.codecPrivateData);
            this.debug.log("[HlsDemux][" + track.type + "] track codecs = " + track.codecs);
        },

        doGetTracks = function(data) {
            var i = 0,
                trackIdCounter = 1; // start at 1;

            // Parse PSI (PAT, PMT) if not yet received
            if (pat === null) {
                pat = getPAT.call(this, data);
                if (pat === null) {
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR,
                        message: "Failed to demux, missing signalization (PAT)"
                    };
                }
            }

            if (pmt === null) {
                pmt = getPMT.call(this, data, pat.getPmtPid());
                if (pmt === null) {
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR,
                        message: "Failed to demux, missing signalization (PMT)"
                    };
                }
            }

            // Get track information and remove tracks for which we did not manage to get codec information (no packet ?!)
            for (i = tracks.length - 1; i >= 0; i--) {
                getTrackCodecInfo.call(this, data, tracks[i]);
                if (tracks[i].codecs === "") {
                    tracks.splice(i, 1);
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR,
                        message: "Failed to get codec information for track " + tracks[i].type
                    };
                }
            }

            // Set track id and map to to PID
            for (i = 0; i < tracks.length; i++) {
                tracks[i].trackId = trackIdCounter;
                pidToTrackId[tracks[i].pid] = trackIdCounter;
                trackIdCounter++;
            }

            return tracks;
        },

        doDemux = function(data) {
            var nbPackets = data.length / mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE,
                track,
                i = 0,
                firstDts = -1,
                offset;

            this.debug.log("[HlsDemux] Demux chunk, size = " + data.length + ", nb packets = " + nbPackets);

            // Get PAT, PMT and tracks information if not yet received
            doGetTracks.call(this, data);

            // Clear current tracks' data
            for (i = 0; i < tracks.length; i++) {
                track = tracks[i];

                // Store last sample timestamp and duration (in case of lost/missing samples)
                if (track.samples.length > 0) {
                    track.previousCts = track.samples[track.samples.length - 1].cts;
                    track.previousDuration = track.samples[track.samples.length - 1].duration;
                }

                tracks[i].samples = [];
                tracks[i].data = null;
            }

            // Parse and demux TS packets
            i = 0;
            while (i < data.length) {
                demuxTsPacket.call(this, data.subarray(i, i + mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE));
                i += mpegts.ts.TsPacket.prototype.TS_PACKET_SIZE;
            }

            // Re-assemble samples from sub-samples
            //this.debug.log("[HlsDemux] Demux: baseDts = " + baseDts + ", dtsOffset = " + dtsOffset);
            for (i = 0; i < tracks.length; i++) {
                track = tracks[i];
                postProcess.call(this, track);

                this.debug.log("[HlsDemux][" + track.type + "] Demux: 1st PTS = " + track.samples[0].dts + " (" + (track.samples[0].dts / 90000) + ")");

                // Check tracks desynchronization (if > 10 sec)
                firstDts = Math.max(firstDts, track.samples[0].dts);
                offset = Math.abs(track.samples[0].dts - firstDts) / 90000;
                if (offset > 10) {
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.HLS_DEMUX_ERROR,
                        message: "A/V desynchronization (" + Math.round(offset) + " s.)"
                    };
                }
            }

            return tracks;
        };

    return {
        debug: undefined,
        reset: doInit,
        getTracks: doGetTracks,
        demux: doDemux
    };
};

Hls.dependencies.HlsDemux.prototype = {
    constructor: Hls.dependencies.HlsDemux
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Hls.dependencies.HlsFragmentController = function() {
    "use strict";
    var lastRequestQuality = null;

    var generateInitSegment = function(data) {
            var i = 0,
                manifest = rslt.manifestModel.getValue(),
                // Process the HLS chunk to get media tracks description
                tracks = rslt.hlsDemux.getTracks(new Uint8Array(data));

            // Add track duration
            for (i = 0; i < tracks.length; i += 1) {
                tracks[i].duration = manifest.mediaPresentationDuration;
            }
            // Generate init segment (moov)
            return rslt.mp4Processor.generateInitSegment(tracks);
        },

        generateMediaSegment = function(data) {
            // Process the HLS chunk to get media tracks description
            //var tracks = rslt.hlsDemux.getTracks(new Uint8Array(data));
            var i = 0,
                tracks = rslt.hlsDemux.demux(new Uint8Array(data));

            for (i = 0; i < tracks.length; i += 1) {
                if (tracks[i].type === "video") {
                    rslt.startTime = tracks[i].samples[0].cts / tracks[i].timescale;
                }
            }
            // Generate media segment (moov)
            return rslt.mp4Processor.generateMediaSegment(tracks, rslt.sequenceNumber);
        };

    var rslt = MediaPlayer.utils.copyMethods(MediaPlayer.dependencies.FragmentController);

    rslt.manifestModel = undefined;
    rslt.hlsDemux = undefined;
    rslt.mp4Processor = undefined;

    rslt.sequenceNumber = 1;

    rslt.segmentStartTime = null;

    rslt.process = function(bytes, request, representations) {
        var result = null,
            InitSegmentData = null,
            catArray = null;

        if ((bytes === null) || (bytes === undefined) || (bytes.byteLength === 0)) {
            return bytes;
        }

        try {
            // Media segment => generate corresponding moof data segment from demultiplexed MPEG2-TS chunk
            if (request && (request.type === "Media Segment") && representations && (representations.length > 0)) {
                if (lastRequestQuality === null || lastRequestQuality !== request.quality) {
                    // If quality changed then generate initialization segment
                    rslt.hlsDemux.reset(request.startTime * 90000);
                    InitSegmentData = generateInitSegment(bytes);
                    request.index = undefined;
                    lastRequestQuality = request.quality;
                }

                // Generate media segment (moof)
                result = generateMediaSegment(bytes);

                // Iinsert initialization if required
                if (InitSegmentData !== null) {
                    catArray = new Uint8Array(InitSegmentData.length + result.length);
                    catArray.set(InitSegmentData, 0);
                    catArray.set(result, InitSegmentData.length);
                    result = catArray;
                }

                rslt.sequenceNumber++;
            }
            return result;
        } catch (e) {
            return e;
        }

        return result;
    };

    rslt.getStartTime = function() {
        return rslt.startTime;
    };

    return rslt;
};

Hls.dependencies.HlsFragmentController.prototype = {
    constructor: Hls.dependencies.HlsFragmentController
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Hls.dependencies.HlsHandler = function() {
    "use strict";
    var getInit = function(representation) {
        var period = null,
            self = this,
            presentationStartTime = null,
            deferred = Q.defer(),
            manifest,
            isDynamic,
            request;

        //Mss.dependencies.MssHandler.prototype.getInitRequest.call(this,quality,data).then(onGetInitRequestSuccess);
        // get the period and startTime
        period = representation.adaptation.period;
        presentationStartTime = period.start;

        manifest = rslt.manifestModel.getValue();
        isDynamic = rslt.manifestExt.getIsDynamic(manifest);

        request = new MediaPlayer.vo.SegmentRequest();

        request.streamType = rslt.getType();
        request.type = "Initialization Segment";
        request.url = null;
        request.data = 1; //used to activate Loaded event in BufferControler
        request.range = representation.range;
        request.availabilityStartTime = self.timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime, representation.adaptation.period.mpd, isDynamic);
        request.availabilityEndTime = self.timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration, period.mpd, isDynamic);

        request.quality = representation.index;
        deferred.resolve(request);
        return deferred.promise;
    };

    var rslt = MediaPlayer.utils.copyMethods(Dash.dependencies.DashHandler);

    rslt.getInitRequest = getInit;

    return rslt;
};

Hls.dependencies.HlsHandler.prototype = {
    constructor: Hls.dependencies.HlsHandler
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Hls.dependencies.HlsParser = function() {
    var TAG_EXTM3U = "#EXTM3U",
        /*TAG_EXTXMEDIASEQUENCE = "#EXT-X-MEDIA-SEQUENCE",
        TAG_EXTXKEY = "#EXT-X-KEY",
        TAG_EXTXPROGRAMDATETIME = "#EXT-X-PROGRAM_DATE_TIME",
        TAG_EXTXDISCONTINUITY = "#EXT-X-DISCONTINUITY",
        TAG_EXTXALLOWCACHE = "#EXT-X-ALLOW-CACHE",*/
        TAG_EXTINF = "#EXTINF",
        TAG_EXTXVERSION = "#EXT-X-VERSION",
        TAG_EXTXTARGETDURATION = "#EXT-X-TARGETDURATION",
        //TAG_EXTXMEDIA = "#EXT-X-MEDIA",
        TAG_EXTXMEDIASEQUENCE = "#EXT-X-MEDIA-SEQUENCE",
        TAG_EXTXSTREAMINF = "#EXT-X-STREAM-INF",
        TAG_EXTXENDLIST = "#EXT-X-ENDLIST",
        ATTR_BANDWIDTH = "BANDWIDTH",
        ATTR_PROGRAMID = "PROGRAM-ID",
        ATTR_AUDIO = "AUDIO",
        ATTR_SUBTITLES = "SUBTITLES",
        ATTR_RESOLUTION = "RESOLUTION",
        ATTR_CODECS = "CODECS",
        /*ATTR_METHOD = "METHOD",
        ATTR_IV = "IV",
        ATTR_URI = "URI",
        ATTR_TYPE = "TYPE",
        ATTR_GROUPID = "GROUP-ID",
        ATTR_NAME = "NAME",
        ATTR_DEFAULT = "DEFAULT",
        ATTR_AUTOSELECT = "AUTOSELECT",
        ATTR_LANGUAGE = "LANGUAGE",
        VAL_YES = "YES";*/
        DEFAULT_RETRY_ATTEMPTS = 2,
        DEFAULT_RETRY_INTERVAL = 500,
        retryAttempts = DEFAULT_RETRY_ATTEMPTS,
        retryInterval = DEFAULT_RETRY_INTERVAL,
        retryCount = 0,
        retryTimeout = null,
        deferredPlaylist = null;


    var playlistRequest = new XMLHttpRequest();

    var _splitLines = function(oData) {
        var i = 0;
        oData = oData.split('\n');
        //remove empty lines
        for (i = 0; i < oData.length; i += 1) {
            if (oData[i] === "" || oData[i] === " ") {
                oData.splice(i, 1);
                i--;
            }
        }
        return oData;
    };

    /*var _getAttrValue = function(data, attrKey) {
        // remove attrKey + '='
        var value = data.substring(data.indexOf(attrKey)+attrKey.length+1);
        // remove quottes
        if (value.charAt(0) == '"') {
            value = value.substring(1,value.length-1);
        }
        return value;
    };*/

    var _containsTag = function(data, tag) {
        return (data.indexOf(tag) > -1);
    };

    var _getTagValue = function(data, tag) {
        // +1 to remove ':' character
        return data.substring(tag.length + 1, data.length);
    };

    var _getTagParams = function(data) {
        return data.substring(data.indexOf(':') + 1).split(',');
    };

    var _isAbsoluteURI = function(uri) {
        return (uri.indexOf("http://") === 0) ||
            (uri.indexOf("https://") === 0);
    };

    var _parseStreamInf = function(streamInfArray) {
        var stream = {
                programId: "",
                bandwidth: 0,
                resolution: "0x0",
                codecs: ""
            },
            name = "",
            value = "",
            i,
            //streamParams = _getTagValue(streamInfArray[0], TAG_EXTXSTREAMINF).split(',');
            streamParams = _getTagParams(streamInfArray[0]);

        for (i = streamParams.length - 1; i >= 0; i -= 1) {

            // Check if '=' character is present. If not, it means that there was
            // a ',' in the parameter value
            if ((streamParams[i].indexOf('=') === -1) && (i > 0)) {
                streamParams[i - 1] += "," + streamParams[i];
            } else {
                name = streamParams[i].trim().split('=')[0];
                value = streamParams[i].trim().split('=')[1];

                switch (name) {
                    case ATTR_PROGRAMID:
                        stream.programId = value;
                        break;
                    case ATTR_BANDWIDTH:
                        stream.bandwidth = parseInt(value, 10);
                        break;
                    case ATTR_RESOLUTION:
                        stream.resolution = value;
                        break;
                    case ATTR_CODECS:
                        stream.codecs = value.replace(/"/g, ''); // Remove '"' characters

                        // PATCH to remove audio track
                        // var codecs = stream.codecs.split(',');
                        // for (var c = 0; c < codecs.length; c++) {
                        //     if (codecs[c].indexOf("avc") !== -1) {
                        //         stream.codecs = codecs[c];
                        //     }
                        // }
                        break;

                        // > HLD v3
                    case ATTR_AUDIO:
                        stream.audioId = value;
                        break;
                    case ATTR_SUBTITLES:
                        stream.subtitlesId = value;
                        break;

                    default:
                        break;

                }
            }
        }

        // Get variant stream URI
        stream.uri = streamInfArray[1];

        return stream;
    };

    // Parse #EXTINF tag
    //  #EXTINF:<duration>,<title>
    //  <url>
    var _parseExtInf = function(extInf) {
        var media = {},
            //mediaParams = _getTagValue(extInf[0], TAG_EXTINF).split(',');
            mediaParams = _getTagParams(extInf[0]);

        media.duration = parseInt(mediaParams[0], 10);
        media.title = mediaParams[1];
        media.uri = extInf[1];

        return media;
    };

    /* > HLS v3
    var _parseMediaInf = function(mediaLine) {
        var mediaObj = {};
        var infos = mediaLine.split(',');
        for (var i = infos.length - 1; i >= 0; i--) {
            if(infos[i].indexOf(ATTR_TYPE)>-1) {
                mediaObj.type = _getAttrValue(infos[i],ATTR_TYPE);
            } else if(infos[i].indexOf(ATTR_GROUPID)>-1) {
                mediaObj.groupId = _getAttrValue(infos[i],ATTR_GROUPID);
            } else if(infos[i].indexOf(ATTR_NAME)>-1) {
                mediaObj.name = _getAttrValue(infos[i],ATTR_NAME);
            } else if(infos[i].indexOf(ATTR_DEFAULT)>-1) {
                mediaObj.default = _getAttrValue(infos[i],ATTR_DEFAULT) == VAL_YES ? true : false;
            } else if(infos[i].indexOf(ATTR_AUTOSELECT)>-1) {
                mediaObj.autoSelect = _getAttrValue(infos[i],ATTR_AUTOSELECT) == VAL_YES ? true : false;
            } else if(infos[i].indexOf(ATTR_LANGUAGE)>-1) {
                mediaObj.language = _getAttrValue(infos[i],ATTR_LANGUAGE);
            } else if(infos[i].indexOf(ATTR_URI)>-1) {
                mediaObj.uri = _getAttrValue(infos[i],ATTR_URI);
            }
        }
        return mediaObj;
    };*/

    var _getVariantStreams = function(data) {
        var streamsArray = [],
            i = 0;

        for (i = 0; i < data.length; i += 1) {

            if (_containsTag(data[i], TAG_EXTXSTREAMINF)) {
                streamsArray.push(_parseStreamInf([data[i], data[i + 1]]));
            }
        }
        return streamsArray;
    };

    var _parsePlaylist = function(data, representation) {
        var segmentList,
            segments,
            segment,
            initialization,
            version,
            duration = 0,
            index = 0,
            media,
            i,
            self = this;

        // Check playlist header
        if (!data || (data && data.length < 0)) {
            return false;
        }

        self.debug.log(data);

        data = _splitLines(data);

        if (data[0].trim() !== TAG_EXTM3U) {
            return false;
        }

        // Intitilaize SegmentList
        segmentList = {
            name: "SegmentList",
            isRoot: false,
            isArray: false,
            // children: [],
            duration: 0,
            startNumber: 0,
            timescale: 1,
            BaseURL: representation.BaseURL,
            SegmentURL_asArray: []
        };
        representation[segmentList.name] = segmentList;

        segments = segmentList.SegmentURL_asArray;

        // Set representation duration, by default set to  (="dynamic")
        representation.duration = Infinity;

        // Parse playlist
        for (i = 1; i < data.length; i++) {
            if (_containsTag(data[i], TAG_EXTXVERSION)) {
                version = _getTagValue(data[i], TAG_EXTXVERSION);
            } else if (_containsTag(data[i], TAG_EXTXTARGETDURATION)) {
                segmentList.duration = parseInt(_getTagValue(data[i], TAG_EXTXTARGETDURATION), 10);
            } else if (_containsTag(data[i], TAG_EXTXMEDIASEQUENCE)) {
                segmentList.startNumber = parseInt(_getTagValue(data[i], TAG_EXTXMEDIASEQUENCE), 10);
            } else if (_containsTag(data[i], TAG_EXTINF)) {
                media = _parseExtInf([data[i], data[i + 1]]);
                segment = {
                    name: "SegmentURL",
                    isRoot: false,
                    isArray: true,
                    //parent: segmentList,
                    // children: [],
                    media: _isAbsoluteURI(media.uri) ? media.uri : (segmentList.BaseURL + media.uri),
                    sequenceNumber: segmentList.startNumber + index,
                    time: (segments.length === 0) ? 0 : segments[segments.length - 1].time + segments[segments.length - 1].duration,
                    duration: media.duration
                };

                segments.push(segment);
                duration += media.duration;

                index++;

            } else if (_containsTag(data[i], TAG_EXTXENDLIST)) {
                // "static" playlist => set representation duration
                representation.duration = duration;
            }
        }

        // Set initialization segment info
        initialization = {
            name: "Initialization",
            sourceURL: representation.SegmentList.SegmentURL_asArray[0].media
        };
        representation.SegmentList.Initialization = initialization;

        // PATCH Live = VOD
        //representation.duration = duration;

        return true;
    };

    /*var mergeSegmentLists = function(_representation, representation) {

        var _segmentList = _representation.SegmentList,
            segmentList = representation.SegmentList,
            _segments = _segmentList.SegmentURL_asArray,
            segments = segmentList.SegmentURL_asArray,
            _length = _segments.length,
            length = segments.length,
            segment,
            _lastSegment = _segments[_length - 1],
            i = 0;

        for (i = 0; i < length; i++) {
            segment = segments[i];
            if (segment.sequenceNumber > _lastSegment.sequenceNumber) {
                segment.time = _lastSegment.time + _lastSegment.duration;
                _segments.push(segment);
                _lastSegment = _segments[_length - 1];
            }
        }

        representation.SegmentList = _segmentList;

    };*/

    var postProcess = function(manifest, quality) {
        var deferred = Q.defer(),
            period = manifest.Period_asArray[0],
            adaptationSet = period.AdaptationSet_asArray[0],
            representation = adaptationSet.Representation_asArray[quality],
            //startNumber = -1,
            //i,
            //valid,
            //initialization,
            request = new MediaPlayer.vo.SegmentRequest(),
            //_manifest = this.manifestModel.getValue(),
            self = this,
            manifestDuration,
            mpdLoadedTime;


        period.start = 0; //segmentTimes[adaptationSet.Representation_asArray[0].SegmentList.startNumber];

        // Copy duration from first representation's duration
        adaptationSet.duration = representation.duration;
        period.duration = representation.duration;

        if (representation.duration !== Infinity) {
            manifest.mediaPresentationDuration = representation.duration;
        }

        // Set manifest type, "static" vs "dynamic"
        manifest.type = (representation.duration === Infinity) ? "dynamic" : "static";

        manifestDuration = representation.SegmentList.duration * representation.SegmentList.SegmentURL_asArray.length;

        // Dynamic use case
        if (manifest.type === "dynamic") {
            // => set manifest refresh period as the duration of 1 fragment/chunk
            //manifest.minimumUpdatePeriod = representation.SegmentList.duration;

            // => set availabilityStartTime property
            mpdLoadedTime = new Date();
            manifest.availabilityStartTime = new Date(mpdLoadedTime.getTime() - (manifestDuration * 1000));

            // => set timeshift buffer depth
            manifest.timeShiftBufferDepth = manifestDuration;
        }

        // Set minBufferTime
        manifest.minBufferTime = representation.SegmentList.duration * 3; //MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME

        // Filter invalid representations
        /*for (i = 0; i < adaptationSet.Representation_asArray.length; i++) {
            representation = adaptationSet.Representation_asArray[i];

            valid = true;

            // Check if segment list is valid
            valid = valid & (representation.SegmentList.SegmentURL_asArray.length > 0);

            // Check if representation (bandwidth) is not already defined
            if (i > 0) {
                valid = valid & (adaptationSet.Representation_asArray[i-1].bandwidth !== adaptationSet.Representation_asArray[i].bandwidth);
            }

            if (valid) {
                // Set initialization segment info
                initialization = {
                    name: "Initialization",
                    sourceURL: representation.SegmentList.SegmentURL_asArray[0].media
                };
                representation.SegmentList.Initialization = initialization;

                // And get highest start sequence number among all representations
                if (representation.SegmentList.startNumber > startNumber) {
                    startNumber = representation.SegmentList.startNumber;
                }
            } else {
                adaptationSet.Representation_asArray.splice(i, 1);
                i--;
            }
        }*/

        /*if (manifest.type === "dynamic") {

            if ((_manifest === undefined) || (_manifest === null)) {
                // At first manifest download, align segment lists according to sequence number
                for (i = 0; i < adaptationSet.Representation_asArray.length; i++) {
                    var itemsToRemove = startNumber - representation.SegmentList.SegmentURL_asArray[0].sequenceNumber;
                    if (itemsToRemove > 0) {
                        representation.SegmentList.SegmentURL_asArray.splice(0, itemsToRemove);
                    }
                }
            } else {
                // Merge segments lists of all representation to get whole timeline
                // in order to enable DashHandler generic operating
                var _period = _manifest.Period_asArray[0],
                    _adaptationSet = _period.AdaptationSet_asArray[0],
                    _representation;

                manifest.availabilityStartTime = _manifest.availabilityStartTime;

                for (i = 0; i < adaptationSet.Representation_asArray.length; i++) {
                    representation = adaptationSet.Representation_asArray[i];
                    _representation = _adaptationSet.Representation_asArray[i];
                    mergeSegmentLists(_representation, representation);
                }
            }
        }*/

        // Download initialization data (PSI, IDR...) of 1st representation to obtain codec information
        representation = adaptationSet.Representation_asArray[quality];
        request.type = "Initialization Segment";
        request.url = representation.SegmentList.Initialization.sourceURL;
        //request.range = "0-18799";

        var onLoaded = function(representation, response) {

            // Parse initialization data to obtain codec information
            var tracks = this.hlsDemux.getTracks(new Uint8Array(response.data)),
                i = 0;

            representation.codecs = "";
            for (i = 0; i < tracks.length; i++) {
                representation.codecs += tracks[i].codecs;
                if (i < (tracks.length - 1)) {
                    representation.codecs += ",";
                }
            }

            deferred.resolve();
        };

        var onError = function() {
            // ERROR
            deferred.resolve();
        };

        if (representation.codecs === "") {
            self.debug.log("[HlsParser]", "Load initialization segment: " + request.url);
            self.fragmentLoader.load(request).then(onLoaded.bind(self, representation), onError.bind(self));
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    };

    var parseBaseUrl = function(url) {
        var base = null;

        if (url.indexOf("/") !== -1) {
            if (url.indexOf("?") !== -1) {
                url = url.substring(0, url.indexOf("?"));
            }
            base = url.substring(0, url.lastIndexOf("/") + 1);
        }

        return base;
    };


    var doUpdatePlaylist = function(representation) {
        var error = true,
            self = this;

        retryTimeout = null;

        var onabort = function() {
            playlistRequest.aborted = true;
        };

        var onload = function() {
            if (playlistRequest.status < 200 || playlistRequest.status > 299) {
                return;
            }

            if (playlistRequest.status === 200 && playlistRequest.readyState === 4) {
                error = false;
                if (_parsePlaylist.call(self, playlistRequest.response, representation)) {
                    deferredPlaylist.resolve();
                } else {
                    deferredPlaylist.reject({
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.MANIFEST_ERR_PARSE,
                        message: "Failed to parse variant stream playlist",
                        data: {
                            url: representation.url
                        }
                    });
                }
            }
        };

        var onreport = function() {

            if (playlistRequest.aborted) {
                deferredPlaylist.reject();
                return;
            }

            if (!error) {
                deferredPlaylist.resolve();
                return;
            }

            retryCount++;
            if (retryAttempts > 0 && retryCount <= retryAttempts) {
                retryTimeout = setTimeout(function() {
                    doUpdatePlaylist.call(self, representation);
                }, retryInterval);
            } else {
                deferredPlaylist.reject({
                    name: MediaPlayer.dependencies.ErrorHandler.prototype.DOWNLOAD_ERR_MANIFEST,
                    message: "Failed to download variant stream playlist",
                    data: {
                        url: representation.url,
                        status: playlistRequest.status
                    }
                });
            }
        };

        try {
            self.debug.log("[HlsParser]", "Load playlist manifest: " + representation.url);
            playlistRequest = new XMLHttpRequest();
            playlistRequest.onload = onload;
            playlistRequest.onloadend = onreport;
            playlistRequest.onerror = onreport;
            playlistRequest.onabort = onabort;
            // var req_ = new XMLHttpRequest();
            // req_.open("GET", '/signedUrl?src_='+representation.url, false);
            // req_.send(null);
            // var url_ = req_.responseText;

            // playlistRequest.open("GET", url_, true);
            var url = representation.url;
            //console.log("onreport");
            
            //console.log(playlistRequest);

            playlistRequest.open("GET", '/get_video_content?video_url='+url,true);

            var value ="XMLHttpPlayerRequest";
            //console.log(value);
            playlistRequest.setRequestHeader("X-Requested-With", value);


            //console.log('playlisto de requesto');
            playlistRequest.withCredentials = true;
            // $.cookie('CloudFront-Key-Pair-Id', $.cookie('Key-Pair-Id'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', $.cookie('Policy'), {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', $.cookie('Signature'), {domain: 'shopistan.pk'});
            playlistRequest.send(null);
            // $.cookie('CloudFront-Key-Pair-Id', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Policy', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // $.cookie('CloudFront-Signature', 'Fuck you IDM', {domain: 'shopistan.pk'});
            // //console.log($.cookie('CloudFront-Signature'));

        } catch (e) {
            playlistRequest.onerror();
        }
    };

    var processManifest = function(data, baseUrl) {
        var deferred = Q.defer(),
            mpd,
            period,
            adaptationsSets = [],
            adaptationSet,
            representations = [],
            representation,
            representationId = 0,
            streams = [],
            stream,
            result,
            //requestsToDo = [],
            self = this,
            i = 0;

        if (!data || data.length <= 0 || data[0].trim() !== TAG_EXTM3U) {
            this.debug.error("[HlsParser] no stream in HLS manifest");
            deferred.reject();
            return deferred.promise;
        }

        // MPD
        mpd = {};
        mpd.name = "M3U";
        mpd.isRoot = true;
        mpd.isArray = true;
        mpd.parent = null;
        // mpd.children = [];
        mpd.BaseURL = baseUrl;

        mpd.profiles = "urn:mpeg:dash:profile:isoff-live:2011";
        mpd.type = "static"; // Updated in postProcess()

        // PERIOD
        period = {};
        period.name = "Period";
        period.isRoot = false;
        period.isArray = false;
        period.parent = mpd;
        period.duration = 0; // To be set at variant playlist parsing
        period.BaseURL = mpd.BaseURL;

        mpd.Period = period;
        mpd.Period_asArray = [period];

        // ADAPTATION SET
        adaptationsSets = [];
        period.AdaptationSet = adaptationsSets;
        period.AdaptationSet_asArray = adaptationsSets;

        // Get variant streams
        streams = _getVariantStreams(data.slice(1));

        // Sort streams by bandwidth
        streams.sort(function(a, b) {
            return a.bandwidth - b.bandwidth;
        });

        // Only one adaptationSet (HLS v3)
        adaptationSet = {
            name: "AdaptationSet",
            isRoot: false,
            isArray: true,
            //parent: period,
            // children: [],
            id: "video",
            lang: "",
            contentType: "video",
            mimeType: "video/mp4",
            maxWidth: 0,
            maxHeight: 0,
            BaseURL: period.BaseURL,
            Representation: representations,
            Representation_asArray: representations
        };

        // Create representations
        for (i = 0; i < streams.length; i += 1) {
            // Do not consider representation with bandwidth <= 64K which corresponds to audio only variant stream
            stream = streams[i];
            if (stream.bandwidth > 64000) {
                representation = {
                    name: "Representation",
                    isRoot: false,
                    isArray: true,
                    //parent: streamAdaptationSet,
                    // children: [],
                    id: representationId.toString(),
                    mimeType: "video/mp4",
                    codecs: stream.codecs,
                    bandwidth: stream.bandwidth,
                    width: parseInt(stream.resolution.split('x')[0], 10),
                    height: parseInt(stream.resolution.split('x')[1], 10),
                    url: _isAbsoluteURI(stream.uri) ? stream.uri : (adaptationSet.BaseURL + stream.uri)
                };
                representation.BaseURL = parseBaseUrl(representation.url);
                representations.push(representation);
                representationId++;
                //requestsToDo.push({"url": representation.url, "parent": representation});
            }
        }

        if (streams.length === 0) {
            this.debug.error("[HlsParser] no stream in HLS manifest");
            deferred.reject();
            return deferred.promise;
        }

        adaptationsSets.push(adaptationSet);

        // alternative renditions of the same content (alternative audio tarcks or subtitles) #EXT-X-MEDIA
        // HLS > v3
        /*if(medias) {
            for (var j = medias.length - 1; j >= 0; j--) {
                var mediaAdaptationSet = {
                    name: "AdaptationSet",
                    isRoot: false,
                    isArray: true,
                    //parent: period,
                    // children: [],
                    id: medias[j].name,
                    lang: medias[j].language,
                    contentType: medias[j].type.toLowerCase(),
                    mimeType: "video/MP2T",
                    maxWidth: "",//FIXME
                    maxHeight: "",//FIXME
                    groupId: medias[j].groupId,
                    default: medias[j].default,
                    autoSelect: medias[j].autoSelect,
                    BaseURL: period.BaseURL
                };
                var mediaRepresentation = {
                    name: "mediaRepresentation",
                    isRoot: false,
                    isArray: true,
                    //parent: mediaAdaptationSet,
                    // children: [],
                    id: 0,
                    bandwidth: "",
                    width: "",
                    height: "",
                    codecs: "",
                    BaseURL: mediaAdaptationSet.BaseURL,
                    url: medias[j].uri.indexOf("http://") !== 1 ? medias[j].uri : (mediaAdaptationSet.BaseURL + medias[j].uri)
                };

                requestsToDo.push({"url": mediaRepresentation.url, "parent": mediaRepresentation});

                mediaAdaptationSet.Representation = mediaRepresentation;
                mediaAdaptationSet.Representation_asArray = [mediaRepresentation];
                adaptationsSet.push(mediaAdaptationSet);
            }
        }*/

        // Get representation (variant stream) playlist
        result = this.abrController.getPlaybackQuality("video", adaptationSet);
        representation = adaptationSet.Representation_asArray[result.quality];
        self.updatePlaylist(representation).then(
            function() {
                postProcess.call(self, mpd, result.quality).then(function() {
                    deferred.resolve(mpd);
                });
            },
            function(error) {
                // error undefined in case of playlist download aborted
                if (error) {
                    // Variant stream playlist download error
                    deferred.reject(error);
                } else {
                    // Variant stream playlist download aborted
                    deferred.resolve(null);
                }
            }
        );

        return deferred.promise;
    };

    var internalParse = function(data, baseUrl) {
        this.debug.log("[HlsParser]", "Doing parse.");
        this.debug.log("[HlsParser]", data);
        return processManifest.call(this, _splitLines(data), baseUrl);
    };

    var abort = function() {
        if (playlistRequest !== null && playlistRequest.readyState > 0 && playlistRequest.readyState < 4) {
            this.debug.log("[HlsParser] Playlist manifest download abort.");
            playlistRequest.abort();
        } else if (retryTimeout) {
            clearTimeout(retryTimeout);
            retryTimeout = null;
            deferredPlaylist.reject();
        }
    };

    return {
        debug: undefined,
        config: undefined,
        manifestModel: undefined,
        fragmentLoader: undefined,
        abrController: undefined,
        hlsDemux: undefined,

        parse: internalParse,

        updatePlaylist: function(representation) {
            retryAttempts = this.config.getParam("ManifestLoader.RetryAttempts", "number", DEFAULT_RETRY_ATTEMPTS);
            retryInterval = this.config.getParam("ManifestLoader.RetryInterval", "number", DEFAULT_RETRY_INTERVAL);
            retryCount = 0;
            deferredPlaylist = Q.defer();
            doUpdatePlaylist.call(this, representation);
            return deferredPlaylist.promise;
        },

        abort: abort
    };
};

Hls.dependencies.HlsParser.prototype = {
    constructor: Hls.dependencies.HlsParser
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
 /*jshint -W020 */
Mss = (function () {
    "use strict";

    return {
        dependencies: {}
    };
}());
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Mss.dependencies.MssParser = function() {
    "use strict";

    var TIME_SCALE_100_NANOSECOND_UNIT = 10000000.0,
        samplingFrequencyIndex = {
            96000: 0x0,
            88200: 0x1,
            64000: 0x2,
            48000: 0x3,
            44100: 0x4,
            32000: 0x5,
            24000: 0x6,
            22050: 0x7,
            16000: 0x8,
            12000: 0x9,
            11025: 0xA,
            8000: 0xB,
            7350: 0xC
        },
        mimeTypeMap = {
            "video": "video/mp4",
            "audio": "audio/mp4",
            "text": "application/ttml+xml+mp4"
        },
        xmlDoc = null,
        baseURL = null,

        mapPeriod = function(minBufferTime) {
            var period = {},
                adaptations = [],
                adaptation,
                smoothNode = this.domParser.getChildNode(xmlDoc, "SmoothStreamingMedia"),
                i;

            period.duration = (parseFloat(this.domParser.getAttributeValue(smoothNode, 'Duration')) === 0) ? Infinity : parseFloat(this.domParser.getAttributeValue(smoothNode, 'Duration')) / TIME_SCALE_100_NANOSECOND_UNIT;
            period.BaseURL = baseURL;

            // For each StreamIndex node, create an AdaptationSet element
            for (i = 0; i < smoothNode.childNodes.length; i++) {
                if (smoothNode.childNodes[i].nodeName === "StreamIndex") {
                    adaptation = mapAdaptationSet.call(this, smoothNode.childNodes[i], minBufferTime);
                    if (adaptation !== null) {
                        adaptations.push(adaptation);
                    }
                }
            }

            if (adaptations.length > 0) {
                period.AdaptationSet = (adaptations.length > 1) ? adaptations : adaptations[0];
            }
            period.AdaptationSet_asArray = adaptations;

            return period;
        },

        mapAdaptationSet = function(streamIndex, minBufferTime) {

            var adaptationSet = {},
                representations = [],
                representation,
                segmentTemplate = {},
                segments,
                qualityLevels = null,
                range,
                i;

            adaptationSet.id = this.domParser.getAttributeValue(streamIndex, "Name");
            adaptationSet.lang = this.domParser.getAttributeValue(streamIndex, "Language");
            adaptationSet.contentType = this.domParser.getAttributeValue(streamIndex, "Type");
            adaptationSet.mimeType = mimeTypeMap[adaptationSet.contentType];
            adaptationSet.maxWidth = this.domParser.getAttributeValue(streamIndex, "MaxWidth");
            adaptationSet.maxHeight = this.domParser.getAttributeValue(streamIndex, "MaxHeight");
            adaptationSet.BaseURL = baseURL;

            // Create a SegmentTemplate with a SegmentTimeline
            segmentTemplate = mapSegmentTemplate.call(this, streamIndex);

            qualityLevels = this.domParser.getChildNodes(streamIndex, "QualityLevel");
            // For each QualityLevel node, create a Representation element
            for (i = 0; i < qualityLevels.length; i++) {
                // Propagate BaseURL and mimeType
                qualityLevels[i].BaseURL = adaptationSet.BaseURL;
                qualityLevels[i].mimeType = adaptationSet.mimeType;

                // Set quality level id
                qualityLevels[i].Id = adaptationSet.id + "_" + this.domParser.getAttributeValue(qualityLevels[i], "Index");

                // Map Representation to QualityLevel
                representation = mapRepresentation.call(this, qualityLevels[i], streamIndex);

                if (representation !== null) {
                    // Copy SegmentTemplate into Representation
                    representation.SegmentTemplate = segmentTemplate;

                    representations.push(representation);
                }
            }

            if (representations.length === 0) {
                return null;
            }

            adaptationSet.Representation = (representations.length > 1) ? representations : representations[0];
            adaptationSet.Representation_asArray = representations;

            // Set SegmentTemplate
            adaptationSet.SegmentTemplate = segmentTemplate;

            segments = segmentTemplate.SegmentTimeline.S_asArray;

            range = {
                start: segments[0].t / segmentTemplate.timescale,
                end: (segments[segments.length - 1].t + segments[segments.length - 1].d)  / segmentTemplate.timescale
            };

            this.metricsModel.addDVRInfo(adaptationSet.contentType, new Date(), range);

            return adaptationSet;
        },

        mapRepresentation = function(qualityLevel, streamIndex) {

            var representation = {},
                fourCCValue = null;

            representation.id = qualityLevel.Id;
            representation.bandwidth = parseInt(this.domParser.getAttributeValue(qualityLevel, "Bitrate"), 10);
            representation.mimeType = qualityLevel.mimeType;
            representation.width = parseInt(this.domParser.getAttributeValue(qualityLevel, "MaxWidth"), 10);
            representation.height = parseInt(this.domParser.getAttributeValue(qualityLevel, "MaxHeight"), 10);

            fourCCValue = this.domParser.getAttributeValue(qualityLevel, "FourCC");

            // If FourCC not defined at QualityLevel level, then get it from StreamIndex level
            if (fourCCValue === null) {
                fourCCValue = this.domParser.getAttributeValue(streamIndex, "FourCC");
            }

            // If still not defined (optionnal for audio stream, see https://msdn.microsoft.com/en-us/library/ff728116%28v=vs.95%29.aspx),
            // then we consider the stream is an audio AAC stream
            if (fourCCValue === null) {
                fourCCValue = "AAC";
            }

            // Do not support AACH (TODO)
            if (fourCCValue.indexOf("AACH") >= 0) {
                return null;
            }

            // Get codecs value according to FourCC field
            if (fourCCValue === "H264" || fourCCValue === "AVC1") {
                representation.codecs = getH264Codec.call(this, qualityLevel);
            } else if (fourCCValue.indexOf("AAC") >= 0) {
                representation.codecs = getAACCodec.call(this, qualityLevel, fourCCValue);
                representation.audioSamplingRate = parseInt(this.domParser.getAttributeValue(qualityLevel, "SamplingRate"), 10);
                representation.audioChannels = parseInt(this.domParser.getAttributeValue(qualityLevel, "Channels"), 10);
            }

            representation.codecPrivateData = "" + this.domParser.getAttributeValue(qualityLevel, "CodecPrivateData");
            representation.BaseURL = qualityLevel.BaseURL;

            return representation;
        },

        getH264Codec = function(qualityLevel) {
            var codecPrivateData = this.domParser.getAttributeValue(qualityLevel, "CodecPrivateData").toString(),
                nalHeader,
                avcoti;


            // Extract from the CodecPrivateData field the hexadecimal representation of the following
            // three bytes in the sequence parameter set NAL unit.
            // => Find the SPS nal header
            nalHeader = /00000001[0-9]7/.exec(codecPrivateData);
            // => Find the 6 characters after the SPS nalHeader (if it exists)
            avcoti = nalHeader && nalHeader[0] ? (codecPrivateData.substr(codecPrivateData.indexOf(nalHeader[0]) + 10, 6)) : undefined;

            return "avc1." + avcoti;
        },

        getAACCodec = function(qualityLevel, fourCCValue) {
            var objectType = 0,
                codecPrivateData = this.domParser.getAttributeValue(qualityLevel, "CodecPrivateData").toString(),
                codecPrivateDataHex,
                samplingRate = parseInt(this.domParser.getAttributeValue(qualityLevel, "SamplingRate"), 10),
                arr16,
                indexFreq,
                extensionSamplingFrequencyIndex;

            //chrome problem, in implicit AAC HE definition, so when AACH is detected in FourCC
            //set objectType to 5 => strange, it should be 2
            if (fourCCValue === "AACH") {
                objectType = 0x05;
            }
            //if codecPrivateData is empty, build it :
            if (codecPrivateData === undefined || codecPrivateData === "") {
                objectType = 0x02; //AAC Main Low Complexity => object Type = 2
                indexFreq = samplingFrequencyIndex[samplingRate];
                if (fourCCValue === "AACH") {
                    // 4 bytes :     XXXXX         XXXX          XXXX             XXXX                  XXXXX      XXX   XXXXXXX
                    //           ' ObjectType' 'Freq Index' 'Channels value'   'Extens Sampl Freq'  'ObjectType'  'GAS' 'alignment = 0'
                    objectType = 0x05; // High Efficiency AAC Profile = object Type = 5 SBR
                    codecPrivateData = new Uint8Array(4);
                    extensionSamplingFrequencyIndex = samplingFrequencyIndex[samplingRate * 2]; // in HE AAC Extension Sampling frequence
                    // equals to SamplingRate*2
                    //Freq Index is present for 3 bits in the first byte, last bit is in the second
                    codecPrivateData[0] = (objectType << 3) | (indexFreq >> 1);
                    codecPrivateData[1] = (indexFreq << 7) | (qualityLevel.Channels << 3) | (extensionSamplingFrequencyIndex >> 1);
                    codecPrivateData[2] = (extensionSamplingFrequencyIndex << 7) | (0x02 << 2); // origin object type equals to 2 => AAC Main Low Complexity
                    codecPrivateData[3] = 0x0; //alignment bits

                    arr16 = new Uint16Array(2);
                    arr16[0] = (codecPrivateData[0] << 8) + codecPrivateData[1];
                    arr16[1] = (codecPrivateData[2] << 8) + codecPrivateData[3];
                    //convert decimal to hex value
                    codecPrivateDataHex = arr16[0].toString(16);
                    codecPrivateDataHex = arr16[0].toString(16) + arr16[1].toString(16);

                } else {
                    // 2 bytes :     XXXXX         XXXX          XXXX              XXX
                    //           ' ObjectType' 'Freq Index' 'Channels value'   'GAS = 000'
                    codecPrivateData = new Uint8Array(2);
                    //Freq Index is present for 3 bits in the first byte, last bit is in the second
                    codecPrivateData[0] = (objectType << 3) | (indexFreq >> 1);
                    codecPrivateData[1] = (indexFreq << 7) | (parseInt(this.domParser.getAttributeValue(qualityLevel, "Channels"), 10) << 3);
                    // put the 2 bytes in an 16 bits array
                    arr16 = new Uint16Array(1);
                    arr16[0] = (codecPrivateData[0] << 8) + codecPrivateData[1];
                    //convert decimal to hex value
                    codecPrivateDataHex = arr16[0].toString(16);
                }

                codecPrivateData = "" + codecPrivateDataHex;
                codecPrivateData = codecPrivateData.toUpperCase();
                qualityLevel.setAttribute("CodecPrivateData", codecPrivateData);
            } else if (objectType === 0) {
                objectType = (parseInt(codecPrivateData.substr(0, 2), 16) & 0xF8) >> 3;
            }

            return "mp4a.40." + objectType;
        },

        mapSegmentTemplate = function(streamIndex) {

            var segmentTemplate = {},
                mediaUrl;

            mediaUrl = this.domParser.getAttributeValue(streamIndex, "Url").replace('{bitrate}', '$Bandwidth$');
            mediaUrl = mediaUrl.replace('{start time}', '$Time$');

            segmentTemplate.media = mediaUrl;
            segmentTemplate.timescale = TIME_SCALE_100_NANOSECOND_UNIT;

            segmentTemplate.SegmentTimeline = mapSegmentTimeline.call(this, streamIndex);

            return segmentTemplate;
        },

        mapSegmentTimeline = function(streamIndex) {

            var segmentTimeline = {},
                chunks = this.domParser.getChildNodes(streamIndex, "c"),
                segments = [],
                i,
                t, d;

            for (i = 0; i < chunks.length; i++) {
                // Get time and duration attributes
                t = parseFloat(this.domParser.getAttributeValue(chunks[i], "t"));
                d = parseFloat(this.domParser.getAttributeValue(chunks[i], "d"));

                if ((i === 0) && !t) {
                    t = 0;
                }

                if (i > 0) {
                    // Update previous segment duration if not defined
                    if (!segments[segments.length - 1].d) {
                        segments[segments.length - 1].d = t - segments[segments.length - 1].t;
                    }
                    // Set segment absolute timestamp if not set
                    if (!t) {
                        t = segments[segments.length - 1].t + segments[segments.length - 1].d;
                    }
                }

                // Create new segment
                segments.push({
                    d: d,
                    t: t
                });

            }

            segmentTimeline.S = segments;
            segmentTimeline.S_asArray = segments;

            return segmentTimeline;
        },

        getKIDFromProtectionHeader = function(protectionHeader) {
            var prHeader,
                wrmHeader,
                xmlReader,
                KID;

            // Get PlayReady header as byte array (base64 decoded)
            prHeader = BASE64.decodeArray(protectionHeader.firstChild.data);

            // Get Right Management header (WRMHEADER) from PlayReady header
            wrmHeader = getWRMHeaderFromPRHeader(prHeader);

            // Convert from multi-byte to unicode
            wrmHeader = new Uint16Array(wrmHeader.buffer);

            // Convert to string
            wrmHeader = String.fromCharCode.apply(null, wrmHeader);

            // Parse <WRMHeader> to get KID field value
            xmlReader = (new DOMParser()).parseFromString(wrmHeader, "application/xml");
            KID = xmlReader.querySelector("KID").textContent;

            // Get KID (base64 decoded) as byte array
            KID = BASE64.decodeArray(KID);

            // Convert UUID from little-endian to big-endian
            convertUuidEndianness(KID);

            return KID;
        },

        getWRMHeaderFromPRHeader = function(prHeader) {
            var length,
                recordCount,
                recordType,
                recordLength,
                recordValue,
                i = 0;

            // Parse PlayReady header

            // Length - 32 bits (LE format)
            length = (prHeader[i + 3] << 24) + (prHeader[i + 2] << 16) + (prHeader[i + 1] << 8) + prHeader[i];
            i += 4;

            // Record count - 16 bits (LE format)
            recordCount = (prHeader[i + 1] << 8) + prHeader[i];
            i += 2;

            // Parse records
            while (i < prHeader.length) {
                // Record type - 16 bits (LE format)
                recordType = (prHeader[i + 1] << 8) + prHeader[i];
                i += 2;

                // Check if Rights Management header (record type = 0x01)
                if (recordType === 0x01) {

                    // Record length - 16 bits (LE format)
                    recordLength = (prHeader[i + 1] << 8) + prHeader[i];
                    i += 2;

                    // Record value => contains <WRMHEADER>
                    recordValue = new Uint8Array(recordLength);
                    recordValue.set(prHeader.subarray(i, i + recordLength));
                    return recordValue;
                }
            }

            return null;
        },

        convertUuidEndianness = function(uuid) {
            swapBytes(uuid, 0, 3);
            swapBytes(uuid, 1, 2);
            swapBytes(uuid, 4, 5);
            swapBytes(uuid, 6, 7);
        },

        swapBytes = function(bytes, pos1, pos2) {
            var temp = bytes[pos1];
            bytes[pos1] = bytes[pos2];
            bytes[pos2] = temp;
        },


        createPRContentProtection = function(protectionHeader) {

            var contentProtection = {},
                keySystem = this.system.getObject("ksPlayReady"),
                pro;

            pro = {
                __text: protectionHeader.firstChild.data,
                __prefix: "mspr"
            };

            contentProtection.schemeIdUri = keySystem.schemeIdURI;
            contentProtection.value = keySystem.systemString;
            contentProtection.pro = pro;
            contentProtection.pro_asArray = pro;

            return contentProtection;
        },

        createWidevineContentProtection = function(/*protectionHeader*/) {

            var contentProtection = {},
                keySystem = this.system.getObject("ksWidevine");

            contentProtection.schemeIdUri = keySystem.schemeIdURI;
            contentProtection.value = keySystem.systemString;

            return contentProtection;
        },

        processManifest = function(manifestLoadedTime) {
            var mpd = {},
                period,
                adaptations,
                contentProtection,
                contentProtections = [],
                smoothNode = this.domParser.getChildNode(xmlDoc, "SmoothStreamingMedia"),
                protection = this.domParser.getChildNode(smoothNode, 'Protection'),
                protectionHeader = null,
                KID,
                realDuration,
                firstSegment,
                lastSegment,
                adaptationTimeOffset,
                i;

            // Set mpd node properties
            mpd.name = 'MSS';
            mpd.profiles = "urn:mpeg:dash:profile:isoff-live:2011";
            mpd.type = Boolean(this.domParser.getAttributeValue(smoothNode, 'IsLive')) ? "dynamic" : "static";
            mpd.timeShiftBufferDepth = parseFloat(this.domParser.getAttributeValue(smoothNode, 'DVRWindowLength')) / TIME_SCALE_100_NANOSECOND_UNIT;
            mpd.mediaPresentationDuration = (parseFloat(this.domParser.getAttributeValue(smoothNode, 'Duration')) === 0) ? Infinity : parseFloat(this.domParser.getAttributeValue(smoothNode, 'Duration')) / TIME_SCALE_100_NANOSECOND_UNIT;
            mpd.BaseURL = baseURL;
            mpd.minBufferTime = MediaPlayer.dependencies.BufferExtensions.DEFAULT_MIN_BUFFER_TIME;

            // In case of live streams, set availabilityStartTime property according to DVRWindowLength
            if (mpd.type === "dynamic") {
                mpd.availabilityStartTime = new Date(manifestLoadedTime.getTime() - (mpd.timeShiftBufferDepth * 1000));
            }

            // Map period node to manifest root node
            mpd.Period = mapPeriod.call(this, mpd.minBufferTime);
            mpd.Period_asArray = [mpd.Period];

            // Initialize period start time
            period = mpd.Period;
            period.start = 0;

            // ContentProtection node
            if (protection !== undefined) {
                protectionHeader = this.domParser.getChildNode(protection, 'ProtectionHeader');

                // Some packagers put newlines into the ProtectionHeader base64 string, which is not good
                // because this cannot be correctly parsed. Let's just filter out any newlines found in there.
                protectionHeader.firstChild.data = protectionHeader.firstChild.data.replace(/\n|\r/g, "");

                // Get KID (in CENC format) from protection header
                KID = getKIDFromProtectionHeader(protectionHeader);

                // Create ContentProtection for PR
                contentProtection = createPRContentProtection.call(this, protectionHeader);
                contentProtection["cenc:default_KID"] = KID;
                contentProtections.push(contentProtection);

                // Create ContentProtection for Widevine (as a CENC protection)
                contentProtection = createWidevineContentProtection.call(this, protectionHeader);
                contentProtection["cenc:default_KID"] = KID;
                contentProtections.push(contentProtection);

                mpd.ContentProtection = (contentProtections.length > 1) ? contentProtections : contentProtections[0];
                mpd.ContentProtection_asArray = contentProtections;

            }

            adaptations = period.AdaptationSet_asArray;
            for (i = 0; i < adaptations.length; i += 1) {
                // In case of VOD streams, check if start time is greater than 0.
                // Therefore, set period start time to the higher adaptation start time
                if (mpd.type === "static" && adaptations[i].contentType !== 'text') {
                    firstSegment = adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray[0];
                    lastSegment = adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray[adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray.length-1];
                    adaptationTimeOffset = parseFloat(firstSegment.t) / TIME_SCALE_100_NANOSECOND_UNIT;
                    period.start = (period.start === 0) ? adaptationTimeOffset : Math.max(period.start, adaptationTimeOffset);
                    //get last segment start time, add the duration of this last segment
                    realDuration = parseFloat(((lastSegment.t + lastSegment.d) / TIME_SCALE_100_NANOSECOND_UNIT).toFixed(3));
                    //detect difference between announced duration (in MSS manifest) and real duration => in any case, we want that the video element sends the ended event.
                    //set the smallest value between all the adaptations
                    if (!isNaN(realDuration) && realDuration < mpd.mediaPresentationDuration) {
                        mpd.mediaPresentationDuration = realDuration;
                        period.duration = realDuration;
                    }
                }

                // Propagate content protection information into each adaptation
                if (mpd.ContentProtection !== undefined) {
                    adaptations[i].ContentProtection = mpd.ContentProtection;
                    adaptations[i].ContentProtection_asArray = mpd.ContentProtection_asArray;
                }
            }

            // Delete Content Protection under root mpd node
            delete mpd.ContentProtection;
            delete mpd.ContentProtection_asArray;


            return mpd;
        },

        internalParse = function(data, baseUrl) {
            this.debug.info("[MssParser]", "Doing parse.");

            var start = new Date(),
                xml = null,
                manifest = null,
                mss2dash = null;

            //this.debug.log("[MssParser]", "Converting from XML.");
            xmlDoc = this.domParser.createXmlTree(data);
            xml = new Date();

            if (xmlDoc === null) {
                return Q.reject(null);
            }

            baseURL = baseUrl;

            // Convert MSS manifest into DASH manifest
            manifest = processManifest.call(this, start);
            mss2dash = new Date();
            //this.debug.log("mpd: " + JSON.stringify(manifest, null, '\t'));

            this.debug.info("[MssParser]", "Parsing complete (xmlParser: " + (xml.getTime() - start.getTime()) + "ms, mss2dash: " + (mss2dash.getTime() - xml.getTime()) + "ms, total: " + ((new Date().getTime() - start.getTime()) / 1000) + "s)");
            //console.info("manifest",JSON.stringify(manifest) );
            return Q.when(manifest);
        };

    return {
        debug: undefined,
        system: undefined,
        domParser: undefined,
        metricsModel: undefined,

        parse: internalParse
    };
};

Mss.dependencies.MssParser.prototype = {
    constructor: Mss.dependencies.MssParser
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Mss.dependencies.MssHandler = function() {
    "use strict";

    var getAudioChannels = function(adaptation, representation) {
            var channels = 1;

            if (adaptation.audioChannels) {
                channels = adaptation.audioChannels;
            } else if (representation.audioChannels) {
                channels = representation.audioChannels;
            }

            return channels;
        },

        getAudioSamplingRate = function(adaptation, representation) {
            var samplingRate = 1;

            if (adaptation.audioSamplingRate) {
                samplingRate = adaptation.audioSamplingRate;
            } else {
                samplingRate = representation.audioSamplingRate;
            }

            return samplingRate;
        },

        // Generates initialization segment data from representation information
        // by using mp4lib library
        getInitData = function(representation) {
            var manifest = rslt.manifestModel.getValue(),
                adaptation,
                realAdaptation,
                realRepresentation,
                track,
                codec;

            if (representation.initData) {
                return representation.initData;
            }

            // Get required media information from manifest  to generate initialisation segment
            adaptation = representation.adaptation;
            realAdaptation = manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index];
            realRepresentation = realAdaptation.Representation_asArray[representation.index];

            track = new MediaPlayer.vo.Mp4Track();
            track.type = rslt.getType() || 'und';
            track.trackId = adaptation.index + 1; // +1 since track_id shall start from '1'
            track.timescale = representation.timescale;
            track.duration = representation.adaptation.period.duration;
            track.codecs = realRepresentation.codecs;
            track.codecPrivateData = realRepresentation.codecPrivateData;
            track.bandwidth = realRepresentation.bandwidth;

            if (track.type !== 'text') {
                codec = realRepresentation.mimeType + ';codecs="' + realRepresentation.codecs + '"';
                if (!this.capabilities.supportsCodec(this.videoModel.getElement(), codec)) {
                    throw {
                        name: MediaPlayer.dependencies.ErrorHandler.prototype.MEDIA_ERR_CODEC_UNSUPPORTED,
                        message: "Codec is not supported",
                        data: {
                            codec: codec
                        }
                    };
                }
            }

            // DRM Protected Adaptation is detected
            if (realAdaptation.ContentProtection_asArray && (realAdaptation.ContentProtection_asArray.length > 0)) {
                track.contentProtection = realAdaptation.ContentProtection_asArray;
            }

            // Video related informations
            track.width = realRepresentation.width || realAdaptation.maxWidth;
            track.height = realRepresentation.height || realAdaptation.maxHeight;

            // Audio related informations
            track.language = realAdaptation.lang ? realAdaptation.lang : 'und';

            track.channels = getAudioChannels(realAdaptation, realRepresentation);
            track.samplingRate = getAudioSamplingRate(realAdaptation, realRepresentation);

            representation.initData = rslt.mp4Processor.generateInitSegment([track]);

            return representation.initData;

        };

    var rslt = MediaPlayer.utils.copyMethods(Dash.dependencies.DashHandler);
    rslt.mp4Processor = undefined;

    rslt.getInitRequest = function(representation) {
        var period = null,
            self = this,
            presentationStartTime = null,
            request = null,
            deferred = Q.defer();

        if (!representation) {
            throw new Error("MssHandler.getInitRequest(): representation is undefined");
        }

        period = representation.adaptation.period;
        presentationStartTime = period.start;

        request = new MediaPlayer.vo.SegmentRequest();

        request.streamType = rslt.getType();
        request.type = "Initialization Segment";
        request.url = null;

        try {
            request.data = getInitData.call(this, representation);
        } catch (e) {
            deferred.reject(e);
            return deferred.promise;
        }

        request.range = representation.range;
        request.availabilityStartTime = self.timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime, representation.adaptation.period.mpd, rslt.getIsDynamic());
        request.availabilityEndTime = self.timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration, period.mpd, rslt.getIsDynamic());

        //request.action = "complete"; //needed to avoid to execute request
        request.quality = representation.index;
        deferred.resolve(request);

        return deferred.promise;
    };

    rslt.getIFrameRequest = function(request){
        if (request && request.url && (request.streamType === "video" || request.streamType === "audio")) {
            request.url = request.url.replace('Fragments','KeyFrames');
        }

        return request;
    };

    rslt.getFragmentInfoRequest = function(request){
        if (request && request.url) {
            request.url = request.url.replace('Fragments','FragmentInfo');
            request.type = "FragmentInfo Segment";
        }

        return request;
    };

    return rslt;
};

Mss.dependencies.MssHandler.prototype = {
    constructor: Mss.dependencies.MssHandler
};
/*
 * The copyright in this software module is being made available under the BSD License, included below. This software module may be subject to other third party and/or contributor rights, including patent rights, and no such rights are granted under this license.
 * The whole software resulting from the execution of this software module together with its external dependent software modules from dash.js project may be subject to Orange and/or other third party rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2014, Orange
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * •  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * •  Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 * •  Neither the name of the Orange nor the names of its contributors may be used to endorse or promote products derived from this software module without specific prior written permission.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
Mss.dependencies.MssFragmentController = function() {
    "use strict";

    var processTfrf = function(request, tfrf, tfdt, adaptation) {
            var manifest = this.manifestModel.getValue(),
                segmentsUpdated = false,
                // Get adaptation's segment timeline (always a SegmentTimeline in Smooth Streaming use case)
                segments = adaptation.SegmentTemplate.SegmentTimeline.S,
                entries = tfrf.entry,
                fragment_absolute_time = 0,
                fragment_duration = 0,
                segment = null,
                t = 0,
                i = 0,
                j = 0,
                segmentId = -1,
                availabilityStartTime = null,
                range;

            // Go through tfrf entries
            while (i < entries.length) {
                fragment_absolute_time = entries[i].fragment_absolute_time;
                fragment_duration = entries[i].fragment_duration;

                // Get timestamp of the last segment
                segment = segments[segments.length - 1];
                t = segment.t;

                if (fragment_absolute_time > t) {
                    this.debug.log("[MssFragmentController] Add new segment - t = " + (fragment_absolute_time / 10000000.0));
                    segments.push({
                        t: fragment_absolute_time,
                        d: fragment_duration
                    });
                    segmentsUpdated = true;
                }

                i += 1;
            }

            for (j = segments.length - 1; j >= 0; j -= 1) {
                if (segments[j].t === tfdt.baseMediaDecodeTime) {
                    segmentId = j;
                    break;
                }
            }

            if (segmentId >= 0) {
                for (i = 0; i < entries.length; i += 1) {
                    if (segmentId + i < segments.length) {
                        t = segments[segmentId + i].t;
                        if ((t + segments[segmentId + i].d) !== entries[i].fragment_absolute_time) {
                            segments[segmentId + i].t = entries[i].fragment_absolute_time;
                            segments[segmentId + i].d = entries[i].fragment_duration;
                            this.debug.log("[MssFragmentController] Correct tfrf time  = " + entries[i].fragment_absolute_time + "and duration = " + entries[i].fragment_duration + "! ********");
                            segmentsUpdated = true;
                        }
                    }
                }
            }

            //
            if (manifest.timeShiftBufferDepth && manifest.timeShiftBufferDepth > 0) {
                if (segmentsUpdated) {
                    // Get timestamp of the last segment
                    segment = segments[segments.length - 1];
                    t = segment.t;

                    // Determine the segments' availability start time
                    availabilityStartTime = t - (manifest.timeShiftBufferDepth * 10000000);

                    // Remove segments prior to availability start time
                    segment = segments[0];
                    while (segment.t < availabilityStartTime) {
                        this.debug.log("[MssFragmentController] Remove segment  - t = " + (segment.t / 10000000.0));
                        segments.splice(0, 1);
                        segment = segments[0];
                    }
                }

                // Update DVR window range
                // => set range end to end time of current segment
                range = {
                    start: segments[0].t / adaptation.SegmentTemplate.timescale,
                    end: (tfdt.baseMediaDecodeTime / adaptation.SegmentTemplate.timescale) + request.duration
                };
                var dvrInfos = this.metricsModel.getMetricsFor(adaptation.type).DVRInfo;
                if (dvrInfos && dvrInfos.length > 0 && range.end > dvrInfos[dvrInfos.length - 1].range.end) {
                    this.metricsModel.addDVRInfo(adaptation.type, new Date(), range);
                }
            }

            return segmentsUpdated;
        },

        updateSegmentsList = function(bytes, request, adaptation) {
            var fragment = null,
                moof = null,
                traf = null,
                tfdt = null,
                tfrf = null,
                pos,
                i = 0;

            // Create new fragment
            fragment = mp4lib.deserialize(bytes);
            moof = fragment.getBoxByType("moof");
            traf = moof.getBoxByType("traf");
            // Create and add tfdt box
            tfdt = traf.getBoxByType("tfdt");
            if (tfdt === null) {
                tfdt = new mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox();
                tfdt.version = 1;
                tfdt.flags = 0;
                tfdt.baseMediaDecodeTime = Math.floor(request.startTime * request.timescale);
                // Insert tfdt box just after the tfhd box (therefore before the trun box)
                pos = traf.getBoxIndexByType("tfhd");
                traf.boxes.splice(pos + 1, 0, tfdt);
            }
            // Process tfrf box
            tfrf = traf.getBoxesByType("tfrf");
            if (tfrf.length !== 0) {
                for (i = 0; i < tfrf.length; i += 1) {
                    processTfrf.call(this, request, tfrf[i], tfdt, adaptation);
                }
            }
        },

        duplicateSample = function(fragment, segmentDuration) {
            var moof = null,
                mdat = null,
                traf = null,
                trun = null,
                tfhd,
                sepiff = null,
                saiz = null,
                i,
                trunEntries,
                trunDuration,
                mdatData;

            // This function duplicates the first sample (from KeyFrame request) to generate
            // a full segment with the segment duration.

            // Get references on boxes
            moof = fragment.getBoxByType("moof");
            mdat = fragment.getBoxByType("mdat");
            traf = moof.getBoxByType("traf");
            trun = traf.getBoxByType("trun");
            tfhd = traf.getBoxByType("tfhd");

            // We will set the sample_duration for each segment, then we do set also for first segment duration if not set
            if (trun.samples_table[0].sample_duration === undefined) {
                trun.samples_table[0].sample_duration = tfhd.default_sample_duration;
            }

            // Determine number of samples according to the segment duration
            trunEntries = Math.floor(segmentDuration / trun.samples_table[0].sample_duration);

            // Add samples in trun box to complete fragment ((trunEntries - 1) for not considering already existing first fragment)
            for (i = 0; i < (trunEntries - 1); i++) {
                trun.samples_table.push(trun.samples_table[0]);
            }

            // Patch/lengthen the last sample duration if segment not complete
            trunDuration = trunEntries * trun.samples_table[0].sample_duration;
            if (trunDuration < segmentDuration) {
                trun.samples_table[trun.samples_table.length - 1].sample_duration += segmentDuration - trunDuration;
            }

            trun.sample_count = trun.samples_table.length;

            // Update PIFF Sample Encryption box
            sepiff = traf.getBoxByType("sepiff");
            if (sepiff !== null) {
                // sepiff box may have already all original samples encryption data definition
                // => we keep only first sample entry
                if (sepiff.sample_count > 1) {
                    sepiff.entry = sepiff.entry.slice(0, 1);
                }
                // Then, we duplicate this first entry
                for (i = 0; i < (trunEntries - 1); i += 1) {
                    sepiff.entry.push(sepiff.entry[0]);
                }
                sepiff.sample_count = sepiff.entry.length;
            }

            // Update saiz box
            saiz = traf.getBoxByType("saiz");
            if (saiz !== null) {
                if (saiz.default_sample_info_size === 0) {
                    // Same process as for sepiff box....
                    if (saiz.sample_count > 1) {
                        saiz.sample_info_size = saiz.sample_info_size.slice(0, 1);
                    }
                    for (i = 0; i < (trunEntries - 1); i += 1) {
                        saiz.sample_info_size.push(saiz.sample_info_size[0]);
                    }
                }
                saiz.sample_count = sepiff.entry.length;
            }

            // Duplicate mdat data
            mdatData = mdat.data;
            mdat.data = new Uint8Array(mdatData.length * trun.sample_count);
            for (i = 0; i < trun.sample_count; i += 1) {
                mdat.data.set(mdatData, mdatData.length * i);
            }
        },

        convertFragment = function(data, request, adaptation) {
            var i = 0,
                // Get track id corresponding to adaptation set
                manifest = this.manifestModel.getValue(),
                trackId = manifest ? this.manifestExt.getIndex(adaptation, manifest) + 1 : -1, // +1 since track_id shall start from '1'
                // Create new fragment
                fragment = mp4lib.deserialize(data),
                moof = null,
                mdat = null,
                traf = null,
                trun = null,
                tfhd = null,
                saio = null,
                sepiff = null,
                saiz = null,
                tfdt = null,
                tfrf = null,
                fragmentDuration,
                sampleDuration,
                pos = -1,
                fragment_size = 0,
                moofPosInFragment = 0,
                trafPosInMoof = 0,
                sencPosInTraf = 0,
                new_data = null;

            if (!fragment) {
                return null;
            }

            // Get references on boxes
            moof = fragment.getBoxByType("moof");
            mdat = fragment.getBoxByType("mdat");
            traf = moof.getBoxByType("traf");
            trun = traf.getBoxByType("trun");
            tfhd = traf.getBoxByType("tfhd");

            // Patch trun and mdat boxes to duplicate first sample in order to have a complete fragment
            // => use case in trick mode where we do request only Key (I) frames, while the <video> element
            // requires continuous stream to enable playback
            sampleDuration = trun.samples_table[0].sample_duration !== undefined ? trun.samples_table[0].sample_duration : tfhd.default_sample_duration;
            fragmentDuration = request.duration * request.timescale;
            if (trun.samples_table.length === 1 && sampleDuration < fragmentDuration) {
                duplicateSample(fragment, fragmentDuration);
            }

            // Update tfhd.track_ID field
            tfhd.track_ID = trackId;

            // Process tfxd boxes
            // This box provide absolute timestamp but we take the segment start time for tfdt
            traf.removeBoxByType("tfxd");

            // Create and add tfdt box
            tfdt = traf.getBoxByType("tfdt");
            if (tfdt === null) {
                tfdt = new mp4lib.boxes.TrackFragmentBaseMediaDecodeTimeBox();
                tfdt.version = 1;
                tfdt.flags = 0;
                tfdt.baseMediaDecodeTime = Math.floor(request.startTime * request.timescale);
                // Insert tfdt box just after the tfhd box (therefore before the trun box)
                pos = traf.getBoxIndexByType("tfhd");
                traf.boxes.splice(pos + 1, 0, tfdt);
            }

            // Process tfrf box
            tfrf = traf.getBoxesByType("tfrf");
            if (tfrf.length !== 0) {
                for (i = 0; i < tfrf.length; i += 1) {
                    processTfrf.call(this, request, tfrf[i], tfdt, adaptation);
                    traf.removeBoxByType("tfrf");
                }
            }

            // If protected content (sepiff box = Sample Encryption PIFF)
            // => convert it into a senc box
            // => create saio and saiz boxes (if not already present)
            sepiff = traf.getBoxByType("sepiff");
            if (sepiff !== null) {
                sepiff.boxtype = "senc";
                sepiff.extended_type = undefined;

                saio = traf.getBoxByType("saio");
                if (saio === null) {
                    // Create Sample Auxiliary Information Offsets Box box (saio)
                    saio = new mp4lib.boxes.SampleAuxiliaryInformationOffsetsBox();
                    saio.version = 0;
                    saio.flags = 0;
                    saio.entry_count = 1;
                    saio.offset = [];

                    saiz = new mp4lib.boxes.SampleAuxiliaryInformationSizesBox();
                    saiz.version = 0;
                    saiz.flags = 0;
                    saiz.sample_count = sepiff.sample_count;
                    saiz.default_sample_info_size = 0;
                    saiz.sample_info_size = [];

                    if (sepiff.flags & 0x02) {
                        // Sub-sample encryption => set sample_info_size for each sample
                        for (i = 0; i < sepiff.sample_count; i += 1) {
                            // 10 = 8 (InitializationVector field size) + 2 (subsample_count field size)
                            // 6 = 2 (BytesOfClearData field size) + 4 (BytesOfEncryptedData field size)
                            saiz.sample_info_size[i] = 10 + (6 * sepiff.entry[i].NumberOfEntries);
                        }
                    } else {
                        // No sub-sample encryption => set default sample_info_size = InitializationVector field size (8)
                        saiz.default_sample_info_size = 8;
                    }

                    //add saio and saiz box
                    traf.boxes.push(saiz);
                    traf.boxes.push(saio);
                }
            }

            // Before determining new size of the converted fragment we update some box flags related to data offset
            tfhd.flags &= 0xFFFFFE; // set tfhd.base-data-offset-present to false
            tfhd.flags |= 0x020000; // set tfhd.default-base-is-moof to true
            trun.flags |= 0x000001; // set trun.data-offset-present to true
            trun.data_offset = 0; // Set a default value for trun.data_offset

            // Determine new size of the converted fragment
            // and allocate new data buffer
            fragment_size = fragment.getLength();

            // updata trun.data_offset field = offset of first data byte (inside mdat box)
            trun.data_offset = fragment_size - mdat.size + 8; // 8 = 'size' + 'type' mdat fields length

            // Update saio box offset field according to new senc box offset
            if (sepiff !== null) {
                moofPosInFragment = fragment.getBoxOffsetByType("moof");
                trafPosInMoof = moof.getBoxOffsetByType("traf");
                sencPosInTraf = traf.getBoxOffsetByType("senc");
                // Set offset from begin fragment to the first IV field in senc box
                saio.offset[0] = moofPosInFragment + trafPosInMoof + sencPosInTraf + 16; // 16 = box header (12) + sample_count field size (4)
            }

            new_data = mp4lib.serialize(fragment);

            return new_data;
        };

    var rslt = MediaPlayer.utils.copyMethods(MediaPlayer.dependencies.FragmentController);

    rslt.manifestModel = undefined;
    rslt.manifestExt = undefined;
    rslt.metricsModel = undefined;

    rslt.process = function(bytes, request, representations) {
        var result = null,
            manifest = this.manifestModel.getValue(),
            adaptation = null;

        if (bytes !== null && bytes !== undefined && bytes.byteLength > 0) {
            result = new Uint8Array(bytes);
        } else {
            return null;
        }

        if (manifest && representations && (representations.length > 0)) {
            // Get adaptation containing provided representations
            // (Note: here representations is of type Dash.vo.Representation)
            adaptation = manifest.Period_asArray[representations[0].adaptation.period.index].AdaptationSet_asArray[representations[0].adaptation.index];
            if (request) {
                if (request.type === "Media Segment") {
                    try {
                        result = convertFragment.call(this, result, request, adaptation);
                    } catch (e) {
                        return e;
                    }

                    if (!result) {
                        return null;
                    }
                } else if (request.type === "FragmentInfo Segment") {
                    try {
                        updateSegmentsList.call(this, result, request, adaptation);
                    } catch (e) {
                        return e;
                    }
                }
            }
        }

        return result;
    };

    return rslt;
};

Mss.dependencies.MssFragmentController.prototype = {
    constructor: Mss.dependencies.MssFragmentController
};
  dijon = this.dijon;
return MediaPlayer;

}));

// $(document).ready(function(){
//
//
//      $(window).load(function(){
//       $('.flexslider').flexslider({
//         animation: "slide",
//         start: function(slider){
//           $('body').removeClass('loading');
//         }
//       });
//
//
//     });
//
// });

function navigate(element, navigateTo) {
    $(element).parents('.menu-items').find('a.active').removeClass('active');
    $(element).addClass('active');
    $('html, body').animate({
        scrollTop: $("#" + navigateTo).offset().top
    }, 2000);
}


function movetoregister() {

    $('html, body').animate({
        scrollTop: $("#slider").offset().top - 100

    }, 1000);

     $('html, body').animate({
        scrollTop: $("#menu").offset().top - 100

    }, 1000);

    $('html, body').animate({
        scrollTop: $("#Features").offset().top - 100

    }, 1000);


    $('html, body').animate({
        scrollTop: $("#powerfull").offset().top - 100

    }, 1000);
    return false;
}

$(function(){
  var toggles = $('.toggle a'),
      codes = $('.code');
  
  toggles.on("click", function(event){
    event.preventDefault();
    var $this = $(this);
    
    if (!$this.hasClass("active")) {
      toggles.removeClass("active");
      $this.addClass("active");
      codes.hide().filter(this.hash).show();
    }
  });
  toggles.first().click();
});
$(window).on('load', function() {
    setTimeout(function() {
    $("#barwrap").css("margin-bottom", "36px !important");
      return $(".bar").animate({
        height: "toggle"
      }, "slow")
    }, 450);
    return $("#ok").on("click", function() {
      $("#barwrap").css("margin-bottom", "0px");
      $(".bar").animate({
        height: "toggle"
      }, "slow");
      return !1
    })
});
(function() {
  'use strict';
  angular
  .module('NearPeer',['ngRateIt','ui.router','base64','angular-loading-bar', 'ngFileUpload', 'flow','angulartics', 'angulartics.google.analytics', 'ngAnimate', 'angularjs-datetime-picker', 'timer', 'chart.js','ui.sortable','ngMaterial','ngStorage','ngSails','textAngular','ng.deviceDetector','ngTagsInput', 'countTo', 'ngCookies', 'angularjs-dropdown-multiselect', 'constants', 'infinite-scroll', 'tooltips', 'ui.select', 'ngSanitize','ngImageCompress','toaster', 'slickCarousel', 'oc.lazyLoad','ui.slider','swipe'])
  .filter('to_trusted', ['$sce', function($sce){
    return function(text) {

      return $sce.trustAsHtml(text);
    };
  }])
  .filter('removeExtraDecimalPoints', function() {
    return function(input) {
      if(input > -1){
        if(input % 1 != 0){
          return parseFloat(input).toFixed(2);
        } else {
          return input;
        }
      }
    };
  })
  .filter('roundup', function () {
    return function (value) {
        return Math.ceil(value);
    };
  })
  .filter('strLimit', ['$filter', function($filter) {
    return function(input, limit) {
       if (! input) return;
       if (input.length <= limit) {
           return input;
       }

       return $filter('limitTo')(input, limit) + '...';
    };
  }])
  .filter('stripHtml', function() {
    return function(text) {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  })
  .directive('bindNotificationToasterHtml', [function () {
    return {
      link: function(scope, element, attrs) {
        scope.clickNotification = function() {
          var message = scope.directiveData;
          if (message.redirect_url) {
            var link = message.redirect_url;
            if (!link.startsWith("http://") && !link.startsWith("https://")) {
              link = "https://" + link;
            }
            if (message.redirect_type === "new_tab") {
              window.open(link, "_blank");
            } else {
              window.location.href = link;
            }
          }
        };
      },
      template: "<div ng-click='clickNotification()'><p  style='color:black'>{{directiveData.title}}</p><p ng-click='hello()' style='color:black'>{{directiveData.description}}</p></div>"
    };
  }])
  .directive('dynFbCommentBox', function () {
    function createHTML(href, numposts, colorscheme) {
      return '<div class="fb-comments" ' +
      'data-href="' + href + '" ' +
      'data-numposts="' + numposts + '" ' +
      'data-colorsheme="' + colorscheme + '">' +
      '</div>';
    }

    return {
      restrict: 'A',
      scope: {},
      link: function postLink(scope, elem, attrs) {
        attrs.$observe('pageHref', function (newValue) {
          var href        = newValue;
          var numposts    = attrs.numposts    || 5;
          var colorscheme = attrs.colorscheme || 'light';
          elem.html(createHTML(href, numposts, colorscheme));
          FB.XFBML.parse(elem[0]);
        });
      }
    };
  })
  .directive('loginForm', function () {
    return {
      restrict: 'A',
      controller:  'loginController',
      templateUrl: 'app/login/login.html'
    };
  })
  .directive('videoPopup', function () {
    return {
      restrict: 'E',
      scope: {
        video: '=',
      },
      controller:  'videoPopupController',
      templateUrl: 'app/instructor_panel/VideoPopup/videoPopup.html'
    };
  })
  // .directive('thankyou', function () {
  //   return {
  //     restrict: 'E',
  //     templateUrl: 'app/thankyou/thankyou.html',
  //     link: function (scope, element, attrs) {
  //       scope.thankyouPopup =false;
  //       scope.openThankyou = function() {
  //       scope.internalControl.takenTablets += 1;
  //     }
  //
  //     }
  //   };
  // })

   .directive('player', function () {
        'use strict';
        return {
            restrict: 'E',
            controller:  'storyPlayerController',
            templateUrl: 'app/admin/stories/storyPlayer.html'
           
        };
  })

  .directive('faqsVideo' , function(){
    return{ 
      restrict: 'E', 
      scope: {
        showbutton:'=',
        institution: '=',
        
      },
      controller:  'faqsVideoController',
      templateUrl: 'app/FaqsVideo/faqsVideo.html', 
    };
  })


  .directive('videoPlayerSat', function () {
    return {
      restrict: 'E',
      scope: {
        src: '@url',
        textid: '@textid',
        poster: '@poster',
        height: '@height'
      },
      controller:  'satVideoController',
      templateUrl: 'app/sat/satVideo.html'
    };
  })
  .directive('adminHeader', function () {
    return {
      restrict: 'E',
      scope: {
        statename: '@statename'
      },
      controller:  'AdminHeaderController',
      templateUrl: 'app/directives/header/adminHeader.html'
    };
  })
  .directive('courseTile', function () {
    return {
      restrict: 'E',
      scope: {
        course: '='
      },
      controller:  'courseTileController',
      templateUrl: 'app/directives/courseTile/courseTile.html'
    };
  })
  .directive('courseBlocks', function () {
    return {
      restrict: 'E',
      scope: {
        courses: '='
      },
      controller:  'courseBlockController',
      templateUrl: 'app/directives/courseBlocks/courseBlocks.html'
    };
  })
  .directive('courseHeader', function () {
    return {
      restrict: 'E',
      scope: {
        course: '='
      },
      controller:  'courseHeaderController',
      templateUrl: 'app/directives/courseHeader/courseHeader.html'
    };
  })

  .directive('paymentMethods', function () {
    return {
      restrict: 'E',
      controller:  'PaymentOptionsController',
      templateUrl: 'app/Pages/payment-options.html'
    };
  })

  .directive('getCourse', function () {
    return {
      restrict: 'E',
      scope: {
        course: '='
      },
      controller:  'getCourseCotroller',
      templateUrl: 'app/directives/getCourse/getCourse.html'
    };
  })
  .directive('customform', function () {
    return {
      restrict: 'E',
      scope: {
        form: '=',
      },
      controller:  'customFormController',
      templateUrl: 'app/directives/customForm/customForm.html'
    };
  })
  .directive('addtocart', function () {
    return {
      restrict: 'E',
      scope: {
        course: '=',
        enrolled: '=',
      },
      controller:  'addToCartController',
      templateUrl: 'app/directives/addToCart/addToCart.html'
    };
  })
  .directive('courseCart', function () {
    return {
      restrict: 'E',
      scope: {
        course: '=',
        enrolled: '=',
        payment: '='
      },
      controller:  'courseCartController',
      templateUrl: 'app/directives/courseCart/courseCart.html'
    };
  })
  .directive('courseInclude', function () {
    return {
      restrict: 'E',
      scope: {
        course: '=',
        enrolled: '='
      },
      controller:  'courseInculdeController',
      templateUrl: 'app/directives/courseInclude/courseInclude.html'
    };
  })
  .directive('mdcatSlider', function ($timeout) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        instructors : '='
      },
      link: function (scope, elem, attrs) {
      },
      templateUrl: 'app/slider/slider.html',
      controller:  'sliderController',
    };
  })
  .directive('breadCrumbs', function () {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        instructors : '='
      },
      templateUrl: 'app/directives/breadCrumbs/breadCrumbs.html',
      controller:  'breadCrumbsController',
    };
  })
  .animation('.slide-animation', function () {
    return {
      beforeAddClass: function (element, className, done) {
        var scope = element.scope();

        if (className == 'ng-hide') {
          var finishPoint = element.parent().width();

          if(scope.direction !== 'right') {
            finishPoint = -finishPoint;
          }
          TweenMax.to(element, 0.5, {left: finishPoint, onComplete: done });
        }

        else {
          done();
        }
      },
      removeClass: function (element, className, done) {
        var scope = element.scope();
        if (className == 'ng-hide') {
          element.removeClass('ng-hide');
          var startPoint = element.parent().width();
          if(scope.direction === 'right') {
            startPoint = -startPoint;
          }

          TweenMax.fromTo(element, 0.5, { left: startPoint }, {left: 0, onComplete: done });
        }
        else {
          done();
        }
      }
    };
  })


  .factory('httpRequestInterceptor', function ($q, CustomStorageService, $rootScope) {
    return {
      request: function (config) {
        if(CustomStorageService.getUserInfoStorageData() && config.url.includes('users/getUserData') && config.headers.uid && (config.headers.uid != CustomStorageService.getUserInfoStorageData().id || config.headers.Authorization != CustomStorageService.getAuthTokenStorageData())) {
        }
        else if(CustomStorageService.getUserInfoStorageData() && (CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData() || CustomStorageService.getAdminSignedInStorageData() || CustomStorageService.getBlogerSignedInStorageData())){
          config.headers["Authorization"] = CustomStorageService.getAuthTokenStorageData();
          config.headers["uid"] = CustomStorageService.getUserInfoStorageData().id;
        }
        // config.headers["browser-user-id"] = CustomStorageService.getBrowserUserID();
        return config;
      },
      responseError: function(rejection) {
        if(rejection.status === 429) {
          $rootScope.rateLimitError = true;
          $rootScope.rateLimitErrorCode = rejection.data.error;
        }
        return $q.reject(rejection);
        
      }
    };
  })
  .config(['uiSelectConfig', function(uiSelectConfig) {
    uiSelectConfig.theme = 'bootstrap';
  }]);
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("InstructorPanelNewLiveSessionController", [
      "$scope",
      "$rootScope",
      "$timeout",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "instructorPanelService",
      "UploadService",
      "$sails",
      '$filter',
      "env",
      "$sce",
      '$location',
      '$window',
      'videoSocket',
      function (
        $scope,
        $rootScope,
        $timeout,
        Upload,
        $http,
        $state,
        CustomStorageService,
        instructorPanelService,
        UploadService,
        $sails,
        $filter,
        env,
        $sce,
        $location,
        $window,
        videoSocket
      ) {
        $scope.showData = false;
        $scope.showChapterSelection = false;
        $scope.showVideoSelection = false;
        $scope.edit = false;
        $scope.creation_alert = false;
        $scope.push_notification = {
            title: null,
            body: null
        };
        $scope.email_notification = {
            subject: null,
            body: null
        };
        $scope.alert_before_in_minutes = 60;
        $scope.alert_at_time = false;
        $scope.cancelLiveSession = false;
        $scope.cancelLiveSessionReason = null;
        $scope.cancelLiveSessionReasonText = null;
        $scope.uploadLiveSession = false;
        $scope.selectedSessionType = null;
        $scope.selectedSessionNiche = null;
        $scope.selectedVideoNiche = null;
        $scope.selectedSessionUserType = null;
        $scope.selectedSessionCourse = null;
        $scope.selectedVideoCourse = null;
        $scope.selectedSessionModule = null;
        $scope.selectedVideoModule = null;
        $scope.selectedSessionChapter = null;
        $scope.selectedVideoChapter = null;
        $scope.selectedSessionCVideo = null;
        $scope.name = null;
        $scope.description = null;
        $scope.instructor_name = null;
        $scope.instructor_profile = null;
        $scope.image_url = null;
        $scope.thumbnail_url = null;
        var time = new Date();
        time.setMinutes(time.getMinutes() + 30)
        time.setMilliseconds(0)
        time.setSeconds(0)
        $scope.time = time;
        $scope.ex_time = null;
        $scope.uploadStatus = 0;
        $scope.session_status = 'SCHEDULED';
        $scope.url_type = 'NEARPEER';
        $scope.url = null;
        $scope.imageUploadingInProcess = false;
        $scope.sessionTypes = [{key: 'OPEN_TO_ALL', value: 'Open to all'}, {key: 'SESSION_FOR_NICHE', value: 'Session for niche'}, {key: 'SESSION_FOR_COURSE', value: 'Session for course'}];
        $scope.sessionNiches = [];
        $scope.videoNiches = [];
        $scope.sessionUserTypes = [{key: 'ENROLLED', value: 'Enrolled'}, {key: 'PAID', value: 'Paid'}];
        $scope.sessionCourses = [];
        $scope.videoCourses = [];
        $scope.sessionModules = [];
        $scope.videoModules = [];
        $scope.sessionChapters = [];
        $scope.videoChapters = [];
        $scope.sessionCVideos = [];
        $scope.is_custom_form = false;
        $scope.is_custom_form_mandatory = false;
        $scope.is_registration_form_mandatory = false;
        var customFormBuilder = null;
        $scope.is_registration_form = false;
        $scope.publish_live_session = true;
        $scope.allow_chat = true;
        $scope.allow_guest_users = false;
        $scope.show_registration_form_after_min = 0;
        $scope.show_custom_form_after_min = 0;
        $scope.customForm = {
            id: 0,
            name: "",
            description: "",
            formData: {},
        }
        $scope.youtubeLink = "";
        $scope.email = "";


        $scope.initializeFormBuilder = function() {
          // Run the formBuilder code here
            $(document.getElementById('custom-live-session-editor')).formBuilder().promise.then(function (cFormBuilder) {
                customFormBuilder = cFormBuilder;
            });
        };

        // $scope.initializeCustomFormBuilder = function() {
        //   // Run the formBuilder code here
        //     if(customFormBuilder === null) customFormBuilder = $(document.getElementById('custom-live-session-editor')).formBuilder();
        // };

        $scope.duplicateLiveSession = function(){
            $scope.showData = false;
            $http.get("api/v1/live-session/duplicate/"+ $state.params.id).then(function (data){
                if (data.data.success) {
                    swal({
                        title: "Success",
                        text: "Live Session Duplicated Successfully",
                        type: "success",
                    });
                                        $state.go("InstructorPanelEditLiveSession", { id: data.data.live_session.id }, { reload: true });
                } else {
                    swal({
                        title: "Error",
                        text: data.data.message,
                        type: "error",
                    });
                }
                $scope.showData = true;
            });
        }

        $scope.cancelLiveSessionAction = function(){
            $http.post("api/v1/live-session/cancel/"+ $state.params.id, {
                "cancellation_reason": $scope.cancelLiveSessionReason == 'Custom' ? $scope.cancelLiveSessionReasonText : $scope.cancelLiveSessionReason
            }).then(function (data){
                if (data.data.success) {
                    swal({
                        title: "Success",
                        text: "Live Session Cancelled Successfully",
                        type: "success",
                    });
                    $state.go("InstructorPanelLiveSession", {}, { reload: true });
                } else {
                    swal({
                        title: "Error",
                        text: data.data.message,
                        type: "error",
                    });
                }
            });
        }

        $scope.cancelLiveSessionPopUp = function(){
          $scope.cancelLiveSession = false;
        }

        $scope.openCancelModal = function(){
          $scope.cancelLiveSession = true;
        }

        $scope.openUploadVideoModal = function(){
          $scope.uploadLiveSession = true;
        }

        $scope.closeUploadVideoModal = function(){
            $scope.clearChanges();
          $scope.uploadLiveSession = false;
        }

        function getSessionNiche(){
            $http({
               url: "api/v1/coursetag/get",
               method: "GET",
               params: {},
            }).then(function (data){
                if (data.data.success) {
                    $scope.sessionNiches = data.data.courseTags.map(function (tag) { return {id: tag.id, name: tag.name}});
                }
            });
        }

        function getSessionCourse(){
            $http({
               url: "api/v1/courses/getAllCourses",
               method: "GET",
               params: {
                  // instructor: instructorPanelService.getInstructorId(),
               },
            }).then(function (data){
                $scope.sessionCourses = data.data.courses;
            });
        }

        $scope.selectSessionType = function(sessionTypeOptions) {
            if(sessionTypeOptions.key === 'SESSION_FOR_NICHE'){
               getSessionNiche()
            }
            else if(sessionTypeOptions.key === 'SESSION_FOR_COURSE'){
               getSessionCourse()
            }
            $scope.selectedSessionType = sessionTypeOptions;
            $scope.showChapterSelection = false;
            $scope.showVideoSelection = false;
        };
        $scope.selectSessionNiche = function(sessionNicheOptions) {
            $scope.selectedSessionCourse = null;
            $scope.selectedSessionModule = null;
            $scope.selectedSessionChapter = null;
            $scope.selectedSessionCVideo = null;
            $scope.showChapterSelection = false;
            $scope.showVideoSelection = false;
           $scope.selectedSessionNiche = sessionNicheOptions;
        };
        $scope.selectVideoNiche = function(sessionNicheOptions) {
            $scope.selectedVideoCourse = null;
            $scope.selectedVideoModule = null;
            $scope.selectedVideoChapter = null;
           $scope.selectedVideoNiche = sessionNicheOptions;

            $http({
                url: "api/v1/courses/tag/"+sessionNicheOptions.id.toString(),
                method: "GET",
                params: {
                    // tag_id: sessionNicheOptions.id,
                    // instructor: instructorPanelService.getInstructorId(),
                },
            }).then(function (data){
                $scope.videoCourses = data.data.courses;
            });
        };
        $scope.selectSessionUserType = function(sessionUserTypeOptions) {
           $scope.selectedSessionUserType = sessionUserTypeOptions;
        };
        $scope.selectSessionCourse = function(sessionCourseOptions) {
            $scope.selectedSessionNiche = null
            $scope.selectedSessionModule = null;
            $scope.selectedSessionChapter = null;
            $scope.selectedSessionCVideo = null;
            $scope.showChapterSelection = false;
            $scope.showVideoSelection = false;

           $scope.selectedSessionCourse = sessionCourseOptions;
           $http({
               url: "api/v1/courses/getModulesByCourseId",
               method: "GET",
               params: {
                  id: sessionCourseOptions.id
               },
            }).then(function (data){
               $scope.sessionModules = data.data.modules;
           });
        };
        $scope.selectVideoCourse = function(sessionCourseOptions) {
            $scope.selectedVideoModule = null;
            $scope.selectedVideoChapter = null;

           $scope.selectedVideoCourse = sessionCourseOptions;
           $http({
               url: "api/v1/courses/getModulesByCourseId",
               method: "GET",
               params: {
                  id: sessionCourseOptions.id
               },
            }).then(function (data){
               $scope.videoModules = data.data.modules;
           });
        };
        $scope.selectSessionModule = function(sessionModuleOptions) {
            $scope.selectedSessionChapter = null;
            $scope.selectedSessionCVideo = null;
            $scope.showVideoSelection = false;

           $scope.selectedSessionModule = sessionModuleOptions;

           $http({
               url: "api/v1/chapter/getChapterByModuleId",
               method: "GET",
               params: {
                  id: sessionModuleOptions.id
               },
            }).then(function (data){
               $scope.sessionChapters = data.data.chapters;
               if(data.data.chapters.length) $scope.showChapterSelection = true;
               else $scope.showChapterSelection = false;
           });
        };
        $scope.selectVideoModule = function(sessionModuleOptions) {
            $scope.selectedVideoChapter = null;
            $scope.videoChapters = [];

           $scope.selectedVideoModule = sessionModuleOptions;

           $http({
               url: "api/v1/chapter/getChapterByModuleId",
               method: "GET",
               params: {
                  id: sessionModuleOptions.id
               },
            }).then(function (data){
               $scope.videoChapters = data.data.chapters;
           });
        };
        $scope.selectSessionChapter = function(sessionChapterOptions) {
            $scope.selectedSessionCVideo = null;

           $scope.selectedSessionChapter = sessionChapterOptions;

           $http({
               url: "api/v1/cvideos/getModuleVideos",
               method: "GET",
               params: {
                  id: sessionChapterOptions.id
               },
            }).then(function (data){
               $scope.sessionCVideos = data.data.videos;
               if(data.data.videos.length) $scope.showVideoSelection = true;
               else $scope.showVideoSelection = false;
           });
        };
        $scope.selectVideoChapter = function(sessionChapterOptions) {
           $scope.selectedVideoChapter = sessionChapterOptions;
        };
        $scope.selectSessionCVideo = function(sessionCVideoOptions) {
           $scope.selectedSessionCVideo = sessionCVideoOptions;
        };

        $scope.uploadInstructorImage = function (image) {
          if (image) {
              if (image.size > 1000000) {
                  return alert('Image size must be less than 1 MB');
              }
            // $scope.showData = false;
            UploadService.uploadImage(image).then(function (data) {
              // $scope.showData = true;
              if(data) {
                  $scope.image_url = data;
              }
              else swal("Error!", "Getting error while uploading picture. Try again!", 'error')
            });
          }
        };

        $scope.uploadThumbnail = function (image) {
          if (image) {
              if (image.size > 1000000) {
                  return alert('Image size must be less than 1 MB');
              }
            // $scope.showData = false;
            UploadService.uploadImage(image).then(function (data) {
              // $scope.showData = true;
              if(data) {
                  $scope.thumbnail_url = data;
              }
              else swal("Error!", "Getting error while uploading thumbnail. Try again!", 'error')
            });
          }
        };

        $scope.saveSession = function () {
            if($scope.selectedSessionType == null) {
                swal({
                    title: "Field required",
                    text: "Kindly select the live session type.",
                    type: "error",
                });
                return;
            }
            if($scope.selectedSessionUserType == null) {
                swal({
                    title: "Field required",
                    text: "Kindly select the live session user type.",
                    type: "error",
                });
                return;
            }
            if($scope.is_custom_form) {
                if(!$scope.customForm.name || !$scope.customForm.description){
                    swal({
                        title: "Field required",
                        text: "Kindly fill all detailed for custom form.",
                        type: "error",
                    });
                    return;
                }
                $scope.customForm.formData = customFormBuilder.actions.getData('json');
            }
            // if($scope.creation_alert){
            //     if(!$scope.push_notification.title || !$scope.push_notification.body){
            //         swal({
            //             title: "Field required",
            //             text: "Kindly fill all detailed for push notification.",
            //             type: "error",
            //         });
            //         return;
            //     }
            //     if(!$scope.email_notification.subject || !$scope.email_notification.body){
            //         swal({
            //             title: "Field required",
            //             text: "Kindly fill all detailed for email notification.",
            //             type: "error",
            //         });
            //         return;
            //     }
            // }
            $scope.push_notification = {
                title: $scope.push_notification.title ? $scope.push_notification.title : null,
                body: $scope.push_notification.body ? $scope.push_notification.body : null
            }
            $scope.email_notification = {
                subject: $scope.email_notification.subject ? $scope.email_notification.subject : null,
                body: $scope.email_notification.body ? $scope.email_notification.body : null
            }
            $http
               .post($scope.edit ? "api/v1/live-session/edit/"+$state.params.id : "api/v1/live-session/create", {
                  "instructor_id": CustomStorageService.getUserInfoStorageData().id,
                  "name": $scope.name,
                  "publish": $scope.publish_live_session,
                  "type": $scope.selectedSessionType.key,
                  "tag_id": $scope.selectedSessionNiche ? $scope.selectedSessionNiche.id : null,
                  "student_type": $scope.selectedSessionUserType.key,
                  "course_id": $scope.selectedSessionCourse? $scope.selectedSessionCourse.id : null,
                  "module_id": $scope.selectedSessionModule ? $scope.selectedSessionModule.id : null,
                  "chapter_id": $scope.selectedSessionChapter ? $scope.selectedSessionChapter.id : null,
                  "video_id": $scope.selectedSessionCVideo ? $scope.selectedSessionCVideo.id : null,
                  "description": $scope.description,
                  "instructor_name": $scope.instructor_name,
                  "instructor_profile": $scope.instructor_profile,
                  "instructor_pic": $scope.image_url ? $scope.image_url : "https://www.nearpeer.org/images/blue-logo.png",
                  "thumbnail": $scope.thumbnail_url ? $scope.thumbnail_url : null,
                  "time": $scope.time,
                  "ex_time": $scope.ex_time,
                  "url_type": $scope.url_type,
                  "url": $scope.url_type == 'NEARPEER' ? null : $scope.url,
                  "creation_alert": $scope.creation_alert,
                  "push_notification": $scope.creation_alert ? $scope.push_notification : null,
                  "email_notification": $scope.creation_alert ? $scope.email_notification : null,
                  "alert_before_in_minutes": $scope.alert_before_in_minutes,
                  "alert_at_time": $scope.alert_at_time,
                  "is_registration_form": $scope.is_registration_form,
                  "allow_chat": $scope.allow_chat,
                  "allow_guest_users": $scope.allow_guest_users,
                  "custom_form": $scope.is_custom_form && $scope.customForm.name && $scope.customForm.description ? $scope.customForm : null,
                  "is_custom_form": $scope.is_custom_form && $scope.customForm.name && $scope.customForm.description ? true : false,
                   "show_registration_form_after_min": $scope.show_registration_form_after_min > 0 ? $scope.show_registration_form_after_min : 0,
                   "show_custom_form_after_min": $scope.show_custom_form_after_min > 0 ? $scope.show_custom_form_after_min : 0,
                   "is_custom_form_mandatory": $scope.is_custom_form_mandatory,
                   "is_registration_form_mandatory": $scope.is_registration_form_mandatory,
              })
               .then(function (data) {
               $scope.showData = true;
               if (data.data.success) {
                  swal({
                     title: "Success",
                     text: "Live Session Successfully "+($scope.edit ? "Updated" : "Created"),
                     type: "success",
                  });
                  $state.go("InstructorPanelLiveSession", {}, { reload: true });
               } else {
                  swal({
                     title: "Error",
                     text: data.data.message,
                     type: "error",
                  });
               }
            });
        };

          $scope.initialize = function () {
              try{
                  $http({
                      url: "api/v1/live-session/" + $state.params.id,
                      method: "GET",
                      params: {},
                  }).then( function (live_session) {
                      if (live_session.data.success) {
                          $scope.name = live_session.data.session.name;
                          $scope.selectedSessionType = $scope.sessionTypes.find(function(item) {
                              return item.key === live_session.data.session.type;
                          });
                          $scope.selectedSessionUserType = $scope.sessionUserTypes.find(function(item) {
                              return item.key === live_session.data.session.student_type;
                          });
                          $scope.description = live_session.data.session.description;
                          $scope.instructor_name = live_session.data.session.instructor_name;
                          $scope.instructor_profile = live_session.data.session.instructor_profile;
                          $scope.image_url = live_session.data.session.instructor_pic;
                          $scope.thumbnail_url = live_session.data.session.thumbnail;

                          var userTimezoneOffset = new Date(live_session.data.session.time);
                          // console.log("userTimezoneOffset", userTimezoneOffset);
                        //   var userLocalDate = new Date(live_session.data.session.time)
                          // console.log("userLocalDate", userLocalDate)
                        //   userLocalDate.setMinutes(userLocalDate.getMinutes() - userTimezoneOffset);
                          // console.log("user time final", userLocalDate)
                          $scope.time = userTimezoneOffset;
                          $scope.ex_time = userTimezoneOffset;

                          $scope.session_status = live_session.data.session.status;
                          $scope.publish_live_session = live_session.data.session.status != 'DRAFT';
                          $scope.url_type = live_session.data.session.url_type;
                          $scope.url = live_session.data.session.url;
                          $scope.creation_alert = live_session.data.session.creation_alert;
                          $scope.push_notification = live_session.data.session.push_notification ? live_session.data.session.push_notification : {
                              title: null,
                              body: null
                          };
                          $scope.email_notification = live_session.data.session.email_notification ? live_session.data.session.email_notification : {
                              subject: null,
                              body: null
                          };
                          $scope.alert_before_in_minutes = live_session.data.session.alert_before_in_minutes;
                          $scope.alert_at_time = live_session.data.session.alert_at_time;
                          $scope.allow_chat = live_session.data.session.allow_chat;
                          $scope.allow_guest_users = live_session.data.session.allow_guest_users;
                          $scope.is_custom_form_mandatory = live_session.data.session.is_custom_form_mandatory;
                          $scope.is_registration_form_mandatory = live_session.data.session.is_registration_form_mandatory;
                          $scope.show_custom_form_after_min = live_session.data.session.show_custom_form_after_min;
                          $scope.show_registration_form_after_min = live_session.data.session.show_registration_form_after_min;
                          $scope.is_custom_form = !!live_session.data.session.is_custom_form;
                          if(!!live_session.data.session.is_custom_form && !!live_session.data.session.custom_form_id) {
                              $scope.customForm = {
                                  id: live_session.data.session.custom_form_id.id,
                                  name: live_session.data.session.custom_form_id.form_name,
                                  description: live_session.data.session.custom_form_id.form_description,
                                  formData: live_session.data.session.custom_form_id.form_data,
                              };
                              const customFormBuilderIntervalId = setInterval(function () {
                                  if(customFormBuilder !== null) {
                                      customFormBuilder.actions.setData(JSON.stringify(live_session.data.session.custom_form_id.form_data));
                                      clearInterval(customFormBuilderIntervalId);
                                  }
                              }, 5000);
                          }
                          $scope.is_registration_form = !!live_session.data.session.is_registration_form;
                          if(live_session.data.session.type == 'SESSION_FOR_NICHE'){
                              $http({
                                  url: "api/v1/coursetag/get",
                                  method: "GET",
                                  params: {},
                              }).then(function (data){
                                  if (data.data.success) {
                                      $scope.sessionNiches = data.data.courseTags.map(function (tag) { return {id: tag.id, name: tag.name}});
                                      $scope.selectedSessionNiche = $scope.sessionNiches.find(function(item) {
                                          return item.id === live_session.data.session.tag_id;
                                      });
                                  }
                                  $scope.showData = true;
                              });
                          }
                          else if(live_session.data.session.type == 'SESSION_FOR_COURSE'){
                              $http({
                                  url: "api/v1/courses/getAllCourses",
                                  method: "GET",
                                  params: {
                                      // instructor: instructorPanelService.getInstructorId(),
                                  },
                              }).then(function (data){
                                  $scope.sessionCourses = data.data.courses;
                                  $scope.selectedSessionCourse = $scope.sessionCourses.find(function(item) {
                                      return item.id === live_session.data.session.course_id;
                                  });

                                  if($scope.selectedSessionCourse){
                                      $http({
                                          url: "api/v1/courses/getModulesByCourseId",
                                          method: "GET",
                                          params: {
                                              id: $scope.selectedSessionCourse.id
                                          },
                                      }).then(function (data){
                                          $scope.sessionModules = data.data.modules;
                                          $scope.selectedSessionModule = $scope.sessionModules.find(function(item) {
                                              return item.id === live_session.data.session.module_id;
                                          });

                                          if($scope.selectedSessionModule){
                                              $http({
                                                  url: "api/v1/chapter/getChapterByModuleId",
                                                  method: "GET",
                                                  params: {
                                                      id: $scope.selectedSessionModule.id
                                                  },
                                              }).then(function (data){
                                                  $scope.sessionChapters = data.data.chapters;
                                                  $scope.selectedSessionChapter = $scope.sessionChapters.find(function(item) {
                                                      return item.id === live_session.data.session.chapter_id;
                                                  });

                                                  if($scope.selectedSessionChapter){
                                                      $http({
                                                          url: "api/v1/cvideos/getModuleVideos",
                                                          method: "GET",
                                                          params: {
                                                              id: $scope.selectedSessionChapter.id
                                                          },
                                                      }).then(function (data){
                                                          $scope.sessionCVideos = data.data.videos;
                                                          $scope.selectedSessionCVideo = $scope.sessionCVideos.find(function(item) {
                                                              return item.id === live_session.data.session.video_id;
                                                          });
                                                          $scope.showData = true;
                                                      });
                                                  }
                                                  else $scope.showData = true;
                                              });
                                          }
                                          else $scope.showData = true;
                                      });
                                  }
                                  else $scope.showData = true;
                              });
                          }
                          else $scope.showData = true;
                      }
                  });
              }
              catch (e){
                  $scope.showData = true;
                  swal("Error!", e.message, 'error')
              }
          };
          var sessionYoutubeData;
          var getLiveSessionYoutubeData = function() {
            $http({
                url: env.videoMigrationMicroServicePath  + 's3totovimeomigration/v1/upload/get-youtube-live-session/' + $state.params.id,
                method: "GET",
                params: {},
            }).then(function (data){
                if(data.data.success && data.data.session) {
                    $scope.youtubeLink = data.data.session.youtube_link;
                    $scope.email=data.data.session.email;
                    sessionYoutubeData = data.data.session;
                }
            });
          }

          if($state.params.id){
              $scope.edit = true;
              $scope.initialize();

              var openParam = $location.search().open;
              if (angular.isDefined(openParam) && openParam === 'uploadVideo') {
                  console.log('The "open" query parameter is set to "uploadVideo"');
                  $scope.openUploadVideoModal()
                  getLiveSessionYoutubeData();
              }
          }
          else $scope.showData = true;

          $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
              // Check if there are unsaved changes or any other condition that requires confirmation
              if ($scope.uploadLiveSession) {
                  console.log('stateChangeStart')
                  // Display a confirmation dialog
                  if (!$window.confirm('You have unsaved changes. Are you sure you want to leave this page?')) {
                      event.preventDefault(); // Prevent the state change
                  }
              }else
                  console.log('stateChangeStart 2')
          });
          window.addEventListener('beforeunload', function(event) {
              // Display a confirmation dialog
              if($scope.uploadLiveSession) event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
          });


          $scope.initializeFormBuilder();

          $http({
              url: "api/v1/coursetag/get",
              method: "GET",
              params: {},
          }).then(function (data){
              if (data.data.success) {
                  $scope.videoNiches = data.data.courseTags.map(function (tag) { return {id: tag.id, name: tag.name}});
              }
          });



          // Video uploading feature starting from here
          $scope.socket = new Object();
          $scope.socketID = '';
          $(document).ready(function(){
              $(this).scrollTop(0);
              $scope.socket = videoSocket;
          });
          $scope.socket.on('connect', function () {
              $scope.socketID = $scope.socket.io.engine.id;
                        });
          $scope.socket.on('new_connection', function (data) {
                            $scope.socketID = data;
          });
          $scope.socket.on('disconnect', function(){
              showSocketDisconnectMessage();
          });
          function showSocketDisconnectMessage(){
              var displayPopup = false;
              var anyVideoUploadingToServer = false;
              if($scope.uploadingVideos.length){
                  $scope.uploadingVideos.forEach(function(video) {
                      if(video.uploaded == false) {
                          displayPopup = true;
                      }
                      if(!video.serverLog) {
                          anyVideoUploadingToServer = true;
                      }
                  });
                  if(displayPopup){
                      if(anyVideoUploadingToServer){
                          setTimeout(function(){showSocketDisconnectMessage()}, 2000)
                      }else{
                          swal('Socket connection disconnected','Real time progress lost please refresh to get updated progress');
                      }
                  }
              }
          }

          $rootScope.online = navigator.onLine;
          $window.addEventListener("offline", function () {
              $rootScope.$apply(function() {
                  $rootScope.online = false;
                  swal('Oops..','Internet connection lost!','error');
              });
          }, false);
          $window.addEventListener("online", function () {
              $rootScope.$apply(function() {
                  $rootScope.online = true;
                  swal('Internet Connected!','Internet connected successfully','success');
                  if($window.location.href.includes('/instructor_panel/video/module/')||$window.location.href.includes('/instructor_panel/video/chapter/')){
                      $window.location.reload();
                  }
              });
          }, false);
          $scope.check = false;
          $window.addEventListener("unload", function () {

          }, false);

          window.onbeforeunload = function(event) {
              if(event.currentTarget.location.pathname.includes('/instructor_panel/video/module/')||event.currentTarget.location.pathname.includes('/instructor_panel/video/chapter/')){
                  $scope.check = false;
                  var itemsProcessed = 0;
                  for(var i in $scope.uploadingVideos){
                      if($scope.uploadingVideos[i].serverLog<100){
                          $scope.check = true;
                      }
                      itemsProcessed++;
                      if(itemsProcessed===$scope.uploadingVideos.length){
                          if($scope.check){
                              return 'Uploading in progress...';
                          }
                      }
                  }
              }
              $sails.get('/api/v1/sockets/clearSocket',{userId:CustomStorageService.getUserInfoStorageData().id})
                  .then(function(res){})
          }

          $scope.clearChanges = function (){
              $scope.uploadingAttachments = [];
              var videosToRemove = $scope.uploadingVideos.filter(function(v){return v.vss_id}).map(function(v){return v.vss_id});
              $http.post('/api/v1/cvideos/delete-temp-videos/', videosToRemove)
              clearVideosProgressFromDB();
              $scope.clearThisModuleLocalStorage();
          }

          $scope.clearThisModuleLocalStorage = function(){
              var videoData = CustomStorageService.getVideoUploadingStateForLiveSession();
              if(videoData!==false && videoData !== null && videoData !== undefined && videoData.length>0){
                  var result = videoData.filter(function(val) {
                      if (val.module_url===$window.location.href)
                          return false;
                      return true;
                  });
                  CustomStorageService.setVideoUploadingStateForLiveSession(result);
                  location.reload();
              }
          }
          function setErrorToVideo(count, module_url){
              var videoData = CustomStorageService.getVideoUploadingStateForLiveSession();
              var videoIndex = videoData.findIndex(function(ele){return(ele.no==count && ele.module_url == module_url)})
              videoData[videoIndex].error = true;
              CustomStorageService.setVideoUploadingStateForLiveSession(videoData);

          }
          var saveStatusToLocalStorage = function() {
              if($window.location.href.includes('/instructor_panel/edit-live-session/')){
                  var videoData = CustomStorageService.getVideoUploadingStateForLiveSession();
                  if(videoData !==false && videoData !== null && videoData !== undefined && videoData.length>0){
                      var itemsProcessed = 0;
                      var videoDataCopy = JSON.stringify(videoData);
                      videoDataCopy = JSON.parse(videoDataCopy);
                      setTimeout(function () {
                          angular.forEach($scope.toUpload, function(video, i) {
                              videoData.push(video);
                              itemsProcessed++;
                              if(itemsProcessed===$scope.toUpload.length){
                                  $scope.toUpload = [];
                                  CustomStorageService.setVideoUploadingStateForLiveSession(videoData);
                              }
                          });
                      }, 500)

                  }else{
                      setTimeout(function () {
                          CustomStorageService.setVideoUploadingStateForLiveSession($scope.uploadingVideos);
                          $scope.toUpload = [];
                      }, 500)
                  }
              }
          }

          var getVideoByNo = function getVideoByNo(no) {
              return $scope.uploadingVideos.find(function (video) {
                  return video.no == no;
              });
          };

          var isValidEmail=function(email) {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            }

          $scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();

          $scope.initializeVideo = function(){
              $scope.s3Duplicates = [];
              $scope.vimeoDuplicates = [];
              $scope.counter = 1;
              $scope.uploadLog = [];
              $scope.showData = false;
              $scope.uploadedVideos = [];
              $scope.uploadingVideos = [];
              $scope.appendingStringVideos = []
              $scope.toUpload = []
              $scope.value = -1;
              var data ={
                  id: $state.params.id,
                  instructor_id: instructorPanelService.getInstructorId()
              }
              if($state.params.state == 'module'){
                  $scope.editingModule = true;
                  $scope.editingChapter = false;
                  data['type'] = 1;
              } else if($state.params.state == 'chapter'){
                  $scope.editingChapter = true;
                  $scope.editingModule = false;
                  data['type'] = 2;
              }

              $http({
                  url: 'api/v1/cvideos/getVideosById',
                  method: "GET",
                  params: data
              }).then(function(data){
                  if(data.data.success){
                      $scope.showData = true;
                      $scope.videos = data.data.videos;
                  } else {
                      $scope.videos = [];
                      $scope.showData = true;
                  }
              });
              var videoData = CustomStorageService.getVideoUploadingStateForLiveSession();
              setTimeout(function() {
                  if(videoData!==false && videoData !== null && videoData !== undefined && videoData.length>0){
                      var itemsProcessed = 0;
                      angular.forEach(videoData, function(video, key) {
                          if(video.module_url===$window.location.href && !video.error){
                              video.serverLog = 100;
                              $scope.uploadingVideos.push(video);
                          }else{
                              video.s3Log = 0;
                              video.jobLog = 0;
                              $scope.uploadingVideos.push(video);
                          }

                          itemsProcessed++;
                          if(itemsProcessed===videoData.length){
                              var max = videoData.reduce(function (prev, current) {
                                  return (prev.no > current.no) ? prev : current
                              });
                              $scope.counter = max.no+1;
                          }
                      });
                  }
              }, 400)

              var dropDownData = CustomStorageService.getVideoUploaderDropdownState();
              if(dropDownData!==false && dropDownData !== null && dropDownData !== undefined){
                  $scope.toVimeo = dropDownData.toVimeo;
                  $scope.toS3 = dropDownData.toS3;
                  $scope.btnText = dropDownData.btnText;
              }

              setTimeout(function(){
                  $http({
                      url:'/api/v1/sockets/getInstructorVideosTrack',
                      method: "GET",
                      params:{userId:CustomStorageService.getUserInfoStorageData().id}})
                      .then(function(res){
                          var data = res.data.data;
                          if(data!=='null'){
                              angular.forEach(data, function(element, key) {
                                  var video = element.video;
                                  if(video.module_url === $window.location.href){
                                      if(video.server==='vimeo'){
                                          $scope.jobVimeoCompleted(video);
                                      }else{
                                          $scope.jobS3Completed(video);
                                      }
                                  }
                              });
                          }
                      })
              },500);
          }


          $scope.setValue = function(index){
              if(index == $scope.value){
                  $scope.value = -1;
              } else {
                  $scope.value = index;
              }
          }

          var clearVideosProgressFromDB = function (videoNo){
              var data = {module_url:$window.location.href,userId:CustomStorageService.getUserInfoStorageData().id};
              if(videoNo) {
                  data.videoNo = videoNo
              }
              $http({
                  url: '/api/v1/sockets/clearInstructorVideosTrack',
                  method: "GET",
                  params:data})
                  .then(function(res){})
          }

          $scope.uploadingAttachments = [];


          $scope.saveData = function(youtubeLink,email){
            console.log(youtubeLink,email);

            if(sessionYoutubeData && sessionYoutubeData.upload_status !== 'pending') {
                swal('Error',"Video is Already uploaded you can't change it now",'error');
                return false;
            } 
            if(!$scope.selectedVideoModule){
                swal('Error','Course Module is required','error');
                return false;
            }
            if($scope.videoChapters.length > 0 && !$scope.selectedVideoChapter){
                swal('Error','Module Chapter is required','error');
                return false;
            }
            if(!youtubeLink) {
                swal('Error','Please enter valid youtube link.');
                return false;
            }
            if(!email) {
                swal('Error','Please enter email');
                return false;
            }
            if (!isValidEmail(email)) {
                swal('Error', 'Please enter a valid email address');
                return false;
            }
            

            var chapter_id;
            if($scope.selectedVideoChapter && $scope.selectedVideoChapter.id) {
                chapter_id = $scope.selectedVideoChapter.id
            }
              
              var data = {
                youtube_link: youtubeLink,
                email:email,
                module_id: $scope.selectedVideoModule.id,
                chapter_id: chapter_id,
                course_id: $scope.selectedVideoCourse.id,
                live_session_id: $state.params.id
              }



              $scope.showData = false;
              $http.post( env.videoMigrationMicroServicePath  + 's3totovimeomigration/v1/upload/add-youtube-live-session',data)
                  .then(function(data){
                      $scope.showData = true;   
                      if(data.data.success){
                          $scope.uploadLiveSession = false;
                          clearVideosProgressFromDB();
                          $scope.clearThisModuleLocalStorage();
                          swal({
                              title: 'Success',
                              text: 'Youtube link saved',
                              type: 'success',
                              timer:2000,
                              showCancelButton: false,
                              showConfirmButton: false
                          },function(){
                            swal.close()
                          });
                      } else {
                          instructorPanelService.tryAgainSwal();
                      }
                  }).catch(function() {
                    $scope.showData = false;   
                  })
            }

          var videoNameExpression = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]+\.mp4$/;
          var videoNameExpression2 = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]$/;
          $scope.toVimeo = true;
          $scope.toS3 = false;
          $scope.btnText = 'Uploading to both';
          $scope.removeItem= function(index){
              var toDeleteVideo = $scope.uploadingVideos[index];
              if($window.location.href.includes('/instructor_panel/edit-live-session')){
                  var videoData = CustomStorageService.getVideoUploadingStateForLiveSession();
                  if(videoData !==false && videoData !== null && videoData !== undefined && videoData.length>0){
                      if(toDeleteVideo.vss_id){
                                                    $http.get('api/v1/cvideos/delete-temp-video/'+toDeleteVideo.vss_id);
                      }
                      var videoDataCopy = JSON.stringify(videoData);
                      videoDataCopy = JSON.parse(videoDataCopy);
                      angular.forEach(videoDataCopy, function(video, i) {
                          if(video.name === toDeleteVideo.name && video.server === toDeleteVideo.server && video.module_url === toDeleteVideo.module_url) {
                              videoData.splice(i, 1);
                          }
                      });
                      CustomStorageService.setVideoUploadingStateForLiveSession(videoData);
                      $scope.uploadingVideos.splice(index, 1);
                      clearVideosProgressFromDB(toDeleteVideo.no);
                  }else{
                      setTimeout(function () {
                          CustomStorageService.setVideoUploadingStateForLiveSession($scope.uploadingVideos);
                      }, 3000)

                  }
              }
          }

          var updateProgress = function(name) {
              setTimeout(function() {
                  $scope.uploadingAttachments.forEach(function(attachment) {
                      if(attachment.name === name && attachment.log < 80) {
                          attachment.log = attachment.log + 5;
                          $scope.$apply();
                          updateProgress(name);
                      }
                  });
              }, 800)
          }

          $scope.uploadAttachments= function(files,type){
              if(files){
                  for (var i = 0; i < files.length; i++) {
                      if(files[i].type==='application/pdf' || files[i].file.type==='application/pdf') {
                      }
                      else {
                          swal('Oops..','Please attachment in .pdf','error');
                          return false;
                      }
                      // if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
                      // } else {
                      // 	swal('Oops..','Please upload video in aplha numeric','error');
                      // 	return false;
                      // }
                  }
                  var readres = [];
                  for(var i in files){
                      var name = files[i].name;
                      var tmp = name.split('.pdf');
                      name = tmp[0];
                      readres[i] = new FileReader();
                      readres[i].readAsBinaryString(files[i]);
                      readres[i].onloadend = function () {
                          const count = readres[i].result.match(/\/Type[\s]*\/Page[^s]/g).length;
                          var nameL = files[i].name;
                          var tmpL = name.split('.pdf');
                          nameL = tmpL[0];
                          $scope.uploadingAttachments.forEach(function(att) {
                              if(att.name === nameL) {
                                  att.page_count = count;
                              }
                          })
                      }
                      var notesData = {
                          name: name,
                          status: 'uploading',
                          log: 0,
                          module_id: $state.params.module_id,
                      }
                      if($state.params.state === 'chapter') {
                          notesData.chapter_id = $scope.selectedVideoChapter.id;
                      }
                      $scope.uploadingAttachments.push(notesData);
                      updateProgress(name);
                      uploadAttachmentFile(name, files[i])
                  }


              }
          }

          var uploadAttachmentFile = function(name, file) {
              Upload.upload({
                  url: '/api/v1/uploader/uploadVideoAttachmentToS3?module_id='+$state.params.module_id+'&userId='+instructorPanelService.getInstructorId()+'&no='+$scope.counter+'&socket_id='+CustomStorageService.getUserInfoStorageData().id,
                  method: "POST",
                  file: file
              }).then(function(data){
                  var link = data.data.link;
                  $scope.uploadingAttachments.forEach(function(attachment) {
                      if(name == attachment.name) {
                          attachment.url = link;
                          attachment.status = 'uploaded';
                          attachment.log = 100;
                      }
                  });
              });
          }

          $scope.uploadVideoss= function(files,type, video){
              if(!$scope.selectedVideoModule){
                  swal('Oops..','Please select Module','error');
                  return false;
              }
              var notesFiles = [];
              var videoFiles = [];

              files.forEach(function(file) {
                                    if(file.type==='application/pdf' || (file.file && file.file.type==='application/pdf')) {
                      if(file.type) {
                          notesFiles.push(file);
                      } else if (file.file) {
                          notesFiles.push(file.file);
                      }
                  } else {
                      videoFiles.push(file)
                  }
              });
              if(notesFiles.length > 0){
                  $scope.uploadAttachments(notesFiles);
              }
              if(videoFiles.length > 0){
                  $scope.filess = videoFiles;
                  $scope.uploadVideosToVimeo(files,type, video);

                  // if(!$scope.toVimeo && $scope.toS3){
                  //     $scope.uploadVideos(files,type, video);
                  // }else if($scope.toVimeo && !$scope.toS3){
                  //     $scope.uploadVideosToVimeo(files,type, video);
                  // }else{
                  //     $scope.uploadVideos(files,type, video);
                  //     $scope.uploadVideosToVimeo(files,type, video);
                  // }
              }
          }
          $scope.uploadVideos = function(files,type, video){
              $scope.s3Duplicates = [];
              if(files){
                  for (var i = 0; i < files.length; i++) {
                      if(files[i].type==='video/mp4' || files[i].file.type==='video/mp4') {
                      }
                      else {
                          swal('Oops..','Please upload video in .mp4','error');
                          return false;
                      }
                      if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
                      } else {
                          swal('Oops..','Please upload video in aplha numeric','error');
                          return false;
                      }
                  }
                  for(var i in files){
                      var name = files[i].name;
                      var tmp = name.split('.mp4');
                      name = tmp[0];
                      var obj = {
                          no: $scope.counter,
                          name: name,
                          serverLog: 0,
                          s3Log: 0,
                          jobLog: 0,
                          error: false,
                          url: '',
                          url_mpd: '',
                          image_url: 'https://nearpeerazblobaccount.blob.core.windows.net/awss3data/nearpeer-imagees/thumb-1.jpg',
                          uploaded: false,
                          server: 'S3',
                          module_url: $window.location.href,
                          video_id: video ? video.id : undefined,
                      }
                      if($scope.toVimeo&&$scope.toS3){
                          obj.isBoth = true;
                          obj.isSame = $scope.counter;
                      }
                      $scope.counter++;
                      checkDuplicationForS3(files[i],obj,type,i).then(function (value) {
                                                });
                  }
              }
          };
          $scope.uploadVideosToVimeo = function(files,type, video){
              $scope.vimeoDuplicates = [];
              if(files){
                  for (var i = 0; i < files.length; i++) {
                      if(files[i].type==='video/mp4' || files[i].file.type==='video/mp4') {
                      }
                      else {
                          swal('Oops..','Please upload video in .mp4','error');
                          return false;
                      }
                      if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
                      } else {
                          swal('Oops..','Please upload video in aplha numeric','error');
                          return false;
                      }
                  }
                  for(var i in files){
                      var name = files[i].name;
                      var tmp = name.split('.mp4');
                      name = tmp[0];
                      // name = name +'-'+files[i].size+'-'+date;
                      var obj = {
                          no: $scope.counter,
                          name: name,
                          serverLog: 0,
                          s3Log: 0,
                          jobLog: 0,
                          error: false,
                          url: '',
                          url_mpd: '',
                          image_url: 'https://nearpeerazblobaccount.blob.core.windows.net/awss3data/nearpeer-imagees/thumb-1.jpg',
                          uploaded: false,
                          server: 'Vimeo',
                          module_url: $window.location.href,
                          video_id: video ? video.id : undefined,
                      }
                      if($scope.toVimeo&&$scope.toS3){
                          obj.isBoth = true;
                          obj.isSame = $scope.counter-1;
                      }
                      $scope.counter++;
                      $scope.checkDuplicationForVimeo(files[i],obj,type,i).then(function (value) {
                                                })
                  }
              }
          };
          var checkDuplicationForS3 = function(file,obj,type,index){
              return new Promise(function(resolve) {
                  setTimeout(function(){
                      if($scope.uploadingVideos.length>0){
                          var notDup = true;
                          var itemsProcessed = 0;
                          var nowAddingVideos  = [];
                          var fileNameArr = file.name.split('.');
                          fileNameArr.splice(fileNameArr.length-1,1);
                          var fileName = fileNameArr.join('.');
                          for(i in $scope.uploadingVideos){
                              if(fileName === $scope.uploadingVideos[i].name && $scope.uploadingVideos[i].server===obj.server && $scope.uploadingVideos[i].module_url===obj.module_url){
                                  var fileData = file.name+'-'+obj.server+'-'+obj.module_url;
                                  if(!nowAddingVideos.includes(fileData)){
                                      nowAddingVideos.push(fileData);
                                      notDup = false;
                                      $scope.s3Duplicates.push(obj);
                                  }
                              }
                              itemsProcessed++;
                              if(itemsProcessed === $scope.uploadingVideos.length) {
                                  if(notDup){
                                      $scope.sendForUpload(obj,type,file, index);
                                      resolve(true);
                                  }else{
                                      swal({
                                          title: 'S3 Error',
                                          text: 'You were uploading duplicate video(s) to S3!',
                                          type: 'error',
                                          showCancelButton: false,
                                          showConfirmButton: true
                                      },function(){
                                          // location.reload();
                                      });
                                      resolve(true);
                                  }

                              }
                          }
                      }else{
                          $scope.sendForUpload(obj,type,file, index);
                          resolve(true);
                      }
                  },500);
              });
          }
          $scope.checkDuplicationForVimeo = function(file,obj,type,index){
              return new Promise(function(resolve) {
                  setTimeout(function(){
                      if($scope.uploadingVideos.length>0){
                          var notDup = true;
                          var itemsProcessed = 0;
                          var nowAddingVideos  = [];
                          angular.forEach($scope.uploadingVideos, function(video, key) {
                              var fileNameArr = file.name.split('.');
                              fileNameArr.splice(fileNameArr.length-1,1);
                              var fileName = fileNameArr.join('.');
                              if(fileName == video.name && video.server==obj.server && video.module_url==obj.module_url){
                                  var fileData = file.name+'-'+obj.server+'-'+obj.module_url;
                                  if(!nowAddingVideos.includes(fileData)){
                                      nowAddingVideos.push(fileData);
                                      notDup = false;
                                      $scope.vimeoDuplicates.push(obj);
                                  }
                              }
                              itemsProcessed++;
                              if(itemsProcessed === $scope.uploadingVideos.length) {
                                  if(notDup){
                                      $scope.sendForUploadToVimeo(obj,type,file,index);
                                      resolve(true);
                                  }else{
                                      swal({
                                          title: 'Vimeo Error',
                                          text: 'You were uploading duplicate video(s) to Vimeo!',
                                          type: 'error',
                                          showCancelButton: false,
                                          showConfirmButton: true
                                      },function(){
                                          // location.reload();
                                      });
                                      resolve(true);
                                  }
                              }
                          });
                      }else{
                          $scope.sendForUploadToVimeo(obj,type,file,index);
                          resolve(true);
                      }
                  },500);
              });
          }
          $scope.sendForUpload  = function (obj,type,file, index){
              $scope.toUpload.push(obj);
              $scope.uploadingVideos.push(obj);
              if(type == 'click'){
                  $scope.uploadVideo(file,obj.no);
              } else {
                  $scope.uploadVideo(file.file,obj.no);
              }
              setTimeout(function () {
                  saveStatusToLocalStorage();
              }, 500 + (100 * index))



          }
          $scope.sendForUploadToVimeo  = function (obj,type,file,index){
              $scope.toUpload.push(obj);
              $scope.uploadingVideos.push(obj);
              if(type == 'click'){
                  $scope.uploadVideoToVimeo(file,obj.no);
              } else {
                  $scope.uploadVideoToVimeo(file.file,obj.no);
              }
              setTimeout(function () {
                  saveStatusToLocalStorage();
              }, 500 + (100 * index))
          }
          $scope.uploadVideoToVimeo = function(file,no){
              var date = new Date();
              date =$filter('date')(date,'MM-dd-yyyy-h:mma');
              var appendingString =file.size+'-'+date
              $scope.appendingStringVideos.push(appendingString);
              if(file && file.name.length < 110){
                  var data = {
                      userId: instructorPanelService.getInstructorId(),
                      count: no,
                      file: file.name,
                      chapter_id:$scope.selectedVideoChapter ? $scope.selectedVideoChapter.id : null,
                      isModule: $scope.editingModule?'yes':'no',
                      socket_id: $scope.socketID,
                      appendingString: appendingString,
                      module_url: $window.location.href,
                      module_id: $scope.selectedVideoModule ? $scope.selectedVideoModule.id : null,
                  };
                  Upload.upload({
                      url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/video-to-vimeo',
                      method: 'POST',
                      file:file,
                      params: data
                  }).then(function(data){
                                                if(data.data.success===true) {
                              var video = getVideoByNo(no);
                              if(video){
                                  video.s3Log = 100;
                                  CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                              }
                              if(!$scope.$$phase) $scope.$apply();
                          }
                          else if(data.data.success===false) {
                              swal({
                                  title: 'Error',
                                  text: 'Server Error!!',
                                  type: 'error',
                                  showCancelButton: false,
                                  showConfirmButton: true
                              },function(){
                                  // location.reload();
                              });
                          }
                      },
                      function(error) {
                                                      var video = getVideoByNo(no);
                          if(video){
                              video.error = true;
                              if(!$scope.$$phase) $scope.$apply();
                              swal(
                                  {
                                      title: "Error",
                                      text:
                                          error.data && error.data.message
                                              ? error.data.message.includes(
                                                  "Internal Server Error"
                                              ) || error.data.includes("html")
                                                  ? error.data.includes("timeout")
                                                      ? "Server timeout (try uploading less videos)"
                                                      : error.message
                                                  : error.data.message
                                              : error.data
                                                  ? "Internal Server Error"
                                                  : "your internet connection is unstable please try again later",
                                      type: "error",
                                      showCancelButton: false,
                                      showConfirmButton: true,
                                  },
                                  function () {
                                      // location.reload();
                                  }
                              );
                              setErrorToVideo(video.no, video.module_url)

                          }
                      },
                      function(evt) {
                          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                          var video = getVideoByNo(no);
                          if(video){
                              video.serverLog = progressPercentage;
                              CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                          }
                      }
                  )
              }else{
                  if(file.name.length >= 110){
                      swal({
                          title: 'Error',
                          text: 'file name should be less then 110 characters',
                          type: 'error',
                          showCancelButton: false,
                          showConfirmButton: true
                      },function(){
                          // location.reload();
                      });
                  }
              }
          }
          $scope.uploadVideo = function(file,no){
              var date = new Date();
              date =$filter('date')(date,'MM-dd-yyyy-h:mma');
              var appendingString =file.size+'-'+date
              $scope.appendingStringVideos.push(appendingString);
              if(file && file.name.length < 110){
                  var data = {
                      userId: instructorPanelService.getInstructorId(),
                      count: no,
                      file: file.name,
                      chapter_id:$scope.selectedVideoChapter ? $scope.selectedVideoChapter.id : null,
                      isModule: $scope.editingModule?'yes':'no',
                      socket_id: $scope.socketID,
                      appendingString:appendingString,
                      module_url: $window.location.href
                  };
                  Upload.upload({
                      url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/video-to-s3',
                      method: 'POST',
                      file:file,
                      params: data
                  }).then(function(data){
                          if(data.data.status==='success') {
                              var video = getVideoByNo(no);
                              if(video){
                                  video.s3Log = 100;
                              }
                              if(!$scope.$$phase) $scope.$apply();
                          }
                          else if(data.data.success===false) {
                              var video = getVideoByNo(no);
                              if(video){
                                  video.error = true;
                                  swal({
                                      title: 'Error',
                                      text: 'Server Error!!',
                                      type: 'error',
                                      showCancelButton: false,
                                      showConfirmButton: true
                                  },function(){
                                      // location.reload();
                                  });
                              }
                          } else {
                              var video = getVideoByNo(no);
                              if(video){
                                  video.error = true;
                                  swal({
                                      title: 'Error',
                                      text: data.data.success,
                                      type: 'error',
                                      showCancelButton: false,
                                      showConfirmButton: true
                                  },function(){
                                      // location.reload();
                                  });
                              }
                          }
                          CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                      },
                      function(error) {
                          var video = getVideoByNo(no);
                          if(video){
                              video.error = true;
                              swal(
                                  {
                                      title: "Error",
                                      text:
                                          error.data && error.data.message
                                              ? error.data.message.includes(
                                                  "Internal Server Error"
                                              ) || error.data.includes("html")
                                                  ? error.data.includes("timeout")
                                                      ? "Server timeout (try uploading less videos)"
                                                      : error.message
                                                  : error.data.message
                                              : error.data
                                                  ? "Internal Server Error"
                                                  : "your internet connection is unstable please try again later",
                                      type: "error",
                                      showCancelButton: false,
                                      showConfirmButton: true,
                                  },
                                  function () {
                                      // location.reload();
                                  }
                              );
                              setErrorToVideo(video.no, video.module_url)
                          }
                          if(!$scope.$$phase) $scope.$apply();
                          CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                          // saveStatusToLocalStorage()
                      },
                      function(evt) {
                          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                          var video = getVideoByNo(no);
                          if(video){
                              video.serverLog = progressPercentage;
                          }
                          CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                      }
                  )
              }else{
                  if(file.name.length >= 110){
                      swal({
                          title: 'Error',
                          text: 'file name should be less then 110 characters',
                          type: 'error',
                          showCancelButton: false,
                          showConfirmButton: true
                      },function(){
                          // location.reload();
                      });
                  }
              }
          }

          $scope.deleteAttachement = function(attachment,index,index2){
              $scope.showData = false;
              Upload.upload({
                  url: '/api/v1/uploader/deleteVideoAttachment',
                  method:"POST",
                  params:{
                      url:attachment.url,
                      module_name:$scope.module_name,
                      video_name:$scope.video_name,
                      video_id:$scope.video_id,
                      module_id:$scope.module_id
                  }
              }).then(function(data){
                  if(data.data.success){
                      var data = {
                          id: attachment.id
                      }
                      $http.post('api/v1/attachments/deleteAttachment',data)
                          .then(function(data){
                              if(data.data.success){
                                  $scope.showData = true;
                                  $scope.videos[index].attachments.splice(index2,1);

                                  $http({
                                      url: '/api/v1/uploader/zipVideoAttachments',
                                      method: "POST",
                                      params: {module_name:$scope.module_name,video_name:$scope.video_name,video_id:$scope.video_id,module_id:$scope.module_id,createFirst:false}
                                  });
                              } else {
                                  instructorPanelService.tryAgainSwal();
                              }
                          });
                  } else {
                      instructorPanelService.tryAgainSwal();
                  }
              });
          }

          $scope.deleteNotes = function(attachment,index,index2){
              $scope.showData = false;
              var data = {
                  id: attachment.id
              }
              $http.post('api/v1/attachments/deleteAttachment',data)
                  .then(function(data){
                      if(data.data.success){
                          $scope.showData = true;
                          $scope.videos.splice(index,1);
                      } else {
                          instructorPanelService.tryAgainSwal();
                      }
                  });
          }

          $scope.downloadAttachment = function(url){
              var win = window.open(url, '_blank');
          }

          $scope.editAttachement = function(attachment, video){
              $scope.notesData.name = attachment.name;
              $scope.notesData = {
                  name: attachment.name,
                  fileLink: attachment.url,
                  isSecure: attachment.is_secure,
              };
              selectedAttachment = attachment;
              $scope.showNotesPopup(video);
          }

          var selectedVideo;
          var selectedAttachment;
          var notesFile;
          $scope.notesData = {
              name: '',
              fileLink: '',
              isSecure: false,
          }
          $scope.notesUploadStatus;

          $scope.showNotesPopup = function (video) {
              $("#notes-popup").modal('show');
              selectedVideo = video;
          }

          $scope.closeNotesPopup = function () {
              $("#notes-popup").modal('hide');
              selectedVideo = false;
              selectedAttachment = false;
              notesFile = '';
              $scope.notesData = {
                  name: '',
                  fileLink: '',
                  isSecure: false,
              };
              $scope.notesUploadStatus = '';
          }

          $scope.uploadVideoAttachments = function(file){
              notesFile = file;
              if(file){
                  $scope.notesUploadStatus = 'uploading';
                  Upload.upload({
                      url: '/api/v1/uploader/uploadVideoAttachmentToS3?video_id='+selectedVideo.id+'&module_id='+selectedVideo.module_id+'&userId='+instructorPanelService.getInstructorId()+'&no='+$scope.counter+'&socket_id='+CustomStorageService.getUserInfoStorageData().id,
                      method: "POST",
                      file: file
                  }).then(function(data){
                      $scope.notesData.fileLink = data.data.link;
                      $scope.notesUploadStatus = 'uploaded';
                      $scope.$apply();
                  });
              }
          }

          $scope.saveNotes = function() {
              if(!$scope.notesData.fileLink || !$scope.notesData.name) {
                  swal("Error", "All Fields are required", "error");
              } else {
                  if(selectedAttachment) {
                      $scope.updateNotes();
                  } else {
                      var data = {
                          name: $scope.notesData.name,
                          url: $scope.notesData.fileLink,
                          is_secure: $scope.notesData.isSecure,
                          video_id: selectedVideo.id,
                      }

                      $http.post('api/v1/attachments/createAttachment',data)
                          .then(function(data){
                              if(data.data.success){
                                  swal("Success", "Video Attachment uploaded successfully", "success");
                              } else {
                              }
                          });
                      selectedVideo.attachments.push(data);
                      $scope.closeNotesPopup();
                  }
              }

          }

          $scope.updateNotes = function() {
              var data = {
                  name: $scope.notesData.name,
                  url: $scope.notesData.fileLink,
                  is_secure: $scope.notesData.isSecure,
                  attachment_id: selectedAttachment.id
              }
              $http.post('api/v1/attachments/updateAttachment',data)
                  .then(function(data){
                      if(data.data.success){
                          swal("Success", "Video Attachment uploaded successfully", "success");
                      } else {
                      }
                  });

              selectedAttachment.name = data.name;
              selectedAttachment.url = data.url;
              selectedAttachment.is_secure = data.is_secure;
              $scope.closeNotesPopup();
          }

          $scope.deleteAllAttachments = function(index){
              var attachments = $scope.videos[index].attachments;
              if(attachments.length > 0){
                  for(var i in attachments){

                  }
              }
          }

          $scope.downloadAllAttachments = function(index,video){
              var video_name = video.name;
              video_name = video_name.split(' ').join('+');
              var win = window.open('https://nearpeer-zips.s3.amazonaws.com/zips/module' + video.module_id + '/' + video_name + '-' +video.id+'.zip', '_blank');
          }

          $scope.uploadImage = function(image,video){
              if(image){
                  Upload.upload({
                      url: '/api/v1/uploader/uploadVideoImageToS3?socket_id='+ CustomStorageService.getUserInfoStorageData().id +'&userId='+CustomStorageService.getUserInfoStorageData().id+'&no='+$scope.counter,
                      method: "POST",
                      file: image
                  }).then(function(data){
                      video.image_url = data.data.link;
                      $scope.uploadLog[data.data.no-1].log = 100;
                      $scope.close = true;
                      swal("Success", "Video Attachment uploaded successfully", "success");
                      if(!$scope.$$phase) $scope.$apply();
                  });
              }
              var log = {
                  name: image.name,
                  no: $scope.counter,
                  log: 0,
                  uploaded: false
              }
              $scope.uploadLog.push(log);
              if(!$scope.$$phase) $scope.$apply();
              $scope.counter++;
              window.scrollTo(0,document.body.scrollHeight);
          };

          $scope.previewPage = function(video){
              var data = video.index_url.split('/');
              if($state.params.state == 'module'){
                  var url = $state.href('video_player', {institutionName:data[0],schoolName:data[1],courseName:data[2],moduleNo:video.module_no,video_no:video.video_no});
              } else {
                  var url = $state.href('video_player_chapter', {institutionName:data[0],schoolName:data[1],courseName:data[2],moduleNo:video.module_no,chapterNo:video.chapter_no,video_no:video.video_no});
              }
              window.open(url,'_blank');
          }

          $scope.deleteVideo = function(index){
              swal({
                      title: "Are you sure to delete this video?",
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#DD6B55",
                      confirmButtonText: "Yes, delete it!",
                      closeOnConfirm: true},
                  function(isConfirm){
                      if(isConfirm) {
                          var id = $scope.videos[index].id;
                          var data = {id:id};
                          $scope.showData = false;
                          $http.post('api/v1/cvideos/deleteVideo',data)
                              .then(function(data){
                                  $scope.showData = true;
                                  if(data.data.success){
                                      $scope.videos.splice(index,1);
                                  } else {
                                      instructorPanelService.tryAgainSwal();
                                  }
                              })

                      }

                  });
          }

          $scope.notExists = function(video){
              for(var i in $scope.uploadedVideos){
                  if(video.url_mpd == $scope.uploadedVideos[i].url_mpd){
                      return false
                  }
              }
              return true;
          }
          $scope.notExistsVimeoVideo = function(video){
              for(var i in $scope.uploadedVideos){
                  if(video.vss_link == $scope.uploadedVideos[i].vss_link){
                      return false
                  }
              }
              return true;
          }

          $scope.jobS3Completed = function(data){
              var video = getVideoByNo(data.count);
              if(video) {
                  if(!video.error){
                      if(data.progress===100){
                          video.jobLog = data.progress;
                          video.s3Log = data.progress;
                          video.uploaded = true;
                      }else{
                          video.s3Log = 100;
                          video.jobLog = data.progress;
                      }
                  }
                  if (!$scope.$$phase) $scope.$apply();
                  var video_name = video.name;
                  video_name = $state.params.id + '-'+ $scope.appendingStringVideos[data.count-1] + '-'+ video_name;
                  video_name = video_name.replace(/[^a-zA-Z0-9]/g, '-');
                  video.url = data.url;
                  video.url_mpd = 'https://video.nearpeer.org/'+data.video_name+data.hight+'.mpd';
                  video.duration = data.duration;
                  if($scope.notExists(video)){
                      $scope.uploadedVideos.push(video);
                  }
                  CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
              }
          }

          $scope.jobVimeoCompleted = function(data){
              var video = getVideoByNo(data.count);
              if(video) {
                  video.jobLog = data.progress;
                  video.s3Log = data.progress;
                  video.uploaded = true;
                  if (!$scope.$$phase) $scope.$apply();
                  video.url = '';
                  video.url_mpd = '';
                  video.vss_link = data.vss_link;
                  video.vss_id = data.vss_id;
                  video.vss_uri = data.vss_uri;
                  video.duration = data.duration;
                  if($scope.notExistsVimeoVideo(video)){
                      $scope.uploadedVideos.push(video);
                  }
                  CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
              }

          }
          $scope.close = false;
          $sails.on('videoAttachmentProgress', function(data) {
              if(data.module_url=== $window.location.href){
                  $scope.uploadLog[data.no-1].log = data.prog;
                  if(!$scope.$$phase) $scope.$apply();
                  if(data.prog == 100){
                      $scope.uploadLog[data.no-1].uploaded = true;
                      // $scope.close = true;
                      // swal("Success", "Video Attachment created successfully", "success");
                  }
              }
          });
          $scope.socket.on('s3FileUpload', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.s3Log = data.progress;
                      video.serverLog = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if(!$scope.$$phase) $scope.$apply();
              }
          });
          $sails.on('s3FileUpload', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.s3Log = data.progress;
                      video.serverLog = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if(!$scope.$$phase) $scope.$apply();
              }
          });

          $scope.socket.on('FileUpload', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.s3Log = data.progress;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if(!$scope.$$phase) $scope.$apply();
              }
          });
          $sails.on('FileUpload', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.s3Log = data.progress;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if(!$scope.$$phase) $scope.$apply();
              }
          });

          $sails.on('transcoding_vimeo', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.jobLog = data.progress;
                      video.s3Log = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if (!$scope.$$phase) $scope.$apply();
              }
          });
          $scope.socket.on('job_create', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.jobLog = data.progress;
                      video.s3Log = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if (!$scope.$$phase) $scope.$apply();
              }
          });
          $scope.socket.on('job_complete', function(data) {
                            if(data.module_url=== $window.location.href){
                  $scope.jobS3Completed(data);
              }
          });

          $scope.socket.on('job_error', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.error = true;
                      if(!$scope.$$phase) $scope.$apply();
                      swal({
                          title: 'Error',
                          text: 'Server Error! Try Again',
                          type: 'error',
                          showCancelButton: false,
                          showConfirmButton: true
                      },function(){
                          // location.reload();
                      });
                  }
              }
          });
          $scope.socket.on('ERROR', function(data) {
              if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.error = true;
                      if(!$scope.$$phase) $scope.$apply();
                      // swal({
                      //     title: 'Error',
                      //     text: data.error.message || 'Server Error! Try Again',
                      //     type: 'error',
                      //     showCancelButton: false,
                      //     showConfirmButton: true
                      // },function(){
                      //     // location.reload();
                      // });
                  }
              }
          });
          $scope.socket.on('transcoding_vimeo', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.jobLog = data.progress;
                      video.s3Log = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if (!$scope.$$phase) $scope.$apply();
              }
          });
          $sails.on('job_create', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.jobLog = data.progress;
                      video.s3Log = 100;
                      CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText});
                  }
                  if (!$scope.$$phase) $scope.$apply();
              }
          });

          $sails.on('job_complete', function(data) {
                            if(data.module_url=== $window.location.href){
                  $scope.jobS3Completed(data);
              }
          });

          $scope.socket.on('job_complete_vimeo',function(data){
                            if(data.module_url=== $window.location.href){
                  $scope.jobVimeoCompleted(data);
              }
          })
          $sails.on('job_complete_vimeo', function(data) {
                            if(data.module_url=== $window.location.href){
                  $scope.jobVimeoCompleted(data);
              }
          });

          $sails.on('job_error', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.error = true;
                      if(!$scope.$$phase) $scope.$apply();
                      swal({
                          title: 'Error',
                          text: 'Server Error! Try Again',
                          type: 'error',
                          showCancelButton: false,
                          showConfirmButton: true
                      },function(){
                          // location.reload();
                      });
                  }
              }
          });

          $sails.on('server_error', function(data) {
                            if(data.module_url=== $window.location.href){
                  var video = getVideoByNo(data.count);
                  if(video) {
                      video.error = true;
                      if(!$scope.$$phase) $scope.$apply();
                      swal({
                          title: 'Error',
                          text: data.error ,
                          type: 'error',
                          showCancelButton: false,
                          showConfirmButton: true
                      },function(){
                          // location.reload();
                      });
                  }
              }
          });

          if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
              $state.go('instructor_signin',{},{reload:true});
          } else {
              $scope.initializeVideo();
          }


      },
    ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("addWpSitePagesController", [
    "$scope",
    "CustomStorageService",
    "HttpService",
    "$http",
    "$state",
    function ($scope, CustomStorageService, HttpService, $http, $state) {
      var sr = $scope;
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      $scope.accessConfig = {};
      $scope.dropdownSetting = { selectionLimit: 1, };
      $scope.tags = [
        { id: 'CA', label: 'CA' },
        { id: 'ACCA', label: 'ACCA' },
        { id: 'ISSB', label: 'ISSB' },
        { id: 'MDCAT', label: 'MDCAT' },
        { id: 'Entry Test', label: 'Entry Test' },
        { id: 'CSS', label: 'CSS' },
        { id: 'FSC & Matric', label: 'FSC & Matric' },
        { id: 'O & A Levels', label: 'O & A Levels' },
        { id: 'IELTS', label: 'IELTS' },
        { id: 'Govt Jobs', label: 'Govt Jobs' },
        { id: 'Fedral Board', label: 'Fedral Board' },
        { id: 'Punjab Board', label: 'Punjab Board' },
      ];
      $scope.accessConfig.selectedTags = [];
      $scope.accessConfig.selectedCourse = [];
      $scope.accessConfig.selectedModules = [];

      // $http({
      //   url: "/api/v1/coursetag/get",
      //   method: "GET",
      // }).then(function (data) {
      //   if (data && data.data) {
      //     data.data.courseTags.forEach(function (tag) {
      //       $scope.tags.push({ id: tag.id, label: tag.name });
      //     });
      //   }
      // });

      if($state.params.id) {
        $http({
          url: '/api/v1/wp-link/wp-link/' + $state.params.id,
          method: "GET",
        }).then(function(data) {
          if(data && data.data) {
            var config = data.data.result;
            $scope.accessConfig = {
              id: config.id,
              name: config.name,
              link: config.link,
              selectedTags: [{ id: config.category, label: config.category }],
            };
          }
          
        });
      }

      $scope.createAccessConfig = function () {
        if (
          !$scope.accessConfig.name ||
          !$scope.accessConfig.link ||
          $scope.accessConfig.selectedTags.length < 1
        ) {
          swal({
            title: "Error!",
            text: "Make sure you have filled all fields",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }
        var url = "api/v1/wp-link/add-wp-link";
        if($state.params.id) {
          url = "api/v1/wp-link/update-wp-link";
        }
        $http
          .post(url, $scope.accessConfig)
          .then(function (data) {
            swal(
              {
                title: "Success",
                text: "Page config Successfull!",
                type: "success",
                showConfirmButton: false,
                timer: 2000,
              },
              function () {
                swal.close();
                $state.go("wp_pages", {});
              }
            );
          });
      };

      sr.selectCourse = function (course, type) {
        if (type === "course") {
          $scope.courses = [];
          $scope.courseKey = "";
          $scope.accessConfig.selectedCourse.push({
            id: course.id,
            name: course.name,
          });
        } else if (type === "course-module") {
          $scope.coursesModule = [];
          $scope.courseModuleKey = course.name;
          getInfo(
            { id: course.id },
            "module",
            "api/v1/courses/getModulesByCourseId"
          );
        }
      };

      sr.deleteCourse = function (courseToDelete, index) {
        var courses = [];
        $scope.accessConfig.selectedCourse.forEach(function (course) {
          if (course.id !== courseToDelete.id) {
            courses.push(course);
          }
        });
        $scope.accessConfig.selectedCourse = courses;
      };

      sr.searchInfo = function (value, type) {
        if (
          type === "course" ||
          type === "module" ||
          type === "course-module"
        ) {
          getInfo({ key: value }, type, "api/v1/courses/search");
        }
      };

      var getInfo = function (data, type, api) {
        HttpService.getRequest(api, data).then(function (res) {
          if (type === "course-module") {
            sr.coursesModule = res.courses;
          } else if (type === "course") {
            sr.courses = res.courses;
          } else if (type === "module") {
            sr.modules = res.modules;
          }
        });
      };

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("admin_panel", {}, { reload: true });
      }
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('AddTagUrlsController', ['$scope','$state','$http','CustomStorageService', function($scope,$state,$http,CustomStorageService) {
      
      $scope.selectedInstitution = "Select Institution";
      $scope.selectedSchool = "Select Faculty";
      $scope.selectedCourse = "Select Course";
      $scope.selectedCourses = [];
      $scope.name;
      $scope.url;
      $scope.id = $state.params.id;

      $scope.myFilter = function (item) {
        return !item.deleted;
      };

      $http({
        url:'api/v1/courses/getUniversityList',
        method:"GET",
        params: {type: 'admin'}
      }).then(function (data) {
        $scope.institutions = data.data;
      });

      if($scope.id) {
        $http({
          url:'/api/v1/tag-url/' + $scope.id,
          method:"GET",
          params: {type: 'admin'}
        }).then(function (data) {
          if(data.data.success) {
            $scope.selectedCourses = data.data.courseTag.courses;
            $scope.name = data.data.courseTag.name;
            $scope.url = data.data.courseTag.index_url;
          }
        });
      }
      
      
      $scope.removeCourse = function (course){
        course.deleted = true;
      };

      $scope.updateInstitution = function(institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
      };

      $scope.updateSchool = function(school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };

      $scope.updateCourse = function(index){
       if(index!=='null'){
        $scope.courses[index].isNew = true;
        $scope.selectedCourses.push($scope.courses[index]);
       }
      };

      $scope.getCourses = function() {
        if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if(data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert('server error');
          }

        });
      };

      $scope.saveTag = function () {
        if(!$scope.name){
          swal('Error','Please Enter Tag Name','error');
        }else if($scope.selectedCourses.length===0){
          swal('Error','Select Course To Add','error');
        } else {
          if($scope.id) {
            $scope.updateCourseTag();
          } else {
            $scope.createCourseTag();
          }
        }
      }

      var finalCourses = function() {
        var courses = []
        $scope.selectedCourses.forEach(function(course) {
          if(!course.deleted) {
            courses.push(course)
          }
        });
        return courses;
      }

      $scope.createCourseTag = function() {
        var courses = finalCourses();
          var data ={
            name: $scope.name,
            url: $scope.url,
            courses: courses,
          };
          $http({
            url:'/api/v1/tag-url/create',
            method:"POST",
            data: data
          }).then(function (res) {
            if(res){
              if(res.data.success) {
                swal('Success','Successfully Added!','success');
                $state.go('tagUrls')
              } else {
                swal('Error',res.data.message,'error');
              }
              
            }else{
              swal('Error','Error saving tag!','error');
            }
          });
      }

      $scope.updateCourseTag = function(){
        var courses = finalCourses();
        var data ={
          name: $scope.name,
          url: $scope.url,
          courses: courses,
        };
        $http({
          url:'/api/v1/tag-url/edit/' + $scope.id,
          method:"PUT",
          data: data
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Updated!','success');
            } else {
              swal('Error',res.data.message,'error');
            }
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }
    }]);
  })();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addSwTagsController', ['$scope', '$state', '$http', 'HttpService', function ($scope, $state, $http, HttpService) {
      var sr = $scope;
      $scope.isEdit = $state.params.course_id;
      $scope.addCofig = false;
      $scope.courseFromAi = true;
      $scope.configType = '';
      $scope.modules = [];
      $scope.courses = []
      $scope.courseKey = ''
      $scope.selectedCourse = {}
      
      sr.promptConfig = {};
      sr.tagsSW = [];

      

      $scope.addConfigPopUpOpen = function (type, id, data, module_id) {
        var swTags = [];
        if(data.sw_tags.length > 0) {
          data.sw_tags.forEach(function(tag) {
            swTags.push({text: tag.name});
          });
        }
        $scope.tagsSW = swTags;
        if(type === 'course') {
          sr.promptConfig = {
            id: id,
            type: type,
            course_id: id,
          }
        } else if(type === 'module') {
          sr.promptConfig = {
            id: id,
            type: type,
            course_id: $scope.selectedCourse.id,
          }
        } else  {
          sr.promptConfig = {
            id: id,
            type: type,
            course_id: $scope.selectedCourse.id,
            module_id: module_id,
          }
        }
        console.log('sr.promptConfig');
        console.log(sr.promptConfig);
        $scope.addCofig = true;
      };
      $scope.addConfigPopUpClose = function () {
        sr.promptConfig = {};
        $scope.addCofig = false;
      };

      $scope.searchInfo = function (value, type) {
        getInfo(
          { key: value },
          "course",
          "api/v1/courses/search"
        );
      };

      var getInfo = function (data, type, api) {
        $scope.isLoading = true;
        HttpService.getRequest(api, data).then(function (res) {
          if(type === 'course') {
            sr.courses = res.courses;
          } else {
            sr.modules = res.modules
            $scope.selectedCourse = res.course
          }
          $scope.isLoading = false;
        });
      };

      $scope.addVariants = function (course) {
        $scope.selectedCourse = course;
        sr.courses = [];
          sr.courseKey = course.name;
          getInfo(
            { id: course.id, swTags: true, courseswTags: true },
            'modules',
            "api/v1/courses/getModulesByCourseId"
          );
      };

      sr.createPromptConfig = function () {
        const tags = []
        $scope.tagsSW.forEach(function(tag) {
          tags.push(tag.text);
        })
        sr.promptConfig.swTags = tags;
        $http({
          url: 'api/v1/coursetag/update-sw-tag',
          method: "POST",
          data: sr.promptConfig
        }).then(function (data) {
          if (data.data.success) {
            $scope.addConfigPopUpClose();
            getInfo(
              { id: $scope.selectedCourse.id, swTags: true, courseswTags: true },
              'modules',
              "api/v1/courses/getModulesByCourseId"
            );
          } else {
            alert('server error');
          }
        });
      };

      if($scope.isEdit) {
        $scope.addVariants({id: $state.params.course_id, name: ''})
      }

    }]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('addSessionController', ['$scope','$state','$http','CustomStorageService', function($scope,$state,$http,CustomStorageService) {
      
      var sr = $scope;
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      $scope.session = {};

      if($state.params.id) {
        $http.get("/api/v1/session/" + $state.params.id, {}).then(
          function (resp) {
            $scope.session = {
              name: resp.data.session.name,
              endDate: new Date(resp.data.session.end_date),
              startDate: new Date(resp.data.session.start_date),
            }
          },
          function errorCallback(response) {
            swal(
              {
                title: "Error",
                text: "Error while getting data",
                type: "error",
                showCancelButton: false
              },
              function (isConfirm) {}
            );
          }
        );
      }
      

      $scope.createSession = function() {
          if (!$scope.session.name || !$scope.session.startDate || !$scope.session.endDate) {
              swal({
              title: "Error!",
              text: "Make sure you have filled all fields",
              type: "error",
              confirmButtonText: "Ok"
              });
              return;
          }
          if(!$state.params.id) {
            $http.post('api/v1/session/create', $scope.session)
            .then(function (data) {
              $state.go('sessions');
            });
          } else {
            $http.put('api/v1/session/edit/' + $state.params.id, $scope.session)
            .then(function (data) {
              $state.go('sessions');
            });
          }
      };

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
          $state.go('admin_panel', {}, { reload: true });
      }
    }]);
  })();


(function () {
  'use strict';

  angular.module('NearPeer')
    .controller('createController', ['UploadService', '$scope', '$http', '$rootScope', '$state', "env",
      function (UploadService, $scope, $http, $rootScope, $state,env) {

        var sr = $scope;
        var id = $state.params.id;
        $scope.nichetags = [];
        $scope.isShow=false;
        $scope.isCustomExam=false;
        $scope.subjects = []; // List of available subjects (configurations)
        $scope.newSubject = {}; // Holder for the selected subject to add
        $scope.bundle = {
          subjects: [] // List of added subjects
        };

        // $scope.newTag = {
        //   tag_name: "",
        //   sw_tag_name: "",
        //   question_occurance_percentage: null,
        //   difficulties: []
        // };

        // Fetch available course tags
        // $http.get('/api/v1/coursetag/get').then(function (response) {
        //   if (response && response.data) {
        //     $scope.nichetags = response.data.courseTags || [];
        //   }
        // })['catch'](function (error) {
        //   console.error("Error fetching course tags:", error);
        // });

        // Fetch available Subjects (Quiz Configurations)
        $http.get(
          env.backendService + '/quizservice/v1/quiz-configurations/get-all-configurations?is_count_needed=true')
          .then(function (response) {
            if (response && response.data && response.data.docs) {
              $scope.subjects = response.data.docs;
            }
          })['catch'](function (error) {
            console.error("Error fetching subjects:", error);
          });

        $scope.toggleCustomExam = function () {
          $scope.isCustomExam = !$scope.isCustomExam;
        };

        // $scope.getSWTags = function(tag_id) { 
        //   $http.get( 
        //     "http://localhost:3002"
        //     //  env.backendService
        //              +
        //     '/quizservice/v1/tag/get-tag-questions-count?tag_id='+tag_id).then(function (response) {
        //     if (response && response.data) {
        //       $scope.sw_tags = response.data.course || [];
        //       for (var i = 0; i < $scope.bundle.sw_tags_distribution.length; i++) {
        //         var val = $scope.bundle.sw_tags_distribution[i];
        //       
        //         // Manually find the matching sw_tag_name
        //         for (var j = 0; j < $scope.sw_tags.length; j++) {
        //           if ($scope.sw_tags[j].sw_tag_name == val.sw_tag_name) {  // Using '==' for compatibility
        //             val.total_available_questions = $scope.sw_tags[j].totalQuestions; // Update value
        //             break; // Exit loop when match is found
        //           }
        //         }
        //       }
        //       
        //     }
        //   })['catch'](function (error) {
        //     console.error("Error fetching course tags:", error);
        //   });
        // }; 

        $scope.$watch("bundle.name", function (newValue) {
          if (newValue === "FLP") {
              $scope.bundle.total_questions = 200;
              $scope.bundle.time_limit = 210;
          } else if (newValue === "HLP") {
              $scope.bundle.total_questions = 100;
              $scope.bundle.time_limit = 105;
          }
      });

      $scope.$watch("bundle.tag_id", function (newValue) {
        if (newValue) {
            console.log("Tag ID selected:", newValue);
            // $scope.getSWTags(newValue);
        }
    });

        // Function to get bundle details
        var getBundle = function () {
          $http.get(                 
            // "http://localhost:3002"
             env.backendService
               + "/quizservice/v1/quiz/quiz-configurations-by-id/" + id)
            .then(function (response) {
              if (response.data) {
                var bundleData = response.data.data;
                sr.bundle = {
                  id: bundleData._id,
                  name: bundleData.name || "",
                  total_questions: bundleData.total_questions || "",
                  quiz_type:"full",
                  time_limit: bundleData.time_limit || "",
                  tag_id: bundleData.tag_id,
                  sw_tags_distribution: bundleData.sw_tags_distribution || [],
                  subjects: bundleData.subjects || [] // Assuming backend returns 'subjects'
                };
                // $scope.getSWTags(bundleData.tag_id); 
              }
            })['catch'](function (error) {
              console.error("Error fetching bundle:", error);
            });
        };

        $scope.removeSubject = function(index) {
          $scope.bundle.subjects.splice(index, 1);
        };

        // NEW: Subject Logic
        $scope.updateNewSubject = function(selectedSubject) {
          if (selectedSubject) {
            $scope.newSubject = {
              _id: selectedSubject._id,
              name: selectedSubject.name,
              total_available_questions: selectedSubject.questionCount,
              question_occurance_percentage: null, // Using 'question_occurance_percentage' as requested by user (acting as count)
              difficulties: []
            };
          }
        };

        // Add Subject to Distribution
        $scope.addSubjectToDistribution = function() {
          if ($scope.newSubject.name && $scope.newSubject.question_occurance_percentage) {
             if ($scope.newSubject.question_occurance_percentage > $scope.newSubject.total_available_questions) {
               $scope.newSubject.question_occurance_percentage = $scope.newSubject.total_available_questions; 
               alert("You cannot add more than " + $scope.newSubject.total_available_questions + " questions for " + $scope.newSubject.name);
               return; 
             }
            var existingSub = $scope.bundle.subjects.find(function(sub) {
              return sub._id === $scope.newSubject._id;
           });
    
            if (existingSub) {
              alert("This Subject is already added!");
              return; 
            }
        
            $scope.bundle.subjects.push(angular.copy($scope.newSubject)); 
            // Reset
            $scope.newSubject = {};
            $scope.selectedSubject = null;
          } else {
            alert("Please select a Subject and enter Question Count!");
          }
        };

        $scope.addDifficultyToSubject = function(subject, difficulty) {
           if (!subject.difficulties) subject.difficulties = [];
           if(subject.difficulties.length > 3)
           {
             alert("You can only add up to 3 difficulty levels!");
             return;
           }
           if (!difficulty) {
             alert("Please select a difficulty level!");
             return;
           }
           if (subject.difficulties.includes(difficulty)) {
             alert("This difficulty level is already added!");
             return;
           }
           subject.difficulties.push(difficulty);
           $scope.newDifficulty = ""; 
         };
         
         $scope.removeDifficultyFromSubject = function(subject, index) {
           subject.difficulties.splice(index, 1);
         };

         $scope.validateSubjectQuestionCount = function (subject) {
            if (subject.question_occurance_percentage > subject.total_available_questions) {
              subject.question_occurance_percentage = subject.total_available_questions;
              alert("You cannot add more than " + subject.total_available_questions + " questions for " + subject.name);
            }
         };


        // $scope.removeTag = function(index) {
        //   $scope.bundle.sw_tags_distribution.splice(index, 1);
        // };
        
        // // Add a new tag to the array
        // $scope.addTag = function() {
        //   if ($scope.newTag && $scope.newTag.sw_tag_name) {
        //     $scope.bundle.sw_tags_distribution.push({
        //       difficulties: [],
        //       tag_name: $scope.newTag.tag_name,
        //       total_available_questions : selectedTag.totalQuestions,
        //       question_occurance_percentage: $scope.newTag.question_occurance_percentage || 0,
        //       sw_tag_name: $scope.newTag.sw_tag_name
        //     });
        //     $scope.newTag = {}; // Reset form
        //   }
        // };
        // $scope.updateNewTag = function(selectedSWTag) {
        //   if (selectedSWTag) {
        //     $scope.newTag.tag_name = selectedSWTag.tag_name; // Auto-fill tag name
        //     $scope.newTag.sw_tag_name = selectedSWTag.sw_tag_name; // Auto-fill SW tag name
        //     $scope.newTag.difficulties = []; // Set difficulties as an empty array
        //     $scope.newTag.total_available_questions=selectedSWTag.totalQuestions;
        //   }
        // };
        
        // // Function to add tag to distribution
        // $scope.addTagToDistribution = function() {
        //   if ($scope.newTag.sw_tag_name && $scope.newTag.question_occurance_percentage) {
        //     if ($scope.newTag.question_occurance_percentage > $scope.newTag.total_available_questions) {
        //       $scope.newTag.question_occurance_percentage = $scope.newTag.total_available_questions; 
        //       alert("You cannot add more than" + $scope.selectedSWTag.totalQuestions + "questions for" + $scope.newTag.sw_tag_name);
        //       return; 
        //     }
        //     var existingTag = $scope.bundle.sw_tags_distribution.find(function(tag) {
        //       return tag.sw_tag_name === $scope.newTag.sw_tag_name;
        //    });
    
        //     if (existingTag) {
        //       alert("This SW Tag is already added to the distribution!");
        //       return; // Stop execution if tag already exists
        //     }
        
        //     $scope.bundle.sw_tags_distribution.push(angular.copy($scope.newTag)); 
        //     // Reset the form after adding
        //     $scope.newTag = { tag_name: "", sw_tag_name: "", question_occurance_percentage: null, difficulties: [] };
        //     $scope.selectedSWTag = null;
        //   } else {
        //     alert("Please select a SW Tag and enter Question Occurrence!");
        //   }
        // };        
        
        // // Remove a difficulty from a tag
        // $scope.addDifficulty = function(tag, difficulty) {
        //   if(tag.difficulties.length > 3)
        //   {
        //     alert("You can only add up to 3 difficulty levels!");
        //     return;
        //   }
        //   if (!difficulty) {
        //     alert("Please select a difficulty level!");
        //     return;
        //   }
        
        //   // Check if difficulty already exists
        //   if (tag.difficulties.includes(difficulty)) {
        //     alert("This difficulty level is already added!");
        //     return; // Stop execution if difficulty already exists
        //   }
        
        //   // Add difficulty if not present
        //   tag.difficulties.push(difficulty);
        //   $scope.newDifficulty = ""; // Reset dropdown selection
        // };
        
        
        // $scope.removeDifficulty = function(tag, index) {
        //   tag.difficulties.splice(index, 1);
        // };


        // $scope.calculateQuestionCount = function() {
        //   if ($scope.selectedSWTag) {
        //       // var availableQuestions = $scope.selectedSWTag.totalQuestions || 0;
        //       // ... (commenting out all this logic as we use direct logic now)
        //       if($scope.selectedSWTag.totalQuestions < $scope.newTag.question_occurance_percentage)
        //       {
        //         alert("Questions cannot exceed than the available questions");
        //         $scope.newTag.question_occurance_percentage = $scope.selectedSWTag.totalQuestions;
        //       }
        //   }
        // };

        // $scope.validateQuestionCount = function (tag) {
        //   console.log("tag-----",tag);
        //   if (tag.question_occurance_percentage > tag.totalQuestions) {
        //     tag.question_occurance_percentage = tag.totalQuestions; // Reset to max available
        //     alert("You cannot add more than " + tag.totalQuestions + " questions for " + tag.sw_tag_name);
        //     tag.question_occurance_percentage = tag.totalQuestions;
        //   }
        // };

        // $scope.$watch(
        //   function () {
        //     var questionCounts = [];
        //     for (var i = 0; i < $scope.bundle.sw_tags_distribution.length; i++) {
        //       questionCounts.push($scope.bundle.sw_tags_distribution[i].question_occurance_percentage);
        //     }
        //     return questionCounts;
        //   },
        //   function (newValues, oldValues) {
        //     for (var i = 0; i < $scope.bundle.sw_tags_distribution.length; i++) {
        //       var tag = $scope.bundle.sw_tags_distribution[i];
        //       if (tag.question_occurance_percentage > tag.total_available_questions) {
        //         tag.question_occurance_percentage = tag.total_available_questions; // Fix: should be total_available_questions
        //         alert("You cannot add more than " + tag.total_available_questions + " questions for " + tag.sw_tag_name);
        //       }
        //     }
        //   },
        //   true
        // );
      
        
        // Save Bundle Function
        sr.SaveBundle = function (bundle) {
          console.log("🚀 ~ bundle:", bundle)
          var totalQuestionsCount = bundle.subjects.reduce(function(sum, subject) {
            return sum + (subject.question_occurance_percentage || 0);
          }, 0);
        
          // Check if required fields are empty
          if (!bundle.name || !bundle.time_limit || !bundle.total_questions) {
              alert("Please fill all required fields: Name, Time Limit, Total Questions");
              return;
          }
      
          // Check if question occurrence percentage sum is exactly 100
          if (totalQuestionsCount !== $scope.bundle.total_questions) {
              alert("Subject question counts must sum up entirely to Total Questions!");
              return;
          }
      
          // Check if any tag has an empty difficulties array
          var hasEmptyDifficulties = bundle.subjects.some(function(subject) {
            return subject.difficulties.length === 0;
          });
          if (hasEmptyDifficulties) {
              alert("Each subject must have at least one difficulty selected!");
              return;
          }
            var subjectNames = {}; 
            for (var j = 0; j < bundle.subjects.length; j++) {
                var sName = bundle.subjects[j].name;
                if (subjectNames[sName]) {
                    alert("Same Subject cannot be added more than once: " + sName);
                    return;
                }
                subjectNames[sName] = true;
            }

          // var totalPercentage = bundle.sw_tags_distribution.reduce(function(sum, tag) {
          //   return sum + (tag.question_occurance_percentage || 0);
          // }, 0);
        
          // // Check if required fields are empty
          // if (!bundle.name || !bundle.time_limit || !bundle.total_questions || !bundle.tag_id) {
          //     alert("Please fill all required fields: Name, Time Limit, Total Questions, and Tag ID.");
          //     return;
          // }
      
          // // Check if question occurrence percentage sum is exactly 100
          // if (totalPercentage !== $scope.bundle.total_questions) {
          //     alert("Question Occurrence Percentage must be exactly equal to total Questions!");
          //     return;
          // }
      
          // // Check if any tag has an empty difficulties array
          // var hasEmptyDifficulties = bundle.sw_tags_distribution.some(function(tag) {
          //   return tag.difficulties.length === 0;
          // });
          // if (hasEmptyDifficulties) {
          //     alert("Each tag must have at least one difficulty selected!");
          //     return;
          // }
          //   var tagNameCounts = {}; 
          //   for (var j = 0; j < bundle.sw_tags_distribution.length; j++) {
          //       var tagName = bundle.sw_tags_distribution[j].sw_tag_name;
          //       if (tagNameCounts[tagName]) {
          //           alert("Same SW Tag cannot be added more than once: " + tagName);
          //           return;
          //       }
          //       tagNameCounts[tagName] = true;
          //   }

          $http.post(
           env.backendService
          //  "http://localhost:3002"
           + "/quizservice/v1/quiz/createOrUpdateQuizConfigurations"
           , bundle)
            .then(function () {
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })['catch'](function (error) {
              console.error("Error saving Configuration:", error);
            });
        };
        // Function to add Course or Module to Bundle

        // Initialize bundle
        if (id) {
          getBundle();
        } else {
            sr.bundle = {
              quiz_type: "full",
              name:  "",
              total_questions: 0,
              time_limit: 0,
              tag_id: null,
              subjects: [], // Initialize subjects
              sw_tags_distribution: [],
            };
            $scope.isShow=true;
          };
      }]);
})();



(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('AddMarketController', ['$scope','$state','$http','CustomStorageService', function($scope,$state,$http,CustomStorageService) {
      
      $scope.selectedInstitution = "Select Institution";
      $scope.selectedSchool = "Select Faculty";
      $scope.selectedCourse = "Select Course";
      $scope.selectedCourses = [];
      $scope.tagName;
      $scope.id = $state.params.id;

      $scope.myFilter = function (item) {
        return !item.deleted;
      };

      // $http({
      //   url:'api/v1/courses/getUniversityList',
      //   method:"GET",
      //   params: {type: 'admin'}
      // }).then(function (data) {
      //   $scope.institutions = data.data;
      // });

      if($scope.id) {
        $http({
          url:'/api/v1/post-question-market/' + $scope.id,
          method:"GET",
          params: {type: 'admin'}
        }).then(function (data) {
          if(data.data.success) {
            $scope.PostQuestionMarket = [];
            $scope.tagName = data.data.PostQuestionMarket.name;
          }
        });
      }
      
      
      $scope.removeCourse = function (course){
        course.deleted = true;
      };

      $scope.updateInstitution = function(institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
      };

      $scope.updateSchool = function(school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };

      $scope.updateCourse = function(index){
       if(index!=='null'){
        $scope.courses[index].isNew = true;
        $scope.selectedCourses.push($scope.courses[index]);
        var id = $scope.courses[index].id;
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: "GET",
          params: {id: id}
        }).then(function(data) {
          $scope.modules = data.data.modules;
        });
       }
      };

      $scope.getCourses = function() {
        if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if(data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert('server error');
          }

        });
      };

      $scope.deleteTag = function () {
        $http({
          url:'/api/v1/post-question-market/delete/' + $scope.id,
          method:"Delete",
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Deleted!','success');
              $state.go('questionMarket', {}, { reload: true });
            } else {
              swal('Error',res.data.message,'error');
            }
            
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }

      $scope.saveTag = function () {
        if(!$scope.tagName){
          swal('Error','Please Enter Tag Name','error');
        } else {
          if($scope.id) {
            $scope.updateCourseTag();
          } else {
            $scope.createCourseTag();
          }
        }
      }

      $scope.createCourseTag = function() {
          var data ={
            tagName: $scope.tagName,
            courses: $scope.selectedCourses,
          };
          $http({
            url:'api/v1/post-question-market/create',
            method:"POST",
            data: data
          }).then(function (res) {
            if(res){
              if(res.data.success) {
                swal('Success','Successfully Added!','success');
              } else {
                swal('Error',res.data.message,'error');
              }
              
            }else{
              swal('Error','Error saving tag!','error');
            }
          });
      }

      $scope.updateCourseTag = function(){
        var data ={
          tagName: $scope.tagName,
          courses: $scope.selectedCourses,
        };
        $http({
          url:'/api/v1/post-question-market/edit/' + $scope.id,
          method:"PUT",
          data: data
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Updated!','success');
            } else {
              swal('Error',res.data.message,'error');
            }
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }
    }]);
  })();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addPromTagOpenAIController', ['$scope', '$state', '$http', 'CustomStorageService', function ($scope, $state, $http, CustomStorageService) {
      var sr = $scope;
      
      $scope.addCofig = false;
      $scope.configType = '';
      $scope.tags = [];
      sr.promptConfig = {};

      $scope.addConfigPopUpOpen = function (type, id, data) {
        $scope.configType = type;
        
        if(data.prompt.length > 0) {
          sr.promptConfig = data.prompt[0];
        } else {
          sr.promptConfig = {
            categoryPrompt: "Please pick one of the these categories that describe this question very well: Example, Practical, Concept, Numerical. Make sure to pick one out of these 4 provides categories.",
            difficultyPrompt: "Please define the difficulty of this question out of the following: very easy, easy, medium, hard, very hard.",
            topicPrompt: "Can you please give me a tag that is relevant to this question? A tag should be the name of the topic that defines this topic very well.",
            solutionPrompt: "Can you please give me the solution of this question? Pretend that you're providing this solution to someone who doesn't know anything about this topic. Also, make the solution grammatical correct and use capital words where needed.",
          };
        }
        if(sr.promptConfig.subjectPrompt) {
          $scope.promptConfig.courseFromAi = true;
        } else {
          $scope.promptConfig.courseFromAi = false;
        }
        sr.promptConfig.type = 'tag';
        sr.promptConfig.tag_id = id;
        $scope.addCofig = true;
      };
      $scope.addConfigPopUpClose = function () {
        $scope.addCofig = false;
      };

      var getModuleDetails = function () {
        $http({
          url: '/api/v1/prompt/get-tag-detail',
          method: "GET",
        }).then(function (data) {
          if (data.data.success) {
            $scope.tags = data.data.tags;
          } else {
            alert('server error');
          }
        });
      };

      getModuleDetails();

      sr.createPromptConfig = function () {
        if($scope.promptConfig.courseFromAi) {
          sr.promptConfig.subjectName = ''
          sr.promptConfig.chapterName = ''
        } else {
          sr.promptConfig.subjectPrompt = ''
          sr.promptConfig.chapterPrompt = ''
        }
        
        $http({
          url: 'api/v1/prompt/create-prompt-config',
          method: "POST",
          data: sr.promptConfig
        }).then(function (data) {
          if (data.data.success) {
            $scope.addConfigPopUpClose();
          } else {
            alert('server error');
          }
        });
      };

    }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addPromOpenAIController', ['$scope', '$state', '$http', 'CustomStorageService', function ($scope, $state, $http, CustomStorageService) {

      var sr = $scope;
      sr.promptConfig = {
        type: "course",
        categoryPrompt: "Please pick one of the these categories that describe this question very well: Example, Practical, Concept, Numerical. Make sure to pick one out of these 4 provides categories.",
        difficultyPrompt: "Please define the difficulty of this question out of the following: very easy, easy, medium, hard, very hard.",
        topicPrompt: "Can you please give me a tag that is relevant to this question? A tag should be the name of the topic that defines this topic very well.",
        solutionPrompt: "Can you please give me the solution of this question? Pretend that you're providing this solution to someone who doesn't know anything about this topic. Also, make the solution grammatical correct and use capital words where needed.",
      };
      console.log("🚀 ~ file: addPromOpenAI.js:9 ~ sr.promptConfig:", sr.promptConfig)

      var reaFeild = {
        promptType : "", // course or text
      }
      
      if($state.params.id) {
        sr.isEdit = true;
        function getPromptConfig() {
          $http({
            url: '/api/v1/prompt/get-prompt-config-by-id/' + $state.params.id,
            method: "GET",
          }).then(function (data) {
            if (data.data.success) {
              sr.promptConfig = data.data.promptConfigs;
              if(sr.promptConfig.subjectPrompt) {
                $scope.promptConfig.courseFromAi = true;
              } else {
                $scope.promptConfig.courseFromAi = false;
              }
            } else {
              alert('server error');
            }
          });
        }
        getPromptConfig();
      }

      var getInsitutions = function () {
        $http({
          url: 'api/v1/courses/getUniversityList',
          method: "GET",
          params: { type: 'admin' }
        }).then(function (data) {
          sr.institutions = data.data;
          sr.selectedInstitution = "Select Institution";
        });
      }();

      sr.updateInstitution = function (institute) {
        sr.selected_faculty = $scope.institutions[institute].faculties;
        sr.selectedInstituteNo = institute;
      };
      sr.updateSchool = function (school) {
        sr.selectedFaculty = school;
        getCourses();
      }
      sr.updateCourse = function (course) {
        var course = sr.courses[course];
        sr.promptConfig.course_id = course.id
      }
      var getCourses = function () {
        if (!sr.selectedInstitution || !sr.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: sr.institutions[sr.selectedInstituteNo].institution,
          faculty: sr.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function (data) {
          if (data.data.success) {
            sr.courses = data.data.courses;
          } else {
            alert('server error');
          }
        });
      };

      sr.createPromptConfig = function () {
        if($scope.promptConfig.courseFromAi) {
          sr.promptConfig.subjectName = ''
          sr.promptConfig.chapterName = ''
        } else {
          sr.promptConfig.subjectPrompt = ''
          sr.promptConfig.chapterPrompt = ''
        }

        // if(
        //   !sr.promptConfig.categoryPrompt || 
        //   !sr.promptConfig.topicPrompt ||
        //   !sr.promptConfig.solutionPrompt ||
        //   !sr.promptConfig.optionPrompt){
        //   swal({
        //       title: "Error!",
        //       text: "Make sure you have filled all fields",
        //       type: "error",
        //       confirmButtonText: "Ok"
        //     });
        //   return;
        // }
        $http({
          url: 'api/v1/prompt/create-prompt-config',
          method: "POST",
          data: sr.promptConfig
        }).then(function (data) {
           if (data.data.success) {
            sr.courses = data.data.courses;
            $state.go('Prom_open_AI_config',{});
          } else {
            alert('server error');
          }
        });
      };

    }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addPromModuleOpenAIController', ['$scope', '$state', '$http', 'CustomStorageService', function ($scope, $state, $http, CustomStorageService) {
      var sr = $scope;
      
      $scope.addCofig = false;
      $scope.courseFromAi = true;
      $scope.configType = '';
      $scope.modules = [];
      sr.promptConfig = {};

      $scope.addConfigPopUpOpen = function (type, id, data) {
        $scope.configType = type;
        if(data.prompt.length > 0) {
          sr.promptConfig = data.prompt[0];
        } else {
          sr.promptConfig = {
            categoryPrompt: "Please pick one of the these categories that describe this question very well: Example, Practical, Concept, Numerical. Make sure to pick one out of these 4 provides categories.",
            difficultyPrompt: "Please define the difficulty of this question out of the following: very easy, easy, medium, hard, very hard.",
            topicPrompt: "Can you please give me a tag that is relevant to this question? A tag should be the name of the topic that defines this topic very well.",
            solutionPrompt: "Can you please give me the solution of this question? Pretend that you're providing this solution to someone who doesn't know anything about this topic. Also, make the solution grammatical correct and use capital words where needed.",
          };
        }
        sr.promptConfig.type = type;
        sr.promptConfig.course_id = $state.params.course_id;
        if(sr.promptConfig.subjectPrompt) {
          $scope.promptConfig.courseFromAi = true;
        } else {
          $scope.promptConfig.courseFromAi = false;
        }
        if(type === 'module') {
          sr.promptConfig.module_id = id;
          sr.promptConfig.video_id = null;
        } else {
          sr.promptConfig.video_id = id;
          sr.promptConfig.module_id = data.module_id;
        }
        $scope.addCofig = true;
      };
      $scope.addConfigPopUpClose = function () {
        $scope.addCofig = false;
      };

      var getModuleDetails = function () {
        $http({
          url: '/api/v1/prompt/get-course-detail/' + $state.params.course_id,
          method: "GET",
        }).then(function (data) {
          if (data.data.success) {
            $scope.modules = data.data.modules;
          } else {
            alert('server error');
          }
        });
      };

      getModuleDetails();

      sr.createPromptConfig = function () {
        if($scope.promptConfig.courseFromAi) {
          sr.promptConfig.subjectName = ''
          sr.promptConfig.chapterName = ''
        } else {
          sr.promptConfig.subjectPrompt = ''
          sr.promptConfig.chapterPrompt = ''
        }
        // if(
        //   !sr.promptConfig.categoryPrompt ||
        //   !sr.promptConfig.topicPrompt ||
        //   !sr.promptConfig.solutionPrompt ||
        //   !sr.promptConfig.optionPrompt){
        //   swal({
        //       title: "Error!",
        //       text: "Make sure you have filled all fields",
        //       type: "error",
        //       confirmButtonText: "Ok"
        //     });
        //   return;
        // }
        $http({
          url: 'api/v1/prompt/create-prompt-config',
          method: "POST",
          data: sr.promptConfig
        }).then(function (data) {
          if (data.data.success) {
            $scope.addConfigPopUpClose();
          } else {
            alert('server error');
          }
        });
      };

    }]);
})();

(function () {
  'use strict';
  angular
      .module('NearPeer')
      .controller('editPostQuestionConfigController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
          var sr = $scope;
          var signedIn = CustomStorageService.getAdminSignedInStorageData();
          $scope.accessConfig = {
            order_terminate_config: 'access-days'
          };
          $scope.tags = [];
          $scope.accessConfig.selectedTags = [];
          $scope.accessConfig.selectedCourse = [];
          // $scope.accessConfig.selectedModules = [];
          

          $http({
              url: '/api/v1/coursetag/get',
              method: "GET",
            }).then(function(data) {
              if(data && data.data) {
                data.data.courseTags.forEach(function (tag) {
                  $scope.tags.push({id: tag.id, label: tag.name})
                });
              }
              
            });

            if($state.params.id) {
                $http({
                  url: '/api/v1/post-question/get-config/' + $state.params.id,
                  method: "GET",
                }).then(function(data) {
                  if(data && data.data) {
                    var config = data.data.config;
                    $scope.accessConfig = {
                      name: config.name,
                      paid_only: config.paid_only,
                      selectedTags: [],
                      selectedCourse: [],
                      selectedModules: [],
                    };

                    config.tagsData.forEach(function(tag) {
                      if(tag.tag_id > 0) {
                        $scope.accessConfig.selectedTags.push({id: tag.tag_id})
                        $scope.accessConfig.specificTag = true;
                      }
                      else if(tag.module_id && tag.module_id.id) {
                        $scope.accessConfig.selectedModules.push({
                          id: tag.module_id.id,
                          name: tag.module_id.name,
                          course_name: tag.course_id.name,
                          course_id: tag.course_id.id
                        })
                        $scope.accessConfig.specificModule = true;
                      }
                      else if(tag.course_id && tag.course_id.id && !tag.module_id) {
                        console.log('doneeee')
                        $scope.accessConfig.selectedCourse.push({
                          id: tag.course_id.id,
                          name: tag.course_id.name
                        })
                        $scope.accessConfig.specificCourse = true;
                      }
                    })
                  }
                  
                });
              }

          $scope.updateConfig = function() {
            var currentDate = new Date(); 
            if (!$scope.accessConfig.name) {
              swal({
              title: "Error!",
              text: "Make sure you have filled all fields",
              type: "error",
              confirmButtonText: "Ok"
              });
              return;
            }
              $http.post('api/v1/post-question/update-config/' + $state.params.id, $scope.accessConfig)
              .then(function (data) {
                
                swal({
                  title: 'Post Question Configuration Updated',
                  text: "Post Question Configuration Updated Successfully!",
                  type: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                }, function () {
                    swal.close();
                    $state.go('post_questions_config', {});
                });
              });
          };

          sr.selectCourse = function (course, type) {
            if(type === 'course') {
              $scope.courses = [];
              $scope.courseKey = '';
              $scope.accessConfig.selectedCourse.push({
                id: course.id,
                name: course.name,
              })
            } else if(type === 'course-module') {
              $scope.coursesModule = [];
              $scope.courseModuleKey = course.name;
              getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
            }
            
          }

          sr.addModule = function (module, type) {
            module = JSON.parse(module)
            $scope.accessConfig.selectedModules.push({
              id: module.id,
              name: module.name,
              course_name: $scope.courseModuleKey,
              course_id: module.course_id,
            })
          }

          sr.selectModule = function (module) {
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
              })
            
          }

          sr.deleteCourse = function (courseToDelete, index) {
            var courses = []
            $scope.accessConfig.selectedCourse.forEach(function(course) {
              if(course.id !== courseToDelete.id) {
                courses.push(course)
              }
            })
            $scope.accessConfig.selectedCourse = courses;
          }

          sr.deleteModule = function (moduleToDelete, index) {
            var modules = []
            $scope.accessConfig.selectedModules.forEach(function(module) {
              if(module.id !== moduleToDelete.id) {
                modules.push(module)
              }
            })
            $scope.accessConfig.selectedModules = modules;
          }

          sr.searchInfo = function (value, type) {
            if (type === 'course' || type === 'module' || type === 'course-module') {
              getInfo({ key: value }, type, 'api/v1/courses/search');
            }
          }

          var getInfo = function (data, type, api) {
            HttpService.getRequest(api, data)
            .then(function (res) {
                if (type === 'course-module') {
                    sr.coursesModule = res.courses;
                } else if (type === 'course') {
                    sr.courses = res.courses;
                } else if (type === 'module') {
                    sr.modules = res.modules;
                } 
            });
          }

          if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
              $state.go('admin_panel', {}, { reload: true });
          }

      }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('addPostQuestionConfigController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            $scope.accessConfig = {
              paid_only: false
            };
            $scope.tags = [];
            $scope.accessConfig.selectedTags = [];
            $scope.accessConfig.selectedCourse = [];
            // $scope.accessConfig.selectedModules = [];
            

            $http({
                url: '/api/v1/coursetag/get',
                method: "GET",
              }).then(function(data) {
                if(data && data.data) {
                  data.data.courseTags.forEach(function (tag) {
                    $scope.tags.push({id: tag.id, label: tag.name})
                  });
                }
                
              });

            $scope.createAccessConfig = function() {
                
              if (!$scope.accessConfig.name) {
                  swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                  return;
              }

                $http.post('api/v1/post-question/create-config', $scope.accessConfig)
                .then(function (data) {
                  swal({
                    title: 'Post Question Configuration Created',
                    text: "Post Question Configuration Created Successfully!",
                    type: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                  }, function () {
                      swal.close();
                      $state.go('post_questions_config', {});
                  });
                  
                });
            };

            sr.selectCourse = function (course, type) {
              if(type === 'course') {
                $scope.courses = [];
                $scope.courseKey = '';
                $scope.accessConfig.selectedCourse.push({
                  id: course.id,
                  name: course.name,
                })
              } else if(type === 'course-module') {
                $scope.coursesModule = [];
                $scope.courseModuleKey = course.name;
                getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
              }
              
            }

            sr.addModule = function (module, type) {
              module = JSON.parse(module)
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
                course_name: $scope.courseModuleKey,
                course_id: module.course_id,
              })
            }

            sr.selectModule = function (module) {
                $scope.accessConfig.selectedModules.push({
                  id: module.id,
                  name: module.name,
                })
              
            }

            sr.deleteCourse = function (courseToDelete, index) {
              var courses = []
              $scope.accessConfig.selectedCourse.forEach(function(course) {
                if(course.id !== courseToDelete.id) {
                  courses.push(course)
                }
              })
              $scope.accessConfig.selectedCourse = courses;
            }

            sr.deleteModule = function (moduleToDelete, index) {
              var modules = []
              $scope.accessConfig.selectedModules.forEach(function(module) {
                if(module.id !== moduleToDelete.id) {
                  modules.push(module)
                }
              })
              $scope.accessConfig.selectedModules = modules;
            }

            sr.searchInfo = function (value, type) {
              if (type === 'course' || type === 'module' || type === 'course-module') {
                getInfo({ key: value }, type, 'api/v1/courses/search');
              }
            }

            var getInfo = function (data, type, api) {
              HttpService.getRequest(api, data)
              .then(function (res) {
                  if (type === 'course-module') {
                      sr.coursesModule = res.courses;
                  } else if (type === 'course') {
                      sr.courses = res.courses;
                  } else if (type === 'module') {
                      sr.modules = res.modules;
                  } 
              });
            }

            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            }

        }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addNpSharePercentageController', ['$scope', '$state', '$http', 'CustomStorageService', function ($scope, $state, $http, CustomStorageService) {

      var sr = $scope;
      
      $scope.selectedCourses = [];

      var getInsitutions = function () {
        $http({
          url: 'api/v1/courses/getUniversityList',
          method: "GET",
          params: { type: 'admin' }
        }).then(function (data) {
          sr.institutions = data.data;
          sr.selectedInstitution = "Select Institution";
        });
      }();

      sr.updateInstitution = function (institute) {
        sr.selected_faculty = $scope.institutions[institute].faculties;
        sr.selectedInstituteNo = institute;
      };
      sr.updateSchool = function (school) {
        sr.selectedFaculty = school;
        getCourses();
      }
      sr.updateCourse = function (course) {
        var course = sr.courses[course];
        $scope.selectedCourses.push(course);
      }
      var getCourses = function () {
        if (!sr.selectedInstitution || !sr.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: sr.institutions[sr.selectedInstituteNo].institution,
          faculty: sr.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function (data) {
          if (data.data.success) {
            // sr.courses = data.data.courses;
            $scope.selectedCourses = data.data.courses;
          } else {
            alert('server error');
          }
        });
      };

      sr.removeCourse = function (indexToRemove) {
        $scope.selectedCourses.splice(indexToRemove, 1);
      }

      sr.createPromptConfig = function () {
        $http({
          url: 'api/v1/courses/update-course-share-percentage',
          method: "POST",
          data: {courses: $scope.selectedCourses}
        }).then(function (data) {
           if (data.data.success) {
            sr.courses = data.data.courses;
            $state.go('NP_SHARE',{});
          } else {
            alert('server error');
          }
        });
      };

    }]);
})();

(function () {
  'use strict';
  angular
      .module('NearPeer')
      .controller('editMobilePopupConfigController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
          var sr = $scope;
          var signedIn = CustomStorageService.getAdminSignedInStorageData();
          $scope.accessConfig = {
            order_terminate_config: 'access-days'
          };
          $scope.tags = [];
          $scope.accessConfig.selectedTags = [];
          $scope.accessConfig.selectedCourse = [];
          // $scope.accessConfig.selectedModules = [];
          

          $http({
              url: '/api/v1/coursetag/get',
              method: "GET",
            }).then(function(data) {
              if(data && data.data) {
                data.data.courseTags.forEach(function (tag) {
                  $scope.tags.push({id: tag.id, label: tag.name})
                });
              }
              
            });

            if($state.params.id) {
                $http({
                  url: '/api/v1/mobile-browser-config/get-config/' + $state.params.id,
                  method: "GET",
                }).then(function(data) {
                  if(data && data.data) {
                    var config = data.data.config;
                    $scope.accessConfig = {
                      name: config.name,
                      paid_only: config.paid_only,
                      selectedTags: [],
                      selectedCourse: [],
                      selectedModules: [],
                    };

                    config.tagsData.forEach(function(tag) {
                      if(tag.tag_id > 0) {
                        $scope.accessConfig.selectedTags.push({id: tag.tag_id})
                        $scope.accessConfig.specificTag = true;
                      }
                      else if(tag.module_id && tag.module_id.id) {
                        $scope.accessConfig.selectedModules.push({
                          id: tag.module_id.id,
                          name: tag.module_id.name,
                          course_name: tag.course_id.name,
                          course_id: tag.course_id.id
                        })
                        $scope.accessConfig.specificModule = true;
                      }
                      else if(tag.course_id && tag.course_id.id && !tag.module_id) {
                        console.log('doneeee')
                        $scope.accessConfig.selectedCourse.push({
                          id: tag.course_id.id,
                          name: tag.course_id.name
                        })
                        $scope.accessConfig.specificCourse = true;
                      }
                    })
                  }
                  
                });
              }

          $scope.updateConfig = function() {
            var currentDate = new Date(); 
            if (!$scope.accessConfig.name) {
              swal({
              title: "Error!",
              text: "Make sure you have filled all fields",
              type: "error",
              confirmButtonText: "Ok"
              });
              return;
            }

            if($scope.accessConfig.selectedTags.length === 0 && $scope.accessConfig.selectedCourse.length === 0) {
              swal({
                title: "Error!",
                text: "Please select at-least one Tag or Course",
                type: "error",
                confirmButtonText: "Ok"
              });
              return;
            }
            
              $http.post('api/v1/mobile-browser-config/update-config/' + $state.params.id, $scope.accessConfig)
              .then(function (data) {
                
                swal({
                  title: 'Mobile Browser Configuration Updated',
                  text: "Mobile Browser Configuration Updated Successfully!",
                  type: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                }, function () {
                    swal.close();
                    $state.go('mobile_popup_config', {});
                });
              });
          };

          sr.selectCourse = function (course, type) {
            if(type === 'course') {
              $scope.courses = [];
              $scope.courseKey = '';
              $scope.accessConfig.selectedCourse.push({
                id: course.id,
                name: course.name,
              })
            } else if(type === 'course-module') {
              $scope.coursesModule = [];
              $scope.courseModuleKey = course.name;
              getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
            }
            
          }

          sr.addModule = function (module, type) {
            module = JSON.parse(module)
            $scope.accessConfig.selectedModules.push({
              id: module.id,
              name: module.name,
              course_name: $scope.courseModuleKey,
              course_id: module.course_id,
            })
          }

          sr.selectModule = function (module) {
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
              })
            
          }

          sr.deleteCourse = function (courseToDelete, index) {
            var courses = []
            $scope.accessConfig.selectedCourse.forEach(function(course) {
              if(course.id !== courseToDelete.id) {
                courses.push(course)
              }
            })
            $scope.accessConfig.selectedCourse = courses;
          }

          sr.deleteModule = function (moduleToDelete, index) {
            var modules = []
            $scope.accessConfig.selectedModules.forEach(function(module) {
              if(module.id !== moduleToDelete.id) {
                modules.push(module)
              }
            })
            $scope.accessConfig.selectedModules = modules;
          }

          sr.searchInfo = function (value, type) {
            if (type === 'course' || type === 'module' || type === 'course-module') {
              getInfo({ key: value }, type, 'api/v1/courses/search');
            }
          }

          var getInfo = function (data, type, api) {
            HttpService.getRequest(api, data)
            .then(function (res) {
                if (type === 'course-module') {
                    sr.coursesModule = res.courses;
                } else if (type === 'course') {
                    sr.courses = res.courses;
                } else if (type === 'module') {
                    sr.modules = res.modules;
                } 
            });
          }

          if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
              $state.go('admin_panel', {}, { reload: true });
          }

      }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('addMobilePopupConfigController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            $scope.accessConfig = {
              paid_only: false
            };
            $scope.tags = [];
            $scope.accessConfig.selectedTags = [];
            $scope.accessConfig.selectedCourse = [];
            // $scope.accessConfig.selectedModules = [];
            

            $http({
                url: '/api/v1/coursetag/get',
                method: "GET",
              }).then(function(data) {
                if(data && data.data) {
                  data.data.courseTags.forEach(function (tag) {
                    $scope.tags.push({id: tag.id, label: tag.name})
                  });
                }
                
              });

            $scope.createAccessConfig = function() {
                
              if (!$scope.accessConfig.name) {
                  swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                  return;
              }

              if($scope.accessConfig.selectedTags.length === 0 && $scope.accessConfig.selectedCourse.length === 0) {
                swal({
                  title: "Error!",
                  text: "Please select at-least one Tag or Course",
                  type: "error",
                  confirmButtonText: "Ok"
                });
                return;
              }

                $http.post('api/v1/mobile-browser-config/create-config', $scope.accessConfig)
                .then(function (data) {
                  swal({
                    title: 'Mobile Browser Configuration Created',
                    text: "Mobile Browser Configuration Created Successfully!",
                    type: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                  }, function () {
                      swal.close();
                      $state.go('mobile_popup_config', {});
                  });
                  
                });
            };

            sr.selectCourse = function (course, type) {
              if(type === 'course') {
                $scope.courses = [];
                $scope.courseKey = '';
                $scope.accessConfig.selectedCourse.push({
                  id: course.id,
                  name: course.name,
                })
              } else if(type === 'course-module') {
                $scope.coursesModule = [];
                $scope.courseModuleKey = course.name;
                getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
              }
              
            }

            sr.addModule = function (module, type) {
              module = JSON.parse(module)
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
                course_name: $scope.courseModuleKey,
                course_id: module.course_id,
              })
            }

            sr.selectModule = function (module) {
                $scope.accessConfig.selectedModules.push({
                  id: module.id,
                  name: module.name,
                })
              
            }

            sr.deleteCourse = function (courseToDelete, index) {
              var courses = []
              $scope.accessConfig.selectedCourse.forEach(function(course) {
                if(course.id !== courseToDelete.id) {
                  courses.push(course)
                }
              })
              $scope.accessConfig.selectedCourse = courses;
            }

            sr.deleteModule = function (moduleToDelete, index) {
              var modules = []
              $scope.accessConfig.selectedModules.forEach(function(module) {
                if(module.id !== moduleToDelete.id) {
                  modules.push(module)
                }
              })
              $scope.accessConfig.selectedModules = modules;
            }

            sr.searchInfo = function (value, type) {
              if (type === 'course' || type === 'module' || type === 'course-module') {
                getInfo({ key: value }, type, 'api/v1/courses/search');
              }
            }

            var getInfo = function (data, type, api) {
              HttpService.getRequest(api, data)
              .then(function (res) {
                  if (type === 'course-module') {
                      sr.coursesModule = res.courses;
                  } else if (type === 'course') {
                      sr.courses = res.courses;
                  } else if (type === 'module') {
                      sr.modules = res.modules;
                  } 
              });
            }

            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            }

        }]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("addInstructorController", [
    "Upload",
    "$scope",
    "$http",
    "$rootScope",
    "$state",
    "HttpService",
    "CustomStorageService",
    function (
      Upload,
      $scope,
      $http,
      $rootScope,
      $state,
      HttpService,
      CustomStorageService
    ) {
      $scope.id = $state.params.id;
      $scope.isEdit = $state.params.id ? true : false;

      $scope.tags = [];
      $scope.selectedCourses = [];
      $scope.courses = [];
      $scope.instructor = {
        name: "",
        experience: "",
        description: "",
        image: "",
      };
      $scope.instructorCourses = [];
      $scope.InstructorTags = [];
      if ($scope.isEdit) {
        $http({
          url: "/api/v1/instructors/getStoredInstructorById/" + $scope.id,
          method: "GET",
        }).then(function (res) {
          if (res.data.success) {
            $scope.instructor.name = res.data.instructor.name;
            $scope.instructor.description = res.data.instructor.description;
            $scope.instructor.experience = res.data.instructor.experience;
            $scope.instructor.image = res.data.instructor.image;
            $scope.instructorCourses = res.data.courses;
            for (var i = 0; i < $scope.instructorCourses.length; i++) {
              var course = $scope.instructorCourses[i];

              if (course.course_id) {
                $scope.selectedCourses.push({
                  id: course.course_id.id,
                  name: course.course_id.name,
                });
              } else if (course.tag_id) {
                $scope.InstructorTags.push({
                  id: course.tag_id.id,
                  label: course.tag_id.name,
                });
              }
            }
            // $scope.selectedCourses = data.courseTag.courses;
            // $scope.tags = data.data.courseTag.name;
          }
        });
      }
      $http({
        url: "/api/v1/coursetag/get",
        method: "GET",
      }).then(function (data) {
        console.log(data);
        if (data && data.data) {
          data.data.courseTags.forEach(function (tag) {
            if (tag.id !== null && tag.id !== undefined) {
              $scope.tags.push({ id: tag.id, label: tag.name });
            }
          });
        }
      });
      console.log("instructor description", $scope.instructor.description);
      $scope.updateInstructorTags = function (tagId, tagName) {
        console.log("instructorTags-----", $scope.InstructorTags);
        console.log("Selected or deselected tag:", tagId);
        console.log("Selected or deselected tag:", tagName);
      };

      $scope.deletecourse = function (index) {
        $scope.selectedCourses.splice(index, 1);
      };
      $scope.deleteTag = function (index) {
        $scope.InstructorTags.splice(index, 1);
      };
      $scope.searchInfo = function (value, type) {
        if (
          type === "course" ||
          type === "module" ||
          type === "course-module"
        ) {
          getInfo({ key: value }, type, "api/v1/courses/search");
        }
      };

      var getInfo = function (data, type, api) {
        HttpService.getRequest(api, data).then(function (res) {
          if (type === "course-module") {
            $scope.coursesModule = res.courses;
          } else if (type === "course") {
            $scope.courses = res.courses;
          } else if (type === "module") {
            $scope.modules = res.modules;
          }
        });
      };

      $scope.selectCourse = function (course, type) {
        if (type === "course") {
          $scope.courses = [];
          $scope.courseKey = "";
          $scope.selectedCourses.push({
            id: course.id,
            name: course.name,
          });
        }
      };
      $scope.uploadImage = function (file) {
        if (file) {
          if (file.size > 1000000) {
            return alert("Image size must be less then 1 mb");
          }
          Upload.upload({
            url: "/api/v1/uploader/uploadImageToS3",
            method: "POST",
            file: file,
            params: {
              userId: CustomStorageService.getUserInfoStorageData().id,
            },
          }).then(function (resp) {
            $scope.instructor.image = resp.data.link;
          });
        }
      };
      $scope.HandleSave = function () {
        // Extract 'id' values from objects in $scope.InstructorTags and store in tagIds
        var courseIds = $scope.selectedCourses.map(function (course) {
          return course.id;
        });
        // Extract 'id' values from objects in $scope.InstructorTags and store in tagIds
        var tagIds = $scope.InstructorTags.map(function (tag) {
          return tag.id;
        });

        var requestBody = {
          name: $scope.instructor.name,
          experience: $scope.instructor.experience,
          description: $scope.instructor.description,
          image: $scope.instructor.image,
          tagIds: tagIds,
          courseIds: courseIds,
        };
        if ($scope.isEdit) {
          // Make the API call to update instructor details
          $http({
            url: "/api/v1/instructors/updateInstructorDetails/" + $scope.id,
            method: "PUT",
            data: requestBody,
          })
            .then(function (response) {
              swal({
                title: "Success!",
                text: "Instructor Updated Successfully!",
                type: "success",
                confirmButtonText: "Ok",
              });
              console.log("API response:", response.data);
            })
            .catch(function (error) {
              swal({
                title: "Error!",
                text: "InTernal Server Problem!",
                type: "error",
                confirmButtonText: "Ok",
              });
              console.error("API error:", error);
            });
        } else {
          $http({
            url: "/api/v1/instructors/storeInstructorDetails",
            method: "POST",
            data: requestBody,
          })
            .then(function (response) {
              swal({
                title: "Success!",
                text: "Instructor Created Successfully!",
                type: "success",
                confirmButtonText: "Ok",
              });
              console.log("API response:", response.data);
            })
            .catch(function (error) {
              swal({
                title: "Error!",
                text: "InTernal Server Problem!",
                type: "error",
                confirmButtonText: "Ok",
              });
              console.error("API error:", error);
            });
        }
      };
      $scope.otherMedium = false;

      $scope.instructor = {
        type: "organic",
        medium: [],
        otherMedium: "",
        category: "tof",
        behavior: "retargeting",
      };
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("addHtmlPagesController", [
    "$scope",
    "CustomStorageService",
    "HttpService",
    "$http",
    "$state",
    "env",
    function ($scope, CustomStorageService, HttpService, $http, $state, env) {
      function encodeBase64(str) {
        return btoa(unescape(encodeURIComponent(str)));
      }

      function decodeBase64(str) {
        return decodeURIComponent(escape(atob(str)));
      }

      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      $scope.page = {};

      if($state.params.id) {
        // Load existing page for editing
        $http({
          url: env.backendService + '/lmsservice/v1/pages/' + $state.params.id,
          method: "GET",
        }).then(function(response) {
          if(response.data && response.data.data) {
            $scope.page = response.data.data;
            if ($scope.page.content) {
              try {
                $scope.page.content = decodeBase64($scope.page.content);
              } catch (e) {
                console.error("Base64 decode failed:", e);
              }
            }
          }
        }).catch(function(error) {
          console.error('Error loading page:', error);
          swal({
            title: "Error",
            text: "Failed to load page data",
            type: "error"
          });
        });
      }

      $scope.savePage = function () {
        if (!$scope.page.name || !$scope.page.content) {
          swal({
            title: "Error!",
            text: "Please fill all required fields (Name, Content)",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }

        // For new pages, link is required
        if (!$state.params.id && !$scope.page.link) {
          swal({
            title: "Error!",
            text: "Please provide a link for the new page",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }

        // Validate link format (slug) if provided
        if ($scope.page.link) {
          var linkRegex = /^[a-z0-9-]+$/;
          if (!linkRegex.test($scope.page.link)) {
            swal({
              title: "Error!",
              text: "Link must contain only lowercase letters, numbers, and hyphens",
              type: "error",
              confirmButtonText: "Ok",
            });
            return;
          }
        }

        var method = $state.params.id ? "PUT" : "POST";
        var url = env.backendService + '/lmsservice/v1/pages' + ($scope.page.id ? '/' + $scope.page.id : '');
        var encodedContent = encodeBase64($scope.page.content);
        // Prepare payload - for updates, only send name and content
        var payload = $state.params.id ?
          { name: $scope.page.name, content: encodedContent } :
          Object.assign({}, $scope.page, {content: encodedContent});
        $http({
          url: url,
          method: method,
          data: payload,
          headers: {
            'uid': CustomStorageService.getUserInfoStorageData().id || '123'
          }
        }).then(function (response) {
          if(response.data.success) {
            swal({
              title: "Success",
              text: "Page " + ($state.params.id ? "updated" : "created") + " successfully!",
              type: "success",
              showConfirmButton: false,
              timer: 2000,
            }, function () {
              swal.close();
              $state.go("HtmlPages", {});
            });
          } else {
            swal({
              title: "Error",
              text: response.data.message || "Failed to save page",
              type: "error"
            });
          }
        }).catch(function(error) {
          console.error('Error saving page:', error);
          swal({
            title: "Error",
            text: "Failed to save page",
            type: "error"
          });
        });
      };

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("admin_panel", {}, { reload: true });
      }
    },
  ]);
})();

(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('FreeAccessTrackingController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			const userData = CustomStorageService.getUserInfoStorageData();
      const isSuperAdmin = userData.is_super_admin;
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user'];
			sr.searchData = [];
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				emailAdmin: userData.email
			};
			sr.searchOrder = function (value, type, flag, first, row) {
				if (first) {
					sr.searchParams.page = 1;
				}
				if ((type === "user" || type === "course") && !flag) {
					SearchService.getSearchData(value, type)
						.then(function (data) {
							sr.searchData = data;
						});
				} else if ((type === "user" || type === "course") && flag) {
					if(row) {
						sr.searchParams.keyId = row.id;
					}
					sr.searchParams.key = value;
					sr.searchData = [];
					getOrders(sr.searchParams);
				}
			}
			var getOrders = function (data) {
				HttpService.postRequest('api/v1/free-access/get-free-access-tracking', data)
					.then(function (res) {
						if (res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							}, function () {
								swal.close();
								sr.searchParams.forDownload = false;
							});

						} else {
							sr.tracking = res.trackingData;
							sr.totalPages = res.totalPages;
							sr.totalCount = res.totalCount;
						}

					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true, false);
				}
			}
			sr.changeType = function (type) {
				sr.searchParams.type = type;
				sr.searchParams.key = "";
				if (type === 'all') {
					getOrders(sr.searchParams);
				}
			}
			sr.terminateOrder = function (id) {
				$http({
					url: '/api/v1/orders/terminate',
					method: "GET",
					params: { id: id }
				}).then(function (data) {
					if (data.data.success) {
						swal({
							title: 'Success!',
							text: "Order Status Updated!",
							type: 'success',
							showConfirmButton: true
						}, function () {
							getOrders(sr.searchParams);
						});
					}
				});
			}
			sr.downloadTracking = function () {
				if ($scope.fromDate && $scope.toDate) {
					const date1 = new Date($scope.fromDate);
					const date2 = new Date($scope.toDate);
					date2.setHours(date2.getHours() + 12);
					const diffTime = Math.abs(date2 - date1);
					const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
					var fromDate = new Date($scope.fromDate);
					fromDate = new Date(fromDate.getTime() + (3600000 * 5.00));
					var toDate = new Date($scope.toDate);
					toDate = new Date(toDate.getTime() + (3600000 * 5.00));
					sr.searchParams.fromDate = fromDate;
					sr.searchParams.toDate = toDate;
					sr.searchParams.forDownload = true;
					getOrders(sr.searchParams);
				} else {
					swal({
						title: 'Error',
						text: "Please Select to and from date!",
						type: 'error',
						showConfirmButton: true
					}, function () {
						
					});
				}

			}

			// sr.formatDate = function (date) {
			// 	var dateOut = new Date(date);
			// 	dateOut = new Date(dateOut.getTime() + (3600000 * 5.00));
			// 	return dateOut;
			// };
			sr.viewOrderTrail =function (id){
				$state.go('AdminOrderEditTrail', {id: id});
			}

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
			}
		}]);
})();

(function () {
  'use strict';
  angular
      .module('NearPeer')
      .controller('editFreeAccessController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
          var sr = $scope;
          var signedIn = CustomStorageService.getAdminSignedInStorageData();
          $scope.accessConfig = {
            order_terminate_config: 'access-days'
          };
          $scope.tags = [];
          $scope.accessConfig.selectedTags = [];
          $scope.accessConfig.selectedCourse = [];
          $scope.accessConfig.selectedModules = [];
          

          $http({
              url: '/api/v1/coursetag/get',
              method: "GET",
            }).then(function(data) {
              if(data && data.data) {
                data.data.courseTags.forEach(function (tag) {
                  $scope.tags.push({id: tag.id, label: tag.name})
                });
              }
              
            });

            if($state.params.id) {
                $http({
                  url: '/api/v1/free-access/get-config/' + $state.params.id,
                  method: "GET",
                }).then(function(data) {
                  if(data && data.data) {
                    var config = data.data.config;
                    $scope.accessConfig = {
                      name: config.name,
                      from_joining: new Date(config.from_joining),
                      to_joining: new Date(config.to_joining),
                      selectedTags: [],
                      selectedCourse: [],
                      selectedModules: [],
                    };

                    config.tagsData.forEach(function(tag) {
                      if(tag.tag_id > 0) {
                        $scope.accessConfig.selectedTags.push({id: tag.tag_id})
                        $scope.accessConfig.specificTag = true;
                      }
                      else if(tag.module_id && tag.module_id.id) {
                        $scope.accessConfig.selectedModules.push({
                          id: tag.module_id.id,
                          name: tag.module_id.name,
                          course_name: tag.course_id.name,
                          course_id: tag.course_id.id
                        })
                        $scope.accessConfig.specificModule = true;
                      }
                      else if(tag.course_id && tag.course_id.id && !tag.module_id) {
                        console.log('doneeee')
                        $scope.accessConfig.selectedCourse.push({
                          id: tag.course_id.id,
                          name: tag.course_id.name
                        })
                        $scope.accessConfig.specificCourse = true;
                      }
                    })
                  }
                  
                });
              }

          $scope.updateConfig = function() {
            var currentDate = new Date(); 
            if (!$scope.accessConfig.from_joining || !$scope.accessConfig.to_joining || !$scope.accessConfig.name) {
              swal({
              title: "Error!",
              text: "Make sure you have filled all fields",
              type: "error",
              confirmButtonText: "Ok"
              });
              return;
            }
              $http.post('api/v1/free-access/update-config/' + $state.params.id, $scope.accessConfig)
              .then(function (data) {
                
                swal({
                  title: 'Free Access Configuration Updated',
                  text: "Free Access Configuration Updated Successfully!",
                  type: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                }, function () {
                    swal.close();
                    $state.go('free_access', {});
                });
              });
          };

          sr.selectCourse = function (course, type) {
            if(type === 'course') {
              $scope.courses = [];
              $scope.courseKey = '';
              $scope.accessConfig.selectedCourse.push({
                id: course.id,
                name: course.name,
              })
            } else if(type === 'course-module') {
              $scope.coursesModule = [];
              $scope.courseModuleKey = course.name;
              getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
            }
            
          }

          sr.addModule = function (module, type) {
            module = JSON.parse(module)
            $scope.accessConfig.selectedModules.push({
              id: module.id,
              name: module.name,
              course_name: $scope.courseModuleKey,
              course_id: module.course_id,
            })
          }

          sr.selectModule = function (module) {
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
              })
            
          }

          sr.deleteCourse = function (courseToDelete, index) {
            var courses = []
            $scope.accessConfig.selectedCourse.forEach(function(course) {
              if(course.id !== courseToDelete.id) {
                courses.push(course)
              }
            })
            $scope.accessConfig.selectedCourse = courses;
          }

          sr.deleteModule = function (moduleToDelete, index) {
            var modules = []
            $scope.accessConfig.selectedModules.forEach(function(module) {
              if(module.id !== moduleToDelete.id) {
                modules.push(module)
              }
            })
            $scope.accessConfig.selectedModules = modules;
          }

          sr.searchInfo = function (value, type) {
            if (type === 'course' || type === 'module' || type === 'course-module') {
              getInfo({ key: value }, type, 'api/v1/courses/search');
            }
          }

          var getInfo = function (data, type, api) {
            HttpService.getRequest(api, data)
            .then(function (res) {
                if (type === 'course-module') {
                    sr.coursesModule = res.courses;
                } else if (type === 'course') {
                    sr.courses = res.courses;
                } else if (type === 'module') {
                    sr.modules = res.modules;
                } 
            });
          }

          if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
              $state.go('admin_panel', {}, { reload: true });
          }

      }]);
})();

(function () {
  'use strict';
  angular
      .module('NearPeer')
      .controller('addFormController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
          var sr = $scope;
          var signedIn = CustomStorageService.getAdminSignedInStorageData();
          $scope.form = {
            order_terminate_config: 'access-days',
            userType: 'purchased',
            specificCourse: true,
          };
          $scope.tags = [];
          $scope.form.selectedTags = [];
          $scope.form.selectedCourse = [];
          $scope.form.selectedModules = [];

          var hideFormBuilderAction = function() {
            var formAction = document.getElementsByClassName('form-actions');
            if(formAction && formAction.length > 0) {
              formAction[0].style.display = 'none'
            } else {
              setTimeout(function() {
                hideFormBuilderAction();
              }, 500)
              
            }
          }

          hideFormBuilderAction();

          $http({
              url: '/api/v1/coursetag/get',
              method: "GET",
            }).then(function(data) {
              if(data && data.data) {
                data.data.courseTags.forEach(function (tag) {
                  $scope.tags.push({id: tag.id, label: tag.name})
                });
              }
              
            });
            var formBuilder;
            setTimeout(function() {
              formBuilder = $(document.getElementById('fb-editor')).formBuilder({
                controlOrder: ['text', 'textarea', 'number', 'date', 'checkbox-group', 'radio-group', 'select'],
                disableFields: ['autocomplete', 'file', 'hidden', 'starRating']
              });
            }, 100)

            if($state.params.id) {
                $http({
                  url: '/api/v1/custom-form/get-custom-form/' + $state.params.id,
                  method: "GET",
                }).then(function(data) {
                  if(data && data.data) {
                    var form = data.data.result;
                    $scope.form = {
                      id: form.id,
                      name: form.form_name,
                      description: form.form_description,
                      formData: form.form_data,
                      mobileForm: form.mobile_form,
                      userType: form.user_type,
                      selectedTags: [],
                      selectedCourse: [],
                      selectedModules: [],
                    };
                    setTimeout(function() {
                      formBuilder.actions.setData(JSON.stringify(form.form_data));
                    }, 500)

                    form.configs.forEach(function(config) {
                      if(config.tag_id > 0) {
                        $scope.form.selectedTags.push({id: config.tag_id})
                        $scope.form.specificTag = true;
                      }
                      else if(config.module_id && config.module_id.id) {
                        $scope.form.selectedModules.push({
                          id: config.module_id.id,
                          name: config.module_id.name,
                          course_name: config.course_id.name,
                          course_id: config.course_id.id
                        })
                        $scope.form.specificModule = true;
                      }
                      else if(config.course_id && config.course_id.id && !config.module_id) {
                      console.log('config.course_id 11');
                        
                        $scope.form.selectedCourse.push({
                          id: config.course_id.id,
                          name: config.course_id.name
                        })
                        $scope.form.specificCourse = true;
                      }
                    })
                    console.log('$scope.form');
                    console.log($scope.form);
                  }
                  
                });
              }
          $scope.updateFrom = function() {

              if (!$scope.form.name) {
                  swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                  return;
              }
              var formData = formBuilder.actions.getData('json');
              $scope.form.formData = formData;
              var url = 'api/v1/custom-form/add-custom-form';
              if($state.params.id) {
                url = '/api/v1/custom-form/update-custom-form'
              }
              $http.post(url, $scope.form)
              .then(function (data) {
                
                swal({
                  title: 'Form Updated',
                  text: "Form Updated Successfully!",
                  type: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                }, function () {
                    swal.close();
                    $state.go('form_builder', {});
                });
              });
          };

          sr.selectCourse = function (course, type) {
            if(type === 'course') {
              $scope.courses = [];
              $scope.courseKey = '';
              console.log('$scope.form');
              console.log($scope.form);
              if(!$scope.form.selectedCourse) {
                $scope.form.selectedCourse = [];
              }
              $scope.form.selectedCourse.push({
                id: course.id,
                name: course.name,
              })
            } else if(type === 'course-module') {
              $scope.coursesModule = [];
              $scope.courseModuleKey = course.name;
              getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
            }
            
          }

          sr.addModule = function (module, type) {
            module = JSON.parse(module)
            $scope.form.selectedModules.push({
              id: module.id,
              name: module.name,
              course_name: $scope.courseModuleKey,
              course_id: module.course_id,
            })
          }

          sr.selectModule = function (module) {
              $scope.form.selectedModules.push({
                id: module.id,
                name: module.name,
              })
            
          }

          sr.deleteCourse = function (courseToDelete, index) {
            var courses = []
            $scope.form.selectedCourse.forEach(function(course) {
              if(course.id !== courseToDelete.id) {
                courses.push(course)
              }
            })
            $scope.form.selectedCourse = courses;
          }

          sr.deleteModule = function (moduleToDelete, index) {
            var modules = []
            $scope.form.selectedModules.forEach(function(module) {
              if(module.id !== moduleToDelete.id) {
                modules.push(module)
              }
            })
            $scope.form.selectedModules = modules;
          }

          sr.searchInfo = function (value, type) {
            if (type === 'course' || type === 'module' || type === 'course-module') {
              getInfo({ key: value }, type, 'api/v1/courses/search');
            }
          }

          var getInfo = function (data, type, api) {
            HttpService.getRequest(api, data)
            .then(function (res) {
                if (type === 'course-module') {
                    sr.coursesModule = res.courses;
                } else if (type === 'course') {
                    sr.courses = res.courses;
                } else if (type === 'module') {
                    sr.modules = res.modules;
                } 
            });
          }
          // if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
          //     $state.go('admin_panel', {}, { reload: true });
          // }

      }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('addFreeAccessController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            $scope.accessConfig = {};
            $scope.tags = [];
            $scope.accessConfig.selectedTags = [];
            $scope.accessConfig.selectedCourse = [];
            $scope.accessConfig.selectedModules = [];
            

            $http({
                url: '/api/v1/coursetag/get',
                method: "GET",
              }).then(function(data) {
                if(data && data.data) {
                  data.data.courseTags.forEach(function (tag) {
                    $scope.tags.push({id: tag.id, label: tag.name})
                  });
                }
                
              });

            $scope.createAccessConfig = function() {
                
              if (!$scope.accessConfig.from_joining || !$scope.accessConfig.to_joining || !$scope.accessConfig.name) {
                  swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                  return;
              }

                $http.post('api/v1/free-access/create-config', $scope.accessConfig)
                .then(function (data) {
                  swal({
                    title: 'Free Access Configuration Created',
                    text: "Free Access Configuration Created Successfully!",
                    type: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                  }, function () {
                      swal.close();
                      $state.go('free_access', {});
                  });
                  
                });
            };

            sr.selectCourse = function (course, type) {
              if(type === 'course') {
                $scope.courses = [];
                $scope.courseKey = '';
                $scope.accessConfig.selectedCourse.push({
                  id: course.id,
                  name: course.name,
                })
              } else if(type === 'course-module') {
                $scope.coursesModule = [];
                $scope.courseModuleKey = course.name;
                getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
              }
              
            }

            sr.addModule = function (module, type) {
              module = JSON.parse(module)
              $scope.accessConfig.selectedModules.push({
                id: module.id,
                name: module.name,
                course_name: $scope.courseModuleKey,
                course_id: module.course_id,
              })
            }

            sr.selectModule = function (module) {
                $scope.accessConfig.selectedModules.push({
                  id: module.id,
                  name: module.name,
                })
              
            }

            sr.deleteCourse = function (courseToDelete, index) {
              var courses = []
              $scope.accessConfig.selectedCourse.forEach(function(course) {
                if(course.id !== courseToDelete.id) {
                  courses.push(course)
                }
              })
              $scope.accessConfig.selectedCourse = courses;
            }

            sr.deleteModule = function (moduleToDelete, index) {
              var modules = []
              $scope.accessConfig.selectedModules.forEach(function(module) {
                if(module.id !== moduleToDelete.id) {
                  modules.push(module)
                }
              })
              $scope.accessConfig.selectedModules = modules;
            }

            sr.searchInfo = function (value, type) {
              if (type === 'course' || type === 'module' || type === 'course-module') {
                getInfo({ key: value }, type, 'api/v1/courses/search');
              }
            }

            var getInfo = function (data, type, api) {
              HttpService.getRequest(api, data)
              .then(function (res) {
                  if (type === 'course-module') {
                      sr.coursesModule = res.courses;
                  } else if (type === 'course') {
                      sr.courses = res.courses;
                  } else if (type === 'module') {
                      sr.modules = res.modules;
                  } 
              });
            }

            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            }

        }]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('addEnrollmentGroupController', ['$scope','$state','$http','CustomStorageService', function($scope,$state,$http,CustomStorageService) {
      
      $scope.selectedInstitution = "Select Institution";
      $scope.selectedSchool = "Select Faculty";
      $scope.selectedCourse = "Select Course";
      $scope.autoEnroll = true;
      $scope.selectedCourses = [];
      $scope.tagName;
      $scope.id = $state.params.id;

      $scope.myFilter = function (item) {
        return !item.deleted;
      };

      $http({
        url:'api/v1/courses/getUniversityList',
        method:"GET",
        params: {type: 'admin'}
      }).then(function (data) {
        $scope.institutions = data.data;
      });

      if($scope.id) {
        $http({
          url:'/api/v1/enrollment-group/' + $scope.id,
          method:"GET",
          params: {type: 'admin'}
        }).then(function (data) {
          if(data.data.success) {
            $scope.selectedCourses = data.data.courseTag.courses;
            $scope.tagName = data.data.courseTag.name;
            $scope.autoEnroll = data.data.courseTag.auto_enroll;
          }
        });
      }
      
      
      $scope.removeCourse = function (course){
        course.deleted = true;
      };

      $scope.updateInstitution = function(institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
      };

      $scope.updateSchool = function(school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };

      $scope.updateCourse = function(index){
       if(index!=='null'){
        $scope.courses[index].isNew = true;
        $scope.selectedCourses.push($scope.courses[index]);
        var id = $scope.courses[index].id;
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: "GET",
          params: {id: id}
        }).then(function(data) {
          $scope.modules = data.data.modules;
        });
       }
      };

      $scope.getCourses = function() {
        if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if(data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert('server error');
          }

        });
      };

      $scope.deleteTag = function () {
        $http({
          url:'/api/v1/enrollment-group/delete/' + $scope.id,
          method:"Delete",
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Deleted!','success');
              $state.go('courseTags', {}, { reload: true });
            } else {
              swal('Error',res.data.message,'error');
            }
            
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }

      $scope.saveTag = function () {
        if(!$scope.tagName){
          swal('Error','Please Enter Tag Name','error');
        }else if($scope.selectedCourses.length===0){
          swal('Error','Select Course To Add','error');
        } else {
          if($scope.id) {
            $scope.updateCourseTag();
          } else {
            $scope.createCourseTag();
          }
        }
      }

      $scope.createCourseTag = function() {
          var data ={
            tagName: $scope.tagName,
            courses: $scope.selectedCourses,
            autoEnroll: $scope.autoEnroll
          };
          $http({
            url:'api/v1/enrollment-group/create',
            method:"POST",
            data: data
          }).then(function (res) {
            if(res){
              if(res.data.success) {
                swal('Success','Successfully Added!','success');
              } else {
                swal('Error',res.data.message,'error');
              }
              
            }else{
              swal('Error','Error saving tag!','error');
            }
          });
      }

      $scope.updateCourseTag = function(){
        var data ={
          tagName: $scope.tagName,
          courses: $scope.selectedCourses,
          autoEnroll: $scope.autoEnroll
        };
        $http({
          url:'/api/v1/enrollment-group/edit/' + $scope.id,
          method:"PUT",
          data: data
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Updated!','success');
            } else {
              swal('Error',res.data.message,'error');
            }
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }
    }]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('AddTagsController', ['$scope','$state','$http','CustomStorageService', function($scope,$state,$http,CustomStorageService) {
      
      $scope.selectedInstitution = "Select Institution";
      $scope.selectedSchool = "Select Faculty";
      $scope.selectedCourse = "Select Course";
      $scope.selectedCourses = [];
      $scope.tagName;
      $scope.mobileMarket = false;
      $scope.id = $state.params.id;

      $scope.myFilter = function (item) {
        return !item.deleted;
      };

      $http({
        url:'api/v1/courses/getUniversityList',
        method:"GET",
        params: {type: 'admin'}
      }).then(function (data) {
        $scope.institutions = data.data;
      });

      if($scope.id) {
        $http({
          url:'/api/v1/coursetag/' + $scope.id,
          method:"GET",
          params: {type: 'admin'}
        }).then(function (data) {
          if(data.data.success) {
            $scope.selectedCourses = data.data.courseTag.courses;
            $scope.tagName = data.data.courseTag.name;
            $scope.mobileMarket = data.data.courseTag.mobile_market;
          }
        });
      }
      
      
      $scope.removeCourse = function (course){
        course.deleted = true;
      };

      $scope.updateInstitution = function(institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
      };

      $scope.updateSchool = function(school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };

      $scope.updateCourse = function(index){
       if(index!=='null'){
        $scope.courses[index].isNew = true;
        $scope.selectedCourses.push($scope.courses[index]);
        var id = $scope.courses[index].id;
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: "GET",
          params: {id: id}
        }).then(function(data) {
          $scope.modules = data.data.modules;
        });
       }
      };

      $scope.getCourses = function() {
        if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if(data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert('server error');
          }

        });
      };

      $scope.deleteTag = function () {
        $http({
          url:'/api/v1/coursetag/delete/' + $scope.id,
          method:"Delete",
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Deleted!','success');
              $state.go('courseTags', {}, { reload: true });
            } else {
              swal('Error',res.data.message,'error');
            }
            
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }

      $scope.saveTag = function () {
        if(!$scope.tagName){
          swal('Error','Please Enter Tag Name','error');
        }else if($scope.selectedCourses.length===0){
          swal('Error','Select Course To Add','error');
        } else {
          if($scope.id) {
            $scope.updateCourseTag();
          } else {
            $scope.createCourseTag();
          }
        }
      }

      $scope.createCourseTag = function() {
          var data ={
            tagName: $scope.tagName,
            mobile_market: $scope.mobileMarket,
            courses: $scope.selectedCourses,
          };
          $http({
            url:'api/v1/coursetag/create',
            method:"POST",
            data: data
          }).then(function (res) {
            if(res){
              if(res.data.success) {
                swal('Success','Successfully Added!','success');
              } else {
                swal('Error',res.data.message,'error');
              }
              
            }else{
              swal('Error','Error saving tag!','error');
            }
          });
      }

      $scope.updateCourseTag = function(){
        var data ={
          tagName: $scope.tagName,
          mobile_market: $scope.mobileMarket,
          courses: $scope.selectedCourses,
        };
        $http({
          url:'/api/v1/coursetag/edit/' + $scope.id,
          method:"PUT",
          data: data
        }).then(function (res) {
          if(res){
            if(res.data.success) {
              swal('Success','Successfully Updated!','success');
            } else {
              swal('Error',res.data.message,'error');
            }
          }else{
            swal('Error','Error saving tag!','error');
          }
        });
      }
    }]);
  })();

(function () {
  'use strict';
  angular
      .module('NearPeer')
      .controller('editCouponController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
          var sr = $scope;
          var signedIn = CustomStorageService.getAdminSignedInStorageData();
          $scope.coupon = {
            order_terminate_config: 'access-days'
          };
          $scope.tags = [];
          $scope.coupon.selectedTags = [];
          $scope.coupon.selectedCourse = [];
          $scope.coupon.selectedModules = [];
          

          $http({
              url: '/api/v1/coursetag/get',
              method: "GET",
            }).then(function(data) {
              if(data && data.data) {
                data.data.courseTags.forEach(function (tag) {
                  $scope.tags.push({id: tag.id, label: tag.name})
                });
              }
              
            });

            if($state.params.id) {
                $http({
                  url: '/api/v1/coupons/get-coupon/' + $state.params.id,
                  method: "GET",
                }).then(function(data) {
                  if(data && data.data) {
                    var coupon = data.data.coupon;
                    $scope.coupon = {
                      name: coupon.coupon_id,
                      price: coupon.price,
                      expiryDate: new Date(coupon.expiry_date),
                      peruse: coupon.peruse,
                      total_frequency: coupon.total_frequency,
                      access_days: coupon.access_days,
                      order_terminate_config: coupon.order_terminate_config,
                      selectedTags: [],
                      selectedCourse: [],
                      selectedModules: [],
                    };

                    coupon.tags.forEach(function(tag) {
                      if(tag.tag_id > 0) {
                        $scope.coupon.selectedTags.push({id: tag.tag_id})
                        $scope.coupon.specificTag = true;
                      }
                      else if(tag.module_id && tag.module_id.id) {
                        $scope.coupon.selectedModules.push({
                          id: tag.module_id.id,
                          name: tag.module_id.name,
                          course_name: tag.course_id.name,
                          course_id: tag.course_id.id
                        })
                        $scope.coupon.specificModule = true;
                      }
                      else if(tag.course_id && tag.course_id.id && !tag.module_id) {
                        $scope.coupon.selectedCourse.push({
                          id: tag.course_id.id,
                          name: tag.course_id.name
                        })
                        $scope.coupon.specificCourse = true;
                      }
                    })
                  }
                  
                });
              }

          $scope.updateCoupons = function() {
            var currentDate = new Date(); 
            console.log(currentDate > $scope.coupon.expiryDate)
            if(currentDate > $scope.coupon.expiryDate) {
              swal({
                title: "Error!",
                text: "Please select future expiry date",
                type: "error",
                confirmButtonText: "Ok"
                });
              return;
            }

              $scope.coupon.quantity = 1;
              if($scope.coupon.order_terminate_config === 'access-days' && (!$scope.coupon.access_days || $scope.coupon.access_days < 1)) {
                swal({
                  title: "Error!",
                  text: "Please enter value for Access Days",
                  type: "error",
                  confirmButtonText: "Ok"
                });
                return;
              }
              if (!$scope.coupon.name || !$scope.coupon.quantity || !$scope.coupon.price || !$scope.coupon.expiryDate) {
                  swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                  return;
              }
              $http.post('api/v1/coupons/update-coupon/' + $state.params.id, $scope.coupon)
              .then(function (data) {
                
                swal({
                  title: 'Coupon Updated',
                  text: "Coupon Updated Successfully!",
                  type: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                }, function () {
                    swal.close();
                    $state.go('coupon', {});
                });
              });
          };

          sr.selectCourse = function (course, type) {
            if(type === 'course') {
              $scope.courses = [];
              $scope.courseKey = '';
              $scope.coupon.selectedCourse.push({
                id: course.id,
                name: course.name,
              })
            } else if(type === 'course-module') {
              $scope.coursesModule = [];
              $scope.courseModuleKey = course.name;
              getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
            }
            
          }

          sr.addModule = function (module, type) {
            module = JSON.parse(module)
            $scope.coupon.selectedModules.push({
              id: module.id,
              name: module.name,
              course_name: $scope.courseModuleKey,
              course_id: module.course_id,
            })
          }

          sr.selectModule = function (module) {
              $scope.coupon.selectedModules.push({
                id: module.id,
                name: module.name,
              })
            
          }

          sr.deleteCourse = function (courseToDelete, index) {
            var courses = []
            $scope.coupon.selectedCourse.forEach(function(course) {
              if(course.id !== courseToDelete.id) {
                courses.push(course)
              }
            })
            $scope.coupon.selectedCourse = courses;
          }

          sr.deleteModule = function (moduleToDelete, index) {
            var modules = []
            $scope.coupon.selectedModules.forEach(function(module) {
              if(module.id !== moduleToDelete.id) {
                modules.push(module)
              }
            })
            $scope.coupon.selectedModules = modules;
          }

          sr.searchInfo = function (value, type) {
            if (type === 'course' || type === 'module' || type === 'course-module') {
              getInfo({ key: value }, type, 'api/v1/courses/search');
            }
          }

          var getInfo = function (data, type, api) {
            HttpService.getRequest(api, data)
            .then(function (res) {
                if (type === 'course-module') {
                    sr.coursesModule = res.courses;
                } else if (type === 'course') {
                    sr.courses = res.courses;
                } else if (type === 'module') {
                    sr.modules = res.modules;
                } 
            });
          }

          if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
              $state.go('admin_panel', {}, { reload: true });
          }

      }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('addCouponController', ['$scope', 'CustomStorageService', 'HttpService', '$http', '$state', function ($scope, CustomStorageService, HttpService, $http, $state) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            $scope.coupon = {
              order_terminate_config: 'access-days',
              custom: true
            };
            $scope.tags = [];
            $scope.coupon.selectedTags = [];
            $scope.coupon.selectedCourse = [];
            $scope.coupon.selectedModules = [];
            

            $http({
                url: '/api/v1/coursetag/get',
                method: "GET",
              }).then(function(data) {
                if(data && data.data) {
                  data.data.courseTags.forEach(function (tag) {
                    $scope.tags.push({id: tag.id, label: tag.name})
                  });
                }
                
              });

              $scope.changeCoupon = function(type) {
                if(type === 'custom') {
                  $scope.coupon.bulk = !$scope.coupon.custom
                } else {
                  $scope.coupon.custom = !$scope.coupon.bulk
                }
              }

            $scope.createCoupons = function() {
              var currentDate = new Date(); 
              console.log(currentDate > $scope.coupon.expiryDate)
              if(currentDate > $scope.coupon.expiryDate) {
                swal({
                  title: "Error!",
                  text: "Please select future expiry date",
                  type: "error",
                  confirmButtonText: "Ok"
                  });
                return;
              }

              if($scope.coupon.custom) {
                $scope.coupon.quantity = 1;
              }
                
                if($scope.coupon.order_terminate_config === 'access-days' && (!$scope.coupon.access_days || $scope.coupon.access_days < 1)) {
                  swal({
                    title: "Error!",
                    text: "Please enter value for Access Days",
                    type: "error",
                    confirmButtonText: "Ok"
                  });
                  return;
                }
                if ((!$scope.coupon.quantity && $scope.coupon.bulk) || (!$scope.coupon.name && $scope.coupon.custom) || !$scope.coupon.quantity || !$scope.coupon.price || !$scope.coupon.expiryDate) {
                    swal({
                    title: "Error!",
                    text: "Make sure you have filled all fields",
                    type: "error",
                    confirmButtonText: "Ok"
                    });
                    return;
                }
                $http.post('api/v1/coupons/createCoupons', $scope.coupon)
                .then(function (data) {
                  if($scope.coupon.bulk) {
                    $scope.downlod_csv(data.data);
                  }
                  swal({
                    title: 'Coupon Created',
                    text: "Coupon Created Successfully!",
                    type: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                  }, function () {
                      swal.close();
                      $state.go('coupon', {});
                  });
                  
                });
            };

            sr.selectCourse = function (course, type) {
              if(type === 'course') {
                $scope.courses = [];
                $scope.courseKey = '';
                $scope.coupon.selectedCourse.push({
                  id: course.id,
                  name: course.name,
                })
              } else if(type === 'course-module') {
                $scope.coursesModule = [];
                $scope.courseModuleKey = course.name;
                getInfo({ id: course.id }, 'module', 'api/v1/courses/getModulesByCourseId');
              }
              
            }

            sr.addModule = function (module, type) {
              module = JSON.parse(module)
              $scope.coupon.selectedModules.push({
                id: module.id,
                name: module.name,
                course_name: $scope.courseModuleKey,
                course_id: module.course_id,
              })
            }

            sr.selectModule = function (module) {
                $scope.coupon.selectedModules.push({
                  id: module.id,
                  name: module.name,
                })
              
            }

            sr.deleteCourse = function (courseToDelete, index) {
              var courses = []
              $scope.coupon.selectedCourse.forEach(function(course) {
                if(course.id !== courseToDelete.id) {
                  courses.push(course)
                }
              })
              $scope.coupon.selectedCourse = courses;
            }

            sr.deleteModule = function (moduleToDelete, index) {
              var modules = []
              $scope.coupon.selectedModules.forEach(function(module) {
                if(module.id !== moduleToDelete.id) {
                  modules.push(module)
                }
              })
              $scope.coupon.selectedModules = modules;
            }

            sr.searchInfo = function (value, type) {
              if (type === 'course' || type === 'module' || type === 'course-module') {
                getInfo({ key: value }, type, 'api/v1/courses/search');
              }
            }

            var getInfo = function (data, type, api) {
              HttpService.getRequest(api, data)
              .then(function (res) {
                  if (type === 'course-module') {
                      sr.coursesModule = res.courses;
                  } else if (type === 'course') {
                      sr.courses = res.courses;
                  } else if (type === 'module') {
                      sr.modules = res.modules;
                  } 
              });
            }

            $scope.downlod_csv = function(data) {

              var csv = 'CouponId,Price,Created At\n';
              data.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-people.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            }

            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            }

        }]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("campaignStatsController", [
    "$scope",
    "CustomStorageService",
    "HttpService",
    "$http",
    "$state",
    function ($scope, CustomStorageService, HttpService, $http, $state) {
      $scope.stats = {
        topCities: [{
          city: '...'
        }]
      }
      if ($state.params.id) {
        $http({
          url: "/api/v1/campaign/get-campaign-stats/" + $state.params.id,
          method: "GET",
        }).then(function (data) {
          if (data && data.data) {
            $scope.stats = data.data;
          }
        });
      }
      $scope.downloadCsvReport = function() {
        $http({
          url: 'api/v1/campaign/get-campaign-report/' + $state.params.id,
          method: "GET",
        }).then(function(data) {
          console.log("🚀 ~ file: campaignStats.js:31 ~ data:", data)
          if(data.data.success) {
            swal({
              title: "Success",
              text: "You will receive an email with csv link",
              type: "success"
            },function(){})
          } else {
            swal({
              title: "Error",
              text: "Error While Getting Campaign Report",
              type: "error"
            },function(){})
          }
        });
      }
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("addCampaignTrackingController", [
    "$scope",
    "CustomStorageService",
    "HttpService",
    "$http",
    "$state",
    function ($scope, CustomStorageService, HttpService, $http, $state) {
      var sr = $scope;
      var signedIn = CustomStorageService.getAdminSignedInStorageData();

      $scope.campaignMedium = [
        {id: 'facebook', label: 'facebook'},
        {id: 'instagram', label: 'Instagram'},
        {id: 'google', label: 'Google'},
        {id: 'youtube', label: 'YouTube'},
        {id: 'notification panel', label: 'Notification Panel'},
        {id: 'other', label: 'Other'}
      ];

      $scope.yourEvents = {
        onItemSelect: function(item) {
          if(item.id === 'other') {
            $scope.otherMedium = true;
          }
        },
        onItemDeselect: function(item) {
          if(item.id === 'other') {
            $scope.otherMedium = false;
          }
        },
        onSelectAll: function(item) {
          $scope.otherMedium = true;
        },
        onDeselectAll: function(item) {
          $scope.otherMedium = false;
        },
      };

      $scope.otherMedium = false;

      $scope.campaign = {
        type: "organic",
        medium: [],
        otherMedium: '',
        category: "tof",
        behavior: "retargeting",
      };

      if ($state.params.id) {
        $http({
          url: "/api/v1/campaign/get-campaign/" + $state.params.id,
          method: "GET",
        }).then(function (data) {
          if (data && data.data) {
            $scope.campaign = data.data.result;
            $scope.campaign.medium.forEach(function(medium) {
              if(medium.id === 'other') {
                $scope.otherMedium = true;
              }
              if(medium.type === 'other-medium-text') {
                $scope.campaign.otherMedium = medium.id;
              }
            })
          }
        });
      }

      $scope.createAccessConfig = function () {
        if (!$scope.campaign.name) {
          swal({
            title: "Error!",
            text: "Make sure you have filled all fields",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }
        var url = "/api/v1/campaign/add-campaign";
        if ($state.params.id) {
          url = "/api/v1/campaign/update-campaign";
        }
        $http.post(url, $scope.campaign).then(function (data) {
          swal(
            {
              title: "Success",
              text: "Page config Successfull!",
              type: "success",
              showConfirmButton: false,
              timer: 2000,
            },
            function () {
              swal.close();
              $state.go("campaign_tracking", {});
            }
          );
        });
      };

    },
  ]);
})();

(function () {
  'use strict';

  angular.module('NearPeer')
    .controller('createBundleController', ['UploadService', '$scope', '$http', '$rootScope', '$state',
      function (UploadService, $scope, $http, $rootScope, $state) {

        var sr = $scope;
        var id = $state.params.id;
        $scope.nichetags = [];

        // Fetch available course tags
        $http.get('/api/v1/coursetag/get').then(function (response) {
          if (response && response.data) {
            $scope.nichetags = response.data.courseTags || [];
          }
        })['catch'](function (error) {
          console.error("Error fetching course tags:", error);
        });

        // Function to get bundle details
        var getBundle = function () {
          $http.post('/api/v1/bundle/find', { id: id, admin: true })
            .then(function (response) {
              if (response.status === 200 && response.data.bundles.length > 0) {
                var bundleData = response.data.bundles[0];
                var price = 0;

                if (bundleData.course instanceof Array) {
                  for (var i = 0; i < bundleData.course.length; i++) {
                    var course = bundleData.course[i];
                    price += course.course_id && course.course_id.price ? course.course_id.price : 0;
                  }
                }

                sr.bundle = {
                  id: bundleData.id,
                  name: bundleData.name || "",
                  redirect_link: bundleData.redirect_link || "",
                  excel_url: bundleData.excel_url || "",
                  np_share: bundleData.np_share || 0,
                  tag_id: bundleData.tag_id > 0 ? bundleData.tag_id.toString() : null,
                  discount_price: bundleData.discount_price || 0,
                  price: price,
                  description: bundleData.description || "",
                  course: bundleData.course.map(function(course) {
                      return {
                          id: course.course_id.id,
                          name: course.course_id.name,
                          price: course.course_id.price,
                          modules: course.modules // This will be an empty array for now
                      };
                  }),
                  publish: bundleData.publish || false,
                  image_url: bundleData.image_url || ""
                };
                console.log("Bundle Data:------------", sr.bundle);
              }
            })['catch'](function (error) {
              console.error("Error fetching bundle:", error);
            });
        };

        // Save Bundle Function
        sr.SaveBundle = function (bundle) {
          $http.post('/api/v1/bundle/create', { bundle: bundle, admin: true })
            .then(function () {
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })['catch'](function (error) {
              console.error("Error saving bundle:", error);
            });
        };

        // Upload Image
        sr.uploadImage = function (image) {
          UploadService.uploadImage(image)
            .then(function (url) {
              sr.bundle.image_url = url;
            })['catch'](function (error) {
              console.error("Error uploading image:", error);
            });
        };

        // Delete Image
        sr.delImage = function () {
          sr.bundle.image_url = null;
        };

        // Function to add Course or Module to Bundle
        var addItemToBundle = function (course) {
          if (!sr.bundle) {
            console.error("Bundle is not initialized.");
            return;
          }

          // Ensure `modules` exists
          if (!course.modules) {
            course.modules = [];
          }

          // Check for duplicate courses
          var isCourseAlreadyAdded = false;
          for (var i = 0; i < sr.bundle.course.length; i++) {
              if (sr.bundle.course[i].id === course.id) {
                  isCourseAlreadyAdded = true;
                  break;
              }
          }

          if (isCourseAlreadyAdded) {
            console.warn("Course/module already exists in bundle.");
            return;
          }

          sr.bundle.price += course.price || 0;
          sr.bundle.course.push(course);

          console.log("Updated Bundle Courses:", sr.bundle.course);
        };

        // Initialize bundle
        if (id) {
          getBundle();
        } else {
          sr.bundle = {
            name: "",
            discount_price: 0,
            redirect_link: "",
            tag_id: null,
            price: 0,
            description: "",
            course: [],
            publish: false,
            image_url: ""
          };
        }

        // Event Listener for Adding Course/Module
        sr.$on('getCourse', function (event, message) {
          addItemToBundle(message);
        });

        sr.$on('getModule', function (event, selectedModules, courseId) {
            console.log("Received Selected Modules:", selectedModules, "For Course ID:", courseId);

            if (sr.bundle && sr.bundle.course.length > 0) {
                var targetCourse = null;
                for (var i = 0; i < sr.bundle.course.length; i++) {
                    if (sr.bundle.course[i].id === courseId) {
                        targetCourse = sr.bundle.course[i];
                        break;
                    }
                }

                if (!targetCourse) {
                    console.warn("Course not found in the bundle for ID:", courseId);
                    return;
                }

                if (!targetCourse.modules) {
                    targetCourse.modules = [];
                }

                // Add only the selected modules, avoiding duplicates
                for (var j = 0; j < selectedModules.length; j++) {
                    var module = selectedModules[j];
                    var moduleExists = false;
                    for (var k = 0; k < targetCourse.modules.length; k++) {
                        if (targetCourse.modules[k].id === module.id) {
                            moduleExists = true;
                            break;
                        }
                    }
                    if (!moduleExists) {
                        targetCourse.modules.push(module);
                    }
                }

                console.log("Updated Bundle Courses (with selected modules):", sr.bundle.courses);
            }
        });

        // Delete Course from Bundle
        $scope.deleteCourse = function (index) {
          if (!$scope.bundle || !$scope.bundle.course[index]) {
            console.error("Invalid course index.");
            return;
          }
        
          var course = $scope.bundle.course[index];
        
          // Deduct price if applicable
          $scope.bundle.price -= course.course_id && course.course_id.price ? course.course_id.price : (course.price || 0);
        
          // Remove course from array
          $scope.bundle.course.splice(index, 1);
        
          console.log("Updated Bundle after deletion:", $scope.bundle);
        };

        $scope.deleteModule = function (course, moduleIndex) {
            if (!course || !course.modules || moduleIndex < 0 || moduleIndex >= course.modules.length) {
                console.error("Invalid module index or course.");
                return;
            }

            // Remove the module from the course's module list
            course.modules.splice(moduleIndex, 1);

            console.log("Updated Course after module deletion:", course);
        };
      }]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("botSystemPromptController", [
    "$scope",
    "CustomStorageService",
    "HttpService",
    "$http",
    "$state",
    function ($scope, CustomStorageService, HttpService, $http, $state) {
      var sr = $scope;
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      $scope.config = {};
      $scope.nichetags = [];
      $scope.dropdownSetting = {selectionLimit: 1,};
      $scope.tags = [
        { id: 'name', label: 'Name' },
        { id: 'city', label: 'City' },
        { id: 'content_watched', label: 'Mins of Content Watched' },
        { id: 'avg_quiz_score', label: 'Avg Quiz Score' },
        { id: 'amount_paid', label: 'amount_paid' },
        { id: 'courses_enrolled', label: 'Courses Enrolled' },
        { id: 'courses_purchased', label: 'Courses Purchased' },
        { id: 'mdcat_score', label: 'MDCAT Score Predictor' },
      ];
      $scope.config.selectedTags = [];
      $scope.selectedNicheTag = '';
      var sysPrompts;
      var niche_id
      var envData;
      var variableprompt = '{variables_data}';
      
      // $scope.config.prompt = initprompt + variableprompt + endingprompt;

      $http({
        url: '/api/v1/coursetag/get',
        method: "GET",
      }).then(function(data) {
        if(data && data.data) {
          $scope.nichetags = data.data.courseTags;
        }
        
      });

      HttpService.getRequest('/api/v1/bot-config/get-sys-prompts')
      .then(function (res) {   
        if (res.success) {
          sysPrompts = res.prompts;
        } 
      });

      var onItemVariable = function () {
        variableprompt = '';
        $scope.config.selectedTags.forEach(function(selectedTag) {
          variableprompt = variableprompt + ' ' + selectedTag.id + ': {' + selectedTag.id + '}'
        })

        // $scope.config.prompt = initprompt + variableprompt + endingprompt;

      }

      $scope.onSelectNicheTag = function(nichTag) {
        niche_id = nichTag;
        var foundPrompt = {}
        sysPrompts.forEach(function(prompt) {
          if(prompt.tag_id == niche_id) {
            console.log(prompt.system_prompt);
            foundPrompt = prompt
          }
        })
        $scope.config.prompt = foundPrompt.system_prompt;

      }

      $scope.yourEvents = {
        onItemSelect: function(item) {
          onItemVariable();
        },
        onItemDeselect: function(item) {
          onItemVariable();
        },
        onSelectAll: function(item) {
          onItemVariable();
        },
        onDeselectAll: function(item) {
          onItemVariable();
        },
      };

      

      $scope.createAccessConfig = function () {
        if (
          !$scope.config.prompt
        ) {
          swal({
            title: "Error!",
            text: "Make sure you have filled all fields",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        } else if (
          !niche_id
        ) {
          swal({
            title: "Error!",
            text: "Please select Niche.",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }
        var configData = {
          selectedTags: $scope.config.selectedTags
        }
        HttpService.postRequest('/api/v1/bot-config/create-sys-prompt', {system_prompt: $scope.config.prompt, system_prompt_data: configData, tag_id: niche_id })
        .then(function (res) {
          if (res.success) {
            swal({
              title: "successful",
              text: "System Prompt Updated",
              type: "success"
            });
            sr.quality = {};
            getQualities();
          } else {
            swal({
              title: "Error!",
              text: 'Value Not Updated',
              type: "error",
              confirmButtonText: "Ok"
            });
          }
        });
      };

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("admin_panel", {}, { reload: true });
      }
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('BlogCommentController', ['$scope', function($scope) {
    
    }]);
  })();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('FAQSCreateController', ['UploadService', '$scope', 'CustomStorageService', 'HttpService', '$state',
            function (UploadService, $scope, CustomStorageService, HttpService, $state) {

                var signedIn = CustomStorageService.getAdminSignedInStorageData();
                var sr = $scope;
                sr.faq = {};
                var institution = [];
                var deletedInst;
                var faqId;
                var url = $state.params.url;

                //to update faq data coming throgh previous state to editable satate
                var getFaqs = function () {
                    HttpService.getRequest("api/v1/faq/getFaq", { url: $state.params.url })
                        .then(function (response) {
                            var data = response.faq.faqResult;
                            if (response) {
                                faqId = data.id;
                                institution = data.institute;
                                sr.institutes = institution;

                                sr.faq = {
                                    id: data.id,
                                    question: data.question,
                                    answer: data.answer,
                                    publish: data.publish,
                                    disabled: data.disabled
                                }
                            }
                            else {
                                swal({
                                    title: "error",
                                    text: response.message,
                                    type: "error"
                                }, function () {
                                });
                            }
                        });
                }
                //if there is data in faq selected to edit
                if (url) {
                    getFaqs();
                } else {
                    sr.faq = {
                        question: "",
                        answer: "",
                        publish: false,
                        disabled: false,
                    };
                }

                // create or update FAQ
                sr.saveFaq = function (faq) {
                    // if (institution.length > 0) {
                        if (faq.question != "") {
                            if (faq.answer != "") {
                                HttpService.postRequest("api/v1/faq/create", {
                                    id: faq.id,
                                    question: faq.question,
                                    answer: faq.answer,
                                    publish: faq.publish,
                                    institute: institution
                                })
                                    .then(function (response) {
                                        if (response.success) {
                                            swal({
                                                title: "successful",
                                                text: response.message,
                                                type: "success"
                                            });
                                            //after updating clear the fields
                                            sr.faq = {
                                                question: "",
                                                answer: "",
                                                publish: false,
                                                disabled: false,
                                            };
                                            sr.institutes = [];
                                            institution = [];
                                            //if you have edited faq then go back to previous page
                                            if (url) {
                                                window.history.back();
                                            }
                                        }
                                        else {
                                            swal({
                                                title: "error",
                                                text: response.message,
                                                type: "error"
                                            }, function () {
                                            });
                                        }
                                    });
                            }
                            else {
                                swal({
                                    title: "OOPs",
                                    text: 'Enter an Answer',
                                    type: "warning"
                                }, function () {
                                });
                        }
                        }else {
                            swal({
                                title: "OOPs",
                                text: 'Enter a Question ',
                                type: "warning"
                            }, function () {
                            });
                        }
                    // }
                    // else {
                    //     swal({
                    //         title: "OOPs",
                    //         text: 'Select Institute/s',
                    //         type: "warning"
                    //     }, function () {
                    //     });
                    // }
                }


                //get all institutons for dropdown menu to create faqs
                var getInstitutions = function () {
                    HttpService.getRequest("api/v1/institute/get")
                        .then(function (response) {
                            if (response.success) {
                                sr.institutions = response.inst;
                                institutes = response.inst;
                            }
                        });
                }();

                //select multiple institutes to have same faqs 
                sr.pickIt = function (ins) {
                    var len = institution.length;
                    var flag = false;
                    for (var i = 0; i < len; i++) {
                        if (institution[i].id == ins.id) {
                            flag = true;
                            return;
                        }
                    }
                    var i = institution.indexOf(ins);
                    if (!flag) {
                        if (i <= -1) {
                            institution.push(ins);
                            sr.institutes = institution;
                        }
                    }
                }


                // drop one or more institutes from selected array 
                sr.dropIt = function (ins) {
                    var i = institution.indexOf(ins);
                    if (i >= 0) {
                        institution.splice(i, 1);
                        deletedInst = ins;
                        sr.institutes = institution;
                    }
                    //if  editing an faq then delete that institute from db
                    if (url) { 
                        HttpService.getRequest("api/v1/instFaq/removeInst", {
                            id: faqId,
                            instId: deletedInst.id
                        })
                            .then(function (response) {
                                if (response) {
                                    swal({
                                        title: "FAQ removed!",
                                        type: "success",
                                        confirmButtonText: "Ok",
                                        timer: 1000,
                                        showConfirmButton: false
                                    });
                                }
                                else {
                                    swal({
                                        title: "error",
                                        text: response.message,
                                        type: "error"
                                    }, function () {
                                    });
                                }
                            })
                    }

                }
                if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                    $state.go('admin_panel', {}, { reload: true });
                } 
            }]);
            
})();

(function() {

	angular
	.module('NearPeer')

	.controller('InstructorPanelVideoController', ['$scope', '$location','$window', '$rootScope','Upload','$timeout', '$http', '$state', 'CustomStorageService', '$sails','instructorPanelService','$filter', 'videoSocket', 'env', function($scope, $location,$window, $rootScope, Upload, $timeout, $http, $state, CustomStorageService, $sails,instructorPanelService,$filter, videoSocket, env) {
		$scope.socket = new Object();
		$scope.socketID = '';
		$(document).ready(function(){
			$(this).scrollTop(0);
			$scope.socket = videoSocket;
		});
		$scope.socket.on('connect', function () {
			$scope.socketID = $scope.socket.io.engine.id;
			console.log('ccc', $scope.socketID);
		});
		$scope.socket.on('new_connection', function (data) {
			console.log('new_connection', data);
			$scope.socketID = data;
		});
		$scope.socket.on('disconnect', function(){
			showSocketDisconnectMessage();			
		});

		$scope.download = function (video){
			$scope.showData = false;
			if(video.is_bunny){
				/* these are for bunny downloads */
				// var storageZone = env.bunnyStorageZoneName;
				// var accessKey = env.bunnyStorageAccessKey;
				
				// var fileName = 'play_480p.mp4';
				// var fileUrl = 'https://storage.bunnycdn.com/' + storageZone + '/' + video.bunny_id + '/' + fileName + '?accessKey=' + accessKey + '&download';
				var fileUrl = video.url;

				var tempInput = document.createElement('textarea');
					tempInput.value = fileUrl;
					document.body.appendChild(tempInput);

					// Select and copy the text
					tempInput.select();
					document.execCommand('copy');
					document.execCommand('Copy');

					// Remove the temporary input element
					document.body.removeChild(tempInput);

					navigator.clipboard.writeText(fileUrl)
						.then(function ()  {
							console.log('Text copied to clipboard:', fileUrl);
						})
						.catch(function (error) {
							console.error('Copy to clipboard failed:', fileUrl);
						});
					$scope.showData = true;

					swal('Success!', "The download link has been copied. Please paste it in a new tab to begin the download.",'success');
			} else {
			$http({
				url: 'api/v1/cvideos/downloadVideo',
				method: "GET",
				params: { video_id: video.id }
			}).then(function(data){
				$scope.showData = true;
				if(data.data.success){
					// Create a temporary input element
					var tempInput = document.createElement('textarea');
					tempInput.value = data.data.mp4_url;
					document.body.appendChild(tempInput);

					// Select and copy the text
					tempInput.select();
					document.execCommand('copy');
					document.execCommand('Copy');

					// Remove the temporary input element
					document.body.removeChild(tempInput);

					navigator.clipboard.writeText(data.data.mp4_url)
						.then(function ()  {
							console.log('Text copied to clipboard:', data.data.mp4_url);
						})
						.catch(function (error) {
							console.error('Copy to clipboard failed:', data.data.mp4_url);
						});

					swal('Success!', "Downloading started and link copied to clipboard.",'success');
					window.open(data.data.mp4_url, '_blank');
				} else {
					swal('Error!',data.data.error,'error');
				}
			});
		}
		};
		function showSocketDisconnectMessage(){
			var displayPopup = false;
			var anyVideoUploadingToServer = false;
			if($scope.uploadingVideos.length){
				$scope.uploadingVideos.forEach(function(video) {
					if(video.uploaded == false) {
						displayPopup = true;
					}
					if(!video.serverLog) {
						anyVideoUploadingToServer = true;
					}
				});
				if(displayPopup){
					if(anyVideoUploadingToServer){
						setTimeout(function(){showSocketDisconnectMessage()}, 2000)
					}else{
						swal('Socket connection disconnected','Real time progress lost please refresh to get updated progress');
					}
				}
			}
		}
		
		$rootScope.online = navigator.onLine;
		$window.addEventListener("offline", function () {
		  $rootScope.$apply(function() {
			$rootScope.online = false;
			swal('Oops..','Internet connection lost!','error');
		  });
		}, false);
		$window.addEventListener("online", function () {
		  $rootScope.$apply(function() {
			$rootScope.online = true;
			swal('Internet Connected!','Internet connected successfully','success');
			if($window.location.href.includes('/instructor_panel/video/module/')||$window.location.href.includes('/instructor_panel/video/chapter/')){
				$window.location.reload();			
			}
		  });
		}, false);
		$scope.check = false;
		$window.addEventListener("unload", function () {
			
		}, false);

		window.onbeforeunload = function(event) {
			if(event.currentTarget.location.pathname.includes('/instructor_panel/video/module/')||event.currentTarget.location.pathname.includes('/instructor_panel/video/chapter/')){
				$scope.check = false;
				var itemsProcessed = 0;
				for(var i in $scope.uploadingVideos){
					if($scope.uploadingVideos[i].serverLog<100){
						$scope.check = true;
					}
					itemsProcessed++;
					if(itemsProcessed===$scope.uploadingVideos.length){
						if($scope.check){
							return 'Uploading in progress...';
						}
					}
				}
			}
			$sails.get('/api/v1/sockets/clearSocket',{userId:CustomStorageService.getUserInfoStorageData().id})
			.then(function(res){})
		}

		$scope.clearChanges = function (){
			$scope.uploadingAttachments = [];
			var videosToRemove = $scope.uploadingVideos.filter(function(v){return v.vss_id}).map(function(v){return v.vss_id});
			$http.post('/api/v1/cvideos/delete-temp-videos/', videosToRemove)
			clearVideosProgressFromDB();
			$scope.clearThisModuleLocalStorage();
		}

		$scope.clearThisModuleLocalStorage = function(){
			var videoData = CustomStorageService.getVideoUploadingState();
			if(videoData!==false && videoData !== null && videoData !== undefined && videoData.length>0){
				var result = videoData.filter(function(val) {
					if (val.module_url===$window.location.href)
							return false;    
					return true;
				});
				CustomStorageService.setVideoUploadingState(result);
				location.reload();
			}
		}
		function setErrorToVideo(count, module_url){
			var videoData = CustomStorageService.getVideoUploadingState();
			var videoIndex = videoData.findIndex(function(ele){return(ele.no==count && ele.module_url == module_url)})
			videoData[videoIndex].error = true;
			CustomStorageService.setVideoUploadingState(videoData);
		
		}
		var saveStatusToLocalStorage = function() {
			if($window.location.href.includes('/instructor_panel/video/module/')||$window.location.href.includes('/instructor_panel/video/chapter/')){
				var videoData = CustomStorageService.getVideoUploadingState();
				if(videoData !==false && videoData !== null && videoData !== undefined && videoData.length>0){
					var itemsProcessed = 0;
					var videoDataCopy = JSON.stringify(videoData);
					videoDataCopy = JSON.parse(videoDataCopy);
					setTimeout(function () {
						angular.forEach($scope.toUpload, function(video, i) {
							videoData.push(video);
							itemsProcessed++;
							if(itemsProcessed===$scope.toUpload.length){
								$scope.toUpload = [];
								CustomStorageService.setVideoUploadingState(videoData);
							}
						});
					}, 500)
					
				}else{
					setTimeout(function () {
						CustomStorageService.setVideoUploadingState($scope.uploadingVideos);
						$scope.toUpload = [];
					}, 500)
				}
			}
		}

		var getVideoByNo = function getVideoByNo(no) {
			return $scope.uploadingVideos.find(function (video) {
				return video.no == no;
			});
		};
		
		$scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();

		$scope.initialize = function(){
			$scope.s3Duplicates = [];
			$scope.vimeoDuplicates = [];
			$scope.bunnyDuplicates = [];
			$scope.counter = 1;
			$scope.uploadLog = [];
			$scope.showData = false;
			$scope.uploadedVideos = [];
			$scope.uploadingVideos = [];
			$scope.appendingStringVideos = []
			$scope.toUpload = []
			$scope.uploadingOptions = [
			// 	{
			// 	name: 'Upload to Azure',
			// 	id: 1
			// },
			// {
			// 	name: 'Upload to VVS',
			// 	id: 2
			// },
			{
				name: 'Upload to Bunny',
				id: 3
			},
			// {
			// 	name: 'Upload to Both',
			// 	id: 4
			// }
		]
			$scope.value = -1;
			var data ={
				id: $state.params.id,
				instructor_id: instructorPanelService.getInstructorId()
			}
			if($state.params.state == 'module'){
				$scope.editingModule = true;
				$scope.editingChapter = false;
				data['type'] = 1;
			} else if($state.params.state == 'chapter'){
				$scope.editingChapter = true;
				$scope.editingModule = false;
				data['type'] = 2;
			}

			$http({
				url: 'api/v1/cvideos/getVideosById',
				method: "GET",
				params: data
			}).then(function(data){
				if(data.data.success){
					$scope.showData = true;
					$scope.videos = data.data.videos;
				} else {
					$scope.videos = [];
					$scope.showData = true;
				}
			});
			var videoData = CustomStorageService.getVideoUploadingState();
			setTimeout(function() {
				if(videoData!==false && videoData !== null && videoData !== undefined && videoData.length>0){
					var itemsProcessed = 0; 
					angular.forEach(videoData, function(video, key) {
						if(video.module_url===$window.location.href && !video.error){
							// EXISTING CODE - keeping this as is for S3/Vimeo compatibility
							video.serverLog = 100;
							
							// NEW: Additional check for Bunny videos specifically
							if(video.server === 'Bunny' && video.bunny_id && video.bunny_url) {
								// Bunny video is completed, set progress to 100%
								video.s3Log = 100;
								video.jobLog = 100;
								video.uploaded = true;
							} else if(video.server === 'Vimeo' && video.vss_id) {
								// Vimeo video is completed (existing behavior)
								video.s3Log = 100;
								video.jobLog = 100;
								video.uploaded = true;
							} else if(video.server === 'S3' && video.url_mpd) {
								// S3 video is completed (existing behavior)
								video.s3Log = 100;
								video.jobLog = 100;
								video.uploaded = true;
							}
							// If none of the completion conditions are met, keep existing behavior
							
							$scope.uploadingVideos.push(video);
						}else{
							// EXISTING CODE - keeping this unchanged
							video.s3Log = 0;
							video.jobLog = 0;
							$scope.uploadingVideos.push(video);
						}
						
						itemsProcessed++;
						if(itemsProcessed===videoData.length){
							var max = videoData.reduce(function (prev, current) {
								return (prev.no > current.no) ? prev : current
							});
							$scope.counter = max.no+1;
						}
					});
				}
			}, 400)
setTimeout(function(){
    // Restore completed videos to uploadedVideos array after localStorage restoration
    angular.forEach($scope.uploadingVideos, function(video) {
        if(video.uploaded && video.server === 'Bunny' && $scope.notExistsBunnyVideo(video)) {
            $scope.uploadedVideos.push(video);
        }
    });
}, 500);
			
			var dropDownData = CustomStorageService.getVideoUploaderDropdownState();
			if(dropDownData!==false && dropDownData !== null && dropDownData !== undefined){
				$scope.toVimeo = dropDownData.toVimeo;
				$scope.toS3 = dropDownData.toS3;
				$scope.toBunny = dropDownData.toBunny;
				$scope.btnText = dropDownData.btnText;
			}
			
			setTimeout(function(){
				$http({
					url:'/api/v1/sockets/getInstructorVideosTrack',
					method: "GET",
					params:{userId:CustomStorageService.getUserInfoStorageData().id}})
				.then(function(res){
					var data = res.data.data;
					if(data!=='null'){
						angular.forEach(data, function(element, key) {
							var video = element.video;
							if(video.module_url === $window.location.href){
								if(video.server==='vimeo'){ 
									$scope.jobVimeoCompleted(video);
								}else if(video.server==='bunny'){
									$scope.jobBunnyCompleted(video);
								}
								else{
									$scope.jobS3Completed(video);
								}
							}
						});
					}
				})
			},500);	
		}

		$scope.setValue = function(index){
			if(index == $scope.value){
				$scope.value = -1;
			} else {
				$scope.value = index;
			}
		}

		var clearVideosProgressFromDB = function (videoNo){
			var data = {module_url:$window.location.href,userId:CustomStorageService.getUserInfoStorageData().id};
			if(videoNo) {
				data.videoNo = videoNo
			}
			$http({
				url: '/api/v1/sockets/clearInstructorVideosTrack',
				method: "GET",
				params:data})
			.then(function(res){})
		}

		$scope.uploadingAttachments = [];

		$scope.saveData = function(){
			if($scope.uploadedVideos.length < $scope.uploadingVideos.length) {
				swal('Please Wait','Some Videos are still uploading','error');
				return false;
			}
			if($scope.uploadedVideos.length > $scope.uploadingVideos.length) {
				var deleted = $scope.uploadingVideos.map(function (video) {
					return video.no;
				});
				$scope.uploadedVideos = $scope.uploadedVideos.filter(function (video) {
					return deleted.includes(video.no);
				});
			}
			if (($scope.videos.length == 0) && ($scope.uploadedVideos.length == 0) && ($scope.uploadingAttachments.length == 0)){
				swal('Oops..','Please add videos to save','error');
				return false;
			}

			$scope.videos.forEach(function(video) {
				var match = null;
				for (var i = 0; i < $scope.uploadingVideos.length; i++) {
					if ($scope.uploadingVideos[i].video_id === video.id) {
					match = $scope.uploadingVideos[i];
					break;
					}
				}

				if (match) {
					if (match.bunny_id) {
					video.bunny_id = match.bunny_id;
					}
					if (match.bunny_url) {
					video.bunny_url = match.bunny_url;
					}
					if (typeof match.is_bunny !== 'undefined') {
					video.is_bunny = match.is_bunny;
					}
					if (match.duration) {
					video.duration = match.duration;	
					}
					if (match.hetzner_url) { // Add this block
                	video.hetzner_url = match.hetzner_url;
            		}
				}
				});


			var data = {
				videos: $scope.videos
			}
			if($scope.uploadedVideos.length > 0){
				$scope.uploadedVideos.sort(function(a, b) {
					return a.no - b.no;
				});
				data['newVideos'] = $scope.uploadedVideos;
			}
			if($scope.editingChapter){
				data['chapter_id'] = $state.params.id;
			}
			if($scope.editingModule){
				data['module_id'] = $state.params.id;
			}

			if($scope.uploadingAttachments.length > 0){
				data['newNotes'] = $scope.uploadingAttachments;
			}

			$scope.showData = false;

			for(var i in $scope.videos) {
				$scope.videos[i].video_no = +i+1;
				if($scope.videos[i].type && $scope.videos[i].type === 'notes') {
					$scope.videos[i].sort_no = +i+1;
				}
			}
			$http.post('api/v1/cvideos/updateVideo',data)
			.then(function(data){
				$scope.showData = true;
				if(data.data.success){
					clearVideosProgressFromDB();
					$scope.clearThisModuleLocalStorage();
					swal({
						title: 'Success',
						text: 'Video data uploaded',
						type: 'success',
						timer:2000,
						showCancelButton: false,
						showConfirmButton: false
					},function(){
						location.reload();
					});
				} else {
					instructorPanelService.tryAgainSwal();
				}
			})
		}

		var videoNameExpression = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]+\.mp4$/;
		var videoNameExpression2 = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]$/;
		$scope.toVimeo = false;
		$scope.toS3 = false;
		$scope.toBunny = true;
		$scope.btnText = 'Uploading to Bunny';
		$scope.changeUploader = function(val){
			if(val===1){
				$scope.toVimeo = false;
				$scope.toS3 = true;
				$scope.toBunny = false;
				$scope.btnText = 'Uploading to Azure';
			}else if(val===2){
				$scope.toVimeo = true;
				$scope.toS3 = false;
				$scope.toBunny = false;
				$scope.btnText = 'Uploading to VVS';
			}else if(val===3){
				$scope.toVimeo = false;
				$scope.toS3 = false;
				$scope.toBunny = true;
				$scope.btnText = 'Uploading to Bunny';
			}
			// else{
			// 	$scope.toVimeo = true;
			// 	$scope.toS3 = true;
			// 	$scope.toBunny = false;
			// 	$scope.btnText = 'Uploading to both';
			// }
		}
		$scope.removeItem= function(index){
			var toDeleteVideo = $scope.uploadingVideos[index];
  if (!toDeleteVideo) return;

  // 🔹 Abort client-side upload if in progress
  if (toDeleteVideo.uploadRequest && typeof toDeleteVideo.uploadRequest.abort === 'function') {
    try {
      console.log('[UPLOAD CANCEL] Aborting client upload for:', toDeleteVideo.name);
	  toDeleteVideo.userCancelled = true;
      toDeleteVideo.uploadRequest.abort();
    } catch (err) {
      console.warn('[UPLOAD CANCEL] Error during abort:', err);
    }
  }

  // 🔹 Notify backend to stop Bunny/Hetzner upload
  if (toDeleteVideo.socket_id && toDeleteVideo.no !== undefined) {
    $http.post(env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/cancel-upload/' + $scope.socketID + '/' + toDeleteVideo.no)
	.catch(function(err) {
		console.warn('[UPLOAD CANCEL] Backend cancel failed:', err);
	});
  }

  // 🔹 Run cleanup asynchronously to avoid conflicts with upload abort
  $timeout(function() {
    var videoData = CustomStorageService.getVideoUploadingState() || [];
    
    // Remove temp video from backend if applicable
    if (toDeleteVideo.vss_id) {
      $http.get('api/v1/cvideos/delete-temp-video/' + toDeleteVideo.vss_id)
	  .catch(function(err) {
		console.warn('[UPLOAD CANCEL] Backend cancel failed:', err);
	});    }

    // Remove from localStorage
    var indexInStorage = videoData.findIndex(function(v) {
		return (
			v.name === toDeleteVideo.name &&
			v.server === toDeleteVideo.server &&
			v.module_url === toDeleteVideo.module_url
		);
	});

    if (indexInStorage !== -1) videoData.splice(indexInStorage, 1);
    CustomStorageService.setVideoUploadingState(videoData);

    // Remove from frontend array
    $scope.uploadingVideos.splice(index, 1);

    // ✅ Always clear progress from DB
    if (toDeleteVideo.no !== undefined) clearVideosProgressFromDB(toDeleteVideo.no);

  }, 0); // next digest cycle
};


		var updateProgress = function(name) {
			setTimeout(function() {
				$scope.uploadingAttachments.forEach(function(attachment) {
					if(attachment.name === name && attachment.log < 80) {
						attachment.log = attachment.log + 5;
						$scope.$apply();
						updateProgress(name);
					}
				});
			}, 800)
		}

		$scope.uploadAttachments= function(files,type){
			if(files){
				for (var i = 0; i < files.length; i++) {
					if(files[i].type==='application/pdf' || files[i].file.type==='application/pdf') {
					}
					else {
						swal('Oops..','Please attachment in .pdf','error');
						return false;
					}
					// if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
					// } else {
					// 	swal('Oops..','Please upload video in aplha numeric','error');
					// 	return false;
					// }
				}
				var readres = [];
				for(var i in files){
					var name = files[i].name;
					var tmp = name.split('.pdf');
					name = tmp[0];
					readres[i] = new FileReader();
					readres[i].readAsBinaryString(files[i]);
					readres[i].onloadend = function () {
						$scope.uploadingAttachments.forEach(function(att, index) {
							files.forEach(function(file, index) {
								if(att.name === file.name.split('.pdf')[0]) {
									att.page_count = readres[index].result.match(/\/Type[\s]*\/Page[^s]/g).length;;
								}
							})
							
						})
					}
					var notesData = {
						name: name,
						status: 'uploading',
						log: 0,
						module_id: $state.params.module_id,
					}
					if($state.params.state === 'chapter') {
						notesData.chapter_id = $state.params.id;
					}
					$scope.uploadingAttachments.push(notesData);
					updateProgress(name);
					uploadAttachmentFile(name, files[i])
				}
				

			}
		}

		var uploadAttachmentFile = function(name, file) {
			Upload.upload({
				url: '/api/v1/uploader/uploadVideoAttachmentToS3?module_id='+$state.params.module_id+'&userId='+instructorPanelService.getInstructorId()+'&no='+$scope.counter+'&socket_id='+CustomStorageService.getUserInfoStorageData().id,
				method: "POST",
				file: file
			}).then(function(data){
				var link = data.data.link;
				$scope.uploadingAttachments.forEach(function(attachment) {
					if(name == attachment.name) {
						attachment.url = link;
						attachment.status = 'uploaded';
						attachment.log = 100;
					}
				});
			});
		}

		$scope.uploadVideoss= function(files,type, video){
			var notesFiles = [];
			var videoFiles = [];
			
			files.forEach(function(file) {
				console.log(file)
				if(file.type==='application/pdf' || (file.file && file.file.type==='application/pdf')) {
					if(file.type) {
						notesFiles.push(file);
					} else if (file.file) {
						notesFiles.push(file.file);
					}
				} else {
					videoFiles.push(file)
				}
			});
			if(notesFiles.length > 0){
				$scope.uploadAttachments(notesFiles);
			}
			if(videoFiles.length > 0){
				$scope.filess = videoFiles;
				if($scope.toBunny){
					$scope.uploadVideosToBunny(files,type, video);
				}else if(!$scope.toVimeo && $scope.toS3){
					$scope.uploadVideos(files,type, video);
				}else if($scope.toVimeo && !$scope.toS3){
					$scope.uploadVideosToVimeo(files,type, video);
				}else{
					$scope.uploadVideos(files,type, video);
					$scope.uploadVideosToVimeo(files,type, video);
				}
			}
		}
		$scope.uploadVideos = function(files,type, video){
			$scope.s3Duplicates = [];
			if(files){
				for (var i = 0; i < files.length; i++) {
					if(files[i].type==='video/mp4' || files[i].file.type==='video/mp4') {
					}
					else {
						swal('Oops..','Please upload video in .mp4','error');
						return false;
					}
					if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
					} else {
						swal('Oops..','Please upload video in aplha numeric','error');
						return false;
					}
				}
				for(var i in files){
							var name = files[i].name;
							var tmp = name.split('.mp4');
							name = tmp[0];
							var obj = {
								no: $scope.counter,
								name: name,
								serverLog: 0,
								s3Log: 0,
								jobLog: 0,
								error: false,
								url: '',
								url_mpd: '',
								image_url: 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/thumb-1.jpg',
								uploaded: false,
								server: 'S3',
								module_url: $window.location.href,
								video_id: video ? video.id : undefined,
							}
							if($scope.toVimeo&&$scope.toS3){
								obj.isBoth = true;
								obj.isSame = $scope.counter;
							} 
							$scope.counter++;
							checkDuplicationForS3(files[i],obj,type,i).then(function (value) {
								console.log('promise result Pakhar: ' + value);
							  });
				}
			}
		};
		$scope.uploadVideosToVimeo = function(files,type, video){
			$scope.vimeoDuplicates = [];
			if(files){
				for (var i = 0; i < files.length; i++) {
					if(files[i].type==='video/mp4' || files[i].file.type==='video/mp4') {
					}
					else {
						swal('Oops..','Please upload video in .mp4','error');
						return false;
					}
					if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
					} else {
						swal('Oops..','Please upload video in aplha numeric','error');
						return false;
					}
				}
				for(var i in files){
					var name = files[i].name;
					var tmp = name.split('.mp4');
					name = tmp[0];
					// name = name +'-'+files[i].size+'-'+date;
					var obj = {
						no: $scope.counter,
						name: name,
						serverLog: 0,
						s3Log: 0,
						jobLog: 0,
						error: false,
						url: '',
						url_mpd: '',
						image_url: 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/thumb-1.jpg',
						uploaded: false,
						server: 'Vimeo',
						module_url: $window.location.href,
						video_id: video ? video.id : undefined,
					}
					if($scope.toVimeo&&$scope.toS3){
						obj.isBoth = true;
						obj.isSame = $scope.counter-1;
					}
					$scope.counter++;
					$scope.checkDuplicationForVimeo(files[i],obj,type,i).then(function (value) {
						console.log('promise result Pakhar: ' + value);
					})
				}
			}
		};
		$scope.uploadVideosToBunny = function(files,type, video){
			$scope.bunnyDuplicates = [];
			if(files){
				for (var i = 0; i < files.length; i++) {
					if(files[i].type==='video/mp4' || files[i].file.type==='video/mp4') {
					}
					else {
						swal('Oops..','Please upload video in .mp4','error');
						return false;
					}
					if(files[i].name.match(videoNameExpression) || files[i].name.match(videoNameExpression2)) {
					} else {
						swal('Oops..','Please upload video in alpha numeric','error');
						return false;
					}
				}
				for(var i in files){
					var name = files[i].name;
					var tmp = name.split('.mp4');
					name = tmp[0];
					var obj = {
						no: $scope.counter,
						name: name,
						serverLog: 0,
						s3Log: 0,
						jobLog: 0,
						error: false,
						url: '',
						url_mpd: '',
						image_url: 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/thumb-1.jpg',
						uploaded: false,
						server: 'Bunny',
						module_url: $window.location.href,
						video_id: video ? video.id : undefined,
					}
					$scope.counter++;
					$scope.sendForUploadToBunny(obj,type,files[i],i);
				}
			}
		};
		var checkDuplicationForS3 = function(file,obj,type,index){
			return new Promise(function(resolve) {
				setTimeout(function(){
				if($scope.uploadingVideos.length>0){
					var notDup = true;
					var itemsProcessed = 0;
					var nowAddingVideos  = [];
					var fileNameArr = file.name.split('.');
					fileNameArr.splice(fileNameArr.length-1,1);
					var fileName = fileNameArr.join('.');
					for(i in $scope.uploadingVideos){
						if(fileName === $scope.uploadingVideos[i].name && $scope.uploadingVideos[i].server===obj.server && $scope.uploadingVideos[i].module_url===obj.module_url){
							var fileData = file.name+'-'+obj.server+'-'+obj.module_url;
							if(!nowAddingVideos.includes(fileData)){
								nowAddingVideos.push(fileData);
								notDup = false;
								$scope.s3Duplicates.push(obj);
							}	
						}
						itemsProcessed++;
						if(itemsProcessed === $scope.uploadingVideos.length) {
							if(notDup){
								$scope.sendForUpload(obj,type,file, index);
								resolve(true);
							}else{
								swal({
									title: 'S3 Error',
									text: 'You were uploading duplicate video(s) to S3!',
									type: 'error',
									showCancelButton: false,
									showConfirmButton: true
								},function(){
									// location.reload();
								});
								resolve(true);
							}
							
						}
					}
				}else{
					$scope.sendForUpload(obj,type,file, index);
					resolve(true);
				}
			},500);
		});
		}
		$scope.checkDuplicationForVimeo = function(file,obj,type,index){
			return new Promise(function(resolve) {
				setTimeout(function(){
					if($scope.uploadingVideos.length>0){ 
						var notDup = true;
						var itemsProcessed = 0;
						var nowAddingVideos  = [];
						angular.forEach($scope.uploadingVideos, function(video, key) {
							var fileNameArr = file.name.split('.');
							fileNameArr.splice(fileNameArr.length-1,1);
							var fileName = fileNameArr.join('.');
							if(fileName == video.name && video.server==obj.server && video.module_url==obj.module_url){
								var fileData = file.name+'-'+obj.server+'-'+obj.module_url;
								if(!nowAddingVideos.includes(fileData)){
									nowAddingVideos.push(fileData);
									notDup = false;
									$scope.vimeoDuplicates.push(obj);
								}
							}
							itemsProcessed++;
							if(itemsProcessed === $scope.uploadingVideos.length) {
								if(notDup){
									$scope.sendForUploadToVimeo(obj,type,file,index);
									resolve(true);
								}else{
									swal({
										title: 'Vimeo Error',
										text: 'You were uploading duplicate video(s) to Vimeo!',
										type: 'error',
										showCancelButton: false,
										showConfirmButton: true
									},function(){
										// location.reload();
									});
									resolve(true);
								}
							}
						});
					}else{
						$scope.sendForUploadToVimeo(obj,type,file,index);
						resolve(true);
					}
				},500);
			});
		}
		$scope.sendForUpload  = function (obj,type,file, index){
			$scope.toUpload.push(obj);
			$scope.uploadingVideos.push(obj);
			if(type == 'click'){
				$scope.uploadVideo(file,obj.no);
			} else {
				$scope.uploadVideo(file.file,obj.no);
			}
			setTimeout(function () {
				saveStatusToLocalStorage();
			}, 500 + (100 * index))
			
			
			
		}
		$scope.sendForUploadToVimeo  = function (obj,type,file,index){
			$scope.toUpload.push(obj);
			$scope.uploadingVideos.push(obj);
			if(type == 'click'){
				$scope.uploadVideoToVimeo(file,obj.no);
			} else {
				$scope.uploadVideoToVimeo(file.file,obj.no);
			}
			setTimeout(function () {
				saveStatusToLocalStorage();
			}, 500 + (100 * index))
		}
		$scope.sendForUploadToBunny  = function (obj,type,file,index){
			$scope.toUpload.push(obj);
			$scope.uploadingVideos.push(obj);
			if(type == 'click'){
				$scope.uploadVideoToBunny(file,obj.no);
			} else {
				$scope.uploadVideoToBunny(file.file,obj.no);
			}
			setTimeout(function () {
				saveStatusToLocalStorage();
			}, 500 + (100 * index))
		}
		$scope.uploadVideoToVimeo = function(file,no){
			var date = new Date();
			date =$filter('date')(date,'MM-dd-yyyy-h:mma');
			var appendingString =file.size+'-'+date
			$scope.appendingStringVideos.push(appendingString);
			if(file && file.name.length < 110){
				var data = {
					userId: instructorPanelService.getInstructorId(),
					count: no,
					file: file.name,
					chapter_id:$state.params.id,
					isModule: $scope.editingModule?'yes':'no',
					socket_id: $scope.socketID,
					appendingString: appendingString,
					module_url: $window.location.href,
					module_id: $state.params.module_id
				};
				Upload.upload({
					url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/video-to-vimeo',
					method: 'POST',
					file:file,
					params: data
				}).then(function(data){
					if(data.data.success===true) {
						var video = getVideoByNo(no);
						if(video){
							video.s3Log = 100;
							CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
						}
						if(!$scope.$$phase) $scope.$apply();
					}
					else if(data.data.success===false) {
						swal({
							title: 'Error',
							text: 'Server Error!!',
							type: 'error',
							showCancelButton: false,
							showConfirmButton: true
						},function(){
							// location.reload();
						});
					}
				},
				function(error) {
					var video = getVideoByNo(no);
					if(video){
						video.error = true;
						if(!$scope.$$phase) $scope.$apply();
						swal(
							{
							  title: "Error",
							  text:
								error.data && error.data.message
								  ? error.data.message.includes(
									  "Internal Server Error"
									) || error.data.includes("html")
									? error.data.includes("timeout")
									  ? "Server timeout (try uploading less videos)"
									  : error.message
									: error.data.message
								  : error.data
								  ? "Internal Server Error"
								  : "your internet connection is unstable please try again later",
							  type: "error",
							  showCancelButton: false,
							  showConfirmButton: true,
							},
							function () {
							  // location.reload();
							}
						  );
					  setErrorToVideo(video.no, video.module_url)

					}
				},
				function(evt) {
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					var video = getVideoByNo(no);
					if(video){
						video.serverLog = progressPercentage;
						CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
					}
				}
			)
		}else{
			if(file.name.length >= 110){
				swal({
					title: 'Error',
					text: 'file name should be less then 110 characters',
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				},function(){
					// location.reload();
				});	
			}
		}
	}
	$scope.uploadVideoToBunny = function(file, no) {
    var date = new Date();
    date = $filter('date')(date, 'MM-dd-yyyy-h:mma');
    var appendingString = file.size + '-' + date;
    $scope.appendingStringVideos.push(appendingString);

    if (!file || file.name.length >= 110) {
        swal({
            title: 'Error',
            text: 'File name should be less than 110 characters',
            type: 'error',
            showCancelButton: false,
            showConfirmButton: true
        });
        return;
    }

    var data = {
        userId: instructorPanelService.getInstructorId(),
        count: no,
        file: file,
        chapter_id: $state.params.id,
        isModule: $scope.editingModule ? 'yes' : 'no',
        socket_id: $scope.socketID,
        appendingString: appendingString,
        module_url: $window.location.href,
        module_id: $state.params.module_id
    };

    // 🔹 CREATE THE UPLOAD REQUEST AND STORE IT
    var uploadRequest = Upload.upload({
        url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/video-to-bunny',
        method: 'POST',
        data: data
    });

    // 🔹 STORE THE REQUEST REFERENCE IN THE VIDEO OBJECT SO WE CAN ABORT IT LATER
    var video = getVideoByNo(no);
    if (video) {
        video.socket_id = $scope.socketID;     // ✅ Store socket_id for backend cancel
        video.count = no;                      // ✅ Store count for backend identification
        video.uploadRequest = uploadRequest;   // ✅ Store upload promise for abort()
    }

    // 🔹 THEN ATTACH THE HANDLERS
    uploadRequest.then(function(resp) {
        // SUCCESS HANDLER
        if (resp.status === 200) {
            var video = getVideoByNo(no);
            if (video) {
                video.s3Log = 100;
                CustomStorageService.setVideoUploaderDropdownState({
                    toVimeo: $scope.toVimeo,
                    toS3: $scope.toS3,
                    toBunny: $scope.toBunny,
                    btnText: $scope.btnText
                });
            }
            if (!$scope.$$phase) $scope.$apply();
        } else {
            swal({
                title: 'Error',
                text: 'Server Error!!',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true
            });
        }
    }, function(error) {
        // ERROR HANDLER
        var video = getVideoByNo(no);
        if (video) {
            video.error = true;
            if (!$scope.$$phase) $scope.$apply();

			// 🔹 Ignore aborted uploads
        	if (error && error.status === -1 && video.userCancelled) {
				console.log('[UPLOAD CANCEL] Upload aborted by user:', video.name);
				return; // Do not show swal
				}

            
            var errorMessage = "Your internet connection is unstable. Please try again later.";
            
            if (error.data && error.data.message) {
                if (error.data.message.includes("Internal Server Error") || 
                    error.data.includes("html")) {
                    errorMessage = error.data.includes("timeout") 
                        ? "Server timeout (try uploading fewer videos)" 
                        : error.message;
                } else {
                    errorMessage = error.data.message;
                }
            } else if (error.data) {
                errorMessage = "Internal Server Error";
            }
            
            swal({
                title: "Error",
                text: errorMessage,
                type: "error",
                showCancelButton: false,
                showConfirmButton: true
            });
            
            setErrorToVideo(video.no, video.module_url);
        }
    }, function(evt) {
        // PROGRESS HANDLER
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        var video = getVideoByNo(no);
        if (video) {
            video.serverLog = progressPercentage;
            CustomStorageService.setVideoUploaderDropdownState({
                toVimeo: $scope.toVimeo,
                toS3: $scope.toS3,
                toBunny: $scope.toBunny,
                btnText: $scope.btnText
            });
        }
    });
}
	$scope.uploadVideo = function(file,no){
		var date = new Date();
		date =$filter('date')(date,'MM-dd-yyyy-h:mma');
		var appendingString =file.size+'-'+date
		$scope.appendingStringVideos.push(appendingString);
		if(file && file.name.length < 110){
			var data = {
				userId: instructorPanelService.getInstructorId(),
				count: no,
				file: file.name,
				chapter_id:$state.params.id,
				isModule: $scope.editingModule?'yes':'no',
				socket_id: $scope.socketID,
				appendingString:appendingString,
				module_url: $window.location.href
			};
			Upload.upload({
				url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/upload/video-to-s3',
				method: 'POST',
				file:file,
				params: data
			}).then(function(data){
				console.log(data, data.data);
				if(data.data.status==='success') {
					var video = getVideoByNo(no);
					if(video){
						video.s3Log = 100;
					}
					if(!$scope.$$phase) $scope.$apply();
				}
				else if(data.data.success===false) {
					var video = getVideoByNo(no);
					if(video){
						video.error = true;
						swal({
							title: 'Error',
							text: 'Server Error!!',
							type: 'error',
							showCancelButton: false,
							showConfirmButton: true
						},function(){
							// location.reload();
						});
					}
				} else {
					var video = getVideoByNo(no);
					if(video){
						video.error = true;
						swal({
							title: 'Error',
							text: data.data.success,
							type: 'error',
							showCancelButton: false,
							showConfirmButton: true
						},function(){
							// location.reload();
						});
					}
				}
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			},
			function(error) {
				var video = getVideoByNo(no);
				if(video){
					video.error = true;
					swal(
						{
						  title: "Error",
						  text:
							error.data && error.data.message
							  ? error.data.message.includes(
								  "Internal Server Error"
								) || error.data.includes("html")
								? error.data.includes("timeout")
								  ? "Server timeout (try uploading less videos)"
								  : error.message
								: error.data.message
							  : error.data
							  ? "Internal Server Error"
							  : "your internet connection is unstable please try again later",
						  type: "error",
						  showCancelButton: false,
						  showConfirmButton: true,
						},
						function () {
						  // location.reload();
						}
					  );
					  setErrorToVideo(video.no, video.module_url)
				}
				if(!$scope.$$phase) $scope.$apply();
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
				// saveStatusToLocalStorage()
			},
			function(evt) {
				var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
				var video = getVideoByNo(no);
				if(video){
					video.serverLog = progressPercentage;
				}
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
		)
	}else{
		if(file.name.length >= 110){
			swal({
				title: 'Error',
				text: 'file name should be less then 110 characters',
				type: 'error',
				showCancelButton: false,
				showConfirmButton: true
			},function(){
				// location.reload();
			});	
		}
	}
}	

	$scope.deleteAttachement = function(attachment,index,index2){
		$scope.showData = false;
		Upload.upload({
			url: '/api/v1/uploader/deleteVideoAttachment',
			method:"POST",
			params:{
				url:attachment.url,
				module_name:$scope.module_name,
				video_name:$scope.video_name,
				video_id:$scope.video_id,
				module_id:$scope.module_id
			}
		}).then(function(data){
			if(data.data.success){
				var data = {
					id: attachment.id
				}
				$http.post('api/v1/attachments/deleteAttachment',data)
				.then(function(data){
					if(data.data.success){
						$scope.showData = true;
						$scope.videos[index].attachments.splice(index2,1);

						$http({
							url: '/api/v1/uploader/zipVideoAttachments',
							method: "POST",
							params: {module_name:$scope.module_name,video_name:$scope.video_name,video_id:$scope.video_id,module_id:$scope.module_id,createFirst:false}
						});
					} else {
						instructorPanelService.tryAgainSwal();
					}
				});
			} else {
				instructorPanelService.tryAgainSwal();
			}
		});
	}

	$scope.deleteNotes = function(attachment,index,index2){
		$scope.showData = false;
		var data = {
			id: attachment.id
		}
		$http.post('api/v1/attachments/deleteAttachment',data)
		.then(function(data){
			if(data.data.success){
				$scope.showData = true;
				$scope.videos.splice(index,1);
			} else {
				instructorPanelService.tryAgainSwal();
			}
		});
	}

	$scope.downloadAttachment = function(url){
		var win = window.open(url, '_blank');
	}

	$scope.editAttachement = function(attachment, video){
		$scope.notesData.name = attachment.name;
		$scope.notesData = {
			name: attachment.name,
			fileLink: attachment.url,
			isSecure: attachment.is_secure,
		};
		selectedAttachment = attachment;
		$scope.showNotesPopup(video);
	}

	var selectedVideo;
	var selectedAttachment;
	var notesFile;
	$scope.notesData = {
		name: '',
		fileLink: '',
		isSecure: false,
	}
	$scope.notesUploadStatus;

	$scope.showNotesPopup = function (video) {
		$("#notes-popup").modal('show');
		selectedVideo = video;
	}

	$scope.closeNotesPopup = function () {
		$("#notes-popup").modal('hide');
		selectedVideo = false;
		selectedAttachment = false;
		notesFile = '';
		$scope.notesData = {
			name: '',
			fileLink: '',
			isSecure: false,
		};
		$scope.notesUploadStatus = '';
	}

	$scope.uploadVideoAttachments = function(file){
		notesFile = file;
		if(file){
			$scope.notesUploadStatus = 'uploading';
			Upload.upload({
				url: '/api/v1/uploader/uploadVideoAttachmentToS3?video_id='+selectedVideo.id+'&module_id='+selectedVideo.module_id+'&userId='+instructorPanelService.getInstructorId()+'&no='+$scope.counter+'&socket_id='+CustomStorageService.getUserInfoStorageData().id,
				method: "POST",
				file: file
			}).then(function(data){
				$scope.notesData.fileLink = data.data.link;
				$scope.notesUploadStatus = 'uploaded';
				$scope.$apply();
			});
		}
	}

	$scope.saveNotes = function() {
		if(!$scope.notesData.fileLink || !$scope.notesData.name) {
			swal("Error", "All Fields are required", "error");
		} else {
			if(selectedAttachment) {
				$scope.updateNotes();
			} else {
				var data = {
					name: $scope.notesData.name,
					url: $scope.notesData.fileLink,
					is_secure: $scope.notesData.isSecure,
					video_id: selectedVideo.id,
				}
				
				$http.post('api/v1/attachments/createAttachment',data)
				.then(function(data){
					if(data.data.success){
						swal("Success", "Video Attachment uploaded successfully", "success");
					} else {
					}
				});
				selectedVideo.attachments.push(data);
				$scope.closeNotesPopup();
			}
		}
		
	}

	$scope.updateNotes = function() {
		var data = {
			name: $scope.notesData.name,
			url: $scope.notesData.fileLink,
			is_secure: $scope.notesData.isSecure,
			attachment_id: selectedAttachment.id
		}
		$http.post('api/v1/attachments/updateAttachment',data)
		.then(function(data){
			if(data.data.success){
				swal("Success", "Video Attachment uploaded successfully", "success");
			} else {
			}
		});

		selectedAttachment.name = data.name;
		selectedAttachment.url = data.url;
		selectedAttachment.is_secure = data.is_secure;
		$scope.closeNotesPopup();
	}

	$scope.deleteAllAttachments = function(index){
		var attachments = $scope.videos[index].attachments;
		if(attachments.length > 0){
			for(var i in attachments){

			}
		}
	}

	$scope.downloadAllAttachments = function(index,video){
		console.log("video attachments",video);
		var video_name = video.name;
		video_name = video_name.split(' ').join('+');
		var win = window.open('https://nearpeer-zips.s3.amazonaws.com/zips/module' + video.module_id + '/' + video_name + '-' +video.id+'.zip', '_blank');
	}

	$scope.uploadImage = function(image,video){
		if(image){
			Upload.upload({
				url: '/api/v1/uploader/uploadVideoImageToS3?socket_id='+ CustomStorageService.getUserInfoStorageData().id +'&userId='+CustomStorageService.getUserInfoStorageData().id+'&no='+$scope.counter,
				method: "POST",
				file: image
			}).then(function(data){
				video.image_url = data.data.link;
				$scope.uploadLog[data.data.no-1].log = 100;
				$scope.close = true;
				swal("Success", "Video Attachment uploaded successfully", "success");
				if(!$scope.$$phase) $scope.$apply();
			});
		}
		var log = {
			name: image.name,
			no: $scope.counter,
			log: 0,
			uploaded: false
		}
		$scope.uploadLog.push(log);
		if(!$scope.$$phase) $scope.$apply();
		$scope.counter++;
		window.scrollTo(0,document.body.scrollHeight);
	};

	$scope.previewPage = function(video){
		var data = video.index_url.split('/');
		if($state.params.state == 'module'){
			var url = $state.href('video_player', {institutionName:data[0],schoolName:data[1],courseName:data[2],moduleNo:video.module_no,video_no:video.video_no});
		} else {
			var url = $state.href('video_player_chapter', {institutionName:data[0],schoolName:data[1],courseName:data[2],moduleNo:video.module_no,chapterNo:video.chapter_no,video_no:video.video_no});
		}
		window.open(url,'_blank');
	}

	$scope.deleteVideo = function(index){
		var videoId = $scope.videos[index].id;
		$http.post(  
			// 'http://localhost:3007'
			 env.backendService
			 +
			'/lmsservice/v1/cvideos/referenced-courses', { video_id: videoId })
		.then(function(refRes) {
			if(refRes.data && refRes.data.courses && refRes.data.courses.length > 1) {
				var courseList = refRes.data.courses.map(function(c) { return '- ' + c.name; }).join('<br>');
				swal({
					title: "You're deleting a video used in " + refRes.data.courses.length + " courses:",
					html: true,
					text: courseList,
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Yes, delete it!",
					closeOnConfirm: true
				}, function(isConfirm){
					if(isConfirm) {
						performDelete();
					}
				});
			} else {
				// Only used in one course, proceed as before
				swal({
					title: "Are you sure to delete this video?",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: "Yes, delete it!",
					closeOnConfirm: true
				}, function(isConfirm){
					if(isConfirm) {
						performDelete();
					}
				});
			}
		});

		function performDelete() {
			var id = $scope.videos[index].id;
			var data = {id:id};
			$scope.showData = false;
			$http.post('api/v1/cvideos/deleteVideo',data)
			.then(function(data){
				$scope.showData = true;
				if(data.data.success){
					$scope.videos.splice(index,1);
				} else {
					instructorPanelService.tryAgainSwal();
				}
			})
		}
	}

	$scope.notExists = function(video){
		for(var i in $scope.uploadedVideos){
			if(video.url_mpd == $scope.uploadedVideos[i].url_mpd){
				return false
			}
		}
		return true;
	}
	$scope.notExistsVimeoVideo = function(video){
		for(var i in $scope.uploadedVideos){
			if(video.vss_link == $scope.uploadedVideos[i].vss_link){
				return false
			}
		}
		return true;
	}

	$scope.jobS3Completed = function(data){
		var video = getVideoByNo(data.count);
		if(video) {
			if(!video.error){
				if(data.progress===100){
					video.jobLog = data.progress;
					video.s3Log = data.progress;
					video.uploaded = true;
				}else{
					video.s3Log = 100;
					video.jobLog = data.progress;
				}
			}
			if (!$scope.$$phase) $scope.$apply();
			var video_name = video.name;
			video_name = $state.params.id + '-'+ $scope.appendingStringVideos[data.count-1] + '-'+ video_name;
			video_name = video_name.replace(/[^a-zA-Z0-9]/g, '-');
			video.url = data.url;
			video.url_mpd = 'https://video.nearpeer.org/'+data.video_name+data.hight+'.mpd';
			video.duration = data.duration;
			if($scope.notExists(video)){
				$scope.uploadedVideos.push(video);
			}
			CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
		}
	}

	$scope.jobVimeoCompleted = function(data){
		var video = getVideoByNo(data.count);
		if(video) {
			video.jobLog = data.progress;
			video.s3Log = data.progress;
			video.uploaded = true;
			if (!$scope.$$phase) $scope.$apply();
			video.url = '';
			video.url_mpd = '';
			video.vss_link = data.vss_link;
			video.vss_id = data.vss_id;
			video.vss_uri = data.vss_uri;
			video.duration = data.duration;
			if($scope.notExistsVimeoVideo(video)){
				$scope.uploadedVideos.push(video);
			}
			CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
		}
		
	}
	$scope.jobBunnyCompleted = function(data){
    var video = getVideoByNo(data.count);
    if(video) {
        video.jobLog = data.progress;
        video.s3Log = data.progress;
        video.uploaded = true;
        // Set bunny info
        video.bunny_id = data.bunny_id;
        video.bunny_url = data.bunny_url || data.bunny_path;
		video.hetzner_url = data.hetzner_url; // Add this line
        video.is_bunny = !!(video.bunny_id && video.bunny_url);
        video.duration = data.duration || 0;

        // CRITICAL: Update the localStorage with the new bunny data
        var videoData = CustomStorageService.getVideoUploadingState();
        if(videoData && videoData.length > 0) {
            // Find and update the video in localStorage
            var videoIndex = videoData.findIndex(function(v) {
                return v.no === video.no && v.module_url === video.module_url;
            });
            
            if(videoIndex !== -1) {
                // Update the localStorage entry with completion data
                videoData[videoIndex].bunny_id = video.bunny_id;
                videoData[videoIndex].bunny_url = video.bunny_url;
				videoData[videoIndex].hetzner_url = video.hetzner_url; // Add this line
                videoData[videoIndex].is_bunny = video.is_bunny;
                videoData[videoIndex].duration = video.duration;
                videoData[videoIndex].s3Log = data.progress;
                videoData[videoIndex].jobLog = data.progress;
                videoData[videoIndex].uploaded = true;
                
                // Save back to localStorage
                CustomStorageService.setVideoUploadingState(videoData);
            }
        }

        if (!$scope.$$phase) $scope.$apply();
        
        // Add the video to uploadedVideos array
        if($scope.notExistsBunnyVideo(video)){
            $scope.uploadedVideos.push(video);
        }
        
        CustomStorageService.setVideoUploaderDropdownState({
            toVimeo:$scope.toVimeo,
            toS3:$scope.toS3,
            btnText:$scope.btnText,
            toBunny:$scope.toBunny
        });
    }
}

// 2. Update the initialization logic to check for bunny completion data
setTimeout(function() {
    if(videoData!==false && videoData !== null && videoData !== undefined && videoData.length>0){
        var itemsProcessed = 0; 
        angular.forEach(videoData, function(video, key) {
            if(video.module_url===$window.location.href && !video.error){
                video.serverLog = 100;
                
                // Check for completion based on server type and available data
                if(video.server === 'Bunny' && video.bunny_id && video.bunny_url) {
                    console.log('Bunny video found completed:', video.name, video.bunny_id);
                    video.s3Log = 100;
                    video.jobLog = 100;
                    video.uploaded = true;
                } else if(video.server === 'Vimeo' && video.vss_id) {
                    video.s3Log = 100;
                    video.jobLog = 100;
                    video.uploaded = true;
                } else if(video.server === 'S3' && video.url_mpd) {
                    video.s3Log = 100;
                    video.jobLog = 100;
                    video.uploaded = true;
                } else {
                    console.log('Video not completed, keeping progress:', video.name, video.server);
                    // Keep existing progress values from localStorage
                    // Don't reset to 0 if there's partial progress
                }
                
                $scope.uploadingVideos.push(video);
            }else{
                video.s3Log = 0;
                video.jobLog = 0;
                $scope.uploadingVideos.push(video);
            }
            
            itemsProcessed++;
            if(itemsProcessed===videoData.length){
                var max = videoData.reduce(function (prev, current) {
                    return (prev.no > current.no) ? prev : current
                });
                $scope.counter = max.no+1;
            }
        });
    }
}, 400)

$scope.notExistsBunnyVideo = function(video){
    for(var i in $scope.uploadedVideos){
        if(video.bunny_id && video.bunny_id == $scope.uploadedVideos[i].bunny_id){
            return false
        }
    }
    return true;
}
	$scope.close = false;
	$sails.on('videoAttachmentProgress', function(data) {
		console.log('videoAttachmentProgress')
		console.log(data);
		console.log($window.location.href);
		if(data.module_url=== $window.location.href){
			console.log('111111')
			$scope.uploadLog[data.no-1].log = data.prog;
			if(!$scope.$$phase) $scope.$apply();
			if(data.prog == 100){
				$scope.uploadLog[data.no-1].uploaded = true;
				// $scope.close = true;
				// swal("Success", "Video Attachment created successfully", "success");
			}
		}
	});
	$scope.socket.on('s3FileUpload', function(data) {
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.s3Log = data.progress;
				video.serverLog = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});
	$sails.on('s3FileUpload', function(data) {
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.s3Log = data.progress;
				video.serverLog = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});
	$scope.socket.on('serverFileUpload', function(data) {
		if(data.module_url === $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				// Optionally, also update video.serverLog if your UI uses that
				video.serverLog = data.progress;
				// CustomStorageService.setVideoUploaderDropdownState({
				// 	toVimeo: $scope.toVimeo,
				// 	toS3: $scope.toS3,
				// 	toBunny: $scope.toBunny,
				// 	btnText: $scope.btnText
				// });
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});

	$scope.socket.on('bunnyFileUpload', function(data) {
		if(data.module_url === $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				// Optionally, also update video.serverLog if your UI uses that
				video.s3Log = data.progress; // Bunny CDN progress
				// CustomStorageService.setVideoUploaderDropdownState({
				// 	toVimeo: $scope.toVimeo,
				// 	toS3: $scope.toS3,
				// 	toBunny: $scope.toBunny,
				// 	btnText: $scope.btnText
				// });
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});
	
	// Listen for Bunny job complete
	$scope.socket.on('job_complete_bunny', function(data) {
		if(data.module_url === $window.location.href){
			// You can create a function like $scope.jobBunnyCompleted(data)
			$scope.jobBunnyCompleted(data);
		}
	});

	const transcodingSteps = [
		"Transcoding started.",
		"Transcoding 240p stream...",
		"Transcoding 360p stream...",
		"Transcoding 480p stream...",
		"Transcoding completed."
	  ];
	  
		function getTranscodingProgress(message) {
		var idx = -1;
		for (var i = 0; i < transcodingSteps.length; i++) {
			if (message === transcodingSteps[i]) {
			idx = i;
			break;
			}
		}
		if (idx === -1) return 0;
		return Math.floor(((idx + 1) / transcodingSteps.length) * 100); // e.g., 20%, 40%, 60%...
		}


	  $scope.socket.on('bunnyTranscodingUpdate', function(data) {
		if (data.module_url === $window.location.href) {
			var video = getVideoByNo(data.count);
			if (video) {
				video.bunnyTranscodeLog = data.transcodingMessage;
				video.bunnyProgress = getTranscodingProgress(data.transcodingMessage); // as defined earlier
				video.serverLog = video.bunnyProgress; // this will make your existing % Complete UI work
			}
			if (!$scope.$$phase) $scope.$apply();
		}
	});
	
	$scope.socket.on('FileUpload', function(data) {
		console.log('Vimeo FileUpload event called', data);
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.s3Log = data.progress;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});
	$sails.on('FileUpload', function(data) {
		console.log('Vimeo FileUpload event called', data);
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.s3Log = data.progress;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
			if(!$scope.$$phase) $scope.$apply();
		}
	});

	$sails.on('transcoding_vimeo', function(data) {
		console.log('transcoding_vimeo event called', data)
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.jobLog = data.progress;
				video.s3Log = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText, toBunny:$scope.toBunny});
			}
			if (!$scope.$$phase) $scope.$apply();
		}
	});
	$scope.socket.on('job_create', function(data) {
		console.log('job_create event called', data);
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.jobLog = data.progress;
				video.s3Log = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText,toBunny:$scope.toBunny});
			}
			if (!$scope.$$phase) $scope.$apply();
		}
	});
	$scope.socket.on('job_complete', function(data) {
		console.log('job_complete event called', data);
		if(data.module_url=== $window.location.href){
			$scope.jobS3Completed(data);
		} 
	});

	$scope.socket.on('job_error', function(data) {
		console.log('job_error event called', data);
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.error = true;
				if(!$scope.$$phase) $scope.$apply();
				swal({
					title: 'Error',
					text: 'Server Error! Try Again',
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				},function(){
				// location.reload();
				});
			}
		}
	});
	$scope.socket.on('ERROR', function(data) {
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.error = true;
				if(!$scope.$$phase) $scope.$apply();
				swal({
					title: 'Error',
					text: data.error.message || 'Server Error! Try Again',
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				},function(){
				// location.reload();
				});
			}
		}
	});
	$scope.socket.on('transcoding_vimeo', function(data) {
		console.log('transcoding_vimeo event called', data)
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.jobLog = data.progress;
				video.s3Log = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText, toBunny:$scope.toBunny});
			}
			if (!$scope.$$phase) $scope.$apply();
		}
	});
	$sails.on('job_create', function(data) {
		console.log('job_create event called', data);
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.jobLog = data.progress;
				video.s3Log = 100;
				CustomStorageService.setVideoUploaderDropdownState({toVimeo:$scope.toVimeo,toS3:$scope.toS3,btnText:$scope.btnText, toBunny:$scope.toBunny});
			}
			if (!$scope.$$phase) $scope.$apply();
		}
	});

	$sails.on('job_complete', function(data) {
		console.log('job_complete event called', data);
		if(data.module_url=== $window.location.href){
			$scope.jobS3Completed(data);
		} 
	});

	$scope.socket.on('job_complete_vimeo',function(data){
		console.log('job_complete_vimeo event called', data);
		if(data.module_url=== $window.location.href){
			$scope.jobVimeoCompleted(data);
		}
	})
	$sails.on('job_complete_vimeo', function(data) {
		console.log('job_complete_vimeo event called', data)
		if(data.module_url=== $window.location.href){
		$scope.jobVimeoCompleted(data);
		}
	});

	$sails.on('job_error', function(data) {
		console.log('job_error event called', data)
		if(data.module_url=== $window.location.href){
		var video = getVideoByNo(data.count);
		if(video) {
			video.error = true;
			if(!$scope.$$phase) $scope.$apply();
			swal({
				title: 'Error',
				text: 'Server Error! Try Again',
				type: 'error',
				showCancelButton: false,
				showConfirmButton: true
			},function(){
				// location.reload();
			});
			}
		}
	});

	$sails.on('server_error', function(data) {
		console.log('server_error event called', data)
		if(data.module_url=== $window.location.href){
			var video = getVideoByNo(data.count);
			if(video) {
				video.error = true; 
				if(!$scope.$$phase) $scope.$apply(); 
				swal({
					title: 'Error',
					text: data.error ,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				},function(){
					// location.reload();
				});
			}
		}
	});

	if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
		$state.go('instructor_signin',{},{reload:true});
	} else {
		$scope.initialize();
	}


}])
})();
(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('InstructorPanelTransactionController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			sr.selectedCourse ='';
			sr.title ='';
			sr.showCoursePopup = false;
			sr.closeCoursePopup = function(){
				sr.showCoursePopup = false;
			}
			sr.viewCoursePopup = function(course,title) {
				sr.selectedCourse = course;
				sr.title = title;
				sr.showCoursePopup = true;
			}
			var signedIn = CustomStorageService.getUserInfoStorageData();
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user'];
			sr.searchData = [];
			sr.pageText ='1st';
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				instructor_id: CustomStorageService.getUserInfoStorageData().id,
				email: CustomStorageService.getUserInfoStorageData().email
			};
			sr.searchOrder = function (value, type, flag, first,perPage) {
				$scope.searchParams.per_page = perPage;
				if (first) {
					sr.searchParams.page = 1;
					sr.pageText ='1st';
				}
				if ((type === "user" || type === "course") && !flag) {
					SearchService.getSearchData(value, type)
						.then(function (data) {
							sr.searchData = data;
						});
				} else if ( type === 'all' ) {
					getOrders(sr.searchParams);
				} else if ((type === "user" || type === "course") && flag){
					sr.searchParams.key = value;
					sr.searchData = [];
					getOrders(sr.searchParams);
				}
			}
			var getOrders = function (data) { 
				HttpService.postRequest('api/v1/orders/get', data)
					.then(function (res) { 			
						if(res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							  }, function() {
								swal.close();
								sr.searchParams.forDownload = false;
							  });

						} else { 
							sr.orders = res.orders;
							sr.totalPages = res.pages;
							sr.totalCount = res.orderCount;
						}
						
					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.pageText =ordinal_suffix_of(page);
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true,false,$scope.searchParams.per_page);
				}
			}
			function ordinal_suffix_of(i) {
				var j = i % 10,
					k = i % 100;
				if (j == 1 && k != 11) {
					return i + "st";
				}
				if (j == 2 && k != 12) {
					return i + "nd";
				}
				if (j == 3 && k != 13) {
					return i + "rd";
				}
				return i + "th";
			}
			sr.changeType = function(type) { 
				sr.searchParams.type=type;
				sr.searchParams.key="";
				if(type==='all') {
					getOrders(sr.searchParams);
				}
			}   
			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('instructor_signin', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
			}
		}]);
})();
(function() {
	'use strict';

	angular
	.module('NearPeer')

	.controller('InstructorPanelQuizDashboardController', ['$scope', '$http', '$state', 'CustomStorageService','instructorPanelService','env', function($scope, $http, $state, CustomStorageService,instructorPanelService,env) {
		$(document).ready(function(){
			$(this).scrollTop(0);
		});

		$scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();
		$scope.goToQuizCenter= function(){
			var user = CustomStorageService.getUserInfoStorageData();
			var token = CustomStorageService.getAuthTokenStorageData();
			if(user && token){
				console.log("token",token,"user",user);
			  var url = env.quizCenter + '?uid=' + user.id + '&token=' + token + '&redirecturl='+encodeURIComponent('quiz/quiz-landing');
			  console.log(url)
			  window.open(url, '_blank')
			}
		  };
		$scope.initialize = function(){
			$scope.goToQuizCenter();
			// $http({
			// 	url: 'api/v1/quiz/getAllQuiz',
			// 	method: "GET",
			// 	params: {instructor_id: instructorPanelService.getInstructorId()}
			// }).then(function(data){
			// 	$scope.quizzes = data.data.quizzes;
			// });
		}

		$scope.goToNewQuizPage = function (){
			$state.go('InstructorPanelQuizNew')
		}

		$scope.goToEditQuizPage = function(id){
			$state.go('InstructorPanelQuizEdit',{id:id});
		}

		$scope.deleteQuiz = function(id,index){
			swal({
				title: 'Warning',
				text: 'Are you sure you want to delete this quiz?',
				type: 'warning',
				showCancelButton: true
			},function(isConfirm){
				if(isConfirm){
					var data = {id:id};
					$http.post('api/v1/quiz/deleteQuiz', data)
					.then(function(data) {
						if(data.data.success){
							instructorPanelService.successDeleteSwal();
							$scope.quizzes.splice(index,1);
							$state.go('InstructorPanelQuizDashboard',{},{reload:true});
						} else{
							instructorPanelService.tryAgainSwal();
						}
					});
				}
			});
		}

		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
			$state.go('instructor_signin',{},{reload:true});
		} else {
			$scope.initialize();
		}
	}]);
})();

// (function() {
// 	'use strict';

// 	angular
// 	.module('NearPeer')

// 	.controller('InstructorPanelQuizController', ['$scope','Upload', '$http', '$state', 'CustomStorageService', '$sails','instructorPanelService','$filter', function($scope, Upload, $http, $state, CustomStorageService, $sails,instructorPanelService,$filter) {
// 		$(document).ready(function(){
// 			$(this).scrollTop(0);
// 		});
// 		$scope.sortingoptions='-id';
// 		$scope.pastingText=function (e,index,id,parent) {
// 			e.preventDefault();
// 			if (window.clipboardData && window.clipboardData.getData) { // IE
// 				var pastedText = window.clipboardData.getData('Text');
// 			} else if (e.clipboardData && e.clipboardData.getData) {
// 				var pastedText = e.clipboardData.getData('text/plain');
// 			}
// 			if(!pastedText.match(/\\\s/g)) {
// 				var a =pastedText.replace(/\s+/g,'\\ ');
// 			}
// 			else {
// 				a =pastedText;
// 			}
// 			if(id==='math-field-option') {
// 				var mathFiel=document.getElementById(id+parent+index);
// 			} else {
// 				var mathFiel=document.getElementById(id+index);
// 			}
// 			if($scope.ctrlPressed && $scope.aPressed){ 
// 				mathFiel.textContent="";	
// 			}
// 			var MQ = MathQuill.getInterface(2);
// 			var mathField = MQ.MathField(mathFiel, {});
// 			mathField.write(a);			
// 		}
// 		$scope.onKeyDown = function(id,index){
// 			var e = window.event;
// 			var key = e.which || e.keyCode;
// 			if(17 == key) { 
// 				$scope.ctrlPressed = true;
// 			}else if(65 == key) { 
// 				$scope.aPressed = true;
// 			}else if(13 == key) {
// 				$scope.mathCreator2(id+index,'\\textcolor{}{\\text{&nbsp}}');
// 			}else if(8 == key){
// 				// var element = document.getElementById(id+index).trigger("focus");
// 				// element.classList.remove("mq-textcolor .mq-text-mode");	
// 			}else if(86 == key) { 

// 			}else{
// 				$scope.ctrlPressed = false;
// 				$scope.aPressed = false;
// 			}
// 		}
// 		$scope.mathCreator2 =  function(id,data) {
// 			setTimeout(function(){
// 				var mathFieldSpan = document.getElementById(id);
// 				var MQ = MathQuill.getInterface(2);
// 					var mathField = MQ.MathField(mathFieldSpan, {
// 						spaceBehavesLikeTab: false, // configurable
// 						handlers: {
// 							edit: function() { // useful event handlers
// 								data=mathField.latex();
// 							}
// 						}
// 					});
// 					mathField.write(data);
// 			},100)
// 		}
// 		var mathCreator =  function(index,update,id,parent) {
// 			setTimeout(function(){
// 				var mathFieldSpan = document.getElementById(id + index);
// 				var MQ = MathQuill.getInterface(2); // for backcompat
// 				if(id ==='math-field') {
// 					var mathField = MQ.MathField(mathFieldSpan, {
// 						spaceBehavesLikeTab: false, // configurable
// 						handlers: {
// 							edit: function() { // useful event handlers
// 								$scope.quiz.questions[index-1].mathtext=mathField.latex();
// 							}
// 						}
// 					});
// 				}else if(id ==='math-field-sol') {
// 					var mathField = MQ.MathField(mathFieldSpan, {
// 						spaceBehavesLikeTab: false, // configurable
// 						handlers: {
// 							edit: function() { // useful event handlers
// 								$scope.quiz.questions[index-1].solution=mathField.latex();
// 							}
// 						}
// 					});
// 				}else{
// 					var mathField = MQ.MathField(mathFieldSpan, {
// 						spaceBehavesLikeTab: false, // configurable
// 						handlers: {
// 							edit: function() { // useful event handlers
// 								$scope.quiz.questions[parent].options[index-1].answer=mathField.latex();
// 							}
// 						}
// 					});
// 				}
// 				if(update===true && id ==='math-field'){
// 					mathField.write($scope.quiz.questions[index-1].mathtext);
// 				}else if(update===true && id ==='math-field-sol'){ 
// 					var data = $scope.quiz.questions[index-1].solution;
// 					if(!data.match(/\\\s/g)) {
// 						data = data.replace(/\s+/g,'\\ ');
// 					}
// 					if(data!=='' && data!=='null'){
// 						mathField.write(data);
// 					} 
// 				}else if(update===true && id ==='math-field-option'+parent){
// 					mathField.write($scope.quiz.questions[parent].options[index-1].answer);
// 				}
// 			},100)
// 		}
// 		$scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();
// 		$scope.initialize = function(){
// 			$scope.counter = 0;
// 			$scope.imageUploadProgress = []
// 			$scope.value = -1;
// 			$scope.modules = [];
// 			$scope.chapters = [];
// 			$scope.videos = [];
// 			if($state.current.name == 'InstructorPanelQuizNew'){
// 				$scope.quiz = {
// 					questions: [],
// 					quizName: '',
// 					quizType: 0,
// 					video_id: ''
// 				}
// 				$scope.creatingQuiz = true;
// 				$scope.showData = false;
// 				$http({
// 					url:'api/v1/courses/getAllCourses',
// 					method:"GET",
// 					params: {instructor_id:instructorPanelService.getInstructorId(),type:'instructor'}
// 				}).then(function(data){
// 					$scope.showData = true;
// 					$scope.courses = data.data.courses;
// 					$scope.selectedCourse = 'Select Course';
// 					$scope.selectedModule = 'Select Module';
// 					$scope.selectedChapter = 'Select Chapter';
// 					$scope.selectedVideo = 'Select Video';
// 					$scope.quizType = 'Select Quiz Type';
// 				})
// 			} else {
// 				$scope.showData = false;
// 				$http({
// 					url: 'api/v1/quiz/getQuizIp',
// 					method: "GET",
// 					params: {quiz_id: $state.params.id}
// 				}).then(function(data){
// 					data.data.quiz.questions = $filter('orderBy')(data.data.quiz.questions, 'id/-1',true);
// 					$scope.quizTime=[];
// 					$scope.quizTime.hours = Math.floor((data.data.quiz.duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
// 					$scope.quizTime.minutes = Math.floor((data.data.quiz.duration % (1000 * 60 * 60)) / (1000 * 60));
// 					$scope.quizTime.seconds = Math.floor((data.data.quiz.duration % (1000 * 60)) / 1000);
// 					$scope.showData = true;
// 					if(data.data.success){
// 						$scope.quiz = data.data.quiz;
// 						for(var i in $scope.quiz.questions){
// 							if( $scope.quiz.questions[i].mathtext) {
// 								$scope.quiz.questions[i].mathbox=true;
// 							}
// 							$scope.quiz.questions[i].options = $filter('orderBy')($scope.quiz.questions[i].options, 'id/-1',true);
// 							for(var j in $scope.quiz.questions[i].options) {
// 								mathCreator(+j+1,true,'math-field-option'+i,i);
// 							}
// 							mathCreator(+i+1,true,'math-field',null);
// 							mathCreator(+i+1,true,'math-field-sol',null);
// 							for(var j in data.data.videos){
// 								if($scope.quiz.questions[i].relatedVideo == data.data.videos[j].id){
// 									$scope.quiz.questions[i].selectedVideoName = data.data.videos[j].name;
// 								}
// 							}
// 						}
// 						$scope.videos = data.data.videos;
// 						$scope.setQuizType(data.data.quiz.quizType);
// 					}
// 				});
// 			}
// 		}
// 		$scope.updateCourse = function(course){
// 			$scope.selectedCourse = course.name;
// 			$scope.showData = false;
// 			$scope.modules = [];
// 			$scope.chapters = [];
// 			$scope.videos = [];
// 			$http({
// 				url: 'api/v1/courses/getModulesByCourseId',
// 				method: "GET",
// 				params: {id:course.id}
// 			}).then(function(data){
// 				$scope.showData = true;
// 				$scope.modules = data.data.modules;
// 			});
// 		}

// 		$scope.updateModule = function(module){
// 			$scope.selectedModule = module.name
// 			$scope.showData = false;
// 			$scope.chapters = [];
// 			$scope.videos = [];
// 			$http({
// 				url: 'api/v1/chapter/getChapterByModuleId',
// 				method: "GET",
// 				params: {id:module.id}
// 			}).then(function(data){
// 				$scope.showData = true;
// 				$scope.chapter = [];
// 				if(data.data.chapters.length > 0){
// 					$scope.chapters = data.data.chapters;
// 				} else {
// 					$scope.getVideos('module',module);
// 				}
// 			});
// 		}

// 		$scope.getVideos = function(type,obj){
// 			$scope.showData = false;
// 			$scope.videos = [];
// 			if(type == 'module'){
// 				var data = {
// 					module_id: obj.id
// 				}
// 			} else {
// 				$scope.selectedChapter = obj.name;
// 				var data = {
// 					id: obj.id
// 				}
// 			}
// 			$http({
// 				url: 'api/v1/cvideos/getVideoById',
// 				method: "GET",
// 				params: data
// 			}).then(function(data){
// 				$scope.showData = true;
// 				$scope.videos = data.data.videos;
// 			})
// 		}
// 		$scope.updateVideoId = function(video){
// 			$scope.selectedVideo = video.name;
// 			$scope.selectedVideoId = video.id;
// 		}
// 		$scope.setQuizType = function(id){
// 			$scope.quiz.quizType = id;
// 			if(id == 1){
// 				$scope.SatQuiz =false;
// 				$scope.quizType = 'Full Quiz';
// 			} else if (id == 2){
// 				$scope.SatQuiz =false;
// 				$scope.quizType = 'Popup Quiz';
// 			} else if (id == 3){
// 				$scope.SatQuiz =true;
// 				$scope.quizType = 'SAT Quiz';
// 			}
// 		}
// 		$scope.saveData = function(){
// 			if($scope.quizTime !==undefined) {
// 				var time=0;
// 				if($scope.quizTime.hours!==undefined) {
// 					time = ($scope.quizTime.hours*60* 60*1000);
// 				}
// 				if($scope.quizTime.minutes!==undefined) {
// 					time =time + ($scope.quizTime.minutes*60*1000);
// 				}
// 				if ($scope.quizTime.seconds!==undefined) {
// 					time =time + ($scope.quizTime.seconds*1000);
// 				}
// 				$scope.quiz.duration=time;
// 			}
// 			if(!validateQuiz($scope.quiz)){
// 				return false
// 			}
// 			for(var i in $scope.quiz.questions){
// 				if(!$scope.quiz.questions[i].relatedVideo){
// 					$scope.quiz.questions[i].relatedVideo = -1;
// 				}
// 			}
// 			if($scope.creatingQuiz){
// 				if(!$scope.selectedVideoId){
// 					swal('Oops..','Please select a video for the quiz to be placed after','error');
// 					return false;
// 				}
// 				$scope.quiz.video_id = $scope.selectedVideoId;
// 				var data ={quiz: $scope.quiz};
// 				$scope.showData = false;
// 				$http.post('api/v1/quiz/createQuiz',data)
// 				.then(function(data){
// 					$scope.showData = true;
// 					if(data.data.success){
// 						swal('Success','Quiz Created Successfully','success');
// 						$state.go('InstructorPanelQuizDashboard');
// 					} else {
// 						instructorPanelService.tryAgainSwal();
// 					}
// 				});
// 			} else {
// 				$scope.showData = false;
// 				$http.post('api/v1/quiz/updateQuiz',{quiz: $scope.quiz})
// 				.then(function(data){
// 					$scope.showData = true;
// 					$scope.responsePopup= false;
// 					if(data.data.success){
// 						instructorPanelService.successUpdateSwal();
// 						location.reload();
// 					} else {
// 						instructorPanelService.tryAgainSwal();
// 					}
// 				});
// 			}
// 		}

// 		var validateQuiz = function(quiz){
// 			if(!quiz.quizName){
// 				swal('Oops..','Please add a name for the quiz','error');
// 				return false;
// 			}
// 			if(!quiz.quizType){
// 				swal('Oops..','Please select quiz type','error');
// 				return false;
// 			}
// 			if(!quiz.questions){
// 				swal('Oops..','Please add questions to the quiz','error');
// 				return false;
// 			}
// 			for(var i in quiz.questions){
// 				if(!quiz.questions[i].text){
// 					var z = parseInt(i)+1;
// 					var text = 'Please add text to question no ' + z;
// 					swal('Ooops,',text,'error');
// 					return false;
// 				}
// 				if(quiz.questions[i].mathtext===undefined){
// 					quiz.questions[i].mathtext='';
// 				}
// 				var x = 0;
// 				for(var j in quiz.questions[i].options){
// 					if(!quiz.questions[i].options[j].answer){
// 						var z = parseInt(i)+1;
// 						var y = parseInt(j) + 1
// 						var text = 'Please add text to option no ' + y + ' in question no ' + z;
// 						swal('Oops..',text,'error');
// 						return false;
// 					}
// 					if(quiz.questions[i].options[j].correct){
// 						x = 1;
// 					}
// 				}
// 				if(x == 0){
// 					var z = parseInt(i)+1;
// 					var text = 'Please select correct answer for question no ' + z;
// 					swal('Oops..',text,'error');
// 					return false;
// 				}
// 			}
// 			return true;
// 		}
// 		$scope.addQuestion = function(index){
// 			var questionObj = {
// 				text: '',
// 				image_url: '',
// 				options: [],
// 				relatedVideo: '',
// 				correctAnswer: -1,
// 				topic: '',
// 				selectedVideoName: 'Select Related Video'
// 			};
// 			for(var i=0;i<4;i++){
// 				mathCreator(+i+1,false,'math-field-option'+index,index);
// 				var optionObj = {
// 					answer: '',
// 					image_url: null,
// 					correct: false
// 				}
// 				questionObj.options.push(optionObj);
// 			}
// 			$scope.quiz.questions.push(questionObj);
// 			mathCreator($scope.quiz.questions.length,false,'math-field',null);
// 			mathCreator($scope.quiz.questions.length,false,'math-field-sol',null);
// 		}
// 		$scope.addOption = function(options,index){
// 			var optionObj = {
// 				answer: '',
// 				image_url: null,
// 				correct: false
// 			}
// 			options.push(optionObj);
// 			mathCreator($scope.quiz.questions[index].options.length,false,'math-field-option'+index,index);
// 		}
// 		$scope.deleteQuestion = function(question,index){
// 			swal({
// 				title: "Are you sure to delete this question?",
// 				type: "warning",
// 				showCancelButton: true,
// 				confirmButtonColor: "#DD6B55",
// 				confirmButtonText: "Yes!",
// 				closeOnConfirm: true},
// 				function(isConfirm){
// 					if(isConfirm) {
// 						if(question.id){
// 							$http.post('api/v1/quiz/deleteQuestion',{id:question.id, quiz_id: $state.params.id})
// 							.then(function(data){
// 								if(data.data.success){
// 									$scope.quiz.questions.splice(index,1);
// 								} else {
// 									instructorPanelService.tryAgainSwal();
// 								}
// 							});
// 						} else {
// 							$scope.quiz.questions.splice(index,1);
// 						}
// 						if(!$scope.$$phase) $scope.$apply();
// 					}
// 				});
// 		}
// 		$scope.updateCorrectAnswer = function(options,index){
// 			for(var i in options){
// 				options[i].correct = false;
// 			}
// 			options[index].correct = true;
// 		}

// 		$scope.deleteOption = function(question,index){
// 			swal({
// 				title: "Are you sure to delete this option?",
// 				type: "warning",
// 				showCancelButton: true,
// 				confirmButtonColor: "#DD6B55",
// 				confirmButtonText: "Yes!",
// 				closeOnConfirm: true},
// 				function(isConfirm){
// 					if(isConfirm) {
// 						if(question.options[index].id){
// 							$http.post('api/v1/quiz/deleteOption',{id:question.options[index].id, quiz_id: $state.params.id})
// 							.then(function(data){
// 								if(data.data.success){
// 									question.options.splice(index,1);
// 								}
// 							})
// 						} else{
// 							question.options.splice(index,1);

// 						}
// 						if(!$scope.$$phase) $scope.$apply();

// 					}
// 				});
// 		}

// 		$scope.uploadQuizImage = function(image,obj,type){
// 			var uploadLog = {
// 				name: image.name,
// 				log: 0
// 			}
// 			$scope.imageAddedText = true;
// 			setTimeout(function(){
// 				$scope.imageAddedText = false;
// 			},2000)
// 			$scope.imageUploadProgress.push(uploadLog);
// 			Upload.upload({
// 				url: '/api/v1/uploader/uploadQuizImageToS3?socket_id='+ CustomStorageService.getSocketIdStorageData() + '&user_id='+CustomStorageService.getUserInfoStorageData().id+'&no='+$scope.counter,
// 				method: "POST",
// 				file: image
// 			}).then(function(data){
// 				$scope.imageUploadProgress[data.data.no].log = 100
// 				if(type == 'solution'){
// 					obj.solution_image = data.data.link;
// 				} else {
// 					obj.image_url = data.data.link;
// 				}
// 				if(!$scope.$$phase) $scope.$apply();
// 			});
// 			$scope.counter++;
// 			window.scrollTo(0,document.body.scrollHeight);
// 		}
// 		$scope.deleteSolutionImage = function(question, type){
// 			$http.post('api/v1/quiz/deleteSolutionImage', { ques_id: question.id, type: type, quiz_id: $state.params.id })
// 			.then(function (data) {
// 				location.reload();
// 			});
// 		}

// 		$scope.loadTags = function(query) {
// 			return $http.get('api/v1/quiztags/getMatchingTags?query=' + query);
// 		}

// 		$scope.deleteTag = function(question, tag, type){
// 			$http.post('api/v1/quiz/deleteTag', { tag_id: tag.id, ques_id: question.id, type: type, quiz_id: $state.params.id})
// 			.then(function (data) {
// 				$scope.showData = true;
// 			});
// 		}

// 		$scope.createTagId = function(tag){
// 			if(tag.id == undefined) {        
// 				tag.id= tag.text;
// 			 }
// 			 return tag;
// 		}

// 		$scope.selectVideo = function(video,question){
// 			question.relatedVideo = video.id;
// 			question.selectedVideoName = video.name;
// 		}

// 		$sails.on('quizImageUploadProgress',function(data){
// 			$scope.imageUploadProgress[data.no].log = data.prog;
// 			if(!$scope.$$phase) $scope.$apply();
// 		});

// 		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
// 			$state.go('instructor_signin',{},{reload:true});
// 		} else {
// 			$scope.initialize();
// 		}

// 	}]);
// })();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("questionsController", [
      "$scope",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "instructorPanelService",
      "$sails",
      "env",
      "$sce",
      function (
        $scope,
        Upload,
        $http,
        $state,
        CustomStorageService,
        instructorPanelService,
        $sails,
        env,
        $sce
      ) {
        $(document).ready(function () {
          $(this).scrollTop(0);
        });
        var sr = $scope;
        var per_page = 10;
        var commentType = "all";
        var totalUnansweredCount = 0;
        $scope.newQuestion = false;

        $scope.page = 1;
        $scope.total = 10;
        $scope.totalPages = 1;
        $scope.userQuestions;
        $scope.showData = false;
        $scope.selectedQuestionImage;
        $scope.selectedQuestion;
        $scope.selectedInstructor;
        $scope.selectedQuestionToAnswer;
        $scope.imageshowloader = true;
        $scope.filterSelected = {
          all: true,
          answered: false,
          unanswered: false,
        };
        $scope.remaining = false;
        $scope.rem_stars = [];
        $scope.callFilters = {
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          pageNo: 1,
          limit: 10,
          answered: null,
          sort: "date",
          order: "desc",
          search: "",
          from_date: "",
          to_date: "",
        };
        $scope.searchText = "";
        $scope.totalPageCount;
        $scope.findInstructor = "";
        $scope.instText = "";
        $scope.selected = false;
        $scope.displayQuestion = false;
        $scope.displayAnswer = false;
        $scope.assignInstructor = false;
        $scope.pageArr = [1, 2, 3, 4, 5];
        $scope.currentPage = 1;
        $scope.displayQuestion = false;
        $scope.answerQuestion = false;
        $scope.asnwerText = "";
        $scope.noData = false;
        $scope.imageLoad = false;
        $scope.imgUploaded = false;
        $scope.selectedImageAnswer;
        $scope.uploadedImgLink = "";
        $scope.instID;
        $scope.selectedAnswerImage = false;
        $scope.previewImage = "";
        $scope.questionPopup = false;
        $scope.selectedVideo = null;
        $scope.notAvideo = true;
        $scope.isPDF = false;
        $scope.containsLinks = false;
        $scope.fileName = "";
        $scope.isYoutube = false;
        // $scope.fromDate = "";
        // $scope.toDate = "";
        $scope.fileUploadSelected = false;
        $scope.linkUpload = false;
        $scope.showOptions = false;
        $scope.defaultDropDown = "Select Uploading Options";
        $scope.videoLink = "";
        $scope.ytID = "";
        $scope.allQuestionsCount = 0;
        $scope.answeredQuestionsCount = 0;
        $scope.unansweredQuestionsCount = 0;
        // $scope.unassignedQuestionsCount = 0;
        $scope.initialize = function () {
          var str = CustomStorageService.getUserInfoStorageData().full_name;
          $scope.instID = CustomStorageService.getUserInfoStorageData().id;
          $scope.imageInitial = str.charAt(0).toUpperCase();
          var data = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            page: 1,
            per_page: per_page,
            type: commentType,
          };
        };

        $scope.getAllQuestions = function (filter) {
          if (filter != null) {
            console.log("EMPTY");
          }
          console.log("CALL FILTERS", $scope.callFilters);
          // answered=false&&search=false
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          //&assigned=false&sort=date&order=asc

          var body = {
            page: $scope.callFilters.pageNo,
            limit: $scope.callFilters.limit,
            answered: $scope.callFilters.answered,
            sort: $scope.callFilters.sort,
            order: $scope.callFilters.order,
            search: $scope.callFilters.search,
            from_date: $scope.callFilters.from_date,
            to_date: $scope.callFilters.to_date,
          };

          $http.post("api/v1/post-question/get?", body).then(function (resp) {
            if (resp.data.success) {
              $scope.totalPageCount = resp.data.data.count;
              if($scope.callFilters.pageNo === 1) {
                $scope.allQuestionsCount = resp.data.data.overallCounts.all;
                $scope.answeredQuestionsCount =
                resp.data.data.overallCounts.answered;
                $scope.unansweredQuestionsCount =
                  resp.data.data.overallCounts.unanswered;
              }
              
                if (filter === "fromUpdate") { 
                  console.log("call");
  
                  $scope.newQuestion = true;
                }
                if ($scope.newQuestion) {
                  setTimeout(function () {
                    $scope.newQuestion = false;
                    $scope.$apply();
                  }, 2000);
                }
              if ((resp.data.data.questions || []).length > 0) {
                $scope.userQuestions = resp.data.data.questions;
                $scope.noData = false;
                $scope.showData = true;
              } else {
                $scope.userQuestions = resp.data.data.questions;
                $scope.noData = true;
                $scope.showData = true;
              }

              // $scope.$apply();
              console.log("QUESTIONS", $scope.userQuestions);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.getUnansweredCount = function () {
          $http
            .get("/api/v1/post-question/get-pending-count")
            .then(function (resp) {
              console.log("count ---", resp);
              if (resp.data.success) {
                // $scope.unansweredQuestionsCount = resp.data.pendingQuestions;
       totalUnansweredCount = resp.data.pendingQuestions;
       if (totalUnansweredCount !== $scope.unansweredQuestionsCount) {
        if ($scope.callFilters.pageNo == 1) {
          $scope.getAllQuestions("fromUpdate");
        }
      }
      console.log(
        "Received Count",
        totalUnansweredCount,
        $scope.unansweredQuestionsCount
      );
                // return resp.data.pendingQuestions;
              } else {
                // $scope.unansweredQuestionsCount = 0;
       totalUnansweredCount = 0;

                // return $scope.unansweredQuestionsCount;
              }
            });
        };
        $scope.getAllQuestions(null);

        var questionInterval = setInterval(function () {
          
          $scope.getUnansweredCount();

        }, 60000);


        if($state.current.name != "InstructorPanelStudentsQuestions"){
          clearInterval(questionInterval);
        }
        $scope.searchQuery = function () {
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          $scope.callFilters.search = $scope.searchText;
          $scope.callFilters.from_date = $scope.fromDate;
          $scope.callFilters.to_date = $scope.toDate;
          $scope.getAllQuestions();
        };

        $scope.clearFilter = function () {
          $scope.searchText = "";
          $scope.toDate = "";
          $scope.fromDate = "";
          $scope.callFilters = {
            // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
            pageNo: 1,
            limit: 10,
            assigned: null,
            answered: false,
            sort: "date",
            order: "desc",
            search: "",
            from_date: "",
            to_date: "",
          };
          $scope.getAllQuestions(null);
        };
        $scope.changeFilter = function (type) {
          $scope.showData = false;
          $scope.callFilters.pageNo = 1;
          Object.keys($scope.filterSelected).forEach(function (element) {
            if (element == type) {
              $scope.filterSelected[element] = true;
            } else {
              $scope.filterSelected[element] = false;
            }
          });
          if (type === "all") {
            $scope.callFilters.answered = null;
          } else if (type === "answered") {
            $scope.callFilters.answered = "true";
          } else {
            $scope.callFilters.answered = "false";
          }
          $scope.getAllQuestions();
        };

        $scope.sortFilter = function (sort, type) {
          // pageNo: 1,
          // limit: 10,
          // answered: null,
          // sort: "date",
          // order: "desc",
          // search : ""
          $scope.showData = false;
          if (sort === "asc") {
            $scope.callFilters.order = "asc";
          } else {
            $scope.callFilters.order = "desc";
          }
          $scope.callFilters.sort = type;
          $scope.getAllQuestions();
        };
        $scope.answerStudent = function (obj) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAnswer = obj;
          $scope.answerQuestion = true;
        };
        $scope.getNumber = function (num) {
          if (num < 5) {
            $scope.remaining = true;
            for (i = 0; i <= 5 - num; i++) {
              $scope.rem_stars.push("star");
            }
          } else {
            $scope.remaining = false;
            $scope.rem_stars = [];
          }
          return new Array(num);
        };
        $scope.imageLoadCheck = function () {
          console.log("on image load");
          $scope.imageshowloader = false;
          $scope.$apply();
        };
        $scope.viewAddManager = function () {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          document.body.style.height = "100vh";
          if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "100vh";
            document.getElementById("adminpanel").style.overflow = "hidden";
          } else if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "100vh";
            document.getElementById("adminpanel").style.overflow = "hidden";
          }
        };
        $scope.viewRemoveManager = function () {
          document.body.style.height = "auto";
          if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "auto";
            document.getElementById("adminpanel").style.overflow = "auto";
          } else if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "auto";
            document.getElementById("adminpanel").style.overflow = "auto";
          }

          // document.body.classList.remove("full-v-h");
        };
        $scope.viewQuestion = function (qId, question, image) {
          $scope.viewAddManager();
          $scope.containsLinks = false;
          console.log(question, qId, "A");
          var questionBody = {
            question_id: qId,
          };
          $http
            .post("/api/v1/post-question/intructor-view-question", questionBody)
            .then(
              function (resp) {
                console.log("q hit", resp);
                if (resp.data.success) {
                }
              },
              function (err) {
                console.log("ERROR IN HIT", err);
              }
            );
          console.log("Image Link", image);

          if (image != null) {
            if (image.includes("mp4") || image.includes("webm")) {
              $scope.notAvideo = false;
              $scope.isPDF = false;
              $scope.isYoutube = false;
              $scope.imageshowloader = false;
            } else if (
              image.includes("pdf") ||
              image.includes("docx") ||
              image.includes("docs") ||
              image.includes("txt") ||
              image.includes("xls") ||
              image.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
              $scope.isYoutube = false;
            } else if (image.includes("youtube")) {
              $scope.imageshowloader = false;
              image.replace("watch?v=", "embed/");
              var linkB = image.substring(image.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("Ext", linkB, linkB2[0]);
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }

          $scope.selectedQuestionImage = image;
          $scope.selectedAnswerImage = image;
          $scope.selectedQuestion = question;
          $scope.displayQuestion = true;
        };

        $scope.openPDF = function (link) {
          location.href = link;
        };
        $scope.openImage = function (link) {
          $scope.previewImage = true;
        };
        $scope.viewAnswer = function (question, image) {
          $scope.viewAddManager();

          $scope.containsLinks = false;
          console.log(question.answers[0], "Answer");
          $scope.answerObj = question.answers[0];
          if ($scope.answerObj.answer_media_link) {
            console.log($scope.answerObj.answer_media_link, "upaaa link");
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;

            var ext = $scope.selectedAnswerImage.substring(
              $scope.selectedAnswerImage.indexOf("v=") + 2
            );
            var ext2 = ext.split("&");
            $scope.ytID = ext2[0];
            console.log("Ext", ext, ext2[0]);

            console.log($scope.selectedAnswerImage, "up link");
          } else {
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;
          }
          $scope.selectedQuestionImage = $scope.answerObj.answer_media_link;
          if ($scope.selectedAnswerImage != null) {
            if (
              $scope.selectedAnswerImage.includes("mp4") ||
              $scope.selectedAnswerImage.includes("webm")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = false;
              $scope.isPDF = false;
            } else if ($scope.selectedAnswerImage.includes("youtube")) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else if (
              $scope.selectedAnswerImage.includes("pdf") ||
              $scope.selectedAnswerImage.includes("docx") ||
              $scope.selectedAnswerImage.includes("docs") ||
              $scope.selectedAnswerImage.includes("txt") ||
              $scope.selectedAnswerImage.includes("xls") ||
              $scope.selectedAnswerImage.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
            }
          } else {
            $scope.imageshowloader = false;
          }

          console.log($scope.selectedQuestionImage, "Image");
          console.log($scope.selectedAnswerImage, "up link");

          // $scope.selectedQuestion = $scope.answerObj.answer_text ;
          $scope.selectedQuestion = $scope.formatTextforLink(
            $scope.answerObj.answer_text
          );
          $scope.displayAnswer = true;
        };

        $scope.formatTextforLink = function (text) {
          console.log("in format text", text);
          if (!text) return text;
          var newText = text.replace(/(https?:\/\/[^\s]+)/g, function (url) {
            $scope.containsLinks = true;

            return (
              '<a target="_blank" style="margin-bottom: 5px;" href="' +
              url +
              '"' +
              ">" +
              url +
              "</a>"
            );
          });
          console.log("in formatted text", newText);

          return newText;
        };
        $scope.closeQuestion = function () {
          $scope.viewRemoveManager();

          $scope.selectedQuestionImage = null;
          $scope.videoLink = "";
          $scope.selectedAnswerImage = false;
          $scope.displayQuestion = false;
          $scope.displayAnswer = false;
          $scope.notAvideo = true;
          $scope.imageshowloader = true;
          $scope.isYoutube = false;

        };
        $scope.closeAnswerWindow = function () {
          $scope.viewRemoveManager();
          $scope.selectedQuestionImage = null;
          $scope.selectedAnswerImage = false;
          $scope.notAvideo = true;
          $scope.videoLink = "";
          $scope.selectedQuestionToAnswer = {};
          $scope.answerQuestion = false;
          $scope.imageshowloader = true;
          $scope.isYoutube = false;

        };
        $scope.pageChange = function (page) {
          $scope.showData = false;
          var temp = [];
          if (
            $scope.pageArr[0] + 4 === page &&
            $scope.pageArr[0] + 4 < $scope.totalPageCount
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row + 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (
            $scope.pageArr[4] - 4 === page &&
            $scope.pageArr[4] - 4 > 1
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row - 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (page <= $scope.totalPageCount && page >= 1) {
            if (page < $scope.currentPage && $scope.pageArr[0] - 1 > 0) {
              $scope.pageArr.forEach(function (row) {
                row = row - 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else if (
              page > $scope.currentPage &&
              $scope.pageArr[4] + 1 < $scope.totalPageCount
            ) {
              $scope.pageArr.forEach(function (row) {
                row = row + 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else {
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            }
          }

          // }
        };
        $scope.uploadImage = function (formData, userId) {
          return new Promise(function (resolve, reject) {
            fetch(
              env.backendService +
                "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
                userId,
              {
                method: "POST",
                body: formData,
              }
            )
              .then(
                function (data) {
                  return data.json();
                },
                function (err) {
                  console.log("ERROR IN UPLOADING IMG 1", err);
                  reject(new Error("ERROR IN UPLOADING IMG 1"));
                }
              )
              .then(
                function (data) {
                  resolve(data);
                },
                function (err) {
                  console.log("ERROR IN UPLOADING IMG 1", err);
                  reject(new Error("ERROR IN UPLOADING IMG 2"));
                }
              );
          });
        };
        $scope.onImageSelected = function (event) {
          $scope.imageLoad = true;
          console.log("EVENTS", event);
          $scope.imgUploaded = false;
          $scope.isYoutube = false;
          $scope.selectedImageAnswer = event.target.files[0];
          console.log($scope.selectedImageAnswer, "size");
          $scope.fileName = $scope.selectedImageAnswer.name;

          if (
            $scope.selectedImageAnswer.type.includes("mp4") ||
            $scope.selectedImageAnswer.type.includes("webm")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = false;
            $scope.isPDF = false;
          } else if (
            $scope.selectedImageAnswer.type.includes("application/pdf") ||
            $scope.selectedImageAnswer.type.includes("xls") ||
            $scope.selectedImageAnswer.type.includes("excel") ||
            $scope.selectedImageAnswer.type.includes("docs") ||
            $scope.selectedImageAnswer.type.includes("docx") ||
            $scope.selectedImageAnswer.type.includes("csv") ||
            $scope.selectedImageAnswer.type.includes("application/msword") ||
            $scope.selectedImageAnswer.type.includes(
              " application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ) ||
            $scope.selectedImageAnswer.type.includes("openxmlformats")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = true;
          } else {
            if ($scope.selectedImageAnswer.size > 4000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = false;
          }
          $scope.$apply();
          //   FormDataa()
          var fd = new FormData();
          console.log($scope.selectedImageAnswer);
          fd.append("file", $scope.selectedImageAnswer);
          $scope.uploadImage(fd, $scope.instID).then(
            function (resp) {
              console.log("up resp", resp);
              if (resp.success) {
                $scope.uploadedImgLink = resp.link;
                // $scope.userData.image = $scope.uploadedImgLink;
                // $scope.userInfo.image = $scope.uploadedImgLink;
                $scope.selectedAnswerImage = resp.link;
                $scope.imageLoad = false;
                $scope.$apply();

                $scope.selectedImageAnswer = null;
                var obj = {
                  id: $scope.userID,
                  user_image: $scope.uploadedImgLink,
                };
              }
            },
            function errorCallback(response) {
              console.log("ERROR RESP", response);
              return response;
            }
          );
        };
        $scope.youtubePreview = function (event) {
          console.log(event, "yt img link");
          setTimeout(function () {
            var ytLink = event.target.value;

            if (ytLink.includes("http://youtu.be/")) {
              ytLink.replace(
                "http://youtu.be/",
                "http://www.youtube.com/embed/"
              );
              var linkB = ytLink.substring(ytLink.indexOf(".be/") + 4);
              var linkB2 = linkB.split("?");
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            } else {
              ytLink.replace("watch?v=", "embed/");
              var linkB = ytLink.substring(ytLink.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            }
            $scope.$apply();
          }, 100);
        };
        $scope.sendAnswer = function (ansText, link) {
          console.log(
            "SELECTED QUESTION TO ANSWER",
            $scope.selectedQuestionToAnswer
          );

          var checkLink;
          if ((link || []).length > 4) {
            console.log("in link attach", link);
            if (link.includes("http://youtu.be/")) {
              checkLink = link.replace(
                "http://youtu.be/",
                "https://www.youtube.com/watch?v="
              );
              link = checkLink;
            } else if (link.includes("https://youtu.be/")) {
              checkLink = link.replace(
                "https://youtu.be/",
                "https://www.youtube.com/watch?v="
              );
              link = checkLink;
            }
            console.log("checkLink", checkLink);

            $scope.uploadedImgLink = link;
          }

          var body = {
            question_id: $scope.selectedQuestionToAnswer.id,
            answer_media_link: $scope.uploadedImgLink,
            answer_text: ansText,
          };
          $http.post("api/v1/post-question/answer", body).then(function (resp) {
            console.log("resp instructor answer", resp);
            if (resp.data.success) {
              swal(
                {
                  title: "Answered",
                  text: "Answer is successfully posted.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeAnswerWindow();
                  $scope.answerQuestion = false;
                  $scope.asnwerText = "";
                  $scope.uploadedImgLink = "";
                  $scope.selectedQuestionToAnswer = "";
                  $scope.videoLink = "";
              $scope.isYoutube = false;

                  $scope.$apply();

                  swal.close();
                  $scope.getAllQuestions();
                  // location.reload();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in answering question",
                type: "error",
              });
              return;
            }
          });
          console.log("answer", $scope.uploadedImgLink);
        };
        $scope.previewEnlargedImage = function (image, type) {
          console.log("Image", image);
          $scope.previewImage = image;
          $scope.imagePreview = true;
          if (type === "question") {
            $scope.displayQuestion = false;
            $scope.questionPopup = true;
          } else {
            $scope.displayAnswer = false;
            $scope.questionPopup = false;
          }
        };

        $scope.closePreviewImage = function (type) {
          // $scope.previewImage = "";
          $scope.imagePreview = false;
          if ($scope.questionPopup) {
            $scope.displayQuestion = true;
          } else {
            $scope.displayAnswer = true;
          }
        };
        $scope.handleOptions = function () {
          $scope.showOptions = !$scope.showOptions;
        };
        $scope.uploadLink = function (link) {
          console.log(link, "yt");

          if (link.includes("watch?v=")) {
            link.replace("watch?v=", "embed/");
            $scope.selectedImageAnswer = link;
          }
          console.log(link);

          $scope.uploadedImgLink = link;
          $scope.notAvideo = false;
          $scope.isYoutube = true;
          $scope.isPDF = false;
          // $scope.$apply();
        };
        sr.trustSrc = function (src) {
          console.log(src, "sssssssource");
          return $sce.trustAsResourceUrl(
            "https://www.youtube.com/embed/" + src
          );
        };
        $scope.selectUploadType = function (type) {
          console.log("TYPE UPLOAD", type);
          $scope.defaultDropDown = type;

          if (type === "Video Link") {
            $scope.fileUploadSelected = false;
            $scope.linkUpload = true;
          } else {
            $scope.fileUploadSelected = true;
            $scope.linkUpload = false;
          $scope.isYoutube = false;

          }
          $scope.handleOptions();
        };
        $scope.$on("closeForm", function (event, message) {});
        $scope.attachFile = function () {
          console.log("answer");
        };
      },
    ]);
})();

(function() {
'use strict';

angular
.module('NearPeer')

.controller('InstructorPanelMyProfileController', ['$scope','Upload', '$http', '$state', 'CustomStorageService', '$sails','instructorPanelService', function($scope, Upload, $http, $state, CustomStorageService, $sails,instructorPanelService) {
	$scope.showData = false;
	$(document).ready(function(){
		$(this).scrollTop(0);
	});

	$scope.initialize = function(){
		$scope.showData = true;
		$scope.userData = CustomStorageService.getUserInfoStorageData();
		if(!$scope.userData.experience){
			$scope.userData.experience = 0;
		}
	}

	$scope.saveData = function(form){
		CustomStorageService.setUserInfoStorageData(form);
		$scope.showData = false;
		$http.post('api/v1/instructors/updateInstructor',{user:form})
		.then(function(data){
			$scope.showData = true;
			if(data.data.success){
				instructorPanelService.successUpdateSwal();
			} else {
				instructorPanelService.tryAgainSwal();
			}

		})
	}

	$scope.uploadImage = function(image){
		if(image){
			$scope.imageUploadingInProcess = true;
			$scope.imageUploadLog = {progress: 0};
			Upload.upload({
				url: 'api/v1/uploader/uploadImageToS3?userId='+CustomStorageService.getUserInfoStorageData().id + '&socket_id=' + CustomStorageService.getSocketIdStorageData(),
 				method: "POST",
 				file: image
 			}).then(function(data){
 				$scope.imageUploadingInProcess = false;
 				$scope.userData.image = data.data.link;
				if(!$scope.$$phase) $scope.$apply();
 			});
		}
	};

	$scope.updateExperience = function(year){
		$scope.userData.experience = year;
	}

	$scope.addFaculty = function(form){
		if(!form.faculty || !form.institution){
			swal('Oops..','Please in all fields','error');
			return false;
		}
		form.instructor_id = CustomStorageService.getUserInfoStorageData().id;
		$scope.showData = false;
		$http.post('api/v1/instructors/addFaculty',{form:form})
		.then(function(data){
			$scope.showData = true;
			if(data.data.success){
				swal('Success','New faculty successfully added, added new courses in this faculty via dashboard.','success');
				$scope.facultyForm = {};
				location.reload();
			} else {
				swal('Oops','Faculty already exists','error');
			}
		});
	}

	$scope.years = [];

	for(var i =0;i<50;i++){
		$scope.years[i] = i+1;
	}

	$sails.on('imageUploadProgress',function(data){
		$scope.imageUploadLog.progress = data;
		if(!$scope.$$phase) $scope.$apply();
	})

	if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
		$state.go('instructor_signin',{},{reload:true});
	} else {
		$scope.initialize();
	}
}]);
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("InstructorPanelModuleController", [
    "$scope",
    "Upload",
    "$http",
    "$state",
    "CustomStorageService",
    "instructorPanelService",
    "$sails",
    function (
      $scope,
      Upload,
      $http,
      $state,
      CustomStorageService,
      instructorPanelService,
      $sails
    ) {
      $(document).ready(function () {
        $(this).scrollTop(0);
      });

      $scope.tagsSW = [];

      $scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();

      var draggable_list = document.getElementById("draggable-list");

      function createList() {
        addEventListeners();
      }

      function dragStart() {
        $scope.dragStartId = +this.closest("li").getAttribute("data-value");
        $scope.dragStartModule = +this.closest("li").getAttribute("data-index");
      }

      function dragEnter() {
        this.classList.add("over");
      }

      function dragLeave() {
        this.classList.remove("over");
      }

      function dragOver(e) {
        e.preventDefault();
      }

      function dragDrop() {
        $scope.dragEndId = +this.getAttribute("data-value");
        $scope.dragEndModule = +this.getAttribute("data-index");
        swapItems();
        this.classList.remove("over");
      }

      // Swap list items that are drag and drop
      function swapItems() {
        var start = -1;
        var end = -1;
        for (
          var count = 0;
          count < $scope.selectedModule.chapters.length;
          count++
        ) {
          if ($scope.selectedModule.chapters[count].id == $scope.dragStartId) {
            $scope.selectedModule.chapters[count].chapter_no =
              $scope.dragEndModule;
            start = count;
          }
          if ($scope.selectedModule.chapters[count].id == $scope.dragEndId) {
            $scope.selectedModule.chapters[count].chapter_no =
              $scope.dragStartModule;
            end = count;
          }
        }
        var temp = $scope.selectedModule.chapters[start];
        $scope.selectedModule.chapters[start] =
          $scope.selectedModule.chapters[end];
        $scope.selectedModule.chapters[end] = temp;
        $scope.$apply();
      }

      $scope.saveChapterOrder = function () {
        this.showData = false;
        $http
          .post("api/v1/chapters/updateChapterNo", {
            chapters: $scope.selectedModule.chapters,
          })
          .then(function (data) {
            $state.go(
              "InstructorPanelModuleEdit",
              { id: $state.params.id },
              { reload: true }
            );
            $scope.showData = true;
          });
        //   $state.go("InstructorPanelModuleEdit", {id : $state.params.id}, { reload: true });
        //   window.location.reload();
        //   $scope.showData = true;
      };

      function addEventListeners() {
        const draggables = document.querySelectorAll(".draggable");
        const dragListItems = document.querySelectorAll(".draggable-list li");
        for (var i = 0; i < draggables.length; i++) {
          draggables[i].addEventListener("dragstart", dragStart);
        }
        for (var count = 0; count < dragListItems.length; count++) {
          dragListItems[count].addEventListener("dragover", dragOver);
          dragListItems[count].addEventListener("drop", dragDrop);
          dragListItems[count].addEventListener("dragenter", dragEnter);
          dragListItems[count].addEventListener("dragleave", dragLeave);
        }
      }

      $scope.initialize = function () {
        if ($state.current.name == "InstructorPanelModuleNew") {
          if (!instructorPanelService.getCourseId()) {
            $state.go("InstructorPanelDashboard", {}, { reload: true });
          }
          $scope.selectedModule = {
            name: "",
            description: "",
            short_description: "",
            module_type: {
              free: false,
              paid: false,
            },
          };
        } else if ($state.current.name == "InstructorPanelModuleEdit") {
          $scope.showData = false;
          $scope.editingModule = true;
          var id = $state.params.id;
          $http({
            url: "api/v1/cmodules/getModuleById",
            method: "GET",
            params: {
              id: id,
              instructor_id: CustomStorageService.getUserInfoStorageData().id,
            },
          }).then(function (data) {
            $scope.showData = true;
            if (data.data.success) {
              $scope.index_url = data.data.index_url;
              $scope.selectedModule = data.data.module;
              $scope.selectedModule.chapters = data.data.chapters;
              $scope.selectedModule.attachments = data.data.attachments;
              setTimeout(createList, 200);

              var swTags = [];
              if($scope.selectedModule.sw_tags) {
                $scope.selectedModule.sw_tags.forEach(function(tag) {
                  swTags.push({text: tag.name});
                });
                $scope.tagsSW = swTags;
              }

            } else {
              $state.go("InstructorPanelDashboard", {}, { reload: true });
            }
          });
        }
      };

      $scope.uploadImage = function (image) {
        if (image) {
          $scope.imageUploadingInProcess = true;
          $scope.imageUploadLog = { progress: 0 };
          Upload.upload({
            url:
              "api/v1/uploader/uploadImageToS3?userId=" +
              CustomStorageService.getUserInfoStorageData().id +
              "&socket_id=" +
              CustomStorageService.getSocketIdStorageData(),
            method: "POST",
            file: image,
          }).then(function (data) {
            $scope.imageUploadingInProcess = false;
            $scope.selectedModule.image_url = data.data.link;
          });
        }
      };

      $scope.saveData = function (form) {
        var swtags = [];
        $scope.tagsSW.forEach(function(tag) {
          swtags.push(tag.text);
        })
        form["swTags"] = swtags;

        if (!$scope.editingModule) {
          if (!form.image_url) {
            form.image_url =
              "https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png";
          }
          if (!form.module_type.paid) {
            form.module_type.free = true;
            form.module_type.paid = false;
          } else {
            form.module_type.free = false;
          }

          if (!validateModuleForm(form)) {
            return false;
          }

          $scope.showData = false;
          var data = { module: form, id: instructorPanelService.getCourseId() };
          $http.post("api/v1/cmodules/newModule", data).then(function (data) {
            $scope.showData = true;
            if (data.data.success) {
              swal("Success", "Module created successfully", "success");
              $state.go(
                "InstructorPanelCourseEdit",
                { id: instructorPanelService.getCourseId() },
                { reload: true }
              );
            } else {
              instructorPanelService.tryAgainSwal();
            }
          });
        } else {
          if (!form.image_url) {
            form.image_url =
              "https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png";
          }
          if (!form.module_type.paid) {
            form.module_type.free = true;
            form.module_type.paid = false;
          } else {
            form.module_type.free = false;
          }

          if (!validateModuleForm(form)) {
            return false;
          }
          var chapters = form.chapters;
          for (var i in chapters) {
            chapters[i].chapter_no = i;
          }
          $http
            .post("api/v1/chapters/updateChapterNo", { chapters: chapters })
            .then(function (data) {});
          $scope.showData = false;
          var data = { module: form, id: form.id };
          $http
            .post("api/v1/cmodules/updateModule", data)
            .then(function (data) {
              $scope.showData = true;
              if (data.data.success) {
                instructorPanelService.successUpdateSwal();
              } else {
                instructorPanelService.tryAgainSwal();
              }
            });
        }
      };

      var validateModuleForm = function (form) {
        if (
          !form.name ||
          !form.description ||
          !form.short_description ||
          !form.image_url
        ) {
          swal("Oops..", "Please fill in all fields", "error");
          return false;
        }
        if (form.module_type.paid && !form.module_type.price) {
          swal("Oops..", "Please add module price", "error");
          return false;
        }
        return true;
      };

	  $scope.goToChapterVideoPage = function(id){
		$state.go('InstructorPanelVideo',{state:'chapter',id:id,module_id:$scope.selectedModule.id},{reload:true});
	}

      $scope.chapterPopupText = "Add";
      $scope.showPopup = false;
      $scope.goToEditChapterPopUp = function (title, chapter) {
        if(title == 'edit')
        {
          $scope.chapterPopupText = "Edit";
          $scope.selectedChapter = chapter;
          $scope.chapterEditing = true;
        }
        else 
        $scope.chapterPopupText = "Add";
        $scope.showPopup = true;
        // $state.go('InstructorPanelChapterEdit',{id:id,module_id:$scope.selectedModule.id},{reload:true});
      };
      $scope.closeChapterPopup = function () {
        $scope.showPopup = false;
      };
      $scope.deleteChapter = function (id, index) {
        var data = { chapter: id };
        swal(
          {
            title: "Warning",
            text: "Are you sure you want to delete this chapter?",
            type: "warning",
            showCancelButton: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.showData = false;
              $http
                .post("api/v1/chapter/deleteChapter", data)
                .then(function (data) {
                  $scope.showData = true;
                  if (data.data.success) {
                    instructorPanelService.successDeleteSwal();
                    $scope.selectedModule.chapters.splice(index, 1);
                  } else {
                    instructorPanelService.tryAgainSwal();
                  }
                });
            }
          }
        );
      };

      $scope.goToVideoPage = function () {
        $state.go(
          "InstructorPanelVideo",
          {
            state: "module",
            id: $scope.selectedModule.id,
            module_id: $scope.selectedModule.id,
          },
          { reload: true }
        );
      };

      $scope.previewPage = function () {
        var data = $scope.index_url.split("/");
        var url = $state.href("course_module", {
          institutionName: data[0],
          schoolName: data[1],
          courseName: data[2],
          moduleNo: $scope.selectedModule.module_no,
        });
        window.open(url, "_blank");
      };


      $scope.deleteAttachement = function(attachment,index){
        $scope.showData = false;
        $http.post('api/v1/attachments/deleteAttachment',{id: attachment.id})
        .then(function(data){
          if(data.data.success){
            $scope.showData = true;
            $scope.selectedModule.attachments.splice(index,1);
          }
        });
      }
    
      $scope.downloadAttachment = function(url){
        var win = window.open(url, '_blank');
      }
    
      $scope.editAttachement = function(attachment){
        $scope.notesData.name = attachment.name;
        $scope.notesData = {
          name: attachment.name,
          fileLink: attachment.url,
          isSecure: attachment.is_secure,
        };
        selectedAttachment = attachment;
        $scope.showNotesPopup();
      }
    
      var selectedAttachment;
      var notesFile;
      $scope.notesData = {
        name: '',
        fileLink: '',
        isSecure: false,
      }
      $scope.notesUploadStatus;
    
      $scope.showNotesPopup = function () {
        $("#notes-popup").modal('show');
      }
    
      $scope.closeNotesPopup = function () {
        $("#notes-popup").modal('hide');
        selectedAttachment = false;
        notesFile = '';
        $scope.notesData = {
          name: '',
          fileLink: '',
          isSecure: false,
        };
        $scope.notesUploadStatus = '';
      }
    
      $scope.uploadVideoAttachments = function(file,video){
        notesFile = file;
        if(file){
          $scope.notesUploadStatus = 'uploading';
          Upload.upload({
            url: '/api/v1/uploader/uploadVideoAttachmentToS3?&module_id='+$scope.selectedModule.id+'&userId='+instructorPanelService.getInstructorId()+'&no='+$scope.counter+'&socket_id='+CustomStorageService.getUserInfoStorageData().id,
            method: "POST",
            file: file
          }).then(function(data){
            $scope.notesData.fileLink = data.data.link;
            $scope.notesUploadStatus = 'uploaded';
            $scope.$apply();
          });
        }
      }
    
      $scope.saveNotes = function() {
        if(!$scope.notesData.fileLink || !$scope.notesData.name) {
          swal("Error", "All Fields are required", "error");
        } else {
          if(selectedAttachment) {
            $scope.updateNotes();
          } else {
            var data = {
              name: $scope.notesData.name,
              url: $scope.notesData.fileLink,
              is_secure: $scope.notesData.isSecure,
              module_id: $scope.selectedModule.id,
            }
            
            $http.post('api/v1/attachments/createAttachment',data)
            .then(function(data){
              if(data.data.success){
                swal("Success", "Video Attachment uploaded successfully", "success");
              } else {
              }
            });
            $scope.selectedModule.attachments.push(data);
            $scope.closeNotesPopup();
          }
        }
      }
    
      $scope.updateNotes = function() {
        var data = {
          name: $scope.notesData.name,
          url: $scope.notesData.fileLink,
          is_secure: $scope.notesData.isSecure,
          attachment_id: selectedAttachment.id
        }
        $http.post('api/v1/attachments/updateAttachment',data)
        .then(function(data){
          if(data.data.success){
            swal("Success", "Video Attachment uploaded successfully", "success");
          } else {
          }
        });
    
        selectedAttachment.name = data.name;
        selectedAttachment.url = data.url;
        selectedAttachment.is_secure = data.is_secure;
        $scope.closeNotesPopup();
      }
      

      $sails.on("imageUploadProgress", function (data) {
        $scope.imageUploadLog.progress = data;
        if (!$scope.$$phase) $scope.$apply();
      });
      $scope.saveChapterData = function (form) {
        if (!form.name) {
          swal("Oops..", "Please add chapter name", "error");
          return false;
        }

        if (!$scope.chapterEditing) {
          $scope.showData = false;
          var data = {
            chapter: form,
            id: $scope.selectedModule.id,
          };
          $http
            .post("api/v1/chapter/createChapter", data)
            .then(function (data) {
              $scope.showData = true;
              if (data.data.success) {
                swal("Success", "Chapter created successfully", "success");
				$state.go('InstructorPanelModuleEdit',{id:$scope.selectedModule.id},{reload:true});
              } else {
                instructorPanelService.tryAgainSwal();
              }
            });
        } else {
          $scope.showData = false;
          var data = { chapter: form };
          $http
            .post("api/v1/chapter/updateChapter", data)
            .then(function (data) {
              $scope.showData = true;
              if (data.data.success) {
                instructorPanelService.successUpdateSwal();
				$state.go('InstructorPanelModuleEdit',{id:$scope.selectedModule.id},{reload:true});
              } else {
                instructorPanelService.tryAgainSwal();
              }
            });
        }
		$scope.showPopup = false;
      };

      if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("instructor_signin", {}, { reload: true });
      } else {
        $scope.initialize();
      }
    },
  ]);
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("InstructorPanelLiveSessionController", [
      "$scope",
      "toaster",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "instructorPanelService",
      "$sails",
      "env",
      "$sce",
      function (
        $scope,
        toaster,
        Upload,
        $http,
        $state,
        CustomStorageService,
        instructorPanelService,
        $sails,
        env,
        $sce
      ) {

        $scope.page = 1;
        $scope.isLoading = false;
        $scope.isArchived = false;
        $scope.live_sessions = [];
        $scope.show_live_sessions = [];
        $scope.search_query = "";
        $scope.total_clicks = 0;
      $scope.total_sessions = 0;
      $scope.conducted_sessions = 0;
      $scope.sessions_events = 0;
      $scope.interested_users = 0;
      $scope.watch_time = {
          instructor_watch_time: 0,
          users_watch_time: 0
      };


          $scope.countEventsByType = function (stats, event_type) {
              // Check if the 'stats' array is defined and not null
              if (angular.isArray(stats)) {
                  // Use the filter method to create an array with only elements that match the 'event_type'
                  var filteredEvents = stats.filter(function(event) {
                      return event.event_type === event_type;
                  });

                  // Return the length of the filtered array
                  return filteredEvents.length;
              } else {
                  // Return 0 if the 'stats' array is undefined or null
                  return 0;
              }
          }

          $scope.countInterestedUsers = function (interested_users, is_interested) {
              // Check if the 'stats' array is defined and not null
              if (angular.isArray(interested_users)) {
                  // Use the filter method to create an array with only elements that match the 'event_type'
                  var filteredEvents = interested_users.filter(function(interested_user) {
                      return interested_user.is_interested === is_interested;
                  });

                  // Return the length of the filtered array
                  return filteredEvents.length;
              } else {
                  // Return 0 if the 'stats' array is undefined or null
                  return 0;
              }
          }

          // $scope.calculateTotalClicks = function() {
          //     $scope.total_clicks = 0;
          //     $scope.live_sessions.forEach(function(session) {
          //         var len = $scope.countEventsByType(session.stats, 'VIEW')
          //         $scope.total_clicks += len;
          //     });
          // };

        function init() {
            var search = '';
            if($scope.search_query) {
                search = "&search=" + $scope.search_query;
            }
          $http({
             url: "api/v1/live-session/get?limit=20&page=1" + search,
             method: "GET",
             params: {},
          }).then(function (data) {
             if (data.data.success) {
                $scope.live_sessions = data.data.sessions;
                $scope.show_live_sessions = $scope.live_sessions;
                // $scope.calculateTotalClicks();
             }
          });

          $http({
             url: "api/v1/live-session/get-stats?event_type=ADD_TO_CALENDER,VIEW,JOINED",
             method: "GET",
             params: {},
          }).then(function (data) {
             if (data.data.success) {
                $scope.total_sessions = data.data.total_sessions;
                $scope.conducted_sessions = data.data.conducted_sessions;
                $scope.sessions_events = data.data.sessions_events;
                $scope.interested_users = data.data.interested_users;
                $scope.watch_time = data.data.watch_time;
                // $scope.calculateTotalClicks();
             }
          });
        }


          $scope.filterEndedSessions = function() {
              return $scope.live_sessions.filter(function(session) {
                  return session.status === 'ENDED';
              });
          };

          $scope.showArchived = function() {
                $scope.isArchived = !$scope.isArchived
              if($scope.isArchived){
                  $scope.show_live_sessions = $scope.live_sessions.filter(function(session) {
                      return session.status === 'DRAFT';
                  });
              }else{
                $scope.show_live_sessions = $scope.live_sessions
              }
          };

        $scope.search = function () {
            init();
        }

        $scope.copyLink = function (live_session){
            // Create a temporary element to hold the modified text
            var tempElement = document.createElement('textarea');
            tempElement.value = env.velocityPortal+"/live-session/"+live_session.id;

            // Append the temporary element to the DOM
            document.body.appendChild(tempElement);

            // Select and copy the modified text
            tempElement.select();
            document.execCommand('copy');

            // Remove the temporary element
            tempElement.remove();
            // document.body.removeChild(tempElement);

            toaster.success({
                title: "Link copied successfully",
            });
        }

        $scope.generateJoinLink = function (live_session){
            if(live_session.url_type == 'NEARPEER')
                window.location.href = env.velocityPortal+"/live-chat/instructor/"+live_session.id+"/"+encodeURIComponent(
                    JSON.stringify(
                        { uid: live_session.instructor_id.id, full_name: live_session.instructor_id.full_name, image: live_session.instructor_id.image, session_id: live_session.id }
                    )
                );
            else {
                $scope.isLoading = true;
                $http.get("api/v1/live-session/start/"+ live_session.id)
                .then(function (data) {
                    if (data.data.success) {
                        $scope.isLoading = false;
                        window.location.href = live_session.url;
                    }
                    else {
                        $scope.isLoading = false;
                        swal('Failed',data.data.message,'error');
                    }
                })
                .catch(function (error) {
                    $scope.isLoading = false;
                    swal('Failed','Try Again','error');
                });
            }
        }

        $scope.endLiveSession = function (live_session){
            $scope.isLoading = true;
            $http.get("api/v1/live-session/end/"+ live_session.id)
            .then(function (data) {
                if (data.data.success) {
                    $scope.isLoading = false;
                    init();
                    swal('Ended','Live Session Ended successfully','success');
                }
                else {
                    $scope.isLoading = false;
                    swal('Failed',data.data.message,'error');
                }
            })
            .catch(function (error) {
                $scope.isLoading = false;
                swal('Failed','Try Again','error');
            });
        }

        $scope.getDateTime = function (time){
            // var userTimezoneOffset = new Date().getTimezoneOffset();
            var userLocalDate = new Date(time)
            // userLocalDate.setMinutes(userLocalDate.getMinutes() - userTimezoneOffset);
            return userLocalDate;
            // return moment.tz(time, 'Asia/Karachi');
        }

          $scope.pagination = function (){
            $scope.isLoading = true;
              if( $scope.page == -1) {
                  $scope.isLoading = false;
                  return;
              }
              var search_pagination = '';
              if($scope.search_query) {
                  search_pagination = "&search=" + $scope.search_query;
              }
              $http({
                  url: "api/v1/live-session/get?limit=20&page="+$scope.page + search_pagination,
                  method: "GET",
                  params: {},
              }).then(function (data) {
                  if (data.data.success) {
                      if(data.data.sessions.length < 20) $scope.page = -1;
                      else $scope.page++;
                      $scope.live_sessions = $scope.live_sessions.concat(data.data.sessions);
                      $scope.show_live_sessions = $scope.live_sessions;
                      // $scope.calculateTotalClicks();
                      $scope.isLoading = false;
                  }
              });
          }

          init();
      },
    ]);
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("InstructorPanelCourseController", [
      "$scope",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "instructorPanelService",
      "$sails",
      "FeatureService",
      "UploadService",
      "$filter",
      "HttpService",
      "env",
      function (
        $scope,
        Upload,
        $http,
        $state,
        CustomStorageService,
        instructorPanelService,
        $sails,
        FeatureService,
        UploadService,
        $filter,
        HttpService,
        env
      ) {
        $(document).ready(function () {
          $(this).scrollTop(0);
        });
		$scope.modulesList ={};
    $scope.tagsSW = [];
        var draggable_list = document.getElementById("draggable-list");

        function createList() {
          addEventListeners();
        }

        function dragStart() {
          $scope.dragStartId = +this.closest("li").getAttribute("data-value");
          $scope.dragStartModule =
            +this.closest("li").getAttribute("data-index");
        }

        function dragEnter() {
          this.classList.add("over");
        }

        function dragLeave() {
          this.classList.remove("over");
        }

        function dragOver(e) {
          e.preventDefault();
        }

        function dragDrop() {
          $scope.dragEndId = +this.getAttribute("data-value");
          $scope.dragEndModule = +this.getAttribute("data-index");
          swapItems();
          this.classList.remove("over");
        }

        // Swap list items that are drag and drop
        function swapItems() {
          var start = -1;
			    var end = -1;
          for (var count = 0; count < $scope.modulesList.length; count++) {
            if ($scope.modulesList[count].id == $scope.dragStartId) {
              $scope.modulesList[count].module_no = $scope.dragEndModule;
              start = count;
            }
            if ($scope.modulesList[count].id == $scope.dragEndId) {
              $scope.modulesList[count].module_no = $scope.dragStartModule;
              end = count;
            }
          }
          var temp = $scope.modulesList[start];
		      $scope.modulesList[start] = $scope.modulesList[end];
		      $scope.modulesList[end] = temp; 
		  $scope.$apply();
        }

        $scope.saveModuleOrder = function () {
          this.showData = false;
          for (var count = 0; count < $scope.modulesList.length; count++) {
            var data = {
              module: $scope.modulesList[count],
              id: $scope.modulesList[count].id,
            };
            $http
              .post("api/v1/cmodules/updateModule", data)
              .then(function (data) {
                if (data.data.success) {
                  instructorPanelService.successUpdateSwal();
                  $state.go("InstructorPanelCourseEdit", {}, { reload: true });
                } else {
                  instructorPanelService.tryAgainSwal();
                }
              });
          }
          $scope.showData = true;
          $state.go("InstructorPanelCourseEdit", {}, { reload: true });
        };

        function addEventListeners() {
          const draggables = document.querySelectorAll(".draggable");
          const dragListItems = document.querySelectorAll(".draggable-list li");
          for (var i = 0; i < draggables.length; i++) {
            draggables[i].addEventListener("dragstart", dragStart);
          }
          for (var count = 0; count < dragListItems.length; count++) {
            dragListItems[count].addEventListener("dragover", dragOver);
            dragListItems[count].addEventListener("drop", dragDrop);
            dragListItems[count].addEventListener("dragenter", dragEnter);
            dragListItems[count].addEventListener("dragleave", dragLeave);
          }
        }

        $scope.invalidName = [
          {
            message: "Name should be alphanumeric ",
            flag: false,
          },
          {
            message: "Name already exist ",
            flag: false,
          },
        ];
        $scope.courseTags = [];
        $scope.isCA = false;
        $scope.signedIn =
          CustomStorageService.getInstructorSignedInStorageData();
        $scope.prepareCourseIncludes = function() {
            var cd = $scope.selectedCourse.course_data || {};
            $scope.includeFields = [];

            // Only include these fields
            var allowedFields = [
                "Live_session_count",
                "videos_count",
                "full_quiz_count",
                "daq_quiz_count",
                "notes_count"
            ];

            Object.keys(cd).forEach(function(key) {
                if (allowedFields.indexOf(key) === -1) return;

                // Build the flag name
                var flagName = "show_" + key;

                // default true if not present
                if (cd[flagName] === undefined) {
                    cd[flagName] = true;
                }

                // Convert key to label with each word capitalized
                var label = key.replace(/_/g, " ").replace("count", "").trim();
                label = label.split(" ").map(function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }).join(" ");

                // Push to the dynamic array (for ng-repeat)
                $scope.includeFields.push({
                    key: key,
                    label: label,
                    flag: flagName
                });
            });
        };
        $scope.initialize = function () {
          $scope.appendingStringVideos = [];
          FeatureService.getFeature({ instructor: true })
            .then(function (result) {
              $scope.features = result;
            })
            .catch(function (error) {});

          $http({
            url: "api/v1/coursetag/get",
            method: "GET",
            params: {},
          }).then(function (data) {
            if (data.data.success) {
              $scope.courseTags = data.data.courseTags;
            }
          });
          if ($state.current.name == "InstructorPanelCourseNew") {
            $scope.selectedCourse = { courseFeature: [] };
          } else if ($state.current.name == "InstructorPanelCourseEdit") {
            $scope.showData = false;
            $scope.currentDate = new Date();
            $scope.editingCourse = true;
            var id = $state.params.id;
            $http({
              url: "api/v1/courses/getCourseById",
              method: "GET",
              params: {
                id: id,
                instructor_id: instructorPanelService.getInstructorId(),
              },
            }).then(function (data) {
              if (data.data.success) {


                $scope.selectedCourse = data.data.course;

                $scope.prepareCourseIncludes();
                
                var swTags = []
                if($scope.selectedCourse.what_will_learn && $scope.selectedCourse.what_will_learn.length > 0) {
                  $scope.selectedCourse.what_will_learn = $scope.selectedCourse.what_will_learn.join('\n');
                } else {
                  $scope.selectedCourse.what_will_learn = '';
                }
                if($scope.selectedCourse.sw_tags) {
                  $scope.selectedCourse.sw_tags.forEach(function(tag) {
                    swTags.push({text: tag.name});
                  });
                  $scope.tagsSW = swTags;
                }
                if(!$scope.selectedCourse.metatags) {
                  $scope.selectedCourse.metatags = [];
                }
                $scope.VVSStatus = data.data.VVSStatus;
                $scope.modulesList = $scope.selectedCourse.modules;
                $scope.modulesList.sort(function(a, b) {
                  return a.module_no - b.module_no;
                });
                console.log("mod",$scope.modulesList);
                setTimeout(createList, 200);
                if ($scope.selectedCourse.discountTo) {
                  $scope.selectedCourse.discountTo = new Date(
                    $scope.selectedCourse.discountTo
                  ).toLocaleString();
                }
                if ($scope.selectedCourse.discountFrom) {
                  $scope.selectedCourse.discountFrom = new Date(
                    $scope.selectedCourse.discountFrom
                  ).toLocaleString();
                }
                if (!$scope.selectedCourse.courseFeature) {
                  $scope.selectedCourse.courseFeature = [];
                }
                if ($scope.selectedCourse.terms.length > 0) {
                  for (var i in $scope.selectedCourse.terms) {
                    $scope.selectedCourse.terms[i].sdate = new Date(
                      $scope.selectedCourse.terms[i].sdate
                    );
                    $scope.selectedCourse.terms[i].edate = new Date(
                      $scope.selectedCourse.terms[i].edate
                    );
                  }
                }
                getSelectedTag();
                $scope.showData = true;
                $scope.checkUploadStatus(false);
              } else {
                $state.go("InstructorPanelDashboard", {}, { reload: true });
              }
            });
          }
        };
        
        $scope.deleteMetatag = function(index){
          $scope.selectedCourse.metatags.splice(index, 1);
        }
  
        $scope.addMetaTagToBlog = function () {
          if (!$scope.metatagContent || !$scope.metatagProperty) {
            return alert("please add valid metatag property and content");
          }
          $scope.selectedCourse.metatags.push({
            property: $scope.metatagProperty,
            content: $scope.metatagContent,
          });
          $scope.metatagContent = '';
          $scope.metatagProperty = '';
          return true;
        };

        function getSelectedTag() {
          if (
            $scope.selectedCourse &&
            $scope.courseTags &&
            $scope.courseTags.length > 0
          ) {
            $scope.courseTags.forEach(function (tag) {
              if (tag.id == $scope.selectedCourse.tag_id) {
                $scope.selectCourseTag(tag);
              }
            });
          } else {
            getSelectedTag();
          }
        }

        $scope.selectCourseTag = function (tag) {
          $scope.selectedCourse.tag_id = tag.id;
          $scope.selectedCourse.tag_name = tag.name;
          if (tag.name === "CA" || tag.name === "CA_ALL") {
            $scope.isCA = true;
          } else {
            $scope.isCA = false;
          }
        };
        $scope.instructorCourseTag = function (tag) {
          $scope.selectedCourse.course_tag = tag;
        };
        $scope.instructorCourseType = function (type) {
          $scope.selectedCourse.course_type = type;
        };
        $scope.convertVideoVimeo = function () {
          var id = $scope.selectedCourse.id;
          swal(
            {
              title: "Are you sure to convert all video to VVS?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, submit it!",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                $http
                  .post(
                    env.videoMigrationMicroServicePath +
                      env.gatewayServerPath +
                      "videos/migrate-to-vimeo",
                    { course_id: id }
                  )
                  .then(function (data) {
                    if (data.data.success) {
                      $scope.selectedCourse.is_converted_to_vvs = "in_progress";
                    }
                    swal(
                      {
                        title: data.data.message,
                        type: "success",
                      },
                      function () {}
                    );
                  });
              }
            }
          );
        };
        $scope.checkUploadStatus = function (isModal) {
          var id = $scope.selectedCourse.id;
          $http
            .post(
              env.videoMigrationMicroServicePath +
                env.gatewayServerPath +
                "videos/check-upload-status",
              { course_id: id }
            )
            .then(function (data) {
              if (data && data.data && data.data.totalVideos) {
                if (data.data.isCompleted) {
                  $scope.selectedCourse.is_converted_to_vvs = "completed";
                }
                $scope.videosUploadStatus = data.data;
                $scope.videosStatusPopup = isModal;
              }
            });
        };
        $scope.restartUpload = function () {
          var id = $scope.selectedCourse.id;
          swal(
            {
              title: "Are you sure to restart converting videos to VVS?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, submit it!",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                $http
                  .post(
                    env.videoMigrationMicroServicePath +
                      env.gatewayServerPath +
                      "videos/check-upload-status-and-reupload",
                    { course_id: id }
                  )
                  .then(function (data) {
                    if (data.data.success) {
                      $scope.selectedCourse.is_converted_to_vvs = "in_progress";
                    }
                    swal(
                      {
                        title: data.data.message,
                        type: "success",
                      },
                      function () {}
                    );
                  });
              }
            }
          );
        };
        $scope.closePopup = function () {
          $scope.videosStatusPopup = false;
        };
        $scope.saveData = function (form) {
          var swtags = [];
          $scope.tagsSW.forEach(function(tag) {
            swtags.push(tag.text);
          })
          form["swTags"] = swtags;
          form.institution = instructorPanelService.getSelectedInstitution();
          form.faculty = instructorPanelService.getSelectedFaculty();
          form.index_url = createIndexUrl(form);
          $scope.validateName(form.name);
          if ($scope.invalidName[0].flag || $scope.invalidName[1].flag) {
            // return false;
          }
          if (!form.tag_id) {
            swal("Error", "Please select course tag", "error");
            return false;
          }
          if (!$scope.editingCourse) {
            if (
              form.institution == "Chartered Accountancy Final" ||
              form.institution == "chartered accountancy final"
            ) {
              form.special = true;
            } else {
              form.special = false;
            }
            if (!form.recurring) {
              form.recurring = false;
            }
            if (!form.image_url) {
              form.image_url =
                "https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png";
            }

            if (!validateCourseForm(form)) {
              return false;
            }
            if (form.discount_price) {
              console.log("discount");
              if (!form.discountTo) {
                return false;
              }
              if (!form.discountFrom) {
                return false;
              }
              if (
                !instructorPanelService.compareDates(
                  form.discountFrom,
                  form.discountTo
                )
              ) {
                console.log("hi, date format incorrect!!!!!");
                return false;
              }
            }
            $scope.showData = false;
            form["instructor_id"] =
              CustomStorageService.getUserInfoStorageData().id;
            $http
              .post("api/v1/courses/createCourse", {
                course: form,
                instructor_id: CustomStorageService.getUserInfoStorageData().id,
              })
              .then(function (data) {
                $scope.showData = true;
                if (data.data.success) {
                  swal({
                    title: "Success",
                    text: "Course Successfully Created",
                    type: "success",
                  });
                  $state.go("InstructorPanelAllCourses", {}, { reload: true });
                } else {
                  instructorPanelService.tryAgainSwal();
                }
              });
          } else {
            if (!validateTerms(form.terms)) {
              return false;
            }

            if (!validateCourseForm(form)) {
              return false;
            }

            if (
              form.institution == "Chartered Accountancy Final" ||
              form.institution == "chartered accountancy final"
            ) {
              form.special = true;
            } else {
              form.special = false;
            }
            if (form.discount_price) {
              if (!form.discountTo) {
                return false;
              }
              if (!form.discountFrom) {
                return false;
              }

              if (
                !instructorPanelService.compareDates(
                  form.discountFrom,
                  form.discountTo
                )
              ) {
                return false;
              }
            }

            $scope.showData = false;
            var data = { course: form };
            $http
              .post("api/v1/courses/updateCourse", data)
              .then(function (data) {
                $scope.showData = true;
                if (data.data.success) {
                  instructorPanelService.successUpdateSwal();
                  $state.go("InstructorPanelAllCourses", {}, { reload: true });
                } else {
                  instructorPanelService.tryAgainSwal();
                }
              });
          }
        };
        $scope.validateName = function (name) {
          var pattern = /^[a-zA-Z0-9()\s]+$/;
          HttpService.getRequest("api/v1/courses/search", {
            key: name,
            contains: false,
          }).then(function (res) {
            if (res.courses.length === 0) {
              $scope.invalidName[1].flag = false;
            } else if ($scope.editingCourse && res.courses.length === 1) {
              $scope.invalidName[1].flag = false;
            } else {
              $scope.invalidName[1].flag = true;
            }
          });
          if (name.match(pattern)) {
            $scope.invalidName[0].flag = false;
          } else {
            $scope.invalidName[0].flag = true;
          }
        };
        $scope.uploadImage = function (image) {
          if (image) {
            $scope.imageUploadingInProcess = true;
            $scope.imageUploadLog = { progress: 0 };
            UploadService.uploadImage(image).then(function (data) {
              $scope.imageUploadingInProcess = false;
              $scope.selectedCourse.image_url = data;
              if (!$scope.$$phase) $scope.$apply();
            });
          }
        };
        var validateCourseForm = function (form) {
          if (
            !form.name ||
            !form.description ||
            !form.institution ||
            !form.index_url ||
            !form.faculty ||
            !form.image_url
          ) {
            swal("Error", "Please fill in all fields", "error");
            return false;
          }
          if (form.paid) {
            if (form.price == null) {
              swal("Error", "Please enter valid price", "error");
              return false;
            } else if (form.price < -1) {
              swal("Error", "Please enter valid price", "error");
              return false;
            }
          }
          return true;
        };

        var validateTerms = function (terms) {
          if (terms.length > 0) {
            for (var i in terms) {
              if (!terms[i].term || !terms[i].sdate || !terms[i].edate) {
                swal("Oops..", "Please fill in all term fields", "error");
                return false;
              }
              if (
                !instructorPanelService.compareDates(
                  terms[i].sdate,
                  terms[i].edate
                )
              ) {
                return false;
              }
            }
          }
          return true;
        };

        var createIndexUrl = function (form) {
          var coursee = form.name.toLowerCase();
          var institution = form.institution.toLowerCase();
          institution = institution.split(" ").join("-");
          var faculty = form.faculty.toLowerCase();
          faculty = faculty.split(" ").join("-");
          coursee = coursee.split(/[^a-zA-Z0-9]/g).join("-");
          coursee = coursee.split(/[\-]+/g).join("-");
          coursee = coursee.split(/^-|-$/).join("");
          return institution + "/" + faculty + "/" + coursee;
        };
        $scope.delFeature = function (index) {
          // $scope.selectedCourse.courseFeature.splice(index, 1);

          if (
            $scope.selectedCourse.courseFeature[index].id &&
            $scope.selectedCourse.courseFeature[index].featureId
          ) {
            $scope.selectedCourse.courseFeature[index].disabled = true;
          } else {
            $scope.selectedCourse.courseFeature.splice(index, 1);
          }
        };
        var videoNameExpression = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]+\.mp4$/;
        var videoNameExpression2 = /^[a-zA-Z0-9\s!@#$%^&*()-+_=:.,<>"';]$/;
        $scope.uploadVideos = function (files) {
          if (files) {
            if (
              files[0].type === "video/mp4" ||
              files[0].file.type === "video/mp4"
            ) {
            } else {
              swal("Oops..", "Please upload video in .mp4", "error");
              return false;
            }
            if (
              files[0].name.match(videoNameExpression) ||
              files[0].name.match(videoNameExpression2)
            ) {
            } else {
              swal("Oops..", "Please upload video in aplha numeric", "error");
              return false;
            }
            $scope.uploadVideo(files[0], 1);
          }
        };
        $scope.uploadVideo = function (file, no) {
          var date = new Date();
          date = $filter("date")(date, "MM-dd-yyyy-h:mma");
          var appendingString = file.size + "-" + date;
          // $scope.appendingStringVideos.push(appendingString);
          if (file) {
            var data = {
              userId: instructorPanelService.getInstructorId(),
              count: no,
              file: file.name,
              course_id: $state.params.id || 123,
              socket_id: CustomStorageService.getSocketIdStorageData(),
              appendingString: appendingString,
            };
            Upload.upload({
              url: "/api/v1/uploader/mp4",
              method: "POST",
              file: file,
              params: data,
            }).then(
              function (data) {
                if (data.data.file_name) {
                  $scope.selectedCourse.videoUrl =
                    "https://demo-courses.s3.amazonaws.com/" +
                    data.data.file_name;
                } else {
                  swal(
                    {
                      title: "Error",
                      text: "Server Error!!",
                      type: "error",
                      showCancelButton: false,
                      showConfirmButton: true,
                    },
                    function () {}
                  );
                }
              },
              function (error) {}
            );
          }
        };
        $scope.addFeature = function (features) {
          if (features) {
            if ($scope.selectedCourse.courseFeature.length < 7) {
              if (
                $scope.selectedCourse.courseFeature.indexOf(features) === -1
              ) {
                $scope.selectedCourse.courseFeature.push(features);
              } else {
                $scope.featureMessage = "you can’t add duplicate";
              }
            } else {
              $scope.featureMessage = "You can’t add more than 7 icons";
            }
          }
        };
        // You can’t add more than 7 icons

        $scope.addNewTerm = function () {
          var obj = {
            term: "",
            sdate: new Date(),
            edate: new Date(),
          };
          $scope.selectedCourse.terms.push(obj);
        };
        $scope.ipEditPopupClose = function () {
          $scope.ipModulePopup = false;
        };
        $scope.ipModulePopup = false;
        $scope.newEditText = "";
        $scope.goToNewEditModulePopUp = function (id, index) {
          $scope.ipModulePopup = true;
          // instructorPanelService.setCourseId($scope.selectedCourse.id);
          // $state.go('InstructorPanelModuleNew');
          if (index == "new") {
            // if(!instructorPanelService.getCourseId()){
            // 	$state.go('InstructorPanelDashboard');
            // }
            $scope.newEditText = "Add new";
            $scope.selectedModule = {
              name: "",
              description: "",
              short_description: "",
              module_type: {
                free: false,
                paid: false,
              },
            };
          } else if (index == "edit") {
            $scope.newEditText = "Edit";
            $scope.showData = false;
            $scope.editingModule = true;
            $http({
              url: "api/v1/cmodules/getModuleById",
              method: "GET",
              params: {
                id: id,
                instructor_id: CustomStorageService.getUserInfoStorageData().id,
              },
            }).then(function (data) {
              $scope.showData = true;
              if (data.data.success) {
                $scope.index_url = data.data.index_url;
                $scope.selectedModule = data.data.module;
                $scope.selectedModule.chapters = data.data.chapters;
              }
              // else {
              // 	$state.go('InstructorPanelDashboard')
              // }
            });
          }
        };

        $scope.goToEditModulePage = function (id) {
          $state.go("InstructorPanelModuleEdit", { id: id }, { reload: true });
        };

        $scope.deleteModule = function (index) {
          var data = { moduleId: $scope.selectedCourse.modules[index].id };
          swal(
            {
              title: "Warning",
              text: "Are you sure you want to delete this module?",
              type: "warning",
              showCancelButton: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                $scope.showData = false;
                $http
                  .post("api/v1/cmodules/deleteModule", data)
                  .then(function (data) {
                    $scope.showData = true;
                    if (data.data.success) {
                      instructorPanelService.successDeleteSwal();
                      $scope.selectedCourse.modules.splice(index, 1);
                    } else {
                      instructorPanelService.tryAgainSwal();
                    }
                  });
              }
            }
          );
        };

        $scope.deleteTerm = function (term, index) {
          if (term.id) {
            $scope.showData = false;
            $http
              .post("api/v1/terms/deleteTerm", { id: term.id })
              .then(function (data) {
                $scope.showData = true;
                if (data.data.success) {
                  instructorPanelService.successDeleteSwal();
                  $scope.selectedCourse.terms.splice(index, 1);
                } else {
                  instructorPanelService.tryAgainSwal();
                }
              });
          } else {
            $scope.selectedCourse.terms.splice(index, 1);
          }
        };

        $scope.previewPage = function () {
          var data = $scope.selectedCourse.index_url.split("/");
          var url = $state.href("Course", {
            institutionName: data[0],
            schoolName: data[1],
            courseName: data[2],
          });
          window.open(url, "_blank");
        };

        $sails.on("s3FileUpload", function (data) {
          // $scope.uploadingVideos[data.count-1].s3Log = data.progress;
          if (!$scope.$$phase) $scope.$apply();
        });

        $sails.on("imageUploadProgress", function (data) {
          $scope.imageUploadLog.progress = data;
          if (!$scope.$$phase) $scope.$apply();
        });

        // Module cONTROLLER

        $scope.saveDataModule = function (form) {
          $scope.ipEditPopupClose();
            if (!$scope.editingModule) {
              if (!form.image_url) {
                form.image_url =
                  "https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png";
              }
              if (!form.module_type.paid) {
                form.module_type.free = true;
                form.module_type.paid = false;
              } else {
                form.module_type.free = false;
              }
    
              if (!validateModuleForm(form)) {
                return false;
              }
              $scope.showData = false;
              var data = { module: form, id: $scope.selectedCourse.id };
              $http.post("api/v1/cmodules/newModule", data).then(function (data) {
                $scope.showData = true;
                if (data.data.success) {
                  swal("Success", "Module created successfully", "success");
                  $state.go(
                    "InstructorPanelCourseEdit",
                    { id: $scope.selectedCourse.id },
                    { reload: true }
                  );
                } else {
                  instructorPanelService.tryAgainSwal();
                }
              });
            } else {
              if (!form.image_url) {
                form.image_url =
                  "https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png";
              }
              if (!form.module_type.paid) {
                form.module_type.free = true;
                form.module_type.paid = false;
              } else {
                form.module_type.free = false;
              }
    
              if (!validateModuleForm(form)) {
                return false;
              }
              var chapters = form.chapters;
              for (var i in chapters) {
                chapters[i].chapter_no = i;
              }
              $http
                .post("api/v1/chapters/updateChapterNo", { chapters: chapters })
                .then(function (data) {});
              $scope.showData = false;
              var data = { module: form, id: form.id };
              $http
                .post("api/v1/cmodules/updateModule", data)
                .then(function (data) {
                  $scope.showData = true;
                  if (data.data.success) {
                    instructorPanelService.successUpdateSwal();
                    $state.go(
                      "InstructorPanelCourseEdit",
                      { id: $scope.selectedCourse.id },
                      { reload: true }
                    );
                  } else {
                    instructorPanelService.tryAgainSwal();
                  }
                });
            }
        };
        var validateModuleForm = function (form) {
          if (
            !form.name ||
            !form.description
          ) {
            swal("Oops..", "Please fill in all fields", "error");
            return false;
          }
          return true;
        };
        // mODULE Controller
        if (
          !$scope.signedIn ||
          !CustomStorageService.getUserInfoStorageData()
        ) {
          $state.go("instructor_signin", {}, { reload: true });
        } else {
          $scope.initialize();
        }
      },
    ]);
})();

(function() {
	'use strict';

	angular
	.module('NearPeer')

	.controller('InstructorPanelEnrolledController', ['$scope', '$http', '$state', 'CustomStorageService','instructorPanelService', function($scope, $http, $state, CustomStorageService,instructorPanelService) {

		$(document).ready(function(){
			$(this).scrollTop(0);
		});

		$scope.totalPages = 1;
		$scope.page = 1;
		$scope.pageText = "1st";
		function ordinal_suffix_of(i) {
			var j = i % 10,
				k = i % 100;
			if (j == 1 && k != 11) {
				return i + "st";
			}
			if (j == 2 && k != 12) {
				return i + "nd";
			}
			if (j == 3 && k != 13) {
				return i + "rd";
			}
			return i + "th";
		}
		$scope.initialize = function(){
			$scope.selectedCourse = 'Select Course';
			$scope.enrolledStudents = {};
		}

		$scope.$on('instructorUpdatedFaculty',function(){
			$scope.selectedCourse = 'Select Course';
			$scope.enrolledStudents = {};
			$scope.showData = false;
			$scope.instructor_courses = instructorPanelService.getSelectedCourses();
			$scope.showData = true;
			if(!$scope.$$phase) $scope.$apply();
		});
		$scope.course = '';
		$scope.studentsExist = true;
		$scope.getEnrolledStudents = function(course, pg){
			$scope.course = course;
			if(pg < 0 || pg > $scope.totalPages)
			{
				return;
			}
			if(pg)
			{
				$scope.page = pg;
				$scope.pageText = ordinal_suffix_of($scope.page);
			}
			$scope.selectedCourse = $scope.instructor_courses[course].name;
			$scope.courseId = $scope.instructor_courses[course].id
			$scope.currentCourse = $scope.instructor_courses[course]
			$scope.showData = false;
			$http({
				url: 'api/v1/enrolledstudents/getEnrolledStudents',
				method:"GET",
				params:{course_id: $scope.courseId, page : $scope.page , per_page : 10}
			}).then(function(data){
				if(!data.data.success > 0){
					$scope.studentsExist = false;
				} else{
					$scope.studentsExist = true;
				}
				$scope.enrolledStudents = data.data.students;
				$scope.totalEnrolled = data.data.total;
				$scope.totalPages = Math.ceil($scope.totalEnrolled /10);
				$scope.showData = true;
			})
		}

		$scope.sendUpdateEmailNotification = function(text,users){
			if(!text){
				swal('Ooopss..','Message for email can not be empty.','error');
				return false;
			}
			var data ={course_id:$scope.currentCourse.id,course_name: $scope.currentCourse.name,index_url:$scope.currentCourse.index_url, text:text, users:users}
			$http.post('api/v1/instructors/sendUpdateNotification',data)
			.then(function(data){
				if(data.data.success){

				} else {
				}
			})
			swal('Success','Emails are now in process','success');
		}

		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
			$state.go('instructor_signin',{},{reload:true});
		} else {
			$scope.initialize();
		}
	}]);
})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('InstructorPanelDashboardController', ['$scope', '$http', '$state', 'CustomStorageService', 'instructorPanelService', '$filter', function ($scope, $http, $state, CustomStorageService, instructorPanelService, $filter) {
      $(document).ready(function () {
        $(this).scrollTop(0);
      });
      var courseIndx;
      var isClearing = false; 
      $scope.initialize = function () {
        $scope.selectedCourse = 'Select Course';
        $scope.maxDate = new Date();
        $scope.selectedId = 1;
        $scope.globalCourseIndex = -1;
        getDashboardData(); 
        // $scope.getData();
      } 

      // Watch for start date change
$scope.$watchGroup(['sDate', 'eDate'], function (newVals, oldVals) {
  if (!isClearing &&
      newVals[0] !== oldVals[0] &&
      newVals[1] !== oldVals[1] &&
      newVals[0] && newVals[1]) {

    getDashboardData();
  }
});


$scope.updateDates = function () {
    $scope.sDate = formatDate($scope.uiStart);
    $scope.eDate   = formatDate($scope.uiEnd);
};

function formatDate(dateObj) {
    if (!dateObj) return null;
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const d = String(dateObj.getDate()).padStart(2, "0");
    return y + '-' + m + '-' + d;
}



    $scope.clearFilters = function () {
      isClearing = true;
      
      $scope.sDate = null;
      $scope.eDate = null;

      $scope.uiStart = null;
      $scope.uiEnd = null;

      $scope.selectedCourse = 'Select Course';
      courseIndx = undefined;
      $scope.globalCourseIndex = -1;
      $scope.courseSearchText = '';  // Add this line
      
      setTimeout(function() {
        isClearing = false;
      }, 0);
      
      getDashboardData();
    };


      var getDashboardData = function (courseIndex) {
        var data = { instructor_id: instructorPanelService.getInstructorId(), institution: instructorPanelService.getSelectedInstitution(), faculty: instructorPanelService.getSelectedFaculty() }
        if (courseIndex > -1) {
          data['course_id'] = $scope.instructor_courses[courseIndex].id;
        }
        if ($scope.courseIndex === -1 || $scope.globalCourseIndex > -1) {
          console.log("If condition");
          data['course_id'] = $scope.instructor_courses[$scope.globalCourseIndex].id;
        }
        if ($scope.sDate && $scope.eDate) {
          data['start_date'] = new Date($scope.sDate);
          data['end_date'] = new Date($scope.eDate);
        }
        $http({
          url: 'api/v1/dashboard/getDashboardDetails',
          method: "GET",
          params: data
        }).then(function (data) {
          if (!data.data.success) {
            $scope.hideDashboard = true;
            swal("No Data Found");
          } else {
            $scope.hideDashboard = false;
            $scope.dashboardData = data.data;
          }
        });
      }
      $scope.$on('init', function () {
        $scope.initialize();
      });


     $scope.getCourseData = function (course) {
  // Find the actual index in the original array
  var actualIndex = $scope.instructor_courses.findIndex(function(c) {
    return c.id === course.id;
  });
  
  if (actualIndex > -1) {
    $scope.selectedCourse = course.name;
    courseIndx = course.id;
    $scope.globalCourseIndex = actualIndex;
    
    // Clear search text after selection
    $scope.courseSearchText = '';
    
    getDashboardData(actualIndex);
  }
};

      var reduceLabels = function (label) {
        var i = 0, date;
        if (label.length < 9) {
          for (var k in label) {
            date = new Date(label[k]);
            label[k] = $filter('date')(date, 'MMM d');
          }
        } else if (label.length % 5 == 0) {
          i = 5;
        } else if (label.length % 4 == 0) {
          i = 4;
        } else if (label.length % 3 == 0) {
          i = 3;
        } else if (label.length % 2 == 0) {
          i = 2;
        } else {
          i = 5;
        }
        if (i != 0) {
          for (var j in label) {
            if (j % i == 0) {
              date = new Date(label[j]);
              label[j] = $filter('date')(date, 'MMM d');
            } else {
              label[j] = '';
            }
          }
        }
        return label;
      }

      $scope.updateChart = function (id) {
        $scope.selectedId = id;
        switch (id) {
          case 1:
            $scope.lineChartData = [$scope.chartData.videoWatchedData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#00ff01',
            },];
            break;
          case 2:
            $scope.lineChartData = [$scope.chartData.enrollmentsData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#0f10fe',
            },];
            break;
          case 3:
            $scope.lineChartData = [$scope.chartData.courseSoldData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#ff1d1e',
            },];
            break;
          case 4:
            $scope.lineChartData = [$scope.chartData.userData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#ff42fe',
            },];
            break;
          case 5:
            $scope.lineChartData = [$scope.chartData.earningData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#3d1055',
            },];
            break;
          case 6:
            $scope.lineChartData = [$scope.chartData.quizAttempted];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#5f1d5b',
            },];
            break;
          case 7:
            $scope.lineChartData = [$scope.chartData.moduleSoldData];
            $scope.chartColor = [{
              backgroundColor: 'transparent',
              borderColor: '#73d4f7',
            },]; break;
          default:
        }
      }
      $scope.getData = function (courseIndex) {
        $scope.showData = false;
        var data = { instructor_id: instructorPanelService.getInstructorId(), institution: instructorPanelService.getSelectedInstitution(), faculty: instructorPanelService.getSelectedFaculty() };
        if ($scope.sDate && $scope.eDate) {
          data['sDate'] = new Date($scope.sDate);
          data['eDate'] = new Date($scope.eDate);
        }
        if (courseIndx > -1) {
          data['course_id'] = courseIndx;
        }
        $http({
          url: "api/v1/dashboard/getDataBetweenDates",
          method: "GET",
          params: data
        }).then(function (data) {
          if (!data.data.success) {
            $scope.hideDashboard = true;
            swal("No Data Found");
          } else {
            $scope.sDate = data.data.sDate;
            $scope.eDate = data.data.eDate;
            $scope.chartData = data.data.chartData;
            $scope.updateChart($scope.selectedId);
            $scope.lineChartLabels = reduceLabels($scope.chartData.labels);
            $scope.showData = true;
          }
        });
      }

      $scope.$on('instructorUpdatedFaculty', function () {
        courseIndx = undefined;
        $scope.selectedCourse = 'Select Course';
        $scope.enrolledStudents = {};
        $scope.showData = false;
        $scope.instructor_courses = instructorPanelService.getSelectedCourses();
        $scope.showData = true;
        if (!$scope.$$phase) $scope.$apply();
        $scope.initialize();
      });

      if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('instructor_signin', {}, { reload: true });
      }
    }]);
})();
(function() {
	'use strict';

	angular
	.module('NearPeer')

	.controller('InstructorPanelCommentsController', ['$scope','Upload', '$http', '$state', 'CustomStorageService','instructorPanelService','$sails', 'env', function($scope, Upload, $http, $state, CustomStorageService,instructorPanelService,$sails, env) {
		$(document).ready(function(){
			$(this).scrollTop(0);
		});
		$scope.showImagePopup = false;
		$scope.selectedImage ='';
		$scope.openCloseImagePopup = function(img) {
			if($scope.showImagePopup)
				$scope.showImagePopup = false;
			else {
				$scope.selectedImage = img;
				$scope.showImagePopup = true;
			}

		}
		function ordinal_suffix_of(i) {
			var j = i % 10,
				k = i % 100;
			if (j == 1 && k != 11) {
				return i + "st";
			}
			if (j == 2 && k != 12) {
				return i + "nd";
			}
			if (j == 3 && k != 13) {
				return i + "rd";
			}
			return i + "th";
		}
		var per_page = 10;
		var commentType = 'all';
		$scope.page = 1;
		$scope.pageText = "1st";
		$scope.total = 10;
		$scope.totalPages = 1;
		$scope.selectedVideo = {};
		$scope.showVideoPopup = false;
		$scope.showPopup = false;
		$scope.replyText = '';
		$scope.initialize =function()
		{
			var str = CustomStorageService.getUserInfoStorageData().full_name;
			$scope.userId = CustomStorageService.getUserInfoStorageData().id;

			$scope.imageInitial = str.charAt(0).toUpperCase();
			var data =
			{
				user_id:CustomStorageService.getUserInfoStorageData().id,
				page: 1,
				per_page: per_page,
				type: commentType
			}

			$http({
				url: 'api/v1/comments/getComments',
				params: data,
				method: "GET"
			}).then(function (data) {
				$scope.comments = data.data.comments;
				$scope.AllComments=data.data.comments.allComments;
				$scope.AllComments.forEach(function(comment){
					comment.text = $scope.formatTextForLink(comment.text);
					if (comment.replies.length > 0) {
						comment.replies.forEach(function(reply){
							reply.text = $scope.formatTextForLink(reply.text);
						});
					}
				});
				$scope.total=data.data.comments.total;
				$scope.totalPages = Math.ceil($scope.total / 10);
			});

			// $http({
      //   url: '/api/v1/courses/getInstructorCoursesById',
      //   method: "GET",
      //   params: {instructor: CustomStorageService.getUserInfoStorageData().id}
      // }).then(function(data) {
      //   $scope.instructorCourses = data.data.courses;
      // })

		}

		$scope.$on('closeForm', function (event, message) {
			
			$scope.showVideoPopup = false;
		});
		
		$scope.selectCourse = function () {

			var per_page = 10;
			var commentType = 'all';
			$scope.page = 1;
			$scope.pageText = "1st";
			$scope.total = 10;
			$scope.totalPages = 1;

			var data =
			{
				user_id:CustomStorageService.getUserInfoStorageData().id,
				page: 1,
				per_page: per_page,
				type: commentType,
				course: $scope.selectedCourse
			}

			$http({
				url: 'api/v1/comments/getComments',
				params: data,
				method: "GET"
			}).then(function (data) {
				$scope.comments = data.data.comments;
				$scope.AllComments=data.data.comments.allComments;
				$scope.AllComments.forEach(function(comment){
					comment.text = $scope.formatTextForLink(comment.text);
					if (comment.replies.length > 0) {
						comment.replies.forEach(function(reply){
							reply.text = $scope.formatTextForLink(reply.text);
						});
					}
				});
				$scope.total=data.data.comments.total;
				$scope.totalPages = Math.ceil($scope.total / 10);
			});
		}


		$scope.customFilter = function (comment) { 
			if($scope.replyFilter === 'replied') {
				if(comment.replies.length > 0) {
					return true
				} else {
					return false
				}
			} else if($scope.replyFilter === 'pending') {
				if(comment.replies.length === 0) {
					return true
				} else {
					return false
				}
			} else {
				return true
			}
	};

		$scope.getComments = function(page) {
			if(page > 0 && $scope.totalPages >= page) {
			$scope.page = page;
			$scope.pageText = ordinal_suffix_of(page);
				var data =
				{
					user_id:CustomStorageService.getUserInfoStorageData().id,
					page: page,
					per_page: per_page,
					type: commentType
				}

				$http({
					url: 'api/v1/comments/getComments',
					params: data,
					method: "GET"
				}).then(function (data) {
					$scope.comments = data.data.comments;
					$scope.AllComments=data.data.comments.allComments;
					$scope.AllComments.forEach(function(comment){
						comment.text = $scope.formatTextForLink(comment.text);
						if (comment.replies.length > 0) {
							comment.replies.forEach(function(reply){
								reply.text = $scope.formatTextForLink(reply.text);
							});
						}
					});
					$scope.total=data.data.comments.total;
					$scope.totalPages = Math.ceil($scope.total / 10);
				});
			}
		}

		$scope.approveComment = function (value,id)
		{
			var sendValue;
			if(value == false){
				sendValue=true;
			}
			else{
				sendValue=false;
			}
			var data ={
				comment_id:id,
				value:sendValue,
			}
			$http.post('api/v1/comments/approveComment',data)
			.then(function(data){
				$state.go($state.current, {}, {reload: true});
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});
			})
		}



		$scope.disableComment = function (value,id)
		{
			var sendValue;
			if(value == false){
				sendValue=true;
			}
			else{
				sendValue=false;
			}
			var data ={
				comment_id:id,
				value:sendValue,
			}
			$http.post('api/v1/comments/disableComment',data)
			.then(function(data){
				$state.go($state.current, {}, {reload: true});
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});

			})

		}
		$scope.closeReplyPopup = function(id,comment) {
			$scope.showPopup = false;
		}
		$scope.selectedCommentID =0;
		$scope.selectedcomment= '';
		$scope.showRepliesPopup = false;
		$scope.viewCommentReplies = function (id,comment) {
			if($scope.showRepliesPopup)
			$scope.showRepliesPopup = false;
			else
			{
				$scope.selectedCommentID =id;
				$scope.selectedcomment= comment;
				$scope.showRepliesPopup = true;
			}
		}
		$scope.instructorReply=function(text,id,reply)
		{
			if(CustomStorageService.getInstructorSignedInStorageData()){
				if($scope.imageUploadingInProcess){
           swal("Uploading","Please wait for attachment to upload","info");
           return false;
         }

				var params = {
					user_id: CustomStorageService.getUserInfoStorageData().id,
					text: text,
					image_url:$scope.commentImage,
					comment_id:id
				}

				var url = 'api/v1/comments/instructorReplyComment';


				$http.post(url,params)
				.then(function(data){
					if(data.status==200)
					{
						text = '';
						$scope.commentImage = '';
						$scope.replyText="";
						reply.showReply=false;
						var index = $scope.AllComments.findIndex(function(c){return c.comment_id === id;});
						data.data.reply.user_name = CustomStorageService.getUserInfoStorageData().full_name;
						$scope.AllComments[index].replies.push(data.data.reply);
						var textarea = document.getElementById(id);
						var fileInput = document.getElementById('file-'+id);
						textarea.value = '';
						fileInput.value = '';
						swal({
							title: "Reply",
							text: "Reply posted",
							type: "info",
							showCancelButton:false
						},function(){
						});
						$scope.showPopup = false;
					}
				})
			}
		}

		$scope.approveReply = function (value,id)
		{
			var sendValue;
			if(value == false){
				sendValue=true;
			}
			else{
				sendValue=false;
			}
			var data ={
				comment_id:id,
				value:sendValue,
			}
			$http.post('api/v1/comments/approveReply',data)
			.then(function(data){
				$state.go($state.current, {}, {reload: true});
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});
			})
		}

		$scope.disableReply = function (value,id)
		{
			var sendValue;
			if(value == false){
				sendValue=true;
			}
			else{
				sendValue=false;
			}
			var data ={
				comment_id:id,
				value:sendValue,
			}
			$http.post('api/v1/comments/disableReply',data)
			.then(function(data){
				$state.go($state.current, {}, {reload: true});
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});

			})
		}

		$scope.change = function(value)
		{
			$scope.selected=value;

			if(value==1)
			{
				$scope.AllComments=$scope.comments.allComments;
				commentType = 'all'
			}

			else if(value==2) {
				$scope.AllComments=$scope.comments.approved;
				commentType = 'approved'
			}
			


			else if(value==3) {
				$scope.AllComments=$scope.comments.pending;
				commentType = 'pending'
			}
			

			else if(value==4) {
				$scope.AllComments=$scope.comments.hidden;
				commentType = 'hidden'
			}
			
			$scope.getComments(1);

		}

		$scope.hideShow = function(id, comment)
		{
			if($scope.showPopup)
		 		$scope.showPopup=false;
		 	else
			 {
				$scope.selectedCommentID =id;
				$scope.selectedcomment= comment;
				$scope.showPopup=true;
			 }
		}

		$scope.approveComment = function (id)
		{
			var data ={
				comment_id:id
			}
			$http.post('api/v1/comments/approveComment',data)
			.then(function(data){
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});
			})
		}

		$scope.hideComment = function(id){
			var data ={
				comment_id:id
			}
			$http.post('api/v1/comments/disableComment',data)
			.then(function(data){
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});
			})
		}
		$scope.unhideComment = function(id){
			var data ={
				comment_id:id
			}
			$http.post('api/v1/comments/enableComment',data)
			.then(function(data){
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				},function(){
					location.reload();
				});
			})
		}
		$scope.hideShowReply = function(reply)
		{
			if(reply.showReply)
		 reply.showReply=false;

		 else {
			 reply.showReply=true;
		 }
		}

		$scope.hideReply = function(id){
			var data ={
				comment_id:id
			}
			$http.post('api/v1/comments/disableReply',data)
			.then(function(data){
				swal({
					title: "Success!",
					type: "info",
					confirmButtonText: "Ok"
				});
			})
		}

		$scope.addImage = function(image){
			if(image)
			{
				if(CustomStorageService.getInstructorSignedInStorageData()){
					$scope.imageUploadingInProcess =  true;
					if(!$scope.$$phase) $scope.$apply();
					Upload.upload({
						url: 'api/v1/uploader/uploadImageToS3?userId='+CustomStorageService.getUserInfoStorageData().id + '&socket_id=' + CustomStorageService.getSocketIdStorageData(),
						method: "POST",
						file: image
					}).then(function(data){
						$scope.imageUploadingInProcess = false;
						$scope.commentImage = data.data.link;
						if(!obj){
							$scope.commentImage = data.data.link;
						} else {
							obj.replyImage_url = data.data.link;
						}
						if(!$scope.$$phase) $scope.$apply();
					});
				}
			}
		}

		$scope.getInitialLetter = function(str){
			return ((str || '').charAt(0) || '').toUpperCase();
		}

		$scope.goToVideo = function(url){
			$http.get('api/v1/playBack/getVideoForInstructor?videoId='+url.video_id)
			.then(function(data){
				if(data.data.success == true){
					$scope.selectedVideo = data.data.video
					$scope.showVideoPopup = true;
				}else{
					alert(data.data.message || 'Error occured')
				}
			})
		}


		$scope.formatTextForLink = function(text){
			var newText = text.replace(/(https?:\/\/[^\s]+)/g, function(url) {
				return '<a target="_blank" href="'+url+'+">'+url+'</a>';
			});
			return newText;
		};

		$sails.on('imageUploadProgress',function(data){
			$scope.imageUploadLog.progress = data;
			if(!$scope.$$phase) $scope.$apply();
		})

		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
			$state.go('instructor_signin',{},{reload:true});
		} else {
			$scope.initialize();
		}

	}]);
})();

(function() {
	'use strict';

	angular
	.module('NearPeer')

	.controller('InstructorPanelChapterController', ['$scope','Upload','$timeout', '$http', '$state', 'CustomStorageService', 'instructorPanelService', function($scope, Upload, $timeout, $http, $state, CustomStorageService, instructorPanelService) {
		$(document).ready(function(){
			$(this).scrollTop(0);
		});
		$scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();

		$scope.initialize = function(){
			if($state.current.name == 'InstructorPanelChapterNew'){
				if(!instructorPanelService.getModuleId()){
					$state.go('InstructorPanelDashboard',{},{reload:true});
				}
				$scope.selectedChapter = {};
			} else if($state.current.name == 'InstructorPanelChapterEdit'){
				$scope.showData = false;
				var id = $state.params.id;
				$scope.chapterEditing = true;
				$http({
					url: 'api/v1/chapter/getChapterById',
					method: "GET",
					params: {id: id,instructor_id: instructorPanelService.getInstructorId()}
				}).then(function(data){
					$scope.showData = true;
					if(data.data.success){
						$scope.selectedChapter = data.data.chapter;
					} else {
						$state.go('InstructorPanelDashboard',{},{reload:true});
					}
				});
			}
		}

		$scope.saveData = function(form){
			if(!form.name){
				swal('Oops..','Please add chapter name','error');
				return false;
			}

			if(!$scope.chapterEditing){
				$scope.showData = false;
				var data = {chapter:form,id:instructorPanelService.getModuleId()};
				$http.post('api/v1/chapter/createChapter', data)
				.then(function(data) {
					$scope.showData = true;
					if(data.data.success){
						swal('Success','Chapter created successfully','success');
						$state.go('InstructorPanelModuleEdit',{id:instructorPanelService.getModuleId()},{reload:true});
					} else {
						instructorPanelService.tryAgainSwal();
					}
				});
			} else {
				$scope.showData = false;
				var data = {chapter:form};
				$http.post('api/v1/chapter/updateChapter', data)
				.then(function(data) {
					$scope.showData = true;
					if(data.data.success){
						instructorPanelService.successUpdateSwal();
						location.reload();
					} else {
						instructorPanelService.tryAgainSwal();
					}
				})
			}
		}

		$scope.goToVideoPage = function(){
			$state.go('InstructorPanelVideo',{state:'chapter',id:$scope.selectedChapter.id,module_id:$state.params.module_id},{reload:true});
		}

		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
			$state.go('instructor_signin',{},{reload:true});
		} else {
			$scope.initialize();
		}
	}]);
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("instructorAssignmentsController", [
      "$scope",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "AssignmentService",
      "$sails",
      "env",
      "$sce",
      function (
        $scope,
        Upload,
        $http,
        $state,
        CustomStorageService,
        AssignmentService,
        $sails,
        env,
        $sce
      ) {
        $(document).ready(function () {
          $(this).scrollTop(0);
        });
        var sr = $scope;
        var per_page = 10;
        var commentType = "all";
        var totalUnansweredCount = 0;
        $scope.newQuestion = false;
        $scope.markedAssignmentLink = "";
        $scope.page = 1;
        $scope.total = 10;
        $scope.totalPages = 1;
        $scope.assignmentSubmistions;
        $scope.showData = false;
        $scope.selectedQuestionImage;
        $scope.selectedQuestion;
        $scope.selectedInstructor;
        $scope.selectedQuestionToAssign;
        $scope.filterSelected = {
          all: true,
          assigned: false,
          unassigned: false,
          answered: false,
        };
        $scope.result = {
          remarks: "",
          total_marks: 100,
          obtained_marks: "",
          page_title: "",
          page_description: "",
        };
        $scope.remaining = false;
        $scope.pageImageLoading = false;
        $scope.rem_stars = [];
        $scope.callFilters = {
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          pageNo: 1,
          limit: 10,
          assigned: null,
          answered: false,
          sort: "submittedAt",
          order: "ASC",
          search: "",
          from_date: "",
          to_date: "",
        };
        $scope.defaultDropDown = "Select Uploading Options";
        $scope.showOptions = false;
        $scope.searchText = "";
        $scope.totalPageCount;
        $scope.findInstructor = "";
        $scope.instText = "";
        $scope.selected = false;
        $scope.displayQuestion = false;
        $scope.assignInstructor = false;
        $scope.pageArr = [1, 2, 3, 4, 5];
        $scope.currentPage = 1;
        $scope.noData = true;
        $scope.toUpdateInstructor = false;
        $scope.previewImage = "";
        $scope.notAvideo = true;
        $scope.isPDF = false;
        $scope.containsLinks = false;
        $scope.fileName = "";
        $scope.isYoutube = false;
        $scope.ytID = "";
        $scope.videoLink = "";
        $scope.imageshowloader = true;
        $scope.fromDate = "";
        $scope.toDate = "";
        $scope.allQuestionsCount = 0;
        $scope.assignedQuestionsCount = 0;
        $scope.answeredQuestionsCount = 0;
        $scope.unassignedQuestionsCount = 0;
        $scope.ytError = "";
        $scope.unansweredQuestionsCount = 0;
        $scope.initialize = function () {
          var str = CustomStorageService.getUserInfoStorageData().full_name;
          $scope.imageInitial = str.charAt(0).toUpperCase();
          var data = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            page: 1,
            per_page: per_page,
            type: commentType,
          };
        };

        var instructor = CustomStorageService.getUserInfoStorageData()

        $scope.getAllQuestions = function (filter) {
          if (filter != null) {
            console.log("EMPTY");
          }
          console.log("CALL FILTERS", $scope.callFilters);
          // answered=false&&search=false
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          //&assigned=false&sort=date&order=asc
          var body = {
            page: $scope.callFilters.pageNo,
            limit: $scope.callFilters.limit,
            status: $scope.callFilters.status,
            sort: $scope.callFilters.sort,
            order: $scope.callFilters.order,
            search: $scope.callFilters.search,
            from_date: $scope.callFilters.from_date,
            to_date: $scope.callFilters.to_date,
            instructor_id: instructor.id
          };
          AssignmentService.getAllAssignments(body).then(function (resp) {
            if (resp.success) {
              $scope.totalPageCount = resp.pages;
              if (resp.countStats) {
                var countStats = {};
                var totalSubmitions = resp.count;
                resp.countStats.forEach(function (stat) {
                  countStats[stat.status] = stat.count;
                });
                $scope.countStats = countStats;
                $scope.totalSubmitions = totalSubmitions;
              }
              // if ($scope.callFilters.pageNo === 1) {
              //   $scope.allQuestionsCount = resp.data.data.overallCounts.all;
              //   $scope.assignedQuestionsCount =
              //     resp.data.data.overallCounts.assigned;
              //   $scope.answeredQuestionsCount =
              //     resp.data.data.overallCounts.answered;
              //   $scope.unassignedQuestionsCount =
              //     resp.data.data.overallCounts.unassigned;
              //   $scope.unansweredQuestionsCount =
              //     resp.data.data.overallCounts.unanswered;
              // }
              // if (filter === "fromUpdate") {
              //   $scope.newQuestion = true;
              // }
              // if ($scope.newQuestion) {
              //   setTimeout(function () {
              //     $scope.newQuestion = false;
              //     $scope.$apply();
              //   }, 2000);
              // }

              if ((resp.assignments || []).length > 0) {
                $scope.assignmentSubmistions = resp.assignments;
                $scope.noData = false;
                $scope.showData = true;
              } else {
                $scope.assignmentSubmistions = resp.assignments;
                $scope.noData = true;
                $scope.showData = true;
              }
              // $scope.$apply();
              console.log("QUESTIONS", $scope.assignmentSubmistions);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.downloadAssignment = function (assignment) {
          updateStatus({status: 'instructor_downloaded', assignment_id: assignment.id}).then(function (res) {});
          window.open(assignment.submitted_file, "_blank");
        };
        $scope.dateFilter = function (type) {
          console.log($scope.fromDate, $scope.toDate, "In date filter", type);
        };
        $scope.getAllInstructors = function () {
          $http.get("/api/v1/user/getInstructors").then(function (resp) {
            if (resp.data.success) {
              // $scope.assignmentSubmistions = resp.data.data.questions;
              $scope.listofInstructors = resp.data.instructors;
              $scope.showData = true;
              console.log("instructors", resp);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.selectInstructor = function (inst) {
          $scope.findInstructor = inst.name ? inst.name : inst.full_name;
          $scope.selected = !$scope.selected;
          $scope.instText = inst.email;

          $scope.selectedInstructor = inst;

          var div = document.getElementById("myDropdown");
          var label = div.getElementsByTagName("label");
          var txtValue = label[i].textContent || label[i].innerText;
          txtValue = $scope.findInstructor;
          console.log("selected inst", inst);
        };
        var updateStatus = function (data) {
          return new Promise(function (resolve, reject) {
            AssignmentService.updateAssignmentStatus(data).then(function (res) {
              resolve(res);
            });
          });
        };

        $scope.assignCall = function () {
          var body = {
            assignment_id: $scope.selectedQuestionToAssign.id,
            assigned_to: $scope.selectedInstructor.id,
            status: "assigned",
          };
          updateStatus(body).then(function (res) {
            if (res && res.success) {
              swal(
                {
                  title: "Assigned to Instructor",
                  text: "Question is successfully assigned.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeInstructor();
                  $scope.assignInstructor = false;
                  $scope.$apply();
                  $scope.getAllQuestions();
                  swal.close();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in assigning question",
                type: "error",
              });
            }
          });
        };
        $scope.closeAnswerWindow = function () {
          $scope.viewRemoveManager();
          $scope.selectedQuestionImage = null;
          $scope.selectedAnswerImage = false;
          $scope.notAvideo = true;
          $scope.videoLink = "";
          $scope.selectedQuestionToAnswer = {};
          $scope.answerQuestion = false;
          $scope.imageshowloader = true;
          $scope.isYoutube = false;
          $scope.result = {
            remarks: "",
            total_marks: "",
            obtained_marks: "",
            page_title: "",
            page_description: "",
          };
        };
        $scope.pageChange = function (page) {
          $scope.showData = false;
          var temp = [];
          if (
            $scope.pageArr[0] + 4 === page &&
            $scope.pageArr[0] + 4 < $scope.totalPageCount
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row + 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (
            $scope.pageArr[4] - 4 === page &&
            $scope.pageArr[4] - 4 > 1
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row - 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (page <= $scope.totalPageCount && page >= 1) {
            if (page < $scope.currentPage && $scope.pageArr[0] - 1 > 0) {
              $scope.pageArr.forEach(function (row) {
                row = row - 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else if (
              page > $scope.currentPage &&
              $scope.pageArr[4] + 1 < $scope.totalPageCount
            ) {
              $scope.pageArr.forEach(function (row) {
                row = row + 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else {
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            }
          }

          // }
        };
        $scope.adminSearchDrop = function () {
          document.getElementById("myDropdown").classList.toggle("show-dp");
        };

        $scope.filterFunctionAdmin = function () {
          var input, filter, ul, li, label, i;
          input = document.getElementById("myInput");
          filter = input.value.toUpperCase();
          var div = document.getElementById("myDropdown");
          label = div.getElementsByTagName("label");
          for (i = 0; i < label.length; i++) {
            var txtValue = label[i].textContent || label[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              label[i].style.display = "";
              // $scope.findInstructor = txtValue ;
            } else {
              label[i].style.display = "none";
            }
          }
        };
        $scope.getUnansweredCount = function () {
          AssignmentService.getPendingCount({}).then(function (res) {
            if (res.success) {
              totalUnansweredCount = res.pendingCount;
              if (totalUnansweredCount !== $scope.unansweredQuestionsCount) {
                $scope.unansweredQuestionsCount = totalUnansweredCount;
                if ($scope.callFilters.pageNo == 1) {
                  $scope.getAllQuestions("fromUpdate");
                }
              }
            }
          });
        };
        $scope.getAllQuestions(null);
        var assignmentInterval = setInterval(function () {
          $scope.getUnansweredCount();
          $scope.$emit("pendingAssignmentCountCheck", {});
        }, 40000);

        if ($state.current.name != "InstructorAssignments") {
          clearInterval(assignmentInterval);
        }
        $scope.searchQuery = function () {
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          $scope.callFilters.search = $scope.searchText;
          $scope.callFilters.from_date = $scope.fromDate;
          $scope.callFilters.to_date = $scope.toDate;
          $scope.getAllQuestions();
        };

        $scope.clearFilter = function () {
          $scope.searchText = "";
          $scope.toDate = "";
          $scope.fromDate = "";
          $scope.callFilters = {
            // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
            pageNo: 1,
            limit: 10,
            assigned: null,
            answered: false,
            sort: "submittedAt",
            order: "ASC",
            search: "",
            from_date: "",
            to_date: "",
          };
          $scope.getAllQuestions(null);
        };
        $scope.getAllInstructors();
        $scope.changeFilter = function (type) {
          console.log(type, "Filter");
          $scope.showData = false;
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          Object.keys($scope.filterSelected).forEach(function (element) {
            if (element == type) {
              $scope.filterSelected[element] = true;
            } else {
              $scope.filterSelected[element] = false;
            }
          });
          if (type === "all") {
            $scope.callFilters.status = null;
          } else if (type === "assigned") {
            $scope.callFilters.status = "assigned";
          } else if (type === "answered") {
            $scope.callFilters.status = "checked";
          } else {
            $scope.callFilters.status = "submitted";
          }
          $scope.getAllQuestions();
        };

        $scope.sortFilter = function (sort, type) {
          // pageNo: 1,
          // limit: 10,
          // answered: null,
          // sort: "date",
          // order: "desc",
          // search : ""
          $scope.showData = false;
          if (sort === "asc") {
            $scope.callFilters.order = "asc";
          } else {
            $scope.callFilters.order = "desc";
          }
          $scope.callFilters.sort = type;
          $scope.getAllQuestions();
        };
        $scope.answerStudent = function (obj) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAnswer = obj;
          $scope.answerQuestion = true;
          if (obj.status === "checked") {
            $scope.uploadedImgLink = obj.checked_file;
            $scope.selectedAnswerImage = obj.checked_file;
            $scope.result = {
              remarks: obj.result_remarks,
              total_marks: obj.total_marks || 100,
              obtained_marks: obj.obtained_marks,
              page_title: obj.result_page_data.page_title,
              page_description: obj.result_page_data.page_description,
              pageImgLink: obj.result_page_data.pageImgLink,
              isEmail: obj.result_page_data.isEmail,
              email_subject: obj.result_page_data.email_subject,
              email_text: obj.result_page_data.email_text,
              isSMS: obj.result_page_data.isSMS,
              sms_text: obj.result_page_data.sms_text,
            };
          }
          if (obj.status === "draft") {
            $scope.uploadedImgLink = obj.checked_file;
            $scope.selectedAnswerImage = obj.checked_file;
            $scope.result = {
              remarks: obj.result_remarks,
              total_marks: obj.total_marks || 100,
              obtained_marks: obj.obtained_marks,
            };
          }
        };

        $scope.assignToInstructor = function (obj, update) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAssign = obj;
          $scope.assignInstructor = true;
          if (update === "update") {
            $scope.toUpdateInstructor = true;
          } else {
            $scope.toUpdateInstructor = false;
          }
        };
        $scope.getNumber = function (num) {
          if (num < 5) {
            $scope.remaining = true;
            for (i = 0; i <= 5 - num; i++) {
              $scope.rem_stars.push("star");
            }
          } else {
            $scope.remaining = false;
            $scope.rem_stars = [];
          }
          return new Array(num);
        };
        $scope.closeInstructor = function () {
          console.log("CLOSE INSTRUCTOR");
          $scope.viewRemoveManager();
          $scope.assignInstructor = false;
          $scope.findInstructor = "";
          $scope.instText = "";
          $scope.selected = false;
          // $scope.$apply();
        };
        $scope.viewAddManager = function () {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          document.body.style.height = "100vh";
          if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "100vh";
            document.getElementById("adminpanel").style.overflow = "hidden";
          } else if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "100vh";
            document.getElementById("adminpanel").style.overflow = "hidden";
          }
        };
        $scope.viewRemoveManager = function () {
          document.body.style.height = "auto";
          if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "auto";
            document.getElementById("adminpanel").style.overflow = "auto";
          } else if (document.getElementById("adminpanel")) {
            document.getElementById("adminpanel").style.minHeight = "auto";
            document.getElementById("adminpanel").style.overflow = "auto";
          }

          // document.body.classList.remove("full-v-h");
        };
        $scope.imageLoadCheck = function () {
          console.log("on image load");
          $scope.imageshowloader = false;
          $scope.$apply();
        };
        $scope.viewQuestion = function (qId, question, image) {
          $scope.viewAddManager();
          $scope.containsLinks = false;

          if (image != null) {
            if (image.includes("mp4") || image.includes("webm")) {
              $scope.imageshowloader = false;

              $scope.notAvideo = false;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            } else if (
              image.includes("pdf") ||
              image.includes("docx") ||
              image.includes("docs") ||
              image.includes("txt") ||
              image.includes("xls") ||
              image.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
              $scope.isYoutube = false;
            } else if (image.includes("youtube")) {
              $scope.imageshowloader = false;

              image.replace("watch?v=", "embed/");
              var linkB = image.substring(image.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("Ext", linkB, linkB2[0]);
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }
          $scope.selectedQuestionImage = image;
          $scope.selectedAnswerImage = image;
          console.log($scope.selectedQuestionImage);

          $scope.selectedQuestion = question;
          $scope.displayQuestion = true;
        };
        $scope.viewAnswer = function (question, image) {
          $scope.viewAddManager();

          $scope.containsLinks = false;
          console.log(question.answers[0], "Answer");
          $scope.answerObj = question.answers[0];
          if ($scope.answerObj.answer_media_link) {
            console.log($scope.answerObj.answer_media_link, "upaaa link");
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;

            var ext = $scope.selectedAnswerImage.substring(
              $scope.selectedAnswerImage.indexOf("v=") + 2
            );
            var ext2 = ext.split("&");
            $scope.ytID = ext2[0];
            console.log("Ext", ext, ext2[0]);

            console.log($scope.selectedAnswerImage, "up link");
          } else {
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;
          }
          $scope.selectedQuestionImage = $scope.answerObj.answer_media_link;
          if ($scope.selectedAnswerImage != null) {
            if (
              $scope.selectedAnswerImage.includes("mp4") ||
              $scope.selectedAnswerImage.includes("webm")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = false;
              $scope.isPDF = false;
            } else if ($scope.selectedAnswerImage.includes("youtube")) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else if (
              $scope.selectedAnswerImage.includes("pdf") ||
              $scope.selectedAnswerImage.includes("docx") ||
              $scope.selectedAnswerImage.includes("docs") ||
              $scope.selectedAnswerImage.includes("txt") ||
              $scope.selectedAnswerImage.includes("xls") ||
              $scope.selectedAnswerImage.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }

          console.log($scope.selectedQuestionImage, "Image");
          console.log($scope.selectedAnswerImage, "up link");

          // $scope.selectedQuestion = $scope.answerObj.answer_text ;
          $scope.selectedQuestion = $scope.formatTextforLink(
            $scope.answerObj.answer_text
          );
          $scope.displayAnswer = true;
        };
        $scope.uploadProgress = 0;
        $scope.uploadImage = function (file, userId) {
          return new Promise(function (resolve, reject) {
            Upload.upload({
              url: env.backendService +
              "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
              userId,
              method: "POST",
              file: file,
              params: { userId: userId },
            }).then(
              function (resp) {
                $scope.uploadProgress = 100;
                resolve(resp.data);
              },
              function (resp) {
                swal(
                  {
                    title: "Uploading Error",
                    text: "File Not Uploaded. Try Again",
                    type: "error",
                    showCancelButton: false,
                  },
                  function () {
                    swal.close();
                  }
                );
                reject(new Error("ERROR IN UPLOADING IMG 2"));
              },
              function (evt) {
                var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
                if(progressPercentage > 80) {
                  $scope.uploadProgress = 80;
                } else {
                  $scope.uploadProgress = progressPercentage;
                }
              }
            );
          });
        };
        $scope.onImageSelected = function (event, type) {
          console.log("EVENTS", event);
          $scope.imgUploaded = false;

          $scope.selectedImageAnswer = event.target.files[0];
          console.log($scope.selectedImageAnswer, "size");
          $scope.fileName = $scope.selectedImageAnswer.name;

          if (
            $scope.selectedImageAnswer.type.includes("mp4") ||
            $scope.selectedImageAnswer.type.includes("webm")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              32553838;
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = false;
            $scope.isPDF = false;
          } else if (
            $scope.selectedImageAnswer.type.includes("application/pdf") ||
            $scope.selectedImageAnswer.type.includes("xls") ||
            $scope.selectedImageAnswer.type.includes("excel") ||
            $scope.selectedImageAnswer.type.includes("docs") ||
            $scope.selectedImageAnswer.type.includes("docx") ||
            $scope.selectedImageAnswer.type.includes("csv") ||
            $scope.selectedImageAnswer.type.includes("application/msword") ||
            $scope.selectedImageAnswer.type.includes(
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ) ||
            $scope.selectedImageAnswer.type.includes("openxmlformats")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = true;
          } else {
            if ($scope.selectedImageAnswer.size > 4000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = false;
          }
          $scope.$apply();
          //   FormDataa()
          if (type === "page_image") {
            $scope.pageImageLoading = true;
          } else {
            $scope.imageLoad = true;
          }
          $scope.$apply();
          var fd = new FormData();
          fd.append("file", $scope.selectedImageAnswer);
          $scope.uploadImage($scope.selectedImageAnswer, $scope.instID).then(
            function (resp) {
              console.log("up resp", resp);
              if (resp.success) {
                if (type === "page_image") {
                  $scope.result.pageImgLink = resp.link;
                  $scope.pageImageLoading = false;
                } else {
                  $scope.uploadedImgLink = resp.link;
                  $scope.selectedAnswerImage = resp.link;
                  $scope.imageLoad = false;
                }
                $scope.$apply();
                $scope.selectedImageAnswer = null;
                $scope.uploadProgress = 0;
              }
            },
            function errorCallback(response) {
              console.log("ERROR RESP", response);
              $scope.imageLoad = false;
              $scope.pageImageLoading = false;
              $scope.uploadProgress = 0;
              return response;
            }
          );
        };
        $scope.youtubePreview = function (event) {
          console.log(event, "yt img link");
          setTimeout(function () {
            var ytLink = event.target.value;

            if (ytLink.includes("http://youtu.be/")) {
              ytLink.replace(
                "http://youtu.be/",
                "http://www.youtube.com/embed/"
              );
              var linkB = ytLink.substring(ytLink.indexOf(".be/") + 4);
              var linkB2 = linkB.split("?");
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            } else {
              ytLink.replace("watch?v=", "embed/");
              var linkB = ytLink.substring(ytLink.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            }
            $scope.$apply();
          }, 100);
        };
        $scope.sendAnswer = function (ansText, link) {
          var body = {
            checked_assignment_file: $scope.selectedAnswerImage
              ? $scope.selectedAnswerImage
              : $scope.result.markedAssignmentLink,
            result: $scope.result,
            assignment_id: $scope.selectedQuestionToAnswer.id,
            status: "draft",
          };
          if (
            !$scope.result.remarks  ||
            !$scope.result.total_marks ||
            !$scope.result.obtained_marks
          ) {
            return swal({
              title: "Error",
              text: "All fields are required",
              type: "error",
            });
          }

          if (
            !$scope.selectedAnswerImage && !$scope.result.markedAssignmentLink
          ) {
            return swal({
              title: "Error",
              text: "Please Attach marked PDF or add marked assignment link",
              type: "error",
            });
          }

          updateStatus(body).then(function (res) {
            if (res && res.success) {
              swal(
                {
                  title: "Assignment Answer Submitted",
                  text: "Assignment Answer is successfully Submitted.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeAnswerWindow();
                  $scope.answerQuestion = false;
                  $scope.asnwerText = "";
                  $scope.uploadedImgLink = "";
                  $scope.selectedQuestionToAnswer = "";
                  $scope.videoLink = "";
                  $scope.$apply();
                  swal.close();
                  $scope.getAllQuestions();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in assignement submittion",
                type: "error",
              });
            }
          });
        };
        $scope.previewEnlargedImage = function (image) {
          console.log("Image", image);
          $scope.previewImage = image;
          $scope.imagePreview = true;
          $scope.displayQuestion = false;
        };
        $scope.formatTextforLink = function (text) {
          console.log("in format text", text);
          if (!text) return text;
          var newText = text.replace(/(https?:\/\/[^\s]+)/g, function (url) {
            $scope.containsLinks = true;

            return (
              '<a target="_blank" style="margin-bottom: 5px;" href="' +
              url +
              '"' +
              ">" +
              url +
              "</a>"
            );
          });
          console.log("in formatted text", newText);

          return newText;
        };
        $scope.closeQuestion = function () {
          // $scope.displayQuestion = false;
          $scope.selectedQuestionImage = null;
          $scope.videoLink = "";
          $scope.selectedAnswerImage = false;
          $scope.displayQuestion = false;
          $scope.displayAnswer = false;
          $scope.notAvideo = true;
          $scope.imageshowloader = false;
          $scope.isYoutube = false;

          $scope.viewRemoveManager();
        };
        $scope.handleOptions = function () {
          $scope.showOptions = !$scope.showOptions;
        };
        $scope.uploadLink = function (link) {
          console.log(link, "yt");

          if (link.includes("watch?v=")) {
            link.replace("watch?v=", "embed/");
            $scope.selectedImageAnswer = link;
          }
          console.log(link);

          $scope.uploadedImgLink = link;
          $scope.notAvideo = false;
          $scope.isYoutube = true;
          $scope.isPDF = false;
          // $scope.$apply();
        };
        $scope.selectUploadType = function (type) {
          console.log("TYPE UPLOAD", type);
          $scope.defaultDropDown = type;

          if (type === "Assignment Link") {
            $scope.fileUploadSelected = false;
            $scope.linkUpload = true;
          } else {
            $scope.fileUploadSelected = true;
            $scope.linkUpload = false;
            $scope.isYoutube = false;
          }
          $scope.handleOptions();
        };
        $scope.closePreviewImage = function (type) {
          // $scope.previewImage = "";
          $scope.imagePreview = false;
          if ($scope.questionPopup) {
            $scope.displayQuestion = true;
          } else {
            $scope.displayAnswer = true;
          }
        };
        sr.trustSrc = function (src) {
          console.log(src, "sssssssource");
          return $sce.trustAsResourceUrl(
            "https://www.youtube.com/embed/" + src
          );
        };
      },
    ]);
})();

(function() {
	'use strict';

	angular
	.module('NearPeer')

	.controller('InstructorPanelAllCoursesController', ['$scope', '$http', '$state', 'CustomStorageService','instructorPanelService', 'HttpService', function($scope, $http, $state, CustomStorageService,instructorPanelService, HttpService) {
		$(document).ready(function(){
			$(this).scrollTop(0);
		});
		$scope.invalidName = [{
			message:"Name should be alphanumeric ",
			flag:false
		},
		{
			message:"Name already exist ",
			flag:false
		}
	];

		$scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();
		$scope.showData = true;
		$scope.ipEditPopup = false;

		$scope.initialize = function(){
			$scope.showData = true;
		}
		
		$scope.initializeData = function (id) {
			$scope.appendingStringVideos = []
				// $scope.showData = false;
				$scope.currentDate = new Date();
				$scope.editingCourse = true;
				var id = id;
				$http({
					url: 'api/v1/courses/getCourseById',
					method: "GET",
					params: { id: id, instructor_id: instructorPanelService.getInstructorId() }
				}).then(function (data) {
					if (data.data.success) {
						$scope.selectedCourse = data.data.course;
						$scope.VVSStatus = data.data.VVSStatus;
						$scope.modulesList = $scope.selectedCourse.modules;
						if($scope.selectedCourse.discountTo) {
							$scope.selectedCourse.discountTo = new Date($scope.selectedCourse.discountTo).toLocaleString();
						} 
						if($scope.selectedCourse.discountFrom) {
							
							$scope.selectedCourse.discountFrom = new Date($scope.selectedCourse.discountFrom).toLocaleString();
							
						}
						if (!$scope.selectedCourse.courseFeature) {
							$scope.selectedCourse.courseFeature = [];
						}
						if ($scope.selectedCourse.terms.length > 0) {
							for (var i in $scope.selectedCourse.terms) {
								$scope.selectedCourse.terms[i].sdate = new Date($scope.selectedCourse.terms[i].sdate);
								$scope.selectedCourse.terms[i].edate = new Date($scope.selectedCourse.terms[i].edate);
							}
						}
						getSelectedTag();
						// $scope.showData = true;
						$scope.checkUploadStatus(false);
					} else {
						$state.go('InstructorPanelDashboard')
					}
				});
		}

		$scope.goToNewCoursePage = function(){
			if(instructorPanelService.getNoFaculty()){
				swal('Oops..','Please add a faculty to add new course','error');
				$state.go('InstructorPanelMyProfile',{},{reload:true});
			} else {
				$state.go('InstructorPanelCourseNew',{},{reload:true});
			}
		}

		$scope.goToEditCoursePage = function(id){
			$state.go('InstructorPanelCourseEdit',{id:id},{reload:true});
		}
		$scope.ipEditPopupBtn = function($event,id){
			$event.stopPropagation();
			$scope.initializeData(id);
			$scope.ipEditPopup = true;
		}
		$scope.ipEditPopupClose = function(){
			$scope.ipEditPopup = false;
		}

		$scope.deleteCourse = function(id,index,$event){
			$event.stopPropagation();
			var data = {id:id};
			swal({
				title: 'Warning',
				text: 'Are you sure you send delete request to super admin?',
				type: 'warning',
				showCancelButton: true
			},function(isConfirm){
				if(isConfirm){
					$scope.showData = false;
					$http.post('api/v1/courses/delete-course-request', data)
					.then(function(data) {
						$scope.showData = true;
						if(data.data.success){
							setTimeout(function () {
								swal({
									title: "Course delete request sent to super admin",
									type: "success",
									timer: 1500,
									showConfirmButton: false
								}, function() {
									swal.close();
								});
							}, 500)
							
						} else {
							instructorPanelService.tryAgainSwal();
						}
					});
				}
			});
		}
		$scope.saveData = function (form) {
			form.institution = instructorPanelService.getSelectedInstitution();
			form.faculty = instructorPanelService.getSelectedFaculty();
			form.index_url = createIndexUrl(form);
			$scope.validateName(form.name);
			if($scope.invalidName[0].flag || $scope.invalidName[1].flag) {1
				return false
			}
			
			if (!$scope.editingCourse) {		
				if (form.institution == 'Chartered Accountancy Final' || form.institution == 'chartered accountancy final') {
					form.special = true;
				} else {
					form.special = false;
				}
				if (!form.recurring) {
					form.recurring = false;
				}
				if (!form.image_url) {
					form.image_url = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png';
				}

				if (!validateCourseForm(form)) {
					return false;
				}
				if(form.discount_price) {
					if(!form.discountTo) {
						return false;
					}
					if(!form.discountFrom) {
						return false;
					}
					
					if(!instructorPanelService.compareDates(form.discountFrom, form.discountTo)){
						return false;
					}
				}
				$scope.showData = false;
				form['instructor_id'] = CustomStorageService.getUserInfoStorageData().id;
				$http.post('api/v1/courses/createCourse', { course: form, instructor_id: CustomStorageService.getUserInfoStorageData().id })
					.then(function (data) {
						$scope.showData = true;
						if (data.data.success) {
							swal({
								title: "Success",
								text: "Course Successfully Created",
								type: "success",
							});
							$state.go('InstructorPanelAllCourses', {}, { reload: true });
						} else {
							instructorPanelService.tryAgainSwal();
						}
					});
			} else {
				if (!validateTerms(form.terms)) {
					return false;
				}

				if (!validateCourseForm(form)) {
					return false;
				}

				if (form.institution == 'Chartered Accountancy Final' || form.institution == 'chartered accountancy final') {
					form.special = true;
				} else {
					form.special = false;
				}
				if(form.discount_price) {
					if(!form.discountTo) {
						return false;
					}
					if(!form.discountFrom) {
						return false;
					}
					
					if(!instructorPanelService.compareDates(form.discountFrom, form.discountTo)){
						return false;
					}
				}

				$scope.showData = false;
				var data = { course: form };
				$http.post('api/v1/courses/updateCourse', data).then(function (data) {
					$scope.showData = true;
					if (data.data.success) {
						instructorPanelService.successUpdateSwal();
						$state.go('InstructorPanelAllCourses',{}, { reload: true });
					} else {
						instructorPanelService.tryAgainSwal();
					}
				});
			}
		}
		var validateCourseForm = function (form) {
			if (!form.name || !form.description || !form.institution || !form.index_url || !form.faculty || !form.image_url) {
				swal('Error', 'Please fill in all fields', 'error');
				return false;
			}
			if (form.paid) {
				if (form.price == null) {
					swal('Error', 'Please enter valid price', 'error');
					return false;
				} else if (form.price < -1) {
					swal('Error', 'Please enter valid price', 'error');
					return false;
				}
			}
			return true;
		};
		var createIndexUrl = function (form) {
			var coursee = form.name.toLowerCase();
			var institution = form.institution.toLowerCase();
			institution = institution.split(' ').join('-');
			var faculty = form.faculty.toLowerCase();
			faculty = faculty.split(' ').join('-');
			coursee = coursee.split(/[^a-zA-Z0-9]/g).join("-");
			coursee = coursee.split(/[\-]+/g).join("-");
			coursee = coursee.split(/^-|-$/).join("");
			return institution + '/' + faculty + '/' + coursee;
		}
		$scope.validateName = function(name) {
			var pattern=/^[a-zA-Z0-9()\s]+$/;
			HttpService.getRequest('api/v1/courses/search',{key:name,contains:false})
			.then(function(res){						
				if(res.courses.length === 0) {
					$scope.invalidName[1].flag = false;
				} else if($scope.editingCourse && res.courses.length === 1){
					$scope.invalidName[1].flag = false;
				} else {
					$scope.invalidName[1].flag = true;
				}
			})
			if(name.match(pattern)) {
				$scope.invalidName[0].flag = false;
			} else {
				$scope.invalidName[0].flag = true;
				
			}

		}
		var validateTerms = function (terms) {
			if (terms.length > 0) {
				for (var i in terms) {
					if (!terms[i].term || !terms[i].sdate || !terms[i].edate) {
						swal('Oops..', 'Please fill in all term fields', 'error');
						return false;
					}
					if(!instructorPanelService.compareDates(terms[i].sdate, terms[i].edate)){
						return false;
					}
				}
			}
			return true;
		}

		$scope.$on('instructorUpdatedFaculty',function(){
			$scope.showData = false;
			$scope.instructor_courses = instructorPanelService.getSelectedCourses();
			$scope.showData = true;
		})

		$scope.addFaculties = function(){
			$http.post('api/v1/instructors/addAllFaculties')
			.then(function(data){

			});
		}

		if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
			$state.go('instructor_signin',{},{reload:true});
		} else {
			$scope.initialize();
		}

	}]);
})();

(function () {
	'use strict';

	angular
    .module('NearPeer')
    .controller('videoPopupController', [
	'$scope',
	'$http',
	'CustomStorageService',
	'$rootScope',
	'$state',
	'$sails',
	'$timeout',
	MainController,
]);

	function MainController(
    $scope,
    $http,
    CustomStorageService,
    $rootScope,
    $state,
    $sails,
    $timeout
  ) {
		$scope.videojs = false;
		$scope.vimeoPlayer_ = false;
		$scope.fromQuestions = false;

		$(document).ready(function () {
			$(this).scrollTop(0);
			console.log($scope.video,'link');
			if(typeof $scope.video === "object"){
				$scope.videojs = $scope.video.vss_id ? false : true;

	
			}else{
				$scope.fromQuestions = true;

				$scope.videojs = false;
			}
      //   $scope.vimeoPlayer_ = $scope.video.vss_id ? true : false;
		});

		$scope.$on('$destroy', function () {
			console.log('destroying');
			$scope.videojs = false;
			var oldPlayer = document.getElementById('example-video');
			videojs(oldPlayer).dispose();

		});


		angular.element(document).ready(function () {
			var date = new Date();
			var isPlaying = false;
			var monthNames = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			$scope.stamp = monthNames[date.getMonth()] + '-' + date.getFullYear();
			var player = videojs('example-video', {
				controlBar: {
					pictureInPictureToggle: false,
				},
			});
			player.controlBar.playToggle.on('tap', function (e) {
				e.preventDefault();
				$scope.play_pause();
			});
			player.qualityLevels();
			player.seekButtons({
				forward: 15,
				back: 15,
			});
			player.maxQualitySelector({
				defaultQuality: 1,
			});
			player.on('progress', function () {
				var duration = player.duration();
				var currentTime = player.currentTime();
				var bufferedPercent = player.bufferedPercent() * 100;

				var bufferTime = (duration / 100) * bufferedPercent;
				if (bufferTime > 10) {
					if (!isPlaying && currentTime === 0) {
						player.pause();
						setTimeout(function () {
							isPlaying = true;
							player.play();
						}, 1000);
					}
				} else {
					isPlaying = false;
				}
			});

			$scope.loader = true;
			$scope.showData = false;
			$scope.rate = '1x';
			$scope.playbackVal = 1;
			$scope.playbackOpt = false;
			$scope.loadPercentage = 0;
			$scope.playCount = 0;

			document.getElementById('playBtn').style.display = 'none';
			document.getElementById('pauseBtn').style.display = 'block';
			var isFirst = true;
			var qualities = $scope.video.vss_urls;
			$scope.qualityLevels = player.qualityLevels();
			if (this.isVss) {
				qualities = qualities.sort(function (a, b) {
					return a.width - b.width;
				});
				this.vimeoVideoQualities = qualities;
				qualities.forEach(function (ele, i) {
					$scope.qualityLevels.addQualityLevel({
						id: ele.public_name + '---' + i,
						width: ele.width,
						height: ele.height,
						bitrate: 250,
						enabled: function (t) {
							return true;
						},
					});
				});
			}

			if (!$scope.videojs) {
				if($scope.fromQuestions){

					player.src({
						src: $scope.video,
						type: 'video/mp4',
					});				
				}else{
					player.src({
						src: qualities[0].link,
						type: 'video/mp4',
					});
				}
		
			} else {
	
					player.src({
						src: '/get_video_content?video_url=' + $scope.fromQuestions,
						type: 'application/dash+xml',
					});
	
			
			}

      //   await this.ontimeUpdate();
			var isFirst = true;

			videojs.Hls.xhr.beforeRequest = function (options) {
				options.headers = options.headers || {};
				if (isFirst) {
					options.headers['X-Requested-With'] = 'XMLHttpPlayerRequest';
				} else {
					options.headers['X-Requested-With'] =
            'XMLHttpPlayerRequest-' + options.headers.Range;
				}

				var baseURI = options.uri.split('/');
				if (!isFirst) {
					options.uri = !$scope.videojs
            ? qualities[0].link
            : '/get_video_content?video_url=https://video.nearpeer.org/' +
              baseURI[baseURI.length - 1];
				}
				isFirst = false;
				return options;
			};
      
		});

		$scope.initialize = function () {
			console.log('init');
		};

		$scope.closeForm = function () {
			console.log('close');
			$scope.$emit('closeForm');
		};

    // $scope.initialize();
	}
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('InstructorPanelQuizUserDetailController', ['$scope', '$location', '$state', 'CustomStorageService', '$http', function($scope, $location, $state,CustomStorageService, $http) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.initialize = function() {
      var quiz_id=$state.params.id;
      $http.post('/api/v1/instructors/quiz/alluser',{id:quiz_id})
      .then(function (quizzesResult) {
        $scope.allQuiz=quizzesResult.data.QuizAllResult;
      });
    },
    $scope.viewQuizResult = function(resultId){
      $state.go('result',{resultId:resultId},{reload:true})
    }
    if (!CustomStorageService.getUserSignedInStorageData() && CustomStorageService.getInstructorSignedInStorageData()) {
      $scope.initialize();
    } else{
      swal({
        title: "Unauthorized",
        text: "Please sign in to view your account",
        type: "error"
      }, function (){
        $scope.$emit('showLoginPopup');
      });
    }
  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('outComeQuizController', ['$scope', '$location', '$state', 'CustomStorageService', '$http', '$filter', function($scope, $location, $state,CustomStorageService, $http,$filter) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    var tempQuestion;
    $scope.questionNumbers = {};
    $scope.initialize = function() {
      $scope.quiz_id=$state.params.id;
      $http.post('/api/v1/instructors/quiz/outCome',{id:$scope.quiz_id})
      .then(function (quizzesOutCome) {
            $scope.quiz=quizzesOutCome.data.outCome;
            tempQuestion=$scope.quiz.questions;
            $scope.totalQuestions =  $scope.quiz.questions.length;
            var no = 1;
            for(var i in $scope.quiz.questions) {
              var key = $scope.quiz.questions[i].id;
              $scope.questionNumbers[key] =no;
              no++;
            }
            $scope.quiz.questions = $filter('orderBy')($scope.quiz.questions, 'count/1',true);
            for(var i in $scope.quiz.questions) {
              $scope.quiz.questions[i].wrong=$scope.quiz.total_attempts-$scope.quiz.questions[i].count; 
              if($scope.quiz.questions[i].options){
                var options = $scope.quiz.questions[i].options;
                for(var x in options){
                  $scope.mathCreator('math-field-opt'+i+x,options[x]);
                }
              }
              if($scope.quiz.questions[i].mathtext){
                var data = $scope.quiz.questions[i].mathtext;
                if(data!=='' && data!=='null'){
                  if(!data.match(/\\\s/g)) {
                    data =data.replace(/\s+/g,'\\ ');
                  }
                  $scope.mathCreator('math-field-question'+i,data); 
                }
              }
              if($scope.quiz.questions[i].solution){
                var data = $scope.quiz.questions[i].solution;
                if(data!=='' && data!=='null'){
                  if(!data.match(/\\\s/g)) {
                    data =data.replace(/\s+/g,'\\ ');
                  }
                  $scope.mathCreator('math-field-sol'+i,data); 
                }
              }       
            }
            $scope.getColors();
      });
    }
    $scope.getColors = function() {
      for(var i in $scope.quiz.questions){
        if(i==0) {
          $scope.quiz.questions[i].backgroundColor = 'rgb(179, 255, 255)';
        } else if(i==$scope.quiz.questions.length-1) {
          $scope.quiz.questions[i].backgroundColor = 'rgb(255, 133, 102)';
        }
      }
    }
    $scope.mathCreator =  function(id,data) {
			setTimeout(function(){
				var mathFieldSpan = document.getElementById(id);
				var MQ = MathQuill.getInterface(2);
					var mathField = MQ.MathField(mathFieldSpan, {
						spaceBehavesLikeTab: true,
						handlers: {
							edit: function() {
								data=mathField.latex();
							}
						}
					});
					mathField.write(data);
			},100)
		}
    $scope.sorting = function(index) {
      if(index=='order') {
          $scope.quiz.questions=tempQuestion;
      } else {
          $scope.quiz.questions = $filter('orderBy')($scope.quiz.questions, index,true);
      }
    }
    if (!CustomStorageService.getUserSignedInStorageData() && CustomStorageService.getInstructorSignedInStorageData()) {
      $scope.initialize();
    } else{
      swal({
        title: "Unauthorized",
        text: "Please sign in to view your account",
        type: "error"
      }, function (){
        $scope.$emit('showLoginPopup');
      });
    }
  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('coursesQuizzesController', ['$scope', '$location', '$state', 'CustomStorageService', '$http', function($scope, $location, $state, CustomStorageService, $http) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.offset = 0;
    $scope.initialize = function() {
      var instructor_id = CustomStorageService.getUserInfoStorageData().id;
      $http.post('/api/v1/instructors/quizzes',{id:instructor_id, offset:$scope.offset})
      .then(function (quizzesResult) {
        $scope.instructorQuiz=quizzesResult.data.instructorQuiz;
        if(!$scope.instructorQuiz){
          $scope.showPrevious();
        }
      });
    }
    $scope.showNext = function() {
      $scope.offset = $scope.offset+15;
      $scope.initialize();
    }
    $scope.showPrevious = function() {
      if($scope.offset!==0){
        $scope.offset = $scope.offset-15;
        $scope.initialize();
      }
    }
    if (!CustomStorageService.getUserSignedInStorageData() && CustomStorageService.getInstructorSignedInStorageData()) {
      $scope.initialize();
    } else{
      swal({
        title: "Unauthorized",
        text: "Please sign in to view your account",
        type: "error"
      }, function (){
        $scope.$emit('showLoginPopup');
      });
    }
  }]);
})();

(function() {
  'use strict';
  angular
    .module('NearPeer')
    .controller('DuplicateVideoController', ['$scope', '$http', 'CustomStorageService', 'env', function($scope, $http, CustomStorageService, env) {

      $scope.source = {
        courses: [],
        modules: [],
        videos: [],
        course: null,
        module: null,
        video: null
      };

      $scope.destination = {
        courses: [],
        modules: [],
        course: null,
        module: null,
        chapters: [],
        chapter: null
      };

      $scope.selectedVideos = [];

      var getAllCourses = function() {
        $http({
          url: 'api/v1/courses/getAllCourses',
          method: 'GET'
        }).then(function(response) {
          $scope.source.courses = response.data.courses;
        });
        // Fetch instructor's courses for destination (by id)
        var instructorId = CustomStorageService.getUserInfoStorageData().id;
        $http({
          url: 'api/v1/courses/getInstructorCoursesById',
          method: 'GET',
          params: { instructor: instructorId }
        }).then(function(response) {
          $scope.destination.courses = response.data.courses;
        });
      };

      $scope.getModulesForSource = function(courseId) {
        if (!courseId) return;
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: 'GET',
          params: { id: courseId }
        }).then(function(response) {
          $scope.source.modules = response.data.modules;
          $scope.source.videos = [];
        });
      };

      $scope.getVideosForSource = function(moduleId) {
        if (!moduleId) return;
        $http({
          url: 'api/v1/cvideos/getModuleVideos',
          method: 'GET',
          params: { module_id: moduleId }
        }).then(function(response) {
          $scope.source.videos = response.data.videos;
        });
      };
      
      $scope.getModulesForDest = function(courseId) {
        if (!courseId) return;
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: 'GET',
          params: { id: courseId }
        }).then(function(response) {
          $scope.destination.modules = response.data.modules;
          $scope.destination.chapters = [];
          $scope.destination.chapter = null;
        });
      };

      $scope.getChaptersForDest = function(moduleId) {
        if (!moduleId) return;
        $http({
          url: '/api/v1/chapter/getChapterByModuleId',
          method: 'GET',
          params: { id: moduleId }
        }).then(function(response) {
          $scope.destination.chapters = response.data.chapters || [];
          $scope.destination.chapter = null;
        });
      };

      $scope.addVideo = function(video) {
        if (video && $scope.selectedVideos.indexOf(video) === -1) {
          $scope.selectedVideos.push(video);
        }
        $scope.source.video = null;
      };

      $scope.removeVideo = function(index) {
        $scope.selectedVideos.splice(index, 1);
      };

      $scope.duplicateVideos = function() {
        var videoIds = $scope.selectedVideos.map(function(v) { return v.id; });
        var chapterId = null;
        if ($scope.destination.chapters && $scope.destination.chapters.length > 0) {
          if (!$scope.destination.chapter) {
            alert('Please select a chapter for the destination module.');
            return;
          }
          chapterId = $scope.destination.chapter.id;
        }
        var payload = {
          videoIds: videoIds,
          targetModuleId: $scope.destination.module.id,
          targetCourseId: $scope.destination.course.id,
          targetChapterId: chapterId
        };

        // I am assuming this is the API endpoint to duplicate videos.
        // This might need to be changed based on the actual backend implementation.
        $http({
          url: 
          env.backendService
        // 'http://localhost:3007'
           + '/lmsservice/v1/cvideos/duplicate',
          method: 'POST',
          data: payload
        }).then(function(response) {
          if (response.data.success) {
            alert('Videos duplicated successfully!');
            $scope.selectedVideos = [];
            $scope.source.video = null;
          } else {
            alert('Error duplicating videos: ' + response.data.message);
          }
        }).catch(function(error) {
          alert('An API error occurred.');
          console.error('Duplicate videos error:', error);
        });
      };

      getAllCourses();
    }]);
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('AdminHeaderController', ['$scope','$state','CustomStorageService', function($scope,$state,CustomStorageService) {
    var name;
    var sr = $scope;
    if(CustomStorageService.getUserInfoStorageData()){
      var userData = CustomStorageService.getUserInfoStorageData();
      name = userData.name || userData.full_name;
    } else {
      $state.go('admin_panel',{},{reload:false});
    }
    sr.getInitial = function() {
      return name.charAt(0).toUpperCase();
    }
    sr.logOut = function(){
      CustomStorageService.logOutService('admin_logout');
      swal({
        title: "Log Out Successful!",
        type: "success",
        confirmButtonText: "Ok",
        timer: 2000,
        showConfirmButton: false
      },function() {
        swal.close();
        $state.go('admin_panel',{},{reload:false});
      });
    }

  }]);
})();

(function() {
  'use strict';
  angular
    .module('NearPeer')
    .controller('getCourseCotroller', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope) {

      var sr = $scope;

      // Fetch institutions on load
      var getInsitutions = function() {
        $http({
          url: 'api/v1/courses/getUniversityList',
          method: "GET",
          params: { type: 'admin' }
        }).then(function(data) {
          sr.institutions = data.data;
          sr.selectedInstitution = "Select Institution";
        });
      }();

      // Update faculties when an institution is selected
      sr.updateInstitution = function(institute) {
        sr.selected_faculty = sr.institutions[institute].faculties;
        sr.selectedInstituteNo = institute;
        sr.selectedFaculty = null; // Reset faculty selection
        sr.courses = []; // Reset courses
        sr.modules = []; // Reset modules
        sr.selectedModule = null; // Reset module selection
      };

      // Update courses when a faculty is selected
      sr.updateSchool = function(school) {
        sr.selectedFaculty = school;
        sr.courses = [];
        sr.modules = [];
        sr.selectedModule = null; // Reset module selection
        getCourses();
      };

      // Fetch courses based on selected institution & faculty
      var getCourses = function() {
        if (!sr.selectedInstitution || !sr.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }

        var data = {
          institution: sr.institutions[sr.selectedInstituteNo].institution,
          faculty: sr.selectedFaculty,
          admin: true
        };

        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if (data.data.success) {
            sr.courses = data.data.courses;
          } else {
            console.error("Error fetching courses");
          }
        });
      };

      // Function to handle course selection and fetch modules
      sr.updateCourse = function(courseIndex) {
        var selectedCourse = sr.courses[courseIndex];
      
        if (!selectedCourse || !selectedCourse.id) {
          console.error("Invalid course selection");
          return;
        }
      
        sr.selectedCourse = selectedCourse;
        sr.modules = [];
        sr.selectedModule = null;
      
        console.log("Selected Course:", sr.selectedCourse);
      
        $http({
          url: 'api/v1/courses/getModulesByCourseId',
          method: "GET",
          params: { id: selectedCourse.id }
        }).then(function(response) {
          if (response.data.modules && response.data.modules.length > 0) {
            sr.modules = response.data.modules;
            console.log("Modules fetched:", sr.modules);
          } else {
            console.warn("No modules found for the selected course.");
            sr.modules = [];
          }
        }).catch(function(error) {
          console.error("API error:", error);
          sr.modules = [];
        });
      
        // Emit only the selected course (not modules yet)
        sr.$emit('getCourse', selectedCourse);
      };
      
      

      
      // Function to handle module selection
//     sr.updateCourseModules = function(selectedModuleId) {
//   console.log("Selected Module ID:", selectedModuleId);

//   if (!sr.selectedCourse) {
//     console.error("No course selected before selecting a module.");
//     return;
//   }

//   // Find the full module object by ID
//   var selectedModule = sr.modules.find(m => m.id === selectedModuleId);
//   if (!selectedModule) {
//     console.error("Invalid module selection");
//     return;
//   }

//   console.log("Selected Module:", selectedModule);

//   // Ensure `modules` exists inside `selectedCourse`
//   if (!sr.selectedCourse.modules) {
//     sr.selectedCourse.modules = [];
//   }

//   // Check if the module is already added
//   var moduleIndexInArray = sr.selectedCourse.modules.findIndex(m => m.id === selectedModule.id);

//   if (moduleIndexInArray === -1) {
//     sr.selectedCourse.modules.push({ ...selectedModule, selected: true });
//     console.log("Module added:", sr.selectedCourse.modules);
//   } else {
//     sr.selectedCourse.modules.splice(moduleIndexInArray, 1);
//     console.log("Module removed:", sr.selectedCourse.modules);
//   }

//   // Emit only when a module is selected/deselected
//   sr.$emit('getModule', sr.selectedCourse.modules, sr.selectedCourse.id);
// };
sr.updateCourseModules = function(selectedModuleId) {
  console.log("Selected Module ID:", selectedModuleId);

  if (!sr.selectedCourse) {
    console.error("No course selected before selecting a module.");
    return;
  }

  // Find the full module object by ID (using a loop instead of .find)
  var selectedModule = null;
  for (var i = 0; i < sr.modules.length; i++) {
    if (sr.modules[i].id === selectedModuleId) {
      selectedModule = sr.modules[i];
      break;
    }
  }

  if (!selectedModule) {
    console.error("Invalid module selection");
    return;
  }

  console.log("Selected Module:", selectedModule);

  // Ensure `modules` exists inside `selectedCourse`
  if (!sr.selectedCourse.modules) {
    sr.selectedCourse.modules = [];
  }

  // Check if the module is already added (using a loop instead of .findIndex)
  var moduleIndexInArray = -1;
  for (var i = 0; i < sr.selectedCourse.modules.length; i++) {
    if (sr.selectedCourse.modules[i].id === selectedModule.id) {
      moduleIndexInArray = i;
      break;
    }
  }

  if (moduleIndexInArray === -1) {
    // Equivalent of `{ ...selectedModule, selected: true }`
    var newModule = Object.assign({}, selectedModule, { selected: true });

    sr.selectedCourse.modules.push(newModule);
    console.log("Module added:", sr.selectedCourse.modules);
  } else {
    sr.selectedCourse.modules.splice(moduleIndexInArray, 1);
    console.log("Module removed:", sr.selectedCourse.modules);
  }

  // Emit only when a module is selected/deselected
  sr.$emit('getModule', sr.selectedCourse.modules, sr.selectedCourse.id);
};
      
    }]);
})();



(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('customFormController', MainController);

  function MainController($scope, $rootScope, $state, $attrs, $http, $filter, $sails, paymentService, CustomStorageService) {
    
    var fbRender;
    var renderForm = function() {
      var fbRender = document.getElementById("fb-render");
      if($scope.form && $scope.form.form_data && $scope.form.form_data.length > 0) {
        var formData = $scope.form.form_data;
        $(fbRender).formRender({ formData: formData });
      }
      
    }
    if(!$rootScope.formDone) {
      renderForm();
    }

    $scope.saveData = function() {
      $rootScope.formDone = true;
      var data = $(fbRender).formRender("userData");
      var body = {
        form_id: 1,
        form_result: data,
      }
      $http.post('/api/v1/custom-form/submit-data', body)
      .then(function (data) {
        $scope.$emit("hide-custom-form");
        swal({
          title: 'Form Submitted',
          text: "Form Submitted Successfully!",
          type: 'success',
          showConfirmButton: false,
          timer: 2000,
        }, function () {
            swal.close();
        });
      });
    }
  }

})();
 
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('courseTileController', MainController);

  function MainController($scope, $rootScope,$attrs,$http,courseDetailService, CustomStorageService) {
    var sr = $scope;
    sr.freeOnAppPopup = false;
    sr.isReactApp = $rootScope.platform_reactApp;
    var today = new Date();
    $scope.showLoginText = false;
    var userData = CustomStorageService.getUserInfoStorageData();
    if(!userData&& $rootScope.platform_reactApp) {
      $scope.showLoginText = true;
    }
    sr.goToCourse = function(course){      
       mixpanel.track('Course-Page',{
        'Course_Name' : course.name,
        'Course_ID' : course.id,
        'Course_Index URL' : course.index_url,
        
      });
      courseDetailService.goToCourse(course);
    }
    sr.validDiscount = function(to,from) {
      
      if(new Date(to) > today && new Date(from) <= today) {
        return true;
      } else {
        return false;
      }

    }
    sr.freeOnAppPopupBtn = function($event){
      $event.stopPropagation();
      // console.log('free on app popup value', sr.freeOnAppPopup);
      // sr.freeOnAppPopup = true;
      this.freeOnAppPopup=!this.freeOnAppPopup;
    }
  }
})();



(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('courseInculdeController', MainController);

  function MainController($scope, $sce) {
    var sr = $scope;
    $scope.courseTitleAV = false;
    sr.isInstallmentAllowed = true;
    sr.buyNow = function (course, type) {
      ttq.track('AddToCart')
      if(type === 'qist-pay') {
        sr.$broadcast('salesPopup-qist');
      } else {
        sr.$broadcast('salesPopup');
      }
      
    }

    sr.isFree = function () {
      if (sr.course) {
        if (sr.course.modules) {
          if(sr.course.discount_price && sr.course.discount_price <= 1500) {
            sr.isInstallmentAllowed = false;
          } else if(sr.course.price <= 1500) {
            sr.isInstallmentAllowed = false;
          }
          var total_count = sr.course.modules.length;
          var freeCnt = 0;
          var paidCnt = 0;
          if (sr.course.price === null) {
            return true;
          } else {
            for (var i in sr.course.modules) {
              if (sr.course.modules[i].module_type.free) {
                freeCnt++;
              }
              else if (sr.course.modules[i].module_type.purchased) {
                paidCnt++;
              }
            }
            if (freeCnt == total_count) {
              return true;
            }
            else if ((paidCnt + freeCnt) == total_count) {
              return true;
            } else if (sr.course.coursePurchased) {
              return true;
            } else {
              return false;
            }
          }
        } else if (sr.course.module_type) {
          if(sr.course.module_type.free){
            return true;
          } else if(sr.course.coursePurchased) {
            return true;
          }
          if(sr.course.module_type.discount && sr.course.module_type.discount <= 1500) {
            sr.isInstallmentAllowed = false;
          } else if(sr.course.module_type.price <= 1500) {
            sr.isInstallmentAllowed = false;
          }
        } else if (sr.course.coursePurchased) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    sr.trustSrc = function (src) {
      return $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + src);
    }
    $("#courseVideoDemo").on('hidden.bs.modal', function (e) {
      $("#courseVideoDemo iframe").attr("src", $("#courseVideoDemo iframe").attr("src"));
    });
    $scope.$on('$stateChangeStart', function (event) {
      if ($('#courseVideoDemo').is(':visible')) {
        event.preventDefault();
        $('#courseVideoDemo').modal('toggle');
      }
    });
    // var courseIncludeText = document.getElementById("appendHere");
    // var node = document.getElementById("courseIncludeMobile");
    // node.append(courseIncludeText);
    // var testAV = node.append(courseIncludeText);
    // console.log('sdfasdfasdj;ljo', testAV); 

    
    $scope.courseIncludeDD = function(){
      console.log('ads ------ working')
      $scope.courseTitleAV = true;
    }
    $scope.courseIncludeDDClose = function(){
      $scope.courseTitleAV = false;
    }
  }

})();


(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('courseHeaderController', MainController);


  function MainController($scope,$attrs,$http,CustomStorageService, $rootScope) {
    var sr = $scope;
    sr.isReactApp = $rootScope.platform_reactApp;
    sr.freeOnAppPopup = false;
    $scope.numLimit = 100;
    $scope.readMoreBtn = "Read more";
    sr.alternative_desc = "This online course will accelerate your learning using video lectures, online classroom groups, & test discussions with tips and tricks. Study anytime, anywhere, with Pakistan’s best teachers.";
    $scope.isGuest = false;
    $scope.showLoginText = false;
    var getEnrollment = function(courseId) {
      $http({
        url: 'api/v1/course/enrollments',
        method: "GET",
        params: {
          courseId:courseId,
        }
      }).then(function(data){
        sr.enrolled = data.data.count;
        
      });
    }
    sr.$on('getCourseEnrolled', function(event, message) {     
      getEnrollment(message);
    });
	 var userData = CustomStorageService.getUserInfoStorageData();
   if(userData) {
    if(userData.user_type === "guest"){
      $scope.isGuest = true;
    }
  }
  if(!userData && $rootScope.platform_reactApp) {
    $scope.showLoginText = true;
  }

    $scope.readMore = function (length) {
      if ($scope.readMoreBtn === "Read more") {
        $scope.readMoreBtn = "Read less";
        $scope.numLimit = length;
      } else if ($scope.readMoreBtn === "Read less") {
        $scope.readMoreBtn = "Read more";
        $scope.numLimit = 50;
      }

    };
    sr.freeOnAppPopupBtn = function($event){
      $event.stopPropagation();
      // console.log('free on app popup value', sr.freeOnAppPopup);
      // sr.freeOnAppPopup = true;
      this.freeOnAppPopup=!this.freeOnAppPopup;
    }
  }
})();



(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('courseCartController', MainController);

  function MainController($scope, $rootScope, $sce,CustomStorageService, $state, $location) {
    var sr = $scope;
    // $scope.courseTitleAV = false;
    sr.isInstallmentAllowed = true;
    $scope.isGuest = false;
    $scope.showLoginText = false;

	 var userData = CustomStorageService.getUserInfoStorageData();
    if(userData) {
      if(userData.user_type === "guest"){
        $scope.isGuest = true;
      }
    }
    $scope.$on("trigger-order-popup", function (event, meesage) {
      sr.$broadcast('salesPopup');
    })

    if(!userData && $rootScope.platform_reactApp) {
      $scope.showLoginText = true;
    }
    sr.buyNow = function (course, type) {
      mixpanel.track('Course-Buy', {
        "Course_ID": course.id,
        "Course_Name": course.name,
      })
      if($rootScope.orderEmailVerify && !$rootScope.orderEmailVerified) {
        sr.$emit('verify-before-order');
      } else {
        if($state.current.name === "Course") {
          $state.go('CourseBuy', $state.params, {notify: false});
        } else if($state.current.name === "course_module") {
          $state.go('course_module_buy', $state.params, {notify: false});
        }
        setTimeout(function() {
          gtag('set', 'page_path', $location.path());
          gtag('event', 'page_view');
        }, 500);
        ttq.track('AddToCart')
        if(type) {
          sr.$broadcast('salesPopup-qist', {type: type});
        } else {
          sr.$broadcast('salesPopup');
        }
      }
    }

    sr.isFree = function () {
      if (sr.course) {
        if (sr.course.modules) {
          if(sr.course.discount_price && sr.course.discount_price <= 1500) {
            sr.isInstallmentAllowed = false;
          } else if(sr.course.price <= 1500) {
            sr.isInstallmentAllowed = false;
          }
          var total_count = sr.course.modules.length;
          var freeCnt = 0;
          var paidCnt = 0;
          if (sr.course.price === null) {
            return true;
          } else {
            for (var i in sr.course.modules) {
              if (sr.course.modules[i].module_type.free) {
                freeCnt++;
              }
              else if (sr.course.modules[i].module_type.purchased) {
                paidCnt++;
              }
            }
            if (freeCnt == total_count) {
              return true;
            }
            else if ((paidCnt + freeCnt) == total_count) {
              return true;
            } else if (sr.course.coursePurchased) {
              return true;
            } else {
              return false;
            }
          }
        } else if (sr.course.module_type) {
          if(sr.course.module_type.free){
            return true;
          } else if(sr.course.coursePurchased) {
            return true;
          }
          if(sr.course.module_type.discount && sr.course.module_type.discount <= 1500) {
            sr.isInstallmentAllowed = false;
          } else if(sr.course.module_type.price <= 1500) {
            sr.isInstallmentAllowed = false;
          }
        } else if (sr.course.coursePurchased) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    sr.trustSrc = function (src) {
      if(src) {
        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + src);
      } else {
        return src;
      }
    }
    $("#courseVideoDemo").on('hidden.bs.modal', function (e) {
      $("#courseVideoDemo iframe").attr("src", $("#courseVideoDemo iframe").attr("src"));
    });
    $scope.$on('$stateChangeStart', function (event) {
      if ($('#courseVideoDemo').is(':visible')) {
        event.preventDefault();
        $('#courseVideoDemo').modal('toggle');
      }
    });

    var courseIncludeText = document.getElementById("appendHere");
    var node = document.getElementById("courseIncludeMobile");
    if(node && courseIncludeText) {
      node.append(courseIncludeText);
      var testAV = node.append(courseIncludeText);
      console.log('sdfasdfasdj;ljo', testAV);
    }
 


    $scope.courseIncludeDD = function(){
      $scope.courseTitleAV = true;
    }
    $scope.courseIncludeDDClose = function(){
      $scope.courseTitleAV = false;
    }
  }

})();


(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('courseBlockController', MainController);

  function MainController($scope, $attrs, $http, $filter, $sails, paymentService, CustomStorageService) {
    var sr = $scope;
    sr.sortingOrder = "name"
    sr.reverse = false;
    sr.$on('caFilter', function (event, message) {
      sr.sortingOrder = message;
      if (message == "name") {
        sr.reverse = false;
      }
      else {
        sr.reverse = true;
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('addToCartController', MainController);

  function MainController($scope, $rootScope, $state, $attrs, $http, $filter, $sails, paymentService, CustomStorageService) {
    var sr = $scope;
    sr.salePopupDiv = false;
    sr.couponBalance = 0;
    var couponUsed;
    var attributes = {};
    var isQistpay = false;
    $scope.showCouponGif = false;
    sr.appliedCoupon;
    var inializer = function () {
      $scope.$watch('myVar', function () {
        couponUsed = false;
        sr.couponMsg = "";
        sr.userBalance = 0;
        sr.couponBalance = 0;
        sr.showJazzCashPopup = false;
        attributes = {
          user_balance: 0,
          coupon_balance: 0,
          coupon_id: null,
          items: [],
          discount_price: 0,
          price: null,
          total: null,
          user_id: null,
          type: null,
          socket_id: CustomStorageService.getSocketIdStorageData(),
          origin: window.location.origin
        };

        console.log('popup-open');
        sr.salePopupDiv = true;
        attributes.user_id = CustomStorageService.getUserInfoStorageData().id;
        attributes.type = "";
        if (sr.course.course_id) {
          attributes.items.push({
            course_id: sr.course.course_id,
            module_id: sr.course.id,
            bundle_id: null
          });
          if (sr.course.module_type.discount > 0) {
            attributes.discount_price = sr.course.module_type.discount;
            sr.total = sr.course.module_type.discount;
            sr.coursePrice = sr.course.module_type.discount;
          } else {
            sr.total = sr.course.module_type.price;
            sr.coursePrice = sr.course.module_type.price;
          }
          attributes.price = sr.course.module_type.price;
          attributes.type = "module";

        } else if (sr.course.bundle) {
          attributes.items = sr.course.courses;
          if (sr.course.discount_price) {
            attributes.discount_price = sr.course.discount_price;
            sr.total = sr.course.discount_price;
            sr.coursePrice = sr.course.discount_price;
          } else {
            sr.total = sr.course.price;
            sr.coursePrice = sr.course.price;
          }
          attributes.price = sr.course.price;
          attributes.type = "bundle";
        } else {

          attributes.items.push({
            course_id: sr.course.id,
            module_id: null,
            bundle_id: null
          });
          if (sr.course.discount_price > 0) {
            attributes.discount_price = sr.course.discount_price;
            sr.total = sr.course.discount_price;
            sr.coursePrice = sr.course.discount_price;
          } else {
            sr.total = sr.course.price;
            sr.coursePrice = sr.course.price;
          }
          attributes.price = sr.course.price;
          attributes.type = "course";
        }
        sr.couponToggle = false;

        fbq('track', 'AddToCart', {
          content_ids: attributes.type.charAt(0).toUpperCase() + sr.course.id,
          content_type: attributes.type,
          value: sr.total,
          currency: 'pkr',
          content_name: sr.course.name,
        });
        try{
          dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          dataLayer.push({
            'event': 'add-to-cart-page',
            'ecommerce': {
              'currencyCode': 'PKR',                       // Local currency is optional.
              'click': {
                'id': sr.course.id,
                'productType': attributes.type,
                'price': sr.total,
                'name': attributes.type == 'module' ? 'module ' + sr.course.name + ' of course ' + sr.course.course_id : sr.course.name,
                'orderType': 'Self-Purchase',
                'brand': 'Nearpeer',
                'instName': sr.course.institution
              }
            
            }
          })
        }catch(err){
          console.log('error in datalayer->', err);
        }

      });

    }

    
    sr.getUserBalance = function () {

      var user_id = { user_id: attributes.user_id };


      $http.post('api/v1/users/balance', user_id)
        .then(function (res) {
          if (sr.total > 0 && sr.userBalance === 0) {
            var userCredit = res.data.credit;
            if (userCredit > 0 && userCredit < sr.total) {
              sr.userBalance = userCredit;
              sr.total = sr.total - userCredit;
            } else if (userCredit > 0 && userCredit >= sr.total) {
              sr.userBalance = sr.total;
              sr.total = 0;
            } else if (userCredit <= 0) {
              sr.couponMsg = "You do not have enough balance.";
            }
          }
          else if (sr.userBalance > 0 && status) {
            sr.total = sr.total + sr.userBalance;
            sr.userBalance = 0;
            sr.couponMsg = "";
          } else if (sr.userBalance > 0) {
            sr.couponMsg = "";
          } else if (sr.total === 0) {
            sr.couponMsg = "Your total already zero";
          }
        }, function (res) {
        });
    }
    sr.closePopup = function () {
      if($state.current.name === "CourseBuy") {
        $state.go('Course', $state.params, {notify: false});
      } else if($state.current.name === "course_module_buy") {
        $state.go('course_module', $state.params, {notify: false});
      }
      setTimeout(function() {
        gtag('set', 'page_path', $location.path());
        gtag('event', 'page_view');
      }, 500);
      sr.salePopupDiv = false;
      console.log("popup-close");
      console.log("close-webview");
    }
    sr.checkEnrollAndBuy = function () { 
      if(sr.enrolled) {
        sr.buyNow()
      } else {
        var data = { user_id: CustomStorageService.getUserInfoStorageData().id, course_id: sr.course.id, time: new Date() };
          $http.post('api/v1/enrolledstudents/enrollCourse', data)
          .then(function (data) {
            if (data.data.success) {
              sr.buyNow()
              sr.enrolled = true;
            }
          });
      }
    }

    sr.couponApplied = function (couponCode) {
      console.log("🚀 ~ file: addToCartController.js:185 ~ MainController ~ couponCode:", couponCode)
      sr.couponSuccess = "";
      sr.couponMsg = "";
      if(couponCode) {
        if (sr.total > 0) {
          if (sr.couponBalance === 0) {

            if (couponCode && !couponUsed) {

              $http({
                url: 'api/v1/coupons/getCouponByID',
                method: "POST",
                params: { id: couponCode, user_id: attributes.user_id, course_id: attributes.items[0].course_id, module_id: attributes.items[0].module_id }
              }).then(function (coupon) {
                if (coupon.data.success) {
                  if (coupon.data.coupon.price >= sr.total) {

                    sr.couponBalance = sr.total;
                    sr.total = 0;
                    sr.isCoupon = true;
                    attributes.coupon_id = coupon.data.coupon.id;
                    if(coupon.data.coupon.unlimited){
                      sr.couponSuccess = 'Coupon Applied!';
                        couponUsed = true;
                      $scope.showCouponGif = true;
                      ttq.track('SubmitForm');
                      sr.appliedCoupon = couponCode;
                      setTimeout(function() {
                        $scope.showCouponGif = false;
                        sr.buyNow();
                      }, 3000) 
                    }
                  } else if (coupon.data.coupon.price < sr.total) {
                    couponUsed = true;
                    sr.couponBalance = coupon.data.coupon.price;
                    sr.total = sr.total - coupon.data.coupon.price;
                    attributes.coupon_id = coupon.data.coupon.id;
                    if(coupon.data.coupon.unlimited){
                      sr.couponSuccess = 'Coupon Applied!';
                      couponUsed = true;
                      $scope.showCouponGif = true;
                      sr.appliedCoupon = couponCode;
                      ttq.track('SubmitForm');
                      setTimeout(function() {
                        $scope.showCouponGif = false;
                        sr.buyNow();
                      }, 1300)
                    }
                  }
                } else {
                  couponUsed = false;
                  sr.couponMsg = coupon.data.message;
                }
              }, function errorCallback(response) {
                sr.couponMsg = "Try again later";
              });
            } else {
              sr.couponMsg = "Please enter valid promo code";
            }
          } else {
            sr.couponMsg = "Only one coupon you can use";
          }

        } else {
          sr.couponMsg = "Your total balance is already zero";
        }
      } else {
        sr.buyNow();
        console.log('asdfe');
      }
    }

    sr.buyNow = function () { 
      mixpanel.track('Order-Proceed', {
        "Course_ID": sr.course.id,
        "Course_Name": sr.course.name,
        "Course_Coupen": sr.couponSuccess ? sr.couponSuccess : null,
        "Course_Coupen_ID": sr.appliedCoupon ? sr.appliedCoupon : null,
      })
      var ifModule = 0;
      console.log("popup-close");
      if(sr.course.course_id && sr.course.module_no){ ifModule = 1;}
      if(sr.course.bundle ){ ifModule = 2; }
      if(attributes.coupon_id) {
        $state.go('orderDetailsCoupon', {course_id: attributes.items[0].course_id, module_id: attributes.items[0].module_id ? attributes.items[0].module_id : 0,instructorId: sr.course.bundle ? sr.course.name : sr.course.instructor_id.id,ifModule:ifModule, couponId: sr.appliedCoupon, total: sr.total, couponAmount: sr.couponBalance, isQistpay: isQistpay});
      } else {
        $state.go('orderDetails', {course_id: attributes.items[0].course_id, module_id: attributes.items[0].module_id ? attributes.items[0].module_id : 0,instructorId: sr.course.bundle ? sr.course.name : sr.course.instructor_id.id,ifModule:ifModule, total: sr.total, isQistpay: isQistpay});
      }
    }
    $sails.on('jazzCashEvent', function (data) {
      if (sr.jazzData && sr.jazzData.billreference === data.pp_BillReference) {
        fbq('track', 'Purchase', {
          content_ids: attributes.type.charAt(0).toUpperCase() + sr.course.id,
          content_type: attributes.type,
          value: attributes.discount_price || attributes.price,
          currency: 'pkr',
          content_name: sr.course.name,
          num_items: attributes.items.length,
        });
        gtag('event', 'conversion', {
          send_to: 'AW-829926847/lqV9CPqYvoUBEL_b3osD',
          value: attributes.discount_price || attributes.price,
          currency: 'PKR',
          transaction_id: sr.jazzData.billreference
        });
        gtag('event', 'purchase', {
          transaction_id: sr.jazzData.billreference,
          value: attributes.discount_price || attributes.price,
          currency: "PKR",
          items: [
            {
              sku: sr.course.id,
              id: sr.course.id,
              name: sr.course.name,
              brand: "NearPeer",
              price: attributes.discount_price || attributes.price,
            }
          ]
        });
        paymentService.handleJazzCashResponse(data, attributes.user_id);
      }else {
        paymentService.handleJazzCashResponse(data, attributes.user_id);
      }
    });
    sr.$on('salesPopup', function (event, message) {
      if (!CustomStorageService.getUserSignedInStorageData()) {
        swal({
          title: "Error",
          text: "Please login to purchase!",
          type: "error"
        }, function (confirm) {
          $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
          sr.$emit('showLoginPopup');
        })
        sr.coursePurchase = true;
        return;
      } else {
        inializer();
      }
    });
    sr.$on('salesPopup-qist', function (event, message) {
      if (!CustomStorageService.getUserSignedInStorageData()) {
        swal({
          title: "Error",
          text: "Please login to purchase!",
          type: "error"
        }, function (confirm) {
          $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
          sr.$emit('showLoginPopup');
        })
        sr.coursePurchase = true;
        return;
      } else {
        inializer();
        isQistpay = message.type;
      }
    });
  }

})();
 
(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("breadCrumbsController", MainController);

  function MainController($rootScope, $scope, BreadcrumbService) {
    $scope.list = [];
    $scope.show = false;

    $rootScope.$on("route_updated", function (event) {
      $scope.show = true;
      $scope.list = BreadcrumbService.getBreadCrumb().list;
      // $scope.$apply();
      // $rootScope.$apply();
    });

    if(BreadcrumbService.getBreadCrumb()) {
      $scope.show = true;
      $scope.list = BreadcrumbService.getBreadCrumb().list;
    }
    

  }
})();

(function() {
    'use strict';
  
  
    angular
    .module('NearPeer')
  
    .controller('seprateBlogsPanelController', ['$scope','Upload','$timeout', '$http', '$state', 'CustomStorageService', '$sails', function($scope, Upload, $timeout, $http, $state, CustomStorageService, $sails) {
      $scope.moduleCount = 1;
      $scope.blog = {};
      $scope.category = {};
      $scope.blogCategories = [];
      // $scope.bundle = {};
      // $scope.bundle['courses'] = [];
      // $scope.bundle['price'] = 0;
      $scope.blog['images'] = [];
      $scope.blog['category_id'] = '0';
      $scope.files_ = [];
      $scope.modules = [];
      $scope.videoForm = false;
      $scope.socket = null;
      $scope.signedIn = CustomStorageService.getBlogerSignedInStorageData();
      $scope.collapseCourseRow =  false;
      $scope.collapseModuleRow = false;
      $scope.showModuleEForm = false;
      $scope.selModule = 0;
      $scope.coupon_record_no = 20;
      $scope.module_record_no = 20;
      $scope.credit_record_no = 20;
      $scope.user_record_no = 20;
      $scope.firstTimeCoupons = 1;
      $scope.firstTimeCredits = 1;
      $scope.firstTimeModules = 1;
      $scope.firstTimeUsers = 1;
      $scope.sortReverse = false;
      $scope.sortType = 1;
      $scope.sortTypeModule = 1;
      $scope.sortTypeCredit = 1;
      $scope.responsePopup = false;
      $scope.createInstructorForm = false;
      $scope.instructorList = false;
      if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('BlogsPanel',{},{reload:true});
      }
      $scope.initialize = function() {
        $sails.get('/api/v1/sockets/setSocket')
        .then(function(resp){
          CustomStorageService.setSocketIdStorageData(resp.data.socketId);
        })
        $scope.createCourseForm = {};
        $scope.createCourseForm.instructor = CustomStorageService.getUserInfoStorageData().full_name;
        $scope.createCourseForm.live_date = new Date();
  
  
        $http({
          url:'api/v1/courses/getUniversityList',
          method:"GET",
          params: {type: 'admin'}
        }).then(function (data) {
          $scope.institutions = data.data;
          $scope.selectedInstitution = "Select Institution";
        });
      };
  
      $scope.showModuleForm = function() {
        $scope.courseFormFlag = true;
        $scope.course_form = true;
        var module = {};
        module.moduleNo = $scope.moduleCount;
        $scope.module_map[module.moduleNo] = module;
        $scope.moduleCount++;
        $scope.modules.push(module);
      };
  
      $scope.showCourseForm = function() {
        $scope.hideAll();
        $scope.courseFormFlag = true;
        $scope.createCouponForm = {};
        $scope.module_map = {};
      };
  
      $scope.$watch('files', function () {
        $scope.upload($scope.files);
      });
  
      $scope.$watch('file', function () {
        if ($scope.file != null) {
          $scope.files = [$scope.file];
        }
      });
  
      $scope.logs = {};
      $scope.image_log = '';
      $scope.upload = function (files, event, flow, module) {
        var total_files = 0;
        if (files && files.length) {
          module.files_ = [];
          module.logs = {};
          module.total_files = 0;
          module.failed_files = [];
          for (var i = 0; i < files.length; i++) {
            var file = files[i].file;
            $scope.upload_alternate(file, module);
          }
        } else {
          if (files) {
            swal({
              title: "Error!",
              text: "Files alreay uplaoded. Try uploading another folder!",
              type: "error",
              confirmButtonText: "Ok"
            });
          }
        }
      };
  
      $scope.upload_alternate = function(file, module) {
        if (!file.$error && file.type.indexOf('video/') > -1) {
          module.files_.push(file);
          module.total_files += 1;
          module.show_logs = true;
          module.logs[file.name] = {name: 'Uploading to server: \n'+file.name, progress: 0};
          var data = {userId: CustomStorageService.getUserInfoStorageData().id, moduleNo: module.moduleNo, file: file.name};
          Upload.upload({
            url: '/upload',
            method: 'POST',
            file: file,
            params: data
          }).then(function (resp) {
            module.logs[resp.config.file.name] = {name: 'Uploading to server: \n'+resp.config.file.name, progress: 100};
          }, function (resp) {
            module.failed_files.push(file);
            module.total_files -= 1;
            if (module.total_files <= 0) {
              swal({
                title: "Error!",
                text: "Some files were not uploaded.",
                type: "error",
                showCancelButton: true,
                confirmButtonText: "Retry",
                cancelButtonText: "Cancel"
              }, function(confirm) {
                if (confirm) {
                  var files = angular.copy(module.failed_files);
                  $scope.retry_upload(files, module);
                  module.failed_files = [];
                }
              });
            }
          }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            module.logs[evt.config.file.name] = {name: 'Uploading to server: \n'+evt.config.file.name, progress: progressPercentage};
          });
        }
      };
  
      $scope.retry_upload = function(files, module) {
        module.total_files = 0;
        module.files_ = [];
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          $scope.upload_alternate(file, module);
        }
      };
  
      $scope.createModule = function() {
        if (!$scope.module.name || !$scope.module.short_description ||
          !$scope.module.description || (!$scope.module.module_type.paid && !$scope.module.module_type.free)
          || ($scope.module.module_type.paid && !$scope.module.module_type.price)) {
            swal({
              title: "Error!",
              text: "Make sure you have filled all fields and checked Free or Paid option",
              type: "error",
              confirmButtonText: "Ok"
            });
            return;
          }
          if (!$scope.modules) {
            $scope.modules = [];
          }
          if (!$scope.module.image_url) {
            $scope.module.image_url = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png';
          }
          $scope.module_imageUploaded = false;
          $scope.logs = {};
          $scope.modules.push($scope.module);
          $scope.showModuleFlag = false;
          $scope.createCourseFlag = true;
          $scope.course_form = true;
        };
  
  
        $scope.revertbtn = function() {
  
          var id = $scope.selectedCourse.id;
          swal({
            title: "Are you sure to revert transcoding button?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes !",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                $http.post('api/v1/cvideo/revertPreviousTranscodingBtn',{course_id:id})
                .then(function (data) {
                  if (data.data.success){
                    $scope.selectedCourse.previous_high_quality = false;
                  }
                });
              }
            });
          };
          $scope.convertVideoHD = function() {
            var id = $scope.selectedCourse.id;
            swal({
              title: "Are you sure to transcode?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, submit it!",
              closeOnConfirm: true},
              function(isConfirm){
                if(isConfirm) {
                  $http({
                    url: 'api/v1/cvideo/PreviousVideosTranscode',
                    method: "GET",
                    params: {id:id }
                  }).then(function(data) {
                    $scope.selectedCourse.previous_high_quality = true;
                  });
                }
              });
            };
  
            $scope.convertVideoVimeo = function() {
              var id = $scope.selectedCourse.id;
              swal({
                title: "Are you sure to convert all video to vimeo?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, submit it!",
                closeOnConfirm: true},
                function(isConfirm){
                  if(isConfirm) {
                    $http.post('http://localhost:3000/v1/videos/migrate-to-vimeo', {course_id: id}).then(function(data) {
                      swal({
                        title: "Uploding to Vimeo started",
                        type: "success",
                      }, function() {});
                    });
                  }
                });
              };
  
            $scope.courseOrderTermination = function() {
              var id = $scope.selectedCourse.id;
              swal({
                title: "Are you sure to terminate Access for this course?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, submit it!",
                closeOnConfirm: true},
                function(isConfirm){
                  if(isConfirm) {
                    $http({
                      url: 'api/v1/orders/course/terminate',
                      method: "GET",
                      params: {id:id }
                    }).then(function(data) {
                      // $scope.selectedCourse.previous_high_quality = true;
                    });
                  }
                });
              };
  
            $scope.createCourse = function() {
              if (!$scope.createCourseForm.special){
                $scope.createCourseForm.special = false;
              }
              if (!$scope.createCourseForm.name || !$scope.createCourseForm.description
                || !$scope.createCourseForm.institution || !$scope.createCourseForm.faculty
                || !$scope.createCourseForm.instructor) {
                  swal({
                    title: "Error!",
                    text: "Make sure you have filled all fields",
                    type: "error",
                    confirmButtonText: "Ok"
                  });
                  return;
                }
  
                if (!$scope.createCourseForm.image_url) {
                  $scope.createCourseForm.image_url = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png';
                }
                $scope.loader = true;
                var coursee = $scope.createCourseForm.name.toLowerCase();
                var institution = $scope.createCourseForm.institution.toLowerCase();
                institution = institution.split(' ').join('-');
                var faculty = $scope.createCourseForm.faculty.toLowerCase();
                faculty = faculty.split(' ').join('-');
                coursee = coursee.split('-').join('');
                coursee = coursee.split('  ').join(' ')
                coursee = coursee.split(' ').join('-');
                $scope.createCourseForm.index_url = institution + '/' + faculty + '/' + coursee;
  
                $http.post('api/v1/courses/createCourse', {course: $scope.createCourseForm})
                .then(function (data) {
                  $scope.loader = false;
                  swal({
                    title: "Course Successfully Created",
                    type: "success",
                  }, function() {
                    $scope.createCourseForm = {};
                    $scope.modules = [];
                    $scope.course_imageUploaded = false;
                    $scope.module_imageUploaded = false;
                    $scope.module_map = {};
                    location.reload();
                  });
                });
                $scope.moduleCount = 1;
              };
  
              $scope.uploadImage = function(file, type) {
                if (file) {
                  //imageUploadInProgress
                  Upload.upload({
                    url: '/api/v1/uploader/uploadImageToS3',
                    method: 'POST',
                    file: file,
                    params: {userId:CustomStorageService.getUserInfoStorageData().id}
                  }).then(function (resp) {
                    if(type == 'newCourseImage'){
                      $scope.createCourseForm.image_url = resp.data.link;
                    } else if(type == 'editCourseImage') {
                      $scope.selectedCourse.image_url = resp.data.link;
                    } else if(type == 'newModuleImage'){
                      $scope.selectedModule.image_url = resp.data.link;
                    } else if(type == 'editModuleImage') {
                      $scope.selectedModule.image_url = resp.data.link;
                    } else if (type === 'blogImage') {
                      $scope.blog.images.push({url: resp.data.link });
                      if (!$scope.$$phase) $scope.$apply();
                    } else if (type === 'blogBanner') {
                      $scope.blog.image= resp.data.link ;
                    } else if (type === 'blogCategoryImage') {
                      $scope.category.image_url = resp.data.link ;
                    }
                    
                    //  else if (type === 'bundleImage') {
                    //   $scope.bundle.image_url= resp.data.link ;
                    // }
                  });
                }
              };
  
              $scope.cancelModule = function() {
                $scope.showModuleFlag = false;
                $scope.module_imageUploaded = false;
                $scope.files_uploaded = false;
                $scope.show_logs = false;
                $scope.image_log = {};
                $scope.module = {};
                $scope.logs = {};
                $scope.files_ = [];
                $scope.course_form = true;
              };
              $scope.showCouponForm = function() {
                $scope.hideAll();
                $scope.coupon_form_flag = true;
              };
  
              $scope.createCoupons = function() {
                if (!$scope.createCouponForm.quantity || !$scope.createCouponForm.price) {
                  swal({
                    title: "Error!",
                    text: "Make sure you have filled all fields",
                    type: "error",
                    confirmButtonText: "Ok"
                  });
                  return;
                }
                $scope.coupon_button = true;
                $http.post('api/v1/coupons/createCoupons', $scope.createCouponForm)
                .then(function (data) {
                  $scope.downlod_csv(data.data);
                  $scope.createCouponForm = {};
                  $scope.coupon_button = false;
                });
              };
  
              $scope.showCoupons = function(page,type) {
                $scope.responsePopup = true;
                $scope.hidePagination = false;
                var data = {page: page,per_page: $scope.coupon_record_no,type:type};
                $scope.hideAll();
                $scope.show_coupons = true;
                if (!$scope.total_coupon_pages) {
                  $scope.responsePopup = false;
                  $scope.total_coupon_pages = 1;
                }
                if (page > 0 && page < $scope.total_coupon_pages+1) {
                  $scope.page = page;
                  $http({
                    url: 'api/v1/coupons/showCoupons',
                    method: "GET",
                    params: data
                  }).then(function(data) {
                    $scope.responsePopup = false;
                    $scope.coupons = data.data.coupons;
                    $scope.total_coupon_pages = data.data.total_pages;
                    $scope.total_coupons = data.data.total_count;
                  });
                } else if (page < 1) {
                  $scope.responsePopup = false;
                  page = 1;
                } else if (page > $scope.total_coupon_pages) {
                  $scope.responsePopup = false;
                  page = $scope.total_coupon_pages;
                }
              };
              $scope.showUsers = function(page, type_, search_query) {
                $scope.hideAll();
                $scope.responsePopup = true;
                $scope.show_users = true;
                if (!$scope.total_users_pages) {
                  $scope.total_users_pages = 1;
                }
                if (page > 0 && page < $scope.total_users_pages+1) {
                  $scope.page = page;
                  var data = {page: page,per_page:$scope.user_record_no};
                  if (type_) {
                    $scope.type_ = type_;
                    $scope.search_query = search_query;
                    data['type'] = type_;
                    data['search_query'] = search_query;
                  }
                  $http({
                    url: 'api/v1/users/getUsersData',
                    method: "GET",
                    params: data
                  }).then(function(data) {
                    $scope.responsePopup = false;
                    $scope.users = data.data.users;
                    $scope.total_users_pages = data.data.total_pages;
                    $scope.total_users = data.data.total_count;
                  });
                } else if (page < 1) {
                  page = 1;
                  $scope.responsePopup = false;
                } else if (page > $scope.total_users_pages) {
                  page = $scope.total_users_pages;
                  $scope.responsePopup = false;
                }
              };
  
              $scope.showCourses = function(page) {
                $scope.hideAll();
                $scope.show_courses = true;
                if (!$scope.total_course_pages) {
                  $scope.total_course_pages = 1;
                }
                if (page > 0 && page < $scope.total_course_pages+1) {
                  $scope.page = page;
                  var data = {page: page};
                  /*$http({
                  url: 'api/v1/courses/show_courses',
                  method: "GET",
                  params: data
                }).then(function(data) {
                $scope.courses = data.data.courses;
                $scope.total_course_pages = data.data.pagination.total;
              });*/
            } else if (page < 1) {
              page = 1;
            } else if (page > $scope.total_course_pages) {
              page = $scope.total_course_pages;
            }
          };
  
          $scope.hideAll = function() {
            // $scope.jazzCashOrdersDashboard = false;
            $scope.showBlogComments = false;
            $scope.showCreateBlogCategoryForm = false;
            $scope.show_blog_categories = false;
            $scope.showEditBlogForm = false;
            $scope.showCreateBlogForm = false;
            $scope.enrolledStudentsTable = false;
            $scope.addNewQualityVideo = false;
            $scope.loadVideo = false;
            $scope.instructorList = false;
            $scope.createInstructorForm = false;
            $scope.listModules = false;
            $scope.collapseNewModuleRow = false;
            $scope.newModuleForm = false;
            $scope.showModuleEForm = false;
            $scope.collapseModuleRow = false;
            $scope.collapseCourseRow = false;
            $scope.courseFormFlag = false;
            $scope.showModuleFlag = false;
            $scope.coupon_form_flag = false;
            $scope.show_coupons = false;
            // $scope.show_module_transactions = false;
            // $scope.show_credit_transactions = false;
            $scope.show_users = false;
            $scope.show_courses = false;
            $scope.videoForm = false;
            $scope.addNewModule = false;
            // $scope.addNewBundle = false;
            // $scope.showBundle = false;
  
          };
          $scope.UpdateCourse = function(course,qualities) {
            var coursee = course.name.toLowerCase();
            var institution = course.institution.toLowerCase();
            institution = institution.split(' ').join('-');
            var faculty = course.faculty.toLowerCase();
            faculty  = faculty.split(' ').join('-');
            coursee = coursee.split('-').join('');
            coursee = coursee.split('  ').join(' ')
            coursee = coursee.split(' ').join('-');
            course.index_url = institution + '/' + faculty + '/' + coursee;
            course.qualities = qualities;
            var data = {course: course,id:course.id};
            $http.post('api/v1/courses/updateCourse', data).then(function(data) {
              if(data.data.success){
                alert('Successfully Updated');
                location.reload();
              }
            });
          };
  
  
          $scope.downlod_csv = function(data) {
  
            var csv = 'CouponId,Price,Created At\n';
            data.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-people.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          }
  
          $scope.showVideoManagement = function(){
            $scope.hideAll();
            $scope.videoForm = true;
            $scope.module_map = {};
          }
  
  
  
  
  
  
  
          $scope.downloadEnrollment = function(course) {
  
            var courseId = $scope.allCourses[course].id
            $http({
              url: 'api/v1/enrolledstudents/getEnrolledStudents',
              method:"GET",
              params:{course_id: courseId,forDownload:true}
            }).then(function(data){
              if(!data.data.success){
                alert(data.data.message);
                $scope.studentsExist = false;
              } else {
                var enrolledStudents = data.data.students;
                var csv = 'User Id,Name,Email,Joining Date,crn,phone,university,city,dob,Mail,Journey\n'
                enrolledStudents.forEach(function(row) {
                            csv += row.join(',');
                            csv += '\n';
                        });
                        var parent = document.getElementById('download_csv');
                        var hiddenElement = document.createElement('a');
                        parent.appendChild(hiddenElement);
                        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                        hiddenElement.target = '_blank';
                        hiddenElement.download = new Date().toUTCString()+'-enrollments.csv';
                        hiddenElement.click();
                        parent.removeChild(hiddenElement);
              }
            });
              }
  
          $scope.updateInstitution = function(institute) {
            $scope.selected_faculty = $scope.institutions[institute].faculties;
            $scope.selectedInstituteNo = institute;
          };
  
          $scope.updateSchool = function(school) {
            $scope.selectedFaculty = school;
            $scope.getCourses();
          };
  
          $scope.getCourses = function() {
            if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
              swal({
                title: "Error!",
                text: "Please select an institution and faculty!",
                type: "error",
                confirmButtonText: "Ok"
              });
              return;
            }
            var data = {
              institution: $scope.institutions[$scope.selectedInstituteNo].institution,
              faculty: $scope.selectedFaculty,
              admin: true
            };
            $http({
              url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
              method: "GET",
              params: data
            }).then(function(data) {
              if(data.data.success) {
                $scope.courses = data.data.courses;
              } else {
                alert('server error');
              }
  
            });
          };
  
          $scope.updateCourse = function(course){
            var id = $scope.courses[course].id;
            $http({
              url: 'api/v1/courses/getModulesByCourseId',
              method: "GET",
              params: {id: id}
            }).then(function(data) {
              $scope.modules = data.data.modules;
            });
          };
  
          $scope.submit = function(module){
            var id;
            for(var i in $scope.modules){
              if($scope.modules[i].name === module){
                id = $scope.modules[i].id;
                break;
              }
            }
            $http({
              url: 'api/v1/cvideos/getModuleVideos',
              method: "GET",
              params: {module_id: id}
            }).then(function(data) {
              $scope.showVideos = true;
              $scope.videos = data.data.videos;
            });
          };
  
          $scope.updateVideoData = function(){
            $scope.loader = true;
            if($scope.selModule == 0){
              for(var i in $scope.modules){
                if($scope.modules[i].name == $scope.selectedModule){
                  $scope.selModule = $scope.modules[i];
                }
              }
            }
            $http.post('api/v1/cvideos/updateVideo', {videos: $scope.videos, module: $scope.selModule})
            .then(function (data) {
              $scope.loader = false;
              if(data.data.success){
  
                alert('Successfully Updated');
                location.reload();
              }
              else{
                alert('There was trouble updating. Please try again');
              }
            });
          };
          $scope.showAddModuleForm = function(){
            $scope.addNewModule = true;
  
          };
          $scope.showMenu = function(){
            if ($('.menu-items').hasClass('nav-hidden')) {
              $('.menu-items').removeClass("nav-hidden").addClass("nav-visible");
              $('.menu').removeClass("btn-hidden").addClass("btn-visible");
              $('.overlay-body').removeClass("active").addClass("active");
            } else {
              $('.menu-items').addClass("nav-hidden").removeClass("nav-visible");
              $('.menu').addClass("btn-hidden").removeClass("btn-visible");
              $('.overlay-body').addClass("active").removeClass("active");
            }
            jQuery(".overlay-body").click(function(){
              jQuery(".cmn-toggle-switch").click();
            });
  
          };
  
          $scope.logOut = function(){
            CustomStorageService.logOutService();
            $state.go('BlogsPanelSignIn',{},{reload:true});
          };
  
          $scope.showCourseEditForm = function(course){
            $http({
              url: 'api/v1/videoQuality/getAllquality',
              method: 'GET'
            }).then(function(data){
              $scope.course_qualities = data.data.qualities;
              $scope.selectedCourse = $scope.courses[course];
              for(var i in $scope.selectedCourse.quality){
                for (var j in $scope.course_qualities) {
                  if($scope.selectedCourse.quality[i].quality_id === $scope.course_qualities[j].id ) {
                    if(!$scope.selectedCourse.quality[i].disabled) {
                      $scope.course_qualities[j].setquality= true;
                    }
                  }
  
                }
              }
              var dt = new Date($scope.selectedCourse.live_date);
              $scope.selectedCourse.live_date = dt;
              $scope.collapseCourseRow = true;
            });
          }
  
          $scope.showModuleEditForm = function(module){
            $scope.selectedModule = module;
            $scope.collapseModuleRow = true;
          };
  
          $scope.updateModuleData = function(module){
            $scope.loader = true;
  
            var data = {module:module,id:module.id};
            $http.post('api/v1/cmodules/updateModule', data).then(function(data) {
              if(data.data.success){
                alert('Successfully Updated');
                location.reload();
              }
              else{
                alert('There was an error updating. Please try again');
              }
              $scope.loader = false;
            });
  
          };
  
          $scope.moduleManagement = function(){
            $scope.hideAll();
            $scope.showModuleEForm = true;
          };
  
          $scope.addModule = function(){
            $scope.hideAll();
            $scope.newModuleForm = true;
          };
  
          $scope.showNewModuleForm = function(){
            $scope.collapseNewModuleRow = true;
            $scope.selectedModule = {};
          };
  
          $scope.addNewModuleData = function(module,selectedCourse){
            $scope.loader = true;
  
            var courseId = $scope.courses[selectedCourse].id;
            var data = {module:module,id:courseId};
            $http.post('api/v1/cmodules/newModule', data).then(function(data) {
              if(data.data.success){
                alert('Module Successfully Added, Please go into Manage Videos to add videos to this module.');
                location.reload();
              }
              else{
                alert('There was an error adding module. Please try again');
              }
              $scope.loader = false;
            });
          };
  
          $scope.showModules = function(){
            $scope.listModules = true;
          };
  
          $scope.disableUser = function(user){
            if (confirm("Do you want to disable this user?") == true) {
              var data = {id:user.id};
              $http.post('api/v1/users/toggleUser', data).then(function(data) {
                if(data.data.success){
                  alert('User Successfully Disabled');
                  var index = $scope.users.indexOf(user);
                  $scope.users[index].disabled = true;
                }
                else{
                  alert('There was an error. Try again.');
                }
              });
            }
          };
  
  
          $scope.deleteModule = function(module,index){
            $scope.loader = true;
            if (confirm("Do you want to delete the module?") == true) {
              var data = {moduleId:module.id};
              $http.post('api/v1/cmodules/deleteModule', data).then(function(data) {
                if(data.data.success){
                  alert('Module Successfully Deleted');
                  $scope.modules.splice(index,1);
                }
                else{
                  alert('There was an error deleting module. Try again');
                }
                $scope.loader = false;
              });
  
            } else {
  
            }
          };
  
          $scope.deleteCourse = function(course){
            $scope.loader = true;
            if (confirm("Do you want to delete the course?") == true) {
              var data = {id:course.id};
              $http.post('api/v1/courses/deleteCourse', data).then(function(data) {
                if(data.data.success){
                  alert('Course Successfully Deleted');
                  location.reload();
                }
                else{
                  alert('There was an error deleting course. Try again');
                }
                $scope.loader = false;
              });
            } else {
  
            }
  
          };
  
          $scope.deleteVideo = function(video){
            $scope.loader = true;
            if(confirm("Do you want to delete this video") == true){
              var data = {id:video.id};
              $http.post('api/v1/cvideos/deleteVideo', data).then(function(data) {
                if(data.data.success){
                  alert('Video Successfully Deleted');
                  var index = $scope.videos.indexOf(video);
                  $scope.videos.splice(index,1);
                }
                else{
                  alert('There was an issue. Try again');
                }
                $scope.loader = false;
              });
            }
          };
  
          $scope.uploadNewVideos = function(files, event, flow, module){
            for(var i in $scope.modules){
              if($scope.modules[i].name == module){
                $scope.selModule = $scope.modules[i];
              }
            }
            $scope.selModule['moduleNo'] = $scope.selModule.module_no;
            $scope.module_map[$scope.selModule.moduleNo] = $scope.selModule;
            $scope.upload(files, event, flow, $scope.selModule);
          };
  
  
          $scope.showMenu();
  
          $scope.searchCouponById = function(coupon_id){
            $scope.hidePagination = true;
            $http({
              url: 'api/v1/coupons/showCoupons',
              method: "GET",
              params: {coupon_id: coupon_id,type: '5'}
            }).then(function(data){
              if(!data.data.success){
                swal({
                  title: "Error",
                  text: "Coupon does not exist",
                  type: "error"
                },function(){
                  $scope.coupons = 0;
                })
              }
              else{
                $scope.coupons = data.data.coupons;
              }
            })
          }
  
          $scope.downloadCouponsCsv = function(){
  
            $http({
              url: 'api/v1/coupons/getAllCoupons',
              method: "GET",
              params: {}
            }).then(function(data){
              $scope.coupon_data = data.data.coupons;
              var csv = 'Id,CouponId,Price,Created At,Status\n';
              $scope.coupon_data.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Coupons.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            })
          }
  
          $scope.$watch('coupon_record_no', function() {
            if($scope.firstTimeCoupons==0){
              $scope.showCoupons(1,$scope.sortType);
            }
            else{
              $scope.firstTimeCoupons--;
            }
          },true)
  
          // $scope.$watch('module_record_no', function() {
          //   if($scope.firstTimeModules==0){
          //     $scope.showModuleTransactions(1,$scope.sortTypeModule);
          //   }
          //   else{
          //     $scope.firstTimeModules--;
          //   }
          // },true)
  
          // $scope.$watch('credit_record_no', function() {
          //   if($scope.firstTimeCredits==0){
          //     $scope.showCreditTransactions(1,$scope.sortTypeCredit);
          //   }
          //   else{
          //     $scope.firstTimeCredits--;
          //   }
          // },true)
  
          $scope.$watch('user_record_no', function() {
            if($scope.firstTimeUsers==0){
              $scope.showUsers(1);
            }
            else{
              $scope.firstTimeUsers--;
            }
          },true)
  
          $scope.downloadModuleTransactionsCSV = function(type){
            if(!type){
              var data = {forDownload:true,type:'1'};
            } else {
              var data = {forDownload:true,type:'7'};
            }
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: data
            }).then(function(data){
              $scope.transaction = data.data.transactions;
              for(var i in $scope.transaction) {
                $scope.transaction[i][5] = $scope.transaction[i][5].replace(',',' ');
                $scope.transaction[i][6] = $scope.transaction[i][6].replace(',',' ');
                if($scope.transaction[i][11]!=null) {
                  if($scope.transaction[i][11].match(',')) {
                    $scope.transaction[i][11] = $scope.transaction[i][11].replace(',',' ');
                  }
                }
              }
              var csv = 'full_name,city,OderId,Coupon Code,Email,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No,university,crn,phone\n';
              $scope.transaction.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            });
          }
  
          $scope.downloadCreditTransactionsCSV = function(){
            $http({
              url: 'api/v1/transactions/creditTransactions',
              method: "GET",
              params: {type: '5'}
            }).then(function(data){
              $scope.transaction = data.data.credit_transactions;
              var csv = 'TransactionId,Coupon Code,User,Amount,Purchased At\n';
              $scope.transaction.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Credit Transactions.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            })
  
          }
  
          $scope.downloadUserCSV = function(){
            $http({
              url: 'api/v1/users/downloadUsersData',
              method: "GET",
              params: {}
            }).then(function(data){
              $scope.usersD = data.data.user_data;
              var csv = 'User Id,Full Name,Email,Phone No,Sign-up Date, Platform,University\n';
              $scope.usersD.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-User.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            })
          }
  
          $scope.searchModuleTransactionById = function(couponId){
            $scope.hidePagination = true;
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: {coupon_id: couponId,type:'3'}
            }).then(function(data){
              if(!data.data.success){
                swal({
                  title: "Error",
                  text: "Coupon does not exist",
                  type: "error"
                },function(){
                  $scope.module_transactions = 0;
                })
              }
              else{
                $scope.module_transactions = data.data.transactions;
              }
            })
          }
  
          $scope.searchCreditTransactionById = function(couponId){
            $scope.hidePagination = true;
  
            $http({
              url: 'api/v1/transactions/creditTransactions',
              method: "GET",
              params: {coupon_id: couponId,type:'3'}
            }).then(function(data){
              if(data.data.credit_transactions.length > 0 ){
                $scope.credit_transactions = data.data.credit_transactions;
              } else {
                swal('Error','No transactions found','error');
              }
            })
          }
  
          $scope.enableUser = function(user){
            if (confirm("Do you want to enable this user?") == true) {
              var data = {id:user.id};
              $http.post('api/v1/users/toggleUser', data).then(function(data) {
                if(data.data.success){
                  alert('User Successfully Enabled');
                  var index = $scope.users.indexOf(user);
                  $scope.users[index].disabled = false;
                }
                else{
                  alert('There was an error. Try again.');
                }
              });
            }
          }
  
          $scope.searchModuleTransactionByUser = function(uid){
            $scope.hidePagination = true;
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: {uid:uid,type:'4'}
            }).then(function(data){
              if(!data.data.success){
                swal({
                  title: "Error",
                  text: "No Transactions",
                  type: "error"
                },function(){
                  $scope.credit_transactions = 0;
                })
              }
              else{
                $scope.module_transactions = data.data.transactions;
                $scope.total_mt = data.data.total_count;
              }
            })
  
          }
  
          $scope.searchCreditTransactionByUser = function(uid){
            $scope.hidePagination = true;
  
            $http({
              url: 'api/v1/transactions/creditTransactions',
              method: "GET",
              params: {uid:uid,type:'4'}
            }).then(function(data){
              if(!data.data.success){
                alert(data.data.message);
              }
              if(data.data.credit_transactions.length > 0 ){
                $scope.credit_transactions = data.data.credit_transactions;
              } else {
                swal('Error','No transactions found','error');
              }
            })
          }
  
          $scope.searchModuleTransactionByCourse = function(course){
            $scope.hidePagination = true;
            var coursee = course.toLowerCase();
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: {course:coursee,type:'5'}
            }).then(function(data){
              if(!data.data.success){
                swal({
                  title: "Error",
                  text: "No Transactions",
                  type: "error"
                },function(){
                  $scope.module_transactions = 0;
                })
              }
              else{
                $scope.module_transactions = data.data.transactions;
                $scope.total_mt = data.data.total_count;
              }
            })
          }
  
          $scope.downloadModuleTransactionsUserCSV = function(uid){
  
            $scope.hidePagination = true;
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: {uid:uid,type:'4',forDownload:true}
            }).then(function(data){
              var transactions = data.data.transactions;
              var csv = 'OderId,Coupon Code,Purchased By,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No\n';
              transactions.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            })
          }
  
          $scope.downloadModuleTransactionsCourseCSV = function(course){
  
            $scope.hidePagination = true;
            var coursee = course.toLowerCase();
            $http({
              url: 'api/v1/transactions/courseTransactions',
              method: "GET",
              params: {course:coursee,type:'5',forDownload:true}
            }).then(function(data){
              var transactions = data.data.transactions;
              var csv = 'OderId,Coupon Code,Purchased By,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No\n';
              transactions.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            })
          }
  
          $scope.downloadCreditTransactionsUserCSV = function(uid){
            $scope.hidePagination = true;
  
            $http({
              url: 'api/v1/transactions/creditTransactions',
              method: "GET",
              params: {uid:uid, type:'4', forDownload:true}
            }).then(function(data){
              if(!data.data.success){
                swal({
                  title: "Error",
                  text: "No Transactions",
                  type: "error"
                },function(){
                })
              }
              else{
                var transactions = data.data.credit_transactions;
                var csv = 'TransactionId,Coupon Code,User,Amount,Purchased At\n';
                transactions.forEach(function(row) {
                  csv += row.join(',');
                  csv += '\n';
                });
                var parent = document.getElementById('download_csv');
                var hiddenElement = document.createElement('a');
                parent.appendChild(hiddenElement);
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = new Date().toUTCString()+'-Credit Transactions.csv';
                hiddenElement.click();
                parent.removeChild(hiddenElement);
              }
            })
  
          }
  
          $scope.createInstructForm = function(){
            $scope.hideAll();
            $scope.createInstructorForm = true;
          }
  
          $scope.createInstructor = function(form){
            if(!form.name || !form.username || !form.password ){
              alert('Please fill all fields');
              return;
            }
            if(form.password.length <8 ){
              alert('password needs to be 8 characters');
              return;
            }
            var data ={
              name: form.name,
              email: form.username,
              password: form.password,
              sendPass: form.password
            }
            $http({
              url: 'api/v1/instructors/createInstructor',
              method: "POST",
              params: data
            }).then(function(data){
              if(data.data.userExists){
                alert('email already in use');
              }
              else if(data.data.success){
                alert('instructor created Successfully');
                location.reload();
              }
            });
          }
  
          $scope.showInstructors = function(){
            $scope.hideAll();
            $scope.instructorList = true;
            $http({
              url: 'api/v1/instructors/getInstructors',
              method: "GET"
            }).then(function(data){
              $scope.instructors = data.data.instructor;
            })
          }
  
          $scope.showAddVideoQuality = function(){
            $scope.hideAll();
            $scope.responsePopup = true;
            $http({
              url: 'api/v1/videoQuality/getAllquality',
              method: 'GET'
            }).then(function(data){
              $scope.responsePopup = false;
              $scope.allquality = data.data.qualities;
              $scope.addNewQualityVideo = true;
            });
          }
          $scope.saveVideoQuality = function(saveQuality) {
            $http.post('api/v1/videoQuality/saveQuality',{quality:saveQuality})
            .then(function(data){
              if (data.data.success) {
                swal({
                  title: "successful",
                  text: "your quality has been added",
                  type: "success"
                },function(){
                  location.reload();
                });
              }
            });
          }
  
  
          $scope.showEnrolledStudents = function(){
            $scope.hideAll();
            $scope.responsePopup = true;
            $http({
              url: 'api/v1/courses/getAllCourses',
              method: 'GET',
              params: {type: 'admin'}
            }).then(function(data){
              $scope.responsePopup = false;
              $scope.allCourses = data.data.courses;
              $scope.enrolledStudentsTable = true;
            });
          }
  
          $scope.getEnrolledStudents = function(course){
            var courseId = $scope.allCourses[course].id
            $scope.currentCourse = $scope.allCourses[course]
            $scope.responsePopup = true;
            $http({
              url: 'api/v1/enrolledstudents/getEnrolledStudents',
              method:"GET",
              params:{course_id: courseId}
            }).then(function(data){
              if(!data.data.success){
                alert(data.data.message);
                $scope.studentsExist = false;
              } else {
                $scope.enrolledStudents = data.data.students;
                $scope.totalEnrolled = data.data.total;
                $scope.studentsExist = true;
              }
              $scope.responsePopup = false;
            })
          }
  
          $scope.sendUpdateEmailNotification = function(text,user){
            if(!text){
              alert('Please enter text for email');
              return false;
            }
            var data ={
              course_id:$scope.currentCourse.id,
              course_name: $scope.currentCourse.name,
              index_url:$scope.currentCourse.index_url,
              text:text,
              users: user
            }
            $http.post('api/v1/instructors/sendUpdateNotification',data)
            .then(function(data){
              if(data.data.success){
  
              } else {
                alert('No users enrolled');
              }
            })
            alert('Emails are now in process');
          }
  
          $scope.showAllCourses = function(){
            $scope.hideAll();
            $http({
              url: "api/v1/courses/getAllCourses",
              method: "GET"
            }).then(function(data){
              $scope.allCourses = data.data.courses;
              $scope.showAllCoursePage = true;
            })
          }
  
          $scope.updateBalance = function(id,credit){
            var data = {id:id,credit:credit};
            $http.post('api/v1/users/updateBalance',data)
            .then(function(data){
              if(data.data.success){
                alert('Updated Balance Successfully');
              }
            })
          }
  
          $scope.editTransaction = function(trans){
            var data = {id:trans.id};
            $http.post('api/v1/transactions/toggleTransaction',data)
            .then(function(data){
              if(data.data.success){
                alert('Operation Successful');
                trans.disabled = !trans.disabled;
              }
            })
          }
          $scope.updateInstructor = function(index){
            var data = $scope.instructors[index];
            $http.post('api/v1/instructors/updateInstructorShare',data)
            .then(function(data){
              if(data.data.success){
                alert('Successfully Updated');
              }
            })
          }
          $scope.ShowEditBlogForm = function () {
            $scope.hideAll();
            $scope.showEditBlogForm = true;
            $http({
              url: '/api/v1/blog/getBlogs',
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogs = res.data.blogs;
            });
          }
          $scope.ShowCreateBlogForm = function () {
            $scope.hideAll();
            $scope.showCreateBlogForm = true;
            $http({
              url: '/api/v1/blog/category/get',
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogCategories = res.data.category;
            });
          }
          // $scope.ShowCreateBundle = function () {
          //   $scope.hideAll();
          //   $scope.addNewBundle = true;
          //
          // }
          // $scope.ShowViewBundles = function () {
          //   $scope.hideAll();
          //   $http.post('/api/v1/bundle/find',{admin:true})
          //   .then(function(data){
          //     if(data.data.succes) {
          //       $scope.bundles = data.data.bundles;
          //       $scope.showBundle = true;
          //
          //     } else {
          //
          //     }
          //
          //   },function errorCallback(response) {
          //
          //   });
          //
          //
          // }
  
          // $scope.SaveBundle = function(bundle) {
          //
          //   $http.post('/api/v1/bundle/create',{bundle: bundle,admin:true})
          //   .then(function(data){
          //
          //     swal({
          //       title: "Success!",
          //       type: "info",
          //       confirmButtonText: "Ok"
          //     })
          //   },function errorCallback(response) {
          //
          //   });
          // }
          // $scope.addCourseToBundle = function(course) {
          //   $scope.bundle.price+=$scope.courses[course].price;
          //   $scope.bundle.courses.push($scope.courses[course]);
          //
          // }
  
          $scope.ShowBlogComments = function () {
            $scope.hideAll();
            $scope.showBlogComments = true;
            $http({
              url: '/api/v1/blog/comment/getAllComments',
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogcomments = res.data;
            });
          }
          $scope.ShowBlogCategories = function () {
            $scope.hideAll();
            $scope.show_blog_categories = true;
            $http({
              url: '/api/v1/blog/category/get',
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogCategories = res.data.category;
            });
          }
          $scope.ShowBlogCategoryForm = function () {
            $scope.category = {};
            $scope.hideAll();
            $scope.showCreateBlogCategoryForm = true;
          }
          $scope.EditBlogCategoryForm = function (id) {
            $scope.category = {};
            $scope.hideAll();
            $scope.showCreateBlogCategoryForm = true;
            $http({
              url: '/api/v1/blog/category/get/' + id,
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.category = res.data.category;
            });
          }
          $scope.DeleteBlogCategoryForm = function (id, index) {
            $http({
              url: '/api/v1/blog/category/delete/' + id,
              method : 'DELETE',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogCategories.splice(index, 1)
              alert('Blog Category Deleted Successfully');
            });
          }
          $scope.blogapproveComment = function (id)
          {
            var data ={
              comment_id:id
            }
            $http.post('api/v1/blog/comment/blogapproveComment',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            });
          }
          $scope.blogapprovereply = function (id)
          {
            var data ={
              reply_id:id
            }
            $http.post('api/v1/blog/comment/reply/blogapprovereply',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.unhideBlogComment = function (id)
          {
            var data ={
              comment_id:id
            }
            $http.post('api/v1/blog/comment/showBlogComment',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.hideBlogComment = function (id)
          {
            var data ={
              comment_id:id
            }
            $http.post('api/v1/blog/comment/hideBlogComment',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.deleteBlogComment = function (id)
          {
            var data ={
              comment_id:id
            }
            $http.post('api/v1/blog/comment/deleteBlogComment',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.showBlogReply = function (id)
          {
            var data ={
              reply_id:id
            }
            $http.post('api/v1/blog/comment/reply/showBlogReply',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.hideBlogReply = function (id)
          {
            var data ={
              reply_id:id
            }
            $http.post('api/v1/blog/comment/reply/hideBlogReply',data)
            .then(function(data){
              swal({
                title: "Success!",
                type: "info",
                confirmButtonText: "Ok"
              });
            })
          }
          $scope.change = function(value)
          {
            $scope.selected=value;
  
            if(value==1) {
              $scope.AllComments=$scope.blogcomments.allComments;
            }
            else if(value==2)
            $scope.AllComments=$scope.blogcomments.approvedComments;
            else if(value==3)
            $scope.AllComments=$scope.blogcomments.pendingComments;
            else if(value==4)
            $scope.AllComments=$scope.blogcomments.hiddenComments;
          }
          $scope.displayBlog = function (blog) {
            $scope.showCreateBlogForm = true;
            $scope.showEditBlogForm = false;
            $scope.blog = blog;
            if(blog.author)
              $scope.blog.author_name = blog.author.name ? blog.author.name : blog.full_name;
            $http({
              url: '/api/v1/blog/category/get',
              method : 'GET',
              params : {admin: true}
            }).then ( function (res) {
              $scope.blogCategories = res.data.category;
              $scope.blog = blog;
              $scope.blog.category_id = $scope.blog.category_id.toString();
            });
          }
          $scope.SaveBlog = function (blog) {
            if(blog.category_id === '0' || blog.category_id === '' || blog.category_id === null) alert('Please Select Blog Category');
            else if(blog.author_email === '' || !blog.author_email) alert('Please Enter Author Email');
            else if(blog.author_name === '' || !blog.author_name) alert('Please Enter Author Name');
            else if(blog.name === '' || !blog.name) alert('Please Enter Blog Name');
            else {
              if(blog){
                $http.post('/api/v1/blog/saveBlog',{blog:blog})
                .then(function(res){
                  if(res.data.name){
                    alert(res.data.name);
                    location.reload();
                  }
                  else {
                    if(res.data.status === 'NOT_AUTHOR') {
                      var r = confirm("This user is not author. Do you want to make this user author?");
                      if (r == true) {
                        blog.updateUser = true;
                        $scope.SaveBlog(blog);
                      } else {
                        txt = "You pressed Cancel!";
                      }
                    } else {
                      alert(res.data.message)
                    }
                  }
                });
              }
            }
          }
          $scope.SaveBlogCategory = function (category) {
            if(category){
              $http.post('/api/v1/blog/category/save',{category:category})
              .then(function(res){
                if(res.data.name){
                  alert(res.data.name);
                  $scope.ShowBlogCategories();
                }
              });
            }
          }
          $scope.terminateAccessForCourse = function(name){
            if(name){
              $http.post('api/v1/transactions/terminateAccess',{name:name})
              .then(function(data){
                if(data.data.success){
                  alert('Operation successful');
                } else {
                  alert('Encountered an issue, please try again later');
                }
              })
            }
          }
          
  
        }]);
      })();
  
(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('wpSitePagesController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      var data = {page: $scope.currentPage, per_page: 30, type: '1'};

      $http({
        url: 'api/v1/wp-link/get-wp-links',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.configs = data.data.result;
        // $scope.total_config_pages = data.data.totalPages;
        // $scope.total_cofings = data.data.totalCount;
      });

      $scope.disableConfig = function(config) {

        swal({
          title: "Confirmation!",
          text: "Are you sure you want to disable Access Config",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/wp-link/delete-wp-link',
              method: "POST",
              data: {id: config.id}
            }).then(function(data) {
              if(data.data.success) {
                $scope.showNext('same');
                swal({
                  title: "Success",
                  text: "Access Config Disabled Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Access Config Deleting",
                  type: "error"
                },function(){})
              }
            });
          }
        });


        
      }

      $scope.editConfig = function(config) {
        $state.go('edit_wp_pages',{id: config.id})
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = {page: $scope.currentPage, per_page: 30, type: '1'};
        $http({
          url: 'api/v1/wp-link/get-wp-links',
          method: "GET",
          params: data
        }).then(function(data) {
          $scope.result = data.data.result;
          // $scope.total_config_pages = data.data.totalPages;
          // $scope.total_cofings = data.data.totalCount;
        });
      }

    }]);
  })();
  
(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('videoQualityController', ['$scope','CustomStorageService','$state','HttpService', function($scope,CustomStorageService,$state,HttpService) {
    var sr = $scope;
    var signedIn = CustomStorageService.getAdminSignedInStorageData();
    sr.quality = {};
    sr.defaultVVSQuality = 240;
    var VVSDefault = {}
    var getQualities = function() {
      HttpService.getRequest('api/v1/videoQuality/getAllquality')
      .then(function (res) {   
        if (res.success) {
          sr.allquality = res.qualities;
        } 
      });
     }

     var getVVSDefaultQuality = function() {
      HttpService.getRequest('/api/v1/env/get-env/by-name?name=vvs_default_quality_mobile')
      .then(function (res) {   
        if (res.success) {
          VVSDefault = res.env;
          sr.defaultVVSQuality = VVSDefault.config_value;
        } 
      });
     }
     sr.saveVideoQuality = function(saveQuality) {
      HttpService.postRequest('api/v1/videoQuality/saveQuality', saveQuality)
      .then(function (res) {
        if (res.success) {
          swal({
            title: "successful",
            text: res.message,
            type: "success"
          });
          sr.quality = {};
          getQualities();
        } else {
          swal({
            title: "Error!",
            text: res.message,
            type: "error",
            confirmButtonText: "Ok"
          });
        }
      });
     }
     sr.changeVVSQuality = function(quality) {
      sr.defaultVVSQuality = quality
     }
     sr.saveDefaultVVS = function() {
      HttpService.postRequest('api/v1/env/update-value', {id: VVSDefault.id, value: sr.defaultVVSQuality})
      .then(function (res) {
        if (res.success) {
          swal({
            title: "successful",
            text: res.message,
            type: "success"
          });
          sr.quality = {};
          getQualities();
        } else {
          swal({
            title: "Error!",
            text: 'Value Not Updated',
            type: "error",
            confirmButtonText: "Ok"
          });
        }
      });
     }
     if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
       $state.go('admin_panel',{},{reload:true});
     } else {
       getQualities();
       getVVSDefaultQuality();
     }


  }]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("whitelistedUsersController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      $scope.users = [];
      $scope.usersList = [];
      $scope.selectedUser;
      $scope.userKey = "";
      $scope.userIP = "";
      $scope.password = "";

      HttpService.getRequest("api/v1/whitelist/whitelisted-users").then(
        function (res) {
          $scope.usersList = res;
        }
      );
      
      $scope.moveTotrash = function (){
        $scope.userKey = "";
        $scope.password = "";
        $scope.userIP = "";
      }
      $scope.WhitelistUser = function () {
        var api = "api/v1/whitelist/whitelist-user";
        if(!$scope.userIP){
          swal({
            title: "Error",
            text: "IP is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        else{
          var req = { userID: $scope.selectedUser.id,userIP: $scope.userIP };
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            HttpService.getRequest("api/v1/whitelist/whitelisted-users").then(
              function (res) {
                $scope.usersList = res;
              }
            );
          });
        }
      };

      $scope.updatePassword = function () {
        var api = "api/v1/whitelist/update-password";
        if($scope.password < 8 || !$scope.userKey){
          swal({
            title: "Error",
            text: "Password should be greater then 8 characters",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        else{
          var req = { userID: $scope.selectedUser.id,password: $scope.password };
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            if(res.success){
              swal({
                title: "Success",
                text: "Password Updated",
                type: "success",
                confirmButtonText: "Ok"
              });
            }else{
              swal({
                title: "Error",
                text: "Something went wrong",
                type: "error",
                confirmButtonText: "Ok"
              });
            }
          });
        }
      };

      $scope.deleteUser = function (id) {
        var api = "api/v1/whitelist/blacklist-user";
        var req = { userID: id };
        swal({
          title: "Are you sure you want to delete this user's access",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                HttpService.getRequest("api/v1/whitelist/whitelisted-users").then(
                  function (res) {
                    $scope.usersList = res;
                  }
                );
              });
            }
          });
      };

      $scope.goto = function (data){
        var param = data.id;
        $state.go('user_ips', {id: param})
      }

      $scope.getInfo = function (data) {
        var api = "api/v1/user/searchAdmin";
        var req = { key: data };
        HttpService.getRequest(api, req).then(function (res) {
          $scope.users = res.users;
        });
      };

      $scope.addVariants = function (user) {
        $scope.selectedUser = user;
        $scope.userKey =
          user.email || user.fb_email || user.name || user.full_name;
        $scope.users = [];
      };
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("userIPListController", [
      "$scope", "$http", "$state", "$rootScope", "HttpService",
      function ($scope, $http, $state, $rootScope, HttpService) {
        
        $scope.ipList = [];
        $scope.userIP = '';
        $scope.currrentIP = '';
        
        HttpService.postRequest("api/v1/whitelist/user-ip-list",{ user_id:$state.params.id }).then(
          function (res) {
            $scope.currrentIP = res.userIp;
            $scope.ipList = res.ipList;
          }
        );

        $scope.moveTotrash = function (){
          $scope.userIP = "";
        }

        $scope.WhitelistUser = function () {
          var api = "api/v1/whitelist/whitelist-user";
          if(!$scope.userIP){
            swal({
              title: "Error",
              text: "IP is required",
              type: "error",
              confirmButtonText: "Ok"
            });
          }else{
            var req = { userID: $state.params.id,userIP: $scope.userIP };
            HttpService.postRequest(api, req).then(function (res) {
              $scope.moveTotrash();
              HttpService.postRequest("api/v1/whitelist/user-ip-list",{ user_id:$state.params.id }).then(
                function (res) {
                  $scope.currrentIP = res.userIp;
                  $scope.ipList = res.ipList;
                }
              );
            });
          }
        };

        $scope.deleteUser = function (obj){
          var api = "api/v1/whitelist/delete-user-ip";
          var req = { ip: obj.ip };
          swal({
            title: "Are you sure you want to delete this IP",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                HttpService.postRequest(api, req).then(function (res) {
                  HttpService.postRequest("api/v1/whitelist/user-ip-list",{ user_id:$state.params.id }).then(
                    function (res) {
                      $scope.currrentIP = res.userIp;
                      $scope.ipList = res.ipList;
                    }
                  );
                });
              }
            });
          }
        },
    ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('TerminateOrdersController', ['$scope','$state','CustomStorageService', 'HttpService', '$http', function($scope,$state,CustomStorageService, HttpService, $http) {
      $scope.message = '';
      $scope.success = false;
      $scope.type = '';
      $scope.data = null

      $scope.selectedCourses = [];

      var httpHandler = function(type, data) {
        if(type === 'course') {
          data = $scope.selectedCourses.map(function(course) {
            return course.id;
          })
        }
        $http({
          url: '/api/v1/orders/terminate-session-orders',
          method: "PUT",
          data: {
            type: type,
            data: data
          }
        }).then(function(res) {
          if(res.data.success){
            $scope.success = true;
            $scope.message = '';
          } else {
            $scope.message = res.data.message;
            $scope.success = false;
          }
          setTimeout(function() { messageHandler() }, 500)
        });
      }

      var messageHandler = function() {
        if($scope.success) {
            setTimeout(function () {
              swal({
                title: "Orders Terminated Successfully",
                type: "success",
                timer: 2000,
                showConfirmButton: false
              }, function() {
                swal.close();
                $state.go('terminateOrders',{},{reload:true});
              });
            }, 500)
            return;
          } else {
            swal({
              title: $scope.message,
              type: "error",
              timer: 2000,
              showConfirmButton: false
            }, function() {
              swal.close();
              $state.go('terminateOrders',{},{reload:true});
            });
            return;
          }
      }

      var terminateSessionOrder = function (type, data) {
        var userData = CustomStorageService.getUserInfoStorageData();
        // if(userData.is_super_admin) {
          swal({
            title: "Are you sure to terminate session orders?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, submit it!",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                httpHandler(type, data)
              } else {
                $state.go('AdminDashBoard',{},{reload:true});
              }
            });
        // } else {
        //   swal({
        //     title: "Please login with super admin",
        //     type: "error",
        //     timer: 2500,
        //     showConfirmButton: false
        //   }, function() {
        //     swal.close();
        //     $state.go('AdminDashBoard',{},{reload:true});
        //   });
        // }
      };

      $http({
        url:'api/v1/courses/getUniversityList',
        method:"GET",
        params: {type: 'admin'}
      }).then(function (data) {
        $scope.institutions = data.data;
      });

      $scope.updateInstitution = function(institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
        var data = {
          institution: $scope.institutions[institute].institution
        }
        // $scope.type = "institute";
        // $scope.data = $scope.institutions[institute].institution;
      };

      $scope.updateSchool = function(school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };

      $scope.getCourses = function() {
        var data = {
          institution: $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true
        };
        // $scope.type = "faculty";
        // $scope.data = $scope.selectedFaculty
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function(data) {
          if(data.data.success) {
            $scope.courses = data.data.courses;

            
          } else {
            swal({
              title: "Error!",
              text: "The courses is unavailable!",
              type: "error",
              confirmButtonText: "Ok"
            });
            return;
          }
        });
      };

      $scope.removeCourse = function (course){
        course.deleted = true;
        $scope.selectedCourses = $scope.selectedCourses.filter(function(item) {return item.id !== course.id});
      };

      $scope.updateCourse = function(index){
        $scope.type = "course"
        $scope.data = $scope.courses[index].id;
        $scope.selectedCourses.push($scope.courses[index]);
      };

      $scope.Terminate = function() {
        if($scope.data && $scope.data.length > 0) {
          swal({
            title: "Error!",
            text: "Please select course first.",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        terminateSessionOrder($scope.type, $scope.data);
      }
    }]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('tagUrlsController', ['$scope','$state','CustomStorageService', 'HttpService', '$http', function($scope,$state,CustomStorageService, HttpService, $http) {
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      var getTags = function () {
        HttpService.getRequest('/api/v1/tag-url/get')
        .then(function (res) {
          if (res.success) {
            $scope.courseTags = res.courseTags;
          } 
        });
      }

      $scope.editTag = function (id) {
        $state.go('editTagUrls', {id: id})
      }

      $scope.copylink = function (tag) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/tag-courses/' + tag.index_url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.deleteTag = function (id) {

        swal(
          {
            title: "Are you sure you want to delete this Bundle",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http({
                url:'/api/v1/tag-url/delete/' + id,
                method:"Delete",
              }).then(function (res) {
                if(res){
                  if(res.data.success) {
                    swal('Success','Successfully Deleted!','success');
                    getTags()
                  } else {
                    swal('Error',res.data.message,'error');
                  }
                  
                }else{
                  swal('Error','Error saving tag!','error');
                }
              });
            }
          }
        );

        
      }

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('admin_panel', {}, { reload: true });
      } else {
        getTags();
      }
    }]);
  })();

(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('TagFeaturesController', ['$scope', 'UploadService', 'HttpService', 'CustomStorageService', 'FeatureService','$state', function ($scope, UploadService, HttpService, CustomStorageService, FeatureService,$state) {
            var sr = $scope;
            var tag_id = $state.params.tag_id;
            sr.features = [];
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.cf = { icon_url: null };
            var getFeature = function (query) {
                HttpService.getRequest("/api/v1/tag-feature/get-all/" + tag_id, {})
                .then(function (res) {
                    if (res.success) {
                        sr.features = res.result;
                    }
                });
            }
            sr.editFeature = function (feature, type) {
                if (type == 'edit') {
                    sr.cf = feature;
                } else if (type == 'del') {
                    swal(
                        {
                          title: "Are you sure to Remove?",
                          type: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#DD6B55",
                          confirmButtonText: "Remove",
                          closeOnConfirm: true,
                        },
                        function (isConfirm) {
                          if (isConfirm) {
                            removeFeature(feature.id, 'remove');
                          }
                        })
                    
                } else if (type == 'hide') {
                    removeFeature(feature.id, 'hide');
                }
            }
            var removeFeature = function (id, type) {
                var api = '/api/v1/tag-feature/delete'
                if(type === 'hide') {
                    api = '/api/v1/tag-feature/hide'
                }
                HttpService.postRequest(api, { id: id })
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });
            }

            sr.searchFeature = function (query) {
                getFeature({ query: query });
            }

            sr.delImage = function () {
                sr.cf.icon_url = null;
            }

            sr.updateSortOrder = function () {
                sr.features.forEach(function (feature, index) {
                    feature.sort_no = index + 1;
                })
                var api = '/api/v1/tag-feature/update-sort-order';
                HttpService.postRequest(api, { features: sr.features })
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });
            }

            sr.submit = function (cf) {
                if(!cf.redirect_url || !cf.name || !cf.icon_url) {
                    swal({
                        title: "Error!",
                        text: 'All Fields are required',
                        type: "error",
                        confirmButtonText: "Ok"
                    });
                    return;
                }
                var pattern = /^(?:https?:\/\/)?(?:www\.)?(?:[\w-]+\.)+[a-z]{2,}(?:\/[\w-./?%&=]*)?$/i;
                console.log(cf.redirect_url);
                console.log(pattern.test(cf.redirect_url));
                if(!pattern.test(cf.redirect_url)) {
                    swal({
                        title: "Error!",
                        text: 'Please Enter Valid Link',
                        type: "error",
                        confirmButtonText: "Ok"
                    });
                    return;
                }
                var api = '/api/v1/tag-feature/create'
                if(cf.id) {
                    api = '/api/v1/tag-feature/update'
                }
                cf.tag_id = tag_id
                HttpService.postRequest(api, cf)
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                            sr.cf = { icon_url: null, publish: false };
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });
            }
            sr.uploadImage = function (image) {
                UploadService.uploadImage(image)
                    .then(function (data) {
                        sr.cf.icon_url = data;
                    });
            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {
                getFeature({});
            }

        }])

})();
(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('swTagsQuestionsController', ['$scope', '$state', 'CustomStorageService', 'HttpService', "$http", "env", function ($scope, $state, CustomStorageService, HttpService, $http, env) {

      $scope.courseTags = [];

      $scope.goToState = function(state, data){
  			$state.go(state, data);
      };

      var getAllPrompts = function () {
        $http({
          url: env.backendService + "/quizservice/v1/tag/get-tag-questions-count",
          method: "GET",
        }).then(function (data) {
          if (data.data.success) {
            $scope.courseTags = data.data.course;
          } else {
            alert('server error');
          }
        });
      };

      getAllPrompts();
    }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('swTagsController', ['$scope', '$state', 'CustomStorageService', 'HttpService', "$http", function ($scope, $state, CustomStorageService, HttpService, $http) {

      $scope.promptConfigs = []

      $scope.addModule = function (config) {
        $state.go('Add_prom_module_open_AI_config', {course_id: config.course_id.id});
      };

      $scope.goToState = function(state, data){
  			$state.go(state, data);
      };

      var getAllPrompts = function () {
        $http({
          url: '/api/v1/coursetag/get-sw-courses',
          method: "GET",
          data: {type: 'course'}
        }).then(function (data) {
          if (data.data.success) {
            $scope.promptConfigs = data.data.courses;
          } else {
            alert('server error');
          }
        });
      };

      getAllPrompts();
    }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('suspiciousUserReqController', ['$scope', '$http', '$state', '$rootScope', 'CustomStorageService', function ($scope, $http, $state, $rootScope, CustomStorageService) {
      $scope.currentPage = 1;


      var searchLinks = function () {
        var data = { page: $scope.currentPage, per_page: 30, type: '1', search: $scope.userKeySearch };
        $http({
          url: 'api/v1/suspicious-user/get-all-request',
          method: "GET",
          params: data
        }).then(function (data) {
          $scope.configs = data.data.requests;
          $scope.total_config_pages = data.data.totalPages;
          $scope.total_cofings = data.data.count;
        });
      }

      searchLinks();

      $scope.approve = function (config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to aprove user request",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function (confirm) {
          if (confirm) {
            $http.post("api/v1/suspicious-user/approve-request", { id: config.id, email: config.user_id.email }).then(function (data) {
              $scope.suspiciousUser = false;
              toaster.success({
                title: "Request Aproved",
              });
            });
          }
        });
      }

      $scope.reject = function (config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want reject user request",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function (confirm) {
          if (confirm) {
            $http.post("api/v1/suspicious-user/reject-request", { id: config.id, email: config.user_id.email }).then(function (data) {
              $scope.suspiciousUser = false;
              toaster.success({
                title: "Request Rejected",
              });
            });
          }
        });
      }

      $scope.searchLinks = function () {
        $scope.currentPage = 1;
        searchLinks();
      }

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        searchLinks();
      }

      $scope.showNext = function (type) {
        if (type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage++;
        } else if (type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = { page: $scope.currentPage, per_page: 30, type: '1', search: $scope.userKeySearch };
        $http({
          url: 'api/v1/suspicious-user/get-all-request',
          method: "GET",
          params: data
        }).then(function (data) {
          $scope.configs = data.data.requests;
          $scope.total_config_pages = data.data.totalPages;
          $scope.total_cofings = data.data.totalCount;
        });
      }

    }]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('SubscriptionsController', ['$scope', '$http', '$state','HttpService', 'CustomStorageService', function($scope, $http, $state,HttpService, CustomStorageService) {
      
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.name = "";
      $scope.form_link = "";
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.forms = [];
      $scope.resize = 'center';
      $scope.dimension = {};
      $scope.errorText = '';

      var getCustomForms = function() {
        var reqData = {currentPage: $scope.currentPage, perPage: $scope.perPage}
        if($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;
          
        }
        HttpService.getRequest("api/v1/subscriptions/get-subscriptions?admin=true", reqData).then(
          function (res) {
            if(res && res.success) {
              $scope.forms = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getCustomForms();

      $scope.copylink = function (link) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/np-form/' + link.form_id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getCustomForms();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getCustomForms();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedlink = undefined;
        $scope.name = '';
        $scope.form_link = '';
        $scope.resize = 'center';
        $scope.dimension = {};
        $scope.height;
        $scope.errorText = '';
      }



      $scope.updateSubscription = function (subscription) {
        $state.go('EditSubscriptions', {subscription_id: subscription.id})
      };

      $scope.deleteSubscription = function (subscription) {
        var api = "api/v1/subscriptions/delete-subscription";
        var req = { id: subscription.id };
        swal({
          title: "Are you sure you want to delete this subscriptions",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getCustomForms();
              });
            }
          });
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.forms.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getCustomForms();
      }

    }]);
  })();
  
(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('EditSubscriptionsController',
            ['UploadService', '$scope', '$state', 'HttpService', 'CustomStorageService', '$http', 'env', '$timeout', "toaster", "TrackingService",
                function (UploadService, $scope, $state, HttpService, CustomStorageService, $http, env, $timeout, toaster, TrackingService) {
                    var sr = $scope;
                    sr.notifyByWhatsapp = false;
                    sr.key = "";
                    sr.sessions = [],
                    sr.courses = [];
                    sr.modules = [];
                    sr.types = true;
                    sr.showInfo = true;
                    var subscription_id = $state.params.subscription_id
                    sr.selectedUser = {}, sr.selectedCourse = {}, sr.selectedCourses = [];
                    sr.selectedModule = {};
                    var signedIn = CustomStorageService.getAdminSignedInStorageData();
                    var items = [];
                    sr.access = {}
                    sr.subscription = {}
                    $scope.disabled = false;
                    
                    
                    HttpService.getRequest("/api/v1/subscriptions/get-subscription/"+subscription_id).then(
                        function (res) {
                          if(res && res.success) {
                            $scope.subscription = res.result;
                          }
                        }
                      );

                    sr.purchaseType = function (type) {
                        sr.access.type = type;
                        items = [];
                        sr.courseKey = "";
                        sr.userKey = "";
                    }

                    sr.searchInfo = function (value, type) {
                        if (type === 'user') {
                            getInfo({ key: value }, type, 'api/v1/user/search');
                        } else if (type === 'course' || type === 'module') {
                            getInfo({ key: value, paid: true }, 'course', 'api/v1/courses/search');
                        } else if (type === 'bundle') {
                            getBundle({ key: value, admin: true }, 'api/v1/bundle/find');
                        }
                    }

                    var getBundle = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.courses = res.bundles;
                            });
                    }
                    var timer;
                    var getInfo = function (data, type, api) {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            HttpService.getRequest(api, data)
                            .then(function (res) {
                                if (type === 'course') {
                                    sr.courses = res.courses;
                                } else if (type === 'module') {
                                    console.log('res.modules')
                                    console.log(res.modules)
                                    sr.modules = res.modules;
                                }
                            });
                        }, 800);
                        
                    }

                    
                    sr.updateSubscription = function () {
                        $scope.disabled = true;
                        
                        var success = true
                        if(!sr.subscription.subscription_name) {
                            success = false
                        } else if(!sr.subscription.subscription_price || sr.subscription.subscription_price < 1) {
                            success = false
                        } else if(!sr.subscription.subscription_days || sr.subscription.subscription_days < 1) {
                            success = false
                        }
                        if (!success) {
                            swal("All fields are required");
                            $scope.disabled = false;
                            return false;
                        }

                        var subscription = {
                            id: sr.subscription.id,
                            subscription_name: sr.subscription.subscription_name,
                            subscription_price: sr.subscription.subscription_price,
                            subscription_days: sr.subscription.subscription_days,
                            course_id: sr.subscription.course_id ? sr.subscription.course_id.id : null,
                            module_id: sr.subscription.module_id ? sr.subscription.module_id.id : null,
                            bundle_id: sr.subscription.bundle_id ? sr.subscription.bundle_id.id : null,
                        }
                        HttpService.postRequest('api/v1/subscriptions/update-subscription', subscription)
                            .then(function (res) {

                                swal({
                                    title: 'Subscription Updated Successfully',
                                    type: "success",
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                }, function () {
                                    $scope.disabled = false;
                                    swal.close();
                                });

                            })

                    }


                    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                        $state.go('admin_panel', {}, { reload: true });
                    } else {
                        
                    }
                }
            ]
        );
})();
(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('AddSubscriptionsController',
            ['UploadService', '$scope', '$state', 'HttpService', 'CustomStorageService', '$http', 'env', '$timeout', "toaster", "TrackingService",
                function (UploadService, $scope, $state, HttpService, CustomStorageService, $http, env, $timeout, toaster, TrackingService) {
                    var sr = $scope;
                    sr.notifyByWhatsapp = false;
                    sr.key = "";
                    sr.sessions = [],
                    sr.courses = [];
                    sr.modules = [];
                    sr.types = true;
                    sr.showInfo = true;
                    sr.selectedUser = {}, sr.selectedCourse = {}, sr.selectedCourses = [];
                    sr.selectedModule = {};
                    var signedIn = CustomStorageService.getAdminSignedInStorageData();
                    var items = [];
                    sr.access = {}
                    sr.subscriptions = [{}]
                    $scope.disabled = false;
                    
                    sr.purchaseType = function (type) {
                        sr.access.type = type;
                        items = [];
                        sr.courseKey = "";
                        sr.userKey = "";
                    }

                    sr.searchInfo = function (value, type) {
                        if (type === 'user') {
                            getInfo({ key: value }, type, 'api/v1/user/search');
                        } else if (type === 'course' || type === 'module') {
                            getInfo({ key: value, paid: true }, 'course', 'api/v1/courses/search');
                        } else if (type === 'bundle') {
                            getBundle({ key: value, admin: true }, 'api/v1/bundle/find');
                        }
                    }

                    var getBundle = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.courses = res.bundles;
                            });
                    }
                    var timer;
                    var getInfo = function (data, type, api) {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            HttpService.getRequest(api, data)
                            .then(function (res) {
                                if (type === 'course') {
                                    sr.courses = res.courses;
                                } else if (type === 'module') {
                                    console.log('res.modules')
                                    console.log(res.modules)
                                    sr.modules = res.modules;
                                }
                            });
                        }, 800);
                        
                    }
                    sr.addNewSubscription = function (module) {
                        sr.subscriptions.push({})
                    }
                    sr.addModule = function (module) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === module.id && course.type === 'module') {
                                isAllowed = false
                            }
                        })
                        if(isAllowed) {
                            sr.selectedModule = sr.modules[module];
                            sr.selectedModule.type = 'module';
                            sr.selectedModule.price = sr.selectedModule.module_type.price;
                            items = [{
                                course_id: sr.selectedCourse.id,
                                module_id: sr.selectedModule.id,
                                bundle_id: null
                            }];
                            sr.selectedModule.items = items;
                            sr.selectedCourses.push(sr.selectedModule);
                        }
                    }

                    sr.addVariants = function (user, type) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === user.id && (type === course.type || type == 'module')) {
                                isAllowed = false
                            }
                        })
                        console.log(isAllowed)
                        if(isAllowed) {
                            if(type === 'course' || type === 'module' || type === 'bundle') {
                                if (type === 'course') {
                                    sr.selectedCourse = user;
                                    sr.selectedCourse.type = type;
                                    sr.courseKey = sr.selectedCourse.name;
                                    sr.courses = [];
                                    items = [{
                                        course_id: sr.selectedCourse.id,
                                        module_id: null,
                                        bundle_id: null
                                    }];
                                    sr.selectedCourse.items = items;
                                    sr.selectedCourses.push(sr.selectedCourse);
                                    sr.courseKey = ""
                                } else if (type === 'module') {
                                    sr.selectedCourse = user;
                                    sr.courseKey = sr.selectedCourse.name;
                                    sr.courses = [];
                                    getInfo({ id: sr.selectedCourse.id }, sr.access.type, 'api/v1/courses/getModulesByCourseId');
                                } else if (type === 'bundle') {
                                    sr.selectedCourse = user;
                                    sr.selectedCourse.type = type;
                                    sr.courseKey = sr.selectedCourse.name;
                                    sr.courses = [];
                                    items = sr.selectedCourse.course;
                                    sr.selectedCourse.items = items;
                                    sr.selectedCourses.push(sr.selectedCourse);
                                    sr.courseKey = "";
                                }
                            } else {
                                sr.reactivate = false;
                                sr.selectedUser = user;
                                sr.userKey = sr.selectedUser.email || sr.selectedUser.fb_email;
                                sr.users = [];
                            }
                        } else {
                            sr.courses = [];
                            sr.users = [];
                            sr.courseKey = ""
                        }
                    }
                    
                    sr.createAccess = function () {
                        $scope.disabled = true;
                        if (sr.selectedCourses.length < 1) {
                            swal("Please select at-least 1 course, module or bundle");
                            $scope.disabled = false;
                            return false;
                        } else if (sr.subscriptions.length < 1) {
                            swal("Please add at-least 1 subscriptions");
                            $scope.disabled = false;
                            return false;
                        } else {
                            var success = true
                            sr.subscriptions.forEach(function(subscription) {
                                if(!subscription.subscription_name) {
                                    success = false
                                } else if(!subscription.subscription_price || subscription.subscription_price < 1) {
                                    success = false
                                } else if(!subscription.subscription_days || subscription.subscription_days < 1) {
                                    success = false
                                }
                            });
                            if (!success) {
                                swal("All fields are required");
                                $scope.disabled = false;
                                return false;
                            }
                        }

                        var courses = [], modules = [], bundels = []
                        sr.selectedCourses.forEach(function(item) { 
                            if(item.type == 'course') {
                                courses.push(item.id)
                            } else if(item.type == 'module') {
                                modules.push(item.id)
                            } else if(item.type == 'bundle') {
                                bundels.push(item.id)
                            }
                        })

                        HttpService.postRequest('api/v1/subscriptions/create-many', {
                            subscriptions: sr.subscriptions,
                            courses: courses,
                            modules: modules,
                            bundels: bundels,
                        })
                            .then(function (res) {

                                swal({
                                    title: 'Subscription Created Successfully',
                                    type: "success",
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                }, function () {
                                    $scope.disabled = false;
                                    swal.close();
                                    $state.go('Subscriptions');
                                });

                            })

                    }


                    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                        $state.go('admin_panel', {}, { reload: true });
                    } else {
                        
                    }
                }
            ]
        );
})();
(function () {
    'use strict';
    angular
      .module('NearPeer')
      .controller('storyPlayerController', MainController);
  
    function MainController($scope, $rootScope, $sce, CustomStorageService) {
      

        var sr = $scope; 
        var instName;
        var instVideo;
        var check = false;
        $scope.videoSource={}; 
    
        var interval = 0;
         
      
        $scope.videoSource=$scope.videoValue;
        video = document.getElementById('videotarget');

    
    video.on('loadeddata', function (e) {
        scope.$apply(function () {
            scope.start = 0;
            scope.end = e.target.duration;
            scope.current = scope.start;
            scope.currentPercent = scope.start;
            scope.duration = scope.end;
        });
    });
    
    video.on('timeupdate', function (e) {
        scope.$apply(function () {
            scope.current = (e.target.currentTime - scope.start);
            console.log("🚀 ~ file: index.module.js ~ line 127 ~ scope.current", scope.current)
            scope.currentPercent = (scope.current / (scope.end - scope.start)) * 100;
            console.log("🚀 ~ file: index.module.js ~ line 129 ~ scope.currentPercent", scope.currentPercent)
            if (e.target.currentTime < scope.start) {
                e.target.currentTime = scope.start;
            }
            if (e.target.currentTime > scope.end) {
                if (video[0].paused === false) {
                    e.target.pause();
                } else {
                    e.target.currentTime = scope.start;
                }
            }
        });
    });
    
    
    
    scope.onTrimChange = function () {
        video[0].pause();
    };
    
    scope.onSliderChange = function () {
        video[0].pause();
        if (interval) {
            window.clearInterval(interval);
        }
        interval = window.setTimeout(function () {
            video[0].currentTime = scope.start + ((scope.currentPercent / 100 ) * (scope.end - scope.start));
        }, 300);
    };
    
    scope.$watch('start', function (num) {
        if (num !== undefined) {
            video[0].currentTime = num;
        }
    });
    scope.$watch('end', function (num) {
        if (num !== undefined) {
            video[0].currentTime = num;
        }
    });

    }
  
  })();
  
  
(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("storyDetailController", ['$scope', '$http', 'UploadService', '$location', MainController]);

  function MainController($scope, $http, UploadService, $location) {


    $scope.storyAdminViewsPopUp = false;
    $scope.storyAdminLikesPopUp = false;
    $scope.storyAdminCommentsPopUp = false;
    $scope.createStoryPopUp = false;
    $scope.uploadingloader=false;
    


    $scope.numLimit = 180;
    $scope.readMoreBtn = "Read more";
    // $scope.commentReply = false;

    $scope.uploadImage = function (image) {
      if((image.type.includes('image') && image.size/1000000>1))
      {
        swal({
          title: "Error!",
          text: "Image size cannot be greater than 1 mb.",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      // else if((image.type.includes('video')))
      // {
        
      //   //console.log('\n\n\n\n\nWE ARE IN THE CONDITION --------------------',image)
      //   $scope.videoValue=image;
      //   $scope.bringPopup=true;
       
      //   // swal({
      //   //   title: "Error!",
      //   //   text: "Video size cannot be greater than 3 mb.",
      //   //   type: "error",
      //   //   confirmButtonText: "Ok"
      //   // });
      // }

      else if((image.type.includes('video') && image.size/1000000>20))
      {
        swal({
          title: "Error!",
          text: "Video size cannot be greater than 3 mb.",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      else
      {
        $scope.uploadingloader=true;
        UploadService.uploadImage(image)
        .then(function (data) {
          $scope.uploadingloader=false;
          $scope.image_url = data;

        });
      }
      

    }

    $scope.delImage = function () {
      $scope.image_url = null;
    }

    $scope.formData = {
      todate: null,
      valid_till: null
    };

    $scope.addStoryDetail = function (story) {

      if (!story.title || !$scope.image_url) {
        swal({
          title: "Error!",
          text: "Image and title fields are mandatory!\nKindly make sure you don't forget to fill them.",
          type: "error",
          confirmButtonText: "Ok"
        });
        return;
      }
      // if (!$scope.formData.todate || !$scope.formData.valid_till) {
      //   swal({
      //     title: "Error!",
      //     text: "Valid From and Valid Till date/time are mandatory!",
      //     type: "error",
      //     confirmButtonText: "Ok"
      //   });
      //   return;
      // }
      var inputData = {
        story_id: $scope.storyId,
        media_link: $scope.image_url,
        title: story.title,
        description: story.description ? story.description : '',
        redirect_url: story.redirectUrl ? story.redirectUrl : '',
        valid_from: $scope.formData.todate,
        valid_till: $scope.formData.valid_till
      }
      console.log("🚀 ~ MainController ~ inputData:", inputData)
      $http.post('api/v1/story/addStoryDetail', inputData)
      .then(function(data) {
        if(data){
          $scope.createStoryPopUp = false;
          $scope.image_url = "";
          $scope.formData.todate = null;
          $scope.formData.valid_till = null;
        }
        getStoryDetails();
      });
    
    }

    $scope.createStoryPopUpOpen = function () {
   
      $scope.createStoryPopUp = true;
      console.log('popup open');
    };
    $scope.createStoryPopUpClose = function () {
      $scope.createStoryPopUp = false;
      $scope.formData.todate = null;
      $scope.formData.valid_till = null;
    };

    $scope.storyAdminViewsPopUpOpen = function (id) {
         $http({
        url: 'api/v1/story/getStoryViews',
        method: "GET",   
        params: { media_id: id },
      }).then(function (response) {
        $scope.media_data = response.data;
      });
      $scope.storyAdminViewsPopUp = true;
    };

    $scope.storyAdminViewsPopUpClose = function () {
      $scope.storyAdminViewsPopUp = false;
    };

    $scope.storyAdminLikesPopUpOpen = function (id) {
      $scope.storyAdminLikesPopUp = true;
      $http({
        url: 'api/v1/story/getStoryLikes',
        method: "GET",   
        params: { media_id: id },
      }).then(function (response) {
        $scope.media_Likes = response.data;
      });
       
    };

    $scope.storyAdminLikesPopUpClose = function () {
      $scope.storyAdminLikesPopUp = false;
    };

    $scope.storyAdminCommentsPopUpOpen = function (id) {
      $scope.storyAdminCommentsPopUp = true;
      $http({
        url: 'api/v1/story/getCommentsForAdmin',
        method: "GET",   
        params: { media_id: id },
      }).then(function (response) {
        $scope.media_Comments = response.data;
      });
    };
    $scope.commentActions = function (id, val,index) {
      var data = {};
      if(val === 1){
         data = {
        approve: true
         }
          $scope.media_Comments[index].is_approved=true;
          
      }
      if(val === 2){
        data = {
          hide: true
           }
            $scope.media_Comments[index].is_approved=false;
            
      }
      $http({
        url: 'api/v1/story/commentActions',
        method: "POST",   
        params: {comment_id: id },
        data: data,
      }).then(function (response) {
        $scope.action = response.data;
      });
    };

    $scope.storyAdminCommentsPopUpClose = function () {
      $scope.storyAdminCommentsPopUp = false;
    };

    // $scope.commentReplyBtn = function () {
    //   $scope.commentReply = true;
    // };
    $scope.readMore = function (length) {
      if ($scope.readMoreBtn === "Read more") {
        $scope.readMoreBtn = "Read less";
        $scope.numLimit = length;
      } else if ($scope.readMoreBtn === "Read less") {
        $scope.readMoreBtn = "Read more";
        $scope.numLimit = 180;
      }

    };

    var getStoryDetails = function(search){
      var path = $location.path();
      $scope.storyId = path.substring(path.lastIndexOf('/') + 1)
      $http({
        url: 'api/v1/story/getIndividualMedia',
        method: "GET",
        params: { story_id: $scope.storyId }
        // params: { per_page: 10, offset: 1 }
      }).then(function (response) {
        // try{
        response.data.forEach(function (ele) {
          console.log('eleeee', ele.media_link);
          if(ele.media_link.includes('.mp4')){
            console.log('ITS A VIDEO LINK')
           ele.video_link = ele.media_link;
          }else{
            ele.image_link = ele.media_link;
          }
        });
      // }catch(err){
      //   console.log(err);
      // }
        $scope.stories = response.data;
        // $scope.dis = true;

      });
    }
    getStoryDetails();
    $scope.deleteMedia = function(id){
      var data = {
          is_deleted: true,
        }
        $http({
          url: 'api/v1/story/individualMedia',
          method: "POST",   
          params: { id: id },
          data:data,
        }).then(function (response) {
          $scope.stories = response.data;
          getStoryDetails();
        });
      }

  }
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("storiesController", ['$scope', '$http', '$state', MainController]);

  function MainController($scope, $http, $state) {
    var page = 1;
    var ended = false;
    var loading = false;
    $scope.pageSize = 10;
    $scope.data = [];
    $scope.stories = [];
    $scope.totalPages = 1;
    $scope.pageRange = [1];

    $scope.businessRequestPopUp = false;

    $scope.businessRequestPopUpOpen = function (index) {
      $scope.selected = $scope.data[index];
      $scope.businessRequestPopUp = true;
    };
    $scope.businessRequestPopUpClose = function () {
      $scope.selected = {};
      $scope.businessRequestPopUp = false;
    };
    $scope.b2bSearchData = {
      search: "",
      fromDate: "",
      toDate: "",
    };
    $scope.selected = {};

    function formatDate(date) {
      var d = new Date(date);
      var month = "" + (d.getMonth() + 1);
      var day = "" + d.getDate();
      var year = d.getFullYear();
      var newDate = [year, month, day].join("-");
      return newDate;
    }
    $scope.storySearch = "";
    $scope.getSearch = function(){
      page = 0;
      getStories($scope.storySearch);

    }

    $scope.clearSearch = function(){
      page = 0;
      $scope.storySearch = "";
      getStories();

    }
    $scope.storyDetail = function(id){
     $state.go("story-detail", { id: id });
    }
    var getStories = function(search){
      console.log('call')
      loading = true;
      $http({
        url: 'api/v1/story/getStories',
        method: "GET",
        params: { search: search, page: page, per_page: 20 }
        // params: { per_page: 10, offset: 1 }
      }).then(function (response) {
        page = page + 1;
        loading = false;
        // $scope.stories = response.data;
        if (response.data.length === 0) {
          ended = true;
        }
        $scope.stories = $scope.stories.concat(
          response.data
        );
        // $scope.dis = true;

      });
    }

    $scope.loadMore = function () {
      if (!ended && !loading) {
        getStories();
      }
    };

    $scope.editStory = function(story){
      $state.go("edit-story", { story_id: story });
     }


     $scope.deleteStories = function(id){
    var data = {
        is_deleted: true,
        deleted_by: 10,
      }
      $http({
        url: 'api/v1/story/deleteStory',
        method: "POST",
        params: { id: id },
        data:data,
      }).then(function (response) {
        $scope.stories = response.data;
        getStories();
      });
    }
    $scope.disableStories = function(id,disable){
      var data = {
          is_disabled: disable,
        }
        $http({
          url: '/api/v1/story/disableStory',
          method: "POST",
          params: { id: id },
          data:data,
        }).then(function (response) {
          $scope.stories = response.data;
          getStories();
        });
      }
    getStories();
    $scope.enableStories = function(id){
      var data = {
          is_disabled: false,
        }
        $http({
          url: '/api/v1/story/disableStory',
          method: "POST",
          params: { id: id },
          data:data,
        }).then(function (response) {
          $scope.stories = response.data;
          getStories();
        });
      }
    $scope.b2bSearchData = {
      search: "",
      fromDate: "",
      toDate: "",
    };
    $scope.formData = {};

    //  var getB2bUserData = function(b2bSearchData) {
    //   var b2bSearchdefer = $q.defer();
    //   $http({
    //     url: '/api/v1/b2b/getb2bleadforms',
    //     method: "GET",
    //     params : {
    //       search: b2bSearchData.search,
    //       fromDate:  b2bSearchData.fromDate,
    //       toDate: b2bSearchData.toDate,
    //     }
    //   }).then(function(data){
    //     b2bSearchdefer.resolve(data.data);
    //   });
    //   return b2bSearchdefer.promise;

    // };

    $scope.intialize = (function () {
      // 			b2bService.getB2bUserData($scope.b2bSearchData)
      //       .then(function(data){
      // 	console.log(data);
      // 	$scope.fromData=data.data;
      // });
    })();

    $scope.clear = function () {
      $scope.page = 1;
      $scope.pageSize = 10;
      $scope.data = [];
      $scope.totalPages = 1;
      $scope.pageRange = [1];
      $scope.b2bSearchData = {
        search: "",
        fromDate: "",
        toDate: "",
      };
      $scope.getb2bData(1);
    }

    $scope.getb2bData = function (page) {
      $scope.page = page;
      var params = {
        page: page,
        per_page: $scope.pageSize,
      };
      if ($scope.b2bSearchData.search) {
        params.search = $scope.b2bSearchData.search;
      }
      if (
        (!$scope.b2bSearchData.fromDate && $scope.b2bSearchData.toDate) ||
        ($scope.b2bSearchData.fromDate && !$scope.b2bSearchData.toDate)
      ) {
        return swal(
          {
            title: "From Date and To Date are required",
            type: "error",
            showConfirmButton: false,
            allowOutsideClick: true,
            timer: 2000,
          },
          function () { }
        );
      }
      if ($scope.b2bSearchData.fromDate && $scope.b2bSearchData.toDate) {
        if (
          new Date($scope.b2bSearchData.fromDate) >
          new Date($scope.b2bSearchData.toDate)
        ) {
          return swal(
            {
              title: "From Date should be less than To Date",
              type: "error",
              showConfirmButton: false,
              allowOutsideClick: true,
              timer: 2000,
            },
            function () { }
          );
        }
        params.fromDate = formatDate($scope.b2bSearchData.fromDate);
        params.toDate = formatDate($scope.b2bSearchData.toDate);
      }
      $http({
        url: "api/v1/b2b/getb2bleadforms",
        method: "GET",
        params: params,
      }).then(function (data) {
        if (data.data.success) {
          $scope.data = data.data.data.records;
          $scope.totalPages = data.data.data.totalPages;
          $scope.pageRange = [];
          for (var i = 1; i <= $scope.totalPages; i++) {
            $scope.pageRange.push(i);
          }
          $scope.data.forEach(function (e) {
            var d = new Date(e.created_at);
            e.date = new Date(e.created_at).toString().substring(0, 16);
            e.time = d.toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });
          });
        }
      });
    };

    $scope.intialize = (function () {
      $scope.getb2bData($scope.page);
    })();
  }
})();

(function () {
  "use strict";
  
  angular
      .module("NearPeer")
      .controller("editStoryController", ['$scope','$state', '$http', 'UploadService','HttpService', MainController]);
  
    function MainController($scope,$state, $http, UploadService,HttpService) {
     
      $scope.tags = [
        { text: 'Tag1' },
        { text: 'Tag2' },
        { text: 'Tag3' }
      ];
     
      $scope.tags = [];
      $scope.selectedCourse = [];
      $scope.selectedTags = [];
      $scope.uploadingLoader=false;
      $scope.specificCourseFlag=false;
      $scope.specificTag=false;
      
      
      
      
      $http({
        url: '/api/v1/coursetag/get',
        method: "GET",
      }).then(function(data) {
        if(data && data.data) {
         
          data.data.courseTags.forEach(function (tag) {
            $scope.tags.push({id: tag.id, label: tag.name})
          });
        }
        
      });

      $scope.courseFlag=function()
      {
        $scope.specificCourseFlag=$scope.specificCourseFlag?false:true;
        $scope.selectedCourse = $scope.specificCourseFlag?$scope.selectedCourse:[];
      }

      $scope.tagFlag=function()
      {
        $scope.specificTag=$scope.specificTag?false:true;
        $scope.selectedTags = $scope.specificTag?$scope.selectedTags:[];
      }

      $scope.setStoryData= function()
      {
        $scope.image_url=$state.params.story_id.thumbnail;
        $scope.thumbnail_link=$state.params.story_id.thumbnail;
        $scope.title=$state.params.story_id.title;
        $scope.description=$state.params.story_id.description;
        $scope.display=$state.params.story_id.stories_display_to=='register'?'Registered User':'Public (all user if not logedin as well)'
        

        if($state.params.story_id.is_configured)
        {
          $http({
            url: '/api/v1/story/getStoryConfigs',
            method: "GET",
            params: {
              story_id:$state.params.story_id.id
              }
          }).then(function(data) {
            data.data.forEach(function(value){



              if(value.course_id)
              {
                $scope.selectedCourse.push({
                  id:value.course_id.id,
                  tag_id:value.course_id.tag_id,
                  name:value.course_id.name
                });
              }
            
              if(value.tag_id)
              {
                $scope.selectedTags.push({
                  id:value.tag_id.id,
                  name:value.tag_id.name
                })
              }
              


            })
        $scope.specificCourseFlag=$scope.selectedCourse.length!==0?true:false;
        $scope.specificTag=$scope.selectedTags.length!==0?true:false;
        $scope.comment_allowed=$state.params.story_id.comment_allowed?true:false;
        $scope.social_media_sharing=$state.params.story_id.social_media_sharing?true:false;
        $scope.todate=$state.params.story_id.valid_from?new Date($state.params.story_id.valid_from):null;
        $scope.valid_till=$state.params.story_id.valid_till?new Date($state.params.story_id.valid_till):null;
            
          });
        }
        else
        {
        $scope.comment_allowed=$state.params.story_id.comment_allowed?true:false;
        $scope.social_media_sharing=$state.params.story_id.social_media_sharing?true:false;
        $scope.todate=$state.params.story_id.valid_from?new Date($state.params.story_id.valid_from):null;
        $scope.valid_till=$state.params.story_id.valid_till?new Date($state.params.story_id.valid_till):null;


        }

        

        
      }
      $scope.setStoryData();

      
      $scope.uploadImageMain = function (image) {
        
        if(($scope.im.type.includes('image') && $scope.im.size/1000000>1))
        {
          swal({
            title: "Error!",
            text: "Image size cannot be greater than 1 mb.",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        
        else if(($scope.im.type.includes('video')))
        {
          swal({
            title: "Error!",
            text: "Uploading videos is not allowed!",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        else
        {
          $scope.uploadingLoader=true;
          UploadService.uploadStoryImage(image.file)
          .then(function (data) {
            console.log('data=',data);
            $scope.image_url = data.link;
            $scope.thumbnail_link=data.thumbnail_link;
            $scope.uploadingLoader=false;
          });
        }
      }
  
      $scope.getInfo = function (data, type, api) {
        HttpService.getRequest(api, data)
        .then(function (res) {
          if (type === 'course') {
            $scope.courses = res.courses;
          } 
        });
      }


      
  
      
      $scope.searchInfo = function (value, type) {
        if (type === 'course') {
          $scope.getInfo({ key: value }, type, 'api/v1/courses/search');
        }
      }
  
      
  
      $scope.selectCourse = function (course, type) {
        
        if(type === 'course') {
          $scope.courses = [];
          $scope.courseKey = '';
          $scope.selectedCourse.push({
            id: course.id,
            name: course.name,
            tag_id:course.tag_id,
          })
        }
        
      }
  
  
      $scope.deleteCourse = function (courseToDelete, index) {
        var courses = []
        $scope.selectedCourse.forEach(function(course) {
          if(course.id !== courseToDelete.id) {
            courses.push(course)
          }
        })
        $scope.selectedCourse = courses;
      }
  
  
      
  
      $scope.delImage = function () {
        $scope.image_url = null;
        $scope.im=null;
      }
      $scope.updateStory = function () {

   
        if (!$scope.image_url || !$scope.thumbnail_link || !$scope.title  || !$scope.display) {
          swal({
            title: "Error!",
            text: "Image, title and display story fields are mandatory!\nKindly make sure you don't forget to fill them.",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        
        if ($scope.comment_allowed === undefined) {
          $scope.comment_allowed = false;
        }
        if ($scope.social_media_sharing === undefined) {
          $scope.social_media_sharing = false;
        }
        if ($scope.display === "Registered User") {
          $scope.display = "register"
        } else {
        $scope.display = "public"
        $scope.selectedCourse = [];
        $scope.selectedTags = [];
        }

    
        var inputData = {
          story_id:$state.params.story_id.id,
          image: $scope.image_url,
          thumbnail:$scope.thumbnail_link,
          categoryTags:$scope.selectedTags?$scope.selectedTags:[],
          courses:$scope.selectedCourse?$scope.selectedCourse:[],
          title: $scope.title,
          description: $scope.description,
          comment_allowed: $scope.comment_allowed,
          social_media_sharing: $scope.social_media_sharing,
          stories_display_to: $scope.display,
          valid_till: $scope.valid_till,
          valid_from: $scope.todate,
          niche_id: $scope.niche_id,
          course_id: $scope.course_id,
  
        }

        console.log
        $http.put('/api/v1/story/updateStory', inputData)
          .then(function (data) {
            console.log(data);
            if(data){
              window.history.back();
            }
  
          });
  
      }
    }
  })();
  
(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("createStoryController", ['$scope', '$http', 'UploadService','HttpService', MainController]);

  function MainController($scope, $http, UploadService,HttpService) {
   
    $scope.tags = [
      { text: 'Tag1' },
      { text: 'Tag2' },
      { text: 'Tag3' }
    ];
   
    $scope.tags = [];
    $scope.selectedCourse = [];
    $scope.selectedTags = [];
    $scope.uploadingLoader=false;
    $scope.specificTag=false;
    


    $http({
      url: '/api/v1/coursetag/get',
      method: "GET",
    }).then(function(data) {
      if(data && data.data) {
       
        data.data.courseTags.forEach(function (tag) {
          $scope.tags.push({id: tag.id, label: tag.name})
        });
      }
      
    });
    
    $scope.uploadImageMain = function (image) {
      
      if(($scope.im.type.includes('image') && $scope.im.size/1000000>1))
      {
        swal({
          title: "Error!",
          text: "Image size cannot be greater than 1 mb.",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      
      else if(($scope.im.type.includes('video')))
      {
        swal({
          title: "Error!",
          text: "Uploading videos is not allowed!",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      else
      {
        $scope.uploadingLoader=true;
        UploadService.uploadStoryImage(image.file)
        .then(function (data) {
          console.log('data=',data);
          $scope.image_url = data.link;
          $scope.thumbnail_link=data.thumbnail_link;
          $scope.uploadingLoader=false;
        });
      }
    }

    $scope.getInfo = function (data, type, api) {
      HttpService.getRequest(api, data)
      .then(function (res) {
        if (type === 'course') {
          $scope.courses = res.courses;
        } 
      });
    }
    

    
    $scope.searchInfo = function (value, type) {
      if (type === 'course') {
        $scope.getInfo({ key: value }, type, 'api/v1/courses/search');
      }
    }


    $scope.courseFlag=function()
    {
      $scope.specificCourseFlag=$scope.specificCourseFlag?false:true;
      $scope.selectedCourse = $scope.specificCourseFlag?$scope.selectedCourse:[];
    }

    $scope.tagFlag=function()
    {
      $scope.specificTag=$scope.specificTag?false:true;
      $scope.selectedTags = $scope.specificTag?$scope.selectedTags:[];
    }

    

    $scope.selectCourse = function (course, type) {
      
      if(type === 'course') {
        $scope.courses = [];
        $scope.courseKey = '';
        $scope.selectedCourse.push({
          id: course.id,
          name: course.name,
          tag_id:course.tag_id,
        })
      }
      
    }


    $scope.deleteCourse = function (courseToDelete, index) {
      var courses = []
      $scope.selectedCourse.forEach(function(course) {
        if(course.id !== courseToDelete.id) {
          courses.push(course)
        }
      })
      $scope.selectedCourse = courses;
    }

    $scope.delImage = function () {
      $scope.image_url = null;
      $scope.im=null;
    }
    $scope.addStory = function () {
 
      if (!$scope.image_url || !$scope.thumbnail_link || !$scope.title  || !$scope.display) {
        swal({
          title: "Error!",
          text: "Image, title and display story fields are mandatory!\nKindly make sure you don't forget to fill them.",
          type: "error",
          confirmButtonText: "Ok"
        });
        return;
      }
      if (($scope.specificTag==true && $scope.selectedTags.length==0) || ($scope.specificCourseFlag==true && $scope.selectedCourse.length==0)) {
        swal({
          title: "Error!",
          text: "If Tags are checked then tags must be selected.\nIf Courses are checked then courses must be selected",
          type: "error",
          confirmButtonText: "Ok"
        });
        return;
      }
      if ($scope.comment_allowed === undefined) {
        $scope.comment_allowed = false;
      }
      if ($scope.social_media_sharing === undefined) {
        $scope.social_media_sharing = false;
      }
      if ($scope.display === "Registered User") {
        $scope.display = "register"
      } else {
        $scope.display = "public"
        $scope.selectedCourse = [];
        $scope.selectedTags = [];
      }
      var inputData = {
        image: $scope.image_url,
        thumbnail:$scope.thumbnail_link,
        categoryTags:$scope.selectedTags?$scope.selectedTags:undefined,
        courses:$scope.selectedCourse?$scope.selectedCourse:undefined,
        title: $scope.title,
        description: $scope.description,
        comment_allowed: $scope.comment_allowed,
        social_media_sharing: $scope.social_media_sharing,
        stories_display_to: $scope.display,
        valid_till: $scope.valid_till,
        valid_from: $scope.todate,
        niche_id: $scope.niche_id,
        course_id: $scope.course_id,

      }

      $http.post('/api/v1/story/createStory', inputData)
        .then(function (data) {
          console.log(data);
          if(data){
            window.history.back();
          }

        });

    }
  }
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("soundBoostController", [
    "$scope",
    "$state",
    "CustomStorageService",
    "HttpService",
    "$http",
    function ($scope, $state, CustomStorageService, HttpService, $http) {
      $scope.selectedInstitution = "Select Institution";
      $scope.selectedSchool = "Select Faculty";
      $scope.selectedCourse = "Select Course";
      $scope.id = $state.params.id;
      $scope.coursess = [];
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      var getBoostedCourse = function () {
        HttpService.getRequest("/api/v1/soundboost/get").then(function (res) {
          if (res.success) {
            console.log(res);
            if (res.success) {
              $scope.coursess = res.courses;
            } else {
              alert("err");
            }
            // $scope.courseTags = res.courseTags;
          }
        });
      };

      // $scope.editTag = function (id) {
      //   $state.go("editCourseTag", { id: id });
      // };
      $http({
        url: "api/v1/courses/getUniversityList",
        method: "GET",
        params: { type: "admin" },
      }).then(function (data) {
        $scope.institutions = data.data;
      });

      if ($scope.id) {
        $http({
          url: "/api/v1/coursetag/" + $scope.id,
          method: "GET",
          params: { type: "admin" },
        }).then(function (data) {
          if (data.data.success) {
            $scope.selectedCourses = data.data.courseTag.courses;
            $scope.tagName = data.data.courseTag.name;
          }
        });
      }

      $scope.updateInstitution = function (institute) {
        $scope.selected_faculty = $scope.institutions[institute].faculties;
        $scope.selectedInstituteNo = institute;
      };

      $scope.updateSchool = function (school) {
        $scope.selectedFaculty = school;
        $scope.getCourses();
      };
      $scope.getCourses = function () {
        if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok",
          });
          return;
        }
        var data = {
          institution:
            $scope.institutions[$scope.selectedInstituteNo].institution,
          faculty: $scope.selectedFaculty,
          admin: true,
        };
        $http({
          url: "api/v1/courses/getCoursesByInstitutionAndFaculty",
          method: "GET",
          params: data,
        }).then(function (data) {
          if (data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert("server error");
          }
        });
      };
      $scope.boostCourseSound = function (index) {
        $http
          .post("api/v1/soundboost/boostCourseSound", {
            courseId: $scope.courses[index].id,
          })
          .then(function (res) {
            if (res.data.success) {
              $scope.coursess.push($scope.courses[index]);
            } else {
              alert("error occured in boosting course volume");
            }
            // $scope.institutions = data.data;
          })
          .catch(function (err) {
            alert("error occured in boosting course volume");
          });
      };
      $scope.unBoostCourseSound = function (index, cid) {
        $http
          .post("api/v1/soundboost/unboostCourseSound", {
            courseId: cid,
          })
          .then(function (res) {
            if (res.data.success) {
              $scope.coursess.splice(index, 1);
            } else {
              alert("error occured in boosting course volume");
            }
            // $scope.institutions = data.data;
          })
          .catch(function (err) {
            alert("error occured in boosting course volume");
          });
      };
      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("admin_panel", {}, { reload: true });
      } else {
        getBoostedCourse();
      }
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('SendBulkSMSController', ['$scope','$state','CustomStorageService', 'HttpService', function($scope,$state,CustomStorageService, HttpService) {
      $scope.toNumbers = [];
      $scope.toNumbersName = [];
      $scope.fromNumber = 'updates@nearpeer.org';
      $scope.numbersss = [];

      $scope.loadWorksheet = function(e) {
        // Read Workbook
        var file = e.target.result;
        var workbook = XLSX.read(file, { type: "binary" });
        // Get the first worksheet as JSON
        var sheetName = workbook.SheetNames[0];
        var data = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

        data.forEach(function(user) {
          var number = user.number.trim();
          var isDuplicate= false;
          for(var i = 0; i < $scope.numbersss.length; i++) {
            if ($scope.numbersss[i].text == number) {
              isDuplicate = true;
                break;
            }
          }
          if(!isNaN(number) && (number.length === 12 || number.length === 11) && !isDuplicate) {
            $scope.numbersss.push({text: number});
            $scope.toNumbersName.push([number, user.name]);
          }
        })
        $scope.toNumbers = $scope.numbersss;
        setTimeout(function() {
          $scope.$apply();
        }, 2000)
      };


      $scope.numbercheck = function (tag) {
        var tagEmails = tag.text.split(",");
        if(tagEmails.length > 1) {

        tagEmails.forEach(function(number) {
          number = number.trim();
          var isDuplicate= false;
          for(var i = 0; i < $scope.numbersss.length; i++) {
            if ($scope.numbersss[i].text == number) {
              isDuplicate = true;
                break;
            }
          }
          if(!isNaN(number) && (number.length === 12 || number.length === 11) && !isDuplicate) {
            $scope.numbersss.push({text: number});
            $scope.toNumbersName.push([number]);
          }
        });
          $scope.toNumbers = $scope.numbersss;
          $scope.toNumbers =  $scope.toNumbers.filter(function(number) {return number.text !== tag.text});
          $scope.numbersss = $scope.toNumbers;

        } else {
          setTimeout(function() {
            $scope.numbersss = $scope.toNumbers
          }, 800)
          $scope.toNumbersName.push([tag.text]);
        }
        
        setTimeout(function() {
          $scope.$apply()
        }, 1000)
    }

    $scope.removeTag =function (tag) {
      $scope.toNumbersName =  $scope.toNumbersName.filter(function(number) {return tag.text !== number[0]});
      setTimeout(function() {
        $scope.numbersss = $scope.toNumbers;
      }, 1000)
    }

      $scope.sendMessage = function () { 
        const numbers = $scope.toNumbers;
        var isValidAll = true;
        const data = {
          numbers: $scope.toNumbers,
          content: $scope.content,
          toNumbersName: $scope.toNumbersName
        }
          HttpService.postRequest("/api/v1/sms/send-bulk-sms", data)
          .then(function (response) {
            // $scope.toNumbers = [];
            $scope.subject = '';
            $scope.content = '';
            swal({
              title: "Success",
              text: "Message sending",
              type: "success",
              confirmButtonText: "Ok"
            });
          });
      }

    }]).directive("importSheetJs", function($parse) {
      return {
        link: function($scope, $elm, $attrs) {
          // Parse callback function from attribute
          var expressionHandler = $parse($attrs.onSheetLoad);
          
          // Pass upload event to callback    
          $elm.on("change", function(changeEvent) {
            var reader = new FileReader();
            reader.onload = function(e) {
              expressionHandler($scope, { e: e });
            };
            reader.readAsBinaryString(changeEvent.target.files[0]);
          });
        }
      };
    });
  //   .directive("fileread", [function () {
  //     return {
  //         scope: {
  //             fileread: "="
  //         },
  //         controller:'SendBulkSMSController',
  //         link: function (scope, element, attributes) {
            
  //           scope.csvJSON = function (csv){
  //             var lines=csv.split("\n");
  //             //return result; //JavaScript object
  //             lines.forEach(function(number){
  //               number = number.split(",");
  //               console.log(number[0]);
  //               console.log(Number(number[0]).toLocaleString('fullwide', {useGrouping:false}) )
  //               var isDuplicate = false;
  //               for(var i = 0; i < scope.$parent.numbersss.length; i++) {
  //                 if (scope.$parent.numbersss[i].text == number[0]) {
  //                   isDuplicate = true;
  //                     break;
  //                 }
  //               }
  //               number[0] = number[0].trim();
  //               if(!isNaN(number[0]) && (number[0].length === 12 || number[0].length === 11) && !isDuplicate) {
  //                 scope.$parent.numbersss.push({text: number[0]});
  //                 scope.$parent.toNumbersName.push(number);
  //               }
  //             })
  //             scope.$parent.toNumbers = scope.$parent.numbersss;
  //             setTimeout(function() {
  //               scope.$parent.$apply();
  //             }, 2000)
  //           }
  //             element.bind("change", function (changeEvent) {
  //                 var reader = new FileReader();
           
  //                 reader.onload = function (loadEvent) {
                  //     scope.$apply(function () {
                  //         scope.fileread = loadEvent.target.result;
                  //         var csv = scope.fileread;
                  //         scope.csvJSON(csv);
                  //     });
                  // }
  //                 reader.readAsText(changeEvent.target.files[0]);
  //             });
  //         }
  //     }
  // }]);
  })();
(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('sidebarController', ['$scope', '$http' ,'$state','CustomStorageService', 'AssignmentService', function($scope, $http, $state,CustomStorageService, AssignmentService) {
      var sr = $scope;
      const user = CustomStorageService.getUserInfoStorageData();
      $scope.isAdmin = user.user_type === 'admin';
      $scope.isActivityViwer = user.user_type === 'activity_viewer';
      $scope.isMarketing = user.user_type === 'marketing';
      $scope.isSuperAdmin = user.is_super_admin;
      $scope.unansweredQuestions = 0;
      $scope.stateName = $state.current.name;
      console.log("stateName ---", $scope.stateName);
      $scope.getUnansweredCount= function (){
        $http.get("/api/v1/post-question/get-pending-count").then(function (resp) {
          console.log("count ---", resp);
          if (resp.data.success) {
            $scope.unansweredQuestions = resp.data.pendingQuestions ;
          } else {
          $scope.unansweredQuestions = 0;
          }
          });
      }
      $scope.getUnansweredAssignmentCount= function (){
        AssignmentService.getPendingCount({}).then(function (res) {
          if(res.success) {
            $scope.unansweredAssignments = res.pendingCount;
          }
        });
      }
      $scope.getUnansweredCount();
      $scope.getUnansweredAssignmentCount();
      $scope.$on("pendingQuestionCountCheck", function (event) {
        $scope.getUnansweredCount();
      });
      $scope.$on("pendingAssignmentCountCheck", function (event) {
        $scope.getUnansweredAssignmentCount();
      });
      sr.goToState = function(state){
        sr.currentPage = state;
  			$state.go(state,{},{reload:true});
      };
      $(".sidebar-button").click(function() {
        if ( $( this ).hasClass( "collapsed" ) ) {
          $(".icon-bar").css("background-color", "#0077a6");
          $(".icon-bar:nth-child(3)").css("opacity", "0");
          $(".icon-bar:nth-child(2)").css({
            "transform" : "rotate(45deg) translateY(8px) translateX(10px)"
          });
          $(".icon-bar:nth-child(4)").css({"transform" : "rotate(-45deg) translateY(2px) translateX(1px)"});
          $('.adminlogo').css('background-image', 'url("../images/nearpeer-logo.svg")');
          $('#sidebar').css('background-color', 'white');
          $('#sidebar').addClass('mobileSideBar')
        }
        else {
          $("#sidebar").css("background-color", "#0077A6");
          $(".icon-bar").css("background-color", "white");
          $(".icon-bar:nth-child(3)").css("opacity", "1000");
          $(".icon-bar:nth-child(2)").css({
            "transform" : "rotate(0deg) translateY(0px) translateX(0px)",
            "background-color": "white"});
          $(".icon-bar:nth-child(4)").css({"transform" : "rotate(0deg) translateY(0px) translateX(0px)", "background-color": "white"});

          $('.adminlogo').css('background-image', 'url("../images/Logo_white.svg")');
          $('#sidebar').removeClass('mobileSideBar')
        }

        $('body').toggleClass('hide-dropdown-toggle');
        
        
      });
      sr.hideDropDown = false;
      sr.showDropDown = function(){
        sr.hideDropDown = !sr.hideDropDown;
      }
      sr.hideFreeAccessDropDown = false;
      sr.showFreeAccessDropDown = function(){
        sr.hideFreeAccessDropDown = !sr.hideFreeAccessDropDown;
      }
	  var wa_icon = document.getElementById("whatsapp_chat_widget")
      if(wa_icon) {
        wa_icon.style.display = "none";
      }
    }]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('sessionController', ['$scope','$state','CustomStorageService', 'HttpService', "$http", function($scope,$state,CustomStorageService, HttpService, $http) {
      $scope.currentPage = 1;

      $http.get("/api/v1/session/get", {}).then(
        function (resp) {
          $scope.sessions = resp.data.sessions;
        },
        function errorCallback(response) {
          swal(
            {
              title: "Error",
              text: "Error while getting data",
              type: "error",
              showCancelButton: false
            },
            function (isConfirm) {}
          );
        }
      );

      $scope.editSession = function (session, index) {
        $state.go('editSession', {id: session.id});
      };

      $scope.addSession = function ( index) {
        $state.go('addSession');
      };

      $scope.deleteSession = function (session, index) {
        $http.post('api/v1/session/delete/' + session.id, $scope.session)
        .then(function (data) {
          $http.get("/api/v1/session/get", {}).then(
            function (resp) {
              $scope.sessions = resp.data.sessions;
            },
            function errorCallback(response) {
              swal(
                {
                  title: "Error",
                  text: "Error while getting data",
                  type: "error",
                  showCancelButton: false
                },
                function (isConfirm) {}
              );
            }
          );
        });
      };

      $scope.terminateOrders = function (session) {
        swal({
          title: "Are you sure to terminate session orders?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, submit it!",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              $http({
                url: '/api/v1/orders/terminate-session-orders/' + session.id,
                method: "POST",
                params: {}
              }).then(function(res) {
                if(res.data.success) {
                  setTimeout(function () {
                    swal({
                      title: "Orders Terminated Successfully",
                      type: "success",
                      timer: 2000,
                      showConfirmButton: false
                    }, function() {
                      swal.close();
                    });
                  }, 500)
                } else {
                  swal({
                    title: "Orders not Terminated",
                    type: "error",
                    timer: 2000,
                    showConfirmButton: false
                  }, function() {
                    swal.close();
                  });
                }
                
              });
            } else {
              swal.close();
            }
          });
      };

    }]);
  })();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('seoTagController', ['$scope', '$state', '$http', '$rootScope', 'CustomStorageService', 'HttpService', function ($scope, $state, $http, $rootScope, CustomStorageService, HttpService) {
      var sr = $scope;
      var totalPages;
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      sr.tagForm = {};
      sr.submit = function (form) {
        HttpService.postRequest('api/v1/metatags/insert-tag', form)
          .then(function (res) {
            if (res.success) {
              swal({
                title: "successful",
                text: res.message,
                type: "success"
              });
              sr.pageTag(1, 12);
              sr.tagForm = {};
            } else {
              swal({
                title: "Error!",
                text: res.message,
                type: "error",
                confirmButtonText: "Ok"
              });
            }
          });
      }
      sr.editTag = function (tag, type) {
        if (type == 'edit') {
          sr.tagForm = tag;
        } else if (type == 'del') {
          removeTag(tag);
        }
      }
      var removeTag = function (tag) {
        $http.post('api/v1/metatags/remove', { id: tag.id })
          .then(function (data) {
            swal({
              title: "tag removed!",
              type: "success",
              confirmButtonText: "Ok",
              timer: 2000,
              showConfirmButton: false
            }, function () {
              swal.close();
              sr.pageTag(1, 12);
            });
          });
      }
      sr.searchTag = function (query) {
        getTag({ identifier: query, page: 1, per_page: 20 });
      }
      sr.pageTag = function (page, per_page) {
        if (!totalPages) {
          totalPages = 1;
        }
        if (page < totalPages + 1) {
          sr.page = page;
          getTag({ page: page, per_page: per_page });

        }

      }
      var getTag = function (params) {
        $http.post('api/v1/metatags/get', params)
          .then(function (data) {
            totalPages = data.data.totalPages
            sr.totalTags = data.data.totalTags
            sr.viewTag = data.data.tags.length;
            sr.tags = data.data.tags;
          });
      }
      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('admin_panel', {}, { reload: true });
      } else {
        sr.pageTag(1, 12);
      }
    }]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("AdminReportsController", [
    "$scope",
    "$http",
    "env",
    function ($scope, $http, env) {
      $scope.labels = [];
      $scope.series = [
        "Total Revenue",
        "Total Enrollments",
        "Total Promo Codes Used",
        "Total Signups"
      ];

      $scope.data = [[], [], [], []];

      $scope.getReports = function () {
        $http
          .post(env.reportsService + "v1/report/get-daywise-report", {
            fromDate: $scope.fromDate,
            toDate: $scope.toDate
          })
          .then(
            function (response) {
              $scope.reportData = response.data.reportsData;
              $scope.labels = Object.keys($scope.reportData);
              $scope.labels.forEach(function (lable) {
                var revenue = $scope.reportData[lable]["Overall"].earning;
                var enrollments =
                  $scope.reportData[lable]["Overall"].enrollments;
                var promocode =
                  $scope.reportData[lable]["Overall"].couponOrders;
                var signup = $scope.reportData[lable]["Overall"].signupCount;
                $scope.data[0].push(parseInt(revenue));
                $scope.data[1].push(parseInt(enrollments));
                $scope.data[2].push(parseInt(promocode));
                $scope.data[3].push(parseInt(signup));
              });
            },
            function (response) {}
          );
      };
    }
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("redirectLinksController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService", "toaster",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService, toaster
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.name = "";
      $scope.redirect_link = "";
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.links = [];

      var getRedirectLink = function() {
        var reqData = {currentPage: $scope.currentPage, perPage: $scope.perPage}
        if($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;
        }
        HttpService.getRequest("api/v1/redirect-link/get-redirect-links", reqData).then(
          function (res) {
            if(res && res.success) {
              $scope.links = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getRedirectLink();

      $scope.copylink = function (link) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/np-link/' + link.link_id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getRedirectLink();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getRedirectLink();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedlink = undefined;
        $scope.name = '';
        $scope.redirect_link = '';
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/redirect-link/add-redirect-link";
        if(!$scope.redirect_link){
          swal({
            title: "Error",
            text: "Redirect Link is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        } 
        else if(!$scope.redirect_link.startsWith("http://") && !$scope.redirect_link.startsWith("https://")){
          swal({
            title: "Error",
            text: "Please Enter valid URL",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        else{
          var req = { name: $scope.name, redirectLink: $scope.redirect_link };
          if(selectedlink && selectedlink > 0) {
            req.id = selectedlink;
            api = "api/v1/redirect-link/update-redirect-link";
          }
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            getRedirectLink();
            selectedlink = 0;
          });
        }
      };

      $scope.updateRedirectLink = function (link) {
        selectedlink = link.id;
        $scope.name = link.name;
        $scope.redirect_link = link.redirect_link;
      };

      $scope.deleteRedirectLink = function (link) {
        var api = "api/v1/redirect-link/delete-redirect-link";
        var req = { id: link.id };
        swal({
          title: "Are you sure you want to delete this user's access",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getRedirectLink();
              });
            }
          });
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.links.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getRedirectLink();
      }

    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("recommendationBannersController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService", "toaster", "Upload", "env",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService, toaster, Upload, env
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.title = '';
      $scope.description = '';
      $scope.image_url = '';
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.links = [];
      $scope.redirectType = 'link';
      $scope.selected_name = '';
      $scope.redirectLink = '';
      $scope.selectedTag = 'all';
      $scope.bannerFor = 'both';
      $scope.tags = [];

      $http({
        url: '/api/v1/coursetag/get',
        method: "GET",
      }).then(function(data) {
        if(data && data.data) {
          $scope.tags = data.data.courseTags;
        }
        
      });

      var getRedirectLink = function() {
        var reqData = {currentPage: $scope.currentPage, perPage: $scope.perPage, admin: true}
        if($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;

        }
        HttpService.getRequest("api/v1/recommendation-banner/get-banners", reqData).then(
          function (res) {
            if(res && res.success) {
              $scope.links = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getRedirectLink();

      $scope.listData = [];
      $scope.getInfo = function (data, type) {
        var url;
        if($scope.redirectType === 'course') {
          url = env.backendService + "/lmsservice/v1/courses/search-courses";
        } else if($scope.redirectType === 'module') {
          url = env.backendService + "/lmsservice/v1/courses/search-modules";
        } else if($scope.redirectType === 'video') {
          url = env.backendService + "/lmsservice/v1/cvideos/search-videos";
        } else if($scope.redirectType === 'quiz') {
          url = env.backendService + "/quizservice/v1/quiz/search-quiz";
        }
        var req = { key: data };
        HttpService.getRequest(url, req).then(function (res) {
          
          if($scope.redirectType === 'course') {
            $scope.listData = res.courses;
          } else if($scope.redirectType === 'module') {
            $scope.listData = res.modules;
          } else if($scope.redirectType === 'video') {
            $scope.listData = res.videos;
          } else if($scope.redirectType === 'quiz') {
            $scope.listData = res.Quizes;
          }
        });
      };

      var redirectData = {};
      $scope.addVariants = function(data) {
        redirectData = {};
        $scope.userKey = '';
        $scope.listData = [];
        $scope.selected_name = data.name;
        redirectData.type = $scope.redirectType;
        if($scope.redirectType === 'course') {
          redirectData.course_id = data.id;
          redirectData.index_url = data.index_url;
          redirectData.course_name = data.name;
        } else if($scope.redirectType === 'module') {
          redirectData.course_id = data.course_id;
          redirectData.module_id = data.id;
          redirectData.index_url = '';
          redirectData.course_name = '';
          redirectData.module_name = data.name;
          redirectData.module_index_url = data.index_url;
        } else if($scope.redirectType === 'video') {
          redirectData.course_id = '';
          redirectData.module_id = data.module_id;
          redirectData.video_id = data.id;
          redirectData.index_url = '';
          redirectData.course_name = '';
          redirectData.module_name = '';
          redirectData.video_name = data.name;
          if(data.chapter_id) {
            redirectData.chapter_id = data.chapter_id;
          }
        } else if($scope.redirectType === 'quiz') {
          redirectData.quiz_id = data._id;
          redirectData.quiz_name = data.name;
        }
      }

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getRedirectLink();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getRedirectLink();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedlink = undefined;
        $scope.title = '';
        $scope.description = '';
        $scope.image_url = '';
        $scope.imageLoadingStatus = '';
        $scope.redirectLink = '';
        $scope.selectedTag = 'all';
        $scope.bannerFor = 'both';

        $scope.selected_name = '';
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/recommendation-banner/add-banner";
        if(!$scope.title){
          swal({
            title: "Error",
            text: "title is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        } else if(!$scope.image_url){
          swal({
            title: "Error",
            text: "Banner Image is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        } 
        else{
          var redirectLink = document.getElementById("redirectLink").value;
          var req = { title: $scope.title, description: $scope.description, image_url: $scope.image_url, tag_id: $scope.selectedTag, bannerFor: $scope.bannerFor, redirectData: redirectData, redirectLink: redirectLink };
          if(selectedlink && selectedlink > 0) {
            req.id = selectedlink;
            api = "api/v1/recommendation-banner/update-banner";
          }
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            getRedirectLink();
            selectedlink = 0;
          });
        }
      };
      
      $scope.updateRedirectLink = function (link) {
        selectedlink = link.id;
        $scope.title = link.title;
        $scope.description = link.description;
        $scope.image_url = link.image_url;
        $scope.selectedTag = link.tag_id ? link.tag_id.id.toString() : 'all';
        $scope.bannerFor = link.banner_for || 'mobile';
        $scope.imageLoadingStatus = '';
        $scope.redirectLink = link.redirect_link;

        // if(link.redirect_data) {
        //   $scope.redirectType = link.redirect_data.type;
          
        //   if($scope.redirectType === 'course') {
        //     $scope.selected_name = link.redirect_data.course_name;
        //   } else if($scope.redirectType === 'module') {
        //     $scope.selected_name = link.redirect_data.module_name;
        //   } else if($scope.redirectType === 'video') {
        //     $scope.selected_name = link.redirect_data.video_name;
        //   } else if($scope.redirectType === 'quiz') {
        //     $scope.selected_name = link.redirect_data.quiz_name;
        //   }
        // } else {
        //   $scope.redirectLink = link.redirect_link;
        // }
      };

      $scope.deleteRedirectLink = function (link) {
        var api = "api/v1/recommendation-banner/delete-banner";
        var req = { id: link.id };
        swal({
          title: "Are you sure you want to update this Banner",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Update",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getRedirectLink();
              });
            }
          });
      };

      $scope.uploadImage = function (file, userId) {
        return new Promise(function (resolve, reject) {
          Upload.upload({
            url: env.backendService +
            "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
            userId,
            method: "POST",
            file: file,
            params: { userId: userId },
          }).then(
            function (resp) {
              $scope.uploadProgress = 100;
              resolve(resp.data);
            },
            function (resp) {
              swal(
                {
                  title: "Uploading Error",
                  text: "File Not Uploaded. Try Again",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              reject(new Error("ERROR IN UPLOADING IMG 2"));
            },
            function (evt) {
            }
          );
        });
      };

      $scope.onImageSelected = function (event) {
        $scope.imgUploaded = false;

        var selectedImageAnswer = event.target.files[0];

          if (selectedImageAnswer.size > 4000000) {
            swal(
              {
                title: "File Size too Big",
                text: "Upload a file less than 40mb",
                type: "error",
                showCancelButton: false,
              },
              function () {
                swal.close();
              }
            );
            return;
          }
        $scope.imageLoading = true;
        $scope.$apply();
        var fd = new FormData();
        fd.append("file", selectedImageAnswer);
        $scope.uploadImage(selectedImageAnswer, '').then(
          function (resp) {
            if (resp.success) {
              $scope.image_url = resp.link;
              $scope.imageLoading = false;
              $scope.imageLoadingStatus = 'Uploaded'
              $scope.$apply();
            }
          },
          function errorCallback(response) {
            $scope.imageLoadingStatus = 'Failed'
            $scope.imageLoading = false;
            return response;
          }
        );
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.links.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getRedirectLink();
      }

    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("quizConfigurationsController", [
    "$scope",
    "$http",
    "$rootScope",
    "env",
    function ($scope, $http, $rootScope,env) {
      var sr = $scope;

      var getBundel = function () {
        $http.get(
          env.backendService 
          + "/quizservice/v1/quiz/quiz-configurations").then(
          function (data) {
            if (data.data) {
              sr.bundles = data.data.data;
              console.log("data.data---",data.data.data);
            } else {
            }
          },
          function errorCallback(response) {}
        );
      };

      getBundel();

      $scope.deleteBundle = function (bundle_id) {
        swal(
          {
            title: "Are you sure you want to delete this Configuration",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http
                .post(
                  env.backendService
                   + "/quizservice/v1/quiz/deleteQuizConfigurations/" + bundle_id )
                .then(
                  function (data) {
                    if (data.data) {
                      getBundel();
                    } else {
                    }
                  },
                  function errorCallback(response) {}
                );
            }
          }
        );
      };
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('questionsMarketController', ['$scope','$state','CustomStorageService', 'HttpService', function($scope,$state,CustomStorageService, HttpService) {
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      var getTags = function () {
        HttpService.getRequest('/api/v1/post-question-market/get')
        .then(function (res) {
          if (res.success) {
            $scope.courseTags = res.PostQuestionMarkets;
          } 
        });
      }

      $scope.editTag = function (id) {
        $state.go('editMarket', {id: id})
      }

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('admin_panel', {}, { reload: true });
      } else {
        getTags();
      }
    }]);
  })();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("adminQuestionsController", [
      "$scope",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "instructorPanelService",
      "$sails",
      "env",
      "$sce",
      function (
        $scope,
        Upload,
        $http,
        $state,
        CustomStorageService,
        instructorPanelService,
        $sails,
        env,
        $sce
      ) {
        $(document).ready(function () {
          $(this).scrollTop(0);
        });
        var sr = $scope;
        var per_page = 10;
        var commentType = "all";
        var totalUnansweredCount = 0;
        $scope.newQuestion = false;
        $scope.page = 1;
        $scope.total = 10;
        $scope.totalPages = 1;
        $scope.userQuestions;
        $scope.showData = false;
        $scope.selectedQuestionImage;
        $scope.selectedQuestion;
        $scope.selectedInstructor;
        $scope.selectedQuestionToAssign;
        $scope.filterSelected = {
          all: true,
          assigned: false,
          unassigned: false,
          answered: false,
        };
        $scope.remaining = false;
        $scope.rem_stars = [];
        $scope.callFilters = {
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          pageNo: 1,
          limit: 10,
          assigned: null,
          answered: false,
          sort: "date",
          order: "desc",
          search: "",
          from_date: "",
          to_date: "",
        };
        $scope.defaultDropDown = "Select Uploading Options";
        $scope.showOptions = false;
        $scope.searchText = "";
        $scope.totalPageCount;
        $scope.findInstructor = "";
        $scope.instText = "";
        $scope.selected = false;
        $scope.displayQuestion = false;
        $scope.assignInstructor = false;
        $scope.pageArr = [1, 2, 3, 4, 5];
        $scope.currentPage = 1;
        $scope.noData = true;
        $scope.toUpdateInstructor = false;
        $scope.previewImage = "";
        $scope.notAvideo = true;
        $scope.isPDF = false;
        $scope.containsLinks = false;
        $scope.fileName = "";
        $scope.isYoutube = false;
        $scope.ytID = "";
        $scope.videoLink = "";
        $scope.imageshowloader = true;
        $scope.fromDate = "";
        $scope.toDate = "";
        $scope.allQuestionsCount = 0;
        $scope.assignedQuestionsCount = 0;
        $scope.answeredQuestionsCount = 0;
        $scope.unassignedQuestionsCount = 0;
        $scope.ytError = "";
        $scope.unansweredQuestionsCount = 0;
        $scope.initialize = function () {
          var str = CustomStorageService.getUserInfoStorageData().full_name;
          $scope.imageInitial = str.charAt(0).toUpperCase();
          var data = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            page: 1,
            per_page: per_page,
            type: commentType,
          };
        };

        $scope.getAllQuestions = function (filter) {
          if (filter != null) {
            console.log("EMPTY");
          }
          console.log("CALL FILTERS", $scope.callFilters);
          // answered=false&&search=false
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          //&assigned=false&sort=date&order=asc
          var body = {
            page: $scope.callFilters.pageNo,
            limit: $scope.callFilters.limit,
            assigned: $scope.callFilters.assigned,
            sort: $scope.callFilters.sort,
            order: $scope.callFilters.order,
            search: $scope.callFilters.search,
            from_date: $scope.callFilters.from_date,
            to_date: $scope.callFilters.to_date,
            answered: $scope.callFilters.answered,
          };

          $http.post("api/v1/post-question/get?", body).then(function (resp) {
            if (resp.data.success) {
              $scope.totalPageCount = resp.data.data.count;

              if ($scope.callFilters.pageNo === 1) {
                $scope.allQuestionsCount = resp.data.data.overallCounts.all;
                $scope.assignedQuestionsCount =
                  resp.data.data.overallCounts.assigned;
                $scope.answeredQuestionsCount =
                  resp.data.data.overallCounts.answered;
                $scope.unassignedQuestionsCount =
                  resp.data.data.overallCounts.unassigned;
                $scope.unansweredQuestionsCount =
                  resp.data.data.overallCounts.unanswered;
              }
              if (filter === "fromUpdate") {
                $scope.newQuestion = true;
              }
              if ($scope.newQuestion) {
                setTimeout(function () {
                  $scope.newQuestion = false;
                  $scope.$apply();
                }, 2000);
              }

              if ((resp.data.data.questions || []).length > 0) {
                $scope.userQuestions = resp.data.data.questions;
                $scope.noData = false;
                $scope.showData = true;
              } else {
                $scope.userQuestions = resp.data.data.questions;
                $scope.noData = true;
                $scope.showData = true;
              }
              // $scope.$apply();
              console.log("QUESTIONS", $scope.userQuestions);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.dateFilter = function (type) {
          console.log($scope.fromDate, $scope.toDate, "In date filter", type);
        };
        $scope.getAllInstructors = function () {
          $http.get("/api/v1/user/getInstructors").then(function (resp) {
            if (resp.data.success) {
              // $scope.userQuestions = resp.data.data.questions;
              $scope.listofInstructors = resp.data.instructors;
              $scope.showData = true;
              console.log("instructors", resp);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.selectInstructor = function (inst) {
          $scope.findInstructor = inst.name ? inst.name : inst.full_name;
          $scope.selected = !$scope.selected;
          $scope.instText = inst.email;

          $scope.selectedInstructor = inst;

          var div = document.getElementById("myDropdown");
          var label = div.getElementsByTagName("label");
          var txtValue = label[i].textContent || label[i].innerText;
          txtValue = $scope.findInstructor;
          console.log("selected inst", inst);
        };
        $scope.assignCall = function () {
          console.log("IUs", $scope.selectedInstructor);
          var body = {
            question_id: $scope.selectedQuestionToAssign.id,
            assigned_to: $scope.selectedInstructor.id,
          };
          $http.post("api/v1/post-question/assign", body).then(function (resp) {
            console.log("resp admin assign", resp);
            if (resp.data.success) {
              swal(
                {
                  title: "Assigned to Instructor",
                  text: "Question is successfully assigned.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeInstructor();
                  $scope.assignInstructor = false;
                  $scope.$apply();
                  $scope.getAllQuestions();
                  swal.close();

                  // location.reload();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in assigning question",
                type: "error",
              });
              return;
            }
          });
        };
        $scope.closeAnswerWindow = function () {
          $scope.viewRemoveManager();
          $scope.selectedQuestionImage = null;
          $scope.selectedAnswerImage = false;
          $scope.notAvideo = true;
          $scope.videoLink = "";
          $scope.selectedQuestionToAnswer = {};
          $scope.answerQuestion = false;
          $scope.imageshowloader = true;
          $scope.isYoutube = false;
        };
        $scope.pageChange = function (page) {
          $scope.showData = false;
          var temp = [];
          if (
            $scope.pageArr[0] + 4 === page &&
            $scope.pageArr[0] + 4 < $scope.totalPageCount
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row + 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (
            $scope.pageArr[4] - 4 === page &&
            $scope.pageArr[4] - 4 > 1
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row - 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (page <= $scope.totalPageCount && page >= 1) {
            if (page < $scope.currentPage && $scope.pageArr[0] - 1 > 0) {
              $scope.pageArr.forEach(function (row) {
                row = row - 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else if (
              page > $scope.currentPage &&
              $scope.pageArr[4] + 1 < $scope.totalPageCount
            ) {
              $scope.pageArr.forEach(function (row) {
                row = row + 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else {
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            }
          }

          // }
        };
        $scope.adminSearchDrop = function () {
          document.getElementById("myDropdown").classList.toggle("show-dp");
        };

        $scope.filterFunctionAdmin = function () {
          var input, filter, ul, li, label, i;
          input = document.getElementById("myInput");
          filter = input.value.toUpperCase();
          var div = document.getElementById("myDropdown");
          label = div.getElementsByTagName("label");
          for (i = 0; i < label.length; i++) {
            var txtValue = label[i].textContent || label[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              label[i].style.display = "";
              // $scope.findInstructor = txtValue ;
            } else {
              label[i].style.display = "none";
            }
          }
        };
        $scope.getUnansweredCount = function () {
          $http
            .get("/api/v1/post-question/get-pending-count")
            .then(function (resp) {
              console.log("count ---", resp);
              if (resp.data.success) {
                totalUnansweredCount = resp.data.pendingQuestions;
                if (totalUnansweredCount !== $scope.unansweredQuestionsCount) {
                  if ($scope.callFilters.pageNo == 1) {
                    $scope.getAllQuestions("fromUpdate");
                  }
                }
                console.log(
                  "Received Count",
                  totalUnansweredCount,
                  $scope.unansweredQuestionsCount
                );
              } else {
                totalUnansweredCount = 0;
              }
            });
        };
        $scope.getAllQuestions(null);
        var questionInterval = setInterval(function () {
          $scope.getUnansweredCount();
          $scope.$emit("pendingQuestionCountCheck", {});
        }, 55000);

        if ($state.current.name != "StudentQuestions") {
          clearInterval(questionInterval);
        }
        $scope.searchQuery = function () {
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          $scope.callFilters.search = $scope.searchText;
          $scope.callFilters.from_date = $scope.fromDate;
          $scope.callFilters.to_date = $scope.toDate;
          $scope.getAllQuestions();
        };

        $scope.clearFilter = function () {
          $scope.searchText = "";
          $scope.toDate = "";
          $scope.fromDate = "";
          $scope.callFilters = {
            // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
            pageNo: 1,
            limit: 10,
            assigned: null,
            answered: false,
            sort: "date",
            order: "desc",
            search: "",
            from_date: "",
            to_date: "",
          };
          $scope.getAllQuestions(null);
        };
        $scope.getAllInstructors();
        $scope.changeFilter = function (type) {
          console.log(type, "Filter");
          $scope.showData = false;
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          Object.keys($scope.filterSelected).forEach(function (element) {
            if (element == type) {
              $scope.filterSelected[element] = true;
            } else {
              $scope.filterSelected[element] = false;
            }
          });
          if (type === "all") {
            $scope.callFilters.assigned = null;
            $scope.callFilters.answered = null;
          } else if (type === "assigned") {
            $scope.callFilters.assigned = "true";
            $scope.callFilters.answered = "false";
          } else if (type === "answered") {
            $scope.callFilters.answered = "true";
            $scope.callFilters.assigned = null;
          } else {
            $scope.callFilters.assigned = "false";
            $scope.callFilters.answered = "false";
          }
          $scope.getAllQuestions();
        };

        $scope.sortFilter = function (sort, type) {
          // pageNo: 1,
          // limit: 10,
          // answered: null,
          // sort: "date",
          // order: "desc",
          // search : ""
          $scope.showData = false;
          if (sort === "asc") {
            $scope.callFilters.order = "asc";
          } else {
            $scope.callFilters.order = "desc";
          }
          $scope.callFilters.sort = type;
          $scope.getAllQuestions();
        };
        $scope.answerStudent = function (obj) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAnswer = obj;
          $scope.answerQuestion = true;
        };

        $scope.assignToInstructor = function (obj, update) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAssign = obj;
          $scope.assignInstructor = true;
          if (update === "update") {
            $scope.toUpdateInstructor = true;
          } else {
            $scope.toUpdateInstructor = false;
          }
        };
        $scope.getNumber = function (num) {
          if (num < 5) {
            $scope.remaining = true;
            for (i = 0; i <= 5 - num; i++) {
              $scope.rem_stars.push("star");
            }
          } else {
            $scope.remaining = false;
            $scope.rem_stars = [];
          }
          return new Array(num);
        };
        $scope.closeInstructor = function () {
          console.log("CLOSE INSTRUCTOR");
          $scope.viewRemoveManager();
          $scope.assignInstructor = false;
          $scope.findInstructor = "";
          $scope.instText = "";
          $scope.selected = false;
          // $scope.$apply();
        };
        $scope.viewAddManager = function () {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          document
            .getElementById("sidebar-parent")
            .classList.remove("col-sm-2");
          document.getElementById("sidebar").classList.remove("col-sm-2");
          document
            .getElementById("sidebar-parent")
            .classList.remove("col-md-2");
          document.getElementById("sidebar").classList.remove("col-md-2");
          document
            .getElementById("admin-view-control")
            .classList.remove("col-sm-10");
          document
            .getElementById("admin-view-control")
            .classList.remove("col-md-10");
          document
            .getElementById("admin-view-control")
            .classList.add("full-v-h");
          document.getElementById("adminpanel").style.overflow = "hidden";
        };
        $scope.viewRemoveManager = function () {
          document.getElementById("sidebar-parent").classList.add("col-sm-2");
          document.getElementById("sidebar").classList.add("col-sm-2");
          document.getElementById("sidebar-parent").classList.add("col-md-2");
          document.getElementById("sidebar").classList.add("col-md-2");
          document
            .getElementById("admin-view-control")
            .classList.add("col-sm-10");
          document
            .getElementById("admin-view-control")
            .classList.add("col-md-10");
          document
            .getElementById("admin-view-control")
            .classList.remove("full-v-h");
          document.getElementById("adminpanel").style.overflow = "auto";
        };
        $scope.imageLoadCheck = function () {
          console.log("on image load");
          $scope.imageshowloader = false;
          $scope.$apply();
        };
        $scope.viewQuestion = function (qId, question, image) {
          $scope.viewAddManager();
          $scope.containsLinks = false;

          if (image != null) {
            if (image.includes("mp4") || image.includes("webm")) {
              $scope.imageshowloader = false;

              $scope.notAvideo = false;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            } else if (
              image.includes("pdf") ||
              image.includes("docx") ||
              image.includes("docs") ||
              image.includes("txt") ||
              image.includes("xls") ||
              image.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
              $scope.isYoutube = false;
            } else if (image.includes("youtube")) {
              $scope.imageshowloader = false;

              image.replace("watch?v=", "embed/");
              var linkB = image.substring(image.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("Ext", linkB, linkB2[0]);
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }
          $scope.selectedQuestionImage = image;
          $scope.selectedAnswerImage = image;
          console.log($scope.selectedQuestionImage);

          $scope.selectedQuestion = question;
          $scope.displayQuestion = true;
        };
        $scope.viewAnswer = function (question, image) {
          $scope.viewAddManager();

          $scope.containsLinks = false;
          console.log(question.answers[0], "Answer");
          $scope.answerObj = question.answers[0];
          if ($scope.answerObj.answer_media_link) {
            console.log($scope.answerObj.answer_media_link, "upaaa link");
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;

            var ext = $scope.selectedAnswerImage.substring(
              $scope.selectedAnswerImage.indexOf("v=") + 2
            );
            var ext2 = ext.split("&");
            $scope.ytID = ext2[0];
            console.log("Ext", ext, ext2[0]);

            console.log($scope.selectedAnswerImage, "up link");
          } else {
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;
          }
          $scope.selectedQuestionImage = $scope.answerObj.answer_media_link;
          if ($scope.selectedAnswerImage != null) {
            if (
              $scope.selectedAnswerImage.includes("mp4") ||
              $scope.selectedAnswerImage.includes("webm")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = false;
              $scope.isPDF = false;
            } else if ($scope.selectedAnswerImage.includes("youtube")) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else if (
              $scope.selectedAnswerImage.includes("pdf") ||
              $scope.selectedAnswerImage.includes("docx") ||
              $scope.selectedAnswerImage.includes("docs") ||
              $scope.selectedAnswerImage.includes("txt") ||
              $scope.selectedAnswerImage.includes("xls") ||
              $scope.selectedAnswerImage.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }

          console.log($scope.selectedQuestionImage, "Image");
          console.log($scope.selectedAnswerImage, "up link");

          // $scope.selectedQuestion = $scope.answerObj.answer_text ;
          $scope.selectedQuestion = $scope.formatTextforLink(
            $scope.answerObj.answer_text
          );
          $scope.displayAnswer = true;
        };
        $scope.uploadImage = function (formData, userId) {
          return new Promise(function (resolve, reject) {
            fetch(
              env.backendService +
                "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
                userId,
              {
                method: "POST",
                body: formData,
              }
            )
              .then(
                function (data) {
                  return data.json();
                },
                function (err) {
                  console.log("ERROR IN UPLOADING IMG 1", err);
                  reject(new Error("ERROR IN UPLOADING IMG 1"));
                }
              )
              .then(
                function (data) {
                  resolve(data);
                },
                function (err) {
                  console.log("ERROR IN UPLOADING IMG 1", err);
                  reject(new Error("ERROR IN UPLOADING IMG 2"));
                }
              );
          });
        };
        $scope.onImageSelected = function (event) {
          $scope.imageLoad = true;
          console.log("EVENTS", event);
          $scope.imgUploaded = false;

          $scope.selectedImageAnswer = event.target.files[0];
          console.log($scope.selectedImageAnswer, "size");
          $scope.fileName = $scope.selectedImageAnswer.name;

          if (
            $scope.selectedImageAnswer.type.includes("mp4") ||
            $scope.selectedImageAnswer.type.includes("webm")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              32553838;
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = false;
            $scope.isPDF = false;
          } else if (
            $scope.selectedImageAnswer.type.includes("application/pdf") ||
            $scope.selectedImageAnswer.type.includes("xls") ||
            $scope.selectedImageAnswer.type.includes("excel") ||
            $scope.selectedImageAnswer.type.includes("docs") ||
            $scope.selectedImageAnswer.type.includes("docx") ||
            $scope.selectedImageAnswer.type.includes("csv") ||
            $scope.selectedImageAnswer.type.includes("application/msword") ||
            $scope.selectedImageAnswer.type.includes(
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ) ||
            $scope.selectedImageAnswer.type.includes("openxmlformats")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = true;
          } else {
            if ($scope.selectedImageAnswer.size > 4000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = false;
          }
          $scope.$apply();
          //   FormDataa()
          var fd = new FormData();
          console.log($scope.selectedImageAnswer);
          fd.append("file", $scope.selectedImageAnswer);
          $scope.uploadImage(fd, $scope.instID).then(
            function (resp) {
              console.log("up resp", resp);
              if (resp.success) {
                $scope.uploadedImgLink = resp.link;
                // $scope.userData.image = $scope.uploadedImgLink;
                // $scope.userInfo.image = $scope.uploadedImgLink;
                $scope.selectedAnswerImage = resp.link;
                $scope.imageLoad = false;
                $scope.$apply();

                $scope.selectedImageAnswer = null;
                var obj = {
                  id: $scope.userID,
                  user_image: $scope.uploadedImgLink,
                };
              }
            },
            function errorCallback(response) {
              console.log("ERROR RESP", response);
              return response;
            }
          );
        };
        $scope.youtubePreview = function (event) {
          console.log(event, "yt img link");
          setTimeout(function () {
            var ytLink = event.target.value;

            if (ytLink.includes("http://youtu.be/")) {
              ytLink.replace(
                "http://youtu.be/",
                "http://www.youtube.com/embed/"
              );
              var linkB = ytLink.substring(ytLink.indexOf(".be/") + 4);
              var linkB2 = linkB.split("?");
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            } else {
              ytLink.replace("watch?v=", "embed/");
              var linkB = ytLink.substring(ytLink.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            }
            $scope.$apply();
          }, 100);
        };
        $scope.sendAnswer = function (ansText, link) {
          console.log(
            "SELECTED QUESTION TO ANSWER",
            $scope.selectedQuestionToAnswer
          );
          var checkLink;
          if ((link || []).length > 4) {
            console.log("in link attach", link);
            if (link.includes("http://youtu.be/")) {
              checkLink = link.replace(
                "http://youtu.be/",
                "https://www.youtube.com/watch?v="
              );
              link = checkLink;
            } else if (link.includes("https://youtu.be/")) {
              checkLink = link.replace(
                "https://youtu.be/",
                "https://www.youtube.com/watch?v="
              );
              link = checkLink;
            }
            console.log("checkLink", checkLink);

            $scope.uploadedImgLink = link;
          }

          var body = {
            question_id: $scope.selectedQuestionToAnswer.id,
            answer_media_link: $scope.uploadedImgLink,
            answer_text: ansText,
          };
          $http.post("api/v1/post-question/answer", body).then(function (resp) {
            console.log("resp instructor answer", resp);
            if (resp.data.success) {
              swal(
                {
                  title: "Answered",
                  text: "Answer is successfully posted.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeAnswerWindow();
                  $scope.answerQuestion = false;
                  $scope.asnwerText = "";
                  $scope.uploadedImgLink = "";
                  $scope.selectedQuestionToAnswer = "";
                  $scope.videoLink = "";
                  $scope.$apply();
                  swal.close();
                  $scope.getAllQuestions();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in answering question",
                type: "error",
              });
              return;
            }
          });
          console.log("answer", $scope.uploadedImgLink);
        };
        $scope.previewEnlargedImage = function (image) {
          console.log("Image", image);
          $scope.previewImage = image;
          $scope.imagePreview = true;
          $scope.displayQuestion = false;
        };
        $scope.formatTextforLink = function (text) {
          console.log("in format text", text);
          if (!text) return text;
          var newText = text.replace(/(https?:\/\/[^\s]+)/g, function (url) {
            $scope.containsLinks = true;

            return (
              '<a target="_blank" style="margin-bottom: 5px;" href="' +
              url +
              '"' +
              ">" +
              url +
              "</a>"
            );
          });
          console.log("in formatted text", newText);

          return newText;
        };
        $scope.closeQuestion = function () {
          // $scope.displayQuestion = false;
          $scope.selectedQuestionImage = null;
          $scope.videoLink = "";
          $scope.selectedAnswerImage = false;
          $scope.displayQuestion = false;
          $scope.displayAnswer = false;
          $scope.notAvideo = true;
          $scope.imageshowloader = false;
          $scope.isYoutube = false;

          $scope.viewRemoveManager();
        };
        $scope.handleOptions = function () {
          $scope.showOptions = !$scope.showOptions;
        };
        $scope.uploadLink = function (link) {
          console.log(link, "yt");

          if (link.includes("watch?v=")) {
            link.replace("watch?v=", "embed/");
            $scope.selectedImageAnswer = link;
          }
          console.log(link);

          $scope.uploadedImgLink = link;
          $scope.notAvideo = false;
          $scope.isYoutube = true;
          $scope.isPDF = false;
          // $scope.$apply();
        };
        $scope.selectUploadType = function (type) {
          console.log("TYPE UPLOAD", type);
          $scope.defaultDropDown = type;

          if (type === "Video Link") {
            $scope.fileUploadSelected = false;
            $scope.linkUpload = true;
          } else {
            $scope.fileUploadSelected = true;
            $scope.linkUpload = false;
            $scope.isYoutube = false;
          }
          $scope.handleOptions();
        };
        $scope.closePreviewImage = function (type) {
          // $scope.previewImage = "";
          $scope.imagePreview = false;
          if ($scope.questionPopup) {
            $scope.displayQuestion = true;
          } else {
            $scope.displayAnswer = true;
          }
        };
        sr.trustSrc = function (src) {
          console.log(src, "sssssssource");
          return $sce.trustAsResourceUrl(
            "https://www.youtube.com/embed/" + src
          );
        };
      },
    ]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('promOpenAIController', ['$scope', '$state', 'CustomStorageService', 'HttpService', "$http", function ($scope, $state, CustomStorageService, HttpService, $http) {

      $scope.promptConfigs = []

      $scope.addSession = function () {
        $state.go('Add_prom_open_AI_config');
      };

      $scope.addCourseConfig = function() {
        $state.go('Add_prom_tag_open_AI_config');

      }

      $scope.editConfig = function (config) {
        $state.go('Edit_prom_open_AI_config', {id: config.id});
      };
      
      $scope.addModule = function (config) {
        $state.go('Add_prom_module_open_AI_config', {course_id: config.course_id.id});
      };

      $scope.deleteConfig = function (config) {
        $http({
          url: '/api/v1/prompt/delete-prompt-config-by-id/'+config.id,
          method: "GET",
          data: {}
        }).then(function (data) {
          if (data.data.success) {
            getAllPrompts();
          } else {
            alert('server error');
          }
        });
      };

      var getAllPrompts = function () {
        $http({
          url: '/api/v1/prompt/get-prompt-config',
          method: "POST",
          data: {type: 'course'}
        }).then(function (data) {
          if (data.data.success) {
            $scope.promptConfigs = data.data.promptConfigs;
          } else {
            alert('server error');
          }
        });
      };

      getAllPrompts();
    }]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('postQuestionConfigController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      var data = {page: $scope.currentPage, per_page: 30, type: '1'};

      $http({
        url: 'api/v1/post-question/get-all-configs',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.configs = data.data.configs;
        $scope.total_config_pages = data.data.totalPages;
        $scope.total_cofings = data.data.totalCount;
      });

      $scope.disableConfig = function(config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to disable Post Question Config",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/post-question/delete-config/' + config.id,
              method: "GET",
              params: data
            }).then(function(data) {
              if(data.data.success) {
                $scope.showNext('same');
                swal({
                  title: "Success",
                  text: "Post Question Config Disabled Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Post Question Config Deleting",
                  type: "error"
                },function(){})
              }
            });
          }
        });


        
      }

      $scope.editConfig = function(config) {
        $state.go('edit_post_questions_config',{id: config.id})
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = {page: $scope.currentPage, per_page: 30, type: '1'};
        $http({
          url: 'api/v1/post-question/get-all-configs',
          method: "GET",
          params: data
        }).then(function(data) {
          $scope.configs = data.data.configs;
          $scope.total_config_pages = data.data.totalPages;
          $scope.total_cofings = data.data.totalCount;
        });
      }

    }]);
  })();
  
(function () {
  "use strict";
  angular.module("NearPeer").controller("AdminPaymentAuditController", [
    "$scope",
    "$http",
    "$state",
    'CustomStorageService',
    function ($scope, $http, $state, CustomStorageService) {
      // API base URL from global or fallback
      var BASE_URL = window.BACKEND_URL || 'https://devbackend.nearpeer.org';
      console.log('BASE_URL', BASE_URL);

      // Admin user ID (replace with actual logic to get logged-in admin ID)
      // $scope.adminUserId = 101;
      $scope.adminUserId = CustomStorageService.getUserInfoStorageData().id;

      // Filters and pagination
      $scope.filters = {
        page: 1,
        per_page: 10,
        fromDate: '',
        toDate: '',
        type: '',
        search: '',
        payment_status: ''
      };
      $scope.orders = [];
      $scope.totalOrders = 0;
      $scope.totalPages = 1;
      $scope.verifiedOrders = 0;
      $scope.unverifiedOrders = 0;

      $scope.pageSizes = [10, 25, 50, 100];
      $scope.pageSize = 10;
      $scope.currentPage = 1;

      $scope.fetchOrders = function() {
        var params = angular.copy($scope.filters);
        params.page = $scope.currentPage;
        params.per_page = $scope.pageSize;
        $http.get('/api/v1/orders/get-orders-with-course-access', { params: params })
          .then(function(response) {
            if (response.data.success) {
              $scope.orders = response.data.orders;
              $scope.totalPages = response.data.totalPages;
            }
          });
      };
      $scope.fetchOrdersStats = function() {
        var params = {};
        if ($scope.filters.fromDate && $scope.filters.toDate) {
          params.fromDate = $scope.filters.fromDate;
          params.toDate = $scope.filters.toDate;
        }
        $http.get('/api/v1/orders/get-order-stats', { params: params })
          .then(function(response) {
            if (response.data.success) {
              $scope.totalOrders = response.data.stats.totalOrders;
              $scope.verifiedOrders = response.data.stats.verifiedOrders;
              $scope.unverifiedOrders = response.data.stats.unverifiedOrders;
            }
          });
      };

      $scope.setPageSize = function(size) {
        $scope.pageSize = size;
        $scope.currentPage = 1;
        $scope.fetchOrders();
      };

      $scope.nextPage = function() {
        if ($scope.currentPage < $scope.totalPages) {
          $scope.currentPage++;
          $scope.fetchOrders();
        }
      };

      $scope.prevPage = function() {
        if ($scope.currentPage > 1) {
          $scope.currentPage--;
          $scope.fetchOrders();
        }
      };

      $scope.pageCount = function() {
        return $scope.totalPages || 1;
      };

      $scope.applyFilters = function() {
        $scope.currentPage = 1;
        $scope.fetchOrders();
        $scope.fetchOrdersStats();
      };

      $scope.showProof = function(order) {
        var proofUrl = 'https://placehold.co/600x400?text=No+Proof';
        if (order.courseAccess && order.courseAccess.length > 0) {
          for (var i = 0; i < order.courseAccess.length; i++) {
            if (order.courseAccess[i].proof) {
              proofUrl = order.courseAccess[i].proof;
              break;
            }
          }
        }
        $scope.currentProof = proofUrl;
        $scope.currentOrder = order;
      };

      $scope.verifyOrder = function() {
        if ($scope.currentOrder) {
          $http.post('/api/v1/orders/update-payment-status', {
            order_id: $scope.currentOrder.id,
            is_verified: true
          }, {
            headers: { uid: $scope.adminUserId }
          }).then(function() {
            $scope.showToast('Order verified successfully!');
            $scope.currentOrder.courseAccess[0].payment_status = 'VERIFIED';
            $scope.verifiedOrders++;
            $scope.unverifiedOrders--;
          }, function() {
            $scope.showToast('Failed to verify order.');
          });
        }
      };

      $scope.unverifyOrder = function() {
        if ($scope.currentOrder) {
          $http.post('/api/v1/orders/update-payment-status', {
            order_id: $scope.currentOrder.id,
            is_verified: false
          }, {
            headers: { uid: $scope.adminUserId }
          }).then(function() {
            $scope.showToast('Order unverified.');
            $scope.currentOrder.courseAccess[0].payment_status = 'UNVERIFIED';
            $scope.verifiedOrders--;
            $scope.unverifiedOrders++;
          }, function() {
            $scope.showToast('Failed to unverify order.');
          });
        }
      };

      $scope.showToast = function(message) {
        $scope.toastMessage = message;
        $scope.showingToast = true;
        setTimeout(function() {
          $scope.showingToast = false;
          $scope.$apply();
        }, 2000);
      };

      $scope.downloadCSV = function() {
        if ($scope.filters.fromDate && $scope.filters.toDate) {
          var date1 = new Date($scope.filters.fromDate);
          var date2 = new Date($scope.filters.toDate);
          date2.setHours(date2.getHours() + 12);
          var diffTime = Math.abs(date2 - date1);
          var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays < 366) {
            var fromDate = new Date($scope.filters.fromDate);
            fromDate = new Date(fromDate.getTime() + (3600000 * 5.00));
            var toDate = new Date($scope.filters.toDate);
            toDate = new Date(toDate.getTime() + (3600000 * 5.00));
            var params = angular.copy($scope.filters);
            params.fromDate = fromDate.toISOString().slice(0, 10);
            params.toDate = toDate.toISOString().slice(0, 10);
            params.csv = true;
            delete params.page;
            delete params.per_page;
            $http.get('/api/v1/orders/get-orders-with-course-access', { params: params })
              .then(function(res) {
                if (res.data && res.data.success) {
                  if (window.swal) {
                    swal({
                      title: 'Success',
                      text: 'CSV will be sent to your email!',
                      type: 'success',
                      showConfirmButton: true
                    });
                  } else {
                    alert('CSV will be sent to your email!');
                  }
                } else {
                  if (window.swal) {
                    swal({
                      title: 'Error',
                      text: res.data && res.data.message ? res.data.message : 'Failed to request CSV.',
                      type: 'error',
                      showConfirmButton: true
                    });
                  } else {
                    alert(res.data && res.data.message ? res.data.message : 'Failed to request CSV.');
                  }
                }
              }, function() {
                if (window.swal) {
                  swal({
                    title: 'Error',
                    text: 'Failed to request CSV.',
                    type: 'error',
                    showConfirmButton: true
                  });
                } else {
                  alert('Failed to request CSV.');
                }
              });
          } else {
            if (window.swal) {
              swal({
                title: 'Error',
                text: 'select date b/w 1-365 days!',
                type: 'error',
                showConfirmButton: true
              });
            } else {
              alert('select date b/w 1-365 days!');
            }
          }
        } else {
          if (window.swal) {
            swal({
              title: 'Error',
              text: 'Please Select to and from date!',
              type: 'error',
              showConfirmButton: true
            });
          } else {
            alert('Please Select to and from date!');
          }
        }
      };

      $scope.clearFilters = function() {
        $scope.filters.search = '';
        $scope.filters.fromDate = '';
        $scope.filters.toDate = '';
        $scope.filters.type = '';
        $scope.currentPage = 1;
        $scope.fetchOrders();
        $scope.fetchOrdersStats();
      };

      // Initial fetch
      $scope.fetchOrders();
      $scope.fetchOrdersStats();
    },
  ]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('otpPageController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', '$cookies', function($scope, $http, $state,$rootScope, CustomStorageService, $cookies) {
      if( CustomStorageService.getAdminSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
        $state.go('AdminDashBoard',{},{reload:true});
      }
      $scope.verifyOtp = function() {
        var browserId = $cookies.get('browserId');
        const data = {
          user_id: $state.params.user_id,
          code: $scope.otpCode,
          browser_id: browserId,
          origin: "LEGACY",
          admin: true
        }
        $http.post('/api/v1/auth/validate-otp',data)
        .then(function(resp) {
          if (resp.data.user.user_type === 'admin') {
            swal({
              title: "Code Verified",
              type: "success",
              timer: 2000,
              showConfirmButton: false
            }, function() {
              swal.close();
              CustomStorageService.SignInService(true,false,false,false,resp.data.token,resp.data.user);
              const redirctData = CustomStorageService.getCourseDeleteLogin();
              const orderTerminateRedirctData = CustomStorageService.getOrderTerminateLogin();
              if(redirctData && redirctData.courseDeleteRedirect) {
                $state.go('deleteCourse',redirctData);
              } else if(orderTerminateRedirctData && orderTerminateRedirctData.courseDeleteRedirect) {
                $state.go('terminateOrders',orderTerminateRedirctData);
              } else {
                $state.go('AdminDashBoard',{},{reload:true});
              }
            });
          } else {
            swal({
              title: "Not Authorized!",
              type: "error",
              confirmButtonText: "Ok"
            }, function() {
              CustomStorageService.logOutService();
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Invalid Verification Code',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      };

      $scope.resendOtp = function() {
        const data = {
          user_id: $state.params.user_id,
          type: 'email',
        }
        $http.post('/api/v1/auth/resend-otp',data)
        .then(function(resp) {
          if (resp.data.success) {
            swal({
              title: "Code Sent",
              text: 'Invalid Verification Code',
              type: "success",
              showConfirmButton: true
            })
          } else {
            swal({
              title: "Error",
              type: "error",
              text: 'Error while sending code',
            }, function() {
              CustomStorageService.logOutService();
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Error while sending code',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      };
    }]);
  })();

(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('PaymentApprovalController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['paymentApprovals'];
			sr.searchData = [];
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				status: 'waitingForApproval',
				emailAdmin: CustomStorageService.getUserInfoStorageData().email,
				search: {
					phone: '',
					name: '',
					email: '',
				},
				orderBy: {
					column: 'orders.time',
					direction: 'DESC'
				}
			};
			sr.searchOrder = function (first, status) {
				if (first) {
					sr.searchParams.page = 1;
				}
				if(status) {
					sr.searchParams.status = status;
				}
				getOrders(sr.searchParams);
				getOrdersCount();
			}
			var getOrdersCount = function (){
				$http.get('api/v1/orders/payment-approvel/count')
                    .then(function (data) {
						// console.log(data);
						sr.pendingCount = data.data.counts.pendingCount;
						sr.approvedCount = data.data.counts.approvedCount;
						sr.rejectedCount = data.data.counts.rejectedCount;
                      });
			}
			var getOrders = function (data) {
				HttpService.postRequest('api/v1/orders/get', data)
					.then(function (res) {
						if (res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							}, function () {
								swal.close();
								sr.searchParams.forDownload = false;
							});

						} else {
							sr.orders = res.orders;
							sr.totalPages = res.pages;
							sr.totalCount = res.orderCount;
						}

					});
			}
			sr.onKeyDown = function(event){
				var e = window.event;
				var key = e.which || e.keyCode;
				if(13 == key) {
					$scope.searchOrder(true);
				}
			}
			sr.pagination = function (page) {
				sr.searchParams.page = page;
				sr.searchOrder(false);
			}

			$scope.updateOrder = function (order_ref, status){
				$http({
						url: '/api/v1/orders/update-order-status',
						method: "PUT",
						params: { ref_no: order_ref,status: status }
				}).then(function (data) {
						if (data.data.success) {
								swal({
										title: 'Order '+status+'!',
										text: "Order Status Updated!",
										type: 'success',
										showConfirmButton: true
								}, function () {
									getOrders(sr.searchParams);
								});
						}
				});
			}

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
				getOrdersCount();
			}
		}]);
})();

(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('OrderManagementController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', 'toaster', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService, toaster) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			const userData = CustomStorageService.getUserInfoStorageData();
      const isSuperAdmin = userData.is_super_admin;
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user', 'coupon', 'order', 'Market'];
			sr.searchData = [];
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				emailAdmin: userData.email
			};
			var timer;
			sr.searchOrder = function (value, type, flag, first, row) {

				if (timer) clearTimeout(timer);
				timer = setTimeout(function () {
					if (first) {
						sr.searchParams.page = 1;
					}
					if ((type === "user" || type === "course") && !flag) {
						SearchService.getSearchData(value, type)
							.then(function (data) {
								sr.searchData = data;
							});
					} else if ((type === 'coupon' && value.length > 7) || (type === 'order' && value.length > 3) || type === 'all') {
						getOrders(sr.searchParams);
					} else if ((type === "user" || type === "course") || type === 'Market' && flag) {
						if(row) {
							sr.searchParams.keyId = row.id;
						}
						sr.searchParams.key = value;
						sr.searchData = [];
						getOrders(sr.searchParams);
					}
				}, 800);

				
			}
			var getOrders = function (data) {
				var url = 'api/v1/orders/get';
				if(data.forDownload) {
					url = 'api/v1/orders/csv-download';
				}
				HttpService.postRequest(url, data)
					.then(function (res) {
						if (res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							}, function () {
								swal.close();
								sr.searchParams.forDownload = false;
							});

						} else {
							sr.orders = res.orders;
							sr.totalPages = res.pages;
							sr.totalCount = res.orderCount;
						}

					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true, false);
				}
			}
			sr.changeType = function (type) {
				sr.searchParams.type = type;
				sr.searchParams.key = "";
				if (type === 'all') {
					getOrders(sr.searchParams);
				}
				if (type === 'Market') {
					sr.searchData =[]
					getCourseTags()
				}else{
					sr.searchData =[]
				}

			}
			var getCourseTags = function (type) {
				$http({
				  url: "/api/v1/coursetag/get",
				  method: "GET",
				}).then(function (data) {
				  if (data && data.data) {
					data.data.courseTags.forEach(function (tag) {
					  sr.searchData.push({ id: tag.id, name: tag.name });
					});
				  }
				});
			  };
			$scope.showReasonPopup = false;
			$scope.selectedReason;
			sr.otherReason = '';
			$scope.selectedDisableOrder;
			$scope.closeCoursesWindow = function() {
				$scope.showReasonPopup = false;
				$scope.otherReason = '';
				$scope.selectedDisableOrder = null;
			}
			sr.callShowReasonPopup = function (order) {
				$scope.showReasonPopup = true;
				$scope.selectedDisableOrder = order;
				sr.otherReason = '';
			}

			sr.terminateOrder = function (id, disable_reason, other_reason) {
				$scope.closeCoursesWindow();
				var reason = disable_reason;
				if(disable_reason === 'other') {
					reason = angular.element('#otherReason').val();
				}
				$http({
					url: '/api/v1/orders/terminate',
					method: "GET",
					params: { id: id, disable_reason: reason }
				}).then(function (data) {
					if (data.data.success) {
						swal({
							title: 'Success!',
							text: "Order Status Updated!",
							type: 'success',
							showConfirmButton: true
						}, function () {
							getOrders(sr.searchParams);
						});
					}
				});
			}
			sr.freezeOrder = function (id) {
				$http({
					url: '/api/v1/orders/freeze-order/'+id,
					method: "PUT",
				}).then(function (data) {
					if (data.data.success) {
						swal({
							title: 'Success!',
							text: "Order Status Updated!",
							type: 'success',
							showConfirmButton: true
						}, function () {
							getOrders(sr.searchParams);
						});
					}
				});
			}
			sr.downloadOrders = function () {
				if ($scope.fromDate && $scope.toDate) {
					var hour = new Date().getHours();
					if(isSuperAdmin) {
						sr.searchParams.isAllowUnlimitedDownloadData = true;
					} else {
						sr.searchParams.isAllowUnlimitedDownloadData = false;
					}
					const date1 = new Date($scope.fromDate);
					const date2 = new Date($scope.toDate);
					date2.setHours(date2.getHours() + 12);
					const diffTime = Math.abs(date2 - date1);
					const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
					if (diffDays < 366) {
						var fromDate = new Date($scope.fromDate);
						fromDate = new Date(fromDate.getTime() + (3600000 * 5.00));
						var toDate = new Date($scope.toDate);
						toDate = new Date(toDate.getTime() + (3600000 * 5.00));
						sr.searchParams.fromDate = fromDate;
						sr.searchParams.toDate = toDate;
						sr.searchParams.forDownload = true;
						getOrders(sr.searchParams);
					} else {
						swal({
							title: 'Error',
							text: "select date b/w 1-365 days!",
							type: 'error',
							showConfirmButton: true
						}, function () {
							
						});
					}
				} else {
					swal({
						title: 'Error',
						text: "Please Select to and from date!",
						type: 'error',
						showConfirmButton: true
					}, function () {
						
					});
				}

			}

			// sr.formatDate = function (date) {
			// 	var dateOut = new Date(date);
			// 	dateOut = new Date(dateOut.getTime() + (3600000 * 5.00));
			// 	return dateOut;
			// };
			sr.viewOrderTrail =function (id){
				$state.go('AdminOrderEditTrail', {id: id});
			}

			var copylink = function (link) {
				
				var textArea = document.createElement("textarea");
				textArea.value = link;
				document.body.appendChild(textArea);
				textArea.select();
				document.execCommand("Copy");
				textArea.remove();
				toaster.success({
					title: "Link copied successfully",
				});
			};

			var paymentMethodOrder;
			sr.paymentMethodPopup = false;
			sr.closePaymentMethods = function () {
				sr.paymentMethodPopup = false;
			}

			sr.openPaymentMethods = function (order) {
				paymentMethodOrder = order;
				sr.paymentMethodPopup = true;
			}

			var paymentLink;
			sr.generatePaymentLink = function (paymentType) {
				console.log(paymentType)
				HttpService.getRequest('/api/v1/orders/get-paymob-url/' + paymentMethodOrder.id + '/' + paymentType, {multiorder: true})
				.then(function (res) {
					sr.closePaymentMethods();
					if(res && res.paymobData) {
						paymentLink = res.paymobData.iframe_url;
						swal({
							title: 'Payment Link Generated Successfully',
							type: "success",
							showConfirmButton: true,
							confirmButtonText: 'Copy Link',
						}, function () {
							copylink(res.paymobData.iframe_url);
							swal.close();
						});
					}
				});
			}

			

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
			}
		}]);
})();

(function () {
	'use strict';

	angular
		.module('NearPeer')
		.controller('orderEditTrailController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user', 'coupon', 'order'];
			sr.searchData = [];
			sr.orders = [];

			sr.getDifference =function(total,discount){
				return parseInt(total)-parseInt(discount);
			}
		
			var getOrderTrail = function () {
				var data = {id: $state.params.id};
				HttpService.getRequest('api/v1/access/get-order-trail', data)
					.then(function (res) {
						if(res.success){
							if (res.data.length>0) {
								sr.orders = res.data;
							}
						}
					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true, false);
				}
			}
			// sr.formatDate = function (date) {
			// 	var dateOut = new Date(date);
			// 	dateOut = new Date(dateOut.getTime() + (3600000 * 5.00));
			// 	return dateOut;
			// };

			sr.createCSV  = function(){
				var array = [];
					angular.forEach(sr.orders,function(order,index){
					var time = sr.formatDate(order.order.order.time)+'';
					var discount_price = order.order.order.discount_price > 0 ? sr.getDifference(order.order.order.price , order.order.order.discount_price) : 0;
					var access = order.order.order.status== 'paid' ? 'disable':order.order.order.status=='disabled'?'enable':order.order.order.status=='enabled'?'Close':null;
					var created_at = sr.formatDate(order.createdAt)+'';
					var arr = [
					index+1,
					order.order.order ? order.order.order.ref_no : '',
					order.order.order ? order.order.order.type : '',
					order.order.bundle_id ? order.order.bundle_id.name : '',
					order.order.course_id ? order.order.course_id.name : '',
					order.order.module_id ? order.order.module_id.name : '',
					order.order.order ? order.order.order.price : '',
					discount_price ? discount_price : '',
					order.order.order ? order.order.order.total : '',
					order.order.order ? order.order.order.user_balance : '',
					order.order.order.coupon_balance ? order.order.order.coupon_balance : '',
					order.order.couponId ?  order.order.couponId: '',
					order.order.user_id ? order.order.user_id.full_name || order.user_id.name : '',
					order.order.user_id.phone ? order.order.user_id.phone : '',
					order.order.user_id.email ? order.order.user_id.email : '',
					order.order.user_id.fb_email ? order.order.user_id.fb_email : '',
					order.order.user_id.crn ? order.order.user_id.crn : '',
					order.order.user_id.city ? order.order.user_id.city : '',
					time ? time : '',
					order.order.orderAccess.reason_id.reason ? order.order.orderAccess.reason_id.reason : '',
					order.order.proof ? order.order.proof : '',
					order.order.orderAccess.payment_id.name ? order.order.orderAccess.payment_id.name : '',
					order.order.orderAccess.comments ? order.order.orderAccess.comments : '',
					order.order.order.status ? order.order.order.status : '',
					order.updatedBy.email ? order.updatedBy.email : '',
					created_at ? created_at : '',
					];
					array.push(arr);
					if((index+1)===sr.orders.length){
						downlod_csv(array);	
					}
				})
			}		

			var downlod_csv = function(array) {
				var csv =  'No.,Ref No,Type,Bundle,Course,Module,Price,Discount,Revenue,Balance,Coup Bal,Coup ID,User,Phone,Primary Email,Facebook Email,CRN,City,Date,Reason for Free,Payment Proof,Payment Type,Comments,Status,Updated By,Updated At\n';
				array.forEach(function(row) {
				  	if(row){
						csv += row.join(',');
						csv += '\n';
				 	}
				});
				var parent = document.getElementById('download_csv');
				var hiddenElement = document.createElement('a');
				parent.appendChild(hiddenElement);
				hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
				hiddenElement.target = '_blank';
				var date = new Date().toUTCString();
				hiddenElement.download = 'OrderTrail.csv'+date+'.csv';
				hiddenElement.click();
				parent.removeChild(hiddenElement);
			}

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrderTrail();
			}
		}]);
})();

(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('editOrderController',
            ['UploadService', '$scope', '$state', 'HttpService', 'CustomStorageService',
                function (UploadService, $scope, $state, HttpService, CustomStorageService) {
                    var sr = $scope;
                    sr.orderCopy = {};
                    sr.open = false;
                    sr.orderId = 'JazzNp';
                    sr.key = "";
                    sr.order = [];
                    sr.orderIds = [];
                    sr.courses = [];
                    sr.modules = [];
                    sr.reasons = [];
                    sr.payTypes = [];
                    sr.types = true;
                    sr.access = {
                        type: null,
                        amount: null,
                        proof: null,
                        comments: null,
                        payment: null,
                        reason: null
                    };
                    sr.isCourseUpdated = true;
                    sr.showInfo = false;
                    sr.selectedUser = {}, 
                    sr.selectedCourse = {};
                    sr.selectedModule = {};
                    sr.selectedReason = {};
                    sr.selectedPaymentType = {};
                    sr.AllOrders = [];
                    sr.sessions = [];
                    sr.selectedOption = 'Purchase type';
                    sr.options = [{
                        name: 'Bundle',
                        id: 'bundle'
                    },
                    {
                        name: 'Course',
                        id: 'course'
                    },
                    {
                        name: 'Module',
                        id: 'module'
                    }];
                    var signedIn = CustomStorageService.getAdminSignedInStorageData();
                    var items = [];
                    var getSession = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.sessions = res.sessions;
                            });
                    }

                    sr.searchSession = function (value) {
                        getSession({ key: value, admin: true }, '/api/v1/session/search');
                    }

                    sr.selectSession = function (session) {
                        sr.sessionKey = session.name;
                        sr.session_id = session.id;
                        sr.sessions = [];
                    }

                    sr.selectSessionBlur = function (selectedCourse) {
                        setTimeout(function() {
                            sr.sessions = [];
                            $scope.$apply();
                        }, 500)
                    }

                    sr.searchOrder = function (orderId) {
                        if(sr.orderIds && sr.orderIds.length > 0){
                            sr.open = true;
                        }
                        getOrders({ id: orderId });
                    }                    
                    var getOrders = function (data) {
                        HttpService.getRequest('api/v1/orders/get-order-ids',data)
                            .then(function (res) {
                               sr.orderIds = res.orderIds;
                        });
                    }
                    sr.selectOrder = function (orderId) {
                        sr.showInfo = false;
                        sr.open = false;
                        getOrder(orderId);
                    }
                    var disableReasons = ["Refunded", "Piracy", "Installment case", "Account shifting", "Freezed"];
                    var getOrder = function (data) {
                        HttpService.getRequest('api/v1/orders/get-complete-order-by-id',data)
                        .then(function (res) {
                            if(res.success){
                                sr.showInfo = true;
                                sr.order = res.order;
                                sr.selectedUser = res.order.user_id;
                                sr.access = res.order.orderAccess;
                                sr.orderItems = res.order.orderItems;
                                sr.selectedReason = res.order.disable_reason;
                                if(!disableReasons.includes(sr.selectedReason)) {
                                    sr.selectedReason = 'other';
                                    sr.otherReason = res.order.disable_reason;
                                }
                                sr.selectedBundle = res.order.orderItems[0].bundle_id;
                                sr.selectedCourse = res.order.orderItems[0].course_id;
                                sr.selectedModule = res.order.orderItems[0].module_id;
                                var a = JSON.stringify(res.order);
                                sr.orderCopy.order =  JSON.parse(a);
                                sr.orderCopy.user_id =  sr.orderCopy.order.user_id;
                                sr.orderCopy.orderAccess =  sr.orderCopy.order.orderAccess;
                                sr.orderCopy.orderItems =  sr.orderCopy.order.orderItems;
                                sr.orderCopy.course_id =  sr.orderCopy.order.orderItems[0].course_id;
                                sr.orderCopy.module_id =  sr.orderCopy.order.orderItems[0].module_id;
                                sr.orderCopy.bundle_id =  sr.orderCopy.order.orderItems[0].bundle_id;
                                if(res.order.session_id) {
                                    sr.sessionKey = res.order.session_id.name;
                                    sr.session_id = res.order.session_id.id;
                                }
                                sr.selectedModuleName = '';
                                if(sr.selectedBundle){
                                    try {
                                        sr.access.type = 'bundle';
                                        sr.selectedOption = 'Bundle';
                                        sr.courseKey = sr.selectedBundle.name;
                                        sr.orderPrice = sr.selectedBundle.price;
                                        sr.selectedModule = null;
                                        sr.selectedCourse = null;
                                        sr.orderItems.forEach(function(item) {
                                            items.push({
                                                course_id: item.course_id ? item.course_id.id : null,
                                                module_id: item.module_id ? item.module_id.id : null,
                                                bundle_id: item.bundle_id ? item.bundle_id.id : null
                                            })
                                        })
                                    } catch (error) {
                                        console.log('error');
                                        console.log(error);
                                    }
                                    
                                }else if(sr.selectedCourse && sr.selectedModule){
                                    sr.access.type = 'module';
                                    sr.selectedOption = 'Module';
                                    sr.courseKey = sr.selectedModule.price;
                                    items=[{
                                        course_id: sr.selectedCourse.id,
                                        module_id: sr.selectedModule.id,
                                        bundle_id: null
                                    }];
                                    getInfo({ id: sr.selectedCourse.id }, sr.access.type, 'api/v1/courses/getModulesByCourseId');
                                }else if(sr.selectedCourse){
                                    sr.access.type = 'course';
                                    sr.selectedOption = 'Course';
                                    sr.courseKey = sr.selectedCourse.name;
                                    sr.orderPrice = sr.selectedCourse.price;
                                    items=[{
                                        course_id: sr.selectedCourse.id,
                                        module_id: null,
                                        bundle_id: null
                                    }];
                                }
                                getPaymentType();
                                getReason();
                            }else{
                                swal({
                                    title: 'Error',
                                    text: res.message,
                                    type: "error",
                                    showConfirmButton: true
                                }, function () {
                                    swal.close();
                                });
                            }
                        });
                    }
                    sr.searchInfo = function (value, type) {
                        if (type === 'user') {
                            getInfo({ key: value }, type, 'api/v1/user/search');
                        } else if (type === 'course' || type === 'module') {
                            getInfo({ key: value }, 'course', 'api/v1/courses/search');
                        } else if (type === 'bundle') {
                            getBundle({ key: value, admin: true }, 'api/v1/bundle/find');
                        }
                    }
                    var getInfo = function (data, type, api) {
                        HttpService.getRequest(api, data)
                            .then(function (res) {
                                if (type === 'user') {
                                    sr.users = res.users;
                                } else if (type === 'course') {
                                    sr.courses = res.courses;
                                } else if (type === 'module') {
                                    sr.modules = res.modules; 
                                    sr.modules.forEach(function(modulee,key){
                                        if(modulee.id===sr.selectedModule.id){
                                            sr.selectedModuleName = module.name;
                                        }
                                    })
                                }
                            });
                    }
                    var getBundle = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.courses = res.bundles;
                            });
                    }
                    sr.addModule = function (module) {
                        sr.selectedModule = sr.modules[module];
                        if(sr.selectedModule.module_type.paid){
                            sr.orderPrice = sr.selectedModule.module_type.price;
                        }else{
                            sr.orderPrice = 0;
                        }
                        items = [{
                            course_id: sr.selectedCourse.id,
                            module_id: sr.selectedModule.id,
                            bundle_id: null
                        }];
                    }
                    sr.uploadImage = function (image, type) {
                        UploadService.uploadImage(image)
                            .then(function (data) {
                                if (type === 'user') {
                                    sr.selectedUser.cnic = data;
                                } else {
                                    sr.access.proof = data;
                                }
                            });
                    }
                    sr.purchaseType = function (type) {
                        sr.access.type = type.id;
                        sr.selectedOption = type.name;
                        sr.courseKey = '';
                        sr.selectedModuleName = '';
                    }
                    sr.addVariants = function (user, type) {
                        if (type === 'user') {
                            sr.selectedUser = user;
                            sr.userKey = sr.selectedUser.email || sr.selectedUser.fb_email;
                            sr.users = [];
                        } else if (type === 'course') {
                            sr.selectedCourse = user;
                            sr.courseKey = sr.selectedCourse.name;
                            sr.orderPrice = sr.selectedCourse.price;
                            sr.selectedModule = null;
                            sr.selectedModuleName = '';
                            sr.courses = [];
                            items = [{
                                course_id: sr.selectedCourse.id,
                                module_id: null,
                                bundle_id: null
                            }];
                        } else if (type === 'module') {
                            sr.selectedCourse = user;
                            sr.courseKey = sr.selectedCourse.name;
                            sr.selectedModule = null;
                            sr.courses = [];
                            getInfo({ id: sr.selectedCourse.id }, type, 'api/v1/courses/getModulesByCourseId');
                        } else if (type === 'bundle') {
                            sr.selectedBundle = user;
                            sr.selectedModule = null;
                            sr.courseKey = sr.selectedBundle.name;
                            sr.orderPrice = sr.selectedBundle.price;
                            sr.courses = [];
                            items = sr.selectedBundle.course;
                        }
                    }
                    sr.showAccesForm = function () {
                        if (Object.keys(sr.selectedUser).length === 0) {
                            swal("please add user")
                            return false;
                        }
                        if (Object.keys(sr.selectedCourse).length === 0) {
                            swal("please add course")
                            return false;
                        } if (sr.access.type === 'module' && Object.keys(sr.selectedModule).length === 0) {
                            swal("please add module")
                            return false;
                        }
                        sr.types = false;
                        sr.showInfo = true;
                    }
                    sr.accessVariants = function (value, type) {
                        if (type === 'reason') {
                            sr.access.reason_id = value;
                            sr.selectedReason = value;                          
                        } else {
                            sr.access.payment_id = value;
                            sr.selectedPaymentType = value.name;
                        }
                    }
                    var getReason = function () {
                        HttpService.getRequest('api/v1/reason/get')
                            .then(function (res) {
                                sr.reasons = res.reasons;
                                angular.forEach(sr.reasons,function(reason,index){
                                    if(reason.id===sr.access.reason_id.id){
                                        sr.selectedReason = reason;
                                    }
                                });
                            })
                    }
                    var getPaymentType = function () {
                        HttpService.getRequest('api/v1/payment/get')
                            .then(function (res) {
                                sr.payTypes = res.types;
                                angular.forEach(sr.payTypes,function(payType,index){
                                    if(payType.id===sr.access.payment_id.id){
                                        sr.selectedPaymentType=payType.name;
                                    }
                                });
                            });
                    }
                    
                    sr.updateOrder = function () {
                        if (sr.access.payment_id && !sr.access.payment_id.id) {
                            swal("Please add payment method")
                            return false;
                        }
                        if (!sr.access.amount) {
                            swal("Please add Amount Received Otherwise amount should be 1");
                            sr.access.amount = 1;
                            return false;
                        }
                        if (sr.access.reason_id && !sr.access.reason_id.id) {
                            if (!sr.access.proof) {
                                swal("Please attach payment proof ");
                                return false;
                            }
                        }
                        if (items.length === 0) {
                            return false;
                        }
                        var bdl = sr.selectedBundle;
                        var crs = sr.selectedCourse;
                        var mdl = sr.selectedModule;
                        if (sr.access.type === 'module') {
                            sr.selectedCourse = sr.selectedModule;
                        }
                        sr.order.total = sr.access.amount;
                        sr.order.discount = sr.access.amount;
                        sr.order.price = sr.orderPrice;
                        var reasonDisable;
                        if(sr.selectedReason === 'other') {
                            reasonDisable = angular.element('#otherReason').val();
                        } else {
                            reasonDisable = sr.selectedReason
                        }
                        var updatedOrder = {
                            user: sr.selectedUser,
                            disable_reason: reasonDisable,
                            session_id: sr.session_id,
                            course: sr.selectedCourse,
                            access: sr.access,
                            bdl: bdl,
                            crs: crs,
                            mdl: mdl,
                            items: items,
                            date: new Date(),
                            order: sr.order,
                            orderCopy: sr.orderCopy,
                            currentUser: CustomStorageService.getUserInfoStorageData().id
                        };
                        $scope.disabled = true;
                        HttpService.postRequest('/api/v1/access/update-complete-order', updatedOrder)
                        .then(function (res) {
                            $scope.disabled = false;
                            if (res.success) {
                                swal({
                                    title: "Order updated successfully!",
                                    type: "success",
                                    showConfirmButton: true
                                }, function (value) {
                                    if(value){
                                        location.reload();
                                    }
                                });
                            } else {
                                swal({
                                    title: 'Error',
                                    text: res.message,
                                    type: "error",
                                    showConfirmButton: true
                                }, function () {
                                    swal.close();
                                });
                            }
                        });
                    }
                    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                        $state.go('admin_panel', {}, { reload: true });
                    }
                }
            ]
        );
})();
(function () {
  "user strict";
  angular.module("NearPeer").controller("createOrderController", [
    "UploadService",
    "$scope",
    "$state",
    "HttpService",
    "CustomStorageService",
    function (
      UploadService,
      $scope,
      $state,
      HttpService,
      CustomStorageService
    ) {
      $scope.userOrder = {};
      $scope.singleSelected = false;
      $scope.bundleSelected = false;
      $scope.moduleSelected = false;
      $scope.jazzcashSelected = false;
      $scope.kuickpaySelected = false;
      $scope.payproSelected = false;
      $scope.courseSelect = function (courseType) {
      
        if(courseType === "single"){
          $scope.userOrder.courseType="single";
            $scope.singleSelected = true;
            console.log("COURSE TYPE", courseType,$scope.userOrder.courseType);
            $scope.bundleSelected = false;
            $scope.moduleSelected = false;

        }else if(courseType === "bundle"){
          $scope.userOrder.courseType="bundle";
            $scope.bundleSelected = true;
            console.log("COURSE TYPE", courseType,$scope.userOrder.courseType);
            $scope.singleSelected = false;
            $scope.moduleSelected = false;
        }else{
          $scope.userOrder.courseType="module";
            $scope.moduleSelected = true;
            console.log("COURSE TYPE", courseType,$scope.userOrder.courseType);
            $scope.singleSelected = false;
            $scope.bundleSelected = false;
        }
      };
      $scope.paymentSelect = function (paymentType) {
      
        if(paymentType === "jazzcash"){
          $scope.userOrder.paymentType="jazzcash";
            $scope.jazzcashSelected = true;
            console.log("PAYMENT TYPE", paymentType,$scope.userOrder.paymentType);
            $scope.kuickpaySelected = false;
            $scope.payproSelected = false;

        }else if(paymentType === "kuickpay"){
          $scope.userOrder.paymentType="kuickpay";
          $scope.kuickpaySelected = true;
            console.log("PAYMENT TYPE", paymentType,$scope.userOrder.paymentType);
            $scope.jazzcashSelected = false;
            $scope.payproSelected = false;
        }else{
          $scope.userOrder.paymentType="paypro";
            $scope.payproSelected = true;
            console.log("PAYMENT TYPE", paymentType,$scope.userOrder.paymentType);
            $scope.jazzcashSelected = false;
            $scope.kuickpaySelected = false;
        }
      };
      $scope.proceedOrder = function (order){
        console.log("ORDER",order);
        console.log("FORM",$scope.userOrder);
      }

    },
  ]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('npSharePercentageController', ['$scope', '$state', 'CustomStorageService', 'HttpService', "$http", function ($scope, $state, CustomStorageService, HttpService, $http) {

      $scope.courses = []

      $scope.goToState = function(state, data){
  			$state.go(state, data);
      };

      var getAllPrompts = function () {
        $http({
          url: '/api/v1/courses/get-np-share-percentage',
          method: "GET",
          data: {type: 'course'}
        }).then(function (data) {
          if (data.data.success) {
            $scope.courses = data.data.courses;
          } else {
            alert('server error');
          }
        });
      };

      getAllPrompts();
    }]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('nicheDiscountController', ['$scope', '$state', 'CustomStorageService', 'HttpService', '$http', 'env', function ($scope, $state, CustomStorageService, HttpService, $http, env) {
      var sr = $scope;
      $scope.selectedCourse = [];
      $scope.selectedCourseId = null
      $scope.selectedCourseName = ''
      $scope.discount_percentage,
      $scope.discount_to
      $scope.discount_from
      $scope.institution
      $scope.isUploading = false;
      sr.searchInfo = function (value) {
        getInfo({ key: value, unpublished: true }, 'api/v1/courses/search');
      }

      var getInfo = function (data, api) {
        HttpService.getRequest(api, data)
          .then(function (res) {
            sr.courses = res.courses;
          });
      }
      // $scope.$watch('institution', function(newValue, oldValue) {
      //   console.log("selectedInstitution changed from", oldValue, "to", newValue);
      // });    
      var getInsitutions = function () {
        $http({
          url: 'api/v1/courses/getUniversityList',
          method: "GET",
          params: { type: 'admin' }
        }).then(function (data) {
          sr.institutions = data.data;
          sr.institution = "Select Institution";
        });
      }();
      sr.updateInstitution = function (selectedInstitution) {
        console.log("I am called---------", selectedInstitution);
    
        // Find the institution object from the institutions array
        var institutionObj = $scope.institutions.find(function(institute) {
            return institute.institution === selectedInstitution;
        });
    
        if (!institutionObj) {
            console.error("Institution not found");
            return;
        }
    
        // Get the index of the selected institution
        var index = $scope.institutions.indexOf(institutionObj);
    
        // Set the selected institution and faculty
        $scope.institution = institutionObj.institution;
        sr.selected_faculty = institutionObj.faculties; // Set faculties based on the found institution
        sr.selectedInstituteNo = selectedInstitution;   // Store the institution name
    
        console.log("Selected Institution:", institutionObj);
        console.log("Index:", index);
    };
      sr.updateSchool = function (school) {
        sr.selectedFaculty = school;
      }
      // sr.selectCourse = function (course) {
      //   $scope.courses = [];
      //   $scope.courseKey = '';
      //   $scope.selectedCourseId = course.id
      //   $scope.selectedCourseName = course.name
      // }
      $scope.handleEdit = function(niche) {
            $scope.type='edit';
            $scope.handleScenario(niche)
        };

        // Function to update institution and load faculties
        $scope.updateInstitution = function(selectedInstitution) {
          // Use a regular function instead of an arrow function for compatibility
          var selectedInstitute = $scope.institutions.find(function(institute) {
              return institute.institution == selectedInstitution;
          });
          
          // Load faculties based on the selected institution
          $scope.selected_faculty = selectedInstitute ? selectedInstitute.faculties : [];
      };

        sr.handleClear=function(){
          $scope.type='create';
          $scope.institution = ''
          $scope.selectedSchool = ''
          $scope.discount_percentage = ''
          $scope.discount_from = ''
          $scope.discount_to = ''
        }
      $scope.deleteNiche = function (niche) {
        $scope.type='delete';
        $scope.handleScenario(niche)
      }

      $scope.handleScenario = function (niche)
      {
        $scope.institution = niche.institution;
        $scope.selectedSchool = niche.faculty ? niche.faculty : '';
        $scope.discount_percentage = niche.discount_percentage;
        $scope.discount_from = new Date(niche.discount_from);
        $scope.discount_to = new Date(niche.discount_to);
        // Update available faculties based on the selected institution
        $scope.updateInstitution($scope.institution);
      }

      var getArchiveCourses = function () {
        $http({
            url: '/api/v1/institute/get-niche-discount',
            method: 'GET'
        }).then(function (res) {
            $scope.nichesWithDiscount = res.data.data;
        });
    };    
      getArchiveCourses()

      $scope.addDiscount = function () {
        var type=$scope.type;
        // Check if all required fields are filled
        if (!$scope.institution || !$scope.discount_percentage || !$scope.discount_from || !$scope.discount_to) {
            swal({
                title: 'Error!',
                text: 'All fields are required. Please fill in the missing fields.',
                type: 'error',
                showConfirmButton: true
            });
            return; // Stop execution if validation fails
        }
    
        // Check if discount_percentage is within the valid range (0 to 100)
        if ($scope.discount_percentage < 0 || $scope.discount_percentage > 100) {
            swal({
                title: 'Error!',
                text: 'Discount percentage must be between 0 and 100.',
                type: 'error',
                showConfirmButton: true
            });
            return; // Stop execution if the discount percentage is out of range
        }
    
        // Check if "Discount From" date is not greater than "Discount To" date
        if (new Date($scope.discount_from) > new Date($scope.discount_to)) {
            swal({
                title: 'Error!',
                text: 'The "Discount From" date cannot be greater than the "Discount To" date.',
                type: 'error',
                showConfirmButton: true
            });
            return; // Stop execution if the date condition fails
        }
    
        $scope.isUploading = true;
        $http({
            url: '/api/v1/institute/niche-discount',
            method: 'POST',
            data: {
                institution: $scope.institution,
                faculty: sr.selectedSchool,
                discount_percentage: $scope.discount_percentage,
                discount_from: $scope.discount_from,
                discount_to: $scope.discount_to,
                type: type // Pass type to the API call
            }
        }).then(function (res) {
            $scope.isUploading = false;
            swal({
                title: 'Niche Added',
                text: 'Niche Added Successfully!',
                type: 'success',
                showConfirmButton: false,
                timer: 2000
            }, function () {
                swal.close();
            });
    
            // Handle response for create, edit, and delete
            var nicheDiscount = type !== 'create' ? res.data.nicheDiscount[0]:res.data.nicheDiscount;
            if (type === 'create') {
                // Push newly created discount
                $scope.nichesWithDiscount.push(nicheDiscount);
            } else {
                // Find and update existing discount
                for (var i = 0; i < $scope.nichesWithDiscount.length; i++) {
                    if ($scope.nichesWithDiscount[i].id === nicheDiscount.id) {
                        $scope.nichesWithDiscount[i] = nicheDiscount;
                        break;
                    }
                }
            } 
        }, function (error) {
            $scope.isUploading = false;
            swal({
                title: 'Error!',
                text: 'Something went wrong, please try again.',
                type: 'error',
                showConfirmButton: true
            });
        });
    };    
    
    }]);

})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("newComingEmailsController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      $scope.usersList = [];
      $scope.fromDate = '';
      $scope.toDate = '';
      $scope.count = 0;
      $scope.searchParams = {
        page: 1,
        per_page: 10
    };
      getEmails();
      function getEmails () {
        HttpService.postRequest("api/v1/users/getComingEmails",$scope.searchParams).then(
          function (res) {
            $scope.usersList = res.result;
            $scope.count = res.count;
          }
        );
      }

      $scope.downloadCSV = function() {
        if(!$scope.fromDate || !$scope.toDate) {
          swal({
            title: "Please Select From & To Date",
            type: "error",
            confirmButtonText: "Ok"
          }, function() {
            swal.close();
          });
        } else {
          HttpService.postRequest("/api/v1/visits/csv-new-emails", {from: $scope.fromDate, to: $scope.toDate, email: $scope.currentUser.email}).then(
            function (res) {
              if(res.success){
                swal({
                  title: "Success",
                  text: "We are compiling sheet you will receive email shortly!",
                  type: "success",
                  showConfirmButton: true
                }, function() {
                  swal.close();
                });
              }else{
                swal({
                  title: "Something Went Wrong",
                  type: "error",
                  confirmButtonText: "Ok"
                }, function() {
                  swal.close();
                });
              }
            });
        }
      }

      $scope.pagination = function (page) { 
        if (page > 0 && page <= numberTest($scope.count/$scope.searchParams.per_page)) {
          $scope.searchParams.page = page;
          getEmails();
        }
      }
      function numberTest(n)
      {
        var result = (n - Math.floor(n)) !== 0; 
        if (result)
          return n + 1;
        else
          return n;
        }
      },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("mobileServingController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      $scope.users = [];
      $scope.courses = [];
      $scope.usersList = [];
      $scope.selectedUser;
      $scope.userKey = "";
      $scope.userIP = "";
      $scope.password = "";

      HttpService.getRequest("api/v1/whitelist/whitelisted-users-mobile-serving").then(
        function (res) {
          $scope.usersList = res;
        }
      );
      
      $scope.moveTotrash = function (){
        $scope.selectedUser = {};
        $scope.selectedCourse = {};
      }

      $scope.selectUser = function (user) {
        $scope.selectedUser = user;
        $scope.users = [];
      }

      $scope.selectCourse = function (course) {
        $scope.selectedCourse = course;
        $scope.courses = [];
      }

      $scope.allowUser = function () {
        if($scope.selectedUser && $scope.selectedCourse) {
          var api = "api/v1/whitelist/allow-mobile-serving";
          var req = { userID: $scope.selectedUser.id, courseId: $scope.selectedCourse.id };
          HttpService.postRequest(api, req).then(function (res) {
            HttpService.getRequest("api/v1/whitelist/whitelisted-users-mobile-serving").then(
              function (res) {
                $scope.usersList = res;
                $scope.selectedUser = {};
                $scope.selectedCourse = {};
              }
            );
          });
        }
      };

      $scope.deleteUser = function (id) {
        var api = "/api/v1/whitelist/delete-user-mobile-serving";
        var req = { id: id };
        swal({
          title: "Are you sure you want to delete this user's access",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                HttpService.getRequest("api/v1/whitelist/whitelisted-users-mobile-serving").then(
                  function (res) {
                    $scope.usersList = res;
                  }
                );
              });
            }
          });
      };

      $scope.goto = function (data){
        var param = data.id;
        $state.go('user_ips', {id: param})
      }

      $scope.getInfo = function (data) {
        var api = "api/v1/user/search";
        var req = { key: data };
        HttpService.getRequest(api, req).then(function (res) {
          $scope.users = res.users;
        });
      };

      $scope.getCourseInfo = function (data) {
        var api = "api/v1/courses/search";
        var req = { key: data };
        HttpService.getRequest(api, req).then(function (res) {
          $scope.courses = res.courses;
        });
      };
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('mobilePopupConfigController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      var data = {page: $scope.currentPage, per_page: 30, type: '1'};

      $http({
        url: 'api/v1/mobile-browser-config/get-all-configs',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.configs = data.data.configs;
        $scope.total_config_pages = data.data.totalPages;
        $scope.total_cofings = data.data.totalCount;
      });

      $scope.disableConfig = function(config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to disable Mobile Browser Config",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/mobile-browser-config/delete-config/' + config.id,
              method: "GET",
              params: data
            }).then(function(data) {
              if(data.data.success) {
                $scope.showNext('same');
                swal({
                  title: "Success",
                  text: "Mobile Browser Config Disabled Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Mobile Browser Config Deleting",
                  type: "error"
                },function(){})
              }
            });
          }
        });


        
      }

      $scope.editConfig = function(config) {
        $state.go('edit_mobile_popup_config',{id: config.id})
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = {page: $scope.currentPage, per_page: 30, type: '1'};
        $http({
          url: 'api/v1/mobile-browser-config/get-all-configs',
          method: "GET",
          params: data
        }).then(function(data) {
          $scope.configs = data.data.configs;
          $scope.total_config_pages = data.data.totalPages;
          $scope.total_cofings = data.data.totalCount;
        });
      }

    }]);
  })();
  
(function () {
  "use strict";
  angular.module("NearPeer").controller("MergeAccountsController", [
    "$scope",
    "$http",
    "HttpService",
    function ($scope, $http, HttpService) {
      $scope.labels = [];
      $scope.series = [
        "Total Revenue",
        "Total Enrollments",
        "Total Promo Codes Used",
        "Total Signups"
      ];

      $scope.data = [[], [], [], []];

      $scope.searchInfo = function (value, type) {
        getInfo({ key: value }, type, "api/v1/user/search");
      };

      var getInfo = function (data, type, api) {
        HttpService.getRequest(api, data).then(function (res) {
          $scope.users = res.users;
        });
      };

      $scope.selectUser = function (user, type) {
        $scope.users = [];
        $http
          .post("api/v1/user/get-accounts-with-email", { user_id: user.id, admin: true })
          .then(function (data) {
            if (data.data.users) {
              $scope.userAccounts = data.data.users;
            }
          });
      };

      $scope.mergeAccount = function (user) {
        $scope.users = [];
        $http
          .post("api/v1/user/merge-accounts", {
            user_id: user.id
          })
          .then(function (data) {
            $scope.userAccounts = [];
            swal({
              title: "Merged",
              text: "Accounts successfully merged",
              type: "success"
            })
          });
      };
    }
  ]);
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('instructorController', ['$scope','$state','CustomStorageService', 'HttpService', '$http', function($scope,$state,CustomStorageService, HttpService, $http) {
    var signedIn = CustomStorageService.getAdminSignedInStorageData();

    var getInstructors = function () {
      HttpService.getRequest('/api/v1/instructors/getStoredInstructors')
      .then(function (res) {
        if (res.success) {
          $scope.courseTags = res.instructors;
        } 
      });
    }

    $scope.editTag = function (id) {
      $state.go('AdminEditInstructor', {id: id})
    }

    $scope.deleteTag = function (id) {

      swal(
        {
          title: "Are you sure you want to delete this Bundle",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              url:"/api/v1/instructors/deleteInstructor/"+id,
              method:'DELETE'
            }).then(function (res) {
              if(res){
                if(res.data.success) {
                  console.log('Success ,Successfully Deleted! ,success');
                  var index = $scope.courseTags.findIndex(function (instructor) {
                    return instructor.id === id;
                  });
                  if (index !== -1) {
                      $scope.courseTags.splice(index, 1);
                  }
                  getTags()
                } else {
                  swal('Error',res.data.message,'error');
                }
                
              }else{
                swal('Error','Error saving tag!','error');
              }
            });
          }
        }
      );

      
    }

    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
      $state.go('admin_panel', {}, { reload: true });
    } else {
      getInstructors();
    }
  }]);
})();

(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('installmentOrdersDetailController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			const userData = CustomStorageService.getUserInfoStorageData();
      const isSuperAdmin = userData.is_super_admin;
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user', 'coupon', 'order'];
			sr.searchData = [];
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				emailAdmin: userData.email
			};
			var timer;

			sr.createInstallment = function () {
				$state.go("AdminCreateInstallment", { order_id: $state.params.order_id });
			}
			sr.searchOrder = function (value, type, flag, first, row) {

				if (timer) clearTimeout(timer);
				timer = setTimeout(function () {
					if (first) {
						sr.searchParams.page = 1;
					}
					if ((type === "user" || type === "course") && !flag) {
						SearchService.getSearchData(value, type)
							.then(function (data) {
								sr.searchData = data;
							});
					} else if ((type === 'coupon' && value.length > 7) || (type === 'order' && value.length > 3) || type === 'all') {
						getOrders(sr.searchParams);
					} else if ((type === "user" || type === "course") && flag) {
						if(row) {
							sr.searchParams.keyId = row.id;
						}
						sr.searchParams.key = value;
						sr.searchData = [];
						getOrders(sr.searchParams);
					}
				}, 800);

				
			}
			var getOrders = function (data) {
				data.parentOrderId = $state.params.order_id;
				HttpService.postRequest('api/v1/orders/get', data)
					.then(function (res) {
						if (res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							}, function () {
								swal.close();
								sr.searchParams.forDownload = false;
							});

						} else {
							sr.orders = res.orders;
							sr.totalPages = res.pages;
							sr.totalCount = res.orderCount;
						}

					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true, false);
				}
			}
			sr.changeType = function (type) {
				sr.searchParams.type = type;
				sr.searchParams.key = "";
				if (type === 'all') {
					getOrders(sr.searchParams);
				}
			}
			$scope.showReasonPopup = false;
			$scope.selectedReason;
			sr.otherReason = '';
			$scope.selectedDisableOrder;
			$scope.closeCoursesWindow = function() {
				$scope.showReasonPopup = false;
				$scope.otherReason = '';
				$scope.selectedDisableOrder = null;
			}
			sr.callShowReasonPopup = function (order) {
				$scope.showReasonPopup = true;
				$scope.selectedDisableOrder = order;
				sr.otherReason = '';
			}

			sr.terminateOrder = function (id, disable_reason, other_reason) {
				$scope.closeCoursesWindow();
				var reason = disable_reason;
				if(disable_reason === 'other') {
					reason = angular.element('#otherReason').val();
				}
				$http({
					url: '/api/v1/orders/terminate',
					method: "GET",
					params: { id: id, disable_reason: reason }
				}).then(function (data) {
					if (data.data.success) {
						swal({
							title: 'Success!',
							text: "Order Status Updated!",
							type: 'success',
							showConfirmButton: true
						}, function () {
							getOrders(sr.searchParams);
						});
					}
				});
			}
			sr.downloadOrders = function () {
				if ($scope.fromDate && $scope.toDate) {
					var hour = new Date().getHours();
					if(isSuperAdmin) {
						sr.searchParams.isAllowUnlimitedDownloadData = true;
					} else {
						sr.searchParams.isAllowUnlimitedDownloadData = false;
					}
					const date1 = new Date($scope.fromDate);
					const date2 = new Date($scope.toDate);
					date2.setHours(date2.getHours() + 12);
					const diffTime = Math.abs(date2 - date1);
					const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
					if (diffDays < 366) {
						var fromDate = new Date($scope.fromDate);
						fromDate = new Date(fromDate.getTime() + (3600000 * 5.00));
						var toDate = new Date($scope.toDate);
						toDate = new Date(toDate.getTime() + (3600000 * 5.00));
						sr.searchParams.fromDate = fromDate;
						sr.searchParams.toDate = toDate;
						sr.searchParams.forDownload = true;
						getOrders(sr.searchParams);
					} else {
						swal({
							title: 'Error',
							text: "select date b/w 1-365 days!",
							type: 'error',
							showConfirmButton: true
						}, function () {
							
						});
					}
				} else {
					swal({
						title: 'Error',
						text: "Please Select to and from date!",
						type: 'error',
						showConfirmButton: true
					}, function () {
						
					});
				}

			}

			// sr.formatDate = function (date) {
			// 	var dateOut = new Date(date);
			// 	dateOut = new Date(dateOut.getTime() + (3600000 * 5.00));
			// 	return dateOut;
			// };
			sr.viewOrderTrail =function (id){
				$state.go('AdminOrderEditTrail', {id: id});
			}

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
			}
		}]);
})();

(function () {
	'use strict';

	angular
		.module('NearPeer')

		.controller('installmentOrdersController', ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
			$(document).ready(function () {
				$(this).scrollTop(0);
			});
			var sr = $scope;
			var signedIn = CustomStorageService.getAdminSignedInStorageData();
			const userData = CustomStorageService.getUserInfoStorageData();
      const isSuperAdmin = userData.is_super_admin;
			sr.pageRow = [10, 50, 100, 200, 400];
			sr.searchType = ['all', 'course', 'user', 'coupon', 'order'];
			sr.searchData = [];
			sr.searchParams = {
				key: "",
				type: sr.searchType[0],
				page: 1,
				per_page: sr.pageRow[0],
				forDownload: false,
				emailAdmin: userData.email
			};
			var timer;
			sr.searchOrder = function (value, type, flag, first, row) {

				if (timer) clearTimeout(timer);
				timer = setTimeout(function () {
					if (first) {
						sr.searchParams.page = 1;
					}
					if ((type === "user" || type === "course") && !flag) {
						SearchService.getSearchData(value, type)
							.then(function (data) {
								sr.searchData = data;
							});
					} else if ((type === 'coupon' && value.length > 7) || (type === 'order' && value.length > 3) || type === 'all') {
						getOrders(sr.searchParams);
					} else if ((type === "user" || type === "course") && flag) {
						if(row) {
							sr.searchParams.keyId = row.id;
						}
						sr.searchParams.key = value;
						sr.searchData = [];
						getOrders(sr.searchParams);
					}
				}, 800);

				
			}
			var getOrders = function (data) {
				data.isInstallment = true;
				HttpService.postRequest('api/v1/orders/get', data)
					.then(function (res) {
						if (res.message) {
							swal({
								title: res.message,
								type: "success",
								showConfirmButton: true
							}, function () {
								swal.close();
								sr.searchParams.forDownload = false;
							});

						} else {
							sr.orders = res.orders;
							sr.totalPages = res.pages;
							sr.totalCount = res.orderCount;
						}

					});
			}
			sr.pagination = function (page) {
				if (page > 0 && page <= sr.totalPages) {
					sr.searchParams.page = page;
					sr.searchOrder(sr.searchParams.key, sr.searchParams.type, true, false);
				}
			}
			sr.changeType = function (type) {
				sr.searchParams.type = type;
				sr.searchParams.key = "";
				if (type === 'all') {
					getOrders(sr.searchParams);
				}
			}
			$scope.showReasonPopup = false;
			$scope.selectedReason;
			sr.otherReason = '';
			$scope.selectedDisableOrder;
			$scope.closeCoursesWindow = function() {
				$scope.showReasonPopup = false;
				$scope.otherReason = '';
				$scope.selectedDisableOrder = null;
			}
			sr.callShowReasonPopup = function (order) {
				$scope.showReasonPopup = true;
				$scope.selectedDisableOrder = order;
				sr.otherReason = '';
			}

			sr.viewInstallments = function (id) {
				$state.go("AdminInstallmentOrdersDetail", { order_id: id });
			}

			sr.createInstallment = function (order) {
				$state.go("AdminCreateInstallment", { installment_id: order.installment_id});
			}

			$scope.prevInstallId;
			sr.rowSpan = function (orders, index) {
				if(orders[index].installment_id !== $scope.prevInstallId) {
					$scope.prevInstallId = orders[index].installment_id;
				}
				if(orders[index + 5] && orders[index + 5].installment_id ===  $scope.prevInstallId) return 6;
				else if(orders[index + 4] && orders[index + 4].installment_id ===  $scope.prevInstallId) return 5;
				else if(orders[index + 3] && orders[index + 3].installment_id ===  $scope.prevInstallId) return 4;
				else if(orders[index + 2] && orders[index + 2].installment_id ===  $scope.prevInstallId) return 3;
				else if(orders[index + 1] && orders[index + 1].installment_id ===  $scope.prevInstallId) return 2;
				else if(orders[index] && orders[index].installment_id ===  $scope.prevInstallId) return 1;
			}

			sr.rowSpanCondition = function (order, index) {
				if(order.installment_id !== $scope.prevInstallId || orders.length === 1) {
					return true;
				}
				return false;
			}

			sr.terminateOrder = function (id, disable_reason, other_reason) {
				$scope.closeCoursesWindow();
				var reason = disable_reason;
				if(disable_reason === 'other') {
					reason = angular.element('#otherReason').val();
				}
				$http({
					url: '/api/v1/orders/terminate',
					method: "GET",
					params: { id: id, disable_reason: reason }
				}).then(function (data) {
					if (data.data.success) {
						swal({
							title: 'Success!',
							text: "Order Status Updated!",
							type: 'success',
							showConfirmButton: true
						}, function () {
							getOrders(sr.searchParams);
						});
					}
				});
			}
			sr.downloadOrders = function () {
				if ($scope.fromDate && $scope.toDate) {
					var hour = new Date().getHours();
					if(isSuperAdmin) {
						sr.searchParams.isAllowUnlimitedDownloadData = true;
					} else {
						sr.searchParams.isAllowUnlimitedDownloadData = false;
					}
					const date1 = new Date($scope.fromDate);
					const date2 = new Date($scope.toDate);
					date2.setHours(date2.getHours() + 12);
					const diffTime = Math.abs(date2 - date1);
					const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
					if (diffDays < 366) {
						var fromDate = new Date($scope.fromDate);
						fromDate = new Date(fromDate.getTime() + (3600000 * 5.00));
						var toDate = new Date($scope.toDate);
						toDate = new Date(toDate.getTime() + (3600000 * 5.00));
						sr.searchParams.fromDate = fromDate;
						sr.searchParams.toDate = toDate;
						sr.searchParams.forDownload = true;
						getOrders(sr.searchParams);
					} else {
						swal({
							title: 'Error',
							text: "select date b/w 1-365 days!",
							type: 'error',
							showConfirmButton: true
						}, function () {
							
						});
					}
				} else {
					swal({
						title: 'Error',
						text: "Please Select to and from date!",
						type: 'error',
						showConfirmButton: true
					}, function () {
						
					});
				}

			}

			// sr.formatDate = function (date) {
			// 	var dateOut = new Date(date);
			// 	dateOut = new Date(dateOut.getTime() + (3600000 * 5.00));
			// 	return dateOut;
			// };
			sr.viewOrderTrail =function (id){
				$state.go('AdminOrderEditTrail', {id: id});
			}

			if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
				$state.go('admin_panel', {}, { reload: true });
			} else {
				getOrders(sr.searchParams);
			}
		}]);
})();

(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('CreateInstallmentController',
            ['UploadService', '$scope', '$state', 'HttpService', 'CustomStorageService', '$http', 'env', '$timeout',
                function (UploadService, $scope, $state, HttpService, CustomStorageService, $http, env, $timeout) {
                    var sr = $scope;
                    sr.notifyByWhatsapp = false;
                    sr.key = "";
                    sr.users = [];
                    sr.sessions = [],
                    sr.courses = [];
                    sr.modules = [];
                    sr.reasons = [];
                    sr.payTypes = [];
                    sr.allAgent = [];
                    sr.agents = [];
                    sr.types = true;
                    sr.sessionKey = '';
                    sr.access = {
                        type: null,
                        amount: null,
                        proof: null,
                        comments: null,
                        payment_id: null,
                        reason_id: null,
                        accessType: 'installment',
                        orderStatus: 'paid'
                    };
                    sr.showInfo = true;
                    sr.selectedUser = {}, sr.selectedCourse = {}, sr.selectedCourses = [];
                    sr.selectedModule = {};
                    sr.order = {};
                    var signedIn = CustomStorageService.getAdminSignedInStorageData();
                    var items = [];

                    var getOrderDetail = function () {
                        $http
                        .get("/api/v1/orders/installment-order-detail/" + $state.params.installment_id)
                        .then(
                        function (response) {
                            if (response.data.success) {
                                var orders = response.data.orders;
                                sr.selectedUser = orders[0].user_id;
                                orders.forEach(function(order) {
                                    var item = order.order_items[0];
                                    if(item.course && item.course.id) {
                                        sr.selectedCourse = item.course;
                                        sr.selectedCourse.type = 'course';
                                        sr.selectedCourse.parentOrderId = order.id;
                                        sr.selectedCourse.totalInstallmentAmount = order.total_installment_amount;
                                        sr.selectedCourse.totalInstallmentsAmountPaid = order.totalInstallmentsAmountPaid;
                                        sr.selectedCourse.totalInstallmentsCount = order.totalInstallmentsCount;
                                        items.push({
                                            course_id: item.course_id,
                                            module_id: null,
                                            bundle_id: null
                                        })
                                        sr.selectedCourse.items = [{
                                            course_id: item.course_id,
                                            module_id: null,
                                            bundle_id: null
                                        }];
                                        sr.selectedCourses.push(sr.selectedCourse);
                                    } else if(item.course && item.course.length) {
                                        sr.selectedCourse = item;
                                        sr.selectedCourse.type = 'bundle';
                                        sr.selectedCourse.parentOrderId = order.id;
                                        sr.selectedCourse.totalInstallmentAmount = order.total_installment_amount;
                                        sr.selectedCourse.totalInstallmentsAmountPaid = order.totalInstallmentsAmountPaid;
                                        sr.selectedCourse.totalInstallmentsCount = order.totalInstallmentsCount;
                                        items = item.course;
                                        sr.selectedCourse.items = items;
                                        sr.selectedCourses.push(sr.selectedCourse);
                                    }
                                })
                            }
                        },
                        function (error) {
                        }
                        );
                    }

                    var getAgents = function () {
                        $http
                        .get("https://apigateway.nearpeer.org/lmsservice/v1/odoo/get-all-odoo-agents")
                        .then(
                        function (response) {
                            if (response.data.success) {
                                sr.allAgent = response.data.agents;
                                // sr.agents = response.data.agents;
                            }
                            // $scope.existingTags = response.data.tags;
                        },
                        function (error) {
                            setTimeout(function() {
                                getAgents()
                            }, 10000)
                        }
                        );
                    }

                    var getCampaigns = function () {
                        $http.get("/api/v1/campaign/get-campaign-names").then(function (resp) {
                            if (resp.data.success) {
                                sr.campaigns = resp.data.campaigns;
                                console.log('sr.campaigns');
                                console.log(sr.campaigns);
                            } else {
                              console.log("network error");
                            }
                          });
                    }
                    

                    sr.searchInfo = function (value, type) {
                        if (type === 'user') {
                            getInfo({ key: value }, type, 'api/v1/user/search');
                        } else if (type === 'course' || type === 'module') {

                            getInfo({ key: value, paid: true }, 'course', 'api/v1/courses/search');
                        } else if (type === 'bundle') {
                            getBundle({ key: value, admin: true }, 'api/v1/bundle/find');
                        }
                    }

                    sr.searchAgent = function (text) {
                        sr.agents = sr.allAgent.filter(function (agent) {
                            return agent.name.toLowerCase().includes(text.toLowerCase());
                          });
                    }

                    sr.focusAgent = function () {
                        $scope.hideAgent = false;
                        $scope.agents = $scope.allAgent; 
                        sr.agentKey = '';
                    }

                    sr.agentBlur = function () {
                        $timeout(function(){
                            $scope.agents = [];
                            $scope.hideAgent = true;
                            sr.agentKey = '';
                        }, 200)
                    }

                    sr.selectAgent = function (agent) {
                        $scope.agents = [];
                        if(agent === 'none') {
                            delete sr.access.agent;
                        } else {
                            sr.access.agent = agent;
                        }
                        // $scope.$apply()
                    }

                    $scope.selectedCampaigns = [];
                    $scope.hideCampaign = true;

                    sr.searchCampaign = function (text) {
                        $scope.selectedCampaigns = sr.campaigns.filter(function (agent) {
                            return agent.name.toLowerCase().includes(text.toLowerCase());
                          });
                    }

                    sr.focuscampaign = function () {
                        $scope.hideCampaign = false;
                        sr.campaignKey = '';
                    }

                    sr.campaignBlur = function () {
                        $timeout(function(){
                            $scope.hideCampaign = true;
                            sr.campaignKey = '';
                        }, 200)
                    }

                    sr.selectCampaign = function (agent) {
                        $scope.selectedCampaigns.push(agent);
                    }

                    var getSession = function (data, api, selectedCourse) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                selectedCourse.sessions = res.sessions;
                            });
                    }

                    var getBundle = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.courses = res.bundles;
                            });
                    }
                    var timer;
                    var getInfo = function (data, type, api) {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            HttpService.getRequest(api, data)
                            .then(function (res) {
                                if (type === 'user') {
                                    sr.users = res.users;
                                } else if (type === 'course') {
                                    sr.courses = res.courses;
                                } else if (type === 'module') {
                                    sr.modules = res.modules;
                                }
                            });
                        }, 800);
                        
                    }
                    sr.addModule = function (module) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === module.id && course.type === 'module') {
                                isAllowed = false
                            }
                        })
                        if(isAllowed) {
                            HttpService.getRequest('/api/v1/access/verify', {user_id: sr.selectedUser.id, course_id: sr.selectedCourse.id, module_id: sr.modules[module].id, type: 'module'})
                            .then(function (res) {
                                if(!res.success) {
                                    swal({
                                        title: "Error!",
                                        text: res.message,
                                        type: "error",
                                        confirmButtonText: "Ok"
                                    });
                                } else {
                                    $scope.reactivate = res.reactivate;
                                    sr.selectedModule = sr.modules[module];
                                    sr.selectedModule.type = 'module';
                                    if(res.courseReactivate) {
                                        sr.selectedModule.courseReactivate = true;
                                    }
                                    sr.selectedModule.price = sr.selectedModule.module_type.price;
                                    items = [{
                                        course_id: sr.selectedCourse.id,
                                        module_id: sr.selectedModule.id,
                                        bundle_id: null
                                    }];
                                    sr.selectedModule.items = items;
                                    sr.selectedCourses.push(sr.selectedModule);
                                }
                            });  
                        }
                    }
                    sr.uploadImage = function (image, type) {
                        UploadService.uploadImage(image)
                            .then(function (data) {
                                if (type === 'user') {
                                    sr.selectedUser.cnic = data;
                                } else {
                                    sr.access.proof = data;
                                }
                            });
                    }
                    sr.purchaseType = function (type) {
                        sr.access.type = type;
                        items = [];
                        sr.courseKey = "";
                        sr.userKey = "";
                    }
                    sr.searchSession = function (selectedCourse, value) {
                        getSession({ key: value, admin: true }, '/api/v1/session/search', selectedCourse);
                    }
                    sr.selectSession = function (selectedCourse, session) {
                        selectedCourse.sessionKey = session.name;
                        selectedCourse.session_id = session.id;
                        selectedCourse.sessions = [];
                        sr.access.session_id = session.id;
                        sr.access.session_name = session.name;
                    }
                    sr.selectSessionBlur = function (selectedCourse) {
                        setTimeout(function() {
                            selectedCourse.sessions = [];
                            $scope.$apply();
                        }, 500)
                    }
                    sr.addVariants = function (user, type) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === user.id && (type === course.type || type == 'module')) {
                                isAllowed = false
                            }
                        })
                        if(isAllowed) {
                            if(!sr.selectedUser.id && type !== 'user') {
                                swal("please select user first");
                                sr.courses = [];
                                sr.users = [];
                                sr.courseKey = ""
                                return
                            }
                            else if(type === 'course' || type === 'module' || type === 'bundle') {
                                HttpService.getRequest('/api/v1/access/verify', {user_id: sr.selectedUser.id, course_id: user.id, bundle_id: user.id, type: type === 'module' ? 'course' : type})
                                .then(function (res) {
                                    if(!res.success) {
                                        swal({
                                            title: "Error!",
                                            text: res.message,
                                            type: "error",
                                            confirmButtonText: "Ok"
                                        });
                                    } else {
                                        $scope.reactivate = res.reactivate;
                                        if (type === 'course') {
                                            sr.selectedCourse = user;
                                            sr.selectedCourse.type = type;
                                            sr.courseKey = sr.selectedCourse.name;
                                            if(res.courseReactivate) {
                                                sr.selectedCourse.courseReactivate = true;
                                            }
                                            sr.courses = [];
                                            items = [{
                                                course_id: sr.selectedCourse.id,
                                                module_id: null,
                                                bundle_id: null
                                            }];
                                            sr.selectedCourse.items = items;
                                            sr.selectedCourses.push(sr.selectedCourse);
                                            sr.courseKey = ""
                                            validateDiscount();
                                            
                                        } else if (type === 'module') {
                                            sr.selectedCourse = user;
                                            sr.courseKey = sr.selectedCourse.name;
                                            sr.courses = [];
                                            getInfo({ id: sr.selectedCourse.id }, sr.access.type, 'api/v1/courses/getModulesByCourseId');
                                            // url: 'api/v1/courses/getModulesByCourseId',
                                            //         method: "GET",
                                            //         params: {id: id}
                                            // items.push({
                                            //     course_id: sr.course.course_id,
                                            //     module_id: sr.course.id,
                                            //     bundle_id: null
                                            //   });
                
                                        } else if (type === 'bundle') {
                                            sr.selectedCourse = user;
                                            sr.selectedCourse.type = type;
                                            sr.courseKey = sr.selectedCourse.name;
                                            sr.courses = [];
                                            items = sr.selectedCourse.course;
                                            sr.selectedCourse.items = items;
                                            sr.selectedCourses.push(sr.selectedCourse);
                                            sr.courseKey = "";
                                        }
                                    }
                                });
                            } else {
                                sr.reactivate = false;
                                sr.selectedUser = user;
                                sr.userKey = sr.selectedUser.email || sr.selectedUser.fb_email;
                                sr.users = [];
                            }
                        } else {
                            sr.courses = [];
                            sr.users = [];
                            sr.courseKey = ""
                        }
                    }
                    sr.removeCourse = function (index) {
                        sr.selectedCourses.splice(index, 1)
                    } 
                    sr.showAccesForm = function () {
                        if (Object.keys(sr.selectedUser).length === 0) {
                            swal("please add user")
                            return false;
                        }
                        if (Object.keys(sr.selectedCourse).length === 0) {
                            swal("please add course")
                            return false;
                        } if (sr.access.type === 'module' && Object.keys(sr.selectedModule).length === 0) {
                            swal("please add module")
                            return false;
                        }
                        sr.types = false;
                        sr.showInfo = true;
                    }
                    sr.accessVariants = function (value, type) {
                        if (type === 'reason') {
                            sr.access.reason_id = value;
                        } else {
                            sr.access.payment_id = value;
                        }
                    }
                    var getReason = function () {
                        HttpService.getRequest('api/v1/reason/get')
                            .then(function (res) {
                                if(res && res.reasons) {
                                    sr.reasons = res.reasons;
                                } else {
                                    setTimeout(function() {
                                        getReason()
                                    }, 10000)
                                }
                            })
                    }

                    var getPaymentType = function () {
                        HttpService.getRequest('api/v1/payment/get')
                            .then(function (res) {
                                if(res && res.types) {
                                    sr.payTypes = res.types;
                                } else {
                                    setTimeout(function() {
                                        getPaymentType()
                                    }, 10000)
                                }
                                
                            });
                    }
                    var validateDiscount = function () {
                        var today = new Date();
                        if (sr.selectedCourse.paid) {
                            if (!(sr.selectedCourse.discountTo > today && sr.selectedCourse.discountFrom <= today)) {
                                sr.selectedCourse.discount_price = 0;
                            }
                        }
                    }
                    sr.toggleNotifyByWhatsapp = function() {
                        sr.notifyByWhatsapp = !sr.notifyByWhatsapp;
                    }
                    sr.createAccess = function (user, course, access) {
                        $scope.disabled = true;
                        access.installmentID = $state.params.installment_id;
                        console.log('access.expiryDate');
                        console.log(access.expiryDate);
                        var myDate = new Date(access.expiryDate);
                        var today = new Date();
                        if(!user.phone && sr.notifyByWhatsapp){
                            swal("User Phone is required for whatsapp alert");
                            $scope.disabled = false;
                            return false;
                        }
                        if (!access.expiryDate || myDate < today ) { 
                            swal("Expiry date show be greater then current date")
                            $scope.disabled = false;
                            return false;
                        }
                        if (!access.notifyHours) {
                            swal("plesae add Notify Hours")
                            $scope.disabled = false;
                            return false;
                        }
                        if (!access.payment_id) {
                            swal("plesae add payment method")
                            $scope.disabled = false;
                            return false;
                        }
                        var isAmount = true;
                        course.forEach(function(course) {
                            if(!course.amount) {
                                isAmount = false;
                            }
                        });
                        if (!isAmount) {
                            swal("Please add Amount Received for all");
                            $scope.disabled = false;
                            return false;
                        }
                        if (!access.reason_id) {
                            if (!access.proof) {
                                swal("please attach payment proof ");
                                $scope.disabled = false;
                                return false;
                            }
                        }
                            
                        

                        if(!sr.access.agent) {
                            swal("Please add agent name")
                            $scope.disabled = false;
                            return false;
                        }

                        if (items.length === 0) {
                            $scope.disabled = false;
                            return false;
                        }
                        if (access.type === 'module') {
                            //course = sr.selectedModule;
                        }
                        access.campaigns = $scope.selectedCampaigns;
                        HttpService.postRequest('api/v1/access/create', {
                            user: user,
                            course: course,
                            access: access,
                            items: items,
                            notifyByWhatsapp: sr.notifyByWhatsapp
                        })
                            .then(function (res) {
                                $scope.disabled = false;
                                if (res.success) {
                                    
                                    var amountPaid = 0;
                                    course.forEach(function(c){
                                        amountPaid += c.amount;
                                    })
                                    // try{
                                    //     dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                                    //     dataLayer.push({
                                    //         'event': 'order-paid-page',
                                    //         'ecommerce': {
                                    //         'currencyCode': 'PKR',                       // Local currency is optional.
                                    //         'click': {
                                    //             'paymentMethod': access.payment_id.name,
                                    //             'price': amountPaid,
                                    //             'productType': '',
                                    //             'name': course[0].name,
                                    //             'brand': 'Nearpeer',
                                    //             'orderType': 'Admin-Order',
                                    //             'instName': $scope.course[0].institution || 'Default'

                                    //         }
                                            
                                    //         }
                                    //     })
                                    // }catch(err){
                                    //     console.log('data layer error -> ', err)
                                    // }
                                    swal({
                                        title: res.message,
                                        type: "success",
                                        showConfirmButton: true
                                    }, function () {
                                        $scope.disabled = false;
                                        swal.close();
                                        $state.go('AdminOrdersManagement');
                                    });
                                } else {
                                    swal({
                                        title: res.message,
                                        type: "error",
                                        showConfirmButton: true
                                    }, function () {
                                        $scope.disabled = false;
                                        swal.close();
                                    });
                                }
                            });
                    }
                    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                        $state.go('admin_panel', {}, { reload: true });
                    } else {
                        getPaymentType();
                        getReason();
                        getAgents();
                        getCampaigns();
                        getOrderDetail();
                    }
                }
            ]
        );
})();
(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('inBuildNotificationBarController', ['$scope', '$state', 'CustomStorageService', 'HttpService', '$http', 'env', function ($scope, $state, CustomStorageService, HttpService, $http, env) {
      var sr = $scope;
      $scope.isUploading = false;

      // Initialize separate arrays for different table types
      $scope.landingBars = [];
      $scope.nicheBars = [];
      $scope.courseBars = [];
      $scope.videoBars = [];

      // Search and pagination variables
      $scope.courseSearch = '';
      $scope.videoSearch = '';
      $scope.currentPageCourse = 1;
      $scope.currentPageVideo = 1;
      $scope.itemsPerPage = 10;

      // textAngular toolbar (limit to specific buttons)
      $scope.taToolbar = [
        ['p', 'bold', 'italics', 'underline']
      ];

      // Pagination functions for Course
      $scope.getTotalPagesCourse = function() {
        return Math.ceil($scope.courseBars.length / $scope.itemsPerPage);
      };

      $scope.nextPageCourse = function() {
        if ($scope.currentPageCourse < $scope.getTotalPagesCourse()) {
          $scope.currentPageCourse++;
        }
      };

      $scope.prevPageCourse = function() {
        if ($scope.currentPageCourse > 1) {
          $scope.currentPageCourse--;
        }
      };

      // Pagination functions for Video
      $scope.getTotalPagesVideo = function() {
        return Math.ceil($scope.videoBars.length / $scope.itemsPerPage);
      };

      $scope.nextPageVideo = function() {
        if ($scope.currentPageVideo < $scope.getTotalPagesVideo()) {
          $scope.currentPageVideo++;
        }
      };

      $scope.prevPageVideo = function() {
        if ($scope.currentPageVideo > 1) {
          $scope.currentPageVideo--;
        }
      };

      // Function to filter bars into separate arrays
      var filterBars = function() {
        $scope.landingBars = $scope.notificationBars.filter(function(bar) {
          return !bar.niche_name && !bar.course_id && !bar.video_id && (!bar.related_type || (bar.related_type !== 'course' && bar.related_type !== 'video'));
        });
        $scope.nicheBars = $scope.notificationBars.filter(function(bar) {
          return bar.niche_name;
        });
        $scope.courseBars = $scope.notificationBars.filter(function(bar) {
          return bar.related_type === 'course' || bar.course_id;
        });
        $scope.videoBars = $scope.notificationBars.filter(function(bar) {
          return bar.related_type === 'video' || bar.video_id;
        });
      };

      // Removed unused functions
        $scope.handleEdit = function(bar) {
            $scope.type = 'edit';
            $scope.selectedBarId = bar.id;
            $scope.content = bar.content;

            // Set page type
            if (bar.landing_page) {
                $scope.selectedType = 'landing';
            } else if (bar.niche_page) {
                $scope.selectedType = 'niche';
            } else if (bar.course_page) {
                $scope.selectedType = 'course';
            } else if (bar.video_page) {
                $scope.selectedType = 'video';
            } else {
                $scope.selectedType = 'landing';
            }
            
            // Set selected values for cascading dropdowns
            $scope.selectedInstitutionIndex = null;
            $scope.selectedInstitution = null;
            $scope.selectedFaculty = null;
            $scope.selectedCourseIndex = null;
            $scope.selectedCourse = null;
            $scope.selectedModuleIndex = null;
            $scope.selectedModule = null;
            
            // For niche page, set niche_id (institution)
            if (bar.niche_id) {
                $scope.niche_id = bar.niche_id;
            }
            
            // For course page, set course_id
            if (bar.course_id) {
                $scope.course_id = bar.course_id;
            }
            
            // For video page, set video_id
            if (bar.video_id) {
                $scope.video_id = bar.video_id;
            }
            
            // Set button fields
            $scope.button_text = bar.button_text || '';
            $scope.button_link = bar.button_link || '';
        };

        sr.handleClear = function() {
            $scope.type = 'create';
            $scope.content = '';
            $scope.niche_id = '';
            $scope.course_id = '';
            $scope.video_id = '';
            $scope.button_text = '';
            $scope.button_link = '';
            $scope.selectedType = 'landing';
            $scope.selectedBarId = null;
            
            // Reset cascading dropdown values
            $scope.selectedInstitutionIndex = null;
            $scope.selectedInstitution = null;
            $scope.selectedFaculty = null;
            $scope.selectedCourseIndex = null;
            $scope.selectedCourse = null;
            $scope.selectedModuleIndex = null;
            $scope.selectedModule = null;
            $scope.faculties = [];
            // $scope.courses = [];
            $scope.videos = [];
            $scope.modules = [];
        }

        $scope.deleteNotificationBar = function (bar) {
            $scope.type = 'delete';
            $scope.selectedBarId = bar.id;
            $scope.addNotificationBar();
        }

    var getNotificationBars = function () {
        $http({
            url: env.backendService + '/lmsservice/v1/in-build-notification-bar/get-bars',
            method: 'GET'
        }).then(function (res) {
            if (res.data.success) {
                $scope.notificationBars = res.data.data;
            } else {
                $scope.notificationBars = [];
            }
            filterBars(); // Filter into separate arrays after fetching
        });
    };
    getNotificationBars()

    // Initialize data arrays
    $scope.courses = [];
    $scope.videos = [];
    $scope.modules = [];
    
    $scope.selectedCourse = null;
    $scope.selectedModule = null;
    $scope.selectedVideo = null;
    $scope.selectedNiche = null;

    $scope.nicheCategories = [
      { name: 'CA', link: 'chartered-accountancy-final' },
      { name: 'SBI', link: 'sbi' },
      { name: 'ACCA', link: 'acca-courses' },
      { name: 'MDCAT', link: 'entry-test-preparation' },
      { name: 'Entry Tests', link: 'entry-test' },
      { name: 'CSS & PMS', link: 'css' },
      { name: 'O’Level & A’Level', link: 'https://cambridge.nearpeer.org/' },
      { name: 'FSc & Matric', link: 'fsc-matric' },
      { name: 'IELTS', link: 'english/online-courses/ielts-by-rabea-babar' },
      { name: 'Nearpeer Shop', link: 'https://bookpeer.nearpeer.org/' }
    ];


    loadAllCourses();

    $scope.updateInstitution = function(institutionIndex) {
        $scope.selectedInstitutionIndex = institutionIndex;
        
        if (institutionIndex !== '') {
            if ($scope.selectedType === 'niche') {
                // For niche page type, use static niche categories
                if ($scope.nicheCategories[institutionIndex]) {
                    $scope.selectedNicheIndex = institutionIndex;
                    $scope.selectedNiche = $scope.nicheCategories[institutionIndex];
                }
                $scope.selectedFaculty = null;
                // $scope.courses = [];
                $scope.selectedCourseIndex = null;
                $scope.selectedCourse = null;
                $scope.videos = [];
                $scope.selectedModuleIndex = null;
                $scope.selectedModule = null;
            } else {
                // For course/video page types, use university data
                if ($scope.universities[institutionIndex]) {
                    $scope.selectedInstitution = $scope.universities[institutionIndex];
                    $scope.faculties = $scope.universities[institutionIndex].faculties;
                    $scope.selectedFaculty = null;
                    // $scope.courses = [];
                    $scope.selectedCourseIndex = null;
                    $scope.selectedCourse = null;
                    $scope.videos = [];
                    $scope.selectedModuleIndex = null;
                    $scope.selectedModule = null;
                }
            }
        } else {
            $scope.selectedInstitution = null;
            $scope.faculties = [];
        }
    };

    function loadAllCourses() {
        $http({
            url: 'api/v1/courses/getAllCourses',
            method: 'GET'
        }).then(function(res) {
            console.log('res--', res)
            $scope.courses = res.data.courses || [];
        });
    }

    // Function to update modules when course is selected (ui-select passes object)
    $scope.updateCourse = function(courseObj) {
        console.log('courseObj', courseObj);
        $scope.selectedCourse = courseObj || null;
        if ($scope.selectedCourse && $scope.selectedCourse.id) {
            $http({
                url: 'api/v1/courses/getModulesByCourseId',
                method: 'GET',
                params: { id: $scope.selectedCourse.id }
            }).then(function(data) {
                $scope.modules = (data.data && data.data.modules) ? data.data.modules : [];
                $scope.selectedModule = null;
                $scope.videos = [];
            }, function() { $scope.modules = []; });
        } else {
            $scope.modules = [];
            $scope.videos = [];
        }
    };

    // Function to update videos when module is selected (ui-select passes object)
    $scope.updateModule = function(moduleObj) {
        $scope.selectedModule = moduleObj || null;
        if ($scope.selectedModule && $scope.selectedModule.id) {
            $http({
                url: 'api/v1/cvideos/getModuleVideos',
                method: 'GET',
                params: { module_id: $scope.selectedModule.id }
            }).then(function(data) {
                $scope.videos = (data.data && data.data.videos) ? data.data.videos : [];
            }, function() { $scope.videos = []; });
        } else {
            $scope.videos = [];
        }
    };

    // Function to handle video selection change
    $scope.onVideoChange = function(selectedVideo) {
        $scope.video_id = selectedVideo ? selectedVideo.id : null;
    };

    $scope.addNotificationBar = function () {

        var type = $scope.type;
        // Check if all required fields are filled
        // if (!$scope.content || type !== 'delete') {
        //     swal({
        //         title: 'Error!',
        //         text: 'Content is required. Please fill in the missing fields.',
        //         type: 'error',
        //         showConfirmButton: true
        //     });
        //     return;
        // }

        // Skip validation for delete operations
        if (type !== 'delete' && $scope.selectedType === 'niche' && !$scope.selectedNiche) {
            swal({
                title: 'Error!',
                text: 'Institute is required for Niche Page.',
                type: 'error',
                showConfirmButton: true
            });
            return;
        }

        // Validate button link format (skip validation for delete operations)
        if (type !== 'delete' && $scope.button_link && !$scope.button_link.startsWith('https://')) {
            swal({
                title: 'Error!',
                text: 'Button link must be a valid HTTPS URL starting with https://',
                type: 'error',
                showConfirmButton: true
            });
            return;
        }

        // if ($scope.selectedType === 'course' && (!$scope.selectedInstitution || !$scope.selectedFaculty || !$scope.selectedCourse)) {
        //     swal({
        //         title: 'Error!',
        //         text: 'Institute, Faculty, and Course are required for Course Page.',
        //         type: 'error',
        //         showConfirmButton: true
        //     });
        //     return;
        // }

        // if ($scope.selectedType === 'video' && (!$scope.selectedInstitution || !$scope.selectedFaculty || !$scope.selectedCourse || !$scope.selectedModule || !$scope.video_id)) {
        //     swal({
        //         title: 'Error!',
        //         text: 'Institute, Faculty, Course, Module, and Video are required for Video Page.',
        //         type: 'error',
        //         showConfirmButton: true
        //     });
        //     return;
        // }

        $scope.isUploading = true;
        var apiUrl = env.backendService + '/lmsservice/v1/in-build-notification-bar/';
        var method = 'POST';
        var data = {
            content: $scope.content,
            niche_name: $scope.selectedType === 'niche' && $scope.selectedNiche ? $scope.selectedNiche.name : null,
            niche_link: $scope.selectedType === 'niche' && $scope.selectedNiche ? $scope.selectedNiche.link : null,
            course_id: $scope.selectedCourse && !$scope.video_id ? $scope.selectedCourse.id : null,
            video_id: $scope.video_id ? $scope.video_id : null,
            button_text: $scope.button_text || '',
            button_link: $scope.button_link || '',
        };

        if (type === 'edit') {
            apiUrl += 'update-bar/' + $scope.selectedBarId;
            method = 'PUT';
        } else if (type === 'delete') {
            apiUrl += 'delete-bar/' + $scope.selectedBarId;
            method = 'DELETE';
            data = { deleted_by: 'admin' };
        } else {
             apiUrl += 'create-bar'
        }

        $http({
            url: apiUrl,
            method: method,
            data: data
        }).then(function (res) {
            $scope.isUploading = false;
            if (res.data.success) {
                getNotificationBars()
                $('#myModal').modal('hide');
                swal({
                    title: 'Success',
                    text: 'Notification Bar ' + (type === 'create' ? 'Created' : type === 'edit' ? 'Updated' : 'Deleted') + ' Successfully!',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 2000
                }, function () {
                    swal.close();
                });

                if (type === 'create') {
                    $scope.notificationBars.push(res.data.data);
                    filterBars(); // Refresh filtered arrays
                } else if (type === 'edit') {
                    // Find and update existing bar
                    for (var i = 0; i < $scope.notificationBars.length; i++) {
                        if ($scope.notificationBars[i].id === res.data.data.id) {
                            $scope.notificationBars[i] = res.data.data;
                            break;
                        }
                    }
                    filterBars(); // Refresh filtered arrays
                } else if (type === 'delete') {
                    // Remove from list
                    $scope.notificationBars = $scope.notificationBars.filter(function(bar) {
                        return bar.id !== $scope.selectedBarId;
                    });
                    filterBars(); // Refresh filtered arrays
                }
                $scope.handleClear();
            } else {
                // On failure, show the error message and keep the modal open for user to correct
                swal({
                    title: 'Error!',
                    text: res.data.message || 'Something went wrong, please try again.',
                    type: 'error',
                    showConfirmButton: true
                });
            }
        }, function (error) {
            console.error('API Error:', error);
            $scope.isUploading = false;
            swal({
                title: 'Error!',
                text: error.data.message || 'Something went wrong, please try again.',
                type: 'error',
                showConfirmButton: true
            });
        });
    };
    
    }]);

})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("iframeFormController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService", "toaster",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService, toaster
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.name = "";
      $scope.form_link = "";
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.links = [];
      $scope.resize = 'center';
      $scope.dimension = {};
      $scope.errorText = '';

      var getRedirectLink = function() {
        var reqData = {currentPage: $scope.currentPage, perPage: $scope.perPage}
        if($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;
        }
        HttpService.getRequest("api/v1/iframe-form/get-iframe-form", reqData).then(
          function (res) {
            if(res && res.success) {
              $scope.links = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getRedirectLink();

      $scope.copylink = function (link) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/np-form/' + link.form_id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getRedirectLink();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getRedirectLink();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedlink = undefined;
        $scope.name = '';
        $scope.form_link = '';
        $scope.resize = 'center';
        $scope.dimension = {};
        $scope.height;
        $scope.errorText = '';
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/iframe-form/add-iframe-form";
        if(!$scope.name){
          $scope.errorText = "Name is required";
        } else if(!$scope.form_link){
          $scope.errorText = "Redirect Link is required";
        } else if($scope.resize === 'custom' && (!$scope.dimension.width || !$scope.dimension.height || $scope.dimension.width < 1 || $scope.dimension.height < 1)){
          $scope.errorText = "Height and Width is required";
        } 
        else if(!$scope.form_link.startsWith("http://") && !$scope.form_link.startsWith("https://")){
          $scope.errorText = "Please Enter valid URL";  
        }
        else{
          $scope.errorText = '';
          $('#myModal').modal('hide');
          var req = { name: $scope.name, formLink: $scope.form_link, dimensions: $scope.dimension, resize_type: $scope.resize };
          if(selectedlink && selectedlink > 0) {
            req.id = selectedlink;
            api = "api/v1/iframe-form/update-iframe-form";
          }
          HttpService.postRequest(api, req).then(function (res) {
            if(res && res.success) {
              $scope.moveTotrash();
              getRedirectLink();
              selectedlink = 0;
            } else {
              swal({
                title: "Error",
                text: res.error,
                type: "error",
                confirmButtonText: "Ok"
              });
            }
          });
        }
      };

      $scope.updateRedirectLink = function (link) {
        selectedlink = link.id;
        $scope.name = link.name;
        $scope.form_link = link.form_link;
        $scope.resize = link.resize_type;
        $scope.dimension = link.dimensions ? link.dimensions : {};
      };

      $scope.deleteRedirectLink = function (link) {
        var api = "api/v1/iframe-form/delete-iframe-form";
        var req = { id: link.id };
        swal({
          title: "Are you sure you want to delete this Form",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getRedirectLink();
              });
            }
          });
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.links.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getRedirectLink();
      }

    },
  ]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('htmlPagesController', [
      '$scope',
      '$http',
      '$state',
      '$rootScope',
      'CustomStorageService',
      'env',
      '$window',
      function ($scope, $http, $state, $rootScope, CustomStorageService, env, $window) {

        $scope.currentPage = 1;
        $scope.pages = [];
        $scope.totalPages = 0;
        $scope.search = '';

        $scope.loadPages = function () {
          var data = { page: $scope.currentPage, limit: 10, search: $scope.search };

          $http({
            url: env.backendService + '/lmsservice/v1/pages',
            method: "GET",
            params: data
          })
            .then(function (response) {
              $scope.pages = response.data.data || [];
              $scope.totalPages = response.data.totalPages || 0;
            })
            .catch(function (error) {
              console.error('Error loading pages:', error);
              $scope.pages = [];
            });
        };

        $scope.loadPages();

        $scope.deletePage = function (page) {
          swal({
            title: "Confirmation!",
            text: "Are you sure you want to delete this page?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No"
          }, function (confirm) {
            if (confirm) {
              $http({
                url: env.backendService + '/lmsservice/v1/pages/' + page.id,
                method: "DELETE"
              })
                .then(function (response) {
                  if (response.data.success) {
                    $scope.loadPages();
                    swal({
                      title: "Success",
                      text: "Page deleted successfully",
                      type: "success"
                    });
                  } else {
                    swal({
                      title: "Error",
                      text: "Error deleting page",
                      type: "error"
                    });
                  }
                })
                .catch(function (error) {
                  console.error('Error deleting page:', error);
                  swal({
                    title: "Error",
                    text: "Error deleting page",
                    type: "error"
                  });
                });
            }
          });
        };

        $scope.editPage = function (page) {
          $state.go('editHtmlPage', { id: page.link });
        };
        $scope.previewPage = function (page) {
          var baseUrl = ($window.location.hostname === 'localhost' || $window.location.hostname.includes('dev')) ? 'https://next.nearpeer.org/html/' : 'https://nearpeer.org/html/';
          $window.open(baseUrl + page.link, '_blank');
        };

        $scope.searchPages = function () {
          $scope.currentPage = 1;
          $scope.loadPages();
        };

        $scope.showNext = function (type) {
          if (type === 'next' && $scope.currentPage < $scope.totalPages) {
            $scope.currentPage++;
            $scope.loadPages();
          } else if (type === 'previous' && $scope.currentPage > 1) {
            $scope.currentPage--;
            $scope.loadPages();
          }
        };
      }
    ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("fscVisitsController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      $scope.visits = [];
      $scope.fromDate = '';
      $scope.toDate = '';

      HttpService.getRequest("https://apigateway.nearpeer.org/trackingservice/v1/websites-tracking/get-fsc-visits?page=" + $scope.currentPage).then(
        function (res) {
          $scope.visits = res.visits;
        }
      );
      
      $scope.showNext = function(type) {
        if(type === 'next' && $scope.visits.length > 19) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        HttpService.getRequest("https://apigateway.nearpeer.org/trackingservice/v1/websites-tracking/get-fsc-visits?page=" + $scope.currentPage).then(
        function (res) {
          $scope.visits = res.visits;
        });
      }

      $scope.downloadOrders = function() {
        if(!$scope.fromDate || !$scope.toDate) {
          swal({
            title: "Please Select From & To Date",
            type: "error",
            confirmButtonText: "Ok"
          }, function() {
            swal.close();
          });
        } else {
          HttpService.postRequest("/api/v1/visits/csv-for-fsc-visits", {from: $scope.fromDate, to: $scope.toDate, email: $scope.currentUser.email}).then(
            function (res) {
              swal({
                title: "Success",
                text: "We are compiling sheet you will receive email shortly!",
                type: "success",
                showConfirmButton: true
              }, function() {
                swal.close();
              });
            });
        }
        
      }
    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('freeAccessController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      var data = {page: $scope.currentPage, per_page: 30, type: '1'};

      $http({
        url: 'api/v1/free-access/get-all-configs',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.configs = data.data.configs;
        $scope.total_config_pages = data.data.totalPages;
        $scope.total_cofings = data.data.totalCount;
      });

      $scope.disableConfig = function(config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to update Access Config",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/free-access/delete-config/' + config.id,
              method: "GET",
              params: data
            }).then(function(data) {
              if(data.data.success) {
                $scope.showNext('same');
                swal({
                  title: "Success",
                  text: "Access Config Updated Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Access Config Deleting",
                  type: "error"
                },function(){})
              }
            });
          }
        });


        
      }

      $scope.editConfig = function(config) {
        $state.go('edit_free_access',{id: config.id})
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = {page: $scope.currentPage, per_page: 30, type: '1'};
        $http({
          url: 'api/v1/free-access/get-all-configs',
          method: "GET",
          params: data
        }).then(function(data) {
          $scope.configs = data.data.configs;
          $scope.total_config_pages = data.data.totalPages;
          $scope.total_cofings = data.data.totalCount;
        });
      }

    }]);
  })();
  
(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('formBuilderController', ['$scope', '$http', '$state','HttpService', 'CustomStorageService', function($scope, $http, $state,HttpService, CustomStorageService) {
      
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.name = "";
      $scope.form_link = "";
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.forms = [];
      $scope.resize = 'center';
      $scope.dimension = {};
      $scope.errorText = '';

      var getCustomForms = function() {
        var reqData = {currentPage: $scope.currentPage, perPage: $scope.perPage}
        if($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;
        }
        HttpService.getRequest("api/v1/custom-form/get-custom-form", reqData).then(
          function (res) {
            if(res && res.success) {
              $scope.forms = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getCustomForms();

      $scope.copylink = function (link) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/np-form/' + link.form_id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getCustomForms();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getCustomForms();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedlink = undefined;
        $scope.name = '';
        $scope.form_link = '';
        $scope.resize = 'center';
        $scope.dimension = {};
        $scope.height;
        $scope.errorText = '';
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/custom-form/add-custom-form";
        if(!$scope.name){
          $scope.errorText = "Name is required";
        } else if(!$scope.form_link){
          $scope.errorText = "Redirect Link is required";
        } else if($scope.resize === 'custom' && (!$scope.dimension.width || !$scope.dimension.height || $scope.dimension.width < 1 || $scope.dimension.height < 1)){
          $scope.errorText = "Height and Width is required";
        } 
        else if(!$scope.form_link.startsWith("http://") && !$scope.form_link.startsWith("https://")){
          $scope.errorText = "Please Enter valid URL";  
        }
        else{
          $scope.errorText = '';
          $('#myModal').modal('hide');
          var req = { name: $scope.name, formLink: $scope.form_link, dimensions: $scope.dimension, resize_type: $scope.resize };
          if(selectedlink && selectedlink > 0) {
            req.id = selectedlink;
            api = "api/v1/custom-form/update-custom-form";
          }
          HttpService.postRequest(api, req).then(function (res) {
            if(res && res.success) {
              $scope.moveTotrash();
              getCustomForms();
              selectedlink = 0;
            } else {
              swal({
                title: "Error",
                text: res.error,
                type: "error",
                confirmButtonText: "Ok"
              });
            }
          });
        }
      };


     $scope.downloadCSV = function (form) {
      const csvContent = $scope.generateCSVContent(form);


      const link = document.createElement('a');
      link.setAttribute('href', csvContent);
      link.setAttribute('download', form.form_name?form.form_name:'formData'+".csv");
      document.body.appendChild(link);
      link.click();
    };


    $scope.generateCSVContent = function (form) {
      var csvContent = "data:text/csv;charset=utf-8,";
    
      var validFields = form.results[0].form_result.filter(function (field) {
        return field.type !== "header" && field.type !== "button" && field.type !== "paragraph";
      });
    
      var headers = ["user_id"];
      validFields.forEach(function (field) {
        headers.push('"' + $scope.replaceCommas($scope.stripHTML(field.label)) + '"');
      });
      csvContent += headers.join(",") + "\n";
    
      var rows = form.results.map(function (result) {
        var rowValues = ['"' + result.user_id + '"'];
        if (result.form_result) {
          validFields.forEach(function (field) {
            var cleanLabel = $scope.replaceCommas($scope.stripHTML(field.label));
            var fieldResult = result.form_result.find(function (fr) {
              return $scope.replaceCommas($scope.stripHTML(fr.label)) === cleanLabel;
            });
    
            var value = "";
    
            if (field.type === "radio-group" || field.type === "select") {
              var selectedValue = field.values.find(function (val) {
                return val.value === (fieldResult ? fieldResult.userData[0] : null);
              });
              value = selectedValue ? selectedValue.label : "";
            } else if (field.type === "checkbox-group") {
              var selectedValues = [];
              if (fieldResult && fieldResult.userData) {
                fieldResult.userData.forEach(function (userValue) {
                  var checkboxValue = field.values.find(function (val) {
                    return val.value === userValue;
                  });
                  if (checkboxValue) {
                    selectedValues.push(checkboxValue.label);
                  }
                });
              }
              value = selectedValues.join("-");
            } else {
              value = fieldResult ? fieldResult.userData.join(";") : "";
            }
    
            rowValues.push('"' + value.replace(/"/g, '""') + '"'); // Escape double quotes inside values
          });
        } else {
          validFields.forEach(function () {
            rowValues.push('""');
          });
        }
        return rowValues.join(",");
      });
    
      csvContent += rows.join("\n");
    
      return encodeURI(csvContent);
    };
    

    $scope.stripHTML= function(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }
    
     $scope.replaceCommas= function (text) {
      return text.replace(/,/g, ' ');
    }


      $scope.updateRedirectLink = function (form) {
        $state.go('edit_custom_form', {id: form.id})
      };

      $scope.deleteRedirectLink = function (link) {
        var api = "api/v1/custom-form/delete-custom-form";
        var req = { id: link.id };
        swal({
          title: "Are you sure you want to delete this Form",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getCustomForms();
              });
            }
          });
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.forms.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getCustomForms();
      }

    }]);
  })();
  
(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('enrollmentGroupController', ['$scope','$state','CustomStorageService', 'HttpService', function($scope,$state,CustomStorageService, HttpService) {
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      var getTags = function () {
        HttpService.getRequest('/api/v1/enrollment-group/get')
        .then(function (res) {
          if (res.success) {
            $scope.enrollmentGroups = res.enrollmentGroups;
          } 
        });
      }

      $scope.editTag = function (id) {
        $state.go('editEnrollmentGroup', {id: id})
      }

      $scope.deleteTag = function ($event, tag) {
        $event.stopPropagation();
        HttpService.postRequest('/api/v1/enrollment-group/delete/' + tag.id, {})
        .then(function (res) {
          console.log('res');
          console.log(res);
          if(res.success) {
            HttpService.getRequest('/api/v1/enrollment-group/get')
            .then(function (res) {
              swal('Success','Successfully Deleted!','success');
              if (res.success) {
                $scope.enrollmentGroups = res.enrollmentGroups;
              } 
            });
          } else {
            swal('Error','Error while deleting group!','error');
          }
          
        });
      }

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('admin_panel', {}, { reload: true });
      } else {
        getTags();
      }
    }]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('SendBulkEmailsController', ['$scope','$state','CustomStorageService', 'HttpService', function($scope,$state,CustomStorageService, HttpService) {
      $scope.toEmails = []
      $scope.fromEmail = 'updates@nearpeer.org'
      $scope.emailcheck = function (tag) {
          var addedEmail = []
          var tagEmails = tag.text.split("-");
          tagEmails.forEach(function(email) {
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const isValid = emailRegex.test(String(email).toLowerCase());
            const isDuplicate = $scope.toEmails.includes(email)
            const isDuplicateNewEmails = addedEmail.includes(email)
            if(isValid && !isDuplicate && !isDuplicateNewEmails) {
              addedEmail.push(email)
            }
          });
          $scope.toEmails = $scope.toEmails.concat(addedEmail);
        
      }

      $scope.sendEmails = function () { 
        const emails = $scope.toEmails;
        var invalidEmails = [];
        var isValidAll = true;
        const data = {
          emails: emails,
          fromEmail: $scope.fromEmail,
          subject: $scope.subject,
          content: $scope.content,
        }
        emails.forEach(function(email) {
          const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const isValid = emailRegex.test(String(email).toLowerCase());
          if(!isValid) {
            isValidAll = false;
            invalidEmails.push(email);
          }
        });
        if(isValidAll) {
          HttpService.postRequest("/api/v1/email/send-bulk-emails", data)
          .then(function (response) {
            $scope.toEmails = [];
            $scope.subject = '';
            $scope.content = '';
            swal({
              title: "Success",
              text: "Emails sending",
              type: "success",
              confirmButtonText: "Ok"
            });
          });
        } else {
          swal({
            title: "Error!",
            text: "Some Emails are not valid",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
      }
    }]);
  })();
(function () {
  "use strict";
  angular.module("NearPeer").controller("downloadVideosConfigController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      $scope.users = [];
      $scope.selectedUser;
      $scope.userKey = "";

      $scope.usersSearch = [];
      $scope.selectedUserSearch;
      $scope.userKeySearch = "";


      $scope.downloadCount = "";
      $scope.deleteVideos = false;
      $scope.disableDownload = false;
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.usersList = [];

      var getUsersConfigList = function() {
        HttpService.getRequest("api/v1/download-config/get-users-download-config", {currentPage: $scope.currentPage, perPage: $scope.perPage}).then(
          function (res) {
            if(res && res.success) {
              $scope.usersList = res.result;
              $scope.total = res.total;
            }
          }
        );
      }

      getUsersConfigList();

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.selectedUserSearch = {};
        $scope.userKeySearch = ''
        $scope.usersSearch = [];
        getUsersConfigList();
      }
      
      $scope.moveTotrash = function (){
        $scope.userKey = "";
        $scope.downloadCount = "";
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/download-config/add-download-config";
        if(!$scope.downloadCount){
          swal({
            title: "Error",
            text: "Download count is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
        else{
          var req = { userID: $scope.selectedUser.id, downloadCount: $scope.downloadCount, deleteDownload: $scope.deleteVideos, disableDownload: $scope.disableDownload };
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            getUsersConfigList();
          });
        }
      };

      $scope.updateUserDownloadConfig = function (user) {
        $scope.selectedUser = user.user_id;
        $scope.userKey =
          user.user_id.email || user.user_id.fb_email || user.user_id.name || user.user_id.full_name;
        $scope.users = [];
        $scope.downloadCount = user.max_download_count;
        $scope.deleteVideos = user.delete_download_offline;
        $scope.disableDownload = user.disable_download;
      };

      $scope.deleteUser = function (id) {
        var api = "api/v1/whitelist/blacklist-user";
        var req = { userID: id };
        swal({
          title: "Are you sure you want to delete this user's access",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                HttpService.getRequest("api/v1/whitelist/whitelisted-users").then(
                  function (res) {
                    $scope.usersList = res;
                  }
                );
              });
            }
          });
      };

      $scope.goto = function (data){
        var param = data.id;
        $state.go('user_ips', {id: param})
      }

      $scope.getInfo = function (data, type) {
        var api = "api/v1/user/search";
        var req = { key: data };
        HttpService.getRequest(api, req).then(function (res) {
          if(type === 'search')  {
            $scope.usersSearch = res.users;
          } else {
            $scope.users = res.users;
          }
        });
      };

      $scope.addVariants = function (user) {
        $scope.selectedUser = user;
        $scope.userKey =
          user.email || user.fb_email || user.name || user.full_name;
        $scope.users = [];
      };

      $scope.addSearchVariants = function (user) {
        $scope.selectedUserSearch = user;
        $scope.userKeySearch =
          user.email || user.fb_email || user.name || user.full_name;
        $scope.usersSearch = [];
        $scope.currentPage = 1;
        HttpService.getRequest("api/v1/download-config/get-users-download-config/" + user.id, {currentPage: $scope.currentPage, perPage: $scope.perPage}).then(
          function (res) {
            if(res && res.success) {
              $scope.usersList = [res.result];
            }
          }
        );
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.usersList.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getUsersConfigList();
      }

    },
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('AdminDashBoardController', ['$scope', function($scope) {
    
    }]);
  })();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('courseTagsController', ['$scope','$state','CustomStorageService', 'HttpService', '$http', function($scope,$state,CustomStorageService, HttpService, $http) {
      var signedIn = CustomStorageService.getAdminSignedInStorageData();
      var getTags = function () {
        HttpService.getRequest('/api/v1/coursetag/get')
        .then(function (res) {
          if (res.success) {
            $scope.courseTags = res.courseTags;
          } 
        });
      }

      $scope.editTag = function (id) {
        $state.go('editCourseTag', {id: id})
      }

      $scope.gotoFeatures = function (tag) {
        $state.go('tagFeature', {tag_id: tag.id})
      }

      $scope.deleteTag = function (id) {

        swal(
          {
            title: "Are you sure you want to delete this Bundle",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http({
                url:'/api/v1/coursetag/delete/' + id,
                method:"Delete",
              }).then(function (res) {
                if(res){
                  if(res.data.success) {
                    swal('Success','Successfully Deleted!','success');
                    getTags()
                  } else {
                    swal('Error',res.data.message,'error');
                  }
                  
                }else{
                  swal('Error','Error saving tag!','error');
                }
              });
            }
          }
        );

        
      }

      if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go('admin_panel', {}, { reload: true });
      } else {
        getTags();
      }
    }]);
  })();

(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("businessRequestController", ['$scope', '$http', MainController]);

  function MainController($scope, $http) {
    $scope.page = 1;
    $scope.pageSize = 10;
    $scope.data = [];
    $scope.totalPages = 1;
    $scope.pageRange = [1];

    $scope.businessRequestPopUp = false;

    $scope.businessRequestPopUpOpen = function (index) {
      $scope.selected = $scope.data[index];
      $scope.businessRequestPopUp = true;
    };
    $scope.businessRequestPopUpClose = function () {
      $scope.selected = {};
      $scope.businessRequestPopUp = false;
    };
    $scope.b2bSearchData = {
      search: "",
      fromDate: "",
      toDate: "",
    };
    $scope.selected = {};

    function formatDate(date) {
      var d = new Date(date);
      var month = "" + (d.getMonth() + 1);
      var day = "" + d.getDate();
      var year = d.getFullYear();
      var newDate = [year, month, day].join("-");
      return newDate;
    }
    $scope.b2bSearchData = {
      search: "",
      fromDate: "",
      toDate: "",
    };
    $scope.formData = {};

    //  var getB2bUserData = function(b2bSearchData) {
    //   var b2bSearchdefer = $q.defer();
    //   $http({
    //     url: '/api/v1/b2b/getb2bleadforms',
    //     method: "GET",
    //     params : {
    //       search: b2bSearchData.search,
    //       fromDate:  b2bSearchData.fromDate,
    //       toDate: b2bSearchData.toDate,
    //     }
    //   }).then(function(data){
    //     b2bSearchdefer.resolve(data.data);
    //   });
    //   return b2bSearchdefer.promise;

    // };

    $scope.intialize = (function () {
      // 			b2bService.getB2bUserData($scope.b2bSearchData)
      //       .then(function(data){
      // 	console.log(data);
      // 	$scope.fromData=data.data;
      // });
    })();

    $scope.clear = function () {
      $scope.page = 1;
      $scope.pageSize = 10;
      $scope.data = [];
      $scope.totalPages = 1;
      $scope.pageRange = [1];
      $scope.b2bSearchData = {
        search: "",
        fromDate: "",
        toDate: "",
      };
      $scope.getb2bData(1);
    }

    $scope.getb2bData = function (page) {
      console.log("🚀 ~ file: businessRequest.js:87 ~ MainController ~ page:", page)
      $scope.page = page;
      console.log("🚀 ~ file: businessRequest.js:88 ~ MainController ~ $scope.page:", $scope.page)
      var params = {
        page: page,
        per_page: $scope.pageSize,
      };
      if ($scope.b2bSearchData.search) {
        params.search = $scope.b2bSearchData.search;
      }
      if (
        (!$scope.b2bSearchData.fromDate && $scope.b2bSearchData.toDate) ||
        ($scope.b2bSearchData.fromDate && !$scope.b2bSearchData.toDate)
      ) {
        return swal(
          {
            title: "From Date and To Date are required",
            type: "error",
            showConfirmButton: false,
            allowOutsideClick: true,
            timer: 2000,
          },
          function () {}
        );
      }
      if ($scope.b2bSearchData.fromDate && $scope.b2bSearchData.toDate) {
        if (
          new Date($scope.b2bSearchData.fromDate) >
          new Date($scope.b2bSearchData.toDate)
        ) {
          return swal(
            {
              title: "From Date should be less than To Date",
              type: "error",
              showConfirmButton: false,
              allowOutsideClick: true,
              timer: 2000,
            },
            function () {}
          );
        }
        params.fromDate = formatDate($scope.b2bSearchData.fromDate);
        params.toDate = formatDate($scope.b2bSearchData.toDate);
      }
      console.log("====== api cal ====", params);
      $http({
        url: "api/v1/b2b/getb2bleadforms",
        method: "GET",
        params: params,
      }).then(function (data) {
        if (data.data.success) {
          $scope.data = data.data.data.records;
          $scope.totalPages = data.data.data.totalPages;
          $scope.pageRange = [];
          for (var i = 1; i <= $scope.totalPages; i++) {
            $scope.pageRange.push(i);
          }
          $scope.data.forEach(function (e) {
            var d = new Date(e.created_at);
            e.date = new Date(e.created_at).toString().substring(0, 16);
            e.time = d.toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });
          });
        }
      });
    };

    $scope.intialize = (function () {
      $scope.getb2bData($scope.page);
    })();
  }
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('couponController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      var data = {page: $scope.currentPage, per_page: 30, type: '1'};

      $http({
        url: 'api/v1/coupons/showCoupons',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.coupons = data.data.coupons;
        $scope.total_coupon_pages = data.data.total_pages;
        $scope.total_coupons = data.data.total_count;
      });

      $scope.terminateOrder = function(coupon) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to terminate all order with this coupon",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/orders/terminate-coupon-orders/' + coupon.id,
              method: "GET",
              params: data
            }).then(function(data) {
              if(data.data.success) {
                swal({
                  title: "Success",
                  text: "All Orders Terminated Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Terminating Orders",
                  type: "error"
                },function(){})
              }
            });
          }
        });


        
      }

      $scope.editCoupon = function(coupon) {
        $state.go('edit_coupon',{id: coupon.id})
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_coupon_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        var data = {page: $scope.currentPage, per_page: 30, type: '1'};
        $http({
          url: 'api/v1/coupons/showCoupons',
          method: "GET",
          params: data
        }).then(function(data) {
          $scope.coupons = data.data.coupons;
          $scope.total_coupon_pages = data.data.total_pages;
          $scope.total_coupons = data.data.total_count;
        });
      }

      $scope.showCoupons = function(page,type) {
        var data = {page: page,per_page: $scope.coupon_record_no,type:type};
        $scope.show_coupons = true;
        if (!$scope.total_coupon_pages) {
          $scope.responsePopup = false;
          $scope.total_coupon_pages = 1;
        }
        if (page > 0 && page < $scope.total_coupon_pages+1) {
          $scope.page = page;
          $http({
            url: 'api/v1/coupons/showCoupons',
            method: "GET",
            params: data
          }).then(function(data) {
            $scope.coupons = data.data.coupons;
            $scope.total_coupon_pages = data.data.total_pages;
            $scope.total_coupons = data.data.total_count;
          });
        } else if (page < 1) {
          $scope.responsePopup = false;
          page = 1;
        } else if (page > $scope.total_coupon_pages) {
          $scope.responsePopup = false;
          page = $scope.total_coupon_pages;
        }
      };

      $scope.searchCouponById = function(coupon_id){
        $scope.hidePagination = true;
        $http({
          url: 'api/v1/coupons/showCoupons',
          method: "GET",
          params: {coupon_id: coupon_id,type: '5'}
        }).then(function(data){
          if(!data.data.success){
            swal({
              title: "Error",
              text: "Coupon does not exist",
              type: "error"
            },function(){
              $scope.coupons = 0;
            })
          }
          else{
            $scope.coupons = data.data.coupons;
          }
        })
      }

    }]);
  })();
  
(function () {
  "use strict";
  angular.module("NearPeer").controller("configurationsEditController", [
    "$scope",
    "$http",
    "$state",
    "$rootScope",
    "CustomStorageService",
    function ($scope, $http, $state, $rootScope, CustomStorageService) {
      $http.get("/api/v1/env/get-env/" + $state.params.id, {}).then(
        function (resp) {
          $scope.configuration = resp.data.env;
          if($scope.configuration.config_name === 'WATI_CHAT_AI_PROMPT' || $scope.configuration.config_name === 'BOT_CHAT_SYSTEM_PROMPT'){
            $scope.promptField = true
          }else{
            $scope.promptField = false
          }
        },
        function errorCallback(response) {
          swal(
            {
              title: "Error",
              text: "Error while getting data",
              type: "error",
              showCancelButton: false
            },
            function (isConfirm) {}
          );
        }
      );

      $scope.editConfig = function (access, index) {
        if($scope.configuration.config_name === 'TAWK_ACTIVE_DAYS') {
          try {
            JSON.parse($scope.configuration.config_value);
          } catch (error) {
            swal(
              {
                title: "Error",
                text: "Invalid JSON Format",
                type: "error",
                showCancelButton: false
              },
              function (isConfirm) {}
            );
            return
          }
        } 
        $http.post("/api/v1/env/update-value/" + $state.params.id, {
          value: $scope.configuration.config_value
        }).then(
          function (resp) {
            swal(
              {
                title: "Success",
                text: "Value Updated Successfully",
                type: "success",
                showCancelButton: false
              },
              function (isConfirm) {}
            );
          },
          function errorCallback(response) {
            swal(
              {
                title: "Error",
                text: "Error while getting data",
                type: "error",
                showCancelButton: false
              },
              function (isConfirm) {}
            );
          }
        );
      };
    }
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("configurationsController", [
    "$scope",
    "$http",
    "$state",
    "$rootScope",
    "CustomStorageService",
    function ($scope, $http, $state, $rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      $http.get("/api/v1/env/get-env", {}).then(
        function (resp) {
          $scope.configurations = resp.data.env;
        },
        function errorCallback(response) {
          swal(
            {
              title: "Error",
              text: "Error while getting data",
              type: "error",
              showCancelButton: false
            },
            function (isConfirm) {}
          );
        }
      );

      $scope.editConfig = function (config, index) {
        $state.go('admin_edit_configurations',{id: config.id});
      };
    }
  ]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('campaignTrackingController', ['$scope', '$http', '$state', '$location','$rootScope', 'CustomStorageService', function($scope, $http, $state, $location, $rootScope, CustomStorageService) {
      $scope.currentPage = 1;
      $scope.total_config_pages = 1;
      $scope.allStatsSearch = '';
      $scope.trending = true;
      $scope.pageRange = [1];
      var searchParams = $location.search();
      console.log("🚀 ~ file: campaignTracking.js:12 ~ .controller ~ searchParams:", searchParams)
      var data = {
        page: $scope.currentPage, 
        per_page: 20, 
        type: '1', 
        sort_order:searchParams.sort?searchParams.sort:'desc', 
        sort: searchParams.filter?searchParams.filter: 'createdAt',
        search: searchParams.search
      };

      var getAllCampaigns = function (page) {
        $scope.page = page;
        // console.log("====== api cal ====", data)
        $http({
          url: 'api/v1/campaign/get-campaigns',
          method: "GET",
          params: data
        }).then(function(res) {
          $scope.configs = res.data.result;
          $scope.total_config_pages = res.data.count / data.per_page;
          $scope.total_cofings = res.data.count;
          
          $scope.pageRange = [];
          for (var i = 1; i <= $scope.total_config_pages; i++) {
            $scope.pageRange.push(i);
          }
          
          $scope.configs.forEach(function (e) {
            var d = new Date(e.createdAt);
            e.date = new Date(e.createdAt).toString().substring(0, 16);
            e.time = d.toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });
          });
        });
      }

      getAllCampaigns();

      
      $scope.getAllCampaignsStats = function () {
				$http({
					url: 'api/v1/campaign/get-all-campaign-stats',
					method: "GET",
          params:data,
				}).then(function (data) {

					if (data.data.success) {
            $scope.campaignStatsAll = data.data;
            $scope.totalCost = ~~$scope.campaignStatsAll.totalCost;
					}
				});
			}
      $scope.getAllCampaignsStats();

      $scope.searchByDate = function(){
        data.searchTo = $scope.overallStatsFromDate;
        data.searchFrom = $scope.overallStatsToDate;
        $scope.getAllCampaignsStats();
      }

      $scope.gotoStats = function(config) {
        $state.go('campaign_stats',{id: config.id})
      }

      $scope.duplicateCampaign = function(config) {
        swal({
          title: "Confirmation!",
          text: "Are you sure you want to create Duplicate Campaign",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/campaign/duplicate-campaign',
              method: "POST",
              data: {id: config.id}
            }).then(function(data) {
              if(data.data.success) {
                getAllCampaigns();
              } else {
                swal({
                  title: "Error",
                  text: "Error While Creating Dupicate Campaign",
                  type: "error"
                },function(){})
              }
            });
          }
        });
      }

      $scope.disableConfig = function(config) {

        swal({
          title: "Confirmation!",
          text: "Are you sure you want to disable Access Config",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }, function(confirm) {
          if (confirm) {
            $http({
              url: 'api/v1/campaign/delete-campaign',
              method: "POST",
              data: {id: config.id}
            }).then(function(data) {
              if(data.data.success) {
                $scope.showNext('same');
                swal({
                  title: "Success",
                  text: "Access Config Disabled Successfully",
                  type: "success"
                },function(){})
              } else {
                swal({
                  title: "Error",
                  text: "Error While Access Config Deleting",
                  type: "error"
                },function(){})
              }
            });
          }
        });
      }

      $scope.editConfig = function(config) {
        $state.go('edit_campaign_tracking',{id: config.id})
      }

      $scope.downloadCsvReport = function(config) {
        $http({
          url: 'api/v1/campaign/get-campaign-report/' + config.id,
          method: "GET",
        }).then(function(data) {
          if(data.data.success) {
            swal({
              title: "Success",
              text: "You will receive an email with csv link",
              type: "success"
            },function(){})
          } else {
            swal({
              title: "Error",
              text: "Error While Getting Campaign Report",
              type: "error"
            },function(){})
          }
        });
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.total_config_pages > $scope.currentPage) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        data = {page: $scope.currentPage, per_page: 20, type: '1'};
        getAllCampaigns()
      }

      $scope.sort = function(keyname){
        $scope.sortKey = keyname;   
        $scope.reverse = !$scope.reverse; 
      }
      $scope.sortFilter = function (sort, type) {
        if (sort === "asc") {
          data.sort_order = "asc";
        } else {
          data.sort_order = "desc";
        }
        data.sort = type;
        getAllCampaigns();
        $state.go("campaign_tracking", {filter: type, sort: sort, }, {notify: false});
            
      };

      $scope.searchAllCampaign = function(){
        $scope.currentPage = 1;
        data.page =  $scope.currentPage;
        data.search = $scope.allStatsSearch;
        $state.go("campaign_tracking", {search: $scope.allStatsSearch }, {notify: false});
        getAllCampaigns();
      }
      $scope.clearFilter = function (){
        $scope.allStatsSearch = ''
        data = {page: $scope.currentPage, per_page: 20, type: '1', sort_order: 'DESC',};
        $state.go("campaign_tracking", {search: '', filter: '',sort:''}, {notify: false});

        getAllCampaigns();
      }
      $scope.trendCompaign = function(){
        data = {
          page: $scope.currentPage, 
          per_page: 20, 
          sort_order: 'DESC', 
          trending:  $scope.trending
        };
        getAllCampaigns();
      }
      

    }]);
  })();
  
(function () {
  "use strict";
  angular.module("NearPeer").controller("bundleController", [
    "$scope",
    "$http",
    "$rootScope",
    function ($scope, $http, $rootScope) {
      var sr = $scope;

      var getBundel = function () {
        $http.post("/api/v1/bundle/find", { admin: true ,type: 'all'}).then(
          function (data) {
            if (data.data.success) {
              sr.bundles = data.data.bundles;
            } else {
            }
          },
          function errorCallback(response) {}
        );
      };

      getBundel();

      $scope.deleteBundle = function (bundle_id) {
        swal(
          {
            title: "Are you sure you want to delete this Bundle",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http
                .post("/api/v1/bundle/delete", { id: bundle_id })
                .then(
                  function (data) {
                    if (data.data.success) {
                      getBundel();
                    } else {
                    }
                  },
                  function errorCallback(response) {}
                );
            }
          }
        );
      };
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("BulkOrderUpdateController", [
    "$scope",
    "$state",
    "CustomStorageService",
    "HttpService",
    function ($scope, $state, CustomStorageService, HttpService) {
      $scope.orderIds = [];
      $scope.fromEmail = "updates@nearpeer.org";
      $scope.emailcheck = function (tag) {
        var addedOrderId = [];
        var tagOrderId = tag.text.split(",");
        tagOrderId.forEach(function (id) {
          var isDuplicateNewEmails = addedOrderId.includes(id);
          if(!isDuplicateNewEmails) {
            addedOrderId.push(id);
          }
        });
        $scope.orderIds = $scope.orderIds.concat(addedOrderId);
      };

      $scope.updateOrders = function () {
        var orderIdsData = $scope.orderIds;
        var data = {
          order_ids: orderIdsData,
          status: $scope.status,
        };
        HttpService.postRequest("/api/v1/orders/bulk-update", data).then(
          function (response) {
            $scope.orderIds = [];
            swal({
              title: "Success",
              text: "Orders Updated Successfully",
              type: "success",
              confirmButtonText: "Ok",
            });
          }
        );
      };
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("botConfigController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService", "toaster",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService, toaster
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedlink;
      $scope.userKeySearch = '';
      $scope.perPage = 30;
      $scope.currentPage = 1;
      $scope.total = 0;
      $scope.courses = [];
      $scope.tags = [];
      $scope.botConfigs = [];
      $scope.config = {
        type: 'course',
        question_count: 10,
      };


      var getRedirectLink = function () {
        var reqData = { currentPage: $scope.currentPage, perPage: $scope.perPage }
        if ($scope.userKeySearch) {
          reqData.search = $scope.userKeySearch;
        }
        HttpService.getRequest("/api/v1/bot-config/get-config", reqData).then(
          function (res) {
            if (res && res.success) {
              $scope.botConfigs = res.configs;
              $scope.total = res.total;
            }
          }
        );
      }

      getRedirectLink();

      var getCourseTags = function () {
        HttpService.getRequest("/api/v1/coursetag/get", {}).then(
          function (res) {
            if (res && res.success) {
              $scope.tags = res.courseTags;
            }
          }
        );
      }

      getCourseTags();

      $scope.searchInfo = function (value, type) {
        if (type === 'course') {
          getInfo({ key: value }, type, 'api/v1/courses/search');
        }
      }

      var getInfo = function (data, type, api) {
        HttpService.getRequest(api, data)
          .then(function (res) {
            $scope.courses = res.courses;
          });
      }

      $scope.selectCourse = function (course, type) {
        $scope.courses = [];
        $scope.courseKey = course.name;
        $scope.config.course_id = course.id
      }

      $scope.clearFilter = function () {
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getRedirectLink();
      }

      $scope.searchLinks = function () {
        $scope.currentPage = 1;
        getRedirectLink();
      }

      $scope.moveTotrash = function () {
        $scope.config = {
          type: 'course',
          question_count: 10,
        };
        $scope.courseKey = '';
        $scope.errorText = '';
      }

      $scope.setSystemPrompt = function () {
        $state.go('bot_system_prompt');
      }
      

      $scope.saveConfig = function () {
        if (!$scope.config.course_id && !$scope.config.tag_id) {
          $scope.errorText = "Please select " + $scope.config.type;
        } else if (!$scope.config.question_count) {
          $scope.errorText = "Please enter Questions Count";
        }
        else {
          $scope.errorText = '';
          $('#myModal').modal('hide');
          var api = "/api/v1/bot-config/create-config";
          HttpService.postRequest(api, $scope.config).then(function (res) {
            if (res && res.success) {
              $scope.moveTotrash();
              getRedirectLink();
              selectedlink = 0;
            } else {
              swal({
                title: "Error",
                text: res.error,
                type: "error",
                confirmButtonText: "Ok"
              });
            }
          });
        }
      };

      $scope.updateRedirectLink = function (link) {
        selectedlink = link.id;
        $scope.name = link.name;
        $scope.form_link = link.form_link;
        $scope.resize = link.resize_type;
        $scope.dimension = link.dimensions ? link.dimensions : {};
      };

      $scope.deleteBotConfig = function (link) {
        var api = "/api/v1/bot-config/delete-config/" + link.id;
        swal({
          title: "Are you sure you want to delete this Config",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true
        },
          function (isConfirm) {
            if (isConfirm) {
              HttpService.getRequest(api, {}).then(function (res) {
                getRedirectLink();
              });
            }
          });
      };

      $scope.showNext = function (type) {
        if (type === 'next' && $scope.links.length > $scope.perPage - 1) {
          $scope.currentPage++;
        } else if (type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage--;
        }
        getRedirectLink();
      }

    },
  ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("blockExtensionController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService", "toaster",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService, toaster
    ) {
      $scope.currentPage = 1;
      $scope.currentUser = CustomStorageService.getUserInfoStorageData();
      var selectedExtension;
      $scope.userKeySearch = '';
      $scope.ext_name = "";
      $scope.ext_id = "";
      $scope.extensions = [];

      var getExtensions = function() {
        HttpService.getRequest("api/v1/extension/get-extensions", {}).then(
          function (res) {
            if(res && res.success) {
              $scope.extensions = res.result;
            }
          }
        );
      }

      getExtensions();

      $scope.copylink = function (link) {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.origin + '/np-link/' + link.link_id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toaster.success({
          title: "Link copied successfully",
        });
      };

      $scope.clearFilter = function (){
        $scope.currentPage = 1;
        $scope.userKeySearch = ''
        getExtensions();
      }

      $scope.searchLinks = function (){
        $scope.currentPage = 1;
        getExtensions();
      }
      
      $scope.moveTotrash = function (){
        $scope.selectedExtension = undefined;
        $scope.ext_name = '';
        $scope.ext_id = '';
      }

      $scope.addUserDownloadConfig = function () {
        var api = "api/v1/extension/add-extension";
        if(!$scope.ext_id){
          swal({
            title: "Error",
            text: "All fields is required",
            type: "error",
            confirmButtonText: "Ok"
          });
        } 
        else{
          var req = { ext_name: $scope.ext_name, ext_id: $scope.ext_id };
          if(selectedExtension && selectedExtension > 0) {
            req.id = selectedExtension;
            api = "api/v1/extension/update-extension";
          }
          HttpService.postRequest(api, req).then(function (res) {
            $scope.moveTotrash();
            getExtensions();
            selectedExtension = 0;
          });
        }
      };

      $scope.updateRedirectLink = function (extension) {
        selectedExtension = extension.id;
        $scope.ext_name = extension.ext_name;
        $scope.ext_id = extension.ext_id;
      };

      $scope.deleteExtension = function (extension) {
        var api = "api/v1/extension/delete-extension";
        var req = { id: extension.id };
        swal({
          title: "Are you sure you want to delete extension",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Delete",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              HttpService.postRequest(api, req).then(function (res) {
                getExtensions();
              });
            }
          });
      };

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.links.length > $scope.perPage - 1) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        getExtensions();
      }

    },
  ]);
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("adminAssignmentsController", [
      "$scope",
      "Upload",
      "$http",
      "$state",
      "CustomStorageService",
      "AssignmentService",
      "$sails",
      "env",
      "$sce",
      "HttpService",
      function (
        $scope,
        Upload,
        $http,
        $state,
        CustomStorageService,
        AssignmentService,
        $sails,
        env,
        $sce,
        HttpService
      ) {
        $(document).ready(function () {
          $(this).scrollTop(0);
        });
        var sr = $scope;
        var per_page = 10;
        var commentType = "all";
        var totalUnansweredCount = 0;
        $scope.newQuestion = false;
        $scope.markedAssignmentLink = "";
        $scope.page = 1;
        $scope.total = 10;
        $scope.totalPages = 1;
        $scope.assignmentSubmistions;
        $scope.showData = false;
        $scope.selectedQuestionImage;
        $scope.selectedQuestion;
        $scope.selectedInstructor;
        $scope.selectedQuestionToAssign;
        $scope.filterSelected = {
          all: true,
          assigned: false,
          unassigned: false,
          answered: false,
        };
        $scope.result = {
          remarks: "",
          total_marks: 100,
          obtained_marks: "",
          email_subject: "Your assignment has been checked",
          email_text: "Your assignment has been checked by your instructor. Visit nearpeer.org and check your notification for detailed feedback as well as checked assignment. Feel free to share your thoughts and feedback with us by replying to this email.",
          page_title: "Your assignment has been checked.",
          page_description: "Congratulations! your assignment has been checked by your instructor. You can download the checked assignment now.",
        };
        $scope.remaining = false;
        $scope.pageImageLoading = false;
        $scope.rem_stars = [];
        $scope.callFilters = {
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          pageNo: 1,
          limit: 10,
          assigned: null,
          answered: false,
          sort: "submittedAt",
          order: "ASC",
          search: "",
          from_date: "",
          to_date: "",
        };
        $scope.defaultDropDown = "Select Uploading Options";
        $scope.showOptions = false;
        $scope.searchText = "";
        $scope.totalPageCount;
        $scope.findInstructor = "";
        $scope.instText = "";
        $scope.selected = false;
        $scope.displayQuestion = false;
        $scope.assignInstructor = false;
        $scope.pageArr = [1, 2, 3, 4, 5];
        $scope.currentPage = 1;
        $scope.noData = true;
        $scope.toUpdateInstructor = false;
        $scope.previewImage = "";
        $scope.notAvideo = true;
        $scope.isPDF = false;
        $scope.containsLinks = false;
        $scope.fileName = "";
        $scope.isYoutube = false;
        $scope.ytID = "";
        $scope.videoLink = "";
        $scope.imageshowloader = true;
        $scope.fromDate = "";
        $scope.toDate = "";
        $scope.allQuestionsCount = 0;
        $scope.assignedQuestionsCount = 0;
        $scope.answeredQuestionsCount = 0;
        $scope.unassignedQuestionsCount = 0;
        $scope.ytError = "";
        $scope.unansweredQuestionsCount = 0;

        var selectedid;
        $scope.initialize = function () {
          var str = CustomStorageService.getUserInfoStorageData().full_name;
          $scope.imageInitial = str.charAt(0).toUpperCase();
          var data = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            page: 1,
            per_page: per_page,
            type: commentType,
          };
        };
        $scope.purchasedCourses = []
        var getPurchasedCourse = function (user_id) {
          $scope.loadingPurchasedCourses = true;
          $http({
            url: "/api/v1/user/get-purchased-courses?user_id=" + user_id,
            method: "GET",
          }).then(function (data) {
            $scope.loadingPurchasedCourses = false;
            if(data.data && data.data.courses) {
              $scope.purchasedCourses = data.data.courses;
            }
          });
        };

        $scope.purchaseType = function (type) {
          $scope.type = type;
          items = [];
          sr.courseKey = "";
          sr.userKey = "";
        };
        $scope.tags = [];
        $scope.selectedTag;
        $scope.showPaidCourses = false;

        $scope.closeCoursesWindow = function() {
          $scope.viewRemoveManager();
          $scope.showPaidCourses = false;
        }
        $scope.openCoursesWindow = function(user_id) {
          $scope.viewAddManager();
          getPurchasedCourse(user_id);
          $scope.showPaidCourses = true;
        }
        var getCourseTags = function () {
          $http({
            url: "/api/v1/coursetag/get",
            method: "GET",
          }).then(function (data) {
            if (data && data.data) {
              data.data.courseTags.forEach(function (tag) {
                $scope.tags.push({ id: tag.id, name: tag.name });
              });
            }
          });
        };
        getCourseTags();

        $scope.searchInfo = function (value, type) {
          if (type === "course" || type === "module") {
            getInfo(
              { key: value, paid: true },
              "course",
              "api/v1/courses/search"
            );
          }
        };

        var getInfo = function (data, type, api) {
          HttpService.getRequest(api, data).then(function (res) {
            if (type === "course") {
              sr.courses = res.courses;
            } else if (type === "module") {
              sr.modules = res.modules;
            }
          });
        };

        $scope.addVariants = function (course, type) {
          sr.courses = [];
          if (type === "module") {
            sr.courseKey = course.name;
            getInfo(
              { id: course.id },
              $scope.type,
              "api/v1/courses/getModulesByCourseId"
            );
          } else if(type === 'course') {
            selectedid = course.id;
            $scope.getAllQuestions()
          }
        };

        $scope.addModule = function (module) {
          selectedid = module;
          $scope.getAllQuestions()
        }

        $scope.addTag = function (tag) {
          selectedid = tag;
          $scope.getAllQuestions()
        }

        $scope.getAllQuestions = function (filter) {
          if (filter != null) {
            console.log("EMPTY");
          }
          console.log("CALL FILTERS", $scope.callFilters);
          // answered=false&&search=false
          // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
          //&assigned=false&sort=date&order=asc
          var body = {
            page: $scope.callFilters.pageNo,
            limit: $scope.callFilters.limit,
            status: $scope.callFilters.status,
            sort: $scope.callFilters.sort,
            order: $scope.callFilters.order,
            search: $scope.callFilters.search,
            from_date: $scope.callFilters.from_date,
            to_date: $scope.callFilters.to_date,
            type: $scope.type,
            selectedid: selectedid,
          };
          AssignmentService.getAllAssignments(body).then(function (resp) {
            if (resp.success) {
              $scope.totalPageCount = resp.pages;
              if (resp.countStats) {
                var countStats = {};
                var totalSubmitions = resp.count;
                resp.countStats.forEach(function (stat) {
                  countStats[stat.status] = stat.count;
                });
                $scope.countStats = countStats;
                $scope.totalSubmitions = totalSubmitions;
              }

              if ((resp.assignments || []).length > 0) {
                $scope.assignmentSubmistions = resp.assignments;
                $scope.noData = false;
                $scope.showData = true;
              } else {
                $scope.assignmentSubmistions = resp.assignments;
                $scope.noData = true;
                $scope.showData = true;
              }
              // $scope.$apply();
              console.log("QUESTIONS", $scope.assignmentSubmistions);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.downloadAssignment = function (assignment) {
          updateStatus({ status: "instructor_downloaded", assignment_id: assignment.id }).then(function (
            res
          ) {});
          window.open(assignment.submitted_file, "_blank");
        };
        $scope.dateFilter = function (type) {
          console.log($scope.fromDate, $scope.toDate, "In date filter", type);
        };
        $scope.getAllInstructors = function () {
          $http.get("/api/v1/user/getInstructors").then(function (resp) {
            if (resp.data.success) {
              // $scope.assignmentSubmistions = resp.data.data.questions;
              $scope.listofInstructors = resp.data.instructors;
              $scope.showData = true;
              console.log("instructors", resp);
            } else {
              console.log("network error");
            }
          });
        };
        $scope.selectInstructor = function (inst) {
          $scope.findInstructor = inst.name ? inst.name : inst.full_name;
          $scope.selected = !$scope.selected;
          $scope.instText = inst.email;

          $scope.selectedInstructor = inst;

          var div = document.getElementById("myDropdown");
          var label = div.getElementsByTagName("label");
          var txtValue = label[i].textContent || label[i].innerText;
          txtValue = $scope.findInstructor;
          console.log("selected inst", inst);
        };
        var updateStatus = function (data) {
          return new Promise(function (resolve, reject) {
            AssignmentService.updateAssignmentStatus(data).then(function (res) {
              resolve(res);
            });
          });
        };

        $scope.assignCall = function () {
          var body = {
            assignment_id: $scope.selectedQuestionToAssign.id,
            assigned_to: $scope.selectedInstructor.id,
            status: "assigned",
          };
          updateStatus(body).then(function (res) {
            if (res && res.success) {
              swal(
                {
                  title: "Assigned to Instructor",
                  text: "Question is successfully assigned.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeInstructor();
                  $scope.assignInstructor = false;
                  $scope.$apply();
                  $scope.getAllQuestions();
                  swal.close();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in assigning question",
                type: "error",
              });
            }
          });
        };
        $scope.closeAnswerWindow = function () {
          $scope.viewRemoveManager();
          $scope.selectedQuestionImage = null;
          $scope.selectedAnswerImage = false;
          $scope.notAvideo = true;
          $scope.videoLink = "";
          $scope.selectedQuestionToAnswer = {};
          $scope.answerQuestion = false;
          $scope.imageshowloader = true;
          $scope.isYoutube = false;
          $scope.result = {
            remarks: "",
            total_marks: "",
            obtained_marks: "",
            page_title: "",
            page_description: "",
          };
        };
        $scope.pageChange = function (page) {
          $scope.showData = false;
          var temp = [];
          if (
            $scope.pageArr[0] + 4 === page &&
            $scope.pageArr[0] + 4 < $scope.totalPageCount
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row + 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (
            $scope.pageArr[4] - 4 === page &&
            $scope.pageArr[4] - 4 > 1
          ) {
            $scope.pageArr.forEach(function (row) {
              row = row - 2;
              temp.push(row);
            });

            $scope.pageArr = temp;
            $scope.callFilters.pageNo = page;
            $scope.currentPage = page;
            $scope.getAllQuestions();
          } else if (page <= $scope.totalPageCount && page >= 1) {
            if (page < $scope.currentPage && $scope.pageArr[0] - 1 > 0) {
              $scope.pageArr.forEach(function (row) {
                row = row - 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else if (
              page > $scope.currentPage &&
              $scope.pageArr[4] + 1 < $scope.totalPageCount
            ) {
              $scope.pageArr.forEach(function (row) {
                row = row + 1;
                temp.push(row);
              });
              $scope.pageArr = temp;
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            } else {
              $scope.callFilters.pageNo = page;
              $scope.currentPage = page;
              $scope.getAllQuestions();
            }
          }

          // }
        };
        $scope.adminSearchDrop = function () {
          document.getElementById("myDropdown").classList.toggle("show-dp");
        };

        $scope.filterFunctionAdmin = function () {
          var input, filter, ul, li, label, i;
          input = document.getElementById("myInput");
          filter = input.value.toUpperCase();
          var div = document.getElementById("myDropdown");
          label = div.getElementsByTagName("label");
          for (i = 0; i < label.length; i++) {
            var txtValue = label[i].textContent || label[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              label[i].style.display = "";
              // $scope.findInstructor = txtValue ;
            } else {
              label[i].style.display = "none";
            }
          }
        };
        $scope.getUnansweredCount = function () {
          AssignmentService.getPendingCount({}).then(function (res) {
            if (res.success) {
              totalUnansweredCount = res.pendingCount;
              if (totalUnansweredCount !== $scope.unansweredQuestionsCount) {
                $scope.unansweredQuestionsCount = totalUnansweredCount;
                if ($scope.callFilters.pageNo == 1) {
                  $scope.getAllQuestions("fromUpdate");
                }
              }
            }
          });
        };
        $scope.getAllQuestions(null);
        var assignmentInterval = setInterval(function () {
          $scope.getUnansweredCount();
          $scope.$emit("pendingAssignmentCountCheck", {});
        }, 40000);

        if ($state.current.name != "AdminAssignments") {
          clearInterval(assignmentInterval);
        }
        $scope.searchQuery = function () {
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          $scope.callFilters.search = $scope.searchText;
          $scope.callFilters.from_date = $scope.fromDate;
          $scope.callFilters.to_date = $scope.toDate;
          $scope.getAllQuestions();
        };

        $scope.clearFilter = function () {
          $scope.type = null;
          $scope.selectedid = null;
          $scope.searchText = "";
          $scope.toDate = "";
          $scope.fromDate = "";
          $scope.callFilters = {
            // get?pageNo=1&limit=10&assigned=false&sort=date&order=asc
            pageNo: 1,
            limit: 10,
            assigned: null,
            answered: false,
            sort: "submittedAt",
            order: "ASC",
            search: "",
            from_date: "",
            to_date: "",
          };
          $scope.getAllQuestions(null);
        };
        $scope.getAllInstructors();
        $scope.changeFilter = function (type) {
          console.log(type, "Filter");
          $scope.showData = false;
          $scope.callFilters.pageNo = 1;
          $scope.currentPage = 1;
          Object.keys($scope.filterSelected).forEach(function (element) {
            if (element == type) {
              $scope.filterSelected[element] = true;
            } else {
              $scope.filterSelected[element] = false;
            }
          });
          if (type === "all") {
            $scope.callFilters.status = null;
          } else if (type === "assigned") {
            $scope.callFilters.status = "assigned";
          } else if (type === "answered") {
            $scope.callFilters.status = "checked";
          } else if (type === "draft") {
            $scope.callFilters.status = "draft";
          } else {
            $scope.callFilters.status = "submitted";
          }
          $scope.getAllQuestions();
        };

        $scope.sortFilter = function (sort, type) {
          // pageNo: 1,
          // limit: 10,
          // answered: null,
          // sort: "date",
          // order: "desc",
          // search : ""
          $scope.showData = false;
          if (sort === "asc") {
            $scope.callFilters.order = "asc";
          } else {
            $scope.callFilters.order = "desc";
          }
          $scope.callFilters.sort = type;
          $scope.getAllQuestions();
        };

        $scope.checkpaid = function (student) {
          if (student && student.paid_count) {
            if (Number(student.paid_count) > 0) {
              return "YES";
            }
          }
          return "NO";
        };
        $scope.answerStudent = function (obj) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAnswer = obj;
          $scope.answerQuestion = true;

          if (obj.status === "checked") {
            $scope.uploadedImgLink = obj.checked_file;
            $scope.selectedAnswerImage = obj.checked_file;
            $scope.result = {
              remarks: obj.result_remarks,
              total_marks: obj.total_marks || 100,
              obtained_marks: obj.obtained_marks,
              page_title: obj.result_page_data.page_title || "Your assignment has been checked.",
              page_description: obj.result_page_data.page_description || "Congratulations! your assignment has been checked by your instructor. You can download the checked assignment now.",
              pageImgLink: obj.result_page_data.pageImgLink,
              isEmail: obj.result_page_data.isEmail,
              email_subject: obj.result_page_data.email_subject || "Your assignment has been checked",
              email_text: obj.result_page_data.email_text || "Your assignment has been checked by your instructor. Visit nearpeer.org and check your notification for detailed feedback as well as checked assignment. Feel free to share your thoughts and feedback with us by replying to this email.",
              isSMS: obj.result_page_data.isSMS,
              sms_text: obj.result_page_data.sms_text,
            };
          }
          if (obj.status === "draft") {
            $scope.uploadedImgLink = obj.checked_file;
            $scope.selectedAnswerImage = obj.checked_file;
            $scope.result = {
              remarks: obj.result_remarks,
              total_marks: obj.total_marks || $scope.result.total_marks,
              obtained_marks: obj.obtained_marks,
              email_subject: "Your assignment has been checked",
              email_text: "Your assignment has been checked by your instructor. Visit nearpeer.org and check your notification for detailed feedback as well as checked assignment. Feel free to share your thoughts and feedback with us by replying to this email.",
              page_title: "Your assignment has been checked.",
              page_description: "Congratulations! your assignment has been checked by your instructor. You can download the checked assignment now.",
            };
          }
        };

        $scope.assignToInstructor = function (obj, update) {
          $scope.viewAddManager();
          $scope.selectedQuestionToAssign = obj;
          $scope.assignInstructor = true;
          if (update === "update") {
            $scope.toUpdateInstructor = true;
          } else {
            $scope.toUpdateInstructor = false;
          }
        };
        $scope.getNumber = function (num) {
          if (num < 5) {
            $scope.remaining = true;
            for (i = 0; i <= 5 - num; i++) {
              $scope.rem_stars.push("star");
            }
          } else {
            $scope.remaining = false;
            $scope.rem_stars = [];
          }
          return new Array(num);
        };
        $scope.closeInstructor = function () {
          console.log("CLOSE INSTRUCTOR");
          $scope.viewRemoveManager();
          $scope.assignInstructor = false;
          $scope.findInstructor = "";
          $scope.instText = "";
          $scope.selected = false;
          // $scope.$apply();
        };
        $scope.viewAddManager = function () {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          document
            .getElementById("sidebar-parent")
            .classList.remove("col-sm-2");
          document.getElementById("sidebar").classList.remove("col-sm-2");
          document
            .getElementById("sidebar-parent")
            .classList.remove("col-md-2");
          document.getElementById("sidebar").classList.remove("col-md-2");
          document
            .getElementById("admin-view-control")
            .classList.remove("col-sm-10");
          document
            .getElementById("admin-view-control")
            .classList.remove("col-md-10");
          document
            .getElementById("admin-view-control")
            .classList.add("full-v-h");
          document.getElementById("adminpanel").style.overflow = "hidden";
        };
        $scope.viewRemoveManager = function () {
          document.getElementById("sidebar-parent").classList.add("col-sm-2");
          document.getElementById("sidebar").classList.add("col-sm-2");
          document.getElementById("sidebar-parent").classList.add("col-md-2");
          document.getElementById("sidebar").classList.add("col-md-2");
          document
            .getElementById("admin-view-control")
            .classList.add("col-sm-10");
          document
            .getElementById("admin-view-control")
            .classList.add("col-md-10");
          document
            .getElementById("admin-view-control")
            .classList.remove("full-v-h");
          document.getElementById("adminpanel").style.overflow = "auto";
        };
        $scope.imageLoadCheck = function () {
          console.log("on image load");
          $scope.imageshowloader = false;
          $scope.$apply();
        };
        $scope.viewQuestion = function (qId, question, image) {
          $scope.viewAddManager();
          $scope.containsLinks = false;

          if (image != null) {
            if (image.includes("mp4") || image.includes("webm")) {
              $scope.imageshowloader = false;

              $scope.notAvideo = false;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            } else if (
              image.includes("pdf") ||
              image.includes("docx") ||
              image.includes("docs") ||
              image.includes("txt") ||
              image.includes("xls") ||
              image.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
              $scope.isYoutube = false;
            } else if (image.includes("youtube")) {
              $scope.imageshowloader = false;

              image.replace("watch?v=", "embed/");
              var linkB = image.substring(image.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("Ext", linkB, linkB2[0]);
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }
          $scope.selectedQuestionImage = image;
          $scope.selectedAnswerImage = image;
          console.log($scope.selectedQuestionImage);

          $scope.selectedQuestion = question;
          $scope.displayQuestion = true;
        };
        $scope.viewAnswer = function (question, image) {
          $scope.viewAddManager();

          $scope.containsLinks = false;
          console.log(question.answers[0], "Answer");
          $scope.answerObj = question.answers[0];
          if ($scope.answerObj.answer_media_link) {
            console.log($scope.answerObj.answer_media_link, "upaaa link");
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;

            var ext = $scope.selectedAnswerImage.substring(
              $scope.selectedAnswerImage.indexOf("v=") + 2
            );
            var ext2 = ext.split("&");
            $scope.ytID = ext2[0];
            console.log("Ext", ext, ext2[0]);

            console.log($scope.selectedAnswerImage, "up link");
          } else {
            $scope.selectedAnswerImage = $scope.answerObj.answer_media_link;
          }
          $scope.selectedQuestionImage = $scope.answerObj.answer_media_link;
          if ($scope.selectedAnswerImage != null) {
            if (
              $scope.selectedAnswerImage.includes("mp4") ||
              $scope.selectedAnswerImage.includes("webm")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = false;
              $scope.isPDF = false;
            } else if ($scope.selectedAnswerImage.includes("youtube")) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = true;
            } else if (
              $scope.selectedAnswerImage.includes("pdf") ||
              $scope.selectedAnswerImage.includes("docx") ||
              $scope.selectedAnswerImage.includes("docs") ||
              $scope.selectedAnswerImage.includes("txt") ||
              $scope.selectedAnswerImage.includes("xls") ||
              $scope.selectedAnswerImage.includes("csv")
            ) {
              $scope.imageshowloader = false;
              $scope.notAvideo = true;
              $scope.isPDF = true;
            } else {
              $scope.notAvideo = true;
              $scope.isPDF = false;
              $scope.isYoutube = false;
            }
          } else {
            $scope.imageshowloader = false;
          }

          console.log($scope.selectedQuestionImage, "Image");
          console.log($scope.selectedAnswerImage, "up link");

          // $scope.selectedQuestion = $scope.answerObj.answer_text ;
          $scope.selectedQuestion = $scope.formatTextforLink(
            $scope.answerObj.answer_text
          );
          $scope.displayAnswer = true;
        };
        $scope.uploadProgress = 0;
        $scope.uploadImage = function (file, userId) {
          return new Promise(function (resolve, reject) {
            Upload.upload({
              url: env.backendService +
              "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
              userId,
              method: "POST",
              file: file,
              params: { userId: userId },
            }).then(
              function (resp) {
                $scope.uploadProgress = 100;
                resolve(resp.data);
              },
              function (resp) {
                swal(
                  {
                    title: "Uploading Error",
                    text: "File Not Uploaded. Try Again",
                    type: "error",
                    showCancelButton: false,
                  },
                  function () {
                    swal.close();
                  }
                );
                reject(new Error("ERROR IN UPLOADING IMG 2"));
              },
              function (evt) {
                var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
                if(progressPercentage > 80) {
                  $scope.uploadProgress = 80;
                } else {
                  $scope.uploadProgress = progressPercentage;
                }
              }
            );
          });
        };
        $scope.onImageSelected = function (event, type) {
          console.log("EVENTS", event);
          $scope.imgUploaded = false;

          $scope.selectedImageAnswer = event.target.files[0];
          console.log($scope.selectedImageAnswer, "size");
          $scope.fileName = $scope.selectedImageAnswer.name;

          if (
            $scope.selectedImageAnswer.type.includes("mp4") ||
            $scope.selectedImageAnswer.type.includes("webm")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              32553838;
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = false;
            $scope.isPDF = false;
          } else if (
            $scope.selectedImageAnswer.type.includes("application/pdf") ||
            $scope.selectedImageAnswer.type.includes("xls") ||
            $scope.selectedImageAnswer.type.includes("excel") ||
            $scope.selectedImageAnswer.type.includes("docs") ||
            $scope.selectedImageAnswer.type.includes("docx") ||
            $scope.selectedImageAnswer.type.includes("csv") ||
            $scope.selectedImageAnswer.type.includes("application/msword") ||
            $scope.selectedImageAnswer.type.includes(
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ) ||
            $scope.selectedImageAnswer.type.includes("openxmlformats")
          ) {
            if ($scope.selectedImageAnswer.size > 40000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = true;
          } else {
            if ($scope.selectedImageAnswer.size > 4000000) {
              swal(
                {
                  title: "File Size too Big",
                  text: "Upload a file less than 40mb",
                  type: "error",
                  showCancelButton: false,
                },
                function () {
                  swal.close();
                }
              );
              return;
            }
            $scope.notAvideo = true;
            $scope.isPDF = false;
          }
          $scope.$apply();
          //   FormDataa()
          if (type === "page_image") {
            $scope.pageImageLoading = true;
          } else {
            $scope.imageLoad = true;
          }
          $scope.$apply();
          var fd = new FormData();
          fd.append("file", $scope.selectedImageAnswer);
          $scope.uploadImage($scope.selectedImageAnswer, $scope.instID).then(
            function (resp) {
              console.log("up resp", resp);
              if (resp.success) {
                if (type === "page_image") {
                  $scope.result.pageImgLink = resp.link;
                  $scope.pageImageLoading = false;
                } else {
                  $scope.uploadedImgLink = resp.link;
                  $scope.selectedAnswerImage = resp.link;
                  $scope.imageLoad = false;
                }
                $scope.$apply();
                $scope.selectedImageAnswer = null;
                $scope.uploadProgress = 0;
              }
            },
            function errorCallback(response) {
              console.log("ERROR RESP", response);
              $scope.imageLoad = false;
              $scope.pageImageLoading = false;
              $scope.uploadProgress = 0;
              return response;
            }
          );
        };
        $scope.youtubePreview = function (event) {
          console.log(event, "yt img link");
          setTimeout(function () {
            var ytLink = event.target.value;

            if (ytLink.includes("http://youtu.be/")) {
              ytLink.replace(
                "http://youtu.be/",
                "http://www.youtube.com/embed/"
              );
              var linkB = ytLink.substring(ytLink.indexOf(".be/") + 4);
              var linkB2 = linkB.split("?");
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            } else {
              ytLink.replace("watch?v=", "embed/");
              var linkB = ytLink.substring(ytLink.indexOf("v=") + 2);
              var linkB2 = linkB.split("&");
              $scope.ytID = linkB2[0];
              console.log("b,b2", linkB, linkB2);
              $scope.ytID = linkB2[0];
              $scope.selectedQuestionImage = "notNull";
              $scope.isYoutube = true;
            }
            $scope.$apply();
          }, 100);
        };
        $scope.sendAnswer = function (ansText, link) {
          var body = {
            checked_assignment_file: $scope.selectedAnswerImage
              ? $scope.selectedAnswerImage
              : $scope.result.markedAssignmentLink,
            result: $scope.result,
            assignment_id: $scope.selectedQuestionToAnswer.id,
            status: "checked",
          };
          if (
            !$scope.result.page_description ||
            !$scope.result.page_title ||
            !$scope.result.remarks ||
            !$scope.result.total_marks ||
            !$scope.result.obtained_marks
          ) {
            return swal({
              title: "Error",
              text: "All fields are required",
              type: "error",
            });
          }

          if (
            !$scope.selectedAnswerImage &&
            !$scope.result.markedAssignmentLink
          ) {
            return swal({
              title: "Error",
              text: "Please Attach marked PDF or add marked assignment link",
              type: "error",
            });
          }

          updateStatus(body).then(function (res) {
            if (res && res.success) {
              swal(
                {
                  title: "Assignment Answer Submitted",
                  text: "Assignment Answer is successfully Submitted.",
                  type: "success",
                  timer: 2000,
                },
                function () {
                  $scope.closeAnswerWindow();
                  $scope.answerQuestion = false;
                  $scope.asnwerText = "";
                  $scope.uploadedImgLink = "";
                  $scope.selectedQuestionToAnswer = "";
                  $scope.videoLink = "";
                  $scope.$apply();
                  swal.close();
                  $scope.getAllQuestions();
                }
              );
            } else {
              swal({
                title: "Error",
                text: "Error in assignement submittion",
                type: "error",
              });
            }
          });
        };
        $scope.previewEnlargedImage = function (image) {
          console.log("Image", image);
          $scope.previewImage = image;
          $scope.imagePreview = true;
          $scope.displayQuestion = false;
        };
        $scope.formatTextforLink = function (text) {
          console.log("in format text", text);
          if (!text) return text;
          var newText = text.replace(/(https?:\/\/[^\s]+)/g, function (url) {
            $scope.containsLinks = true;

            return (
              '<a target="_blank" style="margin-bottom: 5px;" href="' +
              url +
              '"' +
              ">" +
              url +
              "</a>"
            );
          });
          console.log("in formatted text", newText);

          return newText;
        };
        $scope.closeQuestion = function () {
          // $scope.displayQuestion = false;
          $scope.selectedQuestionImage = null;
          $scope.videoLink = "";
          $scope.selectedAnswerImage = false;
          $scope.displayQuestion = false;
          $scope.displayAnswer = false;
          $scope.notAvideo = true;
          $scope.imageshowloader = false;
          $scope.isYoutube = false;

          $scope.viewRemoveManager();
        };
        $scope.handleOptions = function () {
          $scope.showOptions = !$scope.showOptions;
        };
        $scope.uploadLink = function (link) {
          console.log(link, "yt");

          if (link.includes("watch?v=")) {
            link.replace("watch?v=", "embed/");
            $scope.selectedImageAnswer = link;
          }
          console.log(link);

          $scope.uploadedImgLink = link;
          $scope.notAvideo = false;
          $scope.isYoutube = true;
          $scope.isPDF = false;
          // $scope.$apply();
        };
        $scope.selectUploadType = function (type) {
          console.log("TYPE UPLOAD", type);
          $scope.defaultDropDown = type;

          if (type === "Assignment Link") {
            $scope.fileUploadSelected = false;
            $scope.linkUpload = true;
          } else {
            $scope.fileUploadSelected = true;
            $scope.linkUpload = false;
            $scope.isYoutube = false;
          }
          $scope.handleOptions();
        };
        $scope.closePreviewImage = function (type) {
          // $scope.previewImage = "";
          $scope.imagePreview = false;
          if ($scope.questionPopup) {
            $scope.displayQuestion = true;
          } else {
            $scope.displayAnswer = true;
          }
        };
        sr.trustSrc = function (src) {
          console.log(src, "sssssssource");
          return $sce.trustAsResourceUrl(
            "https://www.youtube.com/embed/" + src
          );
        };
      },
    ]);
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('archiveCourseController', ['$scope', '$state', 'CustomStorageService', 'HttpService', '$http', 'env', function ($scope, $state, CustomStorageService, HttpService, $http, env) {
      var sr = $scope;
      $scope.selectedCourses = [];
      $scope.selectedCourseId = null
      $scope.selectedCourseName = ''
      $scope.isUploading = false;
      sr.searchInfo = function (value) {
        getInfo({ key: value, unpublished: true }, 'api/v1/courses/search');
      }

      var getInfo = function (data, api) {
        HttpService.getRequest(api, data)
          .then(function (res) {
            sr.courses = res.courses;
          });
      }
      var getInsitutions = function () {
        $http({
          url: 'api/v1/courses/getUniversityList',
          method: "GET",
          params: { type: 'admin' }
        }).then(function (data) {
          sr.institutions = data.data;
          sr.selectedInstitution = "Select Institution";
        });
      }();
      sr.updateInstitution = function (institute) {
        sr.selected_faculty = $scope.institutions[institute].faculties;
        sr.selectedInstituteNo = institute;
      };
      sr.updateSchool = function (school) {
        sr.selectedFaculty = school;
        getCourses();
      }
      sr.updateCourse = function (course) {
        var course = sr.courses[course];
        $scope.selectedCourses.push(course);
        $scope.selectedCourseId  = course.id
        console.log("🚀 ~ $scope.selectedCourses:", $scope.selectedCourses)
      }
      var getCourses = function () {
        if (!sr.selectedInstitution || !sr.selectedFaculty) {
          swal({
            title: "Error!",
            text: "Please select an institution and faculty!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        var data = {
          institution: sr.institutions[sr.selectedInstituteNo].institution,
          faculty: sr.selectedFaculty,
          admin: true
        };
        $http({
          url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
          method: "GET",
          params: data
        }).then(function (data) {
          if (data.data.success) {
            sr.courses = data.data.courses;
          } else {
            alert('server error');
          }
        });
      };

      // sr.selectCourse = function (course) {
      //   $scope.courses = [];
      //   $scope.courseKey = '';
      //   $scope.selectedCourseId = course.id
      //   $scope.selectedCourseName = course.name
      // }
      sr.deletecourse = function(index) {
        $scope.selectedCourses.splice(index, 1);
        
      }

      var getArchiveCourses = function () {
        $http({
          url: env.videoMigrationMicroServicePath + env.gatewayServerPath + 'videos/unarchive-videos',
          method: "GET",
        }).then(function (res) {
          $scope.unArchiveCourses = res.data;
        });
      }
      getArchiveCourses()

      $scope.archiveVideos = function () {
        $scope.isUploading = true;
        var courseIds = $scope.selectedCourses.map(function(course) {
          return course.id;
        });
        $http
          .post(
            env.videoMigrationMicroServicePath +
            env.gatewayServerPath +
            "videos/archive-videos",
            { courseId: courseIds }
          )
          .then(function (data) {
            if(data.data.success){
              swal({
                title: 'Course Archive',
                text: "Course Archive Successfully!",
                type: 'success',
                showConfirmButton: false,
                timer: 2000,
              }, function () {
                  swal.close();
                  $state.go('ArchiveCourse', {}, {reload:true});
              });
            }else{
              swal({
                title: "Error",
                text: data.data.message,
                type: "error"
              },function(){
                swal.close();
                $state.go('ArchiveCourse', {}, {reload:true});
              })
            }
            $scope.isUploading = false;
          });
      };
    }]);

})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('adminAccessController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      $scope.currentPage = 1;

      $http.get('/api/v1/auth/get',{})
        .then(function(resp) {
          if (resp.data.success) {
            $scope.adminAccess = resp.data.data;
            $scope.count = resp.data.count;
          } else {
            swal({
              title: "Error",
              type: "error",
              text: 'Error while getting data',
            }, function() {
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Error while getting data',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      
      $scope.revokeAccess = function(access, index) {
        const data = {
          id: access.id,
        }
        $http.put('/api/v1/auth/revoke-access',data)
        .then(function(resp) {
          if (resp.data.success) {
            $scope.adminAccess.splice(index, 1)
            swal({
              title: "Success",
              text: resp.data.message,
              type: "success",
              showConfirmButton: true
            })
          } else {
            swal({
              title: "Error",
              type: "error",
              text: resp.data.message,
            }, function() {
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Error while sending code',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      }

      $scope.showNext = function(type) {
        if(type === 'next' && $scope.adminAccess.length > 29) {
          $scope.currentPage ++;
        } else if( type === 'previous' && $scope.currentPage > 1) {
          $scope.currentPage --;
        }
        $http.get('/api/v1/auth/get?page=' + $scope.currentPage)
        .then(function(resp) {
          if (resp.data.success) {
            $scope.adminAccess = resp.data.data;
            $scope.count = resp.data.count;
          } else {
            swal({
              title: "Error",
              type: "error",
              text: 'Error while getting data',
            }, function() {
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Error while getting data',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      }
    }]);
  })();
  
(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('AdminSignInController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', '$cookies', function($scope, $http, $state,$rootScope, CustomStorageService, $cookies) {
    if( CustomStorageService.getAdminSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
      $state.go('AdminDashBoard',{},{reload:true});
    }
    $scope.loginForm = {};
    $rootScope.userSide= false;
    $rootScope.adminSide = true;
    $scope.submitLogin = function(loginForm) {
      var browserId = $cookies.get('browserId');
      loginForm.browser_id = browserId;
      loginForm.origin = 'LEGACY';
      $http.post('/api/v1/auth/signin',loginForm)
      .then(function(resp) {
        if (resp.data.user.user_type === 'admin') {
          swal({
            title: "Verification Code Sent!",
            text: resp.data.message,
            type: "success",
            showConfirmButton: true
          }, function() {
            swal.close();
            //CustomStorageService.SignInService(true,false,false,resp.data.token,resp.data.user);
            $state.go('adminPanelOtp',{user_id: resp.data.user.id});
          });
        } else if(resp.data.user.user_type === 'activity_viewer') {
          CustomStorageService.SignInService(false,false,false,false,resp.data.token,resp.data.user);
          $state.go('fsc_visits');
        } else if(resp.data.user.user_type === 'marketing') {
          CustomStorageService.SignInService(true,false,false,false,resp.data.token,resp.data.user);
          $state.go('emails-in-bulk');
        } else {
          swal({
            title: "Not Authorized!",
            type: "error",
            confirmButtonText: "Ok"
          }, function() {
            CustomStorageService.logOutService();
          });
        }
      },function errorCallback(response) {
        swal({
          title: 'error',
          text: response.data.message,
          type: 'error',
          showCancelButton: false
        },function(isConfirm){
        });
      });
    };
  }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('ReasonsController', ['$scope', 'CustomStorageService', '$state', '$http', function ($scope, CustomStorageService, $state, $http) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.reason = {};
            sr.editReason = function (reason, edit) {
                sr.reason = reason;
            }
            var getReason = function () {
                $http({
                    url: 'api/v1/reason/get',
                    method: 'GET'
                }).then(function (response) {
                    if (response.data.success) {
                        sr.allReasons = response.data.reasons;
                    }

                });

            }
            sr.createReason = function (reason) {
                $http.post('api/v1/reason/create', reason) 
                    .then(function (response) {
                        if (response.data.success) {
                            swal({
                                title: "successful",
                                text: response.data.message,
                                type: "success"
                            });
                            sr.reason = {};
                            getReason();
                        }
                        else {
                            swal({
                                title: "error",
                                text: response.data.message,
                                type: "error"
                            }, function () {
                            });

                        }
                    }, function (response) {
                    });

            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {

                getReason();
            }
        }]);
})();
(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('PaymentTypeController', ['$scope', 'CustomStorageService', '$state', '$http', function ($scope, CustomStorageService, $state, $http) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.paymentType = {};
            sr.editPayType = function (paymentType, edit) {
                sr.paymentType = paymentType;
            }
            var getPayType = function () {
                $http({
                    url: 'api/v1/payment/get',
                    method: 'GET'
                }).then(function (response) {
                    if (response.data.success) {
                        sr.allPayTypes = response.data.types;
                    }

                });

            }
            sr.createPaymentType = function (paymentType) {
                $http.post('api/v1/payment/create', paymentType)
                    .then(function (response) {
                        if (response.data.success) {
                            swal({
                                title: "successful",
                                text: response.data.message,
                                type: "success"
                            });
                            sr.paymentType = {};
                            getPayType();
                        }
                        else {
                            swal({
                                title: "error",
                                text: response.data.message,
                                type: "error"
                            }, function () {
                            });

                        }
                    }, function (response) {
                    });

            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {

                getPayType();
            }
        }]);
})();
(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('CourseFeatureController', ['$scope', 'UploadService', 'HttpService', 'CustomStorageService', 'FeatureService','$state', function ($scope, UploadService, HttpService, CustomStorageService, FeatureService,$state) {
            var sr = $scope;
            sr.features = [];
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.cf = { imageUrl: null, publish: false };
            var getFeature = function (query) {
                FeatureService.getFeature(query)
                    .then(function (result) {           
                        sr.features = result;
                    }).catch(function (error) {
                        sr.features = [];
                     });
            }
            sr.editFeature = function (feature, type) {
                if (type == 'edit') {
                    sr.cf = feature;
                } else if (type == 'del') {
                    removeFeature(feature.id, 'remove');
                } else if (type == 'publish') {
                    removeFeature(feature.id, 'publish');
                }
            }
            var removeFeature = function (id, type) {
                var api = 'api/v1/courses/feature/publish'
                HttpService.postRequest(api, { id: id, type: type })
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });

            }

            sr.searchFeature = function (query) {
                getFeature({ query: query });
            }

            sr.delImage = function () {
                sr.cf.imageUrl = null;
            }


            sr.submit = function (cf) {
                var api = 'api/v1/courses/feature/create'
                HttpService.postRequest(api, cf)
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                            sr.cf = { imageUrl: null, publish: false };
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });
            }
            sr.uploadImage = function (image) {
                UploadService.uploadImage(image)
                    .then(function (data) {
                        sr.cf.imageUrl = data;
                    });
            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {
                getFeature({});
            }

        }])

})();
(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('MainCategoriesController', ['$scope', 'UploadService', 'HttpService', 'CustomStorageService', 'FeatureService','$state', function ($scope, UploadService, HttpService, CustomStorageService, FeatureService,$state) {
            var sr = $scope;
            sr.features = [];
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.cf = { image_url: null, publish: false };
            var getFeature = function (query) {
                HttpService.getRequest('api/v1/main-category/get', query || {})
                .then(function (res) {
                    if (res.success) {
                        sr.features = res.features;
                    }
                    else {
                        sr.features = [];
                    }
                });
            }
            sr.editFeature = function (feature, type) {
                if (type == 'edit') {
                    sr.cf = feature;
                } else if (type == 'del') {
                    removeFeature(feature.id, 'remove');
                } else if (type == 'publish') {
                    removeFeature(feature.id, 'publish');
                }
            }
            var removeFeature = function (id, type) {
                var api = 'api/v1/main-category/publish'
                HttpService.postRequest(api, { id: id, type: type })
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });

            }

            sr.searchFeature = function (query) {
                getFeature({ query: query });
            }

            sr.delImage = function () {
                sr.cf.image_url = null;
            }


            sr.submit = function (cf) {
                var api = 'api/v1/main-category/create'
                HttpService.postRequest(api, cf)
                    .then(function (res) {
                        if (res.success) {
                            swal({
                                title: "successful",
                                text: res.message,
                                type: "success"
                            });
                            getFeature({});
                            sr.cf = { image_url: null, publish: false };
                        } else {
                            swal({
                                title: "Error!",
                                text: res.message,
                                type: "error",
                                confirmButtonText: "Ok"
                            });
                        }
                    });
            }
            sr.uploadImage = function (image) {
                UploadService.uploadImage(image)
                    .then(function (data) {
                        sr.cf.image_url = data;
                    });
            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {
                getFeature({});
            }

        }])

})();
(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('InstitutionController', ['$scope', 'CustomStorageService', 'HttpService', function ($scope, CustomStorageService, HttpService) {
            var sr = $scope;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();
            sr.institution = {};
            sr.editInstitute = function (inst, type) {
                if (type == 'edit') {
                    sr.institution = inst;

                }
                else if (type == 'del') {
                    var c = confirm('Do you really want to delete this ?')
                    if (c) {
                        removeInstitute(inst);
                    }
                }
            }


            var removeInstitute = function (inst) {
                HttpService.postRequest('api/v1/institute/remove', { id: inst.id })
                    .then(function (response) {
                        if (response) {
                            swal({
                                title: "Institution removed!",
                                type: "success",
                                confirmButtonText: "Ok",
                                text: response.faq.message,
                                timer: 2000,
                                showConfirmButton: false
                            })
                        } 
                        getInstitutions();
                    });
            }


            var getInstitutions = function () {
                HttpService.getRequest("api/v1/institute/get")
                    .then(function (response) {
                        if (response.success) {
                            sr.institutions = response.inst;
                        }
                    });
            }

            sr.createIstitution = function (inst) { 
                if (inst.name != null) {
                    HttpService.postRequest("api/v1/institute/create", inst)
                        .then(function (response) {
                            if (response.success) {
                                swal({
                                    title: "successful",
                                    text: response.message,
                                    type: "success"
                                });
                                sr.institution = {};
                                getInstitutions();
                            }
                            else {
                                swal({
                                    title: "error",
                                    text: response.message,
                                    type: "error"
                                }, function () {
                                });
                            }
                        });
                }
                else {
                    swal({
                        title: "OOPs",
                        text: 'Enter Institution Name',
                        type: "warning"
                    }, function () {
                    });
                }
            }
            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {

                getInstitutions();
            }

        }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .controller('FAQSController', ['$scope', 'CustomStorageService', 'HttpService', '$state', function ($scope, CustomStorageService, HttpService, $state) {
            var sr = $scope;
            sr.totalPages = 1;

            sr.faq = {};
            sr.searchParams = {
                page: 1,
                per_page: 50
            };
            var instID;
            var signedIn = CustomStorageService.getAdminSignedInStorageData();

            //GET all institutes to populate in dropdown menu
            sr.institute = {};

            var getAll = function () {
                getInst(sr.searchParams);
                getFaqs(sr.searchParams);
            };
            var getFaqs = function (params) {
                HttpService.getRequest("api/v1/instFaq/get", params)
                    .then(function (response) {
                        if (response.success) {
                            sr.totalFaqs = response.totalFaqs;
                            sr.totalPages = response.totalPages;
                            sr.viewFaq = response.instFaq.length;

                            sr.faqs = response.instFaq;
                        }
                    });
            }

            var getInst = function () {
                HttpService.getRequest("api/v1/institute/get")
                    .then(function (response) {
                        if (response.success) {
                            sr.institutions = response.inst;

                        }
                    });
            }
            // show faqs of selected institute
            sr.pickIt = function (ins) {
                sr.instName = ins;
                sr.searchParams.pick = ins.id;
                sr.searchParams.faqExcerpt = "";

                getFaqs(sr.searchParams);
            };

            //delete an faq from specific institution
            sr.deleteFaq = function (faq) { 

                var verify = confirm('Do you really want to delete this ?')
                if (verify) {
                    removeFaq(faq);
                }
            }

            var removeFaq = function (faq) {
                if (faq.FaqsInstt) { 
                    HttpService.getRequest("api/v1/faq/remove", { id: faq.id })
                        .then(function (data) {
                            swal({
                                title: "FAQ removed!",
                                type: "success",
                                confirmButtonText: "Ok",
                                timer: 2000,
                                showConfirmButton: false
                            });
                            getFaqs(sr.searchParams);
                        });
                }
                if (faq.faqId) {
                    HttpService.getRequest("api/v1/instFaq/remove", { id: faq.id })
                        .then(function (data) {
                            swal({
                                title: "FAQ removed!",
                                type: "success",
                                confirmButtonText: "Ok",
                                timer: 2000,
                                showConfirmButton: false
                            });
                            sr.pickIt(sr.instName);
                        });
                }
            }
            sr.pagination = function (page) { 
                if (page > 0 && page <= sr.totalPages) {
                    sr.searchParams.page = page;

                    getFaqs(sr.searchParams);
                }
            }


            if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                $state.go('admin_panel', {}, { reload: true });
            } else {
                getAll();
            }

            sr.searchFaq = function (faqExcerpt) {
                if(faqExcerpt == ""){ 
                    sr.searchParams.faqExcerpt = "";
                    sr.searchParams.pick = "";
                    sr.getAllInstFaqs();
                }else{  
                    sr.searchParams.faqExcerpt = faqExcerpt;
                    sr.searchParams.pick = "";
                    getFaqs(sr.searchParams);
                }
            }

            sr.getAllInstFaqs = function () {
                sr.instName = "";
                sr.searchParams.pick = "";
                getFaqs(sr.searchParams);
            }
        }]);
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('DeleteCourseController', ['$scope','$state','CustomStorageService', 'HttpService', '$http', function($scope,$state,CustomStorageService, HttpService, $http) {

      var initialize = function (id) {
        const userData = CustomStorageService.getUserInfoStorageData();
        if(userData.is_super_admin) {
          swal({
            title: "Are you sure to delete course?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, submit it!",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                $http({
                  url: '/api/v1/courses/deleteCourse',
                  method: "POST",
                  params: {id: $state.params.course_id }
                }).then(function(res) {
                  if(res.data.success) {
                    setTimeout(function () {
                      swal({
                        title: "Course Deleted Successfully",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false
                      }, function() {
                        swal.close();
                        $state.go('AdminDashBoard',{},{reload:true});
                      });
                    }, 500)
                  } else {
                    swal({
                      title: "Course not Deleted",
                      type: "error",
                      timer: 2000,
                      showConfirmButton: false
                    }, function() {
                      swal.close();
                      $state.go('AdminDashBoard',{},{reload:true});
                    });
                  }
                  
                });
              } else {
                $state.go('AdminDashBoard',{},{reload:true});
              }
            });
        } else {
          swal({
            title: "Please login with super admin",
            type: "error",
            timer: 2500,
            showConfirmButton: false
          }, function() {
            swal.close();
            $state.go('AdminDashBoard',{},{reload:true});
          });
        }
        
      }
      if (!CustomStorageService.getAdminSignedInStorageData()) {
        const data = {
          courseDeleteRedirect: true,
          course_id: $state.params.course_id,
          instructor_id: $state.params.instructor_id,
        }
        CustomStorageService.setCourseDeleteLogin(data);
        $state.go('admin_panel', {}, { reload: true });
      } else {
        const data = {
          courseDeleteRedirect: false,
          course_id: undefined,
          instructor_id: undefined,
        }
        CustomStorageService.setCourseDeleteLogin(data);
        setTimeout(function() {
          initialize();
        }, 1000)
        
      }

    }]);
  })();

(function () {
    'user strict'
    angular
        .module('NearPeer')
        .controller('CourseAccessFormController',
            ['UploadService', '$scope', '$state', 'HttpService', 'CustomStorageService', '$http', 'env', '$timeout', "toaster", "TrackingService",
                function (UploadService, $scope, $state, HttpService, CustomStorageService, $http, env, $timeout, toaster, TrackingService) {
                    var sr = $scope;
                    sr.notifyByWhatsapp = false;
                    sr.key = "";
                    sr.newUser = false;
                    sr.users = [];
                    sr.sessions = [],
                    sr.courses = [];
                    sr.modules = [];
                    sr.reasons = [];
                    sr.payTypes = [];
                    sr.allAgent = [];
                    sr.agents = [];
                    sr.types = true;
                    sr.sessionKey = '';
                    sr.access = {
                        type: null,
                        amount: null,
                        proof: null,
                        comments: null,
                        payment_id: null,
                        reason_id: null,
                        accessType: 'payment',
                        orderStatus: 'paid',
                        paymentMethod: 'EASYPAISA',
                        payment_date: null,
                    };
                    sr.showInfo = true;
                    sr.selectedUser = {}, sr.selectedCourse = {}, sr.selectedCourses = [];
                    sr.selectedModule = {};
                    var signedIn = CustomStorageService.getAdminSignedInStorageData();
                    var items = [];

                    var getAgents = function () {
                        $http
                        .get("https://apigateway.nearpeer.org/lmsservice/v1/odoo/get-all-odoo-agents")
                        .then(
                        function (response) {
                            if (response.data.success) {
                                sr.allAgent = response.data.agents;
                                // sr.agents = response.data.agents;
                            }
                            // $scope.existingTags = response.data.tags;
                        },
                        function (error) {
                            setTimeout(function() {
                                getAgents()
                            }, 10000)
                        }
                        );
                    }

                    var getCampaigns = function () {
                        $http.get("/api/v1/campaign/get-campaign-names").then(function (resp) {
                            if (resp.data.success) {
                                sr.campaigns = resp.data.campaigns;
                                console.log('sr.campaigns');
                                console.log(sr.campaigns);
                            } else {
                              console.log("network error");
                            }
                          });
                    }
                    

                    sr.searchInfo = function (value, type) {
                        if (type === 'user') {
                            getInfo({ key: value }, type, 'api/v1/user/search');
                        } else if (type === 'course' || type === 'module') {

                            getInfo({ key: value, paid: true }, 'course', 'api/v1/courses/search');
                        } else if (type === 'bundle') {
                            getBundle({ key: value, admin: true }, 'api/v1/bundle/find');
                        }
                    }

                    sr.searchAgent = function (text) {
                        sr.agents = sr.allAgent.filter(function (agent) {
                            return agent.name.toLowerCase().includes(text.toLowerCase());
                          });
                    }

                    sr.focusAgent = function () {
                        $scope.hideAgent = false;
                        $scope.agents = $scope.allAgent; 
                        sr.agentKey = '';
                    }

                    sr.agentBlur = function () {
                        $timeout(function(){
                            $scope.agents = [];
                            $scope.hideAgent = true;
                            sr.agentKey = '';
                        }, 200)
                    }

                    sr.selectAgent = function (agent) {
                        $scope.agents = [];
                        if(agent === 'none') {
                            delete sr.access.agent;
                        } else {
                            sr.access.agent = agent;
                        }
                        // $scope.$apply()
                    }

                    $scope.selectedCampaigns = [];
                    $scope.hideCampaign = true;

                    sr.searchCampaign = function (text) {
                        $scope.selectedCampaigns = sr.campaigns.filter(function (agent) {
                            return agent.name.toLowerCase().includes(text.toLowerCase());
                          });
                    }

                    sr.focuscampaign = function () {
                        $scope.hideCampaign = false;
                        sr.campaignKey = '';
                    }

                    sr.campaignBlur = function () {
                        $timeout(function(){
                            $scope.hideCampaign = true;
                            sr.campaignKey = '';
                        }, 200)
                    }

                    sr.selectCampaign = function (agent) {
                        $scope.selectedCampaigns.push(agent);
                    }

                    var getSession = function (data, api, selectedCourse) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                selectedCourse.sessions = res.sessions;
                            });
                    }

                    var getBundle = function (data, api) {
                        HttpService.postRequest(api, data)
                            .then(function (res) {
                                sr.courses = res.bundles;
                            });
                    }
                    var timer;
                    var getInfo = function (data, type, api) {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            HttpService.getRequest(api, data)
                            .then(function (res) {
                                if (type === 'user') {
                                    sr.users = res.users;
                                } else if (type === 'course') {
                                    sr.courses = res.courses;
                                } else if (type === 'module') {
                                    sr.modules = res.modules;
                                }
                            });
                        }, 800);
                        
                    }
                    sr.addModule = function (module) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === module.id && course.type === 'module') {
                                isAllowed = false
                            }
                        })
                        if(isAllowed) {
                            HttpService.getRequest('/api/v1/access/verify', {user_id: sr.selectedUser.id, course_id: sr.selectedCourse.id, module_id: sr.modules[module].id, type: 'module'})
                            .then(function (res) {
                                if(!res.success) {
                                    swal({
                                        title: "Error!",
                                        text: res.message,
                                        type: "error",
                                        confirmButtonText: "Ok"
                                    });
                                } else {
                                    getSubscriptions({module_id: sr.modules[module].id}).then(function (subscriptions) {
                                        $scope.reactivate = res.reactivate;
                                        sr.selectedModule = sr.modules[module];
                                        sr.selectedModule.type = 'module';
                                        sr.selectedModule.subscriptions = subscriptions;
                                        if(res.courseReactivate) {
                                            sr.selectedModule.courseReactivate = true;
                                        }
                                        sr.selectedModule.price = sr.selectedModule.module_type.price;
                                        items = [{
                                            course_id: sr.selectedCourse.id,
                                            module_id: sr.selectedModule.id,
                                            bundle_id: null
                                        }];
                                        sr.selectedModule.items = items;
                                        sr.selectedCourses.push(sr.selectedModule);
                                    })
                                }
                            });  
                        }
                    }
                    sr.uploadImage = function (image, type) {
                        UploadService.uploadStoryImage(image)
                            .then(function (data) {
                                if (type === 'user') {
                                    sr.selectedUser.cnic = data;
                                } else {
                                    sr.access.proof = data.thumbnail_link;
                                }
                            });
                    }
                    sr.purchaseType = function (type) {
                        sr.access.type = type;
                        items = [];
                        sr.courseKey = "";
                        sr.userKey = "";
                    }
                    sr.searchSession = function (selectedCourse, value) {
                        getSession({ key: value, admin: true }, '/api/v1/session/search', selectedCourse);
                    }
                    sr.selectSession = function (selectedCourse, session) {
                        selectedCourse.sessionKey = session.name;
                        selectedCourse.session_id = session.id;
                        selectedCourse.sessions = [];
                        sr.access.session_id = session.id;
                        sr.access.session_name = session.name;
                    }
                    sr.selectSessionBlur = function (selectedCourse) {
                        setTimeout(function() {
                            selectedCourse.sessions = [];
                            $scope.$apply();
                        }, 500)
                    }

                    var getSubscriptions = function (data) {
                        return new Promise(function(resolve, reject) {
                            var params = {}
                            if(data.course_id) {
                                params.course_id = data.course_id;
                            } else if(data.module_id) {
                                params.module_id = data.module_id;
                            } else if(data.bundle_id) {
                                params.bundle_id = data.bundle_id;
                            }
                            HttpService.getRequest('/api/v1/subscriptions/get-subscriptions', params)
                            .then(function (res) {
                                if(res.success) {
                                    resolve(res.result)
                                } else {
                                    resolve([])
                                }
                            })
                        })
                    }

                    sr.addVariants = function (user, type) {
                        var isAllowed = true;
                        angular.forEach(sr.selectedCourses, function(course) {
                            if(course.id === user.id && (type === course.type || type == 'module')) {
                                isAllowed = false
                            }
                        })
                        if(isAllowed) {
                            if(!sr.selectedUser.id && !sr.newUser && type !== 'user') {
                                swal("please select user first");
                                sr.courses = [];
                                sr.users = [];
                                sr.courseKey = ""
                                return
                            }
                            else if(type === 'course' || type === 'module' || type === 'bundle') {
                                HttpService.getRequest('/api/v1/access/verify', {user_id: sr.selectedUser.id, course_id: user.id, bundle_id: user.id, type: type === 'module' ? 'course' : type})
                                .then(function (res) {
                                    if(!res.success) {
                                        swal({
                                            title: "Error!",
                                            text: res.message,
                                            type: "error",
                                            confirmButtonText: "Ok"
                                        });
                                    } else {
                                        $scope.reactivate = res.reactivate;
                                        if (type === 'course') {
                                            getSubscriptions({course_id: user.id}).then(function (subscriptions) {
                                                user.subscriptions = subscriptions;
                                                sr.selectedCourse = user;
                                                sr.selectedCourse.type = type;
                                                sr.courseKey = sr.selectedCourse.name;
                                                if(res.courseReactivate) {
                                                    sr.selectedCourse.courseReactivate = true;
                                                }
                                                sr.courses = [];
                                                items = [{
                                                    course_id: sr.selectedCourse.id,
                                                    module_id: null,
                                                    bundle_id: null
                                                }];
                                                sr.selectedCourse.items = items;
                                                sr.selectedCourses.push(sr.selectedCourse);
                                                sr.courseKey = ""
                                                validateDiscount();
                                            })
                                        } else if (type === 'module') {
                                            sr.selectedCourse = user;
                                            sr.courseKey = sr.selectedCourse.name;
                                            sr.courses = [];
                                            getInfo({ id: sr.selectedCourse.id }, sr.access.type, 'api/v1/courses/getModulesByCourseId');
                                            // url: 'api/v1/courses/getModulesByCourseId',
                                            //         method: "GET",
                                            //         params: {id: id}
                                            // items.push({
                                            //     course_id: sr.course.course_id,
                                            //     module_id: sr.course.id,
                                            //     bundle_id: null
                                            //   });
                
                                        } else if (type === 'bundle') {
                                            getSubscriptions({bundle_id: user.id}).then(function (subscriptions) {
                                                user.subscriptions = subscriptions;
                                                sr.selectedCourse = user;
                                                sr.selectedCourse.type = type;
                                                sr.courseKey = sr.selectedCourse.name;
                                                sr.courses = [];
                                                items = sr.selectedCourse.course;
                                                sr.selectedCourse.items = items;
                                                sr.selectedCourses.push(sr.selectedCourse);
                                                sr.courseKey = "";
                                            })
                                        }
                                    }
                                });
                            } else {
                                sr.reactivate = false;
                                sr.selectedUser = user;
                                sr.userKey = sr.selectedUser.email || sr.selectedUser.fb_email;
                                sr.users = [];
                            }
                        } else {
                            sr.courses = [];
                            sr.users = [];
                            sr.courseKey = ""
                        }
                    }
                    sr.removeCourse = function (index) {
                        sr.selectedCourses.splice(index, 1)
                    } 
                    sr.showAccesForm = function () {
                        if (Object.keys(sr.selectedUser).length === 0) {
                            swal("please add user")
                            return false;
                        }
                        if (Object.keys(sr.selectedCourse).length === 0) {
                            swal("please add course")
                            return false;
                        } if (sr.access.type === 'module' && Object.keys(sr.selectedModule).length === 0) {
                            swal("please add module")
                            return false;
                        }
                        sr.types = false;
                        sr.showInfo = true;
                    }
                    sr.accessVariants = function (value, type) {
                        if (type === 'reason') {
                            sr.access.reason_id = value;
                        } else {
                            sr.access.payment_id = value;
                        }
                    }
                    var getReason = function () {
                        HttpService.getRequest('api/v1/reason/get')
                            .then(function (res) {
                                if(res && res.reasons) {
                                    sr.reasons = res.reasons;
                                } else {
                                    setTimeout(function() {
                                        getReason()
                                    }, 10000)
                                }
                            })
                    }

                    var getPaymentType = function () {
                        HttpService.getRequest('api/v1/payment/get')
                            .then(function (res) {
                                if(res && res.types) {
                                    sr.payTypes = res.types;
                                } else {
                                    setTimeout(function() {
                                        getPaymentType()
                                    }, 10000)
                                }
                                
                            });
                    }
                    var validateDiscount = function () {
                        var today = new Date();
                        if (sr.selectedCourse.paid) {
                            if (!(sr.selectedCourse.discountTo > today && sr.selectedCourse.discountFrom <= today)) {
                                sr.selectedCourse.discount_price = 0;
                            }
                        }
                    }
                    sr.toggleNotifyByWhatsapp = function() {
                        sr.notifyByWhatsapp = !sr.notifyByWhatsapp;
                    }
                    sr.createAccess = function (user, course, access) {
                        console.log('-----0000----', sr)
                        $scope.disabled = true;
                        if(sr.newUser) {
                            if(!user.phone && sr.notifyByWhatsapp){
                                swal("User Phone is required for whatsapp alert");
                                $scope.disabled = false;
                                return false;
                            }
                            else if(!user.email && !user.phone) {
                                swal("User Email or Phone is required");
                                $scope.disabled = false;
                                return false;
                            } else if(!user.full_name) {
                                swal("User Name is required")
                                $scope.disabled = false;
                                return false;
                            }
                        }
                        if(access.accessType === 'installment') {
                            access.installmentNo = 1;

                            var myDate = new Date(access.expiryDate);
                            var today = new Date();
                            if ( !access.expiryDate || myDate < today ) { 
                                swal("Expiry date show be greater then current date")
                                $scope.disabled = false;
                                return false;
                            }
                            if (!access.notifyHours) {
                                swal("plesae add Notify Hours")
                                $scope.disabled = false;
                                return false;
                            }
                        }
                        if(access.accessType === 'payment'|| access.accessType === 'installment') {
                            if(access.orderStatus === 'paid') {
                                if (!access.payment_id) {
                                    swal("plesae add payment method")
                                    $scope.disabled = false;
                                    return false;
                                }
                                if (!access.reason_id) {
                                    if (!access.proof) {
                                        swal("please attach payment proof ");
                                        $scope.disabled = false;
                                        return false;
                                    }
                                }
                                if (!access.payment_date) {
                                        swal("please Select payment date");
                                        $scope.disabled = false;
                                        return false;
                                }
                            }
                            var isAmount = true;
                            course.forEach(function(course) {
                                if(!course.amount) {
                                    isAmount = false;
                                }
                            });
                            if (!isAmount) {
                                swal("Please add Amount Received for all");
                                $scope.disabled = false;
                                return false;
                            }
                            
                            
                        } else if (access.accessType === 'subscription') {
                            var isSubscription = true;
                            course.forEach(function(course) {
                                if(!course.subscription_id) {
                                    isSubscription = false;
                                }
                            });
                            if (!isSubscription) {
                                swal("Please select subscription");
                                $scope.disabled = false;
                                return false;
                            }

                        } else {
                            var myDate = new Date(access.expiryDate);
                            var today = new Date();
                            if (myDate < today ) { 
                                swal("Expiry date show be greater then current date")
                                $scope.disabled = false;
                                return false;
                            }
                            if (!access.notifyHours) {
                                swal("plesae add Notify Hours")
                                $scope.disabled = false;
                                return false;
                            }
                        }

                        if(!sr.access.agent) {
                            swal("Please add agent name")
                            $scope.disabled = false;
                            return false;
                        }

                        if (items.length === 0) {
                            $scope.disabled = false;
                            return false;
                        }
                        if (access.type === 'module') {
                            //course = sr.selectedModule;
                        }
                        access.campaigns = $scope.selectedCampaigns;
                        HttpService.postRequest('api/v1/access/create', {
                            user: user,
                            course: course,
                            access: access,
                            items: items,
                            notifyByWhatsapp: sr.notifyByWhatsapp
                        })
                            .then(function (res) {
                                $scope.disabled = false;
                                if (res.success) {
                                    
                                    var amountPaid = 0;
                                    course.forEach(function(c){
                                        amountPaid += c.amount;
                                    })
                                    if(access.orderStatus === 'paid') {
                                        course.forEach(function(courseData, index) {
                                            TrackingService.purchaseEvent({
                                                order_id: res.orderIds[index],
                                                price: courseData.amount,
                                                item_id: courseData.id,
                                                item_name: courseData.name,
                                                discount: courseData.price - courseData.amount,
                                                productType: courseData.type,
                                                paymentMethod: 'Admin',
                                                institute: courseData.institution || 'Default',
                                                orderType: 'Admin-Order',
                                            });
                                        }) 
                                        
                                    }
                                    swal({
                                        title: access.orderStatus === 'placed' ? 'Payment Link Generated Successfully' : res.message,
                                        type: "success",
                                        showConfirmButton: true,
                                        confirmButtonText: access.orderStatus === 'placed' ? 'Copy Link' : 'OK',
                                    }, function () {
                                        $scope.disabled = false;
                                        swal.close();
                                        if(access.orderStatus === 'placed') {
                                            copylink(res.paymobData.iframe_url);
                                        }
                                        $state.go('AdminOrdersManagement');
                                    });
                                } else {
                                    swal({
                                        title: res.message,
                                        type: "error",
                                        showConfirmButton: true
                                    }, function () {
                                        $scope.disabled = false;
                                        swal.close();
                                    });
                                }
                            });
                    }

                    var copylink = function (link) {
                        var textArea = document.createElement("textarea");
                        textArea.value = link;
                        document.body.appendChild(textArea);
                        textArea.select();
                        document.execCommand("Copy");
                        textArea.remove();
                        toaster.success({
                          title: "Link copied successfully",
                        });
                    };

                    if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
                        $state.go('admin_panel', {}, { reload: true });
                    } else {
                        getPaymentType();
                        getReason();
                        getAgents();
                        getCampaigns();
                    }
                }
            ]
        );
})();
(function () {
    'use strict';
  
    angular
        .module('NearPeer')
        .controller('userOrderListController',  ['$scope', '$http', '$state', 'SearchService', 'CustomStorageService', 'HttpService', 
        function ($scope, $http, $state, SearchService, CustomStorageService, HttpService) {
        var signedIn = CustomStorageService.getUserSignedInStorageData();
        if (!signedIn || !CustomStorageService.getUserInfoStorageData()) {
            $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
            $scope.$emit('showLoginPopup');
        } else {
            var data = {
                forDownload: false,
                key:CustomStorageService.getUserInfoStorageData().email,
                page:1,
                perPage:10,
                type:"user",
                emailAdmin: CustomStorageService.getUserInfoStorageData().email
            }
            var getOrders = function (data) {
                HttpService.postRequest('api/v1/orders/get', data)
                    .then(function (res) {
                        console.log(res);
                        if (res.message) {
                            swal({
                                title: res.message,
                                type: "success",
                                showConfirmButton: true
                            }, function () {
                                swal.close();
                            });
                        } else {
                            $scope.orders = res.orders;
                            $scope.totalPages = res.pages;
                            $scope.totalCount = res.orderCount;
                        }
                        console.log('orders---->',res.orders);
                });
            }
            getOrders(data);
        }        
    }]);
})();
(function () {
    'use strict';
  
    angular
        .module('NearPeer')
        .controller('orderSummaryController', MainController);
  
    function MainController($rootScope, $scope, $http, $base64, $timeout, $state) {
    };
  
  })();
(function () {
    'use strict';
  
    angular
        .module('NearPeer')
        .controller('orderPaymentMethodsController', PaymentMethodsController);
  
    function PaymentMethodsController($rootScope, $scope,HttpService,CustomStorageService, $http, UploadService, $timeout, $state, env, courseDetailService, $sails, TrackingService) {
        $scope.orderRefNo = $state.params.orderRefNo;
        $scope.selectTypeDD = '0';
        $scope.waitingForApproval = false;
        $scope.uploadedFromWhatsApp = false;
        $scope.imageURL = '';
        $scope.imageName = '';
        $scope.isInstallmentAllowed = true;
        $scope.loadingPayment = false;
        $scope.isBankPayment = false;
        $scope.isMobilePayment = false;

        var interval;

        
        $scope.qistPayInstallments = [];
        $scope.paymethodsloader = false;
        if($state.params.isQistpay === 'qist-pay') {
            $scope.paymentType = 'qistPay';
        } else if($state.params.isQistpay === 'easypaisa') {
            $scope.paymentType = 'easyPaisaNew';
            $scope.isMobilePayment = true;
        } else if($state.params.isQistpay === 'jazz_cash') {
            $scope.paymentType = 'jazzCash';
            $scope.isMobilePayment = true;
        } else if($state.params.isQistpay !== 'false') {
            $scope.isBankPayment = true;
            $scope.paymentType = $state.params.isQistpay;
        } else {
            $scope.paymentType = 'paymentBanner';
        }
        $scope.voucher = false;
        $scope.mobileAccount = true;
        $scope.card = false;

        var jazzCashType = "MWALLET";

        var apiJazz;
        $scope.newOrder = {};
        var some = {
            ref_no: $scope.orderRefNo
        };
        if(!CustomStorageService.getUserSignedInStorageData()){
            $state.go('Landing');
        }
        setTimeout(function() {
            console.log('timeout working')
           $scope.paymethodsloader = false;
        }, 3000);
        

        $rootScope.$on('$stateChangeStart', 
        function(event, toState, toParams, fromState, fromParams){ 
            // do something
            clearInterval(interval);
        })

        var sendDataToMobile = function(errorData) {
            try {
                console.log('inn sendd');
                console.log('close-in-app-browser');
                var data = {
                    ref_no: $scope.newOrder && $scope.newOrder.ref_no ? $scope.newOrder.ref_no : $scope.orderRefNo,
                    email: $scope.user_.email ? $scope.user_.email : $scope.user_.fb_email ? $scope.user_.fb_email : $scope.user_.apple_email ? $scope.user_.apple_email : 'Social Login',
                    price: $scope.tprice,
                    paymentType: $scope.newOrder ? $scope.newOrder.order_by : 'Unsuccessfull',
                    bundle: $scope.bundle_ ? $scope.bundle_.name : null,
                    course: $scope.course_ ? $scope.course_.name : null,
                    module: $scope.module_ ? $scope.module_.name : null,
                    courseData: $scope.course_,
                    isLiveSession: $rootScope.liveSessionId ? true : false, 
                }
                console.log('inn sendd 111');
                if(errorData) {
                    data.errorCode = errorData.errorCode;
                    data.errorMessage = errorData.errorMessage;
                    console.log('order-payment-data-error|' + JSON.stringify(data));
                } else {
                    console.log('order-payment-data-success|' + JSON.stringify(data));
                }
                console.log('inn sendd 2222');
                
            } catch (error) {
                console.log(error);
            }
        }

        var intervalToCheckStatus = function() {
            setTimeout(function() {
                interval = setInterval(function() {
                    if($scope.paymentType !== 'payment-success') {
                        $http({
                            method: 'GET',
                            url: '/api/v1/order/get-order-status',
                            params: {
                                refNo: $scope.orderRefNo
                            }
                        })
                        .then(function(res) {
                            if(res && res.data && res.data.success) {
                                console.log('close-in-app-browser');
                                mixpanel.track('Payment-Proceed')
                                $scope.paymentType = 'payment-success';
                                ttq.track('Purchase');
                                $scope.$emit("checkPendingOrdersCount");
                                $scope.newOrder = res.data.order;
                                sendDataToMobile();
                                clearInterval(interval);
                                try{
                                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                                    dataLayer.push({
                                        'event': 'order-paid-page',
                                        'ecommerce': {
                                        'currencyCode': 'PKR',                       // Local currency is optional.
                                        'click': {
                                            'id': $scope.newOrder.ref_no,
                                            'paymentMethod': $scope.newOrder.order_by,
                                            'price': $scope.tprice,
                                            'productType': $scope.bundle_ ? 'bundle': $scope.module_ ? 'module' : 'course',
                                            'name': $scope.bundle_ ? $scope.bundle_.name : $scope.module_ ? $scope.module_.name : $scope.course_.name,
                                            'brand': 'Nearpeer',
                                            'orderType': 'Self-Order',
                                            'instName': $scope.course_.institution || 'Default'
                                        }
                                        
                                        }
                                    })
                                    fbq('track', 'Purchase', {
                                        content_ids: $scope.newOrder.ref_no,
                                        content_type: $scope.bundle_ ? 'bundle': $scope.module_ ? 'module' : 'course',
                                        value: $scope.tprice,
                                        currency: 'pkr',
                                        content_name: $scope.bundle_ ? $scope.bundle_.name : $scope.module_ ? $scope.module_.name : $scope.course_.name,
                                        num_items: 1,
                                    });
                                }catch(err){
                                    console.log('err in datalayer, ', err)
                                }
                                
                            } else if(res && res.data && res.data.status === 'failed') {
                                sendDataToMobile({
                                    errorCode: '199',
                                    errorMessage: 'Sorry! Your transaction was not successful. Please try again later.',
                                })
                            }
                        },function errorCallback(error) {
                            console.log('error');
                            console.log(error);
                        })
                    }
                }, 4000);
            }, 30000)
        }

        var getOrderStatus = function() {
            $http({
                method: 'GET',
                url: '/api/v1/order/get-order-status',
                params: {
                    refNo: $scope.orderRefNo
                }
            })
            .then(function(res) {
                if(res && res.data && res.data.success) {
                    console.log('close-in-app-browser');
                    $scope.$emit("checkPendingOrdersCount");
                    $scope.paymentType = 'payment-success';
                    ttq.track('Purchase')
                    $scope.newOrder = res.data.order;
                    sendDataToMobile();
                    try{
                        TrackingService.purchaseEvent({
                            order_id: $scope.newOrder.ref_no,
                            price: $scope.tprice,
                            item_id: $scope.bundle_ ? $scope.bundle_.id : $scope.module_ ? $scope.module_.id : $scope.course_.id,
                            item_name: $scope.bundle_ ? $scope.bundle_.name : $scope.module_ ? $scope.module_.name : $scope.course_.name,
                            discount: 0,
                            productType: $scope.bundle_ ? 'bundle': $scope.module_ ? 'module' : 'course',
                            paymentMethod: $scope.newOrder.order_by,
                            institute: $scope.course_.institution || 'Default',
                            orderType: 'Self-Order',
                        });
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            'event': 'order-paid-page',
                            'ecommerce': {
                            'currencyCode': 'PKR',                       // Local currency is optional.
                            'click': {
                                'id': $scope.newOrder.ref_no,
                                'paymentMethod': $scope.newOrder.order_by,
                                'price': $scope.tprice,
                                'productType': $scope.bundle_ ? 'bundle': $scope.module_ ? 'module' : 'course',
                                'name': $scope.bundle_ ? $scope.bundle_.name : $scope.module_ ? $scope.module_.name : $scope.course_.name,
                                'orderType': 'Self-Order',
                                'instName': $scope.course_.institution || 'Default',
                                'brand': 'Nearpeer',
                            }
                            }
                        })
                        fbq('track', 'Purchase', {
                            content_ids: $scope.newOrder.ref_no,
                            content_type: $scope.bundle_ ? 'bundle': $scope.module_ ? 'module' : 'course',
                            value: $scope.tprice,
                            currency: 'pkr',
                            content_name: $scope.bundle_ ? $scope.bundle_.name : $scope.module_ ? $scope.module_.name : $scope.course_.name,
                            num_items: 1,
                        });
                    }catch(err){
                        console.log('error in datalayer->', err);
                    }
                   
                    clearInterval(interval);
                }
            },function errorCallback(error) {
                console.log('error');
                console.log(error);
            })
        }

        $sails.on('jazzCashEventSuccess', function (data) {
            getOrderStatus();
            console.log('close-in-app-browser');
        });

        $sails.on('jazzCashEventError', function (data) {
            console.log('jazz-cash-error');
            console.log(data);
            sendDataToMobile(data);
            console.log('close-in-app-browser');
        });

        $sails.on('qistpayEventSuccess', function (data) {
            getOrderStatus();
            console.log('close-in-app-browser');
        });

        $sails.on('paymobEventSuccess', function (data) {
            console.log('close-in-app-browser');
            getOrderStatus();
        });

        $sails.on('paymobEventFailed', function (data) {
            console.log('close-in-app-browser');
            swal({
                title: 'Payment Failed!',
                text: data.message,
                type: "info",
                confirmButtonText: "Ok"
            }); 
            getOrderStatus();
            
        });

        HttpService.getRequest('/api/v1/orders/get-complete-order-by-reference-number',some)
        .then(function (res) {
            upperNavBar(res.order.status);
            $scope.orderObject = res.order;
            $scope.user_ = res.order.user_id;
            $scope.course_ = res.order.orderItems.course_id;
            if(res.order.orderItems.bundle_id) {
                $scope.bundle_ = res.order.orderItems.bundle_id;
            }
            if(res.order.orderItems.module_id){
                $scope.module_ = res.order.orderItems.module_id;
            }
            $scope.tprice = res.order.total;
            if(res.order.status === 'paid') {
                $scope.paymentType = 'payment-success';
                ttq.track('Purchase');
                $scope.$emit("checkPendingOrdersCount");
                $scope.newOrder = res.order;
                
                

                sendDataToMobile();
            } else {
                console.log('Status Not Done')
            }
            var today = new Date();
            for(var i = 0; i < 4; i++) {
                if(i > 0) {
                    var date = new Date(today.setMonth(today.getMonth()+1));
                }
                var installment = {
                    date: date ? date : 'Today',
                    amount: res.order.total / 4,
                    isLast: i === 3 ? true : false
                }
                $scope.qistPayInstallments.push(installment);
            }
            var jazzData = res.order;
            if($scope.tprice <= 1500) {
                $scope.isInstallmentAllowed = false;
            }
            apiJazz = '/jazz/form?description=' + jazzData.type + '&billreference=' + jazzData.ref_no + '&FormattedAmount=' + (jazzData.price * 100) + '&TxnDateTime=' + jazzData.jc_txndatetime;
            setTimeout(function() {
                if(document.getElementById('mobileAccount')) {
                    document.getElementById('mobileAccount').checked = true
                }
            }, 1000)    
        });

        $scope.selectPaymentMethod = function(paymentMethod){
            if(paymentMethod === 'jazzCash') {
                setTimeout(function() {
                    document.getElementById('mobileAccount').checked = true
                }, 500)
            }
            $scope.paymentType = paymentMethod;
        }

        $scope.proceedPayment = function(){
            if(document.getElementById('mobileAccount').checked) {
                jazzCashType = 'MWALLET'
            } else if(document.getElementById('debitCard').checked) {
                jazzCashType = 'MPAY'
            } else if(document.getElementById('mobileVoucher').checked) {
                jazzCashType = 'OTC'
            }
            
            apiJazz = apiJazz + '&paymentType=' + jazzCashType
            $timeout(function(){
                if($rootScope.platform_reactApp){
                    console.log(apiJazz);

                }else{
                    window.open(apiJazz, '_blank');
                    var params = $state.params;
                    params.type = 'jazzcash';
                    $state.go('orderPaymentmethodsProceed', params, {notify: false});
                }
            },500);

            intervalToCheckStatus();
        }

        $scope.proceedPaymentQistPay = function(){
            mixpanel.track('Payment-Type-QisstPay');
            $scope.loadingPayment = true;
            HttpService.getRequest(env.backendService + '/lmsservice/v1/user/get-qistpay-url/' + $scope.orderRefNo, {})
            .then(function (res) {
                if($rootScope.platform_reactApp){
                    console.log(res.qistpayData.iframe_url);
                }else{
                    window.open(res.qistpayData.iframe_url, '_blank')
                    var params = $state.params;
                    params.type = 'qistpay';
                    $state.go('orderPaymentmethodsProceed', params, {notify: false});
                }
                $scope.loadingPayment = false;
            });

            intervalToCheckStatus();
        }

        $scope.proceedPaymentPaymob = function(type){
            mixpanel.track('Payment-Type-' + type)
            $scope.loadingPayment = true;
            var paymentType = 'CARD';
            if(type === 'EasyPaisa') {
                paymentType = 'EASYPAISA';
            } else if (type === 'JazzCash') {
                paymentType = 'JAZZCASH';
            } else if (type === 'NIFT') {
                paymentType = 'NIFT';
            } else {
                paymentType = 'CARD';
            }
            HttpService.getRequest('/api/v1/orders/get-paymob-url/' + $scope.orderRefNo + '/' + paymentType, {})
            .then(function (res) {
                if($rootScope.platform_reactApp){
                    if(paymentType === 'EASYPAISA') {
                        console.log(res.paymobData.iframe_url + '?ucheck=qisstpay.com');
                    } else {
                        console.log(res.paymobData.iframe_url + '&ucheck=qisstpay.com');
                    }
                }else{
                    window.open(res.paymobData.iframe_url, '_blank')
                }
                var params = $state.params;
                params.type = paymentType;
                $state.go('orderPaymentmethodsProceed', params, {notify: false});
                $scope.loadingPayment = false;
            });
            intervalToCheckStatus();
        }
        $scope.proceedPaymentQistPayManual = function(){
            mixpanel.track('Payment-Type-Manual');
        }
        
        $scope.uploadImage = function (image) {
            var ord_id = parseInt($scope.orderRefNo.slice(6));
            UploadService.uploadImage(image)
                .then(function (data) {
                    $scope.imageURL = data;
                    $scope.imageName = $scope.imageURL.slice(49);
                    var data = {
                        "order_id":ord_id,
                        "proof":$scope.imageURL,
                        "amount":$scope.tprice
                    }
                    $http.put('api/v1/payment/payment-proof-saving',data)
                    .then(function (data_) {
                        $scope.paymentType = "2";
                        $scope.waitingForApproval=true;
                      });
                });
        }
        
        $scope.nextButtonMethod = function () {
            var abc = document.getElementById('c-track').getElementsByClassName('active_now')[0];
            var def = document.getElementsByClassName('btn-numF')[0];
            if(abc.nextElementSibling){
                var nextSlide = abc.nextElementSibling;
                abc.classList.remove('active_now');
                def.classList.remove('btn-numF');
                document.getElementById('btn'+nextSlide.id).classList.add('btn-numF');
                nextSlide.classList.add('active_now');
                document.getElementById('c-track').style.transform = 'translateX(-' + (650 * parseInt(abc.id)) + 'px)';
            }
        };
        
        $scope.changeSelectedType = function (){
            $scope.paymentType = $scope.selectTypeDD;
        }

        $scope.closeCancel = function () {
            $scope.orderCancelPopup = false;
        }

        $scope.showCancel = function () {
            $scope.orderCancelPopup = true;
        }

        $scope.changeOrderStatus = function (status){
            
            if(status == 'cancelled'){
                $http({
                    url: '/api/v1/orders/cancel-order-status',
                    method: "GET",
                    params: { ref_no: $scope.orderRefNo, status: status }
                }).then(function (data) {
                    if (data.data.success) {
                        $scope.orderCancelPopup = false;
                        mixpanel.track('Cancel-Order', {
                            'Course_ID': $scope.course_.id,
                            'Course_Name': $scope.course_.name,
                            'Order_ID': $scope.orderObject.id,
                            'Order_Price': $scope.orderObject.price,
                        })
                        swal({
                            title: 'Order Cancelled!',
                            text: "Order Status Updated!",
                            type: 'success',
                            showConfirmButton: false,
                            timer: 2000,
                        }, function () {
                            swal.close();
                            $scope.gotoCourse();
                        });
                        
                    }
                });
                console.log('close-in-app-browser');
                console.log('close-webview');
            }
        }

        $scope.prevButtonMethod = function () {
            var abc = document.getElementById('c-track').getElementsByClassName('active_now')[0];
            var def = document.getElementsByClassName('btn-numF')[0];
            if(abc.previousElementSibling){
                var previousSlide = abc.previousElementSibling;
                abc.classList.remove('active_now');
                def.classList.remove('btn-numF');
                document.getElementById('btn'+previousSlide.id).classList.add('btn-numF');
                previousSlide.classList.add('active_now');
                document.getElementById('c-track').style.transform = 'translateX(-' + (650 * (parseInt(previousSlide.id) - 1)) + 'px)';
            }
        }

        function upperNavBar (status){
            if(status == "paid" || status == "enabled"){
                $scope.paymentType = 'payment-success'
                ttq.track('Purchase')
                $scope.$emit("checkPendingOrdersCount");
            }
        }

        $scope.gotoCourse = function() {
            console.log('course-purchased-successfully');
            if($scope.orderObject.orderItems.bundle_id) {
                courseDetailService.goToBundle($scope.orderObject.orderItems.bundle_id.name);
            } else {
                courseDetailService.goToCourse($scope.course_);
            }
        }

        $scope.gotoLiveSession = function() {
            console.log('live-session-purchased-successfully-'+$rootScope.liveSessionId);
            var url = env.velocityPortal + '/live-session/'+ $rootScope.liveSessionId;
            window.open(url, '_self')
        }

        $scope.getScreenShot = function(){
            var c = document.getElementById('successDiv'); // or document.getElementById('canvas');
            html2canvas(c, {
                onrendered: function (canvas) {
                    var t = canvas.toDataURL().replace("data:image/png;base64,", "");
                    downloadBase64File('image/png',t,'image');
                }
            })
        }
        
        function downloadBase64File(contentType, base64Data, fileName) {
          var linkSource = 'data:' + contentType + ';base64,' + base64Data;
          var downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
    };
  
  })();
(function () {
  'use strict';
  angular
  .module('NearPeer')
  .controller('orderDetailsController',MainController);

    function MainController($scope, $rootScope, $state, $cookies, $http,$timeout, CustomStorageService, courseDetailService, env, TrackingService) {
      var sr = $scope;
      var attributes = {};
      var couponUsed;
      var counterBuy = 0;
      var countSetInterval = 0;
      var courseData = {};
      sr.orderSuccess = false;
      couponUsed = false;
      sr.loginForm = {};
      sr.registrationForm = {};
      sr.signedup = false;
      sr.emailVerification = false;
      sr.counter = 1;
      sr.counterSec = 60;
      var stopped;
      sr.isCouponApplied = false;
      sr.couponMsg = "";
      sr.couponValue = ""
      sr.userBalance = 0;
      sr.couponBalance = 0;
      sr.showData = false;
      sr.loadingPayment = false;
      attributes = {
        user_balance: 0,
        coupon_balance: 0,
        coupon_id: null,
        items: [],
        discount_price: 0,
        price: null,
        total: null,
        user_id: null,
        type: null,
        socket_id: CustomStorageService.getSocketIdStorageData(),
        origin: window.location.origin
      };
      var userData = {}
      $scope.showPlaceOrder = false;
      $scope.couponId = $state.params.couponId;
      if(CustomStorageService.getUserSignedInStorageData()){
        sr.isUserLoggedIn = true;
        attributes.user_id = CustomStorageService.getUserInfoStorageData().id;
        userData = CustomStorageService.getUserInfoStorageData();
      }else{
        sr.isUserLoggedIn = false;
      }
      checkPurchaseStatus();
      if($state.params.ifModule == 0) {
        $http({
          url: 'api/v1/courses/getCourseById',
          method: "GET",
          params: { id: $state.params.course_id, instructor_id: $state.params.instructorId, from: 'order' }
        }).then(function (data) {
          sr.course = data.data.course;

          if (sr.course.course_id) {
            attributes.items.push({
              course_id: sr.course.course_id,
              module_id: sr.course.id,
              bundle_id: null
            });
            if (sr.course.module_type.discount > 0) {
              attributes.discount_price = sr.course.module_type.discount;
              sr.total = sr.course.module_type.discount;
              sr.coursePrice = sr.course.module_type.discount;
            } else {
              sr.total = sr.course.module_type.price;
              sr.coursePrice = sr.course.module_type.price;
            }
            attributes.price = sr.course.module_type.price;
            attributes.type = "module";
          } else if (sr.course.bundle) {
              attributes.items = sr.course.courses;
              if (sr.course.discount_price) {
                attributes.discount_price = sr.course.discount_price;
                sr.total = sr.course.discount_price;
                sr.coursePrice = sr.course.discount_price;
              } else {
                sr.total = sr.course.price;
                sr.coursePrice = sr.course.price;
              }
              attributes.price = sr.course.price;
              attributes.type = "bundle";
            } else {
    
              attributes.items.push({
                course_id: sr.course.id,
                module_id: null,
                bundle_id: null
              });
              if (sr.course.discount_price > 0) {
                attributes.discount_price = sr.course.discount_price;
                sr.total = sr.course.discount_price;
                sr.coursePrice = sr.course.discount_price;
              } else {
                sr.total = sr.course.price;
                sr.coursePrice = sr.course.price;
              }
              attributes.price = sr.course.price;
              attributes.type = "course";
            }
            sr.couponToggle = false;
            TrackingService.addToCartEvent({
              price: sr.total,
              item_id: sr.course.id,
              item_name: sr.course.name,
              discount: sr.course.price - sr.total,
              institute: sr.course.institution,
              productType: 'course',
            })
            if($state.params.couponId) {
              sr.couponApplied();
            } else {
              $scope.showPlaceOrder = true;
            }
            
        }, function errorCallback(error) {
        });
      }else if($state.params.ifModule == 1){ //for module
        $http({
          url: 'api/v1/cmodules/getModuleById',
          method: "GET",
          params: { id: $state.params.module_id, instructor_id: $state.params.instructorId }
        }).then(function (data) {
          sr.course = data.data.module;
          $http({
            url: 'api/v1/courses/getCourseById',
            method: "GET",
            params: { id: sr.course.course_id, instructor_id: $state.params.instructorId, from: 'order' }
          }).then(function (course) {
            courseData = course.data.course
            courseData.module_no = sr.course.module_no;
            courseData.course_name = courseData.name;
            courseData.institution_name = courseData.institution;
            courseData.faculty_name = courseData.faculty;
            courseData.course_index_url = courseData.index_url;
          })
          attributes.items.push({
            course_id: sr.course.course_id,
            module_id: sr.course.id,
            bundle_id: null
          });
          if (sr.course.module_type.discount > 0) {
            attributes.discount_price = sr.course.module_type.discount;
            sr.total = sr.course.module_type.discount;
            sr.coursePrice = sr.course.module_type.discount;
          } else {
            sr.total = sr.course.module_type.price;
            sr.coursePrice = sr.course.module_type.price;
          }
          TrackingService.addToCartEvent({
            price: sr.total,
            item_id: sr.course.id,
            item_name: sr.course.name,
            discount: sr.course.discount_price ? sr.course.price - sr.course.discount_price : 0,
            institute: sr.course.institution,
            productType: 'module',
          })
          attributes.price = sr.course.module_type.price;
          attributes.type = "module";
          sr.couponToggle = false;
          if($state.params.couponId) {
            sr.couponApplied();
          } else {
            $scope.showPlaceOrder = true;
          }
          
        }, function errorCallback(error) {
        });
      } else if($state.params.ifModule == 2) { //for bundle
        $http.post('api/v1/bundle/mdcat',{name: $state.params.instructorId})
        .then(function(data){
          if(data.data.succes){
            var bundleData = data.data.bundle;
            sr.course = bundleData;
            attributes.items = bundleData.courses;
            if (bundleData.discount_price && bundleData.discount_price > 0) {
              attributes.discount_price = bundleData.discount_price;
              sr.total = bundleData.discount_price;
              sr.coursePrice = bundleData.discount_price;
            } else {
              sr.total = bundleData.price;
              sr.coursePrice = bundleData.price;
            }
            attributes.price = bundleData.price;
            attributes.type = "bundle";
            if($state.params.couponId) {
              sr.couponApplied();
            } else {
              $scope.showPlaceOrder = true;
            }
            TrackingService.addToCartEvent({
              price: sr.total,
              item_id: bundleData.id,
              item_name: bundleData.name,
              discount: bundleData.price - sr.total,
              institute: 'Default',
              productType: 'bundle',
            })
          } else {
            return false;
          }
        },function errorCallback(error) {});
      }

      function checkPurchaseStatus(contentType, base64Data, fileName) {
        $http({
          url: 'api/v1/course/check-status',
          method: "GET",
          params: { course_id: $state.params.course_id, module_id: $state.params.module_id }
        }).then(function (data) {
          if(data.data.success) {
            window.history.back();
          } else {
            sr.showData = true;
          }
        }, function errorCallback(error) {
        });
      }

      sr.goBack = function (){
        $state.go('landing');
      }

      sr.signInAndPlaceOrder = function(loginForm) {
        if(!loginForm.email || !loginForm.password){
          swal({
            title: 'Incomplete Data',
            text: 'Please fill in all fields',
            type: 'error'
          },function(confirm){
            // if (!sr.$$phase) sr.$apply();
          })
          return;
        }
        $http.post('/api/v1/auth/signin',loginForm)
        .then(function(resp) {
          if (resp.data.user.user_type === 'student' && resp.data.user.disabled === false) {
            sr.text = "Logged in as " + resp.data.user.full_name;
            CustomStorageService.SignInService(false,true,false,false,resp.data.token,resp.data.user);
            swal({
              title: "Log In Successful!",
              text: sr.text,
              type: "success",
              timer: 2000,
              showConfirmButton: false
            },function(){
              swal.close();
              sr.$emit('userLoggedIn');
            });
          }   else if(resp.data.user.user_type === 'student' && resp.data.user.disabled === true){
            swal({
              title: "Error",
              text: 'Account is temporarily disabled',
              type: "error"
            });
          }   else {
            swal({
              title: "Error",
              text: 'Not Authorized',
              type: "error"
            },function(){
            });
          }
        }, function errorCallback(response) {
          if(response.data.code == 'E_USER_NOT_CONFIRMED'){
            swal({
              title: 'Unconfirmed Account',
              text: response.data.message,
              type: 'info',
              confirmButtonText: "Resend Mail",
              showCancelButton: true
            },function(confirm){
              if(confirm){
                var data = {email: sr.userEmail}
                $http.post('api/v1/users/requestConfirmationMail',data)
                .then(function(data){
                  if(data.data.success){
                    swal({
                      title: 'Confirmation instruction sent',
                      text: 'Please activate your account by clicking on the link sent to your provided email address',
                      type: 'info'
                    })
                  }
                })
              }
            })
  
          } else{
            swal({
              title: 'Error',
              text: response.data.message,
              type: 'error'
            })
          }
        });
      };

      sr.submitRegistration = function(registrationForm) {
        registrationForm.user_type = "student";
        if(!registrationForm.full_name || !registrationForm.email || !registrationForm.phone || !registrationForm.password || !registrationForm.confirmPassword || !registrationForm){
          swal({
            title: "Error!",
            text: "Please enter complete information",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        if(!registrationForm.email.includes('@')){
          swal({
            title: "Error",
            text: "Please enter valid email address",
            type: "error"
          })
          return;
        }
        if(registrationForm.phone.length < 11){
          swal({
            title: "Error",
            text: "Please enter complete contact no",
            type: "error"
          })
          return;
        }
        if(registrationForm.password.length<8){
          swal({
            title: "Error!",
            text: "Password is short!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        if (registrationForm.password != registrationForm.confirmPassword) {
          swal({
            title: "Error!",
            text: "Passwords don't match!",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        if (!registrationForm.image) {
          registrationForm.image = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/default_user.png';
        }
        registrationForm.origin_url = location.protocol+'//'+location.host;
        $http.post('/api/v1/auth/signup',registrationForm)
        .then(function(resp) {
          if(resp.data.error){
            swal({
              title:  "Error",
              text: resp.data.msg,
              type: "error"
            })
          } else {
            swal({
              title: "Account Created Successfully",
              text: "Please activate your account by clicking on the link sent to your provided email address.",
              type: "success",
              timer: 5000
            },function(){
              swal.close();
              sr.signedup = true;
              sr.emailVerification = true;
              sr.verifingEmail();
            });
          }
        })
      };
      $scope.coupon;
      sr.couponApplied = function () {
        $http({
          url: 'api/v1/coupons/getCouponByID',
          method: "POST",
          params: { id: $state.params.couponId, user_id: attributes.user_id, course_id: $state.params.course_id, module_id: $state.params.module_id}
        }).then(function (coupon) {
          $scope.showPlaceOrder = true;
          if (coupon.data.success) {
            $scope.coupon = coupon.data.coupon;
            console.log("🚀 ~ file: orderDetails.js:354 ~ MainController ~ $scope.coupon:", $scope.coupon)
            attributes.coupon_id = coupon.data.coupon.id;
            if (coupon.data.coupon.price >= sr.total) {
              attributes.coupon_balance = sr.total;
              $scope.couponBalance = sr.total;
              $scope.couponAmount = sr.total;
              sr.isCouponApplied = true;
              sr.total = 0;
            } else if (coupon.data.coupon.price < sr.total) {
              var amount = sr.total - coupon.data.coupon.price        
              attributes.coupon_balance = coupon.data.coupon.price;
              $scope.couponBalance = coupon.data.coupon.price;
              $scope.couponAmount = coupon.data.coupon.price;
              sr.isCouponApplied = true;
              sr.total = amount;
            }
          } else {
            couponUsed = false;
            sr.couponMsg = coupon.data.message;
          }
        }, function errorCallback(response) {
          sr.couponMsg = "Try again later";
        });
              
      }
     
      sr.placeOrder = function (){
          mixpanel.track('Place-Order', {
            "Course_ID": sr.course.id,
            "Course_Name": sr.course.name,
            "Course_Coupen": sr.isCouponApplied == true ? 'Coupon Applied!' : null,
            "Course_Coupen_ID": sr.isCouponApplied == true ? $scope.coupon.coupon_id : null,
          })
        if (counterBuy === 0) {
          counterBuy = 1;
          attributes.user_balance = sr.userBalance;
          attributes.total = sr.total;
          attributes.coupon_balance = sr.couponBalance;
          attributes.from = 'checkout'
  
          setTimeout(function () {
            sr.salePopupDiv = false;
          }, 500);
          fbq('track', 'InitiateCheckout', {
            content_ids: attributes.type.charAt(0).toUpperCase() + sr.course.id,
            content_type: attributes.type,
            value: attributes.discount_price || attributes.price,
            currency: 'PKR',
            content_name: sr.course.name,
          });
          sr.loadingPayment = true;
          $http.post('api/v1/orders/createOrder', attributes)
            .then(function (order) {
              sr.loadingPayment = false;
              var order_ref_no = 0;
              if(order.data && order.data.order && order.data.order.jazzData)
              {
                order_ref_no = order.data.order.jazzData.billreference;
              }
              counterBuy = 0;
              sr.orderSuccess = true;
              try{
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                  'event': 'order-placed-page',
                  'ecommerce': {
                    'currencyCode': 'PKR',                       // Local currency is optional.
                    'click': {
                      'id': sr.course.id,
                      'productType': attributes.type,
                      'price': attributes.discount_price || attributes.price,
                      'name': attributes.type == 'module' ? 'module ' + sr.course.name + ' of course ' + sr.course.course_id : sr.course.name,
                      'instName': sr.course.institution,
                      'brand': 'Nearpeer',
                    }
                  
                  }
                })
              }catch(err){
                console.log('error in data layer -> ', err);
              }
              $scope.$emit("checkPendingOrdersCount");
              setTimeout(function() {
                if(order.data.order.status == 'paid') {
                  try{
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'coupon-paid-page',
                        'ecommerce': {
                        'currencyCode': 'PKR',                       // Local currency is optional.
                        'click': {
                            'id': order.data.order.order_id,
                            'paymentMethod': 'coupon',
                            'price': attributes.discount_price || attributes.price,
                            'productType': attributes.type == 'module' ? 'module' : 'course',
                            'name': attributes.type == 'module' ? 'module ' + sr.course.name + ' of course ' + sr.course.course_id : sr.course.name,
                            'brand': 'Nearpeer',
                            'orderType': 'Coupon-Order',
                            'instName': sr.course.institution || 'Default'
                          }
                        }
                    })
                    TrackingService.purchaseEvent({
                      order_id: order.data.order.order_id,
                      price: sr.total,
                      item_id: sr.course.id,
                      item_name:  sr.course.name,
                      discount: attributes.discount_price || attributes.price,
                      productType: attributes.type == 'module' ? 'module' : 'course',
                      paymentMethod: 'Coupon',
                      institute: sr.course.institution || 'Default',
                      orderType: 'Coupon-Order',
                    });
                    fbq('track', 'CouponPurchase', {
                      content_ids: order.data.order.order_id,
                      content_type: attributes.type == 'module' ? 'module' : 'course',
                      value: 0,
                      currency: 'pkr',
                      content_name: attributes.type == 'module' ? 'module ' + sr.course.name + ' of course ' + sr.course.course_id : sr.course.name,
                      num_items: 1,
                    });
                  }catch(err){
                  }
                  try {
                    console.log('course-purchased-successfully-1')
                    var data = {
                      ref_no: order.data.order.ref,
                      email: userData.email ? userData.email : userData.fb_email ? userData.fb_email : userData.apple_email ? userData.apple_email : 'Social Login',
                      price: sr.total,
                      paymentType: 'Coupon',
                      course: sr.course ? sr.course.name : null,
                      courseData: sr.course ? {name: sr.course.name, id: sr.course.id, index_url: sr.course.index_url} : {},
                    }
                    console.log('order-payment-data-success|' + JSON.stringify(data));
                  } catch (error) {
                    console.log('log error')
                    console.log(error)
                  }

                  console.log('course-purchased-successfully')
                  
                  if($rootScope.liveSessionId) {
                    var url = env.velocityPortal + '/live-session/'+ $rootScope.liveSessionId;
                    window.open(url, '_self')
                  } else {
                    if($state.params.ifModule == 1) {
                      courseDetailService.goToModule(courseData);
                    } else if ($state.params.ifModule == 2) {
                      courseDetailService.goToBundle($state.params.instructorId);
                    } else {
                      courseDetailService.goToCourse(sr.course);
                    }
                  }
                } else {
                  TrackingService.beginCheckoutEvent({
                    price: sr.total,
                    item_id: sr.course.id,
                    item_name: sr.course.name,
                    discount: sr.course.price - sr.total,
                    institute: 'Default',
                    productType: attributes.type == 'module' ? 'module' : 'course',
                  });

                  $state.go('orderPaymentmethods', {orderRefNo:order_ref_no, isQistpay: $state.params.isQistpay});
                }
              }, 3000)
              
            }, function errorCallback(error) {
              sr.loadingPayment = false;
            });
        }
      }

      sr.$on('userLoggedIn', function (event, message) {
        location.reload();
      });

      sr.forgotPassword = function(){
        sr.$emit('closeForm');
        $state.go('forgot-password');
      }

      sr.verifingEmail = function(){
        // countSetInterval
        sr.countdown();
        var myVar = setInterval(function(){ 
          var someObject = {
            "email": sr.registrationForm.email
          }
          $http.post('/api/v1/auth/verify-email',someObject)
          .then(function(resp){
            clearInterval(myVar);
              var loginF = {
                'email':sr.registrationForm.email,
                'password':sr.registrationForm.password
              }
              sr.signInAndPlaceOrder(loginF);
          }, function errorCallback(response) {
            if(!response.success){
              if(countSetInterval < 24 ){
                countSetInterval++;
              }else{
                clearInterval(myVar);
                sr.stop();
                $state.go('Landing');
              }
            }
          });
        }, 5000);
      }

      sr.countdown = function() {
        stopped = $timeout(function() {
         if(sr.counter == 1 && sr.counterSec == 1){
          sr.counter--;
          sr.counterSec = 59
         }else if(sr.counter == 0 && sr.counterSec == 0){
         }else{
          sr.counterSec--; 
         }
         sr.countdown();   
        }, 1000);
      };
      sr.stop = function(){
        $timeout.cancel(stopped);
         }
    }
})();


(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('TagController', ['$scope', '$state','$http','$rootScope', function($scope, $state,$http,$rootScope) {

    $scope.submit = function(form){
      $http.post('api/v1/metatags/insert-tag',form)
      .then(function(data){
        if(data.data.success){
          alert('SuccessFullyy Added');
        }
      })
    }

  }]);

})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('StudentAccountController', ['$scope', '$rootScope', '$location', '$state', 'CustomStorageService', '$http','courseDetailService', 'requestService','HttpService', 'env', function($scope,$rootScope, $location, $state, CustomStorageService, $http, courseDetailService, requestService,HttpService, env) {
    $scope.showData = false; 
    $scope.stateName = $state.current.name;
    $scope.reqCount = 0;
    $scope.reqCount2 = 0;
    $scope.reqCount3 = 0;
    $scope.value = 1;
    $scope.showRequestVideo = false;
    $scope.switchToggle = true;
    $scope.userId = CustomStorageService.getUserInfoStorageData().id;
    $scope.lmsPopup = false;
    $scope.videoUrl = '';
    $scope.lmsPopupCount = 0;

    $scope.searchParams = {
      type: 'user',
      page: 1,
      per_page: 10,
      userId: CustomStorageService.getUserInfoStorageData().id
    };
    $(document).ready(function(){
      $(this).scrollTop(0);
    });

    var isOrder = $location.search().order;
    
    $scope.initialize = function() {
      var userId = CustomStorageService.getUserInfoStorageData().id;
      $http({
        url: 'api/v1/users/getUserData',
        method: "GET",
      }).then(function(data){
        $scope.userData = data.data;
        $scope.showRequestVideo = data.data.allowRequest;
        $scope.switchToggle = $scope.showRequestVideo ? false : true;
        $scope.showData = true;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      });

      $http({
        url: 'api/v1/users/getAvgRating',
        method: "GET",
        params: {id: userId}
      }).then(function(data) {
        $scope.reqCount++;
        $scope.avg_rating = data.data.rating;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      });

      var data = {user_id: CustomStorageService.getUserInfoStorageData().id};

      $http({
        url: 'api/v1/users/getEnrolledCourses',
        method: "GET",
        params: data
      }).then(function(data){
        $scope.entolledCourse = data.data.courses;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      })

      $http({
        url: 'api/v1/users/moduleTransaction',
        method: "GET",
        params: data
      }).then(function(data) {
        
        $scope.transactions = data.data.transactions;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      });

      // $http({
      //   url: 'api/v1/users/courseTransactions',
      //   method: "GET",
      //   params: data
      // }).then(function(data) {
      //   $scope.courseTrns = data.data.transactions;
      // }, function errorCallback(response) {
      //   requestService.responseHandler(response.status);
      // });

      // $http({
      //   url: 'api/v1/users/showCreditTransactions',
      //   method: "GET",
      //   params: data
      // }).then(function(data) {
      //   $scope.credits = data.data.credit;
      // }, function errorCallback(response) {
      //
      // });

      $http({
        url: 'api/v1/users/userViewedVideos',
        method: "GET",
        params: data
      }).then(function(data) {
        $scope.videos = data.data.video;
        $scope.totalViewedVideos = $scope.videos.length;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      });

      $http({
        url: 'api/v1/users/getResults',
        method: "GET",
        params: data
      }).then(function(data){
        $scope.quizzes = data.data.result;
      }, function errorCallback(response) {
        requestService.responseHandler(response.status);
      })
      getUserOrders($scope.searchParams);
      $http({
        url: 'api/v1/user/get-user-lms-popup-count',
        method: "GET",
        params: {
         count: 0
        }
      }).then(function(data){
        if(data.data.success){
          $scope.lmsPopupCount = Number(data.data.data.lms_popup_count) ? data.data.data.lms_popup_count : 0;
        }
      })

    };

    var getUserOrders = function(query) {
      HttpService.postRequest('api/v1/orders/get',query)
      .then(function(res){
        $scope.totalPages = res.pages;
				$scope.totalCount = res.orderCount;
        $scope.userOrders = res.orders;
        for(var i = 0; i < $scope.userOrders.length; i++){
          if($scope.userOrders[i].status == 'failed'){$scope.userOrders[i].status_ = 'Order Failed';$scope.userOrders[i].BGColor = '#1CC7BE';}
          else if($scope.userOrders[i].status == 'paid'){$scope.userOrders[i].status_ = 'Order Completed';$scope.userOrders[i].BGColor = '#1DBF73';}
          else if($scope.userOrders[i].status == 'pending'){$scope.userOrders[i].status_ = 'Verifying Payment';$scope.userOrders[i].BGColor = '#38ACD6';}
          else if($scope.userOrders[i].status == 'placed'){$scope.userOrders[i].status_ = 'Awaiting Payment';$scope.userOrders[i].BGColor = '#1CC7BE';}
          else if($scope.userOrders[i].status == 'outdated'){$scope.userOrders[i].status_ = 'Order Outdated Payment';$scope.userOrders[i].BGColor = '#FFCD40';}
          else if($scope.userOrders[i].status == 'enabled'){$scope.userOrders[i].status_ = 'Order Completed';$scope.userOrders[i].BGColor = '#1DBF73';}
          else if($scope.userOrders[i].status == 'disabled'){$scope.userOrders[i].status_ = 'Proof Unverified';$scope.userOrders[i].BGColor = '#FF3C3C';}
          else if($scope.userOrders[i].status == 'closed'){$scope.userOrders[i].status_ = 'Order Closed';$scope.userOrders[i].BGColor = '#FF3C3C';}
          else if($scope.userOrders[i].status == 'canceled'){$scope.userOrders[i].status_ = 'Order Canceled';$scope.userOrders[i].BGColor = '#FF3C3C';}
          else if($scope.userOrders[i].status == 'expired'){$scope.userOrders[i].status_ = 'Order Expired';$scope.userOrders[i].BGColor = '#FF3C3C';}
          else if($scope.userOrders[i].status == 'waitingForApproval'){$scope.userOrders[i].status_ = 'Waiting for approval';$scope.userOrders[i].BGColor = '#38ACD6';}
          else if($scope.userOrders[i].status == 'uploadedFromWhatsApp'){$scope.userOrders[i].status_ = 'Shared at WhatsApp';$scope.userOrders[i].BGColor = '#38ACD6';}
          else if($scope.userOrders[i].status == 'proofRejected'){$scope.userOrders[i].status_ = 'Proof Rejected';$scope.userOrders[i].BGColor = '#FF3C3C';}
        
        }
      });
    }
    $scope.pagination = function (page) {
      if (page > 0 && page <= $scope.totalPages) {
        $scope.searchParams.page = page;
        getUserOrders($scope.searchParams);
      }
    }
    if (!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()) {
      swal({
        title: "Unauthorized",
        text: "Please sign in to view your account",
        type: "error"
      }, function (){
        $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
        $scope.$emit('showLoginPopup');
      });
    } else{
      $scope.initialize();
    }

    $scope.tryLogin = function (page) {
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }

    $scope.addCredit = function() {
      $http.post('api/v1/coupons/redeemCoupon', {coupon_id: $scope.coupon_id,
        user_id: parseInt(CustomStorageService.getUserInfoStorageData().id), purchase_type: 'Account Credit'})
        .then(function (data) {
          if (data.data.error) {
            swal({
              title: "Transaction Unsuccessful!",
              text: data.data.message,
              type: "error",
              confirmButtonText: "Ok"
            }, function() {
              $scope.coupon_id = '';
            });
          }else{
            swal({
              title: "Transaction Successful!",
              text: "Your account has been credited with amount: "+data.data.amount,
              type: "success",
              timer: 2000,
              showConfirmButton: false
            }, function() {
              location.reload();
            });
          }
        });
      };

      $scope.requestVideoOnWeb = function() {
        $http.post('/api/v1/user/req-video-on-web', {})
          .then(function (data) {
            if (data.data.success) {
              $scope.showRequestVideo = false;
              swal({
                title: "Successful!",
                text: data.data.message,
                type: "success",
                confirmButtonText: "Ok"
              }, function() {
              });
            }else{
              $scope.switchToggle = false;
              swal({
                title: "Error!",
                text: data.data.message,
                type: "error",
                confirmButtonText: "Ok"
              }, function() {
              });
            }
          });
        };

      $scope.goToModule = function(data) {
        courseDetailService.goToModule(data);
      }

      $scope.showVideo = function(video){
        var user = CustomStorageService.getUserInfoStorageData();
        var token = CustomStorageService.getAuthTokenStorageData();
        var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl=course/' + video.module_index_url + '/' + video.module_id + '/' + video.video_id +'?courseIndexUrl=' + video.index_url;
        $scope.videoUrl = url;
        if($scope.lmsPopupCount >= 3 || $rootScope.platform_reactApp){
          $scope.goToVelocity()
        }else{
          $http({
            url: 'api/v1/user/update-user-lms-popup-count',
            method: "POST",
          }).then(function(data){})
          $scope.lmsPopup = true;
          $scope.lmsPopupCount += 1
        }
        // courseDetailService.goToVideo(video);
      }
      $scope.goToVelocity = function(){
        window.open($scope.videoUrl, '_self')
      }
      $scope.closeLms = function(){
        $scope.lmsPopup = false;
        $scope.videoUrl = '';
      }
      $scope.goToCourse = function(course){
        courseDetailService.goToCourse(course);
      };

      $scope.setVal = function(id){
        $scope.value = id;
      };

      $scope.goToCourseResultPage = function(course){
        $state.go('courseResult',{id:course.course_id},{reload:true});
      }

      $scope.viewQuiz = function(resultId){
        $state.go('result',{resultId:resultId},{reload:true})
      }
      if(isOrder) {
        $scope.setVal(4);
      }
      $scope.inquireStatus = function(order, ref_no,status){
        if(status != 'canceled' && status != 'closed' && status != 'disabled'){
          if(status === 'placed') {
            $state.go('orderPaymentmethods', {orderRefNo:ref_no});
          } else if(status === 'paid' || status === 'enabled') {
            if(order.module_no) {
              courseDetailService.goToModule(order);
            } else {
              var data = {
                index_url: order.course_index_url,
              }
              courseDetailService.goToCourse(data);
            }
          }
        }
      }
    }]);

  })();

(function() {
    'use strict';

    angular
        .module('NearPeer')
        .service('requestService', ['$rootScope','$http', '$state', 'CustomStorageService', function($rootScope,$http, $state, CustomStorageService) {

          var responseHandler = function(response,type_of_user){
            if(type_of_user == undefined){
              return;
            }
            if (response == 401){
              CustomStorageService.setFcmToken('');
              $http.post('/api/v1/auth/logout',{
                session: CustomStorageService.getAuthTokenStorageData()
              })
              .then(function(resp) {
              },function errorCallback(response) {
              })
            if(type_of_user == 'student'){
              CustomStorageService.logOutService('all');
            }
            if(type_of_user == 'admin'){
              CustomStorageService.logOutService('admin_logout');
            }
            if(type_of_user == 'instructor'){
              CustomStorageService.logOutService('instructor_logout');
            }
              CustomStorageService.logOutService(type_of_user);
              $state.go('Landing',{},{reload:true});
              if ($rootScope.platform_desktop) {
                console.log("loggedOut");
              }
              if ($rootScope.platform_reactApp) {
                console.log("loggedOut");
              }
              swal({
                title: "You've been logged out, Please login to continue",
                type: "success",
                confirmButtonText: "Ok",
                timer: 2000,
                showConfirmButton: false
              });
            }
          }

          return {
            responseHandler:responseHandler
          }
        }]);
})();

(function () {
    "use strict";
    angular.module("NearPeer").controller("storeelController", MainController);
    function MainController(
    $scope,
    $rootScope,
    $http,
    $state,
    $location,
    CustomStorageService,
    UploadService,
    $cookies,
    toaster,
    $interval
    ) 
    {

        $scope.storyPause = true;
        $scope.fcLinkCopy = false;
        $scope.storyPlay = false;
        $scope.showPopup = false;
        $scope.pitbSelected = false;
        $scope.fbSelected = false;
        $scope.loggedIn = false;
        $scope.storyPopup = false;
        $scope.storyShare = false;
        $scope.storyCommentReply = false;
        $scope.storyCommentWriteReply = false;
        $scope.storyComment = false;
        $scope.videoMute = false;
        $scope.beforeReplyType = true;
        $scope.afterReplyType = false;
        $scope.beforeType=true;
        $scope.afterType = false;
        $scope.uploadingLoader=false;
        $scope.userImage=undefined;
        $scope.rep=[];
        $scope.defaultInterval=5000;
        $scope.remainingInterval=0;
        $scope.videoInterval=0;
        $scope.videoRemainingInterval=0;
        $scope.determinateValue=0;
        $scope.commentLoadable=true;
        $scope.commentLoader=false;
        $scope.replyLoader=false;
        $scope.numLimit = 50;
        $scope.longDescLimit = 100;
        $scope.comment_offset=0;
        $scope.commentedPaginationLoader=false;
        $scope.videoLoader=false;
        $scope.readMoreBtn = "Read more";
        $scope.readMoreBtnLong = "Read more";
        $scope.activeVideo=null;
        $scope.videoIsBuffering=false;
        
        
        $scope.page = 0;
        if (
        CustomStorageService.getUserSignedInStorageData()
        ) {
        $scope.loggedIn = true;
        }
        
        $scope.uploadImageMain = function (image) {


            $scope.beforeType = true;
            $scope.afterType = false;
           

        
      if(($scope.im.type.includes('image') && $scope.im.size/1000000>1))
      {
        swal({
          title: "Error!",
          text: "Image size cannot be greater than 1 mb.",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      
      else if(($scope.im.type.includes('video')))
      {
        swal({
          title: "Error!",
          text: "Uploading videos is not allowed!",
          type: "error",
          confirmButtonText: "Ok"
        });
      }
      else
      {
        $scope.uploadingLoader=true;
        UploadService.uploadStoryImage(image.file)
              .then(function (data) {
                $scope.comment_image_url = data.link;
                $scope.comment_thumbnail_link=data.thumbnail_link;
                $scope.beforeType = false;
                $scope.afterType = true;
                $scope.uploadingLoader=false;
                
              });
      }
            
      
          }

        
        
          $scope.delImage = function () {
            $scope.image_url = null;
          }

          $scope.videoMuteBtn = function () {
            if($scope.videoMute==false)
            {
             $scope.videoMute=true;
             var video = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
             video.muted=true;
            }
            else{

             $scope.videoMute=false;
             var video = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
             video.muted=false;
                
            }
          }
        
        
        $scope.storyShareOpen = function (id) {
        $scope.stopBtn();
        $scope.storyShare = true;
        $scope.share_media_storyid = id;
        };
        $scope.storyShareClose = function () {
        $scope.playBtn();     
        $scope.storyShare = false;
        };
        $scope.mediaCopy = function () {
        $scope.fcLinkCopy = true;
        setTimeout(function () {
            $scope.fcLinkCopy = false;
            $scope.$apply();
        }, 1000)
       
            
        var str = $scope.dynamic_url + '/storeel/reel/' + $scope.stories[$scope.activeStory].slides[$scope.activeSlide].link_id;
        navigator.clipboard.writeText(str);
        };
        $scope.whatsAppShare = function () {
        console.log($scope.share_media_storyid)
        var str = $scope.dynamic_url + '/storeel/reel/' + $scope.stories[$scope.activeStory].slides[$scope.activeSlide].link_id;

        $scope.shareWhatsApp(str);
        };



        $scope.shareOnFacebook = function () {

        // if($rootScope.platform_reactApp){
        var str = $scope.dynamic_url + '/storeel/reel/' + $scope.stories[$scope.activeStory].slides[$scope.activeSlide].link_id;
        var e = encodeURIComponent(str)
        window.open(
            "https://www.facebook.com/sharer/sharer.php?u=" + e,
            "_blank",
            "width=500,height=500"
        );
        }


        $scope.shareOnlinkedin = function () {
        var str = $scope.dynamic_url + '/storeel/reel/' + $scope.stories[$scope.activeStory].slides[$scope.activeSlide].link_id
        var e = encodeURIComponent(str)
        window.open(
            "http://www.linkedin.com/shareArticle?url=" + e,
            "sharer",
            "_blank",
            "toolbar=0, status=0, width=626, height=436"
        );
        };



        $scope.shareOnTwitter = function () {
        var str = $scope.dynamic_url + '/storeel/reel/' + $scope.stories[$scope.activeStory].slides[$scope.activeSlide].link_id
        window.open(
            "http://twitter.com/share?url=" +
            encodeURIComponent(str),
            "_blank",
            "left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
        );
        }

        $scope.shareWhatsApp = function (url) {
        
        var message = encodeURIComponent(url);
       

        var agent = navigator.userAgent;

        var iphone = !!~agent.indexOf("iPhone");
        var android = !!~agent.indexOf("Android");
        var palmpre = !!~agent.indexOf("webOS");
        var berry = !!~agent.indexOf("BlackBerry");
        var ipod = !!~agent.indexOf("iPod");

        if (
            (iphone ||
            android ||
            palmpre ||
            ipod ||
            berry ||
            $rootScope.platform_reactApp) == true
        ) {
            console.log('MESSAGE 1111', message)
            var href = "whatsapp://send?text=" + message;
        } else {
            console.log('MESSAGE 2222', message)

            var href = "https://web.whatsapp.com/send?text=" + message;

        }
        window.open(href, "_blank");
        }



        $scope.storyCommentClose = function () {
            console.log('popup-close');
        $scope.removeCommentImage();   
        $scope.storyComment = false;
        
        $scope.playBtn();
        
        }

        $scope.storyCommentWriteReplyToggle = function (id) {

            if($scope.com_id!==id)
            {
                $scope.storyCommentWriteReply = false;
                $scope.com_id = id;
                $scope.storyCommentWriteReply = !$scope.storyCommentWriteReply;
                $scope.storyCommentWriteReply = true;
            }
            else
            {
                $scope.com_id = id;
                $scope.storyCommentWriteReply = !$scope.storyCommentWriteReply;

            }

        };

        $scope.activeStory = 0
        $scope.activeSlide = 0;
        
        $scope.stopBtn = function () {



        $interval.cancel($scope.statusBarInterval);
        $interval.cancel($scope.slideInterval);
        $scope.storyPlay = true;
        $scope.storyPause = false;
        if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
            {
             var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
             vid.pause();
            }
        
        }
        $scope.playBtn = function () {

       
        if($scope.storyComment==true && $scope.determinateValue>98)
        {
            $scope.navigateSlideOrStory(1);
            generateView();
            $scope.getCommentsForUser($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id, $scope.stories[$scope.activeStory].slides[$scope.activeSlide]);
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                 enableVideoConfigs();
               }
               else
               {
                enableImageConfigs();
               } 
        }
        else
        {var vid;
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
            {
             vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
             vid.muted=false;
             vid.play();
            }
            if($scope.incrementedValue)
            {
            var resumeInterval=((100/$scope.incrementedValue)*100)-(($scope.determinateValue/$scope.incrementedValue)*100)
            $scope.storyPlay = false;
            $scope.storyPause = true;            
            $interval.cancel($scope.slideInterval);
            $scope.statusBar(resumeInterval,$scope.determinateValue,$scope.incrementedValue);
            $scope.slideInterval = $interval(slideIntervalFunction, resumeInterval);
            }
            else
            {
            $scope.storyPlay = false;
            $scope.storyPause = true;  
            $interval.cancel($scope.slideInterval);
            $scope.statusBar(vid.duration*1000);
            $scope.slideInterval = $interval(slideIntervalFunction,vid.duration*1000);
            }
            

        }
        }

        var openStory = function(data) {
            if(!$scope.stories || $scope.stories.length === 0 || !$scope.slideInterval) {
                setTimeout(function() {
                    openStory(data)
                }, 200)
                
            } else {
                $scope.openCurrentStory(data.id, data.index);
            }
        }
        var bridgeInterval
        if($rootScope.platform_reactApp_new) {
            bridgeInterval = setInterval(function() {
                console.log('bridge-active');
            }, 5000)
        }
       
        var mobileWebviewEventHandler = function(message) {
            clearInterval(bridgeInterval)
            if (message.data.message.includes("open-sotry")) {
                var data = message.data.message.split("|")[1];
                data = JSON.parse(data);
                openStory(data)
            } else if (message.data.message.includes("pause-sotry")) {
                $scope.stopBtn()
            }
        }

        var stopIfFromWebview = function() {
            if(!$scope.stories || $scope.stories.length === 0 || !$scope.slideInterval) {
                setTimeout(function() {
                    stopIfFromWebview()
                }, 200)
                
            } else {
                $scope.stopBtn();
                document.addEventListener("message", mobileWebviewEventHandler); ///DONOT REMOVE THIS
            }
        }
        var isWebview = $location.search().webview;
        if(isWebview) {
            stopIfFromWebview();
        }
        
        $scope.statusBar=function(intervalTime,resumeIntervalValue,resumedIncremented)
        {
            
            $scope.totalStatusBarReps=intervalTime/100;
            $scope.determinateValue=resumeIntervalValue?resumeIntervalValue:0;
            $scope.incrementedValue=resumedIncremented?resumedIncremented:100/$scope.totalStatusBarReps;
            
            $interval.cancel($scope.statusBarInterval);
            $scope.statusBarInterval=$interval(function() {
            $scope.determinateValue += $scope.incrementedValue;
                
                if($scope.determinateValue>99)
                {
                    $scope.determinateValue=100;
                    $scope.totalStatusBarReps=0;
                    
                }
               
              }, 100, $scope.totalStatusBarReps, true);
          

        }


       function slideIntervalFunction() {
      
        
            
            $interval.cancel($scope.slideInterval);
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                vid.muted=true;
                vid.pause();
                vid.currentTime=0;
                $scope.videoMute=false;
               }
            
               
    
        if($scope.storyComment==true)
        {
            $scope.storyPlay = true;
            $scope.storyPause = false;
            $interval.cancel($scope.slideInterval);
            $scope.getCommentsForUser($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id, $scope.stories[$scope.activeStory].slides[$scope.activeSlide]);
        }
        else
        {
            console.log('r14')
            $scope.navigateSlideOrStory(1);
            generateView();
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                 enableVideoConfigs();
                
               }
               else
               {
                enableImageConfigs();
                
               } 
        
        }
        }
      
       
        var generateView=function(){

            var data;
            data = localStorage.getItem("userInfo");
            var user_id = JSON.parse(data);
            var view = {
            media_id: $scope.stories[$scope.activeStory].slides[$scope.activeSlide].id,
            user_id: user_id.id,
            is_disabled: false,
            is_deleted: false
            }
            var storyMixPanel = {
                storyDetail:$scope.stories[$scope.activeStory],
                reelDetail:$scope.stories[$scope.activeStory].slides[$scope.activeSlide],
            }
            mixpanel.track('Story-Page', {
                "Story_ID": storyMixPanel.storyDetail.id,
                "Story_Name": storyMixPanel.storyDetail.title,
                "Reel_ID": storyMixPanel.reelDetail.id,
                "Reel_Name": storyMixPanel.reelDetail.title,
            })
            if(data)
            {
            $http.post('/api/v1/story/storyViews', view)
            .then(function (data) {
                console.log(data);
                $scope.swipeRight = false;
                $scope.swipeLeft = false;
            });
        }

        }


        $scope.navigateFromButtons =  function (n) {
            
                
        
            $scope.commentedPaginationLoader=false;
            $scope.videoLoader=false;
            
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {

                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                vid.muted=true;
                vid.pause();
                vid.currentTime=0;
                $scope.videoMute=false;

     
               }
            $scope.determinateValue=0;
            $scope.navigateSlideOrStory(n);


            
            
                
       
        if($scope.storyComment==true)
        {
              if($scope.stories[$scope.activeStory].comment_allowed==false)
                {
                    $scope.storyCommentClose()
                }
                else
                {
                $scope.storyPlay = true;
                $scope.storyPause = false;
                $interval.cancel($scope.slideInterval);
                $scope.getCommentsForUser($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id, $scope.stories[$scope.activeStory].slides[$scope.activeSlide]);

                }

            }
        else
        {
          
           

            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                
                enableVideoConfigs();
                generateView();
               }
               else
               {
                enableImageConfigs()
                generateView();
        
               } 
        
        }
            
        }

        $scope.swipeLeft = false
        $scope.swipeRight = false
        
         $scope.navigateFromSwipe =  function (n) {
            $scope.commentedPaginationLoader=false;
            $scope.videoLoader=false;
        
            $interval.cancel($scope.slideInterval);
            
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                vid.muted=true;
                vid.pause();
                vid.currentTime=0;
                $scope.videoMute=false;

               }
                $scope.storyPause = true;       
                $scope.storyPlay = false;
            if(n==1 && $scope.activeStory!==$scope.stories.length-1)
            {
                $scope.activeStory=$scope.activeStory+1;
                $scope.activeSlide=0
                $scope.swipeLeft = false
                 $scope.swipeRight = true
            }
            else if(n==-1 && $scope.activeStory!==0)
            {
                $scope.activeStory=$scope.activeStory-1;
                $scope.activeSlide=0;
                 $scope.swipeLeft = true;
                 $scope.swipeRight = false;
            }
            else
            {
                $scope.activeStory=$scope.activeStory;
                $scope.activeSlide=$scope.activeSlide;
                 $scope.swipeLeft = false

            }
            
             
               
       
        if($scope.storyComment==true)
        {
            $scope.storyPlay = true;
            $scope.storyPause = false;
            $interval.cancel($scope.slideInterval);
            $scope.getCommentsForUser($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id, $scope.stories[$scope.activeStory].slides[$scope.activeSlide]);
        }
        else
        {
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                 enableVideoConfigs();
                 generateView();
               }
               else
               {
                generateView();
                enableImageConfigs();
               } 
        
        }
            
        }
                
        $scope.navigateSlideOrStory = function (n) {


            $scope.videoLoader=false;
            if($scope.storyPlay==true){
                $scope.storyPlay = false;
                $scope.storyPause = true;
            }

            
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                vid.pause();
                vid.currentTime=0;
         
               }


       

      
        var tempSlide = $scope.activeSlide;
        tempSlide = tempSlide + (n);
        if (tempSlide < 0) {
            
            if ($scope.activeStory == 0) {
               
               $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
                
                    return;
            }
            else{

                $scope.activeStory = $scope.activeStory - 1;
                $scope.activeSlide = 0;
                $scope.swipeLeft = true;
                return
            }
            
        }
        if (tempSlide > ($scope.stories[$scope.activeStory].slides.length - 1)) {
           
            if ($scope.activeStory == ($scope.stories.length - 1)) {
                $scope.storyComment = false;
                $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
                $scope.activeStory=0
                $scope.activeSlide=0
                setTimeout(function() {
                    $scope.stopBtn();
                    setTimeout(function() {
                        $scope.stopBtn();
                    }, 1200)
                }, 500)
                if($rootScope.platform_reactApp_new) {
                    console.log('close-webview');
                } else {
                    //when all the stories have been completed and watched then user should be redirected to landing page.
                    $state.go('Landing');
                }
                
                return
            }
            else
            {
                
                 
            $scope.activeStory = $scope.activeStory + 1;
            if($scope.activeStory){
                    $scope.swipeRight = true;
            }else{
                 $scope.swipeRight = false;
            }
            $scope.activeSlide = 0;
            $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
           
            return
            }
            
        }
        $scope.activeSlide = tempSlide;
        $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
        $scope.swipeRight = false;
        return

        }
        $scope.closeStoryPopup = function () {
            if($rootScope.platform_reactApp_new) {
                console.log('close-webview');
                $scope.stopBtn()
            } else {
                mixpanel.track('Story-close')
                console.log('close-webview');
                $state.go('Landing');
                $scope.storyComment = false;
                $interval.cancel($scope.slideInterval);
            }
        }
        document.body.addEventListener("keydown", function (event) {

           
            
            if (event.key === "Escape") {
                $scope.storyComment = false;
                $interval.cancel($scope.slideInterval);
                $interval.cancel($scope.statusBarInterval);
                $state.go('Landing');
            }
            else if(event.key=="ArrowRight")
            {
                $scope.navigateFromButtons(1);
            }
            else if(event.key=="ArrowLeft")
            {
                $scope.navigateFromButtons(-1);
            }
            else if(event.key=="Enter" && $scope.storyComment==true && ($scope.userComment!=='' || $scope.comment_image_url))
            {
                $scope.userCommentAdd($scope.userComment);
            }
            // else if(event.code=="Space")
            // {
            //     if($scope.storyPlay == true)
            //     {
            //         $scope.playBtn();
                    
                    
            //     }
            //     else if($scope.storyPlay==false)
            //     {
            //         $scope.stopBtn();
                   
            //     }
                
        
               
            // }
        });
        // document.addEventListener("pause", function(){

        //     console.log('\n\n\nMobile pause event fired--------------------------')


        // }, false);

        document.addEventListener("visibilitychange", function() {
            if (document.hidden){
                $scope.stopBtn();
            } else {
                if($scope.storyComment==false)
                {
                    if(!$rootScope.platform_reactApp_new) {
                        $scope.playBtn();
                    }
                }
                                 
            }
        });

     
        $scope.getCommentsForUser = function (id, slide) {
            
            
            $scope.coment=[];
            $scope.mediaId = id;
            $scope.slide_data = $scope.stories[$scope.activeStory].slides[$scope.activeSlide];
            $scope.description = $scope.stories[$scope.activeStory].slides[$scope.activeSlide].description;
            $scope.title = $scope.stories[$scope.activeStory].slides[$scope.activeSlide].title;
            
            
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_comments)
            {
            $scope.comment_offset=0;
            $scope.commentLoader=true;
            var data;
            data = localStorage.getItem("userInfo");
            var user_id = JSON.parse(data);

        var a = document.getElementById('storyCommentMain')

        $http({
            url: 'api/v1/story/getCommentsforUser',
            method: "GET",
            params: {
            media_id: id,
            userId:user_id.id,
            per_page: 10,
            offset: $scope.comment_offset,
            }
        }).then(function (response) {
            $scope.commentLoader=false;
            $scope.coment = response.data;
            $scope.commentLoadable=$scope.coment.length<10?false:true;
            $scope.commentedPaginationLoader=false;
            $scope.$apply();
           
        });

        }
        }

        $scope.loadMoreComments = function() {
            if($scope.commentLoadable && $scope.coment.length>9)
            {

        $scope.commentedPaginationLoader=true;
            var data;
            data = localStorage.getItem("userInfo");
            var user_id = JSON.parse(data);
            $scope.comment_offset=$scope.comment_offset+10;

            $http({
                url: 'api/v1/story/getCommentsforUser',
                method: "GET",
                params: {
                media_id: $scope.stories[$scope.activeStory].slides[$scope.activeSlide].id,
                userId:user_id.id,
                per_page: 10,
                offset: $scope.comment_offset,
                }
            }).then(function (response) {
                $scope.commentedPaginationLoader=false;
                $scope.coment=$scope.coment.concat(response.data);
                if(response.data.length<10)
                {
                    $scope.commentLoadable=false;
                }
            
            });
            }
            
           
          }
        $scope.getRepliesForUser = function (id, index) {
            
        
        if($scope.cid !== id)
        {s
        $scope.rep=[];
        $scope.storyCommentReply = false;
        $scope.storyCommentWriteReply =false;
        $scope.cid = id;
        $scope.com_id = id;
        $scope.storyCommentReply==false && $scope.coment[index].replyCount?$scope.replyLoader=true:$scope.replyLoader=false;
        $scope.storyCommentReply = !$scope.storyCommentReply;
        
        }
        else
        {
        $scope.cid = id;
        $scope.com_id = id;
        $scope.storyCommentReply==false && $scope.coment[index].replyCount?$scope.replyLoader=true:$scope.replyLoader=false;
        $scope.storyCommentReply =!$scope.storyCommentReply;
        $scope.storyCommentWriteReply = true;
        }

        //}
        if($scope.coment[index].replyCount && $scope.replyLoader)
        {
            $http({
                url: 'api/v1/story/getRepliesforUser',
                method: "GET",
                params: { comment_id: id }
                // params: { per_page: 10, offset: 1 }
            }).then(function (response) {
                $scope.replyLoader=false;
                $scope.rep = response.data;
                $scope.storyCommentWriteReply = true;
                // $scope.dis = true;addReply
    
            });
        }
        

        }
        $scope.addReply = function (reply, com,index) {
            var data;
            data = localStorage.getItem("userInfo");
            var user_id = JSON.parse(data);
        if (reply == undefined) {
            return
        }
        $scope.beforeReplyType = true;
        $scope.afterReplyType = false;
        var inputData = {
            user_name:user_id.full_name,
            media_id: $scope.mediaId,
            user_id: user_id.id,
            user_image:$scope.userImage?$scope.userImage:undefined,
            comment_id: com,
            reply: reply,
            is_diabled: false,
            is_deleted: false,
            created_at: new Date()
        }

        if($scope.cid!==com)
            {
                $scope.cid = com;
                $scope.rep=[];
            }
            

        
        $scope.rep.push(inputData)
        $scope.coment[index].replyCount=$scope.coment[index].replyCount?parseInt($scope.coment[index].replyCount)+1:1;
        document.getElementById("storyCommentBoxReply").value="";
        $scope.storyCommentWriteReply = false;
        $scope.cid = com;
        $scope.storyCommentReply=true;
        
        
        
        $http.post('/api/v1/story/addReply', inputData)
            .then(function (data) {
                
            //$scope.getCommentsForUser($scope.mediaId, $scope.slide_data);
            //$scope.$apply();
            });
        }
        $scope.addCommentLike = function (comment,index) {
            
            if($scope.coment[index].is_liked==true)
            {
                $scope.coment[index].is_liked=undefined;
                $scope.coment[index].commentlikes=parseInt($scope.coment[index].commentlikes)-1

            }
            else
            {
                $scope.coment[index].is_liked=true;
                $scope.coment[index].commentlikes=$scope.coment[index].commentlikes?parseInt($scope.coment[index].commentlikes)+1:0+1;

            }

        var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);
        var inputData = {
            comment_id: comment.id,
            user_id: user_id.id,
            media_id: comment.media_id,
        }
        $http.post('/api/v1/story/commentLikes', inputData)
            .then(function (data) {
            console.log(data);
            });
        }
        $scope.addLikes = function (id) {
            
       
        var data;
        data = localStorage.getItem("userInfo");
        
        if(data!=='false')
        {
               
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked!==undefined && $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked==true)
            {
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes=$scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes?parseInt($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes)-1:0;
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked=false;
            }
            else
            {
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes=$scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes?parseInt($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes)+1:0+1;
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked=true;
            }
            var user_id = JSON.parse(data);
        var inputData = {
            media_id: id,
            user_id: user_id.id,
            browser_id:null,
        }
        $http.post('/api/v1/story/storyLikes', inputData)
            .then(function (data) {
            $scope.likeFill = false;
            $scope.likeUnFill = true;

            });
        // $scope.slideIntervalFunction();
        }
        else
        {
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked!==undefined && $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked==true)
            {
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes=$scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes?parseInt($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes)-1:0;
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked=false;
            }
            else
            {
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes=$scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes?parseInt($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_likes)+1:0+1;
                $scope.stories[$scope.activeStory].slides[$scope.activeSlide].is_liked=true;
            }
            var browserId = $cookies.get('browserId');
           
            var inputData = {
                media_id: id,
                user_id: null,
                browser_id:browserId
            }
            $http.post('/api/v1/story/storyLikes', inputData)
                .then(function (data) {

                $scope.likeFill = false;
                $scope.likeUnFill = true;

                });
            
        }

        
        
        }

        

        // $scope.openStoryPopup = function (id, index) {
        // $scope.activeStory = index;
        // $scope.storyPopup = true;
        // // $scope.slideIntervalFunction();
        // $scope.slideInterval = $interval(slideIntervalFunction, 5000);
        // document.body.classList.add('remove-story-scroll');
        // }
        

         $scope.initializeUserImage=function()
         {
            var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);

          if(user_id)
          {
            $scope.userImage=user_id.image?user_id.image:undefined;
          }
         }

         $scope.initializeUserImage()


        $scope.storyCommentOpen = function () {
            console.log('popup-open');
        var data = localStorage.getItem("userInfo");
        if(data!=='false')
        {
        $scope.stopBtn(); 
        $scope.storyComment = true;        
       }
        else
        {
            $state.params.storeel_id=$scope.stories[$scope.activeStory].id;
            $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
            $scope.$emit('showLoginPopup');
        }
        }


        $scope.readMore = function (length) {
        if ($scope.readMoreBtn === "Read more") {
            $scope.readMoreBtn = "Read less";
            $scope.numLimit = length;
        } else if ($scope.readMoreBtn === "Read less") {
            $scope.readMoreBtn = "Read more";
            $scope.numLimit = 50;
        }
        

        }
        $scope.readMoreLongDesc = function (length) {
            if ($scope.readMoreBtnLong === "Read more") {
                $scope.readMoreBtnLong = "Read less";
                $scope.longDescLimit = length;
            } else if ($scope.readMoreBtnLong === "Read less") {
                $scope.readMoreBtnLong = "Read more";
                $scope.longDescLimit = 100;
            }
        }


        

        $scope.openCurrentStory = function (id, index, media_id) {

            // mixpanel.track('Story-Open-Inside-Page', {
            //    'Story_ID' : id,
            //     'Story_Title' : media_id, 
            // })
        
            $scope.commentedPaginationLoader=false;
            $scope.videoLoader=false;
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                vid.muted=true;
                vid.pause();
                vid.currentTime=0;
                $scope.videoMute=false;

               }

        $scope.beforeType = true;
        $scope.afterType = false;
        $scope.userComment=''
        $scope.storyPause = true;       
        $scope.storyPlay = false;
        var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);
        $scope.activeStory = index;
        if(user_id.id!==undefined)
                {

                    
                    for(var i=0;i<$scope.stories[$scope.activeStory].slides.length;i++){
                        if($scope.stories[$scope.activeStory].slides[i].is_viewed==false)
                        {
                            $scope.activeSlide=i;
                            $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
                            break;
                        }
                        else
                        {
                            $scope.activeSlide=0;
                        }
                    }                
                }
                $scope.activeSlide=$scope.activeSlide>$scope.stories[$scope.activeStory].slides.length-1?0:$scope.activeSlide;

        if($scope.storyComment==true)
        {
            if($scope.stories[$scope.activeStory].comment_allowed==false)
            {
                $scope.storyCommentClose()
            }
            else
            {
            $scope.storyPlay = true;
            $scope.storyPause = false;
            $interval.cancel($scope.slideInterval);
            $scope.getCommentsForUser($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id, $scope.stories[$scope.activeStory].slides[$scope.activeSlide]);

            }
        }
        else
        {
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                enableVideoConfigs();
                generateView();

               }
               else
               {
                enableImageConfigs();
                generateView();
                // document.body.classList.add('remove-story-scroll');
               }

        }
        
        }

        

        $scope.CircleStatusView = function (stories) {

            var data;
            data = localStorage.getItem("userInfo");
            var user_id = JSON.parse(data);
      
            stories.forEach(function (story,index) {
              var data=[];
              var viewed = 0;
              var notViewed=0;
              var total=story.slides.length;
              var angle = (1 / total) * 360;
              var percentage = (1 / total) * 100;
              var circleCircumference = 2 * Math.PI * 36;
              var strokeDashoffset = circleCircumference - (circleCircumference * percentage) / 100;
              var sliceSpacing = total === 1 ? 0 : 5;
      
              
              story.slides.forEach(function (slide,index){
                if(slide.is_viewed==true)
                {
                data.push({color: user_id.id?'#ffbdca':'#F34A00',rotation:angle * index,circleCircumference:circleCircumference,strokeDashoffset:strokeDashoffset+sliceSpacing,radius:36});
                 viewed++
                }
                else
                {
                 data.push({ color: '#F34A00', rotation:angle * index, circleCircumference: circleCircumference, strokeDashoffset: strokeDashoffset+sliceSpacing,radius:36});
                 notViewed++
                }
             })
             story["storyStatusData"] = data;
        
      
             })
            

             return stories;
            }      

            var enableImageConfigs=function()
            {
                $scope.videoLoader=false;
                $scope.determinateValue=0;
                $interval.cancel($scope.statusBarInterval);
                $interval.cancel($scope.slideInterval);
                var image = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                var isLoaded;
                $scope.videoLoader=true;
                if(image && image.complete && image.naturalHeight)
                {
                    isLoaded = image.complete && image.naturalHeight !== 0;
                }
                if(image!==null && isLoaded)
                {$scope.videoLoader=false;
                $interval.cancel($scope.slideInterval)
                $scope.statusBar($scope.defaultInterval);
                $scope.slideInterval = $interval(slideIntervalFunction, $scope.defaultInterval);
                }
               else{
                setTimeout(enableImageConfigs,300)

               }
            }

            //
            var enableVideoConfigs= function()
            {
                $interval.cancel($scope.statusBarInterval);

                $scope.videoLoader=false;
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                $scope.videoLoader=true;
                $scope.determinateValue=0;
                
                
                if(vid!==null)
                {
                 
                    var duration=vid.duration;
                    
                    if(duration && duration!==NaN)
                    {
                        
                        //$scope.stopBtn();
                    $interval.cancel($scope.statusBarInterval);
                    vid.onwaiting = function(event){
                        $interval.cancel($scope.slideInterval);
                        $interval.cancel($scope.statusBarInterval);
                        $scope.videoLoader=true;
                        $scope.videoIsBuffering=true;
                      };
                      vid.onplaying = function(event){
                        if($scope.videoIsBuffering)
                        {
                        $scope.videoLoader=false;
                        var resumeInterval=((100/$scope.incrementedValue)*100)-(($scope.determinateValue/$scope.incrementedValue)*100)            
                        $interval.cancel($scope.slideInterval);
                        $scope.statusBar(resumeInterval,$scope.determinateValue,$scope.incrementedValue);
                        $scope.slideInterval = $interval(slideIntervalFunction, resumeInterval);
                        $scope.videoIsBuffering=false;
                        }
                      };
                        vid.currentTime =0;
                        vid.muted=false;
                        vid.play();
                        $scope.videoLoader=false;
                    
                    if(duration)
                    {
                        $scope.statusBar(duration*1000);
                    }
                    $interval.cancel($scope.slideInterval);
                    $scope.slideInterval = $interval(slideIntervalFunction, duration*1000);
                    
                    }
                    else
                    {
                    setTimeout(enableVideoConfigs,300);
                    }
                }
                else{

                    setTimeout(enableVideoConfigs,300);
                }          
            }

           


        var getStoriesUsers = function () {
            
        var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);

        if(user_id)
        {
            $scope.initializeUserImage();
        }

        var browserId = $cookies.get('browserId');

        if(!$state.params.stories)
        {

        $http({
            url: 'api/v1/story/getStoriesForUser',
            method: "GET",
            params: { user_id: user_id.id,browser_id: browserId}
            // params: { per_page: 10, offset: 1 }
        }).then(function (response) {
            $scope.stories = $scope.CircleStatusView(response.data.response);
            $scope.dynamic_url = response.data.url;

            if ($state.params.storeel_id!==null && $state.params.storeel_id!=='') {
         
                
            $scope.story_id = $state.params.storeel_id;
            $scope.stories.forEach(function (element, index) {
 
                if (element.id == $scope.story_id) {
                $scope.activeStory = index;
                if(user_id.id!==undefined)
                {
                    for(var i=0;i<$scope.stories[$scope.activeStory].slides.length;i++){
                        if($scope.stories[$scope.activeStory].slides[i].is_viewed==false)
                        {
                            $scope.activeSlide=i;
                            $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
                            
                            break;
                        }
                        else
                        {
                            $scope.activeSlide=0;
                        }
                    }                
                }


                
                $scope.storyPopup = true;
                if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                
                enableVideoConfigs();
                generateView();               
            }
               else
               {
                enableImageConfigs()
                generateView();
               }
                }

            });
            }
            else
            {
                $scope.activeStory=0;
                $scope.activeSlide=0;
                if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
            {

 
                generateView();
                enableVideoConfigs();     
            }
            else
            {
            enableImageConfigs();   
            generateView();
             
            //  document.body.classList.add('remove-story-scroll');
            }

            }

            
        });
    }
    else
    {
       
            $scope.stories = $scope.CircleStatusView($state.params.stories);
            $scope.dynamic_url = $state.params.dynamic_url;
            if ($state.params.storeel_id!==null || $state.params.story_id!==null) {
                
            $scope.story_id = $state.params.storeel_id?$state.params.storeel_id:$state.params.story_id;
                
            $scope.stories.forEach(function (element, index) {
                if (element.id == $scope.story_id) {
                $scope.activeStory = index;

                if(user_id.id!==undefined)
                {
                    for(var i=0;i<$scope.stories[$scope.activeStory].slides.length;i++){
                        if($scope.stories[$scope.activeStory].slides[i].is_viewed==false)
                        {
                            $scope.activeSlide=i;
                            $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
                            
                            break;
                        }
                        else
                        {
                            $scope.activeSlide=0;
                        }
                    }                
                }
                
                $scope.storyPopup = true;
                if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                
                enableVideoConfigs();
                generateView();               
            }
               else
               {
                enableImageConfigs()
                generateView();
               }
                }

            });
            }
            else
            {
                $scope.activeStory=0;
                $scope.activeSlide=0;
                if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
            {

                generateView();
                enableVideoConfigs();     
            }
            else
            {
             enableImageConfigs();
             generateView();
             
            //  document.body.classList.add('remove-story-scroll');
            }

            }

            
        

    }
        // $scope.activeStory = index;
        }
        var uniqueLinkRedirectForStories = function (link_id) {
           
            
        var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);
        if(user_id)
        {
            $scope.initializeUserImage();
        }
        $http({
            url: 'api/v1/story/getStoriesForUser',
            method: "GET",
            params: { user_id: user_id.id,link_id:link_id}
            // params: { per_page: 10, offset: 1 }
        }).then(function (response) {
            
            $scope.stories = $scope.CircleStatusView(response.data.response);


            $scope.dynamic_url = response.data.url;
            if (link_id) {
            var presentedStory=$scope.stories.filter(function(value)
            {
                if (value.link_id==link_id)
                {
                    return value;
                }
            }
            )
            if(presentedStory[0].stories_display_to=='register' && (user_id==false || user_id==undefined)){
                $scope.storyComment = false;
                $interval.cancel($scope.slideInterval);
                CustomStorageService.setStoryLinkFlag('true');
                $scope.$emit('showLoginPopup');
            }
            $scope.story_id = presentedStory[0].id;
            
            $scope.stories.forEach(function (element, index) {
                if (element.id == $scope.story_id) {
                $scope.activeStory = index;
                
                $scope.storyPopup = true;
                if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
               {
                var vid = document.getElementById($scope.stories[$scope.activeStory].slides[$scope.activeSlide].id);
                $interval.cancel($scope.slideInterval);
                $scope.slideInterval = $interval(slideIntervalFunction, vid.duration*1000);$scope.statusBar(vid.duration*1000);

               }
               else
               {
                $interval.cancel($scope.slideInterval);
                $scope.slideInterval = $interval(slideIntervalFunction, $scope.defaultInterval);
               }
                // document.body.classList.add('remove-story-scroll');
                }
                

            });
            }
        });
        // $scope.activeStory = index;
        }

        var uniqueLinkRedirectForReels = function (reel_link_id) {
        var data;
        data = localStorage.getItem("userInfo");
        var user_id = JSON.parse(data);
        var browserId = $cookies.get('browserId');
        $http({
            url: '/api/v1/story/getReelBylinkId',
            method: "GET",
            params: { user_id: user_id.id,reel_link_id:reel_link_id,browser_id:browserId}
            // params: { per_page: 10, offset: 1 }
        }).then(function (response) {
            $scope.stories = $scope.CircleStatusView(response.data.response);
            
            
            var tempStoryIndex;
            $scope.dynamic_url = response.data.url;
            if (reel_link_id) {
            var presentedStory=[]
            var reelId;
            $scope.stories.forEach(function(value,ind)
            {
                value.slides.forEach(function(reel,index)
                {
                    if (reel.link_id==reel_link_id)
                {
                    presentedStory.push(value);
                    $scope.activeSlide=index;
                    tempStoryIndex=ind;
                    reelId=reel.id;
                }
                }) 
            })

            $state.params.storeel_id=$scope.stories[$scope.activeStory].id;
            $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
            if(!user_id && $rootScope.closeLogin!==false){
                
                //CustomStorageService.setReelLinkFlag('true');
                $scope.storyComment = false;
                $interval.cancel($scope.slideInterval);
                $rootScope.closeLogin=false;
                $scope.$emit('showLoginPopup');
            }
            $scope.story_id = presentedStory[0].id;
            
            $scope.activeStory = tempStoryIndex;
            $scope.stories[$scope.activeStory].storyStatusData[$scope.activeSlide].color='#ffbdca';
            
            if($scope.stories[$scope.activeStory].slides[$scope.activeSlide].video_link)
                    {
                        //enableVideoConfigs();
                        $scope.storyPlay = true;
                        $scope.storyPause = false; 
                        generateView();
                    }
                    else
                    {
                        enableImageConfigs();
                        generateView();
                     // document.body.classList.add('remove-story-scroll');
                    }    
            
            
        }
        })
        // $scope.activeStory = index;
        }

        if($state.params.story_link_id)
        {
            uniqueLinkRedirectForStories($state.params.story_link_id);
        }
        else if($state.params.reel_link_id)
        {
            
            uniqueLinkRedirectForReels($state.params.reel_link_id);
        }
        else
        {
            getStoriesUsers();
        }
        

        $scope.userCommentAdd = function (user_comment) {

        $scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_comments=$scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_comments?parseInt($scope.stories[$scope.activeStory].slides[$scope.activeSlide].story_comments)+1:0+1;
        // $scope.coment = response.data;
        //     $scope.$apply();
        var data;
        data = localStorage.getItem("userInfo");

        // $scope.coment.splice(0,0,{
        //     media_id: $scope.stories[$scope.activeStory].slides[$scope.activeSlide].id,
        //     image:$scope.comment_image_url?$scope.comment_image_url:'',
        //     thumbnail:$scope.comment_thumbnail_link?$scope.comment_thumbnail_link:'',
        //     user_id: user_id.id,
        //     comment: user_comment,
        //     is_diabled: false,
        //     is_deleted: false,
        // });
        
        var user_id = JSON.parse(data);
        
        var body = {
            id:$scope.coment[0]?$scope.coment[0].id+1:0,
            user_id:{id:user_id.id,full_name:user_id.full_name,image:$scope.userImage},
            media_id: $scope.stories[$scope.activeStory].slides[$scope.activeSlide].id,
            image:$scope.comment_image_url?$scope.comment_image_url:null,
            thumbnail:$scope.comment_thumbnail_link?$scope.comment_thumbnail_link:null,
            comment: user_comment,
            is_approved:$scope.comment_image_url && $scope.comment_image_url!==''?false:true,
            is_disabled: false,
            is_deleted: false,
            created_at:new Date(),
        }
        if(!$scope.comment_image_url || $scope.comment_image_url=='')
        {
            $scope.coment.splice(0,0,body);
            
        }
        var commentmain=document.getElementById('storyCommentMain')
        commentmain.scrollTop = 0;
        $scope.userComment='';
        
        $scope.beforeType = true;
        $scope.afterType = false;
        $http.post("/api/v1/story/addComments", body)
            .then(function (resp) {
                if($scope.comment_image_url && $scope.comment_image_url!=='')
                {
                    toaster.pop({
                        type: 'success',
                        title: 'Your comment will get posted after approval',
                        timeout: 3000,
                        showCloseButton: true
                    });
            
                }
           
            $scope.comment_image_url = null;
            $scope.comment_thumbnail_link=null;
            })
        }
        
       
        $scope.textAreaAdjust = function () {
            
        var commentBox = document.getElementById("storyCommentBox");
    commentBox.style.height = "1px";
        commentBox.style.height = (25 + commentBox.scrollHeight) + "px";
        
        if($scope.userComment=='' && !$scope.im && !$scope.comment_image_url)
            {
                $scope.beforeType = true;
                $scope.afterType = false;
            }
            else
            {
                $scope.beforeType = false;
                $scope.afterType = true;
            }
        
        
        
        }
        $scope.removeCommentImage=function()
        {
            $scope.comment_image_url = null;
            $scope.comment_thumbnail_link=null;
            $scope.im=null;
            if(!$scope.userComment || $scope.userComment=='')
            {
                $scope.beforeType = true;
                $scope.afterType = false;

            }
            
           
        }
        $scope.replyAreaAdjust = function (userReply) {

        var commentBoxreply = document.getElementById("storyCommentBoxReply");
        commentBoxreply.style.height = "1px";
        commentBoxreply.style.height = (25 + commentBoxreply.scrollHeight) + "px";
        
        if(userReply=='')
            {
                $scope.beforeReplyType = true;
                $scope.afterReplyType = false;
            }
            else
            {
                $scope.beforeReplyType = false;
                $scope.afterReplyType = true;
            }
        
        

        // $scope.beforeType = false;
        // $scope.afterType = true;

        
        }

    };
    })();
    
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('sliderController', MainController);

  function MainController($scope,$timeout) {
    var scope=$scope;
    scope.currentIndex=0;
    scope.direction = 'left';

    scope.next = function() {
      scope.direction = 'right';
      scope.currentIndex < scope.instructors.length - 1 ? scope.currentIndex++ : scope.currentIndex = 0;
    };
    scope.prev = function() {
      scope.direction = 'left';
      scope.currentIndex > 0 ? scope.currentIndex-- : scope.currentIndex = scope.instructors.length - 1;
    };
    scope.$watch('currentIndex',function(){
      scope.instructors.forEach(function(inst){
        inst.visible=false;
      });
      scope.instructors[scope.currentIndex].visible=true;
    });

    /* Start: For Automatic slideshow*/

    var timer;
    var sliderFunc=function(){
      timer=$timeout(function(){
        scope.next();
        timer=$timeout(sliderFunc,5000);
      },5000);
    };

    sliderFunc();

    scope.isCurrentSlideIndex = function (index) {
      return scope.currentIndex === index;
    };

    scope.$on('$destroy',function(){
      $timeout.cancel(timer);
    });

    /* End : For Automatic slideshow*/
  }
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("signUpController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $base64,
    $timeout,
    $state,BlogBackendServices
  ) {

    // $scope.email_Field = true;
    // $scope.password_Field = true;

  }
})();

angular
  .module('NearPeer')
  .factory('videoSocket', ['env' ,function (env) {
	var socket = io.connect(env.videoMigrationMicroServicePath, {
		path: '/s3totovimeomigration/instructor-socket',
		transports: ['websocket'],
	});
	return socket;
}]);

angular.module("NearPeer").factory("notificationSocket", [
  "env",
  "CustomStorageService",
  function (env, CustomStorageService) {
    var uid = 0;
    if (CustomStorageService.getUserInfoStorageData()) {
      uid = parseInt(CustomStorageService.getUserInfoStorageData().id);
    }
    var socket = io.connect(env.backendService, {
      path: "/notificationservice/socket/notification",
      query: {
        uid: uid,
      },
      transports: ["websocket"],
    });

    return socket;
  },
]);

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('landingService', ['$http','$q', function($http, $q) {



    var buyBundle = function (name) {
    var defer = $q.defer();

      $http.post('api/v1/bundle/mdcat',{name:name})
      .then(function(data){
        if(data.data.succes){
          var bundleData = data.data.bundle;
          bundleData.bundle = true;
          defer.resolve(bundleData);

        } else {
          return false;
        }
      },function errorCallback(error) {});
      return defer.promise;


    };

    return {
      buyBundle:buyBundle,
    }
  }]);
})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .service('DownloadPopupService', ['$http', '$q', 'CustomStorageService', function ($http, $q, CustomStorageService) {

            var saveDownloadInfo = function (email, downloadType){
                var userId;
                var data;
                userId = CustomStorageService.getUserInfoStorageData();
                if(userId != false) {
                    userId = CustomStorageService.getUserInfoStorageData().id;
                    data = {
                        'email':email,
                        'userId':userId,
                        'downloadType':downloadType
                    }
                 }
                 else {
                     data = {
                        'email':email,
                        'downloadType':downloadType
                    }
                }
                $http.post('api/v1/apps/saveAppDownloadInfo', data)
                .then(function (res) {
                },function (error) {
                })
            }

            var openApp = function (api, params) {
                window.location.href = "nearpeer://";
            };

            var downloadApp = function (api,params ) {
                var platform = window.navigator.platform,
                macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                os = 'Mac';

                if (macosPlatforms.indexOf(platform) !== -1) {
                    os = 'Mac';
                    window.open("https://downloads.nearpeer.org/desktop-app/Nearpeer_Mac_App.zip","_self");
                } else if (windowsPlatforms.indexOf(platform) !== -1) {
                    window.open("https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Windows-2.exe","_self");
                    os = 'Windows';
                } else if (!os && /Linux/.test(platform)) {
                    window.open("https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Linux.AppImage","_self");
                    os = 'Linux';
                } else {
                    window.location.href = "/downloadapp";
                }
                saveDownloadInfo(null, os);
            };

            var acceptTerm = function (data) {
                $http.post('/api/v1/user/update-video-privacy-term', data)
                .then(function (res) {
                    if(res.data.success) {
                        CustomStorageService.setTermStatus('true');
                    }
                },function (error) {
                    console.log('err');
                    console.log(err);
                })
            };

            return {
                openApp: openApp,
                downloadApp: downloadApp,
                acceptTerm: acceptTerm,
            }
        }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('caCourseServices', ['$rootScope','$http', '$state', '$q','BreadcrumbService',function($rootScope,$http, $state, $q,BreadcrumbService) {
    var GetSearchCACourses = function(searchCourse) {
      var courseSearchdefer = $q.defer();
      $http({
        url: 'api/v1/courses/getSearchCACourses',
        method: "GET",
        params : {tag:searchCourse }
      }).then(function(data){
        courseSearchdefer.resolve(data.data);
      });
      return courseSearchdefer.promise;

    };

    var GetSearchCACoursesType = function(searchCourse,type) {
      var courseSearchdefer = $q.defer();
      $http({
        url: 'api/v1/courses/getSearchCACoursesType',
        method: "GET",
        params : {tag:searchCourse,type:type }
      }).then(function(data){
        courseSearchdefer.resolve(data.data);
      });
      return courseSearchdefer.promise;

    };

    var GetAllCACourses = function () {
      var coursedefer = $q.defer();
      $http({
        url: 'api/v1/courses/getAllCACourses',
        method: "GET"
      }).then(function(data){
        
        coursedefer.resolve(data.data);
      });
      return coursedefer.promise;
    }
    return {
      GetAllCACourses:GetAllCACourses,
      GetSearchCACourses:GetSearchCACourses,
      GetSearchCACoursesType:GetSearchCACoursesType
    }
    
  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('b2bService', ['$rootScope','CustomStorageService','Upload','$http', '$state','$q', function($rootScope,CustomStorageService,Upload,$http, $state, $q) {

    // var b2bUserData = function (b2bFormData) {
    //   $http({
    //     url: '/api/v1/b2b/saveb2bleadform',
    //     method : 'POST',
    //     data : {
    //       "name": b2bFormData.b2bUserName,
    //       "email": b2bFormData.b2bUserEmail,
    //       "phone_number": b2bFormData.b2bUserPhone,
    //       "company_name": b2bFormData.b2bUserCompany,
    //       "description": b2bFormData.b2bUserMessage,
    //   }
    //   })
    //   .then ( function (res) {
    //     if(res.data.success){
    //       swal({
    //         title: "Form Data",
    //         text: "Your data has been sent",
    //         type: "success",
    //         confirmButtonText: "Ok"
    //       });
    //     }
    //   });
    // };
    // var getB2bUserData = function(b2bSearchData) {
    //   var b2bSearchdefer = $q.defer();
    //   $http({
    //     url: '/api/v1/b2b/getb2bleadforms',
    //     method: "GET",
    //     params : {
    //       search: b2bSearchData.search,
    //       fromDate:  b2bSearchData.fromDate,
    //       toDate: b2bSearchData.toDate,
    //     }
    //   }).then(function(data){
    //     b2bSearchdefer.resolve(data.data);
    //   });
    //   return b2bSearchdefer.promise;

    // };
    // return {
    //   b2bUserData:b2bUserData,
    //   getB2bUserData:getB2bUserData
    // };

   
   
  }]);
})();

(function () {
  "use strict";

  angular.module("NearPeer").service("AssignmentService", [
    "$http",
    "env",
    function ($http, env) {
      var getAssignmentDetail = function (campaign_id) {
        return new Promise(function (resolve, reject) {
          $http
            .get(
              env.notificationService +
                "/assignment/get-assignment-detail/" +
                campaign_id
            )
            .then(function (res) {
              resolve(res.data);
            });
        });
      };
      var getAssignmentResult = function (assignment_id) {
        return new Promise(function (resolve, reject) {
          $http
            .get(
              env.notificationService +
                "/assignment/get-assignment-result/" +
                assignment_id
            )
            .then(function (res) {
              resolve(res.data);
            });
        });
      };
      var updateAssignmentStatus = function (data) {
        return new Promise(function (resolve, reject) {
          $http
            .post(
              env.notificationService + "/assignment/get-update-status",
              data
            )
            .then(function (res) {
              if (res.data && res.data.success) {
                resolve({ success: true });
              } else {
                resolve({ success: false });
              }
            });
        });
      };
      var getAllAssignments = function (data) {
        return new Promise(function (resolve, reject) {
          $http
            .post(
              env.notificationService + "/assignment/get-assignment-submitions",
              data
            )
            .then(function (res) {
              if (res.data && res.data.success) {
                resolve(res.data);
              }
            });
        });
      };
      var getPendingCount = function (data) {
        return new Promise(function (resolve, reject) {
          $http({
            url: env.notificationService + "/assignment/get-pending-count",
            method : 'GET',
            params : data,
          }).then(function (res) {
              if (res.data && res.data.success) {
                resolve(res.data);
              }
            });
        });
      };

      return {
        updateAssignmentStatus: updateAssignmentStatus,
        getAssignmentDetail: getAssignmentDetail,
        getAllAssignments: getAllAssignments,
        getAssignmentResult: getAssignmentResult,
        getPendingCount: getPendingCount,
      };
    },
  ]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('UploadService', ['$rootScope','CustomStorageService','Upload','$http', '$state','$q', 'env', function($rootScope,CustomStorageService,Upload,$http, $state, $q, env) {

    var uploadImage = function (file) {
      var defer = $q.defer();
      if (file) {
        Upload.upload({
          url: '/api/v1/uploader/uploadImageToS3',
          method: 'POST',
          file: file,
          params: {userId:CustomStorageService.getUserInfoStorageData().id}
        }).then(function (resp) {
          defer.resolve(resp.data.link);
        });
      }
      return defer.promise;
    };
    var uploadStoryImage = function (file) {
      var defer = $q.defer();
      if (file) {
        Upload.upload({
          url: env.backendService + '/lmsservice/v1/uploader/uploadImageToS3?thumbnail=true',
          method: 'POST',
          file: file,
          params: {userId:CustomStorageService.getUserInfoStorageData().id}
        }).then(function (resp) {
          defer.resolve({link:resp.data.link,thumbnail_link:resp.data.thumbnail_link});
        });
      }
      return defer.promise;
    };
    return {
      uploadImage:uploadImage,
      uploadStoryImage:uploadStoryImage,
    }
  }]);
})();

(function() {
    'use strict';
  
    angular
    .module('NearPeer')
    .service('TrackingService', ['$rootScope', function($rootScope) {
  
      var viewItemEvent = function (data) {
        gtag("event", "view_item", {
            currency: "PKR",
            value: data.price,
            items: [
            {
              item_id: data.item_id,
              item_name:  data.item_name,
              discount: data.discount || 0,
              item_brand: "Nearpeer",
              item_category: data.institute,
              price: data.price,
              quantity: 1,
              instName: data.institute,
              productType: data.productType,
            }]
        });
      };

      var addToCartEvent = function (data) {
        gtag("event", "add_to_cart", {
            currency: "PKR",
            value: data.price,
            items: [
            {
              item_id: data.item_id,
              item_name:  data.item_name,
              discount: data.discount || 0,
              item_brand: "Nearpeer",
              item_category: data.institute,
              price: data.price,
              quantity: 1,
              instName: data.institute,
              productType: data.productType,
            }]
        });
      };

      var beginCheckoutEvent = function (data) {
        gtag("event", "begin_checkout", {
            currency: "PKR",
            value: data.price,
            coupon: data.coupon,
            items: [
            {
              item_id: data.item_id,
              item_name:  data.item_name,
              discount: data.discount || 0,
              item_brand: "Nearpeer",
              item_category: data.institute,
              price: data.price,
              quantity: 1,
              instName: data.institute,
              productType: data.productType,
            }]
        });
      };

      var purchaseEvent = function (data) {
        gtag("event", "purchase", {
            transaction_id: data.order_id,
            value: data.price,
            currency: "PKR",
            items: [
            {
              item_id: data.item_id,
              item_name:  data.item_name,
              discount: data.discount || 0,
              item_brand: "Nearpeer",
              item_category: data.institute,
              price: data.price,
              quantity: 1,
              instName: data.institute,
              orderType: data.orderType,
              productType: data.productType,
              paymentMethod: data.paymentMethod,
            }]
        });
      };

      return {
        purchaseEvent:purchaseEvent,
        viewItemEvent:viewItemEvent,
        addToCartEvent: addToCartEvent,
        beginCheckoutEvent: beginCheckoutEvent
      }
    }]);
  })();
  
(function() {
    'use strict';
  
    angular
    .module('NearPeer')
    .service('SearchService', ['$q','HttpService', function($q,HttpService) {


        var getSearchData = function (value, type) {            
            var defer = $q.defer();
            var api;
            if (type === 'user') {
                api = 'api/v1/user/search';
            } else if (type === 'course') {
                api = 'api/v1/courses/search';
            }
            HttpService.getRequest(api, { key: value })
                .then(function (res) {                    
                    if (type === 'user') {
                        defer.resolve(res.users);
                    } else if (type === 'course') {
                        defer.resolve(res.courses);
                    }
                });
                return defer.promise;
        }
      return {
        getSearchData:getSearchData,
      }
    }]);
  })();
  
(function () {
    'use strict';

    angular
        .module('NearPeer')
        .service('HttpService', ['$http', '$q', function ($http, $q) {

            var postRequest = function (api, params) {
                var defer = $q.defer();

                $http.post(api, params)
                    .then(function (data) {
                        defer.resolve(data.data);

                    }, function errorCallback(error) {
                        defer.resolve(error.data);
                    });
                return defer.promise;
            };
            var getRequest = function (api,params ) {
                var defer = $q.defer();
                $http({
                    url: api,
                    method : 'GET',
                    params : params || {},
                  }).then ( function (res) {
                    defer.resolve(res.data);
                  }, function errorCallback(error) {
                    defer.resolve(error.data);
                });
                return defer.promise;
            };

            return {
                getRequest: getRequest,
                postRequest: postRequest,
            }
        }]);
})();

(function () {
    'use strict';
    angular
        .module('NearPeer')
        .service('FeatureService', ['HttpService', '$q', function (HttpService, $q) {
            var getFeature = function (params) {
                var defer = $q.defer();
                var api = 'api/v1/courses/feature/get'
                HttpService.getRequest(api, params || {})
                    .then(function (res) {
                        if (res.success) {
                            defer.resolve(res.features);
                        }
                        else {
                            defer.reject(false);
                        }
                    });
                return defer.promise;
            };
            return {
                getFeature: getFeature,
            }
        }]);
})();

(function() {
    'use strict';
  
    angular
    .module('NearPeer')
    .service('ExternalLinksService', [function() {
        function addTargetToExternalLinks (input) { 
          if(input.includes('nearpeer.org/')) {
            input = input.replaceAll('target="_blank"', '')
          } else {
            input = input.replace(/(<a [^>]*)(target="[^"]*")([^>]*>)/gi, '$1$3')
            input=  input.replace(/(<a [^>]*)(>)/gi, '$1 target="_blank"$2')
          }
          return input;
        }
      return {
        addTargetToExternalLinks:addTargetToExternalLinks,
      }
    }]);
  })();
  
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('CustomStorageService', [ '$cookies', function($cookies) {
    var appStorage = window.localStorage;
    var initilaizeappStorage = function(){
      // socketId
      // appStorage.setItem("firstTime" ,false);
      appStorage.setItem("userInfo",false);
      appStorage.setItem("userAuthToken",false);
      appStorage.setItem("userSignedIn",false);
      appStorage.setItem("signedIn",false);
      appStorage.setItem("adminSignedIn",false);
      appStorage.setItem("instructorSignedIn", false);
      appStorage.setItem("phone", false);
      localStorage.setItem("adminInfo", false);
      localStorage.setItem('adminAuthToken', false);
      localStorage.setItem("instructorInfo", false);
      localStorage.setItem('instructorAuthToken', false);
    };    
  
    var getBlogsComment = function() {
      var data;
      data = appStorage.getItem("comment");
      if(data) {
        return JSON.parse(data);
      }
      else {
        return false;
      }
    }; 
    var getBlogsReply = function() {
      var data;
      data = appStorage.getItem("reply");
      if(data) {
        return JSON.parse(data);
      }
      else {
        return false;
      }
    }; 
    var setBlogsComment = function(data) {
      appStorage.setItem("comment",JSON.stringify(data));
    };
    var setBlogsReply = function(data) {
      appStorage.setItem("reply",JSON.stringify(data));
    };
    //get length storage
    var getLengthStorageData =function() {
      return appStorage.length;
    }
    function  urlCheck(){
     var checkurl = window.location.pathname;
     var adminurl = checkurl.includes('admin_panel') || checkurl.includes('admin_auth') || checkurl.includes('/admin/') || checkurl === '/admin' || checkurl === '/admin_signin';
     var instructorurl = checkurl.includes('instructor_panel') || checkurl === '/instructor_signin';
    return adminurl ? 'admin' : instructorurl ? 'instructor' : 'user';
  }
    //getter storage data
    var getFirstVisitStorageData = function() {
      var data;
      data = appStorage.getItem("firstVisit");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }

    };
   
    var getFirstTimeStorageData = function() {
      var data;
      data = appStorage.getItem("firstTime");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }

    };
    var getRememberMeData = function() {
      var data;
      data = appStorage.getItem("remember_me");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return JSON.parse(data);
      }

    };

    var getUserInfoStorageData = function() {
      var data;
      var prefix = urlCheck();
      data =  appStorage.getItem(prefix+'Info');
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return JSON.parse(data);
      }
    };
    var getAuthTokenStorageData = function() {
      var data;
      var prefix = urlCheck();
      data =  appStorage.getItem(prefix+'AuthToken');
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };

    var getBlogerSignedInStorageData = function() {
      var data;
      data = appStorage.getItem("blogerSignedIn");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    }
   
    var getAppFreeAccessPopup = function() {
      var data;
      data = appStorage.getItem("appFreeAccess");
      if(data === 'true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return 0;
      }
    };
    var getUserSignedInStorageData = function() {
      var data;
      var prefix = urlCheck();
      data =  appStorage.getItem(prefix+'SignedIn'); 
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var getSignedInStorageData = function() {
      var data;
      data = appStorage.getItem("signedIn");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var getAdminSignedInStorageData = function() {
      var data;
      data = appStorage.getItem("adminSignedIn");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var getInstructorSignedInStorageData = function() {
      var data;
      data = appStorage.getItem("instructorSignedIn");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };

    var getSocketIdStorageData = function() {
      var data;
      data = appStorage.getItem("socketId");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var getPhoneStorageData = function() {
      var data;
      data = appStorage.getItem("phone");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };

    var getStoryLinkFlag = function() {
      var data;
      data = appStorage.getItem("storyLinkUrl");
     
        return data;
    };

    var setStoryLinkFlag = function(link) {
      var data;
      data = appStorage.setItem("storyLinkFlag",link);
        return data;
    };

    var getReelLinkFlag = function() {
      var data;
      data = appStorage.getItem("storyLinkFlag");
     
        return data;
    };

    var setReelLinkFlag = function(link) {
      var data;
      data = appStorage.setItem("storyLinkUrl",link);
        return data;
    };



    var getModule = function(data) {
      var data;
      data = appStorage.getItem("mod_id");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    //setter storage data
    // localStorage.setItem('userInfo',JSON.stringify(resp.data.user));

    var getVideoUploadingState = function(){
       var data = appStorage.getItem("upload_status");
       return JSON.parse(data);
    };
    var getVideoUploadingStateForLiveSession = function(){
       var data = appStorage.getItem("upload_status_for_live_session");
       return JSON.parse(data);
    };
    var getCourseDeleteLogin = function() {
      var data = appStorage.getItem("courseDeleteLogin");
      return JSON.parse(data);
    };

    var getOrderTerminateLogin = function() {
      var data = appStorage.getItem("orderTerminateLogin");
      return JSON.parse(data);
    };
    
    var setVideoUploadingState = function(data){
      appStorage.setItem("upload_status" ,JSON.stringify(data));
    };

    var setVideoUploadingStateForLiveSession = function(data){
      appStorage.setItem("upload_status_for_live_session" ,JSON.stringify(data));
    };

    var getVideoUploaderDropdownState = function(){
      var data = appStorage.getItem("dropdown_status");
      return JSON.parse(data);
   };

   var getTermStatus = function() {
      var data = appStorage.getItem("term_status");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return true;
      }
    }

    var getFcmToken = function() {
      return appStorage.getItem("fcm_token");
    }

    var setFcmToken = function(token) {
      appStorage.setItem("fcm_token" ,token);
    }
   
   var setVideoUploaderDropdownState = function(data){
     appStorage.setItem("dropdown_status" ,JSON.stringify(data));
   };

    var setModule = function(data) {
      appStorage.setItem("mod_id" ,data);
    }; 

    var setFirstVisitStorageData = function(data) {      
      appStorage.setItem("firstVisit" ,data);
    };

    var clearStorage = function(){
      appStorage.clear();
    }

    var setFirstTimeStorageData = function(data) {
      appStorage.setItem("firstTime" ,data);
    };
    var setPhoneStorageData = function(data) {
      appStorage.setItem("phone" ,data);
    };
    var setUserInfoStorageData = function(data) {
      var prefix = urlCheck();
      if(data==false){
        appStorage.setItem(prefix+'Info', data);
      } else if(data==true) {
        appStorage.setItem(prefix+'Info', data);
      } else {
        appStorage.setItem(prefix+'Info', JSON.stringify(data));
      }
    };
    var setRememberMeData = function(data) {
      if(data==false){
        appStorage.setItem("remember_me",data);
      } else if(data==true) {
        appStorage.setItem("remember_me",data);
      } else {
        appStorage.setItem("remember_me",JSON.stringify(data));
      }
    };


    var setAuthTokenStorageData = function(data) {
      var prefix = urlCheck();
      appStorage.setItem(prefix+'AuthToken', data);
    };
    var setAppFreeAccessPopup = function(data) {
      appStorage.setItem("appFreeAccess",data);
    };
    var setUserSignedInStorageData = function(data) {
      appStorage.setItem("userSignedIn",data);
    };
    var setBlogerSignedInStorageData = function(data) {
      appStorage.setItem("blogerSignedIn",data);
    };
    var setSignedInStorageData = function(data) {
      appStorage.setItem("signedIn",data);
    };
    var setAdminSignedInStorageData = function(data) {
      appStorage.setItem("adminSignedIn",data);
    };
    var setInstructorSignedInStorageData = function(data) {
      appStorage.setItem("instructorSignedIn", data);
    };
    var setSocketIdStorageData = function(data) {
      appStorage.setItem("socketId", data);
    };
    var setCourseDeleteLogin = function(data) {
      appStorage.setItem("courseDeleteLogin", JSON.stringify(data));
    };
    var setOrderTerminateLogin = function(data) {
      appStorage.setItem("orderTerminateLogin", JSON.stringify(data));
    };
    var setTermStatus = function(data) {
      appStorage.setItem("term_status", data);
    }
    var setFaculty = function(data) {
      appStorage.setItem("faculty_id" ,data);
    }; 
    var getFaculty = function(data) {
      var data;
      data = appStorage.getItem("faculty_id");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var setInstitution = function(data) {
      appStorage.setItem("institution_id" ,data);
    }; 
    var getInstitution = function(data) {
      var data;
      data = appStorage.getItem("institution_id");
      if(data ==='true') {
        return true;
      }
      else if (data==='false') {
        return false;
      }
      else {
        return data;
      }
    };
    var getBrowserUserID = function(data) {
      var browserId = $cookies.get('browserUserId');
      return browserId
    }
    
    var logOutService = function(loggedout) {
      // setInstructorSignedInStorageData(false);
      setBlogerSignedInStorageData(false);
      // setUserSignedInStorageData(false);
      // setAdminSignedInStorageData(false);
      // setAuthTokenStorageData(false);
      // setUserInfoStorageData(false);
      setPhoneStorageData(false)
      setFaculty(false);
      setInstitution(false);
      if(loggedout == 'admin_logout'){
        localStorage.setItem("adminInfo", false);
        localStorage.setItem('adminAuthToken', false);
        localStorage.setItem("adminSignedIn",false);
        }
         if(loggedout == 'all'){
          // user_logout
          appStorage.setItem("userInfo",false);
          appStorage.setItem("userAuthToken",false);
          appStorage.setItem("userSignedIn",false);
        }
        if(loggedout == 'instructor_logout') {
          localStorage.setItem("instructorInfo", false);
          localStorage.setItem('instructorAuthToken', false);
          localStorage.setItem("instructorSignedIn", false);
        }
    };
    var SignInService = function(admin,user,instructor,bloger,tokenData,userData) {
      var admindata = localStorage.getItem("adminSignedIn");
      var userdata = localStorage.getItem("userSignedIn");
      var instructordata = localStorage.getItem("instructorSignedIn");
      setAppFreeAccessPopup(false);
     if(admindata){
      setAdminSignedInStorageData(true);
     }else{
      setAdminSignedInStorageData(admin);
     }
     if(userdata){
      setUserSignedInStorageData(true);
     }else{
      gtag("event", "login", {
        method: userData.provider
      });
      setUserSignedInStorageData(user);
     }
     if(instructordata){
      setInstructorSignedInStorageData(true);
     }else{
      setInstructorSignedInStorageData(instructor);
     }
      setBlogerSignedInStorageData(bloger);
      setAuthTokenStorageData(tokenData);
      setUserInfoStorageData(userData);
    }
    return {
      initilaizeappStorage:initilaizeappStorage,
      getLengthStorageData:getLengthStorageData,
      //setter return
      setFirstTimeStorageData:setFirstTimeStorageData,
      setFirstVisitStorageData:setFirstVisitStorageData,
      setUserInfoStorageData:setUserInfoStorageData,
      setRememberMeData:setRememberMeData,
      setAuthTokenStorageData:setAuthTokenStorageData,
      setUserSignedInStorageData:setUserSignedInStorageData,
      setBlogerSignedInStorageData:setBlogerSignedInStorageData,
      setSignedInStorageData:setSignedInStorageData,
      setAdminSignedInStorageData:setAdminSignedInStorageData,
      setInstructorSignedInStorageData:setInstructorSignedInStorageData,
      setSocketIdStorageData:setSocketIdStorageData,
      setModule:setModule,
      setPhoneStorageData:setPhoneStorageData,
      setVideoUploadingState:setVideoUploadingState,
      setVideoUploadingStateForLiveSession:setVideoUploadingStateForLiveSession,
      setVideoUploaderDropdownState:setVideoUploaderDropdownState,
      setCourseDeleteLogin: setCourseDeleteLogin,
      setOrderTerminateLogin: setOrderTerminateLogin,
      setTermStatus: setTermStatus,
      setFaculty: setFaculty,
      setInstitution: setInstitution,
      setAppFreeAccessPopup:setAppFreeAccessPopup,
      //getter return
      getFirstTimeStorageData:getFirstTimeStorageData,
      getFirstVisitStorageData:getFirstVisitStorageData,
      getUserInfoStorageData:getUserInfoStorageData,
      getRememberMeData:getRememberMeData,
      getAuthTokenStorageData:getAuthTokenStorageData,
      getUserSignedInStorageData:getUserSignedInStorageData,
      getBlogerSignedInStorageData:getBlogerSignedInStorageData,
      getSignedInStorageData:getSignedInStorageData,
      getAdminSignedInStorageData:getAdminSignedInStorageData,
      getInstructorSignedInStorageData:getInstructorSignedInStorageData,
      getSocketIdStorageData:getSocketIdStorageData,
      getPhoneStorageData:getPhoneStorageData,
      getModule:getModule,
      getVideoUploadingState:getVideoUploadingState,
      getVideoUploadingStateForLiveSession:getVideoUploadingStateForLiveSession,
      getVideoUploaderDropdownState:getVideoUploaderDropdownState,
      getCourseDeleteLogin: getCourseDeleteLogin,
      getOrderTerminateLogin: getOrderTerminateLogin,
      getTermStatus: getTermStatus,
      getFaculty: getFaculty,
      getInstitution:getInstitution,
      getAppFreeAccessPopup:getAppFreeAccessPopup,
      getStoryLinkFlag:getStoryLinkFlag,
      setStoryLinkFlag:setStoryLinkFlag,
      getReelLinkFlag:getReelLinkFlag,
      setReelLinkFlag:setReelLinkFlag,
      //log out service
      logOutService:logOutService,
      //login service
      SignInService:SignInService,
      clearStorage:clearStorage,
      // Blogs
      getBlogsComment:getBlogsComment,
      getBlogsReply:getBlogsReply,
      setBlogsComment:setBlogsComment,
      setBlogsReply:setBlogsReply,
      getFcmToken: getFcmToken,
      setFcmToken: setFcmToken,
      getBrowserUserID:getBrowserUserID,
    }
  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .service('BlogBackendServices', ['$rootScope','$http', '$state','$q', function($rootScope,$http, $state, $q) {

    var DisplayBlogCategories = function () {
      var blogdefer = $q.defer();
      $http({
        url: '/api/v1/blog/category/get',
        method : 'GET',
      }).then ( function (res) {
        blogdefer.resolve(res.data);
      });
      return blogdefer.promise;
    };
    var DisplayCategoryBlogs = function (id, page, limit) {
      if(!limit) limit = 9;
      var blogdefer = $q.defer();
      $http({
        url: '/api/v1/blog/category/' + id + '?page=' + page + '&limit=' + limit,
        method : 'GET'
      }).then ( function (res) {
        blogdefer.resolve(res.data);
      });
      return blogdefer.promise;
    };
    var DisplayAllBlogs = function (filters) {
      var blogdefer = $q.defer();
      $http({
        url: '/api/v1/blog/getDisplayBlog',
        method : 'GET',
        params : filters
      }).then ( function (res) {
        blogdefer.resolve(res.data);
      });
      return blogdefer.promise;
    };
    var DisplayCategoryAllBlogs = function (filters) {
      var blogdefer = $q.defer();
      $http({
        url: '/api/v1/blog/getDisplayCategoryBlog',
        method : 'GET',
        params : filters
      }).then ( function (res) {
        blogdefer.resolve(res.data);
      });
      return blogdefer.promise;
    };
    var blogFeatureOldPage = function () {
      var blogFeatureOldPage = $q.defer();
      $http({
        url: '/api/v1/blog/blogFeatureOldPage',
        method : 'GET'
      })
      .then ( function (res) {
        blogFeatureOldPage.resolve(res.data);
      });
      return blogFeatureOldPage.promise;

    };
    var EmailSubscribeBlog = function (subscribeEmail) {
      $http({
        url: '/api/v1/blog/SubscribeEmail',
        method : 'GET',
        params : {subscribeEmail:subscribeEmail}
      })
      .then ( function (res) {
        if(res.data.status){
          if(document.getElementById('subscribe_nearpeer') && document.getElementById('subscribe_nearpeer').value){
            document.getElementById('subscribe_nearpeer').value = '';
          }
          swal({
            title: "Subscribed!",
            text: "Successfully Subscribed",
            type: "success",
            confirmButtonText: "Ok"
          });
        }
      });

    };
    var sendBlogNotes = function (email,link,page_name) {
      $http({
        url: '/api/v1/blog/sendNotesLink',
        method : 'POST',
        data : {email:email,link:link,page_name:page_name}
      })
      .then ( function (res) {
        if(res.data.success){
          swal({
            title: "Download Your Free Digital Copy",
            text: "The link has been sent to your inbox!",
            type: "success",
            confirmButtonText: "Ok"
          });
        }
      });
    };
    var PageBlog = function( page , date,calltime,totalPages){
      var blogPagedefer = $q.defer();
      if(!totalPages){
        totalPages = 1;
      }
      if(page <  totalPages+1 && page > 0){
        var data = {
          page: page,
          date: date,
          calltime:calltime
        };
        var pageN0 =page;
        $http({
          url:'api/v1/blog/oldblog/getBlogsBypage',
          method: 'get',
          params: data
        }).then(function(res){
          res.data.page =pageN0;
          blogPagedefer.resolve(res.data);
        })
      }
      else {
      }
      return blogPagedefer.promise;
    }
    return {
      DisplayBlogCategories: DisplayBlogCategories,
      DisplayCategoryBlogs: DisplayCategoryBlogs,
      DisplayAllBlogs:DisplayAllBlogs,
      EmailSubscribeBlog:EmailSubscribeBlog,
      PageBlog:PageBlog,
      blogFeatureOldPage:blogFeatureOldPage,
      sendBlogNotes:sendBlogNotes,
      DisplayCategoryAllBlogs: DisplayCategoryAllBlogs,
    }
  }]);
})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('satVideoController', MainController);

  function MainController($scope, $timeout,$sce) {
    $scope.btnPlay = true;

    $scope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+src);
     
     
    }

    $scope.playVideo = function () {
      $scope.btnPlay = false;
      document.getElementById($scope.textid).play();
    }

    $scope.pauseVideo = function () {
      $scope.btnPlay = true;
      document.getElementById($scope.textid).pause();
      // var vid = document.getElementById($scope.textid);
    }

    $scope.$on('videoOnPause', function(event, message) {
      $scope.btnPlay = true;
    });
  
    $scope.showPauseBtn = function () {
      if ( $scope.btnPlay == true ) return;
      $scope.btnPlay == false;
      $scope.btnPause = true;
      $timeout(function () {
        $scope.btnPause = false;
      }, 3000);
    };

  }
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('SATController', MainController);

  function MainController($scope,landingService,CustomStorageService) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.isGuest = false;
    $scope.userData = CustomStorageService.getUserInfoStorageData();
        if($scope.userData.user_type === "guest" || $scope.userData.full_name === "Guest"){
          $scope.isGuest = true;
          }else{
          $scope.isGuest = false;
          
          
          }

    $scope.moveToDiv = function() {
      $('html, body').animate({
        scrollTop: $(".features-scroll").offset().top
      }, 1000);
    }

    $scope.satBuy = function() {
      landingService.buyBundle("SAT_FULL")
      .then(function(data) {
        if(data) {
          $scope.SatData = data;
          if($rootScope.orderEmailVerify && !$rootScope.orderEmailVerified) {
            $scope.$emit('verify-before-order');
          } else {
            $scope.$broadcast('salesPopup');
          }
        }
      });
    }
    $scope.videos = [{
      src: 'B7ilB_oM7Dk',
      id: 'video1',
      poster :'/images/sat-2-thumbnail-2.png'
    },{
      src: 'k-54FYXFdOw',
      id: 'video2',
      poster :'/images/sat-thumbnail-1.png'
    }];
    $scope.direction = 'left';
    $scope.currentIndex = 0;
    $scope.setCurrentSlideIndex = function (index) {
      $scope.direction = (index > $scope.currentIndex) ? 'left' : 'right';
      $scope.currentIndex = index;
    };
    $scope.isCurrentSlideIndex = function (index) {
      return $scope.currentIndex === index;
    };
    $scope.prevSlide = function () {
      $scope.direction = 'left';
      $scope.currentIndex = ($scope.currentIndex < $scope.videos.length - 1) ? ++$scope.currentIndex : 0;
    };
    $scope.nextSlide = function () {
      $scope.direction = 'right';
      $scope.currentIndex = ($scope.currentIndex > 0) ? --$scope.currentIndex : $scope.videos.length - 1;
    };
  }
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('resultController', ['$scope', '$anchorScroll','$state', '$http','CustomStorageService','$rootScope','$filter','courseDetailService', function($scope,$anchorScroll,$state,$http,CustomStorageService,$rootScope,$filter,courseDetailService) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.sortingoptions='-id';
    $scope.showData = false;
    $scope.ConvertText =  function(id,index) {
      setTimeout(function(){
        var MQ = MathQuill.getInterface(2);
        if(id==='mathquiz') {
          var fillInTheBlank = MQ.StaticMath(document.getElementById('mathquiz'));
          fillInTheBlank.latex($scope.solutionQuestion.mathtext);
        }
        else if(id==='mathquiz-options'){
          var fillInTheBlank = MQ.StaticMath(document.getElementById(id+index));
          fillInTheBlank.latex();
        }
      },100)
    }

    //
    // $scope.ConvertText =  function() {
    //   var MQ = MathQuill.getInterface(2);
    //   var fillInTheBlank = MQ.StaticMath(document.getElementById('mathquiz'));
    //   fillInTheBlank.latex($scope.solutionQuestion.mathtext);
    // }
    var getResult = function() {
      if($state.current.name == 'result'){
        var resultId = $state.params.resultId;
        $http({
          url: 'api/v1/quiz/createQuizReport',
          method: "GET",
          params: {userId: CustomStorageService.getUserInfoStorageData().id,resultId:resultId}
        }).then(function(data){
          if(data.data.success){
            $scope.showSolutionDiv = false;
            $scope.result = data.data.result;
            $scope.result.score = data.data.score;
            $scope.result.summary = data.data.summary;
            $scope.pieChartLabels = ["Right Answers", "Wrong Answers", "Unattempted Questions"];
            $scope.pieChartData = [$scope.result.summary.correctAnswers, $scope.result.summary.wrongAnswers, $scope.result.summary.unattemptedQuestions];
            $scope.pieChartColors = ['rgba(39,78,110,1)','rgba(155,224,198,1)','rgba(183,183,183,1)'];
            var percentage = ($scope.result.score.correct/$scope.result.score.total)*100;
            $scope.grade = $scope.getGrade(percentage);
            $scope.imageUrl = $scope.getImageUrl(percentage);
            $scope.result.scale = data.data.scale;
            $scope.result.levels = data.data.levels;
            $scope.lineChartLabels = [];
            for (var i in data.data.performance.dates){
              var date = new Date(data.data.performance.dates[i]);
              date = $filter('date')(date,'short');
              $scope.lineChartLabels.push(date);
            }
            $scope.lineChartLabels.reverse();
            $scope.lineChartData = [data.data.performance.scores];
            $scope.lineChartData.reverse();
            $scope.quizPastMarks = $scope.lineChartData[0];
            $scope.quizPastMarks.reverse();
            $scope.lineChartSeries = ['Marks']
            $scope.result.log = data.data.log;
            $scope.nextVideoData = data.data.nextVideoData;
            $scope.videoExists = data.data.nextVideoExists;
            $scope.rewatchVideos =[];
            // $scope.rewatchVideos = data.data.rewatchVideos;
            for(var i in data.data.rewatchVideos) {
              var boolFlag = false;
              if(data.data.rewatchVideos[i]!=null) {
                for(var j in $scope.rewatchVideos) {
                  if(data.data.rewatchVideos[i].id === $scope.rewatchVideos[j].id) {
                    boolFlag=true;
                  }
                  j++;
                }
              }
              if(boolFlag===false) {
                $scope.rewatchVideos.push(data.data.rewatchVideos[i]);
              }
              i++;
            }
            $scope.showCanvasDiv = false;
            $scope.nonzerotags = [];
            data.data.tags.data.forEach(function (element) {
              if(element>0) $scope.nonzerotags.push(element); 
            }); 
            if($scope.nonzerotags.length>4){
              $scope.showCanvasDiv = true;
              var x = document.getElementById('tagsBarChart');
              x.style.height = '400px';
              x.style.width = '2000px';
            }
            $scope.createBarChart(data.data.tags.data,data.data.tags.label,"tagsBarChart");
            if(!$scope.$$phase) $scope.$apply();
            $scope.showData = true;
            $scope.showSolution(0);
          }
        })
      } else {
        $http({
          url: 'api/v1/quiz/createCourseResultReport',
          method: "GET",
          params: {user_id: CustomStorageService.getUserInfoStorageData().id,course_id: $state.params.id}
        }).then(function(data){
          if(data.data.success){
            $scope.result = data.data.result;
            for(var i in $scope.result.performance.dates){
              var date = new Date($scope.result.performance.dates[i]);
              $scope.result.performance.dates[i] = $filter('date')(date,'short');
            }
            if(!data.data.noChapter){
              $scope.createRadarAllChart($scope.result.topicWiseStrengthAllData,$scope.result.topicWiseStrengthAllLabel);
              $scope.createBarChart($scope.result.topicWiseStrengthAllData,$scope.result.topicWiseStrengthAllLabel,"allTopicsBarChart");
              $scope.createRadarCoveredChart($scope.result.topicWiseStrengthCoveredData,$scope.result.topicWiseStrengthCoveredData);
            }
            $scope.avgAttemptedQuiz = $scope.getGrade($scope.result.avgAttemptedQuiz);
            $scope.avgTotalQuiz = $scope.getGrade($scope.result.avgTotalQuiz);
            $scope.course = data.data.course;
            $scope.showData = true;
          } else {
            swal({
              title: 'Information',
              text: 'You have not attempted any quiz for this course',
              type: 'info'
            },function(){
              $state.go('my-account');
            });
          }
        })
      }
    }

    $scope.initialize = function(){
      const loadingTime = Math.floor(Math.random() * Math.floor(60000));
      setTimeout(function() {
        getResult();
      }, loadingTime);
      
    }

    $scope.getMinutes = function(seconds){
      var m = Math.floor(seconds / 60) < 10 ? '0' + Math.floor(seconds / 60) : Math.floor(seconds / 60);
      var s = Math.floor(seconds - (m * 60)) < 10 ? '0' + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
      return m + ':' + s;
    }
    $scope.getGrade = function(percentage){
      if (percentage >= 90){
        return 'A*';
      } else if(percentage < 90 && percentage >= 80){
        return 'A';
      } else if(percentage < 80 && percentage >=70){
        return 'B';
      } else if(percentage < 70 && percentage >=60){
        return 'C';
      } else if(percentage < 60 && percentage >= 50){
        return 'D';
      } else if(percentage < 50 && percentage >= 40){
        return 'E';
      } else if(percentage < 40){
        return 'U';
      }
    }

    $scope.jumpToQuestion = function(){
      var qNo = document.getElementById('jump-to-question').value;
      if(qNo){
        qNo--;
        if(qNo <  $scope.result.score.total && qNo >= 0) {
          $scope.showSolution(qNo);
        }else{
          swal('Invalid Range!')
        }
      } 
    }

    $scope.showSolution = function(index){
      if(index <  $scope.result.score.total && index >= 0) {
      $scope.currentQNo = index + 1;
      $scope.solutionQuestion = $scope.result.questions[index];
      angular.forEach($scope.solutionQuestion.options, function(option, key) {
        $scope.mathCreator('math-field-opt'+key,option.text);
      });
      var data = $scope.solutionQuestion.solution;
      $scope.mathCreator('math-field-sol',data);
      var mData = $scope.solutionQuestion.mathtext;
      $scope.mathCreator('math-field-question',mData);
      $scope.showSolutionDiv = true;
      $scope.ConvertText('mathquiz',0);
      $anchorScroll('showSolution-new');
      }
    }

    $scope.showQuestions = function(){
      $scope.showSolutionDiv = false;
    }

    $scope.createRadarAllChart = function(data,label){
      var ctx = document.getElementById("allTopicsRadarChart");
      var myChart = new Chart(ctx, {
        type: 'radar',
        data: {
          labels: label,
          datasets: [{
            label: 'Strength',
            backgroundColor: "rgba(153,255,51,0.4)",
            borderColor: "rgba(153,255,51,1)",
            data: data
          }]
        }
      });
    }

    $scope.createRadarCoveredChart = function(data,label){
      if(data.length > 0 && label.length > 0){
        var ctx = document.getElementById("coveredTopicsRadarChart");
        var myChart = new Chart(ctx, {
          type: 'radar',
          data: {
            labels: label,
            datasets: [{
              label: 'Strength',
              backgroundColor: "rgba(153,255,51,0.4)",
              borderColor: "rgba(153,255,51,1)",
              data: data
            }]
          }
        });
      }
    }
    $scope.createBarChart = function(data,label,id){
      var ctx = document.getElementById(id).getContext('2d');
      var myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: label,
          datasets: [{
            label: '',
            data: data,
            backgroundColor: [
              'rgba(0, 141, 0, 1)',
              'rgba(178, 255, 0, 0.7)',
              'rgba(0, 255, 0, 1)',
              'rgba(178, 255, 0, 0.7)',
              'rgba(255, 91, 33, 0.7)',
              'rgba(255, 91, 33, 0.7)',
              'rgba(163, 255, 95, 0.7)'
            ],
            borderColor: [
              'rgba(255,99,132,1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          legend: {
            position: 'bottom',
          },
          hover: {
            mode: 'label'
          },
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                beginAtZero: true,
                steps: 10,
                stepValue: 5,
                max: 100
              }
            }],
            xAxes: [{
            barPercentage: $scope.showCanvasDiv ? 0.8 : 0.4
          }]
          }
        }
      });
    }
    $scope.goToNextVideo = function(){
      var params = $scope.nextVideoData['index_url'].split('/');
      if($scope.videoExists){
        if($scope.nextVideoData['chapter_no']){
          $state.go('video_player_chapter',{institutionName:params[0],schoolName:params[1],courseName:params[2],moduleNo:$scope.nextVideoData['module_no'],chapterNo:$scope.nextVideoData['chapter_no'],video_no:$scope.nextVideoData['video_no']},{reload:true});
        }else{
          $state.go('video_player',{institutionName:params[0],schoolName:params[1],courseName:params[2],moduleNo:$scope.nextVideoData['module_no'],video_no:$scope.nextVideoData['video_no']},{reload:true});
        }
      } else {
        $state.go('course_module',{institutionName:params[0],schoolName:params[1],courseName:params[2],moduleNo:$scope.nextVideoData['module_no']},{reload:true});
      }
    }

    $scope.showVideo = function(video){
      var params = $scope.nextVideoData['index_url'].split('/');
      if($scope.nextVideoData['chapter_no']){
        $state.go('video_player_chapter',{institutionName:params[0],schoolName:params[1],courseName:params[2],moduleNo:$scope.nextVideoData['module_no'],chapterNo:$scope.nextVideoData['chapter_no'],video_no:video.video_no},{reload:true});
      }else{
        $state.go('video_player',{institutionName:params[0],schoolName:params[1],courseName:params[2],moduleNo:$scope.nextVideoData['module_no'],video_no:video.video_no},{reload:true});
      }
    }

    $scope.goToCourse = function(){
      courseDetailService.goToCourse($scope.course[0]);
    }

    $scope.goToQuizResult = function(id){
      $state.go('result',{resultId:id});
    }

    $scope.mathCreator =  function(id,data) {
			setTimeout(function(){
        var mathFieldSpan = document.getElementById(id);
        mathFieldSpan.textContent="";
        if(data){
          if(data!=='' && data!=='null'){
            if(data.includes('text{')){
              if(!data.match(/\\\s/g)) {
                data =data.replace(/\s+/g,'\ ');
              }
            }else{
              if(!data.match(/\\\s/g)) {
                data =data.replace(/\s+/g,'\\ ');
              }
            }
            var MQ = MathQuill.getInterface(2);
            var mathField = MQ.MathField(mathFieldSpan, {
              spaceBehavesLikeTab: false,
              handlers: {
                edit: function() {
                  data=mathField.latex();
                }
              }
            });
            mathField.write(data);
          }
        }   
      },100)
    }

    $scope.getNumberList = function(list){
      var str = '';
      for(var i in list){
        if(i == list.length-1){
          str = str + list[i];
        } else {
          str = str + list[i] + ','
        }
      }
      return str;
    }

    $scope.getVideoList = function(list){
      var str = '';
      for(var i in list){
        if(list[i]){
          var str2 = list[i].name.split('.mp4');
          if(i == list.length-1){
            str = str + str2[0];
          } else {
            str = str + str2[0] + ','
          }
        }
      }
      return str;
    }

    $scope.getImageUrl = function(percentage){
      if (percentage >= 75){
        return '/images/80perc.png';
      } else if(percentage < 75 && percentage >= 50){
        return '/images/60perc.png';
      } else if(percentage < 50){
        return '/images/40perc.png';
      }
    }

    if(!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()){
      swal('Oops..','Please login to continue','error');
      $state.go('Landing');
    }
    else{
      $scope.initialize();
    }
  }]);
})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .controller('paymentStatusController', MainController);

    function MainController($state, $scope, env) {
        $scope.status = $state.params.status;
        
        $scope.gotoCourse = function() {
            window.open(env.velocityPortal, '_self')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NearPeer')
        .controller('passwordResetController',MainController);

        function MainController($scope,$http,$state) {
            var email = $state.params.email;
            var token = $state.params.token;
          $scope.initialize = function(){
            
            $http({
              url: '/api/v1/users/verifyPasswordResetToken',
              method: "GET",
              params: {email: email,token:token}
            }).then(function(data){
              if(data.data.success){
                $scope.showData = true;
              } else {
                swal({
                  title: 'Invalid URL',
                  text: 'This link is invalid now. Please request for a new password reset url',
                  type:'info',
                },function(){
                  $state.go('Landing');
                });
              }
            })
          }

          $scope.initialize();

          $scope.updatePassword = function(){
              if(!$scope.updatePasswordForm.password || !$scope.updatePasswordForm.password_confirmation){
                  swal({
                      title: "Error",
                      text: "Required fields are empty",
                      type:"error"
                  });
                  return;
              }

              if($scope.updatePasswordForm.password != $scope.updatePasswordForm.password_confirmation){
                   swal({
                      title:"Error",
                      text: "Passwords do not match",
                      type: "error"
                  });
                  return;
              }
              if($scope.updatePasswordForm.password.length <8){
                  swal({
                      title:"Error",
                      text: "Password needs to be at least 8 characters",
                      type: "error"
                  });
                  return;
              }

              var params = {
                  password: $scope.updatePasswordForm.password,
                  password_confirmation: $scope.updatePasswordForm.password_confirmation,
                  email: email,
                  token: token,
              }

             $http.post('api/v1/users/updatePassword', params)
              .then(function(resp) {

                  swal({
                      title:"Success",
                      text: "Password successfully changed",
                      type: "success",
                      timer: 2000,
                      showConfirmButton: false
                  },function(){
                    swal.close();
                    $state.go('Landing');
                  })
              })
              .catch(function(resp) {
                  swal({
                      title:"Error",
                      text: "Could not update password. Please try again.",
                      type: "error"
                  })
              });
          }

         };
})();

(function() {
    'use strict';

    angular
        .module('NearPeer')
        .controller('dummyController', ['$state', function($state) {
          $state.go('Landing');
         }]);
})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('closeController', MainController);

  function MainController($state, $location) {
    var params = $location.search();
    if (params.merchant_order_id.includes('MULTI')) {
      $state.go('PaymentStatus', { status: params.success });
    } else {
      window.close();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('NearPeer')
        .controller('UserConfirmedController', ['$scope', '$state','$http','CustomStorageService', function($scope, $state,$http,CustomStorageService) {

          $scope.initilaize = function(){
            var email = $state.params.email;
            var token = $state.params.token;
            $http.post('/api/v1/users/confirmUser',{email: email,confirmation_token: token})
            .then(function(data){
              if(data.data.success){
                swal({
                  title: 'Success',
                  text: data.data.msg,
                  type: 'success'
                },function(){
                  var updatedUser = CustomStorageService.getUserInfoStorageData();
                  updatedUser.confirmed_at = true;
                  CustomStorageService.setUserInfoStorageData(updatedUser);
                  $state.go('Landing');
                })
              } else {
                swal({
                  title: 'Error',
                  text: data.data.msg,
                  type: 'error'
                },function(){
                  $state.go('Landing');
                })
              }
            })
          }

          $scope.initilaize();

         }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('RegistrationController', ['$scope', 'Upload', '$state','$http','$rootScope', function($scope, Upload, $state,$http,$rootScope) {

    $(document).ready(function(){
      $(this).scrollTop(0);
    });

    $scope.resetPassword = function(form){
      $scope.requestSent = true;
      if(!form.email || !form.email.includes('@')){
        swal({
          title: "Error",
          text: "Please enter a valid email address",
          type: "error"
        },function(){
          $scope.requestSent = false;
        });
        return;
      }

      $scope.loader = true;
      $scope.buttonColor = 'background-color: grey';

      var data = {email: form.email,origin_url: location.protocol+'//'+location.host};

      $http.post('/api/v1/users/requestPasswordReset',data)
      .then(function(resp) {
        if(!resp.data.success){
          $scope.loader = false;
          $scope.requestSent = false;
          $scope.buttonColor = 'background-color: #9be0c6';
          swal('Error',resp.data.msg,'error');
        } else {
          $scope.loader = false;
          $scope.requestSent = false;
          swal({
            title:"Success",
            text: "A link to reset your password has been emailed to you.",
            type: "success",
            timer: 2000,
            showConfirmButton: false
          },function(){
            swal.close();
            $state.go('Landing',{},{reload:true});
          })
        }
      })
      .catch(function(resp) {
        $scope.loader = false;
        $scope.requestSent = false;
        $scope.buttonColor = 'background-color: #9be0c6';
        swal({
          title:"Error",
          text: "Email does not exist",
          type: "error"
        },function(){
        })
      });
    }

  }]);

})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("redirectLinkCheckController", [
    "$scope", "$http", "$state", "$rootScope", "CustomStorageService", "HttpService",
    function (
      $scope, $http, $state, $rootScope, CustomStorageService, HttpService
    ) {
      var link_id = $state.params.link_id;
      var checkLink = function() {
        HttpService.getRequest("api/v1/redirect-link/get-redirect-link/" + link_id, {}).then(
          function (res) {
            if(res && res.success && res.result.redirect_link) {
              var link = res.result.redirect_link;
              if(!link.startsWith("http://") && !link.startsWith("https://")){
                link = 'https://' + link
              }
              console.log('link')
              console.log(link)
              window.location.href = link
            } else {
              window.location.href = "/landing"
            }
          }
        );
      }
      checkLink();
    },
  ]);
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('quizController', ['$scope', 'Upload', '$state','$http','CustomStorageService','$filter', function($scope, Upload, $state,$http,CustomStorageService,$filter) {
    var Origionalhours,Origionalminutes,Origionalseconds;
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    var totalPages;
    var initialFlag=0;
    var questions={};
    var questionTime=[];
    var temp_timer;
    $scope.sortingoptions='-id';
    $scope.ConvertText =  function(id) {
      setTimeout(function(){
        var MQ = MathQuill.getInterface(2);
        MQ.StaticMath(document.getElementById(id));
      },100)
    }
    $scope.bulletsArray = function(index) {
      return String.fromCharCode(65+index);
    }
    $scope.jumpToQuestion = function(){
      var qNo = document.getElementById('jump-to-question').value;
      if(qNo){
        qNo--;
        if(qNo <  totalPages && qNo >= 0) {
          $scope.questionCard(qNo);
        }else{
          swal('Invalid Range!')
        }
      } 
    }
    $scope.selectOptions = function(index,questionIndex) {
      var i=0;
      if($scope.content) {
        i=  questionIndex;
      }
      $scope.quizData.questions[i].choosenAnswer=$scope.quizData.questions[i].options[index].id;
    }
    $scope.checkOption = function (answer,index,questionIndex) {
      var i=0;
      if($scope.content) {
        i=  questionIndex;
      }
      if(answer===$scope.quizData.questions[i].options[index].id) {
        return true;
      }
      else {
        return false;
      }
    }
    $scope.questionCard = function(page) {
      if(page <  totalPages && page >= 0) {
        initialFlag++;
        $scope.page = page;
        var obj=[];
        obj.push(questions[page]);
        $scope.quizData.questions=obj;
        $scope.individualTimer(page);
      }
    }
    $scope.initialize = function(){
      $scope.showData = false;
      $scope.quizStarted = false;
      $scope.hideStartButton = true;
      var quiz_id = $state.params.quiz_id;
      $http({
        url:'api/v1/quiz/getQuizFp',
        method: "GET",
        params: {quiz_id: quiz_id}
      }).then(function(data){
        data.data.quiz.questions = $filter('orderBy')(data.data.quiz.questions, 'id/-1',true);
        for(var i in data.data.quiz.questions){

          data.data.quiz.questions[i].options = $filter('orderBy')(data.data.quiz.questions[i].options, 'id/-1',true);
        }
        if(data.data.success){
          if(data.data.quiz.duration==null) {
            $scope.endtime=0;
            $scope.timerFlag=false;
          } else {
            $scope.timerFlag=true;
            Origionalhours = Math.floor((data.data.quiz.duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            Origionalminutes = Math.floor((data.data.quiz.duration % (1000 * 60 * 60)) / (1000 * 60));
            Origionalseconds = Math.floor((data.data.quiz.duration % (1000 * 60)) / 1000);
            var h = Origionalhours<=10 ? '0' + Origionalhours : Origionalhours;
            var m = Origionalminutes<=10 ? '0' + Origionalminutes : Origionalminutes;
            var s = Origionalseconds<=10 ? '0' +Origionalseconds : Origionalseconds;
            $scope.totalTime = h+':'+m+':'+s;
            $scope.endtime = ((Origionalhours*60* 60) + (Origionalminutes*60) + (Origionalseconds));
          }
          temp_timer=0;
          totalPages=data.data.quiz.questions.length;
          $scope.quizData = data.data.quiz;
          $scope.showData = true;
          $scope.hideStartButton = false;
          questions=data.data.quiz.questions;
          $scope.page = 0;
          $scope.maxPage = questions.length;
          if(data.data.quiz.content) {
            $scope.content = data.data.quiz.content;
            document.getElementById('dualQuizId').className = 'dual-quiz-cont';
            var bodyClass = document.getElementById('mainBody');
            bodyClass.classList.add("dual-quiz-scroll");
            var quizClass = document.getElementById("quizDual");
            quizClass.classList.add("quizes-scroller");
          }
          else {
            $scope.questionCard($scope.page);
          }
        }
      }).catch(function (err) {
          swal({
              title: "Oops..",
              text: "Please purchase Module/Course!",
              type: "error",
              closeOnConfirm: true
          }, function(isConfirm) {
              $state.go('Landing');
          });
      });
    }
    $scope.individualTimer = function(index) {
      index=index-1;
      if(initialFlag>1) {
        $scope.stopTimer();
        if(questionTime[index]===undefined) {
          questionTime.push(($scope.timerr-temp_timer));
        }
        else {
          questionTime[index]=((questionTime[index])+($scope.timerr-temp_timer));
        }
        temp_timer=$scope.timerr;
        if(initialFlag !=123456789)
        $scope.$broadcast('timer-resume');
      }
    }
    $scope.checkClass = function(index) {
      if(index % 2 == 1){
        return 'quiz-bg';
      } else {
        return false;
      }
    }
    $scope.finished = function() {
      $scope.stopTimer();
      $scope.submitAnswers($scope.quizData);
    }
    $scope.startQuiz = function(){
      $scope.quizStarted = true;
      $scope.hideStartButton = true;
      $scope.$broadcast('timer-start');
    }
    $scope.submitAlert = function(quiz) {
      if(!$scope.content) {
        initialFlag=123456789;
        $scope.individualTimer($scope.page+1);
      }
      $scope.stopTimer();
      swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, submit it!",
        closeOnConfirm: true},
        function(isConfirm){
          if(isConfirm) {
            $scope.submitAnswers (quiz);
          }
          else {
            initialFlag=4;
            $scope.$broadcast('timer-resume');
          }
        });
      }
      $scope.submitAnswers = function(quiz){
        $scope.showData = false;
        if(!$scope.$$phase) $scope.$apply();
        var counter = 0;
        var attemptedTime = $scope.timerr;
        var data = [];
        for(var i in questions){
          var data2 = {};
          data2['question_id'] = questions[i].id;
          data2['answer_time'] = questionTime[i];
          if(questions[i].choosenAnswer){
            counter++;
          }
          data2['answer_id'] = questions[i].choosenAnswer;
          data.push(data2);
        }
        $http.post('api/v1/quiz/submitQuiz',{data:data,userId: CustomStorageService.getUserInfoStorageData().id,timer:attemptedTime,quizId: quiz.id,attempted:counter})
        .then(function(data){
          $state.go('result',{resultId:data.data.resultId},{reload:true})
        })
      }
      $scope.$on('$stateChangeStart', function (event) {
        var bodyClass = document.getElementById('mainBody');
        bodyClass.classList.remove("dual-quiz-scroll");
      });
      $scope.stopTimer = function (){
        $scope.$broadcast('timer-stop');
        $scope.timerRunning = false;
      };
      $scope.$on('timer-stopped', function (event, data){
        $scope.timerr = (data.hours * 3600) + (data.minutes * 60) + (data.seconds);
      });
      if(!CustomStorageService.getUserSignedInStorageData() && ! CustomStorageService.getInstructorSignedInStorageData()){
        swal('Oops..','Please login to continue','error');
        $scope.$emit('showLoginPopup');
      }
      else{
        $scope.initialize();
      }
    }]);
  })();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('QistPayController',MainController);

  function MainController($scope,$http,$state,CustomStorageService, $location) {
    document.title = "Nearpeer | One Stop Destination For Online Learning In Pakistan";
    $scope.initialize = function () {
      var queryParams = $location.search();
      console.log('queryParams');
      console.log(queryParams);
      if(queryParams.success === 'true') {
        $http({
          method: 'GET',
          url: '/api/v1/order/get-order-status',
          params: {
            orderId: queryParams.merchant_order_id
          }
        })
        .then(function(res) {
          console.log('res');
          console.log(res);
          window.close();
        },function errorCallback(error) {
          console.log('error');
          console.log(error);
        })
      }
    }();
  };
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("ProfileSettingsController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $base64,
    $timeout,
    $state,
    BlogBackendServices,
    CustomStorageService,
    HttpService,
    $location,
    env,
    $cookies,
    toaster
  ) {
    $scope.fullscreenImg = false;
    $scope.emailSubscriptionUpdated = false;
    $scope.updateSubscriptions = true;
    $scope.transferAccount = false;
    $scope.changePassword = false;
    $scope.phoneSelected = false;
    $scope.emailSelected = false;
    $scope.responsive = false;
    $scope.sidebar = false;
    $scope.phoneEdit = false;
    $scope.emailEdit = false;
    $scope.nameEdit = false;
    $scope.uniEdit = false;
    $scope.dobEdit = false;
    $scope.genderEdit = false;
    $scope.cityEdit = false;
    $scope.logoutfromalldevice = false;
    $scope.enterotp = false;
    $scope.userDataObj;
    $scope.showData = false;
    $scope.stateName = $state.current.name;
    $scope.reqCount = 0;
    $scope.reqCount2 = 0;
    $scope.reqCount3 = 0;
    $scope.value = 1;
    $scope.showRequestVideo = false;
    $scope.switchToggle = true;
    $scope.userId = CustomStorageService.getUserInfoStorageData().id;
    $scope.lmsPopup = false;
    $scope.videoUrl = "";
    $scope.lmsPopupCount = 0;
    $scope.ordersLoaded = false;
    $scope.quizzesLoaded = false;
    $scope.videosLoaded = false;
    $scope.quizStats = [];
    $scope.userOrders = [];
    $scope.quizzes = [];
    $scope.passwordObj = {
      old_password: "",
      new_password: "",
      confirm_password: "",
    };
    $scope.dobUser = {
      userDay: "",
      userMonth: "",
      userYear: "",
    };
    $scope.showEditPassword = false;
    $scope.otherCity = "";
    $scope.otherCityDefault = "";
    $scope.otherUni = "";
    $scope.otherUniDefault = "";
    $scope.defaultField = true;
    $scope.emailSubscriptionList = [
      // "Account created",
      // "Account confirmation",
      {
        name: "Instructor Message",
        description: "Get updates of your comments from instructors.",
      },
      {
        name: "Blogs Subscription",
        description: "Get daily updates about our latest blogs.",
      },
      {
        name: "System Default Emails",
        description: "Get all the important updates from admin. ",
      },
      // "Verification Code",
      // "Admin message",
      // "Course access",
      // "Course deletion",
      // "Order expiry",
      // "Otp verification",
      // "Reset password",
      // "User comment",
      // "Video upload",
    ];
    $scope.userAccounts;
    $scope.userSessions;
    $scope.userToken;
    $scope.selectedSession;
    $scope.removeAllSession;
    $scope.imageLoad = false;
    var fieldName;
    $scope.phoneUpdated = false;
    $scope.emailUpdated = false;
    $scope.totalPaidAmount = "0";
    // $rootScope.guest = false;
    $scope.stopQuizzes = false;
    $scope.stopVideos = false;
    $scope.settingType = {
      profileInfo: false,
      contantInfo: false,
      activeDevices: false,
      yourAccount: false,
      emailSubscription: false,
      myOrder: false,
      transactions: false,
      quizzes: false,
      videosWatched: false,
      changePassword: false,
      // nameEdit:false,
      // dobEdit: false,
      // genderEdit: false,
      // cityEdit: false,
      emailVerify: false,
    };
    $scope.customCity = "";
    $scope.customUni = "";
    $scope.newGuest = false;
    $scope.watchedVideos = [];
    $scope.videoStats;
    var userId;
    $scope.toasterField = "";
    $scope.searchParams = {
      type: "user",
      page: 1,
      per_page: 10,
      userId: CustomStorageService.getUserInfoStorageData().id,
    };
    $scope.itemArray;
    $scope.uniArray;
    $scope.baseCities = [
      { id: 1, name: "Abbottabad" },
      { id: 2, name: "Adezai" },
      { id: 3, name: "Ali Bandar" },
      { id: 4, name: "Amir Chah" },
      { id: 5, name: "Attock" },
      { id: 6, name: "Ayubia" },
      { id: 7, name: "Bahawalpur" },
      { id: 8, name: "Baden" },
      { id: 9, name: "Bagh" },
      { id: 10, name: "Bahawalnagar" },
      { id: 11, name: "Burewala" },
      { id: 12, name: "Banda Daud Shah" },
      { id: 13, name: "Bannu district|Bannu" },
      { id: 14, name: "Batagram" },
      { id: 15, name: "Bazdar" },
      { id: 16, name: "Bela" },
      { id: 17, name: "Bellpat" },
      { id: 18, name: "Bhag" },
      { id: 19, name: "Bhakkar" },
      { id: 20, name: "Bhalwal" },
      { id: 21, name: "Bhimber" },
      { id: 22, name: "Birote" },
      { id: 23, name: "Buner" },
      { id: 24, name: "Burj" },
      { id: 25, name: "Chiniot" },
      { id: 26, name: "Chachro" },
      { id: 27, name: "Chagai" },
      { id: 28, name: "Chah Sandan" },
      { id: 29, name: "Chailianwala" },
      { id: 30, name: "Chakdara" },
      { id: 31, name: "Chakku" },
      { id: 32, name: "Chakwal" },
      { id: 33, name: "Chaman" },
      { id: 34, name: "Charsadda" },
      { id: 35, name: "Chhatr" },
      { id: 36, name: "Chichawatni" },
      { id: 37, name: "Chitral" },
      { id: 38, name: "Dadu" },
      { id: 39, name: "Dera Ghazi Khan" },
      { id: 40, name: "Dera Ismail Khan" },
      { id: 41, name: "Dalbandin" },
      { id: 42, name: "Dargai" },
      { id: 43, name: "Darya Khan" },
      { id: 44, name: "Daska" },
      { id: 45, name: "Dera Bugti" },
      { id: 46, name: "Dhana Sar" },
      { id: 47, name: "Digri" },
      { id: 48, name: "Dina City|Dina" },
      { id: 49, name: "Dinga" },
      { id: 50, name: "Pakistan|Diplo" },
      { id: 51, name: "Diwana" },
      { id: 52, name: "Dokri" },
      { id: 53, name: "Drosh" },
      { id: 54, name: "Duki" },
      { id: 55, name: "Dushi" },
      { id: 56, name: "Duzab" },
      { id: 57, name: "Faisalabad" },
      { id: 58, name: "Fateh Jang" },
      { id: 59, name: "Ghotki" },
      { id: 60, name: "Gwadar" },
      { id: 61, name: "Gujranwala" },
      { id: 62, name: "Gujrat" },
      { id: 63, name: "Gadra" },
      { id: 64, name: "Gajar" },
      { id: 65, name: "Gandava" },
      { id: 66, name: "Garhi Khairo" },
      { id: 67, name: "Garruck" },
      { id: 68, name: "Ghakhar Mandi" },
      { id: 69, name: "Ghanian" },
      { id: 70, name: "Ghauspur" },
      { id: 71, name: "Ghazluna" },
      { id: 72, name: "Girdan" },
      { id: 73, name: "Gulistan" },
      { id: 74, name: "Gwash" },
      { id: 75, name: "Hyderabad" },
      { id: 76, name: "Hala" },
      { id: 77, name: "Haripur" },
      { id: 78, name: "Hab Chauki" },
      { id: 79, name: "Hafizabad" },
      { id: 80, name: "Hameedabad" },
      { id: 81, name: "Hangu" },
      { id: 82, name: "Harnai" },
      { id: 83, name: "Hasilpur" },
      { id: 84, name: "Haveli Lakha" },
      { id: 85, name: "Hinglaj" },
      { id: 86, name: "Hoshab" },
      { id: 87, name: "Islamabad" },
      { id: 88, name: "Islamkot" },
      { id: 89, name: "Ispikan" },
      { id: 90, name: "Jacobabad" },
      { id: 91, name: "Jamshoro" },
      { id: 92, name: "Jhang" },
      { id: 93, name: "Jhelum" },
      { id: 94, name: "Jamesabad" },
      { id: 95, name: "Jampur" },
      { id: 96, name: "Janghar" },
      { id: 97, name: "Jati(Mughalbhin)" },
      { id: 98, name: "Jauharabad" },
      { id: 99, name: "Jhal" },
      { id: 100, name: "Jhal Jhao" },
      { id: 101, name: "Jhatpat" },
      { id: 102, name: "Jhudo" },
      { id: 103, name: "Jiwani" },
      { id: 104, name: "Jungshahi" },
      { id: 105, name: "Karachi" },
      { id: 106, name: "Kotri" },
      { id: 107, name: "Kalam" },
      { id: 108, name: "Kalandi" },
      { id: 109, name: "Kalat" },
      { id: 110, name: "Kamalia" },
      { id: 111, name: "Kamararod" },
      { id: 112, name: "Kamber" },
      { id: 113, name: "Kamokey" },
      { id: 114, name: "Kanak" },
      { id: 115, name: "Kandi" },
      { id: 116, name: "Kandiaro" },
      { id: 117, name: "Kanpur" },
      { id: 118, name: "Kapip" },
      { id: 119, name: "Kappar" },
      { id: 120, name: "Karak City" },
      { id: 121, name: "Karodi" },
      { id: 122, name: "Kashmor" },
      { id: 123, name: "Kasur" },
      { id: 124, name: "Katuri" },
      { id: 125, name: "Keti Bandar" },
      { id: 126, name: "Khairpur" },
      { id: 127, name: "Khanaspur" },
      { id: 128, name: "Khanewal" },
      { id: 129, name: "Kharan" },
      { id: 130, name: "kharian" },
      { id: 131, name: "Khokhropur" },
      { id: 132, name: "Khora" },
      { id: 133, name: "Khushab" },
      { id: 134, name: "Khuzdar" },
      { id: 135, name: "Kikki" },
      { id: 136, name: "Klupro" },
      { id: 137, name: "Kohan" },
      { id: 138, name: "Kohat" },
      { id: 139, name: "Kohistan" },
      { id: 140, name: "Kohlu" },
      { id: 141, name: "Korak" },
      { id: 142, name: "Korangi" },
      { id: 143, name: "Kot Sarae" },
      { id: 144, name: "Kotli" },
      { id: 145, name: "Lahore" },
      { id: 146, name: "Larkana" },
      { id: 147, name: "Lahri" },
      { id: 148, name: "Lakki Marwat" },
      { id: 149, name: "Lasbela" },
      { id: 150, name: "Latamber" },
      { id: 151, name: "Layyah" },
      { id: 152, name: "Leiah" },
      { id: 153, name: "Liari" },
      { id: 154, name: "Lodhran" },
      { id: 155, name: "Loralai" },
      { id: 156, name: "Lower Dir" },
      { id: 157, name: "Shadan Lund" },
      { id: 158, name: "Multan" },
      { id: 159, name: "Mandi Bahauddin" },
      { id: 160, name: "Mansehra" },
      { id: 161, name: "Mian Chanu" },
      { id: 162, name: "Mirpur" },
      { id: 163, name: "}, Pakistan|Moro" },
      { id: 164, name: "Mardan" },
      { id: 165, name: "Mach" },
      { id: 166, name: "Madyan" },
      { id: 167, name: "Malakand" },
      { id: 168, name: "Mand" },
      { id: 169, name: "Manguchar" },
      { id: 170, name: "Mashki Chah" },
      { id: 171, name: "Maslti" },
      { id: 172, name: "Mastuj" },
      { id: 173, name: "Mastung" },
      { id: 174, name: "Mathi" },
      { id: 175, name: "Matiari" },
      { id: 176, name: "Mehar" },
      { id: 177, name: "Mekhtar" },
      { id: 178, name: "Merui" },
      { id: 179, name: "Mianwali" },
      { id: 180, name: "Mianez" },
      { id: 181, name: "Mirpur Batoro" },
      { id: 182, name: "Mirpur Khas" },
      { id: 183, name: "Mirpur Sakro" },
      { id: 184, name: "Mithi" },
      { id: 185, name: "Mongora" },
      { id: 186, name: "Murgha Kibzai" },
      { id: 187, name: "Muridke" },
      { id: 188, name: "Musa Khel Bazar" },
      { id: 189, name: "Muzaffar Garh" },
      { id: 190, name: "Muzaffarabad" },
      { id: 191, name: "Nawabshah" },
      { id: 192, name: "Nazimabad" },
      { id: 193, name: "Nowshera" },
      { id: 194, name: "Nagar Parkar" },
      { id: 195, name: "Nagha Kalat" },
      { id: 196, name: "Nal" },
      { id: 197, name: "Naokot" },
      { id: 198, name: "Nasirabad" },
      { id: 199, name: "Nauroz Kalat" },
      { id: 200, name: "Naushara" },
      { id: 201, name: "Nur Gamma" },
      { id: 202, name: "Nushki" },
      { id: 203, name: "Nuttal" },
      { id: 204, name: "Okara" },
      { id: 205, name: "Ormara" },
      { id: 206, name: "Peshawar" },
      { id: 207, name: "Panjgur" },
      { id: 208, name: "Pasni City" },
      { id: 209, name: "Paharpur" },
      { id: 210, name: "Palantuk" },
      { id: 211, name: "Pendoo" },
      { id: 212, name: "Piharak" },
      { id: 213, name: "Pirmahal" },
      { id: 214, name: "Pishin" },
      { id: 215, name: "Plandri" },
      { id: 216, name: "Pokran" },
      { id: 217, name: "Pounch" },
      { id: 218, name: "Quetta" },
      { id: 219, name: "Qambar" },
      { id: 220, name: "Qamruddin Karez" },
      { id: 221, name: "Qazi Ahmad" },
      { id: 222, name: "Qila Abdullah" },
      { id: 223, name: "Qila Ladgasht" },
      { id: 224, name: "Qila Safed" },
      { id: 225, name: "Qila Saifullah" },
      { id: 226, name: "Rawalpindi" },
      { id: 227, name: "Rabwah" },
      { id: 228, name: "Rahim Yar Khan" },
      { id: 229, name: "Rajan Pur" },
      { id: 230, name: "Rakhni" },
      { id: 231, name: "Ranipur" },
      { id: 232, name: "Ratodero" },
      { id: 233, name: "Rawalakot" },
      { id: 234, name: "Renala Khurd" },
      { id: 235, name: "Robat Thana" },
      { id: 236, name: "Rodkhan" },
      { id: 237, name: "Rohri" },
      { id: 238, name: "Sialkot" },
      { id: 239, name: "Sadiqabad" },
      { id: 240, name: "Safdar Abad- (Dhaban Singh)" },
      { id: 241, name: "Sahiwal" },
      { id: 242, name: "Saidu Sharif" },
      { id: 243, name: "Saindak" },
      { id: 244, name: "Sakrand" },
      { id: 245, name: "Sanjawi" },
      { id: 246, name: "Sargodha" },
      { id: 247, name: "Saruna" },
      { id: 248, name: "Shabaz Kalat" },
      { id: 249, name: "Shadadkhot" },
      { id: 250, name: "Shahbandar" },
      { id: 251, name: "Shahpur" },
      { id: 252, name: "Shahpur Chakar" },
      { id: 253, name: "Shakargarh" },
      { id: 254, name: "Shangla" },
      { id: 255, name: "Sharam Jogizai" },
      { id: 256, name: "Sheikhupura" },
      { id: 257, name: "Shikarpur" },
      { id: 258, name: "Shingar" },
      { id: 259, name: "Shorap" },
      { id: 260, name: "Sibi" },
      { id: 261, name: "Sohawa" },
      { id: 262, name: "Sonmiani" },
      { id: 263, name: "Sooianwala" },
      { id: 264, name: "Spezand" },
      { id: 265, name: "Spintangi" },
      { id: 266, name: "Sui" },
      { id: 267, name: "Sujawal" },
      { id: 268, name: "Sukkur" },
      { id: 269, name: "Suntsar" },
      { id: 270, name: "Surab" },
      { id: 271, name: "Swabi" },
      { id: 272, name: "Swat" },
      { id: 273, name: "Tando Adam" },
      { id: 274, name: "Tando Bago" },
      { id: 275, name: "Tangi" },
      { id: 276, name: "Tank City" },
      { id: 277, name: "Tar Ahamd Rind" },
      { id: 278, name: "Thalo" },
      { id: 279, name: "Thatta" },
      { id: 280, name: "Toba Tek Singh" },
      { id: 281, name: "Tordher" },
      { id: 282, name: "Tujal" },
      { id: 283, name: "Tump" },
      { id: 284, name: "Turbat" },
      { id: 285, name: "Umarao" },
      { id: 286, name: "Umarkot" },
      { id: 287, name: "Upper Dir" },
      { id: 288, name: "Uthal" },
      { id: 289, name: "Vehari" },
      { id: 290, name: "Veirwaro" },
      { id: 291, name: "Vitakri" },
      { id: 292, name: "Wadh" },
      { id: 293, name: "Wah Cantt" },
      { id: 294, name: "Warah" },
      { id: 295, name: "Washap" },
      { id: 296, name: "Wasjuk" },
      { id: 297, name: "Wazirabad" },
      { id: 298, name: "Yakmach" },
      { id: 299, name: "Zhob" },
      { id: 300, name: "Other" },
    ];
  
    $scope.baseInstitutes = [
      {
        id: 1,
        name: "ABBOTTABAD PUBLIC SCHOOL",
      },
      {
        id: 2,
        name: "Abbottabad University of Science and Technology",
      },
      {
        id: 3,
        name: "Abdul Wali Khan University Mardan",
      },
      {
        id: 4,
        name: "Aga Khan University",
      },
      {
        id: 5,
        name: "Air University",
      },
      {
        id: 6,
        name: "AIMS School Systems",
      },
      {
        id: 7,
        name: "AITCHISON COLLEGE",
      },
      {
        id: 8,
        name: "Al-Hamd Islamic University",
      },
      {
        id: 9,
        name: "Ali Institute of Education",
      },
      {
        id: 10,
        name: "Allied Scool",
      },
      {
        id: 11,
        name: "American Lyceum",
      },
      {
        id: 12,
        name: "Army Public Schools",
      },
      {
        id: 13,
        name: "Bacha Khan University",
      },
      {
        id: 14,
        name: "Bahauddin Zakariya University",
      },
      {
        id: 15,
        name: "BAHRIA COLLEGE",
      },
      {
        id: 16,
        name: "Bahria University",
      },
      {
        id: 17,
        name: "Balochistan University of Engineering and Technology",
      },
      {
        id: 18,
        name: "Balochistan University of Information Technology, Engineering and Management Sciences",
      },
      {
        id: 19,
        name: "Baqai Medical University",
      },
      {
        id: 20,
        name: "Beaconhouse National University",
      },
      {
        id: 21,
        name: "Beaconhouse School System",
      },
      {
        id: 22,
        name: "Benazir Bhutto Shaheed University Lyari",
      },
      {
        id: 23,
        name: "Benazir Bhutto Shaheed University of Technology and Skill Development",
      },
      {
        id: 24,
        name: "Bloomfield Hall School",
      },
      {
        id: 25,
        name: "Bolan University of Medical and Health Sciences",
      },
      {
        id: 26,
        name: "BURNHALL SCHOOL",
      },
      {
        id: 27,
        name: "CADET COLLEGE HASSAN ABDAL",
      },
      {
        id: 28,
        name: "Capital University of Science and Technology",
      },
      {
        id: 29,
        name: "CECOS University",
      },
      {
        id: 30,
        name: "Central Model High School",
      },
      {
        id: 31,
        name: "CHAND BAGH SCHOOL",
      },
      {
        id: 32,
        name: "City University of Science and Information Technology",
      },
      {
        id: 33,
        name: "Commecs Institute of Business and Emerging Sciences",
      },
      {
        id: 34,
        name: "COMSATS Institute of Information Technology",
      },
      {
        id: 35,
        name: "CONVENT SCHOOL",
      },
      {
        id: 36,
        name: "CRESCENT MODEL SCHOOL",
      },
      {
        id: 37,
        name: "Dadabhoy Institute of Higher Education",
      },
      {
        id: 38,
        name: "Dar-e-Arqam Schools",
      },
      {
        id: 39,
        name: "Dawood University of Engineering and Technology",
      },
      {
        id: 40,
        name: "Divisional Public School",
      },
      {
        id: 41,
        name: "DHA Suffa University",
      },
      {
        id: 42,
        name: "DOW University of Health Sciences",
      },
      {
        id: 43,
        name: "FATA University",
      },
      {
        id: 44,
        name: "Fatima Jinnah Medical University",
      },
      {
        id: 45,
        name: "Fatima Jinnah Women University",
      },
      {
        id: 46,
        name: "Federal Urdu University of Arts, Sciences and Technology",
      },
      {
        id: 47,
        name: "Forman Christian College",
      },
      {
        id: 48,
        name: "Foundation University Islamabad",
      },
      {
        id: 49,
        name: "Gambat Institute of Medical Sciences",
      },
      {
        id: 50,
        name: "Gandhara University",
      },
      {
        id: 51,
        name: "Ghazi University",
      },
      {
        id: 52,
        name: "Ghulam Ishaq Khan Institute of Engineering Sciences and Technology",
      },
      {
        id: 53,
        name: "GIFT University",
      },
      {
        id: 54,
        name: "Gomal University",
      },
      {
        id: 55,
        name: "Government College for Women University, Sialkot",
      },
      {
        id: 56,
        name: "Government College University, Faisalabad",
      },
      {
        id: 57,
        name: "Government College University, Lahore",
      },
      {
        id: 58,
        name: "Government College Women University, Faisalabad",
      },
      {
        id: 59,
        name: "Greenwich University",
      },
      {
        id: 60,
        name: "HABIB PUBLIC SCHOOL",
      },
      {
        id: 61,
        name: "Habib University",
      },
      {
        id: 62,
        name: "Hajvery University",
      },
      {
        id: 63,
        name: "Hamdard University",
      },
      {
        id: 64,
        name: "Hazara University",
      },
      {
        id: 65,
        name: "HITEC University",
      },
      {
        id: 66,
        name: "Ilma University",
      },
      {
        id: 67,
        name: "Imperial College of Business Studies",
      },
      {
        id: 68,
        name: "Indus University, Pakistan",
      },
      {
        id: 69,
        name: "Indus Valley School of Art and Architecture",
      },
      {
        id: 70,
        name: "Information Technology University",
      },
      {
        id: 71,
        name: "Institute of Business Administration",
      },
      {
        id: 72,
        name: "Institute of Business Management",
      },
      {
        id: 73,
        name: "Institute of Management Sciences",
      },
      {
        id: 74,
        name: "Institute of Southern Punjab",
      },
      {
        id: 75,
        name: "Institute of Space Technology",
      },
      {
        id: 76,
        name: "International Islamic University, Islamabad",
      },
      {
        id: 77,
        name: "International Islamic University Islamabad Schools",
      },
      {
        id: 78,
        name: "INTERNATIONAL SCHOOL OF CHOUEIFAT",
      },
      {
        id: 79,
        name: "Iqra National University",
      },
      {
        id: 80,
        name: "Iqra University",
      },
      {
        id: 81,
        name: "Islamia College Peshawar",
      },
      {
        id: 82,
        name: "Isra University",
      },
      {
        id: 83,
        name: "Jinnah Sindh Medical University",
      },
      {
        id: 84,
        name: "Jinnah University for Women",
      },
      {
        id: 85,
        name: "Karachi Institute of Economics and Technology",
      },
      {
        id: 86,
        name: "Karachi Grammar School",
      },
      {
        id: 87,
        name: "Karachi School for Business and Leadership",
      },
      {
        id: 88,
        name: "Karakurum International University",
      },
      {
        id: 89,
        name: "KASB Institute of Technology",
      },
      {
        id: 90,
        name: "Khushal Khan Khattak University",
      },
      {
        id: 91,
        name: "Khwaja Fareed University of Engineering and Information Technology",
      },
      {
        id: 92,
        name: "Khyber Medical University",
      },
      {
        id: 93,
        name: "King Edward Medical University",
      },
      {
        id: 94,
        name: "Kinnaird College for Women",
      },
      {
        id: 95,
        name: "Kohat University of Science and Technology",
      },
      {
        id: 96,
        name: "LAHORE AMERICAN SCHOOL",
      },
      {
        id: 97,
        name: "Lahore College for Women University",
      },
      {
        id: 98,
        name: "Lahore Garrison University",
      },
      {
        id: 99,
        name: "Lahore Grammar Schools",
      },
      {
        id: 100,
        name: "Lahore Leads University",
      },
      {
        id: 101,
        name: "Lahore School of Economics",
      },
      {
        id: 102,
        name: "Lahore University of Management Sciences",
      },
      {
        id: 103,
        name: "Lasbela University of Agriculture, Water and Marine Sciences",
      },
      {
        id: 104,
        name: "Leeds Grammar School",
      },
      {
        id: 105,
        name: "Liaquat University of Medical and Health Sciences",
      },
      {
        id: 106,
        name: "Mehran University of Engineering and Technology",
      },
      {
        id: 107,
        name: "Minhaj University",
      },
      {
        id: 108,
        name: "Mirpur University of Science and Technology",
      },
      {
        id: 109,
        name: "Mohammad Ali Jinnah University",
      },
      {
        id: 110,
        name: "Mohi-ud-Din Islamic University",
      },
      {
        id: 111,
        name: "Muhammad Nawaz Shareef University of Agriculture, Multan",
      },
      {
        id: 112,
        name: "Muhammad Nawaz Sharif University of Engineering and Technology",
      },
      {
        id: 113,
        name: "Muslim Youth University",
      },
      {
        id: 114,
        name: "National College of Arts",
      },
      {
        id: 115,
        name: "National College of Business Administration and Economics",
      },
      {
        id: 116,
        name: "National Defence University",
      },
      {
        id: 117,
        name: "National Textile University",
      },
      {
        id: 118,
        name: "National University of Computer and Emerging Sciences",
      },
      {
        id: 119,
        name: "National University of Medical Sciences",
      },
      {
        id: 120,
        name: "National University of Modern Languages",
      },
      {
        id: 121,
        name: "National University of Sciences and Technology",
      },
      {
        id: 122,
        name: "National University of Technology",
      },
      {
        id: 123,
        name: "Nazeer Hussain University",
      },
      {
        id: 124,
        name: "NED University of Engineering and Technology",
      },
      {
        id: 125,
        name: "Newports Institute of Communications and Economics",
      },
      {
        id: 126,
        name: "NFC Institute of Engineering and Technology",
      },
      {
        id: 127,
        name: "Northern University",
      },
      {
        id: 128,
        name: "Nur International University",
      },
      {
        id: 129,
        name: "Pakistan Institute of Development Economics",
      },
      {
        id: 130,
        name: "Pakistan Institute of Engineering and Applied Sciences",
      },
      {
        id: 131,
        name: "Pakistan Institute of Fashion and Design",
      },
      {
        id: 132,
        name: "Pak-Turk International school",
      },
      {
        id: 133,
        name: "Peoples University of Medical and Health Sciences for Women",
      },
      {
        id: 134,
        name: "Pir Mehr Ali Shah Arid Agriculture University",
      },
      {
        id: 135,
        name: "Preston University",
      },
      {
        id: 136,
        name: "Punjab Group of Colleges",
      },
      {
        id: 137,
        name: "Qarshi University",
      },
      {
        id: 138,
        name: "Quaid-e-Awam University of Engineering, Science and Technology",
      },
      {
        id: 139,
        name: "Quaid-i-Azam University",
      },
      {
        id: 140,
        name: "Qurtaba University",
      },
      {
        id: 141,
        name: "Rawalpindi Medical University",
      },
      {
        id: 142,
        name: "Riphah International University",
      },
      {
        id: 143,
        name: "Roots Millennium School",
      },
      {
        id: 144,
        name: "Sadiq Public School",
      },
      {
        id: 145,
        name: "Salim Habib University",
      },
      {
        id: 146,
        name: "Sardar Bahadur Khan Women's University",
      },
      {
        id: 147,
        name: "Sarhad University of Science and Information Technology",
      },
      {
        id: 148,
        name: "Shah Abdul Latif University",
      },
      {
        id: 149,
        name: "Shaheed Benazir Bhutto City University",
      },
      {
        id: 150,
        name: "Shaheed Benazir Bhutto University",
      },
      {
        id: 151,
        name: "Shaheed Benazir Bhutto University of Veterinary and Animal Sciences",
      },
      {
        id: 152,
        name: "Shaheed Benazir Bhutto University Shaheed Benazirabad",
      },
      {
        id: 153,
        name: "Shaheed Benazir Bhutto Women University",
      },
      {
        id: 154,
        name: "Shaheed Mohtarma Benazir Bhutto Medical University",
      },
      {
        id: 155,
        name: "Shaheed Zulfiqar Ali Bhutto Institute of Science and Technology",
      },
      {
        id: 156,
        name: "Shaheed Zulfiqar Ali Bhutto Medical University",
      },
      {
        id: 157,
        name: "Shaheed Zulfiqar Ali Bhutto University of Law",
      },
      {
        id: 158,
        name: "Shifa Tameer-e-Millat University",
      },
      {
        id: 159,
        name: "Sindh Agriculture University",
      },
      {
        id: 160,
        name: "Sindh Madresatul Islam University",
      },
      {
        id: 161,
        name: "Sir Syed University of Engineering and Technology",
      },
      {
        id: 162,
        name: "Sukkur Institute of Business Administration",
      },
      {
        id: 163,
        name: "Textile Institute of Pakistan",
      },
      {
        id: 164,
        name: "The City Scool",
      },
      {
        id: 165,
        name: "The Government Sadiq College Women University",
      },
      {
        id: 166,
        name: "The Institute of Management Sciences",
      },
      {
        id: 167,
        name: "The Islamia University of Bahawalpur",
      },
      {
        id: 168,
        name: "The Lahore Alma",
      },
      {
        id: 169,
        name: "The Lahore Lyceum",
      },
      {
        id: 170,
        name: "The Multan Alma",
      },
      {
        id: 171,
        name: "THE MAMA PARSI INTERNATIONAL SCHOOL",
      },
      {
        id: 172,
        name: "The Superior College",
      },
      {
        id: 173,
        name: "The University of Agriculture, Peshawar",
      },
      {
        id: 174,
        name: "The University of Faisalabad",
      },
      {
        id: 175,
        name: "The University of Lahore",
      },
      {
        id: 176,
        name: "The Women University Multan",
      },
      {
        id: 177,
        name: "University of Agriculture, Faisalabad",
      },
      {
        id: 178,
        name: "University of Azad Jammu and Kashmirs",
      },
      {
        id: 179,
        name: "University of Balochistan",
      },
      {
        id: 180,
        name: "University of Baltistan, Skardu",
      },
      {
        id: 181,
        name: "University of Central Punjab",
      },
      {
        id: 182,
        name: "University of Chitral",
      },
      {
        id: 183,
        name: "University of Education",
      },
      {
        id: 184,
        name: "University of Engineering and Technology, Lahore",
      },
      {
        id: 185,
        name: "University of Engineering and Technology, Peshawar",
      },
      {
        id: 186,
        name: "University of Engineering and Technology, Taxila",
      },
      {
        id: 187,
        name: "University of Gujrat",
      },
      {
        id: 188,
        name: "University of Haripur",
      },
      {
        id: 189,
        name: "University of Health Sciences, Lahore",
      },
      {
        id: 190,
        name: "University of Karachi",
      },
      {
        id: 191,
        name: "University of Kotli Azad Jammu and Kashmir",
      },
      {
        id: 192,
        name: "University of Loralai",
      },
      {
        id: 193,
        name: "University of Malakand",
      },
      {
        id: 194,
        name: "University of Management and Technology",
      },
      {
        id: 195,
        name: "University of Peshawar",
      },
      {
        id: 196,
        name: "University of Poonch Rawalakot",
      },
      {
        id: 197,
        name: "University of Sargodha",
      },
      {
        id: 198,
        name: "University of Science and Technology, Bannu",
      },
      {
        id: 199,
        name: "University of Sindh",
      },
      {
        id: 200,
        name: "University of South Asia",
      },
      {
        id: 201,
        name: "University of Swabi",
      },
      {
        id: 202,
        name: "University of Swat",
      },
      {
        id: 203,
        name: "University of the Punjab",
      },
      {
        id: 204,
        name: "University of Turbat",
      },
      {
        id: 205,
        name: "University of Veterinary and Animal Sciences",
      },
      {
        id: 206,
        name: "University of Wah",
      },
      {
        id: 207,
        name: "Women University of Azad Jammu and Kashmir Bagh",
      },
      {
        id: 208,
        name: "Women University Swabi",
      },
      {
        id: 209,
        name: "Ziauddin University",
      },
    ];
    $scope.getAllCities = function () {
      HttpService.getRequest("api/v1/common/get-cities").then(function (res) {
        console.log(res, "CITIES");
        $scope.itemArray = res.cities;
        $scope.selected = { value: $scope.itemArray[0] };
      });
    };
    $scope.getAllCities();

    $scope.getAllInstitutes = function () {
      HttpService.getRequest("api/v1/common/get-institutions").then(function (
        res
      ) {
        console.log(res, "INSTITUTES");
        $scope.uniArray = res.institutions;
        $scope.selectedUni = { value: $scope.uniArray[0] };
      });
    };
    $scope.getAllInstitutes();
    $scope.quizPageNo = 1;
    $scope.videoPageNo = 1;

    $scope.myImage = "";
    $scope.myCroppedImage = "";
    $scope.showCropped = false;
    $scope.croppedImageName = "";

    $scope.handleFileSelect = function (evt) {
      // console.log("evaaa",evt);
      var file = evt.currentTarget.files[0];
      // console.log(evt.currentTarget.files[0])
      $scope.croppedImageName = file.name;
      var reader = new FileReader();
      reader.onload = function (evt2) {
        // console.log("in func",evt2);
        $scope.myImage = evt2.target.result;

        $scope.showCropped = true;
        // console.log($scope.myImage,"MY IMAGE");
        $scope.$apply();
        // $scope.$apply(function($scope){
        //   $scope.myImage=evt2.target.result;

        //   $scope.showCropped = true;
        //   console.log($scope.myImage,"MY IMAGE");
        // });
      };
      reader.readAsDataURL(file);
    };
    angular
      .element(document.querySelector("#fileInput"))
      .on("change", $scope.handleFileSelect);

    $scope.closeCustomCrop = function () {
      $scope.showCropped = false;
      $scope.croppedImageName = "";
    };

    function getFormattedDate(date) {
      var year = date.getFullYear();
       $scope.dobUser.userYear = year.toString();
      console.log($scope.dobUser.userYear,"Var");
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : "0" + month;
      $scope.dobUser.userMonth = month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : "0" + day;
      $scope.dobUser.userDay = day;
      return month + "/" + day + "/" + year;
    }
    $scope.goToState = function (state) {
      $state.go(state, {}, { reload: true });
    };

    // console.log(window.location.href,"CURRENT WINDOW");
    function format(date1) {
      var date = new Date(date1);
      var str =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();

      return str;
    }

    $scope.$on("reloadOnRefresh", function (event) {
      // alert("in here");
    location.reload();
    });

    if (CustomStorageService.getUserInfoStorageData()) {
      setTimeout(function () {
        $scope.userDataObj = CustomStorageService.getUserInfoStorageData();
        $scope.userToken = CustomStorageService.getAuthTokenStorageData();
        userId = $scope.userDataObj.id;
 
        // console.log("User Data Profile", $scope.userDataObj);
        // console.log('asdsadasdsadsad-=====', CustomStorageService.getUserInfoStorageData())
        $scope.userEmail = $scope.userDataObj.email;
        $scope.userName = $scope.userDataObj.name
          ? $scope.userDataObj.name
          : $scope.userDataObj.full_name;
        $scope.userPhone = $scope.userDataObj.contact;
        // $scope.userDataObj.dob = new Date($scope.userDataObj.dob);

        if ($scope.userDataObj.dob !== null) {
          // var defaultDate = new Date($scope.userDataObj.dob);
          // dateDob.value = defaultDate.toISOString().substr(0, 10);
          // console.log($scope.userDataObj.dob);
          $scope.userDob = getFormattedDate(new Date($scope.userDataObj.dob));
          // console.log();

          $scope.missingDOB = false;
          // console.log("DAAAAAAAAAAAA", $scope.userDob);
          if ($scope.userDob === "NaN/NaN/NaN") {
            $scope.userDob = "Edit your Date of Birth";
            $scope.missingDOB = true;
          }
        } else {
          $scope.userDob = "Edit your Date of Birth";
          $scope.missingDOB = true;
        }

 
        if (($scope.userDataObj || {}).password_updated_at != null) {
          $scope.updatedAt = getFormattedDate(
            new Date($scope.userDataObj.password_updated_at)
          );
        } else {
          $scope.updatedAt = null;
        }
      }, 300);
    }
    var getUserOrders = function (query, pagination) {
      // console.log(pagination);
      HttpService.postRequest("api/v1/orders/get", query).then(function (res) {
        if (pagination == "pagination") {
          // console.log("ORDERS P", res);
          $scope.showData = true;
          $scope.ordersLoaded = true;
          $scope.totalPages = res.pages;
          $scope.totalCount = res.orderCount;

          $scope.userOrders = $scope.userOrders.concat(res.orders);
        } else {
          // console.log("ORDERS", res);
          $scope.showData = true;
          $scope.ordersLoaded = true;
          $scope.totalPages = res.pages;
          $scope.totalCount = res.orderCount;
          $scope.userOrders = res.orders;
          $scope.totalPaidAmount = res.toatalPaidAmount;
        }
      });
    };
    if ($rootScope.openOrders) {
      // $scope.filterSetting('myOrder');
      $scope.settingType.profileInfo = false;
      $scope.settingType.myOrder = true;
      getUserOrders(null);
    }
    // if (!CustomStorageService.getUserInfoStorageData().is_migrated) {

    // }

    $scope.getUserAccounts = function () {
      $http
        .post("api/v1/user/get-accounts-with-email", {
          user_id: parseInt(CustomStorageService.getUserInfoStorageData().id),
        })
        .then(function (data) {
          if (data.data.users) {
            $scope.userAccounts = data.data.users;
            $scope.showData = true;
            // console.log("ACCOUNTS", $scope.userAccounts);
            if (
              $scope.userAccounts.length > 1 &&
              !CustomStorageService.getUserInfoStorageData().is_migrated
            ) {
              $http
                .get(
                  "/api/v1/user/check-merge-count/" +
                    CustomStorageService.getUserInfoStorageData().id
                )
                .then(function (data) {
                  // $rootScope.mergeTooltip = true;
                  if (data.data.success && data.data.mergeShowCount < 3) {
                    $rootScope.mergeNotify = true;
                    if (!$rootScope.closedToolTip) {
                      document.getElementById(
                        "custom-tooltip"
                      ).style.visibility = "visible";
                      document.getElementById(
                        "custom-tooltip-1"
                      ).style.visibility = "visible";
                      $rootScope.mergeTooltip = true;
                      $rootScope.closedToolTip = true;
                    }
                  } else {
                    $rootScope.mergeNotify = false;
                  }
                });
            }
          }
        });
    };
    $scope.pagination = function (page) {
      $scope.ordersLoaded = false;
      if (page > 0 && page <= $scope.totalPages) {
        $scope.searchParams.page = page;
        getUserOrders($scope.searchParams, "pagination");
      }
    };
    $scope.getQuizzes = function (pagination) {
      var data = { user_id: CustomStorageService.getUserInfoStorageData().id };
      $http({
        url:
          env.backendService +
          "/quizservice/v1/result/get-user-results?page=" +
          $scope.quizPageNo,
        method: "GET",
        params: data,
      }).then(
        function (data) {
          if (pagination != null) {
            if ((data.data.results || []).length < 10) {
              $scope.stopQuizzes = true;
            } else {
              $scope.stopQuizzes = false;
            }
            // console.log("QUIZZES != Null", data);
            $scope.showData = true;
            $scope.quizzesLoaded = true;

            $scope.quizzes = $scope.quizzes.concat(data.data.results);
          } else {
            if ((data.data.results || []).length < 10) {
              $scope.stopQuizzes = true;
            } else {
              $scope.stopQuizzes = false;
            }
            // console.log("QUIZZES", data);
            $scope.showData = true;
            $scope.quizzesLoaded = true;
            $scope.quizzes = data.data.results;
            $scope.quizStats = data.data.statsData;
          }
        },
        function errorCallback(response) {
          $scope.showData = true;
          requestService.responseHandler(response.status);
        }
      );
    };
    $scope.backInputCity = function (d) {
      $scope.selected.value.id = 0;
    };
    $scope.quizPagination = function (page) {
      $scope.quizzesLoaded = false;
      if (!$scope.stopQuizzes) {
        // console.log("IN QUIZ PAGINATION");
        $scope.quizPageNo = page + 1;
        $scope.getQuizzes("pagination");
      }
    };
    $scope.videoPagination = function (page) {
      $scope.videosLoaded = false;
      if (!$scope.stopVideos) {
        // console.log("IN QUIZ PAGINATION");
        $scope.videoPageNo = page + 1;
        $scope.getWatchedVideos("pagination");
      }
    };
    $scope.getWatchedVideos = function (pagination) {
      // console.log("WATCHED VIDEOS");
      $http({
        url:
          env.backendService +
          "/trackingservice/v1/video-tracking/get-viewed-video?page=" +
          $scope.videoPageNo,
        method: "GET",
        // params: data,
      }).then(
        function (response) {
          // console.log(response, "WATCHED VIDEOS");
          if (pagination != null) {
            if ((response.data.videos || []).length < 20) {
              $scope.stopVideos = true;
            } else {
              $scope.stopVideos = false;
            }
            $scope.videosLoaded = true;
            $scope.showData = true;
            $scope.watchedVideos = $scope.watchedVideos.concat(
              response.data.videos
            );
          } else {
            if ((response.data.videos || []).length < 20) {
              $scope.stopVideos = true;
            } else {
              $scope.stopVideos = false;
            }
            $scope.videosLoaded = true;

            $scope.showData = true;
            $scope.watchedVideos = response.data.videos;
          }
        },
        function errorCallback(response) {
          // console.log("ERROR", response);
          $scope.showData = true;
          $scope.watchedVideos = response.data.videos;
          // $scope.showData = true;
          // requestService.responseHandler(response.status);
        }
      );
    };
    ($scope.getVideoStats = function () {
      $http({
        url:
          env.backendService +
          "/trackingservice/v1/video-tracking/get-user-stats",
        method: "GET",
        // params: data,
      }).then(
        function (resp) {
          // console.log("VIDEO STATS", resp);
          $scope.videoStats = resp.data;
        },
        function errorCallBack(response) {
          // console.log("error in video stats", response);
        }
      );
    }),
      function getDocHeight() {
        // $(document).height() value depends on browser
        var D = document;
        return Math.max(
          D.body.scrollHeight,
          D.documentElement.scrollHeight,
          D.body.offsetHeight,
          D.documentElement.offsetHeight,
          D.body.clientHeight,
          D.documentElement.clientHeight
        );
      };
    $(window).scroll(function (event) {
      // console.log(
      //   "in scroll",
      //   $scope.ordersLoaded,
      //   $scope.stopQuizzes,
      //   window.innerHeight + window.scrollY >= document.body.scrollHeight - 2
      // );
      if (
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 2 &&
        $scope.settingType.myOrder &&
        $scope.ordersLoaded
      ) {
        // you're at the bottom of the page
        var st = $(this).scrollTop();
        // console.log("SSS", st, event);
        $scope.pagination($scope.searchParams.page + 1);
      } else if (
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 2 &&
        $scope.settingType.quizzes &&
        $scope.quizzesLoaded &&
        !$scope.stopQuizzes
      ) {
        // you're at the bottom of the page
        var st = $(this).scrollTop();
        // console.log("SSS", st, event);
        $scope.quizPagination($scope.quizPageNo);
        // $scope.pagination($scope.searchParams.page + 1);
      } else if (
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 2 &&
        $scope.settingType.videosWatched &&
        $scope.videosLoaded &&
        !$scope.stopVideos
      ) {
        // you're at the bottom of the page
        var st = $(this).scrollTop();
        // console.log("SSS", st, event);
        $scope.videoPagination($scope.videoPageNo);
        // $scope.pagination($scope.searchParams.page + 1);
      }
    });
    $(window).resize(function (event) {
      // sizeAdjust()
    });

    function sizeAdjust() {
      if (screen.width > 900) {
        $scope.responsive = true;
        $scope.sidebar = false;
      } else {
        $scope.responsive = false;
        $scope.sidebar = true;
        $scope.profileInfo = false;
      }
    }
    $scope.initialize = function () {
      sizeAdjust();
      // getUserOrders($scope.searchParams);

      // $http({
      //   url: 'api/v1/users/getUserData',
      //   method: "GET",
      // }).then(function(data){
      //   // $scope.userDataObj = data.data;
      //   $scope.showRequestVideo = data.data.allowRequest;
      //   $scope.switchToggle = $scope.showRequestVideo ? false : true;
      //   $scope.showData = true;
      // }, function errorCallback(response) {
      //   requestService.responseHandler(response.status);
      // });

      // $http({
      //   url: 'api/v1/users/getAvgRating',
      //   method: "GET",
      //   params: {id: userId}
      // }).then(function(data) {
      //   $scope.reqCount++;
      //   $scope.avg_rating = data.data.rating;
      // }, function errorCallback(response) {
      //   requestService.responseHandler(response.status);
      // });

      // $http({
      //   url: 'api/v1/users/moduleTransaction',
      //   method: "GET",
      //   params: data
      // }).then(function(data) {

      //   $scope.transactions = data.data.transactions;
      // }, function errorCallback(response) {
      //   requestService.responseHandler(response.status);
      // });

      // $http({
      //   url: "api/v1/users/userViewedVideos",
      //   method: "GET",
      //   params: data,
      // }).then(
      //   function (data) {
      //     $scope.videos = data.data.video;
      //     $scope.totalViewedVideos = $scope.videos.length;
      //   },
      //   function errorCallback(response) {
      //     requestService.responseHandler(response.status);
      //   }
      // );

      // $http({
      //   url: "api/v1/user/get-user-lms-popup-count",
      //   method: "GET",
      //   params: {
      //     count: 0,
      //   },
      // }).then(function (data) {
      //   if (data.data.success) {
      //     $scope.lmsPopupCount = Number(data.data.data.lms_popup_count)
      //       ? data.data.data.lms_popup_count
      //       : 0;
      //   }
      // });
    };
    $scope.$on("userProfileUpdated", function (event) {
      // console.log("Updated Data in Profile Settings", event);
      $scope.userDataObj = CustomStorageService.getUserInfoStorageData();
      $scope.userInfo = $scope.userDataObj;
      // $scope.customerName =
      // CustomStorageService.getUserInfoStorageData().name ||
      // CustomStorageService.getUserInfoStorageData().full_name;
      // $scope.missingCredentials.email = $scope.userDataObj.email;
      // $scope.missingCredentials.phone = $scope.userDataObj.phone;
    });
    $scope.getEnrolledCourses = function () {
      var data = { user_id: CustomStorageService.getUserInfoStorageData().id };
      $http({
        url: "api/v1/users/getEnrolledCourses",
        method: "GET",
        params: data,
      }).then(
        function (data) {
          $scope.enrolledCourses = data.data.courses;
          // console.log("ENROLLED COURSES", $scope.enrolledCourses);
        },
        function errorCallback(response) {
          requestService.responseHandler(response.status);
        }
      );
    };
    $scope.closeLogoutForm = function () {
      $scope.changePassword = false;
      document.body.style.overflow = "auto";

      if ($rootScope.platform_reactApp) {
        console.log("popup-close");
      }
    };
    $scope.getAllSessions = function () {
      // console.log($scope.env, "======================");
      var data = { user_id: CustomStorageService.getUserInfoStorageData().id };
      $http
        .post(env.authService + "v1/sessions/get-user-session", {
          user_id: CustomStorageService.getUserInfoStorageData().id,
        })
        .then(
          function (resp) {
            // console.log("Sessions", resp);
            $scope.showData = true;
            // console.log("show data" + $scope.showData);
            $scope.userSessions = resp.data.data.sessions;
          },
          function errorCallback(response) {
            $scope.showData = true;
            requestService.responseHandler(response.status);
            // console.log("show data11111" + $scope.showData);
          }
        );
      $scope.showData = false;
      // console.log("show data222222" + $scope.showData);
    };
    $scope.logoutFromDevice = function (session) {
      $scope.selectedSession = session;
      $scope.logoutfromalldevice = !$scope.logoutfromalldevice;
    };
    $scope.initialize();
    $scope.fieldEditing = function (field) {

      $scope.errorMessage = "";

      // console.log("IN FIELD EDITING", field);
      $scope.genderEdit = false;
      $scope.uniEdit = false;
      $scope.dobEdit = false;
      $scope.cityEdit = false;
      if ($rootScope.platform_reactApp && (field || []).length > 0) {
        console.log("popup-open");
      } else if ($rootScope.platform_reactApp && (field || []).length < 1) {
        console.log("popup-close");
      }
      if (field == "phone") {
        setTimeout(function () {
          $("#country").countrySelect({
            defaultCountry: "pk",
            preferredCountries: ["pk"],
            localizedCountries: {},
          });
          $(".country-select").css("margin-top", "10px");
        }, 300);
      }
      $scope.nameEdit =
        field == "name" ? ($scope.nameEdit = true) : ($scope.nameEdit = false);
      $scope.nameEdit =
        field == "name"
          ? setTimeout(function () {
              document.getElementById("editName").focus();
            }, 300)
          : "";

      $scope.phoneEdit =
        field == "phone"
          ? ($scope.phoneEdit = true)
          : ($scope.phoneEdit = false);
      $scope.emailEdit =
        field == "email"
          ? ($scope.emailEdit = true)
          : ($scope.emailEdit = false);

          // $scope.$apply();
    };
    $scope.fullScreen = function () {
      $scope.fullscreenImg = true;
    };
    $scope.closeImgpopup = function () {
      $scope.fullscreenImg = false;
    };
    $scope.watchVideo = function (videoId) {};
    $scope.viewQuiz = function (result) {
      // /quiz/standard-quiz-results/61af6726c52b9c1697b477f3

      if ($scope.userDataObj && $scope.userToken) {
        // return false;
        if(result.quiz.quiz_type === 'daq') {
          var quiz = result.quiz;
          var url =
          env.velocityPortal +
          "?uid=" +
          $scope.userDataObj.id +
          "&token=" +
          $scope.userToken +
          "&redirecturl=" +
          encodeURIComponent("course/" + quiz.module.index_url + "/ " + quiz.module_id + "/" +quiz._id + "?daq=true&daq_id=" +quiz._id+"&result=true&result_id=" +result._id+"&courseIndexUrl=" +quiz.course.index_url);
          // console.log(url);
          window.open(url, "_self");
        } else {
          var url =
          env.velocityPortal +
          "?uid=" +
          $scope.userDataObj.id +
          "&token=" +
          $scope.userToken +
          "&redirecturl=" +
          encodeURIComponent("quiz/standard-quiz-results/" + result._id);
          // console.log(url);
          window.open(url, "_self");

          
        }
        
      }
      // $state.go("result", { resultId: resultId }, { reload: true });
    };
    $scope.openCourse = function (url) {
      var data = {
        index_url: url,
      };
      if(!$rootScope.platform_reactApp_new) {
        courseDetailService.goToCourse(data);
      }
    };
    $scope.openBundle = function (bundle) {
      if(!$rootScope.platform_reactApp_new) {
        courseDetailService.goToBundle(bundle);
      }
    };
    $scope.viewVideo = function (videoObj) {
      // console.log(videoObj, "VIDEO OBJ");
      if ($scope.userDataObj && $scope.userToken) {
        // return false;
        var redirectURL =
          "course/" +
          videoObj.module.module_index_url +
          "/" +
          videoObj.module.id +
          "/" +
          videoObj.video.id +
          "?courseIndexUrl=" +
          encodeURIComponent(videoObj.course.index_url);
        var url =
          env.velocityPortal +
          "?uid=" +
          $scope.userDataObj.id +
          "&token=" +
          $scope.userToken +
          "&redirecturl=";
        url += encodeURIComponent(redirectURL);

        // console.log(url);
        window.open(url, "_self");
      }
    };
    $scope.mergeAccountCall = function () {
      $http
        .post("api/v1/user/merge-accounts", {
          user_id: parseInt(CustomStorageService.getUserInfoStorageData().id),
        })
        .then(function (data) {
          // console.log("Merge", data);
          setTimeout(function () {
            $scope.settingType.yourAccount = false;
            $scope.transferAccount = true;
            var newData = CustomStorageService.getUserInfoStorageData();
            newData.is_migrated = true;
            CustomStorageService.setUserInfoStorageData(newData);
            document.getElementById("custom-tooltip").style.visibility = "none";
            document.getElementById("custom-tooltip-1").style.visibility =
              "none";
            $rootScope.mergeTooltip = false;
            $rootScope.closedToolTip = true;
            $scope.$apply();
          }, 4000);
        });
    };
    ($scope.keytab = function (event, model) {
      if (
        event.key === "Backspace" ||
        (event.keyCode === 229 && !event.target.value)
      ) {
        event.target.previousElementSibling.focus();
        $scope["digit" + model] = "";

        // if (model === 1) {
        //   $scope.digit1 = "";
        // } else if (model === 2) {
        //   $scope.digit2 = "";
        // } else if (model === 3) {
        //   $scope.digit3 = "";
        // } else if (model === 4) {
        //   $scope.digit4 = "";
        // } else if (model === 5) {
        //   $scope.digit5 = "";
        // } else if (model === 6) {
        //   $scope.digit6 = "";
        // }
      } else {
        if(event.target.value){
          event.target.nextElementSibling.focus()
        }
      }
    }),
      ($scope.onPasteOTP = function (event, num) {
        setTimeout(function () {
          var data = event.target.value.split("");
          event.target.value = data[0];
          angular.element("#digit-2")[0].value = data[1];
          angular.element("#digit-3")[0].value = data[2];
          angular.element("#digit-4")[0].value = data[3];
          angular.element("#digit-5")[0].value = data[4];
          angular.element("#digit-6")[0].value = data[5];
          $scope.digit1 = data[0];
          $scope.digit2 = data[1];
          $scope.digit3 = data[2];
          $scope.digit4 = data[3];
          $scope.digit5 = data[4];
          $scope.digit6 = data[5];
          $scope.$apply();
          angular.element("#digit-6")[0].focus();
        }, 100);
      });

    $scope.changePass = function (field) {
      // $scope.changePassword = true;
      if ($rootScope.guest) {
        if (
          $scope.passwordObj.new_password ===
          $scope.passwordObj.confirm_password
        ) {
          $scope.updateProfile(field, null);
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Passwords does not match";
        }
      } else {
        if (
          $scope.passwordObj.new_password != "" &&
          $scope.passwordObj.confirm_password != "" &&
          $scope.passwordObj.old_password != ""
        ) {
          if (
            $scope.passwordObj.new_password.length > 7 &&
            $scope.passwordObj.confirm_password.length > 7
          ) {
            if (
              $scope.passwordObj.new_password ===
              $scope.passwordObj.confirm_password
            ) {
              $scope.updateProfile(field, null);
            } else {
              $scope.loader = false;
              $scope.errorMessage = "Passwords does not match";
            }
          } else {
            $scope.loader = false;
            $scope.errorMessage = "Minimum 8 characters allowed";
          }
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Fields cannot be empty";
        }
      }
    };
    $scope.blurCall = function(field,val){
      setTimeout(function () {
        if(!updatingBeforeBlur) {
          $scope.updateProfile(field,val);
        }
      }, 300);
    }

    $scope.discard = function (){
      $rootScope.discard = true;
      $scope.nameEdit = false;
      $scope.emailEdit = false;
      $scope.phoneEdit = false;
      $scope.genderEdit = false;
      $scope.uniEdit = false;
      $scope.dobEdit = false;
      $scope.cityEdit = false;
      if($rootScope.platform_reactApp){
        console.log("popup-close");
      }
    }
    $scope.updateProfile = function (field, data) {

      if($rootScope.discard){
        // $scope.nameEdit = false;
        // $scope.emailEdit = false;
        // $scope.phoneEdit = false;
        // $scope.genderEdit = false;
        // $scope.uniEdit = false;
        // $scope.dobEdit = false;
        // $scope.cityEdit = false;
        $rootScope.discard = false;
        $scope.fieldEditing("");
        $scope.fixEditing("");
        return;
      }
      $scope.errorMessage = "";
      $scope.phoneUpdated = false;
      $scope.emailUpdated = false;
      $scope.toasterField = "";
      if (field !== "password") {
        if (
          data === null ||
          (data || []).length < 1 ||
          data === "Choose your City" ||
          data === "Choose your Institute"
        ) {
          // console.log("EMPTY DATA", data);
          $scope.errorMessage = "Field cannot be empty";
          return;
        }
      }
      fieldName = {};
      if (field === "email") {
        if ($scope.userDataObj.user_type === "guest") {
          $scope.newGuest = true;
        } else {
          $scope.newGuest = false;
        }
      }
      // console.log(field, data);
      $scope.loader = true;
      var updatedField = field;
      // return new Promise(function (resolve, reject) {
      $scope.loader = true;

      // console.log("FIELD PROFILE", field, data);

      if (field === "email") {
        $scope.toasterField = "Email";

        $scope.emailUpdated = true;
        if (data.includes("@")) {
          // console.log("IN email", field,data , $scope.userDataObj.email);
          $scope.fieldEditing("");
          if (data === $scope.userDataObj.email) {
            return;
          }
          fieldName = {
            email: data,
          };
          $scope.userEmail = data;
        } else {
          $scope.errorMessage = "Enter a valid Email";
          // console.log(data, "invalid");
          return;
        }
      }
      if (field === "phone") {
        $scope.toasterField = "Phone";

        if (data.length != 0) {
          $scope.phoneUpdated = true;
          var selectedCountry = $("#country").countrySelect(
            "getSelectedCountryData"
          ); 
          console.log('selectedCountry');
          console.log(selectedCountry);
          if(!selectedCountry || !selectedCountry.phone_code || selectedCountry.phone_code == 'undefined'){
            selectedCountry = {
              phone_code: "92",
              iso2: "pk",
              name: "Pakistan"
            }
          }
          $scope.fieldEditing("");
          if (data.startsWith("0")) {
            data = data.substring(1);
          }
          if (data.startsWith("92")) {
            data = data.substring(2);
          }

          if (data.length < 10 || !data.startsWith("3")) {
            $scope.errorMessage = "Enter Valid phone Ex. 3*******";
            setTimeout(function () {
              $scope.errorMessage = null;
            }, 3000);
            return;
          }
          if (data === $scope.userDataObj.uid_phone) {
            return;
          }
          $scope.userDataObj.uid_phone = selectedCountry.phone_code || "92" + data;
          fieldName = {
            phone: data,
            countryCode: selectedCountry.phone_code || "92",
            uidPhone: selectedCountry.phone_code + data,
            id: $scope.userDataObj.id,
            isQR: undefined,
          };
          // $scope.$apply();
        } else {
          $scope.errorMessage = "Field Cannot be empty";
        }
      }
      if (field === "password") {
        $scope.toasterField = "Password";
        fieldName = {
          new_password: $scope.passwordObj.new_password,
          old_password: $scope.passwordObj.old_password,
        };
      }
      if (field === "name") {
        $scope.toasterField = "Name";

        // console.log("IN name", field);
        if (data.length != 0) {
          $scope.fieldEditing("");

          fieldName = {
            name: data,
          };
        } else {
          $scope.errorMessage = "Field Cannot be empty";
          return;
        }
      }

      if (field === "city") {
        $scope.toasterField = "City";
        var c = $scope.itemArray.includes(data);
        console.log(c, "ssssss");

        $scope.fixEditing("");
        // console.log("IN CITY", field);
        fieldName = {
          city: data,
        };
      }

      if (field === "university") {
        $scope.toasterField = "Institute";

        // console.log("IN Institute", field);
        $scope.fixEditing("");

        fieldName = {
          university: data,
        };
      }
      if (field === "gender") {
        $scope.toasterField = "Gender";

        // console.log("IN Gender", field);
        $scope.fixEditing("");

        fieldName = {
          gender: data,
        };
      }
      if (field === "dob") {
        $scope.toasterField = "D.O.B";
        // console.log("dob",data);
        var date = data.userYear + "-" + data.userMonth + "-" + data.userDay;
        var finalDate = new Date(date);
        $scope.userDataObj.dob = finalDate;
        data = finalDate;
        $scope.userDob = getFormattedDate(finalDate);
        $scope.missingDOB = false;
        // console.log("IN DOB", field);
        $scope.fixEditing("");

        fieldName = {
          dob: data,
        };
      }

      if (field === "journey") {
        $scope.toasterField = "Journety";
        fieldName = {
          journey: data,
        };
        $scope.fixEditing("");
      }
      fieldName.id = $scope.userDataObj.id;


      $http.post("/api/v1/users/updateUser", fieldName).then(
        function (resp) {
          console.log("RESPONSE FROM BACKEND", resp);
          if (resp.data.success) {
            console.log('update-user-data');
            if($scope.loader) {
              toaster.success({
                title: "Profile Updated",
                body: $scope.toasterField + " Updated Successfully.",
              });
            }
            console.log('profile_updated');
            $scope.loader = false;
            if (data != null) {
              if (field === "email" || field === "phone") {
                $scope.userDataObj[updatedField] = data;
                // console.log(updatedField);
                // console.log("UPDATED", $scope.userDataObj);
                // console.log(resp.data.user,"useer new ret");
                $scope.userDataObj = resp.data.user;
                CustomStorageService.setUserInfoStorageData($scope.userDataObj);
                $scope.$emit("userProfileUpdated", $scope.userDataObj);
                if($scope.newGuest){
                  $scope.changePassword = true;
      document.body.style.overflow = "hidden";

                }
              } else {
                $scope.userDataObj[updatedField] = data;
                // console.log(updatedField);
                // console.log("UPDATED", $scope.userDataObj);
                CustomStorageService.setUserInfoStorageData($scope.userDataObj);
                $scope.$emit("userProfileUpdated", $scope.userDataObj);
              }
            } else {
              if (field === "password") {
                var pDate = new Date();
                $scope.userDataObj.password_updated_at = pDate;
                var newBrowserId =
                  Math.random().toString(36).substring(2, 15) +
                  Math.random().toString(36).substring(2, 15);
                $cookies.put("browserId", newBrowserId);
                CustomStorageService.setUserInfoStorageData($scope.userDataObj);
                $scope.$emit("userProfileUpdated", $scope.userDataObj);
                if ($rootScope.platform_reactApp) {
                  console.log("popup-close");
                }
                if (($scope.userDataObj || {}).password_updated_at != null) {
                  $scope.updatedAt = getFormattedDate(
                    new Date($scope.userDataObj.password_updated_at)
                  );

                  $scope.passwordObj.new_password = "";
                  $scope.passwordObj.old_password = "";
                  $scope.passwordObj.confirm_password = "";
                } else {
                  $scope.updatedAt = null;
                }

                $scope.changePassword = false;
                $scope.showEditPassword = false;
      document.body.style.overflow = "auto";

                location.reload();
              } else {
                $scope.showEditPassword = false;

                location.reload();
              }
            }
            $scope.fixEditing("");
            $scope.fieldEditing("");
          } else {
            $scope.loader = false;

            if (data != null) {
              // console.log(resp);
              fieldName[updatedField] = data;
              // console.log("SCOPE", fieldName);
              $scope.errorMessage = resp.data.message;
              toaster.error({
                title: "Profile Update Error",
                body: "Error in updating" + toasterField,
              });

              // console.log("Error Message", $scope.errorMessage);
            } else {
              $scope.errorMessage = "Incorrect Old Password";
            }
          }
          // resolve(resp);
        },
        function errorCallback(response) {
          // console.log("update profile", response);
          $scope.loader = false;

          // reject(new Error("ERROR updating"));
        }
      );
      // });
    };
    $scope.closeNewPass = function () {
      $scope.showEditPassword = false;
      // console.log($scope.showEditPassword,"EDIT PASS");
    };
    $scope.uploadImage = function (formData, userId) {
      return new Promise(function (resolve, reject) {
        fetch(
          env.backendService +
            "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
            userId,
          {
            method: "POST",
            body: formData,
          }
        )
          .then(
            function (data) {
              return data.json();
            },
            function (err) {
              // console.log("ERROR IN UPLOADING IMG 1", err);
              reject(new Error("ERROR IN UPLOADING IMG 1"));
            }
          )
          .then(
            function (data) {
              resolve(data);
            },
            function (err) {
              // console.log("ERROR IN UPLOADING IMG 1", err);
              reject(new Error("ERROR IN UPLOADING IMG 2"));
            }
          );
      });
    };
    function dataURLtoFile(dataurl, filename) {
      //  console.log("D",dataurl,filename);
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    }

    $scope.onImageSelected = function (event) {
      $scope.imageLoad = true;
      // console.log("EVENTS", event);
      $scope.imgUploaded = false;
      $scope.loader = true;

      // $scope.selectedImage = event.target.files[0];
      $scope.selectedImage = event;

      // var image1 = new Image();
      // image1.src =  $scope.selectedImage;
      // document.body.appendChild(image1);
      var convertedFile = dataURLtoFile(
        $scope.selectedImage,
        $scope.croppedImageName
      );
      // console.log(convertedFile,"fialals");
      // console.log("IMAGE",image1)
      // console.log($scope.selectedImage,"selected image");
      if (convertedFile.size > 10000000) {
        swal(
          {
            title: "Image Size",
            text: "Image size too big upload an image below 10mb file size",
            type: "error",
          },
          function () {
            swal.close();
          }
        );
        $scope.imageLoad = false;
        return;
      }
      // $scope.$apply();
      //   FormDataa()
      var fd = new FormData();
      // console.log($scope.selectedImage);
      fd.append("file", convertedFile);
      $scope.uploadImage(fd, $scope.userID).then(
        function (resp) {
          console.log("up resp", resp);
          if (resp.success) {
            $scope.uploadedImgLink = resp.link;
            $scope.userDataObj.image = $scope.uploadedImgLink;
            $scope.userInfo.image = $scope.uploadedImgLink;
            $scope.imageLoad = false;

            CustomStorageService.setUserInfoStorageData($scope.userDataObj);

            $scope.selectedImage = null;
            var obj = {
              id: $scope.userID,
              user_image: $scope.uploadedImgLink,
            };
            $http
              .post(
                env.backendService + "/lmsservice/v1/users/change-user-pic",
                obj
              )
              .then(
                function (resp) {
                  console.log('update-user-data');
                  // console.log("Change user pic", resp);
                  $scope.loader = false;

                  $scope.imgUploaded = true;
                  $scope.showCropped = false;
                  $scope.croppedImageName = "";
                  // this.currentUser.image = this.uploadedImgLink;
                  // customStorageService.setUser(this.currentUser);
                  // this.currentUser = customStorageService.getUser();
                  // toastr.success("Image Updated Successfully!");
                  // this.loader = false;
                },
                function errorCallback(response) {
                  console.log("ERROR CHANGE USER PIC", response);
                  $scope.loader = false;
                  $scope.showCropped = false;
                  $scope.croppedImageName = "";

                  return response;
                }
              );
          }
        },
        function errorCallback(response) {
          console.log("ERROR RESP", response);
          return response;
        }
      );
    };
    $scope.deleteAccount = function() {
      swal({
        title: "Are you sure to Delete Account?",
        text: "If yes you will be logged out and will not be able to login with this account again.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Delete Account",
        cancelButtonText: "No",
        closeOnConfirm: true},
        function(isConfirm){
          if(isConfirm) {
            $http.post("/api/v1/users/delete-account", {user_id: $scope.userDataObj.id}).then(
              function (resp) {
                console.lof('23323223')
              });
              setTimeout(function() {
                swal({
                  title: "Account Deleted Successfully!",
                  text: "Your account is deleted successfully!",
                  type: "success",
                  timer: 3000,
                }, function() {
                  swal.close();
                  console.log('account-delete');
                });
                // swal(
                //   {
                //     title: "Account Deleted Successfully!",
                //     text: "Your account is deleted successfully!",
                //     type: "Success",
                //     timer: 2000,
                //     showConfirmButton: false,
                //   },
                //   function () {
                    // console.log('account-delete');
                //     setTimeout(function() {
                //       console.log('account-delete');
                //     }, 2000)
                //   }
                // );
              }, 1000)
              
          }
      });
        
      
    }
    $scope.allLogoutPopup = function () {
      $scope.removeAllSession = true;
      $scope.selectedSession = $scope.userSessions;
      $scope.logoutfromalldevice = !$scope.logoutfromalldevice;
    };
    $scope.backverificationForm = function () {
      if($rootScope.platform_reactApp){
        console.log("popup-close");

      }
      $scope.logoutfromalldevice = true;
      $scope.enterotp = false;
    };
    var addPasteHandler = function() {
      setTimeout(function() {
        angular.element('#digit-1')[0].addEventListener('paste', function(event) {
          var clipboardData = event.clipboardData || window.clipboardData;
          var pastedData = clipboardData.getData('Text');
          var data = pastedData.split("");
          event.target.value = data[0];
          angular.element('#digit-2')[0].value = data[1];
          angular.element('#digit-3')[0].value = data[2];
          angular.element('#digit-4')[0].value = data[3];
          angular.element('#digit-5')[0].value = data[4];
          angular.element('#digit-6')[0].value = data[5];
          $scope.digit1 = data[0];
          $scope.digit2 = data[1];
          $scope.digit3 = data[2];
          $scope.digit4 = data[3];
          $scope.digit5 = data[4];
          $scope.digit6 = data[5];
          $scope.$apply();
          angular.element('#digit-6')[0].focus();
        });
      }, 500)
    }
    $scope.verifyOtp = function (device) {
      if($rootScope.platform_reactApp){
        console.log("popup-open");
      }
      $scope.phoneSelected = device == "phone" ? true : false;
      $scope.emailSelected = device == "phone" ? false : true;
      $scope.phoneSelected = device == "email" ? false : true;
      $scope.emailSelected = device == "email" ? true : false;
      $scope.logoutfromalldevice = false;
      $scope.enterotp = !this.enterotp;
      $scope.sendOtpCode(device);
      if($scope.enterOTP) {
        addPasteHandler();
      }
    };
    $scope.sendOTP = function () {
      $scope.enterotp = false;
      $scope.sendOTPConfirmation();
    };
    $scope.sendOtpCode = function (type) {
      if (type === "phone") {
        // $scope.enterOTP = true;
        type = 'whatsapp'
        $scope.phoneSelected = true;
      } else {
        // $scope.enterOTP = true;
        $scope.emailSelected = true;
      }
      var data = {
        user_id: $scope.userDataObj.id,
        type: type,
      };

      $http.post("/api/v1/auth/send-otp", data).then(
        function (resp) {
          console.log(resp);
          swal(
            {
              title: "OTP Code Sent!",
              type: "success",
              confirmButtonText: "Ok",
              timer: 2000,
              showConfirmButton: false,
            },
            function () {
              // $scope.clearOtp();
              swal.close();
            }
          );
        },
        function errorCallback(response) {
          console.log("response");
          swal(
            {
              title: "Try Again",
              text: "Something went wrong",
              type: "error",
            },
            function () {
              swal.close();
            }
          );
          // console.log(response)
        }
      );
    };
    $scope.searchCities = [];
    $scope.searchUniversities = [];
    $scope.cityCheck = function (s) {
      $scope.showCityList = true;
      $scope.searchCities = [];
      if((s||[]).length > 2){
        $scope.searchCities = $scope.itemArray.filter(function (a) {
          return a.name.toLowerCase().includes(s.toLowerCase());
        });
  
      }else{
        $scope.searchCities = $scope.baseCities.filter(function (a) {
          return a.name;
        });
  
      }

      if (!$scope.searchCities.length) {
        // $scope.showCityList = false;
        $scope.notFound = true;
      } else {
        $scope.notFound = false;
      }
    };
    var updatingBeforeBlur = false;
    $scope.onSelectCity = function (city) {
      updatingBeforeBlur = true;
      $scope.defaultField = !$scope.defaultField;

      console.log(city);
      if (city.id == 404) {
      } else {
        $scope.newVar = city.name;
        $scope.otherCity = city.name;
        $scope.otherCityDefault = city.name;
        $scope.showCityList = false;
        $scope.updateProfile("city", city.name);
        if (!$scope.$$phase) $scope.$apply();
      }
      setTimeout(function() {
        updatingBeforeBlur = false;
      }, 350)
    };
    $scope.uniCheck = function (s) {
      $scope.showUniList = true;
      $scope.searchUniversities = [];
if((s||[]).length > 2){
  $scope.searchUniversities = $scope.uniArray.filter(function (a) {
    return a.name.toLowerCase().includes(s.toLowerCase());
  });
}else{
  $scope.searchUniversities = $scope.baseInstitutes.filter(function (a) {
    return a.name;
  });
}

      if (!$scope.searchUniversities.length) {
        // $scope.showUniList = false;
        $scope.notFound = true;
      } else {
        $scope.notFound = false;
      }
    };

    $scope.onSelectUni = function (uni) {
      updatingBeforeBlur = true;
      $scope.defaultField = !$scope.defaultField;

      console.log(uni);
      if (uni.id == 404) {
      } else {
        $scope.newVar = uni.name;
        $scope.otherUni = uni.name;
        $scope.otherUniDefault = uni.name;
        $scope.showUniList = false;
        $scope.updateProfile("university", uni.name);
        if (!$scope.$$phase) $scope.$apply();
      }
      setTimeout(function() {
        updatingBeforeBlur = false;
      }, 350)
    };
    $scope.closeCityDropdown = function () {
      $scope.showCityList = false;
    };
    $scope.closeUniDropdown = function () {
      $scope.showUniList = false;
    };

    $scope.sendOTPConfirmation = function () {
      var otp =
        angular.element("#digit-1")[0].value +
        angular.element("#digit-2")[0].value +
        angular.element("#digit-3")[0].value +
        angular.element("#digit-4")[0].value +
        angular.element("#digit-5")[0].value +
        angular.element("#digit-6")[0].value;
      console.log("OTP", otp);
      const formData = {
        user_id: $scope.userDataObj.id,
        code: otp,
        session: $scope.selectedSession ? $scope.selectedSession.session : "",
        type: $scope.otpVerification,
        otp_type: $scope.phoneSelected ? "phone" : "email",
        logoutType: "profile",
        removeAllSession: $scope.removeAllSession,
        origin: "LEGACY",
      };

      $http.post("/api/v1/auth/validate-otp", formData).then(
        function (resp) {
          if (resp.data.success && resp.data.token) {
            $scope.enterOTP = false;
            $scope.OTP = false;
            if($rootScope.platform_reactApp){
              console.log("popup-close");
      
            }
            if ($rootScope.platform_reactApp) {
              console.log("userToken" + resp.data.token);
              console.log("userID" + resp.data.user.id);
              console.log("loggedIn");
            }
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              resp.data.token,
              resp.data.user
            );

            const isPrivacy = resp.data.isPrivacy ? "true" : "false";
            CustomStorageService.setTermStatus(isPrivacy);
            $rootScope.userNotLoggedIn = false;
            if ($state.current.name == "forgot-password") {
              $state.go("Landing", {}, { reload: true });
            } else {
              location.reload();
            }
            toaster.success({
              title: "OTP Verification",
              body: "OTP Verified Successfully",
            });
          } else if (
            resp.data.success &&
            CustomStorageService.getAuthTokenStorageData()
          ) {
            $scope.enterOTP = false;
            $scope.OTP = false;
            toaster.success({
              title: "OTP Verification",
              body: "OTP Verified Successfully",
            });
            location.reload();

            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              CustomStorageService.getAuthTokenStorageData(),
              resp.data.user
            );
          } else {
            toaster.success({
              title: "OTP Verification",
              body: "OTP Verified Successfully",
            });
          }
        },
        function errorCallback(response) {
          $scope.otpErroor = "Invalid OTP";
        }
      );
    };
    $scope.transferAccountPopup = function () {
      $scope.transferAccount = !$scope.transferAccount;
    };
    $scope.manageEmailSubscriptions = function () {
      $scope.updateSubscriptions = true;
    };
    $scope.updateEmailSubscriptions = function () {
      var inst = document.getElementById("Instructor Message");
      var blogs = document.getElementById("Blogs Subscription");

      // console.log("inst blogs", inst.checked, blogs.checked);
      var emailSetting;
      var body = {
        emailSetting: {
          blog_email: blogs.checked,
          comment_email: inst.checked,
        },
      };

      HttpService.postRequest("api/v1/user/update-email-setting", body).then(
        function (res) {
          // console.log(res);
          if (res.success) {
            $scope.updateSubscriptions = true;
            $scope.emailSubscriptionUpdated = true;
          }
        }
      );
    };
    $scope.closeemailSettingPopup = function () {
      $scope.emailSubscriptionUpdated = false;
    };
    $scope.closetransferAccountPopup = function () {
      $scope.transferAccount = false;
      $scope.settingType.yourAccount = true;
      location.reload();
    };
    $scope.closeverificationForm = function () {
      $scope.logoutfromalldevice = false;
    };
    $scope.closeotpForm = function () {
      if($rootScope.platform_reactApp){
        console.log("popup-close");

      }

      $scope.enterotp = false;
    };

    $scope.fixEditing = function (field) {
      $scope.errorMessage = "";
      $scope.nameEdit = false;
      $scope.emailEdit = false;
      $scope.phoneEdit = false;
      if ($rootScope.platform_reactApp && (field || []).length > 0) {
        console.log("popup-open");
      } else if ($rootScope.platform_reactApp && (field || []).length < 1) {
        console.log("popup-close");
      }
      $scope.dobEdit =
        field == "dob" ? ($scope.dobEdit = true) : ($scope.dobEdit = false);
      $scope.genderEdit =
        field == "gender"
          ? ($scope.genderEdit = true)
          : ($scope.genderEdit = false);
      $scope.cityEdit =
        field == "city" ? ($scope.cityEdit = true) : ($scope.cityEdit = false);
      $scope.uniEdit =
        field == "university"
          ? ($scope.uniEdit = true)
          : ($scope.uniEdit = false);

      // $scope.$apply();
    };
    $scope.passwordEditing = function () {
      $scope.errorMessage = "";
      $scope.changePassword = true;
      document.body.style.overflow = "hidden";
 
    };
    $scope.emailVerification = function () {
      $scope.emailVerify = !$scope.emailVerify;
    };
    $scope.back = function (page) {
      $location.path("/" + page);
    };
    $scope.filterSetting = function (state) {

      $scope.showData = false;

      if ($(document).width() <= 900 && $scope.sidebar) {
        $scope.responsive = true;
        $scope.sidebar = false;
      } else if ($(document).width() <= 900) {
        $scope.sidebar = true;
        $scope.responsive = false;
      }

      Object.keys($scope.settingType).forEach(function (element) {
        if (element == state) {
          $scope.settingType[element] = true;
        } else {
          $scope.settingType[element] = false;
        }
      });
      if (state === "profileInfo") {
        $state.go("profile_settings", { name: "personal-info" });
      } else if (state === "") {
        $scope.sidebar = true;
        $scope.responsive = false;
      } else if (state === "contantInfo") {
        $state.go("profile_settings", { name: "contact-info" });
      } else if (state === "activeDevices") {
        $state.go("profile_settings", { name: "active-devices" });
        $scope.getAllSessions();
      } else if (state === "yourAccount") {
        $state.go("profile_settings", { name: "your-account" });
        $scope.getUserAccounts();
      } else if (state === "myOrder") {
        $state.go("profile_settings", { name: "my-orders" });
        getUserOrders($scope.searchParams);
      } else if (state === "quizzes") {
        $state.go("profile_settings", { name: "my-quizzes" });
        $scope.getQuizzes(null);
      } else if (state === "emailSubscription") {
        $state.go("profile_settings", { name: "email-subscriptions" });
        $http.get("/api/v1/user/get-email-setting").then(function (resp) {

          var inst = document.getElementById("Instructor Message");
          var blogs = document.getElementById("Blogs Subscription");
          var system = document.getElementById("System Default Emails");
          system.checked = true;
          if (resp.data.success) {
            inst.checked = resp.data.emailSetting.email_setting.comment_email;
            blogs.checked = resp.data.emailSetting.email_setting.blog_email;
          } else {
            inst.checked = true;
            blogs.checked = false;
          }
        });
      } else if (state === "videosWatched") {
        $state.go("profile_settings", { name: "videos-watched" });

        $scope.getVideoStats();

        $scope.getWatchedVideos(null);
      }


    };

    $scope.disabledProp = function () {
      // console.log("heraaa");
      var system = document.getElementById("System Default Emails");
      system.checked = true;
      // system.disabled = true;
      return false;
    };
    $scope.backstage = function () {
      // $scope.responsive = false;
      // $scope.sidebar = true;
      $state.go("profile_settings", { name: "main" });
    };
    if (!CustomStorageService.getAuthTokenStorageData() && !$rootScope.platform_reactApp) {
        $scope.goToState("Landing");
      // profileInfo: false,
      // contantInfo: false,
      // activeDevices: false,
      // yourAccount: false,
      // emailSubscription: false,
      // myOrder: false,
      // transactions: false,
      // quizzes: false,
      // videosWatched: false,
      // changePassword: false,
    } else {
      // console.log("LOCATION", $state.params);
      if ($state.params.name === "personal-info") {
        $scope.filterSetting("profileInfo");
      } else if ($state.params.name === "contact-info") {
        $scope.filterSetting("contantInfo");
      } else if ($state.params.name === "active-devices") {
        $scope.filterSetting("activeDevices");
      } else if ($state.params.name === "your-account") {
        $scope.filterSetting("yourAccount");
      } else if ($state.params.name === "email-subscriptions") {
        $scope.filterSetting("emailSubscription");
      } else if ($state.params.name === "my-orders") {
        $scope.filterSetting("myOrder");
      } else if ($state.params.name === "my-quizzes") {
        $scope.filterSetting("quizzes");
      } else if ($state.params.name === "videos-watched") {
        $scope.filterSetting("videosWatched");
      } else if ($state.params.name === "main") {
        // console.log(screen.width);

        // console.log($scope.sidebar, $scope.responsive);

        $scope.filterSetting("");
      }
    }
    new WOW().init();
  }
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('playerVimeoController', ['courseDetailService','$scope', '$http', '$state', 'CustomStorageService', 'DownloadPopupService','$rootScope','Upload', '$sails','deviceDetector','$filter', '$timeout','$interval', 'env', function(courseDetailService,$scope, $http, $state, CustomStorageService, DownloadPopupService,$rootScope,Upload,$sails,deviceDetector,$filter, $timeout,$interval, env) {
    $scope.waterMark  = false;
    $scope.popupDiv = false;
    $scope.controlsHidden = false;
    $scope.showTerm = false;
    $scope.value = 0;
    $scope.selectedPlaybackRate = 1;
    $scope.qualityDrp = false;
    $scope.progressed = 0;
    $scope.buffered = 0;
    var clickScreenChange = false;
    var pauseByUpdateProgress = false;
    $interval(function(){  
      if($scope.waterMark){
        $scope.waterMark  = false;
      }
   }, 10000);

   $interval( function(){
      if(!$scope.waterMark) 
        $scope.waterMark = true;
    }, 60010)

    // setTimeout( function(){
    //   if(!$scope.controlsHidden)
    //     $scope.controlsHidden = true;
    //     $scope.playbackOpt = false;
    //     $scope.quality = false;
    //     $scope.qualityDrp = false;
    // }, 4000)
    $scope.showQualityDropdown = function (){
      $scope.qualityDrp = !$scope.qualityDrp
      $scope.closePlayback();
      $scope.closeQuality();
    }

    $scope.clickBar = function(){
      // if($rootScope.isMobile ) {
      //   if($scope.controlsHidden) {
      //     setTimeout(function() {
      //       if(!$scope.qualityDrp) {
      //         $scope.controlsHidden = true;
      //       }
      //     }, 2000)
      //   }
      //   if(!$scope.qualityDrp) {
      //     $scope.controlsHidden = !$scope.controlsHidden;
      //   }
      // }
      $scope.controlsHidden = !$scope.controlsHidden;
      $scope.qualityDrp = false;
      $scope.quality = false;
      $scope.playbackOpt = false;
      $scope.closePlayback();
      $scope.closeQuality();
    }

    $scope.showBar = function(){
      if(!$rootScope.isMobile && !$scope.isFullScreen) {
        $scope.controlsHidden = false;
      }
    }

    $scope.hideBar = function(){
      if(!$rootScope.isMobile && !$scope.isFullScreen) {
        if(!$scope.qualityDrp) {
          $scope.controlsHidden = true;
        }
      }
    }

    $scope.controllBarLeave = function() {
      if(!$rootScope.isMobile) {
        if(!$scope.qualityDrp) {
          $scope.controlsHidden = true;
        }
      }
    }

    $scope.controllBarOver = function(){
      if(!$rootScope.isMobile) {
        $scope.controlsHidden = false;
      }
    }

    var vm = this;
    vm.data = deviceDetector;
    vm.allData = JSON.stringify(vm.data, null, 2);
    var mediaPlayer = new MediaPlayer();
    var date = new Date();
    var isPlaying = false;
    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    $scope.stamp = monthNames[date.getMonth()]+'-'+date.getFullYear();
    var statSavingCheck = true;

    
    //mediaPlayer.init(document.querySelector("#video"));
    
    var volumeBar = document.getElementById("volume-bar");
    var seekBar = document.getElementById("seek-bar");
    var bufferBar = document.getElementById("buffer-bar");
    $scope.isMute;
    $scope.playbackVal;
    $scope.qualities = [];
    $scope.player;
    $scope.SeekBarValue = 1;
    $scope.volumeBarValue = 1;
    $scope.videoDuration = 1;
    $scope.loader = true;
    $scope.isPaused = true;
    $scope.showData = false;
    $scope.rate = '1x';
    var videoHeight = 0;
    var userVol = 1;
    $scope.playbackValTest = 1;
    $scope.playbackVal = 1;
    $scope.playbackOpt = false;
    $scope.quality = false;
    $scope.loadPercentage = 0;
    $scope.playCount = 0;
    $scope.showIt = true;
    $scope.selectedQuality = "";
    $scope.selectQC = true;

    // document.getElementById('playBtn').style.display = 'none';
    // document.getElementById('pauseBtn').style.display = 'block';

    // document.getElementById('volBtn').style.display = 'block';
    // document.getElementById('muteBtn').style.display = 'none';

    // document.getElementById('fullScrBtn').style.display = 'block';
    // document.getElementById('exitFlScrBtn').style.display = 'none';

    document.getElementById('loader-two').style.display = 'none';
    // document.getElementById('button-bar').style.display = 'none';

    // document.getElementById('play-iccon').style.display = 'none';

    var isFirst = true;

    var coursePurchasedReq = false ;
    $scope.closePopup = function() {
      $scope.popupDiv = false;
    }
    $scope.openApp = function() {
      $scope.popupDiv = false;
      DownloadPopupService.openApp();
    }
    $scope.DownloadApp = function() {
      DownloadPopupService.downloadApp();
      $scope.popupDiv = false;
    }

    $scope.initialize = function() {
      $scope.show=false;
      if(!$scope.firstTime ||  CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        var id = CustomStorageService.getUserInfoStorageData().id;
        var str = CustomStorageService.getUserInfoStorageData().name || CustomStorageService.getUserInfoStorageData().full_name
        $scope.imageInitial = str.charAt(0).toUpperCase();
        var userTemp = CustomStorageService.getUserInfoStorageData();
        // var dateUSer = new Date("2015-03-25")
        $scope.userInfo = userTemp.email +" , " + userTemp.phone + " , " + dateFormate(new Date());
      } else {
        $scope.imageInitial = 'N';
      }
      $scope.showTerm = CustomStorageService.getTermStatus();
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      var schoolName = $state.params.schoolName;
      schoolName = schoolName.toLowerCase();
      var course = $state.params.courseName;
      course = course.toLowerCase();
      var module_no = $state.params.moduleNo;
      var video_no = $state.params.video_no;
      var url = instName + '/' + schoolName + '/' + course;
      var chapter_no = 0;
      if($state.params.chapterNo){
        chapter_no = $state.params.chapterNo;
        $scope.VideoURL = url  + '/' + module_no + '/' +chapter_no + '/' + video_no;
      } else{
        $scope.VideoURL = url  + '/' + module_no + '/' + video_no;
      }

      var goToVelocityStatus = JSON.parse(sessionStorage.getItem('goToVelocity'));
      if(goToVelocityStatus && goToVelocityStatus.condition && CustomStorageService.getUserSignedInStorageData()){
        $scope.redirectUrlLms = goToVelocityStatus.redirect;
        $scope.goToVelocity()
      }
      
      const width = window.screen.width * window.devicePixelRatio
      const height = window.screen.height * window.devicePixelRatio;

      $http({
        url: 'api/v1/courses/getModuleByIndexUrl',
        method: "GET",
        params: {url: url,module_no:module_no,user_id:id,m_id:CustomStorageService.getModule(),width: width,height: height}
      }).then( function(data){
        if(data.data.coursePurchased) {
            coursePurchasedReq = data.data.coursePurchased.purchased;
        }
        if(data.data.notSignedIn && data.data.paid){
          showLoginPopup();
          return false;
        }
        if(data.data.courseData && data.data.courseData.modules.length > 0){
          if(data.data.courseData.allow_on_web || data.data.courseData.modules[0].module_type.free) {
            $scope.course = data.data.courseData;
            $scope.displayAd = $scope.course.display_ads;
            if($scope.displayAd){
              loadAd();
            }
            if(!$scope.firstTime){
              if(!data.data.enrolled){
                if(data.data.courseData.special){
                  var type = "CA";
                } else {
                  var type = "UNI";
                }
                courseDetailService.swalGetEnrolledPopup(data.data.courseData.id,'player',type);
                return false;
              }
            }
            // data.data.moduleData.module_type.free
            if($scope.course.modules[0].module_type.free || coursePurchasedReq || $scope.course.modules[0].module_type.purchased){
              $scope.module_id = $scope.course.modules[0].id;
              $scope.moduleName = $scope.course.modules[0].name;
              if($state.params.chapterNo){
                $scope.chapters = data.data.content.chapters;
                for (var i in $scope.chapters){
                  if($scope.chapters[i].chapter_no == chapter_no){
                    $scope.videos = $scope.chapters[i].videos
                    break;
                  }
                }
              }
              else{
                if(data.data.content.videos){

                  $scope.videos = data.data.content.videos;
                }
              }
              $scope.noOfVideos = $scope.videos.length;
              var x = 0;

              for(var i in $scope.videos){

                if($scope.videos[i].video_no == video_no){
                  $scope.selectedVideo = $scope.videos[i];
                  x = 1;
                  if(!$scope.firstTime){
                    var data = {video_id: $scope.videos[i].id, viewed_by: CustomStorageService.getUserInfoStorageData().id};
                    $http.post('api/v1/cvideos/userViewedVideo', data)
                    .then(function(data) {
                      var userInfo = CustomStorageService.getUserInfoStorageData();
                      if(!userInfo.profileLevel){
                        if(userInfo.updated){
                          userInfo.profileLevel = 3;
                        } else {
                          userInfo.profileLevel = 0;
                        }
                        CustomStorageService.setUserInfoStorageData(userInfo);
                      }
                      if(data.data.count > 2 && userInfo.profileLevel < 7  && $scope.course.special && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else  if(data.data.count > 2 && userInfo.profileLevel < 3 && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else {
                        /*if(vm.data.os ==='ios') {
                          swal({
                            title: 'Iphone detect',
                            type: 'info',
                            customClass: 'sweet-alert-one',
                            showCancelButton:false
                          },function(){
                            $scope.goToCourse();
                          });

                        } else {  */                      
                          //mediaPlayer.load({url: $scope.videos[i].url_mpd});
                            var options01 = {
                              id: $scope.videos[i].vss_id,
                              controls: false
                            };
                            var vvsPlayer01 = new Vimeo.Player('example-vimeo', options01);
                            vvsPlayer01.on("loaded", function(data) {
                              vvsPlayer01.getDuration().then(function(duration) {
                                $scope.videoDuration = duration;
                                var totalDuration = secondsToHmsForVideo(
                                  $scope.videoDuration
                                );
                                var timeDisplay = "0:00/" + totalDuration;
                                document.getElementById("current-time")
                                  ? (document.getElementById("current-time").innerHTML = timeDisplay)
                                  : "";
                              })
                              $scope.player.setVolume(1);
                              $scope.player.getQualities().then(function(qualities){
                                $scope.qualities = qualities;
                                $scope.playbackVal = $scope.qualities[0].id;
                              });
                            });
                            vvsPlayer01.on("timeupdate", function(data) {
                              CustomStorageService.setFirstTimeStorageData(true);
                              if(!$scope.disableTimeUpdate) {
                                document.getElementById("seek-bar").value = data.percent * 100;
                              }
                              var formattedTime = secondsToHmsForVideo(data.seconds);
                              var totalDuration = secondsToHmsForVideo(
                                $scope.videoDuration
                              );
                              var timeDisplay = formattedTime + "/" + totalDuration;
                              document.getElementById("current-time")
                                ? (document.getElementById("current-time").innerHTML = timeDisplay)
                                : "";
                              $scope.progressed= data.percent * 100;

                                vvsPlayer01.getBuffered().then(function(buffered) {
                                  if(buffered.length > 0) {
                                    buffered.forEach(function(buffer) {
                                      if(data.seconds > buffer[0] && data.seconds < buffer[1]) {
                                        $scope.buffered = (buffer[1] / data.duration) * 100;
                                      }
                                    });
                                    
                                  }
                                }).catch(function(error) {
                                });
                            });
                            vvsPlayer01.on('play', function() {
                              $scope.isPaused = false;
                              document.getElementById('loader-two').style.display = 'none';
                              document.getElementById('play-iccon').style.display = 'none';
                              
                              if(statSavingCheck){
                                var data = {
                                  user_id: CustomStorageService.getUserInfoStorageData().id,
                                  video_id: $scope.selectedVideo.id,
                                  chapter_id: $state.params.chapterNo,
                                  module_id: $state.params.moduleNo,
                                  watching_on: 'vvs vimeoPlayer'
                                }
                                $http.post('/api/v1/apps/saveVideoWatchStats',data)
                                .then(function(data){
                                  statSavingCheck = false;
                                });
                              }
                            });
                            vvsPlayer01.on("pause", function(data) {
                              if(!pauseByUpdateProgress && !clickScreenChange) {
                                $scope.isPaused = true;
                                document.getElementById('play-iccon').style.display = 'block';
                              }
                              clickScreenChange = false;
                            })
                            $scope.player = vvsPlayer01;
                        //}
                      }
                    });

                    $http({
                      url:'api/v1/cvideos/checkRating',
                      method: "GET",
                      params: {vid: $scope.selectedVideo.id,uid:CustomStorageService.getUserInfoStorageData().id}
                    }).then(function(data){
                      $scope.userRatedVideo = data.data.check;
                    })
                  } else {
                    /*if(vm.data.os ==='ios') {
                      swal({
                        title: 'Iphone detect',
                        text: "video page is maintenance for iphone",
                        type: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton:false
                      },function(){
                        $scope.goToCourse();
                      });

                    } else {*/
                      //mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                      var options01 = {
                        id: $scope.selectedVideo.vss_id,
                        controls: false
                      };
                      var vvsPlayer02 = new Vimeo.Player('example-vimeo', options01);
                      $scope.player = vvsPlayer02;
                      vvsPlayer02.on("loaded", function(data) {
                        vvsPlayer02.getDuration().then(function(duration) {
                          $scope.videoDuration = duration;
                          var totalDuration = secondsToHmsForVideo(
                            $scope.videoDuration
                          );
                          var timeDisplay = formattedTime + "0:00/" + totalDuration;
                          document.getElementById("current-time")
                            ? (document.getElementById("current-time").innerHTML = timeDisplay)
                            : "";
                        })
                        $scope.player.getQualities().then(function(qualities){
                          $scope.qualities = qualities;
                          $scope.playbackVal = $scope.qualities[0].id;
                        });
                        $scope.player.setVolume(1);
                      });
                      vvsPlayer02.on("timeupdate", function(data) {
                        CustomStorageService.setFirstTimeStorageData(true);
                        if(!$scope.disableTimeUpdate) {
                          document.getElementById("seek-bar").value = data.percent * 100;
                        }
                        
                        $scope.isPaused = false;
                        $scope.videoDuration = data.duration;
                        var formattedTime = secondsToHmsForVideo(data.seconds);
                        var totalDuration = secondsToHmsForVideo(
                          $scope.videoDuration
                        );
                        var timeDisplay = formattedTime + "/" + totalDuration;
                        document.getElementById("current-time")
                          ? (document.getElementById("current-time").innerHTML = timeDisplay)
                          : "";
                        $scope.progressed= data.percent * 100;

                        vvsPlayer02.getBuffered().then(function(buffered) {
                            if(buffered.length > 0) {
                              buffered.forEach(function(buffer) {
                                if(data.seconds > buffer[0] && data.seconds < buffer[1]) {
                                  $scope.buffered = (buffer[1] / data.duration) * 100;
                                }
                              });
                            }
                          }).catch(function(error) {
                          });
                      });
                      vvsPlayer02.on('play', function() {
                        $scope.isPaused = false;
                        document.getElementById('loader-two').style.display = 'none';
                        document.getElementById('play-iccon').style.display = 'none';
                        
                        if(statSavingCheck){
                          var data = {
                            user_id: CustomStorageService.getUserInfoStorageData().id,
                            video_id: $scope.selectedVideo.id,
                            chapter_id: $state.params.chapterNo,
                            module_id: $state.params.moduleNo,
                            watching_on: 'vvs vimeoPlayer'
                          }
                          $http.post('/api/v1/apps/saveVideoWatchStats',data)
                          .then(function(data){
                            statSavingCheck = false;
                          });
                        }
                      });
                      vvsPlayer02.on("pause", function(data) {
                        if(!pauseByUpdateProgress && !clickScreenChange) {
                          $scope.isPaused = true;
                          document.getElementById('play-iccon').style.display = 'block';
                        }
                        clickScreenChange = false;
                      })
                      
                    //}
                    // mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                          
                  }
                  $http({
                    url: 'api/v1/cvideos/getVideoViews',
                    method: "GET",
                    params: {id: $scope.videos[i].id}
                  }).then(function(data){
                    $scope.view_count = data.data.view + 112;
                    $scope.attachments = data.data.attachments;
                    $scope.showData = true;
                    if(!$scope.$$phase) $scope.$apply();
                  })
                  var send_data ={
                    id:$scope.selectedVideo.id,
                  }
                  if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
                    send_data['user_id'] = CustomStorageService.getUserInfoStorageData().id;
                  }
                  // $http({
                  //   url: 'api/v1/comments/getComments',
                  //   method: "GET",
                  //   params: send_data
                  // }).then(function (data) {
                  //   $scope.user_type=data.data.user_type;
                  //   if(data.data.isInstructor){
                  //     $scope.isInstructor = true;
                  //     $scope.comments=data.data.comments;
                  //     $scope.AllComments=data.data.comments.allComments;
                  //   } else {
                  //     $scope.AllComments=data.data.comments;
                  //   }
                  // });
                  break;
                }
              }
              if(x==0){
                swal({
                  title: "Information",
                  text: "Video does not exist",
                  type: "info",
                  showCancelButton:false
                },function(){
                  $scope.goToModule();
                });
              }
            }
            else{
              swal({
                title: "Information",
                text: "Please purchase this module to view videos",
                type: "info",
                showCancelButton:false
              },function(){
                $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
              });
            }
          } else {
            $scope.popupDiv = true;
          }
        }
        else if(data.data.courseData){
          $rootScope.moduleNotExist = true;
          $scope.goToCourse();
        }
        else{
          $state.go('404');
        }
      })
    }

    $scope.goToVelocity = function(){
      var user = CustomStorageService.getUserInfoStorageData();
      var token = CustomStorageService.getAuthTokenStorageData();
      if(user && token){
      // return false;
      var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl='
      if($scope.redirectUrlLms){
        url += $scope.redirectUrlLms
      }
      window.open(url, '_self')
      sessionStorage.removeItem('goToVelocity');
      }else{
        sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true }));
        showLoginPopup();
      }
    };

    $scope.swithToOldPlayer = function() {
      if($state.params.chapterNo) {
        $state.go('video_player_chapter', $state.params, { reload: true })
      } else {
        $state.go('video_player', $state.params, { reload: true })
      }
    }

    $scope.change = function(value){
      $scope.selected=value;
      if(value==1)
      $scope.AllComments=$scope.comments.allComments;
      else if(value==2)
      $scope.AllComments=$scope.comments.approved;
      else if(value==3)
      $scope.AllComments=$scope.comments.pending;
      else if(value==4)
      $scope.AllComments=$scope.comments.hidden;
    }

    $scope.showDetailPassword = function(password){
      swal({
        title: "Info!",
        text: "Dear Student, Due to excessive bot attacks and data breach attempts, we have added an additional security layer of adding a password for the videos for few days. Please copy-paste the password as shown, and enjoy your course.",
        type: "info",
        showConfirmButton: true,
      }, function() {
        swal.close();
      }); 
    }

    $scope.acceptTerm = function() {
      DownloadPopupService.acceptTerm({video_id: $scope.selectedVideo.id});
      $scope.showTerm = true;
    }
    

    function dateFormate (dat) {
      var date = new Date(dat)
      var yyyy = date.getFullYear();
      var mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1); // getMonth() is zero-based
      var dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return dd + '-' + mm + '-' + yyyy + ' ' + hh + ':'+ min + ':' + ss;
      // return "".concat(yyyy).concat(mm).concat(dd).concat(hh).concat(min).concat(ss);
    }
    var secondsToHmsForVideo = function(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
  
      var hDisplay = h > 0 ? h + ":" : "";
      var mDisplay = m > 0 ? m + ":" : "00:";
      var sDisplay = s == 0 || s < 10 ? "0" + s : s;
      return hDisplay + mDisplay + sDisplay;
    }
    // $scope.fullScreen = function(){
    //   var div = document.getElementById('cont-video-landing');
    //   videoHeight = div.clientHeight;
    //   if (div.requestFullscreen) {
    //     div.requestFullscreen();
    //   } else if (div.mozRequestFullScreen) {
    //     div.mozRequestFullScreen(); // Firefox
    //   } else if (div.webkitRequestFullscreen) {
    //     div.webkitRequestFullscreen(); // Chrome and Safari
    //   }
    //   $scope.isFullScreen = true;
    //   document.getElementById('fullScrBtn').style.display = 'none';
    //   document.getElementById('exitFlScrBtn').style.display = 'block';
    //   div.style.height= 100 + '%';
    //   video.style.height = 100 + '%';
    // }

    // $scope.exitFulScreen = function(){
    //   if (document.cancelFullScreen) {
    //     document.cancelFullScreen();
    //   } else if (document.mozCancelFullScreen) {
    //     document.mozCancelFullScreen();
    //   } else if (document.webkitCancelFullScreen) {
    //     document.webkitCancelFullScreen();
    //   }
    //   $scope.isFullScreen = false;
    //   document.getElementById('fullScrBtn').style.display = 'block';
    //   document.getElementById('exitFlScrBtn').style.display = 'none';
    //   var div = document.getElementById('cont-video-landing');
    //   div.style.height= videoHeight + '%';
    //   video.style.height = videoHeight + '%';
    // }

    // $scope.mute = function(){
    //   if(!video.muted){
    //     document.getElementById('volBtn').style.display = 'none';
    //     document.getElementById('muteBtn').style.display = 'block';
    //     userVol = video.volume;
    //     video.muted = true;
    //     video.volume = 0;
    //     volumeBar.value = video.volume;
    //   }
    //   else{
    //     video.muted = false;
    //     document.getElementById('volBtn').style.display = 'block';
    //     document.getElementById('muteBtn').style.display = 'none';
    //     video.volume = userVol;
    //     volumeBar.value = video.volume;
    //   }
    // }

    $scope.showVolBar = function() {
      $scope.showVloBar = true;
    }

    $scope.hideVolBar = function() {
      $scope.showVloBar = false;
    }

    $scope.showPlaybackOptions = function () {

      if ($scope.playbackOpt) {
        // $scope.playbackOpt = false;
        $scope.showIt = false;
        document.getElementById("dropdown-menu").style.display = "block";
        document.getElementById("qualityParent").style.background = "transparent";
      } else {
        $scope.quality = false;
        $scope.playbackOpt = true;
        $scope.showIt = false;
        document.getElementById("dropdown-menu").style.display = "block";
        document.getElementById("qualityParent").style.background = "transparent";
      }
    }

    $scope.closePlayback = function () {
      $scope.playbackOpt = false;
      $scope.showIt = true;
      document.getElementById("dropdown-menu").style.display = "none";
      document.getElementById("qualityParent").style.background = "#0000009c";
    }

    $scope.closeQuality = function(){
      $scope.playbackOpt = false;
      $scope.quality = false;
      $scope.showIt = true;
      document.getElementById("dropdown-menu").style.display = "none";
      document.getElementById("qualityParent").style.background = "#0000009c";
    }
    $scope.showQualityOptions = function () {
      if ($scope.quality) {
        $scope.quality = false;
        $scope.showIt = false;
        document.getElementById("dropdown-menu").style.display = "block";
        document.getElementById("qualityParent").style.background = "transparent";
      } else {
        $scope.showIt = false;
        $scope.quality = true;
        document.getElementById("dropdown-menu").style.display = "block";
        document.getElementById("qualityParent").style.background = "transparent";
      }
    }

    $scope.playBackRate = function (value) {
      $scope.qualityDrp = !$scope.qualityDrp;
      $scope.showIt = true;
      $scope.playbackOpt = false;
      $scope.playbackVal = value;
      $scope.selectedPlaybackRate = value;
      $scope.player.setPlaybackRate(value);
      setTimeout(function () {
        document.getElementById('dropdowneMenuClick').click();
      }, 500)

    }

    /* mediaPlayer.addEventListener("state_changed", function(event) {
      if(event.detail.state === "playing") {
        $scope.playCount += 1;
        if($scope.playCount > 1) {
          document.getElementById('load-perccentage').innerHTML = 100+'%';
          clearInterval($scope.loadInterval);
          setTimeout(function() {
            document.getElementById('loader-two').style.display = 'none';
            document.getElementById('load-perccentage').style.display = 'none';
          }, 200)
        }
      }
    }); */

    /* seekBar.addEventListener("mousedown", function() {
      video.pause();
      document.getElementById('playBtn').style.display = 'block';
      document.getElementById('pauseBtn').style.display = 'none';
    });

    seekBar.addEventListener("mouseup", function() {
      video.play();
      document.getElementById('playBtn').style.display = 'none';
      document.getElementById('pauseBtn').style.display = 'block';
    });

    video.addEventListener("waiting", function() {
      document.getElementById('loader-two').style.display = 'block';
    });

    video.addEventListener("playing", function() {
      if($scope.playCount > 1) {
        document.getElementById('loader-two').style.display = 'none';
      }
    }); */

    /* video.addEventListener("timeupdate", function() {
      CustomStorageService.setFirstTimeStorageData(true);
      var value = (100 / video.duration) * video.currentTime;
      seekBar.value = value;
      if($scope.loader == false){
        var bufferedEnd = video.buffered.end(video.buffered.length - 1);
        var duration =  video.duration;
        if (duration > 0) {
          var value = (100 / video.duration) * bufferedEnd;
          bufferBar.value = value;
        }
      }
      var seconds = video.duration - video.currentTime;
      var m = Math.floor(seconds / 60) < 10 ? '0' + Math.floor(seconds / 60) : Math.floor(seconds / 60);
      var s = Math.floor(seconds - (m * 60)) < 10 ? '0' + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
      document.getElementById("timeLeft").innerHTML = '-' + m + ':' + s;
      if((video.duration - video.currentTime) == 0){
        nextVideo();
      }
    }); */

    // $scope.updateProgress = function(value){
    //   var time = video.duration * (value / 100);
    //   video.currentTime = time;
    // }

    // volumeBar.addEventListener("change", async function(value) {
    //   $scope.changeVolume(value);
    // });

    // seekBar.addEventListener("change", function() {
    //   var time = video.duration * (seekBar.value / 100);
    //   video.currentTime = time;
    // });

    $scope.handleClick = function(evt) {
      switch(evt.which) {
        case 3:
        break;
        case 1:
        if($scope.loader == false){
          $scope.videoInFocus = true;
          $scope.play_pause();
        }
        break;
      }
    };

    window.addEventListener("keydown",handleKeyboard, false);

    function handleKeyboard(e){
        if(e.keyCode == 37){
          e.preventDefault();
          $scope.skipRwdVideo(15);
        }
        else if(e.keyCode == 39){
          e.preventDefault();
          $scope.skipFwdVideo(15);
        }
        else if(e.keyCode == 38){
          if($scope.volumeBarValue < 1){
            var increasedVol = $scope.volumeBarValue + 0.1;
            $scope.changeVolume(increasedVol);
          }
        }
        else if(e.keyCode == 40){
          if($scope.volumeBarValue > 0){
            var decreasedVol = $scope.volumeBarValue - 0.1;
            $scope.changeVolume(decreasedVol);
            
          }
        }
        else if(e.keyCode == 32){
          e.preventDefault();
          $scope.playPauseVideo();
        }
        else if(e.keyCode == 77){
          $scope.mute();
        }
    }

    //video.addEventListener("ended",nextVideo,false);

    function nextVideo() {
      if(!$scope.userRatedVideo && !$scope.firstTime){
        $scope.userVideoRating = true;
        if (!$scope.$$phase) $scope.$apply();
        return false;
      } else {
        if(!$scope.firstTime && !localStorage.userSignedIn && !CustomStorageService.getInstructorSignedInStorageData()){
          var x = parseInt($state.params.video_no);
          if(x+1 <= $scope.videos.length){
            for(var i in $scope.videos){
              if(x == $scope.videos[i].video_no){
                $scope.showVideo($scope.videos[+i+1]);
              }
            }
          } else {
            $scope.goToModule();
          }
        } else {
          swal({
            text: 'Looks like you are not logged in, Please login to continue',
            type: 'info',
            title: 'Information'
          },function(){
            swal.close();
            $scope.displayNextVideo = true;
            showLoginPopup();
          })
        }
      }
    }

    $scope.approveComment = function (id)
    {
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/approveComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideShow = function(comment)
    {
      if(comment.showReply)
      comment.showReply=false;
      else
      comment.showReply=true;
    }

    $scope.hideShowReply = function(reply)
    {
      if(reply.showReply)
      reply.showReply=false;

      else {
        reply.showReply=true;
      }
    }

    $scope.instructorReply=function(text,id,reply)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        var params = {
          user_id: CustomStorageService.getUserInfoStorageData().id,
          text: text,
          video_id: $scope.selectedVideo.id,
          image_url:$scope.commentImage,
          comment_id:id
        }
        if($scope.user_type =='student'){
          var url = 'api/v1/comments/addReply';
        } else {
          var url = 'api/v1/comments/instructorReplyComment';
        }

        $http.post(url,params)
        .then(function(data){
          if(data.status==200)
          {
            reply.showReply=false;
            $scope.replyText=""
            swal({
              title: "Reply",
              text: "Reply posted",
              type: "info",
              showCancelButton:false
            },function(){
            });
          }
        })

      } else {
        swal("Error","Please login to comment","error");
      }
    }


    $scope.goToCourse = function(){
      var instName = $state.params.institutionName;
      var schoolName = $state.params.schoolName;
      var course = $state.params.courseName;
      $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course},{reload:true});
    };

    $scope.goToModule = function(){
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
    }

    $scope.$on('userLoggedIn', function( event, message ){
      if(!$scope.displayNextVideo && !$scope.displaySelectedVideo){
        location.reload();
      } else if(!$scope.displaySelectedVideo){
        $scope.firstTime = false;
        nextVideo();
      } else if(!$scope.displayNextVideo){
        $scope.firstTime = false;
        $scope.showVideo($scope.videoSelectedData);
      }
    });

    $scope.$on('closeForm', function( event, message ){
      $state.go('Home',{},{reload:true});
    });

    /* $scope.$on('$stateChangeStart', function (event) {
      video.pause();
      mediaPlayer.reset();
      mediaPlayer = null;
    }); */

    $scope.showVideo = function(video){
      if(!$scope.firstTime){
        //mediaPlayer.reset();
        if(video.type == 'quiz'){
          $state.go('quiz',{quiz_id: video.id});
        } else {
          if($state.params.chapterNo){
            if(video.vss_link){
              $state.go('vimeo_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('videojs_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }
          }else{
            if(video.vss_link){
              $state.go('vimeo_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('videojs_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }
          }
        }
      } else {
        swal({
          text: 'Looks like you are not logged in, Please login to continue',
          type: 'info',
          title: 'Information'
        },function(){
          swal.close();
          if(video.type == 'quiz') {
            $scope.displaySelectedVideo = true;
            $scope.videoSelectedData = video;
            var redirecturl = 'quiz/standard-quiz-main/' + video.session_id;
            sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          } else {
            $scope.displaySelectedVideo = true;
            $scope.videoSelectedData = video;
            var redirecturl = 'course/' + $scope.course.modules[0].index_url + '/' + $scope.course.modules[0].id+ '/' + video.id +'?courseIndexUrl=' + $scope.course.index_url;
            sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          }
          showLoginPopup();
          if(!$scope.$$phase) $scope.$apply();
        })
      }
    }

    $scope.zipAttachments = function(id){
      var video_name = $scope.selectedVideo.name;
      video_name = video_name.split(' ').join('+');
      var win = window.open('https://nearpeer-zips.s3.amazonaws.com/zips/module' + $scope.module_id + '/' + video_name + '-' +id+'.zip', '_blank');
    }

    $scope.addImage = function(image){
      if(image)
      {
        if(CustomStorageService.getUserSignedInStorageData()|| CustomStorageService.getInstructorSignedInStorageData()){
          $scope.imageUploadingInProcess =  true;
          if(!$scope.$$phase) $scope.$apply();
          Upload.upload({
            url: 'api/v1/uploader/uploadImageToS3?userId='+CustomStorageService.getUserInfoStorageData().id + '&socket_id=' + CustomStorageService.getSocketIdStorageData(),
            method: "POST",
            file: image
          }).then(function(data){
            $scope.imageUploadingInProcess = false;
            $scope.commentImage = data.data.link;
            if(!obj){
              $scope.commentImage = data.data.link;
            } else {
              obj.replyImage_url = data.data.link;
            }
            if(!$scope.$$phase) $scope.$apply();
          });
        }
      }

    }

    $scope.$on('internetConnectivityLost', function( event, message ){
      video.pause();
    });

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }
    $scope.$on('internetFound', function( event, message ){
    });

    $scope.dblClick = function(){
      if($scope.loader == false){
        if($scope.isFullScreen){
          $scope.exitFulScreen();
        } else {
          $scope.fullScreen();
        }
      }
    };

    $scope.addComment =function(text)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if(!text){
          swal("Empty Comment","Please add text","info");
          return false;
        }
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        if($scope.user_type=="student")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addComment';
          // $scope.showData = false;
          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.showData = true;
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment Published",
          //       text: "Your comment will appear once it has been approved by the instructor",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })

        }

        else if($scope.user_type=="instructor")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addInstructorComment';

          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment",
          //       text: "Comment posted",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })


        }
      } else {
        swal("Error","Please login to comment","error");
      }
    }

    document.addEventListener('fullscreenchange', exitHandler);
document.addEventListener('webkitfullscreenchange', exitHandler);
document.addEventListener('mozfullscreenchange', exitHandler);
document.addEventListener('MSFullscreenChange', exitHandler);

    function exitHandler() {
      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        ///fire your event
        $scope.isFullScreen = false;
      }
    }

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }

    /* document.getElementById("cont-video-landing").addEventListener("mousemove", showHoveDiv);
    document.getElementById("cont-video-landing").addEventListener("mouseleave",hideHoverDiv); */

    function hideHoverDiv(){
      var element = document.getElementById('overlay-cont');
      element.classList.remove("hideDiv");
    }

    function showHoveDiv(event){
      var element = document.getElementById('overlay-cont');
      element.classList.add("hideDiv");
      element.classList.remove("cursorNone");
      $scope.xCord = event.clientX;
      $scope.yCord = event.clientY;
      setTimeout(function(){
        var xCord = event.clientX;
        var yCord = event.clientY;
        if(xCord == $scope.xCord && yCord == $scope.yCord){
          var element = document.getElementById('overlay-cont');
          element.classList.remove("hideDiv");
        }
      },5000)
    }

    $scope.hideComment = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideReply = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableReply',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.getInitialLetter = function(str){
      return str.charAt(0).toUpperCase();
    }

    var showLoginPopup = function(){
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }

    $sails.on('imageUploadProgress',function(data){
      $scope.imageUploadLog.progress = data;
      if(!$scope.$$phase) $scope.$apply();
    })

    var adVideo = document.getElementById("video-ad");
    var adSeekBar = document.getElementById("seek-bar-ad");
    var timer = 5;

    $scope.skipAd = function(){
      if(timer == 0){
        showOriginalVideo();
      }
    }

    /* adVideo.addEventListener("timeupdate", function() {
      if(timer > 0){
        document.getElementById("skip-ad-time").innerHTML = timer - parseInt(adVideo.currentTime);
      }
    }); */

    //adVideo.addEventListener("ended",showOriginalVideo,false);

    function showOriginalVideo(){
      $scope.displayAd = false;
      if(!$scope.$$phase) $scope.$apply();
      if(!$scope.mobileView){
        document.getElementById('video-loader-two').style.display = 'block';
        document.getElementById('button-bar').style.display = 'block';
        video.play()
      } else {
        document.getElementById('play-iccon').style.display = 'block';
      }
    }

    var loadAd = function(){
      $scope.showGifAd = true;
      document.getElementById('play-iccon').style.display = 'none';
      document.getElementById('video-loader-two').style.display = 'none';
      adVideo.src = 'images/Illys_sponsorship.mp4';
      adVideo.play();
    }

    if (window.screen.width > 320 && window.screen.width < 1024) {
      $scope.mobileView = true;
      //video.addEventListener("canplay",playVid,false);
    } else{
      //video.addEventListener("play",firstTime,false);
    }

    if(!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()){
      if(!CustomStorageService.getFirstTimeStorageData()){
        $scope.firstTime = true;
        $scope.initialize();
      } else {
        var instName = $state.params.institutionName;
        var schoolName = $state.params.schoolName;
        var course = $state.params.courseName;
        $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course});
      }
    } else{
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo});

    }

    $scope.setVideoQuality = function (val) {
      // $scope.selectedQuality = $scope.qualities[val].label;
      $scope.qualityDrp = !$scope.qualityDrp;
      $scope.showIt = true;
      $scope.selectQC = false;
      $scope.selectedQuality = val.label;
      $scope.playbackValTest = val.id;
      $scope.player.setQuality(val.id);
      $scope.quality = false;
      setTimeout(function () {
        document.getElementById('dropdowneMenuClick').click();
      }, 500)
    }
    $scope.skipFwdVideo = function () {
      $scope.player.getCurrentTime().then(function(currentTime){
        $scope.player.getDuration().then(function(duration){
          if (currentTime + 15 < duration) {
            // this.video.pause();
            $scope.player.setCurrentTime(currentTime + 15).then(function(time){
            $scope.SeekBarValue = time;
            });
          }
        });
      });
  
    }
    $scope.skipRwdVideo =  function () {
      $scope.player.getCurrentTime().then(function(currentTime){
        if (currentTime - 15 > 0) {
          // this.video.pause();
          $scope.player.setCurrentTime(currentTime - 15).then(function(time){
            $scope.SeekBarValue = time;
          });
        }
      });
    }
    $scope.changeVolume =  function (value) {
      value = +value
      if(value == 0 || value < 0){
      $scope.isMute = true;
      }
      else{
      $scope.isMute = false;
      }
      $scope.volumeBarValue = value;
       $scope.player.setVolume(value);

    }
    $scope.mute = function () {
      $scope.isMute = true;
      $scope.changeVolume(0);
    }
    $scope.unmute = function () {
      $scope.isMute = false;
      $scope.changeVolume(1);
    }
    $scope.updateProgress =  function (value) {
      pauseByUpdateProgress = true;
      $scope.buffered = 0;
      $scope.disableTimeUpdate = true;
      
      document.getElementById('loader-two').style.display = 'block';
      value = +value;
      var time = $scope.videoDuration * (value / 100);
      $scope.progressed= (time /$scope.videoDuration ) * 100;
      $scope.player.setCurrentTime(time).then(function() {
        document.getElementById('loader-two').style.display = 'none';
        pauseByUpdateProgress = false;
      });
    }
    $scope.fullScreen =  function () {
      clickScreenChange = true;
      $scope.isFullScreen = true;
      var div = document.getElementById("cont-video-landing");
      // let videoHeight = div.clientHeight;
      if (div.requestFullscreen) {
        div.requestFullscreen();
      } else if (div.mozRequestFullScreen) {
        div.mozRequestFullScreen(); // Firefox
      } else if (div.webkitRequestFullscreen) {
        div.webkitRequestFullscreen(); // Chrome and Safari
      } else {
        $scope.player.requestFullscreen();
      }
      // div.style.height = 100 + "%";
      // document.getElementById("cont-video-landing").style.height = 100 + "%";

      //  $scope.player.requestFullscreen();
    }
    $scope.exitFulScreen =  function () {
      clickScreenChange = true;
      $scope.isFullScreen = false;
       $scope.player.exitFullscreen();
    }
    $scope.playPauseVideo = function () {
      if($scope.isPaused)
      {
        document.getElementById('loader-two').style.display = 'block';
        document.getElementById('play-iccon').style.display = 'none';
        $scope.player.play();
        $scope.isPaused = false;
      }
      else{
        $scope.player.pause();
        $scope.isPaused = true;
      }
     
    }

  

  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('playerVideojsController', ['courseDetailService','$scope', '$http', '$state', 'CustomStorageService', 'DownloadPopupService','$rootScope','Upload', '$sails','deviceDetector','$filter', '$timeout','$interval', 'env', function(courseDetailService,$scope, $http, $state, CustomStorageService, DownloadPopupService,$rootScope,Upload,$sails,deviceDetector,$filter, $timeout,$interval, env) {
    $scope.waterMark  = false;
    $scope.popupDiv = false;
    $scope.showTerm = false;
    $interval(function(){  
      if($scope.waterMark){
        $scope.waterMark  = false;
      }
   }, 10000);

   $interval( function(){
      if(!$scope.waterMark) 
        $scope.waterMark = true;
    }, 60010)

    $scope.$on("$destroy", function(){
      window.removeEventListener("keydown",handleKeyboard, false);
      var oldPlayer = document.getElementById('example-video');
      videojs(oldPlayer).dispose();
    });

    var vm = this;
    vm.data = deviceDetector;
    vm.allData = JSON.stringify(vm.data, null, 2);
    var mediaPlayer = new MediaPlayer();
    var date = new Date();
    var isPlaying = false;
    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    $scope.stamp = monthNames[date.getMonth()]+'-'+date.getFullYear();
    
    //mediaPlayer.init(document.querySelector("#video"));
    
    var player = videojs('example-video', {
      controlBar: { 
        'pictureInPictureToggle': false
      }
    })
    player.controlBar.playToggle.on('tap', function(e) {
      e.preventDefault()
      $scope.play_pause();
    })
    player.qualityLevels();
    player.seekButtons({
      forward: 15,
      back: 15
    });
    player.maxQualitySelector({
      defaultQuality: 1
    });
    player.on('progress', function() {
      const duration = player.duration()
      const currentTime = player.currentTime()
      const bufferedPercent = player.bufferedPercent() * 100

      const bufferTime = (duration/100) * bufferedPercent;
      if(bufferTime > 10) {
        if(!isPlaying && currentTime === 0) {
          player.pause()
          setTimeout(function() {
            isPlaying = true;
            player.play();
          }, 1000)
        }
      } else {
        isPlaying = false;
      }
    })

    var video = document.getElementById("video");
    var volumeBar = document.getElementById("volume-bar");
    var seekBar = document.getElementById("seek-bar");
    var bufferBar = document.getElementById("buffer-bar");
    $scope.loader = true;
    $scope.showData = false;
    $scope.rate = '1x';
    var videoHeight = 0;
    var userVol = 1;
    $scope.playbackVal = 1;
    $scope.playbackOpt = false;
    $scope.loadPercentage = 0;
    $scope.playCount = 0;

    document.getElementById('playBtn').style.display = 'none';
    document.getElementById('pauseBtn').style.display = 'block';

    document.getElementById('volBtn').style.display = 'block';
    document.getElementById('muteBtn').style.display = 'none';

    document.getElementById('fullScrBtn').style.display = 'block';
    document.getElementById('exitFlScrBtn').style.display = 'none';

    document.getElementById('loader-two').style.display = 'none';
    document.getElementById('button-bar').style.display = 'none';

    document.getElementById('play-iccon').style.display = 'none';

    var isFirst = true;

    var coursePurchasedReq = false ;

    $scope.closePopup = function() {
      $scope.popupDiv = false;
    }
    
    $scope.openApp = function() {
      $scope.popupDiv = false;
      DownloadPopupService.openApp();
    }
    $scope.DownloadApp = function() {
      DownloadPopupService.downloadApp();
      $scope.popupDiv = false;
    }

    $scope.initialize = function() {
      videojs.Hls.xhr.beforeRequest = function(options) {
        options.headers = options.headers || {};
        if(isFirst){
          options.headers['X-Requested-With'] = 'XMLHttpPlayerRequest';
        } else {
          options.headers['X-Requested-With'] = "XMLHttpPlayerRequest-"+ options.headers.Range;
        }
        const baseURI = options.uri.split('/')
        if(!isFirst) {
          options.uri = "/get_video_content?video_url=https://video.nearpeer.org/" + baseURI[baseURI.length - 1]
        }
        isFirst = false;
        return options;
      };
      $scope.show=false;
      if(!$scope.firstTime ||  CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        var id = CustomStorageService.getUserInfoStorageData().id;
        var str = CustomStorageService.getUserInfoStorageData().name || CustomStorageService.getUserInfoStorageData().full_name
        $scope.imageInitial = str.charAt(0).toUpperCase();
        var userTemp = CustomStorageService.getUserInfoStorageData();
        // var dateUSer = new Date("2015-03-25")
        $scope.userInfo = userTemp.email +" , " + userTemp.phone + " , " + dateFormate(new Date());
      } else {
        $scope.imageInitial = 'N';
      }
      $scope.showTerm = CustomStorageService.getTermStatus();
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      var schoolName = $state.params.schoolName;
      schoolName = schoolName.toLowerCase();
      var course = $state.params.courseName;
      course = course.toLowerCase();
      var module_no = $state.params.moduleNo;
      var video_no = $state.params.video_no;
      var url = instName + '/' + schoolName + '/' + course;
      var chapter_no = 0;
      if($state.params.chapterNo){
        chapter_no = $state.params.chapterNo;
        $scope.VideoURL = url  + '/' + module_no + '/' +chapter_no + '/' + video_no;
      } else{
        $scope.VideoURL = url  + '/' + module_no + '/' + video_no;
      }

      var goToVelocityStatus = JSON.parse(sessionStorage.getItem('goToVelocity'));
      if(goToVelocityStatus && goToVelocityStatus.condition && CustomStorageService.getUserSignedInStorageData()){
        $scope.redirectUrlLms = goToVelocityStatus.redirect;
        $scope.goToVelocity()
      }

      const width = window.screen.width * window.devicePixelRatio
      const height = window.screen.height * window.devicePixelRatio;

      $http({
        url: 'api/v1/courses/getModuleByIndexUrl',
        method: "GET",
        params: {url: url,module_no:module_no,user_id:id,m_id:CustomStorageService.getModule(),width: width,height: height}
      }).then(function(data){
        if(data.data.coursePurchased) {
            coursePurchasedReq = data.data.coursePurchased.purchased;
        }
        if(data.data.notSignedIn && data.data.paid){
          showLoginPopup();
          return false;
        }
        if(data.data.courseData && data.data.courseData.modules.length > 0){
          if(data.data.courseData.allow_on_web || data.data.courseData.modules[0].module_type.free) {
            $scope.course = data.data.courseData;
            $scope.displayAd = $scope.course.display_ads;
            if($scope.displayAd){
              loadAd();
            }
            if(!$scope.firstTime){
              if(!data.data.enrolled){
                if(data.data.courseData.special){
                  var type = "CA";
                } else {
                  var type = "UNI";
                }
                courseDetailService.swalGetEnrolledPopup(data.data.courseData.id,'player',type);
                return false;
              }
            }
            // data.data.moduleData.module_type.free
            if($scope.course.modules[0].module_type.free || coursePurchasedReq || $scope.course.modules[0].module_type.purchased){
              $scope.module_id = $scope.course.modules[0].id;
              $scope.moduleName = $scope.course.modules[0].name;
              if($state.params.chapterNo){
                $scope.chapters = data.data.content.chapters;
                for (var i in $scope.chapters){
                  if($scope.chapters[i].chapter_no == chapter_no){
                    $scope.videos = $scope.chapters[i].videos
                    break;
                  }
                }
              }
              else{
                if(data.data.content.videos){

                  $scope.videos = data.data.content.videos;
                }
              }
              $scope.noOfVideos = $scope.videos.length;
              var x = 0;

              for(var i in $scope.videos){

                if($scope.videos[i].video_no == video_no){
                  $scope.selectedVideo = $scope.videos[i];
                  x = 1;
                  var data = {
                    user_id: CustomStorageService.getUserInfoStorageData().id,
                    video_id: $scope.selectedVideo.id,
                    chapter_id: $state.params.chapterNo,
                    module_id: $state.params.moduleNo,
                    watching_on: 's3 videoJs'
                  }
                  $http.post('/api/v1/apps/saveVideoWatchStats',data)
                  .then(function(data){
                    statSavingCheck = false;
                  });
                  if(!$scope.firstTime){
                    var data = {video_id: $scope.videos[i].id, viewed_by: CustomStorageService.getUserInfoStorageData().id};
                    $http.post('api/v1/cvideos/userViewedVideo', data)
                    .then(function(data) {
                      var userInfo = CustomStorageService.getUserInfoStorageData();
                      if(!userInfo.profileLevel){
                        if(userInfo.updated){
                          userInfo.profileLevel = 3;
                        } else {
                          userInfo.profileLevel = 0;
                        }
                        CustomStorageService.setUserInfoStorageData(userInfo);
                      }
                      if(data.data.count > 2 && userInfo.profileLevel < 7  && $scope.course.special && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else  if(data.data.count > 2 && userInfo.profileLevel < 3 && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else {
                        if(vm.data.os ==='ios') {
                          swal({
                            title: 'Iphone detect',
                            type: 'info',
                            customClass: 'sweet-alert-one',
                            showCancelButton:false
                          },function(){
                            $scope.goToCourse();
                          });

                        } else {                        
                          //mediaPlayer.load({url: $scope.videos[i].url_mpd});
                          player.src({
                            src: "/get_video_content?video_url="+$scope.videos[i].url_mpd,
                            type: 'application/dash+xml'
                          });
                        }
                      }
                    });

                    $http({
                      url:'api/v1/cvideos/checkRating',
                      method: "GET",
                      params: {vid: $scope.selectedVideo.id,uid:CustomStorageService.getUserInfoStorageData().id}
                    }).then(function(data){
                      $scope.userRatedVideo = data.data.check;
                    })
                  } else {
                    if(vm.data.os ==='ios') {
                      swal({
                        title: 'Iphone detect',
                        text: "video page is maintenance for iphone",
                        type: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton:false
                      },function(){
                        $scope.goToCourse();
                      });

                    } else {
                      //mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                      
                          player.src({
                            src: "/get_video_content?video_url="+$scope.selectedVideo.url_mpd,
                            type: 'application/dash+xml'
                          });
                    }
                    // mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                          
                  }
                  $http({
                    url: 'api/v1/cvideos/getVideoViews',
                    method: "GET",
                    params: {id: $scope.videos[i].id}
                  }).then(function(data){
                    $scope.view_count = data.data.view + 112;
                    $scope.attachments = data.data.attachments;
                    $scope.showData = true;
                    if(!$scope.$$phase) $scope.$apply();
                  })
                  var send_data ={
                    id:$scope.selectedVideo.id,
                  }
                  if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
                    send_data['user_id'] = CustomStorageService.getUserInfoStorageData().id;
                  }
                  // $http({
                  //   url: 'api/v1/comments/getComments',
                  //   method: "GET",
                  //   params: send_data
                  // }).then(function (data) {
                  //   $scope.user_type=data.data.user_type;
                  //   if(data.data.isInstructor){
                  //     $scope.isInstructor = true;
                  //     $scope.comments=data.data.comments;
                  //     $scope.AllComments=data.data.comments.allComments;
                  //   } else {
                  //     $scope.AllComments=data.data.comments;
                  //   }
                  // });
                  break;
                }
              }
              if(x==0){
                swal({
                  title: "Information",
                  text: "Video does not exist",
                  type: "info",
                  showCancelButton:false
                },function(){
                  $scope.goToModule();
                });
              }
            }
            else{
              swal({
                title: "Information",
                text: "Please purchase this module to view videos",
                type: "info",
                showCancelButton:false
              },function(){
                $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
              });
            }
          } else {
            $scope.popupDiv = true;
          }
        }
        else if(data.data.courseData){
          $rootScope.moduleNotExist = true;
          $scope.goToCourse();
        }
        else{
          $state.go('404');
        }
      })
    }

    $scope.swithToOldPlayer = function() {
      if($state.params.chapterNo) {
        $state.go('video_player_chapter', $state.params, { reload: true })
      } else {
        $state.go('video_player', $state.params, { reload: true })
      }
    }
    $scope.swithToFastStream = function(){
      $state.go("downloadapp", {}, { reload: true });
    }


    $scope.swithToVimeoPlayer = function() {
      if($state.params.chapterNo) {
        $state.go('vimeo_player_chapter', $state.params, { reload: true })
      } else {
        $state.go('vimeo_player', $state.params, { reload: true })
      }
    }
    

    $scope.change = function(value){
      $scope.selected=value;
      if(value==1)
      $scope.AllComments=$scope.comments.allComments;
      else if(value==2)
      $scope.AllComments=$scope.comments.approved;
      else if(value==3)
      $scope.AllComments=$scope.comments.pending;
      else if(value==4)
      $scope.AllComments=$scope.comments.hidden;
    }

    $scope.play_pause = function(){
      if (player.paused()) {
        player.play();
      } else {
        player.pause();
      }
    }

    $scope.acceptTerm = function() {
      DownloadPopupService.acceptTerm({video_id: $scope.selectedVideo.id});
      $scope.showTerm = true;
    }

    function dateFormate (dat) {
      var date = new Date(dat)
      var yyyy = date.getFullYear();
      var mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1); // getMonth() is zero-based
      var dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return dd + '-' + mm + '-' + yyyy + ' ' + hh + ':'+ min + ':' + ss;
      // return "".concat(yyyy).concat(mm).concat(dd).concat(hh).concat(min).concat(ss);
    }

    $scope.fullScreen = function(){
      var div = document.getElementById('cont-video-landing');
      videoHeight = div.clientHeight;
      if (div.requestFullscreen) {
        div.requestFullscreen();
      } else if (div.mozRequestFullScreen) {
        div.mozRequestFullScreen(); // Firefox
      } else if (div.webkitRequestFullscreen) {
        div.webkitRequestFullscreen(); // Chrome and Safari
      }
      $scope.isFullScreen = true;
      document.getElementById('fullScrBtn').style.display = 'none';
      document.getElementById('exitFlScrBtn').style.display = 'block';
      div.style.height= 100 + '%';
      video.style.height = 100 + '%';
    }

    $scope.exitFulScreen = function(){
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      $scope.isFullScreen = false;
      document.getElementById('fullScrBtn').style.display = 'block';
      document.getElementById('exitFlScrBtn').style.display = 'none';
      var div = document.getElementById('cont-video-landing');
      div.style.height= videoHeight + '%';
      video.style.height = videoHeight + '%';
    }

    $scope.mute = function(){
      if(!video.muted){
        document.getElementById('volBtn').style.display = 'none';
        document.getElementById('muteBtn').style.display = 'block';
        userVol = video.volume;
        video.muted = true;
        video.volume = 0;
        volumeBar.value = video.volume;
      }
      else{
        video.muted = false;
        document.getElementById('volBtn').style.display = 'block';
        document.getElementById('muteBtn').style.display = 'none';
        video.volume = userVol;
        volumeBar.value = video.volume;
      }
    }

    $scope.skipFwdVideo = function(value){
      if(player.currentTime() +15 < player.duration()){
        player.currentTime(player.currentTime() + 15);
      }
    }

    $scope.skipRwdVideo = function(value){
      if(player.currentTime() - 15 > 0){
        player.currentTime(player.currentTime() - 15);
      }
    }

    $scope.showPlaybackOptions = function(){
      if($scope.playbackOpt){
        $scope.playbackOpt = false;
      } else{
        $scope.playbackOpt = true;
      }
    }

    $scope.playBackRate = function(value){
      $scope.playbackOpt = false;
      video.playbackRate = value;
      $scope.playbackVal = value;
    }



    function playVid(){
      video.pause();
      document.getElementById('loader-two').style.display = 'none';
      document.getElementById('play-iccon').style.display = 'block';
      video.removeEventListener("canplay",playVid);
    };

    function firstTime(){
      $scope.loader = false;
      if($scope.displayAd){
        video.pause();
      }
      document.getElementById('button-bar').style.display = 'block';
      video.removeEventListener("play",firstTime);
    };

    /* mediaPlayer.addEventListener("state_changed", function(event) {
      if(event.detail.state === "playing") {
        $scope.playCount += 1;
        if($scope.playCount > 1) {
          document.getElementById('load-perccentage').innerHTML = 100+'%';
          clearInterval($scope.loadInterval);
          setTimeout(function() {
            document.getElementById('loader-two').style.display = 'none';
            document.getElementById('load-perccentage').style.display = 'none';
          }, 200)
        }
      }
    }); */

    /* seekBar.addEventListener("mousedown", function() {
      video.pause();
      document.getElementById('playBtn').style.display = 'block';
      document.getElementById('pauseBtn').style.display = 'none';
    });

    seekBar.addEventListener("mouseup", function() {
      video.play();
      document.getElementById('playBtn').style.display = 'none';
      document.getElementById('pauseBtn').style.display = 'block';
    });

    video.addEventListener("waiting", function() {
      document.getElementById('loader-two').style.display = 'block';
    });

    video.addEventListener("playing", function() {
      if($scope.playCount > 1) {
        document.getElementById('loader-two').style.display = 'none';
      }
    }); */

    /* video.addEventListener("timeupdate", function() {
      CustomStorageService.setFirstTimeStorageData(true);
      var value = (100 / video.duration) * video.currentTime;
      seekBar.value = value;
      if($scope.loader == false){
        var bufferedEnd = video.buffered.end(video.buffered.length - 1);
        var duration =  video.duration;
        if (duration > 0) {
          var value = (100 / video.duration) * bufferedEnd;
          bufferBar.value = value;
        }
      }
      var seconds = video.duration - video.currentTime;
      var m = Math.floor(seconds / 60) < 10 ? '0' + Math.floor(seconds / 60) : Math.floor(seconds / 60);
      var s = Math.floor(seconds - (m * 60)) < 10 ? '0' + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
      document.getElementById("timeLeft").innerHTML = '-' + m + ':' + s;
      if((video.duration - video.currentTime) == 0){
        nextVideo();
      }
    }); */

    $scope.updateProgress = function(value){
      var time = video.duration * (value / 100);
      video.currentTime = time;
      CustomStorageService.setFirstTimeStorageData(true);
    }

    volumeBar.addEventListener("change", function() {
      if(video.muted){
        video.muted = false;
        document.getElementById('volBtn').style.display = 'block';
        document.getElementById('muteBtn').style.display = 'none';
      }
      video.volume = volumeBar.value;
    });

    seekBar.addEventListener("change", function() {
      var time = video.duration * (seekBar.value / 100);
      video.currentTime = time;
    });

    $scope.handleClick = function(evt) {
      switch(evt.which) {
        case 3:
        break;
        case 1:
        if($scope.loader == false){
          $scope.videoInFocus = true;
          $scope.play_pause();
        }
        break;
      }
    };

    window.addEventListener("keydown",handleKeyboard, false);

    function handleKeyboard(e){
        if(e.keyCode == 37){
          e.preventDefault();
          $scope.skipRwdVideo(15);
        }
        else if(e.keyCode == 39){
          e.preventDefault();
          $scope.skipFwdVideo(15);
        }
        else if(e.keyCode == 38){
          if(video.volume < 1){
            video.volume = video.volume + 0.1;
            volumeBar.value = video.volume;
          }
        }
        else if(e.keyCode == 40){
          if(volumeBar.value > 0){
            volumeBar.value = volumeBar.value-0.1;
            video.volume = video.volume - 0.1;
          }
        }
        else if(e.keyCode == 32){
          $scope.play_pause();
        }
        else if(e.keyCode == 77){
          $scope.mute();
        }
    }

    //video.addEventListener("ended",nextVideo,false);

    function nextVideo() {
      if(!$scope.userRatedVideo && !$scope.firstTime){
        $scope.userVideoRating = true;
        if (!$scope.$$phase) $scope.$apply();
        return false;
      } else {
        if(!$scope.firstTime && !localStorage.userSignedIn && !CustomStorageService.getInstructorSignedInStorageData()){
          var x = parseInt($state.params.video_no);
          if(x+1 <= $scope.videos.length){
            for(var i in $scope.videos){
              if(x == $scope.videos[i].video_no){
                $scope.showVideo($scope.videos[+i+1]);
              }
            }
          } else {
            $scope.goToModule();
          }
        } else {
          swal({
            text: 'Looks like you are not logged in, Please login to continue',
            type: 'info',
            title: 'Information'
          },function(){
            swal.close();
            $scope.displayNextVideo = true;
            showLoginPopup();
          })
        }
      }
    }

    $scope.approveComment = function (id)
    {
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/approveComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideShow = function(comment)
    {
      if(comment.showReply)
      comment.showReply=false;
      else
      comment.showReply=true;
    }

    $scope.hideShowReply = function(reply)
    {
      if(reply.showReply)
      reply.showReply=false;

      else {
        reply.showReply=true;
      }
    }

    $scope.instructorReply=function(text,id,reply)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        var params = {
          user_id: CustomStorageService.getUserInfoStorageData().id,
          text: text,
          video_id: $scope.selectedVideo.id,
          image_url:$scope.commentImage,
          comment_id:id
        }
        if($scope.user_type =='student'){
          var url = 'api/v1/comments/addReply';
        } else {
          var url = 'api/v1/comments/instructorReplyComment';
        }

        $http.post(url,params)
        .then(function(data){
          if(data.status==200)
          {
            reply.showReply=false;
            $scope.replyText=""
            swal({
              title: "Reply",
              text: "Reply posted",
              type: "info",
              showCancelButton:false
            },function(){
            });
          }
        })

      } else {
        swal("Error","Please login to comment","error");
      }
    }


    $scope.goToCourse = function(){
      var instName = $state.params.institutionName;
      var schoolName = $state.params.schoolName;
      var course = $state.params.courseName;
      $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course},{reload:true});
    };

    $scope.goToModule = function(){
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
    }

    $scope.$on('userLoggedIn', function( event, message ){
      if(!$scope.displayNextVideo && !$scope.displaySelectedVideo){
        location.reload();
      } else if(!$scope.displaySelectedVideo){
        $scope.firstTime = false;
        nextVideo();
      } else if(!$scope.displayNextVideo){
        $scope.firstTime = false;
        $scope.showVideo($scope.videoSelectedData);
      }
    });

    $scope.$on('closeForm', function( event, message ){
      $state.go('Home',{},{reload:true});
    });

    $scope.$on('playVideo', function( event, message ){
      //mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
      player.src({
        src: "/get_video_content?video_url="+$scope.selectedVideo.url_mpd,
        type: 'application/dash+xml'
      });
    });

    /* $scope.$on('$stateChangeStart', function (event) {
      video.pause();
      mediaPlayer.reset();
      mediaPlayer = null;
    }); */

    $scope.goToVelocity = function(){
      var user = CustomStorageService.getUserInfoStorageData();
      var token = CustomStorageService.getAuthTokenStorageData();
      if(user && token){
      // return false;
      var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl='
      if($scope.redirectUrlLms){
        url += $scope.redirectUrlLms
      }
      window.open(url, '_self')
      sessionStorage.removeItem('goToVelocity');
      }else{
        sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true }));
        showLoginPopup();
      }
    };

    $scope.showVideo = function(video){
      if(!$scope.firstTime){
        //mediaPlayer.reset();
        player.dispose();
        if(video.type == 'quiz'){
          $state.go('quiz',{quiz_id: video.id});
        } else {
          if($state.params.chapterNo){
            if(video.vss_link){
              $state.go('vimeo_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('videojs_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }
          }else{
            if(video.vss_link){
              $state.go('vimeo_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('videojs_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }
          }
        }
      } else {
        swal({
          text: 'Looks like you are not logged in, Please login to continue',
          type: 'info',
          title: 'Information'
        },function(){
          console.log($scope.course);
          swal.close();
          if(video.type == 'quiz') {
            $scope.displaySelectedVideo = true;
            $scope.videoSelectedData = video;
            var redirecturl = 'quiz/standard-quiz-main/' + video.session_id;
            sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          } else {
            $scope.displaySelectedVideo = true;
            $scope.videoSelectedData = video;
            var redirecturl = 'course/' + $scope.course.modules[0].index_url + '/' + $scope.course.modules[0].id + '/' + video.id +'?courseIndexUrl=' + $scope.course.index_url;
            sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          }
          showLoginPopup();
          if(!$scope.$$phase) $scope.$apply();
        })
      }
    }

    $scope.play = function(){
      document.getElementById('play-iccon').style.display = 'none';
      document.getElementById('button-bar').style.display = 'block';
      if($scope.displayAd){
        adVideo.play();
      } else {
        video.play();
      }
      $scope.loader = false;
      if (!$scope.$$phase) $scope.$apply();
    }

    $scope.zipAttachments = function(id){
      var video_name = $scope.selectedVideo.name;
      video_name = video_name.split(' ').join('+');
      var win = window.open('https://nearpeer-zips.s3.amazonaws.com/zips/module' + $scope.module_id + '/' + video_name + '-' +id+'.zip', '_blank');
    }

    $scope.addImage = function(image){
      if(image)
      {
        if(CustomStorageService.getUserSignedInStorageData()|| CustomStorageService.getInstructorSignedInStorageData()){
          $scope.imageUploadingInProcess =  true;
          if(!$scope.$$phase) $scope.$apply();
          Upload.upload({
            url: 'api/v1/uploader/uploadImageToS3?userId='+CustomStorageService.getUserInfoStorageData().id + '&socket_id=' + CustomStorageService.getSocketIdStorageData(),
            method: "POST",
            file: image
          }).then(function(data){
            $scope.imageUploadingInProcess = false;
            $scope.commentImage = data.data.link;
            if(!obj){
              $scope.commentImage = data.data.link;
            } else {
              obj.replyImage_url = data.data.link;
            }
            if(!$scope.$$phase) $scope.$apply();
          });
        }
      }

    }

    $scope.$on('internetConnectivityLost', function( event, message ){
      video.pause();
    });

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }
    $scope.$on('internetFound', function( event, message ){
    });

    $scope.dblClick = function(){
      if($scope.loader == false){
        if($scope.isFullScreen){
          $scope.exitFulScreen();
        } else {
          $scope.fullScreen();
        }
      }
    };

    $scope.addComment =function(text)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if(!text){
          swal("Empty Comment","Please add text","info");
          return false;
        }
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        if($scope.user_type=="student")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addComment';
          // $scope.showData = false;
          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.showData = true;
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment Published",
          //       text: "Your comment will appear once it has been approved by the instructor",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })

        }

        else if($scope.user_type=="instructor")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addInstructorComment';

          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment",
          //       text: "Comment posted",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })


        }
      } else {
        swal("Error","Please login to comment","error");
      }
    }

    /* document.addEventListener("fullscreenchange", onFullScreenChange, false);
    document.addEventListener("webkitfullscreenchange", onFullScreenChange, false);
    document.addEventListener("mozfullscreenchange", onFullScreenChange, false); */

    function onFullScreenChange() {
      var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
      if(!fullscreenElement){
        $scope.exitFulScreen();
      }
    }

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }

    /* document.getElementById("cont-video-landing").addEventListener("mousemove", showHoveDiv);
    document.getElementById("cont-video-landing").addEventListener("mouseleave",hideHoverDiv); */

    function hideHoverDiv(){
      var element = document.getElementById('overlay-cont');
      element.classList.remove("hideDiv");
    }

    function showHoveDiv(event){
      var element = document.getElementById('overlay-cont');
      element.classList.add("hideDiv");
      element.classList.remove("cursorNone");
      $scope.xCord = event.clientX;
      $scope.yCord = event.clientY;
      setTimeout(function(){
        var xCord = event.clientX;
        var yCord = event.clientY;
        if(xCord == $scope.xCord && yCord == $scope.yCord){
          var element = document.getElementById('overlay-cont');
          element.classList.remove("hideDiv");
        }
      },5000)
    }

    $scope.hideComment = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideReply = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableReply',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.getInitialLetter = function(str){
      return str.charAt(0).toUpperCase();
    }

    var showLoginPopup = function(){
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }

    $sails.on('imageUploadProgress',function(data){
      $scope.imageUploadLog.progress = data;
      if(!$scope.$$phase) $scope.$apply();
    })

    var adVideo = document.getElementById("video-ad");
    var adSeekBar = document.getElementById("seek-bar-ad");
    var timer = 5;

    $scope.skipAd = function(){
      if(timer == 0){
        showOriginalVideo();
      }
    }

    /* adVideo.addEventListener("timeupdate", function() {
      if(timer > 0){
        document.getElementById("skip-ad-time").innerHTML = timer - parseInt(adVideo.currentTime);
      }
    }); */

    //adVideo.addEventListener("ended",showOriginalVideo,false);

    function showOriginalVideo(){
      $scope.displayAd = false;
      if(!$scope.$$phase) $scope.$apply();
      if(!$scope.mobileView){
        document.getElementById('video-loader-two').style.display = 'block';
        document.getElementById('button-bar').style.display = 'block';
        video.play()
      } else {
        document.getElementById('play-iccon').style.display = 'block';
      }
    }

    var loadAd = function(){
      $scope.showGifAd = true;
      document.getElementById('play-iccon').style.display = 'none';
      document.getElementById('video-loader-two').style.display = 'none';
      adVideo.src = 'images/Illys_sponsorship.mp4';
      adVideo.play();
    }

    if (window.screen.width > 320 && window.screen.width < 1024) {
      $scope.mobileView = true;
      //video.addEventListener("canplay",playVid,false);
    } else{
      //video.addEventListener("play",firstTime,false);
    }

    if(!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()){
      if(!CustomStorageService.getFirstTimeStorageData()){
        $scope.firstTime = true;
        $scope.initialize();
      } else {
        var instName = $state.params.institutionName;
        var schoolName = $state.params.schoolName;
        var course = $state.params.courseName;
        $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course});
      }
    } else{
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo});

    }

  }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('playerController', ['courseDetailService','$scope', '$http', '$state', 'CustomStorageService', 'DownloadPopupService','$rootScope','Upload', '$sails','deviceDetector','$filter', '$timeout','$interval', 'env', function(courseDetailService,$scope, $http, $state, CustomStorageService, DownloadPopupService,$rootScope,Upload,$sails,deviceDetector,$filter, $timeout,$interval, env) {

    $scope.waterMark  = false;
    $scope.popupDiv = false;
    $scope.showTerm = false;
    $interval(function(){  
      if($scope.waterMark){
        $scope.waterMark  = false;
      }
   }, 10000);
   $interval( function(){
      if(!$scope.waterMark) 
        $scope.waterMark = true;
    }, 60000)
    var vm = this;
    vm.data = deviceDetector;
    vm.allData = JSON.stringify(vm.data, null, 2);
    var mediaPlayer = new MediaPlayer();
    var date = new Date();
    var monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
    ];
    $scope.stamp = monthNames[date.getMonth()]+'-'+date.getFullYear();


    mediaPlayer.init(document.querySelector("#video"));
    var video = document.getElementById("video");
    var volumeBar = document.getElementById("volume-bar");
    var seekBar = document.getElementById("seek-bar");
    var bufferBar = document.getElementById("buffer-bar");
    $scope.loader = true;
    $scope.showData = false;
    $scope.rate = '1x';
    var videoHeight = 0;
    var userVol = 1;
    $scope.playbackVal = 1;
    $scope.playbackOpt = false;
    $scope.loadPercentage = 0;
    $scope.playCount = 0;

    document.getElementById('playBtn').style.display = 'none';
    document.getElementById('pauseBtn').style.display = 'block';

    document.getElementById('volBtn').style.display = 'block';
    document.getElementById('muteBtn').style.display = 'none';

    document.getElementById('fullScrBtn').style.display = 'block';
    document.getElementById('exitFlScrBtn').style.display = 'none';

    document.getElementById('loader-two').style.display = 'block';
    document.getElementById('button-bar').style.display = 'none';

    document.getElementById('play-iccon').style.display = 'none';

    var coursePurchasedReq = false ;
    $scope.$on("$destroy", function(){
      window.removeEventListener("keydown",handleKeyboard, false);
    });

    $scope.closePopup = function() {
      $scope.popupDiv = false;
    }
    
    $scope.openApp = function() {
      $scope.popupDiv = false;
      DownloadPopupService.openApp();
    }
    $scope.DownloadApp = function() {
      DownloadPopupService.downloadApp();
      $scope.popupDiv = false;
    }

    $scope.initialize = function() {
      $scope.show=false;
      if(!$scope.firstTime ||  CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        var id = CustomStorageService.getUserInfoStorageData().id;
        var str = CustomStorageService.getUserInfoStorageData().name || CustomStorageService.getUserInfoStorageData().full_name
        $scope.imageInitial = str.charAt(0).toUpperCase();
        var userTemp = CustomStorageService.getUserInfoStorageData();
        // var dateUSer = new Date("2015-03-25")
        $scope.userInfo = userTemp.email +" , " + userTemp.phone + " , " + dateFormate(new Date());
      } else {
        $scope.imageInitial = 'N';
      }
      $scope.showTerm = CustomStorageService.getTermStatus();
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      var schoolName = $state.params.schoolName;
      schoolName = schoolName.toLowerCase();
      var course = $state.params.courseName;
      course = course.toLowerCase();
      var module_no = $state.params.moduleNo;
      var video_no = $state.params.video_no;
      var url = instName + '/' + schoolName + '/' + course;
      var chapter_no = 0;
      if($state.params.chapterNo){
        chapter_no = $state.params.chapterNo;
        $scope.VideoURL = url  + '/' + module_no + '/' +chapter_no + '/' + video_no;
      } else{
        $scope.VideoURL = url  + '/' + module_no + '/' + video_no;
      }

      $scope.loadInterval = setInterval(function() {
        $scope.loadPercentage < 100 ? $scope.loadPercentage += 5 : 100;
        var doc = document.getElementById('load-perccentage');
        if(doc){
          doc.innerHTML = $scope.loadPercentage + '%';
        }
      }, 1000)

      var goToVelocityStatus = JSON.parse(sessionStorage.getItem('goToVelocity'));
      if(goToVelocityStatus && goToVelocityStatus.condition && CustomStorageService.getUserSignedInStorageData()){
        $scope.redirectUrlLms = goToVelocityStatus.redirect;
        $scope.goToVelocity()
      }

      const width = window.screen.width * window.devicePixelRatio
      const height = window.screen.height * window.devicePixelRatio;

      $http({
        url: 'api/v1/courses/getModuleByIndexUrl',
        method: "GET",
        params: {url: url,module_no:module_no,user_id:id,m_id:CustomStorageService.getModule(),width: width,height: height}
      }).then(function(data){
      
        if(data.data.coursePurchased) {
            coursePurchasedReq = data.data.coursePurchased.purchased;
        }
        if(data.data.notSignedIn && data.data.paid){
          showLoginPopup();
          return false;
        }
        
        if(data.data.courseData && data.data.courseData.modules.length > 0){
          if(data.data.courseData.allow_on_web || data.data.courseData.modules[0].module_type.free) {
            $scope.course = data.data.courseData;
            $scope.displayAd = $scope.course.display_ads;
            if($scope.displayAd){
              loadAd();
            }
            if(!$scope.firstTime){
              if(!data.data.enrolled){
                if(data.data.courseData.special){
                  var type = "CA";
                } else {
                  var type = "UNI";
                }
                courseDetailService.swalGetEnrolledPopup(data.data.courseData.id,'player',type);
                return false;
              }
            }
            // data.data.moduleData.module_type.free
            if($scope.course.modules[0].module_type.free || coursePurchasedReq || $scope.course.modules[0].module_type.purchased){
              $scope.module_id = $scope.course.modules[0].id;
              $scope.moduleName = $scope.course.modules[0].name;
              if($state.params.chapterNo){
                $scope.chapters = data.data.content.chapters;
                for (var i in $scope.chapters){
                  if($scope.chapters[i].chapter_no == chapter_no){
                    $scope.videos = $scope.chapters[i].videos
                    break;
                  }
                }
              }
              else{
                if(data.data.content.videos){

                  $scope.videos = data.data.content.videos;
                }
              }
              $scope.noOfVideos = $scope.videos.length;
              var x = 0;

              for(var i in $scope.videos){

                if($scope.videos[i].video_no == video_no){
                  $scope.selectedVideo = $scope.videos[i];
                  x = 1;
                  var data = {
                    user_id: CustomStorageService.getUserInfoStorageData().id,
                    video_id: $scope.selectedVideo.id,
                    chapter_id: $state.params.chapterNo,
                    module_id: $state.params.moduleNo,
                    watching_on: 's3 hasPlayer'
                  }
                  $http.post('/api/v1/apps/saveVideoWatchStats',data)
                  .then(function(data){
                  });
                  if(!$scope.firstTime){
                    var data = {video_id: $scope.videos[i].id, viewed_by: CustomStorageService.getUserInfoStorageData().id};
                    $http.post('api/v1/cvideos/userViewedVideo', data)
                    .then(function(data) {
                      var userInfo = CustomStorageService.getUserInfoStorageData();
                      if(!userInfo.profileLevel){
                        if(userInfo.updated){
                          userInfo.profileLevel = 3;
                        } else {
                          userInfo.profileLevel = 0;
                        }
                        CustomStorageService.setUserInfoStorageData(userInfo);
                      }
                      if(data.data.count > 2 && userInfo.profileLevel < 7  && $scope.course.special && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else  if(data.data.count > 2 && userInfo.profileLevel < 3 && userInfo.user_type !== 'guest'){
                        $scope.$emit('getUserInformation',userInfo.profileLevel);
                      } else {
                        if(vm.data.os ==='ios') {
                          swal({
                            title: 'Iphone detect',
                            type: 'info',
                            customClass: 'sweet-alert-one',
                            showCancelButton:false
                          },function(){
                            $scope.goToCourse();
                          });

                        } else {                        
                          mediaPlayer.load({url: $scope.videos[i].url_mpd});
                        }


                      }
                    });

                    $http({
                      url:'api/v1/cvideos/checkRating',
                      method: "GET",
                      params: {vid: $scope.selectedVideo.id,uid:CustomStorageService.getUserInfoStorageData().id}
                    }).then(function(data){
                      $scope.userRatedVideo = data.data.check;
                    })
                  } else {
                    if(vm.data.os ==='ios') {
                      swal({
                        title: 'Iphone detect',
                        text: "video page is maintenance for iphone",
                        type: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton:false
                      },function(){
                        $scope.goToCourse();
                      });

                    } else {
                      mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                    }
                    // mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
                  }
                  $http({
                    url: 'api/v1/cvideos/getVideoViews',
                    method: "GET",
                    params: {id: $scope.videos[i].id}
                  }).then(function(data){
                    $scope.view_count = data.data.view + 112;
                    $scope.attachments = data.data.attachments;
                    $scope.showData = true;
                    if(!$scope.$$phase) $scope.$apply();
                  })
                  var send_data ={
                    id:$scope.selectedVideo.id,
                  }
                  if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
                    send_data['user_id'] = CustomStorageService.getUserInfoStorageData().id;
                  }
                  // $http({
                  //   url: 'api/v1/comments/getComments',
                  //   method: "GET",
                  //   params: send_data
                  // }).then(function (data) {
                  //   $scope.user_type=data.data.user_type;
                  //   if(data.data.isInstructor){
                  //     $scope.isInstructor = true;
                  //     $scope.comments=data.data.comments;
                  //     $scope.AllComments=data.data.comments.allComments;
                  //   } else {
                  //     $scope.AllComments=data.data.comments;
                  //   }
                  // });
                  break;
                }
              }
              if(x==0){
                swal({
                  title: "Information",
                  text: "Video does not exist",
                  type: "info",
                  showCancelButton:false
                },function(){
                  $scope.goToModule();
                });
              }
            }
            else{
              swal({
                title: "Information",
                text: "Please purchase this module to view videos",
                type: "info",
                showCancelButton:false
              },function(){
                $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
              });
            }
          } else {
            $scope.popupDiv = true;
          }
        }
        else if(data.data.courseData){
          $rootScope.moduleNotExist = true;
          $scope.goToCourse();
        }
        else{
          $state.go('404');
        }
        
      })
    }

    $scope.swithToNewPlayer = function() {
      if($state.params.chapterNo) {
        $state.go('videojs_player_chapter', $state.params, { reload: true })
      } else {
        $state.go('videojs_player', $state.params, { reload: true })
      }
    }

    $scope.swithToVimeoPlayer = function() {
      if($state.params.chapterNo) {
        $state.go('vimeo_player_chapter', $state.params, { reload: true })
      } else {
        $state.go('vimeo_player', $state.params, { reload: true })
      }
    }

    $scope.change = function(value){
      $scope.selected=value;
      if(value==1)
      $scope.AllComments=$scope.comments.allComments;
      else if(value==2)
      $scope.AllComments=$scope.comments.approved;
      else if(value==3)
      $scope.AllComments=$scope.comments.pending;
      else if(value==4)
      $scope.AllComments=$scope.comments.hidden;
    }

    $scope.play_pause = function(){
      if (video.paused == true) {
        video.play();
        video.playBackRate = $scope.videoPlayBackSpeed;
        document.getElementById('playBtn').style.display = 'none';
        document.getElementById('pauseBtn').style.display = 'block';
      } else {
        $scope.videoPlayBackSpeed = video.playBackRate;
        video.pause();
        document.getElementById('playBtn').style.display = 'block';
        document.getElementById('pauseBtn').style.display = 'none';
      }
    }

    $scope.acceptTerm = function() {
      DownloadPopupService.acceptTerm({video_id: $scope.selectedVideo.id});
      $scope.showTerm = true;
    }

    function dateFormate (dat) {
      var date = new Date(dat)
      var yyyy = date.getFullYear();
      var mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1); // getMonth() is zero-based
      var dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return dd + '-' + mm + '-' + yyyy + ' ' + hh + ':'+ min + ':' + ss;
      // return "".concat(yyyy).concat(mm).concat(dd).concat(hh).concat(min).concat(ss);
    }

    $scope.fullScreen = function(){
      var div = document.getElementById('cont-video-landing');
      videoHeight = div.clientHeight;
      if (div.requestFullscreen) {
        div.requestFullscreen();
      } else if (div.mozRequestFullScreen) {
        div.mozRequestFullScreen(); // Firefox
      } else if (div.webkitRequestFullscreen) {
        div.webkitRequestFullscreen(); // Chrome and Safari
      }
      $scope.isFullScreen = true;
      document.getElementById('fullScrBtn').style.display = 'none';
      document.getElementById('exitFlScrBtn').style.display = 'block';
      div.style.height= 100 + '%';
      video.style.height = 100 + '%';
    }

    $scope.exitFulScreen = function(){
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      $scope.isFullScreen = false;
      document.getElementById('fullScrBtn').style.display = 'block';
      document.getElementById('exitFlScrBtn').style.display = 'none';
      var div = document.getElementById('cont-video-landing');
      div.style.height= videoHeight + '%';
      video.style.height = videoHeight + '%';
    }

    $scope.mute = function(){
      if(!video.muted){
        document.getElementById('volBtn').style.display = 'none';
        document.getElementById('muteBtn').style.display = 'block';
        userVol = video.volume;
        video.muted = true;
        video.volume = 0;
        volumeBar.value = video.volume;
      }
      else{
        video.muted = false;
        document.getElementById('volBtn').style.display = 'block';
        document.getElementById('muteBtn').style.display = 'none';
        video.volume = userVol;
        volumeBar.value = video.volume;
      }
    }

    $scope.skipFwdVideo = function(value){
      if(video.currentTime+15 < video.duration){
        video.currentTime += value;
      }
    }

    $scope.skipRwdVideo = function(value){
      if(video.currentTime-15 > 0){
        video.currentTime -= value;
      }
    }

    $scope.showPlaybackOptions = function(){
      if($scope.playbackOpt){
        $scope.playbackOpt = false;
      } else{
        $scope.playbackOpt = true;
      }
    }

    $scope.playBackRate = function(value){
      $scope.playbackOpt = false;
      video.playbackRate = value;
      $scope.playbackVal = value;
    }



    function playVid(){
      video.pause();
      document.getElementById('loader-two').style.display = 'none';
      document.getElementById('play-iccon').style.display = 'block';
      video.removeEventListener("canplay",playVid);
    };

    function firstTime(){
      $scope.loader = false;
      if($scope.displayAd){
        video.pause();
      }
      document.getElementById('button-bar').style.display = 'block';
      video.removeEventListener("play",firstTime);
    };

    mediaPlayer.addEventListener("state_changed", function(event) {
      if(event.detail.state === "playing") {
        $scope.playCount += 1;
        if($scope.playCount > 1) {
          document.getElementById('load-perccentage').innerHTML = 100+'%';
          clearInterval($scope.loadInterval);
          setTimeout(function() {
            document.getElementById('loader-two').style.display = 'none';
            document.getElementById('load-perccentage').style.display = 'none';
          }, 200)
        }
      }
    });

    seekBar.addEventListener("mousedown", function() {
      video.pause();
      document.getElementById('playBtn').style.display = 'block';
      document.getElementById('pauseBtn').style.display = 'none';
    });

    seekBar.addEventListener("mouseup", function() {
      video.play();
      document.getElementById('playBtn').style.display = 'none';
      document.getElementById('pauseBtn').style.display = 'block';
    });

    video.addEventListener("waiting", function() {
      document.getElementById('loader-two').style.display = 'block';
    });

    video.addEventListener("playing", function() {
      if($scope.playCount > 1) {
        document.getElementById('loader-two').style.display = 'none';
      }
    });

    video.addEventListener("timeupdate", function() {
      CustomStorageService.setFirstTimeStorageData(true);
      var value = (100 / video.duration) * video.currentTime;
      seekBar.value = value;
      if($scope.loader == false){
        var bufferedEnd = video.buffered.end(video.buffered.length - 1);
        var duration =  video.duration;
        if (duration > 0) {
          var value = (100 / video.duration) * bufferedEnd;
          bufferBar.value = value;
        }
      }
      var seconds = video.duration - video.currentTime;
      var m = Math.floor(seconds / 60) < 10 ? '0' + Math.floor(seconds / 60) : Math.floor(seconds / 60);
      var s = Math.floor(seconds - (m * 60)) < 10 ? '0' + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
      document.getElementById("timeLeft").innerHTML = '-' + m + ':' + s;
      if((video.duration - video.currentTime) == 0){
        nextVideo();
      }
    });

    $scope.updateProgress = function(value){
      var time = video.duration * (value / 100);
      video.currentTime = time;
    }

    volumeBar.addEventListener("change", function() {
      if(video.muted){
        video.muted = false;
        document.getElementById('volBtn').style.display = 'block';
        document.getElementById('muteBtn').style.display = 'none';
      }
      video.volume = volumeBar.value;
    });

    seekBar.addEventListener("change", function() {
      var time = video.duration * (seekBar.value / 100);
      video.currentTime = time;
    });

    $scope.handleClick = function(evt) {
      switch(evt.which) {
        case 3:
        break;
        case 1:
        if($scope.loader == false){
          $scope.videoInFocus = true;
          $scope.play_pause();
        }
        break;
      }
    };

    $scope.swithToFastStream = function(){
      $state.go("downloadapp", {}, { reload: true });
    }

    window.addEventListener("keydown",handleKeyboard, false);

    function handleKeyboard(e){
      if($scope.videoInFocus && document.activeElement.tagName == 'DIV'){
        e.preventDefault();
        if(e.keyCode == 37){
          $scope.skipRwdVideo(15);
        }
        else if(e.keyCode == 39){
          $scope.skipFwdVideo(15);
        }
        else if(e.keyCode == 38){
          if(video.volume < 1){
            video.volume = video.volume + 0.1;
            volumeBar.value = video.volume;
          }
        }
        else if(e.keyCode == 40){
          if(volumeBar.value > 0){
            volumeBar.value = volumeBar.value-0.1;
            video.volume = video.volume - 0.1;
          }
        }
        else if(e.keyCode == 32){
          $scope.play_pause();
        }
        else if(e.keyCode == 77){
          $scope.mute();
        }
      } else{
      }
    }

    video.addEventListener("ended",nextVideo,false);

    function nextVideo() {
      if(!$scope.userRatedVideo && !$scope.firstTime){
        $scope.userVideoRating = true;
        if (!$scope.$$phase) $scope.$apply();
        return false;
      } else {
        if(!$scope.firstTime && !localStorage.userSignedIn && !CustomStorageService.getInstructorSignedInStorageData()){
          var x = parseInt($state.params.video_no);
          if(x+1 <= $scope.videos.length){
            for(var i in $scope.videos){
              if(x == $scope.videos[i].video_no){
                $scope.showVideo($scope.videos[+i+1]);
              }
            }
          } else {
            $scope.goToModule();
          }
        } else {
          swal({
            text: 'Looks like you are not logged in, Please login to continue',
            type: 'info',
            title: 'Information'
          },function(){
            swal.close();
            $scope.displayNextVideo = true;
            showLoginPopup();
          })
        }
      }
    }

    $scope.approveComment = function (id)
    {
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/approveComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideShow = function(comment)
    {
      if(comment.showReply)
      comment.showReply=false;
      else
      comment.showReply=true;
    }

    $scope.hideShowReply = function(reply)
    {
      if(reply.showReply)
      reply.showReply=false;

      else {
        reply.showReply=true;
      }
    }

    $scope.instructorReply=function(text,id,reply)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        var params = {
          user_id: CustomStorageService.getUserInfoStorageData().id,
          text: text,
          video_id: $scope.selectedVideo.id,
          image_url:$scope.commentImage,
          comment_id:id
        }
        if($scope.user_type =='student'){
          var url = 'api/v1/comments/addReply';
        } else {
          var url = 'api/v1/comments/instructorReplyComment';
        }

        $http.post(url,params)
        .then(function(data){
          if(data.status==200)
          {
            reply.showReply=false;
            $scope.replyText=""
            swal({
              title: "Reply",
              text: "Reply posted",
              type: "info",
              showCancelButton:false
            },function(){
            });
          }
        })

      } else {
        swal("Error","Please login to comment","error");
      }
    }


    $scope.goToCourse = function(){
      var instName = $state.params.institutionName;
      var schoolName = $state.params.schoolName;
      var course = $state.params.courseName;
      $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course},{reload:true});
    };

    $scope.goToModule = function(){
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo},{reload:true});
    }

    $scope.$on('userLoggedIn', function( event, message ){
      if(!$scope.displayNextVideo && !$scope.displaySelectedVideo){
        location.reload();
      } else if(!$scope.displaySelectedVideo){
        $scope.firstTime = false;
        nextVideo();
      } else if(!$scope.displayNextVideo){
        $scope.firstTime = false;
        $scope.showVideo($scope.videoSelectedData);
      }
    });

    $scope.$on('closeForm', function( event, message ){
      $state.go('Home',{},{reload:true});
    });

    $scope.$on('playVideo', function( event, message ){
      mediaPlayer.load({url: $scope.selectedVideo.url_mpd});
    });

    $scope.$on('$stateChangeStart', function (event) {
      video.pause();
      mediaPlayer.reset();
      mediaPlayer = null;
    });

    $scope.goToVelocity = function(){
      var user = CustomStorageService.getUserInfoStorageData();
      var token = CustomStorageService.getAuthTokenStorageData();
      if(user && token){
      // return false;
      var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl='
      if($scope.redirectUrlLms){
        url += encodeURIComponent($scope.redirectUrlLms)
      }
      window.open(url, '_self')
      sessionStorage.removeItem('goToVelocity');
      }else{
        sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true }));
        showLoginPopup();
      }
    };

    $scope.showVideo = function(video){
      if(!$scope.firstTime){
        clearInterval($scope.loadInterval);
        mediaPlayer.reset();
        if(video.type == 'quiz'){
          $state.go('quiz',{quiz_id: video.id});
        } else {
          if($state.params.chapterNo){
            if(video.vss_link){
              $state.go('vimeo_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('video_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:$state.params.chapterNo,video_no:video.video_no},{reload:true});
            }
          }else{
            if(video.vss_link){
              $state.go('vimeo_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }else{
              $state.go('video_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true});
            }
          }
        }
      } else {
        swal({
          text: 'Looks like you are not logged in, Please login to continue',
          type: 'info',
          title: 'Information'
        },function(){
          console.log($scope.course);
          swal.close();
          $scope.displaySelectedVideo = true;
          $scope.videoSelectedData = video;
          var redirecturl = 'course/' + $scope.course.modules[0].index_url + '/' + $scope.course.modules[0].id + '/' + video.id +'?courseIndexUrl=' + encodeURIComponent($scope.course.index_url);
          sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          showLoginPopup();
          if(!$scope.$$phase) $scope.$apply();
        })
      }
    }

    $scope.play = function(){
      document.getElementById('play-iccon').style.display = 'none';
      document.getElementById('button-bar').style.display = 'block';
      if($scope.displayAd){
        adVideo.play();
      } else {
        video.play();
      }
      $scope.loader = false;
      if (!$scope.$$phase) $scope.$apply();
    }

    $scope.zipAttachments = function(id){
      var video_name = $scope.selectedVideo.name;
      video_name = video_name.split(' ').join('+');
      var win = window.open('https://nearpeer-zips.s3.amazonaws.com/zips/module' + $scope.module_id + '/' + video_name + '-' +id+'.zip', '_blank');
    }

    $scope.addImage = function(image){
      if(image)
      {
        if(CustomStorageService.getUserSignedInStorageData()|| CustomStorageService.getInstructorSignedInStorageData()){
          $scope.imageUploadingInProcess =  true;
          if(!$scope.$$phase) $scope.$apply();
          Upload.upload({
            url: 'api/v1/uploader/uploadImageToS3?userId='+CustomStorageService.getUserInfoStorageData().id + '&socket_id=' + CustomStorageService.getSocketIdStorageData(),
            method: "POST",
            file: image
          }).then(function(data){
            $scope.imageUploadingInProcess = false;
            $scope.commentImage = data.data.link;
            if(!obj){
              $scope.commentImage = data.data.link;
            } else {
              obj.replyImage_url = data.data.link;
            }
            if(!$scope.$$phase) $scope.$apply();
          });
        }
      }

    }

    $scope.$on('internetConnectivityLost', function( event, message ){
      video.pause();
    });

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }
    $scope.$on('internetFound', function( event, message ){
    });

    $scope.dblClick = function(){
      if($scope.loader == false){
        if($scope.isFullScreen){
          $scope.exitFulScreen();
        } else {
          $scope.fullScreen();
        }
      }
    };

    $scope.addComment =function(text)
    {
      if(CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        if(!text){
          swal("Empty Comment","Please add text","info");
          return false;
        }
        if($scope.imageUploadingInProcess){
          swal("Uploading","Please wait for attachment to upload","info");
          return false;
        }
        if($scope.user_type=="student")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addComment';
          // $scope.showData = false;
          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.showData = true;
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment Published",
          //       text: "Your comment will appear once it has been approved by the instructor",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })

        }

        else if($scope.user_type=="instructor")
        {
          var params = {
            user_id: CustomStorageService.getUserInfoStorageData().id,
            text: text,
            video_id: $scope.selectedVideo.id,
            image_url:$scope.commentImage
          }
          // var url = 'api/v1/comments/addInstructorComment';

          // $http.post(url,params)
          // .then(function(data){
          //   if(data.status==200)
          //   {
          //     $scope.commentText="";
          //     swal({
          //       title: "Comment",
          //       text: "Comment posted",
          //       type: "info",
          //       showCancelButton:false
          //     },function(){
          //     });
          //   }
          // })


        }
      } else {
        swal("Error","Please login to comment","error");
      }
    }

    document.addEventListener("fullscreenchange", onFullScreenChange, false);
    document.addEventListener("webkitfullscreenchange", onFullScreenChange, false);
    document.addEventListener("mozfullscreenchange", onFullScreenChange, false);

    function onFullScreenChange() {
      var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
      if(!fullscreenElement){
        $scope.exitFulScreen();
      }
    }

    $scope.rateVideo = function(rating){
      $scope.userThankYou = true;
      if(!$scope.firstTime){
        $http.post('api/v1/users/rateVideo',{vid:$scope.selectedVideo.id,uid: CustomStorageService.getUserInfoStorageData().id})
        .then(function(data){
          $scope.userRatedVideo = true;
          nextVideo();
        })
      } else {
        nextVideo();
      }
    }

    document.getElementById("cont-video-landing").addEventListener("mousemove", showHoveDiv);
    document.getElementById("cont-video-landing").addEventListener("mouseleave",hideHoverDiv);

    function hideHoverDiv(){
      var element = document.getElementById('overlay-cont');
      element.classList.remove("hideDiv");
    }

    function showHoveDiv(event){
      var element = document.getElementById('overlay-cont');
      element.classList.add("hideDiv");
      element.classList.remove("cursorNone");
      $scope.xCord = event.clientX;
      $scope.yCord = event.clientY;
      setTimeout(function(){
        var xCord = event.clientX;
        var yCord = event.clientY;
        if(xCord == $scope.xCord && yCord == $scope.yCord){
          var element = document.getElementById('overlay-cont');
          element.classList.remove("hideDiv");
        }
      },5000)
    }

    $scope.hideComment = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableComment',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.hideReply = function(id){
      var data ={
        comment_id:id
      }
      // $http.post('api/v1/comments/disableReply',data)
      // .then(function(data){
      //   swal({
      //     title: "Success!",
      //     type: "info",
      //     confirmButtonText: "Ok"
      //   });
      // })
    }

    $scope.getInitialLetter = function(str){
      return str.charAt(0).toUpperCase();
    }

    var showLoginPopup = function(){
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }

    $sails.on('imageUploadProgress',function(data){
      $scope.imageUploadLog.progress = data;
      if(!$scope.$$phase) $scope.$apply();
    })

    var adVideo = document.getElementById("video-ad");
    var adSeekBar = document.getElementById("seek-bar-ad");
    var timer = 5;

    $scope.skipAd = function(){
      if(timer == 0){
        showOriginalVideo();
      }
    }

    adVideo.addEventListener("timeupdate", function() {
      if(timer > 0){
        document.getElementById("skip-ad-time").innerHTML = timer - parseInt(adVideo.currentTime);
      }
    });

    adVideo.addEventListener("ended",showOriginalVideo,false);

    function showOriginalVideo(){
      $scope.displayAd = false;
      if(!$scope.$$phase) $scope.$apply();
      if(!$scope.mobileView){
        document.getElementById('video-loader-two').style.display = 'block';
        document.getElementById('button-bar').style.display = 'block';
        video.play()
      } else {
        document.getElementById('play-iccon').style.display = 'block';
      }
    }

    var loadAd = function(){
      $scope.showGifAd = true;
      document.getElementById('play-iccon').style.display = 'none';
      document.getElementById('video-loader-two').style.display = 'none';
      adVideo.src = 'images/Illys_sponsorship.mp4';
      adVideo.play();
    }

    if (window.screen.width > 320 && window.screen.width < 1024) {
      $scope.mobileView = true;
      video.addEventListener("canplay",playVid,false);
    } else{
      video.addEventListener("play",firstTime,false);
    }

    if(!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()){
      if(!CustomStorageService.getFirstTimeStorageData()){
        $scope.firstTime = true;
        $scope.initialize();
      } else {
        var instName = $state.params.institutionName;
        var schoolName = $state.params.schoolName;
        var course = $state.params.courseName;
        $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course});

      }
    } else{
      $state.go('course_module',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo});
    }

  }]);
})();

var onlineStatusApp = angular.module('NearPeer');

onlineStatusApp.factory('onlineStatus', ["$window", "$rootScope", function ($window, $rootScope) {
   var onlineStatus = {};

   onlineStatus.onLine = $window.navigator.onLine;

   onlineStatus.isOnline = function() {
       return onlineStatus.onLine;
   }

   $window.addEventListener("online", function () {
       onlineStatus.onLine = true;
       
       $rootScope.$digest();

   }, true);

   $window.addEventListener("offline", function () {
       onlineStatus.onLine = false;
       
      
       $rootScope.$digest();
   }, true);

   return onlineStatus;
}]);
(function() {
  'use strict';

  angular
  .module('NearPeer')

  .service('paymentService', ['$http', '$state', function($http, $state) {

    this.handleJazzCashResponse = function(response,userID){
      response.user_id = userID;
      response.job = false;

      $http.post('api/v1/orders/update',response)
      .then(function(data){
        console.log('close-in-app-browser');
        if(data.data.success){
          var msg = response.pp_ResponseMessage;
          if(data.data.order.status === 'paid') {
            msg = "purchased! Now you can view the content";
          }
          swal({
            title: "Info!",
            text: msg,
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes !",
            closeOnConfirm: true
          }, function(confirm) {
            location.reload();
          });
        } else {
          swal({
            title: "Info!",
            text: 'please connect to admin and your order id is!' + response.pp_TxnRefNo,
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes !",
            closeOnConfirm: true
          }, function(confirm) {
            location.reload();
          });

        }
        
      },function errorCallback(error) {
        console.log('close-in-app-browser');
        swal({
          title: "Info!",
          text: 'please connect to admin and you order id is!' + response.pp_TxnRefNo,
          type: "success",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes !",
          closeOnConfirm: true
        }, function(confirm) {
            location.reload();
        });
      });
    }
  }]);
})();

(function () {
    "use strict";
  
    angular.module("NearPeer").controller("SingleNotificationController", MainController);
  
    function MainController(
      courseDetailService,
      $rootScope,
      $scope,
      $http,
      $base64,
      $timeout,
      $state,BlogBackendServices
    ) {
      $(document).ready(function () {
        $(this).scrollTop(0);
      });
  
  
    }
  })();
  
(function () {
    "use strict";
  
    angular.module("NearPeer").controller("AllNotificationController", MainController);
  
    function MainController(
      $rootScope,
      $scope,
      $http,
      env,
      $state,
      CustomStorageService
    ) {
      $(document).ready(function () {
        $(this).scrollTop(0);
      });
      $scope.notifications = [];
      $scope.searchText = '';
      $scope.page = 0;
      $scope.isLoading = true;
      var isLoadMore = true;

      $http.post(env.notificationService +'/notification/user-notification-read', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id)})
      .then(function (res) {
      })

      $scope.clickNotification = function(notification) {
        if(!notification.is_clicked) {
          notification.is_clicked = true;
          $http.post(env.notificationService +'/notification/user-notification-click', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id), notification_id: notification.id})
          .then(function (res) {
          })
        }
        if(notification.notifications.redirect_url) {
          var link = notification.notifications.redirect_url;
          if(!link.startsWith("http://") && !link.startsWith("https://")){
            link = 'https://' + link
          }
          if(notification.notifications.redirect_type === 'new_tab') {
            window.open(link, '_blank')
          } else {
            window.location.href = link;
          }
        }
      }

      $scope.getNotifications = function() {
        $scope.isLoading = true;
        $http.post(env.notificationService +'/notification/get-user-notifications', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id), page: $scope.page, search: $scope.searchText, assignmentCount: true, assignment: $scope.NotiSortingType === 'Assignment'})
        .then(function (res) {
          if(res.data && res.data.success) {
            $scope.notifications = $scope.notifications.concat(res.data.notifications);
            $scope.isAssignmentNotification = res.data.isAssignmentNotification;
            if(res.data.notifications.length == 0) {
              isLoadMore = false;
            } else {
              isLoadMore = true
            }
          }
          $scope.isLoading = false;
        });
      }

      $scope.loadMore = function() {
        if(isLoadMore) {
          isLoadMore = false
          $scope.page = $scope.page + 1;
          $scope.getNotifications();
        }
      }

      $scope.searchNotifications = function() {
        $scope.page = 1;
        $scope.getNotifications();
        $scope.notifications = [];
      }

      $scope.showTime = function(notification) {
        return moment(notification.notifications.createdAt)
          .format("hh: mm A");
      }
      $scope.showDate = function(notification, index) {
        var prevText;
        if(index > 0) {
          var compareDate = this.notifications[index-1];
          prevText = moment(compareDate.notifications.createdAt)
          .calendar({
            sameDay: "[Today]",
            nextDay: "DD/MM/YYYY",
            nextWeek: "DD/MM/YYYY",
            lastDay: "[Yesterday]",
            lastWeek: '[Last] dddd',
            sameElse: "DD/MM/YYYY",
          }).split(" at")[0];
        }
        var text = moment(notification.notifications.createdAt)
          .calendar({
            sameDay: "[Today]",
            nextDay: "DD/MM/YYYY",
            nextWeek: "DD/MM/YYYY",
            lastDay: "[Yesterday]",
            lastWeek: '[Last] dddd',
            sameElse: "DD/MM/YYYY",
          }).split(" at")[0];
          
        if(text == prevText) {
          return false
        }
        return text;
      }

      $scope.getNotiSortingType = function (type) {
        $scope.NotiSortingType = type;
        $scope.searchNotifications();
      }
      // $scope.getNotifications();

    }
  })();
  
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('mdPaymentController', MainController);

  function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, $state) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.value = 1;
    $scope.seeMore = false;

    $scope.seeMoreClick = function() {
      $scope.seeMore = !$scope.seeMore;
    }

    $scope.setVal = function(id){
      $scope.value = id;
    }
    $scope.showMorePopup1 = function(){
      $scope.morePopup1 = true;
    }
    $scope.showLessPopup1 = function(){
      $scope.morePopup1 = false;
    }

    $scope.showMorePopup2 = function(){
      $scope.morePopup2 = true;
    }
    $scope.showLessPopup2 = function(){
      $scope.morePopup2 = false;
    }

  }

})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('mdCatController', MainController);

  function MainController($scope,$rootScope,$state,$http, HttpService,landingService, CustomStorageService,BreadcrumbService, env) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });

    $scope.isGuest = false;
    $scope.userData = CustomStorageService.getUserInfoStorageData();
        if($scope.userData.user_type === "guest" || $scope.userData.full_name === "Guest"){
          $scope.isGuest = true;
          }else{
          $scope.isGuest = false;
          
          
          }
    $scope.institution = {name:"MDCAT"};
    $scope.moveToDiv = function(){
      $('html, body').animate({
        scrollTop: $(".features-scroll").offset().top
      }, 1000);
    }
    $scope.mdcatbuy = function() {
      location.href = 'http://bit.ly/3MZ4PW8'
      // landingService.buyBundle("MDCAT_FULL")
      // .then(function(data) {
      //   if(data) {
      //     $scope.bundleData = data;
      //     if($rootScope.orderEmailVerify && !$rootScope.orderEmailVerified) {
      //       $scope.$emit('verify-before-order');
      //     } else {
      //       $scope.$broadcast('salesPopup');
      //     }
      //   }

      // });
    }
    $scope.mdcatGetInTouch = function() {
      location.href = 'http://bit.ly/3Jo8Ep8'
    }
    
    $scope.stories = [{
      name:'Muneeb Khawar',
      qualification :"MDCAT 2020",
      description : "I assure you about Nearpeer’s credibility, enthusiasm and their care for students. I joined Nearpeer in an earlier session and the teachers were cordial and genial. Besides this, they offer different courses in an affordable fee structure. So I will recommend Nearpeer to all the students."
    }, {
      name:'Qasim Iftikhar',
      qualification :"3rd Position Overall | MDCAT 2020",
      description : "The recorded lectures on every subject, the affectionate interaction with all the instructors and the reciprocity with the fellow students of this platform just made the whole thing a success. Sit, relax, and practice from the infinite questions. You will actually find a conducive environment here. They will hold you hand until you reach your destination."
    }, {
      name:'Muhammad Waqas',
      qualification :"MDCAT 2020",
      description : "My experience at Nearpeer was actually really good. I benefitted a great deal from the discussion groups/lounges. The instructors were always ready to help, and they maintained everything nicely. Also, the quizzes were really good and in abundance."
    }, {
      name:'Beenish Sabir',
      qualification :"MDCAT 2020",
      description : "My experience at Nearpeer was amazing! It helped me a lot in my preparation. The Facebook groups were actually instrumental in getting my queries answered with timely replies to each query. I never thought I would get this much support from an online platform. But it was all amazing"
    }];
    $scope.mdCatInstructor = [
    //   {
    //   name:'Sir Shoaib Anwar',
    //   image:'images/shoabi.jpg',
    //   exprience:10,
    //   qualification :"Chemistry",
    //   description : "The all knowledgeable and handsome-he is the guy responsible for your chemistry exam. He has been teaching MDCAT since last 10 years. His teaching style is so engaging that students on Nearpeer sit 5 hours straight to take his lectures."
    // }, 
    {
      name:'Sir Shahid Subhani',
      image:'images/1s.png',
      exprience:13,
      qualification :"Biology",
      description : "The subject with the highest weightage in MDCAT is going to be the easiest for you with Sir Shahid’s comprehensive lectures with animations, diagrams, and quick quizzes. He is the man behind the success of hundreds of doctors pursuing their careers today. You’ll fall in love with him the moment you start listening to his lectures."
    }, 
    // {
    //   name:'Sir Zia Ul Haq',
    //   image:'images/zia.jpg',
    //   exprience:6,
    //   qualification :"Physics",
    //   description : "Not only a teacher but a true mentor. A real guide who helps students realizing their ambitions. With MDCAT teaching experience of 5 years, he'll be the one responsible for your Physics."
    // }, {
    //   name:'Sir Ammar Ali Ayub',
    //   image:'images/Ammar-final.png',
    //   exprience:6,
    //   qualification :"English",
    //   description : "Graduated from LUMS, he is the mind behind Nearpeer. Because of his vast experience of entry tests taking and teaching, he is loved by his students for making education easy and fun. You’ll simply love his English course. Don’t forget to watch his vocabulary lectures."
    // },
    {
      name:'Sir Mansoor Ali Farooqi',
      image:'images/4s.png',
      exprience:13,
      qualification :"Physics",
      description : "Sir Mansoor will help you ace MDCAT Physics from the comfort of your home. Over the years, he has developed strategies and learning techniques to help you achieve a perfect score in MDCAT. Physics numericals will be a piece of cake for you with his engaging and fun-filled lectures.Enroll Now and forget all your worries!"
    },
    {
      name:'Sir Habib Rafique',
      image:'images/2s.png',
      exprience:22,
      qualification :"Chemistry",
      description : "Finding Chemistry daunting? Not anymore. With his experience of over two decades, Sir Habib has perfected his Video Lectures, Quizzes, and Notes so you can fall in love with MDCAT Chemistry. This course will prepare you for  MDCAT, NUMS, Aga Khan, and other medical college entrance exams."
    },
    {
      name:'Sir Tanveer Ahmad',
      image:'images/3s.png',
      exprience:7,
      qualification :"English",
      description : "Sir Tanveer has mastered advanced learning techniques for MDCAT English over the last seven years. He is the most energetic instructor, and the students are enthralled by his amazing video lectures.  He will make you fall in love with the course with his dynamic teaching style, pictorial representations, and creative mnemonics to help to learn the vocabulary.  "
    }
  ];
    $scope.mdCatLearn = [{
      name:'Engaging Video Lectures',
      image:'images/core-1-final.png',
      description: 'Your MDCAT preparation relies heavily on your course coverage and concepts building. Our video lectures are prepared by experienced faculty members who ensure that each topic covers the PMC/PMDCs updated syllabus in depth for effective and efficient learning. You can pause, repeat, and revise lectures as many times as you want.',
      // description : "The core of your MDCAT preparation depends on your course coverage and concepts building. Our video lectures prepared by experienced faculty makes sure that each topic, as per UHS syllabus, is covered in depth so that you learn effectively and confidently. You can pause, repeat, and revise lectures as many times as you want."
    }, {
      name:'Online Classroom Groups',
      image:'images/learn1.jpg',
      description : "A lot of times there can be moments you want to talk to your teachers and class fellows to discuss your confusions. We’ve a solution for that too. Stay connected to your teachers and fellows 24/7 via our online classroom groups. Ask question even at 1am in the night and you’ll get your answers."
    }, {
      name:'10,000+ Quiz Questions',
      image:'images/Core-2.png',
      description: 'When it comes to MDCAT, learning without practice is useless! Realizing this, we bring you more than 25,000 Practice MCQs with detailed solutions and representation of your strengths and weaknesses. You get MCQs after each sub-topic, topic, and full length papers along with the solution video. Now that is something that will ensure you don’t even get a single question wrong on the MDCAT Exam Day.',
      // description : "When it comes to MDCAT, learning without practice is useless! Realizing this, we bring you more than 10,000 Practice MCQs that you can practice from repeatedly. You get MCQs after each sub-topic, topic, and full length papers along with the solution video. Now that is something that will ensure you don’t even get a single question wrong on the MDCAT Exam Day."
    }, {
      name:'Its important to know your weaknesses',
      image:'images/Core-3-final.png',
      description : "Its important because once you know your weaknesses, you know what requires more attention and what doesn’t. When you solve quizzes on Nearpeer MDCAT portal, the system understands and shows you your strengths and weaknesses. Now you can further make sure you don’t get any question wrong, even if you were weak in them."
    }];
    $scope.faqs = [{
      question : "What is Nearpeer.org?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Nearpeer Private Limited offers online courses for universities, professional qualifications, and test preparation markets. We take pride in cultivating the motto of Self-Learning in Pakistan. We aim to empower the students by producing the course-complementary content that is engaging, effective, time-efficient, and conceptual. &nbsp;</span></p>'
    },{
      question : "Do you offer any physical classes?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">No, we do not provide any physical classes. Nearpeer.org is a purely online educational ecosystem that believes students can get value out of their time by relying on online education. If you’re confused between choosing online education or a physical academy, read this and make your decision wisely.  &nbsp;</span></p>'
    },{
      question : "What will I get by enrolling in the Nearpeer Online MDCAT Course?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">You get access to every concept through detailed video lectures. 24/7 active classroom groups for Q&A. Nearpeer instructors are the best; they don’t mind if you ping them at 1:00 am in the night to get your questions answered. Notes and PDF Books, so that you can revise what was covered in the video lectures. Unlimited practice material along with performance evaluation. Based on your quiz performances, we can tell your strengths and weaknesses helping you to study smart. </span><span style="font-size: 12.0pt;color: black;">.&nbsp;</span></p>'
    },{
      question : 'How is it better than attending physical academies?',
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">There are many ways in which online education can guarantee you success in MDCAT more than physical institutions can do. Primarily because online education gives you back control of your own learning. Now you can give maximum time to self-study, which is the ultimate key to top MDCAT.However, you cannot do so by attending physical academies. Not only that, there are several other advantages; please refer to the table above on this page to understand what benefits you get by enrolling at Nearpeer as compared to enrolling in a physical academy, or Click here to know more. .&nbsp;</span></p>'
    },{
      question : "Can I talk to instructors in case I have questions?",
      answer : '<p><span style="font-size: 12.0pt;color: black;">Yes, you can. We understand how important it is to talk to an instructor in case you are stuck in some concepts. We bring up the Online Classroom Groups, where our instructors are always available to help you. Stay connected to your teachers and fellows 24/7 via our online classroom groups. &nbsp;</span></p>'
    },{
      question : "Are Nearpeer lectures according to the new MDCAT Syllabus?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Yes. </span><span style="font-size: 12.0pt;color: black;">Nearpeer instructors have covered the entire course as per PMC syllabus requirements. We also update our content.In addition to that, the required difficulty level and format have been kept in mind while designing the course. When you study at Nearpeer, you have the confidence that there is no other book or academy you need to ace your exams! We’ve everything you need to ace your MDCAT exams.</span></p>'
    },{
      question : "Can students of other provinces take this course?",
      answer : '<p>Yes, this course is made keeping in mind the national syllabus of MDCAT announced by PMC (Pakistan Medical Commission). Therefore, you can take this course for MDCAT Preparation regardless of the province you belong to. <br><br></p>'
    },{
      question : "Till when will I have access to the course?",
      answer : '<p>You will have access to the course till MDCAT Exam day. All additions to the course will be made without additional charges once you’re enrolled in the course.<b>Note:</b> Do you know that physical academies charge hefty amounts of money only to teach you for 3-4 months. Make your decision wisely! <br><br></p>'
    },{
      question : "How can I enroll in this amazing ecosystem to top my MDCAT?",
      answer : '<p>Well, below are the steps you can follow to enroll in our MDCAT program.<li> Pay the required fee in our bank account</li> <li>How to Pay?Take a clear picture/screenshot of your receipt and WhatsApp us at 0311-1444734 along with the following details </li> <li>a) Your name </li> <li> b) Course you want (MDCAT in this case)</li> <li> c) Nearpeer registered Email</li> <li>Still didn’t get the answer to your question? Worry not! Contact us at +92 311 1444734, and we will answer all your relevant questions.</li>   <br><br></p>'
     }
    //,{
    //   question : "Can I attend the lectures whenever I want?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Yes, you can attend lectures whenever you want.It’s not like you have to wait for the teacher to start a class and end the class. You can chose to study anytime in the day. You may prefer to study early in the morning or late at the night – you will always have the access to your MDCAT Course.&nbsp;</span></p>'
    // },{
    //   question : "In how many days can I cover the syllabus?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">It completely depends upon you. With Nearpeer MDCAT, you can cover the entire syllabus within 20 days, or chose tocover in 3 months. You can even revise entire course 3 times in 3 months with Nearpeer MDCAT because you may repeat content whenever you want. Nearpeer gives you the flexibility to make your own schedule. To make your own schedule, </span><span style="font-size: 12.0pt;color: black;"><a href="https://web.facebook.com/nearpeer.org/videos/574508542900047/">click here</a></span><span style="font-size: 12.0pt;color: black;">.</span></p>'
    // },{
    //   question : "Do you offer any physical classes?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">No, we do not provide any physicalclasses. Nearpeer.org is purely online educational ecosystem that believes students can get true value out of their time by relying on online education.If you’re confused between whether to choose online education or a physical academy, </span><span style="font-size: 12.0pt;color: black;"><a href="https://www.nearpeer.org/blog/62">read this</a></span><span style="font-size: 12.0pt;color: black;">.&nbsp;</span></p>'
    // },{
    //   question : "Till when will I have access of the course?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">You will have access of the course till MDCAT Exam day. All additions in the course will be made without additional charges once you’re enrolled in the course.&nbsp;</span></p>'
    // },{
    //   question : "How to pay and enrol in the course (JazzCash)?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;"><b>Method 1 (Recommended):</b></span></p><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;"> </span><span style="font-size: 12.0pt;color: black;">Visit </span><u><span style="font-size: 12.0pt;color: #1155cc;"><a href="http://www.nearpeer.org/">www.nearpeer.org</a></span></u><span style="font-size: 12.0pt;color: black;">.</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;"> Click </span><span style="font-size: 12.0pt;color: black;">MDCAT </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;"> Click </span><span style="font-size: 12.0pt;color: black;">“How to buy” and you’ll see a video explaining step-by-step procedure of how to buy, or</span><span style="font-size: 12.0pt;color: black;">,</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">4.</span><span style="font-size: 12.0pt;color: black;"> Simply </span><span style="font-size: 12.0pt;color: black;">Click “Buy Now”. </span><span style="font-size: 12.0pt;color: black;">This will take you to full MDCAT Course page.</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">5.</span><span style="font-size: 12.0pt;color: black;"> Next, Click Purchase through debit/card (</span><span style="font-size: 12.0pt;color: black;">JazzCash</span><span style="font-size: 12.0pt;color: black;">).</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">6.</span><span style="font-size: 12.0pt;color: black;">This </span><span style="font-size: 12.0pt;color: black;">will take you to a “Jazz Cash Payment Portal”</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">7.</span><span style="font-size: 12.0pt;color: black;"> From </span><span style="font-size: 12.0pt;color: black;">the dropdown menu, “Select Voucher Payment” (This is recommended payment method by Nearpeer.org. You can use debit/credit card for purchase to if you want)</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">8.</span><span style="font-size: 12.0pt;color: black;"> Enter </span><span style="font-size: 12.0pt;color: black;">your Mobile Number in the given field, and press pay. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">9.</span><span style="font-size: 12.0pt;color: black;"> You’ll </span><span style="font-size: 12.0pt;color: black;">receive a </span><span style="font-size: 12.0pt;color: black;">sms</span><span style="font-size: 12.0pt;color: black;"> from </span><span style="font-size: 12.0pt;color:black;">JazzCash</span><span style="font-size: 12.0pt;color: black;">.</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">10.</span><span style="font-size: 12.0pt;color: black;"> Next</span><span style="font-size: 12.0pt;color: black;">, you go to any nearest </span><span style="font-size: 12.0pt;color: black;">JazzCash</span><span style="font-size: 12.0pt;color: black;"> shop in the market, show this SMS to </span><span style="font-size: 12.0pt;color: black;">JazzCash</span><span style="font-size: 12.0pt;color: black;"> Agent, and pay the course fee. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">11.</span><span style="font-size: 12.0pt;color: black;"> Once </span><span style="font-size: 12.0pt;color: black;">done with payment, (after one hour) simply refresh the Nearpeer course page, click MDCAT, and you’ll see your 4 courses access in front of you. </span></div><p></p><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">12.</span><span style="font-size: 12.0pt;color: black;">In case of any issue, feel free to WhatsApp/Call on 03470171480</span></div>'
    // },{
    //   question : "How to pay and enrol in the course (EasyPaisa)?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;"><b>Method 3 (Easy Paisa): </b></span></p><p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;"><br></span><span style="font-size: 12.0pt;color: black;">If the above options do not work for you, this will for sure. You may pay by visiting any </span><span style="font-size: 12.0pt;color:black;">EasyPaisa</span><span style="font-size: 12.0pt;color: black;"> Shop near your home. Following are the steps:</span></p><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;"><br></span><span style="font-size: 12.0pt;color: black;">Visit any Nearby </span><span style="font-size: 12.0pt;color: black;">EasyPaisa</span><span style="font-size: 12.0pt;color: black;"> Shop</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;">From the </span><span style="font-size: 12.0pt;color: black;">Easypaisa</span><span style="font-size: 12.0pt;color: black;"> agent, request “Bank Deposit Service”</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;">Provide the agent following details:</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;"><b>Mobile No. 03459615004</b></span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;"><b>Bank Name: </b></span><span style="font-size: 12.0pt;color: black;"><b>Faysal</b></span><span style="font-size: 12.0pt;color: black;"><b> Bank</b></span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;"><b>Bank Account number 0125007900219780 (Branch Code: 125 DHA, Branch)</b></span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">4.</span><span style="font-size: 12.0pt;color: black;"><b>Confirm the Bank Account Title "NEARPEER (Private) Limited"</b></span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">4.</span><span style="font-size: 12.0pt;color: black;">Confirm the transfer. You’ll get a confirmation </span><span style="font-size: 12.0pt;color: black;">sms</span><span style="font-size: 12.0pt;color: black;"> from 3737. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">5.</span><span style="font-size: 12.0pt;color: black;">Take the screenshot of that message and WhatsApp to </span><span style="font-size: 12.0pt;color:black;"><b>0345-9615004</b></span><span style="font-size: 12.0pt;color: black;"> along with the following details:</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;">Your name</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;">City</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;">Course you want (MDCAT in this case)</span></div><p></p><div style="direction: ltr;vertical-align: baseline;"><span style="font-size:12.0pt;">6.</span><span style="font-size: 12.0pt;color: black;">Our representative will then provide you with access codes you will need to view courses.</span></div>'
    // },{
    //   question : "How to pay and enrol in the course (Bank Transfer)?",
    //   answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;"><b>Method 2 (Bank Transfer): </b></span></p><p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;"><br></span><span style="font-size: 12.0pt;color: black;">You can also pay the course feedirectly to our bank account. Following are the steps:</span></p><div style="direction: ltr;vertical-align:baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;"><br></span><span style="font-size: 12.0pt;color: black;">Visit any </span><span style="font-size: 12.0pt;color: black;">Faysal</span><span style="font-size: 12.0pt;color: black;"> Bank Ltd. Branch</span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size:12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;">Askfor the deposit slip. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;">Fillthe deposit slip with the required details. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">4.</span><span style="font-size: 12.0pt;color: black;">Whererequired, enter following account details:</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;"><b>Bank Name: </b></span><span style="font-size: 12.0pt;color: black;"><b>Faysal</b></span><span style="font-size: 12.0pt;color: black;"><b> Bank</b></span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;"><b>Bank Account number0125007900219780 (Branch Code: 125 DHA, Branch)</b></span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;"><b>Bank Account Title "NEARPEER(Private) Limited"</b></span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">5.</span><span style="font-size: 12.0pt;color: black;">You may take any Bank Officer’s help to fill up this deposit slip. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">6.</span><span style="font-size: 12.0pt;color: black;">Onceyou pay the fee, the banking officer will provide you customer’s copy of the deposit slip. </span></div><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">7.</span><span style="font-size: 12.0pt;color: black;">Take a clear picture of that slip and WhatsApp it to </span><span style="font-size: 12.0pt;color: black;"><b>0345-9615004</b></span><span style="font-size: 12.0pt;color: black;"> along with following details:</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size:12.0pt;">1.</span><span style="font-size: 12.0pt;color: black;">Your name</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">2.</span><span style="font-size: 12.0pt;color: black;">City</span></div><div class="O1" style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">3.</span><span style="font-size: 12.0pt;color: black;">Course you want (MDCAT in this case)</span></div><p></p><div style="direction: ltr;vertical-align: baseline;"><span style="font-size: 12.0pt;">8.</span><span style="font-size: 12.0pt;color: black;">Our representative will then provide you with access codes you will need to view courses.&nbsp;</span></div>'
    // }
  ];

    $scope.videos = [{
      src: 'P7nFnDPzQsg',
      id: 'video1',
      quiz : "Chemistry Demo Quiz",
      quizUrl : env.velocityPortal + '/quiz/standard-quiz-main/6052790648405d336503518e?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData(),
      poster :'/images/Chem Thumbnail.png',
      viewMore:{institutionName: 'entry-test-preparation',schoolName: 'mdcat',courseName:'mdcat-chemistry'}
    }, {
      src: 'IzOZ8w1k30Q',
      id: 'video2',
      quiz : "Biology Demo Quiz",
      quizUrl : env.velocityPortal + '/quiz/standard-quiz-main/6052790648405d336503518c?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData(),
      poster :'/images/Bio Thumbnail.png',
      viewMore:{institutionName: 'entry-test-preparation',schoolName: 'mdcat',courseName:'mdcat-biology'}
    }, {
      src: 'MY9xiN-o2jo',
      id: 'video3',
      quiz : "Physics Demo Quiz",
      quizUrl : env.velocityPortal + '/quiz/standard-quiz-main/6052790548405d336503518a?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData(),
      poster :'/images/Physics MDCAT.png',
      viewMore:{institutionName: 'entry-test-preparation',schoolName: 'mdcat',courseName:'mdcat-physics'}

    }, {
      src: 'lFyd9B8F6T0',
      id: 'video4',
      quiz : "English Demo Quiz",
      quizUrl : env.velocityPortal + '/quiz/standard-quiz-main/605279ad48405d33650352ee?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData(),
      poster :'/images/English MDCAT.png',
      viewMore:{institutionName: 'entry-test-preparation',schoolName: 'mdcat',courseName:'mdcat-english'}
    }];
    $scope.direction = 'left';
    $scope.currentIndex = 0;
    $scope.setCurrentSlideIndex = function (index) {
      $scope.direction = (index > $scope.currentIndex) ? 'left' : 'right';
      $scope.currentIndex = index;
    };
    $scope.isCurrentSlideIndex = function (index) {
      return $scope.currentIndex === index;
    };
    $scope.prevSlide = function () {
      $scope.direction = 'left';
      $scope.currentIndex = ($scope.currentIndex < $scope.videos.length - 1) ? ++$scope.currentIndex : 0;
    };
    $scope.nextSlide = function () {
      $scope.direction = 'right';
      $scope.currentIndex = ($scope.currentIndex > 0) ? --$scope.currentIndex : $scope.videos.length - 1;
    };
   
    onloadFunction(
    {'url': '/mdcat-test-preparation',
    'displayName':'MDCAT', 
    },'LEAF'
    );
    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
      }
  }
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("loginController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    CustomStorageService,
    $state,
    $sails,
    $cookies,
    env,
    toaster,
    $location
  ) {

    var allowedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'icloud.com', 'ymail.com'];

    $(document).ready(function(){
      $(this).scrollTop(0);

      document.addEventListener('AppleIDSignInOnSuccess', appleSigninSuccess);
    });
    $scope.$on("$destroy", function () {
      document.removeEventListener('AppleIDSignInOnSuccess', appleSigninSuccess);
    });
    $rootScope.userSide = true;

    $scope.encrypt = function (text) {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };

    $scope.decrypt = function (data) {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    var width = window.screen.width * window.devicePixelRatio;
    var height = window.screen.height * window.devicePixelRatio;

    var dimensions = {
      width: width,
      height: height,
      dimensions: height + "x" + width,
    };

    $scope.login = true;
    $scope.email_Field = true;
    // $scope.signup = false;
    $scope.password_Field = false;
    $scope.password_Field_signup = false;
    $scope.login_button = false;
    $scope.forget_password = false;
    $scope.skip_password = false;
    $scope.Otp_code = false;
    $scope.wrong_Otp_code = false;
    $scope.noti_reset = false;
    $scope.social_login = true;
    $scope.loginForm = {
      password:"",
      confirm_password:""
    };
    $scope.userID = "";
    $scope.userEmail = "";
    $scope.loader = false;
    $scope.errorMessage = "";
    $scope.digit1 = "";
    $scope.digit2 = "";
    $scope.digit3 = "";
    $scope.digit4 = "";
    $scope.digit5 = "";
    $scope.digit6 = "";
    $scope.loginBackBtn = false;
    $scope.thankyou_popup = false;
    $scope.phoneSelected = false;
    $scope.otpString = "";
    $scope.tempEmail = "";
$scope.newUserEmail = false;
$scope.newUserPhone = false;
$scope.oldFlowSignup = false;

    $scope.signupClick = function () {
      setTimeout(function () {
        $("#country").countrySelect({
          defaultCountry: "pk",
          preferredCountries: ["pk"],
          localizedCountries: {},
        });
        $(".country-select").css("margin-top", "0px");
      }, 300);
    };

    $scope.$watch (
      function () { return $state.params; },
      function (value) { onStepChange(value) } 
    );

    var onStepChange = function(params) {
      var step = params.step;
      console.log(params);
      if(!step && $state.current.name != 'Login' && $state.current.name != 'Create_Account'  && $state.current.name != 'Login_Social') {
        $scope.closeForm();
      }
      else if ($state.current.name === 'Login') {
        // $scope.login = true
        // $scope.signup = false
        // $scope.Otp_code = false
        // $scope.email_Field = true;
        // $scope.password_Field = false;
        // $scope.loginForm.password = "";
        // $scope.loginForm.confirm_password = "";
        // $scope.loginBackBtn = false;
        // $scope.phone_Field_signup = false;
        // $scope.social_login = true;
        // $scope.newUserEmail = false;
        // $scope.newUserPhone = false;
        // $scope.skip_password = false;
      } else if(step === 'password') {
        $scope.login = true;
        $scope.email_Field = false;
        $scope.password_Field = true;
        $scope.forget_password = false;
        $scope.loginBackBtn = true;
      }
      else if (step === 'phone') {
        $scope.password_Field_signup = false;
        $scope.phone_Field_signup = true;
        $scope.signupClick();
        $scope.loginBackBtn = true;
        $scope.email_Field = false;
        $scope.social_login = true;
      }
      else if (step === 'email') {
        $scope.social_login = true;
        $scope.password_Field_signup = false;
        $scope.phone_Field_signup = false;
        $scope.email_Field = true;
        $scope.newUserEmail = false;
        $scope.newUserPhone = false;
        $scope.loginBackBtn = false;
      }
    }
    // if ($scope.email_Field) {
    //   $scope.loginBackBtn = false;
    // } else {
    //   $scope.loginBackBtn = true;
    // }

    if ($rootScope.signupFormSelected) {
      // console.log($rootScope.signupFormSelected, "signup form");
      // $scope.login = true;
      $scope.signup = true;
      $scope.signupClick();
      // $scope.social_login = false;
      // $scope.social_login = false;
      setTimeout(function () {
        var loginEmail = document.getElementById('loginEmail');
        var loginPassword = document.getElementById('password');
        // console.log(loginEmail, 'login email');
        // console.log(loginPassword, 'login pasword');
        // loginEmail.focus();
      }, 600);
    } else {
      // $scope.login = false;
      // $scope.social_login = true;
      $scope.signup = false;
      setTimeout(function () {
        var loginEmail = document.getElementById('loginEmail');
        var loginPassword = document.getElementById('password');
        // console.log(loginEmail, 'login email');
        // console.log(loginPassword, 'login pasword');
        // loginEmail.focus();
        // loginPassword.focus();
      }, 600);

    }

    $scope.guestMode = false;
    $scope.userD = {};
    $scope.registrationForm = {
      countryCode: "92",
    };
    $scope.objectFromReact = "";
    $scope.appObject = [];
    var guestID = "123ANCC";
    var tempID = window.localStorage.getItem(
      "guestID"
    );
    if(tempID) {
      guestID = tempID;
    } else {
      guestID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
      window.localStorage.setItem(
        "guestID",
        guestID
      );
    }

    $scope.userD = CustomStorageService.getUserInfoStorageData();
    if (($scope.userD||[]).user_type === "guest") {
      $scope.guestMode = true;
    }
$scope.newCreateAccountEmail = function(data){
  $scope.errorMessage = "";
  // console.log('email',data);
  // console.log($rootScope.signupFormSelected, "signup form");
  // $scope.signup = true;
  $rootScope.signupFormSelected = true;
  // $scope.newUserEmail = false;
  // document.getElementById('newUserEmail').style.height = '0px'
  $state.go('Create_Account', {step: 'phone'}, {notify: false})
  $scope.submitSignup(data,'email');

}
$scope.newCreateAccountPhone = function(){
  $scope.errorMessage = "";
  $scope.loginForm.email_phone="";
  $rootScope.signupFormSelected = true;
  $scope.signup = true;
  $scope.signupClick();
  $state.go('Create_Account', {step: 'email'}, {notify: false})
  mixpanel.track('Create-account-click');
  setTimeout(function () {
    var loginEmail = document.getElementById('loginEmail');
    var loginPassword = document.getElementById('password');
    // console.log(loginEmail, 'login email');
    // console.log(loginPassword, 'login pasword');
    // loginEmail.focus();
  }, 600);
  $scope.newUserPhone = false;
  document.getElementById('newUserPhone').style.height = '0px'
}
    var waitForBridge = function (guest) {
      if (!$rootScope.isWindowloaded) {
        setTimeout(waitForBridge, 400);
      } else {
        setTimeout(function () {
          // swal.close();
          console.log("userToken" + loginResponse.data.token);
          console.log("userID" + loginResponse.data.user.id);
          console.log("urlToRoute"+$location.$$url);

          if(CustomStorageService.getAppFreeAccessPopup()){
            console.log("firstLogin");
          }
          console.log("loggedIn");
          $scope.$emit("userLoggedIn");
          loginResponse = {};
          location.reload();
        }, 600);
      }
    };

    $scope.loginForm = {};
    $scope.currentDate = "";
    var today = new Date();
    var dd = today.getDate() - 1;
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    // function init() {
    //   console.log("in controller init");
    //   gapi.load("auth2", function () {
    //     auth2 = gapi.auth2.init({
    //       client_id:
    //         "715283382661-7rfvtjhs9eaofrhkn50017d4kg7862mh.apps.googleusercontent.com",
    //       cookiepolicy: "single_host_origin",
    //       scope: "profile email",
    //     });
    //     element = document.getElementById("glogin");
    //     auth2.attachClickHandler(element, {}, onGoogleSuccess, onGoogleFailure);
    //   });
    // }
    // window.init = init
    // Sign-in success callback
    function onGoogleSuccess(googleUser) {
      var obj;
      var browser_id = $cookies.get("browserId");
      if ($rootScope.platform_reactApp) {
        obj = {
          user: {
            jwt: googleUser.id_token,
            email: googleUser.user.email ? googleUser.user.email : null,
            name: googleUser.user.name ? googleUser.user.name : null,
            img: googleUser.user.photo ? googleUser.user.photo : null,
          },
          browserId: browser_id,
        };
      } else {
        var profile = googleUser.getBasicProfile();
        // The ID token you need to pass to your backend:
        var id_token = googleUser.getAuthResponse().id_token;
        obj = {
          user: {
            jwt: id_token,
            email: profile.getEmail() ? profile.getEmail() : null,
            name: profile.getName() ? profile.getName() : null,
            img: profile.getImageUrl(),
          },
          browserId: browser_id,
        };
      }

      $http.post("/api/v1/auth/google-login", obj).then(
        function (resp) {
          if (
            resp.data.user.user_type === "student" &&
            resp.data.user.disabled === false
          ) {
            $scope.loading = false;
            $scope.loginpopUp = false;
            $scope.text = "Logged in as " + resp.data.user.full_name;
            $scope.loading = false;
            console.log('google login', resp.data.user.email, resp.data.user.full_name);
            mixpanel.track('Login-with-google',{
              
              'User_ID': resp.data.user.id ? resp.data.user.id : null,
              'User_Name': resp.data.user.name ? resp.data.user.name : null,
              'User_Email': resp.data.user.email ? resp.data.user.email : null,
              'User_Phone': resp.data.user.phone ? resp.data.user.phone : null,
            });
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              resp.data.token,
              resp.data.user
            );

            $rootScope.userNotLoggedIn = false;
            if ($rootScope.platform_reactApp) {
              loginResponse = resp;
              waitForBridge();
            } else {
              swal.close();
              $scope.$emit("userLoggedIn");
            }
            // swal(
            //   {
            //     title: "Log In Successful!",
            //     text: $scope.text,
            //     type: "success",
            //     timer: 2000,
            //     showConfirmButton: false,
            //   },
            //   function () {
     
            //   }
            // );
          } else if (
            resp.data.user.user_type === "student" &&
            resp.data.user.disabled === true
          ) {
            $scope.loading = false;
            $scope.loginpopUp = false;
            swal({
              title: "Error",
              text: "Account is temporarily disabled",
              type: "error",
            });
          } else {
            $scope.loginpopUp = false;
            $scope.loading = false;
            swal(
              {
                title: "Error",
                text: "Not Authorized",
                type: "error",
              },
              function () {
                $scope.loginpopUp = true;
                if (!$scope.$$phase) $scope.$apply();
              }
            );
          }
        },
        function errorCallback(response) {
          if (response.data.code == "LIMIT_REACHED") {
            $scope.$emit("userLoggedInAfterVerification", response.data);
          } else {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
            });
          }
        }
      );
    }
        
    window.onGoogleSuccess = onGoogleSuccess;
    // Sign-in failure callback
    // $scope.googleStart = function(){
    //    googleInit();
    //   }
    function onGoogleFailure(error) {
      console.log("error occured on login:", error);
    }
    window.onGoogleFailure = onGoogleFailure;

    today = yyyy + "-" + mm + "-" + dd;
    $scope.currentDate = today;

    // var Rem = CustomStorageService.getRememberMeData();
    // if (Rem) {
    //   var decPassword = $scope.decrypt(Rem.password);
    //   $scope.loginForm.email = Rem.email;
    //   $scope.loginForm.password = decPassword;
    //   $scope.loginForm.remember_me = Rem.remember_me;
    // }

    // $scope.rememberMe = function (check, loginForm) {
    //   if (check) {
    //     var encPassword = $scope.encrypt(loginForm.password);
    //     var rememberData = {
    //       email: loginForm.email,
    //       password: encPassword,
    //       remember_me: loginForm.remember_me,
    //     };
    //     CustomStorageService.setRememberMeData(rememberData);
    //   } else if (!check) {
    //     window.localStorage.removeItem("remember_me");
    //   }
    // };

    $scope.checkPhone = function () {
      var regExp = /[a-zA-Z]/g;
      if (regExp.test($scope.loginForm.phone)) {
        $scope.errorMessage = "Enter a valid Phone Number.";
      } else {
        if ($scope.loginForm.phone.length < 10) {
          $scope.errorMessage = "Incomplete Contact Number.";
        } else {
          $scope.nextForm("phone");
        }
      }
    };

    $scope.googleForReact = function () {
      $scope.objectFromReact = "google";
      console.log("googleClicked");
    };

    $scope.facebookForReact = function () {
      $scope.objectFromReact = "facebook";
      console.log("facebookClicked");
    };
    $scope.appleForReact = function () {
      $scope.objectFromReact = "apple";
      console.log("appleClicked");
    };
    
    $scope.facebookAuthReact = function (obj) {
      console.log("IN FACEBOOK");
      console.log(obj);
      console.log(JSON.stringify(obj));

      $scope.objectFromReact = "";
      var browserId = $cookies.get("browserId");
      if (!browserId) {
        browserId =
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15);
        $cookies.put("browserId", browserId);
      }
      var object = {
        user: {
          id: obj.id,
          fb_email: obj.email ? obj.email : null,
          name: obj.first_name
            ? obj.last_name
              ? obj.first_name + obj.last_name
              : obj.first_name
            : null,
        },
        browserId: browserId,
        origin: "LMS",
      };

      $http
        .post(
          env.backendService + "/lmsservice/v1/auth/lms-facebook-login",
          object
        )
        .then(
          function (resp) {
            if (resp && resp.data && resp.data.success) {
              $scope.loading = false;
              $scope.loginpopUp = false;
              $scope.text = "Logged in as " + resp.data.user.name;
              $scope.loading = false;
              mixpanel.track('Login-with-facebook',{
                'User_ID': resp.data.user.id ? resp.data.user.id : null,
                'User_Name': resp.data.user.name ? resp.data.user.name : null,
                'User_Email': resp.data.user.email ? resp.data.user.email : null,
                'User_Phone': resp.data.user.phone ? resp.data.user.phone : null,
              });
              CustomStorageService.SignInService(
                false,
                true,
                false,
                false,
                resp.data.token,
                resp.data.user
              );

              const isPrivacy = resp.data.isPrivacy ? "true" : "false";
              CustomStorageService.setTermStatus(isPrivacy);
              $rootScope.userNotLoggedIn = false;
              if ($rootScope.platform_reactApp) {
                loginResponse = resp;
                waitForBridge();
              } else {
                // swal.close();
                $scope.$emit("userLoggedIn");
              }
              // swal(
              //   {
              //     title: "Log In Successful!",
              //     text: $scope.text,
              //     type: "success",
              //     timer: 2000,
              //     showConfirmButton: false,
              //   },
              //   function () {
     
              //   }
              // );
            }
          },
          function errorCallback(response) {
            console.log("IN FB ERROR");
            console.log(response);
            if (response.data.code == "LIMIT_REACHED") {
              $scope.$emit("userLoggedInAfterVerification", response.data);
            } else {
              swal({
                title: "Error",
                text: response.data.message,
                type: "error",
              });
            }
          }
        );
    };

    var loginResponse = {};

    $scope.closeForm = function () {
      $scope.loginpopUp = true;
      $scope.$emit("closeForm");
    };
    
    $scope.googleLogin = function () {
      $state.go('Login_Social', {social_type: 'google'}, {notify: false});
    };

    $scope.authenticateFacebook = function () {
      $state.go('Login_Social', {social_type: 'facebook'}, {notify: false});
      var url =
        location.protocol +
        "//" +
        location.host +
        "/api/v1/auth/facebookSignin?uniqueId=" +
        CustomStorageService.getSocketIdStorageData();
      window.open(url, "_blank", "width=500,height=500");
    };

    $scope.authenticateApple = function () {
      $state.go('Login_Social', {social_type: 'apple'}, {notify: false});
      AppleID.auth.signIn().then(function (authData) {
        console.log(authData);
      });
    };

    function appleSigninSuccess(data) {
      var appleObj;
      console.log("IN apple");

      if ($rootScope.platform_reactApp) {
        appleObj = data;
      } else {
        appleObj = data.detail;
      }

      console.log("IN apple data");
      console.log(JSON.stringify(appleObj));
      $http
        .post("/api/v1/auth/app-apple-login", {
          user: {
            jwt: appleObj.authorization
              ? appleObj.authorization.id_token
              : appleObj.id_token,
            email: appleObj.user ? appleObj.user.email : appleObj.email,
            name: appleObj.user
              ? appleObj.user.name
              : appleObj.name
              ? appleObj.name
              : null,
          },
        })
        .then(
          function (resp) {
            if (
              resp.data.user.user_type === "student" &&
              resp.data.user.disabled === false
            ) {
              console.log("IN apple success");
              $scope.loading = false;
              $scope.loginpopUp = false;
              $scope.text = "Logged in as " + resp.data.user.full_name;
              $scope.loading = false;
              mixpanel.track('Login-with-apple-ID',{
                'User_ID': resp.data.user.id ? resp.data.user.id : null,
                'User_Name': resp.data.user.name ? resp.data.user.name : null,
                'User_Email': resp.data.user.email ? resp.data.user.email : null,
                'User_Phone': resp.data.user.phone ? resp.data.user.phone : null,
              });
              CustomStorageService.SignInService(
                false,
                true,
                false,
                false,
                resp.data.token,
                resp.data.user
              );

              $rootScope.userNotLoggedIn = false;
              if ($rootScope.platform_reactApp) {
                loginResponse = resp;
                waitForBridge();
              } else {
                swal.close();
                $scope.$emit("userLoggedIn");
              }
              // swal(
              //   {
              //     title: "Log In Successful!",
              //     text: $scope.text,
              //     type: "success",
              //     timer: 2000,
              //     showConfirmButton: false,
              //   },
              //   function () {
                  
  
              //   }
              // );
            } else if (
              resp.data.user.user_type === "student" &&
              resp.data.user.disabled === true
            ) {
              console.log("IN apple failure");

              $scope.loading = false;
              $scope.loginpopUp = false;
              swal({
                title: "Error",
                text: "Account is temporarily disabled",
                type: "error",
              });
            } else {
              $scope.loginpopUp = false;
              $scope.loading = false;
              console.log("IN apple non auth");

              swal(
                {
                  title: "Error",
                  text: "Not Authorized",
                  type: "error",
                },
                function () {
                  $scope.loginpopUp = true;
                  if (!$scope.$$phase) $scope.$apply();
                }
              );
            }
          },
          function errorCallback(response) {
            if (response.data.code == "LIMIT_REACHED") {
              $scope.$emit("userLoggedInAfterVerification", response.data);
            } else {
              console.log("IN apple limit");

              swal({
                title: "Error",
                text: response.data.message,
                type: "error",
              });
            }
          }
        );
      
    }

    $scope.backForm = function () {
      $scope.errorMessage = "";
      if(!$scope.oldFlowSignup){
        $scope.login = true;
        $scope.signup = false;
        $scope.phone_Field_signup = false;
        $scope.loginBackBtn = false;
      }
      if ($scope.password_Field) {
        $state.go('Login', {notify: false})
        $scope.email_Field = true;
        $scope.password_Field = false;
        $scope.loginForm.password = "";
        $scope.loginForm.confirm_password = "";
        $scope.loginBackBtn = false;
      }
      if ($scope.forget_password) {
        $scope.login = true;
        $scope.email_Field = false;
        $scope.password_Field = true;
        $scope.forget_password = false;
        $scope.loginBackBtn = true;
        $state.go('Login', {notify: false})
      }
      if ($scope.skip_password) {
        $scope.login = true;
        $scope.email_Field = false;
        $scope.password_Field = true;
        $scope.skip_password = false;
        $scope.loginBackBtn = true;
      }
      
      if ($scope.wrong_Otp_code) {
        $scope.wrong_Otp_code = false;
        $scope.Otp_code = true;
        $scope.loginBackBtn = true;
        addPasteHandler();
      }
      if ($scope.phone_Field_signup) {
        $scope.phone_Field_signup = false;
        $scope.email_Field = true;
        $scope.loginBackBtn = false;
        $state.go('Login', {notify: false})
      }
      if ($scope.password_Field_signup) {
        $scope.password_Field_signup = false;
        $scope.phone_Field_signup = true;
        $scope.signupClick();
        $scope.loginBackBtn = true;
        $scope.email_Field = false;
        $scope.social_login = true;
        $state.go('Create_Account', {step: 'phone'}, {notify: false})
      }
      if ($scope.Otp_code) {
        $scope.Otp_code = false;
        $scope.loginBackBtn = true;
        
        $scope.phone_Field_signup = false;
        $scope.password_Field_signup = true;
        $scope.social_login = false;
        $scope.loginBackBtn = true;

        $scope.fakeEmailDomain = false;
      }
      if ($rootScope.signupFormSelected && !$scope.phone_Field_signup) {
        $scope.social_login = true;
        $scope.password_Field_signup = false;
        $scope.email_Field = true;
        $scope.newUserEmail = false;
        $scope.newUserPhone = false;
        if($scope.signup) {
          $state.go('Create_Account', {step: 'email'}, {notify: false})
        } else {
          $state.go('Login', {notify: false})
        }
      }
    };
    $scope.displayPassword = function () {
      var show = document.getElementById("password");
      var eyeIcon = document.getElementById("passwordIcon");

      if (show.type === "password") {
        show.type = "text";
        eyeIcon.className = "fa fa-eye";
      } else {
        show.type = "password";
        eyeIcon.className = "fa fa-eye-slash";
      }
    };
    $scope.showPassword = function () {
      var show = document.getElementById("signupassword");
      var eyeIcon = document.getElementById("signuppasswordIcon");

      if (show.type === "password") {
        show.type = "text";
        eyeIcon.className = "fa fa-eye";
      } else {
        show.type = "password";
        eyeIcon.className = "fa fa-eye-slash";
      }
    };
    $scope.showConfirmPassword = function () {
      var show = document.getElementById("confirmPassword");
      var eyeIcon = document.getElementById("confirmpasswordIcon");

      if (show.type === "password") {
        show.type = "text";
        eyeIcon.className = "fa fa-eye";
      } else {
        show.type = "password";
        eyeIcon.className = "fa fa-eye-slash";
      }
    };

    $scope.confirmPassword = function () {
      var show = document.getElementById("confirmPassword");
      var eyeIcon = document.getElementById("confirmPassword");

      if (show.type === "password") {
        show.type = "text";
        eyeIcon.className = "fa fa-eye";
      } else {
        show.type = "password";
        eyeIcon.className = "fa fa-eye-slash";
      }
    };
    $scope.nextForm = function (field) {
      // $scope.email_Field = false;
      // $scope.password_Field = true;
// console.log('next form',field);
      if ($rootScope.signupFormSelected && field === "email") {
        $scope.oldFlowSignup = true;
        $scope.submitSignup($scope.loginForm, field);
      } else if (!$rootScope.signupFormSelected && (field === "email" || field === "phone")) {
        $scope.social_login = true;
        $scope.tempEmail = $scope.loginForm.email_phone;
        $scope.submitLogin($scope.loginForm.email_phone, field);
         mixpanel.track('login-email', {
            // 'Login email' : category.name,
          });
        // if(field === "phone"){
         
        // }
      } else {
        // console.log("NEXT FORM", field);
        if ($scope.loginForm.phone) {
          // $scope.submitSignup($scope.loginForm,field);

          $scope.submitSignup($scope.loginForm, field);
        }
      }
    };
    function isANumber(str){
      return !/\D/.test(str);
    }
    $scope.changetext = function () {
      $scope.newUserEmail = false;
      $scope.newUserPhone = false;
      $scope.errorMessage = '';
      document.getElementById('newUserEmail').style.height = '0px'
      document.getElementById('newUserPhone').style.height = '0px'
    }
    $scope.checkCredentials= function(data){
      var isnum = /^\d+$/.test(data);
        // console.log(data,"Data",isANumber(data),isnum);
      if(isANumber(data)){
        // console.log(isnum);
        if(data.length < 11){
          $scope.errorMessage = "Enter a valid number 033********"
        }else{
          $scope.submitLogin(data,'phone');
          mixpanel.track('Login-phone', {
            'Login email' : data,
          });
        }
      }else{
        $scope.submitLogin(data,'email');
        mixpanel.track('Login-email', {
          'Login email' : data,
        });
      }
    }

    $scope.forgetPasswordBtn = function () {
      $scope.errorMessage = "";
      $scope.login = false;
      $scope.forget_password = true;
      $state.go('Login', {notify: false});
      mixpanel.track('Forget-password', {
      });
    };

    $scope.skipPasswordBtn = function () {
      $scope.errorMessage = "";
      $scope.login = false;
      $scope.skip_password = true;
    };
    // today = yyyy + "-" + mm + "-" + dd;
    // $scope.currentDate = today;
    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    function obscureEmail(emailString) {
      var splitEmail = emailString.split("@");
      var domain = splitEmail[1];
      var name = splitEmail[0];
      // console.log(name.substring(0, 3).concat("*********@").concat(domain));
      return name.substring(0, 3).concat("*********@").concat(domain);
    }
    $scope.submitLogin = function (loginForm, field) {
      $scope.loader = true;
      // $scope.newUserEmail = false;
      // $scope.newUserPhone = false;
      $scope.errorMessage = "";
      var mail_format = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
      var browserId = $cookies.get("browserId");
      // console.log(browserId, "br",loginForm);
      if (field === "email") {
        // console.log(validateEmail(loginForm), "HERE");
        var validEmail = validateEmail(loginForm);
        if (validEmail) {
          $http
            .post("/api/v1/auth/validate-email-phone", {
              email_phone: loginForm,
          })
            .then(
              function (resp) {
                setTimeout(function () {
                  var loginPassword = document.getElementById('password');
                  // console.log(loginPassword, 'login pasword');
                  // loginPassword.focus();
                }, 600);
                // console.log(resp, "email response");
                if (resp.data.success) {
                  $state.go('Login', {notify: false})
                  $scope.loader = false;
                  $scope.userID = resp.data.user.id;
                  $scope.userEmail = resp.data.user.email;
                  $scope.userPhone = resp.data.user.phone;
                  $scope.userName = resp.data.user.name ? resp.data.user.name : null;
                  var hidden = obscureEmail($scope.userEmail);
                  $scope.userEmailHidden = hidden;
                  if ($scope.userPhone) {
                    $scope.userPhoneHidden =
                      "92******" + $scope.userPhone.substring(8, 12);
                    // console.log("user phone hidden", $scope.userPhoneHidden);
                  }

                  $scope.email_Field = false;
                  $scope.password_Field = true;
                  $scope.loginBackBtn = true;

                  if ($rootScope.signupFormSelected) {
                    $scope.social_login = false;
                    $scope.password_Field_signup = true;
                  }
                  $scope.login_button = true;
                }else if(!resp.data.success){
                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                  $scope.tempEmail = loginForm;
                  // $scope.userID = resp.data.user.id;
                  // $scope.userEmail = resp.data.user.email;
                  $scope.newUserEmail = true;
                  setTimeout(function(){
                    document.getElementById('newUserEmail').style.height = '32px'
                  }, 200)
                  
                  // $scope.email_Field = false;
                  // $scope.signup = true;
                  // $scope.phone_Field_signup = true;
                  
                  // $scope.loginBackBtn = true;

                  // $scope.signupClick();

                  // submitSignup()
                  // $scope.errorMessage = resp.data.message;

                } else{
                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                }
              },
              function errorCallback(response) {
                $scope.loader = false;
                if (resp.status === 500) {
                  $scope.errorMessage = "Network Error , Please Try Again !";
                }
                // console.log("error email", response);
              }
            );
        } else {
          // console.log("Enter a valid Email");
          $scope.errorMessage = "Enter a Valid Email";
          $scope.loader = false;
        }
      }
           if(field === "phone"){
              $http
                  .post("/api/v1/auth/validate-email-phone", {
                  email_phone: loginForm,
             })
               .then(
                function (resp) {
                // console.log(resp,"phone login resp");
                if(resp.data.success){
                  try {
                    $scope.loader = false;
                    $scope.userID = resp.data.user.id;
                    $scope.userEmail = resp.data.user.email;
                    $scope.userPhone = resp.data.user.phone;
                    $scope.userName = resp.data.user.name ? resp.data.user.name : null;
                    if($scope.userEmail) {
                      var hidden = obscureEmail($scope.userEmail);
                      $scope.userEmailHidden = hidden;
                    }
                    if ($scope.userPhone) {
                      $scope.userPhoneHidden =
                        "****" + $scope.userPhone.substring(8, 12);
                      // console.log("user phone hidden", $scope.userPhoneHidden);
                    }

                    $scope.email_Field = false;
                    $scope.password_Field = true;
                    $scope.loginBackBtn = true;

                    if ($rootScope.signupFormSelected) {
                      $scope.social_login = false;
                      $scope.password_Field_signup = true;
                    }
                    $scope.login_button = true;
                  } catch (error) {
                    console.log('error')
                    console.log(error)
                  }
                  
                }else if(!resp.data.success){
                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                  $scope.newUserPhone = true;
                  setTimeout(function(){
                    document.getElementById('newUserPhone').style.height = '32px'
                  }, 200)
                }
                     }
                   )
          }
      if (field === "password") {
        if ((loginForm || []).length > 7) {
          // console.log(" 8", $scope.userID);
          $http
            .post("/api/v1/auth/validate-password", {
              password: loginForm,
              user_id: $scope.userID,
            })
            .then(
              function (resp) {
                // console.log("resaa", resp);
                $scope.loader = false;
                if (!resp.data.success) {
                  $scope.errorMessage = "Password is wrong";
                }
                if (
                  resp.data.user.user_type === "student" &&
                  resp.data.user.disabled === false
                ) {
                  $scope.loading = false;
                  $scope.loginpopUp = false;
                  $scope.text = "Logged in as " + resp.data.user.full_name;
                  $scope.loading = false;
                  CustomStorageService.SignInService(
                    false,
                    true,
                    false,
                    false,
                    resp.data.token,
                    resp.data.user
                  );
                  if ($rootScope.platform_reactApp) {
                    console.log("userToken" + resp.data.token);
                    console.log("userID" + resp.data.user.id);
                    console.log("urlToRoute"+$location.$$url);

                    if(CustomStorageService.getAppFreeAccessPopup()){
                      console.log("firstLogin");
                    }
                    console.log("loggedIn");
                  }
                  const isPrivacy = resp.data.isPrivacy ? "true" : "false";
                  CustomStorageService.setTermStatus(isPrivacy);
                  $rootScope.userNotLoggedIn = false;
                  if($rootScope.beforJoinusPath) {
                    $state.go($rootScope.beforJoinusPath.current.name, $rootScope.beforJoinusPath.params)
                  }
                  setTimeout(function() {
                    window.location = window.location.href.split("?")[0];
                  }, 500)
                  // swal(
                  //   {
                  //     title: "Log In Successful!",
                  //     text: $scope.text,
                  //     type: "success",
                  //     timer: 2000,
                  //     showConfirmButton: false,
                  //   },
                  //   function () {
                  //     swal.close();
       
                  //   }
                  // );
                } else if (
                  resp.data.user.user_type === "student" &&
                  resp.data.user.disabled === true
                ) {
                  $scope.loading = false;
                  $scope.loginpopUp = false;
                  swal({
                    title: "Error",
                    text: "Account is temporarily disabled",
                    type: "error",
                  });
                } else {
                  // console.log("respaa", resp);
                  $scope.loginpopUp = false;
                  $scope.loading = false;
                  swal(
                    {
                      title: "Error",
                      text: "Not Authorized",
                      type: "error",
                    },
                    function () {
                      $scope.loginpopUp = true;
                      if (!$scope.$$phase) $scope.$apply();
                    }
                  );
                }
                // console.log(resp, "resp password");
              },
              function errorCallback(response) {
                $scope.loader = false;
                // console.log("error", response);
                if (response.data.code == "E_USER_NOT_CONFIRMED") {
                  swal(
                    {
                      title: "Unconfirmed Account",
                      text: response.data.message,
                      type: "info",
                      confirmButtonText: "Resend Mail",
                      showCancelButton: true,
                    },
                    function (confirm) {
                      if (confirm) {
                        var data = { email: $scope.userEmail };
                        $http
                          .post("api/v1/users/requestConfirmationMail", data)
                          .then(function (data) {
                            if (data.data.success) {
                              swal({
                                title: "Confirmation instruction sent",
                                text: "Please activate your account by clicking on the link sent to your provided email address",
                                type: "info",
                              });
                            }
                          });
                      }
                    }
                  );
                } else if (response.data.code == "LIMIT_REACHED") {
                  $scope.$emit("userLoggedInAfterVerification", response.data);
                } else if (response.data.code == "ACCESS_BLOCKED") {
                  $scope.$emit("userLoggedInBlockedUnconfirmed", response.data);
                } else if (response.data.error_code == "Suspicious_User") {
                  // $scope.$emit("userLoggedInBlockedUnconfirmed", response.data);
                  $scope.$emit("suspiciousUser", {user_id: $scope.userID, isPending: response.data.isPending, isRejected: response.data.isRejected});
                  $scope.errorMessage = "User looks Suspicious Please contact the admin.";
                } else {
                  console.log("error", response);
                  $scope.errorMessage = "Network Error , try again.";
                  // swal({
                  //   title: "Error",
                  //   text: response.data.message,
                  //   type: "error",
                  // });
                }
              }
            );
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Password Less than 8 characters";
          // console.log("LESS THAN 8");
        }
      }

    };
    

    var checkEmailDomain = function() {
      var isTrustedDomain = false;
      allowedDomains.forEach(function(domain) {
        if($scope.tempEmail.toLowerCase().includes(domain.toLowerCase())) {
          isTrustedDomain = true;
        }
      })
      return isTrustedDomain;
    }

    $scope.submitSignup = function (loginForm, field,confPassword) {

 
      $scope.loader = true;
      $scope.errorMessage = "";
      var mail_format = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
      var browserId = $cookies.get("browserId");
      // console.log(browserId, "br", loginForm, field);
      if (field === "email") {
        // console.log(validateEmail(loginForm.email_phone), "HERE", loginForm);
        var validEmail = validateEmail(loginForm.email_phone);
        if (validEmail) {
          $http
            .post("api/v1/temp-user/save-email-phone", {
              email: loginForm.email_phone,
            })
            .then(
              function (resp) {
                if (resp.data.success) {
                  setTimeout(function () {
                    var singupNumber = document.getElementById('number');
                    // singupNumber.focus();
                  }, 600);
                  // console.log("RESP SIGNUP EMAIl", resp);
                  $scope.loader = false;
          
                  $scope.signup = true;
                  $scope.tempEmail = resp.data.user.email;
                  $scope.userID = resp.data.user.id;
                  $scope.userEmail = resp.data.user.email;

                  $scope.email_Field = false;
                  $scope.phone_Field_signup = true;
                  $scope.loginBackBtn = true;
                  $state.go('Create_Account', {step: 'phone'}, {notify: false})
                  $scope.signupClick();
                  // if ($rootScope.signupFormSelected) {
                  //   // $scope.social_login = false;
                  //   // $scope.password_Field_signup = true;
                  //   $scope.phone_Field_signup = false;
                  //   $scope.password_Field_signup = true;
                  //   $scope.social_login = false;
                  //   $scope.loginBackBtn = true;
                  // }
                  // $scope.login_button = true;
                } else {
                  // console.log("RESP SIGNUP ELSE", resp);

                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                }

                // console.log(resp, "email response", $scope.userID);
              },
              function errorCallback(response) {
                // console.log("error call back signup", response);

                $scope.loader = false;
                if (response.status == 404) {
                  $scope.errorMessage = "Server Error";
                } else {
                  if (response.data.message) {
                    $scope.errorMessage = response.data.message;
                  } else {
                    $scope.errorMessage = "Network Error";
                  }
                }
              }
            );
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Please Enter a Valid Email";
          // console.log("in valid email");
        }
      }
      if (field === "phone") {
        var selectedCountry = $("#country").countrySelect("getSelectedCountryData");
        if(!selectedCountry || !selectedCountry.phone_code || selectedCountry.phone_code == 'undefined'){
          selectedCountry = {
            phone_code: "92",
            iso2: "pk",
            name: "Pakistan"
          }
        }
        loginForm.countryCode = selectedCountry.phone_code;
        // console.log(validateEmail(loginForm.email_phone), "HERE", loginForm);
        // var validEmail = validateEmail(loginForm.email_phone);
        // if (validEmail) {
          $http
            .post("api/v1/temp-user/save-email-phone", {
              phone: loginForm.countryCode + loginForm.phone,
              contact: loginForm.phone,
              countryCode: loginForm.countryCode,
              uid: $scope.userID,
           //email to be entered.
            })
            .then(
              function (resp) {
                if (resp.data.success) {
                  // console.log("RESP SIGNUP", resp);


        
                  $scope.loader = false;

                  $scope.userID = resp.data.user.id;
                  $scope.userEmail = resp.data.user.email;
                  $scope.userPhone = resp.data.user.phone;
                  $scope.email_Field = false;
                  $scope.userPhoneHidden =
                        "****" + resp.data.user.phone.substring(8, 12);
                  // $scope.password_Field = true;
       

                  // if ($rootScope.signupFormSelected) {
                    // $scope.social_login = false;
                    // $scope.password_Field_signup = true;
                    $scope.phone_Field_signup = false;
                    $scope.password_Field_signup = true;
                    $scope.social_login = false;
                    $scope.loginBackBtn = true;
                    $state.go('Create_Account', {step: 'password'}, {notify: false})

                    setTimeout(function () {
                      var singupPassword = document.getElementById('signupassword');
                      // console.log(singupPassword);
                      // singupPassword.focus();
                    }, 600);
                  // }
                  // $scope.login_button = true;
                } else {
                  // console.log("RESP SIGNUP ELSE", resp);

                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                }

                // console.log(resp, "email response", $scope.userID);
              },
              function errorCallback(response) {
                // console.log("error call back signup", response);

                $scope.loader = false;
                if (response.status == 404) {
                  $scope.errorMessage = "Server Error";
                } else {
                  if (response.data.message) {
                    $scope.errorMessage = response.data.message;
                  } else {
                    $scope.errorMessage = "Network Error";
                  }
                }
              }
            );
        //  else {
        //   $scope.loader = false;
        //   $scope.errorMessage = "Please Enter a Valid Email";
        //   console.log("in valid email");
        // }
      }

      if (field === "password") {

        if (loginForm.password === loginForm.confirm_password) {
          if (loginForm.password.length > 7) {
            if(!checkEmailDomain()) {
              $scope.fakeEmailDomain = true;
              $scope.sendOtp('phone', false);
              $scope.loader = false;
            } else {
              createUserWithPassword();
            }
            
            
          } else {
            $scope.loader = false;
            $scope.errorMessage =
              "Password length must be atleast 8 characters";
          }
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Passwords does not match!";
        }
      }
    };

    var createUserWithPassword = function() {
      $http
        .post("api/v1/temp-user/update-password-signup", {
          password: $scope.loginForm.password,
          user_id: $scope.userID,
        })
        .then(
          function (resp) {
            // if (resp.data.success) {
            $scope.loader = false;

            // console.log(resp, "resp password");
            if (resp.data.error) {
              $scope.errorMessage = resp.data.msg;
              // swal({
              //   title: "Error",
              //   text: resp.data.msg,
              //   type: "error",
              // });
            } else {
              CustomStorageService.SignInService(
                false,
                true,
                false,
                false,
                resp.data.token,
                resp.data.user
              );
              $rootScope.userNotLoggedIn = false;
              if ($rootScope.platform_reactApp) {
                // console.log("userToken" + resp.data.token);
                // console.log("userID" + resp.data.user.id);
                console.log("popup-open");
                var compProf = true;
                window.localStorage.setItem("profileCompleted",compProf);
                // $scope.goToState("Complete-Profile");
                $state.go("Complete-Profile",{name: 'joining'});
              }else{
                // $scope.goToState("Complete-Profile");
                $state.go("Complete-Profile",{name: 'joining'});
              }

              // swal(
              //   {
              //     title: "Success",
              //     text: "Account Created Successfully",
              //     type: "success",
              //     timer: 2000,
              //   },
              //   function () {
              //     swal.close();
        
              //   }
              // );
            }
  
            // }
            // else {
            //   $scope.loader = false;
            //   $scope.errorMessage = "Network Error , Please Try Again";
            //   console.log(resp, "resp password else");
            // }
          },
          function errorCallback(response) {
            // console.log("signup password", response);

            $scope.loader = false;
            if(response.data && response.data.data && response.data.data.error_code === "Suspicious_User") {
              $scope.$emit("suspiciousUser", {user_id: response.data.data.user_id, isPending: response.data.data.isPending, isRejected: response.data.data.isRejected});
            } else if (response.status == 404) {
              $scope.errorMessage = "Server Error";
            } else {
              $scope.errorMessage = "Server Error";
            }
          }
        );
    }

    $scope.sendInstructionBtn = function (email) {
      $scope.loader = true;
      $scope.errorMessage = "";
      if (!email || !email.includes("@")) {
        $scope.errorMessage = "Enter a Valid Email Address";
        return;
      } else {
        $scope.resetPassword(email).then(function (resp) {
          $scope.loader = true;
          // console.log("Password Reset", resp);
          if (resp) {
            // $scope.password_Field = true;
            // $scope.login = true;
            // $scope.forget_password = false;
            // $scope.noti_reset = true;
            // $scope.hideNotification();
            // $state.go('Landing',{},{reload:true});
          } else {
            console.log("ERROR IN RESET");
          }
        });
      }
    };

    $scope.resetPassword = function (form) {
      $scope.requestSent = true;

      var data = {
        email: form,
        origin_url: location.protocol + "//" + location.host,
      };

      $http
        .post("/api/v1/users/requestPasswordReset", data)
        .then(function (resp) {
          if (!resp.data.success) {
            $scope.loader = false;
            $scope.requestSent = false;
            $scope.buttonColor = "background-color: #9be0c6";
            $scope.errorMessage = resp.data.msg;
            // swal("Error", resp.data.msg, "error");
          } else {
            toaster.success({
              title: "Email Sent",
              body: "Please check your email to Reset Password",
            });
            $scope.loader = false;
            $scope.requestSent = false;
            $scope.password_Field = true;
            $scope.login = true;
            $scope.forget_password = false;
            // $scope.noti_reset = true;
            $scope.hideNotification();

            $state.go("Landing", {});
            // swal(
            //   {
            //     title: "Success",
            //     text: "A link to reset your password has been emailed to you.",
            //     type: "success",
            //     timer: 2000,
            //     showConfirmButton: false,
            //   },
            //   function () {
            //     swal.close();

            //   }
            // );
          }
        })
        .catch(function (resp) {
          $scope.loader = false;
          $scope.requestSent = false;
          $scope.buttonColor = "background-color: #9be0c6";
          $scope.errorMessage = "Entered Email does not exist!";

        });
    };

    $scope.hideNotification = function () {
      setTimeout(function () {
        $scope.noti_reset = false;
              $scope.$apply();
        // var noti_element = document.getElementById("hideNotification");
        // noti_element.style.display = "none";
        // $scope.noti_reset = false;
        // console.log($scope.noti_reset, '-------------');
      }, 3000);
    };

    $scope.enterAsGuest = function () {
      var browserId;
      var guestIDCHECK = window.localStorage.getItem(
        "guestID"
      );


      if($rootScope.platform_reactApp){
        console.log(guestID +"GUEST ID CHECK");
        browserId = guestIDCHECK;
      } else{
      browserId = $cookies.get("browserId");

      if (!browserId) {
      browserId =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
       $cookies.put("browserId", browserId);
      }

}
      var data = {
        browser_id: browserId,
        origin: 'LEGACY',
        dimensions: dimensions,
      }
      // console.log("Browser ID", browserId);
      $http.post("/api/v1/auth/signup-as-guest", data).then(function (resp) {
        if (resp.data.user) {
          
          $scope.loading = false;
          $scope.loginpopUp = false;
          $scope.text = "Logged in as " + resp.data.user.full_name;
          $scope.loading = false;

          CustomStorageService.SignInService(
            false,
            true,
            false,
            false,
            resp.data.token,
            resp.data.user
          );

          const isPrivacy = resp.data.isPrivacy ? "true" : "false";
          CustomStorageService.setTermStatus(isPrivacy);
          $rootScope.userNotLoggedIn = false;
          if ($rootScope.platform_reactApp) {
            loginResponse = resp;
            waitForBridge(true);
          } else {
            $scope.$emit("userLoggedIn");
          }
          // swal(
          //   {
          //     title: "Log In Successful!",
          //     text: $scope.text,
          //     type: "success",
          //     timer: 2000,
          //     showConfirmButton: false,
          //   },
          //   function () {
              
      
              
          //   }
          // );
        }
      });
    };

    $scope.signupAsGuest = function (loginForm) {
      $scope.loader = true;
      $scope.errorMessage = "";
      var mail_format = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
      var browserId = $cookies.get("browserId");
      // console.log(browserId, "br", loginForm, field);
      if (field === "email") {
        // console.log(validateEmail(loginForm.email_phone), "HERE", loginForm);
        var validEmail = validateEmail(loginForm.email_phone);
        if (validEmail) {
          $http
            .post("api/v1/temp-user/save-email-phone", {
              email: loginForm.email_phone,
              phone: loginForm.phone,
            })
            .then(
              function (resp) {
                if (resp.data.success) {
                  // console.log("RESP SIGNUP", resp);
                  $scope.loader = false;

                  // $scope.userID = resp.config.data.user_id;
                  $scope.userEmail = resp.config.data.email;
                  $scope.userPhone = resp.config.data.phone;
                  $scope.email_Field = false;
                  $scope.password_Field = true;

                  if ($rootScope.signupFormSelected) {
                    $scope.social_login = false;
                    $scope.password_Field_signup = true;
                  }
                  // $scope.goToState("Complete-Profile");
                  $state.go("Complete-Profile",{name: 'joining'});
                  
                  // $state.go("Complete-Profile", {}, { reload: true });
                  // $scope.login_button = true;
                } else {
                  // console.log("RESP SIGNUP ELSE", resp);

                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                }

              
              },
              function errorCallback(response) {
                // console.log("error call back signup", response);

                $scope.loader = false;

                $scope.errorMessage = "Network Error";
              }
            );
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Please Enter a Valid Email";
       
        }
      }

      if (field === "password") {
        // console.log(loginForm.password === loginForm.confirm_password, "conf");

        if (loginForm.password === loginForm.confirm_password) {
          if (loginForm.password.length > 7) {
            // console.log(" 8", $scope.userID);
            $http
              .post("api/v1/temp-user/update-password-signup", {
                password: $scope.loginForm.password,
                email: $scope.loginForm.email_phone,
                user_id: $scope.userID,
              })
              .then(function (resp) {
                // if (resp.data.success) {
                $scope.loader = false;

                // console.log(resp, "resp password");
                if (resp.data.error) {
                  $scope.errorMessage = resp.data.msg;
   
                } else {
                  // $scope.$emit('userSignupVerification', resp.data);

                  $scope.$emit("userLoggedIn");
                  var oldToken =
                    CustomStorageService.getAuthTokenStorageData();
                  CustomStorageService.SignInService(
                    false,
                    true,
                    false,
                    false,
                    oldToken,
                    resp.data.user
                  );
                  if ($rootScope.platform_reactApp) {
                    console.log("userToken" + resp.data.token);
                    console.log("userID" + resp.data.user.id);
                    console.log("urlToRoute"+$location.$$url);

                    if(CustomStorageService.getAppFreeAccessPopup()){
                      console.log("firstLogin");
                    }
                    console.log("loggedIn");
                  }
                  const isPrivacy = resp.data.isPrivacy ? "true" : "false";
                  CustomStorageService.setTermStatus(isPrivacy);
                  $rootScope.userNotLoggedIn = false;
                  location.reload();
                  // swal(
                  //   {
                  //     title: "Account Created Successfully",
                  //     text: "Please Verify Your Account to Enjoy Full Access.",
                  //     type: "success",
                  //     timer: 2000,
                  //   },
                  //   function () {
                  //     swal.close();
          
                  //   }
                  // );
                }

                // }
                // else {
                //   $scope.loader = false;
                //   $scope.errorMessage = "Network Error , Please Try Again";
                //   console.log(resp, "resp password else");
                // }
              });
          } else {
            // console.log("LESS THAN 8");
            $scope.loader = false;
            $scope.errorMessage =
              "Password length must be atleast 8 characters";
          }
        } else {
          $scope.loader = false;
          $scope.errorMessage = "Passwords does not match!";
        }
      }
    };

    $scope.sendOtpBtn = function () {
      $scope.skip_password = false;
      $scope.Otp_code = true;
      addPasteHandler();
    };

    $scope.sendOtp = function (type, resend) {
      if (type === "phone" || type === "whatsapp") {
        if(!resend) {
          type = "whatsapp";
        }
        $scope.skip_password = false;
        $scope.Otp_code = true;
        $scope.phoneSelected = true;
        $scope.password_Field_signup = false;
      } else {
        $scope.skip_password = false;
        $scope.Otp_code = true;
        $scope.phoneSelected = false;
        $scope.password_Field_signup = false;
      }
      addPasteHandler();
      var data = {
        type: type,
      };

      if($scope.fakeEmailDomain) {
        data.temp_user_id = $scope.userID;
      } else {
        data.user_id = $scope.userID;
      }

      $http.post("/api/v1/auth/send-otp", data).then(
        function (resp) {
          // console.log("OTP", resp);
          if (resend != null || resend.length != 0) {
            $scope.noti_reset = true;
            setTimeout(function () {
              $scope.noti_reset = false;
              $scope.$apply();
            }, 3000);
          }
        },
        function errorCallback(response) {
          // console.log("response", response);

          swal(
            {
              title: "Try Again",
              text: "Something went wrong",
              type: "error",
            },
            function () {
              swal.close();
            }
          );
          // console.log(response)
        }
      );
    };
    $scope.sendOtpWrong = function (type, resend) {
      if (type === "phone") {
        $scope.skip_password = false;
        $scope.wrong_Otp_code = true;
        $scope.phoneSelected = true;
      } else {
        $scope.skip_password = false;
        $scope.wrong_Otp_code = true;
        $scope.phoneSelected = false;
      }
      addPasteHandler();
      var data = {
        user_id: $scope.userID,
        type: type,
      };

      $http.post("/api/v1/auth/send-otp", data).then(
        function (resp) {
          // console.log("OTP", resp);
          if (resend != null || resend.length != 0) {
            $scope.noti_reset = true;
            setTimeout(function () {
              $scope.noti_reset = false;
              $scope.$apply();
            }, 3000);
          }
        },
        function errorCallback(response) {
          // console.log("response", response);
          swal(
            {
              title: "Try Again",
              text: "Something went wrong",
              type: "error",
            },
            function () {
              swal.close();
            }
          );
          // console.log(response)
        }
      );
    };
    var addPasteHandler = function() {
      setTimeout(function() {
        angular.element('#digit-1')[0].addEventListener('paste', function(event) {
          var clipboardData = event.clipboardData || window.clipboardData;
          var pastedData = clipboardData.getData('Text');
          var data = pastedData.split("");
          event.target.value = data[0];
          angular.element('#digit-2')[0].value = data[1];
          angular.element('#digit-3')[0].value = data[2];
          angular.element('#digit-4')[0].value = data[3];
          angular.element('#digit-5')[0].value = data[4];
          angular.element('#digit-6')[0].value = data[5];
          $scope.digit1 = data[0];
          $scope.digit2 = data[1];
          $scope.digit3 = data[2];
          $scope.digit4 = data[3];
          $scope.digit5 = data[4];
          $scope.digit6 = data[5];
          $scope.$apply();
          angular.element('#digit-6')[0].focus();
        });
      }, 500)
    }
    $scope.onPasteOTP = function (event, num) {
      setTimeout(function () {
        var data = event.target.value.split("");
        event.target.value = data[0];
        angular.element("#digit-2")[0].value = data[1];
        angular.element("#digit-3")[0].value = data[2];
        angular.element("#digit-4")[0].value = data[3];
        angular.element("#digit-5")[0].value = data[4];
        angular.element("#digit-6")[0].value = data[5];
        $scope.digit1 = data[0];
        $scope.digit2 = data[1];
        $scope.digit3 = data[2];
        $scope.digit4 = data[3];
        $scope.digit5 = data[4];
        $scope.digit6 = data[5];
        $scope.$apply();
        angular.element("#digit-6")[0].focus();
        $scope.sendOTPConfirmation(
          $scope.digit1,
          $scope.digit2,
          $scope.digit3,
          $scope.digit4,
          $scope.digit5,
          $scope.digit6
        );
      }, 100);
    };
    $scope.keytab = function (event, model) {
      if (
        event.key === "Backspace" ||
        (event.keyCode === 229 && !event.target.value)
      ) {
        event.target.previousElementSibling.focus();
        if (model === 1) {
          $scope.digit1 = "";
        } else if (model === 2) {
          $scope.digit2 = "";
        } else if (model === 3) {
          $scope.digit3 = "";
        } else if (model === 4) {
          $scope.digit4 = "";
        } else if (model === 5) {
          $scope.digit5 = "";
        } else if (model === 6) {
          $scope.digit6 = "";
        }
      } else {
        // if (event.target.nextElementSibling !== null) {

        if($rootScope.platform_reactApp){
          setTimeout(function() {
            if(event.target.value){
              event.target.nextElementSibling.focus()
            }
          }, 200)
        }else{
          if(event.target.value){
            event.target.nextElementSibling.focus()
          }

        }

        // }
      }
    },
      $scope.sendOTPConfirmation = function (d1, d2, d3, d4, d5, d6) {
        // console.log(d1, d2, d3, d4, d5, d6);
        $scope.loader = true;
        var otp_code = d1 + d2 + d3 + d4 + d5 + d6;
        // console.log("OTP", otp_code);

        var otp = otp;

        // console.log("OTP",otp);
        const formData = {
          code: otp_code,
          session: $scope.selectedSession ? $scope.selectedSession.session : "",
          type: $scope.otpVerification,
          removeAllSession: $scope.removeAllSession,
          origin: "LEGACY",
        otp_type: $scope.phoneSelected ? "phone" : "email",
        };

        if($scope.fakeEmailDomain) {
          formData.temp_user_id = $scope.userID;
          formData.userNotCreate = true;
        } else {
          formData.user_id = $scope.userID;
        }

        $http.post("/api/v1/auth/validate-otp", formData).then(
          function (resp) {
            if (resp.data.success && resp.data.token) {
              
                $scope.loader = false;

                $scope.enterOTP = false;
                $scope.OTP = false;
                CustomStorageService.SignInService(
                  false,
                  true,
                  false,
                  false,
                  resp.data.token,
                  resp.data.user
                );
                if ($rootScope.platform_reactApp) {
                  console.log("userToken" + resp.data.token);
                  console.log("userID" + resp.data.user.id);
                  console.log("urlToRoute"+$location.$$url);

                  if(CustomStorageService.getAppFreeAccessPopup()){
                    console.log("firstLogin");
                  }
                  console.log("loggedIn");
                }
                const isPrivacy = resp.data.isPrivacy ? "true" : "false";
                CustomStorageService.setTermStatus(isPrivacy);
                $rootScope.userNotLoggedIn = false;
                if ($state.current.name == "forgot-password") {
                  $state.go("Landing", {}, { reload: true });
                } else {
                  // location.reload();
                  $state.go("Landing", {}, { reload: true });
                }
                // swal(
                //   {
                //     title: "OTP Verified!",
                //     type: "success",
                //     confirmButtonText: "Ok",
                //     timer: 2000,
                //     showConfirmButton: false,
                //   },
                //   function () {
                //     swal.close();
    
                //   }
                // );
              
            } else if (
              resp.data.success &&
              CustomStorageService.getAuthTokenStorageData()
            ) {
              $scope.enterOTP = false;
              $scope.OTP = false;
              $scope.loader = false;

              // swal(
              //   {
              //     title: "OTP Verified!",
              //     type: "success",
              //     confirmButtonText: "Ok",
              //     timer: 2000,
              //     showConfirmButton: false,
              //   },
              //   function () {
    
              //   }
              // );

              CustomStorageService.SignInService(
                false,
                true,
                false,
                false,
                CustomStorageService.getAuthTokenStorageData(),
                resp.data.user
              );
              location.reload();
            } else if(resp.data.success) {
                createUserWithPassword();
            } else {
              $scope.loader = false;
              console.log(resp,"resp");
              location.reload();

              
              // swal(
              //   {
              //     title: "OTP Verified!",
              //     type: "success",
              //     confirmButtonText: "Ok",
              //     timer: 2000,
              //     showConfirmButton: false,
              //   },
              //   function () {
         

              //     swal.close();
              //   }
              // );
            }
          },
          function errorCallback(response) {
            if(response.data && !response.data.success && response.data.data && response.data.data.error_code === "Suspicious_User") {
              $scope.$emit("suspiciousUser", {user_id: $scope.userID, isPending: response.data.data.isPending, isRejected: response.data.data.isRejected});
            } else {
              $scope.otpErroor = "Invalid OTP";
              // $scope.errorMessage = "Invalid OTP";
              $scope.loader = false;
              // $scope.digit1 = "";
              // $scope.digit2 = "";
              // $scope.digit3 = "";
              // $scope.digit4 = "";
              // $scope.digit5 = "";
              // $scope.digit6 = "";
  
              $scope.wrong_Otp_code = true;
              $scope.Otp_code = false;
              addPasteHandler()
              $scope.noti_reset = false;
              var noti_element = document.getElementById("hideNotification");
              noti_element.style.display = "block";
            }
            
          }
        );
      };

    $scope.wrongOtpBtn = function () {
      $scope.wrong_Otp_code = true;
      $scope.Otp_code = false;
      addPasteHandler();
    };

    $scope.closeForm = function () {
      
      $scope.loginpopUp = false;
      console.log('close-login-form');
      $scope.$emit("closeForm");
    };

    $scope.handleEvent = function async(message) {
      if ($rootScope.platform_reactApp) {
        try {
          if (message.data.message.includes("googleLogin")) {
            var token = message.data.message.split("googleLogin");
            console.log(token);
            console.log("Processing Google");
            $scope.onGoogleSuccess(token[1]);
          } else if (message.data.message.includes("guestID")) {
            var token = message.data.message.split("guestID");
            guestID = token[1];
            window.localStorage.setItem(
              "guestID",
              guestID
            );
            console.log('receive-guest-id');
            console.log(token);
          }else if (message.data.message.includes("googleFailed")) {
            $scope.OnGoogleAuthFail("Google Authentication Failed,Try Again");
          } else {
            console.log("Receiving Objects From Native");
            console.log(message.data.message);
            // var loginObject = [...message.data.message];
            // $scope.appObject = [...message.data.message];
            if ($scope.objectFromReact == "google") {
              console.log("Processing Google");
              onGoogleSuccess(message.data.message[0]);
            } else if ($scope.objectFromReact == "facebook") {
              console.log("Processing Facebook");
              $scope.facebookAuthReact(message.data.message[0]);
            } else if ($scope.objectFromReact == "apple") {
              console.log("Processing Apple");
              appleSigninSuccess(message.data.message[0]);
            }
            console.log($scope.objectFromReact);

            $scope.objectFromReact = "";
            console.log($scope.objectFromReact);

            console.log(JSON.stringify(loginObject));
            console.log($scope.appObject);
          }
        } catch (err) {
          console.log("ERROR in Catching Events");
          console.log(JSON.stringify(err));
        }
      }
    };

    var listener = document.addEventListener("message", $scope.handleEvent); ///DONOT REMOVE $scope
    if ($rootScope.platform_reactApp) {
      console.log(listener); ///DONOT REMOVE $scope CONSOLE
      $scope.handleEvent(listener); ///DONOT REMOVE THIS
    }
  }
  new WOW().init();
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("leadGenController", MainController);

  function MainController(
    // courseDetailService,
    // $rootScope,
    $scope,
    $http,
    // CustomStorageService,
    // $state,
    // $sails,
    // $cookies,
    env,
    Upload
  ) {
    $scope.postingLead = false;
    $scope.uploadingCsv = false;
    $scope.csv;
    $scope.csvStatusShow = false;
    $scope.csvStatus = [];
    $scope.existingTags = [];
    $scope.searchedTags = [];
    $scope.markets = [];
    $scope.leadGenSuccessful = false;
    $scope.searchingTags = false;
    $scope.agents = [];
    $scope.searchingAgents = false;
    $scope.leadGen = {
      comment: "",
      name: "",
      email: "",
      phone: "",
      market: "",
      revenue: 0,
      tags: [],
      agent: "",
      probability: 0,
    };
    $scope.errors = {};
    $scope.tagsdata = "";

    var uploadBtnText = document.getElementById("uploadBtnText");
    var actualBtn = document.getElementById("actual-btn");

    var fileChosen = document.getElementById("file-chosen");

    // actualBtn.addEventListener("change", function () {
    //   fileChosen.textContent = this.files[0].name;
    // });
    function validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
    function validatePhone(inputtxt) {
      var phoneno = /^\+?([0-9]{12})/;
      return (
        inputtxt.match(phoneno) ||
        (inputtxt.startsWith("0") && inputtxt.length == 11)
      );
    }
    function getAllTags() {
      $http.get(env.backendService + "/lmsservice/v1/odoo/get-tags").then(
        function (response) {
          $scope.existingTags = response.data.tags;
        },
        function (error) {}
      );
    }
    function getAllMakets() {
      $http
        .get(env.backendService + "/lmsservice/v1/odoo/get-odoo-market")
        .then(
          function (response) {
            if (response.data.success) {
              $scope.markets = response.data.markets;
            }
            // $scope.existingTags = response.data.tags;
          },
          function (error) {}
        );
    }
    $scope.leadGenSuccessfulBtn = function () {
      $scope.errors = {};
      if (!$scope.leadGen.name) {
        $scope.errors.name = "Name is required";
      }
      if ($scope.leadGen.email && !validateEmail($scope.leadGen.email)) {
        $scope.errors.email = "Email is invalid";
      }
      if (!validatePhone($scope.leadGen.phone)) {
        $scope.errors.phone =
          "Phone is invalid, phone number should match +92XXXXXXXXXX or 03XXXXXXXXX";
      }
      if (!$scope.leadGen.phone) {
        $scope.errors.phone = "Phone is required";
      }
      if (!$scope.leadGen.market) {
        $scope.errors.market = "Market is required";
      }

      if (
        $scope.leadGen.probability !== 0 &&
        (isNaN(Number($scope.leadGen.probability)) ||
          $scope.leadGen.probability < 0 ||
          $scope.leadGen.probability > 100)
      ) {
        $scope.errors.probability =
          "Probability should be valid Number ranging between 0 and 100";
      }
      if (Object.keys($scope.errors).length) {
        return false;
      }

      $scope.postingLead = true;
      $http
        .post(
          env.backendService + "/lmsservice/v1/odoo/create-lead",
          $scope.leadGen
        )
        .then(
          function (response) {
            // $scope.existingTags = response.data.tags;
            if (response.data.success) {
              alert("Lead Posted Successfully");
              $scope.postingLead = false;
              $scope.leadGen = {
                comment: "",
                name: "",
                email: "",
                phone: "",
                market: "",
                revenue: 0,
                tags: [],
              };
            }
          },
          function (error) {
            $scope.postingLead = false;
            var message =
              "some error occured while creating lead please try again later";
            if (error.data.message) {
              message = error.data.message;
            }
            alert(message);
          }
        );

      // if()
    };
    $scope.closeCsvPopup = function () {
      $scope.csvStatusShow = false;
    };
    $scope.uploadCsv = function (csv) {
      $scope.errors = {};
      if (!csv) {
        $scope.errors.csv = "Please choose a csv file";
      }
      if ($scope.errors.length) {
        return false;
      }
      var formData = new FormData();
      formData.append("file", csv);
      $scope.uploadingCsv = true;
      Upload.upload({
        url: env.backendService + "/lmsservice/v1/odoo/create-leads-from-csv",
        file: csv,
        method: "POST",
      }).then(
        function (response) {
          $scope.uploadingCsv = false;
          $scope.csv = null;

          if (response.data.errorList.length) {
            response.data.errorList.forEach(function (error) {
              response.data.data[error.recordNumber - 1].error = true;
              response.data.data[error.recordNumber - 1].errorMsg = error.error;
            });
          }
          $scope.csvStatusShow = true;
          $scope.csvStatus = response.data.data;
        },
        function (error) {
          $scope.uploadingCsv = false;
          $scope.csv = null;
          var message =
            "some error occured while creating lead please try again later";
          if (error.data.message) {
            message = error.data.message;
          }
          alert(message);
        }
      );
    };
    $scope.findTags = function (tag) {
      $scope.searchedTags = [];
      var search = $scope.existingTags.filter(function (t) {
        return t.name.toLowerCase().includes(tag.toLowerCase());
      });
      if (search.length > 5) {
        $scope.searchedTags = search.slice(0, 5);
      } else {
        $scope.searchedTags = search;
      }
    };
    $scope.getAgents = function (market) {
      $scope.agents = [];
      $scope.searchingAgents = true;
      $http
        .get(
          env.backendService + "/lmsservice/v1/odoo/get-odoo-agents/" + market
        )
        .then(
          function (response) {
            $scope.searchingAgents = false;
            if (response.data.success) {
              $scope.agents = response.data.agents;
              if (
                response.data.expectedRevenue &&
                response.data.expectedRevenue.expected_revenue
              ) {
                $scope.leadGen.revenue =
                  response.data.expectedRevenue.expected_revenue;
              }
            }
          },
          function (error) {
            $scope.searchingAgents = false;
            $scope.postingLead = false;
            var message =
              "some error occured while fetching agents please try again later";
            if (error.data.message) {
              message = error.data.message;
            }
            alert(message);
          }
        );
    };
    $scope.addTag = function ($event, tag) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      if ($scope.leadGen.tags.includes(tag)) {
        return alert("tag already added");
      }
      $scope.tagsdata = "";
      $scope.leadGen.tags.push(tag);
    };
    $scope.deleteTag = function (index) {
      $scope.leadGen.tags.splice(index, 1);
    };

    $scope.initialize = function () {
      getAllTags();
      getAllMakets();
    };
    $scope.initialize();
  }
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("LoadingController", MainController);

  function MainController(
  ) {
    
  }
})();
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('InstructorSigninController', ['$scope', '$state', 'CustomStorageService','$http', function($scope, $state, CustomStorageService,$http) {

    if(CustomStorageService.getInstructorSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
      $state.go('InstructorPanelDashboard',{},{reload:true});
    }

    $scope.submitLogin = function(loginForm) {
      if(!loginForm.username || !loginForm.password){
        return false;
      }
      var data = {
        email: loginForm.username,
        password: loginForm.password,
        origin: 'LEGACY',
      }
      $http.post('api/v1/auth/signin',data).then(function(resp) {
        $scope.user = resp.data.user;
        if (resp.data.user.user_type === 'instructor') {
          if(resp.data.user.password_changed == true){
            $scope.text = "Logged in as " + resp.data.user.full_name;
            swal({
              title: "Log In Successful!",
              text: $scope.text,
              type: "success",
              timer: 2000,
              showConfirmButton: false
            },function(){
              swal.close();
              CustomStorageService.SignInService(false,false,true,false,resp.data.token,resp.data.user);
              $state.go('InstructorPanelAllCourses',{},{reload:true});
            });
          }
          else{
            $scope.passwordPopup = true;
          }
        }
        else{
          swal({
            title: 'Not Authorized',
            text: 'Your account is not authorized for this operation',
            type: 'info'
          });
        }
      }, function errorCallback(response) {
        swal({
          title: 'Error',
          text: response.data.message,
          type: 'error'
        })
      })
    };


    $scope.submitPassword = function(passwordForm){
      $scope.passwordPopup = false;
      if(!passwordForm.password || !passwordForm.password_confirmation){
        swal({
          title: "Incomplete Data",
          text: "Please fill in all the fields",
          type: "error"
        },function(){
          $scope.passwordPopup = true;
          if (!$scope.$$phase) $scope.$apply();
        });
        return;
      }
      if(passwordForm.password.length < 8){
        swal({
          title: "Password length",
          text: "Password needs to be atleast 8 characters",
          type: "error"
        },function(){
          $scope.passwordPopup = true;
          if (!$scope.$$phase) $scope.$apply();
        });
        return;
      }
      if(passwordForm.password != passwordForm.password_confirmation){
        swal({
          title: "Password Do Not Match",
          text: "Password and Confirm Password Do Not Match",
          type: "error"
        },function(){
          $scope.passwordPopup = true;
          if (!$scope.$$phase) $scope.$apply();
        });
        return;
      }
      $http.post('api/v1/users/updatePassword',{email:$scope.user.email,type:'instructor',password:passwordForm.password})
      .then(function(data){
        if(data.data.success){
          swal({
            title: 'Success',
            text: 'Password successfully updated, please login with new password',
            type: 'success',
            timer: 2000
          },function(){
            swal.close();
            location.reload();
          });
        }
      })
    }

  }]);

})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("InstructorPanelController", [
    "$scope",
    "$http",
    "$state",
    "CustomStorageService",
    "instructorPanelService",
    "$sails",
    "env",
    "AssignmentService",
    function (
      $scope,
      $http,
      $state,
      CustomStorageService,
      instructorPanelService,
      $sails,
      env,
      AssignmentService
    ) {
      $scope.signedIn = CustomStorageService.getInstructorSignedInStorageData();
      $scope.userInfo = CustomStorageService.getUserInfoStorageData();
      console.log("signed in", $scope.userInfo);
      $scope.unansweredQuestions = 0;
      $scope.unansweredAssignments = 0;
      var pageName = [
        { state: "InstructorPanelDashboard", name: "Dashboard" },
        { state: "InstructorPanelAllCourses", name: "Courses" },
        { state: "InstructorPanelEnrolledStudents", name: "Enrolled Students" },
        { state: "InstructorPanelComments", name: "Comments" },
        { state: "InstructorPanelTransactions", name: "Transactions" },
        { state: "InstructorPanelStudentsQuestions", name: "Student Questions"},
        { state: "InstructorPanelMyProfile", name: "Profile Settings" },
        { state: "InstructorPanelCourseNew", name: "Add New Course" },
        { state: "InstructorPanelCourseEdit", name: "Edit a Course" },
        { state: "InstructorPanelModuleNew", name: "Add New Module" },
        { state: "InstructorPanelModuleEdit", name: "Edit a Module" },
        // { state: "InstructorPanelChapterNew", name: "Add New Chapter" },
        // { state: "InstructorPanelChapterEdit", name: "Edit a Chapter" },
        { state: "InstructorPanelVideo", name: "Videos" },
        { state: "InstructorPanelLiveSession", name: "Live Sessions" },
        { state: "InstructorPanelNewLiveSession", name: "Create Live Sessions" },
      ];
      function searchPageName(state) {
        for (var i = 0; i < pageName.length; i++) {
          if (pageName[i].state === state) {
            $scope.currPage = pageName[i].name;
            return;
          }
        }
      }
      $scope.sideBarSelected = false;
      $scope.openSideMenu = function () {
        $scope.sideBarSelected = !$scope.sideBarSelected;
      };
      $scope.logoutDropdown = false;
      $scope.openLogout = function () {
        console.log('222222222')
        $scope.logoutDropdown = !$scope.logoutDropdown;
      };
      var ignoreClickOnMeElement = document.getElementById("logoutDropdown");
      var ignoreClickOnMeElement1 = document.getElementById("facultydropdown");
      var ignoreClickOnMeElement2 = document.getElementById("sidebarMenu");
      var ignoreClickOnMeElement3 = document.getElementById("dropdownIcon");
      document.addEventListener("click", function (event) {
        var isClickInsideElement = ignoreClickOnMeElement.contains(
          event.target
        );
        var isClickInsideElement1 = ignoreClickOnMeElement1.contains(
          event.target
        );
        var isClickInsideElement2 = ignoreClickOnMeElement2.contains(
          event.target
        );
        var isClickInsideElement3 = ignoreClickOnMeElement3.contains(
          event.target
        );
        if (!isClickInsideElement) {
          $scope.logoutDropdown = false;
          $scope.$apply();
        }
        if (!isClickInsideElement1) {
          $scope.facultyDropdown = false;
          $scope.$apply();
        }
        if (!isClickInsideElement2 && !isClickInsideElement3) {
          $scope.sideBarSelected = false;
          $scope.$apply();
        }
      });

      $scope.facultyDropdown = false;
      $scope.openFaculty = function () {
        $scope.facultyDropdown = !$scope.facultyDropdown;
      };
      $scope.getUnansweredCount = function () {
        $http
          .get("/api/v1/post-question/get-pending-count")
          .then(function (resp) {
            console.log("count ---", resp);
            if (resp.data.success) {
              $scope.unansweredQuestions = resp.data.pendingQuestions;
            } else {
              $scope.unansweredQuestions = 0;
            }
          });
      };

      var getUnansweredAssignmentsCount = function () {
        AssignmentService.getPendingCount({instructor_id: CustomStorageService.getUserInfoStorageData().id}).then(function (res) {
          if(res.success) {
            $scope.unansweredAssignments = res.pendingCount;
          }
        });
      };

      getUnansweredAssignmentsCount();

      $scope.$on("$stateChangeSuccess", function (event) {
        $scope.stateName = $state.current.name;
        searchPageName($scope.stateName);
      });
      $scope.initialize = function () {
        var wp_widget = document.getElementById("whatsapp_chat_widget")
        if(wp_widget) {
          wp_widget.style.display = "none";
        }
        $scope.stateName = $state.current.name;
        searchPageName($scope.stateName);
        $sails
          .get("/api/v1/sockets/setSocket", {
            userId: CustomStorageService.getUserInfoStorageData().id,
          })
          .then(function (resp) {
            CustomStorageService.setSocketIdStorageData(resp.data.socketId);
          });
        if (
          $state.current.name == "InstructorPanelComments" ||
          $state.current.name == "InstructorPanelQuizNew" ||
          $state.current.name == "InstructorPanelQuizEdit" ||
          $state.current.name == "InstructorPanelQuizDashboard" ||
          $state.current.name == "InstructorPanelTransactions"
        ) {
          $scope.hideFaculty = true;
        }

        $scope.getUnansweredCount();
        $scope.instructorName =
          CustomStorageService.getUserInfoStorageData().full_name;
        instructorPanelService.setInstructorId(
          CustomStorageService.getUserInfoStorageData().id
        );
        $scope.showData = false;
        $http({
          url: "api/v1/instructors/instructorUniversityList",
          method: "GET",
          params: { instructor_id: instructorPanelService.getInstructorId() },
        }).then(function (data) {
          if (data.data.success) {
            if (data.data.data.length > 0) {
              $scope.instructorData = data.data.data;
              if(CustomStorageService.getInstitution())
                $scope.selectedInstitution = CustomStorageService.getInstitution();
              else
                $scope.selectedInstitution = $scope.instructorData[0].institution;
              if(CustomStorageService.getFaculty())
                $scope.selectedFaculty = CustomStorageService.getFaculty();
              else
                $scope.selectedFaculty = $scope.instructorData[0].faculty;
              CustomStorageService.setFaculty($scope.selectedFaculty);
              CustomStorageService.setInstitution($scope.selectedInstitution);
              instructorPanelService.setSelectedFaculty($scope.selectedFaculty);
              instructorPanelService.setSelectedInstitution(
                $scope.selectedInstitution
              );
              for (var i = 0; i < $scope.instructorData.length; i++) {
                if($scope.selectedFaculty == $scope.instructorData[i].faculty)
                  $scope.instructor_courses = $scope.instructorData[i].courses;
              }
              $scope.$broadcast("init");
            } else {
              instructorPanelService.setNoFaculty();
            }
            $scope.showData = true;
          } else {
            $scope.showData = true;
          }
        });
      };

      $scope.updateFaculty = function (institution, faculty, index) {
        $scope.selectedInstitution = $scope.instructorData[index].institution;
        CustomStorageService.setInstitution($scope.selectedInstitution);
        $scope.selectedFaculty = $scope.instructorData[index].faculty;
        CustomStorageService.setFaculty($scope.selectedFaculty);
        $scope.instructor_courses = $scope.instructorData[index].courses;
        instructorPanelService.setSelectedFaculty($scope.selectedFaculty);
        instructorPanelService.setSelectedInstitution(
          $scope.selectedInstitution
        );
        instructorPanelService.setSelectedCourses($scope.instructor_courses);
        $scope.$broadcast("instructorUpdatedFaculty");
        $scope.facultyDropdown = false;
      };
      $scope.currPage = "";
      $scope.goToState = function (state) {
        $state.go(state, {}, { reload: true });
      };

      $scope.goToQuizCenter= function(){
        var user = CustomStorageService.getUserInfoStorageData();
        var token = CustomStorageService.getAuthTokenStorageData();
        if(user && token){
          console.log("token",token,"user",user);
          var url = env.quizCenter + '?uid=' + user.id + '&token=' + token + '&redirecturl='+encodeURIComponent('quiz/quiz-landing');
          console.log(url)
          window.open(url, '_blank')
        }
      };

     $scope.logOut = function(){
       console.log('2323232232')
			$http.get('/api/v1/sockets/clearSocket',{userId:CustomStorageService.getUserInfoStorageData().id})
			.then(function(res){
				CustomStorageService.logOutService('instructor_logout');
				$state.go('instructor_signin',{},{reload:true});
			})	
		};
      if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
        $state.go("instructor_signin", {}, { reload: true });
      } else {
        $scope.initialize();
      }
    },
  ]);
})();

(function() {
    'use strict';

    angular
        .module('NearPeer')

        .service('instructorPanelService', ['$rootScope','$http', '$state', function($rootScope,$http, $state) {

            var selectedFaculty,selectedInstitution,courses,courseId,moduleId,instructorId,noFaculty;

            var setNoFaculty = function(){
                noFaculty = true;
            }

            var getNoFaculty = function(){
                return noFaculty;
            }

            var setSelectedFaculty = function(str){
                selectedFaculty = str;
            }

            var setSelectedInstitution = function(str){
                selectedInstitution = str;
            }

            var setSelectedCourses = function(coursee){
                courses = coursee;
            }

            var setCourseId = function(id){
                courseId = id;
            }

            var setModuleId = function(id){
                moduleId = id;
            }

            var setInstructorId = function(id){
                instructorId = id;
            }

            var getInstructorId = function(){
                return instructorId;
            }

            var getModuleId = function(){
                return moduleId
            }

            var getCourseId = function(){
                return courseId;
            }

            var getSelectedCourses = function(){
                return courses;
            }

            var getSelectedFaculty = function(){
                return selectedFaculty;
            }

            var getSelectedInstitution = function(){
                return selectedInstitution;
            }

            var successDeleteSwal = function(){
                setTimeout(function(){
                    swal({
                        title: "Success",
                        text: "Successfully Deleted!",
                        type:"success"
                    });
                },200);
            }

            var tryAgainSwal = function(){
                setTimeout(function(){
                    swal({
                        title: "Error",
                        text: "Try again!",
                        type:"error"
                    });
                },200);
            }

            var successUpdateSwal = function(){
                swal({
                    title: "Success",
                    text: "Successfully Updated",
                    type: "success",
                    timer: 2000
                },function(){
          					// location.reload();
                });
            }
            var compareDates = function (fromDate, toDate) {
				var fDate = new Date(fromDate);
				var tDate = new Date(toDate);
		
				if(tDate.getTime() > fDate.getTime()){
					return true;
                }
                swal('Oops..', 'Start date can not be greater than or equal to end date', 'error');
				return false;
			 }

            return {
                getSelectedInstitution:getSelectedInstitution,
                getSelectedFaculty:getSelectedFaculty,
                getSelectedCourses:getSelectedCourses,
                setSelectedFaculty:setSelectedFaculty,
                setSelectedInstitution:setSelectedInstitution,
                setSelectedCourses:setSelectedCourses,
                successDeleteSwal:successDeleteSwal,
                tryAgainSwal:tryAgainSwal,
                successUpdateSwal:successUpdateSwal,
                setCourseId:setCourseId,
                getCourseId:getCourseId,
                setModuleId:setModuleId,
                getModuleId:getModuleId,
                setInstructorId:setInstructorId,
                getInstructorId:getInstructorId,
                setNoFaculty:setNoFaculty,
                getNoFaculty:getNoFaculty,
                compareDates:compareDates
            }
        }]);
    })();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('tagCoursesController', ['$rootScope','$scope', '$http', '$state', 'courseDetailService','BreadcrumbService', function($scope,$rootScope, $http, $state, courseDetailService,BreadcrumbService) {
    $scope.showData = false;
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.courses = [];
    $scope.initialize = function() {
      
      
      $http({
        url: '/api/v1/tag-url/courses/' + $state.params.tag_index_url,
        method: "GET",
        params: {}
      }).then(function(data) {
        if(data.data.success){
          $scope.tag = data.data.tag;
          $scope.courses = data.data.tag.courses;
          $scope.showData = true;
          var breadCrumbData = BreadcrumbService.getBreadCrumbCategoryName($scope.tag.name);
          onloadFunction(breadCrumbData,'LEAF');

          mixpanel.track('Tag-Url-page', {
            'Tag_Url_Name' : $scope.tag.name,
          });
        }
        else{
          $state.go('404');
        }
      });
    };

    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
    }

    $scope.initialize();
  }]);

})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('schoolController', ['$rootScope','$scope', '$http', '$state', 'courseDetailService','BreadcrumbService', function($scope,$rootScope, $http, $state, courseDetailService,BreadcrumbService) {
    $scope.showData = false;
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    var instName = $state.params.institutionName;
    $scope.institution = {name:instName};
    $scope.initialize = function() {
      var breadCrumbData = BreadcrumbService.getBreadCrumbCategoryName($state.params.institutionName);
      
      onloadFunction(breadCrumbData,'LEAF');
      $scope.hideFeaturedCourse = true;
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      instName = instName.split('-').join(' ');
      $http({
        url: 'api/v1/courses/getCoursesByInstitution',
        method: "GET",
        params: {institution: instName}
      }).then(function(data) {
        document.title = instName.toUpperCase() + "- NearPeer Online";
        
        if(data.data.success){
          $scope.schools = data.data.schools;
          $scope.featuredCourse = data.data.featuredCourse;
          $scope.showData = true;
          try{
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
              'event': 'product-listing-age',
              'ecommerce': {
                'currencyCode': 'PKR',                       // Local currency is optional.
                'click': {
                  'facultName':  '',
                  'instName': instName
                }
              }
            });
          }catch(err){
            console.log('error in data layer-> ', err);
          }
          mixpanel.track('Niche-page', {
            'Niche_Name' : breadCrumbData.displayName,
            'Institutions' : instName
          });
        }
        else{
          $state.go('404');
        }
      });
    };

    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
    }

    $scope.initialize();
  }]);

})();

(function() {
  'use strict';

  angular
  .module('NearPeer')

  .service('moduleDetailService', ['$http', '$state', function($http, $state) {

  }]);

})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('moduleDetailController', ['courseDetailService','BreadcrumbService','$scope', '$http', '$state', '$sails', 'CustomStorageService', 'DownloadPopupService','$rootScope','$filter','paymentService','ExternalLinksService', 'env', '$location', function(courseDetailService,BreadcrumbService,$scope, $http, $state, $sails, CustomStorageService, DownloadPopupService,$rootScope,$filter,paymentService,ExternalLinksService, env, $location) {



    $scope.showData = false;
    $scope.popupDiv = false;
    $scope.allow_on_browser = false;
    $scope.numLimit=180;
    $scope.readMoreBtn = "Read more";
    $scope.lmsPopup = false;
    $scope.redirectUrlLms = '';
    $scope.lmsPopupCount = 0
    $scope.readMore=function(length){
      if($scope.readMoreBtn ==="Read more") {
        $scope.readMoreBtn = "Read less";
        $scope.numLimit=length;
      } else if($scope.readMoreBtn ==="Read less"){
        $scope.readMoreBtn = "Read more";
        $scope.numLimit=180;
      }
    
    };

    var checkIsCustomForm = function (module) {
      if($rootScope.customForms && $rootScope.customForms.length > 0) {
        $rootScope.customForms.forEach(function(form) {
          if(form.config && form.config.length > 0) {
            form.config.forEach(function(config) {
              if(module.id === config.module_id) {
                $scope.$emit("show-custom-form", form);
              }
            })
          }
        });
      }
    }

    var queryParams = $location.search();
    
    $scope.closePopup = function() {
      $scope.popupDiv = false;
    }
    
    $scope.openApp = function() {
      $scope.popupDiv = false;
      DownloadPopupService.openApp();
    }
    $scope.DownloadApp = function() {
      DownloadPopupService.downloadApp();
      $scope.popupDiv = false;
    }
    
    $scope.attachments = true;
    var coursePurchasedReq = false ;
    $(document).ready(function(){
      $(this).scrollTop(0);
    });

    if ( CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()) {
      $scope.signedIn = true;
    }

    $scope.initialize = function() {
      if (CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()){
        var id = CustomStorageService.getUserInfoStorageData().id;
      }
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      var schoolName = $state.params.schoolName;
      schoolName = schoolName.toLowerCase();
      var course = $state.params.courseName;
      course = course.toLowerCase();
      var module_no = $state.params.moduleNo;
      var url = instName + '/' + schoolName + '/' + course;

      const width = window.screen.width * window.devicePixelRatio
      const height = window.screen.height * window.devicePixelRatio;

      $http({
        url: 'api/v1/courses/getModuleByIndexUrl',
        method: "GET",
        params: {
          url: url,
          module_no:module_no,
          user_id:id,
          m_id:CustomStorageService.getModule(),
          width: width,
          height: height
        }
      }).then(function(data){
        var crumbURL=window.location.href;
        var leafCrumbUrl=crumbURL.slice(0,-2);
        console.log('CRUMB URL=',crumbURL);
        console.log('LEAF CRUMB URL=',leafCrumbUrl)
            var breadCrumbData = BreadcrumbService.getBreadCrumbCategoryName($state.params.institutionName);
            console.log('INSTITUTION NAME=',breadCrumbData)
            onloadFunction(
              breadCrumbData, 'LEAF'
            );
            onloadFunction(
              {'url': leafCrumbUrl,
                'displayName':data.data.courseData.name, 
              },'category'
            );
            onloadFunction(
              {'url': crumbURL,
                'displayName':data.data.courseData.modules[0].name, 
              },'child'
            );        
        document.title = data.data.courseData.modules[0].name + "- NearPeer Online";
        fbq('track', 'ViewSubContent', {
            content_ids: "M"+data.data.courseData.modules[0].id,
            content_type: 'Module',
            value: data.data.courseData.modules[0].module_type.price || 0,
            currency: 'pkr',
            content_name: data.data.courseData.modules[0].name,
        });
        $scope.selectedModule = data.data.courseData.modules[0];
        $scope.selectedModule.courseFeature = data.data.courseData.courseFeature;
        $scope.selectedModule.instructor_id = data.data.courseData.instructor_id;
        $scope.allow_on_browser = data.data.courseData.allow_on_web;
        $scope.selectedModule.description = ExternalLinksService.addTargetToExternalLinks($scope.selectedModule.description);
        $scope.$broadcast('getCourseEnrolled',data.data.courseData.id);  
        if(data.data.coursePurchased) {
          $scope.selectedModule.coursePurchased = data.data.coursePurchased.purchased;
          coursePurchasedReq = data.data.coursePurchased.purchased;
        } else if($scope.selectedModule.module_type.purchased){
          $scope.selectedModule.coursePurchased = $scope.selectedModule.module_type.purchased

        }
        if(data.data.notSignedIn && $scope.selectedModule.module_type.paid) {
          showLoginPopup();
          return false;
        }
        if(data.data.courseData && data.data.courseData.modules.length > 0) {
          if(!$scope.firstTime && CustomStorageService.getUserSignedInStorageData()) {
            if(!data.data.enrolled){
              if(data.data.courseData.special){
                var type = "CA";
              } else {
                var type = "UNI";
              }
              courseDetailService.swalGetEnrolledPopup(data.data.courseData.id,'player',type);
              return false;
            }
          }
          if(data.data.content.content == 'chapters'){
            $scope.chapters = data.data.content.chapters;
            $scope.hideVideos = true;
          } else {
            $scope.videos = data.data.content.videos;
            $scope.hideChapters = true;
          }
          $scope.selectedCourse = data.data.courseData;
          $scope.showData = true;
          $http({
            url: 'api/v1/attachments/checkAttachments',
            method: "GET",
            params: {id:$scope.selectedModule.id}
          }).then(function(data){
            if(data.data.success){
              $scope.attachments = false;
            }
          })
          if($state.current.name === 'course_module_buy') {
            $scope.$broadcast('salesPopup');
          } else {
            // checkIsCustomForm($scope.selectedModule)
          }
        }
        else if(data.data.courseData){
          $rootScope.moduleNotExist = true;
          $scope.goToCourse();
        }
        else{
          $state.go('404');
        }
        var goToVelocityStatus = JSON.parse(sessionStorage.getItem('goToVelocity'));
        if(goToVelocityStatus && goToVelocityStatus.condition && $scope.signedIn){
          $scope.redirectUrlLms = goToVelocityStatus.redirect;
          $scope.goToVelocity()
        }
      }, function(error) {
        if(!queryParams || !queryParams.uid) {
          swal({
            title: "Error",
            text: 'please contact to admin ! no module exist',
            closeOnConfirm: true
          }, function () {
            return false;
          });
        }
        $scope.showData = true;
      });
      $http({
        url: 'api/v1/user/get-user-lms-popup-count',
        method: "GET",
        params: {
         count: 0
        }
      }).then(function(data){
        if(data.data.success){
          $scope.lmsPopupCount = Number(data.data.data.lms_popup_count) ? data.data.data.lms_popup_count : 0;
        }
      })

    };

    $scope.goToCourse = function(){
      var instName = $state.params.institutionName;
      var schoolName = $state.params.schoolName;
      var course = $state.params.courseName;
      $state.go('Course',{institutionName:instName,schoolName:schoolName,courseName:course},{reload:true});
    };
    $scope.goToVelocity = function(){
       var instName = $state.params.institutionName;
        var schoolName = $state.params.schoolName;
        var course = $state.params.courseName;
        var user = CustomStorageService.getUserInfoStorageData();
        var token = CustomStorageService.getAuthTokenStorageData();
        if(user && token){
        // return false;
          var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl='
          if($scope.redirectUrlLms){
            url += encodeURIComponent($scope.redirectUrlLms)
          }else{
            url+=encodeURIComponent('course/course-detail/' + instName + '/' + schoolName +'/' + course + '/' + $scope.selectedCourse.id)
          }
          console.log(url)
          window.open(url, '_self')
          sessionStorage.removeItem('goToVelocity');
        }else{
          sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true }));
          showLoginPopup();
        }
    };

    $scope.closeLms = function (){
      $scope.lmsPopup = false;
    }
    $scope.showVideo = function(video,chapterNo) {
      mixpanel.track('Video-Page', {
        'Video_Name' : video.name,
        'Video_ID' : video.id,
        'User_ID' : $scope.user.id ? $scope.user.id : null,
      });
      var redirecturl = 'course/' + $scope.selectedModule.index_url + '/' + $scope.selectedModule.id + '/' + video.id +'?courseIndexUrl=' + encodeURIComponent($scope.selectedCourse.index_url)
      if(video.quiz_type == 'daq') {
        redirecturl = 'course/' + $scope.selectedModule.index_url + '/' + $scope.selectedModule.id + '/' + video.session_id +'?daq=true&daq_id='+video.session_id+'&courseIndexUrl=' + encodeURIComponent($scope.selectedCourse.index_url)
      }
      if(($scope.selectedModule.module_type.purchased || coursePurchasedReq || $scope.selectedModule.module_type.free)){
      if($scope.signedIn || (!$scope.signedIn && video.type == 'quiz' && video.session_id)){
        if(($scope.selectedModule.module_type.purchased || coursePurchasedReq || $scope.selectedModule.module_type.free) && video.type == 'quiz'){
          if(video.session_id) {
            if(video.quiz_type == 'daq') {
              $scope.redirectUrlLms = redirecturl
              $scope.goToVelocity()
            } else {
              if(CustomStorageService.getUserInfoStorageData() && CustomStorageService.getUserInfoStorageData().id) {
                location.href = env.velocityPortal + '/quiz/standard-quiz-main/' + video.session_id + '?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData();
              } else {
                location.href = env.velocityPortal + '/quiz/standard-quiz-main/' + video.session_id;
              }
            }
          } else {
            $state.go('quiz',{quiz_id: video.id});
            mixpanel.track('Quiz-Page', {
              'Quiz_Name' : video.name,
              'Quiz_ID' : video.id,
              'User_ID' : $scope.user.id ? $scope.user.id : null,
            });
          }
        } else {
          if(video.type === 'notes') {
            mixpanel.track('Notes-Page', {
              'Notes_Name' : video.name,
              'notes_ID' : video.id,
              'User_ID' : $scope.user.id ? $scope.user.id : null,
            });
            redirecturl = 'course/' + $scope.selectedModule.index_url + '/' + $scope.selectedModule.id + '/' + video.id +'?notes=' + video.id + '&courseIndexUrl=' + encodeURIComponent($scope.selectedCourse.index_url)
          }
          $scope.redirectUrlLms = redirecturl
          if($scope.lmsPopupCount >= 3 || $rootScope.platform_reactApp){ 
            $scope.goToVelocity()
          }else{
            $http({
              url: 'api/v1/user/update-user-lms-popup-count',
              method: "POST",
              params: {
              count: 0
              }
            }).then(function(data){})
            $scope.lmsPopup = true;
            $scope.lmsPopupCount += 1
          }
        }
        
      }else{
        if($scope.firstTime) {
          if(chapterNo > -1){
            if(video.vss_link){
              $state.go('vimeo_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:chapterNo,video_no:video.video_no},{reload:true})
            }else{
              $state.go('video_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:chapterNo,video_no:video.video_no},{reload:true})
            }
          }  else{
            if(video.vss_link){
              $state.go('vimeo_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true})
            }else{
              $state.go('video_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true})
            }
          }
        } else {
          sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true, redirect: redirecturl }));
          showLoginPopup();
        }
        
      }
    }else{
      $scope.swalCouponPopup(); 
    }
      
      // if($scope.allow_on_browser || $scope.selectedModule.module_type.free || video.type == 'quiz') {
      //   if($scope.selectedModule.module_type.purchased || coursePurchasedReq || $scope.selectedModule.module_type.free){
      //     if(video.type == 'quiz'){
      //       if(video.session_id) {
      //         location.href = env.velocityPortal + '/quiz/standard-quiz-main/' + video.session_id + '?uid=' + CustomStorageService.getUserInfoStorageData().id + '&token=' + CustomStorageService.getAuthTokenStorageData();
      //       } else {
      //         $state.go('quiz',{quiz_id: video.id});
      //       }
      //     } else {
      //       if(chapterNo > -1){
      //         if(video.vss_link){
      //           $state.go('vimeo_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:chapterNo,video_no:video.video_no},{reload:true})
      //         }else{
      //           $state.go('video_player_chapter',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,chapterNo:chapterNo,video_no:video.video_no},{reload:true})
      //         }
      //       }  else{
      //         if(video.vss_link){
      //           $state.go('vimeo_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true})
      //         }else{
      //           $state.go('video_player',{institutionName:$state.params.institutionName,schoolName:$state.params.schoolName,courseName:$state.params.courseName,moduleNo:$state.params.moduleNo,video_no:video.video_no},{reload:true})
      //         }
      //       }
      //     }
      //   } else {
      //     $scope.swalCouponPopup();
      //   }
      // } else {
      //   // $scope.popupDiv = true;
      //   $scope.lmsPopup = true;
      //   };
    };

    $scope.swalCouponPopup = function(){
      swal({
        title: "Error",
        text: 'Please purchase this module to view this video',
        closeOnConfirm: true
      }, function () {
        return false;
      });
      document.getElementById('button-link').addEventListener("click", function(){
        swal.close();
        $state.go('paymentOptions',{},{reload:true})
      });
    }
    $scope.$on('userLoggedIn', function( event, message ){
      location.reload();
    });
    $scope.$on('closeForm', function( event, message ){
      $state.go('Home',{},{reload:true});
    });
    $scope.collapse = function(id, chapterName){
      mixpanel.track('Chapter-Page', {
        'Chapter_Name' : chapterName,
        'Chapter_ID' : id,
        'User_ID' : $scope.user.id ? $scope.user.id : null,
      });
      if($scope.value == id){
        $scope.value = -1;
      }
      else{
        $scope.value = id;
      }
    }
    $scope.downloadAttachments = function(){
      var name = $scope.selectedModule.name;
      name = name.split(' ').join('+');
      var id = $scope.selectedModule.id;
      var win = window.open('https://nearpeer-zips.s3.amazonaws.com/moduleZips/' + name + '-' + id+'.zip', '_blank');
    }
    var showLoginPopup = function(){
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }
    if(!CustomStorageService.getUserSignedInStorageData() && !CustomStorageService.getInstructorSignedInStorageData()){
      if(!CustomStorageService.getFirstTimeStorageData()){
        $scope.firstTime = true;
        $scope.initialize();
      } else {
        showLoginPopup();
      }
    } else{
      $scope.initialize();
    }

    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
      
  } 

  }]);
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('InstructorController', ['$rootScope','$scope', '$http', '$state', 'courseDetailService', function($scope,$rootScope, $http, $state, courseDetailService) {
    $scope.showData = false;

    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.courseDiv1 = {}
    $scope.courseDiv2 = {}
    $scope.initialize = function(){
      var instructor = $state.params.instructorName;
      var instructor = instructor.split('-').join(' ');
      $http({
        url: 'api/v1/courses/getInstructorCourses',
        method: "GET",
        params: {instructor: instructor}
      }).then(function(data) {
        $scope.instructor = data.data.instructor;
        $scope.courses = data.data.courses;
        $scope.showData = true;
      })
    }
    $scope.initialize();
  }]);
})();

(function () {
  'use strict';

  angular
    .module('NearPeer')

    .service('courseDetailService', ['$rootScope', '$http', '$state', 'CustomStorageService', function ($rootScope, $http, $state, CustomStorageService) {

      var swalGetEnrolledPopup = function (courseId, from, type) {
        if (type == 'CA') {
          var successMsg = "Successfully Accessed";
        } else {
          var successMsg = "Successfully Enrolled";
        }
        $http.post('api/v1/enrolledstudents/enrollCourse', { user_id: CustomStorageService.getUserInfoStorageData().id, course_id: courseId, time: new Date() })
          .then(function (data) {
            setTimeout(function () {
              if($rootScope.platform_reactApp){
                console.log("courseEnrolled");
              }
              swal({
                title: 'Success',
                text: successMsg,
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              }, function () {
                swal.close();
                if (from == 'course') {
                  $rootScope.$emit('userEnrolled');
                } else {
                  location.reload();
                }
              });
            }, 50);
          });
      }

      var goToBundle = function (bundleName) {
        if(bundleName === 'CSS-COMPULSORY') {
          $state.go('schools',{institutionName: 'css'},{reload:true});
        } else if (bundleName === 'MDCAT_FULL') {
          $state.go('schools',{institutionName: 'entry-test-preparation'},{reload:true});
        } else {
          $state.go('Landing')
        }
      }

      var goToCourse = function (course) {
        var urlParms = course.index_url.split('/')
        if (urlParms.length == 3) {
          $state.go('Course', { institutionName: urlParms[0], schoolName: urlParms[1], courseName: urlParms[2] }, { reload: true });
        } else {
          $state.go('404')
        }
      }

      var goToModule = function (module) {
        var institution;
        var school;
        var course;
        if(module.course_index_url) {
          var urlParms = module.course_index_url.split('/')
          course = urlParms[2];
          school = urlParms[1];
          institution = urlParms[0];
        } else {
          institution = module.institution_name.split(' ').join('-');
          institution = institution.toLowerCase();
          school = module.faculty_name.split(' ').join('-');
          school = school.toLowerCase();
          course = module.course_name.split('-').join('');
          course = course.split('  ').join(' ')
          course = course.split(' ').join('-');
          course = course.toLowerCase();
        }
        $state.go('course_module', { institutionName: institution, schoolName: school, courseName: course, moduleNo: module.module_no }, { reload: true });
      }

      var goToVideo = function (video) { console.log(video);
        var urlParms = video.index_url.split('/')
        if (urlParms.length == 3) {
          if (!video.hasOwnProperty('chapterNo')) {
            if(video.vss_link && video.is_vss_web){
              $state.go('vimeo_player', { institutionName: urlParms[0], schoolName: urlParms[1], courseName: urlParms[2], moduleNo: video.moduleNo, video_no: video.videoNo }, { reload: true })
            }else{
              $state.go('video_player', { institutionName: urlParms[0], schoolName: urlParms[1], courseName: urlParms[2], moduleNo: video.moduleNo, video_no: video.videoNo }, { reload: true })
            }
          } else {
            if(video.vss_link && video.is_vss_web){
              $state.go('vimeo_player_chapter', { institutionName: urlParms[0], schoolName: urlParms[1], courseName: urlParms[2], moduleNo: video.moduleNo, chapterNo: video.chapterNo, video_no: video.videoNo }, { reload: true })
            }else{
              $state.go('video_player_chapter', { institutionName: urlParms[0], schoolName: urlParms[1], courseName: urlParms[2], moduleNo: video.moduleNo, chapterNo: video.chapterNo, video_no: video.videoNo }, { reload: true })
            }
          }
        } else {
          $state.go('404')
        }

        // var institution = video.institutionName.toLowerCase();
        // institution = institution.split(' ').join('-');
        // var school = video.schoolName.toLowerCase();
        // school = school.split(' ').join('-');
        // var course = video.courseName.toLowerCase();
        // course = course.split('-').join('');
        // course = course.split('  ').join(' ')
        // course = course.split(' ').join('-');
        // if (!video.chapterNo) {
        //   $state.go('video_player', { institutionName: institution, schoolName: school, courseName: course, moduleNo: video.moduleNo, video_no: video.videoNo }, { reload: true })
        // } else {
        //   $state.go('video_player_chapter', { institutionName: institution, schoolName: school, courseName: course, moduleNo: video.moduleNo, chapterNo: video.chapterNo, video_no: video.videoNo }, { reload: true })
        // }
      }

      return {
        swalGetEnrolledPopup: swalGetEnrolledPopup,
        goToBundle: goToBundle,
        goToCourse: goToCourse,
        goToModule: goToModule,
        goToVideo: goToVideo
      };

    }]);

})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('courseDetailController', ['$scope', '$http', '$state', 'courseDetailService','BreadcrumbService', 'CustomStorageService', '$rootScope', '$timeout', '$filter', 'paymentService', '$sails', 'ExternalLinksService', '$location', '$cookies', 'env', 'DownloadPopupService', 'TrackingService', function ($scope, $http, $state, courseDetailService,BreadcrumbService, CustomStorageService, $rootScope, $timeout, $filter, paymentService, $sails, ExternalLinksService, $location, $cookies, env, DownloadPopupService, TrackingService) {

      $(document).ready(function () {
        $(this).scrollTop(0);
      });

      $scope.showData = false;
      $scope.value = -1;
      $scope.firsTime = 0;
      $scope.noCoupon = true;
      $scope.numLimit = 180;
      $scope.readMoreBtn = "Read more";
      $scope.popupDiv = false;
      $scope.courseTitleAV = false;
      $scope.showFreeText = false;

      var checkIsCustomForm = function (course) {
        if($rootScope.customForms && $rootScope.customForms.length > 0) {
          $rootScope.customForms.forEach(function(form) {
            if(form.config && form.config.length > 0) {
              form.config.forEach(function(config) {
                if(course.id === config.course_id || course.tag_id === config.tag_id) {
                  $scope.$emit("show-custom-form", form);
                }
              })
            }
          });
        }
      }

      $scope.readMore = function (length) {
        if ($scope.readMoreBtn === "Read more") {
          $scope.readMoreBtn = "Read less";
          $scope.numLimit = length;
        } else if ($scope.readMoreBtn === "Read less") {
          $scope.readMoreBtn = "Read more";
          $scope.numLimit = 180;
        }

      };
      if (CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData()) {
        $scope.signedIn = true;
        $scope.userId = CustomStorageService.getUserInfoStorageData().id;
      } else {
        $scope.notSignedIn = true;
      }

      if ($rootScope.moduleNotExist) {
        $scope.showNoModuleMessage = true;
        $timeout(function showError() {
          $scope.showNoModuleMessage = false;
        }, 2000);
        $rootScope.moduleNotExist = false;
      }

      var initialize = function () {
        // get courses modules
        var data = {};
        var instName = $state.params.institutionName;
        instName = instName.toLowerCase();
        var schoolName = $state.params.schoolName;
        schoolName = schoolName.toLowerCase();
        var courseName = $state.params.courseName;
      var userToken = $location.search().token;
      var browserId = $cookies.get('browserId');
      if(userToken){
        var obj = {
            token: userToken,
            browser_id: browserId
        }
        $http({
            url: 'api/v1/auth/check-logged-in-user',
            method: "POST",
            params: obj
        }).then(function (userLoggedData) {
            CustomStorageService.SignInService(false, true, false, false, userLoggedData.data.data.token, userLoggedData.data.data.user);
            window.history.replaceState({}, document.title, "/" + "courses");
            location.reload();
        });
        }
        courseName = courseName.toLowerCase();
        var url = instName + '/' + schoolName + '/' + courseName;
        if (!$scope.signedIn) {
          data['index_url'] = url;
        } else {
          data['index_url'] = url;
          data['user_id'] = $scope.userId;
        }

        $http({
          url: 'api/v1/courses/getCourseByIndexUrl',
          method: "GET",
          params: data
        }).then(function (data) {
          
          if (data.data.success) {
            document.title = data.data.courseData.name + "- NearPeer Online";
            fbq('track', 'ViewContent', {
              content_ids: "C" + data.data.courseData.id,
              content_type: 'Course',
              value: data.data.courseData.discount_price || data.data.courseData.price || 0,
              currency: 'pkr',
              content_name: data.data.courseData.name,
            });
            TrackingService.viewItemEvent({
              price: data.data.courseData.discount_price || data.data.courseData.price || 0,
              item_id: data.data.courseData.id,
              item_name: data.data.courseData.name,
              discount: data.data.courseData.discount_price ? data.data.courseData.price - data.data.courseData.discount_price : 0,
              institute: data.data.courseData.institution,
              productType: 'course',
            })
            var crumbURL=window.location.href;
            var breadCrumbData = BreadcrumbService.getBreadCrumbCategoryName($state.params.institutionName);
            onloadFunction(
              breadCrumbData, 'LEAF'
            );
            onloadFunction(
              {'url': crumbURL,
                'displayName':data.data.courseData.name, 
              },'child'
            );
          
            try{
              dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
              dataLayer.push({
                'event': 'product-page',
                'ecommerce': {
                  'currencyCode': 'PKR',                       // Local currency is optional.
                  'click': {
                    'name': data.data.courseData.name,       // Name or ID is required.
                    'id': data.data.courseData.id,
                    'price': data.data.courseData.discount_price || data.data.courseData.price || 0,
                    'brand': 'Nearpeer',
                    'instName': data.data.courseData.institution
                  }
                  
                }
              });
            }catch(err){
              console.log('error in data layer ->', err)
            }
            gtag('event', 'select_content', {
              content_type: "product",
              items: [
                {
                  sku: data.data.courseData.id,
                  id: data.data.courseData.id,
                  name: data.data.courseData.name,
                  brand: "NearPeer",
                  price: data.data.courseData.discount_price || data.data.courseData.price || 0,
                }
              ]
            });
            $scope.enrolled = data.data.enrolled;

            $scope.selectedCourse = data.data.courseData;
            if($scope.selectedCourse.allow_on_app && $rootScope.platform_reactApp){
              $scope.showFreeText = true;
            }
            $scope.avg_rating = data.data.courseData.avg_rating;

            $scope.modules = data.data.courseData.modules;
            $scope.showData = true;
            $scope.selectedCourse.description = $scope.selectedCourse.description.replace("<br />", "\n", "g");
            $scope.selectedCourse.description = ExternalLinksService.addTargetToExternalLinks($scope.selectedCourse.description);

            $scope.$broadcast('getCourseEnrolled', data.data.courseData.id);

            if (data.data.coursePurchased) {

              $scope.selectedCourse.coursePurchased = data.data.coursePurchased.purchased;
              $scope.coursePurchased = data.data.coursePurchased;

              if(data.data.coursePurchased.accessConfig && data.data.isFreeAccessPopup) {
                swal({
                  title: 'Free Access',
                  text: 'Congratulations! You got Free Access of This Course',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }, function () {
                  window.localStorage.setItem("free_access_popup",'true');
                  swal.close();
                });
              }

            } else {
              $scope.selectedCourse.coursePurchased = false;
            }

            if ($scope.selectedCourse.special) {
              $scope.enrollBtnText = "Access";
              $scope.enrolledBtnText = "Accessed";
              $scope.successMsg = "Successfully Accessed"
            } else {
              $scope.enrollBtnText = "Enroll Now";
              $scope.enrolledBtnText = "Enrolled";
              $scope.successMsg = "Successfully Enrolled"
            }
            var goToVelocityStatus = JSON.parse(sessionStorage.getItem('goToVelocity'));
            if(goToVelocityStatus && goToVelocityStatus.condition && $scope.signedIn){
              $scope.goToVelocity()
            }
            if($state.current.name === 'CourseBuy') {
              $scope.$broadcast('salesPopup');
            } else {
              // checkIsCustomForm($scope.selectedCourse);
            }
          } else {
            $state.go('404');
          }
        }, function errorCallback(err) {

          if ($state.params.institutionName === 'chartered-accountancy-final') {
            $state.go('CAStatic');
          } else {
            $state.go('schools', { institutionName: $state.params.institutionName });
          } 
          // $state.go('404');
        
        });
      };

      $scope.goToInstitution = function () {
        if ($state.params.institutionName === 'chartered-accountancy-final') {
          $state.go('CAStatic', { reload: true });

        } else {
          $state.go('schools', { institutionName: $state.params.institutionName }, { reload: true });
        }
      }

      $scope.goToInstuctorProfile = function (name) {
        name = name.split(' ').join('-')
        $state.go('instructor', { instructorName: name }, { reload: true });
      }
      $scope.goToModule = function (module) {
      mixpanel.track('Module-Name', {
        'Module_Name' : module.name,
        'Module_Id' : module.id,
        // 'User ID': $scope.userInfo.id ? $scope.userInfo.id : null,
        // 'institutions': "mdcat"

      });

        $scope.module = module;
        if (CustomStorageService.getUserSignedInStorageData()) {
          if (!$scope.enrolled) {
            setTimeout(function () {
              if ($scope.selectedCourse.special) {
                var type = "CA";
              } else {
                var type = "UNI";
              }
              courseDetailService.swalGetEnrolledPopup($scope.selectedCourse.id, 'course', type);
            }, 500)
            return false;
          }
          gotoModule(module);
        }
        else {
          if (!CustomStorageService.getFirstTimeStorageData() && !module.module_type.paid) {
            gotoModule(module);

          } else {
            showLoginPopup();
          }
        }
      };

      var gotoModule = function (module) {
        if($scope.module){
          if((module.module_type.purchased  || $scope.selectedCourse.coursePurchased) && !module.module_type.free && !$rootScope.platform_desktop && !$rootScope.platform_reactApp && !$rootScope.isMobile && !$scope.selectedCourse.is_vvs_web){
            $scope.popupDiv = true;
          }else{
            $state.go('course_module', { institutionName: $state.params.institutionName, schoolName: $state.params.schoolName, courseName: $state.params.courseName, moduleNo: $scope.module.module_no }, { reload: true });
            
          }
        }
      }
      $scope.openSchedule = function (url) {
        window.open(url, '_blank');
      }

      $scope.$on('userLoggedIn', function (event, message) {
        $scope.showData = false;
        $http({
          url: 'api/v1/enrolledstudents/checkEnrollment',
          method: "GET",
          params: { user_id: CustomStorageService.getUserInfoStorageData().id, course_id: $scope.selectedCourse.id }
        }).then(function (data) {
          $scope.showData = true;
          $scope.enrolled = data.data.enrolled;
          if (!$scope.coursePurchase && !$scope.wantEnroll) {
            $scope.goToModule($scope.module);
          } else {
            location.reload();
          }
        })
      });
      $scope.closePopup = function() {
        $scope.popupDiv = false;
      }
      $scope.DownloadApp = function() {
        DownloadPopupService.downloadApp();
        $scope.popupDiv = false;
      }
      $scope.goToVelocity = function(){
        var instName = $state.params.institutionName;
        var schoolName = $state.params.schoolName;
        var course = $state.params.courseName;
        var user = CustomStorageService.getUserInfoStorageData();
        var token = CustomStorageService.getAuthTokenStorageData();
        if(user && token){
        // return false;
          var url = env.velocityPortal+ '?uid=' + user.id + '&token=' + token + '&redirecturl='+encodeURIComponent('course/course-detail/' + instName + '/' + schoolName +'/' + course + '/' + $scope.selectedCourse.id);
          console.log(url)
          window.open(url, '_self')
          sessionStorage.removeItem('goToVelocity');
        }else{
          sessionStorage.setItem('goToVelocity', JSON.stringify({condition: true }));
          showLoginPopup();
        }
      };
      $scope.isFree = function () {
        var total_count = $scope.modules.length;
        var freeCnt = 0;
        var paidCnt = 0;
        for (var i in $scope.modules) {
          if ($scope.modules[i].module_type.free) {
            freeCnt++;
          }
          else if ($scope.modules[i].module_type.purchased) {
            paidCnt++;
          }
        }
        if (freeCnt == total_count) {
          return true;
        }
        else if ((paidCnt + freeCnt) == total_count) {
          return true;
        }
      }
      $scope.getEnroll = function () {
        if (CustomStorageService.getUserSignedInStorageData()) {
          var data = { user_id: CustomStorageService.getUserInfoStorageData().id, course_id: $scope.selectedCourse.id, time: new Date() };
          $http.post('api/v1/enrolledstudents/enrollCourse', data)
            .then(function (data) {
              if (data.data.success) {
                if($rootScope.platform_reactApp){
                  console.log("courseEnrolled");
                }
                swal({ 
                  title: 'Succcess',
                  text: $scope.successMsg,
                  type: 'success', 
                  timer: 2000,
                  showConfirmButton: false
                }, function () {
                  location.reload();
                });
                $scope.enrolled = true;
              }
            });
        } else {
          $scope.wantEnroll = true;
          showLoginPopup();
        }
      }
      $rootScope.$on('userEnrolled', function (event, message) {
        $scope.enrolled = true;
        $scope.goToModule($scope.module);
      });
      initialize();

      var showLoginPopup = function () {
        $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
        $scope.$emit('showLoginPopup');
      }

      $scope.isFree = function () {
        if ($scope.course) {
          if ($scope.course.modules) {
            if($scope.course.discount_price && $scope.course.discount_price <= 1500) {
              $scope.isInstallmentAllowed = false;
            } else if($scope.course.price <= 1500) {
              $scope.isInstallmentAllowed = false;
            }
            var total_count = $scope.course.modules.length;
            var freeCnt = 0;
            var paidCnt = 0;
            if ($scope.course.price === null) {
              return true;
            } else {
              for (var i in $scope.course.modules) {
                if ($scope.course.modules[i].module_type.free) {
                  freeCnt++;
                }
                else if ($scope.course.modules[i].module_type.purchased) {
                  paidCnt++;
                }
              }
              if (freeCnt == total_count) {
                return true;
              }
              else if ((paidCnt + freeCnt) == total_count) {
                return true;
              } else if ($scope.course.coursePurchased) {
                return true;
              } else {
                return false;
              }
            }
          } else if ($scope.course.module_type) {
            if($scope.course.module_type.free){
              return true;
            } else if($scope.course.coursePurchased) {
              return true;
            }
            if($scope.course.module_type.discount && $scope.course.module_type.discount <= 1500) {
              $scope.isInstallmentAllowed = false;
            } else if($scope.course.module_type.price <= 1500) {
              $scope.isInstallmentAllowed = false;
            }
          } else if ($scope.course.coursePurchased) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      $scope.courseIncludeDD = function(){
        $scope.courseTitleAV = true;
      }
      $scope.courseIncludeDDClose = function(){
        $scope.courseTitleAV = false;
      }
      
     
      function onloadFunction(data,level) {
         BreadcrumbService.setBreadCrumb(data,level);
      }

    }]);
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('courseController', ['$rootScope','$scope', '$http', '$state', 'courseDetailService','BreadcrumbService', function($scope,$rootScope, $http, $state, courseDetailService,BreadcrumbService) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.showData = false;
    var instName = $state.params.institutionName;  
    $scope.institution = {name:instName}; 

    var initialize = function() {
      console.log('------rest');
      
      var breadCrumbData = BreadcrumbService.getBreadCrumbCategoryName($state.params.institutionName);
      onloadFunction(breadCrumbData,'LEAF');
      
      var instName = $state.params.institutionName;
      instName = instName.toLowerCase();
      instName = instName.split('-').join(' ');
      var facultName = $state.params.schoolName;
      facultName = facultName.toLowerCase();
      facultName = facultName.split('-').join(' ');
      $scope.hideFeaturedCourse = true;
      $http({
        url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
        method: "GET",
        params: {institution: instName, faculty: facultName}
      }).then(function(data) {
        
                
        if(data.data.success){
          document.title = facultName.toUpperCase() + "- NearPeer Online";
          $scope.selectedCourse = data.data.courses;
          $scope.featuredCourse = data.data.featuredCourse;
          try{
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
              'event': 'product-listing-age',
              'ecommerce': {
                'currencyCode': 'PKR',                       // Local currency is optional.
                'click': {
                  'facultName':  facultName,
                  'instName': instName
                }
              }
            });
          }catch(err){
            console.log('eeror in data layer-> ', err);
          }
          $scope.showData = true;
        }
        else{
          $state.go('404');
        }
      });
    };
    
    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
    }

    initialize();

  }]);

})();

(function () {
  "use strict";

  angular
    .module("NearPeer")

    .controller("allCourseController", [
      "$rootScope",
      "$scope",
      "$http",
      "$state",
      "courseDetailService",
      "$location",
      "$cookies",
      "CustomStorageService",
      function (
        $scope,
        $rootScope,
        $http,
        $state,
        courseDetailService,
        $location,
        $cookies,
        CustomStorageService
      ) {
        document.title =
          "Pakistan's Largest Collection of Online Courses - Nearpeer.org";
        $scope.showData = false;

        $(document).ready(function () {
          $(this).scrollTop(0);
        });
          var isFreeCourses = $location.search().free;
          $rootScope.isFree = isFreeCourses;
        // $rootScope.freeCourseController = true;
        // console.log("$lasadoc",$location, $rootScope.freeCourseController,isFreeCourses);

        $scope.filterDropDown = false;
        $scope.filterName = "All";
        $scope.faculties = [];

        $scope.selectedCourse = [];
        $scope.tags = [];
        var currentPage = 0;
        $scope.loading = false;
        var ended = false;
        var selectTagId;
        var selectCourseId;
        var st;

        $scope.initialize = function () {
          var userToken = $location.search().token;
          var browserId = $cookies.get("browserId");

          $scope.getCourses();

          if (userToken) {
            var obj = {
              token: userToken,
              browser_id: browserId,
            };
            $http({
              url: "api/v1/auth/check-logged-in-user",
              method: "POST",
              params: obj,
            }).then(function (userLoggedData) {
              CustomStorageService.SignInService(
                false,
                true,
                false,
                false,
                userLoggedData.data.data.token,
                userLoggedData.data.data.user
              );
              window.history.replaceState({}, document.title, "/" + "courses");
              location.reload();
            });
          }

          $http({
            url: "api/v1/coursetag/get",
            method: "GET",
          }).then(function (data) {
            $scope.tags = data.data.courseTags;
          });
          var paramsName = {};
          if(isFreeCourses) {
            paramsName.isFreeCourses = true;
          }

          $http({
            url: "api/v1/get-course-names",
            method: "GET",
            params: paramsName,
          }).then(function (data) {
            $scope.searchCourses = data.data.courses;
          });
        };

        $scope.searchChange = function(text) {
          $scope.searchCourse = text;
          if(text.length > 0) {
            console.log("allCoursesFilterOpen");
            $scope.searchFilterDropDown = true;
            var result = $scope.searchCourses.filter(function(course) {
              var name = course.name.toLowerCase();
              var textSearch = text.toLowerCase();
              return name.startsWith(textSearch)
            });
            $scope.searchedResults = result;
          } else {
            console.log("allCoursesFilterClose");
            $scope.searchFilterDropDown = false;
          }
        }

        $scope.openFilter = function () {
          if ($rootScope.platform_reactApp) {
            if (!$scope.filterDropDown) {
              console.log("allCoursesFilterOpen");
              $scope.filterDropDown = true;
            } else {
              console.log("allCoursesFilterClose");
              $scope.filterDropDown = false;
            }
          } else {
            $scope.filterDropDown = !$scope.filterDropDown;
          }
        };

        $scope.clearSearch = function() {
          $scope.searchFilterDropDown = false;
          $scope.filterName = 'All';
          $scope.filterDropDown = false;
          $scope.loading = false;
          ended = false;
          $scope.selectedCourse = [];
          currentPage = 0;
          selectTagId = undefined;
          selectCourseId = undefined;
          $scope.getCourses();

          document.getElementById('searchinput').value = ''; 
        }

        $scope.openSearchFilter = function () {
          if ($rootScope.platform_reactApp) {
            if (!$scope.searchFilterDropDown) {
              console.log("allCoursesFilterOpen");
              $scope.searchFilterDropDown = true;
            } else {
              console.log("allCoursesFilterClose");
              $scope.searchFilterDropDown = false;
            }
          } else {
            $scope.searchFilterDropDown = !$scope.searchFilterDropDown;
          }
        };

        $scope.updateSomeInput = function(event) {
          var text = event.target.value;
          $scope.searchCourse = event.target.value;
          if(text.length > 0) {
            console.log("allCoursesFilterOpen");
            $scope.searchFilterDropDown = true;
            var result = $scope.searchCourses.filter(function(course) {
              var name = course.name.toLowerCase();
              var textSearch = text.toLowerCase();
              if(name.includes(textSearch)) {
                if(selectTagId) {
                  if(selectTagId == course.tag_id) {
                    return true;
                  } else {
                    return false;
                  }
                }
                return true;
              } else {
                return false;
              }
            });
            $scope.searchedResults = result;
          } else {
            console.log("allCoursesFilterClose");
            $scope.searchFilterDropDown = false;
          }
        };

        $scope.searchByFilter = function (tagId, tagName) {
          document.getElementById('searchinput').value = ''; 
          $scope.searchCourse = '';
          $scope.filterName = tagName;
          $scope.filterDropDown = false;
          $scope.searchFilterDropDown = false;
          $scope.loading = false;
          ended = false;
          $scope.selectedCourse = [];
          currentPage = 0;
          selectCourseId = undefined;
          if (tagId === -1) {
            selectTagId = undefined;
          } else {
            selectTagId = tagId;
          }
          $scope.getCourses();
        };

        $scope.searchByCourse = function (course) {
          $scope.searchFilterDropDown = false;
          document.getElementById('searchinput').value = course.name; 
          $scope.filterDropDown = false;
          $scope.loading = false;
          ended = false;
          $scope.selectedCourse = [];
          currentPage = 0;
          selectCourseId = course.id;
          $scope.getCourses();
        };

        $(window).scroll(function (event) {
          if ($rootScope.platform_reactApp) {
            st = $(this).scrollTop();
            if (
              $scope.filterDropDown &&
              $rootScope.platform_reactApp &&
              st > 210
            ) {
              console.log("allCoursesFilterClose");
              $scope.filterDropDown = false;
              $scope.$apply();
            }
          }
        });
        $scope.getCourses = function () {
          if (!$scope.loading) {
            $scope.loading = true;
            currentPage = currentPage + 1;
            var params = { perPage: 10, currentPage: currentPage };
            if (selectTagId) {
              params.tagId = selectTagId;
            }
            if (selectCourseId) {
              params.courseId = selectCourseId;
            }
            if(isFreeCourses) {
              params.isFreeCourses = true;
            }
            $http({
              url: "api/v1/courses/getAllCoursesByTags",
              method: "GET",
              params: params,
            }).then(function (data) {
              
                try {
                  if(isFreeCourses) {
                    if(data.data.courseList.length > 0) {
                      var courses = {}
                      data.data.courseList.forEach(function(course) {
                        if(!courses[course.faculty]) {
                          courses[course.faculty] = [];
                        }
                        courses[course.faculty].push(course);
                      });
                      $scope.selectedCourse = courses;
                      $scope.faculties = Object.keys(courses)
                    } else {
                      $scope.faculties = [];
                    }
                    
                  } else {
                    $scope.selectedCourse = $scope.selectedCourse.concat(
                      data.data.courseList
                    );
                  }
                  
                } catch (error) {
                  console.log(error)
                }
              
              $scope.showData = true;
              if (data.data.courseList.length === 0) {
                ended = true;
              }
              $scope.loading = false;
            });
          }
        };

        $scope.loadMore = function () {
          if (!ended && !isFreeCourses) {
            $scope.getCourses();
          }
        };

        $scope.initialize();
      },
    ]);
})();

(function () {
  "use strict";
  angular.module("NearPeer").controller("formLinkCheckController", [
    "$scope",
    "$sce",
    "$state",
    "$rootScope",
    "CustomStorageService",
    "HttpService",
    function (
      $scope,
      $sce,
      $state,
      $rootScope,
      CustomStorageService,
      HttpService
    ) {
      $scope.iframeLink;
      var form_id = $state.params.form_id;
      var checkLink = function () {
        HttpService.getRequest(
          "api/v1/iframe-form/get-iframe-form/" + form_id,
          {}
        ).then(function (res) {
          console.log(res);

          if (res && res.success && res.result.form_link) {
            var link = res.result.form_link;
            if (!link.startsWith("http://") && !link.startsWith("https://")) {
              link = "https://" + link;
            }
            try {
              $scope.iframeLink = $sce.trustAsResourceUrl(link);
              document.body.style.overflow = "hidden";
              setTimeout(function() {
                document.getElementById("form-iframe").style.height = window.innerHeight - 86 + "px";
                if(res.result.resize_type === 'content_fit') {
                  document.getElementById("form-iframe").style.width = window.innerWidth + "px";
                } else if(res.result.resize_type === 'custom') {
                  document.getElementById("form-iframe").style.width = res.result.dimensions.width + "px";
                  document.getElementById("form-iframe").style.height = res.result.dimensions.height + "px";
                }
              }, 100)
              
            } catch (error) {
              console.log('error -frame')
              console.log(error)
            }
            
          } else {
            // window.location.href = "/landing"
          }
        });
      };
      checkLink();
    },
  ]);
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('cssController', MainController);

  function MainController($scope,$rootScope,$state,$http,landingService,CustomStorageService,BreadcrumbService) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.institution = {name:"CSS"};
    $scope.moveToDiv = function(){
      $('html, body').animate({
        scrollTop: $(".features-scroll").offset().top
      }, 1000);
    }

    
    onloadFunction(
    {'url': '/css-test-preparation',
    'displayName':'CSS & PMS', 
    },'LEAF'
    );

    $scope.cssbuy = function(){
      landingService.buyBundle("CSS-COMPULSORY")
      .then(function(data) {
        if(data) {
          $scope.bundleData = data;
          if($rootScope.orderEmailVerify && !$rootScope.orderEmailVerified) {
            $scope.$emit('verify-before-order');
          } else {
            $scope.$broadcast('salesPopup');
          }
        }
      });
    }
$scope.isGuest = false;
$scope.userData = CustomStorageService.getUserInfoStorageData();
if($scope.userData.user_type === "guest" || $scope.userData.full_name === "Guest"){
$scope.isGuest = true;
}else{
$scope.isGuest = false;


}

    $scope.stories = [{
      name:'Awais Tariq',
      qualification :"MDCAT 2018",
      description : "Nearpeer is a blessing for me. Topic wise lectures which are purely conceptual followed by quizzes. If I had not purchased them, I would have regretted later. Biology Teacher is awesome! It seems like he is teaching me at my home face to face."
    }, {
      name:'Ramshah Mushtaq',
      qualification :"MDCAT 2018",
      description : "I am a repeater. I attended academies twice last year but always realized I wasted my time and money. I had no time left for self-study. Travelling was extremely hectic too. But with Nearpeer, I took control of my learning. I can study at the comfort of my home and concentrate on what actually matters. I truly recommend everyone MDCAT aspirant to give it a try."
    }, {
      name:'Zainab Khan',
      qualification :"MDCAT 2018",
      description : "Nearpeer MDCAT Online is a totally different experience. Like I am lying on my bed right now, eating burger and literally enjoying my lectures on the laptop. Very Comfortable and the best part is I can stop lecture anytime and take rest and then resume It anytime too!"
    }, {
      name:'Muhammad Salman Tariq',
      qualification :"MDCAT 2018",
      description : "I was always a shy student in academy. Students like me never used to ask questions in class because of shyness but now with Online classroom groups on Nearpeer, I can ask any question Alhamdulillah without any fear. I like how I quickly get my answers even if I post my question at 11pm in the night."
    }];


    $scope.cssInstructor = [{
      name:'Awaid Irshad',
      image:'images/css-instructor/awaid.jpg',
      qualification :"1st in CSS 2017 Pakistan | Cambridge University",
      description : "My name is Muhammad Awaid Irshad and I am the CSS Topper of 2017. I graduated from Cambridge University in MPhil Development Studies and BSc Economics from Utrecht University Netherlands and UC Berkeley, California. In teaching the CSS exam, I shall share the exam-taking techniques, the key to targetted preparation and above all analytical content catered to the CSS questions. Hope you all make use of this opportunity. Best of luck in your future endeavours!"
    },
    {
      name:'Abrar Ahmed ',
      image:'images/css-instructor/abrar.jpg',
      qualification :"Political Science Topper | UET",
      description : "Abrar Ahmed belongs to the erstwhile Pakistan Administrative Service (PAS)- 46th Common. He is also a public intellectual, an academic and a political commentator and contributed to The Nation, Dunya (English) and The Diplomat International."
    },
    {
      name:'Muhammad Murtaza',
      image:'images/css-instructor/murtaza.jpg',
      qualification :"3rd in CSS 2017 | LUMS",
      description :"Before he came 3rd in CSS 2017, Mohammad Murtaza was an educationist focusing on innovative methods to teach. His classes make you think and his students have become success stories wherever they go due to his focus on making memorization fun and critical analysis astute"
    },
    {
      name:'Michelle Naeem',
      image:'images/css-instructor/michelle.jpg',
      qualification :"Lums",
      description :"General Science and Ability - the subject we all love to hate. It's endless syllabus and wide aray of topics has us scratching our heads through the night. If there is someone who can make this easy for you, it's Michelle Naeem. Her innovative approach to teaching and witty demeanor will gaurantee success for all her students."
    },
    {
      name:'Talal Shah',
      image:'images/css-instructor/sir Talal _-min.jpg',
      qualification :"Masters Degree in International Relations | Topper of Ilaw in 2019 CSS Exam  ",
      description :"Assistant Superintendent of Police at Police Service of Pakistan - Lahore School of Economics Graduate - Worked As Assistant Director at State Bank of Pakistan"
    },
    {
      name:'Hamza Abbas',
      image:'images/css-instructor/Humza-min.jpg',
      qualification :"13th Position in CSS 2019 | Former WWF- Pakistan Member",
      description :"Experienced environmentalist with a demonstrated history of working in the non-profit organization management industry. Skilled in Public Speaking, Proposal Writing, Team Leadership, B2B Marketing, and Applied Research.Strong administrative professional with a Bachelor's degree focused in Environmental/Environmental Health Engineering from University of Engineering and Technology, Lahore. "
    },
    {
      name:'Mubashar Iqbal',
      image:'images/css-instructor/Mubashir_-min.jpg',
      qualification :"Chartered Accountant ",
      description :"I am a Chartered Accountant with an experience of around 6 years in Corporate Sector & Audit Firms. I got inducted into the Government of Pakistan through CSS Examination in 2017. For the last two years, I have been working for the Government of Pakistan and currently serving in the Ministry of Finance in the Corporate Finance Wing and as a Special Assistant to Special Secretary Finance. "
    },
    {
      name:'Zohaib Ahmed Anjum',
      image:'images/css-instructor/zohaib-min.jpg',
      qualification :"UET",
      description :"An officer of Pakistan Administrative Services (PAS), Mr. Zohaib Ahmed Anjum hails from 46th common civil service of Pakistan. Back in 2017, he appeared in competitive examination and joined civil service as an assistant commissioner.Being holder of an outstanding academic trajectory, he graduated from University of Engineering and Technology, Lahore with a degree in Architectural Engineering and Design. "
    },
    {
      name:'Daud Saleemi',
      image:'images/css-instructor/sir Daud -min.jpg',
      qualification :"2nd Position in Pakistan in CSS 2019",
      description :"Enthusiastic and self-motivated Computer Science graduate, with a keen interest in Project & People Management, Public Speaking and Community Work.I analyze and prepare the Big Data for the Modeling of Artificial Intelligence and Machine Learning Algorithms to achieve Business Objectives.My current portfolio at Afiniti-TRG includes Fortune 500 Companies like AT&T Inc."
    },
    // {
    //   name:'Umair Mehboob',
    //   image:'images/css-instructor/sir Daud -min.jpg',
    //   qualification :"FSc in Pre Engineering from Fazaia Inter College, Sargodha",
    //   description :"BSc Electrical engineering from UET Taxila.Served as Assistant Director in Pakistan Railway for 5 year"
    // },

  ];


    $scope.csslearningslider = [
      {
        name:'Engaging Video Lectures',
        image:'images/learn1.jpg',
        description : "The core of your CSS preparation depends on your course coverage and concepts building. Prepared by some of the best-handpicked faculty (Comprising of toppers), our lectures make sure that each topic is covered in depth so that you learn effectively and confidently. You can pause, repeat, and revise lectures as many times as you want."
    },
    {
      name:'The faculty of toppers',
      image:'images/Core-2.png',
      description : "Our amazing faculty of young CSS officers makes sure it passes on its experiences with you at every stage so that you don’t feel alone in this difficult journey. You’ll be given access to our teachers 24/7."
    },
    {
      name:'Online Classroom Groups',
      image:'images/Core-2.png',
      description : "Scared? Confused? Tensed? Worry no more! We’ve a solution for you. Stay connected to your teachers and other fellows 24/7 via our online classroom groups. Ask question even at 1am in the night and you’ll get your answers."
    }
    ];



    $scope.cssfaqs = [
    {
      question : "What is Nearpeer Online CSS Program?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Nearpeer CSS Program brings you the online courses that you can access through our website. You can watch our video lectures, talk to instructors, send assignments and get them back with feedback. These video lectures will be available to you 24/7. These courses are designed by the best faculty members of CSS who were toppers of their batch. Their experiences, struggles, and rise to prestige are all recorded in these courses. Do enrol now and start studying.&nbsp;</span></p>'
    },
    {
      question : "What will be class timings?",
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Our online courses are in form of video courses that you may access whenever you want, wherever you want. You can study in your office, at home, or while travelling. Meaning, these are not LIVE classes. Therefore, there is no restricted timing of the course. You can enrol whenever you want without fear of anything being missed out. After enrolling, you can study at you own pace. Nearpeer puts back control of your learning in your hands.&nbsp;</span></p>'
    },
    {
      question : 'Can I get my essays and other material checked?',
      answer : '<p style="direction: ltr;"><span style="font-size: 12.0pt;color: black;">Yes you can. Once you enrol, our instructors shall entertain your written pieces. They’ll check your essays or any other material and return it back to you with detailed feedback. So now you don’t have to worry about how you can stay in touch with your instructors. Nearpeer makes sure you two are always connected digitally.&nbsp;</span></p>'
    }
  ];






    $scope.videos = [{
      src: '5j_ae7PlOwk',
      id: 'video1',
      poster :'/images/Governance.png',
      viewMore:{institutionName: 'css',schoolName: 'css-online-preparation',courseName:'governance-and-public-policies',moduleNo:1}
    }, {
      src: 'hiRHUInIozs',
      id: 'video2',
      poster :'/images/Pakistan-Affairs.png',
      viewMore:{institutionName: 'css',schoolName: 'css-online-preparation',courseName:'pakistan-affairs',moduleNo:1}
    }, {
      src: 'sMynNmwqGHo',
      id: 'video3',
      poster :'/images/Islamic-Studies.png',
      viewMore:{institutionName: 'css',schoolName: 'css-online-preparation',courseName:'islamic-studies',moduleNo:1}
    },{
      src: 'bYBQMgXfFpI',
      id: 'video5',
      poster :'/images/Current-Affairs.png',
      viewMore:{institutionName: 'css',schoolName: 'css-online-preparation',courseName:'islamic-studies',moduleNo:1}
    }];
    $scope.direction = 'left';
    $scope.currentIndex = 0;
    $scope.setCurrentSlideIndex = function (index) {
      $scope.direction = (index > $scope.currentIndex) ? 'left' : 'right';
      $scope.currentIndex = index;
    };
    $scope.isCurrentSlideIndex = function (index) {
      return $scope.currentIndex === index;
    };
    $scope.prevSlide = function () {
      $scope.direction = 'left';
      $scope.currentIndex = ($scope.currentIndex < $scope.videos.length - 1) ? ++$scope.currentIndex : 0;
    };
    $scope.nextSlide = function () {
      $scope.direction = 'right';
      $scope.currentIndex = ($scope.currentIndex > 0) ? --$scope.currentIndex : $scope.videos.length - 1;
    };

    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
       setTimeout(function(){
          mixpanel.track('CSS-Landing-Page', {
          'Niche_Name' : $scope.institution.name,
          'Institutions' : $scope.institution.name,
        });
        },5000)                                          
      }
  }
})();

(function () {
  "use strict";

  angular
    .module("NearPeer")
    .controller("completerProfileController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $base64,
    $timeout,
    $state,
    BlogBackendServices,
    env,
    CustomStorageService,
    HttpService,
    $location
  ) {
    $scope.test;
    $scope.userData;
    $scope.tab_navigation = true;
    $scope.thankyou_tab = false;
    $scope.complete_profile = false;
    $scope.name_tab = false;
    $scope.profile_tab = false;
    $scope.city_tab = false;
    $scope.otherCity = '' ;
    $scope.otherCityDefault = '';
    $scope.otherUni = '' ;
    $scope.otherUniDefault = '';
    $scope.defaultField = true;
    $scope.education_tab = false;
    $scope.gender_tab = false;
    $scope.birthday_tab = false;
    $scope.otp_tab = false;
    $scope.otpSent_tab = false;
    $scope.otpWrong_tab = false;
    $scope.welcome_popup = false;
    $scope.journey_tab = false;
    $scope.guardian_tab = false;
    $scope.profile_completed = false;
    $scope.verify_otp_tab = false;
    $scope.loader = false;
    $scope.loading = false;
    $scope.imgUploaded = false;
    $scope.userID = "";
    $scope.userEmail = null;
    $scope.userPhone = null;
    $scope.userName = null;
    $scope.userImage = null;
    $scope.userJourney = null;
    $scope.userInstitute = null;
    $scope.userGender = null;
    $scope.phoneVerified = false;
    $scope.emailVerified = false;
    $scope.noti_reset = false;
    $scope.uploadedImgLink = "";
    $scope.isImgUploaded = "";
    $scope.uploadPercentage = "";
    $scope.userCity = "";
    $scope.userGender = "";
    $scope.userDob = {
      userDay: "",
      userMonth: "",
      userYear: "",
    };
    $scope.otpDigits = null;
    $scope.backBtn = true;
    $scope.profileCityList = false;
    $scope.phoneChoosen = false;
    $scope.showEmailError = false;
    $scope.missingCity = "";
    $scope.customCity = "";
    $scope.customUni = "";
    $scope.guardian_phone = ""
$scope.showJourneyList = true;
    var selectRefere = "";
    $scope.digit1 = "";
    $scope.digit2 = "";
    $scope.digit3 = "";
    $scope.digit4 = "";
    $scope.digit5 = "";
    $scope.digit6 = "";
    $scope.steps = [
      false, //name
      false, //profile
      false, //city
      false, //education
      false, //gender
      false, //Birthday
      false, //Journey
      false, //OTP
      false, //send otp
      false, //wrong otp
    ];
    $scope.journeyArray = [
      { id: 0, name: "Choose your Journey" },
      { id: 1, name: "Social Media (Facebook)" },
      { id: 2, name: "Social Media (Instagram)" },
      { id: 3, name: "Social Media (Linkedin)" },
      { id: 4, name: "YouTube Channel" },
      { id: 5, name: "Google Search" },
      { id: 6, name: "Through a friend/family" },
      { id: 7, name: "Saw an ad in Newspaper" },
      { id: 8, name: "Through School" },
      { id: 9, name: "Other" },
    ];
    $scope.baseCities = [
      { id: 1, name: "Abbottabad" },
      { id: 2, name: "Adezai" },
      { id: 3, name: "Ali Bandar" },
      { id: 4, name: "Amir Chah" },
      { id: 5, name: "Attock" },
      { id: 6, name: "Ayubia" },
      { id: 7, name: "Bahawalpur" },
      { id: 8, name: "Baden" },
      { id: 9, name: "Bagh" },
      { id: 10, name: "Bahawalnagar" },
      { id: 11, name: "Burewala" },
      { id: 12, name: "Banda Daud Shah" },
      { id: 13, name: "Bannu district|Bannu" },
      { id: 14, name: "Batagram" },
      { id: 15, name: "Bazdar" },
      { id: 16, name: "Bela" },
      { id: 17, name: "Bellpat" },
      { id: 18, name: "Bhag" },
      { id: 19, name: "Bhakkar" },
      { id: 20, name: "Bhalwal" },
      { id: 21, name: "Bhimber" },
      { id: 22, name: "Birote" },
      { id: 23, name: "Buner" },
      { id: 24, name: "Burj" },
      { id: 25, name: "Chiniot" },
      { id: 26, name: "Chachro" },
      { id: 27, name: "Chagai" },
      { id: 28, name: "Chah Sandan" },
      { id: 29, name: "Chailianwala" },
      { id: 30, name: "Chakdara" },
      { id: 31, name: "Chakku" },
      { id: 32, name: "Chakwal" },
      { id: 33, name: "Chaman" },
      { id: 34, name: "Charsadda" },
      { id: 35, name: "Chhatr" },
      { id: 36, name: "Chichawatni" },
      { id: 37, name: "Chitral" },
      { id: 38, name: "Dadu" },
      { id: 39, name: "Dera Ghazi Khan" },
      { id: 40, name: "Dera Ismail Khan" },
      { id: 41, name: "Dalbandin" },
      { id: 42, name: "Dargai" },
      { id: 43, name: "Darya Khan" },
      { id: 44, name: "Daska" },
      { id: 45, name: "Dera Bugti" },
      { id: 46, name: "Dhana Sar" },
      { id: 47, name: "Digri" },
      { id: 48, name: "Dina City|Dina" },
      { id: 49, name: "Dinga" },
      { id: 50, name: "Pakistan|Diplo" },
      { id: 51, name: "Diwana" },
      { id: 52, name: "Dokri" },
      { id: 53, name: "Drosh" },
      { id: 54, name: "Duki" },
      { id: 55, name: "Dushi" },
      { id: 56, name: "Duzab" },
      { id: 57, name: "Faisalabad" },
      { id: 58, name: "Fateh Jang" },
      { id: 59, name: "Ghotki" },
      { id: 60, name: "Gwadar" },
      { id: 61, name: "Gujranwala" },
      { id: 62, name: "Gujrat" },
      { id: 63, name: "Gadra" },
      { id: 64, name: "Gajar" },
      { id: 65, name: "Gandava" },
      { id: 66, name: "Garhi Khairo" },
      { id: 67, name: "Garruck" },
      { id: 68, name: "Ghakhar Mandi" },
      { id: 69, name: "Ghanian" },
      { id: 70, name: "Ghauspur" },
      { id: 71, name: "Ghazluna" },
      { id: 72, name: "Girdan" },
      { id: 73, name: "Gulistan" },
      { id: 74, name: "Gwash" },
      { id: 75, name: "Hyderabad" },
      { id: 76, name: "Hala" },
      { id: 77, name: "Haripur" },
      { id: 78, name: "Hab Chauki" },
      { id: 79, name: "Hafizabad" },
      { id: 80, name: "Hameedabad" },
      { id: 81, name: "Hangu" },
      { id: 82, name: "Harnai" },
      { id: 83, name: "Hasilpur" },
      { id: 84, name: "Haveli Lakha" },
      { id: 85, name: "Hinglaj" },
      { id: 86, name: "Hoshab" },
      { id: 87, name: "Islamabad" },
      { id: 88, name: "Islamkot" },
      { id: 89, name: "Ispikan" },
      { id: 90, name: "Jacobabad" },
      { id: 91, name: "Jamshoro" },
      { id: 92, name: "Jhang" },
      { id: 93, name: "Jhelum" },
      { id: 94, name: "Jamesabad" },
      { id: 95, name: "Jampur" },
      { id: 96, name: "Janghar" },
      { id: 97, name: "Jati(Mughalbhin)" },
      { id: 98, name: "Jauharabad" },
      { id: 99, name: "Jhal" },
      { id: 100, name: "Jhal Jhao" },
      { id: 101, name: "Jhatpat" },
      { id: 102, name: "Jhudo" },
      { id: 103, name: "Jiwani" },
      { id: 104, name: "Jungshahi" },
      { id: 105, name: "Karachi" },
      { id: 106, name: "Kotri" },
      { id: 107, name: "Kalam" },
      { id: 108, name: "Kalandi" },
      { id: 109, name: "Kalat" },
      { id: 110, name: "Kamalia" },
      { id: 111, name: "Kamararod" },
      { id: 112, name: "Kamber" },
      { id: 113, name: "Kamokey" },
      { id: 114, name: "Kanak" },
      { id: 115, name: "Kandi" },
      { id: 116, name: "Kandiaro" },
      { id: 117, name: "Kanpur" },
      { id: 118, name: "Kapip" },
      { id: 119, name: "Kappar" },
      { id: 120, name: "Karak City" },
      { id: 121, name: "Karodi" },
      { id: 122, name: "Kashmor" },
      { id: 123, name: "Kasur" },
      { id: 124, name: "Katuri" },
      { id: 125, name: "Keti Bandar" },
      { id: 126, name: "Khairpur" },
      { id: 127, name: "Khanaspur" },
      { id: 128, name: "Khanewal" },
      { id: 129, name: "Kharan" },
      { id: 130, name: "kharian" },
      { id: 131, name: "Khokhropur" },
      { id: 132, name: "Khora" },
      { id: 133, name: "Khushab" },
      { id: 134, name: "Khuzdar" },
      { id: 135, name: "Kikki" },
      { id: 136, name: "Klupro" },
      { id: 137, name: "Kohan" },
      { id: 138, name: "Kohat" },
      { id: 139, name: "Kohistan" },
      { id: 140, name: "Kohlu" },
      { id: 141, name: "Korak" },
      { id: 142, name: "Korangi" },
      { id: 143, name: "Kot Sarae" },
      { id: 144, name: "Kotli" },
      { id: 145, name: "Lahore" },
      { id: 146, name: "Larkana" },
      { id: 147, name: "Lahri" },
      { id: 148, name: "Lakki Marwat" },
      { id: 149, name: "Lasbela" },
      { id: 150, name: "Latamber" },
      { id: 151, name: "Layyah" },
      { id: 152, name: "Leiah" },
      { id: 153, name: "Liari" },
      { id: 154, name: "Lodhran" },
      { id: 155, name: "Loralai" },
      { id: 156, name: "Lower Dir" },
      { id: 157, name: "Shadan Lund" },
      { id: 158, name: "Multan" },
      { id: 159, name: "Mandi Bahauddin" },
      { id: 160, name: "Mansehra" },
      { id: 161, name: "Mian Chanu" },
      { id: 162, name: "Mirpur" },
      { id: 163, name: "}, Pakistan|Moro" },
      { id: 164, name: "Mardan" },
      { id: 165, name: "Mach" },
      { id: 166, name: "Madyan" },
      { id: 167, name: "Malakand" },
      { id: 168, name: "Mand" },
      { id: 169, name: "Manguchar" },
      { id: 170, name: "Mashki Chah" },
      { id: 171, name: "Maslti" },
      { id: 172, name: "Mastuj" },
      { id: 173, name: "Mastung" },
      { id: 174, name: "Mathi" },
      { id: 175, name: "Matiari" },
      { id: 176, name: "Mehar" },
      { id: 177, name: "Mekhtar" },
      { id: 178, name: "Merui" },
      { id: 179, name: "Mianwali" },
      { id: 180, name: "Mianez" },
      { id: 181, name: "Mirpur Batoro" },
      { id: 182, name: "Mirpur Khas" },
      { id: 183, name: "Mirpur Sakro" },
      { id: 184, name: "Mithi" },
      { id: 185, name: "Mongora" },
      { id: 186, name: "Murgha Kibzai" },
      { id: 187, name: "Muridke" },
      { id: 188, name: "Musa Khel Bazar" },
      { id: 189, name: "Muzaffar Garh" },
      { id: 190, name: "Muzaffarabad" },
      { id: 191, name: "Nawabshah" },
      { id: 192, name: "Nazimabad" },
      { id: 193, name: "Nowshera" },
      { id: 194, name: "Nagar Parkar" },
      { id: 195, name: "Nagha Kalat" },
      { id: 196, name: "Nal" },
      { id: 197, name: "Naokot" },
      { id: 198, name: "Nasirabad" },
      { id: 199, name: "Nauroz Kalat" },
      { id: 200, name: "Naushara" },
      { id: 201, name: "Nur Gamma" },
      { id: 202, name: "Nushki" },
      { id: 203, name: "Nuttal" },
      { id: 204, name: "Okara" },
      { id: 205, name: "Ormara" },
      { id: 206, name: "Peshawar" },
      { id: 207, name: "Panjgur" },
      { id: 208, name: "Pasni City" },
      { id: 209, name: "Paharpur" },
      { id: 210, name: "Palantuk" },
      { id: 211, name: "Pendoo" },
      { id: 212, name: "Piharak" },
      { id: 213, name: "Pirmahal" },
      { id: 214, name: "Pishin" },
      { id: 215, name: "Plandri" },
      { id: 216, name: "Pokran" },
      { id: 217, name: "Pounch" },
      { id: 218, name: "Quetta" },
      { id: 219, name: "Qambar" },
      { id: 220, name: "Qamruddin Karez" },
      { id: 221, name: "Qazi Ahmad" },
      { id: 222, name: "Qila Abdullah" },
      { id: 223, name: "Qila Ladgasht" },
      { id: 224, name: "Qila Safed" },
      { id: 225, name: "Qila Saifullah" },
      { id: 226, name: "Rawalpindi" },
      { id: 227, name: "Rabwah" },
      { id: 228, name: "Rahim Yar Khan" },
      { id: 229, name: "Rajan Pur" },
      { id: 230, name: "Rakhni" },
      { id: 231, name: "Ranipur" },
      { id: 232, name: "Ratodero" },
      { id: 233, name: "Rawalakot" },
      { id: 234, name: "Renala Khurd" },
      { id: 235, name: "Robat Thana" },
      { id: 236, name: "Rodkhan" },
      { id: 237, name: "Rohri" },
      { id: 238, name: "Sialkot" },
      { id: 239, name: "Sadiqabad" },
      { id: 240, name: "Safdar Abad- (Dhaban Singh)" },
      { id: 241, name: "Sahiwal" },
      { id: 242, name: "Saidu Sharif" },
      { id: 243, name: "Saindak" },
      { id: 244, name: "Sakrand" },
      { id: 245, name: "Sanjawi" },
      { id: 246, name: "Sargodha" },
      { id: 247, name: "Saruna" },
      { id: 248, name: "Shabaz Kalat" },
      { id: 249, name: "Shadadkhot" },
      { id: 250, name: "Shahbandar" },
      { id: 251, name: "Shahpur" },
      { id: 252, name: "Shahpur Chakar" },
      { id: 253, name: "Shakargarh" },
      { id: 254, name: "Shangla" },
      { id: 255, name: "Sharam Jogizai" },
      { id: 256, name: "Sheikhupura" },
      { id: 257, name: "Shikarpur" },
      { id: 258, name: "Shingar" },
      { id: 259, name: "Shorap" },
      { id: 260, name: "Sibi" },
      { id: 261, name: "Sohawa" },
      { id: 262, name: "Sonmiani" },
      { id: 263, name: "Sooianwala" },
      { id: 264, name: "Spezand" },
      { id: 265, name: "Spintangi" },
      { id: 266, name: "Sui" },
      { id: 267, name: "Sujawal" },
      { id: 268, name: "Sukkur" },
      { id: 269, name: "Suntsar" },
      { id: 270, name: "Surab" },
      { id: 271, name: "Swabi" },
      { id: 272, name: "Swat" },
      { id: 273, name: "Tando Adam" },
      { id: 274, name: "Tando Bago" },
      { id: 275, name: "Tangi" },
      { id: 276, name: "Tank City" },
      { id: 277, name: "Tar Ahamd Rind" },
      { id: 278, name: "Thalo" },
      { id: 279, name: "Thatta" },
      { id: 280, name: "Toba Tek Singh" },
      { id: 281, name: "Tordher" },
      { id: 282, name: "Tujal" },
      { id: 283, name: "Tump" },
      { id: 284, name: "Turbat" },
      { id: 285, name: "Umarao" },
      { id: 286, name: "Umarkot" },
      { id: 287, name: "Upper Dir" },
      { id: 288, name: "Uthal" },
      { id: 289, name: "Vehari" },
      { id: 290, name: "Veirwaro" },
      { id: 291, name: "Vitakri" },
      { id: 292, name: "Wadh" },
      { id: 293, name: "Wah Cantt" },
      { id: 294, name: "Warah" },
      { id: 295, name: "Washap" },
      { id: 296, name: "Wasjuk" },
      { id: 297, name: "Wazirabad" },
      { id: 298, name: "Yakmach" },
      { id: 299, name: "Zhob" },
      { id: 300, name: "Other" },
    ];
  
    $scope.baseInstitutes = [
      {
        id: 1,
        name: "ABBOTTABAD PUBLIC SCHOOL",
      },
      {
        id: 2,
        name: "Abbottabad University of Science and Technology",
      },
      {
        id: 3,
        name: "Abdul Wali Khan University Mardan",
      },
      {
        id: 4,
        name: "Aga Khan University",
      },
      {
        id: 5,
        name: "Air University",
      },
      {
        id: 6,
        name: "AIMS School Systems",
      },
      {
        id: 7,
        name: "AITCHISON COLLEGE",
      },
      {
        id: 8,
        name: "Al-Hamd Islamic University",
      },
      {
        id: 9,
        name: "Ali Institute of Education",
      },
      {
        id: 10,
        name: "Allied Scool",
      },
      {
        id: 11,
        name: "American Lyceum",
      },
      {
        id: 12,
        name: "Army Public Schools",
      },
      {
        id: 13,
        name: "Bacha Khan University",
      },
      {
        id: 14,
        name: "Bahauddin Zakariya University",
      },
      {
        id: 15,
        name: "BAHRIA COLLEGE",
      },
      {
        id: 16,
        name: "Bahria University",
      },
      {
        id: 17,
        name: "Balochistan University of Engineering and Technology",
      },
      {
        id: 18,
        name: "Balochistan University of Information Technology, Engineering and Management Sciences",
      },
      {
        id: 19,
        name: "Baqai Medical University",
      },
      {
        id: 20,
        name: "Beaconhouse National University",
      },
      {
        id: 21,
        name: "Beaconhouse School System",
      },
      {
        id: 22,
        name: "Benazir Bhutto Shaheed University Lyari",
      },
      {
        id: 23,
        name: "Benazir Bhutto Shaheed University of Technology and Skill Development",
      },
      {
        id: 24,
        name: "Bloomfield Hall School",
      },
      {
        id: 25,
        name: "Bolan University of Medical and Health Sciences",
      },
      {
        id: 26,
        name: "BURNHALL SCHOOL",
      },
      {
        id: 27,
        name: "CADET COLLEGE HASSAN ABDAL",
      },
      {
        id: 28,
        name: "Capital University of Science and Technology",
      },
      {
        id: 29,
        name: "CECOS University",
      },
      {
        id: 30,
        name: "Central Model High School",
      },
      {
        id: 31,
        name: "CHAND BAGH SCHOOL",
      },
      {
        id: 32,
        name: "City University of Science and Information Technology",
      },
      {
        id: 33,
        name: "Commecs Institute of Business and Emerging Sciences",
      },
      {
        id: 34,
        name: "COMSATS Institute of Information Technology",
      },
      {
        id: 35,
        name: "CONVENT SCHOOL",
      },
      {
        id: 36,
        name: "CRESCENT MODEL SCHOOL",
      },
      {
        id: 37,
        name: "Dadabhoy Institute of Higher Education",
      },
      {
        id: 38,
        name: "Dar-e-Arqam Schools",
      },
      {
        id: 39,
        name: "Dawood University of Engineering and Technology",
      },
      {
        id: 40,
        name: "Divisional Public School",
      },
      {
        id: 41,
        name: "DHA Suffa University",
      },
      {
        id: 42,
        name: "DOW University of Health Sciences",
      },
      {
        id: 43,
        name: "FATA University",
      },
      {
        id: 44,
        name: "Fatima Jinnah Medical University",
      },
      {
        id: 45,
        name: "Fatima Jinnah Women University",
      },
      {
        id: 46,
        name: "Federal Urdu University of Arts, Sciences and Technology",
      },
      {
        id: 47,
        name: "Forman Christian College",
      },
      {
        id: 48,
        name: "Foundation University Islamabad",
      },
      {
        id: 49,
        name: "Gambat Institute of Medical Sciences",
      },
      {
        id: 50,
        name: "Gandhara University",
      },
      {
        id: 51,
        name: "Ghazi University",
      },
      {
        id: 52,
        name: "Ghulam Ishaq Khan Institute of Engineering Sciences and Technology",
      },
      {
        id: 53,
        name: "GIFT University",
      },
      {
        id: 54,
        name: "Gomal University",
      },
      {
        id: 55,
        name: "Government College for Women University, Sialkot",
      },
      {
        id: 56,
        name: "Government College University, Faisalabad",
      },
      {
        id: 57,
        name: "Government College University, Lahore",
      },
      {
        id: 58,
        name: "Government College Women University, Faisalabad",
      },
      {
        id: 59,
        name: "Greenwich University",
      },
      {
        id: 60,
        name: "HABIB PUBLIC SCHOOL",
      },
      {
        id: 61,
        name: "Habib University",
      },
      {
        id: 62,
        name: "Hajvery University",
      },
      {
        id: 63,
        name: "Hamdard University",
      },
      {
        id: 64,
        name: "Hazara University",
      },
      {
        id: 65,
        name: "HITEC University",
      },
      {
        id: 66,
        name: "Ilma University",
      },
      {
        id: 67,
        name: "Imperial College of Business Studies",
      },
      {
        id: 68,
        name: "Indus University, Pakistan",
      },
      {
        id: 69,
        name: "Indus Valley School of Art and Architecture",
      },
      {
        id: 70,
        name: "Information Technology University",
      },
      {
        id: 71,
        name: "Institute of Business Administration",
      },
      {
        id: 72,
        name: "Institute of Business Management",
      },
      {
        id: 73,
        name: "Institute of Management Sciences",
      },
      {
        id: 74,
        name: "Institute of Southern Punjab",
      },
      {
        id: 75,
        name: "Institute of Space Technology",
      },
      {
        id: 76,
        name: "International Islamic University, Islamabad",
      },
      {
        id: 77,
        name: "International Islamic University Islamabad Schools",
      },
      {
        id: 78,
        name: "INTERNATIONAL SCHOOL OF CHOUEIFAT",
      },
      {
        id: 79,
        name: "Iqra National University",
      },
      {
        id: 80,
        name: "Iqra University",
      },
      {
        id: 81,
        name: "Islamia College Peshawar",
      },
      {
        id: 82,
        name: "Isra University",
      },
      {
        id: 83,
        name: "Jinnah Sindh Medical University",
      },
      {
        id: 84,
        name: "Jinnah University for Women",
      },
      {
        id: 85,
        name: "Karachi Institute of Economics and Technology",
      },
      {
        id: 86,
        name: "Karachi Grammar School",
      },
      {
        id: 87,
        name: "Karachi School for Business and Leadership",
      },
      {
        id: 88,
        name: "Karakurum International University",
      },
      {
        id: 89,
        name: "KASB Institute of Technology",
      },
      {
        id: 90,
        name: "Khushal Khan Khattak University",
      },
      {
        id: 91,
        name: "Khwaja Fareed University of Engineering and Information Technology",
      },
      {
        id: 92,
        name: "Khyber Medical University",
      },
      {
        id: 93,
        name: "King Edward Medical University",
      },
      {
        id: 94,
        name: "Kinnaird College for Women",
      },
      {
        id: 95,
        name: "Kohat University of Science and Technology",
      },
      {
        id: 96,
        name: "LAHORE AMERICAN SCHOOL",
      },
      {
        id: 97,
        name: "Lahore College for Women University",
      },
      {
        id: 98,
        name: "Lahore Garrison University",
      },
      {
        id: 99,
        name: "Lahore Grammar Schools",
      },
      {
        id: 100,
        name: "Lahore Leads University",
      },
      {
        id: 101,
        name: "Lahore School of Economics",
      },
      {
        id: 102,
        name: "Lahore University of Management Sciences",
      },
      {
        id: 103,
        name: "Lasbela University of Agriculture, Water and Marine Sciences",
      },
      {
        id: 104,
        name: "Leeds Grammar School",
      },
      {
        id: 105,
        name: "Liaquat University of Medical and Health Sciences",
      },
      {
        id: 106,
        name: "Mehran University of Engineering and Technology",
      },
      {
        id: 107,
        name: "Minhaj University",
      },
      {
        id: 108,
        name: "Mirpur University of Science and Technology",
      },
      {
        id: 109,
        name: "Mohammad Ali Jinnah University",
      },
      {
        id: 110,
        name: "Mohi-ud-Din Islamic University",
      },
      {
        id: 111,
        name: "Muhammad Nawaz Shareef University of Agriculture, Multan",
      },
      {
        id: 112,
        name: "Muhammad Nawaz Sharif University of Engineering and Technology",
      },
      {
        id: 113,
        name: "Muslim Youth University",
      },
      {
        id: 114,
        name: "National College of Arts",
      },
      {
        id: 115,
        name: "National College of Business Administration and Economics",
      },
      {
        id: 116,
        name: "National Defence University",
      },
      {
        id: 117,
        name: "National Textile University",
      },
      {
        id: 118,
        name: "National University of Computer and Emerging Sciences",
      },
      {
        id: 119,
        name: "National University of Medical Sciences",
      },
      {
        id: 120,
        name: "National University of Modern Languages",
      },
      {
        id: 121,
        name: "National University of Sciences and Technology",
      },
      {
        id: 122,
        name: "National University of Technology",
      },
      {
        id: 123,
        name: "Nazeer Hussain University",
      },
      {
        id: 124,
        name: "NED University of Engineering and Technology",
      },
      {
        id: 125,
        name: "Newports Institute of Communications and Economics",
      },
      {
        id: 126,
        name: "NFC Institute of Engineering and Technology",
      },
      {
        id: 127,
        name: "Northern University",
      },
      {
        id: 128,
        name: "Nur International University",
      },
      {
        id: 129,
        name: "Pakistan Institute of Development Economics",
      },
      {
        id: 130,
        name: "Pakistan Institute of Engineering and Applied Sciences",
      },
      {
        id: 131,
        name: "Pakistan Institute of Fashion and Design",
      },
      {
        id: 132,
        name: "Pak-Turk International school",
      },
      {
        id: 133,
        name: "Peoples University of Medical and Health Sciences for Women",
      },
      {
        id: 134,
        name: "Pir Mehr Ali Shah Arid Agriculture University",
      },
      {
        id: 135,
        name: "Preston University",
      },
      {
        id: 136,
        name: "Punjab Group of Colleges",
      },
      {
        id: 137,
        name: "Qarshi University",
      },
      {
        id: 138,
        name: "Quaid-e-Awam University of Engineering, Science and Technology",
      },
      {
        id: 139,
        name: "Quaid-i-Azam University",
      },
      {
        id: 140,
        name: "Qurtaba University",
      },
      {
        id: 141,
        name: "Rawalpindi Medical University",
      },
      {
        id: 142,
        name: "Riphah International University",
      },
      {
        id: 143,
        name: "Roots Millennium School",
      },
      {
        id: 144,
        name: "Sadiq Public School",
      },
      {
        id: 145,
        name: "Salim Habib University",
      },
      {
        id: 146,
        name: "Sardar Bahadur Khan Women's University",
      },
      {
        id: 147,
        name: "Sarhad University of Science and Information Technology",
      },
      {
        id: 148,
        name: "Shah Abdul Latif University",
      },
      {
        id: 149,
        name: "Shaheed Benazir Bhutto City University",
      },
      {
        id: 150,
        name: "Shaheed Benazir Bhutto University",
      },
      {
        id: 151,
        name: "Shaheed Benazir Bhutto University of Veterinary and Animal Sciences",
      },
      {
        id: 152,
        name: "Shaheed Benazir Bhutto University Shaheed Benazirabad",
      },
      {
        id: 153,
        name: "Shaheed Benazir Bhutto Women University",
      },
      {
        id: 154,
        name: "Shaheed Mohtarma Benazir Bhutto Medical University",
      },
      {
        id: 155,
        name: "Shaheed Zulfiqar Ali Bhutto Institute of Science and Technology",
      },
      {
        id: 156,
        name: "Shaheed Zulfiqar Ali Bhutto Medical University",
      },
      {
        id: 157,
        name: "Shaheed Zulfiqar Ali Bhutto University of Law",
      },
      {
        id: 158,
        name: "Shifa Tameer-e-Millat University",
      },
      {
        id: 159,
        name: "Sindh Agriculture University",
      },
      {
        id: 160,
        name: "Sindh Madresatul Islam University",
      },
      {
        id: 161,
        name: "Sir Syed University of Engineering and Technology",
      },
      {
        id: 162,
        name: "Sukkur Institute of Business Administration",
      },
      {
        id: 163,
        name: "Textile Institute of Pakistan",
      },
      {
        id: 164,
        name: "The City Scool",
      },
      {
        id: 165,
        name: "The Government Sadiq College Women University",
      },
      {
        id: 166,
        name: "The Institute of Management Sciences",
      },
      {
        id: 167,
        name: "The Islamia University of Bahawalpur",
      },
      {
        id: 168,
        name: "The Lahore Alma",
      },
      {
        id: 169,
        name: "The Lahore Lyceum",
      },
      {
        id: 170,
        name: "The Multan Alma",
      },
      {
        id: 171,
        name: "THE MAMA PARSI INTERNATIONAL SCHOOL",
      },
      {
        id: 172,
        name: "The Superior College",
      },
      {
        id: 173,
        name: "The University of Agriculture, Peshawar",
      },
      {
        id: 174,
        name: "The University of Faisalabad",
      },
      {
        id: 175,
        name: "The University of Lahore",
      },
      {
        id: 176,
        name: "The Women University Multan",
      },
      {
        id: 177,
        name: "University of Agriculture, Faisalabad",
      },
      {
        id: 178,
        name: "University of Azad Jammu and Kashmirs",
      },
      {
        id: 179,
        name: "University of Balochistan",
      },
      {
        id: 180,
        name: "University of Baltistan, Skardu",
      },
      {
        id: 181,
        name: "University of Central Punjab",
      },
      {
        id: 182,
        name: "University of Chitral",
      },
      {
        id: 183,
        name: "University of Education",
      },
      {
        id: 184,
        name: "University of Engineering and Technology, Lahore",
      },
      {
        id: 185,
        name: "University of Engineering and Technology, Peshawar",
      },
      {
        id: 186,
        name: "University of Engineering and Technology, Taxila",
      },
      {
        id: 187,
        name: "University of Gujrat",
      },
      {
        id: 188,
        name: "University of Haripur",
      },
      {
        id: 189,
        name: "University of Health Sciences, Lahore",
      },
      {
        id: 190,
        name: "University of Karachi",
      },
      {
        id: 191,
        name: "University of Kotli Azad Jammu and Kashmir",
      },
      {
        id: 192,
        name: "University of Loralai",
      },
      {
        id: 193,
        name: "University of Malakand",
      },
      {
        id: 194,
        name: "University of Management and Technology",
      },
      {
        id: 195,
        name: "University of Peshawar",
      },
      {
        id: 196,
        name: "University of Poonch Rawalakot",
      },
      {
        id: 197,
        name: "University of Sargodha",
      },
      {
        id: 198,
        name: "University of Science and Technology, Bannu",
      },
      {
        id: 199,
        name: "University of Sindh",
      },
      {
        id: 200,
        name: "University of South Asia",
      },
      {
        id: 201,
        name: "University of Swabi",
      },
      {
        id: 202,
        name: "University of Swat",
      },
      {
        id: 203,
        name: "University of the Punjab",
      },
      {
        id: 204,
        name: "University of Turbat",
      },
      {
        id: 205,
        name: "University of Veterinary and Animal Sciences",
      },
      {
        id: 206,
        name: "University of Wah",
      },
      {
        id: 207,
        name: "Women University of Azad Jammu and Kashmir Bagh",
      },
      {
        id: 208,
        name: "Women University Swabi",
      },
      {
        id: 209,
        name: "Ziauddin University",
      },
    ];
    $scope.selectedJourney = { value: $scope.journeyArray[0] };
    // console.log($scope.steps,'sssssssssssssssssssssss');
    if (CustomStorageService.getUserInfoStorageData()) {
      $scope.userData = CustomStorageService.getUserInfoStorageData();
 
      // console.log("USER DATA", $scope.userData);
      $scope.userID = $scope.userData.id;
      $scope.userEmail = $scope.userData.email;
      $scope.userPhone = $scope.userData.phone
        ? $scope.userData.phone
        : $scope.userData.uid_phone;
      $scope.editablePhone = $scope.userData.phone
        ? $scope.userData.phone
        : $scope.userData.uid_phone;
        $scope.imgUploaded = $scope.userData.image ? true : false;
        $scope.otherCity = $scope.userData.city;
        $scope.otherCityDefault = $scope.userData.city;
        $scope.otherUni = $scope.userData.university;
        $scope.otherUniDefault = $scope.userData.university;

        $scope.selectedJourney.value.name = $scope.userData.journey != null ? $scope.userData.journey : "Choose your Journey" ;
        $scope.phoneVerified = $scope.userData.phone_confirmed_at ? true : false;
    }
    if (!CustomStorageService.getAuthTokenStorageData() && !$rootScope.platform_reactApp) {
      $scope.goToState("Landing");
    }
    $scope.backTab = function (skip) {
      // console.log("$scope.userJourney");
      // console.log($scope.selectRefere);
      $scope.userJourney = selectRefere;
      // console.log("$scope.userJourney");
      // console.log($scope.userJourney);
      $scope.errorMessage = "";
      if ($scope.profile_tab) {

        $scope.name_tab = true;
        $scope.steps[0] = false;
        $scope.profile_tab = false;
        $scope.backBtn = false;
        if (!skip) {
          $scope.step = 1;
        }
      $state.go("Complete-Profile",{name: 'name'});

      }
      if ($scope.city_tab) {
        $scope.profile_tab = true;
        $scope.city_tab = false;
        $scope.steps[1] = false;
        if (!skip) {
          $scope.step = 2;
        }
      $state.go("Complete-Profile",{name: 'image'});

      }
      if ($scope.education_tab) {
        $scope.city_tab = true;
        $scope.education_tab = false;
        $scope.steps[2] = false;
        if (!skip) {
          $scope.step = 3;
        }
      $state.go("Complete-Profile",{name: 'city'});

      }
      if ($scope.gender_tab) {
        $scope.education_tab = true;
        $scope.gender_tab = false;
        $scope.steps[3] = false;
        if (!skip) {
          $scope.step = 4;
        }
      $state.go("Complete-Profile",{name: 'institute'});

      }
      if ($scope.birthday_tab) {
        $scope.gender_tab = true;
        $scope.birthday_tab = false;
        $scope.steps[4] = false;
        if (!skip) {
          $scope.step = 5;
        }
      $state.go("Complete-Profile",{name: 'gender'});

      }
      if ($scope.journey_tab) {
        $scope.birthday_tab = true;
        $scope.journey_tab = false;
        $scope.steps[5] = false;
        if (!skip) {
          $scope.step = 6;
        }
        $state.go("Complete-Profile",{name: 'dob'});

      }
      if ($scope.guardian_tab) {
        $scope.birthday_tab = true;
        $scope.guardian_tab = false;
        $scope.steps[5] = false;
        if (!skip) {
          $scope.step = 6;
        }
        $state.go("Complete-Profile",{name: 'dob'});

      }
      if ($scope.otp_tab) {
        $scope.journey_tab = true;
        $scope.otp_tab = false;
        $scope.steps[6] = false;
        if (!skip) {
          $scope.step = 7;
        }
        $state.go("Complete-Profile",{name: 'journey'});

      }
      if ($scope.otpSent_tab) {
        $scope.otp_tab = true;
        setTimeout(function () {
          $("#country").countrySelect({
            defaultCountry: "pk",
            preferredCountries: ["pk"],
            localizedCountries: {},
          });
          $(".country-select").css("margin-top", "0px");
        }, 300);
        $scope.otpSent_tab = false;
        $scope.steps[6] = false;
        if (!skip) {
          $scope.step = 7;
        }
      }
      if ($scope.otpWrong_tab) {
        $scope.otpSent_tab = true;
        $scope.otpWrong_tab = false;
        $scope.steps[5] = false;
        addPasteHandler();
      }
      if ($scope.verify_otp_tab) {
        // $scope.otpSent_tab = true;
        $scope.otp_tab = true;
        $scope.verify_otp_tab = false;
        $scope.steps[5] = false;
      }
    };

    $scope.genderType= function(type){
      if(type==='male'){
document.getElementById('gender_male').checked = true;
$scope.RadioChange('Male');
      }else{
        document.getElementById('gender_female').checked = true;
        $scope.RadioChange('Female');

      }

    }
    $scope.person = {};
    $scope.searchEnabled = undefined;
    $scope.cityOther = false;
    $scope.itemArray=[];
    $scope.uniArray=[]; 

    $scope.getAllCities= function (){
      
      HttpService.getRequest("api/v1/common/get-cities").then(function (res) {
      // console.log(res,"CITIES");
      $scope.itemArray= res.cities;
      $scope.selected = { value: $scope.itemArray[0] };

      }
      );
    }
    $scope.getAllCities();

    $scope.getAllInstitutes = function(){
      HttpService.getRequest("api/v1/common/get-institutions").then(function (res) {
        // console.log(res,"INSTITUTES");
        $scope.uniArray = res.institutions;
        $scope.selectedUni = { value: $scope.uniArray[0] };
        }
        );
    }
$scope.getAllInstitutes();



    $scope.searchCities = [];
    $scope.searchUniversities = [];

    $scope.myImage='';
    $scope.myCroppedImage='';
    $scope.showCropped = false;
    $scope.croppedImageName = "";



    $scope.handleFileSelect = function(evt) {
      // console.log("evaaa",evt);
      var file=evt.currentTarget.files[0];
      $scope.croppedImageName = file.name;
      var reader = new FileReader();
      reader.onload = function (evt2) {
        // console.log("in func",evt2);
        $scope.myImage=evt2.target.result;

        $scope.showCropped = true;
        // console.log($scope.myImage,"MY IMAGE");
        $scope.$apply();
        // $scope.$apply(function($scope){
        //   $scope.myImage=evt2.target.result;

        //   $scope.showCropped = true;
        //   console.log($scope.myImage,"MY IMAGE");
        // });
      };
      reader.readAsDataURL(file);
    };
    angular.element(document.querySelector('#fileInput')).on('change',$scope.handleFileSelect);




$scope.closeCustomCrop = function(){
  $scope.showCropped = false;
}
$scope.cityCheck = function (s){
  $scope.showCityList = true;
  $scope.searchCities = [];
  if((s||[]).length > 2){
    $scope.searchCities = $scope.itemArray.filter(function(a){

      return a.name.toLowerCase().includes(s.toLowerCase());
    })
  }else{
    $scope.searchCities = $scope.baseCities.filter(function(a){

      return a.name;
    })
  }



  if(!$scope.searchCities.length){
    if(s !== null){
    $scope.showCityList = false;

    }else{
      // $scope.showCityList = false;

    }
    $scope.notFound = true;
  }else{
    $scope.notFound = false;
  }

}
    $scope.onSelectCity = function(city){
      $scope.defaultField = !$scope.defaultField;

      // console.log(city)
      if(city.id == 404){
      }else{
      $scope.newVar = city.name;
      $scope.otherCity = city.name;
      $scope.otherCityDefault = city.name;
      $scope.showCityList = false;
      if(!$scope.$$phase) $scope.$apply();

      }
    }
    $scope.uniCheck = function (s){
      // alert('sss');
      $scope.showUniList = true;
      $scope.searchUniversities = [];
      if((s||[]).length > 2){
        $scope.searchUniversities = $scope.uniArray.filter(function(a){

          return a.name.toLowerCase().includes(s.toLowerCase());
        })
      
      }else{
        $scope.searchUniversities = $scope.baseInstitutes.filter(function(a){

          return a.name;
        })
      }

     
      if(!$scope.searchUniversities.length){
        // $scope.showUniList = false;
        if(s !== null){
          $scope.showUniList = false;

        }else{
        // $scope.showUniList = false;

        }
        $scope.notFound = true;
      }else{
        $scope.notFound = false;
      }

    }

    $scope.onSelectUni = function(uni){
      $scope.defaultField = !$scope.defaultField;

      // console.log(uni)
      if(uni.id == 404){
      }else{
      $scope.newVar = uni.name;
      $scope.otherUni = uni.name;
      $scope.otherUniDefault = uni.name;
      $scope.showUniList = false;
      if(!$scope.$$phase) $scope.$apply();

      }
    }
    $scope.closeCityDropdown = function(){
      $scope.showCityList = false;
    }
    $scope.showJourneyList = function(){
      $scope.showJourneyList = true;

    }
    $scope.closeUniDropdown = function(){
      // $scope.showUniList = false;
      $scope.showJourneyList = false;
    }


    if($rootScope.platform_reactApp){
      var compProf = false;
      window.localStorage.setItem("profileCompleted",compProf);
    }
    $(window).on("load", function () {
      $rootScope.isWindowloaded = true;
    

    });
    var closePopUp = function () {
      if (!$rootScope.isWindowloaded) {
        setTimeout(closePopUp, 100);
      } else {

          console.log("popup-close");
          console.log("userToken" + CustomStorageService.getAuthTokenStorageData());
          console.log("userID" + $scope.userData.id);
          console.log("urlToRoute"+$location.$$url);

          if(CustomStorageService.getAppFreeAccessPopup()){
            console.log("firstLogin");
          }
          console.log("loggedIn");

      }
    };
    $scope.closeCompProfile = function () {
      if($rootScope.platform_reactApp){
        // console.log("popup-close");
        closePopUp();
      }
      if(CustomStorageService.getBlogsReply() || CustomStorageService.getBlogsComment())
      {
        var category = CustomStorageService.getBlogsReply() ? CustomStorageService.getBlogsReply().category :CustomStorageService.getBlogsComment().category;
        var id = CustomStorageService.getBlogsReply() ? CustomStorageService.getBlogsReply().blogid :CustomStorageService.getBlogsComment().blogid;
        console.log("categories",category,"id",id);
        $state.go("BlogDetail", { category: category, id: id }, { reload: true });
      } else if($rootScope.beforJoinusPath) {
        $state.go($rootScope.beforJoinusPath.current.name, $rootScope.beforJoinusPath.params)
        setTimeout(function() {
          window.location = window.location.href.split("?")[0];
        }, 500)
      } else
        $state.go("Landing", {}, { reload: true });
    };
    $scope.profileDone = function(){
  $scope.closeCompProfile();
    }
    $scope.discountTab = function () {
      $scope.thankyou_tab = false;
      $scope.complete_profile = true;
    };
    $scope.nameTab = function () {

      $scope.complete_profile = false;
      $scope.thankyou_tab = false;
      $scope.name_tab = true;
      $scope.tab_navigation = true;
      $scope.verify_otp_tab = false;
      $state.go("Complete-Profile",{name: 'name'});

    };

    $scope.profileTab = function (skip, data) {

      $scope.errorMessage = "";

      //   $scope.loader = true;
      // console.log("CHECK PROFILE", skip);

      if (!skip) {
        if (data != null && data.length != 0) {
          // console.log("in not skip");
          $scope.userName = data;
          $scope.updateProfile("name", data).then(
            function (resp) {
              if (resp.data.success) {

                // console.log("RESP", resp);
                $scope.loader = false;
                $scope.userData.name = data;
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);


                $scope.name_tab = false;
                $scope.steps[0] = true;
                $scope.welcome_popup = true;
                $scope.backBtn = true;

                $timeout(function () {
                  $scope.welcome_popup = false;
                  $scope.profile_tab = true;
                $state.go("Complete-Profile",{name: 'image'});

                }, 3500);
              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating Name .";
                // console.log("Error Updating Name");
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "Please Enter Your Name";
        }

        // $scope.step = 2;
      } else {
        $scope.errorMessage = "";
        $state.go("Complete-Profile",{name: 'image'});

        $scope.loader = false;
        $scope.steps[0] = false;
        $scope.name_tab = false;
        $scope.welcome_popup = false;
        $scope.profile_tab = true;
        $scope.backBtn = true;
        // $scope.$apply();
      }
    };

    $scope.cityTab = function (skip, data) {

      $scope.errorMessage = "";

      // if(!skip){
      //     $scope.step = 3;
      // }
      if (!skip) {
        // console.log("image", data);
        if (data != null && data.length != 0) {
          $scope.city_tab = true;

          $scope.profile_tab = false;
          $scope.steps[1] = true;
      $state.go("Complete-Profile",{name: 'city'});

        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.city_tab = true;
        $scope.profile_tab = false;

        $scope.steps[1] = false;
      $state.go("Complete-Profile",{name: 'city'});

      }
    };

    $scope.educationTab = function (skip, data) {
      // console.log("data", data);
      //   $scope.loader = true;

      $scope.errorMessage = "";

      // if(!skip){
      //     $scope.step = true
      //     $scope.step = 4;
      // }
      if (!skip) {
        if (data != null && data.length != 0 && data !== "Choose your City") {
          var city = data.toString();
          // console.log("CITY NAME", city);
          $scope.otherCity = data;
          $scope.otherCityDefault = data;
          $scope.updateProfile("city", city).then(
            function (resp) {

              // console.log("CITY", resp);
              if (resp.data.success) {
                $scope.userData.city = city;
                // console.log("before city", $scope.userData);
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);

                $scope.userCity = city;
                $scope.city_tab = false;
                $scope.loader = false;
                $scope.steps[2] = true;
                $scope.cityverify_popup = true;
                $timeout(function () {
                  $scope.cityverify_popup = false;
                  $scope.education_tab = true;
      $state.go("Complete-Profile",{name: 'institute'});

                }, 3500);

              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating City.";
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.loader = false;
        $scope.userCity = data;

        $scope.city_tab = false;
        $scope.steps[2] = false;
        $scope.cityverify_popup = false;
        $scope.education_tab = true;
      $state.go("Complete-Profile",{name: 'institute'});

      }
    };

    $scope.genderTab = function (skip, data) {

      //   $scope.loader = true;
      // if(!skip){
      //     $scope.step = 5;
      // }
      // console.log("CHECK", skip, data);
      if (!skip) {
        if (
          data != null &&
          data.length != 0 &&
          data !== "Choose your Institute"
        ) {
          // $scope.customUni = data;
          $scope.otherUni = data;
          $scope.otherUniDefault = data;

          $scope.updateProfile("institute", data).then(
            function (resp) {
              // console.log("respr", resp);
              if (resp.data.success) {

                $scope.loader = false;
                $scope.userData.university = data;
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);

                $scope.education_tab = false;

                $scope.gender_tab = true;
                $scope.steps[3] = true;
      $state.go("Complete-Profile",{name: 'gender'});

              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating Gender.";
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.loader = false;
        $scope.education_tab = false;

        $scope.gender_tab = true;
        $scope.steps[3] = false;
        $state.go("Complete-Profile",{name: 'gender'});

      }
    };

    $scope.birthdayTab = function (skip, data) {
      $scope.errorMessage = "";

      // if(!skip){
      //     $scope.step = 6;
      // }
      // console.log(skip, data);
      if (!skip) {
        if (data != null && data.length != 0) {
          $scope.updateProfile("gender", data).then(
            function (resp) {
              // console.log("respr", resp);
              if (resp.data.success) {

                $scope.loader = false;
                $scope.userData.gender = data;
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);

                $scope.steps[4] = true;
                $scope.birthday_tab = true;
                $scope.gender_tab = false;
      $state.go("Complete-Profile",{name: 'dob'});

              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating DOB .";
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.steps[4] = false;

        $scope.birthday_tab = true;
        $scope.gender_tab = false;
      $state.go("Complete-Profile",{name: 'dob'});


  
      }
    };

    function getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : "0" + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : "0" + day;

      return month + "/" + day + "/" + year;
    }
    $scope.journeyTab = function (skip, data) {
        $scope.errorMessage = "";
      if (!skip) {
        if (data != null && data.length != 0) {
          var date = data.userYear + "-" + data.userMonth + "-" + data.userDay;
          var finalDate = new Date(date);
          var cDate = new Date ();
          // console.log("DATE F",  cDate.getFullYear() -finalDate.getFullYear());
var dateToCompare =  cDate.getFullYear() -finalDate.getFullYear();
          if(dateToCompare < 18 ){
            // alert('ssss');
            $scope.updateProfile("dob", finalDate).then(
              function (resp) {
                // console.log("respr", resp);
                if (resp.data.success) {
                  $scope.loader = false;
                  $scope.userData.dob = finalDate;
                  // console.log("before update", $scope.userData);
                  CustomStorageService.setUserInfoStorageData($scope.userData);
                  $scope.$emit("userProfileUpdated", $scope.userData);
  
                  $scope.steps[5] = true;
                  $scope.birthday_tab = false;
                  // $scope.journey_tab = true;
                  $scope.guardian_tab = true;
                  setTimeout(function () {
                    $("#country").countrySelect({
                      defaultCountry: "pk",
                      preferredCountries: ["pk"],
                      localizedCountries: {},
                    });
                    $(".country-select").css("margin-top", "0px");
                  }, 300);
                } else {
                  $scope.loader = false;
                  $scope.errorMessage = "Error Updating Name .";
                }
              },
              function errorCallback(response) {
                $scope.loader = false;
                // console.log("error prof", response);
                return response;
              }
            );
          }else{

            $scope.updateProfile("dob", finalDate).then(
              function (resp) {
                // console.log("respr", resp);
                if (resp.data.success) {

                  $scope.loader = false;
                  $scope.userData.dob = finalDate;
                  // console.log("before update", $scope.userData);
                  CustomStorageService.setUserInfoStorageData($scope.userData);
                  $scope.$emit("userProfileUpdated", $scope.userData);
  
                  $scope.steps[5] = true;
                  $scope.birthday_tab = false;
                  $scope.journey_tab = true;
               $state.go("Complete-Profile",{name: 'journey'});

                } else {
                  $scope.loader = false;
                  $scope.errorMessage = "Error Updating Name .";
                }
              },
              function errorCallback(response) {
                $scope.loader = false;
                // console.log("error prof", response);
                return response;
              }
            );
          }

      
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.loader = false;
        $scope.steps[5] = false;
        $scope.birthday_tab = false;
        $scope.journey_tab = true;
        setTimeout(function () {
          $("#country").countrySelect({
            defaultCountry: "pk",
            preferredCountries: ["pk"],
            localizedCountries: {},
          });
          $(".country-select").css("margin-top", "0px");
        }, 300);
      $state.go("Complete-Profile",{name: 'journey'});

      }

    };
    $scope.guardianTab = function(skip,data){

      // $state.go("Complete-Profile",{name: 'dob'});
      $scope.errorMessage = "";

      // if(!skip){
      //     $scope.step = 6;
      // }
      // console.log(skip, data);
      if (!skip) {
        if (data != null && data.length != 0) {
          $scope.updateProfile("guardian_phone", data).then(
            function (resp) {
              // console.log("respr", resp);
              if (resp.data.success) {
                $scope.loader = false;
                $scope.userData.guardian_phone = data;
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);

                $scope.steps[5] = true;
                // $scope.birthday_tab = true;
                $scope.guardian_tab = false;
        $scope.journey_tab = true;
        

              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating Guardian Phone.";
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.steps[5] = false;
        $scope.guardian_tab = false;
        $scope.journey_tab = true;
      }
    }
    $scope.profileCityDD = function () {
      $scope.profileCityList = !$scope.profileCityList;
    };

    $scope.otpTab = function (skip, data) {

      $scope.errorMessage ="";
      // if(!skip){
      //     $scope.step = 7;
      // }
      if (!skip) {
        if (data != null && data.length != 0) {
          selectRefere = data;
          $scope.updateProfile("journey", data).then(
            function (resp) {
              // console.log("respr", resp);
              if (resp.data.success) {
                $scope.loader = false;
                $scope.userData.journey = data;
                CustomStorageService.setUserInfoStorageData($scope.userData);
                $scope.$emit("userProfileUpdated", $scope.userData);

                $scope.steps[6] = true;
                $scope.otp_tab = true;

                setTimeout(function () {
                  $("#country").countrySelect({
                    defaultCountry: "pk",
                    preferredCountries: ["pk"],
                    localizedCountries: {},
                  });
                  $(".country-select").css("margin-top", "0px");
                }, 300);

                $scope.journey_tab = false;
      $state.go("Complete-Profile",{name: 'verification'});

              } else {
                $scope.loader = false;
                $scope.errorMessage = "Error Updating Journey.";
              }
            },
            function errorCallback(response) {
              $scope.loader = false;
              // console.log("error prof", response);
              return response;
            }
          );
        } else {
          $scope.errorMessage = "This Field cannot be empty";
        }
      } else {
        $scope.loader = false;
        $scope.steps[6] = false;
        $scope.otp_tab = true;
        $scope.journey_tab = false;
        setTimeout(function () {
          $("#country").countrySelect({
            defaultCountry: "pk",
            preferredCountries: ["pk"],
            localizedCountries: {},
          });
          $(".country-select").css("margin-top", "0px");
        }, 300);

      $state.go("Complete-Profile",{name: 'verification'});

      }
    };

    $scope.toLandingPage = function (){
      closePopUp();
      $scope.goToState("Landing");
    }

    var addPasteHandler = function() {
      setTimeout(function() {
        angular.element('#digit-1')[0].addEventListener('paste', function(event) {
          var clipboardData = event.clipboardData || window.clipboardData;
          var pastedData = clipboardData.getData('Text');
          var data = pastedData.split("");
          event.target.value = data[0];
          angular.element('#digit-2')[0].value = data[1];
          angular.element('#digit-3')[0].value = data[2];
          angular.element('#digit-4')[0].value = data[3];
          angular.element('#digit-5')[0].value = data[4];
          angular.element('#digit-6')[0].value = data[5];
          $scope.digit1 = data[0];
          $scope.digit2 = data[1];
          $scope.digit3 = data[2];
          $scope.digit4 = data[3];
          $scope.digit5 = data[4];
          $scope.digit6 = data[5];
          $scope.$apply();
          angular.element('#digit-6')[0].focus();
        });
      }, 500)
    }
    $scope.onPasteOTP = function (event, num) {
      setTimeout(function () {
        var data = event.target.value.split("");
        event.target.value = data[0];
        angular.element("#digit-2")[0].value = data[1];
        angular.element("#digit-3")[0].value = data[2];
        angular.element("#digit-4")[0].value = data[3];
        angular.element("#digit-5")[0].value = data[4];
        angular.element("#digit-6")[0].value = data[5];
        $scope.digit1 = data[0];
        $scope.digit2 = data[1];
        $scope.digit3 = data[2];
        $scope.digit4 = data[3];
        $scope.digit5 = data[4];
        $scope.digit6 = data[5];
        $scope.$apply();
        angular.element("#digit-6")[0].focus();
        $scope.sendOTPConfirmation(
          $scope.digit1,
          $scope.digit2,
          $scope.digit3,
          $scope.digit4,
          $scope.digit5,
          $scope.digit6,
          $scope.phoneChoosen ? "phoneVerify" : "emailVerify"
        );
      }, 100);
    };
    $scope.keytab = function (event, model, digit) {
      if (
        event.key === "Backspace" ||
        (event.keyCode === 229 && !event.target.value)
      ) {
        event.target.previousElementSibling.focus();
        if (model === 1) {
          $scope.digit1 = "";
        } else if (model === 2) {
          $scope.digit2 = "";
        } else if (model === 3) {
          $scope.digit3 = "";
        } else if (model === 4) {
          $scope.digit4 = "";
        } else if (model === 5) {
          $scope.digit5 = "";
        } else if (model === 6) {
          $scope.digit6 = "";
        }
      } else {
        if($rootScope.platform_reactApp){
          setTimeout(function() {
            if(event.target.value){
              event.target.nextElementSibling.focus()
            }
          }, 200)
        }else{
          if(event.target.value){
            event.target.nextElementSibling.focus()
          }
        }

      }
    },
      $scope.otpSentTab = function (from) {
        if (from === "email") {
          $scope.otpSent_tab = true;
          $scope.otp_tab = false;
        } else {
          $scope.otpSent_tab = true;
          $scope.otp_tab = false;
        }
        addPasteHandler();
      };
    $scope.sendOtp = function (type, resend) {
      // console.log("OTP", type, resend);
      $scope.errorMessage = "";
      $scope.loader = true;
      if (type === "phone") {
        type = 'whatsapp';
        $scope.phoneChoosen = true;
        $scope.otpSent_tab = true;
        $scope.otp_tab = false;
      } else {
        $scope.phoneChoosen = false;
        $scope.otpSent_tab = true;
        $scope.otp_tab = false;
      }
      addPasteHandler();
      var data = {
        user_id: $scope.userData.id,
        type: type,
      };

      $http.post("/api/v1/auth/send-otp", data).then(
        function (resp) {
          // console.log(resp);
          $scope.loader = false;

          if (resend != null || resend.length != 0) {
            // console.log("resend code working");
            $scope.noti_reset = true;
            setTimeout(function () {
              // console.log("noti", $scope.noti_reset);
              $scope.noti_reset = false;
              $scope.$apply();
              // var noti_element = document.getElementById("hideNotification");
              // noti_element.style.display = "none";
            }, 3000);
          }
        },
        function errorCallback(response) {
          // console.log("response");
          swal(
            {
              title: "Try Again",
              text: "Something went wrong",
              type: "error",
            },
            function () {
              swal.close();
            }
          );
          // console.log(response)
        }
      );
    };
    $scope.verifyOtpTab = function () {
      // $scope.verify_otp_tab = true;
      // $scope.otpSent_tab = false;
      $scope.steps[6] = true;
      $scope.otp_tab = true;
      setTimeout(function () {
        $("#country").countrySelect({
          defaultCountry: "pk",
          preferredCountries: ["pk"],
          localizedCountries: {},
        });
        $(".country-select").css("margin-top", "0px");
      }, 300);
      $scope.verify_otp_tab = false;
    };
    $scope.sendOTPConfirmation = function (d1, d2, d3, d4, d5, d6, type) {
      $scope.loader = true;
      // console.log("OTP", otp);
      var otp = d1 + d2 + d3 + d4 + d5 + d6;
      // console.log("OTP", otp);
      // var otp = otp;

      // console.log("OTP",otp);
      const formData = {
        user_id: $scope.userData.id,
        code: otp,
        session: $scope.selectedSession ? $scope.selectedSession.session : "",
        type: type,
        removeAllSession: $scope.removeAllSession,
        origin: "LEGACY",
      };

      $http.post("/api/v1/auth/validate-otp", formData).then(
        function (resp) {
          // console.log(resp);
          if (resp.data.success && resp.data.token) {
            $scope.enterOTP = false;
            $scope.loader = false;

            $scope.OTP = false;
            if ($rootScope.platform_reactApp) {
              console.log("userToken" + resp.data.token);
              console.log("userID" + resp.data.user.id);
              console.log("popup-close");
              console.log("urlToRoute"+$location.$$url);

              if(CustomStorageService.getAppFreeAccessPopup()){
                console.log("firstLogin");
              }
              console.log("loggedIn");

            }
            if (!$scope.phoneVerified && !$scope.emailVerified) {
              $scope.phoneVerified = $scope.phoneChoosen ? true : false;
              $scope.emailVerified = $scope.phoneChoosen ? false : true;
              // console.log($scope.phoneVerified, $scope.emailVerified);
              // $scope.$apply();
              $scope.verify_otp_tab = true;
              $scope.otpSent_tab = false;
            } else {
              $scope.profile_completed = true;
              $scope.otpSent_tab = false;
              $scope.steps[7] = true;
              $state.go("Complete-Profile",{name: 'completed'});
            }
            // swal(
            //   {
            //     title: "OTP Verified!",
            //     type: "success",
            //     confirmButtonText: "Ok",
            //     timer: 2000,
            //     showConfirmButton: false,
            //   },
            //   function () {
            //     swal.close();
            //     CustomStorageService.SignInService(
            //       false,
            //       true,
            //       false,
            //       false,
            //       resp.data.token,
            //       resp.data.user
            //     );
            //     if ($rootScope.platform_reactApp) {
            //       console.log("userToken" + resp.data.token);
            //       console.log("userID" + resp.data.user.id);
            //       console.log("loggedIn");
            //     }
            //     const isPrivacy = resp.data.isPrivacy ? "true" : "false";
            //     CustomStorageService.setTermStatus(isPrivacy);
            //     $rootScope.userNotLoggedIn = false;
            //     if ($state.current.name == "forgot-password") {
            //       $state.go("Landing", {}, { reload: true });
            //     } else {
            //       if(!$scope.phoneVerified && !$scope.emailVerified){
            //         $scope.phoneVerified = $scope.phoneChoosen ? $scope.phoneChoosen : false;
            //         $scope.emailVerified = $scope.phoneChoosen ? false : $scope.phoneChoosen;
            //         $scope.verify_otp_tab = true;
            //         $scope.otpSent_tab = false;
            //       }else{
            //         $scope.profile_completed = true;
            //         $scope.otpSent_tab = false;
            //       }

            //       // location.reload();
            //       // $state.go("Landing", {}, { reload: true });

            //     }
            //   }
            // );
          } else if (
            resp.data.success &&
            CustomStorageService.getAuthTokenStorageData()
          ) {
            $scope.loader = false;

            $scope.enterOTP = false;
            $scope.OTP = false;
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              CustomStorageService.getAuthTokenStorageData(),
              resp.data.user
            );
            if (!$scope.phoneVerified && !$scope.emailVerified) {
              $scope.phoneVerified = $scope.phoneChoosen ? true : false;
              $scope.emailVerified = $scope.phoneChoosen ? false : true;
              // console.log($scope.phoneVerified, $scope.emailVerified);

              // $scope.$apply();

              $scope.verify_otp_tab = true;
              $scope.otpSent_tab = false;
            } else {
              $scope.profile_completed = true;
              $scope.otpSent_tab = false;
              $scope.steps[7] = true;
              $state.go("Complete-Profile",{name: 'completed'});
            }
            // swal(
            //   {
            //     title: "OTP Verified!",
            //     type: "success",
            //     confirmButtonText: "Ok",
            //     timer: 2000,
            //     showConfirmButton: false,
            //   },
            //   function () {
            //     location.reload();
            //   }
            // );
            // CustomStorageService.SignInService(
            //   false,
            //   true,
            //   false,
            //   false,
            //   CustomStorageService.getAuthTokenStorageData(),
            //   resp.data.user
            // );
          } else {
            $scope.loader = false;
            if (!$scope.phoneVerified && !$scope.emailVerified) {
              $scope.phoneVerified = $scope.phoneChoosen ? true : false;
              $scope.emailVerified = $scope.phoneChoosen ? false : true;
              // console.log($scope.phoneVerified, $scope.emailVerified);

              // $scope.$apply();
              $scope.verify_otp_tab = true;
              $scope.otpSent_tab = false;
            } else {
              $scope.profile_completed = true;
              $scope.otpSent_tab = false;
              $scope.steps[7] = true;
              $state.go("Complete-Profile",{name: 'completed'});
            }

            // swal(
            //   {
            //     title: "OTP Verified!",
            //     type: "success",
            //     confirmButtonText: "Ok",
            //     timer: 2000,
            //     showConfirmButton: false,
            //   },
            //   function () {
            //     swal.close();
            //   }
            // );
          }
          $scope.digit1 = "";
          $scope.digit2 = "";
          $scope.digit3 = "";
          $scope.digit4 = "";
          $scope.digit5 = "";
          $scope.digit6 = "";
        },
        function errorCallback(response) {
          $scope.otpErroor = "Invalid OTP";
          $scope.loader = false;
          $scope.digit1 = "";
          $scope.digit2 = "";
          $scope.digit3 = "";
          $scope.digit4 = "";
          $scope.digit5 = "";
          $scope.digit6 = "";
          $scope.errorMessage = "Invalid OTP";
        }
      );
    };
    $scope.otpWrongTab = function () {
      $scope.otpWrong_tab = true;
      $scope.otpSent_tab = false;
    };
    $scope.profileCompleted = function () {
      $scope.otpWrong_tab = false;
      $scope.profile_completed = true;
      $scope.steps[0] = true;
      $scope.steps[1] = true;
      $scope.steps[2] = true;
      $scope.steps[3] = true;
      $scope.steps[4] = true;
      $scope.steps[5] = true;
      $scope.steps[6] = true;
      $scope.steps[7] = true;
      $state.go("Complete-Profile",{name: 'completed'});
    };
    $scope.uploadImage = function (formData, userId) {
      return new Promise(function (resolve, reject) {
        fetch(
          env.backendService +
            "/lmsservice/v1/uploader/uploadImageToS3?userId=" +
            userId,
          {
            method: "POST",
            body: formData,
          }
        )
          .then(
            function (data) {
              return data.json();
            },
            function (err) {
              // console.log("ERROR IN UPLOADING IMG 1", err);
              reject(new Error("ERROR IN UPLOADING IMG 1"));
            }
          )
          .then(
            function (data) {
              resolve(data);
            },
            function (err) {
              // console.log("ERROR IN UPLOADING IMG 1", err);
              reject(new Error("ERROR IN UPLOADING IMG 2"));
            }
          );
      });
    };
    function dataURLtoFile(dataurl, filename) {
      //  console.log("D",dataurl,filename);
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
                
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            
            return new File([u8arr], filename, {type:mime});
        }
    $scope.onImageSelected = function (event) {

      $scope.errorMessage = "";
      // console.log("EVENTS", event);
      $scope.imgUploaded = false;
      $scope.loader = true;
      // $scope.$apply();

      $scope.selectedImage = event;
      var convertedFile = dataURLtoFile( $scope.selectedImage,$scope.croppedImageName);
      // console.log(convertedFile,"fialals");
      // console.log("IMAGE",image1)
      // console.log($scope.selectedImage,"selected image");
      if(convertedFile.size > 10000000){
        swal(
          {
            title: "Image Size",
            text: "Image size too big upload an image below 10mb file size",
            type: "error",
          },
          function () {
            swal.close();
          }
        );
        $scope.imageLoad = false;
        return;

      }
      //   FormDataa()
      var fd = new FormData();
      // console.log($scope.selectedImage);
      fd.append("file", convertedFile);
      $scope.uploadImage(fd, $scope.userID).then(
        function (resp) {
          // console.log("up resp", resp);
          if (resp.success) {
            $scope.uploadedImgLink = resp.link;
            $scope.userData.image = $scope.uploadedImgLink;
            CustomStorageService.setUserInfoStorageData($scope.userData);
            $scope.$emit("userProfileUpdated", $scope.userData);

            $scope.selectedImage = null;
            var obj = {
              id: $scope.userID,
              user_image: $scope.uploadedImgLink,
            };
            $http
              .post(
                env.backendService + "/lmsservice/v1/users/change-user-pic",
                obj
              )
              .then(
                function (resp) {
                  // console.log("Change user pic", resp);
                  if (resp.data.success) {
                    $scope.loader = false;

                    $scope.imgUploaded = true;
                    $scope.showCropped = false;
                    $scope.croppedImageName = "";
                  } else {
                    $scope.loader = false;
                    $scope.showCropped = false;
                    $scope.croppedImageName = "";
                    $scope.errorMessage = "Error Changing Picture";
                  }

                  $scope.$apply();
                  // this.currentUser.image = this.uploadedImgLink;
                  // customStorageService.setUser(this.currentUser);
                  // this.currentUser = customStorageService.getUser();
                  // toastr.success("Image Updated Successfully!");
                  // this.loader = false;
                },
                function errorCallback(response) {
                  // console.log("ERROR CHANGE USER PIC", response);
                  $scope.loader = false;
                  $scope.errorMessage = "Error Changing Picture";

                  return response;
                }
              );
          }
        },
        function errorCallback(response) {
          // console.log("ERROR RESP", response);
          return response;
        }
      );
    };

    $scope.updateProfile = function (field, data) {
      // console.log(typeof data);
      var selectedCountry;
      return new Promise(function (resolve, reject) {
        $scope.loader = true;
        $scope.errorMessage = "";
        // console.log("FIELD PROFILE", field, data);
        var fieldName;

        if (field === "name") {
          // console.log("IN name", field);
          fieldName = {
            name: data,
          };
        }

        if (field === "city") {
          // console.log("IN CITY", field);
          fieldName = {
            city: data,
          };
        }

        if (field === "institute") {
          // console.log("IN Institute", field);
          fieldName = {
            university: data,
          };
        }
        if (field === "gender") {
          // console.log(data);
          // console.log("IN Gender", field);
          fieldName = {
            gender: data,
          };
        }
        if (field === "dob") {
          // console.log("IN DOB", field);
          fieldName = {
            dob: data,
          };
        }

        if (field === "journey") {
          // console.log("IN DOB", field);
          fieldName = {
            journey: data,
          };
        }
        if (field === "guardian_phone") {
          // console.log("in p", data, $scope.userData.phone);
          selectedCountry = $("#country").countrySelect(
            "getSelectedCountryData"
          );
          if(!selectedCountry || !selectedCountry.phone_code || selectedCountry.phone_code == 'undefined'){
            selectedCountry = {
              phone_code: "92",
              iso2: "pk",
              name: "Pakistan"
            }
          }

            // console.log("check updated else", data, $scope.userData.phone);
            if (data.startsWith("0")) {
              data = data.substring(1);
            }
            if (data.startsWith("92")) {
              data = data.substring(2);
            }

            if (data.length < 10 || !data.startsWith("3")) {
              $scope.errorMessage = "Enter Valid phone Ex. 3*******";
              setTimeout(function () {
                $scope.errorMessage = null;
              }, 3000);
              return;
            }
            fieldName = {
              guardian_phone: selectedCountry.phone_code + data,
     
            };

        }
        if (field === "phone") {
          // console.log("in p", data, $scope.userData.phone);
          selectedCountry = $("#country").countrySelect(
            "getSelectedCountryData"
          );
          if (data === $scope.userData.phone) {
            // console.log("check updated", data, $scope.userData.phone);
            // loginForm.countryCode = selectedCountry.phone_code;
            $scope.sendOtp("phone");

            return;
          } else {
            // console.log("check updated else", data, $scope.userData.phone);
            if (data.startsWith("0")) {
              data = data.substring(1);
            }
            if (data.startsWith("92")) {
              data = data.substring(2);
            }

            if (data.length < 10 || !data.startsWith("3")) {
              $scope.errorMessage = "Enter Valid phone Ex. 3*******";
              setTimeout(function () {
                $scope.errorMessage = null;
              }, 3000);
              return;
            }
            fieldName = {
              phone: data,
              countryCode: selectedCountry.phone_code,
              uidPhone: selectedCountry.phone_code + data,
              id: $scope.userData.id,
              isQR: undefined,
            };
          }
        }
        if (field === "email") {
          // console.log(
          //   "userData",
          //   $scope.userData.email,
          //   $scope.userEmail,
          //   data
          // );
          if (data === $scope.userData.email) {
            $scope.sendOtp("email");
            return;
          } else {
            fieldName = {
              email: data,
            };
          }
        }
        fieldName.id = $scope.userID ;

        $http
          .post("/api/v1/users/updateUser", fieldName)
          .then(
            function (resp) {
              // console.log(resp);
              //   resolve(resp.json());
              return resp;
            },
            function errorCallback(response) {
              // console.log("update profile", response);
              reject(new Error("ERROR updating"));
            }
          )
          .then(
            function (resp) {
              // $scope.loader = true;
              if (resp.data.success) {
                if (field === "phone") {
                  // phone: data,
                  // countryCode: selectedCountry.phone_code,
                  // uidPhone: selectedCountry.phone_code + data,
                  $scope.userData.phone = data;
                  $scope.userData.uid_phone = selectedCountry.phone_code + data;
                  $scope.editablePhone = selectedCountry.phone_code + data;
                  CustomStorageService.setUserInfoStorageData($scope.userData);
                  $scope.$emit("userProfileUpdated", $scope.userData);
                  $scope.sendOtp("phone");
                } else if (field === "email") {
                  $scope.userData.email = data;
                  $scope.userEmail = data;
                  CustomStorageService.setUserInfoStorageData($scope.userData);
                  $scope.sendOtp("email");
                }
              } else {
                if (field === "email") {
                  $scope.showEmailError = true;
                }
                if (resp.data) {
                  $scope.loader = false;
                  $scope.errorMessage = resp.data.message;
                } else {
                  $scope.loader = false;
                  $scope.errorMessage =
                    field === "email"
                      ? "Email Update Error"
                      : "Phone Update Error";
                }
              }

              resolve(resp);
            },
            function errorCallback(response) {
              // console.log("update profile", response);
              $scope.loader = true;

              reject(new Error("ERROR updating"));
            }
          );
      });
    };

    $scope.checkStatus = function (){

      // false, //name
      // false, //profile
      // false, //city
      // false, //education
      // false, //gender
      // false, //Birthday
      // false, //Journey
      // false, //OTP
      // false, //send otp
      // false, //wrong otp
      if($scope.userData.name && !$scope.name_tab){
        $scope.steps[0] = true;
      }
      if($scope.userData.image && !$scope.profile_tab){
        $scope.steps[1] = true;
      }
      if($scope.userData.city && !$scope.city_tab){
        $scope.steps[2] = true;
      }
      if($scope.userData.university && !$scope.education_tab){
        $scope.steps[3] = true;
      }
      if($scope.userData.gender && !$scope.gender_tab){
        $scope.steps[4] = true;
      }
      if($scope.userData.dob && !$scope.birthday_tab){
        $scope.steps[5] = true;
      }
      if($scope.userData.journey && !$scope.otp_tab ){
        $scope.steps[6] = true;
      }
      // if($scope.userData.journey){
      //   $scope.steps[7] = false;
      // }
    }

    if (!CustomStorageService.getAuthTokenStorageData() && !$rootScope.platform_reactApp) {
        $scope.goToState("Landing");
    } else {
      // console.log("LOCATION", $state.params);

      if ($state.params.name === "joining") {
        $scope.thankyou_tab = true;
        $scope.tab_navigation = false;
        $scope.backBtn = false;
  
        // $scope.filterSetting("profileInfo");
      } else if ($state.params.name === "name") {
        $scope.backBtn = false;
        $scope.nameTab();
        $scope.checkStatus();
        // $scope.filterSetting("contantInfo");
      } else if ($state.params.name === "image") {
        $scope.profileTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("activeDevices");
      } else if ($state.params.name === "city") {
        $scope.cityTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("yourAccount");
      } else if ($state.params.name === "institute") {
        $scope.educationTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("emailSubscription");
      } else if ($state.params.name === "gender") {
        $scope.genderTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("myOrder");
      }
     else if ($state.params.name === "dob") {
        $scope.birthdayTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("videosWatched");
      }     else if ($state.params.name === "journey") {
        $scope.journeyTab(true);
        $scope.checkStatus();

        // $scope.filterSetting("videosWatched");
      } 
      else if ($state.params.name === "verification") {
        // console.log(screen.width);
        $scope.otpTab(true);
        $scope.checkStatus();

      }
      else if ($state.params.name === "completed") {
        $scope.profile_completed = true;
        // $scope.filterSetting("profileInfo");
      }
    }
    AOS.init({
      once: true,
    }),
      new WOW().init();
    // $scope.Gender = "Male";
    $scope.RadioChange = function (s) {
      $scope.GenderSelected = s;
    };
  }
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('blogsPanelSignInController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', function($scope, $http, $state,$rootScope, CustomStorageService) {
      if( CustomStorageService.getAdminSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
        $state.go('BlogsPanel',{},{reload:true});
      }
      $scope.loginForm = {};
      $rootScope.userSide= false;
      $rootScope.adminSide = true;
      $scope.submitLogin = function(loginForm) {
        loginForm.origin = 'LEGACY';
        $http.post('/api/v1/auth/signin',loginForm)
        .then(function(resp) {
          if (resp.data.user.role === 'author') {
            swal({
              title: "Sign In Successfull!",
              type: "success",
              timer: 2000,
              showConfirmButton: false
            }, function() {
              swal.close();
              CustomStorageService.SignInService(false,false,false,true,resp.data.token,resp.data.user);
              $state.go('BlogsPanel',{},{reload:true});
            });
          } else {
            swal({
              title: "Not Authorized!",
              type: "error",
              confirmButtonText: "Ok"
            }, function() {
              CustomStorageService.logOutService();
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'error',
            text: response.data.message,
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      };
    }]);
  })();
  
(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('BlogSearchController', MainController);
  function MainController(courseDetailService,$rootScope,$scope, $anchorScroll, $http, $base64, $timeout, $state,$analytics,onlineStatus,$sails,BlogBackendServices) {
    $scope.showData = false;
    $scope.authors = [];
    $scope.searchInput = $state.params.category;
    $scope.authocimpleteArray = [];
    $scope.blogCategories = [];

    $scope.intialize = function () {
      BlogBackendServices.DisplayCategoryBlogs($scope.searchInput, 1)
        .then(function(data){
          $scope.blogCategories.name = $scope.searchInput;
          $scope.blogCategories.blogs = data.all;
          $scope.blogCategories.push({name: $scope.searchInput, blogs: data.all})
          $scope.showData = true;
        });
      
      $http({
        url: "api/v1/user/getAuthors",
        method: "GET",
      }).then(function (res) {
        $scope.authors = res.data.users;
      });

      $http({
        url: "api/v1/blog/titles",
        method: "GET",
      }).then(function (res) {
        var categories = res.data;
        categories.forEach(function(category) {
          $scope.authocimpleteArray.push({value: category.name, type: 'category', category: category.name, category_index_url: category.index_url});
          category.blogs.forEach(function(blog) {
            $scope.authocimpleteArray.push({value: blog.name, type: 'blog', category: category.name, category_index_url: category.index_url, id: blog.blogUrl});
          })
        })
        $.ui.autocomplete.prototype._renderItem = function (ul, item) {
          var classs = item.type + 'item'
          return $( "<li></li>" )
            .data( "item.autocomplete", item )
            .append( "<a class='"+ classs +"' customattribute='" + item.customattribute + "'>" + item.label + "</a>" )
            .appendTo( ul );
        };
        $( "#tags" ).autocomplete({
          source: function(request, response) {
            var term = request.term.toLowerCase();
            var matches = $.grep($scope.authocimpleteArray, function(item, index) {
                if(item.type === 'category') {
                  for (index in $scope.authocimpleteArray){
                    const acItem = $scope.authocimpleteArray[index];
                    var lable = acItem.value.toLowerCase();
                    if(acItem.category === item.value && lable.includes(term) && acItem.type === 'blog') {
                      return true;
                    }
                      
                  };
                } else {
                  var lable = item.value.toLowerCase();
                  return lable.includes(term);
                }
                
            });
            response(matches);
          },
          select: function(e, ui) {
            if(ui.item.type === 'blog') {
              $state.go('BlogDetail', { category: ui.item.category_index_url, id: ui.item.id })
            } else {
              $state.go('BlogSearch', { category: ui.item.category_index_url })
            }
        }
        })
      });
    }();
    $scope.viewMore = function (category) {
      
      if(category.limit === 20) {
        category.limit = 9;
      } else {
        if(!category.dataLoaded) {
          category.loading = true;
          BlogBackendServices.DisplayCategoryBlogs(category.index_url, 1, 20)
          .then(function(data){
            category.blogs = data.all;
            category.dataLoaded = true;
            category.limit = 20;
            category.loading = false;
          });
        } else {
          category.limit = 20;
        }
      }
    }
    $scope.resetFilter = function () {
      $scope.searchInput = '';
      $scope.fromDate = '';
      $scope.toDate = '';
      $scope.authors.forEach(function(author){
        author.selected = false
      });
      $scope.searchBlogs();
    }
    $scope.searchBlogs =function () {
      $scope.showData = false;
      var aurthors = [];
      $scope.authors.forEach(function(author){
        if(author.selected) {
          aurthors.push(author.id)
        }
      });
      const filter = {
        name: $scope.searchInput,
        fromDate: $scope.fromDate,
        toDate: $scope.toDate,
        aurthors: aurthors
      }
      BlogBackendServices.DisplayAllBlogs(filter)
      .then(function(data){
        $scope.blogCategories = data.all;
        $scope.showData = true;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
  .module('NearPeer')
  .controller('BlogListingController', MainController);
  function MainController(courseDetailService,$location,$rootScope,$scope, $anchorScroll, $http, $base64, $timeout, $state,$analytics,onlineStatus,$sails,BlogBackendServices, BreadcrumbService) {
    
    $scope.showData = false;
    $scope.authocimpleteArray = [];
    $scope.showFilters = false;
    $scope.numLimit = 200;
    $scope.url = $location.absUrl().split("/").pop();
    $scope.url = $scope.url.replace("%20", " ");
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
    $scope.moreFilter = function () {
      $scope.showFilters = !$scope.showFilters;
    }
    var currentPage = 0;
    $scope.loading = false;
    var ended = false;
    $scope.blogCategories = [];
    $scope.startDateSelect=false;
    $scope.endDateSelect=false;
    $scope.startDateSelection = function(n) {
      if(n)
       $scope.startDateSelect=true;
      if(!n)
        $scope.endDateSelect=true;
    }
    $scope.showText = "Select Author";

    $scope.getBlogs = function () {
      if (!$scope.loading) {
        $scope.loading = true;
        currentPage = currentPage + 1;
        var params = { page: currentPage, category: $scope.url };

        BlogBackendServices.DisplayCategoryAllBlogs(params)
        .then(function(data){
           $scope.mixpaneldata = data.all;
           setTimeout(function(){
              mixpanel.track('Blog-Listing-page',{
                'Blog_Name': $scope.mixpaneldata[0].name,
                'Blog_ID': $scope.mixpaneldata[0].id,
              });
            },5000);
          $scope.showData = true;
          if(currentPage === 1) {
            $scope.blogCategories = data.all;
            
          } else {
            try {
              var blogCategories = $scope.blogCategories[0];
              console.log("🚀 ~ file: blogListingController.js:56 ~ .then ~ blogCategories:", blogCategories)
              if(blogCategories) {
                var blogs = blogCategories.blogs;
                blogs = blogs.concat(
                  data.all[0].blogs
                );
                blogCategories.blogs = blogs;
                
                $scope.blogCategories = [blogCategories];
              }
            } catch (error) {
              console.log('error')
              console.log(error)
            }
          }
          
          if (data.all[0] && data.all[0].blogs.length === 0) {
            ended = true;
          }
          $scope.loading = false;
        });
      }
    };

    $scope.loadMore = function () {
      if (!ended) {
        $scope.getBlogs();
      }
    };

    $scope.intialize = function () {
      var url=window.location.href;
      var host = window.location.protocol + "//" + window.location.host;
      onloadFunction(
        {'url': host + '/blogs',
          'displayName': 'Blogs', 
        },'LEAF'
      );
      onloadFunction(
        {'url': url,
          'displayName': $state.params.category, 
        },'child'
      );

      $scope.isFilterLoading = false;
      $scope.selectedCategory = 0;
      $scope.searchInput = '';
      $scope.getBlogs();
      $http({
        url: "api/v1/user/getAuthors",
        method: "GET",
      }).then(function (res) {
        $scope.authors = res.data.users;
      });
      $http({
        url: "api/v1/blog/titles",
        method: "GET",
      }).then(function (res) {
        var categories = res.data;
        categories.forEach(function (category) {
          $scope.authocimpleteArray.push({ value: category.name, type: 'category', category: category.name, category_index_url: category.index_url });
          category.blogs.forEach(function (blog) {
            $scope.authocimpleteArray.push({ value: blog.name, type: 'blog', category: category.name, category_index_url: category.index_url, id: blog.blogUrl });
          })
        })
        $.ui.autocomplete.prototype._renderItem = function (ul, item) {
          var classs = item.type + 'item'
          return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<a class='" + classs + "' customattribute='" + item.customattribute + "'>" + item.label + "</a>")
            .appendTo(ul);
        };
        $("#tags").autocomplete({
          source: function (request, response) {
            var term = request.term.toLowerCase();
            var matches = $.grep($scope.authocimpleteArray, function (item, index) {
              if (item.type === 'category') {
                for (index in $scope.authocimpleteArray) {
                  var acItem = $scope.authocimpleteArray[index];
                  var lable = acItem.value.toLowerCase();
                  if (acItem.category === item.value && lable.includes(term) && acItem.type === 'blog') {
                    return true;
                  }

                };
              } else {
                var lable = item.value.toLowerCase();
                return lable.includes(term);
              }

            });
            response(matches);
          },
          select: function (e, ui) {
            if (ui.item.type === 'blog') {
              $state.go('BlogDetail', { category: ui.item.category_index_url, id: ui.item.id })
            } else {
              $state.go("BlogList", { "category": ui.item.value });
            }
          }
        })
      });
    }();

    $scope.selectedAuthorsName= "";
    $scope.fromDate2="Select Date";
    $scope.toDate2="Select Date";
    $scope.searchBlogs =function () {
      $scope.isFilterLoading = true
      $scope.fromDate2 = ($scope.fromDate).getDate() + "/" + (($scope.fromDate).getMonth() + 1) + "/" + ($scope.fromDate).getFullYear();
      $scope.toDate2 = ($scope.toDate).getDate() + "/" + (($scope.toDate).getMonth() + 1) + "/" + ($scope.toDate).getFullYear();
      var aurthors = [];
      $scope.selectedAuthorsName = "";
      $scope.authors.forEach(function (author) {
        if (author.selected) {
          aurthors.push(author.id)
          var aurthorName = author.name ? author.name : author.full_name;
          $scope.selectedAuthorsName += $scope.selectedAuthorsName ? ', ' + aurthorName : aurthorName;
          $scope.showText = $scope.selectedAuthorsName;
        }
      });
      var filter = {
        name: $scope.searchInput,
        fromDate: $scope.fromDate,
        toDate: $scope.toDate,
        aurthors: aurthors
      }
      BlogBackendServices.DisplayCategoryAllBlogs(filter)
      .then(function(data){
        $scope.blogCategories = data.all;
        $scope.blogtop = data.top;
        $scope.showData = true;
        $scope.isFilterLoading = false
      });
    }
    $scope.resetFilter = function () {
      $scope.searchInput = '';
      $scope.fromDate = '';
      $scope.toDate = '';
      $scope.fromDate2 = "Select Date";
      $scope.toDate2 = "Select Date";
      $scope.startDateSelect = false;
      $scope.endDateSelect = false;
      $scope.showText = "Select Author";
      $scope.authors.forEach(function (author) {
        author.selected = false
      });
      $scope.searchBlogs();
    }
    $scope.EmailSubscribe = function (subscribeEmail) {
      if (subscribeEmail) {
        BlogBackendServices.EmailSubscribeBlog(subscribeEmail);
        $scope.subscribeEmail = "";
        var ele = document.getElementById("email-subscription-blog");
        if (ele && ele.value) {
          ele.value = "";
        }
      }
    }

    function onloadFunction(data,level) {
      BreadcrumbService.setBreadCrumb(data,level);
    } 
        
        
  }
})();


(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('BlogCategoriesController', MainController);
  function MainController(courseDetailService,$rootScope,$scope, $anchorScroll, $http, $base64, $timeout, $state,$analytics,onlineStatus,$sails,BlogBackendServices, BreadcrumbService) {
    $scope.showData = false;
    $scope.authocimpleteArray = [];
    $scope.showFilters=false;
    $scope.numLimit = 175;

    setTimeout(function(){
       mixpanel.track('Blog-Main-page');
    },5000)


    $(document).ready(function(){
      $(this).scrollTop(0);
    });

    $scope.$on("$destroy", widthFix);
    
    $scope.moreFilter=function(){
      $scope.showFilters=!$scope.showFilters;
    }
    $scope.startDateSelect=false;
    $scope.endDateSelect=false;
    $scope.startDateSelection = function(n) {
      if(n)
       $scope.startDateSelect = true;
      if(!n)
        $scope.endDateSelect = true;
    }
    function widthFix () {
      $scope.listCount=4;
      $scope.view="Read";
      $scope.screen=false;
      $scope.windowWidth = $( window ).width();
      if($scope.windowWidth >= 767 && $scope.windowWidth <= 920)
      {
        $scope.listCount=3;
        $scope.view="Read More";
        $scope.screen=true;
      }
      else if($scope.windowWidth > 920)
      {
        $scope.listCount=4;
        $scope.view="Read";
        $scope.screen=false;
      }
      else if($scope.windowWidth < 767)
      {
        $scope.listCount=4;
        $scope.view="Read More";
        $scope.screen=true;
      }
    }
    $(window).resize(function() {
      widthFix();
    });
    $scope.showText="Select Author";
    $scope.intialize = function () {
      $scope.isFilterLoading = false;
      widthFix();
      window.addEventListener('resize', widthFix);
      $scope.selectedCategory = 0;
      $scope.searchInput = '';
      BlogBackendServices.DisplayBlogCategories()
      .then(function(data){
        $scope.categories = data.category;
        // $scope.showData = true;
      });
      BlogBackendServices.DisplayAllBlogs()
      .then(function(data){
        $scope.blogCategories = data.all;
        $scope.blogtop = data.top;
        $scope.showData = true;
      });
      $http({
        url: "api/v1/user/getAuthors",
        method: "GET",
      }).then(function (res) {
        $scope.authors = res.data.users;
      });
      $http({
        url: "api/v1/blog/titles",
        method: "GET",
      }).then(function (res) {
        var categories = res.data;
        categories.forEach(function(category) {
          $scope.authocimpleteArray.push({value: category.name, type: 'category', category: category.name, category_index_url: category.index_url});
          category.blogs.forEach(function(blog) {
            $scope.authocimpleteArray.push({value: blog.name, type: 'blog', category: category.name, category_index_url: category.index_url, id: blog.blogUrl});
          })
        })
        $.ui.autocomplete.prototype._renderItem = function (ul, item) {
          var classs = item.type + 'item'
          return $( '<li style="width="100%"></li>' )
            .data( "item.autocomplete", item )
            .append( "<a class='"+ classs +"' customattribute='" + item.customattribute + "'>" + item.label + "</a>" )
            .appendTo( ul );
        };
        $( "#tags" ).autocomplete({
          source: function(request, response) {
            var term = request.term.toLowerCase();
            var matches = $.grep($scope.authocimpleteArray, function(item, index) {
                if(item.type === 'category') {
                  for (index in $scope.authocimpleteArray){
                    const acItem = $scope.authocimpleteArray[index];
                    var lable = acItem.value.toLowerCase();
                    if(acItem.category === item.value && lable.includes(term) && acItem.type === 'blog') {
                      return true;
                    }
                      
                  };
                } else {
                  var lable = item.value.toLowerCase();
                  return lable.includes(term);
                }
                
            });
            response(matches);
          },
          select: function(e, ui) {
            if(ui.item.type === 'blog') {
              $state.go('BlogDetail', { category: ui.item.category_index_url, id: ui.item.id })
            } else {
              $state.go("BlogList", {"category": ui.item.value  });
            }
        }
        })
      });
    }();
    $scope.selectCategory =function (id) {
      $scope.selectedCategory = id;
      //$anchorScroll(id);
    }
    $scope.viewMore = function (category) {
      
      $state.go("BlogList", {"category": category });
      
    }
    $scope.selectedAuthorsName= "";

    $scope.fromDate1="Select Date";
    $scope.toDate1="Select Date";
    $scope.searchBlogs =function () {
      $scope.fromDate1 = ($scope.fromDate).getDate() + "/" + (($scope.fromDate).getMonth()+1) + "/" + ($scope.fromDate).getFullYear();
      $scope.toDate1 = ($scope.toDate).getDate() + "/" + (($scope.toDate).getMonth()+1) + "/" + ($scope.toDate).getFullYear();
      $scope.isFilterLoading = true
      var aurthors = [];
      $scope.selectedAuthorsName= "";
      $scope.authors.forEach(function(author){
        if(author.selected) {
          aurthors.push(author.id)
         var aurthorName = author.name ? author.name : author.full_name;
          $scope.selectedAuthorsName+= $scope.selectedAuthorsName ? ', '+aurthorName : aurthorName;
          $scope.showText=$scope.selectedAuthorsName;
        }
      });
      const filter = {
        name: $scope.searchInput,
        fromDate: $scope.fromDate,
        toDate: $scope.toDate,
        aurthors: aurthors
      }
      BlogBackendServices.DisplayAllBlogs(filter)
      .then(function(data){
        $scope.blogCategories = data.all;
        $scope.blogtop = data.top;
        $scope.showData = true;
        $scope.isFilterLoading = false
      });
    }
    $scope.EmailSubscribe =function (subscribeEmail) {
      if(subscribeEmail) {
        BlogBackendServices.EmailSubscribeBlog(subscribeEmail);
        $scope.subscribeEmail = "";
        var ele = document.getElementById("email-subscription-blog");
        if(ele && ele.value){
          ele.value = "";
        }
      }
    }
    $scope.resetFilter = function () {
      $scope.searchInput = '';
      $scope.fromDate='';
      $scope.toDate='';
      $scope.fromDate1="Select Date";
      $scope.toDate1="Select Date";
      $scope.startDateSelect=false;
      $scope.endDateSelect=false;
      $scope.showText="Select Author";
      $scope.authors.forEach(function(author){
        author.selected = false
      });
      $scope.searchBlogs();
    }
    new WOW().init();

     function onloadFunction(data,level) {
            BreadcrumbService.setBreadCrumb(data,level);
            
        } 
        onloadFunction({'url': '/blogs' ,'displayName': 'Blogs' },'LEAF');

  }
})();

(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('OlderBlogController', MainController);

  function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, $state,$analytics,onlineStatus,$sails,BlogBackendServices) {
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.showData = false;
    var totalPages;
    $scope.blogCards =function( page , date,calltime){
      calltime = calltime | false;
      BlogBackendServices.PageBlog(page , date,calltime,totalPages)
      .then(function(data){
        $scope.page = data.page;
        $scope.allblog = data.blogs;
        totalPages = data.totalPages;
        $scope.showData = true;
      });
    }
    $scope.initialize = function () {
      BlogBackendServices.blogFeatureOldPage()
      .then(function(data){
        $scope.featureBlog = data.feature;
      });
      $scope.date = new Date();
      var calltime=true;
      $scope.blogCards(1,$scope.date,calltime);
    }();
  }
})();

 (function () {
  "use strict";

  angular.module("NearPeer").controller("BlogDetailController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $window,
    $base64,
    $timeout,
    CustomStorageService,
    $state,
    $analytics,
    $location,
    onlineStatus,
    $sails,
    Upload,
    BlogBackendServices,
    ExternalLinksService,
    BreadcrumbService
  ) {
    $scope.curr=1;
    $scope.amountToTransform=0;
    $scope.isTransform=false;
    $(document).ready(function () {
      $(this).scrollTop(0);
      try {
        $('#quote-carousel').carousel({
          pause: true,
          interval: 4000,
        });
      } catch (error) {
        
      }
      
    });
    $scope.showData = false; 
    $scope.userEmail = "";
    $scope.notesLink = "";
    $scope.isValid = true;
    if ($window.innerWidth < 930) {
      $scope.HtmlWidthLess = true;
    } else {
      $scope.HtmlWidthLess = false;
    }

    if (
      CustomStorageService.getUserSignedInStorageData() ||
      CustomStorageService.getInstructorSignedInStorageData()
    ) {
      $scope.userName = CustomStorageService.getUserInfoStorageData()
        .image;
        $scope.fullName = CustomStorageService.getUserInfoStorageData()
        .full_name;
    }
    var id = $state.params.id;
    var url = $location.absUrl();
    $(window).resize(function() {
      screenAdjust();
      setValues();
    });
    function screenAdjust() {
      $scope.screen=false;
      $scope.windowWidth = $( window ).width();
      if($scope.windowWidth >= 767)
      {
        $scope.curr=1;
        $scope.screen=false;
      }
      else if($scope.windowWidth < 767)
      {
        $scope.curr=0;
        $scope.screen=true;
      }
    }
    $scope.firstAttempt=true;
    function myFunction() {
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height= $('#below-fix').offset().top; 
      var scrolled = (winScroll / height) * 100;
      document.getElementById("myBar").style.width = scrolled + "%";
        var initTopPosition= $('#blog').offset().top-90;
        var lastScrollTop = 0; 
    }
    // for blogs published via old editor (ta text-angular)
    // replace ta img value with actual youtube iframe
    
    function replacetablewithDiv (element){
      try{
      var tablediv = document.createElement('div');
      tablediv.classList.add("tablediv");
      tablediv.append(element.cloneNode(true));
      element.replaceWith(tablediv);
    }catch(err){
      console.log('--=-=-=-', err)
    }
  }
    function loadTaIframesForOldBlog (element){
      var iframe = document.createElement('iframe');
      var attributes = element.attributes;
      // loop through element attributes and apply them on iframe
      var src = ''
      angular.forEach(attributes, function(attr) {
        if(attr.name === 'ta-insert-video'){
          iframe.setAttribute('src', attr.value);
        }
        iframe.setAttribute(attr.name, attr.value);
      });
      element.replaceWith(iframe);
    }
  
    $scope.$on("$destroy",function(){
      $(window).off("scroll" ,myFunction);
    });
    $scope.formatTextForLink = function(text){
			var newText = text.replace(/(https?:\/\/[^\s]+)/g, function(url) {
				return '<a target="_blank" href="'+url+'+">'+url+'</a>';
			});
			return newText;
		};
    $scope.replycomment = function (reply, comments_id) {
      if (
        CustomStorageService.getUserSignedInStorageData() ||
        CustomStorageService.getInstructorSignedInStorageData()
      ) {
        if ($scope.imageUploadingInProcess) {
          swal("Uploading", "Please wait for attachment to upload", "info");
          return false;
        }
        if (!reply || reply === "") {
          swal("Empty Comment", "Please add text", "info");
          return false;
        }

        reply.userid = CustomStorageService.getUserInfoStorageData().id;
        reply.comment_id = comments_id;
        var url = "api/v1/blog/comment/reply/addblogcommentReply";
        reply.image_url = $scope.imageS3_url_reply;

        if (
          CustomStorageService.getUserInfoStorageData().user_type == "student"
        ) {
          reply.approved = false;
        } else if (
          CustomStorageService.getUserInfoStorageData().user_type ==
          "instructor"
        ) {
          reply.approved = true;
        }
        $http.post(url, { reply: reply }).then(function (res) {
          CustomStorageService.setBlogsReply(false);
          swal(
            {
              imageUrl: '../../images/Group-341.svg',
              title: "Comment Published",
              text: res.data.displaymessage,
              customClass: 'swal-wide',
              // type: "info",
              showCancelButton: false,
            },
            function () {
              location.reload();
            }
          );
        });
      } else {
        reply.comment_id= comments_id;
        reply.blogid = $scope.blog.id;
        reply.category = $state.params.category;
        CustomStorageService.setBlogsReply(reply);
        $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
        $scope.$emit('showLoginPopup');
      }
    };
    $scope.commentstore = function (comment) {
      if (
        CustomStorageService.getUserSignedInStorageData() ||
        CustomStorageService.getInstructorSignedInStorageData()
      ) {
        if ($scope.imageUploadingInProcess) {
          swal("Uploading", "Please wait for attachment to upload", "info");
          return false;
        }
        if (!comment || comment === "") {
          swal("Empty Comment", "Please add text", "info");
          return false;
        }

        comment.userid = CustomStorageService.getUserInfoStorageData().id;
        if(!comment.blogid)
          comment.blogid = $scope.blog.id;
        var url = "api/v1/blog/comment/addblogcomment";

        if (
          CustomStorageService.getUserInfoStorageData().user_type == "student"
        ) {
          comment.approved = false;
        } else if (
          CustomStorageService.getUserInfoStorageData().user_type ==
          "instructor"
        ) {
          comment.approved = true;
        }
        comment.image_url = $scope.imageS3_url_comment;
        $http.post(url, { comment: comment }).then(function (res) {
          CustomStorageService.setBlogsComment(false);
          swal(
            {
              imageUrl: '../../images/Group-341.svg',
              title: "Comment Published",
              text: res.data.displaymessage,
              customClass: 'swal-wide',
              // type: "info",
              showCancelButton: false,
            },
            function () {
              location.reload();
            }
          );
        });
      } else {
        comment.blogid = $scope.blog.id;
        comment.category = $state.params.category;
        CustomStorageService.setBlogsComment(comment);
        $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
        $scope.$emit('showLoginPopup');
      }
    };
    $scope.intialize = (function () {
      $scope.claps = 0;
      screenAdjust();
      var url=window.location.href;
      var host = window.location.protocol + "//" + window.location.host;
      onloadFunction(
        {'url': host + '/blogs',
          'displayName': 'Blogs', 
        },'LEAF'
      );
      
      $http({
        url: "/api/v1/blog/getBlogsById",
        method: "GET",
        params: { id: id },
      }).then(function (res) {
        $scope.blog = res.data.blog;
        var url=window.location.href;
        var categoryName = $scope.blog.category_id?$scope.blog.category_id.name : $state.params.category;
        console.log("🚀 ~ file: BlogDetailController.js:251 ~ categoryName:", $scope.blog)
        setTimeout(function(){
          mixpanel.track('Blog-Detail-page',{
            'Blog_ID': $scope.blog.id,
            'Blog_Name': $scope.blog.name,
            'Blog_Category': categoryName,
          });
        },5000)
        onloadFunction(
          {'url': host + '/blogs/' + categoryName,
            'displayName': categoryName, 
          },'category'
        );
        onloadFunction(
          {'url': url,
            'displayName': $scope.blog.name, 
          },'child'
        );

        $scope.blog.content = ExternalLinksService.addTargetToExternalLinks(
          $scope.blog.content
        );
        if ($scope.blog.id === 245) {
          $scope.blogContent = $scope.blog.content.replaceAll("href", "id");
          $window.addEventListener("click", function (event) {
            tags(event.target.tagName, event.target.id, event.target);
          });
        } else {
          $scope.blogContent = ExternalLinksService.addTargetToExternalLinks(
            $scope.blog.content
          );
        }
        var contentDiv = document.getElementById('blog-content');
        contentDiv.innerHTML = $scope.blogContent;
        // getting all element with attribut ta-insert-video
          // for parsing them as youtube iframe
          document.querySelectorAll('[ta-insert-video]').forEach(function(element){
            loadTaIframesForOldBlog(element)
          });
          document.querySelectorAll("table").forEach(function(element){
            replacetablewithDiv(element)
          });
        $scope.claps = $scope.blog.claps;

        $http({
          url: "api/v1/blog/getRelatedBlog",
          method: "GET",
          params: { email: $scope.blog.author_email, id: res.data.blog.id },
        }).then(function (res1) {
          $scope.blogs = res1.data;
          if($scope.blogs.length<2)
          {
            $scope.curr=0;
          }
          $timeout(function () {
            setValues();
          }, 1000);
        });
        $http({
          url: "api/v1/blog/comment/getblogcomment",
          method: "GET",
          params: { id: res.data.blog.id },
        }).then(function (res2) {
          $scope.allComments = res2.data;
          $scope.showData = true;
          for(var i = 0; i < $scope.allComments.length; i++){
            var comment = $scope.allComments[i]
            if(comment.text){
              comment.text = $scope.formatTextForLink(comment.text)
            }
            for(var j = 0; j < comment.replies.length; j++){
              var reply = comment.replies[j]
              if(reply.text){
                reply.text = $scope.formatTextForLink(reply.text)
              }
            }
          }
        });
      });
      BlogBackendServices.DisplayAllBlogs().then(function (data) {
        $scope.blogtop = data.top;
      });
      myData();
    })();
    function myData(){
      if(CustomStorageService.getBlogsComment() && CustomStorageService.getAuthTokenStorageData())
      {
        var cmt = CustomStorageService.getBlogsComment();
        var comment ={}
        comment.text=cmt.text;
        comment.blogid = cmt.blogid;
        $scope.commentstore(comment);
      }
      if(CustomStorageService.getBlogsReply() && CustomStorageService.getAuthTokenStorageData())
      {
        var rply = CustomStorageService.getBlogsReply();
        var reply ={}
        reply.text = rply.text;
        reply.blogid = rply.blogid;
        $scope.replycomment(reply,rply.commentId);
      }
    }
    $(window).scroll(myFunction);
    $scope.showComments = false;
    $scope.hideShowComments = function () {
      $scope.showComments = !$scope.showComments;
    }
    $scope.hideShow = function (comment,id) {
      if (comment.showReply && $scope.selectedTextArea==id) {
        comment.showReply = false;
        $scope.selectedTextArea =-1;
      }
      else if($scope.selectedTextArea != id) {
        comment.showReply = true;
        $scope.selectedTextArea=id;
      }
      
    };
    $scope.hideShowReply = function (reply) {
      if (reply.showReply) reply.showReply = false;
      else {
        reply.showReply = true;
      }
    };
    $scope.giveClap = function () {
      $http({
        url: "/api/v1/blog/clap/" + id,
        method: "PUT",
      }).then(function (res) {
        if (res.data.result) $scope.claps += 1;
      });
    };
    // $scope.getUserInitialLetter = function (str) {
    //   return str.charAt(0).toUpperCase();
      
    // };
    $scope.selectedCommentId=-1;
    $scope.selectedTextArea=-1;
    $scope.hideReplies = function (id){
       $scope.selectedCommentId= id;
    }

    $scope.addImage = function (image, imageFor) {
      if($scope.imageUploadingInProcess === true){
        return
      }
      if (image) {
        if (
          CustomStorageService.getUserSignedInStorageData() ||
          CustomStorageService.getInstructorSignedInStorageData()
        ) {
          if (!$scope.$$phase) $scope.$apply();
          if ( image.size > 1000000){
            return alert('Image size must be less then 1 mb');
          }
          $scope.imageUploadingInProcess = true;
          Upload.upload({
            url:
              "api/v1/uploader/uploadImageToS3?userId=" +
              CustomStorageService.getUserInfoStorageData().id +
              "&socket_id=" +
              CustomStorageService.getSocketIdStorageData(),
            method: "POST",
            file: image,
          }).then(function (data) {
            $scope.imageUploadingInProcess = false;
            $scope.imageS3_url = data.data.link;
            if(imageFor === 'comment'){
              $scope.imageS3_url_comment = data.data.link;
              $scope.imageName_comment = image.name.substring(0, 10) + '...';
            }
            if(imageFor === 'reply'){
              $scope.imageS3_url_reply = data.data.link;
              $scope.imageName_reply = image.name.substring(0, 10) + '...';
            }
            
            if (!$scope.$$phase) $scope.$apply();
          });
        }
      }
    };
    $scope.shareOnFacebook = function () {
      if($rootScope.platform_reactApp){
        
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + url,
          "_blank",
          "width=500,height=500"
        );
      }else{
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + url,
          "_blank",
          "width=500,height=500"
        );
      }

    };
    $scope.shareOnTwitter = function () {
      var text = "";
      window.open(
        "http://twitter.com/share?url=" +
          encodeURIComponent(url) +
          "&text=" +
          encodeURIComponent(text),
        "_blank",
        "left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    };

    $scope.shareOnlinkedin = function () {
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=" + url,
        "sharer",
        "_blank",
        "toolbar=0, status=0, width=626, height=436"
      );
    };
    $scope.shareGmail = function () {
      if($rootScope.platform_reactApp){
        // mailto:chriscoyier@gmail.com?subject=Important!&body=Hi
        var href =
        "mailto:''?subject=" + $scope.blog.name + "&body=" +  url;                    
      window.open(href, "_blank");
      }else{
        var href =
        "https://mail.google.com/mail?view=cm&tf=0?to=&cc=&su=" +
        $scope.blog.name +
        "&body=" +
        url;                    
      window.open(href, "_blank");
      }

    };
    $scope.shareWhatsApp = function () {  
      var message = encodeURI(url);
      message = message.replace("+", "%20");

      var agent = navigator.userAgent;

      var iphone = !!~agent.indexOf("iPhone");
      var android = !!~agent.indexOf("Android");
      var palmpre = !!~agent.indexOf("webOS");
      var berry = !!~agent.indexOf("BlackBerry");
      var ipod = !!~agent.indexOf("iPod");

      if (
        (iphone ||
          android ||
          palmpre ||
          ipod ||
          berry ||
          $rootScope.platform_reactApp) == true
      ) {
        var href = "whatsapp://send?text=" + message;
      } else {
   
          var href = "https://web.whatsapp.com/send?text=" + message;
    
      }
      window.open(href, "_blank");
    };
    $scope.closePopup = function (fromSend) {
      if(!fromSend) {
        $state.go('BlogDetail', {category: 'css', id: 'css-chronicles-a-css-magazine-by-nearpeer'}, {notify: false});
      }
      document.getElementById("popup").style.display = "none";
      $scope.isValid = true;
    };

    var track;
    var slides;
    var slideWidth;

    $scope.whatClassIsIt = function (index) {
      if (!$scope.HtmlWidthLess && index == 1) return "current-slide";
      if ($scope.HtmlWidthLess && index == 0) return "current-slide";
    };
    function setValues() {
      track = document.querySelector(".carousel_track");
      slides = Array.from(track.children);
      slideWidth = slides[0].getBoundingClientRect().width;
      for (var index = 0; index < slides.length; index++) {
        slides[index].style.left = slideWidth * index + "px";
      }
    }
    // function setValues() {
    //   track = document.querySelector(".carousel_track");
    //   slides = Array.from(track.children);
    //   for(var index=0; index<slides.length; index++){
    //     slideWidth = slides[index].getBoundingClientRect().width;
    //     slides[index].style.left = (slideWidth * index) + 'px';
    //   }
    // }

    function sendToGtag() {
      setTimeout(function() {
        gtag('set', 'page_path', $location.path());
        gtag('event', 'page_view');
      }, 500);
    }

    var downloadChronName = ''
    function tags(a, b, c) {
      b = b ? b : c.parentNode.id;
      if (a == "A" || a == "I" || a == "U") {
        var res = b.slice(0, 4);
        if (res == "http" || res == "https") {
          $scope.notesLink = b;
          document.getElementById("popup").style.display = "block";
          downloadChronName = c.innerText.replaceAll(" ", "-");
          $state.go('EnterEmailChronicles', {chronicle: downloadChronName}, {notify: false});
          sendToGtag();
        }
      }
    }


    $scope.sendNotes = function () {
      $state.go('CheckInboxChronicles', {chronicle: downloadChronName}, {notify: false});
      sendToGtag();
      
      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          $scope.userEmail
        )
      ) {
        $scope.isValid = false;
      } else {
        BlogBackendServices.sendBlogNotes(
          $scope.userEmail,
          $scope.notesLink,
          $location.absUrl()
        );
        
        $scope.closePopup(true);
      }
    };

    $scope.nextButtonMethod = function () {
      const currentSlide = track.querySelector(".current-slide");
      const nextSlide = currentSlide.nextElementSibling;
      if (nextSlide) {
        var amountToMove = nextSlide.style.left;
        if (!$scope.HtmlWidthLess) {
          amountToMove = amountToMove.replace("px", "");
          amountToMove = amountToMove - slideWidth;
          amountToMove = parseInt(amountToMove);
          if (nextSlide.nextElementSibling) {
            track.style.transform = "translateX(-" + amountToMove + "px)";
          }
        } else {
          track.style.transform = "translateX(-" + amountToMove + ")";
        }
        currentSlide.classList.remove("current-slide");
        nextSlide.classList.add("current-slide");
      }
    };

    $scope.prevButtonMethod = function () {
      const currentSlide = track.querySelector(".current-slide");
      var prevSlide = currentSlide.previousElementSibling;
      if (prevSlide) {
        var amountToMove = prevSlide.style.left;
        if ($scope.HtmlWidthLess) {
          track.style.transform = "translateX(-" + amountToMove + ")";
        } else {
          amountToMove = amountToMove.replace("px", "");
          amountToMove = parseInt(amountToMove);
          amountToMove = amountToMove - slideWidth;
          if (prevSlide.previousElementSibling) {
            if (amountToMove < 0) {
              track.style.transform = "translateX(" + amountToMove + "px)";
            } else {
              track.style.transform = "translateX(-" + amountToMove + "px)";
            }
          }
        }

        currentSlide.classList.remove("current-slide");
        prevSlide.classList.add("current-slide");
      }
    };




    // $scope.nextButtonMethod = function () {
    //   if($scope.curr+1 < $scope.blogs.length)
    //   {
    //     $scope.curr=$scope.curr+1;
    //   }
    //   else
    //   {
    //     return;
    //   }
    //   const currentSlide = track.querySelector(".current-slide");
    //   const nextSlide = currentSlide.nextElementSibling;
    //   if (nextSlide) {
    //     var amountToMove = nextSlide.style.left;
    //     if (!$scope.HtmlWidthLess) {
    //       amountToMove = amountToMove.replace("px", "");
    //       amountToMove = amountToMove - slideWidth;
    //       amountToMove = parseInt(amountToMove);
    //       if (nextSlide.nextElementSibling) {
    //         track.style.transform = "translateX(-" + amountToMove + "px)";
    //       }
    //     } else {
    //       track.style.transform = "translateX(-" + amountToMove + ")";
    //     }
    //     track = document.querySelector('.carousel_track');
    //   slides = Array.from(track.children);
    //   for(var index=0; index<slides.length; index++){
    //     slideWidth = slides[index].getBoundingClientRect().width;
    //     slides[index].style.left = (slideWidth * index) + 'px';
    //   }
    //   }
    // };
    // $scope.prevButtonMethod = function () {
    //   console.log("previousss");
    //   if($scope.curr-1 > -1)
    //   {
    //     $scope.curr=$scope.curr-1;
    //   }
    //   else
    //   {
    //     return;
    //   }
    //   const currentSlide = track.querySelector(".current-slide");
    //   var prevSlide = currentSlide.previousElementSibling;
    //   if (prevSlide) {
    //     var amountToMove = prevSlide.style.left;
    //     if ($scope.HtmlWidthLess) {
    //         track.style.transform = "translateX(-" + amountToMove + ")";
    //     } else {
    //       amountToMove = amountToMove.replace("px", "");
    //       amountToMove = parseInt(amountToMove);
    //       amountToMove = amountToMove - slideWidth;
    //       if (prevSlide.previousElementSibling) {
    //         if (amountToMove < 0) {
    //           track.style.transform = "translateX(" + amountToMove + "px)";
    //         } else {
    //           track.style.transform = "translateX(-" + amountToMove + "px)";
    //         }
    //       }
    //     }
    //     track = document.querySelector('.carousel_track');
    //   slides = Array.from(track.children);
    //   for(var index=0; index<slides.length; index++){
    //     slideWidth = slides[index].getBoundingClientRect().width;
    //     slides[index].style.left = (slideWidth * index) + 'px';
    //   }
    //   }
    // };
    

     function onloadFunction(data,level) {
            BreadcrumbService.setBreadCrumb(data,level);
            
        } 
       

       
  }
})();
(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('BlogController', MainController);
  function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, $state,$analytics,onlineStatus,$sails,BlogBackendServices) {
    $scope.showData = false;
    $scope.category = $state.params.name;
    var page = 1;
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    $scope.intialize = function () {
      BlogBackendServices.DisplayCategoryBlogs($state.params.name, 1)
      .then(function(data){
        $scope.blogfeature = data.feature;
        $scope.blogs = data.all;
        $scope.blogtop = data.top;
        $scope.showData = true;
      });
      console.log('blog-mainpage')
    }();
    $scope.loadMore =function () {
      page += page;
      BlogBackendServices.DisplayCategoryBlogs($state.params.name, page)
      .then(function(data){
        $scope.blogs = $scope.blogs.concat(data.all); 
      });
    }
    $scope.EmailSubscribe =function (subscribeEmail) {
      if(subscribeEmail) {
        BlogBackendServices.EmailSubscribeBlog(subscribeEmail);
      }
    }
  }
})();

// (function () {
//   'use strict';

//   angular
//     .module('NearPeer')
//     .controller('loginController1', MainController);

//   function MainController(courseDetailService,$rootScope,$scope, $http, CustomStorageService, $state, $sails, $cookies) {
//     $(document).ready(function(){
//       $(this).scrollTop(0);

//       document.addEventListener('AppleIDSignInOnSuccess', appleSigninSuccess);
//     });
//     $scope.$on("$destroy", function () {
//       document.removeEventListener('AppleIDSignInOnSuccess', appleSigninSuccess);
//     });
//     $rootScope.userSide = true;
   

//     $scope.encrypt = function(text){
//       return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
//     };
    
//     $scope.decrypt = function (data) {
//       return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
//     };

//     $rootScope.userSide= true;
//     $rootScope.adminSide = false;
//     $scope.loginForm = {};
//     $scope.registrationForm = {};
// $scope.userD={};
//     $scope.registrationForm = {};
//     $scope.guestMode = false;


//    $scope.userD = CustomStorageService.getUserInfoStorageData();
//     if($scope.userD.user_type === "guest"){
//       $scope.guestMode = true;
//     }


//     $scope.loginForm = {};
//     $scope.currentDate=""
//     var today = new Date();
//     var dd = today.getDate() - 1;
//     var mm = today.getMonth() + 1;
//     var yyyy = today.getFullYear();
//     if (dd < 10) {
//       dd = "0" + dd;
//     }
//     if (mm < 10) {
//       mm = "0" + mm;
//     }

// 	function init() {
//       console.log("in controller init")
//       gapi.load('auth2', function() {
//         auth2 = gapi.auth2.init({
//           client_id: '715283382661-7rfvtjhs9eaofrhkn50017d4kg7862mh.apps.googleusercontent.com',
//           cookiepolicy: 'single_host_origin',
//           scope: 'profile email'
//         });
//         element = document.getElementById('glogin');
//          auth2.attachClickHandler(element, {}, onGoogleSuccess, onGoogleFailure);
//       });
//     }
//     // window.init = init
// // Sign-in success callback
//   function onGoogleSuccess(googleUser) {
//   var profile = googleUser.getBasicProfile();
//   var browser_id = $cookies.get('browserId');

//   // The ID token you need to pass to your backend:
//   var id_token = googleUser.getAuthResponse().id_token;
//  var obj = {  user: {
//     jwt: id_token,
//     email: profile.getEmail() ? profile.getEmail() : null,
//     name: profile.getName() ? profile.getName() : null,
//     img: profile.getImageUrl()
//   },
//   browserId: browser_id
//   };

//    $http.post("/api/v1/auth/google-login", obj
// 				)
// 				.then(function(resp) {
//           if (resp.data.user.user_type === 'student' && resp.data.user.disabled === false) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             $scope.text = "Logged in as " + resp.data.user.full_name;
//             $scope.loading=false;
//             CustomStorageService.SignInService(false,true,false,false,resp.data.token,resp.data.user);
//             $rootScope.userNotLoggedIn = false;
//             swal({
//               title: "Log In Successful!",
//               text: $scope.text,
//               type: "success",
//               timer: 2000,
//               showConfirmButton: false
//             },function(){
//               swal.close();
//               $scope.$emit('userLoggedIn');
//             });
//           }   else if(resp.data.user.user_type === 'student' && resp.data.user.disabled === true){
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             swal({
//               title: "Error",
//               text: 'Account is temporarily disabled',
//               type: "error"
//             });
//           }   else {
//             $scope.loginpopUp = false;
//             $scope.loading = false
//             swal({
//               title: "Error",
//               text: 'Not Authorized',
//               type: "error"
//             },function(){
//               $scope.loginpopUp = true;
//               if (!$scope.$$phase) $scope.$apply();
//             });
//           }
//         }, function errorCallback(response) {
//           if(response.data.code == 'LIMIT_REACHED'){
//             $scope.$emit('userLoggedInAfterVerification', response.data);
//           } else {
//             swal({
//               title: 'Error',
//               text: response.data.message,
//               type: 'error'
//             })
//           }
//         });
//   }
//   window.onGoogleSuccess = onGoogleSuccess
// // Sign-in failure callback
//   function onGoogleFailure(error) {
//   console.log("error occured on login:", error)
//   }
//   window.onGoogleFailure = onGoogleFailure

  
//     today = yyyy + "-" + mm + "-" + dd;
//     $scope.currentDate = today;

//     var Rem = CustomStorageService.getRememberMeData();
//     if(Rem){
//       var decPassword = $scope.decrypt(Rem.password);
//       $scope.loginForm.email = Rem.email;
//       $scope.loginForm.password = decPassword;
//       $scope.loginForm.remember_me = Rem.remember_me;
//     };

//     $scope.rememberMe = function (check,loginForm){
//       if (check) {
//         var encPassword = $scope.encrypt(loginForm.password);
//        var rememberData = {
// email:loginForm.email,
// password: encPassword,
// remember_me : loginForm.remember_me
//        }
//       CustomStorageService.setRememberMeData(rememberData);
   
//       } else if(!check) {
// window.localStorage.removeItem("remember_me");
//       }
//     };
// 	today = yyyy + "-" + mm + "-" + dd;
//     $scope.currentDate = today;
//     $scope.submitLogin = function(loginForm) {
//       var browserId = $cookies.get('browserId');

//       loginForm.browser_id = browserId;
//       loginForm.origin = 'LEGACY';
//       $scope.loginpopUp = false;
//       $scope.userEmail = loginForm.email;
//       if (!loginForm.email || !loginForm.password) {
//         swal({
//           title: 'Incomplete Data',
//           text: 'Please fill in all fields',
//           type: 'error'
//         }, function (confirm) {
//           $scope.loginpopUp = true;
//           if (!$scope.$$phase) $scope.$apply();
//         })
//         return;
//       }
//       $scope.loading = true;
//       $scope.loginpopUp = true;
//       $scope.loginFromPopup = true;
//       $http.post('/api/v1/auth/signin', loginForm)
//         .then(function (resp) {
//           if (resp.data.user.user_type === 'student' && resp.data.user.disabled === false) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             $scope.text = "Logged in as " + resp.data.user.full_name;
//             $scope.loading = false;
//             CustomStorageService.SignInService(false, true, false, false, resp.data.token, resp.data.user);
//             const isPrivacy = resp.data.isPrivacy ? 'true' : 'false';
//             CustomStorageService.setTermStatus(isPrivacy);
//             $rootScope.userNotLoggedIn = false;
//             swal({
//               title: "Log In Successful!",
//               text: $scope.text,
//               type: "success",
//               timer: 2000,
//               showConfirmButton: false
//             }, function () {
//               swal.close();
//               $scope.$emit('userLoggedIn');
//             });
//           } else if (resp.data.user.user_type === 'student' && resp.data.user.disabled === true) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             swal({
//               title: "Error",
//               text: 'Account is temporarily disabled',
//               type: "error"
//             });
//           } else {
//             $scope.loginpopUp = false;
//             $scope.loading = false
//             swal({
//               title: "Error",
//               text: 'Not Authorized',
//               type: "error"
//             }, function () {
//               $scope.loginpopUp = true;
//               if (!$scope.$$phase) $scope.$apply();
//             });
//           }
//         }, function errorCallback(response) {
//           if (response.data.code == 'E_USER_NOT_CONFIRMED') {
//             swal({
//               title: 'Unconfirmed Account',
//               text: response.data.message,
//               type: 'info',
//               confirmButtonText: "Resend Mail",
//               showCancelButton: true
//             }, function (confirm) {
//               if (confirm) {
//                 var data = { email: $scope.userEmail }
//                 $http.post('api/v1/users/requestConfirmationMail', data)
//                   .then(function (data) {
//                     if (data.data.success) {
//                       swal({
//                         title: 'Confirmation instruction sent',
//                         text: 'Please activate your account by clicking on the link sent to your provided email address',
//                         type: 'info'
//                       })
//                     }
//                   })
//               }
//             })

//           } else if(response.data.code == 'LIMIT_REACHED'){
//             $scope.$emit('userLoggedInAfterVerification', response.data);
//           } else if(response.data.code == 'ACCESS_BLOCKED'){
//             $scope.$emit('userLoggedInBlockedUnconfirmed', response.data);
//           } else {
//             swal({
//               title: 'Error',
//               text: response.data.message,
//               type: 'error'
//             })
//           }
//         });
//     };

//     $scope.enterAsGuest = function () {
//       var browserId = $cookies.get('browserId');
//       if(!browserId) {
//         browserId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
//         $cookies.put('browserId', browserId);
//       }
  
//       var data = {
//         browser_id: browserId,
//         origin: 'LEGACY',
//       }
//       // console.log("Browser ID", browserId);
//       $http.post("/api/v1/auth/signup-as-guest", data)
//         .then(function (resp) {
//           if (resp.data.user) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             $scope.text = "Logged in as " + resp.data.user.full_name;
//             $scope.loading = false;
//             CustomStorageService.SignInService(false, true, false, false, resp.data.token, resp.data.user);
//             const isPrivacy = resp.data.isPrivacy ? 'true' : 'false';
//             CustomStorageService.setTermStatus(isPrivacy);
//             $rootScope.userNotLoggedIn = false;
//             swal({
//               title: "Log In Successful!",
//               text: $scope.text,
//               type: "success",
//               timer: 2000,
//               showConfirmButton: false
//             }, function () {
//               swal.close();
//               $scope.$emit('userLoggedIn');
//             });
//           }
//         }
//         )

//     };


//     $scope.closeForm = function () {
//       $scope.loginpopUp = true;
//       $scope.$emit('closeForm');
//     }

//     $scope.authenticateFacebook = function () {
//       var url = location.protocol + '//' + location.host + '/api/v1/auth/facebookSignin?uniqueId=' + CustomStorageService.getSocketIdStorageData();
//       window.open(url, "_blank", "width=500,height=500");
//     }

//     $scope.authenticateApple = function () {
//       AppleID.auth.signIn().then(function (authData) { console.log(authData); });
//     }

//     function appleSigninSuccess(data) {
//       $http.post("/api/v1/auth/app-apple-login",
//         {
//           user: {
//             jwt: data.detail.authorization.id_token,
//             email: data.detail.user ? data.detail.user.email : null,
//             name: data.detail.user ? data.detail.user.name : null,
//           }
//         })
//         .then(function (resp) {
//           if (resp.data.user.user_type === 'student' && resp.data.user.disabled === false) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             $scope.text = "Logged in as " + resp.data.user.full_name;
//             $scope.loading = false;
//             CustomStorageService.SignInService(false, true, false, false, resp.data.token, resp.data.user);
//             $rootScope.userNotLoggedIn = false;
//             swal({
//               title: "Log In Successful!",
//               text: $scope.text,
//               type: "success",
//               timer: 2000,
//               showConfirmButton: false
//             }, function () {
//               swal.close();
//               $scope.$emit('userLoggedIn');
//             });
//           } else if (resp.data.user.user_type === 'student' && resp.data.user.disabled === true) {
//             $scope.loading = false;
//             $scope.loginpopUp = false;
//             swal({
//               title: "Error",
//               text: 'Account is temporarily disabled',
//               type: "error"
//             });
//           } else {
//             $scope.loginpopUp = false;
//             $scope.loading = false
//             swal({
//               title: "Error",
//               text: 'Not Authorized',
//               type: "error"
//             }, function () {
//               $scope.loginpopUp = true;
//               if (!$scope.$$phase) $scope.$apply();
//             });
//           }
//         }, function errorCallback(response) {
//           if(response.data.code == 'LIMIT_REACHED'){
//             $scope.$emit('userLoggedInAfterVerification', response.data);
//           } else {
//             swal({
//               title: 'Error',
//               text: response.data.message,
//               type: 'error'
//             })
//           }
//         });
//     };

//     $scope.forgotPassword = function () {
//       $scope.$emit('closeForm');
//       $state.go('forgot-password');
//     }
//     $scope.postSignup = function (signUp){
//       signUp.browser_id = $scope.userD.browser_id;
//       signUp.id = $scope.userD.id;
//       signUp.user_type = "student";
//       if (!signUp.full_name || !signUp.email || !signUp.phone || !signUp.password || !signUp.confirmPassword || !signUp) {
//         swal({
//           title: "Error!",
//           text: "Please enter complete information",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
//       if (!signUp.email.includes('@')) {
//         swal({
//           title: "Error",
//           text: "Please enter valid email address",
//           type: "error"
//         })
//         return;
//       }
//       if (signUp.phone.length  !== 12 || !signUp.phone.startsWith('92')) {
//         swal({
//           title: "Error",
//           text: "Please enter complete contact no Ex: 923*********",
//           type: "error"
//         })
//         return;
//       }
//       if (signUp.password.length < 8) {
//         swal({
//           title: "Error!",
//           text: "Password is short!",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
//       if (signUp.password != signUp.confirmPassword) {
//         swal({
//           title: "Error!",
//           text: "Passwords don't match!",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
    
//       var d = new Date(signUp.dob);
//       signUp.dob = d;
//       signUp.origin = 'LEGACY';
      
//       // $scope.disableRegBtn = true;
//       signUp.origin_url = location.protocol + '//' + location.host;
//       $http.post('/api/v1/auth/register-guest', signUp)
//         .then(function (resp) {
//           $scope.disableRegBtn = false;
//           $scope.signupPopUp = false;
//           if (resp.data.error) {
//             swal({
//               title: "Error",
//               text: resp.data.msg,
//               type: "error"
//             })
//           } else if(resp.data.success) {
//             swal({
//               title: "Account Created Successfully",
//               text: "Please Verify Your Account to Enjoy Full Access.",
//               type: "success",
//               timer: 2000
//             }, function () {
//               swal.close();
//               $scope.$emit('userLoggedIn');
//               var oldToken= CustomStorageService.getAuthTokenStorageData();
//               CustomStorageService.SignInService(false, true, false, false, oldToken, resp.data.user);
//               const isPrivacy = resp.data.isPrivacy ? 'true' : 'false';
//               CustomStorageService.setTermStatus(isPrivacy);
//               $rootScope.userNotLoggedIn = false;
//               location.reload();
//             });
//           }else if(resp.data.message.error === "E_VALIDATION"){
//             swal({
//               title: "Error",
//               text: "Account Already Exists,Try with another Email!",
//               type: "error"
//             })
//           } else{
//             swal({
//               title: "Error",
//               text: "Something Went Wrong ,Try Again!",
//               type: "error"
//             })
//           }
//         })
//     }
//     $scope.submitRegistration = function (registrationForm) {
//       registrationForm.user_type = "student";
//       if (!registrationForm.full_name || !registrationForm.email || !registrationForm.phone || !registrationForm.password || !registrationForm.confirmPassword || !registrationForm) {
//         swal({
//           title: "Error!",
//           text: "Please enter complete information",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
//       if (!registrationForm.email.includes('@')) {
//         swal({
//           title: "Error",
//           text: "Please enter valid email address",
//           type: "error"
//         })
//         return;
//       }
//       if (registrationForm.phone.length  !== 12 || !registrationForm.phone.startsWith('92')) {
//         swal({
//           title: "Error",
//           text: "Please enter complete contact no Ex: 923*********",
//           type: "error"
//         })
//         return;
//       }
//       if (registrationForm.password.length < 8) {
//         swal({
//           title: "Error!",
//           text: "Password is short!",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
//       if (registrationForm.password != registrationForm.confirmPassword) {
//         swal({
//           title: "Error!",
//           text: "Passwords don't match!",
//           type: "error",
//           confirmButtonText: "Ok"
//         });
//         return;
//       }
//       if (!registrationForm.image) {
//         registrationForm.image = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/default_user.png';
//       }
//       var d = new Date(registrationForm.dob);
//       registrationForm.dob = d;
//       $scope.disableRegBtn = true;
//       registrationForm.origin_url = location.protocol + '//' + location.host;
//       $http.post('/api/v1/auth/signup', registrationForm)
//         .then(function (resp) {
//           $scope.disableRegBtn = false;
//           if (resp.data.error) {
//             swal({
//               title: "Error",
//               text: resp.data.msg,
//               type: "error"
//             })
//           } else {
//             // $scope.$emit('userSignupVerification', resp.data);
//             swal({
//               title: "Success",
//               text: "Account Created Successfully",
//               type: "success",
//               timer: 2000
//             }, function () {
//               swal.close();
//               CustomStorageService.SignInService(false, true, false, false, resp.data.token, resp.data.user);
//               $rootScope.userNotLoggedIn = false;
//               $scope.$emit('userLoggedIn');
//             });
//           }
//         })
//     };

//     $scope.loginButtonIsDisabled = true;
//     $scope.$watch('loginForm', function () {
//       if (!$scope.loginForm.email || !$scope.loginForm.password) {
//         $scope.loginButtonIsDisabled = true;
//       } else {
//         $scope.loginButtonIsDisabled = false;
//       }
//     }, true);

//     $scope.signupButtonIsDisabled = true;
//     $scope.$watch('registrationForm', function () {
//       if (!$scope.registrationForm.full_name || !$scope.registrationForm.email || !$scope.registrationForm.phone || !$scope.registrationForm.password || !$scope.registrationForm.confirmPassword) {
//         $scope.signupButtonIsDisabled = true;
//       } else {
//         $scope.signupButtonIsDisabled = false;
//       }
//     }, true);


//   };
// })();

(function () {
    "use strict";
    angular.module("NearPeer").controller("b2bController", MainController);
    function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    b2bService,
    $http,
    $base64,
    $timeout,
    $state,BlogBackendServices,
    BreadcrumbService
    ) 
    {
      // $scope.user='Angular';

        $scope.b2bUserEmail = '';
        $scope.b2bUserName = '';
        $scope.b2bUserPhone = '';
        $scope.b2bUserCompany = '';
        $scope.b2bUserMessage = '';
        $scope.visile = true;
        setTimeout(function () {
          $("#b2bCountry").countrySelect({
            defaultCountry: "pk",
            preferredCountries: ["pk"],
            localizedCountries: {},
          });
          $(".country-select").css("margin-top", "0px");
        }, 300);
      $scope.error = {}
      $scope.b2bUserEmail = '',
      $scope.clear = function(){
        $scope.visile = false;
        $scope.b2bUserEmail = '';
        $scope.b2bUserName = '';
        $scope.b2bUserPhone = '';
        $scope.b2bUserCompany = '';
        $scope.b2bUserMessage = '';
        $scope.visile = true;
        document.getElementById("submitBtn").click();
        $timeout(function(){
          $scope.error = {};
        },100);
        return;
      }
      $scope.takeToForm = function(){
        document.getElementById('b2b_contact_us').scrollIntoView();
      }
      $scope.submitb2bForm = function () {
        
        $scope.error = {};
        var selectedCountry =  $("#b2bCountry").countrySelect("getSelectedCountryData");
          $scope.b2bslected = selectedCountry.phone_code;

        if($scope.b2bUserPhone.startsWith('0')) {
          $scope.b2bUserPhone = $scope.b2bUserPhone.substring(1);
        }

        if ($scope.b2bUserPhone.length  < 10 || (!$scope.b2bUserPhone.startsWith('3') && $scope.b2bslected.countryCode == '92') || ($scope.b2bUserPhone.length !== 10 && $scope.b2bslected.countryCode == '92')){
          $scope.error.b2bUserPhone = 'Enter Valid phone Ex. 3*******';
        }

        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!(($scope.b2bUserEmail).match(mailformat))){
          $scope.error.b2bUserEmail = 'Email format is not correct';
        }
        
        if(!$scope.b2bUserEmail){
          $scope.error.b2bUserEmail = 'This field is required';
        }
        if(!$scope.b2bUserName){
          $scope.error.b2bUserName = 'This field is required';
        }
        if(!$scope.b2bUserPhone){
          $scope.error.b2bUserPhone = 'This field is required';
        }
        if(!$scope.b2bUserCompany){
          $scope.error.b2bUserCompany = 'This field is required';
        }
        if(!$scope.b2bUserMessage){
          $scope.error.b2bUserMessage = 'This field is required';
        }
        if(Object.keys($scope.error).length){
          return  false;
        }
        fetch('/api/v1/b2b/saveb2bleadform', {
          method:'POST',
          body: JSON.stringify(
            {
            "name": $scope.b2bUserName,
            "email": $scope.b2bUserEmail,
            "phone_number":  $scope.b2bslected + $scope.b2bUserPhone,
            "company_name": $scope.b2bUserCompany,
            "description": $scope.b2bUserMessage,
            }
          )
      })
      .then(function(res){
        return res.json();
      })
      .then (function (res) {
        if(res.success){
          $scope.clear();
          swal({
            title: "Thank You",
            text: "We will be contacting you shortly",
            type: "success",
            confirmButtonText: "Ok"
          });
          // $scope.b2bForm.b2bUserEmail = '';
          // $scope.b2bForm.b2bUserName = '';
          // $scope.b2bForm.b2bUserPhone = '';
          // $scope.b2bForm.b2bUserCompany = '';
          // $scope.b2bForm.b2bUserMessage = '';
        }

      })

        // console.log($scope.b2bFormData);
        // if (b2bForm.$submitted) {
        //  console.log('working');

        // }else{
        //   fetch('/api/v1/b2b/saveb2bleadform', {
        //       method:'POST',
        //       data : {
        //         "name": $scope.b2bFormData.b2bUserName,
        //         "email": $scope.b2bFormData.b2bUserEmail,
        //         "phone_number": $scope.b2bFormData.b2bUserPhone,
        //         "company_name": $scope.b2bFormData.b2bUserCompany,
        //         "description": $scope.b2bFormData.b2bUserMessage,
        //     }
        //   })
        //   // $http({
        //   //   url: '/api/v1/b2b/saveb2bleadform',
        //   //   method : 'POST',
        //   //   data : {
        //   //     "name": $scope.b2bFormData.b2bUserName,
        //   //     "email": $scope.b2bFormData.b2bUserEmail,
        //   //     "phone_number": $scope.b2bFormData.b2bUserPhone,
        //   //     "company_name": $scope.b2bFormData.b2bUserCompany,
        //   //     "description": $scope.b2bFormData.b2bUserMessage,
        //   // }
        //   // })
        //   .then ( function (res) {
        //     if(res.data.success){
        //       swal({
        //         title: "Form Data",
        //         text: "Your data has been sent",
        //         type: "success",
        //         confirmButtonText: "Ok"
        //       });
        //     }
        //   });
        //   // b2bService.b2bUserData($scope.b2bFormData);
        // }

        

      }
      
      
        

      // Animation initialize
      new WOW().init();
      
      // Pricing Slider
      var b2b_pricing_slider = new Splide( '.b2b_pricing', {
        // perPage: 3,
        type:'fade',
        perMove: 1,
        gap: 20,
        drag: false,
        arrows    : false,
        breakpoints : {
          1024: {
            gap: 0,
            // perPage: 1,
            drag: true,
            arrows: true,
            pagination: true,
            autoHeight:true,
          },
        },
      } );

      b2b_pricing_slider.on( 'pagination:mounted', function( data ) {
        // data.items contains all dot items
        data.items.forEach( function( item ) {
          item.button.textContent = String( item.page + 1 );
        } );
      } );
      // Testimonial Slider
      var b2b_testimonial_slider = new Splide( '.b2b_testimonial_slider', {
        type      : 'fade',
        autoplay  : true,
        rewind    : true,
        pagination: false,
        arrows    : true,
      } );

      // main.on( 'autoplay:playing', function ( rate ) {
      //   console.log( rate ); // 0-1
      // } );
      // Testimonial Slider thumbnails
      var b2b_testimonial_thumbnail = new Splide( '#thumbnail-slider', {
        perPage: 3,
        fixedWidth  : 167,
        fixedHeight : 167,
        arrows: false,
        gap         : 10,
        rewind      : true,
        pagination  : false,
        cover       : true,
        isNavigation: true,
        breakpoints : {
          1024: {
            fixedWidth : 100,
            fixedHeight: 100,
          },
          767: {
            fixedWidth : 64,
            fixedHeight: 64,
          },
        },
      } );
      // sliders initializing
      b2b_testimonial_slider.sync( b2b_testimonial_thumbnail );
      b2b_testimonial_slider.mount();
      b2b_testimonial_thumbnail.mount();
      b2b_pricing_slider.mount();
        
      function onloadFunction(data) {
      BreadcrumbService.setBreadCrumb(data,'LEAF');        
    } 
    onloadFunction(
          {
            'url': '/contact-us' , 'displayName': 'For Business',
          }
          ,'LEAF');

    };
    })();
    
(function () {
  "use strict";

  angular.module("NearPeer").controller("workwithusController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $base64,
    $timeout,
    $state,
    BreadcrumbService
  ) {
    $scope.gotoLink = function (link) {
      window.open("https://forms.gle/" + link, "_blank");
    };

    $scope.gotoLink = function (link) {
      window.open("https://forms.gle/" + link, "_blank");
    };

    function onloadFunction(data) {
      BreadcrumbService.setBreadCrumb(data, "LEAF");
    }

    $scope.gotoCustomLink = function (link) {
      window.open(link, "_blank");
    };
    onloadFunction(
      {
        url: "/work-with-us",
        displayName: "Work with us",
      },
      "LEAF"
    );
  }
})();

(function() {
    'use strict';

    angular
        .module('NearPeer')
        .controller('PaymentPlansController', MainController);

    function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, $state) {
    	$(document).ready(function(){
			$(this).scrollTop(0);
		});
        $scope.filterDropDownMonth=false;
        $scope.monthfilter="1 Month";
        $scope.boxSelect="1";

        $scope.checkmarkSelected= function(val) {
            this.boxSelect=val;
            console.log(this.boxSelect+"selection");
        }

        $scope.openfilterDropDownMonth = function () {
            this.filterDropDownMonth=!this.filterDropDownMonth;
        };
        $scope.openfilterDropDown1Month = function () {
            this.filterDropDownMonth=false;
            this.monthfilter="1 Month";
            console.log("month 1");
        };
        $scope.openfilterDropDown3Month = function () {
            this.filterDropDownMonth=false;
            this.monthfilter="3 Month";
            console.log("month 3");
        };
        $scope.openfilterDropDown6Month = function () {
            this.filterDropDownMonth=false;
            this.monthfilter="6 Month";
        };

        $scope.filterDropDownYear=false;
        $scope.yearfilter="1 Year";

        $scope.openfilterDropDownYear = function () {
            this.filterDropDownYear=!this.filterDropDownYear;
        };
        $scope.openfilterDropDown1Year = function () {
            this.filterDropDownYear=!this.filterDropDownYear;
            this.yearfilter="1 Year";
        };
        $scope.openfilterDropDown3Year = function () {
            this.filterDropDownYear=!this.filterDropDownYear;
            this.yearfilter="3 Year";
        };
        $scope.openfilterDropDown6Year = function () {
            this.filterDropDownYear=!this.filterDropDownYear;
            this.yearfilter="6 Year";
        };

        $scope.filterDropDownSession=false;
        $scope.sessionfilter="October 2016";

        $scope.openfilterDropDownSession = function () {
            this.filterDropDownSession=!this.filterDropDownSession;
        };
        $scope.openfilterDropDown1Session = function () {
            this.filterDropDownSession=!this.filterDropDownSession;
            this.sessionfilter="October 2016";
        };
        $scope.openfilterDropDown2Session = function () {
            this.filterDropDownSession=!this.filterDropDownSession;
            this.sessionfilter="March 2017";
        };


	}

})();
(function() {
    'use strict';

    angular
        .module('NearPeer')
        .controller('PaymentOptionsController', MainController);

    function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, $state, BreadcrumbService) {
    	$(document).ready(function(){
			$(this).scrollTop(0);
		});
		$scope.epState = false;
        $scope.jcState = false;
        $scope.obtState = false;
        $scope.fbdState = false;
        $scope.atmState = false;
        $scope.ccState = false;
        $scope.ibtState = false;

        $scope.rotate180 = function (id) {
            if (id === 'ep') {
                ($scope.epState) ? $scope.epState = false : $scope.epState = true
            } else if (id === 'jc') {
                ($scope.jcState) ? $scope.jcState = false : $scope.jcState = true
            } else if (id === 'obt') {
                ($scope.obtState) ? $scope.obtState = false : $scope.obtState = true
            } else if (id === 'fbd') {
                ($scope.fbdState) ? $scope.fbdState = false : $scope.fbdState = true
            } else if (id === 'atm') {
                ($scope.atmState) ? $scope.atmState = false : $scope.atmState = true
            } else if (id === 'cc') {
                ($scope.ccState) ? $scope.ccState = false : $scope.ccState = true
            } else if (id === 'ti') {
                ($scope.ibtState) ? $scope.ibtState = false : $scope.ibtState = true
            }
        };

        function onloadFunction(data) {
            BreadcrumbService.setBreadCrumb(data,'LEAF');
            
        } 
        onloadFunction({'url': '/payment-options' ,'displayName': 'Payment Options' },'LEAF');

	}

})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('HeaderController', MainController);

  function MainController(courseDetailService, $rootScope, $window,$scope, $http, deviceDetector, $base64, $location, CustomStorageService, $state,$cookies, $analytics, onlineStatus, $sails, env, BlogBackendServices, toaster, notificationSocket, BreadcrumbService) {
    var validStates = [ ];
    var allowedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'icloud.com', 'ymail.com'];
    $scope.suspiciousUser = false;
    $scope.showNewLoginDiv = false;
    $scope.noInternet = false;
    $rootScope.fbShow = false;
    $rootScope.loginFormSelected = false;
    $rootScope.signupFormSelected = false;
    $scope.userVisits = "";
    $scope.formattedNumber = "";
    $scope.userInfo = {};
    $scope.OTP = false;
    $scope.logoutAll = false;
    $scope.enterOTP = false;
    $scope.userEmail = "";
    $scope.userPhone = "";
    $scope.userID = "";
    $scope.phoneSelected = false;
    $scope.emailSelected = false;
    $scope.digit1 = "";
    $scope.digit2 = "";
    $scope.digit3 = "";
    $scope.digit4 = "";
    $scope.digit5 = "";
    $scope.digit6 = "";
    $scope.user = {};
    $scope.banner = false;
    $scope.guestUser = false;
    $scope.signupPopUp = false;
    $scope.emailVerification = false;
    $scope.emailSent = false;
    $scope.showPromo = false;
    $scope.signUp = {};
    $scope.missingEmail = false;
    $scope.mergeAccount = false;
    $scope.mergeMain = false;
    $scope.mergeSuccess = false;
    $scope.mergeWait = false;
    $scope.currentDevice = true;
    $scope.userAccounts;
    $scope.editable = true;
    $scope.errorMessage = "";
    $scope.env = env;
    $scope.isBlog = false;
    $scope.before=true;
    $scope.notificationClicked = false;
    $scope.joiningDate = "";
    $scope.enrolledCourses = 0 ;
    $scope.paidCourses = 0;
    $scope.currentDate="";
    $scope.footerSecondry = false;
    $scope.secondryFooterEmail = "";
    $scope.missingCredentials={
      countryCode: '92'
    };
    $scope.courseSearch = false;
    $scope.editable = true;
    $scope.errorMessage = "";
    $scope.env = env;
    $scope.reactAllCourses = 0;
    $rootScope.userVerified = false;
    $scope.profileCompletePercentage = 0;
    $scope.percentageCompleted = 0;
    $scope.courseSearchList = false
    $scope.token = CustomStorageService.getAuthTokenStorageData();
    var width = window.screen.width * window.devicePixelRatio;
    var height = window.screen.height * window.devicePixelRatio;
    $scope.ordersCount = 0;
    $scope.notifications = [];
    $scope.unreadNotification = 0;
    $scope.isLoading = false;
    if(!$rootScope.platform_reactApp_new){
      $scope.appNotification = true
    }

    var dimensions = {
      width: width,
      height: height,
      dimensions: height + "x" + width,
    };

    var playSound = function() {
      var audio = new Audio("https://storage.googleapis.com/nps3storage/nearpeer-imagees/undefined/notification-tone-swift-gesture-1664803917214.mp3");
      audio.play();
    };

    notificationSocket.on('new-notification', function (message) {
			console.log(message);
      setTimeout(function() {
        toaster.pop({
          type: 'info',
          body: 'bind-notification-toaster-html',
          bodyOutputType: 'directive',
          directiveData: message
        });
      }, 2000)
      getNotifications();
      playSound();
		});

    $http({
      method: 'GET',
      url: '/api/v1/env/get-app-configs',
      headers: {},
    })
    .then(function(res) {
      if(res && res.data && res.data.configs ) {
        $rootScope.appConfigs = res.data.configs;
      }
    },function errorCallback(response) {
    })

    var isFreeCourses = $location.search().free;
    $scope.isFree = isFreeCourses;
    if(isFreeCourses){
      $rootScope.freeCourseController = isFreeCourses;
    }
    var isQR = $location.search().is_qr
    $scope.isQRCode = isQR;
    $scope.orderPhoneVerification = false;
    $scope.$on('verify-before-order', function (event, message) {
      if($rootScope.isTrustedDomain) {
        $scope.openEmailVerification()
      } else {
        $scope.orderPhoneVerification = true;
        $scope.openPhoneVerification()
      }
      
    });

    if(isQR && !CustomStorageService.getUserInfoStorageData()) {
      $scope.phoneVerification = true;
      $scope.otpVerification = 'phoneVerify';
      $scope.editable = false;
      $scope.forceEnter = true;
      setTimeout(function() {
        $("#country-phone-verify").countrySelect({
          defaultCountry: "pk",
          preferredCountries: ['pk'],
          localizedCountries: {},
        });
        $(".country-select").css("margin-top", "0px");
      // console.log("popup-open");
      }, 1000)
    }
    ttq.track('Browse', {value: window.location.href});
    if(isQR) {
      $http
        .post(
          env.backendService + "/trackingservice/v1/websites-tracking/save-qr-code-stats",
          {}
        )
        .then(
          function (resp) {
          },
          function errorCallback(response) {
          }
        );
    }

    $(window).on("load", function () {
      // console.log('12121212121212'){
        var firstVisit = CustomStorageService.getAppFreeAccessPopup();

        console.log("...................",firstVisit);
      if(firstVisit === 0){
        CustomStorageService.setAppFreeAccessPopup(true);
      }
      // if($scope.phoneVerification){
      //   setTimeout(function() {
      //     $("#country-phone-verify").countrySelect({
      //       defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
      //       preferredCountries: ['pk'],
      //       localizedCountries: {},
      //     });
      //     $(".country-select").css("margin-top", "0px");
      //   }, 800)
      // }

    });
    var waitForPopup = function () {
      setTimeout(function(){
        if(!$rootScope.isWindowloaded){
            $scope.popupForPhone();
          }else{
            $scope.phoneVerification = true;
            console.log("popup-open");
            setTimeout(function() {
              $("#country-phone-verify").countrySelect({
                defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
                preferredCountries: ['pk'],
                localizedCountries: {},
              });
              $(".country-select").css("margin-top", "0px");

            // console.log("popup-open");
            }, 800)
          }
        // $scope.popupForPhone(i+1)
      }, 100);
    };
    var waitForPopupClose = function () {
      if (!$rootScope.isWindowloaded) {
        setTimeout(waitForPopupClose, 100);
      } else {
        console.log("popup-close");
        $scope.phoneVerification = false;
        // location.reload();
      }
    };
    var waitForPopupCloseEmail = function () {
      if (!$rootScope.isWindowloaded) {
        setTimeout(waitForPopupCloseEmail, 100);
      } else {
        console.log("popup-close");
        $scope.emailVerification = false;
        // location.reload();
      }
    };

    setTimeout(function() {
      if ($rootScope.platform_reactAppOld && !isFreeCourses) {
        // $scope.showMobileAppUpdate = true;
      }
    }, 2000)

    var getCustomForms = function() {
      $http
        .get(
          "/api/v1/custom-form/get-custom-form-for-user"
        )
        .then(function (data) {
          $rootScope.customForms = data.data.result;
        },function(err){
        });
    }

    // getCustomForms();
    
    
    $scope.popupForPhone = function(){
      setTimeout(function(){
        if(!$rootScope.isWindowloaded){
            $scope.popupForPhone();
          }else{
            $scope.phoneVerification = true;
            console.log("popup-open");
            setTimeout(function() {
              $("#country-phone-verify").countrySelect({
                defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
                preferredCountries: ['pk'],
                localizedCountries: {},
              });
              $(".country-select").css("margin-top", "5px");
 

            // console.log("popup-open");
            }, 800);

            $scope.$apply();
          }
        // $scope.popupForPhone(i+1)
      }, 100);
      
    }
    $scope.popupForEmail = function(){
      setTimeout(function(){
        if(!$rootScope.isWindowloaded){
            $scope.popupForEmail();
          }else{
            $scope.emailVerification = true;
            
            console.log("popup-open");
            $scope.$apply();

          }
        // $scope.popupForPhone(i+1)
      }, 100);
      
    }

    if ($rootScope.platform_reactApp) {
      var dataAllCourses = window.localStorage.getItem("allCourses");
      if (dataAllCourses != null) {
        $scope.reactAllCourses = parseInt(dataAllCourses);
      }
    }
    
    if ($rootScope.platform_desktop) {
      $rootScope.styl = {
        "margin-top": "20px",
      };
      setTimeout(function () {
        document.getElementById("arrows_div").style.display = "block";
        document.getElementById("arrows_div").style.position = "fixed";
        document.getElementById("arrows_div").style.zIndex = 999;
        document.getElementById("arrows_div").style.backgroundColor = "white";
        document.getElementById("arrows_div").style.top = "0";
        document.getElementById("arrows_div").style.width = "100%";
        document.getElementById("arrows_div").style.padding = "0 15px";
      }, 500);

      if (!$rootScope.opened) {
        $rootScope.opened = true;
        $http.get("/api/v1/env/check-app-version").then(function (data) {
          if (data.data.needUpdate && $state.current.name == "Landing") {
            $scope.showUpdateApp = true;
            $scope.remainingSec = 15;
            var skipInterval = setInterval(function () {
              $scope.remainingSec = $scope.remainingSec - 1;
              $scope.$apply();
              if ($scope.remainingSec < 1) {
                clearInterval(skipInterval);
              }
            }, 1000);
          }
        });
      }
    }
if($rootScope.platform_reactApp){
  console.log($state.current.name, "state header");
  console.log("PLATFORM", $rootScope.platform_reactApp);
}


    if ($state.current.name !== "Landing" && $rootScope.platform_reactApp) {
      console.log("not-landing");
    }

    // $scope.removeNotificationIcon = function(){
    //   var notiClick = document.getElementsByClassName("new-noti")
    //   notiClick.onClick(){
    //     $scope.notificationClicked = true;
    //   }
    // };
    $scope.closePopup = function () {
      if ($scope.remainingSec < 1) {
        $scope.showUpdateApp = false;
      }
    };
    $scope.DownloadApp = function () {
      $scope.showUpdateApp = false;
      window.open("https://nearpeer.org/downloadapp", "_blank");
    };

    $scope.copyLink = function () {
      var textArea = document.createElement("textarea");
      textArea.value = "https://nearpeer.org/downloadapp";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      textArea.remove();
    };
    $scope.updateMobileApp = function () {
      console.log('https://play.google.com/store/apps/details?id=org.nearpeer.learning&forApp=qisstpay.com');
    };
    

    $rootScope.goForward = function () {
      $window.history.forward();
    };
    $rootScope.goBack = function () {
      $window.history.back();
    };
    $rootScope.reload = function () {
      location.reload();
    };
    if (
      !(
        window.location.href.indexOf("/admin") > -1 ||
        window.location.href.indexOf("/instructor") > -1
      )
    ) {
      $rootScope.fbShow = true;
    }

    $http
      .get(
        "https://apigateway.nearpeer.org/trackingservice/v1/websites-tracking/get-websites-visits?portal=velocity-portal"
      )
      .then(function (data) {
        $scope.formattedNumber = $scope.numFormatter(data.data.visits);
        $scope.userVisits = $scope.formattedNumber;
      });

    // $rootScope.hideFooter = true;
    var today = new Date();
    var dd = today.getDate() - 1;
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    today = yyyy + "-" + mm + "-" + dd;
    $scope.currentDate = today;
    $scope.breadCrumb = true;
    $scope.closeWebview = function() {
      console.log('close-webview')
    }
    $scope.$on("$stateChangeSuccess",  function (event) {
      console.log('state-change-new-page')
      console.log('page-url-change|'+$location.absUrl());
      // mixpanel.track('Page click |' +$location.absUrl(),{
      //   'Page Name' : $location.absUrl(),

      // });
      gtag('set', 'page_path', $location.path());
      gtag('event', 'page_view');
      console.log($state.current.name, "TEST");
      $scope.isLanding = $state.current.name;
      var stopBreadCrumb = ['Landing'];
      if(stopBreadCrumb.includes($scope.isLanding) || $scope.isLanding.includes('ssignment') || $rootScope.platform_reactApp_new) {
        $scope.breadCrumb = false;
      } else {
        $scope.breadCrumb = true;
      }

      // $scope.footerSecondry = !$state.current.name;
      
      if ($rootScope.platform_reactApp) {
        console.log($state.current.name);
        if ($state.current.name == "storeel" || $state.current.name == "Story-Unique-Link" || $state.current.name == "Reel-Unique-Link") {
          console.log('Complete-Profile');
        } else {
          console.log('on-landing');
        }
        if ($state.current.name == "AllCourses") {
          $scope.reactAllCourses = 1;
           window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
        } else if (
          $state.current.name == "Course" &&
          $scope.reactAllCourses === 1
        ) {
          $scope.reactAllCourses = 2;
           window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
        } else if (
          $state.current.name == "course_module" &&
          $scope.reactAllCourses === 2
        ) {
          $scope.reactAllCourses = 3;
           window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
        }else if (
          $state.current.name == "Course" &&
          $scope.reactAllCourses === 3
        ) {
          $scope.reactAllCourses = 2;
         window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
        }else if (
          $state.current.name == "AllCourses" &&
          $scope.reactAllCourses === 2
        ) {
          $scope.reactAllCourses = 1;
          window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
        }
         else {
          $scope.reactAllCourses = 0 ;
           window.localStorage.setItem(
            "allCourses",
            $scope.reactAllCourses
          );
          
        }
      }
      if ($state.current.name === "MDCAT") {
        $rootScope.mdCatlandingPage = "mdcat";
      } else if ($state.current.name === "SAT") {
        $rootScope.mdCatlandingPage = "sat";
      } else if ($state.current.name === "CSS") {
        $rootScope.mdCatlandingPage = "css";
      } else if ($state.current.name === "About-Us") {
        $rootScope.mdCatlandingPage = "about-us";
      } else {
        $rootScope.mdCatlandingPage = false;
      }

      var headerClass = document.getElementById("site-header");
      headerClass.classList.remove("nav-up");
      headerClass.classList.add("nav-down");
    });

    $analytics.eventTrack("eventName", {
      category: "category",
      label: "label",
    });

    $(document).ready(function () {
      $(this).scrollTop(0);
    });
    
    // $scope.popupForPhone = function(){
    //   setTimeout(function(){
    //     if(!$rootScope.isWindowloaded){
    //         $scope.popupForPhone();
    //       }else{
    //         console.log("popup-open");
  
    //         $scope.phoneVerification = true;

    //         setTimeout(function() {
    //           $("#country-phone-verify").countrySelect({
    //             defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
    //             preferredCountries: ['pk'],
    //             localizedCountries: {},
    //           });
    //           $(".country-select").css("margin-top", "0px");

    //         // console.log("popup-open");
    //         }, 800)
    //       }
    //   }, 100);
      
    // }
    $scope.getUserAccounts = function(){
      $http
      .post("api/v1/user/get-accounts-with-email", {
        user_id: parseInt(CustomStorageService.getUserInfoStorageData().id),
      })
      .then(function (data) {
        if (data.data.users) {
          $scope.userAccounts = data.data.users;
          console.log($scope.userAccounts,'acc');
          $scope.userAccounts.forEach(function(account) {

            if(account.id === $scope.userData.id){
              $scope.paidCourses = account.purchasedCoursesCount ;
              $scope.enrolledCourses = account.enrolledCourseCount;
            }
          });

        }
      }
      );
      $scope.showdata=false;
    }
    function getPendingOrdersCount(event) {
      $http
        .get(
          "/api/v1/orders/get-pending-count"
        )
        .then(function (data) {
          $scope.ordersCount = data.data.ordersCount
        },function(err){
        });
    }

    $scope.$on('checkPendingOrdersCount', function (event, message) {
      getPendingOrdersCount();
    });
    if (CustomStorageService.getUserInfoStorageData()) {
      $scope.getUserAccounts();
      $scope.userData = CustomStorageService.getUserInfoStorageData();
      $scope.userEmail = $scope.userData.email;
      $scope.userPhone = $scope.userData.phone;
      $scope.missingCredentials.email = $scope.userEmail;
      $scope.missingCredentials.phone = $scope.userPhone;
      $scope.userPhone = $scope.userData.phone;
      $scope.userID = $scope.userData.id;
      // console.log("user data",$scope.userData);
      $scope.user = $scope.userData;
  
      if ($scope.userData.user_type === "guest") {
        $scope.guestUser = true;
        $rootScope.guest = true;
        $http({
          url: 'api/v1/users/getUserData',
          method: "GET",
        }).then(function(data){
          $scope.userData = data.data;
       CustomStorageService.setUserInfoStorageData($scope.userData);     
          // $scope.showRequestVideo = data.data.allowRequest;
          // $scope.switchToggle = $scope.showRequestVideo ? false : true;
          // $scope.showData = true;
        }, function errorCallback(response) {
          requestService.responseHandler(response.status);
        });
      } else if ($scope.userData.user_type === "student") {
        $scope.guestUser = false;
        $rootScope.guest = false;
        if (!$scope.userData.confirmed_at) {
          // $scope.banner = true;
        } else if (!$scope.userData.phone_confirmed_at) {
          // $scope.phoneBanner= true;
        }
        $rootScope.isTrustedDomain = false
        if($scope.userData.provider === 'email') {
          allowedDomains.forEach(function(domain) {
            if($scope.userData.email.toLowerCase().includes(domain.toLowerCase())) {
              $rootScope.isTrustedDomain = true;
            }
          })
        } else {
          $rootScope.isTrustedDomain = true;
        }

        if(($rootScope.isTrustedDomain && !$scope.userData.confirmed_at && !$scope.userData.phone_confirmed_at) || (!$rootScope.isTrustedDomain && !$scope.userData.phone_confirmed_at )) {
          $rootScope.orderEmailVerify = true;
        }

      verifiedBandCheck();

      }

      if(!$rootScope.platform_reactApp_new && (!$scope.userData.phone || !$scope.userData.uid_phone) && (($scope.userData.user_type === "guest" && ($state.current.name === "video_player_chapter" || $state.current.name === "video_player" ||  $state.current.name === "videojs_player" || $state.current.name === "videojs_player_chapter" || $state.current.name === "vimeo_player" || $state.current.name === "vimeo_player" || $state.current.name === "vimeo_player_chapter" )) ||$scope.userData.user_type === "student") && $state.current.name != "AllCourses") {
        $scope.otpVerification = 'phoneVerify';
        $scope.editable = false;
        $scope.forceEnter = true;
        if ($scope.userData.phone && $scope.userData.phone.startsWith("92")) {
          $scope.userPhone = $scope.userData.phone.substring(2);
        } else if ($scope.userData.phone && $scope.userData.phone.startsWith("0")) {
          $scope.userPhone = $scope.userData.phone.substring(1);
        } else {
          $scope.userPhone = $scope.userData.phone;
        }
        $scope.missingCredentials.phone=$scope.userPhone;


        if($rootScope.platform_reactApp){
          $scope.popupForPhone();

        } else {
          $scope.phoneVerification = true;
          setTimeout(function() {
            $("#country-phone-verify").countrySelect({
              defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
              preferredCountries: ['pk'],
              localizedCountries: {},
            });
            $(".country-select").css("margin-top", "0px");
          }, 800)
        }
      }

      $scope.userData.dob = new Date($scope.userData.dob);
      if (!$scope.userData.name && !$scope.userData.full_name) {
        $scope.questionNo = 10;
        $scope.showOverlay = true;
      }

      if (!$rootScope.tokenLogin) {
        if(!CustomStorageService.getUserInfoStorageData().is_migrated){
          $http
          .post("api/v1/user/get-accounts-with-email", {
            user_id: parseInt(CustomStorageService.getUserInfoStorageData().id),
          })
          .then(function (data) {
            if (data.data.users) {
              $scope.userAccounts = data.data.users;
              // if (
              //   $scope.userAccounts.length > 1 &&
              //   !CustomStorageService.getUserInfoStorageData().is_migrated
              // ) {
              //   $http
              //     .get(
              //       "/api/v1/user/check-merge-count/" +
              //         CustomStorageService.getUserInfoStorageData().id
              //     )
              //     .then(function (data) {
              //       $rootScope.mergeTooltip = true;
              //       if (data.data.success && data.data.mergeShowCount < 3) {
              //         $rootScope.mergeNotify = true;
              //         if (!$rootScope.closedToolTip) {
              //           document.getElementById(
              //             "custom-tooltip"
              //           ).style.visibility = "visible";
              //           document.getElementById(
              //             "custom-tooltip-1"
              //           ).style.visibility = "visible";
              //           $rootScope.mergeTooltip = true;
              //           $rootScope.closedToolTip = true;
              //         }
              //       } else {
              //         $rootScope.mergeNotify = false;
              //       }
              //     });
              // }
            }
          }, function(err){
            console.log('============== error ===', err)
          });
        }

      }

      $http
        .get(
          "/api/v1/user/check-verification-status/" +
            CustomStorageService.getUserInfoStorageData().id
        )
        .then(function (data) {
          if (data.data.emailVerified && !$scope.userData.confirmed_at) {
            var userDetail = $scope.userData;
            userDetail.confirmed_at = true;
            $scope.banner = false;
            CustomStorageService.setUserInfoStorageData(userDetail);
          }
          // if(data.data.phoneVerified && !$scope.userData.phone_confirmed_at) {
          //   var userDetail = $scope.userData;
          //   userDetail.phone_confirmed_at = true;
          //   $scope.phoneBanner= false;
          //   CustomStorageService.setUserInfoStorageData(userDetail);
          // }
        },function(err){
          // console.log("+A+FDS=dada",err);
        });
        getPendingOrdersCount();
        
    }




function verifiedBandCheck(){
  $scope.profileCompletePercentage = 0;
     if($scope.userData.confirmed_at && $scope.userData.phone_confirmed_at && ($scope.userData.name || $scope.userData.full_name) && $scope.userData.dob && $scope.userData.gender && $scope.userData.image && $scope.userData.university){
      $rootScope.userVerified = true;
     }else{
      $scope.userData.confirmed_at ? $scope.profileCompletePercentage= $scope.profileCompletePercentage + 1 : $scope.profileCompletePercentage;
      $scope.userData.phone_confirmed_at ?  $scope.profileCompletePercentage=$scope.profileCompletePercentage + 1 : $scope.profileCompletePercentage;
      ($scope.userData.name || $scope.userData.full_name) ? $scope.profileCompletePercentage=$scope.profileCompletePercentage + 1 : $scope.profileCompletePercentage;
      $scope.userData.dob ? $scope.profileCompletePercentage=$scope.profileCompletePercentage + 1 : $scope.profileCompletePercentage;
      $scope.userData.gender ? $scope.profileCompletePercentage=$scope.profileCompletePercentage + 1 : $scope.profileCompletePercentage;
      $scope.userData.image ? $scope.profileCompletePercentage=$scope.profileCompletePercentage +  1 : $scope.profileCompletePercentage;
      $scope.userData.university ? $scope.profileCompletePercentage=$scope.profileCompletePercentage +  1 : $scope.profileCompletePercentage;
      $scope.profileCompletePercentage = ($scope.profileCompletePercentage/7)*100;
      $scope.percentageCompleted = $scope.profileCompletePercentage;
      // console.log($scope.profileCompletePercentage,$scope.percentageCompleted,"COmplete");
      if($scope.percentageCompleted === 100){
        $rootScope.userVerified = true;
        $rootScope.incompleteProfile = false;
      }else{
        $rootScope.userVerified = false;
        $rootScope.incompleteProfile = true;
      }

      if($scope.userData.user_type === "student"){
        $scope.guestUser = false;
      }else{
        $scope.guestUser = true;

      }


      }
}

    $scope.onKeydown= function (event) {
 
      const char = String.fromCharCode(event.keyCode);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
        event.target.nextElementSibling.focus();
      }
    },
    $scope.keytab= function (event, model) {
      if(event.key === "Backspace" || (event.keyCode === 229 && !event.target.value)){
      event.target.previousElementSibling.focus();
      if(model === 1) {
        $scope.digit1 = ""
      } else if(model === 2) {
        $scope.digit2 = ""
      } else if(model === 3) {
        $scope.digit3 = ""
      } else if(model === 4) {
        $scope.digit4 = ""
      } else if(model === 5) {
        $scope.digit5 = ""
      } else if(model === 6) {
        $scope.digit6 = ""
      }
    }else{
      if(event.target.value){
        event.target.nextElementSibling.focus()
      }
     
    }
  },
  $scope.numFormatter = function (num) {
    if(num > 999 && num < 1000000){
        return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
    }else if(num > 1000000){
        return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
    }else if(num < 900){
        return num; // if value < 1000, nothing to do
    }
}

  $scope.closeMerge = function () {
    $scope.mergeAccount= false;
  }
  $scope.closeMergeTooltip = function (){
    document.getElementById('custom-tooltip').style.display = 'none';
    document.getElementById('custom-tooltip-1').style.display = 'none';
  }
  $scope.penClick = function (){
    $scope.editable = false;
  }
  $scope.backVerifyPopup =function (){
    $scope.editable = true;
    $scope.emailSent = false;
  }




$scope.closeMerge = function(){
$scope.mergeAccount = false;
$scope.mergeWait = false;
$scope.mergeSuccess= false;
$scope.mergeMain = true;
}

$scope.openMerge = function () {
  $scope.mergeAccount = true;
  $scope.mergeMain = true;
}
$scope.mergeAccountCall =  function () {
  
  $scope.mergeSuccess = false;
  $scope.mergeMain = false;
  $scope.mergeWait = true;

  $http.post('api/v1/user/merge-accounts', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id)})
    .then(function (data) {
      setTimeout(function() {
        $scope.mergeWait = false;
        $scope.mergeSuccess = true;
        var newData = CustomStorageService.getUserInfoStorageData();
        newData.is_migrated = true;
        CustomStorageService.setUserInfoStorageData(newData);
        document.getElementById('custom-tooltip').style.visibility = 'none';
        document.getElementById('custom-tooltip-1').style.visibility = 'none';
        $rootScope.mergeTooltip = false;
        $rootScope.closedToolTip = true;
        $scope.$apply();
      }, 4000)
    });

}

  var addPasteHandler = function() {
    setTimeout(function() {
      angular.element('#digit-1')[0].addEventListener('paste', function(event) {
        var clipboardData = event.clipboardData || window.clipboardData;
        var pastedData = clipboardData.getData('Text');
        var data = pastedData.split("");
        event.target.value = data[0];
        angular.element('#digit-2')[0].value = data[1];
        angular.element('#digit-3')[0].value = data[2];
        angular.element('#digit-4')[0].value = data[3];
        angular.element('#digit-5')[0].value = data[4];
        angular.element('#digit-6')[0].value = data[5];
        $scope.digit1 = data[0];
        $scope.digit2 = data[1];
        $scope.digit3 = data[2];
        $scope.digit4 = data[3];
        $scope.digit5 = data[4];
        $scope.digit6 = data[5];
        $scope.$apply();
        angular.element('#digit-6')[0].focus();
      });
    }, 500)
  }
  
  $scope.onPasteOTP = function(event, num) {
    setTimeout(function() {
      var data = event.target.value.split("");
      event.target.value = data[0];
      angular.element('#digit-2')[0].value = data[1];
      angular.element('#digit-3')[0].value = data[2];
      angular.element('#digit-4')[0].value = data[3];
      angular.element('#digit-5')[0].value = data[4];
      angular.element('#digit-6')[0].value = data[5];
      $scope.digit1 = data[0];
      $scope.digit2 = data[1];
      $scope.digit3 = data[2];
      $scope.digit4 = data[3];
      $scope.digit5 = data[4];
      $scope.digit6 = data[5];
      $scope.$apply();
      angular.element('#digit-6')[0].focus();
    }, 100)
  }
  $scope.clearOtp = function() {
    $scope.digit1 = "";
    $scope.digit2 = "";
    $scope.digit3 = "";
    $scope.digit4 = "";
    $scope.digit5 = "";
    $scope.digit6 = "";
    angular.element('#digit-1')[0].value = "";
    angular.element('#digit-2')[0].value = "";
    angular.element('#digit-3')[0].value = "";
    angular.element('#digit-4')[0].value = "";
    angular.element('#digit-5')[0].value = "";
    angular.element('#digit-6')[0].value = "";
  },
$scope.closePromo= function (){
  $scope.showPromo = false;
}
$scope.openSignupPopup =function(){
  $scope.signupPopUp = true;
}
$scope.closeBanner = function(){
  $scope.banner = false;
}
$scope.closePhoneBanner = function (){
  $scope.phoneBanner = false;
}
$scope.closeGuestBanner = function(){
  $scope.guestUser = false;
  // $scope.mergeAccount = true;
}
$scope.closeEmail = function (){
  if($rootScope.platform_reactApp){
  waitForPopupClose();
  }
  $scope.emailVerification = false;
  $scope.phoneVerification = false;
  $scope.emailSent=false;

}
$scope.closeMissingEmail = function(){
  $scope.missingEmail = false
}
$scope.openMissingEmail = function (){
  $scope.missingEmail = true;
}
$scope.openEmailVerification = function (){

  if($rootScope.platform_reactApp){
    // console.log("popup-open");
// waitForPopup();
   $scope.popupForEmail();

  }else{
    $scope.emailVerification = true;
  }
}
$scope.openPhoneVerification = function (){
  if($rootScope.platform_reactApp){
    // console.log("popup-open");
// waitForPopup();
// popupForPhone();
$scope.popupForPhone();

  }else{
  $scope.phoneVerification = true;

  }
  $scope.otpVerification = 'phoneVerify';
  $scope.userPhone = $scope.userData.phone;
  setTimeout(function() {
    $("#country-phone-verify").countrySelect({
      defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
      preferredCountries: ['pk'],
      localizedCountries: {},
    });
    $(".country-select").css("margin-top", "0px");
  }, 800)
  
}
$scope.closeSignup = function(){
  $scope.signupPopUp = false;
}
$scope.sendMerge = function (){

}

$scope.closeEmailVerification = function (){
  $scope.emailSent = false;
  waitForPopupCloseEmail();
}

$scope.postSignup = function (signUp){
  signUp.browser_id = $scope.user.browser_id;
  signUp.id = $scope.user.id;
  signUp.user_type = "student";
  // if (!signUp.full_name || !signUp.email || !signUp.contact || !signUp.password || !signUp.confirmPassword) {
  //   swal({
  //     title: "Error!",
  //     text: "Please enter complete information",
  //     type: "error",
  //     confirmButtonText: "Ok"
  //   });
  //   return;
  // }
  if (signUp.full_name.length < 3) {
    swal({
      title: "Error",
      text: "Please Enter Full Name",
      type: "error"
    })
    return;
  }
  if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    signUp.email
  )) {
    swal({
      title: "Error",
      text: "Please enter valid email address",
      type: "error"
    })
    return;
  }
  if (signUp.contact.length < 11) {
    swal({
      title: "Error",
      text: "Please enter complete contact no",
      type: "error"
    })
    return;
  }
  if (signUp.password.length < 8) {
    swal({
      title: "Error!",
      text: "Password is short!",
      type: "error",
      confirmButtonText: "Ok"
    });
    return;
  }
  if (signUp.password != signUp.confirmPassword) {
    swal({
      title: "Error!",
      text: "Passwords don't match!",
      type: "error",
      confirmButtonText: "Ok"
    });
    return;
  }
  // if (!signUp.image) {
  //   signUp.image = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/default_user.png';
  // }

  var d = new Date(signUp.dob);
  signUp.dob = d;
  signUp.origin = 'LEGACY';
  
  // $scope.disableRegBtn = true;
  signUp.origin_url = location.protocol + '//' + location.host;
  $http.post('/api/v1/auth/register-guest', signUp)
    .then(function (resp) {
      $scope.disableRegBtn = false;
      $scope.signupPopUp = false;
      if (resp.data.error) {
        swal({
          title: "Error",
          text: resp.data.msg,
          type: "error"
        })
      } else if(resp.data.success) {
        swal({
          title: "Account Created Successfully",
          text: "Please Verify Your Account to Enjoy Full Access.",
          type: "success",
          timer: 2000
        }, function () {
          swal.close();
          $scope.$emit('userLoggedIn');
          var oldToken= CustomStorageService.getAuthTokenStorageData();
          CustomStorageService.SignInService(false, true, false, false, oldToken, resp.data.user);
          const isPrivacy = resp.data.isPrivacy ? 'true' : 'false';
          CustomStorageService.setTermStatus(isPrivacy);
          $rootScope.userNotLoggedIn = false;
          location.reload();
        });
      }else if(resp.data.message.error === "E_VALIDATION"){
        swal({
          title: "Error",
          text: "Account Already Exists,Try with another Email!",
          type: "error"
        })
      } else{
        swal({
          title: "Error",
          text: "Something Went Wrong ,Try Again!",
          type: "error"
        })
      }
    })
}
$scope.updateEmail = function (data){
  $scope.emailVerification = false;
  if($rootScope.platform_reactApp){
    console.log("popup-close");
  }
  $scope.missingEmail = true;

}
$scope.sendEmailVerification = function(data){
  $scope.before=false;
  // $scope.emailSent = true;
  var requestEmailResponse = {
    email: data,
    url: location.protocol + '//' + location.host
  };

   var status = $http.post('/api/v1/users/requestConfirmationMail',requestEmailResponse )
  .then(function (resp) {
    if (resp.data.error) {
      swal({
        title: "Error",
        text: resp.data.msg,
        type: "error"
      })
      return false;
    } else {
      // swal({
      //   title: "Email Verification Sent",
      //   text: "Please Verify Your Email!",
      //   type: "success",
      //   timer: 2000
      // }, function () {
      
      //   swal.close();

      //   // CustomStorageService.logOutService();
      //   // $scope.loggedIn = false;
      //   // location.reload();
      // }
      // );
      $scope.emailSent = true;
      $scope.before=true;
      return true;
    }
  });
  return status;
}
function getFormattedDate(date) {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : "0" + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;

  return month + "/" + day + "/" + year;
}
$scope.postMissingCredentials = function (data,status, type){
  var isAllowUpdate = true;
  if (type === "phone") {
    var selectedCountry =  $("#country-phone-verify").countrySelect("getSelectedCountryData");
    if(!selectedCountry || !selectedCountry.phone_code || selectedCountry.phone_code == 'undefined'){
      selectedCountry = {
        phone_code: "92",
        iso2: "pk",
        name: "Pakistan"
      }
    }
    data.countryCode = selectedCountry.phone_code;
    if(data.phone.startsWith('0')) {
      data.phone = data.phone.substring(1);
    }

    if(data.phone.length < 10 || (!data.phone.startsWith('3') && data.countryCode == '92')) {
      $scope.errorMessage = 'Enter Valid phone Ex. 3*******'
      setTimeout(function() {
        $scope.errorMessage = null;
      }, 3000)
      isAllowUpdate = false;
    }
  }
  if(isAllowUpdate) {
    if(status === "update" || status === "update-close"){
      var body = {
        id:$scope.userID,
        isQR: isQR
      }
      if (type === "phone") {
        body.phone = data.phone;
        body.countryCode = data.countryCode;
        body.uidPhone = data.countryCode + data.phone;
      } else {
        body.email = data;
      }
  
    $http.post("/api/v1/users/updateUser", body)
      .then(function (resp) {
        // console.log(resp)
        if (resp.data.success) {
          $scope.loading = false;
          if (type === "phone") {
            if(isQR) {
              swal(
                {
                  title: "Account Created!",
                  text: "We send information on SMS please cheack",
                  type: "success",
                  confirmButtonText: "Ok",
                  timer: 2000,
                  showConfirmButton: false,
                },
                function () {
                  $scope.phoneVerification = false;
                  $scope.$apply();
                  swal.close();
                }
              );
            } else {
              $scope.missingCredentials.phone = data.phone;
              var newData = CustomStorageService.getUserInfoStorageData();
              newData.phone = data.phone;
              newData.uid_phone = data.countryCode + data.phone;
              newData.country_code = data.countryCode;
              $scope.userData.phone = data.phone;
              $scope.userData.uid_phone = data.countryCode + data.phone;
              $scope.userData.country_code = data.countryCode;
              CustomStorageService.setUserInfoStorageData(newData);
              $scope.userPhone = newData.phone;
              if(status === 'update-close') {
                $scope.emailVerification = false;
                if($rootScope.platform_reactApp){
                  // console.log("popup-close");
                  waitForPopupClose();
                }else{
                  $scope.phoneVerification = false;
                }
                $scope.emailSent=false;
                // alert('ddddd');
        // $scope.$emit('reloadOnRefresh');
        location.reload();

              } else {
                if($rootScope.platform_reactApp){
                  // console.log("popup-close");
                  waitForPopupClose();
                }else{
                  $scope.phoneVerification = false;
                }
                $scope.emailSent = false;
                $scope.editable = true;
        
                $scope.enterOTP = true;
                addPasteHandler();
                $scope.OTP = true;
                if($rootScope.platform_reactApp){
                  console.log("popup-open")
                }
                $scope.sendOtp('phone');
                // alert('ddddqqqqd');
                

        // $scope.$emit('reloadOnRefresh');

              }

            } 
          } else {
            $scope.otpVerification = 'emailVerify';
            
            $scope.missingCredentials.email = data;
            $scope.sendOtp('email');
            // if(verify){
              var newData = CustomStorageService.getUserInfoStorageData();
              newData.email = data;
              $scope.userEmail = data;
              CustomStorageService.setUserInfoStorageData(newData);
              $scope.missingEmail = false;

              $scope.enterOTP = true;
              addPasteHandler();
              $scope.OTP = true;
              if($rootScope.platform_reactApp){
                console.log("popup-open")
              }
            // }
            // location.reload();
            // swal.close();
            // $scope.$emit('userLoggedIn');
          // });
        }
        }else if(resp.data.message === "user with this email already exist"){
          swal({
            title: "Error",
            text: "Email Already Exists ,Try with another Email!",
            type: "error"
          }, function () {
            swal.close();
            // $scope.$emit('userLoggedIn');
          })
        }
        else{
          // console.log('error updating number');
          $scope.errorMessage = resp.data.message;
          setTimeout(function() {
            $scope.errorMessage = null;
          }, 3000)
        }
      })
    }else{
      if(type === "phone") {
        $scope.sendOtp('phone');
        if($rootScope.platform_reactApp){
          // console.log("popup-close");
          waitForPopupClose();
        }else{
          $scope.phoneVerification = false;
        }
        $scope.emailSent = false;
        $scope.editable = true;
    
        $scope.enterOTP = true;
        $scope.OTP = true;
        addPasteHandler();

        if($rootScope.platform_reactApp){
          console.log("popup-open")
        }
      } else {
        $scope.sendEmailVerification(data);
      }
    }
  }
  
}
    var searchcourses = "";
    $scope.currentPage = $state.current.name;
    $scope.initilaize = function () {
        $http({
          url: '/api/v1/courses/search-courses-list',
          method: "GET",
        }).then(function(data) {
          if(data.data.success) {
            searchcourses = data.data.res;
          } else {
            console.log('server error')
          }
        });
      $scope.userInfo = CustomStorageService.getUserInfoStorageData();

      if($scope.userInfo){
        $scope.joiningDate =   getFormattedDate(
          new Date($scope.userInfo.created_at)
        );
        getNotifications();
      }
   
      if (CustomStorageService.getFirstVisitStorageData() != false) {
        CustomStorageService.setFirstVisitStorageData(true);
      }
      if (!CustomStorageService.getAuthTokenStorageData()) {
        CustomStorageService.setUserSignedInStorageData(false);
      }
      if (
        CustomStorageService.getUserSignedInStorageData() 
      ) {
        $scope.loggedIn = true;
        $scope.customerName =
          CustomStorageService.getUserInfoStorageData().name ||
          CustomStorageService.getUserInfoStorageData().full_name;
      }
      // else if (
      //   CustomStorageService.getInstructorSignedInStorageData()
      // ) {
      //   // $scope.loggedIn = true;
      //   $scope.customerName =
      //     CustomStorageService.getUserInfoStorageData().name ||
      //     CustomStorageService.getUserInfoStorageData().full_name;
      // }
       else if (
        !CustomStorageService.getUserSignedInStorageData() &&
        !CustomStorageService.getInstructorSignedInStorageData()
      ) {
        if (!CustomStorageService.getFirstTimeStorageData()) {
          CustomStorageService.setFirstTimeStorageData(false);
        }
        CustomStorageService.setUserInfoStorageData(false);
        CustomStorageService.setAuthTokenStorageData(false);
        $scope.loggedIn = false;
      }

      $scope.isLoading = true;
      
    };
    var getNotifications = function() {
      $http.post(env.notificationService +'/notification/get-user-notifications', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id), unreadCount: true})
      .then(function (res) {
        if(res.data && res.data.success) {
          $scope.notifications = res.data.notifications;
          $scope.unreadNotification = res.data.unreadNotification;
          $scope.isLoading = false;
        }
      });
    }

    $scope.openNotifications = function() {
      console.log('------------0')
      mixpanel.track('Notification-Open');
      $scope.unreadNotification = 0;
      $http.post(env.notificationService +'/notification/user-notification-read', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id)})
      .then(function (res) {
      });
    }

    $scope.clickNotification = function(notification) {
      if(!notification.is_clicked) {
        notification.is_clicked = true;
        $http.post(env.notificationService +'/notification/user-notification-click', { user_id: parseInt(CustomStorageService.getUserInfoStorageData().id), notification_id: notification.id})
        .then(function (res) {
        })
      }
      if(notification.notifications.redirect_url) {
        var link = notification.notifications.redirect_url;
        if(!link.startsWith("http://") && !link.startsWith("https://")){
          link = 'https://' + link
        }
        if(notification.notifications.redirect_type === 'new_tab') {
          window.open(link, '_blank')
        } else {
          window.location.href = link;
        }
      }
    }

    $scope.showCloseButton = true;
    setTimeout(function() {
      $(".cmn-toggle-switch").click(function () {
        $scope.showCloseButton = false;
        $(".menu-items").removeClass("nav-hidden").addClass("nav-visible");
        $(".hideIt").css({ display: "block" });
        $(".menu").removeClass("btn-hidden").addClass("btn-visible");
        $(".overlay-body").removeClass("active").addClass("active");
        if (!$scope.$$phase) $scope.$apply();
      });
  
      $(".toggle-switch-close").click(function () {
        $scope.showCloseButton = true;
        $(".menu-items").addClass("nav-hidden").removeClass("nav-visible");
        $(".hideIt").css({ display: "none" });
        $(".menu").addClass("btn-hidden").removeClass("btn-visible");
        $(".overlay-body").addClass("active").removeClass("active");
        if (!$scope.$$phase) $scope.$apply();
      });
    
    
  
      $("#searchHeaderStr").focus(function () {
        $(".logo").addClass("menu-open-hai");
      });
  
      $("#searchHeaderStr").blur(function () {
        $(".logo").removeClass("menu-open-hai");
      });
    }, 1000)
    $(".cmn-toggle-switch").click(function () {
      $scope.showCloseButton = false;
      $(".menu-items").removeClass("nav-hidden").addClass("nav-visible");
      $(".hideIt").css({ display: "block" });
      $(".menu").removeClass("btn-hidden").addClass("btn-visible");
      $(".overlay-body").removeClass("active").addClass("active");
      if (!$scope.$$phase) $scope.$apply();
    });

    $(".toggle-switch-close").click(function () {
      $scope.showCloseButton = true;
      $(".menu-items").addClass("nav-hidden").removeClass("nav-visible");
      $(".hideIt").css({ display: "none" });
      $(".menu").addClass("btn-hidden").removeClass("btn-visible");
      $(".overlay-body").addClass("active").removeClass("active");
      if (!$scope.$$phase) $scope.$apply();
    });

    $("#searchHeaderStr").focus(function () {
      $(".logo").addClass("menu-open-hai");
    });

    $("#searchHeaderStr").blur(function () {
      $(".logo").removeClass("menu-open-hai");
    });

    $scope.success = false;
    $scope.error = false;

    // $scope.subscribe = function (email) {
    //   if (!email) {
    //     swal({
    //       text: 'Enter valid email address',
    //       type: 'error',
    //       title: 'Error'
    //     })
    //     return;
    //   }
    //   var username = "apikey";
    //   var apiKey = "4f441570805068dcd0c08ff6a812505e-us14";
    //   var id = "734ca94896";
    //   var dc = "us14";
    //   var status = "pending";
    //   var target = "lists/734ca94896/members/";
    //   var authdata = $base64.encode('apiKey' + ':' + apiKey);

    //   $http.defaults.headers.common['Authorization'] = 'Basic ' + authdata;

    //   var data = {
    //     email_address: email,
    //     status: status
    //   };
    //   var config = {
    //     headers: {
    //       'Content-Type': 'application/json'
    //     }
    //   };

    //   $http.post(target, data, config)
    //     .then(function successCallback(response) {
    //       $scope.errorMsg = "";
    //       $scope.successMsg = "";
    //       $scope.success = true;
    //       $scope.successMsg = "Thank you for subscription, Confirmation request has been sent";
    //       $timeout(function () {
    //         $scope.success = false;
    //         $scope.error = false;
    //       }, 30000);
    //     }, function errorCallback(response) {
    //       $scope.errorMsg = "";
    //       $scope.successMsg = "";
    //       var msg = response.data.detail;
    //       var x = msg.includes("already");
    //       if (x) {
    //         $scope.errorMsg = "Thank you for subscription, this email address is already in our mailing list.";
    //       }
    //       else {
    //         $scope.errorMsg = "Error, Please try again.";
    //       }
    //       $scope.error = true;
    //       $timeout(function () {
    //         $scope.success = false;
    //         $scope.error = false;
    //       }, 30000);
    //     });
    // }

    $scope.closeOTP = function () {
      $scope.OTP = false;
      $scope.enterOTP = false;
      if($rootScope.platform_reactApp){
        console.log("popup-close")
      }
    };

    $scope.backVerification = function () {
      if (!$scope.logoutAll && !$scope.enterOTP) {
        $scope.logoutAll = true;
      } else {
        $scope.logoutAll = false;
        $scope.enterOTP = false;
        $scope.emailSelected = false;
        $scope.phoneSelected = false;
        $scope.clearOtp();
        if($rootScope.platform_reactApp){
          console.log("popup-close")
        }
      }
    };

    $scope.closeLogoutPopup = function () {
      $scope.logoutAll = false;
      $scope.OTP = false;
      if($rootScope.platform_reactApp){
        console.log("popup-close")
      }
    };

    $scope.skipValidate = function () {
      const formData = {
        user_id: $scope.userData.id,
        origin: "LEGACY",
        dimensions: dimensions,
      };

      $http.post("/api/v1/auth/skip-validate", formData).then(
        function (resp) {
          if (resp.data.success && resp.data.token) {
            if ($rootScope.platform_reactApp) {
              console.log("userToken" + resp.data.token);
              console.log("userID" + resp.data.user.id);

              if(CustomStorageService.getAppFreeAccessPopup()){
                console.log("firstLogin");
              }

              console.log("urlToRoute"+$location.$$url);
              console.log("loggedIn");
            }
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              resp.data.token,
              resp.data.user
            );

            const isPrivacy = resp.data.isPrivacy ? "true" : "false";
            CustomStorageService.setTermStatus(isPrivacy);
            $rootScope.userNotLoggedIn = false;
            if ($state.current.name == "forgot-password") {
              $state.go("Landing", {}, { reload: true });
            } else {
              location.reload();
            }
          }
        },
        function errorCallback(response) {
          // console.log("response");
          // console.log(response)
        }
      );
    };

    $scope.logoutFromDevice = function (session) {
      $scope.logoutAll = false;
      $scope.selectedSession = session;
    };

    $scope.logoutAllDevices = function (session) {
      $scope.logoutAll = false;
      $scope.selectedSession = session;
      $scope.removeAllSession = true;
    };

    $scope.sendOtp = function (type) {
      if (type === "phone") {
        type = 'whatsapp'
        $scope.phoneSelected = true;
        $scope.enterOTP = true;
      } else {
        $scope.emailSelected = true;
        $scope.enterOTP = true;
      }
      if($rootScope.platform_reactApp){
        console.log("popup-open")
      }
      addPasteHandler();

      var data = {
        user_id: $scope.userData.id,
        type: type,
      };

      $http.post("/api/v1/auth/send-otp", data).then(
        function (resp) {
          // console.log(resp);
        },
        function errorCallback(response) {
          // console.log("response");
          swal(
            {
              title: "Try Again",
              text: "Something went wrong",
              type: "error",
            },
            function () {
              swal.close();
            }
          );
          // console.log(response)
        }
      );
    };

    $scope.resendOtp = function (type) {
      const data = {
        user_id: $scope.userData.id,
        type: $scope.phoneSelected ? "phone" : "email",
      };

      $http.post("/api/v1/auth/resend-otp", data).then(
        function (resp) {
          swal(
            {
              title: "Verification Code Sent!",
              type: "success",
              confirmButtonText: "Ok",
              timer: 2000,
              showConfirmButton: false,
            },
            function () {
              $scope.clearOtp();
              swal.close();
            }
          );
        },
        function errorCallback(response) {
          $scope.clearOtp();
          // console.log('response')
          // console.log(response)
        }
      );
    };

    $scope.sendOTPConfirmation = function () {
      var otp =
        angular.element("#digit-1")[0].value +
        angular.element("#digit-2")[0].value +
        angular.element("#digit-3")[0].value +
        angular.element("#digit-4")[0].value +
        angular.element("#digit-5")[0].value +
        angular.element("#digit-6")[0].value;
      // console.log("OTP",otp);
      const formData = {
        user_id: $scope.userData.id,
        code: otp,
        session: $scope.selectedSession ? $scope.selectedSession.session : "",
        type: $scope.otpVerification,
        removeAllSession: $scope.removeAllSession,
        origin: "LEGACY",
      };

      $http.post("/api/v1/auth/validate-otp", formData).then(
        function (resp) {
          if (resp.data.success && resp.data.token) {
            $scope.banner = false;
            $scope.closeEmail();
            $scope.enterOTP = false;
            $scope.OTP = false;
            console.log('$rootScope.orderEmailVerify');
            console.log($rootScope.orderEmailVerify);
            if($rootScope.orderEmailVerify) {
              $rootScope.orderEmailVerified = true;
              $scope.$broadcast('salesPopup');
              toaster.success({
                title: "OTP Verified",
              });
            }
            
            if($rootScope.platform_reactApp){
              console.log("popup-close")
            }
            
                if ($rootScope.platform_reactApp) {
                  console.log("userToken" + resp.data.token);
                  console.log("userID" + resp.data.user.id);
                  if(CustomStorageService.getAppFreeAccessPopup()){
                    console.log("firstLogin");
                  }

                  console.log("urlToRoute"+$location.$$url);

                  console.log("loggedIn");
                }
                CustomStorageService.SignInService(
                  false,
                  true,
                  false,
                  false,
                  resp.data.token,
                  resp.data.user
                );

                const isPrivacy = resp.data.isPrivacy ? "true" : "false";
                CustomStorageService.setTermStatus(isPrivacy);
                $rootScope.userNotLoggedIn = false;
                if ($state.current.name == "forgot-password") {
                  $state.go("Landing", {}, { reload: true });
                } else {
                  if(!$rootScope.orderEmailVerify) {
                    swal(
                      {
                        title: "OTP Verified!",
                        type: "success",
                        confirmButtonText: "Ok",
                        timer: 2000,
                        showConfirmButton: false,
                      },
                      function () {
                        swal.close();
                      });
                    location.reload();
                  }
                  $rootScope.orderEmailVerify = false;
                }
          } else if (
            resp.data.success &&
            CustomStorageService.getAuthTokenStorageData()
          ) {
            $scope.banner = false;
            $scope.closeEmail();
            $scope.enterOTP = false;
            $scope.OTP = false;

            if($rootScope.platform_reactApp){
              console.log("popup-close")
            }
            if($rootScope.orderEmailVerify) {
              $rootScope.orderEmailVerified = true;
              $scope.$broadcast('salesPopup');
              toaster.success({
                title: "OTP Verified",
              });
            }
            if(!$rootScope.orderEmailVerify) {
              swal(
                {
                  title: "OTP Verified!",
                  type: "success",
                  confirmButtonText: "Ok",
                  timer: 2000,
                  showConfirmButton: false,
                },
                function () {
                  location.reload();
                }
              );
              $rootScope.orderEmailVerify = false;
            }
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              CustomStorageService.getAuthTokenStorageData(),
              resp.data.user
            );
          } else {
            swal(
              {
                title: "OTP Verified!",
                type: "success",
                confirmButtonText: "Ok",
                timer: 2000,
                showConfirmButton: false,
              },
              function () {
                swal.close();
              }
            );
          }
        },
        function errorCallback(response) {
          $scope.otpErroor = "Invalid OTP";
        }
      );
    };

    $(window).on("load", function () {
      $rootScope.isWindowloaded = true;
      if($scope.phoneVerification){
        $("#country-phone-verify").countrySelect({
          defaultCountry: $scope.userData.country_code ? $scope.userData.country_code : "pk",
          preferredCountries: ['pk'],
          localizedCountries: {},
        });
        $(".country-select").css("margin-top", "0px");
      }

    });
    $scope.clickMainLogo = function () {
      if(!$rootScope.platform_reactApp_new) {
        $scope.goToState('Landing');
      }
    }
    $scope.goToState = function (state, id) {
      // console.log("in state",state,$rootScope.freeCourseController);

      try {
          $('.modal').removeClass('in');
          $('.modal').css({display: 'none'});
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove()
      } catch (error) {
        console.log(error)
      }
if($rootScope.freeCourseController && $rootScope.platform_reactApp){
    // $state.go("AllCourses",{free: 'personal-info'});
    window.location.href="/courses?free=true";
}else{
  if(state === "profile_settings"){
    if($(document).width() > 900){
      $state.go(state,{name: 'personal-info'});

    }
    else{
  $state.go(state,{name: 'main'});

    }

  }else{
    $state.go(state, {}, { reload: true });

  }
}
    
      
    }

//     var openCompleteProfile= function(){
//       console.log($rootScope.isWindowloaded,"win loaded");
//       if(!$rootScope.isWindowloaded){
//       setTimeout(openCompleteProfile, 3000);
//         }else{
//       if ($rootScope.platform_reactApp) {
//       console.log("in index run2");
//        var profCompStatus =  window.localStorage.getItem("profileCompleted");
//       console.log("Prof Comp"+ profCompStatus,typeof profCompStatus);
//         if(profCompStatus === "true"|| profComp == "true"){
//       console.log("in index run234");
//        $scope.goToState("Complete-Profile");
//     }
//   }
// }
//   }
//   var statusProfile =  window.localStorage.getItem("profileCompleted");
//   if(statusProfile === "true"){
//     openCompleteProfile();
//   }

    $scope.logOut = function () {
      $scope.loggedIn = false;
      $scope.guestUser = false;
      console.log("loggedOut");
      try {
        CustomStorageService.setFcmToken('');
        $http
          .post("/api/v1/auth/logout", {
            session: CustomStorageService.getAuthTokenStorageData(),
          })
          .then(
            function (resp) {
              mixpanel.track('Sign_Out');
            },
            function errorCallback(response) {}
            
          );
        swal(
          {
            title: "Log Out Successful!",
            type: "success",
            confirmButtonText: "Ok",
            timer: 3000,
            showConfirmButton: false,
          },
          function () {
            if ($rootScope.platform_reactApp) {
              waitForBridge();
            } else {
              location.reload();
            }
          }
        );
      } catch (error) {
        if ($rootScope.platform_reactApp) {
          waitForBridge();
        } else {
          location.reload();
        }
      }
      CustomStorageService.logOutService('all');
    };

    var waitForBridge = function () {
      if (!$rootScope.isWindowloaded) {
        setTimeout(waitForBridge, 200);
      } else {
        console.log("loggedOut");
        setTimeout(function() {
          location.reload();
        }, 200)
      }
    };

    $scope.goToState = function (state, id) {
      // mixpanel.track('Nearpeer-' + state + '-page');
      // console.log("in state",state,$rootScope.freeCourseController);
      try {
          $('.modal').removeClass('in');
          $('.modal').css({display: 'none'});
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove()
      } catch (error) {
        console.log(error)
      }

      if($rootScope.freeCourseController && $rootScope.platform_reactApp){
        // $state.go("AllCourses",{free: 'personal-info'});
        window.location.href="/courses?free=true";
    }else{
      if(state === "profile_settings"){
        if($(document).width() > 900){
          $state.go(state,{name: 'personal-info'});
    
        }
        else{
      $state.go(state,{name: 'main'});
    
        }
    
      }else{
        $state.go(state, {}, { reload: true });
    
      }
    }
      
    }

    $scope.goToOrders = function (state, id) {
      // $location.path('/my-account').search({order: 'true'});
    $rootScope.openOrders = true;

    $state.go("profile_settings", { name: "my-orders" });
      
    }

    $scope.onlineStatus = onlineStatus;

    $scope.$watch("onlineStatus.isOnline()", function (online) {
      if (!online) {
        $scope.$broadcast("internetConnectivityLost");
        //$scope.internetConnectivityLost = true;
        //$scope.noInternet = true;
        if (!$scope.$$phase) $scope.$apply();
      } else {
        if ($scope.internetConnectivityLost) {
          $scope.internetConnectivityLost = false;
          $scope.noInternet = false;
          if (
            $state.current.name == "video_player" ||
            $state.current.name == "video_player_chapter"
          ) {
            $scope.$broadcast("internetFound");
          } else {
            $state.reload();
          }
        }
      }
    });

    $scope.updateData = function (form) {
      var x = 0;
      switch ($scope.questionNo) {
        case 0:
          if (!$scope.userData.email) {
            x = 1;
          }
          break;
        case 1:
          if (!$scope.userData.phone) {
            x = 1;
          }
          break;
        case 2:
          if (!$scope.userData.university) {
            x = 1;
          }
          break;
        case 3:
          if (!$scope.userData.crn) {
            x = 1;
          }
          break;
        case 4:
          if (!$scope.userData.firm) {
            x = 1;
          }
          break;
        case 5:
          if (!$scope.userData.city) {
            x = 1;
          }
          break;
        case 6:
          if (!$scope.userData.dob) {
            x = 1;
          }
          break;
        case 10:
          if (!$scope.userData.name) {
            x = 1;
          }
          break;
      }
      if (x) {
        $scope.showOverlay = false;
        if (!$scope.$$phase) $scope.$apply();
        swal(
          {
            title: "Error",
            text: "Please fill in the field",
            type: "error",
          },
          function () {
            $scope.showOverlay = true;
            if (!$scope.$$phase) $scope.$apply();
          }
        );
        return false;
      }
      $scope.requestSent = true;
      $http.post("api/v1/users/updateUser", form).then(function (data) {
        $scope.showOverlay = false;
        if (!$scope.$$phase) $scope.$apply();
        $scope.requestSent = false;
        if (data.data.success) {
          $scope.userData.profileLevel++;
          CustomStorageService.setUserInfoStorageData($scope.userData);
          $scope.$broadcast("playVideo");
        } else {
        }
      });
    };

    $scope.submitSuspiciousRequest = function () {
      if($scope.requestSubmit) {
        $scope.suspiciousUser = false;
      } else {
        $http.post("api/v1/suspicious-user/send-request", { user_id: suspiciousUserId }).then(function (data) {
          $scope.requestSubmit = true;
          toaster.success({
            title: "Request Submitted Successfully",
          });
        });
      }
      
    }

    $scope.closeSuspiciousUser = function () {
      $scope.suspiciousUser = false;
      $scope.requestSubmit = false;
    }

    var suspiciousUserId ;
    $scope.$on("suspiciousUser", function (event, data) {
      suspiciousUserId = data.user_id;
      if(data.isPending || data.isRejected) {
        $scope.requestSubmit = true;
      }
      $scope.suspiciousUser = true;
      $state.go("Landing", {});
    });

    $scope.$on('userLoggedIn', function (event, message) {
    });

    $scope.$on("userLoggedIn", function (event, message) {
      if ($state.current.name == "forgot-password") {
        $state.go("Landing", {}, { reload: true });
      } else {
        if($rootScope.beforJoinusPath) {
          $state.go($rootScope.beforJoinusPath.current.name, $rootScope.beforJoinusPath.params)
        }
        setTimeout(function() {
          location.reload();
        }, 10)
      }
    });
    
    $scope.$on("userProfileUpdated", function (event) {
      // console.log("Updated Data in header",event);
      $scope.userData = CustomStorageService.getUserInfoStorageData();
      console.log("UPDATED DATA",$scope.userData);
      $scope.userInfo = $scope.userData;
      $scope.customerName =
      CustomStorageService.getUserInfoStorageData().name ||
      CustomStorageService.getUserInfoStorageData().full_name;
      $scope.missingCredentials.email = $scope.userData.email;
      $scope.missingCredentials.phone = $scope.userData.phone;
      if($scope.userData.user_type === "guest"){
        $scope.guestUser = true;
      }else{
        $scope.guestUser = false;
      }
      // $scope.$apply();
      verifiedBandCheck();
    });

    $scope.$on("userLoggedInAfterVerification", function (event, res) {
      $scope.otpVerification = "login";
      $scope.sessions = res.data.sessions;
      $scope.userData = res.user;
      $scope.logoutAll = true;
      $scope.OTP = true;
      // if($rootScope.platform_reactApp){
      //   console.log("popup-open")
      // }

      if (($scope.userData.provider = "email")) {
        $scope.userEmail = $scope.userData.email;
      } else if (($scope.userData.provider = "facebook")) {
        $scope.userEmail = $scope.userData.fb_email
          ? $scope.userData.fb_email
          : $scope.userData.email;
      } else if (($scope.userData.provider = "apple")) {
        $scope.userEmail = $scope.userData.apple_email
          ? $scope.userData.apple_email
          : $scope.userData.email;
      } else if (($scope.userData.provider = "google")) {
        $scope.userEmail = $scope.userData.email;
      }
      $scope.splitEmail = [];
      if ($scope.userEmail) {
        $scope.splitEmail = $scope.userEmail.split("@");
      }
      if (
        $scope.userData.phone &&
        ($scope.userData.phone.length === 11 ||
          $scope.userData.phone.length === 12) &&
        !isNaN($scope.userData.phone)
      ) {
        $scope.userPhone = $scope.userData.phone;
      }
    });

    $scope.$on("userLoggedInBlockedUnconfirmed", function (event, res) {
      // console.log("res");
      // console.log(res);
      if (res.type === "email") {
        swal(
          {
            title: "Email Sent",
            text: "Please check your email and verify your email",
            type: "success",
            showCancelButton: false,
          },
          function (isConfirm) {}
        );
      } else {
        $scope.userData = res.user;
        $scope.userPhone = $scope.userData.phone;
        $scope.phoneSelected = true;
        $scope.otpVerification = "phoneVerify_Login";
        if($rootScope.platform_reactApp){
          // console.log("popup-close");
          waitForPopupClose();
        }else{
          $scope.phoneVerification = false;

        }
        $scope.emailSent = false;
        $scope.editable = true;

        $scope.enterOTP = true;
        if($rootScope.platform_reactApp){
          console.log("popup-open")
        }
        $scope.OTP = true;
        addPasteHandler();

        // if($rootScope.platform_reactApp){
        //   console.log("popup-open")
        // }
      }
    });

    $scope.$on("userSignupVerification", function (event, res) {
      $scope.userData = res.user;
      $scope.userPhone = $scope.userData.phone;
      $scope.otpVerification = "signup";
      if($rootScope.platform_reactApp){
        // console.log("popup-close");
        waitForPopupClose();
      }else{
        $scope.phoneVerification = false;
      }
      $scope.emailSent = false;
      $scope.editable = true;
      $scope.phoneSelected = true;
      $scope.enterOTP = true;
      $scope.OTP = true;
      addPasteHandler();

      if($rootScope.platform_reactApp){
        console.log("popup-open")
      }
    });
    
    $scope.showNewLoginPopup = function (form) {
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      if(mixpanel.track) {
        mixpanel.reset();
        mixpanel.track('Join-us-click');
      }
      // console.log(form, 'working')
      if(form === 'login'){
        //  mixpanel.track('Login click');
        // console.log(form, 'condition form');
        $scope.showNewLoginDiv = true;
        $rootScope.loginFormSelected = true;
        $rootScope.signupFormSelected = false;

        if(!$rootScope.platform_reactApp){
          googleInit()
        }
        $state.go('Login', {notify: false})
        
        // test();
      }else if(form === 'signup'){
        if(mixpanel.track) {
         mixpanel.track('Signup-click');
        }
        // console.log(form, 'condition form');
        $scope.showNewLoginDiv = true;
        $rootScope.loginFormSelected = false;
        $rootScope.signupFormSelected = true;
        if(!$rootScope.platform_reactApp){
          googleInit()
        }
      }else{
        $scope.showNewLoginDiv = true;
        $rootScope.loginFormSelected = true;
        $rootScope.signupFormSelected = false;
      }
      // $scope.showNewLoginDiv = true

      // document.body.classList.add("home");
    };

    if(($state.current.name === 'Login' || $state.current.name === 'Create_Account') && !$rootScope.platform_reactApp ) {
      if (CustomStorageService.getUserInfoStorageData()) {
        $scope.showNewLoginDiv = false;
      } else {
        if($state.current.name === 'Create_Account') {
          $state.go('Create_Account',{step: 'email'} , {notify: false})
        } else {
          $state.go('Login', {notify: false})
        }
        $scope.showNewLoginPopup('login');
      }
    }

    $scope.$on("showLoginPopup", function (event, message) {
      if(!$rootScope.platform_reactApp){
        googleInit()
      }
      $state.go('Login', {notify: false})
      $scope.showNewLoginDiv = true;
      if (!$scope.$$phase) $scope.$apply();
      $(window).scrollTop(0);
    });

    $scope.showCustomForm = false;
    $scope.form = {};
    $scope.$on("show-custom-form", function (event, message) {
      if(!$rootScope.formDone) {
        $scope.form = message;
        $scope.showCustomForm = true;
      }
    });

    $scope.$on("hide-custom-form", function (event, message) {
      $scope.showCustomForm = false;
    });

    $scope.$on("closeForm", function (event, message) {
      if (validStates.indexOf($state.current.name) != -1) {
        return;
      }
      if($rootScope.beforJoinusPath && $state.current.name !== 'Complete-Profile') {
        $state.go($rootScope.beforJoinusPath.current.name, $rootScope.beforJoinusPath.params)
      }
      $scope.showNewLoginDiv = false;
    });

    // $scope.$on('getUserInformation',function(event,meesage){
    //   $scope.showOverlay = true;
    //   $scope.userData = ipCookie('userInfo');
    //   $scope.questionNo = meesage;
    // });

    // $scope.showNewLoginPopup = function () {
    //   $scope.showNewLoginDiv = true;
    // };

    // $scope.$on('getUserInformation',function(event,meesage){
    //   $scope.showOverlay = true;
    //   $scope.userData = ipCookie('userInfo');
    //   $scope.questionNo = meesage;
    // });
    var counter = 0;
    var searchStr = document.getElementById("searchHeaderStr");
    searchStr.addEventListener("keyup", handleKeyboard, false);

    function handleKeyboard(event) {
      if (searchStr.value.length == 0) {
        $scope.searchOpen = false;
        return;
      }
      if (counter == 0) {
        $scope.searchLoader = true;
      }
      counter++;
      $http({
        url: "api/v1/courses/searchCourseAndInstructor",
        method: "GET",
        params: { str: searchStr.value },
      }).then(function (data) {
        counter--;
        if (counter == 0) {
          $scope.searchHeaderLoader = false;
        }
        if (
          data.data.courses.length == 0 &&
          data.data.instructors.length == 0
        ) {
          $scope.noResult = true;
        }
        if (data.data.courses.length > 0 || data.data.instructors.length > 0) {
          $scope.noResult = false;
        }
        var element = document.getElementById("header-search");
        element.classList.add("active");
        $scope.searchHeaderOpen = true;
        $scope.courseHeaderResults = data.data.courses;
        $scope.instrutorHeaderResults = data.data.instructors;
      });
    }

    $scope.hideSearchOpen = function ($event) {
      setTimeout(function () {
        $scope.searchOpen = false;
        if (!$scope.$$phase) $scope.$apply();
        var element = document.getElementById("header-search");
        element.classList.remove("active");
      }, 200);
    };

    $scope.goToCourse = function (course) {
      mixpanel.track('Nearpeer-search', {
        'Course_Name' : course.name,
        'Course_ID' : course.id,
      });
      courseDetailService.goToCourse(course);
    };

    $scope.goToInstructor = function (name) {
      name = name.split(" ").join("-");
      name = name.toLowerCase();
      $state.go("instructor", { instructorName: name });
    };

    $scope.showOverlayResponsive = function () {
      $scope.showResponsiveOverlay = true;
    };

    $scope.initilaize();

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
      var st = $(this).scrollTop();
      if (lastScrollTop === 0 && st > 0 && $rootScope.platform_reactApp) {
        console.log("scroll-tip-down");
      }
      if ($rootScope.platform_reactApp && st == 0 && $rootScope.platform_reactApp) {
        console.log("scroll-tip-on-top");
      }

      // console.log("ST",st);
      if (st != 0 && st < 140) {
        // $(".newHeader").removeClass("stickty");
        $(".newHeader").removeClass("fixed");
        // $("header").removeClass("nav-up").addClass("nav-down");
      } else if (st > 150) {
        if (st > lastScrollTop) {
          // $(".newHeader").addClass("stickty");
          $("header").removeClass("nav-down").addClass("nav-up");
        } else {
          $("header").removeClass("nav-up").addClass("nav-down");
          // $(".newHeader").addClass("stickty");
          $(".newHeader").addClass("fixed");
        }
      }else if(st ===0){
        $("header").removeClass("nav-up");
        // $(".newHeader").removeClass("stickty");
        $(".newHeader").removeClass("fixed");
      }
      lastScrollTop = st;
    });


    $scope.showMyAccountPopup = function () {
      $scope.closeMergeTooltip();
      $rootScope.closedToolTip = true;
      $scope.myAccountPopup = true;
      if ($rootScope.mergeTooltip && $rootScope.mergeNotify) {
        $http
          .get(
            "/api/v1/user/update-merge-count/" +
              CustomStorageService.getUserInfoStorageData().id
          )
          .then(function (data) {
            if (data.data.success && data.data.mergeShowCount < 3) {
              $rootScope.mergeNotify = true;
            } else {
              $scope.closeMergeTooltip();
              $rootScope.mergeNotify = false;
            }
          });
      }
    };

    $scope.getInitial = function (name) {
      // console.log(CustomStorageService.getUserInfoStorageData(),"Data");
      if (CustomStorageService.getUserInfoStorageData()) {
        return name.charAt(0).toUpperCase();
      }
    };

    $scope.closeFormm = function () {
      $scope.myAccountPopup = false;
      if (!$scope.$$phase) $scope.$apply();
    };

    $scope.showResponsiveSearch = function () {
      $("#header-search").show();
    };

    $scope.hideResponsiveSearch = function () {
      $("#header-search").hide();
    };

    $sails.get("/api/v1/sockets/setSocket").then(function (resp) {
      CustomStorageService.setSocketIdStorageData(resp.data.socketId);
    });

    $sails.on("facebookLoginEvent", function (data) {
      console.log('facebokk event');
      console.log(data);
      if (data.success) {
        $scope.text = "Logged in as " + data.userData.name;
        swal(
          {
            title: "Log In Successful!",
            text: $scope.text,
            type: "success",
            timer: 2000,
            showConfirmButton: false,
          },
          function () {
            swal.close();
            CustomStorageService.SignInService(
              false,
              true,
              false,
              false,
              data.token,
              data.userData
            );
            location.reload();
          }
        );
      } else {
        $scope.sessions = data.data.sessions;
        $scope.userData = data.user;
        $scope.logoutAll = true;
        $scope.OTP = true;
        if($rootScope.platform_reactApp){
          console.log("popup-open")
        }
        if (($scope.userData.provider = "email")) {
          $scope.userEmail = $scope.userData.email;
        } else if (($scope.userData.provider = "facebook")) {
          $scope.userEmail = $scope.userData.fb_email
            ? $scope.userData.fb_email
            : $scope.userData.email;
        } else if (($scope.userData.provider = "apple")) {
          $scope.userEmail = $scope.userData.apple_email
            ? $scope.userData.apple_email
            : $scope.userData.email;
        } else if (($scope.userData.provider = "google")) {
          $scope.userEmail = $scope.userData.email;
        }
        $scope.splitEmail = $scope.userEmail.split("@");
        if (
          $scope.userData.phone &&
          ($scope.userData.phone.length === 11 ||
            $scope.userData.phone.length === 12) &&
          !isNaN($scope.userData.phone)
        ) {
          $scope.userPhone = $scope.userData.phone;
        }
      }
    });
    $scope.userDropDown = function(){
      $scope.user_dropdown = !$scope.user_dropdown;
    }
    $scope.closeThis = function () {
      $scope.search = "";
      $scope.courseSearchList = false;
    }
    $scope.gotoLink = function(link) {
      window.open('https://forms.gle/'+link, '_blank');
    }

    $scope.gotoLink = function (link) {
      window.open("https://forms.gle/" + link, "_blank");
    };

    $scope.gotoCustomLink = function (link) {
      window.open(link, "_blank");
    };
    var loginInterval;
    var loginOpenReactApp= function () {
      // console.log("in here2");

      if (!$rootScope.isWindowloaded) {
        setTimeout(loginOpenReactApp, 100)
      } else {
        // clearInterval(loginInterval);
        try {
          $scope.showNewLoginDiv = true;
          $rootScope.loginFormSelected = true;
          $rootScope.signupFormSelected = false;

          // googleInit()
          $scope.$apply();
          $rootScope.$apply();
        } catch (error) {
          console.log('error');
          console.log(error);
        }
        
      }
    };
  
    ///////////////////REACT APP

    $scope.handleEvent = function async(message) {
      if ($rootScope.platform_reactApp) {
        try {
          if (message.data.message == "logoutOutFromAll") {
            $scope.logOut();
          }
          if (message.data.message === "openLogin") {
            console.log("in here");
            loginOpenReactApp();
          }
        } catch (err) {
          console.log("ERROR in Catching Events HEADER");
          console.log(JSON.stringify(err));
        }
      }
    };

    var listener = document.addEventListener("message", $scope.handleEvent); ///DONOT REMOVE $scope
    if ($rootScope.platform_reactApp) {
      console.log(listener); ///DONOT REMOVE $scope CONSOLE
      $scope.handleEvent(listener); ///DONOT REMOVE THIS
    }
    $scope.EmailSubscribe = function (subscribeEmail) {
      if(subscribeEmail) {
        BlogBackendServices.EmailSubscribeBlog(subscribeEmail);
        $scope.secondryFooterEmail = "";
      }
    }
    $scope.courseSearchOpen = function (){
      $scope.courseSearch = true;
    }
    $scope.courseSearchClose = function (){
      $scope.courseSearch = false;
    }
    $scope.search = "";
    $scope.courseSearchListOpen = function (search) {
      if(!search){
        return $scope.filterdData = [];
      }
      var newArray = searchcourses.filter(function (el) {
        var data = el.name && el.name.toLowerCase().includes(search.toLowerCase());
        return data;
      });
      if(newArray.length > 5){
        newArray = newArray.splice(0, 5);
      }
      $scope.filterdData = newArray;
      $scope.courseSearchList = true;
    }

    $scope.showTime = function(notification) {
      return moment(notification.notifications.createdAt)
        .format("hh: mm A");
    }
    $scope.showDate = function(notification, index) {
      var prevText;
      if(index > 0) {
        var compareDate = this.notifications[index-1];
        prevText = moment(compareDate.notifications.createdAt)
        .calendar({
          sameDay: "[Today]",
          nextDay: "DD/MM/YYYY",
          nextWeek: "DD/MM/YYYY",
          lastDay: "[Yesterday]",
          lastWeek: '[Last] dddd',
          sameElse: "DD/MM/YYYY",
        }).split(" at")[0];
      }
      var text = moment(notification.notifications.createdAt)
        .calendar({
          sameDay: "[Today]",
          nextDay: "DD/MM/YYYY",
          nextWeek: "DD/MM/YYYY",
          lastDay: "[Yesterday]",
          lastWeek: '[Last] dddd',
          sameElse: "DD/MM/YYYY",
        }).split(" at")[0];
        
      if(text == prevText) {
        return false
      }
      return text;
    }

    $scope.redirectToApp = function() {
      if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){ window.location.href = 'https://www.nearpeer.org/np-link/ozpsqx5dmv'; }

      if(navigator.userAgent.toLowerCase().indexOf("android") > -1){ window.location.href = 'https://www.nearpeer.org/np-link/iowcp8ia8e'; }

    }
    $scope.closeAppNoti = function () {
      $scope.appNotification = false
    }
    $scope.myCourseEvent = function () {
      console.log('-----------------0');
        mixpanel.track('My-Course');
    }
  };
  

})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .controller('DownloadAppMobileController', DownloadAppController);

    function DownloadAppController(CustomStorageService, $scope, $http, $base64, $timeout, $state, BreadcrumbService) {
        $scope.counter = 10;
        $scope.popupDiv = false;
        $scope.emailValid = true;
        $scope.submitted = false;
        $scope.emailAddress = '';
        var downloadType = '';
        $scope.openPopUp = function (deviceTypo) {
            downloadType = deviceTypo;
            var dynamiclink;
            if(deviceTypo == 'Windows'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Windows-2.exe';
            }
            else if(deviceTypo == 'Mac'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer_Mac_App.zip';
            }
            else if(deviceTypo == 'Linux'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Linux.AppImage';
            }
            $scope.popupDiv = true;
            $scope.counter = 10;
            $scope.setCount();
            setTimeout( function(){
                window.open(dynamiclink,"_self");
              }, 10000)
              $scope.goToApp(null,null)
        }
        $scope.goToApp = function (email,addionalPopUpClosingParam,emailSubmissionOnly){
            if(emailSubmissionOnly == 'emailSubmissionOnlyTrue' && !validateEmail(email)){
                $scope.emailValid = false;
                return;
            }
            $scope.emailValid = true;
            var userId;
            var data;
            userId = CustomStorageService.getUserInfoStorageData()
            if(userId != false){
                userId = CustomStorageService.getUserInfoStorageData().id;
                data = {
                    'email':email,
                    'userId':userId,
                    'downloadType':downloadType
                }
             }
             else{
                 data = {
                    'email':email,
                    'downloadType':downloadType
                }
            }
            if(emailSubmissionOnly == 'emailSubmissionOnlyTrue'){
                data.emailSubmissionOnly = true;
            }
            $http.post('api/v1/apps/saveAppDownloadInfo', data)
            .then(function (res) {
                if(addionalPopUpClosingParam == 'popUpCloseTrue'){
                    $scope.submitted = true;
                    $timeout( function(){
                        $scope.popupDiv = false;
                        $scope.submitted = false;
                    }, 5000);
                }
            },function (error) {
            })
        }
        $scope.setCount = function (){
            $timeout( function(){
                if($scope.counter < 11 && $scope.counter > 0){
                    $scope.counter--;
                    $scope.setCount();
                }
            }, 1000);
        }
        $scope.closePopup = function (){
            $scope.popupDiv = false;
        }
        function validateEmail(email) 
        {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }
        function onloadFunction(data) {
            console.log("🚀 ~ file: downloadApp.js:90 ~ onloadFunction ~ data:", data)
            BreadcrumbService.setBreadCrumb(data,'LEAF');
        }
        onloadFunction({'url': '/downloadapp' ,'displayName': 'Download App' },'LEAF');
        };

})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .controller('DownloadAppController', DownloadAppController);

    function DownloadAppController(CustomStorageService, $scope, $http, $base64, $timeout, $state) {
        $scope.counter = 10;
        $scope.popupDiv = false;
        $scope.emailValid = true;
        $scope.submitted = false;
        $scope.emailAddress = '';
        var downloadType = '';
        $scope.openPopUp = function (deviceTypo) {
            downloadType = deviceTypo;
            var dynamiclink;
            if(deviceTypo == 'Windows'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Windows-2.exe';
            }
            else if(deviceTypo == 'Mac'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer_Mac_App.zip';
            }
            else if(deviceTypo == 'Linux'){
                dynamiclink ='https://downloads.nearpeer.org/desktop-app/Nearpeer-Desktop-Linux.AppImage';
            }
            $scope.popupDiv = true;
            $scope.counter = 10;
            $scope.setCount();
            setTimeout( function(){
                window.open(dynamiclink,"_self");
              }, 10000)
              $scope.goToApp(null,null)
        }
        $scope.goToApp = function (email,addionalPopUpClosingParam,emailSubmissionOnly){
            if(emailSubmissionOnly == 'emailSubmissionOnlyTrue' && !validateEmail(email)){
                $scope.emailValid = false;
                return;
            }
            $scope.emailValid = true;
            var userId;
            var data;
            userId = CustomStorageService.getUserInfoStorageData()
            if(userId != false){
                userId = CustomStorageService.getUserInfoStorageData().id;
                data = {
                    'email':email,
                    'userId':userId,
                    'downloadType':downloadType
                }
             }
             else{
                 data = {
                    'email':email,
                    'downloadType':downloadType
                }
            }
            if(emailSubmissionOnly == 'emailSubmissionOnlyTrue'){
                data.emailSubmissionOnly = true;
            }
            $http.post('api/v1/apps/saveAppDownloadInfo', data)
            .then(function (res) {
                if(addionalPopUpClosingParam == 'popUpCloseTrue'){
                    $scope.submitted = true;
                    $timeout( function(){
                        $scope.popupDiv = false;
                        $scope.submitted = false;
                    }, 5000);
                }
            },function (error) {
            })
        }
        $scope.setCount = function (){
            $timeout( function(){
                if($scope.counter < 11 && $scope.counter > 0){
                    $scope.counter--;
                    $scope.setCount();
                }
            }, 1000);
        }
        $scope.closePopup = function (){
            $scope.popupDiv = false;
        }
        function validateEmail(email) 
        {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }
    };

})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .controller('ContactUsController', MainController);

    function MainController(courseDetailService, $rootScope, $scope, $http, $base64, $timeout, $state, BreadcrumbService) {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });

        $scope.mdcatState = false;
        $scope.caState = false;
        $scope.cssState = false;
        $scope.satState = false;
        $scope.nustState = false;
        $scope.accaState = false;
        $scope.tiState = false;
        $scope.furtherDetails = false;

        $scope.rotate180 = function (id) {
            if (id === 'mdcat') {
                ($scope.mdcatState) ? $scope.mdcatState = false : $scope.mdcatState = true
            } else if (id === 'ca') {
                ($scope.caState) ? $scope.caState = false : $scope.caState = true
            } else if (id === 'css') {
                ($scope.cssState) ? $scope.cssState = false : $scope.cssState = true
            } else if (id === 'sat') {
                ($scope.satState) ? $scope.satState = false : $scope.satState = true
            } else if (id === 'nust') {
                ($scope.nustState) ? $scope.nustState = false : $scope.nustState = true
            } else if (id === 'acca') {
                ($scope.accaState) ? $scope.accaState = false : $scope.accaState = true
            } else if (id === 'ti') {
                ($scope.tiState) ? $scope.tiState = false : $scope.tiState = true
            }
        };

        $scope.showFurtherDetails = function (){
            if($scope.furtherDetails == false){
                $scope.furtherDetails = true;
            }
            else{
                $scope.furtherDetails = false;
            }
        }


        function onloadFunction(data) {
      BreadcrumbService.setBreadCrumb(data,'LEAF');        
    } 
    onloadFunction(
          {
            'url': '/contact-us' , 'displayName': 'Contact us',
          }
          ,'LEAF');
        
    };

})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("AboutUsController", MainController);

  function MainController(
    courseDetailService,
    $rootScope,
    $scope,
    $http,
    $base64,
    $timeout,
    $state,BlogBackendServices,
    BreadcrumbService
  ) {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });

   
    $scope.journeyType = {
      idea: true,
      partnership: false,
      launch: false,
      achievement: false,
      momentum: false,
      plan9: false,
      sat: false,
      entryTest: false,
      austin: false,
      ring: false,
      cssLaunch: false,
      startUp: false,
      accaLaunch: false,
      seed: false,
      fscLaunch: false,
      advisors: false,
    };
    $scope.subscribe = false;
    $scope.email = "";
    $scope.filterJourney = function (state) {
      Object.keys($scope.journeyType).forEach( function (element){
        if (element == state) {
          $scope.journeyType[element] = true;
        } else {
          $scope.journeyType[element] = false;
        }
      });
    };

    $scope.workWithUs = function (){
      console.log("IN WORK");
      window.open(
        "https://forms.gle/5TEg8Vt1ffpJdBGt6", "_blank");
    }

    $scope.earnWithUs = function (){
      console.log("IN Earn");
      window.open(
        "https://forms.gle/DFfacqwZHsfenHJk6", "_blank");
    }

    $scope.EmailSubscribe =function (subscribeEmail) {
      if(subscribeEmail) {
        BlogBackendServices.EmailSubscribeBlog(subscribeEmail);
        $scope.email = "";
      }
    }


    AOS.init({
      once: true
   });
    new WOW().init();


    function onloadFunction(data) {
      BreadcrumbService.setBreadCrumb(data,'LEAF');
    }
    onloadFunction({'url': '/about-us' ,'displayName': 'About us' },'LEAF');


  }
})();

(function() {
    'use strict';
    angular
    .module('NearPeer')
    .controller('adminOtpPageController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', '$cookies', function($scope, $http, $state,$rootScope, CustomStorageService, $cookies) {
      if( CustomStorageService.getAdminSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
        $state.go('AdminDashBoard',{},{reload:true});
      }
      $scope.verifyOtp = function() {
        var browserId = $cookies.get('browserId');
        const data = {
          user_id: $state.params.user_id,
          code: $scope.otpCode,
          browser_id: browserId,
          origin: "LEGACY",
          admin: true
        }
        $http.post('/api/v1/auth/validate-otp',data)
        .then(function(resp) {
          if (resp.data.user.user_type === 'admin') {
            swal({
              title: "Code Verified",
              type: "success",
              timer: 2000,
              showConfirmButton: false
            }, function() {
              swal.close();
              CustomStorageService.SignInService(true,false,false, false,resp.data.token,resp.data.user);
              $state.go('admin',{},{reload:true});
            });
          } else {
            swal({
              title: "Not Authorized!",
              type: "error",
              confirmButtonText: "Ok"
            }, function() {
              CustomStorageService.logOutService();
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Invalid Verification Code',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      };

      $scope.resendOtp = function() {
        const data = {
          user_id: $state.params.user_id,
          type: 'email',
        }
        $http.post('/api/v1/auth/resend-otp',data)
        .then(function(resp) {
          if (resp.data.success) {
            swal({
              title: "Code Sent",
              text: 'Invalid Verification Code',
              type: "success",
              showConfirmButton: true
            })
          } else {
            swal({
              title: "Error",
              type: "error",
              text: 'Error while sending code',
            }, function() {
              CustomStorageService.logOutService();
            });
          }
        },function errorCallback(response) {
          swal({
            title: 'Error',
            text: 'Error while sending code',
            type: 'error',
            showCancelButton: false
          },function(isConfirm){
          });
        });
      };
    }]);
  })();
(function() {
  'use strict';
  angular
  .module('NearPeer')
  .controller('AdminSigninController', ['$scope', '$http', '$state','$rootScope', 'CustomStorageService', '$cookies', function($scope, $http, $state,$rootScope, CustomStorageService, $cookies) {
    if( CustomStorageService.getAdminSignedInStorageData() && CustomStorageService.getUserInfoStorageData()){
      $state.go('admin',{},{reload:true});
    }
    $scope.loginForm = {};
    $rootScope.userSide= false;
    $rootScope.adminSide = true;
    $scope.submitLogin = function(loginForm) {
      var browserId = $cookies.get('browserId');
      loginForm.browser_id = browserId;
      loginForm.origin = 'LEGACY';
      $http.post('/api/v1/auth/signin',loginForm)
      .then(function(resp) {
        if (resp.data.user.user_type === 'admin') {
          swal({
            title: "Verification Code Sent!",
            text: resp.data.message,
            type: "success",
            showConfirmButton: true
          }, function() {
            swal.close();
            //CustomStorageService.SignInService(true,false,false,resp.data.token,resp.data.user);
            $state.go('adminOtp',{user_id: resp.data.user.id});
          });
        } else {
          swal({
            title: "Not Authorized!",
            type: "error",
            confirmButtonText: "Ok"
          }, function() {
            CustomStorageService.logOutService();
          });
        }
      },function errorCallback(response) {
        swal({
          title: 'error',
          text: response.data.message,
          type: 'error',
          showCancelButton: false
        },function(isConfirm){
        });
      });
    };
  }]);
})();

(function() {
  'use strict';


  angular
  .module('NearPeer')

  .controller('AdminController', ['$scope','Upload','$timeout', '$http', '$state', 'CustomStorageService', '$sails', 'env', function($scope, Upload, $timeout, $http, $state, CustomStorageService, $sails, env) {
    $scope.moduleCount = 1;
    $scope.blog = {metatags: []};
    $scope.category = {};
    $scope.metatagProperty = '';
    $scope.metatagContent = '';
    $scope.blogCategories = [];
    // $scope.bundle = {};
    // $scope.bundle['courses'] = [];
    // $scope.bundle['price'] = 0;
    $scope.blog['images'] = [];
    $scope.blog['category_id'] = '0';
    $scope.files_ = [];
    $scope.modules = [];
    $scope.videoForm = false;
    $scope.socket = null;
    $scope.signedIn = CustomStorageService.getAdminSignedInStorageData();
    $scope.collapseCourseRow =  false;
    $scope.collapseModuleRow = false;
    $scope.showModuleEForm = false;
    $scope.selModule = 0;
    $scope.coupon_record_no = 20;
    $scope.module_record_no = 20;
    $scope.credit_record_no = 20;
    $scope.user_record_no = 20;
    $scope.firstTimeCoupons = 1;
    $scope.firstTimeCredits = 1;
    $scope.firstTimeModules = 1;
    $scope.firstTimeUsers = 1;
    $scope.sortReverse = false;
    $scope.sortType = 1;
    $scope.sortTypeModule = 1;
    $scope.sortTypeCredit = 1;
    $scope.responsePopup = false;
    $scope.createInstructorForm = false;
    $scope.instructorList = false;
    $scope.initialize = function() {
      Quill.register({
        "modules/htmlEditButton": htmlEditButton,
        // "modules/betterTable": quillBetterTable
      });

      $sails.get('/api/v1/sockets/setSocket')
      .then(function(resp){
        CustomStorageService.setSocketIdStorageData(resp.data.socketId);
      })
      $scope.createCourseForm = {};
      $scope.createCourseForm.instructor = CustomStorageService.getUserInfoStorageData().full_name;
      $scope.createCourseForm.live_date = new Date();


      $http({
        url:'api/v1/courses/getUniversityList',
        method:"GET",
        params: {type: 'admin'}
      }).then(function (data) {
        $scope.institutions = data.data;
        $scope.selectedInstitution = "Select Institution";
      });
    };

    $scope.showModuleForm = function() {
      $scope.courseFormFlag = true;
      $scope.course_form = true;
      var module = {};
      module.moduleNo = $scope.moduleCount;
      $scope.module_map[module.moduleNo] = module;
      $scope.moduleCount++;
      $scope.modules.push(module);
    };

    $scope.showCourseForm = function() {
      $scope.hideAll();
      $scope.courseFormFlag = true;
      $scope.createCouponForm = {};
      $scope.module_map = {};
    };

    $scope.$watch('files', function () {
      $scope.upload($scope.files);
    });

    $scope.$watch('file', function () {
      if ($scope.file != null) {
        $scope.files = [$scope.file];
      }
    });

    $scope.logs = {};
    $scope.image_log = '';
    $scope.upload = function (files, event, flow, module) {
      var total_files = 0;
      if (files && files.length) {
        module.files_ = [];
        module.logs = {};
        module.total_files = 0;
        module.failed_files = [];
        for (var i = 0; i < files.length; i++) {
          var file = files[i].file;
          $scope.upload_alternate(file, module);
        }
      } else {
        if (files) {
          swal({
            title: "Error!",
            text: "Files alreay uplaoded. Try uploading another folder!",
            type: "error",
            confirmButtonText: "Ok"
          });
        }
      }
    };

    $scope.upload_alternate = function(file, module) {
      if (!file.$error && file.type.indexOf('video/') > -1) {
        module.files_.push(file);
        module.total_files += 1;
        module.show_logs = true;
        module.logs[file.name] = {name: 'Uploading to server: \n'+file.name, progress: 0};
        var data = {userId: CustomStorageService.getUserInfoStorageData().id, moduleNo: module.moduleNo, file: file.name};
        Upload.upload({
          url: '/upload',
          method: 'POST',
          file: file,
          params: data
        }).then(function (resp) {
          module.logs[resp.config.file.name] = {name: 'Uploading to server: \n'+resp.config.file.name, progress: 100};
        }, function (resp) {
          module.failed_files.push(file);
          module.total_files -= 1;
          if (module.total_files <= 0) {
            swal({
              title: "Error!",
              text: "Some files were not uploaded.",
              type: "error",
              showCancelButton: true,
              confirmButtonText: "Retry",
              cancelButtonText: "Cancel"
            }, function(confirm) {
              if (confirm) {
                var files = angular.copy(module.failed_files);
                $scope.retry_upload(files, module);
                module.failed_files = [];
              }
            });
          }
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          module.logs[evt.config.file.name] = {name: 'Uploading to server: \n'+evt.config.file.name, progress: progressPercentage};
        });
      }
    };

    $scope.retry_upload = function(files, module) {
      module.total_files = 0;
      module.files_ = [];
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        $scope.upload_alternate(file, module);
      }
    };

    $scope.createModule = function() {
      if (!$scope.module.name || !$scope.module.short_description ||
        !$scope.module.description || (!$scope.module.module_type.paid && !$scope.module.module_type.free)
        || ($scope.module.module_type.paid && !$scope.module.module_type.price)) {
          swal({
            title: "Error!",
            text: "Make sure you have filled all fields and checked Free or Paid option",
            type: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        if (!$scope.modules) {
          $scope.modules = [];
        }
        if (!$scope.module.image_url) {
          $scope.module.image_url = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png';
        }
        $scope.module_imageUploaded = false;
        $scope.logs = {};
        $scope.modules.push($scope.module);
        $scope.showModuleFlag = false;
        $scope.createCourseFlag = true;
        $scope.course_form = true;
      };


      $scope.revertbtn = function() {

        var id = $scope.selectedCourse.id;
        swal({
          title: "Are you sure to revert transcoding button?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes !",
          closeOnConfirm: true},
          function(isConfirm){
            if(isConfirm) {
              $http.post('api/v1/cvideo/revertPreviousTranscodingBtn',{course_id:id})
              .then(function (data) {
                if (data.data.success){
                  $scope.selectedCourse.previous_high_quality = false;
                }
              });
            }
          });
        };
        $scope.convertVideoHD = function() {
          var id = $scope.selectedCourse.id;
          swal({
            title: "Are you sure to transcode?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, submit it!",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                $http({
                  url: 'api/v1/cvideo/PreviousVideosTranscode',
                  method: "GET",
                  params: {id:id }
                }).then(function(data) {
                  $scope.selectedCourse.previous_high_quality = true;
                });
              }
            });
          };

          $scope.convertVideoVimeo = function() {
            var id = $scope.selectedCourse.id;
            swal({
              title: "Are you sure to convert all video to vimeo?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, submit it!",
              closeOnConfirm: true},
              function(isConfirm){
                if(isConfirm) {
                  $http.post('http://localhost:3000/v1/videos/migrate-to-vimeo', {course_id: id}).then(function(data) {
                    swal({
                      title: "Uploding to Vimeo started",
                      type: "success",
                    }, function() {});
                  });
                }
              });
            };

            $scope.transcodeToGCP = function() {
              var id = $scope.selectedCourse.id;
              swal({
                title: "Are you sure to Transcode video to GCP?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                closeOnConfirm: true},
                function(isConfirm){
                  if(isConfirm) {
                    $http({
                      url: env.videoMigrationMicroServicePath + 's3totovimeomigration/v1/videos/upload-to-gcp/'+id,
                      method: "GET",
                      params: {id:id }
                    }).then(function(data) {
                      // $scope.selectedCourse.previous_high_quality = true;
                    });
                  }
                });
              };

          $scope.courseOrderTermination = function() {
            var id = $scope.selectedCourse.id;
            swal({
              title: "Are you sure to terminate Access for this course?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, submit it!",
              closeOnConfirm: true},
              function(isConfirm){
                if(isConfirm) {
                  $http({
                    url: 'api/v1/orders/course/terminate',
                    method: "GET",
                    params: {id:id }
                  }).then(function(data) {
                    // $scope.selectedCourse.previous_high_quality = true;
                  });
                }
              });
            };

          $scope.createCourse = function() {
            if (!$scope.createCourseForm.special){
              $scope.createCourseForm.special = false;
            }
            if (!$scope.createCourseForm.name || !$scope.createCourseForm.description
              || !$scope.createCourseForm.institution || !$scope.createCourseForm.faculty
              || !$scope.createCourseForm.instructor) {
                swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                });
                return;
              }

              if (!$scope.createCourseForm.image_url) {
                $scope.createCourseForm.image_url = 'https://storage.googleapis.com/nps3storage/nearpeer-imagees/created.png';
              }
              $scope.loader = true;
              var coursee = $scope.createCourseForm.name.toLowerCase();
              var institution = $scope.createCourseForm.institution.toLowerCase();
              institution = institution.split(' ').join('-');
              var faculty = $scope.createCourseForm.faculty.toLowerCase();
              faculty = faculty.split(' ').join('-');
              coursee = coursee.split('-').join('');
              coursee = coursee.split('  ').join(' ')
              coursee = coursee.split(' ').join('-');
              $scope.createCourseForm.index_url = institution + '/' + faculty + '/' + coursee;

              $http.post('api/v1/courses/createCourse', {course: $scope.createCourseForm})
              .then(function (data) {
                $scope.loader = false;
                swal({
                  title: "Course Successfully Created",
                  type: "success",
                }, function() {
                  $scope.createCourseForm = {};
                  $scope.modules = [];
                  $scope.course_imageUploaded = false;
                  $scope.module_imageUploaded = false;
                  $scope.module_map = {};
                  location.reload();
                });
              });
              $scope.moduleCount = 1;
            };

            $scope.uploadImage = function(file, type) {
              if (file) {
                if ( file.size > 1000000 && (type === 'blogImage' || type=== 'blogBanner') ){
                  return alert('Image size must be less then 1 mb');
                }
                //imageUploadInProgress
                Upload.upload({
                  url: '/api/v1/uploader/uploadImageToS3',
                  method: 'POST',
                  file: file,
                  params: {userId:CustomStorageService.getUserInfoStorageData().id}
                }).then(function (resp) {
                  if(type == 'newCourseImage'){
                    $scope.createCourseForm.image_url = resp.data.link;
                  } else if(type == 'editCourseImage') {
                    $scope.selectedCourse.image_url = resp.data.link;
                  } else if(type == 'newModuleImage'){
                    $scope.selectedModule.image_url = resp.data.link;
                  } else if(type == 'editModuleImage') {
                    $scope.selectedModule.image_url = resp.data.link;
                  } else if (type === 'blogImage') {
                    $scope.blog.images.push({url: resp.data.link });
                    if (!$scope.$$phase) $scope.$apply();
                  } else if (type === 'blogBanner') {
                    $scope.blog.image= resp.data.link ;
                  } else if (type === 'blogCategoryImage') {
                    $scope.category.image_url = resp.data.link ;
                  }
                  
                  //  else if (type === 'bundleImage') {
                  //   $scope.bundle.image_url= resp.data.link ;
                  // }
                });
              }
            };

            $scope.cancelModule = function() {
              $scope.showModuleFlag = false;
              $scope.module_imageUploaded = false;
              $scope.files_uploaded = false;
              $scope.show_logs = false;
              $scope.image_log = {};
              $scope.module = {};
              $scope.logs = {};
              $scope.files_ = [];
              $scope.course_form = true;
            };
            $scope.showCouponForm = function() {
              $scope.hideAll();
              $scope.coupon_form_flag = true;
            };

            $scope.createCoupons = function() {
              if (!$scope.createCouponForm.quantity || !$scope.createCouponForm.price || !$scope.createCouponForm.expiryDate) {
                swal({
                  title: "Error!",
                  text: "Make sure you have filled all fields",
                  type: "error",
                  confirmButtonText: "Ok"
                });
                return;
              }
              $scope.coupon_button = true;
              $http.post('api/v1/coupons/createCoupons', $scope.createCouponForm)
              .then(function (data) {
                $scope.downlod_csv(data.data);
                $scope.createCouponForm = {};
                $scope.coupon_button = false;
              });
            };

            $scope.showCoupons = function(page,type) {
              $scope.responsePopup = true;
              $scope.hidePagination = false;
              var data = {page: page,per_page: $scope.coupon_record_no,type:type};
              $scope.hideAll();
              $scope.show_coupons = true;
              if (!$scope.total_coupon_pages) {
                $scope.responsePopup = false;
                $scope.total_coupon_pages = 1;
              }
              if (page > 0 && page < $scope.total_coupon_pages+1) {
                $scope.page = page;
                $http({
                  url: 'api/v1/coupons/showCoupons',
                  method: "GET",
                  params: data
                }).then(function(data) {
                  $scope.responsePopup = false;
                  $scope.coupons = data.data.coupons;
                  $scope.total_coupon_pages = data.data.total_pages;
                  $scope.total_coupons = data.data.total_count;
                });
              } else if (page < 1) {
                $scope.responsePopup = false;
                page = 1;
              } else if (page > $scope.total_coupon_pages) {
                $scope.responsePopup = false;
                page = $scope.total_coupon_pages;
              }
            };

            $scope.checkWebServingStatus = function(user) {
              if(user.servingUpdated) return true;
              if(user.req_video_web_time) {
                var GivenDate = user.req_video_web_time;
                var CurrentDate = new Date();
                GivenDate = new Date(GivenDate);
                console.log(GivenDate > CurrentDate);
                return GivenDate > CurrentDate;
              } else {
                return false
              }
              
            }

            $scope.requestVideoOnWeb = function(user) {
              $http.post('/api/v1/user/req-video-on-web', {uder_id: user.id})
                .then(function (data) {
                  if (data.data.success) {
                    user.servingUpdated = true; 
                    swal({
                      title: "Successful!",
                      text: data.data.message,
                      type: "success",
                      confirmButtonText: "Ok"
                    }, function() {
                    });
                  }else{
                    swal({
                      title: "Error!",
                      text: data.data.message,
                      type: "error",
                      confirmButtonText: "Ok"
                    }, function() {
                    });
                  }
                });
              };

            $scope.showUsers = function(page, type_, search_query) {
              $scope.hideAll();
              $scope.responsePopup = true;
              $scope.show_users = true;
              if (!$scope.total_users_pages) {
                $scope.total_users_pages = 1;
              }
              if (page > 0 && page < $scope.total_users_pages+1) {
                $scope.page = page;
                var data = {page: page,per_page:$scope.user_record_no};
                if (type_) {
                  $scope.type_ = type_;
                  $scope.search_query = search_query;
                  data['type'] = type_;
                  data['search_query'] = search_query;
                }
                $http({
                  url: 'api/v1/users/getUsersData',
                  method: "GET",
                  params: data
                }).then(function(data) {
                  $scope.responsePopup = false;
                  $scope.users = data.data.users;
                  $scope.total_users_pages = data.data.total_pages;
                  $scope.total_users = data.data.total_count;
                });
              } else if (page < 1) {
                page = 1;
                $scope.responsePopup = false;
              } else if (page > $scope.total_users_pages) {
                page = $scope.total_users_pages;
                $scope.responsePopup = false;
              }
            };

            $scope.showCourses = function(page) {
              $scope.hideAll();
              $scope.show_courses = true;
              if (!$scope.total_course_pages) {
                $scope.total_course_pages = 1;
              }
              if (page > 0 && page < $scope.total_course_pages+1) {
                $scope.page = page;
                var data = {page: page};
                /*$http({
                url: 'api/v1/courses/show_courses',
                method: "GET",
                params: data
              }).then(function(data) {
              $scope.courses = data.data.courses;
              $scope.total_course_pages = data.data.pagination.total;
            });*/
          } else if (page < 1) {
            page = 1;
          } else if (page > $scope.total_course_pages) {
            page = $scope.total_course_pages;
          }
        };

        $scope.hideAll = function() {
          // $scope.jazzCashOrdersDashboard = false;
          $scope.showBlogComments = false;
          $scope.showCreateBlogCategoryForm = false;
          $scope.show_blog_categories = false;
          $scope.showEditBlogForm = false;
          $scope.showCreateBlogForm = false;
          $scope.enrolledStudentsTable = false;
          $scope.addNewQualityVideo = false;
          $scope.loadVideo = false;
          $scope.instructorList = false;
          $scope.createInstructorForm = false;
          $scope.listModules = false;
          $scope.collapseNewModuleRow = false;
          $scope.newModuleForm = false;
          $scope.showModuleEForm = false;
          $scope.collapseModuleRow = false;
          $scope.collapseCourseRow = false;
          $scope.courseFormFlag = false;
          $scope.showModuleFlag = false;
          $scope.coupon_form_flag = false;
          $scope.show_coupons = false;
          // $scope.show_module_transactions = false;
          // $scope.show_credit_transactions = false;
          $scope.show_users = false;
          $scope.show_courses = false;
          $scope.videoForm = false;
          $scope.addNewModule = false;
          // $scope.addNewBundle = false;
          // $scope.showBundle = false;

        };
        $scope.deleteMetatagCourse = function(index){
          $scope.selectedCourse.metatags.splice(index, 1);
        }
        $scope.addMetaTagToCourse = function () {
          if (!$scope.metatagContent || !$scope.metatagProperty) {
            return alert("please add valid metatag property and content");
          }
          if(!$scope.selectedCourse.metatags) {
            $scope.selectedCourse.metatags = [];
          }
          $scope.selectedCourse.metatags.push({
            property: $scope.metatagProperty,
            content: $scope.metatagContent,
          });
          $scope.metatagContent = '';
          $scope.metatagProperty = '';
          return true;
        };

        $scope.UpdateCourse = function(course,qualities) {
          var coursee = course.name.toLowerCase();
          var institution = course.institution.toLowerCase();
          institution = institution.split(' ').join('-');
          var faculty = course.faculty.toLowerCase();
          faculty  = faculty.split(' ').join('-');
          coursee = coursee.split('-').join('');
          coursee = coursee.split('  ').join(' ')
          coursee = coursee.split(' ').join('-');
          course.index_url = institution + '/' + faculty + '/' + coursee;
          course.qualities = qualities;
          var data = {course: course,id:course.id};
          $http.post('api/v1/courses/updateCourse', data).then(function(data) {
            if(data.data.success){
              alert('Successfully Updated');
              location.reload();
            }
          });
        };

        $scope.changeDownloadConfig = function(type) {

          if($scope.selectedCourse.delete_offline_videos && type === 'delete') {
            $scope.selectedCourse.allow_download_offline = false;
          }
          
          if ($scope.selectedCourse.allow_download_offline && type === 'download') {
            $scope.selectedCourse.delete_offline_videos = false;
          }
        }


        $scope.downlod_csv = function(data) {

          var csv = 'CouponId,Price,Created At\n';
          data.forEach(function(row) {
            csv += row.join(',');
            csv += '\n';
          });
          var parent = document.getElementById('download_csv');
          var hiddenElement = document.createElement('a');
          parent.appendChild(hiddenElement);
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
          hiddenElement.target = '_blank';
          hiddenElement.download = new Date().toUTCString()+'-people.csv';
          hiddenElement.click();
          parent.removeChild(hiddenElement);
        }

        $scope.showVideoManagement = function(){
          $scope.hideAll();
          $scope.videoForm = true;
          $scope.module_map = {};
        }







        $scope.downloadEnrollment = function(course) {

          var courseId = $scope.allCourses[course].id
          $http({
            url: 'api/v1/enrolledstudents/getEnrolledStudents',
            method:"GET",
            params:{course_id: courseId,forDownload:true}
          }).then(function(data){
            if(!data.data.success){
              alert(data.data.message);
              $scope.studentsExist = false;
            } else {
              var enrolledStudents = data.data.students;
              var csv = 'User Id,Name,Email,Joining Date,crn,phone,university,city,dob,Mail,Journey\n'
              enrolledStudents.forEach(function(row) {
      					csv += row.join(',');
      					csv += '\n';
      				});
      				var parent = document.getElementById('download_csv');
      				var hiddenElement = document.createElement('a');
      				parent.appendChild(hiddenElement);
      				hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      				hiddenElement.target = '_blank';
      				hiddenElement.download = new Date().toUTCString()+'-enrollments.csv';
      				hiddenElement.click();
      				parent.removeChild(hiddenElement);
            }
          });
    		}

        $scope.updateInstitution = function(institute) {
          $scope.selected_faculty = $scope.institutions[institute].faculties;
          $scope.selectedInstituteNo = institute;
        };

        $scope.updateSchool = function(school) {
          $scope.selectedFaculty = school;
          $scope.getCourses();
        };

        $scope.getCourses = function() {
          if (!$scope.selectedInstitution || !$scope.selectedFaculty) {
            swal({
              title: "Error!",
              text: "Please select an institution and faculty!",
              type: "error",
              confirmButtonText: "Ok"
            });
            return;
          }
          var data = {
            institution: $scope.institutions[$scope.selectedInstituteNo].institution,
            faculty: $scope.selectedFaculty,
            admin: true
          };
          $http({
            url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
            method: "GET",
            params: data
          }).then(function(data) {
            if(data.data.success) {
              $scope.courses = data.data.courses;
            } else {
              alert('server error');
            }

          });
        };

        $scope.updateCourse = function(course){
          var id = $scope.courses[course].id;
          $http({
            url: 'api/v1/courses/getModulesByCourseId',
            method: "GET",
            params: {id: id}
          }).then(function(data) {
            $scope.modules = data.data.modules;
          });
        };

        $scope.submit = function(module){
          var id;
          for(var i in $scope.modules){
            if($scope.modules[i].name === module){
              id = $scope.modules[i].id;
              break;
            }
          }
          $http({
            url: 'api/v1/cvideos/getModuleVideos',
            method: "GET",
            params: {module_id: id}
          }).then(function(data) {
            $scope.showVideos = true;
            $scope.videos = data.data.videos;
          });
        };

        $scope.updateVideoData = function(){
          $scope.loader = true;
          if($scope.selModule == 0){
            for(var i in $scope.modules){
              if($scope.modules[i].name == $scope.selectedModule){
                $scope.selModule = $scope.modules[i];
              }
            }
          }
          $http.post('api/v1/cvideos/updateVideo', {videos: $scope.videos, module: $scope.selModule})
          .then(function (data) {
            $scope.loader = false;
            if(data.data.success){

              alert('Successfully Updated');
              location.reload();
            }
            else{
              alert('There was trouble updating. Please try again');
            }
          });
        };
        $scope.showAddModuleForm = function(){
          $scope.addNewModule = true;

        };
        $scope.showMenu = function(){
          if ($('.menu-items').hasClass('nav-hidden')) {
            $('.menu-items').removeClass("nav-hidden").addClass("nav-visible");
            $('.menu').removeClass("btn-hidden").addClass("btn-visible");
            $('.overlay-body').removeClass("active").addClass("active");
          } else {
            $('.menu-items').addClass("nav-hidden").removeClass("nav-visible");
            $('.menu').addClass("btn-hidden").removeClass("btn-visible");
            $('.overlay-body').addClass("active").removeClass("active");
          }
          jQuery(".overlay-body").click(function(){
            jQuery(".cmn-toggle-switch").click();
          });

        };

        $scope.logOut = function(){
          CustomStorageService.logOutService();
          $state.go('admin_signin',{},{reload:true});
        };

        $scope.showCourseEditForm = function(course){
          $http({
            url: 'api/v1/videoQuality/getAllquality',
            method: 'GET'
          }).then(function(data){
            $scope.course_qualities = data.data.qualities;
            $scope.selectedCourse = $scope.courses[course];
            for(var i in $scope.selectedCourse.quality){
              for (var j in $scope.course_qualities) {
                if($scope.selectedCourse.quality[i].quality_id === $scope.course_qualities[j].id ) {
                  if(!$scope.selectedCourse.quality[i].disabled) {
                    $scope.course_qualities[j].setquality= true;
                  }
                }

              }
            }
            var dt = new Date($scope.selectedCourse.live_date);
            $scope.selectedCourse.live_date = dt;
            $scope.collapseCourseRow = true;
          });
        }

        $scope.showModuleEditForm = function(module){
          $scope.selectedModule = module;
          $scope.collapseModuleRow = true;
        };

        $scope.updateModuleData = function(module){
          $scope.loader = true;

          var data = {module:module,id:module.id};
          $http.post('api/v1/cmodules/updateModule', data).then(function(data) {
            if(data.data.success){
              alert('Successfully Updated');
              location.reload();
            }
            else{
              alert('There was an error updating. Please try again');
            }
            $scope.loader = false;
          });

        };

        $scope.moduleManagement = function(){
          $scope.hideAll();
          $scope.showModuleEForm = true;
        };

        $scope.addModule = function(){
          $scope.hideAll();
          $scope.newModuleForm = true;
        };

        $scope.showNewModuleForm = function(){
          $scope.collapseNewModuleRow = true;
          $scope.selectedModule = {};
        };

        $scope.addNewModuleData = function(module,selectedCourse){
          $scope.loader = true;

          var courseId = $scope.courses[selectedCourse].id;
          var data = {module:module,id:courseId};
          $http.post('api/v1/cmodules/newModule', data).then(function(data) {
            if(data.data.success){
              alert('Module Successfully Added, Please go into Manage Videos to add videos to this module.');
              location.reload();
            }
            else{
              alert('There was an error adding module. Please try again');
            }
            $scope.loader = false;
          });
        };

        $scope.showModules = function(){
          $scope.listModules = true;
        };

        $scope.disableUser = function(user){
          if (confirm("Do you want to disable this user?") == true) {
            var data = {id:user.id};
            $http.post('api/v1/users/toggleUser', data).then(function(data) {
              if(data.data.success){
                alert('User Successfully Disabled');
                var index = $scope.users.indexOf(user);
                $scope.users[index].disabled = true;
              }
              else{
                alert('There was an error. Try again.');
              }
            });
          }
        };

        $scope.verifyUser = function(user){
          if (confirm("Do you want to marked verified this user phone number?") == true) {
            var data = {id:user.id};
            $http.post('/api/v1/user/verify-phone', data).then(function(data) {
              if(data.data.success){
                alert('User Successfully Verified');
                var index = $scope.users.indexOf(user);
                $scope.users[index].phone_confirmed_at = true;
              }
              else{
                alert('There was an error. Try again.');
              }
            });
          }
        };

        $scope.setBanned = function(user){
          if (confirm("Are you sure you want to mark this user as " + (user.is_banned ? "not banned" : "banned") + "?") == true) {
            var data = {
              id:user.id,
              is_banned:user.is_banned,
            };
            $http.post('/api/v1/user/change-banned-status', data).then(function(data) {
              if(data.data.success){
                var index = $scope.users.indexOf(user);
                $scope.users[index].is_banned = user.is_banned;
                alert(data.data.message);
              }
              else{
                alert(data.data.message);
              }
            });
          }
        };


        $scope.deleteModule = function(module,index){
          $scope.loader = true;
          if (confirm("Do you want to delete the module?") == true) {
            var data = {moduleId:module.id};
            $http.post('api/v1/cmodules/deleteModule', data).then(function(data) {
              if(data.data.success){
                alert('Module Successfully Deleted');
                $scope.modules.splice(index,1);
              }
              else{
                alert('There was an error deleting module. Try again');
              }
              $scope.loader = false;
            });

          } else {

          }
        };

        $scope.deleteCourse = function(course){
          $scope.loader = true;
          if (confirm("Do you want to delete the course?") == true) {
            var data = {id:course.id};
            $http.post('api/v1/courses/deleteCourse', data).then(function(data) {
              if(data.data.success){
                alert('Course Successfully Deleted');
                location.reload();
              }
              else{
                alert('There was an error deleting course. Try again');
              }
              $scope.loader = false;
            });
          } else {

          }

        };

        $scope.deleteVideo = function(video){
          $scope.loader = true;
          if(confirm("Do you want to delete this video") == true){
            var data = {id:video.id};
            $http.post('api/v1/cvideos/deleteVideo', data).then(function(data) {
              if(data.data.success){
                alert('Video Successfully Deleted');
                var index = $scope.videos.indexOf(video);
                $scope.videos.splice(index,1);
              }
              else{
                alert('There was an issue. Try again');
              }
              $scope.loader = false;
            });
          }
        };

        $scope.uploadNewVideos = function(files, event, flow, module){
          for(var i in $scope.modules){
            if($scope.modules[i].name == module){
              $scope.selModule = $scope.modules[i];
            }
          }
          $scope.selModule['moduleNo'] = $scope.selModule.module_no;
          $scope.module_map[$scope.selModule.moduleNo] = $scope.selModule;
          $scope.upload(files, event, flow, $scope.selModule);
        };


        $scope.showMenu();

        $scope.searchCouponById = function(coupon_id){
          $scope.hidePagination = true;
          $http({
            url: 'api/v1/coupons/showCoupons',
            method: "GET",
            params: {coupon_id: coupon_id,type: '5'}
          }).then(function(data){
            if(!data.data.success){
              swal({
                title: "Error",
                text: "Coupon does not exist",
                type: "error"
              },function(){
                $scope.coupons = 0;
              })
            }
            else{
              $scope.coupons = data.data.coupons;
            }
          })
        }

        $scope.downloadCouponsCsv = function(){

          $http({
            url: 'api/v1/coupons/getAllCoupons',
            method: "GET",
            params: {}
          }).then(function(data){
            $scope.coupon_data = data.data.coupons;
            var csv = 'Id,CouponId,Price,Created At,Status\n';
            $scope.coupon_data.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-Coupons.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          })
        }

        $scope.$watch('coupon_record_no', function() {
          if($scope.firstTimeCoupons==0){
            $scope.showCoupons(1,$scope.sortType);
          }
          else{
            $scope.firstTimeCoupons--;
          }
        },true)

        // $scope.$watch('module_record_no', function() {
        //   if($scope.firstTimeModules==0){
        //     $scope.showModuleTransactions(1,$scope.sortTypeModule);
        //   }
        //   else{
        //     $scope.firstTimeModules--;
        //   }
        // },true)

        // $scope.$watch('credit_record_no', function() {
        //   if($scope.firstTimeCredits==0){
        //     $scope.showCreditTransactions(1,$scope.sortTypeCredit);
        //   }
        //   else{
        //     $scope.firstTimeCredits--;
        //   }
        // },true)

        $scope.$watch('user_record_no', function() {
          if($scope.firstTimeUsers==0){
            $scope.showUsers(1);
          }
          else{
            $scope.firstTimeUsers--;
          }
        },true)

        $scope.downloadModuleTransactionsCSV = function(type){
          if(!type){
            var data = {forDownload:true,type:'1'};
          } else {
            var data = {forDownload:true,type:'7'};
          }
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: data
          }).then(function(data){
            $scope.transaction = data.data.transactions;
            for(var i in $scope.transaction) {
              $scope.transaction[i][5] = $scope.transaction[i][5].replace(',',' ');
              $scope.transaction[i][6] = $scope.transaction[i][6].replace(',',' ');
              if($scope.transaction[i][11]!=null) {
                if($scope.transaction[i][11].match(',')) {
                  $scope.transaction[i][11] = $scope.transaction[i][11].replace(',',' ');
                }
              }
            }
            var csv = 'full_name,city,OderId,Coupon Code,Email,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No,university,crn,phone\n';
            $scope.transaction.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          });
        }

        $scope.downloadCreditTransactionsCSV = function(){
          $http({
            url: 'api/v1/transactions/creditTransactions',
            method: "GET",
            params: {type: '5'}
          }).then(function(data){
            $scope.transaction = data.data.credit_transactions;
            var csv = 'TransactionId,Coupon Code,User,Amount,Purchased At\n';
            $scope.transaction.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-Credit Transactions.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          })

        }

        $scope.downloadUserCSV = function(){
          $http({
            url: 'api/v1/users/downloadUsersData',
            method: "GET",
            params: {}
          }).then(function(data){
            $scope.usersD = data.data.user_data;
            var csv = 'User Id,Full Name,Email,Phone No,Sign-up Date, Platform,University\n';
            $scope.usersD.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-User.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          })
        }

        $scope.searchModuleTransactionById = function(couponId){
          $scope.hidePagination = true;
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: {coupon_id: couponId,type:'3'}
          }).then(function(data){
            if(!data.data.success){
              swal({
                title: "Error",
                text: "Coupon does not exist",
                type: "error"
              },function(){
                $scope.module_transactions = 0;
              })
            }
            else{
              $scope.module_transactions = data.data.transactions;
            }
          })
        }

        $scope.searchCreditTransactionById = function(couponId){
          $scope.hidePagination = true;

          $http({
            url: 'api/v1/transactions/creditTransactions',
            method: "GET",
            params: {coupon_id: couponId,type:'3'}
          }).then(function(data){
            if(data.data.credit_transactions.length > 0 ){
              $scope.credit_transactions = data.data.credit_transactions;
            } else {
              swal('Error','No transactions found','error');
            }
          })
        }

        $scope.enableUser = function(user){
          if (confirm("Do you want to enable this user?") == true) {
            var data = {id:user.id};
            $http.post('api/v1/users/toggleUser', data).then(function(data) {
              if(data.data.success){
                alert('User Successfully Enabled');
                var index = $scope.users.indexOf(user);
                $scope.users[index].disabled = false;
              }
              else{
                alert('There was an error. Try again.');
              }
            });
          }
        }

        $scope.searchModuleTransactionByUser = function(uid){
          $scope.hidePagination = true;
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: {uid:uid,type:'4'}
          }).then(function(data){
            if(!data.data.success){
              swal({
                title: "Error",
                text: "No Transactions",
                type: "error"
              },function(){
                $scope.credit_transactions = 0;
              })
            }
            else{
              $scope.module_transactions = data.data.transactions;
              $scope.total_mt = data.data.total_count;
            }
          })

        }

        $scope.searchCreditTransactionByUser = function(uid){
          $scope.hidePagination = true;

          $http({
            url: 'api/v1/transactions/creditTransactions',
            method: "GET",
            params: {uid:uid,type:'4'}
          }).then(function(data){
            if(!data.data.success){
              alert(data.data.message);
            }
            if(data.data.credit_transactions.length > 0 ){
              $scope.credit_transactions = data.data.credit_transactions;
            } else {
              swal('Error','No transactions found','error');
            }
          })
        }

        $scope.searchModuleTransactionByCourse = function(course){
          $scope.hidePagination = true;
          var coursee = course.toLowerCase();
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: {course:coursee,type:'5'}
          }).then(function(data){
            if(!data.data.success){
              swal({
                title: "Error",
                text: "No Transactions",
                type: "error"
              },function(){
                $scope.module_transactions = 0;
              })
            }
            else{
              $scope.module_transactions = data.data.transactions;
              $scope.total_mt = data.data.total_count;
            }
          })
        }

        $scope.downloadModuleTransactionsUserCSV = function(uid){

          $scope.hidePagination = true;
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: {uid:uid,type:'4',forDownload:true}
          }).then(function(data){
            var transactions = data.data.transactions;
            var csv = 'OderId,Coupon Code,Purchased By,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No\n';
            transactions.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          })
        }

        $scope.downloadModuleTransactionsCourseCSV = function(course){

          $scope.hidePagination = true;
          var coursee = course.toLowerCase();
          $http({
            url: 'api/v1/transactions/courseTransactions',
            method: "GET",
            params: {course:coursee,type:'5',forDownload:true}
          }).then(function(data){
            var transactions = data.data.transactions;
            var csv = 'OderId,Coupon Code,Purchased By,CourseName,ModuleName,Price,Purchased At,Purchase Type,Jazz Ref No\n';
            transactions.forEach(function(row) {
              csv += row.join(',');
              csv += '\n';
            });
            var parent = document.getElementById('download_csv');
            var hiddenElement = document.createElement('a');
            parent.appendChild(hiddenElement);
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = new Date().toUTCString()+'-Module Transactions.csv';
            hiddenElement.click();
            parent.removeChild(hiddenElement);
          })
        }

        $scope.downloadCreditTransactionsUserCSV = function(uid){
          $scope.hidePagination = true;

          $http({
            url: 'api/v1/transactions/creditTransactions',
            method: "GET",
            params: {uid:uid, type:'4', forDownload:true}
          }).then(function(data){
            if(!data.data.success){
              swal({
                title: "Error",
                text: "No Transactions",
                type: "error"
              },function(){
              })
            }
            else{
              var transactions = data.data.credit_transactions;
              var csv = 'TransactionId,Coupon Code,User,Amount,Purchased At\n';
              transactions.forEach(function(row) {
                csv += row.join(',');
                csv += '\n';
              });
              var parent = document.getElementById('download_csv');
              var hiddenElement = document.createElement('a');
              parent.appendChild(hiddenElement);
              hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
              hiddenElement.target = '_blank';
              hiddenElement.download = new Date().toUTCString()+'-Credit Transactions.csv';
              hiddenElement.click();
              parent.removeChild(hiddenElement);
            }
          })

        }

        $scope.createInstructForm = function(){
          $scope.hideAll();
          $scope.createInstructorForm = true;
        }
        $scope.formisSubmitted = false;
        $scope.createInstructor = function(form){
          $scope.formisSubmitted = true;
          if(!form.name || !form.username || !form.password ){
            return;
          }
          if(form.password.length <8 ){
            alert('password needs to be 8 characters');
            return;
          }
          // Email validation
          var regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
           if (!regex.test(form.username)) {
            alert('Please enter a valid email address');
            return;
          }
          var data ={
            name: form.name,
            email: form.username,
            password: form.password,
            sendPass: form.password
          }
          $http({
            url: 'api/v1/instructors/createInstructor',
            method: "POST",
            params: data
          }).then(function(data){
            if(data.data.userExists){
              alert('email already in use');
            }
            else if(data.data.success){
              alert('instructor created Successfully');
              location.reload();
            }
          });
        }

        $scope.showInstructors = function(){
          $scope.hideAll();
          $scope.instructorList = true;
          $http({
            url: 'api/v1/instructors/getInstructors',
            method: "GET"
          }).then(function(data){
            $scope.instructors = data.data.instructor;
          })
        }

        $scope.showAddVideoQuality = function(){
          $scope.hideAll();
          $scope.responsePopup = true;
          $http({
            url: 'api/v1/videoQuality/getAllquality',
            method: 'GET'
          }).then(function(data){
            $scope.responsePopup = false;
            $scope.allquality = data.data.qualities;
            $scope.addNewQualityVideo = true;
          });
        }
        $scope.saveVideoQuality = function(saveQuality) {
          $http.post('api/v1/videoQuality/saveQuality',{quality:saveQuality})
          .then(function(data){
            if (data.data.success) {
              swal({
                title: "successful",
                text: "your quality has been added",
                type: "success"
              },function(){
                location.reload();
              });
            }
          });
        }


        $scope.showEnrolledStudents = function(){
          $scope.hideAll();
          $scope.responsePopup = true;
          $http({
            url: 'api/v1/courses/getAllCourses',
            method: 'GET',
            params: {type: 'admin'}
          }).then(function(data){
            $scope.responsePopup = false;
            $scope.allCourses = data.data.courses;
            $scope.enrolledStudentsTable = true;
          });
        }
        $scope.totalEnrolledPages = 1;
        $scope.getEnrolledStudents = function(page, course){
          var per_page_enrollment = 20;
          if(!$scope.totalEnrolled) {
            $scope.totalEnrolled = per_page_enrollment;
          }
          if (page > 0 && (page - 1) * per_page_enrollment < $scope.totalEnrolled) {
            $scope.enrollStudentpage = page;
            var courseId = $scope.allCourses[course].id
            $scope.currentCourse = $scope.allCourses[course]
            $http({
              url: 'api/v1/enrolledstudents/getEnrolledStudents',
              method:"GET",
              params:{course_id: courseId, page: page, per_page: per_page_enrollment}
            }).then(function(data){
              if(!data.data.success){
                alert(data.data.message);
                $scope.studentsExist = false;
              } else {
                $scope.enrolledStudents = data.data.students;
                $scope.totalEnrolled = data.data.total;
                $scope.totalEnrolledPages = Math.ceil($scope.totalEnrolled/per_page_enrollment)
                $scope.studentsExist = true;
              }
            })
          } else if (page < 1) {
            page = 1;
            $scope.responsePopup = false;
          } 
        };

        $scope.sendUpdateEmailNotification = function(text,user){
          if(!text){
            alert('Please enter text for email');
            return false;
          }
          var data ={
            course_id:$scope.currentCourse.id,
            course_name: $scope.currentCourse.name,
            index_url:$scope.currentCourse.index_url,
            text:text,
            users: user
          }
          $http.post('api/v1/instructors/sendUpdateNotification',data)
          .then(function(data){
            if(data.data.success){

            } else {
              alert('No users enrolled');
            }
          })
          alert('Emails are now in process');
        }

        $scope.showAllCourses = function(){
          $scope.hideAll();
          $http({
            url: "api/v1/courses/getAllCourses",
            method: "GET"
          }).then(function(data){
            $scope.allCourses = data.data.courses;
            $scope.showAllCoursePage = true;
          })
        }

        $scope.updateBalance = function(id,credit){
          var data = {id:id,credit:credit};
          $http.post('api/v1/users/updateBalance',data)
          .then(function(data){
            if(data.data.success){
              alert('Updated Balance Successfully');
            }
          })
        }

        $scope.editTransaction = function(trans){
          var data = {id:trans.id};
          $http.post('api/v1/transactions/toggleTransaction',data)
          .then(function(data){
            if(data.data.success){
              alert('Operation Successful');
              trans.disabled = !trans.disabled;
            }
          })
        }

        $scope.searchInstructors = function() {
          var searchQuery = $scope.searchTerm;
        
          // Call your API to search instructors by name or email
          $http.get('/api/v1/instructors/search', {
            params: { query: searchQuery }
          })
          .then(function(response) {
            $scope.instructors = response.data; // Update the list of instructors with search results
            if ($scope.instructors.length === 0) {
              alert('No matching records found.');
            }
          })
          .catch(function(error) {
            console.error('Error searching instructors:', error);
          });
        };
        
        
        $scope.updateInstructor = function(index){

          var data = $scope.instructors[index];
          $http.post('api/v1/instructors/updateInstructorShare',data)
          .then(function(data){
            if(data.data.success){
              alert('Successfully Updated');
            }
          })
        }
        //instructor name and email update
        $scope.formSubmitted = false;
        $scope.showPopup = false;
        $scope.selectedInstructor = {};
        var instr;
        $scope.showUpdatePopup = function(instructor) {
        instr = instructor;
        $scope.selectedInstructor = angular.copy(instructor);
          $scope.showPopup = true;
          $scope.imageLink=null;

        };
        $scope.uploadInstructorImage = function(file) {
          if (file) {
            if (file.size > 1000000) {
              return alert('Image size must be less than 1 MB');
            }
        
            $scope.isUploading = true; // Show mini loader
        
            // imageUploadInProgress
            Upload.upload({
              url: '/api/v1/uploader/uploadImageToS3',
              method: 'POST',
              file: file,
              params: { userId: CustomStorageService.getUserInfoStorageData().id },
            }).then(function(resp) {
              $scope.selectedInstructor.image = resp.data.link;
              $scope.isUploading = false; // Hide mini loader
              $scope.imageLink = resp.data.link; // Display image link
            }).catch(function(err) {
              console.log("Error in uploading Image", err);
              alert("Error in uploading Image");
              $scope.isUploading = false; // Hide mini loader on error
            });
          }
        }; 
          
        $scope.updateInstructorData = function(instructor) {

          $scope.formSubmitted = true;
          var regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}'); 
          if (!regex.test($scope.selectedInstructor.email)) {
            alert("Email is invalid")
            $scope.formSubmitted=false;
          return;
          }
          if (!$scope.selectedInstructor.full_name || !$scope.selectedInstructor.email){
            return;
          }  
          var updatedData = {
            full_name: $scope.selectedInstructor.full_name,
            email: $scope.selectedInstructor.email,
            image: $scope.selectedInstructor.image
          };
          instr.full_name = $scope.selectedInstructor.full_name;
          instr.email=$scope.selectedInstructor.email;
          instr.image=$scope.selectedInstructor.image;
          console.log(instructor)
          $http.put('api/v1/instructors/updateProfile/' + $scope.selectedInstructor.id, updatedData)
            .then(function(response) {
              if (response.data.success) {
                alert('Instructor updated successfully');
                 // Find the index of the selected instructor in the array using a loop
                var index = -1;
                // for (var i = 0; i < $scope.instructors.length; i++) {
                //     if ($scope.instructors[i].id === $scope.selectedInstructor.id) {
                //         index = i;
                //         break;
                //     }
                // }

            // If the instructor is found, update their data
            if (index !== -1) {
                $scope.instructors[index] = updatedData; // Update with the new data
            }
                
              }
            
              $scope.closePopup(); // Close the popup after updating
              $scope.clearSelectedImage(); 
            })
            .catch(function(error) {
              console.error('Error updating instructor:', error);
            });
            $scope.clearSelectedImage(); 
        };

        $scope.closePopup = function() {
          $scope.showPopup = false;
          $scope.clearSelectedImage();
        };

        $scope.clearSelectedImage = function() {
          $scope.selectedInstructor.image = null;
        };
        $scope.ShowEditBlogForm = function () {
          $scope.hideAll();
          $scope.showEditBlogForm = true;
          $http({
            url: '/api/v1/blog/getBlogs',
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
            $scope.blogs = res.data.blogs;
          });
        }
        $scope.ShowCreateBlogForm = function () {
          var editor_container = document.getElementById('editor-container');
          editor_container.innerHTML = '';
          $scope.hideAll();
          $scope.showCreateBlogForm = true;
          $http({
            url: '/api/v1/blog/category/get',
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
           $scope.initEditor(false, '');
            $scope.blogCategories = res.data.category;
          }).catch(function(eerr){
            console.log('error occured 1500 --=-==-=-=-=-=--=', eerr);
          });
        }
        // $scope.ShowCreateBundle = function () {
        //   $scope.hideAll();
        //   $scope.addNewBundle = true;
        //
        // }
        // $scope.ShowViewBundles = function () {
        //   $scope.hideAll();
        //   $http.post('/api/v1/bundle/find',{admin:true})
        //   .then(function(data){
        //     if(data.data.succes) {
        //       $scope.bundles = data.data.bundles;
        //       $scope.showBundle = true;
        //
        //     } else {
        //
        //     }
        //
        //   },function errorCallback(response) {
        //
        //   });
        //
        //
        // }

        // $scope.SaveBundle = function(bundle) {
        //
        //   $http.post('/api/v1/bundle/create',{bundle: bundle,admin:true})
        //   .then(function(data){
        //
        //     swal({
        //       title: "Success!",
        //       type: "info",
        //       confirmButtonText: "Ok"
        //     })
        //   },function errorCallback(response) {
        //
        //   });
        // }
        // $scope.addCourseToBundle = function(course) {
        //   $scope.bundle.price+=$scope.courses[course].price;
        //   $scope.bundle.courses.push($scope.courses[course]);
        //
        // }

        $scope.ShowBlogComments = function () {
          $scope.hideAll();
          $scope.showBlogComments = true;
          $http({
            url: '/api/v1/blog/comment/getAllComments',
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
            $scope.blogcomments = res.data;
          });
        }
        $scope.ShowBlogCategories = function () {
          $scope.hideAll();
          $scope.show_blog_categories = true;
          $http({
            url: '/api/v1/blog/category/get',
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
            $scope.blogCategories = res.data.category;
          });
        }
        $scope.ShowBlogCategoryForm = function () {
          $scope.category = {};
          $scope.hideAll();
          $scope.showCreateBlogCategoryForm = true;
        }
        $scope.EditBlogCategoryForm = function (id) {
          $scope.category = {};
          $scope.hideAll();
          $scope.showCreateBlogCategoryForm = true;
          $http({
            url: '/api/v1/blog/category/get/' + id,
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
            $scope.category = res.data.category;
          });
        }
        $scope.DeleteBlogCategoryForm = function (id, index) {
          $http({
            url: '/api/v1/blog/category/delete/' + id,
            method : 'DELETE',
            params : {admin: true}
          }).then ( function (res) {
            $scope.blogCategories.splice(index, 1)
            alert('Blog Category Deleted Successfully');
          });
        }
        $scope.blogapproveComment = function (id)
        {
          var data ={
            comment_id:id
          }
          $http.post('api/v1/blog/comment/blogapproveComment',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          });
        }
        $scope.blogapprovereply = function (id)
        {
          var data ={
            reply_id:id
          }
          $http.post('api/v1/blog/comment/reply/blogapprovereply',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.unhideBlogComment = function (id)
        {
          var data ={
            comment_id:id
          }
          $http.post('api/v1/blog/comment/showBlogComment',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.hideBlogComment = function (id)
        {
          var data ={
            comment_id:id
          }
          $http.post('api/v1/blog/comment/hideBlogComment',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.deleteBlogComment = function (id)
        {
          var data ={
            comment_id:id
          }
          $http.post('api/v1/blog/comment/deleteBlogComment',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.showBlogReply = function (id)
        {
          var data ={
            reply_id:id
          }
          $http.post('api/v1/blog/comment/reply/showBlogReply',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.hideBlogReply = function (id)
        {
          var data ={
            reply_id:id
          }
          $http.post('api/v1/blog/comment/reply/hideBlogReply',data)
          .then(function(data){
            swal({
              title: "Success!",
              type: "info",
              confirmButtonText: "Ok"
            });
          })
        }
        $scope.change = function(value)
        {
          $scope.selected=value;

          if(value==1) {
            $scope.AllComments=$scope.blogcomments.allComments;
          }
          else if(value==2)
          $scope.AllComments=$scope.blogcomments.approvedComments;
          else if(value==3)
          $scope.AllComments=$scope.blogcomments.pendingComments;
          else if(value==4)
          $scope.AllComments=$scope.blogcomments.hiddenComments;
        }
        $scope.changePublishStatusBlog = function (blog) {
          swal({
            title: "Are you sure you want to change blog status?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes !",
            closeOnConfirm: true},
            function(isConfirm){
              if(isConfirm) {
                $http({
                  url: '/api/v1/blog/update-status/'+blog.id,
                  method : 'PUT',
                  params : {admin: true}
                }).then ( function (res) {
                  setTimeout(function() {
                    swal({
                      title: "Success!",
                      type: "success",
                      confirmButtonText: "Ok"
                    });
                  }, 500)
                });
              } else {
                $timeout(function () {
                  blog.publish = !blog.publish
                }, 0);
              }
            }
          );
        }
        $scope.displayBlog = function (blog) {
          var editor_container = document.getElementById('editor-container');
          editor_container.innerHTML = '';
          // editor_container.innerHTML = '<div id="editor"></div>';
          // var editor_element = document.createElement('div');
          // editor_element
          $scope.showCreateBlogForm = true;
          $scope.showEditBlogForm = false;
          $scope.blog = blog;
          if(!$scope.blog.metatags){
            $scope.blog.metatags = [];
          }
          if(blog.author)
            $scope.blog.author_name = blog.author.name ? blog.author.name : blog.full_name;
          $http({
            url: '/api/v1/blog/category/get',
            method : 'GET',
            params : {admin: true}
          }).then ( function (res) {
            $scope.blogCategories = res.data.category;
            $scope.blog = blog;
            $scope.blog.category_id = $scope.blog.category_id.toString();

            // quill.setContents(delta, 'silent');
            $scope.initEditor(true, blog.content)

            // $scope.editor.clipboard.dangerouslyPasteHTML(blog.content);

            // editor.html.set(blog.content);

            // console.log(blog.content);
            // setTimeout(function(){
            //   editor.html.insert('');
            //   editor.html.set(blog.content);
            //   editor.clean.html('<p dummy="test">foo</p><p>bar</p>');
            // },5000)
          });
        }
        $scope.SaveBlog = function (blog) {
          blog.content = $scope.editor.root.innerHTML;
          if(!blog.blogUrl){
            delete blog.blogUrl;
          }
          if(blog.category_id === '0' || blog.category_id === '' || blog.category_id === null) alert('Please Select Blog Category');
          else if(blog.author_email === '' || !blog.author_email) alert('Please Enter Author Email');
          else if(blog.author_name === '' || !blog.author_name) alert('Please Enter Author Name');
          else if(blog.name === '' || !blog.name) alert('Please Enter Blog Name');
          else {
            if(blog){
              blog.blogUrl = blog.blogUrl ? blog.blogUrl : '';
              $http.post('/api/v1/blog/saveBlog',{blog:blog})
              .then(function(res){
                if(res.data.name){
                  alert(res.data.name);
                  location.reload();
                }
                else {
                  if(res.data.status === 'NOT_AUTHOR') {
                    var r = confirm("This user is not author. Do you want to make this user author?");
                    if (r == true) {
                      blog.updateUser = true;
                      $scope.SaveBlog(blog);
                    } else {
                      txt = "You pressed Cancel!";
                    }
                  } else {
                    alert(res.data.message)
                  }
                }
              });
            }
          }
        }
        $scope.SaveBlogCategory = function (category) {
          if(category){
            $http.post('/api/v1/blog/category/save',{category:category})
            .then(function(res){
              if(res.data.name){
                alert(res.data.name);
                $scope.ShowBlogCategories();
              }
            });
          }
        }
        $scope.initEditor = function(edit, content){
          var editor_container = document.getElementById('editor-container');
          editor_container.innerHTML = '';
          editor_container.innerHTML = '<div><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="insert-table">Insert Table</button> <div id="table-div"> <button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="insert-row-above">Insert Row Above</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="insert-row-below">Insert Row Below</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="insert-column-left">Insert Column Left</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="insert-column-right">Insert Column Right</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="delete-row">Delete Row</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="delete-column">Delete Column</button><button class="btn btn-primary btn-sm mr-2" style="margin-right:5px" id="delete-table">Delete Table</button></div> </div><div id="editor"></div>';
          var toolbarOptions = [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            
            [{ 'font': [] }],

            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
          
            // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript         // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
          
            // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            
          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            
            [{ 'align': [] }],
            
            ['link', 'image'],
            // [ 'link', 'image', 'video', 'formula' ],          // add's image support
            ['clean']                                         // remove formatting button
          ];
          $scope.editor = new Quill('#editor', {
            modules: {
              toolbar: {
                container: toolbarOptions,
                handlers: {
                  image: function() {
                    var range = this.quill.getSelection();
                    var q = this.quill
                    var input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.onchange = function (e) {
                      var file = e.target.files[0];
                      if (!file) {
                        return;
                      }
                      if (file.size > 1000000) {
                        return alert('Image size must be less then 1 mb');
                      }
                      Upload.upload({
                        url: '/api/v1/uploader/uploadImageToS3',
                        method: 'POST',
                        file: file,
                        params: { userId: CustomStorageService.getUserInfoStorageData().id },
                      }).then(function (resp) {
                        q.insertEmbed(
                          range.index,
                          'image',
                          resp.data.link,
                          Quill.sources.USER
                        );
                      });
                    };
                    input.click();
                  }
                  
                }
              },
              htmlEditButton: {},
              table: true,
              
            },
            theme: 'snow',
            
          });
          var editEle = document.querySelector('#editor')
          var tableControlls = document.getElementById("table-div");
          tableControlls.style.display = 'none';
          var table = $scope.editor.getModule("table");
          document.querySelector("#insert-table").addEventListener("click", function () {
            var tab = table.getTable();
            if(tab[tab.length-1] != -1){
              return alert("can't add table within a table");
            }
            var rows = Number(prompt('no of rows for table'));
            var columns = Number(prompt('no of columns for table'));
            if(!rows || !columns || isNaN(rows) || isNaN(columns)){
              return alert('please insert valid rows and columns');
            }
            table.insertTable(rows, columns);
          });
          editEle.addEventListener('click', function(){
            var tab = table.getTable();
            if(tab[tab.length-1] != -1){
                tableControlls.style.display = 'inline-block';
            }else{
              tableControlls.style.display = 'none';
            }
          });
          document
            .querySelector("#insert-row-above")
            .addEventListener("click", function () {
              table.insertRowAbove();
            });
          document
            .querySelector("#insert-row-below")
            .addEventListener("click", function () {
              table.insertRowBelow();
            });
          document
            .querySelector("#insert-column-left")
            .addEventListener("click", function () {
              table.insertColumnLeft();
            });
          document
            .querySelector("#insert-column-right")
            .addEventListener("click", function () {
              table.insertColumnRight();
            });
          document.querySelector("#delete-row").addEventListener("click", function () {
            table.deleteRow();
          });
          document.querySelector("#delete-column").addEventListener("click", function () {
            table.deleteColumn();
          });
          document.querySelector("#delete-table").addEventListener("click", function () {
            table.deleteTable();
          });
          if(edit){
            $scope.editor.clipboard.dangerouslyPasteHTML(content);
          }
        }
        $scope.terminateAccessForCourse = function(name){
          if(name){
            $http.post('api/v1/transactions/terminateAccess',{name:name})
            .then(function(data){
              if(data.data.success){
                alert('Operation successful');
              } else {
                alert('Encountered an issue, please try again later');
              }
            })
          }
        }
        $scope.deleteMetatag = function(index){
          $scope.blog.metatags.splice(index, 1);
        }
        $scope.addMetaTagToBlog = function () {
          if (!$scope.metatagContent || !$scope.metatagProperty) {
            return alert("please add valid metatag property and content");
          }
          $scope.blog.metatags.push({
            property: $scope.metatagProperty,
            content: $scope.metatagContent,
          });
          $scope.metatagContent = '';
          $scope.metatagProperty = '';
          return true;
        };
        if (!$scope.signedIn || !CustomStorageService.getUserInfoStorageData()) {
          $state.go('admin_signin',{},{reload:true});
        } else {
          $scope.initialize();
        }

      }]);
    })();

(function () {
  "use strict";
  angular
    .module("NearPeer")
    .controller("assignmentResultController", MainController);
  function MainController(
    $state,
    $scope,
    $http,
    toaster,
    Upload,
    CustomStorageService,
    AssignmentService
  ) {
    var campaign_id = $state.params.id;
    var user = CustomStorageService.getUserInfoStorageData();
    $scope.assignment = {};
    $scope.isUpload = false;
    $scope.uploadProgress = 0;
    $scope.uploadStatus;
    $scope.isLoading = false;
    $scope.isAssignmentResult = false;
    var getAssignment = function () {
      $scope.isLoading = true;
      AssignmentService.getAssignmentResult(campaign_id).then(function (res) {
        if (res && res.success) {
          var data = res.assignmentResult;
          if(data.result_page_data && data.result_page_data.pageImgLink) {
            $scope.assignmentResult = res.assignmentResult;
          } else {
            data.result_page_data.pageImgLink = "../../images/assignments/default_result.jpeg";
            $scope.assignmentResult = data
          }
          $scope.isAssignmentResult = true;
        }
        $scope.isLoading = false;
      });
    };
    if (user && user.id) {
      if (campaign_id === "assigned") {
        $scope.assignmentResult = {
          result_page_data: {
            page_title: "Your paper has been assigned to the instructor!",
            page_description: "Your instructor will start checking your paper very soon. Keep an eye on your notifications.",
            pageImgLink: "../../images/assignments/assigned_instructor.jpeg",
          },
        };
      } else if (campaign_id === "instructor_downloaded") {
        $scope.assignmentResult = {
          result_page_data: {
            page_title: "Your instructor has started checking your paper!",
            page_description: "You are one step closer to getting your paper checked. Your instructor is checking your paper right now. Let's wait for the next notification.",
            pageImgLink: "../../images/assignments/start_checking.jpeg",
          },
        };
      } else {
        getAssignment();
      }
    } else {
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit("showLoginPopup");
    }

    $scope.downloadClick = function (assignmentResult) {
      window.open(assignmentResult.checked_file, "_blank");
    };
  }
})();

(function () {
  "use strict";
  angular
    .module("NearPeer")
    .controller("assignmentNotificationController", MainController);
  function MainController(
    $state,
    $scope,
    $http,
    toaster,
    Upload,
    CustomStorageService,
    AssignmentService
  ) {
    var campaign_id = $state.params.id;
    
    $scope.assignment = {};
    $scope.isUpload = false;
    $scope.isLoading = false;
    $scope.uploadProgress = 0;
    $scope.fileName = ''
    $scope.uploadStatus;
    var getAssignment = function () {
      $scope.isLoading = true;
      AssignmentService.getAssignmentDetail(campaign_id).then(function (res) {
        if (res && res.success) {
          $scope.assignment = res.assignmentContent;
          if(!$scope.assignment.page_image) {
            $scope.assignment.page_image = '../../images//assignments/default_result.jpeg'
          }
        }
        $scope.isLoading = false;
      });
    };
    var user_id;
    var user = CustomStorageService.getUserInfoStorageData();
    if(user && user.id) {
      user_id = user.id;
      getAssignment();
    } else {
      $rootScope.beforJoinusPath = {current: $state.current, params: $state.params};
      $scope.$emit('showLoginPopup');
    }

    var updateStatus = function (data) {
      AssignmentService.updateAssignmentStatus(data).then(function (res) {
        if (res && res.success) {
          if (data.status === "download") {
            toaster.success({
              title: "Assignment Downloaded",
            });
          } else if (data.status === "submitted") {
            toaster.success({
              title: "Assignment Submitted",
            });
            $state.go('Landing');
          }
        }
      });
    };

    $scope.downloadClick = function (download) {
      updateStatus({
        status: "download",
        campaign_id: campaign_id,
        user_id: user_id,
      });
      window.open(download.link, "_blank");
    };

    $scope.submitAssignment = function () {
      updateStatus({
        status: "submitted",
        campaign_id: campaign_id,
        user_id: user_id,
        submitted_file: $scope.assignmentLink,
      });
    };

    $scope.uploadImage = function (file, type) {
      if (file) {
        if (file.size > 30071520) {
          return alert("file size must be less then 30 mb");
        }
        $scope.fileName = file.name;
        $scope.uploadStatus = "uploading";
        $scope.isUpload = true;
        Upload.upload({
          url: "/api/v1/uploader/uploadImageToS3",
          method: "POST",
          file: file,
          params: { userId: user_id },
        }).then(
          function (resp) {
            $scope.uploadProgress = 100;
            if (resp.data && resp.data.success) {
              toaster.success({
                title: "Assignment Uploaded Successfully",
              });
              $scope.uploadStatus = "uploaded";
              $scope.assignmentLink = resp.data.link;
            } else {
              $scope.uploadStatus = "upload_error";
            }
          },
          function (resp) {},
          function (evt) {
            var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
            if(progressPercentage > 80) {
              $scope.uploadProgress = 80;
            } else {
              $scope.uploadProgress = progressPercentage;
            }
          }
        );
      }
    };

    $scope.customClick = function (custom) {
      window.open(custom.link, "_blank");
    };
  }
})();

(function () {
  "use strict";

  angular.module("NearPeer").controller("landingController", MainController);

  function MainController(
    $scope,
    $rootScope,
    $http,
    $state,
    $location,
    CustomStorageService,
    $cookies,
    BreadcrumbService,
    $interval,
    env
  ) {
    $scope.stories = [];

    
    $scope.stats = {};
    
    document.title =
      "Nearpeer | One Stop Destination For Online Learning In Pakistan";
    $scope.initialize = (function () {
      console.log("on-landing");
      $http({
        url: "api/v1/landingPage/getAllData",
        method: "POST",
      }).then(function (data) {
        if (data) {
          $scope.totalStudent = data.data.totalStudent;

          $scope.categories = [{
              name: "CA",
              text: "Online CA Courses by the best faculty of Pakistan at one place.",
              courses: data.data.totalfaculty.ca,
              instructors: data.data.totalenroll.ca,
              color: "#18c978",
              image: "Group 7711.svg",
              destination: "CAStatic",
            },
            {
              name: "SBI Courses",
              text: 'For SBI students',
              courses: data.data.totalfaculty.sbi,
              instructors: data.data.totalenroll.sbi,
              color: "#EE8815",
              image: "Group 7709.svg",
              destination: "schools({institutionName: 'sbi'})"
              // destination :$rootScope.platform_reactApp ? "listing({institutionName: 'online-course',schoolName: 'O&A-Level'})" : "",
              // externalLink: $rootScope.platform_reactApp ? "" : "https://cambridge.nearpeer.org",
            },
            {
              name: "ISSB",
              text: "Prepare for Army, Navy, and Air Forces courses",
              courses: data.data.totalfaculty.issb,
              instructors: data.data.totalenroll.issb,
              color: "#9443af",
              image: "Group 7707.svg",
              destination: "schools({institutionName: 'ISSB'})",
            },
            {
              name: "MDCAT",
              text: "No need for academies anymore. All preparation material in your pocket!",
              courses: data.data.totalfaculty.mdcat,
              instructors: data.data.totalenroll.mdcat,
              color: "#ea3d49",
              image: "Group 7708.svg",
              destination: $rootScope.platform_reactApp || data.data.mdcatStatus ?
                "schools({institutionName: 'entry-test-preparation'})" : "MDCAT",
            },
            {
              name: "Entry Tests",
              text: "Prepare for LUMS, NUST, LSE, GIKI and other Entry Tests online.",
              courses: data.data.totalfaculty.uet,
              instructors: data.data.totalenroll.uet,
              color: "#3585d8 ",
              image: "Group 7713.svg",
              destination: "schools({institutionName: 'entry-test'})",
              // destination: "SAT"
            },
            {
              name: "CSS & PMS",
              text: "Best online courses for CSS & PMS preparation",
              courses: data.data.totalfaculty.CSS,
              instructors: data.data.totalenroll.CSS,
              color: "#e8b23e",
              image: "Group 7714.svg",
              destination: $rootScope.platform_reactApp ? "schools({institutionName: 'css'})" : data.data.cssStatus ?
                "schools({institutionName: 'css'})" : "CSS",
            },
            {
              name: "FSc & Matric",
              text: "Best online courses for FSc preparation.",
              courses: data.data.totalfaculty.FSC,
              instructors: data.data.totalenroll.FSC,
              color: "#4FDDDD",
              image: "Group 7706.svg",
              destination: "", 
              externalLink: $rootScope.platform_reactApp ? "https://fsc.nearpeer.org" : "https://fsc.nearpeer.org",
            },
            {
              name: "O'Level & A'Level",
              text: "Study from the best and Ensure A* in your CAIEs.",
              courses: data.data.totalfaculty.o_a_level,
              instructors: data.data.totalenroll.o_a_level,
              color: "#EE8815",
              image: "Group 7709.svg",
              destination: $rootScope.platform_reactApp ? "listing({institutionName: 'online-course',schoolName: 'O&A-Level'})" : "",
              externalLink: $rootScope.platform_reactApp ? "" : "https://cambridge.nearpeer.org",
            },
            {
              name: "IELTS",
              text: "Get you desired scores by studying online",
              courses: "1",
              instructors: data.data.totalenroll.english,
              color: "#EE8815",
              image: "Group 7709.svg",
              destination: "Course({institutionName: 'english', schoolName: 'online-courses', courseName: 'ielts-by-rabea-babar'})"
              // destination :$rootScope.platform_reactApp ? "listing({institutionName: 'online-course',schoolName: 'O&A-Level'})" : "",
              // externalLink: $rootScope.platform_reactApp ? "" : "https://cambridge.nearpeer.org",
            },
            // {
            //   name: "ACCA",
            //   text: "Online ACCA courses by the best faculty.",
            //   courses: data.data.totalfaculty.ACCA,
            //   instructors: data.data.totalenroll.ACCA,
            //   color: "#dc4f9b",
            //   image: "Group 7710.svg",
            //   destination: "listing({institutionName: 'acca', schoolName:'acca-online'})",
            // },
            {
              name: "Polling Agents",
              text: "Courses around Elections",
              courses: "1",
              instructors: '20',
              color: "#dc4f9b",
              image: "Group 7710.svg",
              destination: "Course({institutionName: 'sujag-academy', schoolName: 'online-courses', courseName: 'polling-agents-training-course'})"
            },
          ];
          if (CustomStorageService.getUserInfoStorageData()) {
            if (
              !CustomStorageService.getUserInfoStorageData().phone &&
              !CustomStorageService.getPhoneStorageData()
            ) {
              $scope.$emit("getUserInformation", 1);
              CustomStorageService.setPhoneStorageData(true);
            }
          }

        }
       
      });
    })();
    $scope.showPopup = false;
    $scope.pitbSelected = false;
    $scope.fbSelected = false;
    $scope.loggedIn = false;
    $scope.storyPopup = false; 
    
      
      

      $scope.getUserStats = function () {
        $http({
          url: env.backendService + '/lmsservice/v1/user/get-user-stats',
          method: "GET",
        }).then(function (response) {
          if(response && response.data && response.data.stats) {
            $scope.stats = response.data.stats;
          }
        })
      };
      $scope.getUserStats();

      $scope.getUserWatchedTime = function () {
        if($scope.userInfo) {
          $http({
            url: env.backendService + '/trackingservice/v1/tracking/get-user-watched-time/' + $scope.userInfo.id,
            method: "GET",
          }).then(function (response) {
            if(response && response.data && response.data.watchedTime) {
              $scope.watch = response.data.watchedTime;
            }
          })
        }
      };
      $scope.getUserWatchedTime();
      
    $scope.numLimit = 50;
    if (
      CustomStorageService.getUserSignedInStorageData()
    ) {
      $scope.loggedIn = true;
      setTimeout(function(){
        mixpanel.reset();
        mixpanel.register({
          'User_Name': $scope.userInfo.name ? $scope.userInfo.name : null,
          'User_ID': $scope.userInfo.id ? $scope.userInfo.id : null,
          'User_City': $scope.userInfo.city ? $scope.userInfo.city : null,
          'User_Email': $scope.userInfo.email ? $scope.userInfo.email : null,
          'User_Mobile': $scope.userInfo.uid_phone ? $scope.userInfo.uid_phone : null,
          "Order_Paid": $scope.stats && $scope.stats.paid > 0 ? "YES" : "NO",
          'Order_Outdated': $scope.stats["out dated"] > 0 ? "YES" : "NO",
          'Order_Amount_Total': $scope.stats && $scope.stats.total_amount ? $scope.stats.total_amount : 0,
          'Promo_Paid': $scope.stats && $scope.stats.coupon_active > 0 ? "YES" : "NO",
          'Promo_Outdated': $scope.stats && $scope.stats.coupon_outdated > 0 ? "YES" : "NO",
          'Watch_Cumulative': $scope.watch ? parseInt($scope.watch) : 0
        });
        mixpanel.track('Nearpeer-Home');
      }, 5000);
      
      
    }
    var firstVisit = CustomStorageService.getAppFreeAccessPopup();
    if (firstVisit === 0 || firstVisit) {
      $scope.showReactAppPopup = true;
    } else {
      $scope.showReactAppPopup = false;

    }


    $scope.categoryChange = function (category) {
      console.log(category, "CATEGORY");

      // mixpanel.track('Niche-page', {
      //   'Niche_Name' : category.name,
      //   'Niche_ID' : category.id,
      //   'Institutions' : category.name
      // });
    
      if (category.externalLink) {
        if (category.name === "FSc" || category.name === "FSc & Matric") {
          $scope.showPopup = true;
          mixpanel.track('FSC-Board-Selection-Page');
          
        } else {
          location.href = category.externalLink;

        }
      }
      fbq("track", "ViewCategory", {
        content_category: category.name,
      });
    };
    $scope.closeFsc = function () {
      $scope.showPopup = false;
    }

    $scope.openFreeCourses = function () {
      $location.path('/courses').search({ free: 'true' })
    }
    $scope.openLoginForm = function () {
      $scope.$emit('showLoginPopup');

    }
    $scope.selectBoard = function (board) {
      if (board === "pitb") {
        $scope.pitbSelected = true;
        $scope.fbSelected = false;
        document.getElementById("pitb-colored").style.display = "none";
        document.getElementById("pitb-white").style.display = "flex";
        document.getElementById("pitb-box").style.background = "#16b9d6 ";
        document.getElementById("pitb-label").style.color = "#fff";
        document.getElementById("pitb-label2").style.color = "#fff";
        document.getElementById("fsc-colored").style.display = "initial";
        document.getElementById("fsc-white").style.display = "none";
        document.getElementById("fb-box").style.background = "#FFF ";
        document.getElementById("fb-label").style.color = "#575757";
        document.getElementById("fb-label2").style.color = "#575757";
        $state.go('schools', {
          institutionName: 'punjab-board'
        });
      } else if (board === "fed") {
        $scope.pitbSelected = false;
        $scope.fbSelected = true;

        document.getElementById("fsc-colored").style.display = "none";
        document.getElementById("fsc-white").style.display = "flex";
        document.getElementById("fb-box").style.background = "#16b9d6 ";
        document.getElementById("fb-label").style.color = "#fff";
        document.getElementById("fb-label2").style.color = "#fff";
        document.getElementById("pitb-colored").style.display = "initial";
        document.getElementById("pitb-white").style.display = "none";
        document.getElementById("pitb-box").style.background = "#FFF";
        document.getElementById("pitb-label").style.color = "#575757";
        document.getElementById("pitb-label2").style.color = "#575757";
        $state.go('schools', {
          institutionName: 'federal-board'
        });
      } else {
        document.getElementById("fsc-colored").style.display = "initial";
        document.getElementById("fsc-white").style.display = "none";
        document.getElementById("fb-box").style.background = "#FFF ";
        document.getElementById("fb-label").style.color = "#575757";
        document.getElementById("fb-label2").style.color = "#575757";
        document.getElementById("pitb-colored").style.display = "initial";
        document.getElementById("pitb-white").style.display = "none";
        document.getElementById("pitb-box").style.background = "#FFF";
        document.getElementById("pitb-label").style.color = "#575757";
        document.getElementById("pitb-label2").style.color = "#575757";
      }
    }
    $scope.token = CustomStorageService.getAuthTokenStorageData();
    $scope.userInfo = CustomStorageService.getUserInfoStorageData();
    $scope.changeColor = function (color, index) {
      $("#landingLi" + index).css({
        color: "white",
        transition: "all 0.5s",
        "transition-timing-function": "cubic-bezier(0.42,0,0.58,1)",
        border: "none",
        "border-radius": "5px",
      });
      $("#spot" + index).css({
        "background-color": color
      });
      for (var i = 0; i < 8; i++) {
        if (i != index) {
          var str = "#landingLi" + i;
          $(str).css({
            "background-color": "#f2f2f2",
            transition: "all 0.5s ease-in-out",
          });
        }
      }
    };

    $scope.revertColor = function () {
      $(".site-header").css("background-color", "#16b9d6");
      $(".landing-new").css("background-color", "#16b9d6");
      for (var i = 0; i < 8; i++) {
        var str = "#landingLi" + i;
        $(str).css({
          "background-color": "white",
          transition: "all 0.3s ease-in-out",
        });
      }
    };

    $scope.$on("$stateChangeStart", function (event) {
      $(".site-header").css("background-color", "#16b9d6");
    });

    $scope.openStoryPopup = function (id, index, media_id) {
      // console.log("🚀 ~ file: landing.js:341 ~ media_id:", media_id)
      // mixpanel.track('Story-page', {
      //   'Story_ID' : id,
      //   'Story_Title' : media_id,
      // });
    
      $state.go("storeel",{story_id:id,stories:$scope.stories,dynamic_url:$scope.dynamic_url});
    }


    var CircleStatusView = function (stories) {

      var data;
      data = localStorage.getItem("userInfo");
      var user_id = JSON.parse(data);

      stories.forEach(function (story,index) {
        var data=[];
        var viewed = 0;
        var notViewed=0;
        var total=story.slides.length;
        var angle = (1 / total) * 360;
        var percentage = (1 / total) * 100;
        var circleCircumference = 2 * Math.PI * 36;
        var strokeDashoffset = circleCircumference - (circleCircumference * percentage) / 100;
        var sliceSpacing = total === 1 ? 0 : 5;

        
        story.slides.forEach(function (slide,index){
          if(slide.is_viewed==true)
          {
          data.push({color: user_id.id?'#ffbdca':'#F34A00',rotation:angle * index,circleCircumference:circleCircumference,strokeDashoffset:strokeDashoffset+sliceSpacing,radius:36});
           viewed++
          }
          else
          {
           data.push({ color: '#F34A00', rotation:angle * index, circleCircumference: circleCircumference, strokeDashoffset: strokeDashoffset+sliceSpacing,radius:36});
           notViewed++
          }
       })
       story["storyStatusData"] = data;
       


       })

       return stories;
      
    }
    var getStoriesUsers = function (user_id) {
      var data;
      data = localStorage.getItem("userInfo");
      var user_id = JSON.parse(data);

      var browserId = $cookies.get('browserId');
      $http({
        url: 'api/v1/story/getStoriesForUser',
        method: "GET",
        params: { user_id: user_id.id,browser_id:browserId }
        // params: { per_page: 10, offset: 1 }
      }).then(function (response) {
        
        $scope.stories = CircleStatusView(response.data.response);

        $scope.dynamic_url = response.data.url;
        if (window.location.href.includes('storyid')) {
          var path = window.location.href
          $scope.story_id = path.substring(path.lastIndexOf('=') + 1);
          $scope.stories.forEach(function (element, index) {
            if (element.id == $scope.story_id) {
              $scope.activeStory = index;
              $scope.storyPopup = true;
              $scope.slideInterval = $interval(slideIntervalFunction, 5000);
              document.body.classList.add('remove-story-scroll');
            }
          });
        }
      });
    }
    getStoriesUsers();

  }
})();
(function() {
  'use strict';

  angular
  .module('NearPeer')
  .controller('HomeController', MainController);

  function MainController(courseDetailService,$rootScope,$scope, $http, $base64, $timeout, CustomStorageService, $state,$sails) {
    document.title = "Nearpeer - Discover An Online Course And Start Learning Everyday";
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
    var counter = 0;
    $scope.selectedCourse = {
      name :"Select Course"
    };

    $scope.initialize = function() {
      $scope.selectedSchool = "Select School";
      $scope.selectedCourse.name = "Select Course";
      $scope.selectedInstitution = "Select Institution";
      $scope.dataEntered = true;
      $scope.selectSchool = false;
      $scope.selectCourse = false;
      $scope.selectInst = false;
      if (!CustomStorageService.getAuthTokenStorageData()) {
        CustomStorageService.setSignedInStorageData(false);
      }
      $http.get('api/v1/courses/getUniversityList').then(function (data) {
        $scope.institutions = data.data;
        $scope.selectInst = true;
      });

      $http({
        url: 'api/v1/courses/getTopRatedUniversityCourses',
        method: "GET"
      }).then(function (data) {
        $scope.topCourses = data.data;
      });
    };

    $scope.updateInstitution = function(institute) {
      
      
      $scope.selectedInstitution = $scope.institutions[institute].institution;
      $scope.selectedSchool = "Select School";
      $scope.selectedCourse.name = "Select Course";
      $scope.selectSchool = true;
      $scope.selected_faculty = $scope.institutions[institute].faculties;
      $scope.dataEntered = false;
    };

    $scope.updateSchool = function(index) {
    
      
      $scope.selectedSchool = $scope.selected_faculty[index].faculty;
      $scope.selectedCourse.name = "Select Course";
      $scope.getCourses();
    };

    $scope.updateCourse = function(course) {  
      
      $scope.selectedCourse  = course;
    }

    $scope.getCourses = function() {
      $scope.selectCourse = false;
      $http({
        url: 'api/v1/courses/getCoursesByInstitutionAndFaculty',
        method: "GET",
        params: {institution: $scope.selectedInstitution, faculty: $scope.selectedSchool}
      }).then(function(data) {
   
        $scope.courses = data.data.courses;
        $scope.selectCourse = true;
      });
    };

    $scope.initialize();

    $scope.submit = function(){
      if($scope.selectedSchool == "Select School"){
        var institution = $scope.selectedInstitution.toLowerCase();
        institution.trim();
        institution = institution.split(' ').join('-');
        $state.go('schools',{institutionName: institution},{reload:true});
      }
      else if($scope.selectedCourse.name == "Select Course"){
        var institution = $scope.selectedInstitution.toLowerCase();
        institution = institution.trim();
        institution = institution.split(' ').join('-');
        var school = $scope.selectedSchool.toLowerCase();
        school = school.split(' ').join('-');
        $state.go('listing',{institutionName:institution,schoolName:school},{reload:true});
      }
      else{
        var urlParams = $scope.selectedCourse.index_url.split('/');
        $state.go('Course',{institutionName:urlParams[0],schoolName:urlParams[1],courseName:urlParams[2]},{reload:true});
      }
    };

    $scope.goToVideo = function(video){
      // courseDetailService.goToVideo(video);
    }

    $scope.allCourses = function(featuredCourse) {
      $state.go('AllCourses',{},{reload:true});
    }

    $scope.$watch('selectedInstitution', function() {
      if($scope.selectedInstitution == "Select Institution"){
        $scope.selectSchool = false;
        $scope.selectCourse = false;
      }
      $scope.selectedFaculty = "Select School";
    }, true);

    $scope.$watch('selectedSchool', function() {
      if($scope.selectedFaculty == "Select School"){
        $scope.selectCourse = false;
      }
    }, true);

    var searchStr = document.getElementById('searchStr');
    searchStr.addEventListener("keyup",handleKeyboard, false);
    searchStr.addEventListener("focus", showSearchOpen,false);

    function handleKeyboard(event){
      if(searchStr.value.length == 0){
        $scope.searchOpen = false;
        return;
      }
      if (counter == 0){
        $scope.searchLoader = true;
      }
      counter ++;
      $http({
        url: 'api/v1/courses/searchUniversityCourses',
        method: "GET",
        params: {name:searchStr.value}
      }).then(function(data){
        counter --;
        if(counter == 0){
          $scope.searchLoader = false;
        }
        if(data.data.courses.length == 0 && data.data.videos.length == 0){
          $scope.noResult = true;
        }
        if(data.data.courses.length > 0 || data.data.videos.length > 0){
          $scope.noResult = false;
        }
        var element = document.getElementById('ca-search-button');
        element.classList.add("ca-search-button");
        var element2 = document.getElementById('searchStr');
        element2.classList.add("ca-input-form");
        $scope.searchOpen = true;
        $scope.searchCourseResults = data.data.courses;
        $scope.searchVideoResults = data.data.videos;
      });
    }

    function showSearchOpen(){
      if(searchStr.value.length == 0){
        return;
      }
      var element = document.getElementById('ca-search-button');
      element.classList.add("ca-search-button");
      var element2 = document.getElementById('searchStr');
      element2.classList.add("ca-input-form");
      $scope.searchOpen = true;
      if (!$scope.$$phase) $scope.$apply();
    }

    $scope.hideSearchOpen = function($event){
      setTimeout(function(){
        $scope.searchOpen = false;
        if (!$scope.$$phase) $scope.$apply();
        var element = document.getElementById('ca-search-button');
        element.classList.remove("ca-search-button");
        var element2 = document.getElementById('searchStr');
        element2.classList.remove("ca-input-form");
      }, 200);
    }

    $scope.showSearch = function(){
      $scope.searchBar = true;
    }

    $scope.showQueryBuilder = function(){
      $scope.searchBar = false;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('NearPeer')
    .controller('faqsVideoController', ['$scope', '$rootScope', 'HttpService', '$state', '$sce', 'CustomStorageService', function ($scope, $rootScope, HttpService, $state, $sce, CustomStorageService) {

      var sr = $scope; 
      var instName;
      var instVideo;
      var check = false; 

      if ((!CustomStorageService.getUserSignedInStorageData() && CustomStorageService.getFirstVisitStorageData())) {
        CustomStorageService.setFirstVisitStorageData(false);
        HttpService.getRequest("api/v1/institute/getOne", { inst: sr.institution.name })
          .then(function (response) {
            instName = response.insti.name;
            instVideo = response.insti.videoUrl;
            $scope.institution = response.insti;
            if (instName && instVideo) {
              $("#yt-player").html('<iframe width="100%" height="315" src="https://www.youtube.com/embed/' + instVideo + '  " frameborder="0"  allowfullscreen></iframe>');
              $('#faqsVideo').modal('show');
            }


          })
      };

      sr.showModal = function () {
        HttpService.getRequest("api/v1/institute/getOne", { inst: sr.institution.name })
          .then(function (response) {
            instName = response.insti.name;
            instVideo = response.insti.videoUrl;
            if (instName && instVideo) {
              $("#yt-player").html('<iframe width="100%" height="315" src="https://www.youtube.com/embed/' + instVideo + '  " frameborder="0" allowfullscreen></iframe>');
              $('#faqsVideo').modal('show');
            }
            else { 
              $state.go('faqs', { instName: sr.institution.name });
            } 
           
          }); 
      }

      sr.learnMore = function (params) {
        check = true; 
        $('#faqsVideo').modal('toggle');
        $state.go('faqs', { instName: sr.institution.name });

      }

      $("#faqsVideo").on('hidden.bs.modal', function (e) {
        $("#faqsVideo iframe").attr("src", $("#faqsVideo iframe").attr("src"));
      });

      $scope.$on('$stateChangeStart', function (event) {
        if ($('#faqsVideo').is(':visible') && !check) {
          event.preventDefault(); 
          $('#faqsVideo').modal('toggle');
        }
      });

    }]);

})();

(function () {
  'use strict';

  angular
    .module('NearPeer')
    .controller('CPController', ['$scope', '$sce', 'HttpService', 'Upload', '$timeout', '$state', '$http', '$rootScope', 'courseDetailService', 'caCourseServices', 'BreadcrumbService',  function ($scope, $sce, HttpService, Upload, $timeout, $state, $http, $rootScope, courseDetailService, caCourseServices, BreadcrumbService) {
      document.title = "Nearpeer | Online CA Courses - Register Today ";
      $(document).ready(function () {
        $(this).scrollTop(0);
      });
      var counter = 0;
      var institution;
      var sr = $scope;
      $scope.paused = true;
      $scope.played = false;
      $scope.institution = {};
      sr.showbutton = {show:true}; 
      sr.institution = {name:"CA"};

      function onloadFunction(data,level) {
        BreadcrumbService.setBreadCrumb(data,level);
         setTimeout(function(){
          mixpanel.track('Niche-page', {
          'Niche_Name' : sr.institution.name,
          'Institutions' : sr.institution.name,
        });
        },5000)
      }

      $scope.showEP = function () {
        $state.go('paymentOptions', {}, { reload: true })
      }

      $scope.showPricePlans = function () {
        $scope.popup = true;
      }

      $scope.close = function () {
        $scope.popup = false;
        $scope.popup2 = false;
        $scope.advancePayment = false;
      }
      $scope.getSearchCourses = function (searchCourse) {
        $scope.courses = [];
        $scope.currentState = $scope.tags[searchCourse].course_tag;
        caCourseServices.GetSearchCACourses($scope.currentState)
          .then(function (data) {
            $scope.courses = data;
          });
      }
      $scope.getSearchCoursesType = function (type) {
        $scope.courseType = type;
        caCourseServices.GetSearchCACoursesType($scope.currentState, type)
          .then(function (data) {
            $scope.courses = data;
          });
      }
      $scope.getSorting = function (searchCourse, name) {
        $scope.sortingName = name;
        $scope.sortingOrder = searchCourse;
        $scope.$broadcast('caFilter', searchCourse);
      }
      $scope.getAllCourses = function () {
        $scope.currentState = "All";
        caCourseServices.GetAllCACourses()
          .then(function (data) {
            $scope.courses = data;
          });
      }

      $scope.initialize = function () {
        $http({
          url: 'api/v1/courses/getAllCoursesTags',
          method: "GET"
        }).then(function (data) { 
          $scope.tags = data.data.tags;
        });
        $scope.getAllCourses(); 
        var url=window.location.href;
        onloadFunction(
          {'url': url,
            'displayName':'CA', 
          },'LEAF'
        );
      }

      $scope.initialize();

      $scope.goToCourse = function (course) {
        courseDetailService.goToCourse(course);
      }

      $scope.goToVideo = function (video) {
        // courseDetailService.goToVideo(video);
      }

      // var searchStr = document.getElementById('searchStr');
      // searchStr.addEventListener("keyup",handleKeyboard, false);
      // searchStr.addEventListener("focus", showSearchOpen,false);

      function handleKeyboard(event) {
        if (((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 105) || event.keyCode == 8) || ($scope.mobileView)) {
          if (searchStr.value.length == 0) {
            $scope.searchOpen = false;
            return;
          }
          if (counter == 0) {
            $scope.searchLoader = true;
          }
          counter++;
          $http({
            url: 'api/v1/courses/searchCACourses',
            method: "GET",
            params: { name: searchStr.value }
          }).then(function (data) {
            counter--;
            if (counter == 0) {
              $scope.searchLoader = false;
            }
            if (data.data.courses.length == 0 && data.data.videos.length == 0) {
              $scope.noResult = true;
            }
            if (data.data.courses.length > 0 || data.data.videos.length > 0) {
              $scope.noResult = false;
            }
            var element = document.getElementById('ca-search-button');
            element.classList.add("ca-search-button");
            var element2 = document.getElementById('searchStr');
            element2.classList.add("ca-input-form");
            $scope.searchOpen = true;
            $scope.searchCourseResults = data.data.courses;
            $scope.searchVideoResults = data.data.videos;
          });
        }
      }

      function showSearchOpen() {
        if (searchStr.value.length == 0) {
          return;
        }
        var element = document.getElementById('ca-search-button');
        element.classList.add("ca-search-button");
        var element2 = document.getElementById('searchStr');
        element2.classList.add("ca-input-form");
        $scope.searchOpen = true;
        if (!$scope.$$phase) $scope.$apply();
      }

      $scope.hideSearchOpen = function ($event) {
        setTimeout(function () {
          $scope.searchOpen = false;
          if (!$scope.$$phase) $scope.$apply();
          var element = document.getElementById('ca-search-button');
          element.classList.remove("ca-search-button");
          var element2 = document.getElementById('searchStr');
          element2.classList.remove("ca-input-form");
        }, 200);
      }

      
      $scope.instructors = [
        { picture: 'images/ca-inst/Atif Abidi.jpg', experience: '15 Years', name: 'Sir Atif Abidi', qualification: 'ACA',
         description: 'A phenomenal Individual known for his compassionate and benevolent attitude toward students. He is serving as a faculty member of A Leading Institute providing CA Education in Lahore. He has more than a decade worth of Teaching experience in the areas of Corporate Laws, Auditing & Assurance and Business Management. He is author of more than 10 books, study texts and pocket notes of his subjects. His dedication and deliberation is inscribed in his publication. He is also Chief Executive of CA Notes (Private) Limited which has been a dedicated platform for CA students for almost 12 Years. He is running www.canotes.net and help providing online education at www.nearpeer.org through that Platform.' },

        { picture: 'images/ca-inst/Khalid Memood.jpg', experience: '18 Years', name: 'Sir  Khalid Mehmood', qualification: 'FCA', description: 'Sir Khalid Mehmood has 18 Years of professional experience in teaching at various institutes and so caught our attention. He is someone with hands-on experience in developing curricula to make sure the students learn comprehensively without getting overburdened. Nearpeer offers its complete course of CFAP 01 AAFR entirely instructed by Sir Khalid Mehmood himself. ' },

        { picture: 'images/ca-inst/Irfan Qadir.jpg', experience: '37 Years', name: 'Sir Irfan Qadir', qualification: 'MS Strategic financial managment USA,M.COM Finance', description: 'As one of the most senior lecturers in Pakistan, Sir Irfan Qadir has won the hearts of thousands of students. He has completed his MS in Strategic Financial Management from USA and M.Com in Finance and now has a huge experience of 37 years in the field. Nearpeer is proud to have a teacher like him and shares his quality knowledge through the amazing course of CFAP 03 SPM. ' },

        { picture: 'images/ca-inst/Ashraf Rehman.jpg', experience: '25 Years', name: 'Sir Muhammad Ashraf Rehman', qualification: 'PhD Scholar,M.Phil-IT,MBA,BCS', description: 'Sir Ashraf Rehman is a senior CA instructor at Nearpeer with a huge experience of more than 24 years. Not only has he done his BCS and MBA but he has also completed his M.Phil-IT and is now a Ph.D. scholar. His startling teaching skills and qualifications are the reason why we couldn’t resist having an instructor like him on board for our respectable CA students.' },

   
        { picture: 'images/ca-inst/Abdul Azeem.jpg', experience: '15 Years', name: 'Sir Abdul Azeem', qualification: 'PhD Scholar,ACCA,CMA(USA), M.COM,MS/M.PHIL MS-COMMERCE,DIP(Financial Management), DIP(Corporate Finance)', description: 'Sir Abdul Azeem is presently engaged with a leading educational Institution as a full time faculty member. He is energetic and enthusiastic individual having specialization in the subject of Cost & Management Accounting, Financial Management, Corporate Finance, Financial statement analysis and Performance Management.' },

        { picture: 'images/ca-inst/Mirza Munawar.jpg', experience: '30 Years', name: 'Sir Mirza Munawar', qualification: 'MA, MBA, LLB, FCIS, FPFA, FCMA', description: 'One of the most senior instructor in CA. He has 30-years experience of working including 11-Years in the industry at different managerial levels and CFO in a listed company. After that, he practices as Co in Munawar&Mirza Co. firm. He is the author of 11 books related to Tax and Corporate Law. One of his book "Synopsis of taxes in Pakistan" have 40-editions and Introduction to tax have 22-edition (CAF level).' },

        { picture: 'images/ca-inst/Malik Mumtaz.jpg', experience: '22 Years', name: 'Sir Malik Mumtaz', qualification: 'MA-Economics', description: 'Sir Malik Mumtaz is known for his passionate style of teaching and during the past 22 years of his teaching experience, he has won many students’ hearts. He has completed his Masters in Economics and his passion and knowledge in the subject are what we want the students to learn from him. Sir Malik Mumtaz teaches the course Principles of Economics and Principles of Business.' },

        { picture: 'images/ca-inst/Zubair Saleem.jpg', experience: '15 Years', name: 'Sir Zubair Saleem', qualification: 'FCCA', description: 'Nearpeer is proud to have Sir Zubair Saleem as the instructor of CAF 05 Financial Accounting and Reporting who is a Fellow Member of the Association of Chat Certified Accountants (FCCA) with an incredible 15 years of experience in the professional field. He is one of the finest stars of Nearpeer in the CA wing and is considered to be an elite mentor of CAF. ' },

        { picture: 'images/ca-inst/Imran Thakur.jpg', experience: '9 Years', name: 'Sir Imran Thakur', qualification: 'ACMA, M.PHIL (Finance), PhD Scholar', description: 'Sir Thakur is working as visiting lecturer in several professional institutions catering students of ICMAP, ICAP, ACCA, CMA and CIMA. He is a Finance Professional & teacher having a decade worth of multidimensional experience in finance, audit, consulting & academia. His core subjects are Cost and Management Accounting and Financial Management.' },

        { picture: 'images/ca-inst/Rehan.jpg', experience: '6 Years', name: 'Sir Rehan Sarwar', qualification: 'MA (English), MA (Education)', description: 'It’s hard to find individuals like Sir Rehan Sarwar who are highly motivated in promoting quality education through their spectacular qualifications. Sir Rehan is a phenomenal mentor with a qualification of MA English and MA Education and a professional experience of 6+ years as an instructor in the field of CA. Moreover, his experience in the fields of Intermediate and Graduation is more than 10 years. He joined Nearpeer for the purpose of spreading his amazing knowledge in CA to help students fulfil their dreams.' },
      
        { picture: 'images/ca-inst/Jahanzaib Khan.jpg', experience: '6 Years', name: 'Sir Jahanzaib Khan', qualification: 'APFA,MBA,CA(Finalist)', description: 'Sir Jahanzaib Khan is here at Nearpeer to literally make CA super easy. With his amazing skills in Auditing and Taxation and experience of 6+ years, Sir Jahanzaib has recorded many lectures to guide you through your CA journey as a brilliant student. He is CA Finalist, APFA and MBA as well. Nearpeer is highly obliged to have such an ambitious and excellent CA instructor for its students.' },

        { picture: 'images/ca-inst/Waseem Akram.jpg', experience: '7 Years', name: 'Sir Waseem Akram', qualification: 'ACA', description: 'Sir Waseem Akram, ACA has joined hands with Nearpeer to help all CA students. He has 10 years industry and 6 years teaching experience. He has taught Far1 Far2 CMA and MFA to hundreds of students across the country and most of them have successful careers now. Currently he offers the course of Cost, Financial Accounting and Reporting I and II (CMA, FAR I and FAR II at Nearpeer' },

        { picture: 'images/ca-inst/Ajmal Kanju.jpg', experience: '5 Years', name: 'Sir Ajmal Kanju', qualification: 'CA (Finalist),M.Phil (Finance) & SAP certified', description: 'Nearpeer has the sole purpose of creating a friendly environment during the lectures so the students could fall in love with learning. With an experience of 6+ years as an instructor, Sir Ajmal Kanju is one of the many gems at Nearpeer that help fulfilling its purpose. He is an SAP Certified individual with CA (F), M.Phil Finance, and MBA Finance degrees to ensure quality and authentic education at Nearpeer.' },

        { picture: 'images/ca-inst/Osama Waheed.jpg', experience: '5 Years', name: 'Sir Osama Waheed', qualification: 'CA (Finalist)', description: 'Sir Osama Waheed is a passionate individual with a keen interest in building a student’s career and this is because he caught Nearpeer’s attention. As a CA Finalist, Sir Osama has some creative teaching skills since he’s been working as an instructor for more than 4 years now. Studying through his course of Audit and Assurance at Nearpeer will get you 10 steps nearer to success!' },

        { picture: 'images/ca-inst/Daniyal.jpg', experience: '5 Years', name: 'Sir Muhammad Daniyal', qualification: 'MBA, CA(INTER)', description: 'Being a CA Inter and an MBA, Sir Danial Kaleem has joined Nearpeer to pursue his career as a professional and regular teacher. His experience of 5 years in the field may tell his young age but talking about his knowledge and teaching skills, he is a remarkable individual. ' },

      ];
      $scope.direction = 'left';
      $scope.currentIndex = 0;

      $scope.setCurrentSlideIndex = function (index) {
        $scope.direction = (index > $scope.currentIndex) ? 'left' : 'right';
        $scope.currentIndex = index;
      };

      $scope.isCurrentSlideIndex = function (index) {
        return $scope.currentIndex === index;
      };

      $scope.prevSlide = function () {
        $scope.direction = 'left';
        $scope.currentIndex = ($scope.currentIndex < $scope.instructors.length - 1) ? ++$scope.currentIndex : 0;
      };

      $scope.nextSlide = function () {
        $scope.direction = 'right';
        $scope.currentIndex = ($scope.currentIndex > 0) ? --$scope.currentIndex : $scope.instructors.length - 1;
      };

      var video = document.getElementById('video');

      $scope.playVid = function () {
        video.play();
        $scope.paused = false;
        $scope.played = true;
      }

      $scope.pauseVid = function () {
        video.pause();
        $scope.paused = true;
        $scope.played = false;
      }

      $scope.checkDate = function (date) {
        var crtDate = new Date();
        var sDate = new Date(date);

        if (crtDate > sDate) {
          return true;
        }
        else {
          return false;
        }
      }

      if (window.screen.width > 320 && window.screen.width < 1024) {
        $scope.mobileView = true;
      } else {
        $scope.mobileView = false;
      }

      }]);

})();

(function () {
    'use strict';

    angular
        .module('NearPeer')
        .controller('faqsController', ['$scope', 'HttpService', '$state', function ($scope, HttpService, $state) {
            var sr = $scope;
            var faqsArray = [];
            var instName = $state.params.instName; 
            HttpService.getRequest("api/v1/instFaq/getFaq", { name: instName })
                .then(function (response) {
                    if (response) {
                        sr.faqs = response.faq.inst.faqs;
                        sr.name = response.faq.inst.name;
                    }
                    else {
                        swal({
                            title: "Not Found",
                            text: response.message,
                            type: "warning"
                        }, function () {
                        });
                    }
                })



        }])
})();




(function() {
  'use strict';

  angular
  .module('NearPeer')
  .run(function($rootScope, $state, $http, CustomStorageService, deviceDetector, $window, requestService, $cookies, $location, env) {
    var __oldAuthToken__ = window.localStorage.getItem('authToken');
    var __userINfO__ = window.localStorage.getItem('userInfo')
    if (__oldAuthToken__ && __userINfO__ && __userINfO__.user_type == 'student') {
      window.localStorage.setItem('userAuthToken', __oldAuthToken__);
      window.localStorage.removeItem('authToken');
    } else {
      if (__oldAuthToken__){
        window.localStorage.removeItem('authToken')
      }
      if (__oldAuthToken__ && __userINfO__){
        window.localStorage.removeItem('userInfo')
      }
    }
    var browserId = $cookies.get('browserId');
    var params = $location.$$search;
    $rootScope.tokenLogin = false;
    
    if(params.liveSessionId) {
      $rootScope.liveSessionId = params.liveSessionId;
    }

    if(params && params.uid && params.token) {
      var body = {
        user_id: params.uid,
        session: params.token
      };
      var isLogin = CustomStorageService.getAuthTokenStorageData();
      var oldUserData = CustomStorageService.getUserInfoStorageData()
      var toGoUrl = window.location.href;
      if(!isLogin) {
        $location.path("/loading");
        if($rootScope.platform_reactApp){
          console.log("Not Logged In route");

        }
        $http.post(env.authService +'v1/sessions/validate-session',body)
        .then(function(resp) {
          if(resp.data.success) {
            $http({
              method: 'GET',
              url: '/api/v1/users/getUserData',
              headers: {
                uid: params.uid,
                Authorization: params.token
              },
            })
            .then(function(user) {
              var user = user.data;
              CustomStorageService.SignInService(false,true,false,false,params.token,user);
              setTimeout(function() {
                if(toGoUrl.includes('free=true')) {
                  window.location = toGoUrl.split("?")[0] + '?free=true';
                } else if(toGoUrl.includes('payment=true')) {
                  window.location = toGoUrl.split("?")[0] + '?payment=true';
                } else if(toGoUrl.includes('webview=true')) {
                  window.location = toGoUrl.split("?")[0] + '?webview=true';
                } else if(toGoUrl.includes('liveSessionId=')) {
                  window.location = toGoUrl.split("?")[0] + '?liveSessionId=' + params.liveSessionId;
                } else {
                  window.location = toGoUrl.split("?")[0];
                }
              }, 500)
            },function errorCallback(response) {
            })
          }
        },function errorCallback(response) {
        })
      }else if(params.uid != oldUserData.id || params.token !== CustomStorageService.getAuthTokenStorageData()){
        $location.path("/loading");
        if(!$rootScope.platform_reactApp){
          console.log("Logged In route");
        }
         $rootScope.tokenLogin = true;

        // if($rootScope.platform_reactApp){
          var oldToken = CustomStorageService.getAuthTokenStorageData();

          // CustomStorageService.setBlogerSignedInStorageData(false);
          // CustomStorageService.setUserSignedInStorageData(false);
          // CustomStorageService.setAdminSignedInStorageData(false);
          // CustomStorageService.setInstructorSignedInStorageData(false);
          console.log(body);
          $http.post(env.authService +'v1/sessions/validate-session',body)
          .then(function(resp) {
            if(resp.data.success) {
              console.log("validate-session success");
              $http({
                method: 'GET',
                url: '/api/v1/users/getUserData',
                headers: {
                  uid: body.user_id,
                  Authorization: body.session,
                  Referer: 'https://www.nearpeer.org'
                },
              })
              .then(function(user) {
                console.log("det user data success");
                var user = user.data;
                CustomStorageService.setUserSignedInStorageData(false);
                CustomStorageService.SignInService(false,true,false,false,body.session,user);
                setTimeout(function() {
                  console.log("done reloaddd");
                  console.log(toGoUrl);
                  if(toGoUrl.includes('free=true')) {
                    window.location = toGoUrl.split("?")[0] + '?free=true';
                  } else if(toGoUrl.includes('payment=true')) {
                    window.location = toGoUrl.split("?")[0] + '?payment=true';
                  } else if(toGoUrl.includes('webview=true')) {
                    console.log("done reloaddd gotoo");
                    window.location = toGoUrl.split("?")[0] + '?webview=true';
                  } else if(toGoUrl.includes('liveSessionId=')) {
                    window.location = toGoUrl.split("?")[0] + '?liveSessionId=' + params.liveSessionId;
                  } else {
                    window.location = toGoUrl.split("?")[0];
                  }
                }, 500)
              },function errorCallback(response) {
                console.log("det user data errorrr");
                console.log(response);
              })
            } else {
              console.log("validate-session failed");
            }
          },function errorCallback(response) {
          })

        // }

      } else if(params.updateUserData) {
        $location.path("/loading");
        $http({
          method: 'GET',
          url: '/api/v1/users/getUserData',
          headers: {
            uid: body.user_id,
            Authorization: body.session,
            Referer: 'https://www.nearpeer.org'
          },
        })
        .then(function(user) {
          var user = user.data;
          CustomStorageService.setUserSignedInStorageData(false);
          setTimeout(function() {
            if(toGoUrl.includes('free=true')) {
              window.location = toGoUrl.split("?")[0] + '?free=true';
            } else if(toGoUrl.includes('payment=true')) {
              window.location = toGoUrl.split("?")[0] + '?payment=true';
            } else if(toGoUrl.includes('webview=true')) {
              console.log("done reloaddd gotoo");
              window.location = toGoUrl.split("?")[0] + '?webview=true';
            } else if(toGoUrl.includes('liveSessionId=')) {
              window.location = toGoUrl.split("?")[0] + '?liveSessionId=' + params.liveSessionId;
            } else {
              window.location = toGoUrl.split("?")[0];
            }
          }, 500)
        },function errorCallback(response) {
        })
      }
      
    }
    // var time = new Date();
    // if(time){
    //   $http({
		// 	  url: '/api/v1/story/storyDisable',
		// 	  method: 'GET',
		// 	}).then(function(err) {
    //     console.log('ERROR 1', err);
		// 	})
    // }
    // if(time){
    //   $http({
		// 	  url: 'api/v1/story/storyEnable',
		// 	  method: 'GET',
		// 	}).then(function(err) {
    //     console.log('ERROR 2', err);
		// 	})
    // }
    var userAgent = deviceDetector.raw.userAgent;
    if(!browserId) {
      browserId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      $cookies.put('browserId', browserId);
    }
    if(CustomStorageService.getUserSignedInStorageData()) {
      var userData = CustomStorageService.getUserInfoStorageData();
      if(userData != null && userData.user_type === "student") {
        $http({
          method: "GET",
          url: "/api/v1/orders/get-purchase-event-pending-trigger",
          headers: {
            uid: userData.id,
          },
        }).then(
          function (res) {
            var data = res.data.data;
            if (!data || data.length == 0) {
              return false;
            }
            data.forEach(function (item) {
              try {
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                  event: "order-paid-page",
                  ecommerce: {
                    currencyCode: "PKR", // Local currency is optional.
                    click: {
                      id: item.ref_no,
                      paymentMethod: "admin",
                      price: item.total,
                      productType: "N/A",
                      name: item.order_items[0].course.name,
                      brand: "Nearpeer",
                      orderType: "Self-Order",
                      instName:
                        item.order_items[0].course.institution || "Default",
                    },
                  },
                });
              } catch (err) {}
              $http({
                method: "GET",
                url: "/api/v1/orders/mark-true-purchase-event-pending-trigger",
                headers: {
                  uid: userData.id,
                },
              }).then(
                function (res) {
                },
                function errorCallback(response) {
                  console.log("error", response);
                }
              )
            });
          },
          function errorCallback(response) {
            console.log("error", response);
          }
        );
        $rootScope.appConfigs = {};
        $http({
          method: 'GET',
          url: '/api/v1/users/get-tawk-config',
          headers: {
            uid: userData.id,
          },
        })
        .then(function(res) {
          if(res && res.data && res.data.showTalk ) {
            var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();(function(){var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0];s1.async=true;s1.src='https://embed.tawk.to/5881c8302438f53b0a2e3007/default';s1.charset='UTF-8';s1.setAttribute('crossorigin','*');s0.parentNode.insertBefore(s1,s0);})();
          }
        },function errorCallback(response) {
        })
      }
    }
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
      if (CustomStorageService.getUserSignedInStorageData() || CustomStorageService.getInstructorSignedInStorageData() || CustomStorageService.getAdminSignedInStorageData()) {
        if($rootScope.tokenLogin){

          var data = {
            user_id: params.uid,
            token: params.token
          }
          
$rootScope.tokenLogin = false;
        }else{
          var getUserInfoStorageData = CustomStorageService.getUserInfoStorageData();
          if(getUserInfoStorageData){
            var type_of_user = CustomStorageService.getUserInfoStorageData().user_type;
            var data = {
              user_id: CustomStorageService.getUserInfoStorageData().id,
              token: CustomStorageService.getAuthTokenStorageData()
            }
          }
         
        }
		if(data != undefined){
			$http({
			  url: '/api/v1/auth/validateToken',
			  method: 'GET',
			  params: data
			}).then(function(err) {
			}, function errorCallback(response) {
	
			  requestService.responseHandler(response.status, type_of_user);
			});
		  }
		}
	  }); 
    $rootScope.platform_desktop = false;
    $rootScope.platform_reactApp = false;
    $rootScope.openOrders = false;
    
    if(deviceDetector.isTablet() || deviceDetector.isMobile()) {
      $rootScope.isMobile = true;
    }
    if (userAgent.includes('desktop')) {
      $rootScope.platform_desktop = true;
    }
    if (userAgent.includes('React-Native-NP')) {
      $rootScope.platform_reactApp = true;
      if(userAgent === 'React-Native-NP') {
        $rootScope.platform_reactAppOld = true;
      }
    }
    if (userAgent.includes('React-Native-NP-New')) {
      $rootScope.platform_reactApp_new = true;
    }
    $rootScope.online = $window.navigator.onLine;
    if(!$rootScope.online){
      if($rootScope.platform_desktop){
        swal({
          title: "Internet Connection Lost!",
          type: "error",
          showConfirmButton: false,
          allowOutsideClick: false
        }, function() { }); 
      } 
      if($rootScope.platform_reactApp){
        swal({
          title: "Internet Connection Lost!",
          type: "error",
          showConfirmButton: false,
          allowOutsideClick: false
        }, function() { }); 
      } 
    }
		$window.addEventListener("offline", function () {
		  $rootScope.$apply(function() {
        $rootScope.online = false;
        if($rootScope.platform_desktop){
          swal({
            title: "Internet Connection Lost!",
            type: "error",
            showConfirmButton: false,
            allowOutsideClick: false
          }, function() { }); 
        }    
        if($rootScope.platform_reactApp){
          swal({
            title: "Internet Connection Lost!",
            type: "error",
            showConfirmButton: false,
            allowOutsideClick: false
          }, function() { }); 
        }  
		  });
		}, false);
		$window.addEventListener("online", function () {
		  $rootScope.$apply(function() {
        $rootScope.online = true;
        if($rootScope.platform_desktop){
          swal({
            title: "Internet Connected Successfully!",
            type: "success",
            timer: 2000,
            showConfirmButton: false,
          }, function() {
            swal.close();
          }); 
        }
        if($rootScope.platform_reactApp){
          swal({
            title: "Internet Connected Successfully!",
            type: "success",
            timer: 2000,
            showConfirmButton: false,
          }, function() {
            swal.close();
          }); 
        }
		  });
	}, false);
    // var dataAllCourses = window.localStorage.getItem("allCourses");
    // $(window).on("load", function () {
    //   $rootScope.isWindowloadedComplete = true;

    // });
  //   if ($rootScope.platform_reactApp) {
  //     console.log("in index run2");
  //   var profComp =  window.localStorage.getItem("profileCompleted");
  //   console.log("Prof Comp",typeof profComp,profComp);
  //   if(profComp === "true"|| profComp == "true"){
  //     console.log("in index run2");
  //   $scope.goToState("Complete-Profile");
  //   }
  // }


  });
  
})();

(function() {
  'use strict';
  angular
  .module('NearPeer')
  .config(function($stateProvider, $urlRouterProvider,$qProvider,$locationProvider) {
    $qProvider.errorOnUnhandledRejections(false);
    var adminDep = ['https://cdn.quilljs.com/2.0.0-dev.1/quill.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/xlsx.full.min.js',
    './js/angularjs-dropdown-multiselect.min.js',
    'https://cdn.quilljs.com/2.0.0-dev.1/quill.snow.css',
    'https://cdn.quilljs.com/2.0.0-dev.1/quill.bubble.css',
    'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/jszip.js'];
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $stateProvider
    .state('dummy',{
      url: '/',
      controller: 'dummyController'
    })
    .state('closeWindow',{
      url:'/closeWindows',
      controller: 'closeController'
    })
    .state('thankYou',{
      url:'/thankyou',
      templateUrl: 'app/thankYou/thankYou.html'
    })
    .state('qist_pay_redirect', {
      url: '/qist-pay/success-or-failure',
      parent: 'Header',
      templateUrl: 'app/qistpay-response/qistpay-response.html',
      controller: 'QistPayController'
    })
    .state('PaymentStatus',{
      url:'/payment-status/:status',
      templateUrl: 'app/registration/paymentStatus.html',
      controller: 'paymentStatusController'
    })
    .state('Header',{
      templateUrl: 'app/Pages/header.html',
      abstract: true,
      controller: 'HeaderController',
      // resolve: {
      //   loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
      //     return $ocLazyLoad.load([
      //       'https://cdn.nearpeer.org/cdn/countrySelect.js',
      //       'https://cdn.nearpeer.org/cdn/countrySelect.css'
      //     ]);
      //   }]
      // }
    })
    .state('loading',{
      url: '/loading',
      templateUrl: 'app/loading/loading.html',
      controller: 'LoadingController',
    })
    .state('Landing',{
      url: '/landing',
      templateUrl: 'app/Landing/landing.html',
      controller: 'landingController',
      parent: 'Header'
    })
    .state('Login',{
      url: '/join-us',
      templateUrl: 'app/Landing/landing.html',
      controller: 'landingController',
      parent: 'Header'
    })
    .state('Login_Social',{
      url: '/join-us/:social_type',
      templateUrl: 'app/Landing/landing.html',
      controller: 'landingController',
      parent: 'Header'
    })
    .state('Create_Account',{
      url: '/create-account/:step',
      templateUrl: 'app/Landing/landing.html',
      controller: 'landingController',
      parent: 'Header'
    })
    .state('redirect_link_check', {
      url: '/np-link/:link_id',
      templateUrl: 'app/redirectLinkCheck/redirectLinkCheck.html',
      controller: 'redirectLinkCheckController'
    })
    .state('form_link_check', {
      url: '/np-form/:form_id',
      parent: 'Header',
      templateUrl: 'app/formLinkCheck/formLinkCheck.html',
      controller: 'formLinkCheckController'
    })
    .state('404',{
      url: '/pagenotfound',
      parent: 'Header',
      templateUrl: 'app/404/notfound.html'
    })
    // User Orders
    .state('orderDetails', {
      url: '/order/detail/:course_id/:module_id/:instructorId/:ifModule/:total/:isQistpay',
      parent: 'Header',
      templateUrl: 'app/user-orders/orderDetails.html',
      css: 'app/user-orders/orderDetails.css',
      controller: 'orderDetailsController'
    })
    .state('orderDetailsCoupon', {
      url: '/order/detail/:course_id/:module_id/:instructorId/:ifModule/:total/:couponId/:couponAmount/:isQistpay',
      parent: 'Header',
      templateUrl: 'app/user-orders/orderDetails.html',
      css: 'app/user-orders/orderDetails.css',
      controller: 'orderDetailsController'
    })
    .state('orderPaymentmethods', {
      url: '/order/payment-methods/:orderRefNo/:isQistpay',
      parent: 'Header',
      templateUrl: 'app/user-orders/orderPaymentMethods.html',
      css: 'app/user-orders/orderPaymentMethods.css',
      controller: 'orderPaymentMethodsController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js'
          ]);
        }]
      }
    })
    .state('orderPaymentmethodsProceed', {
      url: '/order/payment-methods-proceed/:type/:orderRefNo/:isQistpay',
      parent: 'Header',
      templateUrl: 'app/user-orders/orderPaymentMethods.html',
      css: 'app/user-orders/orderPaymentMethods.css',
      controller: 'orderPaymentMethodsController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js'
          ]);
        }]
      }
    })
    .state('orderlists', {
      url: '/order/list',
      parent: 'Header',
      templateUrl: 'app/user-orders/userOrderList.html',
      controller: 'userOrderListController'
    })
    .state('metatag',{
      url: '/insert-tag',
      parent: 'Header',
      templateUrl: 'app/tag/tag.html',
      controller: 'TagController'
    })
    .state('Home', {
      url: '/university',
      parent: 'Header',
      templateUrl: 'app/Home/Home.html',
      controller: 'HomeController'
    })
    .state('Contact-Us',{
      url: '/contact-us',
      parent: 'Header',
      templateUrl: 'app/Pages/contactus.html',
      controller: 'ContactUsController'
    })
    .state('About-Us',{
      url: '/about-us',
      parent: 'Header',
      templateUrl: 'app/Pages/aboutus.html',
      controller: 'AboutUsController'
    })
    .state('Lead-Gen',{
      url: '/lead-gen',
      parent: 'Header',
      templateUrl: 'app/lead-gen/leadGen.html',
      controller: 'leadGenController'
    })
    .state('B2B',{
      url: '/for-business',
      parent: 'Header',
      templateUrl: 'app/b2b/b2b.html',
      controller: 'b2bController'
    })
    .state('storeel',{
      url: '/storeel/:storeel_id',
      params: {
        story_id: null,
        stories:null,
        dynamic_url:null,
      },
      parent: 'Header',
      templateUrl: 'app/storeel/storeel.html',
      controller: 'storeelController'
    })
    
    .state('Story-Unique-Link',{
      url: '/storeel/story/:story_link_id',
      parent: 'Header',
      templateUrl: 'app/storeel/storeel.html',
      controller: 'storeelController'
    })
    .state('Reel-Unique-Link',{
      url: '/storeel/reel/:reel_link_id',
      parent: 'Header',
      templateUrl: 'app/storeel/storeel.html',
      controller: 'storeelController'
    })
    .state('All-Notification',{
      url: '/all-notification',
      parent: 'Header',
      templateUrl: 'app/notifications/allnotification.html',
      controller: 'AllNotificationController'
    })
    .state('Single-Notification',{
      url: '/single-notification',
      parent: 'Header',
      templateUrl: 'app/notifications/singlenotification.html',
      controller: 'SingleNotificationController'
    })
    .state('Assignment-Notification',{
      url: '/assignment-noti/:id',
      parent: 'Header',
      templateUrl: 'app/assignment/assignmentNotification.html',
      controller: 'assignmentNotificationController'
    })
    .state('Assignment-Result',{
      url: '/assignment-result/:id',
      parent: 'Header',
      templateUrl: 'app/assignment/assignmentResult.html',
      controller: 'assignmentResultController'
    })
    .state('Complete-Profile',{
      url: '/complete-profile/:name',
      parent: 'Header',
      templateUrl: 'app/completeProfile/completeProfile.html',
      controller: 'completerProfileController',
    })
    .state('profile_settings', {
      url: '/profile-settings/:name',
      parent: 'Header',
      templateUrl: 'app/profileSettings/profileSettings.html',
      controller: 'ProfileSettingsController',
    })
    .state('downloadapp',{
      url: '/downloadapp',
      parent: 'Header',
      templateUrl: 'app/Pages/downloadApp.html',
      controller: 'DownloadAppController'
    })
    .state('downloadAppMobile',{
      url: '/download-mobile-app',
      parent: 'Header',
      templateUrl: 'app/Pages/downloadAppMobile.html',
      controller: 'DownloadAppMobileController'
    })
    .state('WorkWithUs',{
      url: '/work-with-us',
      parent: 'Header',
      templateUrl: 'app/Pages/workwithus.html',
      controller: 'workwithusController'
    })
    .state('Blog',{
      url: '/blogs',
      parent: 'Header',
      templateUrl: 'app/blog/blogCategories.html',
      controller: 'BlogCategoriesController'
    })
    // .state('BlogSearch',{
    //   url: '/blogs/:category',
    //   parent: 'Header',
    //   templateUrl: 'app/blog/blogSearch.html',
    //   controller: 'BlogSearchController'
    // })
    .state('BlogList',{
      url: '/blogs/:category',
      parent: 'Header',
      templateUrl: 'app/blog/blogListing.html',
      controller: 'BlogListingController'
    })
    .state('BlogDetail',{
      url: '/blog/:category/:id',
      parent: 'Header',
      templateUrl: 'app/blog/blogdetail.html',
      controller: 'BlogDetailController'
    })
    .state('BlogDetail2',{
      url: '/blog/:id',
      parent: 'Header',
      templateUrl: 'app/blog/blogdetail.html',
      controller: 'BlogDetailController'
    })
    .state('EnterEmailChronicles',{
      url: '/enter-email-chronicles/:chronicle',
      parent: 'Header',
      templateUrl: 'app/blog/blogdetail.html',
      controller: 'BlogDetailController'
    })
    .state('CheckInboxChronicles',{
      url: '/check-inbox-chronicles/:chronicle',
      parent: 'Header',
      templateUrl: 'app/blog/blogdetail.html',
      controller: 'BlogDetailController'
    })
    .state('privacypolicy',{
      url:'/privacypolicy',
      parent: 'Header',
      templateUrl: 'app/Pages/privacypolicy.html',
      controller: ''
    })
    .state('privacypolicy1',{
      url:'/privacypolicy-1.1',
      parent: 'Header',
      templateUrl: 'app/Pages/privacypolicy1.html',
      controller: ''
    })
    .state('paymentOptions',{
      url: '/payment-options',
      parent: 'Header',
      templateUrl: 'app/Pages/payment-options.html',
      controller: 'PaymentOptionsController'
    })
    .state('paymentPlans',{
      url: '/payment-plans',
      parent: 'Header',
      templateUrl: 'app/Pages/payment-plans.html',
      controller: 'PaymentPlansController'
    })
    .state('faqs', {
      url:'/faqs/:instName', 
      parent: 'Header',
      templateUrl: 'app/Faqs/faqs.html',
      controller:'faqsController'
    })

    //Register
    .state('register', {
      url: '/register',
      parent: 'Header',
      templateUrl: 'app/registration/register.html',
      controller: 'RegistrationController',
    })
    .state('forgot-password', {
      url: '/forgot-password',
      parent: 'Header',
      templateUrl: 'app/registration/forgotpassword.html',
      controller: 'RegistrationController',
    })
    .state('update-password', {
      url: '/resetPassword/:email/:token',
      parent: 'Header',
      templateUrl: 'app/registration/updatepassword.html',
      controller: 'passwordResetController',
    })
    .state('user-confirmed', {
      url: '/confirmAccount/:email/:token',
      templateUrl: 'app/registration/userconfirmed.html',
      controller: 'UserConfirmedController',
    })
    //Account Dashboard
    .state('my-account', {
      url: '/my-account',
      parent: 'Header',
      templateUrl: 'app/student_account/my-account.html',
      controller: 'StudentAccountController'
    })
    //AdminSigIn
    .state('admin_signin', {
      url: '/admin_signin',
      templateUrl: 'app/admin/admin_signin.html',
      controller: 'AdminSigninController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load(adminDep);
        }]
      }
    })
    .state('BlogsPanel',{
      url:'/BlogsPanel/BlogsPanelHome',
      templateUrl:'app/blogs-panel/blogsHome/blogsHomePage.html',
      controller:'seprateBlogsPanelController'
    })
    .state('BlogsPanelSignIn',{
      url:'/BlogsPanel',
      templateUrl:'app/blogs-panel/blogsPanelSignIn.html',
      controller:'blogsPanelSignInController'
    })
    .state('otpPageFeature', {
      url: '/admin_OTP',
      templateUrl: 'app/admin/otpPage/otpPage.html',
      controller: 'otpPageController'
    })
    .state('stories', {
      url: '/admin_panel/stories',
      parent: 'Sidebar',
      templateUrl: 'app/admin/stories/stories.html',
      controller: 'storiesController'
    })
    .state('create-story', {
      url: '/admin_panel/create-story',
      parent: 'Sidebar',
      templateUrl: 'app/admin/stories/create-story.html',
      controller: 'createStoryController'
    })
    .state('edit-story', {
      url: '/admin_panel/edit-story',
      params: {
        story_id: null,
      },
      parent: 'Sidebar',
      templateUrl: 'app/admin/stories/edit-story.html',
      controller: 'editStoryController'
    })
    .state('story-detail', {
      url: '/admin_panel/story-detail/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/stories/story-detail.html',
      controller: 'storyDetailController'
    })
    .state('coupon', {
      url: '/admin/coupon',
      parent: 'Sidebar',
      templateUrl: 'app/admin/coupons/coupons.html',
      controller: 'couponController'
    })
    .state('add_coupon', {
      url: '/admin/add-coupon',
      parent: 'Sidebar',
      templateUrl: 'app/admin/coupons/addCoupon/addCoupon.html',
      controller: 'addCouponController'
    })
    .state('edit_coupon', {
      url: '/admin/edit-coupon/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/coupons/editCoupon/editCoupon.html',
      controller: 'editCouponController'
    })
    .state('suspicious_users_req', {
      url: '/admin/suspicious-users-req',
      parent: 'Sidebar',
      templateUrl: 'app/admin/suspiciousUserReq/suspiciousUserReq.html',
      controller: 'suspiciousUserReqController'
    })
    .state('mobile_popup_config', {
      url: '/admin/post-questions-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/mobilePopupConfig/mobilePopupConfig.html',
      controller: 'mobilePopupConfigController'
    })
    .state('add_mobile_popup_config', {
      url: '/admin/add-post-questions-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/mobilePopupConfig/addMobilePopupConfig/addMobilePopupConfig.html',
      controller: 'addMobilePopupConfigController'
    })
    .state('edit_mobile_popup_config', {
      url: '/admin/edit-post-questions-config/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/mobilePopupConfig/editMobilePopupConfig/editMobilePopupConfig.html',
      controller: 'editMobilePopupConfigController'
    })
    .state('post_questions_config', {
      url: '/admin/post-questions-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/postQuestionConfig/postQuestionConfig.html',
      controller: 'postQuestionConfigController'
    })
    .state('add_post_questions_config', {
      url: '/admin/add-post-questions-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/postQuestionConfig/addPostQuestionConfig/addPostQuestionConfig.html',
      controller: 'addPostQuestionConfigController'
    })
    .state('edit_post_questions_config', {
      url: '/admin/edit-post-questions-config/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/postQuestionConfig/editPostQuestionConfig/editPostQuestionConfig.html',
      controller: 'editPostQuestionConfigController'
    })
    .state('wp_pages', {
      url: '/admin/wp-pages',
      parent: 'Sidebar',
      templateUrl: 'app/admin/wpSitePages/wpSitePages.html',
      controller: 'wpSitePagesController'
    })
    .state('add_wp_pages', {
      url: '/admin/add-wp-pages',
      parent: 'Sidebar',
      templateUrl: 'app/admin/wpSitePages/addWpSitePages/addWpSitePages.html',
      controller: 'addWpSitePagesController'
    })
    .state('campaign_tracking', {
      url: '/admin/campaign-tracking?filter&sort&search',
      parent: 'Sidebar',
      templateUrl: 'app/admin/campaignTracking/campaignTracking.html',
      controller: 'campaignTrackingController',
      // params:{
      //   filter, sort
      //   // filter: {filter, sort}
      // }
    })
    .state('add_campaign_tracking', {
      url: '/admin/add-campaign-tracking',
      parent: 'Sidebar',
      templateUrl: 'app/admin/campaignTracking/addCampaignTracking/addCampaignTracking.html',
      controller: 'addCampaignTrackingController'
    })
    .state('edit_campaign_tracking', {
      url: '/admin/edit-campaign-tracking/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/campaignTracking/addCampaignTracking/addCampaignTracking.html',
      controller: 'addCampaignTrackingController'
    })
    .state('campaign_stats', {
      url: '/admin/campaign-stats/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/campaignTracking/campaignStats/campaignStats.html',
      controller: 'campaignStatsController'
    })
    .state('free_access', {
      url: '/admin/free-access',
      parent: 'Sidebar',
      templateUrl: 'app/admin/freeAccessConfig/freeAccess.html',
      controller: 'freeAccessController'
    })
    .state('add_free_access', {
      url: '/admin/add-free-access',
      parent: 'Sidebar',
      templateUrl: 'app/admin/freeAccessConfig/addFreeAccess/addFreeAccess.html',
      controller: 'addFreeAccessController'
    })
    .state('edit_free_access', {
      url: '/admin/edit-free-access/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/freeAccessConfig/editFreeAccess/editFreeAccess.html',
      controller: 'editFreeAccessController'
    })
    .state('free_access_tracking', {
      url: '/admin/free-access-tracking',
      parent: 'Sidebar',
      templateUrl: 'app/admin/freeAccessConfig/freeAccessTracking/freeAccessTracking.html',
      controller: 'FreeAccessTrackingController'
    })
    //AdminAccess
    .state('admin_access', {
      url: '/admin/admin_access',
      parent: 'Sidebar',
      templateUrl: 'app/admin/adminAccess/adminAccess.html',
      controller: 'adminAccessController'
    })
    .state('admin_configurations', {
      url: '/admin_panel/configurations',
      parent: 'Sidebar',
      templateUrl: 'app/admin/configurations/configurations.html',
      controller: 'configurationsController'
    })
    .state('admin_edit_configurations', {
      url: '/admin_panel/configurations/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/configurations/editConfiguration.html',
      controller: 'configurationsEditController'
    })
    .state('fsc_visits', {
      url: '/admin_panel/fsc_visits',
      parent: 'Sidebar',
      templateUrl: 'app/admin/fscVisits/fscVisits.html',
      controller: 'fscVisitsController'
    })
    .state('admin_mobile_serving', {
      url: '/admin_panel/admin_mobile_serving',
      parent: 'Sidebar',
      templateUrl: 'app/admin/mobileServing/mobileServing.html',
      controller: 'mobileServingController'
    })
    .state('download_videos_config', {
      url: '/admin_panel/download_videos_config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/downloadVideosConfig/downloadVideosConfig.html',
      controller: 'downloadVideosConfigController'
    })
    .state('redirect_links', {
      url: '/admin_panel/redirect_links',
      parent: 'Sidebar',
      templateUrl: 'app/admin/redirectLinks/redirectLinks.html',
      controller: 'redirectLinksController'
    })
    .state('recommendation_banner', {
      url: '/admin_panel/recommendation_banner',
      parent: 'Sidebar',
      templateUrl: 'app/admin/recommendationBanners/recommendationBanners.html',
      controller: 'recommendationBannersController'
    })
    .state('iframe_form', {
      url: '/admin_panel/iframe-form',
      parent: 'Sidebar',
      templateUrl: 'app/admin/iframeForm/iframeForm.html',
      controller: 'iframeFormController'
    })
    .state('bot_config', {
      url: '/admin_panel/bot-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/botConfig/botConfig.html',
      controller: 'botConfigController'
    })
    .state('bot_system_prompt', {
      url: '/admin_panel/bot-config/system-prompt',
      parent: 'Sidebar',
      templateUrl: 'app/admin/botConfig/botSystemPrompt/botSystemPrompt.html',
      controller: 'botSystemPromptController'
    })
    .state('add_custom_form', {
      url: '/admin_panel/add-custom-form',
      parent: 'Sidebar',
      templateUrl: 'app/admin/formBuilder/addForm/addForm.html',
      controller: 'addFormController'
    })
    .state('edit_custom_form', {
      url: '/admin_panel/edit-custom-form/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/formBuilder/addForm/addForm.html',
      controller: 'addFormController'
    })
    .state('form_builder', {
      url: '/admin_panel/form-builder',
      parent: 'Sidebar',
      templateUrl: 'app/admin/formBuilder/formBuilder.html',
      controller: 'formBuilderController'
    })
    .state('block_extension', {
      url: '/admin_panel/block_extension',
      parent: 'Sidebar',
      templateUrl: 'app/admin/blockExtension/blockExtension.html',
      controller: 'blockExtensionController'
    })
    .state('new_coming_emails', {
      url: '/admin_panel/new_coming_emails',
      parent: 'Sidebar',
      templateUrl: 'app/admin/newComingEmails/newComingEmails.html',
      controller: 'newComingEmailsController'
    })
    .state('business_request', {
      url: '/admin_panel/business_request',
      parent: 'Sidebar',
      templateUrl: 'app/admin/businessRequest/businessRequest.html',
      controller: 'businessRequestController'
    })
    .state('sms-in-bulk', {
      url: '/admin_panel/sms',
      parent: 'Sidebar',
      templateUrl: 'app/admin/sms/SendBulkSMS.html',
      controller: 'SendBulkSMSController'
    })
    .state('admin_whitelisted_users', {
      url: '/admin_panel/whitelisted_users',
      parent: 'Sidebar',
      templateUrl: 'app/admin/whitelisted_users/whitelisted_users.html',
      controller: 'whitelistedUsersController'
    })
    .state('user_ips', {
      url: '/admin_panel/user_ips/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/whitelisted_users/userIPList.html',
      controller: 'userIPListController'
    })
    .state('courseTags',{
      url:'/admin_panel/course_tags',
      parent: 'Sidebar',
      templateUrl:'app/admin/courseTags/courseTags.html',
      controller:'courseTagsController'
    })
    .state('tagFeature',{
      url:'/admin_panel/tag_feature/:tag_id',
      parent: 'Sidebar',
      templateUrl:'app/admin/tagFeatures/tagFeatures.html',
      controller:'TagFeaturesController'
    })
    .state('StudentQuestions',{
      url:'/admin_panel/questions',
      parent: 'Sidebar',
      templateUrl:'app/admin/questions/adminQuestions.html',
      controller:'adminQuestionsController'
    })
    .state('AdminAssignments',{
      url:'/admin_panel/assignments',
      parent: 'Sidebar',
      templateUrl:'app/admin/assignments/assignments.html',
      controller:'adminAssignmentsController'
    })
    .state('BoostSound',{
      url:'/admin_panel/sound_boost',
      parent: 'Sidebar',
      templateUrl:'app/admin/soundBoost/soundBoost.html',
      controller:'soundBoostController'
    })
    .state('addCourseTag', {
      url: '/admin_panel/add_course_tag',
      parent: 'Sidebar',
      templateUrl: 'app/admin/courseTags/AddTags/addTags.html',
      controller: 'AddTagsController'
    })
    .state('editCourseTag', {
      url: '/admin_panel/edit_course_tag/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/courseTags/AddTags/addTags.html',
      controller: 'AddTagsController'
    })
    .state('tagUrls',{
      url:'/admin_panel/tag-urls',
      parent: 'Sidebar',
      templateUrl:'app/admin/tagUrls/tagUrls.html',
      controller:'tagUrlsController'
    })
    .state('addTagUrls', {
      url: '/admin_panel/add-tag-url',
      parent: 'Sidebar',
      templateUrl: 'app/admin/tagUrls/addTagUrls/addTagUrls.html',
      controller: 'AddTagUrlsController'
    })
    .state('editTagUrls', {
      url: '/admin_panel/edit-tag-url/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/tagUrls/addTagUrls/addTagUrls.html',
      controller: 'AddTagUrlsController'
    })
    .state('questionMarket',{
      url:'/admin_panel/question_market',
      parent: 'Sidebar',
      templateUrl:'app/admin/questionsMarket/questionsMarket.html',
      controller:'questionsMarketController'
    })
    .state('addMarket', {
      url: '/admin_panel/add_market',
      parent: 'Sidebar',
      templateUrl: 'app/admin/questionsMarket/AddMarket/AddMarket.html',
      controller: 'AddMarketController'
    })
    .state('editMarket', {
      url: '/admin_panel/edit_market/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/questionsMarket/AddMarket/AddMarket.html',
      controller: 'AddMarketController'
    })
    .state('enrollmentGroups',{
      url:'/admin_panel/enrollment_groups',
      parent: 'Sidebar',
      templateUrl:'app/admin/enrollmentGroups/enrollmentGroups.html',
      controller:'enrollmentGroupController'
    })
    .state('addEnrollmentGroup', {
      url: '/admin_panel/add_enrollment_group',
      parent: 'Sidebar',
      templateUrl: 'app/admin/enrollmentGroups/AddEnrollmentGroups/addEnrollmentGroups.html',
      controller: 'addEnrollmentGroupController'
    })
    .state('editEnrollmentGroup', {
      url: '/admin_panel/edit_enrollment_group/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/enrollmentGroups/AddEnrollmentGroups/addEnrollmentGroups.html',
      controller: 'addEnrollmentGroupController'
    })
    .state('sessions',{
      url:'/admin_panel/session',
      parent: 'Sidebar',
      templateUrl:'app/admin/session/session.html',
      controller:'sessionController'
    })
    .state('addSession', {
      url: '/admin_panel/add_session',
      parent: 'Sidebar',
      templateUrl: 'app/admin/session/addSession/addSession.html',
      controller: 'addSessionController'
    })
    .state('editSession', {
      url: '/admin_panel/edit_session/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/session/addSession/addSession.html',
      controller: 'addSessionController'
    })
    .state('adminPanelOtp', {
      url: '/admin_auth/:user_id',
      templateUrl: 'app/admin/otpPage/otpPage.html',
      controller: 'otpPageController'
    })
    .state('adminOtp', {
      url: '/admin/auth/:user_id',
      templateUrl: 'app/admin/otpPage.html',
      controller: 'adminOtpPageController'
    })
    .state('emails-in-bulk', {
      url: '/admin_panel/emails',
      parent: 'Sidebar',
      templateUrl: 'app/admin/emails/SendBulkEmails.html',
      controller: 'SendBulkEmailsController'
    })
    //AdminPanel
    .state('admin', {
      url: '/admin',
      templateUrl: 'app/admin/admin.html',
      controller: 'AdminController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load(adminDep);
        }]
      }
    })
    .state('admin_panel', {
      url: '/admin_panel',
      templateUrl: 'app/admin/SignIn/signIn.html',
      controller: 'AdminSignInController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load(adminDep);
        }]
      }
    })
    .state('deleteCourse', {
      url: '/admin_panel/course/delete/:course_id/:instructor_id',
      templateUrl: 'app/admin/DeleteCourse/deleteCourse.html',
      controller: 'DeleteCourseController'
    })
    .state('terminateOrders', {
      url: '/admin_panel/orders/terminate',
      parent: 'Sidebar',
      templateUrl: 'app/admin/terminateOrders/terminateOrders.html',
      controller: 'TerminateOrdersController'
    })
    .state('Sidebar', {
      abstract: true,
      templateUrl: 'app/admin/sidebar/sidebar.html',
      controller: 'sidebarController',
    })
    .state('AdminDashBoard', {
      url: '/admin_panel/dashboard',
      parent: 'Sidebar',
      templateUrl: 'app/admin/dashboard/dashboard.html',
      controller: 'AdminDashBoardController'
    })
    .state('AdminRepoorts', {
      url: '/admin_panel/reports',
      parent: 'Sidebar',
      templateUrl: 'app/admin/reports/reports.html',
      controller: 'AdminReportsController'
    })
    .state('AdminMergeAccounts', {
      url: '/admin_panel/merge-accounts',
      parent: 'Sidebar',
      templateUrl: 'app/admin/mergeAccounts/mergeAccounts.html',
      controller: 'MergeAccountsController'
    })
    .state('AdminOrdersManagement', {
      url: '/admin_panel/orders/management',
      parent: 'Sidebar',
      templateUrl: 'app/admin/orderManagement/orderManagement.html',
      controller: 'OrderManagementController'
    })
    .state('AdminBulkOrderUpdate', {
      url: '/admin_panel/orders/bulk-update',
      parent: 'Sidebar',
      templateUrl: 'app/admin/bulkOrderUpdate/bulkOrderUpdate.html',
      controller: 'BulkOrderUpdateController'
    })
    .state('AdminPaymentApproval', {
      url: '/admin_panel/orders/payment/approval',
      parent: 'Sidebar',
      templateUrl: 'app/admin/orderManagement/paymentApproval.html',
      controller: 'PaymentApprovalController'
    })
    .state('AdminPaymentType', {
      url: '/admin_panel/PaymentType',
      parent: 'Sidebar',
      templateUrl: 'app/admin/PaymentType/PaymentType.html',
      controller: 'PaymentTypeController'
    })
    .state('AdminReasons', {
      url: '/admin_panel/Reasons',
      parent: 'Sidebar',
      templateUrl: 'app/admin/Reasons/Reasons.html',
      controller: 'ReasonsController'
    })
    .state('AdminInstallmentOrders', {
      url: '/admin_panel/installment-orders',
      parent: 'Sidebar',
      templateUrl: 'app/admin/installmentOrders/installmentOrders.html',
      controller: 'installmentOrdersController'
    })
    .state('AdminInstallmentOrdersDetail', {
      url: '/admin_panel/installment-order-detail/:order_id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/installmentOrders/installmentOrdersDetail.html',
      controller: 'installmentOrdersDetailController'
    })
    .state('AdminCreateInstallment', {
      url: '/admin_panel/create-installment/:installment_id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/installmentOrders/createInstallment.html',
      controller: 'CreateInstallmentController'
    })
    .state('AdminCourseAccessForm', {
      url: '/admin_panel/CourseAccessForm',
      parent: 'Sidebar',
      templateUrl: 'app/admin/CourseAccessForm/CourseAccessForm.html',
      controller: 'CourseAccessFormController'
    })
    .state('AdminEditOrder', {
      url: '/admin_panel/edit_order',
      parent: 'Sidebar',
      templateUrl: 'app/admin/orderManagement/editOrder.html',
      controller: 'editOrderController'
    })
    .state('AdminCreateOrder', {
      url: '/admin_panel/create_order',
      parent: 'Sidebar',
      templateUrl: 'app/admin/orderManagement/createOrder.html',
      controller: 'createOrderController'
    })
    .state('AdminOrderEditTrail', {
      url: '/admin_panel/order_edit_trail/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/orderManagement/orderEditTrail.html',
      controller: 'orderEditTrailController'
    })
    .state('EditSubscriptions', {
      url: '/admin_panel/edit-subscriptions/:subscription_id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/subscriptions/EditSubscriptions.html',
      controller: 'EditSubscriptionsController'
    })
    .state('AddSubscriptions', {
      url: '/admin_panel/add-subscriptions',
      parent: 'Sidebar',
      templateUrl: 'app/admin/subscriptions/AddSubscriptions.html',
      controller: 'AddSubscriptionsController'
    })
    .state('Subscriptions', {
      url: '/admin_panel/subscriptions',
      parent: 'Sidebar',
      templateUrl: 'app/admin/subscriptions/Subscriptions.html',
      controller: 'SubscriptionsController'
    })
    .state('AdminPaymentAudit', {
      url: '/admin_panel/payment-audit',
      parent: 'Sidebar',
      templateUrl: 'app/admin/paymentAudit/paymentAudit.html',
      controller: 'AdminPaymentAuditController'
    })
    .state('AdminVideoQuality', {
      url: '/admin_panel/video-quality',
      parent: 'Sidebar',
      templateUrl: 'app/admin/videoQuality/videoQuality.html',
      controller: 'videoQualityController'
    })
    .state('AdminInstitution', {
      url: '/admin_panel/institition',
      parent: 'Sidebar',
      templateUrl: 'app/admin/Institution/Institution.html',
      controller: 'InstitutionController'
    })
    .state('AdminBundle', {
      url: '/admin_panel/bundle',
      parent: 'Sidebar',
      templateUrl: 'app/admin/bundle/bundle.html',
      controller: 'bundleController'
    })
    .state('AdminCreateBundle', {
      url: '/admin_panel/bundle/create',
      parent: 'Sidebar',
      templateUrl: 'app/admin/bundle/create/create.html',
      controller: 'createBundleController'
    })
    .state('AdminEditBundle', {
      url: '/admin_panel/bundle/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/bundle/create/create.html',
      controller: 'createBundleController'
    })
    .state('AdminQuizConfiguration', {
      url: '/admin_panel/quizConfiguration',
      parent: 'Sidebar',
      templateUrl: 'app/admin/quizConfigurations/quizConfigurations.html',
      controller: 'quizConfigurationsController'      
    })
    .state('AdminQuizConfigurationCreate', {
      url: '/admin_panel/quiz-configuration/create',
      parent: 'Sidebar',
      templateUrl: 'app/admin/quizConfigurations/create/create.html',
      controller: 'createController'
    })
    .state('AdminQuizConfigurationEdit', {
      url: '/admin_panel/quiz-configuration/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/quizConfigurations/create/create.html',
      controller: 'createController'
    })
    .state('AdminSeoTag', {
      url: '/admin_panel/seo-tag',
      parent: 'Sidebar',
      templateUrl: 'app/admin/seoTag/seoTag.html',
      controller: 'seoTagController'
    })
    .state('AdminFAQS', {
      url: '/admin_panel/faqs',
      parent: 'Sidebar',
      templateUrl: 'app/admin/FAQS/FAQS.html',
      controller: 'FAQSController'
    })
    .state('AdminFAQSCreate', {
      url: '/admin_panel/faqs/create',
      parent: 'Sidebar',
      templateUrl: 'app/admin/FAQS/Create/FAQSCreate.html',
      controller: 'FAQSCreateController'
    })
    .state('AdminFAQSEdit', {
      url: '/admin_panel/faqs/edit/:url',
      parent: 'Sidebar',
      templateUrl: 'app/admin/FAQS/Create/FAQSCreate.html',
      controller: 'FAQSCreateController'
    })
    .state('AdminCourseFeature', {
      url: '/admin_panel/course/feature',
      parent: 'Sidebar',
      templateUrl: 'app/admin/CourseFeature/CourseFeature.html',
      controller: 'CourseFeatureController'
    })
    .state('AdminMainCategories', {
      url: '/admin_panel/main-categories',
      parent: 'Sidebar',
      templateUrl: 'app/admin/MainCategories/MainCategories.html',
      controller: 'MainCategoriesController'
    })
    .state('AdminAddTags', {
      url: '/admin_panel/course/addtags',
      parent: 'Sidebar',
      templateUrl: 'app/admin/CourseTags/AddTags.html',
      controller: 'AddTagsController'
    })
    .state('AdminCourseTags', {
      url: '/admin_panel/course/coursetags',
      // parent: 'Sidebar',
      templateUrl: 'app/admin/CourseTags/CourseTags.html',
      controller: 'CourseTagsController'
    })
    .state('BlogComment', {
      url: '/admin_panel/blog/comments',
      parent: 'Sidebar',
      templateUrl: 'app/admin/blog/blogComments/blogComment.html',
      controller: 'BlogCommentController'
    })
    .state('Prom_open_AI_config', {
      url: '/admin_panel/prompt-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/promOpenAI/promOpenAI.html',
      controller: 'promOpenAIController'
    })
    .state('Add_prom_open_AI_config', {
      url: '/admin_panel/add-prompt-config',
      parent: 'Sidebar',
      templateUrl: 'app/admin/promOpenAI/addPromOpenAI/addPromOpenAI.html',
      controller: 'addPromOpenAIController'
    })
    .state('Edit_prom_open_AI_config', {
      url: '/admin_panel/edit-prompt-config/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/promOpenAI/addPromOpenAI/addPromOpenAI.html',
      controller: 'addPromOpenAIController'
    })
    .state('Add_prom_tag_open_AI_config', {
      url: '/admin_panel/add-prompt-tag',
      parent: 'Sidebar',
      templateUrl: 'app/admin/promOpenAI/addPromTagOpenAI/addPromTagOpenAI.html',
      controller: 'addPromTagOpenAIController'
    })
    .state('Add_prom_module_open_AI_config', {
      url: '/admin_panel/add-prompt-module/:course_id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/promOpenAI/addPromModuleOpenAI/addPromModuleOpenAI.html',
      controller: 'addPromModuleOpenAIController'
    })
    .state('SW_Tags_Questions', {
      url: '/admin_panel/sw-tags-questions',
      parent: 'Sidebar',
      templateUrl: 'app/admin/swTagsQuestions/swTagsQuestions.html',
      controller: 'swTagsQuestionsController'
    })
    .state('SW_Tags', {
      url: '/admin_panel/sw-tags',
      parent: 'Sidebar',
      templateUrl: 'app/admin/swTags/swTags.html',
      controller: 'swTagsController'
    })
    .state('ADD_SW_Tags', {
      url: '/admin_panel/add-sw-tags',
      parent: 'Sidebar',
      templateUrl: 'app/admin/swTags/addSwTags/addSwTags.html',
      controller: 'addSwTagsController'
    })
    .state('Edit_SW_Tags', {
      url: '/admin_panel/edit-sw-tags/:course_id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/swTags/addSwTags/addSwTags.html',
      controller: 'addSwTagsController'
    })
    .state('NP_SHARE', {
      url: '/admin_panel/np-share',
      parent: 'Sidebar',
      templateUrl: 'app/admin/npSharePercentage/npSharePercentage.html',
      controller: 'npSharePercentageController'
    })
    .state('ADD_NP_SHARE', {
      url: '/admin_panel/add-np-share',
      parent: 'Sidebar',
      templateUrl: 'app/admin/npSharePercentage/addNpSharePercentage/addNpSharePercentage.html',
      controller: 'addNpSharePercentageController'
    })
    .state('AdminInstructor', {
      url: '/admin_panel/instructor',
      parent: 'Sidebar',
      templateUrl: 'app/admin/instructor/instructor.html',
      controller: 'instructorController'
    })
    .state('AdminAddInstructor', {
      url: '/admin_panel/instructor/add-instructor',
      parent: 'Sidebar',
      templateUrl: 'app/admin/instructor/addInstructor/addInstructor.html',
      controller: 'addInstructorController'
    })
    .state('AdminEditInstructor', {
      url: '/admin_panel/instructor/edit-instructor/:id',
      parent: 'Sidebar',
      templateUrl: 'app/admin/instructor/addInstructor/addInstructor.html',
      controller: 'addInstructorController'
    })
    // .state('AdminEditBundle', {
    //   url: '/admin_panel/bundle/:id',
    //   parent: 'Sidebar',
    //   templateUrl: 'app/admin/bundle/create/create.html',
    //   controller: 'createBundleController'
    // })
    .state('ArchiveCourse', {
      url: '/admin_panel/archive-courses',
      parent: 'Sidebar',
      templateUrl: 'app/admin/archiveCourse/archiveCourse.html',
      controller: 'archiveCourseController'
    })

    .state('NicheDiscounts', {
      url: '/admin_panel/niches-discount',
      parent: 'Sidebar',
      templateUrl: 'app/admin/nicheDiscount/nicheDiscount.html',
      controller: 'nicheDiscountController'
    })
    .state('InBuildNotificationBar', {
      url: '/admin_panel/in-build-notification-bar',
      parent: 'Sidebar',
      templateUrl: 'app/admin/inBuildNotificationBar/inBuildNotificationBar.html',
      controller: 'inBuildNotificationBarController'
    })
    .state('HtmlPages', {
      url: '/admin_panel/html-pages',
      parent: 'Sidebar',
      templateUrl: 'app/admin/htmlPages/htmlPages.html',
      controller: 'htmlPagesController'
    })
    .state('editHtmlPage', {
      url: '/admin/edit-html-page/:id?',
      parent: 'Sidebar',
      templateUrl: 'app/admin/htmlPages/addHtmlPage/addHtmlPage.html',
      controller: 'addHtmlPagesController'
    })
    .state('addHtmlPage', {
      url: '/admin/add-html-page',
      parent: 'Sidebar',
      templateUrl: 'app/admin/htmlPages/addHtmlPage/addHtmlPage.html',
      controller: 'addHtmlPagesController'
    })
    //Instructor Sign In
    .state('instructor_signin', {
      url: '/instructor_signin',
      templateUrl: 'app/instructor_panel/instructor_signin.html',
      controller: 'InstructorSigninController'
    })
    //Instructor panel
    .state('instructor_panel', {
      templateUrl: 'app/instructor_panel/instructor_panel.html',
      controller: 'InstructorPanelController',
      abstract: true
    })
    .state('InstructorAssignments',{
      url:'/instructor_panel/assignments',
      parent: 'instructor_panel',
      templateUrl:'app/instructor_panel/assignments/assignments.html',
      controller:'instructorAssignmentsController',
    })
    .state('InstructorPanelCourseNew',{
      url:'/instructor_panel/course',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/course/course.html',
      controller: 'InstructorPanelCourseController'
    })
    .state('InstructorPanelCourseEdit',{
      url:'/instructor_panel/course/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/course/course.html',
      controller: 'InstructorPanelCourseController'
    })
    .state('InstructorPanelModuleNew',{
      url:'/instructor_panel/module',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/module/module.html',
      controller: 'InstructorPanelModuleController'
    })
    .state('InstructorPanelModuleEdit',{
      url:'/instructor_panel/module/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/module/module.html',
      controller: 'InstructorPanelModuleController'
    })
    .state('InstructorPanelChapterNew',{
      url:'/instructor_panel/chapter',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/chapter/chapter.html',
      controller: 'InstructorPanelChapterController'
    })
    .state('InstructorPanelChapterEdit',{
      url:'/instructor_panel/chapter/:id/:module_id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/chapter/chapter.html',
      controller: 'InstructorPanelChapterController'
    })
    .state('InstructorPanelVideo',{
      url:'/instructor_panel/video/:state/:id/:module_id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/video/video.html',
      controller: 'InstructorPanelVideoController'
    })
    .state('InstructorPanelTransactions',{
      url: '/instructor_panel/transactions',
      parent:'instructor_panel',
      templateUrl: 'app/instructor_panel/transaction/transaction.html',
      controller: 'InstructorPanelTransactionController'
    })

    .state('InstructorPanelComments',{
      url: '/instructor_panel/comments',
      parent:'instructor_panel',
      templateUrl: 'app/instructor_panel/comments/comments.html',
      controller: 'InstructorPanelCommentsController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://vjs.zencdn.net/7.8.3/video-js.css',
            // 'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.css',
            'https://ajax.googleapis.com/ajax/libs/shaka-player/3.0.1/controls.css',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.css',
            
          ]);
        }]
      }
    })
    .state('InstructorPanelDashboard',{
      url: '/instructor_panel/dashboard',
      parent:'instructor_panel',
      templateUrl: 'app/instructor_panel/dashboard/dashboard.html',
      controller: 'InstructorPanelDashboardController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://vjs.zencdn.net/7.8.3/video-js.css',
            // 'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.css',
            'https://ajax.googleapis.com/ajax/libs/shaka-player/3.0.1/controls.css',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.css',
            
          ]);
        }]
      }
    })
    .state('InstructorPanelAllCourses',{
      url: '/instructor_panel/courses',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/allCourses/allCourses.html',
      controller: 'InstructorPanelAllCoursesController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://vjs.zencdn.net/7.8.3/video-js.css',
            // 'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.css',
            'https://ajax.googleapis.com/ajax/libs/shaka-player/3.0.1/controls.css',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.css',
            
          ]);
        }]
      }
    })
    .state('InstructorPanelEnrolledStudents',{
      url: '/instructor_panel/enrolled_students',
      parent:'instructor_panel',
      templateUrl: 'app/instructor_panel/enrolled/enrolled.html',
      controller: 'InstructorPanelEnrolledController'
    })
    .state('InstructorPanelQuizDashboard',{
      url: '/instructor_panel/quizzes',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/quiz/quizDashboard.html',
      controller: 'InstructorPanelQuizDashboardController'
    })
    .state('InstructorPanelQuizNew',{
      url: '/instructor_panel/quizzes/create',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/quiz/quiz.html',
      controller: 'InstructorPanelQuizController'
    })
    .state('InstructorPanelCoursesQuizzes',{
      url: '/instructor_panel/CoursesQuizzes/coursesQuizzes',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/QuizResult/coursesQuizzes.html',
      controller: 'coursesQuizzesController'
    })
    .state('InstructorPanelStudentsQuestions',{
      url: '/instructor_panel/Questions/studentsQuestions',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/questions/questions.html',
      controller: 'questionsController'
    })

    .state('InstructorPanelQuizOutCome',{
      url: '/instructor_panel/CourseQuiz/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/QuizResult/outComeQuiz.html',
      controller: 'outComeQuizController'
    })

    .state('InstructorPanelQuizEdit',{
      url: '/instructor_panel/quizzes/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/quiz/quiz.html',
      controller: 'InstructorPanelQuizController'
    })
    .state('InstructorPanelQuizUserDetail',{
      url: '/instructor_panel/quizzes/result/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/QuizResult/resultAllUser.html',
      controller: 'InstructorPanelQuizUserDetailController'
    })
    .state('InstructorPanelMyProfile',{
      url: '/instructor_panel/myprofile',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/myprofile/myprofile.html',
      controller: 'InstructorPanelMyProfileController'
    })
    .state('InstructorPanelLiveSession',{
      url: '/instructor_panel/live-session',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/liveSession/liveSession.html',
      controller: 'InstructorPanelLiveSessionController'
    })
    .state('InstructorPanelDuplicateVideo',{
      url: '/instructor_panel/duplicate-video',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/DuplicateVideo/DuplicateVideo.html',
      controller: 'DuplicateVideoController'
    })
    .state('InstructorPanelNewLiveSession',{
      url: '/instructor_panel/new-live-session',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/liveSession/newLiveSession/newLiveSession.html',
      controller: 'InstructorPanelNewLiveSessionController'
    })
    .state('InstructorPanelEditLiveSession',{
      url: '/instructor_panel/edit-live-session/:id',
      parent: 'instructor_panel',
      templateUrl: 'app/instructor_panel/liveSession/newLiveSession/newLiveSession.html',
      controller: 'InstructorPanelNewLiveSessionController'
    })
    .state('AllCourses', {
      url: '/courses',
      parent: 'Header',
      templateUrl: 'app/courses/allcourses.html',
      controller: 'allCourseController',
    })
    .state('SAT',{
      url: '/sat',
      parent: 'Header',
      templateUrl: 'app/sat/sat.html',
      controller: 'SATController'
    })
    .state('MDCAT-2018',{
      url: '/mdcat-test-preparation-2018',
      parent: 'Header',
      templateUrl: 'app/mdCat/mdCat.html',
      controller: 'mdCatController'
    })
    .state('MDCAT',{
      url: '/mdcat-test-preparation',
      parent: 'Header',
      templateUrl: 'app/mdCat/mdCat.html',
      controller: 'mdCatController'
    })
    .state('MDCATPayment',{
      url: '/how-to-buy-mdcat',
      parent: 'Header',
      templateUrl: 'app/mdCatPayment/mdcatpayment.html',
      controller: 'mdPaymentController'
    })
    .state('CSS-2018',{
      url: '/css-test-preparation-2018',
      parent: 'Header',
      templateUrl: 'app/css/css.html',
      controller: 'cssController'
    })
    .state('CSS',{
      url: '/css-test-preparation',
      parent: 'Header',
      templateUrl: 'app/css/css.html',
      controller: 'cssController'
    })
    .state('CAStatic',{
      url: '/chartered-accountancy-final',
      parent: 'Header',
      templateUrl: 'app/CA/cp.html',
      controller: 'CPController'
    })
    //InstructorStatic
    .state('instructer', {
      url: '/instructor',
      parent: 'Header',
      templateUrl: 'app/Home/instructer.html',
      controller: 'HomeController'
    })
    //Quiz Page
    .state('quiz',{
      url: '/quiz/:quiz_id',
      parent: 'Header',
      templateUrl: 'app/quiz/quiz.html',
      controller: 'quizController'
    })
    //Result Page
    .state('result',{
      url: '/result/:resultId',
      parent: 'Header',
      templateUrl: 'app/result/result.html',
      controller: 'resultController'
    })
    .state('courseResult',{
      url: '/result/course/:id',
      parent: 'Header',
      templateUrl: 'app/result/courseResult.html',
      controller: 'resultController'
    })
    //All Course
    .state('instructor',{
      url: '/instructor/:instructorName',
      parent: 'Header',
      templateUrl: 'app/courses/instructor.html',
      controller: 'InstructorController'
    })
    //Tag Courses
    .state('tagCourses', {
      url: '/tag-courses/:tag_index_url',
      parent: 'Header',
      templateUrl: 'app/courses/tagCourses.html',
      controller: 'tagCoursesController'
    })
    //School
    .state('schools', {
      url: '/:institutionName',
      parent: 'Header',
      templateUrl: 'app/courses/schools.html',
      controller: 'schoolController'
    })
    //Listing
    .state('listing', {
      url: '/:institutionName/:schoolName',
      parent: 'Header',
      templateUrl: 'app/courses/listing.html',
      controller: 'courseController'
    })
     //Course
     .state('CourseBuy', {
      url: '/buy-now/:institutionName/:schoolName/:courseName',
      parent: 'Header',
      templateUrl: 'app/courses/product.html',
      controller: 'courseDetailController'
    })
    //Course
    .state('Course', {
      url: '/:institutionName/:schoolName/:courseName',
      parent: 'Header',
      templateUrl: 'app/courses/product.html',
      controller: 'courseDetailController'
    })
    //Course Module
    .state('course_module_buy', {
      url: '/buy-now/:institutionName/:schoolName/:courseName/:moduleNo',
      parent: 'Header',
      templateUrl: 'app/courses/modules.html',
      controller: 'moduleDetailController'
    })
    //Course Module
    .state('course_module', {
      url: '/:institutionName/:schoolName/:courseName/:moduleNo',
      parent: 'Header',
      templateUrl: 'app/courses/modules.html',
      controller: 'moduleDetailController'
    })
    .state('video_player', {
      url: '/:institutionName/:schoolName/:courseName/:moduleNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/player.html',
      controller: 'playerController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            './js/dash.all.min.js',
            './js/videojs-dash.min.js',
          ]);
        }]
      }
    })
    .state('video_player_chapter', {
      url: '/:institutionName/:schoolName/:courseName/:moduleNo/:chapterNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/player.html',
      controller: 'playerController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            './js/dash.all.min.js',
            './js/videojs-dash.min.js',
          ]);
        }]
      }
    })
    .state('videojs_player', {
      url: '/player/videojs/:institutionName/:schoolName/:courseName/:moduleNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/playervideojs.html',
      controller: 'playerVideojsController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://vjs.zencdn.net/7.8.3/video-js.css',
            // 'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.css',
            'https://ajax.googleapis.com/ajax/libs/shaka-player/3.0.1/controls.css',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.css',
            'https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-quality-levels/2.0.8/videojs-contrib-quality-levels.min.js',
            'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.min.js',
            './js/dash.all.min.js',
            './js/videojs-dash.min.js',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.min.js',
            'https://vjs.zencdn.net/7.8.3/video.min.js'
          ]);
        }]
      }
    })
    .state('videojs_player_chapter', {
      url: '/player/videojs/:institutionName/:schoolName/:courseName/:moduleNo/:chapterNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/playervideojs.html',
      controller: 'playerVideojsController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://vjs.zencdn.net/7.8.3/video-js.css',
            // 'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.css',
            'https://ajax.googleapis.com/ajax/libs/shaka-player/3.0.1/controls.css',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.css',
            'https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-quality-levels/2.0.8/videojs-contrib-quality-levels.min.js',
            'https://unpkg.com/videojs-max-quality-selector/dist/videojs-max-quality-selector.min.js',
            './js/dash.all.min.js',
            './js/videojs-dash.min.js',
            'https://cdn.jsdelivr.net/npm/videojs-seek-buttons/dist/videojs-seek-buttons.min.js',
            'https://vjs.zencdn.net/7.8.3/video.min.js'
          ]);
        }]
      }
    })
    .state('vimeo_player', {
      url: '/vvs/player/:institutionName/:schoolName/:courseName/:moduleNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/playerVimeo.html',
      controller: 'playerVimeoController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://player.vimeo.com/api/player.js',
            './js/videojs-dash.min.js',
          ]);
        }]
      }
    })
    .state('vimeo_player_chapter', {
      url: '/vvs/player/:institutionName/:schoolName/:courseName/:moduleNo/:chapterNo/:video_no',
      parent: 'Header',
      templateUrl: 'app/player/playerVimeo.html',
      controller: 'playerVimeoController',
      resolve: {
        loadMyService: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            'https://player.vimeo.com/api/player.js',
            './js/videojs-dash.min.js',
          ]);
        }]
      }
    })
    
  });
})();


(function() {
  'use strict';

  angular
  .module('NearPeer')
  .config(function($httpProvider,$analyticsProvider,$sailsProvider) {
    //$analyticsProvider.virtualPageviews(false);
    $httpProvider.defaults.useXDomain = true;
    // delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
    $httpProvider.interceptors.push('httpRequestInterceptor');
    // $httpProvider.defaults.withCredentials = true;
    if(location.host == 'localhost:3001')
    $sailsProvider.url = 'http://localhost:3003';
    else if (location.host == 'dev.nearpeer.org')
    $sailsProvider.url = 'https://devbackend.nearpeer.org';
    else if (location.host == 'staginglmsfrontend.nearpeer.org')
    $sailsProvider.url = 'https://devbackend.nearpeer.org';
    else if (location.host == 'test.nearpeer.org')
    $sailsProvider.url = 'https://devbackend.nearpeer.org';
    else if(location.host == 'www.nearpeer.org')
    $sailsProvider.url = 'https://velocitynearpeerbackend.nearpeer.org'
    else
    $sailsProvider.url = 'https://velocitynearpeerbackend.nearpeer.org'
  });
})();

(function() {

  angular.module('NearPeer')
  
  .factory('Global',Global);

 
  /* @ngInject */

  function Global($log,$rootScope) {

    $log.debug('Inside Global Service');

    var globalService;

 
    globalService = {

      rootScope: rootScope,

      setInRootScope: setInRootScope

    };


    return globalService;

  
    function rootScope() {

      if($rootScope.varStack ===undefined) {

        $rootScope.varStack ={};

      }

      return $rootScope.varStack;

    }

  
    function setInRootScope(key,object) {
      rootScope()[key]=object;
      $rootScope.$emit("route_updated", {});
    }

  }

})();
angular.module("constants", [])

.constant("env", {
	"videoMigrationMicroServicePath": "https://devuploading.nearpeer.org/",
	"gatewayServerPath": "s3totovimeomigration/v1/",
	"velocityPortal": "https://lms.nearpeer.org",
	"quizCenter": "https://devquiz.nearpeer.org",
	"authService": "https://devapigateway.nearpeer.org/authservice/",
	"reportsService": "https://devapigateway.nearpeer.org/reportservice/",
	"notificationService": "https://devapigateway.nearpeer.org/notificationservice/v1",
	"backendService": "https://devapigateway.nearpeer.org",
	"bunnyApiKey": "b3c89192-ab09-4d9e-99dae5adc65f-6c6b-4769",
	"bunnyVideoLibraryId": "472079",
	"bunnyEmbedTokenKey": "487d97e3-bd4c-4ef5-8ac1-bb8f66234ec7",
	"bunnyStorageZoneName": "vz-352754c5-5d5",
	"bunnyStorageAccessKey": "dd954b7b-e857-4479-97cf295e61f8-1ffa-489f"
})

;
(function () {
  angular
    .module("NearPeer")

    .factory("BreadcrumbService", BreadcrumbService);

  /* @ngInject */

  function BreadcrumbService(Global, $log, $rootScope) {
    var breadcrumbService,
      defaultBreadCrumb = {
        list: [
          {
            url: "/landing", // replace your root URL
            displayName: "ROOT",
          },
        ],
        last: "LEAF",
      };

    breadcrumbService = {
      getBreadCrumb: getBreadCrumb,

      setBreadCrumb: setBreadCrumb,
      getBreadCrumbCategoryName: getBreadCrumbCategoryName,
    };


    return breadcrumbService;

    function getBreadCrumbCategoryName (institution) {
      var host = window.location.protocol + "//" + window.location.host;
      institution = institution.toLowerCase();
      var bcData = {
        'chartered-accountancy-final': {displayName: 'CA', url: host + '/chartered-accountancy-final'},
        'acca': {displayName: 'ACCA', url: host + '/acca/acca-online'},
        'entry-test-preparation': {displayName: 'MDCAT', url: host + '/entry-test-preparation'},
        'entry-test': {displayName: 'Entry Test', url: host + '/entry-test'},
        'issb': {displayName: 'ISSB', url: host + '/ISSB'},
        'css': {displayName: 'CSS', url: host + '/css'},
        'english': {displayName: 'English', url: host + '/english'},
        'one paper': {displayName: 'Govt Jobs', url: host + '/one%20paper'},
        'punjab-board': {displayName: 'Punjab Board', url: host + '/punjab-board'},
        'federal-board': {displayName: 'Federal Board', url: host + '/federal-board'},
        'lums': {displayName: 'Federal Board', url: host + '/federal-board'},//for federal board case
      }
      return bcData[institution];
    }

    function getBreadCrumb() {
      return Global.rootScope().breadcrumb;
    }

    function setBreadCrumb(breadcrumb, last) {
      var breadcrumbTemplate = getBreadCrumbTemplate(last);
      if (breadcrumb !== undefined) {
        if ((breadcrumb && breadcrumbTemplate.last=='child' && last=='child') || (breadcrumb && breadcrumbTemplate.last=='category' && last=='category') || (breadcrumb && breadcrumbTemplate.last=='LEAF' && last=='LEAF')) {
          breadcrumbTemplate.list.pop();
          breadcrumbTemplate.list.push(breadcrumb);
        } else if((breadcrumb && breadcrumbTemplate.last=='child' && last=='category') || (breadcrumb && breadcrumbTemplate.last=='category' && last=='LEAF') ){
          breadcrumbTemplate.list.pop();
          breadcrumbTemplate.list.pop();
          breadcrumbTemplate.list.push(breadcrumb);
        }
        else{
          breadcrumbTemplate.list.push(breadcrumb);
        }
      }

      if (last !== undefined) {
        breadcrumbTemplate.last = last;
      }

      Global.setInRootScope(
        "breadcrumb",
        breadcrumbTemplate || defaultBreadCrumb
      );
    }

    //Private functions

    function getBreadCrumbTemplate(level) {
      var bcList = Global.rootScope();
      if ((level === 'child' || level === 'category') && bcList && bcList.breadcrumb && bcList.breadcrumb.list) {
        return bcList.breadcrumb;
      } else {
        return {
          list: [
            {
              url: "/landing", // replace your root URL

              displayName: "Nearpeer.org ",
            },
          ],
          last: "ROOT",
        };
      }
    }
  }
})();

angular.module("NearPeer").run(["$templateCache", function($templateCache) {$templateCache.put("app/index.html","<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html ng-app=NearPeer xmlns=http://www.w3.org/1999/xhtml><head><base href=/ ><meta charset=utf-8><title> <%= title %></title><meta http-equiv=Cache-Control content=no-cache><meta http-equiv=Pragma content=no-cache><meta http-equiv=Expires content=0><meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"><meta name=viewport content=\"width=device-width,initial-scale=1\"><meta property=fb:app_id content=101912270291064><meta name=description content=\"<%= description %>\"><link name=canonical rel=\"<%= url %>\"><meta property=og:title content=\"<%= title %>\"><meta property=og:description content=\"<%= description %>\"><meta property=og:url content=\"<%= url %>\"><meta property=og:site_name content=\"<%= site_name %>\"><meta property=og:image content=\"<%= image_url %>\"><meta name=twitter:card content=summary_large_image><meta name=twitter:site content=@Nearpeer><meta name=twitter:title content=\"<%= title %>\"><meta name=twitter:description content=\"<%= description %>\"><meta name=twitter:image content=\"<%= image_url %>\"><link href=https://vjs.zencdn.net/7.8.3/video-js.css rel=stylesheet><!-- If you\'d like to support IE8 (for Video.js versions prior to v7) --><script src=https://vjs.zencdn.net/ie8/1.1.2/videojs-ie8.min.js></script><!-- <script>\n	(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n	})(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n	ga(\'create\', \'UA-83214133-1\', \'auto\');\n	</script> --><!-- Global site tag (gtag.js) - Google Analytics --><script src=https://cdn.onesignal.com/sdks/OneSignalSDK.js async></script><script>var OneSignal = window.OneSignal || [];\n  OneSignal.push(function() {\n    OneSignal.init({\n      appId: \"b7d73687-05ed-4061-88e1-b7f495a570af\",\n    });\n  });</script><script async src=\"https://www.googletagmanager.com/gtag/js?id=G-HYZH1QV1YV\"></script><script>window.dataLayer = window.dataLayer || [];\n	function gtag(){dataLayer.push(arguments);}\n	gtag(\'js\', new Date());\n\n	gtag(\'config\', \'UA-83214133-1\');\n	gtag(\'config\', \'AW-829926847\');\n  gtag(\'config\', \'G-HYZH1QV1YV\');</script><!--  <script>\n	(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n	(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n	m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n})(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n\nga(\'create\', \'UA-84777605-1\', \'auto\');\n\n</script> --><!-- Facebook Pixel Code --><script>var url = \'https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?91804\';\n    var s = document.createElement(\'script\');\n    s.type = \'text/javascript\';\n    s.async = true;\n    s.src = url;\n    var options = {\n  \"enabled\":true,\n  \"chatButtonSetting\":{\n      \"backgroundColor\":\"#4dc247\",\n      \"ctaText\":\"\",\n      \"borderRadius\":\"25\",\n      \"marginLeft\":\"0\",\n      \"marginBottom\":\"50\",\n      \"marginRight\":\"50\",\n      \"position\":\"right\"\n  },\n  \"brandSetting\":{\n      \"brandName\":\"Nearpeer\",\n      \"brandSubTitle\":\"Typically replies within 1 hour\",\n      \"brandImg\":\"https://yt3.ggpht.com/ytc/AAUvwniBZPic-A6dzZyM6m7bexOk6fU5kwz7aG6OX-DJ=s900-c-k-c0x00ffffff-no-rj\",\n      \"welcomeText\":\"Hi, there!\\nHow can I help you?\",\n      \"backgroundColor\":\"#0a5f54\",\n      \"ctaText\":\"Start Chat\",\n      \"borderRadius\":\"25\",\n      \"autoShow\":false,\n      \"phoneNumber\":\"923111444734\"\n  }\n};\n    s.onload = function() {\n        CreateWhatsappChatWidget(options);\n    };\n    var x = document.getElementsByTagName(\'script\')[0];\n    x.parentNode.insertBefore(s, x);</script><script>!function(f,b,e,v,n,t,s)\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n	n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\n	n.queue=[];t=b.createElement(e);t.async=!0;\n	t.src=v;s=b.getElementsByTagName(e)[0];\n	s.parentNode.insertBefore(t,s)}(window, document,\'script\',\n	\'https://connect.facebook.net/en_US/fbevents.js\');\n	fbq(\'init\', \'435351506866606\');\n	fbq(\'track\', \'PageView\');</script><noscript><img height=1 width=1 style=display:none src=\"https://www.facebook.com/tr?id=435351506866606&ev=PageView&noscript=1\"></noscript><!-- End Facebook Pixel Code --><script src=https://platform.twitter.com/widgets.js></script><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- concatenated flow.js + ng-flow libraries --><!-- or include the files separately --><link rel=stylesheet href=styles/vendor-74e83aa204.css><link rel=stylesheet href=styles/app-38b324168e.css><!-- Google Tag Manager --><script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n    new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,\'script\',\'dataLayer\',\'GTM-MZ229VL\');</script><!-- End Google Tag Manager --></head><body ng-class=\"{\'white-bg\':userSide, \'gray-bg\':adminSide}\" id=mainBody><!-- Google Tag Manager (noscript) --><noscript><iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-MZ229VL\" height=0 width=0 style=display:none;visibility:hidden></iframe></noscript><!-- End Google Tag Manager (noscript) --><div id=wrapper><!-- Facebook Comment Settings --><div id=fb-root></div><script>window.fbAsyncInit = function() {\n				FB.init({\n					appId      : \'101912270291064\',\n					xfbml      : true,\n					version    : \'v2.8\'\n				});\n				FB.AppEvents.logPageView();\n			};\n				\n			(function(d, s, id){\n				var js, fjs = d.getElementsByTagName(s)[0];\n				if (d.getElementById(id)) {return;}\n				js = d.createElement(s); js.id = id;\n				js.src = \"https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js\";\n				fjs.parentNode.insertBefore(js, fjs);\n			}(document, \'script\', \'facebook-jssdk\'));</script><!--[if lt IE 10]>\n		<p class=\"browsehappy\">You are using an <strong>outdated</strong> browser. Please <a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your experience.</p>\n		<![endif]--><div ui-view ng-class=\"{\'white-bg\':userSide, \'gray-bg\':adminSide}\" class=\"col-md-12 col-lg-12 padding0\" id=adminpanel></div><div ng-if=fbShow class=fb-customerchat attribution=setup_tool page_id=167671470250425 theme_color=#0084ff logged_in_greeting=\"Hi! How can we help you?\" logged_out_greeting=\"Hi! How can we help you?\"></div><script src=scripts/vendor-c85f5b3c39.js></script><script src=scripts/app-455c319bb8.js></script></div><script src=https://vjs.zencdn.net/7.8.3/video.js></script><script src=./dash.all.min></script><script src=./videojs-dash.min></script></body></html>");
$templateCache.put("app/404/notfound.html","<div style=\"margin-top: 20%;margin-left:35%\"><h1 style=\"color:#0f3b5e; font-size:50px\">Page Not Found</h1><button type=button ui-sref=Landing class=\"btn btn-primary\" style=\"margin-left: 15%\">Go To Home</button></div><div style=margin-top:10%></div>");
$templateCache.put("app/CA/cp.html","<div class=cp-cont><!-- <div class=\"cp-banner cp-cont-hide\">\r\n    <div class=\"container\">\r\n      <div class=\"cp-box\">\r\n        <h1>Online CA courses by the Best Faculty</h1>\r\n        <h3> prepare effeciently, 24/7</h3>\r\n        <form>\r\n          <img src=\"images/search-loader.gif\" ng-show=\"searchLoader\">\r\n          <input type=\"text\" placeholder=\"Search for course or lecturer\" ng-blur=\"hideSearchOpen($event)\" id=\"searchStr\" autocomplete=\"off\"\r\n          />\r\n          <div class=\"search-open\" ng-show=\"searchOpen\">\r\n            <span ng-show=\"noResult\">No result found</span>\r\n            <ul>\r\n              <li ng-repeat=\"searchCourseResult in searchCourseResults\" ng-click=\"goToCourse(searchCourseResult)\">\r\n                <img ng-src={{searchCourseResult.image_url}} alt=\"\" />\r\n                <h1>{{searchCourseResult.name}} </h1>\r\n                <p>{{searchCourseResult.instructor}}</p>\r\n              </li>\r\n              <li ng-repeat=\"searchVideoResult in searchVideoResults\" ng-click=\"goToVideo(searchVideoResult)\">\r\n                <img ng-src={{searchVideoResult.image_url}} alt=\"video image\" />\r\n                <h1>{{searchVideoResult.name}} </h1>\r\n                <p>{{searchVideoResult.moduleName}} | {{searchVideoResult.courseName}}</p>\r\n              </li>\r\n            </ul>\r\n\r\n          </div>\r\n          <button id=\"ca-search-button\"></button>\r\n        </form>\r\n\r\n        <ul>\r\n          <li>Over 300 CA-Final Students</li>\r\n          <li>Taught by the best Instructors</li>\r\n          <li>Learn at your pace on any device</li>\r\n        </ul>\r\n\r\n      </div>\r\n\r\n    </div>\r\n  </div> --><div class=filter-bar><div class=container><div class=col-md-12><div class=filter-tabs><div class=btn-group><button class=\"btn btn-default btn-lg dropdown-toggle visible-xs\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{currentState || \'Select category\'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=\"dropdown-menu filter-dopmenu\"><li ng-class=\"{current: currentState==\'All\'}\" ng-click=getAllCourses();>ALL</li><li ng-class=\"{current: currentState==tag.course_tag}\" ng-repeat=\"tag in tags\" ng-click=getSearchCourses($index);>{{tag.course_tag}}</li></ul></div></div><div class=filter-dropdown><div class=btn-group><button class=\"btn btn-default btn-lg dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{courseType ||\'Course Type\'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=dropdown-menu><li><a ng-click=\"getSearchCoursesType(\'All\');\">All</a></li><li><a ng-click=\"getSearchCoursesType(\'Crash\');\">Crash</a></li><li><a ng-click=\"getSearchCoursesType(\'Full\');\">Full</a></li><li><a ng-click=\"getSearchCoursesType(\'Smart\');\">Smart</a></li></ul></div><div class=\"btn-group sortby-filter\"><button class=\"btn btn-default btn-lg dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{ sortingName || \' Sort By \'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=dropdown-menu><li ng-click=\"getSorting(\'name\',\'Name\');\">Name</li><li ng-click=\"getSorting(\'avg_rating\',\'Popularity\');\">Popularity</li><li ng-click=\"getSorting(\'price\',\'Price Highest to Lowest\');\">Price Highest to Lowest</li><li ng-click=\"getSorting(\'-price\',\'Price Lowest to Highest\');\">Price Lowest to Highest</li></ul></div><div class=btn-group><faqs-video institution=institution showbutton=showbutton></faqs-video></div></div></div></div></div><!-- filter-bars --><course-blocks courses=courses></course-blocks><div class=pricing-cp><div class=container><div class=pricing-cp-left><div class=col-md-3><img src=images/rs-img.png alt=\"\"></div><div class=col-md-6><h3>Price of the course</h3><h4>To view a detail break down of the pricing plan</h4></div><div class=col-md-3><div class=plans-buttons><!-- <a ng-click=\"showPricePlans()\">CLICK HERE</a> --> <button type=button class=\"btn btn-info\" data-toggle=modal data-target=#CoursePricePlan>Click Here</button></div></div></div></div></div><div class=\"col-md-12 video-CAF\"><div class=container><div class=\"col-xs-12 col-md-6\"><video poster=images/thumnail.png id=video src=https://s3-us-west-2.amazonaws.com/nearpeer-imagees/Nearpeer_CA_final_portfolio_video.mp4 style=\"width: 100%;height: auto;border-radius: 4px;border: 1px solid #ccc\"></video><div class=CA-play-button><div class=play-Icon-ca><img src=images/play-cont.png ng-show=paused ng-click=playVid()></div><div class=pause-Icon-ca><img src=images/pause-icon.png ng-show=played ng-click=pauseVid()></div></div></div><div class=\"col-xs-12 col-md-6\"><h1>Why take it online</h1><ul><li>Courses Offered by the best instructors</li><li>Online Pre-recorded Video Courses</li><li>Watch Anytime, Anywhere</li><li>Study at your own schedule</li><li>Downloadable handouts</li><li>Get questions answered online</li><li>Engage with large online community</li></ul></div></div></div><div class=complete-revision><div class=container><ul><li><img src=images/complete-revision-1.png alt=\"\"><p>Complete revision Comprehensive course coverage</p></li><li><img src=images/complete-revision-2.png alt=\"\"><p>Tips and Techniques on exam preparation</p></li><li><img src=images/complete-revision-3.png alt=\"\"><p>Past Papers analysis highlighting important topics</p></li></ul></div></div><div class=instructors-slider><h1 class=text-center>Instructors</h1><div class=\"container slider\"><div class=slide-cont><div ng-repeat=\"instructor in instructors\" class=\"slidee slide-animation\" ng-hide=!isCurrentSlideIndex($index)><div class=slide-img><img ng-src={{instructor.picture}}></div><div class=slide-info><h2>{{instructor.name}}</h2><p>{{instructor.qualification}}</p><p>Experience : {{instructor.experience}}</p><p>{{instructor.description}}</p></div></div><a class=\"arrow prev\" ng-click=nextSlide()>n</a> <a class=\"arrow next\" ng-click=prevSlide()>p</a><nav class=nav><div class=wrapper><ul class=dots><li class=dot ng-repeat=\"slide in slides\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);>{{slide.description}}</a></li></ul></div></nav></div></div></div><!-- Price Sheet Modal --><div id=CoursePricePlan class=\"modal fade\" role=dialog><!-- Modal --><div class=modal-dialog><!-- Modal content--><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal>&times;</button><h4 class=modal-title>Prices of the Courses</h4></div><div class=modal-body><img src=images/ca-prices-sheet-new-3.png></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button></div></div></div></div><div class=poppup-cp ng-show=popup><div class=poppop-content-price><div class=closee ng-click=close()>X</div><div class=poppop-content><img src=images/new_pricing_table.jpg></div></div><div class=poppup-cp ng-show=advancePayment><div class=poppop-content><div class=closee ng-click=close()>X</div><img src=\"images/How to Pay Popup-edited.jpg\"></div></div><div class=poppup-cp ng-show=popup2><div class=poppop-content><div class=closee ng-click=close()>X</div><img src=\"images/Pop up how to pay.jpg\"></div></div></div></div>");
$templateCache.put("app/FaqsVideo/faqsVideo.html","<div id=faqsVideo class=\"modal fade\" role=dialog><!-- Modal --><div class=modal-dialog><!-- Modal content --><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true>&times;</button><h3 style=text-align:center class=modal-title>A Quick Guide</h3></div><div class=modal-body><div class=\"modal-body padding0\" id=yt-player></div></div><div class=modal-footer><button class=btn-orange data-dismiss=modal ng-click=learnMore()>Learn More</button> <button class=btn-empty data-dismiss=modal aria-hidden=true>Close</button></div></div></div></div><div><button ng-show=showbutton.show class=\"btn btn-default\" data-toggle=modal ng-click=\" showModal()\" style=text-align:center>Need Help?</button></div>");
$templateCache.put("app/Landing/landing.html","<div class=landing-new ng-class=\"{centerDiv:  stories.length == 0}\"><div class=story-list ng-if=\"stories && stories.length !==0\"><ul><li ng-repeat=\"story in stories track by $index\" ng-click=\"openStoryPopup(story.id , $index,story.title, story.media_id)\"><div class=story-avatar><img ng-src=\"{{story.thumbnail ? story.thumbnail : story.image}}\" alt=\"\"> <svg height=100 width=100 view-box=\"0 0 100 100\"><g rotation=-90 origin-x=90 origin-y=90><circle ng-repeat=\"element in story.storyStatusData\" cx=50 cy=50 r={{element.radius}} stroke={{element.color}} fill=transparent stroke-width=3.4 stroke-dasharray={{element.circleCircumference}} stroke-dashoffset={{element.strokeDashoffset}} transform=\"rotate({{element.rotation}}, 50, 50)\" origin-x=90 origin-y=90 /></g></svg></div><div class=story-name title={{story.title}}>{{story.title}}</div></li></ul></div><div class=landing-new-cont><!-- && showReactAppPopup  --><div class=free-access-react-native ng-if=\"platform_reactApp && !loggedIn\" ng-click=openFreeCourses()><img style=\"padding-left: 20px\" src=\"./../../images/Group 10171.svg\"><label>Now get access to the selected free courses and modules!!!</label></div><div class=landing-static-heading><h2>Take control of your learning today</h2><p>Study smart and study fast towards a smarter you</p></div><div class=landing-cata><ul style=\"margin-bottom: 0\"><!-- ui-sref={{category.destination}} --><li id=landingLi{{$index}} class=hover-landing ng-repeat=\"category in categories\" ng-mouseleave=revertColor() ng-mouseover=changeColor(category.color,$index)><div class=li-landing><!-- ui-sref-active=\"!platform_reactApp\" \n                        ui-sref=\"{{category.destination}}\"\n if-sref =\"!platform_reactApp\"  --> <a ui-sref={{category.destination}} ng-click=categoryChange(category)><div class=\"name-cata name-div\"><h3 class=h3-tag><li class=\"star showDot\" style=\"border-radius: 50%;\n                      width: 10px;\n                      height: 10px;\n                      border: none !important;\n                      visibility: hidden\"></li><span class=uni-icon><img src=./../../images/{{category.image}} class=icons-upper style=\"z-index: 5;\n                        transition: all 1s;\n                        transition-timing-function: cubic-bezier(\n                          0.42,\n                          0,\n                          0.58,\n                          1\n                        )\"></span></h3><h3 class=landing-category-title style=\"z-index: 5\">{{category.name}}</h3></div><p class=category-text>{{category.text}}</p><div class=\"name-cata-bottom-cont middle-line\"><div class=name-cata-bottom><h3 class=counter><span count-to=\"{{category.courses }}\" value=0 duration=1 filter=number></span></h3><p>Courses</p></div><div class=name-cata-bottom><h3 class=counter><span count-to=\"{{category.instructors }}\" value=0 duration=1 filter=number></span></h3><p>Enrollments</p></div></div></a></div><div class=li-hover><div id=spot{{$index}} class=spot><!-- <span class=\"uni-icon\"\n                ><img\n                  src=\"./../../images/{{category.image}}\"\n                  class=\"icons-upper\"\n                  style=\"\n                    z-index: 5;\n                    transition: all 1s;\n                    transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n                  \"\n              /></span> --></div></div></li></ul></div><div class=footer-landing><ul class=footer-ul><li><img src=\"./../../images/Icon ionic-ios-people (1).svg\" class=icons style=\"margin-right: 8px\">Over {{totalStudent | number}} Students</li><li><img src=\"./../../images/Icon awesome-chalkboard-teacher.svg\" class=icons style=\"margin-right: 8px\">Taught by the Best Instructors</li><li><img src=\"./../../images/Icon awesome-mobile-alt.svg\" class=icons style=\"margin-right: 8px\">Learn at Your Pace on Any Device</li></ul></div><p ui-sref=privacypolicy1 style=\"bottom: 10px;\n      margin-left: 15px;\n      margin-bottom: 0;\n      width: 100px;\n      color: white;\n      text-decoration: underline;\n      cursor: pointer\">Terms of use!</p></div></div><div class=fsc-new-bg ng-show=showPopup><!-- style=\"  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\" --><div><div style=\"position: relative\" class=fsc-logo-section><img ng-click=closeFsc() src=./../../images/np_Group.svg></div><div class=fsc-board-selection><img class=fsc-left-margin ng-click=closeFsc() src=./../../images/fsc_back.svg><label class=fsc-board-text>Please Select Your Board:</label><div></div></div><div class=fsc-main-div><div class=fsc-popup-new><div class=fsc-popup-div><div class=fsc-box-parent><div id=pitb-box class=fsc-popup-box ng-click=\"selectBoard(\'pitb\')\"><div><img id=pitb-colored class=\"pitb-color fsc-img-height\" src=./../../images/pitb_fsc.svg> <img id=pitb-white class=\"pitb-white fsc-img-height\" style=\"margin: 0 auto\" src=./../../images/pitb_fsc_white.svg></div><div class=fsc-text-div><label id=pitb-label class=fsc-popoup-big-text>Punjab Board</label><label id=pitb-label2 class=fsc-popoup-text>Valid for all boards of Punjab Province</label></div></div><!-- <div class=\"fsc-radio-web\">\n          <input type=\"radio\" name=\"board\">\n          <label style=\"margin-left: 10px;\">Punjab Board</label>\n        </div> --></div><div class=fsc-box-parent><div id=fb-box class=fsc-popup-box ng-click=\"selectBoard(\'fed\')\"><div><img id=fsc-colored class=\"fb-fsc-color fsc-img-height\" src=./../../images/fb_fsc.svg> <img id=fsc-white class=\"fb-fsc-white fsc-img-height\" style=\"margin: 0 auto\" src=./../../images/fb_fsc_white.svg></div><div class=fsc-text-div><label id=fb-label class=fsc-popoup-big-text>Federal Board</label><label id=fb-label2 class=fsc-popoup-text>Customized for Federal Board Students only</label></div></div><!-- <div class=\"fsc-radio-web\">\n    <input type=\"radio\" name=\"board\">\n    <label style=\"margin-left: 10px;\">Federal Board</label>\n  </div> --></div><!-- <div class=\"fsc-radio-mob\" >\n    <div >\n      <input type=\"radio\" name=\"board\">\n      <label style=\"margin-left: 10px;\">Punjab Board</label>\n    </div>\n<div>\n  <input type=\"radio\" name=\"board\">\n  <label style=\"margin-left: 10px;\">Federal Board</label>\n</div>\n  </div> --></div><!-- <div style=\"display: flex;justify-content: center;\">\n      <button class=\"fsc-popup-next\" ng-click=\"toFsc()\" >\n        Continue\n      </button>\n    </div> --></div></div></div></div>");
$templateCache.put("app/Home/Home.html","<div class=cp-banner><div class=cp-container><div class=cp-box><div ng-hide=searchBar><div class=query-builder><div class=\"col-md-6 col\"><h1>Study at your own convenience</h1><h4>Our courses will be accessible<br>Anytime, Anywhere!</h4></div><div class=\"col-md-6 col\"><div class=\"query-form new-drop-down-home\"><div class=dropdown><button ng-disabled=!selectInst class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{selectedInstitution}} <span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item ng-click=updateInstitution($index) ng-repeat=\"institution in institutions\">{{institution.institution}}</a></div></div><div class=dropdown><button ng-disabled=!selectSchool class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{selectedSchool}} <span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item ng-repeat=\"faculty in selected_faculty\" ng-click=updateSchool($index)>{{faculty.faculty}}</a></div></div><div class=dropdown><button ng-disabled=!selectCourse class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{selectedCourse.name}} <span class=caret></span></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item ng-repeat=\"course in courses\" ng-click=updateCourse(course)>{{course.name}}</a></div></div><span class=white-btn-sub ng-click=submit() analytics-on=\"\" analytics-event=Search analytics-category=Course analytics-label=UserSearchedForCourses ng-disabled=dataEntered>PROCEED</span></div></div></div></div><div class=search-uni-search-box ng-show=searchBar><div class=search-uni><h1>Study at your own convenience</h1><h4>Our courses will be accessible Anytime, Anywhere!</h4><form><img src=images/search-loader.gif ng-show=searchLoader> <input type=text placeholder=\"Search for course or lecturer\" ng-blur=hideSearchOpen($event) id=searchStr autocomplete=off><div class=search-open ng-show=searchOpen><span ng-show=noResult>No result found</span><ul><li ng-repeat=\"searchCourseResult in searchCourseResults\" ng-click=goToCourse(searchCourseResult)><img ng-src={{searchCourseResult.image_url}} alt=\"\"><h1>{{searchCourseResult.name}}</h1><p>{{searchCourseResult.instructor}}</p></li><li ng-repeat=\"searchVideoResult in searchVideoResults\" ng-click=goToVideo(searchVideoResult)><img ng-src={{searchVideoResult.image_url}} alt=\"video image\"><h1>{{searchVideoResult.name}}</h1><p>{{searchVideoResult.moduleName}} | {{searchVideoResult.courseName}}</p></li></ul></div><button id=ca-search-button></button></form></div><div class=clearfix></div></div><div class=clearfix></div><div class=row><div class=mainfeatures><div class=col-md-4><span class=\"icon icon-student\">Over 300 CA-Final students</span></div><div class=col-md-4><span class=\"icon icon-instructors\">Taught by the best instructors</span></div><div class=col-md-4><span class=\"icon icon-learn-device\">Learn at your pace on any device</span></div><div class=clearfix></div></div></div><a class=switch-search-btn ng-click=showSearch() ng-hide=searchBar>Switch to search</a> <a class=switch-search-btn ng-click=showQueryBuilder() ng-show=searchBar>Switch to course selection</a></div><div class=clearfix></div></div></div><div class=\"partners partners-more\"><div class=container><ul><li><a target=_blank><img src=images/new-patrner-1.png alt=\"\"></a></li><li><a target=_blank><img src=images/new-patrner-2.png alt=\"\"></a></li><li><a target=_blank><img src=images/new-patrner-3.png alt=\"\"></a></li><li><a target=_blank><img src=images/new-patrner-4.png alt=\"\"></a></li></ul></div></div><course-blocks courses=topCourses></course-blocks><div class=container><div class=so-far><div class=so-far-left><img src=images/coursesanywhere.png alt=\"\"></div><div class=so-far-right><h1>Courses, Anywhere Anytime</h1><span>ON A RANGE OF DEVICES</span><p>When delivery isn\'t the problem, you can focus better on your preparation at your own convenience.</p></div></div></div><div class=powerfull id=powerfull><div class=powerfull-left><h1>One Powerful Card</h1><span>Hundreds of precious hours Optimized!</span><p>We have come up with easiest method for you to pay for course modules. Simply buy our scratch card from your university’s Tuc Shop and harness its value online!</p></div><div class=powerfull-right><img src=images/one-powerfull.png alt=\"\"></div></div><div class=container><div class=courses-designed id=Features><ul><li><h1>Courses Designed<br>Just For You</h1><p>Why waste time finding scattered & irrelevant content online when you can take courses designed as per YOUR university’s course outline?</p></li><li><h1>Learn Faster:<br>Your Time Is Worth More</h1><p>Working smart is often more fruitful than working hard in university. Learn concepts quickly & easily by taking our courses: optimized for your attention span & studying habits.</p></li><li><h1>Study At Your<br>Own Convenience</h1><p>Can’t make up to Instructor’s/TA’s office hours? Tired of restricted schedules? With our courses, accessible anywhere & anytime, we aim to help you on your own terms.</p></li><li><h1>Pay For What You<br>Need To Study</h1><p>We’ve broken each course into four equal modules so that you can choose what you want to study and pay for it only. Each module is priced at Rs. 350. The first module is<a href=# class=color-chng> free!</a></p></li></ul></div></div><div class=container><div class=\"so-far sofar-new\"><div class=\"so-far-right Sample-lecture\"><h1>A Sample Lecture</h1><span>FROM OVER 35+ COURSES</span><p>Watch a sample lecture to get a better idea of how we<br>perform and to understand our technique.</p></div><div class=\"so-far-left video\"></div></div></div><div class=partners><div class=container><h1>partners</h1><ul><li><a href=http://www.shopistan.pk/ target=_blank><img src=images/shopistan.png alt=\"\"></a></li><li><a href=http://www.sarg.pk/ target=_blank><img src=images/serg.png alt=\"\"></a></li><li><a href=http://plan9.pitb.gov.pk target=_blank><img src=images/plan.png alt=\"\"></a></li><li><a href=https://www.pitb.gov.pk/ target=_blank><img src=images/plb.png alt=\"\"></a></li><li><a href=https://lce.lums.edu.pk/ target=_blank><img src=images/lums.png alt=\"\"></a></li></ul></div></div><div class=overlay-body></div>");
$templateCache.put("app/Home/instructer.html","<div class=layout><div class=become-new><a href=https://nearpeer.typeform.com/to/XYpVmO><img src=images/applynow-1.png></a><img src=images/become.png> <a href=https://nearpeer.typeform.com/to/XYpVmO><img src=images/applynow-2.png></a></div></div><div class=overlay-body></div>");
$templateCache.put("app/Pages/aboutus.html","<div><section class=landing><div class=\"flex-view align-items-center\" style=\"height: 100%\"><div class=\"landing-box section-box flex-view flex-direction-row-col justify-content-between align-items-center\" style=\"position: relative\"><div class=to-win-text><div class=\"flex-view flex-direction-col\" style=\"align-items: flex-start\"><div class=\"flex-view flex-direction-col landing-desktop\"><label class=about-us-h2 style=\"position: relative\"><div class=\"wow fadeInLeft\" data-wow-delay=.2s><img class=speechmark-left style=\"position: absolute; left: -55px\" src=./../../images/about-us/speechmark-left.svg><img class=speechmark-left-mobile src=./../../images/about-us/speechmark-left-mobile.svg></div><div class=\"wow fadeInRight\" data-wow-delay=.2s>There are 3 solutions</div></label><label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=.2s>to our World\'s problems:</label><!-- <label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=\".2s\">\n                Education, Education, Education.\n              </label> --><!-- <label\n                class=\"about-us-h2 wow fadeInRight\"\n                data-wow-delay=\".2s\"\n                style=\"color: white\"\n              >\n              Education, Education, Education.\n              </label> --><label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=.2s style=\"color: white; position: relative\">Education, Education, Education. <img class=speechmark-right src=./../../images/about-us/speechmark-right.svg> <img class=speechmark-right-mobile src=./../../images/about-us/speechmark-right-mobile.svg><!-- <img\n                  class=\"doug-conant\"\n                  src=\"./../../images/about-us/Doug-Conant.svg\"\n                /> --></label></div><div class=\"flex-view flex-direction-col landing-mobile\"><label class=about-us-h2 style=\"position: relative\"><div class=\"wow fadeInLeft\" data-wow-delay=.2s><img class=speechmark-left style=\"position: absolute; left: -55px\" src=./../../images/about-us/speechmark-left.svg><img class=speechmark-left-mobile src=./../../images/about-us/speechmark-left-mobile.svg></div><div class=\"wow fadeInRight\" data-wow-delay=.2s>There are three solutions</div></label><label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=.2s>to our World\'s problems:</label><!-- <label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=\".2s\">\n                Education, Education, Education.\n              </label> --><!-- <label\n                class=\"about-us-h2 wow fadeInRight\"\n                data-wow-delay=\".2s\"\n                style=\"color: white\"\n              >\n              Education, Education, Education.\n              </label> --><label class=\"about-us-h2 wow fadeInRight\" data-wow-delay=.2s style=\"color: white; position: relative\">Education,<br>Education,<br>Education. <img class=speechmark-right src=./../../images/about-us/speechmark-right.svg> <img class=speechmark-right-mobile src=./../../images/about-us/speechmark-right-mobile.svg><!-- <img\n                  class=\"doug-conant\"\n                  src=\"./../../images/about-us/Doug-Conant.svg\"\n                /> --></label></div></div><div class=\"wow fadeInLeft\" data-wow-delay=.2s><img src=./../../images/about-us/ATF-Arrows.svg class=aboutus-arrows></div></div><div class=\"landing-backgd-img wow fadeInRight\" style=\"width: 551px; position: relative\"><div class=\"landing-props wow fadeInLeft\" data-wow-delay=.2s><img src=./../../images/about-us/Shape-elements-above-the-fold1280.svg></div><div class=mobile-landing-props><div class=triangle><img src=./../../images/about-us/hero-triangle-tablet.svg></div><div class=lines-mobile><img src=./../../images/about-us/lines-tablet.svg></div></div></div><img class=landing-circles src=./../../images/about-us/ATF-circles.svg style=\"position: absolute; bottom: -180px; left: 36px\"></div></div></section><section class=our-vision><div class=\"section-box flex-view justify-content-around flex-direction-row-col justfify-content-row-center\" style=\"align-items: center\"><div class=\"flex-view flex-direction-col aboutus-sec-title\" style=\"align-items: flex-start\" data-aos=fade-up data-aos-duration=2000 data-aos-anchor-placement=top-bottom><label class=about-us-h2>Our</label><label class=about-us-h2>Vision</label></div><div class=aboutus-sec-text style=\"width: 700px\" data-aos=fade-up data-aos-duration=1000 data-aos-anchor-placement=top-bottom><label class=about-us-h5>Started in 2016 - in a pre-pandemic world - Nearpeer aims to make quality education affordable and accessible throughout Pakistan and the Middle East using technology. We believe, everyone should have an equal opportunity to learn and grow, irrespective of their paying capacity and geographical location.</label></div></div></section><section class=meet-the-team><div class=\"section-box meet-the-team-box flex-view justify-content-between flex-direction-col\" style=\"align-items: center\"><div class=\"flex-view flex-direction-row flex-direction-row-col team-detail team-padding\" style=\"width: 100%;   justify-content: space-evenly\"><div class=\"flex-view flex-direction-col aboutus-sec-title\" style=\"align-items: flex-start\" data-aos=fade-up data-aos-duration=2000 data-aos-anchor-placement=top-bottom><label class=about-us-h2 style=\"border-bottom: 2px solid black; width: 215px\">Meet</label><label class=about-us-h2 style=\"color: var(--theme-bg)\">The Team</label></div><div class=aboutus-sec-text style=\"width: 700px\" data-aos=fade-up data-aos-duration=2000 data-aos-anchor-placement=top-bottom><label class=about-us-h5>Our team - Nearpeer Family - consists of growth-oriented young, passionate, and dynamic people who have taken the challenge of improving education in Pakistan and the MENA region. Each one of us works tirelessly to ensure our students have control of their learning. We believe it\'s the student who must decide what to learn, when to learn, how to learn, how much to learn, and how fast to learn. It helps us sleep well at night knowing we have impacted, if not thousands, at least one life today!</label></div></div><div class=\"about-us-image-div wow fadeIn\" data-wow-duration=2s data-wow-delay=.8s><div class=\"wow fadeInUp\" data-wow-duration=2s data-wow-delay=1s><img src=\"./../../images/about-us/IMG_20201110_120028-01_0000_Layer-0 1.png\"></div></div></div></section><section class=meet-the-founders style=\"position: relative\"><div class=\"flex-view flex-direction-row justify-content-around flex-direction-row-col founders-title\" style=\"width: 100%; padding: 0 0 50px; position: relative\"><div class=\"flex-view flex-direction-col\" style=\"align-items: flex-start\" data-aos=fade-up data-aos-duration=2000><!-- width: 350px --><label class=about-us-h2 style=\"border-bottom: 2px solid black; width: 215px\">The</label><label class=about-us-h2 style=\"color: var(--theme-bg)\">Founders</label></div><div style=\"width: 500px\"></div><img class=title-before-image src=./../../images/about-us/Vector.svg style=\"position: absolute; left: -18px; top: 10px\"></div><div class=\"section-box flex-view justify-content-center flex-direction-col\" style=\"align-items: center; height: 620px\"><div class=\"founder-cards-div flex-view justify-content-around flex-direction-row-col\"><div class=\"flex-view flex-direction-col founder-card\" data-aos=fade-up data-aos-duration=1000><div class=\"flex-view align-items-end\"><img src=./../../images/about-us/Frames/Ammar-Ali-Ayub.png class=img-frame><div class=\"flex-view flex-direction-col founder-title\" style=\"margin-left: 20px\"><label class=\"about-us-font-bold about-us-h3\">Ammar Ali Ayub</label><label class=about-us-body-2 style=\"color: var(--theme-bg); font-weight: 700 !important\">Co-founder | CEO | LUMS\'16</label></div></div><div class=founder-detail><label class=about-us-body-2>A celebrated instructor, self-learner, and experienced Edupreneur, Ammar has a huge fan following in the student community. He started Edtech consulting for different universities at the age of 14 and understands ins and outs of Edtech in countries like Pakistan. Under his wings, Nearpeer has attained a market leadership position in the industry and has grown from 2 people to 200+ in a very short time span.</label></div></div><div class=\"flex-view flex-direction-col founder-card\" data-aos=fade-up data-aos-duration=2000><div class=\"flex-view align-items-end\"><img src=./../../images/about-us/Frames/Shahrukh-Swati.png class=img-frame><div class=\"flex-view flex-direction-col founder-title\" style=\"margin-left: 20px\"><label class=\"about-us-font-bold about-us-h3\">Shahrukh Swati</label><label class=about-us-body-2 style=\"color: var(--theme-bg); font-weight: 700 !important\">Co-founder | COO | LUMS\'16</label></div></div><div class=founder-detail><label class=about-us-body-2>From studying in a low fee private school, a government college, and the most expensive university of Pakistan on 100% scholarship, Shahrukh has an in-depth understanding of the real-life challenges faced by the students. He is the muscle of Nearpeer, who ensures that the engine never stops.</label></div></div><div class=\"flex-view flex-direction-col founder-card\" data-aos=fade-up data-aos-duration=3000><div class=\"flex-view align-items-end\"><img src=./../../images/about-us/Frames/Umair-Latif.png class=img-frame><div class=\"flex-view flex-direction-col founder-title\" style=\"margin-left: 20px\"><label class=\"about-us-font-bold about-us-h3\">Umair Latif</label><label class=about-us-body-2 style=\"color: var(--theme-bg); font-weight: 700 !important\">Co-founder | CTO | UOL\'15</label></div></div><div class=founder-detail><label class=about-us-body-2>With a decade of technology industry experience, Umair is leading the technology at Nearpeer. Under his leadership, Nearpeer has grown into a data-driven, scalable, and sustainable Product(s) company that will always be at the forefront of providing cutting-edge tech solutions to make students\' lives easier. His user-centric approach towards the product is pushing Nearpeer to promote quality education in Pakistan and MENA region.</label></div></div></div></div></section><section class=meet-the-advisors style=\"position: relative\"><!-- <div style=\"    bottom: 200px;\nposition: absolute;\nright: -262px;\noverflow: hidden;\">\n<img src=\"./../../images/about-us/Vector (3).svg\" >\n</div> --><div class=\"section-box flex-view justify-content-center flex-direction-col\" style=\"align-items: center;z-index: 1\"><!-- <div\n        class=\"flex-view flex-direction-row justify-content-around\"\n        style=\"width: 100%; padding: 50px 0px\"\n      >\n        <div\n          class=\"flex-view flex-direction-col\"\n          style=\"align-items: flex-start; width: 350px\"\n          data-aos=\"fade-up\"\n          data-aos-duration=\"2000\"\n        >\n          <label\n            class=\"about-us-h2\"\n            style=\"border-bottom: 2px solid black; width: 350px\"\n          >\n            Our Board of\n          </label>\n          <label class=\"about-us-h2\" style=\"color: var(--theme-bg)\">\n            Advisors\n          </label>\n        </div>\n        <div style=\"width: 500px\"></div>\n      </div> --><div class=\"founder-cards-div flex-view justify-content-center flex-direction-row-col\"><div class=\"flex-view flex-direction-col\" style=\"align-items: flex-start; width: 350px\" data-aos=fade-up data-aos-duration=2000><label class=about-us-h2 style=\"border-bottom: 2px solid black; width: 350px\">Our Board of</label><label class=about-us-h2 style=\"color: var(--theme-bg)\">Advisors</label></div><div class=\"flex-view flex-direction-col founder-card\" data-aos=fade-up data-aos-duration=1000><div><img src=./../../images/about-us/Frames/Taimur-K-Bandey.png class=img-frame><div class=advisor-title><label class=\"about-us-font-bold about-us-h3\">Taimur K. Bandey</label></div></div><div><label class=about-us-body-2>Mr. Taimur is a well-known educationist and an amazing teacher for O/A\'Level and IB in Pakistan. Having linked with the education industry for more than 22 years, Mr. Taimur helps in steering Nearpeer to reach its goal of providing quality education. His expertise includes teacher training, curriculum designing, improved learning outcomes, and external partnerships.</label></div></div><!-- <div\n          class=\"flex-view flex-direction-col founder-card\"\n          data-aos=\"fade-up\"\n          data-aos-duration=\"2000\"\n        >\n          <div class=\"\">\n            <img src=\"./../../images/about-us/Frames/Tania-Aidrus.png\" class=\"img-frame\" />\n            <div class=\"advisor-title\">\n              <label class=\"about-us-font-bold about-us-h3\">Tania Aidrus</label>\n            </div>\n          </div>\n          <div>\n            <label class=\"about-us-body-2\"\n              >Ms. Tania is a well-known figure in the government, technology, and consultancy world. She has worked at Google for 12+ years in different leadership positions as a director and helped Nearpeer get its first funding round on track. She makes sure Nearpeer never loses sight of its vision and is always on track to become a regional ed-tech leader in the next 5 years.\n            </label>\n          </div>\n        </div> --></div></div><img class=title-before-image src=./../../images/about-us/Vector.svg><div class=sec-adv-beforeimg style=\"position: absolute; left: -275px; top: 9px; overflow: hidden\"><img src=\"./../../images/about-us/Vector (2).svg\"></div></section><section class=our-journey><div class=\"section-box flex-view flex-direction-col\" style=\"align-items: center\"><div class=\"flex-view flex-direction-row our-journey-title\" style=\"padding: 50px 0px\"><div class=\"flex-view flex-direction-row\" style=\"width: 350px\"><label class=about-us-h2 style=\"border-bottom: none;\n              border-right: 2px solid white;\n              color: white !important;\n              padding: 0px 20px\">Our</label><label class=about-us-h2 style=\"color: var(--theme-bg); padding: 0px 20px\">Journey</label></div></div><div class=\"timeline flex-view justify-content-around flex-direction-col\" style=\"width: 100%; height: 100%\"><div class=\"our-journey-tabs wow fadeIn\" data-wow-duration=2s><div class=\"flex-view justify-content-around journey-icons tabs-wrapper\"><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'idea\')\" ng:class=\"{ active : journeyType.idea }\"><img src=\"./../../images/about-us/Lightbulb=Inactive.svg\"> <img src=\"./../../images/about-us/Lightbulb=Hover.svg\"> <img src=\"./../../images/about-us/Lightbulb=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.idea }\">2015</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'partnership\')\" ng:class=\"{ active : journeyType.partnership}\"><img src=\"./../../images/about-us/Partnership=Inactive.svg\"> <img src=\"./../../images/about-us/Partnership=Hover.svg\"> <img src=\"./../../images/about-us/Partnership=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.partnership}\">2016</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'launch\')\" ng:class=\"{ active : journeyType.launch}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.launch }\">2016</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'plan9\')\" ng:class=\"{ active : journeyType.plan9}\"><img src=\"./../../images/about-us/Achievement=Inactive.svg\"> <img src=\"./../../images/about-us/Achievement=Hover.svg\"> <img src=\"./../../images/about-us/Achievement=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.plan9 }\">2017</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'momentum\')\" ng:class=\"{ active : journeyType.momentum }\"><img src=\"./../../images/about-us/Lightbulb=Inactive.svg\"> <img src=\"./../../images/about-us/Lightbulb=Hover.svg\"> <img src=\"./../../images/about-us/Lightbulb=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.momentum }\">2017</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'achievement\')\" ng:class=\"{ active : journeyType.achievement}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.achievement }\">2017</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'sat\')\" ng:class=\"{ active : journeyType.sat}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.sat }\">2018</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'entryTest\')\" ng:class=\"{ active : journeyType.entryTest}\"><img src=\"./../../images/about-us/Achievement=Inactive.svg\"> <img src=\"./../../images/about-us/Achievement=Hover.svg\"> <img src=\"./../../images/about-us/Achievement=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.entryTest }\">2018</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'austin\')\" ng:class=\"{ active : journeyType.austin }\"><img src=\"./../../images/about-us/Achievement=Inactive.svg\"> <img src=\"./../../images/about-us/Achievement=Hover.svg\"> <img src=\"./../../images/about-us/Achievement=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.austin }\">2018</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'ring\')\" ng:class=\"{ active : journeyType.ring}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.ring }\">2018</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'cssLaunch\')\" ng:class=\"{ active : journeyType.cssLaunch}\"><img src=\"./../../images/about-us/Achievement=Inactive.svg\"> <img src=\"./../../images/about-us/Achievement=Hover.svg\"> <img src=\"./../../images/about-us/Achievement=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.cssLaunch}\">2019</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'startUp\')\" ng:class=\"{ active : journeyType.startUp}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.startUp }\">2020</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'accaLaunch\')\" ng:class=\"{ active : journeyType.accaLaunch}\"><img src=\"./../../images/about-us/Partnership=Inactive.svg\"> <img src=\"./../../images/about-us/Partnership=Hover.svg\"> <img src=\"./../../images/about-us/Partnership=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.accaLaunch }\">2020</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'fscLaunch\')\" ng:class=\"{ active : journeyType.fscLaunch}\"><img src=\"./../../images/about-us/Launch=Inactive.svg\"> <img src=\"./../../images/about-us/Launch=Hover.svg\"> <img src=\"./../../images/about-us/Launch=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.fscLaunch }\">2021</label></div><div class=\"journey-icons flex-view flex-direction-col align-items-center\" style=\"border-right: 1px solid #0F3B48\" ng-click=\"filterJourney(\'seed\')\" ng:class=\"{ active : journeyType.seed}\"><img src=\"./../../images/about-us/Achievement=Inactive.svg\"> <img src=\"./../../images/about-us/Achievement=Hover.svg\"> <img src=\"./../../images/about-us/Achievement=Default.svg\"><label class=subtitle-1 style=\"color: #26778d;opacity:0.6; margin-top: 5px\" ng:class=\"{ \'journey-font-white\' : journeyType.seed }\">2021</label></div></div></div><div class=scroller-icon><img src=./../../images/about-us/tabs-scoller-icon.svg alt=#></div><div class=our-journey-content><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.idea style=\"width: 100%; height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" style=\"width: 600px\" data-wow-duration=2s><div><label class=about-us-h4 style=\"color: white\">LUMS Center for Entrepreneurship (NIC) incubation</label><label class=about-us-body-2 style=\"color: #1DACCE\">An idea sparked into a reality; Nearpeer\'s cofounders - after doing few test runs - joined LCE in Oct 2015 and nourished the young seed of creating local video courses by encouraging peers to create video content in different universities in Pakistan.</label></div><div class=journey-date>FEB - 2015</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=./../../images/about-us/timeline/1.jpg style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.partnership style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Partnership with Shopistan</label><label class=about-us-body-2 style=\"color: #1DACCE\">Soon after the launch of MVP, Nearpeer partnered up with Shopistan - a technology company - to offer cutting-edge technology to its students.</label></div><div class=journey-date>AUG - 2016</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=./../../images/about-us/timeline/2.jpg style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.launch style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Partnership with CANotes</label><label class=about-us-body-2 style=\"color: #1DACCE\">Nearpeer partnered up with one of the most innovative and leading education firms from the CA industry - CANotes - and launched video courses with a complete eco-system and became the market leader in few months.</label></div><div class=journey-date>DEC - 2016</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2016 Dec - Launched CA program.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.achievement style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail fadeIn\" data-wow-duration=2s style=\"width: 600px\"><!-- wow --><div><label class=about-us-h4 style=\"color: white\">Momentum 2017 1st Runner-up</label><label class=about-us-body-2 style=\"color: #1DACCE\">Out of 200+ startups that competed in Momentum 2017 in Karachi Pakistan, Nearpeer was granted 2nd position in the start-up ecosystem by esteemed judges of the industry. A cash prize of 700,000 PKR as prize money by now Prime Minister - Mr. Imran Khan was awarded.</label></div><div class=journey-date>FEB - 2017</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2017 Feb - 1st Runner up of Momentum with Imran Khan 2017.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.momentum style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Incubation at Plan9</label><label class=about-us-body-2 style=\"color: #1DACCE\">Nearpeer got incubated at Plan9 under the IlmIdeas2 partnership. During those 6 months, Nearpeer grew to be one the most known name in the start-up ecosystem of Pakistan.</label></div><div class=journey-date>JAN - 2017</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=./../../images/about-us/timeline/plan9.png style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.plan9 style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">SAT Program Launched</label><label class=about-us-body-2 style=\"color: #1DACCE\">Nearpeer launched SAT program as a tool to ensure that all of the students who were applying for LUMS on scholarship should get access to quality content without leaving their hometown. Got more than 300 enrollments in the very first batch.</label></div><div class=journey-date>JAN - 2017</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2017 Jan - Launched SAT program.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.sat style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Entry Test Program Launched</label><label class=about-us-body-2 style=\"color: #1DACCE\">Soon after SAT, the next objective was to facilitate the MDCAT students in their preparation. Within the first year of the launch, Nearpeer gathered more than 12,000 enrollments and become the best online preparation program in Medical Entry Test Market.</label></div><div class=journey-date>MAR - 2018</div></div><div class=\"image-parent-div wow fadeInR\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2018 March - Launched Entry Test Program.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.entryTest style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeInL\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">ATX Pak Launch - UT Austin, USA</label><label class=about-us-body-2 style=\"color: #1DACCE\">Nearpeer was selected in the ATX Pak Launch program and represented the Ed-tech domain UT Austin in 2018. Nearpeer gathered a lot of praises in the international community and got \"the best start-up pitch\" award in Texas.</label></div><div class=journey-date>MAR - 2018</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2018 March - UT AUSTIN Best Pitch Award (USA, TX).jpeg\" style=\"border-radius: 30px 0px 36px;\n                  object-fit: cover;\n                  object-position: 0px -90px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.austin style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">GITR Global Pakistan Chapter Winner</label><label class=about-us-body-2 style=\"color: #1DACCE\">Nearpeer stood first in the Global GITR (Pakistan Chapter) and represented Pakistan in Singapore. This was the first and only representation of the Pakistani EdTech startup in GITR Singapore.</label></div><div class=journey-date>MAY - 2018</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2018 May - Get in the Ring Pakistan Winner.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.ring style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">CSS Program Launched</label><label class=about-us-body-2 style=\"color: #1DACCE\">Upon gathering a lot of success in the Entry Test preparation market, Nearpeer expanded into the CSS preparation program on students\' requests. It has been our stronghold since then.</label></div><div class=journey-date>OCT - 2018</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2018 Oct - Launched CSS Program.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.cssLaunch style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Total Start-up of the year runner-up</label><label class=about-us-body-2 style=\"color: #1DACCE\">With the aim to represent Pakistan globally, Nearpeer stood as a runner-up in Total\'s startup of the year competition.</label></div><div class=journey-date>JAN - 2019</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2019 Jan - Total Startup of the year Runner-up.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.startUp style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">ACCA Program Launched</label><label class=about-us-body-2 style=\"color: #1DACCE\">With the success in the CA market, Nearpeer aimed to offer quality courses for the ACCA division as well. With this, Nearpeer shall be inviting international traffic as well.</label></div><div class=journey-date>JUN - 2020</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2020 June - Launched ACCA program.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.accaLaunch style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Advisors onboarding</label><label class=about-us-body-2 style=\"color: #1DACCE\">Aiming to expand globally, Nearpeer took industry leaders as its advisors and they have been helping Nearpeer in achieving its vision since then.</label></div><div class=journey-date>DEC - 2020</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/Dec 2020 - Got Advisors on board.jpeg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.seed style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">Pre-seed investment</label><label class=about-us-body-2 style=\"color: #1DACCE\">Being an industry leader in ed-tech domain, Nearpeer gained the confidence of local as well as international investors and got a pre-seed round of whopping $500,000 USD.</label></div><div class=journey-date>JUN - 2021</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=\"./../../images/about-us/timeline/2021 June - Raised $500,000 in pre-seed round.jpg\" style=\"border-radius: 30px 0px 36px\"></div></div></div><div class=\"flex-view justify-content-between flex-direction-row-col\" ng-if=journeyType.fscLaunch style=\"width: 100%;height: 100%\"><div class=\"flex-view flex-direction-col justify-content-between tab-detail wow fadeIn\" data-wow-duration=2s style=\"width: 600px\"><div><label class=about-us-h4 style=\"color: white\">FSC and A/O Level Programs Launched</label><label class=about-us-body-2 style=\"color: #1DACCE\">With the team and technology ready, Nearpeer launched its most awaited programs - Fsc & A/O Levels. With all of the hard work, Nearpeer gathered 20,000+ enrollments in the first very first cohort.</label></div><div class=journey-date>MAR - 2021</div></div><div class=\"image-parent-div wow fadeIn\" data-wow-duration=2s><div style=\"border-radius: 30px 0px 36px\"><img src=./../../images/about-us/timeline/IMG-20210712-WA0030.jpg style=\"border-radius: 30px 0px 36px\"></div></div></div></div></div></div></section><section class=our-movement><div class=\"section-box flex-view justify-content-around flex-direction-col\" style=\"padding: 0 10%\" data-aos=fade-up data-aos-duration=2000><div class=flex-view style=\"justify-content: flex-end\"><div class=\"flex-view justify-content-between align-items-center jtm-title\" style=\"width: 400px\" data-aos=fade-up data-aos-duration=2000><img class=jtm-arrows src=./../../images/about-us/Join-the-movement-arrows.svg><div class=\"flex-view flex-direction-col\"><label class=\"about-us-h2 web-only-btm\" style=\"border-bottom: 2px solid black;width: 100%\">Join The</label><label class=about-us-h2 style=\"color: var(--theme-bg)\">Movement</label></div></div></div><div class=\"flex-view flex-direction-row justify-content-between flex-direction-row-col\" style=\"width: 100%\"><div class=button-hover><div class=\"flex-view align-items-center justify-content-center invest-button\" ng-click=earnWithUs()><label class=about-us-h3 style=\"color: white;min-width: 200px;  max-width: 200px\">Earn with us</label><img src=./../../images/about-us/jtm-w.svg class=movement-icons></div></div><div class=button-hover><div class=\"flex-view align-items-center justify-content-center work-button\" ng-click=workWithUs()><label class=about-us-h3 style=\"min-width: 200px;max-width: 200px\">Work With Us</label><img src=./../../images/about-us/jtm-b.svg class=movement-icons> <img src=./../../images/about-us/jtm-w.svg class=movement-icons></div></div></div></div></section><!-- <section class=\"about-us-footer\">\n    <div class=\"section-box\" style=\"height: auto\">\n      <div\n        class=\"\n          flex-view\n          justify-content-between\n          flex-direction-row-col\n          rsp-footer\n        \"\n      >\n        <div class=\"footer-col\">\n          <div class=\"footer-block-title\">\n            Stay up to date on the latest on Nearpeer\n          </div>\n          <div class=\"subscribe-form\">\n            <form >\n              <input\n                type=\"email\"\n                name=\"subscribe\"\n                id=\"subscribe_nearpeer\"\n                placeholder=\"Enter your e-mail\"\n                ng-model=\"email\"\n              />\n              <button  id=\"submit_nearpeer\" ng-click=\"EmailSubscribe(email)\">Subscribe</button>\n            </form>\n          </div>\n        </div>\n        <div class=\"footer-col\">\n          <div class=\"footer-block-title\">Support</div>\n          <ul>\n            <li><a href=\"/contact-us\">Contact Us</a></li>\n            <li><a href=\"/payment-options\">How to pay</a></li>\n            <li><a href=\"/downloadapp\">Download</a></li>\n          </ul>\n        </div>\n        <div class=\"footer-col\">\n          <div class=\"footer-block-title\">Our Programs</div>\n          <ul>\n            <li>\n              <a ng-if=\"!platform_reactApp\" href=\"/mdcat-test-preparation\">MDCAT</a>\n              <a ng-if=\"platform_reactApp\" href=\"/entry-test-preparation\">MDCAT</a></li>\n            <li>\n              <a ng-if=\"!platform_reactApp\" href=\"/css-test-preparation\">CSS </a>\n              <a ng-if=\"platform_reactApp\" href=\"/css/css-online-preparation\">CSS </a></li>\n            <li><a ng-if=\"!platform_reactApp\" href=\"https://cambridge.nearpeer.org/\">O/A Level</a>\n              <a ng-if=\"platform_reactApp\" href=\"/online-course/O&A-Level\">O/A Level</a></li>\n            <li>\n              <a ng-if=\"!platform_reactApp\" href=\"https://fsc.nearpeer.org/\">FSC</a>\n              <a ng-if=\"platform_reactApp\" href=\"/online-course/fsc\">FSC</a></li>\n            <li><a href=\"/chartered-accountancy-final\">CA</a></li>\n            <li><a href=\"/acca/acca-online\">ACCA</a></li>\n            <li><a href=\"/lums\">University Courses</a></li>\n            <li><a href=\"/entry-test\">University Entry Test</a></li>\n          </ul>\n        </div>\n        <div class=\"footer-col\">\n          <div class=\"footer-block-title\">Our location</div>\n          <ul>\n            <li>\n              <a href=\"https://goo.gl/maps/7zkmkYAqnnEKTq7w8\" target=\"_blank\"\n                ><img src=\"../../images/about-us/map.svg\" alt=\"our location\"\n              /></a>\n            </li>\n            <li>\n              <a href=\"#\"\n                >123 C Ahmed Block, New Garden <br />\n                Town Lahore</a\n              >\n            </li>\n          </ul>\n        </div>\n      </div>\n      <div class=\"footer-bottom\">\n        <div\n          class=\"\n            flex-view\n            justify-content-between\n            align-items-center\n            flex-direction-row-col\n          \"\n        >\n          <div class=\"help\">\n            <p>\n              <b>Need Help?</b> Our team is waiting for your call at\n              <b><a href=\"tel:+923111444734\"> 03111444734</a></b>\n            </p>\n          </div>\n          <div class=\"flex-view align-items-center\">\n            <div class=\"about-us-logo\">\n              <img src=\"../../images/Logo_white.svg\" alt=\"near pear logo\" />\n            </div>\n            <ul class=\"social-icons\">\n              <li>\n                <a href=\"https://www.youtube.com/c/Nearpeerofficial\"\n                target=\"_blank\" \n                ><img src=\"../../images/about-us/icon-yt.svg\" alt=\"\"\n                /></a>\n              </li>\n              <li>\n                <a href=\"https://www.instagram.com/nearpeer.official/\"\n                target=\"_blank\"\n                ><img src=\"../../images/about-us/icon-insta.svg\" alt=\"\"\n                /></a>\n              </li>\n              <li>\n                <a href=\"https://www.facebook.com/nearpeer.org\"\n                target=\"_blank\"\n                  ><img src=\"../../images/about-us/icon-fb.svg\" alt=\"\"\n                /></a>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section> --></div>");
$templateCache.put("app/Pages/blog.html","<div style=margin-top:18%><center><h1 style=color:#0f3b5e class=header-title>Blog</h1><h4 style=color:#9be0c6>Coming Soon</h4></center></div><div style=margin-top:6.5%></div>");
$templateCache.put("app/Pages/contactus.html","<div class=container><div class=row><div class=\"col-md-4 col-md-offset-4\" style=\"text-align: center\"><img class=whatsapp-image src=../../images/whatsapp-icon.png><br><h1 class=whatsapp-text>-- WhatsApp Us 24/7 --</h1><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div></div></div><div class=row><div class=\"col-md-4 col-md-offset-4\" style=\"text-align: center\"><h1 class=whatsapp-text>Or</h1></div></div><div class=row><div class=\"col-md-4 col-md-offset-4\" style=\"text-align: center\"><img class=whatsapp-image src=../../images/call-icon.png><br><h1 class=whatsapp-text>-- Call Us in Official Timings --</h1><br></div></div><div class=row><div class=\"col-md-8 col-md-offset-2 cal\"><h1 class=txt>Monday to Friday: <img class=calndr src=../../images/calender-icon.png> 09:30AM to 05:30PM</h1></div></div></div><div class=contact-info><div class=main-center-btm><div class=ftr><div><h1 style=\"color: #123A7D; font-size: 30px\"><span class=\"fas fa-envelope mail\" style=\"color: #123A7D\"></span> Email us: Contact@nearpeer.org</h1></div><!-- <img class=\"mail\" src=\"../../images/mail-icon-contactus.png\"> --><!-- <h1 class=\"email-contact\"> Email us: Contact@nearpeer.org</h1> --></div></div></div><div class=container style=\"margin-top: 50px; margin-bottom: 50px\"><div class=row><div class=\"col-md-4 col-md-offset-4\" style=\"text-align: center\"><a href=# style=\"color: darkgray\" ng-click=showFurtherDetails()>Further Contact Details</a></div></div></div><div class=container style=\"margin-top: 50px; margin-bottom: 50px\" ng-if=furtherDetails><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div role=tab id=heading1 ng-click=\"rotate180(\'mdcat\')\"><a class=collapsed data-toggle=collapse data-target=#collapse1 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse1><div class=\"row accordion-label\"><h4 ng-click=rotate180(mdcat) ng-class=\"{\'h4focus\': mdcatState}\">MDCAT <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !mdcatState,\'glyphicon-chevron-up\': mdcatState}\"></i></h4></div></a></div><div id=collapse1 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading1 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Counselor 1</span></div><div class=col-md-8><a href=tel:03464394354><span class=text-style-right>03464394354</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Counselor 2</span></div><div class=col-md-8><a href=tel:03474143787><span class=text-style-right>03474143787</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Payment and Joining</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading2 ng-click=\"rotate180(\'ca\')\"><a class=collapsed data-toggle=collapse data-target=#collapse2 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse1><div class=\"row accordion-label\"><h4 ng-click=rotate180(ca) ng-class=\"{\'h4focus\': caState}\">CA <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !caState,\'glyphicon-chevron-up\': caState}\"></i></h4></div></a></div><div id=collapse2 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading2 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>General Queries</span></div><div class=col-md-8><a href=tel:03497331076><span class=text-style-right>03497331076</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Content Queries</span></div><div class=col-md-8><a href=tel:03334748659><span class=text-style-right>03334748659</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>ICAP Matters</span></div><div class=col-md-8><a href=tel:03224330393><span class=text-style-right>03224330393</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>CA Test Session</span></div><div class=col-md-8><a href=tel:03164387917><span class=text-style-right>03164387917</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Test Session Complaints</span></div><div class=col-md-8><a href=tel:03104188117><span class=text-style-right>03104188117</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>CA Program Head</span></div><div class=col-md-8><a href=tel:03334748659><span class=text-style-right>03334748659</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Payment and Joining</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading3 ng-click=\"rotate180(\'css\')\"><a class=collapsed data-toggle=collapse data-target=#collapse3 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse3><div class=\"row accordion-label\"><h4 ng-click=rotate180(css) ng-class=\"{\'h4focus\': cssState}\">CSS <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !cssState,\'glyphicon-chevron-up\': cssState}\"></i></h4></div></a></div><div id=collapse3 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading3 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Counselor</span></div><div class=col-md-8><a href=tel:03466833169><span class=text-style-right>03466833169</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Payment and Joining</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading4 ng-click=\"rotate180(\'sat\')\"><a class=collapsed data-toggle=collapse data-target=#collapse4 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse4><div class=\"row accordion-label\"><h4 ng-click=rotate180(sat) ng-class=\"{\'h4focus\': satState}\">SAT <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !satState,\'glyphicon-chevron-up\': satState}\"></i></h4></div></a></div><div id=collapse4 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading4 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Counselor</span></div><div class=col-md-8><a href=tel:03464394354><span class=text-style-right>03464394354</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Instructor</span></div><div class=col-md-8><a href=tel:03435221582><span class=text-style-right>03435221582</span></a></div></div></div></li></ul></div></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading5 ng-click=\"rotate180(\'nust\')\"><a class=collapsed data-toggle=collapse data-target=#collapse5 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse5><div class=\"row accordion-label\"><h4 ng-click=rotate180(nust) ng-class=\"{\'h4focus\': nustState}\">NUST & ECAT <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !nustState,\'glyphicon-chevron-up\': nustState}\"></i></h4></div></a></div><div id=collapse5 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading5 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Guidance</span></div><div class=col-md-8><a href=tel:03410711894><span class=text-style-right>03410711894</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Payment and Joining</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading6 ng-click=\"rotate180(\'acca\')\"><a class=collapsed data-toggle=collapse data-target=#collapse6 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse6><div class=\"row accordion-label\"><h4 ng-click=rotate180(acca) ng-class=\"{\'h4focus\': accaState}\">ACCA <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !accaState,\'glyphicon-chevron-up\': accaState}\"></i></h4></div></a></div><div id=collapse6 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading6 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Guidance</span></div><div class=col-md-8><a href=tel:03154616191><span class=text-style-right>03154616191</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Payment and Joining</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div></div><div class=row><div class=\"col-md-10 col-lg-10 col-md-offset-1 ani-class\"><div><div role=tab id=heading7 ng-click=\"rotate180(\'ti\')\"><a class=collapsed data-toggle=collapse data-target=#collapse7 data-parent=#accordionEx7 href=# aria-expanded=false aria-controls=collapse7><div class=\"row accordion-label\"><h4 ng-click=rotate180(ti) ng-class=\"{\'h4focus\': tiState}\">TECHNICAL ISSUE <i id=nust class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !tiState,\'glyphicon-chevron-up\': tiState}\"></i></h4></div></a></div><div id=collapse7 class=\"collapse collapse_Css\" role=tabpanel aria-labelledby=heading7 data-parent=#accordionEx7><ul><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>Streaming Issues</span></div><div class=col-md-8><a href=tel:03459615004><span class=text-style-right>03459615004</span></a></div></div></div></li><li class=cu-li-content><div class=container-fuild><div class=row><div class=col-md-4><span class=text-style-left>General Queries</span></div><div class=col-md-8><a href=tel:03111444734><span class=text-style-right>03111444734</span></a></div></div></div></li></ul></div></div></div></div></div>");
$templateCache.put("app/Pages/downloadApp.html","<div class=top_container><div class=\"ar ap\"><div class=headings><h3 id=h3Tag1 style=\"text-align: center\" class=h3TagCommon>Learn on the go with <b>fast streaming</b> across iOS, Android and Desktop Apps</h3><h3 id=h3Tag2 style=\"text-align: center\" class=h3TagCommon>Learn on the go with<br><b>fast streaming</b> across iOS,<br>Android and Desktop Apps</h3></div><ul class=headings><li class=marginBottom><h4>Highly Optimized Apps for Fast Streaming</h4></li><li class=marginBottom><h4>High Quality Video Lectures</h4></li><li class=marginBottom><h4>Access to 200+ Online Courses</h4></li><li class=marginBottom><h4>10,000+ MCQs in the palm of your hands</h4></li><li class=marginBottom><h4>24/7 Community Interaction</h4></li><li class=marginBottom><h4>Performance Evaluation tailored to Improve your Learning</h4></li></ul><div><img class=monitorScreen src=../../images/DownloadPageMonitor.png> <img class=mobileScreen src=../../images/DownloadPageMobile1@2x.png></div><div class=footerClass><div class=\"f-c d-row\"><div class=transparentDiv><a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=_blank><img style=\"height: 68px\" class=transparentDivImage src=../../images/google-play-badge.png> </a><a href=https://apps.apple.com/us/app/nearpeer/id1525357562 target=_blank><img style=\"height: 45px\" class=transparentDivImage src=../../images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg></a></div></div><div class=\"f-c d-col alic\"><div class=transparentDiv><div><p style=\"font-size: 12px; text-align: center\">Choose your operating system to begin download:</p><table><tbody><tr><td width=100px height=120px><img id=img1 class=transparentDivImage ng-click=\"openPopUp(\'Windows\')\" src=\"../../images/Windows Icon.svg\"></td><td width=100px><img id=img2 class=transparentDivImage ng-click=\"openPopUp(\'Mac\')\" src=\"../../images/Mac Icon.svg\"></td><td width=100px><img id=img3 class=transparentDivImage ng-click=\"openPopUp(\'Linux\')\" src=\"../../images/Linux Icon.svg\"></td></tr></tbody></table></div></div><div id=bottomP class=\"f-c d-row\" style=\"padding: 10px\"><img style=\"height: 20px;margin: 5px 10px 10px 10px\" src=../../images/DownloadPageMobileIcon.png><p style=\"margin-top: 5px\">Also available on Android and iOS</p></div></div><div class=\"d-col bottomDiv\"><p style=\"color: white\">Tap below to download for:</p><ul><li><img ng-click=\"openPopUp(\'Windows\')\" src=\"../../images/Windows Icon.svg\"></li><li><img ng-click=\"openPopUp(\'Mac\')\" src=\"../../images/Mac Icon.svg\"></li><li><img ng-click=\"openPopUp(\'Linux\')\" src=\"../../images/Linux Icon.svg\"></li></ul></div></div></div></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new><div class=\"f-c d-col jusc\" style=\"position: relative\"><h3 style=\"text-align: center; color: #7295FE;font-family: nunito, semibold; font-size: 20px\"><b>Thank you for choosing Nearpeer!</b></h3><h4 ng-if=!submitted style=\"text-align:center;font-family: nunito, semibold; font-size: 16px;margin-top: 1px\"><b>Your download will begin in <span style=\"color: #199436\">{{counter}}</span> seconds.</b></h4><img style=\"margin: 9px 0px 14px 0px\" src=../../images/downloadPagePopup.svg><h3 ng-if=submitted style=\"margin-top:15px !important; color: #199436; text-align: center\"><b>Awesome!</b></h3><h4 ng-if=submitted style=\"margin-top:0px; color: #199436; text-align: center\">You have successfully subscribed to Nearpeer.org</h4><h5 ng-if=!submitted style=\"text-align: center;margin-bottom:5px\">For future updates, please enter email address below:</h5><div ng-if=!submitted style=\"padding: 5px 0px\"><input type=email class=popupField placeholder=\"Please enter your email here...\" ng-model=emailAddress required> <button class=popupButton ng-click=\"goToApp(emailAddress,\'popUpCloseTrue\',\'emailSubmissionOnlyTrue\')\">Submit</button></div><p ng-if=!emailValid style=\"color: red\">Enter valid email.</p><span style=\"position: absolute; right: 0px; top: -10px\" ng-click=closePopup()>&times</span></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/Pages/downloadAppMobile.html","<div class=download-wrapper><div class=download-banner><div class=download-container><div class=download-banner-row><div class=download-banner-img><img src=../../images/download-app/app-img.png alt=\"nearpeer app\"></div><div class=download-banner-content><h1>Download Our App Now</h1><p>Get instant access to your favorite courses and unlock your learning potential today!</p><a href=https://apps.apple.com/us/app/nearpeer/id1525357562 class=download-banner-btn><img src=../../images/download-app/apple.svg alt=\"nearpeer app apple store\">Get From Apple Store</a> <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" class=download-banner-btn><img src=../../images/download-app/play.svg alt=\"nearpeer app play store\">Get From Play Store</a></div></div></div></div><div class=download-mobile-btn><a href=https://apps.apple.com/us/app/nearpeer/id1525357562 class=download-banner-btn><img src=../../images/download-app/apple.svg alt=\"nearpeer app apple store\">Get From Apple Store</a> <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" class=download-banner-btn><img src=../../images/download-app/play.svg alt=\"nearpeer app play store\">Get From Play Store</a></div><div class=download-content><div class=download-container><div class=download-content-title><h2>about the app</h2><p>Our app revolutionizes education by providing affordable and instant access to high-quality courses. With a seamless offline video storage feature, lightning-fast AI bot, abundant free courses, and instant notifications, we empower students to unlock their learning potential anytime, anywhere.</p></div><div class=download-content-info><div class=download-content-card><img src=../../images/download-app/storage.svg alt=\"nearpeer offline video storage\"><p>Offline Video Storage:</p><hr><p>Access Learning Anytime, Anywhere!</p></div><div class=download-content-card><img src=../../images/download-app/ai.svg alt=\"nearpeer Super-Fast AI Bot\"><p>Super-Fast AI Bot:</p><hr><p>Instant Answers at Your Fingertips!</p></div><div class=download-content-card><img src=../../images/download-app/courses.svg alt=\"nearpeer Abundant Free Courses\"><p>Abundant Free Courses:</p><hr><p>Learning Made<br>Affordable!</p></div><div class=download-content-card><img src=../../images/download-app/notification.svg alt=\"nearpeer Instant Notifications\"><p>Instant Notifications:</p><hr><p>Stay Updated and Never Miss a Beat!</p></div></div></div></div></div>");
$templateCache.put("app/Pages/header.html","<toaster-container toaster-options=\"{\'position-class\': \'toast-top-right\'}\"></toaster-container><div ng-show=noInternet class=\"overlay-black noInternet\"><div ng-show=noInternet class=offline-internet style=\"background-color: red\"><h2>Error</h2><p>You Are Offline</p></div></div><!-- <div ng-show=\"showOverlay\" class=\"overlay-black\"></div>\n<div\n  ng-show=\"showOverlay\"\n  class=\"pop-overlay-home signup-popup fb-info\"\n  id=\"popup_overlay\"\n> --><!-- <form> --><!-- <h4 class=\"popup-title\" ng-hide=\"questionNo == 1\">\n      Please provide the following information\n    </h4>\n    <h4 class=\"popup-title\" ng-show=\"questionNo == 1\">\n      Please Enter Your Valid Mobile Number\n    </h4>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 10\">\n      <div class=\"col-md-5\"><label>Full Name</label></div>\n      <div class=\"col-md-7\">\n        <input type=\"text\" ng-model=\"userData.name\" placeholder=\"John Smith\" />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 0\">\n      <div class=\"col-md-5\"><label>Email</label></div>\n      <div class=\"col-md-7\">\n        <input\n          type=\"email\"\n          ng-model=\"userData.email\"\n          placeholder=\"someone@example.com\"\n        />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 1\"> --><!-- <div class=\"col-md-5\"><label>Phone</label></div> --><!-- <div class=\"col-md-7\">\n        <input\n          type=\"text\"\n          ng-model=\"userData.phone\"\n          placeholder=\"03XXXXXXXXX\"\n        />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 2\">\n      <div class=\"col-md-5\"><label>University/Institution</label></div>\n      <div class=\"col-md-7\">\n        <input\n          type=\"text\"\n          ng-model=\"userData.university\"\n          placeholder=\"LUMS/SKANS\"\n        />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 3\">\n      <div class=\"col-md-5\"><label>CRN Number</label></div>\n      <div class=\"col-md-7\">\n        <input type=\"text\" ng-model=\"userData.crn\" placeholder=\"\" />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 4\">\n      <div class=\"col-md-5\"><label>Firm</label></div>\n      <div class=\"col-md-7\">\n        <input type=\"text\" ng-model=\"userData.firm\" placeholder=\"\" />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 5\">\n      <div class=\"col-md-5\"><label>City</label></div>\n      <div class=\"col-md-7\">\n        <input type=\"text\" ng-model=\"userData.city\" placeholder=\"\" />\n      </div>\n    </div>\n    <div class=\"row fieldset\" ng-show=\"questionNo == 6\">\n      <div class=\"col-md-5\"><label>Date of Birth</label></div>\n      <div class=\"col-md-7\">\n        <input type=\"date\" ng-model=\"userData.dob\" placeholder=\"\" />\n      </div>\n    </div>\n    <div class=\"row submit-btn\">\n      <button type=\"submit\" ng-click=\"updateData(userData)\">Submit</button>\n      <img\n        ng-show=\"requestSent\"\n        src=\"images/squares.gif\"\n        width=\"40px\"\n        height=\"40px\"\n      />\n    </div> --><!-- </form> --><!-- </div> --><!-- <div class=\"new-popup\" ng-show=\"myAccountPopup\" ng-click=\"closeFormm()\"></div>\n<div class=\"account-login\" ng-show=\"myAccountPopup\">\n  <span>{{getInitial(customerName)}}</span>\n  <h2>{{customerName}}</h2>\n  <ul>\n    <li><a ng-click=\"goToState(\'my-account\')\">Account Settings</a> </li>\n    <li><a ng-click=\"logOut()\">Log Out</a> </li>\n  </ul>\n</div> --><!-- Modal --><div class=\"modal fade\" id=AccountSettings data-dismiss=modal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=\"modal-body account-login\"><span>{{getInitial(customerName)}}</span><h2>{{customerName}}</h2><ul><li><a ng-click=\"goToState(\'my-account\')\">Account Settings</a></li><li><a ng-click=openMerge() ng-if=mergeTooltip style=\"display: flex;\n            align-items: center;\n            justify-content: center\">Merge Account<div class=\"tt-popup flex-view\"><img src=\"./../../images/info icon.svg\" style=\"width: 14px; margin-left: 5px\"><!-- <p   style=\"position: absolute; bottom: 50px;\"> --><p class=tt-show style=\"position: absolute;\ntop: 22px;\n    font-size: 12px!important;\n    right: -23px;\n    width: 270px;\n      background: black;\n      color: white;\n      padding: 5px 15px;\n      border-radius: 8px;\n      box-shadow: 0 4px 2px -2px gray\"><img src=\"./../../images/Polygon 2.svg\" style=\"position: absolute;\n      right: 25px;\n      top: -6px\"> You have multiple accounts with the same email address. Please merge your accounts.</p></div></a></li><li><a ng-click=logOut()>Log Out</a></li></ul></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=exampleModal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><h5 class=modal-title id=exampleModalLabel>Modal title</h5><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body>...</div><div class=modal-footer><button type=button class=\"btn btn-secondary\" data-dismiss=modal>Close</button> <button type=button class=\"btn btn-primary\">Save changes</button></div></div></div></div><div ng-if=showNewLoginDiv login-form></div><customform ng-if=showCustomForm form=form></customform><div id=barwrap class=bar ng-if=showPromo><div><span id=bar-text><a href=https://www.nearpeer.org/blog/General/how-to-use-promo-code-to-access-free-courses target=_blank>Got a promo code? Click to learn how to use it.</a></span> <span id=ok><a href=#><img src=images/close-popup.png height=12px ng-click=closePromo()></a></span></div></div><!-- -------------------------- app notification --------------------------- --><div class=appNoti ng-if=appNotification><div class=appNotiDetail><img src=../../images/close-popup.svg alt=# class=appCross ng-click=closeAppNoti()> <img src=../../images/blue-logo.png alt=nearpeer class=appLogo><h2>Nearpeer.org <span>200,000+ Installs</span></h2></div><button class=appNotiBtn ng-click=redirectToApp()>Install App</button></div><header ng-class=\"{\'mdcat-header\' : mdCatlandingPage === \'mdcat\',\'css-header\' :mdCatlandingPage===\'css\'  ,\'sat-header\':mdCatlandingPage === \'sat\', \'about-us-header\' : mdCatlandingPage === \'about-us\'}\" ng:class=\"{\'snap-shot\' : isLanding === \'About-Us\'}\" class=\"site-header newHeader\" id=site-header><div class=logo><a ng-click=clickMainLogo()><svg xmlns=http://www.w3.org/2000/svg width=240 height=60 viewBox=\"0 0 240 60\"><metadata> <?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?> <x:xmpmeta xmlns:x=adobe:ns:meta/ x:xmptk=\"Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01        \"><rdf:RDF xmlns:rdf=http://www.w3.org/1999/02/22-rdf-syntax-ns#><rdf:Description rdf:about=\"\"/></rdf:RDF></x:xmpmeta> <?xpacket end=\"w\"?> </metadata><defs><style>.cls-1 {\n              fill: #112d4e;\n              fill-rule: evenodd;\n            }</style></defs><path id=Logo class=cls-1 d=M209.473,68.243a7.823,7.823,0,0,1,.289-2.155,5.276,5.276,0,0,1,.867-1.775,4.158,4.158,0,0,1,1.444-1.2,4.363,4.363,0,0,1,2.022-.444,5.236,5.236,0,0,1,2.166.4,3.826,3.826,0,0,1,1.444,1.1,4.135,4.135,0,0,1,.784,1.626,8.378,8.378,0,0,1,.227,1.987V79.993H222.6V67.1a11.254,11.254,0,0,0-.433-3.17,7.115,7.115,0,0,0-1.321-2.557,6.15,6.15,0,0,0-2.228-1.692,7.438,7.438,0,0,0-3.115-.612,7.665,7.665,0,0,0-3.384.8,6.344,6.344,0,0,0-2.723,2.706V59.664h-3.8v20.33h3.878V68.243Zm20.311-.507a5.191,5.191,0,0,1,.454-1.9,6.11,6.11,0,0,1,1.093-1.669,5.131,5.131,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H229.784Zm11.43,5.284a6.853,6.853,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.9,5.9,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H244.6a4.31,4.31,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.639-4.332,9.709,9.709,0,0,0-1.837-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.649,8.649,0,0,0-3.589.781,9.231,9.231,0,0,0-3.033,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.4,12.4,0,0,0,.805,4.608,10.043,10.043,0,0,0,2.186,3.423,9.243,9.243,0,0,0,3.2,2.114,10.214,10.214,0,0,0,3.8.718,9.543,9.543,0,0,0,3.178-.507,9.361,9.361,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm6.725,3.847a5.8,5.8,0,0,0,1.341,1.922,6.8,6.8,0,0,0,2.084,1.331,7.078,7.078,0,0,0,2.744.507,8.246,8.246,0,0,0,2.373-.317,7.139,7.139,0,0,0,1.836-.825,6.585,6.585,0,0,0,1.32-1.1,7.489,7.489,0,0,0,.867-1.141q0,1.1.062,1.733a9.121,9.121,0,0,0,.144,1.014h3.8a11.843,11.843,0,0,1-.165-1.183c-0.056-.535-0.082-1.253-0.082-2.155V66.468a8.861,8.861,0,0,0-.454-2.831,6.151,6.151,0,0,0-1.444-2.367,7.161,7.161,0,0,0-2.559-1.627,10.448,10.448,0,0,0-3.8-.613,9.31,9.31,0,0,0-3.033.486,8.078,8.078,0,0,0-2.5,1.353,7.119,7.119,0,0,0-2.6,4.754l3.713,0.887a4.937,4.937,0,0,1,1.32-2.937,4.2,4.2,0,0,1,3.178-1.163,4.325,4.325,0,0,1,3.28,1.077,3.614,3.614,0,0,1,1.011,2.558,1.591,1.591,0,0,1-.31.971,1.754,1.754,0,0,1-1.217.551l-5.364.8a10.771,10.771,0,0,0-2.393.677,6.285,6.285,0,0,0-1.919,1.225,5.355,5.355,0,0,0-1.258,1.839,6.2,6.2,0,0,0-.454,2.43A5.813,5.813,0,0,0,247.939,76.867Zm4.354-.487a2.9,2.9,0,0,1-.867-2.05,2.665,2.665,0,0,1,.825-2.092,4.046,4.046,0,0,1,2.063-.951l6.066-.929v0.929a7.76,7.76,0,0,1-.454,2.812,4.864,4.864,0,0,1-1.217,1.859,4.632,4.632,0,0,1-1.816,1.015,7.764,7.764,0,0,1-2.249.318A3.094,3.094,0,0,1,252.293,76.38Zm26.971-16.927a4.688,4.688,0,0,0-.516-0.085,6.642,6.642,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.794,6.794,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.878V69.808q0-3.338,1.507-4.8a5.421,5.421,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453Zm7.191,28.572V77.246a6.929,6.929,0,0,0,2.475,2.325,7.677,7.677,0,0,0,3.962.972,8.88,8.88,0,0,0,3.9-.824,8.476,8.476,0,0,0,2.909-2.283,10.152,10.152,0,0,0,1.815-3.4,13.846,13.846,0,0,0,.619-4.226,14.048,14.048,0,0,0-.6-4.143,10.283,10.283,0,0,0-1.733-3.381,8,8,0,0,0-2.847-2.261,8.978,8.978,0,0,0-3.941-.824,7.635,7.635,0,0,0-4.126,1.058,6.97,6.97,0,0,0-2.517,2.577V59.664h-3.755V88.025h3.838ZM297.76,72.7a6.819,6.819,0,0,1-1.176,2.283,5.38,5.38,0,0,1-1.836,1.481,5.83,5.83,0,0,1-4.848,0,5.514,5.514,0,0,1-1.877-1.481,6.607,6.607,0,0,1-1.2-2.283,9.726,9.726,0,0,1-.413-2.894A9.179,9.179,0,0,1,286.826,67a6.681,6.681,0,0,1,1.2-2.241,5.783,5.783,0,0,1,1.877-1.5,5.31,5.31,0,0,1,2.414-.549,5.3,5.3,0,0,1,4.291,2.049A7.143,7.143,0,0,1,297.76,67a9.179,9.179,0,0,1,.413,2.811A9.726,9.726,0,0,1,297.76,72.7Zm11.207-4.966a5.171,5.171,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.116,5.116,0,0,1,1.65-1.186,5.271,5.271,0,0,1,2.208-.443,5.133,5.133,0,0,1,4,1.5,5.64,5.64,0,0,1,1.445,3.7H308.967ZM320.4,73.02a6.843,6.843,0,0,1-1.857,2.916,5.275,5.275,0,0,1-3.713,1.184,6.126,6.126,0,0,1-2.331-.445,5.529,5.529,0,0,1-1.9-1.268,5.91,5.91,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H323.78a4.708,4.708,0,0,0,.062-0.55q0.02-.337.02-0.718a13.95,13.95,0,0,0-.639-4.332,9.724,9.724,0,0,0-1.836-3.361,8.186,8.186,0,0,0-2.992-2.177,10.1,10.1,0,0,0-4.064-.781,8.65,8.65,0,0,0-3.59.781,9.251,9.251,0,0,0-3.033,2.2,10.939,10.939,0,0,0-2.084,3.381,11.72,11.72,0,0,0-.784,4.373,12.424,12.424,0,0,0,.805,4.608,10.031,10.031,0,0,0,2.187,3.423,9.224,9.224,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718A9.541,9.541,0,0,0,318,80.121a9.346,9.346,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm10.3-5.284a5.191,5.191,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.109,5.109,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H330.7Zm11.43,5.284a6.862,6.862,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.879,5.879,0,0,1-1.258-1.965,7.255,7.255,0,0,1-.5-2.493h14.937a4.5,4.5,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.64-4.332,9.707,9.707,0,0,0-1.836-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.653,8.653,0,0,0-3.59.781,9.237,9.237,0,0,0-3.032,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.425,12.425,0,0,0,.8,4.608A10.046,10.046,0,0,0,329.56,77.8a9.234,9.234,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718,9.537,9.537,0,0,0,3.177-.507,9.352,9.352,0,0,0,2.58-1.374,9.013,9.013,0,0,0,3.156-4.544Zm17.88-13.568a4.688,4.688,0,0,0-.516-0.085,6.628,6.628,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.772,6.772,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.879V69.808q0-3.338,1.506-4.8a5.423,5.423,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453ZM162.327,68.719a0.2,0.2,0,0,0,.206-0.331A11.771,11.771,0,0,1,159.061,60a20.22,20.22,0,0,0-4.147-12.314A19.33,19.33,0,0,0,139.53,40,19.773,19.773,0,0,0,120,60v11.67a8.254,8.254,0,0,0,7.63,8.319,0.493,0.493,0,0,0,.507-0.5V60h0A11.534,11.534,0,0,1,139.53,48.332a11.414,11.414,0,0,1,10.687,7.607A21.973,21.973,0,0,0,162.327,68.719ZM170.453,40a19.249,19.249,0,0,0-14.175,6.258,0.8,0.8,0,0,0-.042,1.008,21.472,21.472,0,0,1,3.549,7.748,0.185,0.185,0,0,0,.354.036,11.378,11.378,0,0,1,10.353-6.713,11.674,11.674,0,0,1-.039,23.34,22.719,22.719,0,0,1-19.119-10.551,0.2,0.2,0,0,0-.365.118,20.094,20.094,0,0,0,8.092,15.007A19.117,19.117,0,0,0,170.933,80,20.017,20.017,0,0,0,170.453,40ZM158.641,77.575a21.307,21.307,0,0,1-7.348-9.211,0.191,0.191,0,0,0-.37.072V91.678A8.251,8.251,0,0,0,158.559,100a0.487,0.487,0,0,0,.5-0.5V78.382A0.987,0.987,0,0,0,158.641,77.575Z transform=\"translate(-120 -40)\"/></svg></a></div><div ng-hide=true class=header-search id=header-search><form class=hd-search-form><p class=back-srch ng-click=hideResponsiveSearch()>back</p><input type=search placeholder=Search ng-model=searchHeaderStr ng-blur=hideSearchOpen($event) id=searchHeaderStr> <button type=submit>search</button></form><div class=open-search><div class=open-search-inner><ul><li class=heading-intructors><h2>COURSES</h2></li><li ng-repeat=\"course in courseHeaderResults\" ng-click=goToCourse(course)><img ng-src={{course.image_url}} alt=\"\"><h1>{{course.name}}</h1></li></ul><ul><li class=heading-intructors><h2>INSTRUCTORS</h2></li><li ng-click=goToInstructor(instructor.full_name) ng-repeat=\"instructor in instrutorHeaderResults\"><div class=img-round><img ng-src={{instructor.image}} alt=\"\"></div><p>{{instructor.full_name}}</p></li></ul></div></div></div><div class=menu ng-show=\"reactAllCourses === 0\"><div class=menu-btn ng-if=!platform_reactApp_new><span class=\"cmn-toggle-switch cmn-toggle-switch__htx\" ng-show=showCloseButton><span>toggle menu</span><!-- <span\n          class=\"hamburger-circle\"\n          ng-if=\"token\"\n          title=\"Number of people enjoying our velocity portal\"\n          >{{userVisits}}</span --> > </span><span class=\"toggle-switch-close cmn-toggle-switch__htx\" ng-hide=showCloseButton><i class=\"fa fa-times\" aria-hidden=true></i></span><p>Menu</p></div><ul class=\"nav-hidden menu-items\"><li ng-class=\"{\'menu-active\': currentPage == \'Landing\'}\" ng-click=\"goToState(\'Landing\')\"><a>Home</a></li><!-- <li\n      \n        ng-class=\"{\'menu-active\': currentPage == \'AllCourses\'}\"\n        ng-click=\"goToState(\'AllCourses\')\"\n      >\n        <a> Courses</a>\n      </li> --><li ng-class=\"{\'menu-active\': currentPage == \'paymentOptions\'}\"><a ng-click=\"goToState(\'paymentOptions\')\">How to pay</a></li><li class=\"hideIt hideResponsive\" ng-class=\"{\'menu-active\': currentPage == \'Blog\'}\"><a ng-click=\"goToState(\'Blog\')\">Blog</a></li><!-- hideResponsiveExtended --><li class=\"hideIt hideResponsive\" ng-class=\"{\'menu-active\': currentPage == \'WorkWithUs\', \'hideResponsiveLoggedin\': token}\"><a ng-click=\"goToState(\'WorkWithUs\')\">Work With Us</a></li><li class=\"hideIt hideResponsive\" ng-class=\"{\'menu-active\': currentPage == \'Contact-Us\'}\"><a ng-click=\"goToState(\'Contact-Us\')\">Contact Us</a></li><li ng-class=\"{\'menu-active\': currentPage == \'About-Us\'}\"><a ng-click=\"goToState(\'About-Us\')\">About Us</a></li><li class=\"hideIt hideResponsive\" ng-if=\"!platform_desktop && !reactApp && !platform_reactApp\" ng-class=\"{\'menu-active\': currentPage == \'B2B\'}\"><a ng-click=\"goToState(\'B2B\')\">For Business</a></li><li class=mobile_b2b ng-if=\"!platform_desktop && !reactApp && !platform_reactApp\" style=\"width: 100px\"><a href=https://shop.nearpeer.org/ target=_blank>Shop <span style=\"right: 5px\" class=\"badge_ badge badge-success\">NEW</span></a></li><li class=\"insideBar hideIt hideResponsive\" ng-class=\"{\'menu-active\': currentPage == \'downloadAppMobile\'}\"><a ng-click=\"goToState(\'downloadAppMobile\')\">Mobile Apps</a></li><!-- <li\n      ng-show=\"loggedIn\"\n      ng-class=\"{\'menu-active\': currentPage == \'MyCourses\'}\"\n      ng-click=\"goToState(\'MyCourses\')\"\n      style=\"position: relative;\"\n    >\n      <a ng-href=\"https://velocity.nearpeer.org/landing?uid={{userInfo.id}}&token={{token}}\">My Courses </a>\n      <label class=\"ct-tool-hover merge-dot-course\"></label>\n    </li> --><!-- <li><a ng-click=\"goToState(\'paymentOptions\')\">Payment Options</a></li> --><!-- <li><a ng-click=\"goToState(\'my-account\')\"> my courses</a></li> --></ul><div class=responisve-header-bottom><a ng-show=loggedIn ng-href=\"{{env.velocityPortal}}/landing?uid={{userInfo.id}}&token={{token}}\" ng-click=myCourseEvent() class=sidebar-btn><svg width=19 height=18 viewBox=\"0 0 19 18\" fill=none xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M6.52869 0.522699C7.255 0.178533 8.0487 0 8.85244 0C9.65617 0 10.4499 0.178533 11.1762 0.522699L17.3105 3.3992C18.2749 3.85112 18.7066 4.83287 18.7066 5.72937C18.7066 6.62587 18.2758 7.60853 17.3105 8.06045L15.9566 8.69478V13.1773C15.9566 14.3259 15.3809 15.435 14.3323 16.0162C13.6429 16.3975 12.7373 16.8568 11.7839 17.2225C10.8425 17.5837 9.80027 17.8752 8.85244 17.8752C7.9046 17.8752 6.86235 17.5837 5.92002 17.2225C4.96668 16.8568 4.06193 16.3975 3.3726 16.0162C2.32393 15.435 1.74827 14.3259 1.74827 13.1773V8.47937C1.74827 8.44178 1.75102 8.4042 1.75744 8.36753C1.73721 8.24396 1.75111 8.11721 1.79765 8.00096C1.84419 7.88472 1.92159 7.78339 2.0215 7.70791C2.12141 7.63243 2.24004 7.58568 2.36458 7.57269C2.48912 7.5597 2.61485 7.58097 2.72818 7.6342L7.11168 9.69028C7.65551 9.94903 8.25019 10.0833 8.85244 10.0833C9.45468 10.0833 10.0494 9.94903 10.5932 9.69028L16.7266 6.8147C17.096 6.64145 17.3316 6.22803 17.3316 5.72937C17.3316 5.2307 17.096 4.81728 16.7266 4.64403L10.5941 1.76845C10.0503 1.5097 9.4556 1.37544 8.85335 1.37544C8.25111 1.37544 7.65643 1.5097 7.1126 1.76845L0.980101 4.64403C0.815026 4.72159 0.625904 4.73039 0.45434 4.6685C0.282775 4.60661 0.142822 4.47911 0.0652682 4.31403C-0.0122856 4.14896 -0.0210871 3.95984 0.0407999 3.78827C0.102687 3.61671 0.230193 3.47675 0.395268 3.3992L6.52869 0.522699ZM3.12327 9.34012V13.1782C3.12327 13.8776 3.47069 14.4991 4.03902 14.8144C4.69535 15.1774 5.54052 15.6046 6.41318 15.9392C7.29593 16.2784 8.15394 16.5011 8.85244 16.5011C9.55093 16.5011 10.4089 16.2784 11.2926 15.9392C12.1085 15.6184 12.9017 15.2426 13.6668 14.8144C14.2351 14.4991 14.5816 13.8776 14.5816 13.1782V9.34012L11.1771 10.936C10.4507 11.2804 9.65681 11.459 8.85289 11.459C8.04898 11.459 7.25511 11.2804 6.52869 10.936L3.12327 9.3392V9.34012Z\"/></svg> My Course </a><a href=tel:03111444734 class=sidebar-btn target=_blank><svg width=17 height=17 viewBox=\"0 0 17 17\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M15.5375 16.5C13.5667 16.5 11.6456 16.0606 9.77442 15.1818C7.90319 14.3031 6.24556 13.1419 4.8015 11.6985C3.35744 10.2551 2.19633 8.59742 1.31817 6.72558C0.44 4.85375 0.000611111 2.93272 0 0.9625C0 0.6875 0.0916666 0.458333 0.275 0.275C0.458333 0.0916666 0.6875 0 0.9625 0H4.675C4.88889 0 5.07986 0.0687499 5.24792 0.20625C5.41597 0.34375 5.51528 0.519444 5.54583 0.733333L6.14167 3.94167C6.17222 4.15556 6.16825 4.3505 6.12975 4.5265C6.09125 4.7025 6.00356 4.85894 5.86667 4.99583L3.64375 7.24167C4.28542 8.34167 5.09147 9.37292 6.06192 10.3354C7.03236 11.2979 8.09783 12.1306 9.25833 12.8333L11.4125 10.6792C11.55 10.5417 11.7297 10.4384 11.9515 10.3693C12.1733 10.3003 12.3909 10.2813 12.6042 10.3125L15.7667 10.9542C15.9806 11 16.1562 11.1033 16.2938 11.264C16.4313 11.4247 16.5 11.6117 16.5 11.825V15.5375C16.5 15.8125 16.4083 16.0417 16.225 16.225C16.0417 16.4083 15.8125 16.5 15.5375 16.5ZM2.77292 5.5L4.28542 3.9875L3.89583 1.83333H1.85625C1.93264 2.45972 2.03958 3.07847 2.17708 3.68958C2.31458 4.30069 2.51319 4.90417 2.77292 5.5ZM14.6667 14.6208V12.6042L12.5125 12.1687L10.9771 13.7042C11.5729 13.9639 12.1801 14.1701 12.7985 14.3229C13.4169 14.4757 14.0397 14.575 14.6667 14.6208Z\"/></svg> 0311-1444734 </a><!-- <div class=\"buttonset\">\n        <md-button class=\"md-raised\"\n          ><a\n            href=\"tel:03111444734\"\n            style=\"font-size: 30px; letter-spacing: 1px; color: white\"\n            target=\"_blank\"\n            ><span>03111444734</span></a\n          ></md-button\n        >\n        <label\n          style=\"width: 100%; padding: 0px 15px !important; position: relative\"\n          class=\"velocity-hamburger\"\n          ng-if=\"token\"\n        >\n          <a\n            ng-href=\"{{env.velocityPortal}}/landing?uid={{userInfo.id}}&token={{token}}\"\n           \n            class=\"velocity-hamburger\"\n            style=\"position: relative; display: flex; flex-direction: column\"\n            ><span style=\"height: 35px;\">\n              <img\n                src=\"./../../images/Icon - Courses.svg\"\n                style=\"width: 35px; padding-bottom: 5px\"\n              />\n              My Courses</span\n            >\n            <span style=\"font-size: 12px; margin-bottom: 5px\"\n              >{{userVisits}} Students are already enjoying</span>\n              </a\n          >\n        </label>\n      </div> --><ul><li><a target=_blank href=https://web.facebook.com/nearpeer.org/ ><img src=../../images/icons/fb.svg alt=\"nearpeer facebook\"></a></li><li><a target=_blank href=https://twitter.com/NearPeer><img src=../../images/icons/twitter.svg alt=\"nearpeer twitter\"></a></li><li><a target=_blank href=\"https://api.whatsapp.com/send?phone=923111444734\"><img src=../../images/icons/whatsapp.svg alt=\"nearpeer whatsapp\"></a></li></ul></div></div><div class=header-contact ng-class=\"{\'main-screen\': !loggedIn}\" ng-if=!platform_reactApp_new><div class=course-search-desktop><div class=course-search><input type=text id=courseSearch name=course-search ng-model=search ng-change=courseSearchListOpen(search) placeholder=\"Course Search\"><div style=\"width: 25px\" ng-if=\"search != \'\'\" ng-click=closeThis()><img src=../../images/cross-icon.svg alt=\"\"></div><div ng-if=\"search == \'\'\"><svg width=25 height=25 viewBox=\"0 0 25 25\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_4602_34472)><path d=\"M16.713 11.021C16.713 9.24219 16.0808 7.72055 14.8164 6.45613C13.552 5.19171 12.0303 4.5595 10.2515 4.5595C8.47266 4.5595 6.95102 5.19171 5.6866 6.45613C4.42218 7.72055 3.78996 9.24219 3.78996 11.021C3.78996 12.7999 4.42218 14.3215 5.6866 15.5859C6.95102 16.8504 8.47266 17.4826 10.2515 17.4826C12.0303 17.4826 13.552 16.8504 14.8164 15.5859C16.0808 14.3215 16.713 12.7999 16.713 11.021ZM24.0977 23.021C24.0977 23.521 23.915 23.9537 23.5496 24.3191C23.1842 24.6845 22.7515 24.8672 22.2515 24.8672C21.7323 24.8672 21.2996 24.6845 20.9534 24.3191L16.0063 19.3864C14.2852 20.5787 12.3669 21.1749 10.2515 21.1749C8.8765 21.1749 7.5616 20.9081 6.30679 20.3744C5.05198 19.8407 3.97025 19.1196 3.0616 18.2109C2.15294 17.3023 1.43179 16.2206 0.898137 14.9657C0.364483 13.7109 0.0976562 12.396 0.0976562 11.021C0.0976562 9.64603 0.364483 8.33113 0.898137 7.07632C1.43179 5.82151 2.15294 4.73978 3.0616 3.83113C3.97025 2.92248 5.05198 2.20132 6.30679 1.66767C7.5616 1.13401 8.8765 0.867188 10.2515 0.867188C11.6265 0.867188 12.9414 1.13401 14.1962 1.66767C15.451 2.20132 16.5328 2.92248 17.4414 3.83113C18.3501 4.73978 19.0712 5.82151 19.6049 7.07632C20.1385 8.33113 20.4053 9.64603 20.4053 11.021C20.4053 13.1364 19.8092 15.0547 18.6169 16.7758L23.564 21.723C23.9198 22.0787 24.0977 22.5114 24.0977 23.021Z\" fill=#16B9D6 /></g><defs><clipPath id=clip0_4602_34472><rect width=24 height=24 fill=white transform=\"translate(0.0976562 0.867188)\"/></clipPath></defs></svg></div><ul class=course-search-list ng-if=courseSearchList click-outside=closeThis()><li ng-repeat=\"course in filterdData\"><div class=course-search-item ng-click=goToCourse(course)><div class=course-search-img><img ng-src={{course.image_url}} alt=#></div><div><p class=course-search-name>{{course.name}}</p><span class=course-search-category>{{course.course_tag}}</span></div></div></li><!-- <li>\n            <div class=\"course-search-img\">\n              <img src=\"../../images/Faisal-Basheer.jpg\" alt=\"#\"></div>\n            <div>\n              <p class=\"course-search-name\">Course Name</p>\n              <span class=\"course-search-category\">CSS</span>\n            </div>\n          </li> --></ul></div></div><div class=course-search-mobile><div ng-click=courseSearchOpen()><svg width=25 height=25 viewBox=\"0 0 25 25\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_4602_34472)><path d=\"M16.713 11.021C16.713 9.24219 16.0808 7.72055 14.8164 6.45613C13.552 5.19171 12.0303 4.5595 10.2515 4.5595C8.47266 4.5595 6.95102 5.19171 5.6866 6.45613C4.42218 7.72055 3.78996 9.24219 3.78996 11.021C3.78996 12.7999 4.42218 14.3215 5.6866 15.5859C6.95102 16.8504 8.47266 17.4826 10.2515 17.4826C12.0303 17.4826 13.552 16.8504 14.8164 15.5859C16.0808 14.3215 16.713 12.7999 16.713 11.021ZM24.0977 23.021C24.0977 23.521 23.915 23.9537 23.5496 24.3191C23.1842 24.6845 22.7515 24.8672 22.2515 24.8672C21.7323 24.8672 21.2996 24.6845 20.9534 24.3191L16.0063 19.3864C14.2852 20.5787 12.3669 21.1749 10.2515 21.1749C8.8765 21.1749 7.5616 20.9081 6.30679 20.3744C5.05198 19.8407 3.97025 19.1196 3.0616 18.2109C2.15294 17.3023 1.43179 16.2206 0.898137 14.9657C0.364483 13.7109 0.0976562 12.396 0.0976562 11.021C0.0976562 9.64603 0.364483 8.33113 0.898137 7.07632C1.43179 5.82151 2.15294 4.73978 3.0616 3.83113C3.97025 2.92248 5.05198 2.20132 6.30679 1.66767C7.5616 1.13401 8.8765 0.867188 10.2515 0.867188C11.6265 0.867188 12.9414 1.13401 14.1962 1.66767C15.451 2.20132 16.5328 2.92248 17.4414 3.83113C18.3501 4.73978 19.0712 5.82151 19.6049 7.07632C20.1385 8.33113 20.4053 9.64603 20.4053 11.021C20.4053 13.1364 19.8092 15.0547 18.6169 16.7758L23.564 21.723C23.9198 22.0787 24.0977 22.5114 24.0977 23.021Z\" fill=#fff /></g><defs><clipPath id=clip0_4602_34472><rect width=24 height=24 fill=white transform=\"translate(0.0976562 0.867188)\"/></clipPath></defs></svg></div><div class=course-search-overlay ng-class=\"{\'course-search-animation\' : courseSearch }\" ng-show=courseSearch><div class=course-search><input type=text id=courseSearch name=course-search ng-model=search ng-change=courseSearchListOpen(search) placeholder=\"Course Search\"><div style=\"width: 25px\" ng-if=\"search != \'\'\" ng-click=closeThis()><img src=../../images/cross-icon.svg alt=\"\"></div><div ng-if=\"search == \'\'\"><svg width=25 height=25 viewBox=\"0 0 25 25\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_4602_34472)><path d=\"M16.713 11.021C16.713 9.24219 16.0808 7.72055 14.8164 6.45613C13.552 5.19171 12.0303 4.5595 10.2515 4.5595C8.47266 4.5595 6.95102 5.19171 5.6866 6.45613C4.42218 7.72055 3.78996 9.24219 3.78996 11.021C3.78996 12.7999 4.42218 14.3215 5.6866 15.5859C6.95102 16.8504 8.47266 17.4826 10.2515 17.4826C12.0303 17.4826 13.552 16.8504 14.8164 15.5859C16.0808 14.3215 16.713 12.7999 16.713 11.021ZM24.0977 23.021C24.0977 23.521 23.915 23.9537 23.5496 24.3191C23.1842 24.6845 22.7515 24.8672 22.2515 24.8672C21.7323 24.8672 21.2996 24.6845 20.9534 24.3191L16.0063 19.3864C14.2852 20.5787 12.3669 21.1749 10.2515 21.1749C8.8765 21.1749 7.5616 20.9081 6.30679 20.3744C5.05198 19.8407 3.97025 19.1196 3.0616 18.2109C2.15294 17.3023 1.43179 16.2206 0.898137 14.9657C0.364483 13.7109 0.0976562 12.396 0.0976562 11.021C0.0976562 9.64603 0.364483 8.33113 0.898137 7.07632C1.43179 5.82151 2.15294 4.73978 3.0616 3.83113C3.97025 2.92248 5.05198 2.20132 6.30679 1.66767C7.5616 1.13401 8.8765 0.867188 10.2515 0.867188C11.6265 0.867188 12.9414 1.13401 14.1962 1.66767C15.451 2.20132 16.5328 2.92248 17.4414 3.83113C18.3501 4.73978 19.0712 5.82151 19.6049 7.07632C20.1385 8.33113 20.4053 9.64603 20.4053 11.021C20.4053 13.1364 19.8092 15.0547 18.6169 16.7758L23.564 21.723C23.9198 22.0787 24.0977 22.5114 24.0977 23.021Z\" fill=#16B9D6 /></g><defs><clipPath id=clip0_4602_34472><rect width=24 height=24 fill=white transform=\"translate(0.0976562 0.867188)\"/></clipPath></defs></svg></div><ul class=course-search-list ng-if=courseSearchList><li ng-repeat=\"course in filterdData\"><div class=course-search-item ng-click=goToCourse(course)><div class=course-search-img><!-- <img src=\"../../images/Faisal-Basheer.jpg\" alt=\"#\"></div> --> <img ng-src={{course.image_url}} alt=#></div><div><p class=course-search-name>{{course.name}}</p><span class=course-search-category>{{course.course_tag}}</span></div></div></li><!-- <li>\n              <div class=\"course-search-img\">\n                <img src=\"../../images/Faisal-Basheer.jpg\" alt=\"#\"></div>\n              <div>\n                <p class=\"course-search-name\">Course Name</p>\n                <span class=\"course-search-category\">CSS</span>\n              </div>\n            </li> --></ul></div><div class=course-search-close ng-click=courseSearchClose()><img src=../../images/course-search-icon-close.svg alt=#></div></div></div><div class=parent-popup ng-if=token><a ng-href=\"{{env.velocityPortal}}/landing?uid={{userInfo.id}}&token={{token}}\" class=velocity-parent><!-- <span class=\"velocity-circle\">{{userVisits}}</span> --> <button ng-click=myCourseEvent() class=velocity>My Courses</button><!-- <span class=\"tooltiptext\">{{userVisits}} of your peers are already enjoying The Velocity Portal</span> --> </a><!-- <div class=\"velocity-popup\">\n        <div>\n          <img\n            src=\"./../../images/Login-Sign-Up-Illustration.svg\"\n            class=\"img-pop mt-3\"\n          />\n        </div>\n        <div>\n          <p class=\"popup-text\">The Nearpeer Velocity Portal</p>\n          <p class=\"popup-text-p\" style=\"text-align: center\">\n            All your study requirements in one place.\n          </p>\n          <p class=\"border-bottom\"></p>\n        </div>\n        <div class=\"peers-div\">\n          <img\n            src=\"./../../images/Icon ionic-ios-people.svg\"\n            style=\"width: 28px\"\n          />\n          <p class=\"popup-text-p\">\n            <b>{{userVisits}}</b> of your peers are already enjoying The\n            Nearpeer Velocity Portal.\n          </p>\n        </div>\n        <div>\n          <a\n            ng-href=\"https://velocity.nearpeer.org/landing?uid={{userInfo.id}}&token={{token}}\"\n            ><button class=\"try-now\">Visit Now</button></a\n          >\n        </div>\n      </div> --></div><div class=noti-panel><a ng-if=token class=\"noti-icon dropdown-toggle\" href=# role=button id=dropdownMenuLink data-toggle=dropdown aria-haspopup=true aria-expanded=false ng:class=\"{\'new-noti\' : !notificationClicked}\" ng-click=openNotifications()><div ng-if=\"unreadNotification > 0\" class=unread-count><p style=\"font-size: 12px; color: white; margin: 0 0 0 0\">{{unreadNotification > 9 ? \'9+\' : unreadNotification}}</p></div><i class=\"fa fa-bell\" aria-hidden=true></i></a><div class=\"noti-dropdown dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuLink><div class=noti-header><h4 style=\"font-size: 20px !important\">Notification</h4><a ng-click=\"goToState(\'All-Notification\')\">See All</a> <a href=# class=noti-close><img src=../../images/noti-close.png></a></div><ul class=noti-list><li ng-repeat=\"notification in notifications\" ng-class=\"{\'read\': notification.is_clicked}\"><div class=noti-date ng-if=\"showDate(notification, $index)\">{{showDate(notification, $index)}}</div><a ng-click=clickNotification(notification) class=\"noti-item important\"><div class=noti-thumb><img ng-if=!notification.notifications.thumbnail_url src=../../images/Notification_Icon_large.svg alt=#> <img ng-if=notification.notifications.thumbnail_url ng-src={{notification.notifications.thumbnail_url}} alt=#></div><div class=noti-detail><div class=noti-title>{{notification.notifications.title}}</div><div class=noti-shrtdetail>{{notification.notifications.description}}</div><div class=noti-time><span>{{showTime(notification)}}</span><!-- <div class=\"noti-important\">\n                    <i class=\"fa fa-star\" aria-hidden=\"true\"></i>\n                  </div> --></div></div></a></li></ul><div ng-if=\"!isLoading && notifications.length === 0\" style=\"display: flex; justify-content: center; padding: 20px\"><p>No recent notification</p></div><span style=\"display: flex; justify-content: center; padding: 20px\" ng-show=isLoading><div class=round-loader></div></span></div></div><div class=header-cart title=\"My orders\" title-direction=bottom ng-click=goToOrders() ng-if=userID><div class=header-cart-icon><svg width=25 height=28 viewBox=\"0 0 25 28\" xmlns=http://www.w3.org/2000/svg><path d=\"M21.4482 14.3564H2.71143L4.52884 26.8689H19.9596L21.4482 14.3564Z\" stroke-linecap=round /><path d=\"M5.18555 8.36003L9.1589 2.01892M18.9756 8.36003L15.3528 2.01892\" stroke-width=2 stroke-linecap=square /><rect y=8.24133 width=24.16 height=4.13117 /></svg></div><div class=header-cart-order ng-if=\"ordersCount > 0\">{{ordersCount}}</div></div><div class=instructor-link><a class=\"fas fa-phone\" href=tel:03111444734 target=_blank><span>03111444734</span></a></div><div class=responsive-search-icon ng-click=showResponsiveSearch()><a></a></div><div class=account-pop ng-hide=loggedIn><!-- <a ng-click=\"showNewLoginPopup()\">login</a> --></div><div class=joinUs ng-show=!loggedIn><!-- role=\"button\" id=\"joinUs_dropDown_link\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" --> <a class=\"joinUs_toggle dropdown-toggle\" ng-click=\"showNewLoginPopup(\'login\')\">Join Us<!-- <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i> --></a><div class=\"joinUs_dropDown dropdown-menu dropdown-menu-right fadeInDownCustom\" aria-labelledby=joinUs_dropDown_link><a ng-click=\"showNewLoginPopup(\'login\')\">Login</a><!-- <a ng-click=\"showNewLoginPopup()\">Login</a> --> <a ng-click=\"showNewLoginPopup(\'signup\')\">Sign Up</a></div></div><!-- <div\n      class=\"account-pop account-pop-resposive\"\n      data-toggle=\"modal\"\n      data-target=\"#AccountSettings\"\n      ng-show=\"loggedIn\"\n    >\n      <p class=\"flex-view align-items-center\">\n        <a ng-click=\"showMyAccountPopup()\" style=\"max-width: 100px;\n        white-space: nowrap;\n        height: 35px;\n        overflow: hidden;\" title=\"{{customerName}}\" title-direction=\"bottom\">{{customerName}}</a>\n        <span ng-click=\"showMyAccountPopup()\"\n          >{{getInitial(customerName)}}</span\n        >\n      </p>\n      <label ng-if=\"mergeTooltip\" class=\"ct-tool-hover merge-dot\"  \n      ></label>\n    </div> --><div class=user-popup ng-show=loggedIn><!-- role=\"progressbarHeader\" aria-valuenow=\"65\" aria-valuemin=\"0\" aria-valuemax=\"100\"\n      style=\"--value: {{percentageCompleted}}\" --><div class=\"user-noti-avatar dropdown-toggle\" type=button data-toggle=dropdown ng-click=userDropDown() ng:class=\"{\'user-verified\': userVerified , \'circular-progress\' : !userVerified }\" title=\"{{percentageCompleted === 100 || percentageCompleted === 0  ? \'\' : \'Your profile is \' + percentageCompleted.toFixed(0)  +\'% complete .\' }}\" title-direction=bottom><img ng-if=!userInfo.image src=../../images/male-dp.svg> <img ng-if=userInfo.image src={{userInfo.image}}></div><!-- <label ng-if=\"mergeTooltip\" class=\"ct-tool-hover merge-dot\"  \n      ></label> --><!-- <label ng-if=\"!userVerified && !guestUser\" class=\"ct-tool-hover profile-comp-dot\"  \n      ></label> --><div class=\"user-dropdown dropdown-menu pull-right\"><div class=popup-link-shape></div><div class=position-relative><div class=user-avatar><img ng-if=userInfo.image src={{userInfo.image}}> <img ng-if=!userInfo.image src=../../images/male-dp.svg><p>{{customerName}}</p></div><ul class=user-details><li class=user-email ng-if=userInfo.email><p>{{(userInfo || {}).email}}</p></li><li>User ID: {{(userInfo || {}).id}}</li><li>Joined at: {{joiningDate}}</li><li ng-show=userInfo.phone>{{(userInfo || {}).phone}}</li><li>Paid courses: {{paidCourses}}</li><li class=flex-view>Joined through:<!-- social icon class names --><!-- \n            fb\n            google\n            guest\n            apple\n            np \n          --><div class=user-social ng:class=\"{\'fb\': (userInfo || {}).provider== \'facebook\' , \'google\': (userInfo || {}).provider== \'google\' , \'apple\': (userInfo || {}).provider== \'apple\' , \'np\': (userInfo || {}).provider== \'email\' }\"><img class=guest-icon src=../../images/guest-icon.png alt=guest-icon> <img class=fb-icon src=../../images/fb-icon.png alt=facbook-icon> <img class=google-icon src=../../images/google-icon.png alt=google-icon> <img class=apple-icon src=../../images/apple-icon.png alt=apple-icon> <img class=np-icon src=../../images/np-icon.png alt=np-icon></div></li><li ng-click=\"goToState(\'profile_settings\')\" style=\"background: #16b9d6;\n         margin: 8px 25px;\n         padding: 5px;\n         display: flex;\n         justify-content: center;\n         border-radius: 8px\"><a style=\"color: white;\n    font-size: 13px;\n    font-weight: 300;\n    margin: 0\"><b>View profile <img ng-if=\"(mergeTooltip || !userVerified) && !guestUser\" src=\"./../../images/info icon.svg\" style=\"width: 15px;\n          margin-left: 5px;\n          margin-bottom: 2px\"> </b></a></li><li class=user-enrolled-courses><img src=../../images/course-enrolled-icon.svg alt=\"\"> {{enrolledCourses}} Courses Enrolled</li><li ng-click=logOut()><img src=../../images/signout-icon.svg alt=\"\"> Sign Out</li></ul></div></div></div><p class=custom-tooltip id=custom-tooltip style=\"position: absolute; visibility: hidden;  bottom: 50px\"></p><p class=ct-tool id=custom-tooltip-1 style=\"position: absolute;\n      visibility: hidden;\n      top: 73px;\n    right: 16px;\n      font-size: 14px!important;\n      background: black;\n      color: white;\n      padding: 5px 10px;\n      border-radius: 8px;\n      box-shadow: 0 4px 2px -2px gray\"><img src=\"./../../images/Polygon 2.svg\" style=\"position: absolute;\n      right: 25px;\n      top: -6px\"> Merge your accounts. <img src=./../../images/Icon-Close-white.svg ng-click=closeMergeTooltip() style=\"width:14px ;margin-left:10px\"></p><p></p></div><div class=header-contact ng-if=platform_reactApp_new><div ng-click=closeWebview()><div class=header-cart-icon style=\"font-size: 25px; margin-top: 8px;color: white\">X</div></div></div></header><!-- bread crumbs --><bread-crumbs ng-class=\"{\'mdcat-header\' : mdCatlandingPage === \'mdcat\',\'css-header\' :mdCatlandingPage===\'css\'}\" ng-if=\"breadCrumb && isLanding != \'Login\' && isLanding != \'Login_Social\' && isLanding != \'storeel\' && isLanding != \'Reel-Unique-Link\'\"></bread-crumbs><!-- VERIFCATION BANNER HTML STARTES HERE\n  ng:class=\"{\'promo-margin\' : showPromo}\" top-position------------------------------------------------ --><div class=\"flex-view verification-banner align-items-center\" ng-if=banner style=\"width: 100%\"><img src=\"./../../images/Group 10294.svg\" class=display-none> <img src=\"./../../images/Group 102941.svg\" class=display-none-not><div class=\"flex-view flex-direction-row justify-content-between banner-padding\" style=\"width: 100%\"><div class=\"flex-view align-items-center text-width\"><!-- <img\n      src=\"./../../images/Info-icon.svg\"\n        style=\" width: 20px;\n          position: relative;\n          right: 15px;\n          bottom: 30px;\"\n      /> --><div class=\"flex-view flex-direction-col\"><p class=\"body-2 font-family-bold text-color banner-font\" style=\"font-weight: bold;    margin: 0\">Your Email is not Verified.</p></div></div><div class=\"flex-view align-items-center banner-buttons\"><button class=btn-contained style=\"height: 27px;\n      display: flex;\n      align-items: center;\n      font-size: 16px\" ng-click=openEmailVerification()>Verify</button><p class=text-filled style=\"margin: 0\" ng-click=closeBanner()><img src=./../../images/Icon-Close-white.svg style=\"margin-left: 12px\"></p></div></div></div><div class=\"flex-view verification-banner align-items-center\" ng-if=phoneBanner style=\"width: 100%\"><img src=\"./../../images/Group 10294.svg\" class=display-none> <img src=\"./../../images/Group 102941.svg\" class=display-none-not><div class=\"flex-view flex-direction-row justify-content-between banner-padding\" style=\"width: 100%\"><div class=\"flex-view align-items-center text-width\"><!-- <img\n      src=\"./../../images/Info-icon.svg\"\n        style=\" width: 20px;\n          position: relative;\n          right: 15px;\n          bottom: 30px;\"\n      /> --><div class=\"flex-view flex-direction-col\"><p class=\"body-2 font-family-bold text-color banner-font\" style=\"font-weight: bold;    margin: 0\">Your Phone is not Verified.</p></div></div><div class=\"flex-view align-items-center banner-buttons\"><button class=btn-contained style=\"height: 27px;\n      display: flex;\n      align-items: center;\n      font-size: 16px\" ng-click=openPhoneVerification()>Verify</button><p class=text-filled style=\"margin: 0\" ng-click=closePhoneBanner()><img src=./../../images/Icon-Close-white.svg style=\"margin-left: 12px\"></p></div></div></div><div class=\"flex-view guest-banner align-items-center\" ng-if=\"guestUser && reactAllCourses===0\" style=\"width: 100%\"><img src=\"./../../images/Group 10342.svg\" class=display-none> <img src=\"./../../images/Group 10343.svg\" class=display-none-not><div class=\"flex-view flex-direction-row justify-content-between banner-padding\" style=\"margin: 0 auto; width: 100%\"><div class=\"flex-view align-items-center text-width\"><!-- <img\n      src=\"./../../images/Info-icon.svg\"\n        style=\" width: 20px;\n          position: relative;\n          right: 15px;\n          bottom: 30px;\n      \"\n      \n      /> --><div class=\"flex-view flex-direction-col\"><p class=\"body-2 font-family-bold text-color display-none banner-font\" style=\"font-weight: bold;    margin: 0\">You are in Guest Mode . Login for Full Access.</p><p class=\"body-2 font-family-bold text-color display-none-not banner-font\" style=\"font-weight: bold;     margin: 0\">You are in Guest Mode .</p></div></div><div class=\"flex-view align-items-center banner-buttons\"><button class=btn-contained style=\"height: 27px;\n      display: flex;\n      align-items: center;\n      font-size: 16px\" ng-click=\"showNewLoginPopup(\'signup\')\">Sign up</button><p class=text-filled style=\"margin: 0\" ng-click=closeGuestBanner()><img src=./../../images/Icon-Close-white.svg style=\"margin-left: 12px\"></p></div></div></div><div class=signup-bg style=\"overflow: auto\" ng-if=signupPopUp><div class=\"signup-holder flex-view justify-content-around align-items-center flex-direction-col signup-parent\"><span class=closeButtonImage style=\"top: 0\" ng-click=closeSignup()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div><img src=./../../images/np-red.svg></div><div class=\"flex-view flex-direction-row-col justify-content-around common-right-div\"><div class=\"flex-view flex-direction-col align-items-center mobile-display\"><img src=\"./../../images/Group 10068.svg\" class=left-verify-image><h5 class=\"welcome-text mt-4 mb-2\">Don\'t stop your journey.....</h5><p class=\"body-2 text-align-center\" style=\"max-width: 275px\">Please sign up to continue using the Nearpeer Velocity Portal.</p></div><div class=\"flex-view flex-direction-col ease-out justify-content-around margin-auto\" style=\"width: 300px\"><div class=mb-3><h5 class=font-family-bold style=\"color: #E03249\">Signup</h5></div><div class=\"flex-view mb-2 flex-direction-col input-border\"><label class=subtitle-1>Full Name</label><input class=body-2 ng-model=signUp.full_name placeholder=\"Full Name\"></div><div class=\"flex-view mb-2 flex-direction-col input-border\"><label class=subtitle-1>Email</label><input class=body-2 ng-model=signUp.email type=email placeholder=Email></div><div class=\"flex-view mb-2 flex-direction-col input-border\"><label class=subtitle-1>Contact</label><input class=body-2 ng-model=signUp.contact placeholder=Contact></div><div class=\"flex-view mb-2 flex-direction-col input-border\"><label class=subtitle-1>Password</label><input class=body-2 ng-model=signUp.password placeholder=\"Enter 8 to 20 characters\" type=password></div><div class=\"flex-view flex-direction-col mb-2 input-border\"><label class=subtitle-1>Confirm Password</label><input class=body-2 ng-model=signUp.confirmPassword placeholder=\"Confirm your password\" type=password></div><div class=\"flex-view mb-2 flex-direction-row justify-content-between align-items-center\"><div class=\"flex-view flex-direction-col marg-right\"><label class=subtitle-1>Date of Birth</label><div class=\"flex-view justify-content-between mt-2\" style=\"width: 168px\"><input type=date class=body-2 id=date name=date value=dob ng-model=signUp.dob style=\"width: 150px\" max={{currentDate}}></div></div><div class=\"flex-view flex-direction-col\"><label class=subtitle-1>Gender</label><div class=\"flex-view gen-div mt-2\"><div class=\"flex-view justify-content-between mr-3\"><label class=subtitle-1>Male</label><input type=radio class=\"body-2 ml-2\" id=gender name=gender value=male ng-model=signUp.gender style=\"margin-left: 8px\"></div><div class=\"flex-view justify-content-between mr-3\"><label class=subtitle-1 style=\"margin-left: 8px\">Female</label><input type=radio class=\"body-2 ml-2\" id=gender name=gender value=female ng-model=signUp.gender style=\"margin-left: 8px\"></div></div></div></div><div class=\"error-div ellipsis_\"><div class=blue-loader ng-if=loader></div><p class=error-message ng-if=errorMessage>{{errorMessage}}</p></div><p class=pg-signup>By creating an account, I accept Nearpeer\'s Terms of Service and Privacy Policy.</p><button ng-click=postSignup(signUp) class=\"btn-contained button-alignment mt-3\">Create Account</button></div></div></div></div><div class=\"signup-bg flex-view align-items-center\" style=\"overflow: scroll\" ng-if=emailVerification><div class=\"otp-holder otp-holder-mbl flex-view justify-content-around align-items-center flex-direction-row-col signup-parent\" style=\"width: 100%\"><span class=closeButtonImage style=\"top: 0\" ng-click=closeEmail()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><!-- <button class=\"btn-np text-filled back-hover\" ng-click=\"backVerifyPopup()\" style=\"color: #00000069 !important;\n    left: 0;\n    top: 14px;\n    position: absolute;border:none !important\" ng-if=\"!editable\"><img style=\"width: 8px;\n      margin-right: 5px;\" src=\"./../../images/arrowleft.svg\"> Back</button> --><div class=\"flex-view flex-direction-row-col justify-content-around common-right-div\"><div class=\"flex-view flex-direction-col align-items-center\"><img src=\"./../../images/image 45.svg\" class=left-verify-image><!-- ./../../images/Group 10295.svg --></div><div class=\"flex-view flex-direction-col ease-out justify-content-around right-email-div\" ng-if=\"!emailSent && before\" style=\"max-width: 330px;height: 292px\" ;><h3 class=mb-2 style=\"font-weight: bold\">Verify Email Address</h3><p class=\"body-2 mt-3\">Please verify your email address to continue watching videos. You will not be able to watch further videos without verification.</p><div class=\"flex-view flex-direction-col\"><div class=\"flex-view mb-2 flex-direction-col\" style=\"position: relative\"><label class=subtitle-1 style=\"position: absolute;\n          left: 15px;\n          bottom: 33px;\n          background: white;\n          width: 70px\">Your Email</label><!-- <input ng-if=\"editable\" class=\"body-2\" ng-model=\"missingCredentials.email\" type=\"email\" disabled=\"{{editable}}\" value=\"missingCredentials.email\" style=\"border:1px solid rgb(0 0 0 / 29%);\n                border-radius: 5px;\n                padding: 10px 15px;\n          background: transparent;\" /> --> <input class=body-2 ng-model=missingCredentials.email type=email value=missingCredentials.email style=\"border: 1px solid rgb(0 0 0 / 29%);\n                    border-radius: 5px;\n                    padding: 10px 15px;\n                              background: transparent;height:48px\"><!-- <img ng-if=\"editable\" ng-click=\"penClick()\" src=\"./../../images/edit (2).svg\" class=\"red-pen\" title=\"Edit your email\" /> --></div><div class=\"error-div ellipsis_\"><div class=blue-loader ng-if=loader></div><p class=error-message ng-if=errorMessage>{{errorMessage}}</p></div><!-- <button class=\"btn-contained\" ng-click=\"postMissingCredentials(missingCredentials.email,\'send\', \'email\')\" style=\"width: 180px;\" ng-if=\"editable\">\n        Send Verification\n        </button> --> <button class=btn-contained ng-click=\"postMissingCredentials(missingCredentials.email,\'update\', \'email\')\" style=\"width: 180px\">Send Verification</button></div><!-- <div class=\"flex-view flex-direction-col button-position\">\n        <button class=\"btn-contained\" ng-click=\"sendEmailVerification()\"> SEND VERIFICATION EMAIL</button>\n \n    </div> --></div><div class=\"flex-view flex-direction-col ease-out justify-content-around right-email-div\" ng-if=emailSent style=\"max-width: 330px\"><h3 class=\"mb-2 flex-view\" style=\"font-weight: bold\">Email Sent <img src=\"./../../images/Icon - Done or Correct.svg\" class=ml-1></h3><p class=body-2>An email has been sent to <b>{{missingCredentials.email}}</b>.<br><br>Please click on the link provided in the email to verify your email address within 3 hours.</p><button class=\"btn-np outlined m-0 mt-3\" ng-click=sendEmailVerification(missingCredentials.email)>Resend Email</button></div></div></div></div><div class=\"signup-bg flex-view align-items-center\" ng-if=phoneVerification><div class=\"otp-holder otp-holder-mbl flex-view justify-content-around align-items-center flex-direction-row-col signup-parent\" style=\"width: 100%\"><span ng-if=!forceEnter class=closeButtonImage style=\"top: 0\" ng-click=closeEmail()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><!-- <button ng-if=\"!forceEnter\" class=\"btn-np text-filled back-hover\" ng-click=\"backVerifyPopup()\" style=\"color: #00000069 !important;\n      left: 0;\n      top: 14px;\n      position: absolute;border: none !important;\" ng-if=\"!editable\"><img style=\"width: 8px;\n        margin-right: 5px;\" src=\"./../../images/arrowleft.svg\"> Back</button> --><div class=\"flex-view flex-direction-row-col justify-content-around common-right-div\"><div class=\"flex-view flex-direction-col align-items-center\"><img src=\"./../../images/image 47.svg\" class=left-verify-image><!-- ./../../images/Group 10295.svg --></div><div class=\"flex-view flex-direction-col ease-out justify-content-around right-email-div transition\" ng-show=!emailSent style=\"max-width: 330px;height: 292px\" ;><h3 class=mb-2 style=\"font-weight: bold\">{{forceEnter ? \'Add Phone Number\' : \'Verify Phone Number\' }}</h3><p class=\"body-2 mt-3\">Please {{forceEnter ? \'add\' : \'verify\' }} your phone number to continue watching videos. You will not be able to watch further videos without phone number.</p><div class=\"flex-view flex-direction-col\"><div class=\"flex-view mb-2 flex-direction-col\" style=\"position: relative\"><label class=subtitle-1 style=\"position: absolute;\n            left: 15px;\n            bottom: 33px;\n            background: white;\n            width: 75px\">Your Phone</label><div style=\"height:48px;display: flex; flex-direction: row; border: 1px solid rgb(0 0 0 / 29%); border-radius: 5px; padding: 10px 15px; background: transparent\"><!-- <select\n            name=\"countryCode\"\n            id=\"\"\n            style=\"border: 0px;\"\n            v-model=\"missingCredentials.countryCode\"\n          >\n            <option value=\"92\">+92</option>\n          </select> --> <input type=text style=\"width: 50px\" id=country-phone-verify class=country-code-dropdown> <input class=\"body-2 banner-font\" style=\"margin-left: 30px;\n          width: 100%\" maxlength=16 ng-model=missingCredentials.phone value=missingCredentials.phone></div></div><div class=\"error-div ellipsis_\"><div class=blue-loader ng-if=loader></div><p class=error-message ng-if=errorMessage>{{errorMessage}}</p></div><div style=\"display: flex; flex-direction: row\"><!-- <button class=\"btn-contained\" ng-click=\"postMissingCredentials(missingCredentials.phone,\'send\', \'phone\')\" style=\"width: 180px;\" ng-if=\"editable\">\n              Send Verification\n                </button> --> <button ng-if=!isQRCode class=\"outlined btn-np hover-add\" ng-click=\"postMissingCredentials(missingCredentials,\'update\', \'phone\')\" style=\"width: 180px\">Update and Verify</button> <button ng-if=!orderPhoneVerification class=btn-contained ng-click=\"postMissingCredentials(missingCredentials,\'update-close\', \'phone\')\">{{isQRCode ? \'Save\' : \'Update\'}}</button></div></div></div></div></div></div><div class=\"signup-bg flex-view align-items-center\" ng-if=suspiciousUser><div class=\"otp-holder otp-holder-mbl flex-view justify-content-around align-items-center flex-direction-row-col signup-parent\" style=\"width: 100%\"><span ng-if=!forceEnter class=closeButtonImage style=\"top: 0\" ng-click=closeSuspiciousUser()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div class=\"flex-view flex-direction-row-col justify-content-around common-right-div\"><div class=\"flex-view flex-direction-col align-items-center\"><img src=\"./../../images/image 47.svg\" class=left-verify-image><!-- ./../../images/Group 10295.svg --></div><div class=\"flex-view flex-direction-col ease-out justify-content-around right-email-div transition\" style=\"max-width: 330px;height: 292px\" ;><h3 class=mb-2 style=\"font-weight: bold\">{{requestSubmit ? \'Request Submitted\' : \'Suspicious domain detected!\'}}</h3><p class=\"body-2 mt-3\">{{requestSubmit ? \"Your account review request has been submitted successfully. Please hold. We\'ll get back to you within 48 hours.\" : \"We have observed that you\'re using a private domain to signup at Nearpeer. Your account has been created successfully but it is under review right now. if it gets approved, you\'ll get an email soon. In the meantime, please sign up with the social logins.\"}}</p><div class=\"flex-view flex-direction-col\"><div style=\"display: flex; flex-direction: row\"><button class=btn-contained ng-click=submitSuspiciousRequest()>{{requestSubmit ? \"Understood\" : \"Submit Request\"}}</button></div></div></div></div></div></div><div class=signup-bg style=\"overflow: auto\" ng-if=missingEmail><div class=\"email-holder flex-view justify-content-around align-items-center flex-direction-col signup-parent\"><span class=closeButtonImage style=\"top: 0\" ng-click=closeMissingEmail()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div class=\"flex-view flex-direction-row\" style=\"width: 100%;\n      justify-content: space-around\"><div class=\"flex-view mob-hide\"><img src=\"./../../images/Group 10184 (1).svg\" style=\"width: 270px\"></div><div class=\"flex-view flex-direction-col justify-content-around height-change\" style=\"max-width: 300px\"><div><img src=./../../images/np-red.svg></div><div><h4 class=h4-heading>Update Email</h4><p class=\"body-2 mt-3\">Please provide your email address to update the email address.</p></div><div class=\"flex-view flex-direction-col\"><div class=\"flex-view mb-2 flex-direction-col input-border\" style=\"margin-bottom: 20px\"><label class=subtitle-1>Email</label><input class=body-2 ng-model=missingCredentials type=email placeholder=Email></div><button class=btn-contained ng-click=postMissingCredentials(missingCredentials)>Submit</button></div></div></div></div></div><!-- VERIFCATION BANNER HTML ENDS HERE------------------------------------------------ --><div class=\"content-container white-bg\"><ui-view></ui-view></div><div class=\"newsletter white-bg\" ng-if=\"isLanding != \'Landing\' && isLanding != \'downloadapp\' && isLanding != \'About-Us\' && isLanding != \'All-Notification\' && isLanding!=\'paymentPlans\' && isLanding != \'Complete-Profile\' && isLanding != \'profile_settings\' && isLanding != \'B2B\' && isLanding != \'Lead-Gen\' && isLanding != \'Story-Unique-Link\' && isLanding != \'storeel\' && isLanding != \'Reel-Unique-Link\' && !platform_reactApp_new\" ng:class=\"{\'for-blogs\': isBlog }\"><div class=container><div class=row><div class=col-md-12><div class=\"col-md-4 socail-nav\"><h1>SOCIAL MEDIA</h1><ul><li><a class=\"fab fa-facebook-square\" target=_blank href=https://web.facebook.com/nearpeer.org/ ></a></li><li><a class=\"fab fa-twitter-square\" target=_blank href=https://twitter.com/NearPeer></a></li></ul></div><ul class=\"col-md-5 border-right\" ng-if=platform_desktop><h4>Get the Latest from us by Signing up for our Newsletter</h4></ul><ul class=col-md-4 ng-if=platform_desktop><li><input type=email ng-model=email placeholder=\"Enter Your Email Here\"> <button ng-click=subscribe(email)>Subscribe</button> <span ng-show=success class=text-success>{{successMsg}}</span> <span ng-show=error class=text-danger>{{errorMsg}}</span></li></ul></div></div></div></div><section class=about-us-footer ng-if=\"!platform_reactApp_new && (isLanding === \'About-Us\' || isLanding === \'B2B\')\"><div class=section-box style=\"height: auto\"><div class=\"flex-view justify-content-between flex-direction-row-col rsp-footer\"><div class=footer-col><div class=footer-block-title>Stay up to date on the latest on Nearpeer</div><div class=subscribe-form><form><input type=email name=subscribe id=subscribe_nearpeer placeholder=\"Enter your e-mail\" ng-model=secondryFooterEmail> <button id=submit_nearpeer ng-click=EmailSubscribe(secondryFooterEmail)>Subscribe</button></form></div></div><div class=footer-col><div class=footer-block-title>Support</div><ul><li><a href=/contact-us>Contact Us</a></li><li><a href=/payment-options>How to pay</a></li><li><a href=/downloadapp>Download</a></li></ul></div><div class=footer-col><div class=footer-block-title>Our Programs</div><ul><li><a ng-if=!platform_reactApp href=/mdcat-test-preparation>MDCAT</a> <a ng-if=platform_reactApp href=/entry-test-preparation>MDCAT</a></li><li><a ng-if=!platform_reactApp href=/css-test-preparation>CSS </a><a ng-if=platform_reactApp href=/css/css-online-preparation>CSS </a></li><li><a ng-if=!platform_reactApp href=https://cambridge.nearpeer.org/ >O/A Level</a> <a ng-if=platform_reactApp href=/online-course/O&A-Level>O/A Level</a></li><li><a ng-if=!platform_reactApp href=https://fsc.nearpeer.org/ >FSC</a> <a ng-if=platform_reactApp href=/online-course/fsc>FSC</a></li><li><a href=/chartered-accountancy-final>CA</a></li><li><a href=/acca/acca-online>ACCA</a></li><li><a href=/lums>University Courses</a></li><li><a href=/entry-test>University Entry Test</a></li></ul></div><div class=footer-col><div class=footer-block-title>Our location</div><ul><li><a href=https://g.page/OnlineCoursesPakistan?share target=_blank><img src=../../images/about-us/office-location.png alt=\"our location\"></a></li><li><a href=#>2nd Floor, 278 FF, Phase 4 DHA, Lahore<!-- Town Lahore --></a></li></ul></div></div><div class=footer-bottom><div class=\"flex-view justify-content-between align-items-center flex-direction-row-col\"><div class=help><p><b>Need Help?</b> Our team is waiting for your call at <b><a href=tel:+923111444734>03111444734</a></b></p></div><div class=\"flex-view align-items-center\"><div class=about-us-logo ng-click=\"goToState(\'Landing\')\"><img src=../../images/Logo_white.svg alt=\"near pear logo\"></div><ul class=social-icons><li><a href=https://www.youtube.com/c/Nearpeerofficial target=_blank><img src=../../images/about-us/icon-yt.svg alt=\"\"></a></li><li><a href=https://www.instagram.com/nearpeer.official/ target=_blank><img src=../../images/about-us/icon-insta.svg alt=\"\"></a></li><li><a href=https://www.facebook.com/nearpeer.org target=_blank><img src=../../images/about-us/icon-fb.svg alt=\"\"></a></li></ul></div></div></div></div></section><!-- MEGRE POP UP --><div class=\"signup-bg custom-align flex-view align-items-center\" style=\"overflow: auto\" ng-if=mergeAccount><div class=\"otp-holder otp-holder-mbl tab-width flex-view justify-content-around align-items-center flex-direction-col signup-parent merge-overall-height\" style=\"width: 100%\" ng-if=mergeMain><span class=closeButtonImage style=\"top: 0\" ng-click=closeMerge()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div class=\"flex-view flex-direction-col\" style=\"height: 100%;\n              justify-content: space-evenly;\n              width: 100%\"><!-- <div class=\"flex-view justify-content-center\">\n          <img src=\"./../../../../assets/np-red.svg\" />\n        </div> --><div class=\"flex-view flex-direction-col\" style=\"width: 100%;\n              justify-content: space-around;align-items: center\"><div class=flex-view><img src=./../../images/2219374.svg class=merge-image style=\"width: 180px\"></div><div class=\"flex-view flex-direction-col justify-content-around table-width\" style=\"width: 100%;\n            margin-bottom: 30px;\n            padding: 0px 30px\"><div><p class=\"mt-1 body-1 font-family-bold\">Multiple Accounts Detected</p><p class=\"body-2 mt-2\">It seems that you have multiple Nearpeer accounts associated with same <b>ID: {{userEmail}}</b>. You can merge all your accounts with your Currently logged in account (highlighted below):.</p></div><div class=\"flex-view flex-direction-col mt-1 web-merge\" style=\"overflow-y: scroll;\n        max-height: 235px\"><div class=\"flex-view flex-direction-row align-items-center mob-length row-border\" style=\"width: fit-content\"><p class=body-2 style=\"min-width: 200px\"><b>Login Medium</b></p><p class=body-2 style=\"min-width: 200px\"><b>Courses Unlocked</b></p><p class=body-2 style=\"min-width: 220px\"><b>Last Login</b></p></div><!-- for LOOP --><div class=\"flex-view flex-direction-row align-items-center mob-length row-border\" style=\"width: fit-content\" :class=\"{\'row-bg\': currentDevice}\" ng-repeat=\"account in userAccounts\"><p class=subtitle-1 style=\"min-width: 200px\">{{account.provider}}</p><p class=subtitle-1 style=\"min-width: 200px\">{{account.purchasedCoursesCount}}</p><p class=\"subtitle-1 font-family-bold\" style=\"min-width: 220px;text-overflow: ellipsis;\n              overflow: hidden\">{{account.lastLogin | date:\'yyyy-MM-dd\'}} <img src=\"./../../images//Group 10382.svg\" ng-if=\"account.id === userData.id\" style=\"margin-left: 5px\"></p></div><!--/ FOR LOOP --></div></div><div class=\"flex-view merge-last\" style=\"justify-content: flex-end\"><div><button class=\"btn-np outlined hover-add\" ng-click=closeMerge()>Ignore</button> <button class=\"btn-contained hover-add ml-2\" ng-click=mergeAccountCall() style=\"margin-left: 20px\">Merge all accounts</button></div></div></div></div></div><div class=\"otp-holder otp-holder-mbl tab-width flex-view justify-content-around align-items-center flex-direction-col signup-parent\" style=\"width: 100%;\n  height: 600px\" ng-if=mergeWait><div class=\"flex-view flex-direction-col\" style=\"height: 100%;\n        justify-content: space-evenly;\n        width: 100%\"><div class=\"flex-view flex-direction-col height-on-small\" style=\"width: 100%;\njustify-content: space-around;align-items: center\"><h4>Your Accounts are being merged.</h4><div class=loader-merge><div class=\"box box0\"><div></div></div><div class=\"box box1\"><div></div></div><div class=\"box box2\"><div></div></div><div class=\"box box3\"><div></div></div><div class=\"box box4\"><div></div></div><div class=\"box box5\"><div></div></div><div class=\"box box6\"><div></div></div><div class=\"box box7\"><div></div></div><div class=ground><div></div></div></div><small>Nearpeer</small></div></div></div><div class=\"otp-holder otp-holder-mbl custom-height tab-width flex-view justify-content-around align-items-center flex-direction-col signup-parent\" style=\"width: 100%\" ng-if=mergeSuccess><span class=closeButtonImage style=\"top: 0\" ng-click=closeMerge()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div class=\"flex-view flex-direction-row-col align-items-center\" style=\"width: 100%;\n    justify-content: space-around;height: 480px\"><div class=flex-view><img src=\"./../../images/Group 10263.svg\"><!-- class=\"success-image\" --></div><div class=\"flex-view flex-direction-col justify-content-around height-change\" style=\"max-width: 500px;padding: 0px 50px\"><div><h4>Accounts Sucessfully Merged</h4><p class=\"body-2 mt-3\">Congratulations! Your accounts have successfully been merged. All your courses will now be available in this account.</p></div><div class=flex-view style=\"justify-content: flex-end\"><button class=\"btn-contained hover-add\" ng-click=closeMerge()>Contine</button></div></div></div></div></div><!-- //MERGE END --><!-- OTP POP UP STARTS --><!-- style=\"overflow: auto;\" --><div class=\"signup-bg flex-view align-items-center\" ng-if=OTP><div class=\"otp-new-flow-holder otp-holder-mbl flex-view justify-content-around align-items-center flex-direction-col signup-parent\" style=\"width: 100%\"><div style=\"position: absolute; left: 10px; top: 10px\"><button class=\"btn-np text-filled\" ng-click=backVerification() ng-if=\"(enterOTP || (!logoutAll && !enterOTP)) && otpVerification === \'login\'\" style=\"color: gray;border: none !important\"><img style=\"width: 8px;\n        margin-right: 8px\" src=./../../images/arrowleft.svg> Back</button><!-- <button class=\"btn-np text-filled\" ng-if=\"phoneSelected\" ng-click=\"\"><img src=\"./../../../../assets/back.png\">Back</button> --></div><span class=closeButtonImage style=\"top: 0\" ng-click=closeOTP()><img src=./../../images/Icon-Close-black.svg class=cross-icon></span><div class=\"flex-view flex-direction-col\" style=\"height: 100%;\n            justify-content: center;\n            width: 100%\"><!-- <div class=\"flex-view justify-content-center\">\n        <img src=\"./../../images/np-red.svg\" />\n      </div> --><div class=\"flex-view flex-direction-row-col\" style=\"width: 100%;\n            justify-content: space-around;align-items: center\" ng-if=logoutAll><div class=\"flex-view hide-on-small\"><!-- style=\"width: 270px;\" --> <img src=\"./../../images/Group 10351.svg\" class=otp-image style=\"width: 400px\"></div><div class=\"flex-view flex-direction-col otp-options mt-3\"><div><h4 class=\"mt-4 h4-heading\">Please logout from other devices to proceed.</h4><p class=\"body-2 mt-3\">You can login from a maximum of three devices at one time. Please logout from one of the following devices to continue here:</p><!-- <p class=\"body-2 mt-3\">Please logout from any of the following devices for logging in to this device.</p> --></div><div class=\"flex-view flex-direction-col align-items-center otp-scroller new-flow-visible\"><div ng-repeat=\"session in sessions\" class=\"flex-view justify-content-between flex-direction-row align-items-center mob-length\" style=\"width: 100%;margin:5px;border-bottom: 1px solid #EAEAEA;\n            padding: 5px\"><div class=flex-view><p class=body-2 style=\"color: BLACK; margin-right: 5px\">{{$index + 1}}-</p><!-- <p class=\"body-2\" style=\"width: 200px;\n              text-overflow: ellipsis;\n              overflow: hidden;\">{{((session || {}).device_detail || {}).os +\'(\' + (((session || {}).device_detail || {}).device || {}).type +\')\'}}</p> --><p class=\"body-2 width-on-mob\" style=\"text-overflow: ellipsis;\n              overflow: hidden\">{{((session || {}).device_detail || {}).browser}}</p></div><button class=\"outlined btn-np hover-add\" style=\"padding: 3px 16px 3px 16px; height: 30px\" ng-click=logoutFromDevice(session)>LOGOUT</button></div></div><div class=\"flex-view justify-content-center mt-3 c-row-col mar-on-mob flex-direction-col\" style=\"padding: 0px 18px\"><button class=\"outlined btn-np hover-add mar-btn\" ng-click=logoutAllDevices(sessions[0]) style=\"margin: 0px 0px 15px 0px !important\">LOGOUT ALL DEVICES</button><!-- <button class=\"btn-contained hover-add  \"  ng-click= \"skipValidate()\">SKIP FOR NOW</button> --></div></div></div><div class=\"flex-view flex-direction-row-col\" style=\"width: 100%;\n            justify-content: space-around;align-items: center\" ng-if=\"!logoutAll && !enterOTP\"><div class=\"flex-view hide-on-small\"><img src=\"./../../images/Group 10349.svg\" class=otp-image style=\"width: 400px\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><h4 class=h4-heading>Account Verification</h4><p class=\"body-2 mt-3\">We will send you a <b>One Time Password (OTP)</b>.</p><p class=\"body-2 mt-3\">Please choose where would you like to receive your OTP.</p></div><div class=\"flex-view flex-direction-row justify-content-between align-items-center mob-length\" style=\"width: 100%;margin:5px;border-bottom: 1px solid #EAEAEA;\n          padding: 20px 5px\"><div class=flex-view><p class=body-2 style=\"color: #E03249;margin-right: 5px\"><img src=\"./../../images/Icon - Email.svg\"></p><p class=body-2 style=\"width: 200px;\n              text-overflow: ellipsis;\n              overflow: hidden\">{{splitEmail[0].substring(0, 3)}}*****@{{splitEmail[1]}}</p></div><button class=btn-contained style=\"min-width: 102px\" ng-click=\"sendOtp(\'email\')\">Send OTP</button><!-- <p ng-if=\"userEmail\" style=\"text-align: center;\"></p> --></div><!-- <div class=\"flex-view flex-direction-row justify-content-between align-items-center mob-length\" style=\"width: 100%;margin:5px;border-bottom: 1px solid #EAEAEA;\n            padding: 20px 5px;\">\n              <div class=\"flex-view\">\n                <p class=\"body-2\" style=\"color: #E03249;margin-right: 5px;\"><img src=\"./../../images/Icon awesome-phone-alt.svg\" /></p>\n                <p class=\"body-2\" style=\"width: 200px;\n                text-overflow: ellipsis;\n                overflow: hidden;\">****{{userPhone.substring(8, 12)}}</p>\n             </div>\n                <button class=\"btn-contained\" style=\"min-width: 102px;background:#f24a00 !important;\" ng-click=\"sendOtp(\'phone\')\">\n         Send OTP\n                </button>\n              </div> --><div class=\"flex-view mt-4\" style=\"justify-content: flex-end;\n              margin-top: 35px !important\"><button class=\"outlined btn-np hover-add\" ng-click=closeLogoutPopup()>CANCEL</button><!-- <button class=\"btn-contained hover-add\"  ng-click= \"skipValidate()\">SKIP FOR NOW</button> --></div></div></div><div class=\"flex-view flex-direction-row-col\" style=\"align-items: center;\n\n            justify-content: space-around; overflow-y: auto\" ng-if=enterOTP><div class=\"flex-view hide-on-small\"><img src=./../../images/5326009.svg ng-if=phoneSelected class=otp-image style=\"width: 400px\"> <img src=\"./../../images/Group 1420.svg\" ng-if=emailSelected class=otp-image style=\"width: 400px\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><h2 class=heading-popup-profile-setting>Please Enter the Verification code</h2><p class=\"body-2 mt-3\">A verification code has been sent to <b ng-if=emailSelected>{{userEmail}}</b><b ng-if=phoneSelected>{{userPhone}}</b>.<br><br>To complete your verification please enter the <b>6</b> digit verification code.</p></div><div class=\"flex-view flex-direction-col justify-content-around align-items-center mt-4\"><form style=\"margin-bottom: 15px\" method=get class=field-wrapper-otpCode data-group-name=digits data-autosubmit=false autocomplete=off><input type=text id=digit-1 name=digit-1 data-next=digit-2 ng-model=digit1 maxlength=1 ng-keyup=\"keytab($event, 1)\"> <input type=text id=digit-2 name=digit-2 data-next=digit-3 data-previous=digit-1 maxlength=1 ng-keyup=\"keytab($event, 2)\" ng-model=digit2> <input type=text id=digit-3 name=digit-3 data-next=digit-4 data-previous=digit-2 maxlength=1 ng-keyup=\"keytab($event, 3)\" ng-model=digit3><!-- <span class=\"splitter\">&ndash;</span> --> <input type=text id=digit-4 name=digit-4 data-next=digit-5 data-previous=digit-3 maxlength=1 ng-keyup=\"keytab($event, 4)\" ng-model=digit4> <input type=text id=digit-5 name=digit-5 data-next=digit-6 data-previous=digit-4 maxlength=1 ng-keyup=\"keytab($event, 5)\" ng-model=digit5> <input type=text id=digit-6 name=digit-6 data-next=digit-7 data-previous=digit-5 maxlength=1 ng-keyup=\"keytab($event, 6)\" ng-model=digit6></form><p style=\"color: #E03249\">{{otpErroor}}</p><button class=\"btn-contained mt-3\" style=\"color: white\" ng-click=sendOTPConfirmation()>Submit</button></div><div class=\"flex-view mt-3 justify-content-center\" style=\"margin-top: 15px\"><p class=subtitle-2>Didn\'t get the code? <b ng-click=resendOtp() style=\"color: #f24a00 !important\">Resend</b></p></div></div></div></div></div></div><!-- OTP POP UP ENDS --><div class=poppup-cp-container ng-if=showUpdateApp><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative\"><!-- <span ng-if=\"remainingSec < 1\" class=\"closeBtn\" ng-click=\"closePopup()\">\n        x\n      </span> --><div style=\"min-width: 243px;margin: 20px; margin-top: 50px\"><img src=../../images/update.png></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px\"><h4 style=\"margin-bottom: 10px; font-weight: bold\">Update Available</h4><p>A new version of our app is now available to download. Please download and install the latest version below for an enhanced learning experience.<br>Please open below link in browser to download latest app.<br><br>Link: https://nearpeer.org/downloadapp</p><div class=f-c style=\"flex-direction: column\"><button class=btn-update ng-click=copyLink()><span style=\"top: 2px; margin-right: 5px\" class=\"glyphicon glyphicon-copy\"></span> Click Here to Copy Link</button><!-- <button ng-class=\"{\'btn-update-close\': remainingSec < 1, \'btn-update-close-disable\': remainingSec > 0}\" ng-click=\"closePopup()\">\n            Remind me Later <span ng-if=\"remainingSec > 0\">({{remainingSec}})</span>\n          </button> --></div></div></div></div><div class=poppup-cp-new-overlay></div></div><div class=poppup-cp-container ng-if=showMobileAppUpdate><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative\"><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px\"><h4 style=\"margin-bottom: 10px; font-weight: bold\">Update Available</h4><p>New version of Nearpeer App is available. When you are ready please update.</p><div class=f-c style=\"flex-direction: column\"><button class=btn-update style=\"width: 100% !important; margin-top: 21px\" ng-click=updateMobileApp()><span style=\"top: 2px; margin-right: 5px\" class=\"glyphicon glyphicon-copy\"></span> Update</button><!-- <button ng-class=\"{\'btn-update-close\': remainingSec < 1, \'btn-update-close-disable\': remainingSec > 0}\" ng-click=\"closePopup()\">\n            Remind me Later <span ng-if=\"remainingSec > 0\">({{remainingSec}})</span>\n          </button> --></div></div></div></div><div class=poppup-cp-new-overlay></div></div><div class=poppup-cp-container ng-if=rateLimitError><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative\"><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px; text-align: center\"><h4 style=\"margin-bottom: 10px; font-weight: bold\">Dear {{token ? customerName : \'User\'}},</h4><p v-if=\"rateLimitErrorCode && rateLimitErrorCode.STATUS\">{{rateLimitErrorCode.STATUS}} ({{rateLimitErrorCode.STATUS_CODE}})</p><p>We have observed repetitive activities from your account in a short time period. Your account has been put in the \"limited mode\" for 24 hours. If you wish to change that, please contact us at contact@nearpeer.org.</p></div></div></div><div class=poppup-cp-new-overlay></div></div><div class=container style=\"background-color: hsl(189, 81%, 46%)\"><div class=footer><ul><li><a href=#>About Us</a></li><li><a href=#>Contact Us</a></li><li><a href=#>Terms of Use</a></li><li><a href=#>FAQs</a></li><li><a href=#>Privacy Policy</a></li><li><a href=#>Career </a></li><li><a href=#>Press</a></li></ul></div></div><div class=\"modal fade custom_popup\" id=singUpPopUp tabindex=-1 role=dialog aria-labelledby=singUpPopUpModalLabel aria-hidden=true><div class=\"custom_popup_body loginForm\"><div class=custom_popup_header><span class=\"fa fa-angle-left\"></span> <img src=../../images/email-logo.png alt=\"NearPeer Logo\"> <span class=\"close fa fa-times\" ng-click=closeForm()></span></div><div class=popup_main><div class=popup_title><h1>Login NearPeer</h1><p>Welcome back! Dear user enter the password associated with your email address.</p></div><form action=#><div class=\"field-wrapper mb-24\" ng-if=email_Field><label for=email>Enter Or Phone</label><div class=field-inner><i class=\"fa fa-envelope\" aria-hidden=true></i> <input type=text name=email id=email placeholder=Email@xyz.com></div></div><div class=\"password mb-24\" ng-if=!password_Field><div class=field-wrapper><label for=email>Password</label><div class=field-inner><i class=\"fa fa-lock\" aria-hidden=true></i> <input type=password name=password id=password placeholder=\"\"></div></div><div class=\"password-options flex-view justify-content-between\"><div class=forget-password>Forget Password?</div><div class=skip-password>Skip Password?</div></div></div><div class=\"text-center mb-24\"><button class=popup_button type=button ng-click=nextForm()>Next</button></div><div class=social-logins><div class=\"mb-24 divider mb-24\">OR</div><div class=text-center><button class=social-button><img src=../../images/google-icon.png alt=#> LogIn with Google</button></div><div class=text-center><button class=social-button><img src=../../images/fb-icon.png alt=#> LogIn with FaceBook</button></div><div class=text-center><button class=social-button><img src=../../images/tweeter-icon.png alt=#> LogIn with Tweeter</button></div></div></form></div></div></div>");
$templateCache.put("app/Pages/payment-options.html","<div class=payment-options><div class=\"payment-container container\" style=\"text-align: center\"><div class=row><div class=\"col-xs-offset-1 col-xs-10\"><div><h1 class=payment-txt-main>Payment and Access Method</h1><br><img class=whatsapp-image style=\"width: 30%\" src=../../images/payment_creditcard.png></div><!-- Accordion card easypaisa --><div><!-- Card header --><div role=tab id=heading1 ng-click=\"rotate180(\'ep\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse1 href=# aria-expanded=false aria-controls=collapse1><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': epState}\"><span ng-click=rotate180(ep) class=accordion-label><img class=payment-client-logo src=../../images/logo_easypaisa.png> <i id=ep class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !epState,\'glyphicon-chevron-up\': epState}\"></i></span></div></a></div><!-- Card body --><div id=collapse1 class=collapse role=tabpanel aria-labelledby=heading1 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/easypaisa_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Open your Easypaisa App</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on Money Transfer</span></div></div></div><br><div><div><img class=step src=../../images/easypaisa_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Select Bank Account</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; font-size: 12px; padding-top: 7px\">Search “Faysal Bank”</span></div></div></div><br><div><div><img class=step src=../../images/easypaisa_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Type in the given Bank details</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Account Number: 0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Mobile Number: 03459615004</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Purpose: Education</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on “Send Now”</span></div></div><br><div><div><img class=step src=../../images/easypaisa_step4.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 4. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Your Course Name</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Screenshot of the SMS you get from 3737 (or the Easypaisa App Screen)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Nearpeer login ID (after signing-up)</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card jazzcash--><div><!-- Card header --><div role=tab id=heading2 ng-click=\"rotate180(\'jc\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse2 href=# aria-expanded=false aria-controls=collapse2><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': jcState}\"><span ng-click=rotate180(jc) class=accordion-label><img class=payment-client-logo src=../../images/logo_jazzcash.png> <i id=jc class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !jcState,\'glyphicon-chevron-up\': jcState}\"></i></span></div></a></div><!-- Card body --><div id=collapse2 class=collapse role=tabpanel aria-labelledby=heading2 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/jazzcash_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Open your JazzCash App</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on Send Money</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Select Bank Account</span></div></div></div><br><div><div><img class=step src=../../images/jazzcash_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Type in the given Bank details</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Account Number: 0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Mobile Number: 03459615004</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on “Send Now”</span></div></div><br><div><div><img class=step src=../../images/jazzcash_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Your Course Name</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Screenshot of the SMS you get from 8558 (or the Jazz Cash App Screen)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Nearpeer Login ID (after signing-up)</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card Online Bank Transfer--><div><!-- Card header --><div role=tab id=heading3 ng-click=\"rotate180(\'obt\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse3 href=# aria-expanded=false aria-controls=collapse3><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': obtState}\"><span ng-click=rotate180(obt) class=payment-accordion-label>Online Bank Transfer <i id=obt class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !obtState,\'glyphicon-chevron-up\': obtState}\"></i></span></div></a></div><!-- Card body --><div id=collapse3 class=collapse role=tabpanel aria-labelledby=heading3 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/obt_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Visit your Bank’s Website/App</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on Send Money</span></div></div></div><br><div><div><img class=step src=../../images/obt_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Add following account as your beneficiary:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Account Number: 0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Mobile Number: 03459615004</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Purpose: Education</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on “Transfer Amount”</span></div></div><br><div><div><img class=step src=../../images/obt_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Your Course Name</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Screenshot of the SMS you get from Bank (or the App Screen)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Nearpeer Login ID (after signing-up)</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card Faysal Bank Deposit--><div><!-- Card header --><div role=tab id=heading4 ng-click=\"rotate180(\'fbd\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse4 href=# aria-expanded=false aria-controls=collapse4><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': fbdState}\"><span ng-click=rotate180(fbd) class=payment-accordion-label>Faysal Bank Deposit <i id=fbd class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !fbdState,\'glyphicon-chevron-up\': fbdState}\"></i></span></div></a></div><!-- Card body --><div id=collapse4 class=collapse role=tabpanel aria-labelledby=heading4 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/fbl_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Walk into any Faysal Bank Branch</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Request an Account Deposit service.</span></div></div></div><br><div><div><img class=step src=../../images/fbl_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Provide them the following bank details:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Account Number: 0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Branch: DHA- Phase 1, Lahore</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Mobile Number: 03459615004</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Once the amount is deposited, you’ll get a slip from the bank representative</span></div></div><br><div><div><img class=step src=../../images/fbl_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Picture of the deposit slip you got</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Your Nearpeer Login ID (after signing-up)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Course Name</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card ATM Transfer--><div><!-- Card header --><div role=tab id=heading5 ng-click=\"rotate180(\'atm\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse5 href=# aria-expanded=false aria-controls=collapse5><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': atmState}\"><span ng-click=rotate180(atm) class=payment-accordion-label>ATM Transfer <i id=atm class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !atmState,\'glyphicon-chevron-up\': atmState}\"></i></span></div></a></div><!-- Card body --><div id=collapse5 class=collapse role=tabpanel aria-labelledby=heading5 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/atm_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Visit the ATM of the Bank.</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Insert the card, type in the pin.</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Select Money/Amount Transfer</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Select non-IBAN account.</span></div></div></div><br><div><div><img class=step src=../../images/atm_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Add following details:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Account Number: 0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Once the amount is deposited, you’ll get a slip from the machine.</span></div></div><br><div><div><img class=step src=../../images/atm_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Picture of the deposit slip you got</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Your Nearpeer Login ID (after signing-up)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Course Name</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card Credit Card--><div><!-- Card header --><div role=tab id=heading6 ng-click=\"rotate180(\'cc\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse6 href=# aria-expanded=false aria-controls=collapse6><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': ccState}\"><span ng-click=rotate180(cc) class=payment-accordion-label>Credit Card <i id=cc class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !ccState,\'glyphicon-chevron-up\': ccState}\"></i></span></div></a></div><!-- Card body --><div id=collapse6 class=collapse role=tabpanel aria-labelledby=heading6 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/cc_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Login and visit your course page at nearpeer.org</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on Buy Now and select Proceed</span></div></div></div><br><div><div><img class=step src=../../images/cc_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Add following details:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">You’ll be redirected to a JazzCash Portal</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Select Credit Card from the drop-down menu.</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Fill in the details and complete the transaction</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">You’ll receive an SMS from your Bank.</span></div></div><br><div><div><img class=step src=../../images/cc_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Screenshot of the SMS from the Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Your Nearpeer Login ID (after signing-up)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Course Name</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div><!-- Accordion card International Bank Transfer--><div><!-- Card header --><div role=tab id=heading7 ng-click=\"rotate180(\'ibt\')\"><a class=collapsed data-toggle=collapse data-parent=#accordionEx7 data-target=#collapse7 href=# aria-expanded=false aria-controls=collapse7><div class=\"row payment-accordion-label-bg\" ng-class=\"{\'payment-accordion-label-bg-focus\': ibtState}\"><span ng-click=rotate180(ibt) class=payment-accordion-label><p class=IBTp title=\"International Bank Transfer\">International Bank Transfer</p><i id=ibt class=\"pull-right glyphicon accordion-arrow\" ng-class=\"{\'glyphicon-chevron-down\': !ibtState,\'glyphicon-chevron-up\': ibtState}\"></i></span></div></a></div><!-- Card body --><div id=collapse7 class=collapse role=tabpanel aria-labelledby=heading7 data-parent=#accordionEx7><div class=main_content_aria><div><div class=padding50><img class=step src=../../images/ibt_step1.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 1. Visit your Bank’s Website/App</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on Send Money</span></div></div></div><br><div><div><img class=step src=../../images/ibt_step2.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 2. Add following account as your beneficiary:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Bank Name: Faysal Bank</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">IBAN: PK25FAYS0125007900219780</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Mobile Number: 03459615004</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Confirm the Bank Account Title: NEARPEER(Private) LIMITED</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">Click on “Transfer Amount”</span></div></div><br><div><div><img class=step src=../../images/ibt_step3.png><br></div><div class=payment-instruction-bg><span class=payment-text-white><img class=payment-instruction src=../../images/payment_check_square.png> 3. Once done, whatsapp us:</span></div><br><div class=margin-left50><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">A. Your Course Name</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">B. Screenshot of the SMS you get from Bank (or the App Screen)</span></div><div class=\"padding-top10 row\"><span class=col-xs-1 style=\"padding: 0px\"><img style=\"display: inline\" class=payment-instruction src=../../images/checkmark-circle_outline.png> </span><span class=col-xs-10 style=\"padding: 0px; padding-top: 7px\">C. Your Nearpeer login ID (that you can create by signing up).</span></div></div></div><br><div><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><div class=whatsapp-btn><img class=ct-us-whatsapp-btn src=../../images/120px-WhatsApp.svg.png><label>03111444734</label></div></a></div><div class=payment-txt-btm><span class=payment-txt-btm-blue>And you\'ll get access in </span><span class=payment-txt-btm-red>12 working hours</span></div></div></div></div></div></div></div></div><div class=ftr><span class=payment-contact><img class=callusbutton src=../../images/callusbutton.png> Feel free to call us for any help.</span></div></div>");
$templateCache.put("app/Pages/payment-plans.html","<div><!-- Header --><div class=div-top><div class=container><div class=\"row sub-header\"><div class=\"col-md-5 list-url\"><span>Home<i class=\"icon-style fa fa-angle-right\"></i>Category <i class=\"icon-style fa fa-angle-right\"></i>Course<i class=\"icon-style fa fa-angle-right\"></i>Plan</span><h2 class=sub-heading>Great choice! Choose your plan.</h2></div><div class=col-md-7><ul class=progressbar><li class=\"active list-active\">Choose Plan</li><hr class=hr-tag><li>Place Order</li><hr class=hr-tag><li>Payment</li><hr class=hr-tag><li>Confirmation</li></ul></div></div></div></div><div class=\"container margin-video\"><div class=\"row video-url\"><div class=video-text><i class=\"exclamation fa fa-exclamation\"></i> <span>Watch a video to help you in this step. </span></div></div></div><div class=container><div class=\"row center plan-row\"><div class=\"col-md-3 plan-box\" ng-class=\"{\'plan-box-active\': boxSelect == \'1\'}\"><div><label class=container style=\"margin-top: 50px\"><input type=radio ng-click=\"checkmarkSelected(\'1\')\" checked name=radio> <span class=checkmark></span></label></div><br><div class=type-duration ng-class=\"{\'type-active\': boxSelect == \'1\'}\"><span>Months</span></div><br><div class=type-per-duration ng-class=\"{\'type-active\': boxSelect == \'1\'}\"><span>PKR 500/Month</span></div><br><div class=type-choose-plan ng-class=\"{\'type-active\': boxSelect == \'1\'}\"><span>Choose number of months</span></div><div class=\"header-filter mt-4\"><div class=\"filter-field form-control form-control-alternative\" style=background-color:#FFFFFF ng-click=openfilterDropDownMonth()><span class=filter-name>{{monthfilter}}</span> <i class=\"fa fa-angle-down\" aria-hidden=true></i></div><div class=plan-dropdown><div class=filter-dropdown ng-show=filterDropDownMonth><ul><li ng-click=openfilterDropDown1Month()><div class=\"form-group form-check\"><label class=form-check-label>1 Month- Rs. 300</label></div></li><li ng-click=openfilterDropDown3Month()><div class=\"form-group form-check\"><label class=form-check-label>3 Month- Rs. 600</label></div></li><li><div class=\"form-group form-check\" ng-click=openfilterDropDown6Month()><label class=form-check-label>6 Month- Rs. 900</label></div></li></ul></div></div></div></div><div class=\"col-md-3 plan-box\" ng-class=\"{\'plan-box-active\': boxSelect == \'2\'}\"><div><label class=container style=\"margin-top: 50px\"><input type=radio ng-click=\"checkmarkSelected(\'2\')\" name=radio> <span class=checkmark></span></label></div><br><div class=type-duration ng-class=\"{\'type-active\': boxSelect == \'2\'}\"><span>Years</span></div><br><div class=type-per-duration ng-class=\"{\'type-active\': boxSelect == \'2\'}\"><span>PKR 1000/Year</span></div><br><div class=type-choose-plan ng-class=\"{\'type-active\': boxSelect == \'2\'}\"><span>Choose number of years</span></div><div class=\"header-filter mt-4\"><div class=\"filter-field form-control form-control-alternative\" style=background-color:#FFFFFF ng-click-outside=hide ng-click=openfilterDropDownYear()><span class=filter-name>{{yearfilter}}</span> <i class=\"fa fa-angle-down\" aria-hidden=true></i></div><div class=plan-dropdown><div class=filter-dropdown ng-show=filterDropDownYear><ul><li><div class=\"form-group form-check\" ng-click=openfilterDropDown1Year()><label class=form-check-label>1 Year- Rs. 1000</label></div></li><li><div class=\"form-group form-check\" ng-click=openfilterDropDown3Year()><label class=form-check-label>3 Year- Rs. 2000</label></div></li><li><div class=\"form-group form-check\" ng-click=openfilterDropDown6Year()><label class=form-check-label>6 Year- Rs. 4000</label></div></li></ul></div></div></div></div><div class=\"col-md-3 plan-box\" ng-class=\"{\'plan-box-active\': boxSelect == \'3\'}\"><div><label class=container style=\"margin-top: 50px\"><input type=radio ng-click=\"checkmarkSelected(\'3\')\" name=radio> <span class=checkmark></span></label></div><br><div class=type-duration ng-class=\"{\'type-active\': boxSelect == \'3\'}\"><span>Academic Session</span></div><br><div class=type-per-duration ng-class=\"{\'type-active\': boxSelect == \'3\'}\"><span>PKR 5000</span></div><br><div class=type-choose-plan ng-class=\"{\'type-active\': boxSelect == \'3\'}\"><span>Choose session</span></div><div class=\"header-filter mt-4\"><div class=\"filter-field form-control form-control-alternative\" style=background-color:#FFFFFF ng-click-outside=hide ng-click=openfilterDropDownSession()><span class=filter-name>{{sessionfilter}}</span> <i class=\"fa fa-angle-down\" aria-hidden=true></i></div><div class=plan-dropdown><div class=filter-dropdown ng-show=filterDropDownSession><ul><li><div class=\"form-group form-check\" ng-click=openfilterDropDown1Session()><label class=form-check-label>October 2016</label></div></li><li><div class=\"form-group form-check\" ng-click=openfilterDropDown2Session()><label class=form-check-label>March 2017</label></div></li></ul></div></div></div></div></div></div><!-- Body --><div class=\"container mt-2\"><div class=\"row orders-div\"><div class=order-details>Order Details</div><hr><div class=detail-info><div style=\"font-weight: 700\">The new SAT English(for LUMS preparation)</div><div style=\"font-weight: 400\">Validty<br><b>1 Month</b></div><div style=\"font-weight: 400\">Order Sub Total<br><b>Rs.500</b></div><div><button class=button-style-next id=submit_nearpeer>NEXT</button></div></div></div></div><!-- Footer --><section class=about-us-footer><div class=section-box style=\"height: auto\"><div class=\"flex-view justify-content-between flex-direction-row-col rsp-footer\"><div class=footer-col><div class=footer-block-title>Stay up to date on the latest on Nearpeer</div><div class=subscribe-form><form><input type=email name=subscribe id=subscribe_nearpeer placeholder=\"Enter your e-mail\" ng-model=email> <button id=submit_nearpeer ng-click=EmailSubscribe(email)>Subscribe</button></form></div></div><div class=footer-col><div class=footer-block-title>Support</div><ul><li><a href=/contact-us>Contact Us</a></li><li><a href=/payment-options>How to pay</a></li><li><a href=/downloadapp>Download</a></li></ul></div><div class=footer-col><div class=footer-block-title>Our Programs</div><ul><li><a href=/mdcat-test-preparation>MDCAT</a></li><li><a href=/css-test-preparation>CSS</a></li><li><a href=https://cambridge.nearpeer.org/ >O/A Level</a></li><li><a href=https://fsc.nearpeer.org/ >FSC</a></li><li><a href=/chartered-accountancy-final>CA</a></li><li><a href=/acca/acca-online>ACCA</a></li><li><a href=/lums>University Courses</a></li><li><a href=/entry-test>University Entry Test</a></li></ul></div><div class=footer-col><div class=footer-block-title>Our location</div><ul><li><a href=https://g.page/OnlineCoursesPakistan?share target=_blank><img src=../../images/about-us/map.svg alt=\"our location\"></a></li><li><a href=#>2nd Floor, 278 FF, Phase 4 DHA, Lahore</a></li></ul></div></div><div class=footer-bottom><div class=\"flex-view justify-content-between align-items-center flex-direction-row-col\"><div class=help><p><b>Need Help?</b> Our team is waiting for your call at <b><a href=tel:+923111444734>03111444734</a></b></p></div><div class=\"flex-view align-items-center\"><div class=about-us-logo><img src=../../images/Logo_white.svg alt=\"near pear logo\"></div><ul class=social-icons><li><a href=https://www.youtube.com/c/Nearpeerofficial target=_blank><img src=../../images/about-us/icon-yt.svg alt=\"\"></a></li><li><a href=https://www.instagram.com/nearpeer.official/ target=_blank><img src=../../images/about-us/icon-insta.svg alt=\"\"></a></li><li><a href=https://www.facebook.com/nearpeer.org target=_blank><img src=../../images/about-us/icon-fb.svg alt=\"\"></a></li></ul></div></div></div></div></section></div>");
$templateCache.put("app/Pages/privacypolicy.html","<div class=container><div style=\"margin-right: 100%;    margin-top: 21px\"><p>&nbsp;</p><table width=0 cellspacing=0 cellpadding=3><thead><tr><td colspan=5 bgcolor=#ffffff width=615><p align=center>&nbsp;</p></td></tr></thead><tbody><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#0000ff width=77><p><span style=\"color: #ffffff\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>CATEGORY</strong></span></span></span></p></td><td valign=bottom bgcolor=#0000ff width=100><p><span style=\"color: #ffffff\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>SUMMARY</strong></span></span></span></p></td><td valign=bottom bgcolor=#0000ff width=419><p><span style=\"color: #ffffff\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>DETAILS</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#dadfe8 width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#dadfe8 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#dadfe8 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#dadfe8 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#dadfe8 width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Data</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We only collect anonymous information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We use technologies like cookies (small files stored by your browser), web beacons, or unique device identifiers to anonymously identify your computer or device so we can deliver a better experience. Our systems also log information like your browser, operating system and IP address.<br><br>We do not collect personally identifiable information about you. In other words, we do not collect information such as your name, address, phone number or email address.<br><br>We do not knowingly contact or collect personal information from children under 13. If you believe we have inadvertently collected such information, please contact us so we can promptly obtain parental consent or remove the information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Data</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We collect but do not link personal and activity data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We use technologies like cookies (small files stored by your browser), web beacons, or unique device identifiers to anonymously identify your computer or device so we can deliver a better experience. Our systems also log information like your browser, operating system and IP address.<br><br>We also may collect personally identifiable information that you provide to us, such as your name, address, phone number or email address. With your permission, we may also access other personal information on your device, such as your phone book, calendar or messages, in order to provide services to you. If authorized by you, we may also access profile and other information from services like Facebook.<br><br>Our systems are not designed to associate personal information with your activities (such as pages you view or things you click on or search for).<br><br>We do not knowingly contact or collect personal information from children under 13. If you believe we have inadvertently collected such information, please contact us so we can promptly obtain parental consent or remove the information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Data</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We collect personal and activity data, which may be linked.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We use technologies like cookies (small files stored on your browser), web beacons, or unique device identifiers to identify your computer or device so we can deliver a better experience. Our systems also log information like your browser, operating system and IP address.<br><br>We also may collect personally identifiable information that you provide to us, such as your name, address, phone number or email address. With your permission, we may also access other personal information on your device, such as your phone book, calendar or messages, in order to provide services to you. If authorized by you, we may also access profile and other information from services like Facebook.<br><br>Our systems may associate this personal information with your activities in the course of providing service to you (such as pages you view or things you click on or search for).<br><br>We do not knowingly contact or collect personal information from children under 13. If you believe we have inadvertently collected such information, please contact us so we can promptly obtain parental consent or remove the information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Location</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We do not access your precise location.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We do not collect, use or share your precise geographic location.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Location</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We collect or share your location only with permission.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">In serving you, we may use or store your precise geographic location, if you give us permission to do so. We do not use or share this data for any other purpose. Many devices will indicate through an icon when location services are operating. We only share this location information with others as approved by you.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Location</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may collect but do not share your location history.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">To customize our service for you, we may collect and store your precise geographic location as part of your user profile. This data generally is not shared with others. We may ask for your consent on your first use of the service.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Location</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may collect and share anonymous location data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">To customize our service for you, we and our partners may collect, use, and share precise location data, including the real-time geographic location of your computer or device. This location data is collected anonymously in a form that does not personally identify you and is used only to provide and improve our service. We may obtain your consent on your first use of the service.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Access</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can request to see your personal data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can sign into your account to see any personally identifiable information we have stored, such as your name, email, address or phone number. You can also contact us by email to request to see this information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Access</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can request to see or delete your personal data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can sign into your account to see or delete any personally identifiable information we have stored, such as your name, address, email or phone number. You can also contact us by email to request to see or delete this information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Deletion</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We keep personal data for a limited period.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Our systems are designed to retain log data for up to [TIME PERIOD] after it is collected. We remove personally identifiable information (such as your name, address, email or phone number) and other preferences associated with your account promptly after you delete your account.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Deletion</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We keep personal data until you delete it.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We remove personally identifiable information (such as your name, address, email or phone number) and other preferences associated with your account promptly after you delete your account. We may retain other data indefinitely.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Deletion</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may keep data indefinitely.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may keep data indefinitely.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Sharing</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We don\'t share your personal data with other companies.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We generally do not share personally identifiable information (such as name, address, email or phone) with other companies.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Sharing</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We don\'t share your personal information with marketers.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We generally do not share personally identifiable information (such as name, address, email or phone) with other companies for marketing purposes.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Sharing</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You control whether we share personal data with partners.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may share personally identifiable information (such as name, address, email or phone) with trusted partners in order to provide you with relevant advertising, offers or services.Contact us if you want to opt-out of this sharing:<br><br>[http://www.nearpeer.org/#/contactus] OR [contact@nearpeer.org]<br><br>[Plan9, 9</span></span></span><span style=\"color: #000000\"><sup><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">th</span></span></sup></span><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"> Floor Arfa Kareem Building Ferozpur road Lahore]&nbsp;<br></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Sharing</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may share personal data with companies we trust.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We may share personally identifiable information (such as name, address, email or phone) with trusted partners in order to provide you with relevant advertising, offers or services.<br><br>California residents are legally entitled (at no charge and no more than once annually) to request information about how we may have shared your information with others for direct marketing purposes. Contact us for this information:<br><br>[http://www.nearpeer.org/#/contactus] OR [contact@nearpeer.org]<br><br>[Plan9, 9</span></span></span><span style=\"color: #000000\"><sup><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">th</span></span></sup></span><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"> Floor Arfa Kareem Building Ferozpur road Lahore]&nbsp;</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Ad Tracking</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">No ad companies collect data through our service.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We do not allow advertising companies to collect data through our service for ad targeting.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Ad Tracking</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Ad companies collect anonymous data. You can opt out.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Ad companies may use and collect anonymous data about your interests to customize content and advertising here and in other sites and applications. Interest and location data may be linked to your device, but is not linked to your identity. Click to see company privacy policies and opt-out choices:</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Contact</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can ask privacy questions.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">If you have any questions or concerns about our privacy policies, please contact us:<br><br>[http://www.nearpeer.org/#/contactus] OR [contact@nearpeer.org]<br><br>[Plan9, 9</span></span></span><span style=\"color: #000000\"><sup><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">th</span></span></sup></span><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"> Floor Arfa Kareem Building Ferozpur road Lahore]&nbsp;</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Contact</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can ask privacy questions or opt-out of marketing.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">If you have any questions or concerns about our privacy policies, please contact us:<br><br>[http://www.nearpeer.org/#/contactus] OR [contact@nearpeer.org]<br><br>[Plan9, 9</span></span></span><span style=\"color: #000000\"><sup><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">th</span></span></sup></span><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"> Floor Arfa Kareem Building Ferozpur road Lahore]&nbsp;<br><br>If you have given us contact information but do not want us to contact you with promotional or marketing information, you can opt-out here:<br><br>http://www.nearpeer.org/#/contactus<br><br>Please allow sufficient time for us to process your request.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Vendors</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Service providers access data on our behalf.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">In order to serve you, we may share your personal and anonymous information with other companies, including vendors and contractors. Their use of information is limited to these purposes, and subject to agreements that require them to keep the information confidential. Our vendors provide assurance that they take reasonable steps to safeguard the data they hold on our behalf, although data security cannot be guaranteed.<br><br>Analytics companies may access anonymous data (such as your IP address or device ID) to help us understand how our services are used. They use this data solely on our behalf. They do not share it except in aggregate form; no data is shared as to any individual user. Click to see company privacy policies that govern their use of data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Vendors</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Vendors access data on our behalf.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">In order to serve you, we may share your personal and anonymous information with other companies, including vendors and contractors. Their use of information is limited to these purposes, and subject to agreements that require them to keep the information confidential. Our vendors provide assurance that they take reasonable steps to safeguard the data they hold on our behalf, although data security cannot be guaranteed.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Vendors</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Analytics providers access data on our behalf.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Analytics companies may access anonymous data (such as your IP address or device ID) to help us understand how our services are used. They use this data solely on our behalf. They do not share it except in aggregate form; no data is shared as to any individual user. Click to see company privacy policies that govern their use of data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Security</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We take steps to protect personal information</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We take reasonable steps to secure your personally identifiable information against unauthorized access or disclosure. We encrypt transmission of data on pages where you provide payment information. However, no security or encryption method can be guaranteed to protect information from hackers or human error.<br><br>Information we collect may be stored or processed on computers located in any country where we do business.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Security</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We take detailed steps to protect personal information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">We take reasonable administrative, physical and electronic measures designed to safeguard and protect your information from unauthorized access or disclosure. This includes utilizing Secure Sockets Layer (SSL) software, which encrypts the personal information you input, and storing your information in encrypted form behind a firewall designed to block access from outside our network. However, no security or encryption method can be guaranteed to protect information from hackers or human error.<br><br>Information we collect may be stored or processed on computers located in any country where we do business.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>Special</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Special situations may require disclosure of your data.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">To operate the service, we also may make identifiable and anonymous information available to third parties in these limited circumstances: (1) with your express consent, (2) when we have a good faith belief it is required by law, (3) when we have a good faith belief it is necessary to protect our rights or property, or (4) to any successor or purchaser in a merger, acquisition, liquidation, dissolution or sale of assets. Your consent will not be required for disclosure in these cases, but we will attempt to notify you, to the extent permitted by law to do so.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=77><p align=center>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=100><p>&nbsp;</p></td><td valign=bottom bgcolor=#ff9900 width=419><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=10><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>More</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">You can review more privacy-related information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">This privacy policy was last updated on [22-12-2016]. Our privacy policy may change from time to time. If we make any material changes to our policies, we will place a prominent notice on our website or application. If the change materially affects registered users, we will send a notice to you by email, push notification or text.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr><tr><td bgcolor=#eeeeee width=4364 height=9><p>&nbsp;</p></td><td valign=bottom bgcolor=#ffffff width=77><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\"><strong>More</strong></span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=100><p><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">Our full privacy policy includes more information.</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=419><p><a name=_GoBack></a><span style=\"color: #000000\"><span style=\"font-family: Arial, serif\"><span style=\"font-size: small\">This privacy policy was last updated on [22-12-2016]. Our privacy policy may change from time to time. If we make any material changes to our policies, we will place a prominent notice on our website or application. If the change materially affects registered users, we will send a notice to you by email, push notification or text. Please read our full privacy policy, which includes other important information. [POLICY_LINK]</span></span></span></p></td><td valign=bottom bgcolor=#ffffff width=1><p>&nbsp;</p></td></tr></tbody></table><p>&nbsp;</p><p><br></p></div></div>");
$templateCache.put("app/Pages/privacypolicy1.html","<div><style type=text/css>* {\n      margin: 0;\n      padding: 0;\n      text-indent: 0;\n    }\n    .s1 {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 24pt;\n    }\n    p {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 12pt;\n      margin: 0pt;\n    }\n    a {\n      color: #00f;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: underline;\n      font-size: 12pt;\n    }\n    .s2 {\n      color: #00f;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 12pt;\n    }\n    h1 {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: bold;\n      text-decoration: none;\n      font-size: 12pt;\n    }\n    .s3 {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 16pt;\n    }\n    .s4 {\n      color: #181e23;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 12pt;\n    }\n    .s5 {\n      color: #181e23;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: bold;\n      text-decoration: none;\n      font-size: 12pt;\n    }\n    .s6 {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n      font-size: 12pt;\n    }\n    .h2 {\n      color: black;\n      font-family: \"Times New Roman\", serif;\n      font-style: normal;\n      font-weight: bold;\n      text-decoration: none;\n      font-size: 8pt;\n      vertical-align: 4pt;\n    }\n    li {\n      display: block;\n    }\n    #l1 {\n      padding-left: 0pt;\n      counter-reset: c1 1;\n    }\n    #l1 > li > *:first-child:before {\n      counter-increment: c1;\n      content: counter(c1, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l1 > li:first-child > *:first-child:before {\n      counter-increment: c1 0;\n    }\n    #l2 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l2 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l2 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l3 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l3 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l3 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l4 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l4 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l4 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l5 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l5 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l5 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l6 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l6 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l6 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l7 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l7 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l7 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l8 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l8 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l8 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l9 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l9 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l9 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l10 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l10 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l10 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l11 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l11 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l11 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l12 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l12 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l12 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l13 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l13 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l13 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l14 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l14 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l14 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }\n    #l15 {\n      padding-left: 0pt;\n      counter-reset: c2 1;\n    }\n    #l15 > li > *:first-child:before {\n      counter-increment: c2;\n      content: counter(c1, decimal) \".\" counter(c2, decimal) \". \";\n      color: black;\n      font-style: normal;\n      font-weight: normal;\n      text-decoration: none;\n    }\n    #l15 > li:first-child > *:first-child:before {\n      counter-increment: c2 0;\n    }</style><div style=\"padding: 30px\"><p class=s1 style=\"padding-top: 20px;\n        text-indent: 0pt;\n        text-align: center\">Privacy Policy</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><p class=s2 style=\"padding-left: 5pt;\n        text-indent: 0pt;\n        line-height: 108%;\n        text-align: justify\"><a href=https://www.nearpeer.org/landing class=s6 target=_blank>Welcome to the </a><span style=\"color: #00f;\n          font-family: \'Times New Roman\', serif;\n          font-style: normal;\n          font-weight: normal;\n          text-decoration: underline;\n          font-size: 12pt\">https://www.nearpeer.org</span> <span style=\"color: #000\">website (the &quot;Site&quot;). Nearpeer respects your privacy and wants to protect your personal information. To learn more, please read this Privacy Policy.</span></p><p style=\"padding-top: 7pt;\n        padding-left: 5pt;\n        text-indent: 0pt;\n        line-height: 108%;\n        text-align: justify\">This Privacy Policy <b>(</b>hereinafter, the <b>“Policy”) </b>applies to the use of the website/application and covers any information about users of our products and services <b>(</b>hereinafter, <b>“Services”) </b>that may include personal data as defined by applicable laws and regulations <b>(</b>hereinafter, <b>“Personal Information”)</b>, which Nearpeer may obtain when you use the Nearpeer website or application. The Policy is intended to inform you about how we collect and use information so you can make an informed decision about using the Services. Please read it carefully before using the Services or submitting any information to us. If you do not agree to any part of this Policy, then you should stop accessing the Services.</p><p style=\"padding-top: 8pt;\n        padding-left: 5pt;\n        text-indent: 0pt;\n        text-align: justify\">This Policy does not apply to information collected in any other way, including offline.</p><p style=\"padding-top: 9pt;\n        padding-left: 5pt;\n        text-indent: 0pt;\n        line-height: 108%;\n        text-align: justify\">This Website may contain links to services maintained by others. This Policy does not reflect the privacy practices of those services.</p><p class=s2 style=\"padding-top: 7pt;\n        padding-left: 5pt;\n        text-indent: 0pt;\n        line-height: 108%;\n        text-align: justify\"><a href=https://www.nearpeer.org/landing class=s6 target=_blank>The Policy may change as a result of changes to the Services and the content. Users are requested to refer to this Policy periodically or whenever you visit </a><span style=\"color: #00f;\n          font-family: \'Times New Roman\', serif;\n          font-style: normal;\n          font-weight: normal;\n          text-decoration: underline;\n          font-size: 12pt\">https://www.nearpeer.org</span> <span style=\"color: #000\">. By accessing and using the Website and availing the Services, the User consents to the collection, storage, and use of the personal data that the User provides (including any changes thereto as provided by you) for any of the Services and expressly authorizes the operator to process such personal data.</span></p><p style=\"text-indent: 0pt; text-align: left\"><br></p><p class=s3 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">What Information Do We Collect?</p><ol id=l1><li data-list-text=1.><h1 style=\"padding-top: 9pt;\n            padding-left: 17pt;\n            text-indent: -12pt;\n            text-align: justify\">Personal Information</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l2><li data-list-text=1.1.><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">Nearpeer may collect and store Personal Information that you provide to us when accessing or using the Services. “Personal Information” means information relating to a person who is or can be identified directly from that information. This includes your name, gender, date of birth, mobile number, email address, one-on-one communication between members on the Site, any information mentioned in inquiries, and any other details that are asked through the registration.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.2.><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">Such Personal Information will be stored anonymously when you (a) create or update your account, (b) communicate with us, (c) request services on our website/application, (d) contact us,</p><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">(e) update your profile (“Profile”), <span style=\"color: #000\">or post information using your Profile, we may also collect verification information.</span></p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.3.><p style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">We may use certain information you provide for research and statistical purposes and in such cases, we will take steps with an aim of protecting your individual identity. We may also use the</p><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                text-align: justify\">information you provide to offer you products and services that we believe may be of interest to you. You may choose not to receive such offers and communications from us when you register. You may also opt out or unsubscribe. If authorized by you, we may also access your information from services like Facebook, Google, Apple, and other related sites.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.4.><p style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">You should exercise caution when disclosing personal information in the creation of your account. Please do not submit any confidential, proprietary or sensitive personally identifiable information (e.g., CNIC; passport number (collectively, &quot;Sensitive Information&quot;). If you submit any Sensitive Information, you do so at your own risk and we will not be liable to you or responsible for consequences of your submission.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.5.><p class=s4 style=\"padding-left: 26pt;\n                text-indent: -21pt;\n                text-align: justify\">If you submit your information, know that:</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">-It must be accurate, complete, and current. It will be distributed to third parties in multiple formats (including online), and you will not be compensated by in any way for its use.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">-By submitting the information on our website, you consent to the review of such information by our team members and by those who assist us in the provision of services to the users of our Website and application. We may take steps to inform all such people that such information should be treated as being confidential and should not be shared with anyone (unless required for the provision of any requested service).</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.6.><p style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">If you choose to provide us with personal information, you consent to the transfer and storage of that information on our servers.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=1.7.><p class=s4 style=\"padding-left: 26pt;\n                text-indent: -21pt;\n                text-align: justify\">Personal Information is not associated with user behavior and activity.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=2.><p class=s5 style=\"padding-top: 11pt;\n            padding-left: 17pt;\n            text-indent: -12pt;\n            text-align: justify\">Financial Information</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l3><li data-list-text=2.1.><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">Nearpeer can or may collect and store any Financial Information on our Website. Financial Information refers to bank account details, credit and debit card information etc. (hereinafter, <b>“Financial Information”)</b>. For a successful transaction, you will be asked to choose a payment mode and the relevant Financial Information. Nearpeer can or may retain such information.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=3.><p class=s5 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">Automatically Collected Information</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l4><li data-list-text=3.1.><p class=s4 style=\"padding-left: 5pt; text-indent: 0pt; text-align: justify\">In addition to the abovementioned information, Nearpeer can and may collect some information through cookies and web beacons. When you access our Website or Services from a computer or mobile device, we may receive information about your location and your device including a unique identifier for your device, browser, operating system and your IP address. If you do not allow access, the features of the Nearpeer Services will be limited or not available for use.</p></li><li data-list-text=3.2.><p class=s4 style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                text-align: justify\">We May use your geographic location if you allow us access. This information will only be shared with third parties if you give us permission to do so. If consented by you, your precise geographic location will be shared and used by us or our partners. This information can not be traced back to personally identify you and is collected anonymously to help us improve our services.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=4.><p class=s5 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">Access to the Information</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l5><li data-list-text=4.1.><p class=s2 style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\"><a href=mailto:contact@neerpeer.org style=\"color: #181e23;\n                  font-family: \'Times New Roman\', serif;\n                  font-style: normal;\n                  font-weight: normal;\n                  text-decoration: none;\n                  font-size: 12pt\" target=_blank>You can access all the Personal Information we have stored by signing into your account . You may also email us at </a><span style=\"color: #00f;\n                  font-family: \'Times New Roman\', serif;\n                  font-style: normal;\n                  font-weight: normal;\n                  text-decoration: underline;\n                  font-size: 12pt\">contact@neerpeer.org</span> <span style=\"color: #181e23\">to get access to this information or request to have any information permanently deleted from our servers.</span></p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=5.><p class=s5 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">Data Retention</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l6><li data-list-text=5.1.><p class=s4 style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">We retain user data for no longer than necessary in relation to the purposes for which it is collected or otherwise processed.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=5.2.><p class=s4 style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Your Personal Information shall be deleted immediately after you delete your account on the Nearpeer website. However, other anonymous data in reference to your access and use of the Services collected with your permission may be retained indefinitely.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=6.><h1 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">How We Use the Information You Provide Us</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l7><li data-list-text=6.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">You provide us with information when you sign up to Nearpeer. Nearpeer will also collect information from all of it users about their use of the Website and application. Any information on users or their use of the Website is subject to Nearpeer Privacy Policy. By using Nearpeer, you consent to use of that information and warrant that all information provided by you is accurate.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.2.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">We use information other than Personal Information, including aggregated or anonymized information, for ad targeting, to analyse trends, administer the Services, improve customer service, diagnose problems with our servers, track user movement and gather demographic information for aggregate use. Third party platforms may use this information for a similar purpose, but you should follow up with third parties and confirm their information collection and usage practices directly. We may freely publish, disclose and use information other than Personal Information, including aggregated or anonymized Personal Information, to or with third parties. This information may be linked to your device but not your identity.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.3.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">We may use Your personal information to help us improve our products and services and getting in touch with you to let You know about goods, services or promotions that may interest you. Nearpeer understands your privacy needs and will not sell, trade, or share personal information collected online from customers with third parties. All personal information collected by Nearpeer will only be used internally and exclusively within our corporate group.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.4.><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">In the event that your name and address are passed on to a third party, this will only happen in an effort to have the requested service provided to you. When you order a service through Nearpeer, your personal information will also be automatically used for marketing and/or promotional purposes from time to time. However, you can choose to not receive marketing or promotional information from Nearpeer at any time by simply utilizing the unsubscribe function in the electronic marketing material sent to you.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.5.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">In the event that we engage with third party service providers in connection with our Services, Nearpeer may share Personal Information with such service providers who need access to such information to carry out their work for Nearpeer. Other than such service providers, Nearpeer does not share Personal Information with third parties unless (1) You have indicated to us that you wish to receive information from such parties; (2) You otherwise give us your consent to do so; or (3) in response to a request for information.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.6.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\"><a href=mailto:contact@nearpeer.org class=s6 target=_blank>You may request information about how we share data for direct marketing purposes with third parties. For this information you may email us at </a><a href=mailto:contact@nearpeer.org target=_blank>contact@nearpeer.org</a></p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=6.7.><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">The use of information by third parties is limited to ad targeting purposes and required to be kept confidential. However, data security cannot be guaranteed.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=7.><h1 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">Analytics Companies</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l8><li data-list-text=7.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">We may share anonymous data (such as your IP address or device id) with analytics companies including aggregated or anonymized information to analyse trends, administer the Services, improve customer service, diagnose problems with our servers, track user movement and gather demographic information for aggregate use. They do not pass this data on except in aggregate form and no personal information is used by them.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=7.2.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Your Personal and anonymous information may be shared by us with other companies including vendors and contractors. Their use of data limited and they are privy to this information that they are required to keep confidential. Our partners guarantee that the data they retain on our behalf will be kept secure using reasonable methods, although data security is not guaranteed.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=8.><h1 style=\"padding-left: 19pt; text-indent: -14pt; text-align: justify\">Transfers of Information</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l9><li data-list-text=8.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Information about our Users, including Personal Information, may be disclosed as part of any merger, acquisition, debt financing, sale of company assets, as well as in the event of an insolvency, bankruptcy or receivership in which Personal Information could be transferred to third</p><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">parties as one of our business assets. In such an event, Nearpeer will attempt to notify you before your Personal Information is transferred, but you may not have the right to opt out of any such transfer.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=9.><h1 style=\"padding-left: 17pt; text-indent: -12pt; text-align: justify\">Cookies</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l10><li data-list-text=9.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">The User is aware that a ‘Cookie’ is a small piece of information stored by a web server on a web browser so it can later be traced back from that particular browser, and that cookies are useful for enabling the browser to remember information specific to a given user, including but not limited to a User’s login identification, password, etc. The User is aware that the Website places both permanent and temporary cookies in the User’s computer&#39;s hard drive and web browser, and does hereby expressly consent to the same.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=9.2.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">The User is further aware that the Website uses data collection devices such as cookies on certain pages of the Website to help analyze web page flow, measure promotional effectiveness, and promotes trust and safety, and that certain features of the Website are only available through the use of such cookies. While the User is free to decline the Website’s cookies if the User’s browser permits, the User may consequently be unable to use certain features on the Website.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=9.3.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Additionally, the User is aware that they might encounter cookies or other similar devices on certain pages of the Website that are placed by third parties or affiliates of the Website. The User expressly agrees and acknowledges that the Website does not control the use of such cookies/other devices by third parties, that the Website is in no way responsible for the same, and that the User assumes any and all risks in this regard.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=10.><h1 style=\"padding-left: 23pt; text-indent: -18pt; text-align: justify\">Security</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l11><li data-list-text=10.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Nearpeer endeavors to secure your Personal Information from unauthorized access, use or disclosure by putting into place reasonable physical, electronic and managerial procedures to safeguard the information we collect. We use a Secure Sockets Layer (SSL) software, to assure users that their connection is secure, that encrypts personal information you provide to us and stores it in an encrypted form protected by a firewall to block access by anyone outside our network. However, no security measure or encryption can guarantee protection of data from hacking and we do not provide any guarantee of complete protection of your data.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=10.2.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">We encrypt transmission of data in which you provide payment information. However, no security or encryption method can be guaranteed to protect information from hackers or human error.</p></li><li data-list-text=10.3.><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">No security measures are perfect or impenetrable. To protect the confidentiality of your Personal Information, you must keep your password confidential and not disclose it to any other person. You are responsible for all use of the Services by any person using your password. Please advise us immediately by emailing us if you believe your password has been misused. You should also note that email is not secure, and you should not send any confidential or sensitive information to us via an unsecured email.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=10.4.><p style=\"padding-left: 32pt; text-indent: -27pt; text-align: left\">Data we collect can and may be stored in any country where we conduct business.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=11.><h1 style=\"padding-left: 26pt; text-indent: -21pt; text-align: left\">Lawful Use Only</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l12><li data-list-text=11.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">User will not publish, upload, submit or distribute any posted materials on the Nearpeer Website or app which are unlawful, deceptive, misleading, or abusive in any way, including but not limited to posted materials that are defamatory, blasphemous, libelous, obscene, threatening, indecent, invasive of privacy or publicity rights, hateful, or would constitute or encourage a criminal offence, violate the rights of any party, contain any corrupted data or malicious code that may impair or alter the appearance or functionality of Nearpeer, or give rise to liability or violate any local, state, federal or international law or regulation.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=11.2.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">On certain sections of the Nearpeer Website, posted materials submitted for publication on will be accompanied by User’s name and shall not be submitted anonymously. User warrants that such posted materials will not misrepresent or obscure his or her identity or affiliation with any person or entity. Furthermore, User warrants that it will not, by any method or action, directly or through a third party seek to artificially enhance, degrade, or otherwise manipulate the recommendations or endorsements of any User, individual, or group on Nearpeer including User’s own.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=12.><h1 style=\"padding-left: 26pt; text-indent: -21pt; text-align: left\">Your Rights</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l13><li data-list-text=12.1.><p style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">If you are concerned about your data, you have the right to request access to the personal data which we may hold or process about you. You have the right to require us to correct any inaccuracies in your data free of charge. At any stage, you also have the right to ask us to stop using your personal data for direct marketing purposes.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=13.><h1 style=\"padding-left: 26pt; text-indent: -21pt; text-align: left\">Children</h1><ol id=l14><li data-list-text=13.1.><p style=\"padding-top: 4pt;\n                padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\">Our Services are not intended for use by children under the age of 18. We do not knowingly collect Personal Information from people under 18. If you become aware that a child has provided us with Personal Information, please contact us as set forth in this Policy.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li><li data-list-text=13.2.><p style=\"padding-left: 32pt;\n                text-indent: -27pt;\n                text-align: justify\">Children under the age of 18 can only user our services by declaring a guardian first.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p></li></ol></li><li data-list-text=14.><h1 style=\"padding-left: 26pt; text-indent: -21pt; text-align: justify\">Questions</h1><p style=\"text-indent: 0pt; text-align: left\"><br></p><ol id=l15><li data-list-text=14.1.><p class=s2 style=\"padding-left: 5pt;\n                text-indent: 0pt;\n                line-height: 108%;\n                text-align: justify\"><a href=mailto:contact@nearpeer.org class=s6 target=_blank>If you have any additional concerns or questions related to this Policy and/or our practices, please email us at </a><span style=\"color: #00f;\n                  font-family: \'Times New Roman\', serif;\n                  font-style: normal;\n                  font-weight: normal;\n                  text-decoration: underline;\n                  font-size: 12pt\">contact@nearpeer.org</span> <a href=http://www.nearpeer.org/contact-us class=s6 target=_blank>or contact us through our website https://www.nearpeer.org/contact-us</a></p></li></ol></li></ol><p style=\"text-indent: 0pt; text-align: left\"><br></p><p style=\"padding-left: 5pt;\n        text-indent: 0pt;\n        line-height: 108%;\n        text-align: left\">We may make changes to this Privacy Policy at any time by posting the amended terms on the Website. If the change materially affects registered users, they shall be notified by email.</p><p style=\"text-indent: 0pt; text-align: left\"><br></p><h1 style=\"padding-left: 5pt; text-indent: 0pt; text-align: left\">**This Privacy Policy was last updated on 1<span class=h2>st </span>June 2022.**</h1></div></div>");
$templateCache.put("app/Pages/workwithus.html","<div class=wws-info><div class=container><div class=row><div class=\"column separator\"><div class=\"col-md-12 text-center\"><h2>Work as a Team Member</h2><p>At Nearpeer, we are always looking for talented individuals who not only want to learn but also want to help us grow as a company. You will enjoy the perks of working in a growing start-up, solving the real life challenges, and impacting the lives of 100s of thousands students out there awaiting affordable quality education. Come and join us.</p><img src=images/wws-2.png></div><div class=\"col-md-12 text-center\"><button ng-click=\"gotoCustomLink(\'https://www.nearpeer.org/np-form/5uvjfabw52\')\">Join Us</button></div></div><div class=column><div class=\"col-md-12 text-center\"><h2>Work as Instructor</h2><p>If you are a passionate instructor who wants to eliminate the physical barriers, and wants to reach to a global audience of millions of students through technology, we can help you in making it possible. Fill up the form and our team will get back to you. Looking forward to take you aboard on this fantastic journey.</p><img src=images/wws-1.png height=160 width=320></div><div class=\"col-md-12 text-center\"><button ng-click=\"gotoCustomLink(\'https://www.nearpeer.org/np-form/7qm7c1k1q0\')\">Join Us</button></div></div></div></div></div>");
$templateCache.put("app/Faqs/faqs.html","<div class=\"faqs-mdcat landing-new-mdcat\" style=background:#eeeeee><div class=sat-cont><div class=stories-top><h1>Frequently Asked Questions (FAQs)</h1></div><div class=stories-top><h1 style=color:darkseagreen><span>{{name}}</span></h1></div><div class=panel-group id=faqAccordion><div class=\"panel panel-default\" ng-repeat=\"faq in faqs\"><div class=\"panel-heading accordion-toggle question-toggle collapsed\" data-toggle=collapse data-parent=#faqAccordion data-target=#question{{$index}}><h4 class=panel-title><a href=# class=ing style=\"white-space: pre-line\">{{($index+1)}}: {{faq.faqId.question}}</a></h4></div><div id=question{{$index}} class=\"panel-collapse collapse\" style=\"height: 0px\"><div class=panel-body><h5><span class=\"label label-primary\">Answer</span></h5><p style=\"white-space: pre-line\" ng-bind-html=\"faq.faqId.answer  | to_trusted\"></p></div></div></div></div></div></div><div class=mdcat-contact><div class=sat-cont><h1>Contact us</h1><ul><li><a href=http://m.me/nearpeer.org target=_blank><img src=images/connect-on-messenger.jpg alt=\"\"></a></li><li><a href=\"https://api.whatsapp.com/send?phone=923470171480\" target=_blank><img src=images/connect-on-whatsapp.jpg alt=\"\"></a></li></ul></div></div><div class=mdcat-logos-patners><ul><li><a href=http://plan9.pitb.gov.pk/ target=_blank><img src=images/pitb.png alt=\"\"></a></li><li><a href=https://www.ilmkidunya.com/ target=_blank><img src=images/ilmki.png alt=\"\"></a></li><li><a href=https://lce.lums.edu.pk/ target=_blank><img src=images/nic-lhr.png alt=\"\"></a></li><li><a href=https://shopistan.pk/ target=_blank><img src=images/shopistan-logo.png alt=\"\"></a></li></ul></div>");
$templateCache.put("app/admin/admin.html","<div class=loader ng-show=responsePopup><img src=images/squares.gif></div><div ng-hide=responsePopup><div class=\"header header-two\"><div class=logo><a><svg xmlns=http://www.w3.org/2000/svg width=240 height=60 viewBox=\"0 0 240 60\"><metadata><?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?> <x:xmpmeta xmlns:x=adobe:ns:meta/ x:xmptk=\"Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01        \"><rdf:RDF xmlns:rdf=http://www.w3.org/1999/02/22-rdf-syntax-ns#><rdf:Description rdf:about=\"\"/></rdf:RDF></x:xmpmeta> <?xpacket end=\"w\"?></metadata><defs><style>.cls-1 {\n      fill: #112d4e;\n      fill-rule: evenodd;\n    }</style></defs><path id=Logo class=cls-1 d=M209.473,68.243a7.823,7.823,0,0,1,.289-2.155,5.276,5.276,0,0,1,.867-1.775,4.158,4.158,0,0,1,1.444-1.2,4.363,4.363,0,0,1,2.022-.444,5.236,5.236,0,0,1,2.166.4,3.826,3.826,0,0,1,1.444,1.1,4.135,4.135,0,0,1,.784,1.626,8.378,8.378,0,0,1,.227,1.987V79.993H222.6V67.1a11.254,11.254,0,0,0-.433-3.17,7.115,7.115,0,0,0-1.321-2.557,6.15,6.15,0,0,0-2.228-1.692,7.438,7.438,0,0,0-3.115-.612,7.665,7.665,0,0,0-3.384.8,6.344,6.344,0,0,0-2.723,2.706V59.664h-3.8v20.33h3.878V68.243Zm20.311-.507a5.191,5.191,0,0,1,.454-1.9,6.11,6.11,0,0,1,1.093-1.669,5.131,5.131,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H229.784Zm11.43,5.284a6.853,6.853,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.9,5.9,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H244.6a4.31,4.31,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.639-4.332,9.709,9.709,0,0,0-1.837-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.649,8.649,0,0,0-3.589.781,9.231,9.231,0,0,0-3.033,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.4,12.4,0,0,0,.805,4.608,10.043,10.043,0,0,0,2.186,3.423,9.243,9.243,0,0,0,3.2,2.114,10.214,10.214,0,0,0,3.8.718,9.543,9.543,0,0,0,3.178-.507,9.361,9.361,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm6.725,3.847a5.8,5.8,0,0,0,1.341,1.922,6.8,6.8,0,0,0,2.084,1.331,7.078,7.078,0,0,0,2.744.507,8.246,8.246,0,0,0,2.373-.317,7.139,7.139,0,0,0,1.836-.825,6.585,6.585,0,0,0,1.32-1.1,7.489,7.489,0,0,0,.867-1.141q0,1.1.062,1.733a9.121,9.121,0,0,0,.144,1.014h3.8a11.843,11.843,0,0,1-.165-1.183c-0.056-.535-0.082-1.253-0.082-2.155V66.468a8.861,8.861,0,0,0-.454-2.831,6.151,6.151,0,0,0-1.444-2.367,7.161,7.161,0,0,0-2.559-1.627,10.448,10.448,0,0,0-3.8-.613,9.31,9.31,0,0,0-3.033.486,8.078,8.078,0,0,0-2.5,1.353,7.119,7.119,0,0,0-2.6,4.754l3.713,0.887a4.937,4.937,0,0,1,1.32-2.937,4.2,4.2,0,0,1,3.178-1.163,4.325,4.325,0,0,1,3.28,1.077,3.614,3.614,0,0,1,1.011,2.558,1.591,1.591,0,0,1-.31.971,1.754,1.754,0,0,1-1.217.551l-5.364.8a10.771,10.771,0,0,0-2.393.677,6.285,6.285,0,0,0-1.919,1.225,5.355,5.355,0,0,0-1.258,1.839,6.2,6.2,0,0,0-.454,2.43A5.813,5.813,0,0,0,247.939,76.867Zm4.354-.487a2.9,2.9,0,0,1-.867-2.05,2.665,2.665,0,0,1,.825-2.092,4.046,4.046,0,0,1,2.063-.951l6.066-.929v0.929a7.76,7.76,0,0,1-.454,2.812,4.864,4.864,0,0,1-1.217,1.859,4.632,4.632,0,0,1-1.816,1.015,7.764,7.764,0,0,1-2.249.318A3.094,3.094,0,0,1,252.293,76.38Zm26.971-16.927a4.688,4.688,0,0,0-.516-0.085,6.642,6.642,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.794,6.794,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.878V69.808q0-3.338,1.507-4.8a5.421,5.421,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453Zm7.191,28.572V77.246a6.929,6.929,0,0,0,2.475,2.325,7.677,7.677,0,0,0,3.962.972,8.88,8.88,0,0,0,3.9-.824,8.476,8.476,0,0,0,2.909-2.283,10.152,10.152,0,0,0,1.815-3.4,13.846,13.846,0,0,0,.619-4.226,14.048,14.048,0,0,0-.6-4.143,10.283,10.283,0,0,0-1.733-3.381,8,8,0,0,0-2.847-2.261,8.978,8.978,0,0,0-3.941-.824,7.635,7.635,0,0,0-4.126,1.058,6.97,6.97,0,0,0-2.517,2.577V59.664h-3.755V88.025h3.838ZM297.76,72.7a6.819,6.819,0,0,1-1.176,2.283,5.38,5.38,0,0,1-1.836,1.481,5.83,5.83,0,0,1-4.848,0,5.514,5.514,0,0,1-1.877-1.481,6.607,6.607,0,0,1-1.2-2.283,9.726,9.726,0,0,1-.413-2.894A9.179,9.179,0,0,1,286.826,67a6.681,6.681,0,0,1,1.2-2.241,5.783,5.783,0,0,1,1.877-1.5,5.31,5.31,0,0,1,2.414-.549,5.3,5.3,0,0,1,4.291,2.049A7.143,7.143,0,0,1,297.76,67a9.179,9.179,0,0,1,.413,2.811A9.726,9.726,0,0,1,297.76,72.7Zm11.207-4.966a5.171,5.171,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.116,5.116,0,0,1,1.65-1.186,5.271,5.271,0,0,1,2.208-.443,5.133,5.133,0,0,1,4,1.5,5.64,5.64,0,0,1,1.445,3.7H308.967ZM320.4,73.02a6.843,6.843,0,0,1-1.857,2.916,5.275,5.275,0,0,1-3.713,1.184,6.126,6.126,0,0,1-2.331-.445,5.529,5.529,0,0,1-1.9-1.268,5.91,5.91,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H323.78a4.708,4.708,0,0,0,.062-0.55q0.02-.337.02-0.718a13.95,13.95,0,0,0-.639-4.332,9.724,9.724,0,0,0-1.836-3.361,8.186,8.186,0,0,0-2.992-2.177,10.1,10.1,0,0,0-4.064-.781,8.65,8.65,0,0,0-3.59.781,9.251,9.251,0,0,0-3.033,2.2,10.939,10.939,0,0,0-2.084,3.381,11.72,11.72,0,0,0-.784,4.373,12.424,12.424,0,0,0,.805,4.608,10.031,10.031,0,0,0,2.187,3.423,9.224,9.224,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718A9.541,9.541,0,0,0,318,80.121a9.346,9.346,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm10.3-5.284a5.191,5.191,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.109,5.109,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H330.7Zm11.43,5.284a6.862,6.862,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.879,5.879,0,0,1-1.258-1.965,7.255,7.255,0,0,1-.5-2.493h14.937a4.5,4.5,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.64-4.332,9.707,9.707,0,0,0-1.836-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.653,8.653,0,0,0-3.59.781,9.237,9.237,0,0,0-3.032,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.425,12.425,0,0,0,.8,4.608A10.046,10.046,0,0,0,329.56,77.8a9.234,9.234,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718,9.537,9.537,0,0,0,3.177-.507,9.352,9.352,0,0,0,2.58-1.374,9.013,9.013,0,0,0,3.156-4.544Zm17.88-13.568a4.688,4.688,0,0,0-.516-0.085,6.628,6.628,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.772,6.772,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.879V69.808q0-3.338,1.506-4.8a5.423,5.423,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453ZM162.327,68.719a0.2,0.2,0,0,0,.206-0.331A11.771,11.771,0,0,1,159.061,60a20.22,20.22,0,0,0-4.147-12.314A19.33,19.33,0,0,0,139.53,40,19.773,19.773,0,0,0,120,60v11.67a8.254,8.254,0,0,0,7.63,8.319,0.493,0.493,0,0,0,.507-0.5V60h0A11.534,11.534,0,0,1,139.53,48.332a11.414,11.414,0,0,1,10.687,7.607A21.973,21.973,0,0,0,162.327,68.719ZM170.453,40a19.249,19.249,0,0,0-14.175,6.258,0.8,0.8,0,0,0-.042,1.008,21.472,21.472,0,0,1,3.549,7.748,0.185,0.185,0,0,0,.354.036,11.378,11.378,0,0,1,10.353-6.713,11.674,11.674,0,0,1-.039,23.34,22.719,22.719,0,0,1-19.119-10.551,0.2,0.2,0,0,0-.365.118,20.094,20.094,0,0,0,8.092,15.007A19.117,19.117,0,0,0,170.933,80,20.017,20.017,0,0,0,170.453,40ZM158.641,77.575a21.307,21.307,0,0,1-7.348-9.211,0.191,0.191,0,0,0-.37.072V91.678A8.251,8.251,0,0,0,158.559,100a0.487,0.487,0,0,0,.5-0.5V78.382A0.987,0.987,0,0,0,158.641,77.575Z transform=\"translate(-120 -40)\"/></svg></a></div><div class=\"menu menu-2\"><ul class=\"nav-hidden menu-items old-admin-header-container\"><li ng-click=\"\" class=old-admin-header-items style=\"margin: 0 10px\"><a>Courses</a><ul style=\"margin: 0 8px\"><li><a class=submenu ng-click=showCourseForm()>Create Course</a></li><li><a class=submenu ng-click=showCourses(1)>Manage Courses</a></li><li><a class=submenu ng-click=addModule()>Manage Modules</a></li><li><a class=submenu ng-click=showVideoManagement()>Manage Videos</a></li><li><a class=submenu ng-click=showAddVideoQuality()>Add Video Quality</a></li></ul></li><li ng-click=\"\" class=old-admin-header-items style=\"margin: 0 10px\"><a>Coupons</a><ul style=\"margin: 0 8px\"><li ng-click=showCouponForm()><a class=submenu>Generate Coupons</a></li><li ng-click=showCoupons(1,1)><a class=submenu>View Coupons</a></li></ul></li><li class=old-admin-header-items style=\"margin: 0 10px\"><a>Manage Users</a><ul style=\"margin: 0 8px\"><li><a class=submenu ng-click=showUsers(1)>Manage Students</a></li><li><a class=submenu ng-click=showEnrolledStudents()>Enrolled Students</a></li><li><a class=submenu ng-click=createInstructForm()>Create Instructor</a></li><li><a class=submenu ng-click=showInstructors()>Manage Instructors</a></li><li><a class=submenu ng-click=showAllCourses() style=display:none>All Courses</a></li></ul></li><li class=old-admin-header-items style=\"margin: 0 20px\"><a>Blog</a><ul style=\"margin: 0 8px\"><li><a class=submenu ng-click=ShowCreateBlogForm()>Create Blog</a></li><li><a class=submenu ng-click=ShowEditBlogForm()>Edit Blog</a></li><li><a class=submenu ng-click=ShowBlogComments()>Blog Comments</a></li><li><a class=submenu ng-click=ShowBlogCategories()>Blog Categories</a></li></ul></li><!-- <li><a>Bundles</a>\n      <ul>\n        <li><a ng-click=\"ShowCreateBundle()\">Create Bundle</a></li>\n        <li><a ng-click=\"ShowViewBundles()\">View Bundles</a></li>\n      </ul>\n    </li> --></ul></div><div class=header-contact><div ng-show=true class=\"dropdown my-accont-header\"><a href=\"\" class=\"dropdown-toggle my-accont-header-link\" data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>My Account</a><ul class=dropdown-menu><li><div class=form-group><button type=button ng-click=logOut()>log out</button></div></li></ul></div></div></div><div ng-show=URLloader style=\"margin-left: 50%\"><img src=images/squares.gif width=100px height=100px></div><div class=admin-cont><div class=container-fluid ng-show=signedIn><div class=\"col-sm-12 col-md-12\" ng-show=courseFormFlag style=\"background: #eee\"><h1>Create Course</h1><div style=\"background: #9be0c6; border-radius: 5px\"><h3 style=color:white>Let\'s start by creating a course. Please fill in all the fields to continue</h3></div><form role=form><div><label>Name</label><input class=form-control type=text ng-model=createCourseForm.name></div><div><label>Price</label><input type=checkbox ng-model=createCourseForm.paid> Paid <input class=form-control ng-disabled=!createCourseForm.paid placeholder=\"Please enter price in PKR numericals\" type=number ng-model=createCourseForm.price></div><div><label>Live Date</label><input class=form-control ng-model=createCourseForm.live_date datetime-picker future-only></div><div><label>Description</label><textarea class=form-control type=text rows=5 cols=100 ng-model=createCourseForm.description></textarea></div><div><label>Short Description</label><textarea maxlength=200 class=form-control type=text rows=5 cols=100 ng-model=createCourseForm.short_description></textarea></div><div><label>Institution</label><input class=form-control type=text ng-model=createCourseForm.institution></div><div><label>College/Faculty</label><input class=form-control type=text ng-model=createCourseForm.faculty></div><div><label>Instructor</label><input class=form-control type=text ng-model=createCourseForm.instructor></div><br><div><label class=\"btn btn-primary\">Upload Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'newCourseImage\')\"></label></div><div ng-show=imageUploadInProgress><div class=\"panel panel-info\"><div class=panel-heading>Upload Log</div><p>{{image_log.name}}</p><div class=\"progress progress-striped\"><div class=progress-bar role=progressbar aria-valuenow={{image_log.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: image_log.progress + \'%\'}\"><span>{{image_log.progress}}% Complete</span></div></div></div></div><div ng-hide=!createCourseForm.image_url><h1>Course Image</h1><img ng-src={{createCourseForm.image_url}} height=100 width=100></div><div><br><strong><input type=checkbox ng-model=createCourseForm.publish><label>Publish on website</label></strong></div><div><br><strong><input type=checkbox ng-model=createCourseForm.special><label>Special Course(Only courses that should not appear in dropdown menu)</label></strong></div><div><button type=button class=\"btn btn-primary\" ng-click=createCourse()>Create Course</button> <span ng-show=loader><img src=images/squares.gif width=20px height=20px></span></div></form></div><div class=\"col-sm-12 col-md-12\" ng-show=loadVideo style=\"position:relative ;top:60px\"><video id=video></video><button type=button ng-click=capture()>Capture</button><div><img ng-src={{imgSrc}}></div></div><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=coupon_form_flag style=\"position:relative ;top: 40px\"><h1>Generate Coupons</h1><form role=form ng-init=\"createCouponForm = {}\"><div><label>Number of Coupons</label><input class=form-control type=number ng-model=createCouponForm.quantity></div><div><label>Price</label><input class=form-control type=number ng-model=createCouponForm.price></div><div><label>Expiry Date</label><input class=form-control type=datetime-local ng-model=createCouponForm.expiryDate></div><br></form><div><button class=\"btn btn-primary\" id=submit ng-disabled=coupon_button ng-click=createCoupons()>Generate!</button></div></div></div><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=show_coupons style=\"position:relative ;top:0px\"><div class=\"container newTable\"><h2>Coupons</h2><h4>Sort By</h4><select ng-change=showCoupons(1,sortType) ng-model=sortType><option value=1 selected>Default</option><option value=2>Created At Ascending</option><option value=3>Status Used</option><option value=4>Status Available</option></select><h4>No. Of Records</h4><select ng-model=coupon_record_no><option value=20 selected>20</option><option value=50>50</option><option value=100>100</option></select><h4>Out of</h4>{{total_coupons}}<p><input type=text placeholder=\"Search By Coupon Id\" ng-model=couponID> <button class=\"btn btn-primary\" ng-click=searchCouponById(couponID)>Search</button></p><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>Index</th><th ng-click=\"sortBy = \'id\'; sortReverse = !sortReverse\">Id <span class=arrow-sort><img ng-show=\"sortBy == \'id\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'id\' && !sortReverse\" src=images/down-arrow.png></span></th><th ng-click=\"sortBy = \'coupon_id\'; sortReverse = !sortReverse\">Coupon Id<span class=arrow-sort><img src=images/up-arrow.png ng-show=\"sortBy == \'coupon_id\' && sortReverse\"><img src=images/down-arrow.png ng-show=\"sortBy == \'coupon_id\' && !sortReverse\"></span></th><th ng-click=\"sortBy = \'price\'; sortReverse = !sortReverse\">Price<span class=arrow-sort><img src=images/up-arrow.png ng-show=\"sortBy == \'price\' && sortReverse\"><img src=images/down-arrow.png ng-show=\"sortBy == \'price\' && !sortReverse\"></span></th><th ng-click=\"sortBy = \'status\'; sortReverse = !sortReverse\">Status<span class=arrow-sort><img src=images/up-arrow.png ng-show=\"sortBy == \'status\' && sortReverse\"><img src=images/down-arrow.png ng-show=\"sortBy == \'status\' && !sortReverse\"></span></th><th ng-click=\"sortBy = \'created_at\'; sortReverse = !sortReverse\">Created At<span class=arrow-sort><img src=images/up-arrow.png ng-show=\"sortBy == \'created_at\' && sortReverse\"><img src=images/down-arrow.png ng-show=\"sortBy == \'created_at\' && !sortReverse\"></span></th></tr></thead><tbody><tr ng-repeat=\"coupon in coupons | orderBy: sortBy : sortReverse\"><td>{{$index+1}}</td><td>{{coupon.id}}</td><td>{{coupon.coupon_id}}</td><td>{{coupon.price}}</td><td><p ng-if=\"coupon.status ==true\" style=color:green>Available</p><p ng-if=\"coupon.status==false\" style=color:red>Used</p></td><td>{{coupon.created_at | date: \'short\'}}</td></tr></tbody></table></div><nav aria-label=... ng-hide=hidePagination><ul class=pager><li class=previous><a href=\"\" ng-click=showCoupons(page-1,sortType)><i class=\"fa fa-chevron-left\" aria-hidden=true></i></a></li><li class=next><a href=\"\" ng-click=showCoupons(page+1,sortType)><i class=\"fa fa-chevron-right\" aria-hidden=true></i></a></li></ul></nav><button class=\"btn btn-primary\" id=download_csv ng-click=downloadCouponsCsv()>Save as CSV</button></div></div></div><div class=\"admin-cont admin-cont-nav\" style=\"width: 100%\"><div class=\"col-sm-12 col-md-12\" ng-show=show_users style=\"position:relative ;top:0px;width: 100%\"><div class=\"container newTable responsive-user\"><h2 style=\"text-align: center;color: #3498db;font-size:30px\">Users</h2><h4 style=float:right><select ng-model=user_record_no><option value=50>50</option><option value=100>100</option><option value=500>500</option><option value=1000>1000</option></select><b>Total Count:</b> {{total_users}}</h4><div class=responsive-user-100 style=width:700px><div style=display:inline-block;width:20%><form ng-submit=\"showUsers(1, \'full_name\', full_name)\" role=form><div class=form-group><label>Search by Name</label><input type=text ng-model=full_name class=form-control style=\"border: solid 1px grey\"> <button type=submit class=\"btn btn-primary\" style=\"margin-top: 4px; color: #fff; background-color: #27ae60\">Search</button></div></form></div><div style=\"display:inline-block;width:20%;margin-left: 4px\"><form ng-submit=\"showUsers(1, \'email\', email)\" role=form><div class=form-group><label>Search by Email</label><input type=email ng-model=email class=form-control style=\"border: solid 1px grey\"> <button type=submit class=\"btn btn-primary\" style=\"margin-top: 4px; color: #fff; background-color: #27ae60\">Search</button></div></form></div><div style=\"display:inline-block;width:20%; margin-left: 4px\"><form ng-submit=\"showUsers(1, \'phone\', phone)\" role=form><div class=form-group><label>Search by Phone</label><input type=text pattern=[0-9]{11} ng-model=phone class=form-control style=\"border: solid 1px grey\"> <button type=submit class=\"btn btn-primary\" style=\"margin-top: 4px; color: #fff; background-color: #27ae60\">Search</button></div></form></div></div><!-- <div class=\"table-responsive\"> --><table class=\"table table-bordered table-striped\" style=\"width: 100%\"><thead><tr><th ng-click=\"sortBy = \'id\'; sortReverse = !sortReverse\" style=\"color: #3498db\">User Id <span class=arrow-sort><img ng-show=\"sortBy == \'id\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'id\' && !sortReverse\" src=images/down-arrow.png></span></th><th style=\"color: #3498db\">Provider</th><th ng-click=\"sortBy = \'full_name\'; sortReverse = !sortReverse\" style=\"color: #3498db\">Full Name <span class=arrow-sort><img ng-show=\"sortBy == \'full_name\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'full_name\' && !sortReverse\" src=images/down-arrow.png></span></th><th ng-click=\"sortBy = \'email\'; sortReverse = !sortReverse\" style=\"color: #3498db\">Email<span class=arrow-sort><img ng-show=\"sortBy == \'email\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'email\' && !sortReverse\" src=images/down-arrow.png></span></th><th ng-click=\"sortBy = \'phone\'; sortReverse = !sortReverse\" style=\"color: #3498db\">Phone <span class=arrow-sort><img ng-show=\"sortBy == \'phone\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'phone\' && !sortReverse\" src=images/down-arrow.png></span></th><th style=\"color: #3498db\">User Type</th><th style=\"color: #3498db\">Password</th><th ng-click=\"sortBy = \'created_at\'; sortReverse = !sortReverse\" style=\"color: #3498db\">Created At <span class=arrow-sort><img ng-show=\"sortBy == \'created_at\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'created_at\' && !sortReverse\" src=images/down-arrow.png></span></th><th style=\"color: #3498db\">Balance</th><th ng-click=\"sortBy = \'disabled\'; sortReverse = !sortReverse\" style=\"color: #3498db\">Disable<span class=arrow-sort><img ng-show=\"sortBy == \'disabled\' && sortReverse\" src=images/up-arrow.png><img ng-show=\"sortBy == \'disabled\' && !sortReverse\" src=images/down-arrow.png></span></th><th style=\"color: #3498db\">Verify Phone</th><th style=\"color: #3498db\">Allow Web Serving</th></tr></thead><tbody><tr ng-repeat=\"user in users | orderBy: sortBy :sortReverse\"><td style=\"color: red\">{{user.id}}</td><td>{{user.provider | uppercase}}</td><td>{{user.full_name || user.name}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><td>{{user.user_type}}</td><td>{{user.token}}</td><td>{{user.created_at | date: \'short\'}}</td><td><input style=\"width: 74px; border: solid 1px black\" type=text ng-model=user.credit> <button ng-click=updateBalance(user.id,user.credit) class=\"btn btn-primary\" style=\"color: #fff; background-color: #27ae60; margin-top: 3px\">Update</button></td><td><button ng-hide=user.disabled ng-click=disableUser(user) class=\"btn btn-primary\" style=\"color: #fff; background-color: #27ae60\">Disable User</button><button ng-show=user.disabled ng-click=enableUser(user) class=\"btn btn-primary\">Enable</button></td><td><button ng-show=!user.phone_confirmed_at ng-click=verifyUser(user) class=\"btn btn-primary\" style=\"color: #fff; background-color: #27ae60\">Verify Phone</button><p ng-show=user.phone_confirmed_at style=\"color: blue\">Verified</p></td><td><button ng-show=!checkWebServingStatus(user) ng-click=requestVideoOnWeb(user) class=\"btn btn-primary\" style=\"color: #fff; background-color: #27ae60\">Allow Web Serving</button><p ng-show=checkWebServingStatus(user) style=\"color: blue\">Allowed</p></td></tr></tbody></table><!-- </div> --></div><nav aria-label=... ng-hide=hidePagination><ul class=pager><li class=previous><a href=\"\" ng-click=\"showUsers(page-1, type, search_query)\"><span aria-hidden=true>&larr;</span></a></li><li class=next style=\"margin-right: 50px\"><a href=\"\" ng-click=\"showUsers(page+1, type, search_query)\"><span aria-hidden=true>&rarr;</span></a></li></ul></nav><button ng-click=downloadUserCSV() class=\"btn btn-primary\" id=download_csv style=\"margin-left: 150px\">Download as CSV</button></div></div><div class=\"col-sm-12 col-md-12 responsive-box\" ng-show=show_courses style=\"position:relative ;top:40px\"><h1>Course Management</h1><div style=\"position: fixed\" class=\"search-box search-box45\"><ul><li><h4>Select Institution</h4><select class=form-control ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></li><li><h4>Select Faculty</h4><select class=form-control ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></li><li><h4>Select Course</h4><select class=form-control ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></li><br><button class=\"btn btn-primary\" style=\"margin-left: 75px\" ng-click=showCourseEditForm(selectedCourse)>Edit Course</button></ul></div><div><div ng-show=collapseCourseRow><form><h4>Course Url</h4><p>{{selectedCourse.index_url}}</p><input type=checkbox ng-model=selectedCourse.display_ads> Display Ads<h4>Course Name</h4><button class=\"btn btn-primary\" style=float:right ng-click=deleteCourse(selectedCourse)>Delete This Course</button> <input ng-model=selectedCourse.name><h4>Course Description</h4><textarea rows=5 cols=100 ng-model=selectedCourse.description>\n                </textarea><h4>Course Short Description</h4><textarea maxlength=200 rows=5 cols=100 ng-model=selectedCourse.short_description>\n                </textarea><p>*char limit 200</p><h4>Instructor Id</h4><input type=text ng-model=selectedCourse.instructor_id><h4>Institution</h4><input ng-model=selectedCourse.institution><h4>Faculty</h4><input ng-model=selectedCourse.faculty><h4>Instructor</h4><input ng-model=selectedCourse.instructor><h4>Price</h4><input type=checkbox ng-model=selectedCourse.paid> Paid <input ng-disabled=!selectedCourse.paid placeholder=\"Please enter price in PKR numericals\" type=number ng-model=selectedCourse.price> <input type=number ng-model=selectedCourse.discount_price name=course-name placeholder=\"Please enter the discounted price of course in PKR\" ng-disabled=!selectedCourse.paid min=0><h4>Live Date</h4><input class=date-time-picker-input ng-model=selectedCourse.live_date datetime-picker future-only><h4><input type=checkbox ng-model=selectedCourse.featured> Featured</h4><h4>Video Quality</h4><div><div ng-repeat=\"coursequality in course_qualities\"><h4><input type=checkbox ng-model=coursequality.setquality><p>{{coursequality.quality_name}}</p></h4></div></div><button class=\"btn btn-primary\" ng-hide=selectedCourse.previous_high_quality ng-click=convertVideoHD()>Convert previous Videos into 360,480 & 720</button> <button class=\"btn btn-primary\" ng-show=selectedCourse.previous_high_quality ng-click=revertbtn()>Alert Previous Transcoding Button Revert</button><br><br><br><button class=\"btn btn-primary\" ng-click=courseOrderTermination()>course order terminate</button><h4><input type=checkbox ng-model=selectedCourse.publish> Publish</h4><div style=\"margin-top: 50px; margin-bottom: 50px; border-top: 1px; border-bottom: 1px\"><h4 style=\"margin-bottom: 15px; margin-top: 15px\">Offline Download Configuration</h4><h5><input type=checkbox ng-model=selectedCourse.allow_download_offline ng-change=\"changeDownloadConfig(\'download\')\"> Allow Download Offline</h5><h5><input type=checkbox ng-model=selectedCourse.delete_offline_videos ng-change=\"changeDownloadConfig(\'delete\')\"> Remove Offline Videos (From Users Device)</h5></div><div style=\"margin-top: 50px; margin-bottom: 50px; border-top: 1px; border-bottom: 1px\"><h4 style=\"margin-bottom: 15px; margin-top: 15px\">GCP Video Serving</h4><h5><input type=checkbox ng-model=selectedCourse.gcp_video_serving> Allow GCP Video Serving</h5><button class=\"btn btn-primary\" ng-if=\"selectedCourse.is_converted_to_vvs !== \'completed\'\" ng-click=transcodeToGCP()>Convert Video to GCP</button></div><input type=checkbox ng-model=selectedCourse.hidden><h4>Hide Course From Website (Still accessible via direct hit)</h4><input type=checkbox ng-model=selectedCourse.special><h4>Special Course(Only courses that should not appear in dropdown menu)</h4><h4>Course Image</h4><img width=200px height=100px ng-src={{selectedCourse.image_url}}><h4>Upload New Image</h4><div><label class=\"btn btn-primary\">Upload Image<input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'editCourseImage\')\"></label></div><div ng-show=course_uploadingImage><div class=\"panel panel-info\"><div class=panel-heading>Upload Log</div><p>{{image_log.name}}</p><div class=\"progress progress-striped\"><div class=progress-bar role=progressbar aria-valuenow={{image_log.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: image_log.progress + \'%\'}\"><span>{{image_log.progress}}% Complete</span></div></div></div></div><div ng-show=course_imageUploaded><h1>Course Image</h1><img ng-src={{selectedCourse.image_url}} height=100 width=100></div></form><br><div class=col-md-8><h3>Metatags</h3><table class=table><thead><tr><th>Property</th><th>Content</th></tr></thead><tbody><tr ng-repeat=\"metatags in selectedCourse.metatags\"><td style=\"text-align: center\">{{metatags.property}}</td><td style=\"text-align: center\">{{metatags.content}}</td><td><button class=\"btn btn-danger\" ng-click=deleteMetatagCourse($index)>X</button></td></tr></tbody></table></div><div class=col-md-8><h4>Add metatags</h4><div><div class=row><div class=col-md-5><input type=text ng-model=metatagProperty placeholder=Property class=form-control></div><div class=col-md-5><input type=text ng-model=metatagContent placeholder=Content class=form-control></div><div class=col-md-2><button class=\"btn btn-primary\" ng-click=addMetaTagToCourse()>Add</button></div></div></div></div><br><div class=col-md-12 style=\"margin-top: 25px\"><button class=\"btn btn-primary\" ng-click=UpdateCourse(selectedCourse,course_qualities)>Update Course Data</button><span ng-show=loader><img src=images/squares.gif width=20px height=20px></span></div></div></div></div><!-- MODULE MANAGEMENT--><div class=\"col-sm-12 col-md-12 responsive-box\" ng-show=newModuleForm style=\"position:relative ;top:40px\"><h1>Manage Module</h1><div style=\"position: fixed\" class=\"search-box search-box45\"><ul><li><h4>Select Institution</h4><select class=form-control ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></li><li><h4>Select Faculty</h4><select class=form-control ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></li><li><h4>Select Course</h4><select class=form-control ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></li><br><button class=\"btn btn-primary\" style=\"margin-left: 75px\" ng-click=showModules()>GO</button></ul></div><!-- LIST MODULES --><div ng-show=listModules><table class=\"table table-bordered table-striped\"><tr><th>Module No</th><th>Module Name</th><th>Edit</th><th>Delete</th></tr><tr ng-repeat=\"module in modules\"><td>{{module.module_no}}</td><td>{{module.name}}</td><td><button class=\"btn btn-primary\" ng-click=showModuleEditForm(module)>Edit Module</button></td><td><button class=\"btn btn-primary\" ng-click=deleteModule(module,$index)>Delete Module</button></td></tr></table><button class=\"btn btn-primary\" ng-click=showNewModuleForm()>Add New Module</button></div><!-- MODULE EDIT FORM --><div><div ng-show=collapseModuleRow><h1>Module Edit Form</h1><form><h4>Module No</h4><input ng-model=selectedModule.module_no><h4>Module Name</h4><input ng-model=selectedModule.name><h4>Module Description</h4><textarea rows=5 cols=100 ng-model=selectedModule.description>\n                  </textarea><h4>Module Short Description</h4><textarea maxlength=200 rows=5 cols=100 ng-model=selectedModule.short_description>\n                  </textarea><p>*char limit 200</p><h4>Module Type</h4><form><input ng-hide=selectedModule.module_type.paid type=checkbox ng-model=selectedModule.module_type.free>Free<br><input ng-hide=selectedModule.module_type.free type=checkbox ng-model=selectedModule.module_type.paid>Paid<br><div ng-show=selectedModule.module_type.paid>Price <input type=number ng-model=selectedModule.module_type.price></div><div><input type=checkbox ng-model=selectedModule.youtube>Youtube<br></div><input type=number name=course-name placeholder=\"Please enter the discounted price of module in PKR\" ng-model=selectedModule.module_type.discount ng-disabled=!selectedModule.module_type.paid min=0></form><h4>Module Image</h4><img width=200px height=100px ng-src={{selectedModule.image_url}}><h4>Upload New Image</h4><div><label class=\"btn btn-primary\">Upload Image<input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image,\'editModuleImage\')\"></label></div><div ng-show=course_uploadingImage><div class=\"panel panel-info\"><div class=panel-heading>Upload Log</div><p>{{image_log.name}}</p><div class=\"progress progress-striped\"><div class=progress-bar role=progressbar aria-valuenow={{image_log.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: image_log.progress + \'%\'}\"><span>{{image_log.progress}}% Complete</span></div></div></div></div><div ng-show=\"\"><h1>Course Image</h1><img ng-src={{selectedModule.image_url}} height=100 width=100></div></form><button class=\"btn btn-primary\" ng-click=updateModuleData(selectedModule)>Update Module Data</button> <span ng-show=loader><img src=images/squares.gif width=20px height=20px></span></div></div><!-- NEW MODULE FORM --><div><div ng-show=collapseNewModuleRow><h1>New Module Form</h1><form><h4>Module Name</h4><input ng-model=selectedModule.name><h4>Module Description</h4><textarea rows=5 cols=100 ng-model=selectedModule.description>\n                    </textarea><h4>Module Short Description</h4><textarea maxlength=200 rows=5 cols=100 ng-model=selectedModule.short_description>\n                    </textarea><h4>Module Type</h4><form><input type=checkbox ng-hide=selectedModule.module_type.paid ng-model=selectedModule.module_type.free>Free<br><input type=checkbox ng-hide=selectedModule.module_type.free ng-model=selectedModule.module_type.paid>Paid<br><div ng-show=selectedModule.module_type.paid>Price <input type=number placeholder=\"Please enter price in PKR numericals\" ng-model=selectedModule.module_type.price></div></form><h4>Upload New Image</h4><div ng-hide=\"course_imageUploaded || course_uploadingImage\"><label class=\"btn btn-primary\">Upload Image<input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image,\'newModuleImage\')\"></label></div><div ng-show=course_uploadingImage><div class=\"panel panel-info\"><div class=panel-heading>Upload Log</div><p>{{image_log.name}}</p><div class=\"progress progress-striped\"><div class=progress-bar role=progressbar aria-valuenow={{image_log.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: image_log.progress + \'%\'}\"><span>{{image_log.progress}}% Complete</span></div></div></div></div><div><img ng-src={{selectedModule.image_url}} height=100 width=100></div></form><button class=\"btn btn-primary\" ng-click=addNewModuleData(selectedModule,selectedCourse)>Add Module</button></div></div></div><!-- VIDEO MANAGEMENT --><div class=\"col-sm-12 col-md-12 responsive-box\" ng-show=videoForm><div class=container><h1>Video Management</h1><div class=\"search-box search-box45\"><ul><li><select class=form-control ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option>Select Institution</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></li><li><select class=form-control ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option>Select School</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></li><li><select class=form-control ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option>Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></li><li><select class=form-control ng-model=selectedModule ng-change=\"\"><option>Select Module</option><option ng-repeat=\"module in modules | orderBy:\'module_no\'\" value={{module.name}}>{{module.name}}</option></select></li><li><button class=\"btn btn-primary\" ng-click=submit(selectedModule) ng-disabled=dataEntered>GO</button></li></ul></div><div ng-show=showVideos><table class=table><thead><tr><th class=border-top-remv>#</th><th>Video Name</th><th>Youtube ID</th><th>Video No</th><th>Delete</th></tr></thead><tbody><tr ng-repeat=\"video in videos\"><td>{{$index+1}}</td><td>{{video.name}}</td><td><input type=text ng-model=video.youtube_id placeholder=\"Youtube Video ID\"></td><td><input type=number ng-model=video.video_no></td><td><button class=\"btn btn-primary\" ng-click=deleteVideo(video)>Delete</button></td></tr></tbody></table><h2>Add More Videos</h2><div flow-init flow-directory flow-files-submitted=\"uploadNewVideos( $files, $event, $flow, selectedModule)\"><div class=drop-box flow-drop>Drag And Drop your file here</div><div></div><div class=\"panel panel-default\" ng-show=selModule.show_logs><div class=panel-heading>Upload Log</div><div class=panel-body ng-repeat=\"log in selModule.logs\"><p>{{log.name}}</p><div class=\"progress progress-striped\"><div class=progress-bar role=progressbar aria-valuenow={{log.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: log.progress + \'%\'}\"><span>{{log.progress}}% Complete</span></div></div></div></div><div class=\"panel panel-default\" ng-show=selModule.files_uploaded><div class=panel-heading>Files Uploaded</div><div class=panel-body ng-repeat=\"file in selModule.files_\"><p>{{file.name}}</p></div></div></div><button class=\"btn btn-primary\" ng-click=updateVideoData()>Update Data</button> <span ng-show=loader><img src=images/squares.gif width=20px height=20px></span></div></div></div><div><div class=\"col-sm-12 col-md-12\" ng-show=createInstructorForm style=\"position:relative ;top:100px; background-color: #eee;width: 40%;border-radius: 10px ;padding:20px;margin-left:30%\"><h1 style=\"color: #3498db;text-align: center\">Create Instructor</h1><div class=create-instructor-form><form ng-init=\"createInstructerForm={}\"><p>Full Name</p><input type=text class=form-control name=name ng-model=createInstructerForm.name style=\"background-color: white; border: solid 1px #ccc\"> <span ng-if=\"!createInstructerForm.name && formisSubmitted\" style=\"color: red\">Name is required.</span><br><p>Email</p><input type=text class=form-control name=username ng-model=createInstructerForm.username style=\"background-color:white;  border: solid 1px #ccc\"> <span ng-if=\"!createInstructerForm.username && formisSubmitted\" style=\"color: red\">Email is required.</span><br><p>Password</p><input type=text class=form-control name=password ng-model=createInstructerForm.password style=\"background-color: white; border: solid 1px #ccc\"> <span ng-if=\"!createInstructerForm.password && formisSubmitted\" style=\"color: red\">Password is required.</span><br><br><div style=\"text-align: center\"><input type=submit class=\"btn btn-primary btn-lg\" ng-click=createInstructor(createInstructerForm) value=\"Create Instructor\" style=\"color: #fff; background-color: #27ae60;margin-bottom: 10px\"></div></form></div></div><div class=\"col-sm-12 col-md-12\" ng-show=instructorList style=\"position:relative;margin-top: 20px\"><h1 style=\"text-align: center; color:crimson;text-decoration: solid;font-size: 50px\">Instructors</h1><div class=input-group style=\"margin-bottom: 10px; width: 35%; margin-top: 10px ; height: 30px\"><input type=text class=form-control placeholder=\"Search Instructor\" ng-model=searchTerm style=\"border-radius: 4px; border: 1px solid #ccc\"> <span class=input-group-btn><button class=\"btn btn-primary\" type=button style=\"background-color: #27ae60; margin-left: 5px; color: white; border-radius: 4px\" ng-click=searchInstructors()>Search</button></span></div><div class=table-responsive><br><table class=\"table table-bordered table-striped\"><tr style=\"text-decoration: solid;font-size: large; color: #3498db\"><th>Instructor Id</th><th>Full Name</th><th>Image</th><th>Email</th><th>Share Percentage</th><th>Discount Percentage</th><th>Update Profile</th></tr><tr ng-repeat=\"instructor in instructors\"><td style=\"color: crimson\">{{instructor.id}}</td><td>{{ instructor.full_name }}</td><td><div style=\"display: flex; align-items: center\"><img ng-src=\"{{ instructor.image || \'images/placeholder.png\' }}\" alt=image style=\"width: 50px; height: 50px; border-radius: 50%; margin-left: 3px\"></div></td><td>{{instructor.email}}</td><td><input ng-model=instructor.share style=\"border: 1px solid #ccc\"><button ng-click=updateInstructor($index) style=\"background-color: #27ae60; padding: 3px; color: white; margin-left: 2px; border-radius: 4px\">Update</button></td><td><input ng-model=instructor.discount style=\"border: 1px solid #ccc\"> <button ng-click=updateInstructor($index) style=\"background-color: #27ae60; padding: 3px; color: white; margin-left: 2px; border-radius: 4px\">Update</button></td><td><button ng-click=showUpdatePopup(instructor) style=\"background-color: #3498db; padding: 3px; border-radius: 4px\">Update</button></td></tr></table></div></div><!-- Popup Menu --><div class=popup ng-show=showPopup style=\"display: block; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999\"><div class=popup-content style=\"background-color: #fff; max-height: 50%;  padding: 20px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); border-radius: 5px; overflow-y: auto\"><h2>Edit Instructor</h2><label for=fullName>Full Name:</label><input type=text id=fullName ng-model=selectedInstructor.full_name style=\"width: 100%; padding: 5px; border: 3px solid #ccc\"> <span ng-if=\"!selectedInstructor.full_name && formSubmitted\" style=\"color: red\">Name is required.</span><br><label for=email>Email:</label><input type=email id=email ng-model=selectedInstructor.email style=\"width: 100%; padding: 5px; border: 3px solid #ccc\"> <span ng-if=\"!selectedInstructor.email && formSubmitted\" style=\"color: red\">Email is required</span><br><br><div><label class=\"btn btn-primary\" style=\"background-color: aqua; color: #112d4e\"><span>Upload Image</span> <input type=file id=image style=\"display: none\" accept=image/* ng-model=image ngf-select=uploadInstructorImage(image)></label><span ng-if=isUploading class=mini-loader></span></div><div ng-show=imageLink style=\"margin-top: 10px\"><!-- <p style=\"color: blue;\">{{ imageLink }}</p> --> <img ng-src=\"{{ imageLink }}\" alt=\"Uploaded Image\" style=\"max-width: 100px; max-height: 100px; border-radius: 15px;\"></div><button ng-click=updateInstructorData(selectedInstructor) style=\"background-color: #27ae60; color: #fff; border: none; padding: 5px 10px; margin-top: 10px\">Update</button> <button ng-click=closePopup() style=\"background-color: #e74c3c; color: #fff; border: none; padding: 5px 10px; margin-top: 10px\">Cancel</button></div></div><div class=\"col-sm-12 col-md-12\" ng-show=addNewQualityVideo style=\"position:relative ;top:40px\"><h2>All Quality</h2><div><div class=table-responsive><table class=\"table table-bordered table-striped\"><tr><th>Quality Name</th><th>Preset ID</th></tr><tr ng-repeat=\"quality in allquality\"><td>{{quality.quality_name}}</td><td>{{quality.Preset_id}}</td></tr></table></div></div><div><h2>Add New Quality</h2><ul><li><label>Quality Name:</label><input type=text class=admin-input ng-model=saveQuality.quality_name></li><li><label>Preset ID</label><input type=text class=admin-input ng-model=saveQuality.Preset_id></li></ul><button ng-click=saveVideoQuality(saveQuality) class=\"btn btn-primary\">Save</button></div></div><div class=\"col-sm-12 col-md-12\" ng-show=enrolledStudentsTable style=\"position:relative ;top:60px\"><div class=\"container newTable\"><h2>Enrolled Students</h2><div class=\"row mb-20\"><div class=col-lg-4><h4>Select Course<select class=form-control ng-change=\"getEnrolledStudents(1, selectedCourse)\" ng-model=selectedCourse><option value={{$index}} ng-repeat=\"course in allCourses\">{{course.name}}</option></select></h4></div><div class=col-lg-4 style=\"padding-top: 27px\"><button class=\"btn btn-primary\" id=download_csv ng-click=downloadEnrollment(selectedCourse)>Export</button> <span style=\"padding: 0 10px\"><b>Total: {{totalEnrolled}}</b></span></div></div><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>User Id</th><th>Name</th><th>Email</th><th>Joining Date</th><th>crn</th><th>phone</th><th>university</th><th>city</th><th>dob</th><th>Mail</th></tr></thead><tbody><tr ng-repeat=\"student in enrolledStudents | orderBy: sortBy : sortReverse\"><td>{{student.user_id}}</td><td>{{student.name}}</td><td>{{student.email}}</td><td>{{student.joining_date | date: \'short\'}}</td><td>{{student.crn }}</td><td>{{student.phone }}</td><td>{{student.university }}</td><td>{{student.city }}</td><td>{{student.dob }}</td><td><input type=checkbox ng-model=student.mail checked></td></tr></tbody></table></div><nav aria-label=... ng-hide=hidePagination ng-if=selectedCourse><ul class=pager><li class=previous><a href=\"\" ng-click=\"getEnrolledStudents(enrollStudentpage-1, selectedCourse)\"><span aria-hidden=true>&larr;</span></a></li><li class=next><a href=\"\" ng-click=\"getEnrolledStudents(enrollStudentpage+1, selectedCourse)\"><span aria-hidden=true>&rarr;</span></a></li></ul><ul class=pager style=\"margin-top: 20px\" ng-if=selectedCourse><li class=previous>{{enrollStudentpage}} of {{totalEnrolledPages}}</li></ul></nav></div><div ng-show=studentsExist class=\"mb-50 container\" style=\"padding: 0\"><h4>Email Text</h4><textarea class=form-control type=text rows=5 cols=100 ng-model=emailText style=\"height: 120px !important\"></textarea><br><button class=\"btn btn-primary\" ng-click=sendUpdateEmailNotification(emailText,enrolledStudents)>Send To All</button></div></div><div ng-show=showAllCoursePage style=\"position:relative ;top:0px\"><div class=table-responsive><table><tr><th>Course Name</th><th>Faculty</th><th>Institution</th><th>Save</th></tr><tr ng-repeat=\"course in allCourses\"><td><input type=text ng-model=course.name></td><td><input type=text ng-model=course.faculty></td><td><input type=text ng-model=course.institution></td><td><button ng-click=UpdateCourse(course)>Save</button></td></tr></table></div></div><!-- admin Blogs --><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=showEditBlogForm style=\"position:relative ;top:0px\"><div class=\"container newTable\"><h2>Blogs List</h2><input type=text class=\"form-control search-input\" placeholder=Search ng-model=searchBlog><div class=table-responsive style=\"overflow-x: scroll\"><table class=\"table table-bordered table-striped\"><thead><tr><th>Id</th><th>Name</th><th>Description</th><th>Views</th><th>Created At</th><th>Published</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"blog in blogs | filter:searchBlog\"><td>{{blog.id}}</td><td>{{blog.name}}</td><td>{{blog.description}}</td><td>{{blog.views}}</td><td>{{blog.date | date: \'short\'}}</td><td><input type=checkbox ng-model=blog.publish ng-change=changePublishStatusBlog(blog)></td><td><button type=button class=\"btn btn-success btn-sm\" ng-click=displayBlog(blog)>Edit</button></td></tr></tbody></table></div></div></div></div><!-- admin index page --><div class=container><div ng-show=showCreateBlogForm class=\"col-sm-12 col-md-12\"><input type=text ng-model=blog.name placeholder=\"Blog Name\" class=form-control><br><input type=text ng-model=blog.author_name placeholder=\"Author Name\" class=form-control><br><input type=text ng-model=blog.author_email placeholder=\"Author Email\" class=form-control><br><textarea ng-model=blog.description placeholder=\" Add Description \" class=form-control></textarea><select class=\"form-control mt-20\" ng-model=blog.category_id><option value=0 disabled>Select Category</option><option ng-repeat=\"category in blogCategories\" value={{category.id}}>{{category.name}}</option></select><br><input type=text ng-model=blog.blogUrl placeholder=\"Blog Url\" class=form-control><br><div><h3>Metatags</h3><table class=table><thead><tr><th>Property</th><th>Content</th></tr></thead><tbody><tr ng-repeat=\"metatags in blog.metatags\"><td>{{metatags.property}}</td><td>{{metatags.content}}</td><td><button class=\"btn btn-danger\" ng-click=deleteMetatag($index)>X</button></td></tr></tbody></table></div><div><h4>Add metatags</h4><div><div class=row><div class=col-md-5><input type=text ng-model=metatagProperty placeholder=Property class=form-control></div><div class=col-md-5><input type=text ng-model=metatagContent placeholder=Content class=form-control></div><div class=col-md-2><button class=\"btn btn-primary\" ng-click=addMetaTagToBlog()>Add</button></div></div></div></div><div><br><label class=\"btn btn-primary\">Banner Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'blogBanner\')\"></label>{{blog.image}}</div><br><div><div class=row><div class=col-md-5><input type=text ng-model=blog.banner_alt placeholder=\"Banner Alt trext\" class=form-control></div></div></div><br><!-- <div text-angular ng-model=\"blog.content\"></div> --><div id=editor-container></div><input type=checkbox ng-model=blog.publish> publish <input type=checkbox ng-model=blog.feature> Feature<br><br><button class=\"btn btn-primary mb-20\" ng-click=SaveBlog(blog)>Save</button><div><!-- <label class=\"btn btn-primary\">\n                      Upload Image <input type=\"file\" style=\"display: none;\" accept=\"image/*\"	ng-model=\"image\" ngf-select=\"uploadImage(image, \'blogImage\')\">\n                    </label> --></div><div ng-repeat=\"pic in blog.images\"><img height=250 width=250 ng-src={{pic.url}} alt=Description><p>{{pic.url}}</p></div>{{blogText}}</div></div><!-- admin Add Blog category --><div class=container><div ng-show=showCreateBlogCategoryForm class=\"col-sm-12 col-md-12\"><input type=text ng-model=category.name placeholder=\"Category Name\" class=form-control><br><textarea ng-model=category.description placeholder=\" Add Description \" class=form-control></textarea><div><label class=\"btn btn-primary\">Upload Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'blogCategoryImage\')\"></label></div><button class=\"btn btn-primary mt-20\" ng-click=SaveBlogCategory(category)>Save</button></div></div><!-- admin Blog Categories --><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=show_blog_categories style=\"position:relative ;top:0px\"><div class=\"container newTable\"><h2>Blog Categories</h2><button class=\"btn btn-primary mb-20\" ng-click=ShowBlogCategoryForm()>Add New Category</button> <input type=text class=\"form-control search-input\" placeholder=Search ng-model=search><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>Id</th><th>Name</th><th>Description</th><th>Created At</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"category in blogCategories | filter:search\"><td>{{category.id}}</td><td>{{category.name}}</td><td>{{category.description}}</td><td>{{category.createdAt | date: \'short\'}}</td><td><button type=button class=\"btn btn-success btn-sm\" ng-click=EditBlogCategoryForm(category.id)>Edit</button> <button type=button class=\"btn btn-danger btn-sm\" ng-click=\"DeleteBlogCategoryForm(category.id, $index)\">Delete</button></td></tr></tbody></table></div></div></div></div><!-- admin panel main page --><div ng-show=showBlogComments class=\"col-sm-12 col-md-12 admin-and-instructor-comment\" style=\"position:relative ;top:60px\"><div class=\"comment-section-new row\"><div class=comment-section><div class=main-heading-comment><h1>Comments</h1><span>({{blogcomments.allComments.length}})</span></div><div class=main-tabs-comment ng-init=\"selected=1\" ng-show=true><ul><li ng-click=change(1) ng:class=\"{\'active\' : selected==1}\">ALL</li><li ng-click=change(2) ng:class=\"{\'active\' : selected==2}\">APPROVED</li><li ng-click=change(3) ng:class=\"{\'active\' : selected==3}\">PENDING</li><li ng-click=change(4) ng:class=\"{\'active\' : selected==4}\">HIDDEN</li></ul></div><div class=main-tabs-comment-inner><ul><li ng-class=\"{\'opc-hide\': comments.disabled}\" ng-repeat=\"comments in AllComments\"><div class=tabs-comment-inner-list><div class=tabs-comment-inner-img><div>{{comments.user.name.charAt(0).toUpperCase()}}</div></div><div class=tabs-comment-inner-list-info><div class=main-heading-comment-info><h1>{{comments.user.name}}</h1><span>{{comments.comment_time |date:\'short\'}}</span><small><img src=images/comment-user-status.png alt=\"\" ng-show=comments.approved></small></div><div class=main-heading-comment-info-midle><h2>{{comments.text}}</h2><img ng-show=comments.image_url ng-src={{comments.image_url}} height=400 width=300></div><div class=main-heading-comment-info-bottom><div ng-show=true><small ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\">|</small> <button ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\" ng-click=blogapproveComment(comments.id)>APPROVE</button> <small ng-show=!comments.hidden>|</small> <button ng-show=!comments.hidden ng-click=hideBlogComment(comments.id)>HIDE</button> <small ng-show=comments.hidden>|</small> <button ng-show=comments.hidden ng-click=unhideBlogComment(comments.id)>SHOW</button> <small ng-show=!comments.disabled>|</small> <button ng-show=!comments.disabled ng-click=deleteBlogComment(comments.id)>delete</button></div></div></div></div><ul><li ng-class=\"{\'opc-hide\': reply.disabled}\" ng-repeat=\"reply in comments.replies \"><div class=tabs-comment-inner-list><div class=tabs-comment-inner-img><div>{{reply.user.name.charAt(0).toUpperCase()}}</div></div><div class=tabs-comment-inner-list-info><div class=main-heading-comment-info><h1>{{reply.user.name}}</h1><span>{{reply.comment_time|date:\'short\'}}</span><small><img src=images/comment-user-status.png alt=\"\" ng-show=reply.approved></small></div><div class=main-heading-comment-info-midle><h2>{{reply.text}}</h2><img ng-show=reply.image_url ng-src={{reply.image_url}} height=400 width=300></div><div class=main-heading-comment-info-bottom><small ng-if=\"selected == 3 || (!reply.approved && !reply.disabled)\">|</small> <button ng-if=\"selected == 3 || (!reply.approved && !reply.disabled)\" ng-click=blogapprovereply(reply.id)>APPROVE</button> <small ng-show=!reply.hidden>|</small> <button ng-show=!reply.hidden ng-click=hideBlogReply(reply.id)>HIDE</button> <small ng-show=reply.hidden>|</small> <button ng-show=reply.hidden ng-click=showBlogReply(reply.id)>SHOW</button></div></div></div></li></ul></li></ul></div></div></div></div></div></div><div id=download_csv></div></div><div class=\"col-sm-12 col-md-12\" ng-show=comments style=\"position:relative ;top:60px\"><h1>Comments Management</h1><table class=\"table table-bordered table-striped\"><tr><th>Video Name</th><th>Text</th><th>Approved</th><th>Disabled</th></tr><tr ng-repeat=\"data in AllComments\"><td>{{data.video_name}}</td><td>{{data.text}}</td><td><button ng-class=\"data.approved ? \'button-color-true\' : \'button-color-false\'\" ng-click=approveComment(data.approved,data.comment_id)>{{data.approved}}</button></td><td><button ng-class=\"data.disabled ? \'button-color-true\' : \'button-color-false\'\" ng-click=disableComment(data.disabled,data.comment_id)>{{data.disabled}}</button></td></tr></table></div><div ng-show=showAllCoursePage style=\"position:relative ;top:60px\"><table><tr><th>Course Name</th><th>Faculty</th><th>Institution</th><th>Save</th></tr><tr ng-repeat=\"course in allCourses\"><td><input type=text ng-model=course.name></td><td><input type=text ng-model=course.faculty></td><td><input type=text ng-model=course.institution></td><td><button ng-click=UpdateCourse(course)>Save</button></td></tr></table></div><div id=download_csv></div></div>");
$templateCache.put("app/admin/admin_signin.html","<div class=admin-cont-new><h1>WELCOME TO NEARPEER ADMIN PANEL</h1><div class=admin-form><div></div><div class=popup-form><md-tabs md-dynamic-height><md-tab label=\"Sign in\"><md-content flex layout-padding><div class=form-container><form><ul class=form-list><li><md-input-container class=md-block><label>Email</label><input type=email name=email ng-model=loginForm.email required></md-input-container></li><li><md-input-container class=md-block><label>Password</label><input type=password name=password ng-model=loginForm.password required></md-input-container></li></ul></form><div class=buttonset><md-button type=button class=md-raised ng-click=submitLogin(loginForm)>LOGIN</md-button></div></div><!-- //.form-container --></md-content></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/admin/otpPage.html","<div style=\"text-align: center; padding-top: 150px\"><div class=\"position-centre parent_div\"><h4 style=\"margin-top: 0px;font-size: 15px;padding: 0 15px\">Please enter one time verification code sent to your Email</h4><hr style=\"border-color: white\"><table class=position-centre style=\"margin-top: 50px; margin-bottom: 50px\"><tbody><tr><td><input type=text style=\"color: black\" class=input_field name=\"\" ng-model=otpCode></td></tr></tbody></table><table class=position-centre style=\"font-size: 12px\"><tbody><tr><td><p style=\"margin: 0px\">Didn\'t receive the OTP?</p></td><td><a href=# style=\"margin: 0px 10px; color: brown\" ng-click=resendOtp()>Resend Code</a></td></tr></tbody></table></div><button class=\"position-centre button_custom\" ng-click=verifyOtp()>Verify</button></div>");
$templateCache.put("app/b2b/b2b.html","<div><!-- Hero section --><section class=\"b2b-section b2b-hero\"><div class=container><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6\"><div class=hero-content><h1 class=\"hero-title wow fadeInUp\" data-wow-duration=1s>A Better <span>Learning Future </span>Starts Here.</h1><p class=\"hero-detail wow fadeInUp\" data-wow-duration=1s data-wow-delay=0.7s>Get the education that would make the real difference.</p><a ng-click=takeToForm() class=b2b-btn>Get started</a></div></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><div class=hero-mobile-title><h5>Nearpeer <span>Business</span></h5></div><div class=hero-image><img class=\"wow fadeIn\" data-wow-duration=1s data-wow-delay=1s src=../../images/b2b/hero-image-sharukh.png alt=\"hero image\"></div></div></div></div></section><!-- Pricing section --><section class=\"b2b-section b2b-pricing\"><div class=container><div class=section-title><h2 class=\"section-title text-center wow fadeInUp\" data-wow-duration=1s>Pricing Plans that fit your scale</h2></div><div class=b2b_pricing_desktop><div class=row><div class=col-md-4><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s><div class=\"package-header basic\"><h3>Basic <span>(Hosting)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Start hosting your courses on our secure platform without any hassle. Get access to millions of students!</div><div class=package-price>PKR <span>199</span> per student per month</div><div class=divider>OR</div><div class=package-discount><span>15%</span> Revenue share</div></div><div class=package-feat><div class=\"package-feat-title basic\">Features</div><ul class=basic><li><span>Secure Video Hosting and LMS access</span></li><li><span>Backend Instructor Panel to manage everything</span></li><li><span>Quizzes and Assessment Management</span></li><li><span>Secure and automated Payment Gateways</span></li><li><span>User data, feedbacks, and dashboards</span></li><li><span>Integrated Communication Tools</span></li><li><span>Course insights and analytics</span></li><li><span>Discussion with students</span></li><li><span>Secure Offline Video Storage</span></li><li><span>Cross Platform availability</span></li><li><span>Basic Support and Customer Handling</span></li></ul></div></div></div><div class=col-md-4><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=1.5s><div class=\"package-header professional\"><h3>Professional <span>(Production)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Take your institute/idea to the digital world with confidence. Set-up your own digital world with ease</div><div class=package-price>PKR <span>299</span> per user per month</div><div class=divider>OR</div><div class=package-discount><span>50%</span> to <span>70%</span> Revenue share</div></div><div class=package-feat><div class=\"package-feat-title professional\">Features</div><ul class=professional><li><span>All <b>Basic</b> Package Features PLUS…</span></li><li><span>Consultancy and Teacher Training for video content production </span></li><li><span>Studio access in Lahore </span></li><li><span>Studio setup guidance at your desired location </span></li><li><span>Production studios for Marketing content</span></li><li><span>Instructor evaluation and feedback </span></li><li><span>Marketing and Selling of the content </span></li><li><span>CRM Integration </span></li><li><span>End to end customer support team </span></li><li><span>Strategy planning and execution </span></li></ul></div></div></div><div class=col-md-4><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=2s><div class=\"package-header premium\"><h3>Premium <span>(Customized)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Get access to the content of your liking and digitize your institution.</div><div class=package-price>PKR <span>1499</span> per user per month</div><div class=divider>OR</div><div class=\"package-discount premium text-center\"><span ng-click=takeToForm()>Schedule a call</span></div></div><div class=package-feat><div class=\"package-feat-title premium\">Features</div><ul class=premium><li><span><!-- Everything in <b>Basic</b> and <b>Professional</b> Package  --> All <b>Basic</b> and <b>Professional</b> Package Features PLUS… </span></li><li><span>Access to any of the readily available programs</span></li><li><span>Customized Dashboards and Analytics </span></li><li><span><!-- Customized content based on the users’ feedback --> Customized content based on user feedback </span></li><li><span>Intelligent recommendation and feedback mechanism </span></li><li><span>Advance assessment tools</span></li><li><span>Customized Developments</span></li><li><span>Business Intelligence (BI / BA) module Enabled </span></li></ul></div></div></div></div></div><div class=b2b_pricing><div class=splide__arrows><button class=\"splide__arrow splide__arrow--next\"><img src=../../images/b2b/pricin-arrow-next.png alt=#></button> <button class=\"splide__arrow splide__arrow--prev\"><img src=../../images/b2b/pricing-arrow-prev.png alt=#></button></div><div class=splide__track><ul class=splide__list><li class=splide__slide><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s><div class=\"package-header basic\"><h3>Basic <span>(Hosting)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Start hosting your courses on our secure platform without any hassle. Get access to millions of students!</div><div class=package-price>PKR <span>199</span> per student per month</div><div class=divider>OR</div><div class=package-discount><span>15%</span> Revenue share</div></div><div class=package-feat><div class=\"package-feat-title basic\">Features</div><ul class=basic><li><span>Secure Video Hosting and LMS access</span></li><li><span>Backend Instructor Panel to manage everything</span></li><li><span>Quizzes and Assessment Management</span></li><li><span>Secure and automated Payment Gateways</span></li><li><span>User data, feedbacks, and dashboards</span></li><li><span>Integrated Communication Tools</span></li><li><span>Course insights and analytics</span></li><li><span>Discussion with students</span></li><li><span>Secure Offline Video Storage</span></li><li><span>Cross Platform availability</span></li><li><span>Basic Support and Customer Handling</span></li></ul></div></div></li><li class=splide__slide><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=1.5s><div class=\"package-header professional\"><h3>Professional <span>(Production)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Take your institute/idea to the digital world with confidence. Set-up your own digital world with ease</div><div class=package-price>PKR <span>299</span> per user per month</div><div class=divider>OR</div><div class=package-discount><span>50%</span> to <span>70%</span> Revenue share</div></div><div class=package-feat><div class=\"package-feat-title professional\">Features</div><ul class=professional><li><span>All <b>Basic</b> Package Features PLUS…</span></li><li><span>Consultancy and Teacher Training for video content production </span></li><li><span>Studio access in Lahore </span></li><li><span>Studio setup guidance at your desired location </span></li><li><span>Production studios for Marketing content</span></li><li><span>Instructor evaluation and feedback </span></li><li><span>Marketing and Selling of the content </span></li><li><span>CRM Integration </span></li><li><span>End to end customer support team </span></li><li><span>Strategy planning and execution </span></li></ul></div></div></li><li class=splide__slide><div class=\"package-box wow fadeInUp\" data-wow-duration=1s data-wow-delay=2s><div class=\"package-header premium\"><h3>Premium <span>(Customized)</span></h3><img src=../../images/b2b/np-logo.png alt=\"np logo\"></div><div class=package-detail><div class=package-desc>Get access to the content of your liking and digitize your institution.</div><div class=package-price>PKR <span>1499</span> per user per month</div><div class=divider>OR</div><div class=\"package-discount premium text-center\"><span ng-click=takeToForm()>Schedule a call</span></div></div><div class=package-feat><div class=\"package-feat-title premium\">Features</div><ul class=premium><li><span><!-- Everything in <b>Basic</b> and <b>Professional</b> Package  --> All <b>Basic</b> and <b>Professional</b> Package Features PLUS… </span></li><li><span>Access to any of the readily available programs</span></li><li><span>Customized Dashboards and Analytics </span></li><li><span><!-- Customized content based on the users’ feedback --> Customized content based on user feedback </span></li><li><span>Intelligent recommendation and feedback mechanism </span></li><li><span>Advance assessment tools</span></li><li><span>Customized Developments</span></li><li><span>Business Intelligence (BI / BA) module Enabled </span></li></ul></div></div></li></ul></div></div><div class=\"package-feat b2b-pricing-feat b2b-pricing-points\"><ul><li><span><!-- Prices can be reduced based on the number of students/users. --> Package prices can be negotiated based on the number of students / users. </span></li><li><span>Additional PKR 999 per agent will be charged for the CRM for Basic Package.</span></li><li><span>Marketing and Selling agreement can be executed with Basic Plan members too.</span></li></ul></div></div></section><!-- Key feature section --><section class=\"b2b-section b2b-keyfeat pt-0\"><div class=container><div class=\"section-title wow fadeInUp\" data-wow-duration=1s><h2>Key Features of Nearpeer</h2><p><!-- Lunched in 2016, Nearpeer is home to an award-winning team of educators, researchers, technologies\n                    and thought leaders who build and deliver ground-breaking tools that increase the capacity of\n                    educators and their organizations to research, select and evaluate digital learning products that\n                    best meet the current needs of their students. Our core-offerings are: --><!-- Launched in 2016, Nearpeer is home to an award-winning team of educators, researchers, technologists\n                    and thought-leaders. They build and deliver impactful tools that enhance the capacity of\n                    academicians and educational institutes with the aim to help them explore, select and utilize the\n                    e-learning products, that best meet the needs of their students/beneficiaries. --> Launched in 2016, Nearpeer is home to an award-winning team of educators, researchers, technologists, and thought-leaders. We build and deliver impactful tools, enhancing the capacity of education institutes and providers to help them explore, select and utilize e-learning products that best meet the needs of their students/beneficiaries.</p></div><div class=b2b-keyfeat-grid><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-1.png alt=\"\"></div><div class=card-body><h4 class=card-heading>LMS System</h4><p class=card-detail>Non-Downloadable Video Hosting, Quizzes, Assignments, 24/7 access to instructors, Books and Notes, Live session integrations and much more.</p></div></div></div><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=1.5s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-2.png alt=\"\"></div><div class=card-body><h4 class=card-heading>Assessment</h4><p class=card-detail><!-- Pop-up and standard quizzes to assess the students learning. --> Pop-up and standard quizzes to assess student learning.</p></div></div></div><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=2s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-3.svg alt=\"\"></div><div class=card-body><h4 class=card-heading>Cross Platform</h4><p class=card-detail><!-- Our Services are available on all the platforms 24/7. --> Services are available on all platforms 24/7.</p></div></div></div><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-4.png alt=\"\"></div><div class=card-body><h4 class=card-heading>Offline Video Storage</h4><p class=card-detail><!-- In our Pursue to be the Netflix of Ed-Tec Industry, we are proud to\n                                be the first one in the region to have secured video serving without internet.  --> In our pursuit to be the Netflix of the Ed-Tech industry, we are proudly the first Ed-Tech in the region to have secure video streaming without internet.</p></div></div></div><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=1.5s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-5.svg alt=\"\"></div><div class=card-body><h4 class=card-heading>Detailed Analytics</h4><p class=card-detail><!-- We believe in giving the control of ones learning back to the student\n                                and their respective teachers therefore both user and course analytics are available to\n                                serve that purpose. --> Our detailed user and course analytics give control of student learning back to the students and their respective teachers.</p></div></div></div><div class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=2s><div class=card><div class=card-img><img src=../../images/b2b/key-feat-6.svg alt=\"\"></div><div class=card-body><h4 class=card-heading>Product Management</h4><p class=card-detail><!-- Proper Admin and Instructor panel to manage everything in few clicks. --> Detailed Admin and Instructor Panels help manage everything in a few clicks.</p></div></div></div></div></div></section><!-- Learngin partner section --><section class=\"b2b-section b2b-learning-parner\"><div class=\"b2b-learning-parner-inner wow fadeInUp\" data-wow-duration=3s><h2>We’re here to make your life easy and make your students fall in love with learning <img class=quote-after src=../../images/b2b/blockquote.png alt=\"\"></h2><p><!-- With 6 years of successful operational history and offering 200+courses, Nearpeer deeply values the\n                importance of connecting with organizations directly. we are always looking to widen our professional\n                and social networks. We are proud to offer our data-driven, custom tech-oriented solutions for\n                businesses, catering to each organizations needs individually. --> With over 6 years of successful operational history and a portfolio of 250+courses, Nearpeer profoundly values the importance of connecting with organizations directly. As a community-oriented Ed-Tech startup, we are always looking to widen our professional and social networks. We are proud to offer our data-driven, custom tech-oriented solutions for businesses, catering to each organization\'s needs individually.</p><a class=b2b-btn ng-click=takeToForm()>Get started</a></div></section><!-- Testimonial section --><section class=b2b-testimonial><div class=\"container testimonial-inner\"><div class=\"section-title wow fadeInUp\" data-wow-duration=1s><h2>Hear from the clients</h2></div><div class=\"b2b_testimonial_slider wow fadeInUp\" data-wow-duration=1s><div class=splide__arrows><button class=\"splide__arrow splide__arrow--next\"><img src=../../images/b2b/prev.svg alt=#></button> <button class=\"splide__arrow splide__arrow--prev\"><img src=../../images/b2b/next.svg alt=#></button></div><div class=splide__track><ul class=splide__list><li class=splide__slide data-splide-interval=5500><div class=\"b2b-user-testimonial fade-in-bottom-custom\"><p><span>Hosting our courses at Nearpeer not only helped us scale to thousands of students but it has given detailed insights about our students learning behavior, which helps us in offering better courses.</span><!-- <img src=\"../../images/b2b/blockquote.png\" alt=\"#\"> --></p></div><div class=b2b-user-testimonial-name><span>Atif Abidi</span> (CEO CA-NOTES)</div></li><li class=splide__slide data-splide-interval=5500><div class=\"b2b-user-testimonial fade-in-bottom-custom\"><p><span>We love that Nearpeer’s platform allowed us to provide a breadth of high-quality programs and a splendid learning experience for our students and teachers. I feel it has the best curriculum. Through Nearpeer courses, students from all back grounds explore immersive, tech-oriented online learning dynamics, supported by the relevant academia i.e. teachers, books and syllabi</span><!-- <img src=\"../../images/b2b/blockquote.png\" alt=\"#\"> --></p></div><div class=b2b-user-testimonial-name><span>Tasadduq Bokhari</span> (Project-Director Akhuwat Foundation)</div></li><li class=splide__slide data-splide-interval=5500><div class=\"b2b-user-testimonial fade-in-bottom-custom\"><p><span>We choose Nearpeer business over other learning solutions because of its expert world-class Instructors, relevant course selection, and course content quality. Moreover, Nearpeer believes that everyone deserves quality education irrespective of their geographical and financial position. </span><!-- <img src=\"../../images/b2b/blockquote.png\" alt=\"#\"> --></p></div><div class=b2b-user-testimonial-name><span>Ali Raza Alvi </span>(President Ali Trust)</div></li></ul></div></div><div id=thumbnail-slider class=\"b2b_testimonial_thumbnails wow fadeInUp\" data-wow-duration=1s><div class=splide__track><ul class=splide__list><li class=splide__slide><div class=testimonial-user-bg><!-- <svg viewBox=\"0 0 1 107\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                            <path class=\"\" d=\"M0.499996 98C0.499996 102.971 4.55727 107.077 9.45767 106.245C13.3991 105.575 17.2625 104.465 20.9736 102.928C27.4645 100.239 33.3623 96.2981 38.3302 91.3302C43.2981 86.3623 47.2389 80.4645 49.9276 73.9736C52.6162 67.4826 54 60.5257 54 53.5C54 46.4743 52.6162 39.5174 49.9276 33.0264C47.2389 26.5355 43.2981 20.6377 38.3302 15.6698C33.3623 10.7019 27.4645 6.76107 20.9736 4.07244C17.2625 2.53528 13.3991 1.42462 9.45767 0.755236C4.55728 -0.0770041 0.499996 4.02944 0.499996 9L0.5 53.5L0.499996 98Z\" />\n                                        </svg> --> <svg width=167 height=167 viewBox=\"0 0 167 167\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=83.5 cy=83.5 r=82 stroke-width=3 style=\"stroke: #d9e2e8\"></circle><circle cx=83.5 cy=83.5 r=82 stroke-width=3 stroke-linecap=round style=\"stroke: #1e2432\"></circle></svg> <img src=\"../../images/Syed Atif Hassan Abidi.jpg\"></div></li><li class=splide__slide><div class=testimonial-user-bg><!-- <svg viewBox=\"0 0 1 107\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                        <path class=\"\" d=\"M0.499996 98C0.499996 102.971 4.55727 107.077 9.45767 106.245C13.3991 105.575 17.2625 104.465 20.9736 102.928C27.4645 100.239 33.3623 96.2981 38.3302 91.3302C43.2981 86.3623 47.2389 80.4645 49.9276 73.9736C52.6162 67.4826 54 60.5257 54 53.5C54 46.4743 52.6162 39.5174 49.9276 33.0264C47.2389 26.5355 43.2981 20.6377 38.3302 15.6698C33.3623 10.7019 27.4645 6.76107 20.9736 4.07244C17.2625 2.53528 13.3991 1.42462 9.45767 0.755236C4.55728 -0.0770041 0.499996 4.02944 0.499996 9L0.5 53.5L0.499996 98Z\" />\n                                    </svg> --> <svg width=167 height=167 viewBox=\"0 0 167 167\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=83.5 cy=83.5 r=82 stroke-width=3 style=\"stroke: #d9e2e8\"></circle><circle cx=83.5 cy=83.5 r=82 stroke-width=3 stroke-linecap=round style=\"stroke: #1e2432\"></circle></svg> <img src=../../images/b2b/tasadduq-bokhari.png></div></li><li class=splide__slide><div class=testimonial-user-bg><!-- <svg viewBox=\"0 0 1 107\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                        <path class=\"\" d=\"M0.499996 98C0.499996 102.971 4.55727 107.077 9.45767 106.245C13.3991 105.575 17.2625 104.465 20.9736 102.928C27.4645 100.239 33.3623 96.2981 38.3302 91.3302C43.2981 86.3623 47.2389 80.4645 49.9276 73.9736C52.6162 67.4826 54 60.5257 54 53.5C54 46.4743 52.6162 39.5174 49.9276 33.0264C47.2389 26.5355 43.2981 20.6377 38.3302 15.6698C33.3623 10.7019 27.4645 6.76107 20.9736 4.07244C17.2625 2.53528 13.3991 1.42462 9.45767 0.755236C4.55728 -0.0770041 0.499996 4.02944 0.499996 9L0.5 53.5L0.499996 98Z\" />\n                                    </svg> --> <svg width=167 height=167 viewBox=\"0 0 167 167\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=83.5 cy=83.5 r=82 stroke-width=3 style=\"stroke: #d9e2e8\"></circle><circle cx=83.5 cy=83.5 r=82 stroke-width=3 stroke-linecap=round style=\"stroke: #1e2432\"></circle></svg> <img src=../../images/b2b/ali-raza-alvi.png></div></li></ul></div></div></div></section><!-- FAQ section --><section class=\"b2b-section b2b-faq\"><div class=container><div class=row><div class=col-lg-6><div class=\"section-title wow fadeInUp\" data-wow-duration=1s><h2>Have any questions ?</h2><p><!-- Everything you need to know about the product and the pricing. Can’t find answers what you\n                            are looking for. Please drop us a “Hi” at <a href=\"mailto:contact@nearpeer.org\">\n                                contact@nearpeer.org.</a> --> Can’t find what you’re looking for. Reach out to us at <a href=mailto:contact@nearpeer.org>contact@nearpeer.org.</a> and someone from our team will get in touch.</p></div></div><div class=col-lg-6><ul id=accordion class=\"b2b-faq-accordian wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse1 onclick=event.preventDefault()><span>Who purchases Nearpeer’s LMS solution?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse1 class=\"panel-collapse collapse\"><div class=b2b-faqs>All learning organizations using or planning to use free and/or paid Ed-tech tools can benefit from our comprehensive solutions, including provincial districts, private educational organizations, education service agencies and government education agencies. Ed-tech providers can also benefit from our solutions. Nearpeer’s LMS is configurable to meet the unique needs of a single school, organization-wide needs of entire district or institution of higher education, or overarching specifications of a member network or whole state.</div></div></li><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse2 onclick=event.preventDefault()><span>Can I only get Course Production Consultancy Services from Nearpeer?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse2 class=\"panel-collapse collapse\"><div class=b2b-faqs>Yes. Nearpeer offers custom services based on their specific requirements of their prospective business clients.</div></div></li><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse3 onclick=event.preventDefault()><span>Can I only Host and Sell my courses through Nearpeer?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse3 class=\"panel-collapse collapse\"><div class=b2b-faqs>Nearpeer does take pride in itself on its cutting-edge Learning Management System (LMS) but we do offer custom solutions and custom hosting services based on the specific requirements of our prospective business clients.</div></div></li><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse4 onclick=event.preventDefault()><span>Can I trust my data with Nearpeer and know that all compliance requirements and privacy regulations are being followed?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse4 class=\"panel-collapse collapse\"><div class=b2b-faqs>Yes! With Nearpeer, you can communicate which Edtech tools are safe and approved for use; promote informed Edtech decisions at every level with a centralized repository of information from trusted privacy partners. We take data integrity and student data privacy seriously. Nearpeer is aligned to all compliance requirements, and the team regularly audits practices and systems to ensure safe use.</div></div></li><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse5 onclick=event.preventDefault()><span>Can I break my bill into monthly or quarterly installments?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse5 class=\"panel-collapse collapse\"><div class=b2b-faqs>Yes. We at Nearpear can accommodate payment flexibility based on the financial bandwidth of our prospective business clients.</div></div></li><li class=panel><a data-toggle=collapse data-parent=#accordion href=#collapse6 onclick=event.preventDefault()><span>Does Nearpeer’s LMS integrate with other systems?</span> <img src=../../images/b2b/accordian-icon.png alt=\"\"></a><div id=collapse6 class=\"panel-collapse collapse\"><div class=b2b-faqs>Nearpeer’s platform simply and easily integrates with SIS and other school systems. Nearpeer’s customer support and implementation teams can quickly collaborate with the customer’s designated point of contact to coordinate the appropriate level of connectivity.</div></div></li></ul></div></div></div></section><!-- Contact us section --><section id=b2b_contact_us class=\"b2b-section b2b-contact-us\"><div class=container><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6\"><div class=\"section-title wow fadeInUp\" data-wow-duration=1s><h2>Get your demo now.</h2><p><!-- ee why the leading organizations choose NEARPEER businesss as their destination for the\n                            online education. --> Witness first hand why leading organizations choose NEARPEER business as their destination for online education</p></div><div class=\"demo-learn wow fadeInUp\" data-wow-duration=1s><h3>In your demo learn more about:</h3><ul><li>Unlimited access to 250+ best courses selected and offered by Nearpeer.org.</li><li><!-- 24/7 access to student and teacher centric counseling. --> 24/7 access to student and teacher centric counseling</li><li><!-- Nearpeer provides Content Production Services that includes: End to End content\n                                Production, Setting up content production for companies, Guidelines and Teacher Training\n                                for online education. --> Nearpeer provides Content Production Services that include: End to End content Production, Setting up content production for companies, Guidelines and Teacher Training for online education.</li><li><!-- Providing cutting-edge hosting and deployment of our white labeling services catered to\n                                the educational and financial requirements of each prospective business partner. --> Providing cutting-edge hosting and deployment of our white labeling services catered to educational and financial requirements of each prospective business partner.</li></ul></div></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><form name=b2bForm method=post class=\"wow fadeInUp\" data-wow-duration=1s data-wow-delay=1s ng-show=visile><div class=form-field><input type=text name=b2bEmail ng-model=b2bUserEmail placeholder=\"Workplace Email*\"> <span class=error-msg ng-show=error.b2bUserEmail>{{error.b2bUserEmail}}</span><!-- <div ng-if=\"b2bForm.$submitted || b2bForm.b2bEmail.$dirty\" ng-messages=\"b2bForm.b2bEmail.$error\" style=\"color:red\" role=\"alert\">\n                                <div ng-message=\"required\">Please enter a value for this field.</div>\n                                <div ng-message=\"email\">This field must be a valid email address.</div>\n                            </div> --></div><div class=form-field><input type=text name=b2bname ng-model=b2bUserName placeholder=Name* maxlength=100> <span class=error-msg ng-show=error.b2bUserName>{{error.b2bUserName}}</span><!-- <div ng-if=\"b2bForm.$submitted || b2bForm.b2bname.$dirty\" ng-messages=\"b2bForm.b2bname.$error\" style=\"color:red\" role=\"alert\">\n                                <div ng-message=\"required\">Please enter a value for this field.</div>\n                            </div> --></div><div class=form-field style=\"position: relative\"><input type=text id=b2bCountry class=country-code-dropdown> <input type=tel name=b2bPhone ng-model=b2bUserPhone placeholder=\"Phone Number*\"> <span class=error-msg ng-show=error.b2bUserPhone>{{error.b2bUserPhone}}</span><!-- <div ng-if=\"b2bForm.$submitted || b2bForm.b2bPhone.$dirty\" ng-messages=\"b2bForm.b2bPhone.$error\" style=\"color:red\" role=\"alert\">\n                                <div ng-message=\"required\">Please enter a value for this field.</div>\n                                <div ng-message=\"number\">This field must be a valid number address.</div>\n                            </div> --></div><div class=form-field><input type=text name=b2bCompanyName ng-model=b2bUserCompany placeholder=\"Company Name*\" maxlength=100> <span class=error-msg ng-show=error.b2bUserCompany>{{error.b2bUserCompany}}</span><!-- <div ng-if=\"b2bForm.$submitted || b2bForm.b2bCompanyName.$dirty\" ng-messages=\"b2bForm.b2bCompanyName.$error\" style=\"color:red\" role=\"alert\">\n                                <div ng-message=\"required\">Please enter a value for this field.</div>\n                                <div ng-message=\"number\">This field must be a valid number address.</div>\n                            </div>  --></div><div class=form-field><textarea name=b2bTrainingNeeds id=b2bTrainingNeeds ng-model=b2bUserMessage cols=30 rows=10 placeholder=\"What are your training needs?*\"></textarea><span class=error-msg ng-show=error.b2bUserMessage>{{error.b2bUserMessage}}</span><!-- <div ng-if=\"b2bForm.$submitted || b2bForm.b2bTrainingNeeds.$dirty\" ng-messages=\"b2bForm.b2bTrainingNeeds.$error\" style=\"color:red\" role=\"alert\">\n                                <div ng-message=\"required\">Please enter a value for this field.</div>\n                                <div ng-message=\"number\">This field must be a valid number address.</div>\n                            </div>  --></div><button id=submitBtn ng-click=submitb2bForm() class=\"b2b-btn b2b-btn-filled\">Get in touch</button></form></div></div></div></section></div>");
$templateCache.put("app/backuplogin/latestLogin.html","<div class=new-popup ng-click=closeForm()></div><div class=\"popup-form loginForm\"><span class=\"close fa fa-times\" ng-click=closeForm()></span><!-- <div class=\"close-popup-icon\" ng-click=\"closeForm()\">\n      <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n  </div> --><div ng-cloak><md-tabs md-dynamic-height><md-tab label=\"Log in\"><md-content flex layout-padding><div class=form-container><form><ul class=form-list><li><md-input-container class=md-block><label>Email or Phone</label><input ng-model=loginForm.email></md-input-container></li><li><md-input-container class=md-block><label>Password</label><input ng-model=loginForm.password type=password></md-input-container></li></ul></form><div class=buttonset><md-button class=\"md-raised md-warn\" ng-click=submitLogin(loginForm) ng-disabled=loginButtonIsDisabled ng-class=\"{unactive: loginButtonIsDisabled}\">Log In</md-button><!-- <div>\n              <a class=\"forgot\" >Remember Me</a>\n              <input \n              type=\"checkbox\" \n              id=\"remember_me\" \n              ng-model=\"loginForm.remember_me\" \n              @change=\"rememberMe(loginForm.remember_me)\"\n            > \n          </div> --><div style=\"display: flex;\n          justify-content: space-between\"><span class=forgot style=\"display: flex;\njustify-content: flex-start;\nalign-items: center;width: 125px\">Remember Me <input style=\"margin-left: 5px;margin-top: 0px !important\" ng-model=loginForm.remember_me ng-checked=loginForm.remember_me ng-change=rememberMe(loginForm.remember_me,loginForm); type=checkbox> </span><a class=forgot style=\"text-align: right !important\" ng-click=forgotPassword()>Forgot Password?</a></div><md-button class=\"md-raised md-warn guest\" ng-click=enterAsGuest() ng-if=!guestMode>Connect <span class=hidden-xs>as a</span> Guest</md-button><md-button class=\"md-raised md-warn facebook\" ng-click=authenticateFacebook()>Connect <span class=hidden-xs>with</span> Facebook</md-button><md-button class=\"md-raised md-warn apple\" ng-click=authenticateApple()>Connect <span class=hidden-xs>with</span> Apple</md-button><md-button class=\"md-raised md-warn google\" id=glogin>Connect <span class=hidden-xs>with</span> Google</md-button></div></div><!-- //.form-container --></md-content></md-tab><md-tab label=or ng-disabled=\"\'true\'\"><md-content flex layout-padding></md-content></md-tab><md-tab label=\"Sign up\"><md-content flex layout-padding><div class=form-container><form><ul class=form-list><li><md-input-container class=md-block><label>Full Name</label><input ng-model=registrationForm.full_name></md-input-container></li><li><md-input-container class=md-block><label>Email</label><input ng-model=registrationForm.email></md-input-container></li><li><md-input-container class=md-block><label>Phone</label><input ng-model=registrationForm.phone></md-input-container></li><li><md-input-container class=md-block><label>Password</label><input type=password ng-model=registrationForm.password></md-input-container></li><li><md-input-container class=md-block><label>Confirm Password</label><input type=password ng-model=registrationForm.confirmPassword></md-input-container></li><li><md-input-container class=md-block><label>Date of Birth</label><input type=date class=body-2 id=date name=date value=dob ng-model=registrationForm.dob max={{currentDate}}></md-input-container></li></ul></form><div class=buttonset><md-button class=md-raised ng-click=submitRegistration(registrationForm) ng-disabled=\"disableRegBtn || signupButtonIsDisabled\" ng-class=\"{unactive: signupButtonIsDisabled}\" ng-if=!guestMode>Create Account</md-button><md-button class=md-raised ng-click=postSignup(registrationForm) ng-disabled=\"disableRegBtn || signupButtonIsDisabled\" ng-class=\"{unactive: signupButtonIsDisabled}\" ng-if=guestMode>Create Account</md-button></div><div class=static-info><p>By creating an account, I accept Nearpeer\'s<br><a href=#>Terms of Service</a> and <a href=#>Privacy Policy.</a></p></div></div><!-- //.form-container --></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/blog/OlderBlogs.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=feature-blogs><div ng-model=featureBlog value={{$index}}><a ui-sref=\"BlogDetail({id: featureBlog.blogUrl})\"><div class=feature-blogs-bg-img><img src={{featureBlog.image}}><div class=feature-blogs-info-cont><div class=feature-blogs-info><div class=container><label>{{featureBlog.name}}</label><label>{{featureBlog.user.name}}</label></div></div></div></div></a></div></div><div class=\"stories blog previous-blogs\"><div class=sat-cont><div class=\"stories-top select-date\"><h1>All Blogs</h1><div layout-gt-xs=row><div flex-gt-xs>Select Date:<md-datepicker ng-model=date ng-change=blogCards(1,date) md-placeholder=\"Enter date\"></md-datepicker></div></div><!--    <a href=\"#\">more stories</a> --></div><div class=stories-midle><ul><li ng-repeat=\"blog in allblog\"><a ui-sref=\"BlogDetail({id: blog.blogUrl})\"><div class=stories-midle-img-box><img ng-src={{blog.image}} alt=\"\"></div><div class=stories-midle-info-box><h2>{{blog.name}}</h2><h3>{{blog.description}}</h3></div><div class=stories-midle-info-bottom><h2>{{blog.user.name}}</h2><p>{{blog.date | date : \"d MMM yy\"}}</p><div class=img-box-sat><img ng-src={{blog.user.userImg}} alt=\"\"></div></div></a></li></ul></div></div></div><nav aria-label=... ng-hide=\"\"><ul class=\"pager pager-quiz-new\"><li class=previous><a class=button-red href=\"\" ng-click=blogCards(page-1,date)><span aria-hidden=true>Previous</span></a></li><li class=next><a class=button-red href=\"\" ng-click=blogCards(page+1,date)><span aria-hidden=true>Next</span></a></li></ul></nav><div class=space-extra></div></div>");
$templateCache.put("app/blog/blog.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=feature-blogs><div ng-model=blogfeature value={{$index}}><a ui-sref=\"BlogDetail({category: category, id: blogfeature.blogUrl})\"><div class=feature-blogs-bg-img><img ng-src={{blogfeature.image}}><div class=feature-blogs-info-cont><div class=feature-blogs-info><div class=container><label>{{blogfeature.name}}</label><br><label>by {{blogfeature.user.name}}</label></div></div></div></div></a></div></div><div class=\"stories blog blog-page\"><div class=sat-cont><div class=stories-top><h1>Most Popular Blogs</h1></div><div class=stories-midle><ul><li ng-repeat=\"tblog in blogtop\" value={{$index}}><a ui-sref=\"BlogDetail({category: category, id: tblog.blogUrl})\"><div class=stories-midle-img-box><img ng-src={{tblog.image}} alt=\"\"></div><div class=stories-midle-info-box><h2>{{tblog.name}}</h2><h5>{{tblog.description}}</h5></div><div class=stories-midle-info-bottom><h2><span>{{tblog.user.name}}</span></h2><p>{{tblog.date | date : \"d MMM yy\"}}</p><div class=img-box-sat><img ng-src={{tblog.user.userImg}} alt=\"\"></div></div></a></li></ul></div></div></div><div class=get-notified><div class=get-notified-cont><h2>Get Notified</h2><p>Get daily updates about our latest blogs</p><input type=email ng-model=subscribeEmail placeholder=\"Enter Your Email Here\" class=\"ng-pristine ng-untouched ng-valid ng-empty ng-valid-email round-border\" aria-invalid=false> <button class=\"btn btn-primary\" ng-click=EmailSubscribe(subscribeEmail)>Subscribe</button></div></div><div class=\"stories blog previous-blogs\"><div class=sat-cont><div class=stories-top><h1>Previous Blogs</h1><!--    <a href=\"#\">more stories</a> --></div><div class=stories-midle><ul><li ng-repeat=\"blog in blogs\" value={{$index}}><a ui-sref=\"BlogDetail({category: category, id:blog.blogUrl})\"><div class=stories-midle-img-box><img ng-src={{blog.image}} alt=\"\"></div><div class=stories-midle-info-box><h2>{{blog.name}}</h2><h3>{{blog.description}}</h3></div><div class=stories-midle-info-bottom><h2>{{blog.user.name}}</h2><p>{{blog.date | date : \"d MMM yy\"}}</p><div class=img-box-sat><img ng-src={{blog.user.userImg}} alt=\"\"></div></div></a></li></ul><div class=button-blogs><a class=button-red ng-click=loadMore()>View More</a></div></div></div></div></div>");
$templateCache.put("app/blog/blogCategories.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=filterLoading ng-if=isFilterLoading><img src=images/squares.gif></div><div ng-show=showData class=layout><div><div ng-class=\"{\'search-blogs-padding\': !isFilterLoading}\" class=search-blogs id=search-blogs style=\"border-bottom: 1px solid #eee\"><div class=blog-page-title><h4 class=blogs-heading-text>Nearpeer Blogs</h4><p class=blogs-subheading-text>Our thoughts, Views and Everything Else</p></div><div class=\"blog-tab-responsive-search row blog-tab-responsive-search-mobile\"><div class=\"input-group blog-search\"><input id=tags type=text ng-model=searchInput placeholder=\"Search any blog here...\"><div><i class=\"blogs-search-icon-icon glyphicon glyphicon-search\"></i></div></div></div><!-- <div class=\"col-xs-12 col-sm-12 col-md-6 col-md-offset-3\" >\n      <div class=\"input-group-btn\">\n        <button class=\"more-filters-button\" ng-click=\"moreFilter()\" >\n          <img src=\"../../images/blogs-search-filter.svg\">\n          <span>More Filters</span>\n        </button>\n      </div>\n    </div>\n    <div ng-class=\"{\'height-adjust-blog\': showFilters}\" class=\"height-adjust-0-blog pt-2 col-xs-12 col-sm-12 col-md-6 col-md-offset-3\">\n        <div >\n          <div class=\"blog-search-filter-space-style blogs-date-filter form-group col-md-3 col-sm-3 col-xs-6\" id=\"filterFDate\">\n            <label for=\"example-date-input\" class=\"col-2\">From</label>\n            <div class=\"col-12\" style=\"position: relative;\">\n              <input ng-model=\"fromDate\" style=\"height: 40px;border:none !important;position: absolute;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\" class=\"more-filters-background form-control form-control-sm\"  ng-click=\"startDateSelection(1)\" type=\"date\" id=\"example-date-input\">\n              <div ng-show=\"!startDateSelect\" class=\"blogs-date-text-pop-up\" style=\"overflow:hidden;color: #C4C4C4;position: absolute;z-index: 9;background: #fff;padding: 12px;height: 40px;\">\n                <div style=\"font-size: 14px;height: 24px;overflow: hidden;\">{{fromDate1}}</div></div>\n            </div>\n          </div>\n          <div class=\"blog-search-filter-space-style blogs-date-filter form-group col-md-3 col-sm-3 col-xs-6\" id=\"filterTDate\">\n            <label for=\"example-date-input\" class=\"col-2\">To</label>\n            <div class=\"col-12\" style=\"position: relative;\">\n              <input ng-model=\"toDate\" style=\"height: 40px;border:none !important;position: absolute;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\" class=\"more-filters-background form-control form-control-sm\" ng-click=\"startDateSelection(0)\" type=\"date\" id=\"example-date-input\">\n              <div ng-show=\"!endDateSelect\" class=\"blogs-date-text-pop-up\" style=\"overflow:hidden;color: #C4C4C4;position: absolute;z-index: 9;background: #fff;padding: 12px;height: 40px;\">\n                <div style=\"font-size: 14px;height: 24px;overflow: hidden;\">{{toDate1}}</div></div>\n            </div>\n          </div>\n          <div class=\"blog-search-filter-space-style form-group col-md-3 col-sm-3 col-xs-12\" id=\"filterADate\">\n            <label for=\"example-date-input\" class=\"col-2\">Author</label>\n              <ul class=\"more-filters-background form-group col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown\" style=\"padding:0px;\">\n                <li class=\"dropdown col-md-12 col-sm-12 col-xs-12\" style=\"display: flex; align-items: center;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\">\n                    <a href=\"#\" data-toggle=\"dropdown\" class=\"author-field dropdown-toggle\" style=\"display:inline-flex;color: #C4C4C4; width: 100%;opacity: 0.85;\">\n                      <i class=\"fa fa-user\" aria-hidden=\"true\" style=\"margin-top: auto;\n                      margin-bottom: auto;\"></i>\n                      <div style=\"width:90%;overflow: hidden;height: 18px;\">&nbsp;{{showText}}</div>\n                      <b class=\"caret dropdownIcon\"></b>\n                    </a>\n                    <ul class=\"dropdown-menu width-auto col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown-list\" style=\"overflow-x: hidden;min-width: 152px !important;\">\n                        <li ng-repeat=\"author in authors\">\n                            <div class=\"checkbox\">\n                                <label>\n                                    <input  ng-model=\"author.selected\"type=\"checkbox\">{{author.name ? author.name : author.full_name}}\n                                </label>\n                            </div>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n          </div>\n          <div class=\"blog-search-filter-space-style blog-caregory-search-button-top-spacing form-group col-md-3 col-sm-3 col-xs-12\"  style=\"display: flex\" id=\"filterReset\">\n            <div class=\"clear-button-fix col-2\" style=\"margin-right: 30px;\">\n              <a ng-click=\"searchBlogs()\" class=\"blog-search-web-view mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 11px 20px;\" type=\"submit\" id=\"example-reset-input\"> \n                 <i class=\" glyphicon glyphicon-search\" style=\"\"></i>\n                </a>\n                <a ng-click=\"searchBlogs()\" class=\"blog-search-mbl-view mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 6px 20px;\" type=\"submit\" id=\"example-reset-input\"> \n                  <div class=\"\">Search</div>\n                 </a>\n            </div>\n            <div class=\"clear-button-fix col-2\" >\n              <a class=\"mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 6px 20px;\" ng-click=\"resetFilter()\" type=\"submit\" id=\"example-reset-input\">Clear</a>\n            </div>\n          </div>\n        </div>\n    </div> --><div class=\"blogs-categories-responsive-flow row col-xs-12 col-sm-12 col-md-8 col-md-offset-2\" style=\"padding-top: 20px\"><div value={{$index}} class=\"col-md-2 col-sm-2 col-xs-6 categories-button\" style=\"padding: 0px\"><a type=button ng-class=\"{\'blogs-btn-active\': selectedCategory === 0}\" style=\"padding: 0px;width: 100%\" class=\"btn btn-default blogs-category-buttons\" ng-click=selectCategory(0)>Most Popular</a><div ng-show=\"selectedCategory === 0\" style=\"height: 2px;border-radius: 12px;border: 2px solid #16B9D6;background: #16B9D6;width: 100%;\" class=tab-btns-responsive></div></div><div ng-repeat=\"category in categories\" value={{$index}} class=\"col-md-2 col-sm-2 col-xs-6 categories-button\" style=\"padding: 0px\"><a type=button ng-class=\"{\'blogs-btn-active\': selectedCategory === category.id}\" style=\"padding: 0px;width: 100%\" class=\"btn btn-default blogs-category-buttons\" ng-click=selectCategory(category.id)>{{category.name}}</a><div ng-show=\"selectedCategory === category.id\" style=\"height: 2px;border-radius: 12px;border: 2px solid #16B9D6;background: #16B9D6;width: 100%;\"></div></div></div></div></div><div ng-show=showData><div class=\"blog-tab-responsive-body-block blog-tab-responsive-search row col-xs-12 col-sm-12 col-md-10 col-md-offset-1\" ng-if=\"selectedCategory === 0\"><div><div class=blog-main-wrapper><div class=stories-top><h1>Most Popular Blogs</h1></div><div class=\"top-div-blog display-direction row\" style=\"width: 100% !important;justify-content: center\"><div class=\"blogs-main-block-box-shadow blog-main-block blogs-block-spacing inner-div-blog web-width-fix tab-responsive-height-fix col-md-7\" style=\"padding: 0px\"><ul style=\"list-style: none\"><li ng-repeat=\"tblog in blogtop\" ui-sref=\"BlogDetail({category: tblog.category_id.index_url, id: tblog.blogUrl})\" value={{$index}} class=\"blogs-main-block-box-shadow-responsive blogs-block-spacing popular-blog-category\" ng-if=\"$index==0\"><div class=\"blog-large-img-responsive stories-main-img-box col-md-12 col-sm-4 col-xs-4\"><img class=\"blog-large-img-responsive blog-large-img popular-blog-img\" ng-src={{tblog.image}} alt=\"\"><!-- <div class=\"bottom-left-main\" style=\"width: 125px;text-align: center;\">{{tblog.category_id.name}}</div> --><!-- <div class=\"top-right\">Most Popular</div> --></div><div class=\"blog-categories-content-spacing col-md-12 col-sm-8 col-xs-8\"><div class=blog-header-new><div class=blog-cat-pill>{{tblog.category_id.name}}</div><p class=blog-cat-time>{{tblog.read_time}} min read</p></div><!-- <div class=\"display-blog-date popular-blog-date-style\" >\n                    <p style=\"margin: 0px;\">{{tblog.date | date : \"d MMM yy\"}}</p>\n                  </div> --><div class=\"popular-blog-detail blogcategory-tab-top-space\" style=\"padding-left: 0px;height: auto\"><h4 class=\"blog-mbl-header-size stories-blog-title-style\">{{tblog.name}}</h4></div><div class=\"hide-blog-date popular-blog-date-style\"><p style=\"margin: 0px\">{{tblog.date | date : \"d MMM yy\"}}</p></div><div class=\"blog-responsive-blog-description popular-blog-detail-para\" style=\"padding-left: 0px;line-break: anywhere\">{{tblog.description | limitTo:numLimit| to_trusted}} <a ng-if=\"tblog.description.length > numLimit\" href=#>See more...</a></div><div class=blog-author-new><p class=blog-author-name><span>Written By</span> {{tblog.user.name}}</p><div class=blog-author-date>{{tblog.date | date : \"d MMM yy\"}}</div></div><!-- <div class=\"blogs-profile-top-spacing blogs-profile-top-spacing-major blog-profile-row popular-blog-detail row\">\n               <div class=\"blog-author-img-main\">\n                  <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"tblog.user.userImg\" ng-src={{tblog.user.userImg}} alt=\"\" />\n                  <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"!tblog.user.userImg\" src=\"../../images/profile-user.png\" alt=\"\" /> \n                </div>\n               <div class=\"popular-blog-author-detail\" style=\"margin: auto 0px;\">\n                 <h5 style=\"overflow: hidden;height: 17px;margin: auto 0px;\"><span>Written By</span>{{tblog.user.name}}</h5>\n                 <p style=\"padding-top: 2px;\">{{tblog.read_time}} min read</p>\n               </div>\n               <div class=\"read-more-button-responsive\" style=\"margin: auto 0px auto 20px;\">\n                   <a class=\"blog-btn-primary btn btn-primary blog-style-button\" style=\"color: #fff;\" type=\"submit\" id=\"example-reset-input\">Read More</a>\n               </div>\n             </div> --></div><br><br></li></ul></div><div class=\"inner-div-blog mobile-padding-fix col-md-5 col-xs-12 blog-main-side\"><ul class=\"tab-display popular-blog-detail-direction\" style=\"list-style: none;width: 100%\"><li ng-repeat=\"tblog in blogtop | limitTo: listCount\" ui-sref=\"BlogDetail({category: tblog.category_id.index_url, id: tblog.blogUrl})\" value={{$index}} class=\"blogs-block-spacing tab-responsive-height-fix col-xs-6 col-sm-12 popular-blog-category\" ng-if=\"$index!==0\" style=\"margin-bottom: 20px !important\"><div class=\"row blogs-box-shadow-styling\"><div class=\"blogs-side-bar-spacing col-md-5 col-sm-4 col-xs-4\"><div class=\"blog-stories-side-img-box stories-side-img-box\"><img class=\"popular-blog-img-small popular-blog-img\" ng-src={{tblog.image}} alt=\"\"><!-- <div class=\"bottom-left\" style=\"width: 125px;text-align: center;\">{{tblog.category_id.name}}</div>  --></div></div><div class=\"blogs-side-bar-responsive col-md-7 col-sm-8 col-xs-8\"><div class=blog-header-new><div class=blog-cat-pill>{{tblog.category_id.name}}</div><p class=blog-cat-time>{{tblog.read_time}} min read</p></div><div class=popular-blog-detail style=\"padding: 0px;margin: 0px auto 10px 0px\"><h4 class=\"blog-mbl-header-size blogcategory-side-bar-title\">{{tblog.name}}</h4></div><!-- <div class=\"popular-blog-date-style\" style=\"padding-left: 0px;\">\n            <p>{{tblog.date | date : \"d MMM yy\"}}</p>\n          </div> --><div class=\"blog-responsive-blog-description popular-blog-detail-para-small\" style=\"padding-left: 0px;word-break: break-all\" ng-if=screen>{{tblog.description}}</div><div class=blog-author-new><p class=\"blog-author-name author-ellipse\"><span>Written By</span> {{tblog.user.name}}</p><div class=blog-author-date>{{tblog.date | date : \"d MMM yy\"}}</div></div><!-- <br> --><!-- <div class=\"blogs-profile-responsive blogs-profile-top-spacing popular-blog-detail row\">\n            <div class=\"small-blog-div\">\n              <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"tblog.user.userImg\" ng-src={{tblog.user.userImg}} alt=\"\" />\n              <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"!tblog.user.userImg\" src=\"../../images/profile-user.png\" alt=\"\" /> </div>\n            <div class=\"popular-blog-author-detail\" style=\"margin: auto 0px;\">\n              <h5 class=\"blogs-profile-username\">{{tblog.user.name}}</h5>\n              <p style=\"padding-top: 2px;\">{{tblog.read_time}} min read</p>\n            </div>\n            <div class=\"blog-side-bar-button blog-profile-alignment\">\n                <a class=\"blog-btn-primary btn btn-primary blog-style-button\" style=\"color: #fff;\" type=\"submit\" id=\"example-reset-input\">{{view}}</a>\n            </div>\n          </div> --></div></div></li></ul></div></div></div></div></div><div class=\"blog-tab-responsive-body-block blog-tab-responsive-search row col-xs-12 col-sm-12 col-md-10 col-md-offset-1\"><div class=blog-main-wrapper><div ng-repeat=\"category in blogCategories\" id={{category.id}} value={{$last}} style=\"padding: 23px 0px\" ng-if=\"selectedCategory === category.id || selectedCategory === 0\"><div class=stories-top><h1>{{category.name}} Blogs</h1></div><div class=\"top-div-blog display-direction row\" style=\"width: 100% !important;justify-content: center\"><div class=\"blogs-main-block-box-shadow blog-main-block blogs-block-spacing web-width-fix inner-div-blog tab-responsive-height-fix col-md-7\" style=\"padding: 0px\"><ul style=\"list-style: none\"><li ng-repeat=\"tblog in category.blogs | limitTo: category.limit ? 1 : 1\" ui-sref=\"BlogDetail({category: tblog.category_id.index_url, id: tblog.blogUrl})\" value={{$index}} class=\"blogs-main-block-box-shadow-responsive blogs-block-spacing popular-blog-category\" ng-if=\"$index==0\"><div class=\"blog-large-img-responsive stories-main-img-box col-md-12 col-xs-12\"><img class=\"blog-large-img-responsive blog-large-img popular-blog-img\" ng-src={{tblog.image}} alt=\"\"><!-- <div class=\"bottom-left-main\" style=\"width: 125px;text-align: center;\">{{tblog.category_id.name}}</div> --><!-- <div class=\"top-right\">Most Popular</div> --></div><div class=\"blog-categories-content-spacing col-md-12 col-sm-12 col-xs-12\"><div class=blog-header-new><div class=blog-cat-pill>{{tblog.category_id.name}}</div><p class=blog-cat-time>{{tblog.read_time}} min read</p></div><!-- <div class=\"display-blog-date popular-blog-date-style\" >\n                    <p style=\"margin: 0px;\">{{tblog.date | date : \"d MMM yy\"}}</p>\n                  </div> --><div class=\"popular-blog-detail blogcategory-tab-top-space\" style=\"padding-left: 0px;height: auto\"><h4 class=\"blog-mbl-header-size stories-blog-title-style\">{{tblog.name}}</h4></div><div class=\"hide-blog-date popular-blog-date-style\"><p style=\"margin: 0px\">{{tblog.date | date : \"d MMM yy\"}}</p></div><div class=\"blog-responsive-blog-description popular-blog-detail-para\" style=\"padding-left: 0px;line-break: anywhere\"><!-- {{tblog.description}} <a href=\"#\"> See more...</a> --> {{tblog.description | limitTo:numLimit| to_trusted}} <a ng-if=\"tblog.description.length > numLimit\" href=#>See more...</a></div><div class=blog-author-new><p class=blog-author-name><span>Written By</span> {{tblog.user.name}}</p><div class=blog-author-date>{{tblog.date | date : \"d MMM yy\"}}</div></div><!-- <div class=\"blogs-profile-top-spacing blogs-profile-top-spacing-major blog-profile-row popular-blog-detail row\">\n               <div class=\"blog-author-img-main\">\n                  <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"tblog.user.userImg\" ng-src={{tblog.user.userImg}} alt=\"\" />\n                  <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"!tblog.user.userImg\" src=\"../../images/profile-user.png\" alt=\"\" /> \n                </div>\n               <div class=\"popular-blog-author-detail\" style=\"margin: auto 0px;\">\n                 <h5 style=\"overflow: hidden;height: 17px;margin: auto 0px;\"><span>Written By</span>{{tblog.user.name}}</h5>\n                 <p style=\"padding-top: 2px;\">{{tblog.read_time}} min read</p>\n               </div>\n               <div class=\"read-more-button-responsive\" style=\"margin: auto 0px auto 20px;\">\n                   <a class=\"blog-btn-primary btn btn-primary blog-style-button\" style=\"color: #fff;\" type=\"submit\" id=\"example-reset-input\">Read More</a>\n               </div>\n             </div> --></div><br><br></li></ul></div><div class=\"inner-div-blog mobile-padding-fix col-md-5 col-xs-12 blog-main-side\"><ul class=\"tab-display popular-blog-detail-direction\" style=\"list-style: none;width: 100%\"><li ng-repeat=\"tblog in category.blogs | limitTo: category.limit ? category.limit : listCount\" ui-sref=\"BlogDetail({category: tblog.category_id.index_url, id: tblog.blogUrl})\" style=\"margin-bottom: 20px !important\" value={{$index}} class=\"blogs-block-spacing tab-responsive-height-fix col-xs-6 col-sm-12 popular-blog-category\" ng-show=\"$index!==0\"><div class=\"row blogs-box-shadow-styling\"><div class=\"blogs-side-bar-spacing col-md-5 col-xs-12\"><div class=\"blog-stories-side-img-box stories-side-img-box\"><img class=\"popular-blog-img-small popular-blog-img\" ng-src={{tblog.image}} alt=\"\"><!-- <div class=\"bottom-left\" style=\"width: 125px;text-align: center;\">{{tblog.category_id.name}}</div>  --></div></div><div class=\"blogs-side-bar-responsive col-md-7 col-xs-12\"><div class=blog-header-new><div class=blog-cat-pill>{{tblog.category_id.name}}</div><p class=blog-cat-time>{{tblog.read_time}} min read</p></div><div class=popular-blog-detail style=\"padding: 0px;margin: 0px auto 10px 0px\"><h4 class=\"blog-mbl-header-size blogcategory-side-bar-title\">{{tblog.name}}</h4></div><!-- <div class=\"popular-blog-date-style\" style=\"padding-left: 0px;\">\n            <p>{{tblog.date | date : \"d MMM yy\"}}</p>\n          </div> --><div class=\"blog-responsive-blog-description popular-blog-detail-para-small\" style=\"padding-left: 0px;word-break: break-all\" ng-if=screen>{{tblog.description}}</div><div class=blog-author-new><p class=\"blog-author-name author-ellipse\"><span>Written By</span> {{tblog.user.name}}</p><div class=blog-author-date>{{tblog.date | date : \"d MMM yy\"}}</div></div><!-- <br> --><!-- <div class=\"blogs-profile-responsive blogs-profile-top-spacing popular-blog-detail row\">\n            <div class=\"small-blog-div\">\n              <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"tblog.user.userImg\" ng-src={{tblog.user.userImg}} alt=\"\" />\n              <img class=\"profile-img-blog\" style=\"min-width: 40px;\" ng-if=\"!tblog.user.userImg\" src=\"../../images/profile-user.png\" alt=\"\" /> </div>\n            <div class=\"popular-blog-author-detail\" style=\"margin: auto 0px;\">\n              <h5 class=\"blogs-profile-username\">{{tblog.user.name}}</h5>\n              <p style=\"padding-top: 2px;\">{{tblog.read_time}} min read</p>\n            </div>\n            <div class=\"blog-side-bar-button blog-profile-alignment\">\n                <a class=\"blog-btn-primary btn btn-primary blog-style-button\" style=\"color: #fff;\" type=\"submit\" id=\"example-reset-input\">{{view}}</a>\n            </div>\n          </div> --></div></div></li></ul></div></div><div class=view-more><a type=button ng-if=\" category.blogs.length > 4 \" class=\"btn category-button-view\" ng-click=viewMore(category.name)>View More</a></div><hr ng-if=!$last style=\"margin-bottom: 0px !important;margin-top: 60px\"></div></div></div><div class=\"get-notified tab-responsive-footer\"><hr style=\"margin-bottom: 0px !important;margin-top: 60px\"><div class=blog-main-wrapper><div class=\"subscribe-display row get-notified-cont\"><div class=row><div class=col-md-6><img src=../../images/blog-subscribe.svg alt=\"\"></div><div class=col-md-6><div class=tab-row-display><div><h2 class=tab-responsive-centered>Subscribe For New Blogs</h2><p class=tab-responsive-centered>Enter your email to get notification of our new Blogs</p></div><div class=blog-subscribe><input type=email id=email-subscription-blog ng-model=subscribeEmail placeholder=\"Enter Your Email Here...\" class=\"ng-pristine ng-untouched ng-valid ng-empty ng-valid-email round-border\" aria-invalid=false> <button class=\"tab-responsive-button-fix blog-btn-primary btn btn-primary\" style=color:white ng-click=EmailSubscribe(subscribeEmail)>SUBSCRIBE</button></div></div><p class=tab-responsive-centered>By entering your email, address you can recive our new blogs whenever we upload to our website.</p></div></div></div></div></div></div></div>");
$templateCache.put("app/blog/blogListing.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div><div ng-class=\"{\'search-blogs-padding\': !isFilterLoading}\" class=\"search-blogs search-blogs-listing\" id=search-blogs><div class=blog-page-title><h4 class=blogs-heading-text>Nearpeer Blogs</h4><p class=blogs-subheading-text>Our thoughts, Views and Everything Else</p></div><div class=\"blog-tab-responsive-search row\"><div class=\"input-group blog-search\"><input id=tags type=text ng-model=searchInput placeholder=\"Search any blog here...\"><div><i class=\"blogs-search-icon-icon glyphicon glyphicon-search\"></i></div></div></div><!-- <div class=\"col-xs-12 col-sm-12 col-md-6 col-md-offset-3\" >\n        <div class=\"input-group-btn\">\n          <button class=\"more-filters-button\" ng-click=\"moreFilter()\" style=\"margin-bottom: 20px;\">\n            <img src=\"../../images/blogs-search-filter.svg\">\n            <span>More Filters</span>\n          </button>\n        </div>\n      </div>\n      <div ng-class=\"{\'height-adjust-blog\': showFilters}\" class=\"height-adjust-0-blog pt-2 col-xs-12 col-sm-12 col-md-6 col-md-offset-3\">\n          <div >\n            <div class=\"blog-search-filter-space-style blogs-date-filter form-group col-md-3 col-sm-3 col-xs-6\" id=\"filterFDate\">\n              <label for=\"example-date-input\" class=\"col-2\">From</label>\n              <div class=\"col-12\" style=\"position: relative;\">\n                <input ng-model=\"fromDate\" style=\"height: 40px;border:none !important;position: absolute;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\" class=\"more-filters-background form-control form-control-sm\"  ng-click=\"startDateSelection(1)\" type=\"date\" id=\"example-date-input\">\n                <div ng-show=\"!startDateSelect\" class=\"blogs-date-text-pop-up\" style=\"overflow:hidden;color: #C4C4C4;position: absolute;z-index: 9;background: #fff;padding: 12px;height: 40px;\">\n                  <div style=\"font-size: 14px;height: 24px;overflow: hidden;\">{{fromDate2}}</div></div>\n              </div>\n            </div>\n            <div class=\"blog-search-filter-space-style blogs-date-filter form-group col-md-3 col-sm-3 col-xs-6\" id=\"filterTDate\">\n              <label for=\"example-date-input\" class=\"col-2\">To</label>\n              <div class=\"col-12\" style=\"position: relative;\">\n                <input ng-model=\"toDate\" style=\"height: 40px;border:none !important;position: absolute;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\" class=\"more-filters-background form-control form-control-sm\" ng-click=\"startDateSelection(0)\" type=\"date\" id=\"example-date-input\">\n                <div ng-show=\"!endDateSelect\" class=\"blogs-date-text-pop-up\" style=\"overflow:hidden;color: #C4C4C4;position: absolute;z-index: 9;background: #fff;padding: 12px;height: 40px;\">\n                  <div style=\"font-size: 14px;height: 24px;overflow: hidden;\">{{toDate2}}</div></div>\n              </div>\n            </div>\n            <div class=\"blog-search-filter-space-style form-group col-md-3 col-sm-3 col-xs-12\" id=\"filterADate\">\n              <label for=\"example-date-input\" class=\"col-2\">Author</label>\n                <ul class=\"more-filters-background form-group col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown\" style=\"padding:0px;\">\n                  <li class=\"dropdown col-md-12 col-sm-12 col-xs-12\" style=\"display: flex; align-items: center;box-shadow: 0px 4px 20px rgb(0 0 0 / 6%) !important;\">\n                      <a href=\"#\" data-toggle=\"dropdown\" class=\"author-field dropdown-toggle\" style=\"display:inline-flex;color: #C4C4C4; width: 100%;opacity: 0.85;\">\n                        <i class=\"fa fa-user\" aria-hidden=\"true\" style=\"margin-top: auto;\n                        margin-bottom: auto;\"></i>\n                        <div style=\"width:90%;overflow: hidden;height: 18px;\">&nbsp;{{showText}}</div>\n                        <b class=\"caret dropdownIcon\"></b>\n                      </a>\n                      <ul class=\"dropdown-menu width-auto col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown-list\" style=\"overflow-x: hidden;min-width: 152px !important;\">\n                          <li ng-repeat=\"author in authors\">\n                              <div class=\"checkbox\">\n                                  <label>\n                                      <input  ng-model=\"author.selected\"type=\"checkbox\">{{author.name ? author.name : author.full_name}}\n                                  </label>\n                              </div>\n                          </li>\n                      </ul>\n                  </li>\n              </ul>\n            </div>\n            <div class=\"blog-search-filter-space-style blog-caregory-search-button-top-spacing form-group col-md-3 col-sm-3 col-xs-12\"  style=\"display: flex\" id=\"filterReset\">\n              <div class=\"clear-button-fix col-2\" style=\"margin-right: 30px;\">\n                <a ng-click=\"searchBlogs()\" class=\"blog-search-web-view mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 11px 20px;\" type=\"submit\" id=\"example-reset-input\"> \n                   <i class=\" glyphicon glyphicon-search\" style=\"\"></i>\n                  </a>\n                  <a ng-click=\"searchBlogs()\" class=\"blog-search-mbl-view mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 6px 20px;\" type=\"submit\" id=\"example-reset-input\"> \n                    <div class=\"\">Search</div>\n                   </a>\n              </div>\n              <div class=\"clear-button-fix col-2\" >\n                <a class=\"mobile-responsive-fix blog-btn-primary btn btn-primary\" style=\"line-height:26px;height:40px;color: #fff;padding: 6px 20px;\" ng-click=\"resetFilter()\" type=\"submit\" id=\"example-reset-input\">Clear</a>\n              </div>\n            </div>\n          </div>\n      </div> --></div></div><div class=\"tab-responsive-blog row col-xs-10 col-sm-10 col-md-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1\"><div infinite-scroll=loadMore() infinite-scroll-distance=1><div ng-repeat=\"category in blogCategories\" id={{category.id}} ng-if=\"selectedCategory === category.id || selectedCategory === 0\"><div ng-if=\"category.name === url\"><div class=stories-top style=margin-top:50px><h1 class=blog-listing-header>{{category.name}} Blogs</h1></div><div class=blog-listing-wrapper><ul class=row><li ng-repeat=\"blog in category.blogs\" value={{$index}} class=\"blogs-block-spacing tab-responsive-card col-sm-6 col-md-4\"><div class=blog-listing-box-shadow ui-sref=\"BlogDetail({category: blog.category_id.index_url, id: blog.blogUrl})\"><div class=\"blog-category-div-box blog-category-img-box\"><img ng-src={{blog.image}} style=height:100%;width:100% alt=\"\"><!-- <div class=\"bottom-left-listing\">{{category.name}}</div> --></div><div style=\"padding: 0px 15px;padding-bottom: 15px\"><div class=\"blog-header-new blog-header-new-listing\"><div class=blog-cat-pill>{{category.name}}</div><p class=blog-cat-time>{{blog.read_time}} min read</p></div><!-- <div class=\"popular-blog-author-detail\" style=\"padding: 10px 0px;margin-bottom: 0px;\">\n                <p style=\"padding: 0px;margin-bottom: 0px;\">{{blog.date | date : \"d MMM yy\"}}</p>\n              </div> --><div class=\"blog-listing-blog-title stories-midle-info-box\"><h3 class=blog-listing-blog-title-h3>{{blog.name}}</h3></div><div class=\"blog-responsive-blog-description popular-blog-detail-para listing\" style=\"padding-left: 0px;line-break: anywhere\"><!-- {{blog.description}} --> {{blog.description | limitTo:numLimit| to_trusted}} <a ng-if=\"blog.description.length > numLimit\" class=readMore-btn>Read More</a></div><div class=blog-author-new><p class=\"blog-author-name author-ellipse\"><span>Written By</span> {{blog.user.name}}</p><div class=blog-author-date>{{blog.date | date : \"d MMM yy\"}}</div></div><!-- <div class=\"blogs-profile-top-spacing popular-blog-detail\" style=\"display: inline-flex;width: 100%;padding: 0px;\">\n                <div class=\"blog-listing-profile-img\">\n                   <img class=\"tab-responsive-card-img\"  ng-src={{blog.user.userImg}} alt=\"\" /> </div>\n                <div class=\"popular-blog-author-detail\" style=\"margin-top:3px;\">\n                  <h5 style=\"overflow: hidden;height: 17px;margin: auto 0px;\">{{blog.user.name}}</h5>\n                  <p style=\"padding-top: 2px;\">{{blog.read_time}} min read</p>\n                </div>\n                <div style=\"float:right;margin: auto 0px auto auto;\">\n                    <a class=\"blog-btn-primary blog-listing-button btn btn-primary\" type=\"submit\" id=\"example-reset-input\">Read More</a>\n                </div>\n              </div> --></div></div></li></ul></div></div></div></div><div ng-if=\"!loading && blogCategories.length == 0\" style=\"margin-top: 70px\"><p style=\"text-align: center;color: gray;padding-bottom: 20px\">Oops there is no Blog in select category</p></div><div ng-if=loading style=\"text-align: center; margin-top: 50px\"><img style=\"height: 80px\" src=images/squares.gif></div></div><div class=\"tab-responsive-blog tab-responsive-footer row col-xs-10 col-sm-10 col-md-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1\"><div class=\"get-notified tab-responsive-footer\"><div class=\"subscribe-display row get-notified-cont get-notified-cont-listing\"><div class=row><div class=col-md-6><img src=../../images/blog-subscribe.svg alt=\"\"></div><div class=col-md-6><div class=tab-row-display><div><h2 class=tab-responsive-centered>Subscribe For New Blogs</h2><p class=tab-responsive-centered>Enter your email to get notification of our new Blogs</p></div><div class=blog-subscribe><input type=email id=email-subscription-blog ng-model=subscribeEmail placeholder=\"Enter Your Email Here...\" class=\"ng-pristine ng-untouched ng-valid ng-empty ng-valid-email round-border\" aria-invalid=false> <button class=\"tab-responsive-button-fix blog-btn-primary btn btn-primary\" style=color:white ng-click=EmailSubscribe(subscribeEmail)>SUBSCRIBE</button></div></div><p class=tab-responsive-centered>By entering your email, address you can recive our new blogs whenever we upload to our website.</p></div></div></div></div></div></div>");
$templateCache.put("app/blog/blogSearch.html","<div class=layout><div class=\"filter-blogs row\"><div class=\"col-xs-8 col-md-4 col-md-offset-4 col-xs-offset-2\"><div class=input-group><input id=tags type=text ng-model=searchInput class=\"form-control searchInput\" placeholder=\"Search Any Blog e.g MDCAT, CA\"><div class=input-group-btn><button ng-click=searchBlogs() class=\"btn btn-primary searchButton\"><i class=\"glyphicon glyphicon-search\" style=\"font-size: 20px; color: #fff\"></i></button></div></div></div></div><div class=\"filter-blogs row\"><div class=\"form-group col-md-2 col-sm-3 col-xs-8\" ng-show=isMobile><div class=col-12><a class=category-button ng-click=closeFilter()><i class=\"glyphicon glyphicon-menu-hamburger\" style=\"font-size: 25px\"></i></a></div></div><div class=categories style=\"width: 100%\"><div class=\"form-group col-md-2 col-sm-3 col-xs-8\" id=filterFDate><label for=example-date-input class=col-2>From Date</label><div class=col-12><input id=autocomplete ng-model=fromDate class=\"form-control form-control-sm filter-input\" style=\"border-radius: 40px !important\" ng-blur=searchBlogs() type=date id=example-date-input></div></div><div class=\"form-group col-md-2 col-sm-3 col-xs-8\" id=filterTDate><label for=example-date-input class=col-2>To Date</label><div class=col-2><input ng-model=toDate class=\"form-control form-control-sm filter-input\" style=\"border-radius: 40px !important\" ng-blur=searchBlogs() type=date id=example-date-input></div></div><div class=\"form-group col-md-2 col-sm-3 col-xs-8\" id=filterADate><label for=example-date-input class=col-2>Author</label><ul class=\"form-group col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown filter-input\"><li class=\"dropdown col-md-12 col-sm-12 col-xs-12\" style=\"display: flex; align-items: center\"><a href=# data-toggle=dropdown class=dropdown-toggle style=\"color: #000; width: 100%\">Select<b class=\"caret dropdownIcon\"></b></a><ul class=\"dropdown-menu width-auto col-md-12 col-sm-12 col-xs-12 blog-filter-dropdown-list\"><li ng-repeat=\"author in authors\"><div class=checkbox><label><input ng-change=searchBlogs() ng-model=author.selected type=checkbox>{{author.name ? author.name : author.full_name}}</label></div></li></ul></li></ul></div><div class=\"form-group col-md-1 col-sm-3 col-xs-8\" id=filterReset><div class=col-2 style=\"text-align: center; margin-top: 29px\"><a class=\"btn btn-primary filter-input\" ng-click=resetFilter() type=submit id=example-reset-input>Clear</a></div></div></div></div><div class=loaderBlog ng-hide=showData><img src=images/squares.gif></div><div class=\"stories blog blog-page\" ng-show=showData><div><div ng-repeat=\"category in blogCategories\" style=width:100% class=sat-cont ng-if=\"category.blogs.length > 0\"><div class=stories-top><h1>{{category.name}} Blogs</h1></div><ul class=row><li ng-repeat=\"blog in category.blogs | limitTo: category.limit ? category.limit : 9\" value={{$index}} class=\"col-sm-6 col-md-4 blog-category\"><a ui-sref=\"BlogDetail({category: category.name, id: blog.blogUrl})\"><div class=blog-category-img-box><img ng-src={{blog.image}} style=\"border-radius: 15px\" alt=\"\"></div><div class=stories-midle-info-box><h3>{{blog.name}}</h3><h5>{{blog.description}}</h5></div></a></li></ul><div class=filterLoading ng-if=category.loading><img src=images/squares.gif></div><div class=view-more><a type=button ng-if=\"category.blogs.length > 8\" class=\"btn btn-success category-button\" ng-click=viewMore(category)>{{category.limit === 20 ? \'View Less\' : \'View More\'}}</a></div></div></div></div><div class=get-notified><div class=get-notified-cont><h2>Get Notified</h2><p>Get daily updates about our latest blogs</p><input type=email ng-model=subscribeEmail placeholder=\"Enter Your Email Here\" class=\"ng-pristine ng-untouched ng-valid ng-empty ng-valid-email round-border\" aria-invalid=false> <button class=\"btn btn-primary\" ng-click=EmailSubscribe(subscribeEmail)>Subscribe</button></div></div></div>");
$templateCache.put("app/blog/blogdetail.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div style=\"position: relative\" ng-show=showData><div class=single-blog><div class=blog-header><div class=blog-progress-container><div class=blog-progress-bar id=myBar></div></div></div><div id=blog style=\"background: #ffffff\" class=\"tab-responsive-detail-block tab-responsive-detail row col-xs-12 col-sm-12 col-md-10 col-lg-10 col-md-offset-1 col-lg-offset-1\"><div class=social-icon-bar style=margin-top:0px><div id=social-fix class=\"social-icon-fix icon-bar\"><a ng-click=shareOnFacebook() class=facebook><i class=\"fa fa-facebook\"></i></a> <a ng-click=shareWhatsApp() class=whatsapp><i class=\"fa fa-whatsapp\"></i></a></div></div><div class=col-md-12><div class=feature-blogs-info><h1 class=blog-detail-heading>{{blog.name}}</h1></div></div><div style=margin-top:0px class=\"tab-responsive-detail col-lg-8 col-md-8 col-sm-12 col-xs-12\"><div class=feature-blogs style=\"height: auto !important;padding-left: 15px;padding-right: 15px\"><!-- <div class=\" feature-blogs-info\">\n              <h1 class=\"blog-detail-heading\"> {{blog.name}} </h1>\n          </div> --><div ng-model=blogfeature value={{$index}} class=blog-detail-banner-img><div class=\"feature-blogs-bg-img height-100\"><img ng-src={{blog.image}} alt={{blog.banner_alt}}><!-- <div class=\"bottom-left-listing\" style=\"width: 125px;text-align: center;\">{{blog.category_id.name}}</div> --><!-- <div class=\"top-right\">Most Popular</div> --></div></div><div class=popular-blog-author-detail style=\"padding-left: 0px\"><div class=blog-author-new><!-- <p class=\"blog-author-name\"><span>Written By</span> {{blog.user.name}}</p> --><p>{{blog.date | date : \"d MMM yy\"}}</p></div></div></div><div class=\"blog-content-styling cont-details-blog cont-details-blog-trusted\"><div style=\"width: 100%;padding:0px\" class=\"sat-cont sat-cont-details\"><div style=\"width: 100%;overflow-x: hidden\" id=blog-content></div></div></div></div><div id=content-fix class=\"tab-responsive-centered-blogs col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div><div class=tab-responsive-hide-buttons-blogs><!-- <div class=\"blog-detail-search\">\n          <div class=\"input-group blog-search\">\n              <input id=\"tags\" type=\"text\" class=\"\" placeholder=\"Type something\"/>\n              <div>\n                <i class=\"blogs-search-icon-icon glyphicon glyphicon-search\"></i>\n              </div>\n          </div>\n        </div> --><div class=blog-detail-sidebox><h3 style=\"padding-bottom: 10px;font-size: 25px;font-weight: 700;margin-top: 0px !important\">Other Popular Blogs</h3><ul style=\"list-style: none;display: inline-grid;width: 100%\"><li ng-repeat=\"tblog in blogtop\" value={{$index}} class=popular-blog-category ui-sref=\"BlogDetail({category: tblog.category_id.index_url, id: tblog.blogUrl})\" style=\"margin-bottom: 20px;cursor: pointer\"><div class=row style=\"margin-right: 0px\"><div class=col-md-4><div class=stories-side-img-box><img class=\"inner-box-other-blogs popular-blog-img\" ng-src={{tblog.image}} alt=\"\"><!-- <div class=\"bottom-left\" style=\"width: 125px;text-align: center;\">{{tblog.category_id.name}}</div>  --></div></div><div class=col-md-8><div style=\"padding: 15px 0px\"><div class=popular-blog-detail style=\"padding: 0px\"><h4 style=\"-webkit-box-orient: vertical !important;margin-top:0px;height: 38px\">{{tblog.name}}</h4></div><div class=blog-author-new><p class=\"blog-author-name author-ellipse\"><span>Written By</span> {{tblog.user.name}}</p></div></div><!-- <div class=\"popular-blog-author-detail\" style=\"padding-left: 0px;margin: 0px auto;\">\n                <p>{{tblog.date | date : \"d MMM yy\"}}</p>\n              </div> --><!-- <br> --><!-- <div class=\"popular-blog-detail row\" style=\"margin-right:0px;padding: 0px 10px;\">\n                <div class=\"blog-listing-profile-img col-md-3 col-sm-3 col-xs-6\">\n                   <img class=\"small-blog-div-img\" ng-if=\"tblog.user.userImg\" ng-src={{tblog.user.userImg}} alt=\"\" />\n                   <img class=\"small-blog-div-img\" ng-if=\"!tblog.user.userImg\" src=\"../../images/profile-user.png\" alt=\"\" /> </div>\n                <div class=\"col-md-5 col-xs-3 popular-blog-author-detail\" style=\"padding: 0px;width: 90px;margin: auto 0px;\">\n                  <h5 style=\"overflow: hidden;\n                  height: 17px;margin: auto 0px;\n                  margin-top: 3px;\">{{tblog.user.name}}</h5>\n                  <p style=\"padding-top: 2px;\">{{tblog.read_time}} min read</p>\n                </div>\n                <div class=\"col-md-4\" style=\"float:right;padding: 0px;text-align: end;\">\n                    <a class=\"blog-btn-primary blog-listing-button btn btn-primary\" style=\"width: auto;\" type=\"submit\" id=\"example-reset-input\">Read</a>\n                </div>\n              </div> --></div></div><!-- <br> --></li></ul><div><h3 class=blog-detail-responsive-socials style=\"font-weight: 700\">\"Enjoyed this article?\"</h3><ul style=\"display: inline-flex\"><li style=\"padding: 10px\" class=social-icons-mobile-responsive><a ng-click=shareOnTwitter()><img style=\"width: 100%;height:100%\" src=images/icon_Twitter.png></a></li><li style=\"padding: 10px\" class=social-icons-mobile-responsive><a ng-click=shareOnFacebook()><img style=\"width: 100%;height:100%\" src=images/blogs-icon-fb.svg></a></li><li style=\"padding: 10px\" class=social-icons-mobile-responsive><a ng-click=shareOnlinkedin()><img style=\"width: 100%;height:100%\" src=images/blog-icon-linkedin.svg></a></li><li style=\"padding: 10px\" class=social-icons-mobile-responsive><a ng-click=shareGmail()><img style=\"width: 100%;height:100%\" src=images/blog-icon-email.svg></a></li></ul></div></div><div class=blog-offerd-course><h3>Offered Courses</h3><ul><li><a href=/mdcat-test-preparation>MDCAT</a></li><li><a href=/css-test-preparation>CSS</a></li><li><a href=https://cambridge.nearpeer.org/ >O/A Level</a></li><li><a href=https://fsc.nearpeer.org/ >FSC</a></li><li><a href=/chartered-accountancy-final>CA</a></li><li><a href=/acca/acca-online>ACCA</a></li><li><a href=/lums>University Courses</a></li><li><a href=/entry-test>University Entry Test</a></li></ul></div></div></div></div></div></div><div id=below-fix class=\"tab-responsive-detail-block tab-responsive-detail row col-xs-12 col-sm-12 col-md-10 col-lg-10 col-md-offset-1 col-lg-offset-1\"><div style=margin-top:0px class=\"tab-responsive-detail col-lg-7 col-md-7 col-sm-12 col-xs-12\"><div><div class=cont-details-blog style=\"padding: 0px 15px\"><div class=sat-cont-details><div class=claps-count><span>{{claps}}</span> {{claps === 1 ? \'Clap\' : \'Claps\'}}</div><button class=\"btn btn-success clap-button\" ng-click=giveClap()><img src=/images/clap.png height=20 width=20> Give a Clap To Author</button></div></div></div></div></div></div><div ng-show=showData class=\"glaxy-fold-comment container col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-md-offset-1\"><div class=cont-details-blog style=padding-bottom:30px><div class=\"sat-cont sat-cont-details\" style=width:100%><div class=comment-area-first><!-- <div style=\"padding-bottom: 7px;\" class=\"blogs-leave-reply\">Leave a Reply</div>\n                  <span>Start a discussion</span> --><div style=\"padding-top: 30px;padding-bottom: 10px\" class=blogs-leave-reply>Leave a Reply</div><div class=\"comment-area-first-text-area blog-reply-area\"><textarea ng-model=comment.text style=\"width: 100%;border: none;padding: 15px\" placeholder=\"Write a comment ..\"></textarea></div><div class=comment-section-start><div class=comment-area-first-bottom style=\"width: 100%;margin-top: 0px;padding-top: 48px\"><div class=\"glaxy-fold-clap choose-file-glaxy blog-comment-section\" style=\"margin-right: 15px\"><div><input type=file id=actual-btn style=\"display: none\" accept=image/* ng-model=comment.image_url ngf-select=\"addImage(comment.image_url, \'comment\')\"><label class=\"blogs-reply-comment-button-attach-width blog-comment-section blog-btn-primary btn btn-primary label-file\" style=\"height:40px;font-size: 16px;padding: 8px 12px\" for=actual-btn><i class=\"fa fa-paperclip\" style=font-size:20px aria-hidden=true></i>&nbsp;&nbsp;Choose file</label></div><div class=\"blogs-file-choosen-name blog-comment-section-top\" ng-show=\"imageName_comment && !imageUploadingInProcess\"><span id=file-chosen>{{imageName_comment}}</span></div></div><div ng-show=imageUploadingInProcess style=\"width: 50px\" class=blogs-comments-loader><img class=load-new src=images/img-uploader-loader.gif ng-show=imageUploadingInProcess></div></div><div><button class=\"blogs-post-comment-main post-comment-button-responsive button-red-blogs\" style=\"height: 40px;width: 200px\" ng-click=commentstore(comment)>Post Comment</button></div></div></div></div></div></div></div><div ng-show=showData class=\"glaxy-fold-comment container col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top: 30px\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-md-offset-1\" ng-if=\"allComments.length > 0\"><div class=cont-details-blog><div class=\"sat-cont sat-cont-details\" style=width:100%><div class=comment-section><div class=post-comment-divider><h3>{{allComments.length}} Comments</h3></div><div class=main-tabs-comment-inner style=\"border:none;padding-bottom: 52px\"><ul><li ng-class=\"{\'opc-hide\': comments.disabled}\" ng-repeat=\"comments in allComments | limitTo: 1\" style=\"margin: 0px\"><div class=tabs-comment-inner-list style=\"display: flex\"><div class=\"blogs-child-element-left tabs-comment-inner-img\" style=\"background: transparent !important\"><img ng-src={{comments.user.userImg}} alt=\"\"></div><div class=\"blogs-child-element-right tabs-comment-inner-list-info\"><div class=main-heading-comment-info><h1 style=color:black>{{comments.user.name}}</h1><p class=blogs-comment-date-section>{{comments.comment_time |date:\'short\'}}</p></div><div class=main-heading-comment-info-midle><h2 style=\"word-break: break-all\" ng-bind-html=comments.text></h2><img ng-show=comments.image_url ng-src={{comments.image_url}} class=blogs-comments-img></div><div class=main-heading-comment-info-bottom><div class=\"tabs-comment-inner-list comments-show-hide-button\" style=\"padding-top: 20px\"><button ng-click=hideShow(comments,comments.id) style=\"background:none !important;color: #000 !important;font-size: 14px\">Reply</button> <button ng-click=hideReplies(comments.id) ng-show=\"(comments.replies).length && comments.id != selectedCommentId\" class=blogs-show-hide-comment>View {{(comments.replies).length === 1 ? \'Reply\' : \'Replies\'}} ({{(comments.replies).length}})</button> <button ng-click=hideReplies(-1) ng-show=\"(comments.replies).length && comments.id == selectedCommentId\" class=blogs-show-hide-comment>Hide {{(comments.replies).length === 1 ? \'Reply\' : \'Replies\'}} ({{(comments.replies).length}})</button></div></div><div class=comment-bottom-one ng-show=\"comments.showReply && selectedTextArea==comments.id\"><textarea ng-model=reply.text rows=2 style=\"width: 100% !important;box-shadow: 0px 0px 25px rgba(211, 211, 211, 0.25);border: none;padding: 15px\" placeholder=\"Write a comment ..\"></textarea><div class=\"comment-area-first-bottom glaxy-fold-clap choose-file-glaxy\"><div class=\"glaxy-fold-clap choose-file-glaxy blog-comment-section\" style=\"margin-right: 15px\"><div><input type=file id=actual-btn1 style=\"display: none\" accept=image/* ng-model=reply.image_url ngf-select=\"addImage(reply.image_url, \'reply\')\"><label class=\"blogs-reply-comment-button-attach-width blog-btn-primary btn btn-primary label-file\" style=\"width:100%;height: 40px;padding: 8px 12px;color: #fff;font-size: 16px\" for=actual-btn1><i class=\"fa fa-paperclip\" style=font-size:20px aria-hidden=true></i>&nbsp;&nbsp;Choose file</label></div><div class=\"blogs-file-choosen-name blog-comment-section-top\" ng-show=\"imageName_reply && !imageUploadingInProcess\"><span id=file-chosen>{{imageName_reply}}</span></div></div><div ng-show=imageUploadingInProcess class=blogs-comments-loader><img class=load-new style=\"width:30px !important;height:30px !important\" src=images/img-uploader-loader.gif></div><button class=\"post-comment-button-responsive button-red-blogs blogs-reply-comment-button-width\" ng-click=replycomment(reply,comments.id) style=\"height: 40px\">Reply Comment</button></div></div><ul ng-if=(comments.replies).length><li ng-show=\"comments.id == selectedCommentId\" ng-class=\"{\'opc-hide\': reply.disabled}\" ng-repeat=\"reply in comments.replies \" style=\"margin-left: 0px\"><div class=tabs-comment-inner-list style=\"display: flex\"><div class=\"blogs-child-reply-element-left reply-comment-size tabs-comment-inner-img\" style=\"background: transparent !important\"><img ng-src={{reply.user.userImg}} alt=\"\"></div><div class=\"blogs-reply-element-right tabs-comment-inner-list-info\" style=\"padding-left: 10px\"><div class=main-heading-comment-info><h1 style=color:black>{{reply.user.name}}</h1><p class=blogs-comment-date-section>{{reply.comment_time|date:\'short\'}}</p></div><div class=main-heading-comment-info-midle><h2 style=\"word-break: break-all;margin-top: 9px\" ng-bind-html=reply.text></h2><img ng-show=reply.image_url ng-src={{reply.image_url}} class=blogs-comments-img></div></div></div></li></ul></div></div><div style=\"text-align: left;padding-top: 24px\" ng-if=\"allComments.length >1 && !showComments\"><button ng-click=hideShowComments() class=blogs-show-comments><b>Show All Comments ({{allComments.length-1}})</b> <i ng-show=!showComments class=\"fa fa-angle-down blogs-show-comments-icon\"></i></button></div></li><li ng-class=\"{\'opc-hide\': comments.disabled}\" ng-repeat=\"comments in allComments track by $index\" style=\"margin: 0px\" ng-if=$index><div class=tabs-comment-inner-list style=\"display: flex\" ng-show=showComments><div class=\"blogs-child-element-left tabs-comment-inner-img\" style=\"background: transparent !important\"><img ng-src={{comments.user.userImg}} alt=\"\"></div><div class=\"blogs-child-element-right tabs-comment-inner-list-info\"><div class=main-heading-comment-info><h1 style=color:black>{{comments.user.name}}</h1><p class=blogs-comment-date-section>{{comments.comment_time |date:\'short\'}}</p></div><div class=main-heading-comment-info-midle><h2 style=\"word-break: break-all\" ng-bind-html=comments.text></h2><img ng-show=comments.image_url ng-src={{comments.image_url}} class=blogs-comments-img></div><div class=main-heading-comment-info-bottom><div class=\"tabs-comment-inner-list comments-show-hide-button\" style=\"padding-top: 20px\"><button ng-click=hideShow(comments,comments.id) style=\"background:none !important;color: #000 !important;font-size: 14px\">Reply</button> <button ng-click=hideReplies(comments.id) ng-show=\"(comments.replies).length && comments.id != selectedCommentId\" class=blogs-show-hide-comment>View {{(comments.replies).length === 1 ? \'Reply\' : \'Replies\'}} ({{(comments.replies).length}})</button> <button ng-click=hideReplies(-1) ng-show=\"(comments.replies).length && comments.id == selectedCommentId\" class=blogs-show-hide-comment>Hide {{(comments.replies).length === 1 ? \'Reply\' : \'Replies\'}} ({{(comments.replies).length}})</button></div></div><div class=comment-bottom-one ng-show=\"comments.showReply && selectedTextArea==comments.id\"><textarea ng-model=reply.text rows=2 style=\"width: 100% !important;box-shadow: 0px 0px 25px rgba(211, 211, 211, 0.25);border: none;padding: 15px\" placeholder=\"Write a comment ..\"></textarea><div class=\"comment-area-first-bottom glaxy-fold-clap choose-file-glaxy\"><div class=\"glaxy-fold-clap choose-file-glaxy blog-comment-section\" style=\"margin-right: 15px\"><div><input type=file id=actual-btn1 style=\"display: none\" accept=image/* ng-model=reply.image_url ngf-select=\"addImage(reply.image_url, \'reply\')\"><label class=\"blogs-reply-comment-button-attach-width blog-btn-primary btn btn-primary label-file\" style=\"width:100%;height: 40px;padding: 8px 12px;color: #fff;font-size: 16px\" for=actual-btn1><i class=\"fa fa-paperclip\" style=font-size:20px aria-hidden=true></i>&nbsp;&nbsp;Choose file</label></div><div class=\"blogs-file-choosen-name blog-comment-section-top\" ng-show=\"imageName_reply && !imageUploadingInProcess\"><span id=file-chosen>{{imageName_reply}}</span></div></div><div ng-show=imageUploadingInProcess class=blogs-comments-loader><img class=load-new style=\"width:30px !important;height:30px !important\" src=images/img-uploader-loader.gif></div><button class=\"post-comment-button-responsive button-red-blogs blogs-reply-comment-button-width\" ng-click=replycomment(reply,comments.id) style=\"height: 40px\">Reply Comment</button></div></div><ul ng-if=(comments.replies).length ng-class=\"{\'blog-comment-reply\': comments.id == selectedCommentId}\"><li ng-show=\"comments.id == selectedCommentId\" ng-class=\"{\'opc-hide\': reply.disabled}\" ng-repeat=\"reply in comments.replies \" style=\"margin-left: 0px\"><div class=tabs-comment-inner-list style=\"display: flex\"><div class=\"blogs-child-reply-element-left reply-comment-size tabs-comment-inner-img\" style=\"background: transparent !important\"><img ng-src={{reply.user.userImg}} alt=\"\"></div><div class=\"blogs-reply-element-right tabs-comment-inner-list-info\" style=\"padding-left: 10px\"><div class=main-heading-comment-info><h1 style=color:black>{{reply.user.name}}</h1><p class=blogs-comment-date-section>{{reply.comment_time|date:\'short\'}}</p></div><div class=main-heading-comment-info-midle><h2 style=\"word-break: break-all;margin-top: 9px\" ng-bind-html=reply.text></h2><img ng-show=reply.image_url ng-src={{reply.image_url}} class=blogs-comments-img></div></div></div></li></ul></div></div></li></ul><div style=\"text-align: left;padding-top: 24px\" ng-if=\"allComments.length >1 && showComments\"><button ng-click=hideShowComments() class=blogs-show-comments><b>Hide All Comments ({{allComments.length-1}})</b> <i ng-show=showComments class=\"fa fa-angle-up blogs-show-comments-icon\"></i></button></div></div></div><!-- </li> --><!-- </ul>\n              <div>\n              </div> --></div></div></div></div><!-- Related BLOGS --><div class=\"container col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"stories blog blog-page bodrer-none\" ng-show=\"blogs.length > 0\" style=\"background-color: transparent\"><div class=set-cot_><div class=\"stories-top related-blog-header\"><h1 class=text-center>Related Blogs</h1><div class=blog-slider-arrow><button class=\"carousel_button carousel_button--left\" ng-click=prevButtonMethod() style=\"z-index: 9\"><i class=\"glyphicon glyphicon-arrow-left\"></i></button> <button class=\"carousel_button carousel_button--right\" ng-click=nextButtonMethod()><i class=\"glyphicon glyphicon-arrow-right\"></i></button></div></div><div class=customCarousel><div class=carousel_track-container><ul class=carousel_track><li ng-repeat=\"relatedBlog in blogs track by $index\" class=carousel_slide ng-class=whatClassIsIt($index)><div class=innerDiv><a style=\"height: 100%\" ui-sref=\"BlogDetail({category: relatedBlog.category_id.index_url, id: relatedBlog.blogUrl})\" class=img-responsive><div class=middle-image-box><img ng-src={{relatedBlog.image}} style=\"height: 100%; width: 100%\"></div><div class=stories-midle-info-box style=\"padding-bottom: 0px;padding-left: 10px;padding-right: 10px\"><h2 class=related-blog-title title={{relatedBlog.name}}>{{relatedBlog.name}}</h2><!-- <h5>{{relatedBlog.description}}</h5> --></div><div class=related-blog-info><p class=\"blog-author-name author-ellipse\"><span>Written By</span> {{relatedBlog.user.name}}</p><div class=blog-author-new><div class=blog-author-date>{{relatedBlog.date | date : \"d MMM yy\"}}</div><div class=blog-cat-time>{{relatedBlog.read_time}} min read</div></div></div><!-- <div class=\"stories-midle-info-bottom\">\n                    <table>\n                      <tbody>\n                        <tr>\n                          <td>\n                            <img style=\"height: 40px;width:40px; margin: 0 10px 10px 10px;border-radius: 50%;\" ng-if=\"relatedBlog.user.userImg\" ng-src={{relatedBlog.user.userImg}} alt=\"\" />\n                            <img style=\"height: 40px;width:40px; margin: 0 10px 10px 10px;border-radius: 50%;\" ng-if=\"!relatedBlog.user.userImg\" src=\"../../images/profile-user.png\" />  \n                          </td>\n                          <td>\n                            <h5 style=\"margin-bottom: auto; margin-top: 0px; font-weight: bold;\">{{relatedBlog.user.name}}</h5>\n                            <p>{{relatedBlog.date | date : \"d MMM yy\"}}</p>\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div> --></a></div></li></ul></div></div><!-- <div>\n          <ol>\n            <li class=\"bullet\" ng-repeat=\"relatedBlog in blogs track by $index\" ng-class=\"whatClassIsIt($index)\"></li>\n          </ol>\n        </div> --></div></div><!-- <div class=\"space-extra\" style=\"background-color: #fafafa\"></div> --></div><!-- Related BLOGS --><div class=poppup-cp-container style=\"display: none\" id=popup><div class=email-poppup-cp-new style=\"background-color: #20bddd;overflow-y: visible\"><div class=\"f-c d-col jusc alic\" style=\"position: relative\"><h1 style=\"text-align: center; color: white;font-family: nunito, semibold;max-width: 300px\">Download Your <span style=\"color: yellow\">Free</span> Digital Copy</h1><div class=\"f-c d-row\" style=\"margin: 10px 0\"><input type=email style=\"padding: 10px 8px; border: none; border-radius: 5px\" placeholder=\"Type your Email here\" ng-model=userEmail> <button style=\"padding: 8px; border-radius: 5px; border: none; background: yellow; color: green; margin-left: 2px\" ng-click=sendNotes()>send</button></div><label for=\"\" style=\"color: red\" ng-if=!isValid>Email is invalid</label><label for=\"\" style=\"color: white;max-width: 300px; text-align: center\">Provide us with your email address and get your free Digital Copy via Email.</label><span style=\"position: absolute;color: white; right: 0px; top: -10px\" ng-click=closePopup()>&times</span> <img class=css-chronicles src=../../images/book_magazine_min.png alt=\"\"></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/assignment/assignmentNotification.html","<div class=main-noti><div class=main-noti-card><div ng-if=isLoading style=\"justify-content: center; align-items: center; display: flex\"><img src=images/squares.gif width=100px height=100px></div><div ng-if=!isLoading><div class=main-noti-title><h3>{{assignment.pageTitle}}</h3><!-- <div class=\"back-btn\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>Go Back</div> --></div><div class=main-noti-description><p>{{assignment.pageDescription}}</p><!-- <span>#pakistanrepublic</span> --></div><div class=main-noti-img ng-if=!isUpload><img src={{assignment.page_image}} alt=\"\"></div><div class=text-center ng-if=assignment.buttons_config.download.active><button class=main-noti-cta ng-click=downloadClick(assignment.buttons_config.download)>{{assignment.buttons_config.download.text || \'Download\'}}</button></div><div class=\"text-center main-noti-cta-upload\" ng-if=assignment.buttons_config.upload.active><label class=main-noti-cta for=notiUpaload style=\"margin-bottom: 0px; cursor: pointer\">{{assignment.buttons_config.upload.text || \'Upload\'}}</label><input id=notiUpaload type=file accept=application/pdf ng-model=image ngf-select=\"uploadImage(image, \'editCourseImage\')\" hidden style=\"height: 100%; width: 236px\"></div><div class=\"text-center main-noti-cta-upload\" ng-if=assignment.buttons_config.custom.active><button class=main-noti-cta ng-click=customClick(assignment.buttons_config.custom)>{{assignment.buttons_config.custom.text || \'Help\'}}</button></div></div></div><!-- Upload scenario --><div class=\"main-noti-card mt-30\" ng-if=isUpload><div class=\"main-noti-title upload\"><h4>Your assignment status</h4><div class=back-btn><!-- <img src=\"../../images/notification/cross.svg\" alt=\"#\" /> --></div></div><div class=\"main-noti-uploading flex-view align-items-center\"><p>{{uploadStatus === \'uploading\' ? \'Uploading\' : \'Uploaded\'}}</p><div class=snippet data-title=.dot-flashing ng-if=\"uploadStatus === \'uploading\'\"><div class=stage><div class=dot-flashing></div></div></div></div><div class=\"main-noti-upload-file flex-view align-items-center justify-content-between\"><div class=\"flex-view align-items-center\"><img src=../../images/notification/pdf-icon.svg alt=\"\"><div class=upload-file-title><p>{{fileName}}<!-- <span>Your file is larger than 60MB. It may take some time.</span> --></p></div></div><div class=progress><div class=progress-bar role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: uploadProgress + \'%\'}\">{{uploadProgress}}%</div></div></div><div class=text-center><button class=main-noti-cta ng-class=\"{\'active\':uploadStatus === \'uploaded\', \'inactive\':uploadStatus !== \'uploaded\'}\" ng-click=submitAssignment()>Submit Now</button></div></div></div>");
$templateCache.put("app/assignment/assignmentResult.html","<div class=main-noti><div class=main-noti-card><div ng-if=isLoading style=\"justify-content: center; align-items: center; display: flex\"><img src=images/squares.gif width=100px height=100px></div><div ng-if=!isLoading><div class=main-noti-title><h3>{{assignmentResult.result_page_data.page_title}}</h3><!-- <div class=\"back-btn\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>Go Back</div> --></div><div class=main-noti-description><p>{{assignmentResult.result_page_data.page_description}}</p><!-- <span>#pakistanrepublic</span> --></div><div class=main-noti-description ng-if=isAssignmentResult><p><span style=font-weight:bold>Remarks:</span> {{assignmentResult.result_remarks}}</p></div><div class=main-noti-description ng-if=isAssignmentResult><p><span style=font-weight:bold>Marks:</span> {{assignmentResult.obtained_marks}}/{{assignmentResult.total_marks}}</p></div><div class=main-noti-img><img src={{assignmentResult.result_page_data.pageImgLink}} alt=\"\"></div><div class=text-center ng-click=downloadClick(assignmentResult) ng-if=isAssignmentResult><button class=main-noti-cta>Download Checked Assignment</button></div></div></div></div>");
$templateCache.put("app/blogs-panel/blogsPanelSignIn.html","<div class=admin-cont-new><h1>WELCOME TO NEARPEER BLOGS PANEL</h1><div class=admin-form><div></div><div class=popup-form><md-tabs md-dynamic-height><md-tab label=\"Sign in\"><md-content flex layout-padding><div class=form-container><form><ul class=form-list><li><md-input-container class=md-block><label>Email</label><input type=email name=email ng-model=loginForm.email required></md-input-container></li><li><md-input-container class=md-block><label>Password</label><input type=password name=password ng-model=loginForm.password required></md-input-container></li></ul></form><div style=\"text-align: left\"><!-- <input style=\"vertical-align: text-top;\" type=\"checkbox\" name=\"checkbox\">\n                  Remember Me --></div><div class=buttonset><md-button class=md-raised><md-button class=md-raised ng-click=submitLogin(loginForm)>LOGIN</md-button></md-button></div></div><!-- //.form-container --></md-content></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/completeProfile/completeProfile.html","<div><div class=profile_popup ng-click=closeCityDropdown();closeUniDropdown();closeUniDropdown();event.stopPropagation();><div class=custom_popup_header><div class=\"flex-view align-items-center\" ng-click=backTab();$event.stopPropagation();><div ng-if=backBtn class=\"flex-view align-items-center\"><img src=../../images/back-icon.svg alt=\"\"><span class=btnbBacText>back</span></div></div><div class=popupLogo><img src=../../images/email-logo.svg alt=\"NearPeer Logo\"></div><div ng-click=closeCompProfile();$event.stopPropagation();><img style=\"height: 36px;\n        width: 36px\" src=../../images/cross_red_.svg alt=\"\"></div></div><div class=profile_tab_scroll><ul class=profile_tabs_list ng:class=\"{ profileCompleted : profile_completed }\" ng-if=tab_navigation><li ng:class=\"{ active : name_tab, complete : steps[0]}\"><div class=tab-image><img class=tab-icon src=../../images/name-icon.svg alt=#> <img class=tab-icon-hover src=../../images/name-icon-hover.svg alt=#></div><p class=tab-name>Name</p></li><li ng:class=\"{ active : profile_tab, complete : steps[1]}\"><div class=tab-image><img class=tab-icon src=../../images/camera-icon.png alt=#> <img class=tab-icon-hover src=../../images/camera-icon-hover.svg alt=#></div><p class=tab-name>Profile</p></li><li ng:class=\"{ active : city_tab, complete : steps[2]}\"><div class=tab-image><img class=tab-icon src=../../images/home-icon.svg alt=#> <img class=tab-icon-hover src=../../images/home-icon-hover.svg alt=#></div><p class=tab-name>City</p></li><li ng:class=\"{ active : education_tab, complete : steps[3]}\"><div class=tab-image><img class=tab-icon src=../../images/education-icon.svg alt=#> <img class=tab-icon-hover src=../../images/education-icon-hover.svg alt=#></div><p class=tab-name>Education</p></li><li ng:class=\"{ active : gender_tab, complete : steps[4]}\"><div class=tab-image><img class=tab-icon src=../../images/gender-icon.svg alt=#> <img class=tab-icon-hover src=../../images/gender-icon-hover.svg alt=#></div><p class=tab-name>Gender</p></li><li ng:class=\"{ active : birthday_tab, complete : steps[5]}\"><div class=tab-image><img class=tab-icon src=../../images/dob-icon.svg alt=#> <img class=tab-icon-hover src=../../images/dob-icon-hover.svg alt=#></div><p class=tab-name>Birthday</p></li><li style=\"display: none\" ng:class=\"{complete : steps[6]}\"></li><li ng:class=\"{ active : otp_tab || otpSent_tab || otpWrong_tab || verify_otp_tab, complete : steps[7]}\"><div class=tab-image><img class=tab-icon src=../../images/verify-icon.png alt=#> <img class=tab-icon-hover src=../../images/verify-icon-hover.svg alt=#></div><p class=tab-name>Verify</p></li></ul></div><div class=profile_popup_main ng:class=\"{ \'image-case\' : imgUploaded }\"><!-- Thank you tab --><div class=\"row discount-tab\" ng-if=thankyou_tab><div class=\"col-md-12 col-lg-6\"><!-- data-aos-delay=\"1000\" data-aos=\"fade-up-right\" data-aos=\"fade-up\" data-aos-duration=\"500\"  --> <img data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=300 src=../../images/thankyou-banner.svg alt=#></div><div class=\"col-md-12 col-lg-6\"><div class=profile_popup_content data-aos=fade-up data-aos-duration=300 data-aos-anchor-placement=top-bottom><div style=\"width: auto\"><span class=\"profile_popup_subtitle mb-24\"><b>Thank you for joining Nearpeer.</b></span><p class=profile_popup_detail>Continue to complete your profile and get amazing discounts.</p><div class=profile_button_wrapper><!-- discountTab()\" --> <a class=\"profile_popup_button active\" ng-click=nameTab();$event.stopPropagation();>Continue</a></div></div></div></div></div><div class=\"row discount-tab\" ng-if=complete_profile><div class=\"col-md-12 col-lg-6\"><img data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 src=../../images/amzing-banner.svg alt=#></div><div class=\"col-md-12 col-lg-6\"><div class=profile_popup_content data-aos=fade-up data-aos-duration=1000 data-aos-anchor-placement=top-bottom><div style=\"width: auto\"><span class=profile_popup_subtitle>Complete your profile to become eligible for</span><h1 class=profile_popup_title>Amazing Discounts</h1><span class=profile_popup_subtitle>on Nearpeer Courses.</span><div class=profile_button_wrapper><a class=\"profile_popup_button active\" ng-click=nameTab();$event.stopPropagation();>Complete Profile</a></div></div></div></div></div><!-- Name tab --><div class=row ng-if=name_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000><svg class=welcome-desktop-image width=388 height=390 viewBox=\"0 80 388 390\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0)><path d=\"M83.9443 358.781V388.337H127.16H174.825V358.781H83.9443Z\" fill=#F5F5F5 /><path d=\"M80.1309 350.521V358.782H177.998V350.521H127.159H80.1309Z\" fill=#E0E0E0 /><path d=\"M129.064 388.338H174.825V358.782H178.001V350.521H127.161V358.021L129.064 388.338Z\" fill=#E0E0E0 /><path d=\"M115.079 363.551H96.6494V367.999H115.079V363.551Z\" fill=#E0E0E0 /><path d=\"M117.94 373.561H94.2734V382.956H117.94V373.561Z\" fill=white /><path d=\"M94.373 327.821V350.521H127.572H164.182V327.821H94.373Z\" fill=#F5F5F5 /><path d=\"M91.4492 321.472V327.823H166.626V321.472H127.574H91.4492Z\" fill=#E0E0E0 /><path d=\"M129.048 350.523H164.191V327.823H166.633V321.472H127.581V327.235L129.048 350.523Z\" fill=#EBEBEB /><path d=\"M118.301 331.481H104.147V334.899H118.301V331.481Z\" fill=#E0E0E0 /><path d=\"M120.5 339.168H102.319V346.384H120.5V339.168Z\" fill=white /><g opacity=0.5><path opacity=0.2 d=\"M275.525 387.413C256.152 374.178 251.531 349.278 252.057 326.851C252.144 323.106 251.688 319.168 253.442 315.861C255.188 312.563 259.318 310.274 262.686 311.818C265.475 313.098 266.72 316.317 268.307 318.975C270.412 322.509 273.526 325.421 277.174 327.263C279.568 328.473 282.523 329.201 284.865 327.877C288.075 326.061 288.408 321.597 288.347 317.878C288.233 310.941 288.119 304.003 288.005 297.065C287.943 293.347 287.891 289.54 289.013 285.997C290.136 282.453 292.662 279.147 296.187 278.112C299.721 277.086 304.115 279.076 304.904 282.716C305.229 284.225 304.939 285.804 305.062 287.347C305.185 288.891 305.922 290.593 307.395 291.005C308.886 291.426 310.359 290.356 311.464 289.251C315.27 285.453 317.822 280.585 320.208 275.744C322.593 270.902 324.909 265.947 328.355 261.816C331.802 257.676 336.59 254.378 341.913 254.027C347.246 253.668 352.955 256.904 354.358 262.123C355.761 267.359 352.762 272.709 349.473 276.998C344.597 283.348 338.809 288.987 332.345 293.671C331.179 294.513 329.916 295.425 329.486 296.811C328.706 299.302 331.083 301.74 333.538 302.53C336.318 303.424 339.326 303.108 342.238 303.415C345.141 303.731 348.298 304.977 349.429 307.704C350.99 311.493 347.851 315.51 344.746 318.159C338.528 323.457 331.416 327.658 323.812 330.535C321.085 331.561 318.208 332.473 316.025 334.42C313.841 336.367 312.543 339.726 313.902 342.331C315.262 344.945 318.699 345.743 321.558 345.182C324.417 344.62 326.97 343.033 329.697 341.98C334.792 339.998 341.405 340.279 344.72 344.664C346.904 347.55 347.132 351.593 346.079 355.066C345.027 358.54 342.852 361.548 340.528 364.328C332.433 374.029 322.014 381.887 310.193 386.124C298.344 390.378 287.356 391.605 275.525 387.413Z\" fill=#2DC0DA /><path d=\"M281.162 373.295C284.346 361.946 288.862 349.798 294.028 337.247C295.334 334.116 296.615 331.02 297.886 327.968C299.158 324.924 300.421 321.907 301.842 319.039C304.648 313.277 307.788 307.953 310.927 302.989C314.067 298.024 317.224 293.429 320.206 289.148C323.205 284.877 326.064 280.948 328.835 277.475C334.343 270.511 339.447 265.432 343.087 262.091C344.902 260.415 346.358 259.152 347.358 258.319C347.84 257.924 348.217 257.609 348.498 257.372C348.761 257.161 348.892 257.056 348.901 257.065C348.91 257.074 348.787 257.197 348.542 257.425C348.27 257.67 347.91 258.003 347.445 258.424C346.481 259.293 345.051 260.582 343.262 262.292C339.684 265.695 334.65 270.809 329.204 277.782C326.468 281.264 323.635 285.193 320.662 289.473C317.698 293.762 314.567 298.367 311.445 303.322C308.331 308.277 305.209 313.593 302.429 319.329C301.026 322.188 299.772 325.179 298.5 328.231C297.237 331.283 295.948 334.371 294.65 337.502C289.494 350.035 284.968 362.156 281.758 373.462\" fill=#E0E0E0 /><path d=\"M302.031 319.009C301.987 319.017 301.855 318.456 301.653 317.421C301.443 316.395 301.197 314.904 300.917 313.044C300.356 309.343 299.75 304.203 299.101 298.538C298.452 292.872 297.777 287.758 297.163 284.075C296.856 282.233 296.593 280.742 296.4 279.715C296.216 278.689 296.128 278.11 296.172 278.102C296.216 278.093 296.392 278.645 296.655 279.654C296.926 280.663 297.269 282.145 297.628 283.978C298.374 287.653 299.128 292.775 299.777 298.45C300.399 304.046 300.961 309.106 301.39 312.965C301.592 314.711 301.767 316.184 301.908 317.36C302.031 318.421 302.074 319 302.031 319.009Z\" fill=#E0E0E0 /><path d=\"M349.793 309.57C349.793 309.614 349.117 309.702 347.89 309.816C346.662 309.938 344.89 310.105 342.698 310.386C338.322 310.903 332.297 311.833 325.702 313.148C319.098 314.473 313.178 315.929 308.934 317.104C306.802 317.674 305.092 318.192 303.908 318.534C302.724 318.885 302.058 319.06 302.049 319.007C302.032 318.963 302.672 318.7 303.829 318.271C304.996 317.85 306.688 317.262 308.811 316.63C313.038 315.332 318.966 313.797 325.588 312.464C332.209 311.149 338.26 310.289 342.672 309.894C344.873 309.675 346.662 309.588 347.898 309.544C349.1 309.517 349.784 309.517 349.793 309.57Z\" fill=#E0E0E0 /><path d=\"M281.745 372.406C281.727 372.414 281.613 372.213 281.411 371.827C281.183 371.362 280.911 370.792 280.578 370.108C279.859 368.608 278.877 366.415 277.693 363.679C275.325 358.223 272.299 350.575 269.063 342.103C265.827 333.621 262.872 325.956 260.627 320.456C259.522 317.781 258.618 315.58 257.943 313.948C257.654 313.238 257.417 312.65 257.224 312.177C257.066 311.764 256.996 311.545 257.013 311.536C257.031 311.528 257.145 311.729 257.347 312.115C257.575 312.58 257.847 313.15 258.18 313.834C258.899 315.334 259.881 317.527 261.065 320.263C263.433 325.719 266.459 333.367 269.695 341.848C272.922 350.33 275.878 357.986 278.131 363.486C279.236 366.161 280.14 368.362 280.815 369.994C281.104 370.704 281.341 371.292 281.534 371.765C281.692 372.178 281.762 372.397 281.745 372.406Z\" fill=#E0E0E0 /><path d=\"M345.116 351.254C345.125 351.28 344.905 351.368 344.485 351.517C343.985 351.692 343.379 351.903 342.643 352.157C340.941 352.727 338.644 353.499 335.855 354.438C330.128 356.358 322.244 359.112 313.535 362.165C304.827 365.217 296.908 367.892 291.137 369.699C288.252 370.602 285.91 371.313 284.279 371.769C283.525 371.97 282.902 372.146 282.402 372.286C281.972 372.4 281.736 372.444 281.736 372.418C281.727 372.391 281.946 372.304 282.367 372.146C282.858 371.979 283.472 371.769 284.209 371.506C285.91 370.935 288.199 370.164 290.997 369.225C296.723 367.304 304.608 364.55 313.325 361.498C322.033 358.446 329.944 355.771 335.723 353.964C338.609 353.061 340.95 352.35 342.581 351.894C343.336 351.692 343.958 351.517 344.458 351.377C344.879 351.28 345.107 351.236 345.116 351.254Z\" fill=#E0E0E0 /></g><path d=\"M18.903 198.638L25.8316 207.175C26.0981 207.495 26.4978 207.672 26.9153 207.637L37.8766 206.766C38.9248 206.686 39.6088 207.832 39.0403 208.712L33.0622 217.942C32.8401 218.288 32.7957 218.733 32.9556 219.115L37.166 229.277C37.5657 230.246 36.6863 231.259 35.6737 230.983L25.0499 228.149C24.6502 228.043 24.2149 228.14 23.904 228.407L15.5453 235.549C14.7459 236.233 13.52 235.7 13.4579 234.652L12.8716 223.672C12.8538 223.254 12.6229 222.881 12.2676 222.659L2.88734 216.92C1.99018 216.37 2.11453 215.037 3.09164 214.664L13.3513 210.711C13.7421 210.56 14.0263 210.231 14.1241 209.822L16.6912 199.126C16.9399 198.114 18.2457 197.821 18.903 198.638Z\" fill=#E0E0E0 /><path class=fade-in opacity=0.1 d=\"M200.387 174.634C224.902 174.634 244.775 154.76 244.775 130.243C244.775 105.726 224.902 85.8516 200.387 85.8516C175.873 85.8516 156 105.726 156 130.243C156 154.76 175.873 174.634 200.387 174.634Z\" fill=#2DC0DA /><path d=\"M179.909 250.767C179.909 250.767 179.444 250.925 178.608 251.204C172.806 253.166 155.54 258.876 150.314 261.005C150.314 261.005 159.556 342.75 160.644 350.347C161.732 357.944 162.002 388.332 162.002 388.332H260.317C260.317 388.332 260.056 306.411 260.335 293.699C260.707 277.259 262.743 260.996 262.743 260.996L245.57 254.282L225.496 243.7L179.909 250.767Z\" fill=#2DC0DA /><g opacity=0.3><path opacity=0.3 d=\"M201.77 268.455C193.746 298.267 185.285 327.957 176.406 357.518C175.355 361.005 174.314 364.827 175.736 368.183C177.001 371.178 180.106 373.149 183.323 373.577C186.54 374.004 189.832 373.056 192.668 371.475C199.316 367.765 203.63 360.782 205.75 353.473C207.87 346.164 208.065 338.456 208.232 330.84C208.697 310.55 209.162 290.251 209.627 269.961L201.77 268.455Z\" fill=black /></g><path d=\"M150.319 261.007C150.319 261.007 135.898 267.395 137.023 293.022C137.786 310.457 140.436 326.404 140.436 326.404L180.984 314.725L170.672 270.222L150.319 261.007Z\" fill=#2DC0DA /><path d=\"M246.485 302.256L244.318 331.835L285.08 318.631C285.08 318.631 276.34 266.419 262.496 261.007L247.573 286.513L246.485 302.256Z\" fill=#2DC0DA /><path d=\"M251.132 293.706C251.151 293.706 251.179 293.911 251.207 294.31C251.235 294.757 251.281 295.333 251.328 296.04C251.411 297.602 251.532 299.769 251.681 302.41C251.951 307.784 252.239 315.223 252.499 323.434C252.759 331.617 253.001 339.028 253.178 344.458C253.262 347.108 253.327 349.266 253.373 350.828C253.382 351.544 253.401 352.111 253.401 352.557C253.401 352.957 253.392 353.162 253.382 353.162C253.364 353.162 253.336 352.957 253.308 352.557C253.28 352.111 253.234 351.535 253.187 350.828C253.104 349.266 252.983 347.108 252.834 344.458C252.564 339.084 252.276 331.645 252.016 323.434C251.755 315.251 251.514 307.84 251.337 302.41C251.253 299.76 251.188 297.602 251.142 296.04C251.132 295.324 251.114 294.757 251.104 294.31C251.104 293.911 251.114 293.706 251.132 293.706Z\" fill=#263238 /><path d=\"M170.497 281.257C170.47 281.275 170.284 280.931 169.967 280.318C169.614 279.602 169.168 278.727 168.656 277.695C167.531 275.501 165.969 272.432 163.58 269.531C161.19 266.63 158.308 264.677 156.03 263.775C153.752 262.845 152.181 262.799 152.199 262.697C152.199 262.669 152.59 262.659 153.278 262.743C153.975 262.817 154.97 263.031 156.151 263.459C158.513 264.296 161.506 266.258 163.943 269.224C166.379 272.181 167.913 275.306 168.954 277.547C169.475 278.672 169.865 279.602 170.135 280.243C170.395 280.875 170.525 281.238 170.497 281.257Z\" fill=#263238 /><path d=\"M255.888 259.761C256.027 259.836 254.354 262.7 253.322 266.605C252.252 270.501 252.271 273.821 252.113 273.812C252.057 273.812 251.973 272.984 252.029 271.645C252.085 270.306 252.317 268.455 252.847 266.475C253.377 264.494 254.112 262.774 254.735 261.593C255.358 260.403 255.841 259.724 255.888 259.761Z\" fill=#263238 /><path d=\"M165.228 272.5C165.228 272.527 165.079 272.49 164.828 272.546C164.577 272.593 164.224 272.797 163.936 273.197C163.629 273.597 163.434 274.164 163.313 274.889C163.238 275.243 163.173 275.633 163.015 276.042C162.867 276.442 162.616 276.87 162.188 277.149C161.305 277.735 160.077 277.474 159.175 276.823C158.236 276.135 157.688 275.057 157.018 274.08C156.684 273.588 156.302 273.132 155.81 272.788C155.326 272.444 154.74 272.193 154.155 272.221C153.569 272.248 153.03 272.62 152.732 273.141C152.434 273.68 152.351 274.359 152.304 275.038C152.258 275.726 152.248 276.424 152.165 277.112C152.081 277.8 151.923 278.516 151.505 279.111C151.412 279.269 151.282 279.39 151.151 279.52C151.03 279.65 150.882 279.762 150.724 279.845C150.417 280.022 150.063 280.124 149.719 280.162C149.031 280.227 148.371 280.069 147.795 279.799C146.623 279.222 145.898 278.246 145.229 277.419C144.569 276.572 143.927 275.819 143.183 275.336C142.458 274.843 141.63 274.62 140.961 274.75C140.292 274.889 139.799 275.317 139.52 275.717C139.241 276.126 139.185 276.526 139.213 276.777C139.232 277.037 139.297 277.167 139.269 277.177C139.269 277.177 139.166 277.065 139.111 276.786C139.055 276.517 139.083 276.07 139.352 275.605C139.631 275.159 140.133 274.666 140.887 274.48C141.649 274.303 142.551 274.527 143.35 275.038C144.159 275.54 144.857 276.321 145.526 277.158C146.205 277.976 146.93 278.897 147.971 279.39C148.492 279.632 149.078 279.762 149.654 279.697C150.24 279.65 150.761 279.325 151.096 278.832C151.774 277.818 151.691 276.386 151.793 274.992C151.849 274.294 151.923 273.56 152.286 272.89C152.648 272.23 153.355 271.765 154.099 271.728C155.614 271.709 156.693 272.806 157.353 273.811C158.032 274.824 158.562 275.866 159.38 276.479C160.189 277.084 161.258 277.298 161.974 276.842C162.69 276.377 162.848 275.494 163.015 274.806C163.155 274.099 163.406 273.457 163.75 273.057C164.085 272.639 164.494 272.444 164.773 272.425C165.098 272.425 165.228 272.5 165.228 272.5Z\" fill=#FAFAFA /><path d=\"M173.471 286.218C173.48 286.218 173.508 286.404 173.49 286.748C173.462 287.101 173.341 287.622 172.988 288.199C172.644 288.775 172.039 289.38 171.156 289.798C170.301 290.198 169.064 290.356 167.967 289.752C166.879 289.222 165.968 288.189 164.703 287.836C163.42 287.455 162.035 288.338 161.226 289.575C160.38 290.821 160.036 292.457 159.18 293.982C158.743 294.745 158.13 295.442 157.33 295.907C156.549 296.391 155.471 296.558 154.569 296.13C153.676 295.703 153.09 294.912 152.635 294.159C152.17 293.397 151.789 292.634 151.324 291.955C150.868 291.267 150.273 290.719 149.557 290.523C148.841 290.31 148.079 290.514 147.474 290.933C146.238 291.779 145.531 293.108 144.973 294.354C144.397 295.6 143.876 296.8 143.225 297.804C141.97 299.887 139.971 300.789 138.651 300.817C137.972 300.854 137.461 300.696 137.145 300.557C136.977 300.492 136.875 300.408 136.791 300.371C136.717 300.324 136.68 300.296 136.68 300.287C136.698 300.213 137.331 300.743 138.632 300.64C139.897 300.547 141.766 299.664 142.928 297.637C143.541 296.651 144.034 295.47 144.601 294.206C145.159 292.96 145.866 291.528 147.223 290.579C147.884 290.105 148.813 289.845 149.669 290.096C150.543 290.328 151.231 290.988 151.705 291.704C152.198 292.42 152.588 293.201 153.035 293.927C153.481 294.652 154.02 295.349 154.755 295.703C155.508 296.056 156.372 295.926 157.079 295.507C157.795 295.098 158.362 294.457 158.762 293.759C159.58 292.337 159.933 290.691 160.845 289.342C161.3 288.682 161.877 288.106 162.574 287.743C163.253 287.371 164.09 287.26 164.796 287.464C165.512 287.659 166.089 288.069 166.609 288.44C167.13 288.822 167.613 289.194 168.116 289.463C169.11 290.031 170.217 289.91 171.044 289.566C171.872 289.203 172.467 288.645 172.82 288.115C173.545 287.008 173.397 286.199 173.471 286.218Z\" fill=#FAFAFA /><path d=\"M168.729 306.082C168.72 306.101 168.608 306.054 168.385 306.035C168.171 306.017 167.827 306.063 167.492 306.324C167.158 306.584 166.832 307.012 166.637 307.598C166.405 308.174 166.47 308.881 166.544 309.681C166.609 310.471 166.758 311.419 166.339 312.377C165.93 313.353 164.777 313.949 163.643 313.921C162.481 313.958 161.281 313.363 160.445 312.433C159.58 311.512 158.985 310.35 158.418 309.178L158.585 309.309C157.646 309.132 156.67 309.727 156.056 310.564C155.405 311.401 155.164 312.498 154.987 313.632C154.857 314.469 154.764 315.316 154.531 316.143C154.299 316.98 153.899 317.761 153.323 318.384C152.755 319.007 151.919 319.453 151.063 319.426C150.208 319.407 149.455 318.988 148.878 318.496C147.688 317.482 147.102 316.134 146.293 315.148C145.522 314.116 144.434 313.502 143.355 313.465C142.277 313.4 141.31 313.791 140.678 314.358C140.036 314.934 139.701 315.641 139.543 316.217C139.236 317.417 139.525 318.114 139.46 318.114C139.45 318.114 139.432 318.077 139.404 317.994C139.376 317.91 139.339 317.789 139.311 317.622C139.255 317.296 139.218 316.794 139.357 316.162C139.497 315.539 139.822 314.785 140.492 314.144C141.152 313.502 142.202 313.065 143.365 313.102C143.941 313.121 144.555 313.27 145.122 313.586C145.689 313.893 146.182 314.358 146.6 314.878C147.465 315.911 148.06 317.222 149.166 318.133C149.706 318.589 150.366 318.942 151.072 318.942C151.779 318.961 152.467 318.598 152.979 318.04C153.49 317.482 153.862 316.766 154.076 315.994C154.29 315.213 154.383 314.386 154.513 313.53C154.689 312.396 154.94 311.187 155.675 310.248C156.354 309.327 157.488 308.611 158.669 308.825L158.79 308.844L158.836 308.946C159.403 310.118 159.97 311.243 160.77 312.098C161.551 312.972 162.592 313.493 163.643 313.484C164.675 313.512 165.651 313.009 166.023 312.191C166.405 311.373 166.293 310.462 166.246 309.671C166.181 308.881 166.144 308.1 166.414 307.486C166.646 306.872 167.018 306.426 167.399 306.166C167.79 305.905 168.171 305.877 168.394 305.933C168.636 305.998 168.729 306.082 168.729 306.082Z\" fill=#FAFAFA /><path d=\"M281.6 302.147C281.6 302.175 281.424 302.175 281.135 302.277C280.838 302.38 280.429 302.631 280.085 303.124C279.741 303.607 279.453 304.295 279.257 305.132C279.071 305.96 278.969 306.992 278.467 308.015C278.225 308.517 277.863 309.047 277.286 309.372C276.719 309.698 275.957 309.735 275.315 309.428C274.673 309.121 274.199 308.573 273.818 307.987C273.428 307.401 273.121 306.732 272.832 306.081C272.544 305.448 272.135 304.835 271.633 304.323C271.131 303.83 270.443 303.43 269.773 303.607C269.085 303.756 268.639 304.407 268.509 305.169C268.36 305.932 268.397 306.75 268.388 307.596C268.36 309.289 267.867 311.037 266.687 312.236C265.534 313.408 263.721 313.938 262.27 313.296C260.848 312.655 260.001 311.483 259.053 310.656C258.142 309.781 256.998 309.298 255.976 309.586C254.962 309.847 254.218 310.563 253.763 311.26C253.298 311.967 253.065 312.683 252.898 313.268C252.582 314.44 252.47 315.119 252.433 315.11C252.414 315.11 252.433 314.933 252.47 314.617C252.517 314.301 252.582 313.826 252.721 313.222C252.87 312.627 253.075 311.883 253.54 311.12C254.004 310.377 254.767 309.577 255.901 309.261C256.459 309.103 257.101 309.131 257.696 309.335C258.3 309.54 258.83 309.93 259.323 310.358C260.308 311.204 261.182 312.329 262.447 312.887C263.702 313.436 265.311 312.971 266.352 311.911C267.412 310.832 267.877 309.214 267.905 307.587C267.914 306.769 267.867 305.923 268.044 305.076C268.128 304.658 268.277 304.23 268.555 303.868C268.834 303.505 269.234 303.254 269.671 303.152C270.592 302.938 271.419 303.468 271.968 304.007C272.526 304.574 272.944 305.225 273.251 305.913C273.539 306.583 273.827 307.206 274.181 307.773C274.534 308.331 274.971 308.824 275.501 309.084C276.022 309.344 276.645 309.317 277.119 309.056C277.602 308.805 277.937 308.34 278.169 307.875C278.662 306.917 278.783 305.941 278.997 305.086C279.22 304.23 279.545 303.523 279.936 303.031C280.327 302.529 280.782 302.287 281.108 302.203C281.424 302.101 281.6 302.147 281.6 302.147Z\" fill=#FAFAFA /><path d=\"M276.76 280.29C276.77 280.299 276.714 280.42 276.593 280.634C276.463 280.848 276.277 281.164 276.007 281.554C275.738 281.945 275.384 282.41 274.892 282.893C274.408 283.368 273.757 283.86 272.911 284.111C272.093 284.372 271.024 284.418 270.094 283.86C269.164 283.293 268.718 282.196 267.881 281.619C267.472 281.34 266.933 281.257 266.477 281.471C266.012 281.684 265.65 282.131 265.398 282.642C265.147 283.154 264.989 283.739 264.952 284.325C264.924 284.93 264.943 285.571 264.924 286.222C264.896 286.873 264.831 287.543 264.562 288.175C264.301 288.798 263.809 289.337 263.204 289.616C261.968 290.174 260.657 289.858 259.625 289.412C258.565 288.928 257.756 288.212 256.947 287.645C256.156 287.059 255.375 286.585 254.594 286.362C253.823 286.111 253.07 286.241 252.475 286.473C251.879 286.724 251.424 287.087 251.182 287.459C250.671 288.24 250.94 288.817 250.866 288.807C250.857 288.807 250.801 288.686 250.764 288.435C250.736 288.184 250.773 287.784 251.024 287.357C251.266 286.929 251.74 286.51 252.372 286.222C252.995 285.953 253.841 285.776 254.697 286.036C255.543 286.259 256.38 286.752 257.189 287.329C258.007 287.887 258.825 288.584 259.811 289.012C260.777 289.43 261.986 289.681 263 289.198C263.492 288.965 263.902 288.528 264.115 287.998C264.348 287.468 264.413 286.845 264.441 286.222C264.469 285.59 264.441 284.958 264.469 284.316C264.506 283.656 264.683 283.023 264.971 282.447C265.259 281.88 265.677 281.34 266.291 281.071C266.905 280.782 267.639 280.913 268.141 281.266C269.127 282.001 269.517 283.051 270.317 283.535C271.098 284.028 272.056 284.018 272.827 283.795C273.608 283.581 274.231 283.144 274.724 282.707C275.208 282.261 275.58 281.824 275.868 281.461C276.426 280.699 276.723 280.271 276.76 280.29Z\" fill=#FAFAFA /><path d=\"M252.996 333.803C252.996 333.803 252.903 334.054 252.512 334.352C252.131 334.659 251.378 334.854 250.476 334.687C250.02 334.603 249.537 334.454 249.035 334.194C248.533 333.933 248.059 333.58 247.529 333.217C247.008 332.864 246.441 332.474 245.79 332.222C245.139 331.953 244.386 331.906 243.67 332.167C242.954 332.436 242.387 333.059 241.941 333.775C241.485 334.501 241.122 335.328 240.732 336.193C240.341 337.048 239.951 337.969 239.319 338.806C238.984 339.206 238.612 339.615 238.119 339.875C237.868 340.005 237.617 340.136 237.338 340.173C237.199 340.201 237.059 340.238 236.92 340.257H236.492C235.925 340.238 235.339 340.033 234.884 339.689C234.4 339.373 234.019 338.936 233.656 338.508C232.94 337.625 232.355 336.649 231.657 335.747C230.969 334.863 230.132 334.017 229.035 333.729C227.947 333.45 226.757 333.775 225.772 334.408C224.768 335.04 223.987 335.942 223.364 336.937C222.731 337.932 222.211 338.983 221.625 339.987C221.039 340.991 220.36 341.967 219.486 342.711C218.631 343.465 217.59 344.032 216.465 344.153C215.349 344.274 214.224 343.892 213.415 343.241C212.587 342.59 211.992 341.781 211.444 341.01C210.365 339.457 209.426 337.941 208.087 337.104C207.436 336.677 206.711 336.481 206.014 336.472C205.317 336.481 204.666 336.658 204.099 336.909C202.955 337.42 202.183 338.239 201.728 338.992C201.272 339.754 201.142 340.442 201.114 340.907C201.105 341.372 201.133 341.623 201.105 341.623C201.095 341.623 201.086 341.568 201.068 341.447C201.058 341.326 201.012 341.149 201.012 340.907C201.012 340.433 201.114 339.708 201.56 338.899C201.997 338.099 202.788 337.234 203.978 336.667C204.573 336.388 205.252 336.184 206.005 336.165C206.758 336.156 207.567 336.36 208.264 336.816C209.696 337.699 210.681 339.262 211.76 340.777C212.309 341.54 212.904 342.312 213.666 342.897C214.419 343.502 215.414 343.818 216.409 343.706C217.413 343.595 218.371 343.065 219.18 342.358C219.998 341.651 220.639 340.731 221.207 339.745C221.783 338.759 222.304 337.69 222.955 336.667C223.587 335.644 224.424 334.659 225.511 333.98C226.571 333.301 227.901 332.92 229.156 333.245C230.421 333.58 231.313 334.529 232.029 335.44C232.745 336.37 233.331 337.346 234.01 338.201C234.679 339.038 235.516 339.782 236.52 339.801C237.515 339.857 238.407 339.327 238.984 338.546C239.579 337.774 239.97 336.881 240.369 336.026C240.769 335.17 241.141 334.324 241.634 333.571C242.117 332.827 242.74 332.139 243.558 331.841C244.367 331.553 245.223 331.627 245.911 331.934C246.608 332.222 247.175 332.622 247.696 332.994C248.217 333.366 248.682 333.738 249.146 333.989C249.611 334.25 250.086 334.408 250.513 334.501C251.378 334.687 252.085 334.538 252.466 334.277C252.847 334.017 252.968 333.785 252.996 333.803Z\" fill=#FAFAFA /><path d=\"M251.231 302.868C251.24 302.868 251.212 302.924 251.156 303.017C251.091 303.11 250.98 303.24 250.775 303.343C250.375 303.556 249.669 303.547 248.925 303.175C248.153 302.822 247.549 301.938 246.526 301.529C246.033 301.325 245.401 301.399 244.964 301.799C244.527 302.208 244.304 302.868 244.109 303.547C243.904 304.235 243.737 304.979 243.355 305.714C243.16 306.067 242.909 306.439 242.547 306.699C242.193 306.969 241.756 307.136 241.301 307.183C239.46 307.369 237.712 306.142 236.522 304.682C235.88 303.975 235.248 303.231 234.476 302.664C233.704 302.097 232.765 301.743 231.77 301.799C229.781 301.883 227.884 303.185 226.573 304.858C225.243 306.569 224.36 308.55 223.189 310.289C222.063 312.055 220.446 313.515 218.558 314.138C217.628 314.445 216.624 314.538 215.694 314.315C214.765 314.101 213.974 313.534 213.379 312.911C212.18 311.665 211.39 310.242 210.199 309.508C209.614 309.145 208.954 308.987 208.34 309.033C207.726 309.08 207.168 309.322 206.713 309.638C205.802 310.279 205.216 311.098 204.788 311.767C203.942 313.125 203.635 313.98 203.589 313.952C203.579 313.943 203.645 313.729 203.803 313.339C203.961 312.948 204.221 312.372 204.63 311.665C205.049 310.977 205.606 310.121 206.564 309.415C207.038 309.071 207.633 308.782 208.321 308.727C209 308.661 209.735 308.829 210.385 309.219C211.696 310.01 212.505 311.46 213.677 312.632C214.253 313.218 214.969 313.711 215.806 313.897C216.643 314.092 217.554 314.008 218.428 313.711C220.195 313.116 221.71 311.758 222.798 310.028C223.942 308.327 224.825 306.337 226.201 304.561C227.586 302.813 229.558 301.427 231.761 301.325C232.858 301.269 233.927 301.678 234.755 302.292C235.592 302.915 236.224 303.677 236.866 304.384C237.498 305.1 238.121 305.76 238.883 306.179C239.636 306.606 240.473 306.867 241.263 306.783C242.063 306.718 242.695 306.197 243.03 305.528C243.393 304.868 243.569 304.133 243.783 303.436C243.997 302.757 244.239 302.05 244.759 301.557C245.299 301.074 246.07 301.018 246.628 301.26C247.744 301.753 248.311 302.645 249.018 302.989C249.706 303.361 250.366 303.398 250.738 303.231C251.119 303.082 251.203 302.84 251.231 302.868Z\" fill=#FAFAFA /><path d=\"M251.722 270.763C251.703 270.782 251.573 270.615 251.248 270.447C250.922 270.271 250.355 270.15 249.676 270.336C248.988 270.503 248.235 271.005 247.761 271.898C247.25 272.772 246.999 273.906 246.608 275.162C246.404 275.785 246.143 276.436 245.716 277.04C245.306 277.644 244.665 278.175 243.884 278.416C243.103 278.649 242.238 278.584 241.439 278.351C240.63 278.109 239.858 277.728 239.133 277.254C237.701 276.324 236.306 275.078 234.54 274.762C233.666 274.622 232.745 274.762 231.927 275.19C231.099 275.599 230.374 276.231 229.723 276.947C228.403 278.37 227.51 280.109 226.265 281.55C225.651 282.275 224.972 282.935 224.191 283.428C223.41 283.93 222.508 284.237 221.606 284.265C219.765 284.302 218.259 283.317 217.069 282.387C215.87 281.42 214.865 280.425 213.805 279.709C212.755 278.993 211.648 278.546 210.654 278.556C209.659 278.565 208.813 278.9 208.255 279.328C207.678 279.746 207.409 280.257 207.288 280.601C207.158 280.955 207.167 281.159 207.13 281.159C207.13 281.159 207.092 280.955 207.195 280.574C207.297 280.202 207.548 279.644 208.143 279.179C208.71 278.705 209.594 278.323 210.654 278.286C211.732 278.24 212.904 278.705 214.001 279.421C215.107 280.137 216.139 281.141 217.32 282.071C218.492 282.973 219.942 283.875 221.588 283.819C223.243 283.772 224.749 282.647 225.902 281.243C227.101 279.858 227.985 278.109 229.37 276.622C230.049 275.878 230.82 275.208 231.722 274.762C232.615 274.297 233.656 274.139 234.623 274.297C236.585 274.66 237.989 275.98 239.384 276.882C240.76 277.793 242.368 278.426 243.772 278.044C244.46 277.84 245.018 277.393 245.409 276.836C245.808 276.287 246.069 275.664 246.273 275.059C246.673 273.851 246.961 272.679 247.519 271.768C247.798 271.321 248.124 270.931 248.496 270.661C248.867 270.392 249.267 270.233 249.63 270.159C250.364 269.992 250.969 270.159 251.294 270.373C251.629 270.568 251.722 270.763 251.722 270.763Z\" fill=#FAFAFA /><path d=\"M246.934 255.678C246.953 255.678 246.934 255.799 246.879 256.022C246.823 256.245 246.73 256.57 246.544 256.979C246.358 257.37 246.098 257.881 245.558 258.272C245.038 258.681 244.08 258.728 243.438 258.133C242.806 257.565 242.481 256.738 242.007 255.994C241.774 255.622 241.495 255.259 241.123 255.027C240.751 254.785 240.296 254.636 239.822 254.618C238.855 254.553 237.841 254.924 237.06 255.65C236.261 256.366 235.656 257.342 235.136 258.384C234.866 258.914 234.578 259.453 234.159 259.909C233.759 260.364 233.127 260.736 232.467 260.662C231.807 260.606 231.286 260.206 230.924 259.769C230.552 259.323 230.329 258.802 230.161 258.309C229.826 257.333 229.603 256.375 228.971 255.799C228.664 255.51 228.302 255.296 227.93 255.25C227.558 255.203 227.205 255.324 226.935 255.557C226.405 256.031 226.182 256.728 225.968 257.296C225.763 257.881 225.475 258.374 225.168 258.7C224.861 259.034 224.517 259.183 224.276 259.211C224.034 259.239 223.913 259.193 223.922 259.183C223.904 259.137 224.48 259.239 225.029 258.57C225.298 258.244 225.531 257.779 225.717 257.203C225.921 256.626 226.089 255.892 226.721 255.296C227.028 255.008 227.502 254.822 227.976 254.878C228.45 254.924 228.897 255.176 229.25 255.501C230.003 256.18 230.254 257.231 230.589 258.16C230.756 258.635 230.961 259.09 231.286 259.471C231.602 259.843 232.039 260.16 232.514 260.188C232.997 260.234 233.453 259.974 233.806 259.583C234.169 259.183 234.438 258.681 234.708 258.16C235.247 257.1 235.87 256.068 236.753 255.287C237.609 254.497 238.78 254.069 239.868 254.162C240.407 254.199 240.947 254.367 241.384 254.664C241.83 254.962 242.137 255.38 242.369 255.78C242.853 256.58 243.16 257.379 243.689 257.881C244.21 258.374 244.963 258.374 245.428 258.049C245.912 257.733 246.191 257.268 246.395 256.896C246.776 256.133 246.897 255.659 246.934 255.678Z\" fill=#FAFAFA /><path d=\"M186.319 255.755C186.337 255.755 186.365 255.904 186.412 256.192C186.449 256.48 186.505 256.917 186.523 257.475C186.542 258.033 186.533 258.74 186.282 259.521C186.059 260.302 185.463 261.139 184.515 261.604C184.05 261.827 183.464 261.957 182.879 261.808C182.293 261.678 181.791 261.25 181.428 260.767C181.056 260.283 180.787 259.725 180.461 259.223C180.136 258.712 179.727 258.247 179.169 258.042C178.034 257.624 176.584 258.266 175.97 259.456C175.645 260.042 175.459 260.73 175.394 261.436C175.32 262.143 175.394 262.878 175.431 263.64C175.468 264.403 175.487 265.193 175.264 265.946C175.059 266.69 174.631 267.415 173.953 267.843C173.274 268.271 172.409 268.28 171.721 268.02C171.024 267.769 170.447 267.341 169.964 266.867C169.016 265.881 168.43 264.765 167.612 263.975C166.831 263.157 165.789 262.785 164.832 262.85C163.874 262.896 163.056 263.305 162.526 263.835C161.987 264.375 161.708 264.998 161.568 265.518C161.308 266.579 161.54 267.202 161.475 267.211C161.466 267.211 161.401 267.071 161.345 266.774C161.298 266.486 161.261 266.03 161.382 265.472C161.494 264.914 161.763 264.235 162.331 263.64C162.888 263.036 163.772 262.571 164.813 262.496C165.845 262.394 167.044 262.803 167.891 263.677C168.774 264.514 169.388 265.649 170.271 266.541C170.726 266.978 171.256 267.369 171.861 267.583C172.465 267.797 173.144 267.778 173.683 267.434C174.222 267.09 174.594 266.476 174.78 265.807C174.976 265.137 174.966 264.403 174.929 263.659C174.808 262.18 174.762 260.544 175.543 259.205C176.259 257.856 177.923 257.085 179.308 257.605C180.006 257.866 180.461 258.442 180.796 258.972C181.14 259.512 181.4 260.06 181.735 260.507C182.06 260.962 182.479 261.306 182.953 261.427C183.427 261.557 183.929 261.464 184.348 261.269C185.212 260.869 185.77 260.135 186.003 259.409C186.263 258.684 186.3 258.005 186.31 257.457C186.337 256.369 186.272 255.755 186.319 255.755Z\" fill=#FAFAFA /><path d=\"M236.116 148.681C229.821 147.324 223.889 153.359 217.492 152.661C213.606 152.233 210.463 149.425 206.893 147.817C201.565 145.408 194.331 145.557 189.357 148.635C184.383 151.713 181.277 154.809 181.054 160.658C176.098 158.343 168.706 164.963 166.512 170.933C164.318 176.903 165.489 182.789 167.535 188.814C171.059 199.192 176.647 208.862 183.871 217.101C184.513 217.826 185.498 218.617 186.344 218.133C186.93 217.798 187.06 217.027 187.107 216.357C187.535 210.648 186.335 204.966 185.368 199.331C184.401 193.687 183.667 187.857 184.996 182.287C186.335 176.726 190.147 171.426 195.651 169.845C199.715 168.683 204.122 169.659 207.962 171.407C211.811 173.155 215.27 175.647 218.961 177.693C222.652 179.748 226.753 181.394 230.974 181.217C235.195 181.041 239.537 178.679 241.015 174.718C242.484 170.756 240.021 165.512 235.827 164.982C239.584 164.312 242.605 160.76 242.68 156.957C242.736 153.145 239.835 149.49 236.116 148.681Z\" fill=#263238 /><path d=\"M225.547 248.98L223.92 236.845C223.92 236.845 239.717 232.41 237.978 216.295C237.141 208.512 234.11 192.63 231.209 178.282C228.085 162.855 213.636 152.413 198.007 154.291L196.454 154.477C179.83 157.462 173.079 173.251 176.529 189.794L185.901 254.513C187.482 265.401 197.551 272.98 208.448 271.473C219.373 269.958 227.016 259.906 225.547 248.98Z\" fill=#FFBE9D /><path d=\"M223.938 236.846C223.938 236.846 213.868 238.891 202.246 233.405C202.246 233.405 208.596 244.387 224.477 241.012L223.938 236.846Z\" fill=#EB996E /><path d=\"M226.254 188.056C226.449 189.311 225.593 190.511 224.329 190.734C223.074 190.957 221.893 190.12 221.698 188.855C221.502 187.6 222.358 186.4 223.613 186.177C224.878 185.954 226.058 186.8 226.254 188.056Z\" fill=#263238 /><path d=\"M228.7 187.638C228.449 187.973 226.552 186.895 224.079 187.192C221.606 187.462 219.941 188.95 219.634 188.68C219.486 188.559 219.709 187.983 220.434 187.313C221.141 186.644 222.405 185.928 223.949 185.751C225.492 185.574 226.85 185.983 227.668 186.476C228.505 186.969 228.821 187.48 228.7 187.638Z\" fill=#263238 /><path d=\"M202.715 190.033C202.919 191.316 202.055 192.535 200.799 192.758C199.544 192.981 198.363 192.116 198.159 190.833C197.954 189.55 198.819 188.332 200.074 188.108C201.339 187.885 202.52 188.75 202.715 190.033Z\" fill=#263238 /><path d=\"M204.963 189.558C204.712 189.893 202.816 188.814 200.342 189.121C197.869 189.391 196.205 190.878 195.898 190.609C195.749 190.488 195.973 189.911 196.698 189.242C197.404 188.572 198.669 187.856 200.203 187.68C201.746 187.503 203.104 187.912 203.922 188.405C204.768 188.898 205.084 189.409 204.963 189.558Z\" fill=#263238 /><path d=\"M215.63 207.207C215.602 207.067 217.108 206.621 219.563 205.998C220.186 205.859 220.771 205.663 220.827 205.217C220.92 204.743 220.576 204.092 220.176 203.394C219.395 201.935 218.586 200.41 217.731 198.81C214.319 192.273 211.762 186.871 212.022 186.731C212.282 186.592 215.267 191.78 218.689 198.317C219.516 199.935 220.306 201.47 221.06 202.939C221.385 203.627 221.896 204.389 221.683 205.375C221.571 205.868 221.143 206.268 220.753 206.426C220.362 206.603 220.009 206.649 219.702 206.705C217.21 207.151 215.658 207.346 215.63 207.207Z\" fill=#263238 /><path d=\"M208.545 209.792C208.945 209.717 209.271 212.404 211.8 214.032C214.319 215.668 217.146 215.027 217.211 215.399C217.267 215.566 216.634 215.994 215.435 216.17C214.254 216.356 212.478 216.18 210.935 215.185C209.391 214.181 208.601 212.702 208.378 211.605C208.146 210.498 208.359 209.801 208.545 209.792Z\" fill=#263238 /><path d=\"M203.695 178.258C203.528 178.956 201.026 178.937 198.163 179.634C195.29 180.276 193.049 181.401 192.593 180.853C192.389 180.583 192.724 179.904 193.588 179.142C194.444 178.379 195.866 177.579 197.586 177.18C199.306 176.78 200.934 176.863 202.04 177.17C203.165 177.459 203.76 177.923 203.695 178.258Z\" fill=#263238 /><path d=\"M226.912 179.517C226.54 180.131 224.773 179.75 222.719 179.973C220.664 180.122 218.981 180.801 218.516 180.261C218.302 180.001 218.516 179.406 219.204 178.783C219.883 178.16 221.082 177.583 222.495 177.453C223.909 177.332 225.192 177.695 225.973 178.178C226.763 178.671 227.07 179.229 226.912 179.517Z\" fill=#263238 /><path d=\"M179.265 201.549C178.977 201.465 167.82 199.605 169.493 210.569C171.167 221.532 181.822 217.589 181.794 217.273C181.757 216.947 179.265 201.549 179.265 201.549Z\" fill=#FFBE9D /><path d=\"M177.81 213.636C177.754 213.608 177.643 213.803 177.336 213.998C177.048 214.193 176.518 214.37 175.913 214.249C174.695 213.998 173.431 212.315 173.078 210.344C172.901 209.349 172.966 208.373 173.198 207.526C173.412 206.671 173.84 206.039 174.407 205.843C174.965 205.62 175.43 205.908 175.616 206.197C175.811 206.485 175.774 206.708 175.839 206.717C175.876 206.736 176.044 206.494 175.886 206.057C175.811 205.843 175.644 205.611 175.346 205.434C175.049 205.257 174.649 205.211 174.249 205.313C173.412 205.499 172.771 206.392 172.51 207.312C172.204 208.242 172.111 209.349 172.315 210.465C172.724 212.659 174.165 214.556 175.82 214.77C176.62 214.854 177.234 214.519 177.522 214.212C177.829 213.905 177.857 213.645 177.81 213.636Z\" fill=#EB996E /><path d=\"M234.198 174.498C227.336 177.232 219.154 176.395 212.99 172.322C208.676 169.477 205.087 165.06 200.001 164.14C196.579 163.517 192.99 164.67 190.173 166.706C187.347 168.742 185.208 171.588 183.432 174.582C187.523 182.384 186.528 191.766 185.431 200.507C185.31 201.474 185.152 202.515 184.455 203.203C183.274 204.356 181.229 203.808 179.955 202.757C177.909 201.074 176.887 198.47 176.106 195.941C174.339 190.176 173.456 184.085 174.069 178.078C174.683 172.081 176.84 166.167 180.671 161.508C185.459 155.687 192.721 152.098 200.215 151.307C207.709 150.526 215.379 152.451 221.897 156.245C224.919 158.003 227.773 160.225 229.586 163.219\" fill=#263238 /><path d=\"M241.195 152.015C241.195 152.015 241.297 152.34 241.214 152.982C241.13 153.605 240.805 154.553 239.949 155.437C239.103 156.33 237.699 157.027 236.007 157.306C235.161 157.445 234.24 157.529 233.255 157.464C232.279 157.39 231.219 157.148 230.298 156.497C229.396 155.865 228.606 154.832 228.55 153.559C228.485 152.266 229.378 151.057 230.549 150.471C231.135 150.164 231.804 149.988 232.502 149.979C233.19 149.979 233.906 150.202 234.491 150.602C235.7 151.383 236.416 152.796 236.593 154.256C236.779 155.734 236.286 157.297 235.347 158.505C234.408 159.724 233.097 160.653 231.628 161.249C228.68 162.457 225.249 162.281 222.107 161.351C218.927 160.44 216.072 158.915 213.385 157.427C210.698 155.939 208.086 154.526 205.445 153.605C202.814 152.666 200.117 152.312 197.663 152.675C195.208 153.028 193.042 153.996 191.285 155.158C187.742 157.529 185.864 160.588 184.785 162.671C184.246 163.731 183.893 164.596 183.67 165.173C183.437 165.758 183.326 166.075 183.307 166.065C183.298 166.065 183.316 165.982 183.354 165.823C183.4 165.665 183.456 165.433 183.558 165.135C183.753 164.531 184.069 163.657 184.59 162.569C185.622 160.44 187.472 157.306 191.071 154.832C192.856 153.624 195.069 152.61 197.598 152.219C200.127 151.829 202.916 152.182 205.612 153.121C208.318 154.051 210.959 155.474 213.655 156.953C216.342 158.431 219.159 159.928 222.274 160.821C225.352 161.723 228.634 161.881 231.442 160.746C232.827 160.188 234.064 159.314 234.938 158.189C235.821 157.064 236.267 155.669 236.1 154.321C235.951 152.991 235.291 151.708 234.231 151.02C233.199 150.276 231.814 150.341 230.763 150.89C229.703 151.42 228.931 152.461 228.978 153.559C229.015 154.656 229.703 155.614 230.531 156.199C231.367 156.794 232.362 157.046 233.292 157.129C234.231 157.204 235.133 157.138 235.96 157.018C237.615 156.776 238.973 156.134 239.8 155.307C240.647 154.479 240.991 153.586 241.111 152.982C241.223 152.35 241.158 152.015 241.195 152.015Z\" fill=#455A64 /><path d=\"M165.681 180.637C165.709 180.517 166.992 181.121 169.149 181.102C170.218 181.084 171.492 180.851 172.794 180.275C174.095 179.717 175.425 178.843 176.68 177.792C179.181 175.635 180.381 172.743 180.799 170.651C181.227 168.53 181.013 167.164 181.124 167.154C181.162 167.154 181.236 167.48 181.292 168.103C181.348 168.716 181.348 169.618 181.18 170.725C180.855 172.901 179.665 175.951 177.043 178.21C175.741 179.308 174.365 180.182 172.989 180.74C171.622 181.316 170.265 181.521 169.149 181.484C168.024 181.446 167.141 181.223 166.564 181.019C165.978 180.833 165.672 180.665 165.681 180.637Z\" fill=#455A64 /><path d=\"M167.135 188.545C167.135 188.443 168.455 188.573 170.519 188.21C172.565 187.857 175.373 186.871 177.8 184.816C180.226 182.752 181.658 180.139 182.337 178.177C183.034 176.206 183.118 174.885 183.22 174.895C183.257 174.895 183.267 175.229 183.211 175.824C183.155 176.42 183.016 177.275 182.709 178.298C182.104 180.334 180.682 183.087 178.162 185.225C175.633 187.364 172.695 188.322 170.584 188.582C169.525 188.722 168.651 188.722 168.055 188.675C167.451 188.647 167.126 188.582 167.135 188.545Z\" fill=#455A64 /><path d=\"M197.479 201.452C197.34 201.499 197.172 201.406 197.126 201.257C197.07 201.099 197.154 200.932 197.293 200.885C197.433 200.839 197.6 200.932 197.647 201.09C197.693 201.238 197.619 201.406 197.479 201.452Z\" fill=#EB996E /><path d=\"M202.074 199.808C201.935 199.854 201.767 199.743 201.702 199.566C201.647 199.39 201.712 199.204 201.86 199.157C202 199.111 202.167 199.222 202.232 199.399C202.288 199.575 202.223 199.752 202.074 199.808Z\" fill=#EB996E /><path d=\"M205.26 199.345C205.111 199.382 204.944 199.215 204.888 198.973C204.832 198.731 204.897 198.508 205.046 198.471C205.195 198.434 205.362 198.601 205.418 198.843C205.483 199.085 205.409 199.308 205.26 199.345Z\" fill=#EB996E /><path d=\"M200.162 204.134C200.014 204.153 199.883 204.088 199.865 203.995C199.856 203.902 199.967 203.809 200.116 203.79C200.265 203.772 200.395 203.837 200.413 203.93C200.423 204.023 200.311 204.116 200.162 204.134Z\" fill=#EB996E /><path d=\"M204.366 202.618C204.218 202.646 204.069 202.534 204.032 202.367C203.994 202.2 204.087 202.032 204.236 202.004C204.385 201.976 204.534 202.088 204.571 202.255C204.608 202.423 204.515 202.581 204.366 202.618Z\" fill=#EB996E /><path d=\"M226.614 197.209C226.475 197.256 226.307 197.163 226.261 197.005C226.205 196.837 226.279 196.67 226.428 196.623C226.577 196.577 226.735 196.67 226.781 196.828C226.828 196.995 226.753 197.163 226.614 197.209Z\" fill=#EB996E /><path d=\"M229.782 196.528C229.633 196.565 229.484 196.435 229.438 196.249C229.4 196.063 229.484 195.886 229.633 195.849C229.782 195.812 229.93 195.942 229.977 196.128C230.014 196.314 229.93 196.491 229.782 196.528Z\" fill=#EB996E /><path d=\"M223.77 197.625C223.631 197.672 223.472 197.606 223.435 197.486C223.398 197.355 223.472 197.216 223.621 197.169C223.761 197.123 223.919 197.188 223.956 197.309C223.993 197.439 223.909 197.579 223.77 197.625Z\" fill=#EB996E /><path d=\"M226.54 200.564C226.41 200.639 226.233 200.583 226.141 200.434C226.048 200.285 226.085 200.099 226.215 200.025C226.345 199.951 226.522 200.006 226.615 200.155C226.708 200.295 226.67 200.481 226.54 200.564Z\" fill=#EB996E /><path d=\"M229.237 199.685C229.088 199.666 228.977 199.545 228.995 199.415C229.014 199.285 229.153 199.201 229.302 199.229C229.451 199.248 229.562 199.368 229.544 199.499C229.525 199.62 229.386 199.703 229.237 199.685Z\" fill=#EB996E /><path d=\"M168.899 207.356C168.918 207.411 168.295 207.411 167.802 206.686C167.57 206.342 167.402 205.821 167.514 205.254C167.626 204.696 167.979 204.138 168.509 203.776C169.039 203.404 169.69 203.283 170.229 203.348C170.777 203.404 171.233 203.617 171.568 203.859C172.237 204.361 172.349 204.901 172.302 204.91C172.228 204.956 172.014 204.51 171.373 204.147C170.777 203.794 169.652 203.552 168.769 204.175C168.332 204.473 168.035 204.919 167.932 205.356C167.821 205.793 167.914 206.212 168.081 206.519C168.425 207.151 168.927 207.281 168.899 207.356Z\" fill=#263238 /><path d=\"M252.129 327.481L252.957 351.491C252.957 351.491 183.353 365.281 174.4 369.893C165.446 374.505 161.792 375.221 162.331 388.518L273.561 388.323C273.561 388.323 287.266 383.19 286.996 368.265C286.726 353.341 282.998 317.485 282.998 317.485L252.129 327.481Z\" fill=#FFBE9D /><path d=\"M173.836 388.868L183.078 388.022L191.902 366.942C190.47 366.7 160.708 362.302 158.95 362.776L151.81 388.143C151.81 388.152 173.204 388.868 173.836 388.868Z\" fill=#FFBE9D /><path d=\"M153.491 388.548C153.51 388.595 153.686 388.632 153.984 388.66C156.439 388.93 167.791 388.241 167.791 388.241C168.312 386.772 167.326 382.374 165.913 382.114C164.5 381.853 152.413 382.672 152.413 382.672C152.413 382.672 150.507 382.923 150.032 386.121C149.754 388.083 153.491 388.548 153.491 388.548Z\" fill=#FFBE9D /><path d=\"M149.652 382.113C149.671 382.159 149.848 382.196 150.145 382.224C152.6 382.494 163.339 382.373 163.804 381.071C164.324 379.602 163.497 375.938 162.084 375.678C160.67 375.418 148.592 376.236 148.592 376.236C148.592 376.236 146.686 376.487 146.212 379.686C145.924 381.657 149.652 382.113 149.652 382.113Z\" fill=#FFBE9D /><path d=\"M147.756 375.805C147.775 375.852 147.952 375.889 148.249 375.917C150.704 376.186 161.443 376.066 161.908 374.764C162.428 373.295 161.601 369.631 160.187 369.37C158.774 369.11 146.687 369.928 146.687 369.928C146.687 369.928 144.781 370.179 144.307 373.378C144.019 375.34 147.756 375.805 147.756 375.805Z\" fill=#FFBE9D /><path d=\"M145.979 369.531C145.998 369.577 146.174 369.614 146.472 369.642C148.926 369.912 159.665 369.791 160.13 368.489C160.651 367.02 159.823 363.356 158.41 363.096C156.997 362.836 144.91 363.654 144.91 363.654C144.91 363.654 143.004 363.905 142.53 367.104C142.241 369.075 145.979 369.531 145.979 369.531Z\" fill=#FFBE9D /><path d=\"M162.774 382.066C162.755 382.252 160.422 382.466 157.549 382.55C154.676 382.633 152.36 382.55 152.379 382.364C152.398 382.178 154.731 381.964 157.604 381.88C160.477 381.796 162.793 381.88 162.774 382.066Z\" fill=#EB996E /><path d=\"M162.855 375.716C162.864 375.902 159.536 376.163 155.426 376.293C151.316 376.423 147.979 376.376 147.979 376.19C147.969 376.004 151.298 375.744 155.407 375.614C159.508 375.484 162.846 375.53 162.855 375.716Z\" fill=#EB996E /><g opacity=0.78><g opacity=0.78><g opacity=0.78><g opacity=0.78><path opacity=0.78 d=\"M162.333 369.305C162.342 369.491 159.013 369.751 154.904 369.881C150.794 370.011 147.456 369.965 147.456 369.779C147.447 369.593 150.775 369.333 154.885 369.202C158.995 369.072 162.323 369.109 162.333 369.305Z\" fill=#EB996E /></g></g></g></g><path d=\"M179.569 365.323C179.569 365.323 159.309 356.312 158.044 357.614C156.78 358.916 154.827 363.1 154.827 363.1L179.569 365.323Z\" fill=#FFBE9D /><path d=\"M268.519 372.438C268.435 372.466 268.017 370.987 267.059 368.728C266.585 367.593 265.934 366.282 265.135 364.869C264.317 363.465 263.34 361.968 262.197 360.489C261.034 359.02 259.826 357.709 258.663 356.574C257.483 355.458 256.376 354.51 255.391 353.766C253.429 352.278 252.099 351.516 252.146 351.441C252.164 351.414 252.508 351.581 253.113 351.916C253.726 352.241 254.582 352.771 255.595 353.487C256.618 354.194 257.762 355.133 258.97 356.249C260.16 357.383 261.406 358.704 262.578 360.192C263.74 361.698 264.716 363.223 265.525 364.655C266.306 366.096 266.939 367.445 267.376 368.607C267.822 369.769 268.129 370.718 268.296 371.396C268.473 372.057 268.556 372.429 268.519 372.438Z\" fill=#EB996E /><path d=\"M187.027 259.371L166.069 319.031L142.509 325.819C142.509 325.819 151.053 361.982 159.775 368.472C162.741 370.676 167.585 373.066 172.55 372.722C181.969 372.062 192.531 365.423 196.557 356.152C200.137 347.913 209.695 262.709 209.695 262.709L187.027 259.371Z\" fill=#FFBE9D /><path d=\"M209.412 265.248L210.63 250.714L207.255 239.044L205.954 234.581L208.501 237.185L213.15 232.228C213.15 232.228 211.644 223.422 210.379 223.422C209.589 223.422 207.283 224.213 205.675 224.808C204.717 225.161 204.01 225.44 204.01 225.44L200.077 227.449L204.01 221.414C204.01 221.414 208.064 224.789 210.138 221.86C211.728 219.619 205.814 214.598 203.592 212.822C203.081 212.413 202.42 212.264 201.779 212.385L199.482 212.85C199.557 211.557 198.153 209.819 196.126 209.791C193.123 209.744 191.728 212.431 191.728 212.431L189.311 212.869C187.618 212.869 186.112 213.919 185.526 215.509L180.208 229.978L187.033 259.39\" fill=#FFBE9D /><path d=\"M187.017 259.377C187.017 259.377 186.952 259.201 186.869 258.857C186.776 258.485 186.646 257.973 186.478 257.313C186.143 255.937 185.669 253.947 185.056 251.418C183.847 246.285 182.108 238.948 179.998 230.012L179.988 229.956L180.007 229.9C181.058 227.027 182.164 223.996 183.326 220.806C183.912 219.216 184.507 217.58 185.111 215.915C185.372 215.078 185.846 214.176 186.608 213.591C187.352 212.986 188.31 212.642 189.286 212.642H189.249C190.002 212.503 190.83 212.354 191.666 212.205L191.508 212.326C191.945 211.563 192.55 210.922 193.284 210.41C194.019 209.918 194.902 209.601 195.813 209.573C196.724 209.499 197.691 209.806 198.417 210.392C199.142 210.978 199.728 211.833 199.709 212.865L199.421 212.623C199.997 212.512 200.574 212.391 201.159 212.27C201.457 212.224 201.727 212.14 202.071 212.112C202.396 212.093 202.731 212.14 203.047 212.261C203.354 212.363 203.66 212.577 203.874 212.763L204.581 213.339C205.046 213.73 205.511 214.121 205.966 214.53C206.878 215.348 207.761 216.203 208.588 217.152C209.388 218.1 210.215 219.095 210.569 220.406C210.652 220.778 210.68 221.197 210.541 221.587C210.401 221.997 210.113 222.257 209.862 222.536C209.304 223.075 208.505 223.336 207.761 223.298C206.245 223.205 204.971 222.452 203.846 221.606L204.2 221.55C202.861 223.596 201.55 225.604 200.257 227.585L199.951 227.241C201.28 226.562 202.591 225.893 203.893 225.232L203.902 225.223H203.912C205.241 224.721 206.552 224.219 207.872 223.8C208.533 223.596 209.193 223.382 209.89 223.252C210.076 223.224 210.215 223.177 210.485 223.215C210.764 223.289 210.894 223.475 211.006 223.624C211.22 223.931 211.359 224.247 211.489 224.572C212.438 227.139 212.884 229.714 213.358 232.197L213.377 232.299L213.302 232.383C211.684 234.103 210.132 235.74 208.644 237.33L208.495 237.488L208.347 237.339C207.463 236.437 206.626 235.573 205.799 234.726L206.124 234.54C207.91 240.789 209.472 246.22 210.745 250.683L210.755 250.711V250.739C210.346 255.314 210.011 258.94 209.788 261.451C209.667 262.669 209.574 263.617 209.509 264.287C209.472 264.594 209.453 264.836 209.425 265.012C209.407 265.18 209.388 265.254 209.388 265.254C209.379 265.254 209.379 265.17 209.388 265.003C209.397 264.817 209.416 264.575 209.434 264.268C209.481 263.599 209.546 262.65 209.639 261.423C209.834 258.912 210.113 255.286 210.476 250.702L210.485 250.748C209.174 246.285 207.584 240.873 205.762 234.633L205.548 233.89L206.087 234.438C206.915 235.275 207.761 236.14 208.644 237.042H208.356C209.844 235.452 211.387 233.797 212.995 232.076L212.94 232.262C212.475 229.807 212.001 227.213 211.08 224.73C210.959 224.433 210.82 224.126 210.643 223.884C210.559 223.754 210.448 223.67 210.401 223.661C210.336 223.642 210.122 223.67 209.983 223.698C209.341 223.819 208.681 224.024 208.03 224.238C206.719 224.656 205.418 225.158 204.097 225.66L204.116 225.651C202.824 226.311 201.513 226.99 200.183 227.669L199.393 228.078L199.876 227.334C201.169 225.353 202.48 223.336 203.809 221.299L203.949 221.085L204.163 221.253C205.204 222.052 206.468 222.768 207.779 222.833C208.43 222.861 209.072 222.647 209.537 222.201C209.751 221.959 210.002 221.718 210.085 221.448C210.178 221.169 210.169 220.853 210.095 220.537C209.797 219.411 209.007 218.407 208.226 217.496C207.426 216.575 206.552 215.729 205.65 214.92C205.204 214.511 204.748 214.121 204.283 213.739C203.809 213.377 203.382 212.912 202.889 212.744C202.368 212.54 201.866 212.642 201.262 212.772C200.676 212.893 200.099 213.005 199.523 213.116L199.225 213.172L199.235 212.865C199.253 212.075 198.761 211.294 198.119 210.782C197.477 210.271 196.65 209.992 195.832 210.057C194.158 210.094 192.689 211.21 191.908 212.558L191.852 212.661L191.75 212.679C190.913 212.828 190.076 212.977 189.323 213.116H189.305H189.286C188.412 213.116 187.557 213.423 186.897 213.962C186.209 214.511 185.809 215.246 185.539 216.092C184.925 217.756 184.321 219.384 183.735 220.974C182.554 224.154 181.439 227.194 180.379 230.058L180.388 229.947C182.434 238.902 184.107 246.257 185.279 251.39C185.846 253.928 186.292 255.927 186.599 257.313C186.738 257.973 186.85 258.494 186.934 258.866C186.999 259.191 187.017 259.377 187.017 259.377Z\" fill=#EB996E /><path d=\"M203.811 232.703C203.765 232.6 205.494 231.67 207.884 230.508L209.399 229.773L208.144 230.899C207.819 231.187 207.531 231.549 207.307 231.968C206.936 232.665 206.787 233.437 206.843 234.116C206.898 234.804 207.131 235.399 207.391 235.855C207.94 236.775 208.544 237.129 208.498 237.194C208.488 237.24 207.782 236.989 207.103 236.041C206.777 235.576 206.48 234.934 206.396 234.162C206.313 233.4 206.461 232.526 206.88 231.745C207.131 231.271 207.465 230.861 207.837 230.545L208.088 230.936C205.671 232.052 203.858 232.805 203.811 232.703Z\" fill=#EB996E /><path d=\"M192.675 224.837C192.619 224.8 193.056 223.963 193.809 222.643C194.562 221.323 195.641 219.509 196.849 217.529C197.463 216.534 198.03 215.595 198.588 214.739C199.146 213.893 199.806 213.177 200.513 212.786C201.21 212.396 201.889 212.331 202.326 212.386C202.772 212.442 202.977 212.591 202.967 212.61C202.958 212.647 202.726 212.563 202.316 212.572C201.907 212.572 201.312 212.693 200.689 213.084C199.406 213.837 198.514 215.827 197.268 217.78C196.059 219.76 194.934 221.546 194.107 222.82C193.27 224.094 192.73 224.865 192.675 224.837Z\" fill=#EB996E /><path d=\"M185.481 224.793C185.426 224.765 185.677 224.012 186.169 222.812C186.662 221.622 187.387 219.985 188.261 218.228C189.135 216.461 189.991 214.899 190.642 213.783C191.292 212.667 191.739 212.007 191.795 212.035C191.85 212.072 191.516 212.788 190.939 213.941C190.279 215.262 189.526 216.768 188.689 218.433C187.871 220.106 187.127 221.622 186.476 222.942C185.909 224.114 185.546 224.821 185.481 224.793Z\" fill=#EB996E /><path d=\"M168.635 313.203C168.663 313.213 168.542 313.603 168.291 314.282C168.003 315.054 167.64 316.021 167.213 317.165C166.292 319.601 165.037 322.958 163.707 326.696C162.378 330.434 161.234 333.837 160.416 336.301C160.026 337.454 159.7 338.431 159.43 339.221C159.189 339.909 159.049 340.281 159.012 340.272C158.984 340.262 159.068 339.872 159.254 339.165C159.44 338.458 159.719 337.445 160.091 336.199C160.834 333.707 161.922 330.276 163.252 326.538C164.581 322.8 165.892 319.443 166.887 317.044C167.389 315.844 167.808 314.877 168.105 314.217C168.421 313.547 168.607 313.194 168.635 313.203Z\" fill=#EB996E /><path d=\"M199.711 340.706C199.721 340.706 199.711 340.799 199.693 340.984C199.665 341.189 199.628 341.459 199.581 341.784C199.479 342.519 199.33 343.551 199.135 344.853C198.93 346.182 198.688 347.819 198.307 349.697C197.926 351.576 197.415 353.714 196.559 355.983C195.695 358.243 194.411 360.642 192.459 362.743C190.534 364.854 188.154 366.807 185.393 368.443C182.631 370.089 179.489 371.363 176.132 372.293C174.44 372.739 172.664 373.037 170.851 373.037C169.028 373.046 167.188 372.702 165.43 372.089C161.906 370.805 158.978 368.434 156.802 365.71C154.589 362.994 153.018 359.963 151.8 357.015C150.582 354.04 149.866 351.083 149.029 348.386C148.192 345.68 147.411 343.16 146.704 340.854C145.263 336.251 144.166 332.504 143.487 329.891C143.143 328.589 142.892 327.566 142.734 326.878C142.66 326.553 142.604 326.293 142.558 326.088C142.52 325.911 142.502 325.818 142.511 325.818C142.52 325.818 142.548 325.902 142.604 326.079C142.66 326.283 142.734 326.534 142.827 326.86C143.032 327.576 143.311 328.58 143.664 329.845C144.408 332.439 145.552 336.158 147.03 340.752C147.764 343.049 148.555 345.569 149.419 348.265C150.284 350.971 151.009 353.919 152.227 356.848C153.445 359.768 154.998 362.753 157.183 365.412C159.331 368.081 162.185 370.387 165.607 371.633C167.318 372.237 169.094 372.572 170.86 372.554C172.627 372.563 174.365 372.275 176.02 371.837C179.34 370.926 182.454 369.671 185.179 368.062C187.903 366.454 190.274 364.547 192.18 362.474C194.105 360.419 195.378 358.085 196.252 355.862C197.126 353.631 197.656 351.511 198.056 349.651C198.456 347.782 198.726 346.155 198.958 344.825C199.181 343.523 199.367 342.5 199.488 341.766C199.553 341.44 199.6 341.18 199.646 340.975C199.683 340.789 199.702 340.706 199.711 340.706Z\" fill=#EB996E /><path class=fade-in-bottom opacity=0.4 d=\"M198.92 135.004L198.881 132.433C198.861 130.803 199.04 129.459 199.429 128.341C199.817 127.222 200.294 126.307 200.942 125.486C201.59 124.664 202.216 123.963 202.831 123.324C203.672 122.474 204.441 121.674 205.149 120.863C205.797 120.041 206.114 118.973 206.101 117.657C206.099 116.969 205.905 116.308 205.546 115.869C205.199 115.369 204.757 115.039 204.245 114.759C203.732 114.48 203.248 114.393 202.752 114.366C201.811 114.385 201.019 114.618 200.376 115.065C199.732 115.512 199.249 116.113 198.816 116.786C198.443 117.469 198.059 118.214 197.796 118.979L192.121 116.459C192.29 115.864 192.614 115.109 193.091 114.194C193.568 113.279 194.237 112.336 195.089 111.426C195.94 110.516 197.084 109.721 198.398 109.019C199.762 108.388 201.385 108.054 203.278 107.957C205.161 107.92 206.797 108.213 208.317 108.799C209.838 109.385 211.04 110.352 211.934 111.638C212.829 112.924 213.322 114.702 213.376 116.838C213.424 118.66 213.224 120.125 212.714 121.221C212.265 122.329 211.656 123.283 210.947 124.094C210.239 124.904 209.541 125.655 208.844 126.405C208.3 126.995 207.756 127.585 207.323 128.258C206.829 128.92 206.434 129.724 206.15 130.611C205.865 131.498 205.741 132.539 205.765 133.794L205.773 134.796L198.92 135.004ZM202.574 145.291C201.38 145.327 200.432 145.031 199.671 144.394C198.91 143.757 198.496 142.932 198.499 141.87C198.491 140.868 198.836 139.992 199.584 139.313C200.331 138.634 201.277 138.241 202.411 138.195C203.545 138.148 204.481 138.504 205.242 139.141C205.993 139.839 206.407 140.664 206.415 141.666C206.411 142.728 206.077 143.544 205.391 144.234C204.643 144.912 203.708 145.245 202.574 145.291Z\" fill=#55A3F3 /><path d=\"M29.3592 331.168C28.5784 328.461 26.904 325.832 24.31 324.722C21.6119 323.559 18.4887 324.219 15.7385 325.225C12.9796 326.223 10.2728 327.568 7.34046 327.75C4.4081 327.932 1.10268 326.544 0.226439 323.741C-0.597746 321.112 0.989895 318.301 2.97662 316.384C7.1496 312.367 13.4308 310.657 19.0699 312.011C24.7091 313.364 29.5241 317.737 31.424 323.212\" fill=#979797 /><path d=\"M52.5766 342.937C56.8711 338.85 56.6629 331.744 54.52 326.217C52.3771 320.691 47.7009 316.448 42.4695 313.645C32.3364 308.222 19.67 307.815 9.21582 312.569C14.3605 312.743 19.3229 315.658 21.9777 320.066C24.3375 323.979 24.858 328.725 26.8013 332.855C28.9702 337.453 32.9437 341.176 37.6806 343.024C42.4175 344.881 47.8658 344.846 52.5766 342.937Z\" fill=#B4B4B4 /><path d=\"M54.6408 318.406C59.3951 312.793 60.0284 303.769 59.3344 296.446C58.6316 289.115 56.9312 281.74 58.0937 274.469C58.7791 270.165 60.4535 266.053 61.0174 261.723C61.5813 257.402 60.7832 252.509 57.4344 249.715C53.5824 246.505 47.5181 247.259 43.51 250.279C39.5018 253.29 37.1855 258.027 35.485 262.738C31.7545 273.098 30.3924 284.594 33.4549 295.171C36.5174 305.747 43.7009 315.205 54.2418 318.398\" fill=#B4B4B4 /><path d=\"M56.9282 364.484C56.9456 364.484 56.9456 364.258 56.9456 363.833C56.9369 363.408 56.9456 362.783 56.9109 361.976C56.8501 360.362 56.694 358.037 56.3383 355.174C55.9739 352.311 55.41 348.918 54.5077 345.213C53.6228 341.5 52.1046 337.535 49.9617 333.682C47.8101 329.821 45.1901 326.498 42.5353 323.748C39.8719 321.006 37.1564 318.863 34.7446 317.275C33.556 316.451 32.4022 315.826 31.4132 315.254C30.3981 314.724 29.5132 314.282 28.7844 313.935C28.0644 313.631 27.5004 313.397 27.0753 313.215C26.6849 313.058 26.4767 312.98 26.468 312.989C26.4594 312.998 26.6589 313.102 27.0406 313.284C27.4571 313.475 28.0123 313.744 28.715 314.065C29.4264 314.438 30.3027 314.889 31.3004 315.436C32.272 316.026 33.4086 316.668 34.5798 317.501C36.9482 319.115 39.6377 321.258 42.2577 323.999C44.8777 326.741 47.4718 330.047 49.606 333.873C53.9785 341.526 55.1757 349.578 56.0433 355.217C56.4424 358.063 56.6332 360.388 56.746 361.994C56.7894 362.766 56.8241 363.382 56.8588 363.842C56.8935 364.267 56.9195 364.484 56.9282 364.484Z\" fill=#263238 /><path d=\"M97.9617 296.244C106.767 301.554 106.741 306.396 105.267 310.959C103.8 315.523 98.3955 318.69 93.9102 316.981C91.3769 316.018 89.5463 313.814 87.976 311.602C86.4057 309.389 84.9396 307.02 82.7446 305.433C80.5497 303.845 77.3657 303.237 75.1621 304.808\" fill=#979797 /><path d=\"M104.557 302.066C102.258 298.882 96.5668 297.962 92.9751 299.55C89.3833 301.138 86.7546 304.287 84.4035 307.428C82.0524 310.569 79.7534 313.892 76.5 316.079C73.238 318.265 68.6833 319.055 65.4299 316.851C63.2957 315.402 62.0551 312.886 61.6734 310.343C61.283 307.793 61.656 305.19 62.1939 302.665C62.9747 298.969 64.2413 295.116 67.1911 292.774C70.4878 290.162 75.0512 290.032 79.2589 290.171C84.0825 290.327 88.9756 290.691 93.5043 292.366C98.0156 294.032 102.631 297.641 104.557 302.066Z\" fill=#B4B4B4 /><path d=\"M64.2399 357.442C64.2486 357.442 64.2572 357.373 64.2659 357.251C64.2746 357.104 64.2833 356.913 64.2919 356.687C64.3093 356.158 64.3353 355.429 64.37 354.501C64.4221 352.566 64.5002 349.833 64.6043 346.467C64.7084 343.074 64.8472 339.039 65.0901 334.554C65.3417 330.077 65.6714 325.148 66.3568 320.029C66.7038 317.47 67.1029 314.971 67.8143 312.654C68.5257 310.338 69.48 308.177 70.5124 306.199C71.5535 304.221 72.6986 302.425 73.9132 300.854C75.1365 299.284 76.3945 297.922 77.6264 296.776C80.125 294.495 82.5108 293.098 84.2199 292.282C84.6537 292.082 85.0267 291.892 85.3651 291.753C85.6948 291.623 85.981 291.51 86.224 291.423C86.4409 291.336 86.6144 291.267 86.7532 291.206C86.8746 291.154 86.9267 291.128 86.9267 291.119C86.9267 291.111 86.8573 291.128 86.7358 291.163C86.5883 291.206 86.4148 291.267 86.1979 291.336C85.955 291.423 85.66 291.519 85.3217 291.64C84.9747 291.77 84.5929 291.952 84.1592 292.135C82.424 292.907 79.9949 294.278 77.4442 296.56C76.1863 297.705 74.9023 299.076 73.653 300.646C72.4123 302.225 71.2498 304.03 70.1827 306.017C69.133 308.012 68.17 310.182 67.4412 312.524C66.7125 314.884 66.3047 317.392 65.9577 319.96C65.2723 325.105 64.9513 330.033 64.7257 334.519C64.5002 339.005 64.3874 343.048 64.318 346.44C64.2486 349.833 64.2225 352.583 64.2139 354.484C64.2139 355.412 64.2139 356.141 64.2139 356.67C64.2139 356.904 64.2225 357.086 64.2225 357.243C64.2225 357.373 64.2312 357.442 64.2399 357.442Z\" fill=#263238 /><path d=\"M61.0722 361.413C61.0722 361.413 61.5667 360.103 62.0352 357.63C62.495 355.157 62.842 351.496 62.4343 347.01C62.0612 342.524 60.9074 337.249 59.0768 331.601C57.2723 325.935 54.8171 319.879 52.7262 313.371C51.6852 310.109 50.8003 306.89 50.2016 303.723C49.5857 300.556 49.2039 297.467 48.9523 294.517C48.4578 288.609 48.5272 283.255 48.6747 278.778C48.8309 274.293 49.0651 270.666 49.2126 268.167C49.282 266.935 49.3427 265.963 49.3861 265.278C49.4035 264.965 49.4122 264.714 49.4208 264.523C49.4295 264.349 49.4295 264.263 49.4208 264.263C49.4122 264.263 49.4035 264.349 49.3861 264.514C49.3688 264.705 49.3427 264.948 49.308 265.26C49.2473 265.946 49.1692 266.909 49.0651 268.141C48.8656 270.64 48.588 274.267 48.3971 278.761C48.2149 283.247 48.1195 288.609 48.5966 294.544C48.8309 297.511 49.2126 300.608 49.8286 303.793C50.4359 306.977 51.3208 310.213 52.3619 313.484C54.4614 320.018 56.9253 326.065 58.7471 331.713C60.5864 337.344 61.7576 342.576 62.174 347.036C62.6078 351.496 62.3042 355.14 61.8964 357.604C61.6795 358.836 61.48 359.79 61.3065 360.433C61.2284 360.736 61.1763 360.979 61.1329 361.161C61.0896 361.326 61.0722 361.413 61.0722 361.413Z\" fill=#263238 /><path d=\"M39.2549 365.399H80.5856L81.5313 357.442H39.2549V365.399Z\" fill=#455A64 /><path d=\"M76.1449 364.486L70.9742 388.364H48.513L43.6807 364.486H76.1449Z\" fill=#455A64 /><path d=\"M39.2549 365.397C39.2549 365.51 48.347 365.571 59.5472 365.536C70.7561 365.501 79.8482 365.388 79.8482 365.284C79.8482 365.172 70.7648 365.111 59.5472 365.145C48.3383 365.172 39.2549 365.284 39.2549 365.397Z\" fill=#455A64 /><path d=\"M46.3445 377.182C46.3965 377.26 47.5677 376.063 49.9882 375.091C51.1855 374.614 52.7124 374.241 54.4128 374.206C56.1219 374.154 57.9785 374.562 59.8524 375.204C61.7351 375.837 63.4962 376.583 65.214 376.991C66.9318 377.364 68.5368 377.338 69.8468 377.13C71.1568 376.922 72.1718 376.54 72.8225 376.184C73.1435 376.002 73.3864 375.854 73.5426 375.724C73.6988 375.611 73.7768 375.542 73.7682 375.533C73.7421 375.499 73.4125 375.742 72.7618 376.045C72.1024 376.349 71.0961 376.687 69.8121 376.852C68.5281 377.017 66.9665 377.017 65.3007 376.635C63.6437 376.219 61.8912 375.473 59.9913 374.831C58.1 374.18 56.174 373.763 54.4128 373.841C52.6517 373.902 51.1074 374.31 49.8928 374.839C48.6695 375.351 47.776 375.958 47.1947 376.41C46.8997 376.635 46.6915 376.826 46.5527 376.965C46.4052 377.095 46.3358 377.173 46.3445 377.182Z\" fill=#263238 /><path d=\"M46.6659 378.778C46.7179 378.856 47.8457 377.693 50.1621 376.721C51.316 376.244 52.7822 375.871 54.4305 375.845C56.0789 375.802 57.8834 376.175 59.6967 376.791C61.5185 377.398 63.2276 378.11 64.8587 378.544C66.4897 378.986 68.0253 379.142 69.3093 379.047C70.5933 378.96 71.591 378.596 72.2243 378.266C72.5366 378.092 72.7708 377.945 72.9183 377.823C73.0658 377.711 73.1439 377.65 73.1352 377.633C73.1092 377.598 72.7969 377.832 72.1549 378.127C71.5129 378.405 70.5325 378.717 69.2832 378.769C68.0339 378.83 66.5417 378.656 64.9454 378.197C63.3491 377.745 61.6487 377.034 59.8094 376.418C57.9789 375.793 56.1136 375.411 54.4132 375.481C52.7128 375.533 51.2119 375.941 50.0407 376.47C48.8608 376.982 48.0192 377.589 47.464 378.032C47.1864 378.249 46.9782 378.439 46.848 378.57C46.7179 378.691 46.6572 378.76 46.6659 378.778Z\" fill=white /><path d=\"M45.9324 375.591C45.9844 375.67 47.199 374.446 49.6716 373.388C50.9035 372.867 52.4478 372.398 54.2089 372.294C55.9701 372.173 57.8874 372.624 59.8221 373.283C61.7741 373.934 63.5786 374.732 65.3658 375.097C67.153 375.418 68.8013 375.322 70.1461 375.106C71.4908 374.871 72.5405 374.489 73.2172 374.134C73.5469 373.952 73.8072 373.795 73.9633 373.674C74.1282 373.552 74.2063 373.483 74.1976 373.474C74.1716 373.44 73.8332 373.691 73.1565 373.995C72.4711 374.299 71.4301 374.637 70.1114 374.828C68.7927 375.01 67.1703 375.071 65.4439 374.741C63.7261 374.377 61.9129 373.57 59.9522 372.91C58.0002 372.242 56.0135 371.782 54.1916 371.93C52.3784 372.06 50.7994 372.563 49.5675 373.127C48.3182 373.683 47.4072 374.325 46.8086 374.784C46.505 375.019 46.2881 375.218 46.1493 375.357C45.9931 375.505 45.9237 375.583 45.9324 375.591Z\" fill=white /><path d=\"M38.8818 365.432C38.8818 365.545 48.1821 365.631 59.6513 365.631C71.1205 365.631 80.4208 365.545 80.4208 365.432C80.4208 365.319 71.1205 365.232 59.6513 365.232C48.1734 365.232 38.8818 365.319 38.8818 365.432Z\" fill=#263238 /><path opacity=0.4 d=\"M296.58 180.918L296.191 178.921C295.947 177.654 295.899 176.583 296.045 175.657C296.191 174.732 296.434 173.952 296.824 173.222C297.214 172.491 297.603 171.858 297.993 171.273C298.529 170.494 299.016 169.763 299.454 169.033C299.844 168.302 299.941 167.425 299.746 166.403C299.649 165.867 299.405 165.38 299.064 165.087C298.723 164.746 298.334 164.552 297.895 164.405C297.457 164.259 297.067 164.259 296.678 164.308C295.947 164.454 295.363 164.746 294.924 165.185C294.486 165.623 294.194 166.159 293.95 166.744C293.756 167.328 293.561 167.961 293.463 168.594L288.69 167.425C288.739 166.938 288.885 166.305 289.129 165.526C289.372 164.746 289.762 163.918 290.298 163.09C290.833 162.262 291.613 161.483 292.538 160.752C293.512 160.07 294.73 159.583 296.191 159.242C297.652 158.95 298.967 158.95 300.233 159.194C301.499 159.437 302.571 160.022 303.448 160.898C304.324 161.775 304.957 163.09 305.298 164.746C305.591 166.159 305.639 167.328 305.396 168.253C305.201 169.179 304.86 170.007 304.422 170.738C303.983 171.468 303.545 172.15 303.107 172.832C302.766 173.368 302.425 173.904 302.181 174.488C301.889 175.073 301.694 175.755 301.597 176.485C301.499 177.216 301.548 178.044 301.743 179.018L301.889 179.798L296.58 180.918ZM300.866 188.419C299.941 188.614 299.162 188.516 298.48 188.127C297.798 187.737 297.36 187.153 297.214 186.325C297.067 185.545 297.214 184.815 297.701 184.181C298.188 183.548 298.869 183.11 299.746 182.915C300.623 182.72 301.402 182.866 302.084 183.256C302.766 183.694 303.204 184.279 303.35 185.058C303.496 185.886 303.35 186.568 302.912 187.201C302.425 187.835 301.743 188.224 300.866 188.419Z\" fill=#55A3F3 /><path opacity=0.4 d=\"M99.6392 217.492L98.8599 215.788C98.3729 214.716 98.0806 213.742 98.0319 212.914C97.9832 212.086 98.0319 211.306 98.2268 210.576C98.4216 209.894 98.6164 209.212 98.8599 208.627C99.2008 207.848 99.4443 207.069 99.6879 206.338C99.8827 205.607 99.7853 204.828 99.3956 203.951C99.2008 203.464 98.8599 203.123 98.519 202.928C98.1293 202.734 97.7397 202.587 97.3014 202.587C96.8631 202.539 96.5221 202.636 96.1812 202.782C95.5481 203.075 95.1097 203.464 94.8175 203.951C94.5253 204.438 94.3792 204.974 94.2818 205.51C94.2331 206.095 94.1844 206.679 94.2331 207.264L89.7523 207.215C89.7036 206.776 89.7036 206.192 89.7523 205.413C89.8011 204.682 89.9959 203.854 90.2881 202.977C90.5803 202.1 91.116 201.272 91.7979 200.444C92.4797 199.616 93.4538 198.934 94.7201 198.35C95.9377 197.814 97.1553 197.473 98.3242 197.473C99.493 197.424 100.565 197.717 101.539 198.35C102.513 198.934 103.341 199.957 103.974 201.37C104.509 202.539 104.802 203.562 104.802 204.438C104.802 205.315 104.704 206.095 104.461 206.825C104.217 207.556 103.974 208.238 103.73 208.968C103.535 209.504 103.389 210.04 103.243 210.673C103.097 211.258 103.097 211.891 103.146 212.573C103.195 213.255 103.438 213.985 103.828 214.813L104.12 215.495L99.6392 217.492ZM104.997 223.24C104.217 223.581 103.487 223.679 102.805 223.484C102.123 223.289 101.636 222.85 101.295 222.169C101.003 221.487 101.003 220.853 101.295 220.171C101.587 219.49 102.123 219.002 102.854 218.613C103.584 218.272 104.315 218.223 104.997 218.418C105.678 218.661 106.165 219.1 106.506 219.782C106.799 220.464 106.847 221.146 106.555 221.779C106.312 222.412 105.776 222.899 104.997 223.24Z\" fill=#55A3F3 /><g opacity=0.03><path opacity=0.4 d=\"M300.118 219.854L300.313 218.588C300.459 217.808 300.654 217.127 300.946 216.639C301.238 216.152 301.579 215.714 301.92 215.373C302.309 215.032 302.65 214.74 303.04 214.496C303.527 214.155 303.965 213.814 304.355 213.522C304.745 213.181 304.988 212.694 305.086 212.061C305.134 211.72 305.086 211.428 304.988 211.135C304.842 210.892 304.696 210.648 304.452 210.453C304.209 210.259 304.014 210.161 303.771 210.112C303.332 210.015 302.894 210.064 302.553 210.259C302.212 210.405 301.92 210.648 301.676 210.94C301.433 211.233 301.189 211.574 300.994 211.915L298.462 210.21C298.608 209.918 298.852 209.625 299.144 209.187C299.436 208.797 299.874 208.408 300.361 208.018C300.848 207.628 301.482 207.336 302.163 207.141C302.894 206.946 303.673 206.946 304.599 207.092C305.524 207.239 306.303 207.531 306.985 207.969C307.667 208.408 308.154 208.943 308.495 209.674C308.836 210.405 308.884 211.281 308.738 212.304C308.592 213.181 308.349 213.863 308.056 214.35C307.716 214.837 307.375 215.276 306.936 215.568C306.547 215.86 306.108 216.201 305.719 216.493C305.427 216.737 305.086 216.98 304.793 217.273C304.501 217.565 304.258 217.906 304.014 218.296C303.819 218.685 303.624 219.221 303.527 219.806L303.43 220.293L300.118 219.854ZM300.994 225.115C300.41 225.017 299.972 224.774 299.68 224.433C299.387 224.043 299.241 223.605 299.339 223.118C299.436 222.631 299.679 222.241 300.118 221.949C300.556 221.656 301.043 221.608 301.579 221.656C302.115 221.754 302.553 221.997 302.845 222.387C303.137 222.777 303.284 223.215 303.186 223.702C303.089 224.189 302.845 224.579 302.456 224.823C302.066 225.115 301.579 225.212 300.994 225.115Z\" fill=#55A3F3 /></g><g opacity=0.03><path opacity=0.4 d=\"M105.337 189.144L105.288 187.878C105.288 187.099 105.337 186.417 105.532 185.881C105.727 185.345 105.97 184.858 106.262 184.517C106.555 184.127 106.847 183.786 107.188 183.445C107.626 183.056 107.967 182.617 108.308 182.228C108.649 181.838 108.795 181.302 108.746 180.669C108.746 180.328 108.649 180.036 108.454 179.792C108.259 179.549 108.064 179.403 107.821 179.256C107.577 179.11 107.334 179.062 107.09 179.062C106.652 179.062 106.262 179.208 105.921 179.403C105.629 179.646 105.386 179.89 105.191 180.231C104.996 180.572 104.85 180.913 104.704 181.302L101.928 180.084C102.025 179.792 102.171 179.451 102.415 178.964C102.658 178.526 102.951 178.039 103.389 177.6C103.827 177.162 104.363 176.772 104.996 176.431C105.629 176.09 106.408 175.944 107.334 175.896C108.259 175.896 109.038 175.993 109.769 176.285C110.5 176.577 111.084 177.016 111.522 177.649C111.961 178.282 112.204 179.11 112.253 180.182C112.253 181.059 112.155 181.741 111.961 182.325C111.717 182.861 111.474 183.348 111.133 183.738C110.792 184.127 110.451 184.517 110.11 184.858C109.866 185.15 109.574 185.442 109.379 185.783C109.136 186.124 108.941 186.514 108.844 186.952C108.698 187.391 108.649 187.878 108.649 188.511V188.998L105.337 189.144ZM107.139 194.113C106.555 194.113 106.116 193.967 105.727 193.674C105.337 193.382 105.142 192.992 105.142 192.457C105.142 191.97 105.288 191.531 105.678 191.19C106.019 190.849 106.506 190.654 107.042 190.654C107.577 190.654 108.064 190.8 108.405 191.141C108.795 191.482 108.941 191.872 108.99 192.359C108.99 192.846 108.844 193.285 108.503 193.577C108.162 193.967 107.723 194.113 107.139 194.113Z\" fill=#55A3F3 /></g></g><defs><clipPath id=clip0><rect width=388 height=390 fill=white /></clipPath></defs></svg> <svg class=welcome-mobile-image width=388 height=390 viewBox=\"0 80 388 313\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0)><path d=\"M83.9443 358.781V388.337H127.16H174.825V358.781H83.9443Z\" fill=#F5F5F5 /><path d=\"M80.1309 350.521V358.782H177.998V350.521H127.159H80.1309Z\" fill=#E0E0E0 /><path d=\"M129.064 388.338H174.825V358.782H178.001V350.521H127.161V358.021L129.064 388.338Z\" fill=#E0E0E0 /><path d=\"M115.079 363.551H96.6494V367.999H115.079V363.551Z\" fill=#E0E0E0 /><path d=\"M117.94 373.561H94.2734V382.956H117.94V373.561Z\" fill=white /><path d=\"M94.373 327.821V350.521H127.572H164.182V327.821H94.373Z\" fill=#F5F5F5 /><path d=\"M91.4492 321.472V327.823H166.626V321.472H127.574H91.4492Z\" fill=#E0E0E0 /><path d=\"M129.048 350.523H164.191V327.823H166.633V321.472H127.581V327.235L129.048 350.523Z\" fill=#EBEBEB /><path d=\"M118.301 331.481H104.147V334.899H118.301V331.481Z\" fill=#E0E0E0 /><path d=\"M120.5 339.168H102.319V346.384H120.5V339.168Z\" fill=white /><g opacity=0.5><path opacity=0.2 d=\"M275.525 387.413C256.152 374.178 251.531 349.278 252.057 326.851C252.144 323.106 251.688 319.168 253.442 315.861C255.188 312.563 259.318 310.274 262.686 311.818C265.475 313.098 266.72 316.317 268.307 318.975C270.412 322.509 273.526 325.421 277.174 327.263C279.568 328.473 282.523 329.201 284.865 327.877C288.075 326.061 288.408 321.597 288.347 317.878C288.233 310.941 288.119 304.003 288.005 297.065C287.943 293.347 287.891 289.54 289.013 285.997C290.136 282.453 292.662 279.147 296.187 278.112C299.721 277.086 304.115 279.076 304.904 282.716C305.229 284.225 304.939 285.804 305.062 287.347C305.185 288.891 305.922 290.593 307.395 291.005C308.886 291.426 310.359 290.356 311.464 289.251C315.27 285.453 317.822 280.585 320.208 275.744C322.593 270.902 324.909 265.947 328.355 261.816C331.802 257.676 336.59 254.378 341.913 254.027C347.246 253.668 352.955 256.904 354.358 262.123C355.761 267.359 352.762 272.709 349.473 276.998C344.597 283.348 338.809 288.987 332.345 293.671C331.179 294.513 329.916 295.425 329.486 296.811C328.706 299.302 331.083 301.74 333.538 302.53C336.318 303.424 339.326 303.108 342.238 303.415C345.141 303.731 348.298 304.977 349.429 307.704C350.99 311.493 347.851 315.51 344.746 318.159C338.528 323.457 331.416 327.658 323.812 330.535C321.085 331.561 318.208 332.473 316.025 334.42C313.841 336.367 312.543 339.726 313.902 342.331C315.262 344.945 318.699 345.743 321.558 345.182C324.417 344.62 326.97 343.033 329.697 341.98C334.792 339.998 341.405 340.279 344.72 344.664C346.904 347.55 347.132 351.593 346.079 355.066C345.027 358.54 342.852 361.548 340.528 364.328C332.433 374.029 322.014 381.887 310.193 386.124C298.344 390.378 287.356 391.605 275.525 387.413Z\" fill=#2DC0DA /><path d=\"M281.162 373.295C284.346 361.946 288.862 349.798 294.028 337.247C295.334 334.116 296.615 331.02 297.886 327.968C299.158 324.924 300.421 321.907 301.842 319.039C304.648 313.277 307.788 307.953 310.927 302.989C314.067 298.024 317.224 293.429 320.206 289.148C323.205 284.877 326.064 280.948 328.835 277.475C334.343 270.511 339.447 265.432 343.087 262.091C344.902 260.415 346.358 259.152 347.358 258.319C347.84 257.924 348.217 257.609 348.498 257.372C348.761 257.161 348.892 257.056 348.901 257.065C348.91 257.074 348.787 257.197 348.542 257.425C348.27 257.67 347.91 258.003 347.445 258.424C346.481 259.293 345.051 260.582 343.262 262.292C339.684 265.695 334.65 270.809 329.204 277.782C326.468 281.264 323.635 285.193 320.662 289.473C317.698 293.762 314.567 298.367 311.445 303.322C308.331 308.277 305.209 313.593 302.429 319.329C301.026 322.188 299.772 325.179 298.5 328.231C297.237 331.283 295.948 334.371 294.65 337.502C289.494 350.035 284.968 362.156 281.758 373.462\" fill=#E0E0E0 /><path d=\"M302.031 319.009C301.987 319.017 301.855 318.456 301.653 317.421C301.443 316.395 301.197 314.904 300.917 313.044C300.356 309.343 299.75 304.203 299.101 298.538C298.452 292.872 297.777 287.758 297.163 284.075C296.856 282.233 296.593 280.742 296.4 279.715C296.216 278.689 296.128 278.11 296.172 278.102C296.216 278.093 296.392 278.645 296.655 279.654C296.926 280.663 297.269 282.145 297.628 283.978C298.374 287.653 299.128 292.775 299.777 298.45C300.399 304.046 300.961 309.106 301.39 312.965C301.592 314.711 301.767 316.184 301.908 317.36C302.031 318.421 302.074 319 302.031 319.009Z\" fill=#E0E0E0 /><path d=\"M349.793 309.57C349.793 309.614 349.117 309.702 347.89 309.816C346.662 309.938 344.89 310.105 342.698 310.386C338.322 310.903 332.297 311.833 325.702 313.148C319.098 314.473 313.178 315.929 308.934 317.104C306.802 317.674 305.092 318.192 303.908 318.534C302.724 318.885 302.058 319.06 302.049 319.007C302.032 318.963 302.672 318.7 303.829 318.271C304.996 317.85 306.688 317.262 308.811 316.63C313.038 315.332 318.966 313.797 325.588 312.464C332.209 311.149 338.26 310.289 342.672 309.894C344.873 309.675 346.662 309.588 347.898 309.544C349.1 309.517 349.784 309.517 349.793 309.57Z\" fill=#E0E0E0 /><path d=\"M281.745 372.406C281.727 372.414 281.613 372.213 281.411 371.827C281.183 371.362 280.911 370.792 280.578 370.108C279.859 368.608 278.877 366.415 277.693 363.679C275.325 358.223 272.299 350.575 269.063 342.103C265.827 333.621 262.872 325.956 260.627 320.456C259.522 317.781 258.618 315.58 257.943 313.948C257.654 313.238 257.417 312.65 257.224 312.177C257.066 311.764 256.996 311.545 257.013 311.536C257.031 311.528 257.145 311.729 257.347 312.115C257.575 312.58 257.847 313.15 258.18 313.834C258.899 315.334 259.881 317.527 261.065 320.263C263.433 325.719 266.459 333.367 269.695 341.848C272.922 350.33 275.878 357.986 278.131 363.486C279.236 366.161 280.14 368.362 280.815 369.994C281.104 370.704 281.341 371.292 281.534 371.765C281.692 372.178 281.762 372.397 281.745 372.406Z\" fill=#E0E0E0 /><path d=\"M345.116 351.254C345.125 351.28 344.905 351.368 344.485 351.517C343.985 351.692 343.379 351.903 342.643 352.157C340.941 352.727 338.644 353.499 335.855 354.438C330.128 356.358 322.244 359.112 313.535 362.165C304.827 365.217 296.908 367.892 291.137 369.699C288.252 370.602 285.91 371.313 284.279 371.769C283.525 371.97 282.902 372.146 282.402 372.286C281.972 372.4 281.736 372.444 281.736 372.418C281.727 372.391 281.946 372.304 282.367 372.146C282.858 371.979 283.472 371.769 284.209 371.506C285.91 370.935 288.199 370.164 290.997 369.225C296.723 367.304 304.608 364.55 313.325 361.498C322.033 358.446 329.944 355.771 335.723 353.964C338.609 353.061 340.95 352.35 342.581 351.894C343.336 351.692 343.958 351.517 344.458 351.377C344.879 351.28 345.107 351.236 345.116 351.254Z\" fill=#E0E0E0 /></g><path d=\"M18.903 198.638L25.8316 207.175C26.0981 207.495 26.4978 207.672 26.9153 207.637L37.8766 206.766C38.9248 206.686 39.6088 207.832 39.0403 208.712L33.0622 217.942C32.8401 218.288 32.7957 218.733 32.9556 219.115L37.166 229.277C37.5657 230.246 36.6863 231.259 35.6737 230.983L25.0499 228.149C24.6502 228.043 24.2149 228.14 23.904 228.407L15.5453 235.549C14.7459 236.233 13.52 235.7 13.4579 234.652L12.8716 223.672C12.8538 223.254 12.6229 222.881 12.2676 222.659L2.88734 216.92C1.99018 216.37 2.11453 215.037 3.09164 214.664L13.3513 210.711C13.7421 210.56 14.0263 210.231 14.1241 209.822L16.6912 199.126C16.9399 198.114 18.2457 197.821 18.903 198.638Z\" fill=#E0E0E0 /><path class=fade-in opacity=0.1 d=\"M200.387 174.634C224.902 174.634 244.775 154.76 244.775 130.243C244.775 105.726 224.902 85.8516 200.387 85.8516C175.873 85.8516 156 105.726 156 130.243C156 154.76 175.873 174.634 200.387 174.634Z\" fill=#2DC0DA /><path d=\"M179.909 250.767C179.909 250.767 179.444 250.925 178.608 251.204C172.806 253.166 155.54 258.876 150.314 261.005C150.314 261.005 159.556 342.75 160.644 350.347C161.732 357.944 162.002 388.332 162.002 388.332H260.317C260.317 388.332 260.056 306.411 260.335 293.699C260.707 277.259 262.743 260.996 262.743 260.996L245.57 254.282L225.496 243.7L179.909 250.767Z\" fill=#2DC0DA /><g opacity=0.3><path opacity=0.3 d=\"M201.77 268.455C193.746 298.267 185.285 327.957 176.406 357.518C175.355 361.005 174.314 364.827 175.736 368.183C177.001 371.178 180.106 373.149 183.323 373.577C186.54 374.004 189.832 373.056 192.668 371.475C199.316 367.765 203.63 360.782 205.75 353.473C207.87 346.164 208.065 338.456 208.232 330.84C208.697 310.55 209.162 290.251 209.627 269.961L201.77 268.455Z\" fill=black /></g><path d=\"M150.319 261.007C150.319 261.007 135.898 267.395 137.023 293.022C137.786 310.457 140.436 326.404 140.436 326.404L180.984 314.725L170.672 270.222L150.319 261.007Z\" fill=#2DC0DA /><path d=\"M246.485 302.256L244.318 331.835L285.08 318.631C285.08 318.631 276.34 266.419 262.496 261.007L247.573 286.513L246.485 302.256Z\" fill=#2DC0DA /><path d=\"M251.132 293.706C251.151 293.706 251.179 293.911 251.207 294.31C251.235 294.757 251.281 295.333 251.328 296.04C251.411 297.602 251.532 299.769 251.681 302.41C251.951 307.784 252.239 315.223 252.499 323.434C252.759 331.617 253.001 339.028 253.178 344.458C253.262 347.108 253.327 349.266 253.373 350.828C253.382 351.544 253.401 352.111 253.401 352.557C253.401 352.957 253.392 353.162 253.382 353.162C253.364 353.162 253.336 352.957 253.308 352.557C253.28 352.111 253.234 351.535 253.187 350.828C253.104 349.266 252.983 347.108 252.834 344.458C252.564 339.084 252.276 331.645 252.016 323.434C251.755 315.251 251.514 307.84 251.337 302.41C251.253 299.76 251.188 297.602 251.142 296.04C251.132 295.324 251.114 294.757 251.104 294.31C251.104 293.911 251.114 293.706 251.132 293.706Z\" fill=#263238 /><path d=\"M170.497 281.257C170.47 281.275 170.284 280.931 169.967 280.318C169.614 279.602 169.168 278.727 168.656 277.695C167.531 275.501 165.969 272.432 163.58 269.531C161.19 266.63 158.308 264.677 156.03 263.775C153.752 262.845 152.181 262.799 152.199 262.697C152.199 262.669 152.59 262.659 153.278 262.743C153.975 262.817 154.97 263.031 156.151 263.459C158.513 264.296 161.506 266.258 163.943 269.224C166.379 272.181 167.913 275.306 168.954 277.547C169.475 278.672 169.865 279.602 170.135 280.243C170.395 280.875 170.525 281.238 170.497 281.257Z\" fill=#263238 /><path d=\"M255.888 259.761C256.027 259.836 254.354 262.7 253.322 266.605C252.252 270.501 252.271 273.821 252.113 273.812C252.057 273.812 251.973 272.984 252.029 271.645C252.085 270.306 252.317 268.455 252.847 266.475C253.377 264.494 254.112 262.774 254.735 261.593C255.358 260.403 255.841 259.724 255.888 259.761Z\" fill=#263238 /><path d=\"M165.228 272.5C165.228 272.527 165.079 272.49 164.828 272.546C164.577 272.593 164.224 272.797 163.936 273.197C163.629 273.597 163.434 274.164 163.313 274.889C163.238 275.243 163.173 275.633 163.015 276.042C162.867 276.442 162.616 276.87 162.188 277.149C161.305 277.735 160.077 277.474 159.175 276.823C158.236 276.135 157.688 275.057 157.018 274.08C156.684 273.588 156.302 273.132 155.81 272.788C155.326 272.444 154.74 272.193 154.155 272.221C153.569 272.248 153.03 272.62 152.732 273.141C152.434 273.68 152.351 274.359 152.304 275.038C152.258 275.726 152.248 276.424 152.165 277.112C152.081 277.8 151.923 278.516 151.505 279.111C151.412 279.269 151.282 279.39 151.151 279.52C151.03 279.65 150.882 279.762 150.724 279.845C150.417 280.022 150.063 280.124 149.719 280.162C149.031 280.227 148.371 280.069 147.795 279.799C146.623 279.222 145.898 278.246 145.229 277.419C144.569 276.572 143.927 275.819 143.183 275.336C142.458 274.843 141.63 274.62 140.961 274.75C140.292 274.889 139.799 275.317 139.52 275.717C139.241 276.126 139.185 276.526 139.213 276.777C139.232 277.037 139.297 277.167 139.269 277.177C139.269 277.177 139.166 277.065 139.111 276.786C139.055 276.517 139.083 276.07 139.352 275.605C139.631 275.159 140.133 274.666 140.887 274.48C141.649 274.303 142.551 274.527 143.35 275.038C144.159 275.54 144.857 276.321 145.526 277.158C146.205 277.976 146.93 278.897 147.971 279.39C148.492 279.632 149.078 279.762 149.654 279.697C150.24 279.65 150.761 279.325 151.096 278.832C151.774 277.818 151.691 276.386 151.793 274.992C151.849 274.294 151.923 273.56 152.286 272.89C152.648 272.23 153.355 271.765 154.099 271.728C155.614 271.709 156.693 272.806 157.353 273.811C158.032 274.824 158.562 275.866 159.38 276.479C160.189 277.084 161.258 277.298 161.974 276.842C162.69 276.377 162.848 275.494 163.015 274.806C163.155 274.099 163.406 273.457 163.75 273.057C164.085 272.639 164.494 272.444 164.773 272.425C165.098 272.425 165.228 272.5 165.228 272.5Z\" fill=#FAFAFA /><path d=\"M173.471 286.218C173.48 286.218 173.508 286.404 173.49 286.748C173.462 287.101 173.341 287.622 172.988 288.199C172.644 288.775 172.039 289.38 171.156 289.798C170.301 290.198 169.064 290.356 167.967 289.752C166.879 289.222 165.968 288.189 164.703 287.836C163.42 287.455 162.035 288.338 161.226 289.575C160.38 290.821 160.036 292.457 159.18 293.982C158.743 294.745 158.13 295.442 157.33 295.907C156.549 296.391 155.471 296.558 154.569 296.13C153.676 295.703 153.09 294.912 152.635 294.159C152.17 293.397 151.789 292.634 151.324 291.955C150.868 291.267 150.273 290.719 149.557 290.523C148.841 290.31 148.079 290.514 147.474 290.933C146.238 291.779 145.531 293.108 144.973 294.354C144.397 295.6 143.876 296.8 143.225 297.804C141.97 299.887 139.971 300.789 138.651 300.817C137.972 300.854 137.461 300.696 137.145 300.557C136.977 300.492 136.875 300.408 136.791 300.371C136.717 300.324 136.68 300.296 136.68 300.287C136.698 300.213 137.331 300.743 138.632 300.64C139.897 300.547 141.766 299.664 142.928 297.637C143.541 296.651 144.034 295.47 144.601 294.206C145.159 292.96 145.866 291.528 147.223 290.579C147.884 290.105 148.813 289.845 149.669 290.096C150.543 290.328 151.231 290.988 151.705 291.704C152.198 292.42 152.588 293.201 153.035 293.927C153.481 294.652 154.02 295.349 154.755 295.703C155.508 296.056 156.372 295.926 157.079 295.507C157.795 295.098 158.362 294.457 158.762 293.759C159.58 292.337 159.933 290.691 160.845 289.342C161.3 288.682 161.877 288.106 162.574 287.743C163.253 287.371 164.09 287.26 164.796 287.464C165.512 287.659 166.089 288.069 166.609 288.44C167.13 288.822 167.613 289.194 168.116 289.463C169.11 290.031 170.217 289.91 171.044 289.566C171.872 289.203 172.467 288.645 172.82 288.115C173.545 287.008 173.397 286.199 173.471 286.218Z\" fill=#FAFAFA /><path d=\"M168.729 306.082C168.72 306.101 168.608 306.054 168.385 306.035C168.171 306.017 167.827 306.063 167.492 306.324C167.158 306.584 166.832 307.012 166.637 307.598C166.405 308.174 166.47 308.881 166.544 309.681C166.609 310.471 166.758 311.419 166.339 312.377C165.93 313.353 164.777 313.949 163.643 313.921C162.481 313.958 161.281 313.363 160.445 312.433C159.58 311.512 158.985 310.35 158.418 309.178L158.585 309.309C157.646 309.132 156.67 309.727 156.056 310.564C155.405 311.401 155.164 312.498 154.987 313.632C154.857 314.469 154.764 315.316 154.531 316.143C154.299 316.98 153.899 317.761 153.323 318.384C152.755 319.007 151.919 319.453 151.063 319.426C150.208 319.407 149.455 318.988 148.878 318.496C147.688 317.482 147.102 316.134 146.293 315.148C145.522 314.116 144.434 313.502 143.355 313.465C142.277 313.4 141.31 313.791 140.678 314.358C140.036 314.934 139.701 315.641 139.543 316.217C139.236 317.417 139.525 318.114 139.46 318.114C139.45 318.114 139.432 318.077 139.404 317.994C139.376 317.91 139.339 317.789 139.311 317.622C139.255 317.296 139.218 316.794 139.357 316.162C139.497 315.539 139.822 314.785 140.492 314.144C141.152 313.502 142.202 313.065 143.365 313.102C143.941 313.121 144.555 313.27 145.122 313.586C145.689 313.893 146.182 314.358 146.6 314.878C147.465 315.911 148.06 317.222 149.166 318.133C149.706 318.589 150.366 318.942 151.072 318.942C151.779 318.961 152.467 318.598 152.979 318.04C153.49 317.482 153.862 316.766 154.076 315.994C154.29 315.213 154.383 314.386 154.513 313.53C154.689 312.396 154.94 311.187 155.675 310.248C156.354 309.327 157.488 308.611 158.669 308.825L158.79 308.844L158.836 308.946C159.403 310.118 159.97 311.243 160.77 312.098C161.551 312.972 162.592 313.493 163.643 313.484C164.675 313.512 165.651 313.009 166.023 312.191C166.405 311.373 166.293 310.462 166.246 309.671C166.181 308.881 166.144 308.1 166.414 307.486C166.646 306.872 167.018 306.426 167.399 306.166C167.79 305.905 168.171 305.877 168.394 305.933C168.636 305.998 168.729 306.082 168.729 306.082Z\" fill=#FAFAFA /><path d=\"M281.6 302.147C281.6 302.175 281.424 302.175 281.135 302.277C280.838 302.38 280.429 302.631 280.085 303.124C279.741 303.607 279.453 304.295 279.257 305.132C279.071 305.96 278.969 306.992 278.467 308.015C278.225 308.517 277.863 309.047 277.286 309.372C276.719 309.698 275.957 309.735 275.315 309.428C274.673 309.121 274.199 308.573 273.818 307.987C273.428 307.401 273.121 306.732 272.832 306.081C272.544 305.448 272.135 304.835 271.633 304.323C271.131 303.83 270.443 303.43 269.773 303.607C269.085 303.756 268.639 304.407 268.509 305.169C268.36 305.932 268.397 306.75 268.388 307.596C268.36 309.289 267.867 311.037 266.687 312.236C265.534 313.408 263.721 313.938 262.27 313.296C260.848 312.655 260.001 311.483 259.053 310.656C258.142 309.781 256.998 309.298 255.976 309.586C254.962 309.847 254.218 310.563 253.763 311.26C253.298 311.967 253.065 312.683 252.898 313.268C252.582 314.44 252.47 315.119 252.433 315.11C252.414 315.11 252.433 314.933 252.47 314.617C252.517 314.301 252.582 313.826 252.721 313.222C252.87 312.627 253.075 311.883 253.54 311.12C254.004 310.377 254.767 309.577 255.901 309.261C256.459 309.103 257.101 309.131 257.696 309.335C258.3 309.54 258.83 309.93 259.323 310.358C260.308 311.204 261.182 312.329 262.447 312.887C263.702 313.436 265.311 312.971 266.352 311.911C267.412 310.832 267.877 309.214 267.905 307.587C267.914 306.769 267.867 305.923 268.044 305.076C268.128 304.658 268.277 304.23 268.555 303.868C268.834 303.505 269.234 303.254 269.671 303.152C270.592 302.938 271.419 303.468 271.968 304.007C272.526 304.574 272.944 305.225 273.251 305.913C273.539 306.583 273.827 307.206 274.181 307.773C274.534 308.331 274.971 308.824 275.501 309.084C276.022 309.344 276.645 309.317 277.119 309.056C277.602 308.805 277.937 308.34 278.169 307.875C278.662 306.917 278.783 305.941 278.997 305.086C279.22 304.23 279.545 303.523 279.936 303.031C280.327 302.529 280.782 302.287 281.108 302.203C281.424 302.101 281.6 302.147 281.6 302.147Z\" fill=#FAFAFA /><path d=\"M276.76 280.29C276.77 280.299 276.714 280.42 276.593 280.634C276.463 280.848 276.277 281.164 276.007 281.554C275.738 281.945 275.384 282.41 274.892 282.893C274.408 283.368 273.757 283.86 272.911 284.111C272.093 284.372 271.024 284.418 270.094 283.86C269.164 283.293 268.718 282.196 267.881 281.619C267.472 281.34 266.933 281.257 266.477 281.471C266.012 281.684 265.65 282.131 265.398 282.642C265.147 283.154 264.989 283.739 264.952 284.325C264.924 284.93 264.943 285.571 264.924 286.222C264.896 286.873 264.831 287.543 264.562 288.175C264.301 288.798 263.809 289.337 263.204 289.616C261.968 290.174 260.657 289.858 259.625 289.412C258.565 288.928 257.756 288.212 256.947 287.645C256.156 287.059 255.375 286.585 254.594 286.362C253.823 286.111 253.07 286.241 252.475 286.473C251.879 286.724 251.424 287.087 251.182 287.459C250.671 288.24 250.94 288.817 250.866 288.807C250.857 288.807 250.801 288.686 250.764 288.435C250.736 288.184 250.773 287.784 251.024 287.357C251.266 286.929 251.74 286.51 252.372 286.222C252.995 285.953 253.841 285.776 254.697 286.036C255.543 286.259 256.38 286.752 257.189 287.329C258.007 287.887 258.825 288.584 259.811 289.012C260.777 289.43 261.986 289.681 263 289.198C263.492 288.965 263.902 288.528 264.115 287.998C264.348 287.468 264.413 286.845 264.441 286.222C264.469 285.59 264.441 284.958 264.469 284.316C264.506 283.656 264.683 283.023 264.971 282.447C265.259 281.88 265.677 281.34 266.291 281.071C266.905 280.782 267.639 280.913 268.141 281.266C269.127 282.001 269.517 283.051 270.317 283.535C271.098 284.028 272.056 284.018 272.827 283.795C273.608 283.581 274.231 283.144 274.724 282.707C275.208 282.261 275.58 281.824 275.868 281.461C276.426 280.699 276.723 280.271 276.76 280.29Z\" fill=#FAFAFA /><path d=\"M252.996 333.803C252.996 333.803 252.903 334.054 252.512 334.352C252.131 334.659 251.378 334.854 250.476 334.687C250.02 334.603 249.537 334.454 249.035 334.194C248.533 333.933 248.059 333.58 247.529 333.217C247.008 332.864 246.441 332.474 245.79 332.222C245.139 331.953 244.386 331.906 243.67 332.167C242.954 332.436 242.387 333.059 241.941 333.775C241.485 334.501 241.122 335.328 240.732 336.193C240.341 337.048 239.951 337.969 239.319 338.806C238.984 339.206 238.612 339.615 238.119 339.875C237.868 340.005 237.617 340.136 237.338 340.173C237.199 340.201 237.059 340.238 236.92 340.257H236.492C235.925 340.238 235.339 340.033 234.884 339.689C234.4 339.373 234.019 338.936 233.656 338.508C232.94 337.625 232.355 336.649 231.657 335.747C230.969 334.863 230.132 334.017 229.035 333.729C227.947 333.45 226.757 333.775 225.772 334.408C224.768 335.04 223.987 335.942 223.364 336.937C222.731 337.932 222.211 338.983 221.625 339.987C221.039 340.991 220.36 341.967 219.486 342.711C218.631 343.465 217.59 344.032 216.465 344.153C215.349 344.274 214.224 343.892 213.415 343.241C212.587 342.59 211.992 341.781 211.444 341.01C210.365 339.457 209.426 337.941 208.087 337.104C207.436 336.677 206.711 336.481 206.014 336.472C205.317 336.481 204.666 336.658 204.099 336.909C202.955 337.42 202.183 338.239 201.728 338.992C201.272 339.754 201.142 340.442 201.114 340.907C201.105 341.372 201.133 341.623 201.105 341.623C201.095 341.623 201.086 341.568 201.068 341.447C201.058 341.326 201.012 341.149 201.012 340.907C201.012 340.433 201.114 339.708 201.56 338.899C201.997 338.099 202.788 337.234 203.978 336.667C204.573 336.388 205.252 336.184 206.005 336.165C206.758 336.156 207.567 336.36 208.264 336.816C209.696 337.699 210.681 339.262 211.76 340.777C212.309 341.54 212.904 342.312 213.666 342.897C214.419 343.502 215.414 343.818 216.409 343.706C217.413 343.595 218.371 343.065 219.18 342.358C219.998 341.651 220.639 340.731 221.207 339.745C221.783 338.759 222.304 337.69 222.955 336.667C223.587 335.644 224.424 334.659 225.511 333.98C226.571 333.301 227.901 332.92 229.156 333.245C230.421 333.58 231.313 334.529 232.029 335.44C232.745 336.37 233.331 337.346 234.01 338.201C234.679 339.038 235.516 339.782 236.52 339.801C237.515 339.857 238.407 339.327 238.984 338.546C239.579 337.774 239.97 336.881 240.369 336.026C240.769 335.17 241.141 334.324 241.634 333.571C242.117 332.827 242.74 332.139 243.558 331.841C244.367 331.553 245.223 331.627 245.911 331.934C246.608 332.222 247.175 332.622 247.696 332.994C248.217 333.366 248.682 333.738 249.146 333.989C249.611 334.25 250.086 334.408 250.513 334.501C251.378 334.687 252.085 334.538 252.466 334.277C252.847 334.017 252.968 333.785 252.996 333.803Z\" fill=#FAFAFA /><path d=\"M251.231 302.868C251.24 302.868 251.212 302.924 251.156 303.017C251.091 303.11 250.98 303.24 250.775 303.343C250.375 303.556 249.669 303.547 248.925 303.175C248.153 302.822 247.549 301.938 246.526 301.529C246.033 301.325 245.401 301.399 244.964 301.799C244.527 302.208 244.304 302.868 244.109 303.547C243.904 304.235 243.737 304.979 243.355 305.714C243.16 306.067 242.909 306.439 242.547 306.699C242.193 306.969 241.756 307.136 241.301 307.183C239.46 307.369 237.712 306.142 236.522 304.682C235.88 303.975 235.248 303.231 234.476 302.664C233.704 302.097 232.765 301.743 231.77 301.799C229.781 301.883 227.884 303.185 226.573 304.858C225.243 306.569 224.36 308.55 223.189 310.289C222.063 312.055 220.446 313.515 218.558 314.138C217.628 314.445 216.624 314.538 215.694 314.315C214.765 314.101 213.974 313.534 213.379 312.911C212.18 311.665 211.39 310.242 210.199 309.508C209.614 309.145 208.954 308.987 208.34 309.033C207.726 309.08 207.168 309.322 206.713 309.638C205.802 310.279 205.216 311.098 204.788 311.767C203.942 313.125 203.635 313.98 203.589 313.952C203.579 313.943 203.645 313.729 203.803 313.339C203.961 312.948 204.221 312.372 204.63 311.665C205.049 310.977 205.606 310.121 206.564 309.415C207.038 309.071 207.633 308.782 208.321 308.727C209 308.661 209.735 308.829 210.385 309.219C211.696 310.01 212.505 311.46 213.677 312.632C214.253 313.218 214.969 313.711 215.806 313.897C216.643 314.092 217.554 314.008 218.428 313.711C220.195 313.116 221.71 311.758 222.798 310.028C223.942 308.327 224.825 306.337 226.201 304.561C227.586 302.813 229.558 301.427 231.761 301.325C232.858 301.269 233.927 301.678 234.755 302.292C235.592 302.915 236.224 303.677 236.866 304.384C237.498 305.1 238.121 305.76 238.883 306.179C239.636 306.606 240.473 306.867 241.263 306.783C242.063 306.718 242.695 306.197 243.03 305.528C243.393 304.868 243.569 304.133 243.783 303.436C243.997 302.757 244.239 302.05 244.759 301.557C245.299 301.074 246.07 301.018 246.628 301.26C247.744 301.753 248.311 302.645 249.018 302.989C249.706 303.361 250.366 303.398 250.738 303.231C251.119 303.082 251.203 302.84 251.231 302.868Z\" fill=#FAFAFA /><path d=\"M251.722 270.763C251.703 270.782 251.573 270.615 251.248 270.447C250.922 270.271 250.355 270.15 249.676 270.336C248.988 270.503 248.235 271.005 247.761 271.898C247.25 272.772 246.999 273.906 246.608 275.162C246.404 275.785 246.143 276.436 245.716 277.04C245.306 277.644 244.665 278.175 243.884 278.416C243.103 278.649 242.238 278.584 241.439 278.351C240.63 278.109 239.858 277.728 239.133 277.254C237.701 276.324 236.306 275.078 234.54 274.762C233.666 274.622 232.745 274.762 231.927 275.19C231.099 275.599 230.374 276.231 229.723 276.947C228.403 278.37 227.51 280.109 226.265 281.55C225.651 282.275 224.972 282.935 224.191 283.428C223.41 283.93 222.508 284.237 221.606 284.265C219.765 284.302 218.259 283.317 217.069 282.387C215.87 281.42 214.865 280.425 213.805 279.709C212.755 278.993 211.648 278.546 210.654 278.556C209.659 278.565 208.813 278.9 208.255 279.328C207.678 279.746 207.409 280.257 207.288 280.601C207.158 280.955 207.167 281.159 207.13 281.159C207.13 281.159 207.092 280.955 207.195 280.574C207.297 280.202 207.548 279.644 208.143 279.179C208.71 278.705 209.594 278.323 210.654 278.286C211.732 278.24 212.904 278.705 214.001 279.421C215.107 280.137 216.139 281.141 217.32 282.071C218.492 282.973 219.942 283.875 221.588 283.819C223.243 283.772 224.749 282.647 225.902 281.243C227.101 279.858 227.985 278.109 229.37 276.622C230.049 275.878 230.82 275.208 231.722 274.762C232.615 274.297 233.656 274.139 234.623 274.297C236.585 274.66 237.989 275.98 239.384 276.882C240.76 277.793 242.368 278.426 243.772 278.044C244.46 277.84 245.018 277.393 245.409 276.836C245.808 276.287 246.069 275.664 246.273 275.059C246.673 273.851 246.961 272.679 247.519 271.768C247.798 271.321 248.124 270.931 248.496 270.661C248.867 270.392 249.267 270.233 249.63 270.159C250.364 269.992 250.969 270.159 251.294 270.373C251.629 270.568 251.722 270.763 251.722 270.763Z\" fill=#FAFAFA /><path d=\"M246.934 255.678C246.953 255.678 246.934 255.799 246.879 256.022C246.823 256.245 246.73 256.57 246.544 256.979C246.358 257.37 246.098 257.881 245.558 258.272C245.038 258.681 244.08 258.728 243.438 258.133C242.806 257.565 242.481 256.738 242.007 255.994C241.774 255.622 241.495 255.259 241.123 255.027C240.751 254.785 240.296 254.636 239.822 254.618C238.855 254.553 237.841 254.924 237.06 255.65C236.261 256.366 235.656 257.342 235.136 258.384C234.866 258.914 234.578 259.453 234.159 259.909C233.759 260.364 233.127 260.736 232.467 260.662C231.807 260.606 231.286 260.206 230.924 259.769C230.552 259.323 230.329 258.802 230.161 258.309C229.826 257.333 229.603 256.375 228.971 255.799C228.664 255.51 228.302 255.296 227.93 255.25C227.558 255.203 227.205 255.324 226.935 255.557C226.405 256.031 226.182 256.728 225.968 257.296C225.763 257.881 225.475 258.374 225.168 258.7C224.861 259.034 224.517 259.183 224.276 259.211C224.034 259.239 223.913 259.193 223.922 259.183C223.904 259.137 224.48 259.239 225.029 258.57C225.298 258.244 225.531 257.779 225.717 257.203C225.921 256.626 226.089 255.892 226.721 255.296C227.028 255.008 227.502 254.822 227.976 254.878C228.45 254.924 228.897 255.176 229.25 255.501C230.003 256.18 230.254 257.231 230.589 258.16C230.756 258.635 230.961 259.09 231.286 259.471C231.602 259.843 232.039 260.16 232.514 260.188C232.997 260.234 233.453 259.974 233.806 259.583C234.169 259.183 234.438 258.681 234.708 258.16C235.247 257.1 235.87 256.068 236.753 255.287C237.609 254.497 238.78 254.069 239.868 254.162C240.407 254.199 240.947 254.367 241.384 254.664C241.83 254.962 242.137 255.38 242.369 255.78C242.853 256.58 243.16 257.379 243.689 257.881C244.21 258.374 244.963 258.374 245.428 258.049C245.912 257.733 246.191 257.268 246.395 256.896C246.776 256.133 246.897 255.659 246.934 255.678Z\" fill=#FAFAFA /><path d=\"M186.319 255.755C186.337 255.755 186.365 255.904 186.412 256.192C186.449 256.48 186.505 256.917 186.523 257.475C186.542 258.033 186.533 258.74 186.282 259.521C186.059 260.302 185.463 261.139 184.515 261.604C184.05 261.827 183.464 261.957 182.879 261.808C182.293 261.678 181.791 261.25 181.428 260.767C181.056 260.283 180.787 259.725 180.461 259.223C180.136 258.712 179.727 258.247 179.169 258.042C178.034 257.624 176.584 258.266 175.97 259.456C175.645 260.042 175.459 260.73 175.394 261.436C175.32 262.143 175.394 262.878 175.431 263.64C175.468 264.403 175.487 265.193 175.264 265.946C175.059 266.69 174.631 267.415 173.953 267.843C173.274 268.271 172.409 268.28 171.721 268.02C171.024 267.769 170.447 267.341 169.964 266.867C169.016 265.881 168.43 264.765 167.612 263.975C166.831 263.157 165.789 262.785 164.832 262.85C163.874 262.896 163.056 263.305 162.526 263.835C161.987 264.375 161.708 264.998 161.568 265.518C161.308 266.579 161.54 267.202 161.475 267.211C161.466 267.211 161.401 267.071 161.345 266.774C161.298 266.486 161.261 266.03 161.382 265.472C161.494 264.914 161.763 264.235 162.331 263.64C162.888 263.036 163.772 262.571 164.813 262.496C165.845 262.394 167.044 262.803 167.891 263.677C168.774 264.514 169.388 265.649 170.271 266.541C170.726 266.978 171.256 267.369 171.861 267.583C172.465 267.797 173.144 267.778 173.683 267.434C174.222 267.09 174.594 266.476 174.78 265.807C174.976 265.137 174.966 264.403 174.929 263.659C174.808 262.18 174.762 260.544 175.543 259.205C176.259 257.856 177.923 257.085 179.308 257.605C180.006 257.866 180.461 258.442 180.796 258.972C181.14 259.512 181.4 260.06 181.735 260.507C182.06 260.962 182.479 261.306 182.953 261.427C183.427 261.557 183.929 261.464 184.348 261.269C185.212 260.869 185.77 260.135 186.003 259.409C186.263 258.684 186.3 258.005 186.31 257.457C186.337 256.369 186.272 255.755 186.319 255.755Z\" fill=#FAFAFA /><path d=\"M236.116 148.681C229.821 147.324 223.889 153.359 217.492 152.661C213.606 152.233 210.463 149.425 206.893 147.817C201.565 145.408 194.331 145.557 189.357 148.635C184.383 151.713 181.277 154.809 181.054 160.658C176.098 158.343 168.706 164.963 166.512 170.933C164.318 176.903 165.489 182.789 167.535 188.814C171.059 199.192 176.647 208.862 183.871 217.101C184.513 217.826 185.498 218.617 186.344 218.133C186.93 217.798 187.06 217.027 187.107 216.357C187.535 210.648 186.335 204.966 185.368 199.331C184.401 193.687 183.667 187.857 184.996 182.287C186.335 176.726 190.147 171.426 195.651 169.845C199.715 168.683 204.122 169.659 207.962 171.407C211.811 173.155 215.27 175.647 218.961 177.693C222.652 179.748 226.753 181.394 230.974 181.217C235.195 181.041 239.537 178.679 241.015 174.718C242.484 170.756 240.021 165.512 235.827 164.982C239.584 164.312 242.605 160.76 242.68 156.957C242.736 153.145 239.835 149.49 236.116 148.681Z\" fill=#263238 /><path d=\"M225.547 248.98L223.92 236.845C223.92 236.845 239.717 232.41 237.978 216.295C237.141 208.512 234.11 192.63 231.209 178.282C228.085 162.855 213.636 152.413 198.007 154.291L196.454 154.477C179.83 157.462 173.079 173.251 176.529 189.794L185.901 254.513C187.482 265.401 197.551 272.98 208.448 271.473C219.373 269.958 227.016 259.906 225.547 248.98Z\" fill=#FFBE9D /><path d=\"M223.938 236.846C223.938 236.846 213.868 238.891 202.246 233.405C202.246 233.405 208.596 244.387 224.477 241.012L223.938 236.846Z\" fill=#EB996E /><path d=\"M226.254 188.056C226.449 189.311 225.593 190.511 224.329 190.734C223.074 190.957 221.893 190.12 221.698 188.855C221.502 187.6 222.358 186.4 223.613 186.177C224.878 185.954 226.058 186.8 226.254 188.056Z\" fill=#263238 /><path d=\"M228.7 187.638C228.449 187.973 226.552 186.895 224.079 187.192C221.606 187.462 219.941 188.95 219.634 188.68C219.486 188.559 219.709 187.983 220.434 187.313C221.141 186.644 222.405 185.928 223.949 185.751C225.492 185.574 226.85 185.983 227.668 186.476C228.505 186.969 228.821 187.48 228.7 187.638Z\" fill=#263238 /><path d=\"M202.715 190.033C202.919 191.316 202.055 192.535 200.799 192.758C199.544 192.981 198.363 192.116 198.159 190.833C197.954 189.55 198.819 188.332 200.074 188.108C201.339 187.885 202.52 188.75 202.715 190.033Z\" fill=#263238 /><path d=\"M204.963 189.558C204.712 189.893 202.816 188.814 200.342 189.121C197.869 189.391 196.205 190.878 195.898 190.609C195.749 190.488 195.973 189.911 196.698 189.242C197.404 188.572 198.669 187.856 200.203 187.68C201.746 187.503 203.104 187.912 203.922 188.405C204.768 188.898 205.084 189.409 204.963 189.558Z\" fill=#263238 /><path d=\"M215.63 207.207C215.602 207.067 217.108 206.621 219.563 205.998C220.186 205.859 220.771 205.663 220.827 205.217C220.92 204.743 220.576 204.092 220.176 203.394C219.395 201.935 218.586 200.41 217.731 198.81C214.319 192.273 211.762 186.871 212.022 186.731C212.282 186.592 215.267 191.78 218.689 198.317C219.516 199.935 220.306 201.47 221.06 202.939C221.385 203.627 221.896 204.389 221.683 205.375C221.571 205.868 221.143 206.268 220.753 206.426C220.362 206.603 220.009 206.649 219.702 206.705C217.21 207.151 215.658 207.346 215.63 207.207Z\" fill=#263238 /><path d=\"M208.545 209.792C208.945 209.717 209.271 212.404 211.8 214.032C214.319 215.668 217.146 215.027 217.211 215.399C217.267 215.566 216.634 215.994 215.435 216.17C214.254 216.356 212.478 216.18 210.935 215.185C209.391 214.181 208.601 212.702 208.378 211.605C208.146 210.498 208.359 209.801 208.545 209.792Z\" fill=#263238 /><path d=\"M203.695 178.258C203.528 178.956 201.026 178.937 198.163 179.634C195.29 180.276 193.049 181.401 192.593 180.853C192.389 180.583 192.724 179.904 193.588 179.142C194.444 178.379 195.866 177.579 197.586 177.18C199.306 176.78 200.934 176.863 202.04 177.17C203.165 177.459 203.76 177.923 203.695 178.258Z\" fill=#263238 /><path d=\"M226.912 179.517C226.54 180.131 224.773 179.75 222.719 179.973C220.664 180.122 218.981 180.801 218.516 180.261C218.302 180.001 218.516 179.406 219.204 178.783C219.883 178.16 221.082 177.583 222.495 177.453C223.909 177.332 225.192 177.695 225.973 178.178C226.763 178.671 227.07 179.229 226.912 179.517Z\" fill=#263238 /><path d=\"M179.265 201.549C178.977 201.465 167.82 199.605 169.493 210.569C171.167 221.532 181.822 217.589 181.794 217.273C181.757 216.947 179.265 201.549 179.265 201.549Z\" fill=#FFBE9D /><path d=\"M177.81 213.636C177.754 213.608 177.643 213.803 177.336 213.998C177.048 214.193 176.518 214.37 175.913 214.249C174.695 213.998 173.431 212.315 173.078 210.344C172.901 209.349 172.966 208.373 173.198 207.526C173.412 206.671 173.84 206.039 174.407 205.843C174.965 205.62 175.43 205.908 175.616 206.197C175.811 206.485 175.774 206.708 175.839 206.717C175.876 206.736 176.044 206.494 175.886 206.057C175.811 205.843 175.644 205.611 175.346 205.434C175.049 205.257 174.649 205.211 174.249 205.313C173.412 205.499 172.771 206.392 172.51 207.312C172.204 208.242 172.111 209.349 172.315 210.465C172.724 212.659 174.165 214.556 175.82 214.77C176.62 214.854 177.234 214.519 177.522 214.212C177.829 213.905 177.857 213.645 177.81 213.636Z\" fill=#EB996E /><path d=\"M234.198 174.498C227.336 177.232 219.154 176.395 212.99 172.322C208.676 169.477 205.087 165.06 200.001 164.14C196.579 163.517 192.99 164.67 190.173 166.706C187.347 168.742 185.208 171.588 183.432 174.582C187.523 182.384 186.528 191.766 185.431 200.507C185.31 201.474 185.152 202.515 184.455 203.203C183.274 204.356 181.229 203.808 179.955 202.757C177.909 201.074 176.887 198.47 176.106 195.941C174.339 190.176 173.456 184.085 174.069 178.078C174.683 172.081 176.84 166.167 180.671 161.508C185.459 155.687 192.721 152.098 200.215 151.307C207.709 150.526 215.379 152.451 221.897 156.245C224.919 158.003 227.773 160.225 229.586 163.219\" fill=#263238 /><path d=\"M241.195 152.015C241.195 152.015 241.297 152.34 241.214 152.982C241.13 153.605 240.805 154.553 239.949 155.437C239.103 156.33 237.699 157.027 236.007 157.306C235.161 157.445 234.24 157.529 233.255 157.464C232.279 157.39 231.219 157.148 230.298 156.497C229.396 155.865 228.606 154.832 228.55 153.559C228.485 152.266 229.378 151.057 230.549 150.471C231.135 150.164 231.804 149.988 232.502 149.979C233.19 149.979 233.906 150.202 234.491 150.602C235.7 151.383 236.416 152.796 236.593 154.256C236.779 155.734 236.286 157.297 235.347 158.505C234.408 159.724 233.097 160.653 231.628 161.249C228.68 162.457 225.249 162.281 222.107 161.351C218.927 160.44 216.072 158.915 213.385 157.427C210.698 155.939 208.086 154.526 205.445 153.605C202.814 152.666 200.117 152.312 197.663 152.675C195.208 153.028 193.042 153.996 191.285 155.158C187.742 157.529 185.864 160.588 184.785 162.671C184.246 163.731 183.893 164.596 183.67 165.173C183.437 165.758 183.326 166.075 183.307 166.065C183.298 166.065 183.316 165.982 183.354 165.823C183.4 165.665 183.456 165.433 183.558 165.135C183.753 164.531 184.069 163.657 184.59 162.569C185.622 160.44 187.472 157.306 191.071 154.832C192.856 153.624 195.069 152.61 197.598 152.219C200.127 151.829 202.916 152.182 205.612 153.121C208.318 154.051 210.959 155.474 213.655 156.953C216.342 158.431 219.159 159.928 222.274 160.821C225.352 161.723 228.634 161.881 231.442 160.746C232.827 160.188 234.064 159.314 234.938 158.189C235.821 157.064 236.267 155.669 236.1 154.321C235.951 152.991 235.291 151.708 234.231 151.02C233.199 150.276 231.814 150.341 230.763 150.89C229.703 151.42 228.931 152.461 228.978 153.559C229.015 154.656 229.703 155.614 230.531 156.199C231.367 156.794 232.362 157.046 233.292 157.129C234.231 157.204 235.133 157.138 235.96 157.018C237.615 156.776 238.973 156.134 239.8 155.307C240.647 154.479 240.991 153.586 241.111 152.982C241.223 152.35 241.158 152.015 241.195 152.015Z\" fill=#455A64 /><path d=\"M165.681 180.637C165.709 180.517 166.992 181.121 169.149 181.102C170.218 181.084 171.492 180.851 172.794 180.275C174.095 179.717 175.425 178.843 176.68 177.792C179.181 175.635 180.381 172.743 180.799 170.651C181.227 168.53 181.013 167.164 181.124 167.154C181.162 167.154 181.236 167.48 181.292 168.103C181.348 168.716 181.348 169.618 181.18 170.725C180.855 172.901 179.665 175.951 177.043 178.21C175.741 179.308 174.365 180.182 172.989 180.74C171.622 181.316 170.265 181.521 169.149 181.484C168.024 181.446 167.141 181.223 166.564 181.019C165.978 180.833 165.672 180.665 165.681 180.637Z\" fill=#455A64 /><path d=\"M167.135 188.545C167.135 188.443 168.455 188.573 170.519 188.21C172.565 187.857 175.373 186.871 177.8 184.816C180.226 182.752 181.658 180.139 182.337 178.177C183.034 176.206 183.118 174.885 183.22 174.895C183.257 174.895 183.267 175.229 183.211 175.824C183.155 176.42 183.016 177.275 182.709 178.298C182.104 180.334 180.682 183.087 178.162 185.225C175.633 187.364 172.695 188.322 170.584 188.582C169.525 188.722 168.651 188.722 168.055 188.675C167.451 188.647 167.126 188.582 167.135 188.545Z\" fill=#455A64 /><path d=\"M197.479 201.452C197.34 201.499 197.172 201.406 197.126 201.257C197.07 201.099 197.154 200.932 197.293 200.885C197.433 200.839 197.6 200.932 197.647 201.09C197.693 201.238 197.619 201.406 197.479 201.452Z\" fill=#EB996E /><path d=\"M202.074 199.808C201.935 199.854 201.767 199.743 201.702 199.566C201.647 199.39 201.712 199.204 201.86 199.157C202 199.111 202.167 199.222 202.232 199.399C202.288 199.575 202.223 199.752 202.074 199.808Z\" fill=#EB996E /><path d=\"M205.26 199.345C205.111 199.382 204.944 199.215 204.888 198.973C204.832 198.731 204.897 198.508 205.046 198.471C205.195 198.434 205.362 198.601 205.418 198.843C205.483 199.085 205.409 199.308 205.26 199.345Z\" fill=#EB996E /><path d=\"M200.162 204.134C200.014 204.153 199.883 204.088 199.865 203.995C199.856 203.902 199.967 203.809 200.116 203.79C200.265 203.772 200.395 203.837 200.413 203.93C200.423 204.023 200.311 204.116 200.162 204.134Z\" fill=#EB996E /><path d=\"M204.366 202.618C204.218 202.646 204.069 202.534 204.032 202.367C203.994 202.2 204.087 202.032 204.236 202.004C204.385 201.976 204.534 202.088 204.571 202.255C204.608 202.423 204.515 202.581 204.366 202.618Z\" fill=#EB996E /><path d=\"M226.614 197.209C226.475 197.256 226.307 197.163 226.261 197.005C226.205 196.837 226.279 196.67 226.428 196.623C226.577 196.577 226.735 196.67 226.781 196.828C226.828 196.995 226.753 197.163 226.614 197.209Z\" fill=#EB996E /><path d=\"M229.782 196.528C229.633 196.565 229.484 196.435 229.438 196.249C229.4 196.063 229.484 195.886 229.633 195.849C229.782 195.812 229.93 195.942 229.977 196.128C230.014 196.314 229.93 196.491 229.782 196.528Z\" fill=#EB996E /><path d=\"M223.77 197.625C223.631 197.672 223.472 197.606 223.435 197.486C223.398 197.355 223.472 197.216 223.621 197.169C223.761 197.123 223.919 197.188 223.956 197.309C223.993 197.439 223.909 197.579 223.77 197.625Z\" fill=#EB996E /><path d=\"M226.54 200.564C226.41 200.639 226.233 200.583 226.141 200.434C226.048 200.285 226.085 200.099 226.215 200.025C226.345 199.951 226.522 200.006 226.615 200.155C226.708 200.295 226.67 200.481 226.54 200.564Z\" fill=#EB996E /><path d=\"M229.237 199.685C229.088 199.666 228.977 199.545 228.995 199.415C229.014 199.285 229.153 199.201 229.302 199.229C229.451 199.248 229.562 199.368 229.544 199.499C229.525 199.62 229.386 199.703 229.237 199.685Z\" fill=#EB996E /><path d=\"M168.899 207.356C168.918 207.411 168.295 207.411 167.802 206.686C167.57 206.342 167.402 205.821 167.514 205.254C167.626 204.696 167.979 204.138 168.509 203.776C169.039 203.404 169.69 203.283 170.229 203.348C170.777 203.404 171.233 203.617 171.568 203.859C172.237 204.361 172.349 204.901 172.302 204.91C172.228 204.956 172.014 204.51 171.373 204.147C170.777 203.794 169.652 203.552 168.769 204.175C168.332 204.473 168.035 204.919 167.932 205.356C167.821 205.793 167.914 206.212 168.081 206.519C168.425 207.151 168.927 207.281 168.899 207.356Z\" fill=#263238 /><path d=\"M252.129 327.481L252.957 351.491C252.957 351.491 183.353 365.281 174.4 369.893C165.446 374.505 161.792 375.221 162.331 388.518L273.561 388.323C273.561 388.323 287.266 383.19 286.996 368.265C286.726 353.341 282.998 317.485 282.998 317.485L252.129 327.481Z\" fill=#FFBE9D /><path d=\"M173.836 388.868L183.078 388.022L191.902 366.942C190.47 366.7 160.708 362.302 158.95 362.776L151.81 388.143C151.81 388.152 173.204 388.868 173.836 388.868Z\" fill=#FFBE9D /><path d=\"M153.491 388.548C153.51 388.595 153.686 388.632 153.984 388.66C156.439 388.93 167.791 388.241 167.791 388.241C168.312 386.772 167.326 382.374 165.913 382.114C164.5 381.853 152.413 382.672 152.413 382.672C152.413 382.672 150.507 382.923 150.032 386.121C149.754 388.083 153.491 388.548 153.491 388.548Z\" fill=#FFBE9D /><path d=\"M149.652 382.113C149.671 382.159 149.848 382.196 150.145 382.224C152.6 382.494 163.339 382.373 163.804 381.071C164.324 379.602 163.497 375.938 162.084 375.678C160.67 375.418 148.592 376.236 148.592 376.236C148.592 376.236 146.686 376.487 146.212 379.686C145.924 381.657 149.652 382.113 149.652 382.113Z\" fill=#FFBE9D /><path d=\"M147.756 375.805C147.775 375.852 147.952 375.889 148.249 375.917C150.704 376.186 161.443 376.066 161.908 374.764C162.428 373.295 161.601 369.631 160.187 369.37C158.774 369.11 146.687 369.928 146.687 369.928C146.687 369.928 144.781 370.179 144.307 373.378C144.019 375.34 147.756 375.805 147.756 375.805Z\" fill=#FFBE9D /><path d=\"M145.979 369.531C145.998 369.577 146.174 369.614 146.472 369.642C148.926 369.912 159.665 369.791 160.13 368.489C160.651 367.02 159.823 363.356 158.41 363.096C156.997 362.836 144.91 363.654 144.91 363.654C144.91 363.654 143.004 363.905 142.53 367.104C142.241 369.075 145.979 369.531 145.979 369.531Z\" fill=#FFBE9D /><path d=\"M162.774 382.066C162.755 382.252 160.422 382.466 157.549 382.55C154.676 382.633 152.36 382.55 152.379 382.364C152.398 382.178 154.731 381.964 157.604 381.88C160.477 381.796 162.793 381.88 162.774 382.066Z\" fill=#EB996E /><path d=\"M162.855 375.716C162.864 375.902 159.536 376.163 155.426 376.293C151.316 376.423 147.979 376.376 147.979 376.19C147.969 376.004 151.298 375.744 155.407 375.614C159.508 375.484 162.846 375.53 162.855 375.716Z\" fill=#EB996E /><g opacity=0.78><g opacity=0.78><g opacity=0.78><g opacity=0.78><path opacity=0.78 d=\"M162.333 369.305C162.342 369.491 159.013 369.751 154.904 369.881C150.794 370.011 147.456 369.965 147.456 369.779C147.447 369.593 150.775 369.333 154.885 369.202C158.995 369.072 162.323 369.109 162.333 369.305Z\" fill=#EB996E /></g></g></g></g><path d=\"M179.569 365.323C179.569 365.323 159.309 356.312 158.044 357.614C156.78 358.916 154.827 363.1 154.827 363.1L179.569 365.323Z\" fill=#FFBE9D /><path d=\"M268.519 372.438C268.435 372.466 268.017 370.987 267.059 368.728C266.585 367.593 265.934 366.282 265.135 364.869C264.317 363.465 263.34 361.968 262.197 360.489C261.034 359.02 259.826 357.709 258.663 356.574C257.483 355.458 256.376 354.51 255.391 353.766C253.429 352.278 252.099 351.516 252.146 351.441C252.164 351.414 252.508 351.581 253.113 351.916C253.726 352.241 254.582 352.771 255.595 353.487C256.618 354.194 257.762 355.133 258.97 356.249C260.16 357.383 261.406 358.704 262.578 360.192C263.74 361.698 264.716 363.223 265.525 364.655C266.306 366.096 266.939 367.445 267.376 368.607C267.822 369.769 268.129 370.718 268.296 371.396C268.473 372.057 268.556 372.429 268.519 372.438Z\" fill=#EB996E /><path d=\"M187.027 259.371L166.069 319.031L142.509 325.819C142.509 325.819 151.053 361.982 159.775 368.472C162.741 370.676 167.585 373.066 172.55 372.722C181.969 372.062 192.531 365.423 196.557 356.152C200.137 347.913 209.695 262.709 209.695 262.709L187.027 259.371Z\" fill=#FFBE9D /><path d=\"M209.412 265.248L210.63 250.714L207.255 239.044L205.954 234.581L208.501 237.185L213.15 232.228C213.15 232.228 211.644 223.422 210.379 223.422C209.589 223.422 207.283 224.213 205.675 224.808C204.717 225.161 204.01 225.44 204.01 225.44L200.077 227.449L204.01 221.414C204.01 221.414 208.064 224.789 210.138 221.86C211.728 219.619 205.814 214.598 203.592 212.822C203.081 212.413 202.42 212.264 201.779 212.385L199.482 212.85C199.557 211.557 198.153 209.819 196.126 209.791C193.123 209.744 191.728 212.431 191.728 212.431L189.311 212.869C187.618 212.869 186.112 213.919 185.526 215.509L180.208 229.978L187.033 259.39\" fill=#FFBE9D /><path d=\"M187.017 259.377C187.017 259.377 186.952 259.201 186.869 258.857C186.776 258.485 186.646 257.973 186.478 257.313C186.143 255.937 185.669 253.947 185.056 251.418C183.847 246.285 182.108 238.948 179.998 230.012L179.988 229.956L180.007 229.9C181.058 227.027 182.164 223.996 183.326 220.806C183.912 219.216 184.507 217.58 185.111 215.915C185.372 215.078 185.846 214.176 186.608 213.591C187.352 212.986 188.31 212.642 189.286 212.642H189.249C190.002 212.503 190.83 212.354 191.666 212.205L191.508 212.326C191.945 211.563 192.55 210.922 193.284 210.41C194.019 209.918 194.902 209.601 195.813 209.573C196.724 209.499 197.691 209.806 198.417 210.392C199.142 210.978 199.728 211.833 199.709 212.865L199.421 212.623C199.997 212.512 200.574 212.391 201.159 212.27C201.457 212.224 201.727 212.14 202.071 212.112C202.396 212.093 202.731 212.14 203.047 212.261C203.354 212.363 203.66 212.577 203.874 212.763L204.581 213.339C205.046 213.73 205.511 214.121 205.966 214.53C206.878 215.348 207.761 216.203 208.588 217.152C209.388 218.1 210.215 219.095 210.569 220.406C210.652 220.778 210.68 221.197 210.541 221.587C210.401 221.997 210.113 222.257 209.862 222.536C209.304 223.075 208.505 223.336 207.761 223.298C206.245 223.205 204.971 222.452 203.846 221.606L204.2 221.55C202.861 223.596 201.55 225.604 200.257 227.585L199.951 227.241C201.28 226.562 202.591 225.893 203.893 225.232L203.902 225.223H203.912C205.241 224.721 206.552 224.219 207.872 223.8C208.533 223.596 209.193 223.382 209.89 223.252C210.076 223.224 210.215 223.177 210.485 223.215C210.764 223.289 210.894 223.475 211.006 223.624C211.22 223.931 211.359 224.247 211.489 224.572C212.438 227.139 212.884 229.714 213.358 232.197L213.377 232.299L213.302 232.383C211.684 234.103 210.132 235.74 208.644 237.33L208.495 237.488L208.347 237.339C207.463 236.437 206.626 235.573 205.799 234.726L206.124 234.54C207.91 240.789 209.472 246.22 210.745 250.683L210.755 250.711V250.739C210.346 255.314 210.011 258.94 209.788 261.451C209.667 262.669 209.574 263.617 209.509 264.287C209.472 264.594 209.453 264.836 209.425 265.012C209.407 265.18 209.388 265.254 209.388 265.254C209.379 265.254 209.379 265.17 209.388 265.003C209.397 264.817 209.416 264.575 209.434 264.268C209.481 263.599 209.546 262.65 209.639 261.423C209.834 258.912 210.113 255.286 210.476 250.702L210.485 250.748C209.174 246.285 207.584 240.873 205.762 234.633L205.548 233.89L206.087 234.438C206.915 235.275 207.761 236.14 208.644 237.042H208.356C209.844 235.452 211.387 233.797 212.995 232.076L212.94 232.262C212.475 229.807 212.001 227.213 211.08 224.73C210.959 224.433 210.82 224.126 210.643 223.884C210.559 223.754 210.448 223.67 210.401 223.661C210.336 223.642 210.122 223.67 209.983 223.698C209.341 223.819 208.681 224.024 208.03 224.238C206.719 224.656 205.418 225.158 204.097 225.66L204.116 225.651C202.824 226.311 201.513 226.99 200.183 227.669L199.393 228.078L199.876 227.334C201.169 225.353 202.48 223.336 203.809 221.299L203.949 221.085L204.163 221.253C205.204 222.052 206.468 222.768 207.779 222.833C208.43 222.861 209.072 222.647 209.537 222.201C209.751 221.959 210.002 221.718 210.085 221.448C210.178 221.169 210.169 220.853 210.095 220.537C209.797 219.411 209.007 218.407 208.226 217.496C207.426 216.575 206.552 215.729 205.65 214.92C205.204 214.511 204.748 214.121 204.283 213.739C203.809 213.377 203.382 212.912 202.889 212.744C202.368 212.54 201.866 212.642 201.262 212.772C200.676 212.893 200.099 213.005 199.523 213.116L199.225 213.172L199.235 212.865C199.253 212.075 198.761 211.294 198.119 210.782C197.477 210.271 196.65 209.992 195.832 210.057C194.158 210.094 192.689 211.21 191.908 212.558L191.852 212.661L191.75 212.679C190.913 212.828 190.076 212.977 189.323 213.116H189.305H189.286C188.412 213.116 187.557 213.423 186.897 213.962C186.209 214.511 185.809 215.246 185.539 216.092C184.925 217.756 184.321 219.384 183.735 220.974C182.554 224.154 181.439 227.194 180.379 230.058L180.388 229.947C182.434 238.902 184.107 246.257 185.279 251.39C185.846 253.928 186.292 255.927 186.599 257.313C186.738 257.973 186.85 258.494 186.934 258.866C186.999 259.191 187.017 259.377 187.017 259.377Z\" fill=#EB996E /><path d=\"M203.811 232.703C203.765 232.6 205.494 231.67 207.884 230.508L209.399 229.773L208.144 230.899C207.819 231.187 207.531 231.549 207.307 231.968C206.936 232.665 206.787 233.437 206.843 234.116C206.898 234.804 207.131 235.399 207.391 235.855C207.94 236.775 208.544 237.129 208.498 237.194C208.488 237.24 207.782 236.989 207.103 236.041C206.777 235.576 206.48 234.934 206.396 234.162C206.313 233.4 206.461 232.526 206.88 231.745C207.131 231.271 207.465 230.861 207.837 230.545L208.088 230.936C205.671 232.052 203.858 232.805 203.811 232.703Z\" fill=#EB996E /><path d=\"M192.675 224.837C192.619 224.8 193.056 223.963 193.809 222.643C194.562 221.323 195.641 219.509 196.849 217.529C197.463 216.534 198.03 215.595 198.588 214.739C199.146 213.893 199.806 213.177 200.513 212.786C201.21 212.396 201.889 212.331 202.326 212.386C202.772 212.442 202.977 212.591 202.967 212.61C202.958 212.647 202.726 212.563 202.316 212.572C201.907 212.572 201.312 212.693 200.689 213.084C199.406 213.837 198.514 215.827 197.268 217.78C196.059 219.76 194.934 221.546 194.107 222.82C193.27 224.094 192.73 224.865 192.675 224.837Z\" fill=#EB996E /><path d=\"M185.481 224.793C185.426 224.765 185.677 224.012 186.169 222.812C186.662 221.622 187.387 219.985 188.261 218.228C189.135 216.461 189.991 214.899 190.642 213.783C191.292 212.667 191.739 212.007 191.795 212.035C191.85 212.072 191.516 212.788 190.939 213.941C190.279 215.262 189.526 216.768 188.689 218.433C187.871 220.106 187.127 221.622 186.476 222.942C185.909 224.114 185.546 224.821 185.481 224.793Z\" fill=#EB996E /><path d=\"M168.635 313.203C168.663 313.213 168.542 313.603 168.291 314.282C168.003 315.054 167.64 316.021 167.213 317.165C166.292 319.601 165.037 322.958 163.707 326.696C162.378 330.434 161.234 333.837 160.416 336.301C160.026 337.454 159.7 338.431 159.43 339.221C159.189 339.909 159.049 340.281 159.012 340.272C158.984 340.262 159.068 339.872 159.254 339.165C159.44 338.458 159.719 337.445 160.091 336.199C160.834 333.707 161.922 330.276 163.252 326.538C164.581 322.8 165.892 319.443 166.887 317.044C167.389 315.844 167.808 314.877 168.105 314.217C168.421 313.547 168.607 313.194 168.635 313.203Z\" fill=#EB996E /><path d=\"M199.711 340.706C199.721 340.706 199.711 340.799 199.693 340.984C199.665 341.189 199.628 341.459 199.581 341.784C199.479 342.519 199.33 343.551 199.135 344.853C198.93 346.182 198.688 347.819 198.307 349.697C197.926 351.576 197.415 353.714 196.559 355.983C195.695 358.243 194.411 360.642 192.459 362.743C190.534 364.854 188.154 366.807 185.393 368.443C182.631 370.089 179.489 371.363 176.132 372.293C174.44 372.739 172.664 373.037 170.851 373.037C169.028 373.046 167.188 372.702 165.43 372.089C161.906 370.805 158.978 368.434 156.802 365.71C154.589 362.994 153.018 359.963 151.8 357.015C150.582 354.04 149.866 351.083 149.029 348.386C148.192 345.68 147.411 343.16 146.704 340.854C145.263 336.251 144.166 332.504 143.487 329.891C143.143 328.589 142.892 327.566 142.734 326.878C142.66 326.553 142.604 326.293 142.558 326.088C142.52 325.911 142.502 325.818 142.511 325.818C142.52 325.818 142.548 325.902 142.604 326.079C142.66 326.283 142.734 326.534 142.827 326.86C143.032 327.576 143.311 328.58 143.664 329.845C144.408 332.439 145.552 336.158 147.03 340.752C147.764 343.049 148.555 345.569 149.419 348.265C150.284 350.971 151.009 353.919 152.227 356.848C153.445 359.768 154.998 362.753 157.183 365.412C159.331 368.081 162.185 370.387 165.607 371.633C167.318 372.237 169.094 372.572 170.86 372.554C172.627 372.563 174.365 372.275 176.02 371.837C179.34 370.926 182.454 369.671 185.179 368.062C187.903 366.454 190.274 364.547 192.18 362.474C194.105 360.419 195.378 358.085 196.252 355.862C197.126 353.631 197.656 351.511 198.056 349.651C198.456 347.782 198.726 346.155 198.958 344.825C199.181 343.523 199.367 342.5 199.488 341.766C199.553 341.44 199.6 341.18 199.646 340.975C199.683 340.789 199.702 340.706 199.711 340.706Z\" fill=#EB996E /><path class=fade-in-bottom opacity=0.4 d=\"M198.92 135.004L198.881 132.433C198.861 130.803 199.04 129.459 199.429 128.341C199.817 127.222 200.294 126.307 200.942 125.486C201.59 124.664 202.216 123.963 202.831 123.324C203.672 122.474 204.441 121.674 205.149 120.863C205.797 120.041 206.114 118.973 206.101 117.657C206.099 116.969 205.905 116.308 205.546 115.869C205.199 115.369 204.757 115.039 204.245 114.759C203.732 114.48 203.248 114.393 202.752 114.366C201.811 114.385 201.019 114.618 200.376 115.065C199.732 115.512 199.249 116.113 198.816 116.786C198.443 117.469 198.059 118.214 197.796 118.979L192.121 116.459C192.29 115.864 192.614 115.109 193.091 114.194C193.568 113.279 194.237 112.336 195.089 111.426C195.94 110.516 197.084 109.721 198.398 109.019C199.762 108.388 201.385 108.054 203.278 107.957C205.161 107.92 206.797 108.213 208.317 108.799C209.838 109.385 211.04 110.352 211.934 111.638C212.829 112.924 213.322 114.702 213.376 116.838C213.424 118.66 213.224 120.125 212.714 121.221C212.265 122.329 211.656 123.283 210.947 124.094C210.239 124.904 209.541 125.655 208.844 126.405C208.3 126.995 207.756 127.585 207.323 128.258C206.829 128.92 206.434 129.724 206.15 130.611C205.865 131.498 205.741 132.539 205.765 133.794L205.773 134.796L198.92 135.004ZM202.574 145.291C201.38 145.327 200.432 145.031 199.671 144.394C198.91 143.757 198.496 142.932 198.499 141.87C198.491 140.868 198.836 139.992 199.584 139.313C200.331 138.634 201.277 138.241 202.411 138.195C203.545 138.148 204.481 138.504 205.242 139.141C205.993 139.839 206.407 140.664 206.415 141.666C206.411 142.728 206.077 143.544 205.391 144.234C204.643 144.912 203.708 145.245 202.574 145.291Z\" fill=#55A3F3 /><path d=\"M29.3592 331.168C28.5784 328.461 26.904 325.832 24.31 324.722C21.6119 323.559 18.4887 324.219 15.7385 325.225C12.9796 326.223 10.2728 327.568 7.34046 327.75C4.4081 327.932 1.10268 326.544 0.226439 323.741C-0.597746 321.112 0.989895 318.301 2.97662 316.384C7.1496 312.367 13.4308 310.657 19.0699 312.011C24.7091 313.364 29.5241 317.737 31.424 323.212\" fill=#979797 /><path d=\"M52.5766 342.937C56.8711 338.85 56.6629 331.744 54.52 326.217C52.3771 320.691 47.7009 316.448 42.4695 313.645C32.3364 308.222 19.67 307.815 9.21582 312.569C14.3605 312.743 19.3229 315.658 21.9777 320.066C24.3375 323.979 24.858 328.725 26.8013 332.855C28.9702 337.453 32.9437 341.176 37.6806 343.024C42.4175 344.881 47.8658 344.846 52.5766 342.937Z\" fill=#B4B4B4 /><path d=\"M54.6408 318.406C59.3951 312.793 60.0284 303.769 59.3344 296.446C58.6316 289.115 56.9312 281.74 58.0937 274.469C58.7791 270.165 60.4535 266.053 61.0174 261.723C61.5813 257.402 60.7832 252.509 57.4344 249.715C53.5824 246.505 47.5181 247.259 43.51 250.279C39.5018 253.29 37.1855 258.027 35.485 262.738C31.7545 273.098 30.3924 284.594 33.4549 295.171C36.5174 305.747 43.7009 315.205 54.2418 318.398\" fill=#B4B4B4 /><path d=\"M56.9282 364.484C56.9456 364.484 56.9456 364.258 56.9456 363.833C56.9369 363.408 56.9456 362.783 56.9109 361.976C56.8501 360.362 56.694 358.037 56.3383 355.174C55.9739 352.311 55.41 348.918 54.5077 345.213C53.6228 341.5 52.1046 337.535 49.9617 333.682C47.8101 329.821 45.1901 326.498 42.5353 323.748C39.8719 321.006 37.1564 318.863 34.7446 317.275C33.556 316.451 32.4022 315.826 31.4132 315.254C30.3981 314.724 29.5132 314.282 28.7844 313.935C28.0644 313.631 27.5004 313.397 27.0753 313.215C26.6849 313.058 26.4767 312.98 26.468 312.989C26.4594 312.998 26.6589 313.102 27.0406 313.284C27.4571 313.475 28.0123 313.744 28.715 314.065C29.4264 314.438 30.3027 314.889 31.3004 315.436C32.272 316.026 33.4086 316.668 34.5798 317.501C36.9482 319.115 39.6377 321.258 42.2577 323.999C44.8777 326.741 47.4718 330.047 49.606 333.873C53.9785 341.526 55.1757 349.578 56.0433 355.217C56.4424 358.063 56.6332 360.388 56.746 361.994C56.7894 362.766 56.8241 363.382 56.8588 363.842C56.8935 364.267 56.9195 364.484 56.9282 364.484Z\" fill=#263238 /><path d=\"M97.9617 296.244C106.767 301.554 106.741 306.396 105.267 310.959C103.8 315.523 98.3955 318.69 93.9102 316.981C91.3769 316.018 89.5463 313.814 87.976 311.602C86.4057 309.389 84.9396 307.02 82.7446 305.433C80.5497 303.845 77.3657 303.237 75.1621 304.808\" fill=#979797 /><path d=\"M104.557 302.066C102.258 298.882 96.5668 297.962 92.9751 299.55C89.3833 301.138 86.7546 304.287 84.4035 307.428C82.0524 310.569 79.7534 313.892 76.5 316.079C73.238 318.265 68.6833 319.055 65.4299 316.851C63.2957 315.402 62.0551 312.886 61.6734 310.343C61.283 307.793 61.656 305.19 62.1939 302.665C62.9747 298.969 64.2413 295.116 67.1911 292.774C70.4878 290.162 75.0512 290.032 79.2589 290.171C84.0825 290.327 88.9756 290.691 93.5043 292.366C98.0156 294.032 102.631 297.641 104.557 302.066Z\" fill=#B4B4B4 /><path d=\"M64.2399 357.442C64.2486 357.442 64.2572 357.373 64.2659 357.251C64.2746 357.104 64.2833 356.913 64.2919 356.687C64.3093 356.158 64.3353 355.429 64.37 354.501C64.4221 352.566 64.5002 349.833 64.6043 346.467C64.7084 343.074 64.8472 339.039 65.0901 334.554C65.3417 330.077 65.6714 325.148 66.3568 320.029C66.7038 317.47 67.1029 314.971 67.8143 312.654C68.5257 310.338 69.48 308.177 70.5124 306.199C71.5535 304.221 72.6986 302.425 73.9132 300.854C75.1365 299.284 76.3945 297.922 77.6264 296.776C80.125 294.495 82.5108 293.098 84.2199 292.282C84.6537 292.082 85.0267 291.892 85.3651 291.753C85.6948 291.623 85.981 291.51 86.224 291.423C86.4409 291.336 86.6144 291.267 86.7532 291.206C86.8746 291.154 86.9267 291.128 86.9267 291.119C86.9267 291.111 86.8573 291.128 86.7358 291.163C86.5883 291.206 86.4148 291.267 86.1979 291.336C85.955 291.423 85.66 291.519 85.3217 291.64C84.9747 291.77 84.5929 291.952 84.1592 292.135C82.424 292.907 79.9949 294.278 77.4442 296.56C76.1863 297.705 74.9023 299.076 73.653 300.646C72.4123 302.225 71.2498 304.03 70.1827 306.017C69.133 308.012 68.17 310.182 67.4412 312.524C66.7125 314.884 66.3047 317.392 65.9577 319.96C65.2723 325.105 64.9513 330.033 64.7257 334.519C64.5002 339.005 64.3874 343.048 64.318 346.44C64.2486 349.833 64.2225 352.583 64.2139 354.484C64.2139 355.412 64.2139 356.141 64.2139 356.67C64.2139 356.904 64.2225 357.086 64.2225 357.243C64.2225 357.373 64.2312 357.442 64.2399 357.442Z\" fill=#263238 /><path d=\"M61.0722 361.413C61.0722 361.413 61.5667 360.103 62.0352 357.63C62.495 355.157 62.842 351.496 62.4343 347.01C62.0612 342.524 60.9074 337.249 59.0768 331.601C57.2723 325.935 54.8171 319.879 52.7262 313.371C51.6852 310.109 50.8003 306.89 50.2016 303.723C49.5857 300.556 49.2039 297.467 48.9523 294.517C48.4578 288.609 48.5272 283.255 48.6747 278.778C48.8309 274.293 49.0651 270.666 49.2126 268.167C49.282 266.935 49.3427 265.963 49.3861 265.278C49.4035 264.965 49.4122 264.714 49.4208 264.523C49.4295 264.349 49.4295 264.263 49.4208 264.263C49.4122 264.263 49.4035 264.349 49.3861 264.514C49.3688 264.705 49.3427 264.948 49.308 265.26C49.2473 265.946 49.1692 266.909 49.0651 268.141C48.8656 270.64 48.588 274.267 48.3971 278.761C48.2149 283.247 48.1195 288.609 48.5966 294.544C48.8309 297.511 49.2126 300.608 49.8286 303.793C50.4359 306.977 51.3208 310.213 52.3619 313.484C54.4614 320.018 56.9253 326.065 58.7471 331.713C60.5864 337.344 61.7576 342.576 62.174 347.036C62.6078 351.496 62.3042 355.14 61.8964 357.604C61.6795 358.836 61.48 359.79 61.3065 360.433C61.2284 360.736 61.1763 360.979 61.1329 361.161C61.0896 361.326 61.0722 361.413 61.0722 361.413Z\" fill=#263238 /><path d=\"M39.2549 365.399H80.5856L81.5313 357.442H39.2549V365.399Z\" fill=#455A64 /><path d=\"M76.1449 364.486L70.9742 388.364H48.513L43.6807 364.486H76.1449Z\" fill=#455A64 /><path d=\"M39.2549 365.397C39.2549 365.51 48.347 365.571 59.5472 365.536C70.7561 365.501 79.8482 365.388 79.8482 365.284C79.8482 365.172 70.7648 365.111 59.5472 365.145C48.3383 365.172 39.2549 365.284 39.2549 365.397Z\" fill=#455A64 /><path d=\"M46.3445 377.182C46.3965 377.26 47.5677 376.063 49.9882 375.091C51.1855 374.614 52.7124 374.241 54.4128 374.206C56.1219 374.154 57.9785 374.562 59.8524 375.204C61.7351 375.837 63.4962 376.583 65.214 376.991C66.9318 377.364 68.5368 377.338 69.8468 377.13C71.1568 376.922 72.1718 376.54 72.8225 376.184C73.1435 376.002 73.3864 375.854 73.5426 375.724C73.6988 375.611 73.7768 375.542 73.7682 375.533C73.7421 375.499 73.4125 375.742 72.7618 376.045C72.1024 376.349 71.0961 376.687 69.8121 376.852C68.5281 377.017 66.9665 377.017 65.3007 376.635C63.6437 376.219 61.8912 375.473 59.9913 374.831C58.1 374.18 56.174 373.763 54.4128 373.841C52.6517 373.902 51.1074 374.31 49.8928 374.839C48.6695 375.351 47.776 375.958 47.1947 376.41C46.8997 376.635 46.6915 376.826 46.5527 376.965C46.4052 377.095 46.3358 377.173 46.3445 377.182Z\" fill=#263238 /><path d=\"M46.6659 378.778C46.7179 378.856 47.8457 377.693 50.1621 376.721C51.316 376.244 52.7822 375.871 54.4305 375.845C56.0789 375.802 57.8834 376.175 59.6967 376.791C61.5185 377.398 63.2276 378.11 64.8587 378.544C66.4897 378.986 68.0253 379.142 69.3093 379.047C70.5933 378.96 71.591 378.596 72.2243 378.266C72.5366 378.092 72.7708 377.945 72.9183 377.823C73.0658 377.711 73.1439 377.65 73.1352 377.633C73.1092 377.598 72.7969 377.832 72.1549 378.127C71.5129 378.405 70.5325 378.717 69.2832 378.769C68.0339 378.83 66.5417 378.656 64.9454 378.197C63.3491 377.745 61.6487 377.034 59.8094 376.418C57.9789 375.793 56.1136 375.411 54.4132 375.481C52.7128 375.533 51.2119 375.941 50.0407 376.47C48.8608 376.982 48.0192 377.589 47.464 378.032C47.1864 378.249 46.9782 378.439 46.848 378.57C46.7179 378.691 46.6572 378.76 46.6659 378.778Z\" fill=white /><path d=\"M45.9324 375.591C45.9844 375.67 47.199 374.446 49.6716 373.388C50.9035 372.867 52.4478 372.398 54.2089 372.294C55.9701 372.173 57.8874 372.624 59.8221 373.283C61.7741 373.934 63.5786 374.732 65.3658 375.097C67.153 375.418 68.8013 375.322 70.1461 375.106C71.4908 374.871 72.5405 374.489 73.2172 374.134C73.5469 373.952 73.8072 373.795 73.9633 373.674C74.1282 373.552 74.2063 373.483 74.1976 373.474C74.1716 373.44 73.8332 373.691 73.1565 373.995C72.4711 374.299 71.4301 374.637 70.1114 374.828C68.7927 375.01 67.1703 375.071 65.4439 374.741C63.7261 374.377 61.9129 373.57 59.9522 372.91C58.0002 372.242 56.0135 371.782 54.1916 371.93C52.3784 372.06 50.7994 372.563 49.5675 373.127C48.3182 373.683 47.4072 374.325 46.8086 374.784C46.505 375.019 46.2881 375.218 46.1493 375.357C45.9931 375.505 45.9237 375.583 45.9324 375.591Z\" fill=white /><path d=\"M38.8818 365.432C38.8818 365.545 48.1821 365.631 59.6513 365.631C71.1205 365.631 80.4208 365.545 80.4208 365.432C80.4208 365.319 71.1205 365.232 59.6513 365.232C48.1734 365.232 38.8818 365.319 38.8818 365.432Z\" fill=#263238 /><path opacity=0.4 d=\"M296.58 180.918L296.191 178.921C295.947 177.654 295.899 176.583 296.045 175.657C296.191 174.732 296.434 173.952 296.824 173.222C297.214 172.491 297.603 171.858 297.993 171.273C298.529 170.494 299.016 169.763 299.454 169.033C299.844 168.302 299.941 167.425 299.746 166.403C299.649 165.867 299.405 165.38 299.064 165.087C298.723 164.746 298.334 164.552 297.895 164.405C297.457 164.259 297.067 164.259 296.678 164.308C295.947 164.454 295.363 164.746 294.924 165.185C294.486 165.623 294.194 166.159 293.95 166.744C293.756 167.328 293.561 167.961 293.463 168.594L288.69 167.425C288.739 166.938 288.885 166.305 289.129 165.526C289.372 164.746 289.762 163.918 290.298 163.09C290.833 162.262 291.613 161.483 292.538 160.752C293.512 160.07 294.73 159.583 296.191 159.242C297.652 158.95 298.967 158.95 300.233 159.194C301.499 159.437 302.571 160.022 303.448 160.898C304.324 161.775 304.957 163.09 305.298 164.746C305.591 166.159 305.639 167.328 305.396 168.253C305.201 169.179 304.86 170.007 304.422 170.738C303.983 171.468 303.545 172.15 303.107 172.832C302.766 173.368 302.425 173.904 302.181 174.488C301.889 175.073 301.694 175.755 301.597 176.485C301.499 177.216 301.548 178.044 301.743 179.018L301.889 179.798L296.58 180.918ZM300.866 188.419C299.941 188.614 299.162 188.516 298.48 188.127C297.798 187.737 297.36 187.153 297.214 186.325C297.067 185.545 297.214 184.815 297.701 184.181C298.188 183.548 298.869 183.11 299.746 182.915C300.623 182.72 301.402 182.866 302.084 183.256C302.766 183.694 303.204 184.279 303.35 185.058C303.496 185.886 303.35 186.568 302.912 187.201C302.425 187.835 301.743 188.224 300.866 188.419Z\" fill=#55A3F3 /><path opacity=0.4 d=\"M99.6392 217.492L98.8599 215.788C98.3729 214.716 98.0806 213.742 98.0319 212.914C97.9832 212.086 98.0319 211.306 98.2268 210.576C98.4216 209.894 98.6164 209.212 98.8599 208.627C99.2008 207.848 99.4443 207.069 99.6879 206.338C99.8827 205.607 99.7853 204.828 99.3956 203.951C99.2008 203.464 98.8599 203.123 98.519 202.928C98.1293 202.734 97.7397 202.587 97.3014 202.587C96.8631 202.539 96.5221 202.636 96.1812 202.782C95.5481 203.075 95.1097 203.464 94.8175 203.951C94.5253 204.438 94.3792 204.974 94.2818 205.51C94.2331 206.095 94.1844 206.679 94.2331 207.264L89.7523 207.215C89.7036 206.776 89.7036 206.192 89.7523 205.413C89.8011 204.682 89.9959 203.854 90.2881 202.977C90.5803 202.1 91.116 201.272 91.7979 200.444C92.4797 199.616 93.4538 198.934 94.7201 198.35C95.9377 197.814 97.1553 197.473 98.3242 197.473C99.493 197.424 100.565 197.717 101.539 198.35C102.513 198.934 103.341 199.957 103.974 201.37C104.509 202.539 104.802 203.562 104.802 204.438C104.802 205.315 104.704 206.095 104.461 206.825C104.217 207.556 103.974 208.238 103.73 208.968C103.535 209.504 103.389 210.04 103.243 210.673C103.097 211.258 103.097 211.891 103.146 212.573C103.195 213.255 103.438 213.985 103.828 214.813L104.12 215.495L99.6392 217.492ZM104.997 223.24C104.217 223.581 103.487 223.679 102.805 223.484C102.123 223.289 101.636 222.85 101.295 222.169C101.003 221.487 101.003 220.853 101.295 220.171C101.587 219.49 102.123 219.002 102.854 218.613C103.584 218.272 104.315 218.223 104.997 218.418C105.678 218.661 106.165 219.1 106.506 219.782C106.799 220.464 106.847 221.146 106.555 221.779C106.312 222.412 105.776 222.899 104.997 223.24Z\" fill=#55A3F3 /><g opacity=0.03><path opacity=0.4 d=\"M300.118 219.854L300.313 218.588C300.459 217.808 300.654 217.127 300.946 216.639C301.238 216.152 301.579 215.714 301.92 215.373C302.309 215.032 302.65 214.74 303.04 214.496C303.527 214.155 303.965 213.814 304.355 213.522C304.745 213.181 304.988 212.694 305.086 212.061C305.134 211.72 305.086 211.428 304.988 211.135C304.842 210.892 304.696 210.648 304.452 210.453C304.209 210.259 304.014 210.161 303.771 210.112C303.332 210.015 302.894 210.064 302.553 210.259C302.212 210.405 301.92 210.648 301.676 210.94C301.433 211.233 301.189 211.574 300.994 211.915L298.462 210.21C298.608 209.918 298.852 209.625 299.144 209.187C299.436 208.797 299.874 208.408 300.361 208.018C300.848 207.628 301.482 207.336 302.163 207.141C302.894 206.946 303.673 206.946 304.599 207.092C305.524 207.239 306.303 207.531 306.985 207.969C307.667 208.408 308.154 208.943 308.495 209.674C308.836 210.405 308.884 211.281 308.738 212.304C308.592 213.181 308.349 213.863 308.056 214.35C307.716 214.837 307.375 215.276 306.936 215.568C306.547 215.86 306.108 216.201 305.719 216.493C305.427 216.737 305.086 216.98 304.793 217.273C304.501 217.565 304.258 217.906 304.014 218.296C303.819 218.685 303.624 219.221 303.527 219.806L303.43 220.293L300.118 219.854ZM300.994 225.115C300.41 225.017 299.972 224.774 299.68 224.433C299.387 224.043 299.241 223.605 299.339 223.118C299.436 222.631 299.679 222.241 300.118 221.949C300.556 221.656 301.043 221.608 301.579 221.656C302.115 221.754 302.553 221.997 302.845 222.387C303.137 222.777 303.284 223.215 303.186 223.702C303.089 224.189 302.845 224.579 302.456 224.823C302.066 225.115 301.579 225.212 300.994 225.115Z\" fill=#55A3F3 /></g><g opacity=0.03><path opacity=0.4 d=\"M105.337 189.144L105.288 187.878C105.288 187.099 105.337 186.417 105.532 185.881C105.727 185.345 105.97 184.858 106.262 184.517C106.555 184.127 106.847 183.786 107.188 183.445C107.626 183.056 107.967 182.617 108.308 182.228C108.649 181.838 108.795 181.302 108.746 180.669C108.746 180.328 108.649 180.036 108.454 179.792C108.259 179.549 108.064 179.403 107.821 179.256C107.577 179.11 107.334 179.062 107.09 179.062C106.652 179.062 106.262 179.208 105.921 179.403C105.629 179.646 105.386 179.89 105.191 180.231C104.996 180.572 104.85 180.913 104.704 181.302L101.928 180.084C102.025 179.792 102.171 179.451 102.415 178.964C102.658 178.526 102.951 178.039 103.389 177.6C103.827 177.162 104.363 176.772 104.996 176.431C105.629 176.09 106.408 175.944 107.334 175.896C108.259 175.896 109.038 175.993 109.769 176.285C110.5 176.577 111.084 177.016 111.522 177.649C111.961 178.282 112.204 179.11 112.253 180.182C112.253 181.059 112.155 181.741 111.961 182.325C111.717 182.861 111.474 183.348 111.133 183.738C110.792 184.127 110.451 184.517 110.11 184.858C109.866 185.15 109.574 185.442 109.379 185.783C109.136 186.124 108.941 186.514 108.844 186.952C108.698 187.391 108.649 187.878 108.649 188.511V188.998L105.337 189.144ZM107.139 194.113C106.555 194.113 106.116 193.967 105.727 193.674C105.337 193.382 105.142 192.992 105.142 192.457C105.142 191.97 105.288 191.531 105.678 191.19C106.019 190.849 106.506 190.654 107.042 190.654C107.577 190.654 108.064 190.8 108.405 191.141C108.795 191.482 108.941 191.872 108.99 192.359C108.99 192.846 108.844 193.285 108.503 193.577C108.162 193.967 107.723 194.113 107.139 194.113Z\" fill=#55A3F3 /></g></g><defs><clipPath id=clip0><rect width=388 height=390 fill=white /></clipPath></defs></svg></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000 data-aos-anchor-placement=top-bottom><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\">Hey there, We would love to get to know you! Please tell us your name:</span><div class=profile_popup_input><label for=name>Name</label><input type=text name=name id=username placeholder=\"Your Name\" ng-model=userData.name></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=profileTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=profileTab(false,userData.name);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- Profile tab --><div class=row ng-if=profile_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000><svg width=334 height=307 viewBox=\"0 0 334 307\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M173.725 80.1175L178.67 78.6146L200.146 77.9844L204.994 79.3014L204.364 91.1144L193.399 98.1036L182.766 97.8935L176.084 91.8012L174.605 85.7654L173.725 80.1175Z\" fill=#FFBE9D /><path d=\"M235.755 98.7094C234.468 96.009 233.013 93.3915 231.4 90.8718C228.791 86.8667 224.799 83.9619 220.185 82.711L202.66 77.96C202.66 77.96 201.755 95.4693 189.732 95.4693C177.709 95.4693 175.333 79.0588 175.333 79.0588L155.052 87.1388C154.357 87.4055 149.647 89.0376 144.177 100.77C138.965 111.944 136.687 117.665 136.687 117.665L157.581 123.693L158.882 142.487L158.147 166.824H221.979L221.131 141.024L221.729 122.004L222.537 123.281L243.633 114.821C243.633 114.821 240.886 109.278 235.755 98.7094Z\" fill=#16B9D6 /><path d=\"M158.381 158.688C157.928 160.53 156.765 164.626 156.046 166.347C155.897 166.876 155.897 167.435 156.046 167.963C156.296 168.489 157.347 168.295 157.92 168.181C163.189 167.155 169.014 168.004 174.161 169.539C179.51 171.155 184.665 174.112 190.216 174.015C193.973 173.951 197.545 172.488 201.156 171.43C207.857 169.471 214.88 168.864 221.817 169.644C222.286 169.749 222.777 169.689 223.207 169.474C223.821 169.054 223.772 168.157 223.651 167.422C223.385 165.685 221.55 160.909 221.106 159.188\" fill=#16B9D6 /><path d=\"M154.818 98.3291C154.939 98.3291 155.626 104.114 156.313 111.257C156.999 118.4 157.5 124.25 157.387 124.258C157.274 124.266 156.579 118.473 155.892 111.33C155.206 104.187 154.705 98.3372 154.818 98.3291Z\" fill=#263238 /><path d=\"M222.787 100.915C222.9 100.915 222.722 106.321 222.383 112.97C222.043 119.62 221.672 125.01 221.575 125.002C221.478 124.993 221.639 119.596 221.979 112.946C222.318 106.296 222.674 100.907 222.787 100.915Z\" fill=#263238 /><path d=\"M206.134 78.8564C206.13 79.0449 206.103 79.2323 206.053 79.414C205.98 79.818 205.875 80.3432 205.746 81.03C205.351 82.978 204.844 84.9015 204.227 86.791C203.337 89.6251 201.883 92.2498 199.952 94.5074C198.788 95.8206 197.398 96.9151 195.848 97.7394C194.162 98.6287 192.284 99.0893 190.378 99.0807C186.692 99.0007 183.16 97.5918 180.431 95.1134C178.245 93.1007 176.52 90.6394 175.373 87.898C174.589 86.0762 173.985 84.1818 173.571 82.242C173.426 81.5552 173.329 81.0219 173.28 80.626C173.239 80.443 173.217 80.2561 173.216 80.0684C173.283 80.2434 173.332 80.4248 173.361 80.6098L173.733 82.1854C174.202 84.1019 174.84 85.973 175.64 87.7768C176.806 90.4561 178.527 92.8575 180.69 94.8226C183.361 97.2169 186.8 98.578 190.386 98.6606C192.223 98.6671 194.034 98.2261 195.662 97.3758C197.186 96.5718 198.554 95.5019 199.702 94.2165C201.615 92.0033 203.071 89.4328 203.984 86.6537C204.792 84.3024 205.277 82.3228 205.6 80.9976L205.988 79.4301C206.023 79.2358 206.072 79.0441 206.134 78.8564Z\" fill=#263238 /><path d=\"M180.883 91.4452C180.956 91.5422 180.528 91.9543 179.938 92.3744C179.348 92.7946 178.807 93.0451 178.742 92.9481C178.677 92.8512 179.097 92.4391 179.695 92.027C180.293 91.6149 180.818 91.3563 180.883 91.4452Z\" fill=#263238 /><path d=\"M188.075 98.8306C187.936 98.2709 187.936 97.6855 188.075 97.1258C188.086 96.5625 188.227 96.0094 188.487 95.5098C188.608 95.5098 188.608 96.3178 188.487 97.2146C188.478 97.7781 188.337 98.3315 188.075 98.8306Z\" fill=#263238 /><path d=\"M198.708 95.8253C198.627 95.9061 197.957 95.4052 197.213 94.6941C196.47 93.9831 195.937 93.3529 196.01 93.264C196.082 93.1751 196.761 93.6841 197.504 94.3952C198.248 95.1062 198.789 95.7203 198.708 95.8253Z\" fill=#263238 /><path d=\"M203.119 88.7307C203.054 88.8277 202.448 88.5449 201.713 88.2055C200.978 87.8662 200.356 87.5995 200.388 87.4783C200.42 87.3571 201.115 87.4783 201.883 87.8258C202.65 88.1732 203.184 88.6338 203.119 88.7307Z\" fill=#263238 /><path d=\"M176.455 84.0928C176.496 84.1978 176.068 84.4564 175.502 84.6665C174.936 84.8765 174.443 84.9654 174.403 84.8523C174.363 84.7392 174.791 84.4887 175.356 84.2786C175.922 84.0685 176.455 83.9877 176.455 84.0928Z\" fill=#263238 /><g opacity=0.3><path opacity=0.3 d=\"M222.625 104.131L224.742 122.416L222.504 123.313L221.712 122.036L222.625 104.131Z\" fill=black /></g><path d=\"M150.6 99.0646C149.821 98.9283 149.088 98.6007 148.467 98.1111C147.376 97.4001 146.657 96.6163 146.738 96.4951C148.061 97.2814 149.35 98.1253 150.6 99.0242V99.0646Z\" fill=white /><path d=\"M167.689 101.699C166.519 101.794 165.342 101.75 164.182 101.57C163.007 101.53 161.84 101.348 160.708 101.029C161.881 100.935 163.06 100.978 164.223 101.158C165.396 101.193 166.561 101.375 167.689 101.699Z\" fill=white /><path d=\"M186.201 105.101C185.031 105.107 183.862 105.004 182.71 104.794C181.543 104.724 180.383 104.554 179.244 104.285C180.414 104.139 181.598 104.169 182.759 104.374C183.936 104.447 185.095 104.692 186.201 105.101Z\" fill=white /><path d=\"M209.714 102.701C208.4 103.131 207.047 103.426 205.674 103.582C204.327 103.875 202.955 104.032 201.577 104.051C204.234 103.328 206.958 102.875 209.706 102.701H209.714Z\" fill=white /><path d=\"M224.128 97.2305C223.627 97.8765 222.955 98.3692 222.189 98.6526C221.481 99.0625 220.671 99.2615 219.854 99.2262C220.551 98.8606 221.271 98.5421 222.011 98.2728C222.692 97.8772 223.399 97.529 224.128 97.2305Z\" fill=white /><path d=\"M232.491 95.0977C231.727 95.7057 230.851 96.1585 229.913 96.4309C229.022 96.8379 228.057 97.0605 227.077 97.0853C227.947 96.6601 228.853 96.3113 229.784 96.043C230.653 95.6395 231.56 95.3229 232.491 95.0977Z\" fill=white /><path d=\"M215.41 93.9746C213.057 94.8128 210.618 95.3873 208.138 95.6876C209.287 95.1994 210.488 94.8442 211.717 94.6291C212.919 94.2715 214.158 94.0519 215.41 93.9746Z\" fill=white /><path d=\"M227.11 88.7549C226.208 89.436 225.226 90.0032 224.185 90.4436C223.203 91.005 222.155 91.4446 221.066 91.7526C222.949 90.5068 224.979 89.4999 227.11 88.7549Z\" fill=white /><path d=\"M214.432 87.2523C212.843 87.8982 211.159 88.2777 209.446 88.3754C210.207 87.989 211.026 87.7298 211.87 87.6078C212.699 87.3516 213.564 87.2315 214.432 87.2523Z\" fill=white /><path d=\"M222.229 84.8283C222.277 84.9414 221.768 85.2484 221.098 85.5232C220.427 85.7979 219.853 85.9272 219.805 85.8221C219.756 85.7171 220.274 85.402 220.944 85.1353C221.615 84.8687 222.188 84.7232 222.229 84.8283Z\" fill=white /><path d=\"M191.76 101.376C190.574 101.621 189.354 101.654 188.156 101.473C186.946 101.416 185.755 101.143 184.642 100.665C185.832 100.716 187.019 100.834 188.197 101.021C189.39 101.072 190.58 101.19 191.76 101.376Z\" fill=white /><path d=\"M203.581 98.0867C203.581 98.1998 202.935 98.4827 202.07 98.717C201.206 98.9513 200.454 99.0483 200.454 98.9351C200.454 98.822 201.1 98.5473 201.965 98.3049C202.83 98.0625 203.549 97.9736 203.581 98.0867Z\" fill=white /><path d=\"M175.818 97.9175C174.863 98.0342 173.896 98.0097 172.949 97.8448C171.987 97.8191 171.034 97.6502 170.121 97.3438C171.076 97.2321 172.042 97.2593 172.99 97.4246C173.951 97.4555 174.903 97.6214 175.818 97.9175Z\" fill=white /><path d=\"M163.132 94.8639C162.081 94.863 161.035 94.7217 160.021 94.4437C158.982 94.3123 157.965 94.0405 156.999 93.6357C158.05 93.6367 159.096 93.778 160.11 94.0559C161.148 94.1918 162.164 94.4634 163.132 94.8639Z\" fill=white /><path d=\"M163.997 87.8097C163.213 87.9474 162.412 87.9474 161.629 87.8097C160.831 87.8071 160.041 87.6621 159.294 87.3814C160.08 87.2439 160.884 87.2439 161.669 87.3814C162.464 87.3846 163.252 87.5296 163.997 87.8097Z\" fill=white /><path d=\"M172.537 90.8151C171.853 91.0863 171.101 91.1344 170.388 90.9525C169.655 90.9064 168.958 90.6227 168.4 90.1445C169.095 90.2387 169.783 90.3736 170.461 90.5485C171.159 90.5872 171.853 90.6763 172.537 90.8151Z\" fill=white /><path d=\"M171.543 84.8436C170.841 84.8569 170.144 84.7305 169.491 84.4719C168.798 84.333 168.139 84.0584 167.552 83.6639C168.253 83.6455 168.952 83.7691 169.604 84.0275C170.299 84.167 170.958 84.4445 171.543 84.8436Z\" fill=white /><path d=\"M211.702 81.9843C211.702 82.0975 211.217 82.3479 210.554 82.5499C209.892 82.7519 209.318 82.8166 209.286 82.7035C209.253 82.5903 209.762 82.3399 210.433 82.1459C211.104 81.952 211.669 81.8954 211.702 81.9843Z\" fill=white /><path d=\"M151.06 106.854C149.414 106.392 147.853 105.666 146.438 104.705C148.088 105.159 149.65 105.885 151.06 106.854Z\" fill=white /><path d=\"M144.136 113.932C143.32 113.989 142.501 113.91 141.712 113.697C140.895 113.611 140.097 113.39 139.353 113.043C140.992 113.056 142.616 113.357 144.152 113.932H144.136Z\" fill=white /><path d=\"M153.735 117.31C152.737 117.088 151.757 116.794 150.802 116.429C149.805 116.199 148.825 115.899 147.869 115.532C149.949 115.585 151.976 116.2 153.735 117.31Z\" fill=white /><path d=\"M163.528 109.456C161.821 109.736 160.08 109.736 158.373 109.456C160.08 109.176 161.821 109.176 163.528 109.456Z\" fill=white /><path d=\"M167.568 120.154C166.461 119.943 165.366 119.673 164.288 119.346C163.176 119.133 162.076 118.863 160.991 118.538C163.288 118.483 165.559 119.04 167.568 120.154Z\" fill=white /><path d=\"M186.532 115.54C185.977 115.62 185.414 115.62 184.859 115.54C183.505 115.449 182.156 115.285 180.819 115.047C179.492 114.815 178.179 114.513 176.884 114.142C176.334 114.025 175.803 113.829 175.309 113.561C175.309 113.439 177.805 114.094 180.892 114.635C183.978 115.177 186.54 115.419 186.532 115.54Z\" fill=white /><path d=\"M186.628 122.44C185.412 122.579 184.184 122.579 182.968 122.44C181.746 122.449 180.528 122.311 179.34 122.028C180.554 121.894 181.778 121.894 182.992 122.028C184.216 122.03 185.435 122.168 186.628 122.44Z\" fill=white /><path d=\"M198.538 110.579C196.183 110.918 193.797 110.978 191.428 110.757C193.783 110.417 196.169 110.358 198.538 110.579Z\" fill=white /><path d=\"M208.671 119.467C206.985 119.863 205.269 120.118 203.541 120.226C201.826 120.475 200.094 120.588 198.361 120.566C200.049 120.178 201.765 119.924 203.492 119.806C205.207 119.557 206.939 119.444 208.671 119.467Z\" fill=white /><path d=\"M216.856 109.513C215.313 110.097 213.724 110.551 212.105 110.87C210.519 111.329 208.897 111.651 207.257 111.832C208.799 111.242 210.388 110.785 212.008 110.466C213.594 110.013 215.216 109.694 216.856 109.513Z\" fill=white /><path d=\"M217.721 116.049C217.234 116.57 216.605 116.935 215.911 117.099C215.257 117.389 214.532 117.482 213.826 117.366C214.452 117.081 215.104 116.86 215.773 116.703C216.398 116.418 217.051 116.199 217.721 116.049Z\" fill=white /><path d=\"M229.639 102.903C228.856 103.346 228.008 103.663 227.126 103.841C226.285 104.158 225.398 104.338 224.5 104.374C225.285 103.935 226.132 103.619 227.013 103.437C227.857 103.129 228.742 102.949 229.639 102.903Z\" fill=white /><path d=\"M235.699 110.417C232.936 111.416 230.084 112.152 227.183 112.615C228.538 112.047 229.945 111.612 231.384 111.314C232.79 110.874 234.235 110.574 235.699 110.417Z\" fill=white /><path d=\"M237.816 104.155C236.902 104.759 235.913 105.242 234.875 105.594C233.89 106.074 232.847 106.427 231.772 106.644C233.674 105.563 235.705 104.726 237.816 104.155Z\" fill=white /><path d=\"M231.594 116.954C230.133 118.027 228.514 118.866 226.795 119.443C228.256 118.37 229.876 117.531 231.594 116.954Z\" fill=white /><path d=\"M170.267 133.534C169.137 133.653 167.998 133.634 166.873 133.478C165.737 133.457 164.608 133.297 163.512 133.001C164.641 132.883 165.781 132.902 166.905 133.058C168.041 133.078 169.17 133.238 170.267 133.534Z\" fill=white /><path d=\"M175.947 129.082C173.47 128.817 171.031 128.275 168.675 127.466C169.924 127.521 171.163 127.719 172.367 128.056C173.595 128.261 174.796 128.605 175.947 129.082Z\" fill=white /><path d=\"M196.575 129.041C194.57 129.322 192.536 129.322 190.531 129.041C192.536 128.761 194.57 128.761 196.575 129.041Z\" fill=white /><path d=\"M193.198 136.29C192.672 136.437 192.127 136.503 191.582 136.483C190.298 136.53 189.013 136.484 187.736 136.346C186.457 136.211 185.19 135.978 183.946 135.651C183.422 135.553 182.915 135.376 182.443 135.126C182.443 135.005 184.819 135.619 187.784 135.934C190.75 136.249 193.19 136.16 193.198 136.29Z\" fill=white /><path d=\"M215.773 131.167C214.237 131.557 212.655 131.736 211.07 131.701C209.49 131.803 207.903 131.694 206.352 131.377C206.352 131.256 208.469 131.337 211.062 131.281C213.656 131.224 215.757 131.046 215.773 131.167Z\" fill=white /><path d=\"M215.418 124.598C213.341 125.233 211.189 125.591 209.019 125.664C211.096 125.031 213.247 124.672 215.418 124.598Z\" fill=white /><path d=\"M167.778 163.528C166.562 163.55 165.346 163.509 164.134 163.407C162.919 163.45 161.703 163.431 160.49 163.35C161.68 163.016 162.919 162.893 164.15 162.986C165.382 162.951 166.611 163.134 167.778 163.528Z\" fill=white /><path d=\"M180.933 167.438C179.442 167.507 177.949 167.431 176.473 167.212C174.98 167.133 173.498 166.916 172.045 166.566C173.538 166.497 175.035 166.573 176.513 166.792C178.003 166.87 179.483 167.086 180.933 167.438Z\" fill=white /><path d=\"M193.731 170.46C192.31 170.943 190.827 171.215 189.327 171.268C187.836 171.458 186.326 171.431 184.843 171.187C184.843 171.066 186.847 171.05 189.295 170.856C191.743 170.662 193.707 170.339 193.731 170.46Z\" fill=white /><path d=\"M192.495 164.472C191.331 164.733 190.141 164.864 188.948 164.86C187.764 164.997 186.569 164.997 185.385 164.86C186.544 164.588 187.733 164.458 188.924 164.472C190.11 164.326 191.309 164.326 192.495 164.472Z\" fill=white /><path d=\"M181.821 160.893C180.216 161.129 178.594 161.229 176.973 161.192C175.34 161.289 173.702 161.248 172.076 161.071C173.694 160.834 175.33 160.734 176.965 160.772C178.584 160.676 180.208 160.717 181.821 160.893Z\" fill=white /><path d=\"M206.707 160.659C205.162 160.986 203.591 161.175 202.013 161.225C200.445 161.415 198.863 161.463 197.286 161.37C198.832 161.048 200.403 160.859 201.981 160.804C203.549 160.619 205.131 160.571 206.707 160.659Z\" fill=white /><path d=\"M207.596 165.499C207.596 165.628 205.503 165.79 202.999 166.404C200.494 167.018 198.547 167.826 198.498 167.713C199.85 166.879 201.342 166.296 202.902 165.992C204.426 165.555 206.015 165.388 207.596 165.499Z\" fill=white /><path d=\"M219.861 162.783C219.19 163.063 218.472 163.214 217.744 163.228C217.032 163.37 216.299 163.37 215.587 163.228C216.967 162.793 218.42 162.634 219.861 162.759V162.783Z\" fill=white /><path d=\"M205.197 82.2832C205.149 82.3883 204.494 82.1539 203.686 81.8792C202.878 81.6045 202.216 81.4106 202.232 81.2894C202.777 81.1766 203.344 81.2447 203.848 81.4833C204.664 81.7661 205.254 82.1863 205.197 82.2832Z\" fill=#263238 /><path d=\"M171.689 143.893C170.212 143.951 168.732 143.867 167.27 143.643C165.795 143.559 164.332 143.337 162.898 142.98C164.374 142.918 165.851 143.001 167.31 143.23C168.787 143.314 170.254 143.536 171.689 143.893Z\" fill=white /><path d=\"M185.183 142.026C184.07 142.172 182.943 142.172 181.83 142.026C180.71 142.021 179.595 141.88 178.509 141.606C179.622 141.461 180.749 141.461 181.862 141.606C182.982 141.612 184.097 141.753 185.183 142.026Z\" fill=white /><path d=\"M206.554 140.524C206.554 140.645 204.639 140.629 202.304 140.839C199.968 141.049 198.086 141.38 198.062 141.259C199.411 140.771 200.829 140.498 202.263 140.451C203.688 140.246 205.137 140.27 206.554 140.524Z\" fill=white /><path d=\"M216.25 148.111C214.284 148.294 212.307 148.337 210.335 148.24C208.362 148.279 206.388 148.179 204.429 147.941C206.394 147.753 208.371 147.71 210.343 147.812C212.317 147.773 214.29 147.873 216.25 148.111Z\" fill=white /><path d=\"M217.01 138.391C215.672 139.132 214.123 139.4 212.614 139.15C213.326 138.93 214.061 138.789 214.804 138.73C215.525 138.538 216.264 138.424 217.01 138.391Z\" fill=white /><path d=\"M193.505 147.893C192.41 148.318 191.233 148.489 190.063 148.394C188.887 148.436 187.716 148.215 186.637 147.747C186.637 147.626 188.18 147.941 190.071 147.974C191.961 148.006 193.48 147.772 193.505 147.893Z\" fill=white /><path d=\"M181.085 149.307C178.872 149.587 176.632 149.587 174.419 149.307C176.632 149.027 178.872 149.027 181.085 149.307Z\" fill=white /><path d=\"M172.141 154.009C170.377 154.232 168.589 154.181 166.841 153.855C167.714 153.668 168.611 153.621 169.499 153.718C170.39 153.67 171.282 153.768 172.141 154.009Z\" fill=white /><path d=\"M191.242 155.698C189.831 155.862 188.407 155.884 186.992 155.763C185.57 155.781 184.149 155.662 182.75 155.407C184.164 155.247 185.59 155.226 187.008 155.342C188.428 155.324 189.846 155.443 191.242 155.698Z\" fill=white /><path d=\"M207.911 153.257C206.674 153.3 205.436 153.271 204.202 153.168C202.962 153.202 201.721 153.164 200.485 153.055C201.701 152.744 202.96 152.641 204.21 152.748C205.463 152.713 206.714 152.885 207.911 153.257Z\" fill=white /><path d=\"M219.887 156.732C218.632 156.888 217.369 156.969 216.105 156.975C214.845 157.121 213.577 157.192 212.308 157.185C214.773 156.497 217.357 156.343 219.887 156.732Z\" fill=white /><path d=\"M162.72 149.614C162.72 149.727 162.114 149.921 161.314 150.042C160.514 150.163 159.859 150.179 159.843 150.042C159.827 149.905 160.457 149.735 161.249 149.606C162.041 149.476 162.72 149.493 162.72 149.614Z\" fill=white /><path d=\"M164.109 125.204C164.109 125.325 163.35 125.487 162.388 125.568C161.805 125.688 161.201 125.668 160.627 125.511C161.746 125.13 162.941 125.025 164.109 125.204Z\" fill=white /><path d=\"M175.333 107.444C174.751 107.581 174.146 107.581 173.564 107.444C172.602 107.315 171.835 107.121 171.851 107C172.433 106.863 173.038 106.863 173.62 107C174.582 107.129 175.349 107.323 175.333 107.444Z\" fill=white /><path d=\"M217.47 105.683C216.2 106.11 214.89 106.406 213.559 106.563C212.254 106.858 210.922 107.016 209.584 107.032C210.854 106.603 212.164 106.305 213.495 106.143C214.8 105.848 216.132 105.694 217.47 105.683Z\" fill=white /><g opacity=0.3><path opacity=0.3 d=\"M157.944 159.059C159.124 161.022 161.588 161.83 163.883 161.96C166.178 162.089 168.481 161.693 170.759 161.96C174.331 162.396 177.514 164.432 181.013 165.313C188.972 167.3 197.173 163.058 205.35 163.026C208.137 163.026 210.909 163.495 213.696 163.608C216.484 163.721 219.393 163.438 221.776 162.04L221.574 159.051L157.944 159.059Z\" fill=black /></g><path d=\"M214.885 201.221H167.601V212.589H214.885V201.221Z\" fill=#455A64 /><path d=\"M171.293 212.589L147.223 305.961H152.41L178.807 212.589H171.293Z\" fill=#455A64 /><path d=\"M209.924 212.589L234.172 305.961H228.984L202.409 212.589H209.924Z\" fill=#455A64 /><path d=\"M202.489 212.88C202.562 212.969 195.581 219.239 186.887 226.882C178.192 234.526 171.082 240.659 171.009 240.57C170.937 240.481 177.918 234.219 186.612 226.567C195.306 218.915 202.408 212.799 202.489 212.88Z\" fill=#263238 /><path d=\"M214.246 240.877C214.174 240.974 205.989 234.68 195.961 226.834C185.934 218.989 177.87 212.557 177.943 212.46C178.016 212.363 186.193 218.657 196.22 226.503C206.247 234.349 214.311 240.789 214.246 240.877Z\" fill=#263238 /><path d=\"M214.659 212.597C214.659 212.71 204.332 212.807 191.598 212.807C178.864 212.807 168.538 212.71 168.538 212.597C168.538 212.484 178.864 212.379 191.598 212.379C204.332 212.379 214.659 212.476 214.659 212.597Z\" fill=#263238 /><path d=\"M194.523 272.672L184.827 288.177L214.351 306.761C215.967 303.836 204.251 288.549 204.251 288.549L208.938 281.665L194.523 272.672Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M194.458 272.672L184.803 288.177L214.335 306.761C215.951 303.836 204.227 288.549 204.227 288.549L208.913 281.665L194.458 272.672Z\" fill=black /></g><path d=\"M195.905 281.56C195.575 281.472 195.225 281.505 194.918 281.653C194.611 281.802 194.368 282.055 194.232 282.368C194.126 282.701 194.15 283.061 194.3 283.376C194.451 283.692 194.715 283.938 195.04 284.065C195.399 284.16 195.78 284.119 196.111 283.951C196.442 283.782 196.699 283.498 196.834 283.152C196.888 282.801 196.809 282.443 196.611 282.148C196.414 281.853 196.112 281.643 195.767 281.56\" fill=white /><path d=\"M184.858 288.097L186.345 285.673L214.06 304.645C214.06 304.645 215.005 306.051 214.27 306.875L184.858 288.097Z\" fill=white /><path d=\"M204.8 288.735C204.703 288.873 203.944 288.485 202.942 288.501C201.94 288.517 201.181 288.889 201.084 288.744C200.987 288.598 201.73 287.936 202.942 287.936C204.154 287.936 204.914 288.622 204.8 288.735Z\" fill=#263238 /><path d=\"M207.095 291.967C207.039 292.12 206.287 291.967 205.382 292.274C204.477 292.581 203.96 293.138 203.823 293.041C203.686 292.944 204.106 292.064 205.197 291.716C206.287 291.369 207.16 291.821 207.095 291.967Z\" fill=#263238 /><path d=\"M206.513 296.775C206.368 296.726 206.618 295.878 207.483 295.32C208.348 294.763 209.228 294.876 209.212 295.037C209.196 295.199 208.517 295.353 207.806 295.845C207.095 296.338 206.667 296.855 206.513 296.775Z\" fill=#263238 /><path d=\"M206.732 285.091C206.587 285.18 206.053 284.566 205.205 284.105C204.356 283.645 203.589 283.507 203.589 283.338C203.589 283.168 204.526 283.031 205.52 283.588C206.514 284.146 206.877 285.018 206.732 285.091Z\" fill=#263238 /><path d=\"M196.769 272.865L206.393 287.846L177.127 306.858C175.511 303.949 186.976 288.5 186.976 288.5L182.451 282.036L196.769 272.865Z\" fill=#FF725E /><g opacity=0.6><path opacity=0.6 d=\"M195.202 281.358C195.537 281.257 195.897 281.284 196.214 281.433C196.53 281.582 196.78 281.843 196.915 282.166C197.023 282.5 197 282.862 196.85 283.179C196.7 283.496 196.434 283.744 196.107 283.871C195.749 283.974 195.365 283.939 195.031 283.775C194.696 283.611 194.435 283.328 194.297 282.982C194.22 282.623 194.285 282.248 194.478 281.935C194.67 281.622 194.976 281.395 195.331 281.302\" fill=white /></g><g opacity=0.6><path opacity=0.6 d=\"M206.352 287.749L204.833 285.325L177.361 304.717C177.361 304.717 176.44 306.139 177.183 306.955L206.352 287.749Z\" fill=white /></g><path d=\"M186.403 288.662C186.5 288.799 187.259 288.403 188.261 288.403C189.263 288.403 190.023 288.767 190.12 288.622C190.217 288.476 189.465 287.813 188.253 287.813C187.041 287.813 186.29 288.549 186.403 288.662Z\" fill=#263238 /><path d=\"M184.157 291.927C184.213 292.088 184.965 291.927 185.87 292.217C186.774 292.508 187.308 293.025 187.445 292.953C187.583 292.88 187.146 291.991 186.047 291.652C184.948 291.312 184.076 291.789 184.157 291.927Z\" fill=#263238 /><path d=\"M184.802 296.734C184.956 296.678 184.689 295.837 183.808 295.288C182.928 294.738 182.063 294.868 182.079 295.029C182.095 295.191 182.782 295.336 183.493 295.797C184.204 296.257 184.649 296.807 184.802 296.734Z\" fill=#263238 /><path d=\"M184.422 285.042C184.568 285.139 185.093 284.509 185.933 284.04C186.774 283.572 187.549 283.418 187.549 283.232C187.549 283.047 186.612 282.942 185.626 283.515C184.641 284.089 184.277 284.978 184.422 285.042Z\" fill=#263238 /><path d=\"M157.678 166.598C157.678 166.598 132.016 191.945 137.381 210.084C141.655 224.418 178.807 284.533 178.807 284.533L201.116 269.941L172.085 215.87C171.784 213.224 171.244 210.611 170.469 208.064L172.085 205.907C172.085 205.907 181.708 201.35 189.788 201.867L190.507 166.848L157.678 166.598Z\" fill=#263238 /><path d=\"M189.788 201.883C189.788 201.883 204.817 205.608 207.968 205.608C209.956 205.608 208.865 211.555 209.939 213.979V214.504L188.851 270.377L210.61 283.216C210.61 283.216 227.053 241.822 230.56 234.825C234.066 227.828 239.698 211.547 241.872 206.707C244.045 201.867 241.064 193.496 237.298 186.224C233.533 178.952 221.68 166.832 221.68 166.832H190.507L189.788 201.883Z\" fill=#263238 /><path d=\"M233.283 192.494C231.963 192.062 230.613 191.73 229.243 191.5C225.954 191.001 222.592 191.498 219.588 192.926C216.584 194.355 214.077 196.65 212.388 199.516C211.714 200.713 211.128 201.958 210.635 203.241C210.678 202.87 210.768 202.506 210.901 202.158C211.213 201.185 211.628 200.248 212.138 199.362C213.793 196.388 216.336 194.004 219.411 192.542C222.485 191.081 225.939 190.615 229.292 191.209C230.297 191.376 231.283 191.646 232.233 192.017C232.6 192.135 232.952 192.295 233.283 192.494Z\" fill=#455A64 /><path d=\"M220.799 205.607C220.214 206.011 219.601 206.373 218.965 206.69C217.491 207.54 216.079 208.493 214.739 209.542C213.403 210.595 212.144 211.742 210.974 212.976C210.513 213.516 210.02 214.026 209.495 214.503C209.837 213.874 210.261 213.292 210.756 212.774C211.878 211.468 213.126 210.274 214.48 209.211C215.831 208.142 217.284 207.211 218.819 206.432C219.442 206.075 220.107 205.798 220.799 205.607Z\" fill=#455A64 /><path d=\"M172.142 205.882C172.069 205.931 171.334 204.775 169.871 203.216C168.995 202.301 168.038 201.468 167.011 200.727C164.501 198.903 161.626 197.644 158.584 197.035C157.343 196.779 156.084 196.627 154.818 196.582C152.661 196.51 151.32 196.712 151.312 196.631C151.612 196.527 151.924 196.465 152.241 196.445C152.607 196.385 152.977 196.347 153.348 196.332C153.784 196.332 154.277 196.259 154.826 196.283C156.111 196.287 157.393 196.409 158.656 196.647C160.204 196.955 161.715 197.424 163.165 198.045C164.592 198.689 165.946 199.482 167.205 200.412C168.234 201.183 169.187 202.052 170.049 203.006C170.429 203.402 170.712 203.814 170.986 204.153C171.222 204.44 171.438 204.742 171.633 205.058C171.833 205.313 172.004 205.589 172.142 205.882Z\" fill=#455A64 /><path d=\"M172.141 205.883C171.959 205.264 171.811 204.635 171.697 204C171.304 202.504 170.763 201.05 170.081 199.661C169.062 197.721 167.903 195.858 166.614 194.086C167.125 194.489 167.577 194.963 167.956 195.492C168.937 196.722 169.777 198.058 170.46 199.475C171.152 200.893 171.655 202.395 171.955 203.944C172.126 204.575 172.189 205.231 172.141 205.883Z\" fill=#455A64 /><path d=\"M178.807 284.534C178.807 284.534 178.807 284.534 178.904 284.453L179.195 284.243L180.367 283.435L184.835 280.453L200.825 269.909L200.769 270.143L188.455 246.849C182.039 234.632 176.205 223.506 171.858 215.24V215.199C171.32 212.565 170.821 210.219 170.364 208.162C169.547 205.872 168.017 203.904 166 202.546C165.461 202.193 164.896 201.88 164.312 201.609L163.859 201.415C163.762 201.366 163.706 201.342 163.714 201.334C164.547 201.587 165.339 201.96 166.065 202.441C168.152 203.779 169.742 205.767 170.59 208.097L172.141 215.118V215.078L188.834 246.63L201.1 269.957L201.173 270.103L201.035 270.192L184.956 280.615L180.431 283.516L179.235 284.267L178.928 284.453L178.807 284.534Z\" fill=#455A64 /><path d=\"M189.327 192.898C189.327 192.979 188.163 192.898 186.297 193.003C183.865 193.152 181.456 193.55 179.106 194.191C176.751 194.81 174.48 195.714 172.343 196.881C170.727 197.794 169.83 198.554 169.781 198.497C169.954 198.285 170.152 198.095 170.371 197.932C170.61 197.715 170.864 197.515 171.131 197.334C171.472 197.079 171.828 196.845 172.197 196.631C174.315 195.366 176.604 194.411 178.992 193.795C181.364 193.144 183.806 192.78 186.264 192.712C187.011 192.688 187.759 192.712 188.503 192.785C188.781 192.785 189.058 192.823 189.327 192.898Z\" fill=#455A64 /><path d=\"M189.028 188.414C188.852 188.183 188.71 187.927 188.608 187.654L187.598 185.529C186.539 183.183 185.208 180.97 183.631 178.936C182.028 176.927 179.932 175.368 177.547 174.411C176.54 174.068 175.504 173.816 174.452 173.66C174.741 173.616 175.036 173.616 175.325 173.66C176.118 173.724 176.899 173.886 177.652 174.145C180.131 175.049 182.312 176.62 183.954 178.686C185.563 180.741 186.882 183.009 187.873 185.424C188.269 186.337 188.568 187.089 188.762 187.606C188.879 187.865 188.969 188.136 189.028 188.414Z\" fill=#455A64 /><path d=\"M207.968 175.906C207.968 175.995 206.788 176.051 204.954 176.544C203.886 176.841 202.845 177.227 201.843 177.7C199.387 178.868 197.206 180.542 195.444 182.612C194.728 183.455 194.088 184.358 193.529 185.311C192.575 186.927 192.212 188.082 192.131 188.058C192.173 187.781 192.249 187.509 192.357 187.25C192.448 186.937 192.565 186.632 192.705 186.337C192.866 185.99 193.028 185.586 193.27 185.166C193.805 184.172 194.436 183.233 195.153 182.362C196.911 180.209 199.146 178.494 201.681 177.352C202.719 176.88 203.802 176.515 204.913 176.261C205.334 176.158 205.76 176.077 206.19 176.019C206.51 175.958 206.834 175.922 207.16 175.914C207.428 175.881 207.699 175.878 207.968 175.906Z\" fill=#455A64 /><path d=\"M211.531 199.838C211.466 199.895 210.674 199.03 209.107 197.988C207.014 196.678 204.763 195.638 202.409 194.893C200.068 194.1 197.649 193.558 195.193 193.277L193.925 193.189H192.939C192.67 193.22 192.399 193.22 192.131 193.189C192.389 193.085 192.662 193.02 192.939 192.995C193.206 192.995 193.537 192.946 193.917 192.922H195.209C197.705 193.126 200.167 193.636 202.538 194.441C204.925 195.191 207.191 196.279 209.269 197.673C209.628 197.919 209.971 198.189 210.295 198.481C210.55 198.682 210.787 198.904 211.006 199.144C211.208 199.353 211.385 199.586 211.531 199.838Z\" fill=#455A64 /><path d=\"M212.153 206.472C212.153 206.513 211.862 206.359 211.572 205.988C211.203 205.489 210.974 204.901 210.909 204.285C210.844 203.668 210.944 203.045 211.2 202.481C211.41 202.053 211.628 201.859 211.668 201.883C211.424 202.645 211.309 203.442 211.329 204.242C211.472 205.028 211.751 205.783 212.153 206.472Z\" fill=#455A64 /><path d=\"M211.103 211.022C211.054 211.022 210.877 210.844 210.707 210.44C210.515 209.907 210.453 209.335 210.526 208.773C210.599 208.211 210.805 207.675 211.127 207.208C211.386 206.861 211.62 206.707 211.652 206.748C211.334 207.413 211.093 208.112 210.933 208.832C210.905 209.566 210.962 210.301 211.103 211.022Z\" fill=#455A64 /><path d=\"M189.965 188.058C190.148 190.366 190.189 192.684 190.086 194.998C190.125 197.313 190.023 199.628 189.779 201.931C189.602 199.622 189.564 197.304 189.666 194.99C189.627 192.675 189.727 190.36 189.965 188.058Z\" fill=#455A64 /><path d=\"M212.525 55.8935C211.523 56.4511 210.182 55.7238 209.73 54.6734C209.366 53.5764 209.4 52.3864 209.826 51.3122C210.259 50.2514 210.561 49.1416 210.723 48.0075C210.768 46.9627 210.473 45.9316 209.883 45.0681C209.293 44.2046 208.44 43.5549 207.451 43.216C207.913 42.8118 208.289 42.3185 208.556 41.7657C208.823 41.2128 208.976 40.6118 209.005 39.9985C209.035 39.3852 208.94 38.7723 208.727 38.1964C208.514 37.6206 208.187 37.0936 207.766 36.647C206.857 35.9294 205.88 35.3017 204.849 34.7724C204.294 34.4046 203.777 33.9823 203.306 33.5119C204.173 33.7309 205.077 33.7612 205.956 33.6008C206.663 33.4449 207.319 33.1128 207.863 32.6353C208.407 32.1578 208.821 31.5504 209.067 30.8698C209.297 30.1843 209.331 29.4484 209.165 28.7447C208.999 28.041 208.641 27.3974 208.13 26.8863C207.598 26.3849 206.926 26.0592 206.203 25.9537C205.48 25.8481 204.742 25.9678 204.09 26.2965C202.837 26.9591 202.142 28.3246 201.536 29.6093C201.342 30.0052 201.157 30.4173 200.971 30.7971C199.201 28.4539 197.537 26.0379 194.806 25.2138C192.333 24.4623 189.675 25.2946 187.097 25.1087C185.223 24.9714 183.421 24.3007 181.546 24.0907C179.672 23.8806 177.506 24.2846 176.448 25.8117C175.794 26.7005 175.592 27.864 174.937 28.7528C173.58 30.587 170.663 30.8375 169.548 32.7928C168.643 34.4088 169.338 36.453 168.95 38.271C168.53 40.2426 166.906 41.6808 165.572 43.1918C164.239 44.7027 163.084 46.7874 163.827 48.6619C164.482 50.2779 166.405 51.199 167.059 52.8554C167.512 54.0674 167.18 55.4168 167.156 56.7096C167.132 58.0024 167.657 59.5376 168.917 59.8285L183.259 63.618C188.204 65.6299 193.303 67.658 198.611 67.658C203.92 67.658 209.633 65.0966 211.741 60.1921C210.962 60.1586 210.226 59.8291 209.681 59.271C210.376 58.9538 210.991 58.4863 211.483 57.9022C211.975 57.3181 212.331 56.632 212.525 55.8935Z\" fill=#263238 /><path d=\"M200.76 60.3938C202.044 56.7866 203.012 53.0747 203.653 49.2999C204.29 45.5118 203.976 41.6248 202.74 37.9879C202.538 37.4466 200.817 33.8025 200.243 33.859C199.831 33.8994 200.889 37.3011 200.679 37.6566C198.692 41.0745 198.15 45.1872 198.465 49.1383C198.813 52.9686 199.582 56.7488 200.76 60.4099\" fill=#263238 /><path d=\"M188.092 92.1964C194.022 92.0671 200.753 79.1068 200.753 79.1068L201.141 45.793C201.456 36.202 196.131 28.017 186.532 27.9766L185.644 28.025C181.339 28.2568 177.279 30.1003 174.271 33.1888C171.264 36.2773 169.528 40.3847 169.411 44.6941C169.185 53.0084 169.047 62.2034 169.338 66.6394C169.944 75.8263 179.22 76.7636 179.22 76.7636C179.22 76.7636 179.268 78.8967 179.301 81.6116C179.365 87.6797 185.716 92.4065 188.092 92.2045V92.1964Z\" fill=#FFBE9D /><path d=\"M179.219 76.7643C183.465 76.5282 187.553 75.0783 190.999 72.5869C190.999 72.5869 188.438 79.4307 179.219 79.0509V76.7643Z\" fill=#EB996E /><path d=\"M173.378 51.9101C173.395 52.253 173.544 52.576 173.794 52.8112C174.044 53.0463 174.376 53.1751 174.719 53.1705C174.887 53.1738 175.053 53.1436 175.209 53.0817C175.365 53.0197 175.507 52.9274 175.626 52.81C175.746 52.6927 175.841 52.5526 175.906 52.3981C175.971 52.2436 176.004 52.0776 176.004 51.9101C175.991 51.5678 175.844 51.2444 175.595 51.01C175.345 50.7755 175.013 50.6489 174.671 50.6577C174.503 50.6534 174.336 50.6825 174.18 50.7434C174.024 50.8043 173.882 50.8958 173.761 51.0124C173.641 51.129 173.545 51.2685 173.479 51.4226C173.413 51.5767 173.379 51.7425 173.378 51.9101Z\" fill=#263238 /><path d=\"M171.608 48.4033C171.778 48.573 172.731 47.7811 174.145 47.7084C175.559 47.6357 176.634 48.2902 176.779 48.1043C176.925 47.9185 176.666 47.7246 176.198 47.4175C175.563 47.0275 174.824 46.844 174.081 46.8924C173.34 46.9368 172.634 47.2203 172.069 47.7003C171.608 48.0478 171.495 48.3306 171.608 48.4033Z\" fill=#263238 /><path d=\"M186.151 51.5704C186.164 51.9134 186.311 52.2376 186.56 52.4733C186.81 52.7091 187.141 52.8375 187.485 52.8309C187.653 52.8352 187.82 52.8058 187.977 52.7444C188.134 52.683 188.276 52.5908 188.397 52.4734C188.517 52.3559 188.613 52.2155 188.678 52.0604C188.744 51.9053 188.777 51.7387 188.777 51.5704C188.761 51.2296 188.612 50.9086 188.364 50.675C188.115 50.4414 187.785 50.3134 187.444 50.318C187.276 50.3126 187.109 50.341 186.952 50.4015C186.796 50.462 186.653 50.5534 186.532 50.6703C186.412 50.7871 186.316 50.927 186.25 51.0816C186.185 51.2363 186.151 51.4025 186.151 51.5704Z\" fill=#263238 /><path d=\"M185.449 48.2334C185.627 48.395 186.58 47.6112 187.994 47.5385C189.408 47.4658 190.483 48.1122 190.628 47.9344C190.774 47.7567 190.515 47.5547 190.046 47.2476C189.412 46.8576 188.673 46.6741 187.929 46.7224C187.194 46.7554 186.488 47.0246 185.918 47.49C185.497 47.8456 185.344 48.1607 185.449 48.2334Z\" fill=#263238 /><path d=\"M180.964 59.3604C180.207 59.1665 179.428 59.0687 178.645 59.0695C178.29 59.0695 177.943 58.9968 177.837 58.7544C177.781 58.3838 177.843 58.0046 178.015 57.6717C178.314 56.7829 178.613 55.8456 178.936 54.8679C180.213 50.8764 181.11 47.5959 180.948 47.5474C180.787 47.4989 179.623 50.6986 178.355 54.6901C178.048 55.6705 177.757 56.6078 177.482 57.502C177.28 57.9513 177.24 58.4567 177.369 58.9321C177.428 59.0565 177.515 59.1657 177.622 59.2512C177.73 59.3366 177.856 59.3961 177.991 59.425C178.192 59.4734 178.399 59.4924 178.605 59.4816C179.393 59.5426 180.186 59.5019 180.964 59.3604Z\" fill=#263238 /><path d=\"M185.175 60.1196C184.948 60.1196 185.029 61.6548 183.769 62.8103C182.508 63.9657 180.876 63.893 180.876 64.1031C180.876 64.3132 181.256 64.3859 181.943 64.3697C182.841 64.3296 183.698 63.9783 184.367 63.3759C185.007 62.7942 185.396 61.9854 185.449 61.1216C185.474 60.4752 185.28 60.1035 185.175 60.1196Z\" fill=#263238 /><path d=\"M185.223 42.4971C185.384 42.8768 186.782 42.6183 188.455 42.7314C190.127 42.8445 191.485 43.2162 191.687 42.8607C191.776 42.691 191.525 42.3435 190.968 42.0042C190.228 41.5762 189.397 41.3323 188.544 41.2931C187.689 41.2364 186.834 41.3832 186.047 41.7214C185.441 42.0042 185.15 42.3193 185.223 42.4971Z\" fill=#263238 /><path d=\"M171.916 43.6768C172.182 43.9838 173.136 43.6041 174.34 43.5233C175.543 43.4425 176.513 43.6202 176.723 43.2728C176.812 43.1031 176.642 42.796 176.19 42.5132C175.588 42.1819 174.902 42.0358 174.218 42.0933C173.534 42.1508 172.882 42.4094 172.344 42.8365C171.916 43.2001 171.794 43.5313 171.916 43.6768Z\" fill=#263238 /><path d=\"M200.752 52.6455C200.905 52.5647 206.974 50.4396 207.111 56.7339C207.248 63.0283 200.897 61.8648 200.881 61.687C200.865 61.5092 200.752 52.6455 200.752 52.6455Z\" fill=#FFBE9D /><path d=\"M202.749 59.2629C202.749 59.2629 202.862 59.3356 203.048 59.4164C203.307 59.5191 203.596 59.5191 203.856 59.4164C204.518 59.1579 205.051 58.0913 205.059 56.9924C205.062 56.4541 204.946 55.9218 204.72 55.433C204.653 55.2407 204.541 55.0671 204.393 54.9266C204.246 54.7862 204.067 54.6828 203.872 54.625C203.745 54.5964 203.613 54.6122 203.497 54.6695C203.381 54.7269 203.288 54.8224 203.233 54.9401C203.153 55.1179 203.193 55.2471 203.161 55.2552C203.128 55.2633 203.023 55.1583 203.072 54.8916C203.102 54.7366 203.185 54.5968 203.306 54.4957C203.39 54.4269 203.487 54.3757 203.591 54.3452C203.695 54.3146 203.804 54.3054 203.912 54.3179C204.171 54.3644 204.414 54.4764 204.618 54.6433C204.822 54.8102 204.979 55.0264 205.076 55.2714C205.364 55.7802 205.525 56.3513 205.544 56.9359C205.544 58.2044 204.906 59.4084 204.001 59.6912C203.834 59.7452 203.657 59.7601 203.483 59.7349C203.309 59.7097 203.144 59.645 202.999 59.5457C202.765 59.4164 202.732 59.271 202.749 59.2629Z\" fill=#EB996E /><path d=\"M173.353 34.207C172.327 33.6576 175.341 30.3205 177.83 29.1489C181.595 27.3875 187.364 26.2563 190.871 27.2016C195.089 28.3409 198.604 30.3852 200.761 34.1828C202.845 38.0509 203.86 42.4047 203.702 46.7956C203.782 48.1295 203.503 49.4604 202.894 50.6498C202.029 52.0557 200.349 52.9526 200.47 54.8756C200.498 55.2232 200.456 55.5728 200.348 55.9042C200.24 56.2356 200.067 56.5424 199.84 56.8068C198.7 58.043 197.278 56.9118 196.608 55.7645C195.194 53.3405 194.992 50.3751 194.838 47.5471C194.617 45.5444 194.726 43.519 195.161 41.5517C195.452 40.5013 195.969 39.4994 196.171 38.4329C196.326 37.9068 196.362 37.3531 196.279 36.8113C196.195 36.2694 195.993 35.7527 195.687 35.2978C195.533 35.1103 195.359 34.9397 195.17 34.7888C194.282 34.0332 193.21 33.5272 192.063 33.3227C190.915 33.1182 189.734 33.2227 188.641 33.6252C185.11 34.9261 179.074 36.8573 177.474 35.6937C175.18 33.9969 174.622 32.8738 174.622 32.8738L173.353 34.207Z\" fill=#263238 /><path d=\"M190.523 26.3449C188.792 25.7571 186.961 25.5187 185.137 25.6436C183.313 25.7684 181.532 26.2539 179.897 27.0721C179.02 27.4873 178.235 28.0757 177.591 28.8019C176.947 29.5281 176.456 30.3771 176.148 31.2979C175.647 33.1725 176.472 35.4591 178.281 36.1459L178.403 36.2267C181.101 37.0913 182.847 36.7115 185.513 35.75C187.759 34.942 189.739 33.5199 191.977 32.7281C194.383 31.874 196.99 31.7642 199.459 32.4129C197.066 29.6391 193.984 27.5459 190.523 26.3449Z\" fill=#263238 /><path d=\"M202.506 32.5746C202.449 32.6231 201.94 32.0171 200.89 31.3142C200.294 30.8974 199.651 30.553 198.975 30.288C198.164 29.9562 197.288 29.8099 196.413 29.8598C194.81 30.039 193.289 30.6663 192.026 31.6697C191.048 32.4777 190.596 33.0917 190.539 33.0433C190.483 32.9948 190.604 32.8494 190.814 32.5585C191.111 32.15 191.452 31.776 191.832 31.4434C193.115 30.3213 194.717 29.6291 196.413 29.4638C197.352 29.4075 198.29 29.5737 199.153 29.9486C199.849 30.2381 200.503 30.6185 201.1 31.0798C201.67 31.4721 202.149 31.9818 202.506 32.5746Z\" fill=#455A64 /><path d=\"M203.12 34.8047C203.073 35.4295 202.912 36.0403 202.643 36.6065C201.516 39.4292 199.438 41.7697 196.769 43.224C196.238 43.5549 195.653 43.7901 195.04 43.9189C198.814 42.0441 201.711 38.7759 203.12 34.8047Z\" fill=#455A64 /><path d=\"M205.698 35.8311C205.735 36.0667 205.735 36.3065 205.698 36.5421C205.659 37.1949 205.567 37.8434 205.423 38.4813C204.94 40.6005 203.94 42.567 202.512 44.2053C201.083 45.8436 199.272 47.1028 197.238 47.8703C196.627 48.0999 195.997 48.2783 195.356 48.4036C195.124 48.4658 194.884 48.4903 194.645 48.4763C194.645 48.4036 195.63 48.2258 197.125 47.5875C199.071 46.7695 200.805 45.5172 202.193 43.9262C203.581 42.3353 204.586 40.448 205.132 38.4086C205.585 36.8411 205.617 35.823 205.698 35.8311Z\" fill=#455A64 /><path d=\"M183.316 25.7715C182.771 26.0136 182.212 26.2241 181.643 26.4017C180.327 26.9327 179.098 27.6601 177.999 28.5591C176.904 29.4632 175.955 30.5317 175.187 31.7265C174.589 32.6476 174.315 33.2697 174.25 33.2455C174.367 32.6496 174.597 32.0817 174.929 31.5729C175.649 30.2967 176.6 29.1652 177.732 28.2359C178.861 27.3006 180.154 26.5853 181.546 26.127C182.11 25.9025 182.709 25.7821 183.316 25.7715Z\" fill=#455A64 /><path d=\"M207.669 26.5635C207.531 27.8783 206.963 29.1108 206.053 30.0702C205.26 31.1226 204.145 31.8883 202.878 32.2518C203.914 31.5461 204.872 30.7337 205.738 29.8278C206.5 28.8139 207.147 27.7192 207.669 26.5635Z\" fill=#455A64 /><path d=\"M138.48 118.223L129.947 135.312C128.999 137.218 128.554 139.334 128.655 141.461C128.81 144.65 130.187 147.657 132.499 149.859C134.81 152.061 137.881 153.29 141.074 153.29L165.435 151.876L166.501 140.758L147.966 136.29L154.987 123.006L138.48 118.223Z\" fill=#FFBE9D /><path d=\"M161.734 140.718H166.502C166.502 140.718 177.264 136.831 179.478 137.203C181.474 137.534 188.77 142.382 190.2 143.344C190.358 143.453 190.479 143.608 190.548 143.788C190.687 144.168 190.674 144.587 190.511 144.957C190.349 145.328 190.049 145.621 189.675 145.776L189.522 145.832L189.586 146.05C189.673 146.333 189.711 146.628 189.699 146.923C189.683 147.147 189.596 147.36 189.45 147.53C189.304 147.7 189.107 147.82 188.889 147.87C188.67 147.921 188.441 147.9 188.235 147.811C188.029 147.722 187.857 147.569 187.744 147.376L188.019 147.868C188.13 148.068 188.183 148.295 188.172 148.523V148.967C188.159 149.205 188.075 149.434 187.931 149.624C187.787 149.814 187.59 149.957 187.364 150.034C187.147 150.107 186.912 150.115 186.69 150.058C186.468 150 186.267 149.88 186.112 149.711C185.183 148.693 183.187 146.648 181.829 146.422C180.366 146.249 178.892 146.176 177.418 146.204C177.117 146.202 176.822 146.293 176.574 146.463C176.325 146.634 176.135 146.876 176.028 147.157C176.836 147.214 182.419 150.131 184.399 151.197C184.709 151.351 184.976 151.579 185.176 151.861C185.376 152.143 185.503 152.47 185.546 152.813C185.619 153.427 185.312 154.082 184.084 153.791C181.566 153.041 179.106 152.109 176.723 151.003C176.723 151.003 174.299 150.309 172.683 151.424C170.461 152.991 169.451 153.565 167.528 152.935C166.369 152.545 165.258 152.027 164.215 151.391L160.45 151.02C160.45 151.02 156.87 142.083 161.734 140.718Z\" fill=#FFBE9D /><path d=\"M175.947 142.535C176.615 142.407 177.29 142.313 177.967 142.253C179.608 142.144 181.251 142.424 182.763 143.07C184.275 143.716 185.613 144.709 186.669 145.969C187.477 146.931 187.825 147.642 187.865 147.626C187.8 147.452 187.719 147.284 187.623 147.125C187.39 146.687 187.12 146.271 186.815 145.88C185.773 144.571 184.422 143.542 182.883 142.884C181.344 142.227 179.666 141.963 178 142.115C177.497 142.153 177 142.237 176.513 142.366C176.318 142.399 176.128 142.456 175.947 142.535Z\" fill=#EB996E /><path d=\"M177.086 139.926C177.768 139.714 178.474 139.589 179.187 139.554C180.917 139.545 182.615 140.027 184.083 140.944C185.538 141.879 186.864 143.001 188.026 144.281L189.109 145.428C189.231 145.578 189.369 145.713 189.521 145.832C189.416 145.669 189.297 145.515 189.166 145.372C188.931 145.089 188.584 144.677 188.131 144.184C186.989 142.86 185.661 141.709 184.188 140.766C182.688 139.832 180.946 139.36 179.179 139.409C178.648 139.436 178.124 139.534 177.619 139.7C177.441 139.748 177.312 139.821 177.215 139.853C177.118 139.885 177.078 139.918 177.086 139.926Z\" fill=#EB996E /><path d=\"M147.966 136.249C147.966 136.322 147.118 136.185 145.777 136.193C144.027 136.23 142.293 136.538 140.638 137.106C138.977 137.648 137.419 138.467 136.032 139.53C134.982 140.338 134.481 141.041 134.416 141C134.352 140.96 134.505 140.798 134.723 140.483C135.053 140.052 135.426 139.657 135.838 139.304C137.205 138.137 138.786 137.248 140.492 136.686C142.187 136.098 143.975 135.824 145.769 135.878C146.311 135.897 146.852 135.959 147.385 136.063C147.587 136.095 147.783 136.158 147.966 136.249Z\" fill=#EB996E /><path d=\"M242.526 115.281C242.526 115.281 247.851 130.633 253.596 144.846C253.708 145.135 253.8 145.432 253.871 145.735C254.052 146.645 254.028 147.584 253.801 148.484C253.573 149.384 253.148 150.221 252.556 150.936C251.964 151.65 251.22 152.224 250.378 152.614C249.536 153.004 248.617 153.202 247.689 153.193H214.125V142.39L234.794 138.002L227.312 121.39L242.526 115.281Z\" fill=#FFBE9D /><path d=\"M221.114 141.057H216.347C216.347 141.057 205.584 137.171 203.37 137.543C201.375 137.874 194.078 142.722 192.648 143.683C192.488 143.787 192.366 143.94 192.301 144.12C192.162 144.5 192.175 144.919 192.337 145.289C192.5 145.66 192.8 145.953 193.173 146.107L193.327 146.172L193.254 146.39C193.17 146.673 193.134 146.968 193.149 147.263C193.165 147.487 193.253 147.699 193.399 147.87C193.545 148.04 193.741 148.16 193.96 148.21C194.179 148.261 194.408 148.24 194.614 148.151C194.82 148.062 194.992 147.909 195.105 147.715L194.83 148.2C194.716 148.399 194.662 148.626 194.676 148.855V149.299C194.688 149.538 194.771 149.769 194.915 149.961C195.059 150.152 195.257 150.296 195.484 150.374C195.703 150.445 195.937 150.451 196.159 150.392C196.381 150.334 196.582 150.212 196.737 150.042C197.666 149.024 199.662 146.988 201.011 146.762C202.477 146.584 203.954 146.511 205.431 146.544C205.731 146.544 206.025 146.636 206.273 146.806C206.521 146.976 206.712 147.217 206.82 147.497C206.012 147.554 200.429 150.471 198.45 151.537C198.14 151.691 197.872 151.919 197.671 152.201C197.469 152.483 197.34 152.81 197.294 153.153C197.221 153.775 197.537 154.422 198.765 154.139C201.282 153.389 203.743 152.457 206.126 151.351C206.126 151.351 208.55 150.648 210.166 151.763C212.396 153.339 213.398 153.913 215.321 153.274C216.482 152.891 217.597 152.376 218.642 151.739L222.407 151.359C222.407 151.359 225.978 142.423 221.114 141.057Z\" fill=#FFBE9D /><path d=\"M206.901 142.875C206.233 142.747 205.559 142.652 204.881 142.592C203.241 142.482 201.597 142.761 200.085 143.407C198.572 144.053 197.234 145.047 196.179 146.309C195.371 147.27 195.024 147.981 194.983 147.925C195.045 147.752 195.127 147.586 195.226 147.432C195.459 146.992 195.73 146.573 196.034 146.179C197.081 144.874 198.435 143.848 199.974 143.191C201.513 142.535 203.19 142.268 204.857 142.414C205.359 142.458 205.856 142.545 206.344 142.673C206.538 142.713 206.726 142.781 206.901 142.875Z\" fill=#EB996E /><path d=\"M205.762 140.257C205.077 140.051 204.368 139.929 203.653 139.893C201.927 139.886 200.233 140.365 198.765 141.275C197.308 142.21 195.98 143.332 194.814 144.612L193.739 145.768C193.612 145.912 193.474 146.047 193.327 146.172C193.427 146.007 193.544 145.852 193.675 145.711C193.917 145.428 194.264 145.016 194.709 144.515C195.855 143.194 197.186 142.046 198.66 141.105C200.156 140.169 201.897 139.696 203.661 139.748C204.195 139.772 204.722 139.87 205.229 140.039C205.365 140.078 205.498 140.13 205.625 140.192L205.762 140.257Z\" fill=#EB996E /><path d=\"M247.94 141.178C247.9 141.235 247.245 140.718 246.098 140.063C243.095 138.331 239.639 137.548 236.183 137.817C234.858 137.914 234.05 138.1 234.034 138.027C234.204 137.928 234.39 137.86 234.584 137.825C235.098 137.685 235.622 137.583 236.151 137.518C239.682 137.077 243.255 137.886 246.251 139.805C246.702 140.09 247.132 140.409 247.536 140.758C247.811 141.009 247.964 141.154 247.94 141.178Z\" fill=#EB996E /><path d=\"M333.402 153.613H48.3555V159.051H333.402V153.613Z\" fill=#455A64 /><path d=\"M59.9339 306.034H56.0312V158.688H64.3779L59.9339 306.034Z\" fill=#455A64 /><path d=\"M110.135 305.962H106.24V158.793H114.587L110.135 305.962Z\" fill=#263238 /><path d=\"M273.691 305.8H269.788V158.809H278.135L273.691 305.8Z\" fill=#263238 /><path d=\"M315.714 305.962H311.812V158.744H320.158L315.714 305.962Z\" fill=#455A64 /><path d=\"M214.335 153.557H164.28C163.596 153.556 162.939 153.292 162.444 152.819C161.949 152.347 161.655 151.703 161.622 151.02L160.119 116.559C160.103 116.2 160.161 115.842 160.288 115.506C160.414 115.171 160.608 114.864 160.856 114.605C161.104 114.346 161.403 114.14 161.733 114C162.063 113.859 162.418 113.787 162.777 113.787H215.741C216.099 113.788 216.453 113.861 216.782 114.001C217.111 114.142 217.409 114.347 217.657 114.605C217.905 114.863 218.098 115.168 218.226 115.502C218.354 115.836 218.413 116.193 218.4 116.55L216.994 151.012C216.967 151.698 216.674 152.346 216.178 152.821C215.683 153.296 215.022 153.559 214.335 153.557Z\" fill=#E0E0E0 /><path d=\"M191.994 134.278C191.994 134.82 191.833 135.349 191.532 135.8C191.231 136.25 190.803 136.601 190.303 136.809C189.802 137.016 189.252 137.07 188.72 136.965C188.189 136.859 187.701 136.598 187.318 136.215C186.935 135.832 186.674 135.344 186.568 134.813C186.463 134.281 186.517 133.73 186.724 133.23C186.931 132.729 187.283 132.302 187.733 132.001C188.183 131.7 188.713 131.539 189.255 131.539C189.981 131.541 190.676 131.83 191.189 132.344C191.702 132.857 191.992 133.552 191.994 134.278Z\" fill=white /><path d=\"M309.186 92.6574C309.22 92.3819 309.309 92.116 309.447 91.8755C309.586 91.635 309.771 91.4246 309.992 91.2569C310.213 91.0892 310.466 90.9676 310.735 90.8991C311.004 90.8307 311.284 90.8168 311.558 90.8584C311.832 90.9 312.096 90.9962 312.332 91.1413C312.569 91.2864 312.774 91.4774 312.936 91.7031C313.097 91.9288 313.212 92.1846 313.273 92.4554C313.334 92.7261 313.34 93.0064 313.291 93.2795L304.192 148.83H300.031L309.186 92.6574Z\" fill=#263238 /><path d=\"M312.434 93.3437L274.91 52.1357L274.635 52.5882L272.817 55.6021L309.355 96.1475C309.726 96.5518 310.241 96.7931 310.789 96.8185C311.337 96.844 311.873 96.6517 312.28 96.2835C312.686 95.9153 312.931 95.4012 312.959 94.8534C312.988 94.3057 312.799 93.7688 312.434 93.3599V93.3437Z\" fill=#263238 /><path d=\"M309.679 94.4107C309.679 94.4107 309.614 94.3218 309.631 94.1522C309.655 93.9028 309.777 93.6732 309.97 93.5138C310.117 93.3865 310.296 93.3001 310.487 93.2633C310.679 93.2264 310.876 93.2404 311.061 93.3038C311.292 93.3814 311.493 93.5296 311.635 93.7275C311.777 93.9254 311.854 94.163 311.854 94.4067C311.854 94.6504 311.777 94.888 311.635 95.0859C311.493 95.2838 311.292 95.432 311.061 95.5096C310.877 95.5717 310.68 95.5857 310.489 95.5503C310.298 95.515 310.119 95.4314 309.97 95.3076C309.777 95.1482 309.655 94.9186 309.631 94.6693C309.631 94.4996 309.631 94.4107 309.679 94.4107C309.727 94.4107 309.744 94.7905 310.156 95.0733C310.267 95.1484 310.396 95.1944 310.53 95.2071C310.664 95.2198 310.799 95.1988 310.923 95.146C311.07 95.0859 311.195 94.9842 311.284 94.8535C311.373 94.7228 311.422 94.5689 311.424 94.4107C311.424 94.2512 311.376 94.0955 311.286 93.9632C311.197 93.8309 311.071 93.728 310.923 93.6674C310.799 93.6157 310.663 93.5961 310.529 93.6102C310.395 93.6243 310.267 93.6717 310.156 93.7482C309.776 94.0229 309.776 94.4269 309.679 94.4107Z\" fill=#455A64 /><path d=\"M310.243 90.9443C310.668 91.2335 311.049 91.5818 311.375 91.9786C311.774 92.3726 312.152 92.788 312.506 93.2229C312.743 93.5026 312.918 93.8294 313.02 94.1818C313.122 94.5341 313.147 94.9041 313.096 95.2671C313 95.632 312.808 95.9643 312.539 96.2288C312.27 96.4934 311.935 96.6804 311.569 96.77C311.279 96.8466 310.976 96.8647 310.68 96.823C310.383 96.7814 310.097 96.681 309.839 96.5276C309.371 96.285 308.985 95.908 308.732 95.4449C308.781 95.3803 309.177 95.8489 309.985 96.2529C310.438 96.4883 310.966 96.5376 311.455 96.3903C311.749 96.312 312.017 96.1582 312.232 95.9441C312.448 95.73 312.603 95.4632 312.684 95.1702C312.721 94.8637 312.696 94.5528 312.612 94.2559C312.527 93.959 312.384 93.6819 312.191 93.4411C311.843 92.9563 311.447 92.5361 311.156 92.1725C310.797 91.8068 310.49 91.3936 310.243 90.9443Z\" fill=#455A64 /><path d=\"M283.564 153.734H317.727C317.727 153.734 313.364 148.296 301.995 148.296C291.402 148.296 285.092 151.407 283.564 153.734Z\" fill=#263238 /><path d=\"M275.128 45.5912L276.866 42.9813L274.716 41.333L272.874 43.959L275.128 45.5912Z\" fill=#263238 /><path d=\"M278.07 47.159L270.588 41.7373L263.413 50.3748C250.962 52.3787 245.944 60.2082 245.944 60.2082L268.229 77.2731C275.856 68.8457 272.269 56.7984 272.269 56.7984L278.07 47.159Z\" fill=#696969 /><path d=\"M272.244 56.7976C270.655 55.9018 269.137 54.8862 267.703 53.7595C266.19 52.7395 264.756 51.6079 263.412 50.374C265.001 51.2698 266.519 52.2854 267.953 53.4121C269.47 54.4265 270.904 55.5585 272.244 56.7976Z\" fill=#263238 /><path d=\"M244.99 66.1472C245.039 66.2522 241.225 68.1268 236.474 70.3327C231.723 72.5385 227.828 74.2353 227.78 74.1303C227.731 74.0252 231.545 72.1507 236.296 69.9448C241.047 67.739 244.942 66.0422 244.99 66.1472Z\" fill=#263238 /><path d=\"M253.587 73.5807C253.676 73.6615 250.735 76.8127 247.034 80.6184C243.334 84.424 240.255 87.446 240.174 87.3652C240.094 87.2844 243.027 84.1332 246.727 80.3275C250.428 76.5218 253.506 73.4999 253.587 73.5807Z\" fill=#263238 /><path d=\"M259.259 95.8811C259.146 95.8811 259.38 92.0511 259.792 87.3486C260.204 82.646 260.6 78.8403 260.746 78.8565C260.712 81.7078 260.534 84.5557 260.212 87.389C259.8 92.0915 259.372 95.8891 259.259 95.8811Z\" fill=#263238 /><g opacity=0.7><path d=\"M102.177 0.199117L71.8643 7.95312L78.0623 32.1828L108.375 24.4288L102.177 0.199117Z\" fill=#EBEBEB /><path d=\"M102.178 0.193875L101.599 0.324063L99.9546 0.764955L93.7609 2.37099L71.8762 8.00269L71.9378 7.90526C73.785 15.1194 75.9036 23.3828 78.1548 32.1299L78.046 32.0708L108.352 24.3327L108.302 24.4276C106.446 17.12 104.907 11.0663 103.838 6.8411C103.359 4.70437 102.892 3.05405 102.603 1.92515L102.309 0.618106L102.207 0.163489C102.207 0.163489 102.241 0.311241 102.307 0.606746C102.373 0.902252 102.47 1.33414 102.595 1.89106C102.851 3.02762 103.317 4.67793 103.862 6.78798C104.956 11.0194 106.52 17.0794 108.413 24.3907L108.428 24.4589L108.349 24.4767L78.0477 32.2375L77.9567 32.258L77.9363 32.167C75.6965 23.4174 73.5867 15.14 71.7421 7.9373L71.7242 7.85774L71.8038 7.83987L93.7518 2.27752L99.9419 0.708132L101.59 0.337986L102.147 0.2129L102.178 0.193875Z\" fill=#263238 /><path d=\"M101.485 2.01036L73.3057 9.21875L78.7242 30.4014L106.904 23.193L101.485 2.01036Z\" fill=#CFCFCF /><g opacity=0.3><path opacity=0.3 d=\"M78.7186 30.3915L85.2001 14.7046L93.3989 21.3875L96.41 15.9237L106.898 23.1788L78.7186 30.3915Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M93.4742 10.864C93.6064 11.4494 93.5075 12.0632 93.1982 12.5775C92.8889 13.0918 92.393 13.4669 91.814 13.6247C91.3652 13.7469 90.8901 13.732 90.4498 13.5819C90.0095 13.4318 89.6243 13.1533 89.3437 12.7824C89.063 12.4114 88.8999 11.965 88.8752 11.5005C88.8505 11.036 88.9654 10.5747 89.2051 10.1761C89.4449 9.77752 89.7984 9.45978 90.2203 9.26385C90.6422 9.06792 91.113 9.00275 91.5722 9.07674C92.0315 9.15073 92.458 9.36049 92.797 9.67901C93.136 9.99754 93.3719 10.4102 93.4742 10.864Z\" fill=black /></g></g><path d=\"M71.6167 37.2859L55.3877 48.5557L64.3959 61.528L80.6249 50.2582L71.6167 37.2859Z\" fill=#EBEBEB /><path d=\"M71.6178 37.2818L71.3034 37.4866L70.4277 38.1099L67.1164 40.4254L55.407 48.5817L55.422 48.5104C58.1051 52.3724 61.1802 56.7955 64.4403 61.4756L64.3629 61.4645L80.5916 50.2056L80.5828 50.2729C77.8737 46.3576 75.6288 43.1144 74.0653 40.8495C73.3103 39.6908 72.6707 38.817 72.2506 38.2127L71.7888 37.5039L71.6282 37.2574C71.6282 37.2574 71.6804 37.3375 71.7848 37.4978C71.8892 37.658 72.0418 37.8922 72.2386 38.1942C72.6402 38.8105 73.2798 39.6844 74.0677 40.8128C75.6475 43.0758 77.9088 46.3172 80.6404 50.2266L80.6645 50.2635L80.6213 50.2916L64.4006 61.5629L64.3513 61.595L64.3192 61.5457C61.0653 56.8616 57.9923 52.4283 55.3132 48.5725L55.2851 48.5294L55.3283 48.5013L67.0905 40.3721L70.4076 38.079L71.3013 37.4968L71.6033 37.3L71.6178 37.2818Z\" fill=#263238 /><path d=\"M71.6075 38.5106L56.5205 48.9873L64.3959 60.3282L79.4829 49.8515L71.6075 38.5106Z\" fill=#CFCFCF /><g opacity=0.3><path opacity=0.3 d=\"M64.3912 60.3221L64.7692 49.6104L71.094 51.7581L71.6716 47.8611L79.4773 49.8428L64.3912 60.3221Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M68.8184 45.5157C69.0256 45.8331 69.1024 46.2181 69.0327 46.5906C68.963 46.9631 68.7523 47.2944 68.4444 47.5154C68.2057 47.6866 67.9213 47.7825 67.6277 47.7907C67.334 47.7989 67.0447 47.7191 66.7969 47.5614C66.549 47.4037 66.3541 47.1755 66.2371 46.9061C66.1201 46.6366 66.0864 46.3384 66.1404 46.0496C66.1944 45.7609 66.3336 45.495 66.5401 45.286C66.7466 45.0771 67.0108 44.9348 67.2989 44.8773C67.587 44.8199 67.8856 44.85 68.1564 44.9638C68.4272 45.0776 68.6578 45.2698 68.8184 45.5157Z\" fill=black /></g><path d=\"M80.1573 127.337C80.2734 127.337 80.3674 126.885 80.3674 126.327C80.3674 125.77 80.2734 125.317 80.1573 125.317C80.0413 125.317 79.9473 125.77 79.9473 126.327C79.9473 126.885 80.0413 127.337 80.1573 127.337Z\" fill=#263238 /><path d=\"M80.1574 136.452C79.8772 134.946 79.8772 133.401 80.1574 131.895C80.4375 133.401 80.4375 134.946 80.1574 136.452Z\" fill=#263238 /><path d=\"M82.1774 143.029C81.5249 143.234 80.838 143.305 80.1573 143.239L79.9473 143.029V142.584V142.213C79.9473 141.97 79.9473 141.752 79.9473 141.566C79.9877 141.203 80.0442 140.977 80.1008 140.977C80.1573 140.977 80.2058 141.203 80.2462 141.566C80.2462 141.752 80.2462 141.97 80.2947 142.213V142.972L80.0846 142.762C80.7933 142.699 81.5071 142.79 82.1774 143.029Z\" fill=#263238 /><path d=\"M90.2906 143.029C89.6354 143.234 88.9457 143.305 88.2625 143.239C87.5792 143.305 86.8895 143.234 86.2344 143.029C86.8886 142.819 87.5792 142.748 88.2625 142.819C88.9457 142.748 89.6364 142.819 90.2906 143.029Z\" fill=#263238 /><path d=\"M98.4111 143.029C97.0787 143.306 95.7034 143.306 94.3711 143.029C95.7034 142.751 97.0787 142.751 98.4111 143.029Z\" fill=#263238 /><path d=\"M106.522 143.029C105.19 143.306 103.815 143.306 102.482 143.029C103.815 142.751 105.19 142.751 106.522 143.029Z\" fill=#263238 /><path d=\"M114.644 143.029C113.311 143.306 111.936 143.306 110.604 143.029C111.936 142.751 113.311 142.751 114.644 143.029Z\" fill=#263238 /><path d=\"M122.764 143.029C121.431 143.306 120.056 143.306 118.724 143.029C120.056 142.752 121.431 142.752 122.764 143.029Z\" fill=#263238 /><path d=\"M130.876 143.029C129.544 143.306 128.168 143.306 126.836 143.029C128.168 142.751 129.544 142.751 130.876 143.029Z\" fill=#263238 /><path d=\"M138.996 143.029C137.664 143.306 136.288 143.306 134.956 143.029C136.288 142.751 137.664 142.751 138.996 143.029Z\" fill=#263238 /><path d=\"M147.109 143.029C145.777 143.306 144.402 143.306 143.069 143.029C144.402 142.751 145.777 142.751 147.109 143.029Z\" fill=#263238 /><path d=\"M155.229 143.029C153.897 143.306 152.522 143.306 151.189 143.029C152.522 142.751 153.897 142.751 155.229 143.029Z\" fill=#263238 /><path d=\"M161.305 143.028C161.305 143.142 160.853 143.238 160.295 143.238C159.738 143.238 159.285 143.142 159.285 143.028C159.285 142.915 159.738 142.818 160.295 142.818C160.853 142.818 161.305 142.907 161.305 143.028Z\" fill=#263238 /><path d=\"M106.733 54.0273H49.0176C45.9876 54.0273 43.5312 56.4837 43.5312 59.5137V117.229C43.5312 120.259 45.9876 122.715 49.0176 122.715H106.733C109.763 122.715 112.219 120.259 112.219 117.229V59.5137C112.219 56.4837 109.763 54.0273 106.733 54.0273Z\" fill=#3E3E3E /><path d=\"M90.7273 102.871C92.6195 102.346 94.2257 101.091 95.1924 99.3814C96.1592 97.6722 96.4073 95.6489 95.8823 93.7567C95.3573 91.8644 94.1021 90.2583 92.3928 89.2915C90.6836 88.3248 88.6603 88.0766 86.7681 88.6016C87.3579 82.8729 82.1463 77.2412 76.3853 77.3947C70.6242 77.5482 65.7116 83.4466 66.6165 89.143C64.8197 89.0787 63.0709 89.7308 61.7548 90.9559C60.4388 92.1811 59.6634 93.8788 59.5991 95.6757C59.5348 97.4725 60.1869 99.2213 61.412 100.537C62.6372 101.853 64.3349 102.629 66.1317 102.693L90.7273 102.871Z\" fill=white /><path d=\"M32.0505 251.761C34.9318 250.278 38.3268 250.085 41.5291 250.615C43.2466 250.895 45.0444 251.409 46.2082 252.7C47.3799 253.991 47.5967 256.261 46.2563 257.368C45.4537 258.025 44.3381 258.13 43.3028 258.114C40.7987 258.081 38.0218 257.64 36.0153 259.148C34.8756 260.006 34.1132 261.434 32.7488 261.859C31.4165 262.276 29.9076 261.482 29.2014 260.279C28.4951 259.076 28.471 257.568 28.8001 256.213C28.8001 256.213 29.1532 253.253 32.0505 251.761Z\" fill=#4A4A4A /><path d=\"M25.4508 239.018C27.2165 241.536 30.6355 240.702 32.2247 239.162C33.8138 237.63 34.4879 235.4 35.0979 233.275C36.4944 228.423 37.899 223.338 36.8636 218.397C36.5506 216.921 35.9968 215.446 34.9615 214.355C33.9261 213.256 32.329 212.606 30.8683 212.991C29.1427 213.449 28.0672 215.141 27.2887 216.745C25.0094 221.469 23.7975 226.714 23.7814 231.96C23.7734 234.422 24.0623 236.997 25.4508 239.018Z\" fill=#4A4A4A /><path d=\"M20.605 242.627C22.5152 240.357 22.8844 237.045 22.0336 234.205C21.1829 231.358 19.2567 228.944 17.0415 226.971C14.4411 224.653 11.3833 222.856 8.10069 221.702C6.80853 221.244 5.44412 220.891 4.07972 221.02C2.71532 221.148 1.34291 221.846 0.708863 223.057C-0.230166 224.854 0.66872 227.027 1.64788 228.8C3.36542 231.928 5.33176 234.919 7.52283 237.734C9.2805 240.004 11.295 242.242 13.9837 243.26C16.6643 244.287 19.4493 244.167 20.8779 242.306\" fill=#4A4A4A /><path d=\"M25.3328 276.971C25.3649 276.971 25.4211 276.562 25.4933 275.824C25.5736 274.99 25.6779 273.947 25.7983 272.704C25.9428 271.389 26.1354 269.833 26.5046 268.124C26.8657 266.424 27.4356 264.587 28.1659 262.727C28.9204 260.874 29.8433 259.19 30.9268 257.842C31.9943 256.487 33.2463 255.508 34.4181 254.947C35.5818 254.369 36.6332 254.137 37.3555 254.032C38.0859 253.96 38.4952 253.896 38.4952 253.864C38.4952 253.832 38.0859 253.824 37.3395 253.848C36.5931 253.896 35.5096 254.089 34.2736 254.642C33.0376 255.187 31.7134 256.182 30.5897 257.569C29.4581 258.949 28.503 260.665 27.7325 262.558C26.9861 264.459 26.4243 266.312 26.0792 268.044C25.7341 269.777 25.5736 271.357 25.4692 272.68C25.3729 274.003 25.3328 275.078 25.3167 275.816C25.2927 276.554 25.3007 276.963 25.3328 276.971Z\" fill=#263238 /><path d=\"M25.5403 274.565C25.5564 274.565 25.5644 274.38 25.5724 274.035C25.5724 273.634 25.5724 273.137 25.5644 272.52C25.5644 271.204 25.5644 269.295 25.6286 266.945C25.749 262.237 26.1503 257.176 26.9368 250.038C27.6752 243.325 28.6704 235.513 29.7218 230.436C29.9465 229.281 30.1713 228.239 30.388 227.332C30.5886 226.418 30.7652 225.632 30.9337 224.998C31.0782 224.397 31.1986 223.908 31.2869 223.523C31.3591 223.186 31.3992 223.001 31.3832 223.001C31.3671 222.993 31.3029 223.17 31.1986 223.499C31.0862 223.883 30.9337 224.365 30.7571 224.95C30.5645 225.584 30.3639 226.362 30.1311 227.268C29.8903 228.174 29.6416 229.209 29.3928 230.364C28.3574 234.968 27.2498 241.4 26.4633 248.554C25.6768 255.709 25.3236 262.221 25.2915 266.937C25.2674 269.295 25.3156 271.204 25.3718 272.52C25.4119 273.137 25.444 273.634 25.4681 274.035C25.5082 274.388 25.5243 274.565 25.5403 274.565Z\" fill=#263238 /><path d=\"M25.5727 262.005C25.6048 262.005 25.5968 261.444 25.5647 260.417C25.5085 259.399 25.3641 257.931 25.0751 256.126C24.7702 254.33 24.3448 252.188 23.6786 249.871C23.3897 248.812 22.7075 246.269 21.0622 242.468C18.8952 237.319 15.9417 233.116 13.3734 230.509C12.7715 229.819 12.1054 229.322 11.5676 228.833C11.2867 228.6 11.0459 228.368 10.7971 228.183C10.5483 228.007 10.3156 227.846 10.0989 227.702C9.25616 227.125 8.78263 226.82 8.76658 226.852C8.69434 226.956 10.6607 228.111 13.1407 230.75C15.6126 233.389 18.4779 237.567 20.6368 242.668C21.8407 245.435 22.6754 247.906 23.2693 249.999C23.9595 252.301 24.409 254.41 24.7541 256.191C25.0832 257.979 25.2678 259.431 25.3882 260.441C25.4764 261.444 25.5406 262.005 25.5727 262.005Z\" fill=#263238 /><path d=\"M13.4297 284.166L14.6817 301.41H36.8573L38.1174 284.166H13.4297Z\" fill=#263238 /><path d=\"M40.7662 277.363H11.2871V284.165H40.7662V277.363Z\" fill=#263238 /><path d=\"M11.2871 300.751V302.636H12.6676H40.2766V300.751H11.2871Z\" fill=#455A64 /><path d=\"M14.0234 305.948L12.667 302.636H39.2166L37.6355 305.948H14.0234Z\" fill=#455A64 /><path d=\"M37.6999 289.803C37.708 289.811 37.6678 289.859 37.5956 289.963C37.5073 290.084 37.395 290.228 37.2665 290.405C36.9535 290.806 36.5201 291.359 35.9744 292.057L35.9182 292.129L35.862 292.049C35.0514 290.926 33.9679 289.426 32.6918 287.662H32.8764C31.9293 289.001 30.8779 290.485 29.7543 292.081L29.658 292.217L29.5456 292.089C28.3899 290.717 27.1379 289.234 25.8377 287.686H26.0544C25.9902 287.766 25.9179 287.854 25.8537 287.942C24.706 289.378 23.5904 290.773 22.539 292.089L22.4267 292.225L22.3224 292.081C21.1987 290.493 20.1473 289.009 19.2003 287.662L19.3849 287.67C17.8439 289.426 16.5357 290.91 15.5325 292.049L15.4602 292.129L15.4121 292.041C14.9064 291.191 14.4971 290.509 14.2082 290.02C14.0798 289.803 13.9835 289.619 13.8952 289.482C13.831 289.362 13.7908 289.29 13.7989 289.29C13.8069 289.29 13.847 289.346 13.9273 289.458C14.0156 289.594 14.1279 289.763 14.2724 289.979C14.5774 290.461 15.0027 291.126 15.5405 291.969L15.4201 291.96C16.4073 290.806 17.6914 289.298 19.2083 287.525L19.3046 287.413L19.3929 287.533C20.348 288.873 21.4154 290.348 22.5471 291.928L22.3384 291.92C23.3898 290.597 24.4974 289.209 25.6451 287.766C25.7173 287.678 25.7815 287.589 25.8457 287.509L25.95 287.381L26.0624 287.509C27.3626 289.057 28.6066 290.549 29.7543 291.92L29.5456 291.928C30.6853 290.34 31.7447 288.857 32.6998 287.533L32.7961 287.405L32.8844 287.533C34.1365 289.314 35.1959 290.83 35.9904 291.969H35.8781C36.4479 291.287 36.8974 290.749 37.2184 290.356C37.3629 290.188 37.4832 290.052 37.5795 289.939C37.6518 289.843 37.6999 289.795 37.6999 289.803Z\" fill=#E0E0E0 /><path d=\"M38.4235 284.051C38.4235 284.132 32.8696 284.188 26.0155 284.188C19.1614 284.188 13.6074 284.124 13.6074 284.051C13.6074 283.979 19.1614 283.915 26.0155 283.915C32.8696 283.915 38.4235 283.971 38.4235 284.051Z\" fill=#455A64 /><path d=\"M39.5461 302.821C39.5461 302.901 33.5106 302.957 26.0626 302.957C18.6146 302.957 12.5791 302.893 12.5791 302.821C12.5791 302.749 18.6146 302.685 26.0626 302.685C33.5026 302.685 39.5461 302.741 39.5461 302.821Z\" fill=#263238 /><g class=fade-in-bottom opacity=0.8><path d=\"M76.5 83.625L84.375 89.75H80.0088L80 99.375H73V89.75H68.625L76.5 83.625Z\" stroke=black stroke-width=2 stroke-linecap=round stroke-linejoin=round /></g></svg></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000 ng:class=\" showCropped ? \'for-position\' : \'\'\"><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\">How about uploading a profile picture to go with that beautiful name?</span><div ng-if=imgUploaded class=comp-profile-frame><img class=uploaded-avatar src={{userData.image}} alt=\"user avatar\"></div><div class=profile_popup_upload><!-- ng-if=\"!imgUploaded\" --> <img ng-if=!loader src=../../images/upload-image.gif alt=\"\"><div class=login-theme-loader ng-if=loader></div><label for=name ng-if=\"!imgUploaded && !loader\">Upload Photo</label><label for=name ng-if=\"!imgUploaded && loader\">Uploading Photo</label><input type=file name=image id=image accept=\".png, .jpg, .jpeg\" ng-model=userData.image onchange=angular.element(this).scope().handleFileSelect(event) ng-if=!loader><label ng-if=imgUploaded>Change Image</label></div><div ng-if=showCropped style=\"align-items: center !important;\n                        padding-top: 0\" class=image-crop-popup><div class=cropArea><img ng-click=closeCustomCrop();$event.stopPropagation(); class=custom-crop-cross src=./../../images/cross-icon.svg><img-crop image=myImage result-image=myCroppedImage></img-crop><button class=custom-crop-save ng-click=onImageSelected(myCroppedImage);$event.stopPropagation();><span ng-show=!loader>Save</span> <span style=\"display: flex;\n              justify-content: center\" ng-show=loader><div class=login-theme-loader></div></span></button><!-- <img ng-src=\"{{myImage}}\" /> --></div></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=cityTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=cityTab(false,userData.image);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- City tab --><div class=row ng-if=city_tab ng-click=closeCityDropdown();$event.stopPropagation();><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\" ng-click=closeCityDropdown();$event.stopPropagation();><img src=../../images/city-banner.svg alt=#></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000 ng-click=closeCityDropdown();$event.stopPropagation();><div class=profile_popup_content><div><span ng-hide=notFound class=\"profile_popup_subtitle mb-24\">Now, let’s get to know about the beautiful city you call home:</span> <span class=\"profile_popup_subtitle mb-24\" ng-show=notFound>Seems like we missed your city , you can enter it below :</span><div class=\"profile_popup_input profile_city_dropdown\"><!-- profile_popup_input --><div class=profile_city_dropdown><input type=text ng-show=defaultField ng-model=otherCity ng-change=cityCheck(otherCity) ng-click=cityCheck(otherCity);$event.stopPropagation(); placeholder=\"Choose your City\" autocomplete=off autocomplete=chrome-off> <input type=text ng-show=!defaultField ng-model=otherCityDefault ng-change=cityCheck(otherCityDefault) ng-click=cityCheck(otherCityDefault);$event.stopPropagation(); placeholder=\"Choose your City\" autocomplete=off autocomplete=chrome-off><ul class=custom-city-select ng-show=showCityList><li ng-repeat=\"x in searchCities\" ng-click=onSelectCity(x);$event.stopPropagation();>{{x.name}}</li></ul><!-- <ui-select\nng-model=\"selected.value\"\nng-show=\"!cityOther\"\nonchange=\"angular.element(this).scope().cityCheck(event)\"\n>\n<ui-select-match placeholder=\"Choose your city\">\n  <span >{{$select.selected.name}}</span>\n</ui-select-match>\n<ui-select-choices\nclass=\"sssss\"\nid=\"selectUI\"\n\n  repeat=\"item in (itemArray | filter: $select.search) track by $index\"\n>\n\n  <span >{{item.name}}</span>\n</ui-select-choices>\n</ui-select> --></div></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=educationTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=\"defaultField ? educationTab(false,otherCity): educationTab(false,otherCityDefault);$event.stopPropagation()\"><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- Education tab --><div class=\"row education-tab\" ng-if=education_tab ng-click=closeUniDropdown();$event.stopPropagation();><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000><svg class=welcome-desktop-image width=372 height=355 viewBox=\"0 0 372 355\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M304.467 25.5273C303.326 25.5273 302.211 25.1871 301.263 24.5495C300.315 23.9119 299.576 23.0057 299.139 21.9455C298.703 20.8853 298.588 19.7186 298.811 18.5931C299.033 17.4676 299.583 16.4337 300.389 15.6223C301.196 14.8108 302.223 14.2582 303.342 14.0343C304.46 13.8105 305.62 13.9254 306.674 14.3645C307.727 14.8037 308.628 15.5474 309.262 16.5016C309.895 17.4557 310.234 18.5775 310.234 19.7251C310.232 21.2634 309.624 22.7383 308.543 23.8261C307.461 24.9138 305.996 25.5257 304.467 25.5273ZM304.467 15.8578C303.707 15.8578 302.963 16.0846 302.331 16.5095C301.699 16.9345 301.207 17.5385 300.916 18.2451C300.625 18.9518 300.549 19.7294 300.697 20.4796C300.845 21.2298 301.211 21.9188 301.749 22.4597C302.287 23.0006 302.972 23.3689 303.717 23.5181C304.463 23.6673 305.235 23.5907 305.938 23.298C306.64 23.0053 307.24 22.5097 307.663 21.8737C308.085 21.2377 308.31 20.49 308.31 19.7251C308.309 18.6994 307.904 17.7159 307.184 16.9902C306.463 16.2644 305.486 15.8554 304.467 15.8528V15.8578Z\" fill=#898A8D /><path d=\"M22.3614 107.678C21.2209 107.678 20.1059 107.337 19.1576 106.7C18.2093 106.062 17.4701 105.156 17.0337 104.096C16.5972 103.036 16.483 101.869 16.7055 100.744C16.928 99.618 17.4773 98.5841 18.2837 97.7727C19.0902 96.9612 20.1178 96.4086 21.2364 96.1847C22.355 95.9609 23.5145 96.0757 24.5682 96.5149C25.6219 96.9541 26.5226 97.6977 27.1562 98.6519C27.7899 99.6061 28.128 100.728 28.128 101.876C28.1264 103.414 27.5183 104.889 26.4372 105.977C25.3561 107.064 23.8903 107.676 22.3614 107.678ZM22.3614 98.0081C21.6012 98.0081 20.8581 98.235 20.226 98.6599C19.5939 99.0849 19.1013 99.6888 18.8103 100.396C18.5194 101.102 18.4433 101.88 18.5916 102.63C18.7399 103.38 19.106 104.069 19.6435 104.61C20.1811 105.151 20.8659 105.519 21.6115 105.669C22.3571 105.818 23.13 105.741 23.8323 105.448C24.5346 105.156 25.1349 104.66 25.5572 104.024C25.9796 103.388 26.205 102.64 26.205 101.876C26.2011 100.852 25.7947 99.8707 25.0746 99.147C24.3545 98.4234 23.3791 98.0158 22.3614 98.0132V98.0081Z\" fill=#898A8D /><g opacity=0.5><g opacity=0.5><path opacity=0.5 d=\"M172.837 4.52563C173.208 4.16128 173.463 3.69443 173.57 3.18407C173.678 2.67372 173.632 2.14279 173.44 1.65842C173.247 1.17405 172.916 0.757979 172.489 0.462823C172.061 0.167667 171.556 0.00667305 171.038 0.000203005C170.52 -0.00626704 170.011 0.142051 169.576 0.426447C169.142 0.710843 168.8 1.11854 168.596 1.59796C168.392 2.07738 168.333 2.60699 168.428 3.11987C168.523 3.63275 168.766 4.10587 169.128 4.47937C169.369 4.72746 169.656 4.92544 169.972 5.06204C170.289 5.19863 170.629 5.27115 170.973 5.27544C171.317 5.27974 171.659 5.21577 171.979 5.08711C172.299 4.95846 172.59 4.76764 172.837 4.52563Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M155.125 5.06239C155.376 4.81588 155.549 4.49997 155.622 4.15462C155.694 3.80928 155.664 3.45005 155.533 3.12227C155.403 2.79449 155.179 2.51295 154.89 2.31321C154.601 2.11347 154.259 2.00451 153.908 2.00014C153.557 1.99576 153.213 2.09616 152.919 2.28863C152.625 2.48109 152.394 2.757 152.256 3.08143C152.118 3.40586 152.078 3.76421 152.142 4.11126C152.206 4.45831 152.371 4.77848 152.616 5.03117C152.779 5.19896 152.973 5.33286 153.187 5.42524C153.401 5.51762 153.631 5.56662 153.864 5.56952C154.097 5.57243 154.328 5.52913 154.545 5.44211C154.761 5.3551 154.958 5.22608 155.125 5.06239Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M156.213 21.1904C156.546 20.8592 156.774 20.436 156.869 19.9743C156.963 19.5127 156.92 19.0332 156.744 18.5964C156.568 18.1596 156.267 17.785 155.88 17.5199C155.493 17.2547 155.036 17.1109 154.568 17.1065C154.099 17.1022 153.64 17.2375 153.248 17.4954C152.856 17.7533 152.548 18.1222 152.364 18.5557C152.18 18.9892 152.128 19.4677 152.214 19.9311C152.3 20.3944 152.521 20.8217 152.848 21.1591C153.29 21.612 153.893 21.8697 154.524 21.8756C155.155 21.8815 155.762 21.635 156.213 21.1904Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M153.985 20.0924C153.94 19.9998 153.804 19.7171 153.476 3.40723L153.469 3.06454L170.623 2.04395L170.666 2.75689L154.19 3.73618C154.314 10.045 154.539 19.3019 154.643 19.8435C154.638 19.8219 154.631 19.8008 154.621 19.7809L153.985 20.0924Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M97.3167 355C97.2719 354.907 97.1364 354.624 96.8083 338.314L96.8008 337.972L113.955 336.951L113.998 337.664L97.5218 338.643C97.6461 344.952 97.8711 354.209 97.9755 354.751C97.9704 354.729 97.9629 354.708 97.9531 354.688L97.3167 355Z\" fill=#4375C4 /></g></g><path d=\"M49.3753 29.2402L47.7822 35.9629L48.8273 36.2136L50.4203 29.4909L49.3753 29.2402Z\" fill=#76C99F /><path d=\"M45.8869 31.4016L45.6377 32.4531L52.3191 34.0561L52.5683 33.0046L45.8869 31.4016Z\" fill=#76C99F /><path d=\"M247.792 69.6183L245.328 80.0352L246.947 80.4229L249.411 70.0061L247.792 69.6183Z\" fill=#76C99F /><path d=\"M242.387 72.9662L242.001 74.5957L252.356 77.0799L252.742 75.4503L242.387 72.9662Z\" fill=#76C99F /><g opacity=0.6><g opacity=0.6><path opacity=0.6 d=\"M367.423 70.1607C366.686 70.1607 365.965 69.9407 365.352 69.5284C364.738 69.1161 364.26 68.53 363.978 67.8444C363.696 67.1587 363.622 66.4043 363.766 65.6765C363.91 64.9486 364.265 64.2801 364.786 63.7553C365.308 63.2305 365.972 62.8732 366.696 62.7284C367.419 62.5836 368.169 62.6578 368.851 62.9418C369.532 63.2258 370.115 63.7068 370.524 64.3239C370.934 64.9409 371.153 65.6663 371.153 66.4084C371.153 67.4036 370.76 68.358 370.06 69.0617C369.361 69.7654 368.412 70.1607 367.423 70.1607ZM367.423 63.9507C366.94 63.9507 366.467 64.0951 366.065 64.3654C365.663 64.6357 365.35 65.0199 365.164 65.4694C364.979 65.919 364.931 66.4136 365.025 66.8909C365.12 67.3681 365.352 67.8066 365.694 68.1506C366.036 68.4947 366.472 68.729 366.947 68.824C367.421 68.9189 367.912 68.8702 368.359 68.684C368.806 68.4977 369.188 68.1824 369.456 67.7778C369.725 67.3732 369.869 66.8976 369.869 66.411C369.868 65.7588 369.61 65.1336 369.151 64.6724C368.693 64.2113 368.072 63.9517 367.423 63.9507Z\" fill=#828282 /></g></g><path d=\"M186.923 299.823C185.782 299.823 184.667 299.483 183.719 298.845C182.771 298.208 182.032 297.302 181.595 296.241C181.159 295.181 181.044 294.015 181.267 292.889C181.49 291.764 182.039 290.73 182.845 289.918C183.652 289.107 184.679 288.554 185.798 288.33C186.916 288.106 188.076 288.221 189.13 288.66C190.183 289.1 191.084 289.843 191.718 290.797C192.351 291.752 192.69 292.873 192.69 294.021C192.688 295.559 192.08 297.034 190.999 298.122C189.918 299.21 188.452 299.822 186.923 299.823ZM186.923 290.154C186.163 290.154 185.42 290.38 184.787 290.805C184.155 291.23 183.663 291.834 183.372 292.541C183.081 293.248 183.005 294.025 183.153 294.776C183.301 295.526 183.668 296.215 184.205 296.756C184.743 297.296 185.428 297.665 186.173 297.814C186.919 297.963 187.691 297.887 188.394 297.594C189.096 297.301 189.696 296.806 190.119 296.17C190.541 295.534 190.766 294.786 190.766 294.021C190.765 292.995 190.36 292.012 189.64 291.286C188.919 290.56 187.942 290.151 186.923 290.149V290.154Z\" fill=#898A8D /><path d=\"M316.912 277.544C315.772 277.544 314.657 277.204 313.708 276.566C312.76 275.929 312.021 275.022 311.584 273.962C311.148 272.902 311.034 271.735 311.256 270.61C311.479 269.484 312.028 268.45 312.835 267.639C313.641 266.827 314.669 266.275 315.787 266.051C316.906 265.827 318.065 265.942 319.119 266.381C320.173 266.82 321.073 267.564 321.707 268.518C322.341 269.472 322.679 270.594 322.679 271.742C322.677 273.28 322.069 274.755 320.988 275.843C319.907 276.93 318.441 277.542 316.912 277.544ZM316.912 267.874C316.152 267.874 315.409 268.101 314.777 268.526C314.145 268.951 313.652 269.555 313.361 270.262C313.07 270.968 312.994 271.746 313.142 272.496C313.291 273.246 313.657 273.935 314.194 274.476C314.732 275.017 315.417 275.386 316.162 275.535C316.908 275.684 317.681 275.607 318.383 275.315C319.085 275.022 319.686 274.526 320.108 273.89C320.53 273.254 320.756 272.507 320.756 271.742C320.752 270.718 320.345 269.737 319.625 269.013C318.905 268.29 317.93 267.882 316.912 267.879V267.874Z\" fill=#89D1AD /><g opacity=0.5><g opacity=0.5><path opacity=0.5 d=\"M103.695 264.896C104.066 264.531 104.321 264.065 104.429 263.554C104.536 263.044 104.491 262.513 104.298 262.029C104.106 261.544 103.775 261.128 103.347 260.833C102.92 260.538 102.415 260.377 101.896 260.37C101.378 260.364 100.869 260.512 100.435 260.797C99.9999 261.081 99.6589 261.489 99.4545 261.968C99.2501 262.447 99.1916 262.977 99.2863 263.49C99.3811 264.003 99.6248 264.476 99.9868 264.849C100.227 265.098 100.514 265.296 100.83 265.432C101.147 265.569 101.487 265.641 101.831 265.646C102.176 265.65 102.518 265.586 102.837 265.457C103.157 265.329 103.448 265.138 103.695 264.896Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M85.9843 265.433C86.2354 265.186 86.4083 264.87 86.481 264.525C86.5537 264.179 86.5229 263.82 86.3927 263.492C86.2625 263.165 86.0385 262.883 85.7493 262.683C85.46 262.484 85.1184 262.375 84.7676 262.37C84.4168 262.366 84.0725 262.466 83.7784 262.659C83.4843 262.851 83.2535 263.127 83.1153 263.452C82.977 263.776 82.9374 264.134 83.0016 264.481C83.0658 264.828 83.2308 265.149 83.4758 265.401C83.6384 265.569 83.8324 265.703 84.0465 265.795C84.2606 265.888 84.4907 265.937 84.7236 265.94C84.9565 265.943 85.1878 265.899 85.4041 265.812C85.6204 265.725 85.8176 265.596 85.9843 265.433Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M87.0701 281.561C87.4034 281.229 87.6316 280.806 87.7261 280.344C87.8206 279.883 87.7771 279.403 87.6011 278.967C87.4252 278.53 87.1246 278.155 86.7373 277.89C86.35 277.625 85.8934 277.481 85.4249 277.477C84.9565 277.472 84.4973 277.608 84.1052 277.866C83.7131 278.123 83.4057 278.492 83.2218 278.926C83.0378 279.359 82.9856 279.838 83.0716 280.301C83.1576 280.765 83.378 281.192 83.7051 281.529C84.1474 281.982 84.7502 282.24 85.3812 282.246C86.0122 282.252 86.6197 282.005 87.0701 281.561Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M84.843 280.464C84.7983 280.371 84.6628 280.088 84.3346 263.778L84.3271 263.436L101.482 262.415L101.524 263.128L85.0482 264.107C85.1725 270.416 85.3975 279.673 85.5019 280.215C85.4968 280.193 85.4893 280.172 85.4795 280.152L84.843 280.464Z\" fill=#4375C4 /></g></g><path d=\"M3.73763 183.79L2.14453 190.513L3.18956 190.763L4.78266 184.041L3.73763 183.79Z\" fill=#76C99F /><path d=\"M0.249174 185.951L0 187.003L6.68139 188.606L6.93056 187.554L0.249174 185.951Z\" fill=#76C99F /><path d=\"M215.987 307.712L213.523 318.129L215.143 318.517L217.606 308.1L215.987 307.712Z\" fill=#76C99F /><path d=\"M210.582 311.06L210.196 312.689L220.551 315.174L220.937 313.544L210.582 311.06Z\" fill=#76C99F /><g opacity=0.6><g opacity=0.6><path opacity=0.6 d=\"M337.004 72.9449C336.267 72.9449 335.546 72.725 334.933 72.3127C334.32 71.9003 333.841 71.3142 333.559 70.6286C333.277 69.9429 333.203 69.1885 333.347 68.4607C333.491 67.7328 333.846 67.0642 334.367 66.5395C334.889 66.0147 335.554 65.6573 336.277 65.5126C337 65.3678 337.75 65.442 338.432 65.726C339.113 66.01 339.696 66.491 340.105 67.1081C340.515 67.7251 340.734 68.4505 340.734 69.1926C340.734 70.1878 340.341 71.1422 339.641 71.8459C338.942 72.5496 337.993 72.9449 337.004 72.9449ZM337.004 66.7349C336.521 66.7349 336.048 66.8793 335.646 67.1496C335.244 67.4199 334.931 67.8041 334.746 68.2536C334.56 68.7032 334.512 69.1978 334.606 69.6751C334.701 70.1523 334.933 70.5908 335.275 70.9349C335.617 71.2789 336.053 71.5133 336.528 71.6082C337.002 71.7031 337.494 71.6544 337.94 71.4682C338.387 71.282 338.769 70.9666 339.037 70.562C339.306 70.1574 339.45 69.6818 339.45 69.1952C339.449 68.543 339.191 67.9178 338.732 67.4566C338.274 66.9955 337.653 66.7359 337.004 66.7349Z\" fill=#828282 /></g></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1s><path d=\"M151.479 189.195C151.479 189.195 153.286 193.135 153.192 194.215C153.097 195.294 151.479 198.704 151.479 198.704L149.522 189.65L151.479 189.195Z\" fill=#FFB27D /><path d=\"M150.047 172.243L151.477 189.195L149.52 189.65L144.364 174.289L150.047 172.243Z\" fill=#FFB27D /><path d=\"M107.978 117.826L127.414 106.271L140.774 115.704L122.278 126.557L107.978 117.826Z\" fill=#233862 /><path d=\"M117.966 123.147C117.966 123.147 117.476 125.988 114.748 127.466C112.039 128.924 109.705 129.36 110.289 134.076C110.872 138.793 107.673 139.872 107.09 142.998C106.507 146.123 106.582 151.843 114.372 150.138C122.161 148.434 139.999 149.646 141.937 147.108C143.875 144.57 142.52 139.285 139.209 135.288C135.916 131.273 140.281 128.659 138.719 125.136C137.158 121.613 134.185 117.976 134.185 117.976C134.185 117.976 121.371 115.514 117.966 123.147Z\" fill=#132644 /><path d=\"M121.654 253.102L124.27 264.258L128.221 264.239L128.353 253.102H121.654Z\" fill=#FFB27D /><path d=\"M154.768 253.576L162.256 264.258L165.173 260.489L160.657 252.117L154.768 253.576Z\" fill=#FFB27D /><path d=\"M131.99 140.78C132.008 140.799 131.5 153.186 129.393 153.205C128.941 153.205 125.686 144.53 125.272 144.417C123.015 143.792 122.695 138.242 122.732 138.223C123.692 138.034 123.955 136.708 123.936 131.025L124.369 131.12L131.632 132.56C131.632 132.56 131.463 134.87 131.463 137.03C131.482 138.848 131.576 140.591 131.99 140.78Z\" fill=#FFB27D /><path d=\"M102.632 128.338L102.388 127.846C107.675 125.308 107.957 119.322 107.957 117.94C107.957 117.769 108.051 117.599 108.221 117.523C108.39 117.447 108.559 117.58 108.559 117.75C108.559 119.36 108.145 125.705 102.632 128.338Z\" fill=#EFCBAB /><path d=\"M102.405 127.846L101.652 127.959L102.085 128.812L102.631 128.338L102.405 127.846Z\" fill=#D8A987 /><path d=\"M101.652 127.958C101.652 127.958 100.674 128.413 100.41 128.147C100.41 128.147 100.523 129.019 100.918 129.189C100.918 129.189 101.746 129.094 102.066 128.81L101.652 127.958Z\" fill=#EFCBAB /><path d=\"M131.64 132.561C131.64 132.561 131.471 134.872 131.471 137.031C127.406 136.917 125.261 133.186 124.377 131.103L131.64 132.561Z\" fill=#EF9E67 /><path d=\"M122.875 131.369C122.875 131.369 120.128 128.471 119.056 125.724C118.284 123.773 117.814 116.045 125.528 115.61C125.528 115.61 127.749 115.382 130.082 116.367C131.926 117.144 134.767 119.057 133.45 126.16L133.205 128.508L122.875 131.369Z\" fill=#132644 /><path d=\"M164.46 258.046C164.46 258.046 162.522 258.387 160.942 258.501C160.584 258.52 160.264 258.539 159.963 258.539C159.192 258.539 157.818 258.255 156.896 258.027L156.821 258.008C156.407 257.914 156.106 257.838 155.993 257.8L155.937 257.781C155.937 257.781 146.303 246.985 140.903 229.692C140.771 229.294 140.639 228.877 140.508 228.479C137.554 219.804 131.42 208.913 128.183 199.045C127.675 197.473 127.205 195.995 126.791 194.594C126.659 194.139 126.528 193.704 126.415 193.268C124.025 184.934 123.348 179.479 122.708 173.626L142.126 178.607C142.145 178.626 150.311 214.217 164.46 258.046Z\" fill=#A53D38 /><path d=\"M132.902 133.717C132.902 133.717 123.494 135.782 122.309 129.872C121.123 123.963 119.11 120.25 125.056 118.678C131.002 117.106 132.639 119.133 133.504 121.008C134.389 122.883 135.329 133.035 132.902 133.717Z\" fill=#FFB27D /><path d=\"M129.336 117.655C129.336 117.655 128.151 125.118 124.387 126.955C120.624 128.793 118.705 128.073 118.705 128.073C118.705 128.073 121.264 125.023 121.038 120.648C121.038 120.648 126.739 114.757 129.336 117.655Z\" fill=#132644 /><path d=\"M128.807 118.357C128.807 118.357 131.046 119.513 131.817 120.933C132.589 122.335 134.188 122.846 134.301 125.119C134.301 125.119 135.298 120.005 132.589 117.789C129.691 115.421 128.807 118.357 128.807 118.357Z\" fill=#132644 /><path d=\"M124.135 263.635C124.135 263.635 124.455 265.851 123.627 268.2C123.627 268.2 122.987 271.154 125.866 271.211C128.764 271.268 129.46 270.984 129.14 269.185C128.82 267.366 128.18 264.241 128.18 264.241L124.135 263.635Z\" fill=#FFB27D /><path d=\"M123.645 268.198C123.645 268.198 123.118 270.982 123.438 272.479C123.438 272.479 124.304 273.141 126.411 273.141C128.405 273.141 129.44 272.479 129.44 272.479C129.44 272.479 129.497 269.41 128.97 268.122C128.97 268.122 126.919 271.228 123.645 268.198Z\" fill=#C45446 /><path d=\"M172.139 269.486C172.139 269.486 166.814 263.52 165.177 260.489L161.207 262.535L170.069 270.907L172.139 270.623V269.486Z\" fill=#FFB27D /><path d=\"M175.523 272.971C175.523 272.971 169.785 272.971 168.806 272.857C167.828 272.743 167.038 271.323 165.965 269.183C165.532 268.311 164.554 267.819 163.557 267.554V272.516H162.051L160.621 267.251C159.681 265.508 160.546 263.917 161.205 262.534C161.976 262.534 164.065 263.065 167.997 267.535C169.295 268.993 170.725 269.523 172.137 269.486C172.155 269.505 172.174 269.505 172.193 269.523C175.467 271.001 175.523 272.971 175.523 272.971Z\" fill=#C45446 /><path d=\"M160.941 258.501C160.584 258.52 160.264 258.539 159.963 258.539C159.191 258.539 157.818 258.254 156.896 258.027L156.82 258.008L155.993 257.8L155.936 257.781C155.936 257.781 146.302 246.985 140.902 229.691C140.771 229.294 140.639 228.877 140.507 228.479C137.553 219.804 131.419 208.913 128.183 199.045C127.675 197.473 127.204 195.995 126.79 194.593C126.659 194.139 126.527 193.703 126.414 193.268L129.857 190.635C129.857 190.635 140.168 207.436 143.367 223.27C146.02 236.396 157.423 253.406 160.941 258.501Z\" fill=#912F2F /><path d=\"M130.233 224.766C130.289 232.456 129.913 250.147 128.916 257.477C128.916 257.477 127.975 258.311 125.623 258.33C123.234 258.349 122.161 257.458 122.161 257.458C119.659 244.73 117.89 234.199 116.592 225.107C115.538 217.663 114.597 211.28 113.863 205.768C113.223 200.9 117.288 187.698 117.288 187.698L132.529 186.202C132.265 199.688 130.195 220.296 130.233 224.766Z\" fill=#A53D38 /><path d=\"M125.623 258.311C123.591 258.425 122.161 257.44 122.161 257.44C119.659 244.711 117.89 234.18 116.592 225.088C115.538 217.644 114.597 211.261 113.863 205.749C113.223 200.882 117.288 187.68 117.288 187.68L122.462 191.013C122.462 191.013 115.124 197.718 116.93 210.409C118.718 223.118 123.121 256.531 125.623 258.311Z\" fill=#912F2F /><path d=\"M149.633 177.073C148.673 177.395 147.601 177.585 146.547 177.736C144.854 177.982 143.217 178.153 142.144 178.626C139.021 180.047 131.476 138.055 131.476 138.055C131.476 138.055 136.97 138.112 139.491 142.108C142.012 146.105 151.834 165.898 152.719 172.224C153.114 175.103 151.646 176.391 149.633 177.073Z\" fill=#1C468A /><path d=\"M160.939 233.707C160.939 233.707 160.431 234.976 159.038 236.756C158.342 237.647 157.439 238.651 156.273 239.711C153.187 242.458 148.257 245.45 140.655 246.928C140.26 247.004 139.846 247.079 139.414 247.155C137.118 247.534 134.917 247.818 132.828 247.988C128.557 248.367 124.737 248.386 121.463 248.235C119.224 248.14 117.267 247.951 115.611 247.742C111.886 247.269 109.76 246.7 109.76 246.7C109.76 246.7 109.76 208.761 112.864 186.222C114.577 173.739 120.353 138.263 120.353 138.263L123.213 137.827L130.081 153.245L131.436 138.092L134.559 139.096C136.102 139.589 137.269 140.858 137.664 142.43L160.939 233.707Z\" fill=#1C468A /><path d=\"M138.795 175.426L122.839 173.797L125.417 150.519L141.372 152.147L138.795 175.426Z\" fill=#BC3F3F /><path d=\"M125.416 150.517L124.4 150.441L121.991 173.682L122.838 173.796L125.416 150.517Z\" fill=#9B2323 /><path d=\"M112.041 162.509C112.041 162.509 123.236 165.956 133.943 167.49C133.943 167.49 137.48 169.025 135.824 169.441C135.391 169.555 113.96 174.252 110.78 171.203L112.041 162.509Z\" fill=#FFB27D /><path d=\"M123.233 137.791C123.233 137.791 114.86 138.814 113.449 140.519C108.989 145.898 104.944 168.892 108.444 174.215C112.621 180.56 119.056 170.597 121.069 164.744C122.104 161.695 123.816 143.322 123.233 137.791Z\" fill=#1C468A /><path d=\"M132.886 167.337C132.886 167.337 134.203 167.204 134.448 166.787C134.956 165.935 135.727 165.954 136.386 165.84C137.045 165.727 137.778 165.007 137.91 165.158C138.042 165.31 137.421 166.106 137.082 166.409C137.082 166.409 137.797 166.446 138.249 166.219C138.719 165.992 140.356 164.117 140.356 164.912C140.375 166.863 140.224 167.185 138.569 168.568C137.195 169.704 132.566 170.121 132.566 170.121L132.886 167.337Z\" fill=#FFB27D /><path d=\"M123.213 161.996L122.893 165.292C122.366 165.178 121.764 164.989 121.068 164.705C116.477 162.849 118.283 153.662 118.283 153.662C118.998 157.356 121.293 160.197 123.213 161.996Z\" fill=#233862 /><path d=\"M134.203 117.977C134.203 117.977 127.41 115.382 117.965 123.166L118.153 121.386C118.322 119.795 119.131 118.355 120.411 117.389C121.841 116.31 124.136 115.135 127.58 114.643C129.951 114.302 132.303 115.325 133.695 117.276L134.203 117.977Z\" fill=#1C468A /><path d=\"M149.638 177.075C148.679 177.396 147.606 177.586 146.552 177.737L142.149 158.152C142.149 158.152 149.563 173.211 149.638 177.075Z\" fill=#233862 /><path d=\"M129.558 130.479C129.558 130.479 129.99 131.312 130.63 131.331C131.27 131.331 132.888 131.179 133.001 131.028C133.114 130.876 133.434 129.986 133.434 129.986C133.434 129.986 130.743 129.929 129.558 130.479Z\" fill=white /></g><path class=\"wow slideInRight\" data-wow-delay=1s d=\"M333.443 276.549H25.2413C25.0463 276.549 24.8945 276.224 24.8945 275.854V275.616C24.8945 275.225 25.0571 274.921 25.2413 274.921H333.443C333.638 274.921 333.79 275.247 333.79 275.616V275.854C333.79 276.245 333.638 276.549 333.443 276.549Z\" fill=#2E3552 /><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1.33s><path d=\"M32.0934 173.026L30.2871 192.782L32.959 193.199L40.5041 175.621L32.0934 173.026Z\" fill=#FFB27D /><path d=\"M33.3018 191.172C33.3018 191.172 32.6809 193.236 33.0761 194.771C33.3395 195.793 31.7401 197.214 29.9903 199.165C29.8209 199.354 29.4822 199.165 29.5199 198.9C29.5387 198.767 29.5763 198.597 29.6704 198.407C29.9903 197.669 30.8934 196.381 30.8934 196.381C30.8182 196.097 28.9554 197.1 27.9017 197.801C27.2808 198.218 25.5121 200.131 25.0417 199.847C24.5713 199.563 25.3239 197.707 26.1518 196.343C26.9797 194.979 29.915 193.824 30.2913 192.782C30.6676 191.74 33.3018 191.172 33.3018 191.172Z\" fill=#FFB27D /><path d=\"M41.9229 101.391L61.4725 93L79.4792 101.656L61.4725 110.861L41.9229 101.391Z\" fill=#233862 /><path d=\"M45.0822 111.034L45.3644 110.655C41.4319 107.681 42.2034 102.7 42.4292 101.563C42.4668 101.412 42.3915 101.26 42.2786 101.184C42.1657 101.09 41.9964 101.165 41.9588 101.317C41.7142 102.643 40.9803 107.927 45.0822 111.034Z\" fill=#EFCBAB /><path d=\"M45.3672 110.653L45.9505 110.881L45.4613 111.506L45.085 111.032L45.3672 110.653Z\" fill=#D8A987 /><path d=\"M45.9494 110.882C45.9494 110.882 46.6832 111.412 46.9278 111.261C46.9278 111.261 46.6832 111.961 46.3257 112.037C46.3257 112.037 45.6672 111.81 45.4414 111.526L45.9494 110.882Z\" fill=#EFCBAB /><path d=\"M54.5383 251.291L53.2212 256.898L51.4525 264.341H45.9583L45.6384 257.22L45.375 251.708L54.5383 251.291Z\" fill=#FFB27D /><path d=\"M43.7979 272.521C43.7979 272.521 43.7979 269.813 44.1742 268.904C44.5505 267.995 45.9617 264.339 45.9617 264.339H51.4559C51.4559 264.339 52.472 267.691 52.5472 268.771C52.6037 269.87 52.5472 272.503 52.5472 272.503H43.7979V272.521Z\" fill=#233862 /><path d=\"M78.6895 272.521C78.6895 272.521 78.6895 269.813 78.3132 268.904C77.9369 267.995 76.5257 264.339 76.5257 264.339H71.0315C71.0315 264.339 70.0154 267.691 69.9401 268.771C69.8837 269.87 69.9401 272.503 69.9401 272.503H78.6895V272.521Z\" fill=#233862 /><path d=\"M56.6738 120.504C56.6738 120.504 56.4857 126.527 55.7142 129.235L49.6367 142.4L63.0712 161.113L72.4791 136.926L67.0225 129.349C67.0225 129.349 65.3856 121.261 66.2323 118.269C67.1355 115.276 56.6738 120.504 56.6738 120.504Z\" fill=#FFB27D /><path d=\"M56.6377 121.316C56.6377 121.316 58.444 125.692 61.8497 125.597C65.2553 125.502 66.0268 121.619 66.0268 121.619L56.6377 121.316Z\" fill=#ED985F /><path d=\"M54.6091 117.776C54.6091 117.776 53.5178 112.246 52.7464 110.579C51.9749 108.912 51.3352 101.449 59.8399 101.051C59.8399 101.051 63.0951 101.43 64.8826 100.351C64.8826 100.351 64.8826 101.449 64.431 101.828C64.431 101.828 66.6513 100.426 68.9468 103.002C71.2423 105.578 68.1377 115.276 68.3259 117.398L54.6091 117.776Z\" fill=#132644 /><path d=\"M61.4761 123.913C59.0112 123.875 54.4766 120.56 54.4766 116.469V110.086C54.4766 108.589 55.5114 107.377 56.7721 107.377H66.18C67.4407 107.377 68.4755 108.608 68.4755 110.086V116.109C68.4755 120.408 64.2984 123.969 61.4761 123.913Z\" fill=#FFB27D /><path d=\"M54.451 113.495C54.451 113.495 54.4698 109.65 57.4804 109.063C60.4909 108.476 67.2646 110.938 68.2242 108.135C69.1838 105.332 55.166 105.389 54.451 107.169C53.7548 108.968 54.451 113.495 54.451 113.495Z\" fill=#132644 /><path d=\"M55.7164 129.235L61.3423 130.504L67.0247 129.121L68.4735 137.891L62.0949 159.73L55.1143 133.553L55.7164 129.235Z\" fill=white /><path d=\"M55.4492 131.015L59.9086 134.387L61.3762 131.962L62.7121 134.387L67.4725 130.201L66.5317 129.121L61.3386 130.504L55.7126 130.239L55.4492 131.015Z\" fill=#D2E3FC /><path d=\"M78.8116 178.67L65.4336 179.503C65.3583 179.371 65.2642 179.371 65.1701 179.522L61.2376 179.769L44.4727 178.708C44.4727 178.708 40.258 198.085 41.9138 223.92C42.4406 232.16 43.626 256.556 44.755 265.193L56.2514 265.307C57.7379 255.552 59.469 231.194 60.3909 227.008C60.8049 225.114 61.2 223.219 61.5575 221.363C61.8962 223.485 62.1032 225.208 62.1032 226.288C62.1032 228.012 62.5924 230.739 63.2886 234.035C64.2482 238.675 67.1082 260.041 67.9549 265.629H80.0159C80.1664 257.938 80.8249 231.819 80.9566 223.92C81.3141 202.858 78.8116 178.67 78.8116 178.67Z\" fill=#EE9849 /><path d=\"M88.056 246.764C81.9033 250.003 40.038 253.848 32.5305 244.946C31.2511 243.43 49.0885 130.504 49.0885 130.504C49.0885 130.504 50.2362 130.163 52.1742 129.803C53.1715 129.614 54.3569 129.424 55.7116 129.254C55.7304 129.67 58.6093 148.005 62.5606 155.165C62.5606 155.165 67.0199 145.297 67.0387 129.348C67.0387 129.273 67.0199 129.197 67.0199 129.121C67.8666 129.216 68.7134 129.329 69.5789 129.481C69.9364 129.538 70.3127 129.614 70.6702 129.689C72.0438 129.973 73.4361 130.333 74.8097 130.788C74.8097 130.788 89.3355 246.082 88.056 246.764Z\" fill=#1C468A /><path d=\"M53.9436 129.464C53.9436 129.464 47.5274 179.014 45.0814 182.726C44.0465 184.279 42.5412 184.526 40.7725 184.185C40.4339 184.128 40.0764 184.033 39.7377 183.919L34.8267 182.025H34.8079C34.0177 181.703 33.2086 181.4 32.3995 181.154C27.3569 179.582 27.752 175.301 29.1067 169.467C30.4615 163.634 39.3614 135.563 42.3719 133.574C47.678 130.07 53.9436 129.464 53.9436 129.464Z\" fill=#1C468A /><path d=\"M67.0222 129.12C62.8074 128.665 58.8373 128.874 55.7139 129.252C55.7139 129.234 55.7139 129.234 55.7139 129.234C55.7139 129.234 66.1755 122.718 67.0222 129.12Z\" fill=#FFB27D /><path d=\"M63.3277 159.748C56.8551 154.956 52.1699 129.803 52.1699 129.803C53.1672 129.613 54.3526 129.424 55.7073 129.253C55.7261 129.67 58.4544 147.001 62.3869 154.161C62.3869 154.161 67.0156 145.296 67.0344 129.367C67.0344 129.291 67.0156 129.215 67.0156 129.14C67.8623 129.234 68.709 129.348 69.5746 129.5C69.9321 129.556 70.3084 129.632 70.6659 129.708C70.6659 143.099 63.3277 159.748 63.3277 159.748Z\" fill=#BC3F3F /><path d=\"M59.29 119.177C59.29 119.177 62.2441 118.874 63.6177 119.215C63.6177 119.215 62.8839 120.408 61.6796 120.408C60.4754 120.389 59.5723 119.953 59.29 119.177Z\" fill=#FFF0E6 /><path d=\"M52.1543 104.327L52.3236 107.225C52.3236 107.225 58.9468 102.774 69.8036 106.865L69.653 102.679C69.5025 101.865 68.9945 101.164 68.2795 100.747C66.2474 99.5731 61.4681 97.3759 53.9418 101.05C52.8881 101.543 52.2296 103.134 52.1543 104.327Z\" fill=#1C468A /><path d=\"M56.2052 126.562L53.9473 129.46L59.9307 133.57L61.3419 130.501L56.2052 126.562Z\" fill=white /><path d=\"M66.5489 126.562L61.3369 130.501L62.8422 133.57L67.9789 129.232L66.5489 126.562Z\" fill=white /><path d=\"M61.167 137.285C61.3364 137.115 61.581 137.115 61.7503 137.285C61.9197 137.456 61.9197 137.702 61.7503 137.872C61.581 138.043 61.3364 138.043 61.167 137.872C60.9977 137.702 60.9977 137.437 61.167 137.285Z\" fill=#D2E3FC /><path d=\"M61.454 142.454C61.6826 142.454 61.8679 142.267 61.8679 142.037C61.8679 141.807 61.6826 141.62 61.454 141.62C61.2254 141.62 61.04 141.807 61.04 142.037C61.04 142.267 61.2254 142.454 61.454 142.454Z\" fill=#D2E3FC /><path d=\"M61.167 146.34C61.3364 146.169 61.581 146.169 61.7503 146.34C61.9197 146.51 61.9197 146.756 61.7503 146.927C61.581 147.097 61.3364 147.097 61.167 146.927C60.9977 146.756 60.9977 146.491 61.167 146.34Z\" fill=#D2E3FC /><path d=\"M74.8037 130.787C74.8037 130.787 78.8303 132.473 80.9753 137.435C83.1203 142.398 92.0578 155.96 91.7944 162.305C91.531 168.65 90.3268 174.427 84.3245 174.617C80.2039 174.749 76.0079 170.696 76.0079 164.616C76.0079 158.555 74.8037 130.787 74.8037 130.787Z\" fill=#1C468A /><path d=\"M87.5825 171.057C87.4131 172.761 86.7922 174.144 85.2681 174.542C80.4513 175.754 78.3251 171.076 79.3411 166.492C79.3788 166.34 79.4164 166.189 79.454 166.056C80.4889 162.704 84.1768 162.192 85.5504 162.117C85.8702 162.098 86.0584 162.098 86.0584 162.098C86.0584 162.098 86.0772 162.173 86.1337 162.306C86.4723 163.348 87.9023 167.799 87.5825 171.057Z\" fill=#233862 /><path d=\"M87.584 171.057C87.584 171.057 73.5474 164.693 67.9968 157.4C67.5828 156.87 68.6365 156.207 68.6365 156.207L85.5331 162.117L86.1164 162.325C86.4739 163.348 87.9039 167.799 87.584 171.057Z\" fill=#FFB27D /><path d=\"M71.0824 156.547H52.5488V181.151H71.0824V156.547Z\" fill=#FCECDB /><path d=\"M60.1735 173.882L58.085 177.386L59.4021 177.197L59.9665 178.257L61.7352 175.037L60.1735 173.882Z\" fill=#932424 /><path d=\"M62.926 173.673L65.0145 177.177L63.6974 176.988L63.133 178.048L61.3643 174.809L62.926 173.673Z\" fill=#932424 /><path d=\"M59.4417 173.105C59.6675 171.571 60.4954 170.965 61.756 170.776C63.4118 170.529 64.0704 171.817 64.0704 173.105C64.0704 174.393 63.0355 175.435 61.756 175.435C60.4765 175.435 59.2347 174.393 59.4417 173.105Z\" fill=#BC3F3F /><path d=\"M61.7319 174.959C61.1674 174.959 60.6029 174.694 60.2454 174.277C59.9444 173.936 59.8127 173.501 59.8879 173.084C60.0573 171.985 60.6218 171.417 61.7131 171.247C62.2211 171.171 62.6539 171.266 62.9737 171.55C63.3501 171.872 63.5759 172.44 63.5759 173.103C63.5947 174.126 62.7668 174.959 61.7319 174.959ZM62.0329 171.436C61.9389 171.436 61.8448 171.436 61.7507 171.455C60.7535 171.607 60.2643 172.099 60.0949 173.122C60.0385 173.482 60.1514 173.842 60.4148 174.145C60.7347 174.524 61.2427 174.751 61.7319 174.751C62.6351 174.751 63.3689 174.012 63.3689 173.103C63.3689 172.516 63.1807 172.004 62.842 171.72C62.6351 171.531 62.3716 171.436 62.0329 171.436Z\" fill=#932424 /><path d=\"M64.4066 159.501H59.2511C59.157 159.501 59.1006 159.426 59.1006 159.351C59.1006 159.257 59.1758 159.2 59.2511 159.2H64.4066C64.5007 159.2 64.5572 159.275 64.5572 159.351C64.5572 159.426 64.4819 159.501 64.4066 159.501Z\" fill=#1C468A /><path d=\"M65.4043 160.164H58.2355C58.1414 160.164 58.085 160.089 58.085 160.014C58.085 159.92 58.1602 159.863 58.2355 159.863H65.4043C65.4984 159.863 65.5548 159.939 65.5548 160.014C65.5548 160.089 65.4796 160.164 65.4043 160.164Z\" fill=#1C468A /><path d=\"M67.0847 165.583H56.5102C56.4161 165.583 56.3408 165.508 56.3408 165.413C56.3408 165.319 56.4161 165.244 56.5102 165.244H67.0847C67.1787 165.244 67.254 165.319 67.254 165.413C67.2728 165.508 67.1787 165.583 67.0847 165.583Z\" fill=#1C468A /><path d=\"M67.0847 166.493H56.5102C56.4161 166.493 56.3408 166.418 56.3408 166.324C56.3408 166.23 56.4161 166.154 56.5102 166.154H67.0847C67.1787 166.154 67.254 166.23 67.254 166.324C67.2728 166.399 67.1787 166.493 67.0847 166.493Z\" fill=#1C468A /><path d=\"M67.0847 167.268H56.5102C56.4161 167.268 56.3408 167.193 56.3408 167.099C56.3408 167.005 56.4161 166.93 56.5102 166.93H67.0847C67.1787 166.93 67.254 167.005 67.254 167.099C67.2728 167.193 67.1787 167.268 67.0847 167.268Z\" fill=#1C468A /><path d=\"M67.0847 168.12H56.5102C56.4161 168.12 56.3408 168.045 56.3408 167.951C56.3408 167.857 56.4161 167.781 56.5102 167.781H67.0847C67.1787 167.781 67.254 167.857 67.254 167.951C67.2728 168.045 67.1787 168.12 67.0847 168.12Z\" fill=#1C468A /><path d=\"M67.9726 173.196C67.6339 173.48 67.2764 173.708 66.9001 173.916C66.9377 173.821 66.9565 173.708 66.9565 173.613C66.9565 173.48 66.8436 173.424 66.7496 173.386C66.7307 173.367 66.6931 173.367 66.6743 173.348C66.7119 173.31 66.7307 173.253 66.7119 173.196C66.6743 173.102 66.5426 173.121 66.505 173.196C66.505 173.215 66.4861 173.234 66.4861 173.253C66.4673 173.253 66.4485 173.234 66.4485 173.215C66.505 173.102 66.5614 172.988 66.6179 172.855C66.6367 172.836 66.6179 172.799 66.599 172.78C66.505 172.704 66.3921 172.742 66.3168 172.817C66.2227 172.912 66.2604 173.064 66.298 173.177V173.196C66.2227 173.348 66.1286 173.48 66.0346 173.613L66.0157 173.594C65.9969 173.575 65.9593 173.537 65.9405 173.499C65.9781 173.386 66.0157 173.272 66.0157 173.158C66.0157 173.102 65.9593 173.083 65.9217 173.102C65.79 173.139 65.7335 173.272 65.7523 173.405C65.7523 173.443 65.7711 173.499 65.79 173.537C65.7711 173.594 65.7335 173.651 65.6959 173.708C65.6771 173.746 65.6959 173.783 65.7147 173.802C65.6771 173.935 65.6206 174.068 65.5265 174.181C65.4513 174.257 65.3008 174.314 65.2255 174.219C65.169 174.162 65.1502 174.068 65.1502 173.973C65.1314 173.783 65.1126 173.575 65.1314 173.386C65.1314 173.291 65.1502 173.196 65.169 173.102C65.1879 173.045 65.2067 172.969 65.2443 173.064C65.2631 173.102 65.2443 173.177 65.2255 173.234C65.2255 173.31 65.3384 173.329 65.3572 173.253C65.376 173.158 65.4136 172.95 65.3008 172.893C65.2067 172.836 65.1314 172.912 65.075 172.988C64.9244 173.272 64.9809 173.651 64.9997 173.935C65.0185 174.181 65.1126 174.465 65.4136 174.39C65.6959 174.314 65.8088 173.954 65.8652 173.708C65.8652 173.689 65.8652 173.67 65.8652 173.67C65.884 173.689 65.884 173.689 65.9029 173.708C65.9217 173.727 65.9405 173.746 65.9593 173.746C65.9217 173.783 65.9029 173.821 65.8652 173.878C65.8464 173.897 65.8464 173.935 65.8652 173.954C65.9593 174.068 66.1286 173.992 66.1286 173.84C66.1286 173.802 66.1286 173.783 66.1098 173.746C66.2039 173.613 66.2792 173.48 66.3544 173.348C66.3921 173.386 66.4485 173.405 66.505 173.405C66.505 173.405 66.505 173.405 66.5238 173.405C66.5614 173.443 66.599 173.461 66.6367 173.499C66.6743 173.518 66.7119 173.537 66.7496 173.556C66.806 173.613 66.7872 173.67 66.7872 173.746C66.7684 173.84 66.7307 173.935 66.7119 174.03C66.5802 174.105 66.4485 174.2 66.4109 174.352C66.3733 174.484 66.4109 174.636 66.5238 174.712C66.5614 174.73 66.599 174.712 66.6179 174.674C66.6931 174.484 66.7496 174.314 66.806 174.124V174.105C66.9189 174.049 67.0506 173.973 67.1635 173.916C67.4646 173.727 67.7468 173.537 68.029 173.31C68.1231 173.234 68.0478 173.139 67.9726 173.196ZM66.4109 173.026C66.4109 172.969 66.4297 172.874 66.505 172.874C66.4861 172.931 66.4485 172.988 66.4297 173.045C66.4109 173.045 66.4109 173.026 66.4109 173.026ZM66.5614 174.541C66.505 174.446 66.5802 174.314 66.6743 174.219C66.6555 174.333 66.6179 174.427 66.5614 174.541Z\" fill=#1C468A /><path d=\"M70.3456 180.433H53.3926V157.4H70.3456V180.433ZM53.5995 180.243H70.1763V157.59H53.5995V180.243Z\" fill=#1C468A /><path d=\"M64.5526 154.674C64.5526 154.674 61.1281 157.628 62.3699 158.064C63.5929 158.5 66.9045 156.53 67.5443 156.53C68.184 156.53 69.6893 156.53 69.6893 156.53C69.6893 156.53 67.5819 154.068 66.4718 154.143C65.3428 154.219 64.5526 154.674 64.5526 154.674Z\" fill=#FFB27D /><path d=\"M45.082 149.426L40.7732 184.183C40.4345 184.126 40.077 184.031 39.7383 183.917L34.8274 182.023H34.8086C34.8086 182.023 36.3139 180.451 38.3836 174.977C40.4345 169.484 45.082 149.426 45.082 149.426Z\" fill=#233862 /></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1.3s><path d=\"M282.405 93.633C282.405 93.633 284.211 92.0041 284.644 90.8487C285.077 89.7122 285.039 87.7802 285.039 86.5301C285.039 86.5301 284.493 86.3407 284.362 86.9279C284.23 87.515 283.985 88.8977 283.496 89.1818C282.988 89.466 281.878 89.4281 281.615 90.8487C281.351 92.2692 282.405 93.633 282.405 93.633Z\" fill=#B56F40 /><path d=\"M278.303 93.8999C278.303 93.8999 276.666 90.5284 277.005 89.4298C277.344 88.3312 282.368 87.1379 283.026 87.6493C283.685 88.1608 283.026 94.4681 283.026 94.4681L278.303 93.8999Z\" fill=#B56F40 /><path d=\"M331.157 195.404C331.157 195.404 330.912 198.188 331.872 199.514C332.831 200.84 333.358 202.052 333.678 201.446C333.998 200.84 333.151 198.737 333.434 198.794C333.716 198.832 334.487 201.294 334.882 202.052C335.277 202.81 336.124 204.022 336.67 203.416C337.234 202.81 336.143 197.09 335.71 196.37C335.277 195.65 334.356 194.04 334.356 194.04L331.157 195.404Z\" fill=#B56F40 /><path d=\"M296.611 111.57L315.728 100.735L328.579 116.76L311.081 125.302L296.611 111.57Z\" fill=#233862 /><path d=\"M304.639 116.668C304.639 116.668 304.243 118.391 303.115 119.016C301.986 119.641 303.754 121.289 303.321 122.52C302.889 123.752 304.657 125.324 304.657 125.324L317.001 126.763C317.001 126.763 318.807 125.968 318.976 123.827C319.146 121.687 319.334 119.016 319.334 119.016L313.934 114.868L306.163 115.247L304.639 116.668Z\" fill=#C94C43 /><path d=\"M263.161 95.9445C263.161 95.9445 262.597 94.5997 262.183 93.1223C261.995 92.4404 261.863 91.7396 261.825 91.1335C261.807 90.7925 261.825 90.4705 261.882 90.2243C261.882 90.2243 277.8 86.9096 279.362 86.2656C280.923 85.6216 294.621 81 294.621 81C294.621 81 295.092 81.966 295.525 83.2729C295.675 83.7654 295.844 84.2957 295.957 84.845C296.183 85.8679 296.296 86.9475 296.145 87.8945C296.145 87.8945 280.02 89.8265 278.346 90.6221C276.69 91.4555 263.161 95.9445 263.161 95.9445Z\" fill=#EFCBAB /><path d=\"M262.183 93.1223C261.995 92.4404 261.863 91.7396 261.825 91.1335C261.807 90.7925 261.825 90.4705 261.882 90.2243C261.882 90.2243 277.8 86.9096 279.362 86.2656C280.923 85.6216 294.621 81 294.621 81C294.621 81 295.092 81.966 295.525 83.2729C295.675 83.7654 295.844 84.2957 295.957 84.845C291.423 85.4133 279.098 86.9854 277.574 87.7241C276.088 88.4628 266.247 91.7775 262.183 93.1223Z\" fill=#DDB08E /><path d=\"M282.074 85.2998C282.074 85.2998 277.821 85.7165 276.278 87.0803L277.181 91.1147C277.181 91.1147 281.076 90.717 283.052 89.6752L282.074 85.2998Z\" fill=#C94C43 /><path d=\"M285.921 271.906C285.921 271.906 285.921 269.33 286.278 268.478C286.636 267.626 287.972 264.141 287.972 264.141H293.203C293.203 264.141 294.181 267.323 294.238 268.364C294.294 269.406 294.238 271.925 294.238 271.925H285.921V271.906Z\" fill=#233862 /><path d=\"M319.073 271.906C319.073 271.906 319.073 269.33 318.716 268.478C318.358 267.626 317.022 264.141 317.022 264.141H311.791C311.791 264.141 310.813 267.323 310.757 268.364C310.7 269.406 310.757 271.925 310.757 271.925H319.073V271.906Z\" fill=#233862 /><path d=\"M306.013 127.047C306.013 127.047 304.959 132.691 303.849 135.116L297.546 138.241L306.37 155.818L318.507 144.794L314.48 136.877C314.48 136.877 314.104 129.035 315.327 126.365C316.569 123.656 306.013 127.047 306.013 127.047Z\" fill=#B56F40 /><path d=\"M305.864 127.822C305.864 127.822 306.937 132.198 310.135 132.595C313.353 132.993 314.632 129.47 314.632 129.47L305.864 127.822Z\" fill=#99592E /><path d=\"M310.006 130.947C307.692 130.549 303.91 126.78 304.493 122.935L305.415 116.93C305.622 115.529 306.77 114.525 307.974 114.714L316.798 116.078C317.984 116.268 318.774 117.556 318.567 118.957L317.702 124.621C317.1 128.674 312.659 131.401 310.006 130.947Z\" fill=#B56F40 /><path d=\"M286.578 182.79C286.559 182.089 287.481 210.671 286.126 226.904C284.79 242.928 286.145 265.222 286.145 265.222C286.145 265.222 290.51 267.646 295.252 265.222C295.252 265.222 300.445 234.272 300.407 226.904C300.37 219.062 306.052 184.021 306.052 184.021L286.578 182.79Z\" fill=#F99746 /><path d=\"M318.887 265.204C318.887 265.204 314.522 267.628 309.78 265.204C309.78 265.204 304.587 234.254 304.625 226.886C304.643 223.571 303.627 215.408 302.461 207.074C300.861 195.69 298.961 184.003 298.961 184.003L319.188 182.734C319.188 182.734 317.513 210.862 318.887 226.886C320.26 242.91 318.887 265.204 318.887 265.204Z\" fill=#F99746 /><path d=\"M308.122 123.354C307.257 123.222 305.563 122.767 305.488 121.214C305.469 120.74 305.62 120.343 305.921 120.078C306.259 119.774 306.749 119.661 307.257 119.737L309.91 120.153C310.418 120.229 310.738 120.437 310.888 120.74C311.133 121.271 310.775 121.972 310.606 122.237C310.041 123.165 309.402 123.544 308.593 123.411C308.574 123.392 308.386 123.392 308.122 123.354ZM307.238 119.888C306.767 119.812 306.335 119.926 306.034 120.191C305.77 120.418 305.638 120.778 305.657 121.195C305.695 121.991 306.203 122.578 307.144 122.938C307.878 123.203 308.593 123.241 308.611 123.241H308.63C309.364 123.354 309.947 123.013 310.474 122.142C310.587 121.953 310.963 121.29 310.738 120.816C310.625 120.551 310.324 120.381 309.891 120.324L307.238 119.888Z\" fill=#2C3A64 /><path d=\"M314.231 124.302C313.967 124.264 313.779 124.207 313.741 124.207C312.932 124.075 312.443 123.525 312.18 122.465C312.104 122.162 311.973 121.385 312.368 120.949C312.594 120.684 312.97 120.608 313.478 120.684L316.131 121.101C316.658 121.177 317.091 121.442 317.316 121.84C317.523 122.199 317.542 122.616 317.392 123.052C316.846 124.51 315.096 124.434 314.231 124.302ZM313.44 120.855C312.989 120.779 312.669 120.855 312.481 121.063C312.142 121.442 312.293 122.18 312.33 122.408C312.575 123.393 313.026 123.904 313.76 124.018H313.779C313.779 124.018 314.494 124.207 315.265 124.169C316.282 124.112 316.94 123.715 317.204 122.957C317.354 122.559 317.335 122.199 317.147 121.896C316.94 121.555 316.564 121.328 316.093 121.252L313.44 120.855Z\" fill=#2C3A64 /><path d=\"M310.555 121.495C310.517 121.495 310.48 121.457 310.461 121.419C310.442 121.363 310.48 121.306 310.536 121.287C310.574 121.269 311.703 120.967 312.55 121.608C312.587 121.646 312.606 121.702 312.568 121.759C312.531 121.797 312.474 121.815 312.418 121.778C311.646 121.212 310.611 121.495 310.593 121.495C310.593 121.495 310.574 121.495 310.555 121.495Z\" fill=#2C3A64 /><path d=\"M308.22 138.202L302.236 135.588C302.236 135.588 299.151 160.325 303.271 161.859C303.271 161.859 315.05 140.816 314.241 138.107L308.22 138.202Z\" fill=white /><path d=\"M304.437 134.037C304.437 134.037 302.743 134.321 301.878 135.174C301.878 135.174 303.157 139.36 306.563 140.61L308.031 138.204C308.031 138.204 305.246 136.897 304.437 134.037Z\" fill=#D2E3FC /><path d=\"M308.036 138.203C308.036 138.203 313.606 137.995 314.434 135.286C314.434 135.286 315.544 136.46 315.506 138.355C315.506 138.355 313.737 141.025 309.334 141.063L308.036 138.203Z\" fill=#D2E3FC /><path d=\"M308.484 126.744C308.484 126.744 311.438 126.877 312.756 127.407C312.756 127.407 311.852 128.487 310.667 128.297C309.5 128.127 308.673 127.54 308.484 126.744Z\" fill=#FFF0E6 /><path d=\"M287.521 117.953C284.83 119.658 281.161 121.969 278.169 123.787C278.019 123.276 277.906 122.821 277.849 122.405C276.852 116.021 278.301 93.8982 278.301 93.8982C278.301 93.8982 279.298 93.3868 280.333 93.3111C282.29 93.1595 283.024 94.4665 283.024 94.4665C283.024 94.4665 286.392 113.938 287.521 117.953Z\" fill=#B56F40 /><path d=\"M335.084 194.967L333.052 195.819C329.815 196.975 326.316 195.421 325.262 192.126C323.832 187.694 323.681 182.901 323.155 178.962C322.891 177.03 322.59 173.033 321.424 169.927L323.456 238.74C292.936 240.918 278.053 223.265 278.053 223.265C277.263 204.627 284.657 162.653 287.348 148.107C286.05 145.152 276.811 136.666 275.268 128.332C274.553 124.468 276.792 121.722 279.521 119.884C282.945 117.555 287.141 116.646 287.141 116.646L297.001 129.923C297.415 130.397 297.716 130.776 297.828 131.003C298.581 132.556 302.532 135.151 302.532 135.151C302.514 135.227 302.965 157.52 303.755 158.24C304.922 157.804 312.693 142.121 314.424 136.894C316.908 137.575 319.58 138.504 322.402 139.754C322.402 139.754 327.746 142.614 328.498 155.134C329.138 165.741 335.573 179.284 337.041 191.576C337.248 192.997 336.439 194.399 335.084 194.967Z\" fill=#1C468A /><path d=\"M301.483 134.358C301.483 134.358 302.198 155.97 303.12 161.387L316.818 137.578L314.937 136.878L304.099 156.595L303.026 135.116L301.483 134.358Z\" fill=#C94C43 /><path d=\"M304.437 133.523C304.437 133.523 302.743 133.808 301.878 134.66C301.878 134.66 303.157 138.846 306.563 140.096L308.031 138.202C308.031 138.202 305.246 136.384 304.437 133.523Z\" fill=white /><path d=\"M308.036 138.203C308.036 138.203 313.606 137.483 314.434 134.774C314.434 134.774 315.544 135.949 315.506 137.843C315.506 137.843 313.737 140.514 309.334 140.551L308.036 138.203Z\" fill=white /><path d=\"M300.863 164.72C301.424 164.72 301.879 164.263 301.879 163.698C301.879 163.133 301.424 162.675 300.863 162.675C300.302 162.675 299.847 163.133 299.847 163.698C299.847 164.263 300.302 164.72 300.863 164.72Z\" fill=#233862 /><path d=\"M297.951 172.865C297.951 172.296 298.403 171.842 298.967 171.842C299.532 171.842 299.983 172.296 299.983 172.865C299.983 173.433 299.532 173.887 298.967 173.887C298.422 173.887 297.951 173.433 297.951 172.865Z\" fill=#233862 /><path d=\"M297.996 121.704L298.335 121.382C294.948 117.783 296.528 113.01 296.942 111.911C296.999 111.779 296.961 111.608 296.867 111.513C296.754 111.4 296.585 111.438 296.528 111.589C296.039 112.858 294.459 117.953 297.996 121.704Z\" fill=#EFCBAB /><path d=\"M298.338 121.383L298.865 121.705L298.281 122.254L297.999 121.705L298.338 121.383Z\" fill=#D8A987 /><path d=\"M298.861 121.706C298.861 121.706 299.501 122.35 299.764 122.236C299.764 122.236 299.407 122.88 299.049 122.899C299.049 122.899 298.428 122.577 298.259 122.255L298.861 121.706Z\" fill=#EFCBAB /><path d=\"M304.951 117.972C304.951 117.972 307.322 118.143 308.018 116.931C308.018 116.931 309.937 117.423 310.803 116.684C310.803 116.684 313.776 117.291 313.851 116.078C313.851 116.078 316.128 120.662 318.611 119.696C321.095 118.73 314.622 114.108 314.622 114.108L306.155 115.245L304.951 117.972Z\" fill=#C94C43 /><path d=\"M305.133 114.545L304.644 116.666C304.644 116.666 311.267 114.299 319.339 119.015L319.245 115.587C319.226 114.924 318.925 114.299 318.417 113.863C316.949 112.651 313.468 110.283 306.996 112.158C306.074 112.442 305.34 113.617 305.133 114.545Z\" fill=#1C468A /><path d=\"M276.235 88.3301C276.216 88.1975 275.783 87.2884 276.366 86.436C276.968 85.5837 280.882 84.2768 281.24 84.9776C281.597 85.6595 281.371 88.046 280.111 88.5764C278.869 89.1067 276.329 88.8605 276.235 88.3301Z\" fill=#B56F40 /><path d=\"M287.391 148.089C286.093 145.135 276.854 136.649 275.311 128.315C274.596 124.451 276.835 121.704 279.564 119.867C279.564 119.867 278.284 125.72 281.916 131.005C285.528 136.27 287.391 148.089 287.391 148.089Z\" fill=#233862 /><path d=\"M333.072 195.802C329.835 196.957 326.335 195.404 325.282 192.108C323.852 187.676 323.701 182.884 323.174 178.944C322.911 177.012 322.61 173.016 321.443 169.909C321.556 170.08 325.056 175.667 328.217 184.702C331.416 193.908 330.418 195.233 333.072 195.802Z\" fill=#233862 /></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1s><path d=\"M213.481 217.806C214.704 215.874 204.411 194.584 209.943 182.727C210.639 181.249 223.453 183.465 223.453 183.465C223.453 183.465 226.068 213.411 224.601 221.347C223.566 226.954 221.515 243.471 220.424 252.695C220.424 252.733 220.424 252.752 220.405 252.79C220.141 254.987 219.934 256.748 219.803 257.847C219.709 258.68 219.803 259.514 220.085 260.309C220.894 262.563 222.682 267.223 223.566 267.867C223.566 267.867 218.711 269.268 217.789 268.719C216.849 268.17 214.497 259.571 214.497 259.571C214.911 258.775 215.061 257.866 214.911 256.976C214.722 255.801 214.44 253.964 214.139 251.71C209.924 234.606 210.564 222.408 213.481 217.806Z\" fill=#FFB27D /><path d=\"M186.071 256.027C186.748 255.421 187.2 254.626 187.369 253.735C187.614 252.58 187.99 250.762 188.498 248.527C190.568 231.101 195.441 219.907 199.788 216.63C201.613 215.266 199.449 191.684 208.782 182.555C209.948 181.418 221.163 188.048 221.163 188.048C221.163 188.048 213.109 216.99 208.951 223.884C206.016 228.752 198.301 243.488 194.03 251.709C192.995 253.698 192.167 255.308 191.641 256.311C191.264 257.05 191.057 257.884 191.038 258.717C191.02 261.123 190.7 267.544 191.641 268.112C192.224 268.453 192.732 268.85 193.146 269.229C193.146 269.229 188.724 268.85 188.178 268.813C187.652 268.794 184.246 258.092 184.189 257.884C184.886 257.145 185.563 256.482 186.071 256.027Z\" fill=#FFB27D /><path d=\"M182.004 261.825L180.894 268.379L181.477 268.814L184.958 263.757L182.004 261.825Z\" fill=#233862 /><path d=\"M182.115 262.336C185.916 264.344 186.481 271.03 187.083 272.469L194.026 272.488C195.08 272.128 194.666 270.632 193.16 269.23C193.16 269.23 188.739 268.852 188.193 268.814C187.666 268.795 184.26 258.093 184.204 257.885C182.605 259.646 181.062 261.768 182.115 262.336Z\" fill=#1C468A /><path d=\"M188.197 240.157C188.498 248.529 205.037 246.919 205.037 246.919L207.22 236.274L208.669 229.209L209.158 226.86L208.424 226.519L197.906 221.5L194.613 219.928L194.482 220.344L188.818 238.225L188.197 240.157Z\" fill=#F99746 /><path d=\"M188.813 238.225C193.593 233.281 207.234 236.274 207.234 236.274L208.683 229.209L208.438 226.52L197.92 221.5L194.496 220.345L188.813 238.225Z\" fill=#EF7E29 /><path d=\"M213.219 266.22L214.122 272.451H215.119L215.608 267.621L213.219 266.22Z\" fill=#233862 /><path d=\"M213.216 266.218C215.324 267.203 217.638 271.332 218.711 272.469L227.479 272.525C228.57 271.616 224.75 268.699 223.565 267.847C223.565 267.847 218.711 269.249 217.789 268.699C216.848 268.15 214.496 259.551 214.496 259.551C213.442 261.559 211.655 265.498 213.216 266.218Z\" fill=#1C468A /><path d=\"M209.156 223.791L211.339 247.827C215.384 252.979 226.053 249.816 226.053 249.816C226.053 249.816 226.862 229.966 227.276 229.189L225.733 228.735L209.156 223.791Z\" fill=#F99746 /><path d=\"M209.156 223.791L211.339 247.827C211.452 236.008 226.655 237.182 226.655 237.182L225.733 228.716L209.156 223.791Z\" fill=#EF7E29 /><path d=\"M227.764 110.883L205.467 102L193.011 114.103L214.197 122.418L227.764 110.883Z\" fill=#233862 /><path d=\"M217.323 114.994C217.323 114.994 217.36 117.665 219.317 118.498C223.363 120.222 219.505 122.23 223.476 125.033C224.379 125.677 225.037 129.711 218.734 130.318C212.431 130.924 211.64 131.454 211.64 131.454C211.64 131.454 206.955 134.485 201.781 131.359C198.77 129.56 202.552 124.541 201.179 123.271C199.316 121.548 199.071 115.922 201.781 113.593C204.49 111.263 208.799 109.918 208.799 109.918L217.323 114.994Z\" fill=#132644 /><path d=\"M235.025 120.809L235.194 120.24C229.23 118.46 227.95 112.228 227.724 110.77C227.706 110.58 227.555 110.429 227.386 110.391C227.198 110.334 227.028 110.505 227.066 110.694C227.329 112.361 228.797 118.952 235.025 120.809Z\" fill=#EFCBAB /><path d=\"M235.189 120.239H235.979L235.678 121.205L235.02 120.808L235.189 120.239Z\" fill=#D8A987 /><path d=\"M235.987 120.239C235.987 120.239 237.079 120.542 237.323 120.239C237.323 120.239 237.342 121.167 236.966 121.414C236.966 121.414 236.081 121.452 235.705 121.205L235.987 120.239Z\" fill=#EFCBAB /><path d=\"M218.696 131.984C218.244 131.927 216.908 130.847 216.306 129.199C215.572 127.211 214.951 125.07 214.951 125.07L213.013 125.392L207.839 126.245L207.406 126.32C207.82 127.419 208.14 128.461 208.347 129.408C208.761 131.131 208.874 132.59 208.836 133.689C208.78 134.806 208.215 135.09 207.895 135.317C207.745 135.412 213.352 153.918 216.062 152.989C218.413 152.175 218.922 131.908 218.696 131.984Z\" fill=#FFB27D /><path d=\"M208.839 133.67C211.943 132.401 214.954 125.051 214.954 125.051C214.333 124.976 213.674 125.108 213.016 125.373C211.303 126.074 209.554 127.722 208.368 129.389C208.763 131.113 208.895 132.59 208.839 133.67Z\" fill=#ED975D /><path d=\"M206.86 130.675C206.86 130.675 216.099 129.16 215.082 123.383C214.066 117.606 214.574 113.515 208.629 114.234C202.683 114.954 201.93 117.36 201.798 119.386C201.667 121.394 204.433 130.922 206.86 130.675Z\" fill=#FFB27D /><path d=\"M206.026 136.057C206.026 136.057 190.428 131.341 189.318 130.015C188.208 128.708 185.517 111.244 185.517 108.744L183.24 109.066C183.24 109.066 181.566 128.916 183.504 133.405C185.461 137.913 205.123 144.997 205.123 144.997L206.026 136.057Z\" fill=#FFB27D /><path d=\"M218.224 131.758C218.224 131.758 216.305 137.762 208.816 133.993L216.7 151.438L218.751 135.849L218.224 131.758Z\" fill=#F99746 /><path d=\"M224.598 133.519C224.598 133.519 223.657 136.644 241.721 146.55L255.042 137.364L256.642 138.708C256.642 138.708 243.866 154.202 241.871 153.88C239.877 153.558 226.16 144.467 226.16 144.467L224.598 133.519Z\" fill=#FFB27D /><path d=\"M175.492 211.044C175.492 211.044 175.981 212.597 177.092 214.851C179.011 218.715 182.793 224.643 189.096 228.185C196.265 232.22 219.465 239.929 235.402 236.197C235.402 236.197 233.897 185.435 230.547 164.562C230.472 164.07 230.397 163.615 230.322 163.161C231.3 166.911 236.286 168.142 238.318 167.441C242.815 165.926 244.377 162.403 244.584 158.69C244.904 152.97 242.044 146.758 241.705 146.568C234.348 142.363 232.975 135.677 229.4 133.29C226.201 131.169 218.58 131.718 218.204 131.756L216.529 148.443L208.777 133.991C208.759 133.991 196.284 132.893 189.284 130.014C189.284 130.014 168.399 159.107 194.27 158.728C194.27 165.433 191.166 171.514 188.155 180.567C185.22 189.545 175.492 211.044 175.492 211.044Z\" fill=#1C468A /><path d=\"M208.871 126.473C208.871 126.473 208.777 127.42 208.175 127.647C207.591 127.874 206.011 128.31 205.86 128.215C205.691 128.121 205.089 127.401 205.089 127.401C205.089 127.401 207.554 126.397 208.871 126.473Z\" fill=white /><path d=\"M185.573 108.743C185.573 108.743 186.533 108.08 186.025 106.243C185.686 105.012 185.912 104.008 185.648 104.046C185.366 104.084 185.159 105.675 184.99 106.072C184.858 106.413 182.769 102.455 182.243 102.758C181.716 103.061 180.681 104.633 183.165 110.031L185.573 108.743Z\" fill=#FFB27D /><path d=\"M255.045 137.381C255.045 137.381 256.456 133.991 256.945 133.29C257.886 131.907 260.539 131.036 260.727 131.661C260.897 132.267 259.015 133.176 258.94 134.578C258.921 134.976 259.711 134.218 260.2 133.915C260.501 133.744 260.671 133.877 260.52 134.104C259.73 135.26 259.316 136.434 258.563 136.87C257.811 137.305 256.663 138.726 256.663 138.726L255.045 137.381Z\" fill=#FFB27D /><path d=\"M218.221 131.758L216.546 148.445L208.832 133.671L206.028 133.69L217.374 154.468L220.291 131.663L218.221 131.758Z\" fill=#AA443E /><path d=\"M203.039 114.464C203.039 114.464 200.33 117.684 208.872 119.256C211.619 119.767 212.993 122.438 212.24 124.692C211.13 128.025 213.933 131.643 218.054 130.336C221.328 129.313 215.984 113.877 213.068 113.63C210.17 113.384 203.039 114.464 203.039 114.464Z\" fill=#132644 /><path d=\"M206.028 115.203C206.028 115.203 203.281 117.192 203.055 118.783C202.83 120.374 202.19 122.647 201.136 121.037C200.083 119.427 199.913 117.267 201.136 115.79C202.359 114.332 205.087 113.669 205.671 114.161C206.254 114.673 206.028 115.203 206.028 115.203Z\" fill=#132644 /><path d=\"M201.199 114.274C201.199 114.274 206.43 109.728 217.569 116.414L217.72 113.649C217.287 112.001 216.779 112.02 215.273 111.225C213.599 110.315 211.002 109.444 207.314 109.463C204.774 109.482 203.288 109.16 202.14 111.433L201.199 114.274Z\" fill=#1C468A /><path d=\"M270.546 146.001C270.546 146.001 271.525 144.921 272.39 143.671C272.785 143.084 273.162 142.478 273.387 141.929C273.519 141.607 273.613 141.304 273.632 141.039C273.632 141.039 259.727 132.553 258.466 131.435C257.206 130.299 245.841 121.34 245.841 121.34C245.841 121.34 245.088 122.079 244.242 123.177C243.922 123.575 243.602 124.029 243.301 124.522C242.736 125.412 242.266 126.397 242.097 127.325C242.097 127.325 256.66 134.58 257.958 135.887C259.276 137.212 270.546 146.001 270.546 146.001Z\" fill=#EFCBAB /><path d=\"M272.391 143.671C272.786 143.084 273.162 142.478 273.388 141.929C273.52 141.607 273.614 141.304 273.633 141.039C273.633 141.039 259.728 132.553 258.467 131.435C257.207 130.299 245.842 121.34 245.842 121.34C245.842 121.34 245.089 122.079 244.243 123.177C243.923 123.575 243.603 124.029 243.302 124.522C247.404 126.587 258.486 132.212 259.672 133.424C260.838 134.599 269.023 141.02 272.391 143.671Z\" fill=#DDB08E /><path d=\"M256.249 129.618C256.249 129.618 260.106 131.437 261.103 133.255L258.921 136.759C258.921 136.759 255.383 135.073 253.878 133.425L256.249 129.618Z\" fill=#C94C43 /><path d=\"M258.54 136.871C258.54 136.871 259.519 136.474 260.102 135.735C260.685 134.996 261.476 133.803 260.497 134.106C259.519 134.409 257.769 135.64 257.11 135.754C256.452 135.867 256.696 136.379 256.64 136.53C256.583 136.701 258.54 136.871 258.54 136.871Z\" fill=#FFB27D /><path d=\"M175.492 211.044C175.492 211.044 175.981 212.597 177.092 214.851C181.287 210.4 187.12 203.297 191.185 194.754C198.203 180.018 194.289 158.729 194.289 158.729C194.289 165.434 191.185 171.514 188.174 180.568C185.22 189.546 175.492 211.044 175.492 211.044Z\" fill=#233862 /><path d=\"M218.743 160.49C218.743 160.111 218.423 159.789 218.047 159.789C217.67 159.789 217.351 160.111 217.351 160.49C217.351 160.869 217.67 161.191 218.047 161.191C218.423 161.191 218.743 160.888 218.743 160.49Z\" fill=#233862 /><path d=\"M218.743 173.258C218.743 172.88 218.423 172.558 218.047 172.558C217.67 172.558 217.351 172.88 217.351 173.258C217.351 173.637 217.67 173.959 218.047 173.959C218.423 173.959 218.743 173.656 218.743 173.258Z\" fill=#233862 /><path d=\"M230.567 164.562C230.492 164.069 230.416 163.615 230.341 163.16C231.32 166.911 236.306 168.142 238.338 167.441C242.835 165.926 244.397 162.403 244.604 158.69C244.114 158.936 236.833 162.687 233.446 160.49C229.984 158.254 227.857 153.159 227.782 153.008L230.567 164.562Z\" fill=#233862 /></g></svg> <svg class=welcome-mobile-image width=372 height=355 viewBox=\"0 0 372 280\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M304.467 25.5273C303.326 25.5273 302.211 25.1871 301.263 24.5495C300.315 23.9119 299.576 23.0057 299.139 21.9455C298.703 20.8853 298.588 19.7186 298.811 18.5931C299.033 17.4676 299.583 16.4337 300.389 15.6223C301.196 14.8108 302.223 14.2582 303.342 14.0343C304.46 13.8105 305.62 13.9254 306.674 14.3645C307.727 14.8037 308.628 15.5474 309.262 16.5016C309.895 17.4557 310.234 18.5775 310.234 19.7251C310.232 21.2634 309.624 22.7383 308.543 23.8261C307.461 24.9138 305.996 25.5257 304.467 25.5273ZM304.467 15.8578C303.707 15.8578 302.963 16.0846 302.331 16.5095C301.699 16.9345 301.207 17.5385 300.916 18.2451C300.625 18.9518 300.549 19.7294 300.697 20.4796C300.845 21.2298 301.211 21.9188 301.749 22.4597C302.287 23.0006 302.972 23.3689 303.717 23.5181C304.463 23.6673 305.235 23.5907 305.938 23.298C306.64 23.0053 307.24 22.5097 307.663 21.8737C308.085 21.2377 308.31 20.49 308.31 19.7251C308.309 18.6994 307.904 17.7159 307.184 16.9902C306.463 16.2644 305.486 15.8554 304.467 15.8528V15.8578Z\" fill=#898A8D /><path d=\"M22.3614 107.678C21.2209 107.678 20.1059 107.337 19.1576 106.7C18.2093 106.062 17.4701 105.156 17.0337 104.096C16.5972 103.036 16.483 101.869 16.7055 100.744C16.928 99.618 17.4773 98.5841 18.2837 97.7727C19.0902 96.9612 20.1178 96.4086 21.2364 96.1847C22.355 95.9609 23.5145 96.0757 24.5682 96.5149C25.6219 96.9541 26.5226 97.6977 27.1562 98.6519C27.7899 99.6061 28.128 100.728 28.128 101.876C28.1264 103.414 27.5183 104.889 26.4372 105.977C25.3561 107.064 23.8903 107.676 22.3614 107.678ZM22.3614 98.0081C21.6012 98.0081 20.8581 98.235 20.226 98.6599C19.5939 99.0849 19.1013 99.6888 18.8103 100.396C18.5194 101.102 18.4433 101.88 18.5916 102.63C18.7399 103.38 19.106 104.069 19.6435 104.61C20.1811 105.151 20.8659 105.519 21.6115 105.669C22.3571 105.818 23.13 105.741 23.8323 105.448C24.5346 105.156 25.1349 104.66 25.5572 104.024C25.9796 103.388 26.205 102.64 26.205 101.876C26.2011 100.852 25.7947 99.8707 25.0746 99.147C24.3545 98.4234 23.3791 98.0158 22.3614 98.0132V98.0081Z\" fill=#898A8D /><g opacity=0.5><g opacity=0.5><path opacity=0.5 d=\"M172.837 4.52563C173.208 4.16128 173.463 3.69443 173.57 3.18407C173.678 2.67372 173.632 2.14279 173.44 1.65842C173.247 1.17405 172.916 0.757979 172.489 0.462823C172.061 0.167667 171.556 0.00667305 171.038 0.000203005C170.52 -0.00626704 170.011 0.142051 169.576 0.426447C169.142 0.710843 168.8 1.11854 168.596 1.59796C168.392 2.07738 168.333 2.60699 168.428 3.11987C168.523 3.63275 168.766 4.10587 169.128 4.47937C169.369 4.72746 169.656 4.92544 169.972 5.06204C170.289 5.19863 170.629 5.27115 170.973 5.27544C171.317 5.27974 171.659 5.21577 171.979 5.08711C172.299 4.95846 172.59 4.76764 172.837 4.52563Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M155.125 5.06239C155.376 4.81588 155.549 4.49997 155.622 4.15462C155.694 3.80928 155.664 3.45005 155.533 3.12227C155.403 2.79449 155.179 2.51295 154.89 2.31321C154.601 2.11347 154.259 2.00451 153.908 2.00014C153.557 1.99576 153.213 2.09616 152.919 2.28863C152.625 2.48109 152.394 2.757 152.256 3.08143C152.118 3.40586 152.078 3.76421 152.142 4.11126C152.206 4.45831 152.371 4.77848 152.616 5.03117C152.779 5.19896 152.973 5.33286 153.187 5.42524C153.401 5.51762 153.631 5.56662 153.864 5.56952C154.097 5.57243 154.328 5.52913 154.545 5.44211C154.761 5.3551 154.958 5.22608 155.125 5.06239Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M156.213 21.1904C156.546 20.8592 156.774 20.436 156.869 19.9743C156.963 19.5127 156.92 19.0332 156.744 18.5964C156.568 18.1596 156.267 17.785 155.88 17.5199C155.493 17.2547 155.036 17.1109 154.568 17.1065C154.099 17.1022 153.64 17.2375 153.248 17.4954C152.856 17.7533 152.548 18.1222 152.364 18.5557C152.18 18.9892 152.128 19.4677 152.214 19.9311C152.3 20.3944 152.521 20.8217 152.848 21.1591C153.29 21.612 153.893 21.8697 154.524 21.8756C155.155 21.8815 155.762 21.635 156.213 21.1904Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M153.985 20.0924C153.94 19.9998 153.804 19.7171 153.476 3.40723L153.469 3.06454L170.623 2.04395L170.666 2.75689L154.19 3.73618C154.314 10.045 154.539 19.3019 154.643 19.8435C154.638 19.8219 154.631 19.8008 154.621 19.7809L153.985 20.0924Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M97.3167 355C97.2719 354.907 97.1364 354.624 96.8083 338.314L96.8008 337.972L113.955 336.951L113.998 337.664L97.5218 338.643C97.6461 344.952 97.8711 354.209 97.9755 354.751C97.9704 354.729 97.9629 354.708 97.9531 354.688L97.3167 355Z\" fill=#4375C4 /></g></g><path d=\"M49.3753 29.2402L47.7822 35.9629L48.8273 36.2136L50.4203 29.4909L49.3753 29.2402Z\" fill=#76C99F /><path d=\"M45.8869 31.4016L45.6377 32.4531L52.3191 34.0561L52.5683 33.0046L45.8869 31.4016Z\" fill=#76C99F /><path d=\"M247.792 69.6183L245.328 80.0352L246.947 80.4229L249.411 70.0061L247.792 69.6183Z\" fill=#76C99F /><path d=\"M242.387 72.9662L242.001 74.5957L252.356 77.0799L252.742 75.4503L242.387 72.9662Z\" fill=#76C99F /><g opacity=0.6><g opacity=0.6><path opacity=0.6 d=\"M367.423 70.1607C366.686 70.1607 365.965 69.9407 365.352 69.5284C364.738 69.1161 364.26 68.53 363.978 67.8444C363.696 67.1587 363.622 66.4043 363.766 65.6765C363.91 64.9486 364.265 64.2801 364.786 63.7553C365.308 63.2305 365.972 62.8732 366.696 62.7284C367.419 62.5836 368.169 62.6578 368.851 62.9418C369.532 63.2258 370.115 63.7068 370.524 64.3239C370.934 64.9409 371.153 65.6663 371.153 66.4084C371.153 67.4036 370.76 68.358 370.06 69.0617C369.361 69.7654 368.412 70.1607 367.423 70.1607ZM367.423 63.9507C366.94 63.9507 366.467 64.0951 366.065 64.3654C365.663 64.6357 365.35 65.0199 365.164 65.4694C364.979 65.919 364.931 66.4136 365.025 66.8909C365.12 67.3681 365.352 67.8066 365.694 68.1506C366.036 68.4947 366.472 68.729 366.947 68.824C367.421 68.9189 367.912 68.8702 368.359 68.684C368.806 68.4977 369.188 68.1824 369.456 67.7778C369.725 67.3732 369.869 66.8976 369.869 66.411C369.868 65.7588 369.61 65.1336 369.151 64.6724C368.693 64.2113 368.072 63.9517 367.423 63.9507Z\" fill=#828282 /></g></g><path d=\"M186.923 299.823C185.782 299.823 184.667 299.483 183.719 298.845C182.771 298.208 182.032 297.302 181.595 296.241C181.159 295.181 181.044 294.015 181.267 292.889C181.49 291.764 182.039 290.73 182.845 289.918C183.652 289.107 184.679 288.554 185.798 288.33C186.916 288.106 188.076 288.221 189.13 288.66C190.183 289.1 191.084 289.843 191.718 290.797C192.351 291.752 192.69 292.873 192.69 294.021C192.688 295.559 192.08 297.034 190.999 298.122C189.918 299.21 188.452 299.822 186.923 299.823ZM186.923 290.154C186.163 290.154 185.42 290.38 184.787 290.805C184.155 291.23 183.663 291.834 183.372 292.541C183.081 293.248 183.005 294.025 183.153 294.776C183.301 295.526 183.668 296.215 184.205 296.756C184.743 297.296 185.428 297.665 186.173 297.814C186.919 297.963 187.691 297.887 188.394 297.594C189.096 297.301 189.696 296.806 190.119 296.17C190.541 295.534 190.766 294.786 190.766 294.021C190.765 292.995 190.36 292.012 189.64 291.286C188.919 290.56 187.942 290.151 186.923 290.149V290.154Z\" fill=#898A8D /><path d=\"M316.912 277.544C315.772 277.544 314.657 277.204 313.708 276.566C312.76 275.929 312.021 275.022 311.584 273.962C311.148 272.902 311.034 271.735 311.256 270.61C311.479 269.484 312.028 268.45 312.835 267.639C313.641 266.827 314.669 266.275 315.787 266.051C316.906 265.827 318.065 265.942 319.119 266.381C320.173 266.82 321.073 267.564 321.707 268.518C322.341 269.472 322.679 270.594 322.679 271.742C322.677 273.28 322.069 274.755 320.988 275.843C319.907 276.93 318.441 277.542 316.912 277.544ZM316.912 267.874C316.152 267.874 315.409 268.101 314.777 268.526C314.145 268.951 313.652 269.555 313.361 270.262C313.07 270.968 312.994 271.746 313.142 272.496C313.291 273.246 313.657 273.935 314.194 274.476C314.732 275.017 315.417 275.386 316.162 275.535C316.908 275.684 317.681 275.607 318.383 275.315C319.085 275.022 319.686 274.526 320.108 273.89C320.53 273.254 320.756 272.507 320.756 271.742C320.752 270.718 320.345 269.737 319.625 269.013C318.905 268.29 317.93 267.882 316.912 267.879V267.874Z\" fill=#89D1AD /><g opacity=0.5><g opacity=0.5><path opacity=0.5 d=\"M103.695 264.896C104.066 264.531 104.321 264.065 104.429 263.554C104.536 263.044 104.491 262.513 104.298 262.029C104.106 261.544 103.775 261.128 103.347 260.833C102.92 260.538 102.415 260.377 101.896 260.37C101.378 260.364 100.869 260.512 100.435 260.797C99.9999 261.081 99.6589 261.489 99.4545 261.968C99.2501 262.447 99.1916 262.977 99.2863 263.49C99.3811 264.003 99.6248 264.476 99.9868 264.849C100.227 265.098 100.514 265.296 100.83 265.432C101.147 265.569 101.487 265.641 101.831 265.646C102.176 265.65 102.518 265.586 102.837 265.457C103.157 265.329 103.448 265.138 103.695 264.896Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M85.9843 265.433C86.2354 265.186 86.4083 264.87 86.481 264.525C86.5537 264.179 86.5229 263.82 86.3927 263.492C86.2625 263.165 86.0385 262.883 85.7493 262.683C85.46 262.484 85.1184 262.375 84.7676 262.37C84.4168 262.366 84.0725 262.466 83.7784 262.659C83.4843 262.851 83.2535 263.127 83.1153 263.452C82.977 263.776 82.9374 264.134 83.0016 264.481C83.0658 264.828 83.2308 265.149 83.4758 265.401C83.6384 265.569 83.8324 265.703 84.0465 265.795C84.2606 265.888 84.4907 265.937 84.7236 265.94C84.9565 265.943 85.1878 265.899 85.4041 265.812C85.6204 265.725 85.8176 265.596 85.9843 265.433Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M87.0701 281.561C87.4034 281.229 87.6316 280.806 87.7261 280.344C87.8206 279.883 87.7771 279.403 87.6011 278.967C87.4252 278.53 87.1246 278.155 86.7373 277.89C86.35 277.625 85.8934 277.481 85.4249 277.477C84.9565 277.472 84.4973 277.608 84.1052 277.866C83.7131 278.123 83.4057 278.492 83.2218 278.926C83.0378 279.359 82.9856 279.838 83.0716 280.301C83.1576 280.765 83.378 281.192 83.7051 281.529C84.1474 281.982 84.7502 282.24 85.3812 282.246C86.0122 282.252 86.6197 282.005 87.0701 281.561Z\" fill=#4375C4 /></g><g opacity=0.5><path opacity=0.5 d=\"M84.843 280.464C84.7983 280.371 84.6628 280.088 84.3346 263.778L84.3271 263.436L101.482 262.415L101.524 263.128L85.0482 264.107C85.1725 270.416 85.3975 279.673 85.5019 280.215C85.4968 280.193 85.4893 280.172 85.4795 280.152L84.843 280.464Z\" fill=#4375C4 /></g></g><path d=\"M3.73763 183.79L2.14453 190.513L3.18956 190.763L4.78266 184.041L3.73763 183.79Z\" fill=#76C99F /><path d=\"M0.249174 185.951L0 187.003L6.68139 188.606L6.93056 187.554L0.249174 185.951Z\" fill=#76C99F /><path d=\"M215.987 307.712L213.523 318.129L215.143 318.517L217.606 308.1L215.987 307.712Z\" fill=#76C99F /><path d=\"M210.582 311.06L210.196 312.689L220.551 315.174L220.937 313.544L210.582 311.06Z\" fill=#76C99F /><g opacity=0.6><g opacity=0.6><path opacity=0.6 d=\"M337.004 72.9449C336.267 72.9449 335.546 72.725 334.933 72.3127C334.32 71.9003 333.841 71.3142 333.559 70.6286C333.277 69.9429 333.203 69.1885 333.347 68.4607C333.491 67.7328 333.846 67.0642 334.367 66.5395C334.889 66.0147 335.554 65.6573 336.277 65.5126C337 65.3678 337.75 65.442 338.432 65.726C339.113 66.01 339.696 66.491 340.105 67.1081C340.515 67.7251 340.734 68.4505 340.734 69.1926C340.734 70.1878 340.341 71.1422 339.641 71.8459C338.942 72.5496 337.993 72.9449 337.004 72.9449ZM337.004 66.7349C336.521 66.7349 336.048 66.8793 335.646 67.1496C335.244 67.4199 334.931 67.8041 334.746 68.2536C334.56 68.7032 334.512 69.1978 334.606 69.6751C334.701 70.1523 334.933 70.5908 335.275 70.9349C335.617 71.2789 336.053 71.5133 336.528 71.6082C337.002 71.7031 337.494 71.6544 337.94 71.4682C338.387 71.282 338.769 70.9666 339.037 70.562C339.306 70.1574 339.45 69.6818 339.45 69.1952C339.449 68.543 339.191 67.9178 338.732 67.4566C338.274 66.9955 337.653 66.7359 337.004 66.7349Z\" fill=#828282 /></g></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1s><path d=\"M151.479 189.195C151.479 189.195 153.286 193.135 153.192 194.215C153.097 195.294 151.479 198.704 151.479 198.704L149.522 189.65L151.479 189.195Z\" fill=#FFB27D /><path d=\"M150.047 172.243L151.477 189.195L149.52 189.65L144.364 174.289L150.047 172.243Z\" fill=#FFB27D /><path d=\"M107.978 117.826L127.414 106.271L140.774 115.704L122.278 126.557L107.978 117.826Z\" fill=#233862 /><path d=\"M117.966 123.147C117.966 123.147 117.476 125.988 114.748 127.466C112.039 128.924 109.705 129.36 110.289 134.076C110.872 138.793 107.673 139.872 107.09 142.998C106.507 146.123 106.582 151.843 114.372 150.138C122.161 148.434 139.999 149.646 141.937 147.108C143.875 144.57 142.52 139.285 139.209 135.288C135.916 131.273 140.281 128.659 138.719 125.136C137.158 121.613 134.185 117.976 134.185 117.976C134.185 117.976 121.371 115.514 117.966 123.147Z\" fill=#132644 /><path d=\"M121.654 253.102L124.27 264.258L128.221 264.239L128.353 253.102H121.654Z\" fill=#FFB27D /><path d=\"M154.768 253.576L162.256 264.258L165.173 260.489L160.657 252.117L154.768 253.576Z\" fill=#FFB27D /><path d=\"M131.99 140.78C132.008 140.799 131.5 153.186 129.393 153.205C128.941 153.205 125.686 144.53 125.272 144.417C123.015 143.792 122.695 138.242 122.732 138.223C123.692 138.034 123.955 136.708 123.936 131.025L124.369 131.12L131.632 132.56C131.632 132.56 131.463 134.87 131.463 137.03C131.482 138.848 131.576 140.591 131.99 140.78Z\" fill=#FFB27D /><path d=\"M102.632 128.338L102.388 127.846C107.675 125.308 107.957 119.322 107.957 117.94C107.957 117.769 108.051 117.599 108.221 117.523C108.39 117.447 108.559 117.58 108.559 117.75C108.559 119.36 108.145 125.705 102.632 128.338Z\" fill=#EFCBAB /><path d=\"M102.405 127.846L101.652 127.959L102.085 128.812L102.631 128.338L102.405 127.846Z\" fill=#D8A987 /><path d=\"M101.652 127.958C101.652 127.958 100.674 128.413 100.41 128.147C100.41 128.147 100.523 129.019 100.918 129.189C100.918 129.189 101.746 129.094 102.066 128.81L101.652 127.958Z\" fill=#EFCBAB /><path d=\"M131.64 132.561C131.64 132.561 131.471 134.872 131.471 137.031C127.406 136.917 125.261 133.186 124.377 131.103L131.64 132.561Z\" fill=#EF9E67 /><path d=\"M122.875 131.369C122.875 131.369 120.128 128.471 119.056 125.724C118.284 123.773 117.814 116.045 125.528 115.61C125.528 115.61 127.749 115.382 130.082 116.367C131.926 117.144 134.767 119.057 133.45 126.16L133.205 128.508L122.875 131.369Z\" fill=#132644 /><path d=\"M164.46 258.046C164.46 258.046 162.522 258.387 160.942 258.501C160.584 258.52 160.264 258.539 159.963 258.539C159.192 258.539 157.818 258.255 156.896 258.027L156.821 258.008C156.407 257.914 156.106 257.838 155.993 257.8L155.937 257.781C155.937 257.781 146.303 246.985 140.903 229.692C140.771 229.294 140.639 228.877 140.508 228.479C137.554 219.804 131.42 208.913 128.183 199.045C127.675 197.473 127.205 195.995 126.791 194.594C126.659 194.139 126.528 193.704 126.415 193.268C124.025 184.934 123.348 179.479 122.708 173.626L142.126 178.607C142.145 178.626 150.311 214.217 164.46 258.046Z\" fill=#A53D38 /><path d=\"M132.902 133.717C132.902 133.717 123.494 135.782 122.309 129.872C121.123 123.963 119.11 120.25 125.056 118.678C131.002 117.106 132.639 119.133 133.504 121.008C134.389 122.883 135.329 133.035 132.902 133.717Z\" fill=#FFB27D /><path d=\"M129.336 117.655C129.336 117.655 128.151 125.118 124.387 126.955C120.624 128.793 118.705 128.073 118.705 128.073C118.705 128.073 121.264 125.023 121.038 120.648C121.038 120.648 126.739 114.757 129.336 117.655Z\" fill=#132644 /><path d=\"M128.807 118.357C128.807 118.357 131.046 119.513 131.817 120.933C132.589 122.335 134.188 122.846 134.301 125.119C134.301 125.119 135.298 120.005 132.589 117.789C129.691 115.421 128.807 118.357 128.807 118.357Z\" fill=#132644 /><path d=\"M124.135 263.635C124.135 263.635 124.455 265.851 123.627 268.2C123.627 268.2 122.987 271.154 125.866 271.211C128.764 271.268 129.46 270.984 129.14 269.185C128.82 267.366 128.18 264.241 128.18 264.241L124.135 263.635Z\" fill=#FFB27D /><path d=\"M123.645 268.198C123.645 268.198 123.118 270.982 123.438 272.479C123.438 272.479 124.304 273.141 126.411 273.141C128.405 273.141 129.44 272.479 129.44 272.479C129.44 272.479 129.497 269.41 128.97 268.122C128.97 268.122 126.919 271.228 123.645 268.198Z\" fill=#C45446 /><path d=\"M172.139 269.486C172.139 269.486 166.814 263.52 165.177 260.489L161.207 262.535L170.069 270.907L172.139 270.623V269.486Z\" fill=#FFB27D /><path d=\"M175.523 272.971C175.523 272.971 169.785 272.971 168.806 272.857C167.828 272.743 167.038 271.323 165.965 269.183C165.532 268.311 164.554 267.819 163.557 267.554V272.516H162.051L160.621 267.251C159.681 265.508 160.546 263.917 161.205 262.534C161.976 262.534 164.065 263.065 167.997 267.535C169.295 268.993 170.725 269.523 172.137 269.486C172.155 269.505 172.174 269.505 172.193 269.523C175.467 271.001 175.523 272.971 175.523 272.971Z\" fill=#C45446 /><path d=\"M160.941 258.501C160.584 258.52 160.264 258.539 159.963 258.539C159.191 258.539 157.818 258.254 156.896 258.027L156.82 258.008L155.993 257.8L155.936 257.781C155.936 257.781 146.302 246.985 140.902 229.691C140.771 229.294 140.639 228.877 140.507 228.479C137.553 219.804 131.419 208.913 128.183 199.045C127.675 197.473 127.204 195.995 126.79 194.593C126.659 194.139 126.527 193.703 126.414 193.268L129.857 190.635C129.857 190.635 140.168 207.436 143.367 223.27C146.02 236.396 157.423 253.406 160.941 258.501Z\" fill=#912F2F /><path d=\"M130.233 224.766C130.289 232.456 129.913 250.147 128.916 257.477C128.916 257.477 127.975 258.311 125.623 258.33C123.234 258.349 122.161 257.458 122.161 257.458C119.659 244.73 117.89 234.199 116.592 225.107C115.538 217.663 114.597 211.28 113.863 205.768C113.223 200.9 117.288 187.698 117.288 187.698L132.529 186.202C132.265 199.688 130.195 220.296 130.233 224.766Z\" fill=#A53D38 /><path d=\"M125.623 258.311C123.591 258.425 122.161 257.44 122.161 257.44C119.659 244.711 117.89 234.18 116.592 225.088C115.538 217.644 114.597 211.261 113.863 205.749C113.223 200.882 117.288 187.68 117.288 187.68L122.462 191.013C122.462 191.013 115.124 197.718 116.93 210.409C118.718 223.118 123.121 256.531 125.623 258.311Z\" fill=#912F2F /><path d=\"M149.633 177.073C148.673 177.395 147.601 177.585 146.547 177.736C144.854 177.982 143.217 178.153 142.144 178.626C139.021 180.047 131.476 138.055 131.476 138.055C131.476 138.055 136.97 138.112 139.491 142.108C142.012 146.105 151.834 165.898 152.719 172.224C153.114 175.103 151.646 176.391 149.633 177.073Z\" fill=#1C468A /><path d=\"M160.939 233.707C160.939 233.707 160.431 234.976 159.038 236.756C158.342 237.647 157.439 238.651 156.273 239.711C153.187 242.458 148.257 245.45 140.655 246.928C140.26 247.004 139.846 247.079 139.414 247.155C137.118 247.534 134.917 247.818 132.828 247.988C128.557 248.367 124.737 248.386 121.463 248.235C119.224 248.14 117.267 247.951 115.611 247.742C111.886 247.269 109.76 246.7 109.76 246.7C109.76 246.7 109.76 208.761 112.864 186.222C114.577 173.739 120.353 138.263 120.353 138.263L123.213 137.827L130.081 153.245L131.436 138.092L134.559 139.096C136.102 139.589 137.269 140.858 137.664 142.43L160.939 233.707Z\" fill=#1C468A /><path d=\"M138.795 175.426L122.839 173.797L125.417 150.519L141.372 152.147L138.795 175.426Z\" fill=#BC3F3F /><path d=\"M125.416 150.517L124.4 150.441L121.991 173.682L122.838 173.796L125.416 150.517Z\" fill=#9B2323 /><path d=\"M112.041 162.509C112.041 162.509 123.236 165.956 133.943 167.49C133.943 167.49 137.48 169.025 135.824 169.441C135.391 169.555 113.96 174.252 110.78 171.203L112.041 162.509Z\" fill=#FFB27D /><path d=\"M123.233 137.791C123.233 137.791 114.86 138.814 113.449 140.519C108.989 145.898 104.944 168.892 108.444 174.215C112.621 180.56 119.056 170.597 121.069 164.744C122.104 161.695 123.816 143.322 123.233 137.791Z\" fill=#1C468A /><path d=\"M132.886 167.337C132.886 167.337 134.203 167.204 134.448 166.787C134.956 165.935 135.727 165.954 136.386 165.84C137.045 165.727 137.778 165.007 137.91 165.158C138.042 165.31 137.421 166.106 137.082 166.409C137.082 166.409 137.797 166.446 138.249 166.219C138.719 165.992 140.356 164.117 140.356 164.912C140.375 166.863 140.224 167.185 138.569 168.568C137.195 169.704 132.566 170.121 132.566 170.121L132.886 167.337Z\" fill=#FFB27D /><path d=\"M123.213 161.996L122.893 165.292C122.366 165.178 121.764 164.989 121.068 164.705C116.477 162.849 118.283 153.662 118.283 153.662C118.998 157.356 121.293 160.197 123.213 161.996Z\" fill=#233862 /><path d=\"M134.203 117.977C134.203 117.977 127.41 115.382 117.965 123.166L118.153 121.386C118.322 119.795 119.131 118.355 120.411 117.389C121.841 116.31 124.136 115.135 127.58 114.643C129.951 114.302 132.303 115.325 133.695 117.276L134.203 117.977Z\" fill=#1C468A /><path d=\"M149.638 177.075C148.679 177.396 147.606 177.586 146.552 177.737L142.149 158.152C142.149 158.152 149.563 173.211 149.638 177.075Z\" fill=#233862 /><path d=\"M129.558 130.479C129.558 130.479 129.99 131.312 130.63 131.331C131.27 131.331 132.888 131.179 133.001 131.028C133.114 130.876 133.434 129.986 133.434 129.986C133.434 129.986 130.743 129.929 129.558 130.479Z\" fill=white /></g><path class=\"wow slideInRight\" data-wow-delay=1s d=\"M333.443 276.549H25.2413C25.0463 276.549 24.8945 276.224 24.8945 275.854V275.616C24.8945 275.225 25.0571 274.921 25.2413 274.921H333.443C333.638 274.921 333.79 275.247 333.79 275.616V275.854C333.79 276.245 333.638 276.549 333.443 276.549Z\" fill=#2E3552 /><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1.3s><path d=\"M32.0934 173.026L30.2871 192.782L32.959 193.199L40.5041 175.621L32.0934 173.026Z\" fill=#FFB27D /><path d=\"M33.3018 191.172C33.3018 191.172 32.6809 193.236 33.0761 194.771C33.3395 195.793 31.7401 197.214 29.9903 199.165C29.8209 199.354 29.4822 199.165 29.5199 198.9C29.5387 198.767 29.5763 198.597 29.6704 198.407C29.9903 197.669 30.8934 196.381 30.8934 196.381C30.8182 196.097 28.9554 197.1 27.9017 197.801C27.2808 198.218 25.5121 200.131 25.0417 199.847C24.5713 199.563 25.3239 197.707 26.1518 196.343C26.9797 194.979 29.915 193.824 30.2913 192.782C30.6676 191.74 33.3018 191.172 33.3018 191.172Z\" fill=#FFB27D /><path d=\"M41.9229 101.391L61.4725 93L79.4792 101.656L61.4725 110.861L41.9229 101.391Z\" fill=#233862 /><path d=\"M45.0822 111.034L45.3644 110.655C41.4319 107.681 42.2034 102.7 42.4292 101.563C42.4668 101.412 42.3915 101.26 42.2786 101.184C42.1657 101.09 41.9964 101.165 41.9588 101.317C41.7142 102.643 40.9803 107.927 45.0822 111.034Z\" fill=#EFCBAB /><path d=\"M45.3672 110.653L45.9505 110.881L45.4613 111.506L45.085 111.032L45.3672 110.653Z\" fill=#D8A987 /><path d=\"M45.9494 110.882C45.9494 110.882 46.6832 111.412 46.9278 111.261C46.9278 111.261 46.6832 111.961 46.3257 112.037C46.3257 112.037 45.6672 111.81 45.4414 111.526L45.9494 110.882Z\" fill=#EFCBAB /><path d=\"M54.5383 251.291L53.2212 256.898L51.4525 264.341H45.9583L45.6384 257.22L45.375 251.708L54.5383 251.291Z\" fill=#FFB27D /><path d=\"M43.7979 272.521C43.7979 272.521 43.7979 269.813 44.1742 268.904C44.5505 267.995 45.9617 264.339 45.9617 264.339H51.4559C51.4559 264.339 52.472 267.691 52.5472 268.771C52.6037 269.87 52.5472 272.503 52.5472 272.503H43.7979V272.521Z\" fill=#233862 /><path d=\"M78.6895 272.521C78.6895 272.521 78.6895 269.813 78.3132 268.904C77.9369 267.995 76.5257 264.339 76.5257 264.339H71.0315C71.0315 264.339 70.0154 267.691 69.9401 268.771C69.8837 269.87 69.9401 272.503 69.9401 272.503H78.6895V272.521Z\" fill=#233862 /><path d=\"M56.6738 120.504C56.6738 120.504 56.4857 126.527 55.7142 129.235L49.6367 142.4L63.0712 161.113L72.4791 136.926L67.0225 129.349C67.0225 129.349 65.3856 121.261 66.2323 118.269C67.1355 115.276 56.6738 120.504 56.6738 120.504Z\" fill=#FFB27D /><path d=\"M56.6377 121.316C56.6377 121.316 58.444 125.692 61.8497 125.597C65.2553 125.502 66.0268 121.619 66.0268 121.619L56.6377 121.316Z\" fill=#ED985F /><path d=\"M54.6091 117.776C54.6091 117.776 53.5178 112.246 52.7464 110.579C51.9749 108.912 51.3352 101.449 59.8399 101.051C59.8399 101.051 63.0951 101.43 64.8826 100.351C64.8826 100.351 64.8826 101.449 64.431 101.828C64.431 101.828 66.6513 100.426 68.9468 103.002C71.2423 105.578 68.1377 115.276 68.3259 117.398L54.6091 117.776Z\" fill=#132644 /><path d=\"M61.4761 123.913C59.0112 123.875 54.4766 120.56 54.4766 116.469V110.086C54.4766 108.589 55.5114 107.377 56.7721 107.377H66.18C67.4407 107.377 68.4755 108.608 68.4755 110.086V116.109C68.4755 120.408 64.2984 123.969 61.4761 123.913Z\" fill=#FFB27D /><path d=\"M54.451 113.495C54.451 113.495 54.4698 109.65 57.4804 109.063C60.4909 108.476 67.2646 110.938 68.2242 108.135C69.1838 105.332 55.166 105.389 54.451 107.169C53.7548 108.968 54.451 113.495 54.451 113.495Z\" fill=#132644 /><path d=\"M55.7164 129.235L61.3423 130.504L67.0247 129.121L68.4735 137.891L62.0949 159.73L55.1143 133.553L55.7164 129.235Z\" fill=white /><path d=\"M55.4492 131.015L59.9086 134.387L61.3762 131.962L62.7121 134.387L67.4725 130.201L66.5317 129.121L61.3386 130.504L55.7126 130.239L55.4492 131.015Z\" fill=#D2E3FC /><path d=\"M78.8116 178.67L65.4336 179.503C65.3583 179.371 65.2642 179.371 65.1701 179.522L61.2376 179.769L44.4727 178.708C44.4727 178.708 40.258 198.085 41.9138 223.92C42.4406 232.16 43.626 256.556 44.755 265.193L56.2514 265.307C57.7379 255.552 59.469 231.194 60.3909 227.008C60.8049 225.114 61.2 223.219 61.5575 221.363C61.8962 223.485 62.1032 225.208 62.1032 226.288C62.1032 228.012 62.5924 230.739 63.2886 234.035C64.2482 238.675 67.1082 260.041 67.9549 265.629H80.0159C80.1664 257.938 80.8249 231.819 80.9566 223.92C81.3141 202.858 78.8116 178.67 78.8116 178.67Z\" fill=#EE9849 /><path d=\"M88.056 246.764C81.9033 250.003 40.038 253.848 32.5305 244.946C31.2511 243.43 49.0885 130.504 49.0885 130.504C49.0885 130.504 50.2362 130.163 52.1742 129.803C53.1715 129.614 54.3569 129.424 55.7116 129.254C55.7304 129.67 58.6093 148.005 62.5606 155.165C62.5606 155.165 67.0199 145.297 67.0387 129.348C67.0387 129.273 67.0199 129.197 67.0199 129.121C67.8666 129.216 68.7134 129.329 69.5789 129.481C69.9364 129.538 70.3127 129.614 70.6702 129.689C72.0438 129.973 73.4361 130.333 74.8097 130.788C74.8097 130.788 89.3355 246.082 88.056 246.764Z\" fill=#1C468A /><path d=\"M53.9436 129.464C53.9436 129.464 47.5274 179.014 45.0814 182.726C44.0465 184.279 42.5412 184.526 40.7725 184.185C40.4339 184.128 40.0764 184.033 39.7377 183.919L34.8267 182.025H34.8079C34.0177 181.703 33.2086 181.4 32.3995 181.154C27.3569 179.582 27.752 175.301 29.1067 169.467C30.4615 163.634 39.3614 135.563 42.3719 133.574C47.678 130.07 53.9436 129.464 53.9436 129.464Z\" fill=#1C468A /><path d=\"M67.0222 129.12C62.8074 128.665 58.8373 128.874 55.7139 129.252C55.7139 129.234 55.7139 129.234 55.7139 129.234C55.7139 129.234 66.1755 122.718 67.0222 129.12Z\" fill=#FFB27D /><path d=\"M63.3277 159.748C56.8551 154.956 52.1699 129.803 52.1699 129.803C53.1672 129.613 54.3526 129.424 55.7073 129.253C55.7261 129.67 58.4544 147.001 62.3869 154.161C62.3869 154.161 67.0156 145.296 67.0344 129.367C67.0344 129.291 67.0156 129.215 67.0156 129.14C67.8623 129.234 68.709 129.348 69.5746 129.5C69.9321 129.556 70.3084 129.632 70.6659 129.708C70.6659 143.099 63.3277 159.748 63.3277 159.748Z\" fill=#BC3F3F /><path d=\"M59.29 119.177C59.29 119.177 62.2441 118.874 63.6177 119.215C63.6177 119.215 62.8839 120.408 61.6796 120.408C60.4754 120.389 59.5723 119.953 59.29 119.177Z\" fill=#FFF0E6 /><path d=\"M52.1543 104.327L52.3236 107.225C52.3236 107.225 58.9468 102.774 69.8036 106.865L69.653 102.679C69.5025 101.865 68.9945 101.164 68.2795 100.747C66.2474 99.5731 61.4681 97.3759 53.9418 101.05C52.8881 101.543 52.2296 103.134 52.1543 104.327Z\" fill=#1C468A /><path d=\"M56.2052 126.562L53.9473 129.46L59.9307 133.57L61.3419 130.501L56.2052 126.562Z\" fill=white /><path d=\"M66.5489 126.562L61.3369 130.501L62.8422 133.57L67.9789 129.232L66.5489 126.562Z\" fill=white /><path d=\"M61.167 137.285C61.3364 137.115 61.581 137.115 61.7503 137.285C61.9197 137.456 61.9197 137.702 61.7503 137.872C61.581 138.043 61.3364 138.043 61.167 137.872C60.9977 137.702 60.9977 137.437 61.167 137.285Z\" fill=#D2E3FC /><path d=\"M61.454 142.454C61.6826 142.454 61.8679 142.267 61.8679 142.037C61.8679 141.807 61.6826 141.62 61.454 141.62C61.2254 141.62 61.04 141.807 61.04 142.037C61.04 142.267 61.2254 142.454 61.454 142.454Z\" fill=#D2E3FC /><path d=\"M61.167 146.34C61.3364 146.169 61.581 146.169 61.7503 146.34C61.9197 146.51 61.9197 146.756 61.7503 146.927C61.581 147.097 61.3364 147.097 61.167 146.927C60.9977 146.756 60.9977 146.491 61.167 146.34Z\" fill=#D2E3FC /><path d=\"M74.8037 130.787C74.8037 130.787 78.8303 132.473 80.9753 137.435C83.1203 142.398 92.0578 155.96 91.7944 162.305C91.531 168.65 90.3268 174.427 84.3245 174.617C80.2039 174.749 76.0079 170.696 76.0079 164.616C76.0079 158.555 74.8037 130.787 74.8037 130.787Z\" fill=#1C468A /><path d=\"M87.5825 171.057C87.4131 172.761 86.7922 174.144 85.2681 174.542C80.4513 175.754 78.3251 171.076 79.3411 166.492C79.3788 166.34 79.4164 166.189 79.454 166.056C80.4889 162.704 84.1768 162.192 85.5504 162.117C85.8702 162.098 86.0584 162.098 86.0584 162.098C86.0584 162.098 86.0772 162.173 86.1337 162.306C86.4723 163.348 87.9023 167.799 87.5825 171.057Z\" fill=#233862 /><path d=\"M87.584 171.057C87.584 171.057 73.5474 164.693 67.9968 157.4C67.5828 156.87 68.6365 156.207 68.6365 156.207L85.5331 162.117L86.1164 162.325C86.4739 163.348 87.9039 167.799 87.584 171.057Z\" fill=#FFB27D /><path d=\"M71.0824 156.547H52.5488V181.151H71.0824V156.547Z\" fill=#FCECDB /><path d=\"M60.1735 173.882L58.085 177.386L59.4021 177.197L59.9665 178.257L61.7352 175.037L60.1735 173.882Z\" fill=#932424 /><path d=\"M62.926 173.673L65.0145 177.177L63.6974 176.988L63.133 178.048L61.3643 174.809L62.926 173.673Z\" fill=#932424 /><path d=\"M59.4417 173.105C59.6675 171.571 60.4954 170.965 61.756 170.776C63.4118 170.529 64.0704 171.817 64.0704 173.105C64.0704 174.393 63.0355 175.435 61.756 175.435C60.4765 175.435 59.2347 174.393 59.4417 173.105Z\" fill=#BC3F3F /><path d=\"M61.7319 174.959C61.1674 174.959 60.6029 174.694 60.2454 174.277C59.9444 173.936 59.8127 173.501 59.8879 173.084C60.0573 171.985 60.6218 171.417 61.7131 171.247C62.2211 171.171 62.6539 171.266 62.9737 171.55C63.3501 171.872 63.5759 172.44 63.5759 173.103C63.5947 174.126 62.7668 174.959 61.7319 174.959ZM62.0329 171.436C61.9389 171.436 61.8448 171.436 61.7507 171.455C60.7535 171.607 60.2643 172.099 60.0949 173.122C60.0385 173.482 60.1514 173.842 60.4148 174.145C60.7347 174.524 61.2427 174.751 61.7319 174.751C62.6351 174.751 63.3689 174.012 63.3689 173.103C63.3689 172.516 63.1807 172.004 62.842 171.72C62.6351 171.531 62.3716 171.436 62.0329 171.436Z\" fill=#932424 /><path d=\"M64.4066 159.501H59.2511C59.157 159.501 59.1006 159.426 59.1006 159.351C59.1006 159.257 59.1758 159.2 59.2511 159.2H64.4066C64.5007 159.2 64.5572 159.275 64.5572 159.351C64.5572 159.426 64.4819 159.501 64.4066 159.501Z\" fill=#1C468A /><path d=\"M65.4043 160.164H58.2355C58.1414 160.164 58.085 160.089 58.085 160.014C58.085 159.92 58.1602 159.863 58.2355 159.863H65.4043C65.4984 159.863 65.5548 159.939 65.5548 160.014C65.5548 160.089 65.4796 160.164 65.4043 160.164Z\" fill=#1C468A /><path d=\"M67.0847 165.583H56.5102C56.4161 165.583 56.3408 165.508 56.3408 165.413C56.3408 165.319 56.4161 165.244 56.5102 165.244H67.0847C67.1787 165.244 67.254 165.319 67.254 165.413C67.2728 165.508 67.1787 165.583 67.0847 165.583Z\" fill=#1C468A /><path d=\"M67.0847 166.493H56.5102C56.4161 166.493 56.3408 166.418 56.3408 166.324C56.3408 166.23 56.4161 166.154 56.5102 166.154H67.0847C67.1787 166.154 67.254 166.23 67.254 166.324C67.2728 166.399 67.1787 166.493 67.0847 166.493Z\" fill=#1C468A /><path d=\"M67.0847 167.268H56.5102C56.4161 167.268 56.3408 167.193 56.3408 167.099C56.3408 167.005 56.4161 166.93 56.5102 166.93H67.0847C67.1787 166.93 67.254 167.005 67.254 167.099C67.2728 167.193 67.1787 167.268 67.0847 167.268Z\" fill=#1C468A /><path d=\"M67.0847 168.12H56.5102C56.4161 168.12 56.3408 168.045 56.3408 167.951C56.3408 167.857 56.4161 167.781 56.5102 167.781H67.0847C67.1787 167.781 67.254 167.857 67.254 167.951C67.2728 168.045 67.1787 168.12 67.0847 168.12Z\" fill=#1C468A /><path d=\"M67.9726 173.196C67.6339 173.48 67.2764 173.708 66.9001 173.916C66.9377 173.821 66.9565 173.708 66.9565 173.613C66.9565 173.48 66.8436 173.424 66.7496 173.386C66.7307 173.367 66.6931 173.367 66.6743 173.348C66.7119 173.31 66.7307 173.253 66.7119 173.196C66.6743 173.102 66.5426 173.121 66.505 173.196C66.505 173.215 66.4861 173.234 66.4861 173.253C66.4673 173.253 66.4485 173.234 66.4485 173.215C66.505 173.102 66.5614 172.988 66.6179 172.855C66.6367 172.836 66.6179 172.799 66.599 172.78C66.505 172.704 66.3921 172.742 66.3168 172.817C66.2227 172.912 66.2604 173.064 66.298 173.177V173.196C66.2227 173.348 66.1286 173.48 66.0346 173.613L66.0157 173.594C65.9969 173.575 65.9593 173.537 65.9405 173.499C65.9781 173.386 66.0157 173.272 66.0157 173.158C66.0157 173.102 65.9593 173.083 65.9217 173.102C65.79 173.139 65.7335 173.272 65.7523 173.405C65.7523 173.443 65.7711 173.499 65.79 173.537C65.7711 173.594 65.7335 173.651 65.6959 173.708C65.6771 173.746 65.6959 173.783 65.7147 173.802C65.6771 173.935 65.6206 174.068 65.5265 174.181C65.4513 174.257 65.3008 174.314 65.2255 174.219C65.169 174.162 65.1502 174.068 65.1502 173.973C65.1314 173.783 65.1126 173.575 65.1314 173.386C65.1314 173.291 65.1502 173.196 65.169 173.102C65.1879 173.045 65.2067 172.969 65.2443 173.064C65.2631 173.102 65.2443 173.177 65.2255 173.234C65.2255 173.31 65.3384 173.329 65.3572 173.253C65.376 173.158 65.4136 172.95 65.3008 172.893C65.2067 172.836 65.1314 172.912 65.075 172.988C64.9244 173.272 64.9809 173.651 64.9997 173.935C65.0185 174.181 65.1126 174.465 65.4136 174.39C65.6959 174.314 65.8088 173.954 65.8652 173.708C65.8652 173.689 65.8652 173.67 65.8652 173.67C65.884 173.689 65.884 173.689 65.9029 173.708C65.9217 173.727 65.9405 173.746 65.9593 173.746C65.9217 173.783 65.9029 173.821 65.8652 173.878C65.8464 173.897 65.8464 173.935 65.8652 173.954C65.9593 174.068 66.1286 173.992 66.1286 173.84C66.1286 173.802 66.1286 173.783 66.1098 173.746C66.2039 173.613 66.2792 173.48 66.3544 173.348C66.3921 173.386 66.4485 173.405 66.505 173.405C66.505 173.405 66.505 173.405 66.5238 173.405C66.5614 173.443 66.599 173.461 66.6367 173.499C66.6743 173.518 66.7119 173.537 66.7496 173.556C66.806 173.613 66.7872 173.67 66.7872 173.746C66.7684 173.84 66.7307 173.935 66.7119 174.03C66.5802 174.105 66.4485 174.2 66.4109 174.352C66.3733 174.484 66.4109 174.636 66.5238 174.712C66.5614 174.73 66.599 174.712 66.6179 174.674C66.6931 174.484 66.7496 174.314 66.806 174.124V174.105C66.9189 174.049 67.0506 173.973 67.1635 173.916C67.4646 173.727 67.7468 173.537 68.029 173.31C68.1231 173.234 68.0478 173.139 67.9726 173.196ZM66.4109 173.026C66.4109 172.969 66.4297 172.874 66.505 172.874C66.4861 172.931 66.4485 172.988 66.4297 173.045C66.4109 173.045 66.4109 173.026 66.4109 173.026ZM66.5614 174.541C66.505 174.446 66.5802 174.314 66.6743 174.219C66.6555 174.333 66.6179 174.427 66.5614 174.541Z\" fill=#1C468A /><path d=\"M70.3456 180.433H53.3926V157.4H70.3456V180.433ZM53.5995 180.243H70.1763V157.59H53.5995V180.243Z\" fill=#1C468A /><path d=\"M64.5526 154.674C64.5526 154.674 61.1281 157.628 62.3699 158.064C63.5929 158.5 66.9045 156.53 67.5443 156.53C68.184 156.53 69.6893 156.53 69.6893 156.53C69.6893 156.53 67.5819 154.068 66.4718 154.143C65.3428 154.219 64.5526 154.674 64.5526 154.674Z\" fill=#FFB27D /><path d=\"M45.082 149.426L40.7732 184.183C40.4345 184.126 40.077 184.031 39.7383 183.917L34.8274 182.023H34.8086C34.8086 182.023 36.3139 180.451 38.3836 174.977C40.4345 169.484 45.082 149.426 45.082 149.426Z\" fill=#233862 /></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1.3s><path d=\"M282.405 93.633C282.405 93.633 284.211 92.0041 284.644 90.8487C285.077 89.7122 285.039 87.7802 285.039 86.5301C285.039 86.5301 284.493 86.3407 284.362 86.9279C284.23 87.515 283.985 88.8977 283.496 89.1818C282.988 89.466 281.878 89.4281 281.615 90.8487C281.351 92.2692 282.405 93.633 282.405 93.633Z\" fill=#B56F40 /><path d=\"M278.303 93.8999C278.303 93.8999 276.666 90.5284 277.005 89.4298C277.344 88.3312 282.368 87.1379 283.026 87.6493C283.685 88.1608 283.026 94.4681 283.026 94.4681L278.303 93.8999Z\" fill=#B56F40 /><path d=\"M331.157 195.404C331.157 195.404 330.912 198.188 331.872 199.514C332.831 200.84 333.358 202.052 333.678 201.446C333.998 200.84 333.151 198.737 333.434 198.794C333.716 198.832 334.487 201.294 334.882 202.052C335.277 202.81 336.124 204.022 336.67 203.416C337.234 202.81 336.143 197.09 335.71 196.37C335.277 195.65 334.356 194.04 334.356 194.04L331.157 195.404Z\" fill=#B56F40 /><path d=\"M296.611 111.57L315.728 100.735L328.579 116.76L311.081 125.302L296.611 111.57Z\" fill=#233862 /><path d=\"M304.639 116.668C304.639 116.668 304.243 118.391 303.115 119.016C301.986 119.641 303.754 121.289 303.321 122.52C302.889 123.752 304.657 125.324 304.657 125.324L317.001 126.763C317.001 126.763 318.807 125.968 318.976 123.827C319.146 121.687 319.334 119.016 319.334 119.016L313.934 114.868L306.163 115.247L304.639 116.668Z\" fill=#C94C43 /><path d=\"M263.161 95.9445C263.161 95.9445 262.597 94.5997 262.183 93.1223C261.995 92.4404 261.863 91.7396 261.825 91.1335C261.807 90.7925 261.825 90.4705 261.882 90.2243C261.882 90.2243 277.8 86.9096 279.362 86.2656C280.923 85.6216 294.621 81 294.621 81C294.621 81 295.092 81.966 295.525 83.2729C295.675 83.7654 295.844 84.2957 295.957 84.845C296.183 85.8679 296.296 86.9475 296.145 87.8945C296.145 87.8945 280.02 89.8265 278.346 90.6221C276.69 91.4555 263.161 95.9445 263.161 95.9445Z\" fill=#EFCBAB /><path d=\"M262.183 93.1223C261.995 92.4404 261.863 91.7396 261.825 91.1335C261.807 90.7925 261.825 90.4705 261.882 90.2243C261.882 90.2243 277.8 86.9096 279.362 86.2656C280.923 85.6216 294.621 81 294.621 81C294.621 81 295.092 81.966 295.525 83.2729C295.675 83.7654 295.844 84.2957 295.957 84.845C291.423 85.4133 279.098 86.9854 277.574 87.7241C276.088 88.4628 266.247 91.7775 262.183 93.1223Z\" fill=#DDB08E /><path d=\"M282.074 85.2998C282.074 85.2998 277.821 85.7165 276.278 87.0803L277.181 91.1147C277.181 91.1147 281.076 90.717 283.052 89.6752L282.074 85.2998Z\" fill=#C94C43 /><path d=\"M285.921 271.906C285.921 271.906 285.921 269.33 286.278 268.478C286.636 267.626 287.972 264.141 287.972 264.141H293.203C293.203 264.141 294.181 267.323 294.238 268.364C294.294 269.406 294.238 271.925 294.238 271.925H285.921V271.906Z\" fill=#233862 /><path d=\"M319.073 271.906C319.073 271.906 319.073 269.33 318.716 268.478C318.358 267.626 317.022 264.141 317.022 264.141H311.791C311.791 264.141 310.813 267.323 310.757 268.364C310.7 269.406 310.757 271.925 310.757 271.925H319.073V271.906Z\" fill=#233862 /><path d=\"M306.013 127.047C306.013 127.047 304.959 132.691 303.849 135.116L297.546 138.241L306.37 155.818L318.507 144.794L314.48 136.877C314.48 136.877 314.104 129.035 315.327 126.365C316.569 123.656 306.013 127.047 306.013 127.047Z\" fill=#B56F40 /><path d=\"M305.864 127.822C305.864 127.822 306.937 132.198 310.135 132.595C313.353 132.993 314.632 129.47 314.632 129.47L305.864 127.822Z\" fill=#99592E /><path d=\"M310.006 130.947C307.692 130.549 303.91 126.78 304.493 122.935L305.415 116.93C305.622 115.529 306.77 114.525 307.974 114.714L316.798 116.078C317.984 116.268 318.774 117.556 318.567 118.957L317.702 124.621C317.1 128.674 312.659 131.401 310.006 130.947Z\" fill=#B56F40 /><path d=\"M286.578 182.79C286.559 182.089 287.481 210.671 286.126 226.904C284.79 242.928 286.145 265.222 286.145 265.222C286.145 265.222 290.51 267.646 295.252 265.222C295.252 265.222 300.445 234.272 300.407 226.904C300.37 219.062 306.052 184.021 306.052 184.021L286.578 182.79Z\" fill=#F99746 /><path d=\"M318.887 265.204C318.887 265.204 314.522 267.628 309.78 265.204C309.78 265.204 304.587 234.254 304.625 226.886C304.643 223.571 303.627 215.408 302.461 207.074C300.861 195.69 298.961 184.003 298.961 184.003L319.188 182.734C319.188 182.734 317.513 210.862 318.887 226.886C320.26 242.91 318.887 265.204 318.887 265.204Z\" fill=#F99746 /><path d=\"M308.122 123.354C307.257 123.222 305.563 122.767 305.488 121.214C305.469 120.74 305.62 120.343 305.921 120.078C306.259 119.774 306.749 119.661 307.257 119.737L309.91 120.153C310.418 120.229 310.738 120.437 310.888 120.74C311.133 121.271 310.775 121.972 310.606 122.237C310.041 123.165 309.402 123.544 308.593 123.411C308.574 123.392 308.386 123.392 308.122 123.354ZM307.238 119.888C306.767 119.812 306.335 119.926 306.034 120.191C305.77 120.418 305.638 120.778 305.657 121.195C305.695 121.991 306.203 122.578 307.144 122.938C307.878 123.203 308.593 123.241 308.611 123.241H308.63C309.364 123.354 309.947 123.013 310.474 122.142C310.587 121.953 310.963 121.29 310.738 120.816C310.625 120.551 310.324 120.381 309.891 120.324L307.238 119.888Z\" fill=#2C3A64 /><path d=\"M314.231 124.302C313.967 124.264 313.779 124.207 313.741 124.207C312.932 124.075 312.443 123.525 312.18 122.465C312.104 122.162 311.973 121.385 312.368 120.949C312.594 120.684 312.97 120.608 313.478 120.684L316.131 121.101C316.658 121.177 317.091 121.442 317.316 121.84C317.523 122.199 317.542 122.616 317.392 123.052C316.846 124.51 315.096 124.434 314.231 124.302ZM313.44 120.855C312.989 120.779 312.669 120.855 312.481 121.063C312.142 121.442 312.293 122.18 312.33 122.408C312.575 123.393 313.026 123.904 313.76 124.018H313.779C313.779 124.018 314.494 124.207 315.265 124.169C316.282 124.112 316.94 123.715 317.204 122.957C317.354 122.559 317.335 122.199 317.147 121.896C316.94 121.555 316.564 121.328 316.093 121.252L313.44 120.855Z\" fill=#2C3A64 /><path d=\"M310.555 121.495C310.517 121.495 310.48 121.457 310.461 121.419C310.442 121.363 310.48 121.306 310.536 121.287C310.574 121.269 311.703 120.967 312.55 121.608C312.587 121.646 312.606 121.702 312.568 121.759C312.531 121.797 312.474 121.815 312.418 121.778C311.646 121.212 310.611 121.495 310.593 121.495C310.593 121.495 310.574 121.495 310.555 121.495Z\" fill=#2C3A64 /><path d=\"M308.22 138.202L302.236 135.588C302.236 135.588 299.151 160.325 303.271 161.859C303.271 161.859 315.05 140.816 314.241 138.107L308.22 138.202Z\" fill=white /><path d=\"M304.437 134.037C304.437 134.037 302.743 134.321 301.878 135.174C301.878 135.174 303.157 139.36 306.563 140.61L308.031 138.204C308.031 138.204 305.246 136.897 304.437 134.037Z\" fill=#D2E3FC /><path d=\"M308.036 138.203C308.036 138.203 313.606 137.995 314.434 135.286C314.434 135.286 315.544 136.46 315.506 138.355C315.506 138.355 313.737 141.025 309.334 141.063L308.036 138.203Z\" fill=#D2E3FC /><path d=\"M308.484 126.744C308.484 126.744 311.438 126.877 312.756 127.407C312.756 127.407 311.852 128.487 310.667 128.297C309.5 128.127 308.673 127.54 308.484 126.744Z\" fill=#FFF0E6 /><path d=\"M287.521 117.953C284.83 119.658 281.161 121.969 278.169 123.787C278.019 123.276 277.906 122.821 277.849 122.405C276.852 116.021 278.301 93.8982 278.301 93.8982C278.301 93.8982 279.298 93.3868 280.333 93.3111C282.29 93.1595 283.024 94.4665 283.024 94.4665C283.024 94.4665 286.392 113.938 287.521 117.953Z\" fill=#B56F40 /><path d=\"M335.084 194.967L333.052 195.819C329.815 196.975 326.316 195.421 325.262 192.126C323.832 187.694 323.681 182.901 323.155 178.962C322.891 177.03 322.59 173.033 321.424 169.927L323.456 238.74C292.936 240.918 278.053 223.265 278.053 223.265C277.263 204.627 284.657 162.653 287.348 148.107C286.05 145.152 276.811 136.666 275.268 128.332C274.553 124.468 276.792 121.722 279.521 119.884C282.945 117.555 287.141 116.646 287.141 116.646L297.001 129.923C297.415 130.397 297.716 130.776 297.828 131.003C298.581 132.556 302.532 135.151 302.532 135.151C302.514 135.227 302.965 157.52 303.755 158.24C304.922 157.804 312.693 142.121 314.424 136.894C316.908 137.575 319.58 138.504 322.402 139.754C322.402 139.754 327.746 142.614 328.498 155.134C329.138 165.741 335.573 179.284 337.041 191.576C337.248 192.997 336.439 194.399 335.084 194.967Z\" fill=#1C468A /><path d=\"M301.483 134.358C301.483 134.358 302.198 155.97 303.12 161.387L316.818 137.578L314.937 136.878L304.099 156.595L303.026 135.116L301.483 134.358Z\" fill=#C94C43 /><path d=\"M304.437 133.523C304.437 133.523 302.743 133.808 301.878 134.66C301.878 134.66 303.157 138.846 306.563 140.096L308.031 138.202C308.031 138.202 305.246 136.384 304.437 133.523Z\" fill=white /><path d=\"M308.036 138.203C308.036 138.203 313.606 137.483 314.434 134.774C314.434 134.774 315.544 135.949 315.506 137.843C315.506 137.843 313.737 140.514 309.334 140.551L308.036 138.203Z\" fill=white /><path d=\"M300.863 164.72C301.424 164.72 301.879 164.263 301.879 163.698C301.879 163.133 301.424 162.675 300.863 162.675C300.302 162.675 299.847 163.133 299.847 163.698C299.847 164.263 300.302 164.72 300.863 164.72Z\" fill=#233862 /><path d=\"M297.951 172.865C297.951 172.296 298.403 171.842 298.967 171.842C299.532 171.842 299.983 172.296 299.983 172.865C299.983 173.433 299.532 173.887 298.967 173.887C298.422 173.887 297.951 173.433 297.951 172.865Z\" fill=#233862 /><path d=\"M297.996 121.704L298.335 121.382C294.948 117.783 296.528 113.01 296.942 111.911C296.999 111.779 296.961 111.608 296.867 111.513C296.754 111.4 296.585 111.438 296.528 111.589C296.039 112.858 294.459 117.953 297.996 121.704Z\" fill=#EFCBAB /><path d=\"M298.338 121.383L298.865 121.705L298.281 122.254L297.999 121.705L298.338 121.383Z\" fill=#D8A987 /><path d=\"M298.861 121.706C298.861 121.706 299.501 122.35 299.764 122.236C299.764 122.236 299.407 122.88 299.049 122.899C299.049 122.899 298.428 122.577 298.259 122.255L298.861 121.706Z\" fill=#EFCBAB /><path d=\"M304.951 117.972C304.951 117.972 307.322 118.143 308.018 116.931C308.018 116.931 309.937 117.423 310.803 116.684C310.803 116.684 313.776 117.291 313.851 116.078C313.851 116.078 316.128 120.662 318.611 119.696C321.095 118.73 314.622 114.108 314.622 114.108L306.155 115.245L304.951 117.972Z\" fill=#C94C43 /><path d=\"M305.133 114.545L304.644 116.666C304.644 116.666 311.267 114.299 319.339 119.015L319.245 115.587C319.226 114.924 318.925 114.299 318.417 113.863C316.949 112.651 313.468 110.283 306.996 112.158C306.074 112.442 305.34 113.617 305.133 114.545Z\" fill=#1C468A /><path d=\"M276.235 88.3301C276.216 88.1975 275.783 87.2884 276.366 86.436C276.968 85.5837 280.882 84.2768 281.24 84.9776C281.597 85.6595 281.371 88.046 280.111 88.5764C278.869 89.1067 276.329 88.8605 276.235 88.3301Z\" fill=#B56F40 /><path d=\"M287.391 148.089C286.093 145.135 276.854 136.649 275.311 128.315C274.596 124.451 276.835 121.704 279.564 119.867C279.564 119.867 278.284 125.72 281.916 131.005C285.528 136.27 287.391 148.089 287.391 148.089Z\" fill=#233862 /><path d=\"M333.072 195.802C329.835 196.957 326.335 195.404 325.282 192.108C323.852 187.676 323.701 182.884 323.174 178.944C322.911 177.012 322.61 173.016 321.443 169.909C321.556 170.08 325.056 175.667 328.217 184.702C331.416 193.908 330.418 195.233 333.072 195.802Z\" fill=#233862 /></g><g class=\"wow bounce\" data-wow-duration=5s data-wow-delay=1s><path d=\"M213.481 217.806C214.704 215.874 204.411 194.584 209.943 182.727C210.639 181.249 223.453 183.465 223.453 183.465C223.453 183.465 226.068 213.411 224.601 221.347C223.566 226.954 221.515 243.471 220.424 252.695C220.424 252.733 220.424 252.752 220.405 252.79C220.141 254.987 219.934 256.748 219.803 257.847C219.709 258.68 219.803 259.514 220.085 260.309C220.894 262.563 222.682 267.223 223.566 267.867C223.566 267.867 218.711 269.268 217.789 268.719C216.849 268.17 214.497 259.571 214.497 259.571C214.911 258.775 215.061 257.866 214.911 256.976C214.722 255.801 214.44 253.964 214.139 251.71C209.924 234.606 210.564 222.408 213.481 217.806Z\" fill=#FFB27D /><path d=\"M186.071 256.027C186.748 255.421 187.2 254.626 187.369 253.735C187.614 252.58 187.99 250.762 188.498 248.527C190.568 231.101 195.441 219.907 199.788 216.63C201.613 215.266 199.449 191.684 208.782 182.555C209.948 181.418 221.163 188.048 221.163 188.048C221.163 188.048 213.109 216.99 208.951 223.884C206.016 228.752 198.301 243.488 194.03 251.709C192.995 253.698 192.167 255.308 191.641 256.311C191.264 257.05 191.057 257.884 191.038 258.717C191.02 261.123 190.7 267.544 191.641 268.112C192.224 268.453 192.732 268.85 193.146 269.229C193.146 269.229 188.724 268.85 188.178 268.813C187.652 268.794 184.246 258.092 184.189 257.884C184.886 257.145 185.563 256.482 186.071 256.027Z\" fill=#FFB27D /><path d=\"M182.004 261.825L180.894 268.379L181.477 268.814L184.958 263.757L182.004 261.825Z\" fill=#233862 /><path d=\"M182.115 262.336C185.916 264.344 186.481 271.03 187.083 272.469L194.026 272.488C195.08 272.128 194.666 270.632 193.16 269.23C193.16 269.23 188.739 268.852 188.193 268.814C187.666 268.795 184.26 258.093 184.204 257.885C182.605 259.646 181.062 261.768 182.115 262.336Z\" fill=#1C468A /><path d=\"M188.197 240.157C188.498 248.529 205.037 246.919 205.037 246.919L207.22 236.274L208.669 229.209L209.158 226.86L208.424 226.519L197.906 221.5L194.613 219.928L194.482 220.344L188.818 238.225L188.197 240.157Z\" fill=#F99746 /><path d=\"M188.813 238.225C193.593 233.281 207.234 236.274 207.234 236.274L208.683 229.209L208.438 226.52L197.92 221.5L194.496 220.345L188.813 238.225Z\" fill=#EF7E29 /><path d=\"M213.219 266.22L214.122 272.451H215.119L215.608 267.621L213.219 266.22Z\" fill=#233862 /><path d=\"M213.216 266.218C215.324 267.203 217.638 271.332 218.711 272.469L227.479 272.525C228.57 271.616 224.75 268.699 223.565 267.847C223.565 267.847 218.711 269.249 217.789 268.699C216.848 268.15 214.496 259.551 214.496 259.551C213.442 261.559 211.655 265.498 213.216 266.218Z\" fill=#1C468A /><path d=\"M209.156 223.791L211.339 247.827C215.384 252.979 226.053 249.816 226.053 249.816C226.053 249.816 226.862 229.966 227.276 229.189L225.733 228.735L209.156 223.791Z\" fill=#F99746 /><path d=\"M209.156 223.791L211.339 247.827C211.452 236.008 226.655 237.182 226.655 237.182L225.733 228.716L209.156 223.791Z\" fill=#EF7E29 /><path d=\"M227.764 110.883L205.467 102L193.011 114.103L214.197 122.418L227.764 110.883Z\" fill=#233862 /><path d=\"M217.323 114.994C217.323 114.994 217.36 117.665 219.317 118.498C223.363 120.222 219.505 122.23 223.476 125.033C224.379 125.677 225.037 129.711 218.734 130.318C212.431 130.924 211.64 131.454 211.64 131.454C211.64 131.454 206.955 134.485 201.781 131.359C198.77 129.56 202.552 124.541 201.179 123.271C199.316 121.548 199.071 115.922 201.781 113.593C204.49 111.263 208.799 109.918 208.799 109.918L217.323 114.994Z\" fill=#132644 /><path d=\"M235.025 120.809L235.194 120.24C229.23 118.46 227.95 112.228 227.724 110.77C227.706 110.58 227.555 110.429 227.386 110.391C227.198 110.334 227.028 110.505 227.066 110.694C227.329 112.361 228.797 118.952 235.025 120.809Z\" fill=#EFCBAB /><path d=\"M235.189 120.239H235.979L235.678 121.205L235.02 120.808L235.189 120.239Z\" fill=#D8A987 /><path d=\"M235.987 120.239C235.987 120.239 237.079 120.542 237.323 120.239C237.323 120.239 237.342 121.167 236.966 121.414C236.966 121.414 236.081 121.452 235.705 121.205L235.987 120.239Z\" fill=#EFCBAB /><path d=\"M218.696 131.984C218.244 131.927 216.908 130.847 216.306 129.199C215.572 127.211 214.951 125.07 214.951 125.07L213.013 125.392L207.839 126.245L207.406 126.32C207.82 127.419 208.14 128.461 208.347 129.408C208.761 131.131 208.874 132.59 208.836 133.689C208.78 134.806 208.215 135.09 207.895 135.317C207.745 135.412 213.352 153.918 216.062 152.989C218.413 152.175 218.922 131.908 218.696 131.984Z\" fill=#FFB27D /><path d=\"M208.839 133.67C211.943 132.401 214.954 125.051 214.954 125.051C214.333 124.976 213.674 125.108 213.016 125.373C211.303 126.074 209.554 127.722 208.368 129.389C208.763 131.113 208.895 132.59 208.839 133.67Z\" fill=#ED975D /><path d=\"M206.86 130.675C206.86 130.675 216.099 129.16 215.082 123.383C214.066 117.606 214.574 113.515 208.629 114.234C202.683 114.954 201.93 117.36 201.798 119.386C201.667 121.394 204.433 130.922 206.86 130.675Z\" fill=#FFB27D /><path d=\"M206.026 136.057C206.026 136.057 190.428 131.341 189.318 130.015C188.208 128.708 185.517 111.244 185.517 108.744L183.24 109.066C183.24 109.066 181.566 128.916 183.504 133.405C185.461 137.913 205.123 144.997 205.123 144.997L206.026 136.057Z\" fill=#FFB27D /><path d=\"M218.224 131.758C218.224 131.758 216.305 137.762 208.816 133.993L216.7 151.438L218.751 135.849L218.224 131.758Z\" fill=#F99746 /><path d=\"M224.598 133.519C224.598 133.519 223.657 136.644 241.721 146.55L255.042 137.364L256.642 138.708C256.642 138.708 243.866 154.202 241.871 153.88C239.877 153.558 226.16 144.467 226.16 144.467L224.598 133.519Z\" fill=#FFB27D /><path d=\"M175.492 211.044C175.492 211.044 175.981 212.597 177.092 214.851C179.011 218.715 182.793 224.643 189.096 228.185C196.265 232.22 219.465 239.929 235.402 236.197C235.402 236.197 233.897 185.435 230.547 164.562C230.472 164.07 230.397 163.615 230.322 163.161C231.3 166.911 236.286 168.142 238.318 167.441C242.815 165.926 244.377 162.403 244.584 158.69C244.904 152.97 242.044 146.758 241.705 146.568C234.348 142.363 232.975 135.677 229.4 133.29C226.201 131.169 218.58 131.718 218.204 131.756L216.529 148.443L208.777 133.991C208.759 133.991 196.284 132.893 189.284 130.014C189.284 130.014 168.399 159.107 194.27 158.728C194.27 165.433 191.166 171.514 188.155 180.567C185.22 189.545 175.492 211.044 175.492 211.044Z\" fill=#1C468A /><path d=\"M208.871 126.473C208.871 126.473 208.777 127.42 208.175 127.647C207.591 127.874 206.011 128.31 205.86 128.215C205.691 128.121 205.089 127.401 205.089 127.401C205.089 127.401 207.554 126.397 208.871 126.473Z\" fill=white /><path d=\"M185.573 108.743C185.573 108.743 186.533 108.08 186.025 106.243C185.686 105.012 185.912 104.008 185.648 104.046C185.366 104.084 185.159 105.675 184.99 106.072C184.858 106.413 182.769 102.455 182.243 102.758C181.716 103.061 180.681 104.633 183.165 110.031L185.573 108.743Z\" fill=#FFB27D /><path d=\"M255.045 137.381C255.045 137.381 256.456 133.991 256.945 133.29C257.886 131.907 260.539 131.036 260.727 131.661C260.897 132.267 259.015 133.176 258.94 134.578C258.921 134.976 259.711 134.218 260.2 133.915C260.501 133.744 260.671 133.877 260.52 134.104C259.73 135.26 259.316 136.434 258.563 136.87C257.811 137.305 256.663 138.726 256.663 138.726L255.045 137.381Z\" fill=#FFB27D /><path d=\"M218.221 131.758L216.546 148.445L208.832 133.671L206.028 133.69L217.374 154.468L220.291 131.663L218.221 131.758Z\" fill=#AA443E /><path d=\"M203.039 114.464C203.039 114.464 200.33 117.684 208.872 119.256C211.619 119.767 212.993 122.438 212.24 124.692C211.13 128.025 213.933 131.643 218.054 130.336C221.328 129.313 215.984 113.877 213.068 113.63C210.17 113.384 203.039 114.464 203.039 114.464Z\" fill=#132644 /><path d=\"M206.028 115.203C206.028 115.203 203.281 117.192 203.055 118.783C202.83 120.374 202.19 122.647 201.136 121.037C200.083 119.427 199.913 117.267 201.136 115.79C202.359 114.332 205.087 113.669 205.671 114.161C206.254 114.673 206.028 115.203 206.028 115.203Z\" fill=#132644 /><path d=\"M201.199 114.274C201.199 114.274 206.43 109.728 217.569 116.414L217.72 113.649C217.287 112.001 216.779 112.02 215.273 111.225C213.599 110.315 211.002 109.444 207.314 109.463C204.774 109.482 203.288 109.16 202.14 111.433L201.199 114.274Z\" fill=#1C468A /><path d=\"M270.546 146.001C270.546 146.001 271.525 144.921 272.39 143.671C272.785 143.084 273.162 142.478 273.387 141.929C273.519 141.607 273.613 141.304 273.632 141.039C273.632 141.039 259.727 132.553 258.466 131.435C257.206 130.299 245.841 121.34 245.841 121.34C245.841 121.34 245.088 122.079 244.242 123.177C243.922 123.575 243.602 124.029 243.301 124.522C242.736 125.412 242.266 126.397 242.097 127.325C242.097 127.325 256.66 134.58 257.958 135.887C259.276 137.212 270.546 146.001 270.546 146.001Z\" fill=#EFCBAB /><path d=\"M272.391 143.671C272.786 143.084 273.162 142.478 273.388 141.929C273.52 141.607 273.614 141.304 273.633 141.039C273.633 141.039 259.728 132.553 258.467 131.435C257.207 130.299 245.842 121.34 245.842 121.34C245.842 121.34 245.089 122.079 244.243 123.177C243.923 123.575 243.603 124.029 243.302 124.522C247.404 126.587 258.486 132.212 259.672 133.424C260.838 134.599 269.023 141.02 272.391 143.671Z\" fill=#DDB08E /><path d=\"M256.249 129.618C256.249 129.618 260.106 131.437 261.103 133.255L258.921 136.759C258.921 136.759 255.383 135.073 253.878 133.425L256.249 129.618Z\" fill=#C94C43 /><path d=\"M258.54 136.871C258.54 136.871 259.519 136.474 260.102 135.735C260.685 134.996 261.476 133.803 260.497 134.106C259.519 134.409 257.769 135.64 257.11 135.754C256.452 135.867 256.696 136.379 256.64 136.53C256.583 136.701 258.54 136.871 258.54 136.871Z\" fill=#FFB27D /><path d=\"M175.492 211.044C175.492 211.044 175.981 212.597 177.092 214.851C181.287 210.4 187.12 203.297 191.185 194.754C198.203 180.018 194.289 158.729 194.289 158.729C194.289 165.434 191.185 171.514 188.174 180.568C185.22 189.546 175.492 211.044 175.492 211.044Z\" fill=#233862 /><path d=\"M218.743 160.49C218.743 160.111 218.423 159.789 218.047 159.789C217.67 159.789 217.351 160.111 217.351 160.49C217.351 160.869 217.67 161.191 218.047 161.191C218.423 161.191 218.743 160.888 218.743 160.49Z\" fill=#233862 /><path d=\"M218.743 173.258C218.743 172.88 218.423 172.558 218.047 172.558C217.67 172.558 217.351 172.88 217.351 173.258C217.351 173.637 217.67 173.959 218.047 173.959C218.423 173.959 218.743 173.656 218.743 173.258Z\" fill=#233862 /><path d=\"M230.567 164.562C230.492 164.069 230.416 163.615 230.341 163.16C231.32 166.911 236.306 168.142 238.338 167.441C242.835 165.926 244.397 162.403 244.604 158.69C244.114 158.936 236.833 162.687 233.446 160.49C229.984 158.254 227.857 153.159 227.782 153.008L230.567 164.562Z\" fill=#233862 /></g></svg></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000><div class=profile_popup_content><div><span ng-hide=notFound class=\"profile_popup_subtitle mb-24\">Now, let’s get to know about your educational institute. Where did you study?</span> <span ng-show=notFound class=\"profile_popup_subtitle mb-24\">Seems like we missed your institute , you can enter it below :</span><!-- ng:class=\"{ d_inflex : selected.value.id === 0.1 }\" --><div class=\"profile_popup_input profile_city_dropdown\"><!-- <ui-select\n                ng-model=\"selectedUni.value\"\n                ng-if=\"selectedUni.value.id !== 0.1\"\n              >\n                <ui-select-match placeholder=\"Choose your Institute\">\n                  <span ng-bind=\"$select.selected.name\"></span>\n                </ui-select-match>\n                <ui-select-choices\n                  repeat=\"item in (uniArray | filter: $select.search) track by item.id\"\n                >\n                  <span ng-bind=\"item.name\"></span>\n                </ui-select-choices>\n              </ui-select> --> <input type=text ng-show=defaultField ng-model=otherUni ng-change=uniCheck(otherUni) ng-click=uniCheck(otherUni);$event.stopPropagation(); placeholder=\"Choose your Institute\" autocomplete=off autocomplete=chrome-off> <input type=text ng-show=!defaultField ng-model=otherUniDefault ng-change=uniCheck(otherUniDefault) ng-click=uniCheck(otherUniDefault);$event.stopPropagation(); placeholder=\"Choose your Institute\" autocomplete=off autocomplete=chrome-off><ul class=custom-city-select ng-show=showUniList><li ng-repeat=\"x in searchUniversities\" ng-click=onSelectUni(x);$event.stopPropagation();>{{x.name}}</li></ul><!-- <img\n              src=\"./../../images/back-icon.svg\"\n                 ng-click=\"selectedUni.value.id = 0\"\n                 ng-show=\"selectedUni.value.id === 0.1\" class=\"fas fa-angle-left\" style=\"padding-right: 10px\" /> --><!-- <input\n                  type=\"text\"\n                  name=\"profile-insitution\"\n                  id=\"profile-insitution\"\n                  placeholder=\"Enter Institution name\"\n                  ng-model=\"customUni\"\n                  ng-show=\"selectedUni.value.id === 0.1\"\n                /> --></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=genderTab(true)>Skip </a><a class=\"profile_popup_button active\" ng-click=\"defaultField ? genderTab(false,otherUni) : genderTab(false,otherUniDefault) ;$event.stopPropagation() \"><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- Gender tab --><div class=\"row gender-tab\" ng-if=gender_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><div class=\"gender {{GenderSelected}}\"><label class=gender-female for=gender_female ng-click=\"genderType(\'female\')\"><img class=female-icon src=../../images/female-icon.svg alt=# ng-show=\"GenderSelected !== \'Female\'\"> <img class=female-icon-hover src=../../images/female-icon-hover.svg alt=# ng-show=\"GenderSelected === \'Female\'\"></label><label class=gender-male for=gender_male ng-click=\"genderType(\'male\')\"><img class=male-icon src=../../images/male-icon.svg alt=# ng-show=\"GenderSelected !== \'Male\'\"> <img class=male-icon-hover src=../../images/male-icon-hover.svg alt=# ng-show=\"GenderSelected === \'Male\'\"></label></div></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up-left data-aos-duration=1000><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\">Awesome! What gender do you identify with?</span><div class=profile_popup_radio><div class=btnRadio ng-click=gneder_male();$event.stopPropagation();><input type=radio id=gender_male name=profile-gender ng-change=\"RadioChange(\'Male\')\" ng-model=userData.gender value=Male><label for=gender_male>Male</label></div><div class=btnRadio><input type=radio id=gender_female name=profile-gender ng-change=\"RadioChange(\'Female\')\" ng-model=userData.gender value=Female><label for=gender_female>Female</label></div><div class=btnRadio><input type=radio id=other name=profile-gender ng-change=\"RadioChange(\'Other\')\" ng-model=userData.gender value=OTHER><label for=other>Other</label></div></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=birthdayTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=birthdayTab(false,userData.gender);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- birthday tab --><div class=\"row birthday-tab\" ng-if=birthday_tab><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000 data-aos-delay=1000><svg class=welcome-desktop-image width=324 height=288 viewBox=\"0 0 324 288\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M294.987 212.653C295.145 212.839 295.284 213.039 295.403 213.251C295.653 213.644 295.993 214.227 296.417 214.946C297.249 216.383 298.354 218.403 299.534 220.65C300.714 222.897 301.728 224.887 302.56 226.422C302.923 227.111 303.226 227.701 303.476 228.162C303.607 228.367 303.711 228.589 303.786 228.82C303.629 228.637 303.49 228.44 303.37 228.23C303.12 227.829 302.78 227.254 302.364 226.528C301.539 225.083 300.465 223.048 299.284 220.801C298.104 218.554 297.06 216.58 296.258 215.052L295.335 213.312C295.193 213.107 295.077 212.886 294.987 212.653Z\" fill=#E0E0E0 /><path d=\"M304.693 228.767C304.647 228.692 308.71 226.233 313.771 223.275C318.832 220.317 322.956 217.979 323.001 218.047C323.046 218.115 318.984 220.582 313.923 223.54C308.861 226.498 304.738 228.836 304.693 228.767Z\" fill=#E0E0E0 /><path d=\"M297.912 253.855C298.137 253.755 298.374 253.681 298.616 253.635L300.568 253.143C302.217 252.727 304.486 252.145 306.968 251.411C309.449 250.677 311.681 249.898 313.285 249.383L315.191 248.74C315.419 248.644 315.658 248.575 315.903 248.536C315.688 248.661 315.462 248.768 315.229 248.854C314.79 249.035 314.155 249.293 313.361 249.61C311.772 250.208 309.578 250.987 307.059 251.721C304.539 252.455 302.285 253.015 300.62 253.378C299.788 253.552 299.107 253.688 298.646 253.771C298.404 253.822 298.159 253.85 297.912 253.855Z\" fill=#E0E0E0 /><path d=\"M285.921 241.213C286.113 241.339 286.288 241.489 286.443 241.659L287.774 242.96C288.887 244.065 290.415 245.608 292.087 247.318C293.759 249.028 295.257 250.609 296.331 251.751L297.594 253.121C297.757 253.281 297.902 253.459 298.025 253.65C297.833 253.524 297.658 253.374 297.503 253.204L296.202 251.903C295.09 250.798 293.562 249.255 291.89 247.538C290.218 245.82 288.72 244.254 287.646 243.112L286.367 241.742C286.199 241.584 286.049 241.406 285.921 241.213Z\" fill=#E0E0E0 /><path d=\"M277.122 262.585C277.359 262.755 277.58 262.948 277.78 263.16L279.498 264.817C280.935 266.231 282.902 268.191 285.066 270.37C287.229 272.549 289.174 274.538 290.566 275.983L292.215 277.708C292.423 277.913 292.613 278.136 292.782 278.374C292.545 278.204 292.325 278.011 292.124 277.799L290.414 276.142C288.977 274.727 287.002 272.768 284.846 270.589C282.69 268.41 280.738 266.421 279.339 264.976L277.697 263.251C277.485 263.047 277.293 262.824 277.122 262.585Z\" fill=#E0E0E0 /><path d=\"M292.521 277.905C292.807 277.781 293.103 277.683 293.406 277.61L295.857 276.899C297.93 276.293 300.782 275.454 303.906 274.432C307.031 273.411 309.822 272.42 311.865 271.663L314.263 270.793C314.553 270.675 314.851 270.578 315.156 270.506C314.888 270.667 314.604 270.802 314.309 270.907C313.749 271.141 312.947 271.474 311.941 271.868C309.936 272.624 307.137 273.683 304.005 274.697C300.873 275.711 298.005 276.528 295.917 277.08C294.873 277.353 294.026 277.564 293.443 277.693C293.143 277.791 292.834 277.862 292.521 277.905Z\" fill=#E0E0E0 /><path d=\"M255.274 98.6812C260.925 100.542 264.617 94.0588 264.617 94.0588L261.198 92.001C259.412 95.9879 253.738 95.3903 253.738 95.3903L255.274 98.6812Z\" fill=#E0E0E0 /><path d=\"M302.71 79.3066C303.058 85.2454 310.442 86.3045 310.442 86.3045L311.1 82.3705C306.742 82.1663 305.214 76.6738 305.214 76.6738L302.71 79.3066Z\" fill=#E0E0E0 /><path d=\"M36.146 157.199C34.4741 153.469 29.4658 154.597 29.4658 154.597L30.003 157.282C32.8551 156.344 35.1777 159.506 35.1777 159.506L36.146 157.199Z\" fill=#E0E0E0 /><path d=\"M211.379 42.0847C209.707 38.355 204.699 39.4823 204.699 39.4823L205.236 42.168C208.089 41.2299 210.411 44.3922 210.411 44.3922L211.379 42.0847Z\" fill=#E0E0E0 /><path d=\"M289.305 2.76764C287.633 -0.962085 282.625 0.157587 282.625 0.157587L283.162 2.85085C286.014 1.91275 288.337 5.07507 288.337 5.07507L289.305 2.76764Z\" fill=#E0E0E0 /><path d=\"M165.399 22.3394C164.264 19.805 160.859 20.5691 160.859 20.5691L161.223 22.3923C163.159 21.7568 164.74 23.9054 164.74 23.9054L165.399 22.3394Z\" fill=#E0E0E0 /><path d=\"M88.597 29.6855C85.9113 30.374 86.0853 33.8541 86.0853 33.8541L87.9464 33.8011C87.6513 31.7887 90.0269 30.5934 90.0269 30.5934L88.597 29.6855Z\" fill=#E0E0E0 /><path d=\"M6.55659 89.1944C6.55659 86.4179 3.13704 85.7295 3.13704 85.7295L2.72852 87.5452C4.75603 87.757 5.31587 90.3595 5.31587 90.3595L6.55659 89.1944Z\" fill=#E0E0E0 /><path d=\"M249.244 50.4668C256.53 52.8575 261.288 44.5053 261.288 44.5053L256.862 41.8574C254.593 46.9716 247.27 46.2151 247.27 46.2151L249.244 50.4668Z\" fill=#E0E0E0 /><path d=\"M54.8681 13.7839C62.1535 16.1746 66.9197 7.81487 66.9197 7.81487L62.5091 5.16699C60.2395 10.3039 52.8936 9.5322 52.8936 9.5322L54.8681 13.7839Z\" fill=#E0E0E0 /><path d=\"M39.9976 42.0847C38.3256 38.355 33.3174 39.4823 33.3174 39.4823L33.8621 42.168C36.7067 41.2299 39.0292 44.3922 39.0292 44.3922L39.9976 42.0847Z\" fill=#E0E0E0 /><path d=\"M32.8013 126.082C30.1534 119.001 20.4697 121.921 20.4697 121.921L21.1128 127.111C26.6658 124.841 30.6376 130.734 30.6376 130.734L32.8013 126.082Z\" fill=#E0E0E0 /><path d=\"M211.905 141.44C208.705 134.298 199.127 136.447 199.127 136.447L200.156 141.591C205.61 139.798 210.059 145.843 210.059 145.843L211.905 141.44Z\" fill=#E0E0E0 /><path d=\"M159.332 62.3282C159.332 59.5517 155.912 58.8633 155.912 58.8633L155.504 60.679C157.531 60.8908 158.091 63.4933 158.091 63.4933L159.332 62.3282Z\" fill=#E0E0E0 /><path d=\"M206.698 90.7159C206.698 87.947 203.286 87.251 203.286 87.251L202.878 89.0667C204.898 89.2785 205.465 91.881 205.465 91.881L206.698 90.7159Z\" fill=#E0E0E0 /><path d=\"M177.672 148.158C177.672 145.382 174.252 144.693 174.252 144.693L173.844 146.509C175.871 146.721 176.431 149.323 176.431 149.323L177.672 148.158Z\" fill=#E0E0E0 /><path d=\"M301.932 127.164C301.932 124.388 298.512 123.699 298.512 123.699L298.104 125.515C300.131 125.727 300.691 128.329 300.691 128.329L301.932 127.164Z\" fill=#E0E0E0 /><path d=\"M177.692 104.318C178.728 104.318 179.568 103.478 179.568 102.442C179.568 101.405 178.728 100.565 177.692 100.565C176.655 100.565 175.815 101.405 175.815 102.442C175.815 103.478 176.655 104.318 177.692 104.318Z\" fill=#FF725E /><path d=\"M10.2004 176.582C11.2366 176.582 12.0766 175.742 12.0766 174.706C12.0766 173.67 11.2366 172.83 10.2004 172.83C9.16423 172.83 8.32422 173.67 8.32422 174.706C8.32422 175.742 9.16423 176.582 10.2004 176.582Z\" fill=#FF725E /><path d=\"M317.838 99.4758C317.837 99.8453 317.726 100.206 317.52 100.513C317.315 100.82 317.023 101.059 316.682 101.201C316.341 101.342 315.965 101.38 315.602 101.309C315.24 101.239 314.906 101.062 314.643 100.803C314.381 100.543 314.2 100.211 314.125 99.8497C314.05 99.488 314.083 99.1121 314.221 98.7692C314.359 98.4264 314.594 98.1317 314.899 97.9223C315.203 97.7129 315.562 97.598 315.932 97.592C316.181 97.588 316.429 97.6338 316.661 97.7268C316.893 97.8197 317.103 97.958 317.281 98.1334C317.458 98.3088 317.599 98.5179 317.695 98.7484C317.791 98.9789 317.839 99.2262 317.838 99.4758Z\" fill=#FF725E /><path d=\"M25.6958 82.1213C25.6958 82.4924 25.5857 82.8551 25.3796 83.1637C25.1734 83.4722 24.8804 83.7127 24.5376 83.8547C24.1947 83.9967 23.8175 84.0339 23.4535 83.9615C23.0896 83.8891 22.7553 83.7104 22.4929 83.448C22.2305 83.1856 22.0518 82.8513 21.9794 82.4874C21.907 82.1234 21.9442 81.7462 22.0862 81.4033C22.2282 81.0605 22.4687 80.7675 22.7772 80.5613C23.0857 80.3552 23.4485 80.2451 23.8196 80.2451C24.3172 80.2451 24.7944 80.4428 25.1462 80.7946C25.4981 81.1465 25.6958 81.6237 25.6958 82.1213Z\" fill=#FF725E /><path d=\"M127.252 40.3833C128.288 40.3833 129.128 39.5433 129.128 38.5071C129.128 37.4709 128.288 36.6309 127.252 36.6309C126.216 36.6309 125.376 37.4709 125.376 38.5071C125.376 39.5433 126.216 40.3833 127.252 40.3833Z\" fill=#FF725E /><path d=\"M231.086 62.6489C232.122 62.6489 232.962 61.8089 232.962 60.7727C232.962 59.7365 232.122 58.8965 231.086 58.8965C230.05 58.8965 229.21 59.7365 229.21 60.7727C229.21 61.8089 230.05 62.6489 231.086 62.6489Z\" fill=#FF725E /><path d=\"M201.493 138.703C201.559 138.769 201.611 138.847 201.647 138.934C201.683 139.02 201.701 139.112 201.701 139.206C201.701 139.299 201.683 139.392 201.647 139.478C201.611 139.564 201.559 139.643 201.493 139.709C201.428 139.776 201.35 139.829 201.265 139.865C201.179 139.901 201.087 139.92 200.994 139.92C200.9 139.92 200.808 139.901 200.723 139.865C200.637 139.829 200.559 139.776 200.494 139.709C200.378 139.573 200.317 139.399 200.324 139.22C200.33 139.042 200.404 138.872 200.53 138.745C200.655 138.619 200.824 138.544 201.003 138.536C201.181 138.528 201.356 138.588 201.493 138.703Z\" fill=#FF725E /><path d=\"M267.951 90.3517C268.049 90.4503 268.115 90.5757 268.142 90.7121C268.169 90.8484 268.155 90.9896 268.101 91.1179C268.048 91.2461 267.958 91.3557 267.842 91.4328C267.726 91.5099 267.591 91.551 267.452 91.551C267.313 91.551 267.177 91.5099 267.061 91.4328C266.946 91.3557 266.855 91.2461 266.802 91.1179C266.749 90.9896 266.734 90.8484 266.761 90.7121C266.788 90.5757 266.854 90.4503 266.952 90.3517C267.017 90.2849 267.095 90.2318 267.181 90.1956C267.266 90.1593 267.359 90.1406 267.452 90.1406C267.545 90.1406 267.637 90.1593 267.723 90.1956C267.808 90.2318 267.886 90.2849 267.951 90.3517Z\" fill=#FF725E /><path d=\"M172.238 60.1137C172.63 60.1137 172.949 59.7953 172.949 59.4025C172.949 59.0098 172.63 58.6914 172.238 58.6914C171.845 58.6914 171.526 59.0098 171.526 59.4025C171.526 59.7953 171.845 60.1137 172.238 60.1137Z\" fill=#FF725E /><path d=\"M267.454 20.8413C267.554 20.9408 267.621 21.0675 267.649 21.2055C267.676 21.3434 267.662 21.4864 267.608 21.6163C267.554 21.7462 267.463 21.8572 267.346 21.9353C267.229 22.0134 267.092 22.0551 266.951 22.0551C266.811 22.0551 266.673 22.0134 266.556 21.9353C266.439 21.8572 266.348 21.7462 266.294 21.6163C266.241 21.4864 266.226 21.3434 266.254 21.2055C266.281 21.0675 266.349 20.9408 266.448 20.8413C266.514 20.7752 266.593 20.7228 266.679 20.687C266.765 20.6512 266.858 20.6328 266.951 20.6328C267.045 20.6328 267.137 20.6512 267.224 20.687C267.31 20.7228 267.388 20.7752 267.454 20.8413Z\" fill=#FF725E /><path d=\"M316.96 136.554C317.061 136.653 317.13 136.78 317.158 136.918C317.186 137.056 317.173 137.2 317.119 137.33C317.066 137.461 316.974 137.572 316.857 137.651C316.74 137.729 316.602 137.771 316.461 137.771C316.32 137.771 316.182 137.729 316.065 137.651C315.948 137.572 315.857 137.461 315.803 137.33C315.75 137.2 315.736 137.056 315.764 136.918C315.793 136.78 315.861 136.653 315.962 136.554C316.027 136.487 316.104 136.434 316.19 136.398C316.276 136.361 316.368 136.343 316.461 136.343C316.554 136.343 316.646 136.361 316.732 136.398C316.818 136.434 316.896 136.487 316.96 136.554Z\" fill=#FF725E /><path d=\"M70.4742 28.9751C70.5893 29.1117 70.6489 29.2866 70.641 29.4651C70.6331 29.6436 70.5583 29.8125 70.4315 29.9384C70.3047 30.0642 70.1352 30.1377 69.9566 30.1443C69.7781 30.1509 69.6036 30.09 69.468 29.9738C69.4012 29.9089 69.348 29.8313 69.3118 29.7455C69.2755 29.6597 69.2568 29.5676 69.2568 29.4744C69.2568 29.3813 69.2755 29.2892 69.3118 29.2034C69.348 29.1176 69.4012 29.04 69.468 28.9751C69.534 28.909 69.6124 28.8566 69.6988 28.8208C69.7851 28.785 69.8776 28.7666 69.9711 28.7666C70.0645 28.7666 70.157 28.785 70.2434 28.8208C70.3297 28.8566 70.4081 28.909 70.4742 28.9751Z\" fill=#FF725E /><path d=\"M8.82443 138.271C9.21718 138.271 9.53557 137.953 9.53557 137.56C9.53557 137.167 9.21718 136.849 8.82443 136.849C8.43167 136.849 8.11328 137.167 8.11328 137.56C8.11328 137.953 8.43167 138.271 8.82443 138.271Z\" fill=#FF725E /><path d=\"M1.21376 49.5977C1.27986 49.6637 1.33231 49.7422 1.36809 49.8285C1.40387 49.9148 1.42229 50.0073 1.42229 50.1008C1.42229 50.1942 1.40387 50.2868 1.36809 50.3731C1.33231 50.4594 1.27986 50.5378 1.21376 50.6039C1.11427 50.7033 0.987559 50.7709 0.84963 50.7983C0.7117 50.8257 0.568748 50.8116 0.438843 50.7577C0.308939 50.7039 0.197916 50.6127 0.119804 50.4958C0.0416934 50.3789 0 50.2414 0 50.1008C0 49.9602 0.0416934 49.8227 0.119804 49.7058C0.197916 49.5888 0.308939 49.4977 0.438843 49.4438C0.568748 49.39 0.7117 49.3759 0.84963 49.4033C0.987559 49.4306 1.11427 49.4983 1.21376 49.5977Z\" fill=#FF725E /><path d=\"M170.494 16.256C170.414 16.3034 170.325 16.3343 170.232 16.347C170.14 16.3597 170.046 16.3539 169.956 16.3299C169.866 16.306 169.782 16.2644 169.708 16.2076C169.634 16.1507 169.572 16.0797 169.526 15.9988C169.469 15.9181 169.43 15.8266 169.41 15.7299C169.391 15.6333 169.392 15.5337 169.413 15.4374C169.434 15.3411 169.475 15.2503 169.533 15.1707C169.591 15.0911 169.665 15.0244 169.751 14.975C169.836 14.9255 169.931 14.8943 170.029 14.8833C170.126 14.8724 170.226 14.8819 170.32 14.9113C170.414 14.9407 170.501 14.9893 170.575 15.0541C170.649 15.1189 170.709 15.1984 170.751 15.2876C170.799 15.3679 170.83 15.4569 170.842 15.5492C170.855 15.6416 170.849 15.7355 170.825 15.8256C170.801 15.9157 170.76 16.0002 170.703 16.0741C170.646 16.1479 170.575 16.2098 170.494 16.256Z\" fill=#FF725E /><path d=\"M312.733 36.6301C312.733 37.0012 312.623 37.3639 312.417 37.6725C312.211 37.981 311.917 38.2215 311.575 38.3635C311.232 38.5055 310.855 38.5427 310.491 38.4703C310.127 38.3979 309.792 38.2192 309.53 37.9568C309.268 37.6944 309.089 37.3601 309.017 36.9961C308.944 36.6322 308.981 36.255 309.123 35.9121C309.265 35.5693 309.506 35.2763 309.814 35.0701C310.123 34.8639 310.486 34.7539 310.857 34.7539C311.103 34.7539 311.347 34.8024 311.575 34.8967C311.802 34.991 312.009 35.1292 312.183 35.3034C312.358 35.4777 312.496 35.6845 312.59 35.9121C312.684 36.1398 312.733 36.3837 312.733 36.6301Z\" fill=#FF725E /><path d=\"M204.88 5.10593C205.916 5.10593 206.756 4.26593 206.756 3.22972C206.756 2.19352 205.916 1.35352 204.88 1.35352C203.844 1.35352 203.004 2.19352 203.004 3.22972C203.004 4.26593 203.844 5.10593 204.88 5.10593Z\" fill=#FF725E /><path d=\"M234.226 123.715C234.226 124.086 234.116 124.449 233.91 124.757C233.704 125.066 233.411 125.306 233.068 125.448C232.725 125.59 232.348 125.628 231.984 125.555C231.62 125.483 231.286 125.304 231.023 125.042C230.761 124.779 230.582 124.445 230.51 124.081C230.437 123.717 230.474 123.34 230.616 122.997C230.758 122.654 230.999 122.361 231.307 122.155C231.616 121.949 231.979 121.839 232.35 121.839C232.847 121.839 233.325 122.037 233.676 122.388C234.028 122.74 234.226 123.217 234.226 123.715Z\" fill=#FF725E /><path d=\"M117.804 109.888C119.807 109.888 121.43 108.265 121.43 106.262C121.43 104.259 119.807 102.636 117.804 102.636C115.801 102.636 114.178 104.259 114.178 106.262C114.178 108.265 115.801 109.888 117.804 109.888Z\" fill=#FF725E /><path d=\"M108.57 98.0323C109.132 97.8812 109.722 97.8646 110.292 97.984C111.686 98.1707 113.008 98.7138 114.131 99.5608C115.254 100.408 116.14 101.53 116.703 102.819C116.971 103.333 117.114 103.903 117.119 104.482C116.842 103.994 116.593 103.491 116.374 102.974C115.765 101.786 114.897 100.749 113.835 99.9407C112.772 99.1324 111.541 98.5727 110.234 98.3031C109.675 98.2441 109.119 98.1537 108.57 98.0323Z\" fill=#263238 /><path d=\"M116.113 104.5C116.171 104.375 116.567 104.413 116.964 104.191C117.36 103.969 117.544 103.63 117.689 103.64C117.834 103.65 117.795 103.795 117.737 104.007C117.645 104.276 117.455 104.5 117.206 104.636C116.954 104.77 116.661 104.808 116.384 104.742C116.171 104.675 116.084 104.559 116.113 104.5Z\" fill=#263238 /><path d=\"M120.348 107.818C120.555 106.937 120.555 106.02 120.348 105.14C119.846 103.728 118.608 103.205 118.685 103.041C118.762 102.877 119.053 103.041 119.517 103.321C120.122 103.714 120.581 104.296 120.822 104.976C121.064 105.656 121.074 106.397 120.851 107.083C120.639 107.605 120.406 107.886 120.348 107.818Z\" fill=white /><path d=\"M149.514 105.063C149.514 106.073 149.215 107.06 148.654 107.9C148.093 108.739 147.296 109.394 146.363 109.78C145.43 110.167 144.403 110.268 143.413 110.071C142.422 109.874 141.512 109.387 140.798 108.673C140.084 107.959 139.598 107.049 139.401 106.059C139.204 105.069 139.305 104.042 139.691 103.109C140.078 102.176 140.732 101.379 141.572 100.818C142.412 100.257 143.399 99.957 144.409 99.957C145.762 99.9596 147.059 100.498 148.016 101.455C148.973 102.412 149.512 103.71 149.514 105.063Z\" fill=#FF725E /><path d=\"M157.412 93.4684C157.412 93.5458 156.445 93.5264 155.062 93.8165C153.202 94.1836 151.451 94.9714 149.942 96.1196C148.434 97.2677 147.208 98.7458 146.359 100.441C145.691 101.736 145.469 102.636 145.392 102.607C145.443 101.796 145.663 101.006 146.039 100.286C146.837 98.4833 148.078 96.9124 149.647 95.7201C151.217 94.5278 153.063 93.7531 155.013 93.4684C155.804 93.297 156.621 93.297 157.412 93.4684Z\" fill=#455A64 /><path d=\"M146.796 102.567C146.796 102.625 146.69 102.76 146.4 102.837C146.029 102.907 145.646 102.849 145.313 102.673C144.98 102.498 144.715 102.215 144.563 101.87C144.475 101.59 144.514 101.406 144.563 101.397C144.611 101.387 144.92 101.938 145.53 102.257C146.139 102.576 146.738 102.441 146.796 102.567Z\" fill=#263238 /><path d=\"M140.818 107.249C140.77 107.249 140.46 106.92 140.228 106.194C139.942 105.245 139.965 104.229 140.296 103.293C140.627 102.353 141.255 101.545 142.085 100.992C142.713 100.576 143.187 100.489 143.207 100.537C143.226 100.586 142.83 100.818 142.298 101.272C141.605 101.851 141.079 102.604 140.777 103.455C140.474 104.305 140.405 105.221 140.576 106.107C140.702 106.804 140.876 107.21 140.818 107.249Z\" fill=white /><path d=\"M107.739 109.626H156.032V155.182H104.828V112.527C104.828 112.145 104.903 111.767 105.05 111.415C105.196 111.062 105.411 110.742 105.681 110.472C105.952 110.203 106.273 109.989 106.626 109.844C106.979 109.699 107.357 109.625 107.739 109.626Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M106.684 112.385C122.427 112.578 137.725 111.592 153.468 111.785L156.012 113.497L156.07 121.001C156.07 121.001 154.987 121.426 154.677 120.614C154.448 119.66 154.448 118.666 154.677 117.713C153.759 117.104 153.217 117.916 152.743 118.931C152.395 119.984 152.273 121.097 152.385 122.2C152.434 122.752 152.363 123.308 152.178 123.83C151.992 124.352 151.697 124.828 151.312 125.227C150.799 125.563 150.195 125.733 149.582 125.712C148.969 125.691 148.377 125.481 147.889 125.111C146.929 124.344 146.144 123.382 145.587 122.287C144.803 120.741 143.71 119.372 142.377 118.264C141.702 117.722 140.881 117.396 140.019 117.327C139.156 117.258 138.293 117.449 137.542 117.877C136.014 118.941 135.443 121.31 133.673 121.745C131.565 122.21 129.805 119.57 127.678 119.705C125.87 119.821 124.835 121.774 124.052 123.418C123.268 125.062 121.905 126.919 120.116 126.609C117.737 126.194 117.137 122.345 114.739 122.103C112.902 121.919 111.703 124.037 110.001 124.714C109.103 125.016 108.13 125.008 107.237 124.691C106.344 124.373 105.584 123.765 105.079 122.964C104.599 122.148 104.291 121.242 104.175 120.302C104.058 119.362 104.136 118.409 104.402 117.5C104.945 115.692 105.736 113.967 106.752 112.375\" fill=black /></g><path d=\"M156.194 109.444C155.273 109.076 154.282 108.918 153.293 108.98C137.995 108.786 123.093 109.676 107.843 109.618C106.9 109.613 105.976 109.879 105.18 110.385C104.385 110.891 103.751 111.615 103.356 112.471C102.986 113.25 102.691 114.063 102.476 114.898C102.201 115.837 102.121 116.822 102.24 117.794C102.36 118.765 102.677 119.701 103.172 120.545C103.696 121.371 104.482 121.998 105.404 122.326C106.326 122.654 107.331 122.664 108.259 122.354C110.019 121.619 111.266 119.453 113.162 119.656C115.647 119.907 116.266 123.882 118.722 124.307C120.83 124.675 122.368 122.141 123.093 120.333C123.411 119.463 123.936 118.683 124.621 118.06C127.831 115.304 129.978 119.897 132.753 119.288C134.63 118.863 135.219 116.387 136.796 115.314C137.574 114.871 138.468 114.672 139.361 114.743C140.254 114.814 141.105 115.151 141.805 115.71C143.18 116.861 144.311 118.275 145.131 119.868C145.706 120.996 146.517 121.985 147.51 122.769C148.014 123.155 148.626 123.375 149.26 123.397C149.894 123.42 150.52 123.244 151.05 122.895C151.449 122.484 151.755 121.991 151.946 121.45C152.136 120.909 152.206 120.333 152.152 119.762C152.042 118.62 152.17 117.467 152.529 116.377C153.003 115.343 154.357 114.588 155.314 115.217C155.072 116.094 155.072 117.019 155.314 117.896C155.447 118.328 155.74 118.694 156.134 118.917C156.528 119.14 156.992 119.204 157.432 119.095C158.322 118.747 158.525 117.596 158.592 116.629C158.786 113.96 158.631 110.614 156.194 109.444Z\" fill=#FF725E /><path d=\"M130.823 81.7763C130.26 81.6291 129.741 81.3468 129.312 80.9539C128.883 80.561 128.556 80.0694 128.36 79.5216C128.164 78.9739 128.104 78.3865 128.186 77.8105C128.268 77.2345 128.489 76.6872 128.831 76.216C129.566 75.2489 130.832 74.572 131.239 73.3923C131.376 72.7753 131.461 72.1477 131.49 71.5162C131.505 71.206 131.603 70.9054 131.773 70.6454C131.943 70.3854 132.179 70.1753 132.457 70.0367C132.727 69.9745 133.01 69.9916 133.27 70.086C133.531 70.1803 133.759 70.3479 133.927 70.5686C134.249 71.0152 134.47 71.5267 134.575 72.0674C135.112 73.9641 135.112 75.9729 134.575 77.8696C134.346 78.7955 133.872 79.6428 133.203 80.3232C132.535 81.0036 131.696 81.4921 130.774 81.7377\" fill=#FF725E /><path d=\"M132.59 83.2656H128.944V109.288H132.59V83.2656Z\" fill=#455A64 /><path d=\"M132.552 85.498C132.031 86.0396 131.462 86.5316 130.85 86.9679C130.282 87.4612 129.671 87.9014 129.022 88.2831C129.543 87.7417 130.113 87.2497 130.724 86.8132C131.29 86.3174 131.902 85.877 132.552 85.498Z\" fill=#263238 /><path d=\"M132.552 90.083C132.031 90.6245 131.462 91.1166 130.85 91.5529C130.282 92.0461 129.671 92.4864 129.022 92.868C129.548 92.3466 130.118 91.871 130.724 91.4465C131.291 90.9378 131.903 90.4814 132.552 90.083Z\" fill=#263238 /><path d=\"M132.552 94.667C131.467 95.7055 130.285 96.6381 129.022 97.452C129.546 96.9138 130.116 96.422 130.724 95.9822C131.296 95.494 131.908 95.0541 132.552 94.667Z\" fill=#263238 /><path d=\"M132.552 99.2607C132.026 99.7961 131.456 100.288 130.85 100.731C130.276 101.216 129.665 101.656 129.022 102.046C129.542 101.5 130.111 101.004 130.724 100.566C131.292 100.075 131.904 99.6382 132.552 99.2607Z\" fill=#263238 /><path d=\"M132.552 103.843C132.026 104.378 131.456 104.87 130.85 105.313C130.279 105.802 129.668 106.242 129.022 106.628C129.54 106.083 130.11 105.591 130.724 105.158C131.29 104.662 131.902 104.222 132.552 103.843Z\" fill=#263238 /><path d=\"M130.831 79.127C130.973 80.5643 130.973 82.0122 130.831 83.4495C130.702 82.0116 130.702 80.5649 130.831 79.127Z\" fill=#263238 /><path d=\"M76.3545 155.271C75.5806 154.385 75.1721 153.238 75.2116 152.062C75.2511 150.886 75.7356 149.769 76.5672 148.937C77.6073 148.174 78.7105 147.501 79.8648 146.926C80.9575 146.229 81.9245 144.992 81.6634 143.764C81.4893 142.874 80.6964 142.081 80.8898 141.191C81.0221 140.764 81.3144 140.405 81.7055 140.189C82.0967 139.973 82.5563 139.916 82.9882 140.031C83.8527 140.284 84.6101 140.814 85.1447 141.539C87.1433 143.866 88.4055 146.733 88.771 149.778C88.9451 151.248 88.5293 153.966 87.4752 155C85.9421 155.144 84.4016 155.193 82.8625 155.145\" fill=#FF725E /><path d=\"M94.3459 155.271C93.5687 154.387 93.157 153.241 93.1948 152.064C93.2325 150.888 93.7167 149.77 94.549 148.937C95.5911 148.172 96.6977 147.499 97.8562 146.926C98.9393 146.23 99.9063 144.992 99.6549 143.764C99.4711 142.874 98.6879 142.081 98.8716 141.192C99.0059 140.764 99.3001 140.405 99.6928 140.188C100.086 139.972 100.546 139.916 100.98 140.031C101.84 140.287 102.594 140.817 103.126 141.54C105.125 143.866 106.387 146.734 106.753 149.779C106.927 151.249 106.521 153.966 105.467 155.001C103.934 155.144 102.393 155.193 100.854 155.146\" fill=#FF725E /><path d=\"M112.322 155.271C111.548 154.385 111.14 153.238 111.179 152.062C111.219 150.886 111.703 149.769 112.535 148.937C113.574 148.172 114.677 147.499 115.833 146.926C116.916 146.229 117.892 144.992 117.631 143.764C117.457 142.874 116.664 142.081 116.858 141.191C116.99 140.764 117.282 140.405 117.673 140.189C118.064 139.973 118.524 139.916 118.956 140.031C119.819 140.287 120.576 140.816 121.112 141.539C123.111 143.866 124.373 146.733 124.739 149.778C124.913 151.248 124.497 153.966 123.443 155C121.91 155.144 120.369 155.193 118.83 155.145\" fill=#FF725E /><path d=\"M130.308 155.271C129.531 154.387 129.119 153.241 129.157 152.064C129.194 150.888 129.679 149.77 130.511 148.937C131.553 148.172 132.66 147.499 133.818 146.926C134.901 146.23 135.868 144.992 135.617 143.764C135.433 142.874 134.65 142.081 134.834 141.192C134.968 140.764 135.262 140.405 135.655 140.188C136.047 139.972 136.508 139.916 136.942 140.031C137.802 140.287 138.556 140.817 139.088 141.54C141.087 143.866 142.349 146.734 142.715 149.779C142.889 151.249 142.483 153.966 141.429 155.001C139.896 155.144 138.355 155.193 136.816 155.146\" fill=#FF725E /><path d=\"M148.285 155.271C147.511 154.385 147.103 153.238 147.142 152.062C147.182 150.886 147.666 149.769 148.498 148.937C149.537 148.172 150.64 147.499 151.795 146.926C152.878 146.229 153.855 144.992 153.594 143.764C153.41 142.874 152.627 142.081 152.82 141.191C152.953 140.764 153.245 140.405 153.636 140.189C154.027 139.973 154.487 139.916 154.919 140.031C155.782 140.287 156.539 140.816 157.075 141.539C159.074 143.866 160.336 146.733 160.702 149.778C160.866 151.248 160.46 153.966 159.406 155C157.873 155.144 156.332 155.193 154.793 155.145\" fill=#FF725E /><path d=\"M166.263 155.271C165.489 154.385 165.08 153.238 165.12 152.062C165.159 150.887 165.644 149.77 166.475 148.937C167.518 148.172 168.624 147.499 169.783 146.926C170.866 146.23 171.833 144.992 171.581 143.764C171.398 142.874 170.614 142.081 170.798 141.192C170.932 140.764 171.227 140.405 171.619 140.188C172.012 139.972 172.473 139.916 172.906 140.031C173.767 140.287 174.52 140.817 175.053 141.54C177.052 143.866 178.314 146.734 178.679 149.779C178.853 151.249 178.447 153.966 177.383 155.001C175.854 155.144 174.316 155.193 172.78 155.146\" fill=#FF725E /><g opacity=0.8><path opacity=0.8 d=\"M76.3545 155.271C75.5806 154.385 75.1721 153.238 75.2116 152.062C75.2511 150.886 75.7356 149.769 76.5672 148.937C77.6073 148.174 78.7105 147.501 79.8648 146.926C80.9575 146.229 81.9245 144.992 81.6634 143.764C81.4893 142.874 80.6964 142.081 80.8898 141.191C81.0221 140.764 81.3144 140.405 81.7055 140.189C82.0967 139.973 82.5563 139.916 82.9882 140.031C83.8527 140.284 84.6101 140.814 85.1447 141.539C87.1433 143.866 88.4055 146.733 88.771 149.778C88.9451 151.248 88.5293 153.966 87.4752 155C85.9421 155.144 84.4016 155.193 82.8625 155.145\" fill=white /><path opacity=0.8 d=\"M94.3401 155.271C93.5628 154.387 93.1512 153.241 93.1889 152.064C93.2266 150.888 93.7108 149.77 94.5431 148.937C95.5852 148.172 96.6918 147.499 97.8504 146.926C98.9334 146.23 99.9004 144.992 99.649 143.764C99.4653 142.874 98.682 142.081 98.8657 141.192C99.0001 140.764 99.2943 140.405 99.687 140.188C100.08 139.972 100.541 139.916 100.974 140.031C101.834 140.287 102.588 140.817 103.121 141.54C105.119 143.866 106.381 146.734 106.747 149.779C106.921 151.249 106.515 153.966 105.461 155.001C103.928 155.144 102.387 155.193 100.848 155.146\" fill=white /><path opacity=0.8 d=\"M112.317 155.271C111.543 154.385 111.135 153.238 111.174 152.062C111.214 150.886 111.699 149.769 112.53 148.937C113.569 148.172 114.672 147.499 115.828 146.926C116.911 146.229 117.887 144.992 117.626 143.764C117.452 142.874 116.659 142.081 116.853 141.191C116.985 140.764 117.277 140.405 117.668 140.189C118.06 139.973 118.519 139.916 118.951 140.031C119.814 140.287 120.571 140.816 121.108 141.539C123.106 143.866 124.368 146.733 124.734 149.778C124.908 151.248 124.492 153.966 123.438 155C121.905 155.144 120.364 155.193 118.825 155.145\" fill=white /><path opacity=0.8 d=\"M130.306 155.271C129.529 154.387 129.117 153.241 129.155 152.064C129.192 150.888 129.677 149.77 130.509 148.937C131.551 148.172 132.658 147.499 133.816 146.926C134.899 146.23 135.866 144.992 135.615 143.764C135.431 142.874 134.648 142.081 134.832 141.192C134.966 140.764 135.26 140.405 135.653 140.188C136.045 139.972 136.506 139.916 136.94 140.031C137.8 140.287 138.554 140.817 139.086 141.54C141.085 143.866 142.347 146.734 142.713 149.779C142.887 151.249 142.481 153.966 141.427 155.001C139.894 155.144 138.353 155.193 136.814 155.146\" fill=white /><path opacity=0.8 d=\"M148.282 155.271C147.508 154.385 147.1 153.238 147.139 152.062C147.179 150.886 147.663 149.769 148.495 148.937C149.534 148.172 150.637 147.499 151.792 146.926C152.876 146.229 153.852 144.992 153.591 143.764C153.407 142.874 152.624 142.081 152.818 141.191C152.95 140.764 153.242 140.405 153.633 140.189C154.024 139.973 154.484 139.916 154.916 140.031C155.779 140.287 156.536 140.816 157.072 141.539C159.071 143.866 160.333 146.733 160.699 149.778C160.863 151.248 160.457 153.966 159.403 155C157.87 155.144 156.329 155.193 154.79 155.145\" fill=white /><path opacity=0.8 d=\"M166.26 155.271C165.486 154.385 165.077 153.238 165.117 152.062C165.156 150.887 165.641 149.77 166.472 148.937C167.515 148.172 168.621 147.499 169.78 146.926C170.863 146.23 171.83 144.992 171.578 143.764C171.395 142.874 170.611 142.081 170.795 141.192C170.929 140.764 171.224 140.405 171.616 140.188C172.009 139.972 172.47 139.916 172.903 140.031C173.764 140.287 174.517 140.817 175.05 141.54C177.049 143.866 178.311 146.734 178.676 149.779C178.85 151.249 178.444 153.966 177.38 155.001C175.851 155.144 174.313 155.193 172.777 155.146\" fill=white /></g><path d=\"M190.514 155.183H68.7754V208.93H190.514V155.183Z\" fill=#FF725E /><path d=\"M221.904 277.975H37V287.877H221.904V277.975Z\" fill=#263238 /><g opacity=0.3><path opacity=0.3 d=\"M65.4528 274.698C65.4528 274.824 64.7952 274.766 64.0796 274.543C63.3641 274.321 62.8032 274.05 62.8515 273.915C62.8999 273.779 63.4995 273.847 64.2247 274.06C64.95 274.273 65.4528 274.563 65.4528 274.698Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M81.0773 274.215C81.1643 274.322 80.9419 274.65 80.5841 274.931C80.2263 275.211 79.8588 275.366 79.7718 275.26C79.6848 275.153 79.9072 274.825 80.265 274.544C80.6228 274.264 80.9903 274.09 81.0773 274.215Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M99.8363 274.659C99.7203 274.736 99.3915 274.456 99.1014 274.03C98.8112 273.605 98.6662 273.189 98.7822 273.111C98.8983 273.034 99.2271 273.315 99.5172 273.75C99.8073 274.185 99.9524 274.581 99.8363 274.659Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M120.035 271.545C120.161 271.622 119.958 272.144 119.6 272.715C119.242 273.285 118.846 273.682 118.73 273.624C118.614 273.566 118.807 273.024 119.175 272.444C119.542 271.864 119.919 271.467 120.035 271.545Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M132.833 275.732C132.736 275.829 132.369 275.626 132.011 275.258C131.653 274.891 131.44 274.533 131.537 274.436C131.634 274.339 132.001 274.542 132.359 274.91C132.717 275.277 132.93 275.635 132.833 275.732Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M151.053 275.182C151.053 275.327 150.695 275.433 150.27 275.433C149.844 275.433 149.486 275.327 149.486 275.182C149.486 275.037 149.834 274.931 150.27 274.931C150.705 274.931 151.053 275.076 151.053 275.182Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M169.258 272.348C169.326 272.474 168.978 272.802 168.475 273.092C167.972 273.383 167.508 273.518 167.44 273.392C167.372 273.267 167.72 272.938 168.223 272.657C168.726 272.377 169.19 272.28 169.258 272.348Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M191.898 274.958C191.898 275.084 191.801 275.248 191.589 275.326C191.376 275.403 191.163 275.326 191.115 275.21C191.066 275.094 191.211 274.92 191.424 274.842C191.637 274.765 191.85 274.823 191.898 274.958Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M198.899 272.068C198.926 272.135 198.925 272.209 198.898 272.276C198.871 272.342 198.82 272.396 198.754 272.426C198.691 272.461 198.617 272.471 198.546 272.453C198.476 272.435 198.415 272.391 198.377 272.329C198.353 272.262 198.355 272.188 198.382 272.122C198.408 272.056 198.458 272.003 198.522 271.971C198.585 271.935 198.66 271.925 198.73 271.943C198.801 271.961 198.861 272.006 198.899 272.068Z\" fill=black /></g><path d=\"M60.0544 207.635H203.29C203.982 207.635 204.646 207.91 205.136 208.4C205.626 208.889 205.901 209.553 205.901 210.246V275.365C205.901 276.057 205.626 276.722 205.136 277.211C204.646 277.701 203.982 277.976 203.29 277.976H55.6061C54.9136 277.976 54.2495 277.701 53.7598 277.211C53.2702 276.722 52.9951 276.057 52.9951 275.365V214.694C52.9939 213.767 53.1756 212.848 53.5299 211.991C53.8842 211.134 54.4041 210.355 55.0599 209.7C55.7157 209.044 56.4944 208.524 57.3514 208.17C58.2085 207.815 59.127 207.633 60.0544 207.635Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M204.364 266.547C171.486 265.241 138.472 263.936 105.612 266.16C90.6717 267.127 75.5184 268.897 60.81 265.986C59.1438 265.517 57.3973 265.405 55.6848 265.657C55.0893 265.799 54.5295 266.062 54.0409 266.431C53.7518 266.643 53.5301 266.935 53.4024 267.27C53.2747 267.606 53.2464 267.971 53.3209 268.322C53.3954 268.673 53.5696 268.995 53.8224 269.25C54.0753 269.504 54.3963 269.681 54.7468 269.757C80.1601 274.989 106.279 268.094 132.302 269.284C141.005 269.68 149.708 270.966 158.47 270.589C164.455 270.328 170.383 269.303 176.369 268.955C185.691 268.423 195.071 269.564 204.364 268.645C205.119 268.578 206.086 268.22 206.008 267.466C205.931 266.711 205.051 266.576 204.364 266.547Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M52.8027 230.911C54.1064 231.81 55.6455 232.306 57.2288 232.338C58.8122 232.37 60.3701 231.936 61.7091 231.091C63.0481 230.245 64.1092 229.025 64.7608 227.581C65.4123 226.138 65.6256 224.535 65.374 222.971C66.1242 224.173 67.2705 225.076 68.6151 225.523C69.9596 225.97 71.418 225.933 72.7386 225.42C74.0591 224.906 75.159 223.948 75.8483 222.71C76.5376 221.472 76.7731 220.032 76.5141 218.639C77.6234 219.657 79.0847 220.203 80.5896 220.164C82.0945 220.124 83.525 219.501 84.5791 218.426C85.3817 217.546 85.9426 216.386 87.0063 215.854C88.6792 215.013 90.7873 216.25 91.619 217.933C92.4506 219.616 92.4119 221.579 92.5087 223.455C92.6054 225.331 92.9341 227.323 94.288 228.648C95.6418 229.973 98.3108 229.944 99.0747 228.222C99.5195 227.255 99.4035 225.756 100.429 225.408C101.212 225.147 101.995 225.863 102.305 226.617C102.505 227.413 102.757 228.194 103.059 228.957C103.9 230.446 106.057 230.717 107.604 229.992C109.088 229.137 110.337 227.927 111.24 226.472C110.854 228.685 110.936 230.955 111.482 233.135C112.178 235.272 114.073 237.187 116.317 237.158C119.218 237.158 121.152 234.131 121.703 231.355C122.254 228.58 122.119 225.553 123.366 222.942C124.14 221.356 125.881 219.916 127.534 220.505C129.333 221.153 129.749 223.677 131.402 224.615C133.414 225.747 135.822 223.977 137.204 222.111C138.587 220.244 139.854 217.952 142.117 217.556C144.38 217.16 146.72 219.19 147.726 221.424C148.731 223.658 149.002 226.172 150.104 228.358C151.207 230.543 153.644 232.419 155.974 231.665C157.908 231.046 158.875 229.006 160.045 227.371C161.216 225.737 163.478 224.315 165.132 225.437C166.786 226.559 166.699 229.305 168.526 229.837C170.789 230.475 171.959 226.878 174.222 226.23C177.365 225.321 179.057 230.34 182.239 231.172C184.83 231.858 187.238 229.441 188.234 226.955C189.23 224.47 189.52 221.656 191.135 219.519C192.75 217.382 196.522 216.56 197.904 218.861C198.436 219.761 198.436 220.873 198.871 221.821C199.983 224.209 204.935 224.422 205.969 222.004V211.551H53.0058L52.8027 230.911Z\" fill=black /></g><path d=\"M204.448 264.542C171.193 263.237 137.879 261.931 104.671 264.155C89.5759 265.122 74.268 266.892 59.4145 263.981C57.7285 263.512 55.963 263.4 54.2312 263.652C53.6297 263.794 53.0636 264.057 52.568 264.426C52.2788 264.639 52.0574 264.931 51.9303 265.267C51.8032 265.604 51.7758 265.969 51.8513 266.32C51.9269 266.672 52.1022 266.994 52.3563 267.248C52.6103 267.502 52.9323 267.677 53.2836 267.753C78.958 272.984 105.348 266.089 131.612 267.279C140.432 267.675 149.231 268.961 158.051 268.584C164.104 268.323 170.09 267.298 176.134 266.95C185.553 266.418 195.039 267.559 204.419 266.64C205.183 266.573 206.17 266.215 206.083 265.461C205.996 264.706 205.135 264.542 204.448 264.542Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M54.8142 250.327L97.5275 251.468C111.066 251.836 124.701 252.193 138.142 250.501C150.859 248.886 163.536 245.415 176.291 246.633C182.045 247.165 187.683 248.644 193.437 249.118C198.378 249.534 201.057 250.462 205.892 248.258V245.608C193.253 245.608 182.683 244.196 170.248 244.187C156.99 244.187 143.887 245.685 130.6 245.676H57.6765C56.2636 245.56 54.8442 245.799 53.5474 246.372C53.2062 246.658 52.9579 247.04 52.8343 247.468C52.7106 247.896 52.7171 248.351 52.853 248.775C52.9889 249.199 53.2479 249.573 53.5972 249.85C53.9465 250.126 54.3701 250.292 54.8142 250.327Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M67.9439 258.539C67.8666 258.655 67.3831 258.432 66.8706 258.055C66.358 257.678 66.0002 257.282 66.0873 257.166C66.1743 257.05 66.6481 257.272 67.1607 257.649C67.6732 258.026 68.031 258.423 67.9439 258.539Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M81.339 255.269C81.2327 255.182 81.339 254.911 81.4841 254.669C81.6291 254.428 81.9193 254.302 82.0256 254.379C82.132 254.457 82.074 254.737 81.8806 254.979C81.6872 255.221 81.4551 255.356 81.339 255.269Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M98.4527 259.601C98.3463 259.697 98.0369 259.504 97.6888 259.282C97.3406 259.059 97.0409 258.856 97.0795 258.721C97.1182 258.585 97.534 258.585 97.9595 258.856C98.385 259.127 98.5591 259.514 98.4527 259.601Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M107.399 253.819C107.486 253.935 107.244 254.254 106.857 254.544C106.471 254.834 106.094 254.989 106.007 254.873C105.919 254.757 106.171 254.438 106.558 254.148C106.944 253.858 107.322 253.713 107.399 253.819Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M124.67 257.95C124.544 258.008 124.312 257.795 124.148 257.466C123.983 257.137 123.954 256.828 124.08 256.76C124.206 256.693 124.438 256.915 124.602 257.244C124.766 257.572 124.786 257.882 124.67 257.95Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M150.131 252.94C150.208 253.056 150.005 253.327 149.676 253.549C149.347 253.772 149.028 253.849 148.951 253.733C148.874 253.617 149.077 253.346 149.406 253.124C149.734 252.901 150.053 252.805 150.131 252.94Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M169.519 258.307C169.383 258.365 169.035 257.853 168.484 257.34C167.933 256.828 167.391 256.586 167.44 256.441C167.488 256.296 168.174 256.441 168.822 256.963C169.47 257.485 169.644 258.259 169.519 258.307Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M187.185 249.428C187.282 249.525 186.905 250.125 186.325 250.773C185.745 251.421 185.203 251.865 185.097 251.74C184.99 251.614 185.377 251.053 185.957 250.405C186.538 249.757 187.079 249.341 187.185 249.428Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M196.879 257.492C196.754 257.56 196.425 257.183 195.912 257.009C195.4 256.835 194.878 256.912 194.82 256.786C194.762 256.661 195.322 256.274 196.077 256.535C196.831 256.796 197.015 257.454 196.879 257.492Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M184.39 270.528C184.39 270.673 183.974 270.779 183.471 270.779C182.969 270.779 182.562 270.673 182.562 270.528C182.562 270.383 182.969 270.276 183.471 270.276C183.974 270.276 184.39 270.392 184.39 270.528Z\" fill=black /></g><path d=\"M52.3821 248.104L95.0955 249.245C108.634 249.613 122.269 249.971 135.71 248.278C148.427 246.663 161.104 243.192 173.869 244.41C179.613 244.942 185.251 246.422 191.005 246.895C195.946 247.311 202.715 246.895 207.55 244.662C207.684 244.601 207.793 244.497 207.86 244.366C207.927 244.236 207.947 244.086 207.918 243.943C207.889 243.799 207.812 243.669 207.699 243.575C207.587 243.481 207.446 243.427 207.299 243.424C194.66 243.424 180.387 243.472 167.98 243.472H128.187H55.2638C53.8509 243.356 52.4314 243.596 51.1346 244.168C50.7666 244.446 50.4928 244.83 50.3507 245.268C50.2085 245.706 50.2047 246.178 50.34 246.619C50.4752 247.059 50.7428 247.447 51.1065 247.73C51.4701 248.014 51.9122 248.178 52.3724 248.201\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M142.165 237.042C142.059 236.955 142.465 236.21 143.084 235.369C143.703 234.528 144.283 233.919 144.399 233.996C144.515 234.073 144.099 234.828 143.49 235.669C142.881 236.51 142.281 237.119 142.165 237.042Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M160.219 237.466C160.094 237.524 159.765 237.07 159.484 236.451C159.204 235.832 159.078 235.291 159.204 235.233C159.33 235.175 159.668 235.629 159.949 236.248C160.229 236.867 160.335 237.389 160.219 237.466Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M174.405 234.566C174.483 234.682 174.134 235.05 173.632 235.388C173.129 235.727 172.665 235.901 172.578 235.785C172.49 235.669 172.848 235.301 173.351 234.963C173.854 234.624 174.328 234.489 174.405 234.566Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M196.324 236.006C196.218 236.093 195.725 235.716 195.222 235.155C194.719 234.594 194.39 234.072 194.497 233.975C194.603 233.878 195.096 234.256 195.599 234.816C196.102 235.377 196.421 235.909 196.324 236.006Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M97.5623 239.672C97.4656 239.575 97.7074 239.179 98.0942 238.792C98.481 238.405 98.8872 238.153 98.9839 238.26C99.0806 238.366 98.8485 238.753 98.452 239.14C98.0555 239.527 97.659 239.778 97.5623 239.672Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M84.7917 235.464C84.7046 235.348 85.0528 234.971 85.5556 234.632C86.0585 234.294 86.5226 234.11 86.6 234.226C86.6774 234.342 86.3389 234.71 85.836 235.048C85.3332 235.387 84.9077 235.532 84.7917 235.464Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M63.5142 238.668C63.4466 238.784 62.9534 238.61 62.6342 238.088C62.3151 237.565 62.3635 237.053 62.4989 237.043C62.6343 237.033 62.7986 237.411 63.0597 237.817C63.3208 238.223 63.5819 238.542 63.5142 238.668Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M76.277 227.913C76.3834 228.01 76.1997 228.397 75.8612 228.793C75.5228 229.19 75.165 229.431 75.0586 229.335C74.9522 229.238 75.1456 228.851 75.4744 228.464C75.8032 228.078 76.1707 227.797 76.277 227.913Z\" fill=black /></g><path d=\"M52.8042 227.005C54.1086 227.905 55.6488 228.402 57.2332 228.434C58.8177 228.466 60.3766 228.031 61.7161 227.184C63.0556 226.337 64.1166 225.115 64.7672 223.67C65.4178 222.225 65.6293 220.621 65.3755 219.057C66.119 220.269 67.2643 221.181 68.6117 221.636C69.9591 222.09 71.4232 222.057 72.7488 221.543C74.0745 221.028 75.1776 220.065 75.8659 218.821C76.5542 217.577 76.7842 216.13 76.5156 214.734C77.6261 215.75 79.0882 216.295 80.593 216.254C82.0979 216.212 83.5277 215.588 84.5805 214.512C85.6733 213.322 86.3212 211.61 88.3906 211.659C88.8814 211.686 89.3611 211.815 89.799 212.038C90.237 212.261 90.6235 212.573 90.9339 212.955C92.4908 214.889 92.3941 217.258 92.5101 219.54C92.6068 221.416 92.9356 223.408 94.2894 224.743C95.6433 226.077 98.3122 226.029 99.0762 224.317C99.521 223.35 99.405 221.851 100.43 221.503C101.213 221.242 101.997 221.948 102.306 222.712C102.506 223.507 102.758 224.289 103.06 225.052C103.902 226.541 106.058 226.802 107.605 226.087C109.09 225.228 110.339 224.015 111.241 222.557C110.961 225.236 110.69 228.021 112.015 230.477C112.359 231.163 112.853 231.763 113.461 232.232C114.069 232.701 114.774 233.026 115.525 233.185C118.832 233.755 121.076 230.467 121.705 227.383C122.381 224.153 122.053 220.613 124.025 217.848C124.328 217.391 124.742 217.018 125.226 216.763C125.711 216.508 126.253 216.379 126.801 216.388C129.257 216.533 129.547 219.588 131.413 220.642C133.28 221.696 135.833 220.004 137.216 218.138C138.734 216.03 140.204 213.37 143.018 213.525C143.674 213.582 144.313 213.773 144.893 214.085C145.473 214.398 145.984 214.826 146.393 215.343C149.091 218.563 148.491 223.079 151.324 226.232C151.746 226.728 152.266 227.13 152.853 227.414C153.439 227.697 154.078 227.854 154.728 227.876C157.484 227.876 158.596 225.342 160.008 223.389C161.188 221.764 163.441 220.333 165.095 221.455C166.748 222.576 166.661 225.323 168.489 225.855C170.752 226.493 171.922 222.896 174.185 222.248C177.328 221.339 179.02 226.358 182.201 227.189C184.793 227.866 187.201 225.458 188.197 222.973C189.357 220.072 189.56 216.726 192.007 214.531C192.575 214.005 193.277 213.645 194.036 213.491C194.795 213.338 195.582 213.396 196.31 213.661C198.486 214.483 198.119 216.368 198.805 217.828C199.917 220.217 204.868 220.439 205.903 218.012L206.541 209.541C206.565 209.222 206.523 208.902 206.418 208.6C206.313 208.298 206.147 208.021 205.93 207.786C205.713 207.552 205.451 207.364 205.158 207.235C204.866 207.106 204.55 207.038 204.23 207.036L56.5466 206.659C55.978 206.655 55.4145 206.766 54.8899 206.985C54.3653 207.204 53.8904 207.527 53.4938 207.935C53.0972 208.342 52.7872 208.825 52.5822 209.356C52.3773 209.886 52.2818 210.452 52.3013 211.021L52.8042 227.005Z\" fill=#FF725E /><g opacity=0.6><path opacity=0.6 d=\"M52.3821 248.104L95.0955 249.245C108.634 249.613 122.269 249.971 135.71 248.278C148.427 246.663 161.104 243.192 173.869 244.41C179.613 244.942 185.251 246.422 191.005 246.895C195.946 247.311 202.715 246.895 207.55 244.662C207.684 244.601 207.793 244.497 207.86 244.366C207.927 244.236 207.947 244.086 207.918 243.943C207.889 243.799 207.812 243.669 207.699 243.575C207.587 243.481 207.446 243.427 207.299 243.424C194.66 243.424 180.387 243.472 167.98 243.472H128.187H55.2638C53.8509 243.356 52.4314 243.596 51.1346 244.168C50.7666 244.446 50.4928 244.83 50.3507 245.268C50.2085 245.706 50.2047 246.178 50.34 246.619C50.4752 247.059 50.7428 247.447 51.1065 247.73C51.4701 248.014 51.9122 248.178 52.3724 248.201\" fill=white /></g><g opacity=0.6><path opacity=0.6 d=\"M204.448 264.542C171.193 263.237 137.879 261.931 104.671 264.155C89.5759 265.122 74.268 266.892 59.4145 263.981C57.7285 263.512 55.963 263.4 54.2312 263.652C53.6297 263.794 53.0636 264.057 52.568 264.426C52.2788 264.639 52.0574 264.931 51.9303 265.267C51.8032 265.604 51.7758 265.969 51.8513 266.32C51.9269 266.672 52.1022 266.994 52.3563 267.248C52.6103 267.502 52.9323 267.677 53.2836 267.753C78.958 272.984 105.348 266.089 131.612 267.279C140.432 267.675 149.231 268.961 158.051 268.584C164.104 268.323 170.09 267.298 176.134 266.95C185.553 266.418 195.039 267.559 204.419 266.64C205.183 266.573 206.17 266.215 206.083 265.461C205.996 264.706 205.135 264.542 204.448 264.542Z\" fill=white /></g><g opacity=0.3><path opacity=0.3 d=\"M189.123 183.168C162.83 182.124 136.479 181.089 110.234 182.859C98.2911 183.662 86.184 185.044 74.454 182.724C73.1225 182.341 71.7242 182.248 70.3539 182.453C69.8792 182.571 69.4323 182.781 69.0387 183.072C68.8103 183.244 68.6359 183.477 68.5359 183.745C68.436 184.013 68.4148 184.304 68.4748 184.584C68.5347 184.863 68.6734 185.12 68.8744 185.323C69.0754 185.526 69.3304 185.668 69.6093 185.731C89.9167 189.909 110.775 184.406 131.557 185.354C138.539 185.673 145.491 186.698 152.464 186.398C157.25 186.195 161.989 185.364 166.766 185.093C174.212 184.667 181.706 185.576 189.133 184.851C189.733 184.783 190.506 184.503 190.448 183.884C190.39 183.265 189.675 183.188 189.123 183.168Z\" fill=black /></g><path d=\"M189.23 181.563C162.666 180.519 136.044 179.475 109.518 181.254C97.4596 182.056 85.2268 183.439 73.3614 181.118C72.0166 180.736 70.6058 180.644 69.2226 180.848C68.7422 180.967 68.2892 181.177 67.8881 181.467C67.6596 181.639 67.4855 181.874 67.3861 182.142C67.2868 182.411 67.2664 182.702 67.3274 182.982C67.3885 183.262 67.5283 183.518 67.7305 183.721C67.9327 183.923 68.1887 184.064 68.4683 184.126C88.9788 188.303 110.05 182.801 131.064 183.749C138.104 184.068 145.134 185.093 152.183 184.793C157.018 184.58 161.796 183.758 166.631 183.488C174.154 183.062 181.726 183.971 189.23 183.236C189.83 183.178 190.622 182.898 190.555 182.269C190.487 181.641 189.743 181.583 189.23 181.563Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M68.7754 155.183C68.7754 161.787 73.7749 168.179 78.6003 170.336C81.0272 171.404 83.646 171.968 86.2974 171.993C88.9489 172.018 91.5778 171.503 94.0243 170.481C98.1922 168.711 102.312 165.394 106.692 166.555C109.013 167.174 110.812 168.972 112.727 170.423C114.641 171.873 117.117 173.092 119.389 172.299C122.929 171.061 124.002 165.723 127.696 165.085C131.39 164.447 134.784 169.524 138.527 168.45C141.186 167.686 142.269 164.166 144.909 163.335C147.549 162.503 150.112 164.659 152.8 164.437C154.985 164.253 156.832 162.503 159.028 162.426C161.223 162.348 163.302 163.992 164.627 165.849C165.951 167.706 166.909 169.843 168.495 171.467C170.081 173.092 172.701 174.069 174.684 172.927C176.666 171.786 177.053 169.456 177.691 167.396C178.329 165.336 179.78 163.044 181.936 163.19C184.093 163.335 185.727 166.226 188.019 166.091C188.75 165.965 189.419 165.602 189.924 165.059C190.429 164.516 190.742 163.821 190.814 163.083C190.923 161.601 190.695 160.113 190.146 158.732L68.7754 155.183Z\" fill=black /></g><path d=\"M68.7754 154.92C70.4773 159.929 73.7749 164.832 78.6003 166.988C81.0258 168.061 83.6445 168.628 86.2964 168.654C88.9483 168.681 91.5778 168.167 94.0243 167.143C98.1922 165.373 102.312 162.057 106.692 163.217C109.013 163.836 110.812 165.625 112.727 167.085C114.641 168.545 117.117 169.754 119.389 168.961C122.929 167.733 124.002 162.385 127.696 161.747C131.39 161.109 134.784 166.195 138.527 165.112C141.186 164.348 142.269 160.828 144.909 160.006C147.549 159.184 150.112 161.331 152.8 161.099C154.985 160.925 156.832 159.165 159.028 159.088C161.223 159.01 163.302 160.654 164.627 162.511C165.951 164.368 166.909 166.505 168.495 168.129C170.081 169.754 172.701 170.731 174.684 169.59C176.666 168.449 177.053 166.118 177.691 164.058C178.329 161.999 179.78 159.716 181.936 159.852C184.093 159.987 185.727 162.888 188.019 162.753C188.749 162.625 189.418 162.263 189.922 161.72C190.427 161.176 190.74 160.483 190.814 159.745C191.161 158.024 191.181 156.252 190.872 154.523L68.7754 154.92Z\" fill=#FF725E /><g opacity=0.3><path opacity=0.3 d=\"M85.8916 197.818C86.6526 196.219 87.7054 194.776 88.9957 193.563C88.7113 194.413 88.2683 195.2 87.6902 195.884C86.7909 197.025 86.0076 197.915 85.8916 197.818Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M102.91 196.996C102.823 197.103 102.243 196.745 101.614 196.194C100.986 195.642 100.551 195.12 100.647 195.014C100.744 194.907 101.324 195.265 101.943 195.816C102.562 196.368 103.007 196.851 102.91 196.996Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M96.9657 200.962C97.0527 201.078 96.8013 201.417 96.4145 201.726C96.0277 202.035 95.6409 202.209 95.5538 202.103C95.4668 201.997 95.7086 201.649 96.105 201.339C96.5015 201.03 96.8786 200.856 96.9657 200.962Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M119.062 193.603C118.946 193.68 118.472 193.168 118.008 192.462C117.543 191.756 117.253 191.127 117.369 191.05C117.485 190.972 117.959 191.485 118.423 192.181C118.888 192.877 119.178 193.525 119.062 193.603Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M119.903 202.374C120.01 202.451 119.671 203.012 118.936 203.283C118.201 203.554 117.592 203.38 117.621 203.283C117.65 203.186 118.163 203.09 118.753 202.858C119.342 202.625 119.797 202.277 119.903 202.374Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M135.782 195.014C135.695 195.12 135.105 194.724 134.757 193.94C134.409 193.157 134.515 192.461 134.651 192.461C134.786 192.461 134.912 193.07 135.221 193.737C135.531 194.405 135.879 194.917 135.782 195.014Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M138.063 201.03C138.063 201.165 137.618 201.397 136.999 201.562C136.38 201.726 135.839 201.745 135.8 201.61C135.761 201.475 136.245 201.233 136.873 201.078C137.502 200.924 138.034 200.895 138.063 201.03Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M150.799 194.734C150.673 194.792 150.258 194.212 149.832 193.428C149.407 192.645 149.233 191.959 149.349 191.9C149.465 191.842 149.9 192.423 150.316 193.206C150.731 193.989 150.925 194.666 150.799 194.734Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M156.747 202.655C156.66 202.548 157.008 202.113 157.298 201.513C157.588 200.914 157.743 200.382 157.888 200.392C158.033 200.401 158.101 201.04 157.743 201.736C157.385 202.432 156.834 202.771 156.747 202.655Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M163.526 193.333C163.429 193.43 162.897 192.85 163.014 191.97C163.13 191.09 163.768 190.654 163.845 190.78C163.923 190.906 163.584 191.351 163.507 192.028C163.429 192.704 163.652 193.256 163.526 193.333Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M176.088 200.103C175.953 200.103 175.711 199.523 175.556 198.739C175.401 197.956 175.382 197.299 175.556 197.27C175.73 197.241 175.933 197.859 176.088 198.633C176.243 199.407 176.223 200.074 176.088 200.103Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M182.219 198.681C182.103 198.604 182.219 198.159 182.577 197.714C182.935 197.269 183.235 196.931 183.351 197.008C183.467 197.085 183.302 197.53 182.993 197.975C182.683 198.42 182.326 198.787 182.219 198.681Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M183.003 174.843C182.887 174.765 183.003 174.398 183.225 174.011C183.448 173.624 183.757 173.363 183.883 173.44C184.008 173.518 183.883 173.885 183.66 174.272C183.438 174.659 183.128 174.91 183.003 174.843Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M157.888 176.312C157.762 176.38 157.337 175.79 156.921 175.017C156.505 174.243 156.312 173.547 156.437 173.479C156.563 173.411 156.979 174.001 157.404 174.784C157.83 175.568 158.004 176.254 157.888 176.312Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M160.999 169.233C160.854 169.233 160.748 169.165 160.748 169.088C160.748 169.01 160.854 168.952 160.999 168.952C161.145 168.952 161.251 169.01 161.251 169.088C161.251 169.165 161.183 169.233 160.999 169.233Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M139.232 175.5C139.116 175.413 139.532 174.707 140.151 173.924C140.77 173.141 141.369 172.57 141.476 172.657C141.582 172.744 141.166 173.45 140.509 174.233C139.851 175.017 139.339 175.578 139.232 175.5Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M129.272 172.675C129.146 172.627 129.272 172.086 129.466 171.457C129.659 170.828 129.997 170.364 130.123 170.413C130.249 170.461 130.171 171.012 129.939 171.631C129.707 172.25 129.398 172.675 129.272 172.675Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M121.614 175.752C121.556 175.626 121.885 175.336 122.349 175.104C122.813 174.872 123.248 174.775 123.316 174.901C123.384 175.027 123.045 175.317 122.581 175.549C122.117 175.781 121.682 175.878 121.614 175.752Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M104.295 174.35C104.179 174.427 103.889 174.166 103.657 173.779C103.425 173.393 103.318 173.015 103.444 172.938C103.57 172.861 103.85 173.131 104.082 173.518C104.314 173.905 104.411 174.282 104.295 174.35Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M104.073 171.796C103.947 171.729 103.976 171.429 104.131 171.11C104.286 170.791 104.518 170.597 104.634 170.665C104.75 170.733 104.74 171.023 104.576 171.342C104.411 171.661 104.199 171.854 104.073 171.796Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M92.4289 180.286C92.3032 180.344 91.8294 179.629 91.3555 178.691C90.8817 177.753 90.6109 176.94 90.727 176.882C90.843 176.824 91.3362 177.53 91.81 178.468C92.2839 179.406 92.5256 180.218 92.4289 180.286Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M79.393 176.032C79.5319 176.032 79.6444 175.651 79.6444 175.181C79.6444 174.711 79.5319 174.33 79.393 174.33C79.2542 174.33 79.1416 174.711 79.1416 175.181C79.1416 175.651 79.2542 176.032 79.393 176.032Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M71.1854 174.901C71.0404 174.901 71.0017 174.418 71.0791 173.876C71.1565 173.335 71.3305 172.909 71.4659 172.909C71.6013 172.909 71.6496 173.383 71.5723 173.934C71.4949 174.485 71.3208 174.921 71.1854 174.901Z\" fill=black /></g><g opacity=0.3><path opacity=0.3 d=\"M103.482 178.013C103.482 178.149 102.989 178.448 102.283 178.68C101.577 178.912 100.977 178.999 100.929 178.864C100.88 178.729 101.422 178.439 102.128 178.197C102.834 177.955 103.433 177.887 103.482 178.013Z\" fill=black /></g><g opacity=0.8><path opacity=0.8 d=\"M52.8042 227.005C54.1086 227.905 55.6488 228.402 57.2332 228.434C58.8177 228.466 60.3766 228.031 61.7161 227.184C63.0556 226.337 64.1166 225.115 64.7672 223.67C65.4178 222.225 65.6293 220.621 65.3755 219.057C66.119 220.269 67.2643 221.181 68.6117 221.636C69.9591 222.09 71.4232 222.057 72.7488 221.543C74.0745 221.028 75.1776 220.065 75.8659 218.821C76.5542 217.577 76.7842 216.13 76.5156 214.734C77.6261 215.75 79.0882 216.295 80.593 216.254C82.0979 216.212 83.5277 215.588 84.5805 214.512C85.6733 213.322 86.3212 211.61 88.3906 211.659C88.8814 211.686 89.3611 211.815 89.799 212.038C90.237 212.261 90.6235 212.573 90.9339 212.955C92.4908 214.889 92.3941 217.258 92.5101 219.54C92.6068 221.416 92.9356 223.408 94.2894 224.743C95.6433 226.077 98.3122 226.029 99.0762 224.317C99.521 223.35 99.405 221.851 100.43 221.503C101.213 221.242 101.997 221.948 102.306 222.712C102.506 223.507 102.758 224.289 103.06 225.052C103.902 226.541 106.058 226.802 107.605 226.087C109.09 225.228 110.339 224.015 111.241 222.557C110.961 225.236 110.69 228.021 112.015 230.477C112.359 231.163 112.853 231.763 113.461 232.232C114.069 232.701 114.774 233.026 115.525 233.185C118.832 233.755 121.076 230.467 121.705 227.383C122.381 224.153 122.053 220.613 124.025 217.848C124.328 217.391 124.742 217.018 125.226 216.763C125.711 216.508 126.253 216.379 126.801 216.388C129.257 216.533 129.547 219.588 131.413 220.642C133.28 221.696 135.833 220.004 137.216 218.138C138.734 216.03 140.204 213.37 143.018 213.525C143.674 213.582 144.313 213.773 144.893 214.085C145.473 214.398 145.984 214.826 146.393 215.343C149.091 218.563 148.491 223.079 151.324 226.232C151.746 226.728 152.266 227.13 152.853 227.414C153.439 227.697 154.078 227.854 154.728 227.876C157.484 227.876 158.596 225.342 160.008 223.389C161.188 221.764 163.441 220.333 165.095 221.455C166.748 222.576 166.661 225.323 168.489 225.855C170.752 226.493 171.922 222.896 174.185 222.248C177.328 221.339 179.02 226.358 182.201 227.189C184.793 227.866 187.201 225.458 188.197 222.973C189.357 220.072 189.56 216.726 192.007 214.531C192.575 214.005 193.277 213.645 194.036 213.491C194.795 213.338 195.582 213.396 196.31 213.661C198.486 214.483 198.119 216.368 198.805 217.828C199.917 220.217 204.868 220.439 205.903 218.012L206.541 209.541C206.565 209.222 206.523 208.902 206.418 208.6C206.313 208.298 206.147 208.021 205.93 207.786C205.713 207.552 205.451 207.364 205.158 207.235C204.866 207.106 204.55 207.038 204.23 207.036L56.5466 206.659C55.978 206.655 55.4145 206.766 54.8899 206.985C54.3653 207.204 53.8904 207.527 53.4938 207.935C53.0972 208.342 52.7872 208.825 52.5822 209.356C52.3773 209.886 52.2818 210.452 52.3013 211.021L52.8042 227.005Z\" fill=white /></g><g opacity=0.8><path opacity=0.8 d=\"M68.7754 154.92C70.4773 159.929 73.7749 164.832 78.6003 166.988C81.0258 168.061 83.6445 168.628 86.2964 168.654C88.9483 168.681 91.5778 168.167 94.0243 167.143C98.1922 165.373 102.312 162.057 106.692 163.217C109.013 163.836 110.812 165.625 112.727 167.085C114.641 168.545 117.117 169.754 119.389 168.961C122.929 167.733 124.002 162.385 127.696 161.747C131.39 161.109 134.784 166.195 138.527 165.112C141.186 164.348 142.269 160.828 144.909 160.006C147.549 159.184 150.112 161.331 152.8 161.099C154.985 160.925 156.832 159.165 159.028 159.088C161.223 159.01 163.302 160.654 164.627 162.511C165.951 164.368 166.909 166.505 168.495 168.129C170.081 169.754 172.701 170.731 174.684 169.59C176.666 168.449 177.053 166.118 177.691 164.058C178.329 161.999 179.78 159.716 181.936 159.852C184.093 159.987 185.727 162.888 188.019 162.753C188.749 162.625 189.418 162.263 189.922 161.72C190.427 161.176 190.74 160.483 190.814 159.745C191.161 158.024 191.181 156.252 190.872 154.523L68.7754 154.92Z\" fill=white /></g><g opacity=0.8><path opacity=0.8 d=\"M156.194 109.444C155.273 109.076 154.282 108.918 153.293 108.98C137.995 108.786 123.093 109.676 107.843 109.618C106.9 109.613 105.976 109.879 105.18 110.385C104.385 110.891 103.751 111.615 103.356 112.471C102.986 113.25 102.691 114.063 102.476 114.898C102.201 115.837 102.121 116.822 102.24 117.794C102.36 118.765 102.677 119.701 103.172 120.545C103.696 121.371 104.482 121.998 105.404 122.326C106.326 122.654 107.331 122.664 108.259 122.354C110.019 121.619 111.266 119.453 113.162 119.656C115.647 119.907 116.266 123.882 118.722 124.307C120.83 124.675 122.368 122.141 123.093 120.333C123.411 119.463 123.936 118.683 124.621 118.06C127.831 115.304 129.978 119.897 132.753 119.288C134.63 118.863 135.219 116.387 136.796 115.314C137.574 114.871 138.468 114.672 139.361 114.743C140.254 114.814 141.105 115.151 141.805 115.71C143.18 116.861 144.311 118.275 145.131 119.868C145.706 120.996 146.517 121.985 147.51 122.769C148.014 123.155 148.626 123.375 149.26 123.397C149.894 123.42 150.52 123.244 151.05 122.895C151.449 122.484 151.755 121.991 151.946 121.45C152.136 120.909 152.206 120.333 152.152 119.762C152.042 118.62 152.17 117.467 152.529 116.377C153.003 115.343 154.357 114.588 155.314 115.217C155.072 116.094 155.072 117.019 155.314 117.896C155.447 118.328 155.74 118.694 156.134 118.917C156.528 119.14 156.992 119.204 157.432 119.095C158.322 118.747 158.525 117.596 158.592 116.629C158.786 113.96 158.631 110.614 156.194 109.444Z\" fill=white /></g><g opacity=0.6><path opacity=0.6 d=\"M189.23 181.563C162.666 180.519 136.044 179.475 109.518 181.254C97.4596 182.056 85.2268 183.439 73.3614 181.118C72.0166 180.736 70.6058 180.644 69.2226 180.848C68.7422 180.967 68.2892 181.177 67.8881 181.467C67.6596 181.639 67.4855 181.874 67.3861 182.142C67.2868 182.411 67.2664 182.702 67.3274 182.982C67.3885 183.262 67.5283 183.518 67.7305 183.721C67.9327 183.923 68.1887 184.064 68.4683 184.126C88.9788 188.303 110.05 182.801 131.064 183.749C138.104 184.068 145.134 185.093 152.183 184.793C157.018 184.58 161.796 183.758 166.631 183.488C174.154 183.062 181.726 183.971 189.23 183.236C189.83 183.178 190.622 182.898 190.555 182.269C190.487 181.641 189.743 181.583 189.23 181.563Z\" fill=white /></g><path d=\"M89.9624 126.937C89.3995 126.79 88.8811 126.507 88.4519 126.115C88.0228 125.722 87.6959 125.23 87.4997 124.682C87.3034 124.134 87.2438 123.547 87.3258 122.971C87.4078 122.395 87.629 121.848 87.9703 121.377C88.7053 120.361 89.9624 119.723 90.3686 118.543C90.5111 117.93 90.5953 117.305 90.62 116.677C90.6379 116.361 90.742 116.056 90.921 115.795C91.1 115.534 91.3471 115.328 91.6353 115.197C91.9041 115.135 92.1853 115.152 92.4446 115.246C92.7039 115.34 92.9301 115.508 93.0956 115.729C93.4257 116.171 93.6476 116.685 93.7435 117.228C94.2811 119.125 94.2811 121.134 93.7435 123.03C93.5105 123.954 93.0356 124.8 92.3677 125.48C91.6998 126.159 90.8629 126.649 89.9431 126.898\" fill=#FF725E /><path d=\"M91.7345 128.474H88.0889V154.496H91.7345V128.474Z\" fill=#455A64 /><path d=\"M91.6839 130.708C91.1601 131.246 90.5907 131.738 89.982 132.178C89.4101 132.666 88.7988 133.106 88.1543 133.493C88.6749 132.952 89.2447 132.459 89.8562 132.023C90.424 131.53 91.0358 131.09 91.6839 130.708Z\" fill=#263238 /><path d=\"M91.6839 135.291C91.1631 135.832 90.5933 136.324 89.982 136.761C89.4131 137.253 88.8015 137.693 88.1543 138.076C88.6749 137.534 89.2447 137.042 89.8562 136.606C90.424 136.113 91.0358 135.673 91.6839 135.291Z\" fill=#263238 /><path d=\"M91.6839 139.877C91.166 140.421 90.596 140.914 89.982 141.347C89.4162 141.843 88.8042 142.283 88.1543 142.662C88.6808 142.127 89.25 141.635 89.8562 141.192C90.4271 140.703 91.0385 140.263 91.6839 139.877Z\" fill=#263238 /><path d=\"M91.6839 144.459C91.166 145.003 90.596 145.496 89.982 145.929C89.4162 146.425 88.8042 146.865 88.1543 147.244C88.6808 146.709 89.25 146.217 89.8562 145.774C90.43 145.289 91.0412 144.849 91.6839 144.459Z\" fill=#263238 /><path d=\"M91.6839 149.041C91.1649 149.587 90.595 150.083 89.982 150.521C89.4101 151.009 88.7988 151.449 88.1543 151.836C88.6761 151.293 89.2457 150.797 89.8562 150.356C90.43 149.871 91.0412 149.431 91.6839 149.041Z\" fill=#263238 /><path d=\"M89.9726 124.326C90.1016 125.764 90.1016 127.211 89.9726 128.649C89.8308 127.211 89.8308 125.764 89.9726 124.326Z\" fill=#263238 /><path d=\"M179.502 126.685C178.94 126.536 178.423 126.253 177.995 125.86C177.567 125.466 177.241 124.975 177.046 124.427C176.85 123.88 176.792 123.293 176.874 122.717C176.957 122.142 177.178 121.595 177.52 121.125C178.255 120.157 179.512 119.481 179.918 118.301C180.055 117.687 180.139 117.063 180.169 116.434C180.186 116.118 180.29 115.813 180.469 115.552C180.648 115.291 180.896 115.084 181.185 114.955C181.454 114.893 181.734 114.911 181.993 115.005C182.252 115.1 182.479 115.267 182.645 115.487C182.969 115.932 183.19 116.444 183.293 116.986C183.83 118.882 183.83 120.891 183.293 122.788C183.059 123.713 182.583 124.559 181.913 125.239C181.243 125.919 180.404 126.408 179.483 126.656\" fill=#FF725E /><path d=\"M181.278 128.223H177.632V154.245H181.278V128.223Z\" fill=#455A64 /><path d=\"M181.229 130.456C180.71 131.002 180.14 131.498 179.527 131.936C178.958 132.424 178.346 132.861 177.699 133.241C178.223 132.703 178.792 132.211 179.401 131.771C179.975 131.286 180.586 130.846 181.229 130.456Z\" fill=#263238 /><path d=\"M181.229 135.05C180.705 135.588 180.136 136.08 179.527 136.52C178.953 137.005 178.342 137.445 177.699 137.835C178.218 137.289 178.788 136.793 179.401 136.355C179.971 135.867 180.582 135.43 181.229 135.05Z\" fill=#263238 /><path d=\"M181.229 139.632C180.705 140.17 180.136 140.662 179.527 141.102C178.956 141.591 178.345 142.031 177.699 142.417C178.217 141.872 178.787 141.38 179.401 140.947C179.969 140.454 180.581 140.014 181.229 139.632Z\" fill=#263238 /><path d=\"M181.229 144.218C180.708 144.759 180.138 145.251 179.527 145.688C178.959 146.181 178.347 146.621 177.699 147.003C178.22 146.461 178.79 145.969 179.401 145.533C179.969 145.04 180.581 144.599 181.229 144.218Z\" fill=#263238 /><path d=\"M181.229 148.801C180.711 149.345 180.141 149.838 179.527 150.271C178.959 150.764 178.347 151.204 177.699 151.586C178.223 151.048 178.792 150.556 179.401 150.116C179.972 149.627 180.583 149.187 181.229 148.801Z\" fill=#263238 /><path d=\"M179.559 124.094C179.688 125.532 179.688 126.978 179.559 128.416C179.417 126.979 179.417 125.531 179.559 124.094Z\" fill=#263238 /><g data-aos=fade-up data-aos-duration=1000 data-aos-delay=1500><path opacity=0.2 d=\"M240.397 143.233C237.325 145.838 231.481 152.934 232.682 160.478C233.884 168.021 241.061 178.629 244.499 182.99C248.012 189.587 250.692 205.06 233.302 214.177\" stroke=black stroke-width=1.5 stroke-linecap=round /><path d=\"M240.999 140.721C240.389 141.431 239.649 142.521 239.469 142.861C239.499 142.881 239.959 143.211 241.289 143.421C242.599 143.621 243.059 143.471 243.099 143.451C243.009 142.771 242.639 141.681 242.309 140.931C247.459 140.561 267.649 131.221 271.149 109.481C273.579 94.3612 264.889 80.3912 251.739 78.2712C238.589 76.1512 225.949 86.6912 223.509 101.811C219.929 124.021 236.239 138.831 240.999 140.721Z\" fill=#00D6AD /><path d=\"M240.94 80.9404C240.94 80.9404 229.98 86.2504 227.98 98.6204C226 110.99 230.4 119.9 234.03 126.66C234.03 126.66 224.72 101.47 240.94 80.9404Z\" fill=white /></g><g data-aos=fade-up data-aos-duration=1000 data-aos-delay=2000><path opacity=0.2 d=\"M34.3974 122.233C31.325 124.838 25.4806 131.934 26.6822 139.478C27.8839 147.021 35.0606 157.629 38.4988 161.99C42.0122 168.587 44.6918 184.06 27.3024 193.177\" stroke=black stroke-width=1.5 stroke-linecap=round /><path d=\"M34.9991 119.721C34.389 120.431 33.6491 121.521 33.4691 121.861C33.4991 121.881 33.9591 122.211 35.2891 122.421C36.5991 122.621 37.059 122.471 37.099 122.451C37.009 121.771 36.639 120.681 36.309 119.931C41.459 119.561 61.6491 110.221 65.1491 88.4812C67.5791 73.3612 58.889 59.3912 45.739 57.2712C32.589 55.1512 19.9491 65.6912 17.5091 80.8112C13.9291 103.021 30.239 117.831 34.9991 119.721Z\" fill=#00D6AD /><path d=\"M34.9401 59.9404C34.9401 59.9404 23.9801 65.2504 21.9801 77.6204C20.0001 89.9904 24.4001 98.9004 28.0301 105.66C28.0301 105.66 18.7201 80.4704 34.9401 59.9404Z\" fill=white /></g></svg> <svg class=welcome-mobile-image width=324 height=288 fill=none xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 280 288\"><path d=\"M294.987 212.653C295.145 212.839 295.284 213.039 295.403 213.251C295.653 213.644 295.993 214.227 296.417 214.946C297.249 216.383 298.354 218.403 299.534 220.65C300.714 222.897 301.728 224.887 302.56 226.422C302.923 227.111 303.226 227.701 303.476 228.162C303.607 228.367 303.711 228.589 303.786 228.82C303.629 228.637 303.49 228.44 303.37 228.23C303.12 227.829 302.78 227.254 302.364 226.528C301.539 225.083 300.465 223.048 299.284 220.801C298.104 218.554 297.06 216.58 296.258 215.052L295.335 213.312C295.193 213.107 295.077 212.886 294.987 212.653Z\" fill=#E0E0E0></path><path d=\"M304.693 228.767C304.647 228.692 308.71 226.233 313.771 223.275C318.832 220.317 322.956 217.979 323.001 218.047C323.046 218.115 318.984 220.582 313.923 223.54C308.861 226.498 304.738 228.836 304.693 228.767Z\" fill=#E0E0E0></path><path d=\"M297.912 253.855C298.137 253.755 298.374 253.681 298.616 253.635L300.568 253.143C302.217 252.727 304.486 252.145 306.968 251.411C309.449 250.677 311.681 249.898 313.285 249.383L315.191 248.74C315.419 248.644 315.658 248.575 315.903 248.536C315.688 248.661 315.462 248.768 315.229 248.854C314.79 249.035 314.155 249.293 313.361 249.61C311.772 250.208 309.578 250.987 307.059 251.721C304.539 252.455 302.285 253.015 300.62 253.378C299.788 253.552 299.107 253.688 298.646 253.771C298.404 253.822 298.159 253.85 297.912 253.855Z\" fill=#E0E0E0></path><path d=\"M285.921 241.213C286.113 241.339 286.288 241.489 286.443 241.659L287.774 242.96C288.887 244.065 290.415 245.608 292.087 247.318C293.759 249.028 295.257 250.609 296.331 251.751L297.594 253.121C297.757 253.281 297.902 253.459 298.025 253.65C297.833 253.524 297.658 253.374 297.503 253.204L296.202 251.903C295.09 250.798 293.562 249.255 291.89 247.538C290.218 245.82 288.72 244.254 287.646 243.112L286.367 241.742C286.199 241.584 286.049 241.406 285.921 241.213Z\" fill=#E0E0E0></path><path d=\"M277.122 262.585C277.359 262.755 277.58 262.948 277.78 263.16L279.498 264.817C280.935 266.231 282.902 268.191 285.066 270.37C287.229 272.549 289.174 274.538 290.566 275.983L292.215 277.708C292.423 277.913 292.613 278.136 292.782 278.374C292.545 278.204 292.325 278.011 292.124 277.799L290.414 276.142C288.977 274.727 287.002 272.768 284.846 270.589C282.69 268.41 280.738 266.421 279.339 264.976L277.697 263.251C277.485 263.047 277.293 262.824 277.122 262.585Z\" fill=#E0E0E0></path><path d=\"M292.521 277.905C292.807 277.781 293.103 277.683 293.406 277.61L295.857 276.899C297.93 276.293 300.782 275.454 303.906 274.432C307.031 273.411 309.822 272.42 311.865 271.663L314.263 270.793C314.553 270.675 314.851 270.578 315.156 270.506C314.888 270.667 314.604 270.802 314.309 270.907C313.749 271.141 312.947 271.474 311.941 271.868C309.936 272.624 307.137 273.683 304.005 274.697C300.873 275.711 298.005 276.528 295.917 277.08C294.873 277.353 294.026 277.564 293.443 277.693C293.143 277.791 292.834 277.862 292.521 277.905Z\" fill=#E0E0E0></path><path d=\"M255.274 98.6812C260.925 100.542 264.617 94.0588 264.617 94.0588L261.198 92.001C259.412 95.9879 253.738 95.3903 253.738 95.3903L255.274 98.6812Z\" fill=#E0E0E0></path><path d=\"M302.71 79.3066C303.058 85.2454 310.442 86.3045 310.442 86.3045L311.1 82.3705C306.742 82.1663 305.214 76.6738 305.214 76.6738L302.71 79.3066Z\" fill=#E0E0E0></path><path d=\"M36.146 157.199C34.4741 153.469 29.4658 154.597 29.4658 154.597L30.003 157.282C32.8551 156.344 35.1777 159.506 35.1777 159.506L36.146 157.199Z\" fill=#E0E0E0></path><path d=\"M211.379 42.0847C209.707 38.355 204.699 39.4823 204.699 39.4823L205.236 42.168C208.089 41.2299 210.411 44.3922 210.411 44.3922L211.379 42.0847Z\" fill=#E0E0E0></path><path d=\"M289.305 2.76764C287.633 -0.962085 282.625 0.157587 282.625 0.157587L283.162 2.85085C286.014 1.91275 288.337 5.07507 288.337 5.07507L289.305 2.76764Z\" fill=#E0E0E0></path><path d=\"M165.399 22.3394C164.264 19.805 160.859 20.5691 160.859 20.5691L161.223 22.3923C163.159 21.7568 164.74 23.9054 164.74 23.9054L165.399 22.3394Z\" fill=#E0E0E0></path><path d=\"M88.597 29.6855C85.9113 30.374 86.0853 33.8541 86.0853 33.8541L87.9464 33.8011C87.6513 31.7887 90.0269 30.5934 90.0269 30.5934L88.597 29.6855Z\" fill=#E0E0E0></path><path d=\"M6.55659 89.1944C6.55659 86.4179 3.13704 85.7295 3.13704 85.7295L2.72852 87.5452C4.75603 87.757 5.31587 90.3595 5.31587 90.3595L6.55659 89.1944Z\" fill=#E0E0E0></path><path d=\"M249.244 50.4668C256.53 52.8575 261.288 44.5053 261.288 44.5053L256.862 41.8574C254.593 46.9716 247.27 46.2151 247.27 46.2151L249.244 50.4668Z\" fill=#E0E0E0></path><path d=\"M54.8681 13.7839C62.1535 16.1746 66.9197 7.81487 66.9197 7.81487L62.5091 5.16699C60.2395 10.3039 52.8936 9.5322 52.8936 9.5322L54.8681 13.7839Z\" fill=#E0E0E0></path><path d=\"M39.9976 42.0847C38.3256 38.355 33.3174 39.4823 33.3174 39.4823L33.8621 42.168C36.7067 41.2299 39.0292 44.3922 39.0292 44.3922L39.9976 42.0847Z\" fill=#E0E0E0></path><path d=\"M32.8013 126.082C30.1534 119.001 20.4697 121.921 20.4697 121.921L21.1128 127.111C26.6658 124.841 30.6376 130.734 30.6376 130.734L32.8013 126.082Z\" fill=#E0E0E0></path><path d=\"M211.905 141.44C208.705 134.298 199.127 136.447 199.127 136.447L200.156 141.591C205.61 139.798 210.059 145.843 210.059 145.843L211.905 141.44Z\" fill=#E0E0E0></path><path d=\"M159.332 62.3282C159.332 59.5517 155.912 58.8633 155.912 58.8633L155.504 60.679C157.531 60.8908 158.091 63.4933 158.091 63.4933L159.332 62.3282Z\" fill=#E0E0E0></path><path d=\"M206.698 90.7159C206.698 87.947 203.286 87.251 203.286 87.251L202.878 89.0667C204.898 89.2785 205.465 91.881 205.465 91.881L206.698 90.7159Z\" fill=#E0E0E0></path><path d=\"M177.672 148.158C177.672 145.382 174.252 144.693 174.252 144.693L173.844 146.509C175.871 146.721 176.431 149.323 176.431 149.323L177.672 148.158Z\" fill=#E0E0E0></path><path d=\"M301.932 127.164C301.932 124.388 298.512 123.699 298.512 123.699L298.104 125.515C300.131 125.727 300.691 128.329 300.691 128.329L301.932 127.164Z\" fill=#E0E0E0></path><path d=\"M177.692 104.318C178.728 104.318 179.568 103.478 179.568 102.442C179.568 101.405 178.728 100.565 177.692 100.565C176.655 100.565 175.815 101.405 175.815 102.442C175.815 103.478 176.655 104.318 177.692 104.318Z\" fill=#FF725E></path><path d=\"M10.2004 176.582C11.2366 176.582 12.0766 175.742 12.0766 174.706C12.0766 173.67 11.2366 172.83 10.2004 172.83C9.16423 172.83 8.32422 173.67 8.32422 174.706C8.32422 175.742 9.16423 176.582 10.2004 176.582Z\" fill=#FF725E></path><path d=\"M317.838 99.4758C317.837 99.8453 317.726 100.206 317.52 100.513C317.315 100.82 317.023 101.059 316.682 101.201C316.341 101.342 315.965 101.38 315.602 101.309C315.24 101.239 314.906 101.062 314.643 100.803C314.381 100.543 314.2 100.211 314.125 99.8497C314.05 99.488 314.083 99.1121 314.221 98.7692C314.359 98.4264 314.594 98.1317 314.899 97.9223C315.203 97.7129 315.562 97.598 315.932 97.592C316.181 97.588 316.429 97.6338 316.661 97.7268C316.893 97.8197 317.103 97.958 317.281 98.1334C317.458 98.3088 317.599 98.5179 317.695 98.7484C317.791 98.9789 317.839 99.2262 317.838 99.4758Z\" fill=#FF725E></path><path d=\"M25.6958 82.1213C25.6958 82.4924 25.5857 82.8551 25.3796 83.1637C25.1734 83.4722 24.8804 83.7127 24.5376 83.8547C24.1947 83.9967 23.8175 84.0339 23.4535 83.9615C23.0896 83.8891 22.7553 83.7104 22.4929 83.448C22.2305 83.1856 22.0518 82.8513 21.9794 82.4874C21.907 82.1234 21.9442 81.7462 22.0862 81.4033C22.2282 81.0605 22.4687 80.7675 22.7772 80.5613C23.0857 80.3552 23.4485 80.2451 23.8196 80.2451C24.3172 80.2451 24.7944 80.4428 25.1462 80.7946C25.4981 81.1465 25.6958 81.6237 25.6958 82.1213Z\" fill=#FF725E></path><path d=\"M127.252 40.3833C128.288 40.3833 129.128 39.5433 129.128 38.5071C129.128 37.4709 128.288 36.6309 127.252 36.6309C126.216 36.6309 125.376 37.4709 125.376 38.5071C125.376 39.5433 126.216 40.3833 127.252 40.3833Z\" fill=#FF725E></path><path d=\"M231.086 62.6489C232.122 62.6489 232.962 61.8089 232.962 60.7727C232.962 59.7365 232.122 58.8965 231.086 58.8965C230.05 58.8965 229.21 59.7365 229.21 60.7727C229.21 61.8089 230.05 62.6489 231.086 62.6489Z\" fill=#FF725E></path><path d=\"M201.493 138.703C201.559 138.769 201.611 138.847 201.647 138.934C201.683 139.02 201.701 139.112 201.701 139.206C201.701 139.299 201.683 139.392 201.647 139.478C201.611 139.564 201.559 139.643 201.493 139.709C201.428 139.776 201.35 139.829 201.265 139.865C201.179 139.901 201.087 139.92 200.994 139.92C200.9 139.92 200.808 139.901 200.723 139.865C200.637 139.829 200.559 139.776 200.494 139.709C200.378 139.573 200.317 139.399 200.324 139.22C200.33 139.042 200.404 138.872 200.53 138.745C200.655 138.619 200.824 138.544 201.003 138.536C201.181 138.528 201.356 138.588 201.493 138.703Z\" fill=#FF725E></path><path d=\"M267.951 90.3517C268.049 90.4503 268.115 90.5757 268.142 90.7121C268.169 90.8484 268.155 90.9896 268.101 91.1179C268.048 91.2461 267.958 91.3557 267.842 91.4328C267.726 91.5099 267.591 91.551 267.452 91.551C267.313 91.551 267.177 91.5099 267.061 91.4328C266.946 91.3557 266.855 91.2461 266.802 91.1179C266.749 90.9896 266.734 90.8484 266.761 90.7121C266.788 90.5757 266.854 90.4503 266.952 90.3517C267.017 90.2849 267.095 90.2318 267.181 90.1956C267.266 90.1593 267.359 90.1406 267.452 90.1406C267.545 90.1406 267.637 90.1593 267.723 90.1956C267.808 90.2318 267.886 90.2849 267.951 90.3517Z\" fill=#FF725E></path><path d=\"M172.238 60.1137C172.63 60.1137 172.949 59.7953 172.949 59.4025C172.949 59.0098 172.63 58.6914 172.238 58.6914C171.845 58.6914 171.526 59.0098 171.526 59.4025C171.526 59.7953 171.845 60.1137 172.238 60.1137Z\" fill=#FF725E></path><path d=\"M267.454 20.8413C267.554 20.9408 267.621 21.0675 267.649 21.2055C267.676 21.3434 267.662 21.4864 267.608 21.6163C267.554 21.7462 267.463 21.8572 267.346 21.9353C267.229 22.0134 267.092 22.0551 266.951 22.0551C266.811 22.0551 266.673 22.0134 266.556 21.9353C266.439 21.8572 266.348 21.7462 266.294 21.6163C266.241 21.4864 266.226 21.3434 266.254 21.2055C266.281 21.0675 266.349 20.9408 266.448 20.8413C266.514 20.7752 266.593 20.7228 266.679 20.687C266.765 20.6512 266.858 20.6328 266.951 20.6328C267.045 20.6328 267.137 20.6512 267.224 20.687C267.31 20.7228 267.388 20.7752 267.454 20.8413Z\" fill=#FF725E></path><path d=\"M316.96 136.554C317.061 136.653 317.13 136.78 317.158 136.918C317.186 137.056 317.173 137.2 317.119 137.33C317.066 137.461 316.974 137.572 316.857 137.651C316.74 137.729 316.602 137.771 316.461 137.771C316.32 137.771 316.182 137.729 316.065 137.651C315.948 137.572 315.857 137.461 315.803 137.33C315.75 137.2 315.736 137.056 315.764 136.918C315.793 136.78 315.861 136.653 315.962 136.554C316.027 136.487 316.104 136.434 316.19 136.398C316.276 136.361 316.368 136.343 316.461 136.343C316.554 136.343 316.646 136.361 316.732 136.398C316.818 136.434 316.896 136.487 316.96 136.554Z\" fill=#FF725E></path><path d=\"M70.4742 28.9751C70.5893 29.1117 70.6489 29.2866 70.641 29.4651C70.6331 29.6436 70.5583 29.8125 70.4315 29.9384C70.3047 30.0642 70.1352 30.1377 69.9566 30.1443C69.7781 30.1509 69.6036 30.09 69.468 29.9738C69.4012 29.9089 69.348 29.8313 69.3118 29.7455C69.2755 29.6597 69.2568 29.5676 69.2568 29.4744C69.2568 29.3813 69.2755 29.2892 69.3118 29.2034C69.348 29.1176 69.4012 29.04 69.468 28.9751C69.534 28.909 69.6124 28.8566 69.6988 28.8208C69.7851 28.785 69.8776 28.7666 69.9711 28.7666C70.0645 28.7666 70.157 28.785 70.2434 28.8208C70.3297 28.8566 70.4081 28.909 70.4742 28.9751Z\" fill=#FF725E></path><path d=\"M8.82443 138.271C9.21718 138.271 9.53557 137.953 9.53557 137.56C9.53557 137.167 9.21718 136.849 8.82443 136.849C8.43167 136.849 8.11328 137.167 8.11328 137.56C8.11328 137.953 8.43167 138.271 8.82443 138.271Z\" fill=#FF725E></path><path d=\"M1.21376 49.5977C1.27986 49.6637 1.33231 49.7422 1.36809 49.8285C1.40387 49.9148 1.42229 50.0073 1.42229 50.1008C1.42229 50.1942 1.40387 50.2868 1.36809 50.3731C1.33231 50.4594 1.27986 50.5378 1.21376 50.6039C1.11427 50.7033 0.987559 50.7709 0.84963 50.7983C0.7117 50.8257 0.568748 50.8116 0.438843 50.7577C0.308939 50.7039 0.197916 50.6127 0.119804 50.4958C0.0416934 50.3789 0 50.2414 0 50.1008C0 49.9602 0.0416934 49.8227 0.119804 49.7058C0.197916 49.5888 0.308939 49.4977 0.438843 49.4438C0.568748 49.39 0.7117 49.3759 0.84963 49.4033C0.987559 49.4306 1.11427 49.4983 1.21376 49.5977Z\" fill=#FF725E></path><path d=\"M170.494 16.256C170.414 16.3034 170.325 16.3343 170.232 16.347C170.14 16.3597 170.046 16.3539 169.956 16.3299C169.866 16.306 169.782 16.2644 169.708 16.2076C169.634 16.1507 169.572 16.0797 169.526 15.9988C169.469 15.9181 169.43 15.8266 169.41 15.7299C169.391 15.6333 169.392 15.5337 169.413 15.4374C169.434 15.3411 169.475 15.2503 169.533 15.1707C169.591 15.0911 169.665 15.0244 169.751 14.975C169.836 14.9255 169.931 14.8943 170.029 14.8833C170.126 14.8724 170.226 14.8819 170.32 14.9113C170.414 14.9407 170.501 14.9893 170.575 15.0541C170.649 15.1189 170.709 15.1984 170.751 15.2876C170.799 15.3679 170.83 15.4569 170.842 15.5492C170.855 15.6416 170.849 15.7355 170.825 15.8256C170.801 15.9157 170.76 16.0002 170.703 16.0741C170.646 16.1479 170.575 16.2098 170.494 16.256Z\" fill=#FF725E></path><path d=\"M312.733 36.6301C312.733 37.0012 312.623 37.3639 312.417 37.6725C312.211 37.981 311.917 38.2215 311.575 38.3635C311.232 38.5055 310.855 38.5427 310.491 38.4703C310.127 38.3979 309.792 38.2192 309.53 37.9568C309.268 37.6944 309.089 37.3601 309.017 36.9961C308.944 36.6322 308.981 36.255 309.123 35.9121C309.265 35.5693 309.506 35.2763 309.814 35.0701C310.123 34.8639 310.486 34.7539 310.857 34.7539C311.103 34.7539 311.347 34.8024 311.575 34.8967C311.802 34.991 312.009 35.1292 312.183 35.3034C312.358 35.4777 312.496 35.6845 312.59 35.9121C312.684 36.1398 312.733 36.3837 312.733 36.6301Z\" fill=#FF725E></path><path d=\"M204.88 5.10593C205.916 5.10593 206.756 4.26593 206.756 3.22972C206.756 2.19352 205.916 1.35352 204.88 1.35352C203.844 1.35352 203.004 2.19352 203.004 3.22972C203.004 4.26593 203.844 5.10593 204.88 5.10593Z\" fill=#FF725E></path><path d=\"M234.226 123.715C234.226 124.086 234.116 124.449 233.91 124.757C233.704 125.066 233.411 125.306 233.068 125.448C232.725 125.59 232.348 125.628 231.984 125.555C231.62 125.483 231.286 125.304 231.023 125.042C230.761 124.779 230.582 124.445 230.51 124.081C230.437 123.717 230.474 123.34 230.616 122.997C230.758 122.654 230.999 122.361 231.307 122.155C231.616 121.949 231.979 121.839 232.35 121.839C232.847 121.839 233.325 122.037 233.676 122.388C234.028 122.74 234.226 123.217 234.226 123.715Z\" fill=#FF725E></path><path d=\"M117.804 109.888C119.807 109.888 121.43 108.265 121.43 106.262C121.43 104.259 119.807 102.636 117.804 102.636C115.801 102.636 114.178 104.259 114.178 106.262C114.178 108.265 115.801 109.888 117.804 109.888Z\" fill=#FF725E></path><path d=\"M108.57 98.0323C109.132 97.8812 109.722 97.8646 110.292 97.984C111.686 98.1707 113.008 98.7138 114.131 99.5608C115.254 100.408 116.14 101.53 116.703 102.819C116.971 103.333 117.114 103.903 117.119 104.482C116.842 103.994 116.593 103.491 116.374 102.974C115.765 101.786 114.897 100.749 113.835 99.9407C112.772 99.1324 111.541 98.5727 110.234 98.3031C109.675 98.2441 109.119 98.1537 108.57 98.0323Z\" fill=#263238></path><path d=\"M116.113 104.5C116.171 104.375 116.567 104.413 116.964 104.191C117.36 103.969 117.544 103.63 117.689 103.64C117.834 103.65 117.795 103.795 117.737 104.007C117.645 104.276 117.455 104.5 117.206 104.636C116.954 104.77 116.661 104.808 116.384 104.742C116.171 104.675 116.084 104.559 116.113 104.5Z\" fill=#263238></path><path d=\"M120.348 107.818C120.555 106.937 120.555 106.02 120.348 105.14C119.846 103.728 118.608 103.205 118.685 103.041C118.762 102.877 119.053 103.041 119.517 103.321C120.122 103.714 120.581 104.296 120.822 104.976C121.064 105.656 121.074 106.397 120.851 107.083C120.639 107.605 120.406 107.886 120.348 107.818Z\" fill=white></path><path d=\"M149.514 105.063C149.514 106.073 149.215 107.06 148.654 107.9C148.093 108.739 147.296 109.394 146.363 109.78C145.43 110.167 144.403 110.268 143.413 110.071C142.422 109.874 141.512 109.387 140.798 108.673C140.084 107.959 139.598 107.049 139.401 106.059C139.204 105.069 139.305 104.042 139.691 103.109C140.078 102.176 140.732 101.379 141.572 100.818C142.412 100.257 143.399 99.957 144.409 99.957C145.762 99.9596 147.059 100.498 148.016 101.455C148.973 102.412 149.512 103.71 149.514 105.063Z\" fill=#FF725E></path><path d=\"M157.412 93.4684C157.412 93.5458 156.445 93.5264 155.062 93.8165C153.202 94.1836 151.451 94.9714 149.942 96.1196C148.434 97.2677 147.208 98.7458 146.359 100.441C145.691 101.736 145.469 102.636 145.392 102.607C145.443 101.796 145.663 101.006 146.039 100.286C146.837 98.4833 148.078 96.9124 149.647 95.7201C151.217 94.5278 153.063 93.7531 155.013 93.4684C155.804 93.297 156.621 93.297 157.412 93.4684Z\" fill=#455A64></path><path d=\"M146.796 102.567C146.796 102.625 146.69 102.76 146.4 102.837C146.029 102.907 145.646 102.849 145.313 102.673C144.98 102.498 144.715 102.215 144.563 101.87C144.475 101.59 144.514 101.406 144.563 101.397C144.611 101.387 144.92 101.938 145.53 102.257C146.139 102.576 146.738 102.441 146.796 102.567Z\" fill=#263238></path><path d=\"M140.818 107.249C140.77 107.249 140.46 106.92 140.228 106.194C139.942 105.245 139.965 104.229 140.296 103.293C140.627 102.353 141.255 101.545 142.085 100.992C142.713 100.576 143.187 100.489 143.207 100.537C143.226 100.586 142.83 100.818 142.298 101.272C141.605 101.851 141.079 102.604 140.777 103.455C140.474 104.305 140.405 105.221 140.576 106.107C140.702 106.804 140.876 107.21 140.818 107.249Z\" fill=white></path><path d=\"M107.739 109.626H156.032V155.182H104.828V112.527C104.828 112.145 104.903 111.767 105.05 111.415C105.196 111.062 105.411 110.742 105.681 110.472C105.952 110.203 106.273 109.989 106.626 109.844C106.979 109.699 107.357 109.625 107.739 109.626Z\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M106.684 112.385C122.427 112.578 137.725 111.592 153.468 111.785L156.012 113.497L156.07 121.001C156.07 121.001 154.987 121.426 154.677 120.614C154.448 119.66 154.448 118.666 154.677 117.713C153.759 117.104 153.217 117.916 152.743 118.931C152.395 119.984 152.273 121.097 152.385 122.2C152.434 122.752 152.363 123.308 152.178 123.83C151.992 124.352 151.697 124.828 151.312 125.227C150.799 125.563 150.195 125.733 149.582 125.712C148.969 125.691 148.377 125.481 147.889 125.111C146.929 124.344 146.144 123.382 145.587 122.287C144.803 120.741 143.71 119.372 142.377 118.264C141.702 117.722 140.881 117.396 140.019 117.327C139.156 117.258 138.293 117.449 137.542 117.877C136.014 118.941 135.443 121.31 133.673 121.745C131.565 122.21 129.805 119.57 127.678 119.705C125.87 119.821 124.835 121.774 124.052 123.418C123.268 125.062 121.905 126.919 120.116 126.609C117.737 126.194 117.137 122.345 114.739 122.103C112.902 121.919 111.703 124.037 110.001 124.714C109.103 125.016 108.13 125.008 107.237 124.691C106.344 124.373 105.584 123.765 105.079 122.964C104.599 122.148 104.291 121.242 104.175 120.302C104.058 119.362 104.136 118.409 104.402 117.5C104.945 115.692 105.736 113.967 106.752 112.375\" fill=black></path></g><path d=\"M156.194 109.444C155.273 109.076 154.282 108.918 153.293 108.98C137.995 108.786 123.093 109.676 107.843 109.618C106.9 109.613 105.976 109.879 105.18 110.385C104.385 110.891 103.751 111.615 103.356 112.471C102.986 113.25 102.691 114.063 102.476 114.898C102.201 115.837 102.121 116.822 102.24 117.794C102.36 118.765 102.677 119.701 103.172 120.545C103.696 121.371 104.482 121.998 105.404 122.326C106.326 122.654 107.331 122.664 108.259 122.354C110.019 121.619 111.266 119.453 113.162 119.656C115.647 119.907 116.266 123.882 118.722 124.307C120.83 124.675 122.368 122.141 123.093 120.333C123.411 119.463 123.936 118.683 124.621 118.06C127.831 115.304 129.978 119.897 132.753 119.288C134.63 118.863 135.219 116.387 136.796 115.314C137.574 114.871 138.468 114.672 139.361 114.743C140.254 114.814 141.105 115.151 141.805 115.71C143.18 116.861 144.311 118.275 145.131 119.868C145.706 120.996 146.517 121.985 147.51 122.769C148.014 123.155 148.626 123.375 149.26 123.397C149.894 123.42 150.52 123.244 151.05 122.895C151.449 122.484 151.755 121.991 151.946 121.45C152.136 120.909 152.206 120.333 152.152 119.762C152.042 118.62 152.17 117.467 152.529 116.377C153.003 115.343 154.357 114.588 155.314 115.217C155.072 116.094 155.072 117.019 155.314 117.896C155.447 118.328 155.74 118.694 156.134 118.917C156.528 119.14 156.992 119.204 157.432 119.095C158.322 118.747 158.525 117.596 158.592 116.629C158.786 113.96 158.631 110.614 156.194 109.444Z\" fill=#FF725E></path><path d=\"M130.823 81.7763C130.26 81.6291 129.741 81.3468 129.312 80.9539C128.883 80.561 128.556 80.0694 128.36 79.5216C128.164 78.9739 128.104 78.3865 128.186 77.8105C128.268 77.2345 128.489 76.6872 128.831 76.216C129.566 75.2489 130.832 74.572 131.239 73.3923C131.376 72.7753 131.461 72.1477 131.49 71.5162C131.505 71.206 131.603 70.9054 131.773 70.6454C131.943 70.3854 132.179 70.1753 132.457 70.0367C132.727 69.9745 133.01 69.9916 133.27 70.086C133.531 70.1803 133.759 70.3479 133.927 70.5686C134.249 71.0152 134.47 71.5267 134.575 72.0674C135.112 73.9641 135.112 75.9729 134.575 77.8696C134.346 78.7955 133.872 79.6428 133.203 80.3232C132.535 81.0036 131.696 81.4921 130.774 81.7377\" fill=#FF725E></path><path d=\"M132.59 83.2656H128.944V109.288H132.59V83.2656Z\" fill=#455A64></path><path d=\"M132.552 85.498C132.031 86.0396 131.462 86.5316 130.85 86.9679C130.282 87.4612 129.671 87.9014 129.022 88.2831C129.543 87.7417 130.113 87.2497 130.724 86.8132C131.29 86.3174 131.902 85.877 132.552 85.498Z\" fill=#263238></path><path d=\"M132.552 90.083C132.031 90.6245 131.462 91.1166 130.85 91.5529C130.282 92.0461 129.671 92.4864 129.022 92.868C129.548 92.3466 130.118 91.871 130.724 91.4465C131.291 90.9378 131.903 90.4814 132.552 90.083Z\" fill=#263238></path><path d=\"M132.552 94.667C131.467 95.7055 130.285 96.6381 129.022 97.452C129.546 96.9138 130.116 96.422 130.724 95.9822C131.296 95.494 131.908 95.0541 132.552 94.667Z\" fill=#263238></path><path d=\"M132.552 99.2607C132.026 99.7961 131.456 100.288 130.85 100.731C130.276 101.216 129.665 101.656 129.022 102.046C129.542 101.5 130.111 101.004 130.724 100.566C131.292 100.075 131.904 99.6382 132.552 99.2607Z\" fill=#263238></path><path d=\"M132.552 103.843C132.026 104.378 131.456 104.87 130.85 105.313C130.279 105.802 129.668 106.242 129.022 106.628C129.54 106.083 130.11 105.591 130.724 105.158C131.29 104.662 131.902 104.222 132.552 103.843Z\" fill=#263238></path><path d=\"M130.831 79.127C130.973 80.5643 130.973 82.0122 130.831 83.4495C130.702 82.0116 130.702 80.5649 130.831 79.127Z\" fill=#263238></path><path d=\"M76.3545 155.271C75.5806 154.385 75.1721 153.238 75.2116 152.062C75.2511 150.886 75.7356 149.769 76.5672 148.937C77.6073 148.174 78.7105 147.501 79.8648 146.926C80.9575 146.229 81.9245 144.992 81.6634 143.764C81.4893 142.874 80.6964 142.081 80.8898 141.191C81.0221 140.764 81.3144 140.405 81.7055 140.189C82.0967 139.973 82.5563 139.916 82.9882 140.031C83.8527 140.284 84.6101 140.814 85.1447 141.539C87.1433 143.866 88.4055 146.733 88.771 149.778C88.9451 151.248 88.5293 153.966 87.4752 155C85.9421 155.144 84.4016 155.193 82.8625 155.145\" fill=#FF725E></path><path d=\"M94.3459 155.271C93.5687 154.387 93.157 153.241 93.1948 152.064C93.2325 150.888 93.7167 149.77 94.549 148.937C95.5911 148.172 96.6977 147.499 97.8562 146.926C98.9393 146.23 99.9063 144.992 99.6549 143.764C99.4711 142.874 98.6879 142.081 98.8716 141.192C99.0059 140.764 99.3001 140.405 99.6928 140.188C100.086 139.972 100.546 139.916 100.98 140.031C101.84 140.287 102.594 140.817 103.126 141.54C105.125 143.866 106.387 146.734 106.753 149.779C106.927 151.249 106.521 153.966 105.467 155.001C103.934 155.144 102.393 155.193 100.854 155.146\" fill=#FF725E></path><path d=\"M112.322 155.271C111.548 154.385 111.14 153.238 111.179 152.062C111.219 150.886 111.703 149.769 112.535 148.937C113.574 148.172 114.677 147.499 115.833 146.926C116.916 146.229 117.892 144.992 117.631 143.764C117.457 142.874 116.664 142.081 116.858 141.191C116.99 140.764 117.282 140.405 117.673 140.189C118.064 139.973 118.524 139.916 118.956 140.031C119.819 140.287 120.576 140.816 121.112 141.539C123.111 143.866 124.373 146.733 124.739 149.778C124.913 151.248 124.497 153.966 123.443 155C121.91 155.144 120.369 155.193 118.83 155.145\" fill=#FF725E></path><path d=\"M130.308 155.271C129.531 154.387 129.119 153.241 129.157 152.064C129.194 150.888 129.679 149.77 130.511 148.937C131.553 148.172 132.66 147.499 133.818 146.926C134.901 146.23 135.868 144.992 135.617 143.764C135.433 142.874 134.65 142.081 134.834 141.192C134.968 140.764 135.262 140.405 135.655 140.188C136.047 139.972 136.508 139.916 136.942 140.031C137.802 140.287 138.556 140.817 139.088 141.54C141.087 143.866 142.349 146.734 142.715 149.779C142.889 151.249 142.483 153.966 141.429 155.001C139.896 155.144 138.355 155.193 136.816 155.146\" fill=#FF725E></path><path d=\"M148.285 155.271C147.511 154.385 147.103 153.238 147.142 152.062C147.182 150.886 147.666 149.769 148.498 148.937C149.537 148.172 150.64 147.499 151.795 146.926C152.878 146.229 153.855 144.992 153.594 143.764C153.41 142.874 152.627 142.081 152.82 141.191C152.953 140.764 153.245 140.405 153.636 140.189C154.027 139.973 154.487 139.916 154.919 140.031C155.782 140.287 156.539 140.816 157.075 141.539C159.074 143.866 160.336 146.733 160.702 149.778C160.866 151.248 160.46 153.966 159.406 155C157.873 155.144 156.332 155.193 154.793 155.145\" fill=#FF725E></path><path d=\"M166.263 155.271C165.489 154.385 165.08 153.238 165.12 152.062C165.159 150.887 165.644 149.77 166.475 148.937C167.518 148.172 168.624 147.499 169.783 146.926C170.866 146.23 171.833 144.992 171.581 143.764C171.398 142.874 170.614 142.081 170.798 141.192C170.932 140.764 171.227 140.405 171.619 140.188C172.012 139.972 172.473 139.916 172.906 140.031C173.767 140.287 174.52 140.817 175.053 141.54C177.052 143.866 178.314 146.734 178.679 149.779C178.853 151.249 178.447 153.966 177.383 155.001C175.854 155.144 174.316 155.193 172.78 155.146\" fill=#FF725E></path><g opacity=0.8><path opacity=0.8 d=\"M76.3545 155.271C75.5806 154.385 75.1721 153.238 75.2116 152.062C75.2511 150.886 75.7356 149.769 76.5672 148.937C77.6073 148.174 78.7105 147.501 79.8648 146.926C80.9575 146.229 81.9245 144.992 81.6634 143.764C81.4893 142.874 80.6964 142.081 80.8898 141.191C81.0221 140.764 81.3144 140.405 81.7055 140.189C82.0967 139.973 82.5563 139.916 82.9882 140.031C83.8527 140.284 84.6101 140.814 85.1447 141.539C87.1433 143.866 88.4055 146.733 88.771 149.778C88.9451 151.248 88.5293 153.966 87.4752 155C85.9421 155.144 84.4016 155.193 82.8625 155.145\" fill=white></path><path opacity=0.8 d=\"M94.3401 155.271C93.5628 154.387 93.1512 153.241 93.1889 152.064C93.2266 150.888 93.7108 149.77 94.5431 148.937C95.5852 148.172 96.6918 147.499 97.8504 146.926C98.9334 146.23 99.9004 144.992 99.649 143.764C99.4653 142.874 98.682 142.081 98.8657 141.192C99.0001 140.764 99.2943 140.405 99.687 140.188C100.08 139.972 100.541 139.916 100.974 140.031C101.834 140.287 102.588 140.817 103.121 141.54C105.119 143.866 106.381 146.734 106.747 149.779C106.921 151.249 106.515 153.966 105.461 155.001C103.928 155.144 102.387 155.193 100.848 155.146\" fill=white></path><path opacity=0.8 d=\"M112.317 155.271C111.543 154.385 111.135 153.238 111.174 152.062C111.214 150.886 111.699 149.769 112.53 148.937C113.569 148.172 114.672 147.499 115.828 146.926C116.911 146.229 117.887 144.992 117.626 143.764C117.452 142.874 116.659 142.081 116.853 141.191C116.985 140.764 117.277 140.405 117.668 140.189C118.06 139.973 118.519 139.916 118.951 140.031C119.814 140.287 120.571 140.816 121.108 141.539C123.106 143.866 124.368 146.733 124.734 149.778C124.908 151.248 124.492 153.966 123.438 155C121.905 155.144 120.364 155.193 118.825 155.145\" fill=white></path><path opacity=0.8 d=\"M130.306 155.271C129.529 154.387 129.117 153.241 129.155 152.064C129.192 150.888 129.677 149.77 130.509 148.937C131.551 148.172 132.658 147.499 133.816 146.926C134.899 146.23 135.866 144.992 135.615 143.764C135.431 142.874 134.648 142.081 134.832 141.192C134.966 140.764 135.26 140.405 135.653 140.188C136.045 139.972 136.506 139.916 136.94 140.031C137.8 140.287 138.554 140.817 139.086 141.54C141.085 143.866 142.347 146.734 142.713 149.779C142.887 151.249 142.481 153.966 141.427 155.001C139.894 155.144 138.353 155.193 136.814 155.146\" fill=white></path><path opacity=0.8 d=\"M148.282 155.271C147.508 154.385 147.1 153.238 147.139 152.062C147.179 150.886 147.663 149.769 148.495 148.937C149.534 148.172 150.637 147.499 151.792 146.926C152.876 146.229 153.852 144.992 153.591 143.764C153.407 142.874 152.624 142.081 152.818 141.191C152.95 140.764 153.242 140.405 153.633 140.189C154.024 139.973 154.484 139.916 154.916 140.031C155.779 140.287 156.536 140.816 157.072 141.539C159.071 143.866 160.333 146.733 160.699 149.778C160.863 151.248 160.457 153.966 159.403 155C157.87 155.144 156.329 155.193 154.79 155.145\" fill=white></path><path opacity=0.8 d=\"M166.26 155.271C165.486 154.385 165.077 153.238 165.117 152.062C165.156 150.887 165.641 149.77 166.472 148.937C167.515 148.172 168.621 147.499 169.78 146.926C170.863 146.23 171.83 144.992 171.578 143.764C171.395 142.874 170.611 142.081 170.795 141.192C170.929 140.764 171.224 140.405 171.616 140.188C172.009 139.972 172.47 139.916 172.903 140.031C173.764 140.287 174.517 140.817 175.05 141.54C177.049 143.866 178.311 146.734 178.676 149.779C178.85 151.249 178.444 153.966 177.38 155.001C175.851 155.144 174.313 155.193 172.777 155.146\" fill=white></path></g><path d=\"M190.514 155.183H68.7754V208.93H190.514V155.183Z\" fill=#FF725E></path><path d=\"M221.904 277.975H37V287.877H221.904V277.975Z\" fill=#263238></path><g opacity=0.3><path opacity=0.3 d=\"M65.4528 274.698C65.4528 274.824 64.7952 274.766 64.0796 274.543C63.3641 274.321 62.8032 274.05 62.8515 273.915C62.8999 273.779 63.4995 273.847 64.2247 274.06C64.95 274.273 65.4528 274.563 65.4528 274.698Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M81.0773 274.215C81.1643 274.322 80.9419 274.65 80.5841 274.931C80.2263 275.211 79.8588 275.366 79.7718 275.26C79.6848 275.153 79.9072 274.825 80.265 274.544C80.6228 274.264 80.9903 274.09 81.0773 274.215Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M99.8363 274.659C99.7203 274.736 99.3915 274.456 99.1014 274.03C98.8112 273.605 98.6662 273.189 98.7822 273.111C98.8983 273.034 99.2271 273.315 99.5172 273.75C99.8073 274.185 99.9524 274.581 99.8363 274.659Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M120.035 271.545C120.161 271.622 119.958 272.144 119.6 272.715C119.242 273.285 118.846 273.682 118.73 273.624C118.614 273.566 118.807 273.024 119.175 272.444C119.542 271.864 119.919 271.467 120.035 271.545Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M132.833 275.732C132.736 275.829 132.369 275.626 132.011 275.258C131.653 274.891 131.44 274.533 131.537 274.436C131.634 274.339 132.001 274.542 132.359 274.91C132.717 275.277 132.93 275.635 132.833 275.732Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M151.053 275.182C151.053 275.327 150.695 275.433 150.27 275.433C149.844 275.433 149.486 275.327 149.486 275.182C149.486 275.037 149.834 274.931 150.27 274.931C150.705 274.931 151.053 275.076 151.053 275.182Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M169.258 272.348C169.326 272.474 168.978 272.802 168.475 273.092C167.972 273.383 167.508 273.518 167.44 273.392C167.372 273.267 167.72 272.938 168.223 272.657C168.726 272.377 169.19 272.28 169.258 272.348Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M191.898 274.958C191.898 275.084 191.801 275.248 191.589 275.326C191.376 275.403 191.163 275.326 191.115 275.21C191.066 275.094 191.211 274.92 191.424 274.842C191.637 274.765 191.85 274.823 191.898 274.958Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M198.899 272.068C198.926 272.135 198.925 272.209 198.898 272.276C198.871 272.342 198.82 272.396 198.754 272.426C198.691 272.461 198.617 272.471 198.546 272.453C198.476 272.435 198.415 272.391 198.377 272.329C198.353 272.262 198.355 272.188 198.382 272.122C198.408 272.056 198.458 272.003 198.522 271.971C198.585 271.935 198.66 271.925 198.73 271.943C198.801 271.961 198.861 272.006 198.899 272.068Z\" fill=black></path></g><path d=\"M60.0544 207.635H203.29C203.982 207.635 204.646 207.91 205.136 208.4C205.626 208.889 205.901 209.553 205.901 210.246V275.365C205.901 276.057 205.626 276.722 205.136 277.211C204.646 277.701 203.982 277.976 203.29 277.976H55.6061C54.9136 277.976 54.2495 277.701 53.7598 277.211C53.2702 276.722 52.9951 276.057 52.9951 275.365V214.694C52.9939 213.767 53.1756 212.848 53.5299 211.991C53.8842 211.134 54.4041 210.355 55.0599 209.7C55.7157 209.044 56.4944 208.524 57.3514 208.17C58.2085 207.815 59.127 207.633 60.0544 207.635Z\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M204.364 266.547C171.486 265.241 138.472 263.936 105.612 266.16C90.6717 267.127 75.5184 268.897 60.81 265.986C59.1438 265.517 57.3973 265.405 55.6848 265.657C55.0893 265.799 54.5295 266.062 54.0409 266.431C53.7518 266.643 53.5301 266.935 53.4024 267.27C53.2747 267.606 53.2464 267.971 53.3209 268.322C53.3954 268.673 53.5696 268.995 53.8224 269.25C54.0753 269.504 54.3963 269.681 54.7468 269.757C80.1601 274.989 106.279 268.094 132.302 269.284C141.005 269.68 149.708 270.966 158.47 270.589C164.455 270.328 170.383 269.303 176.369 268.955C185.691 268.423 195.071 269.564 204.364 268.645C205.119 268.578 206.086 268.22 206.008 267.466C205.931 266.711 205.051 266.576 204.364 266.547Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M52.8027 230.911C54.1064 231.81 55.6455 232.306 57.2288 232.338C58.8122 232.37 60.3701 231.936 61.7091 231.091C63.0481 230.245 64.1092 229.025 64.7608 227.581C65.4123 226.138 65.6256 224.535 65.374 222.971C66.1242 224.173 67.2705 225.076 68.6151 225.523C69.9596 225.97 71.418 225.933 72.7386 225.42C74.0591 224.906 75.159 223.948 75.8483 222.71C76.5376 221.472 76.7731 220.032 76.5141 218.639C77.6234 219.657 79.0847 220.203 80.5896 220.164C82.0945 220.124 83.525 219.501 84.5791 218.426C85.3817 217.546 85.9426 216.386 87.0063 215.854C88.6792 215.013 90.7873 216.25 91.619 217.933C92.4506 219.616 92.4119 221.579 92.5087 223.455C92.6054 225.331 92.9341 227.323 94.288 228.648C95.6418 229.973 98.3108 229.944 99.0747 228.222C99.5195 227.255 99.4035 225.756 100.429 225.408C101.212 225.147 101.995 225.863 102.305 226.617C102.505 227.413 102.757 228.194 103.059 228.957C103.9 230.446 106.057 230.717 107.604 229.992C109.088 229.137 110.337 227.927 111.24 226.472C110.854 228.685 110.936 230.955 111.482 233.135C112.178 235.272 114.073 237.187 116.317 237.158C119.218 237.158 121.152 234.131 121.703 231.355C122.254 228.58 122.119 225.553 123.366 222.942C124.14 221.356 125.881 219.916 127.534 220.505C129.333 221.153 129.749 223.677 131.402 224.615C133.414 225.747 135.822 223.977 137.204 222.111C138.587 220.244 139.854 217.952 142.117 217.556C144.38 217.16 146.72 219.19 147.726 221.424C148.731 223.658 149.002 226.172 150.104 228.358C151.207 230.543 153.644 232.419 155.974 231.665C157.908 231.046 158.875 229.006 160.045 227.371C161.216 225.737 163.478 224.315 165.132 225.437C166.786 226.559 166.699 229.305 168.526 229.837C170.789 230.475 171.959 226.878 174.222 226.23C177.365 225.321 179.057 230.34 182.239 231.172C184.83 231.858 187.238 229.441 188.234 226.955C189.23 224.47 189.52 221.656 191.135 219.519C192.75 217.382 196.522 216.56 197.904 218.861C198.436 219.761 198.436 220.873 198.871 221.821C199.983 224.209 204.935 224.422 205.969 222.004V211.551H53.0058L52.8027 230.911Z\" fill=black></path></g><path d=\"M204.448 264.542C171.193 263.237 137.879 261.931 104.671 264.155C89.5759 265.122 74.268 266.892 59.4145 263.981C57.7285 263.512 55.963 263.4 54.2312 263.652C53.6297 263.794 53.0636 264.057 52.568 264.426C52.2788 264.639 52.0574 264.931 51.9303 265.267C51.8032 265.604 51.7758 265.969 51.8513 266.32C51.9269 266.672 52.1022 266.994 52.3563 267.248C52.6103 267.502 52.9323 267.677 53.2836 267.753C78.958 272.984 105.348 266.089 131.612 267.279C140.432 267.675 149.231 268.961 158.051 268.584C164.104 268.323 170.09 267.298 176.134 266.95C185.553 266.418 195.039 267.559 204.419 266.64C205.183 266.573 206.17 266.215 206.083 265.461C205.996 264.706 205.135 264.542 204.448 264.542Z\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M54.8142 250.327L97.5275 251.468C111.066 251.836 124.701 252.193 138.142 250.501C150.859 248.886 163.536 245.415 176.291 246.633C182.045 247.165 187.683 248.644 193.437 249.118C198.378 249.534 201.057 250.462 205.892 248.258V245.608C193.253 245.608 182.683 244.196 170.248 244.187C156.99 244.187 143.887 245.685 130.6 245.676H57.6765C56.2636 245.56 54.8442 245.799 53.5474 246.372C53.2062 246.658 52.9579 247.04 52.8343 247.468C52.7106 247.896 52.7171 248.351 52.853 248.775C52.9889 249.199 53.2479 249.573 53.5972 249.85C53.9465 250.126 54.3701 250.292 54.8142 250.327Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M67.9439 258.539C67.8666 258.655 67.3831 258.432 66.8706 258.055C66.358 257.678 66.0002 257.282 66.0873 257.166C66.1743 257.05 66.6481 257.272 67.1607 257.649C67.6732 258.026 68.031 258.423 67.9439 258.539Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M81.339 255.269C81.2327 255.182 81.339 254.911 81.4841 254.669C81.6291 254.428 81.9193 254.302 82.0256 254.379C82.132 254.457 82.074 254.737 81.8806 254.979C81.6872 255.221 81.4551 255.356 81.339 255.269Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M98.4527 259.601C98.3463 259.697 98.0369 259.504 97.6888 259.282C97.3406 259.059 97.0409 258.856 97.0795 258.721C97.1182 258.585 97.534 258.585 97.9595 258.856C98.385 259.127 98.5591 259.514 98.4527 259.601Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M107.399 253.819C107.486 253.935 107.244 254.254 106.857 254.544C106.471 254.834 106.094 254.989 106.007 254.873C105.919 254.757 106.171 254.438 106.558 254.148C106.944 253.858 107.322 253.713 107.399 253.819Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M124.67 257.95C124.544 258.008 124.312 257.795 124.148 257.466C123.983 257.137 123.954 256.828 124.08 256.76C124.206 256.693 124.438 256.915 124.602 257.244C124.766 257.572 124.786 257.882 124.67 257.95Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M150.131 252.94C150.208 253.056 150.005 253.327 149.676 253.549C149.347 253.772 149.028 253.849 148.951 253.733C148.874 253.617 149.077 253.346 149.406 253.124C149.734 252.901 150.053 252.805 150.131 252.94Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M169.519 258.307C169.383 258.365 169.035 257.853 168.484 257.34C167.933 256.828 167.391 256.586 167.44 256.441C167.488 256.296 168.174 256.441 168.822 256.963C169.47 257.485 169.644 258.259 169.519 258.307Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M187.185 249.428C187.282 249.525 186.905 250.125 186.325 250.773C185.745 251.421 185.203 251.865 185.097 251.74C184.99 251.614 185.377 251.053 185.957 250.405C186.538 249.757 187.079 249.341 187.185 249.428Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M196.879 257.492C196.754 257.56 196.425 257.183 195.912 257.009C195.4 256.835 194.878 256.912 194.82 256.786C194.762 256.661 195.322 256.274 196.077 256.535C196.831 256.796 197.015 257.454 196.879 257.492Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M184.39 270.528C184.39 270.673 183.974 270.779 183.471 270.779C182.969 270.779 182.562 270.673 182.562 270.528C182.562 270.383 182.969 270.276 183.471 270.276C183.974 270.276 184.39 270.392 184.39 270.528Z\" fill=black></path></g><path d=\"M52.3821 248.104L95.0955 249.245C108.634 249.613 122.269 249.971 135.71 248.278C148.427 246.663 161.104 243.192 173.869 244.41C179.613 244.942 185.251 246.422 191.005 246.895C195.946 247.311 202.715 246.895 207.55 244.662C207.684 244.601 207.793 244.497 207.86 244.366C207.927 244.236 207.947 244.086 207.918 243.943C207.889 243.799 207.812 243.669 207.699 243.575C207.587 243.481 207.446 243.427 207.299 243.424C194.66 243.424 180.387 243.472 167.98 243.472H128.187H55.2638C53.8509 243.356 52.4314 243.596 51.1346 244.168C50.7666 244.446 50.4928 244.83 50.3507 245.268C50.2085 245.706 50.2047 246.178 50.34 246.619C50.4752 247.059 50.7428 247.447 51.1065 247.73C51.4701 248.014 51.9122 248.178 52.3724 248.201\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M142.165 237.042C142.059 236.955 142.465 236.21 143.084 235.369C143.703 234.528 144.283 233.919 144.399 233.996C144.515 234.073 144.099 234.828 143.49 235.669C142.881 236.51 142.281 237.119 142.165 237.042Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M160.219 237.466C160.094 237.524 159.765 237.07 159.484 236.451C159.204 235.832 159.078 235.291 159.204 235.233C159.33 235.175 159.668 235.629 159.949 236.248C160.229 236.867 160.335 237.389 160.219 237.466Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M174.405 234.566C174.483 234.682 174.134 235.05 173.632 235.388C173.129 235.727 172.665 235.901 172.578 235.785C172.49 235.669 172.848 235.301 173.351 234.963C173.854 234.624 174.328 234.489 174.405 234.566Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M196.324 236.006C196.218 236.093 195.725 235.716 195.222 235.155C194.719 234.594 194.39 234.072 194.497 233.975C194.603 233.878 195.096 234.256 195.599 234.816C196.102 235.377 196.421 235.909 196.324 236.006Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M97.5623 239.672C97.4656 239.575 97.7074 239.179 98.0942 238.792C98.481 238.405 98.8872 238.153 98.9839 238.26C99.0806 238.366 98.8485 238.753 98.452 239.14C98.0555 239.527 97.659 239.778 97.5623 239.672Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M84.7917 235.464C84.7046 235.348 85.0528 234.971 85.5556 234.632C86.0585 234.294 86.5226 234.11 86.6 234.226C86.6774 234.342 86.3389 234.71 85.836 235.048C85.3332 235.387 84.9077 235.532 84.7917 235.464Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M63.5142 238.668C63.4466 238.784 62.9534 238.61 62.6342 238.088C62.3151 237.565 62.3635 237.053 62.4989 237.043C62.6343 237.033 62.7986 237.411 63.0597 237.817C63.3208 238.223 63.5819 238.542 63.5142 238.668Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M76.277 227.913C76.3834 228.01 76.1997 228.397 75.8612 228.793C75.5228 229.19 75.165 229.431 75.0586 229.335C74.9522 229.238 75.1456 228.851 75.4744 228.464C75.8032 228.078 76.1707 227.797 76.277 227.913Z\" fill=black></path></g><path d=\"M52.8042 227.005C54.1086 227.905 55.6488 228.402 57.2332 228.434C58.8177 228.466 60.3766 228.031 61.7161 227.184C63.0556 226.337 64.1166 225.115 64.7672 223.67C65.4178 222.225 65.6293 220.621 65.3755 219.057C66.119 220.269 67.2643 221.181 68.6117 221.636C69.9591 222.09 71.4232 222.057 72.7488 221.543C74.0745 221.028 75.1776 220.065 75.8659 218.821C76.5542 217.577 76.7842 216.13 76.5156 214.734C77.6261 215.75 79.0882 216.295 80.593 216.254C82.0979 216.212 83.5277 215.588 84.5805 214.512C85.6733 213.322 86.3212 211.61 88.3906 211.659C88.8814 211.686 89.3611 211.815 89.799 212.038C90.237 212.261 90.6235 212.573 90.9339 212.955C92.4908 214.889 92.3941 217.258 92.5101 219.54C92.6068 221.416 92.9356 223.408 94.2894 224.743C95.6433 226.077 98.3122 226.029 99.0762 224.317C99.521 223.35 99.405 221.851 100.43 221.503C101.213 221.242 101.997 221.948 102.306 222.712C102.506 223.507 102.758 224.289 103.06 225.052C103.902 226.541 106.058 226.802 107.605 226.087C109.09 225.228 110.339 224.015 111.241 222.557C110.961 225.236 110.69 228.021 112.015 230.477C112.359 231.163 112.853 231.763 113.461 232.232C114.069 232.701 114.774 233.026 115.525 233.185C118.832 233.755 121.076 230.467 121.705 227.383C122.381 224.153 122.053 220.613 124.025 217.848C124.328 217.391 124.742 217.018 125.226 216.763C125.711 216.508 126.253 216.379 126.801 216.388C129.257 216.533 129.547 219.588 131.413 220.642C133.28 221.696 135.833 220.004 137.216 218.138C138.734 216.03 140.204 213.37 143.018 213.525C143.674 213.582 144.313 213.773 144.893 214.085C145.473 214.398 145.984 214.826 146.393 215.343C149.091 218.563 148.491 223.079 151.324 226.232C151.746 226.728 152.266 227.13 152.853 227.414C153.439 227.697 154.078 227.854 154.728 227.876C157.484 227.876 158.596 225.342 160.008 223.389C161.188 221.764 163.441 220.333 165.095 221.455C166.748 222.576 166.661 225.323 168.489 225.855C170.752 226.493 171.922 222.896 174.185 222.248C177.328 221.339 179.02 226.358 182.201 227.189C184.793 227.866 187.201 225.458 188.197 222.973C189.357 220.072 189.56 216.726 192.007 214.531C192.575 214.005 193.277 213.645 194.036 213.491C194.795 213.338 195.582 213.396 196.31 213.661C198.486 214.483 198.119 216.368 198.805 217.828C199.917 220.217 204.868 220.439 205.903 218.012L206.541 209.541C206.565 209.222 206.523 208.902 206.418 208.6C206.313 208.298 206.147 208.021 205.93 207.786C205.713 207.552 205.451 207.364 205.158 207.235C204.866 207.106 204.55 207.038 204.23 207.036L56.5466 206.659C55.978 206.655 55.4145 206.766 54.8899 206.985C54.3653 207.204 53.8904 207.527 53.4938 207.935C53.0972 208.342 52.7872 208.825 52.5822 209.356C52.3773 209.886 52.2818 210.452 52.3013 211.021L52.8042 227.005Z\" fill=#FF725E></path><g opacity=0.6><path opacity=0.6 d=\"M52.3821 248.104L95.0955 249.245C108.634 249.613 122.269 249.971 135.71 248.278C148.427 246.663 161.104 243.192 173.869 244.41C179.613 244.942 185.251 246.422 191.005 246.895C195.946 247.311 202.715 246.895 207.55 244.662C207.684 244.601 207.793 244.497 207.86 244.366C207.927 244.236 207.947 244.086 207.918 243.943C207.889 243.799 207.812 243.669 207.699 243.575C207.587 243.481 207.446 243.427 207.299 243.424C194.66 243.424 180.387 243.472 167.98 243.472H128.187H55.2638C53.8509 243.356 52.4314 243.596 51.1346 244.168C50.7666 244.446 50.4928 244.83 50.3507 245.268C50.2085 245.706 50.2047 246.178 50.34 246.619C50.4752 247.059 50.7428 247.447 51.1065 247.73C51.4701 248.014 51.9122 248.178 52.3724 248.201\" fill=white></path></g><g opacity=0.6><path opacity=0.6 d=\"M204.448 264.542C171.193 263.237 137.879 261.931 104.671 264.155C89.5759 265.122 74.268 266.892 59.4145 263.981C57.7285 263.512 55.963 263.4 54.2312 263.652C53.6297 263.794 53.0636 264.057 52.568 264.426C52.2788 264.639 52.0574 264.931 51.9303 265.267C51.8032 265.604 51.7758 265.969 51.8513 266.32C51.9269 266.672 52.1022 266.994 52.3563 267.248C52.6103 267.502 52.9323 267.677 53.2836 267.753C78.958 272.984 105.348 266.089 131.612 267.279C140.432 267.675 149.231 268.961 158.051 268.584C164.104 268.323 170.09 267.298 176.134 266.95C185.553 266.418 195.039 267.559 204.419 266.64C205.183 266.573 206.17 266.215 206.083 265.461C205.996 264.706 205.135 264.542 204.448 264.542Z\" fill=white></path></g><g opacity=0.3><path opacity=0.3 d=\"M189.123 183.168C162.83 182.124 136.479 181.089 110.234 182.859C98.2911 183.662 86.184 185.044 74.454 182.724C73.1225 182.341 71.7242 182.248 70.3539 182.453C69.8792 182.571 69.4323 182.781 69.0387 183.072C68.8103 183.244 68.6359 183.477 68.5359 183.745C68.436 184.013 68.4148 184.304 68.4748 184.584C68.5347 184.863 68.6734 185.12 68.8744 185.323C69.0754 185.526 69.3304 185.668 69.6093 185.731C89.9167 189.909 110.775 184.406 131.557 185.354C138.539 185.673 145.491 186.698 152.464 186.398C157.25 186.195 161.989 185.364 166.766 185.093C174.212 184.667 181.706 185.576 189.133 184.851C189.733 184.783 190.506 184.503 190.448 183.884C190.39 183.265 189.675 183.188 189.123 183.168Z\" fill=black></path></g><path d=\"M189.23 181.563C162.666 180.519 136.044 179.475 109.518 181.254C97.4596 182.056 85.2268 183.439 73.3614 181.118C72.0166 180.736 70.6058 180.644 69.2226 180.848C68.7422 180.967 68.2892 181.177 67.8881 181.467C67.6596 181.639 67.4855 181.874 67.3861 182.142C67.2868 182.411 67.2664 182.702 67.3274 182.982C67.3885 183.262 67.5283 183.518 67.7305 183.721C67.9327 183.923 68.1887 184.064 68.4683 184.126C88.9788 188.303 110.05 182.801 131.064 183.749C138.104 184.068 145.134 185.093 152.183 184.793C157.018 184.58 161.796 183.758 166.631 183.488C174.154 183.062 181.726 183.971 189.23 183.236C189.83 183.178 190.622 182.898 190.555 182.269C190.487 181.641 189.743 181.583 189.23 181.563Z\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M68.7754 155.183C68.7754 161.787 73.7749 168.179 78.6003 170.336C81.0272 171.404 83.646 171.968 86.2974 171.993C88.9489 172.018 91.5778 171.503 94.0243 170.481C98.1922 168.711 102.312 165.394 106.692 166.555C109.013 167.174 110.812 168.972 112.727 170.423C114.641 171.873 117.117 173.092 119.389 172.299C122.929 171.061 124.002 165.723 127.696 165.085C131.39 164.447 134.784 169.524 138.527 168.45C141.186 167.686 142.269 164.166 144.909 163.335C147.549 162.503 150.112 164.659 152.8 164.437C154.985 164.253 156.832 162.503 159.028 162.426C161.223 162.348 163.302 163.992 164.627 165.849C165.951 167.706 166.909 169.843 168.495 171.467C170.081 173.092 172.701 174.069 174.684 172.927C176.666 171.786 177.053 169.456 177.691 167.396C178.329 165.336 179.78 163.044 181.936 163.19C184.093 163.335 185.727 166.226 188.019 166.091C188.75 165.965 189.419 165.602 189.924 165.059C190.429 164.516 190.742 163.821 190.814 163.083C190.923 161.601 190.695 160.113 190.146 158.732L68.7754 155.183Z\" fill=black></path></g><path d=\"M68.7754 154.92C70.4773 159.929 73.7749 164.832 78.6003 166.988C81.0258 168.061 83.6445 168.628 86.2964 168.654C88.9483 168.681 91.5778 168.167 94.0243 167.143C98.1922 165.373 102.312 162.057 106.692 163.217C109.013 163.836 110.812 165.625 112.727 167.085C114.641 168.545 117.117 169.754 119.389 168.961C122.929 167.733 124.002 162.385 127.696 161.747C131.39 161.109 134.784 166.195 138.527 165.112C141.186 164.348 142.269 160.828 144.909 160.006C147.549 159.184 150.112 161.331 152.8 161.099C154.985 160.925 156.832 159.165 159.028 159.088C161.223 159.01 163.302 160.654 164.627 162.511C165.951 164.368 166.909 166.505 168.495 168.129C170.081 169.754 172.701 170.731 174.684 169.59C176.666 168.449 177.053 166.118 177.691 164.058C178.329 161.999 179.78 159.716 181.936 159.852C184.093 159.987 185.727 162.888 188.019 162.753C188.749 162.625 189.418 162.263 189.922 161.72C190.427 161.176 190.74 160.483 190.814 159.745C191.161 158.024 191.181 156.252 190.872 154.523L68.7754 154.92Z\" fill=#FF725E></path><g opacity=0.3><path opacity=0.3 d=\"M85.8916 197.818C86.6526 196.219 87.7054 194.776 88.9957 193.563C88.7113 194.413 88.2683 195.2 87.6902 195.884C86.7909 197.025 86.0076 197.915 85.8916 197.818Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M102.91 196.996C102.823 197.103 102.243 196.745 101.614 196.194C100.986 195.642 100.551 195.12 100.647 195.014C100.744 194.907 101.324 195.265 101.943 195.816C102.562 196.368 103.007 196.851 102.91 196.996Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M96.9657 200.962C97.0527 201.078 96.8013 201.417 96.4145 201.726C96.0277 202.035 95.6409 202.209 95.5538 202.103C95.4668 201.997 95.7086 201.649 96.105 201.339C96.5015 201.03 96.8786 200.856 96.9657 200.962Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M119.062 193.603C118.946 193.68 118.472 193.168 118.008 192.462C117.543 191.756 117.253 191.127 117.369 191.05C117.485 190.972 117.959 191.485 118.423 192.181C118.888 192.877 119.178 193.525 119.062 193.603Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M119.903 202.374C120.01 202.451 119.671 203.012 118.936 203.283C118.201 203.554 117.592 203.38 117.621 203.283C117.65 203.186 118.163 203.09 118.753 202.858C119.342 202.625 119.797 202.277 119.903 202.374Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M135.782 195.014C135.695 195.12 135.105 194.724 134.757 193.94C134.409 193.157 134.515 192.461 134.651 192.461C134.786 192.461 134.912 193.07 135.221 193.737C135.531 194.405 135.879 194.917 135.782 195.014Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M138.063 201.03C138.063 201.165 137.618 201.397 136.999 201.562C136.38 201.726 135.839 201.745 135.8 201.61C135.761 201.475 136.245 201.233 136.873 201.078C137.502 200.924 138.034 200.895 138.063 201.03Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M150.799 194.734C150.673 194.792 150.258 194.212 149.832 193.428C149.407 192.645 149.233 191.959 149.349 191.9C149.465 191.842 149.9 192.423 150.316 193.206C150.731 193.989 150.925 194.666 150.799 194.734Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M156.747 202.655C156.66 202.548 157.008 202.113 157.298 201.513C157.588 200.914 157.743 200.382 157.888 200.392C158.033 200.401 158.101 201.04 157.743 201.736C157.385 202.432 156.834 202.771 156.747 202.655Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M163.526 193.333C163.429 193.43 162.897 192.85 163.014 191.97C163.13 191.09 163.768 190.654 163.845 190.78C163.923 190.906 163.584 191.351 163.507 192.028C163.429 192.704 163.652 193.256 163.526 193.333Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M176.088 200.103C175.953 200.103 175.711 199.523 175.556 198.739C175.401 197.956 175.382 197.299 175.556 197.27C175.73 197.241 175.933 197.859 176.088 198.633C176.243 199.407 176.223 200.074 176.088 200.103Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M182.219 198.681C182.103 198.604 182.219 198.159 182.577 197.714C182.935 197.269 183.235 196.931 183.351 197.008C183.467 197.085 183.302 197.53 182.993 197.975C182.683 198.42 182.326 198.787 182.219 198.681Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M183.003 174.843C182.887 174.765 183.003 174.398 183.225 174.011C183.448 173.624 183.757 173.363 183.883 173.44C184.008 173.518 183.883 173.885 183.66 174.272C183.438 174.659 183.128 174.91 183.003 174.843Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M157.888 176.312C157.762 176.38 157.337 175.79 156.921 175.017C156.505 174.243 156.312 173.547 156.437 173.479C156.563 173.411 156.979 174.001 157.404 174.784C157.83 175.568 158.004 176.254 157.888 176.312Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M160.999 169.233C160.854 169.233 160.748 169.165 160.748 169.088C160.748 169.01 160.854 168.952 160.999 168.952C161.145 168.952 161.251 169.01 161.251 169.088C161.251 169.165 161.183 169.233 160.999 169.233Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M139.232 175.5C139.116 175.413 139.532 174.707 140.151 173.924C140.77 173.141 141.369 172.57 141.476 172.657C141.582 172.744 141.166 173.45 140.509 174.233C139.851 175.017 139.339 175.578 139.232 175.5Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M129.272 172.675C129.146 172.627 129.272 172.086 129.466 171.457C129.659 170.828 129.997 170.364 130.123 170.413C130.249 170.461 130.171 171.012 129.939 171.631C129.707 172.25 129.398 172.675 129.272 172.675Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M121.614 175.752C121.556 175.626 121.885 175.336 122.349 175.104C122.813 174.872 123.248 174.775 123.316 174.901C123.384 175.027 123.045 175.317 122.581 175.549C122.117 175.781 121.682 175.878 121.614 175.752Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M104.295 174.35C104.179 174.427 103.889 174.166 103.657 173.779C103.425 173.393 103.318 173.015 103.444 172.938C103.57 172.861 103.85 173.131 104.082 173.518C104.314 173.905 104.411 174.282 104.295 174.35Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M104.073 171.796C103.947 171.729 103.976 171.429 104.131 171.11C104.286 170.791 104.518 170.597 104.634 170.665C104.75 170.733 104.74 171.023 104.576 171.342C104.411 171.661 104.199 171.854 104.073 171.796Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M92.4289 180.286C92.3032 180.344 91.8294 179.629 91.3555 178.691C90.8817 177.753 90.6109 176.94 90.727 176.882C90.843 176.824 91.3362 177.53 91.81 178.468C92.2839 179.406 92.5256 180.218 92.4289 180.286Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M79.393 176.032C79.5319 176.032 79.6444 175.651 79.6444 175.181C79.6444 174.711 79.5319 174.33 79.393 174.33C79.2542 174.33 79.1416 174.711 79.1416 175.181C79.1416 175.651 79.2542 176.032 79.393 176.032Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M71.1854 174.901C71.0404 174.901 71.0017 174.418 71.0791 173.876C71.1565 173.335 71.3305 172.909 71.4659 172.909C71.6013 172.909 71.6496 173.383 71.5723 173.934C71.4949 174.485 71.3208 174.921 71.1854 174.901Z\" fill=black></path></g><g opacity=0.3><path opacity=0.3 d=\"M103.482 178.013C103.482 178.149 102.989 178.448 102.283 178.68C101.577 178.912 100.977 178.999 100.929 178.864C100.88 178.729 101.422 178.439 102.128 178.197C102.834 177.955 103.433 177.887 103.482 178.013Z\" fill=black></path></g><g opacity=0.8><path opacity=0.8 d=\"M52.8042 227.005C54.1086 227.905 55.6488 228.402 57.2332 228.434C58.8177 228.466 60.3766 228.031 61.7161 227.184C63.0556 226.337 64.1166 225.115 64.7672 223.67C65.4178 222.225 65.6293 220.621 65.3755 219.057C66.119 220.269 67.2643 221.181 68.6117 221.636C69.9591 222.09 71.4232 222.057 72.7488 221.543C74.0745 221.028 75.1776 220.065 75.8659 218.821C76.5542 217.577 76.7842 216.13 76.5156 214.734C77.6261 215.75 79.0882 216.295 80.593 216.254C82.0979 216.212 83.5277 215.588 84.5805 214.512C85.6733 213.322 86.3212 211.61 88.3906 211.659C88.8814 211.686 89.3611 211.815 89.799 212.038C90.237 212.261 90.6235 212.573 90.9339 212.955C92.4908 214.889 92.3941 217.258 92.5101 219.54C92.6068 221.416 92.9356 223.408 94.2894 224.743C95.6433 226.077 98.3122 226.029 99.0762 224.317C99.521 223.35 99.405 221.851 100.43 221.503C101.213 221.242 101.997 221.948 102.306 222.712C102.506 223.507 102.758 224.289 103.06 225.052C103.902 226.541 106.058 226.802 107.605 226.087C109.09 225.228 110.339 224.015 111.241 222.557C110.961 225.236 110.69 228.021 112.015 230.477C112.359 231.163 112.853 231.763 113.461 232.232C114.069 232.701 114.774 233.026 115.525 233.185C118.832 233.755 121.076 230.467 121.705 227.383C122.381 224.153 122.053 220.613 124.025 217.848C124.328 217.391 124.742 217.018 125.226 216.763C125.711 216.508 126.253 216.379 126.801 216.388C129.257 216.533 129.547 219.588 131.413 220.642C133.28 221.696 135.833 220.004 137.216 218.138C138.734 216.03 140.204 213.37 143.018 213.525C143.674 213.582 144.313 213.773 144.893 214.085C145.473 214.398 145.984 214.826 146.393 215.343C149.091 218.563 148.491 223.079 151.324 226.232C151.746 226.728 152.266 227.13 152.853 227.414C153.439 227.697 154.078 227.854 154.728 227.876C157.484 227.876 158.596 225.342 160.008 223.389C161.188 221.764 163.441 220.333 165.095 221.455C166.748 222.576 166.661 225.323 168.489 225.855C170.752 226.493 171.922 222.896 174.185 222.248C177.328 221.339 179.02 226.358 182.201 227.189C184.793 227.866 187.201 225.458 188.197 222.973C189.357 220.072 189.56 216.726 192.007 214.531C192.575 214.005 193.277 213.645 194.036 213.491C194.795 213.338 195.582 213.396 196.31 213.661C198.486 214.483 198.119 216.368 198.805 217.828C199.917 220.217 204.868 220.439 205.903 218.012L206.541 209.541C206.565 209.222 206.523 208.902 206.418 208.6C206.313 208.298 206.147 208.021 205.93 207.786C205.713 207.552 205.451 207.364 205.158 207.235C204.866 207.106 204.55 207.038 204.23 207.036L56.5466 206.659C55.978 206.655 55.4145 206.766 54.8899 206.985C54.3653 207.204 53.8904 207.527 53.4938 207.935C53.0972 208.342 52.7872 208.825 52.5822 209.356C52.3773 209.886 52.2818 210.452 52.3013 211.021L52.8042 227.005Z\" fill=white></path></g><g opacity=0.8><path opacity=0.8 d=\"M68.7754 154.92C70.4773 159.929 73.7749 164.832 78.6003 166.988C81.0258 168.061 83.6445 168.628 86.2964 168.654C88.9483 168.681 91.5778 168.167 94.0243 167.143C98.1922 165.373 102.312 162.057 106.692 163.217C109.013 163.836 110.812 165.625 112.727 167.085C114.641 168.545 117.117 169.754 119.389 168.961C122.929 167.733 124.002 162.385 127.696 161.747C131.39 161.109 134.784 166.195 138.527 165.112C141.186 164.348 142.269 160.828 144.909 160.006C147.549 159.184 150.112 161.331 152.8 161.099C154.985 160.925 156.832 159.165 159.028 159.088C161.223 159.01 163.302 160.654 164.627 162.511C165.951 164.368 166.909 166.505 168.495 168.129C170.081 169.754 172.701 170.731 174.684 169.59C176.666 168.449 177.053 166.118 177.691 164.058C178.329 161.999 179.78 159.716 181.936 159.852C184.093 159.987 185.727 162.888 188.019 162.753C188.749 162.625 189.418 162.263 189.922 161.72C190.427 161.176 190.74 160.483 190.814 159.745C191.161 158.024 191.181 156.252 190.872 154.523L68.7754 154.92Z\" fill=white></path></g><g opacity=0.8><path opacity=0.8 d=\"M156.194 109.444C155.273 109.076 154.282 108.918 153.293 108.98C137.995 108.786 123.093 109.676 107.843 109.618C106.9 109.613 105.976 109.879 105.18 110.385C104.385 110.891 103.751 111.615 103.356 112.471C102.986 113.25 102.691 114.063 102.476 114.898C102.201 115.837 102.121 116.822 102.24 117.794C102.36 118.765 102.677 119.701 103.172 120.545C103.696 121.371 104.482 121.998 105.404 122.326C106.326 122.654 107.331 122.664 108.259 122.354C110.019 121.619 111.266 119.453 113.162 119.656C115.647 119.907 116.266 123.882 118.722 124.307C120.83 124.675 122.368 122.141 123.093 120.333C123.411 119.463 123.936 118.683 124.621 118.06C127.831 115.304 129.978 119.897 132.753 119.288C134.63 118.863 135.219 116.387 136.796 115.314C137.574 114.871 138.468 114.672 139.361 114.743C140.254 114.814 141.105 115.151 141.805 115.71C143.18 116.861 144.311 118.275 145.131 119.868C145.706 120.996 146.517 121.985 147.51 122.769C148.014 123.155 148.626 123.375 149.26 123.397C149.894 123.42 150.52 123.244 151.05 122.895C151.449 122.484 151.755 121.991 151.946 121.45C152.136 120.909 152.206 120.333 152.152 119.762C152.042 118.62 152.17 117.467 152.529 116.377C153.003 115.343 154.357 114.588 155.314 115.217C155.072 116.094 155.072 117.019 155.314 117.896C155.447 118.328 155.74 118.694 156.134 118.917C156.528 119.14 156.992 119.204 157.432 119.095C158.322 118.747 158.525 117.596 158.592 116.629C158.786 113.96 158.631 110.614 156.194 109.444Z\" fill=white></path></g><g opacity=0.6><path opacity=0.6 d=\"M189.23 181.563C162.666 180.519 136.044 179.475 109.518 181.254C97.4596 182.056 85.2268 183.439 73.3614 181.118C72.0166 180.736 70.6058 180.644 69.2226 180.848C68.7422 180.967 68.2892 181.177 67.8881 181.467C67.6596 181.639 67.4855 181.874 67.3861 182.142C67.2868 182.411 67.2664 182.702 67.3274 182.982C67.3885 183.262 67.5283 183.518 67.7305 183.721C67.9327 183.923 68.1887 184.064 68.4683 184.126C88.9788 188.303 110.05 182.801 131.064 183.749C138.104 184.068 145.134 185.093 152.183 184.793C157.018 184.58 161.796 183.758 166.631 183.488C174.154 183.062 181.726 183.971 189.23 183.236C189.83 183.178 190.622 182.898 190.555 182.269C190.487 181.641 189.743 181.583 189.23 181.563Z\" fill=white></path></g><path d=\"M89.9624 126.937C89.3995 126.79 88.8811 126.507 88.4519 126.115C88.0228 125.722 87.6959 125.23 87.4997 124.682C87.3034 124.134 87.2438 123.547 87.3258 122.971C87.4078 122.395 87.629 121.848 87.9703 121.377C88.7053 120.361 89.9624 119.723 90.3686 118.543C90.5111 117.93 90.5953 117.305 90.62 116.677C90.6379 116.361 90.742 116.056 90.921 115.795C91.1 115.534 91.3471 115.328 91.6353 115.197C91.9041 115.135 92.1853 115.152 92.4446 115.246C92.7039 115.34 92.9301 115.508 93.0956 115.729C93.4257 116.171 93.6476 116.685 93.7435 117.228C94.2811 119.125 94.2811 121.134 93.7435 123.03C93.5105 123.954 93.0356 124.8 92.3677 125.48C91.6998 126.159 90.8629 126.649 89.9431 126.898\" fill=#FF725E></path><path d=\"M91.7345 128.474H88.0889V154.496H91.7345V128.474Z\" fill=#455A64></path><path d=\"M91.6839 130.708C91.1601 131.246 90.5907 131.738 89.982 132.178C89.4101 132.666 88.7988 133.106 88.1543 133.493C88.6749 132.952 89.2447 132.459 89.8562 132.023C90.424 131.53 91.0358 131.09 91.6839 130.708Z\" fill=#263238></path><path d=\"M91.6839 135.291C91.1631 135.832 90.5933 136.324 89.982 136.761C89.4131 137.253 88.8015 137.693 88.1543 138.076C88.6749 137.534 89.2447 137.042 89.8562 136.606C90.424 136.113 91.0358 135.673 91.6839 135.291Z\" fill=#263238></path><path d=\"M91.6839 139.877C91.166 140.421 90.596 140.914 89.982 141.347C89.4162 141.843 88.8042 142.283 88.1543 142.662C88.6808 142.127 89.25 141.635 89.8562 141.192C90.4271 140.703 91.0385 140.263 91.6839 139.877Z\" fill=#263238></path><path d=\"M91.6839 144.459C91.166 145.003 90.596 145.496 89.982 145.929C89.4162 146.425 88.8042 146.865 88.1543 147.244C88.6808 146.709 89.25 146.217 89.8562 145.774C90.43 145.289 91.0412 144.849 91.6839 144.459Z\" fill=#263238></path><path d=\"M91.6839 149.041C91.1649 149.587 90.595 150.083 89.982 150.521C89.4101 151.009 88.7988 151.449 88.1543 151.836C88.6761 151.293 89.2457 150.797 89.8562 150.356C90.43 149.871 91.0412 149.431 91.6839 149.041Z\" fill=#263238></path><path d=\"M89.9726 124.326C90.1016 125.764 90.1016 127.211 89.9726 128.649C89.8308 127.211 89.8308 125.764 89.9726 124.326Z\" fill=#263238></path><path d=\"M179.502 126.685C178.94 126.536 178.423 126.253 177.995 125.86C177.567 125.466 177.241 124.975 177.046 124.427C176.85 123.88 176.792 123.293 176.874 122.717C176.957 122.142 177.178 121.595 177.52 121.125C178.255 120.157 179.512 119.481 179.918 118.301C180.055 117.687 180.139 117.063 180.169 116.434C180.186 116.118 180.29 115.813 180.469 115.552C180.648 115.291 180.896 115.084 181.185 114.955C181.454 114.893 181.734 114.911 181.993 115.005C182.252 115.1 182.479 115.267 182.645 115.487C182.969 115.932 183.19 116.444 183.293 116.986C183.83 118.882 183.83 120.891 183.293 122.788C183.059 123.713 182.583 124.559 181.913 125.239C181.243 125.919 180.404 126.408 179.483 126.656\" fill=#FF725E></path><path d=\"M181.278 128.223H177.632V154.245H181.278V128.223Z\" fill=#455A64></path><path d=\"M181.229 130.456C180.71 131.002 180.14 131.498 179.527 131.936C178.958 132.424 178.346 132.861 177.699 133.241C178.223 132.703 178.792 132.211 179.401 131.771C179.975 131.286 180.586 130.846 181.229 130.456Z\" fill=#263238></path><path d=\"M181.229 135.05C180.705 135.588 180.136 136.08 179.527 136.52C178.953 137.005 178.342 137.445 177.699 137.835C178.218 137.289 178.788 136.793 179.401 136.355C179.971 135.867 180.582 135.43 181.229 135.05Z\" fill=#263238></path><path d=\"M181.229 139.632C180.705 140.17 180.136 140.662 179.527 141.102C178.956 141.591 178.345 142.031 177.699 142.417C178.217 141.872 178.787 141.38 179.401 140.947C179.969 140.454 180.581 140.014 181.229 139.632Z\" fill=#263238></path><path d=\"M181.229 144.218C180.708 144.759 180.138 145.251 179.527 145.688C178.959 146.181 178.347 146.621 177.699 147.003C178.22 146.461 178.79 145.969 179.401 145.533C179.969 145.04 180.581 144.599 181.229 144.218Z\" fill=#263238></path><path d=\"M181.229 148.801C180.711 149.345 180.141 149.838 179.527 150.271C178.959 150.764 178.347 151.204 177.699 151.586C178.223 151.048 178.792 150.556 179.401 150.116C179.972 149.627 180.583 149.187 181.229 148.801Z\" fill=#263238></path><path d=\"M179.559 124.094C179.688 125.532 179.688 126.978 179.559 128.416C179.417 126.979 179.417 125.531 179.559 124.094Z\" fill=#263238></path><g data-aos=fade-up data-aos-duration=1000 data-aos-delay=1500 class=\"aos-init aos-animate\"><path opacity=0.2 d=\"M240.397 143.233C237.325 145.838 231.481 152.934 232.682 160.478C233.884 168.021 241.061 178.629 244.499 182.99C248.012 189.587 250.692 205.06 233.302 214.177\" stroke=black stroke-width=1.5 stroke-linecap=round></path><path d=\"M240.999 140.721C240.389 141.431 239.649 142.521 239.469 142.861C239.499 142.881 239.959 143.211 241.289 143.421C242.599 143.621 243.059 143.471 243.099 143.451C243.009 142.771 242.639 141.681 242.309 140.931C247.459 140.561 267.649 131.221 271.149 109.481C273.579 94.3612 264.889 80.3912 251.739 78.2712C238.589 76.1512 225.949 86.6912 223.509 101.811C219.929 124.021 236.239 138.831 240.999 140.721Z\" fill=#00D6AD></path><path d=\"M240.94 80.9404C240.94 80.9404 229.98 86.2504 227.98 98.6204C226 110.99 230.4 119.9 234.03 126.66C234.03 126.66 224.72 101.47 240.94 80.9404Z\" fill=white></path></g><g data-aos=fade-up data-aos-duration=1000 data-aos-delay=2000 class=\"aos-init aos-animate\"><path opacity=0.2 d=\"M34.3974 122.233C31.325 124.838 25.4806 131.934 26.6822 139.478C27.8839 147.021 35.0606 157.629 38.4988 161.99C42.0122 168.587 44.6918 184.06 27.3024 193.177\" stroke=black stroke-width=1.5 stroke-linecap=round></path><path d=\"M34.9991 119.721C34.389 120.431 33.6491 121.521 33.4691 121.861C33.4991 121.881 33.9591 122.211 35.2891 122.421C36.5991 122.621 37.059 122.471 37.099 122.451C37.009 121.771 36.639 120.681 36.309 119.931C41.459 119.561 61.6491 110.221 65.1491 88.4812C67.5791 73.3612 58.889 59.3912 45.739 57.2712C32.589 55.1512 19.9491 65.6912 17.5091 80.8112C13.9291 103.021 30.239 117.831 34.9991 119.721Z\" fill=#00D6AD></path><path d=\"M34.9401 59.9404C34.9401 59.9404 23.9801 65.2504 21.9801 77.6204C20.0001 89.9904 24.4001 98.9004 28.0301 105.66C28.0301 105.66 18.7201 80.4704 34.9401 59.9404Z\" fill=white></path></g></svg></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\">Neapeer would love to share in your joys! Let us know your date of birth?</span><div class=profile_popup_dob ng-click=$event.stopPropagation();><label for=dob-day class=control-label>Please enter your date of birth:</label><div class=dob-dropdown><select name=dob-day id=dob-day ng-model=userDob.userDay><option value=\"\">Day</option><option value=01>01</option><option value=02>02</option><option value=03>03</option><option value=04>04</option><option value=05>05</option><option value=06>06</option><option value=07>07</option><option value=08>08</option><option value=09>09</option><option value=10>10</option><option value=11>11</option><option value=12>12</option><option value=13>13</option><option value=14>14</option><option value=15>15</option><option value=16>16</option><option value=17>17</option><option value=18>18</option><option value=19>19</option><option value=20>20</option><option value=21>21</option><option value=22>22</option><option value=23>23</option><option value=24>24</option><option value=25>25</option><option value=26>26</option><option value=27>27</option><option value=28>28</option><option value=29>29</option><option value=30>30</option><option value=31>31</option></select><select name=dob-month id=dob-month ng-model=userDob.userMonth><option value=\"\">Month</option><option value=01>January</option><option value=02>February</option><option value=03>March</option><option value=04>April</option><option value=05>May</option><option value=06>June</option><option value=07>July</option><option value=08>August</option><option value=09>September</option><option value=10>October</option><option value=11>November</option><option value=12>December</option></select><select name=dob-year id=dob-year ng-model=userDob.userYear><option value=\"\">Year</option><option value=2012>2012</option><option value=2011>2011</option><option value=2010>2010</option><option value=2009>2009</option><option value=2008>2008</option><option value=2007>2007</option><option value=2006>2006</option><option value=2005>2005</option><option value=2004>2004</option><option value=2003>2003</option><option value=2002>2002</option><option value=2001>2001</option><option value=2000>2000</option><option value=1999>1999</option><option value=1998>1998</option><option value=1997>1997</option><option value=1996>1996</option><option value=1995>1995</option><option value=1994>1994</option><option value=1993>1993</option><option value=1992>1992</option><option value=1991>1991</option><option value=1990>1990</option><option value=1989>1989</option><option value=1988>1988</option><option value=1987>1987</option><option value=1986>1986</option><option value=1985>1985</option><option value=1984>1984</option><option value=1983>1983</option><option value=1982>1982</option><option value=1981>1981</option><option value=1980>1980</option><option value=1979>1979</option><option value=1978>1978</option><option value=1977>1977</option><option value=1976>1976</option><option value=1975>1975</option><option value=1974>1974</option><option value=1973>1973</option><option value=1972>1972</option><option value=1971>1971</option><option value=1970>1970</option><option value=1969>1969</option><option value=1968>1968</option><option value=1967>1967</option><option value=1966>1966</option><option value=1965>1965</option><option value=1964>1964</option><option value=1963>1963</option><option value=1962>1962</option><option value=1961>1961</option><option value=1960>1960</option><option value=1959>1959</option><option value=1958>1958</option><option value=1957>1957</option><option value=1956>1956</option><option value=1955>1955</option><option value=1954>1954</option><option value=1953>1953</option><option value=1952>1952</option><option value=1951>1951</option><option value=1950>1950</option><option value=1949>1949</option><option value=1948>1948</option><option value=1947>1947</option><option value=1946>1946</option><option value=1945>1945</option><option value=1944>1944</option><option value=1943>1943</option><option value=1942>1942</option><option value=1941>1941</option><option value=1940>1940</option><option value=1939>1939</option><option value=1938>1938</option><option value=1937>1937</option><option value=1936>1936</option><option value=1935>1935</option><option value=1934>1934</option><option value=1933>1933</option><option value=1932>1932</option><option value=1931>1931</option><option value=1930>1930</option><option value=1929>1929</option><option value=1928>1928</option><option value=1927>1927</option><option value=1926>1926</option><option value=1925>1925</option><option value=1924>1924</option><option value=1923>1923</option><option value=1922>1922</option><option value=1921>1921</option><option value=1920>1920</option><option value=1919>1919</option><option value=1918>1918</option><option value=1917>1917</option><option value=1916>1916</option><option value=1915>1915</option><option value=1914>1914</option><option value=1913>1913</option><option value=1912>1912</option><option value=1911>1911</option><option value=1910>1910</option><option value=1909>1909</option><option value=1908>1908</option><option value=1907>1907</option><option value=1906>1906</option><option value=1905>1905</option><option value=1904>1904</option><option value=1903>1903</option><option value=1901>1901</option><option value=1900>1900</option></select></div></div><div class=login-loader-cont style=\"margin-top: 15px\"><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=journeyTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=journeyTab(false,userDob);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- Guardian Tab --><div class=\"row journey-tab\" ng-if=guardian_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><img src=../../images/guardian_p.svg alt=#></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up-left data-aos-duration=1000><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\"><span ng-if=userData.name>Hey {{userData.name}},</span> <span ng-if=!userData.name>Hey User,</span>would you like to share your Guardians/Parents cell number with us.</span><div class=\"profile_popup_input profile_city_dropdown\"><div class=field-inner><!-- <img src=\"../../images/email-icon.svg\" alt=\"\" /> --> <input type=text style=\"width: 50px\" id=country class=country-code-dropdown> <input type=text name=number id=number placeholder=3312232323 ng-model=guardian_phone style=\"margin-left: 30px\"></div></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=guardianTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=guardianTab(false,guardian_phone);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- journey tab --><div class=\"row journey-tab\" ng-if=journey_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><img src=../../images/journey-banner.svg alt=#></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up-left data-aos-duration=1000><div class=profile_popup_content><div><span class=\"profile_popup_subtitle mb-24\"><span ng-if=userData.name>{{userData.name}},</span> please let us know how you first came to know about Nearpeer?</span><div class=\"profile_popup_input profile_city_dropdown\"><!-- ng-if=\"selectedJourney.value.id !== 0.1\" --><ui-select ng-model=selectedJourney.value ng-click=showJourney()><ui-select-match placeholder=\"Choose your Journey\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices ng-show=showJourneyList repeat=\"item in (journeyArray | filter: $select.search) track by item.id\"><span ng-bind=item.name></span></ui-select-choices></ui-select></div><div class=profile_button_wrapper><a class=profile_popup_button ng-click=otpTab(true);$event.stopPropagation();>Skip </a><a class=\"profile_popup_button active\" ng-click=otpTab(false,selectedJourney.value.name);$event.stopPropagation();><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></a></div></div></div></div></div><!-- Otp tab --><div class=\"row otp-tab\" ng-if=otp_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><img src=../../images/verify-banner-tab.svg alt=\"Birthday banner\"></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000><div class=profile_popup_content><div class=profile_popup_otp><form class=\"ng-pristine ng-valid\"><div class=\"field-wrapper-otp mb-24\"><div class=field-inner><div style=\"max-width: 260px; display: flex\"><i class=\"fa fa-envelope\" aria-hidden=true></i> <input ng-show=!emailVerified type=text name=email-otp id=email ng-model=userEmail> <input ng-show=emailVerified type=text name=email-otp id=email ng-model=userEmail disabled><!-- <label>{{userEmail}}</label> --></div><div class=text-center><button ng-if=!emailVerified ng-click=\"updateProfile(\'email\',userEmail);$event.stopPropagation();\"><div ng-if=!loader>Send OTP</div><div ng-if=\"loader && !emailVerified\"><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></button> <button ng-if=emailVerified style=\"background-color: #4a7aff !important\">Verified</button> <span ng-if=!emailVerified>Via email</span></div></div><div ng-if=showEmailError class=login-loader-cont style=\"margin-top: 0px\"><div><p style=\"text-align: inherit; max-width: 200px\" class=login-error-message ng-if=errorMessage>{{errorMessage}}</p><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div></div></div></div><div class=\"field-wrapper-otp mb-24\"><div class=field-inner><div style=\"position: relative;\n                        max-width: 260px;\n                        display: flex\"><i style=\"margin-right: 0px !important\" class=\"fa fa-phone\" aria-hidden=true></i> <input ng-show=!phoneVerified type=text id=country class=country-code-dropdown style=\"width: 50px\"> <input ng-show=!phoneVerified type=text name=number-otp id=email ng-model=editablePhone style=\"margin-left: 30px; width: 100%\"> <input ng-if=phoneVerified type=text id=country class=country-code-dropdown style=\"width: 50px\"> <input ng-if=phoneVerified type=text name=number-otp id=email ng-model=editablePhone style=\"margin-left: 67px; width: 100%\"><!-- <label>{{userPhone}}</label> --></div><div class=text-center><button ng-if=!phoneVerified ng-click=\"updateProfile(\'phone\',editablePhone);$event.stopPropagation();\"><div ng-if=!loader>Send OTP</div><div ng-if=\"loader && !phoneVerified\"><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></button> <button ng-if=phoneVerified style=\"background-color: #4a7aff !important\">Verified</button> <span ng-if=!phoneVerified>Via phone</span></div></div><div ng-if=!showEmailError class=login-loader-cont style=\"margin-top: 0px\"><div><p style=\"text-align: inherit; max-width: 200px\" class=login-error-message ng-if=errorMessage>{{errorMessage}}</p><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div><div></div></div></div></form><div class=profile_button_wrapper><a class=profile_popup_button ng-click=toLandingPage();$event.stopPropagation();>Skip</a></div></div></div></div></div><!-- Otp sent tab --><div class=\"row otp-sent-tab\" ng-if=otpSent_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><img src=../../images/verify-banner.svg alt=\"Birthday banner\"></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000><div class=profile_popup_content><div class=profile_popup_otpCode><h4 class=\"profile_popup_subtitle mb-16\">Please enter the OTP sent to you.</h4><p data-aos=fade-up data-aos-duration=1000 data-aos-delay=300>To complete your <span ng-if=phoneChoosen>phone number</span> <span ng-if=!phoneChoosen>email address</span> verification please enter the 6 digit verification code sent on your <span ng-if=phoneChoosen>{{userData.uid_phone ? userData.uid_phone : userData.phone}}</span> <span ng-if=!phoneChoosen>{{userData.email}}</span>.</p><div class=\"otp-code mb-24\" data-aos=fade-up data-aos-duration=1000 data-aos-delay=500><div class=\"field-wrapper-otpCode mb-24\"><div class=field-inner><form method=get data-group-name=digits data-autosubmit=false autocomplete=off style=\"display: flex\"><input type=text maxlength=1 id=digit-1 name=digit-1 data-next=digit-2 ng-model=digit1 ng-keyup=\"keytab($event, 1)\"> <input type=text name=digit-2 id=digit-2 ng-model=digit2 ng-keyup=\"keytab($event, 2)\" data-next=digit-3 data-previous=digit-1 maxlength=1> <input type=text name=digit-3 id=digit-3 ng-model=digit3 ng-keyup=\"keytab($event, 3 )\" data-next=digit-4 data-previous=digit-3 maxlength=1> <input type=text name=digit-4 id=digit-4 ng-model=digit4 ng-keyup=\"keytab($event, 4 )\" data-next=digit-5 data-previous=digit-4 maxlength=1> <input type=text name=digit-5 id=digit-5 ng-model=digit5 ng-keyup=\"keytab($event, 5)\" data-next=digit-6 data-previous=digit-5 maxlength=1> <input type=text name=digit-6 id=digit-6 ng-model=digit6 ng-keyup=\"keytab($event, 6)\" data-next=digit-7 data-previous=digit-5 maxlength=1></form></div></div></div><div class=login-loader-cont style=\"margin-top: 5px; padding: 0\"><div></div><div><p class=login-error-message ng-if=errorMessage>{{errorMessage}}</p><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=\"password-options flex-view justify-content-between mb-24\"><div class=forget-password></div><!-- ng-click=\"sendOTPConfirmation(digit1,digit2,digit3,digit4,digit5,digit6)\" --><div class=skip-password ng-click=\"sendOtp(phoneChoosen ? \'phone\' : \'email\',\'resend\');$event.stopPropagation();\">Resend code.</div></div><div class=profile_button_wrapper><!-- <div class=\"profile_popup_button active\" ng-click=\"verifyOtpTab()(otpDigits)\">\n                  Verify\n                </div> --><div class=\"profile_popup_button active\" ng-click=\"sendOTPConfirmation(digit1,digit2,digit3,digit4,digit5,digit6,phoneChoosen ? \'phoneVerify\' : \'emailVerify\');$event.stopPropagation();\"><div ng-if=!loader>Verify</div><div ng-if=loader><div class=login-theme-loader style=\"margin: 3px auto 0\"></div></div></div></div></div></div></div></div><!-- Otp wrong tab --><div class=\"row otp-sent-tab\" ng-if=otpWrong_tab><div class=\"col-md-12 col-lg-6 scale-up-bl\" data-aos=fade-up-right data-aos-duration=1000 data-aos-delay=1000 style=\"animation-delay: 1s\"><img src=../../images/verify-banner.svg alt=\"Birthday banner\"></div><div class=\"col-md-12 col-lg-6\" data-aos=fade-up data-aos-duration=1000><div class=profile_popup_content><div class=profile_popup_otpCode><h4 class=\"profile_popup_subtitle mb-16\">Wrong otp</h4><p data-aos=fade-up data-aos-duration=1000 data-aos-delay=300>Dear user you have entered the wrong OTP. Please re-enter the latest OTP again we sent at your <span ng-if=phoneChoosen>{{userData.uid_phone ? userData.uid_phone : userData.phone}}</span> <span ng-if=!phoneChoosen>{{userData.email}}</span>.</p><div class=\"otp-wrong-code otp-code mb-24\" data-aos=fade-up data-aos-duration=1000 data-aos-delay=500><form method=get data-group-name=digits data-autosubmit=false autocomplete=off><div class=\"field-wrapper-otpCode mb-24\"><div class=field-inner><input type=text maxlength=1 id=digit-1 ng-paste=\"onPasteOTP($event, 1)\" name=digit-1 data-next=digit-2 ng-model=digit1 ng-keyup=\"keytab($event, 1 , digit1)\"> <input type=text maxlength=1 name=digit-2 id=digit-2 ng-model=digit2 ng-keyup=\"keytab($event, 2 , digit2)\" data-next=digit-3 data-previous=digit-1> <input type=text maxlength=1 name=digit-3 id=digit-3 ng-model=digit3 ng-keyup=\"keytab($event, 3 , digit3)\" data-next=digit-4 data-previous=digit-3> <input type=text maxlength=1 name=digit-4 id=digit-4 ng-model=digit4 ng-keyup=\"keytab($event, 4 , digit4)\" data-next=digit-5 data-previous=digit-4> <input type=text maxlength=1 name=digit-5 id=digit-5 ng-model=digit5 ng-keyup=\"keytab($event, 5 ,digit5)\" data-next=digit-6 data-previous=digit-5> <input type=text maxlength=1 name=digit-6 id=digit-6 ng-model=digit6 ng-keyup=\"keytab($event, 6,digit6)\" data-next=digit-7 data-previous=digit-5></div></div></form></div><div class=\"password-options flex-view justify-content-between mb-24\"><div class=forget-password></div><div class=skip-password>Resend code.</div></div><div class=profile_button_wrapper><a class=\"profile_popup_button active\" ng-click=profileCompleted();$event.stopPropagation();>verify</a></div></div></div></div></div><!-- verify popup otp tab --><div class=\"row text-center\" ng-if=verify_otp_tab><div class=verify-otp-tab><div class=verify-otp-animation><img src=../../images/verifypopup.gif alt=#></div><p class=profile_popup_detail data-aos=fade-up data-aos-duration=1000 data-aos-anchor-placement=top-bottom>Hey {{userData.name}} , Your <span ng-if=phoneChoosen>phone number</span> <span ng-if=!phoneChoosen>email address</span> has been verified successfully. In order to complete your profile please verify your <span ng-if=!phoneChoosen>phone number</span> <span ng-if=phoneChoosen>email address</span> and get amazing discounts at Nearpeer.</p><a class=\"profile_popup_button active\" data-aos=fade-up data-aos-duration=1000 data-aos-delay=300 data-aos-anchor-placement=top-bottom ng-click=verifyOtpTab();$event.stopPropagation();>Verify <span ng-if=!phoneChoosen>Phone</span><span ng-if=phoneChoosen>Email</span></a></div></div><!-- Profile complete tab --><div class=\"completeProfie-tab text-center\" ng-if=profile_completed><div><h2>Profile Completed</h2><p>Congratulations {{userData.name}}! You have completed your profile. You are now a verified member of Nearpeer</p><p>You’ll get notifications about our discount offers soon. Happy learning!</p><a class=\"profile_popup_button active\" ng-click=profileDone();$event.stopPropagation();>Next</a></div></div></div></div><div class=noti_reset ng-if=noti_reset id=hideNotification><img src=../../images/noti-check.png alt=Check><p>OTP sent to<span ng-if=!phoneChoosen>{{userData.email}}</span> <span ng-if=phoneChoosen>{{userData.uid_phone ? userData.uid_phone : userData.phone}}</span></p></div><div class=\"welcom_popup wow fadeInUp\" ng-if=welcome_popup><svg class=welcome-desktop-image width=705 height=540 viewBox=\"0 0 705 540\" fill=none xmlns=http://www.w3.org/2000/svg><g opacity=0.4><path d=\"M468.21 440.42C468.878 440.42 469.42 439.878 469.42 439.21C469.42 438.542 468.878 438 468.21 438C467.542 438 467 438.542 467 439.21C467 439.878 467.542 440.42 468.21 440.42Z\" fill=#2DC0DA /><path d=\"M481.06 440.42C481.728 440.42 482.27 439.878 482.27 439.21C482.27 438.542 481.728 438 481.06 438C480.391 438 479.85 438.542 479.85 439.21C479.85 439.878 480.391 440.42 481.06 440.42Z\" fill=#2DC0DA /><path d=\"M495.13 439.21C495.13 439.88 494.59 440.42 493.92 440.42C493.25 440.42 492.71 439.88 492.71 439.21C492.71 438.54 493.25 438 493.92 438C494.58 438 495.13 438.54 495.13 439.21Z\" fill=#2DC0DA /><path d=\"M507.98 439.21C507.98 439.88 507.44 440.42 506.77 440.42C506.1 440.42 505.56 439.88 505.56 439.21C505.56 438.54 506.1 438 506.77 438C507.43 438 507.98 438.54 507.98 439.21Z\" fill=#2DC0DA /><path d=\"M520.83 439.21C520.83 439.88 520.29 440.42 519.62 440.42C518.95 440.42 518.41 439.88 518.41 439.21C518.41 438.54 518.95 438 519.62 438C520.29 438 520.83 438.54 520.83 439.21Z\" fill=white /><path d=\"M532.47 440.42C533.138 440.42 533.68 439.878 533.68 439.21C533.68 438.542 533.138 438 532.47 438C531.802 438 531.26 438.542 531.26 439.21C531.26 439.878 531.802 440.42 532.47 440.42Z\" fill=#2DC0DA /><path d=\"M546.53 439.21C546.53 439.88 545.99 440.42 545.32 440.42C544.65 440.42 544.11 439.88 544.11 439.21C544.11 438.54 544.65 438 545.32 438C545.99 438 546.53 438.54 546.53 439.21Z\" fill=#2DC0DA /><path d=\"M468.21 454.64C468.878 454.64 469.42 454.098 469.42 453.43C469.42 452.761 468.878 452.22 468.21 452.22C467.542 452.22 467 452.761 467 453.43C467 454.098 467.542 454.64 468.21 454.64Z\" fill=white /><path d=\"M481.06 454.64C481.728 454.64 482.27 454.098 482.27 453.43C482.27 452.761 481.728 452.22 481.06 452.22C480.391 452.22 479.85 452.761 479.85 453.43C479.85 454.098 480.391 454.64 481.06 454.64Z\" fill=#2DC0DA /><path d=\"M495.13 453.43C495.13 454.1 494.59 454.64 493.92 454.64C493.25 454.64 492.71 454.1 492.71 453.43C492.71 452.76 493.25 452.22 493.92 452.22C494.58 452.22 495.13 452.76 495.13 453.43Z\" fill=#2DC0DA /><path d=\"M507.98 453.43C507.98 454.1 507.44 454.64 506.77 454.64C506.1 454.64 505.56 454.1 505.56 453.43C505.56 452.76 506.1 452.22 506.77 452.22C507.43 452.22 507.98 452.76 507.98 453.43Z\" fill=#2DC0DA /><path d=\"M520.83 453.43C520.83 454.1 520.29 454.64 519.62 454.64C518.95 454.64 518.41 454.1 518.41 453.43C518.41 452.76 518.95 452.22 519.62 452.22C520.29 452.22 520.83 452.76 520.83 453.43Z\" fill=#2DC0DA /><path d=\"M532.47 454.64C533.138 454.64 533.68 454.098 533.68 453.43C533.68 452.761 533.138 452.22 532.47 452.22C531.802 452.22 531.26 452.761 531.26 453.43C531.26 454.098 531.802 454.64 532.47 454.64Z\" fill=#2DC0DA /><path d=\"M546.53 453.43C546.53 454.1 545.99 454.64 545.32 454.64C544.65 454.64 544.11 454.1 544.11 453.43C544.11 452.76 544.65 452.22 545.32 452.22C545.99 452.22 546.53 452.76 546.53 453.43Z\" fill=#2DC0DA /><path d=\"M469.42 467.65C469.42 468.32 468.88 468.86 468.21 468.86C467.54 468.86 467 468.32 467 467.65C467 466.98 467.54 466.44 468.21 466.44C468.88 466.44 469.42 466.98 469.42 467.65Z\" fill=#2DC0DA /><path d=\"M482.27 467.65C482.27 468.32 481.73 468.86 481.06 468.86C480.39 468.86 479.85 468.32 479.85 467.65C479.85 466.98 480.39 466.44 481.06 466.44C481.73 466.44 482.27 466.98 482.27 467.65Z\" fill=#2DC0DA /><path d=\"M495.13 467.65C495.13 468.32 494.59 468.86 493.92 468.86C493.25 468.86 492.71 468.32 492.71 467.65C492.71 466.98 493.25 466.44 493.92 466.44C494.58 466.44 495.13 466.98 495.13 467.65Z\" fill=white /><path d=\"M507.98 467.65C507.98 468.32 507.44 468.86 506.77 468.86C506.1 468.86 505.56 468.32 505.56 467.65C505.56 466.98 506.1 466.44 506.77 466.44C507.43 466.44 507.98 466.98 507.98 467.65Z\" fill=#2DC0DA /><path d=\"M520.83 467.65C520.83 468.32 520.29 468.86 519.62 468.86C518.95 468.86 518.41 468.32 518.41 467.65C518.41 466.98 518.95 466.44 519.62 466.44C520.29 466.44 520.83 466.98 520.83 467.65Z\" fill=#2DC0DA /><path d=\"M533.68 467.65C533.68 468.32 533.14 468.86 532.47 468.86C531.8 468.86 531.26 468.32 531.26 467.65C531.26 466.98 531.8 466.44 532.47 466.44C533.14 466.44 533.68 466.98 533.68 467.65Z\" fill=#2DC0DA /><path d=\"M546.53 467.65C546.53 468.32 545.99 468.86 545.32 468.86C544.65 468.86 544.11 468.32 544.11 467.65C544.11 466.98 544.65 466.44 545.32 466.44C545.99 466.44 546.53 466.98 546.53 467.65Z\" fill=#2DC0DA /><path d=\"M468.21 483.08C468.878 483.08 469.42 482.538 469.42 481.87C469.42 481.202 468.878 480.66 468.21 480.66C467.542 480.66 467 481.202 467 481.87C467 482.538 467.542 483.08 468.21 483.08Z\" fill=#2DC0DA /><path d=\"M481.06 483.08C481.728 483.08 482.27 482.538 482.27 481.87C482.27 481.202 481.728 480.66 481.06 480.66C480.391 480.66 479.85 481.202 479.85 481.87C479.85 482.538 480.391 483.08 481.06 483.08Z\" fill=#2DC0DA /><path d=\"M495.13 481.87C495.13 482.54 494.59 483.08 493.92 483.08C493.25 483.08 492.71 482.54 492.71 481.87C492.71 481.2 493.25 480.66 493.92 480.66C494.58 480.66 495.13 481.2 495.13 481.87Z\" fill=#2DC0DA /><path d=\"M507.98 481.87C507.98 482.54 507.44 483.08 506.77 483.08C506.1 483.08 505.56 482.54 505.56 481.87C505.56 481.2 506.1 480.66 506.77 480.66C507.43 480.66 507.98 481.2 507.98 481.87Z\" fill=#2DC0DA /><path d=\"M520.83 481.87C520.83 482.54 520.29 483.08 519.62 483.08C518.95 483.08 518.41 482.54 518.41 481.87C518.41 481.2 518.95 480.66 519.62 480.66C520.29 480.66 520.83 481.2 520.83 481.87Z\" fill=white /><path d=\"M532.47 483.08C533.138 483.08 533.68 482.538 533.68 481.87C533.68 481.202 533.138 480.66 532.47 480.66C531.802 480.66 531.26 481.202 531.26 481.87C531.26 482.538 531.802 483.08 532.47 483.08Z\" fill=#2DC0DA /><path d=\"M546.53 481.87C546.53 482.54 545.99 483.08 545.32 483.08C544.65 483.08 544.11 482.54 544.11 481.87C544.11 481.2 544.65 480.66 545.32 480.66C545.99 480.66 546.53 481.2 546.53 481.87Z\" fill=#2DC0DA /><path d=\"M469.42 496.09C469.42 496.76 468.88 497.3 468.21 497.3C467.54 497.3 467 496.76 467 496.09C467 495.42 467.54 494.88 468.21 494.88C468.88 494.88 469.42 495.42 469.42 496.09Z\" fill=#2DC0DA /><path d=\"M482.27 496.09C482.27 496.76 481.73 497.3 481.06 497.3C480.39 497.3 479.85 496.76 479.85 496.09C479.85 495.42 480.39 494.88 481.06 494.88C481.73 494.88 482.27 495.42 482.27 496.09Z\" fill=#2DC0DA /><path d=\"M495.13 496.09C495.13 496.76 494.59 497.3 493.92 497.3C493.25 497.3 492.71 496.76 492.71 496.09C492.71 495.42 493.25 494.88 493.92 494.88C494.58 494.88 495.13 495.42 495.13 496.09Z\" fill=#2DC0DA /><path d=\"M507.98 496.09C507.98 496.76 507.44 497.3 506.77 497.3C506.1 497.3 505.56 496.76 505.56 496.09C505.56 495.42 506.1 494.88 506.77 494.88C507.43 494.88 507.98 495.42 507.98 496.09Z\" fill=#2DC0DA /><path d=\"M520.83 496.09C520.83 496.76 520.29 497.3 519.62 497.3C518.95 497.3 518.41 496.76 518.41 496.09C518.41 495.42 518.95 494.88 519.62 494.88C520.29 494.88 520.83 495.42 520.83 496.09Z\" fill=#2DC0DA /><path d=\"M533.68 496.09C533.68 496.76 533.14 497.3 532.47 497.3C531.8 497.3 531.26 496.76 531.26 496.09C531.26 495.42 531.8 494.88 532.47 494.88C533.14 494.88 533.68 495.42 533.68 496.09Z\" fill=#2DC0DA /><path d=\"M546.53 496.09C546.53 496.76 545.99 497.3 545.32 497.3C544.65 497.3 544.11 496.76 544.11 496.09C544.11 495.42 544.65 494.88 545.32 494.88C545.99 494.88 546.53 495.42 546.53 496.09Z\" fill=#2DC0DA /><path d=\"M468.21 511.52C468.878 511.52 469.42 510.978 469.42 510.31C469.42 509.641 468.878 509.1 468.21 509.1C467.542 509.1 467 509.641 467 510.31C467 510.978 467.542 511.52 468.21 511.52Z\" fill=#2DC0DA /><path d=\"M481.06 511.52C481.728 511.52 482.27 510.978 482.27 510.31C482.27 509.641 481.728 509.1 481.06 509.1C480.391 509.1 479.85 509.641 479.85 510.31C479.85 510.978 480.391 511.52 481.06 511.52Z\" fill=#2DC0DA /><path d=\"M495.13 510.31C495.13 510.98 494.59 511.52 493.92 511.52C493.25 511.52 492.71 510.98 492.71 510.31C492.71 509.64 493.25 509.1 493.92 509.1C494.58 509.1 495.13 509.64 495.13 510.31Z\" fill=#2DC0DA /><path d=\"M507.98 510.31C507.98 510.98 507.44 511.52 506.77 511.52C506.1 511.52 505.56 510.98 505.56 510.31C505.56 509.64 506.1 509.1 506.77 509.1C507.43 509.1 507.98 509.64 507.98 510.31Z\" fill=white /><path d=\"M520.83 510.31C520.83 510.98 520.29 511.52 519.62 511.52C518.95 511.52 518.41 510.98 518.41 510.31C518.41 509.64 518.95 509.1 519.62 509.1C520.29 509.1 520.83 509.64 520.83 510.31Z\" fill=#2DC0DA /><path d=\"M532.47 511.52C533.138 511.52 533.68 510.978 533.68 510.31C533.68 509.641 533.138 509.1 532.47 509.1C531.802 509.1 531.26 509.641 531.26 510.31C531.26 510.978 531.802 511.52 532.47 511.52Z\" fill=#2DC0DA /><path d=\"M546.53 510.31C546.53 510.98 545.99 511.52 545.32 511.52C544.65 511.52 544.11 510.98 544.11 510.31C544.11 509.64 544.65 509.1 545.32 509.1C545.99 509.1 546.53 509.64 546.53 510.31Z\" fill=#2DC0DA /><path d=\"M468.21 525.75C468.878 525.75 469.42 525.208 469.42 524.54C469.42 523.872 468.878 523.33 468.21 523.33C467.542 523.33 467 523.872 467 524.54C467 525.208 467.542 525.75 468.21 525.75Z\" fill=#2DC0DA /><path d=\"M481.06 525.75C481.728 525.75 482.27 525.208 482.27 524.54C482.27 523.872 481.728 523.33 481.06 523.33C480.391 523.33 479.85 523.872 479.85 524.54C479.85 525.208 480.391 525.75 481.06 525.75Z\" fill=#2DC0DA /><path d=\"M495.13 524.54C495.13 525.21 494.59 525.75 493.92 525.75C493.25 525.75 492.71 525.21 492.71 524.54C492.71 523.87 493.25 523.33 493.92 523.33C494.58 523.32 495.13 523.87 495.13 524.54Z\" fill=#2DC0DA /><path d=\"M507.98 524.54C507.98 525.21 507.44 525.75 506.77 525.75C506.1 525.75 505.56 525.21 505.56 524.54C505.56 523.87 506.1 523.33 506.77 523.33C507.43 523.32 507.98 523.87 507.98 524.54Z\" fill=#2DC0DA /><path d=\"M520.83 524.54C520.83 525.21 520.29 525.75 519.62 525.75C518.95 525.75 518.41 525.21 518.41 524.54C518.41 523.87 518.95 523.33 519.62 523.33C520.29 523.32 520.83 523.87 520.83 524.54Z\" fill=#2DC0DA /><path d=\"M532.47 525.75C533.138 525.75 533.68 525.208 533.68 524.54C533.68 523.872 533.138 523.33 532.47 523.33C531.802 523.33 531.26 523.872 531.26 524.54C531.26 525.208 531.802 525.75 532.47 525.75Z\" fill=white /><path d=\"M546.53 524.54C546.53 525.21 545.99 525.75 545.32 525.75C544.65 525.75 544.11 525.21 544.11 524.54C544.11 523.87 544.65 523.33 545.32 523.33C545.99 523.32 546.53 523.87 546.53 524.54Z\" fill=#2DC0DA /><path d=\"M469.42 538.76C469.42 539.43 468.88 539.97 468.21 539.97C467.54 539.97 467 539.43 467 538.76C467 538.09 467.54 537.55 468.21 537.55C468.88 537.54 469.42 538.09 469.42 538.76Z\" fill=#2DC0DA /><path d=\"M482.27 538.76C482.27 539.43 481.73 539.97 481.06 539.97C480.39 539.97 479.85 539.43 479.85 538.76C479.85 538.09 480.39 537.55 481.06 537.55C481.73 537.55 482.27 538.09 482.27 538.76Z\" fill=white /><path d=\"M495.13 538.76C495.13 539.43 494.59 539.97 493.92 539.97C493.25 539.97 492.71 539.43 492.71 538.76C492.71 538.09 493.25 537.55 493.92 537.55C494.58 537.54 495.13 538.09 495.13 538.76Z\" fill=#2DC0DA /><path d=\"M507.98 538.76C507.98 539.43 507.44 539.97 506.77 539.97C506.1 539.97 505.56 539.43 505.56 538.76C505.56 538.09 506.1 537.55 506.77 537.55C507.43 537.54 507.98 538.09 507.98 538.76Z\" fill=#2DC0DA /><path d=\"M520.83 538.76C520.83 539.43 520.29 539.97 519.62 539.97C518.95 539.97 518.41 539.43 518.41 538.76C518.41 538.09 518.95 537.55 519.62 537.55C520.29 537.54 520.83 538.09 520.83 538.76Z\" fill=#2DC0DA /><path d=\"M533.68 538.76C533.68 539.43 533.14 539.97 532.47 539.97C531.8 539.97 531.26 539.43 531.26 538.76C531.26 538.09 531.8 537.55 532.47 537.55C533.14 537.55 533.68 538.09 533.68 538.76Z\" fill=#2DC0DA /><path d=\"M546.53 538.76C546.53 539.43 545.99 539.97 545.32 539.97C544.65 539.97 544.11 539.43 544.11 538.76C544.11 538.09 544.65 537.55 545.32 537.55C545.99 537.54 546.53 538.09 546.53 538.76Z\" fill=#2DC0DA /></g><path d=\"M290.362 141.723C210.064 142.723 144.044 101.538 76.4376 165.033C24.4342 213.895 14.8072 287.871 41.2544 351.258C104.688 503.213 333.434 555.249 478.839 501.299C645.975 439.109 766.954 255.993 668.728 124.305C638.043 82.9892 553.269 44.783 503.374 46.0225C413.71 48.0448 379.092 140.592 290.362 141.723Z\" fill=#2DC0DA /><path opacity=0.9 d=\"M290.362 141.723C210.064 142.723 144.044 101.538 76.4376 165.033C24.4342 213.895 14.8072 287.871 41.2544 351.258C104.688 503.213 333.434 555.249 478.839 501.299C645.975 439.109 766.954 255.993 668.728 124.305C638.043 82.9892 553.269 44.783 503.374 46.0225C413.71 48.0448 379.092 140.592 290.362 141.723Z\" fill=white /><path d=\"M81.5998 385.069C87.5552 382.002 94.5722 381.604 101.191 382.698C104.741 383.278 108.457 384.339 110.862 387.008C113.284 389.677 113.732 394.369 110.962 396.656C109.303 398.016 106.997 398.231 104.857 398.198C99.6815 398.132 93.9418 397.22 89.7947 400.336C87.4391 402.11 85.8631 405.061 83.043 405.94C80.2893 406.802 77.1706 405.161 75.7108 402.674C74.251 400.187 74.2012 397.071 74.8814 394.269C74.8814 394.269 75.6113 388.152 81.5998 385.069Z\" fill=#4A4A4A /><path d=\"M67.9586 358.728C71.6081 363.934 78.675 362.21 81.9596 359.027C85.2441 355.861 86.6376 351.252 87.8983 346.859C90.7848 336.83 93.6879 326.32 91.5479 316.108C90.9009 313.058 89.7563 310.007 87.6164 307.753C85.4764 305.482 82.1752 304.139 79.156 304.935C75.5895 305.88 73.3666 309.377 71.7574 312.693C67.0462 322.457 64.5413 333.299 64.5081 344.14C64.4916 349.23 65.0887 354.551 67.9586 358.728Z\" fill=#4A4A4A /><path d=\"M57.9428 366.188C61.8909 361.497 62.654 354.651 60.8956 348.782C59.1372 342.897 55.1559 337.907 50.5774 333.829C45.2026 329.038 38.8823 325.325 32.0975 322.938C29.4267 321.993 26.6066 321.263 23.7865 321.529C20.9664 321.794 18.1298 323.236 16.8192 325.739C14.8784 329.453 16.7363 333.945 18.7601 337.609C22.3101 344.074 26.3744 350.257 30.9031 356.076C34.536 360.768 38.6998 365.393 44.257 367.498C49.7977 369.62 55.554 369.371 58.5068 365.525\" fill=#4A4A4A /><path d=\"M67.7145 437.174C67.7808 437.174 67.8969 436.329 68.0462 434.804C68.2121 433.08 68.4278 430.925 68.6766 428.355C68.9752 425.636 69.3733 422.42 70.1364 418.889C70.8829 415.375 72.0607 411.579 73.5703 407.733C75.1296 403.903 77.0374 400.422 79.2768 397.637C81.4831 394.835 84.071 392.813 86.493 391.653C88.8983 390.459 91.0714 389.978 92.5644 389.763C94.074 389.614 94.92 389.481 94.92 389.415C94.92 389.348 94.074 389.332 92.5312 389.381C90.9885 389.481 88.749 389.879 86.1943 391.023C83.6397 392.15 80.9025 394.205 78.5801 397.073C76.2411 399.925 74.267 403.472 72.6745 407.385C71.1317 411.313 69.9705 415.143 69.2572 418.724C68.5439 422.304 68.2121 425.57 67.9965 428.305C67.7974 431.041 67.7144 433.262 67.6813 434.787C67.6315 436.312 67.6481 437.158 67.7145 437.174Z\" fill=#263238 /><path d=\"M68.1436 432.201C68.1768 432.201 68.1934 431.819 68.21 431.107C68.21 430.278 68.21 429.25 68.1934 427.973C68.1934 425.255 68.1934 421.309 68.3261 416.452C68.5749 406.721 69.4044 396.261 71.0301 381.507C72.5562 367.631 74.6133 351.485 76.7864 340.991C77.2509 338.604 77.7153 336.449 78.1632 334.575C78.578 332.686 78.9429 331.061 79.2913 329.751C79.5899 328.508 79.8387 327.497 80.0212 326.701C80.1705 326.005 80.2535 325.624 80.2203 325.624C80.1871 325.607 80.0544 325.972 79.8387 326.651C79.6065 327.447 79.2913 328.442 78.9263 329.652C78.5282 330.962 78.1135 332.57 77.6324 334.443C77.1347 336.316 76.6205 338.455 76.1062 340.842C73.9663 350.357 71.677 363.653 70.0513 378.44C68.4256 393.227 67.6957 406.688 67.6293 416.435C67.5796 421.309 67.6791 425.255 67.7952 427.973C67.8782 429.25 67.9445 430.278 67.9943 431.107C68.0772 431.836 68.1104 432.201 68.1436 432.201Z\" fill=#263238 /><path d=\"M68.2105 406.242C68.2769 406.242 68.2603 405.082 68.194 402.96C68.0778 400.854 67.7792 397.821 67.182 394.091C66.5516 390.377 65.6725 385.951 64.2956 381.16C63.6984 378.972 62.2883 373.717 58.8877 365.859C54.4087 355.217 48.3041 346.53 42.9957 341.142C41.7515 339.717 40.3747 338.689 39.2632 337.678C38.6826 337.197 38.1849 336.716 37.6707 336.335C37.1564 335.97 36.6753 335.638 36.2274 335.34C34.4856 334.147 33.5069 333.517 33.4737 333.583C33.3244 333.798 37.3887 336.186 42.5146 341.64C47.6239 347.094 53.5461 355.73 58.0085 366.274C60.4968 371.993 62.222 377.099 63.4496 381.426C64.8762 386.183 65.8052 390.543 66.5185 394.223C67.1986 397.92 67.5802 400.921 67.829 403.009C68.0115 405.082 68.1442 406.242 68.2105 406.242Z\" fill=#263238 /><path d=\"M43.1123 452.046L45.7002 487.688H91.535L94.1395 452.046H43.1123Z\" fill=#263238 /><path d=\"M99.6141 437.985H38.6836V452.043H99.6141V437.985Z\" fill=#263238 /><path d=\"M38.6836 486.325V490.221H41.5369H98.6023V486.325H38.6836Z\" fill=#455A64 /><path d=\"M44.3387 497.067L41.5352 490.221H96.4109L93.1429 497.067H44.3387Z\" fill=#455A64 /><path d=\"M93.2765 463.695C93.2931 463.711 93.2101 463.811 93.0608 464.026C92.8784 464.275 92.6461 464.573 92.3807 464.938C91.7337 465.767 90.8379 466.911 89.7099 468.353L89.5938 468.502L89.4777 468.336C87.8022 466.016 85.5627 462.916 82.9251 459.269H83.3066C81.3492 462.037 79.176 465.104 76.8536 468.403L76.6545 468.685L76.4223 468.419C74.0335 465.585 71.4457 462.518 68.7583 459.318H69.2062C69.0735 459.484 68.9242 459.667 68.7915 459.849C66.4193 462.816 64.1134 465.701 61.9403 468.419L61.7081 468.701L61.4924 468.403C59.17 465.12 56.9968 462.054 55.0394 459.269L55.4209 459.285C52.2359 462.916 49.5319 465.983 47.4583 468.336L47.309 468.502L47.2095 468.32C46.1644 466.563 45.3183 465.154 44.7211 464.142C44.4557 463.695 44.2567 463.314 44.0742 463.032C43.9415 462.783 43.8586 462.634 43.8752 462.634C43.8917 462.634 43.9747 462.75 44.1406 462.982C44.3231 463.264 44.5553 463.612 44.8539 464.06C45.4843 465.054 46.3634 466.43 47.4749 468.171L47.2261 468.154C49.2665 465.767 51.9207 462.65 55.056 458.987L55.255 458.755L55.4375 459.003C57.4116 461.772 59.6179 464.822 61.9569 468.088L61.5256 468.071C63.6987 465.336 65.9879 462.468 68.3601 459.484C68.5094 459.302 68.6421 459.119 68.7749 458.954L68.9905 458.688L69.2228 458.954C71.9102 462.153 74.4814 465.237 76.8536 468.071L76.4223 468.088C78.7779 464.806 80.9676 461.739 82.9417 459.003L83.1407 458.738L83.3232 459.003C85.9111 462.684 88.1008 465.817 89.7431 468.171H89.5108C90.6886 466.762 91.6176 465.651 92.2812 464.839C92.5798 464.491 92.8286 464.209 93.0276 463.977C93.1769 463.778 93.2765 463.678 93.2765 463.695Z\" fill=#E0E0E0 /><path d=\"M94.772 451.809C94.772 451.975 83.2926 452.091 69.1258 452.091C54.959 452.091 43.4795 451.958 43.4795 451.809C43.4795 451.66 54.959 451.527 69.1258 451.527C83.2926 451.527 94.772 451.643 94.772 451.809Z\" fill=#455A64 /><path d=\"M97.0919 490.604C97.0919 490.77 84.6171 490.886 69.2227 490.886C53.8283 490.886 41.3535 490.753 41.3535 490.604C41.3535 490.455 53.8283 490.322 69.2227 490.322C84.6005 490.322 97.0919 490.438 97.0919 490.604Z\" fill=#263238 /><path d=\"M381.671 49.1336L379.01 75.0893L378.932 75.9822C378.259 82.5925 372.374 87.3858 365.785 86.7122C359.179 86.023 354.39 80.1489 355.063 73.5386L355.564 68.5573L357.786 46.69C358.272 41.9907 362.482 38.5602 367.193 39.0458L374.017 39.735C378.729 40.2206 382.156 44.4343 381.671 49.1336Z\" fill=#FFBE9D /><path d=\"M390.607 77.257C390.607 77.257 390.607 77.257 390.591 77.2727C390.122 77.0847 389.668 76.8967 389.214 76.7087C387.445 85.9037 378.211 92.9213 367.082 92.9213C354.796 92.9213 344.825 84.3999 344.653 73.8108L355.5 69.0176C363.921 71.4925 371.903 71.8058 379.369 69.3779L390.607 77.257Z\" fill=#FFBE9D /><path opacity=0.5 d=\"M381.967 44.3621L379.306 70.3178C377.068 71.1637 374.673 71.6023 372.2 71.6023C365.845 71.6023 360.085 68.6417 355.844 63.8014L358.066 41.9341C358.552 37.2348 362.762 33.8044 367.473 34.29L374.297 34.9792C379.008 35.4491 382.436 39.6628 381.967 44.3621Z\" fill=#F39371 /><path d=\"M397.915 42.6855C396.303 47.8234 392.281 49.2018 388.524 49.9851C388.477 49.9851 388.43 50.0007 388.384 50.0164C386.411 53.3842 383.751 56.6267 380.761 59.274C377.599 62.4695 373.655 64.7095 369.32 65.43C369.194 65.4457 369.054 65.477 368.928 65.4927C368.678 65.524 368.427 65.5867 368.177 65.6023C368.005 65.618 367.833 65.6023 367.661 65.618C367.504 65.618 367.379 65.618 367.222 65.618C366.878 65.618 366.549 65.618 366.221 65.5867C365.892 65.5553 365.563 65.5083 365.235 65.4614C365.094 65.43 364.953 65.4144 364.812 65.383C364.64 65.3517 364.468 65.336 364.295 65.289C364.045 65.2264 363.81 65.1324 363.575 65.0541C363.45 65.0228 363.325 64.9758 363.2 64.9444C359.021 63.5816 355.483 60.7464 352.838 57.1123C350.287 54.0264 348.158 50.408 346.734 46.7895C346.609 46.7425 346.484 46.6956 346.358 46.6486C342.852 45.3171 339.221 43.2964 338.439 38.0959C337.797 33.8508 339.362 28.431 342.868 28.3997C343.901 28.384 345.059 28.8696 346.171 29.6372C348.237 22.7762 352.478 15.6333 357.409 10.887C359.506 8.49039 361.807 7.00228 364.264 6.2034C365.595 5.67082 366.925 5.35753 368.24 5.34187C369.147 5.3262 370.024 5.3732 370.9 5.45152C371.777 5.49851 372.653 5.60816 373.546 5.74914C374.829 5.96844 376.097 6.48536 377.333 7.20592C379.634 8.38074 381.685 10.2135 383.391 12.892C387.523 18.3589 390.606 26.0657 391.608 33.1616C392.813 32.5664 394.018 32.2688 395.051 32.4411C398.479 33.005 399.183 38.5971 397.915 42.6855Z\" fill=#FFBE9D /><path d=\"M380.543 34.6187C380.277 34.65 380.01 34.5091 379.87 34.2584C377.616 30.3424 374.016 32.1281 373.859 32.2064C373.515 32.3787 373.092 32.2377 372.905 31.8931C372.732 31.5485 372.873 31.1099 373.218 30.9376C374.924 30.0761 378.774 29.4965 381.106 33.5535C381.294 33.8981 381.184 34.3211 380.84 34.5247C380.73 34.5874 380.637 34.6187 380.543 34.6187Z\" fill=#0E1A2F /><path d=\"M367.379 52.2565C367.536 52.0372 367.818 51.9275 368.099 51.9902C372.498 52.9927 373.64 49.1393 373.687 48.967C373.797 48.591 374.188 48.3717 374.564 48.4814C374.939 48.591 375.158 48.9826 375.049 49.3586C374.532 51.207 372.325 54.4181 367.786 53.3843C367.411 53.2903 367.16 52.9144 367.254 52.5384C367.27 52.4288 367.317 52.3348 367.379 52.2565Z\" fill=#0E1A2F /><path d=\"M361.322 30.8119C361.15 30.9529 360.899 30.9999 360.68 30.9059C357.237 29.3552 355.64 32.3314 355.578 32.4567C355.421 32.7543 355.077 32.864 354.78 32.7073C354.482 32.5507 354.373 32.1904 354.529 31.9084C355.265 30.483 357.613 28.196 361.181 29.8094C361.479 29.9504 361.619 30.295 361.479 30.5926C361.432 30.6866 361.385 30.7649 361.322 30.8119Z\" fill=#0E1A2F /><path d=\"M367.176 48.5748C366.237 49.2796 365.267 49.6086 364.421 49.5459C363.921 49.4989 363.482 49.3423 363.091 49.029C362.653 48.7001 362.355 48.2458 362.199 47.6819C361.886 46.6637 362.011 45.3166 362.621 43.8128L364.922 36.012C365.016 35.7144 365.314 35.5421 365.627 35.6361C365.924 35.7301 366.096 36.0433 366.002 36.341L363.701 44.1888C363.06 45.8022 363.075 46.93 363.388 47.5879C363.482 47.8229 363.623 47.9952 363.78 48.1205C364.39 48.5904 365.345 48.4494 366.3 47.7915C366.347 47.7602 366.378 47.7445 366.425 47.7132C366.675 47.5252 367.051 47.5566 367.254 47.7915C367.27 47.8072 367.286 47.8385 367.301 47.8699C367.427 48.1048 367.395 48.3868 367.176 48.5748Z\" fill=#0E1A2F /><path d=\"M378.148 38.6754C378.007 39.8816 376.943 40.7431 375.738 40.6178C374.548 40.4925 373.672 39.396 373.813 38.1898C373.954 36.9837 375.018 36.1221 376.223 36.2475C377.413 36.3884 378.273 37.4693 378.148 38.6754Z\" fill=#0E1A2F /><path d=\"M360.477 37.9235C360.336 39.1296 359.271 39.9912 358.066 39.8658C356.877 39.7249 356.016 38.644 356.141 37.4379C356.282 36.2317 357.346 35.3702 358.551 35.4955C359.757 35.6208 360.617 36.7173 360.477 37.9235Z\" fill=#0E1A2F /><path d=\"M334.949 485.828C334.996 486.392 335.027 486.784 334.996 486.878L314.727 502.73C312.692 504.187 313.13 507.508 315.463 508.338C315.76 508.432 316.042 508.541 316.339 508.62C321.833 510.202 331.834 510.719 335.81 506.286C337.547 504.328 340.02 503.263 342.556 503.372L343.401 503.419C349.896 503.686 348.128 495.853 346.938 489.039C346.938 489.039 346.672 486.424 346.422 483.432C346.469 484.512 346.5 485.578 346.547 486.658L334.949 485.828Z\" fill=#223B77 /><path d=\"M379.556 482.444C379.275 485.703 378.993 488.538 378.993 488.538C377.694 495.916 375.784 504.421 382.828 504.124L383.736 504.077C386.49 503.967 389.167 505.126 391.045 507.241C395.334 512.05 406.196 511.486 412.144 509.763C412.472 509.669 412.785 509.559 413.098 509.45C415.634 508.541 416.088 504.954 413.897 503.372L391.906 486.172C391.874 486.078 391.89 485.656 391.953 485.029L379.416 485.922C379.478 484.763 379.51 483.603 379.556 482.444Z\" fill=#223B77 /><path d=\"M326.137 197.511C322.068 216.559 320.487 260.763 319.939 280.469C317.92 352.806 319.579 422.184 332.382 487.973L338.361 487.629L348.66 488.49C348.613 487.363 348.519 486.266 348.55 485.138C351.243 400.019 351.258 328.621 358.693 263.426C359.1 259.823 363.31 259.933 363.639 263.536C369.399 328.824 373.766 400.175 376.395 485.138C376.426 486.266 376.332 487.363 376.285 488.49L386.584 487.629L394.348 487.832C406.885 421.808 403.895 352.196 401.704 277.289C401.187 259.776 399.794 212.079 396.179 195.146L326.137 197.511Z\" fill=#0E1A2F /><path d=\"M434.306 162.737L434.103 162.533L433.884 162.22L434.103 161.828C434.244 162.11 434.306 162.455 434.306 162.737Z\" fill=#001E48 /><path d=\"M418.248 94.2054L414.695 106.314L399.137 159.384C396.366 169.112 395.099 179.215 395.333 189.288H326.622C327.639 178.401 328.187 171.603 327.53 161.045C327.154 154.889 326.011 148.842 324.431 142.937C320.596 128.651 318.671 102.382 320.095 86.0443C327.843 80.2015 335.966 76.4108 344.293 73.9358C344.418 73.9045 344.528 73.8732 344.653 73.8262C344.825 84.4152 354.795 92.9366 367.082 92.9366C378.21 92.9366 387.445 85.919 389.213 76.7241C389.652 76.912 390.121 77.1 390.591 77.288C400.264 81.3294 411.361 87.1408 416.682 92.4353C417.261 92.9992 417.794 93.5945 418.248 94.2054Z\" fill=white /><path d=\"M321.582 129.951L315.494 155.656L311.017 192.64C310.329 198.31 305.101 202.179 299.638 201.051C294.896 200.064 291.625 195.6 292.016 190.65C293.456 172.605 296.367 132.959 296.852 130.217C298.355 122.025 300.108 114.193 301.924 106.972C305.899 91.1037 317.873 84.5247 320.487 82.8486L319 83.7885L321.582 129.951Z\" fill=#56C2D5 /><path d=\"M432.679 196.226C427.936 198.137 422.646 195.318 421.441 190.227L413.865 158.303L407.589 131.784C406.712 111.185 407.495 95.5521 410.14 85.6366L410.171 85.292C412.785 86.9681 423.256 92.9675 427.216 108.82C429.955 119.753 432.553 132.05 434.306 144.769C434.807 148.215 436.952 174.735 437.985 187.47C438.282 191.276 436.138 194.832 432.679 196.226Z\" fill=#56C2D4 /><path d=\"M416.667 90.1329L414.695 104.043L408.027 151.004C405.586 159.729 404.193 168.752 403.88 177.837L402.111 231.174C402.048 233.226 399.685 234.229 398.229 232.866L387.195 222.496C377.334 213.254 371.433 200.503 370.573 186.985C370.4 184.682 370.4 182.333 370.557 179.983C370.557 179.983 370.573 179.967 370.588 179.921C378.555 162.674 382.421 143.814 381.936 124.829L380.449 68.2969C391.014 71.931 409.702 83.1623 416.667 90.1329Z\" fill=#2DC0DA /><path d=\"M316.824 85.2765L317.137 99.3274L318.17 146.774C319.563 155.734 319.876 164.867 319.109 173.921L314.539 227.085C314.367 229.137 316.574 230.422 318.201 229.247L330.378 220.35C332.491 218.799 334.761 216.324 337.062 213.332C349.442 197.151 354.138 176.427 350.788 156.33C348.425 142.153 347.908 127.899 349.27 113.018L353.762 68.8447C349.693 67.7012 324.572 79.2457 316.824 85.2765Z\" fill=#2DC0DA /><path d=\"M355.86 63.1113C355.86 63.1113 340.678 65.3826 344.105 78.9949C345.076 82.864 345.655 86.8114 346.203 90.7588L349.208 112.266C352.432 98.7789 356.267 74.8125 355.86 63.1113Z\" fill=#56C2D4 /><path d=\"M379.807 64.4746C379.807 64.4746 394.99 66.7459 391.562 80.3582C390.592 84.2273 381.858 114.804 381.858 114.804C378.634 101.333 379.401 76.1915 379.807 64.4746Z\" fill=#56C2D4 /><path d=\"M394.003 22.9173C393.565 21.1786 393.096 20.0508 391.703 18.8603C389.903 17.3252 388.713 17.5915 386.772 17.1216C388.103 13.1272 388.087 10.245 384.988 7.09643C380.246 2.2875 372.216 -1.20564 365.439 0.39212C360.884 1.47295 357.926 4.82511 355.093 8.28691C353.716 9.97866 350.585 19.6905 347.439 13.8007C346.281 15.5551 346.391 18.7037 347.095 20.6304C345.013 21.3353 343.464 19.1736 341.805 18.359C341.852 20.5834 342.368 23.4029 343.683 25.5176C343.965 25.9719 343.354 27.2094 343.339 27.7576C343.229 34.3993 348.065 40.2734 347.455 46.8524C347.831 42.6857 348.582 38.6756 349.224 34.5089C349.505 32.6605 349.818 30.9375 350.476 29.1204C350.585 28.8228 350.758 28.4782 350.961 28.1179C352.98 27.554 354.968 26.4888 356.877 25.9406C360.149 25.0164 363.827 24.9537 367.208 24.9067C371.011 24.8597 380.23 25.8309 382.108 21.1473C382.155 23.6849 381.341 26.1599 381.826 28.7758C382.265 31.1568 383.501 33.6787 384.581 35.8247C385.536 37.7514 386.944 46.1318 387.524 48.2935C388.51 42.3411 392.25 36.9682 394.035 31.1881C394.833 28.5722 394.676 25.6116 394.003 22.9173Z\" fill=#0E1A2F /><path d=\"M401.344 135.01C401.328 135.01 401.312 135.01 401.281 135.01L389.417 134.838C387.492 134.807 385.911 133.287 385.817 131.361L385.128 117.341C385.034 115.587 386.208 114.02 387.914 113.613C390.747 112.924 399.387 110.856 408.074 115.352C409.576 116.135 410.328 117.889 409.874 119.534C408.935 122.949 406.963 129.293 404.427 133.35C403.77 134.384 402.596 135.01 401.344 135.01ZM396.147 113.3C392.469 113.3 389.526 114.005 388.102 114.349C386.772 114.678 385.848 115.9 385.927 117.278L386.615 131.298C386.693 132.802 387.93 134.008 389.448 134.039L401.312 134.212C401.328 134.212 401.344 134.212 401.359 134.212C402.345 134.212 403.269 133.71 403.77 132.911C406.258 128.948 408.199 122.683 409.123 119.315C409.483 118.015 408.888 116.636 407.73 116.025C403.644 113.926 399.575 113.3 396.147 113.3Z\" fill=#F7F9FE /><path d=\"M325.934 133.35C323.398 129.293 321.426 122.965 320.487 119.534C320.033 117.89 320.784 116.119 322.287 115.352C330.974 110.841 339.598 112.924 342.446 113.613C344.137 114.02 345.311 115.587 345.232 117.341L344.544 131.361C344.45 133.288 342.869 134.807 340.944 134.838L329.08 135.011C329.064 135.011 329.048 135.011 329.017 135.011C327.765 135.011 326.591 134.384 325.934 133.35ZM322.647 116.041C321.473 116.652 320.894 118.031 321.254 119.331C322.193 122.714 324.134 128.964 326.607 132.927C327.108 133.726 328.031 134.227 329.017 134.227C329.033 134.227 329.048 134.227 329.064 134.227L340.928 134.055C342.446 134.039 343.683 132.833 343.761 131.314L344.45 117.294C344.512 115.916 343.605 114.678 342.274 114.365C340.85 114.02 337.907 113.316 334.229 113.316C330.786 113.3 326.716 113.927 322.647 116.041Z\" fill=#F7F9FE /><g><rect x=130 y=195 width=450 height=153 rx=6 fill=white /><text x=50% y=48% dominant-baseline=middle text-anchor=middle font-size=48px fill=black font-weight=bold>Hey {{userName}}</text><text x=50% y=58% dominant-baseline=bottom text-anchor=middle font-size=30px fill=black>Great to have you at Nearpeer!</text></g><path d=\"M313.199 189.152L318.677 201.573C319.24 202.842 318.927 204.44 317.754 205.207C316.439 206.069 314.232 205.756 310.914 200.132L308.816 197.767L309.223 201.479C309.521 204.189 306.093 205.662 304.387 203.547C303.776 202.795 303.15 201.761 302.524 200.383C301.961 202.466 299.66 203.578 297.688 202.701C295.262 201.62 292.366 198.863 291.005 191.987C290.864 188.133 293.963 184.954 297.813 185.001L307.11 185.126C309.755 185.173 312.135 186.739 313.199 189.152Z\" fill=#E78C6B /><path d=\"M415.75 184.152L410.272 196.573C409.709 197.842 410.022 199.44 411.196 200.207C412.51 201.069 414.717 200.756 418.035 195.132L420.133 192.767L419.726 196.479C419.428 199.189 422.856 200.662 424.562 198.547C425.173 197.795 425.799 196.761 426.425 195.383C426.988 197.466 429.289 198.578 431.261 197.701C433.687 196.62 436.583 193.863 437.945 186.987C438.085 183.133 434.986 179.954 431.136 180.001L421.839 180.126C419.194 180.173 416.815 181.739 415.75 184.152Z\" fill=#E78C6B /><path d=\"M462.223 396H458.003V410.23H462.223V396Z\" fill=white /><path d=\"M467.23 405.225V401.005H453V405.225H467.23Z\" fill=white /><path opacity=0.2 d=\"M636.36 159.72C639.32 159.72 641.72 157.32 641.72 154.36C641.72 151.4 639.32 149 636.36 149C633.4 149 631 151.4 631 154.36C631 157.32 633.4 159.72 636.36 159.72Z\" stroke=#606060 stroke-width=0.6545 stroke-miterlimit=10 /></svg> <svg class=welcome-mobile-image width=100% height=100% viewBox=\"0 0 360 640\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_2890:7194)><rect width=360 height=640 fill=white /><path d=\"M18.665 237.394C-51.6554 254.407 -117.124 234.654 -164.918 299.303C-201.677 349.047 -196.655 410.41 -161.888 455.984C-78.5133 565.231 131.807 560.85 249.647 488.164C385.068 404.471 457.934 232.967 347.703 147.022C313.236 120.031 231.843 106.457 188.26 117.525C109.902 137.25 96.3647 218.574 18.665 237.394Z\" fill=#2DC0DA /><path opacity=0.9 d=\"M18.665 237.394C-51.6554 254.407 -117.124 234.654 -164.918 299.303C-201.677 349.047 -196.655 410.41 -161.888 455.984C-78.5133 565.231 131.807 560.85 249.647 488.164C385.068 404.471 457.934 232.967 347.703 147.022C313.236 120.031 231.843 106.457 188.26 117.525C109.902 137.25 96.3647 218.574 18.665 237.394Z\" fill=white /><path d=\"M7.24725 554.941L-4 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M12.7224 554.941L1.4751 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M18.2053 554.941L6.95801 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M23.6789 554.941L12.4316 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M29.1619 554.941L17.9146 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M34.637 554.941L23.3979 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M40.1198 554.941L28.8726 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M45.6017 554.941L34.3545 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M51.0769 554.941L39.8296 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M56.5598 554.941L45.3125 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M62.0349 554.941L50.7876 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M67.5168 554.941L56.2695 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M72.9914 554.941L61.7441 566.189\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path opacity=0.1 d=\"M46 544H-4V548H46V544Z\" fill=#FF2C2C /><path opacity=0.1 d=\"M73 544H52V548H73V544Z\" fill=#2DC0DA /><path d=\"M200.671 142.134L198.01 168.089L197.932 168.982C197.259 175.592 191.374 180.386 184.785 179.712C178.179 179.023 173.39 173.149 174.063 166.539L174.564 161.557L176.786 139.69C177.272 134.991 181.482 131.56 186.193 132.046L193.017 132.735C197.729 133.221 201.156 137.434 200.671 142.134Z\" fill=#FFBE9D /><path d=\"M209.607 170.257C209.607 170.257 209.607 170.257 209.591 170.273C209.122 170.085 208.668 169.897 208.214 169.709C206.445 178.904 197.211 185.921 186.082 185.921C173.796 185.921 163.825 177.4 163.653 166.811L174.5 162.018C182.921 164.493 190.903 164.806 198.369 162.378L209.607 170.257Z\" fill=#FFBE9D /><path opacity=0.5 d=\"M200.967 137.362L198.306 163.318C196.068 164.164 193.673 164.602 191.2 164.602C184.845 164.602 179.085 161.642 174.844 156.801L177.066 134.934C177.552 130.235 181.762 126.804 186.473 127.29L193.297 127.979C198.008 128.449 201.436 132.663 200.967 137.362Z\" fill=#F39371 /><path d=\"M216.916 135.686C215.304 140.824 211.281 142.203 207.525 142.986C207.478 142.986 207.431 143.002 207.384 143.017C205.412 146.385 202.751 149.628 199.762 152.275C196.6 155.47 192.656 157.71 188.32 158.431C188.195 158.447 188.054 158.478 187.929 158.494C187.678 158.525 187.428 158.588 187.178 158.603C187.005 158.619 186.833 158.603 186.661 158.619C186.505 158.619 186.379 158.619 186.223 158.619C185.878 158.619 185.55 158.619 185.221 158.588C184.892 158.556 184.564 158.509 184.235 158.462C184.094 158.431 183.953 158.415 183.812 158.384C183.64 158.353 183.468 158.337 183.296 158.29C183.045 158.227 182.811 158.133 182.576 158.055C182.451 158.024 182.325 157.977 182.2 157.945C178.021 156.583 174.484 153.747 171.839 150.113C169.288 147.027 167.159 143.409 165.735 139.791C165.609 139.744 165.484 139.697 165.359 139.65C161.853 138.318 158.222 136.297 157.439 131.097C156.797 126.852 158.363 121.432 161.869 121.401C162.902 121.385 164.06 121.871 165.171 122.638C167.237 115.777 171.479 108.634 176.409 103.888C178.506 101.491 180.807 100.003 183.265 99.2044C184.595 98.6718 185.925 98.3585 187.24 98.3428C188.148 98.3272 189.024 98.3742 189.901 98.4525C190.777 98.4995 191.654 98.6091 192.546 98.7501C193.83 98.9694 195.097 99.4863 196.334 100.207C198.635 101.382 200.685 103.214 202.391 105.893C206.523 111.36 209.607 119.067 210.608 126.163C211.813 125.567 213.019 125.27 214.052 125.442C217.479 126.006 218.184 131.598 216.916 135.686Z\" fill=#FFBE9D /><path d=\"M199.543 127.619C199.277 127.65 199.01 127.509 198.87 127.258C196.616 123.342 193.016 125.128 192.859 125.206C192.515 125.379 192.092 125.238 191.905 124.893C191.732 124.549 191.873 124.11 192.218 123.938C193.924 123.076 197.774 122.496 200.106 126.554C200.294 126.898 200.184 127.321 199.84 127.525C199.73 127.587 199.637 127.619 199.543 127.619Z\" fill=#0E1A2F /><path d=\"M186.38 145.256C186.536 145.037 186.818 144.928 187.1 144.99C191.498 145.993 192.641 142.139 192.688 141.967C192.797 141.591 193.188 141.372 193.564 141.481C193.94 141.591 194.159 141.983 194.049 142.359C193.533 144.207 191.326 147.418 186.787 146.384C186.411 146.29 186.161 145.914 186.255 145.538C186.27 145.429 186.317 145.335 186.38 145.256Z\" fill=#0E1A2F /><path d=\"M180.323 123.812C180.15 123.953 179.9 124 179.681 123.906C176.237 122.355 174.641 125.331 174.578 125.457C174.422 125.754 174.077 125.864 173.78 125.707C173.483 125.551 173.373 125.19 173.53 124.908C174.265 123.483 176.613 121.196 180.182 122.809C180.479 122.95 180.62 123.295 180.479 123.593C180.432 123.687 180.385 123.765 180.323 123.812Z\" fill=#0E1A2F /><path d=\"M186.177 141.576C185.237 142.281 184.267 142.61 183.422 142.547C182.921 142.5 182.483 142.343 182.091 142.03C181.653 141.701 181.356 141.247 181.199 140.683C180.886 139.665 181.011 138.318 181.622 136.814L183.923 129.013C184.017 128.715 184.314 128.543 184.627 128.637C184.924 128.731 185.097 129.044 185.003 129.342L182.702 137.19C182.06 138.803 182.076 139.931 182.389 140.589C182.483 140.824 182.624 140.996 182.78 141.121C183.391 141.591 184.345 141.45 185.3 140.793C185.347 140.761 185.378 140.746 185.425 140.714C185.676 140.526 186.051 140.558 186.255 140.793C186.271 140.808 186.286 140.84 186.302 140.871C186.427 141.106 186.396 141.388 186.177 141.576Z\" fill=#0E1A2F /><path d=\"M197.148 131.676C197.007 132.883 195.943 133.744 194.738 133.619C193.548 133.493 192.672 132.397 192.813 131.191C192.954 129.985 194.018 129.123 195.223 129.248C196.413 129.389 197.273 130.47 197.148 131.676Z\" fill=#0E1A2F /><path d=\"M179.477 130.924C179.336 132.131 178.272 132.992 177.067 132.867C175.877 132.726 175.016 131.645 175.141 130.439C175.282 129.233 176.347 128.371 177.552 128.496C178.757 128.622 179.618 129.718 179.477 130.924Z\" fill=#0E1A2F /><path d=\"M153.949 578.828C153.996 579.392 154.027 579.784 153.996 579.878L133.727 595.73C131.692 597.187 132.13 600.508 134.463 601.338C134.76 601.432 135.042 601.541 135.339 601.62C140.833 603.202 150.834 603.719 154.81 599.286C156.547 597.328 159.02 596.263 161.556 596.372L162.401 596.419C168.896 596.686 167.128 588.853 165.938 582.039C165.938 582.039 165.672 579.424 165.422 576.432C165.469 577.512 165.5 578.578 165.547 579.658L153.949 578.828Z\" fill=#223B77 /><path d=\"M198.557 575.444C198.275 578.703 197.994 581.538 197.994 581.538C196.694 588.916 194.785 597.421 201.828 597.124L202.736 597.077C205.491 596.967 208.167 598.126 210.045 600.241C214.334 605.05 225.196 604.486 231.144 602.763C231.473 602.669 231.786 602.559 232.099 602.45C234.634 601.541 235.088 597.954 232.897 596.372L210.906 579.172C210.875 579.078 210.891 578.656 210.953 578.029L198.416 578.922C198.479 577.763 198.51 576.603 198.557 575.444Z\" fill=#223B77 /><path d=\"M145.137 290.512C141.067 309.56 139.486 353.764 138.938 373.47C136.919 445.807 138.578 515.184 151.382 580.974L157.361 580.63L167.66 581.491C167.613 580.364 167.519 579.267 167.55 578.139C170.242 493.02 170.258 421.622 177.692 356.427C178.099 352.824 182.31 352.934 182.638 356.537C188.398 421.825 192.765 493.176 195.395 578.139C195.426 579.267 195.332 580.364 195.285 581.491L205.584 580.63L213.347 580.833C225.884 514.809 222.895 445.197 220.703 370.29C220.187 352.777 218.794 305.08 215.178 288.146L145.137 290.512Z\" fill=#0E1A2F /><path d=\"M253.306 255.737L253.103 255.533L252.884 255.22L253.103 254.828C253.244 255.11 253.306 255.455 253.306 255.737Z\" fill=#001E48 /><path d=\"M237.248 187.205L233.695 199.314L218.137 252.384C215.366 262.112 214.099 272.215 214.333 282.288H145.622C146.639 271.401 147.187 264.603 146.53 254.045C146.154 247.889 145.011 241.842 143.431 235.937C139.596 221.651 137.671 195.382 139.095 179.044C146.843 173.202 154.966 169.411 163.293 166.936C163.418 166.904 163.528 166.873 163.653 166.826C163.825 177.415 173.795 185.937 186.082 185.937C197.21 185.937 206.445 178.919 208.213 169.724C208.652 169.912 209.121 170.1 209.591 170.288C219.264 174.329 230.361 180.141 235.682 185.435C236.261 185.999 236.794 186.594 237.248 187.205Z\" fill=white /><path d=\"M140.582 222.952L134.494 248.657L130.017 285.641C129.329 291.311 124.101 295.18 118.638 294.052C113.896 293.065 110.625 288.601 111.016 283.651C112.456 265.606 115.367 225.96 115.852 223.218C117.355 215.026 119.108 207.194 120.924 199.973C124.899 184.105 136.873 177.526 139.487 175.85L138 176.789L140.582 222.952Z\" fill=#56C2D5 /><path d=\"M251.679 289.227C246.936 291.138 241.646 288.319 240.441 283.228L232.865 251.304L226.589 224.785C225.712 204.186 226.495 188.553 229.14 178.638L229.171 178.293C231.785 179.969 242.256 185.968 246.216 201.821C248.955 212.754 251.553 225.051 253.306 237.77C253.807 241.216 255.952 267.736 256.985 280.471C257.282 284.277 255.138 287.833 251.679 289.227Z\" fill=#56C2D4 /><path d=\"M235.667 183.133L233.694 197.043L227.027 244.004C224.585 252.729 223.192 261.752 222.879 270.837L221.11 324.174C221.048 326.226 218.684 327.229 217.229 325.866L206.194 315.496C196.334 306.254 190.433 293.503 189.572 279.985C189.4 277.682 189.4 275.333 189.556 272.983C189.556 272.983 189.572 272.967 189.588 272.921C197.554 255.674 201.42 236.814 200.935 217.829L199.448 161.297C210.013 164.931 228.702 176.162 235.667 183.133Z\" fill=#2DC0DA /><path d=\"M135.824 178.276L136.137 192.327L137.17 239.774C138.564 248.734 138.877 257.867 138.11 266.921L133.539 320.085C133.367 322.137 135.574 323.422 137.202 322.247L149.379 313.35C151.492 311.799 153.761 309.324 156.062 306.332C168.443 290.151 173.138 269.427 169.789 249.33C167.425 235.153 166.909 220.899 168.271 206.018L172.763 161.845C168.693 160.701 143.572 172.246 135.824 178.276Z\" fill=#2DC0DA /><path d=\"M174.86 156.111C174.86 156.111 159.678 158.383 163.105 171.995C164.076 175.864 164.655 179.811 165.203 183.759L168.208 205.266C171.432 191.779 175.267 167.813 174.86 156.111Z\" fill=#56C2D4 /><path d=\"M198.807 157.475C198.807 157.475 213.99 159.746 210.562 173.358C209.592 177.227 200.858 207.804 200.858 207.804C197.634 194.333 198.401 169.191 198.807 157.475Z\" fill=#56C2D4 /><path d=\"M213.003 115.917C212.565 114.179 212.095 113.051 210.702 111.86C208.902 110.325 207.713 110.591 205.772 110.122C207.102 106.127 207.087 103.245 203.988 100.096C199.245 95.2875 191.216 91.7944 184.438 93.3921C179.884 94.473 176.926 97.8251 174.093 101.287C172.715 102.979 169.585 112.691 166.439 106.801C165.281 108.555 165.39 111.704 166.095 113.63C164.013 114.335 162.463 112.174 160.804 111.359C160.851 113.583 161.368 116.403 162.682 118.518C162.964 118.972 162.354 120.209 162.338 120.758C162.229 127.399 167.065 133.273 166.455 139.852C166.83 135.686 167.581 131.676 168.223 127.509C168.505 125.661 168.818 123.937 169.475 122.12C169.585 121.823 169.757 121.478 169.961 121.118C171.98 120.554 173.967 119.489 175.877 118.941C179.148 118.016 182.826 117.954 186.207 117.907C190.01 117.86 199.229 118.831 201.108 114.147C201.155 116.685 200.341 119.16 200.826 121.776C201.264 124.157 202.501 126.679 203.581 128.825C204.535 130.751 205.944 139.132 206.523 141.293C207.509 135.341 211.25 129.968 213.034 124.188C213.833 121.572 213.676 118.612 213.003 115.917Z\" fill=#0E1A2F /><path d=\"M220.344 228.011C220.328 228.011 220.313 228.011 220.281 228.011L208.417 227.839C206.492 227.808 204.911 226.288 204.817 224.362L204.129 210.342C204.035 208.588 205.209 207.021 206.915 206.614C209.748 205.925 218.388 203.857 227.074 208.353C228.577 209.136 229.328 210.89 228.874 212.535C227.935 215.95 225.963 222.294 223.427 226.351C222.77 227.385 221.596 228.011 220.344 228.011ZM215.148 206.301C211.469 206.301 208.527 207.006 207.103 207.35C205.772 207.679 204.849 208.901 204.927 210.279L205.616 224.299C205.694 225.803 206.93 227.009 208.449 227.04L220.313 227.213C220.328 227.213 220.344 227.213 220.36 227.213C221.346 227.213 222.269 226.711 222.77 225.912C225.259 221.949 227.2 215.684 228.123 212.316C228.483 211.016 227.888 209.637 226.73 209.026C222.645 206.927 218.575 206.301 215.148 206.301Z\" fill=#F7F9FE /><path d=\"M144.933 226.351C142.398 222.294 140.426 215.966 139.486 212.535C139.032 210.891 139.784 209.12 141.286 208.353C149.973 203.842 158.597 205.925 161.446 206.614C163.136 207.021 164.31 208.588 164.232 210.342L163.543 224.362C163.449 226.289 161.868 227.808 159.943 227.839L148.079 228.012C148.064 228.012 148.048 228.012 148.017 228.012C146.764 228.012 145.591 227.385 144.933 226.351ZM141.646 209.042C140.472 209.653 139.893 211.032 140.253 212.332C141.192 215.715 143.133 221.965 145.606 225.928C146.107 226.727 147.031 227.228 148.017 227.228C148.032 227.228 148.048 227.228 148.064 227.228L159.928 227.056C161.446 227.04 162.682 225.834 162.761 224.315L163.449 210.295C163.512 208.917 162.604 207.679 161.274 207.366C159.849 207.021 156.907 206.317 153.229 206.317C149.785 206.301 145.716 206.927 141.646 209.042Z\" fill=#F7F9FE /><g filter=url(#filter0_d_2890:7194)><rect x=27 y=288 width=297 height=124 rx=6 fill=white /><text dominant-baseline=middle text-anchor=middle fill=black font-size=22px style=\"width: 100px\" x=50% font-weight=bold y=52%>Hey {{userData.name}}</text><text dominant-baseline=bottom text-anchor=middle fill=black font-size=16px x=48% y=58%>Nice to have you onboard.</text></g><!-- <path d=\"M84.752 337V320.2H87.92V326.968H95.264V320.2H98.432V337H95.264V329.896H87.92V337H84.752ZM112.904 331.768H103.736C103.832 332.68 104.176 333.408 104.768 333.952C105.36 334.48 106.104 334.744 107 334.744C108.472 334.744 109.568 334.016 110.288 332.56L112.544 333.856C111.424 336.176 109.56 337.336 106.952 337.336C105.256 337.336 103.808 336.752 102.608 335.584C101.424 334.4 100.832 332.888 100.832 331.048C100.832 329.192 101.432 327.68 102.632 326.512C103.848 325.344 105.336 324.76 107.096 324.76C108.792 324.76 110.184 325.32 111.272 326.44C112.36 327.544 112.904 328.968 112.904 330.712V331.768ZM107 327.064C106.216 327.064 105.528 327.304 104.936 327.784C104.36 328.248 103.96 328.84 103.736 329.56H110.12C109.976 328.776 109.632 328.168 109.088 327.736C108.544 327.288 107.848 327.064 107 327.064ZM115.056 341.8L115.536 338.992C115.888 339.184 116.248 339.28 116.616 339.28C117.24 339.28 117.688 338.904 117.96 338.152L118.344 337.096L113.448 325.096H116.88L119.952 332.824L122.88 325.096H126.312L120.648 339.16C120.232 340.184 119.704 340.92 119.064 341.368C118.44 341.832 117.656 342.064 116.712 342.064C116.056 342.064 115.504 341.976 115.056 341.8ZM137.887 324.4C137.887 325.04 138.207 325.568 138.847 325.984C139.487 326.384 140.519 326.728 141.943 327.016C143.799 327.4 145.175 328.008 146.071 328.84C146.983 329.672 147.439 330.784 147.439 332.176C147.439 333.6 146.863 334.816 145.711 335.824C144.575 336.832 143.063 337.336 141.175 337.336C139.175 337.336 137.583 336.848 136.399 335.872C135.215 334.896 134.455 333.592 134.119 331.96L136.903 330.544C137.399 333.216 138.815 334.552 141.151 334.552C142.095 334.552 142.847 334.344 143.407 333.928C143.983 333.512 144.271 332.968 144.271 332.296C144.271 331.56 143.935 330.984 143.263 330.568C142.607 330.152 141.559 329.8 140.118 329.512C138.503 329.192 137.223 328.616 136.279 327.784C135.335 326.936 134.863 325.832 134.863 324.472C134.863 323.08 135.407 321.968 136.495 321.136C137.583 320.288 139.007 319.864 140.767 319.864C143.967 319.864 146.095 321.304 147.151 324.184L144.655 325.624C143.983 323.64 142.663 322.648 140.695 322.648C139.895 322.648 139.223 322.8 138.679 323.104C138.151 323.392 137.887 323.824 137.887 324.4ZM160.781 337H157.709C157.325 336.52 157.133 335.888 157.133 335.104C156.301 336.592 154.973 337.336 153.149 337.336C151.965 337.336 150.997 337 150.245 336.328C149.509 335.64 149.141 334.736 149.141 333.616C149.141 332.48 149.533 331.592 150.317 330.952C151.117 330.296 152.141 329.872 153.389 329.68L156.965 329.128V328.672C156.965 327.472 156.237 326.872 154.781 326.872C154.109 326.872 153.581 327 153.197 327.256C152.829 327.512 152.645 327.832 152.645 328.216C152.645 328.312 152.661 328.408 152.693 328.504L149.981 329.416C149.837 329.096 149.765 328.76 149.765 328.408C149.765 327.432 150.221 326.584 151.133 325.864C152.045 325.128 153.261 324.76 154.781 324.76C156.477 324.76 157.765 325.12 158.645 325.84C159.541 326.56 159.989 327.64 159.989 329.08V334.048C159.989 335.248 160.253 336.232 160.781 337ZM153.869 334.888C154.781 334.888 155.525 334.592 156.101 334C156.677 333.392 156.965 332.536 156.965 331.432V331.216L154.085 331.696C152.757 331.92 152.093 332.504 152.093 333.448C152.093 333.912 152.253 334.272 152.573 334.528C152.893 334.768 153.325 334.888 153.869 334.888ZM174.211 337H171.139C170.755 336.52 170.563 335.888 170.563 335.104C169.731 336.592 168.403 337.336 166.579 337.336C165.395 337.336 164.427 337 163.675 336.328C162.939 335.64 162.571 334.736 162.571 333.616C162.571 332.48 162.963 331.592 163.747 330.952C164.547 330.296 165.571 329.872 166.819 329.68L170.395 329.128V328.672C170.395 327.472 169.667 326.872 168.211 326.872C167.539 326.872 167.011 327 166.627 327.256C166.259 327.512 166.075 327.832 166.075 328.216C166.075 328.312 166.091 328.408 166.123 328.504L163.411 329.416C163.267 329.096 163.195 328.76 163.195 328.408C163.195 327.432 163.651 326.584 164.563 325.864C165.475 325.128 166.691 324.76 168.211 324.76C169.907 324.76 171.195 325.12 172.075 325.84C172.971 326.56 173.419 327.64 173.419 329.08V334.048C173.419 335.248 173.683 336.232 174.211 337ZM167.299 334.888C168.211 334.888 168.955 334.592 169.531 334C170.107 333.392 170.395 332.536 170.395 331.432V331.216L167.515 331.696C166.187 331.92 165.523 332.504 165.523 333.448C165.523 333.912 165.683 334.272 166.003 334.528C166.323 334.768 166.755 334.888 167.299 334.888ZM188.48 320.2V337H185.456V335.32C185.12 335.912 184.624 336.4 183.968 336.784C183.328 337.152 182.576 337.336 181.712 337.336C180.032 337.336 178.632 336.768 177.512 335.632C176.408 334.496 175.856 332.968 175.856 331.048C175.856 329.16 176.44 327.64 177.608 326.488C178.792 325.336 180.16 324.76 181.712 324.76C183.472 324.76 184.72 325.36 185.456 326.56V320.2H188.48ZM179.888 333.544C180.528 334.184 181.328 334.504 182.288 334.504C183.248 334.504 184.048 334.184 184.688 333.544C185.328 332.888 185.648 332.056 185.648 331.048C185.648 330.04 185.328 329.216 184.688 328.576C184.048 327.92 183.248 327.592 182.288 327.592C181.328 327.592 180.528 327.92 179.888 328.576C179.248 329.216 178.928 330.04 178.928 331.048C178.928 332.056 179.248 332.888 179.888 333.544ZM195.449 341.824L195.833 339.088C196.137 339.216 196.449 339.28 196.769 339.28C197.249 339.28 197.593 339.136 197.801 338.848C198.009 338.576 198.113 338.152 198.113 337.576V325.096H201.137V337.912C201.137 339.256 200.809 340.28 200.153 340.984C199.513 341.704 198.545 342.064 197.249 342.064C196.625 342.064 196.025 341.984 195.449 341.824ZM197.969 323.368V320.2H201.281V323.368H197.969ZM215.227 337H212.155C211.771 336.52 211.579 335.888 211.579 335.104C210.747 336.592 209.419 337.336 207.595 337.336C206.411 337.336 205.443 337 204.691 336.328C203.955 335.64 203.587 334.736 203.587 333.616C203.587 332.48 203.979 331.592 204.763 330.952C205.563 330.296 206.587 329.872 207.835 329.68L211.411 329.128V328.672C211.411 327.472 210.683 326.872 209.227 326.872C208.555 326.872 208.027 327 207.643 327.256C207.275 327.512 207.091 327.832 207.091 328.216C207.091 328.312 207.107 328.408 207.139 328.504L204.427 329.416C204.283 329.096 204.211 328.76 204.211 328.408C204.211 327.432 204.667 326.584 205.579 325.864C206.491 325.128 207.707 324.76 209.227 324.76C210.923 324.76 212.211 325.12 213.091 325.84C213.987 326.56 214.435 327.64 214.435 329.08V334.048C214.435 335.248 214.699 336.232 215.227 337ZM208.315 334.888C209.227 334.888 209.971 334.592 210.547 334C211.123 333.392 211.411 332.536 211.411 331.432V331.216L208.531 331.696C207.203 331.92 206.539 332.504 206.539 333.448C206.539 333.912 206.699 334.272 207.019 334.528C207.339 334.768 207.771 334.888 208.315 334.888ZM234.85 328.672V337H231.826V329.632C231.826 328.144 231.202 327.4 229.954 327.4C229.266 327.4 228.706 327.656 228.274 328.168C227.858 328.68 227.65 329.416 227.65 330.376V337H224.626V329.68C224.626 328.16 223.986 327.4 222.706 327.4C222.082 327.4 221.546 327.664 221.098 328.192C220.666 328.704 220.45 329.416 220.45 330.328V337H217.426V325.096H220.45V326.68C221.282 325.4 222.434 324.76 223.906 324.76C225.57 324.76 226.674 325.44 227.218 326.8C228.066 325.44 229.33 324.76 231.01 324.76C232.226 324.76 233.17 325.112 233.842 325.816C234.514 326.52 234.85 327.472 234.85 328.672ZM249.1 331.768H239.932C240.028 332.68 240.372 333.408 240.964 333.952C241.556 334.48 242.3 334.744 243.196 334.744C244.668 334.744 245.764 334.016 246.484 332.56L248.74 333.856C247.62 336.176 245.756 337.336 243.148 337.336C241.452 337.336 240.004 336.752 238.804 335.584C237.62 334.4 237.028 332.888 237.028 331.048C237.028 329.192 237.628 327.68 238.828 326.512C240.044 325.344 241.532 324.76 243.292 324.76C244.988 324.76 246.38 325.32 247.468 326.44C248.556 327.544 249.1 328.968 249.1 330.712V331.768ZM243.196 327.064C242.412 327.064 241.724 327.304 241.132 327.784C240.556 328.248 240.156 328.84 239.932 329.56H246.316C246.172 328.776 245.828 328.168 245.284 327.736C244.74 327.288 244.044 327.064 243.196 327.064ZM251.504 337V320.2H254.528V337H251.504Z\" fill=\"black\"/> --><!-- <path d=\"M66.584 373V360.4H68.186L74.18 369.886C74.468 370.366 74.648 370.696 74.72 370.876V360.4H76.16V373H74.558L68.564 363.514C68.276 363.034 68.096 362.704 68.024 362.524V373H66.584ZM79.1121 373V364.072H80.5161V373H79.1121ZM78.9681 362.524V360.76H80.6601V362.524H78.9681ZM90.0508 370.03L91.0588 370.678C90.1948 372.394 88.8568 373.252 87.0448 373.252C85.7488 373.252 84.6628 372.808 83.7868 371.92C82.9108 371.032 82.4728 369.904 82.4728 368.536C82.4728 367.18 82.9168 366.058 83.8048 365.17C84.7048 364.27 85.7848 363.82 87.0448 363.82C87.9928 363.82 88.8088 364.036 89.4928 364.468C90.1768 364.9 90.6808 365.5 91.0048 366.268L89.9428 366.97C89.3548 365.71 88.3948 365.08 87.0628 365.08C86.1508 365.08 85.3888 365.398 84.7768 366.034C84.1768 366.658 83.8768 367.492 83.8768 368.536C83.8768 369.58 84.1708 370.42 84.7588 371.056C85.3588 371.68 86.1268 371.992 87.0628 371.992C87.7708 371.992 88.3588 371.83 88.8268 371.506C89.2948 371.17 89.7028 370.678 90.0508 370.03ZM101.118 368.77H93.7381C93.7861 369.73 94.0861 370.522 94.6381 371.146C95.1901 371.758 95.9161 372.064 96.8161 372.064C97.5721 372.064 98.1781 371.89 98.6341 371.542C99.1021 371.182 99.4981 370.678 99.8221 370.03L100.848 370.642C99.9721 372.382 98.6101 373.252 96.7621 373.252C95.5261 373.252 94.4761 372.808 93.6121 371.92C92.7601 371.02 92.3341 369.892 92.3341 368.536C92.3341 367.18 92.7661 366.058 93.6301 365.17C94.4941 364.27 95.5561 363.82 96.8161 363.82C98.1361 363.82 99.1801 364.234 99.9481 365.062C100.728 365.89 101.118 366.964 101.118 368.284V368.77ZM96.8161 365.008C96.0361 365.008 95.3881 365.248 94.8721 365.728C94.3561 366.196 94.0141 366.826 93.8461 367.618H99.7141C99.6661 366.814 99.3541 366.178 98.7781 365.71C98.2021 365.242 97.5481 365.008 96.8161 365.008ZM107.411 365.188V364.072H108.905V361.66H110.309V364.072H112.361V365.188H110.309V370.588C110.309 371.104 110.387 371.476 110.543 371.704C110.711 371.92 111.041 372.028 111.533 372.028C111.737 372.028 111.959 371.992 112.199 371.92L112.325 373.09C112.013 373.198 111.617 373.252 111.137 373.252C110.489 373.252 109.955 373.066 109.535 372.694C109.115 372.31 108.905 371.698 108.905 370.858V365.188H107.411ZM122.085 365.98C122.565 366.712 122.805 367.564 122.805 368.536C122.805 369.508 122.565 370.36 122.085 371.092C121.617 371.824 121.035 372.37 120.339 372.73C119.643 373.078 118.911 373.252 118.143 373.252C117.375 373.252 116.643 373.078 115.947 372.73C115.251 372.37 114.663 371.824 114.183 371.092C113.715 370.36 113.481 369.508 113.481 368.536C113.481 367.564 113.715 366.712 114.183 365.98C114.663 365.248 115.251 364.708 115.947 364.36C116.643 364 117.375 363.82 118.143 363.82C118.911 363.82 119.643 364 120.339 364.36C121.035 364.708 121.617 365.248 122.085 365.98ZM115.839 371.02C116.463 371.668 117.231 371.992 118.143 371.992C119.055 371.992 119.817 371.668 120.429 371.02C121.053 370.36 121.365 369.532 121.365 368.536C121.365 367.54 121.053 366.718 120.429 366.07C119.817 365.41 119.055 365.08 118.143 365.08C117.231 365.08 116.463 365.41 115.839 366.07C115.227 366.718 114.921 367.54 114.921 368.536C114.921 369.532 115.227 370.36 115.839 371.02ZM137.545 366.97V373H136.141V367.222C136.141 366.538 135.937 366.01 135.529 365.638C135.133 365.266 134.611 365.08 133.963 365.08C133.243 365.08 132.619 365.356 132.091 365.908C131.563 366.448 131.299 367.162 131.299 368.05V373H129.895V360.4H131.299V365.638C131.587 365.086 132.007 364.648 132.559 364.324C133.111 363.988 133.705 363.82 134.341 363.82C135.241 363.82 135.997 364.09 136.609 364.63C137.233 365.158 137.545 365.938 137.545 366.97ZM147.651 373H146.247C145.887 372.568 145.707 371.98 145.707 371.236C145.431 371.884 145.023 372.382 144.483 372.73C143.955 373.078 143.349 373.252 142.665 373.252C141.765 373.252 141.039 373 140.487 372.496C139.935 371.98 139.659 371.326 139.659 370.534C139.659 369.718 139.941 369.064 140.505 368.572C141.081 368.08 141.825 367.762 142.737 367.618L145.707 367.132V366.736C145.707 365.584 145.005 365.008 143.601 365.008C142.929 365.008 142.407 365.14 142.035 365.404C141.675 365.668 141.495 365.998 141.495 366.394C141.495 366.478 141.507 366.568 141.531 366.664L140.307 367.078C140.211 366.85 140.163 366.61 140.163 366.358C140.163 365.662 140.475 365.068 141.099 364.576C141.735 364.072 142.569 363.82 143.601 363.82C144.753 363.82 145.623 364.078 146.211 364.594C146.811 365.098 147.111 365.812 147.111 366.736V370.768C147.111 371.284 147.147 371.698 147.219 372.01C147.291 372.31 147.435 372.64 147.651 373ZM142.827 371.992C143.727 371.992 144.429 371.656 144.933 370.984C145.449 370.3 145.707 369.478 145.707 368.518V368.248L142.989 368.716C142.377 368.824 141.909 369.028 141.585 369.328C141.261 369.628 141.099 370.006 141.099 370.462C141.099 370.93 141.255 371.302 141.567 371.578C141.879 371.854 142.299 371.992 142.827 371.992ZM156.787 364.072L153.187 373H151.783L148.183 364.072H149.695L152.485 371.38L155.275 364.072H156.787ZM166.192 368.77H158.812C158.86 369.73 159.16 370.522 159.712 371.146C160.264 371.758 160.99 372.064 161.89 372.064C162.646 372.064 163.252 371.89 163.708 371.542C164.176 371.182 164.572 370.678 164.896 370.03L165.922 370.642C165.046 372.382 163.684 373.252 161.836 373.252C160.6 373.252 159.55 372.808 158.686 371.92C157.834 371.02 157.408 369.892 157.408 368.536C157.408 367.18 157.84 366.058 158.704 365.17C159.568 364.27 160.63 363.82 161.89 363.82C163.21 363.82 164.254 364.234 165.022 365.062C165.802 365.89 166.192 366.964 166.192 368.284V368.77ZM161.89 365.008C161.11 365.008 160.462 365.248 159.946 365.728C159.43 366.196 159.088 366.826 158.92 367.618H164.788C164.74 366.814 164.428 366.178 163.852 365.71C163.276 365.242 162.622 365.008 161.89 365.008ZM172.971 376.618L173.187 375.358C173.427 375.478 173.667 375.538 173.907 375.538C174.183 375.538 174.399 375.472 174.555 375.34C174.711 375.208 174.855 374.98 174.987 374.656L175.653 372.964L172.053 364.072H173.601L176.427 371.074L179.217 364.072H180.729L176.247 375.106C175.995 375.73 175.683 376.168 175.311 376.42C174.951 376.672 174.483 376.798 173.907 376.798C173.571 376.798 173.259 376.738 172.971 376.618ZM189.971 365.98C190.451 366.712 190.691 367.564 190.691 368.536C190.691 369.508 190.451 370.36 189.971 371.092C189.503 371.824 188.921 372.37 188.225 372.73C187.529 373.078 186.797 373.252 186.029 373.252C185.261 373.252 184.529 373.078 183.833 372.73C183.137 372.37 182.549 371.824 182.069 371.092C181.601 370.36 181.367 369.508 181.367 368.536C181.367 367.564 181.601 366.712 182.069 365.98C182.549 365.248 183.137 364.708 183.833 364.36C184.529 364 185.261 363.82 186.029 363.82C186.797 363.82 187.529 364 188.225 364.36C188.921 364.708 189.503 365.248 189.971 365.98ZM183.725 371.02C184.349 371.668 185.117 371.992 186.029 371.992C186.941 371.992 187.703 371.668 188.315 371.02C188.939 370.36 189.251 369.532 189.251 368.536C189.251 367.54 188.939 366.718 188.315 366.07C187.703 365.41 186.941 365.08 186.029 365.08C185.117 365.08 184.349 365.41 183.725 366.07C183.113 366.718 182.807 367.54 182.807 368.536C182.807 369.532 183.113 370.36 183.725 371.02ZM192.667 369.958V364.072H194.071V369.886C194.071 370.57 194.263 371.092 194.647 371.452C195.031 371.812 195.541 371.992 196.177 371.992C196.909 371.992 197.527 371.722 198.031 371.182C198.547 370.642 198.805 369.94 198.805 369.076V364.072H200.209V373H198.805V371.434C198.169 372.646 197.179 373.252 195.835 373.252C194.935 373.252 194.179 372.982 193.567 372.442C192.967 371.902 192.667 371.074 192.667 369.958ZM215.917 365.98C216.397 366.712 216.637 367.564 216.637 368.536C216.637 369.508 216.397 370.36 215.917 371.092C215.449 371.824 214.867 372.37 214.171 372.73C213.475 373.078 212.743 373.252 211.975 373.252C211.207 373.252 210.475 373.078 209.779 372.73C209.083 372.37 208.495 371.824 208.015 371.092C207.547 370.36 207.313 369.508 207.313 368.536C207.313 367.564 207.547 366.712 208.015 365.98C208.495 365.248 209.083 364.708 209.779 364.36C210.475 364 211.207 363.82 211.975 363.82C212.743 363.82 213.475 364 214.171 364.36C214.867 364.708 215.449 365.248 215.917 365.98ZM209.671 371.02C210.295 371.668 211.063 371.992 211.975 371.992C212.887 371.992 213.649 371.668 214.261 371.02C214.885 370.36 215.197 369.532 215.197 368.536C215.197 367.54 214.885 366.718 214.261 366.07C213.649 365.41 212.887 365.08 211.975 365.08C211.063 365.08 210.295 365.41 209.671 366.07C209.059 366.718 208.753 367.54 208.753 368.536C208.753 369.532 209.059 370.36 209.671 371.02ZM226.295 366.934V373H224.891V367.186C224.891 366.502 224.693 365.98 224.297 365.62C223.913 365.26 223.397 365.08 222.749 365.08C222.041 365.08 221.429 365.356 220.913 365.908C220.409 366.448 220.157 367.162 220.157 368.05V373H218.753V364.072H220.157V365.638C220.481 365.074 220.901 364.63 221.417 364.306C221.945 363.982 222.527 363.82 223.163 363.82C224.039 363.82 224.777 364.084 225.377 364.612C225.989 365.128 226.295 365.902 226.295 366.934ZM228.825 373V360.4H230.229V365.692C230.565 365.116 231.021 364.66 231.597 364.324C232.185 363.988 232.821 363.82 233.505 363.82C234.681 363.82 235.659 364.264 236.439 365.152C237.231 366.04 237.627 367.168 237.627 368.536C237.627 369.904 237.219 371.032 236.403 371.92C235.599 372.808 234.579 373.252 233.343 373.252C232.659 373.252 232.035 373.078 231.471 372.73C230.919 372.382 230.505 371.938 230.229 371.398V373H228.825ZM230.985 371.02C231.561 371.644 232.281 371.956 233.145 371.956C234.009 371.956 234.729 371.644 235.305 371.02C235.893 370.384 236.187 369.556 236.187 368.536C236.187 367.516 235.893 366.694 235.305 366.07C234.729 365.434 234.009 365.116 233.145 365.116C232.281 365.116 231.561 365.434 230.985 366.07C230.409 366.694 230.121 367.516 230.121 368.536C230.121 369.556 230.409 370.384 230.985 371.02ZM247.751 365.98C248.231 366.712 248.471 367.564 248.471 368.536C248.471 369.508 248.231 370.36 247.751 371.092C247.283 371.824 246.701 372.37 246.005 372.73C245.309 373.078 244.577 373.252 243.809 373.252C243.041 373.252 242.309 373.078 241.613 372.73C240.917 372.37 240.329 371.824 239.849 371.092C239.381 370.36 239.147 369.508 239.147 368.536C239.147 367.564 239.381 366.712 239.849 365.98C240.329 365.248 240.917 364.708 241.613 364.36C242.309 364 243.041 363.82 243.809 363.82C244.577 363.82 245.309 364 246.005 364.36C246.701 364.708 247.283 365.248 247.751 365.98ZM241.505 371.02C242.129 371.668 242.897 371.992 243.809 371.992C244.721 371.992 245.483 371.668 246.095 371.02C246.719 370.36 247.031 369.532 247.031 368.536C247.031 367.54 246.719 366.718 246.095 366.07C245.483 365.41 244.721 365.08 243.809 365.08C242.897 365.08 242.129 365.41 241.505 366.07C240.893 366.718 240.587 367.54 240.587 368.536C240.587 369.532 240.893 370.36 241.505 371.02ZM258.041 373H256.637C256.277 372.568 256.097 371.98 256.097 371.236C255.821 371.884 255.413 372.382 254.873 372.73C254.345 373.078 253.739 373.252 253.055 373.252C252.155 373.252 251.429 373 250.877 372.496C250.325 371.98 250.049 371.326 250.049 370.534C250.049 369.718 250.331 369.064 250.895 368.572C251.471 368.08 252.215 367.762 253.127 367.618L256.097 367.132V366.736C256.097 365.584 255.395 365.008 253.991 365.008C253.319 365.008 252.797 365.14 252.425 365.404C252.065 365.668 251.885 365.998 251.885 366.394C251.885 366.478 251.897 366.568 251.921 366.664L250.697 367.078C250.601 366.85 250.553 366.61 250.553 366.358C250.553 365.662 250.865 365.068 251.489 364.576C252.125 364.072 252.959 363.82 253.991 363.82C255.143 363.82 256.013 364.078 256.601 364.594C257.201 365.098 257.501 365.812 257.501 366.736V370.768C257.501 371.284 257.537 371.698 257.609 372.01C257.681 372.31 257.825 372.64 258.041 373ZM253.217 371.992C254.117 371.992 254.819 371.656 255.323 370.984C255.839 370.3 256.097 369.478 256.097 368.518V368.248L253.379 368.716C252.767 368.824 252.299 369.028 251.975 369.328C251.651 369.628 251.489 370.006 251.489 370.462C251.489 370.93 251.645 371.302 251.957 371.578C252.269 371.854 252.689 371.992 253.217 371.992ZM264.599 363.91L264.365 365.224C264.149 365.152 263.915 365.116 263.663 365.116C263.027 365.116 262.487 365.398 262.043 365.962C261.611 366.514 261.395 367.234 261.395 368.122V373H259.991V364.072H261.395V365.692C261.971 364.444 262.835 363.82 263.987 363.82C264.179 363.82 264.383 363.85 264.599 363.91ZM274.017 360.4V373H272.613V371.398C271.905 372.634 270.879 373.252 269.535 373.252C268.287 373.252 267.255 372.814 266.439 371.938C265.623 371.05 265.215 369.916 265.215 368.536C265.215 367.192 265.635 366.07 266.475 365.17C267.315 364.27 268.305 363.82 269.445 363.82C270.177 363.82 270.819 363.988 271.371 364.324C271.923 364.648 272.337 365.104 272.613 365.692V360.4H274.017ZM267.519 371.02C268.107 371.644 268.833 371.956 269.697 371.956C270.561 371.956 271.281 371.644 271.857 371.02C272.433 370.384 272.721 369.556 272.721 368.536C272.721 367.516 272.433 366.694 271.857 366.07C271.281 365.434 270.561 365.116 269.697 365.116C268.833 365.116 268.107 365.434 267.519 366.07C266.943 366.694 266.655 367.516 266.655 368.536C266.655 369.556 266.943 370.384 267.519 371.02ZM276.257 373V371.236H277.949V373H276.257Z\" fill=\"black\"/> --><path d=\"M132.199 282.152L137.677 294.573C138.24 295.842 137.927 297.44 136.754 298.207C135.439 299.069 133.232 298.756 129.914 293.132L127.816 290.767L128.223 294.479C128.521 297.189 125.093 298.662 123.387 296.547C122.776 295.795 122.15 294.761 121.524 293.383C120.961 295.466 118.66 296.578 116.688 295.701C114.262 294.62 111.366 291.863 110.005 284.987C109.864 281.133 112.963 277.954 116.813 278.001L126.11 278.126C128.755 278.173 131.135 279.739 132.199 282.152Z\" fill=#E78C6B /><path d=\"M237.75 284.152L232.272 296.573C231.709 297.842 232.022 299.44 233.196 300.207C234.51 301.069 236.717 300.756 240.035 295.132L242.133 292.767L241.726 296.479C241.428 299.189 244.856 300.662 246.562 298.547C247.173 297.795 247.799 296.761 248.425 295.383C248.988 297.466 251.289 298.578 253.261 297.701C255.687 296.62 258.583 293.863 259.945 286.987C260.085 283.133 256.986 279.954 253.136 280.001L243.839 280.126C241.194 280.173 238.815 281.739 237.75 284.152Z\" fill=#E78C6B /><path d=\"M92.5998 502.366C98.5552 499.299 105.572 498.901 112.191 499.995C115.741 500.575 119.457 501.636 121.862 504.305C124.284 506.974 124.732 511.665 121.962 513.953C120.303 515.313 117.997 515.528 115.857 515.495C110.682 515.429 104.942 514.517 100.795 517.633C98.4391 519.407 96.8631 522.358 94.043 523.237C91.2893 524.099 88.1706 522.457 86.7108 519.971C85.251 517.484 85.2012 514.368 85.8814 511.566C85.8814 511.566 86.6113 505.449 92.5998 502.366Z\" fill=#4A4A4A /><path d=\"M78.9586 476.024C82.6081 481.23 89.675 479.506 92.9596 476.323C96.2441 473.156 97.6376 468.548 98.8983 464.155C101.785 454.126 104.688 443.615 102.548 433.404C101.901 430.353 100.756 427.303 98.6164 425.049C96.4764 422.778 93.1752 421.435 90.156 422.231C86.5895 423.175 84.3666 426.673 82.7574 429.989C78.0462 439.753 75.5413 450.595 75.5081 461.436C75.4916 466.526 76.0887 471.847 78.9586 476.024Z\" fill=#4A4A4A /><path d=\"M68.9428 483.484C72.8909 478.793 73.654 471.946 71.8956 466.078C70.1372 460.193 66.1559 455.203 61.5774 451.125C56.2026 446.334 49.8823 442.621 43.0975 440.234C40.4267 439.289 37.6066 438.559 34.7865 438.825C31.9664 439.09 29.1298 440.532 27.8192 443.035C25.8784 446.749 27.7363 451.241 29.7601 454.905C33.3101 461.37 37.3744 467.553 41.9031 473.372C45.536 478.064 49.6998 482.689 55.257 484.794C60.7977 486.916 66.554 486.667 69.5068 482.821\" fill=#4A4A4A /><path d=\"M78.7145 554.47C78.7808 554.47 78.8969 553.625 79.0462 552.1C79.2121 550.376 79.4278 548.221 79.6766 545.651C79.9752 542.932 80.3733 539.716 81.1364 536.185C81.8829 532.671 83.0607 528.875 84.5703 525.029C86.1296 521.199 88.0374 517.718 90.2768 514.933C92.4831 512.131 95.071 510.109 97.493 508.948C99.8983 507.755 102.071 507.274 103.564 507.059C105.074 506.909 105.92 506.777 105.92 506.71C105.92 506.644 105.074 506.628 103.531 506.677C101.988 506.777 99.749 507.175 97.1943 508.319C94.6397 509.446 91.9025 511.501 89.5801 514.369C87.2411 517.221 85.267 520.768 83.6745 524.681C82.1317 528.609 80.9705 532.439 80.2572 536.02C79.5439 539.6 79.2121 542.866 78.9965 545.601C78.7974 548.337 78.7144 550.558 78.6813 552.083C78.6315 553.608 78.6481 554.454 78.7145 554.47Z\" fill=#263238 /><path d=\"M79.1436 549.498C79.1768 549.498 79.1934 549.116 79.21 548.403C79.21 547.575 79.21 546.547 79.1934 545.27C79.1934 542.552 79.1934 538.606 79.3261 533.749C79.5749 524.018 80.4044 513.557 82.0301 498.803C83.5562 484.928 85.6133 468.781 87.7864 458.288C88.2509 455.901 88.7153 453.746 89.1632 451.872C89.578 449.982 89.9429 448.358 90.2913 447.048C90.5899 445.805 90.8387 444.794 91.0212 443.998C91.1705 443.302 91.2535 442.92 91.2203 442.92C91.1871 442.904 91.0544 443.269 90.8387 443.948C90.6065 444.744 90.2913 445.739 89.9263 446.949C89.5282 448.258 89.1135 449.866 88.6324 451.74C88.1347 453.613 87.6205 455.752 87.1062 458.139C84.9663 467.654 82.677 480.949 81.0513 495.737C79.4256 510.524 78.6957 523.985 78.6293 533.732C78.5796 538.606 78.6791 542.552 78.7952 545.27C78.8782 546.547 78.9445 547.575 78.9943 548.403C79.0772 549.133 79.1104 549.498 79.1436 549.498Z\" fill=#263238 /><path d=\"M79.2105 523.539C79.2769 523.539 79.2603 522.379 79.194 520.257C79.0778 518.151 78.7792 515.118 78.182 511.388C77.5516 507.674 76.6725 503.248 75.2956 498.457C74.6984 496.269 73.2883 491.014 69.8877 483.156C65.4087 472.513 59.3041 463.827 53.9957 458.439C52.7515 457.013 51.3747 455.986 50.2632 454.974C49.6826 454.494 49.1849 454.013 48.6707 453.632C48.1564 453.267 47.6753 452.935 47.2274 452.637C45.4856 451.443 44.5069 450.813 44.4737 450.88C44.3244 451.095 48.3887 453.482 53.5146 458.936C58.6239 464.39 64.5461 473.027 69.0085 483.571C71.4968 489.29 73.222 494.396 74.4496 498.722C75.8762 503.48 76.8052 507.84 77.5185 511.52C78.1986 515.217 78.5802 518.218 78.829 520.306C79.0115 522.379 79.1442 523.539 79.2105 523.539Z\" fill=#263238 /><path d=\"M54.1118 569.342L56.6997 604.983H102.535L105.139 569.342H54.1118Z\" fill=#263238 /><path d=\"M110.614 555.281H49.6836V569.339H110.614V555.281Z\" fill=#263238 /><path d=\"M49.6836 603.621V607.517H52.5369H109.602V603.621H49.6836Z\" fill=#455A64 /><path d=\"M55.3392 614.363L52.5356 607.517H107.411L104.143 614.363H55.3392Z\" fill=#455A64 /><path d=\"M104.277 580.991C104.293 581.007 104.21 581.107 104.061 581.322C103.878 581.571 103.646 581.869 103.381 582.234C102.734 583.063 101.838 584.207 100.71 585.649L100.594 585.798L100.478 585.632C98.8022 583.312 96.5627 580.212 93.9251 576.565H94.3066C92.3492 579.333 90.176 582.4 87.8536 585.699L87.6545 585.981L87.4223 585.715C85.0335 582.881 82.4457 579.814 79.7583 576.614H80.2062C80.0735 576.78 79.9242 576.962 79.7915 577.145C77.4193 580.112 75.1134 582.997 72.9403 585.715L72.7081 585.997L72.4924 585.699C70.17 582.416 67.9968 579.35 66.0394 576.565L66.4209 576.581C63.2359 580.212 60.5319 583.278 58.4583 585.632L58.309 585.798L58.2095 585.616C57.1644 583.859 56.3183 582.45 55.7211 581.438C55.4557 580.991 55.2567 580.609 55.0742 580.328C54.9415 580.079 54.8586 579.93 54.8752 579.93C54.8917 579.93 54.9747 580.046 55.1406 580.278C55.3231 580.56 55.5553 580.908 55.8539 581.355C56.4843 582.35 57.3634 583.726 58.4749 585.467L58.2261 585.45C60.2665 583.063 62.9207 579.946 66.056 576.283L66.255 576.051L66.4375 576.299C68.4116 579.068 70.6179 582.118 72.9569 585.384L72.5256 585.367C74.6987 582.632 76.9879 579.764 79.3601 576.78C79.5094 576.598 79.6421 576.415 79.7749 576.25L79.9905 575.984L80.2228 576.25C82.9102 579.449 85.4814 582.532 87.8536 585.367L87.4223 585.384C89.7779 582.101 91.9676 579.035 93.9417 576.299L94.1407 576.034L94.3232 576.299C96.9111 579.98 99.1008 583.113 100.743 585.467H100.511C101.689 584.058 102.618 582.947 103.281 582.135C103.58 581.786 103.829 581.505 104.028 581.273C104.177 581.074 104.277 580.974 104.277 580.991Z\" fill=#E0E0E0 /><path d=\"M105.772 569.105C105.772 569.271 94.2926 569.387 80.1258 569.387C65.959 569.387 54.4795 569.254 54.4795 569.105C54.4795 568.956 65.959 568.823 80.1258 568.823C94.2926 568.823 105.772 568.939 105.772 569.105Z\" fill=#455A64 /><path d=\"M108.092 607.9C108.092 608.066 95.6176 608.182 80.2232 608.182C64.8288 608.182 52.354 608.049 52.354 607.9C52.354 607.751 64.8288 607.618 80.2232 607.618C95.601 607.618 108.092 607.734 108.092 607.9Z\" fill=#263238 /><g opacity=0.5><path opacity=0.3 d=\"M323.81 114.06L317.75 108L308.91 116.84L300.06 108L294 114.06L302.84 122.9L294 131.75L300.06 137.81L308.91 128.97L317.75 137.81L323.81 131.75L314.97 122.9L323.81 114.06Z\" fill=#EBE9E9 /><path opacity=0.1 d=\"M318.81 169.32L312.75 163.25L303.91 172.1L295.06 163.25L289 169.32L297.84 178.16L289 187L295.06 193.07L303.91 184.22L312.75 193.07L318.81 187L309.97 178.16L318.81 169.32Z\" fill=#2DC0DA /><path d=\"M318.81 224.57L312.75 218.51L303.91 227.35L295.06 218.51L289 224.57L297.84 233.42L289 242.26L295.06 248.32L303.91 239.48L312.75 248.32L318.81 242.26L309.97 233.42L318.81 224.57Z\" fill=white /></g><g opacity=0.5><path d=\"M36.16 212.9L19 203V222.81L36.16 212.9Z\" fill=#56C2D4 /><path d=\"M64.89 212.9L47.73 203V222.81L64.89 212.9Z\" fill=#EAF9FB /><path opacity=0.1 d=\"M93.61 212.9L76.46 203V222.81L93.61 212.9Z\" fill=#FF2C2C fill-opacity=0.8 /></g><path d=\"M280.15 465.9L263 456L263 475.8L280.15 465.9Z\" fill=#FDFDFD /><path opacity=0.2 d=\"M303.851 466L291.851 459L291.851 473L303.851 466Z\" fill=#2DC0DA /><path opacity=0.5 d=\"M325.851 465.9L315.901 460.15L315.901 471.64L325.851 465.9Z\" fill=#2DC0DA /><path d=\"M127.223 523H123.003V537.23H127.223V523Z\" fill=white /><path d=\"M132.23 532.226V528.006H118V532.226H132.23Z\" fill=white /><path d=\"M249.223 419H245.003V433.23H249.223V419Z\" fill=white /><path d=\"M254.23 428.226V424.006H240V428.226H254.23Z\" fill=white /><path d=\"M25.2234 268H21.0034V282.23H25.2234V268Z\" fill=white /><path d=\"M30.23 277.226V273.006H16V277.226H30.23Z\" fill=white /></g><defs><filter id=filter0_d_2890:7194 x=21 y=286 width=309 height=136 filterUnits=userSpaceOnUse color-interpolation-filters=sRGB><feFlood flood-opacity=0 result=BackgroundImageFix /><feColorMatrix in=SourceAlpha type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=hardAlpha /><feMorphology radius=2 operator=dilate in=SourceAlpha result=effect1_dropShadow_2890:7194 /><feOffset dy=4 /><feGaussianBlur stdDeviation=2 /><feComposite in2=hardAlpha operator=out /><feColorMatrix type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0\"/><feBlend mode=normal in2=BackgroundImageFix result=effect1_dropShadow_2890:7194 /><feBlend mode=normal in=SourceGraphic in2=effect1_dropShadow_2890:7194 result=shape /></filter><clipPath id=clip0_2890:7194><rect width=360 height=640 fill=white /></clipPath></defs></svg></div><div class=\"welcom_popup wow fadeInUp\" ng-if=cityverify_popup><svg class=welcome-desktop-image width=100% height=auto viewBox=\"0 0 1275 703\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0)><rect width=1275 height=703 fill=white /><g opacity=0.2 clip-path=url(#clip1)><path d=\"M401.456 346.988H344.928V571.921H401.456V346.988Z\" fill=#B5C3C2 /><path d=\"M392.22 330.859H354.162V425.393H392.22V330.859Z\" fill=#B5C3C2 /><path d=\"M383.741 320.635H362.627V373.063H383.741V320.635Z\" fill=#B5C3C2 /><path d=\"M380.383 347.576H365.985V311.836H371.176H376.325H380.383V347.576Z\" fill=#B5C3C2 /><path d=\"M372.24 332.021H370.673V296.28H371.247H371.792H372.24V332.021Z\" fill=#B5C3C2 /><path d=\"M375.696 319.655H374.129V283.929H374.689H375.248H375.696V319.655Z\" fill=#B5C3C2 /><path d=\"M402.952 346.415H343.416V348.807H402.952V346.415Z\" fill=#B5C3C2 /><path d=\"M393.591 329.713H352.763V332.021H393.591V329.713Z\" fill=#B5C3C2 /><path d=\"M384.622 319.655H361.088V321.418H384.622V319.655Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M359.423 334.692H357.66V344.596H359.423V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M364.32 334.692H362.557V344.596H364.32V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M369.203 334.692H367.44V344.596H369.203V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M374.101 334.692H372.338V344.596H374.101V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M378.997 334.692H377.234V344.596H378.997V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M383.895 334.692H382.132V344.596H383.895V334.692Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M388.792 334.692H387.029V344.596H388.792V334.692Z\" fill=#B5C3C2 /><path d=\"M354.161 355.955H349.88V367.705H354.161V355.955Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M362.627 355.955H358.346V367.705H362.627V355.955Z\" fill=#B5C3C2 /><path d=\"M371.092 355.955H366.811V367.705H371.092V355.955Z\" fill=#B5C3C2 /><path d=\"M379.557 355.955H375.275V367.705H379.557V355.955Z\" fill=#B5C3C2 /><path d=\"M388.023 355.955H383.741V367.705H388.023V355.955Z\" fill=#B5C3C2 /><path d=\"M396.488 355.955H392.206V367.705H396.488V355.955Z\" fill=#B5C3C2 /><path d=\"M354.161 374.279H349.88V386.029H354.161V374.279Z\" fill=#B5C3C2 /><path d=\"M362.627 374.279H358.346V386.029H362.627V374.279Z\" fill=#B5C3C2 /><path d=\"M371.092 374.279H366.811V386.029H371.092V374.279Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M379.557 374.279H375.275V386.029H379.557V374.279Z\" fill=#B5C3C2 /><path d=\"M388.023 374.279H383.741V386.029H388.023V374.279Z\" fill=#B5C3C2 /><path d=\"M396.488 374.279H392.206V386.029H396.488V374.279Z\" fill=#B5C3C2 /><path d=\"M354.161 392.59H349.88V404.34H354.161V392.59Z\" fill=#B5C3C2 /><path d=\"M362.627 392.59H358.346V404.34H362.627V392.59Z\" fill=#B5C3C2 /><path d=\"M371.092 392.59H366.811V404.34H371.092V392.59Z\" fill=#B5C3C2 /><path d=\"M379.557 392.59H375.275V404.34H379.557V392.59Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M388.023 392.59H383.741V404.34H388.023V392.59Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M396.488 392.59H392.206V404.34H396.488V392.59Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M354.161 410.901H349.88V422.652H354.161V410.901Z\" fill=#B5C3C2 /><path d=\"M362.627 410.901H358.346V422.652H362.627V410.901Z\" fill=#B5C3C2 /><path d=\"M371.092 410.901H366.811V422.652H371.092V410.901Z\" fill=#B5C3C2 /><path d=\"M379.557 410.901H375.275V422.652H379.557V410.901Z\" fill=#B5C3C2 /><path d=\"M388.023 410.901H383.741V422.652H388.023V410.901Z\" fill=#B5C3C2 /><path d=\"M396.488 410.901H392.206V422.652H396.488V410.901Z\" fill=#B5C3C2 /><path d=\"M354.161 429.226H349.88V440.976H354.161V429.226Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M362.627 429.226H358.346V440.976H362.627V429.226Z\" fill=#B5C3C2 /><path d=\"M371.092 429.226H366.811V440.976H371.092V429.226Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M379.557 429.226H375.275V440.976H379.557V429.226Z\" fill=#B5C3C2 /><path d=\"M388.023 429.226H383.741V440.976H388.023V429.226Z\" fill=#B5C3C2 /><path d=\"M396.488 429.226H392.206V440.976H396.488V429.226Z\" fill=#B5C3C2 /><path d=\"M354.161 447.537H349.88V459.287H354.161V447.537Z\" fill=#B5C3C2 /><path d=\"M362.627 447.537H358.346V459.287H362.627V447.537Z\" fill=#B5C3C2 /><path d=\"M371.092 447.537H366.811V459.287H371.092V447.537Z\" fill=#B5C3C2 /><path d=\"M379.557 447.537H375.275V459.287H379.557V447.537Z\" fill=#B5C3C2 /><path d=\"M388.023 447.537H383.741V459.287H388.023V447.537Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M396.488 447.537H392.206V459.287H396.488V447.537Z\" fill=#B5C3C2 /><path d=\"M354.161 465.861H349.88V477.612H354.161V465.861Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M362.627 465.861H358.346V477.612H362.627V465.861Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M371.092 465.861H366.811V477.612H371.092V465.861Z\" fill=#B5C3C2 /><path d=\"M379.557 465.861H375.275V477.612H379.557V465.861Z\" fill=#B5C3C2 /><path d=\"M388.023 465.861H383.741V477.612H388.023V465.861Z\" fill=#B5C3C2 /><path d=\"M396.488 465.861H392.206V477.612H396.488V465.861Z\" fill=#B5C3C2 /><path d=\"M354.161 484.173H349.88V495.923H354.161V484.173Z\" fill=#B5C3C2 /><path d=\"M362.627 484.173H358.346V495.923H362.627V484.173Z\" fill=#B5C3C2 /><path d=\"M371.092 484.173H366.811V495.923H371.092V484.173Z\" fill=#B5C3C2 /><path d=\"M379.557 484.173H375.275V495.923H379.557V484.173Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M388.023 484.173H383.741V495.923H388.023V484.173Z\" fill=#B5C3C2 /><path d=\"M396.488 484.173H392.206V495.923H396.488V484.173Z\" fill=#B5C3C2 /><path d=\"M354.161 502.497H349.88V514.247H354.161V502.497Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M362.627 502.497H358.346V514.247H362.627V502.497Z\" fill=#B5C3C2 /><path d=\"M371.092 502.497H366.811V514.247H371.092V502.497Z\" fill=#B5C3C2 /><path d=\"M379.557 502.497H375.275V514.247H379.557V502.497Z\" fill=#B5C3C2 /><path d=\"M388.023 502.497H383.741V514.247H388.023V502.497Z\" fill=#B5C3C2 /><path d=\"M396.488 502.497H392.206V514.247H396.488V502.497Z\" fill=#B5C3C2 /><path d=\"M354.161 520.808H349.88V532.558H354.161V520.808Z\" fill=#B5C3C2 /><path d=\"M362.627 520.808H358.346V532.558H362.627V520.808Z\" fill=#B5C3C2 /><path d=\"M371.092 520.808H366.811V532.558H371.092V520.808Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M379.557 520.808H375.275V532.558H379.557V520.808Z\" fill=#B5C3C2 /><path d=\"M388.023 520.808H383.741V532.558H388.023V520.808Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M396.488 520.808H392.206V532.558H396.488V520.808Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M354.161 539.133H349.88V550.883H354.161V539.133Z\" fill=#B5C3C2 /><path d=\"M362.627 539.133H358.346V550.883H362.627V539.133Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M371.092 539.133H366.811V550.883H371.092V539.133Z\" fill=#B5C3C2 /><path d=\"M379.557 539.133H375.275V550.883H379.557V539.133Z\" fill=#B5C3C2 /><path d=\"M388.023 539.133H383.741V550.883H388.023V539.133Z\" fill=#B5C3C2 /><path d=\"M396.488 539.133H392.206V550.883H396.488V539.133Z\" fill=#B5C3C2 /><path d=\"M271.623 355.549H180.759V545.035H271.623V355.549Z\" fill=#B5C3C2 /><path d=\"M274.197 352.289H178.17V357.647H274.197V352.289Z\" fill=#B5C3C2 /><path d=\"M268.572 345.435H183.809V370.893H268.572V345.435Z\" fill=#B5C3C2 /><path d=\"M223.868 335.013H190.301V362.822H223.868V335.013Z\" fill=#B5C3C2 /><path d=\"M209.722 342.847H190.301V328.215H204.223L209.722 342.847Z\" fill=#B5C3C2 /><path d=\"M200.011 316.059H198.122V348.679H200.011V316.059Z\" fill=#B5C3C2 /><path d=\"M200.753 314.366C200.753 315.304 199.998 316.059 199.06 316.059C198.123 316.059 197.367 315.304 197.367 314.366C197.367 313.429 198.123 312.674 199.06 312.674C199.998 312.674 200.753 313.429 200.753 314.366Z\" fill=#B5C3C2 /><path d=\"M1024.1 559.457H924.632L912.221 280.851L1024.1 304.071V559.457Z\" fill=#B5C3C2 /><path d=\"M590.137 400.354V307.205H574.536V282.264H568.967V245.67H538.255V218.77H535.526V245.67H529.51V212H526.781V245.67H507.374V307.205H497.342V400.354H488.751V570.005H596.182V400.354H590.137Z\" fill=#B5C3C2 /><path d=\"M1242.2 556.002H53.7529V584.258H1242.2V556.002Z\" fill=#B5C3C2 /><path d=\"M753.313 577.335H700.688L721.187 471.988H753.313V577.335Z\" fill=#95A9A7 /><path d=\"M1258.93 581.447H11.1182V626H1258.93V581.447Z\" fill=#95A9A7 /><path d=\"M710.19 382.378V335.699H693.287V317.92H684.249V302.994H681.072V277.396H680.261V302.994H677.085V317.92H668.046V335.699H651.269V382.378H647.785V467.148H621.788V563.766H647.785H673.783H713.548V382.378H710.19Z\" fill=#95A9A7 /><path d=\"M807.294 436.01H725.511V437.493H729.205V575.754H803.6V437.493H807.294V436.01Z\" fill=#95A9A7 /><path d=\"M434.35 470.449H361.829V585.63H434.35V470.449Z\" fill=#95A9A7 /><path d=\"M350.902 529.466H226.19V585.629H350.902V529.466Z\" fill=#95A9A7 /><path d=\"M320.413 403.977H293.03V541.902H320.413V403.977Z\" fill=#95A9A7 /><path d=\"M300.502 367.188H299.075V442.193H300.502V367.188Z\" fill=#95A9A7 /><path d=\"M305.133 372.866H303.706V447.872H305.133V372.866Z\" fill=#95A9A7 /><path d=\"M311.878 395.443H295.144V413.922H311.878V395.443Z\" fill=#95A9A7 /><path d=\"M393.661 491.068H346.019V585.63H393.661V491.068Z\" fill=#95A9A7 /><path d=\"M535.527 391.009H446.09V585.629H535.527V391.009Z\" fill=#95A9A7 /><path d=\"M526.74 384.309H454.877V416.72H526.74V384.309Z\" fill=#95A9A7 /><path d=\"M542.467 395.08H439.164V397.36H542.467V395.08Z\" fill=#95A9A7 /><path d=\"M472.031 487.333H429.887V585.615H472.031V487.333Z\" fill=#95A9A7 /><path d=\"M176.406 483.599H128.05V585.616H176.406V483.599Z\" fill=#95A9A7 /><path d=\"M240.057 455.873H143.693V585.615H240.057V455.873Z\" fill=#95A9A7 /><path d=\"M242.533 450.894H138.068V455.873H242.533V450.894Z\" fill=#95A9A7 /><path d=\"M190.301 437.395H147.961V463.707H190.301V437.395Z\" fill=#95A9A7 /><path d=\"M211.247 437.395H204.139V453.397H211.247V437.395Z\" fill=#95A9A7 /><path d=\"M226.19 437.395H218.368V453.397H226.19V437.395Z\" fill=#95A9A7 /><path d=\"M152.229 546.168H101.731V585.629H152.229V546.168Z\" fill=#95A9A7 /><path d=\"M106.573 529.466H82.6602V585.629H106.573V529.466Z\" fill=#95A9A7 /><path d=\"M94.6097 565.892H53.7529V585.615H94.6097V565.892Z\" fill=#95A9A7 /><path d=\"M1030.24 541.902H526.74V585.63H1030.24V541.902Z\" fill=#95A9A7 /><path d=\"M1082.41 471.736H1004.65V585.63H1082.41V471.736Z\" fill=#95A9A7 /><path d=\"M1148.77 516.01H1071.02V584.972H1148.77V516.01Z\" fill=#95A9A7 /><path d=\"M813.115 505.882H769.502V563.766H813.115V505.882Z\" fill=#95A9A7 /><path d=\"M1098.51 363.424H1043.52V585.629H1098.51V363.424Z\" fill=#95A9A7 /><path d=\"M1189.07 585.629H1116.53V455.873H1171.52L1189.07 585.629Z\" fill=#95A9A7 /><path d=\"M1220.83 556.002H1157.31V585.615H1220.83V556.002Z\" fill=#95A9A7 /><path d=\"M1086.2 316.997H1084.29V377.385H1086.2V316.997Z\" fill=#95A9A7 /><path opacity=0.5 d=\"M989.004 420.926H986.835V432.914H989.004V420.926Z\" fill=white /><path opacity=0.5 d=\"M996.475 420.926H994.307V432.914H996.475V420.926Z\" fill=white /><path opacity=0.5 d=\"M1003.95 420.926H1001.78V432.914H1003.95V420.926Z\" fill=white /><path opacity=0.5 d=\"M990.081 437.628H987.912V449.616H990.081V437.628Z\" fill=white /><path opacity=0.5 d=\"M997.553 437.628H995.385V449.616H997.553V437.628Z\" fill=white /><path opacity=0.5 d=\"M1003.95 437.628H1001.78V449.616H1003.95V437.628Z\" fill=white /><path opacity=0.5 d=\"M990.081 454.33H987.912V466.318H990.081V454.33Z\" fill=white /><path opacity=0.5 d=\"M997.553 454.33H995.385V466.318H997.553V454.33Z\" fill=white /><path opacity=0.5 d=\"M1005.03 454.33H1002.86V466.318H1005.03V454.33Z\" fill=white /><path opacity=0.5 d=\"M990.081 471.032H987.912V483.02H990.081V471.032Z\" fill=white /><path opacity=0.5 d=\"M997.553 471.032H995.385V483.02H997.553V471.032Z\" fill=white /><path opacity=0.5 d=\"M1005.03 471.032H1002.86V483.02H1005.03V471.032Z\" fill=white /><path opacity=0.5 d=\"M990.081 488.657H987.912V500.645H990.081V488.657Z\" fill=white /><path opacity=0.5 d=\"M997.553 488.657H995.385V500.645H997.553V488.657Z\" fill=white /><path opacity=0.5 d=\"M1005.03 488.657H1002.86V500.645H1005.03V488.657Z\" fill=white /><path d=\"M1092.59 329.964H1090.69V390.352H1092.59V329.964Z\" fill=#95A9A7 /><path opacity=0.5 d=\"M960.088 418.037H957.919V430.025H960.088V418.037Z\" fill=white /><path opacity=0.5 d=\"M967.559 418.037H965.391V430.025H967.559V418.037Z\" fill=white /><path opacity=0.5 d=\"M975.031 418.037H972.862V430.025H975.031V418.037Z\" fill=white /><path opacity=0.5 d=\"M961.165 434.739H958.996V446.727H961.165V434.739Z\" fill=white /><path opacity=0.5 d=\"M968.637 434.739H966.469V446.727H968.637V434.739Z\" fill=white /><path opacity=0.5 d=\"M975.031 434.739H972.862V446.727H975.031V434.739Z\" fill=white /><path opacity=0.5 d=\"M961.165 451.441H958.996V463.429H961.165V451.441Z\" fill=white /><path opacity=0.5 d=\"M968.637 451.441H966.469V463.429H968.637V451.441Z\" fill=white /><path opacity=0.5 d=\"M976.108 451.441H973.939V463.429H976.108V451.441Z\" fill=white /><path opacity=0.5 d=\"M961.165 468.144H958.996V480.132H961.165V468.144Z\" fill=white /><path opacity=0.5 d=\"M968.637 468.144H966.469V480.132H968.637V468.144Z\" fill=white /><path opacity=0.5 d=\"M976.108 468.144H973.939V480.132H976.108V468.144Z\" fill=white /><path opacity=0.5 d=\"M961.165 485.769H958.996V497.757H961.165V485.769Z\" fill=white /><path opacity=0.5 d=\"M968.637 485.769H966.469V497.757H968.637V485.769Z\" fill=white /><path opacity=0.5 d=\"M976.108 485.769H973.939V497.757H976.108V485.769Z\" fill=white /><path d=\"M1080.39 338.301H1078.49V398.689H1080.39V338.301Z\" fill=#95A9A7 /><path opacity=0.5 d=\"M931.171 415.148H929.002V427.136H931.171V415.148Z\" fill=white /><path opacity=0.5 d=\"M938.642 415.148H936.474V427.136H938.642V415.148Z\" fill=white /><path opacity=0.5 d=\"M946.114 415.148H943.945V427.136H946.114V415.148Z\" fill=white /><path opacity=0.5 d=\"M932.248 431.851H930.079V443.839H932.248V431.851Z\" fill=white /><path opacity=0.5 d=\"M939.719 431.851H937.551V443.839H939.719V431.851Z\" fill=white /><path opacity=0.5 d=\"M946.114 431.851H943.945V443.839H946.114V431.851Z\" fill=white /><path opacity=0.5 d=\"M932.248 448.553H930.079V460.541H932.248V448.553Z\" fill=white /><path opacity=0.5 d=\"M939.719 448.553H937.551V460.541H939.719V448.553Z\" fill=white /><path opacity=0.5 d=\"M932.248 465.255H930.079V477.243H932.248V465.255Z\" fill=white /><path opacity=0.5 d=\"M939.719 465.255H937.551V477.243H939.719V465.255Z\" fill=white /><path opacity=0.5 d=\"M947.192 465.255H945.023V477.243H947.192V465.255Z\" fill=white /><path opacity=0.5 d=\"M932.248 482.88H930.079V494.868H932.248V482.88Z\" fill=white /><path opacity=0.5 d=\"M939.719 482.88H937.551V494.868H939.719V482.88Z\" fill=white /><path opacity=0.5 d=\"M947.192 482.88H945.023V494.868H947.192V482.88Z\" fill=white /><path d=\"M1145.33 445.396H1119.37V465.833H1145.33V445.396Z\" fill=#95A9A7 /><path d=\"M1142.49 438.108H1122.23V449.593H1142.49V438.108Z\" fill=#95A9A7 /><path d=\"M1160.62 451.383H1155.64V459.636H1160.62V451.383Z\" fill=#95A9A7 /><path d=\"M1169.49 443.844H1162.38V459.623H1169.49V443.844Z\" fill=#95A9A7 /><path d=\"M835.208 413.544H769.277V625.999H835.208V413.544Z\" fill=#658280 /><path d=\"M840.134 414.803H764.353V416.957H840.134V414.803Z\" fill=#658280 /><path d=\"M838.077 444.653H766.396V446.794H838.077V444.653Z\" fill=#658280 /><path d=\"M838.077 473.554H766.396V475.694H838.077V473.554Z\" fill=#658280 /><path d=\"M838.077 502.454H766.396V504.594H838.077V502.454Z\" fill=#658280 /><path d=\"M838.077 531.354H766.396V533.494H838.077V531.354Z\" fill=#658280 /><path d=\"M838.077 560.254H766.396V562.394H838.077V560.254Z\" fill=#658280 /><path d=\"M838.077 589.153H766.396V591.294H838.077V589.153Z\" fill=#658280 /><path d=\"M842.638 408.941H761.848V414.816H842.638V408.941Z\" fill=#658280 /><path opacity=0.29 d=\"M782.066 423.938H775.21V440.905H782.066V423.938Z\" fill=#658280 /><path d=\"M797.387 423.938H790.531V440.905H797.387V423.938Z\" fill=#658280 /><path d=\"M812.708 423.938H805.853V440.905H812.708V423.938Z\" fill=#658280 /><path d=\"M828.03 423.938H821.174V440.905H828.03V423.938Z\" fill=#658280 /><path d=\"M782.066 451.69H775.21V468.658H782.066V451.69Z\" fill=#658280 /><path opacity=0.29 d=\"M797.387 451.69H790.531V468.658H797.387V451.69Z\" fill=#658280 /><path d=\"M812.708 451.69H805.853V468.658H812.708V451.69Z\" fill=#658280 /><path d=\"M828.03 451.69H821.174V468.658H828.03V451.69Z\" fill=#658280 /><path d=\"M782.066 480.59H775.21V497.558H782.066V480.59Z\" fill=#658280 /><path d=\"M797.387 480.59H790.531V497.558H797.387V480.59Z\" fill=#658280 /><path d=\"M812.708 480.59H805.853V497.558H812.708V480.59Z\" fill=#658280 /><path opacity=0.29 d=\"M828.03 480.59H821.174V497.558H828.03V480.59Z\" fill=#658280 /><path d=\"M782.066 509.49H775.21V526.458H782.066V509.49Z\" fill=#658280 /><path opacity=0.29 d=\"M797.387 509.49H790.531V526.458H797.387V509.49Z\" fill=#658280 /><path opacity=0.29 d=\"M812.708 509.49H805.853V526.458H812.708V509.49Z\" fill=#658280 /><path d=\"M828.03 509.49H821.174V526.458H828.03V509.49Z\" fill=#658280 /><path opacity=0.29 d=\"M782.066 538.39H775.21V555.358H782.066V538.39Z\" fill=#658280 /><path d=\"M797.387 538.39H790.531V555.358H797.387V538.39Z\" fill=#658280 /><path d=\"M812.708 538.39H805.853V555.358H812.708V538.39Z\" fill=#658280 /><path d=\"M828.03 538.39H821.174V555.358H828.03V538.39Z\" fill=#658280 /><path d=\"M782.066 567.29H775.21V584.258H782.066V567.29Z\" fill=#658280 /><path d=\"M797.387 567.29H790.531V584.258H797.387V567.29Z\" fill=#658280 /><path opacity=0.29 d=\"M812.708 567.29H805.853V584.258H812.708V567.29Z\" fill=#658280 /><path d=\"M828.03 567.29H821.174V584.258H828.03V567.29Z\" fill=#658280 /><path d=\"M782.066 596.189H775.21V613.157H782.066V596.189Z\" fill=#658280 /><path opacity=0.29 d=\"M797.387 596.189H790.531V613.157H797.387V596.189Z\" fill=#658280 /><path d=\"M812.708 596.189H805.853V613.157H812.708V596.189Z\" fill=#658280 /><path opacity=0.29 d=\"M828.03 596.189H821.174V613.157H828.03V596.189Z\" fill=#658280 /><path d=\"M795.863 400.843H773.434V411.88H795.863V400.843Z\" fill=#658280 /><path d=\"M797.387 400.521H771.922V402.409H797.387V400.521Z\" fill=#658280 /><path d=\"M674.789 625.999H586.961V424.133L674.789 402.661V625.999Z\" fill=#658280 /><path d=\"M590.809 420.595H583.1V626.014H590.809V420.595Z\" fill=#658280 /><path d=\"M612.763 414.804H605.054V626H612.763V414.804Z\" fill=#658280 /><path d=\"M634.716 408.788H627.007V626H634.716V408.788Z\" fill=#658280 /><path d=\"M656.684 403.893H648.975V626H656.684V403.893Z\" fill=#658280 /><path d=\"M678.637 398.675H670.928V626H678.637V398.675Z\" fill=#658280 /><path opacity=0.29 d=\"M603.053 437.828H592.811V453.425H603.053V437.828Z\" fill=#658280 /><path opacity=0.29 d=\"M625.02 437.828H614.777V453.425H625.02V437.828Z\" fill=#658280 /><path d=\"M646.974 437.828H636.731V453.425H646.974V437.828Z\" fill=#658280 /><path opacity=0.29 d=\"M668.927 437.828H658.685V453.425H668.927V437.828Z\" fill=#658280 /><path d=\"M603.053 464.994H592.811V480.591H603.053V464.994Z\" fill=#658280 /><path d=\"M625.02 464.994H614.777V480.591H625.02V464.994Z\" fill=#658280 /><path opacity=0.29 d=\"M646.974 464.994H636.731V480.591H646.974V464.994Z\" fill=#658280 /><path opacity=0.29 d=\"M668.927 464.994H658.685V480.591H668.927V464.994Z\" fill=#658280 /><path opacity=0.29 d=\"M603.053 492.159H592.811V507.756H603.053V492.159Z\" fill=#658280 /><path opacity=0.29 d=\"M625.02 492.159H614.777V507.756H625.02V492.159Z\" fill=#658280 /><path opacity=0.29 d=\"M646.974 492.159H636.731V507.756H646.974V492.159Z\" fill=#658280 /><path d=\"M668.927 492.159H658.685V507.756H668.927V492.159Z\" fill=#658280 /><path opacity=0.29 d=\"M603.053 519.311H592.811V534.908H603.053V519.311Z\" fill=#658280 /><path d=\"M625.02 519.311H614.777V534.908H625.02V519.311Z\" fill=#658280 /><path opacity=0.29 d=\"M646.974 519.311H636.731V534.908H646.974V519.311Z\" fill=#658280 /><path opacity=0.29 d=\"M668.927 519.311H658.685V534.908H668.927V519.311Z\" fill=#658280 /><path opacity=0.29 d=\"M603.053 546.476H592.811V562.073H603.053V546.476Z\" fill=#658280 /><path opacity=0.29 d=\"M625.02 546.476H614.777V562.073H625.02V546.476Z\" fill=#658280 /><path d=\"M646.974 546.476H636.731V562.073H646.974V546.476Z\" fill=#658280 /><path opacity=0.29 d=\"M668.927 546.476H658.685V562.073H668.927V546.476Z\" fill=#658280 /><path d=\"M603.053 573.642H592.811V589.239H603.053V573.642Z\" fill=#658280 /><path d=\"M625.02 573.642H614.777V589.239H625.02V573.642Z\" fill=#658280 /><path opacity=0.29 d=\"M646.974 573.642H636.731V589.239H646.974V573.642Z\" fill=#658280 /><path opacity=0.29 d=\"M668.927 573.642H658.685V589.239H668.927V573.642Z\" fill=#658280 /><path opacity=0.29 d=\"M603.053 600.807H592.811V616.404H603.053V600.807Z\" fill=#658280 /><path d=\"M625.02 600.807H614.777V616.404H625.02V600.807Z\" fill=#658280 /><path opacity=0.29 d=\"M646.974 600.807H636.731V616.404H646.974V600.807Z\" fill=#658280 /><path d=\"M668.927 600.807H658.685V616.404H668.927V600.807Z\" fill=#658280 /><path d=\"M336.434 433.813V435.912H334.335V441.885H371.092V626H310.786V451.481V441.885V435.912H308.604V433.813H336.434Z\" fill=#658280 /><path d=\"M490.823 517.45H439.164V626.014H490.823V517.45Z\" fill=#658280 /><path d=\"M256.021 492.564H214.031V626.014H256.021V492.564Z\" fill=#658280 /><path d=\"M293.45 520.359H247.696V626H293.45V520.359Z\" fill=#658280 /><path d=\"M247.71 487.207H229.143V503.182H247.71V487.207Z\" fill=#658280 /><path d=\"M299.62 518.625H250.844V522.528H299.62V518.625Z\" fill=#658280 /><path d=\"M339.834 565.668H288.539V626H339.834V565.668Z\" fill=#658280 /><path d=\"M164.471 516.597H122.747V626H164.471V516.597Z\" fill=#658280 /><path d=\"M141.427 571.123H86.5361V625.999H141.427V571.123Z\" fill=#658280 /><path d=\"M60.4263 562.143H26.0898V626H60.4263V562.143Z\" fill=#658280 /><path d=\"M134.907 605.996H53.7529V625.999H134.907V605.996Z\" fill=#658280 /><path d=\"M36.5984 599.534H-5V626H36.5984V599.534Z\" fill=#658280 /><path d=\"M229.129 585.629H164.472V625.999H229.129V585.629Z\" fill=#658280 /><path d=\"M454.891 608.612H354.162V626H454.891V608.612Z\" fill=#658280 /><path d=\"M633.471 608.612H532.742V626H633.471V608.612Z\" fill=#658280 /><path d=\"M450.959 557.54H412.677L396.488 617.298H450.959V557.54Z\" fill=#658280 /><path d=\"M469.722 470.589H468.658V536.88H469.722V470.589Z\" fill=#658280 /><path d=\"M475.417 493.026H473.99V532.152H475.417V493.026Z\" fill=#658280 /><path d=\"M485.729 499.95H466.364V519.31H485.729V499.95Z\" fill=#658280 /><path d=\"M488.737 498.453H463.09V500.188H488.737V498.453Z\" fill=#658280 /><path d=\"M544.006 570.004H481.42V625.999H544.006V570.004Z\" fill=#658280 /><path d=\"M572.256 508.371H532.043V616.403H572.256V508.371Z\" fill=#658280 /><path d=\"M753.313 528.683H689.075V626H753.313V528.683Z\" fill=#658280 /><path d=\"M742.175 590.147H668.927V626.014H742.175V590.147Z\" fill=#658280 /><path d=\"M797.388 613.173H749.759V626.014H797.388V613.173Z\" fill=#658280 /><path d=\"M900.551 590.147H823.119V626.014H900.551V590.147Z\" fill=#658280 /><path d=\"M853.954 625.996H950.317V496.254H853.954V625.996Z\" fill=#658280 /><path d=\"M851.477 496.25H955.941V491.27H851.477V496.25Z\" fill=#658280 /><path d=\"M903.716 504.075H946.056V477.763H903.716V504.075Z\" fill=#658280 /><path d=\"M882.769 493.767H889.877V477.764H882.769V493.767Z\" fill=#658280 /><path d=\"M867.828 493.767H875.649V477.764H867.828V493.767Z\" fill=#658280 /><path d=\"M1016.58 625.997H1092.85V436.511H1016.58V625.997Z\" fill=#658280 /><path d=\"M1014.39 438.604H1095V433.246H1014.39V438.604Z\" fill=#658280 /><path d=\"M1019.12 451.848H1090.27V426.389H1019.12V451.848Z\" fill=#658280 /><path d=\"M1056.65 443.794H1084.83V415.985H1056.65V443.794Z\" fill=#658280 /><path d=\"M1068.53 423.812H1084.83V409.18H1073.13L1068.53 423.812Z\" fill=#658280 /><path d=\"M1076.67 429.636H1078.25V397.015H1076.67V429.636Z\" fill=#658280 /><path d=\"M1076.05 395.331C1076.05 396.268 1076.68 397.024 1077.47 397.024C1078.25 397.024 1078.88 396.268 1078.88 395.331C1078.88 394.394 1078.25 393.639 1077.47 393.639C1076.68 393.639 1076.05 394.394 1076.05 395.331Z\" fill=#658280 /><path d=\"M1116.53 547.776H1082.39V625.999H1116.53V547.776Z\" fill=#658280 /><path d=\"M1024.09 509.63H985.161V625.999H1024.09V509.63Z\" fill=#658280 /><path d=\"M1004.65 626H949.817V563.766L996.089 584.259L1004.65 626Z\" fill=#658280 /><path d=\"M1189.07 592.204H1105.33V626H1189.07V592.204Z\" fill=#658280 /><path d=\"M1206.78 491.068H1158.13V626H1206.78V491.068Z\" fill=#658280 /><path d=\"M1276 600.807H1195.41V626H1276V600.807Z\" fill=#658280 /><path d=\"M1209.01 488.592H1155.64V493.012H1209.01V488.592Z\" fill=#658280 /><path d=\"M1200.26 469.554H1199.2V496.747H1200.26V469.554Z\" fill=#658280 /><path d=\"M1193.15 472.995H1192.09V494.803H1193.15V472.995Z\" fill=#658280 /><path d=\"M1224.79 541.901H1203.1V603.716H1234.04L1224.79 541.901Z\" fill=#658280 /><g opacity=0.52><path opacity=0.52 d=\"M221.545 499.321H218.369V502.497H221.545V499.321Z\" fill=white /><path opacity=0.52 d=\"M227.925 499.321H224.749V502.497H227.925V499.321Z\" fill=white /><path opacity=0.52 d=\"M221.545 506.777H218.369V509.953H221.545V506.777Z\" fill=white /><path opacity=0.52 d=\"M227.925 506.777H224.749V509.953H227.925V506.777Z\" fill=white /><path opacity=0.52 d=\"M221.545 513.995H218.369V517.171H221.545V513.995Z\" fill=white /><path opacity=0.52 d=\"M235.02 499.321H231.844V502.497H235.02V499.321Z\" fill=white /></g><path opacity=0.5 d=\"M453.128 403.893H450.959V415.881H453.128V403.893Z\" fill=white /><path opacity=0.5 d=\"M460.599 403.893H458.431V415.881H460.599V403.893Z\" fill=white /><path opacity=0.5 d=\"M468.071 403.893H465.902V415.881H468.071V403.893Z\" fill=white /><path opacity=0.5 d=\"M475.543 403.893H473.374V415.881H475.543V403.893Z\" fill=white /><path opacity=0.5 d=\"M483.014 403.893H480.846V415.881H483.014V403.893Z\" fill=white /><path opacity=0.5 d=\"M490.486 403.893H488.317V415.881H490.486V403.893Z\" fill=white /><path opacity=0.5 d=\"M497.944 403.893H495.775V415.881H497.944V403.893Z\" fill=white /><path opacity=0.5 d=\"M505.416 403.893H503.247V415.881H505.416V403.893Z\" fill=white /><path opacity=0.5 d=\"M453.128 420.595H450.959V432.583H453.128V420.595Z\" fill=white /><path opacity=0.5 d=\"M460.599 420.595H458.431V432.583H460.599V420.595Z\" fill=white /><path opacity=0.5 d=\"M468.071 420.595H465.902V432.583H468.071V420.595Z\" fill=white /><path opacity=0.5 d=\"M475.543 420.595H473.374V432.583H475.543V420.595Z\" fill=white /><path opacity=0.5 d=\"M483.014 420.595H480.846V432.583H483.014V420.595Z\" fill=white /><path opacity=0.5 d=\"M490.486 420.595H488.317V432.583H490.486V420.595Z\" fill=white /><path opacity=0.5 d=\"M497.944 420.595H495.775V432.583H497.944V420.595Z\" fill=white /><path opacity=0.5 d=\"M505.416 420.595H503.247V432.583H505.416V420.595Z\" fill=white /><path opacity=0.5 d=\"M453.128 437.283H450.959V449.271H453.128V437.283Z\" fill=white /><path opacity=0.5 d=\"M460.599 437.283H458.431V449.271H460.599V437.283Z\" fill=white /><path opacity=0.5 d=\"M468.071 437.283H465.902V449.271H468.071V437.283Z\" fill=white /><path opacity=0.5 d=\"M475.543 437.283H473.374V449.271H475.543V437.283Z\" fill=white /><path opacity=0.5 d=\"M483.014 437.283H480.846V449.271H483.014V437.283Z\" fill=white /><path opacity=0.5 d=\"M490.486 437.283H488.317V449.271H490.486V437.283Z\" fill=white /><path opacity=0.5 d=\"M497.944 437.283H495.775V449.271H497.944V437.283Z\" fill=white /><path opacity=0.5 d=\"M505.416 437.283H503.247V449.271H505.416V437.283Z\" fill=white /><path opacity=0.5 d=\"M475.543 453.985H473.374V465.973H475.543V453.985Z\" fill=white /><path opacity=0.5 d=\"M483.014 453.985H480.846V465.973H483.014V453.985Z\" fill=white /><path opacity=0.5 d=\"M490.486 453.985H488.317V465.973H490.486V453.985Z\" fill=white /><path opacity=0.5 d=\"M497.944 453.985H495.775V465.973H497.944V453.985Z\" fill=white /><path opacity=0.5 d=\"M505.416 453.985H503.247V465.973H505.416V453.985Z\" fill=white /><path opacity=0.5 d=\"M483.014 471.61H480.846V483.598H483.014V471.61Z\" fill=white /><path opacity=0.5 d=\"M490.486 471.61H488.317V483.598H490.486V471.61Z\" fill=white /><path opacity=0.5 d=\"M497.944 471.61H495.775V483.598H497.944V471.61Z\" fill=white /><path opacity=0.5 d=\"M505.416 471.61H503.247V483.598H505.416V471.61Z\" fill=white /><path opacity=0.5 d=\"M512.888 403.893H510.719V415.881H512.888V403.893Z\" fill=white /><path opacity=0.5 d=\"M520.359 403.893H518.19V415.881H520.359V403.893Z\" fill=white /><path opacity=0.5 d=\"M527.831 403.893H525.662V415.881H527.831V403.893Z\" fill=white /><path opacity=0.5 d=\"M513.979 420.595H511.811V432.583H513.979V420.595Z\" fill=white /><path opacity=0.5 d=\"M521.451 420.595H519.282V432.583H521.451V420.595Z\" fill=white /><path opacity=0.5 d=\"M527.831 420.595H525.662V432.583H527.831V420.595Z\" fill=white /><path opacity=0.5 d=\"M513.979 437.283H511.811V449.271H513.979V437.283Z\" fill=white /><path opacity=0.5 d=\"M521.451 437.283H519.282V449.271H521.451V437.283Z\" fill=white /><path opacity=0.5 d=\"M528.908 437.283H526.739V449.271H528.908V437.283Z\" fill=white /><path opacity=0.5 d=\"M513.979 453.984H511.811V465.972H513.979V453.984Z\" fill=white /><path opacity=0.5 d=\"M521.451 453.984H519.282V465.972H521.451V453.984Z\" fill=white /><path opacity=0.5 d=\"M528.908 453.984H526.739V465.972H528.908V453.984Z\" fill=white /><path opacity=0.5 d=\"M513.979 471.61H511.811V483.598H513.979V471.61Z\" fill=white /><path opacity=0.5 d=\"M521.451 471.61H519.282V483.598H521.451V471.61Z\" fill=white /><path opacity=0.5 d=\"M528.908 471.61H526.739V483.598H528.908V471.61Z\" fill=white /><path opacity=0.5 d=\"M548.735 521.465H546.566V533.453H548.735V521.465Z\" fill=white /><path opacity=0.5 d=\"M556.207 521.465H554.038V533.453H556.207V521.465Z\" fill=white /><path opacity=0.5 d=\"M563.679 521.465H561.51V533.453H563.679V521.465Z\" fill=white /><path opacity=0.5 d=\"M549.812 538.167H547.644V550.155H549.812V538.167Z\" fill=white /><path opacity=0.5 d=\"M557.284 538.167H555.115V550.155H557.284V538.167Z\" fill=white /><path opacity=0.5 d=\"M563.679 538.167H561.51V550.155H563.679V538.167Z\" fill=white /><path opacity=0.5 d=\"M549.812 554.869H547.644V566.857H549.812V554.869Z\" fill=white /><path opacity=0.5 d=\"M557.284 554.869H555.115V566.857H557.284V554.869Z\" fill=white /><path opacity=0.5 d=\"M564.757 554.869H562.588V566.857H564.757V554.869Z\" fill=white /><path opacity=0.5 d=\"M549.812 571.571H547.644V583.559H549.812V571.571Z\" fill=white /><path opacity=0.5 d=\"M557.284 571.571H555.115V583.559H557.284V571.571Z\" fill=white /><path opacity=0.5 d=\"M564.757 571.571H562.588V583.559H564.757V571.571Z\" fill=white /><path opacity=0.5 d=\"M549.812 589.196H547.644V601.184H549.812V589.196Z\" fill=white /><path opacity=0.5 d=\"M557.284 589.196H555.115V601.184H557.284V589.196Z\" fill=white /><path opacity=0.5 d=\"M564.757 589.196H562.588V601.184H564.757V589.196Z\" fill=white /><path opacity=0.5 d=\"M989.004 322.721H986.835V334.709H989.004V322.721Z\" fill=white /><path opacity=0.5 d=\"M996.475 322.721H994.307V334.709H996.475V322.721Z\" fill=white /><path opacity=0.5 d=\"M1003.95 322.721H1001.78V334.709H1003.95V322.721Z\" fill=white /><path opacity=0.5 d=\"M990.081 339.423H987.912V351.411H990.081V339.423Z\" fill=white /><path opacity=0.5 d=\"M997.553 339.423H995.385V351.411H997.553V339.423Z\" fill=white /><path opacity=0.5 d=\"M1003.95 339.423H1001.78V351.411H1003.95V339.423Z\" fill=white /><path opacity=0.5 d=\"M990.081 356.125H987.912V368.113H990.081V356.125Z\" fill=white /><path opacity=0.5 d=\"M997.553 356.125H995.385V368.113H997.553V356.125Z\" fill=white /><path opacity=0.5 d=\"M1005.03 356.125H1002.86V368.113H1005.03V356.125Z\" fill=white /><path opacity=0.5 d=\"M990.081 372.827H987.912V384.815H990.081V372.827Z\" fill=white /><path opacity=0.5 d=\"M997.553 372.827H995.385V384.815H997.553V372.827Z\" fill=white /><path opacity=0.5 d=\"M1005.03 372.827H1002.86V384.815H1005.03V372.827Z\" fill=white /><path opacity=0.5 d=\"M990.081 390.452H987.912V402.44H990.081V390.452Z\" fill=white /><path opacity=0.5 d=\"M997.553 390.452H995.385V402.44H997.553V390.452Z\" fill=white /><path opacity=0.5 d=\"M1005.03 390.452H1002.86V402.44H1005.03V390.452Z\" fill=white /><path opacity=0.5 d=\"M960.088 319.833H957.919V331.821H960.088V319.833Z\" fill=white /><path opacity=0.5 d=\"M967.559 319.833H965.391V331.821H967.559V319.833Z\" fill=white /><path opacity=0.5 d=\"M975.031 319.833H972.862V331.821H975.031V319.833Z\" fill=white /><path opacity=0.5 d=\"M961.165 336.535H958.996V348.523H961.165V336.535Z\" fill=white /><path opacity=0.5 d=\"M968.637 336.535H966.469V348.523H968.637V336.535Z\" fill=white /><path opacity=0.5 d=\"M975.031 336.535H972.862V348.523H975.031V336.535Z\" fill=white /><path opacity=0.5 d=\"M961.165 353.237H958.996V365.225H961.165V353.237Z\" fill=white /><path opacity=0.5 d=\"M968.637 353.237H966.469V365.225H968.637V353.237Z\" fill=white /><path opacity=0.5 d=\"M976.108 353.237H973.939V365.225H976.108V353.237Z\" fill=white /><path opacity=0.5 d=\"M961.165 369.939H958.996V381.928H961.165V369.939Z\" fill=white /><path opacity=0.5 d=\"M968.637 369.939H966.469V381.928H968.637V369.939Z\" fill=white /><path opacity=0.5 d=\"M976.108 369.939H973.939V381.928H976.108V369.939Z\" fill=white /><path opacity=0.5 d=\"M961.165 387.564H958.996V399.553H961.165V387.564Z\" fill=white /><path opacity=0.5 d=\"M968.637 387.564H966.469V399.553H968.637V387.564Z\" fill=white /><path opacity=0.5 d=\"M976.108 387.564H973.939V399.553H976.108V387.564Z\" fill=white /><path opacity=0.5 d=\"M931.171 316.944H929.002V328.932H931.171V316.944Z\" fill=white /><path opacity=0.5 d=\"M938.642 316.944H936.474V328.932H938.642V316.944Z\" fill=white /><path opacity=0.5 d=\"M946.114 316.944H943.945V328.932H946.114V316.944Z\" fill=white /><path opacity=0.5 d=\"M932.248 333.646H930.079V345.635H932.248V333.646Z\" fill=white /><path opacity=0.5 d=\"M939.719 333.646H937.551V345.635H939.719V333.646Z\" fill=white /><path opacity=0.5 d=\"M946.114 333.646H943.945V345.635H946.114V333.646Z\" fill=white /><path opacity=0.5 d=\"M932.248 350.349H930.079V362.337H932.248V350.349Z\" fill=white /><path opacity=0.5 d=\"M939.719 350.349H937.551V362.337H939.719V350.349Z\" fill=white /><path opacity=0.5 d=\"M947.192 350.349H945.023V362.337H947.192V350.349Z\" fill=white /><path opacity=0.5 d=\"M932.248 367.051H930.079V379.039H932.248V367.051Z\" fill=white /><path opacity=0.5 d=\"M939.719 367.051H937.551V379.039H939.719V367.051Z\" fill=white /><path opacity=0.5 d=\"M947.192 367.051H945.023V379.039H947.192V367.051Z\" fill=white /><path opacity=0.5 d=\"M932.248 384.676H930.079V396.664H932.248V384.676Z\" fill=white /><path opacity=0.5 d=\"M939.719 384.676H937.551V396.664H939.719V384.676Z\" fill=white /><path opacity=0.5 d=\"M947.192 384.676H945.023V396.664H947.192V384.676Z\" fill=white /><path opacity=0.5 d=\"M460.053 522.611H457.885V534.599H460.053V522.611Z\" fill=white /><path opacity=0.5 d=\"M467.525 522.611H465.356V534.599H467.525V522.611Z\" fill=white /><path opacity=0.5 d=\"M474.997 522.611H472.828V534.599H474.997V522.611Z\" fill=white /><path opacity=0.5 d=\"M461.145 539.313H458.977V551.302H461.145V539.313Z\" fill=white /><path opacity=0.5 d=\"M468.617 539.313H466.448V551.302H468.617V539.313Z\" fill=white /><path opacity=0.5 d=\"M474.997 539.313H472.828V551.302H474.997V539.313Z\" fill=white /><path opacity=0.5 d=\"M461.145 556.016H458.977V568.004H461.145V556.016Z\" fill=white /><path opacity=0.5 d=\"M468.617 556.016H466.448V568.004H468.617V556.016Z\" fill=white /><path opacity=0.5 d=\"M476.074 556.016H473.905V568.004H476.074V556.016Z\" fill=white /><path opacity=0.5 d=\"M461.145 572.718H458.977V584.706H461.145V572.718Z\" fill=white /><path opacity=0.5 d=\"M468.617 572.718H466.448V584.706H468.617V572.718Z\" fill=white /><path opacity=0.5 d=\"M476.074 572.718H473.905V584.706H476.074V572.718Z\" fill=white /><path opacity=0.5 d=\"M461.145 590.343H458.977V602.331H461.145V590.343Z\" fill=white /><path opacity=0.5 d=\"M468.617 590.343H466.448V602.331H468.617V590.343Z\" fill=white /><path opacity=0.5 d=\"M476.074 590.343H473.905V602.331H476.074V590.343Z\" fill=white /><path opacity=0.5 d=\"M350.734 450.194H348.565V462.182H350.734V450.194Z\" fill=white /><path opacity=0.5 d=\"M358.206 450.194H356.037V462.182H358.206V450.194Z\" fill=white /><path opacity=0.5 d=\"M365.664 450.194H363.495V462.182H365.664V450.194Z\" fill=white /><path opacity=0.5 d=\"M351.811 466.896H349.643V478.885H351.811V466.896Z\" fill=white /><path opacity=0.5 d=\"M359.283 466.896H357.114V478.885H359.283V466.896Z\" fill=white /><path opacity=0.5 d=\"M365.664 466.896H363.495V478.885H365.664V466.896Z\" fill=white /><path opacity=0.5 d=\"M351.811 483.585H349.643V495.573H351.811V483.585Z\" fill=white /><path opacity=0.5 d=\"M359.283 483.585H357.114V495.573H359.283V483.585Z\" fill=white /><path opacity=0.5 d=\"M366.756 483.585H364.587V495.573H366.756V483.585Z\" fill=white /><path opacity=0.5 d=\"M351.811 500.286H349.643V512.274H351.811V500.286Z\" fill=white /><path opacity=0.5 d=\"M359.283 500.286H357.114V512.274H359.283V500.286Z\" fill=white /><path opacity=0.5 d=\"M366.756 500.286H364.587V512.274H366.756V500.286Z\" fill=white /><path opacity=0.5 d=\"M351.811 517.912H349.643V529.9H351.811V517.912Z\" fill=white /><path opacity=0.5 d=\"M359.283 517.912H357.114V529.9H359.283V517.912Z\" fill=white /><path opacity=0.5 d=\"M366.756 517.912H364.587V529.9H366.756V517.912Z\" fill=white /><path opacity=0.5 d=\"M317.965 450.194H315.796V462.182H317.965V450.194Z\" fill=white /><path opacity=0.5 d=\"M325.436 450.194H323.268V462.182H325.436V450.194Z\" fill=white /><path opacity=0.5 d=\"M332.908 450.194H330.739V462.182H332.908V450.194Z\" fill=white /><path opacity=0.5 d=\"M319.042 466.896H316.873V478.885H319.042V466.896Z\" fill=white /><path opacity=0.5 d=\"M326.514 466.896H324.346V478.885H326.514V466.896Z\" fill=white /><path opacity=0.5 d=\"M332.908 466.896H330.739V478.885H332.908V466.896Z\" fill=white /><path opacity=0.5 d=\"M319.042 483.585H316.873V495.573H319.042V483.585Z\" fill=white /><path opacity=0.5 d=\"M326.514 483.585H324.346V495.573H326.514V483.585Z\" fill=white /><path opacity=0.5 d=\"M333.986 483.585H331.817V495.573H333.986V483.585Z\" fill=white /><path opacity=0.5 d=\"M319.042 500.286H316.873V512.274H319.042V500.286Z\" fill=white /><path opacity=0.5 d=\"M326.514 500.286H324.346V512.274H326.514V500.286Z\" fill=white /><path opacity=0.5 d=\"M333.986 500.286H331.817V512.274H333.986V500.286Z\" fill=white /><path opacity=0.5 d=\"M319.042 517.912H316.873V529.9H319.042V517.912Z\" fill=white /><path opacity=0.5 d=\"M326.514 517.912H324.346V529.9H326.514V517.912Z\" fill=white /><path opacity=0.5 d=\"M333.986 517.912H331.817V529.9H333.986V517.912Z\" fill=white /><path opacity=0.5 d=\"M255.559 527.731H253.391V539.719H255.559V527.731Z\" fill=white /><path opacity=0.5 d=\"M263.031 527.731H260.862V539.719H263.031V527.731Z\" fill=white /><path opacity=0.5 d=\"M270.503 527.731H268.334V539.719H270.503V527.731Z\" fill=white /><path opacity=0.5 d=\"M256.637 544.434H254.468V556.422H256.637V544.434Z\" fill=white /><path opacity=0.5 d=\"M264.108 544.434H261.939V556.422H264.108V544.434Z\" fill=white /><path opacity=0.5 d=\"M270.503 544.434H268.334V556.422H270.503V544.434Z\" fill=white /><path opacity=0.5 d=\"M256.637 561.122H254.468V573.11H256.637V561.122Z\" fill=white /><path opacity=0.5 d=\"M264.108 561.122H261.939V573.11H264.108V561.122Z\" fill=white /><path opacity=0.5 d=\"M271.581 561.122H269.412V573.11H271.581V561.122Z\" fill=white /><path opacity=0.5 d=\"M256.637 577.823H254.468V589.811H256.637V577.823Z\" fill=white /><path opacity=0.5 d=\"M264.108 577.823H261.939V589.811H264.108V577.823Z\" fill=white /><path opacity=0.5 d=\"M271.581 577.823H269.412V589.811H271.581V577.823Z\" fill=white /><path opacity=0.5 d=\"M256.637 595.449H254.468V607.437H256.637V595.449Z\" fill=white /><path opacity=0.5 d=\"M264.108 595.449H261.939V607.437H264.108V595.449Z\" fill=white /><path opacity=0.5 d=\"M271.581 595.449H269.412V607.437H271.581V595.449Z\" fill=white /><path opacity=0.5 d=\"M136.767 522.528H134.599V534.516H136.767V522.528Z\" fill=white /><path opacity=0.5 d=\"M144.239 522.528H142.07V534.516H144.239V522.528Z\" fill=white /><path opacity=0.5 d=\"M151.711 522.528H149.542V534.516H151.711V522.528Z\" fill=white /><path opacity=0.5 d=\"M137.859 539.23H135.69V551.219H137.859V539.23Z\" fill=white /><path opacity=0.5 d=\"M145.316 539.23H143.147V551.219H145.316V539.23Z\" fill=white /><path opacity=0.5 d=\"M151.711 539.23H149.542V551.219H151.711V539.23Z\" fill=white /><path opacity=0.5 d=\"M137.859 555.933H135.69V567.921H137.859V555.933Z\" fill=white /><path opacity=0.5 d=\"M145.316 555.933H143.147V567.921H145.316V555.933Z\" fill=white /><path opacity=0.5 d=\"M152.789 555.933H150.62V567.921H152.789V555.933Z\" fill=white /><path opacity=0.5 d=\"M137.859 572.62H135.69V584.608H137.859V572.62Z\" fill=white /><path opacity=0.5 d=\"M145.316 572.62H143.147V584.608H145.316V572.62Z\" fill=white /><path opacity=0.5 d=\"M152.789 572.62H150.62V584.608H152.789V572.62Z\" fill=white /><path opacity=0.5 d=\"M137.859 590.246H135.69V602.234H137.859V590.246Z\" fill=white /><path opacity=0.5 d=\"M145.316 590.246H143.147V602.234H145.316V590.246Z\" fill=white /><path opacity=0.5 d=\"M152.789 590.246H150.62V602.234H152.789V590.246Z\" fill=white /><path opacity=0.5 d=\"M222.791 527.731H220.622V539.719H222.791V527.731Z\" fill=white /><path opacity=0.5 d=\"M230.263 527.731H228.094V539.719H230.263V527.731Z\" fill=white /><path opacity=0.5 d=\"M237.734 527.731H235.565V539.719H237.734V527.731Z\" fill=white /><path opacity=0.5 d=\"M223.868 544.434H221.699V556.422H223.868V544.434Z\" fill=white /><path opacity=0.5 d=\"M231.34 544.434H229.171V556.422H231.34V544.434Z\" fill=white /><path opacity=0.5 d=\"M237.734 544.434H235.565V556.422H237.734V544.434Z\" fill=white /><path opacity=0.5 d=\"M223.868 561.122H221.699V573.11H223.868V561.122Z\" fill=white /><path opacity=0.5 d=\"M231.34 561.122H229.171V573.11H231.34V561.122Z\" fill=white /><path opacity=0.5 d=\"M238.812 561.122H236.644V573.11H238.812V561.122Z\" fill=white /><path opacity=0.5 d=\"M223.868 577.823H221.699V589.811H223.868V577.823Z\" fill=white /><path opacity=0.5 d=\"M231.34 577.823H229.171V589.811H231.34V577.823Z\" fill=white /><path opacity=0.5 d=\"M238.812 577.823H236.644V589.811H238.812V577.823Z\" fill=white /><path opacity=0.5 d=\"M223.868 595.449H221.699V607.437H223.868V595.449Z\" fill=white /><path opacity=0.5 d=\"M231.34 595.449H229.171V607.437H231.34V595.449Z\" fill=white /><path opacity=0.5 d=\"M238.812 595.449H236.644V607.437H238.812V595.449Z\" fill=white /><path opacity=0.33 d=\"M600.492 433.66H595.371V446.641H600.492V433.66Z\" fill=white /><path opacity=0.33 d=\"M600.492 458.503H595.371V471.484H600.492V458.503Z\" fill=white /><path opacity=0.33 d=\"M600.492 483.332H595.371V496.313H600.492V483.332Z\" fill=white /><path opacity=0.33 d=\"M600.492 508.176H595.371V521.157H600.492V508.176Z\" fill=white /><path opacity=0.33 d=\"M600.492 531.593H595.371V544.574H600.492V531.593Z\" fill=white /><path opacity=0.33 d=\"M600.492 556.422H595.371V569.403H600.492V556.422Z\" fill=white /><path opacity=0.33 d=\"M622.46 433.66H617.339V446.641H622.46V433.66Z\" fill=white /><path opacity=0.33 d=\"M622.46 458.503H617.339V471.484H622.46V458.503Z\" fill=white /><path opacity=0.33 d=\"M622.46 483.332H617.339V496.313H622.46V483.332Z\" fill=white /><path opacity=0.33 d=\"M622.46 508.176H617.339V521.157H622.46V508.176Z\" fill=white /><path opacity=0.33 d=\"M622.46 531.593H617.339V544.574H622.46V531.593Z\" fill=white /><path opacity=0.33 d=\"M622.46 556.422H617.339V569.403H622.46V556.422Z\" fill=white /><path opacity=0.33 d=\"M644.413 433.66H639.292V446.641H644.413V433.66Z\" fill=white /><path opacity=0.33 d=\"M644.413 458.503H639.292V471.484H644.413V458.503Z\" fill=white /><path opacity=0.33 d=\"M644.413 483.332H639.292V496.313H644.413V483.332Z\" fill=white /><path opacity=0.33 d=\"M644.413 508.176H639.292V521.157H644.413V508.176Z\" fill=white /><path opacity=0.33 d=\"M644.413 531.593H639.292V544.574H644.413V531.593Z\" fill=white /><path opacity=0.33 d=\"M644.413 556.422H639.292V569.403H644.413V556.422Z\" fill=white /><path opacity=0.33 d=\"M666.366 433.66H661.245V446.641H666.366V433.66Z\" fill=white /><path opacity=0.33 d=\"M666.366 458.503H661.245V471.484H666.366V458.503Z\" fill=white /><path opacity=0.33 d=\"M666.366 483.332H661.245V496.313H666.366V483.332Z\" fill=white /><path opacity=0.33 d=\"M666.366 508.176H661.245V521.157H666.366V508.176Z\" fill=white /><path opacity=0.33 d=\"M666.366 531.593H661.245V544.574H666.366V531.593Z\" fill=white /><path opacity=0.33 d=\"M666.366 556.422H661.245V569.403H666.366V556.422Z\" fill=white /><path opacity=0.5 d=\"M517.155 252.58H512.888V263.939H517.155V252.58Z\" fill=white /><path opacity=0.5 d=\"M527.678 252.58H523.41V263.939H527.678V252.58Z\" fill=white /><path opacity=0.5 d=\"M538.186 252.58H533.918V263.939H538.186V252.58Z\" fill=white /><path opacity=0.5 d=\"M548.693 252.58H544.426V263.939H548.693V252.58Z\" fill=white /><path opacity=0.5 d=\"M517.155 271.507H512.888V282.865H517.155V271.507Z\" fill=white /><path opacity=0.5 d=\"M527.678 271.507H523.41V282.865H527.678V271.507Z\" fill=white /><path opacity=0.5 d=\"M538.186 271.507H533.918V282.865H538.186V271.507Z\" fill=white /><path opacity=0.5 d=\"M548.693 271.507H544.426V282.865H548.693V271.507Z\" fill=white /><path opacity=0.5 d=\"M517.155 290.433H512.888V301.791H517.155V290.433Z\" fill=white /><path opacity=0.5 d=\"M527.678 290.433H523.41V301.791H527.678V290.433Z\" fill=white /><path opacity=0.5 d=\"M560.629 252.58H556.361V263.939H560.629V252.58Z\" fill=white /><path opacity=0.4 d=\"M231.857 367.704H229.143V378.125H231.857V367.704Z\" fill=white /><path opacity=0.4 d=\"M241.414 367.704H238.699V378.125H241.414V367.704Z\" fill=white /><path opacity=0.4 d=\"M252.593 367.704H249.879V378.125H252.593V367.704Z\" fill=white /><path opacity=0.4 d=\"M262.165 367.704H259.45V378.125H262.165V367.704Z\" fill=white /><path opacity=0.4 d=\"M210.618 367.704H207.903V378.125H210.618V367.704Z\" fill=white /><path opacity=0.4 d=\"M220.174 367.704H217.46V378.125H220.174V367.704Z\" fill=white /><path opacity=0.4 d=\"M231.857 385.792H229.143V396.213H231.857V385.792Z\" fill=white /><path opacity=0.4 d=\"M241.414 385.792H238.699V396.213H241.414V385.792Z\" fill=white /><path opacity=0.4 d=\"M252.593 385.792H249.879V396.213H252.593V385.792Z\" fill=white /><path opacity=0.4 d=\"M262.165 385.792H259.45V396.213H262.165V385.792Z\" fill=white /><path opacity=0.4 d=\"M210.618 385.792H207.903V396.213H210.618V385.792Z\" fill=white /><path opacity=0.4 d=\"M220.174 385.792H217.46V396.213H220.174V385.792Z\" fill=white /><path opacity=0.4 d=\"M231.857 403.879H229.143V414.3H231.857V403.879Z\" fill=white /><path opacity=0.4 d=\"M241.414 403.879H238.699V414.3H241.414V403.879Z\" fill=white /><path opacity=0.4 d=\"M252.593 403.879H249.879V414.3H252.593V403.879Z\" fill=white /><path opacity=0.4 d=\"M262.165 403.879H259.45V414.3H262.165V403.879Z\" fill=white /><path opacity=0.4 d=\"M210.618 403.879H207.903V414.3H210.618V403.879Z\" fill=white /><path opacity=0.4 d=\"M220.174 403.879H217.46V414.3H220.174V403.879Z\" fill=white /><path opacity=0.5 d=\"M739.013 447.536H734.815V463.693H739.013V447.536Z\" fill=white /><path opacity=0.5 d=\"M751.858 447.536H747.66V463.693H751.858V447.536Z\" fill=white /><path opacity=0.5 d=\"M763.947 447.536H759.749V463.693H763.947V447.536Z\" fill=white /><path opacity=0.33 d=\"M1027.29 450.894H1024.1V459.972H1027.29V450.894Z\" fill=white /><path opacity=0.33 d=\"M1037.28 450.894H1034.09V459.972H1037.28V450.894Z\" fill=white /><path opacity=0.33 d=\"M1027.29 450.894H1024.1V459.972H1027.29V450.894Z\" fill=white /><path opacity=0.33 d=\"M1037.28 450.894H1034.09V459.972H1037.28V450.894Z\" fill=white /><path opacity=0.33 d=\"M1046.71 450.894H1043.52V459.972H1046.71V450.894Z\" fill=white /><path opacity=0.33 d=\"M1056.7 450.894H1053.51V459.972H1056.7V450.894Z\" fill=white /><path opacity=0.33 d=\"M1027.29 467.189H1024.1V476.268H1027.29V467.189Z\" fill=white /><path opacity=0.33 d=\"M1037.28 467.189H1034.09V476.268H1037.28V467.189Z\" fill=white /><path opacity=0.33 d=\"M1027.29 467.189H1024.1V476.268H1027.29V467.189Z\" fill=white /><path opacity=0.33 d=\"M1037.28 467.189H1034.09V476.268H1037.28V467.189Z\" fill=white /><path opacity=0.33 d=\"M1046.71 467.189H1043.52V476.268H1046.71V467.189Z\" fill=white /><path opacity=0.33 d=\"M1056.7 467.189H1053.51V476.268H1056.7V467.189Z\" fill=white /><path opacity=0.33 d=\"M1027.29 484.535H1024.1V493.614H1027.29V484.535Z\" fill=white /><path opacity=0.33 d=\"M1037.28 484.535H1034.09V493.614H1037.28V484.535Z\" fill=white /><path opacity=0.33 d=\"M1027.29 484.535H1024.1V493.614H1027.29V484.535Z\" fill=white /><path opacity=0.33 d=\"M1037.28 484.535H1034.09V493.614H1037.28V484.535Z\" fill=white /><path opacity=0.33 d=\"M1046.71 484.535H1043.52V493.614H1046.71V484.535Z\" fill=white /><path opacity=0.33 d=\"M1056.7 484.535H1053.51V493.614H1056.7V484.535Z\" fill=white /><path opacity=0.33 d=\"M1067.62 450.894H1064.43V459.972H1067.62V450.894Z\" fill=white /><path opacity=0.33 d=\"M1067.62 467.189H1064.43V476.268H1067.62V467.189Z\" fill=white /><path opacity=0.33 d=\"M1077.61 450.894H1074.42V459.972H1077.61V450.894Z\" fill=white /><path opacity=0.33 d=\"M778.639 423.938H775.211V438.108H778.639V423.938Z\" fill=white /><path opacity=0.33 d=\"M795.681 423.938H792.253V438.108H795.681V423.938Z\" fill=white /><path opacity=0.33 d=\"M812.709 423.938H809.281V438.108H812.709V423.938Z\" fill=white /><path opacity=0.33 d=\"M829.738 423.938H826.31V438.108H829.738V423.938Z\" fill=white /><path opacity=0.33 d=\"M778.639 453.09H775.211V467.26H778.639V453.09Z\" fill=white /><path opacity=0.33 d=\"M795.681 453.09H792.253V467.26H795.681V453.09Z\" fill=white /><path opacity=0.33 d=\"M812.709 453.09H809.281V467.26H812.709V453.09Z\" fill=white /><path opacity=0.33 d=\"M829.738 453.09H826.31V467.26H829.738V453.09Z\" fill=white /><path opacity=0.33 d=\"M875.114 499.503H871.686V513.673H875.114V499.503Z\" fill=white /><path opacity=0.33 d=\"M892.142 499.503H888.714V513.673H892.142V499.503Z\" fill=white /><path opacity=0.33 d=\"M909.17 499.503H905.742V513.673H909.17V499.503Z\" fill=white /><path opacity=0.33 d=\"M926.213 499.503H922.785V513.673H926.213V499.503Z\" fill=white /><path opacity=0.33 d=\"M778.639 482.969H775.211V497.139H778.639V482.969Z\" fill=white /><path opacity=0.33 d=\"M795.681 482.969H792.253V497.139H795.681V482.969Z\" fill=white /><path opacity=0.33 d=\"M812.709 482.969H809.281V497.139H812.709V482.969Z\" fill=white /><path opacity=0.33 d=\"M829.738 482.969H826.31V497.139H829.738V482.969Z\" fill=white /><path opacity=0.33 d=\"M778.639 512.849H775.211V527.019H778.639V512.849Z\" fill=white /><path opacity=0.33 d=\"M795.681 512.849H792.253V527.019H795.681V512.849Z\" fill=white /><path opacity=0.33 d=\"M812.709 512.849H809.281V527.019H812.709V512.849Z\" fill=white /><path opacity=0.33 d=\"M829.738 512.849H826.31V527.019H829.738V512.849Z\" fill=white /><path opacity=0.33 d=\"M778.639 539.985H775.211V554.156H778.639V539.985Z\" fill=white /><path opacity=0.33 d=\"M795.681 539.985H792.253V554.156H795.681V539.985Z\" fill=white /><path opacity=0.33 d=\"M812.709 539.985H809.281V554.156H812.709V539.985Z\" fill=white /><path opacity=0.33 d=\"M778.639 570.257H775.211V584.427H778.639V570.257Z\" fill=white /><path opacity=0.33 d=\"M795.681 570.257H792.253V584.427H795.681V570.257Z\" fill=white /><path opacity=0.33 d=\"M812.709 570.257H809.281V584.427H812.709V570.257Z\" fill=white /><path opacity=0.33 d=\"M829.738 539.985H826.31V554.156H829.738V539.985Z\" fill=white /><path opacity=0.33 d=\"M1165.94 498.817H1162.44V506.945H1165.94V498.817Z\" fill=white /><path opacity=0.33 d=\"M1165.94 511.953H1162.44V520.08H1165.94V511.953Z\" fill=white /><path opacity=0.33 d=\"M1174.92 498.817H1171.42V506.945H1174.92V498.817Z\" fill=white /><path opacity=0.33 d=\"M874.414 570.257H870.986V584.427H874.414V570.257Z\" fill=white /><path opacity=0.33 d=\"M891.456 570.257H888.028V584.427H891.456V570.257Z\" fill=white /><path opacity=0.33 d=\"M908.485 570.257H905.057V584.427H908.485V570.257Z\" fill=white /><path opacity=0.33 d=\"M925.513 570.257H922.085V584.427H925.513V570.257Z\" fill=white /><path opacity=0.33 d=\"M696.995 567.585H693.567V581.755H696.995V567.585Z\" fill=white /><path opacity=0.33 d=\"M714.037 567.585H710.609V581.755H714.037V567.585Z\" fill=white /><path opacity=0.33 d=\"M731.066 567.585H727.638V581.755H731.066V567.585Z\" fill=white /><path opacity=0.33 d=\"M748.094 567.585H744.666V581.755H748.094V567.585Z\" fill=white /><path opacity=0.33 d=\"M316.005 539.985H312.577V554.156H316.005V539.985Z\" fill=white /><path opacity=0.33 d=\"M333.047 539.985H329.619V554.156H333.047V539.985Z\" fill=white /><path opacity=0.33 d=\"M350.076 539.985H346.647V554.156H350.076V539.985Z\" fill=white /><path opacity=0.33 d=\"M367.104 539.985H363.676V554.156H367.104V539.985Z\" fill=white /><path opacity=0.33 d=\"M316.005 566.102H312.577V580.272H316.005V566.102Z\" fill=white /><path opacity=0.33 d=\"M333.047 566.102H329.619V580.272H333.047V566.102Z\" fill=white /><path opacity=0.33 d=\"M350.076 566.102H346.647V580.272H350.076V566.102Z\" fill=white /><path opacity=0.33 d=\"M367.104 566.102H363.676V580.272H367.104V566.102Z\" fill=white /><path opacity=0.33 d=\"M36.9066 567.277H33.4785V581.448H36.9066V567.277Z\" fill=white /><path opacity=0.33 d=\"M53.9349 567.277H50.5068V581.448H53.9349V567.277Z\" fill=white /><path opacity=0.33 d=\"M36.9066 589.169H33.4785V603.339H36.9066V589.169Z\" fill=white /><path opacity=0.33 d=\"M53.9349 589.169H50.5068V603.339H53.9349V589.169Z\" fill=white /><path opacity=0.33 d=\"M1029.67 516.22H1026.24V530.39H1029.67V516.22Z\" fill=white /><path opacity=0.33 d=\"M1046.71 516.22H1043.28V530.39H1046.71V516.22Z\" fill=white /><path opacity=0.33 d=\"M1063.74 516.22H1060.31V530.39H1063.74V516.22Z\" fill=white /><path opacity=0.33 d=\"M1080.78 516.22H1077.36V530.39H1080.78V516.22Z\" fill=white /><path opacity=0.33 d=\"M1029.67 543.413H1026.24V557.583H1029.67V543.413Z\" fill=white /><path opacity=0.33 d=\"M1046.71 543.413H1043.28V557.583H1046.71V543.413Z\" fill=white /><path opacity=0.33 d=\"M1063.74 543.413H1060.31V557.583H1063.74V543.413Z\" fill=white /><path opacity=0.33 d=\"M1080.78 543.413H1077.36V557.583H1080.78V543.413Z\" fill=white /><path opacity=0.33 d=\"M1029.67 572.816H1026.24V586.987H1029.67V572.816Z\" fill=white /><path opacity=0.33 d=\"M1046.71 572.816H1043.28V586.987H1046.71V572.816Z\" fill=white /><path opacity=0.33 d=\"M1063.74 572.816H1060.31V586.987H1063.74V572.816Z\" fill=white /><path opacity=0.33 d=\"M1080.78 572.816H1077.36V586.987H1080.78V572.816Z\" fill=white /><path opacity=0.33 d=\"M874.414 537.496H870.986V551.666H874.414V537.496Z\" fill=white /><path opacity=0.33 d=\"M891.456 537.496H888.028V551.666H891.456V537.496Z\" fill=white /><path opacity=0.33 d=\"M908.485 537.496H905.057V551.666H908.485V537.496Z\" fill=white /><path opacity=0.33 d=\"M925.513 537.496H922.085V551.666H925.513V537.496Z\" fill=white /><path opacity=0.33 d=\"M696.995 534.824H693.567V548.994H696.995V534.824Z\" fill=white /><path opacity=0.33 d=\"M714.037 534.824H710.609V548.994H714.037V534.824Z\" fill=white /><path opacity=0.33 d=\"M731.066 534.824H727.638V548.994H731.066V534.824Z\" fill=white /><path opacity=0.33 d=\"M748.094 534.824H744.666V548.994H748.094V534.824Z\" fill=white /></g><path opacity=0.25 d=\"M200 107H314C314 107 303.85 88.9041 274.579 91.4576C246.546 93.991 245.125 82.5303 230.875 81.1228C216.625 79.7154 204.75 90.5327 200 107Z\" fill=#EBEBEB /><path opacity=0.2 d=\"M30 51H144C144 51 133.843 32.9063 104.551 35.4796C76.4979 38.0127 75.0759 26.5533 60.8158 25.1259C46.5556 23.6985 34.7534 34.5347 30 51Z\" fill=#EBEBEB /><path opacity=0.5 d=\"M905 170H1113C1113 170 1094.68 136.373 1041.06 141.381C989.942 146.042 987.337 124.823 961.329 122.227C935.322 119.631 913.669 139.521 905 170Z\" fill=#FAFAFA /><path opacity=0.15 d=\"M1092 71H1273C1273 71 1257.01 42.3426 1210.42 46.5168C1165.91 50.5304 1163.64 32.469 1141.06 30.2013C1118.48 27.9336 1099.55 45.0317 1092 71Z\" fill=#EBEBEB /><g opacity=0.3><path d=\"M1223.22 573.016C1226.79 568.375 1227.9 559.464 1225.38 554.179C1223.98 556.198 1222.16 557.883 1220.04 559.115C1221.22 556.277 1222.08 553.317 1222.61 550.291L1218.02 546.746C1217.4 548.055 1216.93 550.76 1215.74 552.112C1216.97 550.121 1216.54 545.568 1215.07 544.253C1213.3 542.725 1211.23 541.587 1208.99 540.916C1206.19 539.96 1203.31 539.277 1200.39 538.876C1198.45 538.631 1196.27 538.625 1194.79 539.901C1192.69 541.717 1193.16 545.284 1194.95 547.406C1196.74 549.527 1199.41 550.634 1201.89 551.883C1211.04 556.518 1218.5 563.91 1223.22 573.016Z\" fill=#A9ACAB /><path d=\"M1232.95 563.554C1234.93 560.958 1237.89 559.322 1240.33 557.14C1242.78 554.959 1244.85 551.768 1244.06 548.6L1239.65 549.958C1244.43 547.438 1246.78 541.107 1244.81 536.078L1243.31 536.351C1245.15 535.342 1246.28 533.319 1246.64 531.246C1246.92 529.156 1246.79 527.032 1246.26 524.991C1245.52 521.55 1244.4 518.2 1242.94 515C1241.64 515.889 1239.98 515.987 1238.45 516.331C1236.92 516.674 1235.27 517.487 1234.85 519.003C1234.19 521.397 1237.04 523.606 1236.68 526.065C1235.38 524.338 1233.63 523.014 1231.61 522.248C1231.53 524.091 1229.32 525.449 1229.56 527.282C1229.7 527.901 1229.98 528.48 1230.38 528.972L1236.46 537.813C1232.72 536.372 1229.11 534.628 1225.66 532.599C1226.29 543.392 1228.06 553.895 1232.95 563.537\" fill=#A9ACAB /><path d=\"M1267.04 563.913C1267.04 563.913 1266.99 563.951 1266.89 564.011L1266.44 564.284C1266.04 564.524 1265.43 564.829 1264.69 565.309C1262.58 566.619 1260.56 568.077 1258.66 569.672C1258.04 570.158 1257.44 570.725 1256.79 571.308C1256.14 571.892 1255.51 572.497 1254.87 573.157C1253.48 574.546 1252.17 576.013 1250.95 577.553C1250.3 578.365 1249.71 579.243 1249.08 580.138C1248.78 580.585 1248.44 581.021 1248.15 581.49L1247.28 582.924C1246.66 583.873 1246.19 584.92 1245.64 585.94C1245.36 586.448 1245.14 586.998 1244.89 587.533C1244.63 588.067 1244.39 588.624 1244.16 589.169C1242.47 593.345 1241.26 597.699 1240.55 602.149C1239.97 605.783 1239.68 609.458 1239.69 613.138C1239.65 614.708 1239.75 616.126 1239.78 617.375C1239.82 618.624 1239.95 619.687 1240.02 620.571C1240.08 621.454 1240.18 622.103 1240.23 622.583C1240.23 622.801 1240.27 622.976 1240.28 623.129C1240.29 623.188 1240.29 623.249 1240.28 623.309C1240.27 623.249 1240.26 623.189 1240.25 623.129C1240.25 622.998 1240.2 622.823 1240.17 622.611C1240.11 622.131 1240.02 621.46 1239.9 620.598C1239.79 619.737 1239.72 618.651 1239.62 617.402C1239.52 616.153 1239.46 614.73 1239.48 613.154C1239.44 609.441 1239.7 605.731 1240.27 602.061C1240.97 597.588 1242.18 593.211 1243.89 589.016C1244.11 588.471 1244.38 587.925 1244.62 587.38C1244.86 586.835 1245.08 586.289 1245.37 585.782C1245.92 584.751 1246.43 583.704 1247.04 582.75L1247.93 581.31C1248.22 580.841 1248.56 580.399 1248.86 579.952C1249.49 579.063 1250.1 578.174 1250.75 577.362C1251.98 575.818 1253.3 574.348 1254.71 572.961C1255.36 572.295 1256.02 571.701 1256.65 571.112C1257.28 570.523 1257.91 569.988 1258.53 569.509C1260.46 567.928 1262.5 566.495 1264.64 565.222C1265.39 564.764 1266.01 564.464 1266.41 564.24L1266.88 563.995L1267.04 563.913Z\" fill=#263238 /><path d=\"M1229.37 621.864C1229.36 621.791 1229.36 621.718 1229.37 621.646C1229.37 621.487 1229.37 621.275 1229.37 621.007C1229.37 620.429 1229.32 619.6 1229.29 618.542C1229.25 617.484 1229.21 616.17 1229.2 614.649C1229.18 613.127 1229.14 611.376 1229.16 609.484C1229.16 605.666 1229.21 601.107 1229.37 596.052C1229.53 590.996 1229.84 585.444 1230.27 579.62C1230.7 573.795 1231.27 568.265 1231.85 563.259C1232.44 558.252 1233.07 553.726 1233.66 549.947C1233.94 548.054 1234.2 546.347 1234.48 544.847C1234.75 543.348 1234.95 542.061 1235.15 541.03C1235.34 539.999 1235.49 539.176 1235.6 538.608L1235.72 537.981C1235.73 537.909 1235.75 537.838 1235.77 537.769C1235.78 537.841 1235.78 537.914 1235.77 537.987C1235.77 538.139 1235.72 538.352 1235.67 538.619L1235.28 541.052C1235.1 542.104 1234.89 543.391 1234.66 544.896C1234.43 546.402 1234.14 548.103 1233.88 549.996C1233.34 553.78 1232.72 558.291 1232.14 563.313C1231.55 568.336 1231.05 573.866 1230.57 579.674C1230.1 585.482 1229.85 591.04 1229.66 596.095C1229.46 601.151 1229.39 605.694 1229.38 609.522C1229.38 611.431 1229.38 613.16 1229.38 614.681C1229.38 616.203 1229.38 617.506 1229.41 618.575C1229.44 619.644 1229.41 620.462 1229.44 621.04V621.678C1229.42 621.742 1229.4 621.805 1229.37 621.864Z\" fill=#263238 /><path d=\"M1213.46 552.478C1213.57 552.587 1213.66 552.703 1213.74 552.827C1213.93 553.088 1214.18 553.432 1214.5 553.863C1214.81 554.294 1215.22 554.866 1215.65 555.499C1216.08 556.131 1216.59 556.895 1217.1 557.746C1217.62 558.597 1218.19 559.518 1218.74 560.538C1219.28 561.558 1219.91 562.649 1220.53 563.81C1221.72 566.15 1222.94 568.768 1224.08 571.576C1225.21 574.385 1226.11 577.139 1226.85 579.658C1227.2 580.924 1227.55 582.124 1227.81 583.263C1228.07 584.403 1228.32 585.445 1228.52 586.432C1228.72 587.419 1228.87 588.292 1229.01 589.066C1229.15 589.84 1229.25 590.517 1229.32 591.067C1229.39 591.618 1229.45 592.016 1229.49 592.333C1229.52 592.478 1229.53 592.626 1229.53 592.774C1229.49 592.631 1229.46 592.485 1229.43 592.338C1229.38 592.027 1229.31 591.607 1229.21 591.084C1229.12 590.56 1229.01 589.868 1228.85 589.093C1228.7 588.319 1228.55 587.457 1228.31 586.476C1228.07 585.494 1227.86 584.447 1227.56 583.318C1227.26 582.189 1226.94 580.995 1226.59 579.735C1225.83 577.226 1224.91 574.494 1223.79 571.685C1222.68 568.877 1221.45 566.264 1220.28 563.93C1219.67 562.769 1219.1 561.661 1218.52 560.658C1217.94 559.655 1217.4 558.706 1216.88 557.86C1216.37 557.015 1215.89 556.257 1215.47 555.592C1215.05 554.926 1214.68 554.359 1214.38 553.901L1213.67 552.837C1213.59 552.722 1213.52 552.602 1213.46 552.478Z\" fill=#263238 /><g opacity=0.2><path d=\"M1243.36 590.74C1239.79 586.099 1238.69 577.188 1241.21 571.903C1242.6 573.921 1244.43 575.606 1246.55 576.839C1245.37 574 1244.51 571.041 1243.97 568.015L1248.57 564.47C1249.19 565.779 1249.66 568.484 1250.85 569.831C1249.62 567.846 1250.05 563.314 1251.51 561.972C1253.29 560.444 1255.36 559.308 1257.6 558.64C1260.39 557.682 1263.28 556.997 1266.2 556.595C1268.14 556.349 1270.32 556.344 1271.8 557.62C1273.9 559.436 1273.43 562.997 1271.64 565.124C1269.84 567.251 1267.17 568.353 1264.7 569.602C1255.55 574.238 1248.08 581.63 1243.36 590.735\" fill=black /></g><g opacity=0.3><path d=\"M1205.88 584.872C1203.98 585.662 1202.51 587.195 1200.8 588.34C1199.08 589.485 1196.8 590.222 1195 589.235L1196.54 586.769C1195.35 587.989 1193.76 588.748 1192.07 588.914C1190.37 589.079 1188.67 588.641 1187.27 587.675L1187.67 586.802C1187.19 587.261 1186.62 587.607 1185.99 587.816C1185.36 588.026 1184.69 588.093 1184.03 588.013C1182.72 587.846 1181.45 587.425 1180.29 586.775C1178.32 585.77 1176.46 584.554 1174.74 583.148C1175.49 582.499 1175.83 581.512 1176.28 580.634C1176.72 579.756 1178.92 578.529 1178.92 578.529L1182.47 581.136C1181.62 580.071 1181.1 578.789 1180.96 577.438C1182.1 577.689 1183.28 576.56 1184.35 577.002C1184.72 577.155 1186.03 577.046 1186.34 577.297C1187.5 578.173 1188.52 579.215 1189.37 580.389C1189.1 577.886 1188.89 577.907 1188.21 575.48C1194.68 577.596 1200.76 580.361 1205.86 584.883\" fill=black /></g><path d=\"M1191.09 583.318C1191.69 582.959 1192.34 582.678 1193.01 582.484C1194.86 581.939 1196.8 581.805 1198.7 582.091C1201.51 582.548 1204.19 583.607 1206.56 585.194C1212.33 589.078 1217.33 593.988 1221.32 599.679C1222.94 602.005 1224.32 604.483 1225.45 607.08C1226.2 608.833 1226.82 610.639 1227.31 612.484C1227.46 613.144 1227.57 613.657 1227.64 614L1227.73 614.399C1227.73 614.444 1227.73 614.49 1227.73 614.535C1227.7 614.494 1227.69 614.45 1227.68 614.404L1227.57 614.017C1227.48 613.651 1227.35 613.15 1227.19 612.517C1226.66 610.691 1226.01 608.901 1225.25 607.162C1224.1 604.59 1222.71 602.134 1221.09 599.826C1217.1 594.187 1212.12 589.311 1206.4 585.434C1204.07 583.854 1201.43 582.788 1198.65 582.309C1196.78 582.004 1194.86 582.106 1193.03 582.609C1192.53 582.751 1192.05 582.924 1191.57 583.127L1191.2 583.291C1191.17 583.305 1191.13 583.315 1191.09 583.318Z\" fill=#263238 /><path d=\"M1268.36 624.16C1264.9 613.422 1252.6 606.392 1241.6 608.862C1238.72 605.613 1235.09 603.119 1231.02 601.598C1226.96 600.078 1222.58 599.577 1218.27 600.139C1213.97 600.701 1209.87 602.31 1206.33 604.824C1202.79 607.338 1199.92 610.682 1197.97 614.561C1186.82 609.408 1172.84 611.049 1163.19 618.641L1156 623.173L1268.36 624.16Z\" fill=#9D9D9D /></g><g opacity=0.2><path opacity=0.4 d=\"M57.8256 593.442C61.855 588.207 63.1038 578.155 60.2556 572.194C58.6833 574.472 56.6267 576.373 54.2331 577.761C55.5634 574.56 56.5372 571.222 57.1367 567.808L51.9569 563.809C51.2618 565.286 50.7266 568.337 49.3855 569.863C50.7758 567.617 50.2898 562.481 48.635 560.998C46.6371 559.274 44.2977 557.991 41.7697 557.233C38.6177 556.155 35.3688 555.385 32.0685 554.933C29.8784 554.656 27.4239 554.65 25.7568 556.089C23.3884 558.138 23.9113 562.161 25.9352 564.554C27.9591 566.947 30.9673 568.196 33.7663 569.604C44.0861 574.832 52.5023 583.171 57.8256 593.442Z\" fill=black /><path opacity=0.4 d=\"M68.7939 582.769C71.0331 579.84 74.3673 577.995 77.1294 575.534C79.8915 573.074 82.223 569.475 81.331 565.901L76.3605 567.432C81.7494 564.59 84.4007 557.448 82.1738 551.776L80.4821 552.084C82.5614 550.946 83.8348 548.664 84.2469 546.326C84.5536 543.968 84.4053 541.572 83.8102 539.27C82.9737 535.389 81.7175 531.61 80.0638 528C78.5997 529.003 76.7296 529.113 75.001 529.501C73.2723 529.889 71.4145 530.805 70.947 532.515C70.2026 535.216 73.4077 537.707 73.0016 540.482C71.544 538.533 69.5618 537.04 67.2867 536.176C67.2006 538.255 64.703 539.787 64.9798 541.854C65.1322 542.552 65.4461 543.205 65.8964 543.761L72.7556 553.733C68.5419 552.108 64.4682 550.141 60.5752 547.852C61.2888 560.026 63.2819 571.874 68.7939 582.75\" fill=black /><path d=\"M107.248 583.174C107.248 583.174 107.193 583.217 107.082 583.285L106.572 583.592C106.123 583.863 105.44 584.207 104.603 584.749C102.221 586.226 99.9478 587.871 97.7993 589.67C97.1041 590.218 96.4274 590.857 95.6954 591.516C94.9633 592.174 94.2497 592.857 93.5238 593.601C91.9572 595.167 90.4825 596.823 89.1069 598.559C88.3749 599.476 87.7043 600.466 86.9969 601.475C86.6524 601.98 86.2771 602.472 85.9449 603.001L84.9607 604.619C84.2655 605.689 83.7303 606.87 83.1152 608.021C82.7953 608.593 82.5554 609.214 82.2662 609.817C81.9771 610.42 81.7003 611.047 81.448 611.662C79.5392 616.373 78.171 621.285 77.3695 626.303C76.7167 630.403 76.3916 634.548 76.3975 638.699C76.3606 640.471 76.4713 642.07 76.5082 643.479C76.5451 644.888 76.6989 646.087 76.7728 647.084C76.8466 648.08 76.9573 648.813 77.0127 649.354C77.0127 649.6 77.0557 649.797 77.068 649.969C77.0773 650.036 77.0773 650.105 77.068 650.172C77.0518 650.105 77.0395 650.037 77.0311 649.969C77.0311 649.821 76.9819 649.625 76.945 649.385C76.8712 648.843 76.7728 648.087 76.6436 647.115C76.5144 646.143 76.4405 644.918 76.3237 643.51C76.2068 642.101 76.1453 640.495 76.1637 638.718C76.118 634.529 76.4184 630.344 77.0619 626.205C77.8468 621.159 79.2134 616.221 81.1343 611.49C81.3865 610.875 81.688 610.26 81.9587 609.645C82.2293 609.029 82.4877 608.414 82.8137 607.842C83.4289 606.679 84.001 605.498 84.6961 604.422L85.6927 602.798C86.0249 602.269 86.4063 601.77 86.7508 601.266C87.4583 600.263 88.1411 599.261 88.8793 598.344C90.2662 596.602 91.7555 594.944 93.3393 593.38C94.0775 592.629 94.828 591.958 95.5355 591.294C96.2429 590.63 96.9565 590.027 97.6578 589.485C99.8272 587.703 102.128 586.086 104.542 584.65C105.397 584.133 106.086 583.795 106.547 583.543L107.07 583.266L107.248 583.174Z\" fill=#263238 /><path d=\"M64.7588 648.542C64.7506 648.46 64.7506 648.378 64.7588 648.296C64.7588 648.117 64.7588 647.878 64.7588 647.576C64.7588 646.924 64.7034 645.989 64.6665 644.796C64.6296 643.602 64.5865 642.12 64.5681 640.403C64.5496 638.687 64.5066 636.712 64.525 634.578C64.525 630.271 64.5865 625.129 64.7649 619.426C64.9433 613.723 65.2878 607.461 65.7738 600.891C66.2598 594.321 66.9057 588.083 67.564 582.436C68.2222 576.788 68.9358 571.683 69.6002 567.419C69.9139 565.285 70.2153 563.359 70.5229 561.668C70.8305 559.976 71.0581 558.524 71.2796 557.361C71.501 556.199 71.6671 555.27 71.784 554.63L71.9255 553.923C71.9362 553.841 71.9547 553.761 71.9809 553.683C71.9904 553.764 71.9904 553.847 71.9809 553.929C71.9809 554.101 71.9194 554.341 71.8701 554.642L71.4272 557.386C71.2242 558.573 70.9843 560.025 70.7259 561.723C70.4676 563.421 70.1477 565.34 69.8524 567.475C69.2372 571.744 68.5421 576.831 67.8839 582.497C67.2256 588.163 66.6535 594.401 66.1183 600.952C65.5831 607.504 65.3063 613.772 65.0848 619.475C64.8634 625.178 64.7895 630.302 64.7711 634.621C64.7711 636.774 64.7711 638.724 64.7711 640.44C64.7711 642.156 64.7711 643.627 64.808 644.832C64.8449 646.038 64.808 646.961 64.8388 647.613V648.333C64.8196 648.405 64.7928 648.475 64.7588 648.542Z\" fill=#263238 /><path d=\"M46.8203 570.274C46.9348 570.397 47.0397 570.529 47.134 570.668C47.3432 570.963 47.6262 571.351 47.983 571.837C48.3398 572.323 48.795 572.969 49.281 573.682C49.767 574.396 50.3452 575.257 50.9235 576.217C51.5017 577.177 52.1538 578.216 52.769 579.367C53.3842 580.517 54.0916 581.747 54.7867 583.058C56.134 585.697 57.512 588.65 58.7915 591.818C60.0711 594.986 61.08 598.092 61.9227 600.935C62.3165 602.362 62.704 603.715 62.9993 605.001C63.2946 606.286 63.5775 607.461 63.8052 608.575C64.0328 609.688 64.1988 610.673 64.3588 611.546C64.5187 612.42 64.6295 613.183 64.7094 613.804C64.7894 614.425 64.8509 614.874 64.894 615.231C64.9261 615.395 64.9406 615.562 64.9371 615.729C64.8925 615.568 64.8576 615.403 64.8325 615.237C64.771 614.887 64.691 614.413 64.5864 613.822C64.4818 613.232 64.3588 612.451 64.1804 611.577C64.002 610.703 63.8359 609.731 63.5652 608.624C63.2946 607.517 63.0608 606.336 62.7225 605.062C62.3841 603.789 62.0212 602.442 61.6213 601.021C60.7662 598.191 59.7266 595.109 58.4716 591.941C57.2167 588.773 55.8326 585.826 54.5038 583.193C53.8148 581.883 53.1812 580.634 52.5229 579.502C51.8647 578.37 51.2618 577.3 50.6774 576.346C50.093 575.393 49.5517 574.538 49.078 573.787C48.6043 573.037 48.186 572.397 47.8476 571.88L47.0479 570.68C46.9628 570.55 46.8868 570.415 46.8203 570.274Z\" fill=#263238 /><g opacity=0.2><path d=\"M80.5434 613.435C76.5202 608.2 75.2715 598.148 78.1136 592.187C79.6897 594.463 81.7481 596.364 84.1422 597.754C82.8127 594.552 81.837 591.214 81.2325 587.801L86.4184 583.802C87.1135 585.278 87.6487 588.33 88.9898 589.849C87.5995 587.61 88.0854 582.498 89.7403 580.984C91.7376 579.261 94.0774 577.98 96.6056 577.226C99.7573 576.146 103.006 575.373 106.307 574.919C108.497 574.642 110.951 574.636 112.618 576.075C114.987 578.124 114.464 582.141 112.44 584.54C110.416 586.939 107.402 588.182 104.609 589.591C94.2886 594.82 85.8708 603.158 80.5434 613.429\" fill=black /></g><g opacity=0.3><path d=\"M38.2636 606.815C36.1228 607.707 34.4619 609.436 32.5302 610.727C30.5986 612.019 28.0272 612.85 25.9971 611.736L27.7258 608.956C26.3824 610.331 24.5965 611.188 22.6832 611.374C20.7698 611.561 18.8519 611.066 17.2679 609.977L17.7292 608.993C17.1877 609.51 16.5383 609.9 15.8277 610.136C15.1172 610.372 14.3632 610.448 13.6199 610.358C12.1363 610.17 10.7032 609.695 9.39985 608.962C7.17258 607.829 5.07486 606.457 3.14355 604.871C3.98634 604.139 4.37391 603.025 4.8722 602.035C5.37049 601.045 7.84961 599.66 7.84961 599.66L11.8544 602.601C10.9036 601.4 10.3146 599.954 10.1565 598.43C11.436 598.713 12.771 597.44 13.9829 597.938C14.395 598.11 15.8714 597.987 16.2221 598.27C17.527 599.259 18.6795 600.434 19.6424 601.758C19.3348 598.935 19.1011 598.959 18.3383 596.222C25.628 598.609 32.4872 601.727 38.2452 606.827\" fill=black /></g><path d=\"M21.5801 605.063C22.2605 604.658 22.9904 604.341 23.7516 604.122C25.8302 603.507 28.0184 603.356 30.1617 603.679C33.3359 604.195 36.3615 605.389 39.0325 607.18C45.5369 611.56 51.1815 617.099 55.6851 623.519C57.5058 626.142 59.0636 628.938 60.3358 631.866C61.1852 633.844 61.8863 635.881 62.4335 637.963C62.6119 638.707 62.7289 639.285 62.815 639.673L62.9072 640.122C62.9153 640.173 62.9153 640.225 62.9072 640.276C62.8819 640.229 62.8633 640.18 62.8519 640.128L62.735 639.691C62.6304 639.279 62.4828 638.713 62.2982 638C61.706 635.94 60.9764 633.921 60.1144 631.959C58.8163 629.058 57.2446 626.287 55.4206 623.685C50.9175 617.323 45.3058 611.824 38.8541 607.45C36.2238 605.667 33.2437 604.466 30.1125 603.925C27.9986 603.581 25.8353 603.696 23.7701 604.264C23.2106 604.423 22.662 604.618 22.1276 604.848L21.7093 605.033C21.6679 605.049 21.6244 605.059 21.5801 605.063Z\" fill=#263238 /><path d=\"M108.744 651.132C104.843 639.019 90.9651 631.09 78.5572 633.877C75.309 630.212 71.2123 627.398 66.6254 625.683C62.0385 623.968 57.1011 623.402 52.2451 624.037C47.3892 624.671 42.7627 626.486 38.7703 629.322C34.7779 632.158 31.5412 635.929 29.3435 640.305C16.7633 634.492 0.996462 636.343 -9.89206 644.907L-18 650.019L108.744 651.132Z\" fill=#9D9D9D /></g><g opacity=0.25><path d=\"M106.908 627.481H2V651.139H106.908V627.481Z\" fill=#EBEBEB /><path d=\"M214.195 627.482H109.287V651.14H214.195V627.482Z\" fill=#F5F5F5 /><path d=\"M321.482 627.482H216.574V651.14H321.482V627.482Z\" fill=#EBEBEB /><path d=\"M428.767 627.482H323.859V651.14H428.767V627.482Z\" fill=#F5F5F5 /><path d=\"M536.055 627.482H431.147V651.14H536.055V627.482Z\" fill=#EBEBEB /><path d=\"M643.34 627.482H538.433V651.14H643.34V627.482Z\" fill=#F5F5F5 /><path d=\"M750.628 627.482H645.721V651.14H750.628V627.482Z\" fill=#EBEBEB /><path d=\"M857.916 627.482H753.008V651.14H857.916V627.482Z\" fill=#EBEBEB /><path d=\"M965.201 627.482H860.293V651.14H965.201V627.482Z\" fill=#F5F5F5 /><path d=\"M1072.49 627.482H967.582V651.14H1072.49V627.482Z\" fill=#EBEBEB /><path d=\"M1179.78 627.482H1074.87V651.14H1179.78V627.482Z\" fill=#F5F5F5 /><path d=\"M1287.08 627.482H1182.17V651.14H1287.08V627.482Z\" fill=#EBEBEB /><path d=\"M1330 627.482C1330 627.76 1032.68 627.964 666.029 627.964C299.374 627.964 2 627.76 2 627.482C2 627.204 299.239 627 666.029 627C1032.82 627 1330 627.222 1330 627.482Z\" fill=#263238 /><path d=\"M1330 651.14C1330 651.4 1032.68 651.622 666.029 651.622C299.374 651.622 2 651.4 2 651.14C2 650.881 299.239 650.658 666.029 650.658C1032.82 650.658 1330 650.881 1330 651.14Z\" fill=#263238 /><path d=\"M108.184 651.03C107.513 643.98 107.513 636.887 108.184 629.838C108.854 636.887 108.854 643.98 108.184 651.03Z\" fill=#263238 /><path d=\"M215.547 651.029C214.883 644.01 214.883 636.948 215.547 629.93C216.218 636.979 216.218 644.072 215.547 651.121V651.029Z\" fill=#263238 /><path d=\"M322.932 651.03C322.261 643.98 322.261 636.887 322.932 629.838C323.602 636.887 323.602 643.98 322.932 651.03Z\" fill=#263238 /><path d=\"M430.237 651.029C429.572 644.01 429.572 636.948 430.237 629.93C430.907 636.979 430.907 644.072 430.237 651.121V651.029Z\" fill=#263238 /><path d=\"M537.679 651.03C537.008 643.98 537.008 636.887 537.679 629.838C538.349 636.887 538.349 643.98 537.679 651.03Z\" fill=#263238 /><path d=\"M645.043 651.03C644.372 643.98 644.372 636.887 645.043 629.838C645.713 636.887 645.713 643.98 645.043 651.03Z\" fill=#263238 /><path d=\"M752.406 651.03C751.736 643.98 751.736 636.887 752.406 629.838C753.077 636.887 753.077 643.98 752.406 651.03Z\" fill=#263238 /><path d=\"M859.792 651.03C859.121 643.98 859.121 636.887 859.792 629.838C860.462 636.887 860.462 643.98 859.792 651.03Z\" fill=#263238 /><path d=\"M967.154 651.03C966.484 643.98 966.484 636.887 967.154 629.838C967.825 636.887 967.825 643.98 967.154 651.03Z\" fill=#263238 /><path d=\"M1074.52 651.03C1073.85 643.98 1073.85 636.887 1074.52 629.838C1075.19 636.887 1075.19 643.98 1074.52 651.03Z\" fill=#263238 /><path d=\"M1181.9 651.03C1181.23 643.98 1181.23 636.887 1181.9 629.838C1182.57 636.887 1182.57 643.98 1181.9 651.03Z\" fill=#263238 /></g><path d=\"M673.671 172.134L671.01 198.089L670.932 198.982C670.259 205.592 664.374 210.386 657.785 209.712C651.179 209.023 646.39 203.149 647.063 196.539L647.564 191.557L649.786 169.69C650.272 164.991 654.482 161.56 659.193 162.046L666.017 162.735C670.729 163.221 674.156 167.434 673.671 172.134Z\" fill=#FFBE9D /><path d=\"M682.607 200.257C682.607 200.257 682.607 200.257 682.591 200.273C682.122 200.085 681.668 199.897 681.214 199.709C679.445 208.904 670.211 215.921 659.082 215.921C646.796 215.921 636.825 207.4 636.653 196.811L647.5 192.018C655.921 194.493 663.903 194.806 671.369 192.378L682.607 200.257Z\" fill=#FFBE9D /><path opacity=0.5 d=\"M673.967 167.362L671.306 193.318C669.068 194.164 666.673 194.602 664.2 194.602C657.845 194.602 652.085 191.642 647.844 186.801L650.066 164.934C650.552 160.235 654.762 156.804 659.473 157.29L666.297 157.979C671.008 158.449 674.436 162.663 673.967 167.362Z\" fill=#F39371 /><path d=\"M689.915 165.685C688.303 170.823 684.281 172.202 680.524 172.985C680.477 172.985 680.43 173.001 680.384 173.016C678.411 176.384 675.751 179.627 672.761 182.274C669.599 185.469 665.655 187.709 661.32 188.43C661.194 188.446 661.054 188.477 660.928 188.493C660.678 188.524 660.427 188.587 660.177 188.602C660.005 188.618 659.833 188.602 659.661 188.618C659.504 188.618 659.379 188.618 659.222 188.618C658.878 188.618 658.549 188.618 658.221 188.587C657.892 188.555 657.563 188.508 657.235 188.461C657.094 188.43 656.953 188.414 656.812 188.383C656.64 188.352 656.468 188.336 656.295 188.289C656.045 188.226 655.81 188.132 655.575 188.054C655.45 188.023 655.325 187.976 655.2 187.944C651.021 186.582 647.483 183.746 644.838 180.112C642.287 177.026 640.158 173.408 638.734 169.79C638.609 169.743 638.484 169.696 638.358 169.649C634.852 168.317 631.221 166.296 630.439 161.096C629.797 156.851 631.362 151.431 634.868 151.4C635.901 151.384 637.059 151.87 638.171 152.637C640.237 145.776 644.478 138.633 649.409 133.887C651.506 131.49 653.807 130.002 656.264 129.203C657.595 128.671 658.925 128.358 660.24 128.342C661.147 128.326 662.024 128.373 662.9 128.452C663.777 128.499 664.653 128.608 665.546 128.749C666.829 128.968 668.097 129.485 669.333 130.206C671.634 131.381 673.685 133.213 675.391 135.892C679.523 141.359 682.606 149.066 683.608 156.162C684.813 155.566 686.018 155.269 687.051 155.441C690.479 156.005 691.183 161.597 689.915 165.685Z\" fill=#FFBE9D /><path d=\"M672.543 157.619C672.277 157.65 672.01 157.509 671.87 157.258C669.616 153.342 666.016 155.128 665.859 155.206C665.515 155.379 665.092 155.238 664.905 154.893C664.732 154.549 664.873 154.11 665.218 153.938C666.924 153.076 670.774 152.496 673.106 156.554C673.294 156.898 673.184 157.321 672.84 157.525C672.73 157.587 672.637 157.619 672.543 157.619Z\" fill=#0E1A2F /><path d=\"M659.379 175.256C659.536 175.037 659.818 174.928 660.099 174.99C664.498 175.993 665.64 172.139 665.687 171.967C665.797 171.591 666.188 171.372 666.564 171.481C666.939 171.591 667.158 171.983 667.049 172.359C666.532 174.207 664.325 177.418 659.786 176.384C659.411 176.29 659.16 175.914 659.254 175.538C659.27 175.429 659.317 175.335 659.379 175.256Z\" fill=#0E1A2F /><path d=\"M653.322 153.812C653.15 153.953 652.899 154 652.68 153.906C649.237 152.355 647.64 155.331 647.578 155.457C647.421 155.754 647.077 155.864 646.78 155.707C646.482 155.551 646.373 155.19 646.529 154.908C647.265 153.483 649.613 151.196 653.181 152.809C653.479 152.95 653.619 153.295 653.479 153.593C653.432 153.687 653.385 153.765 653.322 153.812Z\" fill=#0E1A2F /><path d=\"M659.176 171.575C658.237 172.28 657.267 172.609 656.421 172.546C655.921 172.499 655.482 172.342 655.091 172.029C654.653 171.7 654.355 171.246 654.199 170.682C653.886 169.664 654.011 168.317 654.621 166.813L656.922 159.012C657.016 158.714 657.314 158.542 657.627 158.636C657.924 158.73 658.096 159.043 658.002 159.341L655.701 167.189C655.06 168.802 655.075 169.93 655.388 170.588C655.482 170.823 655.623 170.995 655.78 171.12C656.39 171.59 657.345 171.449 658.3 170.792C658.347 170.76 658.378 170.745 658.425 170.713C658.675 170.525 659.051 170.557 659.254 170.792C659.27 170.807 659.286 170.839 659.301 170.87C659.427 171.105 659.395 171.387 659.176 171.575Z\" fill=#0E1A2F /><path d=\"M670.148 161.675C670.007 162.882 668.943 163.743 667.738 163.618C666.548 163.492 665.672 162.396 665.813 161.19C665.954 159.984 667.018 159.122 668.223 159.247C669.413 159.388 670.273 160.469 670.148 161.675Z\" fill=#0E1A2F /><path d=\"M652.477 160.923C652.336 162.13 651.271 162.991 650.066 162.866C648.877 162.725 648.016 161.644 648.141 160.438C648.282 159.232 649.346 158.37 650.551 158.496C651.757 158.621 652.617 159.717 652.477 160.923Z\" fill=#0E1A2F /><path d=\"M626.949 608.828C626.996 609.392 627.027 609.784 626.996 609.878L606.727 625.73C604.692 627.187 605.13 630.508 607.463 631.338C607.76 631.432 608.042 631.541 608.339 631.62C613.833 633.202 623.834 633.719 627.81 629.286C629.547 627.328 632.02 626.263 634.556 626.372L635.401 626.419C641.896 626.686 640.128 618.853 638.938 612.039C638.938 612.039 638.672 609.424 638.422 606.432C638.469 607.512 638.5 608.578 638.547 609.658L626.949 608.828Z\" fill=#414141 /><path d=\"M671.556 605.444C671.275 608.703 670.993 611.538 670.993 611.538C669.694 618.916 667.784 627.421 674.828 627.124L675.736 627.077C678.49 626.967 681.167 628.126 683.045 630.241C687.334 635.05 698.196 634.486 704.144 632.763C704.472 632.669 704.785 632.559 705.098 632.45C707.634 631.541 708.088 627.954 705.897 626.372L683.906 609.172C683.874 609.078 683.89 608.656 683.953 608.029L671.416 608.922C671.478 607.763 671.51 606.603 671.556 605.444Z\" fill=#414141 /><path d=\"M618.137 320.511C614.068 339.559 612.487 383.763 611.939 403.469C609.92 475.806 611.579 545.184 624.382 610.973L630.361 610.629L640.66 611.49C640.613 610.363 640.519 609.266 640.55 608.138C643.243 523.019 643.258 451.621 650.693 386.426C651.1 382.823 655.31 382.933 655.639 386.536C661.399 451.824 665.766 523.175 668.395 608.138C668.426 609.266 668.332 610.363 668.285 611.49L678.584 610.629L686.348 610.832C698.885 544.808 695.895 475.196 693.704 400.289C693.187 382.776 691.794 335.079 688.179 318.146L618.137 320.511Z\" fill=#0E1A2F /><path d=\"M726.306 285.737L726.103 285.533L725.884 285.22L726.103 284.828C726.244 285.11 726.306 285.455 726.306 285.737Z\" fill=#001E48 /><path d=\"M710.248 217.205L706.695 229.314L691.137 282.384C688.366 292.112 687.099 302.215 687.333 312.288H618.622C619.639 301.401 620.187 294.603 619.53 284.045C619.154 277.889 618.011 271.842 616.431 265.937C612.596 251.651 610.671 225.382 612.095 209.044C619.843 203.202 627.966 199.411 636.293 196.936C636.418 196.904 636.528 196.873 636.653 196.826C636.825 207.415 646.795 215.937 659.082 215.937C670.21 215.937 679.445 208.919 681.213 199.724C681.652 199.912 682.121 200.1 682.591 200.288C692.264 204.329 703.361 210.141 708.682 215.435C709.261 215.999 709.794 216.594 710.248 217.205Z\" fill=white /><path d=\"M613.582 252.951L607.494 278.656L603.017 315.64C602.329 321.31 597.101 325.179 591.638 324.051C586.896 323.064 583.625 318.6 584.016 313.65C585.456 295.605 588.367 255.959 588.852 253.217C590.355 245.025 592.108 237.193 593.924 229.972C597.899 214.104 609.873 207.525 612.487 205.849L611 206.788L613.582 252.951Z\" fill=#56C2D5 /><path d=\"M724.679 319.226C719.936 321.137 714.646 318.318 713.441 313.227L705.865 281.303L699.589 254.784C698.712 234.185 699.495 218.552 702.14 208.637L702.171 208.292C704.785 209.968 715.256 215.967 719.216 231.82C721.955 242.753 724.553 255.05 726.306 267.769C726.807 271.215 728.952 297.735 729.985 310.47C730.282 314.276 728.138 317.832 724.679 319.226Z\" fill=#56C2D4 /><path d=\"M708.667 213.133L706.695 227.043L700.027 274.004C697.586 282.729 696.193 291.752 695.88 300.837L694.111 354.174C694.048 356.226 691.685 357.229 690.229 355.866L679.195 345.496C669.334 336.254 663.433 323.503 662.573 309.985C662.4 307.682 662.4 305.333 662.557 302.983C662.557 302.983 662.573 302.967 662.588 302.921C670.555 285.674 674.421 266.814 673.936 247.829L672.449 191.297C683.014 194.931 701.702 206.162 708.667 213.133Z\" fill=#2DC0DA /><path d=\"M608.824 208.276L609.137 222.327L610.17 269.774C611.563 278.734 611.876 287.867 611.109 296.921L606.539 350.085C606.367 352.137 608.574 353.422 610.201 352.247L622.378 343.35C624.491 341.799 626.761 339.324 629.062 336.332C641.442 320.151 646.138 299.427 642.788 279.33C640.425 265.153 639.908 250.899 641.27 236.018L645.762 191.845C641.693 190.701 616.572 202.246 608.824 208.276Z\" fill=#2DC0DA /><path d=\"M647.86 186.111C647.86 186.111 632.678 188.383 636.105 201.995C637.076 205.864 637.655 209.811 638.203 213.759L641.208 235.266C644.432 221.779 648.267 197.813 647.86 186.111Z\" fill=#56C2D4 /><path d=\"M671.807 187.475C671.807 187.475 686.99 189.746 683.562 203.358C682.592 207.227 673.858 237.804 673.858 237.804C670.634 224.333 671.401 199.191 671.807 187.475Z\" fill=#56C2D4 /><path d=\"M686.003 145.917C685.565 144.179 685.096 143.051 683.703 141.86C681.903 140.325 680.713 140.591 678.772 140.122C680.103 136.127 680.087 133.245 676.988 130.096C672.246 125.287 664.216 121.794 657.439 123.392C652.884 124.473 649.926 127.825 647.093 131.287C645.716 132.979 642.585 142.691 639.439 136.801C638.281 138.555 638.391 141.704 639.095 143.63C637.013 144.335 635.464 142.174 633.805 141.359C633.852 143.583 634.368 146.403 635.683 148.518C635.965 148.972 635.354 150.209 635.339 150.758C635.229 157.399 640.065 163.273 639.455 169.852C639.831 165.686 640.582 161.676 641.224 157.509C641.505 155.661 641.818 153.937 642.476 152.12C642.585 151.823 642.758 151.478 642.961 151.118C644.98 150.554 646.968 149.489 648.877 148.941C652.149 148.016 655.827 147.954 659.208 147.907C663.011 147.86 672.23 148.831 674.108 144.147C674.155 146.685 673.341 149.16 673.826 151.776C674.265 154.157 675.501 156.679 676.581 158.825C677.536 160.751 678.944 169.132 679.524 171.293C680.51 165.341 684.25 159.968 686.035 154.188C686.833 151.572 686.676 148.612 686.003 145.917Z\" fill=#0E1A2F /><path d=\"M693.344 258.01C693.328 258.01 693.312 258.01 693.281 258.01L681.417 257.838C679.492 257.807 677.911 256.287 677.817 254.361L677.128 240.341C677.034 238.587 678.208 237.02 679.914 236.613C682.747 235.924 691.387 233.856 700.074 238.352C701.576 239.135 702.328 240.889 701.874 242.534C700.935 245.949 698.963 252.293 696.427 256.35C695.77 257.384 694.596 258.01 693.344 258.01ZM688.147 236.3C684.469 236.3 681.526 237.005 680.102 237.349C678.772 237.678 677.848 238.9 677.927 240.278L678.615 254.298C678.693 255.802 679.93 257.008 681.448 257.039L693.312 257.212C693.328 257.212 693.344 257.212 693.359 257.212C694.345 257.212 695.269 256.71 695.77 255.911C698.258 251.948 700.199 245.683 701.123 242.315C701.483 241.015 700.888 239.636 699.73 239.025C695.644 236.926 691.575 236.3 688.147 236.3Z\" fill=#F7F9FE /><path d=\"M617.934 256.35C615.398 252.293 613.426 245.965 612.487 242.534C612.033 240.89 612.784 239.119 614.287 238.352C622.974 233.841 631.598 235.924 634.446 236.613C636.137 237.02 637.311 238.587 637.232 240.341L636.544 254.361C636.45 256.288 634.869 257.807 632.944 257.838L621.08 258.011C621.064 258.011 621.048 258.011 621.017 258.011C619.765 258.011 618.591 257.384 617.934 256.35ZM614.647 239.041C613.473 239.652 612.894 241.031 613.254 242.331C614.193 245.714 616.134 251.964 618.607 255.927C619.108 256.726 620.031 257.227 621.017 257.227C621.033 257.227 621.048 257.227 621.064 257.227L632.928 257.055C634.446 257.039 635.683 255.833 635.761 254.314L636.45 240.294C636.512 238.916 635.605 237.678 634.274 237.365C632.85 237.02 629.907 236.316 626.229 236.316C622.786 236.3 618.716 236.927 614.647 239.041Z\" fill=#F7F9FE /><path d=\"M620.963 616.157C622.956 615.923 627.161 616.531 628.037 620.843\" stroke=white /><path d=\"M619.851 618.928C621.282 618.756 624.304 619.186 624.94 622.282\" stroke=white /><path d=\"M684.001 622.965C684.382 620.994 686.237 617.172 690.611 617.645\" stroke=white /><path d=\"M687 624.287C687.27 622.871 688.597 620.122 691.74 620.455\" stroke=white /><g filter=url(#filter0_d)><rect x=428 y=318 width=419 height=153 rx=6 fill=white /><text x=50% y=55% dominant-baseline=middle text-anchor=middle font-size=48px fill=black font-weight=bold>{{userCity}}</text><text x=50% y=62% dominant-baseline=bottom text-anchor=middle font-size=30px fill=black>What a beautiful city!</text></g><!-- <path d=\"M548.56 394V360.4H554.896V388.144H571.744V394H548.56ZM598.801 394H592.657C591.889 393.04 591.505 391.776 591.505 390.208C589.841 393.184 587.185 394.672 583.537 394.672C581.169 394.672 579.233 394 577.729 392.656C576.257 391.28 575.521 389.472 575.521 387.232C575.521 384.96 576.305 383.184 577.873 381.904C579.473 380.592 581.521 379.744 584.017 379.36L591.169 378.256V377.344C591.169 374.944 589.713 373.744 586.801 373.744C585.457 373.744 584.401 374 583.633 374.512C582.897 375.024 582.529 375.664 582.529 376.432C582.529 376.624 582.561 376.816 582.625 377.008L577.201 378.832C576.913 378.192 576.769 377.52 576.769 376.816C576.769 374.864 577.681 373.168 579.505 371.728C581.329 370.256 583.761 369.52 586.801 369.52C590.193 369.52 592.769 370.24 594.529 371.68C596.321 373.12 597.217 375.28 597.217 378.16V388.096C597.217 390.496 597.745 392.464 598.801 394ZM584.977 389.776C586.801 389.776 588.289 389.184 589.441 388C590.593 386.784 591.169 385.072 591.169 382.864V382.432L585.409 383.392C582.753 383.84 581.425 385.008 581.425 386.896C581.425 387.824 581.745 388.544 582.385 389.056C583.025 389.536 583.889 389.776 584.977 389.776ZM625.524 377.92V394H619.476V380.272C619.476 378.672 619.06 377.424 618.228 376.528C617.428 375.632 616.244 375.184 614.676 375.184C612.98 375.184 611.572 375.808 610.452 377.056C609.364 378.304 608.82 379.92 608.82 381.904V394H602.772V360.4H608.82V373.936C610.708 370.992 613.46 369.52 617.076 369.52C619.668 369.52 621.716 370.288 623.22 371.824C624.756 373.328 625.524 375.36 625.524 377.92ZM651.769 372.88C654.361 375.088 655.657 378.16 655.657 382.096C655.657 386.032 654.361 389.12 651.769 391.36C649.209 393.568 646.169 394.672 642.649 394.672C639.129 394.672 636.073 393.568 633.481 391.36C630.921 389.12 629.641 386.032 629.641 382.096C629.641 378.16 630.921 375.088 633.481 372.88C636.073 370.64 639.129 369.52 642.649 369.52C646.169 369.52 649.209 370.64 651.769 372.88ZM637.801 387.136C639.177 388.384 640.793 389.008 642.649 389.008C644.505 389.008 646.105 388.384 647.449 387.136C648.825 385.856 649.513 384.176 649.513 382.096C649.513 380.016 648.825 378.352 647.449 377.104C646.105 375.824 644.505 375.184 642.649 375.184C640.793 375.184 639.177 375.824 637.801 377.104C636.457 378.352 635.785 380.016 635.785 382.096C635.785 384.176 636.457 385.856 637.801 387.136ZM674.872 369.808L673.912 375.52C673.304 375.296 672.648 375.184 671.944 375.184C670.184 375.184 668.776 375.856 667.72 377.2C666.696 378.512 666.184 380.192 666.184 382.24V394H660.136V370.192H666.184V373.984C667.656 371.008 669.864 369.52 672.808 369.52C673.544 369.52 674.232 369.616 674.872 369.808ZM700.039 383.536H681.703C681.895 385.36 682.583 386.816 683.767 387.904C684.951 388.96 686.439 389.488 688.231 389.488C691.175 389.488 693.367 388.032 694.807 385.12L699.319 387.712C697.079 392.352 693.351 394.672 688.135 394.672C684.743 394.672 681.847 393.504 679.447 391.168C677.079 388.8 675.895 385.776 675.895 382.096C675.895 378.384 677.095 375.36 679.495 373.024C681.927 370.688 684.903 369.52 688.423 369.52C691.815 369.52 694.599 370.64 696.775 372.88C698.951 375.088 700.039 377.936 700.039 381.424V383.536ZM688.231 374.128C686.663 374.128 685.287 374.608 684.103 375.568C682.951 376.496 682.151 377.68 681.703 379.12H694.471C694.183 377.552 693.495 376.336 692.407 375.472C691.319 374.576 689.927 374.128 688.231 374.128ZM705.089 372.064V360.4H711.425V372.064L710.657 384.016H705.857L705.089 372.064ZM705.089 394V387.376H711.425V394H705.089Z\" fill=\"black\"/>\n            <path d=\"M500.108 436L494.198 415H496.688L500.948 430.81C501.168 431.77 501.338 432.5 501.458 433L501.968 430.78L506.078 415H508.778L512.888 430.78C513.128 431.76 513.298 432.5 513.398 433L513.908 430.81L518.168 415H520.658L514.748 436H512.138L507.428 418.12L502.718 436H500.108ZM535.826 425.95V436H533.486V426.37C533.486 425.23 533.146 424.35 532.466 423.73C531.806 423.11 530.936 422.8 529.856 422.8C528.656 422.8 527.616 423.26 526.736 424.18C525.856 425.08 525.416 426.27 525.416 427.75V436H523.076V415H525.416V423.73C525.896 422.81 526.596 422.08 527.516 421.54C528.436 420.98 529.426 420.7 530.486 420.7C531.986 420.7 533.246 421.15 534.266 422.05C535.306 422.93 535.826 424.23 535.826 425.95ZM552.668 436H550.328C549.728 435.28 549.428 434.3 549.428 433.06C548.968 434.14 548.288 434.97 547.388 435.55C546.508 436.13 545.498 436.42 544.358 436.42C542.858 436.42 541.648 436 540.728 435.16C539.808 434.3 539.348 433.21 539.348 431.89C539.348 430.53 539.818 429.44 540.758 428.62C541.718 427.8 542.958 427.27 544.478 427.03L549.428 426.22V425.56C549.428 423.64 548.258 422.68 545.918 422.68C544.798 422.68 543.928 422.9 543.308 423.34C542.708 423.78 542.408 424.33 542.408 424.99C542.408 425.13 542.428 425.28 542.468 425.44L540.428 426.13C540.268 425.75 540.188 425.35 540.188 424.93C540.188 423.77 540.708 422.78 541.748 421.96C542.808 421.12 544.198 420.7 545.918 420.7C547.838 420.7 549.288 421.13 550.268 421.99C551.268 422.83 551.768 424.02 551.768 425.56V432.28C551.768 433.14 551.828 433.83 551.948 434.35C552.068 434.85 552.308 435.4 552.668 436ZM544.628 434.32C546.128 434.32 547.298 433.76 548.138 432.64C548.998 431.5 549.428 430.13 549.428 428.53V428.08L544.898 428.86C543.878 429.04 543.098 429.38 542.558 429.88C542.018 430.38 541.748 431.01 541.748 431.77C541.748 432.55 542.008 433.17 542.528 433.63C543.048 434.09 543.748 434.32 544.628 434.32ZM554.273 422.98V421.12H556.763V417.1H559.103V421.12H562.523V422.98H559.103V431.98C559.103 432.84 559.233 433.46 559.493 433.84C559.773 434.2 560.323 434.38 561.143 434.38C561.483 434.38 561.853 434.32 562.253 434.2L562.463 436.15C561.943 436.33 561.283 436.42 560.483 436.42C559.403 436.42 558.513 436.11 557.813 435.49C557.113 434.85 556.763 433.83 556.763 432.43V422.98H554.273ZM586.77 436H584.43C583.83 435.28 583.53 434.3 583.53 433.06C583.07 434.14 582.39 434.97 581.49 435.55C580.61 436.13 579.6 436.42 578.46 436.42C576.96 436.42 575.75 436 574.83 435.16C573.91 434.3 573.45 433.21 573.45 431.89C573.45 430.53 573.92 429.44 574.86 428.62C575.82 427.8 577.06 427.27 578.58 427.03L583.53 426.22V425.56C583.53 423.64 582.36 422.68 580.02 422.68C578.9 422.68 578.03 422.9 577.41 423.34C576.81 423.78 576.51 424.33 576.51 424.99C576.51 425.13 576.53 425.28 576.57 425.44L574.53 426.13C574.37 425.75 574.29 425.35 574.29 424.93C574.29 423.77 574.81 422.78 575.85 421.96C576.91 421.12 578.3 420.7 580.02 420.7C581.94 420.7 583.39 421.13 584.37 421.99C585.37 422.83 585.87 424.02 585.87 425.56V432.28C585.87 433.14 585.93 433.83 586.05 434.35C586.17 434.85 586.41 435.4 586.77 436ZM578.73 434.32C580.23 434.32 581.4 433.76 582.24 432.64C583.1 431.5 583.53 430.13 583.53 428.53V428.08L579 428.86C577.98 429.04 577.2 429.38 576.66 429.88C576.12 430.38 575.85 431.01 575.85 431.77C575.85 432.55 576.11 433.17 576.63 433.63C577.15 434.09 577.85 434.32 578.73 434.32ZM598.75 436V415H601.09V423.82C601.65 422.86 602.41 422.1 603.37 421.54C604.35 420.98 605.41 420.7 606.55 420.7C608.51 420.7 610.14 421.44 611.44 422.92C612.76 424.4 613.42 426.28 613.42 428.56C613.42 430.84 612.74 432.72 611.38 434.2C610.04 435.68 608.34 436.42 606.28 436.42C605.14 436.42 604.1 436.13 603.16 435.55C602.24 434.97 601.55 434.23 601.09 433.33V436H598.75ZM602.35 432.7C603.31 433.74 604.51 434.26 605.95 434.26C607.39 434.26 608.59 433.74 609.55 432.7C610.53 431.64 611.02 430.26 611.02 428.56C611.02 426.86 610.53 425.49 609.55 424.45C608.59 423.39 607.39 422.86 605.95 422.86C604.51 422.86 603.31 423.39 602.35 424.45C601.39 425.49 600.91 426.86 600.91 428.56C600.91 430.26 601.39 431.64 602.35 432.7ZM630.592 428.95H618.292C618.372 430.55 618.872 431.87 619.792 432.91C620.712 433.93 621.922 434.44 623.422 434.44C624.682 434.44 625.692 434.15 626.452 433.57C627.232 432.97 627.892 432.13 628.432 431.05L630.142 432.07C628.682 434.97 626.412 436.42 623.332 436.42C621.272 436.42 619.522 435.68 618.082 434.2C616.662 432.7 615.952 430.82 615.952 428.56C615.952 426.3 616.672 424.43 618.112 422.95C619.552 421.45 621.322 420.7 623.422 420.7C625.622 420.7 627.362 421.39 628.642 422.77C629.942 424.15 630.592 425.94 630.592 428.14V428.95ZM623.422 422.68C622.122 422.68 621.042 423.08 620.182 423.88C619.322 424.66 618.752 425.71 618.472 427.03H628.252C628.172 425.69 627.652 424.63 626.692 423.85C625.732 423.07 624.642 422.68 623.422 422.68ZM646.74 436H644.4C643.8 435.28 643.5 434.3 643.5 433.06C643.04 434.14 642.36 434.97 641.46 435.55C640.58 436.13 639.57 436.42 638.43 436.42C636.93 436.42 635.72 436 634.8 435.16C633.88 434.3 633.42 433.21 633.42 431.89C633.42 430.53 633.89 429.44 634.83 428.62C635.79 427.8 637.03 427.27 638.55 427.03L643.5 426.22V425.56C643.5 423.64 642.33 422.68 639.99 422.68C638.87 422.68 638 422.9 637.38 423.34C636.78 423.78 636.48 424.33 636.48 424.99C636.48 425.13 636.5 425.28 636.54 425.44L634.5 426.13C634.34 425.75 634.26 425.35 634.26 424.93C634.26 423.77 634.78 422.78 635.82 421.96C636.88 421.12 638.27 420.7 639.99 420.7C641.91 420.7 643.36 421.13 644.34 421.99C645.34 422.83 645.84 424.02 645.84 425.56V432.28C645.84 433.14 645.9 433.83 646.02 434.35C646.14 434.85 646.38 435.4 646.74 436ZM638.7 434.32C640.2 434.32 641.37 433.76 642.21 432.64C643.07 431.5 643.5 430.13 643.5 428.53V428.08L638.97 428.86C637.95 429.04 637.17 429.38 636.63 429.88C636.09 430.38 635.82 431.01 635.82 431.77C635.82 432.55 636.08 433.17 636.6 433.63C637.12 434.09 637.82 434.32 638.7 434.32ZM650.107 430.93V421.12H652.447V430.81C652.447 431.95 652.767 432.82 653.407 433.42C654.047 434.02 654.897 434.32 655.957 434.32C657.177 434.32 658.207 433.87 659.047 432.97C659.907 432.07 660.337 430.9 660.337 429.46V421.12H662.677V436H660.337V433.39C659.277 435.41 657.627 436.42 655.387 436.42C653.887 436.42 652.627 435.97 651.607 435.07C650.607 434.17 650.107 432.79 650.107 430.93ZM665.748 422.98V421.12H668.238V417.1H670.578V421.12H673.998V422.98H670.578V431.98C670.578 432.84 670.708 433.46 670.968 433.84C671.248 434.2 671.798 434.38 672.618 434.38C672.958 434.38 673.328 434.32 673.728 434.2L673.938 436.15C673.418 436.33 672.758 436.42 671.958 436.42C670.878 436.42 669.988 436.11 669.288 435.49C668.588 434.85 668.238 433.83 668.238 432.43V422.98H665.748ZM677.353 436V421.12H679.693V436H677.353ZM677.113 418.54V415.6H679.933V418.54H677.113ZM682.677 422.98V421.12H685.017V418.15C685.017 416.73 685.417 415.6 686.217 414.76C687.017 413.92 688.147 413.5 689.607 413.5C690.167 413.5 690.647 413.57 691.047 413.71L690.687 415.69C690.387 415.59 690.057 415.54 689.697 415.54C688.137 415.54 687.357 416.42 687.357 418.18V421.12H690.777V422.98H687.357V436H685.017V422.98H682.677ZM693.554 430.93V421.12H695.894V430.81C695.894 431.95 696.214 432.82 696.854 433.42C697.494 434.02 698.344 434.32 699.404 434.32C700.624 434.32 701.654 433.87 702.494 432.97C703.354 432.07 703.784 430.9 703.784 429.46V421.12H706.124V436H703.784V433.39C702.724 435.41 701.074 436.42 698.834 436.42C697.334 436.42 696.074 435.97 695.054 435.07C694.054 434.17 693.554 432.79 693.554 430.93ZM710.693 436V415H713.033V436H710.693ZM737.508 431.05L739.188 432.13C737.748 434.99 735.518 436.42 732.498 436.42C730.338 436.42 728.528 435.68 727.068 434.2C725.608 432.72 724.878 430.84 724.878 428.56C724.878 426.3 725.618 424.43 727.098 422.95C728.598 421.45 730.398 420.7 732.498 420.7C734.078 420.7 735.438 421.06 736.578 421.78C737.718 422.5 738.558 423.5 739.098 424.78L737.328 425.95C736.348 423.85 734.748 422.8 732.528 422.8C731.008 422.8 729.738 423.33 728.718 424.39C727.718 425.43 727.218 426.82 727.218 428.56C727.218 430.3 727.708 431.7 728.688 432.76C729.688 433.8 730.968 434.32 732.528 434.32C733.708 434.32 734.688 434.05 735.468 433.51C736.248 432.95 736.928 432.13 737.508 431.05ZM742.597 436V421.12H744.937V436H742.597ZM742.357 418.54V415.6H745.177V418.54H742.357ZM748.101 422.98V421.12H750.591V417.1H752.931V421.12H756.351V422.98H752.931V431.98C752.931 432.84 753.061 433.46 753.321 433.84C753.601 434.2 754.151 434.38 754.971 434.38C755.311 434.38 755.681 434.32 756.081 434.2L756.291 436.15C755.771 436.33 755.111 436.42 754.311 436.42C753.231 436.42 752.341 436.11 751.641 435.49C750.941 434.85 750.591 433.83 750.591 432.43V422.98H748.101ZM759.81 442.03L760.17 439.93C760.57 440.13 760.97 440.23 761.37 440.23C761.83 440.23 762.19 440.12 762.45 439.9C762.71 439.68 762.95 439.3 763.17 438.76L764.28 435.94L758.28 421.12H760.86L765.57 432.79L770.22 421.12H772.74L765.27 439.51C764.85 440.55 764.33 441.28 763.71 441.7C763.11 442.12 762.33 442.33 761.37 442.33C760.81 442.33 760.29 442.23 759.81 442.03ZM775.685 421.69V415H778.205V421.69L777.875 430.36H776.015L775.685 421.69ZM775.565 436V433H778.325V436H775.565Z\" fill=\"black\"/> --><path d=\"M605.199 312.152L610.677 324.573C611.24 325.842 610.927 327.44 609.754 328.207C608.439 329.069 606.232 328.756 602.914 323.132L600.816 320.767L601.223 324.479C601.521 327.189 598.093 328.662 596.387 326.547C595.776 325.795 595.15 324.761 594.524 323.383C593.961 325.466 591.66 326.578 589.688 325.701C587.262 324.62 584.366 321.863 583.005 314.987C582.864 311.133 585.963 307.954 589.813 308.001L599.11 308.126C601.755 308.173 604.135 309.739 605.199 312.152Z\" fill=#E78C6B /><path d=\"M707.75 307.152L702.272 319.573C701.709 320.842 702.022 322.44 703.196 323.207C704.51 324.069 706.717 323.756 710.035 318.132L712.133 315.767L711.726 319.479C711.428 322.189 714.856 323.662 716.562 321.547C717.173 320.795 717.799 319.761 718.425 318.383C718.988 320.466 721.289 321.578 723.261 320.701C725.687 319.62 728.583 316.863 729.945 309.987C730.085 306.133 726.986 302.954 723.136 303.001L713.839 303.126C711.194 303.173 708.815 304.739 707.75 307.152Z\" fill=#E78C6B /></g><defs><filter id=filter0_d x=426 y=318 width=427 height=161 filterUnits=userSpaceOnUse color-interpolation-filters=sRGB><feFlood flood-opacity=0 result=BackgroundImageFix /><feColorMatrix in=SourceAlpha type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=hardAlpha /><feOffset dx=2 dy=4 /><feGaussianBlur stdDeviation=2 /><feComposite in2=hardAlpha operator=out /><feColorMatrix type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\"/><feBlend mode=normal in2=BackgroundImageFix result=effect1_dropShadow /><feBlend mode=normal in=SourceGraphic in2=effect1_dropShadow result=shape /></filter><clipPath id=clip0><rect width=1275 height=703 fill=white /></clipPath><clipPath id=clip1><rect width=1281 height=414 fill=white transform=\"translate(-5 212)\"/></clipPath></defs></svg> <svg class=welcome-mobile-image width=100% height=100% viewBox=\"0 0 360 640\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_3325:20386)><rect width=360 height=640 fill=white /><g opacity=0.2 clip-path=url(#clip1_3325:20386)><path d=\"M60.7272 198.244H-16.1436V503.588H60.7272V198.244Z\" fill=#B5C3C2 /><path d=\"M48.1685 176.351H-3.58594V304.679H48.1685V176.351Z\" fill=#B5C3C2 /><path d=\"M36.639 162.469H7.92676V233.64H36.639V162.469Z\" fill=#B5C3C2 /><path d=\"M32.0714 199.041H12.4922V150.524H19.5514H26.5534H32.0714V199.041Z\" fill=#B5C3C2 /><path d=\"M20.998 177.926H18.8672V129.409H19.6472H20.3893H20.998V177.926Z\" fill=#B5C3C2 /><path d=\"M25.6985 161.14H23.5674V112.642H24.3285H25.0896H25.6985V161.14Z\" fill=#B5C3C2 /><path d=\"M62.7635 197.466H-18.1982V200.713H62.7635V197.466Z\" fill=#B5C3C2 /><path d=\"M50.0338 174.793H-5.48828V177.926H50.0338V174.793Z\" fill=#B5C3C2 /><path d=\"M37.8372 161.14H5.83301V163.532H37.8372V161.14Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M3.56924 181.553H1.17188V194.997H3.56924V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M10.2287 181.553H7.83105V194.997H10.2287V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M16.8692 181.553H14.4717V194.997H16.8692V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M23.5284 181.553H21.1309V194.997H23.5284V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M30.1884 181.553H27.791V194.997H30.1884V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M36.8477 181.553H34.4502V194.997H36.8477V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M43.5071 181.553H41.1094V194.997H43.5071V181.553Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M7.92596 210.417H2.10352V226.368H7.92596V210.417Z\" fill=#B5C3C2 /><path d=\"M19.4376 210.417H13.6152V226.368H19.4376V210.417Z\" fill=#B5C3C2 /><path d=\"M30.9493 210.417H25.127V226.368H30.9493V210.417Z\" fill=#B5C3C2 /><path d=\"M42.4611 210.417H36.6387V226.368H42.4611V210.417Z\" fill=#B5C3C2 /><path d=\"M53.9726 210.417H48.1504V226.368H53.9726V210.417Z\" fill=#B5C3C2 /><path d=\"M7.92596 235.292H2.10352V251.243H7.92596V235.292Z\" fill=#B5C3C2 /><path d=\"M19.4376 235.292H13.6152V251.243H19.4376V235.292Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M30.9493 235.292H25.127V251.243H30.9493V235.292Z\" fill=#B5C3C2 /><path d=\"M42.4611 235.292H36.6387V251.243H42.4611V235.292Z\" fill=#B5C3C2 /><path d=\"M53.9726 235.292H48.1504V251.243H53.9726V235.292Z\" fill=#B5C3C2 /><path d=\"M7.92596 260.149H2.10352V276.1H7.92596V260.149Z\" fill=#B5C3C2 /><path d=\"M19.4376 260.149H13.6152V276.1H19.4376V260.149Z\" fill=#B5C3C2 /><path d=\"M30.9493 260.149H25.127V276.1H30.9493V260.149Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M42.4611 260.149H36.6387V276.1H42.4611V260.149Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M53.9726 260.149H48.1504V276.1H53.9726V260.149Z\" fill=#B5C3C2 /><path d=\"M7.92596 285.005H2.10352V300.956H7.92596V285.005Z\" fill=#B5C3C2 /><path d=\"M19.4376 285.005H13.6152V300.956H19.4376V285.005Z\" fill=#B5C3C2 /><path d=\"M30.9493 285.005H25.127V300.956H30.9493V285.005Z\" fill=#B5C3C2 /><path d=\"M42.4611 285.005H36.6387V300.956H42.4611V285.005Z\" fill=#B5C3C2 /><path d=\"M53.9726 285.005H48.1504V300.956H53.9726V285.005Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M7.92596 309.882H2.10352V325.833H7.92596V309.882Z\" fill=#B5C3C2 /><path d=\"M19.4376 309.882H13.6152V325.833H19.4376V309.882Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M30.9493 309.882H25.127V325.833H30.9493V309.882Z\" fill=#B5C3C2 /><path d=\"M42.4611 309.882H36.6387V325.833H42.4611V309.882Z\" fill=#B5C3C2 /><path d=\"M53.9726 309.882H48.1504V325.833H53.9726V309.882Z\" fill=#B5C3C2 /><path d=\"M7.92596 334.737H2.10352V350.688H7.92596V334.737Z\" fill=#B5C3C2 /><path d=\"M19.4376 334.737H13.6152V350.688H19.4376V334.737Z\" fill=#B5C3C2 /><path d=\"M30.9493 334.737H25.127V350.688H30.9493V334.737Z\" fill=#B5C3C2 /><path d=\"M42.4611 334.737H36.6387V350.688H42.4611V334.737Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M53.9726 334.737H48.1504V350.688H53.9726V334.737Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M7.92596 359.613H2.10352V375.564H7.92596V359.613Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M19.4376 359.613H13.6152V375.564H19.4376V359.613Z\" fill=#B5C3C2 /><path d=\"M30.9493 359.613H25.127V375.564H30.9493V359.613Z\" fill=#B5C3C2 /><path d=\"M42.4611 359.613H36.6387V375.564H42.4611V359.613Z\" fill=#B5C3C2 /><path d=\"M53.9726 359.613H48.1504V375.564H53.9726V359.613Z\" fill=#B5C3C2 /><path d=\"M7.92596 384.47H2.10352V400.421H7.92596V384.47Z\" fill=#B5C3C2 /><path d=\"M19.4376 384.47H13.6152V400.421H19.4376V384.47Z\" fill=#B5C3C2 /><path d=\"M30.9493 384.47H25.127V400.421H30.9493V384.47Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M42.4611 384.47H36.6387V400.421H42.4611V384.47Z\" fill=#B5C3C2 /><path d=\"M53.9726 384.47H48.1504V400.421H53.9726V384.47Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M7.92596 409.346H2.10352V425.296H7.92596V409.346Z\" fill=#B5C3C2 /><path d=\"M19.4376 409.346H13.6152V425.296H19.4376V409.346Z\" fill=#B5C3C2 /><path d=\"M30.9493 409.346H25.127V425.296H30.9493V409.346Z\" fill=#B5C3C2 /><path d=\"M42.4611 409.346H36.6387V425.296H42.4611V409.346Z\" fill=#B5C3C2 /><path d=\"M53.9726 409.346H48.1504V425.296H53.9726V409.346Z\" fill=#B5C3C2 /><path d=\"M7.92596 434.202H2.10352V450.153H7.92596V434.202Z\" fill=#B5C3C2 /><path d=\"M19.4376 434.202H13.6152V450.153H19.4376V434.202Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M30.9493 434.202H25.127V450.153H30.9493V434.202Z\" fill=#B5C3C2 /><path d=\"M42.4611 434.202H36.6387V450.153H42.4611V434.202Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M53.9726 434.202H48.1504V450.153H53.9726V434.202Z\" fill=#B5C3C2 /><path d=\"M7.92596 459.078H2.10352V475.029H7.92596V459.078Z\" fill=#B5C3C2 /><path opacity=0.29 d=\"M19.4376 459.078H13.6152V475.029H19.4376V459.078Z\" fill=#B5C3C2 /><path d=\"M30.9493 459.078H25.127V475.029H30.9493V459.078Z\" fill=#B5C3C2 /><path d=\"M42.4611 459.078H36.6387V475.029H42.4611V459.078Z\" fill=#B5C3C2 /><path d=\"M53.9726 459.078H48.1504V475.029H53.9726V459.078Z\" fill=#B5C3C2 /><path d=\"M317.312 270.688V144.24H296.097V110.382H288.524V60.7067H246.759V24.1907H243.048V60.7067H234.866V15H231.156V60.7067H204.765V144.24H191.122V270.688H179.439V500.987H325.532V270.688H317.312Z\" fill=#B5C3C2 /><path d=\"M1204.03 481.979H-412.104V520.336H1204.03V481.979Z\" fill=#B5C3C2 /><path d=\"M1226.79 516.521H-470.081V577.001H1226.79V516.521Z\" fill=#95A9A7 /><path d=\"M105.462 365.842H6.84277V522.198H105.462V365.842Z\" fill=#95A9A7 /><path d=\"M50.1302 393.832H-14.6582V522.198H50.1302V393.832Z\" fill=#95A9A7 /><path d=\"M243.048 258.003H121.425V522.198H243.048V258.003Z\" fill=#95A9A7 /><path d=\"M231.099 248.907H133.374V292.905H231.099V248.907Z\" fill=#95A9A7 /><path d=\"M252.486 263.529H112.007V266.624H252.486V263.529Z\" fill=#95A9A7 /><path d=\"M156.702 388.762H99.3916V522.179H156.702V388.762Z\" fill=#95A9A7 /><path d=\"M915.802 462.838H231.1V522.198H915.802V462.838Z\" fill=#95A9A7 /><path d=\"M432.428 577H312.992V302.969L432.428 273.821V577Z\" fill=#658280 /><path d=\"M318.225 298.165H307.741V577.019H318.225V298.165Z\" fill=#658280 /><path d=\"M348.08 290.304H337.596V577H348.08V290.304Z\" fill=#658280 /><path opacity=0.29 d=\"M334.876 321.56H320.947V342.732H334.876V321.56Z\" fill=#658280 /><path opacity=0.29 d=\"M364.747 321.56H350.819V342.732H364.747V321.56Z\" fill=#658280 /><path d=\"M334.876 358.436H320.947V379.608H334.876V358.436Z\" fill=#658280 /><path d=\"M364.747 358.436H350.819V379.608H364.747V358.436Z\" fill=#658280 /><path opacity=0.29 d=\"M334.876 395.313H320.947V416.486H334.876V395.313Z\" fill=#658280 /><path opacity=0.29 d=\"M364.747 395.313H350.819V416.486H364.747V395.313Z\" fill=#658280 /><path opacity=0.29 d=\"M334.876 432.171H320.947V453.344H334.876V432.171Z\" fill=#658280 /><path d=\"M364.747 432.171H350.819V453.344H364.747V432.171Z\" fill=#658280 /><path opacity=0.29 d=\"M334.876 469.047H320.947V490.22H334.876V469.047Z\" fill=#658280 /><path opacity=0.29 d=\"M364.747 469.047H350.819V490.22H364.747V469.047Z\" fill=#658280 /><path d=\"M334.876 505.925H320.947V527.098H334.876V505.925Z\" fill=#658280 /><path d=\"M364.747 505.925H350.819V527.098H364.747V505.925Z\" fill=#658280 /><path opacity=0.29 d=\"M334.876 542.801H320.947V563.974H334.876V542.801Z\" fill=#658280 /><path d=\"M364.747 542.801H350.819V563.974H364.747V542.801Z\" fill=#658280 /><path d=\"M-27.6925 316.109V318.958H-30.5466V327.066H19.4384V577H-62.5698V340.093V327.066V318.958H-65.5381V316.109H-27.6925Z\" fill=#658280 /><path d=\"M182.256 429.646H112.007V577.02H182.256V429.646Z\" fill=#658280 /><path d=\"M133.394 553.396H-3.58398V577H133.394V553.396Z\" fill=#658280 /><path d=\"M376.241 553.396H239.263V577H376.241V553.396Z\" fill=#658280 /><path d=\"M128.048 484.068H75.9884L53.9736 565.19H128.048V484.068Z\" fill=#658280 /><path d=\"M153.563 366.031H152.117V456.02H153.563V366.031Z\" fill=#658280 /><path d=\"M161.307 396.49H159.366V449.603H161.307V396.49Z\" fill=#658280 /><path d=\"M175.33 405.891H148.996V432.172H175.33V405.891Z\" fill=#658280 /><path d=\"M179.421 403.858H144.544V406.213H179.421V403.858Z\" fill=#658280 /><path d=\"M254.579 500.987H169.47V577H254.579V500.987Z\" fill=#658280 /><path d=\"M292.995 417.321H238.311V563.974H292.995V417.321Z\" fill=#658280 /><path opacity=0.5 d=\"M130.996 275.491H128.047V291.765H130.996V275.491Z\" fill=white /><path opacity=0.5 d=\"M141.157 275.491H138.208V291.765H141.157V275.491Z\" fill=white /><path opacity=0.5 d=\"M151.317 275.491H148.368V291.765H151.317V275.491Z\" fill=white /><path opacity=0.5 d=\"M161.479 275.491H158.529V291.765H161.479V275.491Z\" fill=white /><path opacity=0.5 d=\"M171.64 275.491H168.69V291.765H171.64V275.491Z\" fill=white /><path opacity=0.5 d=\"M181.8 275.491H178.851V291.765H181.8V275.491Z\" fill=white /><path opacity=0.5 d=\"M191.942 275.491H188.992V291.765H191.942V275.491Z\" fill=white /><path opacity=0.5 d=\"M202.102 275.491H199.152V291.765H202.102V275.491Z\" fill=white /><path opacity=0.5 d=\"M130.996 298.165H128.047V314.439H130.996V298.165Z\" fill=white /><path opacity=0.5 d=\"M141.157 298.165H138.208V314.439H141.157V298.165Z\" fill=white /><path opacity=0.5 d=\"M151.317 298.165H148.368V314.439H151.317V298.165Z\" fill=white /><path opacity=0.5 d=\"M161.479 298.165H158.529V314.439H161.479V298.165Z\" fill=white /><path opacity=0.5 d=\"M171.64 298.165H168.69V314.439H171.64V298.165Z\" fill=white /><path opacity=0.5 d=\"M181.8 298.165H178.851V314.439H181.8V298.165Z\" fill=white /><path opacity=0.5 d=\"M191.942 298.165H188.992V314.439H191.942V298.165Z\" fill=white /><path opacity=0.5 d=\"M202.102 298.165H199.152V314.439H202.102V298.165Z\" fill=white /><path opacity=0.5 d=\"M130.996 320.818H128.047V337.092H130.996V320.818Z\" fill=white /><path opacity=0.5 d=\"M141.157 320.818H138.208V337.092H141.157V320.818Z\" fill=white /><path opacity=0.5 d=\"M151.317 320.818H148.368V337.092H151.317V320.818Z\" fill=white /><path opacity=0.5 d=\"M161.479 320.818H158.529V337.092H161.479V320.818Z\" fill=white /><path opacity=0.5 d=\"M171.64 320.818H168.69V337.092H171.64V320.818Z\" fill=white /><path opacity=0.5 d=\"M181.8 320.818H178.851V337.092H181.8V320.818Z\" fill=white /><path opacity=0.5 d=\"M191.942 320.818H188.992V337.092H191.942V320.818Z\" fill=white /><path opacity=0.5 d=\"M202.102 320.818H199.152V337.092H202.102V320.818Z\" fill=white /><path opacity=0.5 d=\"M161.479 343.492H158.529V359.766H161.479V343.492Z\" fill=white /><path opacity=0.5 d=\"M171.64 343.492H168.69V359.766H171.64V343.492Z\" fill=white /><path opacity=0.5 d=\"M181.8 343.492H178.851V359.766H181.8V343.492Z\" fill=white /><path opacity=0.5 d=\"M191.942 343.492H188.992V359.766H191.942V343.492Z\" fill=white /><path opacity=0.5 d=\"M202.102 343.492H199.152V359.766H202.102V343.492Z\" fill=white /><path opacity=0.5 d=\"M171.64 367.417H168.69V383.691H171.64V367.417Z\" fill=white /><path opacity=0.5 d=\"M181.8 367.417H178.851V383.691H181.8V367.417Z\" fill=white /><path opacity=0.5 d=\"M191.942 367.417H188.992V383.691H191.942V367.417Z\" fill=white /><path opacity=0.5 d=\"M202.102 367.417H199.152V383.691H202.102V367.417Z\" fill=white /><path opacity=0.5 d=\"M212.263 275.491H209.313V291.765H212.263V275.491Z\" fill=white /><path opacity=0.5 d=\"M222.423 275.491H219.474V291.765H222.423V275.491Z\" fill=white /><path opacity=0.5 d=\"M232.584 275.491H229.635V291.765H232.584V275.491Z\" fill=white /><path opacity=0.5 d=\"M213.747 298.165H210.798V314.439H213.747V298.165Z\" fill=white /><path opacity=0.5 d=\"M223.907 298.165H220.958V314.439H223.907V298.165Z\" fill=white /><path opacity=0.5 d=\"M232.584 298.165H229.635V314.439H232.584V298.165Z\" fill=white /><path opacity=0.5 d=\"M213.747 320.818H210.798V337.092H213.747V320.818Z\" fill=white /><path opacity=0.5 d=\"M223.907 320.818H220.958V337.092H223.907V320.818Z\" fill=white /><path opacity=0.5 d=\"M234.05 320.818H231.101V337.092H234.05V320.818Z\" fill=white /><path opacity=0.5 d=\"M213.747 343.491H210.798V359.765H213.747V343.491Z\" fill=white /><path opacity=0.5 d=\"M223.907 343.491H220.958V359.765H223.907V343.491Z\" fill=white /><path opacity=0.5 d=\"M234.05 343.491H231.101V359.765H234.05V343.491Z\" fill=white /><path opacity=0.5 d=\"M213.747 367.418H210.798V383.692H213.747V367.418Z\" fill=white /><path opacity=0.5 d=\"M223.907 367.418H220.958V383.692H223.907V367.418Z\" fill=white /><path opacity=0.5 d=\"M234.05 367.418H231.101V383.692H234.05V367.418Z\" fill=white /><path opacity=0.5 d=\"M261.011 435.095H258.062V451.368H261.011V435.095Z\" fill=white /><path opacity=0.5 d=\"M271.172 435.095H268.223V451.368H271.172V435.095Z\" fill=white /><path opacity=0.5 d=\"M281.332 435.095H278.383V451.368H281.332V435.095Z\" fill=white /><path opacity=0.5 d=\"M262.475 457.769H259.526V474.042H262.475V457.769Z\" fill=white /><path opacity=0.5 d=\"M272.637 457.769H269.688V474.042H272.637V457.769Z\" fill=white /><path opacity=0.5 d=\"M281.332 457.769H278.383V474.042H281.332V457.769Z\" fill=white /><path opacity=0.5 d=\"M262.475 480.44H259.526V496.714H262.475V480.44Z\" fill=white /><path opacity=0.5 d=\"M272.637 480.44H269.688V496.714H272.637V480.44Z\" fill=white /><path opacity=0.5 d=\"M282.797 480.44H279.848V496.714H282.797V480.44Z\" fill=white /><path opacity=0.5 d=\"M262.475 503.114H259.526V519.388H262.475V503.114Z\" fill=white /><path opacity=0.5 d=\"M272.637 503.114H269.688V519.388H272.637V503.114Z\" fill=white /><path opacity=0.5 d=\"M282.797 503.114H279.848V519.388H282.797V503.114Z\" fill=white /><path opacity=0.5 d=\"M262.475 527.04H259.526V543.314H262.475V527.04Z\" fill=white /><path opacity=0.5 d=\"M272.637 527.04H269.688V543.314H272.637V527.04Z\" fill=white /><path opacity=0.5 d=\"M282.797 527.04H279.848V543.314H282.797V527.04Z\" fill=white /><path opacity=0.5 d=\"M140.416 436.651H137.467V452.925H140.416V436.651Z\" fill=white /><path opacity=0.5 d=\"M150.576 436.651H147.627V452.925H150.576V436.651Z\" fill=white /><path opacity=0.5 d=\"M160.737 436.651H157.787V452.925H160.737V436.651Z\" fill=white /><path opacity=0.5 d=\"M141.9 459.325H138.951V475.599H141.9V459.325Z\" fill=white /><path opacity=0.5 d=\"M152.061 459.325H149.111V475.599H152.061V459.325Z\" fill=white /><path opacity=0.5 d=\"M160.737 459.325H157.787V475.599H160.737V459.325Z\" fill=white /><path opacity=0.5 d=\"M141.9 481.997H138.951V498.271H141.9V481.997Z\" fill=white /><path opacity=0.5 d=\"M152.061 481.997H149.111V498.271H152.061V481.997Z\" fill=white /><path opacity=0.5 d=\"M162.203 481.997H159.254V498.271H162.203V481.997Z\" fill=white /><path opacity=0.5 d=\"M141.9 504.671H138.951V520.945H141.9V504.671Z\" fill=white /><path opacity=0.5 d=\"M152.061 504.671H149.111V520.945H152.061V504.671Z\" fill=white /><path opacity=0.5 d=\"M162.203 504.671H159.254V520.945H162.203V504.671Z\" fill=white /><path opacity=0.5 d=\"M141.9 528.597H138.951V544.87H141.9V528.597Z\" fill=white /><path opacity=0.5 d=\"M152.061 528.597H149.111V544.87H152.061V528.597Z\" fill=white /><path opacity=0.5 d=\"M162.203 528.597H159.254V544.87H162.203V528.597Z\" fill=white /><path opacity=0.5 d=\"M1.914 338.346H-1.03516V354.619H1.914V338.346Z\" fill=white /><path opacity=0.5 d=\"M12.0558 338.346H9.10645V354.619H12.0558V338.346Z\" fill=white /><path opacity=0.5 d=\"M3.37994 361.02H0.430664V377.293H3.37994V361.02Z\" fill=white /><path opacity=0.5 d=\"M12.0558 361.02H9.10645V377.293H12.0558V361.02Z\" fill=white /><path opacity=0.5 d=\"M3.37994 383.673H0.430664V399.947H3.37994V383.673Z\" fill=white /><path opacity=0.5 d=\"M13.5409 383.673H10.5918V399.947H13.5409V383.673Z\" fill=white /><path opacity=0.5 d=\"M3.37994 406.346H0.430664V422.619H3.37994V406.346Z\" fill=white /><path opacity=0.5 d=\"M13.5409 406.346H10.5918V422.619H13.5409V406.346Z\" fill=white /><path opacity=0.5 d=\"M3.37994 430.272H0.430664V446.546H3.37994V430.272Z\" fill=white /><path opacity=0.5 d=\"M13.5409 430.272H10.5918V446.546H13.5409V430.272Z\" fill=white /><path opacity=0.33 d=\"M331.393 315.9H324.429V333.522H331.393V315.9Z\" fill=white /><path opacity=0.33 d=\"M331.393 349.625H324.429V367.247H331.393V349.625Z\" fill=white /><path opacity=0.33 d=\"M331.393 383.331H324.429V400.953H331.393V383.331Z\" fill=white /><path opacity=0.33 d=\"M331.393 417.056H324.429V434.677H331.393V417.056Z\" fill=white /><path opacity=0.33 d=\"M331.393 448.843H324.429V466.465H331.393V448.843Z\" fill=white /><path opacity=0.33 d=\"M331.393 482.549H324.429V500.171H331.393V482.549Z\" fill=white /><path opacity=0.33 d=\"M361.267 315.9H354.303V333.522H361.267V315.9Z\" fill=white /><path opacity=0.33 d=\"M361.267 349.625H354.303V367.247H361.267V349.625Z\" fill=white /><path opacity=0.33 d=\"M361.267 383.331H354.303V400.953H361.267V383.331Z\" fill=white /><path opacity=0.33 d=\"M361.267 417.056H354.303V434.677H361.267V417.056Z\" fill=white /><path opacity=0.33 d=\"M361.267 448.843H354.303V466.465H361.267V448.843Z\" fill=white /><path opacity=0.33 d=\"M361.267 482.549H354.303V500.171H361.267V482.549Z\" fill=white /><path opacity=0.5 d=\"M218.066 70.0879H212.263V85.507H218.066V70.0879Z\" fill=white /><path opacity=0.5 d=\"M232.374 70.0879H226.57V85.507H232.374V70.0879Z\" fill=white /><path opacity=0.5 d=\"M246.665 70.0879H240.861V85.507H246.665V70.0879Z\" fill=white /><path opacity=0.5 d=\"M260.954 70.0879H255.15V85.507H260.954V70.0879Z\" fill=white /><path opacity=0.5 d=\"M218.066 95.7793H212.263V111.198H218.066V95.7793Z\" fill=white /><path opacity=0.5 d=\"M232.374 95.7793H226.57V111.198H232.374V95.7793Z\" fill=white /><path opacity=0.5 d=\"M246.665 95.7793H240.861V111.198H246.665V95.7793Z\" fill=white /><path opacity=0.5 d=\"M260.954 95.7793H255.15V111.198H260.954V95.7793Z\" fill=white /><path opacity=0.5 d=\"M218.066 121.473H212.263V136.892H218.066V121.473Z\" fill=white /><path opacity=0.5 d=\"M232.374 121.473H226.57V136.892H232.374V121.473Z\" fill=white /><path opacity=0.5 d=\"M277.183 70.0879H271.38V85.507H277.183V70.0879Z\" fill=white /><path opacity=0.33 d=\"M14.0162 460.236H9.35449V479.472H14.0162V460.236Z\" fill=white /><path opacity=0.33 d=\"M14.0162 495.689H9.35449V514.925H14.0162V495.689Z\" fill=white /></g><path d=\"M7.24725 426.94L-4 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M12.7219 426.94L1.47461 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M18.2053 426.94L6.95801 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M23.6789 426.94L12.4316 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M29.1623 426.94L17.915 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M34.6365 426.94L23.3975 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M40.1203 426.94L28.873 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M45.6017 426.94L34.3545 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M51.0764 426.94L39.8291 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M56.5598 426.94L45.3125 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M62.0344 426.94L50.7871 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M67.5168 426.94L56.2695 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path d=\"M72.9914 426.94L61.7441 438.188\" stroke=#D8D9DA stroke-width=0.7797 stroke-miterlimit=10 /><path opacity=0.1 d=\"M46 416H-4V420H46V416Z\" fill=#FF2C2C /><path opacity=0.1 d=\"M73 416H52V420H73V416Z\" fill=#2DC0DA /><path d=\"M200.671 89.1336L198.01 115.089L197.932 115.982C197.259 122.592 191.374 127.386 184.785 126.712C178.179 126.023 173.39 120.149 174.063 113.539L174.564 108.557L176.786 86.69C177.272 81.9907 181.482 78.5602 186.193 79.0458L193.017 79.735C197.729 80.2206 201.156 84.4343 200.671 89.1336Z\" fill=#FFBE9D /><path d=\"M209.607 117.257C209.607 117.257 209.607 117.257 209.591 117.273C209.122 117.085 208.668 116.897 208.214 116.709C206.445 125.904 197.211 132.921 186.082 132.921C173.796 132.921 163.825 124.4 163.653 113.811L174.5 109.018C182.921 111.493 190.903 111.806 198.369 109.378L209.607 117.257Z\" fill=#FFBE9D /><path opacity=0.5 d=\"M200.967 84.3621L198.306 110.318C196.068 111.164 193.673 111.602 191.2 111.602C184.845 111.602 179.085 108.642 174.844 103.801L177.066 81.9341C177.552 77.2348 181.762 73.8044 186.473 74.29L193.297 74.9792C198.008 75.4491 201.436 79.6628 200.967 84.3621Z\" fill=#F39371 /><path d=\"M216.915 82.6855C215.303 87.8234 211.281 89.2018 207.524 89.9851C207.477 89.9851 207.43 90.0007 207.384 90.0164C205.411 93.3842 202.751 96.6267 199.761 99.274C196.599 102.469 192.655 104.709 188.32 105.43C188.194 105.446 188.054 105.477 187.928 105.493C187.678 105.524 187.427 105.587 187.177 105.602C187.005 105.618 186.833 105.602 186.661 105.618C186.504 105.618 186.379 105.618 186.222 105.618C185.878 105.618 185.549 105.618 185.221 105.587C184.892 105.555 184.563 105.508 184.235 105.461C184.094 105.43 183.953 105.414 183.812 105.383C183.64 105.352 183.468 105.336 183.295 105.289C183.045 105.226 182.81 105.132 182.575 105.054C182.45 105.023 182.325 104.976 182.2 104.944C178.021 103.582 174.483 100.746 171.838 97.1123C169.287 94.0264 167.158 90.408 165.734 86.7895C165.609 86.7425 165.484 86.6956 165.358 86.6486C161.852 85.3171 158.221 83.2964 157.439 78.0959C156.797 73.8508 158.362 68.431 161.868 68.3997C162.901 68.384 164.059 68.8696 165.171 69.6372C167.237 62.7762 171.478 55.6333 176.409 50.887C178.506 48.4904 180.807 47.0023 183.264 46.2034C184.595 45.6708 185.925 45.3575 187.24 45.3419C188.147 45.3262 189.024 45.3732 189.9 45.4515C190.777 45.4985 191.653 45.6082 192.546 45.7491C193.829 45.9684 195.097 46.4854 196.333 47.2059C198.634 48.3807 200.685 50.2135 202.391 52.892C206.523 58.3589 209.606 66.0657 210.608 73.1616C211.813 72.5664 213.018 72.2688 214.051 72.4411C217.479 73.005 218.183 78.5971 216.915 82.6855Z\" fill=#FFBE9D /><path d=\"M199.543 74.6187C199.277 74.65 199.01 74.5091 198.87 74.2584C196.616 70.3424 193.016 72.1281 192.859 72.2064C192.515 72.3787 192.092 72.2377 191.905 71.8931C191.732 71.5485 191.873 71.1099 192.218 70.9376C193.924 70.0761 197.774 69.4965 200.106 73.5535C200.294 73.8981 200.184 74.3211 199.84 74.5247C199.73 74.5874 199.637 74.6187 199.543 74.6187Z\" fill=#0E1A2F /><path d=\"M186.379 92.2565C186.536 92.0372 186.818 91.9275 187.099 91.9902C191.498 92.9927 192.64 89.1393 192.687 88.967C192.797 88.591 193.188 88.3717 193.564 88.4814C193.939 88.591 194.158 88.9826 194.049 89.3586C193.532 91.207 191.325 94.4181 186.786 93.3843C186.411 93.2903 186.16 92.9144 186.254 92.5384C186.27 92.4288 186.317 92.3348 186.379 92.2565Z\" fill=#0E1A2F /><path d=\"M180.322 70.8119C180.15 70.9529 179.899 70.9999 179.68 70.9059C176.237 69.3552 174.64 72.3314 174.578 72.4567C174.421 72.7543 174.077 72.864 173.78 72.7073C173.482 72.5507 173.373 72.1904 173.529 71.9084C174.265 70.483 176.613 68.196 180.181 69.8094C180.479 69.9504 180.619 70.295 180.479 70.5926C180.432 70.6866 180.385 70.7649 180.322 70.8119Z\" fill=#0E1A2F /><path d=\"M186.176 88.5748C185.237 89.2796 184.267 89.6086 183.421 89.5459C182.921 89.4989 182.482 89.3423 182.091 89.029C181.653 88.7001 181.355 88.2458 181.199 87.6819C180.886 86.6637 181.011 85.3166 181.621 83.8128L183.922 76.012C184.016 75.7144 184.314 75.5421 184.627 75.6361C184.924 75.7301 185.096 76.0433 185.002 76.341L182.701 84.1888C182.06 85.8022 182.075 86.93 182.388 87.5879C182.482 87.8229 182.623 87.9952 182.78 88.1205C183.39 88.5904 184.345 88.4494 185.3 87.7915C185.347 87.7602 185.378 87.7445 185.425 87.7132C185.675 87.5252 186.051 87.5566 186.254 87.7915C186.27 87.8072 186.286 87.8385 186.301 87.8699C186.427 88.1048 186.395 88.3868 186.176 88.5748Z\" fill=#0E1A2F /><path d=\"M197.148 78.6754C197.007 79.8816 195.943 80.7431 194.738 80.6178C193.548 80.4925 192.672 79.396 192.813 78.1898C192.954 76.9837 194.018 76.1221 195.223 76.2475C196.413 76.3884 197.273 77.4693 197.148 78.6754Z\" fill=#0E1A2F /><path d=\"M179.477 77.9235C179.336 79.1296 178.271 79.9912 177.066 79.8658C175.877 79.7249 175.016 78.644 175.141 77.4379C175.282 76.2317 176.346 75.3702 177.551 75.4955C178.757 75.6208 179.617 76.7173 179.477 77.9235Z\" fill=#0E1A2F /><path d=\"M153.949 525.828C153.996 526.392 154.027 526.784 153.996 526.878L133.727 542.73C131.692 544.187 132.13 547.508 134.463 548.338C134.76 548.432 135.042 548.541 135.339 548.62C140.833 550.202 150.834 550.719 154.81 546.286C156.547 544.328 159.02 543.263 161.556 543.372L162.401 543.419C168.896 543.686 167.128 535.853 165.938 529.039C165.938 529.039 165.672 526.424 165.422 523.432C165.469 524.512 165.5 525.578 165.547 526.658L153.949 525.828Z\" fill=#223B77 /><path d=\"M198.556 522.444C198.275 525.703 197.993 528.538 197.993 528.538C196.694 535.916 194.784 544.421 201.828 544.124L202.736 544.077C205.49 543.967 208.167 545.126 210.045 547.241C214.334 552.05 225.196 551.486 231.144 549.763C231.472 549.669 231.785 549.559 232.098 549.45C234.634 548.541 235.088 544.954 232.897 543.372L210.906 526.172C210.874 526.078 210.89 525.656 210.953 525.029L198.416 525.922C198.478 524.763 198.51 523.603 198.556 522.444Z\" fill=#223B77 /><path d=\"M145.137 237.511C141.068 256.559 139.487 300.763 138.939 320.469C136.92 392.806 138.579 462.184 151.382 527.973L157.361 527.629L167.66 528.49C167.613 527.363 167.519 526.266 167.55 525.138C170.243 440.019 170.258 368.621 177.693 303.426C178.1 299.823 182.31 299.933 182.639 303.536C188.399 368.824 192.766 440.175 195.395 525.138C195.426 526.266 195.332 527.363 195.285 528.49L205.584 527.629L213.348 527.832C225.885 461.808 222.895 392.196 220.704 317.289C220.187 299.776 218.794 252.079 215.179 235.146L145.137 237.511Z\" fill=#0E1A2F /><path d=\"M253.306 202.737L253.103 202.533L252.884 202.22L253.103 201.828C253.244 202.11 253.306 202.455 253.306 202.737Z\" fill=#001E48 /><path d=\"M237.248 134.205L233.695 146.314L218.137 199.384C215.366 209.112 214.099 219.215 214.333 229.288H145.622C146.639 218.401 147.187 211.603 146.53 201.045C146.154 194.889 145.011 188.842 143.431 182.937C139.596 168.651 137.671 142.382 139.095 126.044C146.843 120.202 154.966 116.411 163.293 113.936C163.418 113.904 163.528 113.873 163.653 113.826C163.825 124.415 173.795 132.937 186.082 132.937C197.21 132.937 206.445 125.919 208.213 116.724C208.652 116.912 209.121 117.1 209.591 117.288C219.264 121.329 230.361 127.141 235.682 132.435C236.261 132.999 236.794 133.594 237.248 134.205Z\" fill=white /><path d=\"M140.582 169.951L134.494 195.656L130.017 232.64C129.329 238.31 124.101 242.179 118.638 241.051C113.896 240.064 110.625 235.6 111.016 230.65C112.456 212.605 115.367 172.959 115.852 170.217C117.355 162.025 119.108 154.193 120.924 146.972C124.899 131.104 136.873 124.525 139.487 122.849L138 123.788L140.582 169.951Z\" fill=#56C2D5 /><path d=\"M251.679 236.226C246.936 238.137 241.646 235.318 240.441 230.227L232.865 198.303L226.589 171.784C225.712 151.185 226.495 135.552 229.14 125.637L229.171 125.292C231.785 126.968 242.256 132.967 246.216 148.82C248.955 159.753 251.553 172.05 253.306 184.769C253.807 188.215 255.952 214.735 256.985 227.47C257.282 231.276 255.138 234.832 251.679 236.226Z\" fill=#56C2D4 /><path d=\"M235.667 130.133L233.695 144.043L227.027 191.004C224.586 199.729 223.193 208.752 222.88 217.837L221.111 271.174C221.048 273.226 218.685 274.229 217.229 272.866L206.195 262.496C196.334 253.254 190.433 240.503 189.573 226.985C189.4 224.682 189.4 222.333 189.557 219.983C189.557 219.983 189.573 219.967 189.588 219.921C197.555 202.674 201.421 183.814 200.936 164.829L199.449 108.297C210.014 111.931 228.702 123.162 235.667 130.133Z\" fill=#2DC0DA /><path d=\"M135.824 125.276L136.137 139.327L137.17 186.774C138.563 195.734 138.876 204.867 138.109 213.921L133.539 267.085C133.367 269.137 135.574 270.422 137.201 269.247L149.378 260.35C151.491 258.799 153.761 256.324 156.062 253.332C168.442 237.151 173.138 216.427 169.788 196.33C167.425 182.153 166.908 167.899 168.27 153.018L172.762 108.845C168.693 107.701 143.572 119.246 135.824 125.276Z\" fill=#2DC0DA /><path d=\"M174.86 103.111C174.86 103.111 159.678 105.383 163.105 118.995C164.076 122.864 164.655 126.811 165.203 130.759L168.208 152.266C171.432 138.779 175.267 114.813 174.86 103.111Z\" fill=#56C2D4 /><path d=\"M198.807 104.475C198.807 104.475 213.99 106.746 210.562 120.358C209.592 124.227 200.858 154.804 200.858 154.804C197.634 141.333 198.401 116.191 198.807 104.475Z\" fill=#56C2D4 /><path d=\"M213.003 62.9173C212.565 61.1786 212.096 60.0508 210.703 58.8603C208.903 57.3252 207.713 57.5915 205.772 57.1216C207.103 53.1272 207.087 50.245 203.988 47.0964C199.246 42.2875 191.216 38.7944 184.439 40.3921C179.884 41.473 176.926 44.8251 174.093 48.2869C172.716 49.9787 169.585 59.6905 166.439 53.8007C165.281 55.5551 165.391 58.7037 166.095 60.6304C164.013 61.3353 162.464 59.1736 160.805 58.359C160.852 60.5834 161.368 63.4029 162.683 65.5176C162.965 65.9719 162.354 67.2094 162.339 67.7576C162.229 74.3993 167.065 80.2734 166.455 86.8524C166.831 82.6857 167.582 78.6756 168.224 74.5089C168.505 72.6605 168.818 70.9375 169.476 69.1204C169.585 68.8228 169.758 68.4782 169.961 68.1179C171.98 67.554 173.968 66.4888 175.877 65.9406C179.149 65.0164 182.827 64.9537 186.208 64.9067C190.011 64.8597 199.23 65.8309 201.108 61.1473C201.155 63.6849 200.341 66.1599 200.826 68.7758C201.265 71.1568 202.501 73.6787 203.581 75.8247C204.536 77.7514 205.944 86.1318 206.524 88.2935C207.51 82.3411 211.25 76.9682 213.035 71.1881C213.833 68.5722 213.676 65.6116 213.003 62.9173Z\" fill=#0E1A2F /><path d=\"M220.344 175.01C220.328 175.01 220.312 175.01 220.281 175.01L208.417 174.838C206.492 174.807 204.911 173.287 204.817 171.361L204.128 157.341C204.034 155.587 205.208 154.02 206.914 153.613C209.747 152.924 218.387 150.856 227.074 155.352C228.576 156.135 229.328 157.889 228.874 159.534C227.935 162.949 225.963 169.293 223.427 173.35C222.77 174.384 221.596 175.01 220.344 175.01ZM215.147 153.3C211.469 153.3 208.526 154.005 207.102 154.349C205.772 154.678 204.848 155.9 204.927 157.278L205.615 171.298C205.693 172.802 206.93 174.008 208.448 174.039L220.312 174.212C220.328 174.212 220.344 174.212 220.359 174.212C221.345 174.212 222.269 173.71 222.77 172.911C225.258 168.948 227.199 162.683 228.123 159.315C228.483 158.015 227.888 156.636 226.73 156.025C222.644 153.926 218.575 153.3 215.147 153.3Z\" fill=#F7F9FE /><path d=\"M144.934 173.35C142.398 169.293 140.426 162.965 139.487 159.534C139.033 157.89 139.784 156.119 141.287 155.352C149.974 150.841 158.598 152.924 161.446 153.613C163.137 154.02 164.311 155.587 164.232 157.341L163.544 171.361C163.45 173.288 161.869 174.807 159.944 174.838L148.08 175.011C148.064 175.011 148.048 175.011 148.017 175.011C146.765 175.011 145.591 174.384 144.934 173.35ZM141.647 156.041C140.473 156.652 139.894 158.031 140.254 159.331C141.193 162.714 143.134 168.964 145.607 172.927C146.108 173.726 147.031 174.227 148.017 174.227C148.033 174.227 148.048 174.227 148.064 174.227L159.928 174.055C161.446 174.039 162.683 172.833 162.761 171.314L163.45 157.294C163.512 155.916 162.605 154.678 161.274 154.365C159.85 154.02 156.907 153.316 153.229 153.316C149.786 153.3 145.716 153.927 141.647 156.041Z\" fill=#F7F9FE /><g filter=url(#filter0_d_3325:20386)><rect x=27 y=235 width=297 height=124 rx=6 fill=white /><text dominant-baseline=middle text-anchor=middle fill=black font-size=22px x=48% font-weight=\"\" y=44%>{{userCity}}!</text><text x=50% dominant-baseline=bottom text-anchor=middle fill=black font-size=16px y=50%>What a beautiful city!</text></g><!-- <path d=\"M130.752 284V267.2H133.92V281.072H142.344V284H130.752ZM155.992 284H152.92C152.536 283.52 152.344 282.888 152.344 282.104C151.512 283.592 150.184 284.336 148.36 284.336C147.176 284.336 146.208 284 145.456 283.328C144.72 282.64 144.352 281.736 144.352 280.616C144.352 279.48 144.744 278.592 145.528 277.952C146.328 277.296 147.352 276.872 148.6 276.68L152.176 276.128V275.672C152.176 274.472 151.448 273.872 149.992 273.872C149.32 273.872 148.792 274 148.408 274.256C148.04 274.512 147.856 274.832 147.856 275.216C147.856 275.312 147.872 275.408 147.904 275.504L145.192 276.416C145.048 276.096 144.976 275.76 144.976 275.408C144.976 274.432 145.432 273.584 146.344 272.864C147.256 272.128 148.472 271.76 149.992 271.76C151.688 271.76 152.976 272.12 153.856 272.84C154.752 273.56 155.2 274.64 155.2 276.08V281.048C155.2 282.248 155.464 283.232 155.992 284ZM149.08 281.888C149.992 281.888 150.736 281.592 151.312 281C151.888 280.392 152.176 279.536 152.176 278.432V278.216L149.296 278.696C147.968 278.92 147.304 279.504 147.304 280.448C147.304 280.912 147.464 281.272 147.784 281.528C148.104 281.768 148.536 281.888 149.08 281.888ZM169.474 275.96V284H166.45V277.136C166.45 276.336 166.242 275.712 165.826 275.264C165.426 274.816 164.834 274.592 164.05 274.592C163.202 274.592 162.498 274.904 161.938 275.528C161.394 276.152 161.122 276.96 161.122 277.952V284H158.098V267.2H161.122V273.968C162.066 272.496 163.442 271.76 165.25 271.76C166.546 271.76 167.57 272.144 168.322 272.912C169.09 273.664 169.474 274.68 169.474 275.96ZM182.717 273.44C184.013 274.544 184.661 276.08 184.661 278.048C184.661 280.016 184.013 281.56 182.717 282.68C181.437 283.784 179.917 284.336 178.157 284.336C176.397 284.336 174.869 283.784 173.573 282.68C172.293 281.56 171.653 280.016 171.653 278.048C171.653 276.08 172.293 274.544 173.573 273.44C174.869 272.32 176.397 271.76 178.157 271.76C179.917 271.76 181.437 272.32 182.717 273.44ZM175.733 280.568C176.421 281.192 177.229 281.504 178.157 281.504C179.085 281.504 179.885 281.192 180.557 280.568C181.245 279.928 181.589 279.088 181.589 278.048C181.589 277.008 181.245 276.176 180.557 275.552C179.885 274.912 179.085 274.592 178.157 274.592C177.229 274.592 176.421 274.912 175.733 275.552C175.061 276.176 174.725 277.008 174.725 278.048C174.725 279.088 175.061 279.928 175.733 280.568ZM194.388 271.904L193.908 274.76C193.604 274.648 193.276 274.592 192.924 274.592C192.044 274.592 191.34 274.928 190.812 275.6C190.3 276.256 190.044 277.096 190.044 278.12V284H187.02V272.096H190.044V273.992C190.78 272.504 191.884 271.76 193.356 271.76C193.724 271.76 194.068 271.808 194.388 271.904ZM207.092 278.768H197.924C198.02 279.68 198.364 280.408 198.956 280.952C199.548 281.48 200.292 281.744 201.188 281.744C202.66 281.744 203.756 281.016 204.476 279.56L206.732 280.856C205.612 283.176 203.748 284.336 201.14 284.336C199.444 284.336 197.996 283.752 196.796 282.584C195.612 281.4 195.02 279.888 195.02 278.048C195.02 276.192 195.62 274.68 196.82 273.512C198.036 272.344 199.524 271.76 201.284 271.76C202.98 271.76 204.372 272.32 205.46 273.44C206.548 274.544 207.092 275.968 207.092 277.712V278.768ZM201.188 274.064C200.404 274.064 199.716 274.304 199.124 274.784C198.548 275.248 198.148 275.84 197.924 276.56H204.308C204.164 275.776 203.82 275.168 203.276 274.736C202.732 274.288 202.036 274.064 201.188 274.064ZM209.736 273.032V267.2H212.904V273.032L212.52 279.008H210.12L209.736 273.032ZM209.736 284V280.688H212.904V284H209.736Z\" fill=\"black\"/> --><!-- <path d=\"M95.636 320L92.09 307.4H93.584L96.14 316.886C96.272 317.462 96.374 317.9 96.446 318.2L96.752 316.868L99.218 307.4H100.838L103.304 316.868C103.448 317.456 103.55 317.9 103.61 318.2L103.916 316.886L106.472 307.4H107.966L104.42 320H102.854L100.028 309.272L97.202 320H95.636ZM117.067 313.97V320H115.663V314.222C115.663 313.538 115.459 313.01 115.051 312.638C114.655 312.266 114.133 312.08 113.485 312.08C112.765 312.08 112.141 312.356 111.613 312.908C111.085 313.448 110.821 314.162 110.821 315.05V320H109.417V307.4H110.821V312.638C111.109 312.086 111.529 311.648 112.081 311.324C112.633 310.988 113.227 310.82 113.863 310.82C114.763 310.82 115.519 311.09 116.131 311.63C116.755 312.158 117.067 312.938 117.067 313.97ZM127.172 320H125.768C125.408 319.568 125.228 318.98 125.228 318.236C124.952 318.884 124.544 319.382 124.004 319.73C123.476 320.078 122.87 320.252 122.186 320.252C121.286 320.252 120.56 320 120.008 319.496C119.456 318.98 119.18 318.326 119.18 317.534C119.18 316.718 119.462 316.064 120.026 315.572C120.602 315.08 121.346 314.762 122.258 314.618L125.228 314.132V313.736C125.228 312.584 124.526 312.008 123.122 312.008C122.45 312.008 121.928 312.14 121.556 312.404C121.196 312.668 121.016 312.998 121.016 313.394C121.016 313.478 121.028 313.568 121.052 313.664L119.828 314.078C119.732 313.85 119.684 313.61 119.684 313.358C119.684 312.662 119.996 312.068 120.62 311.576C121.256 311.072 122.09 310.82 123.122 310.82C124.274 310.82 125.144 311.078 125.732 311.594C126.332 312.098 126.632 312.812 126.632 313.736V317.768C126.632 318.284 126.668 318.698 126.74 319.01C126.812 319.31 126.956 319.64 127.172 320ZM122.348 318.992C123.248 318.992 123.95 318.656 124.454 317.984C124.97 317.3 125.228 316.478 125.228 315.518V315.248L122.51 315.716C121.898 315.824 121.43 316.028 121.106 316.328C120.782 316.628 120.62 317.006 120.62 317.462C120.62 317.93 120.776 318.302 121.088 318.578C121.4 318.854 121.82 318.992 122.348 318.992ZM128.135 312.188V311.072H129.629V308.66H131.033V311.072H133.085V312.188H131.033V317.588C131.033 318.104 131.111 318.476 131.267 318.704C131.435 318.92 131.765 319.028 132.257 319.028C132.461 319.028 132.683 318.992 132.923 318.92L133.049 320.09C132.737 320.198 132.341 320.252 131.861 320.252C131.213 320.252 130.679 320.066 130.259 319.694C129.839 319.31 129.629 318.698 129.629 317.858V312.188H128.135ZM147.633 320H146.229C145.869 319.568 145.689 318.98 145.689 318.236C145.413 318.884 145.005 319.382 144.465 319.73C143.937 320.078 143.331 320.252 142.647 320.252C141.747 320.252 141.021 320 140.469 319.496C139.917 318.98 139.641 318.326 139.641 317.534C139.641 316.718 139.923 316.064 140.487 315.572C141.063 315.08 141.807 314.762 142.719 314.618L145.689 314.132V313.736C145.689 312.584 144.987 312.008 143.583 312.008C142.911 312.008 142.389 312.14 142.017 312.404C141.657 312.668 141.477 312.998 141.477 313.394C141.477 313.478 141.489 313.568 141.513 313.664L140.289 314.078C140.193 313.85 140.145 313.61 140.145 313.358C140.145 312.662 140.457 312.068 141.081 311.576C141.717 311.072 142.551 310.82 143.583 310.82C144.735 310.82 145.605 311.078 146.193 311.594C146.793 312.098 147.093 312.812 147.093 313.736V317.768C147.093 318.284 147.129 318.698 147.201 319.01C147.273 319.31 147.417 319.64 147.633 320ZM142.809 318.992C143.709 318.992 144.411 318.656 144.915 317.984C145.431 317.3 145.689 316.478 145.689 315.518V315.248L142.971 315.716C142.359 315.824 141.891 316.028 141.567 316.328C141.243 316.628 141.081 317.006 141.081 317.462C141.081 317.93 141.237 318.302 141.549 318.578C141.861 318.854 142.281 318.992 142.809 318.992ZM154.821 320V307.4H156.225V312.692C156.561 312.116 157.017 311.66 157.593 311.324C158.181 310.988 158.817 310.82 159.501 310.82C160.677 310.82 161.655 311.264 162.435 312.152C163.227 313.04 163.623 314.168 163.623 315.536C163.623 316.904 163.215 318.032 162.399 318.92C161.595 319.808 160.575 320.252 159.339 320.252C158.655 320.252 158.031 320.078 157.467 319.73C156.915 319.382 156.501 318.938 156.225 318.398V320H154.821ZM156.981 318.02C157.557 318.644 158.277 318.956 159.141 318.956C160.005 318.956 160.725 318.644 161.301 318.02C161.889 317.384 162.183 316.556 162.183 315.536C162.183 314.516 161.889 313.694 161.301 313.07C160.725 312.434 160.005 312.116 159.141 312.116C158.277 312.116 157.557 312.434 156.981 313.07C156.405 313.694 156.117 314.516 156.117 315.536C156.117 316.556 156.405 317.384 156.981 318.02ZM173.927 315.77H166.547C166.595 316.73 166.895 317.522 167.447 318.146C167.999 318.758 168.725 319.064 169.625 319.064C170.381 319.064 170.987 318.89 171.443 318.542C171.911 318.182 172.307 317.678 172.631 317.03L173.657 317.642C172.781 319.382 171.419 320.252 169.571 320.252C168.335 320.252 167.285 319.808 166.421 318.92C165.569 318.02 165.143 316.892 165.143 315.536C165.143 314.18 165.575 313.058 166.439 312.17C167.303 311.27 168.365 310.82 169.625 310.82C170.945 310.82 171.989 311.234 172.757 312.062C173.537 312.89 173.927 313.964 173.927 315.284V315.77ZM169.625 312.008C168.845 312.008 168.197 312.248 167.681 312.728C167.165 313.196 166.823 313.826 166.655 314.618H172.523C172.475 313.814 172.163 313.178 171.587 312.71C171.011 312.242 170.357 312.008 169.625 312.008ZM183.616 320H182.212C181.852 319.568 181.672 318.98 181.672 318.236C181.396 318.884 180.988 319.382 180.448 319.73C179.92 320.078 179.314 320.252 178.63 320.252C177.73 320.252 177.004 320 176.452 319.496C175.9 318.98 175.624 318.326 175.624 317.534C175.624 316.718 175.906 316.064 176.47 315.572C177.046 315.08 177.79 314.762 178.702 314.618L181.672 314.132V313.736C181.672 312.584 180.97 312.008 179.566 312.008C178.894 312.008 178.372 312.14 178 312.404C177.64 312.668 177.46 312.998 177.46 313.394C177.46 313.478 177.472 313.568 177.496 313.664L176.272 314.078C176.176 313.85 176.128 313.61 176.128 313.358C176.128 312.662 176.44 312.068 177.063 311.576C177.7 311.072 178.534 310.82 179.566 310.82C180.718 310.82 181.588 311.078 182.176 311.594C182.776 312.098 183.076 312.812 183.076 313.736V317.768C183.076 318.284 183.112 318.698 183.184 319.01C183.256 319.31 183.4 319.64 183.616 320ZM178.792 318.992C179.692 318.992 180.394 318.656 180.898 317.984C181.414 317.3 181.672 316.478 181.672 315.518V315.248L178.954 315.716C178.342 315.824 177.874 316.028 177.55 316.328C177.226 316.628 177.063 317.006 177.063 317.462C177.063 317.93 177.22 318.302 177.532 318.578C177.844 318.854 178.264 318.992 178.792 318.992ZM185.636 316.958V311.072H187.04V316.886C187.04 317.57 187.232 318.092 187.616 318.452C188 318.812 188.51 318.992 189.146 318.992C189.878 318.992 190.496 318.722 191 318.182C191.516 317.642 191.774 316.94 191.774 316.076V311.072H193.178V320H191.774V318.434C191.138 319.646 190.148 320.252 188.804 320.252C187.904 320.252 187.148 319.982 186.536 319.442C185.936 318.902 185.636 318.074 185.636 316.958ZM195.02 312.188V311.072H196.514V308.66H197.918V311.072H199.97V312.188H197.918V317.588C197.918 318.104 197.996 318.476 198.152 318.704C198.32 318.92 198.65 319.028 199.142 319.028C199.346 319.028 199.568 318.992 199.808 318.92L199.934 320.09C199.622 320.198 199.226 320.252 198.746 320.252C198.098 320.252 197.564 320.066 197.144 319.694C196.724 319.31 196.514 318.698 196.514 317.858V312.188H195.02ZM201.983 320V311.072H203.387V320H201.983ZM201.839 309.524V307.76H203.531V309.524H201.839ZM205.178 312.188V311.072H206.582V309.29C206.582 308.438 206.822 307.76 207.302 307.256C207.782 306.752 208.46 306.5 209.336 306.5C209.672 306.5 209.96 306.542 210.2 306.626L209.984 307.814C209.804 307.754 209.606 307.724 209.39 307.724C208.454 307.724 207.986 308.252 207.986 309.308V311.072H210.038V312.188H207.986V320H206.582V312.188H205.178ZM211.704 316.958V311.072H213.108V316.886C213.108 317.57 213.3 318.092 213.684 318.452C214.068 318.812 214.578 318.992 215.214 318.992C215.946 318.992 216.564 318.722 217.068 318.182C217.584 317.642 217.842 316.94 217.842 316.076V311.072H219.246V320H217.842V318.434C217.206 319.646 216.216 320.252 214.872 320.252C213.972 320.252 213.216 319.982 212.604 319.442C212.004 318.902 211.704 318.074 211.704 316.958ZM221.987 320V307.4H223.391V320H221.987ZM238.076 317.03L239.084 317.678C238.22 319.394 236.882 320.252 235.07 320.252C233.774 320.252 232.688 319.808 231.812 318.92C230.936 318.032 230.498 316.904 230.498 315.536C230.498 314.18 230.942 313.058 231.83 312.17C232.73 311.27 233.81 310.82 235.07 310.82C236.018 310.82 236.834 311.036 237.518 311.468C238.202 311.9 238.706 312.5 239.03 313.268L237.968 313.97C237.38 312.71 236.42 312.08 235.088 312.08C234.176 312.08 233.414 312.398 232.802 313.034C232.202 313.658 231.902 314.492 231.902 315.536C231.902 316.58 232.196 317.42 232.784 318.056C233.384 318.68 234.152 318.992 235.088 318.992C235.796 318.992 236.384 318.83 236.852 318.506C237.32 318.17 237.728 317.678 238.076 317.03ZM241.13 320V311.072H242.534V320H241.13ZM240.986 309.524V307.76H242.678V309.524H240.986ZM244.432 312.188V311.072H245.926V308.66H247.33V311.072H249.382V312.188H247.33V317.588C247.33 318.104 247.408 318.476 247.564 318.704C247.732 318.92 248.062 319.028 248.554 319.028C248.758 319.028 248.98 318.992 249.22 318.92L249.346 320.09C249.034 320.198 248.638 320.252 248.158 320.252C247.51 320.252 246.976 320.066 246.556 319.694C246.136 319.31 245.926 318.698 245.926 317.858V312.188H244.432ZM251.457 323.618L251.673 322.358C251.913 322.478 252.153 322.538 252.393 322.538C252.669 322.538 252.885 322.472 253.041 322.34C253.197 322.208 253.341 321.98 253.473 321.656L254.139 319.964L250.539 311.072H252.087L254.913 318.074L257.703 311.072H259.215L254.733 322.106C254.481 322.73 254.169 323.168 253.797 323.42C253.437 323.672 252.969 323.798 252.393 323.798C252.057 323.798 251.745 323.738 251.457 323.618ZM260.982 311.414V307.4H262.494V311.414L262.296 316.616H261.18L260.982 311.414ZM260.91 320V318.2H262.566V320H260.91Z\" fill=\"black\"/> --><path d=\"M132.199 229.152L137.677 241.573C138.24 242.842 137.927 244.44 136.754 245.207C135.439 246.069 133.232 245.756 129.914 240.132L127.816 237.767L128.223 241.479C128.521 244.189 125.093 245.662 123.387 243.547C122.776 242.795 122.15 241.761 121.524 240.383C120.961 242.466 118.66 243.578 116.688 242.701C114.262 241.62 111.366 238.863 110.005 231.987C109.864 228.133 112.963 224.954 116.813 225.001L126.11 225.126C128.755 225.173 131.135 226.739 132.199 229.152Z\" fill=#E78C6B /><path d=\"M237.75 231.152L232.272 243.573C231.709 244.842 232.022 246.44 233.196 247.207C234.51 248.069 236.717 247.756 240.035 242.132L242.133 239.767L241.726 243.479C241.428 246.189 244.856 247.662 246.562 245.547C247.173 244.795 247.799 243.761 248.425 242.383C248.988 244.466 251.289 245.578 253.261 244.701C255.687 243.62 258.583 240.863 259.945 233.987C260.085 230.133 256.986 226.954 253.136 227.001L243.839 227.126C241.194 227.173 238.815 228.739 237.75 231.152Z\" fill=#E78C6B /><path d=\"M92.5998 449.365C98.5552 446.298 105.572 445.9 112.191 446.994C115.741 447.574 119.457 448.635 121.862 451.304C124.284 453.973 124.732 458.665 121.962 460.952C120.303 462.312 117.997 462.527 115.857 462.494C110.682 462.428 104.942 461.516 100.795 464.632C98.4391 466.406 96.8631 469.357 94.043 470.236C91.2893 471.098 88.1706 469.456 86.7108 466.97C85.251 464.483 85.2012 461.367 85.8814 458.565C85.8814 458.565 86.6113 452.448 92.5998 449.365Z\" fill=#4A4A4A /><path d=\"M78.9586 423.024C82.6081 428.23 89.675 426.506 92.9596 423.323C96.2441 420.156 97.6376 415.548 98.8983 411.155C101.785 401.126 104.688 390.615 102.548 380.404C101.901 377.353 100.756 374.303 98.6164 372.049C96.4764 369.778 93.1752 368.435 90.156 369.231C86.5895 370.175 84.3666 373.673 82.7574 376.989C78.0462 386.753 75.5413 397.595 75.5081 408.436C75.4916 413.526 76.0887 418.847 78.9586 423.024Z\" fill=#4A4A4A /><path d=\"M68.9428 430.484C72.8909 425.793 73.654 418.946 71.8956 413.078C70.1372 407.193 66.1559 402.203 61.5774 398.125C56.2026 393.334 49.8823 389.621 43.0975 387.234C40.4267 386.289 37.6066 385.559 34.7865 385.825C31.9664 386.09 29.1298 387.532 27.8192 390.035C25.8784 393.749 27.7363 398.241 29.7601 401.905C33.3101 408.37 37.3744 414.553 41.9031 420.372C45.536 425.064 49.6998 429.689 55.257 431.794C60.7977 433.916 66.554 433.667 69.5068 429.821\" fill=#4A4A4A /><path d=\"M78.7145 501.47C78.7808 501.47 78.8969 500.625 79.0462 499.1C79.2121 497.376 79.4278 495.221 79.6766 492.651C79.9752 489.932 80.3733 486.716 81.1364 483.185C81.8829 479.671 83.0607 475.875 84.5703 472.029C86.1296 468.199 88.0374 464.718 90.2768 461.933C92.4831 459.131 95.071 457.109 97.493 455.948C99.8983 454.755 102.071 454.274 103.564 454.059C105.074 453.909 105.92 453.777 105.92 453.71C105.92 453.644 105.074 453.628 103.531 453.677C101.988 453.777 99.749 454.175 97.1943 455.319C94.6397 456.446 91.9025 458.501 89.5801 461.369C87.2411 464.221 85.267 467.768 83.6745 471.681C82.1317 475.609 80.9705 479.439 80.2572 483.02C79.5439 486.6 79.2121 489.866 78.9965 492.601C78.7974 495.337 78.7144 497.558 78.6813 499.083C78.6315 500.608 78.6481 501.454 78.7145 501.47Z\" fill=#263238 /><path d=\"M79.1436 496.497C79.1768 496.497 79.1934 496.115 79.21 495.402C79.21 494.574 79.21 493.546 79.1934 492.269C79.1934 489.551 79.1934 485.605 79.3261 480.748C79.5749 471.017 80.4044 460.556 82.0301 445.802C83.5562 431.927 85.6133 415.78 87.7864 405.287C88.2509 402.9 88.7153 400.745 89.1632 398.871C89.578 396.982 89.9429 395.357 90.2913 394.047C90.5899 392.804 90.8387 391.793 91.0212 390.997C91.1705 390.301 91.2535 389.919 91.2203 389.919C91.1871 389.903 91.0544 390.268 90.8387 390.947C90.6065 391.743 90.2913 392.738 89.9263 393.948C89.5282 395.257 89.1135 396.865 88.6324 398.739C88.1347 400.612 87.6205 402.751 87.1062 405.138C84.9663 414.653 82.677 427.948 81.0513 442.736C79.4256 457.523 78.6957 470.984 78.6293 480.731C78.5796 485.605 78.6791 489.551 78.7952 492.269C78.8782 493.546 78.9445 494.574 78.9943 495.402C79.0772 496.132 79.1104 496.497 79.1436 496.497Z\" fill=#263238 /><path d=\"M79.2105 470.538C79.2769 470.538 79.2603 469.378 79.194 467.256C79.0778 465.15 78.7792 462.117 78.182 458.387C77.5516 454.673 76.6725 450.247 75.2956 445.456C74.6984 443.268 73.2883 438.013 69.8877 430.155C65.4087 419.512 59.3041 410.826 53.9957 405.438C52.7515 404.012 51.3747 402.985 50.2632 401.973C49.6826 401.493 49.1849 401.012 48.6707 400.631C48.1564 400.266 47.6753 399.934 47.2274 399.636C45.4856 398.442 44.5069 397.812 44.4737 397.879C44.3244 398.094 48.3887 400.481 53.5146 405.935C58.6239 411.389 64.5461 420.026 69.0085 430.57C71.4968 436.289 73.222 441.395 74.4496 445.721C75.8762 450.479 76.8052 454.839 77.5185 458.519C78.1986 462.216 78.5802 465.217 78.829 467.305C79.0115 469.378 79.1442 470.538 79.2105 470.538Z\" fill=#263238 /><path d=\"M54.1123 516.342L56.7002 551.983H102.535L105.139 516.342H54.1123Z\" fill=#263238 /><path d=\"M110.614 502.281H49.6836V516.339H110.614V502.281Z\" fill=#263238 /><path d=\"M49.6836 550.621V554.517H52.5369H109.602V550.621H49.6836Z\" fill=#455A64 /><path d=\"M55.3387 561.363L52.5352 554.517H107.411L104.143 561.363H55.3387Z\" fill=#455A64 /><path d=\"M104.277 527.991C104.293 528.007 104.21 528.107 104.061 528.322C103.878 528.571 103.646 528.869 103.381 529.234C102.734 530.063 101.838 531.207 100.71 532.649L100.594 532.798L100.478 532.632C98.8022 530.312 96.5627 527.212 93.9251 523.565H94.3066C92.3492 526.333 90.176 529.4 87.8536 532.699L87.6545 532.981L87.4223 532.715C85.0335 529.881 82.4457 526.814 79.7583 523.614H80.2062C80.0735 523.78 79.9242 523.962 79.7915 524.145C77.4193 527.112 75.1134 529.997 72.9403 532.715L72.7081 532.997L72.4924 532.699C70.17 529.416 67.9968 526.35 66.0394 523.565L66.4209 523.581C63.2359 527.212 60.5319 530.278 58.4583 532.632L58.309 532.798L58.2095 532.616C57.1644 530.859 56.3183 529.45 55.7211 528.438C55.4557 527.991 55.2567 527.609 55.0742 527.328C54.9415 527.079 54.8586 526.93 54.8752 526.93C54.8917 526.93 54.9747 527.046 55.1406 527.278C55.3231 527.56 55.5553 527.908 55.8539 528.355C56.4843 529.35 57.3634 530.726 58.4749 532.467L58.2261 532.45C60.2665 530.063 62.9207 526.946 66.056 523.283L66.255 523.051L66.4375 523.299C68.4116 526.068 70.6179 529.118 72.9569 532.384L72.5256 532.367C74.6987 529.632 76.9879 526.764 79.3601 523.78C79.5094 523.598 79.6421 523.415 79.7749 523.25L79.9905 522.984L80.2228 523.25C82.9102 526.449 85.4814 529.532 87.8536 532.367L87.4223 532.384C89.7779 529.101 91.9676 526.035 93.9417 523.299L94.1407 523.034L94.3232 523.299C96.9111 526.98 99.1008 530.113 100.743 532.467H100.511C101.689 531.058 102.618 529.947 103.281 529.135C103.58 528.786 103.829 528.505 104.028 528.273C104.177 528.074 104.277 527.974 104.277 527.991Z\" fill=#E0E0E0 /><path d=\"M105.772 516.105C105.772 516.271 94.2926 516.387 80.1258 516.387C65.959 516.387 54.4795 516.254 54.4795 516.105C54.4795 515.956 65.959 515.823 80.1258 515.823C94.2926 515.823 105.772 515.939 105.772 516.105Z\" fill=#455A64 /><path d=\"M108.092 554.9C108.092 555.066 95.6171 555.182 80.2227 555.182C64.8283 555.182 52.3535 555.049 52.3535 554.9C52.3535 554.751 64.8283 554.618 80.2227 554.618C95.6005 554.618 108.092 554.734 108.092 554.9Z\" fill=#263238 /><path d=\"M25.2229 140H21.0029V154.23H25.2229V140Z\" fill=white /><path d=\"M30.2305 149.225V145.005H16.0005V149.225H30.2305Z\" fill=white /></g><defs><filter id=filter0_d_3325:20386 x=21 y=233 width=309 height=136 filterUnits=userSpaceOnUse color-interpolation-filters=sRGB><feFlood flood-opacity=0 result=BackgroundImageFix /><feColorMatrix in=SourceAlpha type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=hardAlpha /><feMorphology radius=2 operator=dilate in=SourceAlpha result=effect1_dropShadow_3325:20386 /><feOffset dy=4 /><feGaussianBlur stdDeviation=2 /><feComposite in2=hardAlpha operator=out /><feColorMatrix type=matrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0\"/><feBlend mode=normal in2=BackgroundImageFix result=effect1_dropShadow_3325:20386 /><feBlend mode=normal in=SourceGraphic in2=effect1_dropShadow_3325:20386 result=shape /></filter><clipPath id=clip0_3325:20386><rect width=360 height=640 fill=white /></clipPath><clipPath id=clip1_3325:20386><rect width=1742 height=562 fill=white transform=\"translate(-492 15)\"/></clipPath></defs></svg></div></div>");
$templateCache.put("app/courses/allcourses.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=container style=\"height: 200px\"><div class=categories-list><div class=row><div class=col-md-12><h2>{{isFree ? \'Free\' : \'All\'}} Courses</h2></div></div></div><div class=filter-div style=margin-top:-30px;z-index:2><form action=#><div class=main-search><div class=header-filter><div class=\"form-control-alternative filter-button\" ng-click=openFilter()><i class=\"fa fa-filter\" aria-hidden=true></i><!-- <i :class=\"icon\" aria-hidden=\"true\"></i> --> <span class=filter-name>{{filterName}}</span> <i class=\"fa fa-angle-down\" aria-hidden=true style=\"float: right\"></i></div><div ng-if=filterDropDown class=filter-drop-down><ul style=\"padding-top:5px; height: 250px; overflow: scroll\"><li ng-click=\"searchByFilter(-1, \'All\')\"><div class=\"form-group form-check filter-li\" style=\"margin-top: 5px; margin-bottom: 5px\"><label class=form-check-label style=\"margin-bottom: 0px\" for=filterAlltime>All</label></div></li><li ng-repeat=\"tag in tags\" ng-click=\"searchByFilter(tag.id, tag.name)\"><div class=\"form-group form-check filter-li\" style=\"margin-top: 5px; margin-bottom: 5px\"><label class=form-check-label style=\"margin-bottom: 0px\" for=filterAlltime>{{tag.name}}</label></div></li></ul></div></div></div></form></div><div class=filter-div style=margin-top:20px;z-index:1><div class=main-search><div class=header-filter style=\"margin-top: 10px\"><div class=\"form-control-alternative filter-button\" style=\"padding: 9px !important\"><!-- <i :class=\"icon\" aria-hidden=\"true\"></i> --> <input type=text class=form-control id=searchinput ng-model=searchCourse placeholder=\"Search Course\" ng-keyup=updateSomeInput($event) style=\"background: transparent; border: 0px !important\"></div><div ng-if=\"searchFilterDropDown && searchedResults.length > 0\" class=filter-drop-down><ul style=\"padding-top:5px; max-height: 250px; overflow: scroll\"><li ng-repeat=\"course in searchedResults\" ng-click=searchByCourse(course)><div class=\"form-group form-check filter-li\" style=\"margin-top: 5px; margin-bottom: 5px\"><label class=form-check-label style=\"margin-bottom: 0px\" for=filterAlltime>{{course.name}}</label></div></li></ul></div></div></div><p style=\"text-align: end; margin-top: 15px; color: gray; font-size: 17px\" ng-click=clearSearch()>Clear</p></div></div><div ng-if=\"selectedCourse.length > 0 && !isFree\" infinite-scroll=loadMore() infinite-scroll-distance=1 style=\"margin-top: 80px\"><course-blocks courses=selectedCourse></course-blocks></div><div ng-if=isFree infinite-scroll=loadMore() infinite-scroll-distance=1 style=\"margin-top: 80px\"><div class=categories-list ng-repeat=\"faculty in faculties\"><div class=row style=\"padding: 0 21px\"><div><h2>{{faculty}}</h2></div><course-blocks courses=selectedCourse[faculty]></course-blocks></div><!-- row --></div><!-- category listing --><course-blocks courses=selectedCourse[faculty]></course-blocks></div><div ng-if=\"!loading && selectedCourse.length == 0\" style=\"margin-top: 70px\"><p style=\"text-align: center;color: gray;padding-bottom: 20px\">Oops there is no course in select category</p></div><div ng-if=loading style=\"text-align: center; margin-top: 50px\"><img style=\"height: 80px\" src=images/squares.gif></div><!-- <div class=\"main\">\n    <div class=\"container\">\n\n\n      <div class=\"main-header\">\n        <div class=\"featuredCourses\">\n          <div class=\"col-md-8 col\">\n            <div class=\"content-wrapper\">\n              <h4>Featured Course</h4>\n              <h2 class=\"course-name-title\">{{featuredCourse.name}}</h2>\n              <p class=\"ellipsis short-desc\">{{featuredCourse.description}}</p>\n              <button class=\"button\" ng-click=\"goToCourse(featuredCourse)\">More Information</button>\n            </div>\n          </div>\n          <div class=\"col-md-4 col f-img\">\n            <img class=\"img-responsive\" src=\"{{featuredCourse.image_url}}\" alt=\"\" />\n          </div>\n        </div>\n      </div> \n\n\n    </div>\n  </div> --></div><div class=overlay-body></div>");
$templateCache.put("app/courses/instructor.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=main><div class=container><div class=main-header><div class=row><div class=heading-instructer-page><h1>Instructor</h1><div class=instructer-page-left-img><img ng-src={{instructor.image}}></div><div class=instructer-page-left-info><h2>{{instructor.full_name}}</h2><span>{{instructor.qualification}} </span><span>{{instructor.experience}} Year(s)</span><p>{{instructor.description}}</p></div></div></div><!-- main header --><div class=\"categories-list categories-list-new\"><div class=row style=\"overflow: hidden\"><h2>Courses</h2><ul style=\"list-style-type: none; width: 4000px\"><li class=col ng-click=goToCourse(course) ng-repeat=\"\"><div class=category-list-content><div class=category-img><img class=img-responsive width=100% ng-src={{course.image_url}}></div><div class=course-detail><div class=category-title><span class=uni-name>{{course.institution}}</span><h4 class=course-title>{{course.name}}</h4></div><div ng-hide=true class=rating><ng-rate-it ng-model=course.avg_rating read-only=true></ng-rate-it></div><div class=total-courses>{{course.module_count}} Modules</div></div><!-- course detail --></div></li></ul></div><!-- row --></div></div></div><div class=overlay-body></div></div></div>");
$templateCache.put("app/courses/listing.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><faqs-video institution=institution></faqs-video><div ng-show=showData class=layout><div class=main><div class=container><div class=main-header ng-hide=hideFeaturedCourse><div class=\"col-md-6 col\"><div class=content-wrapper><h4>Featured Course</h4><h2 class=course-name-title>{{featuredCourse.name}}</h2><p class=\"ellipsis short-desc\">{{featuredCourse.description}}</p><button class=button style=margin-left:0px ng-click=goToCourse(featuredCourse)>More Information</button></div></div><div class=\"col-md-6 col f-img\"><p><img class=img-responsive src={{featuredCourse.image_url}} alt=\"\"></p></div></div><!-- main header --><div class=categories-list><h2 style=\"margin-top: 30px!important\">{{selectedCourse[0].faculty}}</h2><course-blocks courses=selectedCourse></course-blocks></div><!-- category listing --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/courses/modules.html","<div class=loader ng-hide=\"showData || showLoader\"><img src=images/squares.gif></div><div ng-show=showData class=layout><course-header course=selectedModule></course-header><div class=main><div class=container><div class=row><div class=\"col-md-3 action-block-col\"><course-cart course=selectedModule></course-cart><div class=sidebar-content><div class=basic-info><ul><li class=edu></li><li class=name></li></ul></div><div class=schedule><div class=time></div><div class=\"download-all-attachments download-all-attachments-chap\" ng-hide=attachments><h3>Notes, PDF’s, Exercises</h3><button ng-click=downloadAttachments()>download all attachments</button></div></div><!-- schedule --></div><!-- sidebar content --></div><!-- col-sm-3 --><div class=col-sm-9><div class=\"content-area mb-50 pt-50\"><div class=description-area ng-attr-dir=\"{{ selectedCourse.id == 954 ? \'rtl\' : \'\' }}\"><p ng-style=\"{\'line-height\': selectedCourse.id == 954 ? \'40px\': \'22px\'}\" class=courDesc ng-bind-html=\"selectedModule.description\n								 | limitTo:numLimit\n								 | to_trusted \"></p><p style=display:inline>{{selectedModule.description.length > 180 && numLimit == 180 ? \'...\' : \'\'}}</p><a ng-if=\"selectedModule.description.length > 180\n								 \" class=readMore-btn ng-click=readMore(selectedModule.description.length)>{{ selectedCourse.id === 954 && readMoreBtn === \'Read more\' ? \'مزید پڑھ\' : (selectedCourse.id === 954 && readMoreBtn === \'Read less\' ? \'کم پڑھیں\' : readMoreBtn) }}</a></div><div class=title-row><h4 class=content-title ng-hide=hideVideos>Videos</h4><!-- <a ng-click=\"goToCourse(selectedCourse)\" class=\"back-link\"> <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n                Go Back</a> --> <a ng-click=goToVelocity(selectedCourse) ng-if=!platform_reactApp class=back-link style=\"font-size: 16px;\n                padding: 8px 20px\"><i class=\"fa fa-external-link\"></i> Open in Velocity Portal</a></div><div class=clearfix></div><div class=panel-group id=accordion ng-hide=hideVideos><div class=\"panel panel-default\" ng-repeat=\"video in videos |\n                orderBy : \'video_no\'\"><div analytics-on analytics-event=ViewedVideo analytics-category=ViewedVideo analytics-label=UserViewedVideo ng-click=showVideo(video) class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#collapseOne><span class=serial-no>{{$index+1}}</span><h4 class=\"panel-title hidden-xs\"><a class=accordion-toggle>{{video.name | limitTo:80}}{{video.name.length > 80 ? \'...\' : \'\'}}</a></h4><h4 class=\"panel-title visible-xs\"><a class=accordion-toggle>{{video.name | limitTo:35}}{{video.name.length > 35 ? \'...\' : \'\'}}</a></h4><span ng-show=\"video.type ==\'quiz\'\" class=\"pull-right quiz-icon\"><img src=\"{{video.session_id ? video.quiz_type == \'daq\' ? \'images/daq_icon.svg\' : \'images/quiz-icon-red.svg\' : \'images/quiz-icon.svg\'}}\" alt=\"\"></span><span ng-show=\"video.type ==\'notes\'\" class=\"pull-right quiz-icon\"><img src=images/Notes-icon.svg alt=\"\"></span><!-- <span ng-hide = \"video.type==\'quiz\'\" class=\"pull-right user-icon\"><img src=\"images/user-attech-icon.png\" alt=\"\"></span> --><p style=float:right>{{video.video_length}}</p></div></div></div><h4 class=content-title ng-hide=hideChapters>Chapters</h4><div class=panel-group id=accordion ng-hide=hideChapters><div class=\"panel panel-default\" ng-repeat=\"chapter in chapters |\n                orderBy: \'chapter_no\'\"><div ng-click=\"collapse($index , chapter.name)\" class=panel-heading ng-if=\"chapter.type !=\'quiz\'\" data-toggle=collapse data-parent=#accordion data-target=#collapseOne><h4 class=\"panel-title hidden-xs\"><a class=accordion-toggle>{{chapter.name | limitTo:80}}{{chapter.name.length > 80 ? \'...\' : \'\'}}</a></h4><h4 class=\"panel-title visible-xs\"><a class=accordion-toggle>{{chapter.name | limitTo:20}}{{chapter.name.length > 20 ? \'...\' : \'\'}}</a></h4></div><div ng-show=\"value == $index\" class=\"panel-collapse collapse in\"><div class=\"panel-body panel-video-chapter\" ng-repeat=\"video\n                    in chapter.videos | orderBy : \'video_no\'\" ng-click=showVideo(video,chapter.chapter_no)><div class=chapter-cont><span>{{$index+1}}</span><p class=\"product-praha hidden-xs\">{{video.name | limitTo:80}}{{video.name.length > 80 ? \'...\' : \'\'}}</p><p class=\"product-praha visible-xs\">{{video.name | limitTo:20}}{{video.name.length > 20 ? \'...\' : \'\'}}</p><p class=video-timer-moduler>{{video.video_length}}</p><span ng-show=\"video.type ==\'quiz\'\" class=\"pull-right quiz-icon\"><img src=\"{{video.session_id ? video.quiz_type == \'daq\' ? \'images/daq_icon.svg\' : \'images/quiz-icon-red.svg\' : \'images/quiz-icon.svg\'}}\" alt=\"\"></span><span ng-show=\"video.type ==\'notes\'\" class=\"pull-right quiz-icon\"><img src=images/Notes-icon.svg alt=\"\"></span><!-- <span ng-hide = \"video.type==\'quiz\'\" class=\"pull-right user-icon\"><img src=\"images/user-attech-icon.png\" alt=\"\"></span> --></div></div></div><div analytics-on analytics-event=ViewedVideo analytics-category=ViewedVideo analytics-label=UserViewedVideo ng-click=showVideo(chapter) ng-if=\"chapter.type ==\'quiz\'\" class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#collapseOne><h4 class=\"panel-title hidden-xs\"><a class=accordion-toggle>{{chapter.name | limitTo:80}}{{chapter.name.length > 80 ? \'...\' : \'\'}}</a></h4><h4 class=\"panel-title visible-xs\"><a class=accordion-toggle>{{chapter.name | limitTo:25}}{{chapter.name.length > 25 ? \'...\' : \'\'}}</a></h4><span ng-show=\"chapter.type ==\'quiz\'\" class=\"pull-right quiz-icon\"><img src=\"{{chapter.session_id ? video.quiz_type == \'daq\' ? \'images/daq_icon.svg\' :  \'images/quiz-icon-red.svg\' : \'images/quiz-icon.svg\'}}\" alt=\"\"></span><!-- <span ng-hide = \"video.type==\'quiz\'\" class=\"pull-right user-icon\"><img src=\"images/user-attech-icon.png\" alt=\"\"></span> --></div></div></div></div><!-- content area --></div><!-- col-sm-9 --></div><!-- ////////////////POP UP ///////////////////////////////////////////////////////--><div class=\"signup-bg flex-view align-items-center\" style=\"overflow: auto\" ng-if=lmsPopup><div class=\"otp-holder flex-view justify-content-around align-items-center flex-direction-col signup-parent\" style=\"width: 100%\"><div style=\"position: absolute; left: 10px; top: 10px\"></div><span class=closeButtonImage style=\"top: 0\" ng-click=closeLms()><img src=./../../images/cross-lms.svg class=cross-icon></span><div class=\"flex-view flex-direction-col\" style=\"height: 100%;\n			  justify-content: center;\n			  width: 100%\"><!-- <div class=\"flex-view justify-content-center\">\n		  <img src=\"./../../images/np-red.svg\"   class=\"otp-image\" style=\"width: 270px;\"/>\n		</div> --><div class=\"flex-view flex-direction-row-col\" style=\"width: 100%;\n			  justify-content: space-around;align-items: center\"><div class=\"flex-view hide-on-small lms-popup justify-content-center\"><img src=./../../images/lms-promo.gif></div><div class=\"flex-view flex-direction-col lms-popup resp-lms justify-content-between\"><h3 class=\"h4-heading fade-in-lms-1\" style=\"position: relative\">We have upgraded to a new and improved study portal.</h3><div class=\"flex-view flex-direction-col otp-options\"><div><label class=\"about-us-body-2 fade-in-lms-4\" style=\"position: relative\">You are being redirected to our newly developed study portal to improve your learning experience with us.</label><div class=\"flex-view flex-direction-col to-hide fade-in-lms-3\" style=\"position: relative\"><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Study Faster</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Easier Navigation</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Progress Tracking</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\">New Quiz Layout and Experience</label></div></div></div><div class=\"flex-view justify-content-center otp-options fade-in-lms-2\" style=\"position: relative\"><button class=\"btn-contained flex-view justify-content-center align-items-center\" style=\"background-color: #f24a00; width: 100%\" ng-click=goToVelocity()><img src=./../../images/external-link.svg style=\"margin-right: 5px\"> CONTINUE TO VELOCITY PORTAL</button></div></div></div></div></div></div><!-- ////////////////POP UP ///////////////////////////////////////////////////--></div><!-- container --></div></div><div class=overlay-body></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative;padding: 40px 15px\"><span class=closeBtn ng-click=closePopup()>x</span><div style=\"min-width: 180px;margin: 20px\"><img src=\"../../images/DownloadPageMonitor 1.svg\"></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px;width: 300px;\n		  display: flex;\n		  justify-content: space-around\"><h3 style=\"margin-bottom: 10px; font-weight: bold\">Continue With Desktop App For Faster Streaming</h3><p>Our app has been developed to help our users view lectures with zero buffering and high quality streaming.</p><div class=\"f-c d-row\" style=\"justify-content: flex-end\"><button class=btn-two ng-click=DownloadApp() style=\"background: #f24a00 !important;\n			  width: 100%\"><img style=\"margin-right: 5px\" src=\"../../images/Icon - Download.svg\"> Download App</button></div></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/courses/product.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showNoModuleMessage class=overlay-error-sms>Module not found</div><div ng-show=showData class=layout><course-header course=selectedCourse ng-if=!isPayment></course-header><div class=main><div class=container><div class=row><div class=\"col-md-3 action-block-col\"><course-cart course=selectedCourse enrolled=enrolled payment=isPayment></course-cart></div><div class=col-md-9 ng-if=!isPayment><div class=\"content-area mb-50 mt-30\"><div class=description-area ng-attr-dir=\"{{ selectedCourse.id == 954 ? \'rtl\' : \'\' }}\"><p class=courDesc ng-bind-html=\"selectedCourse.description | limitTo:numLimit| to_trusted \" ng-style=\"{\'line-height\': selectedCourse.id == 954 ? \'40px\': \'22px\'}\"></p><p style=display:inline>{{selectedCourse.description.length > numLimit ? \'...\' : \'\'}}</p><a ng-if=\"selectedCourse.description.length > 180\n								 \" class=readMore-btn ng-click=readMore(selectedCourse.description.length)>{{ selectedCourse.id === 954 && readMoreBtn === \'Read more\' ? \'مزید پڑھ\' : (selectedCourse.id === 954 && readMoreBtn === \'Read less\' ? \'کم پڑھیں\' : readMoreBtn) }}</a></div><div class=\"module-row col-md-12 mt-20\" ng-show=\"selectedCourse.whatsapp && (coursePurchased.purchased)\"><span>Join Digital classroom group <em>here</em></span> <img src=images/wp-logo.png alt=wp-logo style=\"display: none\"> <a href={{selectedCourse.whatsapp}} target=_blank></a></div><div class=title-row><div class=\"flex-view align-items-center justify-content-between\"><h4 class=content-title>Modules</h4><div><!-- <p id=\"courseInclude\" ng-show=\"course.courseFeature.length > 0\"> This Course includes:</p> --><p id=courseIncludeMobile ng-show=\"selectedCourse.courseFeature.length > 0\" ng-click=courseIncludeDD()><span>This Course Offers</span><img src=../../images/course-cart/down-arrow.svg alt=#></p><div class=mobile-course-include-overlay ng-show=courseTitleAV><div class=mobile-course-include ng:class=\"{ active : courseTitleAV}\"><div class=course-include-title><p>This Course includes:</p><div ng-click=courseIncludeDDClose()><img src=../../../images/course-cart/Vector(1).svg alt=\"\"></div></div><ul ng-show=\"selectedCourse.courseFeature.length > 0\" class=course-feature-list><li ng-repeat=\"cf in selectedCourse.courseFeature\"><div class=course-feature-header><img class=course-feature-header-img src={{cf.featureId.imageUrl}}> <span>{{cf.featureId.name}}</span></div><div class=course-feature-desc><p>{{cf.featureId.description}}</p></div></li></ul></div></div></div></div><a ng-click=\" goToVelocity(selectedCourse)\" ng-if=!platform_reactApp class=back-link style=\"font-size: 16px;\n							padding: 8px 20px\"><i class=\"fa fa-external-link\"></i> Open in Velocity Portal</a></div><div class=clearfix></div><div class=panel-group id=accordion><div class=\"panel panel-default\" ng-repeat=\"module in modules | orderBy:\n								\'module_no\'\"><!-- ng-click=\"collapse($index)\"  --><div ng-if=!module.disabled ng-click=goToModule(module) class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#collapseOne><span class=serial-no>{{module.module_no}}</span><h4 class=\"panel-title hidden-xs\"><a class=accordion-toggle>{{module.name | limitTo:80}}{{module.name.length > 80 ? \'...\' : \'\'}}</a></h4><h4 class=\"panel-title visible-xs\"><a class=accordion-toggle>{{module.name | limitTo:30}}{{module.name.length > 30 ? \'...\' : \'\'}}</a></h4><span ng-hide=\"module.module_type.free || module.module_type.purchased\n										|| coursePurchased.purchased\" class=price-lbl>{{module.module_type.price}} </span><span ng-show=module.module_type.free class=\"action-button free\">Free</span> <button ng-show=\"(module.module_type.purchased ||\n										coursePurchased.purchased) && !module.module_type.free\" class=\"action-button free hidden-xs\">Purchased</button> <button ng-show=\"(module.module_type.purchased ||\n										coursePurchased.purchased) && !module.module_type.free\" style=\"font-size: 10px !important;margin-top: 0px !important;\n										padding: 0px 5px !important\" class=\"action-button free visible-xs\">{{showFreeText || (module.module_type.accessConfig && platform_reactApp) ? \"Free on App Now\" : \"Paid\"}}<img style=\"width: 14px;\n										height: 14px;\n										margin-bottom: 3px;\n										margin-left: 3px\" ng-if=\"showFreeText || (module.module_type.accessConfig && platform_reactApp)\" src=../../images/ribbon-alert.gif></button></div></div></div><!-- <p ng-show=\"selectedCourse.special\" class=\"courDesc\"\n							ng-bind-html=\"selectedCourse.description | to_trusted\"></p> --></div><!-- content area --></div></div></div><!-- container --></div></div><div class=overlay-body></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative;padding: 40px 15px\"><span class=closeBtn ng-click=closePopup()>x</span><div style=\"min-width: 180px;margin: 20px\"><img src=\"../../images/DownloadPageMonitor 1.svg\"></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px;width: 300px;\n		  display: flex;\n		  justify-content: space-around\"><h3 style=\"margin-bottom: 10px; font-weight: bold\">Continue With Desktop App For Faster Streaming</h3><p>Our app has been developed to help our users view lectures with zero buffering and high quality streaming.</p><div class=\"f-c d-row\" style=\"justify-content: flex-end\"><button class=btn-two ng-click=DownloadApp() style=\"background: #f24a00 !important;\n			  width: 100%\"><img style=\"margin-right: 5px\" src=\"../../images/Icon - Download.svg\"> Download App</button></div></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/courses/schools.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><faqs-video institution=institution></faqs-video><div ng-show=showData class=layout><div class=main><div class=container><div class=main-header ng-hide=hideFeaturedCourse><div class=row><div class=\"col-md-6 col\"><div class=content-wrapper><h4>Featured Course</h4><h2 class=course-name-title>{{featuredCourse.name}}</h2><p class=\"ellipsis short-desc\">{{featuredCourse.description}}</p><button class=button style=margin-left:0px ng-click=goToCourse(featuredCourse)>More Information</button></div></div><div class=\"col-md-6 col f-img\"><p><img src={{featuredCourse.image_url}} alt=\"\"></p></div></div></div><!-- main header --><div class=categories-list ng-repeat=\"school in schools\"><div class=row><div><h2>{{school.name}}</h2></div><course-blocks courses=school.courses></course-blocks></div><!-- row --></div><!-- category listing --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/courses/tagCourses.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=main><div class=container><div class=categories-list><div class=row><div><h2>{{tag.name}}</h2></div><course-blocks courses=courses></course-blocks></div><!-- row --></div><!-- category listing --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/formLinkCheck/formLinkCheck.html","<div class=\"col-md-12 mb-50 ng-scope\" style=\"display: flex; justify-content: center\" ng-if=iframeLink><iframe id=form-iframe src={{iframeLink}} style=\"margin-top: 20px\" width=640 height=947 frameborder=0 marginheight=0 marginwidth=0>Loading…</iframe></div>");
$templateCache.put("app/css/css.html","<div class=\"landing-new landing-new-mdcat css\"><faqs-video institution=institution></faqs-video><div class=landing-new-cont><div class=landing-static-heading><h1>Civil Service is a Prestige</h1><h2>Helping you achieve what you deserve</h2><ul><li>Top Faculty</li><li>24/7 Accessible video lectures</li><li>Study anywhere, anytime</li><li>Teachers access</li><li>Lecture Notes</li><li>Guidance at every step</li></ul><button ng-hide=isGuest ng-click=cssbuy()>Buy Now</button> <button class=go-to-courses ui-sref=\"schools({institutionName: \'css\'})\">Go to courses</button></div></div></div><addtocart course=bundleData></addtocart><div class=mdcat-lect-slider><div class=container><div class=inner-container><div class=row><div class=stories-top><h1>All the Lectures in your Pocket</h1></div></div><div class=row><div class=slide-cont><div class=\"slidee mdcat-slider slide-animation\" ng-repeat=\"video in videos\" ng-hide=!isCurrentSlideIndex($index)><div class=col-sm-8 style=height:350px><video-player-sat poster={{video.poster}} url={{video.src}} textid={{video.id}} height=285px></video-player-sat><a class=\"arrow prev\" ng-click=nextSlide()>n</a> <a class=\"arrow next\" ng-click=prevSlide()>p</a><nav class=nav><div class=wrapper><ul class=slider-dots><li class=dot ng-repeat=\"slide in videos\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);></a></li></ul></div></nav></div><div class=col-sm-4><div class=\"btn-practice-quiz css-practice-quiz pull-right\"><button class=view-more-new ui-sref=course_module({{video.viewMore}})>View more videos</button></div></div></div></div></div></div></div></div><div class=css-courses><div class=landing-new-cont><div class=row><div class=\"col-xs-12 col-sm-4 col-mg-4 col-lg-4\"><div class=block><div class=icon><img src=images/css-icon02.png alt=\"\"></div><div class=text><p>Study courses along<br>with your job</p></div></div></div><div class=\"col-xs-12 col-sm-4 col-mg-4 col-lg-4\"><div class=block><div class=icon><img src=images/css-icon01.png alt=\"\"></div><div class=text><p>Study courses while you’re<br>still a student</p></div></div></div><div class=\"col-xs-12 col-sm-4 col-mg-4 col-lg-4\"><div class=block><div class=icon><img src=images/css-icon03.png alt=\"\"></div><div class=text><p>Study courses if you belong<br>to small/rural cities</p></div></div></div></div></div></div><div class=\"teams-meet whatsapp-classroom\"><div class=sat-cont><h1>How Will You Learn?</h1><mdcat-slider instructors=csslearningslider></mdcat-slider></div></div><div class=\"full-mdcat full-css\"><div class=sat-cont><div class=full-mdcat-inner><h1>CSS Compulsory Package</h1><h2>Get all 6 subjects for 1 academic year at a discounted price of</h2><h3>Rs. 44,000 only</h3><button ng-click=cssbuy()>Buy Now</button> <button class=how-to-buy ng-click=\"goToState(\'paymentOptions\')\">How to buy</button></div><div class=\"full-mdcat-inner css-inner\"><h1>Facebook Study Group</h1><h2>For free CSS resources. Daily articles, questions, webinars, news, and more…</h2><a class=join-now href=https://bit.ly/2Qv9in1 target=_blank>Join Now</a></div></div></div><!-- <div class=\"stories landing-new-mdcat\">\n    <div class=\"container\">\n      <div class=\"stories-top text-center\">\n        <h1>Success Stories</h1>\n        <p>Hear from our past students</p>\n      </div>\n      <div class=\"sat-cont\">\n        <div class=\"cp-container student-slide-container slider\">\n          <div class=\"slide-cont\">\n            <div\n            ng-repeat=\"instructor in stories\"\n            class=\"slidee slide-animation\"\n            ng-hide=\"!isCurrentSlideIndex($index)\">\n            <div class=\"slide-info\">\n              <h6>\n                <span class=\"first\">\n                </span>\n                {{instructor.description}}\n                <span class=\"last\">\n                </span>\n              </h6>\n              <h2>{{instructor.name}}</h2>\n              <p>{{instructor.qualification}}</p>\n            </div>\n\n          </div>\n          <a class=\"arrow prev\" ng-click=\"nextSlide()\">n</a>\n          <a class=\"arrow next\" ng-click=\"prevSlide()\">p</a>\n          <nav class=\"nav\">\n            <div class=\"wrapper\">\n              <ul class=\"dots\">\n                <li class=\"dot\" ng-repeat=\"slide in slides\">\n                  <a href=\"#\" ng-class=\"{\'active\':isCurrentSlideIndex($index)}\"\n                  ng-click=\"setCurrentSlideIndex($index);\">{{slide.description}}</a></li>\n                </ul>\n              </div>\n            </nav>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"bottom-link-blog-more\">\n      <a href=\"https://www.nearpeer.org/blog/72\" target=\"_blank\">Learn more from our Blogs</a>\n    </div>\n  </div> --><div class=\"teams-meet css-team\"><div class=sat-cont><h1>Meet Your Instructors</h1><mdcat-slider instructors=cssInstructor></mdcat-slider></div></div><div class=\"faqs-mdcat landing-new-mdcat\" style=background:#eeeeee><div class=sat-cont><div class=stories-top><h1>Frequently Asked Questions (FAQs)</h1></div><div class=panel-group id=faqAccordion><div class=\"panel panel-default\" ng-repeat=\"faq in cssfaqs\"><div class=\"panel-heading accordion-toggle question-toggle collapsed\" data-toggle=collapse data-parent=#faqAccordion data-target=#question{{$index}}><h4 class=panel-title><a href=# class=ing>Q: {{faq.question}}</a></h4></div><div id=question{{$index}} class=\"panel-collapse collapse\" style=\"height: 0px\"><div class=panel-body><h5><span class=\"label label-primary\">Answer</span></h5><p ng-bind-html=\"faq.answer  | to_trusted\"></p></div></div></div></div></div></div><div class=\"mdcat-contact mb-30\"><div class=sat-cont><h1>Contact us</h1><ul><li><a href=http://m.me/nearpeer.org target=_blank><img src=images/connect-on-messenger.jpg alt=\"\"></a></li><li><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=_blank><img src=images/connect-on-whatsapp.jpg alt=\"\"></a></li></ul></div></div>");
$templateCache.put("app/instructor_panel/instructor_panel.html","<div class=instrucor-header-new><div class=instrucor-header-cont><div class=menu-items-intruction style=\"display: flex\"><div class=ip-sidebar-mbl style=\"margin: auto 0px\" id=dropdownIcon><button class=\"navCheck btn btn-primary\" ng-click=openSideMenu() type=button data-toggle=collapse data-target=#collapseExample aria-expanded=true aria-controls=collapseExample><i class=\"fa fa-bars\" aria-hidden=true></i></button></div><!-- <div class=\"ip-sidebar-mbl\" style=\"margin:auto 0px;padding-left:14px;\">\n        <img src=\"../../images/ip-logo-blue.svg\" style=\"width: 120px;height: 50px;\">\n      </div> --><div class=\"ip-background-color-fix ip-sidebar-web ip-page-name\" style=\"padding-left: 260px\">{{currPage}}</div><div class=right-user-panel style=\"display: flex;margin-right: 0px;margin-left: auto\"><div id=facultydropdown class=\"dropdown two\" ng-hide=hideFaculty style=\"background-color: #fff;z-index: 9;width: 238px\"><button style=\"max-width: 100%;padding-right: 5px;display: flex;width: 100%\" class=p type=button ng-click=openFaculty()><div style=\"width: 100%;display: flex;justify-content: flex-end\"><div><h3 class=h3Tag>{{selectedInstitution}}</h3><h3 class=h3Tag>{{selectedFaculty}}</h3></div><div><span class=button-cart></span></div></div></button><div ng-show=facultyDropdown style=\"z-index: 9;background-color: #fff\"><ul class=ip-boxshadow style=\"min-width: 200px;max-height: 325px;overflow: auto\"><li ng-repeat=\"data in instructorData track by $index\" class=ip-facultyDropdown style=\"padding: 10px 0px\"><a style=\"background-color: #fff;text-align: left\" ng-click=updateFaculty(data.institution,data.faculty,$index)>{{data.institution}}<br>{{data.faculty}}</a></li></ul></div></div><div id=logoutDropdown style=\"width: 70px\"><button style=padding-left:10px class=\"p account-icon\" type=button ng-click=openLogout() aria-haspopup=true aria-expanded=true><img ng-src={{userInfo.image}} style=\"width: 40px;height: 40px; border-radius: 50%;margin-top: 15px\"><!-- {{instructorName | limitTo:12}} --></button><div ng-show=logoutDropdown class=\"ip-boxshadow ip-p-0\" style=\"display: flex;position: absolute;right: 0px;z-index: 9;background: #fff\"><div style=\"width: 250px;display: block;padding: 10px 20px\"><div class=ip-sidebar-user-avatar><img ng-if=userInfo.image src={{userInfo.image}} alt=\" user avatar\"> <img ng-if=!userInfo.image src=../../images/male-dp.svg alt=\" user avatar\"></div><div style=\"padding: 10px 0px;\n              font-size: 16px;\n              text-transform: capitalize\">{{userInfo.full_name || userInfo.name}}</div><ul><li class=ip-sidebar-user-email ng-if=userInfo.email><p>{{(userInfo || {}).email}}</p></li><li style=\"padding-top: 10px;text-align: left\">User ID: {{(userInfo || {}).id}}</li><li style=\"padding-top: 10px;text-align: left\" ng-show=userInfo.phone>Phone No: {{(userInfo || {}).phone}}</li><li style=\"padding-top: 10px;text-align: left\"><a ui-sref=InstructorPanelMyProfile ng-click=openLogout()><b>View profile</b></a></li><li style=\"padding-top: 10px;text-align: center;background: #f1f8fe;margin: 10px -20px -20px;padding-bottom: 10px\" ng-click=logOut()><img src=../../images/signout-icon.svg alt=\"\"> Sign Out</li></ul></div></div></div></div></div></div></div><div class=overlay-box-intr ng-hide=\"showData || stateName==\'InstructorPanelStudentsQuestions\'\"><img src=images/nearpeer-loading.gif></div><div style=\"display: inline-flex;width:100%\"><div class=\"ip-container ip-sidebar-web\"><div class=ip-sidebar style=\"margin-top: 16px\"><div><div style=\"padding-bottom: 12px;padding-left:14px\"><img src=../../images/ip-logo.svg style=\"width: 180px;height: 50px\"></div><div class=ip-sidebar-body><a ng-class=\"{active: stateName==\'InstructorPanelDashboard\'}\" ng-click=\"goToState(\'InstructorPanelDashboard\')\"><img src=../../images/ip-layout.svg style=\"width: 20px;height: 20px\"> <span>Dashboard</span> </a><a ng-class=\"{active: stateName==\'InstructorPanelAllCourses\' || stateName==\'InstructorPanelCourseNew\' || stateName==\'InstructorPanelCourseEdit\'\n          || stateName==\'InstructorPanelModuleNew\'  || stateName==\'InstructorPanelModuleEdit\'  || stateName==\'InstructorPanelVideo\'}\" ng-click=\"goToState(\'InstructorPanelAllCourses\')\"><img src=../../images/ip-book-open.svg style=\"width: 20px;height: 20px\"><span>Courses</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelEnrolledStudents\'}\" ng-click=\"goToState(\'InstructorPanelEnrolledStudents\')\"><img src=../../images/ip-users.svg style=\"width: 20px;height: 20px\"> <span>Enrolled Students</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelTransactions\' }\" ng-click=\"goToState(\'InstructorPanelTransactions\')\"><i class=\"fa fa-exchange\" aria-hidden=true style=\"font-size: 20px;color:#ffffff\"></i> <span>Transactions</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelComments\'}\" ng-click=\"goToState(\'InstructorPanelComments\')\"><i class=\"fa fa-comments-o\" aria-hidden=true style=\"font-size: 20px;color:#ffffff\"></i> <span>Comments</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelQuizDashboard\' || stateName == \'InstructorPanelQuizNew\' || stateName == \'InstructorPanelQuizEdit\'}\" ng-click=goToQuizCenter()><img src=../../images/ip-quizzes.svg style=\"width: 20px;height: 20px\"> <span>Quizzes</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelStudentsQuestions\'}\" ng-click=\"goToState(\'InstructorPanelStudentsQuestions\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Students Questions <span class=question-circle>{{unansweredQuestions ? unansweredQuestions : 0 }}</span></span></a> <a ng-class=\"{active: stateName==\'InstructorAssignments\'}\" ng-click=\"goToState(\'InstructorAssignments\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Assignments <span class=question-circle>{{unansweredAssignments ? unansweredAssignments : 0 }}</span></span></a> <a ng-class=\"{active: stateName==\'InstructorPanelLiveSession\' || stateName==\'InstructorPanelNewLiveSession\'}\" ng-click=\"goToState(\'InstructorPanelLiveSession\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Live Session</span> </a><a ng-class=\"{active: stateName==\'InstructorPanelDuplicateVideo\'}\" ng-click=\"goToState(\'InstructorPanelDuplicateVideo\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Duplicate Video</span></a></div></div></div></div><div class=ip-popup ng-show=sideBarSelected style=\"justify-content: left\"><div class=\"ip-container ip-sidebar-mbl\" id=sidebarMenu><div class=ip-sidebar><div><div style=\"display: flex;padding-bottom: 12px\"><div style=\"padding-left:14px;margin: auto 0px\"><button class=\"navCheck btn btn-primary\" ng-click=openSideMenu() type=button data-toggle=collapse data-target=#collapseExample aria-expanded=true aria-controls=collapseExample><i class=\"fa fa-bars\" style=color:#fff aria-hidden=true></i></button></div><div style=padding-left:14px><img src=../../images/ip-logo.svg style=\"width: 180px;height: 50px\"></div></div><div class=ip-sidebar-body><a ng-class=\"{active: stateName==\'InstructorPanelDashboard\'}\" ng-click=\"goToState(\'InstructorPanelDashboard\')\"><img src=../../images/ip-layout.svg style=\"width: 20px;height: 20px\"> <span>Dashboard</span> </a><a ng-class=\"{active: stateName==\'InstructorPanelAllCourses\'}\" ng-click=\"goToState(\'InstructorPanelAllCourses\')\"><img src=../../images/ip-book-open.svg style=\"width: 20px;height: 20px\"><span>Courses</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelEnrolledStudents\'}\" ng-click=\"goToState(\'InstructorPanelEnrolledStudents\')\"><img src=../../images/ip-users.svg style=\"width: 20px;height: 20px\"> <span>Enrolled Students</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelTransactions\'}\" ng-click=\"goToState(\'InstructorPanelTransactions\')\"><i class=\"fa fa-exchange\" aria-hidden=true style=\"font-size: 20px;color:#ffffff\"></i> <span>Transactions</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelComments\'}\" ng-click=\"goToState(\'InstructorPanelComments\')\"><i class=\"fa fa-comments-o\" aria-hidden=true style=\"font-size: 20px;color:#ffffff\"></i> <span>Comments</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelQuizDashboard\' || stateName == \'InstructorPanelQuizNew\' || stateName == \'InstructorPanelQuizEdit\'}\" ng-click=goToQuizCenter()><img src=../../images/ip-quizzes.svg style=\"width: 20px;height: 20px\"> <span>Quizzes</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelStudentsQuestions\'}\" ng-click=\"goToState(\'InstructorPanelStudentsQuestions\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Students Questions</span><span class=question-circle>{{unansweredQuestions ? unansweredQuestions : 0 }}</span></a> <a ng-class=\"{active: stateName==\'InstructorAssignments\'}\" ng-click=\"goToState(\'InstructorAssignments\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Assignments</span><span class=question-circle>{{unansweredAssignments ? unansweredAssignments : 0 }}</span></a> <a ng-class=\"{active: stateName==\'InstructorPanelLiveSession\' || stateName==\'InstructorPanelNewLiveSession\'}\" ng-click=\"goToState(\'InstructorPanelLiveSession\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Live Session</span> </a><a ng-class=\"{active: stateName==\'InstructorPanelDuplicateVideo\'}\" ng-click=\"goToState(\'InstructorPanelDuplicateVideo\')\"><img src=../../images/ip-postquestion.svg style=\"width: 20px;height: 20px\"> <span>Duplicate Video</span></a></div></div></div></div></div><ui-view class=ip-background-color-fix></ui-view></div>");
$templateCache.put("app/instructor_panel/instructor_signin.html","<div class=\"instrucor-header-new instrucor-sign-only\"><div class=instrucor-header-cont><div class=logo-instruction><a href=#><img src=images/logo.png alt=\"\"></a></div><div class=right-user-panel><div class=dropdown><button class=\"p dropdown-toggle\" type=button id=dropdownMenu1 data-toggle=dropdown aria-haspopup=true aria-expanded=true>sign in</button><ul class=dropdown-menu aria-labelledby=dropdownMenu1><li><a>My account</a></li><li><a>Log out</a></li></ul></div></div></div></div><div class=instrucor-sign-in><form role=form ng-init=\"loginForm = {}\"><h2>Instructor Sign In</h2><input type=text name=email placeholder=Email ng-model=loginForm.username required> <input type=password name=password placeholder=Password ng-model=loginForm.password required> <button type=submit class=\"btn btn-primary btn-lg\" ng-click=submitLogin(loginForm)>Sign in</button></form></div><div class=instrucor-sign-in style=\"display: none\"><form role=form ng-init=\"loginForm = {}\"><h2>Please provide the folllowing information<br>to complete sign-up</h2><input type=text name=\"Full name  \" placeholder=\"Full name  \" ng-model=loginForm.username required> <input type=text name=\"Phone or Mobile Number\" placeholder=\"Phone or Mobile Number\" ng-model=loginForm.username required> <input type=password name=\"Universty or Institution\" placeholder=\"Universty or Institution\" ng-model=loginForm.password required> <input type=text name=\"Email  (Active)\" placeholder=\"Email  (Active)\" ng-model=loginForm.username required> <input type=password name=password placeholder=Password ng-model=loginForm.password required> <input type=password name=\"Re-type password\" placeholder=\"Re-type password\" ng-model=loginForm.password required> <button type=submit class=\"btn btn-primary btn-lg\" ng-click=submitLogin(loginForm)>Sign up</button></form></div><div ng-show=passwordPopup class=overlay-black></div><div ng-show=\"passwordPopup \" class=\"pop-overlay-home instrucor-sign-in\" id=popup_overlay><h4>Enter New Password</h4><p></p><form ng-submit=submitPassword(passwordForm) ng-init=\"passwordForm = {}\"><input type=password placeholder=Password ng-model=passwordForm.password> <input type=password placeholder=\"Confirm Password\" ng-model=passwordForm.password_confirmation> <button type=submit class=\"btn btn-primary\">Submit</button></form><p></p></div>");
$templateCache.put("app/lead-gen/leadGen.html","<div ng-click=\"searchingTags=false;alert(\'3\')\"><div class=lead-gen style=\"cursor: auto\"><div class=lead-gen-header><div></div><div class=lead-gen-logo><img src=../../images/led-gen/lead-gen-logo.svg alt=#><br><h1>Lead Genration Form</h1></div><div class=\"flex-view align-items-center justify-content-end\"><a class=\"lead-gen-button lead-gen-button-download\" target=_blank href=https://storage.googleapis.com/nps3storage/nearpeer-imagees/205437/example_Lead_Gen_CSV-1646137037540.csv>download demo CSV</a></div></div><div class=lead-gen-main ng-click=\"searchingTags=false;alert(\'1\')\"><form class=lead-gen-form ng-click=\"searchingTags=false;alert(\'2\')\"><div class=form-group><label for=leadGenContact>Contact *</label><input type=text name=leadGenContact id=leadGenContact placeholder=\"Enter Number (contact number is mendatroy)\" ng-model=leadGen.phone> <span class=\"text-danger error\" ng-if=errors.phone>{{errors.phone}}</span></div><div class=form-group><label for=leadGenMarket>Market *</label><select id=leadGenMarket placeholder=\"Enter Number (contact number is mendatroy)\" ng-model=leadGen.market ng-change=getAgents(leadGen.market)><option ng-repeat=\"opt in markets\" value={{opt}}>{{opt}}</option></select><span class=\"text-danger error\" ng-if=errors.market>{{errors.market}}</span></div><div class=form-group><label for=leadGenName>User Name *</label><input type=text name=leadGenName id=leadGenName placeholder=\"Add User Name\" ng-model=leadGen.name> <span class=\"text-danger error\" ng-if=errors.name>{{errors.name}}</span></div><div class=form-group><label for=leadGenEmail>Email</label><input type=email name=leadGenEame id=leadGenEame placeholder=\"Enter Email\" ng-model=leadGen.email> <span class=\"text-danger error\" ng-if=errors.email>{{errors.email}}</span></div><div class=form-group><label for=leadGenAgent>Agent</label><select id=leadGenAgent ng-model=leadGen.agent><option value=\"\">Auto Select</option><option ng-repeat=\"opt in agents\" value={{opt.email}}>{{opt.name}}</option></select><span class=\"text-danger error\" ng-if=errors.agent>{{errors.agent}}</span></div><div class=form-group><label for=leadGenRevenue>Expected Revenue</label><input type=number min=0 name=leadGenRevenue id=leadGenRevenue ng-model=leadGen.revenue></div><div class=form-group><label for=leadGenProbability>Probability</label><input type=number min=0 max=100 step=1 name=leadGenProbability id=leadGenProbability ng-model=leadGen.probability> <span class=\"text-danger error\" ng-if=errors.probability>{{errors.probability}}</span></div><section class=inner><label for=leadGenTags>Tags</label><div class=\"tag-field js-tags\" style=\"position: relative\"><div class=\"tag js-tag\" ng-repeat=\"tag in leadGen.tags\">{{tag}} <span class=\"tag-close js-tag-close\" ng-click=deleteTag($index)>×</span></div><input class=js-tag-input name=leadGenTags id=leadGenTags ng-model=tagsdata ng-keydown=\"($event.keyCode === 13 && addTag($event, tagsdata)) || ($event.keyCode === 8 && deleteTag(leadGen.tags.length - 1))\" ng-click=\"$event.stopPropagation(); $event.preventDefault(); searchingTags = true\" ng-focus=\"searchingTags=true\" ng-change=findTags(tagsdata) placeholder=\"Enter new tag...\" id=textInput autocomplete=off><div class=drop-down-container ng-if=searchingTags><ul><li ng-repeat=\"tag in searchedTags\" class=dropDownList style=\"padding: 10px 20px\" ng-click=\"addTag(null, tag.name)\">{{tag.name}}</li></ul></div></div></section><div class=form-group><label for=leadGenComment>Comment</label><textarea ng-model=leadGen.comment name=leadGenComment id=leadGenComment cols=30 rows=10 placeholder=\"Write Comments\"></textarea></div><div class=\"flex-view align-items-center justify-content-center\"><button ng-class=\"{\'diabled\':postingLead}\" class=\"lead-gen-button lead-gen-button-post\" ng-click=leadGenSuccessfulBtn() ng-disabled=postingLead>{{postingLead ? \'Posting ...\' : \'Post a lead\'}}</button></div><div class=lead-gen-divider><span>OR</span></div><div class=\"flex-view align-items-center justify-content-center\"><!-- <button class=\"lead-gen-button lead-gen-button-uploadcsv\">Reupload csv</button> --><!-- actual upload which is hidden --> <input type=file id=actual-btn hidden accept=.csv ng-model=csv ngf-select=uploadCsv(csv)><!-- <span id=\"file-chosen\">No file chosen</span> --><!-- our custom upload button --><label class=\"lead-gen-button lead-gen-button-uploadcsv\" for=actual-btn ng-class=\"{\'diabled\':uploadingCsv}\" class=\"lead-gen-button lead-gen-button-post\" ng-disabled=uploadingCsv><span id=uploadBtnText>{{uploadingCsv? \'uploadind ...\' : \'upload csv\'}} </span></label></div></form></div></div><div class=lead-gen-popup ng-if=leadGenReuploadCsv><div class=lead-gen-popup-main><div class=lead-gen-popup-close><img src=../../images/led-gen/close-icon.svg alt=#></div><p>Ops.. its seems like you upload an wrong file</p><div class=lead-gen-reupload-csv><img src=../../images/led-gen/reupload-img.svg alt=#></div><button class=\"lead-gen-button lead-gen-button-post\">reupload svg</button></div></div><div class=\"lead-gen-popup leaD-GEN-csv-status\" ng-if=csvStatusShow><div class=lead-gen-popup-main><div class=lead-gen-popup-close ng-click=closeCsvPopup()><img src=../../images/led-gen/close-icon.svg alt=#></div><h2>Csv Upload Successfully</h2><p>Here\'s the details of uploaded data</p><div style=\"max-height: 400px; overflow-y: scroll; margin-bottom: 30px\"><table class=table><thead><tr><th>Lead</th><th>status</th><th>message</th></tr></thead><tbody><tr ng-repeat=\"err in csvStatus\" ng-class=\"{success: !err.error, failed: err.error}\"><td>{{err.name}}</td><td ng-class=\"{success: !err.error, failed: err.error}\">{{err.error ? \'failed\' : \'success\'}}</td><td><span ng-if=err.error>{{err.errorMsg || \'some error occured\'}}</span><span ng-if=!err.error>Success</span></td></tr></tbody></table></div><button class=\"lead-gen-button lead-gen-button-post\" ng-click=closeCsvPopup()>OK</button></div></div><div class=\"lead-gen-popup successfully\" ng-if=leadGenSuccessful><div class=lead-gen-popup-logo><img src=../../images/led-gen/lead-gen-logo.svg alt=#></div><div class=lead-gen-popup-main><div class=lead-gen-reupload-csv><img src=../../images/led-gen/reupload-img.svg alt=#></div><button class=\"lead-gen-button lead-gen-button-post\">Back to oddo</button></div></div></div>");
$templateCache.put("app/loading/loading.html","<div style=\"display: flex; justify-content: center; align-items: center; padding-top: 200px\"><img src=images/squares.gif width=100px height=100px></div>");
$templateCache.put("app/login/login.html","<div class=custom_popup><div class=\"custom_popup_body loginForm\"><div class=custom_popup_header><div ng-click=backForm()><div ng-if=loginBackBtn><img src=../../images/back-icon.svg alt=\"\"></div></div><!-- <span class=\"fa fa-angle-left\" ></span> --> <img src=../../images/email-logo.svg alt=\"NearPeer Logo\"><div ng-click=closeForm()><img src=../../images/cross-icon.svg alt=\"\"></div><!-- <span class=\"close fa fa-times\" ></span> --></div><!-- Login --><div class=popup_main ng-if=login><form><div ng-if=email_Field><div class=popup_title ng-if=!signup><h1>Login to Nearpeer</h1><p><!-- Welcome back! Dear user enter your email here to continue login --> Dear Student, please enter your email or phone here:</p></div><div class=popup_title ng-if=signup><h1>Signup at Nearpeer</h1><p>Let\'s start by providing your email address</p></div><!--  --><div class=\"field-wrapper mb-24\" ng:class=\"{ \'error-border\' : errorMessage}\"><label ng-if=!signup for=email ng:class=\"{ \'error-border-message\' : errorMessage}\">Email or Phone</label><label ng-if=signup for=email>Email</label><div class=field-inner><img src=../../images/email-icon.svg alt=\"\"> <input ng-show=!signup type=text name=email id=loginEmail placeholder=\"nearpeer@gmail.com or 923111444734\" ng-model=loginForm.email_phone ng-keypress=\"($event.keyCode === 13)?checkCredentials(loginForm.email_phone):changetext()\"> <input ng-show=signup type=text name=email id=loginEmail placeholder=email@nearpeer.org ng-model=loginForm.email_phone ng-keypress=\"($event.keyCode === 13)?nextForm(\'email\'):0\"></div></div><p class=create-account-new ng-show=\"!signup && !newUserEmail && !newUserPhone\" ng-click=newCreateAccountPhone()>Create Account?</p><!-- <div class=\"field-wrapper mb-24\" ng-if=\"signup\">\n              <label for=\"email\">Phone</label>\n              <div class=\"field-inner\">\n                <input type=\"text\" id=\"country\" class=\"country-code-dropdown\" >\n  \n                <input\n                  type=\"text\"\n                  name=\"number\"\n                  id=\"number\"\n                  placeholder=\"3312232323\"\n                  ng-model=\"loginForm.phone\"\n                  style=\"    margin-left: 20px;\n                  \"\n                />\n              </div>\n            </div> --><div class=login-loader-cont style=\"padding: 0 0 0 20px\"><div style=\"display: flex;\n            justify-content: space-between;\n            flex-direction: row;\n            width: 100%\"><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=\"text-center mb-24\"><p class=\"new_create-account wow fadeInUp\" style=\"height: 0px; transition: 1s; overflow: hidden\" ng-show=newUserEmail id=newUserEmail ng-click=newCreateAccountEmail(loginForm)>Create Account?</p><p class=\"new_create-account wow fadeInUp\" style=\"height: 0px; transition: 1s; overflow: hidden\" ng-show=newUserPhone id=newUserPhone ng-click=newCreateAccountPhone()>Create Account?</p><button class=popup_button type=button ng-click=\"signup ? nextForm(\'email\') : checkCredentials(loginForm.email_phone)\" :disabled=loader><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader></div></div></button><!-- <p class=\"new_create-account wow fadeInUp\" ng-show=\"!signup && !newUserEmail && !newUserPhone\"  ng-click=\"newCreateAccountPhone()\">Create Account?</p> --></div></div><!-- Signup phone --><div class=popup_main ng-if=\"signup && phone_Field_signup\"><div class=popup_title><h1>Signup at Nearpeer</h1><p ng-show=!oldFlowSignup>It seems that you have never logged-in to Nearpeer with this email address. Don\'t worry, let\'s create an account by adding your phone number</p><p ng-show=oldFlowSignup>Please enter your phone number to continue your journey with us</p><div class=signup-user-email style=\"margin-top: 10px\"><!-- <img src=\"../../images/profile-img.png\" alt=\"Avatar\"> --><p>{{tempEmail}}</p></div></div><form><div class=\"field-wrapper mb-24\"><label for=email>Phone</label><div class=field-inner><!-- <img src=\"../../images/email-icon.svg\" alt=\"\" /> --> <input type=text style=\"width: 50px\" id=country class=country-code-dropdown> <input type=text name=number id=number placeholder=3312232323 ng-model=loginForm.phone ng-keypress=\"($event.keyCode === 13)?checkPhone():0\" style=\"margin-left: 30px\"></div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=\"text-center mb-24\"><button class=popup_button type=button ng-click=checkPhone() :disabled=loader><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></form></div><!-- Sign up password --><div class=popup_main ng-if=\"signup && password_Field_signup\"><div class=popup_title><h1>Create a password</h1><p>Please enter a secure password here to associate it with your account:</p></div><form><div class=\"signup-user-email mb-24\"><!-- <img src=\"../../images/profile-img.png\" alt=\"Avatar\"> --><p>{{userEmail}}</p></div><div class=\"field-wrapper mb-24\"><label for=email>Password</label><div class=field-inner><input type=password name=SignupPassword id=signupassword placeholder=\"\" ng-model=loginForm.password> <i id=signuppasswordIcon class=\"fa fa-eye-slash\" aria-hidden=true ng-click=showPassword()></i></div></div><div class=\"field-wrapper mb-24\"><label for=email>Confirm Password</label><div class=field-inner><input type=password name=confirmPassword id=confirmPassword placeholder=\"\" ng-model=loginForm.confirm_password> <i id=confirmpasswordIcon class=\"fa fa-eye-slash\" aria-hidden=true ng-click=showConfirmPassword()></i></div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=text-center><button class=popup_button type=button ng-click=\"submitSignup(loginForm,\'password\',loginForm.confirm_password)\" ng-disabled=\"disableRegBtn || signupButtonIsDisabled\" ng-show=!guestMode style=\"margin-top: 20px\"><div ng-if=!loader>Create Account</div><div ng-if=loader><div class=login-theme-loader></div></div></button> <button class=popup_button type=button ng-click=\"submitSignup(loginForm,\'password\')\" ng-disabled=\"disableRegBtn || signupButtonIsDisabled\" ng-show=guestMode style=\"margin-top: 20px\"><div ng-if=!loader>Create Account</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></form></div><!-- Login password --><div class=\"password mb-24\" ng-if=\"!signup && password_Field\"><div class=popup_title><h1>Login to Nearpeer</h1><p><span ng-if=\"userName === null\">Dear</span> <span ng-if=\"userName != null\">Welcome back </span><span ng-if=\"userName != null\" style=\"font-weight: bold\">{{userName}}</span>,Please enter your password here:<!-- Please enter the password associated with your\n              account. --></p></div><div class=field-wrapper><label for=email>Password</label><div class=field-inner><img src=../../images/lock-icon.svg alt=\"\"> <input type=password name=password id=password placeholder=\"\" ng-model=loginForm.password ng-keypress=\"($event.keyCode === 13)?submitLogin(loginForm.password,\'password\'):0\"> <i id=passwordIcon class=\"fa fa-eye-slash\" aria-hidden=true ng-click=displayPassword()></i></div></div><div class=\"password-options mb-24 flex-view justify-content-between\"><div class=forget-password ng-click=forgetPasswordBtn()>Forgot Password?</div><div class=skip-password ng-click=skipPasswordBtn()>Log in with OTP</div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=text-center ng-if=login_button><button class=popup_button type=button ng-disabled=loader ng-click=\"submitLogin(loginForm.password,\'password\')\"><div ng-if=!loader>Login</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></div><!-- Social login --><div class=social-logins ng-if=\"social_login \"><div class=\"mb-24 social-login-divider mb-24\"><p>OR</p></div><div class=text-center><button ng-if=!platform_reactApp class=social-button id=glogin ng-click=googleLogin()><img src=\"../../images/Mask Group 82.svg\" alt=#> Log in with Google</button> <button ng-if=platform_reactApp class=social-button ng-click=googleForReact()><img src=\"../../images/Mask Group 82.svg\" alt=#> Log in with Google</button></div><div class=text-center><button ng-if=!platform_reactApp class=social-button ng-click=authenticateFacebook()><img src=../../images/f-blue.svg alt=#> Log in with Facebook</button> <button ng-if=platform_reactApp ng-click=facebookForReact() class=social-button><img src=../../images/f-blue.svg alt=#> Log in with Facebook</button></div><div class=text-center><button ng-if=!platform_reactApp class=social-button ng-click=authenticateApple()><img src=../../images/apple-black.svg alt=#> Log in with Apple</button> <button ng-if=platform_reactApp class=social-button ng-click=appleForReact()><img src=../../images/apple-black.svg alt=#> Log in with Apple</button></div><!-- <div class=\"text-center\" ng-if=\"!guestMode\"    style=\"margin-bottom: 0\">\n            <button class=\"social-button\" ng-click=\"enterAsGuest()\">\n              <img src=\"../../images/guest.svg\" style=\"width: 18px;\n              height: 18px;\" alt=\"#\" /> Log in as Guest\n            </button>\n          </div> --></div></form></div><!-- Forget Password --><div class=popup_main ng-if=forget_password><div class=popup_title><h1>Forgot Password</h1><p style=\"margin: 15px 0 25px\">Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p><p>Rest assured that we will never send your password via email.</p></div><form><div class=\"field-wrapper mb-32\"><label for=email>Email</label><div class=field-inner><i class=\"fa fa-envelope\" aria-hidden=true></i> <input type=text name=email id=email placeholder=Email@xyz.com ng-model=userEmail></div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><div class=\"text-center mb-24\"><button class=popup_button type=button ng-click=sendInstructionBtn(userEmail)><div ng-if=!loader>Send Reset Instructions</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></form></div><!-- Instructions Message --><div class=\"popup_main d-none\"><div class=popup_title><h1>Instructions Message</h1><p style=\"margin: 25px 0\">Instructions for resetting your password have been sent to <b>maazhaider21@gmail.com.</b></p><p>You’ll receive the email in no time. Be sure to check your email’s spam folder, too.</p></div></div><!-- OTP --><div class=popup_main ng-if=skip_password><div class=popup_title><h1>Login to Nearpeer</h1><p>Dear user choose a method through which you want to receive OTP and continue your login without password.</p></div><form><div class=\"field-wrapper-otp mb-24\" ng-if=userEmailHidden><div class=field-inner><div style=\"display: flex;\n         align-items: baseline\"><i class=\"fa fa-envelope\" aria-hidden=true></i><p class=otp_em_limit ng-model=userEmailHidden>{{userEmailHidden}}</p></div><!-- /> --><div class=text-center><button ng-click=\"sendOtp(\'email\')\">Send OTP</button> <span>Via email</span></div></div></div><div class=\"field-wrapper-otp mb-24\" ng-if=userPhone><div class=field-inner><div style=\"display: flex;\nalign-items: baseline\"><img src=../../images/whatsapp.svg alt=\"nearpeer whatsapp\" width=16 height=16 style=\"margin-right: 15px\"><p>{{userPhoneHidden}}</p></div><div class=text-center><button ng-click=\"sendOtp(\'phone\')\">Send OTP</button> <span>Via Whatsapp</span></div></div></div></form></div><!-- OTP Code --><div class=popup_main ng-if=Otp_code><div class=popup_title><h1>Please enter the OTP sent to you.</h1><p>An OTP is sent to your <span ng-if=phoneSelected>{{userPhoneHidden}}</span> <span ng-if=!phoneSelected>{{userEmailHidden}}</span> .Please enter the code to login:</p></div><div class=\"field-wrapper-otpCode mb-24\"><div class=field-inner><!-- <input\n              type=\"text\"\n              ng-paste=\"onPasteOTP($event, 1)\"\n              name=\"digit-1\"\n              id=\"digit-1\"\n              maxlength=\"1\"\n              placeholder=\"\"\n              ng-model=\"digit1\"\n              data-next=\"digit-2\"\n              ng-keyup=\"keytab($event, 1)\"\n            /> --><form method=get data-group-name=digits data-autosubmit=false autocomplete=off style=\"display: flex\"><input type=text maxlength=1 id=digit-1 name=digit-1 data-next=digit-2 ng-model=digit1 ng-keyup=\"keytab($event, 1)\"> <input type=text maxlength=1 name=digit-2 id=digit-2 ng-model=digit2 ng-keyup=\"keytab($event, 2)\" data-next=digit-3 data-previous=digit-1> <input type=text name=digit-3 id=digit-3 ng-model=digit3 ng-keyup=\"keytab($event, 3)\" data-next=digit-4 data-previous=digit-3 maxlength=1> <input type=text name=digit-4 id=digit-4 ng-model=digit4 ng-keyup=\"keytab($event, 4)\" data-next=digit-5 data-previous=digit-4 maxlength=1> <input type=text name=digit-5 id=digit-5 ng-model=digit5 ng-keyup=\"keytab($event, 5)\" data-next=digit-6 data-previous=digit-5 maxlength=1> <input type=text name=digit-6 id=digit-6 ng-model=digit6 ng-keyup=\"keytab($event, 6)\" data-next=digit-7 data-previous=digit-5 maxlength=1></form></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><!-- <div class=\"field-inner\">\n    \n            </div> --></div><div class=\"password-options resend-code flex-view flex-direction-col align-items-center justify-content-between mb-24\"><div class=skip-password ng-click=\"sendOtp(phoneSelected ? \'phone\' : \'email\',\'resend\')\">Resend code on SMS</div><div class=\"skip-password mt-10\" ng-click=\"sendOtp(phoneSelected ? \'whatsapp\' : \'email\',\'resend\')\">Resend code on Whatsapp</div></div><div class=text-center><button class=popup_button type=button ng-click=sendOTPConfirmation(digit1,digit2,digit3,digit4,digit5,digit6)><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></div><!-- Wrong OTP Code --><div class=popup_main ng-if=wrong_Otp_code><div class=popup_title><h1>Wrong OTP code</h1><p>Dear user you have entered the wrong otp code. Please re-enter the latest otp code again for your verification.</p></div><form method=get data-group-name=digits data-autosubmit=false autocomplete=off><div class=\"field-wrapper-otpCode mb-24\"><div class=field-inner><!-- <input\n              type=\"text\"\n              ng-paste=\"onPasteOTP($event, 1)\"\n              name=\"digit-1\"\n              id=\"digit-1\"\n              maxlength=\"1\"\n              placeholder=\"\"\n              ng-model=\"digit1\"\n              data-next=\"digit-2\"\n              ng-keyup=\"keytab($event, 1)\"\n            /> --> <input type=text maxlength=1 id=digit-1 name=digit-1 data-next=digit-2 ng-model=digit1 ng-keyup=\"keytab($event, 1 , digit1)\"> <input type=text maxlength=1 name=digit-2 id=digit-2 ng-model=digit2 ng-keyup=\"keytab($event, 2 , digit2)\" data-next=digit-3 data-previous=digit-1> <input type=text maxlength=1 name=digit-3 id=digit-3 ng-model=digit3 ng-keyup=\"keytab($event, 3 , digit3)\" data-next=digit-4 data-previous=digit-3> <input type=text maxlength=1 name=digit-4 id=digit-4 ng-model=digit4 ng-keyup=\"keytab($event, 4 , digit4)\" data-next=digit-5 data-previous=digit-4> <input type=text maxlength=1 name=digit-5 id=digit-5 ng-model=digit5 ng-keyup=\"keytab($event, 5 ,digit5)\" data-next=digit-6 data-previous=digit-5> <input type=text maxlength=1 name=digit-6 id=digit-6 ng-model=digit6 ng-keyup=\"keytab($event, 6,digit6)\" data-next=digit-7 data-previous=digit-5></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><div><!-- <div class=\"login-theme-loader\" ng-if=\"loader\"></div> --></div></div><!-- <div class=\"field-inner\">\n    \n            </div> --></div><div class=\"password-options resend-code flex-view flex-direction-row-col justify-content-between mb-24\"><div class=forget-password></div><div class=skip-password ng-click=\"sendOtp(phoneSelected ? \'phone\' : \'email\',\'resend\')\">Resend code.</div></div><div class=text-center><button class=popup_button type=button ng-click=sendOTPConfirmation(digit1,digit2,digit3,digit4,digit5,digit6)><div ng-if=!loader>Next</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></form></div><!-- Reset password --><div class=\"popup_main d-none\"><div class=popup_title><h1>Reset Password</h1><p>Dear user please create a new password for your Nearpeer account.</p></div><form><div class=\"user-email mb-24\"><img src=../../images/profile-img.png alt=Avatar><p>{{userEmail}}</p></div><div class=\"field-wrapper mb-24\"><label for=email>Password</label><div class=field-inner><input type=password name=resetPassword id=resetPassword placeholder=\"\"></div></div><div class=\"field-wrapper mb-24\"><label for=email>Confirm Password</label><div class=field-inner><input type=password name=confirmPassword id=confirmPassword placeholder=\"\"> <i class=\"fa fa-eye-slash\" aria-hidden=true></i></div></div><div class=text-center><button class=popup_button type=button>Login</button></div></form></div><!-- Reset password notification --><div class=noti_reset ng-if=noti_reset id=hideNotification><img src=../../images/noti-check.png alt=Check><p>OTP sent to<span ng-if=phoneSelected>{{userPhoneHidden}}</span> <span ng-if=!phoneSelected>{{userEmailHidden}}</span></p></div></div></div>");
$templateCache.put("app/mdCat/mdCat.html","<div class=\"landing-new landing-new-mdcat\"><faqs-video institution=institution></faqs-video><div class=landing-new-cont><div class=landing-static-heading><!-- <h1>MDCAT Online</h1> --><h1>The Best Online MDCAT Program</h1><h2>Leading You to Your Dream Medical College</h2><ul><li>1000+ Video Lectures</li><li>25,000+ Practice Questions</li><li>Books and Notes</li><li>Test Sessions</li><li>Past Papers with Solutions</li><li>Multiple Mock Exams</li><li>Monthly Topper\'s Guide</li><li>Preparation according to the updated syllabus</li><li>Regular Live Sessions with Instructors</li><li>Answers to your questions in 5 Seconds</li><li>Up to 95% accurate score prediction, months before exams</li><li>24/7 Access to Student Success Officers</li><li>24/7 Access to Instructors & Community</li></ul><button ng-click=mdcatbuy()>Explore All Courses</button> <button class=how-to-buy ng-click=mdcatGetInTouch()>Connect with the Counselor</button><!-- <a ui-sref=\"schools({institutionName: \'entry-test-preparation\'})\">Go to courses</a>   --></div></div></div><addtocart course=bundleData></addtocart><div class=mdcat-lect-slider><div class=container><div class=inner-container><div class=row><div class=stories-top><h1>All the Lectures in your Pocket</h1></div></div><div class=row><div class=slide-cont><div class=\"slidee mdcat-slider slide-animation\" ng-repeat=\"video in videos\" ng-hide=!isCurrentSlideIndex($index)><div class=col-sm-8 style=height:350px><video-player-sat poster={{video.poster}} url={{video.src}} textid={{video.id}} height=285px></video-player-sat><a class=\"arrow prev\" ng-click=nextSlide()>n</a> <a class=\"arrow next\" ng-click=prevSlide()>p</a><nav class=nav><div class=wrapper><ul class=slider-dots><li class=dot ng-repeat=\"slide in videos\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);></a></li></ul></div></nav></div><div class=col-sm-4><div class=\"btn-practice-quiz pull-right\"><a href={{video.quizUrl}}>{{video.quiz}}</a> <button class=view-more-new ui-sref=Course({{video.viewMore}})>View more videos</button></div></div></div></div></div></div></div></div><div class=\"faqs-mdcat landing-new-mdcat\" style=padding-bottom:80px><div class=sat-cont><div class=stories-top style=padding-top:0px><h1>How are we different from physical academies</h1><!-- <a href=\"#\">more stories</a> --></div><div class=physical-img><img src=images/MDCATcscdscsd.jpg alt=\"\"></div></div></div><div class=\"teams-meet whatsapp-classroom\"><div class=sat-cont><h1>How Will You Learn?</h1><mdcat-slider instructors=mdCatLearn></mdcat-slider></div></div><div class=full-mdcat><div class=sat-cont><div class=full-mdcat-inner><h1 style=\"margin-top: 35px !important\">MDCAT Courses Starting <span>from</span></h1><!-- <h2>Get the Course at a discounted price</h2>\n      <h2 style=\"font-size:25px; text-decoration: line-through;\">\n        Rs. 12,000\n      </h2> --><h3 style=\"margin-top: 30px !important;margin-bottom: 0 !important\">Rs. 3,500/- Only</h3><button ng-hide=isGuest ng-click=mdcatGetInTouch()>Avail Scholarship</button> <button class=how-to-buy ng-click=mdcatGetInTouch()>How to buy</button></div><div class=full-mdcat-inner><h1>Join MDCAT Community Group</h1><h2 style=\"margin-top: 25px !important\">For updated and verified news regarding MDCAT, free resources, questions, books and more...</h2><a class=join-now href=https://nearpeer.org/np-link/sbmhf103pp target=_blank>Join Now</a></div></div></div><div class=\"stories landing-new-mdcat\"><div class=container><div class=\"stories-top text-center\"><h1>Our Happy Students</h1><p>See How Online MDCAT is Helping them</p></div><div class=sat-cont><div class=\"cp-container student-slide-container slider\"><div class=slide-cont><div ng-repeat=\"instructor in stories\" class=\"slidee slide-animation\" ng-hide=!isCurrentSlideIndex($index)><div class=slide-info><h6><span class=first></span> {{instructor.description}} <span class=last></span></h6><h2>{{instructor.name}}</h2><p>{{instructor.qualification}}</p></div></div><a class=\"arrow prev\" ng-click=nextSlide()>n</a> <a class=\"arrow next\" ng-click=prevSlide()>p</a><nav class=nav><div class=wrapper><ul class=dots><li class=dot ng-repeat=\"slide in slides\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);>{{slide.description}}</a></li></ul></div></nav></div></div></div></div><div class=bottom-link-blog-more><a href=https://www.nearpeer.org/blog/72 target=_blank>Learn more from our Blogs</a></div></div><div class=teams-meet><div class=sat-cont><h1>Meet Your Instructors</h1><mdcat-slider instructors=mdCatInstructor></mdcat-slider></div></div><div class=\"faqs-mdcat landing-new-mdcat\" style=background:#eeeeee><div class=sat-cont><div class=stories-top><h1>Frequently Asked Questions (FAQs)</h1></div><div class=panel-group id=faqAccordion><div class=\"panel panel-default\" ng-repeat=\"faq in faqs\"><div class=\"panel-heading accordion-toggle question-toggle collapsed\" data-toggle=collapse data-parent=#faqAccordion data-target=#question{{$index}}><h4 class=panel-title><a href=# class=ing>Q: {{faq.question}}</a></h4></div><div id=question{{$index}} class=\"panel-collapse collapse\" style=\"height: 0px\"><div class=panel-body><h5><span class=\"label label-primary\">Answer</span></h5><p ng-bind-html=\"faq.answer  | to_trusted\"></p></div></div></div></div></div></div><div class=mdcat-contact><div class=sat-cont><h1>Contact us</h1><ul><li><a href=http://m.me/nearpeer.org target=_blank><img src=images/connect-on-messenger.jpg alt=\"\"></a></li><li><a href=https://www.nearpeer.org/np-link/818zhelsa5 target=_blank><img src=images/connect-on-whatsapp.jpg alt=\"\"></a></li></ul></div></div><div class=mdcat-logos-patners><ul><li><a href=http://plan9.pitb.gov.pk/ target=_blank><img src=images/pitb.png alt=\"\"></a></li><!-- <li><a href=\"https://www.ilmkidunya.com/\" target=\"_blank\"> <img src=\"images/ilmki.png\" alt=\"\" /></a></li> --><li><a href=https://lce.lums.edu.pk/ target=_blank><img src=images/nic-lhr.png alt=\"\"></a></li><li><a href=https://shopistan.pk/ target=_blank><img src=images/shopistan-logo.png alt=\"\"></a></li></ul></div>");
$templateCache.put("app/mdCatPayment/mdcatpayment.html","<section class=\"section section-slider bg-gray-light\"><div class=container><div class=\"slide-section text-center\"><header class=slide-heading><h2 class=slide-title-lg>How to Buy Full MDCAT Course</h2><h4 class=slide-title-md>Step By Step Explanation in the Video</h4></header><div class=video-block-sm><video-player-sat poster=/images/mdpayment.png url=qq5GlN3Ed-Q textid=1 height=285px></video-player-sat></div><!-- //.video-block-sm --></div></div></section><section class=section style=\"padding-bottom: 0 !important\"><div class=container><div class=slide-cont><header class=heading-1><h3>How to Pay</h3></header><ul class=list-disc><li>Simply Click “Buy Now”. This will take you to full MDCAT Course page.</li><li>Next, Click Purchase through debit/card (JazzCash).</li><li>This will take you to a “Jazz Cash Payment Portal”</li><li>From the drop-down menu, “Select Voucher Payment” (This is recommended payment method by Nearpeer.org. You can use debit/credit card for purchase to if you want)</li><li>Enter your Mobile Number in the given field, and press pay.</li><li>You’ll receive a sms from JazzCash.</li><li>Next, you go to any nearest JazzCash shop in the market, show this SMS to JazzCash Agent, and pay the course fee.</li><li>Once done with payment, you will receive a sms.</li><li>Send the screenshot of this message via WhatsApp at 03470171480 along with following details:<ul class=list-dash><li>Your name</li><li>City</li><li>Course you want (MDCAT in this case)</li></ul>Our representative will then provide you with access codes you will need to view courses.</li><li>In case of any issue, feel free to WhatsApp/Call on 03470171480</li></ul></div></div></section><payment-methods></payment-methods>");
$templateCache.put("app/notifications/allnotification.html","<div class=noti-main><div class=noti-wrapper><div class=noti-searchbar><div class=noti-search><input type=text ng-model=searchText ng-keyup=\"$event.keyCode === 13 && searchNotifications()\" name=notification_search id=notification_search placeholder=Search> <i class=\"fa fa-search\" aria-hidden=true></i></div><div class=noti-sorting ng-if=isAssignmentNotification><a class=dropdown-toggle href=# role=button id=noti_sort data-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=../../images/sort-by.png alt=#> <span>{{NotiSortingType || \'All Notification\'}}</span> <img src=../../images/sort-arrow.png alt=#></a><div class=\"sort-dropdown dropdown-menu dropdown-menu-left\" aria-labelledby=noti_sort><ul><li><a href=# ng-class=\"{active: NotiSortingType == \'All Notification\'}\" ng-click=\"getNotiSortingType(\'All Notification\');\"><span>All Notification</span> <i class=\"fa fa-check\" aria-hidden=true></i></a></li><li><a href=# ng-class=\"{active: NotiSortingType == \'Assignment\'}\" ng-click=\"getNotiSortingType(\'Assignment\');\"><span>Assignment</span> <i class=\"fa fa-check\" aria-hidden=true></i></a></li></ul></div></div><div class=noti-submit><a href=JavaScript:void(0); class=btn-filled ng-click=\"searchNotifications(); $event.stopPropagation();\">Search</a></div></div><div class=noti-all><div class=noti-all-title><h3><!--<a ng-click=\"goToState(\'Landing\')\" class=\"mobileback\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i></a>--> Notification</h3><a ng-click=\"goToState(\'Landing\')\" class=back-btn><i class=\"fa fa-angle-left\" aria-hidden=true></i> Go Back</a></div><ul class=noti-list infinite-scroll=loadMore() infinite-scroll-distance=0><li ng-repeat=\"notification in notifications\" ng-class=\"{\'read\': notification.is_clicked}\" style=\"background: #fff\"><div class=noti-date ng-if=\"showDate(notification, $index)\">{{showDate(notification, $index)}}</div><div ng-click=clickNotification(notification) class=\"noti-item important\"><div class=noti-all-detail><div class=noti-thumb><img ng-if=!notification.notifications.thumbnail_url src=../../images/Notification_Icon_large.svg alt=#> <img ng-if=notification.notifications.thumbnail_url ng-src={{notification.notifications.thumbnail_url}} alt=#></div><div class=noti-detail><div class=noti-title>{{notification.notifications.title}}</div><div class=noti-shrtdetail>{{notification.notifications.description}}</div><div class=noti-time><span>{{showTime(notification)}}</span><!-- <div class=\"noti-important\">\n                          <span> limited time offer</span>\n                      </div> --></div></div></div><!-- <div class=\"noti-action\">\n                    <a ng-click=\"goToState(\'Single-Notification\')\" class=\"noti-btn\">Avail Offer</a>\n                </div> --></div></li></ul><div ng-if=\"!isLoading && notifications.length === 0\" style=\"display: flex; justify-content: center; padding: 20px\"><p>No recent notification</p></div><span style=\"display: flex; justify-content: center; padding: 20px\" ng-show=isLoading><div class=round-loader></div></span></div></div></div>");
$templateCache.put("app/notifications/singlenotification.html","<div class=noti-main><div class=noti-wrapper><div class=noti-all><div class=noti-all-title><h3><!--<a ng-click=\"goToState(\'All-Notification\')\" class=\"mobileback\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i></a> -->From Notifications</h3><a ng-click=\"goToState(\'All-Notification\')\" class=back-btn><i class=\"fa fa-angle-left\" aria-hidden=true></i>Go Back</a></div><div class=noti-single><div class=row><div class=col-md-8><div class=noti-single-image><img src=../../images/single-image.png alt=#></div></div><div class=col-md-4><div class=noti-single-detail><div class=noti-single-title><h3>20% Off AT MD-CAT</h3><p>limited time offer</p></div><div class=noti-single-desc>its very limited time offer for medical students if you want good marks in MD-Cat go and avail this offer before its ends.</div><div class=noti-single-course><ul><li>1000+ Video Lectures</li><li>50,000+ Practice Questions</li><li>24/7 Access to the Instructor</li><li>Past Papers with Solutions</li><li>Full Length Papers</li><li>Books and Notes</li></ul><a href=# class=noti-btn>Avail Offer</a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/player/player.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData><div class=main-contianer-video-one><div class=\"new-video-page video-box-padding\"><div class=left-panel-video id=left-panel-video><div class=video-rating-popup ng-show=userVideoRating><div class=video-rating-popup-main><h4 ng-hide=userThankYou>Please rate this video</h4><h4 class=last ng-show=userThankYou>Thank You!</h4><ng-rate-it ng-hide=userThankYou ng-model=videoRating cancel-width=1 cancel-height=1 star-height=15 ng-click=rateVideo(videoRating)></ng-rate-it></div></div><div id=video-loader-two><div id=loader-two class=loadder-two><img src=images/videoLoader.gif> <span id=load-perccentage>0%</span></div></div><div class=loadder-two id=play-iccon><img src=images/play-icon.png ng-click=play()></div><div class=cont-video-landing id=cont-video-landing ng-dblclick=dblClick() ng-hide=displayAd><div class=video-overly-info><h3>{{stamp}}</h3><h3>www.nearpeer.org</h3></div><div ng-if=waterMark class=video-marquee><span class=text>{{userInfo}}</span></div><video id=video ng-mousedown=handleClick($event) oncontextmenu=\"return false\" height=480px></video><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=buffered><input class=bufferbar type=range id=buffer-bar value=0 step=0.5 range disabled></div></li><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li><li class=play><a ng-click=play_pause()><img id=playBtn src=images/play-cont.png alt=\"\"><img id=pauseBtn class=pause-icon src=images/pause-icon.png alt=\"\"></a></li><li class=controller-perv><a ng-click=skipRwdVideo(15)><img src=images/perv-cont.png alt=\"\"></a></li><li class=share-info><a>15</a></li><li class=controller-next><a ng-click=skipFwdVideo(15)><img src=images/farwrd-cont.png alt=\"\"></a></li></ul></div><div class=right-panel-video><ul><li class=resize-video><a ng-click=fullScreen()><img id=fullScrBtn src=images/resize-close.png alt=\"\"></a><a ng-click=exitFulScreen()><img id=exitFlScrBtn src=images/resize-back.png alt=\"close full screen\"></a></li><li class=vol><a ng-click=mute()><img id=volBtn src=images/vol-cont.png alt=\"\"><img id=muteBtn class=mute-icon src=images/mute-icon.png alt=\"\"></a><input class=volume type=range id=volume-bar min=0 max=1 step=0.1 value=1></li><li class=playback-rate><div class=play-back-web><p ng-click=showPlaybackOptions()>{{playbackVal}}x</p><ul ng-show=playbackOpt><li ng-click=playBackRate(4)>4x</li><li ng-click=playBackRate(2)>2x</li><li ng-click=playBackRate(1.5)>1.5x</li><li ng-click=playBackRate(1.2)>1.2x</li><li ng-click=playBackRate(1)>1x</li><li ng-click=playBackRate(0.7)>0.7x</li><li ng-click=playBackRate(0.5)>0.5x</li></ul></div></li><li class=time><a><p id=timeLeft></p></a></li></ul></div></div></div></div><div class=\"f-c d-row\" style=\"justify-content: space-between\"><button type=button ng-click=swithToNewPlayer() class=\"btn btn-primary\" style=\"margin-top: 10px\">Switch to new player</button> <button type=button class=fast-stream ng-click=swithToFastStream()><img src=\"../../images/Fast Streaming Icon.svg\"> Try Fast Streaming</button></div><div class=cont-video-landing ng-show=displayAd><video id=video-ad ng-mousedown=handleClick($event) oncontextmenu=\"return false\" height=480px></video><div class=skip-ad ng-click=skipAd()>Skip Ad in<p id=skip-ad-time></p></div><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar-ad value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li></ul></div></div></div></div></div><h2 class=video-name-heading>{{selectedVideo.name}}</h2><h3 class=video-name-heading-sub>{{moduleName}}</h3><h3 class=video-name-heading-views>{{view_count}} VIEWS</h3><div class=video-views-des><h2 ng-hide=!selectedVideo.description>Description</h2><p>{{selectedVideo.description}}</p></div><div class=show-more-video-tagline style=\"display: none\"><h4>SHOW MORE</h4></div><div class=download-all-attachments ng-show=attachments><h3>Notes, PDF’s, Exercises</h3><button ng-click=zipAttachments(selectedVideo.id)>download all attachments</button></div></div><div class=video-ad style=width:30% ng-show=\"showGifAd && !mobileView\"><a href=https://goo.gl/db2BiP target=_blank><img style=width:100% src=images/Illys_sponsorship.gif></a></div><div class=terms ng-if=!showTerm><p>Dear Student, Under Copyright Ordinance 1962 and Prevention of Electronic Crimes Act (“PECA”) 2016, stealing of intellectual property, including on-screen recording, downloading, and sharing of Nearpeer\'s video content is a punishable crime. We encourage our students to stay away from all illegal activities.</p><button class=btn-two ng-click=acceptTerm()>Accept</button></div><div class=playlist><h1>playlist({{noOfVideos}} videos)</h1><ul id=testDiv ui-sortable ng-model=videos><li class=playlist-item ng-repeat=\"video in videos | orderBy : \'video_no\'\"><a ng-click=showVideo(video)><div class=playlist-left><img ng-src={{video.image_url}} alt=\"\"></div><div class=playlist-right><h2>{{video.name}}</h2><label ng-show=\"video.video_no == selectedVideo.video_no && !video.type\">now playing</label><p>{{video.video_length}}</p></div></a></li></ul></div></div></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative;padding: 40px 15px\"><span class=closeBtn ng-click=closePopup()>x</span><div style=\"min-width: 180px;margin: 20px\"><img src=\"../../images/DownloadPageMonitor 1.svg\"></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px;width: 300px;\n		  display: flex;\n		  justify-content: space-around\"><h3 style=\"margin-bottom: 10px; font-weight: bold\">Continue With Desktop App For Faster Streaming</h3><p>Our app has been developed to help our users view lectures with zero buffering and high quality streaming.</p><div class=\"f-c d-row\" style=\"justify-content: flex-end\"><button class=btn-two ng-click=DownloadApp() style=\"background: #f24a00 !important;\n			  width: 100%\"><img style=\"margin-right: 5px\" src=\"../../images/Icon - Download.svg\"> Download App</button></div></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/player/playerVimeo.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData><div class=main-contianer-video-one><div class=\"new-video-page video-box-padding\"><div class=left-panel-video id=left-panel-video style=\"margin-top: 20px\"><div class=video-rating-popup ng-show=userVideoRating><div class=video-rating-popup-main><h4 ng-hide=userThankYou>Please rate this video</h4><h4 class=last ng-show=userThankYou>Thank You!</h4><ng-rate-it ng-hide=userThankYou ng-model=videoRating cancel-width=1 cancel-height=1 star-height=15 ng-click=rateVideo(videoRating)></ng-rate-it></div></div><div class=cont-video-landing id=cont-video-landing ng-dblclick=dblClick() ng-hide=displayAd><div id=video-loader-two style=\"z-index: 113\"><div id=loader-two class=loadder-two style=\"z-index: 113\"><img src=images/videoLoader.gif></div></div><div class=loadder-two style=\"z-index: 112\" id=play-iccon><img src=images/play-sat.png ng-click=playPauseVideo()></div><div class=video-overly-info2 ng-click=clickBar() ng-mouseover=showBar() ng-mouseleave=hideBar()></div><div class=video-overly-info><h3>{{stamp}}</h3><h3>www.nearpeer.org</h3></div><div ng-if=waterMark class=video-marquee><span class=\"text marquee-text\">{{userInfo}}</span></div><div id=example-vimeo class=embed-container></div><div class=overlay-cont style=\"display: block\" id=overlay-cont ng-mouseover=controllBarOver() ng-mouseleave=controllBarLeave()><div class=container-video-vimeo id=button-bar ng-show=!controlsHidden><div class=overlay-cont-left-vimeo><div class=bars-parent><div class=buffered-bar><input class=bufferbar type=range id=buffer-bar value=0 step=0.5 range disabled></div><div class=buffered-bar style=\"background-color: rgb(0 0 0 / 20%)\" ng-style=\"{\'width\': buffered + \'%\'}\"></div><div class=buffered-bar style=\"position: relative !important;    display: flex\"><div class=buffered-bar style=\"background-color: red;     position: relative !important\" ng-style=\"{\'width\': progressed + \'%\'}\"></div><div style=\"border-radius: 50%;\n                  color: red;\n                  position: relative;\n                  bottom: 5px\"><p style=\"background: red;\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;cursor: pointer;position:absolute;\n    left: -2px\"></p></div></div><div class=progresss id=progress><input class=seekbar style=-webkit-appearance:none type=range id=seek-bar value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></div><div class=play style=\"width: 25px;\n                margin: 9px 0px 5px 0px\" ng-click=playPauseVideo()><a><img ng-if=isPaused id=playBtn class=icon-height src=images/play-cont.png alt=\"\"> <img ng-if=!isPaused id=pauseBtn class=icon-height style=\"height: 24px\" src=images/pause-icon.png alt=\"\"></a></div><p style=\"color: white; width: 80px;margin: 9px 0px 5px 5px\" class=\"p_ mob-font\" id=current-time></p><div class=controller-perv><a ng-click=skipRwdVideo()><img class=icon-height src=images/perv-cont.png alt=\"\"></a></div><div style=\"color: white;margin-top: 6px\">15</div><div class=controller-next><a ng-click=skipFwdVideo()><img class=icon-height src=images/farwrd-cont.png alt=\"\"></a></div><div class=vol ng-mouseover=showVolBar() ng-mouseleave=hideVolBar()><a><img ng-click=mute() id=volBtn ng-if=!isMute class=icon-height src=images/vol-cont.png alt=\"\"><img ng-click=unmute() ng-if=isMute id=muteBtn class=\"mute-icon icon-height\" src=images/mute-icon.png alt=\"\"></a><input ng-if=showVloBar ng-click=changeVolume($event.target.value) ng-model=volumeBarValue class=volume type=range id=volume-bar min=0 max=1 step=0.1 value=1></div></div><div class=overlay-cont-right-vimeo><div><div style=\"position: relative; width: fit-content\"><img class=\"quality icon-height\" id=dropdowneMenuClick ng-click=showQualityDropdown() data-toggle=dropdown aria-haspopup=true aria-expanded=false title=Settings src=\"images/Group 2124.svg\"><div ng-if=qualityDrp class=dropdownMenu id=qualityParent><div class=playback-rate><div class=\"play-back-web dropleft\"><div ng-click=showPlaybackOptions() class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false><div id=playback-text ng-if=showIt style=\"display: flex;\n                                  justify-content: space-around\"><p style=\"width: 150px;\n                                text-align: start\">Playback Speed</p><p style=\"display: flex\"></p><p style=\"margin-right: 22px\">{{selectedPlaybackRate}}</p><p style=\"margin: 0\"><img src=./../../images/arrowright.svg style=\"height: 13px;\n      width: 13px;\n      margin-top: 4px;\n      display: flex;\n      align-items: end\"></p><p></p></div></div><ul id=dropdown-menu class=dropdown-menu style=\"background: #00000073\" ng-show=playbackOpt><div style=\"display: flex;border-bottom: 1px solid white\"><img src=./../../images/arrowleft.svg ng-click=closePlayback() style=\"width: 15px;\n                                  height: 16px\"><p style=\"flex-grow: 1\">Playback Speed</p></div><li ng-style=\"{\'background-color\': selectedPlaybackRate == 2 ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(2)>2x</li><li ng-style=\"{\'background-color\': selectedPlaybackRate == 1.5 ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(1.5)>1.5x</li><li ng-style=\"{\'background-color\': selectedPlaybackRate == 1.2 ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(1.2)>1.2x</li><li ng-style=\"{\'background-color\': selectedPlaybackRate == Normal ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(1)>1</li><li ng-style=\"{\'background-color\': selectedPlaybackRate == 0.7 ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(0.7)>0.7x</li><li ng-style=\"{\'background-color\': selectedPlaybackRate == 0.5 ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\" ng-click=playBackRate(0.5)>0.5x</li></ul></div></div><div class=playback-rate ng-if=\"qualities.length > 1\"><div class=\"play-back-web dropleft\"><div style=\"display: flex; justify-content: space-around\" ng-click=showQualityOptions() class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-if=showIt><p style=\"width: 150px;\n                              text-align: start\">Quality</p><div ng-if=!selectQC style=\"display: flex\"><p style=\"margin-right: 7px\">{{selectedQuality}}</p><p style=\"margin: 0\"><img src=./../../images/arrowright.svg style=\"height: 13px;\n      width: 13px;\n      margin-top: 4px;\n      display: flex;\n      align-items: end\"></p></div><div ng-if=selectQC style=\"display: flex\"><p style=\"margin-right: 7px\">Auto</p><p style=\"margin: 0\"><img src=./../../images/arrowright.svg style=\"height: 13px;\n                                width: 13px;\n                                margin-top: 3px\"></p></div></div><div><ul id=dropdown-menu class=dropdown-menu ng-if=\"qualities.length > 1 && quality\" style=\"display: flex; flex-direction: column\"><div style=\"display: flex;border-bottom: 1px solid white\"><img src=./../../images/arrowleft.svg ng-click=closeQuality() style=\"width: 15px;\n                                  height: 16px\"><p style=\"flex-grow: 1\">Quality</p></div><li ng-repeat=\"quality in qualities\" ng-click=setVideoQuality(quality) ng-style=\"{\'background-color\': playbackValTest == quality.id ? \'rgb(238 238 238 / 33%)\': \'transparent\'}\" style=\"color: white !important\">{{quality.label}}</li></ul></div></div></div></div></div></div><div class=resize-video><a ng-click=fullScreen() ng-if=!isFullScreen><img id=fullScrBtn class=icon-height src=images/resize-close.png alt=\"\"></a><a ng-click=exitFulScreen() ng-if=isFullScreen><img id=exitFlScrBtn src=images/resize-back.png alt=\"close full screen\" class=icon-height></a></div><div class=time><a><p id=timeLeft></p></a></div></div></div></div></div><div class=cont-video-landing ng-show=displayAd><video id=video-ad ng-mousedown=handleClick($event) oncontextmenu=\"return false\" height=480px></video><div class=skip-ad ng-click=skipAd()>Skip Ad in<p id=skip-ad-time></p></div><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar-ad value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li></ul></div></div></div></div></div><h2 class=video-name-heading>{{selectedVideo.name}}</h2><h3 class=video-name-heading-sub>{{moduleName}}</h3><h3 class=video-name-heading-views>{{view_count}} VIEWS</h3><div class=video-views-des><h2 ng-hide=!selectedVideo.description>Description</h2><p>{{selectedVideo.description}}</p></div><div class=show-more-video-tagline style=\"display: none\"><h4>SHOW MORE</h4></div><div class=download-all-attachments ng-show=attachments><h3>Notes, PDF’s, Exercises</h3><button ng-click=zipAttachments(selectedVideo.id)>download all attachments</button></div></div><div class=video-ad style=\"width: 30%\" ng-show=\"showGifAd && !mobileView\"><a href=https://goo.gl/db2BiP target=_blank><img style=\"width: 100%\" src=images/Illys_sponsorship.gif></a></div><div class=terms ng-if=!showTerm><p>Dear Student, Under Copyright Ordinance 1962 and Prevention of Electronic Crimes Act (“PECA”) 2016, stealing of intellectual property, including on-screen recording, downloading, and sharing of Nearpeer\'s video content is a punishable crime. We encourage our students to stay away from all illegal activities.</p><button class=btn-two ng-click=acceptTerm()>Accept</button></div><div class=playlist><h1>playlist({{noOfVideos}} videos)</h1><ul id=testDiv ui-sortable ng-model=videos><li class=playlist-item ng-repeat=\"video in videos | orderBy : \'video_no\'\"><a ng-click=showVideo(video)><div class=playlist-left><img ng-src={{video.image_url}} alt=\"\"></div><div class=playlist-right><h2>{{video.name}}</h2><label ng-show=\"video.video_no == selectedVideo.video_no && !video.type\">now playing</label><p>{{video.video_length}}</p></div></a></li></ul></div></div></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative;padding: 40px 15px\"><span class=closeBtn ng-click=closePopup()>x</span><div style=\"min-width: 180px;margin: 20px\"><img src=\"../../images/DownloadPageMonitor 1.svg\"></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px;width: 300px;\n		  display: flex;\n		  justify-content: space-around\"><h3 style=\"margin-bottom: 10px; font-weight: bold\">Continue With Desktop App For Faster Streaming</h3><p>Our app has been developed to help our users view lectures with zero buffering and high quality streaming.</p><div class=\"f-c d-row\" style=\"justify-content: flex-end\"><button class=btn-two ng-click=DownloadApp() style=\"background: #f24a00 !important;\n			  width: 100%\"><img style=\"margin-right: 5px\" src=\"../../images/Icon - Download.svg\"> Download App</button></div></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/player/playervideojs.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData><div class=main-contianer-video-one><div class=\"new-video-page video-box-padding\"><div class=left-panel-video id=left-panel-video><div class=video-rating-popup ng-show=userVideoRating><div class=video-rating-popup-main><h4 ng-hide=userThankYou>Please rate this video</h4><h4 class=last ng-show=userThankYou>Thank You!</h4><ng-rate-it ng-hide=userThankYou ng-model=videoRating cancel-width=1 cancel-height=1 star-height=15 ng-click=rateVideo(videoRating)></ng-rate-it></div></div><div id=video-loader-two><div id=loader-two class=loadder-two><img src=images/videoLoader.gif> <span id=load-perccentage>0%</span></div></div><div class=loadder-two id=play-iccon><img src=images/play-icon.png ng-click=play()></div><div class=cont-video-landing id=cont-video-landing ng-dblclick=dblClick() ng-hide=displayAd><div class=video-overly-info><h3>{{stamp}}</h3><h3>www.nearpeer.org</h3></div><div ng-if=waterMark class=video-marquee><span class=\"text marquee-text\">{{userInfo}}</span></div><video id=example-video class=video-js height=400px controls data-setup=\'{ \"playbackRates\": [0.25, 0.5, 1, 1.25, 1.5, 2] }\'></video><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=buffered><input class=bufferbar type=range id=buffer-bar value=0 step=0.5 range disabled></div></li><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li><li class=play><a ng-click=play_pause()><img id=playBtn src=images/play-cont.png alt=\"\"><img id=pauseBtn class=pause-icon src=images/pause-icon.png alt=\"\"></a></li><li class=controller-perv><a ng-click=skipRwdVideo(15)><img src=images/perv-cont.png alt=\"\"></a></li><li class=share-info><a>15</a></li><li class=controller-next><a ng-click=skipFwdVideo(15)><img src=images/farwrd-cont.png alt=\"\"></a></li></ul></div><div class=right-panel-video><ul><li class=resize-video><a ng-click=fullScreen()><img id=fullScrBtn src=images/resize-close.png alt=\"\"></a><a ng-click=exitFulScreen()><img id=exitFlScrBtn src=images/resize-back.png alt=\"close full screen\"></a></li><li class=vol><a ng-click=mute()><img id=volBtn src=images/vol-cont.png alt=\"\"><img id=muteBtn class=mute-icon src=images/mute-icon.png alt=\"\"></a><input class=volume type=range id=volume-bar min=0 max=1 step=0.1 value=1></li><li class=playback-rate><div class=play-back-web><p ng-click=showPlaybackOptions()>{{playbackVal}}x</p><ul ng-show=playbackOpt><li ng-click=playBackRate(4)>4x</li><li ng-click=playBackRate(2)>2x</li><li ng-click=playBackRate(1.5)>1.5x</li><li ng-click=playBackRate(1.2)>1.2x</li><li ng-click=playBackRate(1)>1x</li><li ng-click=playBackRate(0.7)>0.7x</li><li ng-click=playBackRate(0.5)>0.5x</li></ul></div></li><li class=time><a><p id=timeLeft></p></a></li></ul></div></div></div></div><div class=\"f-c d-row\" style=\"justify-content: space-between\"><button type=button ng-click=swithToOldPlayer() class=\"btn btn-primary\" style=\"margin-top: 10px\">Switch to legacy player</button> <button type=button class=fast-stream ng-click=swithToFastStream()><img src=\"../../images/Fast Streaming Icon.svg\"> Try Fast Streaming</button></div><div class=cont-video-landing ng-show=displayAd><video id=video-ad ng-mousedown=handleClick($event) oncontextmenu=\"return false\" height=480px></video><div class=skip-ad ng-click=skipAd()>Skip Ad in<p id=skip-ad-time></p></div><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar-ad value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li></ul></div></div></div></div></div><h2 class=video-name-heading>{{selectedVideo.name}}</h2><h3 class=video-name-heading-sub>{{moduleName}}</h3><h3 class=video-name-heading-views>{{view_count}} VIEWS</h3><div class=video-views-des><h2 ng-hide=!selectedVideo.description>Description</h2><p>{{selectedVideo.description}}</p></div><div class=show-more-video-tagline style=\"display: none\"><h4>SHOW MORE</h4></div><div class=download-all-attachments ng-show=attachments><h3>Notes, PDF’s, Exercises</h3><button ng-click=zipAttachments(selectedVideo.id)>download all attachments</button></div></div><div class=video-ad style=width:30% ng-show=\"showGifAd && !mobileView\"><a href=https://goo.gl/db2BiP target=_blank><img style=width:100% src=images/Illys_sponsorship.gif></a></div><div class=terms ng-if=!showTerm><p>Dear Student, Under Copyright Ordinance 1962 and Prevention of Electronic Crimes Act (“PECA”) 2016, stealing of intellectual property, including on-screen recording, downloading, and sharing of Nearpeer\'s video content is a punishable crime. We encourage our students to stay away from all illegal activities.</p><button class=btn-two ng-click=acceptTerm()>Accept</button></div><div class=playlist><h1>playlist({{noOfVideos}} videos)</h1><ul id=testDiv ui-sortable ng-model=videos><li class=playlist-item ng-repeat=\"video in videos | orderBy : \'video_no\'\"><a ng-click=showVideo(video)><div class=playlist-left><img ng-src={{video.image_url}} alt=\"\"></div><div class=playlist-right><h2>{{video.name}}</h2><label ng-show=\"video.video_no == selectedVideo.video_no && !video.type\">now playing</label><p>{{video.video_length}}</p></div></a></li></ul></div></div></div><div class=poppup-cp-container ng-if=popupDiv><div class=email-poppup-cp-new style=\"height: auto; padding: 5px\"><div class=\"f-c d-row flex-wrap\" style=\"position: relative\"><span class=closeBtn ng-click=closePopup()>x</span><div style=\"min-width: 180px;margin: 20px\"><img src=\"../../images/Group 2874.png\"></div><div class=break></div><div class=\"f-c d-col ppmaxwidth\" style=\"margin: 20px\"><h4 style=\"margin-bottom: 10px\">Get Fast Streaming With Nearpeer App</h4><p>Dear student,<br><br>We, at Nearpeer, are always on our toes to bring you the best virtual academic experience. For this reason, streaming has been shifted to the exclusively designed App for the desktop/laptop users. Our Desktop App will start downloading soon. On your new App, you will be able to control the <b>quality</b> as well as the <b>speed</b> of your video playbacks with <b>zero buffering</b> or streaming issues.<br><br>Happy Learning!</p><div class=\"f-c d-row\" style=\"justify-content: flex-end\"><button class=btn-two ng-click=DownloadApp()><img style=\"margin-right: 5px\" src=\"../../images/Icon - Download.svg\"> Download App</button></div></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/profileSettings/profileSettings.html","<div><div class=popup_main_img ng-if=fullscreenImg><span style=\"padding: 20px\" class=\"display-none-profile close fa fa-times close-button\" ng-click=closeImgpopup()></span> <img class=full-screen-img ng-if=userDataObj.image src={{userDataObj.image}} alt=\"user avatar\"> <img class=full-screen-img ng-if=!userDataObj.image src=../../images/male-dp.svg alt=\"user avatar\"></div><!-- Change password --><div ng:class=\"changePassword ? \'new_password_popup\' : \'\' \" style=\"overflow-y: auto\"><div class=popup_main1 ng-show=changePassword style=\"overflow-y: auto; height: 550px !important\"><div class=custom_popup_header><div style=\"display: flex; justify-content: space-between; align-items: center;\n        width: 100%\" ng-show=!newGuest><div ng-click=backForm() role=button tabindex=0><!-- ngIf: loginBackBtn --></div><!-- <span class=\"fa fa-angle-left\" ></span> --> <img src=../../images/email-logo.svg alt=\"NearPeer Logo\"><div ng-click=closeLogoutForm() role=button tabindex=0><img src=../../images/cross-icon.svg alt=\"\"></div></div><div style=\"display: flex; justify-content: center; align-items: center;\n        width: 100%\" ng-show=newGuest><!-- <span class=\"fa fa-angle-left\" ></span> --> <img src=../../images/email-logo.svg alt=\"NearPeer Logo\"></div><!-- <span class=\"close fa fa-times\" ></span> --></div><div class=popup_title><h1>Change Your Password</h1><p>To continue, please enter your old password of<br>your Nearpeer Account.</p></div><br><form><div class=\"field-wrapper mb-24\" ng-show=!guest><label for=email>Old Password</label><div class=field-inner><input type=password name=oldPassword id=oldPassword placeholder=\"\" ng-model=passwordObj.old_password></div></div><div class=\"field-wrapper mb-24\"><label for=email>Password</label><div class=field-inner><input type=password name=resetPassword id=resetPassword placeholder=\"\" ng-model=passwordObj.new_password></div></div><div class=\"field-wrapper mb-24\"><label for=email>Confirm Password</label><div class=field-inner><input type=password name=confirmPassword id=confirmPassword placeholder=\"\" ng-model=passwordObj.confirm_password></div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><!-- <div>\n            <div class=\"login-theme-loader\" ng-if=\"loader\"></div>\n          </div> --></div><div class=text-center ng-click=\"changePass(\'password\')\"><button class=popup_button type=button><div ng-if=!loader>Save</div><div ng-if=loader><div class=login-theme-loader></div></div></button></div></form></div></div><!-- Logout all devices --><div class=\"signup-bg flex-view align-items-center\" style=\"overflow-y: scroll\" ng-if=logoutfromalldevice><div class=popup_main2 ng-if=logoutfromalldevice><span class=\"close-button-popup display-none-profile close fa fa-times close-button\" ng-click=closeverificationForm() style=\"margin-right: -10px !important\"></span><h3 class=\"display-none-profile h4-heading\">Account Verification</h3><div class=\"flex-view hide-on-small\"><img src=\"./../../images/Group 10276 (1).svg\" class=\"otp-image otp-image-tab\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><span style=\"margin-top: -40px; margin-right: -20px\" class=\"close fa fa-times display-block close-button\" ng-click=closeverificationForm()></span><h3 class=\"h4-heading display-block\">Account Verification</h3><p class=\"body-popup-profile-setting body-2 mt-3\">We will send you a <b>One Time Password (OTP)</b>.</p><p class=\"body-popup-profile-setting body-2 mt-3\">Please choose where would you like to receive your OTP.</p></div><div class=\"flex-view flex-direction-row justify-content-between align-items-center mob-length verification-popup\"><div class=flex-view><p class=body-2 style=\"color: #16b9d6;\n                margin-right: 5px;\n                height: 25px;\n                width: 25px\"><img src=\"./../../images/Icon - Email.svg\"></p><p class=\"body-2 width-mbl-profile\" style=\"text-overflow: ellipsis; overflow: hidden\"><!-- {{splitEmail[0].substring(0, 3)}}*****@{{splitEmail[1]}} --> {{userDataObj.email}}</p></div><button class=btn-contained style=\"min-width: 102px\" ng-click=\"verifyOtp(\'email\')\">Send OTP</button><!-- <p ng-if=\"userEmail\" style=\"text-align: center;\"></p> --></div><div class=\"flex-view flex-direction-row justify-content-between align-items-center mob-length\" style=\"width: 100%;\n            margin: 5px;\n            border: 1px solid #eaeaea;\n            padding: 20px 5px\"><div class=flex-view><p class=body-2 style=\"color: #16b9d6; margin-right: 5px\"><img src=\"./../../images/Icon awesome-phone-alt.svg\"></p><p class=body-2 style=\"max-width: 200px;\n                text-overflow: ellipsis;\n                overflow: hidden\"><!-- ****{{userPhone.substring(8, 12)}} --> {{userDataObj.phone}}</p></div><button class=btn-contained style=\"min-width: 102px; background: #16b9d6 !important\" ng-click=\"verifyOtp(\'phone\')\">Send OTP</button></div></div></div></div><!-- enter otp --><div class=\"signup-bg flex-view align-items-center\" ng-if=enterotp style=\"overflow: scroll\"><div class=popup_main2 ng-if=enterotp style=\"width: 100%; justify-content: center; margin-top: 0 !important\"><div class=row><a style=\"color: #000; margin-left: 15px\" ng-click=backverificationForm()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back </a><span class=\"display-none-profile close fa fa-times close-button\" ng-click=closeotpForm() role=button tabindex=0></span></div><div class=\"flex-view hide-on-small\"><img src=./../../images/5326009.svg ng-if=phoneSelected class=otp-image style=\"width: 270px; margin: 20px auto\"> <img src=\"./../../images/Group 1420.svg\" ng-if=emailSelected class=otp-image style=\"width: 270px; margin: 20px auto\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><div><span style=\"margin-top: -44px; margin-right: -15px\" class=\"close fa fa-times display-block close-button\" ng-click=closeotpForm()></span></div><h3 class=h4-heading>Please Enter the OTP sent to you.</h3><p class=\"body-2 mt-3\">A verification code has been sent to <b ng-if=emailSelected>{{userDataObj.email}}</b><b ng-if=phoneSelected>{{userDataObj.phone}}</b>. To complete your verification please enter the <b>6</b> digit verification code.</p></div><div class=\"flex-view flex-direction-col justify-content-around align-items-center mt-4\"><form style=\"margin-bottom: 15px\" method=get class=field-wrapper-otpCode data-group-name=digits data-autosubmit=false autocomplete=off><input type=text maxlength=1 id=digit-1 name=digit-1 data-next=digit-2 ng-model=digit1 ng-keyup=\"keytab($event, 1)\"> <input type=text id=digit-2 name=digit-2 data-next=digit-3 data-previous=digit-1 maxlength=1 ng-keyup=\"keytab($event, 2)\" ng-model=digit2> <input type=text id=digit-3 name=digit-3 data-next=digit-4 data-previous=digit-2 maxlength=1 ng-keyup=\"keytab($event, 3)\" ng-model=digit3><!-- <span class=\"splitter\">&ndash;</span> --> <input type=text id=digit-4 name=digit-4 data-next=digit-5 data-previous=digit-3 maxlength=1 ng-keyup=\"keytab($event, 4)\" ng-model=digit4> <input type=text id=digit-5 name=digit-5 data-next=digit-6 data-previous=digit-4 maxlength=1 ng-keyup=\"keytab($event, 5)\" ng-model=digit5> <input type=text id=digit-6 name=digit-6 data-next=digit-7 data-previous=digit-5 maxlength=1 ng-keyup=\"keytab($event, 6)\" ng-model=digit6></form><p style=\"color: #16b9d6; text-align: center\">{{otpErroor}}</p><button class=\"btn-contained mt-3\" style=\"background: #16b9d6 !important; color: white\" ng-click=sendOTPConfirmation()>Submit</button></div><div class=\"flex-view mt-3 justify-content-center\" style=\"margin-top: 15px\"><p class=subtitle-2>Didn\'t get the code? <b ng-click=\"sendOtpCode(emailSelected ? \'email\' :\'phone\' )\" style=\"color: #16b9d6 !important\">Resend</b></p></div></div></div></div><!-- transfer your account --><div class=\"signup-bg flex-view align-items-center\" style=\"overflow-y: auto\" ng-show=transferAccount><div class=popup_main2 ng-show=transferAccount><span class=\"close-button-popup display-none-profile close fa fa-times close-button\" ng-click=closetransferAccountPopup()></span><div class=\"flex-view hide-on-small\" style=\"width: 100%; height: 70%; margin-top: 8%\"><img src=./../../images/animation_500_ku472cnh.gif class=\"otp-image-tab otp-image\" style=\"width: 270px\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><span style=\"margin-top: -50px; margin-right: -15px\" class=\"close fa fa-times display-block close-button\" ng-click=closetransferAccountPopup()></span><br><br><br><br><h3 class=h4-heading>Accounts Successfully Transferred</h3><!-- <p class=\"body-2 mt-3\">We will send you a <b>One Time Password (OTP)</b>.</p> --><p class=\"body-popup-profile-setting mt-2\">Congratulations! Your account have successfully been merged. All your courses will now be available in this below mentioned account.</p><!-- <ul >\n          <li style=\"list-style: disc !important;margin-left: 20px;\" >Facebook</li>\n        </ul> --></div><div style=\"text-align: center\"><button class=\"btn-continue btn-contained\" ng-click=closetransferAccountPopup()>Continue</button></div></div></div></div><div class=\"signup-bg flex-view align-items-center\" ng-if=emailSubscriptionUpdated><div class=popup_main2 ng-show=emailSubscriptionUpdated><span class=\"close-button-popup display-none-profile close fa fa-times close-button\" ng-click=closeemailSettingPopup()></span><div class=\"subscription-popup flex-view hide-on-small\"><img src=./../../images/animation_500_ku472cnh.gif class=otp-image style=\"width: 270px\"></div><div class=\"flex-view flex-direction-col justify-content-around otp-options\"><div><span style=\"margin-top: -53px; margin-right: -3px\" class=\"close fa fa-times display-block close-button\" ng-click=closeemailSettingPopup()></span><br><br><br><br><h3 class=h4-heading>Subscriptions Updated</h3><p class=\"body-2 mt-3\" style=\"font-size: 18px\">You have successfully updated Nearpeer email subscriptions. From now on you will only recieve emails regarding the checked boxes .</p></div><button class=\"btn-continue logout-button btn-contained mt-3\" style=\"width: 210px\" ng-click=closeemailSettingPopup()>Back to profile page</button></div></div></div><!-- Chnaage password  changePassword|| --><div class=\"profile-tabs row profile-tabs-responsive\" style=\"width: 100%; overflow-x: hidden; margin: 0%\" id=profile ng-style=\"{display: fullscreenImg ? \'none\' : \'flex\'}\"><div ng-show=!sidebar class=\"profile-sidbar display-fix\"><h4 class=sidebar-title>Settings</h4><ul><div class=hover-bg></div><li ng-click=\"filterSetting(\'profileInfo\')\" ng:class=\"{ activetab : settingType.profileInfo }\"><svg class=icons-web-responsive width=16 height=16 viewBox=\"0 0 16 16\" xmlns=http://www.w3.org/2000/svg><path d=\"M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z\"/></svg> personal info <img ng-if=\"(userDataObj.name === null  && userDataObj.full_name === null) || userData.gender === null  || userData.gender === \'\' || missingDOB || userDataObj.city === null || userDataObj.city === \'\' || userDataObj.university=== null || userDataObj.university === \'\'\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-click=\"filterSetting(\'contantInfo\')\" ng:class=\"{ activetab : settingType.contantInfo }\"><svg class=icons-web-responsive width=18 height=18 viewBox=\"0 0 18 18\" xmlns=http://www.w3.org/2000/svg><path d=\"M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z\"/></svg> contact info <img ng-if=\"userDataObj.confirmed_at === \'\' || userDataObj.phone_confirmed_at === \'\' || userDataObj.confirmed_at === null || userDataObj.phone_confirmed_at === null\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-show=!guest ng-click=\"filterSetting(\'activeDevices\')\" ng:class=\"{ activetab : settingType.activeDevices }\"><svg class=icons-web-responsive width=22 height=20 viewBox=\"0 0 22 20\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M2 0H20C21.1 0 22 0.9 22 2V14C22 15.1 21.1 16 20 16H13V18H15V20H7V18H9V16H2C0.9 16 0 15.1 0 14V2C0 0.9 0.9 0 2 0Z\"/></svg> active devices</li><li ng-show=!guest ng-click=\"filterSetting(\'yourAccount\')\" ng:class=\"{ activetab : settingType.yourAccount }\"><svg class=icons-web-responsive width=22 height=16 viewBox=\"0 0 22 16\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M15.6699 9.13C17.0399 10.06 17.9999 11.32 17.9999 13V16H21.9999V13C21.9999 10.82 18.4299 9.53 15.6699 9.13Z\"/><path d=\"M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z\"/><path fill-rule=evenodd clip-rule=evenodd d=\"M13.9999 8C16.2099 8 17.9999 6.21 17.9999 4C17.9999 1.79 16.2099 0 13.9999 0C13.5299 0 13.0899 0.0999998 12.6699 0.24C13.4999 1.27 13.9999 2.58 13.9999 4C13.9999 5.42 13.4999 6.73 12.6699 7.76C13.0899 7.9 13.5299 8 13.9999 8Z\"/><path fill-rule=evenodd clip-rule=evenodd d=\"M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9Z\"/></svg> your accounts <img ng-if=mergeTooltip src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-show=!guest ng-click=\"filterSetting(\'emailSubscription\')\" ng:class=\"{ activetab : settingType.emailSubscription }\"><svg class=icons-web-responsive width=22 height=22 viewBox=\"0 0 22 22\" xmlns=http://www.w3.org/2000/svg><path d=\"M10.9991 20.9489C11.3841 20.94 11.7535 20.7953 12.042 20.5403C12.3306 20.2853 12.5196 19.9365 12.5758 19.5555H9.36133C9.41906 19.9468 9.61697 20.3039 9.91824 20.5602C10.2195 20.8165 10.6036 20.9546 10.9991 20.9489Z\"/><path d=\"M20.0744 17.1905L19.8666 17.0072C19.2772 16.482 18.7612 15.8797 18.3327 15.2167C17.8647 14.3016 17.5843 13.3022 17.5077 12.2772V9.25833C17.5052 8.89163 17.4725 8.52576 17.4099 8.16444C16.3748 7.95167 15.445 7.38773 14.7779 6.56808C14.1108 5.74844 13.7475 4.72345 13.7494 3.66666V3.28166C13.1113 2.96767 12.4258 2.76118 11.7205 2.67055V1.90055C11.7205 1.68418 11.6345 1.47667 11.4816 1.32367C11.3286 1.17067 11.121 1.08472 10.9047 1.08472C10.6883 1.08472 10.4808 1.17067 10.3278 1.32367C10.1748 1.47667 10.0888 1.68418 10.0888 1.90055V2.70111C8.50955 2.92389 7.06419 3.7105 6.01958 4.91573C4.97498 6.12096 4.40167 7.66341 4.4055 9.25833V12.2772C4.32896 13.3022 4.04848 14.3016 3.5805 15.2167C3.15938 15.8781 2.65173 16.4803 2.07106 17.0072L1.86328 17.1905V18.9139H20.0744V17.1905Z\"/><path d=\"M18.3329 6.7222C20.0204 6.7222 21.3885 5.35418 21.3885 3.66664C21.3885 1.9791 20.0204 0.611084 18.3329 0.611084C16.6454 0.611084 15.2773 1.9791 15.2773 3.66664C15.2773 5.35418 16.6454 6.7222 18.3329 6.7222Z\"/></svg> subscriptions</li><li ng-click=\"filterSetting(\'myOrder\')\" ng:class=\"{ activetab : settingType.myOrder }\"><svg class=icons-web-responsive width=20 height=20 viewBox=\"0 0 20 20\" xmlns=http://www.w3.org/2000/svg><path d=\"M6 16C4.9 16 4.01 16.9 4.01 18C4.01 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM0 0V2H2L5.6 9.59L4.25 12.04C4.09 12.32 4 12.65 4 13C4 14.1 4.9 15 6 15H18V13H6.42C6.28 13 6.17 12.89 6.17 12.75L6.2 12.63L7.1 11H14.55C15.3 11 15.96 10.59 16.3 9.97L19.88 3.48C19.96 3.34 20 3.17 20 3C20 2.45 19.55 2 19 2H4.21L3.27 0H0ZM16 16C14.9 16 14.01 16.9 14.01 18C14.01 19.1 14.9 20 16 20C17.1 20 18 19.1 18 18C18 16.9 17.1 16 16 16Z\"/></svg> my orders</li><!-- <li ng-click=\"filterSetting(\'transactions\')\" ng:class=\"{ activetab : settingType.transactions }\">\n                    <svg width=\"20\" height=\"16\" viewBox=\"0 0 20 16\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path d=\"M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V8H18V14ZM18 4H2V2H18V4Z\" />\n                    </svg>\n                        \n                    transactions\n                </li> --><li ng-click=\"filterSetting(\'quizzes\')\" ng:class=\"{ activetab : settingType.quizzes }\"><svg class=icons-web-responsive width=20 height=20 viewBox=\"0 0 20 20\" xmlns=http://www.w3.org/2000/svg><path d=\"M2 4H0V18C0 19.1 0.9 20 2 20H16V18H2V4Z\"/><path d=\"M18 0H6C4.9 0 4 0.9 4 2V14C4 15.1 4.9 16 6 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM12.01 13C11.42 13 10.96 12.53 10.96 11.95C10.96 11.36 11.43 10.91 12.01 10.91C12.6 10.91 13.05 11.36 13.05 11.95C13.04 12.53 12.6 13 12.01 13ZM14.51 6.83C13.88 7.76 13.28 8.04 12.95 8.64C12.82 8.88 12.77 9.04 12.77 9.82H11.25C11.25 9.41 11.19 8.74 11.51 8.17C11.92 7.44 12.69 7.01 13.14 6.37C13.62 5.69 13.35 4.43 12 4.43C11.12 4.43 10.68 5.1 10.5 5.66L9.13 5.09C9.51 3.96 10.52 3 11.99 3C13.22 3 14.07 3.56 14.5 4.26C14.87 4.87 15.08 5.99 14.51 6.83Z\"/></svg> quizzes</li><li ng-click=\"filterSetting(\'videosWatched\')\" ng:class=\"{ activetab : settingType.videosWatched }\"><svg class=icons-web-responsive width=20 height=20 viewBox=\"0 0 20 20\" xmlns=http://www.w3.org/2000/svg><path d=\"M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 13.5V6.5C8 6.09 8.47 5.85 8.8 6.1L13.47 9.6C13.74 9.8 13.74 10.2 13.47 10.4L8.8 13.9C8.47 14.15 8 13.91 8 13.5Z\"/></svg> Watched Videos</li></ul></div><div ng-show=sidebar style=\"width: 100%; background: #f8fdfe; min-height: 90vh\"><div class=sidebar-responsive><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a style=\"color: #000; margin-left: 15px\" ng-click=\"goToState(\'Landing\')\"><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Profile Settings</h4></div></div><div class=sidebar-responsive-fix><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"><div><div id=imagePreview><img class=img-profile-style ng-if=\"!userDataObj.image && !imageLoad\" src=../../images/male-dp.svg alt=\"user avatar\"> <img class=img-profile-style ng-if=\"userDataObj.image && !imageLoad\" src={{userDataObj.image}} alt=\"user avatar\"><div class=loader ng-if=imageLoad><img src=images/squares.gif></div><!-- style=\"background-image: url(../../images/Abdul\\ Azeem.jpg)\" --></div></div></div><div style=\"margin-left: auto; margin-right: auto; text-align: center\"><div style=\"padding-top: 10px\"><h3>{{userDataObj.name ? userDataObj.name : userDataObj.full_name}}</h3></div></div></div><ul class=profile-sidbar style=\"margin: 0px\"><div class=hover-bg></div><li ng-click=\"filterSetting(\'profileInfo\')\"><svg width=16 height=16 viewBox=\"0 0 16 16\" xmlns=http://www.w3.org/2000/svg><path d=\"M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z\"/></svg> personal info <img ng-if=\"(userDataObj.name === null  && userDataObj.full_name === null) || userData.gender === null  || userData.gender === \'\' || missingDOB || userDataObj.city === null || userDataObj.city === \'\' || userDataObj.university=== null || userDataObj.university === \'\'\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-click=\"filterSetting(\'contantInfo\')\"><svg width=18 height=18 viewBox=\"0 0 18 18\" xmlns=http://www.w3.org/2000/svg><path d=\"M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z\"/></svg> contact info <img ng-if=\"userDataObj.confirmed_at === \'\' || userDataObj.phone_confirmed_at === \'\' || userDataObj.confirmed_at === null || userDataObj.phone_confirmed_at === null\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-show=!guest ng-click=\"filterSetting(\'activeDevices\')\"><svg width=22 height=20 viewBox=\"0 0 22 20\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M2 0H20C21.1 0 22 0.9 22 2V14C22 15.1 21.1 16 20 16H13V18H15V20H7V18H9V16H2C0.9 16 0 15.1 0 14V2C0 0.9 0.9 0 2 0Z\"/></svg> active devices</li><li ng-show=!guest ng-click=\"filterSetting(\'yourAccount\')\"><svg width=22 height=16 viewBox=\"0 0 22 16\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M15.6699 9.13C17.0399 10.06 17.9999 11.32 17.9999 13V16H21.9999V13C21.9999 10.82 18.4299 9.53 15.6699 9.13Z\"/><path d=\"M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z\"/><path fill-rule=evenodd clip-rule=evenodd d=\"M13.9999 8C16.2099 8 17.9999 6.21 17.9999 4C17.9999 1.79 16.2099 0 13.9999 0C13.5299 0 13.0899 0.0999998 12.6699 0.24C13.4999 1.27 13.9999 2.58 13.9999 4C13.9999 5.42 13.4999 6.73 12.6699 7.76C13.0899 7.9 13.5299 8 13.9999 8Z\"/><path fill-rule=evenodd clip-rule=evenodd d=\"M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9Z\"/></svg> your accounts <img ng-if=mergeTooltip src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></li><li ng-show=!guest ng-click=\"filterSetting(\'emailSubscription\')\"><svg width=22 height=22 viewBox=\"0 0 22 22\" xmlns=http://www.w3.org/2000/svg><path d=\"M10.9991 20.9489C11.3841 20.94 11.7535 20.7953 12.042 20.5403C12.3306 20.2853 12.5196 19.9365 12.5758 19.5555H9.36133C9.41906 19.9468 9.61697 20.3039 9.91824 20.5602C10.2195 20.8165 10.6036 20.9546 10.9991 20.9489Z\"/><path d=\"M20.0744 17.1905L19.8666 17.0072C19.2772 16.482 18.7612 15.8797 18.3327 15.2167C17.8647 14.3016 17.5843 13.3022 17.5077 12.2772V9.25833C17.5052 8.89163 17.4725 8.52576 17.4099 8.16444C16.3748 7.95167 15.445 7.38773 14.7779 6.56808C14.1108 5.74844 13.7475 4.72345 13.7494 3.66666V3.28166C13.1113 2.96767 12.4258 2.76118 11.7205 2.67055V1.90055C11.7205 1.68418 11.6345 1.47667 11.4816 1.32367C11.3286 1.17067 11.121 1.08472 10.9047 1.08472C10.6883 1.08472 10.4808 1.17067 10.3278 1.32367C10.1748 1.47667 10.0888 1.68418 10.0888 1.90055V2.70111C8.50955 2.92389 7.06419 3.7105 6.01958 4.91573C4.97498 6.12096 4.40167 7.66341 4.4055 9.25833V12.2772C4.32896 13.3022 4.04848 14.3016 3.5805 15.2167C3.15938 15.8781 2.65173 16.4803 2.07106 17.0072L1.86328 17.1905V18.9139H20.0744V17.1905Z\"/><path d=\"M18.3329 6.7222C20.0204 6.7222 21.3885 5.35418 21.3885 3.66664C21.3885 1.9791 20.0204 0.611084 18.3329 0.611084C16.6454 0.611084 15.2773 1.9791 15.2773 3.66664C15.2773 5.35418 16.6454 6.7222 18.3329 6.7222Z\"/></svg> subscriptions</li><li ng-click=\"filterSetting(\'myOrder\')\"><svg width=20 height=20 viewBox=\"0 0 20 20\" xmlns=http://www.w3.org/2000/svg><path d=\"M6 16C4.9 16 4.01 16.9 4.01 18C4.01 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM0 0V2H2L5.6 9.59L4.25 12.04C4.09 12.32 4 12.65 4 13C4 14.1 4.9 15 6 15H18V13H6.42C6.28 13 6.17 12.89 6.17 12.75L6.2 12.63L7.1 11H14.55C15.3 11 15.96 10.59 16.3 9.97L19.88 3.48C19.96 3.34 20 3.17 20 3C20 2.45 19.55 2 19 2H4.21L3.27 0H0ZM16 16C14.9 16 14.01 16.9 14.01 18C14.01 19.1 14.9 20 16 20C17.1 20 18 19.1 18 18C18 16.9 17.1 16 16 16Z\"/></svg> my orders</li><!-- <li ng-click=\"filterSetting(\'quizzes\')\">\n          <svg\n            width=\"20\"\n            height=\"20\"\n            viewBox=\"0 0 20 20\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n          >\n            <path d=\"M2 4H0V18C0 19.1 0.9 20 2 20H16V18H2V4Z\" />\n            <path\n              d=\"M18 0H6C4.9 0 4 0.9 4 2V14C4 15.1 4.9 16 6 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM12.01 13C11.42 13 10.96 12.53 10.96 11.95C10.96 11.36 11.43 10.91 12.01 10.91C12.6 10.91 13.05 11.36 13.05 11.95C13.04 12.53 12.6 13 12.01 13ZM14.51 6.83C13.88 7.76 13.28 8.04 12.95 8.64C12.82 8.88 12.77 9.04 12.77 9.82H11.25C11.25 9.41 11.19 8.74 11.51 8.17C11.92 7.44 12.69 7.01 13.14 6.37C13.62 5.69 13.35 4.43 12 4.43C11.12 4.43 10.68 5.1 10.5 5.66L9.13 5.09C9.51 3.96 10.52 3 11.99 3C13.22 3 14.07 3.56 14.5 4.26C14.87 4.87 15.08 5.99 14.51 6.83Z\"\n            />\n          </svg>\n\n          quizzes\n        </li> --><li ng-click=\"filterSetting(\'videosWatched\')\"><svg width=20 height=20 viewBox=\"0 0 20 20\" xmlns=http://www.w3.org/2000/svg><path d=\"M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 13.5V6.5C8 6.09 8.47 5.85 8.8 6.1L13.47 9.6C13.74 9.8 13.74 10.2 13.47 10.4L8.8 13.9C8.47 14.15 8 13.91 8 13.5Z\"/></svg> Watched Videos</li></ul></div><div class=profile-content ng-show=responsive style=\"width: 100%\" ng-style=\"{display: fullscreenImg ? \'none\' : \'flex\'}\"><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=settingType.profileInfo ng:class=\" showCropped ? \'custom-crop\' : \'\'\"><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Personal Information</h4></div></div><div class=image-upload><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"><div class=avatar-edit><input type=file id=imageUpload accept=\".png, .jpg, .jpeg\" ng-model=userDataObj.image onchange=angular.element(this).scope().handleFileSelect(event)><label for=imageUpload></label></div><div><div id=imagePreview><img data-enlargeable width=100 style=\"cursor: zoom-in\" ng-click=fullScreen() class=img-profile-style ng-if=\"!userDataObj.image && !imageLoad\" src=../../images/male-dp.svg alt=\"user avatar\"> <img data-enlargeable width=100 style=\"cursor: zoom-in\" ng-click=fullScreen() class=img-profile-style ng-if=\"userDataObj.image && !imageLoad\" src={{userDataObj.image}} alt=\"user avatar\"><div class=loader ng-if=imageLoad><img src=images/squares.gif></div></div></div></div><!-- <div ng-if=\"showCropped\" class=\"image-crop-popup\">\n              <div  class=\"cropArea\">\n                <img-crop image=\"myImage\" result-image=\"myCroppedImage\"></img-crop>\n              </div>\n            </div> --><!-- <div\n              style=\"margin-left: auto; margin-right: auto; text-align: center\"\n            >\n              <div class=\"list-btn\" style=\"padding-top: 10px\">\n                <a class=\"edit-button-color\" href=\"JavaScript:void(0);\" ng-click=\"fullScreen()\">View</a>\n              </div>\n            </div> --></div></div><!-- responsive --><div class=\"tab-content-header flex-view justify-content-between profile-content-responsive-hide\"><div class=content-title><h3>Personal Information</h3><p>Info about you and your preferences across Nearpeer.</p></div><div class=\"avatar-upload display-block\"><div class=avatar-edit><input type=file id=imageUpload accept=\".png, .jpg, .jpeg\" ng-model=userDataObj.image onchange=angular.element(this).scope().handleFileSelect(event)><!-- onchange=\"angular.element(this).scope().onImageSelected(event)\" --><label for=imageUpload></label></div><div><div id=imagePreview><img class=img-profile-style ng-if=\"!userDataObj.image && !imageLoad\" src=../../images/male-dp.svg alt=\"user avatar\"> <img class=img-profile-style ng-if=\"userDataObj.image && !imageLoad\" src={{userDataObj.image}} alt=\"user avatar\"><div class=loader ng-if=imageLoad><img src=images/squares.gif></div></div></div></div><!-- <div>Select an image file: <input type=\"file\" id=\"fileInput\" /></div> --><div ng-if=showCropped class=image-crop-popup><div class=cropArea><img ng-click=closeCustomCrop() class=custom-crop-cross src=./../../images/cross-icon.svg><img-crop image=myImage result-image=myCroppedImage></img-crop><button class=custom-crop-save ng-click=onImageSelected(myCroppedImage)><span ng-show=!loader>Save</span> <span style=\"display: flex;\n              justify-content: center\" ng-show=loader><div class=login-theme-loader></div></span></button><!-- <img ng-src=\"{{myImage}}\" /> --></div></div><!-- <div>Cropped Image:</div>\n          <div><img ng-src=\"{{myCroppedImage}}\" /></div> --></div><div class=\"tab-content-main profile-content-responsive-hide\" style=\"padding-bottom: 150px\"><div class=tab-content-list><div class=\"list-item flex-view justify-content-between\" ng-click=\"nameEdit ? \'\' : fieldEditing(\'name\')\"><div class=\"list-data flex-view\"><div class=list-label>Name <img ng-if=\"incompleteProfile && userDataObj.name === \'\'\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></div><div class=list-detail id=name ng-show=!nameEdit>{{userDataObj.name ? userDataObj.name : userDataObj.full_name}}</div><div ng-show=nameEdit><input type=text class=body-2 ng-model=userName style=\"width: 150px; background: transparent\" id=editName onblur=\"angular.element(this).scope().blurCall(\'name\',event.target.value)\"><br><span style=\"color: rgb(226, 4, 4);\n                      font-weight: 400;\n                      font-size: 14px\"><!-- <span ng-if=\"errorMessage.length == 0\"\n                      >Edit your name here.</span\n                    > --> <span ng-if=\"errorMessage.length > 0\">{{errorMessage}}</span></span></div></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-click=\"fieldEditing(\'name\')\" ng-if=!nameEdit>Edit</a> <a class=edit-button-color href=JavaScript:void(0); ng-click=\"discard(); $event.stopPropagation();\" ng-if=nameEdit>Discard</a> <a class=save-button-color href=JavaScript:void(0); ng-click=\"updateProfile(\'name\',userName); $event.stopPropagation();\" ng-if=nameEdit>Save</a></div></div><div class=\"list-item flex-view justify-content-between\" ng-click=\"dobEdit ? \'\' : fixEditing(\'dob\')\"><div class=\"list-data flex-view\" ng-click=\" $event.stopPropagation();\"><div class=list-label>Birthday <img ng-if=missingDOB src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></div><div class=list-detail id=dob><div ng-show=!dobEdit>{{userDob}}</div><div ng-show=dobEdit><div class=dob-dropdown-profile><select name=dob-day id=dob-day ng-model=dobUser.userDay><option value=\"\">Day</option><option value=01>01</option><option value=02>02</option><option value=03>03</option><option value=04>04</option><option value=05>05</option><option value=06>06</option><option value=07>07</option><option value=08>08</option><option value=09>09</option><option value=10>10</option><option value=11>11</option><option value=12>12</option><option value=13>13</option><option value=14>14</option><option value=15>15</option><option value=16>16</option><option value=17>17</option><option value=18>18</option><option value=19>19</option><option value=20>20</option><option value=21>21</option><option value=22>22</option><option value=23>23</option><option value=24>24</option><option value=25>25</option><option value=26>26</option><option value=27>27</option><option value=28>28</option><option value=29>29</option><option value=30>30</option><option value=31>31</option></select><select name=dob-month id=dob-month ng-model=dobUser.userMonth><option value=\"\">Month</option><option value=01>Jan</option><option value=02>Feb</option><option value=03>Mar</option><option value=04>Apr</option><option value=05>May</option><option value=06>Jun</option><option value=07>Jul</option><option value=08>Aug</option><option value=09>Sep</option><option value=10>Oct</option><option value=11>Nov</option><option value=12>Dec</option></select><select name=dob-year id=dob-year ng-model=dobUser.userYear><option value=\"\">Year</option><option value=2012>2012</option><option value=2011>2011</option><option value=2010>2010</option><option value=2009>2009</option><option value=2008>2008</option><option value=2007>2007</option><option value=2006>2006</option><option value=2005>2005</option><option value=2004>2004</option><option value=2003>2003</option><option value=2002>2002</option><option value=2001>2001</option><option value=2000>2000</option><option value=1999>1999</option><option value=1998>1998</option><option value=1997>1997</option><option value=1996>1996</option><option value=1995>1995</option><option value=1994>1994</option><option value=1993>1993</option><option value=1992>1992</option><option value=1991>1991</option><option value=1990>1990</option><option value=1989>1989</option><option value=1988>1988</option><option value=1987>1987</option><option value=1986>1986</option><option value=1985>1985</option><option value=1984>1984</option><option value=1983>1983</option><option value=1982>1982</option><option value=1981>1981</option><option value=1980>1980</option><option value=1979>1979</option><option value=1978>1978</option><option value=1977>1977</option><option value=1976>1976</option><option value=1975>1975</option><option value=1974>1974</option><option value=1973>1973</option><option value=1972>1972</option><option value=1971>1971</option><option value=1970>1970</option><option value=1969>1969</option><option value=1968>1968</option><option value=1967>1967</option><option value=1966>1966</option><option value=1965>1965</option><option value=1964>1964</option><option value=1963>1963</option><option value=1962>1962</option><option value=1961>1961</option><option value=1960>1960</option><option value=1959>1959</option><option value=1958>1958</option><option value=1957>1957</option><option value=1956>1956</option><option value=1955>1955</option><option value=1954>1954</option><option value=1953>1953</option><option value=1952>1952</option><option value=1951>1951</option><option value=1950>1950</option><option value=1949>1949</option><option value=1948>1948</option><option value=1947>1947</option><option value=1946>1946</option><option value=1945>1945</option><option value=1944>1944</option><option value=1943>1943</option><option value=1942>1942</option><option value=1941>1941</option><option value=1940>1940</option><option value=1939>1939</option><option value=1938>1938</option><option value=1937>1937</option><option value=1936>1936</option><option value=1935>1935</option><option value=1934>1934</option><option value=1933>1933</option><option value=1932>1932</option><option value=1931>1931</option><option value=1930>1930</option><option value=1929>1929</option><option value=1928>1928</option><option value=1927>1927</option><option value=1926>1926</option><option value=1925>1925</option><option value=1924>1924</option><option value=1923>1923</option><option value=1922>1922</option><option value=1921>1921</option><option value=1920>1920</option><option value=1919>1919</option><option value=1918>1918</option><option value=1917>1917</option><option value=1916>1916</option><option value=1915>1915</option><option value=1914>1914</option><option value=1913>1913</option><option value=1912>1912</option><option value=1911>1911</option><option value=1910>1910</option><option value=1909>1909</option><option value=1908>1908</option><option value=1907>1907</option><option value=1906>1906</option><option value=1905>1905</option><option value=1904>1904</option><option value=1903>1903</option><option value=1901>1901</option><option value=1900>1900</option></select></div><!-- <input\n                      type=\"date\"\n                      class=\"body-2\"\n                      ng-model=\"userDataObj.dob\"\n                      name=\"date\"\n                      style=\"width: 150px; background: transparent\"\n                      max=\"{{currentDate}}\"\n                      value=\"2013-01-08\"\n                      id=\"dateDob\"\n                    onblur=\"angular.element(this).scope().blurCall(\'dob\',event.target.value);\"\n\n                    /> --><!-- <br /> --><!-- <span ng-if=\"!dob.length\"\n                      style=\"\n                        color: rgb(226, 4, 4);\n                        font-weight: 400;\n                        font-size: 14px;\n                      \">Please enter a valid date of birth.</span> --></div></div></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-click=\"fixEditing(\'dob\')\" ng-show=!dobEdit>Edit</a> <a class=edit-button-color href=JavaScript:void(0); ng-click=\"discard(); $event.stopPropagation();\" ng-show=dobEdit>Discard</a> <a class=save-button-color href=JavaScript:void(0); ng-click=\"updateProfile(\'dob\',dobUser); $event.stopPropagation();\" ng-show=dobEdit>Save</a></div></div><div class=\"list-item flex-view justify-content-between\" ng-click=\"genderEdit ? \'\' : fixEditing(\'gender\')\"><div class=\"list-data flex-view\"><div class=list-label>Gender <img ng-if=\"userDataObj.gender === \'\' || userDataObj.gender === null\" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></div><div class=list-detail ng-show=!genderEdit>{{userDataObj.gender ? userData.gender : \'N/A\'}}</div><div class=profile_popup_radio ng-show=genderEdit><div class=btnRadio><input type=radio id=gender_male name=profile-gender ng-model=userDataObj.gender value=Male onclick=\"angular.element(this).scope().blurCall(\'gender\',event.target.value)\"><label style=\"padding-left: 3px; padding-right: 10px\" for=gender_male>Male</label></div><div class=btnRadio><input type=radio id=gender_female name=profile-gender ng-model=userDataObj.gender value=Female onclick=\"angular.element(this).scope().blurCall(\'gender\',event.target.value)\"><label style=\"padding-left: 3px; padding-right: 10px\" for=gender_female>Female</label></div><div class=btnRadio><input type=radio id=other name=profile-gender ng-model=userDataObj.gender value=OTHER onclick=\"angular.element(this).scope().blurCall(\'gender\',event.target.value)\"><label style=\"padding-left: 3px; padding-right: 10px\" for=other>Other</label></div></div></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-click=\"fixEditing(\'gender\')\" ng-show=!genderEdit>Edit</a><!-- <a\n                class=\"edit-button-color\"\n                href=\"JavaScript:void(0);\"\n                ng-click=\"discard(); $event.stopPropagation();\"\n                ng-show=\"genderEdit\"\n                >Discard</a\n              > --> <a class=\"save-button-color left_margin_mobile\" href=JavaScript:void(0); ng-click=\"updateProfile(\'gender\',userDataObj.gender); $event.stopPropagation();\" ng-show=genderEdit>Save</a></div></div></div><div class=flex-view ng:class=\"showEditPassword ? \'alignment-custom-password list-item-copy\' : \'justify-content-between list-item\'  \" ng-click=\"(userDataObj.provider === \'email\') ? passwordEditing() : \'\'\"><div class=\"list-data flex-view\"><div class=list-label>Password</div><div class=list-detail ng-show=!showEditPassword>**********<p class=password-update ng-if=updatedAt>Last updated on {{updatedAt}}</p></div></div><div class=list-btn ng-show=\"userDataObj.provider === \'email\' && !showEditPassword\"><a class=edit-button-color href=JavaScript:void(0); ng-click=\"passwordEditing(); $event.stopPropagation();\">Edit</a></div><div ng-show=showEditPassword style=\"width: 280px\"><form><div class=\"field-wrapper mb-24\" ng-show=!guest><label for=email style=\"background-color: #F8FDFE\">Old Password</label><div class=field-inner><input style=\"background: transparent\" type=password name=oldPassword id=oldPassword placeholder=\"\" ng-model=passwordObj.old_password></div></div><div class=\"field-wrapper mb-24\"><label for=email style=\"background-color: #F8FDFE\">Password</label><div class=field-inner><input style=\"background: transparent\" type=password name=resetPassword id=resetPassword placeholder=\"\" ng-model=passwordObj.new_password></div></div><div class=\"field-wrapper mb-24\"><label for=email style=\"background-color: #F8FDFE\">Confirm Password</label><div class=field-inner><input style=\"background: transparent\" type=password name=confirmPassword id=confirmPassword placeholder=\"\" ng-model=passwordObj.confirm_password></div></div><div class=login-loader-cont><div><p class=login-error-message v-if=errorMessage>{{errorMessage}}</p></div><!-- <div>\n                    <div class=\"login-theme-loader\" ng-if=\"loader\"></div>\n                  </div> --></div><div class=text-center style=\"display: flex\"><button class=popup_button type=button style=\"width: 120px\" ng-click=\"changePass(\'password\');$event.stopPropagation();\"><div ng-if=!loader>Save</div><div ng-if=loader><div class=login-theme-loader></div></div></button> <button class=popup_button type=button style=\"color: #16B9D6;\n                  background: white;\n                  border: 1px solid #16B9D6;width: 120px\" ng-click=closeNewPass();$event.stopPropagation();><div>Cancel</div></button></div></form></div></div><div class=\"list-item flex-view justify-content-between\" ng-click=\"cityEdit ? \'\' : fixEditing(\'city\')\"><div class=\"list-data flex-view\"><div class=list-label>City <img ng-if=\"userDataObj.city === \'\' || userDataObj.city === null \" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></div><div class=list-detail ng-show=!cityEdit><!-- {{userDataObj.city.name || userDataObj.city}} --> {{userDataObj.city.name ? userDataObj.city.name : userDataObj.city === null ? \"Choose your City\" : userDataObj.city}}</div><div ng-show=cityEdit class=list-detail style=\"width: 200px; background: transparent;    height: 35px;   \n                align-items: center;position: relative\"><input type=text ng-show=defaultField ng-model=otherCity ng-change=cityCheck(otherCity) ng-click=cityCheck(otherCity);$event.stopPropagation(); placeholder=\"Choose your City\" autocomplete=off autocomplete=chrome-off style=\"background: transparent\" onblur=\"angular.element(this).scope().blurCall(\'city\',event.target.value)\"> <input type=text ng-show=!defaultField ng-model=otherCityDefault ng-change=cityCheck(otherCityDefault) ng-click=cityCheck(otherCityDefault);$event.stopPropagation(); placeholder=\"Choose your City\" autocomplete=off autocomplete=chrome-off style=\"background: transparent\" onblur=\"angular.element(this).scope().blurCall(\'city\',event.target.value)\"><ul class=custom-city-select ng-show=showCityList><li style=\"font-size: 14px\" ng-repeat=\"x in searchCities\" ng-click=onSelectCity(x);$event.stopPropagation();>{{x.name}}</li></ul></div><br></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-show=!cityEdit ng-click=\"fixEditing(\'city\')\">Edit</a><!-- <a\n              class=\"edit-button-color\"\n              href=\"JavaScript:void(0);\"\n              ng-click=\"discard(); $event.stopPropagation();\"\n              ng-show=\"cityEdit\"\n              >Discard</a\n            > --> <a class=save-button-color href=JavaScript:void(0); ng-show=cityEdit ng-click=\"updateProfile(\'city\',defaultField ? otherCity : otherCityDefault); $event.stopPropagation();\">Save</a></div></div><div class=\"list-item flex-view justify-content-between\" ng-click=\"uniEdit ? \'\' : fixEditing(\'university\')\"><div class=\"list-data flex-view\"><div class=list-label>Institute <img ng-if=\"userDataObj.university === \'\' || userDataObj.university === null \" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\"></div><div class=list-detail ng-show=!uniEdit>{{userDataObj.university === null ? \"Choose your Institute\" : userDataObj.university}}</div><div ng-show=uniEdit class=list-detail style=\"width: 240px; background: transparent;    height: 35px;align-items: center;    position: relative\"><input type=text ng-show=defaultField ng-model=otherUni ng-change=uniCheck(otherUni) ng-click=uniCheck(otherUni);$event.stopPropagation(); placeholder=\"Choose your Institute\" autocomplete=off autocomplete=chrome-off style=\"background: transparent\" onblur=\"angular.element(this).scope().blurCall(\'university\',event.target.value)\"> <input type=text ng-show=!defaultField ng-model=otherUniDefault ng-change=uniCheck(otherUniDefault) ng-click=uniCheck(otherUniDefault);$event.stopPropagation(); placeholder=\"Choose your Institute\" autocomplete=off autocomplete=chrome-off style=\"background: transparent\" onblur=\"angular.element(this).scope().blurCall(\'university\',event.target.value)\"><ul class=custom-city-select ng-show=showUniList><li style=\"font-size: 14px\" ng-repeat=\"x in searchUniversities\" ng-click=onSelectUni(x);$event.stopPropagation();>{{x.name}}</li></ul></div><br><span style=\"color: rgb(226, 4, 4);\n                  font-weight: 400;\n                  font-size: 14px;    display: flex;\n    align-items: center\" ng-show=\"selectedUni.value.id === 0.1 && uniEdit\"><!-- <span ng-if=\"errorMessage.length == 0\"\n                >Edit your name here.</span\n              > --> <span ng-if=\"errorMessage.length > 0\">{{errorMessage}}</span></span></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-show=!uniEdit ng-click.stop=\"fixEditing(\'university\')\">Edit</a><!-- <a\n              class=\"edit-button-color\"\n              href=\"JavaScript:void(0);\"\n              ng-click=\"discard(); $event.stopPropagation();\"\n              ng-show=\"uniEdit\"\n              >Discard</a\n            > --> <a class=save-button-color href=JavaScript:void(0); ng-show=uniEdit ng-click=\"updateProfile(\'university\',defaultField ? otherUni : otherUniDefault); $event.stopPropagation();\">Save</a></div></div><div class=\"list-item flex-view justify-content-between\" ng-if=\"platform_reactApp_new && appConfigs && appConfigs.showDeleteAccount\" ng-click=deleteAccount()><div class=\"list-data flex-view\"><div style=\"width: 130px\">Account Deletion</div></div><div class=list-btn><a class=edit-button-color href=JavaScript:void(0); ng-click=deleteAccount() style=\"width: 150px; margin-top: 15px\">Delete Account</a></div></div></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=settingType.contantInfo><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Contact Information</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>Contact Information</h3><p>Communication will make our bond stronger. Let us know the best way to reach you.</p></div></div><div class=\"tab-content-main profile-content-responsive-hide\"><div class=tab-content-list><div class=\"list-item flex-view justify-content-between\" ng-click=\"emailEdit  ? \'\' : (userDataObj.provider != \'email\' || userDataObj.provider != \'phone\') ? \'\' : fieldEditing(\'email\')\"><div class=\"list-data flex-view\"><div class=list-label>Email <img ng-if=\"userDataObj.confirmed_at === null || userDataObj.confirmed_at === \'\' \" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\" title=\"Verify your email\"></div><div class=list-detail ng-show=!emailEdit style=\"display: flex\"><div class=email-fix id=email>{{userDataObj.email}}</div><img ng-show=userDataObj.confirmed_at style=\"width: 15px; height: 15px\" src=\"../../images/Icon - Done or Correct.svg\" alt=\"\"></div><input type=text class=\"body-2 email-Up-fix\" ng-model=userEmail ng-show=emailEdit onblur=\"angular.element(this).scope().blurCall(\'email\',event.target.value)\"><p ng-if=\"errorMessage && emailUpdated\" style=\"font-size: 12px; color: red; margin-left: 10px;\n                  margin: 0\">{{errorMessage}}</p></div><div class=list-btn><a v-show=!emailVerified href=JavaScript:void(0); class=\"btn-verified btn-filled\" ng-if=\"userDataObj.confirmed_at && !emailEdit\">Verified</a> <a v-show=!emailVerified href=JavaScript:void(0); class=btn-filled ng-click=\"openEmailVerification(); $event.stopPropagation();\" ng-if=\"!emailEdit && !userDataObj.confirmed_at\">Verify</a><!-- <span v-show=\"emailVerified\" style=\"color:#03901A;\">Verified</span>\n                 && !userDataObj.confirmed_at --> <a href=JavaScript:void(0); class=edit-button-color ng-show=\"!emailEdit && (userDataObj.provider == \'email\' || userDataObj.provider == \'phone\')\" ng-click=\"fieldEditing(\'email\'); $event.stopPropagation();\">Edit</a> <a class=edit-button-color href=JavaScript:void(0); ng-click=\"discard(); $event.stopPropagation();\" ng-show=emailEdit>Discard</a> <a class=save-button-color href=JavaScript:void(0); ng-show=emailEdit ng-click=\"updateProfile(\'email\',userEmail); $event.stopPropagation();\">Save</a></div></div><div class=\"list-item flex-view justify-content-between\" ng-click=\"phoneEdit ? \'\' : fieldEditing(\'phone\')\"><div class=\"list-data flex-view\"><div class=list-label>Phone <img ng-if=\"userDataObj.phone_confirmed_at === null || userDataObj.phone_confirmed_at === \'\' \" src=\"./../../images/info icon.svg\" style=\"width: 15px; margin-left: 5px; margin-bottom: 0px\" title=\"Verify your phone\"></div><div class=list-detail id=phone ng-show=!phoneEdit>{{userDataObj.uid_phone ? userDataObj.uid_phone : \"Enter Phone Number\"}} <img ng-show=userDataObj.phone_confirmed_at style=\"width: 15px; height: 15px; margin-bottom: 10px\" src=\"../../images/Icon - Done or Correct.svg\" alt=\"\"></div><div class=mobile-fix-phone><input type=text ng-if=phoneEdit id=country class=country-code-dropdown> <input type=text class=body-2 ng-model=userDataObj.phone ng-show=phoneEdit style=\"background: transparent; margin-left: 25px\" onblur=\"angular.element(this).scope().blurCall(\'phone\',event.target.value)\"></div><br><p ng-if=\"errorMessage && phoneUpdated\" style=\"font-size: 12px; color: red; margin-left: 10px\">{{errorMessage}}</p></div><div class=list-btn><a v-show=phoneVerified href=JavaScript:void(0); class=\"btn-verified btn-filled\" ng-if=\"userDataObj.phone_confirmed_at && !phoneEdit \">Verified</a> <a v-show=phoneVerified href=JavaScript:void(0); class=btn-filled ng-click=\"openPhoneVerification(); $event.stopPropagation();\" ng-if=\"!phoneEdit && !userDataObj.phone_confirmed_at\">Verify</a><!-- <span v-show=\"!phoneVerified\" style=\"color:#03901A;\">Verified</span>\n                && !userDataObj.phone_confirmed_at --> <a class=edit-button-color href=JavaScript:void(0); ng-show=\"!phoneEdit \" ng-click=\"fieldEditing(\'phone\'); $event.stopPropagation();\">Edit</a> <a class=edit-button-color href=JavaScript:void(0); ng-click=\"discard(); $event.stopPropagation();\" ng-show=phoneEdit>Discard</a> <a class=save-button-color href=JavaScript:void(0); ng-show=phoneEdit ng-click=\"updateProfile(\'phone\',userDataObj.phone); $event.stopPropagation();\">Save</a></div></div></div></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=\"settingType.activeDevices && !guest\"><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Devices Info</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>Active devices information</h3><p>We value your privacy. Following are the devices your device is being used on.</p></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=\"tab-content-main profile-content-responsive-hide\" ng-show=showData><div class=tab-content-list><div class=\"list-item flex-view justify-content-between\" ng-repeat=\"sessions in userSessions\"><div class=\"list-data flex-view\" style=\"display: inline-flex !important\"><div class=list-icon><img src=../../images/window-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Windows\')\" alt=\"\"> <img src=../../images/apple-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Mac\')\" alt=\"\"> <img src=../../images/apple-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'iOS\')\" alt=\"\"> <img src=../../images/phone-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Android\')\" alt=\"\"> <img src=../../images/phone-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Mobile App\')\" alt=\"\"> <img src=../../images/phone-icon.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'BlackBerry\')\" alt=\"\"> <img src=../../images/linux.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Linux\')\" style=\"height: 24px\" alt=\"\"> <img src=../../images/linux.svg ng-if=\"((sessions || {}).device_detail || {}).browser.includes(\'Ubuntu\')\" style=\"height: 24px\" alt=\"\"></div><div class=list-detail><p style=\"font-size: 18px\">{{((sessions || {}).device_detail || {}).browser}} <span style=\"font-size: 16px\" class=current-deivce ng-if=\"sessions.session === userToken\">(Currently logged in)</span></p></div></div><div class=list-btn><button ng-click=logoutFromDevice(sessions) class=btn-emptyyy ng-if=\"sessions.session !== userToken\">Logout</button></div></div></div><div class=list-btn style=\"margin: 30px 0px; text-align: end\" ng-if=\"(userSessions || []).length > 1\"><a href=JavaScript:void(0); class=\"logout-button btn-filled\" ng-click=allLogoutPopup()>Logout from all devices except current</a></div></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=\"settingType.yourAccount && !guest\"><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Accounts Info</h4></div></div><div style=\"margin-left: auto;\n              margin-right: auto;\n              background: #fff;\n              padding-top: 10px;\n              padding-bottom: 10px\"></div></div><!-- responsive --><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>Transfer your courses</h3><p>Transfer all your active accounts in single account.</p></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=\"tab-content-main profile-content-responsive-hide\" ng-if=showData><p ng-show=\"(userAccounts || []).length>1\">It seems that you have multiple Nearpeer accounts associated with same ID: <b>{{userDataObj.email}}</b>. You can merge all your accounts with your Currently logged in account (highlighted below):.</p><div class=\"table-responsive-profile table_overflow_class\" style=\"overflow: auto\"><table class=\"table tab-table\" style=\"min-width: 900px\"><thead><tr class=table-row><th style=\"padding-left: 20px !important\">Login Method</th><th>Courses Unlocked</th><th>Bundles Unlocked</th><th>Modules Unlocked</th><th>Status</th></tr></thead><tbody><tr class=table-row ng-class=\"{\'current\' : account.id == userDataObj.id}\" ng-repeat=\"account in userAccounts\"><td style=\"padding-left: 20px !important;\n                      border-radius: 0px !important\">{{account.provider}}</td><td>{{account.purchasedCoursesCount}}</td><td>{{account.purchasedBundleCount}}</td><td>{{account.purchasedModuleCount}}</td><td><span ng-if=\"account.id === userDataObj.id\">Currently logged in</span> <span ng-if=\"account.id != userDataObj.id\">{{account.lastLogin | date:\'MM/dd/yyyy\'}}</span> <span ng-if=\"account.id != userDataObj.id && !account.lastLogin\">N/A</span> &nbsp;&nbsp;<img style=\"width: 20px; height: 20px\" src=\"../../images/Icon - Done-Blue.svg\" ng-if=\"account.id === userDataObj.id\" alt=\"\"></td></tr></tbody></table></div><!-- <div\n            ng-if=\"mergeTooltip\"\n            class=\"list-btn\"\n            style=\"margin: 30px 0px; text-align: end\"\n            ng-show=\"(userAccounts || []).length > 1\"\n          >\n            <a\n              href=\"JavaScript:void(0);\"\n              class=\"btn-filled\"\n              ng-click=\"mergeAccountCall()\"\n              >Transfer your accounts</a\n            >\n          </div> --></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-if=\"settingType.emailSubscription && !guest\"><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Subscriptions</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h2 class=profile-heading-size>Manage your subscriptions</h2><p class=profile-subheading-size>Manage your all Nearpeer subscriptions here.</p></div></div><div class=\"tab-content-main profile-content-responsive-hide\"><div class=tab-content-list><div ng-repeat=\"subscription in emailSubscriptionList\" class=\"list-item flex-view justify-content-between\"><div class=\"list-data flex-view\" style=\"display: inline-flex !important\"><div ng-show=updateSubscriptions><input class=checkbox-size type=checkbox id={{subscription.name}} ng-click=\"subscription.name === \'System Default Emails\' ? disabledProp() : \'\' \"> &nbsp;&nbsp;</div><div><p class=list-detail>{{subscription.name}}</p><p class=list-detail-minor>{{subscription.description}}</p></div></div></div></div><div class=\"profile-adjustment list-btn\"><a href=JavaScript:void(0); ng-if=!updateSubscriptions class=\"logout-button btn-filled\" ng-click=manageEmailSubscriptions()>Manage subscriptions</a> <a href=JavaScript:void(0); ng-if=updateSubscriptions class=\"logout-button btn-filled\" ng-click=updateEmailSubscriptions()>Update email setting</a></div></div></div><div id=orders-div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=settingType.myOrder><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">My Orders</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>My Orders</h3><p>A quick snapshot of your purchase history at Nearpeer.</p></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=\"showData && (userOrders||[]).length\" class=\"tab-content-main profile-content-responsive-hide\"><div class=blocks-holder><div class=\"row cards-responsive\" style=\"display: flex\"><div class=col><div class=block-profile style=\"margin-left: 10px;\n                      margin-right: 10px;\n                      min-width: 200px;\n                      max-width: 350px\"><div class=text-1><span>Total orders</span><br></div><div class=text-order><span>{{totalCount}}</span></div></div></div><div class=col><div class=block-profile style=\"margin-left: 10px;\n                      margin-right: 10px;\n                      min-width: 200px;\n                      max-width: 350px\"><div class=text-1><span>Active Orders</span><br></div><div class=text-total-amount-paid><span>{{totalPaidAmount.active_orders}}</span></div></div></div><!-- <div class=\"col\">\n                <div\n                  class=\"block-profile\"\n                  style=\"\n                    margin-left: 10px;\n                    margin-right: 10px;\n                    min-width: 200px;max-width: 350px;\n                  \"\n                >\n                  <div class=\"text-1\"><span>User balance</span><br /></div>\n                  <div class=\"text-user-balance\"><span>Rs.{{userOrders[0].user_balance}}</span></div>\n                </div>\n              </div> --><div class=col><div class=block-profile style=\"margin-left: 10px;\n                      margin-right: 10px;\n                      min-width: 200px;\n                      max-width: 350px\"><div class=text-1><span>Coupon Amount Used</span><br></div><div class=text-user-coupen><span>Rs. {{totalPaidAmount.coupon ? totalPaidAmount.coupon : 0}}</span></div></div></div><div class=col><div class=block-profile style=\"margin-left: 10px;\n                      margin-right: 10px;\n                      min-width: 200px;\n                      max-width: 350px\"><div class=text-1><span>Total Coupons Used</span><br></div><div class=text-total-coupons-used><span>{{totalPaidAmount.coupons_count ? totalPaidAmount.coupons_count : 0 }}</span></div></div></div><div class=col><div class=block-profile style=\"margin-left: 10px;\n                      margin-right: 10px;\n                      min-width: 200px;\n                      max-width: 350px\"><div class=text-1><span>Total amount paid</span><br></div><div class=text-total-amount-paid><span>Rs. {{totalPaidAmount.amount}}</span></div></div></div></div></div><br><div class=\"table-responsive-profile col-xs-12 table_overflow_class\" style=\"overflow-x: auto; overflow-y: auto; padding: 0px\"><table class=\"table table-bordered\" style=\"min-width: 990px; width: 100%; padding: 0px\"><thead style=\"background: #eaeaea; vertical-align: middle\"><tr><th class=\"p-20 ver-middle\" style=\"min-width: 100px; max-width: 100px\">Status</th><th class=\"p-20 ver-middle\">Order Id</th><th class=\"p-20 ver-middle\" style=\"min-width: 150px; max-width: 150px\">Course Name</th><th class=\"p-20 ver-middle\" style=\"min-width: 150px; max-width: 150px\">Module Name</th><th class=\"p-20 ver-middle\" style=\"min-width: 150px; max-width: 150px\">Bundle Name</th><th class=\"p-20 ver-middle\">Price</th><th class=\"p-20 ver-middle\">Purchased At</th></tr></thead><tbody style=\"background: #fff\"><!-- <tr>\n                  <td class=\"p-20\">123</td>\n                  <td class=\"p-20\">MDCAT BAsic Course</td>\n                  <td class=\"p-20\">Module 23</td>\n                  <td class=\"p-20\">N/A</td>\n                  <td class=\"p-20 status-failed\">Failed</td>\n                  <td class=\"p-20\">9000</td>\n                  <td class=\"p-20\">12/02/2029</td>\n\n                </tr> --><!-- ng-show=\"order.status===\'paid\' || order.status===\'pending\' || order.status===\'failed\' || order.status===\'merged\'\" --><tr ng-repeat=\"order in userOrders\"><td class=p-20><span style=\"display: flex;\n                  justify-content: center\" ng-click=\"order.bundle ? openBundle(order.bundle) : order.course_index_url ? openCourse(order.course_index_url) : \'\'\" style=\"cursor: pointer\" ng:class=\"{\'status-failed\' : order.status === \'failed\' || order.status === \'canceled\' ,\'status-expired\' : order.status === \'expired\', \'status-success\' : order.status == \'paid\' ,\'status-placed\' : order.status == \'placed\',\'status-disabled\' : order.status == \'merged\'}\">{{order.status == \'merged\' ? \'Disabled\' : order.status}}</span></td><td class=p-20>{{order.ref_no}}</td><td class=p-20>{{order.course ? order.course : \"N/A\"}}</td><td class=p-20>{{order.module ? order.module : \"N/A\" }}</td><td class=p-20>{{order.bundle ? order.bundle : \"N/A\"}}</td><!-- <td class=\"p-20\">{{order.user_balance}}</td> --><td class=p-20>{{order.price}}</td><!-- <td class=\"p-20\">{{order.coupon_balance}}</td> --><td class=p-20>{{order.time | date:\'MM/dd/yyyy\'}}</td><!-- <td><button ng-click=\"inquireStatus($index)\" ng-hide=\"order.status == \'paid\' || order.status == \'failed\'\">Update\n                      Status</button></td> --></tr><!-- <tr>\n                  <td class=\"p-20\">123</td>\n                  <td class=\"p-20\">MDCAT BAsic Course</td>\n                  <td class=\"p-20\">Module 23</td>\n                  <td class=\"p-20\">N/A</td>\n                  <td class=\"p-20 status-success\">Success<br />Paid</td>\n                  <td class=\"p-20\">9000</td>\n                  <td class=\"p-20\">12/02/2029</td>\n                </tr>\n                <tr>\n                  <td class=\"p-20\">123</td>\n                  <td class=\"p-20\">MDCAT BAsic Course</td>\n                  <td class=\"p-20\">Module 23</td>\n                  <td class=\"p-20\">N/A</td>\n                  <td class=\"p-20 status-placed\">\n                    Awaiting Payment<br />(Placed)\n                  </td>\n                  <td class=\"p-20\">9000</td>\n                  <td class=\"p-20\">12/02/2029</td>\n                </tr>\n                <tr>\n                  <td class=\"p-20\">123</td>\n                  <td class=\"p-20\">MDCAT BAsic Course</td>\n                  <td class=\"p-20\">Module 23</td>\n                  <td class=\"p-20\">N/A</td>\n                  <td class=\"p-20 status-expired\">Expired</td>\n                  <td class=\"p-20\">9000</td>\n                  <td class=\"p-20\">12/02/2029</td>\n                </tr> --></tbody></table></div><div class=loader ng-hide=ordersLoaded><img src=images/squares.gif></div></div><div ng-if=\"showData && !(userOrders||[]).length\" style=\"text-align: center; margin-top: 5%\"><img src=../../images/Group-22017.svg alt=\"NP banner\"><h2>No order found</h2><span>Looks like you have not made any order yet</span><div class=list-btn style=\"margin-top: 30px; align-items: center !important\"><a href=JavaScript:void(0); ng-click=\"goToState(\'Landing\')\" class=\"logout-button btn-filled\">Explore Courses</a></div></div></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=settingType.quizzes><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Quizzes</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=\"showData && !(quizzes || []).length\" style=\"text-align: center; margin-top: 5%\"><img src=../../images/no-quiz-attempted.svg alt=\"NP banner\"><h2>No quiz history found</h2><span>Looks like you have not attempted any quiz yet</span><div class=list-btn style=\"margin-top: 30px;align-items: center !important\"><a href=JavaScript:void(0); ng-click=\"goToState(\'Landing\')\" class=\"logout-button btn-filled\">Explore Courses</a></div></div><div ng-if=\"showData && (quizzes || []).length\"><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>Quiz Attempts</h3><p>Practice is the key to success. Here is the summary of your progress on quizes so far.</p></div></div><div class=\"tab-content-main profile-content-responsive-hide\"><div class=\"col blocks-holder\"><div class=\"row cards-responsive-quiz\" style=\"display: flex\"><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Attempted Quizzes</span><br></div><div class=text-total-amount-paid><span>{{quizStats.totalAttempts}} Quiz</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Average Percentage</span><br></div><div class=text-order><span>{{quizStats.average}} %</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Time Spent</span><br></div><div class=text-user-balance><span ng-show=\"(quizStats.timeSpent / 60) >= 1\">{{quizStats.timeSpent ? (quizStats.timeSpent / 60).toFixed(0) : 0}} mins</span> <span ng-show=\"(quizStats.timeSpent / 60) < 1\">{{quizStats.timeSpent ? (quizStats.timeSpent).toFixed(0) : 0}} sec</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Attempted Questions</span><br></div><div class=text-user-balance style=\"color: #1c393e\"><span>{{quizStats.questionsCount ? quizStats.questionsCount : 0 }}</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Correct Questions</span><br></div><div class=text-total-amount-paid><span>{{quizStats.correctQuestion ? quizStats.correctQuestion : 0 }}</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Incorrect Questions</span><br></div><div class=text-order><span>{{quizStats.incorrectQuestion ? quizStats.incorrectQuestion : 0 }}</span></div></div></div><!-- <div class=\"col block-profile-quizzes\">\n                <div class=\"block-profile\" style=\"margin-left: 0px\">\n                  <div class=\"text-1\"><span>My Modules</span><br /></div>\n                  <div class=\"text-user-coupen\"><span>87</span></div>\n                </div>\n              </div> --><!-- <div class=\"col block-profile-quizzes\">\n                <div class=\"block-profile\" style=\"margin-left: 0px\">\n                  <div class=\"text-1\"><span>My Bundles</span><br /></div>\n                  <div class=\"text-total-bundels\"><span>40</span></div>\n                </div>\n              </div> --></div></div><br><div class=\"table-responsive-profile table_overflow_class\" style=\"overflow-x: auto; overflow-y: auto; padding-left: 0px\"><table class=\"table table-bordered\" style=\"min-width: 990px; width: 100%; padding: 0px\"><thead style=\"background: #eaeaea; vertical-align: middle\"><tr><th class=\"p-20 ver-middle\">Result</th><th class=\"p-20 ver-middle\">No</th><th class=\"p-20 ver-middle\">Course Name</th><th class=\"p-20 ver-middle\">Quiz Name</th><th class=\"p-20 ver-middle\">Score</th><th class=\"p-20 ver-middle\">Time Taken</th><th class=\"p-20 ver-middle\">Date</th><th class=\"p-20 ver-middle\">Submited Time</th></tr></thead><tbody style=\"background: #fff\"><!-- <tr>\n                  <td class=\"p-20\">123</td>\n                  <td class=\"p-20\">MDCAT BAsic Course</td>\n                  <td class=\"p-20\">Module 23</td>\n                  <td class=\"p-20\">23</td>\n                  <td class=\"p-20\">13 mint</td>\n                  <td class=\"p-20\">12/12/2022</td>\n                  <td class=\"p-20\">12:23 AM</td>\n                  <td class=\"p-20 status-view\">View</td>\n                </tr> --><tr ng-repeat=\"quiz in quizzes\"><td class=p-20><p style=\"display: flex;\n                      justify-content: center\" class=status-view ng-click=viewQuiz(quiz)>View</p></td><td class=p-20>{{$index+1}}</td><td class=p-20>{{quiz.quiz.course.name}}</td><td class=p-20>{{quiz.quiz.name}}</td><td class=p-20>{{quiz.correct_percentage}} %</td><td class=p-20><span ng-show=\"(quiz.time_spent / 60) >= 1\">{{(quiz.time_spent / 60).toFixed(0)}} mins</span> <span ng-show=\"(quiz.time_spent / 60) < 1\">{{(quiz.time_spent).toFixed(0)}} sec</span></td><td class=p-20>{{quiz.created_at | date:\'mediumDate\' }}</td><td class=p-20>{{quiz.created_at | date:\'shortTime\'}}</td></tr></tbody></table></div><div class=loader ng-hide=quizzesLoaded><img src=images/squares.gif></div></div></div></div><div class=\"profile-content-wrapper profile-content-responsive wow fadeInUp\" ng-show=settingType.videosWatched><!-- responsive --><div style=\"padding: 0px\" class=display-none-profile><div class=responsive-submenu><div class=\"col-xs-4 col-sm-4 col-md-5\" style=\"margin-top: auto; margin-bottom: auto\"><a ng-if=!platform_reactApp_new style=\"color: #000; margin-left: 15px\" ng-click=backstage()><i class=\"fas fa-angle-left\" style=\"padding-right: 10px\"></i>Back</a></div><div class=\"col-xs-8 col-sm-8 col-md-7\" style=\"padding-left: 0px\"><h4 style=\"font-weight: 400\">Videos</h4></div></div><div style=\"background: #fff; padding-top: 10px; padding-bottom: 10px\"><div class=avatar-upload style=\"margin-left: auto; margin-right: auto\"></div></div></div><!-- responsive --><div class=loader ng-hide=showData><img src=images/squares.gif></div><div style=\"text-align: center; margin-top: 5%\" ng-if=\"showData && !(watchedVideos || []).length\"><img style=\"margin-bottom: 20px\" src=../../images/Frame.svg alt=\"NP banner\"><h2>No videos history found</h2><span>Looks like you have not watched any video yet.</span><div class=list-btn style=\"margin-top: 30px;align-items: center !important\"><a href=JavaScript:void(0); ng-click=\"goToState(\'Landing\')\" class=\"logout-button btn-filled\">Explore Courses</a></div></div><div ng-if=\"showData && (watchedVideos || []).length\"><div class=\"tab-content-header profile-content-responsive-hide\"><div class=content-title><h3>Videos history</h3><p>Track your videos progress here. A quick snapshot of your watched videos at Neapeer.</p></div></div><div class=\"tab-content-main profile-content-responsive-hide\"><div class=\"col blocks-holder\"><div class=\"row cards-responsive-quiz\" style=\"display: flex\"><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Videos Completed</span><br></div><div class=text-total-amount-paid><span>{{(videoStats.watchedVideosCount)}}</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Overall Progress</span><br></div><div class=text-order><span>{{videoStats.overallProgress}} %</span></div></div></div><div class=\"col block-profile-quizzes\"><div class=block-profile style=\"margin-left: 0px\"><div class=text-1><span>Watch Time</span><br></div><div class=text-order><span>{{videoStats.watchedTime ? ((videoStats.watchedTime)/60).toFixed(0) + \' mins\' : 0}}</span></div></div></div></div></div><br><div class=\"table-responsive-profile table_overflow_class\" style=\"overflow-x: auto; overflow-y: auto; padding-left: 0px\"><table class=\"table table-bordered\" style=\"min-width: 990px; width: 100%; padding: 0px\"><thead style=\"background: #eaeaea; vertical-align: middle\"><tr><th class=\"p-20 ver-middle\">Video</th><th class=\"p-20 ver-middle\">Sr.No</th><th class=\"p-20 ver-middle\">Course Name</th><th class=\"p-20 ver-middle\">Video Name</th><th class=\"p-20 ver-middle\">Date</th><th class=\"p-20 ver-middle\">Time</th><th class=\"p-20 ver-middle\">Last Watched Time</th></tr></thead><tbody style=\"background: #fff\"><tr ng-repeat=\"videos in watchedVideos\"><td class=p-20 ng-click=viewVideo(videos)><p style=\"display: flex;\n                      justify-content: center\" class=status-view ng-click=viewVideo(videos)>Watch</p></td><td class=p-20>{{$index+1}}</td><td class=p-20>{{videos.course.name}}</td><td class=p-20>{{videos.video.name}}</td><td class=p-20>{{videos.updatedAt | date:\'mediumDate\'}}</td><td class=p-20>{{videos.updatedAt | date:\'shortTime\'}}</td><td class=p-20>{{(videos.lastWatchTime/60).toFixed(0)}} out of {{(videos.duration/60).toFixed(0)}} mins</td></tr></tbody></table></div><div class=loader ng-hide=videosLoaded><img src=images/squares.gif></div></div></div></div></div></div></div>");
$templateCache.put("app/qistpay-response/qistpay-response.html","<div></div>");
$templateCache.put("app/quiz/quiz.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=timer-fix ng-show=\"(showData && timerFlag)\"><h5>Timer</h5><timer countdown=endtime autostart=false max-time-unit=\"\'hour\'\" finish-callback=finished() interval=1000>{{hhours}}:{{mminutes}}:{{sseconds}}</timer></div><div class=timer-fix ng-show=\"!(showData && timerFlag)\"><h5>Timer</h5><timer interval=1000 autostart=false>{{hours}}:{{minutes}}:{{seconds}}</timer></div><button ng-hide=hideStartButton class=start-button-quiz ng-click=startQuiz()>Start Quiz</button><!-- <span>Total Questions: {{maxPage}}</span>\n<span>Total Time: {{totalTime}}</span> --><div id=dualQuizId><div class=dual-quiz-one ng-show=\"quizStarted && content\"><p ng-bind-html=\"content | to_trusted\"></p></div><div class=quiz-frnt id=quizDual ng-show=quizStarted style=\"padding-top: 50px\"><div class=quiz-heading><h1>Quiz</h1><h2>{{quizData.quizName}}</h2><p>Answer the following questions:</p></div><div class=quiz ng-repeat=\"question in quizData.questions\" ng-class=\" checkClass($index+1)\"><div class=quiz-cont><div class=row style=padding-bottom:30px><h1 style=float:left>QUESTION <span ng-hide=content>{{page+1}}/{{maxPage}}:</span><span ng-show=content>{{$index+1}}:</span></h1><div class=search-container style=float:right><form><input style=\"width:100px; margin: 5px\" type=number placeholder=\"Question no.\" id=jump-to-question> <button ng-click=jumpToQuestion()><span>GO</span></button></form></div></div><p ng-bind-html=\"question.text | to_trusted\"></p><!-- <p>  <span class=\"quiz-img\"><img ng-show=\"question.image_url\" ng-src={{question.image_url}}/></span></p> --><div style=\"position: relative\"><span id=mathquiz{{$index+1}} ng-if=question.mathtext>{{ConvertText(\"mathquiz\"+($index+1))}}{{question.mathtext}}</span><div style=\"position: absolute; width: 100%; height: 100%\" ng-click=selectOptions($index,$parent.$index)></div></div><div class=\"quiz-img question-img\"><img ng-show=question.image_url ng-src={{question.image_url}}></div><div class=col-lg-12><ul class=clearfix><li ng-readonly=true class=\"one math-operator\" ng-repeat=\"option in question.options | orderBy:sortingoptions:true\"><p style=\"position: relative\" ng-class=\"{\'answer-active\': checkOption(question.choosenAnswer,$index,$parent.$index)}\" ng-click=selectOptions($index,$parent.$index)><span ng-model=question.choosenAnswer>{{bulletsArray($index)}}</span><label class=quiz-label id=\"{{\'mathquiz-options\'+$parent.$index+\'\'+($index+1)}}\">{{ConvertText(\"mathquiz-options\"+\'\'+$parent.$index+\'\'+($index+1))}}{{option.answer}}</label><span class=quiz-img><img ng-show=option.image_url ng-src={{option.image_url}}></span></p><div style=\"position: absolute; width: 100%; height: 100%\" ng-click=selectOptions($index,$parent.$index)></div><p></p></li></ul></div></div></div><div class=col-lg-12><nav aria-label=... ng-hide=content><ul class=\"pager pager-quiz\"><li ng-show=\"page > 0\" class=previous><a href=\"\" ng-click=questionCard(page-1)><span aria-hidden=true>Previous</span></a></li><li ng-show=\"page < maxPage-1\" class=next><a href=\"\" ng-click=questionCard(page+1)><span aria-hidden=true>Next</span></a></li><li ng-show=\"page == maxPage-1\" class=next><a style=background-color:red href=\"\" ng-click=submitAlert(quizData)><span aria-hidden=true>Finish</span></a></li></ul></nav><nav aria-label=... ng-show=content><ul class=\"pager pager-quiz\"><li class=next><a style=background-color:red href=\"\" ng-click=submitAlert(quizData)><span aria-hidden=true>Finish</span></a></li></ul></nav></div></div></div><div ng-class=\"{paddingAdd: (!quizStarted)}\"></div>");
$templateCache.put("app/redirectLinkCheck/redirectLinkCheck.html","<div class=\"col-md-12 mb-50 ng-scope\"></div>");
$templateCache.put("app/registration/forgotpassword.html","<div class=layout><div class=page-header><div class=container><div class=row><h1 class=header-title>Forgot Password</h1><h3>Enter your email below</h3></div></div><!-- container --></div><div class=main><div class=container><div class=mid-container><form ng-init=\"passwordResetForm={}\"><div class=register-form><div class=section><div class=\"form-group row\"><label for=example-text-input class=\"col-xs-12 col-sm-3 col-form-label\">Email</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=passwordResetForm.email class=form-control type=text></div></div><div class=button-set><button style={{buttonColor}} ng-disabled=requestSent ng-click=resetPassword(passwordResetForm)>Reset Password</button><span ng-show=loader><img src=images/squares.gif width=30px height=30px></span></div></div><!-- register form --></div></form></div><!-- mid container --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/registration/paymentStatus.html","<div class=payment-success-box style=\"border-left: 0px !important; margin-top: 70px\" ng-if=\"status === \'true\'\"><div class=\"f-c d-col\" style=\"align-items: center\"><img style=\"width: 70px\" src=../../images/payment/payment-successfull.png><div style=\"margin: 10px 0\"><h3 style=\"font-weight: bold; color: #38b16c\">Payment Successful</h3></div><div><img style=\"height: 200px; min-width: 225px\" src=../../images/payment/frame_1.png></div><button class=\"btn-contained btn-proceed\" style=\"width: 200px\" ng-click=gotoCourse()>Start Studying</button></div></div><div class=payment-success-box style=\"border-left: 0px !important; margin-top: 70px\" ng-if=\"status === \'false\'\"><div class=\"f-c d-col\" style=\"align-items: center\"><img style=\"width: 70px\" src=../../images/cross_red_.svg><div style=\"margin: 10px 0\"><h3 style=\"font-weight: bold; color: red\">Payment Failed</h3></div><div><img style=\"height: 200px; min-width: 225px\" src=../../images/payment/frame_1.png></div><button class=\"btn-contained btn-proceed\" style=\"width: 200px\" ng-click=gotoCourse()>Start Studying</button></div></div>");
$templateCache.put("app/registration/register.html","<div class=layout><div class=page-header><div class=container><div class=row><h1 class=header-title>Register</h1><h3>Enter your details below</h3></div></div><!-- container --></div><div class=main><div class=container><div class=mid-container><div class=section-title><h4>Personal Information</h4></div><form ng-init=\"registrationForm={}\"><div class=register-form><div class=section><div class=\"form-group row\"><label for=example-text-input class=\"col-xs-12 col-sm-3 col-form-label\">Full Name</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=registrationForm.full_name class=form-control type=text></div></div><div class=\"form-group row\"><label for=example-email-input class=\"col-xs-12 col-sm-3 col-form-label\">Email Address</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=registrationForm.email class=form-control type=text placeholder=someone@example.com></div></div><div class=password-fields><div class=\"form-group row\"><label for=example-tel-input class=\"col-xs-12 col-sm-3 col-form-label\">Contact No</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=registrationForm.phone placeholder=03XXXXXXXXX class=form-control type=text></div></div><div class=\"form-group row\"><label for=example-password-input class=\"col-xs-12 col-sm-3 col-form-label\">Password</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=registrationForm.password class=form-control type=password> <span class=text-danger><h4>{{message}}</h4></span></div></div><div class=\"form-group row\"><label for=example-password-input class=\"col-xs-12 col-sm-3 col-form-label\">Confirm Password</label><div class=\"col-xs-12 col-sm-9\"><input ng-model=registrationForm.confirmPassword class=form-control type=password style={{style}}></div></div><div class=button-set><button style=\"background-color: {{regBtnColor}}\" ng-disabled=disableRegBtn ng-click=submitRegistration(registrationForm)>Register</button></div></div><!-- register form --></div></div></form></div><!-- mid container --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/registration/updatepassword.html","<div class=layout ng-show=showData><div class=page-header><div class=container><div class=row><h1 class=header-title>Update Password</h1><h3>Enter your new password below</h3></div></div><!-- container --></div><div class=main><div class=container><div class=mid-container><form ng-init=\"updatePasswordForm={}\"><div class=register-form><div class=section><div class=\"form-group row\"><label for=example-text-input class=\"col-xs-12 col-sm-3 col-form-label\">Password</label><div class=\"col-xs-12 col-sm-9\"><input required ng-model=updatePasswordForm.password class=form-control type=password required></div></div><div class=\"form-group row\"><label for=example-text-input class=\"col-xs-12 col-sm-3 col-form-label\">Confirm Password</label><div class=\"col-xs-12 col-sm-9\"><input required ng-model=updatePasswordForm.password_confirmation class=form-control type=password required></div></div><div class=button-set><button ng-click=updatePassword()>Update Password</button></div></div><!-- register form --></div></form></div><!-- mid container --></div><!-- container --></div></div><div class=overlay-body></div>");
$templateCache.put("app/registration/userconfirmed.html","");
$templateCache.put("app/result/courseResult.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=resultDiv ng-show=showData><div class=heading-result><h1>Result</h1></div><div class=summary-table-inner style=display:none><h1>Summary table</h1><div class=summary-table><div class=summary-table-left><p>Total Questions</p><p>Attempted Questions</p><p>Correct Answers</p><p>Wrong Answers</p><p>Unattempted Qs</p><p>Total Time Allotted</p><p>Time finished this quiz in</p><p>Average time per question</p></div><div class=summary-table-right><span>{{result.summary.totalQuestions}}</span> <span>{{result.summary.attemptedQuestion}}</span> <span>{{result.summary.correctAnswers}}</span> <span>{{result.summary.wrongAnswers}}</span> <span>{{result.summary.unattemptedQuestions}}</span> <span>-</span> <span>{{getMinutes(result.summary.attemptedTime) + \' minute(s)\'}}</span> <span>{{result.summary.averageTime | removeExtraDecimalPoints}} second(s)</span></div></div></div><div class=\"pie-chart-main all-pie-chart-main\"><div class=pie-chart-result><p>{{avgAttemptedQuiz}}</p><span>*For the topics already covered</span><br><span>*Absolute Grading (not according<br>to real thresholds)</span></div><div class=pie-chart-result-right><p>{{avgTotalQuiz}}</p><span>*For the whole syllabus</span><br><span>*Absolute Grading (not according<br>to real thresholds)</span></div></div><div class=clr></div><div class=Relative-Scale><div class=Relative-Scale-cont><h1>Relative Scale</h1><div class=up-scale>0</div><div class=down-scale>100</div><div class=relativeScaleBar><div id=classAvg ng-style=\"{left: result.scale.average + \'%\'}\"><p>Class average:</p>{{result.scale.average | removeExtraDecimalPoints}}%</div><div id=yourAvg ng-style=\"{left: result.scale.percentage + \'%\'}\">You are here:{{result.scale.percentage | removeExtraDecimalPoints}}%</div></div></div></div><div class=clr></div><div class=\"review-quiz review-quiz-two review-quiz-three\"><h1>Topics</h1><div><p class=label><small>Covered </small><span ng-repeat=\"topic in result.topicsCovered\">{{topic.topicName}}</span></p><p class=labelinner><small>Remaining</small><span ng-repeat=\"topic in result.topicsNotCovered\">{{topic.topicName}}</span></p></div></div><div class=clr></div><div class=lineChart ng-hide=\"result.topicsCovered.length == 0\"><h1>Topic wise strengths and weaknesses (covered topics)</h1><canvas id=coveredTopicsRadarChart height=150></canvas></div><div class=clr></div><div class=lineChart><h1>Topic wise strengths and weaknesses (all topics)</h1><canvas id=allTopicsRadarChart height=150></canvas></div><div class=clr></div><div class=lineChart><h1>Topic wise strengths and weaknesses (all topics)</h1><canvas id=allTopicsBarChart height=150></canvas></div><div class=clr></div><div class=lineChart><h1>Performance trend</h1><canvas id=line class=\"chart chart-line\" chart-data=result.performance.scores chart-labels=result.performance.dates chart-series=series height=150></canvas><div class=date-chart><span ng-repeat=\"date in result.performance.dates\">{{date}}</span><br><span ng-repeat=\"marks in result.performance.scores track by $index\">{{marks}}</span></div></div><div class=clr></div><div class=\"review-quiz review-quiz-two\" style=display:none><h1>Area of improvement on sub-topic level</h1><div><p class=label>Area of improvement on sub-topic level</p><p class=labelinner><span ng-repeat=\"topic in result.weakTopics track by $index\">{{topic}}</span></p></div></div><div class=clr></div><div class=quiz-three><h1>Review Last Quiz</h1><div class=innnnr-cont><div class=\"quiz-admin-add quiz-result-course\" ng-click=goToQuizResult(quiz.resultid) ng-repeat=\"quiz in result.attemptedQuizzes\"><ul><li>{{quiz.quizname}}</li><li><label>COURSE</label><p>{{quiz.coursename}}</p></li><li><label>Module</label><p>{{quiz.modulename}}</p></li></ul></div></div></div></div><div class=clr></div><div class=study-suggestions style=\"display: none\"><h1>Study suggestions</h1><h3>Based on your performance on this quiz, we<br>suggest that you review following short lectures</h3><div class=box-styudy-sugestions><img src=images/machine-learing.png alt=\"\"><p>Business Finance Decisions By Imran Thakur</p></div><div class=box-styudy-sugestions><img src=images/machine-learing.png alt=\"\"><p>Business Finance Decisions By Imran Thakur</p></div><div class=box-styudy-sugestions><img src=images/machine-learing.png alt=\"\"><p>Business Finance Decisions By Imran Thakur</p></div></div><div class=clr></div><div class=button-result ng-show=showData><button ng-click=goToCourse()>Continue</button></div>");
$templateCache.put("app/result/result.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><h4 ng-hide=showData style=\"text-align: center; padding-bottom: 70px\">We are calculating your result. it will take almost <strong>1 minute</strong></h4><div class=resultDiv ng-show=showData><div class=heading-result><h1>Result</h1></div><div class=score><div class=left-score><p>Score:</p></div><div class=right-score><p class=green-main>{{result.score.correct + \'/\' + result.score.total}}</p><p class=green-main-inner>{{result.score.correct/result.score.total*100 | removeExtraDecimalPoints}}%</p><img ng-src={{imageUrl}}></div></div><div class=summary-table-inner><h1>Summary table</h1><div class=summary-table><table class=summary-table-left border=1><tr><td style=\"width: 50%\">Total Questions</td><td style=\"width: 50%\"><span>{{result.summary.totalQuestions}}</span></td></tr><tr><td style=\"width: 50%\">Attempted Questions</td><td style=\"width: 50%\"><span>{{result.summary.attemptedQuestion}}</span></td></tr><tr><td style=\"width: 50%\">Correct Answers</td><td style=\"width: 50%\"><span>{{result.summary.correctAnswers}}</span></td></tr><tr><td style=\"width: 50%\">Wrong Answers</td><td style=\"width: 50%\"><span>{{result.summary.wrongAnswers}}</span></td></tr><tr><td style=\"width: 50%\">Unattempted Qs</td><td style=\"width: 50%\"><span>{{result.summary.unattemptedQuestions}}</span></td></tr><tr><td style=\"width: 50%\">Total Time Allotted</td><td style=\"width: 50%\"><span>-</span></td></tr><tr><td style=\"width: 50%\">Time finished this quiz in</td><td style=\"width: 50%\"><span>{{getMinutes(result.summary.attemptedTime)}} min:sec(s)</span></td></tr><tr><td style=\"width: 50%\">Average time per question</td><td style=\"width: 50%\"><span>{{result.summary.averageTime | removeExtraDecimalPoints}} seconds(s)</span></td></tr></table></div></div><div class=pie-chart-main><div class=pie-chart-result><p>PIE CHART</p><canvas id=pie class=\"chart chart-pie\" chart-data=pieChartData chart-labels=pieChartLabels chart-colors=pieChartColors height=180 style=margin-top:25px></canvas><ul><li><span></span>Right answers</li><li><span></span>Wrong answers</li><li><span></span>Unattempted questions</li></ul></div><div class=pie-chart-result-right><h1>EXPECTED GRADE</h1><p>{{grade}}</p><span>*Absolute Grading (not according<br>to real thresholds)</span></div></div><div class=clr></div><div class=Relative-Scale><div class=Relative-Scale-cont><h1>Relative Scale</h1><div class=up-scale>0</div><div class=down-scale>100</div><div class=relativeScaleBar><div id=classAvg ng-style=\"{left: result.scale.average + \'%\'}\">Class average:{{result.scale.average | removeExtraDecimalPoints}}%</div><div id=yourAvg ng-style=\"{left: result.scale.percentage + \'%\'}\">You are here:{{result.scale.percentage | removeExtraDecimalPoints}}%</div></div></div></div><!-- | reverse --><div class=clr></div><div class=lineChart><h1>Performance trend</h1><div class=lineChartDiv><canvas id=line class=\"chart chart-line\" chart-data=lineChartData chart-labels=lineChartLabels chart-series=series></canvas></div><div class=date-chart><span ng-repeat=\"date in lineChartLabels track by $index\">{{date}}</span><br><span ng-repeat=\"marks in quizPastMarks track by $index \">{{marks | number:2 }}</span></div></div><div class=lineChart><h1>Topic Wise Strengths</h1><div style=\"overflow-x:scroll; width: 730px\"><div ng-class=\"showCanvasDiv ? \'barChart\' : \'\'\"><canvas id=tagsBarChart chart-data=lineChartData chart-labels=lineChartLabels chart-series=series></canvas></div></div></div><div class=clr></div></div><div ng-if=showData class=container style=\"background-color: #E4E4E4\"><div class=justify-content-center><div class=col-lg-12 style=\"margin-top: 10px\"><h1 style=\"text-align: center\">Review Quiz Questions</h1><div class=col-lg-12 style=\"margin-top: 60px\"><div class=col-lg-6 style=margin-top:10px><div class=ip-qz-avg-time style=height:65px><h3 style=\"color: #535353\">Correct Answers to Question No</h3></div></div><div class=col-lg-6><div class=ip-qz-avg-time style=\"overflow-y:scroll; height:65px; margin-top:10px\"><ul class=\"col-md-2 col-xs-4\" ng-repeat=\"number in result.log.correctAnsweredQuestionNo\"><li><div ng-click=showSolution(number-1) style=\"background-color: green; padding: 5px; border-radius: 5px\"><h3>{{number}}</h3></div></li></ul></div></div></div><div class=col-lg-12 style=\"margin-top: 10px\"><div class=col-lg-6 style=margin-top:10px><div class=ip-qz-avg-time style=\"height: 65px\"><h3 style=\"color: #535353\">Wrong Answers to Question No</h3></div></div><div class=col-lg-6><div class=ip-qz-avg-time style=\"overflow-y:scroll; height: 65px; margin-top:10px\"><ul class=\"col-md-2 col-xs-4\" ng-repeat=\"number in result.log.wrongAnsweredQuestionNo\"><li><div ng-click=showSolution(number-1) style=\"background-color: brown; padding: 5px; border-radius: 5px\"><h3>{{number}}</h3></div></li></ul></div></div></div><div class=col-lg-12 style=\"margin-top: 10px\"><div class=col-lg-6 style=margin-top:10px><div class=ip-qz-avg-time style=\"height: 65px\"><h3 style=\"color: #535353\">No Answers Provided</h3></div></div><div class=col-lg-6><div class=ip-qz-avg-time style=\"overflow-y:scroll; height: 65px; margin-top:10px\"><ul class=\"col-md-2 col-xs-4\" ng-repeat=\"number in result.log.notAnsweredQuestionNo\"><li><div ng-click=showSolution(number-1) style=\"background-color: gray; padding: 5px; border-radius: 5px\"><h3>{{number}}</h3></div></li></ul></div></div></div><div class=clear></div><div ng-if=showSolutionDiv><div class=col-lg-12 id=showSolution-new><div style=\"padding: 30px\"><div><h1 style=\"float: left;\">Solution to the Questions</h1></div><div class=search-container style=float:right><form><input style=\"width:150px; height: 35px\" type=number placeholder=\"Question no.\" id=jump-to-question> <button style=\"width: 35px; height: 35px\" ng-click=jumpToQuestion()><span>GO</span></button></form></div></div></div><div class=clear></div><div id=showSolution-new class=\"col-xs-12 res-sol\"><div><div class=col-lg-12 style=\"display: block\"><div class=col-lg-6><div style=\"padding: 10px\"><h3 style=\"color: #535353\">Question {{currentQNo}} of {{result.score.total}}</h3></div></div><div class=col-lg-2><div style=\"padding: 10px\"><div class=\"difficulty-level {{result.levels[solutionQuestion.question_id]}}\">{{result.levels[solutionQuestion.question_id] }}</div></div></div><div class=col-lg-4><div class=ip-qz-avg-time><h3 style=\"color: #535353\">Time: {{solutionQuestion.answer_time ? solutionQuestion.answer_time : 0 | removeExtraDecimalPoints}} second(s)</h3></div></div></div><div class=\"row col-lg-12\" style=\"margin-top: 40px; margin-bottom: 40px\"><div class=col-lg-10><p ng-bind-html=\"solutionQuestion.text | to_trusted\"></p><div><p><span id=math-field-question{{$index}} class=totalValue></span></p></div></div></div><div class=col-lg-12><div class=col-lg-4><div ng-repeat=\"option in solutionQuestion.options\"><div class=ip-option-div ng-class=\"{correctAnswerSolution: ((option.userSelected && solutionQuestion.correct) || (solutionQuestion.correctAnswerId == option.id)),wrongAnswerSolution: (option.userSelected && !solutionQuestion.correct)}\"><p><span id=math-field-opt{{$index}}></span></p><img ng-if=option.image_url ng-src={{option.image_url}} alt=\"\"></div></div></div><div class=col-lg-8><div style=\"text-align: center\"><img src={{solutionQuestion.image_url}} alt=\"\"></div><div class=clear></div></div></div></div><div class=col-lg-12><div class=ip-qz-q-sol-div><div ng-style=\"{\'background-color\': question.backgroundColor}\" class=res-sol-div><p><label style=\"color: #535353\">Solution:</label><span id=math-field-sol class=totalValue></span></p><div class=col-lg-12><div ng-if=solutionQuestion.solution_image style=\"text-align: center; margin:30px\"><img src={{solutionQuestion.solution_image}} alt=\"\"></div><div class=clear></div></div></div></div></div><div class=clear></div></div><div class=col-lg-12><div style=\"padding: 20px\"><div class=col-lg-6 style=text-align:center><button class=ip-q-btn ng-click=showSolution(currentQNo-2)><span>Previous</span></button></div><div class=col-lg-6 style=text-align:center><button class=ip-q-btn ng-click=showSolution(currentQNo)><span>Next</span></button></div></div></div></div></div></div><div class=clr></div></div><div ng-show=showData><div class=\"review-quiz review-quiz-two\" style=\"display: none\"><h1>Areas of improvement on sub-topic level</h1><div><p class=label>Areas of improvement on sub-topic level</p><p class=labelinner><span>{{getVideoList(rewatchVideos)}}</span></p></div></div><div style=\"margin: 30px\"><div class=study-suggestions ng-hide=\"rewatchVideos.length == 0\"><h1>Study suggestions</h1><h3>Based on your performance on this quiz, we<br>suggest that you review following short lectures</h3><div class=box-styudy-sugestions ng-repeat=\"video in rewatchVideos\" ng-click=showVideo(video)><img ng-src={{video.image_url}} alt=\"\"><p>{{video.name}}</p></div></div><div class=button-result ng-hide=\"rewatchVideos.length == 0\"><button ng-click=goToNextVideo()>Continue</button></div></div></div>");
$templateCache.put("app/sat/sat.html","<div class=\"landing-new landing-new-mdcat sat-landing\"><div class=landing-new-cont><div class=landing-static-heading><h1>Our SAT Prep Gets You in Top Colleges</h1><h2>LUMS | IBA | NUST | US Universities</h2><ul><li>120+ Lecture Videos</li><li>2000+ Practice Questions</li><li>24/7 Talk to Teachers</li><li>Solved Papers</li><li>Lecture Notes</li><li>Admission Guidance</li></ul><button ng-hide=isGuest ng-click=satBuy()>Buy Now</button> <button class=how-to-buy ng-click=\"goToState(\'paymentOptions\')\">How to buy</button> <a ui-sref=\"listing({institutionName: \'entry-test\',schoolName: \'sat\'})\">Go to courses</a></div></div></div><addtocart course=SatData></addtocart><div class=\"stories features-scroll our-features\"><div class=sat-cont><div class=stories-top><h1>Our Features</h1><!--    <a href=\"#\">more stories</a> --></div><div class=our-features-sat><ul><li><div class=our-features-sat-img><img src=images/pak-top-instuctors.png alt=\"\"><h2>Pakistan’s Top Instructors</h2></div></li><li><div class=our-features-sat-img><img src=images/live-online-classes.png alt=\"\"><h2>Live Online Interactive Classes</h2></div></li><li><div class=our-features-sat-img><img src=images/access-toawesome.png alt=\"\"><h2>24/7 Access to Awesome Videos</h2></div></li><li><div class=our-features-sat-img><img src=images/access-to-whatsapp.png alt=\"\"><h2>24/7 Access to the Instructors through Whatsapp group</h2></div></li><li><div class=our-features-sat-img><img src=images/send-a-snap.png alt=\"\"><h2>Send a Snap of a question, get a reply in video format instantly</h2></div></li><li><div class=our-features-sat-img><img src=images/countless-practice.png alt=\"\"><h2>Countless Practice Tests</h2></div></li></ul></div></div></div><div class=slide-cont-sat-bg><div class=container><div class=inner-container><div class=slide-cont-sat><div class=stories-top><h1>Why take it online?</h1><p>Watch sample lectures below to see how nearpeer works</p></div><!-- //.stories-top --><div class=row><div class=col-md-8><div class=slide-cont><div class=\"slidee slide-animation\" ng-repeat=\"video in videos\" ng-class=\"{\'hide-video\': !isCurrentSlideIndex($index)}\"><video-player-sat url={{video.src}} poster={{video.poster}} textid={{video.id}} height=285px></video-player-sat></div><a class=\"arrow prev sat-arrow\" ng-click=nextSlide()>n</a> <a class=\"arrow next sat-arrow\" ng-click=prevSlide()>p</a><nav class=nav><div class=wrapper><ul class=dots><li class=dot ng-repeat=\"slide in videos\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);></a></li></ul></div></nav></div><!-- //.slide-cont --></div></div></div><!-- //.slide-cont-sat --></div></div></div><div class=\"stories sat-stroies\"><div class=sat-cont><div class=stories-top><h1>stories</h1><p>hear from our students</p><!--    <a href=\"#\">more stories</a> --></div><div class=stories-bottom><ul><li><div class=stories-thumb-img><div class=stories-thumb-box><img src=images/Maryam-Zulfiqar.jpg alt=\"\"></div></div><div class=stories-thumb-info><h2>Maryam Zulfiqar</h2><h3>LUMS 2020</h3><p>Being a female, attending an academy was an impossible task for me. But Nearpeer’s online course helped me prepare at home, and achieve my dream score that made me land into LUMS.</p></div></li><li><div class=stories-thumb-img><div class=stories-thumb-box><img src=images/Reshail-Kiyani.jpg alt=\"\"></div></div><div class=stories-thumb-info><h2>Reshail Kiyani</h2><h3>LUMS 2021</h3><p>Quality SAT prepration was not available in my hometown and travelling to other cities was not an option for me. Thanks to Nearpeer for I was able to prepare SAT without leaving my hometown.</p></div></li><li><div class=stories-thumb-img><div class=stories-thumb-box><img src=images/Faisal-Basheer.jpg alt=\"\"></div></div><div class=stories-thumb-info><h2>Fasil Basheer</h2><h3>LUMS 2021</h3><p>Academies in my city were expensive and quality was not upto mark. I was worried for my SAT prep until I found Nearpeer.org where I was learning from the best instructors for the best price.</p></div></li></ul></div></div></div><div class=\"stories blog\"><div class=sat-cont><div class=stories-top><h1>Most Popular Blogs</h1><!--    <a href=\"#\">more stories</a> --></div><div class=stories-midle><ul><li><a href=https://nearpeerblog.wordpress.com/8/09/19/how-do-i-get-admission-in-lums-what-is-sat-can-i-get-financial-aidscholarship-by-nearpeer-org/ target=_blank><div class=stories-midle-img-box><img src=images/blog-1.png alt=\"\"></div><div class=stories-midle-info-box><h2>How do I get admission in LUMS? What is SAT? Can I get Financial Aid/Scholarship? -by Nearpeer.org</h2></div><div class=stories-midle-info-bottom><h2>Ch. Malik bhatti</h2><p>Sep 19, 8</p><div class=img-box-sat><img src=images/imran-thakur.png alt=\"\"></div></div></a></li><li><a href=https://nearpeerblog.wordpress.com/8/09/18/i-am-still-in-fsc-shouldnt-i-be-applying-for-lums-after-i-am-done-with-fsc/ target=_blank><div class=stories-midle-img-box><img src=images/blog-2.png alt=\"\"></div><div class=stories-midle-info-box><h2>I am still in FSc. Shouldn’t I be applying for LUMS after I am done with FSc? by Nearpeer.org</h2></div><div class=stories-midle-info-bottom><h2>Ch. Malik bhatti</h2><p>Sep 18, 8</p><div class=img-box-sat><img src=images/imran-thakur.png alt=\"\"></div></div></a></li><li><a href=https://nearpeerblog.wordpress.com/8/09/16/i-have-87-in-matric-and-82-in-fsc-how-much-sat-score-is-required-to-secure-spot-at-lums/ target=_blank><div class=stories-midle-img-box><img src=images/blog-3.png alt=\"\"></div><div class=stories-midle-info-box><h2>I have 87% in matric and 82% in FSc. How much SAT Score is required to secure spot at LUMS?</h2></div><div class=stories-midle-info-bottom><h2>Ch. Malik bhatti</h2><p>Sep 16, 2017</p><div class=img-box-sat><img src=images/imran-thakur.png alt=\"\"></div></div></a></li></ul></div></div></div><div class=scholarships-video><h2>How our students are studying on 100% scholarships at LUMS</h2><video-player-sat class=video poster=\"/images/SAT video at bottom thumbnail.png\" url=eM1WnONGJ9k textid=videoend height=480px></video-player-sat></div><div class=ready-to-register><h1>you are ready to learn ?</h1><p>take your education to the next level</p><a class=\"button-red fas fa-phone\" href=tel:+923470171480 target=_blank>03470171480</a></div>");
$templateCache.put("app/sat/satVideo.html","<div class=\"modal-body video-sat-cont padding0\" id=yt-player><iframe width=100% height={{height}} ng-src=\"{{trustSrc(src) }}\"></iframe></div><!-- showPauseBtn() --><!-- <div\n  class=\"video-sat-cont\"\n  ng-class=\"{\'playing\': !btnPlay, \'paused\': btnPause}\">\n\n  <video\n    id=\"{{textid}}\"\n    ng-src={{src}}\n    height=\"{{height}}\"\n    controls poster=\"{{poster}}\"\n    ng-click=\"showPauseBtn()\"\n    controlsList=\"nodownload\">\n  </video> --><!-- ng-show=\"btnPlay\" --><!-- <button\n    type=\"button\"\n    class=\"btn-paly-pause btn-play\"\n    ng-click=\"playVideo()\"\n    >\n    play\n  </button>\n  <button\n    type=\"button\"\n    class=\"btn-paly-pause btn-pause\"\n    ng-click=\"pauseVideo()\">\n    pause\n  </button> --><!-- ng-hide=\"btnPlay\" --> <!-- </div> -->");
$templateCache.put("app/slider/slider.html","<div class=slider><div class=\"slide meet-our-instructors slide-animation\" ng-repeat=\"data in instructors\" ng-show=data.visible><div class=meet-our-instructors-img><img src={{data.image}} alt=\"\"></div><div class=meet-our-instructors-info><h3>{{data.name}}</h3><span ng-show=data.exprience>{{data.exprience}} years </span><span ng-show=\"data.exprience && data.qualification \">/ </span><span ng-show=data.qualification>{{data.qualification}}</span><p>{{data.description}}</p></div></div><a class=\"arrow prev\" ng-click=prev()>n</a> <a class=\"arrow next\" ng-click=next()>p</a><nav class=nav><div class=wrapper><ul class=dots><li class=dot ng-repeat=\"slide in instructors\"><a href=# ng-class=\"{\'active\':isCurrentSlideIndex($index)}\" ng-click=setCurrentSlideIndex($index);></a></li></ul></div></nav></div>");
$templateCache.put("app/signUp/signUp.html","<!-- <div class=\"custom_popup\">\n  <div class=\"custom_popup_body loginForm\">\n    <div class=\"custom_popup_header\">\n      <span class=\"fa fa-angle-left\"></span>\n      <img src=\"../../images/email-logo.png\" alt=\"NearPeer Logo\">\n      <span class=\"close fa fa-times\" ng-click=\"closeForm()\"></span>\n    </div>\n    <div class=\"popup_main\">\n      <div class=\"popup_title\">\n        <h1>Login NearPeer</h1>\n        <p>Welcome back! Dear user enter the password associated with your email address.</p>\n      </div>\n      <form action=\"#\">\n        <div class=\"field-wrapper mb-24\" ng-if=\"email_Field\">\n          <label for=\"email\">Enter Or Phone</label>\n          <div class=\"field-inner\">\n            <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i>\n            <input type=\"text\" name=\"email\" id=\"email\" placeholder=\"Email@xyz.com\" />\n          </div>\n        </div>\n        <div class=\"password  mb-24\" ng-if=\"!password_Field\">\n          <div class=\"field-wrapper\">\n            <label for=\"email\">Password</label>\n            <div class=\"field-inner\">\n              <i class=\"fa fa-lock\" aria-hidden=\"true\"></i>\n              <input type=\"password\" name=\"password\" id=\"password\" placeholder=\"\" />\n            </div>\n          </div>\n          <div class=\"password-options flex-view justify-content-between\">\n            <div class=\"forget-password\">Forget Password?</div>\n            <div class=\"skip-password\">Skip Password?</div>\n          </div>\n\n        </div>\n        <div class=\"text-center mb-24\">\n          <button class=\"popup_button\" type=\"button\" ng-click=\"nextForm()\">\n            Next\n          </button>\n        </div>\n        <div class=\"social-logins\">\n          <div class=\"mb-24 divider mb-24\">\n            OR\n          </div>\n          <div class=\"text-center\">\n            <button class=\"social-button\"><img src=\"../../images/google-icon.png\" alt=\"#\"> LogIn with Google</button>\n          </div>\n          <div class=\"text-center\">\n            <button class=\"social-button\"><img src=\"../../images/fb-icon.png\" alt=\"#\"> LogIn with FaceBook</button>\n          </div>\n          <div class=\"text-center\">\n            <button class=\"social-button\"><img src=\"../../images/tweeter-icon.png\" alt=\"#\"> LogIn with Tweeter</button>\n          </div>\n        </div>\n      </form>\n    </div>\n\n  </div>\n</div> --><div class=\"modal fade custom_popup\" id=singUpPopUp tabindex=-1 role=dialog aria-labelledby=singUpPopUpModalLabel aria-hidden=true><div class=\"custom_popup_body loginForm\"><div class=custom_popup_header><span class=\"fa fa-angle-left\"></span> <img src=../../images/email-logo.png alt=\"NearPeer Logo\"> <span class=\"close fa fa-times\" ng-click=closeForm()></span></div><div class=popup_main><div class=popup_title><h1>Login NearPeer</h1><p>Welcome back! Dear user enter the password associated with your email address.</p></div><form action=#><div class=\"field-wrapper mb-24\" ng-if=email_Field><label for=email>Enter Or Phone</label><div class=field-inner><i class=\"fa fa-envelope\" aria-hidden=true></i> <input type=text name=email id=email placeholder=Email@xyz.com></div></div><div class=\"password mb-24\" ng-if=!password_Field><div class=field-wrapper><label for=email>Password</label><div class=field-inner><i class=\"fa fa-lock\" aria-hidden=true></i> <input type=password name=password id=password placeholder=\"\"></div></div><div class=\"password-options flex-view justify-content-between\"><div class=forget-password>Forget Password?</div><div class=skip-password>Skip Password?</div></div></div><div class=\"text-center mb-24\"><button class=popup_button type=button ng-click=nextForm()>Next</button></div><div class=social-logins><div class=\"mb-24 divider mb-24\">OR</div><div class=text-center><button class=social-button><img src=../../images/google-icon.png alt=#> LogIn with Google</button></div><div class=text-center><button class=social-button><img src=../../images/fb-icon.png alt=#> LogIn with FaceBook</button></div><div class=text-center><button class=social-button><img src=../../images/tweeter-icon.png alt=#> LogIn with Tweeter</button></div></div></form></div></div></div>");
$templateCache.put("app/storeel/storeel.html","<div class=story-popup><div class=story-container><div class=story-popup-close ng-keydown=closeStoryPopup($event) ng-click=closeStoryPopup(event)><img src=../../images/nearpeer-story/icon-cross-white.svg alt=\"\"></div><div class=story-list-sidebar><div class=story-list-header><img src=../../images/nearpeer-story/back-arrow.svg ng-click=closeStoryPopup() alt=\"\"><p>All Stories</p></div><div class=story-list-wrapper><ul class=story-list-all><li ng-repeat=\"story in stories track by $index\" ng-class=\"{\'active\': $index == activeStory}\" ng-click=\"openCurrentStory(story.id, $index, story.title)\"><div class=story-avatar><img src={{story.thumbnail}} alt=\"\"> <svg class=dasharray-{{story.slides.length}} viewBox=\"0 0 100 100\"><g rotation=-90 origin-x=90 origin-y=90><circle ng-repeat=\"element in story.storyStatusData\" cx=50 cy=50 r={{element.radius}} stroke={{element.color}} fill=transparent stroke-width=3.5 stroke-dasharray={{element.circleCircumference}} stroke-dashoffset={{element.strokeDashoffset}} transform=\"rotate({{element.rotation}}, 50, 50)\" origin-x=90 origin-y=90 /></g></svg></div><div><div class=story-name>{{story.title}}</div><div class=story-time>Posted On {{story.created_at | date:\'short\'}}</div></div></li></ul></div></div><div class=story-view><div class=story-view-pagination><div ng-repeat=\"slide in stories[activeStory].slides track by $index\" class=story-view-bar><md-progress-linear class=mytbar md-mode=determinate value=\"{{slide.id==stories[activeStory].slides[activeSlide].id?determinateValue:$index<activeSlide?100:0}}\"></md-progress-linear></div></div><div class=story-view-slider><div class=story-view-slider-inner ng-class=\"{\'fade-in-left \' : swipeLeft, \'fade-in-right\' : swipeRight }\"><div class=\"story-view-action-btn play-pause\" style=\"position: absolute; z-index: 9; left: 20px; top: 30px; color: #ffffff\"><div ng-if=storyPlay ng-click=playBtn()><i class=\"fa fa-play\" aria-hidden=true></i></div><div ng-if=storyPause ng-click=stopBtn()><i class=\"fa fa-pause\" aria-hidden=true></i></div></div><div class=\"story-view-action-btn play-pause\" ng-if=\"stories[activeStory].slides[activeSlide].video_link && stories[activeStory].slides[activeSlide].video_link!==\'\'\" ng-click=videoMuteBtn() style=\"position: absolute; z-index: 9; left: 80px; top: 30px; color: #ffffff\"><img src=../../images/nearpeer-story/mute.svg alt=\"\" ng-if=\"videoMute==false\" style=\"width: 25px\"> <img src=../../images/nearpeer-story/unmute.svg alt=\"\" ng-if=\"videoMute==true\" style=\"width: 25px\"></div><div class=story-view-slider-item ng-class=\"{\'d-none\': $index != activeSlide}\" ng-repeat=\"slide in stories[activeStory].slides\"><div class=story-view-wrapper><div ng-if=videoLoader class=story-element-loading><span class=np-loader></span></div><img id=\"{{slide.id }}\" ng-if=slide.image_link ng-src={{slide.media_link}} alt=\"\" eager><video id=\"{{slide.id }}\" ng-if=slide.video_link ng-src={{slide.media_link}} playsinline></video><div class=story-view-detail><h4>{{slide.title}}</h4><p class=story-view-description>{{slide.description | limitTo:numLimit| to_trusted}} <span>{{slide.description.length > numLimit ? \'...\' : \'\'}}</span> <a ng-if=\"slide.description.length > 50\" class=readMore-btn ng-click=readMore(slide.description.length)>{{readMoreBtn}}</a></p><a ng-click=stopBtn() href={{slide.redirect_url}} target=_blank style=\"display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;  overflow: hidden\">{{slide.redirect_url}} </a><!-- <span>NearPeer</span> --></div><div class=story-view-action><div class=story-view-action-wrapper><div class=story-view-action-btn ng-click=addLikes(slide.id);$event.stopPropagation();$event.preventDefault();><img src=../../images/nearpeer-story/icon-like.svg alt=\"\" ng-if=\"slide.is_liked==false\"> <img src=../../images/nearpeer-story/icon-like-fill.svg alt=\"\" ng-if=\"slide.is_liked==true\"></div><p>{{slide.story_likes?slide.story_likes:\'0\'}}</p></div><div class=story-view-action-wrapper ng-class=\"{\'d-none noClick\': stories[activeStory].comment_allowed !== true}\"><div class=story-view-action-btn ng-click=\"storyCommentOpen();getCommentsForUser(slide.id, slide)\"><img src=../../images/nearpeer-story/icon-comment.svg alt=\"\"></div><p>{{slide.story_comments?slide.story_comments:\'0\'}}</p></div><div class=story-view-action-btn ng-class=\"{\'d-none noClick\': stories[activeStory].social_media_sharing !== true}\" ng-click=storyShareOpen(slide.id)><img src=../../images/nearpeer-story/icon-share.svg alt=\"\"></div></div><div class=\"story-view-overlay top\"></div><div class=story-view-overlay></div></div></div><div class=story-view-navigation ng-class=\"{\'highZindex\' : videoLoader}\" ng-swipe-left=navigateFromSwipe(1) ng-swipe-right=navigateFromSwipe(-1)><a class=prev ng-click=navigateFromButtons(-1)><img src=../../images/nearpeer-story/story-arrwo-left.svg alt=\"\"> </a><a class=next ng-click=navigateFromButtons(1)><img src=../../images/nearpeer-story/story-arrow-right.svg alt=\"\"></a></div></div><!-- Story popup comment --><div class=story-popup-comment ng-show=storyComment ng:class=\"{ active : storyComment}\"><div class=story-comment-header><h4>All Comments <span>{{title}}</span></h4><p>{{description | limitTo:longDescLimit| to_trusted}} <span>{{description.length > longDescLimit ? \'...\' : \'\'}}</span> <a ng-if=\"description.length > 100\" class=readMore-btn ng-click=readMoreLongDesc(description.length)>{{readMoreBtnLong}}</a></p><!-- <ul>\n              <li>#tag</li>\n              <li>#tag</li>\n              <li>#tag</li>\n            </ul> --><div class=story-comment-close ng-click=storyCommentClose()><img src=../../images/nearpeer-story/icon-cross.svg alt=\"\"></div></div><div id=storyCommentMain class=story-comment-main><ul ng-if=storyComment infinite-scroll=loadMoreComments() infinite-scroll-container=\'\".story-comment-main\"\' infinite-scroll-distance=0 infinite-scroll-parent=true><div ng-if=commentLoader ng:class={centerDiv:commentLoader}><img src=images/squares.gif style=\"width: 70px\"></div><li ng-repeat=\"comments in coment track by $index\"><div class=story-comment-user><div class=story-comment-avatar><img ng-if=!comments.user_id.image src=../../images/male-dp.svg alt=\"\"> <img ng-if=comments.user_id.image src={{comments.user_id.image}} alt=\"\"></div><!-- <div>\n                    <div class=\"story-comment-username\">Fahad Khan</div>\n                    <div class=\"story-comment-date\">NOV 23 2021</div>\n                  </div> --></div><div class=story-comment><div class=story-comment-shadow><div><div class=story-comment-username>{{comments.user_id.full_name}}</div><div class=story-comment-date>{{comments.created_at | date:\'short\'}}</div></div><p>{{comments.comment}}</p><img class=comment-img ng-if=\"comments.thumbnail && comments.thumbnail!=\'\'\" src={{comments.thumbnail}} alt=\"\"><div class=story-reply><span ng-click=\"addCommentLike(comments, $index)\"><img src=../../images/nearpeer-story/comment-like.svg ng-if=\"comments.is_liked==undefined\" alt=\"\"> <img src=../../images/nearpeer-story/comment-like-fill.svg ng-if=comments.is_liked alt=\"\"> Like <b style=\"margin-left: 5px\">{{comments.commentlikes}}</b> </span><span ng-click=\"storyCommentWriteReplyToggle(comments.id, $index)\"><img src=../../images/nearpeer-story/write-comment.svg alt=\"\"> Reply</span> <span ng-click=\"getRepliesForUser(comments.id, $index);\">{{comments.replyCount?comments.replyCount: \'0\'}} Replies</span></div></div><div ng-if=\"replyLoader && comments.id == cid\" ng:class=\"{centerDiv:replyLoader && comments.id == cid}\"><img src=images/squares.gif style=\"width: 50px\"></div><ul ng-if=\"comments.id == cid\" ng-show=storyCommentReply><li ng-repeat=\"cReplies in rep\"><div class=story-comment-user><div class=story-comment-avatar><img ng-if=!cReplies.user_image src=../../images/male-dp.svg alt=\"\"> <img ng-if=cReplies.user_image src={{cReplies.user_image}} alt=\"\"></div><!-- <div>\n                          <div class=\"story-comment-username\">Fahad Khan</div>\n                          <div class=\"story-comment-date\">NOV 23 2021</div>\n                        </div> --></div><div class=story-comment><div class=story-comment-shadow><div><div class=story-comment-username>{{cReplies.user_name}}</div><div class=story-comment-date>{{cReplies.created_at | date:\'short\'}}</div></div><p>{{cReplies.reply}}</p></div></div></li></ul><div ng-if=\"comments.id == com_id\" ng-show=storyCommentWriteReply class=\"story-comment-box reply\"><div class=flex-view><div class=story-comment-avatar><img ng-if=!userImage src=../../images/male-dp.svg alt=\"\"> <img ng-if=userImage src={{userImage}} alt=\"\"></div><div class=story-comment-area><textarea name=storyCommentBox id=storyCommentBoxReply placeholder=\"Type a reply\" ng-model=userReply ng-keyup=replyAreaAdjust(userReply)></textarea><div class=story-comment-btn><!-- <div> <img src=\"../../images/nearpeer-story/file-upload.svg\" width=\"25px\" alt=\"\"></div> --><!-- <div> <img src=\"../../images/nearpeer-story/Emoji.svg\" width=\"25px\" alt=\"\"></div> --><div><img src=../../images/nearpeer-story/send.svg width=25px alt=\"\" ng-if=beforeReplyType></div><div><img ng-click=\"addReply(userReply, comments.id,$index)\" src=../../images/nearpeer-story/send-1.svg width=25px alt=\"\" ng-if=afterReplyType></div></div><!-- <div class=\"story-comment-btn\">\n                              <button>cancel</button>\n                              <button class=\"filled\" ng-click=\"userCommentAdd(userComment)\">post</button>\n                            </div> --></div></div></div></div></li></ul></div><div ng-if=commentedPaginationLoader ng:class={centerDiv:commentedPaginationLoader}><img src=images/squares.gif style=\"width: 50px\"></div><div class=story-comment-box><div class=\"flex-view align-items-center\"><div class=story-comment-avatar style=\"margin-top: 0\"><!-- <img src=\"../../images/nearpeer-story/avatar.png\" alt=\"\" /> --> <img ng-if=!userImage src=../../images/male-dp.svg alt=\"\"> <img ng-if=userImage src={{userImage}} alt=\"\"></div><div class=story-comment-area><textarea ng-keyup=textAreaAdjust() ng-model=userComment id=storyCommentBox style=overflow:hidden placeholder=\"Type a comment here\"></textarea><div class=story-comment-btn><!-- <div> <img src=\"../../images/nearpeer-story/file-upload.svg\" width=\"25px\" alt=\"\"></div> --><div class=image-upload><label for=fileInput><!-- <div><img src=\"../../images/nearpeer-story/file-upload.svg\" width=\"25px\" alt=\"\"></div> --></label><input id=fileInput type=file accept=image/* resize-quality=0.7 resize-type=image/jpg ng-image-compress image=image1 ng-model=im ngf-select=uploadImageMain(image1)></div><!-- <div> <img src=\"../../images/nearpeer-story/Emoji.svg\" width=\"25px\" alt=\"\"></div> --><div><img src=../../images/nearpeer-story/send.svg width=25px alt=\"\" ng-if=beforeType> <img ng-click=userCommentAdd(userComment) src=../../images/nearpeer-story/send-1.svg width=25px alt=\"\" ng-if=afterType></div></div><!-- <div class=\"story-comment-btn\">\n                  <button>cancel</button>\n                  <button class=\"filled\" ng-click=\"userCommentAdd(userComment)\">post</button>\n                </div> --></div></div><div class=story-media-upload><div class=story-media-img><img ng-if=uploadingLoader src=images/squares.gif style=\"width: 50px\"> <img ng-if=comment_thumbnail_link ng-src={{comment_thumbnail_link}} alt=#></div><div class=story-media-close role=button tabindex=0><img src=../../images/nearpeer-story/icon-cross.svg ng-if=comment_thumbnail_link ng-click=removeCommentImage() alt=\"\"></div></div></div></div></div><!-- Story popup share --><div class=story-popup-share ng-if=storyShare><div class=story-popup-share-inner><div class=story-popup-share-close ng-click=storyShareClose()><img src=../../images/nearpeer-story/icon-cross.svg alt=\"\"></div><h2>Share Link</h2><p>Share link with your friend given social media icon.</p><ul><li><img ng-click=shareOnFacebook() src=../../images/nearpeer-story/icon-fb.svg alt=\"\"></li><li><img ng-click=whatsAppShare() src=../../images/nearpeer-story/icon-whatsapp.svg alt=\"\"></li><li><img ng-click=shareOnTwitter() src=../../images/nearpeer-story/icon-twitter.svg alt=\"\"></li><li><img ng-click=shareOnlinkedin() src=../../images/nearpeer-story/icon-linkedin.svg alt=\"\"></li><li style=\"position: relative\"><img ng-click=mediaCopy() src=../../images/nearpeer-story/icon-copy.svg alt=\"\"><p ng-if=fcLinkCopy style=\"position: absolute;  margin: 10px 0 0; left: 0\">link coppied</p></li></ul></div></div></div></div></div>");
$templateCache.put("app/student_account/my-account.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-show=showData class=layout><div class=banner-accont><div class=container><div class=left-img><a><img src={{userData.image}}></a></div><div class=right-accont-title><h1 ng-if=\"userData.name == NULL\">{{userData.full_name}}</h1><h1 ng-if=\"userData.full_name == NULL\">{{userData.name}}</h1><h2>Current Balance {{userData.credit}}</h2><ul><li ng-class=\"{active: value == 1}\"><a ng-click=setVal(1)>Dashboard</a></li><!-- <li ng-class=\"{active: value == 2}\"><a ng-click=\"setVal(2)\">Courses</a></li> --><!-- <li ng-class=\"{active: value == 3}\"><a ng-click=\"setVal(3)\">MODULES</a></li> --><li ng-class=\"{active: value == 4}\"><a ng-click=setVal(4)>Orders</a></li><li ng-class=\"{active: value == 5}\"><a ng-click=setVal(5)>TRANSACTIONS</a></li><li ng-class=\"{active: value == 6}\"><a ng-click=setVal(6)>Quizzes</a></li><li ng-class=\"{active: value == 7}\"><a ng-click=setVal(7)>Course Results</a></li></ul></div></div></div><div class=traancaction><div class=container><div class=traancaction-left><ul><li class=mt-10 ng-show=userData.email><a>{{userData.email}}</a></li><li ng-show=userData.phone class=phone-class><a>{{userData.phone}}</a></li><li ng-show=userData.created_at><a>Joined {{userData.created_at | date: \'dd MMMM, yy\'}}</a></li></ul></div><!-- <div class=\"traancaction-right mudules-two\" ng-show=\"value == 3\">\n        <h2>My Purchased Modules</h2>\n        <div class=\"modules-panel\" ng-repeat=\"t in transactions\">\n          <ul>\n            <td ng-repeat=\"product in order.product\">{{product.course_id.name}}</td>\n            <td ng-repeat=\"product in order.product\">{{product.module_id.name}}</td>\n            <li><span>{{t.module_no}}</span>\n              <p class=\"hidden-xs\">{{t.module_name  | limitTo:35}}<label>{{t.course_name | limitTo:25}}</label></p>\n              <p class=\"visible-xs\">{{t.module_name  | limitTo:20}}<label>{{t.course_name | limitTo:20}}...</label></p>\n\n              <button  ng-click=\"goToModule(t)\" class=\"active\">GO TO MODULE</button>\n            </li>\n          </ul>\n        </div>\n      </div> --><!-- <div class=\"traancaction-right mudules-two\" ng-show=\"value == 2\">\n        <h2>My Purchased Courses</h2>\n        <div class=\"modules-panel\" ng-repeat=\"course in courseTrns\">\n          <ul>\n            <li><span>{{$index+1}}</span>\n              <p class=\"hidden-xs\">{{course.name  | limitTo:35}}<label>{{course.institution | limitTo:25}}</label></p>\n              <p class=\"visible-xs\">{{course.name  | limitTo:20}}<label>{{course.institution | limitTo:20}}...</label></p>\n\n              <button  ng-click=\"goToCourse(course)\" class=\"active\">GO TO COURSE</button>\n            </li>\n          </ul>\n        </div>\n      </div> --><div class=traancaction-right ng-show=\"value == 1\"><!-- <button ng-if=\"showRequestVideo\" ng-click=\"requestVideoOnWeb()\" style=\"margin-top: 10px\">Request Videos on Web</button> --><h2>Your Statistics</h2><!-- <div class=\"add-blance\">\n          <div class=\"add-blance-left\"> <a>add balance</a> </div>\n          <div class=\"add-blance-right\">\n            <input ng-model=\"coupon_id\" type=\"text\" placeholder=\"Enter 10-Digit Scratch Card Code\" />\n            <button ng-click=\"addCredit(coupon_id)\">add</button>\n          </div>\n        </div> --><div class=recent-view><h3>All Viewed Videos</h3><div class=panel-group id=accordion style=\"max-height: 500px; overflow: scroll; overflow-x: hidden\"><div class=\"panel panel-default\" ng-repeat=\"video in videos\"><div ng-click=showVideo(video) class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#collapseOne><span class=serial-no>{{$index+1}}</span><h4 class=panel-title><a class=\"accordion-toggle hidden-xs\">{{video.video_name | limitTo:80}}</a></h4><h4 class=panel-title><a class=\"accordion-toggle visible-xs\">{{video.video_name | limitTo:25}}...</a></h4><p style=float:right>{{video.length}}</p></div></div></div></div><div class=recent-view-bottom><div class=recent-view-bottom-left><p>Average Course Rating:</p><ng-rate-it ng-model=avg_rating read-only=true class=rating-starts></ng-rate-it></div><div class=recent-view-bottom-right><p>Total Videos Viewed:</p><span>{{totalViewedVideos}}</span></div></div><p>Allow web streaming</p><label class=switchhh><input type=checkbox class=checkbox ng-model=switchToggle ng-change=requestVideoOnWeb() ng-disabled=switchToggle ng-hide=switchToggle> <span class=\"sliderrr rounddd\"></span></label><!-- <div style=\"margin-top: 25px\">\n          <p>Your Other Account</p>\n          <div ng-repeat=\"account in userAccounts\" class=\"user-account\" ng-click=\"tryLogin()\" ng-if=\"userId != account.id\">\n            <div>\n              <span class=\"account-avatart\">{{ account.email ? account.email : account.fb_email ? account.fb_email : account.apple_email }}</span>\n            </div>\n            <div style=\"margin-left: 20px\">\n              <p style=\"margin: 0px\" ng-if=\"account.provider == \'email\' || account.provider == \'google\'\">{{account.email}}</p>\n              <p style=\"margin: 0px\" ng-if=\"account.provider == \'facebook\'\">{{account.fb_email ? account.fb_email : account.email}}</p>\n              <p style=\"margin: 0px\" ng-if=\"account.provider == \'apple\'\">{{account.apple_email ? account.apple_email : account.email}}</p>\n              <p style=\"margin: 0px\">{{account.provider}}</p>\n            </div>\n          </div>\n        </div> --></div><div class=traancaction-right ng-show=\"value == 4\"><div class=col-xs-12><h2 class=col-sm-8>Order History</h2><div class=\"col-sm-4 ng-binding no-of-pages mt-10\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span class=order-page-detail>{{searchParams.page}} in {{totalPages}} ,{{(searchParams.page*searchParams.per_page)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}} Out of {{totalCount}}</span></div></div><div class=\"table-responsive col-xs-12\"><table class=\"table table-bordered table-striped\"><thead><tr><th>Status</th><th>Order Number</th><th>Course Name</th><th>Module Name</th><th>Bundle Name</th><th>Price</th><th>User Balance</th><th>Coupon Balance</th><th>Purchased At</th></tr></thead><tbody><tr ng-repeat=\"order in userOrders\"><td><button ng-style=\"{\'background-color\':order.BGColor}\" ng-click=\"inquireStatus(order, order.ref_no,order.status)\">{{order.status_}}</button></td><td>{{order.ref_no}}</td><td>{{order.course}}</td><td>{{order.module}}</td><td>{{order.bundle}}</td><td>{{order.price}}</td><td>{{order.user_balance}}</td><td>{{order.coupon_balance}}</td><td>{{order.time}}</td></tr></tbody></table></div><!-- <div class=\"responsive-table\">\n            <table class=\"table\">\n              <thead>\n                <tr>\n                  <th class=\"border-top-remv\">#</th>\n                  <th>Course</th>\n                  <th>Module</th>\n                  <th>Date</th>\n                  <th>Reference #</th>\n                  <th>Price</th>\n                  <th>Status</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"order in orders\">\n                  <td>{{$index+1}}</td>\n                  <td>{{order .course_name}}</td>\n                  <td>{{order.module_name}}</td>\n                  <td>{{order.trans_time}}</td>\n                  <td>{{order.ref_no}}</td>\n                  <td>{{order.price}}</td>\n                  <td>{{order.status}} <button ng-click=\"inquireStatus($index)\" ng-hide=\"order.status == \'paid\' || order.status == \'failed\'\">Update Status</button></td>\n                </tr>\n              </tbody>\n            </table>\n          </div> --></div><div class=traancaction-right ng-show=\"value == 5\"><h2>Course Transaction History</h2><div class=responsive-table><table class=table><thead><tr><th class=border-top-remv>#</th><th>Course</th><th>Date</th><th>Price</th><th class=border-top-remv-right>Payment Type</th></tr></thead><tbody><tr ng-repeat=\"courseTrn in courseTrns\"><td>{{$index+1}}</td><td>{{courseTrn .name}}</td><td>{{courseTrn .date_purchased | date: \'dd MMMM, yy\'}}</td><td>{{courseTrn .price}}</td><td>{{courseTrn .payment_type}}</td></tr></tbody></table></div><h2>Module Transaction History</h2><div class=responsive-table><table class=table><thead><tr><th class=border-top-remv>#</th><th>Course</th><th>Module</th><th>Date</th><th>Price</th><th class=border-top-remv-right>Payment Type</th></tr></thead><tbody><tr ng-repeat=\"t in transactions\"><td>{{$index+1}}</td><td>{{t.course_name}}</td><td>{{t.module_name}}</td><td>{{t.date_purchased | date: \'dd MMMM, yy\'}}</td><td>{{t.price}}</td><td>{{t.payment_type}}</td></tr></tbody></table></div><h2>My Credit History</h2><div class=responsive-table><table class=table><thead><tr><th class=border-top-remv>#</th><th>Coupon Code</th><th>Date</th><th class=border-top-remv-right>Price</th></tr></thead><tbody><tr ng-repeat=\"t in credits\"><td>{{$index+1}}</td><td>{{t.coupon_id}}</td><td>{{t.purchased_at | date: \'dd MMMM, yy\'}}</td><td>{{t.amount}}</td></tr></tbody></table></div></div><div class=traancaction-right ng-show=\"value == 6\"><h2>Quizzes History</h2><div class=responsive-table><table class=table><thead><tr><th class=border-top-remv>#</th><th>Quiz</th><th>Duration</th><th>Marks</th><th>Date</th><th>View</th></tr></thead><tbody><tr ng-repeat=\"quiz in quizzes\"><td>{{$index+1}}</td><td>{{quiz.name}}</td><td>{{quiz.duration}}</td><td>{{quiz.marks}}</td><td>{{quiz.date | date:\'medium\'}}</td><td><button ng-click=viewQuiz(quiz.resultId)>View</button></td></tr></tbody></table></div></div><div class=traancaction-right ng-show=\"value == 7\"><div class=heading-course-name-cont ng-repeat=\"course in entolledCourse\" ng-click=goToCourseResultPage(course)><div class=heading-course-name><h3>{{course.name}}</h3><p>Enrolled</p></div></div></div></div></div></div><!-- ////////////////POP UP ///////////////////////////////////////////////////////--><div class=\"signup-bg flex-view align-items-center\" style=\"overflow: auto\" ng-if=lmsPopup><div class=\"otp-holder flex-view justify-content-around align-items-center flex-direction-col signup-parent\" style=\"width: 100%\"><div style=\"position: absolute; left: 10px; top: 10px\"></div><span class=closeButtonImage style=\"top: 0\" ng-click=closeLms()><img src=./../../images/cross-lms.svg class=cross-icon></span><div class=\"flex-view flex-direction-col\" style=\"height: 100%;\n              justify-content: center;\n              width: 100%\"><!-- <div class=\"flex-view justify-content-center\">\n            <img src=\"./../../images/np-red.svg\"   class=\"otp-image\" style=\"width: 270px;\"/>\n          </div> --><div class=\"flex-view flex-direction-row-col\" style=\"width: 100%;\n              justify-content: space-around;align-items: center\"><div class=\"flex-view hide-on-small lms-popup justify-content-center\"><img src=./../../images/lms-promo.gif></div><div class=\"flex-view flex-direction-col lms-popup resp-lms justify-content-between\"><h3 class=\"h4-heading fade-in-lms-1\" style=\"position: relative\">We have upgraded to a new and improved study portal.</h3><div class=\"flex-view flex-direction-col otp-options\"><div><label class=\"about-us-body-2 fade-in-lms-4\" style=\"position: relative\">You are being redirected to our newly developed study portal to improve your learning experience with us.</label><div class=\"flex-view flex-direction-col to-hide fade-in-lms-3\" style=\"position: relative\"><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Study Faster</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Easier Navigation</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\"> Progress Tracking</label><label class=about-us-body-2><img src=./../../images/tick-lms.svg style=\"margin-right: 10px\">New Quiz Layout and Experience</label></div></div></div><div class=\"flex-view justify-content-center otp-options fade-in-lms-2\" style=\"position: relative\"><button class=\"btn-contained flex-view justify-content-center align-items-center\" style=\"background-color: #f24a00; width: 100%\" ng-click=goToVelocity()><img src=./../../images/external-link.svg style=\"margin-right: 5px\"> CONTINUE TO VELOCITY PORTAL</button></div></div></div></div></div></div><!-- ////////////////POP UP ///////////////////////////////////////////////////--><div class=overlay-body></div>");
$templateCache.put("app/tag/tag.html","<div style=margin-top:100px><form ng-init=\"tagForm = {}\"><h3>Title</h3><input type=text ng-model=tagForm.title><h3>Description</h3><input type=text ng-model=tagForm.description><h3>identifier</h3><input type=text ng-model=tagForm.identifier><h3>URL</h3><input type=text ng-model=tagForm.url><h3>Image URL</h3><input type=text ng-model=tagForm.image_url></form><button ng-click=submit(tagForm)>Submit</button></div>");
$templateCache.put("app/thankYou/thankYou.html","<div class=poppup-cp-new-overlay></div><div class=poppup-cp-new><div class=thankyou-page><div class=row><div class=col-sm-12><span class=order-status>Your Order Has Been Recieved</span><h1>Thank You</h1><h2>FOR YOUR PURCHASE!</h2><div class=order-no><span class=\"mb-30 number\">Your order # is: <b>NP-3214223</b></span><p>You will receive an order confirmation email with details of your order</p></div><button class=okbtn>OK</button></div></div></div></div>");
$templateCache.put("app/user-orders/orderDetails.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-hide=!showData><div class=popupContainer style=\"height: calc(100vh - 177px); overflow-y: auto\" ng-if=!orderSuccess><div style=\"background:white; box-shadow: 2px 2px 3px -3px black\"><div class=\"ar aq ap an\" style=\"margin-top: 16px\"><div style=\"min-height: 70px;padding: 17.5px 0\" class=\"f-c d-row jcsc order-bullets\"><div class=\"f-c d-row jcsa\" style=\"margin-top: 15px\"><div id=Oplaced class=\"t-checkbox t-checkbox-in-process\"><h6 class=steps-h6 style=width:75px>Place Order</h6></div><div><label class=\"btline_ colorccc\"></label></div><div id=MakePayment class=t-checkbox><h6 class=steps-h6 style=width:85px>Make Payment</h6></div><div><label class=\"btline_ colorccc\"></label></div><div id=OCompleted class=t-checkbox><h6 class=steps-h6 style=width:100px>Order Completion</h6></div></div></div></div></div><div class=order-summary-popup style=\"display: flex; justify-content: center; margin-top: 50px\"><div class=\"f-c d-col alic ospContainer\" style=\"align-items: normal\"><div class=\"f-c d-col\"><h3 class=font-25 style=\"font-weight: bold\">Order Summary</h3></div><div class=cart-container><div class=cart-header><div><div style=\"font-weight: bold; font-size: 16px\">Course/Module</div></div><div><div class=text-right style=\"margin-left: 10px; font-weight: bold; font-size: 16px\">Price</div></div></div><div class=cart-row><div style=\"font-size: 16px\">{{course.name}}</div><div><p class=text-right style=\"margin-left: 10px; font-size: 16px\">PKR {{coursePrice }}</p></div></div><div class=cart-row ng-if=isCouponApplied><div style=\"color: #00BE06; font-weight: bold; font-size: 16px\">Promo Code Applied ({{coupon.coupon_id}})</div><div><p class=text-right style=\"margin-left: 10px; color: #00BE06; font-weight: bold; font-size: 16px\">- PKR {{couponBalance }}</p></div></div><div class=order-seprater></div><div class=cart-row><div style=\"font-weight: bold\">Total</div><div><p class=text-right style=\"margin-left: 10px; font-weight: bold\">PKR {{total}}</p></div></div></div><div class=\"f-c d-row b-center\" style=\"justify-content: flex-end\" ng-if=showPlaceOrder><button class=btn style=\"margin-top: -5px; margin: 10px 0px; color: white; background-color: #16B9D6; min-width: 110px\" ng-click=placeOrder()><span ng-if=!loadingPayment>Place Order</span><div ng-if=loadingPayment style=\"display: flex; justify-content: center\"><div class=login-theme-loader></div></div></button></div></div></div></div></div><div class=popupContainer style=\"height: calc(100vh - 177px); overflow-y: auto\" ng-if=orderSuccess><div style=\"display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center\"><img height=450px src=../../../images/payment/success.gif><div style=\"position: absolute;\n      background: white;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center\"><img height=80px src=\"../../../images/Group 1356@2x.png\"><p style=\"color: #0BC278;\n        font-weight: bold;\n        font-size: 20px;\n        margin-top: 20px\">Order Successfully</p><p style=\"color: #0BC278;\n        font-weight: bold;\n        font-size: 20px\">Placed!</p></div></div></div>");
$templateCache.put("app/user-orders/orderPaymentMethods.html","<div class=payment-method-main><div class=paymethodsloader ng-if=paymethodsloader><div><img src=../../images/payment-success-icon.png alt=\"\"><h1>order successfully created</h1></div></div><div class=order-cancel-popup ng-if=orderCancelPopup><div class=popup-wrapper><div class=popup-close ng-click=closeCancel()><img src=\"../../images/close iocn.png\" alt=\"\" style=\"height: 25px\"></div><div class=poup-icon><img src=../../images/cancel-order-icon.png alt=\"\" style=\"height: 85px\"></div><div class=popup-detail><p style=\"font-size: 18px; font-weight: bold; margin-top: 20px\">Are Your Sure!</p><p style=\"font-size: 16px\">You Want To Cancel The Process</p></div><div class=popup-buttons><button class=btn-cancel-outline ng-click=\"changeOrderStatus(\'cancelled\')\">Cancel Order</button> <button class=\"btn-cancel-outline filled\" ng-click=closeCancel()>NO</button></div></div></div><div class=\"top-box f-c d-row jcsa\" id=topGreenBar><p style=\"font-size: 12px\"><img style=\"height: 20px; margin-right: 10px\" src=\"../../images/Icon material-receipt.png\"> Total is <b>PKR {{tprice}}. ORDER NO. {{orderRefNo}}</b></p><img ng-click=\"changeOrderStatus(\'cancelled\')\" src=../../images/dlt-white.png></div><div style=\"background: white; box-shadow: 2px 2px 3px -3px black\"><div class=\"ar aq ap an\"><div style=\"min-height: 70px; padding: 24px 0\" class=\"f-c d-row\" ng-class=\"{\'jcsc\':paymentType == \'10\',\'jcsa\':paymentType != \'10\'}\"><div id=greenBar ng-if=\"paymentType != \'10\'\"><div class=top-box><p><img style=\"height: 20px\" src=\"../../images/Icon material-receipt.png\"> Order Total is <b style=\"margin-right: 20px\">PKR {{tprice}}.</b><b>ORDER NO. {{orderRefNo}}</b></p></div></div><div class=\"f-c d-row jcsa\" style=\"margin-top: 15px; margin-left: auto; margin-right: auto\"><div id=Oplaced class=\"t-checkbox t-checkbox-done\"><h6 class=steps-h6 style=\"width: 75px\">Order placed</h6></div><div><label class=\"btline color0BD684\"></label></div><div id=MakePayment class=t-checkbox ng-class=\"{ \'t-checkbox-done\': paymentType === \'payment-success\', \'t-checkbox-in-process\': paymentType !== \'payment-success\'}\"><h6 class=\"steps-h6 payment-success-text\">{{paymentType != \'payment-success\' ? \'Make Payment\' : \'Payment Successful\'}}</h6></div><div><label class=btline ng-class=\"{ \'color0BD684\': paymentType === \'payment-success\', \'colorccc\': paymentType !== \'payment-success\'}\"></label></div><div id=OCompleted class=t-checkbox ng-class=\"{ \'t-checkbox-done\': paymentType === \'payment-success\'}\"><h6 class=steps-h6 style=\"width: 100px\">{{paymentType != \'payment-success\' ? \'Order Completion\' : \'Order Completed\'}}</h6></div></div><div id=cancelBtn style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div></div><div class=\"ar aq an\" style=\"padding: 0\"><div class=\"f-c d-row-col cr-order\"><div class=\"leftBox payment-method-mobile\" ng-if=\"paymentType != \'payment-success\'\"><!-- <h3 class=\"font-25 text-center font-bold\">\n          Please choose Payment Method:\n        </h3> --><div class=payment-tabs><div class=panel-group id=accordion><div class=\"panel panel-default\"><a class=\"accordion-toggle font-bold\" ng-class=\"{ \'collapsed\': !isBankPayment}\" data-toggle=collapse data-parent=#accordion href=#bankPayment><p>Bank account payments <span>All you need is a simple bank account. No need for debit/credit card.</span></p></a><div id=bankPayment class=\"panel-collapse collapse\" ng-class=\"{ \'in\': isBankPayment}\"><div class=panel-body><ul class=\"payment-list twoRow\"><li ng-click=\"selectPaymentMethod(\'mcb\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'mcb\'}\"><img src=../../images/payment/mcb.svg></div></li><li ng-click=\"selectPaymentMethod(\'allied\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'allied\'}\"><img src=../../images/payment/allied.svg></div></li><li ng-click=\"selectPaymentMethod(\'bankIslami\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'bankIslami\'}\"><img src=../../images/payment/bank-islami.svg></div></li><li ng-click=\"selectPaymentMethod(\'alflah\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'alflah\'}\"><img src=../../images/payment/alflah.svg></div></li><li ng-click=\"selectPaymentMethod(\'bop\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'bop\'}\"><img src=../../images/payment/bop.png></div></li><li ng-click=\"selectPaymentMethod(\'askari\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'askari\'}\"><img src=../../images/payment/askari.png></div></li><li ng-click=\"selectPaymentMethod(\'albarka\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'albarka\'}\"><img src=../../images/payment/al-barka.png></div></li><li ng-click=\"selectPaymentMethod(\'bok\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'bok\'}\"><img src=../../images/payment/bok.png></div></li><li ng-click=\"selectPaymentMethod(\'samba\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'samba\'}\"><img src=../../images/payment/samba.png></div></li><li ng-click=\"selectPaymentMethod(\'hmb\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'hmb\'}\"><img src=../../images/payment/hmb.png></div></li></ul><!-- mobile tabs --><div class=\"rightBox rightBoxMobile\" ng-if=\"paymentType == \'askari\' || paymentType == \'albarka\' || paymentType == \'bok\' || paymentType == \'samba\' || paymentType == \'hmb\' ||paymentType == \'bop\' || paymentType == \'mcb\' || paymentType == \'allied\' || paymentType == \'bankIslami\' || paymentType == \'alflah\'\"><div class=bank-payment><div class=payment-method-detail ng-if=\"paymentType == \'mcb\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/mcb.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'allied\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/allied.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bankIslami\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bank-islami.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'alflah\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/alflah.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bop\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bop.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'askari\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/askari.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'albarka\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/al-barka.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bok\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bok.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'samba\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/samba.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><div class=payment-method-detail ng-if=\"paymentType == \'hmb\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/hmb.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p></div></div><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div></div></div></div><div class=\"panel panel-default\"><a class=\"accordion-toggle font-bold collapsed\" ng-class=\"{ \'collapsed\': !isMobilePayment}\" data-toggle=collapse data-parent=#accordion href=#mobilePayment><p>Mobile payments <span>Pay through EasyPaisa or Jazzcash.</span></p></a><div id=mobilePayment class=\"panel-collapse collapse\" ng-class=\"{ \'in\': isMobilePayment}\"><div class=panel-body><ul class=payment-list><li ng-click=\"selectPaymentMethod(\'easyPaisaNew\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'easyPaisaNew\'}\"><img src=../../images/payment/easypaisa.svg></div></li><li ng-click=\"selectPaymentMethod(\'jazzCash\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'jazzCash\'}\"><img src=../../images/payment/jazz_cash.svg></div></li><!-- <li ng-click=\"selectPaymentMethod(\'qistPay\')\">\n                    <div class=\"payment-method-icon\" ng-class=\"{ \'active\': paymentType === \'qistPay\'}\">\n                      <img src=\"../../images/qispya-icon.png\"/>\n                    </div>\n                  </li> --></ul><!-- mobile tabs --><div class=\"rightBox rightBoxMobile\" ng-if=\"paymentType == \'jazzCash\' || paymentType == \'easyPaisaNew\' || paymentType == \'qistPay\'\"><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'jazzCash\'\" style=\"font-weight: bold\"><div class=bank-payment><div class=jazzcash-logo style=\"margin-bottom: 10px\"><img style=\"width: 250px; height: auto !important\" src=../../images/logo_jazzcash.png></div><p>Pay through your Mobile Wallet and get access instantly.</p><div class=checkbox-jazzcash><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'JazzCash\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div><div id=cancelBtn class=cancel-order-mobile style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'easyPaisaNew\'\" style=\"font-weight: bold\"><div class=bank-payment><div class=jazzcash-logo style=\"margin-bottom: 10px\"><img style=\"width: 250px\" src=../../images/payment/easypaisa.svg></div><p>Pay through your Mobile Wallet and get access instantly.</p><div class=checkbox-jazzcash><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'EasyPaisa\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div></div><!-- <div class=\"d-col f-c alic payment-method-detail\"\n                      ng-if=\"paymentType == \'qistPay\'\"\n                    >\n                      <div class=\"bank-payment\">\n                        <h3 class=\"font-25 font-bold\">QisstPay Payment Schedule</h3>\n                        <p style=\"line-height: 1.7;\">4 Interest-Free payments of PKR {{tprice}} with <span> <img src=\"../../images/qispya-icon.png\" alt=\"\" style=\"width: 20px; height: auto; margin-bottom: 0;\"> QisstPay</span>.You need a Debit or Credit card for the transaction and your payment will be deducted automatically every month.</p>\n  \n                        <div class=\"qist-container\">\n                          <div ng-repeat=\"installment in qistPayInstallments\" class=\"qist-row qist-link\" ng-class=\"{ \'qist-last\': installment.isLast}\"><p><span class=\"qist-dot qist-today\"></span>{{installment.date | date:\'MMM dd, yyyy\'}}</p>   <p style=\"margin-left:30px;\"> PKR {{installment.amount}}</p></div>\n                          <div class=\"qist-total\">Total <span style=\"margin-left:30px;\">PKR</span> {{tprice}}</div>\n                        </div>\n                        <button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentQistPay()\">\n                          <span ng-if=\"!loadingPayment\">Proceed to payment</span>\n                          <div ng-if=\"loadingPayment\" class=\"loader-contaiber\">\n                            <div class=\"login-theme-loader\"></div>\n                          </div>\n                        </button>\n                        <div\n                          id=\"cancelBtn\"\n                          class=\"cancel-order-mobile\"\n                          style=\"text-align: center\"\n                          ng-if=\"paymentType != \'payment-success\'\"\n                        >\n                          <button\n                            style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\"\n                            ng-click=\"showCancel()\"\n                          >\n                            Cancel Order\n                          </button>\n                        </div>\n                      </div >\n                    </div> --></div></div></div></div><div class=\"panel panel-default\"><a class=\"accordion-toggle font-bold collapsed\" data-toggle=collapse data-parent=#accordion href=#cardPayment><p>Debit/Credit cards <span>Use your internet enabled Debit or Credit Card to make a transaction.</span></p></a><div id=cardPayment class=\"panel-collapse collapse\"><div class=panel-body><ul class=payment-list><li ng-click=\"selectPaymentMethod(\'payMob\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'payMob\'}\"><img src=../../images/payment/paymoc.svg></div></li></ul><!-- mobile tabs --><div class=\"rightBox rightBoxMobile\" ng-if=\"paymentType == \'payMob\'\"><div class=payment-method-detail><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/paymoc.svg alt=#></div><p>Pay through highly secure and trusted payment partner.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'paymob\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div></div></div></div></div><div class=\"panel panel-default\" style=\"display: none\"><a class=\"accordion-toggle font-bold\" ng-class=\"{ \'collapsed\': paymentType !== \'qistPay\'}\" data-toggle=collapse data-parent=#accordion href=#qisstPay><p>Buy Now Pay Later <span>Now pay in easy 04 months interest free installments.</span></p></a><div id=qisstPay class=\"panel-collapse collapse\" ng-class=\"{ \'in\': paymentType === \'qistPay\'}\"><div class=panel-body><ul class=payment-list><li ng-click=\"selectPaymentMethod(\'qistPay\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'qistPay\'}\"><img src=../../images/qispya-icon.png></div></li></ul><!-- mobile tabs --><div class=\"rightBox rightBoxMobile\" ng-if=\"paymentType == \'qistPay\'\"><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'qistPay\'\"><div class=bank-payment><h3 class=\"font-25 font-bold\">QisstPay Payment Schedule</h3><p style=\"line-height: 1.7\">4 Interest-Free payments of PKR {{tprice}} with <span><img src=../../images/qispya-icon.png alt=\"\" style=\"width: 20px; height: auto; margin-bottom: 0\"> QisstPay</span>.You need a Debit or Credit card for the transaction and your payment will be deducted automatically every month.</p><div class=qist-container><div ng-repeat=\"installment in qistPayInstallments\" class=\"qist-row qist-link\" ng-class=\"{ \'qist-last\': installment.isLast}\"><p><span class=\"qist-dot qist-today\"></span>{{installment.date | date:\'MMM dd, yyyy\'}}</p><p style=margin-left:30px>PKR {{installment.amount}}</p></div><div class=qist-total>Total <span style=margin-left:30px>PKR</span> {{tprice}}</div></div><button class=\"btn-contained btn-proceed\" ng-click=proceedPaymentQistPay()><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button><div id=cancelBtn class=cancel-order-mobile style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div></div></div></div></div><div class=\"panel panel-default\"><a class=\"accordion-toggle font-bold collapsed\" data-toggle=collapse data-parent=#accordion href=#accountPayment><p>Manual Payment <span>Make a simple bank account deposit/transfer and let us know on WhatsApp.</span></p></a><div id=accountPayment class=\"panel-collapse collapse\"><div class=panel-body><ul class=payment-list><li ng-click=\"selectPaymentMethod(\'manualTransferFaysal\')\"><div class=payment-method-icon ng-class=\"{ \'active\': paymentType === \'manualTransferFaysal\'}\"><img src=../../images/payment/faisal.svg></div></li><!-- <li ng-click=\"selectPaymentMethod(\'manualTransferInternational\')\">\n                    <div class=\"payment-method-icon\" ng-class=\"{ \'active\': paymentType === \'manualTransferInternational\'}\">\n                      <img src=\"../../images/payment/international.svg\" />\n                    </div>\n                  </li> --></ul><!-- mobile tabs --><div class=\"rightBox rightBoxMobile\" ng-if=\"paymentType == \'manualTransferFaysal\' || paymentType == \'manualTransferInternational\'\"><div class=payment-method-detail ng-if=\"paymentType == \'manualTransferFaysal\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/faisal.svg alt=#></div><p style=\"line-height: 1.6 !important\">Make a manual transaction from any bank account and WhatsApp us the payment proof.<br><b>Bank Name: Faysal Bank</b><br><b>Account Number: 0125007900219780</b><br><b>Branch: DHA- Phase 1, Lahore</b><br><b>Mobile Number: 03459615004</b><br><b>Account Title: NEARPEER (Private) LIMITED</b></p><button class=\"btn-contained btn-proceed\">WhatsApp us</button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'manualTransferInternational\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/international.svg alt=#></div><p style=\"line-height: 1.6 !important\">Make a manual transaction from any account and WhatsApp us the payment proof:<br><b>Bank Name: Faysal Bank</b><br><b>Account Number: 0125007900219780</b><br><b>Branch: DHA- Phase 1, Lahore</b><br><b>Mobile Number: 03459615004</b><br><b>Account Title: NEARPEER (Private) LIMITED</b></p><button class=\"btn-contained btn-proceed\">WhatsApp us</button></div></div></div></div></div></div></div></div></div><div class=leftBox ng-if=\"paymentType == \'payment-success\'\"><div class=payment-success-mobile style=\"align-items: center\"><img style=\"width: 70px\" src=../../images/payment/payment-successfull.png><div style=\"margin: 10px 0\"><h3 style=\"font-weight: bold; color: #38b16c\">Payment Success</h3></div><p>You now have access to {{orderObject.orderItems.course_id.name}}</p></div><h3 class=\"font-25 order-title\">Your Order Details</h3><div class=successDiv id=successDiv><div class=\"order-detail flex-view flex-direction-row-col\"><div class=order-detail-title width=130px>Order Number</div><div><b>{{newOrder.ref_no}}</b></div></div><div class=\"order-detail flex-view flex-direction-row-col\"><div class=order-detail-title width=130px>Payment Method</div><div ng-if=\"newOrder.order_by === \'qist_pay\'\"><img src=../../images/qispya-icon.png style=\"height: 20px\"><b style=\"margin-left: 7px\">Qisst Pay</b></div><div ng-if=\"newOrder.order_by === \'jazz_cash\'\"><b>JazzCash</b></div><div ng-if=\"newOrder.order_by !== \'jazz_cash\' && newOrder.order_by !== \'qist_pay\'\"><b>{{newOrder.order_by}}</b></div></div><!-- <div><div>Payment Type</div><div>{{tprice}}</div></div> --><div class=\"order-detail flex-view flex-direction-row-col\"><div class=order-detail-title>Registered Email</div><div><b>{{user_.email ? user_.email : user_.fb_email ? user_.fb_email : user_.apple_email ? user_.apple_email : \'Social Login\'}}</b></div></div><div class=\"order-detail flex-view flex-direction-row-col\"><div class=order-detail-title>Amount Paid</div><div><b>PKR {{tprice}}</b></div></div><div class=\"order-detail flex-view flex-direction-row-col\" ng-if=bundle_><div class=order-detail-title>Bundle Name</div><div><b>{{bundle_.name}}</b></div></div><div class=\"order-detail flex-view flex-direction-row-col\" ng-if=!bundle_><div class=order-detail-title>Course Name</div><div><b>{{course_.name}}</b></div></div><div class=\"order-detail flex-view flex-direction-row-col\" ng-if=module_><div class=order-detail-title>Module Name</div><div><b>{{module_.name}}</b></div></div></div><div style=\"display: flex; flex-direction: row; justify-content: end; align-items: baseline\"><p style=\"color: red; padding-right: 20px\" ng-click=getScreenShot()>Save Screenshot</p><button ng-if=!liveSessionId class=\"btn-contained btn-proceed\" style=\"width: 40%\" ng-click=gotoCourse()>{{bundle_ ? \'Go to Courses\' : \'Go to Course\'}}</button> <button ng-if=liveSessionId class=\"btn-contained btn-proceed\" style=\"width: 40%\" ng-click=gotoLiveSession()>Go To Live Session</button></div></div><div class=rightBox ng-if=\"paymentType == \'paymentBanner\' || paymentType == \'jazzCash\' || paymentType == \'bankPayment\' || paymentType == \'qistPay\' || paymentType == \'easypaisa\' || paymentType == \'4\' || paymentType == \'5\'\n                || paymentType == \'6\' || paymentType == \'7\' || paymentType == \'8\'|| paymentType == \'mcb\' || paymentType == \'allied\' || paymentType == \'bankIslami\'\n                 || paymentType == \'alflah\' || paymentType == \'bop\' || paymentType == \'askari\' || paymentType == \'albarka\' || paymentType == \'bok\'\n                 || paymentType == \'samba\' || paymentType == \'hmb\' || paymentType == \'easyPaisaNew\' || paymentType == \'payMob\'|| paymentType == \'manualTransferFaysal\'\n                  || paymentType == \'manualTransferInternational\'\"><div class=payment-method-detail ng-if=\"paymentType == \'paymentBanner\'\"><div class=bank-payment><p>Please choose a payment method to continue</p><div class=other-bank-logo><img src=../../images/payment/banner.svg alt=#></div></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bankPayment\'\"></div><div class=payment-method-detail ng-if=\"paymentType == \'mcb\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/mcb.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'allied\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/allied.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bankIslami\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bank-islami.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'alflah\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/alflah.svg alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bop\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bop.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'askari\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/askari.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'albarka\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/al-barka.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'bok\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/bok.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'samba\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/samba.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'hmb\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/hmb.png alt=#></div><p>Pay through NIFT method by adding your bank <b>Account number, CNIC</b> and <b>Mobile number</b> only.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'NIFT\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'jazzCash\'\" style=\"font-weight: bold\"><div class=bank-payment><div class=jazzcash-logo style=\"margin-bottom: 10px\"><img style=\"width: 250px; height: auto\" src=../../images/logo_jazzcash.png></div><p>You are being redirected to JazzCash Portal.</p><div class=checkbox-jazzcash><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'JazzCash\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div><div id=cancelBtn class=cancel-order-mobile style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'easyPaisaNew\'\" style=\"font-weight: bold\"><div class=bank-payment><div class=jazzcash-logo style=\"margin-bottom: 10px\"><img style=\"width: 250px\" src=../../images/payment/easypaisa.svg></div><p>You are being redirected to EasyPaisa Portal.</p><div class=checkbox-jazzcash><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'EasyPaisa\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div><div id=cancelBtn class=cancel-order-mobile style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div><div class=\"d-col f-c alic payment-method-detail\" ng-if=\"paymentType == \'qistPay\'\" style=\"font-weight: bold\"><div class=bank-payment><h3 class=\"font-25 font-bold\">QisstPay Payment Schedule</h3><p style=\"line-height: 1.7\">4 Interest-Free payments of PKR {{tprice}} with <span><img src=../../images/qispya-icon.png alt=\"\" style=\"width: 20px; height:auto; margin-bottom:0\"> QisstPay</span>.You need a Debit or Credit card for the transaction and your payment will be deducted automatically every month.</p><div class=qist-container><div ng-repeat=\"installment in qistPayInstallments\" class=\"qist-row qist-link\" ng-class=\"{ \'qist-last\': installment.isLast}\"><p><span class=\"qist-dot qist-today\"></span>{{installment.date | date:\'MMM dd, yyyy\'}}</p><p style=margin-left:30px>PKR {{installment.amount}}</p></div><div class=qist-total>Total <span style=margin-left:30px>PKR</span> {{tprice}}</div></div><div class=checkbox-jazzcash><button class=\"btn-contained btn-proceed\" ng-click=proceedPaymentQistPay()><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div><div id=cancelBtn class=cancel-order-mobile style=\"text-align: center\" ng-if=\"paymentType != \'payment-success\'\"><button style=\"border: 0; padding: 5px 10px; color: #BDBDBD; background: none; font-size: 16px\" ng-click=showCancel()>Cancel Order</button></div></div></div><div class=payment-method-detail ng-if=\"paymentType == \'payMob\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/paymoc.svg alt=#></div><p>Pay through highly secure and trusted payment partner.</p><button class=\"btn-contained btn-proceed\" ng-click=\"proceedPaymentPaymob(\'paymob\')\"><span ng-if=!loadingPayment>Proceed to payment</span><div ng-if=loadingPayment class=loader-contaiber><div class=login-theme-loader></div></div></button></div></div><div class=payment-method-detail ng-if=\"paymentType == \'manualTransferFaysal\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/faisal.svg alt=#></div><p style=\"line-height: 1.6 !important\">Make a manual transaction from any account and WhatsApp us the payment proof:<br><b>Bank Name: Faysal Bank</b><br><b>Account Number: 0125007900219780</b><br><b>Branch: DHA- Phase 1, Lahore</b><br><b>Mobile Number: 03459615004</b><br><b>Account Title: NEARPEER (Private) LIMITED</b></p><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=blank_><button class=\"btn-contained btn-proceed\" ng-click=proceedPaymentQistPayManual()>WhatsApp us</button></a></div></div><div class=payment-method-detail ng-if=\"paymentType == \'manualTransferInternational\'\"><div class=bank-payment><div class=other-bank-logo><img src=../../images/payment/international.svg alt=#></div><p style=\"line-height: 1.6 !important\">Make a manual transaction from any account and WhatsApp us the payment proof:<br><b>Bank Name: Faysal Bank</b><br><b>Account Number: 0125007900219780</b><br><b>Branch: DHA- Phase 1, Lahore</b><br><b>Mobile Number: 03459615004</b><br><b>Account Title: NEARPEER (Private) LIMITED</b></p><a href=\"https://api.whatsapp.com/send?phone=923111444734\" target=blank_><button class=\"btn-contained btn-proceed\">WhatsApp us</button></a></div></div><div ng-if=\"paymentType == \'4\'\"><div class=\"f-c d-col\"><div class=trackUp id=nearpeerSlide><div id=c-track style=\"width: 2600px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Open your JazzCash App</b></p><p class=fcolp>Tap Money Transfer</p><p class=fcolp>Select Bank Account</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/jazzcash_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Enter Bank Details:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Mobile Number: 03459615004</p><p class=fcolp>Purpose: Education</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Click on “Send Now”</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/jazzcash_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Send Us Proof of payment</b></p><p class=fcolp>A. Your Course Name</p><p class=fcolp>B. Screenshot of the SMS you get from 3737 (or the Easypaisa App Screen)</p><p class=fcolp>C. Your Nearpeer login ID (after signing-up)</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ for=actual-btn>{{ imageName||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 170px\" src=../../images/jazzcash_step3.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li></ul></div></div></div><div ng-if=\"paymentType == \'5\'\"><div class=\"f-c d-col\"><div class=trackUp><div id=c-track style=\"width: 2000px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Visit your Bank’s Website/App</b></p><p class=fcolp>Tap Send Money</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/obt_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Add following account as your beneficiary:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Mobile Number: 03459615004</p><p class=fcolp>Purpose: Education</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Click on “Transfer Amount”</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/obt_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Send Us Proof of payment:</b></p><p class=fcolp>A. Your Course Name</p><p class=fcolp>B. Screenshot of the SMS you get from 3737 (or the Easypaisa App Screen)</p><p class=fcolp>C. Your Nearpeer login ID (after signing-up)</p><p class=fcolp>Our no: 03470171480</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ for=actual-btn>{{ imageURL||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 170px\" src=../../images/obt_step3.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li></ul></div></div></div><div ng-if=\"paymentType == \'6\'\"><div class=\"f-c d-col\"><div class=trackUp><div id=c-track style=\"width: 2000px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Walk into any Faysal Bank Branch</b></p><p class=fcolp>Request an Account Deposit service.</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/fbl_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Provide them the following bank details:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Branch: DHA- Phase 1, Lahore</p><p class=fcolp>Mobile Number: 03459615004</p><p class=fcolp>Purpose: Education</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Once the amount is deposited, you’ll get a slip from the bank representative</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/fbl_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Once done, Whatsapp us:</b></p><p class=fcolp>A. Picture of the deposit slip you got</p><p class=fcolp>B. Your Nearpeer Login ID (after signing-up)</p><p class=fcolp>C. Your Course Name</p><p class=fcolp>Our no: 03470171480</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ for=actual-btn>{{ imageURL||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 170px\" src=../../images/fbl_step3.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li></ul></div></div></div><div ng-if=\"paymentType == \'7\'\"><div class=\"f-c d-col\"><div class=trackUp><div id=c-track style=\"width: 2000px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Visit the ATM of the Bank.</b></p><p class=fcolp>Insert the card, type in the pin.</p><p class=fcolp>Select Money/Amount Transfer.</p><p class=fcolp>Select non-IBAN account.</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/atm_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Add following details:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Once the amount is deposited, you’ll get a slip from the machine.</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/atm_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Once done, Whatsapp us:</b></p><p class=fcolp>A. Picture of the deposit slip you got</p><p class=fcolp>B. Your Nearpeer Login ID (after signing-up)</p><p class=fcolp>C. Your Course Name</p><p class=fcolp>Our no: 03470171480</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ for=actual-btn>{{ imageURL||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 170px\" src=../../images/atm_step3.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li></ul></div></div></div><div ng-if=\"paymentType == \'8\'\"><div class=\"f-c d-col\"><div class=trackUp><div id=c-track style=\"width: 2000px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Visit your Bank’s Website/App</b></p><p class=fcolp>Tap Send Money</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/ibt_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Add following account as your beneficiary:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Mobile Number: 03459615004</p><p class=fcolp>Purpose: Education</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Click on “Transfer Amount”</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/ibt_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Send Us Proof of payment:</b></p><p class=fcolp>A. Your Course Name</p><p class=fcolp>B. Screenshot of the SMS you get from 3737 (or the Easypaisa App Screen)</p><p class=fcolp>C. Your Nearpeer login ID (after signing-up)</p><p class=fcolp>Our no: 03470171480</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ for=actual-btn>{{ imageURL||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 170px\" src=../../images/ibt_step3.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li></ul></div></div></div><div ng-if=\"paymentType == \'easypaisa\'\"><div class=\"f-c d-col\"><div class=trackUp><div id=c-track style=\"width: 2000px\" class=\"f-c d-row\"><div id=1 class=\"f-c d-col alic active_now c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>1</label><div class=\"f-c d-col\"><p class=fcolp><b>Open your easypaisa App</b></p><p class=fcolp>Tap Money Transfer</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/easypaisa_step1.png></div></div></div><div id=2 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>2</label><div class=\"f-c d-col\"><p class=fcolp><b>Select Bank Account and serach Faysal Bank</b></p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/easypaisa_step2.png></div></div></div><div id=3 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>3</label><div class=\"f-c d-col\"><p class=fcolp><b>Enter Bank Details:</b></p><p class=fcolp>Bank Name: Faysal Bank</p><p class=fcolp>Bank Account Number: 0125007900219780</p><p class=fcolp>Mobile Number: 03459615004</p><p class=fcolp>Purpose: Education</p><p class=fcolp>Confirm the Bank Account Title: NEARPEER(Private) LIMITED</p><p class=fcolp>Click on “Send Now”</p></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/easypaisa_step3.png></div></div></div><div id=4 class=\"f-c d-col alic c-t-inDiv\"><div class=\"f-c d-row jcsa\" style=\"width: 100%\"><div class=\"f-c d-row\"><label class=r-circle>4</label><div class=\"f-c d-col\"><p class=fcolp><b>Send Us Proof of payment</b></p><p class=fcolp>A. Your Course Name</p><p class=fcolp>B. Screenshot of the SMS you get from 3737 (or the Easypaisa App Screen)</p><p class=fcolp>C. Your Nearpeer login ID (after signing-up)</p><p class=fcolp style=\"margin: 5px 0;\n                            text-align: center;\n                            font-weight: bold\">Or</p><input type=file id=actual-btn ng-model=image ngf-select=uploadImage(image)><label class=button_ style=\"text-align: center\" for=actual-btn>{{ imageURL||\'Upload Payment Proof\'}}</label></div></div><div><img style=\"height: 250px; min-width: 225px\" src=../../images/easypaisa_step4.png></div></div></div></div></div><div style=\"padding: 10px; text-align: center\"><button class=btn-NP ng-click=prevButtonMethod()>Prev</button> <button class=btn-NP ng-click=nextButtonMethod()>Next</button></div><div class=f-c style=\"justify-content: center; margin-top: 5px\"><ul class=steps><li><button id=btn1 class=\"btn-num btn-numF\">1</button></li><li><button id=btn2 class=btn-num>2</button></li><li><button id=btn3 class=btn-num>3</button></li><li><button id=btn4 class=btn-num>4</button></li></ul></div></div></div></div><div class=\"rightBox payment-success-box\" style=\"border-left: 0px !important\" ng-if=\"paymentType == \'payment-success\'\"><div class=\"f-c d-col\" style=\"align-items: center\"><img style=\"width: 70px\" src=../../images/payment/payment-successfull.png><div style=\"margin: 10px 0\"><h3 style=\"font-weight: bold; color: #38b16c\">Payment Successful</h3></div><p>You now have access to {{orderObject.orderItems.course_id.name}}</p><div><img style=\"height: 200px; min-width: 225px\" src=../../images/payment/frame_1.png></div></div></div></div></div></div>");
$templateCache.put("app/user-orders/orderSummary.html","<p>orderSummary works!</p>");
$templateCache.put("app/user-orders/userOrderList.html","<p>userOrderList works!</p>");
$templateCache.put("app/admin/CourseAccessForm/CourseAccessForm.html","<admin-header statename=\"Course Access Form\"></admin-header><div class=coure-access-form><!--  --><div><div class=\"row search-type-block\" ng-show=types><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'bundle\')\" class=\"btn btn-default secondry_btn\">Bundle</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'course\')\" class=\"btn btn-default secondry_btn\">Course</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'module\')\" class=\"btn btn-default secondry_btn\">Module</button></div></div><div class=\"row info-block mt-10 mb-10\"><h3 class=pb-20>Order Type</h3><div class=col-md-12><select class=btn ng-model=access.orderStatus><option value=paid>Paid</option><option value=placed>Payment Link</option></select></div></div><div class=\"row info-block mt-10 mb-10\" ng-if=\"access.orderStatus === \'placed\'\"><h3 class=pb-20>Payment Method</h3><div class=col-md-12><select class=btn ng-model=access.paymentMethod><option value=EASYPAISA>Easypaisa</option><option value=JAZZCASH>Jazzcash</option><option value=NIFT>NIFT</option><option value=CARD>Card</option></select></div></div><div class=\"row course-form-search\"><div class=col-md-6><div class=\"publish form-group mt-10\"><input type=checkbox ng-model=newUser> New User</div></div></div><div class=\"row course-form-search mt-10\" ng-if=!newUser><div class=col-md-6><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? searchInfo(userKey,\'user\') : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=\"addVariants(user,\'user\')\" class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.name || user.full_name}} ({{user.provider}}) <span ng-if=\"!user.confirmed_at || !user.phone_confirmed_at \">(Not Verifired: </span><span ng-if=!user.confirmed_at>Email</span> <span ng-if=!user.phone_confirmed_at>Phone</span><span ng-if=\"!user.confirmed_at || !user.phone_confirmed_at \">)</span></li></ul></div></div></div><div ng-show=access.type class=\"row course-form-search\"><!------ col-md-6-----><div class=col-md-6><div class=form-group><label>{{access.type===\'course\' || access.type===\'module\'?\'Course\':\'Bundle\'}}</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey,access.type) : null\" placeholder=\"Search {{access.type===\'course\' || access.type===\'module\'?\'Course\':\'Bundle\'}}\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=addVariants(course,access.type) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div ng-show=\"access.type===\'module\'\" class=col-md-6><div class=form-group data-text=\"Enter text here\"><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{$index}}>{{module.name}}</option></select></div></div><!------ col-md-6-----></div></div><div ng-show=showInfo><!-----row-----><div class=\"row info-block mt-30\"><div ng-if=\"selectedUser.id || newUser\" class=col-md-12><h3 class=pb-20>Basic Information</h3><h5 ng-if=reactivate style=\"color: red\">Repeat User</h5><div class=form-group ng-if=!newUser><input type=text class=form-control ng-model=selectedUser.name placeholder=\" First Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.full_name placeholder=\" Full Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.email placeholder=\"Primary Email Address\"></div><div class=form-group ng-if=!newUser><input type=text class=form-control ng-model=selectedUser.fb_email placeholder=\"Facebook Email Address\" readonly></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.phone placeholder=\"Mobile Number\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.city placeholder=City></div></div><div class=\"row payment-block info-block mt-30 mb-30\" ng-if=\"selectedCourses.length > 0\"><h3 class=pb-20>Access Type</h3><div class=col-md-12><select class=btn ng-model=access.accessType><option value=payment>Payment</option><option value=trial>Course Trial</option><option value=time_bound>Time Bound Access</option><option value=installment>Installment</option><option value=subscription>Subscription</option></select></div></div><div class=col-md-12 ng-if=\"selectedCourses.length > 0\"><h3 class=pb-20>Select Courses</h3><div class=col-md-12 ng-repeat=\"selectedCourse in selectedCourses\"><div class=\"form-group col-md-1 col-sm-1\" style=\"padding-top: 6px\"><span ng-if=selectedCourse.courseReactivate style=\"color: red\">Reactivate</span></div><div class=\"form-group col-md-3 col-sm-3\"><input type=text class=form-control ng-model=selectedCourse.name readonly></div><div class=\"form-group col-md-2 col-sm-3\"><input type=text class=form-control ng-model=selectedCourse.price readonly></div><div class=\"form-group col-md-2 col-sm-2\" ng-if=\"access.accessType !== \'subscription\'\"><input type=number class=form-control ng-model=selectedCourse.amount placeholder=\"Amount Paid\"></div><div class=\"form-group col-md-2 col-sm-2\" ng-if=\"access.accessType === \'installment\'\"><input type=number class=form-control ng-model=selectedCourse.totalInstallmentAmount placeholder=\"Total Installment Amount\"></div><div class=\"form-group col-md-2 col-sm-2\" ng-if=\"access.accessType === \'subscription\'\"><select class=btn ng-model=selectedCourse.subscription_id><option value=\"\" selected disabled>Select Subscription</option><option ng-repeat=\"subscription in selectedCourse.subscriptions\" value={{subscription.id}}>{{subscription.subscription_name}}</option></select></div><div class=\"form-group col-md-1 col-sm-1\" style=\"padding-top: 6px\"><a style=\"font-weight: bold; font-size: 23px\" ng-click=removeCourse($index)>X</a></div></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Session: <span>{{access.session_name}}</span></label><input type=text class=form-control placeholder=\"Search Session\" ng-model=selectedCourse.sessionKey ng-blur=selectSessionBlur(selectedCourse) ng-focus=\"searchSession(selectedCourse, selectedCourse.sessionKey)\" ng-change=\"searchSession(selectedCourse, selectedCourse.sessionKey)\"><ul ng-if=\"selectedCourse.sessions.length > 0\" class=list-group><li ng-click=\"selectSession(selectedCourse, session)\" class=list-group-item ng-repeat=\"session in selectedCourse.sessions\">{{session.name}}</li></ul></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Agent: <span>{{access.agent ? access.agent.name : \"\"}}</span></label><input type=text placeholder=\"Search Agent\" ng-focus=focusAgent() ng-blur=agentBlur() ng-model=agentKey ng-change=searchAgent(agentKey) class=form-control><ul ng-if=\"agents.length > 0 && !hideAgent\" class=list-group><li ng-click=\"selectAgent(\'none\'); agentKey = \'\'\" class=list-group-item style=\"color: lightgray\">None</li><li ng-click=selectAgent(agent) class=list-group-item ng-repeat=\"agent in agents\">{{agent.name}}</li></ul></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Campaign:<p ng-repeat=\"selectedCampaign in selectedCampaigns\">{{selectedCampaign.name}}</p></label><input type=text placeholder=\"Search Campaign\" ng-focus=focuscampaign() ng-blur=campaignBlur() ng-model=campaignKey ng-change=searchCampaign(campaignKey) class=form-control><ul ng-if=\"campaigns.length > 0 && !hideCampaign\" class=list-group><li ng-click=\"selectCampaign(\'none\'); campaignKey = \'\'\" class=list-group-item style=\"color: lightgray\">None</li><li ng-click=selectCampaign(campaign) class=list-group-item ng-repeat=\"campaign in campaigns\">{{campaign.name}}</li></ul></div></div></div><!-----row-----><!-- ng-if=\"selectedCourse.paid\" --><div class=\"row payment-block info-block mt-30 mb-30\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6 ng-if=\"access.orderStatus === \'paid\' && (access.accessType === \'payment\' || access.accessType === \'time_bound\' || access.accessType === \'installment\')\"><h3 class=pb-20>Payment Information</h3><div class=\"form-group upload-file-form\"><label>{{ access.proof||\'Amount Payment Proof\'}} <span>&#x2b;</span> <input class=upload-box ng-model=image ngf-select=\"uploadImage(image,\'access\')\" type=file id=file placeholder=\"Amount Payment Proof\"></label></div><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{access.payment_id.name ||\'Payment type\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'type\')\">Payment Type</a></li><li ng-repeat=\"type in payTypes\"><a ng-click=\"accessVariants(type , \'type\')\">{{type.name}}</a></li></ul></div></div><div class=form-group><div flex-gt-xs><label id=payment_date for=to>Payment Date</label><md-datepicker ng-model=access.payment_date md-placeholder=\"Enter date\" input-aria-labelledby=payment_date></md-datepicker></div></div></div><div class=col-md-6 ng-if=\"access.accessType === \'trial\' || access.accessType === \'time_bound\'  || access.accessType === \'installment\'\"><h3 class=pb-20>{{access.accessType === \'trial\' ? \'Trial Access\' : \'Time Bound Access\'}}</h3><div class=form-group><p>Enter Expiry Date</p><input type=datetime-local class=form-control ng-model=access.expiryDate placeholder=\"Expiry Date\"></div><div class=form-group><p>Notification hours before expiry</p><input type=number class=form-control ng-model=access.notifyHours placeholder=\"No. of hours\"></div></div><div class=col-md-6 ng-if=\"access.orderStatus === \'paid\'\"><h3 class=pb-20>Reason for Free</h3><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{access.reason_id.reason ||\'Select Reason\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'reason\')\">Select Reason</a></li><li ng-repeat=\"reason in reasons\"><a ng-click=\"accessVariants(reason , \'reason\')\">{{reason.reason}}</a></li></ul></div></div><div class=form-group><textarea type=text ng-model=access.comments class=\"reason-comment-block form-control\" placeholder=\"Write your comments...\"></textarea></div></div><div class=\"row course-form-search\"><div class=col-md-6><div class=\"publish form-group mt-10\"><input type=checkbox ng-model=notifyByWhatsapp ng-click=toggleNotifyByWhatsapp()> Notify On WhatsApp</div></div></div><div class=col-md-12><button type=button ng-disabled=disabled ng-click=createAccess(selectedUser,selectedCourses,access) class=\"btn btn-default primary_btn payment-block-btn\">Submit</button></div></div><!-----row-----></div></div>");
$templateCache.put("app/admin/FAQS/FAQS.html","<admin-header statename=FAQs></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=pull-right><a ui-sref=AdminFAQSCreate() class=\"btn btn-default primary_btn\">Create FAQ</a></div><div class=form-group><div class=pull-left><input type=text placeholder=\"Type Here For Search\" ng-model=faqExcerpt ng-change=\"faqExcerpt.length>= 0 ? searchFaq(faqExcerpt):null\" class=form-control></div><div class=\"col-xs-12 col-md-4 ng-binding no-of-pages\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span class=order-page-detail>{{(totalFaqs > 0)?searchParams.page: 0}} in {{(totalFaqs > 0)?totalPages:0}} ,{{(totalFaqs>0)?((searchParams.page*searchParams.per_page)-searchParams.per_page)+1:0}}-{{((searchParams.per_page*searchParams.page)>totalFaqs)?totalFaqs:searchParams.per_page*searchParams.page}} Out of {{totalFaqs}}</span></div><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{!(instName.name)?\'All Institute\':instName.name}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=getAllInstFaqs()>All Institute</a></li><li ng-repeat=\"inst in institutions\"><a ng-click=pickIt(inst)>{{inst.name}}</a></li></ul></div></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-12\" ng-repeat=\"faq in faqs\"><div class=\"form-group holder\"><div class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ui-sref=\"AdminFAQSEdit({url: !(faq.url)?faq.faqId.url:faq.url})\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=deleteFaq(faq) class=\"glyphicon glyphicon-trash\"></a></div></div><span class=single-bundles>Question: {{ !(faq.question)?faq.faqId.question:faq.question }}</span><br><br><span class=single-bundles>Answer: {{ !(faq.answer)?faq.faqId.answer:faq.answer }}</span></div></div></div></div></div>");
$templateCache.put("app/admin/Institution/Institution.html","<admin-header statename=Institution></admin-header><div class=\"row editable-tags pb-30\"><div class=col-md-12><div class=\"col-xs-12 col-md-3\" ng-repeat=\"inst in institutions\"><div class=\"form-group holder\"><span>{{ inst.name | limitTo : 20 }} {{inst.name.length > 20 ? \'...\' : \'\'}}</span><div class=\"pull-right actions\"><a ng-click=\"editInstitute(inst,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=\"editInstitute(inst,\'del\')\" class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Institution</h3></div><div class=\"col-xs-12 col-md-6\"><form name=myForm class=form-group><label>Institution Name</label><input type=text class=form-control ng-model=institution.name></form><form name=myForm class=form-group><label>Video URL</label><input type=text class=form-control ng-model=institution.videoUrl></form></div></div></div><div class=\"col-md-12 pl-30\"><button ng-click=createIstitution(institution) class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/CourseFeature/CourseFeature.html","<admin-header statename=\"Course Feature\"></admin-header><div class=form-area><form><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=\"uploadlgBox mb-30\" style=\"min-height: 100px;width: 100px\"><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i> </span><input class=uploadlgBox ng-if=!cf.imageUrl type=file accept=image/* ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image ng-if=cf.imageUrl src={{cf.imageUrl}} alt=\"\"> <span ng-if=!cf.imageUrl class=upload style=\"left: 0\">Upload Image</span></div><!-- <div class=\"form-group\">\n                        <span class=\"cross\"><i ng-click=\"delImage()\" class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </span>\n                        <label>Image URL</label>\n                        <img class=\"uploaded_image\" src=\"{{cf.imageUrl}}\" alt=\"\" />\n                        <input class=\"uploadlgBox\" type=\"file\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImage(image)\">\n                    </div> --></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Title</label><input type=text class=form-control ng-model=cf.name></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Description</label><input type=text class=form-control maxlength=70 ng-model=cf.description></div></div></div></div><div class=col-md-12><button ng-click=submit(cf) class=\"btn btn-default primary_btn\">Save</button></div></form></div><div class=\"col-xs-12 col-md-12 mb-30\"><div class=\"col-xs-12 col-md-6 padding0\"><div class=form-group><input type=text placeholder=\"Search Here ...\" class=form-control ng-model=query ng-change=\"query.length> 1 ? searchFeature(query):searchFeature(null)\"></div></div></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-12\" ng-repeat=\"feature in features\"><div class=\"form-group holder\"><input type=checkbox class=checkbox ng-click=\"editFeature(feature,\'publish\')\" ng-model=feature.publish> <img class=uploaded_image src={{feature.imageUrl}}><!-- <span>{{feature.imageUrl | limitTo : 20 }} {{tag.title.length > 20 ?\n                    \'...\' : \'\'}}</span> --> <span class=title>{{feature.name | limitTo : 20 }} {{tag.title.length > 20 ? \'...\' : \'\'}}</span> <span>{{feature.description | limitTo : 20 }} {{tag.title.length > 20 ? \'...\' : \'\'}}</span><div class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=\"editFeature(feature,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=\"editFeature(feature,\'del\')\" class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div></div>");
$templateCache.put("app/admin/DeleteCourse/deleteCourse.html","<div class=container></div>");
$templateCache.put("app/admin/MainCategories/MainCategories.html","<admin-header statename=\"Main Categories\"></admin-header><div class=form-area><form><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=\"uploadlgBox mb-30\" style=\"min-height: 100px;width: 100px\"><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i> </span><input class=uploadlgBox ng-if=!cf.image_url type=file accept=image/* ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image ng-if=cf.image_url src={{cf.image_url}} alt=\"\"> <span ng-if=!cf.image_url class=upload style=\"left: 0\">Upload Image</span></div><!-- <div class=\"form-group\">\n                        <span class=\"cross\"><i ng-click=\"delImage()\" class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </span>\n                        <label>Image URL</label>\n                        <img class=\"uploaded_image\" src=\"{{cf.imageUrl}}\" alt=\"\" />\n                        <input class=\"uploadlgBox\" type=\"file\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImage(image)\">\n                    </div> --></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Title</label><input type=text class=form-control ng-model=cf.name></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Description</label><input type=text class=form-control maxlength=70 ng-model=cf.description></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>URL</label><input type=text class=form-control maxlength=70 ng-model=cf.index_url></div></div></div></div><div class=col-md-12><button ng-click=submit(cf) class=\"btn btn-default primary_btn\">Save</button></div></form></div><div class=\"col-xs-12 col-md-12 mb-30\"><div class=\"col-xs-12 col-md-6 padding0\"><div class=form-group><input type=text placeholder=\"Search Here ...\" class=form-control ng-model=query ng-change=\"query.length> 1 ? searchFeature(query):searchFeature(null)\"></div></div></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-12\" ng-repeat=\"feature in features\"><div class=\"form-group holder\"><input type=checkbox class=checkbox ng-click=\"editFeature(feature,\'publish\')\" ng-model=feature.publish> <img class=uploaded_image height=40px src={{feature.image_url}}><!-- <span>{{feature.image_url | limitTo : 20 }} {{tag.title.length > 20 ?\n                    \'...\' : \'\'}}</span> --> <span class=title>{{feature.name | limitTo : 20 }} {{tag.title.length > 20 ? \'...\' : \'\'}}</span> <span>{{feature.description | limitTo : 20 }} {{tag.title.length > 20 ? \'...\' : \'\'}}</span><div class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=\"editFeature(feature,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=\"editFeature(feature,\'del\')\" class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div></div>");
$templateCache.put("app/admin/Reasons/Reasons.html","<admin-header statename=Reasons></admin-header><div class=\"row editable-tags pb-30\"><div class=col-md-12><div class=\"col-xs-12 col-md-3\" ng-repeat=\"reason in allReasons\"><div class=\"form-group holder\"><span>{{ reason.reason }}</span><div class=\"pull-right actions\"><a ng-click=\"editReason(reason,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a></div></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Reason</h3></div><div class=\"col-xs-12 col-md-6\"><form name=myForm class=form-group><label>Reason Name</label><input type=text class=form-control ng-model=reason.reason></form></div></div></div><div class=\"col-md-12 pl-30\"><button ng-click=createReason(reason) class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/SignIn/signIn.html","<div class=admin-cont-new><h1>WELCOME TO NEARPEER ADMIN PANEL</h1><div class=admin-form><div></div><div class=popup-form><md-tabs md-dynamic-height><md-tab label=\"Sign in\"><md-content flex layout-padding><div class=form-container><form><ul class=form-list><li><md-input-container class=md-block><label>Email</label><input type=email name=email ng-model=loginForm.email required></md-input-container></li><li><md-input-container class=md-block><label>Password</label><input type=password name=password ng-model=loginForm.password required></md-input-container></li></ul></form><div style=\"text-align: left\"><input style=\"vertical-align: text-top\" type=checkbox name=checkbox> Remember Me</div><div class=buttonset><md-button class=md-raised ng-click=submitLogin(loginForm)>LOGIN</md-button></div></div><!-- //.form-container --></md-content></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/admin/PaymentType/PaymentType.html","<admin-header statename=\"Payment Type\"></admin-header><div class=\"row editable-tags pb-30\"><div class=col-md-12><div class=\"col-xs-12 col-md-3\" ng-repeat=\"paymentType in allPayTypes\"><div class=\"form-group holder\"><span>{{ paymentType.name | limitTo : 20 }} {{ paymentType.name.length > 20 ? \'...\' : \'\'}}</span><div class=\"pull-right actions\"><a ng-click=\"editPayType(paymentType,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a></div></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Payment</h3></div><div class=\"col-xs-12 col-md-6\"><form name=myForm class=form-group><label>Payment Name</label><input type=text class=form-control ng-model=paymentType.name></form></div></div></div><div class=\"col-md-12 pl-30\"><button ng-click=createPaymentType(paymentType) class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/adminAccess/adminAccess.html","<admin-header statename=\"Admin Access\"></admin-header><div><span style=\"float: right\">Search: <input ng-model=search type=text name=One style=\"height: 25px; width: 150px; margin-right: 10px\"></span><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Email</p></th><th><p class=\"pTag table_th\">Browser ID</p></th><th><p class=\"pTag table_th\">Status</p></th><th><p class=\"pTag table_th\">Date</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"access in adminAccess | filter: search \"><td><p class=pTag>{{access.user_id.full_name}}</p></td><td><p class=pTag>{{access.user_id.email}}</p></td><td><p class=pTag>{{access.device_detail ? access.device_detail.browser : \'NA\'}}</p></td><td><p class=pTag>{{access.disabled ? \'Disabled\' : \'Enabled\'}}</p></td><td><p class=pTag>{{access.createdAt | date:\'yyyy-MM-dd hh:mm a\'}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=\"revokeAccess(access, $index)\" ng-disabled=access.disabled>Revoke</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ adminAccess.length / 30 | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/archiveCourse/archiveCourse.html","<admin-header statename=\"Archive Courses\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Archive Courses :</h2></div><div class=\"col-md-12 mb-50 ng-scope\"><div class=row><div class=\"col-xs-12 col-lg-3\"><div class=form-group><label for=Institution>Select Institution</label><select class=form-control id=Institution ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div></div><div class=\"col-xs-12 col-lg-3 course-dropdown\"><div class=form-group><label for=faculty>Select Faculty</label><select class=form-control id=faculty ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-disabled=\"selected_faculty.length==0\" ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div></div><div class=\"col-xs-12 col-lg-3\"><div class=form-group><label for=courses>Select Course</label><select class=form-control id=courses ng-disabled=\"courses.length==0\" ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><div ng-show=\"selectedCourses.length > 0\"><div class=\"course-holder mb-20\"><div class=col-md-4 ng-repeat=\"course in selectedCourses\"><div class=text-holder><span>{{course.name || course.course_id.name | limitTo: 30}} {{course.name.length > 30 || course.course_id.name.length > 30 ? \'...\' : \'\'}}</span> <span class=del ng-click=deletecourse($index)><i class=\"fa fa-times\" aria-hidden=true></i></span></div></div></div><button ng-click=archiveVideos() class=\"btn btn-default primary_btn\">Archive</button></div><div class=responsive-table ng-hide=isUploading><table class=table><thead><tr><th>Name</th></tr></thead><tbody><tr ng-repeat=\"course in unArchiveCourses\"><td>{{course.name}}</td></tr></tbody></table></div><div class=loader ng-show=isUploading><img src=images/squares.gif></div></div></div>");
$templateCache.put("app/admin/blockExtension/blockExtension.html","<admin-header statename=\"Blocked Extensions\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><!-- <div class=\"form-group col-xs-6 col-md-3\">\n    <label>Search</label>\n    <input\n      type=\"text\"\n      placeholder=\"Search Link\"\n      ng-model=\"userKeySearch\"\n      class=\"form-control\"\n    />\n    <div style=\"margin-top: 10px;\">\n      <button class=\"btn btn-primary text-light\" style=\"color: white;\" ng-click=\"searchLinks()\">Search</button>\n      <button class=\"btn btn-primary text-danger\" style=\"color: white;\" ng-click=\"clearFilter()\">Reset</button>\n    </div> --></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Add Extension</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 210px\"><div class=col-md-12><div class=form-group><label>Extension Name</label><input type=text placeholder=\"Extension Name\" ng-model=ext_name class=form-control></div><div class=form-group><label>Extension ID</label><input type=text placeholder=\"Extension ID\" ng-model=ext_id class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=addUserDownloadConfig() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Extension Name</p></th><th><p class=\"pTag table_th\">Extension ID</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"extension in extensions \"><td><p class=pTag>{{extension.ext_name}}</p></td><td><p class=pTag style=\"max-width: 200px\">{{extension.ext_id}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=deleteExtension(extension)>Delete</button></td></tr></tbody></table></div>");
$templateCache.put("app/admin/assignments/assignments.html","<admin-header statename=Assignments></admin-header><div class=container-fluid><div class=\"comment-section-new row\"><div class=comment-section style=\"display: flex; flex-direction: column\"><div class=chips-div><div class=search-bar><div style=\"display: flex; flex-direction: column\"><input placeholder=\"Search Anything\" class=question-input ng-model=searchText><div style=\"display: flex;\n                justify-content: space-between;\n                margin-top: 10px\"><div class=\"flex-view flex-direction-col\" style=\"width: 140px\"><label for=dateFrom style=\"margin: 0\">From:</label><input type=date ng-model=fromDate name=dateFrom></div><div class=\"flex-view flex-direction-col\" style=\"width: 140px\"><label for=dateTo style=\"margin: 0\">To:</label><input type=date ng-model=toDate name=dateTo></div></div><!-- question text,name, number,email,course tag,answer text --></div><div style=\"display: flex;\n              flex-direction: column;\n              justify-content: space-between;\n              margin-left: 10px\"><button class=question-search ng-click=searchQuery()><img style=\"margin: 0px 5px\" src=./../../../images/QSearch.svg> <span class=admin-q-hide>Search</span></button> <button class=question-search style=\"color: #133c5c;\n                border: 1px solid #133c5c;\n                background: white\" ng-click=clearFilter()><img style=\"margin: 0px 5px\" src=\"./../../../images/delete_outline_black_24dp 1.svg\"> <span class=admin-q-hide>Clear</span></button></div></div><div class=students-filter><div class=question-filter-container><div class=ind-filter ng:class=\"{ \'ind-filter-selected\' :filterSelected.all }\" ng-click=\"changeFilter(\'all\')\">All({{totalSubmitions || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.unassigned }\" ng-click=\"changeFilter(\'unassigned\')\" style=\"margin-right: 0\">Unassigned({{countStats.submitted || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.assigned }\" ng-click=\"changeFilter(\'assigned\')\">Assigned({{countStats.assigned || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.draft }\" ng-click=\"changeFilter(\'draft\')\">Draft({{countStats.draft || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.answered }\" ng-click=\"changeFilter(\'answered\')\">Marked({{countStats.checked || 0}})</div></div></div></div><div><div class=\"row search-type-block\"><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'niche\')\" class=\"btn btn-default secondry_btn\">Niche</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'course\')\" class=\"btn btn-default secondry_btn\">Course</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'module\')\" class=\"btn btn-default secondry_btn\">Module</button></div></div><div ng-show=type class=\"row course-form-search\"><!------ col-md-6-----><div class=col-md-6 ng-show=\"type===\'niche\'\"><div class=form-group><label>Niche</label><select class=form-control id=tags ng-disabled=\"tag.length==0\" ng-model=selectedTag ng-change=addTag(selectedTag)><option ng-repeat=\"tag in tags\" value={{tag.id}}>{{tag.name}}</option></select></div></div><div class=col-md-6 ng-show=\"type===\'module\' || type===\'course\'\"><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey,type) : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=addVariants(course,type) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div ng-show=\"type===\'module\'\" class=col-md-6><div class=form-group data-text=\"Enter text here\"><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module.id}}>{{module.name}}</option></select></div></div><!------ col-md-6-----></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=showData class=\"table-responsive col-xs-12 questions-table\" style=\"padding: 20px 20px 0px 20px\"><!-- table-bordered table-striped --><div class=ledger-question><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ff000021\"></li><p>Unassigned</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ffff0045\"></li><p>Assigned & Unmarked</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #FF80FF\"></li><p>Draft</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #00800040\"></li><p>Marked</p></div></div><table class=\"table custom-question\" ng-if=!noData><thead><tr><th><div class=question-table-head><label>Status</label></div></th><th><div class=question-table-head><label>Action</label></div></th><th><div class=question-table-head><label>Submition</label></div></th><th><div class=question-table-head><label>Assignment Name</label></div></th><th><div class=question-table-head><label>Student ID</label></div></th><th><div class=question-table-head><label>Student Name</label></div></th><th><div class=question-table-head><label>Email</label></div></th><th><div class=question-table-head><label>Contact Number</label></div></th><th><div class=question-table-head><label>Paid Status</label></div></th><th><div class=question-table-head><label>Marks</label></div></th><!-- <th>\n                <div class=\"question-table-head\">\n                  <label>Time</label>\n                </div>\n              </th> --><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'submittedAt\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'submittedAt\')\"><img src=./../../../images/QDWN.svg></div></div><label>Date & Time</label></div></th></tr></thead><tbody><tr ng-repeat=\"assignment in assignmentSubmistions\" :id={{$index}} style=\"height: 80px\" ng:class=\"{ \'unassigned-color\' : assignment.status === \'submitted\' ,\'answered-color\' : assignment.status === \'checked\' ,\'unanswered-color\' : assignment.status === \'assigned\',\'draft-color\' : assignment.status === \'draft\' }\"><td><p ng-if=\"assignment.status === \'checked\' && assignment.instructor_checked\">Answered by {{assignment.instructor_checked.email}}</p><p ng-if=\"assignment.status === \'draft\'\">Answered by {{assignment.instructor_checked.email}}</p><p ng-if=assignment.instructor><!-- {{question.assigned_to != null ? \"Assigned to \" +\n                  question.assigned_to_user_full_name : \"Unanswered\" }} --> Assigned to {{assignment.instructor.email}} <img style=\"cursor: pointer\" ng-click=\"assignToInstructor(assignment,\'update\')\" src=./../../../images/admin_edit_inst.svg></p><button class=assign-admin-btn ng-click=assignToInstructor(assignment) ng-if=!assignment.instructor>Assign To Instructor</button></td><td><!-- <td>{{question.is_answered != null ? question.is_answered : \"Unanswered\" }}</td> --><!-- <p ng-if=\"question.is_answered\">\n                  {{question.is_answered != null ? \"Answered\": \"Unanswered\" }}\n                </p> --> <button class=assign-admin-btn ng-click=answerStudent(assignment) ng-if=\"assignment.status === \'checked\'\" style=\"margin: 0 auto; background-color: #0b99e9\">Edit Answer</button> <button class=assign-admin-btn ng-click=answerStudent(assignment) ng-if=\"assignment.status !== \'checked\'\" style=\"margin: 0 auto; background-color: #0b99e9\">Send Answer</button></td><td class=question-view-td><button class=question-view ng-click=downloadAssignment(assignment)>Download Assignment</button></td><td>{{assignment.assignment_campaign.name}}</td><td>{{assignment.student.id}}</td><td>{{assignment.student.full_name}}</td><td class=question-email-cell>{{assignment.student.email}}</td><td>{{assignment.student.phone}}</td><td>{{checkpaid(assignment.student)}}<div ng-click=openCoursesWindow(assignment.student.id) ng-if=\"checkpaid(assignment.student) === \'YES\'\" style=\"color: #0b99e9;\n                    text-decoration: underline;\n                    font-size: 13px\">Check Courses</div></td><td ng-if=\"assignment.obtained_marks && assignment.total_marks\">{{assignment.obtained_marks}} / {{assignment.total_marks}}</td><td ng-if=\"!assignment.obtained_marks || !assignment.total_marks\">N/A</td><td>{{assignment.submittedAt | date:\'short\'}}</td><!-- <td>{{question.created_at | date:\'mediumDate\'}}</td> --><!-- class=\"question-view-td\" --></tr></tbody></table><h3 style=\"display: flex; justify-content: center\" ng-if=noData>No Relevant Data Found!</h3></div><div ng-if=\"showData && totalPageCount > 1\" class=pagination-main><div class=inner-pagination><div class=q-left-arrow ng-show=\"currentPage != 1\" ng-click=\"pageChange(currentPage - 1)\"><img src=./../../../images/insLeft.svg></div><div class=question-pagination><p class=q-page ng-click=pageChange(pageTag) ng-repeat=\"pageTag in pageArr\" ng:class=\"{ \'q-page-selected\' : currentPage === pageTag }\" ng-show=\"pageTag <= totalPageCount\">{{pageTag}}</p><!-- <p class=\"q-page\" ng-click=\"pageChange()\">2</p> --></div><div class=q-right-arrow ng-show=\"currentPage != totalPageCount\" ng-click=\"pageChange(currentPage + 1)\"><img src=./../../../images/insRight.svg></div></div></div></div></div></div><div class=display-question-container ng-if=\"displayQuestion || displayAnswer\"><div class=display-question><img ng-click=closeQuestion() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1 ng-if=displayQuestion>Question</h1><h1 ng-if=displayAnswer>Answer</h1></div><div class=question-sec><div class=assignment-text-div><p ng-if=!containsLinks>{{selectedQuestion}}</p><div ng-if=containsLinks ng-bind-html=selectedQuestion></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && !isYoutube\"><img ng-if=\"notAvideo && !isPDF\" ng-click=previewEnlargedImage(selectedQuestionImage) style=\"cursor: pointer\" src={{selectedQuestionImage}} onloadeddata=angular.element(this).scope().imageLoadCheck() onload=angular.element(this).scope().imageLoadCheck()> <img src=images/squares.gif ng-show=imageshowloader><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup><button ng-if=\"notAvideo && !isPDF\" class=question-view ng-click=\"displayQuestion ? previewEnlargedImage(selectedQuestionImage,question) : previewEnlargedImage(selectedQuestionImage,answer) \">Preview Image</button> <a ng-if=\"notAvideo && isPDF\" class=question-view href={{selectedQuestionImage}} target=_blank>Download File</a></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><!-- <iframe width=\"420\" height=\"315\" ng-src=\"{{selectedAnswerImage}}\" allowfullscreen frameborder=\"0\">\n          </iframe> --><iframe width=420 height=315 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div></div></div></div></div><div class=display-question-container ng-click=closePreviewImage(); ng-if=imagePreview><div><img ng-click=\"closePreviewImage(); $event.stopPropagation();\" src=./../../../images/Icon-Close-black.svg style=\"position: absolute;\n        top: 14px;\n        right: 18px;\n        background: white;\n        border-radius: 11px\"> <img ng-click=$event.stopPropagation(); class=image-preview src={{previewImage}}></div></div><div class=display-question-container style=\"width: 99%\" ng-if=assignInstructor><div class=display-question style=\"height: 300px\"><img ng-click=closeInstructor() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question style=\"justify-content: center\"><div class=question-head><h1>Assign To Instructor</h1></div><div class=admin-question-dropdown><!-- <button ng-click=\"adminSearchDrop()\" class=\"admin-dropbtn\">\n          Dropdown\n        </button> --><div class=question-sec ng-click=adminSearchDrop() class=admin-dropbtn><div class=assignment-text-div><div class=custom-assign-div><img src=./../../../images/userHead.svg> <input type=text placeholder=Search.. id=myInput ng-model=findInstructor ng-keyup=filterFunctionAdmin() ng-if=!selected autocomplete=off> <input type=text placeholder=Search.. id=myInput ng-model=instText ng-keyup=filterFunctionAdmin() ng-if=selected autocomplete=off><!-- <p ng-if=\"selected\">{{instText}}</p> --></div><div id=myDropdown class=admin-dropdown-content><!-- ng-model=\"findInstructor\" --><label ng-click=selectInstructor(inst) ng-repeat=\"inst in listofInstructors\">{{inst.email ? inst.email : inst.full_name}}</label></div></div></div><div class=custom-assign-div style=\"margin: 15px 0px\"><button class=assign-admin-btn style=\"width: 150px;\n              font-size: 15px;\n              display: flex;\n              justify-content: center;\n              padding: 7px\" ng-click=assignCall()><span ng-if=toUpdateInstructor>Update</span> <span ng-if=!toUpdateInstructor>Assign</span></button></div></div></div></div></div><div class=display-question-container ng-if=showPaidCourses><div class=display-question><img ng-click=closeCoursesWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h4>Purchased Courses</h4></div><div class=question-sec style=\"align-items: center; max-height: 400px\"><img ng-if=loadingPurchasedCourses style=\"width: 80px; height: 80px; margin-top: 17px\" src=images/squares.gif><div ng-if=!loadingPurchasedCourses><p ng-repeat=\"course in purchasedCourses\">{{$index + 1}}: {{course.name}}</p></div></div></div></div></div><div class=display-question-container ng-if=answerQuestion><div class=display-question><img ng-click=closeAnswerWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1>Upload Marked Assignment</h1></div><div class=question-sec><div class=assignment-text-div><label style=\"font-size: 12px; display: flex; align-items: center\"><img style=\"width: 18px; height: 18px; margin-right: 5px\" src=./../../../images/infoQU.svg> Assignment Remarks</label><textarea style=\"max-height: 200px;\n              min-height: 50px;\n              width: 85% !important;\n              margin: 8px 10px 0px 0px;\n              border: 1px solid #eaeaea\" ng-model=result.remarks placeholder=\"Enter your Remarks\">\n          </textarea><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\"><div><label style=\"font-size: 12px; display: flex; align-items: center\">Total Marks</label><input type=number ng-model=result.total_marks placeholder=\"Total Marks\" style=\"border: 1px solid #eaeaea\"></div><div style=\"margin-left: 25px\"><label style=\"font-size: 12px; display: flex; align-items: center\">Obtained Marks</label><input type=number ng-model=result.obtained_marks placeholder=\"Obtained Marks\" style=\"border: 1px solid #eaeaea\"></div></div><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\"><div><label style=\"font-size: 12px; display: flex; align-items: center\">Notification Title</label><input type=text ng-model=result.page_title placeholder=\"Notification Title\" style=\"border: 1px solid #eaeaea\"></div><div style=\"margin-left: 25px\"><label style=\"font-size: 12px; display: flex; align-items: center\">Notification Description</label><input type=text ng-model=result.page_description placeholder=\"Notification Description\" style=\"border: 1px solid #eaeaea\"></div></div><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\"><div><div class=\"flex-view flex-direction-row-col\"><input type=checkbox ng-model=result.isSMS><spna style=\"margin-top: 4px; margin-left: 10px\">SMS</spna></div></div><div style=\"margin-left: 25px\"><div class=\"flex-view flex-direction-row-col\"><input type=checkbox ng-model=result.isEmail><spna style=\"margin-top: 4px; margin-left: 10px\">Email</spna></div></div></div><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\" ng-if=result.isEmail><div style=\"width: 40%\"><label style=\"font-size: 12px; display: flex; align-items: center\">Email Subject</label><input type=text ng-model=result.email_subject placeholder=\"Email Subject\" style=\"border: 1px solid #eaeaea; width: 100%\"></div><div style=\"width: 55%; margin-left: 20px\"><label style=\"font-size: 12px; display: flex; align-items: center\">Email Text</label><input type=text ng-model=result.email_text placeholder=\"Email Text\" style=\"border: 1px solid #eaeaea; width: 100%\"></div></div><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\" ng-if=result.isSMS><div style=\"width: 40%\"><label style=\"font-size: 12px; display: flex; align-items: center\">SMS Text</label><input type=text ng-model=result.sms_text placeholder=\"SMS Text\" style=\"border: 1px solid #eaeaea; width: 100%\"></div></div><div class=\"flex-view flex-direction-row-col\" style=\"align-items: center; margin-top: 20px; margin-bottom: 25px\"><div><input type=file id=imageUpload accept=image/* ng-model=selectedImageAnswer style=\"visibility: hidden; width: 100px\" onchange=\"angular.element(this).scope().onImageSelected(event, \'page_image\')\"><!-- position: absolute; --><label style=\"background: grey;\n                  color: white;\n                  border-radius: 5px;\n                  font-size: 13px;\n                  display: flex;\n                  width: 120px;\n                  height: 30px;\n                  justify-content: center;\n                  align-items: center\" for=imageUpload>Upload Image</label></div><div ng-if=pageImageLoading><img style=\"height: 40px; margin-top: 17px\" src=images/squares.gif></div><img ng-if=\"!pageImageLoading && result.pageImgLink\" style=\"height: 80px; margin-left: 70px\" src={{result.pageImgLink}}></div></div><div ng-if=\"selectedAnswerImage && !isYoutube\" class=question-image><a href={{selectedAnswerImage}} target=_blank style=\"display: flex; flex-direction: column; align-items: center\"><img style=\"width: 45px; height: 45px; margin-bottom: 8px\" src=./../../../images/newspaper-svgrepo-com.svg> Uploaded File</a></div><div ng-if=imageLoad class=main-instr-assign-upload-file style=\"justify-content: center;\n            align-items: center;\n            display: flex;\n            margin-top: 20px\"><div class=progress><div class=progress-bar role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: uploadProgress + \'%\'}\">{{uploadProgress}}%</div></div></div><div ng-if=!selectedAnswerImage style=\"display: flex; justify-content: center\"><div class=\"dropdown show\" style=\"border: 1px solid #eaeaea; width: 200px\"><label style=\"width: 100%; display: flex; justify-content: space-between\" ng-click=handleOptions() class=\"btn btn-secondary dropdown-toggle\" href=# role=button id=dropdownMenuLink data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{defaultDropDown}} <img style=\"margin-left: 5px\" src=./../../../images/commentarrows.svg></label><!-- class=\"dropdown-menu\" --><div style=\"display: flex;\n                flex-direction: column;\n                border: 1px solid #eaeaea;\n                padding: 6px 12px;\n                background: white;\n                position: absolute;\n                width: 200px\" ng-if=showOptions aria-labelledby=dropdownMenuLink><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Assignment Link\')\">Assignment Link</label><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Upload through System\')\">Upload through System</label></div></div></div><div class=\"flex-view flex-direction-row-col\" style=\"justify-content: space-evenly; padding: 15px; height: 70px\"><input type=file id=imageUploadd accept=application/pdf ng-model=selectedImageAnswer style=\"visibility: hidden; width: 100px\" ng-hide=linkUpload onchange=angular.element(this).scope().onImageSelected(event)><!-- position: absolute; --><label style=\"background: #d4165a;\n              color: white;\n              padding: 8px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex\" ng-if=!linkUpload for=imageUploadd>Attach PDF</label><input type=text ng-model=result.markedAssignmentLink name=markedlink placeholder=\"Add Marked Assignment Link\" ng-if=linkUpload style=\"border: 1px solid #eaeaea; margin-left: 20px\"><!-- onblur=\"angular.element(this).scope().youtubePreview(event.target.value)\" --><div ng-if=imageLoad><img style=\"height: 40px\" src=images/squares.gif></div><button class=assign-admin-btn style=\"display: flex; align-items: center\" ng-click=\"imageLoad ? \'\' : sendAnswer(answerText,videoLink)\"><!-- <span  >Uploading</span> --> <span>Send Answer</span></button></div></div></div></div></div>");
$templateCache.put("app/admin/botConfig/botConfig.html","<admin-header statename=\"Bot Config\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><!-- <div class=\"form-group col-xs-6 col-md-3\">\n    <label>Search</label>\n    <input\n      type=\"text\"\n      placeholder=\"Search Link\"\n      ng-model=\"userKeySearch\"\n      class=\"form-control\"\n    />\n    <div style=\"margin-top: 10px\">\n      <button\n        class=\"btn btn-primary text-light\"\n        style=\"color: white\"\n        ng-click=\"searchLinks()\"\n      >\n        Search\n      </button>\n      <button\n        class=\"btn btn-primary text-danger\"\n        style=\"color: white\"\n        ng-click=\"clearFilter()\"\n      >\n        Reset\n      </button>\n    </div>\n  </div> --><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=setSystemPrompt()>System Prompt</button> <button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Create Config</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\" style=\"width: 400px\"><div class=modal-content><div class=modal-body style=\"min-height: 210px\"><div class=col-md-12><div class=form-group style=\"display: flex; justify-content: space-around\"><label><input type=radio ng-model=config.type value=course> Course</label><br><label><input type=radio ng-model=config.type value=tag> Niche</label><br></div><div class=form-group ng-show=\"config.type === \'course\'\"><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div><div class=form-group ng-show=\"config.type === \'tag\'\"><label>Select Niche:</label><select ng-model=config.tag_id><option ng-repeat=\"tag in tags\" value={{tag.id}}>{{tag.name}}</option></select></div><div class=form-group><label>Enrolled Questions Count</label><input type=text placeholder=0 ng-model=config.question_count class=form-control></div><div class=form-group><label>Paid Questions Count</label><input type=text placeholder=0 ng-model=config.paid_question_count class=form-control></div><div ng-if=errorText class=form-group style=\"display: flex\"><p style=\"color: red; font-size: 12px\">{{errorText}}</p></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=saveConfig() class=\"btn btn-danger\">Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Tag Name</p></th><th><p class=\"pTag border-top-remv table_th\">Course Name</p></th><th><p class=\"pTag table_th\">Enrolled Questions Allowed</p></th><th><p class=\"pTag table_th\">Paid Questions Allowed</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"config in botConfigs \"><td><p class=pTag>{{config.tag_id.name}}</p></td><td><p class=pTag>{{config.course_id.name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{config.question_count}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{config.paid_question_count}}</p></td><td style=\"text-align: center\"><!-- <button class=\"btn btn-default\" ng-click=\"updateRedirectLink(config)\" data-toggle=\"modal\"\n              data-target=\"#myModal\">\n              Update\n            </button> --> <button class=\"btn btn-default\" ng-click=deleteBotConfig(config)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/bulkOrderUpdate/bulkOrderUpdate.html","<admin-header statename=\"Orders Update\"></admin-header><div style=\"margin: 0 30px\"><div><h3 style=\"font-weight: bold; color: #172352\">To</h3><tags-input use-strings=true placeholder=\"Add Order #\" on-tag-adding=emailcheck($tag) ng-model=orderIds></tags-input><h3 style=\"font-weight: bold; color: #172352\">Order Status</h3><select ng-model=status class=emailInput><option value=paid>Paid</option><option value=\"out dated\">Out Dated</option><option value=failed>Failed</option><option value=expired>Expired</option></select><div class=clearfix></div><button class=\"btn btn-default\" style=\"margin-bottom: 50px\" ng-click=updateOrders()>Update Orders</button></div></div>");
$templateCache.put("app/admin/bundle/bundle.html","<admin-header statename=Bundles></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=pull-left><input type=text placeholder=\"Type Here For Search\" ng-model=refNo ng-change=\"refNo.length> 3 ? searchOrder(refNo,\'refNo\'):null\" class=form-control></div><div class=pull-right><a ui-sref=AdminCreateBundle() class=\"btn btn-default primary_btn\">Create Bundle</a></div></div><div class=col-md-12><ul class=row><div><li ng-repeat=\"bunlde in bundles\" class=\"col-xs-12 col-md-3\"><div class=\"signle-course single-bundles\"><a ui-sref=\"AdminEditBundle({id: bunlde.id})\"><div class=\"category-img overlay\"><img ng-src={{bunlde.image_url}} alt=\"\"></div><div class=course-detail><div class=category-title><h4>{{bunlde.name}}</h4></div><div class=\"price-module clearfix\"><div class=\"total-courses pull-left\">Rs: <del>{{bunlde.discount_price}}</del></div><div class=\"total-courses pull-right\">Rs: {{bunlde.price}}</div></div></div></a><div class=actions><a href=# class=\"fa fa-pencil\" aria-hidden=true></a> <a href=# ng-click=deleteBundle(bunlde.id) class=\"fa fa-trash\" aria-hidden=true></a></div></div></li></div></ul></div>");
$templateCache.put("app/admin/campaignTracking/campaignTracking.html","<admin-header statename=\"Campaign Tracking\"></admin-header><div><div class=\"text-right mb-30\"><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_campaign_tracking\')\">Create New Campaign</button></div><div class=\"flex-view align-items-center justify-content-between mb-24\"><h4 class=\"font-25 font-bold\">Overall stats</h4><div class=business-request-date><div class=businnes-request-date-from for=buinessRequestDateFrom><label for=buinessRequestDateFrom>From:</label><input type=date name=buinessRequestDateFrom id=buinessRequestDateFrom ng-model=overallStatsFromDate placeholder=\"\"><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><div class=business-request-date-to for=buinessRequestDateTo><label for=buinessRequestDateFrom>To:</label><input type=date name=buinessRequestDateTo id=buinessRequestDateTo placeholder=\"\" ng-model=overallStatsToDate><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><button class=\"btn btn-default secondry_btn\" ng-click=searchByDate()>Search</button></div></div><div class=campaignWrapper><div class=story-card><b>Total leads</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.totalLeads.toLocaleString()}}</p></div><div class=story-card><b>Total Messages</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.totalMessages.toLocaleString()}}</p></div><div class=story-card><b>Users Sent Msg Multiple Times</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.multiMessageUsers.toLocaleString()}}</p></div><div class=story-card><b>Total cost</b><p class=\"mt-10 mb-0\">{{totalCost.toLocaleString()}}</p></div><div class=story-card><b>Cost per lead</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.costPerLead.toLocaleString()}}</p></div><div class=story-card><b>Leads converted</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.totalConvetedLeads.toLocaleString()}}</p></div><div class=story-card><b>Cost per conversion</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.costPerConvertedLead.toLocaleString()}}</p></div><div class=story-card><b>% conversation rate</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.conversionPercentage.toLocaleString()}}</p></div><div class=story-card><b>Avg days to convert</b><p class=\"mt-10 mb-0\">{{campaignStatsAll.avgDaysToConvert.toLocaleString()}}</p></div><div class=story-card><b>Top Cities</b><p class=\"mt-10 mb-0\" ng-repeat=\"cities in campaignStatsAll.topCities\">{{cities.city}}</p></div></div><div class=\"flex-view justify-content-between align-items-center mt-30 mb-20\"><div><input type=text name=businessRequestSearch id=businessRequestSearch ng-model=allStatsSearch class=question-input placeholder=\"Search here\"> <button class=\"btn btn-default secondry_btn\" ng-click=searchAllCampaign()>search</button> <button class=\"btn btn-default secondry_btn\" ng-click=clearFilter()>Clear</button> <button type=button class=\"btn btn-default primary_btn mb-0\" ng-click=trendCompaign()>Sort Trend Campaigns</button></div></div><!-- <div>\n    <p style=\"float: right;\"><input type=\"text\" placeholder=\"Search By Coupon Id\" ng-model=\"couponID\"> <button class=\"btn btn-primary\" ng-click=\"searchCouponById(couponID)\">Search</button></p>\n    <h4>Sort By</h4>\n    <select ng-change=\"showCoupons(1,sortType)\" ng-model=\"sortType\">\n      <option value=\"1\" selected>Default</option>\n      <option value=\"2\">Created At Ascending</option>\n      <option value=\"3\">Status Used</option>\n      <option value=\"4\">Status Available</option>\n    </select>\n  </div> --><div class=business-request-table style=height:auto><table><thead><tr><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Date</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'createdAt\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'createdAt\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Campaing ID</p></div></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Name</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'name\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'name\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Type</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'type\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'type\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><p class=\"pTag table_th\">Medium</p></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Category</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'category\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'category\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Behavior</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'behavior\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'behavior\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><div class=\"flex-view align-items-center\"><p class=\"pTag table_th\">Budget</p><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'budget\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'budget\')\"><img src=./../../../images/QDWN.svg></div></div></div></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.date}}</p></td><td><p class=pTag>{{config.id}}</p></td><td><p class=pTag title={{config.name}}><img src=../../../images/trend.png alt=# width=14 style=margin-right:6px ng-if=\"trending == false\"> {{config.name | strLimit : 40}}</p></td><td><p class=pTag>{{config.type}}</p></td><td><div class=flex-view ng-init=\"limit = 2\"><p class=pTag ng-repeat=\"medium in config.medium | limitTo: limit as results\" ng-if=\"medium.id != \'other\' \">{{medium.id}} <span ng-if=\"medium.type == \'other-medium-text\'\">(Other)</span></p></div><span ng-hide=\"results.length === config.medium.length\" ng-click=\"limit = limit +4\">more...</span></td><td><p class=pTag>{{config.category}}</p></td><td><p class=pTag>{{config.behavior}}</p></td><td><p class=pTag>{{config.budget}}</p></td><td><div class=flex-view><button class=\"btn btn-default\" style=\"margin: 5px\" ng-click=duplicateCampaign(config)>Duplicate</button> <button class=\"btn btn-default\" style=\"margin: 5px\" ng-click=downloadCsvReport(config)>CSV Report</button> <button class=\"btn btn-default\" style=\"margin: 5px\" ng-click=gotoStats(config)>Stats</button> <button class=\"btn btn-default\" style=\"margin: 5px\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" style=\"margin: 5px\" ng-click=disableConfig(config)>Delete</button></div></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages pt-20 pb-20\" style=\"text-align: center\" ng-hide=\"total_config_pages < 1\"><div class=business-request-table-pagination><div class=\"pagination-icon prev\" ng-click=\"showNext(\'previous\')\" ng-hide=\"page===1\"><img src=../../../images/b2b/pagination-icon-prev.png alt=\"\"></div><ul><li ng-repeat=\"p in pageRange\" ng-class=\"{\'active\': p===page }\" ng-click=getAllCampaigns(p)>{{p}}</li></ul><div class=\"pagination-icon next\" ng-click=\"showNext(\'next\')\" ng-hide=\"page===total_config_pages\"><img src=../../../images/b2b/pagination-icon-next.png alt=\"\"></div></div></div></div>");
$templateCache.put("app/admin/configurations/configurations.html","<admin-header statename=Configuration></admin-header><div><span style=\"float: right\">Search: <input ng-model=search type=text name=One style=\"height: 25px; width: 150px; margin-right: 10px\"></span><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Configuration Name</p></th><th><p class=\"pTag table_th\">Configuration Value</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"configuration in configurations | filter: search \"><td><p class=pTag>{{configuration.config_name}}</p></td><td><p class=pTag>{{configuration.config_value.substring(0, 90)}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editConfig(configuration)>Edit</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/configurations/editConfiguration.html","<admin-header statename=\"Edit Configuration\"></admin-header><div style=\"margin: 0 30px\"><div><h3 style=\"font-weight: bold; color: #172352\">{{configuration.config_name}}</h3><input ng-if=!promptField class=emailInput ng-model=configuration.config_value><textarea ng-if=promptField class=form-control type=text rows=8 cols=100 ng-model=configuration.config_value style=\"margin:10px 0\"></textarea><div class=clearfix></div><button class=\"btn btn-default\" style=\"margin-bottom: 50px\" ng-click=editConfig()>Update</button></div></div>");
$templateCache.put("app/admin/coupons/coupons.html","<admin-header statename=Coupons></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_coupon\')\">Create Coupon</button><div><p style=\"float: right\"><input type=text placeholder=\"Search By Coupon Id\" ng-model=couponID> <button class=\"btn btn-primary\" ng-click=searchCouponById(couponID)>Search</button></p><h4>Sort By</h4><select ng-change=showCoupons(1,sortType) ng-model=sortType><option value=1 selected>Default</option><option value=2>Created At Ascending</option><option value=3>Status Used</option><option value=4>Status Available</option></select></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Coupon Id</p></th><th><p class=\"pTag table_th\">Price</p></th><th><p class=\"pTag table_th\">Expiry Date</p></th><th><p class=\"pTag table_th\">Status</p></th><th><p class=\"pTag table_th\">Single user frequency</p></th><th><p class=\"pTag table_th\">Overall use frequency</p></th><th><p class=\"pTag table_th\">Active Orders</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"coupon in coupons\"><td><p class=pTag>{{coupon.coupon_id}}</p></td><td><p class=pTag>{{coupon.price}}</p></td><td><p class=pTag>{{coupon.expiry_date | date:\'yyyy-MM-dd\'}}</p></td><td><p ng-if=\"coupon.status ==true\" style=color:green>Available</p><p ng-if=\"coupon.status==false\" style=color:red>Used</p></td><td><p class=pTag>{{coupon.peruse}}</p></td><td><p class=pTag>{{coupon.total_frequency}}</p></td><td><p class=pTag>{{coupon.orders_count}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editCoupon(coupon)>Edit</button> <button class=\"btn btn-default\" ng-click=terminateOrder(coupon)>Terminate Orders</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total_coupon_pages | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/dashboard/dashboard.html","<admin-header statename=\"Welcome to Nearpeer Dashboard\"></admin-header><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"filter-datepicker clearfix mb-50\"><div class=\"col-sm-12 col-md-8 col-lg-8 padding0\"><div class=\"col-xs-12 col-md-6 col-lg-6 course-dropdown\"><div class=form-group><label for=course>Course</label><select class=form-control id=course><option>All</option><option>2</option><option>3</option><option>4</option></select></div></div><div class=\"col-xs-12 col-md-3 col-lg-3\"><div layout-gt-xs=row><div flex-gt-xs><label for=to>To:</label><md-datepicker ng-model=date ng-change=blogCards(1,date) md-placeholder=\"Set Date\"></md-datepicker></div></div></div><div class=\"col-xs-12 col-md-3 col-lg-3\"><div layout-gt-xs=row><div flex-gt-xs><label for=from>From:</label><md-datepicker ng-model=date ng-change=blogCards(1,date) md-placeholder=\"Set Date\"></md-datepicker></div></div></div></div></div><div class=\"col-md-12 col-lg-12 blocks-holder\"><div class=row><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Sale</div><span class=text>Rs. 5852</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Video Watched</div><span class=text>585</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Enrollments</div><span class=text>55</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Courses Sold</div><span class=text>5050</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Module Watched</div><span class=text>325</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Quizzes Solved</div><span class=text>999</span></div></div></div></div><div class=\"col-md-12 col-lg-12 blocks-holder\"><div class=row><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Sale</div><span class=text>Rs. 5852</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Video Watched</div><span class=text>585</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Enrollments</div><span class=text>55</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Courses Sold</div><span class=text>5050</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Module Watched</div><span class=text>325</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Quizzes Solved</div><span class=text>999</span></div></div></div></div><div class=\"col-md-12 col-lg-12 blocks-holder\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4\"><div class=block><div class=head>Best Selling Courses</div><span class=text>MDCAT 2018</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4\"><div class=block><div class=head>Heightest Enrollments</div><span class=text>F1 Managment Accounting</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4\"><div class=block><div class=head>Heightest Quiz Solved</div><span class=text>SAT</span></div></div></div></div></div></div>");
$templateCache.put("app/admin/courseTags/courseTags.html","<admin-header statename=\"Course Tags\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Course Tags:</h2></div><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'addCourseTag\')\">Create Tags</button></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Mobile Market</p></th><th><p class=\"pTag table_th\">Features</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"tag in courseTags\"><td><p class=pTag>{{tag.name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{tag.mobile_market ? \'Yes\' : \'No\'}}</p></td><td style=\"text-align: center\"><button ng-if=tag.mobile_market class=\"btn btn-default\" ng-click=gotoFeatures(tag)>Tag Features</button></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editTag(tag.id)>Update</button> <button class=\"btn btn-default\" ng-click=deleteTag(tag.id)>Delete</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/downloadVideosConfig/downloadVideosConfig.html","<admin-header statename=\"Users Offline Downloads Configurations\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKeySearch ng-change=\"userKeySearch.length > 3 ? getInfo(userKeySearch, \'search\') : null\" class=form-control><ul ng-if=\"usersSearch.length > 0\" class=list-group><li ng-click=addSearchVariants(user) class=list-group-item ng-repeat=\"user in usersSearch\">{{user.email || user.fb_email || usser.apple_email || user.name || user.full_name}} ({{user.provider}})</li></ul><p ng-click=clearFilter()>Clear</p></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Allow User Offline</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 315px\"><div class=col-md-12><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? getInfo(userKey) : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group style=\"z-index: 999; border-top-left-radius: 4px;\n                border-top-right-radius: 4px; border-bottom: 1px solid #ddd; max-height: 220px\"><li ng-click=addVariants(user) class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || usser.apple_email || user.name || user.full_name}} ({{user.provider}})</li></ul></div><div class=form-group><label>Max Offline Download Count</label><input type=text placeholder=Count ng-model=downloadCount class=form-control></div><div class=\"publish form-group mt-10\"><span>Delete Videos</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=deleteVideos> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"publish form-group mt-10\"><span>Disable Download</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=disableDownload> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=addUserDownloadConfig() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Email</p></th><th><p class=\"pTag table_th\">Max Download Count</p></th><th><p class=\"pTag table_th\">Delete Offline Videos</p></th><th><p class=\"pTag table_th\">Disable Downloads</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"user in usersList | filter: search \"><td><p class=pTag>{{user.user_id.full_name || user.user_id.name}}</p></td><td><p class=pTag>{{user.user_id.email ? user.user_id.email : user.user_id.fb_email}} ({{user.user_id.provider}})</p></td><td><p class=pTag>{{user.max_download_count}}</p></td><td><p class=pTag>{{user.delete_download_offline || false}}</p></td><td><p class=pTag>{{user.disable_download || false}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateUserDownloadConfig(user) data-toggle=modal data-target=#myModal>Update</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/businessRequest/businessRequest.html","<admin-header statename=\"Business request\"></admin-header><div class=business-request><div class=business-request-header><div class=business-request-search><input type=text name=businessRequestSearch id=businessRequestSearch ng-model=b2bSearchData.search placeholder=\"Search here\"></div><div class=business-request-date><div class=businnes-request-date-from for=buinessRequestDateFrom><label for=buinessRequestDateFrom>From:</label><input type=date name=buinessRequestDateFrom id=buinessRequestDateFrom ng-model=b2bSearchData.fromDate placeholder=\"\"><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><div class=business-request-date-to for=buinessRequestDateTo><label for=buinessRequestDateFrom>To:</label><input type=date name=buinessRequestDateTo id=buinessRequestDateTo placeholder=\"\" ng-model=b2bSearchData.toDate><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div></div><div><button class=\"btn btn-primary text-light\" style=\"color: white\" ng-click=getb2bData(1)>Search</button> <button class=\"btn btn-primary text-danger\" style=\"color: white\" ng-click=clear()>Reset</button></div></div><div class=business-request-table><table><thead><tr><th style=\"min-width: 110px; width: 110px\">Sr No.</th><th>Name</th><th>Phone number</th><th>Workplace Email</th><th>Company Name</th><th>Time</th><th>Date</th><th>Training Needs</th></tr></thead><tbody><tr ng-repeat=\"req in data\"><td style=\"min-width: 110px; width: 110px\"><div>{{((page-1)*pageSize) + 1 + $index}}</div></td><td><div>{{req.name}}</div></td><td><div>{{req.phone_number}}</div></td><td><div>{{req.email}}</div></td><td><div>{{req.company_name}}</div></td><td><div>{{req.time}}</div></td><td><div>{{req.date}}</div></td><td><div class=view-btn ng-click=businessRequestPopUpOpen($index)>View</div></td></tr></tbody></table></div><div class=business-request-table-pagination><div class=\"pagination-icon prev\" ng-click=getb2bData(page-1) ng-hide=\"page===1\"><img src=../../../images/b2b/pagination-icon-prev.png alt=\"\"></div><ul><li ng-repeat=\"p in pageRange\" ng-class=\"{\'active\': p===page }\" ng-click=getb2bData(p)>{{p}}</li><!-- <li>2</li>\n      <li>3</li>\n      <li>4</li>\n      <li>5</li>\n      <li>6</li>\n      <li>7</li>\n      <li>8</li>\n      <li>9</li> --></ul><div class=\"pagination-icon next\" ng-click=getb2bData(page+1) ng-hide=\"page===totalPages\"><img src=../../../images/b2b/pagination-icon-next.png alt=\"\"></div></div><div class=business-request-popup ng-if=businessRequestPopUp><div class=business-request-popup-wrapper><div class=popup-close-icon ng-click=businessRequestPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=business-request-popup-header><h3>{{selected.name}}</h3><p>{{selected.email}}</p></div><div class=business-request-popup-body><h4>Training needs</h4><p>{{selected.description}}</p></div><div class=business-request-popup-footer><!-- <div class=\"popup-close-btn\" ng-click=\"businessRequestPopUpClose()\">Back</div> --></div></div></div></div>");
$templateCache.put("app/admin/emails/SendBulkEmails.html","<admin-header statename=Emails></admin-header><div style=\"margin: 0 30px\"><div><h3 style=\"font-weight: bold; color: #172352\">To</h3><tags-input use-strings=true placeholder=\"Add email addresses\" on-tag-adding=emailcheck($tag) ng-model=toEmails></tags-input><h3 style=\"font-weight: bold; color: #172352\">Subject</h3><input class=emailInput ng-model=subject><h3 style=\"font-weight: bold; color: #172352\">From</h3><select ng-model=fromEmail class=emailInput><option value=updates@nearpeermail.org>updates@nearpeermail.org</option><option value=registrations@nearpeermail.org>registrations@nearpeermail.org</option><option value=admin@nearpeermail.org>admin@nearpeermail.org</option><!-- <option value=\"cssupdates@nearpeer.org\">cssupdates@nearpeer.org</option> --></select><h3 style=\"font-weight: bold; color: #172352\">Message</h3><div class=clearfix></div><div text-angular ng-model=content style=\"padding-bottom: 10px\"></div><div class=clearfix></div><button class=\"btn btn-default\" style=\"margin-bottom: 50px\" ng-click=sendEmails()>Send</button></div></div>");
$templateCache.put("app/admin/enrollmentGroups/enrollmentGroups.html","<admin-header statename=\"Enrollment Groups\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Enrollment Groups:</h2></div><div class=container-fluid><div class=row><div ng-repeat=\"tag in enrollmentGroups\" ng-click=editTag(tag.id) class=\"col-md-3 col-sm-4 col-xs-12 tagsSpan\"><span style=\"padding-top: 5px; padding-bottom: 5px; overflow: hidden; padding-right: 8px\">{{tag.name}}</span> <span ng-click=\"deleteTag($event, tag)\" style=\"padding: 5px\">x</span></div></div></div><div class=container-fluid><div style=\"margin: 30px 0\"><button style=\"padding: 0 20px;\n            background: #D29696;\n            border: 1px solid gray;\n			border-radius: 5px\" ng-click=\"goToState(\'addEnrollmentGroup\')\">Add Enrollment Group</button></div></div></div>");
$templateCache.put("app/admin/freeAccessConfig/freeAccess.html","<admin-header statename=\"Free Access Config\"></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_free_access\')\">Create Free Access Config</button><!-- <div>\n    <p style=\"float: right;\"><input type=\"text\" placeholder=\"Search By Coupon Id\" ng-model=\"couponID\"> <button class=\"btn btn-primary\" ng-click=\"searchCouponById(couponID)\">Search</button></p>\n    <h4>Sort By</h4>\n    <select ng-change=\"showCoupons(1,sortType)\" ng-model=\"sortType\">\n      <option value=\"1\" selected>Default</option>\n      <option value=\"2\">Created At Ascending</option>\n      <option value=\"3\">Status Used</option>\n      <option value=\"4\">Status Available</option>\n    </select>\n  </div> --><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">From Joining</p></th><th><p class=\"pTag table_th\">To Joining</p></th><th><p class=\"pTag table_th\">Status</p></th><th><p class=\"pTag table_th\">Created By</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.name}}</p></td><td><p class=pTag>{{config.from_joining | date:\'yyyy-MM-dd\'}}</p></td><td><p class=pTag>{{config.to_joining | date:\'yyyy-MM-dd\'}}</p></td><td><p ng-if=!config.disabled class=pTag style=color:green>Active</p><p ng-if=config.disabled class=pTag style=color:red>Disabled</p></td><td><p class=pTag>{{config.created_by.full_name}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" ng-click=disableConfig(config)>{{config.disabled ? \'Enable\' : \'Disable\'}}</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total_config_pages | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/formBuilder/formBuilder.html","<admin-header statename=Forms></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"><label>Search</label><input type=text placeholder=\"Search Link\" ng-model=userKeySearch class=form-control><div style=\"margin-top: 10px\"><button class=\"btn btn-primary text-light\" style=\"color: white\" ng-click=searchLinks()>Search</button> <button class=\"btn btn-primary text-danger\" style=\"color: white\" ng-click=clearFilter()>Reset</button></div></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_custom_form\')\">Create Form</button></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Description</p></th><th><p class=\"pTag table_th\">Mobile Form</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"form in forms \"><td><p class=pTag>{{form.form_name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{form.form_description}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{form.mobile_form}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateRedirectLink(form)>Update</button> <button class=\"btn btn-default\" ng-click=deleteRedirectLink(form)>Delete</button> <button class=\"btn btn-default\" ng-if=\"form.results.length > 0\" ng-click=downloadCSV(form)>Download CSV</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/fscVisits/fscVisits.html","<admin-header statename=\"Whitelist Users\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"col-xs-6 col-md-2 download-csv-block\"><label for=dateFrom>From:</label><input type=date ng-model=fromDate name=dateFrom><label for=dateTo>To:</label><input type=date id=birthday ng-model=toDate name=dateTo> <a id=download_csv ng-click=downloadOrders()>Download CSV</a></div><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>Ref No</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th></tr></thead><tbody><tr ng-repeat=\"visit in visits\"><td class=text-center>{{visit._source.websiteEvent}}</td><td class=text-center>{{visit._source.ip}}</td><td>{{visit._source.createdAt}}</td><td>{{visit._source.userContactNo}}</td></tr></tbody></table><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n        ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n        Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/iframeForm/iframeForm.html","<admin-header statename=Forms></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"><label>Search</label><input type=text placeholder=\"Search Link\" ng-model=userKeySearch class=form-control><div style=\"margin-top: 10px\"><button class=\"btn btn-primary text-light\" style=\"color: white\" ng-click=searchLinks()>Search</button> <button class=\"btn btn-primary text-danger\" style=\"color: white\" ng-click=clearFilter()>Reset</button></div></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Create Form</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\" style=\"width: 400px\"><div class=modal-content><div class=modal-body style=\"min-height: 210px\"><div class=col-md-12><div class=form-group><label>Name</label><input type=text placeholder=Name ng-model=name class=form-control></div><div class=form-group><label>Form Link</label><input type=text placeholder=http://samplelink.com ng-model=form_link class=form-control></div><div class=form-group style=\"display: flex; justify-content: space-around\"><label><input type=radio ng-model=resize value=center> Center</label><br><label><input type=radio ng-model=resize value=content_fit> Content Fit</label><br><label><input type=radio ng-model=resize value=custom> Custom</label><br></div><div ng-if=\"resize=== \'custom\'\" class=form-group style=\"display: flex; justify-content: space-around\"><div style=\"width: 40%\"><input type=number ng-model=dimension.height placeholder=Height class=form-control></div><div style=\"width: 40%\"><input type=number ng-model=dimension.width placeholder=Width class=form-control></div></div><div ng-if=errorText class=form-group style=\"display: flex\"><p style=\"color: red; font-size: 12px\">{{errorText}}</p></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=addUserDownloadConfig() class=\"btn btn-danger\">Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Redirect Link</p></th><th><p class=\"pTag table_th\">App Link</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"link in links \"><td><p class=pTag>{{link.name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{link.form_link}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=copylink(link)>Copy Link</button></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateRedirectLink(link) data-toggle=modal data-target=#myModal>Update</button> <button class=\"btn btn-default\" ng-click=deleteRedirectLink(link)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/inBuildNotificationBar/inBuildNotificationBar.html","<admin-header statename=\"Notification Bars\"></admin-header><div><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"></div><div class=text-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleClear()>Add Notification Bar</button></div><!-- Home/Landing Page Notifications Table --><div ng-if=\"landingBars.length > 0\" class=mb-50><h3 class=mb-20>Home Page Notifications</h3><div class=responsive-table ng-hide=isUploading><table class=\"table custom-table\"><thead><tr><th>Content</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"bar in landingBars\"><td>{{bar.content | stripHtml}}</td><td><button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleEdit(bar)>Edit</button> <button class=\"btn btn-danger\" ng-click=deleteNotificationBar(bar)>Delete</button></td></tr></tbody></table></div></div><!-- Niche Page Notifications Table --><div ng-if=\"nicheBars.length > 0\" class=mb-50><h3 class=mb-20>Niche Page Notifications</h3><div class=responsive-table ng-hide=isUploading><table class=\"table custom-table\"><thead><tr><th>Content</th><th>Niche</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"bar in nicheBars\"><td>{{bar.content | stripHtml}}</td><td>{{bar.niche_name}}</td><td><button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleEdit(bar)>Edit</button> <button class=\"btn btn-danger\" ng-click=deleteNotificationBar(bar)>Delete</button></td></tr></tbody></table></div></div><!-- Course Page Notifications Table --><div ng-if=\"courseBars.length > 0\" class=mb-50><h3 class=mb-20>Course Page Notifications</h3><div class=form-group><input type=text class=form-control placeholder=\"Search courses...\" ng-model=courseSearch style=\"max-width: 30%\"></div><div class=responsive-table ng-hide=isUploading><table class=\"table custom-table\"><thead><tr><th>Content</th><th>Course</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"bar in courseBars | filter:courseSearch | limitTo: itemsPerPage : (currentPageCourse - 1) * itemsPerPage\"><td>{{bar.content | stripHtml}}</td><td>{{bar.related_name}}</td><td><button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleEdit(bar)>Edit</button> <button class=\"btn btn-danger\" ng-click=deleteNotificationBar(bar)>Delete</button></td></tr></tbody></table></div><!-- Pagination for Course --><div ng-if=\"getTotalPagesCourse() > 1\" class=text-center><button class=\"btn btn-default\" ng-click=prevPageCourse() ng-disabled=\"currentPageCourse <= 1\">Previous</button> <span>Page {{currentPageCourse}} of {{getTotalPagesCourse()}}</span> <button class=\"btn btn-default\" ng-click=nextPageCourse() ng-disabled=\"currentPageCourse >= getTotalPagesCourse()\">Next</button></div></div><!-- Video Page Notifications Table --><div ng-if=\"videoBars.length > 0\" class=mb-50><h3 class=mb-20>Video Page Notifications</h3><div class=form-group><input type=text class=form-control placeholder=\"Search videos...\" ng-model=videoSearch style=\"max-width: 30%\"></div><div class=responsive-table ng-hide=isUploading><table class=\"table custom-table\"><thead><tr><th>Content</th><th>Video</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"bar in videoBars | filter:videoSearch | limitTo: itemsPerPage : (currentPageVideo - 1) * itemsPerPage\"><td>{{bar.content | stripHtml}}</td><td>{{bar.related_name}}</td><td><button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleEdit(bar)>Edit</button> <button class=\"btn btn-danger\" ng-click=deleteNotificationBar(bar)>Delete</button></td></tr></tbody></table></div><!-- Pagination for Video --><div ng-if=\"getTotalPagesVideo() > 1\" class=text-center><button class=\"btn btn-default\" ng-click=prevPageVideo() ng-disabled=\"currentPageVideo <= 1\">Previous</button> <span>Page {{currentPageVideo}} of {{getTotalPagesVideo()}}</span> <button class=\"btn btn-default\" ng-click=nextPageVideo() ng-disabled=\"currentPageVideo >= getTotalPagesVideo()\">Next</button></div></div><div class=loader ng-show=isUploading><img src=images/squares.gif></div><!-- Modal --><div class=\"modal archiveModal fade\" id=myModal role=dialog data-backdrop=static><div class=\"modal-dialog modal-lg\"><div class=modal-content><div class=modal-body style=\"min-height: 415px\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 padding0\"><!-- Page Types Radio Buttons --><div class=col-xs-12><div class=form-group><h2 class=text-center>{{type === \'edit\' ? \'Edit\' : \'Create\' }} Notification</h2><div class=row ng-hide=\"type === \'edit\'\"><div class=\"col-md-6 col-lg-3\"><div class=radio><label><input type=radio ng-model=selectedType value=landing> Landing Page</label></div></div><div class=\"col-md-6 col-lg-3\"><div class=radio><label><input type=radio ng-model=selectedType value=niche> Niche Page</label></div></div><div class=\"col-md-6 col-lg-3\"><div class=radio><label><input type=radio ng-model=selectedType value=course> Course Page</label></div></div><div class=\"col-md-6 col-lg-3\"><div class=radio><label><input type=radio ng-model=selectedType value=video> Video Page</label></div></div></div></div></div><!-- Niche selector (only for niche page) --><div ng-if=\"selectedType === \'niche\'\" ng-hide=\"type === \'edit\'\"><div class=col-xs-12><div class=form-group><label for=niche_id>Niche</label><select class=form-control id=niche_id ng-model=selectedInstitutionIndex ng-change=updateInstitution(selectedInstitutionIndex)><option value=\"\">Select Niche</option><!-- Use static nicheCategories for niche; universities for course/video --><option ng-repeat=\"institute in nicheCategories\" value={{$index}}>{{institute.name}}</option></select></div></div></div><div ng-if=\"selectedType === \'course\' || selectedType === \'video\'\" ng-hide=\"type === \'edit\'\"><div class=col-xs-12 ng-if=\"selectedType === \'course\' || selectedType === \'video\'\"><div class=form-group><label for=course_id>Course</label><ui-select ng-model=selectedCourse theme=bootstrap style=width:100% on-select=updateCourse($select.selected)><ui-select-match placeholder=\"-- Select Course --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course in courses | filter: $select.search\"><span ng-bind=course.name></span></ui-select-choices></ui-select></div></div></div><div ng-if=\"selectedType === \'video\'\"><div class=col-xs-12 ng-if=\"modules.length > 0\"><div class=form-group><label for=module_id>Module</label><ui-select ng-model=selectedModule theme=bootstrap style=width:100% on-select=updateModule($select.selected)><ui-select-match placeholder=\"-- Select Module --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"module in modules | filter: $select.search\"><span ng-bind=module.name></span></ui-select-choices></ui-select></div></div><div class=col-xs-12 ng-if=\"videos.length > 0\"><div class=form-group><label for=video_id>Video</label><ui-select ng-model=selectedVideo theme=bootstrap style=width:100% on-select=onVideoChange($select.selected)><ui-select-match placeholder=\"-- Select Video --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"video in videos | filter: $select.search\"><span ng-bind=video.name></span></ui-select-choices></ui-select></div></div></div><!-- Content Field --><div class=col-xs-12><div class=form-group><label for=content>Content</label><textarea class=form-control id=content ng-model=content placeholder=\"Enter notification content\" rows=3></textarea><!-- <div class=\"clearfix\"></div>\n											<div text-angular ng-model=\"content\" ta-toolbar=\"taToolbar\" class=\"Enter notification content\" style=\"padding-bottom: 10px;\"></div>\n										<div class=\"clearfix\"></div> --></div></div><!-- Button Text Field --><div class=col-xs-12><div class=form-group><label for=button_text>Button Text</label><input type=text class=form-control id=button_text ng-model=button_text placeholder=\"Enter button text (optional)\"></div></div><!-- Button Link Field --><div class=col-xs-12><div class=form-group><label for=button_link>Button Link</label><input type=text class=form-control id=button_link ng-model=button_link placeholder=\"Enter button link URL (optional)\"></div></div></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button class=btn data-dismiss=modal aria-label=Close>cancel</button> <button class=\"btn btn-danger\" ng-click=addNotificationBar()>Save</button></div></div></div></div><!-- delete confirmation modal --><div class=\"modal fade\" id=deleteConfirmationModal role=dialog><div class=\"modal-dialog modal-md\"><div class=modal-content><div class=\"modal-header text-center\" style=\"padding: 15px !important\"><button type=button class=close data-dismiss=modal>&times;</button><h3 class=modal-title>Are you sure you want to delete this Notification Bar?</h3></div><div class=\"modal-body text-center\"><p>This will permanently delete the notification bar.</p></div><div style=\"min-width: 300px\" class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>No</button> <button ng-click=addNotificationBar(delete) class=\"btn btn-danger\" data-dismiss=modal>Sure</button></div></div></div></div></div></div>");
$templateCache.put("app/admin/htmlPages/htmlPages.html","<admin-header statename=\"HTML Pages\"></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'addHtmlPage\')\">Create HTML Page</button><div style=\"margin: 20px 0\"><input type=text placeholder=\"Search pages...\" ng-model=search ng-change=searchPages() class=form-control style=\"width: 300px; display: inline-block\"></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">Slug</p></th><!-- <th><p class=\"pTag table_th\">Content Preview</p></th>\n            <th><p class=\"pTag table_th\">Created At</p></th> --><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"page in pages\"><td><p class=pTag>{{page.name}}</p></td><td><p class=pTag>{{page.link}}</p></td><!-- <td><p class=\"pTag\">{{page.content | limitTo: 50}}...</p></td>\n            <td><p class=\"pTag\">{{page.created_at | date:\'medium\'}}</p></td> --><td style=\"text-align: center\"><button class=btn ng-click=previewPage(page)>Preview</button> <button class=\"btn btn-default\" ng-click=editPage(page)>Edit</button> <button class=\"btn btn-danger\" ng-click=deletePage(page)>Delete</button></td></tr><tr ng-if=\"pages.length === 0\"><td colspan=5 style=\"text-align: center\"><p class=pTag>No pages found</p></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\" ng-if=\"totalPages > 1\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span></span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span></span></a></li><li class=next><p>{{currentPage}} of {{totalPages}}</p></li></ul></nav></div></div>");
$templateCache.put("app/admin/installmentOrders/createInstallment.html","<admin-header statename=\"Create New Installment\"></admin-header><div class=coure-access-form><div><!-----row-----><div class=\"row info-block mt-30\"><div ng-if=selectedUser.id class=col-md-12><h3 class=pb-20>Basic Information</h3><div class=form-group><input type=text class=form-control ng-model=selectedUser.name placeholder=\" First Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.full_name placeholder=\" Full Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.email placeholder=\"Primary Email Address\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.fb_email placeholder=\"Facebook Email Address\" readonly></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.city placeholder=City></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.phone placeholder=\"Mobile Number\"></div></div><div class=col-md-12 ng-if=\"selectedCourses.length > 0\"><h3 class=pb-20>Select Courses</h3><div class=col-md-12 ng-repeat=\"selectedCourse in selectedCourses\"><div class=\"form-group col-md-6 col-sm-6\"><p>Total Installments Paid: {{selectedCourse.totalInstallmentsCount}}</p></div><div class=\"form-group col-md-6 col-sm-6\"><p>Total Installments Amount Paid: {{selectedCourse.totalInstallmentsAmountPaid}}</p></div><div class=\"form-group col-md-3 col-sm-3\"><input type=text class=form-control ng-model=selectedCourse.name readonly></div><div class=\"form-group col-md-2 col-sm-3\"><input type=text class=form-control ng-model=selectedCourse.price readonly></div><div class=\"form-group col-md-2 col-sm-2\"><input type=number class=form-control ng-model=selectedCourse.amount placeholder=\"Amount Paid\"></div><div class=\"form-group col-md-2 col-sm-2\"><input type=number class=form-control ng-model=selectedCourse.totalInstallmentAmount placeholder=\"Total Installment Amount\" readonly></div><div class=\"form-group col-md-1 col-sm-1\" style=\"padding-top: 6px\"><a style=\"font-weight: bold; font-size: 23px\" ng-click=removeCourse($index)>X</a></div></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Session: <span>{{access.session_name}}</span></label><input type=text class=form-control placeholder=\"Search Session\" ng-model=selectedCourse.sessionKey ng-blur=selectSessionBlur(selectedCourse) ng-focus=\"searchSession(selectedCourse, selectedCourse.sessionKey)\" ng-change=\"searchSession(selectedCourse, selectedCourse.sessionKey)\"><ul ng-if=\"selectedCourse.sessions.length > 0\" class=list-group><li ng-click=\"selectSession(selectedCourse, session)\" class=list-group-item ng-repeat=\"session in selectedCourse.sessions\">{{session.name}}</li></ul></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Agent: <span>{{access.agent ? access.agent.name : \"\"}}</span></label><input type=text placeholder=\"Search Agent\" ng-focus=focusAgent() ng-blur=agentBlur() ng-model=agentKey ng-change=searchAgent(agentKey) class=form-control><ul ng-if=\"agents.length > 0 && !hideAgent\" class=list-group><li ng-click=\"selectAgent(\'none\'); agentKey = \'\'\" class=list-group-item style=\"color: lightgray\">None</li><li ng-click=selectAgent(agent) class=list-group-item ng-repeat=\"agent in agents\">{{agent.name}}</li></ul></div></div></div><div class=\"row course-form-search\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6><div class=form-group><label>Select Campaign:<p ng-repeat=\"selectedCampaign in selectedCampaigns\">{{selectedCampaign.name}}</p></label><input type=text placeholder=\"Search Campaign\" ng-focus=focuscampaign() ng-blur=campaignBlur() ng-model=campaignKey ng-change=searchCampaign(campaignKey) class=form-control><ul ng-if=\"campaigns.length > 0 && !hideCampaign\" class=list-group><li ng-click=\"selectCampaign(\'none\'); campaignKey = \'\'\" class=list-group-item style=\"color: lightgray\">None</li><li ng-click=selectCampaign(campaign) class=list-group-item ng-repeat=\"campaign in campaigns\">{{campaign.name}}</li></ul></div></div></div><!-----row-----><!-- ng-if=\"selectedCourse.paid\" --><div class=\"row payment-block info-block mt-30 mb-30\" ng-if=\"selectedCourses.length > 0\"><div class=col-md-6 ng-if=\"access.orderStatus === \'paid\' && (access.accessType === \'payment\' || access.accessType === \'time_bound\' || access.accessType === \'installment\')\"><h3 class=pb-20>Payment Information</h3><div class=\"form-group upload-file-form\"><label>{{ access.proof||\'Amount Payment Proof\'}} <span>&#x2b;</span> <input class=upload-box ng-model=image ngf-select=\"uploadImage(image,\'access\')\" type=file id=file placeholder=\"Amount Payment Proof\"></label></div><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{access.payment_id.name ||\'Payment type\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'type\')\">Payment Type</a></li><li ng-repeat=\"type in payTypes\"><a ng-click=\"accessVariants(type , \'type\')\">{{type.name}}</a></li></ul></div></div></div><div class=col-md-6 ng-if=\"access.accessType === \'trial\' || access.accessType === \'time_bound\'  || access.accessType === \'installment\'\"><h3 class=pb-20>{{access.accessType === \'trial\' ? \'Trial Access\' : \'Time Bound Access\'}}</h3><div class=form-group><p>Enter Expiry Date</p><input type=datetime-local class=form-control ng-model=access.expiryDate placeholder=\"Expiry Date\"></div><div class=form-group><p>Notification hours before expiry</p><input type=number class=form-control ng-model=access.notifyHours placeholder=\"No. of hours\"></div></div><div class=col-md-6><h3 class=pb-20>Reason for Free</h3><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{access.reason_id.reason ||\'Select Reason\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'reason\')\">Select Reason</a></li><li ng-repeat=\"reason in reasons\"><a ng-click=\"accessVariants(reason , \'reason\')\">{{reason.reason}}</a></li></ul></div></div><div class=form-group><textarea type=text ng-model=access.comments class=\"reason-comment-block form-control\" placeholder=\"Write your comments...\"></textarea></div></div><div class=\"row course-form-search\"><div class=col-md-6><div class=\"publish form-group mt-10\"><input type=checkbox ng-click=toggleNotifyByWhatsapp() ng-model=notifyByWhatsapp> Notify On WhatsApp</div></div></div><div class=col-md-12><button type=button ng-disabled=disabled ng-click=createAccess(selectedUser,selectedCourses,access) class=\"btn btn-default primary_btn payment-block-btn\">Submit</button></div></div><!-----row-----></div></div>");
$templateCache.put("app/admin/installmentOrders/installmentOrders.html","<admin-header statename=\"Installment Orders\"></admin-header><div class=order-management><div class=\"row pb-30 order-mgt-block\"><div class=\"col-md-12 mt-10 page-num-block\"><div class=\"col-xs-6 col-md-3\"><input ng-disabled=\"searchParams.type===\'all\'\" type=text placeholder=Search ng-model=searchParams.key ng-change=\"searchParams.key.length > 0 ? searchOrder(searchParams.key, searchParams.type,false,true) : null\" class=form-control> <span>By:</span><ul ng-if=\"searchData.length > 0\" class=list-group><!-- ng-click=\"addVariants(user,\'user\')\" --><li ng-click=\"searchOrder(row.email || row.fb_email || row.name || row.full_name,searchParams.type,true,true, row)\" class=list-group-item ng-repeat=\"row in searchData\">{{row.email || row.fb_email || row.name || row.full_name }} {{row.provider ? \'(\' + row.provider + \')\' : \'\'}}</li></ul></div><div class=\"col-xs-6 col-md-2 btn-group\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{ searchParams.type ||\'SearchType\'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=\"search-type dropdown-menu\"><li ng-repeat=\"type in searchType\"><a ng-click=changeType(type)>{{type}}</a></li></ul></div><!-- <div class=\" col-xs-6 col-md-1  padding0 page-num-option\">\n        <select ng-model=\"searchParams.per_page\" class=\"form-control\"\n          ng-change=\"searchOrder(searchParams.key, searchParams.type, true,true)\" aria-invalid=\"false\">\n          <option ng-repeat=\"pageNum in pageRow\">{{pageNum}}</option>\n        </select>\n      </div> --><!-- <div class=\" col-xs-6 col-md-2 download-csv-block\">\n        <label for=\"dateFrom\">From:</label>\n        <input type=\"date\" ng-model = \"fromDate\" name=\"dateFrom\">\n        <label for=\"dateTo\">To:</label>\n        <input type=\"date\" id=\"birthday\" ng-model = \"toDate\" name=\"dateTo\">\n        <a id=\"download_csv\" ng-click=\"downloadOrders()\">Download\n          CSV</a>\n      </div> --><div class=\"col-xs-12 col-md-4 ng-binding no-of-pages\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span class=order-page-detail>{{searchParams.page}} in {{totalPages}} ,{{(searchParams.page*searchParams.per_page)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}} Out of {{totalCount}}</span></div></div><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>Action</th><th class=text-center>Ref No</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th><th class=text-center>Module</th><th class=text-center>Price</th><th class=text-center>Total Installment Amount</th><th class=text-center>Discount</th><th class=text-center>Revenue</th><th class=text-center>Balance</th><th class=text-center>Coup Bal</th><th class=text-center>Coup ID</th><th class=text-center>User ID</th><th class=text-center>User</th><th class=text-center>Phone</th><th class=text-center>Primary Email</th><th class=text-center>Facebook Email</th><th class=text-center>Provider</th><th class=text-center>CRN</th><th class=text-center>City</th><th class=text-center>Date</th><th class=text-center>Reason for Free</th><th class=text-center>Payment Proof</th><th class=text-center>Payment Type</th><th class=text-center>Comments</th><th class=text-center>Status</th><th class=text-center>Session</th><th class=text-center>Admin Name</th><th class=text-center>Agent Name</th><th class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td ng-if=\"rowSpanCondition(order, $index)\" rowspan=\"{{rowSpan(orders, $index)}}\" style=\"vertical-align: middle\"><button class=\"btn btn-primary table-btn\" ng-click=createInstallment(order) style=\"color: white\">Create Installment</button></td><!-- <td class=\"text-center\">{{($index+1)+((searchParams.page*searchParams.per_page)-searchParams.per_page)}} --><td class=text-center>{{order.ref_no}}</td><td>{{order.type}}</td><td>{{order.bundle}}</td><td>{{order.course}}</td><td>{{order.module}}</td><td>{{order.price}}</td><td>{{order.total_installment_amount}}</td><td>{{order.discount}}</td><td>{{order.revenue}}</td><td>{{order.user_balance}}</td><td>{{order.coupon_balance}}</td><td>{{order.couponId}}</td><td>{{order.user_id}}</td><td>{{order.user_name}}</td><td>{{order.phone}}</td><td>{{order.provider !== \'facebook\' ? order.user_email : \'\'}}</td><td>{{order.provider === \'facebook\' ? order.fb_email || order.user_email : \'\'}}</td><td>{{order.provider}}</td><td>{{order.crn}}</td><td>{{order.city}}</td><td>{{order.time | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</td><td>{{order.reason}}</td><td>{{order.proof}}</td><td>{{order.payType}}</td><td title={{order.comments}}>{{order.comments | limitTo : 20}} {{order.comments.length > 20 ? \'...\' : \'\'}}</td><td>{{order.status}}</td><td>{{order.session ? order.session.name : \'\'}}</td><td>{{order.admin_name}}</td><td>{{order.agent_name}}</td><!-- <td>{{order.reason_disabled}}</td>\n            <td>{{order.disable_by_name}}</td> --><td><button class=\"btn btn-primary table-btn\" ng-click=viewInstallments(order.id)>View Installments</button></td></tr></tbody></table></div></div><div class=order-disable-popup-container ng-if=showReasonPopup><div class=order-disable-popup><img ng-click=closeCoursesWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-reason><div class=reason-head><h4>Select Reason</h4></div><div class=reason-sec style=\"max-height: 400px\"><div><label><input type=radio ng-model=selectedReason value=Refunded> Refunded</label><br><label><input type=radio ng-model=selectedReason value=Piracy> Piracy</label><br><label><input type=radio ng-model=selectedReason value=\"Installment Case\"> Installment Case</label><br><label><input type=radio ng-model=selectedReason value=\"Account shifting\"> Account shifting</label><br><label><input type=radio ng-model=selectedReason value=Freezed> Freezed</label><br><label><input type=radio ng-model=selectedReason value=other> Other</label><br><labe ng-if=\"selectedReason === \'other\'\"><textarea class=form-control type=text rows=5 cols=100 ng-model=otherReason id=otherReason placeholder=\"Add Reason\"></textarea><br></labe></div><div style=\"text-align: center\"><button class=\"btn btn-primary table-btn\" ng-click=\"terminateOrder(selectedDisableOrder.id, selectedReason, otherReason)\">Disable Order</button></div></div></div></div></div></div>");
$templateCache.put("app/admin/installmentOrders/installmentOrdersDetail.html","<admin-header statename=\"Installment Order Detail\"></admin-header><div class=order-management><div class=\"row pb-30 order-mgt-block\"><!-- <div class=\"text-right mb-30\">\n      <button type=\"button\" class=\"btn btn-default primary_btn\" ng-click=\"createInstallment()\">Create New Insatllment</button>\n    </div> --><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>#</th><th class=text-center>Ref No</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th><th class=text-center>Module</th><th class=text-center>Price</th><th class=text-center>Total Installment Amount</th><th class=text-center>Discount</th><th class=text-center>Revenue</th><th class=text-center>Balance</th><th class=text-center>Coup Bal</th><th class=text-center>Coup ID</th><th class=text-center>User ID</th><th class=text-center>User</th><th class=text-center>Phone</th><th class=text-center>Primary Email</th><th class=text-center>Facebook Email</th><th class=text-center>Provider</th><th class=text-center>CRN</th><th class=text-center>City</th><th class=text-center>Date</th><th class=text-center>Reason for Free</th><th class=text-center>Payment Proof</th><th class=text-center>Payment Type</th><th class=text-center>Comments</th><th class=text-center>Status</th><th class=text-center>Session</th><th class=text-center>Admin Name</th><th class=text-center>Agent Name</th></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td class=text-center>{{($index+1)+((searchParams.page*searchParams.per_page)-searchParams.per_page)}}</td><td class=text-center>{{order.ref_no}}</td><td>{{order.type}}</td><td>{{order.bundle}}</td><td>{{order.course}}</td><td>{{order.module}}</td><td>{{order.price}}</td><td>{{order.total_installment_amount}}</td><td>{{order.discount}}</td><td>{{order.revenue}}</td><td>{{order.user_balance}}</td><td>{{order.coupon_balance}}</td><td>{{order.couponId}}</td><td>{{order.user_id}}</td><td>{{order.user_name}}</td><td>{{order.phone}}</td><td>{{order.provider !== \'facebook\' ? order.user_email : \'\'}}</td><td>{{order.provider === \'facebook\' ? order.fb_email || order.user_email : \'\'}}</td><td>{{order.provider}}</td><td>{{order.crn}}</td><td>{{order.city}}</td><td>{{order.time | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</td><td>{{order.reason}}</td><td>{{order.proof}}</td><td>{{order.payType}}</td><td title={{order.comments}}>{{order.comments | limitTo : 20}} {{order.comments.length > 20 ? \'...\' : \'\'}}</td><td>{{order.status}}</td><td>{{order.session ? order.session.name : \'\'}}</td><td>{{order.admin_name}}</td><td>{{order.agent_name}}</td></tr></tbody></table></div></div><div class=order-disable-popup-container ng-if=showReasonPopup><div class=order-disable-popup><img ng-click=closeCoursesWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-reason><div class=reason-head><h4>Select Reason</h4></div><div class=reason-sec style=\"max-height: 400px\"><div><label><input type=radio ng-model=selectedReason value=Refunded> Refunded</label><br><label><input type=radio ng-model=selectedReason value=Piracy> Piracy</label><br><label><input type=radio ng-model=selectedReason value=\"Installment Case\"> Installment Case</label><br><label><input type=radio ng-model=selectedReason value=\"Account shifting\"> Account shifting</label><br><label><input type=radio ng-model=selectedReason value=Freezed> Freezed</label><br><label><input type=radio ng-model=selectedReason value=other> Other</label><br><labe ng-if=\"selectedReason === \'other\'\"><textarea class=form-control type=text rows=5 cols=100 ng-model=otherReason id=otherReason placeholder=\"Add Reason\"></textarea><br></labe></div><div style=\"text-align: center\"><button class=\"btn btn-primary table-btn\" ng-click=\"terminateOrder(selectedDisableOrder.id, selectedReason, otherReason)\">Disable Order</button></div></div></div></div></div></div>");
$templateCache.put("app/admin/instructor/instructor.html","<admin-header statename=\"Admin Instructors\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Admin Instructors:</h2></div><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'AdminAddInstructor\')\">Create Instructor</button></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Exp</p></th><th><p class=\"pTag table_th\">Image</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"tag in courseTags\"><td><p class=pTag>{{tag.name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{tag.experience}} years</p></td><td style=\"text-align: center\"><img ng-src=\"{{ tag.image || \'images/placeholder.png\' }}\" alt=image style=\"width: 50px; height: 50px; border-radius: 50%; margin-left: 3px\"></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editTag(tag.id)>Update</button> <button class=\"btn btn-default\" ng-click=deleteTag(tag.id)>Delete</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/mergeAccounts/mergeAccounts.html","<admin-header statename=\"Welcome to Nearpeer Reporting\"></admin-header><div><div class=\"row course-form-search\"><div class=col-md-6><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? searchInfo(userKey,\'user\') : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=\"selectUser(user,\'user\')\" class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.apple_email || user.name || user.full_name}} ({{user.provider}})</li></ul></div></div></div><div><h5>Accounts</h5><div ng-repeat=\"account in userAccounts\" class=merge-accounts-list><span class=merge-accounts-list-item>{{account.email || account.fb_email || account.apple_email}}</span> <span class=merge-accounts-list-item>{{account.purchasedCoursesCount}}</span> <span class=merge-accounts-list-item>{{account.provider}}</span> <button ng-click=mergeAccount(account) class=\"btn btn-primary merge-accounts-list-item\" ng-if=!account.is_migrated>Merge All</button> <span class=merge-accounts-list-item ng-if=account.is_migrated>Merged</span></div></div></div>");
$templateCache.put("app/admin/mobilePopupConfig/mobilePopupConfig.html","<admin-header statename=\"Mobile Browser Config\"></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_mobile_popup_config\')\">Create Mobile Browser Config</button><!-- <div>\n    <p style=\"float: right;\"><input type=\"text\" placeholder=\"Search By Coupon Id\" ng-model=\"couponID\"> <button class=\"btn btn-primary\" ng-click=\"searchCouponById(couponID)\">Search</button></p>\n    <h4>Sort By</h4>\n    <select ng-change=\"showCoupons(1,sortType)\" ng-model=\"sortType\">\n      <option value=\"1\" selected>Default</option>\n      <option value=\"2\">Created At Ascending</option>\n      <option value=\"3\">Status Used</option>\n      <option value=\"4\">Status Available</option>\n    </select>\n  </div> --><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">Paid Only</p></th><th><p class=\"pTag table_th\">Created By</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.name}}</p></td><td><p class=pTag>{{config.paid_only | date:\'yyyy-MM-dd\'}}</p></td><td><p class=pTag>{{config.created_by.full_name}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" ng-click=disableConfig(config)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total_config_pages | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/mobileServing/mobileServing.html","<admin-header statename=\"Whitelist Users For Mobile Serving\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Allow Mobile for User</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 220px\"><div class=col-md-12><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? getInfo(userKey) : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=selectUser(user) class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.name || user.full_name}}</li></ul><input type=text placeholder=\"Search Courser\" ng-model=courserKey ng-change=\"courserKey.length > 3 ? getCourseInfo(courserKey) : null\" class=form-control><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=selectCourse(course) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul><div style=\"margin-top: 10px\"><p>Selected User: {{selectedUser.email || selectedUser.fb_email || selectedUser.name || selectedUser.full_name}}</p><p>Selected Course: {{selectedCourse.name}}</p></div></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=allowUser() class=\"btn btn-danger\" data-dismiss=modal>Whitelist</button></div></div></div></div><!--- hallo ---><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div ng-if=\"usersList.length && usersList.length > 0\" class=\"col-xs-12 col-md-12\" ng-repeat=\"user in usersList\"><div class=\"form-group holder\"><div ng-if=\"currentUser.id != user.id\" class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=deleteUser(user.id) class=\"glyphicon glyphicon-trash\"></a></div></div><span style=\"cursor: pointer\" class=single-bundles>{{user.email || user.fb_email || user.apple_email || user.name || user.full_name}} ({{user.course_name}})</span></div></div></div></div></div>");
$templateCache.put("app/admin/newComingEmails/newComingEmails.html","<admin-header statename=\"New Coming Emails\"></admin-header><div class=\"f-c d-col\"><div style=\"margin: 10px 0\"><label for=dateFrom>From:</label><input type=date ng-model=fromDate name=dateFrom><label for=dateTo>To:</label><input type=date id=birthday ng-model=toDate name=dateTo> <a id=download_csv style=\"margin: 0 10px\" ng-click=downloadCSV()>Download CSV</a></div><nav class=\"f-c d-row alic\"><ul class=pagination ng-hide=\"searchParams.per_page >= count\"><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul><span style=\"margin: 0 10px\" class=order-page-detail>{{(count > 0)?searchParams.page: 0}} in {{(count > 0)?totalPages:0}} ,{{(count>0)?((searchParams.page*searchParams.per_page)-searchParams.per_page)+1:0}}-{{((searchParams.per_page*searchParams.page)>count)?count:searchParams.per_page*searchParams.page}} Out of {{count}}</span></nav><div class=\"f-c d-row jcsa tableRow\"><div class=tableCell><b>Email</b></div><div class=tableCell><b>Page Name</b></div><div class=tableCell><b>Shared Link</b></div><div class=tableCell><b>Date</b></div></div><div ng-if=\"usersList.length && usersList.length > 0\" ng-repeat=\"user in usersList\" class=\"f-c d-row jcsa tableRow\"><div class=tableCell><span class=single-bundles>{{user.email}}</span></div><div class=tableCell><span class=single-bundles>{{user.page_name}}</span></div><div class=tableCell><span class=single-bundles>{{user.shared_notes}}</span></div><div class=tableCell><span class=single-bundles>{{user.createdAt | date:\'yyyy-MM-dd\'}}</span></div></div></div><style>.tableCell {\n    width: 200px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 10px;\n    padding: 5px;\n  }\n  .tableRow {\n    border-bottom: 1px solid #00000038;\n  }\n  .jcse {\n    justify-content: flex-end;\n  }</style>");
$templateCache.put("app/admin/nicheDiscount/nicheDiscount.html","<admin-header statename=\"Niche Discounts\"></admin-header><div><!-- <div style=\"padding: 30px 0; color: #04044D;\">\n		<h2>Welcome to Course Tags:</h2>\n	</div> --><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleClear()>Add Discount in Niche</button></div><div class=responsive-table ng-hide=isUploading><table class=\"table custom-table\"><thead><tr><th>Institution</th><th>Faculty</th><th>Discount Percentage %</th><th>Discount From</th><th>Discount To</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"niche in nichesWithDiscount\"><td>{{niche.institution}}</td><td>{{niche.faculty || \'Empty\'}}</td><td>{{niche.discount_percentage}}%</td><td>{{niche.discount_from | date:\'yyyy-MM-dd\'}}</td><td>{{niche.discount_to | date:\'yyyy-MM-dd\'}}</td><td><button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal ng-click=handleEdit(niche)>Edit</button> <button class=\"btn btn-danger\" data-toggle=modal data-target=#deleteConfirmationModal ng-click=deleteNiche(niche) ng-if=\"niche.discount_percentage > 0\">Remove Discount</button></td></tr></tbody></table></div><div class=loader ng-show=isUploading><img src=images/squares.gif></div><!-- Modal --><div class=\"modal archiveModal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 415px\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 padding0\"><!-- Select Institution --><div class=col-xs-12><div class=form-group><label for=Institution>Select Institution</label><select class=form-control id=Institution ng-model=institution ng-disabled=\"type === \'edit\'\" ng-change=updateInstitution(institution)><option ng-repeat=\"institute in institutions\" value={{institute.institution}}>{{institute.institution}}</option></select></div></div><!-- Select Faculty --><div class=\"col-xs-12 course-dropdown\"><div class=form-group><label for=faculty>Select Faculty</label><select class=form-control id=faculty ng-model=selectedSchool ng-disabled=\"type === \'edit\'\" ng-change=updateSchool(selectedSchool)><option ng-repeat=\"faculty in selected_faculty\" ng-selected=\"faculty.faculty === selectedSchool\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div></div><!-- Discount Percentage Field --><div class=col-xs-12><div class=form-group><label for=discountPercentage>Discount Percentage</label><input type=number class=form-control id=discountPercentage ng-model=discount_percentage placeholder=\"Enter Discount Percentage\"></div></div><!-- Discount From Field --><div class=col-xs-12><div class=form-group><label for=discountFrom>Discount From</label><input type=date class=form-control id=discountFrom ng-model=discount_from></div></div><!-- Discount To Field --><div class=col-xs-12><div class=form-group><label for=discountTo>Discount To</label><input type=date class=form-control id=discountTo ng-model=discount_to></div></div></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button class=\"btn btn-danger\" data-dismiss=modal data-target=#archiveConfirmationModal data-toggle=modal>Save</button></div></div></div></div><!-- Archive confirmation Modal --><div class=\"modal fade\" id=archiveConfirmationModal role=dialog><div class=\"modal-dialog modal-md\"><div class=modal-content><div class=\"modal-header text-center\" style=\"padding: 15px !important\"><button type=button class=close data-dismiss=modal>&times;</button><h3 class=modal-title>Are you sure you want to add this Discount?</h3></div><div class=\"modal-body text-center\"><p>Once Discount Added on Niche it will Added on all the courses of Niche</p></div><div style=\"min-width: 300px\" class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>No</button> <button ng-click=addDiscount() class=\"btn btn-danger\" data-dismiss=modal>Sure</button></div></div></div></div><!-- delete confirmation modal --><div class=\"modal fade\" id=deleteConfirmationModal role=dialog><div class=\"modal-dialog modal-md\"><div class=modal-content><div class=\"modal-header text-center\" style=\"padding: 15px !important\"><button type=button class=close data-dismiss=modal>&times;</button><h3 class=modal-title>Are you sure you want to remove this Discount?</h3></div><div class=\"modal-body text-center\"><p>Once Discount removed on Niche it will removed from all the courses inside Niche</p></div><div style=\"min-width: 300px\" class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>No</button> <button ng-click=addDiscount() class=\"btn btn-danger\" data-dismiss=modal>Sure</button></div></div></div></div></div></div>");
$templateCache.put("app/admin/npSharePercentage/npSharePercentage.html","<admin-header statename=\"NP Share Percentage\"></admin-header><div><span style=\"float: right\"><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'ADD_NP_SHARE\')\">Add or Update NP Share</button></span><div class=responsive-table><table class=table><colgroup><col class=col-xs-8><col class=col-xs-4></colgroup><thead><tr><th><p class=\"pTag table_th\" style=\"text-align: left\">Course Name</p></th><th><p class=\"pTag table_th\" style=\"text-align: center\">NP Share %</p></th><!-- <th><p class=\"pTag table_th\">Action</p></th> --></tr></thead><tbody><tr ng-repeat=\"course in courses\"><td><p class=pTag style=\"text-align: left\">{{course.name}}</p></td><td style=\"text-align: center\">{{course.np_share_percentage}}</td><!-- <td style=\"text-align: center\">\n                <button class=\"btn btn-default\" ng-click=\"goToState(\'ADD_NP_SHARE\', {course_id: course.id})\">Update Share</button>\n            </td> --></tr></tbody></table></div></div>");
$templateCache.put("app/admin/orderManagement/createOrder.html","<admin-header statename=\"Create Order\"></admin-header><!-- <admin-header statename=\"Edit Course Access\"></admin-header> --><div class=coure-access-form id=createOrder><div class=\"row course-form-search\"><div class=col-md-6><h4 style=\"color: #0077A6\">User\'s Information</h4><div class=\"form-group flex-view flex-direction-col\"><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Email or Phone Number</label><input class=common-input type=text placeholder=\"Email or Phone Number\" ng-model=userOrder.email class=form-control></div><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Name</label><input class=common-input type=text placeholder=\"Enter Name for User\" ng-model=userOrder.name class=form-control></div><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>City</label><!-- <input class=\"common-input\" type=\"text\" placeholder=\"City of User\" ng-model=\"userOrder.city\"\n                        class=\"form-control\" /> --><select class=common-input name=Location id=Location required ng-model=userOrder.city><option value=\"\" disabled selected>Select The City</option><option value=Islamabad>Islamabad</option><option value=\"\" disabled>Punjab Cities</option><option value=\"Ahmed Nager Chatha\">Ahmed Nager Chatha</option><option value=\"Ahmadpur East\">Ahmadpur East</option><option value=\"Ali Khan Abad\">Ali Khan Abad</option><option value=Alipur>Alipur</option><option value=Arifwala>Arifwala</option><option value=Attock>Attock</option><option value=Bhera>Bhera</option><option value=Bhalwal>Bhalwal</option><option value=Bahawalnagar>Bahawalnagar</option><option value=Bahawalpur>Bahawalpur</option><option value=Bhakkar>Bhakkar</option><option value=Burewala>Burewala</option><option value=Chillianwala>Chillianwala</option><option value=Chakwal>Chakwal</option><option value=Chichawatni>Chichawatni</option><option value=Chiniot>Chiniot</option><option value=Chishtian>Chishtian</option><option value=Daska>Daska</option><option value=\"Darya Khan\">Darya Khan</option><option value=\"Dera Ghazi Khan\">Dera Ghazi Khan</option><option value=Dhaular>Dhaular</option><option value=Dina>Dina</option><option value=Dinga>Dinga</option><option value=Dipalpur>Dipalpur</option><option value=Faisalabad>Faisalabad</option><option value=Ferozewala>Ferozewala</option><option value=\"Fateh Jhang\">Fateh Jang</option><option value=\"Ghakhar Mandi\">Ghakhar Mandi</option><option value=Gojra>Gojra</option><option value=Gujranwala>Gujranwala</option><option value=Gujrat>Gujrat</option><option value=\"Gujar Khan\">Gujar Khan</option><option value=Hafizabad>Hafizabad</option><option value=Haroonabad>Haroonabad</option><option value=Hasilpur>Hasilpur</option><option value=\"Haveli Lakha\">Haveli Lakha</option><option value=Jatoi>Jatoi</option><option value=Jalalpur>Jalalpur</option><option value=Jattan>Jattan</option><option value=Jampur>Jampur</option><option value=Jaranwala>Jaranwala</option><option value=Jhang>Jhang</option><option value=Jhelum>Jhelum</option><option value=Kalabagh>Kalabagh</option><option value=\"Karor Lal Esan\">Karor Lal Esan</option><option value=Kasur>Kasur</option><option value=Kamalia>Kamalia</option><option value=Kamoke>Kamoke</option><option value=Khanewal>Khanewal</option><option value=Khanpur>Khanpur</option><option value=Kharian>Kharian</option><option value=Khushab>Khushab</option><option value=\"Kot Addu\">Kot Addu</option><option value=Jauharabad>Jauharabad</option><option value=Lahore>Lahore</option><option value=Lalamusa>Lalamusa</option><option value=Layyah>Layyah</option><option value=\"Liaquat Pur\">Liaquat Pur</option><option value=Lodhran>Lodhran</option><option value=Malakwal>Malakwal</option><option value=Mamoori>Mamoori</option><option value=Mailsi>Mailsi</option><option value=\"Mandi Bahauddin\">Mandi Bahauddin</option><option value=\"Mian Channu\">Mian Channu</option><option value=Mianwali>Mianwali</option><option value=Multan>Multan</option><option value=Murree>Murree</option><option value=Muridke>Muridke</option><option value=\"Mianwali Bangla\">Mianwali Bangla</option><option value=Muzaffargarh>Muzaffargarh</option><option value=Narowal>Narowal</option><option value=\"Nankana Sahib\">Nankana Sahib</option><option value=Okara>Okara</option><option value=\"Renala Khurd\">Renala Khurd</option><option value=Pakpattan>Pakpattan</option><option value=Pattoki>Pattoki</option><option value=\"Pir Mahal\">Pir Mahal</option><option value=Qaimpur>Qaimpur</option><option value=\"Qila Didar Singh\">Qila Didar Singh</option><option value=Rabwah>Rabwah</option><option value=Raiwind>Raiwind</option><option value=Rajanpur>Rajanpur</option><option value=\"Rahim Yar Khan\">Rahim Yar Khan</option><option value=Rawalpindi>Rawalpindi</option><option value=Sadiqabad>Sadiqabad</option><option value=Safdarabad>Safdarabad</option><option value=Sahiwal>Sahiwal</option><option value=\"Sangla Hill\">Sangla Hill</option><option value=\"Sarai Alamgir\">Sarai Alamgir</option><option value=Sargodha>Sargodha</option><option value=Shakargarh>Shakargarh</option><option value=Sheikhupura>Sheikhupura</option><option value=Sialkot>Sialkot</option><option value=Sohawa>Sohawa</option><option value=Soianwala>Soianwala</option><option value=Siranwali>Siranwali</option><option value=Talagang>Talagang</option><option value=Taxila>Taxila</option><option value=\"Toba Tek Singh\">Toba Tek Singh</option><option value=Vehari>Vehari</option><option value=\"Wah Cantonment\">Wah Cantonment</option><option value=Wazirabad>Wazirabad</option><option value=\"\" disabled>Sindh Cities</option><option value=Badin>Badin</option><option value=Bhirkan>Bhirkan</option><option value=\"Rajo Khanani\">Rajo Khanani</option><option value=Chak>Chak</option><option value=Dadu>Dadu</option><option value=Digri>Digri</option><option value=Diplo>Diplo</option><option value=Dokri>Dokri</option><option value=Ghotki>Ghotki</option><option value=Haala>Haala</option><option value=Hyderabad>Hyderabad</option><option value=Islamkot>Islamkot</option><option value=Jacobabad>Jacobabad</option><option value=Jamshoro>Jamshoro</option><option value=Jungshahi>Jungshahi</option><option value=Kandhkot>Kandhkot</option><option value=Kandiaro>Kandiaro</option><option value=Karachi>Karachi</option><option value=Kashmore>Kashmore</option><option value=\"Keti Bandar\">Keti Bandar</option><option value=Khairpur>Khairpur</option><option value=Kotri>Kotri</option><option value=Larkana>Larkana</option><option value=Matiari>Matiari</option><option value=Mehar>Mehar</option><option value=\"Mirpur Khas\">Mirpur Khas</option><option value=Mithani>Mithani</option><option value=Mithi>Mithi</option><option value=Mehrabpur>Mehrabpur</option><option value=Moro>Moro</option><option value=Nagarparkar>Nagarparkar</option><option value=Naudero>Naudero</option><option value=\"Naushahro Feroze\">Naushahro Feroze</option><option value=Naushara>Naushara</option><option value=Nawabshah>Nawabshah</option><option value=Nazimabad>Nazimabad</option><option value=Qambar>Qambar</option><option value=Qasimabad>Qasimabad</option><option value=Ranipur>Ranipur</option><option value=Ratodero>Ratodero</option><option value=Rohri>Rohri</option><option value=Sakrand>Sakrand</option><option value=Sanghar>Sanghar</option><option value=Shahbandar>Shahbandar</option><option value=Shahdadkot>Shahdadkot</option><option value=Shahdadpur>Shahdadpur</option><option value=\"Shahpur Chakar\">Shahpur Chakar</option><option value=Shikarpaur>Shikarpaur</option><option value=Sukkur>Sukkur</option><option value=Tangwani>Tangwani</option><option value=\"Tando Adam Khan\">Tando Adam Khan</option><option value=\"Tando Allahyar\">Tando Allahyar</option><option value=\"Tando Muhammad Khan\">Tando Muhammad Khan</option><option value=Thatta>Thatta</option><option value=Umerkot>Umerkot</option><option value=Warah>Warah</option><option value=\"\" disabled>Khyber Cities</option><option value=Abbottabad>Abbottabad</option><option value=Adezai>Adezai</option><option value=Alpuri>Alpuri</option><option value=\"Akora Khattak\">Akora Khattak</option><option value=Ayubia>Ayubia</option><option value=\"Banda Daud Shah\">Banda Daud Shah</option><option value=Bannu>Bannu</option><option value=Batkhela>Batkhela</option><option value=Battagram>Battagram</option><option value=Birote>Birote</option><option value=Chakdara>Chakdara</option><option value=Charsadda>Charsadda</option><option value=Chitral>Chitral</option><option value=Daggar>Daggar</option><option value=Dargai>Dargai</option><option value=\"Darya Khan\">Darya Khan</option><option value=\"Dera Ismail Khan\">Dera Ismail Khan</option><option value=Doaba>Doaba</option><option value=Dir>Dir</option><option value=Drosh>Drosh</option><option value=Hangu>Hangu</option><option value=Haripur>Haripur</option><option value=Karak>Karak</option><option value=Kohat>Kohat</option><option value=Kulachi>Kulachi</option><option value=\"Lakki Marwat\">Lakki Marwat</option><option value=Latamber>Latamber</option><option value=Madyan>Madyan</option><option value=Mansehra>Mansehra</option><option value=Mardan>Mardan</option><option value=Mastuj>Mastuj</option><option value=Mingora>Mingora</option><option value=Nowshera>Nowshera</option><option value=Paharpur>Paharpur</option><option value=Pabbi>Pabbi</option><option value=Peshawar>Peshawar</option><option value=\"Saidu Sharif\">Saidu Sharif</option><option value=Shorkot>Shorkot</option><option value=\"Shewa Adda\">Shewa Adda</option><option value=Swabi>Swabi</option><option value=Swat>Swat</option><option value=Tangi>Tangi</option><option value=Tank>Tank</option><option value=Thall>Thall</option><option value=Timergara>Timergara</option><option value=Tordher>Tordher</option><option value=\"\" disabled>Balochistan Cities</option><option value=Awaran>Awaran</option><option value=Barkhan>Barkhan</option><option value=Chagai>Chagai</option><option value=\"Dera Bugti\">Dera Bugti</option><option value=Gwadar>Gwadar</option><option value=Harnai>Harnai</option><option value=Jafarabad>Jafarabad</option><option value=\"Jhal Magsi\">Jhal Magsi</option><option value=Kacchi>Kacchi</option><option value=Kalat>Kalat</option><option value=Kech>Kech</option><option value=Kharan>Kharan</option><option value=Khuzdar>Khuzdar</option><option value=\"Killa Abdullah\">Killa Abdullah</option><option value=\"Killa Saifullah\">Killa Saifullah</option><option value=Kohlu>Kohlu</option><option value=Lasbela>Lasbela</option><option value=Lehri>Lehri</option><option value=Loralai>Loralai</option><option value=Mastung>Mastung</option><option value=Musakhel>Musakhel</option><option value=Nasirabad>Nasirabad</option><option value=Nushki>Nushki</option><option value=Panjgur>Panjgur</option><option value=\"Pishin Valley\">Pishin Valley</option><option value=Quetta>Quetta</option><option value=Sherani>Sherani</option><option value=Sibi>Sibi</option><option value=Sohbatpur>Sohbatpur</option><option value=Washuk>Washuk</option><option value=Zhob>Zhob</option><option value=Ziarat>Ziarat</option></select></div><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Date of Birth</label><div class=\"flex-direction-row flex-view justify-space-between dob\"><input class=common-input type=date placeholder=\"Date of Birth\" ng-model=userOrder.dob class=form-control></div></div><h4 class=label-margin style=\"color: #0077A6\">Package Type</h4><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Please Choose the Package Type</label></div><div class=\"flex-view flex-direction-row-col label-margin justify-content-between three-buttons align-items-center\"><button class=button-common ng-click=\"courseSelect(\'single\')\" ng-class=\"{\'activeButton\' : singleSelected }\">Single Course</button> <button class=\"button-common bt-mt\" ng-click=\"courseSelect(\'bundle\')\" ng-class=\"{\'activeButton\' : bundleSelected }\">Bundle</button> <button class=\"button-common bt-mt\" ng-click=\"courseSelect(\'module\')\" ng-class=\"{\'activeButton\' : moduleSelected }\" style=\"width: 180px\">Module of a Course</button></div><h4 class=label-margin style=\"color: #0077A6\">Package Details</h4><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Please Choose the Package Details</label></div><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Course/Module/Bundle Name</label><input class=common-input type=text placeholder=\"Search Courses/Modules/Bundles here\" ng-model=userOrder.searchType class=form-control></div><div class=\"flex-view flex-direction-row-col label-margin justify-content-between three-buttons align-items-center\"><div class=flex-view style=\"border: 1px solid #00000045\"><div class=price-box><label class=price-labels>PKR.</label></div><input class=price-input ng-click=\"courseSelect(\'single\')\"></div><div class=\"flex-view bt-mt\" style=\"border: 1px solid #00000045\"><div class=price-box><label class=price-labels>PER.</label></div><input class=price-input ng-click=\"courseSelect(\'single\')\"></div><div class=\"flex-view bt-mt\" style=\"border: 1px solid #00000045\"><div class=price-box><label class=price-labels>PKR.</label></div><input class=price-input ng-click=\"courseSelect(\'single\')\"></div></div><div class=\"flex-view label-margin\"><label class=common-label>Reasons for Discount</label></div><div class=\"flex-view flex-direction-row label-margin justify-content-between\"><textarea class=text-area ng-model=userOrder.reason>\n\n</textarea></div><h4 class=label-margin style=\"color: #0077A6\">Payment</h4><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Please Select the Payment Method for the Student</label></div><div class=\"flex-view flex-direction-row label-margin\"><input type=radio id=male name=payment value=otherPayment><label class=common-label for=otherPayment style=\"margin-left: 5px\">User will pay online through Jazzcash, Kuickpay or Paypro</label></div><div class=\"flex-view flex-direction-row label-margin\"><input type=radio id=female name=payment value=nearpeer><label class=common-label for=nearpeer style=\"margin-left: 5px\">User will transfer amount to Nearpeer\'s account and will upload a payment proof.</label></div><h4 class=label-margin style=\"color: #0077A6\">Package Method</h4><div class=\"flex-view flex-direction-col label-margin\"><label class=common-label>Please Choose the Payment Type</label></div><div class=\"flex-view flex-direction-row-col label-margin justify-content-between three-buttons align-items-center\"><button class=button-common ng-click=\"paymentSelect(\'jazzcash\')\" ng-class=\"{\'activeButton\' : jazzcashSelected }\">Jazzcash</button> <button class=\"button-common bt-mt\" ng-click=\"paymentSelect(\'kuickpay\')\" ng-class=\"{\'activeButton\' : kuickpaySelected }\">Kuickpay</button> <button class=\"button-common bt-mt\" ng-click=\"paymentSelect(\'paypro\')\" ng-class=\"{\'activeButton\' : payproSelected }\" style=\"width: 180px\">Paypro</button></div><div class=\"flex-view justify-content-c label-margin\"><button style=\"background: #0077A6;\n                color: white;\n                border: none;\n                width: 160px;\n                height: 38px\" ng-click=proceedOrder(userOrder)><span ng-if=!loadingPayment>Place Order</span><div ng-if=loadingPayment style=\"display: flex; justify-content: center\"><div class=login-theme-loader></div></div></button></div></div></div></div></div>");
$templateCache.put("app/admin/orderManagement/editOrder.html","<admin-header statename=\"Edit Course Access\"></admin-header><div class=coure-access-form><div class=\"row course-form-search\"><div class=col-md-6><div class=form-group><label>Order Id</label><input type=text placeholder=\"Enter order id here\" ng-model=orderId ng-change=\"orderId.length>8 ? searchOrder(orderId) : \'\' \" class=form-control><ul ng-if=open class=list-group><li ng-click=selectOrder(order) class=list-group-item ng-repeat=\"order in orderIds\">{{order.ref_no}}</li></ul></div></div></div></div><div ng-show=showInfo><!------ dropdowns -----><div class=col-12><div class=btn-group style=\"float: right\"><button class=\"btn btn-default btn-lg dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{selectedOption}}</label><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu><li ng-repeat=\"option in options\"><a ng-click=purchaseType(option)>{{option.name}}</a></li></ul></div></div><div class=clearfix></div><div style=\"overflow: auto\"></div><div><div ng-show=access.type class=\"course-form-search row\"><div class=col-md-6><div class=form-group><label>User</label><input type=text placeholder=\"{{selectedUser.email || selectedUser.fb_email || selectedUser.name || selectedUser.full_name}}\" ng-model=userKey ng-change=\"userKey.length > 3 ? searchInfo(userKey,\'user\') : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=\"addVariants(user,\'user\')\" class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.name || user.full_name}} {{user.provider ? \'(\' + user.provider + \')\' : \'\'}}</li></ul></div></div><div class=col-md-6><div class=form-group><label>{{access.type===\'course\' || access.type===\'module\'?\'Course\':\'Bundle\'}}</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey,access.type) : null\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=addVariants(course,access.type) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div><div class=form-group data-text=\"Enter text here\" ng-show=\"access.type===\'module\'\"><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectedModuleName ng-change=addModule(selectedModuleName)><option ng-repeat=\"module in modules\" value={{$index}}>{{module.name}}</option></select></div></div><div class=col-md-6><div class=form-group><label>Session</label><input type=text class=form-control placeholder=\"Search Session\" ng-model=sessionKey ng-blur=selectSessionBlur(selectedCourse) ng-focus=searchSession(sessionKey) ng-change=searchSession(sessionKey)><ul ng-if=\"sessions.length > 0\" class=list-group><li ng-click=selectSession(session) class=list-group-item ng-repeat=\"session in sessions\">{{session.name}}</li></ul></div></div></div></div><!------ dropdowns -----><div class=\"row info-block mt-30\"><div class=col-md-6><h3 class=pb-20>User Information</h3><div class=form-group><input type=text class=form-control ng-model=selectedUser.name placeholder=\"First Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.full_name placeholder=\"Full Name\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.email placeholder=\"Primary Email Address\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.fb_email placeholder=\"Facebook Email Address\" readonly></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.city placeholder=City></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.phone placeholder=\"Mobile Number\"></div></div><div class=col-md-6><h3 class=pb-20>Other Information</h3><div class=form-group ng-if=\"access.type===\'bundle\'\"><input type=text class=form-control ng-model=selectedBundle.name readonly></div><div class=form-group ng-if=\"access.type!==\'bundle\'\"><input type=text class=form-control ng-model=selectedCourse.name readonly></div><div class=form-group ng-show=selectedModule.name><input type=text class=form-control ng-model=selectedModule.name readonly></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.crn placeholder=CRN></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.dob placeholder=\" Date of Birth\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.marksPercentage placeholder=\"Matriculation / Intermediate Percentage\"></div><div class=form-group><input type=text class=form-control ng-model=selectedUser.university placeholder=\"School / College / University\"></div><div class=\"form-group upload-file-form\"><label>{{ selectedUser.cnic || \'Attach CNIC / Student Card\' }} <span>&#x2b;</span> <input class=upload-box ng-model=image ngf-select=\"uploadImage(image,\'user\')\" type=file id=file placeholder=\"CNIC Copy\"></label></div></div></div><!-----row-----><div class=\"row payment-block info-block mt-30 mb-30\"><div class=col-md-6><h3 class=pb-20>Payment Information</h3><div ng-show=\"access.type!==\'module\' && !selectedModule.module_type.paid\" class=form-group><input type=text class=form-control ng-model=orderPrice readonly></div><div ng-show=selectedModule.module_type.paid class=form-group><input type=text class=form-control ng-model=selectedModule.module_type.price readonly></div><div class=form-group><input type=number class=form-control ng-model=access.amount placeholder=\"Amount you have Paid\"></div><div class=\"form-group upload-file-form\"><label>{{ access.proof||\'Amount Payment Proof\'}} <span>&#x2b;</span> <input class=upload-box ng-model=image ngf-select=\"uploadImage(image,\'access\')\" type=file id=file placeholder=\"Amount Payment Proof\"></label></div><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{selectedPaymentType||\'Payment type\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'type\')\">Payment Type</a></li><li ng-repeat=\"type in payTypes\"><a ng-click=\"accessVariants(type , \'type\')\">{{type.name}}</a></li></ul></div></div><div class=form-group><div flex-gt-xs><label id=payment_date for=to>Payment Date</label><md-datepicker ng-model=order.payment_date md-placeholder=\"Enter date\" input-aria-labelledby=payment_date></md-datepicker></div></div></div><div class=col-md-6><h3 class=pb-20>Reason for Free</h3><div class=form-group data-text=\"Enter text here\"><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{selectedReason.reason ||\'Select Reason\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a ng-click=\"accessVariants(null , \'reason\')\">Select Reason</a></li><li ng-repeat=\"reason in reasons\"><a ng-click=\"accessVariants(reason , \'reason\')\">{{reason.reason}}</a></li></ul></div></div><div class=form-group><textarea type=text ng-model=access.comments class=\"reason-comment-block form-control\" placeholder=\"Write your comments...\"></textarea></div></div><div class=col-md-12><div><div class=inner-display-reason><h3 class=pb-20>Disable Reason</h3><div class=reason-sec style=\"max-height: 400px\"><div><label><input type=radio ng-model=selectedReason value=Refunded> Refunded</label><br><label><input type=radio ng-model=selectedReason value=Piracy> Piracy</label><br><label><input type=radio ng-model=selectedReason value=\"Installment Case\"> Installment Case</label><br><label><input type=radio ng-model=selectedReason value=\"Account shifting\"> Account shifting</label><br><label><input type=radio ng-model=selectedReason value=Freezed> Freezed</label><br><label><input type=radio ng-model=selectedReason value=other> Other</label><br><labe ng-if=\"selectedReason === \'other\'\"><textarea class=form-control type=text rows=5 cols=100 ng-model=otherReason id=otherReason placeholder=\"Add Reason\"></textarea><br></labe></div></div></div></div></div><div class=col-md-12><button type=button ng-disabled=disabled ng-click=updateOrder() class=\"btn btn-default primary_btn payment-block-btn\">Save</button></div></div><!-----row-----></div>");
$templateCache.put("app/admin/orderManagement/orderEditTrail.html","<admin-header statename=\"Order Trail\"></admin-header><div class=order-management><div class=\"row pb-30 order-mgt-block\"><div><button id=download_csv type=button style=\"margin: 20px\" class=\"btn btn-default\" ng-click=createCSV()><span class=\"glyphicon glyphicon-export\"></span> Export</button></div><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>#</th><th class=text-center>Ref No</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th><th class=text-center>Module</th><th class=text-center>Price</th><th class=text-center>Discount</th><th class=text-center>Revenue</th><th class=text-center>Balance</th><th class=text-center>Coup Bal</th><th class=text-center>Coup ID</th><th class=text-center>User</th><th class=text-center>Phone</th><th class=text-center>Primary Email</th><th class=text-center>Facebook Email</th><th class=text-center>CRN</th><th class=text-center>City</th><th class=text-center>Date</th><th class=text-center>Reason for Free</th><th class=text-center>Payment Proof</th><th class=text-center>Payment Type</th><th class=text-center>Comments</th><th class=text-center>Status</th><th class=text-center>Updated By</th><th class=text-center>Updated At</th></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td class=text-center>{{$index+1}}</td><td class=text-center>{{order.order.order.ref_no}}</td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.type !== orders[$index+1].order.order.type)}\">{{order.order.order.type}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.bundle_id.name !== orders[$index+1].order.order.bundle_id.name)}\">{{order.order.bundle_id.name}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.course_id.name !== orders[$index+1].order.course_id.name)}\">{{order.order.course_id.name}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.module_id.name !== orders[$index+1].order.module_id.name)}\">{{order.order.module_id.name}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.price !== orders[$index+1].order.order.price)}\">{{order.order.order.price}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.total !== orders[$index+1].order.order.total)}\">{{order.order.order.discount_price > 0 ? getDifference(order.order.order.price , order.order.order.total) : 0 }}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.total !== orders[$index+1].order.order.total)}\">{{order.order.order.total}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.user_balance !== orders[$index+1].order.order.user_balance)}\">{{order.order.order.user_balance}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.coupon_balance !== orders[$index+1].order.order.coupon_balance)}\">{{order.order.order.coupon_balance}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.couponId !== orders[$index+1].order.order.couponId)}\">{{order.order.couponId}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.full_name !== orders[$index+1].order.user_id.full_name || orders[$index].order.user_id.name !== orders[$index+1].order.user_id.name)}\">{{order.order.user_id.full_name || order.user_id.name}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.phone !== orders[$index+1].order.user_id.phone)}\">{{order.order.user_id.phone}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.email !== orders[$index+1].order.user_id.email)}\">{{order.order.user_id.email}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.fb_email !== orders[$index+1].order.user_id.fb_email)}\">{{order.order.user_id.fb_email}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.crn !== orders[$index+1].order.user_id.crn)}\">{{order.order.user_id.crn}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.user_id.city !== orders[$index+1].order.user_id.city)}\">{{order.order.user_id.city}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.time !== orders[$index+1].order.time)}\">{{order.order.order.time | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.orderAccess.reason_id.reason !== orders[$index+1].order.orderAccess.reason_id.reason)}\">{{order.order.orderAccess.reason_id.reason}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.proof !== orders[$index+1].order.proof)}\">{{order.order.proof}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.orderAccess.payment_id.name !== orders[$index+1].order.orderAccess.payment_id.name)}\">{{order.order.orderAccess.payment_id.name}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.orderAccess.comments !== orders[$index+1].order.orderAccess.comments)}\">{{order.order.orderAccess.comments | limitTo : 20}} {{order.order.orderAccess.comments.length > 20 ? \'...\' : \'\'}}</span></td><td><span ng-class=\"{fieldBold: $index+1!==orders.length && (orders[$index].order.order.status !== orders[$index+1].order.order.status)}\">{{order.order.order.status}}</span></td><td><span>{{order.updatedBy.email}}</span></td><td><span>{{order.createdAt | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/orderManagement/orderManagement.html","<admin-header statename=Orders></admin-header><div class=order-management><div class=\"row pb-30 order-mgt-block\"><div class=\"col-md-12 mt-10 page-num-block\"><div class=\"col-xs-6 col-md-3\"><input ng-disabled=\"searchParams.type===\'all\'\" type=text placeholder=Search ng-model=searchParams.key ng-change=\"searchParams.key.length > 0 ? searchOrder(searchParams.key, searchParams.type,false,true) : null\" class=form-control> <span>By:</span><ul ng-if=\"searchData.length > 0\" class=list-group><!-- ng-click=\"addVariants(user,\'user\')\" --><li ng-click=\"searchOrder(row.email || row.fb_email || row.name || row.full_name,searchParams.type,true,true, row)\" class=list-group-item ng-repeat=\"row in searchData\">{{row.email || row.fb_email || row.name || row.full_name }} {{row.provider ? \'(\' + row.provider + \')\' : \'\'}}</li></ul></div><div class=\"col-xs-6 col-md-2 btn-group\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"display: block\"><label>{{ searchParams.type ||\'SearchType\'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=\"search-type dropdown-menu\"><li ng-repeat=\"type in searchType\"><a ng-click=changeType(type)>{{type}}</a></li></ul></div><div class=\"col-xs-6 col-md-1 padding0 page-num-option\"><select ng-model=searchParams.per_page class=form-control ng-change=\"searchOrder(searchParams.key, searchParams.type, true,true)\" aria-invalid=false><option ng-repeat=\"pageNum in pageRow\">{{pageNum}}</option></select></div><div class=\"col-xs-6 col-md-2 download-csv-block\"><label for=dateFrom>From:</label><input type=date ng-model=fromDate name=dateFrom><label for=dateTo>To:</label><input type=date id=birthday ng-model=toDate name=dateTo> <a id=download_csv ng-click=downloadOrders()>Download CSV</a></div><div class=\"col-xs-12 col-md-4 ng-binding no-of-pages\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span class=order-page-detail>{{searchParams.page}} in {{totalPages}} ,{{(searchParams.page*searchParams.per_page)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}} Out of {{totalCount}}</span></div></div><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>#</th><th class=text-center>Ref No</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th><th class=text-center>Module</th><th class=text-center>Price</th><th class=text-center>Discount</th><th class=text-center>Revenue</th><th class=text-center>Balance</th><th class=text-center>Coup Bal</th><th class=text-center>Coup ID</th><th class=text-center>User ID</th><th class=text-center>User</th><th class=text-center>Phone</th><th class=text-center>Primary Email</th><th class=text-center>Facebook Email</th><th class=text-center>Provider</th><th class=text-center>CRN</th><th class=text-center>City</th><th class=text-center>Date</th><th class=text-center>Reason for Free</th><th class=text-center>Payment Proof</th><th class=text-center>Payment Type</th><th class=text-center>Comments</th><th class=text-center>Status</th><th class=text-center>Session</th><th class=text-center>Admin Name</th><th class=text-center>Agent Name</th><th class=text-center>Disable Reason</th><th class=text-center>Disable By</th><th class=text-center>Access</th><th class=text-center>Freeze Status</th><th class=text-center>Edited</th><th class=text-center>Payment Link</th><th class=text-center>Payment Date</th></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td class=text-center>{{($index+1)+((searchParams.page*searchParams.per_page)-searchParams.per_page)}}</td><td class=text-center>{{order.ref_no}}</td><td>{{order.type}}</td><td>{{order.bundle}}</td><td>{{order.course}}</td><td>{{order.module}}</td><td>{{order.price}}</td><td>{{order.discount}}</td><td>{{order.revenue}}</td><td>{{order.user_balance}}</td><td>{{order.coupon_balance}}</td><td>{{order.couponId}}</td><td>{{order.user_id}}</td><td>{{order.user_name}}</td><td>{{order.phone}}</td><td>{{order.provider !== \'facebook\' ? order.user_email : \'\'}}</td><td>{{order.provider === \'facebook\' ? order.fb_email || order.user_email : \'\'}}</td><td>{{order.provider}}</td><td>{{order.crn}}</td><td>{{order.city}}</td><td>{{order.time | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</td><td>{{order.reason}}</td><td>{{order.proof}}</td><td>{{order.payType}}</td><td title={{order.comments}}>{{order.comments | limitTo : 20}} {{order.comments.length > 20 ? \'...\' : \'\'}}</td><td>{{order.status}}</td><td>{{order.session ? order.session.name : \'\'}}</td><td>{{order.admin_name}}</td><td>{{order.agent_name}}</td><td>{{order.reason_disabled}}</td><td>{{order.disable_by_name}}</td><td><button class=\"btn btn-primary table-btn\" ng-if=\"order.status== \'paid\' ||\n                  order.status == \'disabled\' || order.status== \'enabled\'\" ng-click=\"order.status== \'paid\' ? callShowReasonPopup(order) : terminateOrder(order.id)\">{{order.status == \'paid\' ? \'disable\':order.status==\'disabled\'?\'close\':order.status==\'enabled\'?\'close\':null}}</button></td><td><button class=\"btn btn-primary table-btn\" ng-if=\"order.status== \'paid\' || order.status== \'out dated\' \" ng-click=freezeOrder(order.id)>{{order.is_freeze ? \"Unfreeze\" : \"Freeze\"}}</button></td><td><button class=\"btn btn-primary table-btn\" ng-if=\"order.isEdited===true\" ng-click=viewOrderTrail(order.id)>View Trail</button></td><td><button class=\"btn btn-primary table-btn\" ng-if=\"order.status===\'placed\'\" ng-click=\"openPaymentMethods(order, \'CARD\')\">Generate Link</button></td><td>{{order.payment_date | date:\"MM/dd/yyyy\" || null}}</td></tr></tbody></table></div></div><div class=order-disable-popup-container ng-if=paymentMethodPopup><div class=order-disable-popup><img ng-click=closePaymentMethods() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-reason><div class=reason-head><h4>Select Payment Method</h4></div><div class=reason-sec style=\"max-height: 400px\"><div><label><input type=radio ng-model=paymentMethod value=EASYPAISA> EASYPAISA</label><br><label><input type=radio ng-model=paymentMethod value=JAZZCASH> JAZZCASH</label><br><label><input type=radio ng-model=paymentMethod value=CARD> CARD</label><br><label><input type=radio ng-model=paymentMethod value=NIFT> NIFT</label><br></div><div style=\"text-align: center\"><button class=\"btn btn-primary table-btn\" ng-click=generatePaymentLink(paymentMethod)>Generate Payment Link</button></div></div></div></div></div><div class=order-disable-popup-container ng-if=showReasonPopup><div class=order-disable-popup><img ng-click=closeCoursesWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-reason><div class=reason-head><h4>Select Reason</h4></div><div class=reason-sec style=\"max-height: 400px\"><div><label><input type=radio ng-model=selectedReason value=Refunded> Refunded</label><br><label><input type=radio ng-model=selectedReason value=Piracy> Piracy</label><br><label><input type=radio ng-model=selectedReason value=\"Installment Case\"> Installment Case</label><br><label><input type=radio ng-model=selectedReason value=\"Account shifting\"> Account shifting</label><br><label><input type=radio ng-model=selectedReason value=Freezed> Freezed</label><br><label><input type=radio ng-model=selectedReason value=other> Other</label><br><labe ng-if=\"selectedReason === \'other\'\"><textarea class=form-control type=text rows=5 cols=100 ng-model=otherReason id=otherReason placeholder=\"Add Reason\"></textarea><br></labe></div><div style=\"text-align: center\"><button class=\"btn btn-primary table-btn\" ng-click=\"terminateOrder(selectedDisableOrder.id, selectedReason, otherReason)\">Disable Order</button></div></div></div></div></div></div>");
$templateCache.put("app/admin/orderManagement/paymentApproval.html","<admin-header statename=\"Payment Approvals\"></admin-header><div><div class=\"row pb-30 order-mgt-block\"><div class=\"col-md-12 mt-10\"><div class=\"col-xs-4 col-md-2\" style=\"max-width: 130px\"><div style=\"padding-top: 5px;padding-right: 10px;border-right: 1px solid #B3B3B3\"><i class=\"fa fa-search\"></i><label>Search By</label></div></div><div class=\"col-xs-8 col-md-3\"><label>Name:</label><input type=text ng-model=searchParams.search.name ng-keydown=onKeyDown($event) class=AdminApprovalInput> <button ng-click=searchOrder(true) class=AdminApprovalButton>Go</button></div><div class=\"col-xs-8 col-md-3\"><label>Email:</label><input type=text ng-model=searchParams.search.email ng-keydown=onKeyDown($event) class=AdminApprovalInput> <button ng-click=searchOrder(true) class=AdminApprovalButton>Go</button></div><div class=\"col-xs-8 col-md-3\"><label>Phone:</label><input type=text ng-model=searchParams.search.phone ng-keydown=onKeyDown($event) class=AdminApprovalInput> <button ng-click=searchOrder(true) class=AdminApprovalButton>Go</button></div></div><div class=\"col-md-12 mt-30\"><div class=\"col-xs-12 col-md-1\"><p style=\"margin:5px 0px\">Filters:</p></div><div class=\"col-xs-12 col-md-2\"><div ng-click=\"searchOrder(true, \'waitingForApproval\')\" class=AdminApprovalDiv style=\"cursor: pointer; height: 30px; display: flex; justify-content: center; align-items: center; border-radius: 15px\"><p style=\"margin:5px 0px\">Pending ({{pendingCount}})</p></div></div><div class=\"col-xs-12 col-md-2\"><div ng-click=\"searchOrder(true, \'proofRejected\')\" class=AdminApprovalDiv style=\"cursor: pointer; height: 30px; display: flex; justify-content: center; align-items: center; border-radius: 15px\"><p style=\"margin:5px 0px\">Rejected ({{rejectedCount}})</p></div></div><div class=\"col-xs-12 col-md-2\"><div ng-click=\"searchOrder(true, \'paid\')\" class=AdminApprovalDiv style=\"cursor: pointer; height: 30px; display: flex; justify-content: center; align-items: center; border-radius: 15px\"><p style=\"margin:5px 0px\">Accepted ({{approvedCount}})</p></div></div></div><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>Payment Proof</th><th class=text-center ng-click=\"sortData(\'order.ref_no\')\">Received Date</th><th class=text-center>Order No</th><th class=text-center>User</th><th class=text-center>Phone</th><th class=text-center>Email</th><th class=text-center>Type</th><th class=text-center>Bundle</th><th class=text-center>Course</th><th class=text-center>Module</th><th class=text-center>Price</th><th class=text-center>Discount</th><th class=text-center>Revenue</th><th class=text-center>Status</th><th class=text-center>Access</th></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td><a ng-if=\"order.status != \'uploadedFromWhatsApp\'\" href={{order.proof}} target=_blank>View Proof File</a><p ng-if=\"order.status == \'uploadedFromWhatsApp\'\" style=\"margin: 0\">View Proof on WhatsApp</p></td><td>{{order.time | date:\"MM/dd/yyyy \'at\' h:mm a\"}}</td><td class=text-center>{{order.ref_no}}</td><td>{{order.user_name}}</td><td>{{order.phone}}</td><td>{{order.user_email ? order.user_email : \'fb:\'+order.fb_email}}</td><td>{{order.type}}</td><td>{{order.bundle}}</td><td>{{order.course}}</td><td>{{order.module}}</td><td>{{order.price}}</td><td>{{order.discount}}</td><td>{{order.revenue}}</td><td>{{order.status}}</td><td><button class=\"btn btn-primary table-btn\" ng-if=\"order.status== \'uploadedFromWhatsApp\' || order.status== \'waitingForApproval\'\" ng-click=\"updateOrder(order.ref_no, \'paid\')\">Approve</button> <button class=\"btn btn-primary table-btn\" ng-if=\"order.status== \'uploadedFromWhatsApp\' || order.status== \'waitingForApproval\'\" ng-click=\"updateOrder(order.ref_no, \'proofRejected\')\">Reject</button></td></tr></tbody></table><div class=\"col-xs-12 col-md-4\" style=\"float: right\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=\"searchParams.page > 1 ? pagination(searchParams.page-1) : null\"><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=\"orders.length == 10 ? pagination(searchParams.page+1) : null\"><a href=\"\"><span>&gt;</span></a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/admin/otpPage/otpPage.html","<div style=\"text-align: center; padding-top: 150px\"><div class=\"position-centre parent_div\"><h4 style=\"margin-top: 0px;font-size: 15px;padding: 0 15px\">Please enter one time verification code sent to your Email</h4><hr style=\"border-color: white\"><table class=position-centre style=\"margin-top: 50px; margin-bottom: 50px\"><tbody><tr><td><input type=text style=\"color: black\" class=input_field name=\"\" ng-model=otpCode></td></tr></tbody></table><table class=position-centre style=\"font-size: 12px\"><tbody><tr><td><p style=\"margin: 0px\">Didn\'t receive the OTP?</p></td><td><a href=# style=\"margin: 0px 10px; color: brown\" ng-click=resendOtp()>Resend Code</a></td></tr></tbody></table></div><button class=\"position-centre button_custom\" ng-click=verifyOtp()>Verify</button></div>");
$templateCache.put("app/admin/paymentAudit/paymentAudit.html","<admin-header statename=\"Payment Audit\" style=\"border-bottom: 1px solid #eee\"></admin-header><!-- Modern Payment Audit UI --><div class=container-fluid ng-controller=AdminPaymentAuditController><div class=row><!-- Main Content --><div class=col-sm-12 style=\"padding: 0\"><!-- Filters --><div class=pa-filters><div class=row><div class=\"col-md-6 col-lg-5ths\" style=\"margin-bottom: 16px\"><div class=form-group><label for=search>Search</label><div class=input-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control placeholder=\"Search orders...\" ng-model=filters.search ng-disabled=\"filters.type === \'\'\"></div></div></div><div class=\"col-md-6 col-lg-5ths\" style=\"margin-bottom: 16px\"><div class=form-group><label for=type>By</label><select class=form-control ng-model=filters.type><option value=\"\">Please Select Type</option><option value=reference>Reference</option><option value=bundle>Bundle</option><option value=course>Course</option><option value=module>Module</option></select></div></div><div class=\"col-md-6 col-lg-5ths\" style=\"margin-bottom: 16px\"><div class=form-group><label for=from>From</label><div class=input-group><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span> <input type=date class=form-control placeholder=From ng-model=filters.fromDate></div></div></div><div class=\"col-md-6 col-lg-5ths\" style=\"margin-bottom: 16px\"><div class=form-group><label for=to>To</label><div class=input-group><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span> <input type=date class=form-control placeholder=To ng-model=filters.toDate></div></div></div><div class=\"col-md-6 col-lg-5ths\" style=\"margin-bottom: 16px\"><div class=form-group><label for=type>Payment Status</label><select class=form-control ng-model=filters.payment_status><option value=\"\">Please Select Status</option><option value=UNVERIFIED>UNVERIFIED</option><option value=VERIFIED>VERIFIED</option></select></div></div><div class=\"col-md-6 col-lg-1\" style=\"margin-bottom: 16px\"><div class=form-group><!-- <label for=\"filter\">&nbsp;</label> --> <button class=\"btn btn-primary btn-block\" style=\"height: 38px; color: #ffffff\" ng-click=applyFilters()>Filter</button></div></div><div class=\"col-md-6 col-lg-1\" style=\"margin-bottom: 16px\"><div class=form-group><!-- <label for=\"clear\">&nbsp;</label> --> <button class=\"btn btn-default btn-block\" style=height:38px ng-click=clearFilters() ng-disabled=\"!filters.search && !filters.fromDate && !filters.toDate && filters.type === \'\'\">Clear</button></div></div><div class=\"col-md-6 col-lg-1\" style=\"margin-bottom: 16px; text-align: right\"><div class=form-group><!-- <label for=\"csv\">&nbsp;</label> --> <button class=\"btn btn-default btn-block\" style=\"height: 38px\" ng-click=downloadCSV()><span class=\"glyphicon glyphicon-download-alt\"></span> CSV</button></div></div></div></div><!-- Summary Cards --><div class=\"row pa-summary-cards\"><div class=col-sm-4><div class=\"panel panel-default\" style=\"border-radius: 16px;\n              box-shadow: 0 2px 8px #f0f1f3;\n              border: none\"><div class=panel-body style=\"display: flex;\n                align-items: center;\n                gap: 16px;\n                padding: 24px 20px\"><span style=\"background: #f3f6fd;\n                  border-radius: 50%;\n                  padding: 12px;\n                  display: inline-block\"><span class=\"glyphicon glyphicon-list-alt\" style=\"font-size: 28px; color: #6c63ff\"></span></span><div><div style=\"font-size: 15px; color: #888; font-weight: 600; margin-bottom: 10px\">Total Orders</div><div style=\"font-size: 26px; font-weight: 700; color: #222\">{{totalOrders}}</div></div></div></div></div><div class=col-sm-4><div class=\"panel panel-default\" style=\"border-radius: 16px;\n              box-shadow: 0 2px 8px #f0f1f3;\n              border: none\"><div class=panel-body style=\"display: flex;\n                align-items: center;\n                gap: 16px;\n                padding: 24px 20px\"><span style=\"background: #eafaf1;\n                  border-radius: 50%;\n                  padding: 12px;\n                  display: inline-block\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size: 28px; color: #4caf50\"></span></span><div><div style=\"font-size: 15px; color: #888; font-weight: 600; margin-bottom: 10px\">Verified Orders</div><div style=\"font-size: 26px; font-weight: 700; color: #222\">{{verifiedOrders}}</div></div></div></div></div><div class=col-sm-4><div class=\"panel panel-default\" style=\"border-radius: 16px;\n              box-shadow: 0 2px 8px #f0f1f3;\n              border: none\"><div class=panel-body style=\"display: flex;\n                align-items: center;\n                gap: 16px;\n                padding: 24px 20px\"><span style=\"background: #fff0f0;\n                  border-radius: 50%;\n                  padding: 12px;\n                  display: inline-block\"><span class=\"glyphicon glyphicon-remove-circle\" style=\"font-size: 28px; color: #f44336\"></span></span><div><div style=\"font-size: 15px; color: #888; font-weight: 600; margin-bottom: 10px\">Unverified Orders</div><div style=\"font-size: 26px; font-weight: 700; color: #222\">{{unverifiedOrders}}</div></div></div></div></div></div><!-- Table --><div class=row><div class=pa-table-wrap><table class=\"table pa-table\"><thead><tr><!-- <th style=\"width: 32px\"><input type=\"checkbox\" /></th> --><th style=\"text-align: center\">VERIFIED</th><th style=\"min-width: 150px\">PAYMENT PROOF</th><th>Payment date</th><th>Payment type</th><th>Agent name</th><th>REF NO.</th><th style=\"min-width: 200px\">BUNDLE</th><th style=\"min-width: 200px\">COURSE</th><th style=\"min-width: 200px\">MODULE</th><th>PRICE</th><th>Discount</th><th>Revenue</th><th style=\"min-width: 110px\">Date</th><th>User email</th><th>User phone</th><th>Comments</th></tr></thead><tbody><tr ng-repeat=\"order in orders\" style=\"vertical-align: middle\"><!-- <td><input type=\"checkbox\" /></td> --><td style=\"text-align: center\"><span ng-if=\"order.courseAccess && order.courseAccess[0] && order.courseAccess[0].payment_status === \'VERIFIED\'\" class=\"glyphicon glyphicon-ok\" style=\"color: #4caf50; font-size: 18px\"></span> <span ng-if=\"!order.courseAccess || !order.courseAccess[0] || order.courseAccess[0].payment_status !== \'VERIFIED\'\" class=\"glyphicon glyphicon-remove\" style=\"color: #f44336; font-size: 18px\"></span></td><td><a href=# class=pa-link data-toggle=modal data-target=#proofModal ng-click=showProof(order)>View Proof</a></td><td>{{order.payment_date}}</td><td><span ng-repeat=\"access in order.courseAccess\">{{ access.payment_id && access.payment_id.name ? access.payment_id.name : \'-\' }}<span ng-if=!$last>,</span></span></td><td>{{order.agent_name}}</td><td>{{order.ref_no}}</td><td>{{order.order_items[0].bundle_id.name}}</td><!-- <td>{{order.order_items[0].course_id ? order.order_items[0].course_id.name : \'-\'}}</td> --><td><span ng-repeat=\"item in order.order_items\">{{item.course_id ? item.course_id.name : \'-\'}}<span ng-if=!$last>,</span></span></td><!-- <td>{{order.order_items[0].module_id ? order.order_items[0].module_id.name : \'-\'}}</td> --><td><span ng-repeat=\"item in order.order_items | filter:{module_id:{name:\'\'}}:false\">{{item.module_id && item.module_id.name ? item.module_id.name : \'\'}}<span ng-if=!$last>,</span></span></td><td>{{order.price ? order.price : \'-\'}}</td><td>{{order.discount_price}}</td><td>{{order.total}}</td><td>{{order.time | date:\'dd-MM-yyyy\'}}</td><td>{{order.user_id && order.user_id.email ? order.user_id.email : \'-\'}}</td><td>{{order.user_id && order.user_id.phone ? order.user_id.phone : \'-\'}}</td><td><span ng-repeat=\"access in order.courseAccess\">{{ access.comments ? access.comments : \'\' }}<span ng-if=!$last>,</span></span></td><!-- <td>\n                  <span\n                    class=\"glyphicon glyphicon-option-horizontal\"\n                    style=\"font-size: 18px; color: #888\"\n                  ></span>\n                </td> --></tr></tbody></table></div></div><!-- Pagination & Row Count --><div class=pa-pagination-row><div class=col-sm-6 style=\"padding-top: 8px; display: flex; align-items: center; gap: 8px\"><span style=\"font-size: 14px; color: #888\">Show:</span><select ng-model=pageSize ng-options=\"s for s in pageSizes\" ng-change=setPageSize(pageSize) class=form-control style=\"width: auto; display: inline-block\"></select></div><div class=\"col-sm-6 text-right\" style=\"padding-top: 8px; font-size: 14px; color: #888\"><span>{{ currentPage }}-<!-- {{\n            Math.min(currentPage*pageSize, totalOrders) }}  --> of {{ totalPages }}</span> <button class=\"btn btn-link btn-sm\" style=\"color: #888\" ng-click=prevPage() ng-disabled=\"currentPage === 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></button> <button class=\"btn btn-link btn-sm\" style=\"color: #888\" ng-click=nextPage() ng-disabled=\"currentPage === totalPages\"><span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div></div></div><!-- Modal for Payment Proof --><div class=\"modal fade\" id=proofModal tabindex=-1 role=dialog aria-labelledby=proofModalLabel><div class=modal-dialog role=document><div class=modal-content><div class=modal-header style=\"padding: 16px !important\"><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title id=proofModalLabel>Payment Proof</h4></div><div class=modal-body style=\"text-align: center\"><img ng-src={{currentProof}} alt=\"Payment Proof\" style=\"max-width: 100%; border-radius: 8px; margin-bottom: 24px\"></div><div class=modal-footer style=\"display: flex; justify-content: center; gap: 16px\"><button ng-if=\"currentOrder && currentOrder.courseAccess && currentOrder.courseAccess[0] && currentOrder.courseAccess[0].payment_status === \'UNVERIFIED\'\" type=button class=\"btn btn-success\" ng-click=verifyOrder() data-dismiss=modal>Verify</button> <button ng-if=\"currentOrder && currentOrder.courseAccess && currentOrder.courseAccess[0] && currentOrder.courseAccess[0].payment_status === \'VERIFIED\'\" type=button class=\"btn btn-danger\" ng-click=unverifyOrder() data-dismiss=modal>Unverify</button></div></div></div></div><div ng-if=showingToast style=\"position: fixed; top: 30px; right: 30px; z-index: 9999\"><div class=\"alert alert-success\" style=\"min-width: 200px; text-align: center\">{{toastMessage}}</div></div></div>");
$templateCache.put("app/admin/postQuestionConfig/postQuestionConfig.html","<admin-header statename=\"Post Question Config\"></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_post_questions_config\')\">Create Post Question Config</button><!-- <div>\n    <p style=\"float: right;\"><input type=\"text\" placeholder=\"Search By Coupon Id\" ng-model=\"couponID\"> <button class=\"btn btn-primary\" ng-click=\"searchCouponById(couponID)\">Search</button></p>\n    <h4>Sort By</h4>\n    <select ng-change=\"showCoupons(1,sortType)\" ng-model=\"sortType\">\n      <option value=\"1\" selected>Default</option>\n      <option value=\"2\">Created At Ascending</option>\n      <option value=\"3\">Status Used</option>\n      <option value=\"4\">Status Available</option>\n    </select>\n  </div> --><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">Paid Only</p></th><th><p class=\"pTag table_th\">Created By</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.name}}</p></td><td><p class=pTag>{{config.paid_only | date:\'yyyy-MM-dd\'}}</p></td><td><p class=pTag>{{config.created_by.full_name}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" ng-click=disableConfig(config)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total_config_pages | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/questions/adminQuestions.html","<admin-header statename=\"Student Questions\"></admin-header><div class=container-fluid><div class=\"comment-section-new row\"><div class=comment-section style=\"display: flex; flex-direction: column\"><div class=chips-div><div class=search-bar><div style=\"display: flex;    flex-direction: column\"><input placeholder=\"Search Anything\" class=question-input ng-model=searchText><div style=\"display: flex;\n          justify-content: space-between;margin-top: 10px\"><div class=\"flex-view flex-direction-col\" style=\"width: 140px\"><label for=dateFrom style=\"margin: 0\">From:</label><input type=date ng-model=fromDate name=dateFrom></div><div class=\"flex-view flex-direction-col\" style=\"width: 140px\"><label for=dateTo style=\"margin: 0\">To:</label><input type=date ng-model=toDate name=dateTo></div></div><!-- question text,name, number,email,course tag,answer text --></div><div style=\"display: flex;\nflex-direction: column;\njustify-content: space-between;\nmargin-left: 10px\"><button class=question-search ng-click=searchQuery()><img style=\"margin: 0px 5px\" src=./../../../images/QSearch.svg> <span class=admin-q-hide>Search</span></button> <button class=question-search style=\"color: #133c5c;\n    border: 1px solid #133c5c;\n    background: white\" ng-click=clearFilter()><img style=\"margin: 0px 5px\" src=\"./../../../images/delete_outline_black_24dp 1.svg\"> <span class=admin-q-hide>Clear</span></button></div></div><div class=students-filter><div class=question-filter-container><div class=ind-filter ng:class=\"{ \'ind-filter-selected\' :filterSelected.all }\" ng-click=\"changeFilter(\'all\')\">All({{allQuestionsCount}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.assigned }\" ng-click=\"changeFilter(\'assigned\')\">Assigned({{assignedQuestionsCount}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.answered }\" ng-click=\"changeFilter(\'answered\')\">Answered({{answeredQuestionsCount}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.unassigned }\" ng-click=\"changeFilter(\'unassigned\')\" style=\"margin-right: 0\">Unassigned({{unassignedQuestionsCount}})</div></div></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=showData class=\"table-responsive col-xs-12 questions-table\" style=\"padding: 20px 20px 0px 20px\"><!-- table-bordered table-striped --><div class=ledger-question><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #00800040\"></li><p>Assigned & Answered</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ff000021\"></li><p>Unassigned</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ffff0045\"></li><p>Assigned & Unanswered</p></div></div><table class=\"table custom-question\" ng-if=!noData><thead><tr><th><div class=question-table-head><label>Status</label></div></th><th><div class=question-table-head><label>Action</label></div></th><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'id\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'id\')\"><img src=./../../../images/QDWN.svg></div></div><label>Student ID</label></div></th><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'name\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'name\')\"><img src=./../../../images/QDWN.svg></div></div><label>Student Name</label></div></th><th><div class=question-table-head><label>Email</label></div></th><th><div class=question-table-head><label>Contact Number</label></div></th><th><div class=question-table-head><label>Course Tag</label></div></th><th><div class=question-table-head><label>Question</label></div></th><th><div class=question-table-head><label>Rating (5)</label></div></th><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Gender</label></div></th><!-- <th>\n                <div class=\"question-table-head\">\n                  <label>Time</label>\n                </div>\n              </th> --><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'date\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'date\')\"><img src=./../../../images/QDWN.svg></div></div><label>Date & Time</label></div></th></tr></thead><tbody><tr ng-repeat=\"question in userQuestions\" :id={{$index}} ng:class=\"{ \'unassigned-color\' : !question.assigned_to ,\'answered-color\' : question.is_answered ,\'unanswered-color\' : (!question.is_answered && question.assigned_to),\'new-question\' : (newQuestion && $index == 0) }\"><td><p ng-if=\"question.assigned_to && !question.is_answered\"><!-- {{question.assigned_to != null ? \"Assigned to \" +\n                  question.assigned_to_user_full_name : \"Unanswered\" }} --> Assigned to {{question.assigned_to_user_uid}} <img style=\"cursor: pointer\" ng-click=\"assignToInstructor(question,\'update\')\" src=./../../../images/admin_edit_inst.svg></p><p ng-if=question.is_answered><!-- {{question.assigned_to != null ? \"Assigned to \" +\n                  question.assigned_to_user_full_name : \"Unanswered\" }} --> Answered by {{question.answers[0].answered_by.uid}}</p><button class=assign-admin-btn ng-click=assignToInstructor(question) ng-if=\"!question.assigned_to && !question.is_answered\">Assign To Instructor</button></td><td><!-- <td>{{question.is_answered != null ? question.is_answered : \"Unanswered\" }}</td> --><!-- <p ng-if=\"question.is_answered\">\n                  {{question.is_answered != null ? \"Answered\": \"Unanswered\" }}\n                </p> --> <button class=assign-admin-btn ng-click=viewAnswer(question,question.answer_media_link) ng-if=\"question.is_answered != null \" style=\"margin: 0 auto;background-color: #0b99e9\">View Answer</button> <button class=assign-admin-btn ng-click=answerStudent(question) ng-if=\"question.is_answered == null\" style=\"margin: 0 auto;background-color: #0b99e9\">Send Answer</button></td><td>{{question.user_id}}</td><td>{{question.user_full_name}}</td><td class=question-email-cell>{{question.user_email_primary}}</td><td>{{question.user_phone}}</td><td>{{question.tag_name != null ? question.tag_name : \'N/A\'}}</td><td class=question-view-td><button class=question-view ng-click=viewQuestion(question.id,question.question_text,question.question_media_link)>View</button></td><td><div ng-if=\"question.answers.length > 0\"><div style=\"display: flex;flex-direction: row;justify-content: center\" ng-if=question.answers[0].rating title={{question.answers[0].rating_description}}><p ng-repeat=\"i in getNumber(question.answers[0].rating) track by $index\"><img src=./../../../images/gold_star.svg style=\"width: 18px;height: 18px\"></p></div><p ng-if=\"question.answers[0].rating == null\">N/A</p><!-- <p ng-else>N/A</p> --></div><p ng-if=\"question.answers.length === 0\">N/A</p></td><td>{{question.user_gender != null ? question.user_gender : \'N/A\'}}</td><td>{{question.created_at | date:\'short\'}}</td><!-- <td>{{question.created_at | date:\'mediumDate\'}}</td> --><!-- class=\"question-view-td\" --></tr></tbody></table><h3 style=\"display: flex;\n        justify-content: center\" ng-if=noData>No Relevant Data Found!</h3></div><div ng-if=\"showData && totalPageCount > 1\" class=pagination-main><div class=inner-pagination><div class=q-left-arrow ng-show=\"currentPage != 1\" ng-click=\"pageChange(currentPage - 1)\"><img src=./../../../images/insLeft.svg></div><div class=question-pagination><p class=q-page ng-click=pageChange(pageTag) ng-repeat=\"pageTag in pageArr\" ng:class=\"{ \'q-page-selected\' : currentPage === pageTag }\" ng-show=\"pageTag <= totalPageCount\">{{pageTag}}</p><!-- <p class=\"q-page\" ng-click=\"pageChange()\">2</p> --></div><div class=q-right-arrow ng-show=\"currentPage != totalPageCount\" ng-click=\"pageChange(currentPage + 1)\"><img src=./../../../images/insRight.svg></div></div></div></div></div></div><div class=display-question-container ng-if=\"displayQuestion || displayAnswer\"><div class=display-question><img ng-click=closeQuestion() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1 ng-if=displayQuestion>Question</h1><h1 ng-if=displayAnswer>Answer</h1></div><div class=question-sec><div class=question-text-div><p ng-if=!containsLinks>{{selectedQuestion}}</p><div ng-if=containsLinks ng-bind-html=selectedQuestion></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && !isYoutube\"><img ng-if=\"notAvideo && !isPDF\" ng-click=previewEnlargedImage(selectedQuestionImage) style=\"cursor: pointer\" src={{selectedQuestionImage}} onloadeddata=angular.element(this).scope().imageLoadCheck() onload=angular.element(this).scope().imageLoadCheck()> <img src=images/squares.gif ng-show=imageshowloader><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup><button ng-if=\"notAvideo && !isPDF\" class=question-view ng-click=\"displayQuestion ? previewEnlargedImage(selectedQuestionImage,question) : previewEnlargedImage(selectedQuestionImage,answer) \">Preview Image</button> <a ng-if=\"notAvideo && isPDF\" class=question-view href={{selectedQuestionImage}} target=_blank>Download File</a></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><!-- <iframe width=\"420\" height=\"315\" ng-src=\"{{selectedAnswerImage}}\" allowfullscreen frameborder=\"0\">\n          </iframe> --><iframe width=420 height=315 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div></div></div></div></div><div class=display-question-container ng-click=closePreviewImage(); ng-if=imagePreview><div><img ng-click=\"closePreviewImage(); $event.stopPropagation();\" src=./../../../images/Icon-Close-black.svg style=\"position: absolute;\n  top: 14px;\n  right: 18px;\n  background: white;\n  border-radius: 11px\"> <img ng-click=$event.stopPropagation(); class=image-preview src={{previewImage}}></div></div><div class=display-question-container style=\"width: 99%\" ng-if=assignInstructor><div class=display-question style=\"height: 300px\"><img ng-click=closeInstructor() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question style=\"justify-content: center\"><div class=question-head><h1>Assign To Instructor</h1></div><div class=admin-question-dropdown><!-- <button ng-click=\"adminSearchDrop()\" class=\"admin-dropbtn\">\n          Dropdown\n        </button> --><div class=question-sec ng-click=adminSearchDrop() class=admin-dropbtn><div class=question-text-div><div class=custom-assign-div><img src=./../../../images/userHead.svg> <input type=text placeholder=Search.. id=myInput ng-model=findInstructor ng-keyup=filterFunctionAdmin() ng-if=!selected autocomplete=off> <input type=text placeholder=Search.. id=myInput ng-model=instText ng-keyup=filterFunctionAdmin() ng-if=selected autocomplete=off><!-- <p ng-if=\"selected\">{{instText}}</p> --></div><div id=myDropdown class=admin-dropdown-content><!-- ng-model=\"findInstructor\" --><label ng-click=selectInstructor(inst) ng-repeat=\"inst in listofInstructors\">{{inst.email ? inst.email : inst.full_name}}</label></div></div></div><div class=custom-assign-div style=\"margin: 15px 0px\"><button class=assign-admin-btn style=\"width: 150px;\n              font-size: 15px;\n              display: flex;\n              justify-content: center;\n              padding: 7px\" ng-click=assignCall()><span ng-if=toUpdateInstructor>Update</span> <span ng-if=!toUpdateInstructor>Assign</span></button></div></div></div></div></div><div class=display-question-container ng-if=answerQuestion><div class=display-question><img ng-click=closeAnswerWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1>Write your answer</h1></div><div class=question-sec><div class=question-text-div style=\"display: flex; justify-content: center;flex-direction: column;align-items: center\"><label style=\"font-size: 12px;    display: flex;\n        align-items: center\"><img style=\"width: 18px;\n          height: 18px;margin-right: 5px\" src=./../../../images/infoQU.svg> You can paste pdf links , google drive links and any reference links in the box below.</label><textarea style=\"max-height: 300px;\n    min-height: 100px;\n              width: 85% !important;\n              margin: 8px 10px 25px 10px;\n              border: 1px solid #EAEAEA\" ng-model=answerText placeholder=\"Enter your answer here\">\n          </textarea></div><div ng-if=\"selectedAnswerImage && !isYoutube\" class=question-image><a ng-if=\"notAvideo && isPDF\" href={{selectedQuestionImage}} target=_blank style=\"display: flex; flex-direction: column; align-items: center\"><img style=\"width: 45px; height: 45px; margin-bottom: 8px\" src=./../../../images/newspaper-svgrepo-com.svg> {{fileName}}</a> <img ng-if=\"notAvideo && !isPDF\" src={{selectedAnswerImage}}><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup></div><div ng-if=\"selectedAnswerImage && isYoutube\"><iframe width=420 height=315 src={{selectedAnswerImage}}></iframe></div><div ng-if=!selectedAnswerImage style=\"display: flex; justify-content: center\"><div class=\"dropdown show\" style=\"border: 1px solid #eaeaea; width: 200px\"><label style=\"width: 100%; display: flex; justify-content: space-between\" ng-click=handleOptions() class=\"btn btn-secondary dropdown-toggle\" href=# role=button id=dropdownMenuLink data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{defaultDropDown}} <img style=\"margin-left: 5px\" src=./../../../images/commentarrows.svg></label><!-- class=\"dropdown-menu\" --><div style=\"display: flex;\n                flex-direction: column;\n                border: 1px solid #eaeaea;\n                padding: 6px 12px;\n                background: white;\n                position: absolute;\n                width: 200px\" ng-if=showOptions aria-labelledby=dropdownMenuLink><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Video Link\')\">Video Link</label><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Upload through System\')\">Upload through System</label></div></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><iframe width=350 height=220 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div><div class=\"flex-view flex-direction-row-col\" style=\"justify-content: space-evenly; padding: 15px\"><input ng-if=fileUploadSelected type=file id=imageUpload accept=image/*,video/*,application/pdf,.doc,.docx,application/msword,.xls ng-model=selectedImageAnswer style=\"visibility: hidden;  width: 100px\" onchange=angular.element(this).scope().onImageSelected(event)><!-- position: absolute; --><label ng-if=fileUploadSelected style=\"background: #d4165a;\n              color: white;\n              padding: 8px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex\" for=imageUpload>Attach Image/Video/PDF</label><input type=text ng-model=videoLink placeholder=\"Paste Youtube Link\" ng-show=linkUpload style=\"border: 1px solid #eaeaea ; margin-left: 20px\" ng-paste=youtubePreview($event)><!-- onblur=\"angular.element(this).scope().youtubePreview(event.target.value)\" --><div ng-if=imageLoad><img style=\"height: 40px\" src=images/squares.gif></div><button class=assign-admin-btn style=\"display: flex; align-items: center\" ng-click=\"imageLoad ? \'\' : sendAnswer(answerText,videoLink)\"><!-- <span  >Uploading</span> --> <span>Send Answer</span></button></div></div></div></div></div>");
$templateCache.put("app/admin/questionsMarket/questionsMarket.html","<admin-header statename=\"Question Market\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Question Market:</h2></div><div class=container-fluid><div class=row><div ng-repeat=\"tag in courseTags\" ng-click=editTag(tag.id) class=\"col-md-2 col-sm-2 col-xs-12\"><p class=tagsSpan>{{tag.name}}</p></div></div></div><div class=container-fluid><div style=\"margin: 30px 0\"><button style=\"padding: 0 20px;\n            background: #D29696;\n            border: 1px solid gray;\n			border-radius: 5px\" ng-click=\"goToState(\'addMarket\')\">Add more Market</button></div></div></div>");
$templateCache.put("app/admin/promOpenAI/promOpenAI.html","<admin-header statename=\"Prom open AI config\"></admin-header><div><span style=\"float: right\"><button type=button class=\"btn btn-default primary_btn\" ng-click=addSession()>Add Course config</button></span> <span style=\"float: right; margin-right: 10px\"><button type=button class=\"btn btn-default primary_btn\" ng-click=addCourseConfig()>Add Niche config</button></span><div class=responsive-table><table class=table><colgroup><col class=col-xs-8><col class=col-xs-4></colgroup><thead><tr><th><p class=\"pTag table_th\" style=\"text-align: left\">Course Name</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in promptConfigs\"><td><p class=pTag style=\"text-align: left\">{{config.course_id.name}}</p></td><td style=\"text-align: right\"><button class=\"btn btn-default\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" ng-click=deleteConfig(config)>Delete</button> <button class=\"btn btn-default\" ng-click=addModule(config)>Add Module Config</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/quizConfigurations/quizConfigurations.html","<admin-header statename=\"Quiz Configurations\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><!-- <div class=\"pull-left\">\n    <input type=\"text\" placeholder=\"Type Here For Search\" ng-model=\"refNo\" ng-change=\"refNo.length> 3 ? searchOrder(refNo,\'refNo\'):null\"\n      class=\"form-control\" />\n  </div> --><div class=pull-right><a ui-sref=AdminQuizConfigurationCreate() class=\"btn btn-default primary_btn\">Create Configurations</a></div></div><div class=col-md-12><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>Name</th><th class=text-center>Total Questions</th><th class=text-center>Total Added tags</th><th class=text-center>Time limit</th><th class=text-center>Niche</th><th class=text-center>Delete</th><th class=text-center>Edit</th></tr></thead><tbody><tr ng-repeat=\"order in bundles\"><td>{{order.name}}</td><td>{{order.total_questions}}</td><td>{{order.sw_tags_distribution.length}}</td><td>{{order.time_limit}}</td><td>{{order.tag_id.name}}</td><td><button class=\"btn btn-primary table-btn\" ng-click=deleteBundle(order._id)>Delete</button></td><td><a class=\"btn btn-primary table-btn\" ui-sref=\"AdminQuizConfigurationEdit({id: order._id})\">Edit</a></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/recommendationBanners/recommendationBanners.html","<admin-header statename=\"Recommendation Banners\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"><!-- <label>Search</label>\n    <input\n      type=\"text\"\n      placeholder=\"Search Link\"\n      ng-model=\"userKeySearch\"\n      class=\"form-control\"\n    />\n    <div style=\"margin-top: 10px;\">\n      <button class=\"btn btn-primary text-light\" style=\"color: white;\" ng-click=\"searchLinks()\">Search</button>\n      <button class=\"btn btn-primary text-danger\" style=\"color: white;\" ng-click=\"clearFilter()\">Reset</button>\n    </div> --></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Add Banner</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content style=\"width: 400px\"><div class=modal-body style=\"min-height: 440px\"><div class=col-md-12><div class=form-group><label>Title</label><input type=text placeholder=Title ng-model=title class=form-control></div><div class=form-group><label>Description</label><input type=text placeholder=Description ng-model=description class=form-control></div><div class=form-group style=\"display: flex\"><div><input type=file id=imageUpload accept=image/* ng-model=selectedImageAnswer style=\"visibility: hidden; width: 100px\" onchange=angular.element(this).scope().onImageSelected(event)><!-- position: absolute; --><label style=\"background: grey;\n                  color: white;\n                  border-radius: 5px;\n                  font-size: 13px;\n                  display: flex;\n                  width: 120px;\n                  height: 30px;\n                  justify-content: center;\n                  align-items: center\" for=imageUpload>Upload Image</label></div><div><img ng-if=imageLoading style=\"height: 40px; margin-top: 17px\" src=images/squares.gif><p style=\"height: 40px; margin-top: 30px; margin-left: 10px\" ng-if=\"imageLoadingStatus && !imageLoading\">{{imageLoadingStatus}}</p></div></div><!-- <div\n              class=\"form-group\"\n              style=\"display: flex; justify-content: space-around\"\n            >\n            <label>\n              <input type=\"radio\" ng-model=\"redirectType\" value=\"link\" />\n              Link </label\n            ><br />\n            <label>\n              <input type=\"radio\" ng-model=\"redirectType\" value=\"course\" />\n              Course </label\n            ><br />\n            <label>\n              <input type=\"radio\" ng-model=\"redirectType\" value=\"module\" />\n              Module </label\n            ><br />\n            <label>\n              <input type=\"radio\" ng-model=\"redirectType\" value=\"video\" />\n              Video </label\n            ><label>\n              <input type=\"radio\" ng-model=\"redirectType\" value=\"quiz\" />\n              Quiz </label\n            ><br />\n          </div> --><div class=form-group><label>Banner For:</label><select ng-change=showCoupons(1,sortType) ng-model=bannerFor><option value=mobile selected>Mobile</option><option value=web selected>Web</option><option value=both selected>Both</option></select></div><div class=form-group><label>Niche:</label><select ng-change=showCoupons(1,sortType) ng-model=selectedTag><option value=all selected>All</option><option ng-repeat=\"tag in tags\" value={{tag.id}}>{{tag.name}}</option></select></div><div class=form-group ng-if=\"redirectType !== \'link\'\"><label>Select {{redirectType}}</label><input type=text placeholder=\"{{selected_name ? selected_name : \'Search \'+redirectType}}\" ng-model=userKey ng-change=\"userKey.length > 2 ? getInfo(userKey) : null\" class=form-control><ul ng-if=\"listData.length > 0\" class=list-group style=\"z-index: 999; border-top-left-radius: 4px;\n              border-top-right-radius: 4px; border-bottom: 1px solid #ddd; max-height: 220px\"><li ng-click=addVariants(data) class=list-group-item ng-repeat=\"data in listData\">{{data.name}}</li></ul></div><div class=form-group ng-show=\"redirectType === \'link\'\"><label>Enter Redirect Link</label><input type=text placeholder=\"Enter Redirect Link\" ng-model=redirectLink id=redirectLink class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=addUserDownloadConfig() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Title</p></th><th><p class=\"pTag table_th\">Description</p></th><th><p class=\"pTag table_th\">Niche Tag</p></th><th><p class=\"pTag table_th\">Image</p></th><th><p class=\"pTag table_th\">Status</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"banner in links \"><td><p class=pTag>{{banner.title}}</p></td><td><p class=pTag style=\"max-width: 200px\">{{banner.description}}</p></td><td><p class=pTag style=\"max-width: 200px\">{{banner.tag_id ? banner.tag_id.name : \'ALL\'}}</p></td><td><p class=pTag><img style=\"height: 60px\" src={{banner.image_url}}></p></td><td><p ng-if=!banner.disabled class=pTag style=color:green>Active</p><p ng-if=banner.disabled class=pTag style=color:red>Disabled</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateRedirectLink(banner) data-toggle=modal data-target=#myModal>Update</button> <button class=\"btn btn-default\" ng-click=deleteRedirectLink(banner)>{{banner.disabled ? \'Enable\' : \'Disable\'}}</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/redirectLinks/redirectLinks.html","<admin-header statename=\"Redirect Links\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"><label>Search</label><input type=text placeholder=\"Search Link\" ng-model=userKeySearch class=form-control><div style=\"margin-top: 10px\"><button class=\"btn btn-primary text-light\" style=\"color: white\" ng-click=searchLinks()>Search</button> <button class=\"btn btn-primary text-danger\" style=\"color: white\" ng-click=clearFilter()>Reset</button></div></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Add Link</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 210px\"><div class=col-md-12><div class=form-group><label>Name</label><input type=text placeholder=Name ng-model=name class=form-control></div><div class=form-group><label>Redirect Link</label><input type=text placeholder=http://samplelink.com ng-model=redirect_link class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=addUserDownloadConfig() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Redirect Link</p></th><th><p class=\"pTag table_th\">Hits Count</p></th><th><p class=\"pTag table_th\">Platforms</p></th><th><p class=\"pTag table_th\">App Link</p></th><th><p class=\"pTag table_th\">Disable Downloads</p></th></tr></thead><tbody><tr ng-repeat=\"link in links \"><td><p class=pTag>{{link.name}}</p></td><td><p class=pTag style=\"max-width: 200px\">{{link.redirect_link}}</p></td><td><p class=pTag>{{link.hits_count}}</p></td><td><p class=pTag v-if=link.redirect_referers>Facebook: {{link.redirect_referers.facebook || 0}} | Direct: {{link.redirect_referers.direct || 0}} | Twitter: {{link.redirect_referers.twitter || 0}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=copylink(link)>Copy Link</button></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateRedirectLink(link) data-toggle=modal data-target=#myModal>Update</button> <button class=\"btn btn-default\" ng-click=deleteRedirectLink(link)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/reports/reports.html","<admin-header statename=\"Welcome to Nearpeer Reporting\"></admin-header><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"filter-datepicker clearfix mb-50\"><div class=\"col-sm-12 col-md-8 col-lg-8 padding0\"><div class=\"col-xs-12 col-md-6 col-lg-6 course-dropdown\"><div layout-gt-xs=row><div flex-gt-xs><label for=to>From:</label><md-datepicker ng-model=fromDate md-placeholder=\"Set Date\"></md-datepicker></div></div></div><div class=\"col-xs-12 col-md-3 col-lg-3\"><div layout-gt-xs=row><div flex-gt-xs><label for=from>To:</label><md-datepicker ng-model=toDate md-placeholder=\"Set Date\"></md-datepicker></div></div></div><div class=\"col-xs-12 col-md-3 col-lg-3\"><button type=button class=\"btn btn-primary\" ng-click=getReports()>Show</button></div></div></div><div class=\"col-md-12 col-lg-12 blocks-holder\"><canvas id=bar class=\"chart chart-bar\" chart-data=data chart-labels=labels chart-series=series></canvas><div ng-repeat=\"(day, value) in reportData\" style=\"margin-top: 20px; border-bottom: 1px solid gray\"><h3>Report for: {{day}}</h3><div class=tableCell><table id=expectedTable border=1 cellpadding=3 cellspacing=0><tr><th>Tag</th><th>Total Revenue:</th><th>Total Paid Customers:</th><th>Repeat Customers:</th><th>Total Courses Sold:</th><th>Total Module Sold:</th><th>Unique Courses Sold:</th><th>Unique Module Sold:</th><th>Total Signups:</th><th>Total Signup Landing:</th><th>Total Enrollments:</th><th>Total Promo Codes Used:</th><th>Promos used by individual user</th></tr><tr ng-repeat=\"(key, reportTag) in value\"><td>{{reportTag[\'tag\']}}</td><td>{{reportTag[\'earning\'] || 0}}</td><td>{{reportTag[\'users\']}}</td><td>{{reportTag[\'repeatUsers\']}}</td><td>{{reportTag[\'courseSold\']}}</td><td>{{reportTag[\'moduleSold\']}}</td><td>{{reportTag[\'courseSoldUnique\']}}</td><td>{{reportTag[\'moduleSoldUnique\']}}</td><td>{{reportTag[\'signupCount\']}}</td><td>{{reportTag[\'signupLandingCount\']}}</td><td>{{reportTag[\'enrollments\']}}</td><td>{{reportTag[\'couponOrders\']}}</td><td>{{reportTag[\'userCouponOrders\']}}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/admin/seoTag/seoTag.html","<admin-header statename=\"SEO Tags\"></admin-header><div class=form-area><form><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Title</label><input type=text class=form-control ng-model=tagForm.title></div></div><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>identifier</label><input type=text class=form-control ng-model=tagForm.identifier></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Description</label><input type=text class=form-control ng-model=tagForm.description></div></div><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>URL</label><input type=text class=form-control ng-model=tagForm.url></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Image URL</label><input type=text class=form-control ng-model=tagForm.image_url></div></div></div></div><div class=col-md-12><button ng-click=submit(tagForm) class=\"btn btn-default primary_btn\">Save</button></div></form></div><div class=\"col-xs-12 col-md-12 mb-30\"><div class=\"col-xs-12 col-md-6 padding0\"><div class=form-group><input type=text placeholder=\"Search Here ...\" class=form-control ng-model=query ng-change=\"query.length> 1 ? searchTag(query):pageTag(1,12)\"></div></div><div class=\"col-xs-12 col-md-6 text-right\"><div class=\"col-md-3 col-md-offset-7\"><span>{{viewTag}} out of {{totalTags}}</span></div><nav aria-label=... ng-hide=hidePagination class=\"col-md-2 padding0\" aria-hidden=false><ul class=\"pagination pull-right\" style=\"margin: -6px 0 0\"><li class=previous><a href=\"\" ng-click=\"page> 0 ? pageTag(page-1,12):null\"><span aria-hidden=true>&lt;</span></a></li><li class=next><a href=\"\" ng-click=pageTag(page+1,12)><span aria-hidden=true>&gt;</span></a></li></ul></nav></div></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-3\" ng-repeat=\"tag in tags\"><div class=\"form-group holder\"><span>{{tag.title | limitTo : 20 }} {{tag.title.length > 20 ? \'...\' : \'\'}}</span><div class=\"pull-right actions\"><a ng-click=\"editTag(tag,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=\"editTag(tag,\'del\')\" class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div>");
$templateCache.put("app/admin/session/session.html","<admin-header statename=\"Order Sessions\"></admin-header><div><span style=\"float: right\"><button type=button class=\"btn btn-default primary_btn\" ng-click=addSession()>Add Session</button></span><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Session Name</p></th><th><p class=\"pTag table_th\">Start Date</p></th><th><p class=\"pTag table_th\">End Date</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"session in sessions | filter: search \"><td><p class=pTag>{{session.name}}</p></td><td><p class=pTag>{{session.start_date}}</p></td><td><p class=pTag>{{session.end_date}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editSession(session)>Edit</button> <button class=\"btn btn-default\" ng-click=deleteSession(session)>Delete</button> <button class=\"btn btn-default\" ng-click=terminateOrders(session)>Terminate Orders</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/sms/SendBulkSMS.html","<admin-header statename=SMS></admin-header><div style=\"margin: 0 30px\"><div><div style=\"display: flex; flex-direction: row; margin-bottom: 30px; align-items: center\"><div><h3 style=\"font-weight: bold; color: #172352\">Upload XLSX File</h3><input type=file import-sheet-js=\"\" accept=.xlsx on-sheet-load=loadWorksheet(e) multiple></div><a style=\"margin-left: 60px\" href=https://nearpeer-zips.s3.amazonaws.com/module1893/video17018/sample-number.xlsx>Download Sample XLSX</a></div><h3 style=\"font-weight: bold; color: #172352\">To</h3><tags-input placeholder=\"Add Mobile Numbers Ex: 923******* and press TAB to enter another number\" on-tag-adding=numbercheck($tag) on-tag-removed=removeTag($tag) add-on-comma=true add-on-enter=true ng-model=toNumbers></tags-input><h3 style=\"font-weight: bold; color: #172352\">Message</h3><div class=clearfix></div><div><textarea ng-model=content style=\"padding-bottom: 10px;\n          width: 800px;\n          min-height: 400px;\n          margin-bottom: 20px;\n          margin-top: 20px\"></textarea></div><div class=clearfix></div><button class=\"btn btn-default\" style=\"margin-bottom: 50px\" ng-click=sendMessage()>Send</button></div></div>");
$templateCache.put("app/admin/soundBoost/soundBoost.html","<admin-header statename=\"Sound Boosted Course\"></admin-header><div><div style=\"padding: 30px 0; color: #04044d\"><h2>Welcome to Sound Boosted Course :</h2></div><div class=container style=\"margin: 20px 0px; max-width: 600px; padding-left: 0px\"><div class=row><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution) style=\"width: 150px; margin: 5px 0; border: 1px solid black\"><option value=\"Select Institution\">Select Institute</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedSchool ng-change=updateSchool(selectedSchool) style=\"width: 150px; margin: 5px 0; border: 1px solid black\"><option value=\"Select Faculty\">Select Faculty</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedCourse ng-change=boostCourseSound(selectedCourse) style=\"width: 150px; margin: 5px 0; border: 1px solid black\"><option value=\"Select Course\">Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><div class=container-fluid><div class=row><table class=table><thead><tr><th>Course Name</th><th>remove</th></tr></thead><tbody><tr ng-repeat=\"course in coursess\"><td>{{course.name}}</td><td><button class=\"btn btn-danger\" ng-click=\"unBoostCourseSound($index, course.id)\">X</button></td></tr></tbody></table><div ng-repeat=\"course in courses\"><!-- <h1>hello</h1> --></div><!-- <div\n        ng-repeat=\"tag in courseTags\"\n        ng-click=\"editTag(tag.id)\"\n        class=\"col-md-2 col-sm-2 col-xs-12\"\n      >\n        <p class=\"tagsSpan\">{{tag.name}}</p>\n      </div> --></div></div><!-- <div class=\"container-fluid\">\n    <div style=\"margin: 30px 0\">\n      <button\n        style=\"\n          padding: 0 20px;\n          background: #d29696;\n          border: 1px solid gray;\n          border-radius: 5px;\n        \"\n        ng-click=\"goToState(\'addCourseTag\')\"\n      >\n        Add more Tags\n      </button>\n    </div>\n  </div> --></div>");
$templateCache.put("app/admin/stories/create-story.html","<admin-header statename=\"create story\"></admin-header><div class=container><!-- <div class=\"create-story-admin\">\n    <div class=\"create-story-title\">\n      <div class=\"form-group\">\n        <label for=\"storyTitle\">Story Title</label>\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          id=\"storyTitle\"\n          placeholder=\"Please enter story title\"\n        />\n      </div>\n    </div>\n    <tags-input ng-model=\"tags\"></tags-input>\n\n    <div class=\"story-admin-main\"></div>\n  </div> --><div class=row><div class=col-md-12><div class=\"col-md-12 mb-20\"><div class=\"col-md-6 padding0\"><div class=uploadlgBox><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i> </span><!-- <input id=\"inputImage\" type=\"file\" accept=\"image/*\" image=\"image1\" resize-max-height=\"800\" \n            resize-max-width=\"800\" resize-quality=\"0.7\" resize-type=\"image/jpg\" ng-image-compress /> --><div class=loader ng-if=uploadingLoader style=\"position: absolute; inset: 0; margin: 0; display: grid; place-items: center\"><img src=images/squares.gif></div><input type=file id=inputImage accept=video/*,image/* resize-max-height=400 resize-max-width=400 resize-quality=0.7 resize-type=video/mp4,image/jpg ng-image-compress image=image1 ng-model=im ngf-select=uploadImageMain(image1)> <img class=uploaded_image src={{image_url}} alt=\"\"> <span ng-if=!image_url class=upload>Upload Image</span></div></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><div class=form-group><label for=storyTitle>Story Title</label><input type=text class=form-control id=storyTitle ng-model=title placeholder=\"Please enter story title\" maxlength=73><p ng-if=\"title.length>72\" style=color:red>Length cannot be greater than 72</p></div></div><div class=\"col-md-12 mb-20 padding0\"><div class=\"col-md-4 padding0\"><div class=form-group><label for=storyDescription>Story Description</label><input type=text class=form-control id=storyDescription ng-model=description placeholder=\"Please enter story description\"></div></div><div class=col-md-4></div><div class=\"col-md-4 padding0\"><div class=form-group><label for=sel1>Display story</label><select class=form-control ng-model=display><option>Public (all user if not logedin as well)</option><option>Registered User</option></select></div></div></div><div ng-if=\"display && display==\'Registered User\'\"><!-- story for a specific category --><div class=\"publish form-group mt-10\"><span>Story for specific tags</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-click=tagFlag() ng-model=specificTag ng-click=changeTag()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=\"col-md-4 padding0\" ng-if=specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=selectedTags></div></div></div><!-- story for a specific course --><div class=\"publish form-group mt-10\"><span>Story for specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-click=courseFlag() ng-model=specificCourseFlag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=specificCourseFlag><div><div class=form-group><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=course-list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div></div></div><!-- <div class=\"col-md-12 mb-20\">\n        <div class=\"form-group\">\n          <label for=\"storyTitle\">Story Description</label>\n          <textarea\n            ng-model=\"bundle.description\"\n            placeholder=\" Add Description \"\n            class=\"form-control\"\n            rows=\"7\"\n          ></textarea>\n        </div>\n      </div> --><div class=col-md-12><div class=\"form-group col-md-12 mb-20 padding0\"><label>Story available time</label><div class=business-request-date><div class=businnes-request-date-from style=\"padding-left: 0; display: block\" for=buinessRequestDateFrom><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">Start Time:</label><input type=datetime-local name=buinessRequestDateFrom id=buinessRequestDateFrom ng-model=todate placeholder=\"\"><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><div class=business-request-date-to style=\"padding-left: 0; display: block\" for=buinessRequestDateTo><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">End Time:</label><input type=datetime-local name=buinessRequestDateTo id=buinessRequestDateTo placeholder=\"\" ng-model=valid_till><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div></div><!-- <input\n            class=\"form-control\"\n            type=\"number\"\n            ng-model=\"valid_till\"\n            placeholder=\"Story available hours\"\n          /> --></div><!-- <div class=\"mb-20\">\n          <tags-input ng-model=\"tags\"></tags-input>\n        </div> --><div class=\"col-md-12 padding0\"><input type=checkbox ng-model=comment_allowed> Comments allow<br><br></div><div class=\"col-md-12 padding0\"><input type=checkbox ng-model=social_media_sharing> Story shareable on socialmedia<br><br></div></div><div class=\"col-md-12 mb-20\"><button class=\"btn btn-default secondry_btn\" ng-click=addStory()>Save</button></div></div></div></div><div class=video-trim><div class=video-trim-wrapper><player class=player></player></div></div>");
$templateCache.put("app/admin/stories/edit-story.html","<admin-header statename=\"edit story\"></admin-header><div class=container><!-- <div class=\"create-story-admin\">\n    <div class=\"create-story-title\">\n      <div class=\"form-group\">\n        <label for=\"storyTitle\">Story Title</label>\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          id=\"storyTitle\"\n          placeholder=\"Please enter story title\"\n        />\n      </div>\n    </div>\n    <tags-input ng-model=\"tags\"></tags-input>\n\n    <div class=\"story-admin-main\"></div>\n  </div> --><div class=row><div class=col-md-12><div class=\"col-md-12 mb-20\"><div class=\"col-md-6 padding0\"><div class=uploadlgBox><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i> </span><!-- <input id=\"inputImage\" type=\"file\" accept=\"image/*\" image=\"image1\" resize-max-height=\"800\" \n            resize-max-width=\"800\" resize-quality=\"0.7\" resize-type=\"image/jpg\" ng-image-compress /> --><div class=loader ng-if=uploadingLoader style=\"position: absolute; inset: 0; margin: 0; display: grid; place-items: center\"><img src=images/squares.gif></div><input type=file id=inputImage accept=video/*,image/* resize-max-height=400 resize-max-width=400 resize-quality=0.7 resize-type=video/mp4,image/jpg ng-image-compress image=image1 ng-model=im ngf-select=uploadImageMain(image1)> <img class=uploaded_image src={{image_url}} alt=\"\"> <span ng-if=!image_url class=upload>Upload Image</span></div></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><div class=form-group><label for=storyTitle>Story Title</label><input type=text class=form-control id=storyTitle ng-model=title placeholder=\"Please enter story title\" maxlength=73><p ng-if=\"title.length>72\" style=color:red>Length cannot be greater than 72</p></div></div><div class=\"col-md-12 mb-20 padding0\"><div class=\"col-md-4 padding0\"><div class=form-group><label for=storyDescription>Story Description</label><input type=text class=form-control id=storyDescription ng-model=description placeholder=\"Please enter story description\"></div></div><div class=col-md-4></div><div class=\"col-md-4 padding0\"><div class=form-group><label for=sel1>Display story</label><select class=form-control ng-model=display><option>Public (all user if not logedin as well)</option><option>Registered User</option></select></div></div></div><div ng-if=\"display && display==\'Registered User\'\"><!-- story for a specific category --><div class=\"publish form-group mt-10\"><span>Story for specific tags</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-click=tagFlag() ng-model=specificTag ng-click=changeTag()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=\"col-md-4 padding0\" ng-if=specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=selectedTags></div></div></div><!-- story for a specific course --><div class=\"publish form-group mt-10\"><span>Story for specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-click=courseFlag() ng-model=specificCourseFlag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=specificCourseFlag><div><div class=form-group><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=course-list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div></div></div><!-- <div class=\"col-md-12 mb-20\">\n        <div class=\"form-group\">\n          <label for=\"storyTitle\">Story Description</label>\n          <textarea\n            ng-model=\"bundle.description\"\n            placeholder=\" Add Description \"\n            class=\"form-control\"\n            rows=\"7\"\n          ></textarea>\n        </div>\n      </div> --><div class=col-md-12><div class=\"form-group col-md-12 mb-20 padding0\"><label>Story available time</label><div class=business-request-date><div class=businnes-request-date-from style=\"padding-left: 0; display: block\" for=buinessRequestDateFrom><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">Start Time:</label><input type=datetime-local name=buinessRequestDateFrom id=buinessRequestDateFrom ng-model=todate placeholder=\"\"><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><div class=business-request-date-to style=\"padding-left: 0; display: block\" for=buinessRequestDateTo><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">End Time:</label><input type=datetime-local name=buinessRequestDateTo id=buinessRequestDateTo placeholder=\"\" ng-model=valid_till><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div></div><!-- <input\n            class=\"form-control\"\n            type=\"number\"\n            ng-model=\"valid_till\"\n            placeholder=\"Story available hours\"\n          /> --></div><!-- <div class=\"mb-20\">\n          <tags-input ng-model=\"tags\"></tags-input>\n        </div> --><div class=\"col-md-12 padding0\"><input type=checkbox ng-model=comment_allowed> Comments allow<br><br></div><div class=\"col-md-12 padding0\"><input type=checkbox ng-model=social_media_sharing> Story shareable on socialmedia<br><br></div></div><div class=\"col-md-12 mb-20\"><button class=\"btn btn-default secondry_btn\" ng-click=updateStory()>Update</button></div></div></div></div><div class=video-trim><div class=video-trim-wrapper><player class=player></player></div></div>");
$templateCache.put("app/admin/stories/stories.html","<admin-header statename=Stories></admin-header><div class=story-admin><div class=create-stroy-btn></div><div class=story-admin-header><div><div class=story-admin-search><input type=text name=businessRequestSearch id=businessRequestSearch placeholder=\"Search Story here\" ng-model=storySearch></div><button type=button class=\"btn btn-default secondry_btn\" ng-click=getSearch()>Search</button> <button type=button class=\"btn btn-default secondry_btn\" ng-click=clearSearch()>Clear</button></div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'create-story\')\">Create story</button></div><div class=loader ng-if=!stories><img src=images/squares.gif></div><div class=story-admin-main><div class=row><div infinite-scroll=loadMore() infinite-scroll-distance=1><div class=col-md-4 ng-repeat=\"story in stories\"><!-- <div class=\"story-card\" ng-if=\"story.is_disabled == true\" ng-class=\"{ disableStory: true }\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img  src={{story.thumbnail}} alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\" ng-if=\"story.is_disabled == false\" ng-click=\"disableStories(story.id)\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\" ng-if=\"story.is_disabled == true\" ng-click=\"enableStories(story.id)\"><img src=\"../../../images/nearpeer-story/admin/enable.png\" alt=\"\"></a>\n                      \n                      <a href=\"\" ng-click=\"deleteStories(story.id)\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>{{story.title}}</h3>\n                <button class=\"btn btn-default primary_btn\" ng-click=\"storyDetail(story.id)\">view story</button>\n              </div>\n              <div class=\"story-card-disable\">\n\n              </div>\n            </div> --><div class=story-card><div class=story-card-body><div class=story-card-image><!-- <img ng-if=\"!story.image\" src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\"> --> <img src={{story.thumbnail}} alt=\"\"><div class=story-card-image-overlay><div class=story-action-btn><a href=\"\" title=\"Niche based configuration enabled\" ng-if=\"story.is_configured==true\"><img src=../../../images/nearpeer-story/admin/configuration.png alt=\"\"></a><a href=\"\" title=\"Public Story\" ng-if=\"story.stories_display_to==\'public\'\"><img src=../../../images/nearpeer-story/admin/public.png alt=\"\"></a><a href=\"\" title=\"Registered Story\" ng-if=\"story.stories_display_to==\'register\'\"><img src=../../../images/nearpeer-story/admin/registered.png alt=\"\"></a><a href=\"\" title=\"Edit Story\" ng-click=editStory(story)><img src=../../../images/nearpeer-story/admin/editing.png alt=\"\"></a><a href=\"\" title=\"Disable Story\" ng-if=\"story.is_disabled==false\" ng-click=disableStories(story.id,true)><img src=../../../images/nearpeer-story/admin/disabled.png alt=\"\"></a><a href=\"\" title=\"Enable Story\" ng-if=\"story.is_disabled==true\" ng-click=disableStories(story.id,false)><img src=../../../images/nearpeer-story/admin/enable.png alt=\"\"></a><!-- <button><img src=\"../../../images/nearpeer-story/admin/delete.png\"></button> --> <a href=\"\" title=\"Delete Story\" ng-click=deleteStories(story.id)><img src=../../../images/nearpeer-story/admin/delete.png alt=\"\"></a></div></div></div><div class=story-card-title><h3>{{story.title}}</h3><ul class=story-detail-action><li class=story-detail-action-btn ng-click=storyAdminViewsPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/views.png alt=\"\"> <span ng-if=story.view_count>{{story.view_count}}</span> <span ng-if=!story.view_count>0</span></li><li class=story-detail-action-btn ng-click=storyAdminLikesPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/like.png alt=\"\"> <span ng-if=story.likes_count>{{story.likes_count}}</span> <span ng-if=!story.likes_count>0</span></li><li class=story-detail-action-btn ng-click=storyAdminCommentsPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/comment.png alt=\"\"> <span ng-if=story.comment_count>{{story.comment_count}}</span> <span ng-if=!story.comment_count>0</span></li></ul></div><button class=\"btn btn-default primary_btn\" ng-click=storyDetail(story.id)>view story</button></div></div></div></div><div style=\"text-align: center; margin-top: 50px\"><img style=\"height: 80px\" src=images/squares.gif></div><!-- <div class=\"col-md-4\">\n            <div class=\"story-card\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>STORY TITLE</h3>\n                <button class=\"btn btn-default primary_btn\">view story</button>\n              </div>\n            </div>\n      </div>\n      <div class=\"col-md-4\">\n            <div class=\"story-card\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>STORY TITLE</h3>\n                <button class=\"btn btn-default primary_btn\">view story</button>\n              </div>\n            </div>\n      </div>\n      <div class=\"col-md-4\">\n            <div class=\"story-card\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>STORY TITLE</h3>\n                <button class=\"btn btn-default primary_btn\">view story</button>\n              </div>\n            </div>\n      </div>\n      <div class=\"col-md-4\">\n            <div class=\"story-card\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>STORY TITLE</h3>\n                <button class=\"btn btn-default primary_btn\">view story</button>\n              </div>\n            </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"story-card\">\n              <div class=\"story-card-body\">\n               <div class=\"story-card-image\"> \n                 <img src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\" alt=\"\">\n                  <div class=\"story-card-image-overlay\">\n                  <div class=\"story-action-btn\">\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/disabled.png\" alt=\"\"></a>\n                      <a href=\"\"><img src=\"../../../images/nearpeer-story/admin/delete.png\" alt=\"\"></a>\n                  </div>\n                  </div>\n                </div>\n                <h3>STORY TITLE</h3>\n                <button class=\"btn btn-default primary_btn\">view story</button>\n              </div>\n        </div>\n      </div> --></div></div></div>");
$templateCache.put("app/admin/stories/story-detail.html","<admin-header statename=\"Story Detail (Reels)\"></admin-header><div class=story-admin><div class=create-stroy-btn></div><div class=story-admin-header><div></div><button type=button class=\"btn btn-default primary_btn\" ng-click=createStoryPopUpOpen()>Create Reels</button></div><div class=loader ng-if=!stories><img src=images/squares.gif></div><div class=story-admin-main><div class=row><div class=col-md-4 ng-repeat=\"story in stories\"><div class=story-card><div class=story-card-body><div class=story-card-image><!-- <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              /> --> <img ng-if=story.image_link src={{story.media_link}} alt=\"\"><video ng-if=story.video_link src={{story.media_link}} autoplay muted></video><!-- <video width=\"320\" height=\"240\" controls>\n                <source src=\"movie.mp4\" type=\"video/mp4\">\n                <source src=\"movie.ogg\" type=\"video/ogg\">\n                Your browser does not support the video tag.\n              </video> --><div class=story-card-image-overlay><div class=story-action-btn><a href=\"\"></a> <a href=\"\"><img ng-click=deleteMedia(story.id) src=../../../images/nearpeer-story/admin/delete.png alt=\"\"></a></div></div></div><ul class=story-detail-action><li class=story-detail-action-btn><img src=../../../images/nearpeer-story/profileview.png alt=\"\"> <span ng-if=story.views>{{story.register_users_views+story.nonregister_users_views}}</span> <span ng-if=!story.views>0</span></li><li class=story-detail-action-btn ng-click=storyAdminViewsPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/views.png alt=\"\"> <span ng-if=story.views>{{story.views}}</span> <span ng-if=!story.views>0</span></li><li class=story-detail-action-btn ng-click=storyAdminLikesPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/like.png alt=\"\"> <span ng-if=story.likes>{{story.likes}}</span> <span ng-if=!story.likes>0</span></li><li class=story-detail-action-btn ng-click=storyAdminCommentsPopUpOpen(story.id)><img src=../../../images/nearpeer-story/admin/comment.png alt=\"\"> <span ng-if=story.comments>{{story.comments}}</span> <span ng-if=!story.comments>0</span></li></ul></div></div></div><!-- <div class=\"col-md-4\">\n        <div class=\"story-card\">\n          <div class=\"story-card-body\">\n            <div class=\"story-card-image\">\n              <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              />\n              <div class=\"story-card-image-overlay\">\n                <div class=\"story-action-btn\">\n                  <a href=\"\"></a>\n                  <a href=\"\"\n                    ><img\n                      src=\"../../../images/nearpeer-story/admin/delete.png\"\n                      alt=\"\"\n                  /></a>\n                </div>\n              </div>\n            </div>\n            <ul class=\"story-detail-action\">\n              <li\n                class=\"story-detail-action-btn\"\n                ng-click=\"storyAdminPopUpOpen()\"\n              >\n                <img\n                  src=\"../../../images/nearpeer-story/admin/views.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/like.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/comment.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div> --><!-- <div class=\"col-md-4\">\n        <div class=\"story-card\">\n          <div class=\"story-card-body\">\n            <div class=\"story-card-image\">\n              <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              />\n              <div class=\"story-card-image-overlay\">\n                <div class=\"story-action-btn\">\n                  <a href=\"\"></a>\n                  <a href=\"\"\n                    ><img\n                      src=\"../../../images/nearpeer-story/admin/delete.png\"\n                      alt=\"\"\n                  /></a>\n                </div>\n              </div>\n            </div>\n            <ul class=\"story-detail-action\">\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/views.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/like.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/comment.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"story-card\">\n          <div class=\"story-card-body\">\n            <div class=\"story-card-image\">\n              <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              />\n              <div class=\"story-card-image-overlay\">\n                <div class=\"story-action-btn\">\n                  <a href=\"\"></a>\n                  <a href=\"\"\n                    ><img\n                      src=\"../../../images/nearpeer-story/admin/delete.png\"\n                      alt=\"\"\n                  /></a>\n                </div>\n              </div>\n            </div>\n            <ul class=\"story-detail-action\">\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/views.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/like.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/comment.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"story-card\">\n          <div class=\"story-card-body\">\n            <div class=\"story-card-image\">\n              <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              />\n              <div class=\"story-card-image-overlay\">\n                <div class=\"story-action-btn\">\n                  <a href=\"\"></a>\n                  <a href=\"\"\n                    ><img\n                      src=\"../../../images/nearpeer-story/admin/delete.png\"\n                      alt=\"\"\n                  /></a>\n                </div>\n              </div>\n            </div>\n            <ul class=\"story-detail-action\">\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/views.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/like.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/comment.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"story-card\">\n          <div class=\"story-card-body\">\n            <div class=\"story-card-image\">\n              <img\n                src=\"https://image.freepik.com/free-vector/polygonal-lion-head_23-2147495868.jpg\"\n                alt=\"\"\n              />\n              <div class=\"story-card-image-overlay\">\n                <div class=\"story-action-btn\">\n                  <a href=\"\"></a>\n                  <a href=\"\"\n                    ><img\n                      src=\"../../../images/nearpeer-story/admin/delete.png\"\n                      alt=\"\"\n                  /></a>\n                </div>\n              </div>\n            </div>\n            <ul class=\"story-detail-action\">\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/views.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/like.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n              <li class=\"story-detail-action-btn\">\n                <img\n                  src=\"../../../images/nearpeer-story/admin/comment.png\"\n                  alt=\"\"\n                />\n                <span>123</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div> --></div></div><!-- Create Story popup --><div class=story-admin-popup ng-if=createStoryPopUp><div class=story-admin-popup-wrapper><div class=popup-close-icon ng-click=createStoryPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Create Reel</h2></div><div class=story-admin-popup-body><div class=row><input class=col-md-12><div class=\"col-md-12 mb-20\"><div class=\"col-md-6 padding0\"><div class=uploadlgBox><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i></span><div class=loader ng-if=uploadingloader style=\"position: absolute; inset: 0; margin: 0; display: grid; place-items: center\"><img src=images/squares.gif></div><input type=file ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image src={{image_url}} alt=\"\"> <span ng-if=!image_url class=upload>Upload Reel</span><player ng-if=\"bringPopup==true\" ng-model=videoValue></player></div></div></div><div class=\"col-md-12 mb-20\"><div class=form-group><label for=storyTitle>Reel Title</label><input type=text class=form-control id=storyTitle placeholder=\"Please enter story title\" ng-model=title maxlength=73><p ng-if=\"title.length>72\" style=color:red>Length cannot be greater than 72</p></div><div class=\"form-group col-md-12 mb-20 padding0\"><label>Story available time</label><div class=business-request-date><div class=businnes-request-date-from style=\"padding-left: 0; display: block\" for=buinessRequestDateFrom><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">Start Time:</label><input type=datetime-local name=buinessRequestDateFrom id=buinessRequestDateFrom ng-model=formData.todate placeholder=\"\"><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div><div class=business-request-date-to style=\"padding-left: 0; display: block\" for=buinessRequestDateTo><label for=buinessRequestDateFrom style=\"font-weight: normal !important; display: block; font-size: 14px\">End Time:</label><input type=datetime-local name=buinessRequestDateTo id=buinessRequestDateTo placeholder=\"\" ng-model=formData.valid_till><!-- <img src=\"../../../images/b2b/b2-calender.png\" alt=\"\"> --></div></div><!-- <input\n            class=\"form-control\"\n            type=\"number\"\n            ng-model=\"valid_till\"\n            placeholder=\"Story available hours\"\n          /> --></div></div><div class=\"col-md-12 mb-20\"><div class=form-group><label for=storyTitle>Reel Description</label><textarea placeholder=\" Add Story Description \" class=form-control ng-model=description rows=7></textarea></div></div><div class=col-md-12><div class=\"form-group col-md-12 mb-20 padding0\"><label>Redirect URL</label><input class=form-control ng-model=redirectUrl placeholder=\"enter your redirect URL\"></div><div class=\"col-md-12 mb-20 padding0\"><button class=\"btn btn-default secondry_btn\" ng-click=addStoryDetail({title:title,description:description,redirectUrl:redirectUrl})>Save</button></div></div></div></div></div></div><!-- Story Views popup --><div class=story-admin-popup ng-if=storyAdminViewsPopUp><div class=story-admin-popup-wrapper><div class=popup-close-icon ng-click=storyAdminViewsPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Views</h2></div><div class=story-admin-popup-body ng-repeat=\"views in media_data\"><ul class=story-admin-popup-list><li><div class=user-count>{{views.count}}</div><div class=user-detail><p>{{views.name}}</p><p>{{views.email}}</p><p>{{views.phone}}</p></div></li><!-- <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li> --></ul></div></div></div><!-- Story likes popup --><div class=story-admin-popup ng-if=storyAdminLikesPopUp><div class=story-admin-popup-wrapper><div class=popup-close-icon ng-click=storyAdminLikesPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Likes</h2></div><div class=story-admin-popup-body ng-repeat=\"likes in media_Likes\"><ul class=story-admin-popup-list><li><div class=user-count>{{likes.count}}</div><div class=user-detail><p>{{likes.name}}</p><p>{{likes.email}}</p><p>{{likes.phone}}</p></div></li><!-- <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li>\n          <li>\n            <div class=\"user-count\">1</div>\n            <div class=\"user-detail\">\n              <p>Jhon doe</p>\n              <p>email@example.com</p>\n              <p>+92 300 134567</p>\n            </div>\n          </li> --></ul></div></div></div><!-- Story Comments popup --><div class=story-admin-popup ng-if=storyAdminCommentsPopUp><div class=story-admin-popup-wrapper><div class=popup-close-icon ng-click=storyAdminCommentsPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Comments</h2></div><div class=story-admin-popup-body ng-repeat=\"comments in media_Comments track by $index\"><ul class=\"story-admin-popup-list story-admin-comment-list\"><li><div class=user-count>{{comments.comment_count}}</div><div class=user-detail><p>{{comments.user_name}}</p><div class=user-comment ng-bind-html=\"limitTo:numLimit| to_trusted \">{{comments.comment}}<p style=\"display: inline\">{{length > numLimit ? \'...\' : \'\'}}</p><a ng-if=\"length > 180\n								 \" class=readMore-btn ng-click=readMore(length)>{{readMoreBtn}}</a></div><img class=comment-img ng-if=\"comments.thumbnail && comments.thumbnail!=\'\'\" src={{comments.thumbnail}} alt=\"\"><!-- <div class=\"user-comment-reply\">\n                Lorem ipsum dolor sit amet consectetur adipisicing elit.\n                Impedit, commodi.\n              </div> --><div class=story-comment-action><button class=\"btn btn-default primary_btn\" ng-class=\"{\'opc-hide noClick\': comments.is_approved == true}\" ng-click=\"commentActions(comments.id, 1,$index)\">Approve</button> <button class=\"btn btn-default primary_btn\" ng-class=\"{\'opc-hide noClick\': comments.is_approved !== true}\" ng-click=\"commentActions(comments.id, 2,$index)\">Hide</button><!-- <button\n                  class=\"btn btn-default primary_btn\"\n                  ng-click=\"commentReplyBtn()\"\n                >\n                  Reply\n                </button> --></div></div></li></ul></div></div></div></div>");
$templateCache.put("app/admin/stories/storyPlayer.html","<div class=wide><video id=videotarget autoplay controls><source id=videosrc ng-src=videoSource type=video/mp4></video></div><slider floor=0 ceiling=100 step=1 ng-model=currentPercent change=onSliderChange()></slider><slider floor=0 ceiling=\"{{ duration }}\" step=0.1 precision=10 ng-model-low=start ng-model-high=end change=onTrimChange()></slider><p>start = {{ start }}</p><p>current = {{ current }}</p><p>end = {{ end }}</p><button>Trim video</button>\'");
$templateCache.put("app/admin/subscriptions/AddSubscriptions.html","<admin-header statename=Subscriptions></admin-header><div class=coure-access-form><!--  --><div><div class=\"row search-type-block\" ng-show=types><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'bundle\')\" class=\"btn btn-default secondry_btn\">Bundle</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'course\')\" class=\"btn btn-default secondry_btn\">Course</button></div><div class=\"col-sm-4 col-xs-12 mt-10\"><button type=button ng-click=\"purchaseType(\'module\')\" class=\"btn btn-default secondry_btn\">Module</button></div></div><div ng-show=access.type class=\"row course-form-search\"><!------ col-md-6-----><div class=col-md-6><div class=form-group><label>{{access.type===\'course\' || access.type===\'module\'?\'Course\':\'Bundle\'}}</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey,access.type) : null\" placeholder=\"Search {{access.type===\'course\' || access.type===\'module\'?\'Course\':\'Bundle\'}}\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=addVariants(course,access.type) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div ng-show=\"access.type===\'module\'\" class=col-md-6><div class=form-group data-text=\"Enter text here\"><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{$index}}>{{module.name}}</option></select></div></div><!------ col-md-6-----></div></div><div ng-show=showInfo><div class=\"row info-block mt-30\"><h3 class=pb-20>Selected</h3><div class=col-md-4 ng-repeat=\"selectedCourse in selectedCourses\"><div class=form-group><h5>{{selectedCourse.type}}: {{selectedCourse.name}}</h5></div></div></div><div class=\"row info-block mt-30\"><div class=col-md-6 ng-repeat=\"subscription in subscriptions\"><h3 class=pb-20>Subscription</h3><div class=form-group><input type=text class=form-control ng-model=subscription.subscription_name placeholder=\"Subscription Name\"></div><div class=form-group><input type=number class=form-control ng-model=subscription.subscription_price placeholder=\"Subscription Price\"></div><div class=form-group><input type=number class=form-control ng-model=subscription.subscription_days placeholder=\"Subscription Days\"></div></div></div><a style=\"font-weight: bold; font-size: 16px\" ng-click=addNewSubscription()>+ Add Subscription</a><div class=\"col-md-12 mt-20 mb-20\"><button type=button ng-disabled=disabled ng-click=createAccess() class=\"btn btn-default primary_btn payment-block-btn\">Create Subscriptions</button></div></div></div>");
$templateCache.put("app/admin/subscriptions/EditSubscriptions.html","<admin-header statename=\"Edit Subscriptions\"></admin-header><div class=coure-access-form><div ng-show=showInfo><div class=\"row info-block mt-30\"><h3 class=pb-20>Selected {{subscription.course_id ? \'Course\': subscription.bundle_id ? \'Bundle\' : \'Module\'}}</h3><div class=col-md-4><div class=form-group><h5>{{subscription.course_id ? subscription.course_id.name : subscription.bundle_id ? subscription.bundle_id.name : subscription.module_id.name}}</h5></div></div></div><div class=\"row info-block mt-30\"><div class=col-md-6><h3 class=pb-20>Subscription</h3><div class=form-group><label>Subscription Name</label><input type=text class=form-control ng-model=subscription.subscription_name placeholder=\"Subscription Name\"></div><div class=form-group><label>Subscription Price</label><input type=number class=form-control ng-model=subscription.subscription_price placeholder=\"Subscription Price\"></div><div class=form-group><label>Subscription Days</label><input type=number class=form-control ng-model=subscription.subscription_days placeholder=\"Subscription Days\"></div></div></div><div class=\"col-md-12 mt-20 mb-20\"><button type=button ng-disabled=disabled ng-click=updateSubscription() class=\"btn btn-default primary_btn payment-block-btn\">Update Subscriptions</button></div></div></div>");
$templateCache.put("app/admin/subscriptions/Subscriptions.html","<admin-header statename=Subscriptions></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><!-- <div class=\"form-group col-xs-6 col-md-3\">\n    <label>Search</label>\n    <input\n      type=\"text\"\n      placeholder=\"Search Link\"\n      ng-model=\"userKeySearch\"\n      class=\"form-control\"\n    />\n    <div style=\"margin-top: 10px\">\n      <button\n        class=\"btn btn-primary text-light\"\n        style=\"color: white\"\n        ng-click=\"searchLinks()\"\n      >\n        Search\n      </button>\n      <button\n        class=\"btn btn-primary text-danger\"\n        style=\"color: white\"\n        ng-click=\"clearFilter()\"\n      >\n        Reset\n      </button>\n    </div>\n  </div> --><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'AddSubscriptions\')\">Create Subscription</button></div><!--- hallo ---><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Subscription Name</p></th><th><p class=\"pTag border-top-remv table_th\">Bundle/Course/Module Name</p></th><th><p class=\"pTag table_th\">Subscription Price</p></th><th><p class=\"pTag table_th\">Subscription Days</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"form in forms \"><td><p class=pTag>{{form.subscription_name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{form.course_id ? \'Course: \'+form.course_id.name : form.bundle_id ? \'Bundle: \'+form.bundle_id.name: \'Module: \'+form.module_id.name}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{form.subscription_price}}</p></td><td style=\"max-width: 200px\"><p class=pTag>{{form.subscription_days}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=updateSubscription(form)>Update</button> <button class=\"btn btn-default\" ng-click=deleteSubscription(form)>Delete</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total / perPage | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/swTags/swTags.html","<admin-header statename=\"SW Tags\"></admin-header><div><span style=\"float: right\"><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'ADD_SW_Tags\')\">Add SW Tags</button></span><div class=responsive-table><table class=table><colgroup><col class=col-xs-8><col class=col-xs-4></colgroup><thead><tr><th><p class=\"pTag table_th\" style=\"text-align: left\">Course Name</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in promptConfigs\"><td><p class=pTag style=\"text-align: left\">{{config.name}}</p></td><td style=\"text-align: right\"><button class=\"btn btn-default\" ng-click=\"goToState(\'Edit_SW_Tags\', {course_id: config.id})\">Update SW Tags</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/swTagsQuestions/swTagsQuestions.html","<admin-header statename=\"SW Tags\"></admin-header><div><div class=panel-group id=accordion><div class=\"panel panel-default\" ng-repeat=\"courseTag in courseTags\"><div class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#{{$index}} style=\"padding-bottom: 60px\"><h4 class=\"panel-title flex-view align-items-center justify-content-b\" style=\"width: 100%\"><a class=\"accordion-toggle font-bold\" href=#{{$index}}>{{courseTag.name}} (Questions Count: {{courseTag.questions}})</a></h4></div><div id={{$index}} class=\"panel-collapse collapse\"><div class=panel-body style=\"padding-bottom: 15px\" ng-repeat=\"moduleTag in courseTag.moduleTags\"><div class=\"flex-view align-items-center justify-content-b\"><p class=mb-0>{{moduleTag.name}} (Questions Count: {{moduleTag.questions}})</p></div></div></div></div></div></div>");
$templateCache.put("app/admin/suspiciousUserReq/suspiciousUserReq.html","<admin-header statename=\"Suspicious Users Req\"></admin-header><div><div class=\"form-group col-xs-6 col-md-3\"><label>Search</label><input type=text placeholder=\"Search by Email\" ng-model=userKeySearch class=form-control><div style=\"margin-top: 10px\"><button class=\"btn btn-primary text-light\" style=\"color: white\" ng-click=searchLinks()>Search</button> <button class=\"btn btn-primary text-danger\" style=\"color: white\" ng-click=clearFilter()>Reset</button></div></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">Email</p></th><th><p class=\"pTag table_th\">Phone</p></th><th><p class=\"pTag table_th\">Status</p></th><th><p class=\"pTag table_th\">Created At</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.user_id.full_name}}</p></td><td><p class=pTag>{{config.user_id.email}}</p></td><td><p class=pTag>{{config.user_id.phone}}</p></td><td><p class=pTag>{{config.status}}</p></td><td><p class=pTag>{{config.createdAt | date:\'yyyy-MM-dd\'}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=approve(config)>Approve</button> <button class=\"btn btn-default\" ng-click=reject(config)>Reject</button></td></tr></tbody></table></div><div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center\"><nav><ul class=pagination><li class=previous ng-click=\"showNext(\'previous\')\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"showNext(\'next\')\"><a href=\"\"><span>&gt;</span></a></li><li class=next><p>{{currentPage}} Out of {{ total_config_pages | roundup }}</p></li></ul></nav><!-- <span class=\"order-page-detail\">{{searchParams.page}} in {{totalPages}}\n      ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}}\n      Out of {{totalCount}}</span> --></div></div>");
$templateCache.put("app/admin/tagFeatures/tagFeatures.html","<admin-header statename=\"Tag Feature\"></admin-header><div class=form-area><form><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=\"uploadlgBox mb-30\" style=\"min-height: 100px;width: 100px\"><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i> </span><input class=uploadlgBox ng-if=!cf.icon_url type=file accept=image/* ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image ng-if=cf.icon_url src={{cf.icon_url}} alt=\"\"> <span ng-if=!cf.icon_url class=upload style=\"left: 0\">Upload Image</span></div><!-- <div class=\"form-group\">\n                        <span class=\"cross\"><i ng-click=\"delImage()\" class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </span>\n                        <label>Image URL</label>\n                        <img class=\"uploaded_image\" src=\"{{cf.icon_url}}\" alt=\"\" />\n                        <input class=\"uploadlgBox\" type=\"file\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImage(image)\">\n                    </div> --></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Name</label><input type=text class=form-control ng-model=cf.name></div></div></div></div><div class=row><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Redirect URL</label><input type=text class=form-control ng-model=cf.redirect_url></div></div></div></div><div class=col-md-12><button ng-click=submit(cf) class=\"btn btn-default primary_btn\">Save</button></div></form></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div ui-sortable ng-model=features><div class=\"col-xs-12 col-md-12\" ng-repeat=\"feature in features\"><div class=\"form-group holder\"><input type=checkbox class=checkbox ng-click=\"editFeature(feature,\'publish\')\" ng-model=feature.publish> <img class=uploaded_image src={{feature.icon_url}} style=\"height: 22px\"><!-- <span>{{feature.icon_url | limitTo : 20 }} {{tag.title.length > 20 ?\n                    \'...\' : \'\'}}</span> --> <span class=title>{{feature.name | limitTo : 20 }} {{feature.name.length > 20 ? \'...\' : \'\'}}</span> <span>{{feature.redirect_url | limitTo : 40 }} {{feature.redirect_url.length > 40 ? \'...\' : \'\'}}</span><div class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=\"editFeature(feature,\'edit\')\" class=\"glyphicon glyphicon-pencil\"></a> <a ng-click=\"editFeature(feature,\'del\')\" class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div><div class=col-md-12><button ng-click=updateSortOrder() class=\"btn btn-default primary_btn\">Save Sorting</button></div></div></div>");
$templateCache.put("app/admin/tagUrls/tagUrls.html","<admin-header statename=\"Tag URLS\"></admin-header><div><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Tags Urls:</h2></div><div class=\"col-md-12 mb-50 ng-scope\"><div class=\"form-group col-xs-6 col-md-3\"></div><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'addTagUrls\')\">Create Tags</button></div><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag border-top-remv table_th\">Name</p></th><th><p class=\"pTag table_th\">Copy Url</p></th><th><p class=\"pTag table_th\">Actions</p></th></tr></thead><tbody><tr ng-repeat=\"tag in courseTags\"><td><p class=pTag>{{tag.name}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=copylink(tag)>Copy Link</button></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editTag(tag.id)>Update</button> <button class=\"btn btn-default\" ng-click=deleteTag(tag.id)>Delete</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/terminateOrders/terminateOrders.html","<admin-header statename=\"Terminate Orders\"></admin-header><div class=terminate-orders-container><div class=terminate-orders-heading><h2>Welcome to Terminate Orders:</h2></div><div class=container><div class=row><div class=\"col-md-2 col-sm-2\"><select class=select-box ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option value=\"\">Select Institute</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-md-2 col-sm-2\"><select class=select-box ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option value=\"\">Select Faculty</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div><div class=\"col-md-2 col-sm-2\"><select class=select-box ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option value=\"\">Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><h3 class=orders-heading>Can you terminate orders?</h3><div class=clearfix></div><ul><div ng-repeat=\"course in selectedCourses\" value={{$index}}><div style=\"margin: 10px; display: flex; align-items: center\"><p style=\"margin-right: 20px; margin-bottom: 0px\">{{course.name}}</p><i style=\"margin-left: 30px;font-weight: bold\" ng-click=removeCourse(course)>X</i></div></div></ul><ul><div><div class=col-6><button type=button class=terminate-btn ng-if=\"type && data\" ng-click=Terminate()>Terminate</button></div></div></ul></div>");
$templateCache.put("app/admin/whitelisted_users/userIPList.html","<admin-header statename=\"User Whitelisted IPs list\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Add new IP</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 100px\"><div class=col-md-12><div class=form-group><label>Add User IP</label><input type=text placeholder=\"User IP\" ng-model=userIP class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=WhitelistUser() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div class=\"col-xs-12 col-md-12\" ng-repeat=\"ip in ipList\"><div class=\"form-group holder\"><div ng-if=\"currrentIP != ip.ip\" class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=deleteUser(ip) class=\"glyphicon glyphicon-trash\"></a></div></div><span class=single-bundles>{{ip.ip}}</span></div></div></div></div></div>");
$templateCache.put("app/admin/whitelisted_users/whitelisted_users.html","<admin-header statename=\"Whitelist Users\"></admin-header><div class=\"col-md-12 mb-50 ng-scope\"><div class=pull-right><button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModalTwo>Update Admin\'s Password</button> <button type=button class=\"btn btn-default primary_btn\" data-toggle=modal data-target=#myModal>Whitelist a User</button></div><!-- Modal --><div class=\"modal fade\" id=myModal role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 180px\"><div class=col-md-12><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? getInfo(userKey) : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=addVariants(user) class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.name || user.full_name}}</li></ul></div><div class=form-group><label>Select User IP</label><input type=text placeholder=\"User IP\" ng-model=userIP class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=WhitelistUser() class=\"btn btn-danger\" data-dismiss=modal>Whitelist</button></div></div></div></div><!-- Modal Two--><div class=\"modal fade\" id=myModalTwo role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 180px\"><div class=col-md-12><div class=form-group><label>Select User</label><input type=text placeholder=\"Search User\" ng-model=userKey ng-change=\"userKey.length > 3 ? getInfo(userKey) : null\" class=form-control><ul ng-if=\"users.length > 0\" class=list-group><li ng-click=addVariants(user) class=list-group-item ng-repeat=\"user in users\">{{user.email || user.fb_email || user.name || user.full_name}}</li></ul></div><div class=form-group><label>Enter New Password</label><input type=text placeholder=Password ng-model=password class=form-control></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=moveTotrash() type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> <button ng-click=updatePassword() class=\"btn btn-danger\" data-dismiss=modal>Update</button></div></div></div></div><!--- hallo ---><div class=\"row editable-tags\"><div class=\"col-md-12 col-lg-12\"><div ng-if=\"usersList.length && usersList.length > 0\" class=\"col-xs-12 col-md-12\" ng-repeat=\"user in usersList\"><div class=\"form-group holder\"><div ng-if=\"currentUser.id != user.id\" class=\"single-bundles pull-right\"><div class=actions style=\"position: static\"><a ng-click=deleteUser(user.id) class=\"glyphicon glyphicon-trash\"></a></div></div><span style=\"cursor: pointer\" ng-click=goto(user) class=single-bundles>{{user.email}}</span></div></div></div></div></div>");
$templateCache.put("app/admin/videoQuality/videoQuality.html","<admin-header statename=\"Video Quality\"></admin-header><div class=\"col-md-12 col-lg-12\"><table class=\"table table-bordered table-striped\"><thead><tr><th>Quality Name</th><th>Preset ID</th></tr></thead><tbody><tr ng-repeat=\"quality in allquality\"><td>{{quality.quality_name}}</td><td>{{quality.Preset_id}}</td></tr></tbody></table><p>Default VVS Quality for Mobile</p><div class=btn-group style=\"margin-bottom: 20px\"><button class=\"btn btn-default btn-lg dropdown-toggle\" style=\"float: left\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{defaultVVSQuality}}P</label><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu><li><a ng-click=changeVVSQuality(240)>240P</a></li><li><a ng-click=changeVVSQuality(360)>360P</a></li><li><a ng-click=changeVVSQuality(540)>540P</a></li></ul></div><div><button ng-click=saveDefaultVVS() class=\"btn btn-default primary_btn\">Save</button></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Quality Name</label><input type=text class=form-control ng-model=quality.quality_name></div></div><div class=\"col-xs-12 col-md-6\"><div class=form-group><label>Preset ID</label><input type=text class=form-control ng-model=quality.Preset_id></div></div></div></div><div class=\"col-md-12 padding0\"><button ng-click=saveVideoQuality(quality) class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/wpSitePages/wpSitePages.html","<admin-header statename=\"Wordpress Site Pages\"></admin-header><div><button type=button class=\"btn btn-default primary_btn\" ng-click=\"goToState(\'add_wp_pages\')\">Create Wordpress Page</button><!-- <div>\n    <p style=\"float: right;\"><input type=\"text\" placeholder=\"Search By Coupon Id\" ng-model=\"couponID\"> <button class=\"btn btn-primary\" ng-click=\"searchCouponById(couponID)\">Search</button></p>\n    <h4>Sort By</h4>\n    <select ng-change=\"showCoupons(1,sortType)\" ng-model=\"sortType\">\n      <option value=\"1\" selected>Default</option>\n      <option value=\"2\">Created At Ascending</option>\n      <option value=\"3\">Status Used</option>\n      <option value=\"4\">Status Available</option>\n    </select>\n  </div> --><div class=responsive-table><table class=table><thead><tr><th><p class=\"pTag table_th\">Name</p></th><th><p class=\"pTag table_th\">Link</p></th><th><p class=\"pTag table_th\">Niche</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"config in configs\"><td><p class=pTag>{{config.name}}</p></td><td><p class=pTag>{{config.link}}</p></td><td><p class=pTag>{{config.category}}</p></td><td style=\"text-align: center\"><button class=\"btn btn-default\" ng-click=editConfig(config)>Edit</button> <button class=\"btn btn-default\" ng-click=disableConfig(config)>Delete</button></td></tr></tbody></table></div><!-- <div class=\"col-12 ng-binding no-of-pages\" style=\"text-align: center;\">\n    <nav>\n      <ul class=\"pagination\">\n        <li class=\"previous\" ng-click=\"showNext(\'previous\')\">\n          <a href=\"\" style=\"margin-right: 10px;\">\n            <span>&lt;</span>\n          </a>\n        </li>\n        <li class=\"next\" ng-click=\"showNext(\'next\')\">\n          <a href=\"\">\n            <span>&gt;</span>\n          </a>\n        </li>\n        <li class=\"next\">\n          <p>{{currentPage}} Out of  {{ total_config_pages | roundup }}</p>\n        </li>\n      </ul>\n    </nav>\n  </div> --></div>");
$templateCache.put("app/admin/sidebar/sidebar.html","<toaster-container toaster-options=\"{\'position-class\': \'toast-bottom-right\'}\"></toaster-container><div id=sidebar-parent class=\"col-xs-12 col-sm-2 col-md-2 padding0\"><div id=sidebar style=\"overflow-y: auto\"><nav class=navbar><button type=button class=\"sidebar-button navbar-toggle collapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=adminlogo></a><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1><ul class=\"navigation navbar-nav\" ng-if=isAdmin><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminDashBoard\'}\" ng-click=\"goToState(\'AdminDashBoard\')\">Dashboard</a></li><li class=drop-down-menu ng-click=showDropDown()><a class=drop-caret href=#>Order Management</a><ul ng-show=hideDropDown><li class=nav-item><a href=# ng-class=\"{\'active\': currentPage ==\n                \'AdminOrdersManagement\'}\" ng-click=\"goToState(\'AdminOrdersManagement\')\">Orders</a></li><!-- <li class=\"nav-item\">\n                <a ng-class=\"{\'active\': currentPage == \'AdminCreateOrder\'}\" ng-click=\"goToState(\'AdminCreateOrder\')\">Create Order</a>\n              </li> --><!-- <li class=\"nav-item\">\n                <a href=\"#\" ng-class=\"{\'active\': currentPage ==\n                \'AdminPaymentApproval\'}\" ng-click=\"goToState(\'AdminPaymentApproval\')\">Payment Approvals</a>\n              </li> --><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminCourseAccessForm\'}\" ng-click=\"goToState(\'AdminCourseAccessForm\')\">Course Access Form</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminEditOrder\'}\" ng-click=\"goToState(\'AdminEditOrder\')\">Edit Order</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'sessions\'}\" ng-click=\"goToState(\'sessions\')\">Order Sessions</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminPaymentType\'}\" ng-click=\"goToState(\'AdminPaymentType\')\">Payment Type</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminReasons\'}\" ng-click=\"goToState(\'AdminReasons\')\">Reasons</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminBulkOrderUpdate\'}\" ng-click=\"goToState(\'AdminBulkOrderUpdate\')\">Bulk Orders Update</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminInstallmentOrders\'}\" ng-click=\"goToState(\'AdminInstallmentOrders\')\">Installment Orders</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'terminateOrders\'}\" ng-click=\"goToState(\'terminateOrders\')\">Bulk Orders Terminate</a></li></ul></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminPaymentAudit\'}\" ng-click=\"goToState(\'AdminPaymentAudit\')\">Payment Audit</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminVideoQuality\'}\" ng-click=\"goToState(\'AdminVideoQuality\')\">Video Quality</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'Subscriptions\'}\" ng-click=\"goToState(\'Subscriptions\')\">Subscriptions</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminBundle\'}\" ng-click=\"goToState(\'AdminBundle\')\">Bundles</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminBundle\'}\" ng-click=\"goToState(\'AdminQuizConfiguration\')\">Quiz Configurations</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminFAQS\'}\" ng-click=\"goToState(\'AdminFAQS\')\">FAQS</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminSeoTag\'}\" ng-click=\"goToState(\'AdminSeoTag\')\">SEO Tags</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminInstitution\'}\" ng-click=\"goToState(\'AdminInstitution\')\">Institution</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminCourseFeature\'}\" ng-click=\"goToState(\'AdminCourseFeature\')\">Features</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'CourseTags\'}\" ng-click=\"goToState(\'courseTags\')\">Course Tags</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminMainCategories\'}\" ng-click=\"goToState(\'AdminMainCategories\')\">Main Categories</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'questionMarket\'}\" ng-click=\"goToState(\'questionMarket\')\">Question Markets</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'StudentQuestions\'}\" ng-click=\"goToState(\'StudentQuestions\')\">Student Questions <span class=question-circle style=\"top: 3px;\n    right: 1px\">{{unansweredQuestions ? unansweredQuestions : 0 }}</span></a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminAssignments\'}\" ng-click=\"goToState(\'AdminAssignments\')\">Assignments <span class=question-circle style=\"top: 3px;\n    right: 1px\">{{unansweredAssignments ? unansweredAssignments : 0 }}</span></a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'enrollmentGroups\'}\" ng-click=\"goToState(\'enrollmentGroups\')\">Enrollment Groups</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'CourseTags\'}\" ng-click=\"goToState(\'coupon\')\">Coupons</a></li><li class=nav-item ng-if=isSuperAdmin><a ng-class=\"{\'active\': currentPage == \'CourseTags\'}\" ng-click=\"goToState(\'admin_access\')\">Admin Access</a></li><li class=nav-item ng-if=isSuperAdmin><a ng-class=\"{\'active\': currentPage == \'CourseTags\'}\" ng-click=\"goToState(\'admin_configurations\')\">Configurations</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'emails-in-bulk\'}\" ng-click=\"goToState(\'emails-in-bulk\')\">Emails</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'sms-in-bulk\'}\" ng-click=\"goToState(\'sms-in-bulk\')\">SMS</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'new_coming_emails\'}\" ng-click=\"goToState(\'new_coming_emails\')\">New Coming Emails</a></li><li class=nav-item ng-if=isSuperAdmin><a ng-class=\"{\'active\': currentPage == \'CourseTags\'}\" ng-click=\"goToState(\'admin_whitelisted_users\')\">Users IP Access</a></li><li class=nav-item ng-if=isSuperAdmin><a ng-class=\"{\'active\': currentPage == \'admin_mobile_serving\'}\" ng-click=\"goToState(\'admin_mobile_serving\')\">Allow Mobile Serving</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminRepoorts\'}\" ng-click=\"goToState(\'AdminRepoorts\')\">Reports</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'download_videos_config\'}\" ng-click=\"goToState(\'download_videos_config\')\">Offline Downloads Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'redirect_links\'}\" ng-click=\"goToState(\'redirect_links\')\">Redirect Links</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'recommendation_banner\'}\" ng-click=\"goToState(\'recommendation_banner\')\">Recommendation Banner</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'post_questions_config\'}\" ng-click=\"goToState(\'post_questions_config\')\">Post Question Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'wp_pages\'}\" ng-click=\"goToState(\'wp_pages\')\">Wordpress Pages</a></li><li class=drop-down-menu ng-click=showFreeAccessDropDown()><a class=drop-caret href=#>Free Access Config</a><ul ng-show=hideFreeAccessDropDown><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'free_access\'}\" ng-click=\"goToState(\'free_access\')\">Create Free Access Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'free_access_tracking\'}\" ng-click=\"goToState(\'free_access_tracking\')\">Free Access Tracking</a></li></ul></li><!-- <li class=\"nav-item\">\n            <a ng-class=\"{\'active\': currentPage == \'AdminMergeAccounts\'}\" \n            ng-click=\"goToState(\'AdminMergeAccounts\')\">Merge Accounts</a>\n          </li> --><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'BoostSound\'}\" ng-click=\"goToState(\'BoostSound\')\">Boost Sound Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'business_request\'}\" ng-click=\"goToState(\'business_request\')\">Business Request</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'stories\'}\" ng-click=\"goToState(\'stories\')\">Stories</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'block_extension\'}\" ng-click=\"goToState(\'block_extension\')\">Block Extensions</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'iframe_form\'}\" ng-click=\"goToState(\'iframe_form\')\">Iframe Forms</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'form_builder\'}\" ng-click=\"goToState(\'form_builder\')\">Forms Builder</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'campaign_tracking\'}\" ng-click=\"goToState(\'campaign_tracking\')\">Campaign Tracking</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'mobile_popup_config\'}\" ng-click=\"goToState(\'mobile_popup_config\')\">Mobile Browser Popup Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'suspicious_users_req\'}\" ng-click=\"goToState(\'suspicious_users_req\')\">Suspicious Users Req</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'bot_config\'}\" ng-click=\"goToState(\'bot_config\')\">Bot Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'tagUrls\'}\" ng-click=\"goToState(\'tagUrls\')\">Tag Urls</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'Prom_open_AI_config\'}\" ng-click=\"goToState(\'Prom_open_AI_config\')\">Quiz Prompt Config</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'SW_Tags\'}\" ng-click=\"goToState(\'SW_Tags\')\">SW Tags</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'SW_Tags_Questions\'}\" ng-click=\"goToState(\'SW_Tags_Questions\')\">SW Tag Questions</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'AdminInstructor\'}\" ng-click=\"goToState(\'AdminInstructor\')\">Instructor</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'NP_SHARE\'}\" ng-click=\"goToState(\'NP_SHARE\')\">NP Share Percentage</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'ArchiveCourse\'}\" ng-click=\"goToState(\'ArchiveCourse\')\">Archive Courses</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'NicheDiscounts\'}\" ng-click=\"goToState(\'NicheDiscounts\')\">Niche Discounts</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'InBuildNotificationBar\'}\" ng-click=\"goToState(\'InBuildNotificationBar\')\">Notification Bar</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'HtmlPages\'}\" ng-click=\"goToState(\'HtmlPages\')\">Html pages</a></li></ul><ul class=\"navigation navbar-nav\" ng-if=isActivityViwer><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'fsc_visits\'}\" ng-click=\"goToState(\'fsc_visits\')\">FSC Visits</a></li></ul><ul class=\"navigation navbar-nav\" ng-if=isMarketing><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'emails-in-bulk\'}\" ng-click=\"goToState(\'emails-in-bulk\')\">Emails</a></li><li class=nav-item><a ng-class=\"{\'active\': currentPage == \'sms-in-bulk\'}\" ng-click=\"goToState(\'sms-in-bulk\')\">SMS</a></li></ul></div></nav></div></div><div id=admin-view-control class=\"col-xs-12 col-sm-10 col-md-10 white-bg\"><ui-view></ui-view></div>");
$templateCache.put("app/blogs-panel/blogsHome/blogsHomePage.html","<div class=loader ng-show=responsePopup><img src=images/squares.gif></div><div ng-hide=responsePopup><div class=\"header header-two\"><div class=logo><a><svg xmlns=http://www.w3.org/2000/svg width=240 height=60 viewBox=\"0 0 240 60\"><metadata><?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?> <x:xmpmeta xmlns:x=adobe:ns:meta/ x:xmptk=\"Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01        \"><rdf:RDF xmlns:rdf=http://www.w3.org/1999/02/22-rdf-syntax-ns#><rdf:Description rdf:about=\"\"/></rdf:RDF></x:xmpmeta> <?xpacket end=\"w\"?></metadata><defs><style>.cls-1 {\n        fill: #112d4e;\n        fill-rule: evenodd;\n      }</style></defs><path id=Logo class=cls-1 d=M209.473,68.243a7.823,7.823,0,0,1,.289-2.155,5.276,5.276,0,0,1,.867-1.775,4.158,4.158,0,0,1,1.444-1.2,4.363,4.363,0,0,1,2.022-.444,5.236,5.236,0,0,1,2.166.4,3.826,3.826,0,0,1,1.444,1.1,4.135,4.135,0,0,1,.784,1.626,8.378,8.378,0,0,1,.227,1.987V79.993H222.6V67.1a11.254,11.254,0,0,0-.433-3.17,7.115,7.115,0,0,0-1.321-2.557,6.15,6.15,0,0,0-2.228-1.692,7.438,7.438,0,0,0-3.115-.612,7.665,7.665,0,0,0-3.384.8,6.344,6.344,0,0,0-2.723,2.706V59.664h-3.8v20.33h3.878V68.243Zm20.311-.507a5.191,5.191,0,0,1,.454-1.9,6.11,6.11,0,0,1,1.093-1.669,5.131,5.131,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H229.784Zm11.43,5.284a6.853,6.853,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.9,5.9,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H244.6a4.31,4.31,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.639-4.332,9.709,9.709,0,0,0-1.837-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.649,8.649,0,0,0-3.589.781,9.231,9.231,0,0,0-3.033,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.4,12.4,0,0,0,.805,4.608,10.043,10.043,0,0,0,2.186,3.423,9.243,9.243,0,0,0,3.2,2.114,10.214,10.214,0,0,0,3.8.718,9.543,9.543,0,0,0,3.178-.507,9.361,9.361,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm6.725,3.847a5.8,5.8,0,0,0,1.341,1.922,6.8,6.8,0,0,0,2.084,1.331,7.078,7.078,0,0,0,2.744.507,8.246,8.246,0,0,0,2.373-.317,7.139,7.139,0,0,0,1.836-.825,6.585,6.585,0,0,0,1.32-1.1,7.489,7.489,0,0,0,.867-1.141q0,1.1.062,1.733a9.121,9.121,0,0,0,.144,1.014h3.8a11.843,11.843,0,0,1-.165-1.183c-0.056-.535-0.082-1.253-0.082-2.155V66.468a8.861,8.861,0,0,0-.454-2.831,6.151,6.151,0,0,0-1.444-2.367,7.161,7.161,0,0,0-2.559-1.627,10.448,10.448,0,0,0-3.8-.613,9.31,9.31,0,0,0-3.033.486,8.078,8.078,0,0,0-2.5,1.353,7.119,7.119,0,0,0-2.6,4.754l3.713,0.887a4.937,4.937,0,0,1,1.32-2.937,4.2,4.2,0,0,1,3.178-1.163,4.325,4.325,0,0,1,3.28,1.077,3.614,3.614,0,0,1,1.011,2.558,1.591,1.591,0,0,1-.31.971,1.754,1.754,0,0,1-1.217.551l-5.364.8a10.771,10.771,0,0,0-2.393.677,6.285,6.285,0,0,0-1.919,1.225,5.355,5.355,0,0,0-1.258,1.839,6.2,6.2,0,0,0-.454,2.43A5.813,5.813,0,0,0,247.939,76.867Zm4.354-.487a2.9,2.9,0,0,1-.867-2.05,2.665,2.665,0,0,1,.825-2.092,4.046,4.046,0,0,1,2.063-.951l6.066-.929v0.929a7.76,7.76,0,0,1-.454,2.812,4.864,4.864,0,0,1-1.217,1.859,4.632,4.632,0,0,1-1.816,1.015,7.764,7.764,0,0,1-2.249.318A3.094,3.094,0,0,1,252.293,76.38Zm26.971-16.927a4.688,4.688,0,0,0-.516-0.085,6.642,6.642,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.794,6.794,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.878V69.808q0-3.338,1.507-4.8a5.421,5.421,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453Zm7.191,28.572V77.246a6.929,6.929,0,0,0,2.475,2.325,7.677,7.677,0,0,0,3.962.972,8.88,8.88,0,0,0,3.9-.824,8.476,8.476,0,0,0,2.909-2.283,10.152,10.152,0,0,0,1.815-3.4,13.846,13.846,0,0,0,.619-4.226,14.048,14.048,0,0,0-.6-4.143,10.283,10.283,0,0,0-1.733-3.381,8,8,0,0,0-2.847-2.261,8.978,8.978,0,0,0-3.941-.824,7.635,7.635,0,0,0-4.126,1.058,6.97,6.97,0,0,0-2.517,2.577V59.664h-3.755V88.025h3.838ZM297.76,72.7a6.819,6.819,0,0,1-1.176,2.283,5.38,5.38,0,0,1-1.836,1.481,5.83,5.83,0,0,1-4.848,0,5.514,5.514,0,0,1-1.877-1.481,6.607,6.607,0,0,1-1.2-2.283,9.726,9.726,0,0,1-.413-2.894A9.179,9.179,0,0,1,286.826,67a6.681,6.681,0,0,1,1.2-2.241,5.783,5.783,0,0,1,1.877-1.5,5.31,5.31,0,0,1,2.414-.549,5.3,5.3,0,0,1,4.291,2.049A7.143,7.143,0,0,1,297.76,67a9.179,9.179,0,0,1,.413,2.811A9.726,9.726,0,0,1,297.76,72.7Zm11.207-4.966a5.171,5.171,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.116,5.116,0,0,1,1.65-1.186,5.271,5.271,0,0,1,2.208-.443,5.133,5.133,0,0,1,4,1.5,5.64,5.64,0,0,1,1.445,3.7H308.967ZM320.4,73.02a6.843,6.843,0,0,1-1.857,2.916,5.275,5.275,0,0,1-3.713,1.184,6.126,6.126,0,0,1-2.331-.445,5.529,5.529,0,0,1-1.9-1.268,5.91,5.91,0,0,1-1.258-1.965,7.278,7.278,0,0,1-.5-2.493H323.78a4.708,4.708,0,0,0,.062-0.55q0.02-.337.02-0.718a13.95,13.95,0,0,0-.639-4.332,9.724,9.724,0,0,0-1.836-3.361,8.186,8.186,0,0,0-2.992-2.177,10.1,10.1,0,0,0-4.064-.781,8.65,8.65,0,0,0-3.59.781,9.251,9.251,0,0,0-3.033,2.2,10.939,10.939,0,0,0-2.084,3.381,11.72,11.72,0,0,0-.784,4.373,12.424,12.424,0,0,0,.805,4.608,10.031,10.031,0,0,0,2.187,3.423,9.224,9.224,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718A9.541,9.541,0,0,0,318,80.121a9.346,9.346,0,0,0,2.579-1.374,9.013,9.013,0,0,0,3.156-4.544Zm10.3-5.284a5.191,5.191,0,0,1,.454-1.9,6.064,6.064,0,0,1,1.093-1.669,5.109,5.109,0,0,1,1.651-1.186,5.265,5.265,0,0,1,2.208-.443,5.134,5.134,0,0,1,4,1.5,5.634,5.634,0,0,1,1.444,3.7H330.7Zm11.43,5.284a6.862,6.862,0,0,1-1.857,2.916,5.279,5.279,0,0,1-3.714,1.184,6.129,6.129,0,0,1-2.331-.445,5.516,5.516,0,0,1-1.9-1.268,5.879,5.879,0,0,1-1.258-1.965,7.255,7.255,0,0,1-.5-2.493h14.937a4.5,4.5,0,0,0,.062-0.55q0.021-.337.021-0.718a13.95,13.95,0,0,0-.64-4.332,9.707,9.707,0,0,0-1.836-3.361,8.19,8.19,0,0,0-2.991-2.177,10.1,10.1,0,0,0-4.065-.781,8.653,8.653,0,0,0-3.59.781,9.237,9.237,0,0,0-3.032,2.2,10.9,10.9,0,0,0-2.084,3.381,11.7,11.7,0,0,0-.784,4.373,12.425,12.425,0,0,0,.8,4.608A10.046,10.046,0,0,0,329.56,77.8a9.234,9.234,0,0,0,3.2,2.114,10.211,10.211,0,0,0,3.8.718,9.537,9.537,0,0,0,3.177-.507,9.352,9.352,0,0,0,2.58-1.374,9.013,9.013,0,0,0,3.156-4.544Zm17.88-13.568a4.688,4.688,0,0,0-.516-0.085,6.628,6.628,0,0,0-.763-0.043,7.819,7.819,0,0,0-1.568.17,5.48,5.48,0,0,0-1.609.612,6.772,6.772,0,0,0-1.506,1.184,6.625,6.625,0,0,0-1.259,1.923v-3.55h-3.8v20.33h3.879V69.808q0-3.338,1.506-4.8a5.423,5.423,0,0,1,3.94-1.458,11.582,11.582,0,0,1,1.692.127V59.453ZM162.327,68.719a0.2,0.2,0,0,0,.206-0.331A11.771,11.771,0,0,1,159.061,60a20.22,20.22,0,0,0-4.147-12.314A19.33,19.33,0,0,0,139.53,40,19.773,19.773,0,0,0,120,60v11.67a8.254,8.254,0,0,0,7.63,8.319,0.493,0.493,0,0,0,.507-0.5V60h0A11.534,11.534,0,0,1,139.53,48.332a11.414,11.414,0,0,1,10.687,7.607A21.973,21.973,0,0,0,162.327,68.719ZM170.453,40a19.249,19.249,0,0,0-14.175,6.258,0.8,0.8,0,0,0-.042,1.008,21.472,21.472,0,0,1,3.549,7.748,0.185,0.185,0,0,0,.354.036,11.378,11.378,0,0,1,10.353-6.713,11.674,11.674,0,0,1-.039,23.34,22.719,22.719,0,0,1-19.119-10.551,0.2,0.2,0,0,0-.365.118,20.094,20.094,0,0,0,8.092,15.007A19.117,19.117,0,0,0,170.933,80,20.017,20.017,0,0,0,170.453,40ZM158.641,77.575a21.307,21.307,0,0,1-7.348-9.211,0.191,0.191,0,0,0-.37.072V91.678A8.251,8.251,0,0,0,158.559,100a0.487,0.487,0,0,0,.5-0.5V78.382A0.987,0.987,0,0,0,158.641,77.575Z transform=\"translate(-120 -40)\"/></svg></a></div><div class=\"menu menu-2\"><ul class=\"nav-hidden menu-items\"><li><a ng-click=ShowCreateBlogForm()>Create Blog</a></li><li><a ng-click=ShowEditBlogForm()>Edit Blog</a></li><li><a ng-click=ShowBlogComments()>Blog Comments</a></li><li><a ng-click=ShowBlogCategories()>Blog Categories</a></li></ul></div><div class=header-contact><div ng-show=true class=\"dropdown my-accont-header\"><a href=\"\" class=\"dropdown-toggle my-accont-header-link\" data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>My Account</a><ul class=dropdown-menu><li><div class=form-group><button type=button ng-click=logOut()>log out</button></div></li></ul></div></div></div><div ng-show=URLloader style=\"margin-left: 50%\"><img src=images/squares.gif width=100px height=100px></div><div class=admin-cont><div class=container-fluid ng-show=signedIn><!-- admin Blogs --><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=showEditBlogForm style=\"position:relative ;top:0px\"><div class=\"container newTable\"><h2>Blogs List</h2><input type=text class=\"form-control search-input\" placeholder=Search ng-model=searchBlog><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>Id</th><th>Name</th><th>Description</th><th>Created At</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"blog in blogs | filter:searchBlog\"><td>{{blog.id}}</td><td>{{blog.name}}</td><td>{{blog.description}}</td><td>{{blog.date | date: \'short\'}}</td><td><button type=button class=\"btn btn-success btn-sm\" ng-click=displayBlog(blog)>Edit</button></td></tr></tbody></table></div><nav aria-label=... ng-hide=hidePagination><ul class=pager><li class=previous><a href=\"\" ng-click=showCoupons(page-1,sortType)><i class=\"fa fa-chevron-left\" aria-hidden=true></i></a></li><li class=next><a href=\"\" ng-click=showCoupons(page+1,sortType)><i class=\"fa fa-chevron-right\" aria-hidden=true></i></a></li></ul></nav></div></div></div><!-- admin index page --><div class=container><div ng-show=showCreateBlogForm class=\"col-sm-12 col-md-12\"><input type=text ng-model=blog.name placeholder=\"Blog Name\" class=form-control><br><input type=text ng-model=blog.author_name placeholder=\"Author Name\" class=form-control><br><input type=text ng-model=blog.author_email placeholder=\"Author Email\" class=form-control><br><textarea ng-model=blog.description placeholder=\" Add Description \" class=form-control></textarea><select class=\"form-control mt-20\" ng-model=blog.category_id><option value=0 disabled>Select Category</option><option ng-repeat=\"category in blogCategories\" value={{category.id}}>{{category.name}}</option></select><div><br><label class=\"btn btn-primary\">Banner Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'blogBanner\')\"></label>{{blog.image}}</div><br><div text-angular ng-model=blog.content></div><input type=checkbox ng-model=blog.publish> publish <input type=checkbox ng-model=blog.feature> Feature<br><br><button class=\"btn btn-primary mb-20\" ng-click=SaveBlog(blog)>Save</button><div><label class=\"btn btn-primary\">Upload Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'blogImage\')\"></label></div><div ng-repeat=\"pic in blog.images\"><img height=250 width=250 ng-src={{pic.url}} alt=Description><p>{{pic.url}}</p></div>{{blogText}}</div></div><!-- admin Add Blog category --><div class=container><div ng-show=showCreateBlogCategoryForm class=\"col-sm-12 col-md-12\"><input type=text ng-model=category.name placeholder=\"Category Name\" class=form-control><br><textarea ng-model=category.description placeholder=\" Add Description \" class=form-control></textarea><div><label class=\"btn btn-primary\">Upload Image <input type=file style=\"display: none\" accept=image/* ng-model=image ngf-select=\"uploadImage(image, \'blogCategoryImage\')\"></label></div><button class=\"btn btn-primary mt-20\" ng-click=SaveBlogCategory(category)>Save</button></div></div><!-- admin Blog Categories --><div class=\"admin-cont admin-cont-nav\"><div class=\"col-sm-12 col-md-12\" ng-show=show_blog_categories style=\"position:relative ;top:0px\"><div class=\"container newTable\"><h2>Blog Categories</h2><button class=\"btn btn-primary mb-20\" ng-click=ShowBlogCategoryForm()>Add New Category</button> <input type=text class=\"form-control search-input\" placeholder=Search ng-model=search><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>Id</th><th>Name</th><th>Description</th><th>Created At</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"category in blogCategories | filter:search\"><td>{{category.id}}</td><td>{{category.name}}</td><td>{{category.description}}</td><td>{{category.createdAt | date: \'short\'}}</td><td><button type=button class=\"btn btn-success btn-sm\" ng-click=EditBlogCategoryForm(category.id)>Edit</button> <button type=button class=\"btn btn-danger btn-sm\" ng-click=\"DeleteBlogCategoryForm(category.id, $index)\">Delete</button></td></tr></tbody></table></div></div></div></div><!-- admin panel main page --><div ng-show=showBlogComments class=\"col-sm-12 col-md-12\" style=\"position:relative ;top:60px\"><div class=comment-section><div class=main-heading-comment><h1>Comments</h1><span>({{blogcomments.allComments.length}})</span></div><div class=main-tabs-comment ng-init=\"selected=1\" ng-show=true><ul><li ng-click=change(1) ng:class=\"{\'active\' : selected==1}\">ALL</li><li ng-click=change(2) ng:class=\"{\'active\' : selected==2}\">APPROVED</li><li ng-click=change(3) ng:class=\"{\'active\' : selected==3}\">PENDING</li><li ng-click=change(4) ng:class=\"{\'active\' : selected==4}\">HIDDEN</li></ul></div><div class=main-tabs-comment-inner><ul><li ng-class=\"{\'opc-hide\': comments.disabled}\" ng-repeat=\"comments in AllComments\"><div class=tabs-comment-inner-list><div class=tabs-comment-inner-img><div>{{comments.user.name.charAt(0).toUpperCase()}}</div></div><div class=tabs-comment-inner-list-info><div class=main-heading-comment-info><h1>{{comments.user.name}}</h1><span>{{comments.comment_time |date:\'short\'}}</span><small><img src=images/comment-user-status.png alt=\"\" ng-show=comments.approved></small></div><div class=main-heading-comment-info-midle><h2>{{comments.text}}</h2><img ng-show=comments.image_url ng-src={{comments.image_url}} height=400 width=300></div><div class=main-heading-comment-info-bottom><div ng-show=true><small ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\">|</small> <button ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\" ng-click=blogapproveComment(comments.id)>APPROVE</button> <small ng-show=!comments.hidden>|</small> <button ng-show=!comments.hidden ng-click=hideBlogComment(comments.id)>HIDE</button> <small ng-show=comments.hidden>|</small> <button ng-show=comments.hidden ng-click=unhideBlogComment(comments.id)>SHOW</button> <small ng-show=!comments.disabled>|</small> <button ng-show=!comments.disabled ng-click=deleteBlogComment(comments.id)>delete</button></div></div></div></div><ul><li ng-class=\"{\'opc-hide\': reply.disabled}\" ng-repeat=\"reply in comments.replies \"><div class=tabs-comment-inner-list><div class=tabs-comment-inner-img><div>{{reply.user.name.charAt(0).toUpperCase()}}</div></div><div class=tabs-comment-inner-list-info><div class=main-heading-comment-info><h1>{{reply.user.name}}</h1><span>{{reply.comment_time|date:\'short\'}}</span><small><img src=images/comment-user-status.png alt=\"\" ng-show=reply.approved></small></div><div class=main-heading-comment-info-midle><h2>{{reply.text}}</h2><img ng-show=reply.image_url ng-src={{reply.image_url}} height=400 width=300></div><div class=main-heading-comment-info-bottom><small ng-if=\"selected == 3 || (!reply.approved && !reply.disabled)\">|</small> <button ng-if=\"selected == 3 || (!reply.approved && !reply.disabled)\" ng-click=blogapprovereply(reply.id)>APPROVE</button> <small ng-show=!reply.hidden>|</small> <button ng-show=!reply.hidden ng-click=hideBlogReply(reply.id)>HIDE</button> <small ng-show=reply.hidden>|</small> <button ng-show=reply.hidden ng-click=showBlogReply(reply.id)>SHOW</button></div></div></div></li></ul></li></ul></div></div></div></div></div><div id=download_csv></div></div><div class=\"col-sm-12 col-md-12\" ng-show=\"    \" style=\"position:relative ;top:60px\"><h1>Comments Management</h1><table class=\"table table-bordered table-striped\"><tr><th>Video Name</th><th>Text</th><th>Approved</th><th>Disabled</th></tr><tr ng-repeat=\"data in AllComments\"><td>{{data.video_name}}</td><td>{{data.text}}</td><td><button ng-class=\"data.approved ? \'button-color-true\' : \'button-color-false\'\" ng-click=approveComment(data.approved,data.comment_id)>{{data.approved}}</button></td><td><button ng-class=\"data.disabled ? \'button-color-true\' : \'button-color-false\'\" ng-click=disableComment(data.disabled,data.comment_id)>{{data.disabled}}</button></td></tr></table></div><div ng-show=showAllCoursePage style=\"position:relative ;top:60px\"><table><tr><th>Course Name</th><th>Faculty</th><th>Institution</th><th>Save</th></tr><tr ng-repeat=\"course in allCourses\"><td><input type=text ng-model=course.name></td><td><input type=text ng-model=course.faculty></td><td><input type=text ng-model=course.institution></td><td><button ng-click=UpdateCourse(course)>Save</button></td></tr></table></div><div id=download_csv></div>");
$templateCache.put("app/directives/addToCart/addToCart.html","<div class=\"poppup-cp-container order-summary-popup\" ng-if=salePopupDiv><div class=poppup-cp-new><div class=popupCloseIcon ng-click=closePopup()><img src=\"../../../images/close iocn.png\" alt=# style=\"height: 22px\"></div><div class=\"f-c d-col alic\"><div class=\"f-c d-col\" style=\"align-items: center\"><h5 class=popupTitle>Order Summary</h5></div><div class=f-c style=\"justify-content: center\"><img style=\"height: 100px\" src=../../../images/payment/cart.png></div><div class=\"f-c d-col\" style=\"align-items: center; margin-top: 15px\"><h5 class=popupTitle>Great Choice!</h5></div><div class=cart-container><div class=cart-header><div><div style=\"font-weight: bold; font-size: 16px\">Course/Module</div></div><div><div class=text-right style=\"margin-left: 10px; font-weight: bold; font-size: 16px\">Price</div></div></div><div class=cart-row><div style=\"max-width:250px; width:100%; font-size: 16px\">{{course.name}}</div><div><p class=text-right style=\"margin-left: 10px; font-size: 16px\">PKR {{coursePrice }}</p></div></div></div><div class=promo-code style=\"width: 100%\"><div style=\"display: flex; justify-content: space-between\"><p>Promo Code</p><a href=\"https://api.whatsapp.com/send?phone=923111444734&text=Hi%20Team,%20I%20would%20love%20to%20know%20that%20if%20you%20are%20offering%20any%20promo%20codes%20for%20my%20course?\" target=_blank>Need Promo Code?</a></div><div class=row><div class=col-lg-12 style=\"position: relative\"><input ng-model=couponCode type=text class=form-control placeholder=\"Enter 10-Digit promo Code here\"> <img ng-if=showCouponGif height=25px style=\"position: absolute;\n            top: 4px;\n            right: 32px\" src=../../../images/payment/coupon-success.gif></div></div><div ng-show=\"couponMsg.length>0\" class=\"mt-10 sm-alert\" role=alert><p style=\"color: red\">{{couponMsg}}</p></div><div ng-show=\"couponSuccess.length>0\" class=\"mt-10 sm-alert\" role=alert><div style=\"color: green\">{{couponSuccess}}</div></div></div><div style=\"width: 100%\"><button type=button class=proceed ng-click=couponApplied(couponCode)>Proceed</button></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/directives/breadCrumbs/breadCrumbs.html","<div class=bread-crumbs-main><div class=bread-crumbs><ul class=bread-crumbs-list><!-- <li class=\"bread-crumbs-item\">\n                <img src=\"../../../images/bread-crumbs/home.svg\" alt=\"\"> Nearpeer.org\n            </li> --><li ng-if=show class=bread-crumbs-item ng-repeat=\"breadCrumb in list\"><a href={{breadCrumb.url}}>{{breadCrumb.displayName}}</a></li></ul></div></div>");
$templateCache.put("app/directives/courseBlocks/courseBlocks.html","<div class=\"main course-mobile\"><div class=container><div class=row><div class=col-md-12><div ng-repeat=\"course in courses\"><course-tile course=course></course-tile></div></div></div></div></div>");
$templateCache.put("app/directives/courseCart/courseCart.html","<div class=course-cart-aside ng-class=\"{\'pb-0\': isFree() && !course.excel_url && !course.courseFeature.length }\"><div class=\"profile-img profile-img-desktop\" ng-if=!payment><img src={{course.image_url}}><div ng-show=course.videoUrl class=icon-profile-modal data-toggle=modal data-target=#courseVideoDemo><span class=btn-profile-modal><i class=\"fa fa-play\"></i></span><p>Preview this Lecture</p></div></div><div ng-if=!payment ng-show=\"!isFree() || course.excel_url || course.courseFeature.length > 0 \" class=diccount-right-new><div ng-show=!isFree()><div ng-if=\"course.discount_price || course.module_type.discount\" class=\"course-prices clearfix\"><h4 class=course-offered-price ng-style=\"(course.discount_price > 19000 \n                    || course.module_type.discount > 19000) ? {\'font-size\' : \'24px\'} : \n                    {\'font-size\': \'26px\'}\" ng-show=\"course.discount_price || course.module_type.discount\">Rs.{{(course.discount_price || course.module_type.discount ) | currency:\"\":\'0\'}}</h4><p class=discount-offer><del ng-class=\"{\'del\': course.discount_price || course.module_type.discount}\">Rs. {{(course.price || course.module_type.price) | currency:\"\":\'0\' }}</del> <span class=discount-percentage>{{course.discountPercent}}% Off</span></p></div><div ng-if=\"!course.discount_price && !course.module_type.discount\" class=\"course-prices clearfix\"><h4 class=course-offered-price>Rs.{{(course.price || course.module_type.price) | currency:\"\":\'0\'}}</h4></div><p ng-show=\"course.discountDays && (course.discount_price || course.module_type.discount)\"><img src=images/course-cart/clock.png><span class=offer-time><b>{{course.discountDays}} days</b> left at this price!</span></p><div class=\"course-prices clearfix free-access-banner\" style=\"margin-bottom: 10px; margin-right: -10px\" ng-if=course.allow_on_app><div class=left-ribin style=\"float: right; padding: 4px 0 0 31px; height: 30px\" ng-style=\"{\'width\': showLoginText ? \'185px\': \'136px\'}\"><div class=\"flex-view align-items-center\"><div class=ribbon-alert-icon><img src=../../../images/ribbon-alert.gif alt=\"\"></div><p style=\"color: white;\n                font-size: 12px;\n                margin-left: 8px;\n                margin-bottom: 0\">{{showLoginText ? \'Login to Free Access\' : course.module_allow_on_app ? \"Free Module\" : \"Free on App\"}}<!-- <i class=\"free-access-info-icon glyphicon glyphicon-info-sign\"></i> --></p></div></div></div><div class=free-access-popup ng-if=course.allow_on_app><p>Get Free access to this course by Downloading</p><p style=\"font-weight: bold; color: #d01830\">Nearpeer App</p><!-- <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=\"_blank\" style=\"font-size: 18; color: red; font-weight: bold;\">Nearpeer App</a> --><div style=\"display: flex; justify-content: space-around\"><a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=_blank style=\"font-size: 15\"><img src=../../../images/play_store.svg> <span class=store_text>Play Store</span> </a><a href=https://apps.apple.com/pk/app/nearpeer/id1525357562 target=_blank style=\"font-size: 15\"><img src=../../../images/apple-app-store.svg> <span class=store_text>App Store</span></a></div></div><button ng-hide=isGuest class=btn-installment ng-click=buyNow(course)>Buy Now</button> <button ng-hide=isGuest class=mt-10 ng-click=buyNow(course) style=\"color:#45b9d6; background-color:#E8F8FB\">Use Promo Code</button> <button ng-if=\"!isInstallmentAllowed && !isGuest\" class=mt-10 title=\"Installments not Available\" style=\"background: grey !important; display: none\">Purchase on installments</button> <button class=mt-10 ng-if=\"isInstallmentAllowed && !isGuest\" ng-click=\"buyNow(course, \'qist-pay\')\" style=\"display: none\">Purchase on installments</button><div class=payment-method><ul><li><div class=payment-method-icon ng-click=\"buyNow(course, \'easypaisa\')\"><img src=../../images/payment/easypaisa.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'jazz_cash\')\"><img src=../../images/payment/jazz_cash.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'mcb\')\"><img src=../../images/payment/mcb.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'allied\')\"><img src=../../images/payment/allied.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'bankIslami\')\"><img src=../../images/payment/bank-islami.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'alflah\')\"><img src=../../images/payment/alflah.svg></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'bop\')\"><img src=../../images/payment/bop.png></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'askari\')\"><img src=../../images/payment/askari.png></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'albarka\')\"><img src=../../images/payment/al-barka.png></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'bok\')\"><img src=../../images/payment/bok.png></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'samba\')\"><img src=../../images/payment/samba.png></div></li><li><div class=payment-method-icon ng-click=\"buyNow(course, \'hmb\')\"><img src=../../images/payment/hmb.png></div></li></ul></div><!-- <div class=\"feat-qispay\" ng-hide=\"isGuest\">\n                <img src=\"../../../images/qistpay icon.png\" alt=\"\">\n                <p><b>QisstPay</b> is available now you can purchase with interest free instalments. <span><img\n                            class=\"feat-new-gif\" src=\"../../../images/feat-new.gif\" alt=\"\"></span></p>\n            </div> --> <button class=btn-empty ui-sref=paymentOptions() ng-hide=isGuest>How to pay?</button></div><div ng-show=course.excel_url class=schedule><div class=text-center><a class=course-Schedule href={{course.excel_url}} target=_blank>View Course Schedule</a></div></div><!-- schedule --><div class=course-include-desktop><p id=courseInclude ng-show=\"course.courseFeature.length > 0\">This Course includes:</p><!-- <p id=\"courseIncludeMobile\" ng-show=\"course.courseFeature.length > 0\" ng-click=\"courseIncludeDD()\"> <span> This\n                    Course includes:</span></p> --><ul ng-show=\"course.courseFeature.length > 0\" class=course-feature-list><li ng-repeat=\"cf in course.courseFeature\"><div class=course-feature-header><img class=course-feature-header-img src={{cf.featureId.imageUrl}}> <span>{{cf.featureId.name}}</span></div><div class=course-feature-desc><p>{{cf.featureId.description}}</p></div></li></ul></div><div class=mobile-course-include-overlay ng-if=courseTitleAV><div class=mobile-course-include ng:class=\"{ active : courseTitleAV}\"><div class=course-include-title><p>This Course includes:</p><div ng-click=courseIncludeDDClose()><img src=../../../images/course-cart/Vector(1).svg alt=\"\"></div></div><ul ng-show=\"course.courseFeature.length > 0\" class=course-feature-list><li ng-repeat=\"cf in course.courseFeature\"><div class=course-feature-header><img class=course-feature-header-img src={{cf.featureId.imageUrl}}> <span>{{cf.featureId.name}}</span></div><div class=course-feature-desc><p>{{cf.featureId.description}}</p></div></li></ul></div></div></div><addtocart course=course enrolled=enrolled></addtocart></div><div id=courseVideoDemo class=\"modal fade\" role=dialog ng-if=\"course.videoUrl && !payment\"><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=\"modal-body padding0\" id=yt-player><iframe width=100% height=315 ng-src=\"{{trustSrc(course.videoUrl) }}\"></iframe></div></div></div></div>");
$templateCache.put("app/directives/courseHeader/courseHeader.html","<div class=\"page-header page-header-new-cor\"><div class=container><div class=\"row header-row\"><div class=\"col-md-9 col-md-offset-3\"><div class=pushed-col-new><div class=course-header-mobile><div class=\"profile-img profile-img-mobile\"><img src={{course.image_url}}><div ng-show=course.videoUrl class=icon-profile-modal data-toggle=modal data-target=#courseVideoDemo><span class=btn-profile-modal><i class=\"fa fa-play\"></i></span><p>Preview this Lecture</p></div><div class=total-courses-mobile style=\"margin: 10px; margin-left: 0\" ng-if=course.allow_on_app><div class=free-access-banner-tile ng-click=freeOnAppPopupBtn($event)><p ng-if=\"!showLoginText && course.module_allow_on_app\">Free Module on <span>APP</span></p><p ng-if=\"!showLoginText && !course.module_allow_on_app\">Free on <span>APP</span></p><p ng-if=showLoginText style=\"margin: 0\">Login to Free Access</p><div class=ribbon-alert-icon><img src=../../../images/ribbon-alert.gif alt=\"\"></div></div><div class=\"free-access-popup-tile free-access-popup-course\" ng-if=\"course.allow_on_app  && !isReactApp && freeOnAppPopup\"><p style=\"color: #000\">Get Free access to this course by Downloading</p><p style=\"font-weight: bold; color: #D01830\">Nearpeer App</p><!-- <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=\"_blank\" style=\"font-size: 18; color: red; font-weight: bold;\">Nearpeer App</a> --><div style=\"display: flex; justify-content: space-around\"><a ng-click=$event.stopPropagation(); class=store-icon href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=_blank style=\"font-size: 15\"><img src=../../../images/play_store.svg> <span class=store_text>Play Store</span> </a><a ng-click=$event.stopPropagation(); class=store-icon href=https://apps.apple.com/pk/app/nearpeer/id1525357562 target=_blank style=\"font-size: 15\"><img src=../../../images/apple-app-store.svg> <span class=store_text>App Store</span></a></div></div></div></div><div><h2 class=header-title>{{course.name}}</h2><h4 class=header-instructor-name>By {{course.instructor_id.full_name}}</h4><div class=\"course-prices clearfix\"><h4 class=course-offered-price><span style=\"text-decoration-color: white\" ng-class=\"{\'discount-del\': course.discount_price || course.module_type.discount}\" ng-if=\"(course.price || course.module_type.price)\">PKR {{(course.price || course.module_type.price) | currency:\"\":\'0\'}}</span> <span ng-if=\"course.discount_price || course.module_type.discount\" class=discount-percentage>{{course.discountPercent}}% Off</span></h4></div><div ng-if=\"course.discount_price || course.module_type.discount\" class=\"course-prices clearfix\"><h4 class=course-offered-price>PKR {{(course.discount_price || course.module_type.discount ) | currency:\"\":\'0\'}}</h4></div></div></div><p class=course-description>{{course.short_description || alternative_desc | limitTo : 100 }} {{course.short_description.length > 100 ? \'...\' : \'\'}}<!-- <a ng-if=\"course.short_description.length > 180\n              \" class=\"readMore-btn\" ng-click=\"readMore(course.short_description.length)\">\n              {{readMoreBtn}}\n            </a> --></p><div class=course-modules><span class=course-preview-mobile><p ng-show=course.videoUrl data-toggle=modal data-target=#courseVideoDemo><i class=\"fa fa-play\"></i> Preview this Lecture</p></span><span ng-show=\"enrolled && enrolled > 0\"><i class=\"fa fa-users\"></i> Enrollments : <strong>{{enrolled}} Students</strong> </span><span ng-if=\"course.videoContent && course.videoContent > 0\"><i class=\"fa fa-play-circle\"></i> Video content: <strong>{{course.videoContent}} Hours</strong> </span><span ng-if=\"course.quizContent && course.quizContent > 0\"><i class=\"fa fa-file\"></i> Quizzes: <strong>{{course.quizContent}}</strong></span></div><!-- //.course-modules --></div></div></div><!-- //.header-row --></div></div>");
$templateCache.put("app/directives/courseInclude/courseInclude.html","<div class=course-cart-aside ng-class=\"{\'pb-0\': isFree() && !course.excel_url && !course.courseFeature.length }\"><div ng-show=\"!isFree() || course.excel_url || course.courseFeature.length > 0 \" class=diccount-right-new><!-- <p id=\"courseInclude\" ng-show=\"course.courseFeature.length > 0\"> This Course includes:</p> --><p id=courseIncludeMobile ng-show=\"course.courseFeature.length > 0\" ng-click=courseIncludeDD()><span>This Course includes:</span></p><div class=mobile-course-include-overlay ng-if=courseTitleAV><div class=mobile-course-include ng:class=\"{ active : courseTitleAV}\"><div class=course-include-title><p>This Course includes:</p><div ng-click=courseIncludeDDClose()><img src=../../../images/course-cart/Vector(1).svg alt=\"\"></div></div><ul ng-show=\"selectedCourse.courseFeature.length > 0\" class=course-feature-list><li ng-repeat=\"cf in selectedCourse.courseFeature\"><div class=course-feature-header><img class=course-feature-header-img src={{cf.featureId.imageUrl}}> <span>{{cf.featureId.name}}</span></div><div class=course-feature-desc><p>{{cf.featureId.description}}</p></div></li></ul></div></div></div></div>");
$templateCache.put("app/directives/courseTile/courseTile.html","<div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\"><div ng-click=goToCourse(course) class=signle-course><!-- style=\"background-image: url({{course.image_url}} );\" --><div class=category-img><img ng-src={{course.image_url}}><div class=total-courses-mobile ng-if=course.allow_on_app><div class=free-access-banner-tile ng-click=freeOnAppPopupBtn($event)><p ng-if=\"!showLoginText && course.module_allow_on_app\">Free Module on <span>APP</span></p><p ng-if=\"!showLoginText && !course.module_allow_on_app\">Free on <span>APP</span></p><p ng-if=showLoginText style=\"margin: 0\">Login to Free Access</p><div class=ribbon-alert-icon><img src=../../../images/ribbon-alert.gif alt=\"\"></div></div><div class=free-access-popup-tile ng-if=\"course.allow_on_app && !isReactApp && freeOnAppPopup\"><p>Get Free access to this course by Downloading</p><p style=\"font-weight: bold; color: #D01830\">Nearpeer App</p><!-- <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=\"_blank\" style=\"font-size: 18; color: red; font-weight: bold;\">Nearpeer App</a> --><div style=\"display: flex; justify-content: space-around\"><a ng-click=$event.stopPropagation(); class=store-icon href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=_blank style=\"font-size: 15\"><img src=../../../images/play_store.svg> <span class=store_text>Play Store</span> </a><a ng-click=$event.stopPropagation(); class=store-icon href=https://apps.apple.com/pk/app/nearpeer/id1525357562 target=_blank style=\"font-size: 15\"><img src=../../../images/apple-app-store.svg> <span class=store_text>App Store</span></a></div></div></div></div><div class=course-detail><div class=category-title><span ng-hide=true>{{course.institution}}</span><h4>{{course.name | limitTo: 65}} {{course.name.length > 65 ? \'...\' : \'\'}}</h4></div><div ng-hide=true class=rating><ng-rate-it ng-model=course.avg_rating read-only=true></ng-rate-it></div><div class=\"price-module clearfix\" ng-class=\"{ \'ribbon-course\' : course.allow_on_app}\"><div class=\"total-courses-desktop pull-left\" ng-if=course.allow_on_app><div class=free-access-banner-tile><div class=right-ribin style=\"float: right\"><p>{{course.module_allow_on_app ? \"Free Module\" : \"Free on App\"}}</p><div class=ribbon-alert-icon><img src=../../../images/ribbon-alert.gif alt=\"\"></div></div></div><div class=free-access-popup-tile ng-if=\"course.allow_on_app && !isReactApp\"><p>Get Free access to this course by Downloading</p><p style=\"font-weight: bold; color: #D01830\">Nearpeer App</p><!-- <a href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=\"_blank\" style=\"font-size: 18; color: red; font-weight: bold;\">Nearpeer App</a> --><div style=\"display: flex; justify-content: space-around\"><a ng-click=$event.stopPropagation(); href=\"https://play.google.com/store/apps/details?id=org.nearpeer.learning\" target=_blank style=\"font-size: 15\"><img src=../../../images/play_store.svg> <span class=store_text>Play Store</span> </a><a ng-click=$event.stopPropagation(); href=https://apps.apple.com/pk/app/nearpeer/id1525357562 target=_blank style=\"font-size: 15\"><img src=../../../images/apple-app-store.svg> <span class=store_text>App Store</span></a></div></div></div><div class=module-course-prices ng-class=\"{ \'ribbon-course-prices\' : course.allow_on_app}\"><div ng-class=\"{\'discount-del\': course.discount_price!= null && course.discount_price>0 && validDiscount(course.discountTo,course.discountFrom)}\" class=\"total-courses orignal-price pull-left\" ng-show=\"course.price>0\">PKR {{course.price}}</div><div class=\"total-courses pull-right\" ng-show=\" course.discount_price!= null && course.discount_price>0 && validDiscount(course.discountTo,course.discountFrom)\">PKR {{course.discount_price}}</div></div></div></div></div></div>");
$templateCache.put("app/directives/customForm/customForm.html","<div class=\"poppup-cp-container order-summary-popup\"><div class=poppup-cp-new><div class=popupCloseIcon ng-click=closePopup()><!-- <img src=\"../../../images/close iocn.png\" alt=\"#\" style=\"height: 22px;\" /> --></div><div class=\"f-c d-col alic\"><div style=\"width: 100%; max-height: 550px; overflow: scroll\"><form id=fb-render></form></div><div style=\"width: 100%\"><button type=button class=proceed ng-click=saveData()>Save</button></div></div></div><div class=poppup-cp-new-overlay></div></div>");
$templateCache.put("app/directives/header/adminHeader.html","<div class=\"top-area clearfix\"><div class=\"title pull-left\"><h2>{{statename}}</h2></div><div class=\"pull-right account-info\"><div class=dropdown><button class=dropdown-toggle type=button data-toggle=dropdown><span>{{getInitial(customerName)}}</span></button><ul class=dropdown-menu><li><a ng-click=logOut()>Log Out</a></li></ul></div></div></div>");
$templateCache.put("app/directives/getCourse/getCourse.html","<div class=\"col-sm-12 col-md-12 col-lg-12 filter-datepicker clearfix mb-20\"><div class=\"col-sm-12 col-md-12 col-lg-12 padding0\"><div class=\"col-xs-12 col-md-4 col-lg-4\"><label for=Institution>Select Institution</label><select class=form-control id=Institution ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-4 course-dropdown\"><div class=form-group><label for=faculty>Select Faculty</label><select class=form-control id=faculty ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-disabled=\"selected_faculty.length==0\" ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label for=courses>Select Course</label><select class=form-control id=courses ng-disabled=\"courses.length==0\" ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label for=modules>Select Module</label><select class=form-control id=modules ng-disabled=\"modules.length == 0\" ng-model=selectedModule ng-change=updateCourseModules(selectedModule)><option ng-repeat=\"module in modules\" ng-value=module.id>{{module.name}}</option></select></div></div></div>");
$templateCache.put("app/instructor_panel/DuplicateVideo/DuplicateVideo.html","<div ng-controller=DuplicateVideoController style=\"padding: 20px; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1)\"><!-- Main Selection Area --><div class=row><!-- Source Selection --><div class=col-md-6><div style=\"padding: 20px; background-color: #fff; border-radius: 8px; height: 100%\"><h3 style=\"font-size: 20px; color: #333; margin-bottom: 20px; border-bottom: 1px solid #eee; padding-bottom: 10px\">Select Videos to Duplicate</h3><div class=form-group style=\"margin-bottom: 15px\"><label for=sourceCourse>Select Course</label><ui-select ng-model=source.course theme=bootstrap style=width:100% on-select=getModulesForSource($select.selected.id)><ui-select-match placeholder=\"-- Select Course --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course in source.courses | filter: $select.search\"><span ng-bind=course.name></span></ui-select-choices></ui-select></div><div class=form-group ng-show=source.course style=\"margin-bottom: 15px\"><label for=sourceModule>Select Module</label><ui-select ng-model=source.module theme=bootstrap style=width:100% on-select=getVideosForSource($select.selected.id)><ui-select-match placeholder=\"-- Select Module --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"module in source.modules | filter: $select.search\"><span ng-bind=module.name></span></ui-select-choices></ui-select></div><div class=form-group ng-show=source.module style=\"margin-bottom: 15px\"><label for=sourceVideo>Select Video</label><ui-select ng-model=source.video theme=bootstrap style=width:100% on-select=addVideo($select.selected)><ui-select-match placeholder=\"-- Select Video to Add --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"video in source.videos | filter: $select.search\"><span ng-bind=video.name></span></ui-select-choices></ui-select></div></div></div><!-- Destination Selection --><div class=col-md-6><div style=\"padding: 20px; background-color: #fff; border-radius: 8px; height: 100%\"><h3 style=\"font-size: 20px; color: #333; margin-bottom: 20px; border-bottom: 1px solid #eee; padding-bottom: 10px\">Select Destination</h3><div class=form-group style=\"margin-bottom: 15px\"><label for=destCourse>Select Course</label><ui-select ng-model=destination.course theme=bootstrap style=width:100% on-select=getModulesForDest($select.selected.id)><ui-select-match placeholder=\"-- Select Course --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course in destination.courses | filter: $select.search\"><span ng-bind=course.name></span></ui-select-choices></ui-select></div><div class=form-group ng-show=destination.course style=\"margin-bottom: 15px\"><label for=destModule>Select Module</label><ui-select ng-model=destination.module theme=bootstrap style=width:100% on-select=getChaptersForDest($select.selected.id)><ui-select-match placeholder=\"-- Select Module --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"module in destination.modules | filter: $select.search\"><span ng-bind=module.name></span></ui-select-choices></ui-select></div><div class=form-group ng-show=\"destination.chapters.length > 0\" style=\"margin-bottom: 15px\"><label for=destChapter>Select Chapter</label><ui-select ng-model=destination.chapter theme=bootstrap style=width:100%><ui-select-match placeholder=\"-- Select Chapter --\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"chapter in destination.chapters | filter: $select.search\"><span ng-bind=chapter.name></span></ui-select-choices></ui-select></div></div></div></div><!-- Selected Videos List and Action Button --><div class=row style=\"margin-top: 20px\"><div class=col-md-12><div style=\"padding: 20px; background-color: #fff; border-radius: 8px\"><!-- Selected Videos List --><div ng-show=\"selectedVideos.length > 0\"><h4 style=\"font-size: 16px; color: #555; margin-top: 0; margin-bottom: 15px\">Selected Videos:</h4><ul class=list-group style=\"position:unset; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; padding-left: 0; margin-bottom: 20px\"><li class=list-group-item ng-repeat=\"video in selectedVideos track by $index\" style=\"display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; border-bottom: 1px solid #eee; background-color: #fff\"><span>{{video.name}}</span> <button class=\"btn btn-danger btn-xs pull-right\" ng-click=removeVideo($index) style=\"font-size: 10px; padding: 1px 5px; border-radius: 50%\"><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul></div><!-- Duplicate Button --><div class=text-center style=\"margin-top: 15px\"><button class=\"btn btn-primary\" ng-click=duplicateVideos() ng-disabled=\"!destination.module || selectedVideos.length === 0 || (destination.chapters.length > 0 && !destination.chapter)\" style=\"background-color: #007bff; border-color: #007bff; padding: 10px 20px; font-size: 16px; border-radius: 5px\">Duplicate Videos</button></div></div></div></div></div>");
$templateCache.put("app/instructor_panel/QuizResult/coursesQuizzes.html","<div class=container-setting><h2>Quizzes History</h2><div class=responsive-table><table class=table><thead><tr><th class=\"border-top-remv table_th\">#</th><th class=table_th>Course Name</th><th class=table_th>Quiz Name</th></tr></thead><tbody><tr ng-repeat=\"quiz in instructorQuiz\"><td>{{offset+$index+1}}</td><td>{{quiz.course_name}}</td><td>{{quiz.quiz_name}}</td><td><button ui-sref=InstructorPanelQuizOutCome({id:quiz.quizId})>View</button></td></tr></tbody></table></div><div class=col-lg-12 style=\"margin-bottom: 50px\"><div class=\"col-lg-6 col-xs-6\" style=text-align:center><button style=\"margin: 10px; width: 100px; height: 35px\" ng-click=showPrevious()><span>Previous</span></button></div><div class=col-lg-6 style=text-align:center><button style=\"margin: 10px; width: 100px; height: 35px\" ng-click=showNext()><span>Next</span></button></div></div></div>");
$templateCache.put("app/instructor_panel/QuizResult/outComeQuiz.html","<div class=container><div class=col-lg-12><div class=justify-content-center><div style=\"text-align: center\"><h2>Quizzes History</h2></div><div><table class=\"table quiz-summary\"><thead><tr><th>Total Marks</th><td>{{quiz.total_marks}}</td></tr><tr><th>Avg Marks</th><td>{{quiz.avg_marks | number:2}}</td></tr><tr><th>Highest Marks</th><td>{{quiz.max_marks}}</td></tr><tr><th>Lowest Marks</th><td>{{quiz.min_marks}}</td></tr><tr><th>Avg time</th><td>{{quiz.avg_time}}(s)</td></tr><tr><th>Total Attempts</th><td>{{quiz.total_attempts}}</td></tr></thead><tbody><tr><td colspan=2><button ui-sref=InstructorPanelQuizUserDetail({id:quiz_id}) class=btn-view>View</button></td></tr></tbody></table><div class=\"btn-group sort-by\"><button class=\"btn btn-default btn-lg dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>Sort by</label><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu style=\"min-width: 122px !important\"><li><a ng-click=\"sorting(\'order\')\">Quiz Order</a></li><li><a ng-click=\"sorting(\'count/1\')\">Easiest</a></li><li><a ng-click=\"sorting(\'wrong/1\')\">Difficult</a></li></ul></div><div class=clear></div><div ng-repeat=\"question in quiz.questions\" class=\"question-remarks easiest\" ng-style=\"{\'background-color\': question.backgroundColor}\"><div><div class=\"row col-lg-12\"><div class=col-lg-4><div class=ip-qz-avg-time><h3 style=\"color: #535353\">Correct Answers: {{question.count}}</h3></div></div><div class=col-lg-4><div class=ip-qz-avg-time><h3 style=\"color: #535353\">Wrong Answers: {{question.wrong}}</h3></div></div><div class=col-lg-4><div class=ip-qz-avg-time><h3 style=\"color: #535353\">Avg time: {{question.avg | number:2}} sec</h3></div></div></div><div class=\"row col-lg-12\"><div class=col-lg-8><div style=\"padding: 10px\"><h3 style=\"color: #535353\">Question {{questionNumbers[question.id]}} of {{totalQuestions}}</h3></div></div></div><div class=\"row col-lg-12\" style=\"margin-top: 40px; margin-bottom: 40px\"><div class=col-lg-10><p ng-bind-html=\"question.question | to_trusted\"></p><div ng-style=\"{\'background-color\': question.backgroundColor}\" class=ip-sol-div><p><span id=math-field-question{{$index}} class=totalValue></span></p></div></div></div><div class=col-lg-12><div class=col-lg-4><div ng-repeat=\"option in question.options\"><div ng-class=\"question.option_ids[$index] === question.correct_opt_id ? \'row ip-correct-option-div\' : \'row ip-option-div\'\"><p><span style=\"text-decoration-color: black\" id=math-field-opt{{$parent.$index}}{{$index}}></span></p><img ng-if=option.image_url ng-src={{option.image_url}} alt=\"\"></div></div></div><div class=col-lg-8><div style=\"text-align: center\"><img src={{question.image_url}} alt=\"\"></div><div class=clear></div></div></div></div><div class=col-lg-12><div class=ip-qz-q-sol-div><div ng-style=\"{\'background-color\': question.backgroundColor}\" class=ip-sol-div><p><label style=\"color: #535353\">Solution:</label><span id=math-field-sol{{$index}} class=totalValue></span></p><div class=col-lg-12><div ng-if=question.solution_image style=\"text-align: center; margin:30px\"><img src={{question.solution_image}} alt=\"\"></div><div class=clear></div></div></div></div></div><div class=clear></div></div></div></div></div></div>");
$templateCache.put("app/instructor_panel/QuizResult/resultAllUser.html","<div class=container-setting><h2>Quizzes History</h2><div class=responsive-table><table class=table><thead><tr><th class=border-top-remv>#</th><th>User Name</th><th>Total Questions</th><th>correct Questions</th><th>attempted Questions</th><th>Quiz Duration</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"quiz in allQuiz\"><td>{{$index+1}}</td><td>{{quiz.user_name || quiz.name}}</td><td>{{quiz.total}}</td><td>{{quiz.correct}}</td><td>{{quiz.attempted}}</td><td>{{quiz.quiz_duration}}</td><td>{{quiz.date | date: \'dd MMMM, yy\'}}</td><td ng-click=viewQuizResult(quiz.id)><button>View</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/instructor_panel/allCourses/allCourses.html","<div class=ip-courses-container-centered ng-show=showData style=\"padding-top: 40px\"><div class=ip-page-title><h1 class=ip-sidebar-mbl>Courses</h1><!-- <h1 class=\"ip-sidebar-web\"></h1> --><div class=\"ip-sidebar-web main-headeing-inst\"><h3>{{instructorName}}, WELCOME TO THE instructor panel</h3><p>Get started by creating a new course</p></div><button class=ip-btn-3 ng-click=goToNewCoursePage()>ADD A NEW COURSE</button></div><div class=First-page-inst><div class=\"ip-sidebar-mbl main-headeing-inst\"><h1>{{instructorName}}, WELCOME TO THE instructor panel</h1><p>Get started by creating a new course</p></div><!-- <div class=\"add-new-course\">\n      <h3 ng-click=\"goToNewCoursePage()\">ADD A NEW Course</h3>\n    </div> --><div ng-show=\"instructor_courses.length > 0\" class=my-course-cont><h2 style=\"padding-bottom: 20px;font-weight: 700\">My Courses:</h2><!-- <div class=\"my-course-list\" style=\"padding-bottom: 50px;\">\n        <ul>\n          <div ui-sortable ng-model=\"instructor_courses\">\n            <li ng-repeat=\"course in instructor_courses\" style=\"height: 30px;\">\n              <div class=\"my-course-list-left\"> <span>{{$index+1}}</span>\n                <h3 title=\"{{course.name}}\">{{course.name}}</h3>\n              </div>\n              <div class=\"my-course-list-right\"> <a ng-click=\"deleteCourse(course.id,$index)\" class=\"dlt\">&nbsp;</a> <a\n                  ng-click=\"goToEditCoursePage(course.id,$index)\" class=\"edit\">&nbsp;</a> </div>\n            </li>\n          </div>\n        </ul>\n      </div> --><div class=ip-boxshadow><table class=\"my-course-list table table-responsive table-borderless\"><thead><tr><th style=\"min-width: 70px; width: 70px; text-align: center;font-weight: 700\">Sr No.</th><th style=\"font-weight: 700\">Course Name</th><th style=\"text-align: right; padding: 0 20px;font-weight: 700\">Actions</th></tr></thead><tbody><tr ng-repeat=\"course in instructor_courses\" ng-click=goToEditCoursePage(course.id,$index)><td style=\"text-align: center\"><span>{{$index+1}}</span></td><td class=course-hover><div class=my-course-list-left><p title={{course.name}}>{{course.name}} <span ng-if=course.archived style=\"color: red; font-weight: bold; cursor: pointer\" title=ARCHIVED ng-mouseenter=$event.stopPropagation() ng-mouseleave=$event.stopPropagation() ng-click=$event.stopPropagation()>❌</span></p></div></td><td><div class=my-course-list-right><a ng-click=\"deleteCourse(course.id,$index, $event)\" class=dlt>&nbsp;</a><!-- <a ng-click=\"goToEditCoursePage(course.id,$index)\" class=\"edit\">&nbsp;</a> --> <a ng-click=\"ipEditPopupBtn($event, course.id)\" class=edit>&nbsp;</a></div></td></tr></tbody></table></div></div></div></div><div class=ip-popup ng-if=ipEditPopup style=\"padding: 40px 10px\"><div class=ip-popup-container style=\"height: 100%\"><div class=ip-popup-close ng-click=ipEditPopupClose()><img src=../../../images/close-popup.png alt=\"\"></div><div class=ip-poup-title><h2>Edit Course</h2></div><div class=ip-popup-body><div class=form-group><label for=exampleInputEmail1>Name</label><input type=text name=course-name class=form-control ng-model=selectedCourse.name ng-bind=selectedCourse.name placeholder=\"Course name\" ng-blur=validateName(selectedCourse.name)></div><div class=form-group><label for=exampleFormControlTextarea1>Descriptions</label><textarea class=form-control ng-model=selectedCourse.description ng-model=selectedCourse.description rows=8></textarea></div><div class=form-group><!-- <label>Total Price</label>\n        <input type=\"number\" class=\"form-control mb-50\" ng-model=\"selectedCourse.price\" ng-bind=\"selectedCourse.price\"\n          name=\"course-name\" placeholder=\"Please enter the price of course in PKR\" ng-disabled=\"!selectedCourse.paid\"\n          min=\"0\">\n        <label>Discounted Price</label>\n        <input type=\"number\" class=\"form-control mb-50\" ng-model=\"selectedCourse.discount_price\"\n          ng-bind=\"selectedCourse.discount_price\" name=\"course-name\"\n          placeholder=\"Please enter the discounted price of course in PKR\"\n          ng-disabled=\"!selectedCourse.price && !selectedCourse.price > 0\" min=\"0\"> --><div class=\"publish form-group ip-course-detail-box\"><div><label>Price</label><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=selectedCourse.paid> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=pr-15><label>Total Price</label><input type=number class=\"form-control mb-20\" ng-model=selectedCourse.price name=course-name placeholder=\"Total price in PKR\" ng-disabled=!selectedCourse.paid min=0></div><div><label>Discounted Price</label><input type=number class=\"form-control mb-20\" ng-model=selectedCourse.discount_price name=course-name placeholder=\"Discounted price in PKR\" ng-disabled=\"!selectedCourse.price && !selectedCourse.price > 0\" min=0></div></div><div class=\"clearfix mb-20\" ng-show=selectedCourse.discount_price><label>Discount Validity</label><div class=\"col-sm-12 col-md-12 col-lg-12 padding0 ip-course-date\"><div><div layout-gt-xs=row><div flex-gt-xs class=ip-date-pr-15><label for=from>From: &nbsp;&nbsp;</label><input type=date class=\"form-control mb-20 ip-course-date-inputs\" ng-model=selectedCourse.discountFrom name=FROM style=\"width: auto\"><!-- <md-datepicker ng-model=\"selectedCourse.discountFrom\" md-placeholder=\"Set Date\">\n                     </md-datepicker> --></div></div></div><div><div layout-gt-xs=row><div flex-gt-xs><label for=to>To: &nbsp;&nbsp;</label><input type=date class=\"form-control mb-20 ip-course-date-inputs\" ng-model=selectedCourse.discountTo name=To style=\"width: auto\"><!-- <md-datepicker ng-model=\"selectedCourse.discountTo \" md-placeholder=\"Set Date\">\n                     </md-datepicker> --></div></div></div></div></div></div><div class=text-center><p>{{errorMsg}}</p><button ng-click=saveData(selectedCourse) class=ip-btn-3>Save Changes</button></div></div></div></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div><div style=\"display: none\"><button ng-click=addFaculties()>addFaculties</button></div>");
$templateCache.put("app/instructor_panel/assignments/assignments.html","<div class=container-fluid><div class=\"comment-section-new row\"><div class=comment-section><div class=chips-div><div class=ip-search-bar><div style=\"display: flex; flex-direction: column\"><input placeholder=Search class=ip-question-input ng-model=searchText><div style=\"display: flex;\n                justify-content: space-between;\n                margin-top: 10px\"><div class=\"flex-view flex-direction-col\"><label for=dateFrom style=\"margin: 0\">From:</label><md-datepicker ng-model=fromDate md-placeholder=\"Start Date\"></md-datepicker></div><div class=\"flex-view flex-direction-col\"><label for=dateTo style=\"margin: 0\">To:</label><md-datepicker ng-model=toDate md-placeholder=\"End Date\"></md-datepicker></div></div></div><div class=ip-question-search-button><button class=ip-question-search ng-click=searchQuery()><img style=\"margin: 0px 5px\" src=./../../../images/QSearch.svg> <span>Search</span></button> <button class=ip-question-search style=\"color: #133c5c;\n                border: 1px solid #133c5c;\n                background: white\" ng-click=clearFilter()><img style=\"margin: 0px 5px\" src=\"./../../../images/delete_outline_black_24dp 1.svg\"> <span>Clear</span></button></div></div><div class=students-filter><div class=question-filter-container><div class=ind-filter ng:class=\"{ \'ind-filter-selected\' :filterSelected.all }\" ng-click=\"changeFilter(\'all\')\">All({{totalSubmitions || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.unassigned }\" ng-click=\"changeFilter(\'unassigned\')\" style=\"margin-right: 0\">Unassigned({{countStats.submitted || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.assigned }\" ng-click=\"changeFilter(\'assigned\')\">Assigned({{countStats.assigned || 0}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.answered }\" ng-click=\"changeFilter(\'answered\')\">Marked({{countStats.checked + countStats.draft || 0}})</div></div></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=showData class=\"table-responsive col-xs-12 ip-questions-table\"><!-- table-bordered table-striped --><div class=ledger-question><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ff000021\"></li><p>Unassigned</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ffff0045\"></li><p>Assigned & Unmarked</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #00800040\"></li><p>Marked</p></div></div><table class=\"table custom-question\" ng-if=!noData><thead><tr><th><div class=question-table-head><label>Status</label></div></th><th><div class=question-table-head><label>Action</label></div></th><th><div class=question-table-head><label>Submition</label></div></th><th><div class=question-table-head><label>Assignment Name</label></div></th><th><div class=question-table-head><label>Student ID</label></div></th><th><div class=question-table-head><label>Student Name</label></div></th><th><div class=question-table-head><label>Email</label></div></th><th><div class=question-table-head><label>Contact Number</label></div></th><th><div class=question-table-head><label>Marks</label></div></th><!-- <th>\n                <div class=\"question-table-head\">\n                  <label>Time</label>\n                </div>\n              </th> --><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'submittedAt\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'submittedAt\')\"><img src=./../../../images/QDWN.svg></div></div><label>Date & Time</label></div></th></tr></thead><tbody><tr ng-repeat=\"assignment in assignmentSubmistions\" :id={{$index}} style=\"height: 80px\" ng:class=\"{ \'unassigned-color\' : assignment.status === \'submitted\' ,\'answered-color\' : assignment.status === \'draft\' || assignment.status === \'checked\' ,\'unanswered-color\' : assignment.status === \'assigned\' }\"><td><p ng-if=\"assignment.status === \'checked\' && assignment.instructor_checked\">Answered by {{assignment.instructor_checked.email}}</p><p ng-if=\"assignment.status === \'draft\'\">Answered by {{assignment.instructor_checked.email}}</p><p ng-if=\"assignment.status === \'assigned\' && assignment.instructor\"><!-- {{question.assigned_to != null ? \"Assigned to \" +\n                  question.assigned_to_user_full_name : \"Unanswered\" }} --> Assigned to {{assignment.instructor.email}}<!-- <img\n                    style=\"cursor: pointer\"\n                    ng-click=\"assignToInstructor(assignment,\'update\')\"\n                    src=\"./../../../images/admin_edit_inst.svg\"\n                  /> --></p><button class=assign-admin-btn ng-click=assignToInstructor(assignment) ng-if=\"!assignment.instructor && !assignment.instructor_checked\">Assign To Instructor</button></td><td><!-- <td>{{question.is_answered != null ? question.is_answered : \"Unanswered\" }}</td> --><!-- <p ng-if=\"question.is_answered\">\n                  {{question.is_answered != null ? \"Answered\": \"Unanswered\" }}\n                </p> --> <button class=assign-admin-btn ng-click=answerStudent(assignment) ng-if=\"assignment.status === \'checked\' || assignment.status === \'draft\'\" style=\"margin: 0 auto; background-color: #0b99e9\">Edit Answer</button> <button class=assign-admin-btn ng-click=answerStudent(assignment) ng-if=\"assignment.status !== \'checked\' && assignment.status !== \'draft\'\" style=\"margin: 0 auto; background-color: #0b99e9\">Send Answer</button></td><td class=question-view-td><button class=question-view ng-click=downloadAssignment(assignment)>Download Assignment</button></td><td>{{assignment.assignment_campaign.name}}</td><td>{{assignment.student.id}}</td><td>{{assignment.student.full_name}}</td><td class=question-email-cell>{{assignment.student.email}}</td><td>{{assignment.student.phone}}</td><td ng-if=\"assignment.obtained_marks && assignment.total_marks\">{{assignment.obtained_marks}} / {{assignment.total_marks}}</td><td ng-if=\"!assignment.obtained_marks || !assignment.total_marks\">N/A</td><td>{{assignment.submittedAt | date:\'short\'}}</td><!-- <td>{{question.created_at | date:\'mediumDate\'}}</td> --><!-- class=\"question-view-td\" --></tr></tbody></table><h3 style=\"display: flex; justify-content: center\" ng-if=noData>No Relevant Data Found!</h3><div ng-if=\"showData && totalPageCount > 1\" class=pagination-main><div class=inner-pagination><div class=q-left-arrow ng-show=\"currentPage != 1\" ng-click=\"pageChange(currentPage - 1)\"><img src=./../../../images/insLeft.svg></div><div class=question-pagination><p class=q-page ng-click=pageChange(pageTag) ng-repeat=\"pageTag in pageArr\" ng:class=\"{ \'q-page-selected\' : currentPage === pageTag }\" ng-show=\"pageTag <= totalPageCount\">{{pageTag}}</p><!-- <p class=\"q-page\" ng-click=\"pageChange()\">2</p> --></div><div class=q-right-arrow ng-show=\"currentPage != totalPageCount\" ng-click=\"pageChange(currentPage + 1)\"><img src=./../../../images/insRight.svg></div></div></div></div></div></div></div><div class=ip-popup ng-if=\"displayQuestion || displayAnswer\"><div class=ip-display-question><img ng-click=closeQuestion() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1 ng-if=displayQuestion>Question</h1><h1 ng-if=displayAnswer>Answer</h1></div><div class=question-sec><div class=question-text-div><p ng-if=!containsLinks>{{selectedQuestion}}</p><div ng-if=containsLinks ng-bind-html=selectedQuestion></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && !isYoutube\"><img ng-if=\"notAvideo && !isPDF\" ng-click=previewEnlargedImage(selectedQuestionImage) style=\"cursor: pointer\" src={{selectedQuestionImage}} onloadeddata=angular.element(this).scope().imageLoadCheck() onload=angular.element(this).scope().imageLoadCheck()> <img src=images/squares.gif ng-if=imageshowloader><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup><button ng-if=\"notAvideo && !isPDF\" class=question-view ng-click=\"displayQuestion ? previewEnlargedImage(selectedQuestionImage,question) : previewEnlargedImage(selectedQuestionImage,answer) \">Preview Image</button> <a ng-if=\"notAvideo && isPDF\" class=question-view href={{selectedQuestionImage}} target=_blank>Download File</a></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><!-- <iframe width=\"420\" height=\"315\" ng-src=\"{{selectedAnswerImage}}\" allowfullscreen frameborder=\"0\">\n          </iframe> --><iframe width=420 height=315 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div></div></div></div></div><div class=ip-popup ng-click=closePreviewImage(); ng-if=imagePreview><div><img ng-click=\"closePreviewImage(); $event.stopPropagation();\" src=./../../../images/Icon-Close-black.svg style=\"position: absolute;\n        top: 14px;\n        right: 18px;\n        background: white;\n        border-radius: 11px\"> <img ng-click=$event.stopPropagation(); class=image-preview src={{previewImage}}></div></div><div class=ip-popup ng-if=answerQuestion><div class=ip-display-question><img ng-click=closeAnswerWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1>Upload Marked Assignment</h1></div><div class=question-sec><div class=assignment-text-div><label style=\"font-size: 12px; display: flex; align-items: center\"><img style=\"width: 18px; height: 18px; margin-right: 5px\" src=./../../../images/infoQU.svg> Assignment Remarks</label><textarea style=\"max-height: 200px;\n              min-height: 50px;\n              width: 85% !important;\n              margin: 8px 10px 0px 0px;\n              border: 1px solid #eaeaea\" ng-model=result.remarks placeholder=\"Enter your Remarks\">\n          </textarea><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\"><div><label style=\"font-size: 12px; display: flex; align-items: center\">Total Marks</label><input type=number ng-model=result.total_marks placeholder=\"Total Marks\" style=\"border: 1px solid #eaeaea\"></div><div style=\"margin-left: 25px\"><label style=\"font-size: 12px; display: flex; align-items: center\">Obtained Marks</label><input type=number ng-model=result.obtained_marks placeholder=\"Obtained Marks\" style=\"border: 1px solid #eaeaea\"></div></div><div class=\"flex-view flex-direction-row-col\" style=\"margin-top: 15px\" ng-if=result.isSMS><div style=\"width: 40%\"><label style=\"font-size: 12px; display: flex; align-items: center\">SMS Text</label><input type=text ng-model=result.sms_text placeholder=\"SMS Text\" style=\"border: 1px solid #eaeaea; width: 100%\"></div></div></div><div ng-if=\"selectedAnswerImage && !isYoutube\" class=question-image style=\"margin-top: 20px\"><a href={{selectedAnswerImage}} target=_blank style=\"display: flex; flex-direction: column; align-items: center\"><img style=\"width: 45px; height: 45px; margin-bottom: 8px\" src=./../../../images/newspaper-svgrepo-com.svg> Uploaded File</a></div><div ng-if=imageLoad class=main-instr-assign-upload-file style=\"justify-content: center;\n            align-items: center;\n            display: flex;\n            margin-top: 20px\"><div class=progress><div class=progress-bar role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: uploadProgress + \'%\'}\">{{uploadProgress}}%</div></div></div><div ng-if=!selectedAnswerImage style=\"display: flex; justify-content: center; margin-top: 20px\"><div class=\"dropdown show\" style=\"border: 1px solid #eaeaea; width: 200px\"><label style=\"width: 100%; display: flex; justify-content: space-between\" ng-click=handleOptions() class=\"btn btn-secondary dropdown-toggle\" href=# role=button id=dropdownMenuLink data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{defaultDropDown}} <img style=\"margin-left: 5px\" src=./../../../images/commentarrows.svg></label><!-- class=\"dropdown-menu\" --><div style=\"display: flex;\n                flex-direction: column;\n                border: 1px solid #eaeaea;\n                padding: 6px 12px;\n                background: white;\n                position: absolute;\n                width: 200px\" ng-if=showOptions aria-labelledby=dropdownMenuLink><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Assignment Link\')\">Assignment Link</label><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Upload through System\')\">Upload through System</label></div></div></div><div class=\"flex-view flex-direction-row-col\" style=\"justify-content: space-evenly; padding: 15px\"><!-- <button\n            ng-click=\"attachFile()\"\n            style=\"\n              background: #d4165a;\n              color: white;\n              padding: 2px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex;\n            \"\n            .png, .jpg, .jpeg\n          > --> <input type=file id=imageUploadd accept=application/pdf ng-model=selectedImageAnswer style=\"visibility: hidden; width: 100px\" ng-hide=linkUpload onchange=angular.element(this).scope().onImageSelected(event)><!-- position: absolute; --><label style=\"background: #d4165a;\n              color: white;\n              padding: 8px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex\" ng-if=!linkUpload for=imageUploadd>Attach PDF</label><input type=text ng-model=result.markedAssignmentLink name=markedlink placeholder=\"Add Marked Assignment Link\" ng-if=linkUpload style=\"border: 1px solid #eaeaea; margin-left: 20px\"><!-- onblur=\"angular.element(this).scope().youtubePreview(event.target.value)\" --><div ng-if=imageLoad><img style=\"height: 40px\" src=images/squares.gif></div><!-- ng-show=\"!imageLoad\" --> <button class=assign-admin-btn style=\"display: flex; align-items: center\" ng-click=\"imageLoad ? \'\' : sendAnswer(answerText,videoLink)\"><!-- <span  >Uploading</span> --> <span>Submit Back to Admin</span></button></div></div></div></div></div>");
$templateCache.put("app/instructor_panel/VideoPopup/videoPopup.html","<div class=new-popup ng:class=\"{ \'vid-custom-question\' : fromQuestions}\" ng-click=closeForm()></div><div class=loginForm ng:class=\"{ \'question-video-popup-form\'  : fromQuestions,\n\'popup-form\' : !fromQuestions }\"><span class=\"close fa fa-times\" ng:class=\"{ \'vid-custom-question\' : fromQuestions}\" ng-click=closeForm()></span><div ng-cloak><div><div class=cont-video-landing ng:class=\"{ \'question-video-popup\' : fromQuestions}\" id=cont-video-landing ng-dblclick=dblClick() ng-hide=displayAd><div class=video-overly-info><h3>{{stamp}}</h3><h3>www.nearpeer.org</h3></div><!-- <div ng-if=\"waterMark\" class=\"video-marquee\">\n          <span class=\"text marquee-text\">{{userInfo}}</span>\n        </div> --><video id=example-video class=video-js height=400px controls data-setup=\'{ \"playbackRates\": [0.25, 0.5, 1, 1.25, 1.5, 2] }\'></video><div class=overlay-cont id=overlay-cont><div class=container-video id=button-bar><div class=overlay-cont-left><ul><li><div class=buffered><input class=bufferbar type=range id=buffer-bar value=0 step=0.5 range disabled></div></li><li><div class=progresss id=progress><input class=seekbar type=range id=seek-bar value=0 step=0.5 ng-model=value ng-click=updateProgress(value)></div></li><li class=play><a ng-click=play_pause()><img id=playBtn src=images/play-cont.png alt=\"\"><img id=pauseBtn class=pause-icon src=images/pause-icon.png alt=\"\"></a></li><!-- <li class=\"controller-perv\">\n                  <a ng-click=\"skipRwdVideo(15)\"\n                    ><img src=\"images/perv-cont.png\" alt=\"\"\n                  /></a>\n                </li> --><!-- <li class=\"share-info\"><a>15</a></li> --><!-- <li class=\"controller-next\">\n                  <a ng-click=\"skipFwdVideo(15)\"\n                    ><img src=\"images/farwrd-cont.png\" alt=\"\"\n                  /></a>\n                </li> --></ul></div><div class=right-panel-video><ul><!-- <li class=\"resize-video\">\n                  <a ng-click=\"fullScreen()\"\n                    ><img id=\"fullScrBtn\" src=\"images/resize-close.png\" alt=\"\"\n                  /></a>\n                  <a ng-click=\"exitFulScreen()\"\n                    ><img\n                      id=\"exitFlScrBtn\"\n                      src=\"images/resize-back.png\"\n                      alt=\"close full screen\"\n                  /></a>\n                </li> --><li class=vol><a ng-click=mute()><img id=volBtn src=images/vol-cont.png alt=\"\"><img id=muteBtn class=mute-icon src=images/mute-icon.png alt=\"\"></a><input class=volume type=range id=volume-bar min=0 max=1 step=0.1 value=1></li><li class=playback-rate ng:class=\"{ \'vid-custom-question\' : fromQuestions}\"><div class=play-back-web><p ng-click=showPlaybackOptions()>{{playbackVal}}x</p><ul ng-show=playbackOpt><li ng-click=playBackRate(4)>4x</li><li ng-click=playBackRate(2)>2x</li><li ng-click=playBackRate(1.5)>1.5x</li><li ng-click=playBackRate(1.2)>1.2x</li><li ng-click=playBackRate(1)>1x</li><li ng-click=playBackRate(0.7)>0.7x</li><li ng-click=playBackRate(0.5)>0.5x</li></ul></div></li><li class=time><a><p id=timeLeft></p></a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/instructor_panel/chapter/chapter.html","<!-- <div class=\"three-page-inst four-page-inst container-fluid\">\n  <div class=\"three-page-inst-right\">\n    <ul style=\"margin-left: 20px;\">\n      <li>\n        <label>Chapter Title</label>\n        <input type=\"text\" name=\"course-name\" placeholder=\"Chapter 1\" ng-model=\"selectedChapter.name\">\n      </li>\n    </ul>\n  </div>\n  <div class=\"three-page-inst-bottom\">\n    <div class=\"my-course-cont\">\n      <div style=\"margin-left: 20px;\" ng-show=\"chapterEditing\" class=\"add-new-course add-new-course-one\" ng-click=\"goToVideoPage()\" ng-show=\"editingModule\">\n      <h3>aDD/Edit Videos</h3>\n      </div>\n      <div class=\"btn-save\" style=\"margin-left: 20px;\">\n        <p> {{errorMsg}}</p>\n        <button ng-click=\"saveData(selectedChapter)\">Save Changes</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"overlay-box-intr\" ng-hide=\"showData\">\n<img src=\"images/nearpeer-loading.gif\">\n</div> -->");
$templateCache.put("app/instructor_panel/comments/comments.html","<div style=top:100px;position:relative class=\"container-fluid admin-and-instructor-comment\"><div class=\"comment-section-new row\"><div class=\"comment-section col-md-8 col-md-offset-2\"><div class=main-heading-comment><h1>Comments</h1><span>({{AllComments.length}})</span></div><div class=comments-vpopup ng-if=showVideoPopup><video-popup video=selectedVideo></video-popup></div><div class=\"col-md-10 col-md-offset-5 ng-binding no-of-pages\" style=\"margin-bottom: 30px;display: flex;align-items: center;justify-content: center\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=getComments(page-1)><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=getComments(page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span style=\"padding-left: 15px\">{{page}} in {{totalPages}}</span></div><!-- <div style=\"margin-bottom: 20px;\">\n        <div>\n          <label>Filters</label>\n          <select style=\"width: 150px;\" ng-model=\"replyFilter\" class=\"form-control\" ng-change=\"\" aria-invalid=\"false\" placeholder=\"Select One\">\n            <option value=\"all\" selected>All</option>\n            <option value=\"replied\">Replied</option>\n            <option value=\"pending\">Pending</option>\n          </select>\n        </div>\n        <div>\n          <label>Select Course</label>\n          <select style=\"width: 150px;\" ng-model=\"selectedCourse\" ng-change=\"selectCourse()\" class=\"form-control\" ng-change=\"\" aria-invalid=\"false\" placeholder=\"Select One\">\n            <option ng-repeat=\"course in instructorCourses\" value=\"{{course.id}}\">{{course.name}}</option>\n          </select>\n        </div>\n      </div> --><div class=main-tabs-comment ng-init=\"selected=1\"><ul><li ng-click=change(1) ng:class=\"{\'active\' : selected==1}\">ALL</li><li ng-click=change(2) ng:class=\"{\'active\' : selected==2}\">APPROVED</li><li ng-click=change(3) ng:class=\"{\'active\' : selected==3}\">PENDING</li><li ng-click=change(4) ng:class=\"{\'active\' : selected==4}\">HIDDEN</li></ul></div><div class=main-tabs-comment-inner><ul><li ng-class=\"{\'opc-hide\': comments.disabled}\" ng-repeat=\"comments in AllComments | filter: customFilter\" style=\"padding-bottom: 15px\"><div class=tabs-comment-inner-list ng-style=\"comments.replies.length > 0 && {\'background-color\':\'aquamarine\'}\"><div class=tabs-comment-inner-img><div>{{getInitialLetter(comments.user_name)}}</div></div><div class=tabs-comment-inner-list-info style=\"position: relative\"><div class=main-heading-comment-info></div><div class=custom-user-comment><div class=user-detail><h1>{{comments.user_name}}</h1><span class=comment-date>{{comments.time |date:\'short\'}}</span><div ng-class=\"{\'abc\': selected == 3}\" style=\"margin-bottom: 10px; text-decoration: underline; color: blueviolet\"><img src=images/comment-user-status.png alt=\"\" ng-show=comments.approved> <span ng-click=goToVideo(comments.videoUrl)>{{comments.videoName}}</span></div><div class=main-heading-comment-info-midle><h2 ng-bind-html=comments.text></h2><img ng-show=comments.image_url ng-src={{comments.image_url}} height=400 width=300></div><div class=main-heading-comment-info-bottom><button ng-click=hideShowReply(comments)>REPLY</button><div><small ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\"></small> <button ng-if=\"selected == 3 || (!comments.approved && !comments.disabled)\" ng-click=approveComment(comments.comment_id)>APPROVE</button> <small ng-show=!comments.disabled></small> <button ng-show=!comments.disabled ng-click=hideComment(comments.comment_id)>HIDE</button></div><div class=comment-bottom-one ng-show=comments.showReply><textarea ng-model=replyText ng-attr-id=\"{{ comments.comment_id }}\">Write a comment...</textarea><div class=comment-area-first-bottom><button ng-click=instructorReply(replyText,comments.comment_id,comments)>Reply</button><!-- <button class=\"attach-icon\" >&nbsp;</button> --> <input type=file class=\"attach-icon ng-pristine ng-valid ng-empty ng-touched\" ng-attr-id=\"{{ \'file-\'+comments.comment_id }}\" accept=image/* ng-model=image ngf-select=addImage(image) aria-invalid=false> <img class=load-new src=images/img-uploader-loader.gif ng-show=imageUploadingInProcess></div></div></div></div></div></div></div><!-- </div> --><ul><li ng-class={} ng-repeat=\"reply in comments.replies \"><div class=tabs-comment-inner-list><div class=tabs-comment-inner-img><div>{{getInitialLetter(reply.user_name)}}</div></div><div class=tabs-comment-inner-list-info><div class=main-heading-comment-info><h1>{{reply.user_name}}</h1><span>{{reply.time|date:\'short\'}}</span><small><img src=images/comment-user-status.png alt=\"\" ng-show=reply.approved></small></div><div class=main-heading-comment-info-midle><h2 ng-bind-html=reply.text></h2><img class=img-fluid-custom ng-show=reply.image_url ng-src={{reply.image_url}} height=300 width=200></div><div class=main-heading-comment-info-bottom><!-- <button ng-click=\"hideShowReply(reply)\">REPLY </button> --> <small ng-show=isInstructor></small> <button ng-show=isInstructor ng-click=hideReply(reply.id)>HIDE</button><div class=comment-bottom-one ng-show=reply.showReply><div class=img-label><div>{{imageInitial}}</div></div><textarea ng-model=replyText ng-attr-id=\"{{ comments.comment_id }}\">Write a comment...</textarea><div class=comment-area-first-bottom><button ng-click=instructorReply(replyText,reply.comment_id,reply)>Reply</button><!-- <button class=\"attach-icon\" >&nbsp;</button> --> <input type=file class=\"attach-icon ng-pristine ng-valid ng-empty ng-touched\" ng-attr-id=\"{{ \'file-\'+comments.comment_id }}\" accept=image/* ng-model=image ngf-select=addImage(image) aria-invalid=false> <img class=load-new src=images/img-uploader-loader.gif ng-show=imageUploadingInProcess></div></div><!-- <textarea>Write a comment...</textarea> --></div></div></div></li></ul></li></ul></div></div></div></div>");
$templateCache.put("app/instructor_panel/dashboard/dashboard.html","<div class=instructor-dashboard-container><div class=container-fluid ng-show=\"showData \"><!-- TOP ROW --><div style=\"text-align: center; text-align: center\" class=\"ip-dashboard-responsive enrolled-cont container-fluid mt-30\"><div class=ip-page-title><h1 class=ip-sidebar-mbl>Dashboard</h1><h1 class=ip-sidebar-web></h1><div class=row style=\"align-items:center; gap:15px; display:flex; flex-wrap:wrap\"><!-- From Date --><!-- <div style=\"display:flex; align-items:center; gap:8px;\">\n        <h5 class=\"first_inner\">From:</h5>\n        <md-datepicker ng-model=\"sDate\" md-placeholder=\"Select Date\" md-max-date=\"maxDate\"></md-datepicker>\n      </div> --><div style=\"display:flex; align-items:center; gap:8px; margin-bottom:10px\"><h5 class=first_inner style=\"margin:0; white-space:nowrap; flex-shrink:0\">From:</h5><input type=date class=form-control id=from ng-model=uiStart ng-change=updateDates() style=\"max-width: 200px\"></div><div style=\"display:flex; align-items:center; gap:8px; margin-bottom:10px\"><h5 class=first_inner style=\"margin:0; white-space:nowrap; flex-shrink:0\">To:</h5><input type=date class=form-control id=to ng-model=uiEnd ng-change=updateDates() style=\"max-width: 200px\"></div><!-- To Date --><!-- <div style=\"display:flex; align-items:center; gap:8px;\">\n        <h5 class=\"first_inner\">To:</h5>\n        <md-datepicker ng-model=\"eDate\" md-placeholder=\"Select Date\" md-max-date=\"maxDate\"></md-datepicker>\n      </div> --><!-- Course Dropdown --><div class=btn-group style=position:relative><button class=\"btn btn-default btn-lg dropdown-toggle instructor-dashboard-search-filters-centered\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false id=courseDropdownBtn><p style=margin:0>{{selectedCourse | limitTo:35}}</p><span class=caret style=margin-left:10px></span></button><ul class=\"dropdown-menu ip-dropdwon-menu\" style=\"max-height:300px; overflow-y:auto\"><!-- Search Input --><li style=\"padding:8px 12px; position:sticky; top:0; background:white; z-index:1\"><input type=text class=form-control placeholder=\"Search courses...\" ng-model=courseSearchText ng-click=$event.stopPropagation() style=\"width:100%; border:1px solid #ddd; border-radius:4px; padding:6px 10px\"></li><li class=divider style=margin:0></li><!-- Course List --><li ng-repeat=\"course in instructor_courses | filter:{name: courseSearchText} track by course.id\"><a ng-click=getCourseData(course)>{{course.name | limitTo:35}}</a></li><!-- No Results Message --><li ng-if=\"(instructor_courses | filter:{name: courseSearchText}).length === 0\" style=\"padding:10px 15px; color:#999; text-align:center\">No courses found</li></ul></div><button class=ip-btn-3 style=\"padding:10px 20px; width:auto; min-width:80px\" ng-click=clearFilters() ng-disabled=\"!sDate && !eDate && selectedCourse === \'Select Course\'\">Clear</button><!-- Search Button (at the END) --><!-- <button class=\"ip-btn-3\" \n              style=\"padding:10px 15px;\" \n              ng-click=\"getData()\">\n        Search\n      </button> --></div></div><!-- <div class=\"dashboardData-newOne container-fluid\">\n      <div class=\"row\">\n        <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n          <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n            <div class=\"instructor-dashboard-report-box zoom-in\">\n                <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                    <div class=\"flex\">\n                      <img src=\"../../../images/icons/instructor_video.svg\" class=\"ip-dashboard-img-icon\">\n                     </div>\n                    <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card1\">{{dashboardData.videosWatchedToday}}</div>\n                    <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Videos watched today</div>\n                </div>\n            </div>\n        </div>\n        </div>\n    \n        <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n          <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n            <div class=\"instructor-dashboard-report-box zoom-in\">\n                <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                    <div class=\"flex\">\n                      <img src=\"../../../images/icons/instructor_users.svg\" class=\"ip-dashboard-img-icon\">\n                     </div>\n                    <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card2\">{{dashboardData.enrollmentsLastWeek}}</div>\n                    <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Enrollments in last week</div>\n                </div>\n            </div>\n        </div>\n        </div>\n    \n        <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n          <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n            <div class=\"instructor-dashboard-report-box zoom-in\">\n                <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                    <div class=\"flex\">\n                      <img src=\"../../../images/icons/instructor_payments.svg\" class=\"ip-dashboard-img-icon\">\n                    </div>\n                    <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card4\">Rs. {{dashboardData.totalEarning}}</div>\n                    <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Lifetime Earning</div>\n                </div>\n            </div>\n        </div>\n        </div>\n      </div>\n    </div> --><!-- Chart--><!-- <div class=\"container-fluid instructor-dashboard-graph\" style=\"padding-top: 75px;\">\n      <div class=\"row instructor-dashboard-responsive-graph\">\n        <div class=\"col-md-12\">\n          <div class=\"container-fluid\" style=\"padding-bottom: 35px;\">\n            <div class=\"row date-filters-row-align\">\n              <div class=\"col-md-4\">\n                <h3>Show details</h3>\n              </div>\n              <div class=\"col-md-8 instructor-dashboard-date-filters-right-align\" >\n                <div style=\"display: flex;\" class=\"ip-dashboard-graph-date\">\n                <h3 class=\"first_inner\">From: </h3>\n                <md-datepicker ng-model=\"sDate\" md-placeholder=\"Select Date\" md-max-date=\"maxDate\"></md-datepicker>\n                </md-datepicker>\n              </div>\n              <div class=\"ip-dashboard-graph-date\" style=\"float: right;\">\n                <h3 class=\"first_inner\">To:&nbsp;&nbsp; &nbsp;&nbsp; </h3>\n                <md-datepicker ng-model=\"eDate\" md-placeholder=\"Select Date\" md-max-date=\"maxDate\">\n                </md-datepicker>\n              </div>\n              <button class=\"ip-btn-3\" style=\"padding: 10px 15px;\" ng-click=\"getData()\">Search</button>\n            </div>\n            </div>\n          </div>\n          <div>\n            <canvas id=\"line\" class=\"chart chart-line\" chart-data=\"lineChartData\" chart-labels=\"lineChartLabels\"\n              chart-series=\"series\" height=\"150\" chart-colors=\"chartColor\">\n            </canvas>\n          </div>\n          <div class=\"radio-dash container-fluid\">\n            <div class=\"row\">\n              <div class=\"col-md-3 radio-dash_div\" title=\"Videos Watched\" ng-click=\"updateChart(1)\">\n                <span ng-class=\"{active: selectedId == 1}\"></span><input type=\"radio\" name=\"type\"\n                  value=\"videos\" checked /> Videos Watched\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Enrollments\" ng-click=\"updateChart(2)\">\n                <span ng-class=\"{active: selectedId == 2}\"></span><input type=\"radio\" name=\"type\" \n                  value=\"enrollments\" /> Enrollments\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Courses/Bundle\" ng-click=\"updateChart(3)\">\n                <span ng-class=\"{active: selectedId == 3}\"></span><input type=\"radio\" name=\"type\"\n                  value=\"coursesold\" /> Courses/Bundle\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Users\" ng-click=\"updateChart(4)\">\n                <span ng-class=\"{active: selectedId == 4}\"></span><input type=\"radio\" name=\"type\"\n                  value=\"users\" /> Users\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Earning\" ng-click=\"updateChart(5)\">\n                <span ng-class=\"{active: selectedId == 5}\"></span><input type=\"radio\" name=\"type\"\n                value=\"earning\" /> Earning\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Quiz Attempted\" ng-click=\"updateChart(6)\">\n                <span ng-class=\"{active: selectedId == 6}\"></span><input type=\"radio\" name=\"type\"\n                  value=\"quizatm\" /> Quiz Attempted\n              </div>\n              <div class=\"col-md-3 radio-dash_div\" title=\"Modules Sold\" ng-click=\"updateChart(7)\">\n                <span ng-class=\"{active: selectedId == 7}\"></span><input type=\"radio\" name=\"type\"\n                  value=\"moduleSold\" />Modules Sold\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=clr></div><!-- Today\'s Overview --><div class=summary-table-inner><h1>Quick Overview</h1><div class=\"summary-table cards-responsive-dashboard\"><div class=row><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_video.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card1\">{{dashboardData.videosWatched || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Videos Watched</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_users.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card2\">{{dashboardData.users || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Users</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_users.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card3\">{{dashboardData.enrollments || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Free Enrollments</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_users.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card3\">{{(dashboardData.users - dashboardData.enrollments) || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Paid Enrollments</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_module.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card4\">{{dashboardData.sales || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Bundle/Courses/Module Sold</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_payments.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card5\">{{dashboardData.earnings || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Earning</div></div></div></div></div><div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\"><div class=flex><img src=../../../images/icons/instructor_quizzes.svg class=ip-dashboard-img-icon></div><div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card6\">{{dashboardData.quizCount || 0}}</div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Quiz Attempted</div></div></div></div></div></div></div></div><!-- Last Week Overview --><!-- <div class=\"summary-table-inner\">\n      <h1>Last Week\'s Overview</h1>\n      <div class=\"summary-table  cards-responsive-dashboard\" >\n        <div class=\"row\">\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_video.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card1\">{{dashboardData.lastWeekOverview.videoWatched}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Videos Watched</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_users.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card2\">{{dashboardData.lastWeekOverview.users}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Users</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_users.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card3\">{{dashboardData.lastWeekOverview.enrollments}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Enrollments</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_module.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card4\">{{dashboardData.lastWeekOverview.courseSold}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Bundle/Courses/Module Sold</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_payments.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card5\">{{dashboardData.lastWeekOverview.earning}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Earning</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_quizzes.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card6\">{{dashboardData.lastWeekOverview.quizAttempted}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Quiz Attempted</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          </div>\n        </div> \n    </div> --><!-- Total Overview --><!-- <div class=\"summary-table-inner\">\n      <h1>Total Overview</h1>\n      <div class=\"summary-table  cards-responsive-dashboard\" >\n        <div class=\"row\">\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_video.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card1\">{{dashboardData.totalOverview.videoWatched}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Videos Watched</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_users.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card2\">{{dashboardData.totalOverview.users}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Users</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_users.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card3\">{{dashboardData.totalOverview.enrollments}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Enrollments</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_module.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card4\">{{dashboardData.totalOverview.courseSold}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Bundle/Courses/Module Sold</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_payments.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card5\">{{dashboardData.totalOverview.earning}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Earning</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          <div class=\"col-md-4 instructor-dashboard-instructor-cards-responsive\">\n            <div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\">\n              <div class=\"instructor-dashboard-report-box zoom-in\">\n                  <div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\">\n                      <div class=\"flex\">\n                        <img src=\"../../../images/icons/instructor_quizzes.svg\" class=\"ip-dashboard-img-icon\">\n                      </div>\n                      <div class=\"instructor-dashboard-text-3xl instructor-dashboard-font-medium instructor-dashboard-leading-8 instructor-dashboard-mt-6 radio-dash_div-card6\">{{dashboardData.totalOverview.quizAttempted}}</div>\n                      <div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">Quiz Attempted</div>\n                  </div>\n              </div>\n          </div>\n          </div>\n          </div>\n        </div> \n    </div> --><div class=overlay-box-intr ng-hide=\"showData || hideDashboard\"><img src=images/nearpeer-loading.gif></div></div></div></div>");
$templateCache.put("app/instructor_panel/course/course.html","<div class=\"container-fluid mb-50\"><div class=ip-popup ng-if=ipModulePopup style=\"z-index: 9999\"><div class=ip-popup-container><div class=ip-popup-close ng-click=ipEditPopupClose()><img src=../../../images/close-popup.png alt=\"\"></div><div class=ip-poup-title><h2>{{newEditText}} Module</h2></div><div class=ip-popup-body><div class=form-group><label for=exampleInputEmail1>Module Name</label><input type=text name=course-name class=form-control ng-model=selectedModule.name ng-bind=selectedModule.name placeholder=\"Enter Module name\" ng-blur=validateName(selectedModule.name)></div><div class=form-group><label for=exampleFormControlTextarea1>Module Descriptions</label><textarea class=form-control ng-model=selectedModule.description ng-bind=selectedModule.description rows=8></textarea></div><div class=form-group><div class=\"publish form-group\"><span>Price</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=selectedModule.module_type.paid> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><input type=number name=course-name class=\"form-control ip-mb-15\" placeholder=\"Please enter the original price of module in PKR\" ng-model=selectedModule.module_type.price ng-disabled=!selectedModule.module_type.paid min=0> <input type=number name=course-name class=form-control placeholder=\"Please enter the discounted price of module in PKR\" ng-model=selectedModule.module_type.discount ng-disabled=\"!selectedModule.module_type.paid && !selectedModule.module_type.price > 0\" min=0></div><div class=text-center><p>{{errorMsg}}</p><button ng-click=saveDataModule(selectedModule) class=ip-btn-3>Save Changes</button></div></div></div></div></div><div class=\"ip-courses-container-centered mt-30 mb-30\" ng-show=showData><div class=\"instructor-panel-page ip-course-uploader-direction\"><div class=ip-course-img-box><div class=\"picture-uploader course-cart-aside ip-boxshadow\" style=\"margin-bottom: 20px !important\"><div class=main-upload-img><img ng-if=selectedCourse.image_url ng-src={{selectedCourse.image_url}} alt=\"\" class=ip-course-img-uploader><div ng-if=!selectedCourse.image_url class=ip-course-img-uploader><i class=\"fa fa-upload\" style=\"font-size: 120px;color: #1d4c69;margin-top: 16%\" aria-hidden=true></i></div><div class=progress ng-show=imageUploadingInProcess><div class=\"progress-bar progress-bar-success\" role=progressbar aria-valuenow={{imageUploadLog.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: imageUploadLog.progress + \'%\'}\">{{imageUploadLog.progress}}% Complete</div></div><span class=upload-instructions>Image Uploading Guideline: *960x720*</span></div></div><!-- <button class=\"ip-btn-3\" ng-class=\"{\'dragViderHere\': !selectedCourse.image_url, \n              \'update-img-here\': selectedCourse.image_url}\"\n            for=\"sat-course-cover\" style=\"margin: auto;\">\n            <i ng-if=\"!selectedCourse.image_url\" class=\"fa fa-upload\"></i>\n              \n            </button> --><!-- <input id=\"sat-course-cover\" type=\"file\" accept=\"image/*\" ng-model=\"image\" style=\"display: none;\" ngf-select=\"uploadImage(image)\"> --><div class=main-upload-button style=\"text-align: center\"><input type=file id=files style=\"margin-left: 20%\" accept=image/* ng-model=image ngf-select=uploadImage(image) class=hidden><label for=files class=ip-btn-3 style=\"max-width: 280px;text-align: center\">{{selectedCourse.image_url ? \"Click here to update Image\" : \"Click here to upload Image\"}}</label><!-- <input type=\"file\" style=\"margin-left: 20%;\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImageModule(image)\"> --></div></div><!-- col-md-4 --><div class=course-form-aside style=\"flex: 1;padding-right: 15px;padding-left: 15px\"><div class=form-group><label>Course Title</label><input type=text name=course-name class=form-control ng-model=selectedCourse.name placeholder=\"Enter Course name here\" ng-blur=validateName(selectedCourse.name)><div><label class=\"invalid-message mt-10\" ng-repeat=\"invalid in invalidName\" ng-show=invalid.flag>{{invalid.message}}</label></div></div><div class=form-group><label>Demo Video</label><input type=text name=course-demo class=form-control ng-model=selectedCourse.videoUrl placeholder=\"Youtube demo video ID\"></div><div class=\"publish form-group ip-course-detail-box\"><div><label>Price</label><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=selectedCourse.paid> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=pr-15><label>Total Price</label><input type=number class=\"form-control mb-20\" ng-model=selectedCourse.price name=course-name placeholder=\"Total price in PKR\" ng-disabled=!selectedCourse.paid min=0></div><div><label>Discounted Price</label><input type=number class=\"form-control mb-20\" ng-model=selectedCourse.discount_price name=course-name placeholder=\"Discounted price in PKR\" ng-disabled=\"!selectedCourse.price && !selectedCourse.price > 0\" min=0></div></div><div class=\"clearfix mb-20\" ng-show=selectedCourse.discount_price><label>Discount Validity</label><div class=\"col-sm-12 col-md-12 col-lg-12 padding0 ip-course-date\"><div><div layout-gt-xs=row><div flex-gt-xs class=ip-date-pr-15><label for=from>From: &nbsp;&nbsp;</label><input type=date class=\"form-control mb-20 ip-course-date-inputs\" ng-model=selectedCourse.discountFrom name=FROM style=\"width: auto\"><!-- <md-datepicker ng-model=\"selectedCourse.discountFrom\" md-placeholder=\"Set Date\">\n                  </md-datepicker> --></div></div></div><div><div layout-gt-xs=row><div flex-gt-xs><label for=to>To: &nbsp;&nbsp;</label><input type=date class=\"form-control mb-20 ip-course-date-inputs\" ng-model=selectedCourse.discountTo name=To style=\"width: auto\"><!-- <md-datepicker ng-model=\"selectedCourse.discountTo \" md-placeholder=\"Set Date\">\n                  </md-datepicker> --></div></div></div></div></div></div></div><div class=row style=\"margin: 0px;padding: 15px\"><div class=\"form-group mb-20\"><label>Description</label><textarea class=form-control ng-model=selectedCourse.description rows=6></textarea></div><div class=\"form-group mb-20\"><label>Short Description For SEO</label><textarea class=form-control maxlength=200 ng-model=selectedCourse.short_description rows=6></textarea></div><div class=\"form-group mb-20\"><label>What you will Learn</label><textarea class=form-control ng-model=selectedCourse.what_will_learn rows=6></textarea></div><div class=\"publish form-group ip-course-detail-box\"><div><label>Enable Guided Journey</label><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=selectedCourse.enable_guided_journey> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=pr-15 ng-if=selectedCourse.enable_guided_journey><label>Module Progress %</label><input type=number class=\"form-control mb-20\" ng-model=selectedCourse.guided_journey_perogress name=course-name placeholder=\"Module Progress %\" min=0></div></div></div><div class=row style=\"margin: 0px;padding: 15px\"><div class=ip-course-date><div class=ip-date-pr-15><label>Course Tag</label><div><div><div class=btn-group style=\"padding: 5px 0\"><button class=\"btn btn-default btn-md dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"min-width: 160px;margin: auto;margin-right: 10px;display: flex\">{{selectedCourse.tag_name ||\'Select Course Tag\'}}<div style=\"margin: auto;margin-right:10px\"><span class=caret></span></div></button><ul class=dropdown-menu style=\"max-height: 300px; overflow: scroll\"><li ng-repeat=\"tag in courseTags\"><a ng-click=selectCourseTag(tag)>{{tag.name}}</a></li></ul></div></div></div></div><div><div class=ip-course-date ng-if=isCA><div class=ip-date-pr-15><div><label ng-if=isCA>Course Tag (For CA)</label></div><div class=btn-group style=\"padding: 5px 0\"><button class=\"btn btn-default btn-md dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true style=\"display: flex;min-width: 160px;margin: auto;margin-right: 10px\" aria-expanded=false>{{selectedCourse.course_tag ||\'Select Tag ( For CA )\'}}<div style=\"margin: auto;margin-right:10px\"><span class=caret></span></div></button><ul class=dropdown-menu><li><a ng-click=\"instructorCourseTag(\'CFAP\')\">CFAP</a></li><li><a ng-click=\"instructorCourseTag(\'CAF\')\">CAF</a></li><li><a ng-click=\"instructorCourseTag(\'PRC\')\">PRC</a></li></ul></div></div><div class=ip-date-pr-15 style=\"margin-top: auto\"><div class=btn-group style=\"padding: 5px 0\"><button class=\"btn btn-default btn-md dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"min-width: 160px;margin: auto;margin-right: 10px;display: flex\">{{selectedCourse.course_type ||\'Select Type ( For CA ) \'}}<div style=\"margin: auto;margin-right:10px\"><span class=caret></span></div></button><ul class=dropdown-menu><li><a ng-click=\"instructorCourseType(\'Crash\')\">Crash</a></li><li><a ng-click=\"instructorCourseType(\'Full\')\">Full</a></li><li><a ng-click=\"instructorCourseType(\'Smart\')\">Smart</a></li></ul></div></div></div></div></div><div class=\"form-group mb-20 mt-20\"><label>Course Tags (Strength & Weakness)</label><tags-input placeholder=\"Add Tag Name\" replace-spaces-with-dashes=false add-on-comma=true add-on-enter=true ng-model=tagsSW></tags-input></div><div class=\"form-group mb-20 mt-20\"><label>Course Schedule Link</label><input class=form-control type=text name=course-excelLink ng-model=selectedCourse.excel_url placeholder=\"Add Link Here\"></div><div class=\"form-group mb-20 mt-20\"><label>Paid Schedule Link</label><input class=form-control type=text name=course-excelLink ng-model=selectedCourse.paid_schedule_url placeholder=\"Add Link Here\"></div><div class=\"form-group mb-20\"><label>Digital Classroom Link</label><input class=form-control type=text name=course-excelLink ng-model=selectedCourse.whatsapp placeholder=\"Add Link Here\"></div><div class=\"form-group mb-20\"><label>Video Content in Hours</label><input class=form-control type=number name=course-videos ng-model=selectedCourse.videoContent placeholder=\"video content\"></div><div class=\"form-group mb-20\"><label>No. of Quizzes</label><input class=form-control type=number name=course-quizzes ng-model=selectedCourse.quizContent placeholder=\"Num of Quizzes\"></div><div ng-show=editingCourse class=row style=\"margin: 30px 0\"><h3>This Course Includes</h3><div class=\"publish form-group mt-10\" ng-repeat=\"item in includeFields\"><div class=checkbox style=\"display: flex; margin: 0 10px\"><label><input type=checkbox ng-model=selectedCourse.course_data[item.flag]> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>{{ item.label }}</span></div></div></div></div><div class=row><div class=\"col-md-12 mb-20\"><label style=\"font-weight: 700\">Course includes (Features)</label><div class=\"action-buttons padding0 mb-20\"><div class=\"btn-group ip-course-features\"><button class=\"btn btn-default btn-md dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"width: 100% !important;display: flex;justify-content: space-between\"><div>Features</div><span style=\"margin: auto 0px\" class=caret></span></button><ul class=\"dropdown-menu featureDropDown\" style=\"width: 100%\"><li ng-repeat=\"feature in features\"><a ng-click=addFeature(feature)><img src={{feature.imageUrl}} alt=\"\">{{feature.name}}</a></li></ul></div></div><div class=row><div class=\"col-lg-12 padding0\"><!-- <div ng-repeat=\"cf in selectedCourse.courseFeature\" class=\"pl-0 col-sm-3\">\n                <a ng-if=\"!cf.disabled\" class=\"featureCourseHolder \">\n                  <img src=\"{{cf.imageUrl || cf.featureId.imageUrl}}\" />\n                  <div class=\"name\">{{cf.name || cf.featureId.name}}</div>\n                  <span class=\"cross\" ng-click=\"delFeature($index)\"><img src=\"../../../images/cross-icon.svg\"/></span>\n                </a>\n              </div> --><div ng-repeat=\"cf in selectedCourse.courseFeature\" class=\"pl-0 col-md-3 instructor-dashboard-instructor-cards-responsive\"><div class=\"col-span-12 sm:col-span-6 xl:col-span-3 intro-y\"><div ng-if=!cf.disabled class=\"instructor-dashboard-report-box zoom-in\"><div class=\"instructor-dashboard-box ip-boxshadow instructor-dashboard-p-5\" style=\"text-align: center\"><span class=ip-featureCard-cross ng-click=delFeature($index) style=\"float: right\"><img src=../../../images/cross-icon.svg></span><div class=flex><img src=\"{{cf.imageUrl || cf.featureId.imageUrl}}\" class=ip-dashboard-img-icon style=width:20px;height:20px></div><div class=\"instructor-dashboard-text-base instructor-dashboard-text-slate-500 instructor-dashboard-mt-1\">{{cf.name || cf.featureId.name}}</div></div></div></div></div></div></div></div></div><button ng-if=\"!videosUploadStatus.isCompleted && (selectedCourse.is_converted_to_vvs ===\'completed\' || selectedCourse.is_converted_to_vvs === null)\" class=ip-btn-3 ng-click=convertVideoVimeo()>Convert Existing Videos To VVS</button> <button ng-if=\"!videosUploadStatus.isCompleted && selectedCourse.is_converted_to_vvs ===\'in_progress\'\" class=ip-btn-3>In Progress</button> <button ng-if=\"!videosUploadStatus.isCompleted && selectedCourse.is_converted_to_vvs ===\'in_progress\'\" class=ip-btn-3 ng-click=restartUpload()>Restart Upload</button> <button ng-if=\"VVSStatus && videosUploadStatus.isCompleted\" class=ip-btn-3>Already converted</button> <button ng-if=\"!videosUploadStatus.isCompleted && selectedCourse.is_converted_to_vvs ===\'in_progress\'\" class=ip-btn-3 ng-click=checkUploadStatus(true)>Check Upload Status</button><div class=\"publish form-group mt-20\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.is_vvs_web ng-disabled=\"selectedCourse.is_converted_to_vvs === null && !VVSStatus\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Serve VVS on Web (Less Secure)</span></div></div></div><div class=\"publish form-group mt-10\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.is_vvs_mobile ng-disabled=\"selectedCourse.is_converted_to_vvs === null && !VVSStatus\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Serve VVS on Mobile Browser</span></div></div></div><div class=\"publish form-group mt-10\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.watched_real_time_spent> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Mark Watched on Real Time Spent</span></div></div><input ng-if=selectedCourse.watched_real_time_spent class=\"form-control mt-10\" type=number name=course-videos ng-model=selectedCourse.time_spent_percentage_threshold placeholder=\"Time spent percentage threshold\"></div><div class=\"publish form-group mt-10\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.allow_offline_video_download> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Enable Offline Videos In Desktop App</span></div></div></div><div class=\"publish form-group mt-10\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.allow_source_file_download> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Enable HD Download In Desktop App</span></div></div></div></div><div class=row style=\"margin: 0px;padding: 15px\"><h3>Metatags</h3><table class=table><thead><tr><th style=\"text-align: center\">Property</th><th style=\"text-align: center\">Content</th></tr></thead><tbody><tr ng-repeat=\"metatags in selectedCourse.metatags\"><td style=\"text-align: center\">{{metatags.property}}</td><td style=\"text-align: center\">{{metatags.content}}</td><td><button class=\"btn btn-danger\" ng-click=deleteMetatag($index)>X</button></td></tr></tbody></table></div><div class=row style=\"margin: 0px;padding: 15px\"><h4>Add metatags</h4><div><div class=row><div class=col-md-5 style=\"margin-bottom: 10px\"><input type=text ng-model=metatagProperty placeholder=Property class=form-control></div><div class=col-md-5 style=\"margin-bottom: 10px\"><input type=text ng-model=metatagContent placeholder=Content class=form-control></div><div class=col-md-2><button class=\"btn btn-primary mobile-full-width\" ng-click=addMetaTagToBlog()>Add</button></div></div></div><div><div ng-show=editingCourse><div class=my-course-heading-3rd><h2>MODULES</h2></div><!-- <div ng-click=\"goToNewModulePage()\" class=\"add-new-course add-new-course-one\">\n            <h3>ADD A NEW MODULE</h3>\n          </div> --><div style=\"text-align: end\"><button class=\"ip-btn-3 ip-date-mr-15 mobile-full-width\" ng-click=\"goToNewEditModulePopUp(-1,\'new\')\" style=\"margin-bottom: 15px\"><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add A New Module</button> <button class=\"ip-btn-3 mobile-full-width\" ng-click=saveModuleOrder()>Save Module Order</button></div><div class=my-course-cont style=\"overflow: auto;margin: 0px -15px\"><div class=\"my-course-list ip-boxshadow\" style=\"margin:15px;margin-top:20px;min-width: 600px\"><ul class=draggable-list-header><li style=\"box-shadow: none !important;pointer-events:none;margin-bottom: 0px\"><h4 style=\"font-weight:700;margin: auto\">Sr. No</h4><div class=draggable-header><h4 style=font-weight:700>Module name</h4><div class=my-course-list-right style=\"text-align: end;padding-right: 15px\"><h4 style=font-weight:700>Actions</h4></div></div></li></ul><ul class=draggable-list id=draggable-list ng-model=modulesList><li ng-repeat=\"module in modulesList track by $index\" data-index={{module.module_no}} data-value={{module.id}} class=drag-list><span class=number ng-click=goToEditModulePage(module.id)>{{$index + 1}}</span><div class=\"draggable course-hover\" draggable=true ng-click=goToEditModulePage(module.id)><h4 ng-click=goToEditModulePage(module.id)>{{module.name}}</h4></div><div class=my-course-list-right><a class=dlt ng-click=deleteModule($index)>&nbsp;</a> <a ng-click=\"goToNewEditModulePopUp(module.id,\'edit\')\" class=edit>&nbsp;</a></div></li></ul></div></div><!-- <div class=\"my-course-heading-3rd\">\n            <h2 style=\"margin-bottom: 0px\">Term Details</h2>\n            </div>\n            <div style=\"text-align: end;\">\n              <button class=\"ip-btn-3\" ng-click=\"addNewTerm()\">Add A New Term</button>\n          </div>\n          <div class=\"terms\" ng-repeat=\"term in selectedCourse.terms\">\n            <div class=\"terms-left\">\n              <ul>\n                <li ng-class=\"{active: term.sdate <= currentDate && term.edate >= currentDate}\">\n                  <label>Term Name</label>\n                  <input type=\"text\" placeholder=\"First Term\" ng-model=\"term.term\" />\n                </li>\n              </ul>\n            </div>\n            <div class=\"terms-center\">\n              <ul>\n                <li>\n                  <label>Start Date</label>\n                  <input type=\"text\" placeholder=\"Start Date\" ng-model=\"term.sdate\" datetime-picker date-format=\"yyyy-MM-dd\" />\n                </li>\n                <li>\n                  <label>End Date</label>\n                  <input type=\"text\" placeholder=\"End Date\" ng-model=\"term.edate\" datetime-picker date-format=\"yyyy-MM-dd\" />\n                </li>\n              </ul>\n            </div>\n            <div class=\"terms-right\">\n              <ul>\n                <li ng-click=\"deleteTerm(term,$index)\"><a>&nbsp;</a></li>\n              </ul>\n            </div>\n          </div> --></div><div class=\"row mt-10\" style=\"margin: 0px\"><div class=\"publish mt-30\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedCourse.publish> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Publish</span></div></div></div><div class=\"btn-save saveBtn mobile-full-width\" style=\"text-align: left\"><p>{{errorMsg}}</p><button class=\"ip-btn-3 mobile-full-width\" ng-click=saveData(selectedCourse)>Save Changes</button></div></div></div></div></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div><div ng-show=videosStatusPopup class=overlay-black></div><div ng-show=\"videosStatusPopup \" class=\"pop-overlay-home instrucor-sign-in\" id=popup_overlay><div class=row><p style=\"float: left\">Total Videos</p><p style=\"float: right\">{{videosUploadStatus.totalVideos}}</p></div><div class=row><p style=\"float: left\">Uploading Complete</p><p style=\"float: right\">{{videosUploadStatus.uploadComplete}}</p></div><div class=row><p style=\"float: left\">Uploading Pending</p><p style=\"float: right\">{{videosUploadStatus.uploadPending}}</p></div><div class=row><p style=\"float: left\">Transcoding Complete</p><p style=\"float: right\">{{videosUploadStatus.transcodingComplete}}</p></div><div class=row><p style=\"float: left\">Transcoding Pending</p><p style=\"float: right\">{{videosUploadStatus.transcodingPending}}</p></div><div class=row><button ng-click=closePopup() type=submit class=ip-btn-3 style=\"margin-top: 0px !important\">Okay</button></div></div>");
$templateCache.put("app/instructor_panel/enrolled/enrolled.html","<div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div><div class=enrolled ng-show=showData><div class=enrolled-cont><!-- <h1>ENROLLED STUDENTS</h1> --><div style=\"width: 100% !important; text-align: center;padding: 0px !important\" class=\"enrolled-cont container-fluid\"><div class=ip-page-title><div class=ip-enrolled-mbl class=ip-sidebar-mbl style=\"z-index: 0\"><h1 class=ip-sidebar-mbl style=\"z-index: 0\">ENROLLED STUDENTS</h1><div class=ip-sidebar-mbl ng-show=\"enrolledStudents.length > 0\"><h3>&nbsp;({{totalEnrolled}})</h3></div></div><div class=ip-enrolled-web><h1 class=ip-sidebar-web></h1><div ng-show=\"enrolledStudents.length > 0\"><h3>Enrolled Students: {{totalEnrolled}}</h3></div></div><div class=btn-group><button class=\"btn btn-default btn-lg dropdown-toggle instructor-dashboard-search-filters-centered\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><p>{{selectedCourse | limitTo : 30}}</p><span class=caret></span></button><ul class=\"dropdown-menu ip-dropdwon-menu\"><li><a ng-repeat=\"course in instructor_courses\" ng-click=\"getEnrolledStudents($index, 1)\">{{course.name | limitTo : 35}}</a></li></ul></div></div></div><!-- <div class=\"btn-group mb-20\">\n   <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n     <p>{{selectedCourse | limitTo : 35}}</p><span class=\"caret\"></span>\n   </button>\n   <ul class=\"dropdown-menu\">\n   <li><a ng-repeat=\"course in instructor_courses\" ng-click=\"getEnrolledStudents($index)\">{{course.name | limitTo : 35}}</a></li>\n   </ul>\n </div> --><!-- <div class=\"\" ng-show=\"enrolledStudents.length > 0\"><h3>Total: {{totalEnrolled}}</h3></div> --><div ng-show=!studentsExist style=\"padding: 20px\"><p>No enrolled Students</p></div><div class=\"enrolled-midle ip-boxshadow mb-0\" ng-show=\"enrolledStudents.length > 0\" style=\"overflow-y: auto\"><table class=\"my-course-list table table-responsive table-borderless ip-enrolled-students-responsive\" style=\"border:0px !important;clip-path: inset(-15px 0px -15px -15px);margin-bottom: 0px !important\"><thead><tr><th class=table_th style=\"float: left\">Sr. No</th><th class=table_th style=\"text-align: left\">User ID</th><th class=table_th style=\"text-align: left !important\">Name</th><th class=table_th style=\"text-align: left !important\">Email address</th><th class=table_th style=\"text-align: left !important\">Joining date</th><th class=table_th style=\"text-align: right !important\">Mail</th></tr></thead><tbody><tr ng-repeat=\"student in enrolledStudents\"><td>{{($index+1)+((page*10)-10)}}</td><td>{{student.user_id}}</td><td>{{student.name}}</td><td>{{student.email}}</td><td>{{student.joining_date | date: \"short\"}}</td><td style=\"text-align: right !important\"><input type=checkbox ng-model=student.mail></td></tr></tbody></table></div><div ng-show=\"enrolledStudents.length > 0\" style=\"display: flex;float: right\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=\"getEnrolledStudents(course, page-1)\"><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=\"getEnrolledStudents(course, page+1)\"><a href=\"\"><span>&gt;</span></a></li></ul></nav><span style=\"margin: auto;padding-left: 15px\">{{pageText}} Page in {{totalPages}} Pages</span></div><div ng-show=\"enrolledStudents.length > 0\"><div class=enrolled-text-area><h2>Email enrolled students</h2><textarea ng-model=text></textarea></div><button class=ip-btn-3 style=\"width: auto;border-radius: 8px;float: right\" ng-click=sendUpdateEmailNotification(text,enrolledStudents)>Send to all</button></div><div class=enrolled-text-area ng-show=\"enrolledStudents.length > 0\"><h2>Preview</h2><textarea disabled>\n       Hello XYZ,\n\n       {{text}}\n\n        {{currentCourse.name}} (Link to your course)\n       Best wishes,\n       Team Nearpeer\n     </textarea></div></div></div>");
$templateCache.put("app/instructor_panel/liveSession/liveSession.html","<div class=p-20><div class=ip-page-title><h1 class=ip-sidebar-mbl>Live sessions</h1><!-- <h1 class=\"ip-sidebar-web\"></h1> --><div class=\"ip-sidebar-web main-headeing-inst\"><h3>Welcome to your live sessions, {{instructorName}}</h3></div><button class=ip-btn-3 ng-click=\"goToState(\'InstructorPanelNewLiveSession\')\">Create New</button></div><div class=\"row pt-20 pb-50\"><div class=col-md-3><div class=\"ip-boxshadow text-center\"><h2>{{ total_sessions }}</h2><p>Live Sessions Created</p></div></div><div class=col-md-3><div class=\"ip-boxshadow text-center\"><h2>{{ conducted_sessions }}</h2><p>Live Sessions Conducted</p></div></div><div class=col-md-3><div class=\"ip-boxshadow text-center\"><h2>{{ sessions_events[\'JOINED\'] }}</h2><p>Live Sessions Joins</p></div></div><div class=col-md-3><div class=\"ip-boxshadow text-center\"><h2>{{ sessions_events[\'VIEW\'] }}</h2><p>Live Sessions Clicks</p></div></div><div class=\"col-md-3 col-mt-3\"><div class=\"ip-boxshadow text-center\"><h2>{{ sessions_events[\'ADD_TO_CALENDER\'] }}</h2><p>Add To Calender</p></div></div><div class=\"col-md-3 col-mt-3\"><div class=\"ip-boxshadow text-center\"><h2>{{ interested_users }}</h2><p>Interested Users</p></div></div><div class=\"col-md-3 col-mt-3\"><div class=\"ip-boxshadow text-center\"><h2>{{ watch_time.instructor_watch_time.toFixed(2) }}</h2><p>Instructor watch time (Min)</p></div></div><div class=\"col-md-3 col-mt-3\"><div class=\"ip-boxshadow text-center\"><h2>{{ watch_time.users_watch_time.toFixed(2) }}</h2><p>Users watch time (Min)</p></div></div></div><div class=\"flex-view align-items-center justify-content-between mb-10\"><div class=\"live-session-search flex-view align-items-center\"><input placeholder=Search ng-model=search_query class=ip-question-input> <button ng-click=search() class=ip-question-search><img style=\"margin: 0px 5px\" src=./../../../images/QSearch.svg> <span>Search</span></button></div><a ng-click=showArchived() class=text-under style=\"text-decoration: underline\">{{isArchived ? \'Undo Archive\' : \'Archived Live Sessions\'}}</a></div><div class=\"ip-boxshadow mb-0 live-session-table\" style=\"overflow-y: auto\"><table class=\"my-course-list table table-responsive table-borderless ip-enrolled-students-responsive\" style=\"border:0px !important;clip-path: inset(-15px 0px -15px -15px);margin-bottom: 0px !important\"><thead><tr><th class=table_th>Index No</th><!-- <th class=\"table_th\">Course</th> --><th class=table_th>Live Session Name</th><th class=table_th>Max Targeted Students</th><th class=table_th>Add To Calender</th><th class=table_th>Click</th><th class=table_th>Joined</th><th class=table_th>Interested Users</th><th class=table_th>Date</th><th class=table_th style=\"min-width: 215px\">Action</th></tr></thead><tbody infinite-scroll=\"!isLoading && pagination()\" infinite-scroll-distance=2><tr ng-repeat=\"live_session in show_live_sessions\"><td>{{ live_session.id }}</td><!-- <td>MDCAT Chemistry Improver</td> --><td>{{ live_session.name }}</td><td>{{ live_session.calculated_stats.users_targeted }}</td><td>{{ countEventsByType(live_session.stats, \'ADD_TO_CALENDER\') }}</td><td>{{ countEventsByType(live_session.stats, \'VIEW\') }}</td><td>{{ countEventsByType(live_session.stats, \'JOINED\') }}</td><td>{{ countInterestedUsers(live_session.interested_users, true) }}</td><td><p>{{ getDateTime(live_session.time) | date:\'dd-MM-yyyy hh:mm a\' }}</p></td><td><div class=\"flex-view align-items-center\" style=\"min-width: 360px\"><button ng-click=copyLink(live_session) class=assign-admin-btn>Copy Link</button> <button ng-if=\"live_session.status != \'STARTED\'\" ng-click=generateJoinLink(live_session) class=assign-admin-btn>Join</button> <button ng-if=\"live_session.status == \'STARTED\' && live_session.url_type != \'NEARPEER\'\" ng-click=endLiveSession(live_session) class=assign-admin-btn>End Session</button> <a class=assign-admin-btn ng-href=\"/instructor_panel/edit-live-session/{{ live_session.id }}\">Edit</a> <a class=assign-admin-btn ng-show=\"live_session.status == \'ENDED\'\" ng-href=\"/instructor_panel/edit-live-session/{{ live_session.id }}?open=uploadVideo\">Upload Video</a></div></td></tr></tbody></table><div class=text-center ng-show=isLoading><img src=images/squares.gif></div></div><div ng-if=\"showData && totalPageCount > 1\" class=pagination-main><div class=inner-pagination><div class=q-left-arrow ng-show=\"currentPage != 1\" ng-click=\"pageChange(currentPage - 1)\"><img src=./../../../images/insLeft.svg></div><div class=question-pagination><p class=q-page ng-click=pageChange(pageTag) ng-repeat=\"pageTag in pageArr\" ng:class=\"{ \'q-page-selected\' : currentPage === pageTag }\" ng-show=\"pageTag <= totalPageCount\">{{pageTag}}</p><!-- <p class=\"q-page\" ng-click=\"pageChange()\">2</p> --></div><div class=q-right-arrow ng-show=\"currentPage != totalPageCount\" ng-click=\"pageChange(currentPage + 1)\"><img src=./../../../images/insRight.svg></div></div></div></div><toaster-container toaster-options=\"{\'position-class\': \'toast-top-right\'}\"></toaster-container>");
$templateCache.put("app/instructor_panel/module/module.html","<div class=\"mt-30 mb-30 ip-courses-container-centered\" ng-show=showData><div class=ip-popup ng-show=showPopup><div class=ip-popup-container><div class=ip-popup-close ng-click=closeChapterPopup()><img src=../../../images/close-popup.png alt=\"\"></div><div class=ip-poup-title><h2>{{chapterPopupText}} Chapter</h2></div><div class=ip-popup-body><div class=form-group><label style=\"width: 100%\">Chapter Title</label><input type=text name=course-name placeholder=\"Chapter 1\" ng-model=selectedChapter.name class=form-control style=\"width: 100%\"></div><div style=\"text-align: center;padding-top: 20px\"><button ng-click=saveChapterData(selectedChapter) class=ip-btn-3 style=\"padding: 10px 20px !important\">Save Changes</button></div></div></div></div><div class=ip-course-date><div class=ip-course-img-box style=margin-top:0px><div class=\"main-upload-img ip-boxshadow\" style=\"text-align: center\"><img ng-src={{selectedModule.image_url}} alt=\"\"> <span class=upload-instructions>Image Uploading Guideline: *960x720*<p></p><div class=progress ng-show=imageUploadingInProcess><div class=\"progress-bar progress-bar-success\" role=progressbar aria-valuenow={{imageUploadLog.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: imageUploadLog.progress + \'%\'}\">{{imageUploadLog.progress}}% Complete</div></div></span></div><div class=main-upload-button style=\"text-align: center;padding: 10px\"><input type=file id=files style=\"margin-left: 20%\" accept=image/* ng-model=image ngf-select=uploadImageModule(image) class=hidden><label for=files class=ip-btn-3 style=\"max-width: 280px;text-align: center;margin-top: 15px\">Upload Image</label><!-- <input type=\"file\" style=\"margin-left: 20%;\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImageModule(image)\"> --></div></div><div class=\"course-form-aside ip-module-pl\" style=\"flex: 1\"><ul><li class=ip-pb-15><label ng-show=editingModule><a ng-click=previewPage()>Preview</a></label></li><li class=ip-pb-15><label style=\"font-weight: 700 !important\">Module Title</label><input type=text name=course-name placeholder=\"Module 1\" ng-model=selectedModule.name class=form-control></li><li class=ip-pb-15><div class=\"publish form-group\"><span>Price</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=selectedModule.module_type.paid> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><input type=number name=course-name class=\"form-control ip-mb-15\" placeholder=\"Please enter the original price of module in PKR\" ng-model=selectedModule.module_type.price ng-disabled=!selectedModule.module_type.paid min=0> <input type=number name=course-name class=form-control placeholder=\"Please enter the discounted price of module in PKR\" ng-model=selectedModule.module_type.discount ng-disabled=\"!selectedModule.module_type.paid && !selectedModule.module_type.price > 0\" min=0></li><!-- <li class=\"ip-pb-15\">\n        <label style=\"font-weight: 700 !important;\">Module No</label>\n        <input type=\"text\" name=\"course-name\" class=\"form-control\" placeholder=\"1\" ng-model=\"selectedModule.module_no\">\n      </li> --></ul></div></div><div class=three-page-inst-bottom><div><h3>Description</h3></div><div class=\"descripttion mb-20\"><textarea ng-model=selectedModule.description></textarea></div><div><h3>Short Description</h3></div><div class=descripttion><textarea maxlength=200 ng-model=selectedModule.short_description></textarea></div><div class=\"form-group mb-20 mt-20\"><label>Module Tags (Strength & Weakness)</label><tags-input placeholder=\"Add Tag Name\" add-on-comma=true add-on-enter=true ng-model=tagsSW></tags-input></div><div class=\"publish mt-30\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedModule.hidden> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Hide Module</span></div></div></div><div class=my-course-heading-3rd ng-show=editingModule><h3>My Chapters:</h3></div><div style=\"text-align: end\"><button class=\"ip-btn-3 ip-date-mr-15 mobile-full-width\" ng-click=\"goToEditChapterPopUp(\'add\',-1)\" ng-show=editingModule style=\"margin-bottom: 15px\"><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add A New Chapter</button> <button class=\"ip-btn-3 mobile-full-width\" ng-click=saveChapterOrder()>Save Chapter Order</button></div><div class=my-course-cont ng-show=\"(selectedModule.chapters).length>0\"><div class=\"my-course-list ip-boxshadow\" ng-show=editingModule><ul class=draggable-list-header><li style=\"pointer-events:none;margin-bottom: 0px\"><h4 style=\"font-weight:700;margin: auto\">Sr. No</h4><div class=draggable-header><h4 style=font-weight:700>Chapter name</h4><div class=my-course-list-right style=\"text-align: end;padding-right: 15px\"><h4 style=\"font-weight: 700\">Actions</h4></div></div></li></ul><ul class=draggable-list id=draggable-list ng-model=selectedModule.chapters><li ng-repeat=\"chapter in selectedModule.chapters track by $index\" data-index={{chapter.chapter_no}} data-value={{chapter.id}} class=drag-list><span class=number>{{$index + 1}}</span><div class=draggable draggable=true ng-click=goToChapterVideoPage(chapter.id)><h4>{{chapter.name}}</h4></div><div class=my-course-list-right><a class=dlt ng-click=deleteChapter(chapter.id,$index)>&nbsp;</a> <a class=edit ng-click=\"goToEditChapterPopUp(\'edit\',chapter)\">&nbsp;</a></div></li></ul></div></div><div class=my-course-heading-3rd ng-show=\"editingModule && (selectedModule.chapters.length == 0)\"><h3>My Vidoes:</h3></div><div class=my-course-cont><div style=\"text-align: end\"><button class=\"ip-btn-3 mobile-full-width\" ng-click=goToVideoPage() ng-show=\"editingModule && (selectedModule.chapters.length == 0)\" style=\"margin-bottom: 15px\"><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add/Edit Videos</button></div></div><!-- <div class=\"my-course-heading-3rd\" ng-show=\"editingModule\">\n      <h3>My Notes:</h3>\n    </div>\n    <div style=\"text-align: end;\">\n      <button class=\"ip-btn-3 mobile-full-width\" ng-click=\"showNotesPopup()\" style=\"margin-bottom: 15px;\"><i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add A New Notes</button>\n    </div>\n    <div class=\"my-course-cont\">\n      <div class=\"my-course-list ip-boxshadow\" ng-show=\"editingModule\">\n        <ul class=\"draggable-list-header\">\n          <li style=\"pointer-events:none;margin-bottom: 0px;\">\n            <h4 style=\"font-weight:700;margin: auto;\">Sr. No</h4>\n            <div class=\"draggable-header\">\n            <h4 style=\"font-weight:700;\">Notes name</h4>\n          <div class=\"my-course-list-right\" style=\"text-align: end;padding-right: 15px;\"><h4 style=\"font-weight: 700;\">Actions</h4> </div>\n          </div>\n          </li>\n        </ul>\n        <ul class=\"draggable-list\" id=\"draggable-list\" ng-model=\"selectedModule.attachments\">\n          <li ng-repeat=\"attachment in selectedModule.attachments track by $index\"  data-index=\"{{attachment.sort_no}}\" data-value=\"{{attachment.id}}\" class=\"drag-list\">\n            <span class=\"number\" >{{$index + 1}}</span>\n            <div class=\"draggable\" draggable=\"true\">\n              <h4>{{attachment.name}}</h4>\n            </div>\n          <div class=\"my-course-list-right\">\n            <a class=\"dlt\" ng-click=\"deleteAttachement(attachment,$index)\">&nbsp;</a> \n            <a class=\"edit\" ng-click=\"editAttachement(attachment)\">&nbsp;</a>\n            <a class=\"download\" ng-click=\"downloadAttachment(attachment.url)\">&nbsp;</a> \n\n          </div>\n          </li>\n        </ul>\n      </div>\n    </div> --><div class=\"publish mt-30\"><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom;display: flex\"><label><input type=checkbox ng-model=selectedModule.is_secure_notes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><div><span>Secure Notes (Stop on Web)</span></div></div></div><div class=\"btn-save mobile-full-width\" style=\"width: 100%\"><p>{{errorMsg}}</p><button ng-click=saveData(selectedModule) class=\"ip-btn-3 mobile-full-width\">Save Changes</button></div></div></div><!-- Modal --><div class=\"modal fade\" id=notes-popup role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 260px\"><div class=col-md-12><div class=form-group><label>Name</label><input type=text placeholder=\"Notes Name\" ng-model=notesData.name class=form-control></div><div class=\"publish form-group mt-10\"><span>Stop Web serving (Secure)</span><div class=checkbox style=\"display: inline-block;margin: 8px 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=notesData.isSecure> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=form-group><label>PDF File</label><input type=file ng-model=notesData.file ngf-select=uploadVideoAttachments(notesData.file) accept=application/pdf class=form-control></div><div class=form-group ng-if=\"notesUploadStatus === \'uploading\' || notesUploadStatus === \'uploaded\'\"><label>{{notesUploadStatus === \'uploading\' ? \'Uploading...\' : \'Uploaded\'}}</label><img ng-if=\"notesUploadStatus === \'uploading\'\" height=25 src=images/nearpeer-loading.gif></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=closeNotesPopup() type=button class=\"btn btn-default\">Close</button> <button ng-click=saveNotes() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div>");
$templateCache.put("app/instructor_panel/myprofile/myprofile.html","<div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div><div class=container-fluid><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12\"><div class=my-profile ng-show=showData><h1>Profile Settings</h1><div class=container-fluid><div class=row><div class=my-profile-img-background><img class=my-profile_img ng-if=userData.image ng-src={{userData.image}}> <img class=my-profile_img ng-if=!userData.image src=../../../images/profile-user.png></div><div class=progress ng-show=imageUploadingInProcess><div class=\"progress-bar progress-bar-success\" role=progressbar aria-valuenow={{imageUploadLog.progress}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width: imageUploadLog.progress + \'%\'}\">{{imageUploadLog.progress}}% Complete</div></div></div><div class=row><div><button accept=image/* style=\"display:block;margin:auto;float: unset !important\" class=\"my-profile_input_new_button ip-btn-3\" ng-model=image ngf-select=uploadImage(image)>UPLOAD NEW IMAGE</button></div></div><div class=row><div class=col-md-4><label>Name:</label></div><div class=col-md-8><input type=text class=my_profile_input_field ng-model=userData.full_name></div></div><div class=row><div class=col-md-4><label>Qualification:</label></div><div class=col-md-8><input type=text class=my_profile_input_field ng-model=userData.qualification></div></div><div class=row><div class=col-md-4><label>Experience:</label></div><div class=col-md-8 style=\"display: flex\"><div class=btn-group><button class=\"btn btn-default my-profile_btn-group_button btn-lg dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><p>{{userData.experience}}</p><span class=caret></span></button><ul class=dropdown-menu style=\"min-width: auto;height: 200px; overflow: auto\"><li ng-repeat=\"year in years\"><a ng-click=updateExperience(year)>{{year}}</a></li></ul></div><div class=my-profile_small>years</div></div></div><div class=row><div class=col-md-4><label>Description:</label></div><div class=col-md-8><input type=text class=my_profile_input_field style=\"height: 70px\" ng-model=userData.description></div></div><div class=row><div style=\"margin: auto\"><button ng-click=saveData(userData) class=\"my-profile_input_new_button ip-btn-3\" style=\"margin-top: 0px\">UPDATE</button></div></div></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12\"><div class=my-profile ng-show=showData><h1>Add New Faculty</h1><form ng-init=\"facultyForm= {}\"><div class=container-fluid><div class=row style=\"padding: 10px 0\"><div class=col-md-4><label>Institution</label></div><div class=col-md-8><input type=text class=my_profile_input_field ng-model=facultyForm.institution></div></div><div class=row style=\"padding: 10px 0\"><div class=col-md-4><label>Faculty</label></div><div class=col-md-8><input type=text class=my_profile_input_field ng-model=facultyForm.faculty></div></div><div class=row style=\"padding: 10px 0\"><div style=\"margin: auto\"><button ng-click=addFaculty(facultyForm) class=\"my-profile_input_new_button ip-btn-3\" style=\"margin-top: 0px\">ADD</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/instructor_panel/questions/questions.html","<div class=container-fluid><div class=\"comment-section-new row\"><div class=comment-section><div class=chips-div><div class=ip-search-bar><div style=\"display: flex;    flex-direction: column\"><input placeholder=Search class=ip-question-input ng-model=searchText><div style=\"display: flex;\n          justify-content: space-between;margin-top: 10px\"><div class=\"flex-view flex-direction-col\"><label for=dateFrom style=\"margin: 0\">From:</label><md-datepicker ng-model=fromDate md-placeholder=\"Start Date\"></md-datepicker></div><div class=\"flex-view flex-direction-col\"><label for=dateTo style=\"margin: 0\">To:</label><md-datepicker ng-model=toDate md-placeholder=\"End Date\"></md-datepicker></div></div></div><div class=ip-question-search-button><button class=ip-question-search ng-click=searchQuery()><img style=\"margin: 0px 5px\" src=./../../../images/QSearch.svg> <span>Search</span></button> <button class=ip-question-search style=\"color: #133c5c;\n    border: 1px solid #133c5c;\n    background: white\" ng-click=clearFilter()><img style=\"margin: 0px 5px\" src=\"./../../../images/delete_outline_black_24dp 1.svg\"> <span>Clear</span></button></div></div><div class=students-filter><div class=question-filter-container><div class=ind-filter ng:class=\"{ \'ind-filter-selected\' :filterSelected.all }\" ng-click=\"changeFilter(\'all\')\">All({{allQuestionsCount}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.answered }\" ng-click=\"changeFilter(\'answered\')\">Answered({{answeredQuestionsCount}})</div><div class=ind-filter ng:class=\"{  \'ind-filter-selected\' :filterSelected.unanswered }\" ng-click=\"changeFilter(\'unanswered\')\">Unanswered({{unansweredQuestionsCount}})</div></div></div></div><div class=loader ng-hide=showData><img src=images/squares.gif></div><div ng-if=showData class=\"table-responsive col-xs-12 ip-questions-table\"><!-- table-bordered table-striped --><div class=ledger-question><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #00800040\"></li><p>Answered</p></div><div class=\"flex-view flex-direction-row\"><li class=ledger-circle style=\"background-color: #ff000021\"></li><p>Unanswered</p></div><!-- <div class=\"flex-view flex-direction-row\">\n            <li class=\"ledger-circle\" style=\"background-color: #00800040;\"></li><p>Answered</p>\n          </div> --></div><table class=\"table custom-question\" ng-if=!noData><thead><tr><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Status</label></div></th><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'id\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'id\')\"><img src=./../../../images/QDWN.svg></div></div><label>Student ID</label></div></th><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'name\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'name\')\"><img src=./../../../images/QDWN.svg></div></div><label>Student Name</label></div></th><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Email</label></div></th><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />s\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Contact</label></div></th><th><div class=question-table-head><label>Course Tag</label></div></th><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Question</label></div></th><th><div class=question-table-head><label>Rating (5)</label></div></th><th><div class=question-table-head><!-- <div class=\"inner-pic\">\n                    <div>\n                      <img src=\"./../../../images/QUP.svg\" />\n                    </div>\n                    <div>\n                      <img src=\"./../../../images/QDWN.svg\" />\n                    </div>\n                  </div> --><label>Gender</label></div></th><th><div class=question-table-head><div class=inner-pic><div ng-click=\"sortFilter(\'desc\',\'date\')\"><img src=./../../../images/QUP.svg></div><div ng-click=\"sortFilter(\'asc\',\'date\')\"><img src=./../../../images/QDWN.svg></div></div><label>Date & Time</label></div></th></tr></thead><tbody><tr ng-repeat=\"question in userQuestions\" ng:class=\"{ \'answered-color\' : question.is_answered ,\'unassigned-color\' : !question.is_answered,\'new-question\' : (newQuestion && $index == 0)  }\"><td class=question-view-td><!-- <td>{{question.is_answered != null ? question.is_answered : \"Unanswered\" }}</td> --><!-- <p ng-if=\"question.is_answered\">\n                  {{question.is_answered != null ? \"Answered\": \"Unanswered\" }}\n                </p> --> <button class=question-view ng-click=viewAnswer(question,question.answer_media_link) ng-if=\"question.is_answered != null \">View Answer</button> <button class=assign-admin-btn ng-click=answerStudent(question) ng-if=!question.is_answered>Send Answer</button></td><td>{{question.user_id}}</td><td>{{question.user_full_name}}</td><td class=question-email-cell>{{question.user_email_primary}}</td><td>{{question.user_phone}}</td><td>{{question.tag_name != null ? question.tag_name : \'N/A\'}}</td><td class=question-view-td><button class=question-view ng-click=viewQuestion(question.id,question.question_text,question.question_media_link)>View</button></td><td><div ng-if=\"question.answers.length > 0\"><!-- <p>\n                    {{question.answers[0].rating != null ?\n                    question.answers[0].rating : \'N/A\'}}\n                  </p> --><!-- <p>{{question.answers[0].rating}}</p> --><!-- <p ng-if=\"question.answers[0].rating == null\">N/A</p> --><div style=\"display: flex;\n                      flex-direction: row;\n                      justify-content: center\" ng-if=question.answers[0].rating title={{question.answers[0].rating_description}}><p ng-repeat=\"i in getNumber(question.answers[0].rating) track by $index\"><img src=./../../../images/gold_star.svg style=\"width: 18px; height: 18px\"></p><!-- <p ng-if=\"remaining\" ng-repeat=\"i in rem_stars\" >\n                      <img src=\"./../../../images/gray_star.svg\" style=\"width: 18px;height: 18px;\" />\n\n                    </p> --></div><p ng-if=\"question.answers[0].rating == null\">N/A</p><!-- <p ng-else>N/A</p> --></div><p ng-if=\"question.answers.length === 0\">N/A</p></td><td>{{question.user_gender != null ? question.user_gender : \'N/A\'}}</td><td>{{question.created_at | date:\'short\'}}</td><!-- <td>{{question.created_at | date:\'mediumDate\'}}</td> --></tr></tbody></table><h3 style=\"display: flex; justify-content: center\" ng-if=noData>No Relevant Data Found!</h3><div ng-if=\"showData && totalPageCount > 1\" class=pagination-main><div class=inner-pagination><div class=q-left-arrow ng-show=\"currentPage != 1\" ng-click=\"pageChange(currentPage - 1)\"><img src=./../../../images/insLeft.svg></div><div class=question-pagination><p class=q-page ng-click=pageChange(pageTag) ng-repeat=\"pageTag in pageArr\" ng:class=\"{ \'q-page-selected\' : currentPage === pageTag }\" ng-show=\"pageTag <= totalPageCount\">{{pageTag}}</p><!-- <p class=\"q-page\" ng-click=\"pageChange()\">2</p> --></div><div class=q-right-arrow ng-show=\"currentPage != totalPageCount\" ng-click=\"pageChange(currentPage + 1)\"><img src=./../../../images/insRight.svg></div></div></div></div></div></div></div><div class=ip-popup ng-if=\"displayQuestion || displayAnswer\"><div class=ip-display-question><img ng-click=closeQuestion() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1 ng-if=displayQuestion>Question</h1><h1 ng-if=displayAnswer>Answer</h1></div><div class=question-sec><div class=question-text-div><p ng-if=!containsLinks>{{selectedQuestion}}</p><div ng-if=containsLinks ng-bind-html=selectedQuestion></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && !isYoutube\"><img ng-if=\"notAvideo && !isPDF\" ng-click=previewEnlargedImage(selectedQuestionImage) style=\"cursor: pointer\" src={{selectedQuestionImage}} onloadeddata=angular.element(this).scope().imageLoadCheck() onload=angular.element(this).scope().imageLoadCheck()> <img src=images/squares.gif ng-if=imageshowloader><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup><button ng-if=\"notAvideo && !isPDF\" class=question-view ng-click=\"displayQuestion ? previewEnlargedImage(selectedQuestionImage,question) : previewEnlargedImage(selectedQuestionImage,answer) \">Preview Image</button> <a ng-if=\"notAvideo && isPDF\" class=question-view href={{selectedQuestionImage}} target=_blank>Download File</a></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><!-- <iframe width=\"420\" height=\"315\" ng-src=\"{{selectedAnswerImage}}\" allowfullscreen frameborder=\"0\">\n          </iframe> --><iframe width=420 height=315 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div></div></div></div></div><div class=ip-popup ng-click=closePreviewImage(); ng-if=imagePreview><div><img ng-click=\"closePreviewImage(); $event.stopPropagation();\" src=./../../../images/Icon-Close-black.svg style=\"position: absolute;\n        top: 14px;\n        right: 18px;\n        background: white;\n        border-radius: 11px\"> <img ng-click=$event.stopPropagation(); class=image-preview src={{previewImage}}></div></div><div class=ip-popup ng-if=answerQuestion><div class=ip-display-question><img ng-click=closeAnswerWindow() src=./../../../images/Icon-Close-black.svg style=\"position: absolute; top: 14px; right: 18px\"><div class=inner-display-question><div class=question-head><h1>Write your answer</h1></div><div class=question-sec><div class=question-text-div style=\"display: flex; justify-content: center;flex-direction: column;align-items: center\"><label style=\"font-size: 12px;    display: flex;\n        align-items: center\"><img style=\"width: 18px;\n          height: 18px;margin-right: 5px\" src=./../../../images/infoQU.svg> You can paste pdf links , google drive links and any reference links in the box below.</label><textarea style=\"max-height: 300px;\n    min-height: 100px;\n              width: 85% !important;\n              margin: 8px 10px 25px 10px;\n              border: 1px solid #EAEAEA\" ng-model=answerText placeholder=\"Enter your answer here\">\n          </textarea></div><div ng-if=\"selectedAnswerImage && !isYoutube\" class=question-image><a ng-if=\"notAvideo && isPDF\" href={{selectedQuestionImage}} target=_blank style=\"display: flex; flex-direction: column; align-items: center\"><img style=\"width: 45px; height: 45px; margin-bottom: 8px\" src=./../../../images/newspaper-svgrepo-com.svg> {{fileName}}</a> <img ng-if=\"notAvideo && !isPDF\" src={{selectedAnswerImage}}><video-popup style=\"width: 100%\" ng-if=\"!notAvideo && !isPDF\" video=selectedAnswerImage></video-popup></div><div ng-if=\"selectedAnswerImage && isYoutube\"><iframe width=420 height=315 src={{selectedAnswerImage}}></iframe></div><div ng-if=!selectedAnswerImage style=\"display: flex; justify-content: center\"><div class=\"dropdown show\" style=\"border: 1px solid #eaeaea; width: 200px\"><label style=\"width: 100%; display: flex; justify-content: space-between\" ng-click=handleOptions() class=\"btn btn-secondary dropdown-toggle\" href=# role=button id=dropdownMenuLink data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{defaultDropDown}} <img style=\"margin-left: 5px\" src=./../../../images/commentarrows.svg></label><!-- class=\"dropdown-menu\" --><div style=\"display: flex;\n                flex-direction: column;\n                border: 1px solid #eaeaea;\n                padding: 6px 12px;\n                background: white;\n                position: absolute;\n                width: 200px\" ng-if=showOptions aria-labelledby=dropdownMenuLink><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Video Link\')\">Video Link</label><label class=dropdown-item style=\"width: 100%;\n                  display: flex;\n                  justify-content: space-between\" ng-click=\"selectUploadType(\'Upload through System\')\">Upload through System</label></div></div></div><div style=\"flex-direction: column; align-items: center\" class=question-image ng-if=\"selectedQuestionImage && isYoutube\"><iframe width=350 height=220 src={{trustSrc(ytID)}} title=\"YouTube video player\" frameborder=0 allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div><div class=\"flex-view flex-direction-row-col\" style=\"justify-content: space-evenly; padding: 15px\"><!-- <button\n            ng-click=\"attachFile()\"\n            style=\"\n              background: #d4165a;\n              color: white;\n              padding: 2px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex;\n            \"\n            .png, .jpg, .jpeg\n          > --> <input ng-if=fileUploadSelected type=file id=imageUpload accept=image/*,video/*,application/pdf,.doc,.docx,application/msword,.xls ng-model=selectedImageAnswer style=\"visibility: hidden; width: 100px\" onchange=angular.element(this).scope().onImageSelected(event)><!-- position: absolute; --><label ng-if=fileUploadSelected style=\"background: #d4165a;\n              color: white;\n              padding: 8px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex\" for=imageUpload>Attach Image/Video/PDF</label><input type=text ng-model=videoLink placeholder=\"Paste Youtube Link\" ng-show=linkUpload style=\"border: 1px solid #eaeaea ; margin-left: 20px\" ng-paste=youtubePreview($event)><!-- <button\n            ng-if=\"linkUpload\"\n            style=\"\n              background: #d4165a;\n              color: white;\n              padding: 8px 15px;\n              border: none;\n              border-radius: 5px;\n              font-size: 15px;\n              display: flex;\n            \"\n            ng-click=\"uploadLink(videoLink)\"\n          >\n            Upload Link\n          </button> --><!-- </button> --><div ng-if=imageLoad><img style=\"height: 40px\" src=images/squares.gif></div><!-- ng-show=\"!imageLoad\" --> <button class=assign-admin-btn style=\"display: flex; align-items: center\" ng-click=\"imageLoad ? \'\' : sendAnswer(answerText,videoLink)\"><!-- <span  >Uploading</span> --> <span>Send Answer</span></button></div></div></div></div></div>");
$templateCache.put("app/instructor_panel/quiz/quiz.html","<div class=\"quiz-admin-back container-setting\" ng-show=showData><!-- <div class=\"quiz-admin-back-cont\">\n    <div class=\"quiz-admin-back-top\">\n      <div class=\"go-back-arrow\">\n        <a ui-sref=\"InstructorPanelQuizDashboard\">GO BACK</a>\n      </div>\n      <div class=\"quiz-title\">\n        <h2>Quiz Placement</h2>\n      </div>\n      <div class=\"quiz-Placement-dropdown\" ng-show=\"creatingQuiz\">\n        <ul>\n          <li>\n            <div class=\"btn-group\">\n              <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"courses.length == 0\">\n                <p>{{selectedCourse | limitTo: 17}}</p><span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li><a ng-repeat=\"course in courses\" ng-click=\"updateCourse(course)\">{{course.name}}</a></li>\n              </ul>\n            </div>\n          </li>\n          <li>\n            <div class=\"btn-group\">\n              <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"modules.length == 0\">\n                <p>{{selectedModule | limitTo: 17}}</p><span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li><a ng-repeat=\"module in modules\" ng-click=\"updateModule(module)\">{{module.name}}</a></li>\n              </ul>\n            </div>\n          </li>\n          <li>\n            <div class=\"btn-group\" ng-hide=\"chapters.length == 0\">\n              <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"chapters.length == 0\">\n                <p>{{selectedChapter | limitTo: 20}}</p><span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li><a ng-repeat=\"chapter in chapters\" ng-click=\"getVideos(\'chapter\',chapter)\">{{chapter.name}}</a></li>\n              </ul>\n            </div>\n          </li>\n          <li>\n            <div class=\"btn-group\">\n              <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"videos.length == 0\">\n                <p>{{selectedVideo | limitTo: 17}}</p><span class=\"caret\"></span>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li><a ng-repeat=\"video in videos\" ng-click=\"updateVideoId(video)\">{{video.name}}</a></li>\n              </ul>\n            </div>\n          </li>\n        </ul>\n        <p>This quiz will be presented at the end of the selected video</p>\n      </div>\n    </div>\n    <div class=\"quiz-title\">\n      <div class=\"fullpoppup-fld\">\n        <input style=\"padding-top: 10px;\" type=\"text\" ng-model=\"quiz.quizName\" placeholder=\"Enter your quiz name here\">\n        <div class=\"btn-group\" style=\"padding-top: 10px;\">\n          <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n            <p>{{quizType}}</p><span class=\"caret\"></span>\n          </button>\n          <ul class=\"dropdown-menu\">\n            <li><a ng-click=\"setQuizType(1)\">Full Quiz</a></li>\n            <li><a ng-click=\"setQuizType(2)\">Popup Quiz</a></li>\n            <li><a ng-click=\"setQuizType(3)\">SAT Quiz</a></li>\n          </ul>\n        </div>\n      </div>\n      <div class=\"quiz-title\">\n        <h4>Quiz Time</h4>\n      </div>\n\n      <div ng-model=\"quizTime\" >\n        <input ng-model=\"quizTime.hours\" type=\"number\" class=\"hours\" placeholder=\"00\" min=\"0\" max=\"23\" >\n        <span >:</span>\n        <input ng-model=\"quizTime.minutes\" type=\"number\" class=\"minutes\" placeholder=\"00\" min=\"0\" max=\"59\" >\n        <span >:</span>\n        <input ng-model=\"quizTime.seconds\" type=\"number\" class=\"seconds\" placeholder=\"00\" min=\"0\" max=\"59\" step=\"1\">\n      </div>\n      <div ng-show =\"SatQuiz\" class=\"quiz-title\">\n        <h2>SAT Quiz Content</h2>\n      </div>\n      <div ng-show =\"SatQuiz\">\n        <text-angular  ng-model=\"quiz.content\"></text-angular>\n      </div>\n      <h2>Questions</h2>\n    </div>\n    <div ng-repeat=\"question in quiz.questions\">\n      <div class=\"quiz-admin-back-left\">\n        <div class=\"quiz-title\">\n          <h4>Tag {{$index + 1}}</h4>\n        </div>\n        <div>\n          <tags-input ng-model=\"question.tags\" key-property=\"id\" display-property=\"text\" on-tag-removing=\"deleteTag(question, $tag, \'tag\')\" on-tag-adding=\"createTagId($tag)\">\n            <auto-complete source=\"loadTags($query)\"></auto-complete>\n          </tags-input>\n        </div>\n        <div class=\"quiz-title\">\n          <h4>Difficulty Level {{$index + 1}}</h4>\n        </div>\n        <div>\n          <tags-input ng-model=\"question.levels\" key-property=\"id\" display-property=\"text\" on-tag-removing=\"deleteTag(question, $tag, \'level\')\" on-tag-adding=\"createTagId($tag)\">\n            <auto-complete source=\"loadTags($query)\"></auto-complete>\n          </tags-input>\n        </div>\n        <div class=\"quiz-title\">\n          <h4>Question {{$index + 1}}</h4>\n        </div>\n        <div >\n          <text-angular ng-model=\"question.text\"></text-angular>\n        </div>\n        <div class=\"maths-checkbox\">\n          <label> <input type=\"checkbox\" ng-model=\"question.mathbox\" />For equations</label>\n        </div>\n        <div  ng-show=\"question.mathbox \">\n          <div class=\"quiz-title\">\n            <h4 class=\"ng-binding\">Math :</h4>\n          </div>\n          <p><span ng-keydown = \"onKeyDown($event)\" ng-paste=\"pastingText($event.originalEvent,$index+1,\'math-field\',null)\" class=\"maths-text-area\" id=\"math-field{{$index+1}}\" ng-model=\"question.mathtext\"></span></p>\n        </div>\n        <div class=\"quiz-title\">\n          <h4>Options </h4>\n        </div>\n        <div class=\"btn-group selected-videos\">\n          <button class=\"btn btn-default btn-lg dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"videos.length == 0\">\n            <p>{{question.selectedVideoName}}</p><span class=\"caret\"></span>\n          </button>\n          <ul class=\"dropdown-menu\">\n            <li><a ng-repeat=\"video in videos\" ng-click=\"selectVideo(video,question)\">{{video.name}}</a></li>\n          </ul>\n        </div>\n        <div class=\"options-links\">\n          <ul>\n            <li ng-repeat=\"option in question.options\" ng-class=\"{activeCorrectAnswer: option.correct}\">\n              <label>{{$index+1}} </label>\n              <div class=\"box-option\">\n                <div>\n                  <p><span ng-keydown = \"onKeyDown($event)\" ng-paste=\"pastingText($event.originalEvent,$index+1,\'math-field-option\',$parent.$index)\" class=\"textarea-span\"  id=\"math-field-option{{$parent.$index}}{{$index+1}}\" ng-model=\"option.answer\" ></span></p>\n                </div>\n                <div class=\"img-upload-option\">\n                  <img ng-src={{option.image_url}} alt=\"\">\n                </div>\n                <button ngf-select=\"uploadQuizImage(image,option)\" ng-model=\"image\" name=\"file\">Upload</button>\n                <div ng-click=\"deleteOption(question,$index)\" class=\"dlt-option\">\n                  &nbsp;\n                </div>\n                <input type=\"checkbox\" ng-model=\"option.correct\" ng-click=\"updateCorrectAnswer(question.options,$index)\">\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n      <div class=\"quiz-admin-back-right\">\n        <div class=\"quiz-title\">\n          <h4>Figure</h4>\n        </div>\n        <div class=\"quiz-admin-back-right-links\">\n          <ul>\n            <li>\n              <div class=\"img-upload-option\">\n                <img ng-src={{question.image_url}} alt=\"\">\n              </div>\n            </li>\n          </ul>\n          <button  ngf-select=\"uploadQuizImage(image,question)\" ng-model=\"image\" name=\"file\">Upload</button>\n          <button ng-if=\"question.image_url\" ng-click=\"deleteSolutionImage(question, \'figure\')\">Remove</button>\n          <div class=\"solution\">\n            <div class=\"quiz-title\">\n              <h4>Solution</h4>\n            </div>\n            <p><span ng-keydown = \"onKeyDown(\'math-field-sol\',$index+1)\" ng-paste=\"pastingText($event.originalEvent,$index+1,\'math-field-sol\',null)\" id=\"math-field-sol{{$index+1}}\"\n              class=\"maths-text-area\" ng-model=\"question.solution\"></span></p>\n            <img ng-src={{question.solution_image}} alt=\"\">\n            <button ngf-select=\"uploadQuizImage(image,question,\'solution\')\" ng-model=\"image\" name=\"file\">Upload</button>\n            <button ng-if=\"question.solution_image\" ng-click=\"deleteSolutionImage(question, \'solution\')\">Remove</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"btn-save-and-change\">\n        <button ng-click=\"addOption(question.options,$index)\">Add Option</button>\n        <div ng-click=\"deleteQuestion(question,$index)\" class=\"dlt-option\">\n          <img src=\"../../images/dlt.png\" alt=\"\" />\n        </div>\n      </div>\n    </div>\n    <div class=\"add-new-course\" ng-click=\"addQuestion(quiz.questions.length)\">\n      <h3>ADD QUESTION</h3>\n    </div>\n    <div class=\"btn-save-and-change\">\n      <button ng-click=\"saveData()\">Save Changes</button>\n      <div ng-show=\"imageUploadProgress.length > 0\">\n        <table>\n          <tr>\n            <th>Index</th>\n            <th>Name</th>\n            <th>Log</th>\n          </tr>\n          <tr ng-repeat=\"log in imageUploadProgress\">\n            <td>{{$index + 1}}</td>\n            <td>{{log.name}}</td>\n            <td>\n              <div class=\"progress\">\n                <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"{{log.log}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:log.log + \'%\'}\">\n                  {{log.log}}% Complete\n                </div>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div> --></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div>");
$templateCache.put("app/instructor_panel/quiz/quizDashboard.html","<div class=\"quiz-admin container-setting\" ng-show=showData><!-- <div class=\"quiz-admin-cont\">\n\n    <div class=\"quiz-admin-main-heading\">\n      <h1>Quiz Center</h1>\n      <p>Get started by creating your first quiz</p>\n    </div>\n\n    <div class=\"add-new-course\" ng-click=\"goToNewQuizPage()\">\n      <h3>CREATE A NEW QUIZ</h3>\n    </div>\n    \n\n    <div class=\"quiz-admin-inner-heading\">\n      <h1>Quizes</h1>\n    </div>\n\n    <div class=\"quiz-admin-add \" ng-click=\"goToEditQuizPage(quiz.quizid)\" ng-repeat=\"quiz in quizzes\">\n      <ul>\n        <li>{{quiz.quizname}}</li>\n        <li>\n          <label>COURSE</label>\n          <P>{{quiz.coursename}}</P>\n        </li>\n\n        <li class=\"dlt\"><a ng-click=\"deleteQuiz(quiz.quizid,$index)\">&nbsp;</a></li>\n        <li>\n          <label>Module</label>\n          <P>{{quiz.modulename}}</P>\n        </li>\n      </ul>\n    </div>\n  </div> --></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div>");
$templateCache.put("app/instructor_panel/transaction/transaction.html","<div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div><div class=ip-popup ng-show=showCoursePopup><div class=ip-popup-container><div class=ip-popup-close ng-click=closeCoursePopup()><img src=../../../images/close-popup.png alt=\"\"></div><div class=ip-poup-title><h2>{{title}}</h2></div><div class=ip-popup-body><div class=form-group>{{selectedCourse}}</div><div style=\"text-align: end\"><button ng-click=closeCoursePopup() class=ip-btn-3 style=\"padding: 10px 20px !important\">OK</button></div></div></div></div><div class=order-management><div style=\"margin-right: 0px !important\" class=\"pb-30 order-mgt-block\"><div class=\"mt-20 col-md-12 mt-10 page-num-block ip-transactions-header\"><div class=\"col-md-3 col-xs-12 ip-page-title\"><h1 class=ip-sidebar-mbl>Transactions</h1><h1 class=ip-sidebar-web></h1></div><div class=\"col-md-9 ip-transactions-header-search\"><div class=\"col-xs-6 col-md-6\" ng-hide=\"searchParams.type===\'all\'\"><input type=text placeholder=Search ng-model=searchParams.key style=\"width: 100%;background: transparent;border: 1px solid #d3d3d3;height: 40px\" ng-change=\"searchParams.key.length > 0 ? searchOrder(searchParams.key, searchParams.type,false,true,searchParams.per_page) : null\" class=form-control><!-- <span>By:</span> --><ul ng-if=\"searchData.length > 0\" class=list-group style=\"width: 95%\"><li ng-click=\"searchOrder(row.email || row.fb_email || row.name || row.full_name,searchParams.type,true,true,searchParams.per_page)\" class=list-group-item ng-repeat=\"row in searchData\">{{row.email || row.fb_email || row.name || row.full_name }}</li></ul></div><div class=\"col-xs-6 col-md-4\" style=\"padding:0px;display: flex\"><span style=\"padding-right: 15px;margin: auto 0px\">By:</span><div style=\"width: 100%\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"width: 100%;display: flex;justify-content: space-between\"><div><label>{{searchParams.type.charAt(0).toUpperCase() + searchParams.type.slice(1)}}</label></div><div style=\"margin: auto 0px\"><span class=\"fa fa-angle-down\"></span></div></button><ul class=dropdown-menu style=\"width: 86%;float: right;margin-right: 0px;margin-left: 35px\"><li ng-repeat=\"type in searchType\" class=ip-facultyDropdown><a ng-click=changeType(type)>{{type.charAt(0).toUpperCase() + type.slice(1)}}</a></li></ul></div></div><div class=\"ip-header-count col-xs-6 col-md-2 padding0 page-num-option\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false style=\"width: 100%;justify-content: space-between;display: flex\"><div><label>{{ searchParams.per_page }}</label></div><div style=\"margin: auto 0px\"><span class=\"fa fa-angle-down\"></span></div></button><ul class=dropdown-menu style=\"min-width: 100px !important;width: 100% !important\"><li ng-repeat=\"type in pageRow\" class=ip-facultyDropdown ng-click=\"searchOrder(searchParams.key, searchParams.type, true,true,type)\"><a ng-model=searchParams.per_page>{{type}}</a></li></ul></div></div><!-- <div class=\" col-xs-6 col-md-2 download-csv-block\">\n        <a id=\"download_csv\" ng-click=\"downloadOrders()\">Download\n          CSV</a>\n      </div> --></div><div class=\"col-md-12 ip-order-item-table mt-30 enrolled-inner\"><div class=ip-boxshadow style=\"margin: 15px; margin-right: 0px;width: fit-content\"><table class=\"my-course-list table table-responsive table-borderless\"><thead><tr><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;min-width: 75px\">Sr. No</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Ref No</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Status</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Type</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 200px;min-width: 200px\">Bundle</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 300px;min-width: 300px\">Course</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 200px;min-width: 200px\">Module</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Price</th><!-- <th class=\"table_th\">Discount</th> --><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Revenue</th><!-- <th class=\"table_th\">Balance</th> --><!-- <th class=\"table_th\">Coup Bal</th> --><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 150px;min-width: 150px\">Coupon ID</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">User</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Phone</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 200px;min-width: 200px\">Primary Email</th><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important;width: 200px;min-width: 200px\">Facebook Email</th><!-- <th class=\"table_th\">CRN</th> --><!-- <th class=\"table_th\">City</th> --><th class=\"table_th ip-pl-15 ip-pr-15 ip-pt-15\" style=\"text-align: left !important\">Date</th><!-- <th class=\"table_th\">Reason for Free</th> --><!-- <th class=\"table_th\">Payment Proof</th> --><!-- <th class=\"table_th\">Payment Type</th> --><!-- <th class=\"table_th\">Comments</th> --><!-- <th class=\"table_th\">Access</th> --></tr></thead><tbody><tr ng-repeat=\"order in orders | orderBy:id:false\"><td class=\"ip-pl-15 ip-pr-15\">{{($index+1)+((searchParams.page*searchParams.per_page)-searchParams.per_page)}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.ref_no}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.status}}</td><td class=\"ip-pl-15 ip-pr-15\"><div style=\"width: 150px\">{{order.type | limitTo : 25}} <span ng-if=\"((order.type).length > 25)\">... </span><button ng-if=\"((order.type).length > 25)\" ng-click=\"viewCoursePopup(order.type, \'Order Type\')\" style=\"color:#1D4C69;background: transparent;border: none\">View more</button></div></td><td class=\"ip-pl-15 ip-pr-15\">{{order.bundle}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.course | limitTo : 55}} <span ng-if=\"((order.course).length > 55)\">... </span><button ng-if=\"((order.course).length > 55) \" ng-click=\'viewCoursePopup(order.course, \"Course\")\' style=\"color:#1D4C69;background: transparent;border: none\">View more</button></td><td class=\"ip-pl-15 ip-pr-15\">{{order.module}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.price}}</td><!-- <td>{{order.discount}}</td> --><td class=\"ip-pl-15 ip-pr-15\">{{order.revenue}}</td><!-- <td>{{order.user_balance}}</td> --><!-- <td>{{order.coupon_balance}}</td> --><td class=\"ip-pl-15 ip-pr-15\">{{order.couponId}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.user_name}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.phone}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.user_email}}</td><td class=\"ip-pl-15 ip-pr-15\">{{order.fb_email}}</td><!-- <td>{{order.crn}}</td> --><!-- <td>{{order.user_id.city}}</td> --><td class=\"ip-pl-15 ip-pr-15\">{{order.time | date:\"MM/dd/yyyy \'at\' h:mma\"}}</td><!-- <td>{{order.reason}}</td> --><!-- <td>{{order.proof}}</td> --><!-- <td>{{order.payType}}</td> --><!-- <td>{{order.comments | limitTo : 20}} {{order.comments.length\n              > 20  ? \'...\' : \'\'}}</td> --></tr></tbody></table></div></div></div><div class=\"col-md-12 col-xs-12 ng-binding\"><div style=\"display: flex;float: right\"><nav ng-hide=hidePagination><ul class=pagination style=\"display: flex\"><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\" style=\"margin-right: 10px\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span style=\"margin: auto 10px\">{{pageText}} Page in {{totalPages}} Pages ,{{((searchParams.page*searchParams.per_page)+1)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}} entries Out of {{totalCount}} entries</span></div></div></div>");
$templateCache.put("app/instructor_panel/video/video.html","<div class=ip-courses-container-centered ng-show=showData><div class=ip-my-course-heading-3rd><h2>VIDEOS:</h2><div class=btn-group><button class=\"btn btn-default btn-lg dropdown-toggle\" style=\"float: left\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{btnText}}</label><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu><li ng-repeat=\"option in uploadingOptions\"><a ng-click=changeUploader(option.id)>{{option.name}}</a></li></ul></div></div><div ui-sortable ng-model=videos><div ng-repeat=\"video in videos\"><div class=\"add-new-course five-page-inst\"><h3 style=\"margin-bottom: 0px; height: 45px\" ng-class=\"{\'notes-tile-gray-bg\': video.type === \'notes\'}\"><p style=\"/*width: calc(100% - 105px);*/ float: left; margin-right: 0px; white-space: nowrap; overflow: hidden\" title=\"{{($index+1) + \'- \' + video.name}}\"><img src=\"{{video.type === \'notes\' ? \'images/Notes-icon.svg\' : \'images/Video-Icon.svg\'}}\" style=\"padding-right: 10px\" alt=\"\" height=15> {{($index+1) + \'- \' + video.name}} {{video.type === \'notes\' ? \'(Notes)\' : \'\'}} {{video.vss_id && video.type !== \'notes\' ? \'(VVS)\' : \'\'}} {{video.url_mpd && video.type !== \'notes\' ? \'(S3)\' : \'\'}}</p><p style=\"width:fit-content;margin: 0;padding-left: 5px; float: right\"><a ng-if=\"video.type !== \'notes\'\" class=download ng-click=download(video)>&nbsp;</a> <a ng-if=\"video.type === \'notes\'\" class=download ng-click=downloadAttachment(video.url)>&nbsp;</a> <a class=\"dlt deleteVideo\" ng-click=\"video.type === \'notes\' ? deleteNotes(video, $index) : deleteVideo($index)\">&nbsp;</a> <a class=edit ng-click=setValue($index)>&nbsp;</a> <i ng-if=video.referenced_by class=\"fa fa-copy\" title=Duplicated style=\"color:#007bff;margin-left:8px; margin-right: 5px\"></i></p></h3></div><div ng-show=\"value == $index\"><div class=ip-course-date><div class=ip-course-img-box ng-if=\"video.type !== \'notes\'\"><div class=\"main-upload-img ip-boxshadow\"><img ng-src={{video.image_url}} alt=\"\"></div><div class=main-upload-button style=\"text-align: center;padding: 10px\"><input type=file id=file style=\"margin-left: 20%\" accept=image/* ng-model=image ngf-select=uploadImage(image,video) class=hidden><label for=file class=\"ip-btn-3 mobile-full-width\" style=\"max-width: 280px;text-align: center;margin-top: 15px\">Upload Image</label></div><div class=main-upload-button style=\"text-align: center;padding: 10px\"><label style=width:100%;text-align:left>Replace Video</label><input type=file id=files style=\"margin-left: 20%\" ng-model=files ngf-select=\"uploadVideoss([files],\'click\', video)\" class=hidden><label for=files class=\"ip-btn-3 mobile-full-width\" style=\"max-width: 280px;text-align: center;margin-top: 15px\">Upload a New Video</label></div></div><div class=ip-module-pl style=\"flex: 1\"><ul><li><label ng-if=\"video.type !== \'notes\'\"><a ng-click=previewPage(video)>Preview</a></label></li><li><label style=width:100%>{{video.type === \'notes\' ? \'Notes\' : \'Video\'}} Title</label><input type=text name=course-name ng-model=video.name placeholder=\"Video 1\" class=\"form-control ip-mb-15\"></li><li ng-if=\"video.type !== \'notes\'\"><input type=text ng-model=video.youtube_id placeholder=\"Youtube Video ID\" class=\"form-control ip-mb-15\"></li><li ng-if=\"video.type !== \'notes\'\"><div class=\"publish form-group\" ng-if=video.vss_id><span>Allow VVS on Web</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=video.is_vss_web> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div></li><li><div class=\"publish form-group\" ng-if=\"video.type === \'notes\'\"><span>Secure Notes (Stop on Web)</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=video.is_secure> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div></li><li ng-if=\"video.type !== \'notes\'\"><label>Description</label><div class=\"descripttion short-description-one\"><textarea ng-model=video.description></textarea></div></li></ul></div></div><div class=three-page-inst-bottom style=\"display: flex;flex-direction: column\" ng-if=\"video.type !== \'notes\'\"><div class=my-course-heading-3rd><h2>Attachments:</h2></div><div class=my-course-cont><div class=my-course-list><ul style=\"overflow: auto\"><li ng-repeat=\"attachment in video.attachments  track by $index\" style=\"overflow: auto\"><!-- <div class=\"my-course-list-left\"> \n              <span>{{$index+1}}</span>\n              <h3>{{attachment.name}}</h3>\n            </div>\n            <div class=\"my-course-list-right\"> <a class=\"dlt\" ng-click=\"deleteAttachement(attachment,$parent.$index,$index)\">&nbsp;</a> \n              <a class=\"download\" ng-click=\"downloadAttachment(attachment.url)\">&nbsp;</a> </div> --><div class=\"add-new-course five-page-inst\"><h3 style=\"margin-bottom: 0px; height: 45px\"><p style=\"width: calc(100% - 130px); float: left; margin-right: 0px; white-space: nowrap; overflow: hidden\" title=\"{{($index+1) + \'- \' + (attachment.name)}}\">{{($index+1) + \'- \' + attachment.name}}</p><p style=\"width:fit-content;margin: 0;padding-left: 5px; float: right\"><a class=dlt ng-click=deleteAttachement(attachment,$parent.$index,$index)>&nbsp;</a> <a class=edit ng-click=\"editAttachement(attachment, video)\">&nbsp;</a> <a class=download ng-click=downloadAttachment(attachment.url)>&nbsp;</a></p></h3><p></p></div></li></ul><ul><li class=without-bg><div class=my-course-list-right><div class=up-load ng-click=showNotesPopup(video)><!-- <input style=\"width: 130px;\" class=\"dlt\" type=\"file\" ng-model=\"file\" ngf-select=\"uploadVideoAttachments(file,video)\"> --><h1>UPLOAD FILES</h1></div><a class=download ng-click=downloadAllAttachments($index,video) ng-show=\"video.attachments.length > 0\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DOWNLOAD ALL</a></div></li><!-- <li class=\"without-bg\" style=\"margin-bottom:20px;\">\n            <div class=\"my-course-list-left\"> <span>&nbsp;</span>\n              <h3>&nbsp;</h3>\n            </div>\n            <div class=\"my-course-list-right\"> <a class=\"dlt\" ng-click=\"deleteAllAttachments($index)\">DELETE ALL</a> </div>\n           </li> --></ul></div></div></div></div></div></div><div class=fixed-pos flow-init flow-directory flow-files-submitted=\"uploadVideoss($files,\'drag\')\"><div class=drop-box style=\"width: 100%\" flow-drop>Drag And Drop your file here</div></div><div style=margin-top:20px class=\"drag ip-mb-15\" ngf-select=\"uploadVideoss(files,\'click\')\" ng-model=files ngf-multiple=true ngf-accept=\"\'video/*, application/pdf\'\">&nbsp;</div><!-- <Input type=\"file\" model=\"fileuploaded\"  /> --><!-- accept=\"video/*\" --><div class=clearfix></div><div class=\"uplod ip-boxshadow\" ng-show=\"uploadingVideos.length > 0\" style=\"overflow: auto\"><table style=\"width: 100%;min-width: 700px\"><tr><th>Index</th><th>Name</th><th>Uploading To Server</th><th>Uploading To {{(toVimeo && toS3)? \'VVS/Azure\' : toVimeo ? \'VVS\' : toBunny ? \'Buuny\' : \'Azure\'}}</th><!-- <th>Transcoding Job</th> --></tr><tr ng-repeat=\"video in uploadingVideos  track by $index\" ng-class=\"{videoUploadedSuccess: video.uploaded,videoUploadedFail:video.error}\"><td>{{$index+1}} ({{(video.server===\'Vimeo\')? \'VVS\': toBunny ? \'Bunny\' : \'Azure\'}})</td><td>{{video.name}}</td><td><!-- <div class=\"progress\">\n            <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"{{video.serverLog}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.serverLog + \'%\'}\">\n                {{video.serverLog}}% Complete\n            </div>\n          </div> --><div class=progress style=\"position: relative\"><div class=\"progress-bar progress-bar-success\" role=progressbar style=\"position: absolute\" aria-valuenow={{video.serverLog}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width:video.serverLog + \'%\'}\"></div><div style=\"color: #000;text-align: center;position: relative;font-size: 12px\">{{video.serverLog}}% Complete</div></div></td><td><!-- <div class=\"progress\">\n            <div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{video.s3Log}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.s3Log + \'%\'}\">\n              {{video.s3Log}}% Complete\n            </div>\n          </div> --><div class=progress style=\"position: relative\"><div class=\"progress-bar progress-bar-info\" role=progressbar style=\"position: absolute\" aria-valuenow={{video.s3Log}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width:video.s3Log + \'%\'}\"></div><div style=\"color: #000;text-align: center;position: relative;font-size: 12px\">{{video.s3Log}}% Complete</div></div></td><!-- <td> --><!-- <div class=\"progress\">\n            <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"{{video.jobLog}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.jobLog + \'%\'}\">\n                  {{video.jobLog}}% Complete\n            </div>\n          </div> --><!-- <div class=\"progress\" style=\"position: relative;\">\n              <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" style=\"position: absolute;\" aria-valuenow=\"{{video.jobLog}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.jobLog + \'%\'}\">\n              </div>\n             <div style=\"color: #000;text-align: center;position: relative;font-size: 12px;\">{{video.jobLog}}% Complete</div>\n            </div> --><!-- </td> --><td><span ng-click=removeItem($index) style=\"float: right\"><img src=../../../images/cross-icon.svg></span></td></tr></table></div><div class=\"uplod fixed-pos ip-boxshadow\" ng-show=\"uploadLog.length > 0 && !close\" style=\"margin: 15px 0px\"><table style=\"width: 100%\"><tr><th>Index</th><th>Name</th><th>Log</th></tr><tr ng-repeat=\"log in uploadLog track by $index\" ng-class=\"{videoUploadedSuccess: log.uploaded}\"><td>{{$index + 1}}</td><td>{{log.name}}</td><td><div class=progress style=\"position: relative\"><div class=\"progress-bar progress-bar-success\" role=progressbar style=\"position: absolute\" aria-valuenow={{log.log}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width:log.log + \'%\'}\"></div><div style=\"color: #000;text-align: center;position: relative;font-size: 12px\">{{log.log}}% Complete</div></div></td></tr></table></div><div class=\"uplod fixed-pos ip-boxshadow\" ng-show=\"uploadingAttachments.length > 0 && !close\" style=\"margin: 15px 0px\"><table style=\"width: 100%\"><tr><th>Index</th><th>Name</th><th>Log</th></tr><tr ng-repeat=\"attachment in uploadingAttachments\" ng-class=\"{videoUploadedSuccess: attachment.status === \'uploaded\'}\"><td>{{$index + 1}}</td><td>{{attachment.name}}</td><td><div class=progress style=\"position: relative\"><div class=\"progress-bar progress-bar-success\" role=progressbar style=\"position: absolute\" aria-valuenow={{attachment.log}} aria-valuemin=0 aria-valuemax=100 ng-style=\"{width:attachment.log + \'%\'}\"></div><div style=\"color: #000;text-align: center;position: relative;font-size: 12px\">{{attachment.log}}% Complete</div></div></td></tr></table></div><div class=\"col-12 ip-video-buttons\"><div style=\"padding: 10px\"><button ng-click=saveData() class=\"ip-btn-3 mobile-full-width\">Save Changes</button></div><div style=\"padding: 10px\"><button ng-click=clearChanges() class=\"ip-btn-3 mobile-full-width\">Clear Changes</button></div></div><br><br></div><!-- Modal --><div class=\"modal fade\" id=notes-popup role=dialog><div class=\"modal-dialog modal-sm\"><div class=modal-content><div class=modal-body style=\"min-height: 260px\"><div class=col-md-12><div class=form-group><label>Name</label><input type=text placeholder=\"Notes Name\" ng-model=notesData.name class=form-control></div><div class=\"publish form-group mt-10\"><span>Stop Web serving (Secure)</span><div class=checkbox style=\"display: inline-block;margin: 8px 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=notesData.isSecure> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=form-group><label>PDF File</label><input type=file ng-model=notesData.file ngf-select=uploadVideoAttachments(notesData.file) accept=application/pdf class=form-control></div><div class=form-group ng-if=\"notesUploadStatus === \'uploading\' || notesUploadStatus === \'uploaded\'\"><label>{{notesUploadStatus === \'uploading\' ? \'Uploading...\' : \'Uploaded\'}}</label><img ng-if=\"notesUploadStatus === \'uploading\'\" height=25 src=images/nearpeer-loading.gif></div></div></div><div style=\"min-width: 300px\" class=modal-footer><button ng-click=closeNotesPopup() type=button class=\"btn btn-default\">Close</button> <button ng-click=saveNotes() class=\"btn btn-danger\" data-dismiss=modal>Add</button></div></div></div></div><div class=overlay-box-intr ng-hide=showData><img src=images/nearpeer-loading.gif></div>");
$templateCache.put("app/admin/FAQS/Create/FAQSCreate.html","<admin-header statename=\"Create Question\"></admin-header><div class=\"row editable-tags pb-30\"><div class=col-md-12><div class=\"col-xs-12 col-md-3\" ng-repeat=\"inst in institutes\" track by $index><div class=\"form-group holder\"><span>{{ inst.name | limitTo : 25 }} {{inst.name.length > 25 ? \'...\' : \'\'}}</span><div class=\"pull-right actions\"><a ng-click=dropIt(inst) class=\"glyphicon glyphicon-trash\"></a></div></div></div></div></div><div class=form-group><div class=btn-group><button class=\"btn btn-default btn-md dropdown-toggle form-control\" type=button data-toggle=dropdown>{{\'Select Institute\'}} <span class=caret></span></button><ul class=\"dropdown-menu list-group\"><li><a>Select Institute</a></li><li ng-repeat=\"inst in institutions\"><a ng-click=pickIt(inst)>{{inst.name}}</a></li></ul></div></div><div><h4>Question:</h4><textarea ng-model=faq.question placeholder=\" Add Quesstion \" class=form-control></textarea></div><div><h4>Answer:</h4><textarea ng-model=faq.answer placeholder=\" Add Answer \" class=form-control></textarea></div><div><h4>Publish: <input type=checkbox ng-model=faq.publish></h4></div><div class=pull-right><button ng-click=saveFaq(faq) class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/blog/blogComments/blogComment.html","");
$templateCache.put("app/admin/botConfig/botSystemPrompt/botSystemPrompt.html","<admin-header statename=\"Chat-Bot System Prompt Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=\"col-xs-12 col-md-12\"><div><label class=mt-10>Select Niche</label><select ng-change=onSelectNicheTag(selectedNicheTag) ng-model=selectedNicheTag><option ng-repeat=\"nichetag in nichetags\" value={{nichetag.id}}>{{nichetag.name}}</option></select></div><div><label class=mt-10>Variable Key:</label><p class=mt-10>{name} | {city} | {content_watched} | {avg_quiz_score} | {amount_paid} | {courses_enrolled} | {courses_purchased} | {mdcat_score}</p><!-- <div ng-dropdown-multiselect=\"\" events=\"yourEvents\" options=\"tags\" selected-model=\"config.selectedTags\"></div> --></div><label class=mt-20>System Prompt</label><textarea type=text class=form-control rows=10 ng-model=config.prompt></textarea></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px; margin-top: 30px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/bundle/create/create.html","<admin-header statename=\"Create Bundle\"></admin-header><div class=row><div class=col-md-12><div class=\"col-md-12 mb-20\"><div class=\"col-md-6 padding0\"><div class=uploadlgBox><span class=cross><i ng-click=delImage() class=\"fa fa-times\" aria-hidden=true></i></span> <input type=file accept=image/* ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image ng-if=bundle.image_url src={{bundle.image_url}} alt=\"\"> <span ng-if=!bundle.image_url class=upload>Upload Image</span></div></div><div class=\"col-md-6 padding0\"><div class=pull-right><button class=\"btn btn-default secondry_btn\" ng-click=SaveBundle(bundle)>Delete Bundle</button></div></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><input type=text ng-model=bundle.name placeholder=\"Bundle Name\" class=form-control></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Bundle Redirect Link</label><input type=text ng-model=bundle.redirect_link placeholder=\"Bundle Redirect Link\" class=form-control></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Bundle Schedule Link</label><input type=text ng-model=bundle.excel_url placeholder=\"Bundle Schedule Link\" class=form-control></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Nearpeer Share</label><input type=number ng-model=bundle.np_share placeholder=\"Nearpeer Share\" class=form-control></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label for=Institution>Select Tag</label><select class=form-control id=Institution ng-model=bundle.tag_id><option ng-repeat=\"tag in nichetags\" value={{tag.id}}>{{tag.name}}</option></select></div></div><div class=\"col-md-12 mb-20\"><textarea ng-model=bundle.description placeholder=\" Add Description \" class=form-control rows=7></textarea></div><get-course></get-course><div class=col-md-12><div class=\"course-holder mb-20\"><div class=col-md-4 ng-repeat=\"course in bundle.course\"><div class=text-holder><span>{{ course.name || course.course_id.name | limitTo: 30 }} {{ (course.name.length > 30 || course.course_id.name.length > 30) ? \'...\' : \'\' }} </span><span class=del ng-click=deleteCourse($index)><i class=\"fa fa-times\" aria-hidden=true></i></span></div><!-- Modules List with Delete Button --><div class=module-list ng-if=\"course.modules && course.modules.length\"><ul><li ng-repeat=\"module in course.modules\" class=module-item><span class=module-name ng-if=module.module_id>{{ module.module_id.name }} </span><!-- Else, show module.name --> <span class=module-name ng-if=!module.module_id>{{ module.name }} </span><span class=\"del module-del\" ng-click=\"deleteModule(course, $index)\"><i class=\"fa fa-times\" aria-hidden=true></i></span></li></ul></div></div></div></div><div class=\"col-md-12 mb-20 padding0\"><label>Total Price: {{bundle.price}}</label><input class=form-control type=number ng-model=bundle.discount_price placeholder=\"Bundle discount price\"></div><div class=\"col-md-12 padding0\"><input type=checkbox ng-model=bundle.publish> Public<br><br></div><div class=\"col-md-12 mb-20\"><button class=\"btn btn-default secondry_btn\" ng-click=SaveBundle(bundle)>Save</button></div></div></div><!-- Inline CSS --><style>.text-holder {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-bottom: 10px;\n  }\n\n  .del {\n    cursor: pointer;\n    color: red;\n    font-size: 16px;\n    transition: transform 0.2s ease-in-out;\n  }\n\n  .del:hover {\n    transform: scale(1.2);\n  }\n\n  .module-list {\n    margin-top: 10px;\n    padding: 10px;\n    background-color: #fff;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n  }\n\n  .module-item {\ndisplay: flex;\njustify-content: space-between;\nalign-items: center;\npadding: 8px 10px;\nborder-bottom: 1px solid #ddd;\nposition: relative; /* Ensure positioning works correctly */\n}\n\n.module-name {\nflex-grow: 1; /* Ensures the module name takes up the available space */\nword-break: break-word; /* Prevents long names from breaking layout */\n}\n\n.module-del {\ncolor: #ff0000;\nfont-size: 16px;\ncursor: pointer;\nposition: absolute;\nright: 10px; /* Push delete button to the right */\ntop: 50%;\ntransform: translateY(-50%); /* Align vertically */\n}\n\n.module-del:hover {\ntransform: translateY(-50%) scale(1.1);\n}\n\n.module-item:last-child {\nborder-bottom: none;\n}</style>");
$templateCache.put("app/admin/campaignTracking/addCampaignTracking/addCampaignTracking.html","<admin-header statename=\"Campaign Tracking\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=campaign.name><label class=mt-10>Description</label><input type=text class=form-control ng-model=campaign.description><label class=mt-10>Campaign Type</label><select class=form-control ng-model=campaign.type><option value=organic selected>Organic</option><option value=inorganic>Inorganic</option></select><label class=mt-10>Campaign Medium</label><!-- <select class=\"form-control\" ng-model=\"campaign.medium\">\n        <option value=\"facebook\" selected>Facebook</option>\n        <option value=\"youtube\">Youtube</option>\n      </select> --><div ng-dropdown-multiselect=\"\" options=campaignMedium selected-model=campaign.medium events=yourEvents></div><input type=text style=\"margin-top: 10px\" placeholder=\"Other Medium\" class=form-control ng-if=otherMedium ng-model=campaign.otherMedium><label class=mt-10>Campaign Category</label><select class=form-control ng-model=campaign.category><option value=tof selected>TOF</option><option value=mof>MOF</option><option value=bof>BOF</option></select><label class=mt-10>Campaign Behavior</label><select class=form-control ng-model=campaign.behavior><option value=retargeting selected>Retargeting</option><option value=fresh>Fresh</option></select><label class=mt-10>Budget</label><input type=number class=form-control ng-model=campaign.budget><label class=mt-10>Wati Match Text</label><input type=text class=form-control ng-model=campaign.match_text><label class=mt-10>Match Text Accuracy ({{campaign.match_text_accuracy}}%)</label><input type=range name=range ng-model=campaign.match_text_accuracy min=0 max=100></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px; margin-top: 30px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/campaignTracking/campaignStats/campaignStats.html","<admin-header statename=\"Campaign Stats\"></admin-header><div><div class=\"col-md-12 col-lg-12 blocks-holder\"><div class=row><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Total leads</div><span class=text>{{stats.totalLeads || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Total Messages</div><span class=text>{{stats.totalMessages || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Users Sent Msg Multiple Times</div><span class=text>{{stats.multiMessageUsers || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Total cost</div><span class=text>{{stats.totalCost || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Cost per lead</div><span class=text>{{stats.costPerLead.toFixed(2) || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Leads converted</div><span class=text>{{stats.totalConvetedLeads.toFixed(2) || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Cost per conversion</div><span class=text>{{stats.costPerConvertedLead.toFixed(2) || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>% conversation rate</div><span class=text>{{stats.conversionPercentage.toFixed(2) || 0}}%</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Avg days to convert</div><span class=text>{{stats.avgDaysToConvert.toFixed(2) || 0}}</span></div></div><div class=\"col-xs-6 col-sm-4 col-md-2 col-lg-2\"><div class=block><div class=head>Top Cities</div><p class=text style=\"display: block; padding: 10px 0\" ng-repeat=\"city in stats.topCities\">{{city.city}}</p></div></div></div><div class=row><button class=\"btn btn-default secondry_btn\" ng-click=downloadCsvReport()>Download CSV</button></div></div></div>");
$templateCache.put("app/admin/coupons/addCoupon/addCoupon.html","<admin-header statename=\"Add Coupon\"></admin-header><div class=row><div id=download_csv></div><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Coupon</h3></div><div class=\"col-xs-12 col-md-7\"><div class=\"publish form-group mt-10\"><input type=checkbox ng-model=coupon.custom ng-change=\"changeCoupon(\'custom\')\"> Custom Coupon <input type=checkbox ng-model=coupon.bulk ng-change=\"changeCoupon(\'bulk\')\" style=\"margin-left: 40px\"> Bulk Coupons</div><div ng-if=coupon.custom><label class=mt-10>Coupon Name</label><input type=text class=form-control ng-model=coupon.name></div><div ng-if=coupon.bulk><label class=mt-10>Number of Coupons</label><input type=text class=form-control ng-model=coupon.quantity><label class=mt-10>Prefix</label><input type=text class=form-control ng-model=coupon.prefix></div><label class=mt-10>Price</label><input type=number class=form-control ng-model=coupon.price><label class=mt-10>Expiry Date</label><input type=datetime-local class=form-control ng-model=coupon.expiryDate><label class=mt-10>Single user frequency</label><input type=number class=form-control ng-model=coupon.peruse><label class=mt-10>Overall use frequency</label><input type=number class=form-control ng-model=coupon.total_frequency><label class=mt-10>Days Access</label><input type=number class=form-control ng-model=coupon.access_days><label class=mt-10>Order Expiry Configuration</label><select class=form-control ng-model=coupon.order_terminate_config><option value=access-days selected>On Access Days</option><option value=expiry-date>On Expiry Date</option></select><div class=\"publish form-group mt-10\"><span>Allow coupon on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=coupon.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow coupon on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in coupon.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><div class=\"publish form-group mt-10\"><span>Allow coupon on specific Module</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificModule> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in coupon.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=createCoupons() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/coupons/editCoupon/editCoupon.html","<admin-header statename=\"Edit Coupon\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Edit Coupon</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Coupon Name</label><input type=text class=form-control ng-model=coupon.name><label class=mt-10>Price</label><input type=number class=form-control ng-model=coupon.price><label class=mt-10>Expiry Date</label><input type=datetime-local class=form-control ng-model=coupon.expiryDate><label class=mt-10>Single user frequency</label><input type=number class=form-control ng-model=coupon.peruse><label class=mt-10>Overall use frequency</label><input type=number class=form-control ng-model=coupon.total_frequency><label class=mt-10>Days Access</label><input type=number class=form-control ng-model=coupon.access_days><label class=mt-10>Order Expiry Configuration</label><select class=form-control ng-model=coupon.order_terminate_config><option value=access-days selected>On Access Days</option><option value=expiry-date>On Expiry Date</option></select><div class=\"publish form-group mt-10\"><span>Allow coupon on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=coupon.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow coupon on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in coupon.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><div class=\"publish form-group mt-10\"><span>Allow coupon on specific Module</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=coupon.specificModule> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=coupon.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in coupon.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=updateCoupons() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/courseTags/AddTags/addTags.html","<admin-header statename=\"Course Tags\"></admin-header><div class=\"col-xs-12 col-md-7\"><div style=\"padding: 30px 0; color: #04044D\"><h2>{{id ? \'Update Tag:\' : \'New Tags:\'}}</h2></div><div><label class=mt-10>Tag Name</label><input type=text class=form-control ng-model=tagName></div><div class=clearfix></div><div class=\"publish form-group mt-20\"><span>Mobile Market</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=mobileMarket> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=clearfix></div><div class=container style=\"margin:20px 0px; max-width: 600px; padding-left:0px\"><div class=row><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Institution\">Select Institute</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedSchool ng-change=updateSchool(selectedSchool) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Faculty\">Select Faculty</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedCourse ng-change=updateCourse(selectedCourse) style=\"width: 150px; margin: 5px 0; border:1px solid black\"><option value=\"Select Course\">Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><h3>Selected course for current Tag</h3><div class=clearfix></div><ul><div ng-repeat=\"course in selectedCourses | filter:myFilter\" value={{$index}}><div style=\"margin: 10px; display: flex; align-items: center\"><p style=\"margin-right: 20px; margin-bottom: 0px\">{{course.name}}</p><input type=number name=sort placeholder=\"Sort #\" ng-model=course.no required> <i style=\"margin-left: 30px;font-weight: bold\" ng-click=removeCourse(course)>X</i></div></div></ul><div class=clearfix></div><div class=col-12><button type=button class=\"btn btn-primary\" style=\"float: right; margin-right: 15%\" ng-click=saveTag()>{{id ? \'Update\' : \'Create\'}}</button><!-- <button ng-if=\"id\" type=\"button\" class=\"btn btn-danger\" style=\"float: right; margin-right: 15px\" ng-click=\"deleteTag()\">\n            Delete\n        </button> --></div></div>");
$templateCache.put("app/admin/enrollmentGroups/AddEnrollmentGroups/addEnrollmentGroups.html","<admin-header statename=\"Enrollment Group\"></admin-header><div style=\"height: calc(100vh)\"><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Enrollment Group:</h2></div><div><p>{{id ? \'Update Enrollment Group:\' : \'New Enrollment Group:\'}}</p><p style=\"float: left; margin-right:30px\">Enter Name here:</p><input type=text class=borderOnePixel ng-model=tagName></div><div class=\"publish form-group mt-10\"><span>Allow Auto Enrollment</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=autoEnroll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=clearfix></div><div class=container style=\"margin:20px 0px; max-width: 600px; padding-left:0px\"><div class=row><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Institution\">Select Institute</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedSchool ng-change=updateSchool(selectedSchool) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Faculty\">Select Faculty</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedCourse ng-change=updateCourse(selectedCourse) style=\"width: 150px; margin: 5px 0; border:1px solid black\"><option value=\"Select Course\">Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><h3>Selected course for Enrollment Group</h3><div class=clearfix></div><ul><div ng-repeat=\"course in selectedCourses | filter:myFilter\" value={{$index}}><div style=\"margin: 10px\">{{course.name}}<i style=\"margin-left: 30px;font-weight: bold\" ng-click=removeCourse(course)>X</i></div></div></ul><div class=clearfix></div><div class=col-12><button type=button class=\"btn btn-primary\" style=\"float: right; margin-right: 15%\" ng-click=saveTag()>{{id ? \'Update\' : \'Create\'}}</button><!-- <button ng-if=\"id\" type=\"button\" class=\"btn btn-danger\" style=\"float: right; margin-right: 15px\" ng-click=\"deleteTag()\">\n            Delete\n        </button> --></div></div>");
$templateCache.put("app/admin/freeAccessConfig/editFreeAccess/editFreeAccess.html","<admin-header statename=\"Edit Free Acccess Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Edit Free Acccess Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><label class=mt-10>From Joining Date</label><input type=datetime-local class=form-control ng-model=accessConfig.from_joining><label class=mt-10>To Joining Date</label><input type=datetime-local class=form-control ng-model=accessConfig.to_joining><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific Module</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificModule> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=updateConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/freeAccessConfig/addFreeAccess/addFreeAccess.html","<admin-header statename=\"Add Free Acccess Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Free Acccess Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><label class=mt-10>From Joining Date</label><input type=datetime-local class=form-control ng-model=accessConfig.from_joining><label class=mt-10>To Joining Date</label><input type=datetime-local class=form-control ng-model=accessConfig.to_joining><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific Module</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificModule> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/freeAccessConfig/freeAccessTracking/freeAccessTracking.html","<admin-header statename=\"Mobile Free Access Data\"></admin-header><div class=order-management><div class=\"row pb-30 order-mgt-block\"><div class=\"col-md-12 mt-10 page-num-block\"><div class=\"col-xs-6 col-md-3\"><input ng-disabled=\"searchParams.type===\'all\'\" type=text placeholder=Search ng-model=searchParams.key ng-change=\"searchParams.key.length > 0 ? searchOrder(searchParams.key, searchParams.type,false,true) : null\" class=form-control> <span>By:</span><ul ng-if=\"searchData.length > 0\" class=list-group><!-- ng-click=\"addVariants(user,\'user\')\" --><li ng-click=\"searchOrder(row.email || row.fb_email || row.name || row.full_name,searchParams.type,true,true, row)\" class=list-group-item ng-repeat=\"row in searchData\">{{row.email || row.fb_email || row.name || row.full_name }} {{row.provider ? \'(\' + row.provider + \')\' : \'\'}}</li></ul></div><div class=\"col-xs-6 col-md-2 btn-group\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><label>{{ searchParams.type ||\'SearchType\'}}</label><span class=\"fa fa-angle-down\"></span></button><ul class=\"search-type dropdown-menu\"><li ng-repeat=\"type in searchType\"><a ng-click=changeType(type)>{{type}}</a></li></ul></div><div class=\"col-xs-6 col-md-2 download-csv-block\"><label for=dateFrom>From:</label><input type=date ng-model=fromDate name=dateFrom><label for=dateTo>To:</label><input type=date id=birthday ng-model=toDate name=dateTo> <a id=download_csv ng-click=downloadTracking()>Download CSV</a></div><div class=\"col-xs-12 col-md-4 ng-binding no-of-pages\"><nav ng-hide=hidePagination><ul class=pagination><li class=previous ng-click=pagination(searchParams.page-1)><a href=\"\"><span>&lt;</span></a></li><li class=next ng-click=pagination(searchParams.page+1)><a href=\"\"><span>&gt;</span></a></li></ul></nav><span class=order-page-detail>{{searchParams.page}} in {{totalPages}} ,{{(searchParams.page*searchParams.per_page)-searchParams.per_page}}-{{searchParams.per_page*searchParams.page}} Out of {{totalCount}}</span></div></div><div class=\"col-md-12 order-item-table mt-30\"><table class=\"table table-bordered table-striped\"><thead><tr><th class=text-center>User ID</th><th class=text-center>User Name</th><th class=text-center>Config Name</th><th class=text-center>Config Used Date</th><th class=text-center>Course Name</th><th class=text-center>Module Name</th></tr></thead><tbody><tr ng-repeat=\"order in tracking | orderBy:id:false\"><td>{{order.user_id.id}}</td><td>{{order.user_id.full_name || order.user_id.name}}</td><td>{{order.access_config_id.name}}</td><td>{{order.access_config_id.createdAt | date:\"dd/MM/yyyy\"}}</td><td>{{order.course_id.name}}</td><td>{{order.module_id.name || \'N/A\'}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/formBuilder/addForm/addForm.html","<admin-header statename=\"Custom Form\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Custom Form</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Form Name</label><input type=text class=form-control ng-model=form.name><label class=mt-10>Description</label><input type=text class=form-control ng-model=form.description><div class=\"publish form-group mt-10\"><span>Mobile App Form</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=form.mobileForm> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"publish form-group mt-10\"><span>Show form on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=form.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=form.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=form.selectedTags></div></div><div class=\"publish form-group mt-20\"><span>Show form on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=form.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=form.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in form.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow coupon on specific Module</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"form.specificModule\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div ng-if=form.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in form.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><label class=mt-20>User Type:</label><select ng-model=form.userType><option value=purchased selected>Course Purchased</option><option value=enrolled_only>Enrolled Only</option><option value=all>All</option></select><div style=\"margin-top: 30px\"><h4>Build Your Form:</h4><div id=fb-editor></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=updateFrom() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/htmlPages/addHtmlPage/addHtmlPage.html","<admin-header statename=\"Add/Edit HTML Page\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>{{page.id ? \'Edit\' : \'Add\'}} HTML Page</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name *</label><input type=text class=form-control ng-model=page.name placeholder=\"Enter page name\"><label class=mt-10>Link (Slug) *</label><input type=text class=form-control ng-model=page.link placeholder=enter-page-slug><label class=mt-10>Content *</label><div style=\"color: red\"><p><strong>Design & Styling Disclaimer (Team Note)</strong></p><p>Purpose: This note clarifies the styling rules and guidelines for our front-end codebase to maintain consistency and prevent unintended side effects.</p><p><strong>Core Guidelines:</strong></p><ol style=\"margin-left: 25px\"><li>Class-first styling: Always apply CSS using class selectors or inline styles. Avoid global element selectors.</li><li>Do not style base HTML tags: Never style body, p, h1–h6, b, i, or other native tags globally. Use class-based alternatives.</li><li>Scoped overrides only: If a component needs style variations, use modifier classes (e.g., .button--primary) instead of overriding base rules globally.</li><li>Inline styles: Use inline styles only for dynamic or one-off runtime values (e.g., CMS content, SVG fills). Do not use inline styles for reusable UI.</li><li>Responsiveness: Use relative units, utility classes, or modifier classes to make elements adapt across breakpoints. Avoid hard-coded pixels unless necessary.</li></ol></div><!-- <text-angular ng-model=\"page.content\" placeholder=\"Enter HTML content\"></text-angular> --><textarea class=form-control ng-model=page.content rows=10 placeholder=\"Enter HTML content\"></textarea></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px; margin-top: 30px\"><button ng-click=savePage() class=\"btn btn-default primary_btn\">Save Page</button> <button ng-click=\"goToState(\'HtmlPages\')\" class=\"btn btn-default\" style=\"margin-left: 10px\">Cancel</button></div>");
$templateCache.put("app/admin/instructor/addInstructor/addInstructor.html","<admin-header statename=\"Add Instructor\"></admin-header><div class=row><div class=col-md-12><div class=\"col-md-12 mb-20\"><div class=\"col-md-6 padding0\"><div class=uploadlgBox><span class=cross><i class=\"fa fa-times\" aria-hidden=true></i> </span><input type=file accept=image/* ng-model=image ngf-select=uploadImage(image)> <img class=uploaded_image ng-if=instructor.image src={{instructor.image}} alt=\"No image\"> <span ng-if=!instructor.image class=upload>Upload Image</span></div></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><input type=text ng-model=instructor.name placeholder=\"Instructor Name\" class=form-control></div><div class=col-md-8></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><input type=number ng-model=instructor.experience placeholder=\"Instructor Experience\" class=form-control></div><div class=col-md-8></div></div><div class=\"col-md-12 mb-20\"><textarea ng-model=instructor.description placeholder=\" Add Instructor Description \" class=form-control rows=7></textarea></div><!-- <get-course></get-course> --><div class=col-md-12><label class=mt-10>Select Niche</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=InstructorTags ng-click=updateInstructorTags(tag.id,tag.label)></div></div><div><div><div class=form-group><label style=\"margin-top: 30px\">Select Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><label style=\"margin-top: 20px\">Selected Courses</label><div class=\"course-holder mb-20\"><div class=col-md-4 ng-repeat=\"course in selectedCourses\"><div class=text-holder><span>{{course.name | limitTo: 40}} {{course.name.length > 40 ? \'...\' : \'\'}}</span> <span class=del ng-click=deletecourse($index)><i class=\"fa fa-times\" aria-hidden=true></i></span></div></div></div><!-- <label style=\"margin-top: 20px;\">Selected Niches</label>\n      <div class=\"tag-holder mb-20\">\n          <div class=\"col-md-4\" ng-repeat=\"tag in InstructorTags\">\n              <div class=\"text-holder\">\n                  <span>{{tag.label | limitTo: 40}} {{tag.label.length > 40 ? \'...\' : \'\'}}</span>\n                  <span class=\"del\" ng-click=\"deleteTag($index)\">\n                      <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                  </span>\n              </div>\n          </div>\n      </div> --></div><div class=\"col-md-12 mb-20\" style=\"margin-top: 40px\"><button class=\"btn btn-default secondry_btn\" ng-click=HandleSave()>{{isEdit? \'Update\' : \'Save\'}}</button></div></div></div>");
$templateCache.put("app/admin/mobilePopupConfig/addMobilePopupConfig/addMobilePopupConfig.html","<admin-header statename=\"Add Mobile Browser Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Mobile Browser Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><div class=\"publish form-group mt-10\"><span>Paid Users Only</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.paid_only> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><!-- <label class=\"mt-10\">From Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.from_joining\" />\n            <label class=\"mt-10\">To Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.to_joining\" /> --><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific Module</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificModule\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/mobilePopupConfig/editMobilePopupConfig/editMobilePopupConfig.html","<admin-header statename=\"Edit Mobile Browser Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Edit Mobile Browser Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><div class=\"publish form-group mt-10\"><span>Paid Users Only</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.paid_only> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><!-- <label class=\"mt-10\">From Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.from_joining\" />\n            <label class=\"mt-10\">To Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.to_joining\" /> --><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific Module</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificModule\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=updateConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/npSharePercentage/addNpSharePercentage/addNpSharePercentage.html","<admin-header statename=\"Add Np Share Configurations\"></admin-header><div class=row ng-if=!isEdit><div class=\"col-sm-12 col-md-12 col-lg-12 padding0\"><div class=\"col-xs-12 col-md-4 col-lg-4\"><div class=form-group><label for=Institution>Select Institution</label><select class=form-control id=Institution ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div></div><div class=\"col-xs-12 col-md-4 col-lg-4 course-dropdown\"><div class=form-group><label for=faculty>Select Faculty</label><select class=form-control id=faculty ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-disabled=\"selected_faculty.length==0\" ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div></div><!-- <div class=\"col-xs-12 col-md-4 col-lg-4\">\n            <div class=\"form-group\">\n                <label for=\"courses\">Select Course</label>\n                <select class=\"form-control\" id=\"courses\" ng-disabled=\"courses.length==0\" ng-model=\"selectedCourse\"\n                    ng-change=\"updateCourse(selectedCourse)\">\n                    <option ng-repeat=\"course in courses\" value=\"{{$index}}\">{{course.name}}</option>\n                </select>\n            </div>\n        </div> --></div></div><table class=table><colgroup><col class=col-xs-6><col class=col-xs-3><col class=col-xs-3></colgroup><thead><tr><th><p class=\"pTag table_th\" style=\"text-align: left\">Course Name</p></th><th><p class=\"pTag table_th\">Share Percentage</p></th><th><p class=\"pTag table_th\">Action</p></th></tr></thead><tbody><tr ng-repeat=\"course in selectedCourses\"><td><p class=pTag style=\"text-align: left\">{{course.name}}</p></td><td style=\"text-align: right\"><input type=number ng-model=course.np_share_percentage class=form-control></td><td style=\"text-align: center; margin-right: 20px\" ng-click=removeCourse($index)>X</td></tr></tbody></table><div class=\"col-md-12 pl-30 mt-10\"><button class=\"btn btn-default primary_btn\" ng-click=createPromptConfig()>Save</button></div>");
$templateCache.put("app/admin/postQuestionConfig/editPostQuestionConfig/editPostQuestionConfig.html","<admin-header statename=\"Edit Post Question Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Edit Post Question Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><div class=\"publish form-group mt-10\"><span>Paid Users Only</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.paid_only> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><!-- <label class=\"mt-10\">From Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.from_joining\" />\n            <label class=\"mt-10\">To Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.to_joining\" /> --><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific Module</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificModule\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=updateConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/postQuestionConfig/addPostQuestionConfig/addPostQuestionConfig.html","<admin-header statename=\"Add Post Question Config\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Add New Post Question Config</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><div class=\"publish form-group mt-10\"><span>Paid Users Only</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.paid_only> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><!-- <label class=\"mt-10\">From Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.from_joining\" />\n            <label class=\"mt-10\">To Joining Date</label>\n            <input type=\"datetime-local\"  class=\"form-control\" ng-model=\"accessConfig.to_joining\" /> --><div class=\"publish form-group mt-10\"><span>Allow Access on specific tag</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificTag> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificTag><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags></div></div><div class=\"publish form-group mt-10\"><span>Allow Access on specific course</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=accessConfig.specificCourse> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div ng-if=accessConfig.specificCourse><div><div class=form-group><label>Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course\')\" class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=container-fluid><h4>Selected Courses</h4><div class=row style=\"margin-top: 20px; margin-left: 30px\"><div style=\"display: flex; flex-direction: row\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\"><p>{{course.name}}</p><p style=\"margin-left: 20px; font-weight: bold\">X</p></div></div></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific Module</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificModule\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div ng-if=accessConfig.specificModule><div><div class=form-group><label>Course</label><input type=text ng-model=courseModuleKey class=form-control ng-change=\"courseModuleKey.length > 0 ? searchInfo(courseModuleKey, \'course-module\') : null\" placeholder=\"Search Course\"><ul ng-if=\"coursesModule.length > 0\" class=list-group><li ng-click=\"selectCourse(course, \'course-module\')\" class=list-group-item ng-repeat=\"course in coursesModule\">{{course.name}}</li></ul></div><div class=form-group><label for=courses>Modules</label><select class=form-control id=modules ng-disabled=\"modules.length==0\" ng-model=selectModule ng-change=addModule(selectModule)><option ng-repeat=\"module in modules\" value={{module}}>{{module.name}}</option></select></div></div><div class=container-fluid><h4>Selected Modules</h4><div class=row style=\"margin-top: 20px\"><table style=\"width: 100%\"><tr><th>Course</th><th>Module</th><th>Action</th></tr><tr ng-repeat=\"module in accessConfig.selectedModules\"><td>{{module.course_name}}</td><td>{{module.name}}</td><td style=\"margin-left: 20px; font-weight: bold; text-align: center\" ng-click=\"deleteModule(module, $index)\">X</td></tr></table></div></div></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/questionsMarket/AddMarket/AddMarket.html","<admin-header statename=\"Question Market\"></admin-header><div style=\"height: calc(100vh)\"><div style=\"padding: 30px 0; color: #04044D\"><h2>Welcome to Question Market:</h2></div><div><p>{{id ? \'Update Market:\' : \'New Market:\'}}</p><p style=\"float: left; margin-right:30px\">Enter Name here:</p><input type=text class=borderOnePixel ng-model=tagName></div><div class=clearfix></div><!-- <div class=\"container\" style=\"margin:20px 0px; max-width: 600px; padding-left:0px;\">\n        <div class=\"row\">\n            <div class=\"col-md-4 col-sm-4\">\n                <select ng-model=\"selectedInstitution\" ng-change=\"updateInstitution(selectedInstitution)\" style=\"width: 150px; margin: 5px 0;border:1px solid black;\">\n                    <option value=\"Select Institution\">Select Institute</option>\n                    <option ng-repeat=\"institute in institutions\" value=\"{{$index}}\">{{institute.institution}}</option>\n                </select>\n            </div>\n            <div class=\"col-md-4 col-sm-4\">\n                <select ng-model=\"selectedSchool\" ng-change=\"updateSchool(selectedSchool)\" style=\"width: 150px; margin: 5px 0;border:1px solid black;\">\n                    <option value=\"Select Faculty\">Select Faculty</option>\n                    <option ng-repeat=\"faculty in selected_faculty\" value=\"{{faculty.faculty}}\">{{faculty.faculty}}</option>\n                </select>\n            </div>\n            <div class=\"col-md-4 col-sm-4\">\n                <select ng-model=\"selectedCourse\" ng-change=\"updateCourse(selectedCourse)\" style=\"width: 150px; margin: 5px 0; border:1px solid black;\">\n                    <option value=\"Select Course\">Select Course</option>\n                    <option ng-repeat=\"course in courses\" value=\"{{$index}}\">{{course.name}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n    <h3>Selected course for current Tag</h3>\n    <div class=\"clearfix\"></div>\n    <ul>\n        <div ng-repeat=\"course in selectedCourses | filter:myFilter\" value=\"{{$index}}\">\n            <div style=\"margin: 10px; display: flex; align-items: center;\">\n                <p style=\"margin-right: 20px; margin-bottom: 0px;\">{{course.name}}</p>\n                <input type=\"number\" name=\"sort\" placeholder=\"Sort #\" ng-model=\"course.no\" required=\"required\"/>\n                <i style=\"margin-left: 30px;font-weight: bold;\" ng-click=\"removeCourse(course)\">X</i>\n            </div>\n        </div>\n    </ul> --><div class=clearfix></div><div class=col-12><button type=button class=\"btn btn-primary\" style=\"float: right; margin-right: 15%\" ng-click=saveTag()>{{id ? \'Update\' : \'Create\'}}</button></div></div>");
$templateCache.put("app/admin/promOpenAI/addPromOpenAI/addPromOpenAI.html","<admin-header statename=\"Add prompt open AI Configurations\"></admin-header><div class=row ng-if=!isEdit><div class=\"col-sm-12 col-md-12 col-lg-12 padding0\"><div class=\"col-xs-12 col-md-4 col-lg-4\"><div class=form-group><label for=Institution>Select Institution</label><select class=form-control id=Institution ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution)><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div></div><div class=\"col-xs-12 col-md-4 col-lg-4 course-dropdown\"><div class=form-group><label for=faculty>Select Faculty</label><select class=form-control id=faculty ng-model=selectedSchool ng-change=updateSchool(selectedSchool)><option ng-disabled=\"selected_faculty.length==0\" ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><div class=form-group><label for=courses>Select Course</label><select class=form-control id=courses ng-disabled=\"courses.length==0\" ng-model=selectedCourse ng-change=updateCourse(selectedCourse)><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div></div><div class=row ng-if=isEdit><h3>Course Name: {{promptConfig.course_id.name}}</h3></div><div class=row><div class=\"col-sm-12 col-md-6 col-lg-6 padding0\"><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectInstituteField ng-model=promptConfig.categoryPrompt placeholder=\"Category Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=form-group><input class=\"form-control mt-20\" type=text ng-model=promptConfig.difficultyPrompt placeholder=\"Difficulty Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.topicPrompt placeholder=\"Topic Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.solutionPrompt placeholder=\"Solution Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.optionPrompt placeholder=\"Option Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12 publish form-group mt-10\"><span>Course & Subject from AI</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=promptConfig.courseFromAi> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"col-xs-12 col-md-12 col-lg-12 course-dropdown\" ng-if=promptConfig.courseFromAi><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectFacultyField ng-model=promptConfig.subjectPrompt placeholder=\"Subject Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\" ng-if=promptConfig.courseFromAi><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.chapterPrompt placeholder=\"Chapter Prompt\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\" ng-if=!promptConfig.courseFromAi><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.subjectName placeholder=\"Subject Name\"></div></div><div class=\"col-xs-12 col-md-12 col-lg-12\" ng-if=!promptConfig.courseFromAi><div class=form-group><input class=\"form-control mt-20\" type=text id=SelectCourseField ng-model=promptConfig.chapterName placeholder=\"Chapter Name\"></div></div></div></div><div class=\"col-md-12 pl-30 mt-10\"><button class=\"btn btn-default primary_btn\" ng-click=createPromptConfig()>Save</button></div>");
$templateCache.put("app/admin/promOpenAI/addPromModuleOpenAI/addPromModuleOpenAI.html","<admin-header statename=\"Add prompt open AI Configurations\"></admin-header><div class=panel-group id=accordion><div class=\"panel panel-default\" ng-repeat=\"module in modules\"><div class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#{{module.id}} style=\"padding-bottom: 60px\"><h4 class=\"panel-title flex-view align-items-center justify-content-b\" style=\"width: 100%\"><a class=\"accordion-toggle font-bold\" href=#{{module.id}}>{{module.name}}</a> <button class=\"btn btn-default secondry_btn\" ng-click=\"addConfigPopUpOpen(\'module\', module.id, module)\">{{module.prompt.length > 0 ? \'Edit Config\' : \'Add Config\'}}</button></h4></div><div id={{module.id}} class=\"panel-collapse collapse\"><div class=panel-body style=\"padding-bottom: 15px\" ng-repeat=\"video in module.videos\"><div class=\"flex-view align-items-center justify-content-b\"><p class=mb-0><img src=../../../../images/play-icon.png width=20 height=20><span style=\"font-size: 16px; margin-left: 15px\">{{video.name}}</span></p><button class=\"btn btn-default secondry_btn mb-0\" ng-click=\"addConfigPopUpOpen(\'video\', video.id, video)\">{{video.prompt.length > 0 ? \'Edit Config\' : \'Add Config\'}}</button></div></div></div></div></div><div class=story-admin-popup ng-if=addCofig><div class=\"story-admin-popup-wrapper prom-cofig\"><div class=popup-close-icon ng-click=addConfigPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Add {{configType}} config</h2></div><div class=story-admin-popup-body><div class=row><div class=col-md-12><div class=form-group><label for=categoryPrompt>Category Prompt</label><input class=form-control type=text ng-model=promptConfig.categoryPrompt placeholder=\"Category Prompt\"></div><div class=form-group><label for=topicPrompt>Topic Prompt</label><input class=form-control type=text ng-model=promptConfig.topicPrompt placeholder=\"Topic Prompt\"></div><div class=form-group><label for=solutionPrompt>Solution Prompt</label><input class=form-control type=text ng-model=promptConfig.solutionPrompt placeholder=\"Solution Prompt\"></div><div class=form-group><label for=optionPrompt>Option Prompt</label><input class=form-control type=text ng-model=promptConfig.optionPrompt placeholder=\"Option Prompt\"></div><div class=\"publish form-group mt-10\"><span>Course & Subject from AI</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=promptConfig.courseFromAi> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=form-group ng-if=promptConfig.courseFromAi><label for=subjectPrompt>Subject Prompt</label><input class=form-control type=text ng-model=promptConfig.subjectPrompt placeholder=\"Subject Prompt\"></div><div class=form-group ng-if=promptConfig.courseFromAi><label for=chapterPrompt>Chapter Prompt</label><input class=form-control type=text ng-model=promptConfig.chapterPrompt placeholder=\"Chapter Prompt\"></div><div class=form-group ng-if=!promptConfig.courseFromAi><label for=optionPrompt>Subject Name</label><input class=form-control type=text ng-model=promptConfig.subjectName placeholder=\"Subject Name\"></div><div class=form-group ng-if=!promptConfig.courseFromAi><label for=optionPrompt>Chapter Name</label><input class=form-control type=text ng-model=promptConfig.chapterName placeholder=\"Chapter Name\"></div><button class=\"btn btn-default secondry_btn mt-20\" ng-click=createPromptConfig()>Save</button></div></div></div></div></div>");
$templateCache.put("app/admin/promOpenAI/addPromTagOpenAI/addPromTagOpenAI.html","<admin-header statename=\"Add prompt open AI Configurations\"></admin-header><div class=panel-group id=accordion><div class=\"panel panel-default\" ng-repeat=\"tag in tags\"><div class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#{{tag.id}} style=\"padding-bottom: 60px\"><h4 class=\"panel-title flex-view align-items-center justify-content-b\" style=\"width: 100%\"><a class=\"accordion-toggle font-bold\" href=#{{tag.id}}>{{tag.name}}</a> <button class=\"btn btn-default secondry_btn\" ng-click=\"addConfigPopUpOpen(\'tag\', tag.id, tag)\">{{tag.prompt.length > 0 ? \'Edit Config\' : \'Add Config\'}}</button></h4></div></div></div><div class=story-admin-popup ng-if=addCofig><div class=\"story-admin-popup-wrapper prom-cofig\"><div class=popup-close-icon ng-click=addConfigPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Add Niche config</h2></div><div class=story-admin-popup-body><div class=row><div class=col-md-12><div class=form-group><label for=categoryPrompt>Category Prompt</label><input class=form-control type=text ng-model=promptConfig.categoryPrompt placeholder=\"Category Prompt\"></div><div class=form-group><label for=topicPrompt>Difficulty Prompt</label><input class=form-control type=text ng-model=promptConfig.difficultyPrompt placeholder=\"Difficulty Prompt\"></div><div class=form-group><label for=topicPrompt>Topic Prompt</label><input class=form-control type=text ng-model=promptConfig.topicPrompt placeholder=\"Topic Prompt\"></div><div class=form-group><label for=solutionPrompt>Solution Prompt</label><input class=form-control type=text ng-model=promptConfig.solutionPrompt placeholder=\"Solution Prompt\"></div><div class=form-group><label for=optionPrompt>Option Prompt</label><input class=form-control type=text ng-model=promptConfig.optionPrompt placeholder=\"Option Prompt\"></div><div class=\"publish form-group mt-10\"><span>Course & Subject from AI</span><div class=checkbox style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\"><label><input type=checkbox ng-model=promptConfig.courseFromAi> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=form-group ng-if=promptConfig.courseFromAi><label for=subjectPrompt>Subject Prompt</label><input class=form-control type=text ng-model=promptConfig.subjectPrompt placeholder=\"Subject Prompt\"></div><div class=form-group ng-if=promptConfig.courseFromAi><label for=chapterPrompt>Chapter Prompt</label><input class=form-control type=text ng-model=promptConfig.chapterPrompt placeholder=\"Chapter Prompt\"></div><div class=form-group ng-if=!promptConfig.courseFromAi><label for=optionPrompt>Subject Name</label><input class=form-control type=text ng-model=promptConfig.subjectName placeholder=\"Subject Name\"></div><div class=form-group ng-if=!promptConfig.courseFromAi><label for=optionPrompt>Chapter Name</label><input class=form-control type=text ng-model=promptConfig.chapterName placeholder=\"Chapter Name\"></div><button class=\"btn btn-default secondry_btn mt-20\" ng-click=createPromptConfig()>Save</button></div></div></div></div></div>");
$templateCache.put("app/admin/quizConfigurations/create/create.html","<admin-header statename=\"Add/Edit Quiz Configuration\"></admin-header><div class=row><div class=\"alert alert-warning\" ng-show=showAlert>You have exceeded the available questions. Maximum allowed is {{ maxPercentageAllowed }}%.</div><div class=col-md-12><!-- <div class=\"col-md-12 mb-20\">\n      <div class=\"col-md-6 padding0\">\n        <div class=\"uploadlgBox\">\n          <span class=\"cross\"><i ng-click=\"delImage()\" class=\"fa fa-times\" aria-hidden=\"true\"></i></span>\n          <input type=\"file\" accept=\"image/*\" ng-model=\"image\" ngf-select=\"uploadImage(image)\">\n          <img class=\"uploaded_image\" ng-if=\"bundle.image_url\" src=\"{{bundle.image_url}}\" alt=\"\" />\n          <span ng-if=\"!bundle.image_url\" class=\"upload\">Upload Image</span>\n        </div>\n      </div>\n      <div class=\"col-md-6 padding0\">\n        <div class=\"pull-right\">\n          <button class=\"btn btn-default secondry_btn\" ng-click=\"SaveBundle(bundle)\">Delete Bundle</button>\n        </div>\n      </div>\n    </div> --><div class=\"col-md-4 padding0\" ng-if=isShow><button class=\"btn btn-primary\" ng-click=toggleCustomExam()>Add Custom Exam</button></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Exam Name</label><div ng-if=!isCustomExam><select ng-model=bundle.name class=form-control><option value=FLP>FLP</option><option value=HLP>HLP</option></select></div><div ng-if=isCustomExam><input type=text ng-model=bundle.name class=form-control placeholder=\"Enter Exam Name\"></div></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Total Questions</label><input type=number ng-model=bundle.total_questions placeholder=\"Total Questions\" class=form-control ng-readonly=!isCustomExam></div></div><div class=\"col-md-12 mb-20\"><div class=\"col-md-4 padding0\"><label>Time Limit</label><input type=number ng-model=bundle.time_limit placeholder=\"Time Limit\" class=form-control ng-readonly=!isCustomExam></div></div><!-- <div class=\"col-md-12 mb-20\">\n      <div class=\"col-md-4 padding0\">\n        <label>Nearpeer Share</label>\n        <input type=\"number\" ng-model=\"bundle.np_share\" placeholder=\"Nearpeer Share\" class=\"form-control\">\n      </div>\n    </div> --><div class=\"col-md-12 mb-20\" ng-if=isShow><!-- <div class=\"col-md-4 padding0\">\n        <label for=\"Institution\">Select Tag</label>\n        <select class=\"form-control\" id=\"Institution\" ng-model=\"bundle.tag_id\">\n          <option ng-repeat=\"tag in nichetags\" ng-value=\"tag.id\">{{tag.name}}</option>\n        </select>\n      </div> --></div><div class=\"col-md-12 mb-20\"><!-- NEW: Subjects Available --><h4 class=text-primary ng-if=\"bundle.subjects.length > 0\">Subjects Added</h4><div class=row><div class=col-md-6 ng-repeat=\"subject in bundle.subjects track by $index\"><div class=\"card border-primary mb-3\"><div class=\"card-header bg-primary text-white d-flex justify-content-between align-items-center\"><span class=font-weight-bold>{{subject.name}}</span> <button class=\"btn btn-danger btn-sm\" ng-click=removeSubject($index)><i class=\"fa fa-trash\"></i> Delete</button></div><div class=card-body><div class=form-group><label>Question Count: (Max: {{subject.total_available_questions}})</label><input type=number class=form-control ng-model=subject.question_occurance_percentage ng-change=validateSubjectQuestionCount(subject)></div><div class=form-group><label>Difficulties:</label><div class=\"d-flex flex-wrap\"><span class=\"badge badge-success me-1 p-2\" ng-repeat=\"difficulty in subject.difficulties track by $index\">{{difficulty}} <button class=\"btn btn-danger btn-sm ms-1\" ng-click=\"removeDifficultyFromSubject(subject, $index)\">×</button></span></div><div><select class=\"form-control mt-2\" ng-model=newDifficulty ng-options=\"diff for diff in [\'Easy\', \'Medium\', \'Hard\']\"><option value=\"\">Select Difficulty</option></select><button class=\"btn btn-info btn-sm mt-1\" ng-click=\"addDifficultyToSubject(subject, newDifficulty)\">+ Add Difficulty</button></div></div></div></div></div></div><!-- NEW: Add Subject --><h7 class=\"text-primary fw-bold\" style=\"font-size: 1.5rem\">Add Subject</h7><div class=\"card border-success mt-30\"><div class=card-body><div class=form-group><label>Subject Name:</label><select class=form-control ng-model=selectedSubject ng-change=updateNewSubject(selectedSubject)><option value=\"\">Select a Subject</option><option ng-repeat=\"subject in subjects\" ng-value=subject>{{ subject.name }} (Available: {{ subject.questionCount }})</option></select></div><div class=form-group><label>Questions Count:</label><input type=number class=form-control ng-model=newSubject.question_occurance_percentage></div><button class=\"btn btn-success mt-2\" ng-click=addSubjectToDistribution()>+ Add Subject</button></div></div><!-- OLD SW Tags Code Commented Out --><!-- <h4 class=\"text-primary\" ng-if=\"bundle.sw_tags_distribution.length > 0\">SW Tags Available</h4>\n      <div class=\"row\">\n        <div class=\"col-md-6\" ng-repeat=\"tag in bundle.sw_tags_distribution track by $index\">\n          <div class=\"card border-primary mb-3\">\n            <div class=\"card-header bg-primary text-white d-flex justify-content-between align-items-center\">\n              <button class=\"btn btn-danger btn-sm\" ng-click=\"removeTag($index)\">\n                <i class=\"fa fa-trash\"></i> Delete\n              </button>\n            </div>\n            <div class=\"card-body\">\n              <div class=\"form-group\">\n                <label>SW Tag Name:</label>\n                <select class=\"form-control\" ng-model=\"tag.sw_tag_name\">\n                  <option value=\"\">Select a tag</option>\n                  <option ng-repeat=\"sw_tag in sw_tags\" ng-if=\"sw_tag.totalQuestions > 0\" value=\"{{sw_tag.sw_tag_name}}\">\n                    {{ sw_tag.sw_tag_name }} Available Question({{ sw_tag.totalQuestions }})\n                  </option>\n                </select>\n              </div>\n              <div class=\"form-group\">\n                <label>Questions Count:</label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"tag.question_occurance_percentage\"  ng-change=\"validateQuestionCount(tag)\" />\n              </div>\n               <div class=\"form-group\">\n                <label>Difficulties:</label>\n                <div class=\"d-flex flex-wrap\">\n                  <span class=\"badge badge-success me-1 p-2\" ng-repeat=\"difficulty in tag.difficulties track by $index\">\n                    <select class=\"form-control form-control-sm d-inline-block w-auto\" ng-model=\"tag.difficulties[$index]\" \n                      ng-options=\"diff for diff in [\'Easy\', \'Medium\', \'Hard\']\">\n                  </select>\n                    <button class=\"btn btn-danger btn-sm ms-1\" ng-click=\"removeDifficulty(tag, $index)\">×</button>\n                  </span>\n                </div>\n                <div>\n                  <select class=\"form-control mt-2\" ng-model=\"newDifficulty\" \n                          ng-options=\"diff for diff in [\'Easy\', \'Medium\', \'Hard\']\">\n                    <option value=\"\">Select Difficulty</option>\n                  </select>\n                  <button class=\"btn btn-info btn-sm mt-1\" ng-click=\"addDifficulty(tag, newDifficulty)\">\n                    + Add Difficulty\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    \n      <h7 class=\"text-primary fw-bold\" style=\"font-size: 1.5rem;\">Add SW Tags</h7>\n      <div class=\"card border-success mt-30\">\n        <div class=\"card-body\">\n          <div class=\"form-group\">\n            <label>SW Tag Name:</label>\n            <select class=\"form-control\" ng-model=\"selectedSWTag\" ng-change=\"updateNewTag(selectedSWTag)\">\n              <option value=\"\">Select a tag</option>\n              <option ng-repeat=\"sw_tag in sw_tags\" ng-if=\"sw_tag.totalQuestions > 0\" ng-value=\"sw_tag\">\n                {{ sw_tag.sw_tag_name }} Available Question ({{ sw_tag.totalQuestions }})\n              </option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label>Questions Count:</label>\n            <input type=\"number\" class=\"form-control\" ng-model=\"newTag.question_occurance_percentage\"  ng-change=\"calculateQuestionCount()\"/>\n          </div>\n          <button class=\"btn btn-success mt-2\" ng-click=\"addTagToDistribution()\">+ Add Tag</button>\n        </div>\n      </div> --></div><!-- <div class=\"col-md-12 mb-20\">\n      <textarea ng-model=\"bundle.description\" placeholder=\" Add Description \" class=\"form-control\" rows=\"7\"></textarea>\n    </div> --><!-- <get-course></get-course> --><!-- <div class=\"col-md-12\">\n      <div class=\"course-holder mb-20\">\n        <div class=\"col-md-4\" ng-repeat=\"course in bundle.course\">\n          <div class=\"text-holder\">\n            <span>\n              {{ course.name || course.course_id.name | limitTo: 30 }} \n              {{ (course.name.length > 30 || course.course_id.name.length > 30) ? \'...\' : \'\' }}\n            </span>\n            <span class=\"del\" ng-click=\"deleteCourse($index)\">\n              <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n            </span>\n          </div>\n    \n          <div class=\"module-list\" ng-if=\"course.modules && course.modules.length\">\n            <ul>\n              <li ng-repeat=\"module in course.modules\" class=\"module-item\">\n                <span class=\"module-name\" ng-if=\"module.module_id\">\n                  {{ module.module_id.name }}\n                </span>\n              \n                <span class=\"module-name\" ng-if=\"!module.module_id\">\n                  {{ module.name }}\n                </span>\n              \n                <span class=\"del module-del\" ng-click=\"deleteModule(course, $index)\">\n                  <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                </span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div> --><!-- <div class=\"col-md-12 mb-20 padding0\">\n      <label>Total Price: {{bundle.price}}</label>\n      <input class=\"form-control\" type=\"number\" ng-model=\"bundle.discount_price\" placeholder=\"Bundle discount price\">\n    </div> --><!-- <div class=\"col-md-12 padding0\">\n      <input type=\"checkbox\" ng-model=\"bundle.publish\"> Public <br><br>\n    </div> --><div class=\"col-md-12 mb-20\"><button class=\"btn btn-default secondry_btn\" ng-click=SaveBundle(bundle)>Save</button></div></div></div><!-- Inline CSS --><style>.difficulties .badge {\n  font-size: 14px;\n  padding: 5px 10px;\n}</style>");
$templateCache.put("app/admin/session/addSession/addSession.html","<admin-header statename=\"Order Session\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=\"col-xs-12 col-md-6\"><label class=mt-10>Session Name</label><input type=text class=form-control ng-model=session.name><label class=mt-10>Session Start</label><input type=datetime-local class=form-control ng-model=session.startDate><label class=mt-10>Session End</label><input type=datetime-local class=form-control ng-model=session.endDate></div></div></div><div class=\"col-md-12 pl-30 mt-10\"><button ng-click=createSession() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/admin/swTags/addSwTags/addSwTags.html","<admin-header statename=\"Strength & Weakness Tags\"></admin-header><div class=panel-group id=accordion><div class=col-md-6><div class=form-group><label>Select Course</label><input type=text ng-model=courseKey class=form-control ng-change=\"courseKey.length > 0 ? searchInfo(courseKey,type) : null\" placeholder=\"Search Course\"><ul ng-if=\"courses.length > 0\" class=list-group style=\"max-height: 370px;height: 370px\"><li ng-click=addVariants(course,type) class=list-group-item ng-repeat=\"course in courses\">{{course.name}}</li></ul></div></div><div class=panel-group id=accordion ng-if=\"selectedCourse.id && !isLoading\" style=\"margin-top: 100px\"><div class=\"panel panel-default\"><div class=panel-heading data-toggle=collapse data-parent=#accordion data-target=#{{selectedCourse.id}} style=\"padding-bottom: 60px\"><h4 class=\"panel-title flex-view align-items-center justify-content-b\" style=\"width: 100%\"><p class=\"accordion-toggle font-bold\">{{selectedCourse.name}}</p><button class=\"btn btn-default secondry_btn\" ng-click=\"addConfigPopUpOpen(\'course\', selectedCourse.id, selectedCourse)\">Update Tags</button></h4></div><div class=\"panel-collapse collapse in\" style=\"margin-left: 20px; margin-right: 20px\" ng-if=\"modules.length > 0\"><p style=\"font-size: 15px; font-weight: bold\">Modules:</p><div class=panel-body style=\"padding-bottom: 15px; border-bottom: 1px solid #9c9a9a\" ng-repeat=\"module in modules\" ng-style=\"{background: module.sw_tags.length > 0 ? \'#e0e0e0\' : \'white\'}\"><div class=\"flex-view align-items-center justify-content-b\"><p class=mb-0><span style=\"font-size: 16px; margin-left: 15px\">{{module.name}}</span></p><button class=\"btn btn-default secondry_btn mb-0\" ng-click=\"addConfigPopUpOpen(\'module\', module.id, module)\">Update Tags</button></div><div class=\"panel-collapse collapse in\" ng-if=\"module.chapters && module.chapters.length > 0\" style=\"margin-left: 45px; margin-right: 45px\"><p style=\"font-size: 17px; font-weight: bold; margin-top: 15px; color: black\">Chapters:</p><div class=panel-body style=\"padding-bottom: 15px; margin-top: 7px\" ng-repeat=\"chapter in module.chapters\" ng-style=\"{background: chapter.sw_tags.length > 0 ? \'#e0e0e0\' : \'white\'}\"><div class=\"flex-view align-items-center justify-content-b\"><p class=mb-0><span style=\"font-size: 16px; margin-left: 15px\">{{chapter.name}}</span></p><button class=\"btn btn-default secondry_btn mb-0\" ng-click=\"addConfigPopUpOpen(\'chapter\', chapter.id, chapter, module.id)\">Update Tags</button></div></div></div></div></div></div></div></div><div ng-if=isLoading class=col-md-12 style=\"justify-content: center; align-items: center; display: flex\"><img src=images/squares.gif width=100px height=100px></div><div class=story-admin-popup ng-if=addCofig><div class=\"story-admin-popup-wrapper prom-cofig\"><div class=popup-close-icon ng-click=addConfigPopUpClose()><img src=../../../images/b2b/popupclose-icon.png alt=#></div><div class=story-admin-popup-header><h2>Add config</h2></div><div class=story-admin-popup-body><div class=row><div class=col-md-12><div class=form-group><label>Course Tags (Strength & Weakness)</label><tags-input placeholder=\"Add Tag Name\" replace-spaces-with-dashes=false add-on-comma=true add-on-enter=true ng-model=tagsSW></tags-input></div><button class=\"btn btn-default secondry_btn mt-20\" ng-click=createPromptConfig()>Save</button></div></div></div></div></div>");
$templateCache.put("app/admin/tagUrls/addTagUrls/addTagUrls.html","<admin-header statename=\"Course Tags\"></admin-header><div class=\"col-xs-12 col-md-7\"><div style=\"padding: 30px 0; color: #04044D\"><h2>{{id ? \'Update Tag:\' : \'New Tags:\'}}</h2></div><div><label class=mt-10>Tag Name</label><input type=text class=form-control ng-model=name></div><div class=clearfix></div><div><label class=mt-10>Index-Url</label><input type=text class=form-control ng-model=url></div><div class=clearfix></div><div class=container style=\"margin:20px 0px; max-width: 600px; padding-left:0px\"><div class=row><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedInstitution ng-change=updateInstitution(selectedInstitution) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Institution\">Select Institute</option><option ng-repeat=\"institute in institutions\" value={{$index}}>{{institute.institution}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedSchool ng-change=updateSchool(selectedSchool) style=\"width: 150px; margin: 5px 0;border:1px solid black\"><option value=\"Select Faculty\">Select Faculty</option><option ng-repeat=\"faculty in selected_faculty\" value={{faculty.faculty}}>{{faculty.faculty}}</option></select></div><div class=\"col-md-4 col-sm-4\"><select ng-model=selectedCourse ng-change=updateCourse(selectedCourse) style=\"width: 150px; margin: 5px 0; border:1px solid black\"><option value=\"Select Course\">Select Course</option><option ng-repeat=\"course in courses\" value={{$index}}>{{course.name}}</option></select></div></div></div><h3>Selected course for current Tag</h3><div class=clearfix></div><ul><div ng-repeat=\"course in selectedCourses | filter:myFilter\" value={{$index}}><div style=\"margin: 10px; display: flex; align-items: center\"><p style=\"margin-right: 20px; margin-bottom: 0px\">{{course.name}}</p><input type=number name=sort placeholder=\"Sort #\" ng-model=course.sort_no required> <i style=\"margin-left: 30px;font-weight: bold\" ng-click=removeCourse(course)>X</i></div></div></ul><div class=clearfix></div><div class=col-12><button type=button class=\"btn btn-primary\" style=\"float: right; margin-right: 15%\" ng-click=saveTag()>{{id ? \'Update\' : \'Create\'}}</button></div></div>");
$templateCache.put("app/admin/wpSitePages/addWpSitePages/addWpSitePages.html","<admin-header statename=\"Wordpress Page Config Form\"></admin-header><div class=row><div class=\"col-md-12 col-lg-12 pl-30\"><div class=col-lg-12><h3>Wordpress Page Config Form</h3></div><div class=\"col-xs-12 col-md-7\"><label class=mt-10>Name</label><input type=text class=form-control ng-model=accessConfig.name><label class=mt-10>Wordpress Link</label><input type=text class=form-control ng-model=accessConfig.link><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific tag</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificTag\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div> --><div><label class=mt-10>Select Tag</label><div ng-dropdown-multiselect=\"\" options=tags selected-model=accessConfig.selectedTags extra-settings=dropdownSetting></div></div><!-- <div class=\"publish form-group mt-10\">\n                <span>Allow Access on specific course</span>\n                <div class=\"checkbox\" style=\"display: inline-block;margin: 0 10px;vertical-align: bottom\">\n                    <label><input type=\"checkbox\" ng-model=\"accessConfig.specificCourse\">\n                        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"accessConfig.specificCourse\">\n                <div >\n                    <div class=\"form-group\">\n                        <label>Course</label>\n                        <input type=\"text\" ng-model=\"courseKey\" class=\"form-control\" ng-change=\"courseKey.length > 0 ? searchInfo(courseKey, \'course\') : null\"\n                            placeholder=\"Search Course\">\n                        <ul ng-if=\"courses.length > 0\" class=\"list-group\">\n                            <li ng-click=\"selectCourse(course, \'course\')\" class=\"list-group-item\" ng-repeat=\"course in courses\">{{course.name}}</li>\n                        </ul>\n                    </div>\n                </div>\n                <div class=\"container-fluid\">\n                    <h4>Selected Courses</h4>\n                    <div class=\"row\" style=\"margin-top: 20px; margin-left: 30px;\">\n                        <div style=\"display: flex; flex-direction: row;\" ng-repeat=\"course in accessConfig.selectedCourse\" ng-click=\"deleteCourse(course, $index)\">\n                            <p>{{course.name}}</p>\n                            <p style=\"margin-left: 20px; font-weight: bold;\">X</p>\n                        </div>\n                    </div>\n                </div>\n            </div> --></div></div></div><div class=\"col-md-12 pl-30 mt-10\" style=\"padding-bottom: 200px; margin-top: 30px\"><button ng-click=createAccessConfig() class=\"btn btn-default primary_btn\">Save</button></div>");
$templateCache.put("app/instructor_panel/liveSession/newLiveSession/newLiveSession.html","<div class=loader ng-hide=showData><img src=images/squares.gif></div><div class=p-20 ng-show=showData><div class=row><div class=col-md-6><div class=\"live-session-dropdown form-group\"><label>Pick your Live Session Type:</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{ selectedSessionType.value || \'Select Session Type\' }}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li ng-repeat=\"sessionType in sessionTypes\"><a ng-click=selectSessionType(sessionType)>{{ sessionType.value }}</a></li></ul></div></div><div ng-show=\"selectedSessionType.key === \'SESSION_FOR_NICHE\'\" class=\"live-session-dropdown form-group\"><label>Select Niche</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionNiche.name || \'Select Niche\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Niche\" ng-model=searchNiche></div></li><li ng-repeat=\"sessionNiche in sessionNiches | filter:searchNiche\"><a ng-click=selectSessionNiche(sessionNiche)>{{ sessionNiche.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Select user Type</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionUserType.value || \'Select Student Type\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=\"dropdown-menu session-field\"><li ng-repeat=\"sessionUserType in sessionUserTypes\"><a ng-click=selectSessionUserType(sessionUserType)>{{ sessionUserType.value }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\" ng-show=\"selectedSessionType.key === \'SESSION_FOR_COURSE\'\"><label>Select Course</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionCourse.name || \'Select Course\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=\"dropdown-menu course\" id=myDropdown><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Course\" ng-model=searchCourse></div></li><li ng-repeat=\"sessionCourse in sessionCourses | filter:searchCourse\"><a ng-click=selectSessionCourse(sessionCourse)>{{ sessionCourse.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\" ng-show=\"selectedSessionType.key === \'SESSION_FOR_COURSE\'\"><label>Select Module (optional):</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionModule.name || \'Select Module\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Module\" ng-model=searchModule></div></li><li ng-repeat=\"sessionModule in sessionModules | filter:searchModule\"><a ng-click=selectSessionModule(sessionModule)>{{ sessionModule.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\" ng-show=\"selectedSessionType.key === \'SESSION_FOR_COURSE\' && showChapterSelection\"><label>Select Chapter (optional):</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionChapter.name || \'Select Chapter\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li ng-repeat=\"sessionChapter in sessionChapters\"><a ng-click=selectSessionChapter(sessionChapter)>{{ sessionChapter.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\" ng-show=\"selectedSessionType.key === \'SESSION_FOR_COURSE\' && showVideoSelection\"><label>Select Chapter Video (optional):</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedSessionCVideo.name || \'Select Chapter Video\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li ng-repeat=\"sessionCVideo in sessionCVideos\"><a ng-click=selectSessionCVideo(sessionCVideo)>{{ sessionCVideo.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Add name here:</label><div class=session-field><input type=text ng-model=name name=course-name class=form-control placeholder=\"Enter Session Name Here\"></div></div><div class=\"live-session-dropdown form-group\"><label>Add session thumbnail:</label><div class=\"flex-view align-items-center\"><div class=session-field><input type=file id=thumbnail-files style=\"margin-left: 20%\" accept=image/* ng-model=image ngf-select=uploadThumbnail(image) class=hidden><label for=thumbnail-files class=ip-btn-3 style=\"max-width: 280px;text-align: center\">{{thumbnail_url ? \"Update\" : \"Upload\"}}</label></div><div class=session-thumbnail><img ng-if=thumbnail_url ng-src={{thumbnail_url}} alt=\"\"> <img ng-if=!thumbnail_url src=../../../images/profile-user.png alt=\"\"></div></div></div><div class=\"live-session-dropdown form-group\"><label>Short Description:</label><div class=session-field><textarea name=course-name ng-model=description class=form-control placeholder=\"Enter Session Description Here\"></textarea></div></div><div class=\"live-session-dropdown form-group\"><label>Instructor Name:</label><div class=session-field><input type=text ng-model=instructor_name name=course-name class=form-control placeholder=\"Enter Instructor Name Here\"></div></div><div class=\"live-session-dropdown form-group\"><label>Instructor Profile:</label><div class=session-field><input type=text ng-model=instructor_profile name=course-name class=form-control placeholder=\"Instructor Bio Here\"></div></div><div class=\"live-session-dropdown form-group\"><label>Instructor Picture:</label><div class=\"flex-view align-items-center\"><div class=session-field><input type=file id=files style=\"margin-left: 20%\" accept=image/* ng-model=image ngf-select=uploadInstructorImage(image) class=hidden><label for=files class=ip-btn-3 style=\"max-width: 280px;text-align: center\">{{image_url ? \"Update\" : \"Upload\"}}</label></div><div class=insturctor-image><img ng-if=image_url ng-src={{image_url}} alt=\"\"> <img ng-if=!image_url src=../../../images/profile-user.png alt=\"\"></div></div></div><div class=\"live-session-dropdown fform-group\"><label for=sessionTime>Session Time:</label><div style=\"width: 50%\"><input id=sessionTime type=datetime-local class=form-control ng-model=time></div></div><div class=\"live-session-dropdown form-group mt-20\"><label for=urlType>Select URL Type:</label><div><div class=radio><label><input type=radio name=urlType ng-model=url_type value=NEARPEER> Nearpeer Meeting Link</label></div><div class=radio><label><input type=radio name=urlType ng-model=url_type value=CUSTOM> Custom Link</label></div></div></div><div ng-show=\"url_type === \'CUSTOM\'\" class=\"live-session-dropdown form-group\"><label>Add live session URL:</label><div class=session-field><input type=text ng-model=url name=course-name class=form-control placeholder=\"Add your custom live session URL here\"></div></div></div><div class=col-md-6><b>Alert and Notifications:</b><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=creation_alert> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>{{ edit ? \"Send Notification About Changes\" : \"Live Session Creation\" }}</span></div><div ng-if=creation_alert><div class=form-group><label>Push Notification:</label><div class=session-field><input type=text name=course-name ng-model=push_notification.title class=form-control placeholder=\" Your Live Session has been scheduled for <date and time>\"></div><div class=\"session-field mt-3\"><input type=text name=course-name ng-model=push_notification.body class=form-control placeholder=\"Click here to see the details for <Live Session Name>\"></div></div></div><div ng-if=creation_alert><div class=form-group><label>Email Notification:</label><div class=session-field><input type=text name=course-name ng-model=email_notification.subject class=form-control placeholder=\" Your Live Session has been scheduled for <date and time>\"></div><!-- <div class=\"session-field mt-3\">\n            <input type=\"text\" name=\"course-name\" ng-model=\"email_notification.body\" class=\"form-control\" placeholder=\"Enter email body\" />\n          </div> --><!-- <div class=\"form-group session-field mt-3\">\n            <textarea ng-model=\"email_notification.body\" class=\"form-control\" rows=\"5\" placeholder=\"Enter email body\"></textarea>\n          </div>  --><div class=clearfix></div><div text-angular ng-model=email_notification.body class=live-session-email-body style=\"padding-bottom: 10px\"></div><div class=clearfix></div></div></div><div ng-hide=edit class=\"publish form-group\"><label class=mt-10>Before Live Session (Minutes)</label><input ng-model=alert_before_in_minutes type=number class=form-control><!-- <div class=\"checkbox\" style=\"flex: 0;\">\n          <label><input type=\"checkbox\" ng-model=\"alertOneHourBefore\" />\n            <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n          </label>\n        </div>\n        <span>1 hour before Live Session</span> --></div><div ng-hide=edit class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=alert_at_time> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>At the time of Live Session</span></div></div><div class=col-xs-12><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=publish_live_session> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Publish Live Session</span></div><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=allow_chat> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Allow Chat</span></div><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=allow_guest_users> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Allow Guest Users</span></div><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=is_custom_form> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Add custom form for Live Session</span></div><div ng-show=is_custom_form><label class=mt-10>Form Name</label><input ng-model=customForm.name type=text class=form-control><label class=mt-10>Description</label><input ng-model=customForm.description type=text class=form-control><label class=mt-10>Show after (Minutes)</label><input ng-model=show_custom_form_after_min type=number class=form-control><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input ng-model=is_custom_form_mandatory type=checkbox> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Mark it mandatory</span></div><div style=\"margin-top: 30px\" class=live-session-form-builder><h4>Build Your Form:</h4><div id=custom-live-session-editor></div></div></div><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input type=checkbox ng-model=is_registration_form> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Add registration form for Live Session</span></div><div ng-show=is_registration_form><label class=mt-10>Show after (Minutes)</label><input ng-model=show_registration_form_after_min type=number class=form-control><div class=\"publish form-group\" style=\"display: flex; align-items: center\"><div class=checkbox style=\"flex: 0\"><label><input ng-model=is_registration_form_mandatory type=checkbox> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Mark it mandatory</span></div></div></div><div class=col-xs-12><div class=\"flex-view align-items-center justify-content-end flex-direction-row-col mt-30\"><button ng-click=saveSession() class=\"ip-btn-3 marg-right mb-10\">{{ edit ? \"Update \" : \"Create \" }}Live Session</button> <button ng-show=\"edit && session_status != \'CANCELLED\'\" ng-click=openCancelModal() class=\"ip-btn-3 marg-right mb-10\">Cancel The Session</button> <button ng-show=\"edit && session_status == \'ENDED\'\" ng-click=openUploadVideoModal() class=\"ip-btn-3 marg-right mb-10\">Upload Session\'s Video</button> <button ng-show=edit ng-click=duplicateLiveSession() class=\"ip-btn-3 marg-right mb-10\">Duplicate Live Session</button></div></div></div><div class=ip-popup ng-show=cancelLiveSession><div class=ip-popup-container><div class=ip-poup-title><h2>ARE YOU SURE YOU WANT TO CANCEL THE LIVE SESSION?</h2></div><div class=\"ip-popup-body p-20\" style=\"font-size: 18px\"><div class=\"radio mb-20\"><label><input type=radio ng-model=cancelLiveSessionReason value=\"Instructor was not available at the time\">Instructor was not available at the time</label></div><!-- <div class=\"publish form-group\" style=\"display: flex; align-items: center;\">\n            \n            <div class=\"radio\" style=\"flex: 0;\">\n              <label><input type=\"radio\" ng-model=\"cancelLiveSessionReason\" value=\"Instructor was not available at the time\" />\n                <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n              </label>\n            </div>\n            <span>Instructor was not available at the time</span>\n          </div> --><div class=\"radio mb-20\"><label><input type=radio ng-model=cancelLiveSessionReason value=\"Technical Issue\">Technical Issue</label></div><!-- <div class=\"publish form-group\" style=\"display: flex; align-items: center;\">\n            <div class=\"radio\" style=\"flex: 0;\">\n              <input type=\"radio\" ng-model=\"cancelLiveSessionReason\" value=\"Technical Issue\" />\n            </div>\n            <span>Technical Issue</span>\n          </div> --><div class=\"radio mb-20\"><label><input type=radio ng-model=cancelLiveSessionReason value=\"Session has been delayed indefinitely\">Session has been delayed indefinitely</label></div><!-- <div class=\"publish form-group\" style=\"display: flex; align-items: center;\">\n            <div class=\"radio\" style=\"flex: 0;\">\n              <label><input type=\"radio\" ng-model=\"cancelLiveSessionReason\" value=\"Session has been delayed indefinitely\" />\n                <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n              </label>\n            </div>\n            <span>Session has been delayed indefinitely</span>\n          </div> --><div class=\"radio mb-20\"><label class=mb-20><input type=radio ng-model=cancelLiveSessionReason value=Custom>Custom</label><span><input type=text ng-model=cancelLiveSessionReasonText ng-focus=\"cancelLiveSessionReason = \'Custom\'\" class=form-control></span></div><!-- <div class=\"publish form-group\" style=\"display: flex; align-items: center;\">\n            <div class=\"radio\" style=\"flex: 0;\">\n              <label><input type=\"radio\" ng-model=\"cancelLiveSessionReason\" value=\"Custom\" />\n                <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n              </label>\n            </div>\n            <span><input type=\"text\" ng-model=\"cancelLiveSessionReasonText\" ng-focus=\"cancelLiveSessionReason = \'Custom\'\" class=\"form-control\" /></span>\n          </div> --><div class=\"flex-view align-items-center justfify-content-end w-hundred-p\"><button class=\"ip-btn-3 marg-right\" ng-click=cancelLiveSessionPopUp()>Go back</button> <button class=ip-btn-3 ng-click=cancelLiveSessionAction()>Yes, Cancel</button></div></div></div></div><div class=ip-popup ng-if=uploadLiveSession><div class=ip-popup-container><div class=\"ip-popup-body p-20\"><div class=\"live-session-dropdown form-group\"><label>Select Niche</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedVideoNiche.name || \'Select Niche\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Niche\" ng-model=searchNicheUpload></div></li><li ng-repeat=\"sessionNiche in videoNiches | filter:searchNicheUpload\"><a ng-click=selectVideoNiche(sessionNiche)>{{ sessionNiche.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Select Course</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedVideoCourse.name || \'Select Course\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Course\" ng-model=searchCourseUpload></div></li><li ng-repeat=\"sessionCourse in videoCourses | filter:searchCourseUpload\"><a ng-click=selectVideoCourse(sessionCourse)>{{ sessionCourse.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Select Module</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedVideoModule.name || \'Select Module\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Module\" ng-model=searchModuleUpload></div></li><li ng-repeat=\"sessionModule in videoModules | filter:searchModuleUpload\"><a ng-click=selectVideoModule(sessionModule)>{{ sessionModule.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Select Chapter (optional)</label><div class=\"dropdown session-field\"><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>{{selectedVideoChapter.name || \'Select Chapter\'}}<div style=\"margin-left: auto\"><span class=caret></span></div></button><ul class=dropdown-menu><li><div class=\"col-lg-12 mt-10 mb-10\"><input type=text class=form-control placeholder=\"Search Chapter\" ng-model=searchChapterUpload></div></li><li ng-repeat=\"sessionChapter in videoChapters | filter:searchChapterUpload\"><a ng-click=selectVideoChapter(sessionChapter)>{{ sessionChapter.name }}</a></li></ul></div></div><div class=\"live-session-dropdown form-group\"><label>Youtube Video Link</label><div class=\"dropdown session-field\"><input type=text class=form-control placeholder=\"Add Youtube Video Link\" ng-model=youtubeLink></div></div><div class=\"live-session-dropdown form-group\"><label>Your Email (Note:This is to get email notifications regarding progress of uploading)</label><div class=\"dropdown session-field\"><input type=text class=form-control placeholder=\"Add Your Email\" ng-model=email></div></div><!-- <div>\n            <div style=\"margin-top:20px;\" class=\"drag ip-mb-15\" ngf-select=\"uploadVideoss(files,\'click\')\" ng-model=\"files\" ngf-multiple=\"true\" ngf-accept=\"\'video/*\'\"> &nbsp;</div>\n            <div class=\"uplod ip-boxshadow\" ng-show=\"uploadingVideos.length > 0\" style=\"overflow: auto;\">\n              <table style=\"width: 100%;min-width: 700px;\">\n                <tr>\n                  <th>Index</th>\n                  <th>Name</th>\n                  <th>Uploading To Server</th>\n                  <th>Uploading To VVS</th>\n                  <th>Transcoding Job</th>\n                </tr>\n                <tr ng-repeat=\"video in uploadingVideos  track by $index\" ng-class=\"{videoUploadedSuccess: video.uploaded,videoUploadedFail:video.error}\">\n                  <td>{{$index+1}}</td>\n                  <td><input type=\"text\" ng-model=\"video.name\" name=\"video_name\" id=\"video_name\"></td>\n                  <td>\n                    <div class=\"progress\" style=\"position: relative;\">\n                      <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" style=\"position: absolute;\" aria-valuenow=\"{{video.serverLog}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.serverLog + \'%\'}\">\n                      </div>\n                      <div style=\"color: #000;text-align: center;position: relative;font-size: 12px;\">{{video.serverLog}}% Complete</div>\n                    </div>\n                  </td>\n                  <td>\n                    <div class=\"progress\" style=\"position: relative;\">\n                      <div class=\"progress-bar progress-bar-info\" role=\"progressbar\" style=\"position: absolute;\" aria-valuenow=\"{{video.s3Log}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.s3Log + \'%\'}\">\n                      </div>\n                      <div style=\"color: #000;text-align: center;position: relative;font-size: 12px;\">{{video.s3Log}}% Complete</div>\n                    </div>\n                  </td>\n                  <td>\n                    <div class=\"progress\" style=\"position: relative;\">\n                      <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" style=\"position: absolute;\" aria-valuenow=\"{{video.jobLog}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:video.jobLog + \'%\'}\">\n                      </div>\n                      <div style=\"color: #000;text-align: center;position: relative;font-size: 12px;\">{{video.jobLog}}% Complete</div>\n                    </div>\n                  </td>\n                  <td>\n                    <span class=\"\" ng-click=\"removeItem($index)\" style=\"float: right;\"><img src=\"../../../images/cross-icon.svg\"/></span>\n                  </td>\n                </tr>\n              </table>\n            </div>\n            <div ng-show=\"uploadStatus\">\n                {{ uploadStatus }}\n            </div>\n          </div> --><div class=\"flex-view align-items-center justfify-content-end w-hundred-p\"><button class=\"ip-btn-3 marg-right\" ng-click=saveData(youtubeLink,email)>Save and upload</button> <button class=\"ip-btn-3 marg-right\" ng-click=closeUploadVideoModal()>Close</button></div></div></div></div></div>");}]);